(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2b58"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2b58"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8f2hE", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $60017ef49634633f$export$ffb0004e005737fa; }, function (v) { return $60017ef49634633f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $60017ef49634633f$export$34b9dba7ce09269b; }, function (v) { return $60017ef49634633f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $60017ef49634633f$export$25062201e9e25d76; }, function (v) { return $60017ef49634633f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $60017ef49634633f$export$ffb0004e005737fa;
var $60017ef49634633f$export$34b9dba7ce09269b;
var $60017ef49634633f$export$25062201e9e25d76;
"use strict";

var $bnENU = parcelRequire("bnENU");
var $60017ef49634633f$var$k = Symbol.for("react.element"), $60017ef49634633f$var$l = Symbol.for("react.fragment"), $60017ef49634633f$var$m = Object.prototype.hasOwnProperty, $60017ef49634633f$var$n = $bnENU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $60017ef49634633f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $60017ef49634633f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$60017ef49634633f$var$m.call(a, b) && !$60017ef49634633f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $60017ef49634633f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $60017ef49634633f$var$n.current
    };
}
$60017ef49634633f$export$ffb0004e005737fa = $60017ef49634633f$var$l;
$60017ef49634633f$export$34b9dba7ce09269b = $60017ef49634633f$var$q;
$60017ef49634633f$export$25062201e9e25d76 = $60017ef49634633f$var$q;

});
parcelRegister("bnENU", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aJe5t"));

});
parcelRegister("aJe5t", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $7cf908cbc36e9c56$export$dca3b0875bd9a954; }, function (v) { return $7cf908cbc36e9c56$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $7cf908cbc36e9c56$export$16fa2f45be04daa8; }, function (v) { return $7cf908cbc36e9c56$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $7cf908cbc36e9c56$export$ffb0004e005737fa; }, function (v) { return $7cf908cbc36e9c56$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $7cf908cbc36e9c56$export$e2c29f18771995cb; }, function (v) { return $7cf908cbc36e9c56$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $7cf908cbc36e9c56$export$221d75b3f55bb0bd; }, function (v) { return $7cf908cbc36e9c56$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $7cf908cbc36e9c56$export$5f8d39834fd61797; }, function (v) { return $7cf908cbc36e9c56$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $7cf908cbc36e9c56$export$74bf444e3cd11ea5; }, function (v) { return $7cf908cbc36e9c56$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $7cf908cbc36e9c56$export$ae55be85d98224ed; }, function (v) { return $7cf908cbc36e9c56$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $7cf908cbc36e9c56$export$3ba232387fd5d6dd; }, function (v) { return $7cf908cbc36e9c56$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $7cf908cbc36e9c56$export$e530037191fcd5d7; }, function (v) { return $7cf908cbc36e9c56$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $7cf908cbc36e9c56$export$fd42f52fd3ae1109; }, function (v) { return $7cf908cbc36e9c56$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $7cf908cbc36e9c56$export$c8a8987d4410bf2d; }, function (v) { return $7cf908cbc36e9c56$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $7cf908cbc36e9c56$export$d38cd72104c1f0e9; }, function (v) { return $7cf908cbc36e9c56$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $7cf908cbc36e9c56$export$7d1e3a5e95ceca43; }, function (v) { return $7cf908cbc36e9c56$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $7cf908cbc36e9c56$export$257a8862b851cb5b; }, function (v) { return $7cf908cbc36e9c56$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $7cf908cbc36e9c56$export$a8257692ac88316c; }, function (v) { return $7cf908cbc36e9c56$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $7cf908cbc36e9c56$export$488013bae63b21da; }, function (v) { return $7cf908cbc36e9c56$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $7cf908cbc36e9c56$export$7c73462e0d25e514; }, function (v) { return $7cf908cbc36e9c56$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $7cf908cbc36e9c56$export$7568632d0d33d16d; }, function (v) { return $7cf908cbc36e9c56$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $7cf908cbc36e9c56$export$88948ce120ea2619; }, function (v) { return $7cf908cbc36e9c56$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $7cf908cbc36e9c56$export$35808ee640e87ca7; }, function (v) { return $7cf908cbc36e9c56$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $7cf908cbc36e9c56$export$fae74005e78b1a27; }, function (v) { return $7cf908cbc36e9c56$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $7cf908cbc36e9c56$export$dc8fbce3eb94dc1e; }, function (v) { return $7cf908cbc36e9c56$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $7cf908cbc36e9c56$export$6a7bc4e911dc01cf; }, function (v) { return $7cf908cbc36e9c56$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $7cf908cbc36e9c56$export$6d9c69b0de29b591; }, function (v) { return $7cf908cbc36e9c56$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $7cf908cbc36e9c56$export$f680877a34711e37; }, function (v) { return $7cf908cbc36e9c56$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $7cf908cbc36e9c56$export$d5a552a76deda3c2; }, function (v) { return $7cf908cbc36e9c56$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $7cf908cbc36e9c56$export$aaabe4eda9ed9969; }, function (v) { return $7cf908cbc36e9c56$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $7cf908cbc36e9c56$export$e5c5a5f917a5871c; }, function (v) { return $7cf908cbc36e9c56$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $7cf908cbc36e9c56$export$1538c33de8887b59; }, function (v) { return $7cf908cbc36e9c56$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $7cf908cbc36e9c56$export$13e3392192263954; }, function (v) { return $7cf908cbc36e9c56$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $7cf908cbc36e9c56$export$b8f5890fc79d6aca; }, function (v) { return $7cf908cbc36e9c56$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $7cf908cbc36e9c56$export$60241385465d0a34; }, function (v) { return $7cf908cbc36e9c56$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $7cf908cbc36e9c56$export$306c0aa65ff9ec16; }, function (v) { return $7cf908cbc36e9c56$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $7cf908cbc36e9c56$export$7b286972b8d8ccbf; }, function (v) { return $7cf908cbc36e9c56$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $7cf908cbc36e9c56$export$83d89fbfd8236492; }, function (v) { return $7cf908cbc36e9c56$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7cf908cbc36e9c56$export$dca3b0875bd9a954;
var $7cf908cbc36e9c56$export$16fa2f45be04daa8;
var $7cf908cbc36e9c56$export$ffb0004e005737fa;
var $7cf908cbc36e9c56$export$e2c29f18771995cb;
var $7cf908cbc36e9c56$export$221d75b3f55bb0bd;
var $7cf908cbc36e9c56$export$5f8d39834fd61797;
var $7cf908cbc36e9c56$export$74bf444e3cd11ea5;
var $7cf908cbc36e9c56$export$ae55be85d98224ed;
var $7cf908cbc36e9c56$export$3ba232387fd5d6dd;
var $7cf908cbc36e9c56$export$e530037191fcd5d7;
var $7cf908cbc36e9c56$export$fd42f52fd3ae1109;
var $7cf908cbc36e9c56$export$c8a8987d4410bf2d;
var $7cf908cbc36e9c56$export$d38cd72104c1f0e9;
var $7cf908cbc36e9c56$export$7d1e3a5e95ceca43;
var $7cf908cbc36e9c56$export$257a8862b851cb5b;
var $7cf908cbc36e9c56$export$a8257692ac88316c;
var $7cf908cbc36e9c56$export$488013bae63b21da;
var $7cf908cbc36e9c56$export$7c73462e0d25e514;
var $7cf908cbc36e9c56$export$7568632d0d33d16d;
var $7cf908cbc36e9c56$export$88948ce120ea2619;
var $7cf908cbc36e9c56$export$35808ee640e87ca7;
var $7cf908cbc36e9c56$export$fae74005e78b1a27;
var $7cf908cbc36e9c56$export$dc8fbce3eb94dc1e;
var $7cf908cbc36e9c56$export$6a7bc4e911dc01cf;
var $7cf908cbc36e9c56$export$6d9c69b0de29b591;
var $7cf908cbc36e9c56$export$f680877a34711e37;
var $7cf908cbc36e9c56$export$d5a552a76deda3c2;
var $7cf908cbc36e9c56$export$aaabe4eda9ed9969;
var $7cf908cbc36e9c56$export$e5c5a5f917a5871c;
var $7cf908cbc36e9c56$export$1538c33de8887b59;
var $7cf908cbc36e9c56$export$13e3392192263954;
var $7cf908cbc36e9c56$export$b8f5890fc79d6aca;
var $7cf908cbc36e9c56$export$60241385465d0a34;
var $7cf908cbc36e9c56$export$306c0aa65ff9ec16;
var $7cf908cbc36e9c56$export$7b286972b8d8ccbf;
var $7cf908cbc36e9c56$export$83d89fbfd8236492;
"use strict";
var $7cf908cbc36e9c56$var$l = Symbol.for("react.element"), $7cf908cbc36e9c56$var$n = Symbol.for("react.portal"), $7cf908cbc36e9c56$var$p = Symbol.for("react.fragment"), $7cf908cbc36e9c56$var$q = Symbol.for("react.strict_mode"), $7cf908cbc36e9c56$var$r = Symbol.for("react.profiler"), $7cf908cbc36e9c56$var$t = Symbol.for("react.provider"), $7cf908cbc36e9c56$var$u = Symbol.for("react.context"), $7cf908cbc36e9c56$var$v = Symbol.for("react.forward_ref"), $7cf908cbc36e9c56$var$w = Symbol.for("react.suspense"), $7cf908cbc36e9c56$var$x = Symbol.for("react.memo"), $7cf908cbc36e9c56$var$y = Symbol.for("react.lazy"), $7cf908cbc36e9c56$var$z = Symbol.iterator;
function $7cf908cbc36e9c56$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $7cf908cbc36e9c56$var$z && a[$7cf908cbc36e9c56$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7cf908cbc36e9c56$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $7cf908cbc36e9c56$var$C = Object.assign, $7cf908cbc36e9c56$var$D = {};
function $7cf908cbc36e9c56$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7cf908cbc36e9c56$var$D;
    this.updater = e || $7cf908cbc36e9c56$var$B;
}
$7cf908cbc36e9c56$var$E.prototype.isReactComponent = {};
$7cf908cbc36e9c56$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$7cf908cbc36e9c56$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $7cf908cbc36e9c56$var$F() {}
$7cf908cbc36e9c56$var$F.prototype = $7cf908cbc36e9c56$var$E.prototype;
function $7cf908cbc36e9c56$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $7cf908cbc36e9c56$var$D;
    this.updater = e || $7cf908cbc36e9c56$var$B;
}
var $7cf908cbc36e9c56$var$H = $7cf908cbc36e9c56$var$G.prototype = new $7cf908cbc36e9c56$var$F;
$7cf908cbc36e9c56$var$H.constructor = $7cf908cbc36e9c56$var$G;
$7cf908cbc36e9c56$var$C($7cf908cbc36e9c56$var$H, $7cf908cbc36e9c56$var$E.prototype);
$7cf908cbc36e9c56$var$H.isPureReactComponent = !0;
var $7cf908cbc36e9c56$var$I = Array.isArray, $7cf908cbc36e9c56$var$J = Object.prototype.hasOwnProperty, $7cf908cbc36e9c56$var$K = {
    current: null
}, $7cf908cbc36e9c56$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7cf908cbc36e9c56$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$7cf908cbc36e9c56$var$J.call(b, d) && !$7cf908cbc36e9c56$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $7cf908cbc36e9c56$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $7cf908cbc36e9c56$var$K.current
    };
}
function $7cf908cbc36e9c56$var$N(a, b) {
    return {
        $$typeof: $7cf908cbc36e9c56$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $7cf908cbc36e9c56$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7cf908cbc36e9c56$var$l;
}
function $7cf908cbc36e9c56$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $7cf908cbc36e9c56$var$P = /\/+/g;
function $7cf908cbc36e9c56$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $7cf908cbc36e9c56$var$escape("" + a.key) : b.toString(36);
}
function $7cf908cbc36e9c56$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $7cf908cbc36e9c56$var$l:
                case $7cf908cbc36e9c56$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $7cf908cbc36e9c56$var$Q(h, 0) : d, $7cf908cbc36e9c56$var$I(c) ? (e = "", null != a && (e = a.replace($7cf908cbc36e9c56$var$P, "$&/") + "/"), $7cf908cbc36e9c56$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($7cf908cbc36e9c56$var$O(c) && (c = $7cf908cbc36e9c56$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($7cf908cbc36e9c56$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($7cf908cbc36e9c56$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $7cf908cbc36e9c56$var$Q(k, g);
        h += $7cf908cbc36e9c56$var$R(k, b, e, f, c);
    }
    else if (f = $7cf908cbc36e9c56$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $7cf908cbc36e9c56$var$Q(k, g++), h += $7cf908cbc36e9c56$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $7cf908cbc36e9c56$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $7cf908cbc36e9c56$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $7cf908cbc36e9c56$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $7cf908cbc36e9c56$var$U = {
    current: null
}, $7cf908cbc36e9c56$var$V = {
    transition: null
}, $7cf908cbc36e9c56$var$W = {
    ReactCurrentDispatcher: $7cf908cbc36e9c56$var$U,
    ReactCurrentBatchConfig: $7cf908cbc36e9c56$var$V,
    ReactCurrentOwner: $7cf908cbc36e9c56$var$K
};
function $7cf908cbc36e9c56$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$7cf908cbc36e9c56$export$dca3b0875bd9a954 = {
    map: $7cf908cbc36e9c56$var$S,
    forEach: function(a, b, e) {
        $7cf908cbc36e9c56$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $7cf908cbc36e9c56$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $7cf908cbc36e9c56$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$7cf908cbc36e9c56$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$7cf908cbc36e9c56$export$16fa2f45be04daa8 = $7cf908cbc36e9c56$var$E;
$7cf908cbc36e9c56$export$ffb0004e005737fa = $7cf908cbc36e9c56$var$p;
$7cf908cbc36e9c56$export$e2c29f18771995cb = $7cf908cbc36e9c56$var$r;
$7cf908cbc36e9c56$export$221d75b3f55bb0bd = $7cf908cbc36e9c56$var$G;
$7cf908cbc36e9c56$export$5f8d39834fd61797 = $7cf908cbc36e9c56$var$q;
$7cf908cbc36e9c56$export$74bf444e3cd11ea5 = $7cf908cbc36e9c56$var$w;
$7cf908cbc36e9c56$export$ae55be85d98224ed = $7cf908cbc36e9c56$var$W;
$7cf908cbc36e9c56$export$3ba232387fd5d6dd = $7cf908cbc36e9c56$var$X;
$7cf908cbc36e9c56$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $7cf908cbc36e9c56$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $7cf908cbc36e9c56$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$7cf908cbc36e9c56$var$J.call(b, f) && !$7cf908cbc36e9c56$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $7cf908cbc36e9c56$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$7cf908cbc36e9c56$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $7cf908cbc36e9c56$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $7cf908cbc36e9c56$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$7cf908cbc36e9c56$export$c8a8987d4410bf2d = $7cf908cbc36e9c56$var$M;
$7cf908cbc36e9c56$export$d38cd72104c1f0e9 = function(a) {
    var b = $7cf908cbc36e9c56$var$M.bind(null, a);
    b.type = a;
    return b;
};
$7cf908cbc36e9c56$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$7cf908cbc36e9c56$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $7cf908cbc36e9c56$var$v,
        render: a
    };
};
$7cf908cbc36e9c56$export$a8257692ac88316c = $7cf908cbc36e9c56$var$O;
$7cf908cbc36e9c56$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $7cf908cbc36e9c56$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $7cf908cbc36e9c56$var$T
    };
};
$7cf908cbc36e9c56$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $7cf908cbc36e9c56$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$7cf908cbc36e9c56$export$7568632d0d33d16d = function(a) {
    var b = $7cf908cbc36e9c56$var$V.transition;
    $7cf908cbc36e9c56$var$V.transition = {};
    try {
        a();
    } finally{
        $7cf908cbc36e9c56$var$V.transition = b;
    }
};
$7cf908cbc36e9c56$export$88948ce120ea2619 = $7cf908cbc36e9c56$var$X;
$7cf908cbc36e9c56$export$35808ee640e87ca7 = function(a, b) {
    return $7cf908cbc36e9c56$var$U.current.useCallback(a, b);
};
$7cf908cbc36e9c56$export$fae74005e78b1a27 = function(a) {
    return $7cf908cbc36e9c56$var$U.current.useContext(a);
};
$7cf908cbc36e9c56$export$dc8fbce3eb94dc1e = function() {};
$7cf908cbc36e9c56$export$6a7bc4e911dc01cf = function(a) {
    return $7cf908cbc36e9c56$var$U.current.useDeferredValue(a);
};
$7cf908cbc36e9c56$export$6d9c69b0de29b591 = function(a, b) {
    return $7cf908cbc36e9c56$var$U.current.useEffect(a, b);
};
$7cf908cbc36e9c56$export$f680877a34711e37 = function() {
    return $7cf908cbc36e9c56$var$U.current.useId();
};
$7cf908cbc36e9c56$export$d5a552a76deda3c2 = function(a, b, e) {
    return $7cf908cbc36e9c56$var$U.current.useImperativeHandle(a, b, e);
};
$7cf908cbc36e9c56$export$aaabe4eda9ed9969 = function(a, b) {
    return $7cf908cbc36e9c56$var$U.current.useInsertionEffect(a, b);
};
$7cf908cbc36e9c56$export$e5c5a5f917a5871c = function(a, b) {
    return $7cf908cbc36e9c56$var$U.current.useLayoutEffect(a, b);
};
$7cf908cbc36e9c56$export$1538c33de8887b59 = function(a, b) {
    return $7cf908cbc36e9c56$var$U.current.useMemo(a, b);
};
$7cf908cbc36e9c56$export$13e3392192263954 = function(a, b, e) {
    return $7cf908cbc36e9c56$var$U.current.useReducer(a, b, e);
};
$7cf908cbc36e9c56$export$b8f5890fc79d6aca = function(a) {
    return $7cf908cbc36e9c56$var$U.current.useRef(a);
};
$7cf908cbc36e9c56$export$60241385465d0a34 = function(a) {
    return $7cf908cbc36e9c56$var$U.current.useState(a);
};
$7cf908cbc36e9c56$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $7cf908cbc36e9c56$var$U.current.useSyncExternalStore(a, b, e);
};
$7cf908cbc36e9c56$export$7b286972b8d8ccbf = function() {
    return $7cf908cbc36e9c56$var$U.current.useTransition();
};
$7cf908cbc36e9c56$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("gjQGW", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $18FZq = parcelRequire("18FZq");

var $cmlvI = parcelRequire("cmlvI");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $18FZq.isBrowserBundle)() && Object.prototype.toString.call(typeof $cmlvI !== "undefined" ? $cmlvI : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("18FZq", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $0d471c1c7b881aa2$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $0d471c1c7b881aa2$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0d471c1c7b881aa2$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0d471c1c7b881aa2$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("cmlvI", function(module, exports) {
// shim for using process in browser
var $8ff839a7d0ad494d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8ff839a7d0ad494d$var$cachedSetTimeout;
var $8ff839a7d0ad494d$var$cachedClearTimeout;
function $8ff839a7d0ad494d$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $8ff839a7d0ad494d$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $8ff839a7d0ad494d$var$cachedSetTimeout = setTimeout;
        else $8ff839a7d0ad494d$var$cachedSetTimeout = $8ff839a7d0ad494d$var$defaultSetTimout;
    } catch (e) {
        $8ff839a7d0ad494d$var$cachedSetTimeout = $8ff839a7d0ad494d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $8ff839a7d0ad494d$var$cachedClearTimeout = clearTimeout;
        else $8ff839a7d0ad494d$var$cachedClearTimeout = $8ff839a7d0ad494d$var$defaultClearTimeout;
    } catch (e) {
        $8ff839a7d0ad494d$var$cachedClearTimeout = $8ff839a7d0ad494d$var$defaultClearTimeout;
    }
})();
function $8ff839a7d0ad494d$var$runTimeout(fun) {
    if ($8ff839a7d0ad494d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8ff839a7d0ad494d$var$cachedSetTimeout === $8ff839a7d0ad494d$var$defaultSetTimout || !$8ff839a7d0ad494d$var$cachedSetTimeout) && setTimeout) {
        $8ff839a7d0ad494d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8ff839a7d0ad494d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8ff839a7d0ad494d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8ff839a7d0ad494d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8ff839a7d0ad494d$var$runClearTimeout(marker) {
    if ($8ff839a7d0ad494d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8ff839a7d0ad494d$var$cachedClearTimeout === $8ff839a7d0ad494d$var$defaultClearTimeout || !$8ff839a7d0ad494d$var$cachedClearTimeout) && clearTimeout) {
        $8ff839a7d0ad494d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8ff839a7d0ad494d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8ff839a7d0ad494d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8ff839a7d0ad494d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8ff839a7d0ad494d$var$queue = [];
var $8ff839a7d0ad494d$var$draining = false;
var $8ff839a7d0ad494d$var$currentQueue;
var $8ff839a7d0ad494d$var$queueIndex = -1;
function $8ff839a7d0ad494d$var$cleanUpNextTick() {
    if (!$8ff839a7d0ad494d$var$draining || !$8ff839a7d0ad494d$var$currentQueue) return;
    $8ff839a7d0ad494d$var$draining = false;
    if ($8ff839a7d0ad494d$var$currentQueue.length) $8ff839a7d0ad494d$var$queue = $8ff839a7d0ad494d$var$currentQueue.concat($8ff839a7d0ad494d$var$queue);
    else $8ff839a7d0ad494d$var$queueIndex = -1;
    if ($8ff839a7d0ad494d$var$queue.length) $8ff839a7d0ad494d$var$drainQueue();
}
function $8ff839a7d0ad494d$var$drainQueue() {
    if ($8ff839a7d0ad494d$var$draining) return;
    var timeout = $8ff839a7d0ad494d$var$runTimeout($8ff839a7d0ad494d$var$cleanUpNextTick);
    $8ff839a7d0ad494d$var$draining = true;
    var len = $8ff839a7d0ad494d$var$queue.length;
    while(len){
        $8ff839a7d0ad494d$var$currentQueue = $8ff839a7d0ad494d$var$queue;
        $8ff839a7d0ad494d$var$queue = [];
        while(++$8ff839a7d0ad494d$var$queueIndex < len)if ($8ff839a7d0ad494d$var$currentQueue) $8ff839a7d0ad494d$var$currentQueue[$8ff839a7d0ad494d$var$queueIndex].run();
        $8ff839a7d0ad494d$var$queueIndex = -1;
        len = $8ff839a7d0ad494d$var$queue.length;
    }
    $8ff839a7d0ad494d$var$currentQueue = null;
    $8ff839a7d0ad494d$var$draining = false;
    $8ff839a7d0ad494d$var$runClearTimeout(timeout);
}
$8ff839a7d0ad494d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8ff839a7d0ad494d$var$queue.push(new $8ff839a7d0ad494d$var$Item(fun, args));
    if ($8ff839a7d0ad494d$var$queue.length === 1 && !$8ff839a7d0ad494d$var$draining) $8ff839a7d0ad494d$var$runTimeout($8ff839a7d0ad494d$var$drainQueue);
};
// v8 likes predictible objects
function $8ff839a7d0ad494d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8ff839a7d0ad494d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8ff839a7d0ad494d$var$process.title = "browser";
$8ff839a7d0ad494d$var$process.browser = true;
$8ff839a7d0ad494d$var$process.env = {};
$8ff839a7d0ad494d$var$process.argv = [];
$8ff839a7d0ad494d$var$process.version = ""; // empty string to avoid regexp issues
$8ff839a7d0ad494d$var$process.versions = {};
function $8ff839a7d0ad494d$var$noop() {}
$8ff839a7d0ad494d$var$process.on = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.addListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.once = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.off = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.removeListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.removeAllListeners = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.emit = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.prependListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.prependOnceListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.listeners = function(name) {
    return [];
};
$8ff839a7d0ad494d$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$8ff839a7d0ad494d$var$process.cwd = function() {
    return "/";
};
$8ff839a7d0ad494d$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$8ff839a7d0ad494d$var$process.umask = function() {
    return 0;
};

});


parcelRegister("34ehV", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $23bcd42a245f9d7b$export$ae55be85d98224ed; }, function (v) { return $23bcd42a245f9d7b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $23bcd42a245f9d7b$export$d39a5bbd09211389; }, function (v) { return $23bcd42a245f9d7b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $23bcd42a245f9d7b$export$882461b6382ed46c; }, function (v) { return $23bcd42a245f9d7b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $23bcd42a245f9d7b$export$466bfc07425424d5; }, function (v) { return $23bcd42a245f9d7b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $23bcd42a245f9d7b$export$cd75ccfd720a3cd4; }, function (v) { return $23bcd42a245f9d7b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $23bcd42a245f9d7b$export$fa8d919ba61d84db; }, function (v) { return $23bcd42a245f9d7b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $23bcd42a245f9d7b$export$757ceba2d55c277e; }, function (v) { return $23bcd42a245f9d7b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $23bcd42a245f9d7b$export$b3890eb0ae9dca99; }, function (v) { return $23bcd42a245f9d7b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $23bcd42a245f9d7b$export$502457920280e6be; }, function (v) { return $23bcd42a245f9d7b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $23bcd42a245f9d7b$export$c78a37762a8d58e1; }, function (v) { return $23bcd42a245f9d7b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $23bcd42a245f9d7b$export$dc54d992c10e8a18; }, function (v) { return $23bcd42a245f9d7b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $23bcd42a245f9d7b$export$83d89fbfd8236492; }, function (v) { return $23bcd42a245f9d7b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $23bcd42a245f9d7b$export$ae55be85d98224ed;
var $23bcd42a245f9d7b$export$d39a5bbd09211389;
var $23bcd42a245f9d7b$export$882461b6382ed46c;
var $23bcd42a245f9d7b$export$466bfc07425424d5;
var $23bcd42a245f9d7b$export$cd75ccfd720a3cd4;
var $23bcd42a245f9d7b$export$fa8d919ba61d84db;
var $23bcd42a245f9d7b$export$757ceba2d55c277e;
var $23bcd42a245f9d7b$export$b3890eb0ae9dca99;
var $23bcd42a245f9d7b$export$502457920280e6be;
var $23bcd42a245f9d7b$export$c78a37762a8d58e1;
var $23bcd42a245f9d7b$export$dc54d992c10e8a18;
var $23bcd42a245f9d7b$export$83d89fbfd8236492;
"use strict";

var $bnENU = parcelRequire("bnENU");

var $fOxuK = parcelRequire("fOxuK");
function $23bcd42a245f9d7b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $23bcd42a245f9d7b$var$da = new Set, $23bcd42a245f9d7b$var$ea = {};
function $23bcd42a245f9d7b$var$fa(a, b) {
    $23bcd42a245f9d7b$var$ha(a, b);
    $23bcd42a245f9d7b$var$ha(a + "Capture", b);
}
function $23bcd42a245f9d7b$var$ha(a, b) {
    $23bcd42a245f9d7b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$23bcd42a245f9d7b$var$da.add(b[a]);
}
var $23bcd42a245f9d7b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $23bcd42a245f9d7b$var$ja = Object.prototype.hasOwnProperty, $23bcd42a245f9d7b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $23bcd42a245f9d7b$var$la = {}, $23bcd42a245f9d7b$var$ma = {};
function $23bcd42a245f9d7b$var$oa(a) {
    if ($23bcd42a245f9d7b$var$ja.call($23bcd42a245f9d7b$var$ma, a)) return !0;
    if ($23bcd42a245f9d7b$var$ja.call($23bcd42a245f9d7b$var$la, a)) return !1;
    if ($23bcd42a245f9d7b$var$ka.test(a)) return $23bcd42a245f9d7b$var$ma[a] = !0;
    $23bcd42a245f9d7b$var$la[a] = !0;
    return !1;
}
function $23bcd42a245f9d7b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $23bcd42a245f9d7b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $23bcd42a245f9d7b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $23bcd42a245f9d7b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $23bcd42a245f9d7b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $23bcd42a245f9d7b$var$z[b] = new $23bcd42a245f9d7b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $23bcd42a245f9d7b$var$ra = /[\-:]([a-z])/g;
function $23bcd42a245f9d7b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($23bcd42a245f9d7b$var$ra, $23bcd42a245f9d7b$var$sa);
    $23bcd42a245f9d7b$var$z[b] = new $23bcd42a245f9d7b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($23bcd42a245f9d7b$var$ra, $23bcd42a245f9d7b$var$sa);
    $23bcd42a245f9d7b$var$z[b] = new $23bcd42a245f9d7b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($23bcd42a245f9d7b$var$ra, $23bcd42a245f9d7b$var$sa);
    $23bcd42a245f9d7b$var$z[b] = new $23bcd42a245f9d7b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$23bcd42a245f9d7b$var$z.xlinkHref = new $23bcd42a245f9d7b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $23bcd42a245f9d7b$var$z[a] = new $23bcd42a245f9d7b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $23bcd42a245f9d7b$var$ta(a, b, c, d) {
    var e = $23bcd42a245f9d7b$var$z.hasOwnProperty(b) ? $23bcd42a245f9d7b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $23bcd42a245f9d7b$var$qa(b, c, e, d) && (c = null), d || null === e ? $23bcd42a245f9d7b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $23bcd42a245f9d7b$var$ua = $bnENU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $23bcd42a245f9d7b$var$va = Symbol.for("react.element"), $23bcd42a245f9d7b$var$wa = Symbol.for("react.portal"), $23bcd42a245f9d7b$var$ya = Symbol.for("react.fragment"), $23bcd42a245f9d7b$var$za = Symbol.for("react.strict_mode"), $23bcd42a245f9d7b$var$Aa = Symbol.for("react.profiler"), $23bcd42a245f9d7b$var$Ba = Symbol.for("react.provider"), $23bcd42a245f9d7b$var$Ca = Symbol.for("react.context"), $23bcd42a245f9d7b$var$Da = Symbol.for("react.forward_ref"), $23bcd42a245f9d7b$var$Ea = Symbol.for("react.suspense"), $23bcd42a245f9d7b$var$Fa = Symbol.for("react.suspense_list"), $23bcd42a245f9d7b$var$Ga = Symbol.for("react.memo"), $23bcd42a245f9d7b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $23bcd42a245f9d7b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $23bcd42a245f9d7b$var$Ja = Symbol.iterator;
function $23bcd42a245f9d7b$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $23bcd42a245f9d7b$var$Ja && a[$23bcd42a245f9d7b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $23bcd42a245f9d7b$var$A = Object.assign, $23bcd42a245f9d7b$var$La;
function $23bcd42a245f9d7b$var$Ma(a) {
    if (void 0 === $23bcd42a245f9d7b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $23bcd42a245f9d7b$var$La = b && b[1] || "";
    }
    return "\n" + $23bcd42a245f9d7b$var$La + a;
}
var $23bcd42a245f9d7b$var$Na = !1;
function $23bcd42a245f9d7b$var$Oa(a, b) {
    if (!a || $23bcd42a245f9d7b$var$Na) return "";
    $23bcd42a245f9d7b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $23bcd42a245f9d7b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $23bcd42a245f9d7b$var$Ma(a) : "";
}
function $23bcd42a245f9d7b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $23bcd42a245f9d7b$var$Ma(a.type);
        case 16:
            return $23bcd42a245f9d7b$var$Ma("Lazy");
        case 13:
            return $23bcd42a245f9d7b$var$Ma("Suspense");
        case 19:
            return $23bcd42a245f9d7b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $23bcd42a245f9d7b$var$Oa(a.type, !1), a;
        case 11:
            return a = $23bcd42a245f9d7b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $23bcd42a245f9d7b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $23bcd42a245f9d7b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $23bcd42a245f9d7b$var$ya:
            return "Fragment";
        case $23bcd42a245f9d7b$var$wa:
            return "Portal";
        case $23bcd42a245f9d7b$var$Aa:
            return "Profiler";
        case $23bcd42a245f9d7b$var$za:
            return "StrictMode";
        case $23bcd42a245f9d7b$var$Ea:
            return "Suspense";
        case $23bcd42a245f9d7b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $23bcd42a245f9d7b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $23bcd42a245f9d7b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $23bcd42a245f9d7b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $23bcd42a245f9d7b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $23bcd42a245f9d7b$var$Qa(a.type) || "Memo";
        case $23bcd42a245f9d7b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $23bcd42a245f9d7b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $23bcd42a245f9d7b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $23bcd42a245f9d7b$var$Qa(b);
        case 8:
            return b === $23bcd42a245f9d7b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $23bcd42a245f9d7b$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $23bcd42a245f9d7b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $23bcd42a245f9d7b$var$Ua(a) {
    var b = $23bcd42a245f9d7b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $23bcd42a245f9d7b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $23bcd42a245f9d7b$var$Ua(a));
}
function $23bcd42a245f9d7b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $23bcd42a245f9d7b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $23bcd42a245f9d7b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $23bcd42a245f9d7b$var$Ya(a, b) {
    var c = b.checked;
    return $23bcd42a245f9d7b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $23bcd42a245f9d7b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $23bcd42a245f9d7b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $23bcd42a245f9d7b$var$ab(a, b) {
    b = b.checked;
    null != b && $23bcd42a245f9d7b$var$ta(a, "checked", b, !1);
}
function $23bcd42a245f9d7b$var$bb(a, b) {
    $23bcd42a245f9d7b$var$ab(a, b);
    var c = $23bcd42a245f9d7b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $23bcd42a245f9d7b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $23bcd42a245f9d7b$var$cb(a, b.type, $23bcd42a245f9d7b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $23bcd42a245f9d7b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $23bcd42a245f9d7b$var$cb(a, b, c) {
    if ("number" !== b || $23bcd42a245f9d7b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $23bcd42a245f9d7b$var$eb = Array.isArray;
function $23bcd42a245f9d7b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $23bcd42a245f9d7b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $23bcd42a245f9d7b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($23bcd42a245f9d7b$var$p(91));
    return $23bcd42a245f9d7b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $23bcd42a245f9d7b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($23bcd42a245f9d7b$var$p(92));
            if ($23bcd42a245f9d7b$var$eb(c)) {
                if (1 < c.length) throw Error($23bcd42a245f9d7b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $23bcd42a245f9d7b$var$Sa(c)
    };
}
function $23bcd42a245f9d7b$var$ib(a, b) {
    var c = $23bcd42a245f9d7b$var$Sa(b.value), d = $23bcd42a245f9d7b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $23bcd42a245f9d7b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $23bcd42a245f9d7b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $23bcd42a245f9d7b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $23bcd42a245f9d7b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $23bcd42a245f9d7b$var$mb, $23bcd42a245f9d7b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $23bcd42a245f9d7b$var$mb = $23bcd42a245f9d7b$var$mb || document.createElement("div");
        $23bcd42a245f9d7b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $23bcd42a245f9d7b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $23bcd42a245f9d7b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $23bcd42a245f9d7b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $23bcd42a245f9d7b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($23bcd42a245f9d7b$var$pb).forEach(function(a) {
    $23bcd42a245f9d7b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $23bcd42a245f9d7b$var$pb[b] = $23bcd42a245f9d7b$var$pb[a];
    });
});
function $23bcd42a245f9d7b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $23bcd42a245f9d7b$var$pb.hasOwnProperty(a) && $23bcd42a245f9d7b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $23bcd42a245f9d7b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $23bcd42a245f9d7b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $23bcd42a245f9d7b$var$tb = $23bcd42a245f9d7b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $23bcd42a245f9d7b$var$ub(a, b) {
    if (b) {
        if ($23bcd42a245f9d7b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($23bcd42a245f9d7b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($23bcd42a245f9d7b$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($23bcd42a245f9d7b$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($23bcd42a245f9d7b$var$p(62));
    }
}
function $23bcd42a245f9d7b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $23bcd42a245f9d7b$var$wb = null;
function $23bcd42a245f9d7b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $23bcd42a245f9d7b$var$yb = null, $23bcd42a245f9d7b$var$zb = null, $23bcd42a245f9d7b$var$Ab = null;
function $23bcd42a245f9d7b$var$Bb(a) {
    if (a = $23bcd42a245f9d7b$var$Cb(a)) {
        if ("function" !== typeof $23bcd42a245f9d7b$var$yb) throw Error($23bcd42a245f9d7b$var$p(280));
        var b = a.stateNode;
        b && (b = $23bcd42a245f9d7b$var$Db(b), $23bcd42a245f9d7b$var$yb(a.stateNode, a.type, b));
    }
}
function $23bcd42a245f9d7b$var$Eb(a) {
    $23bcd42a245f9d7b$var$zb ? $23bcd42a245f9d7b$var$Ab ? $23bcd42a245f9d7b$var$Ab.push(a) : $23bcd42a245f9d7b$var$Ab = [
        a
    ] : $23bcd42a245f9d7b$var$zb = a;
}
function $23bcd42a245f9d7b$var$Fb() {
    if ($23bcd42a245f9d7b$var$zb) {
        var a = $23bcd42a245f9d7b$var$zb, b = $23bcd42a245f9d7b$var$Ab;
        $23bcd42a245f9d7b$var$Ab = $23bcd42a245f9d7b$var$zb = null;
        $23bcd42a245f9d7b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$23bcd42a245f9d7b$var$Bb(b[a]);
    }
}
function $23bcd42a245f9d7b$var$Gb(a, b) {
    return a(b);
}
function $23bcd42a245f9d7b$var$Hb() {}
var $23bcd42a245f9d7b$var$Ib = !1;
function $23bcd42a245f9d7b$var$Jb(a, b, c) {
    if ($23bcd42a245f9d7b$var$Ib) return a(b, c);
    $23bcd42a245f9d7b$var$Ib = !0;
    try {
        return $23bcd42a245f9d7b$var$Gb(a, b, c);
    } finally{
        if ($23bcd42a245f9d7b$var$Ib = !1, null !== $23bcd42a245f9d7b$var$zb || null !== $23bcd42a245f9d7b$var$Ab) $23bcd42a245f9d7b$var$Hb(), $23bcd42a245f9d7b$var$Fb();
    }
}
function $23bcd42a245f9d7b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $23bcd42a245f9d7b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($23bcd42a245f9d7b$var$p(231, b, typeof c));
    return c;
}
var $23bcd42a245f9d7b$var$Lb = !1;
if ($23bcd42a245f9d7b$var$ia) try {
    var $23bcd42a245f9d7b$var$Mb = {};
    Object.defineProperty($23bcd42a245f9d7b$var$Mb, "passive", {
        get: function() {
            $23bcd42a245f9d7b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $23bcd42a245f9d7b$var$Mb, $23bcd42a245f9d7b$var$Mb);
    window.removeEventListener("test", $23bcd42a245f9d7b$var$Mb, $23bcd42a245f9d7b$var$Mb);
} catch (a) {
    $23bcd42a245f9d7b$var$Lb = !1;
}
function $23bcd42a245f9d7b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $23bcd42a245f9d7b$var$Ob = !1, $23bcd42a245f9d7b$var$Pb = null, $23bcd42a245f9d7b$var$Qb = !1, $23bcd42a245f9d7b$var$Rb = null, $23bcd42a245f9d7b$var$Sb = {
    onError: function(a) {
        $23bcd42a245f9d7b$var$Ob = !0;
        $23bcd42a245f9d7b$var$Pb = a;
    }
};
function $23bcd42a245f9d7b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $23bcd42a245f9d7b$var$Ob = !1;
    $23bcd42a245f9d7b$var$Pb = null;
    $23bcd42a245f9d7b$var$Nb.apply($23bcd42a245f9d7b$var$Sb, arguments);
}
function $23bcd42a245f9d7b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $23bcd42a245f9d7b$var$Tb.apply(this, arguments);
    if ($23bcd42a245f9d7b$var$Ob) {
        if ($23bcd42a245f9d7b$var$Ob) {
            var l = $23bcd42a245f9d7b$var$Pb;
            $23bcd42a245f9d7b$var$Ob = !1;
            $23bcd42a245f9d7b$var$Pb = null;
        } else throw Error($23bcd42a245f9d7b$var$p(198));
        $23bcd42a245f9d7b$var$Qb || ($23bcd42a245f9d7b$var$Qb = !0, $23bcd42a245f9d7b$var$Rb = l);
    }
}
function $23bcd42a245f9d7b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $23bcd42a245f9d7b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $23bcd42a245f9d7b$var$Xb(a) {
    if ($23bcd42a245f9d7b$var$Vb(a) !== a) throw Error($23bcd42a245f9d7b$var$p(188));
}
function $23bcd42a245f9d7b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $23bcd42a245f9d7b$var$Vb(a);
        if (null === b) throw Error($23bcd42a245f9d7b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $23bcd42a245f9d7b$var$Xb(e), a;
                if (f === d) return $23bcd42a245f9d7b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($23bcd42a245f9d7b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($23bcd42a245f9d7b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($23bcd42a245f9d7b$var$p(190));
    }
    if (3 !== c.tag) throw Error($23bcd42a245f9d7b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $23bcd42a245f9d7b$var$Zb(a) {
    a = $23bcd42a245f9d7b$var$Yb(a);
    return null !== a ? $23bcd42a245f9d7b$var$$b(a) : null;
}
function $23bcd42a245f9d7b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $23bcd42a245f9d7b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $23bcd42a245f9d7b$var$ac = $fOxuK.unstable_scheduleCallback, $23bcd42a245f9d7b$var$bc = $fOxuK.unstable_cancelCallback, $23bcd42a245f9d7b$var$cc = $fOxuK.unstable_shouldYield, $23bcd42a245f9d7b$var$dc = $fOxuK.unstable_requestPaint, $23bcd42a245f9d7b$var$B = $fOxuK.unstable_now, $23bcd42a245f9d7b$var$ec = $fOxuK.unstable_getCurrentPriorityLevel, $23bcd42a245f9d7b$var$fc = $fOxuK.unstable_ImmediatePriority, $23bcd42a245f9d7b$var$gc = $fOxuK.unstable_UserBlockingPriority, $23bcd42a245f9d7b$var$hc = $fOxuK.unstable_NormalPriority, $23bcd42a245f9d7b$var$ic = $fOxuK.unstable_LowPriority, $23bcd42a245f9d7b$var$jc = $fOxuK.unstable_IdlePriority, $23bcd42a245f9d7b$var$kc = null, $23bcd42a245f9d7b$var$lc = null;
function $23bcd42a245f9d7b$var$mc(a) {
    if ($23bcd42a245f9d7b$var$lc && "function" === typeof $23bcd42a245f9d7b$var$lc.onCommitFiberRoot) try {
        $23bcd42a245f9d7b$var$lc.onCommitFiberRoot($23bcd42a245f9d7b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $23bcd42a245f9d7b$var$oc = Math.clz32 ? Math.clz32 : $23bcd42a245f9d7b$var$nc, $23bcd42a245f9d7b$var$pc = Math.log, $23bcd42a245f9d7b$var$qc = Math.LN2;
function $23bcd42a245f9d7b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($23bcd42a245f9d7b$var$pc(a) / $23bcd42a245f9d7b$var$qc | 0) | 0;
}
var $23bcd42a245f9d7b$var$rc = 64, $23bcd42a245f9d7b$var$sc = 4194304;
function $23bcd42a245f9d7b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $23bcd42a245f9d7b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $23bcd42a245f9d7b$var$tc(h) : (f &= g, 0 !== f && (d = $23bcd42a245f9d7b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $23bcd42a245f9d7b$var$tc(g) : 0 !== f && (d = $23bcd42a245f9d7b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $23bcd42a245f9d7b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $23bcd42a245f9d7b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $23bcd42a245f9d7b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $23bcd42a245f9d7b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $23bcd42a245f9d7b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $23bcd42a245f9d7b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $23bcd42a245f9d7b$var$yc() {
    var a = $23bcd42a245f9d7b$var$rc;
    $23bcd42a245f9d7b$var$rc <<= 1;
    0 === ($23bcd42a245f9d7b$var$rc & 4194240) && ($23bcd42a245f9d7b$var$rc = 64);
    return a;
}
function $23bcd42a245f9d7b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $23bcd42a245f9d7b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $23bcd42a245f9d7b$var$oc(b);
    a[b] = c;
}
function $23bcd42a245f9d7b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $23bcd42a245f9d7b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $23bcd42a245f9d7b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $23bcd42a245f9d7b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $23bcd42a245f9d7b$var$C = 0;
function $23bcd42a245f9d7b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $23bcd42a245f9d7b$var$Ec, $23bcd42a245f9d7b$var$Fc, $23bcd42a245f9d7b$var$Gc, $23bcd42a245f9d7b$var$Hc, $23bcd42a245f9d7b$var$Ic, $23bcd42a245f9d7b$var$Jc = !1, $23bcd42a245f9d7b$var$Kc = [], $23bcd42a245f9d7b$var$Lc = null, $23bcd42a245f9d7b$var$Mc = null, $23bcd42a245f9d7b$var$Nc = null, $23bcd42a245f9d7b$var$Oc = new Map, $23bcd42a245f9d7b$var$Pc = new Map, $23bcd42a245f9d7b$var$Qc = [], $23bcd42a245f9d7b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $23bcd42a245f9d7b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $23bcd42a245f9d7b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $23bcd42a245f9d7b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $23bcd42a245f9d7b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $23bcd42a245f9d7b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $23bcd42a245f9d7b$var$Pc.delete(b.pointerId);
    }
}
function $23bcd42a245f9d7b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $23bcd42a245f9d7b$var$Cb(b), null !== b && $23bcd42a245f9d7b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $23bcd42a245f9d7b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $23bcd42a245f9d7b$var$Lc = $23bcd42a245f9d7b$var$Tc($23bcd42a245f9d7b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $23bcd42a245f9d7b$var$Mc = $23bcd42a245f9d7b$var$Tc($23bcd42a245f9d7b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $23bcd42a245f9d7b$var$Nc = $23bcd42a245f9d7b$var$Tc($23bcd42a245f9d7b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $23bcd42a245f9d7b$var$Oc.set(f, $23bcd42a245f9d7b$var$Tc($23bcd42a245f9d7b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $23bcd42a245f9d7b$var$Pc.set(f, $23bcd42a245f9d7b$var$Tc($23bcd42a245f9d7b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $23bcd42a245f9d7b$var$Vc(a) {
    var b = $23bcd42a245f9d7b$var$Wc(a.target);
    if (null !== b) {
        var c = $23bcd42a245f9d7b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $23bcd42a245f9d7b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $23bcd42a245f9d7b$var$Ic(a.priority, function() {
                        $23bcd42a245f9d7b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $23bcd42a245f9d7b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $23bcd42a245f9d7b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $23bcd42a245f9d7b$var$wb = d;
            c.target.dispatchEvent(d);
            $23bcd42a245f9d7b$var$wb = null;
        } else return b = $23bcd42a245f9d7b$var$Cb(c), null !== b && $23bcd42a245f9d7b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $23bcd42a245f9d7b$var$Zc(a, b, c) {
    $23bcd42a245f9d7b$var$Xc(a) && c.delete(b);
}
function $23bcd42a245f9d7b$var$$c() {
    $23bcd42a245f9d7b$var$Jc = !1;
    null !== $23bcd42a245f9d7b$var$Lc && $23bcd42a245f9d7b$var$Xc($23bcd42a245f9d7b$var$Lc) && ($23bcd42a245f9d7b$var$Lc = null);
    null !== $23bcd42a245f9d7b$var$Mc && $23bcd42a245f9d7b$var$Xc($23bcd42a245f9d7b$var$Mc) && ($23bcd42a245f9d7b$var$Mc = null);
    null !== $23bcd42a245f9d7b$var$Nc && $23bcd42a245f9d7b$var$Xc($23bcd42a245f9d7b$var$Nc) && ($23bcd42a245f9d7b$var$Nc = null);
    $23bcd42a245f9d7b$var$Oc.forEach($23bcd42a245f9d7b$var$Zc);
    $23bcd42a245f9d7b$var$Pc.forEach($23bcd42a245f9d7b$var$Zc);
}
function $23bcd42a245f9d7b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $23bcd42a245f9d7b$var$Jc || ($23bcd42a245f9d7b$var$Jc = !0, $fOxuK.unstable_scheduleCallback($fOxuK.unstable_NormalPriority, $23bcd42a245f9d7b$var$$c)));
}
function $23bcd42a245f9d7b$var$bd(a) {
    function b(b) {
        return $23bcd42a245f9d7b$var$ad(b, a);
    }
    if (0 < $23bcd42a245f9d7b$var$Kc.length) {
        $23bcd42a245f9d7b$var$ad($23bcd42a245f9d7b$var$Kc[0], a);
        for(var c = 1; c < $23bcd42a245f9d7b$var$Kc.length; c++){
            var d = $23bcd42a245f9d7b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $23bcd42a245f9d7b$var$Lc && $23bcd42a245f9d7b$var$ad($23bcd42a245f9d7b$var$Lc, a);
    null !== $23bcd42a245f9d7b$var$Mc && $23bcd42a245f9d7b$var$ad($23bcd42a245f9d7b$var$Mc, a);
    null !== $23bcd42a245f9d7b$var$Nc && $23bcd42a245f9d7b$var$ad($23bcd42a245f9d7b$var$Nc, a);
    $23bcd42a245f9d7b$var$Oc.forEach(b);
    $23bcd42a245f9d7b$var$Pc.forEach(b);
    for(c = 0; c < $23bcd42a245f9d7b$var$Qc.length; c++)d = $23bcd42a245f9d7b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $23bcd42a245f9d7b$var$Qc.length && (c = $23bcd42a245f9d7b$var$Qc[0], null === c.blockedOn);)$23bcd42a245f9d7b$var$Vc(c), null === c.blockedOn && $23bcd42a245f9d7b$var$Qc.shift();
}
var $23bcd42a245f9d7b$var$cd = $23bcd42a245f9d7b$var$ua.ReactCurrentBatchConfig, $23bcd42a245f9d7b$var$dd = !0;
function $23bcd42a245f9d7b$var$ed(a, b, c, d) {
    var e = $23bcd42a245f9d7b$var$C, f = $23bcd42a245f9d7b$var$cd.transition;
    $23bcd42a245f9d7b$var$cd.transition = null;
    try {
        $23bcd42a245f9d7b$var$C = 1, $23bcd42a245f9d7b$var$fd(a, b, c, d);
    } finally{
        $23bcd42a245f9d7b$var$C = e, $23bcd42a245f9d7b$var$cd.transition = f;
    }
}
function $23bcd42a245f9d7b$var$gd(a, b, c, d) {
    var e = $23bcd42a245f9d7b$var$C, f = $23bcd42a245f9d7b$var$cd.transition;
    $23bcd42a245f9d7b$var$cd.transition = null;
    try {
        $23bcd42a245f9d7b$var$C = 4, $23bcd42a245f9d7b$var$fd(a, b, c, d);
    } finally{
        $23bcd42a245f9d7b$var$C = e, $23bcd42a245f9d7b$var$cd.transition = f;
    }
}
function $23bcd42a245f9d7b$var$fd(a, b, c, d) {
    if ($23bcd42a245f9d7b$var$dd) {
        var e = $23bcd42a245f9d7b$var$Yc(a, b, c, d);
        if (null === e) $23bcd42a245f9d7b$var$hd(a, b, d, $23bcd42a245f9d7b$var$id, c), $23bcd42a245f9d7b$var$Sc(a, d);
        else if ($23bcd42a245f9d7b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($23bcd42a245f9d7b$var$Sc(a, d), b & 4 && -1 < $23bcd42a245f9d7b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $23bcd42a245f9d7b$var$Cb(e);
                null !== f && $23bcd42a245f9d7b$var$Ec(f);
                f = $23bcd42a245f9d7b$var$Yc(a, b, c, d);
                null === f && $23bcd42a245f9d7b$var$hd(a, b, d, $23bcd42a245f9d7b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $23bcd42a245f9d7b$var$hd(a, b, d, null, c);
    }
}
var $23bcd42a245f9d7b$var$id = null;
function $23bcd42a245f9d7b$var$Yc(a, b, c, d) {
    $23bcd42a245f9d7b$var$id = null;
    a = $23bcd42a245f9d7b$var$xb(d);
    a = $23bcd42a245f9d7b$var$Wc(a);
    if (null !== a) {
        if (b = $23bcd42a245f9d7b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $23bcd42a245f9d7b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $23bcd42a245f9d7b$var$id = a;
    return null;
}
function $23bcd42a245f9d7b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($23bcd42a245f9d7b$var$ec()){
                case $23bcd42a245f9d7b$var$fc:
                    return 1;
                case $23bcd42a245f9d7b$var$gc:
                    return 4;
                case $23bcd42a245f9d7b$var$hc:
                case $23bcd42a245f9d7b$var$ic:
                    return 16;
                case $23bcd42a245f9d7b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $23bcd42a245f9d7b$var$kd = null, $23bcd42a245f9d7b$var$ld = null, $23bcd42a245f9d7b$var$md = null;
function $23bcd42a245f9d7b$var$nd() {
    if ($23bcd42a245f9d7b$var$md) return $23bcd42a245f9d7b$var$md;
    var a, b = $23bcd42a245f9d7b$var$ld, c = b.length, d, e = "value" in $23bcd42a245f9d7b$var$kd ? $23bcd42a245f9d7b$var$kd.value : $23bcd42a245f9d7b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $23bcd42a245f9d7b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $23bcd42a245f9d7b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $23bcd42a245f9d7b$var$pd() {
    return !0;
}
function $23bcd42a245f9d7b$var$qd() {
    return !1;
}
function $23bcd42a245f9d7b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $23bcd42a245f9d7b$var$pd : $23bcd42a245f9d7b$var$qd;
        this.isPropagationStopped = $23bcd42a245f9d7b$var$qd;
        return this;
    }
    $23bcd42a245f9d7b$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $23bcd42a245f9d7b$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $23bcd42a245f9d7b$var$pd);
        },
        persist: function() {},
        isPersistent: $23bcd42a245f9d7b$var$pd
    });
    return b;
}
var $23bcd42a245f9d7b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $23bcd42a245f9d7b$var$td = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$sd), $23bcd42a245f9d7b$var$ud = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$sd, {
    view: 0,
    detail: 0
}), $23bcd42a245f9d7b$var$vd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$ud), $23bcd42a245f9d7b$var$wd, $23bcd42a245f9d7b$var$xd, $23bcd42a245f9d7b$var$yd, $23bcd42a245f9d7b$var$Ad = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $23bcd42a245f9d7b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $23bcd42a245f9d7b$var$yd && ($23bcd42a245f9d7b$var$yd && "mousemove" === a.type ? ($23bcd42a245f9d7b$var$wd = a.screenX - $23bcd42a245f9d7b$var$yd.screenX, $23bcd42a245f9d7b$var$xd = a.screenY - $23bcd42a245f9d7b$var$yd.screenY) : $23bcd42a245f9d7b$var$xd = $23bcd42a245f9d7b$var$wd = 0, $23bcd42a245f9d7b$var$yd = a);
        return $23bcd42a245f9d7b$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $23bcd42a245f9d7b$var$xd;
    }
}), $23bcd42a245f9d7b$var$Bd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Ad), $23bcd42a245f9d7b$var$Cd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$Ad, {
    dataTransfer: 0
}), $23bcd42a245f9d7b$var$Dd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Cd), $23bcd42a245f9d7b$var$Ed = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$ud, {
    relatedTarget: 0
}), $23bcd42a245f9d7b$var$Fd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Ed), $23bcd42a245f9d7b$var$Gd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $23bcd42a245f9d7b$var$Hd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Gd), $23bcd42a245f9d7b$var$Id = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $23bcd42a245f9d7b$var$Jd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Id), $23bcd42a245f9d7b$var$Kd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$sd, {
    data: 0
}), $23bcd42a245f9d7b$var$Ld = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Kd), $23bcd42a245f9d7b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $23bcd42a245f9d7b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $23bcd42a245f9d7b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $23bcd42a245f9d7b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $23bcd42a245f9d7b$var$Od[a]) ? !!b[a] : !1;
}
function $23bcd42a245f9d7b$var$zd() {
    return $23bcd42a245f9d7b$var$Pd;
}
var $23bcd42a245f9d7b$var$Qd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $23bcd42a245f9d7b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $23bcd42a245f9d7b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $23bcd42a245f9d7b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $23bcd42a245f9d7b$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $23bcd42a245f9d7b$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $23bcd42a245f9d7b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $23bcd42a245f9d7b$var$Rd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Qd), $23bcd42a245f9d7b$var$Sd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $23bcd42a245f9d7b$var$Td = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Sd), $23bcd42a245f9d7b$var$Ud = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $23bcd42a245f9d7b$var$zd
}), $23bcd42a245f9d7b$var$Vd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Ud), $23bcd42a245f9d7b$var$Wd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $23bcd42a245f9d7b$var$Xd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Wd), $23bcd42a245f9d7b$var$Yd = $23bcd42a245f9d7b$var$A({}, $23bcd42a245f9d7b$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $23bcd42a245f9d7b$var$Zd = $23bcd42a245f9d7b$var$rd($23bcd42a245f9d7b$var$Yd), $23bcd42a245f9d7b$var$$d = [
    9,
    13,
    27,
    32
], $23bcd42a245f9d7b$var$ae = $23bcd42a245f9d7b$var$ia && "CompositionEvent" in window, $23bcd42a245f9d7b$var$be = null;
$23bcd42a245f9d7b$var$ia && "documentMode" in document && ($23bcd42a245f9d7b$var$be = document.documentMode);
var $23bcd42a245f9d7b$var$ce = $23bcd42a245f9d7b$var$ia && "TextEvent" in window && !$23bcd42a245f9d7b$var$be, $23bcd42a245f9d7b$var$de = $23bcd42a245f9d7b$var$ia && (!$23bcd42a245f9d7b$var$ae || $23bcd42a245f9d7b$var$be && 8 < $23bcd42a245f9d7b$var$be && 11 >= $23bcd42a245f9d7b$var$be), $23bcd42a245f9d7b$var$ee = String.fromCharCode(32), $23bcd42a245f9d7b$var$fe = !1;
function $23bcd42a245f9d7b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $23bcd42a245f9d7b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $23bcd42a245f9d7b$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $23bcd42a245f9d7b$var$ie = !1;
function $23bcd42a245f9d7b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $23bcd42a245f9d7b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $23bcd42a245f9d7b$var$fe = !0;
            return $23bcd42a245f9d7b$var$ee;
        case "textInput":
            return a = b.data, a === $23bcd42a245f9d7b$var$ee && $23bcd42a245f9d7b$var$fe ? null : a;
        default:
            return null;
    }
}
function $23bcd42a245f9d7b$var$ke(a, b) {
    if ($23bcd42a245f9d7b$var$ie) return "compositionend" === a || !$23bcd42a245f9d7b$var$ae && $23bcd42a245f9d7b$var$ge(a, b) ? (a = $23bcd42a245f9d7b$var$nd(), $23bcd42a245f9d7b$var$md = $23bcd42a245f9d7b$var$ld = $23bcd42a245f9d7b$var$kd = null, $23bcd42a245f9d7b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $23bcd42a245f9d7b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $23bcd42a245f9d7b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $23bcd42a245f9d7b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$23bcd42a245f9d7b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $23bcd42a245f9d7b$var$ne(a, b, c, d) {
    $23bcd42a245f9d7b$var$Eb(d);
    b = $23bcd42a245f9d7b$var$oe(b, "onChange");
    0 < b.length && (c = new $23bcd42a245f9d7b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $23bcd42a245f9d7b$var$pe = null, $23bcd42a245f9d7b$var$qe = null;
function $23bcd42a245f9d7b$var$re(a) {
    $23bcd42a245f9d7b$var$se(a, 0);
}
function $23bcd42a245f9d7b$var$te(a) {
    var b = $23bcd42a245f9d7b$var$ue(a);
    if ($23bcd42a245f9d7b$var$Wa(b)) return a;
}
function $23bcd42a245f9d7b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $23bcd42a245f9d7b$var$we = !1;
if ($23bcd42a245f9d7b$var$ia) {
    var $23bcd42a245f9d7b$var$xe;
    if ($23bcd42a245f9d7b$var$ia) {
        var $23bcd42a245f9d7b$var$ye = "oninput" in document;
        if (!$23bcd42a245f9d7b$var$ye) {
            var $23bcd42a245f9d7b$var$ze = document.createElement("div");
            $23bcd42a245f9d7b$var$ze.setAttribute("oninput", "return;");
            $23bcd42a245f9d7b$var$ye = "function" === typeof $23bcd42a245f9d7b$var$ze.oninput;
        }
        $23bcd42a245f9d7b$var$xe = $23bcd42a245f9d7b$var$ye;
    } else $23bcd42a245f9d7b$var$xe = !1;
    $23bcd42a245f9d7b$var$we = $23bcd42a245f9d7b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $23bcd42a245f9d7b$var$Ae() {
    $23bcd42a245f9d7b$var$pe && ($23bcd42a245f9d7b$var$pe.detachEvent("onpropertychange", $23bcd42a245f9d7b$var$Be), $23bcd42a245f9d7b$var$qe = $23bcd42a245f9d7b$var$pe = null);
}
function $23bcd42a245f9d7b$var$Be(a) {
    if ("value" === a.propertyName && $23bcd42a245f9d7b$var$te($23bcd42a245f9d7b$var$qe)) {
        var b = [];
        $23bcd42a245f9d7b$var$ne(b, $23bcd42a245f9d7b$var$qe, a, $23bcd42a245f9d7b$var$xb(a));
        $23bcd42a245f9d7b$var$Jb($23bcd42a245f9d7b$var$re, b);
    }
}
function $23bcd42a245f9d7b$var$Ce(a, b, c) {
    "focusin" === a ? ($23bcd42a245f9d7b$var$Ae(), $23bcd42a245f9d7b$var$pe = b, $23bcd42a245f9d7b$var$qe = c, $23bcd42a245f9d7b$var$pe.attachEvent("onpropertychange", $23bcd42a245f9d7b$var$Be)) : "focusout" === a && $23bcd42a245f9d7b$var$Ae();
}
function $23bcd42a245f9d7b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $23bcd42a245f9d7b$var$te($23bcd42a245f9d7b$var$qe);
}
function $23bcd42a245f9d7b$var$Ee(a, b) {
    if ("click" === a) return $23bcd42a245f9d7b$var$te(b);
}
function $23bcd42a245f9d7b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $23bcd42a245f9d7b$var$te(b);
}
function $23bcd42a245f9d7b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $23bcd42a245f9d7b$var$He = "function" === typeof Object.is ? Object.is : $23bcd42a245f9d7b$var$Ge;
function $23bcd42a245f9d7b$var$Ie(a, b) {
    if ($23bcd42a245f9d7b$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$23bcd42a245f9d7b$var$ja.call(b, e) || !$23bcd42a245f9d7b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $23bcd42a245f9d7b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $23bcd42a245f9d7b$var$Ke(a, b) {
    var c = $23bcd42a245f9d7b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $23bcd42a245f9d7b$var$Je(c);
    }
}
function $23bcd42a245f9d7b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $23bcd42a245f9d7b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $23bcd42a245f9d7b$var$Me() {
    for(var a = window, b = $23bcd42a245f9d7b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $23bcd42a245f9d7b$var$Xa(a.document);
    }
    return b;
}
function $23bcd42a245f9d7b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $23bcd42a245f9d7b$var$Oe(a) {
    var b = $23bcd42a245f9d7b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $23bcd42a245f9d7b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $23bcd42a245f9d7b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $23bcd42a245f9d7b$var$Ke(c, f);
                var g = $23bcd42a245f9d7b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $23bcd42a245f9d7b$var$Pe = $23bcd42a245f9d7b$var$ia && "documentMode" in document && 11 >= document.documentMode, $23bcd42a245f9d7b$var$Qe = null, $23bcd42a245f9d7b$var$Re = null, $23bcd42a245f9d7b$var$Se = null, $23bcd42a245f9d7b$var$Te = !1;
function $23bcd42a245f9d7b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $23bcd42a245f9d7b$var$Te || null == $23bcd42a245f9d7b$var$Qe || $23bcd42a245f9d7b$var$Qe !== $23bcd42a245f9d7b$var$Xa(d) || (d = $23bcd42a245f9d7b$var$Qe, "selectionStart" in d && $23bcd42a245f9d7b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $23bcd42a245f9d7b$var$Se && $23bcd42a245f9d7b$var$Ie($23bcd42a245f9d7b$var$Se, d) || ($23bcd42a245f9d7b$var$Se = d, d = $23bcd42a245f9d7b$var$oe($23bcd42a245f9d7b$var$Re, "onSelect"), 0 < d.length && (b = new $23bcd42a245f9d7b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $23bcd42a245f9d7b$var$Qe)));
}
function $23bcd42a245f9d7b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $23bcd42a245f9d7b$var$We = {
    animationend: $23bcd42a245f9d7b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $23bcd42a245f9d7b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $23bcd42a245f9d7b$var$Ve("Animation", "AnimationStart"),
    transitionend: $23bcd42a245f9d7b$var$Ve("Transition", "TransitionEnd")
}, $23bcd42a245f9d7b$var$Xe = {}, $23bcd42a245f9d7b$var$Ye = {};
$23bcd42a245f9d7b$var$ia && ($23bcd42a245f9d7b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $23bcd42a245f9d7b$var$We.animationend.animation, delete $23bcd42a245f9d7b$var$We.animationiteration.animation, delete $23bcd42a245f9d7b$var$We.animationstart.animation), "TransitionEvent" in window || delete $23bcd42a245f9d7b$var$We.transitionend.transition);
function $23bcd42a245f9d7b$var$Ze(a) {
    if ($23bcd42a245f9d7b$var$Xe[a]) return $23bcd42a245f9d7b$var$Xe[a];
    if (!$23bcd42a245f9d7b$var$We[a]) return a;
    var b = $23bcd42a245f9d7b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $23bcd42a245f9d7b$var$Ye) return $23bcd42a245f9d7b$var$Xe[a] = b[c];
    return a;
}
var $23bcd42a245f9d7b$var$$e = $23bcd42a245f9d7b$var$Ze("animationend"), $23bcd42a245f9d7b$var$af = $23bcd42a245f9d7b$var$Ze("animationiteration"), $23bcd42a245f9d7b$var$bf = $23bcd42a245f9d7b$var$Ze("animationstart"), $23bcd42a245f9d7b$var$cf = $23bcd42a245f9d7b$var$Ze("transitionend"), $23bcd42a245f9d7b$var$df = new Map, $23bcd42a245f9d7b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $23bcd42a245f9d7b$var$ff(a, b) {
    $23bcd42a245f9d7b$var$df.set(a, b);
    $23bcd42a245f9d7b$var$fa(b, [
        a
    ]);
}
for(var $23bcd42a245f9d7b$var$gf = 0; $23bcd42a245f9d7b$var$gf < $23bcd42a245f9d7b$var$ef.length; $23bcd42a245f9d7b$var$gf++){
    var $23bcd42a245f9d7b$var$hf = $23bcd42a245f9d7b$var$ef[$23bcd42a245f9d7b$var$gf], $23bcd42a245f9d7b$var$jf = $23bcd42a245f9d7b$var$hf.toLowerCase(), $23bcd42a245f9d7b$var$kf = $23bcd42a245f9d7b$var$hf[0].toUpperCase() + $23bcd42a245f9d7b$var$hf.slice(1);
    $23bcd42a245f9d7b$var$ff($23bcd42a245f9d7b$var$jf, "on" + $23bcd42a245f9d7b$var$kf);
}
$23bcd42a245f9d7b$var$ff($23bcd42a245f9d7b$var$$e, "onAnimationEnd");
$23bcd42a245f9d7b$var$ff($23bcd42a245f9d7b$var$af, "onAnimationIteration");
$23bcd42a245f9d7b$var$ff($23bcd42a245f9d7b$var$bf, "onAnimationStart");
$23bcd42a245f9d7b$var$ff("dblclick", "onDoubleClick");
$23bcd42a245f9d7b$var$ff("focusin", "onFocus");
$23bcd42a245f9d7b$var$ff("focusout", "onBlur");
$23bcd42a245f9d7b$var$ff($23bcd42a245f9d7b$var$cf, "onTransitionEnd");
$23bcd42a245f9d7b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$23bcd42a245f9d7b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$23bcd42a245f9d7b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$23bcd42a245f9d7b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$23bcd42a245f9d7b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$23bcd42a245f9d7b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$23bcd42a245f9d7b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$23bcd42a245f9d7b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$23bcd42a245f9d7b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$23bcd42a245f9d7b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $23bcd42a245f9d7b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $23bcd42a245f9d7b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($23bcd42a245f9d7b$var$lf));
function $23bcd42a245f9d7b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $23bcd42a245f9d7b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $23bcd42a245f9d7b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $23bcd42a245f9d7b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $23bcd42a245f9d7b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($23bcd42a245f9d7b$var$Qb) throw a = $23bcd42a245f9d7b$var$Rb, $23bcd42a245f9d7b$var$Qb = !1, $23bcd42a245f9d7b$var$Rb = null, a;
}
function $23bcd42a245f9d7b$var$D(a, b) {
    var c = b[$23bcd42a245f9d7b$var$of];
    void 0 === c && (c = b[$23bcd42a245f9d7b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($23bcd42a245f9d7b$var$pf(b, a, 2, !1), c.add(d));
}
function $23bcd42a245f9d7b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $23bcd42a245f9d7b$var$pf(c, a, d, b);
}
var $23bcd42a245f9d7b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $23bcd42a245f9d7b$var$sf(a) {
    if (!a[$23bcd42a245f9d7b$var$rf]) {
        a[$23bcd42a245f9d7b$var$rf] = !0;
        $23bcd42a245f9d7b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($23bcd42a245f9d7b$var$mf.has(b) || $23bcd42a245f9d7b$var$qf(b, !1, a), $23bcd42a245f9d7b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$23bcd42a245f9d7b$var$rf] || (b[$23bcd42a245f9d7b$var$rf] = !0, $23bcd42a245f9d7b$var$qf("selectionchange", !1, b));
    }
}
function $23bcd42a245f9d7b$var$pf(a, b, c, d) {
    switch($23bcd42a245f9d7b$var$jd(b)){
        case 1:
            var e = $23bcd42a245f9d7b$var$ed;
            break;
        case 4:
            e = $23bcd42a245f9d7b$var$gd;
            break;
        default:
            e = $23bcd42a245f9d7b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$23bcd42a245f9d7b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $23bcd42a245f9d7b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $23bcd42a245f9d7b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $23bcd42a245f9d7b$var$Jb(function() {
        var d = f, e = $23bcd42a245f9d7b$var$xb(c), g = [];
        a: {
            var h = $23bcd42a245f9d7b$var$df.get(a);
            if (void 0 !== h) {
                var k = $23bcd42a245f9d7b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $23bcd42a245f9d7b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $23bcd42a245f9d7b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $23bcd42a245f9d7b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $23bcd42a245f9d7b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $23bcd42a245f9d7b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $23bcd42a245f9d7b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $23bcd42a245f9d7b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $23bcd42a245f9d7b$var$Vd;
                        break;
                    case $23bcd42a245f9d7b$var$$e:
                    case $23bcd42a245f9d7b$var$af:
                    case $23bcd42a245f9d7b$var$bf:
                        k = $23bcd42a245f9d7b$var$Hd;
                        break;
                    case $23bcd42a245f9d7b$var$cf:
                        k = $23bcd42a245f9d7b$var$Xd;
                        break;
                    case "scroll":
                        k = $23bcd42a245f9d7b$var$vd;
                        break;
                    case "wheel":
                        k = $23bcd42a245f9d7b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $23bcd42a245f9d7b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $23bcd42a245f9d7b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $23bcd42a245f9d7b$var$Kb(w, x), null != F && t.push($23bcd42a245f9d7b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $23bcd42a245f9d7b$var$wb && (n = c.relatedTarget || c.fromElement) && ($23bcd42a245f9d7b$var$Wc(n) || n[$23bcd42a245f9d7b$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $23bcd42a245f9d7b$var$Wc(n) : null, null !== n && (J = $23bcd42a245f9d7b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $23bcd42a245f9d7b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $23bcd42a245f9d7b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $23bcd42a245f9d7b$var$ue(k);
                        u = null == n ? h : $23bcd42a245f9d7b$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $23bcd42a245f9d7b$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $23bcd42a245f9d7b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $23bcd42a245f9d7b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $23bcd42a245f9d7b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $23bcd42a245f9d7b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $23bcd42a245f9d7b$var$vf(t);
                                x = $23bcd42a245f9d7b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $23bcd42a245f9d7b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $23bcd42a245f9d7b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $23bcd42a245f9d7b$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $23bcd42a245f9d7b$var$ve;
                else if ($23bcd42a245f9d7b$var$me(h)) {
                    if ($23bcd42a245f9d7b$var$we) na = $23bcd42a245f9d7b$var$Fe;
                    else {
                        na = $23bcd42a245f9d7b$var$De;
                        var xa = $23bcd42a245f9d7b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $23bcd42a245f9d7b$var$Ee);
                if (na && (na = na(a, d))) {
                    $23bcd42a245f9d7b$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $23bcd42a245f9d7b$var$cb(h, "number", h.value);
            }
            xa = d ? $23bcd42a245f9d7b$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($23bcd42a245f9d7b$var$me(xa) || "true" === xa.contentEditable) $23bcd42a245f9d7b$var$Qe = xa, $23bcd42a245f9d7b$var$Re = d, $23bcd42a245f9d7b$var$Se = null;
                    break;
                case "focusout":
                    $23bcd42a245f9d7b$var$Se = $23bcd42a245f9d7b$var$Re = $23bcd42a245f9d7b$var$Qe = null;
                    break;
                case "mousedown":
                    $23bcd42a245f9d7b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $23bcd42a245f9d7b$var$Te = !1;
                    $23bcd42a245f9d7b$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($23bcd42a245f9d7b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $23bcd42a245f9d7b$var$Ue(g, c, e);
            }
            var $a;
            if ($23bcd42a245f9d7b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $23bcd42a245f9d7b$var$ie ? $23bcd42a245f9d7b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($23bcd42a245f9d7b$var$de && "ko" !== c.locale && ($23bcd42a245f9d7b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $23bcd42a245f9d7b$var$ie && ($a = $23bcd42a245f9d7b$var$nd()) : ($23bcd42a245f9d7b$var$kd = e, $23bcd42a245f9d7b$var$ld = "value" in $23bcd42a245f9d7b$var$kd ? $23bcd42a245f9d7b$var$kd.value : $23bcd42a245f9d7b$var$kd.textContent, $23bcd42a245f9d7b$var$ie = !0)), xa = $23bcd42a245f9d7b$var$oe(d, ba), 0 < xa.length && (ba = new $23bcd42a245f9d7b$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $23bcd42a245f9d7b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $23bcd42a245f9d7b$var$ce ? $23bcd42a245f9d7b$var$je(a, c) : $23bcd42a245f9d7b$var$ke(a, c)) d = $23bcd42a245f9d7b$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $23bcd42a245f9d7b$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $23bcd42a245f9d7b$var$se(g, b);
    });
}
function $23bcd42a245f9d7b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $23bcd42a245f9d7b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $23bcd42a245f9d7b$var$Kb(a, c), null != f && d.unshift($23bcd42a245f9d7b$var$tf(a, f, e)), f = $23bcd42a245f9d7b$var$Kb(a, b), null != f && d.push($23bcd42a245f9d7b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $23bcd42a245f9d7b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $23bcd42a245f9d7b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $23bcd42a245f9d7b$var$Kb(c, f), null != k && g.unshift($23bcd42a245f9d7b$var$tf(c, k, h))) : e || (k = $23bcd42a245f9d7b$var$Kb(c, f), null != k && g.push($23bcd42a245f9d7b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $23bcd42a245f9d7b$var$xf = /\r\n?/g, $23bcd42a245f9d7b$var$yf = /\u0000|\uFFFD/g;
function $23bcd42a245f9d7b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($23bcd42a245f9d7b$var$xf, "\n").replace($23bcd42a245f9d7b$var$yf, "");
}
function $23bcd42a245f9d7b$var$Af(a, b, c) {
    b = $23bcd42a245f9d7b$var$zf(b);
    if ($23bcd42a245f9d7b$var$zf(a) !== b && c) throw Error($23bcd42a245f9d7b$var$p(425));
}
function $23bcd42a245f9d7b$var$Bf() {}
var $23bcd42a245f9d7b$var$Cf = null, $23bcd42a245f9d7b$var$Df = null;
function $23bcd42a245f9d7b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $23bcd42a245f9d7b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $23bcd42a245f9d7b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $23bcd42a245f9d7b$var$Hf = "function" === typeof Promise ? Promise : void 0, $23bcd42a245f9d7b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $23bcd42a245f9d7b$var$Hf ? function(a) {
    return $23bcd42a245f9d7b$var$Hf.resolve(null).then(a).catch($23bcd42a245f9d7b$var$If);
} : $23bcd42a245f9d7b$var$Ff;
function $23bcd42a245f9d7b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $23bcd42a245f9d7b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $23bcd42a245f9d7b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $23bcd42a245f9d7b$var$bd(b);
}
function $23bcd42a245f9d7b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $23bcd42a245f9d7b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $23bcd42a245f9d7b$var$Nf = Math.random().toString(36).slice(2), $23bcd42a245f9d7b$var$Of = "__reactFiber$" + $23bcd42a245f9d7b$var$Nf, $23bcd42a245f9d7b$var$Pf = "__reactProps$" + $23bcd42a245f9d7b$var$Nf, $23bcd42a245f9d7b$var$uf = "__reactContainer$" + $23bcd42a245f9d7b$var$Nf, $23bcd42a245f9d7b$var$of = "__reactEvents$" + $23bcd42a245f9d7b$var$Nf, $23bcd42a245f9d7b$var$Qf = "__reactListeners$" + $23bcd42a245f9d7b$var$Nf, $23bcd42a245f9d7b$var$Rf = "__reactHandles$" + $23bcd42a245f9d7b$var$Nf;
function $23bcd42a245f9d7b$var$Wc(a) {
    var b = a[$23bcd42a245f9d7b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$23bcd42a245f9d7b$var$uf] || c[$23bcd42a245f9d7b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $23bcd42a245f9d7b$var$Mf(a); null !== a;){
                if (c = a[$23bcd42a245f9d7b$var$Of]) return c;
                a = $23bcd42a245f9d7b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $23bcd42a245f9d7b$var$Cb(a) {
    a = a[$23bcd42a245f9d7b$var$Of] || a[$23bcd42a245f9d7b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $23bcd42a245f9d7b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($23bcd42a245f9d7b$var$p(33));
}
function $23bcd42a245f9d7b$var$Db(a) {
    return a[$23bcd42a245f9d7b$var$Pf] || null;
}
var $23bcd42a245f9d7b$var$Sf = [], $23bcd42a245f9d7b$var$Tf = -1;
function $23bcd42a245f9d7b$var$Uf(a) {
    return {
        current: a
    };
}
function $23bcd42a245f9d7b$var$E(a) {
    0 > $23bcd42a245f9d7b$var$Tf || (a.current = $23bcd42a245f9d7b$var$Sf[$23bcd42a245f9d7b$var$Tf], $23bcd42a245f9d7b$var$Sf[$23bcd42a245f9d7b$var$Tf] = null, $23bcd42a245f9d7b$var$Tf--);
}
function $23bcd42a245f9d7b$var$G(a, b) {
    $23bcd42a245f9d7b$var$Tf++;
    $23bcd42a245f9d7b$var$Sf[$23bcd42a245f9d7b$var$Tf] = a.current;
    a.current = b;
}
var $23bcd42a245f9d7b$var$Vf = {}, $23bcd42a245f9d7b$var$H = $23bcd42a245f9d7b$var$Uf($23bcd42a245f9d7b$var$Vf), $23bcd42a245f9d7b$var$Wf = $23bcd42a245f9d7b$var$Uf(!1), $23bcd42a245f9d7b$var$Xf = $23bcd42a245f9d7b$var$Vf;
function $23bcd42a245f9d7b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $23bcd42a245f9d7b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $23bcd42a245f9d7b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $23bcd42a245f9d7b$var$$f() {
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf);
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$H);
}
function $23bcd42a245f9d7b$var$ag(a, b, c) {
    if ($23bcd42a245f9d7b$var$H.current !== $23bcd42a245f9d7b$var$Vf) throw Error($23bcd42a245f9d7b$var$p(168));
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$H, b);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Wf, c);
}
function $23bcd42a245f9d7b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($23bcd42a245f9d7b$var$p(108, $23bcd42a245f9d7b$var$Ra(a) || "Unknown", e));
    return $23bcd42a245f9d7b$var$A({}, c, d);
}
function $23bcd42a245f9d7b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $23bcd42a245f9d7b$var$Vf;
    $23bcd42a245f9d7b$var$Xf = $23bcd42a245f9d7b$var$H.current;
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$H, a);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Wf, $23bcd42a245f9d7b$var$Wf.current);
    return !0;
}
function $23bcd42a245f9d7b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($23bcd42a245f9d7b$var$p(169));
    c ? (a = $23bcd42a245f9d7b$var$bg(a, b, $23bcd42a245f9d7b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf), $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$H), $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$H, a)) : $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Wf, c);
}
var $23bcd42a245f9d7b$var$eg = null, $23bcd42a245f9d7b$var$fg = !1, $23bcd42a245f9d7b$var$gg = !1;
function $23bcd42a245f9d7b$var$hg(a) {
    null === $23bcd42a245f9d7b$var$eg ? $23bcd42a245f9d7b$var$eg = [
        a
    ] : $23bcd42a245f9d7b$var$eg.push(a);
}
function $23bcd42a245f9d7b$var$ig(a) {
    $23bcd42a245f9d7b$var$fg = !0;
    $23bcd42a245f9d7b$var$hg(a);
}
function $23bcd42a245f9d7b$var$jg() {
    if (!$23bcd42a245f9d7b$var$gg && null !== $23bcd42a245f9d7b$var$eg) {
        $23bcd42a245f9d7b$var$gg = !0;
        var a = 0, b = $23bcd42a245f9d7b$var$C;
        try {
            var c = $23bcd42a245f9d7b$var$eg;
            for($23bcd42a245f9d7b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $23bcd42a245f9d7b$var$eg = null;
            $23bcd42a245f9d7b$var$fg = !1;
        } catch (e) {
            throw null !== $23bcd42a245f9d7b$var$eg && ($23bcd42a245f9d7b$var$eg = $23bcd42a245f9d7b$var$eg.slice(a + 1)), $23bcd42a245f9d7b$var$ac($23bcd42a245f9d7b$var$fc, $23bcd42a245f9d7b$var$jg), e;
        } finally{
            $23bcd42a245f9d7b$var$C = b, $23bcd42a245f9d7b$var$gg = !1;
        }
    }
    return null;
}
var $23bcd42a245f9d7b$var$kg = [], $23bcd42a245f9d7b$var$lg = 0, $23bcd42a245f9d7b$var$mg = null, $23bcd42a245f9d7b$var$ng = 0, $23bcd42a245f9d7b$var$og = [], $23bcd42a245f9d7b$var$pg = 0, $23bcd42a245f9d7b$var$qg = null, $23bcd42a245f9d7b$var$rg = 1, $23bcd42a245f9d7b$var$sg = "";
function $23bcd42a245f9d7b$var$tg(a, b) {
    $23bcd42a245f9d7b$var$kg[$23bcd42a245f9d7b$var$lg++] = $23bcd42a245f9d7b$var$ng;
    $23bcd42a245f9d7b$var$kg[$23bcd42a245f9d7b$var$lg++] = $23bcd42a245f9d7b$var$mg;
    $23bcd42a245f9d7b$var$mg = a;
    $23bcd42a245f9d7b$var$ng = b;
}
function $23bcd42a245f9d7b$var$ug(a, b, c) {
    $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$rg;
    $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$sg;
    $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$qg;
    $23bcd42a245f9d7b$var$qg = a;
    var d = $23bcd42a245f9d7b$var$rg;
    a = $23bcd42a245f9d7b$var$sg;
    var e = 32 - $23bcd42a245f9d7b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $23bcd42a245f9d7b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $23bcd42a245f9d7b$var$rg = 1 << 32 - $23bcd42a245f9d7b$var$oc(b) + e | c << e | d;
        $23bcd42a245f9d7b$var$sg = f + a;
    } else $23bcd42a245f9d7b$var$rg = 1 << f | c << e | d, $23bcd42a245f9d7b$var$sg = a;
}
function $23bcd42a245f9d7b$var$vg(a) {
    null !== a.return && ($23bcd42a245f9d7b$var$tg(a, 1), $23bcd42a245f9d7b$var$ug(a, 1, 0));
}
function $23bcd42a245f9d7b$var$wg(a) {
    for(; a === $23bcd42a245f9d7b$var$mg;)$23bcd42a245f9d7b$var$mg = $23bcd42a245f9d7b$var$kg[--$23bcd42a245f9d7b$var$lg], $23bcd42a245f9d7b$var$kg[$23bcd42a245f9d7b$var$lg] = null, $23bcd42a245f9d7b$var$ng = $23bcd42a245f9d7b$var$kg[--$23bcd42a245f9d7b$var$lg], $23bcd42a245f9d7b$var$kg[$23bcd42a245f9d7b$var$lg] = null;
    for(; a === $23bcd42a245f9d7b$var$qg;)$23bcd42a245f9d7b$var$qg = $23bcd42a245f9d7b$var$og[--$23bcd42a245f9d7b$var$pg], $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg] = null, $23bcd42a245f9d7b$var$sg = $23bcd42a245f9d7b$var$og[--$23bcd42a245f9d7b$var$pg], $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg] = null, $23bcd42a245f9d7b$var$rg = $23bcd42a245f9d7b$var$og[--$23bcd42a245f9d7b$var$pg], $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg] = null;
}
var $23bcd42a245f9d7b$var$xg = null, $23bcd42a245f9d7b$var$yg = null, $23bcd42a245f9d7b$var$I = !1, $23bcd42a245f9d7b$var$zg = null;
function $23bcd42a245f9d7b$var$Ag(a, b) {
    var c = $23bcd42a245f9d7b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $23bcd42a245f9d7b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $23bcd42a245f9d7b$var$xg = a, $23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $23bcd42a245f9d7b$var$xg = a, $23bcd42a245f9d7b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $23bcd42a245f9d7b$var$qg ? {
                id: $23bcd42a245f9d7b$var$rg,
                overflow: $23bcd42a245f9d7b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $23bcd42a245f9d7b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $23bcd42a245f9d7b$var$xg = a, $23bcd42a245f9d7b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $23bcd42a245f9d7b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $23bcd42a245f9d7b$var$Eg(a) {
    if ($23bcd42a245f9d7b$var$I) {
        var b = $23bcd42a245f9d7b$var$yg;
        if (b) {
            var c = b;
            if (!$23bcd42a245f9d7b$var$Cg(a, b)) {
                if ($23bcd42a245f9d7b$var$Dg(a)) throw Error($23bcd42a245f9d7b$var$p(418));
                b = $23bcd42a245f9d7b$var$Lf(c.nextSibling);
                var d = $23bcd42a245f9d7b$var$xg;
                b && $23bcd42a245f9d7b$var$Cg(a, b) ? $23bcd42a245f9d7b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $23bcd42a245f9d7b$var$I = !1, $23bcd42a245f9d7b$var$xg = a);
            }
        } else {
            if ($23bcd42a245f9d7b$var$Dg(a)) throw Error($23bcd42a245f9d7b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $23bcd42a245f9d7b$var$I = !1;
            $23bcd42a245f9d7b$var$xg = a;
        }
    }
}
function $23bcd42a245f9d7b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $23bcd42a245f9d7b$var$xg = a;
}
function $23bcd42a245f9d7b$var$Gg(a) {
    if (a !== $23bcd42a245f9d7b$var$xg) return !1;
    if (!$23bcd42a245f9d7b$var$I) return $23bcd42a245f9d7b$var$Fg(a), $23bcd42a245f9d7b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$23bcd42a245f9d7b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $23bcd42a245f9d7b$var$yg)) {
        if ($23bcd42a245f9d7b$var$Dg(a)) throw $23bcd42a245f9d7b$var$Hg(), Error($23bcd42a245f9d7b$var$p(418));
        for(; b;)$23bcd42a245f9d7b$var$Ag(a, b), b = $23bcd42a245f9d7b$var$Lf(b.nextSibling);
    }
    $23bcd42a245f9d7b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($23bcd42a245f9d7b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $23bcd42a245f9d7b$var$yg = null;
        }
    } else $23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$xg ? $23bcd42a245f9d7b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $23bcd42a245f9d7b$var$Hg() {
    for(var a = $23bcd42a245f9d7b$var$yg; a;)a = $23bcd42a245f9d7b$var$Lf(a.nextSibling);
}
function $23bcd42a245f9d7b$var$Ig() {
    $23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$xg = null;
    $23bcd42a245f9d7b$var$I = !1;
}
function $23bcd42a245f9d7b$var$Jg(a) {
    null === $23bcd42a245f9d7b$var$zg ? $23bcd42a245f9d7b$var$zg = [
        a
    ] : $23bcd42a245f9d7b$var$zg.push(a);
}
var $23bcd42a245f9d7b$var$Kg = $23bcd42a245f9d7b$var$ua.ReactCurrentBatchConfig;
function $23bcd42a245f9d7b$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($23bcd42a245f9d7b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($23bcd42a245f9d7b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($23bcd42a245f9d7b$var$p(284));
        if (!c._owner) throw Error($23bcd42a245f9d7b$var$p(290, a));
    }
    return a;
}
function $23bcd42a245f9d7b$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($23bcd42a245f9d7b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $23bcd42a245f9d7b$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $23bcd42a245f9d7b$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $23bcd42a245f9d7b$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $23bcd42a245f9d7b$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $23bcd42a245f9d7b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $23bcd42a245f9d7b$var$Ha && $23bcd42a245f9d7b$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $23bcd42a245f9d7b$var$Lg(a, b, c), d.return = a, d;
        d = $23bcd42a245f9d7b$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $23bcd42a245f9d7b$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $23bcd42a245f9d7b$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $23bcd42a245f9d7b$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $23bcd42a245f9d7b$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $23bcd42a245f9d7b$var$va:
                    return c = $23bcd42a245f9d7b$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $23bcd42a245f9d7b$var$Lg(a, null, b), c.return = a, c;
                case $23bcd42a245f9d7b$var$wa:
                    return b = $23bcd42a245f9d7b$var$Sg(b, a.mode, c), b.return = a, b;
                case $23bcd42a245f9d7b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($23bcd42a245f9d7b$var$eb(b) || $23bcd42a245f9d7b$var$Ka(b)) return b = $23bcd42a245f9d7b$var$Tg(b, a.mode, c, null), b.return = a, b;
            $23bcd42a245f9d7b$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $23bcd42a245f9d7b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $23bcd42a245f9d7b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $23bcd42a245f9d7b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($23bcd42a245f9d7b$var$eb(c) || $23bcd42a245f9d7b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $23bcd42a245f9d7b$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $23bcd42a245f9d7b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $23bcd42a245f9d7b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $23bcd42a245f9d7b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($23bcd42a245f9d7b$var$eb(d) || $23bcd42a245f9d7b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $23bcd42a245f9d7b$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $23bcd42a245f9d7b$var$Ka(h);
        if ("function" !== typeof l) throw Error($23bcd42a245f9d7b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($23bcd42a245f9d7b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $23bcd42a245f9d7b$var$I && $23bcd42a245f9d7b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $23bcd42a245f9d7b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $23bcd42a245f9d7b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $23bcd42a245f9d7b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $23bcd42a245f9d7b$var$Ha && $23bcd42a245f9d7b$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $23bcd42a245f9d7b$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $23bcd42a245f9d7b$var$ya ? (d = $23bcd42a245f9d7b$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $23bcd42a245f9d7b$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $23bcd42a245f9d7b$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $23bcd42a245f9d7b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $23bcd42a245f9d7b$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $23bcd42a245f9d7b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($23bcd42a245f9d7b$var$eb(f)) return n(a, d, f, h);
            if ($23bcd42a245f9d7b$var$Ka(f)) return t(a, d, f, h);
            $23bcd42a245f9d7b$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $23bcd42a245f9d7b$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $23bcd42a245f9d7b$var$Ug = $23bcd42a245f9d7b$var$Og(!0), $23bcd42a245f9d7b$var$Vg = $23bcd42a245f9d7b$var$Og(!1), $23bcd42a245f9d7b$var$Wg = $23bcd42a245f9d7b$var$Uf(null), $23bcd42a245f9d7b$var$Xg = null, $23bcd42a245f9d7b$var$Yg = null, $23bcd42a245f9d7b$var$Zg = null;
function $23bcd42a245f9d7b$var$$g() {
    $23bcd42a245f9d7b$var$Zg = $23bcd42a245f9d7b$var$Yg = $23bcd42a245f9d7b$var$Xg = null;
}
function $23bcd42a245f9d7b$var$ah(a) {
    var b = $23bcd42a245f9d7b$var$Wg.current;
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wg);
    a._currentValue = b;
}
function $23bcd42a245f9d7b$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $23bcd42a245f9d7b$var$ch(a, b) {
    $23bcd42a245f9d7b$var$Xg = a;
    $23bcd42a245f9d7b$var$Zg = $23bcd42a245f9d7b$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($23bcd42a245f9d7b$var$dh = !0), a.firstContext = null);
}
function $23bcd42a245f9d7b$var$eh(a) {
    var b = a._currentValue;
    if ($23bcd42a245f9d7b$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $23bcd42a245f9d7b$var$Yg) {
            if (null === $23bcd42a245f9d7b$var$Xg) throw Error($23bcd42a245f9d7b$var$p(308));
            $23bcd42a245f9d7b$var$Yg = a;
            $23bcd42a245f9d7b$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $23bcd42a245f9d7b$var$Yg = $23bcd42a245f9d7b$var$Yg.next = a;
    }
    return b;
}
var $23bcd42a245f9d7b$var$fh = null;
function $23bcd42a245f9d7b$var$gh(a) {
    null === $23bcd42a245f9d7b$var$fh ? $23bcd42a245f9d7b$var$fh = [
        a
    ] : $23bcd42a245f9d7b$var$fh.push(a);
}
function $23bcd42a245f9d7b$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $23bcd42a245f9d7b$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $23bcd42a245f9d7b$var$ih(a, d);
}
function $23bcd42a245f9d7b$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $23bcd42a245f9d7b$var$jh = !1;
function $23bcd42a245f9d7b$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $23bcd42a245f9d7b$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $23bcd42a245f9d7b$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $23bcd42a245f9d7b$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($23bcd42a245f9d7b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $23bcd42a245f9d7b$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $23bcd42a245f9d7b$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $23bcd42a245f9d7b$var$ih(a, c);
}
function $23bcd42a245f9d7b$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $23bcd42a245f9d7b$var$Cc(a, c);
    }
}
function $23bcd42a245f9d7b$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $23bcd42a245f9d7b$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $23bcd42a245f9d7b$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $23bcd42a245f9d7b$var$A({}, q, r);
                            break a;
                        case 2:
                            $23bcd42a245f9d7b$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $23bcd42a245f9d7b$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $23bcd42a245f9d7b$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($23bcd42a245f9d7b$var$p(191, e));
            e.call(d);
        }
    }
}
var $23bcd42a245f9d7b$var$th = {}, $23bcd42a245f9d7b$var$uh = $23bcd42a245f9d7b$var$Uf($23bcd42a245f9d7b$var$th), $23bcd42a245f9d7b$var$vh = $23bcd42a245f9d7b$var$Uf($23bcd42a245f9d7b$var$th), $23bcd42a245f9d7b$var$wh = $23bcd42a245f9d7b$var$Uf($23bcd42a245f9d7b$var$th);
function $23bcd42a245f9d7b$var$xh(a) {
    if (a === $23bcd42a245f9d7b$var$th) throw Error($23bcd42a245f9d7b$var$p(174));
    return a;
}
function $23bcd42a245f9d7b$var$yh(a, b) {
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$wh, b);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$vh, a);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$uh, $23bcd42a245f9d7b$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $23bcd42a245f9d7b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $23bcd42a245f9d7b$var$lb(b, a);
    }
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$uh);
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$uh, b);
}
function $23bcd42a245f9d7b$var$zh() {
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$uh);
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$vh);
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$wh);
}
function $23bcd42a245f9d7b$var$Ah(a) {
    $23bcd42a245f9d7b$var$xh($23bcd42a245f9d7b$var$wh.current);
    var b = $23bcd42a245f9d7b$var$xh($23bcd42a245f9d7b$var$uh.current);
    var c = $23bcd42a245f9d7b$var$lb(b, a.type);
    b !== c && ($23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$vh, a), $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$uh, c));
}
function $23bcd42a245f9d7b$var$Bh(a) {
    $23bcd42a245f9d7b$var$vh.current === a && ($23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$uh), $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$vh));
}
var $23bcd42a245f9d7b$var$L = $23bcd42a245f9d7b$var$Uf(0);
function $23bcd42a245f9d7b$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $23bcd42a245f9d7b$var$Dh = [];
function $23bcd42a245f9d7b$var$Eh() {
    for(var a = 0; a < $23bcd42a245f9d7b$var$Dh.length; a++)$23bcd42a245f9d7b$var$Dh[a]._workInProgressVersionPrimary = null;
    $23bcd42a245f9d7b$var$Dh.length = 0;
}
var $23bcd42a245f9d7b$var$Fh = $23bcd42a245f9d7b$var$ua.ReactCurrentDispatcher, $23bcd42a245f9d7b$var$Gh = $23bcd42a245f9d7b$var$ua.ReactCurrentBatchConfig, $23bcd42a245f9d7b$var$Hh = 0, $23bcd42a245f9d7b$var$M = null, $23bcd42a245f9d7b$var$N = null, $23bcd42a245f9d7b$var$O = null, $23bcd42a245f9d7b$var$Ih = !1, $23bcd42a245f9d7b$var$Jh = !1, $23bcd42a245f9d7b$var$Kh = 0, $23bcd42a245f9d7b$var$Lh = 0;
function $23bcd42a245f9d7b$var$P() {
    throw Error($23bcd42a245f9d7b$var$p(321));
}
function $23bcd42a245f9d7b$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$23bcd42a245f9d7b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $23bcd42a245f9d7b$var$Nh(a, b, c, d, e, f) {
    $23bcd42a245f9d7b$var$Hh = f;
    $23bcd42a245f9d7b$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $23bcd42a245f9d7b$var$Fh.current = null === a || null === a.memoizedState ? $23bcd42a245f9d7b$var$Oh : $23bcd42a245f9d7b$var$Ph;
    a = c(d, e);
    if ($23bcd42a245f9d7b$var$Jh) {
        f = 0;
        do {
            $23bcd42a245f9d7b$var$Jh = !1;
            $23bcd42a245f9d7b$var$Kh = 0;
            if (25 <= f) throw Error($23bcd42a245f9d7b$var$p(301));
            f += 1;
            $23bcd42a245f9d7b$var$O = $23bcd42a245f9d7b$var$N = null;
            b.updateQueue = null;
            $23bcd42a245f9d7b$var$Fh.current = $23bcd42a245f9d7b$var$Qh;
            a = c(d, e);
        }while ($23bcd42a245f9d7b$var$Jh);
    }
    $23bcd42a245f9d7b$var$Fh.current = $23bcd42a245f9d7b$var$Rh;
    b = null !== $23bcd42a245f9d7b$var$N && null !== $23bcd42a245f9d7b$var$N.next;
    $23bcd42a245f9d7b$var$Hh = 0;
    $23bcd42a245f9d7b$var$O = $23bcd42a245f9d7b$var$N = $23bcd42a245f9d7b$var$M = null;
    $23bcd42a245f9d7b$var$Ih = !1;
    if (b) throw Error($23bcd42a245f9d7b$var$p(300));
    return a;
}
function $23bcd42a245f9d7b$var$Sh() {
    var a = 0 !== $23bcd42a245f9d7b$var$Kh;
    $23bcd42a245f9d7b$var$Kh = 0;
    return a;
}
function $23bcd42a245f9d7b$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $23bcd42a245f9d7b$var$O ? $23bcd42a245f9d7b$var$M.memoizedState = $23bcd42a245f9d7b$var$O = a : $23bcd42a245f9d7b$var$O = $23bcd42a245f9d7b$var$O.next = a;
    return $23bcd42a245f9d7b$var$O;
}
function $23bcd42a245f9d7b$var$Uh() {
    if (null === $23bcd42a245f9d7b$var$N) {
        var a = $23bcd42a245f9d7b$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $23bcd42a245f9d7b$var$N.next;
    var b = null === $23bcd42a245f9d7b$var$O ? $23bcd42a245f9d7b$var$M.memoizedState : $23bcd42a245f9d7b$var$O.next;
    if (null !== b) $23bcd42a245f9d7b$var$O = b, $23bcd42a245f9d7b$var$N = a;
    else {
        if (null === a) throw Error($23bcd42a245f9d7b$var$p(310));
        $23bcd42a245f9d7b$var$N = a;
        a = {
            memoizedState: $23bcd42a245f9d7b$var$N.memoizedState,
            baseState: $23bcd42a245f9d7b$var$N.baseState,
            baseQueue: $23bcd42a245f9d7b$var$N.baseQueue,
            queue: $23bcd42a245f9d7b$var$N.queue,
            next: null
        };
        null === $23bcd42a245f9d7b$var$O ? $23bcd42a245f9d7b$var$M.memoizedState = $23bcd42a245f9d7b$var$O = a : $23bcd42a245f9d7b$var$O = $23bcd42a245f9d7b$var$O.next = a;
    }
    return $23bcd42a245f9d7b$var$O;
}
function $23bcd42a245f9d7b$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $23bcd42a245f9d7b$var$Wh(a) {
    var b = $23bcd42a245f9d7b$var$Uh(), c = b.queue;
    if (null === c) throw Error($23bcd42a245f9d7b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $23bcd42a245f9d7b$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($23bcd42a245f9d7b$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $23bcd42a245f9d7b$var$M.lanes |= m;
                $23bcd42a245f9d7b$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $23bcd42a245f9d7b$var$He(d, b.memoizedState) || ($23bcd42a245f9d7b$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $23bcd42a245f9d7b$var$M.lanes |= f, $23bcd42a245f9d7b$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $23bcd42a245f9d7b$var$Xh(a) {
    var b = $23bcd42a245f9d7b$var$Uh(), c = b.queue;
    if (null === c) throw Error($23bcd42a245f9d7b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $23bcd42a245f9d7b$var$He(f, b.memoizedState) || ($23bcd42a245f9d7b$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $23bcd42a245f9d7b$var$Yh() {}
function $23bcd42a245f9d7b$var$Zh(a, b) {
    var c = $23bcd42a245f9d7b$var$M, d = $23bcd42a245f9d7b$var$Uh(), e = b(), f = !$23bcd42a245f9d7b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $23bcd42a245f9d7b$var$dh = !0);
    d = d.queue;
    $23bcd42a245f9d7b$var$$h($23bcd42a245f9d7b$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $23bcd42a245f9d7b$var$O && $23bcd42a245f9d7b$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $23bcd42a245f9d7b$var$bi(9, $23bcd42a245f9d7b$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $23bcd42a245f9d7b$var$Q) throw Error($23bcd42a245f9d7b$var$p(349));
        0 !== ($23bcd42a245f9d7b$var$Hh & 30) || $23bcd42a245f9d7b$var$di(c, b, e);
    }
    return e;
}
function $23bcd42a245f9d7b$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $23bcd42a245f9d7b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $23bcd42a245f9d7b$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $23bcd42a245f9d7b$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $23bcd42a245f9d7b$var$ei(b) && $23bcd42a245f9d7b$var$fi(a);
}
function $23bcd42a245f9d7b$var$ai(a, b, c) {
    return c(function() {
        $23bcd42a245f9d7b$var$ei(b) && $23bcd42a245f9d7b$var$fi(a);
    });
}
function $23bcd42a245f9d7b$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$23bcd42a245f9d7b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $23bcd42a245f9d7b$var$fi(a) {
    var b = $23bcd42a245f9d7b$var$ih(a, 1);
    null !== b && $23bcd42a245f9d7b$var$gi(b, a, 1, -1);
}
function $23bcd42a245f9d7b$var$hi(a) {
    var b = $23bcd42a245f9d7b$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $23bcd42a245f9d7b$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $23bcd42a245f9d7b$var$ii.bind(null, $23bcd42a245f9d7b$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $23bcd42a245f9d7b$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $23bcd42a245f9d7b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $23bcd42a245f9d7b$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $23bcd42a245f9d7b$var$ji() {
    return $23bcd42a245f9d7b$var$Uh().memoizedState;
}
function $23bcd42a245f9d7b$var$ki(a, b, c, d) {
    var e = $23bcd42a245f9d7b$var$Th();
    $23bcd42a245f9d7b$var$M.flags |= a;
    e.memoizedState = $23bcd42a245f9d7b$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $23bcd42a245f9d7b$var$li(a, b, c, d) {
    var e = $23bcd42a245f9d7b$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $23bcd42a245f9d7b$var$N) {
        var g = $23bcd42a245f9d7b$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $23bcd42a245f9d7b$var$Mh(d, g.deps)) {
            e.memoizedState = $23bcd42a245f9d7b$var$bi(b, c, f, d);
            return;
        }
    }
    $23bcd42a245f9d7b$var$M.flags |= a;
    e.memoizedState = $23bcd42a245f9d7b$var$bi(1 | b, c, f, d);
}
function $23bcd42a245f9d7b$var$mi(a, b) {
    return $23bcd42a245f9d7b$var$ki(8390656, 8, a, b);
}
function $23bcd42a245f9d7b$var$$h(a, b) {
    return $23bcd42a245f9d7b$var$li(2048, 8, a, b);
}
function $23bcd42a245f9d7b$var$ni(a, b) {
    return $23bcd42a245f9d7b$var$li(4, 2, a, b);
}
function $23bcd42a245f9d7b$var$oi(a, b) {
    return $23bcd42a245f9d7b$var$li(4, 4, a, b);
}
function $23bcd42a245f9d7b$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $23bcd42a245f9d7b$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $23bcd42a245f9d7b$var$li(4, 4, $23bcd42a245f9d7b$var$pi.bind(null, b, a), c);
}
function $23bcd42a245f9d7b$var$ri() {}
function $23bcd42a245f9d7b$var$si(a, b) {
    var c = $23bcd42a245f9d7b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $23bcd42a245f9d7b$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $23bcd42a245f9d7b$var$ti(a, b) {
    var c = $23bcd42a245f9d7b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $23bcd42a245f9d7b$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $23bcd42a245f9d7b$var$ui(a, b, c) {
    if (0 === ($23bcd42a245f9d7b$var$Hh & 21)) return a.baseState && (a.baseState = !1, $23bcd42a245f9d7b$var$dh = !0), a.memoizedState = c;
    $23bcd42a245f9d7b$var$He(c, b) || (c = $23bcd42a245f9d7b$var$yc(), $23bcd42a245f9d7b$var$M.lanes |= c, $23bcd42a245f9d7b$var$rh |= c, a.baseState = !0);
    return b;
}
function $23bcd42a245f9d7b$var$vi(a, b) {
    var c = $23bcd42a245f9d7b$var$C;
    $23bcd42a245f9d7b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $23bcd42a245f9d7b$var$Gh.transition;
    $23bcd42a245f9d7b$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $23bcd42a245f9d7b$var$C = c, $23bcd42a245f9d7b$var$Gh.transition = d;
    }
}
function $23bcd42a245f9d7b$var$wi() {
    return $23bcd42a245f9d7b$var$Uh().memoizedState;
}
function $23bcd42a245f9d7b$var$xi(a, b, c) {
    var d = $23bcd42a245f9d7b$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($23bcd42a245f9d7b$var$zi(a)) $23bcd42a245f9d7b$var$Ai(b, c);
    else if (c = $23bcd42a245f9d7b$var$hh(a, b, c, d), null !== c) {
        var e = $23bcd42a245f9d7b$var$R();
        $23bcd42a245f9d7b$var$gi(c, a, d, e);
        $23bcd42a245f9d7b$var$Bi(c, b, d);
    }
}
function $23bcd42a245f9d7b$var$ii(a, b, c) {
    var d = $23bcd42a245f9d7b$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($23bcd42a245f9d7b$var$zi(a)) $23bcd42a245f9d7b$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($23bcd42a245f9d7b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $23bcd42a245f9d7b$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $23bcd42a245f9d7b$var$hh(a, b, e, d);
        null !== c && (e = $23bcd42a245f9d7b$var$R(), $23bcd42a245f9d7b$var$gi(c, a, d, e), $23bcd42a245f9d7b$var$Bi(c, b, d));
    }
}
function $23bcd42a245f9d7b$var$zi(a) {
    var b = a.alternate;
    return a === $23bcd42a245f9d7b$var$M || null !== b && b === $23bcd42a245f9d7b$var$M;
}
function $23bcd42a245f9d7b$var$Ai(a, b) {
    $23bcd42a245f9d7b$var$Jh = $23bcd42a245f9d7b$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $23bcd42a245f9d7b$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $23bcd42a245f9d7b$var$Cc(a, c);
    }
}
var $23bcd42a245f9d7b$var$Rh = {
    readContext: $23bcd42a245f9d7b$var$eh,
    useCallback: $23bcd42a245f9d7b$var$P,
    useContext: $23bcd42a245f9d7b$var$P,
    useEffect: $23bcd42a245f9d7b$var$P,
    useImperativeHandle: $23bcd42a245f9d7b$var$P,
    useInsertionEffect: $23bcd42a245f9d7b$var$P,
    useLayoutEffect: $23bcd42a245f9d7b$var$P,
    useMemo: $23bcd42a245f9d7b$var$P,
    useReducer: $23bcd42a245f9d7b$var$P,
    useRef: $23bcd42a245f9d7b$var$P,
    useState: $23bcd42a245f9d7b$var$P,
    useDebugValue: $23bcd42a245f9d7b$var$P,
    useDeferredValue: $23bcd42a245f9d7b$var$P,
    useTransition: $23bcd42a245f9d7b$var$P,
    useMutableSource: $23bcd42a245f9d7b$var$P,
    useSyncExternalStore: $23bcd42a245f9d7b$var$P,
    useId: $23bcd42a245f9d7b$var$P,
    unstable_isNewReconciler: !1
}, $23bcd42a245f9d7b$var$Oh = {
    readContext: $23bcd42a245f9d7b$var$eh,
    useCallback: function(a, b) {
        $23bcd42a245f9d7b$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $23bcd42a245f9d7b$var$eh,
    useEffect: $23bcd42a245f9d7b$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $23bcd42a245f9d7b$var$ki(4194308, 4, $23bcd42a245f9d7b$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $23bcd42a245f9d7b$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $23bcd42a245f9d7b$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $23bcd42a245f9d7b$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $23bcd42a245f9d7b$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $23bcd42a245f9d7b$var$xi.bind(null, $23bcd42a245f9d7b$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $23bcd42a245f9d7b$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $23bcd42a245f9d7b$var$hi,
    useDebugValue: $23bcd42a245f9d7b$var$ri,
    useDeferredValue: function(a) {
        return $23bcd42a245f9d7b$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $23bcd42a245f9d7b$var$hi(!1), b = a[0];
        a = $23bcd42a245f9d7b$var$vi.bind(null, a[1]);
        $23bcd42a245f9d7b$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $23bcd42a245f9d7b$var$M, e = $23bcd42a245f9d7b$var$Th();
        if ($23bcd42a245f9d7b$var$I) {
            if (void 0 === c) throw Error($23bcd42a245f9d7b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $23bcd42a245f9d7b$var$Q) throw Error($23bcd42a245f9d7b$var$p(349));
            0 !== ($23bcd42a245f9d7b$var$Hh & 30) || $23bcd42a245f9d7b$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $23bcd42a245f9d7b$var$mi($23bcd42a245f9d7b$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $23bcd42a245f9d7b$var$bi(9, $23bcd42a245f9d7b$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $23bcd42a245f9d7b$var$Th(), b = $23bcd42a245f9d7b$var$Q.identifierPrefix;
        if ($23bcd42a245f9d7b$var$I) {
            var c = $23bcd42a245f9d7b$var$sg;
            var d = $23bcd42a245f9d7b$var$rg;
            c = (d & ~(1 << 32 - $23bcd42a245f9d7b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $23bcd42a245f9d7b$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $23bcd42a245f9d7b$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $23bcd42a245f9d7b$var$Ph = {
    readContext: $23bcd42a245f9d7b$var$eh,
    useCallback: $23bcd42a245f9d7b$var$si,
    useContext: $23bcd42a245f9d7b$var$eh,
    useEffect: $23bcd42a245f9d7b$var$$h,
    useImperativeHandle: $23bcd42a245f9d7b$var$qi,
    useInsertionEffect: $23bcd42a245f9d7b$var$ni,
    useLayoutEffect: $23bcd42a245f9d7b$var$oi,
    useMemo: $23bcd42a245f9d7b$var$ti,
    useReducer: $23bcd42a245f9d7b$var$Wh,
    useRef: $23bcd42a245f9d7b$var$ji,
    useState: function() {
        return $23bcd42a245f9d7b$var$Wh($23bcd42a245f9d7b$var$Vh);
    },
    useDebugValue: $23bcd42a245f9d7b$var$ri,
    useDeferredValue: function(a) {
        var b = $23bcd42a245f9d7b$var$Uh();
        return $23bcd42a245f9d7b$var$ui(b, $23bcd42a245f9d7b$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $23bcd42a245f9d7b$var$Wh($23bcd42a245f9d7b$var$Vh)[0], b = $23bcd42a245f9d7b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $23bcd42a245f9d7b$var$Yh,
    useSyncExternalStore: $23bcd42a245f9d7b$var$Zh,
    useId: $23bcd42a245f9d7b$var$wi,
    unstable_isNewReconciler: !1
}, $23bcd42a245f9d7b$var$Qh = {
    readContext: $23bcd42a245f9d7b$var$eh,
    useCallback: $23bcd42a245f9d7b$var$si,
    useContext: $23bcd42a245f9d7b$var$eh,
    useEffect: $23bcd42a245f9d7b$var$$h,
    useImperativeHandle: $23bcd42a245f9d7b$var$qi,
    useInsertionEffect: $23bcd42a245f9d7b$var$ni,
    useLayoutEffect: $23bcd42a245f9d7b$var$oi,
    useMemo: $23bcd42a245f9d7b$var$ti,
    useReducer: $23bcd42a245f9d7b$var$Xh,
    useRef: $23bcd42a245f9d7b$var$ji,
    useState: function() {
        return $23bcd42a245f9d7b$var$Xh($23bcd42a245f9d7b$var$Vh);
    },
    useDebugValue: $23bcd42a245f9d7b$var$ri,
    useDeferredValue: function(a) {
        var b = $23bcd42a245f9d7b$var$Uh();
        return null === $23bcd42a245f9d7b$var$N ? b.memoizedState = a : $23bcd42a245f9d7b$var$ui(b, $23bcd42a245f9d7b$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $23bcd42a245f9d7b$var$Xh($23bcd42a245f9d7b$var$Vh)[0], b = $23bcd42a245f9d7b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $23bcd42a245f9d7b$var$Yh,
    useSyncExternalStore: $23bcd42a245f9d7b$var$Zh,
    useId: $23bcd42a245f9d7b$var$wi,
    unstable_isNewReconciler: !1
};
function $23bcd42a245f9d7b$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $23bcd42a245f9d7b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $23bcd42a245f9d7b$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $23bcd42a245f9d7b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $23bcd42a245f9d7b$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $23bcd42a245f9d7b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $23bcd42a245f9d7b$var$R(), e = $23bcd42a245f9d7b$var$yi(a), f = $23bcd42a245f9d7b$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $23bcd42a245f9d7b$var$nh(a, f, e);
        null !== b && ($23bcd42a245f9d7b$var$gi(b, a, e, d), $23bcd42a245f9d7b$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $23bcd42a245f9d7b$var$R(), e = $23bcd42a245f9d7b$var$yi(a), f = $23bcd42a245f9d7b$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $23bcd42a245f9d7b$var$nh(a, f, e);
        null !== b && ($23bcd42a245f9d7b$var$gi(b, a, e, d), $23bcd42a245f9d7b$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $23bcd42a245f9d7b$var$R(), d = $23bcd42a245f9d7b$var$yi(a), e = $23bcd42a245f9d7b$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $23bcd42a245f9d7b$var$nh(a, e, d);
        null !== b && ($23bcd42a245f9d7b$var$gi(b, a, d, c), $23bcd42a245f9d7b$var$oh(b, a, d));
    }
};
function $23bcd42a245f9d7b$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$23bcd42a245f9d7b$var$Ie(c, d) || !$23bcd42a245f9d7b$var$Ie(e, f) : !0;
}
function $23bcd42a245f9d7b$var$Gi(a, b, c) {
    var d = !1, e = $23bcd42a245f9d7b$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $23bcd42a245f9d7b$var$eh(f) : (e = $23bcd42a245f9d7b$var$Zf(b) ? $23bcd42a245f9d7b$var$Xf : $23bcd42a245f9d7b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $23bcd42a245f9d7b$var$Yf(a, e) : $23bcd42a245f9d7b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $23bcd42a245f9d7b$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $23bcd42a245f9d7b$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $23bcd42a245f9d7b$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $23bcd42a245f9d7b$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $23bcd42a245f9d7b$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $23bcd42a245f9d7b$var$eh(f) : (f = $23bcd42a245f9d7b$var$Zf(b) ? $23bcd42a245f9d7b$var$Xf : $23bcd42a245f9d7b$var$H.current, e.context = $23bcd42a245f9d7b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($23bcd42a245f9d7b$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $23bcd42a245f9d7b$var$Ei.enqueueReplaceState(e, e.state, null), $23bcd42a245f9d7b$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $23bcd42a245f9d7b$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $23bcd42a245f9d7b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $23bcd42a245f9d7b$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $23bcd42a245f9d7b$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $23bcd42a245f9d7b$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $23bcd42a245f9d7b$var$Ni(a, b, c) {
    c = $23bcd42a245f9d7b$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $23bcd42a245f9d7b$var$Oi || ($23bcd42a245f9d7b$var$Oi = !0, $23bcd42a245f9d7b$var$Pi = d);
        $23bcd42a245f9d7b$var$Li(a, b);
    };
    return c;
}
function $23bcd42a245f9d7b$var$Qi(a, b, c) {
    c = $23bcd42a245f9d7b$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $23bcd42a245f9d7b$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $23bcd42a245f9d7b$var$Li(a, b);
        "function" !== typeof d && (null === $23bcd42a245f9d7b$var$Ri ? $23bcd42a245f9d7b$var$Ri = new Set([
            this
        ]) : $23bcd42a245f9d7b$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $23bcd42a245f9d7b$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $23bcd42a245f9d7b$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $23bcd42a245f9d7b$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $23bcd42a245f9d7b$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $23bcd42a245f9d7b$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $23bcd42a245f9d7b$var$mh(-1, 1), b.tag = 2, $23bcd42a245f9d7b$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $23bcd42a245f9d7b$var$Wi = $23bcd42a245f9d7b$var$ua.ReactCurrentOwner, $23bcd42a245f9d7b$var$dh = !1;
function $23bcd42a245f9d7b$var$Xi(a, b, c, d) {
    b.child = null === a ? $23bcd42a245f9d7b$var$Vg(b, null, c, d) : $23bcd42a245f9d7b$var$Ug(b, a.child, c, d);
}
function $23bcd42a245f9d7b$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $23bcd42a245f9d7b$var$ch(b, e);
    d = $23bcd42a245f9d7b$var$Nh(a, b, c, d, f, e);
    c = $23bcd42a245f9d7b$var$Sh();
    if (null !== a && !$23bcd42a245f9d7b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $23bcd42a245f9d7b$var$Zi(a, b, e);
    $23bcd42a245f9d7b$var$I && c && $23bcd42a245f9d7b$var$vg(b);
    b.flags |= 1;
    $23bcd42a245f9d7b$var$Xi(a, b, d, e);
    return b.child;
}
function $23bcd42a245f9d7b$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$23bcd42a245f9d7b$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $23bcd42a245f9d7b$var$bj(a, b, f, d, e);
        a = $23bcd42a245f9d7b$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $23bcd42a245f9d7b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $23bcd42a245f9d7b$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $23bcd42a245f9d7b$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $23bcd42a245f9d7b$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($23bcd42a245f9d7b$var$Ie(f, d) && a.ref === b.ref) {
            if ($23bcd42a245f9d7b$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($23bcd42a245f9d7b$var$dh = !0);
            else return b.lanes = a.lanes, $23bcd42a245f9d7b$var$Zi(a, b, e);
        }
    }
    return $23bcd42a245f9d7b$var$cj(a, b, c, d, e);
}
function $23bcd42a245f9d7b$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$ej, $23bcd42a245f9d7b$var$fj), $23bcd42a245f9d7b$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$ej, $23bcd42a245f9d7b$var$fj), $23bcd42a245f9d7b$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$ej, $23bcd42a245f9d7b$var$fj);
            $23bcd42a245f9d7b$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$ej, $23bcd42a245f9d7b$var$fj), $23bcd42a245f9d7b$var$fj |= d;
    $23bcd42a245f9d7b$var$Xi(a, b, e, c);
    return b.child;
}
function $23bcd42a245f9d7b$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $23bcd42a245f9d7b$var$cj(a, b, c, d, e) {
    var f = $23bcd42a245f9d7b$var$Zf(c) ? $23bcd42a245f9d7b$var$Xf : $23bcd42a245f9d7b$var$H.current;
    f = $23bcd42a245f9d7b$var$Yf(b, f);
    $23bcd42a245f9d7b$var$ch(b, e);
    c = $23bcd42a245f9d7b$var$Nh(a, b, c, d, f, e);
    d = $23bcd42a245f9d7b$var$Sh();
    if (null !== a && !$23bcd42a245f9d7b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $23bcd42a245f9d7b$var$Zi(a, b, e);
    $23bcd42a245f9d7b$var$I && d && $23bcd42a245f9d7b$var$vg(b);
    b.flags |= 1;
    $23bcd42a245f9d7b$var$Xi(a, b, c, e);
    return b.child;
}
function $23bcd42a245f9d7b$var$hj(a, b, c, d, e) {
    if ($23bcd42a245f9d7b$var$Zf(c)) {
        var f = !0;
        $23bcd42a245f9d7b$var$cg(b);
    } else f = !1;
    $23bcd42a245f9d7b$var$ch(b, e);
    if (null === b.stateNode) $23bcd42a245f9d7b$var$ij(a, b), $23bcd42a245f9d7b$var$Gi(b, c, d), $23bcd42a245f9d7b$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $23bcd42a245f9d7b$var$eh(l) : (l = $23bcd42a245f9d7b$var$Zf(c) ? $23bcd42a245f9d7b$var$Xf : $23bcd42a245f9d7b$var$H.current, l = $23bcd42a245f9d7b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $23bcd42a245f9d7b$var$Hi(b, g, d, l);
        $23bcd42a245f9d7b$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $23bcd42a245f9d7b$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $23bcd42a245f9d7b$var$Wf.current || $23bcd42a245f9d7b$var$jh ? ("function" === typeof m && ($23bcd42a245f9d7b$var$Di(b, c, m, d), k = b.memoizedState), (h = $23bcd42a245f9d7b$var$jh || $23bcd42a245f9d7b$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $23bcd42a245f9d7b$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $23bcd42a245f9d7b$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $23bcd42a245f9d7b$var$eh(k) : (k = $23bcd42a245f9d7b$var$Zf(c) ? $23bcd42a245f9d7b$var$Xf : $23bcd42a245f9d7b$var$H.current, k = $23bcd42a245f9d7b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $23bcd42a245f9d7b$var$Hi(b, g, d, k);
        $23bcd42a245f9d7b$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $23bcd42a245f9d7b$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $23bcd42a245f9d7b$var$Wf.current || $23bcd42a245f9d7b$var$jh ? ("function" === typeof y && ($23bcd42a245f9d7b$var$Di(b, c, y, d), n = b.memoizedState), (l = $23bcd42a245f9d7b$var$jh || $23bcd42a245f9d7b$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $23bcd42a245f9d7b$var$jj(a, b, c, d, f, e);
}
function $23bcd42a245f9d7b$var$jj(a, b, c, d, e, f) {
    $23bcd42a245f9d7b$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $23bcd42a245f9d7b$var$dg(b, c, !1), $23bcd42a245f9d7b$var$Zi(a, b, f);
    d = b.stateNode;
    $23bcd42a245f9d7b$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $23bcd42a245f9d7b$var$Ug(b, a.child, null, f), b.child = $23bcd42a245f9d7b$var$Ug(b, null, h, f)) : $23bcd42a245f9d7b$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $23bcd42a245f9d7b$var$dg(b, c, !0);
    return b.child;
}
function $23bcd42a245f9d7b$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $23bcd42a245f9d7b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $23bcd42a245f9d7b$var$ag(a, b.context, !1);
    $23bcd42a245f9d7b$var$yh(a, b.containerInfo);
}
function $23bcd42a245f9d7b$var$lj(a, b, c, d, e) {
    $23bcd42a245f9d7b$var$Ig();
    $23bcd42a245f9d7b$var$Jg(e);
    b.flags |= 256;
    $23bcd42a245f9d7b$var$Xi(a, b, c, d);
    return b.child;
}
var $23bcd42a245f9d7b$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $23bcd42a245f9d7b$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $23bcd42a245f9d7b$var$oj(a, b, c) {
    var d = b.pendingProps, e = $23bcd42a245f9d7b$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$L, e & 1);
    if (null === a) {
        $23bcd42a245f9d7b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $23bcd42a245f9d7b$var$pj(g, d, 0, null), a = $23bcd42a245f9d7b$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $23bcd42a245f9d7b$var$nj(c), b.memoizedState = $23bcd42a245f9d7b$var$mj, a) : $23bcd42a245f9d7b$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $23bcd42a245f9d7b$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $23bcd42a245f9d7b$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $23bcd42a245f9d7b$var$Pg(h, f) : (f = $23bcd42a245f9d7b$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $23bcd42a245f9d7b$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $23bcd42a245f9d7b$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $23bcd42a245f9d7b$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $23bcd42a245f9d7b$var$qj(a, b) {
    b = $23bcd42a245f9d7b$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $23bcd42a245f9d7b$var$sj(a, b, c, d) {
    null !== d && $23bcd42a245f9d7b$var$Jg(d);
    $23bcd42a245f9d7b$var$Ug(b, a.child, null, c);
    a = $23bcd42a245f9d7b$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $23bcd42a245f9d7b$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $23bcd42a245f9d7b$var$Ki(Error($23bcd42a245f9d7b$var$p(422))), $23bcd42a245f9d7b$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $23bcd42a245f9d7b$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $23bcd42a245f9d7b$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $23bcd42a245f9d7b$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $23bcd42a245f9d7b$var$nj(g);
        b.memoizedState = $23bcd42a245f9d7b$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $23bcd42a245f9d7b$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($23bcd42a245f9d7b$var$p(419));
        d = $23bcd42a245f9d7b$var$Ki(f, d, void 0);
        return $23bcd42a245f9d7b$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($23bcd42a245f9d7b$var$dh || h) {
        d = $23bcd42a245f9d7b$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $23bcd42a245f9d7b$var$ih(a, e), $23bcd42a245f9d7b$var$gi(d, a, e, -1));
        }
        $23bcd42a245f9d7b$var$tj();
        d = $23bcd42a245f9d7b$var$Ki(Error($23bcd42a245f9d7b$var$p(421)));
        return $23bcd42a245f9d7b$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $23bcd42a245f9d7b$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$Lf(e.nextSibling);
    $23bcd42a245f9d7b$var$xg = b;
    $23bcd42a245f9d7b$var$I = !0;
    $23bcd42a245f9d7b$var$zg = null;
    null !== a && ($23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$rg, $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$sg, $23bcd42a245f9d7b$var$og[$23bcd42a245f9d7b$var$pg++] = $23bcd42a245f9d7b$var$qg, $23bcd42a245f9d7b$var$rg = a.id, $23bcd42a245f9d7b$var$sg = a.overflow, $23bcd42a245f9d7b$var$qg = b);
    b = $23bcd42a245f9d7b$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $23bcd42a245f9d7b$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $23bcd42a245f9d7b$var$bh(a.return, b, c);
}
function $23bcd42a245f9d7b$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $23bcd42a245f9d7b$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $23bcd42a245f9d7b$var$Xi(a, b, d.children, c);
    d = $23bcd42a245f9d7b$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $23bcd42a245f9d7b$var$vj(a, c, b);
            else if (19 === a.tag) $23bcd42a245f9d7b$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $23bcd42a245f9d7b$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $23bcd42a245f9d7b$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $23bcd42a245f9d7b$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $23bcd42a245f9d7b$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $23bcd42a245f9d7b$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $23bcd42a245f9d7b$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $23bcd42a245f9d7b$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $23bcd42a245f9d7b$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($23bcd42a245f9d7b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $23bcd42a245f9d7b$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $23bcd42a245f9d7b$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $23bcd42a245f9d7b$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $23bcd42a245f9d7b$var$kj(b);
            $23bcd42a245f9d7b$var$Ig();
            break;
        case 5:
            $23bcd42a245f9d7b$var$Ah(b);
            break;
        case 1:
            $23bcd42a245f9d7b$var$Zf(b.type) && $23bcd42a245f9d7b$var$cg(b);
            break;
        case 4:
            $23bcd42a245f9d7b$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$L, $23bcd42a245f9d7b$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $23bcd42a245f9d7b$var$oj(a, b, c);
                $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$L, $23bcd42a245f9d7b$var$L.current & 1);
                a = $23bcd42a245f9d7b$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$L, $23bcd42a245f9d7b$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $23bcd42a245f9d7b$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$L, $23bcd42a245f9d7b$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $23bcd42a245f9d7b$var$dj(a, b, c);
    }
    return $23bcd42a245f9d7b$var$Zi(a, b, c);
}
var $23bcd42a245f9d7b$var$zj, $23bcd42a245f9d7b$var$Aj, $23bcd42a245f9d7b$var$Bj, $23bcd42a245f9d7b$var$Cj;
$23bcd42a245f9d7b$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$23bcd42a245f9d7b$var$Aj = function() {};
$23bcd42a245f9d7b$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $23bcd42a245f9d7b$var$xh($23bcd42a245f9d7b$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $23bcd42a245f9d7b$var$Ya(a, e);
                d = $23bcd42a245f9d7b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $23bcd42a245f9d7b$var$A({}, e, {
                    value: void 0
                });
                d = $23bcd42a245f9d7b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $23bcd42a245f9d7b$var$gb(a, e);
                d = $23bcd42a245f9d7b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $23bcd42a245f9d7b$var$Bf);
        }
        $23bcd42a245f9d7b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($23bcd42a245f9d7b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($23bcd42a245f9d7b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $23bcd42a245f9d7b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$23bcd42a245f9d7b$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $23bcd42a245f9d7b$var$Dj(a, b) {
    if (!$23bcd42a245f9d7b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $23bcd42a245f9d7b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $23bcd42a245f9d7b$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $23bcd42a245f9d7b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $23bcd42a245f9d7b$var$S(b), null;
        case 1:
            return $23bcd42a245f9d7b$var$Zf(b.type) && $23bcd42a245f9d7b$var$$f(), $23bcd42a245f9d7b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $23bcd42a245f9d7b$var$zh();
            $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf);
            $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$H);
            $23bcd42a245f9d7b$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $23bcd42a245f9d7b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $23bcd42a245f9d7b$var$zg && ($23bcd42a245f9d7b$var$Fj($23bcd42a245f9d7b$var$zg), $23bcd42a245f9d7b$var$zg = null));
            $23bcd42a245f9d7b$var$Aj(a, b);
            $23bcd42a245f9d7b$var$S(b);
            return null;
        case 5:
            $23bcd42a245f9d7b$var$Bh(b);
            var e = $23bcd42a245f9d7b$var$xh($23bcd42a245f9d7b$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $23bcd42a245f9d7b$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($23bcd42a245f9d7b$var$p(166));
                    $23bcd42a245f9d7b$var$S(b);
                    return null;
                }
                a = $23bcd42a245f9d7b$var$xh($23bcd42a245f9d7b$var$uh.current);
                if ($23bcd42a245f9d7b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$23bcd42a245f9d7b$var$Of] = b;
                    d[$23bcd42a245f9d7b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $23bcd42a245f9d7b$var$D("cancel", d);
                            $23bcd42a245f9d7b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $23bcd42a245f9d7b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $23bcd42a245f9d7b$var$lf.length; e++)$23bcd42a245f9d7b$var$D($23bcd42a245f9d7b$var$lf[e], d);
                            break;
                        case "source":
                            $23bcd42a245f9d7b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $23bcd42a245f9d7b$var$D("error", d);
                            $23bcd42a245f9d7b$var$D("load", d);
                            break;
                        case "details":
                            $23bcd42a245f9d7b$var$D("toggle", d);
                            break;
                        case "input":
                            $23bcd42a245f9d7b$var$Za(d, f);
                            $23bcd42a245f9d7b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $23bcd42a245f9d7b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $23bcd42a245f9d7b$var$hb(d, f), $23bcd42a245f9d7b$var$D("invalid", d);
                    }
                    $23bcd42a245f9d7b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $23bcd42a245f9d7b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $23bcd42a245f9d7b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $23bcd42a245f9d7b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $23bcd42a245f9d7b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $23bcd42a245f9d7b$var$Va(d);
                            $23bcd42a245f9d7b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $23bcd42a245f9d7b$var$Va(d);
                            $23bcd42a245f9d7b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $23bcd42a245f9d7b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $23bcd42a245f9d7b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$23bcd42a245f9d7b$var$Of] = b;
                    a[$23bcd42a245f9d7b$var$Pf] = d;
                    $23bcd42a245f9d7b$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $23bcd42a245f9d7b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $23bcd42a245f9d7b$var$D("cancel", a);
                                $23bcd42a245f9d7b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $23bcd42a245f9d7b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $23bcd42a245f9d7b$var$lf.length; e++)$23bcd42a245f9d7b$var$D($23bcd42a245f9d7b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $23bcd42a245f9d7b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $23bcd42a245f9d7b$var$D("error", a);
                                $23bcd42a245f9d7b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $23bcd42a245f9d7b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $23bcd42a245f9d7b$var$Za(a, d);
                                e = $23bcd42a245f9d7b$var$Ya(a, d);
                                $23bcd42a245f9d7b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $23bcd42a245f9d7b$var$A({}, d, {
                                    value: void 0
                                });
                                $23bcd42a245f9d7b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $23bcd42a245f9d7b$var$hb(a, d);
                                e = $23bcd42a245f9d7b$var$gb(a, d);
                                $23bcd42a245f9d7b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $23bcd42a245f9d7b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $23bcd42a245f9d7b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $23bcd42a245f9d7b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $23bcd42a245f9d7b$var$ob(a, k) : "number" === typeof k && $23bcd42a245f9d7b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($23bcd42a245f9d7b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $23bcd42a245f9d7b$var$D("scroll", a) : null != k && $23bcd42a245f9d7b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $23bcd42a245f9d7b$var$Va(a);
                                $23bcd42a245f9d7b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $23bcd42a245f9d7b$var$Va(a);
                                $23bcd42a245f9d7b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $23bcd42a245f9d7b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $23bcd42a245f9d7b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $23bcd42a245f9d7b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $23bcd42a245f9d7b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $23bcd42a245f9d7b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $23bcd42a245f9d7b$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($23bcd42a245f9d7b$var$p(166));
                c = $23bcd42a245f9d7b$var$xh($23bcd42a245f9d7b$var$wh.current);
                $23bcd42a245f9d7b$var$xh($23bcd42a245f9d7b$var$uh.current);
                if ($23bcd42a245f9d7b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$23bcd42a245f9d7b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $23bcd42a245f9d7b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $23bcd42a245f9d7b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $23bcd42a245f9d7b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$23bcd42a245f9d7b$var$Of] = b, b.stateNode = d;
            }
            $23bcd42a245f9d7b$var$S(b);
            return null;
        case 13:
            $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($23bcd42a245f9d7b$var$I && null !== $23bcd42a245f9d7b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $23bcd42a245f9d7b$var$Hg(), $23bcd42a245f9d7b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $23bcd42a245f9d7b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($23bcd42a245f9d7b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($23bcd42a245f9d7b$var$p(317));
                        f[$23bcd42a245f9d7b$var$Of] = b;
                    } else $23bcd42a245f9d7b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $23bcd42a245f9d7b$var$S(b);
                    f = !1;
                } else null !== $23bcd42a245f9d7b$var$zg && ($23bcd42a245f9d7b$var$Fj($23bcd42a245f9d7b$var$zg), $23bcd42a245f9d7b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($23bcd42a245f9d7b$var$L.current & 1) ? 0 === $23bcd42a245f9d7b$var$T && ($23bcd42a245f9d7b$var$T = 3) : $23bcd42a245f9d7b$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $23bcd42a245f9d7b$var$S(b);
            return null;
        case 4:
            return $23bcd42a245f9d7b$var$zh(), $23bcd42a245f9d7b$var$Aj(a, b), null === a && $23bcd42a245f9d7b$var$sf(b.stateNode.containerInfo), $23bcd42a245f9d7b$var$S(b), null;
        case 10:
            return $23bcd42a245f9d7b$var$ah(b.type._context), $23bcd42a245f9d7b$var$S(b), null;
        case 17:
            return $23bcd42a245f9d7b$var$Zf(b.type) && $23bcd42a245f9d7b$var$$f(), $23bcd42a245f9d7b$var$S(b), null;
        case 19:
            $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$L);
            f = b.memoizedState;
            if (null === f) return $23bcd42a245f9d7b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $23bcd42a245f9d7b$var$Dj(f, !1);
                else {
                    if (0 !== $23bcd42a245f9d7b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $23bcd42a245f9d7b$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $23bcd42a245f9d7b$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$L, $23bcd42a245f9d7b$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $23bcd42a245f9d7b$var$B() > $23bcd42a245f9d7b$var$Gj && (b.flags |= 128, d = !0, $23bcd42a245f9d7b$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $23bcd42a245f9d7b$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $23bcd42a245f9d7b$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$23bcd42a245f9d7b$var$I) return $23bcd42a245f9d7b$var$S(b), null;
                    } else 2 * $23bcd42a245f9d7b$var$B() - f.renderingStartTime > $23bcd42a245f9d7b$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $23bcd42a245f9d7b$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $23bcd42a245f9d7b$var$B(), b.sibling = null, c = $23bcd42a245f9d7b$var$L.current, $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$L, d ? c & 1 | 2 : c & 1), b;
            $23bcd42a245f9d7b$var$S(b);
            return null;
        case 22:
        case 23:
            return $23bcd42a245f9d7b$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($23bcd42a245f9d7b$var$fj & 1073741824) && ($23bcd42a245f9d7b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $23bcd42a245f9d7b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($23bcd42a245f9d7b$var$p(156, b.tag));
}
function $23bcd42a245f9d7b$var$Ij(a, b) {
    $23bcd42a245f9d7b$var$wg(b);
    switch(b.tag){
        case 1:
            return $23bcd42a245f9d7b$var$Zf(b.type) && $23bcd42a245f9d7b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $23bcd42a245f9d7b$var$zh(), $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf), $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$H), $23bcd42a245f9d7b$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $23bcd42a245f9d7b$var$Bh(b), null;
        case 13:
            $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($23bcd42a245f9d7b$var$p(340));
                $23bcd42a245f9d7b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$L), null;
        case 4:
            return $23bcd42a245f9d7b$var$zh(), null;
        case 10:
            return $23bcd42a245f9d7b$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $23bcd42a245f9d7b$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $23bcd42a245f9d7b$var$Jj = !1, $23bcd42a245f9d7b$var$U = !1, $23bcd42a245f9d7b$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $23bcd42a245f9d7b$var$V = null;
function $23bcd42a245f9d7b$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $23bcd42a245f9d7b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $23bcd42a245f9d7b$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $23bcd42a245f9d7b$var$W(a, b, d);
    }
}
var $23bcd42a245f9d7b$var$Nj = !1;
function $23bcd42a245f9d7b$var$Oj(a, b) {
    $23bcd42a245f9d7b$var$Cf = $23bcd42a245f9d7b$var$dd;
    a = $23bcd42a245f9d7b$var$Me();
    if ($23bcd42a245f9d7b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $23bcd42a245f9d7b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $23bcd42a245f9d7b$var$dd = !1;
    for($23bcd42a245f9d7b$var$V = b; null !== $23bcd42a245f9d7b$var$V;)if (b = $23bcd42a245f9d7b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $23bcd42a245f9d7b$var$V = a;
    else for(; null !== $23bcd42a245f9d7b$var$V;){
        b = $23bcd42a245f9d7b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $23bcd42a245f9d7b$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($23bcd42a245f9d7b$var$p(163));
            }
        } catch (F) {
            $23bcd42a245f9d7b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $23bcd42a245f9d7b$var$V = a;
            break;
        }
        $23bcd42a245f9d7b$var$V = b.return;
    }
    n = $23bcd42a245f9d7b$var$Nj;
    $23bcd42a245f9d7b$var$Nj = !1;
    return n;
}
function $23bcd42a245f9d7b$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $23bcd42a245f9d7b$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $23bcd42a245f9d7b$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $23bcd42a245f9d7b$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $23bcd42a245f9d7b$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $23bcd42a245f9d7b$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$23bcd42a245f9d7b$var$Of], delete b[$23bcd42a245f9d7b$var$Pf], delete b[$23bcd42a245f9d7b$var$of], delete b[$23bcd42a245f9d7b$var$Qf], delete b[$23bcd42a245f9d7b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $23bcd42a245f9d7b$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $23bcd42a245f9d7b$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $23bcd42a245f9d7b$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $23bcd42a245f9d7b$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $23bcd42a245f9d7b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($23bcd42a245f9d7b$var$Vj(a, b, c), a = a.sibling; null !== a;)$23bcd42a245f9d7b$var$Vj(a, b, c), a = a.sibling;
}
function $23bcd42a245f9d7b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($23bcd42a245f9d7b$var$Wj(a, b, c), a = a.sibling; null !== a;)$23bcd42a245f9d7b$var$Wj(a, b, c), a = a.sibling;
}
var $23bcd42a245f9d7b$var$X = null, $23bcd42a245f9d7b$var$Xj = !1;
function $23bcd42a245f9d7b$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$23bcd42a245f9d7b$var$Zj(a, b, c), c = c.sibling;
}
function $23bcd42a245f9d7b$var$Zj(a, b, c) {
    if ($23bcd42a245f9d7b$var$lc && "function" === typeof $23bcd42a245f9d7b$var$lc.onCommitFiberUnmount) try {
        $23bcd42a245f9d7b$var$lc.onCommitFiberUnmount($23bcd42a245f9d7b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $23bcd42a245f9d7b$var$U || $23bcd42a245f9d7b$var$Lj(c, b);
        case 6:
            var d = $23bcd42a245f9d7b$var$X, e = $23bcd42a245f9d7b$var$Xj;
            $23bcd42a245f9d7b$var$X = null;
            $23bcd42a245f9d7b$var$Yj(a, b, c);
            $23bcd42a245f9d7b$var$X = d;
            $23bcd42a245f9d7b$var$Xj = e;
            null !== $23bcd42a245f9d7b$var$X && ($23bcd42a245f9d7b$var$Xj ? (a = $23bcd42a245f9d7b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $23bcd42a245f9d7b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $23bcd42a245f9d7b$var$X && ($23bcd42a245f9d7b$var$Xj ? (a = $23bcd42a245f9d7b$var$X, c = c.stateNode, 8 === a.nodeType ? $23bcd42a245f9d7b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $23bcd42a245f9d7b$var$Kf(a, c), $23bcd42a245f9d7b$var$bd(a)) : $23bcd42a245f9d7b$var$Kf($23bcd42a245f9d7b$var$X, c.stateNode));
            break;
        case 4:
            d = $23bcd42a245f9d7b$var$X;
            e = $23bcd42a245f9d7b$var$Xj;
            $23bcd42a245f9d7b$var$X = c.stateNode.containerInfo;
            $23bcd42a245f9d7b$var$Xj = !0;
            $23bcd42a245f9d7b$var$Yj(a, b, c);
            $23bcd42a245f9d7b$var$X = d;
            $23bcd42a245f9d7b$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$23bcd42a245f9d7b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $23bcd42a245f9d7b$var$Mj(c, b, g) : 0 !== (f & 4) && $23bcd42a245f9d7b$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $23bcd42a245f9d7b$var$Yj(a, b, c);
            break;
        case 1:
            if (!$23bcd42a245f9d7b$var$U && ($23bcd42a245f9d7b$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $23bcd42a245f9d7b$var$W(c, b, h);
            }
            $23bcd42a245f9d7b$var$Yj(a, b, c);
            break;
        case 21:
            $23bcd42a245f9d7b$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($23bcd42a245f9d7b$var$U = (d = $23bcd42a245f9d7b$var$U) || null !== c.memoizedState, $23bcd42a245f9d7b$var$Yj(a, b, c), $23bcd42a245f9d7b$var$U = d) : $23bcd42a245f9d7b$var$Yj(a, b, c);
            break;
        default:
            $23bcd42a245f9d7b$var$Yj(a, b, c);
    }
}
function $23bcd42a245f9d7b$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $23bcd42a245f9d7b$var$Kj);
        b.forEach(function(b) {
            var d = $23bcd42a245f9d7b$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $23bcd42a245f9d7b$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $23bcd42a245f9d7b$var$X = h.stateNode;
                        $23bcd42a245f9d7b$var$Xj = !1;
                        break a;
                    case 3:
                        $23bcd42a245f9d7b$var$X = h.stateNode.containerInfo;
                        $23bcd42a245f9d7b$var$Xj = !0;
                        break a;
                    case 4:
                        $23bcd42a245f9d7b$var$X = h.stateNode.containerInfo;
                        $23bcd42a245f9d7b$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $23bcd42a245f9d7b$var$X) throw Error($23bcd42a245f9d7b$var$p(160));
            $23bcd42a245f9d7b$var$Zj(f, g, e);
            $23bcd42a245f9d7b$var$X = null;
            $23bcd42a245f9d7b$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $23bcd42a245f9d7b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$23bcd42a245f9d7b$var$dk(b, a), b = b.sibling;
}
function $23bcd42a245f9d7b$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $23bcd42a245f9d7b$var$ck(b, a);
            $23bcd42a245f9d7b$var$ek(a);
            if (d & 4) {
                try {
                    $23bcd42a245f9d7b$var$Pj(3, a, a.return), $23bcd42a245f9d7b$var$Qj(3, a);
                } catch (t) {
                    $23bcd42a245f9d7b$var$W(a, a.return, t);
                }
                try {
                    $23bcd42a245f9d7b$var$Pj(5, a, a.return);
                } catch (t) {
                    $23bcd42a245f9d7b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $23bcd42a245f9d7b$var$ck(b, a);
            $23bcd42a245f9d7b$var$ek(a);
            d & 512 && null !== c && $23bcd42a245f9d7b$var$Lj(c, c.return);
            break;
        case 5:
            $23bcd42a245f9d7b$var$ck(b, a);
            $23bcd42a245f9d7b$var$ek(a);
            d & 512 && null !== c && $23bcd42a245f9d7b$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $23bcd42a245f9d7b$var$ob(e, "");
                } catch (t) {
                    $23bcd42a245f9d7b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $23bcd42a245f9d7b$var$ab(e, f);
                    $23bcd42a245f9d7b$var$vb(h, g);
                    var l = $23bcd42a245f9d7b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $23bcd42a245f9d7b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $23bcd42a245f9d7b$var$nb(e, q) : "children" === m ? $23bcd42a245f9d7b$var$ob(e, q) : $23bcd42a245f9d7b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $23bcd42a245f9d7b$var$bb(e, f);
                            break;
                        case "textarea":
                            $23bcd42a245f9d7b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $23bcd42a245f9d7b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $23bcd42a245f9d7b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $23bcd42a245f9d7b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$23bcd42a245f9d7b$var$Pf] = f;
                } catch (t) {
                    $23bcd42a245f9d7b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $23bcd42a245f9d7b$var$ck(b, a);
            $23bcd42a245f9d7b$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($23bcd42a245f9d7b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $23bcd42a245f9d7b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $23bcd42a245f9d7b$var$ck(b, a);
            $23bcd42a245f9d7b$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $23bcd42a245f9d7b$var$bd(b.containerInfo);
            } catch (t) {
                $23bcd42a245f9d7b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $23bcd42a245f9d7b$var$ck(b, a);
            $23bcd42a245f9d7b$var$ek(a);
            break;
        case 13:
            $23bcd42a245f9d7b$var$ck(b, a);
            $23bcd42a245f9d7b$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($23bcd42a245f9d7b$var$fk = $23bcd42a245f9d7b$var$B()));
            d & 4 && $23bcd42a245f9d7b$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($23bcd42a245f9d7b$var$U = (l = $23bcd42a245f9d7b$var$U) || m, $23bcd42a245f9d7b$var$ck(b, a), $23bcd42a245f9d7b$var$U = l) : $23bcd42a245f9d7b$var$ck(b, a);
            $23bcd42a245f9d7b$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($23bcd42a245f9d7b$var$V = a, m = a.child; null !== m;){
                    for(q = $23bcd42a245f9d7b$var$V = m; null !== $23bcd42a245f9d7b$var$V;){
                        r = $23bcd42a245f9d7b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $23bcd42a245f9d7b$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $23bcd42a245f9d7b$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $23bcd42a245f9d7b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $23bcd42a245f9d7b$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $23bcd42a245f9d7b$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $23bcd42a245f9d7b$var$V = y) : $23bcd42a245f9d7b$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $23bcd42a245f9d7b$var$rb("display", g));
                            } catch (t) {
                                $23bcd42a245f9d7b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $23bcd42a245f9d7b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $23bcd42a245f9d7b$var$ck(b, a);
            $23bcd42a245f9d7b$var$ek(a);
            d & 4 && $23bcd42a245f9d7b$var$ak(a);
            break;
        case 21:
            break;
        default:
            $23bcd42a245f9d7b$var$ck(b, a), $23bcd42a245f9d7b$var$ek(a);
    }
}
function $23bcd42a245f9d7b$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($23bcd42a245f9d7b$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($23bcd42a245f9d7b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($23bcd42a245f9d7b$var$ob(e, ""), d.flags &= -33);
                    var f = $23bcd42a245f9d7b$var$Uj(a);
                    $23bcd42a245f9d7b$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $23bcd42a245f9d7b$var$Uj(a);
                    $23bcd42a245f9d7b$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($23bcd42a245f9d7b$var$p(161));
            }
        } catch (k) {
            $23bcd42a245f9d7b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $23bcd42a245f9d7b$var$hk(a, b, c) {
    $23bcd42a245f9d7b$var$V = a;
    $23bcd42a245f9d7b$var$ik(a, b, c);
}
function $23bcd42a245f9d7b$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $23bcd42a245f9d7b$var$V;){
        var e = $23bcd42a245f9d7b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $23bcd42a245f9d7b$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $23bcd42a245f9d7b$var$U;
                h = $23bcd42a245f9d7b$var$Jj;
                var l = $23bcd42a245f9d7b$var$U;
                $23bcd42a245f9d7b$var$Jj = g;
                if (($23bcd42a245f9d7b$var$U = k) && !l) for($23bcd42a245f9d7b$var$V = e; null !== $23bcd42a245f9d7b$var$V;)g = $23bcd42a245f9d7b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $23bcd42a245f9d7b$var$jk(e) : null !== k ? (k.return = g, $23bcd42a245f9d7b$var$V = k) : $23bcd42a245f9d7b$var$jk(e);
                for(; null !== f;)$23bcd42a245f9d7b$var$V = f, $23bcd42a245f9d7b$var$ik(f, b, c), f = f.sibling;
                $23bcd42a245f9d7b$var$V = e;
                $23bcd42a245f9d7b$var$Jj = h;
                $23bcd42a245f9d7b$var$U = l;
            }
            $23bcd42a245f9d7b$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $23bcd42a245f9d7b$var$V = f) : $23bcd42a245f9d7b$var$kk(a, b, c);
    }
}
function $23bcd42a245f9d7b$var$kk(a) {
    for(; null !== $23bcd42a245f9d7b$var$V;){
        var b = $23bcd42a245f9d7b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $23bcd42a245f9d7b$var$U || $23bcd42a245f9d7b$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$23bcd42a245f9d7b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $23bcd42a245f9d7b$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $23bcd42a245f9d7b$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $23bcd42a245f9d7b$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $23bcd42a245f9d7b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($23bcd42a245f9d7b$var$p(163));
                }
                $23bcd42a245f9d7b$var$U || b.flags & 512 && $23bcd42a245f9d7b$var$Rj(b);
            } catch (r) {
                $23bcd42a245f9d7b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $23bcd42a245f9d7b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $23bcd42a245f9d7b$var$V = c;
            break;
        }
        $23bcd42a245f9d7b$var$V = b.return;
    }
}
function $23bcd42a245f9d7b$var$gk(a) {
    for(; null !== $23bcd42a245f9d7b$var$V;){
        var b = $23bcd42a245f9d7b$var$V;
        if (b === a) {
            $23bcd42a245f9d7b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $23bcd42a245f9d7b$var$V = c;
            break;
        }
        $23bcd42a245f9d7b$var$V = b.return;
    }
}
function $23bcd42a245f9d7b$var$jk(a) {
    for(; null !== $23bcd42a245f9d7b$var$V;){
        var b = $23bcd42a245f9d7b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $23bcd42a245f9d7b$var$Qj(4, b);
                    } catch (k) {
                        $23bcd42a245f9d7b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $23bcd42a245f9d7b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $23bcd42a245f9d7b$var$Rj(b);
                    } catch (k) {
                        $23bcd42a245f9d7b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $23bcd42a245f9d7b$var$Rj(b);
                    } catch (k) {
                        $23bcd42a245f9d7b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $23bcd42a245f9d7b$var$W(b, b.return, k);
        }
        if (b === a) {
            $23bcd42a245f9d7b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $23bcd42a245f9d7b$var$V = h;
            break;
        }
        $23bcd42a245f9d7b$var$V = b.return;
    }
}
var $23bcd42a245f9d7b$var$lk = Math.ceil, $23bcd42a245f9d7b$var$mk = $23bcd42a245f9d7b$var$ua.ReactCurrentDispatcher, $23bcd42a245f9d7b$var$nk = $23bcd42a245f9d7b$var$ua.ReactCurrentOwner, $23bcd42a245f9d7b$var$ok = $23bcd42a245f9d7b$var$ua.ReactCurrentBatchConfig, $23bcd42a245f9d7b$var$K = 0, $23bcd42a245f9d7b$var$Q = null, $23bcd42a245f9d7b$var$Y = null, $23bcd42a245f9d7b$var$Z = 0, $23bcd42a245f9d7b$var$fj = 0, $23bcd42a245f9d7b$var$ej = $23bcd42a245f9d7b$var$Uf(0), $23bcd42a245f9d7b$var$T = 0, $23bcd42a245f9d7b$var$pk = null, $23bcd42a245f9d7b$var$rh = 0, $23bcd42a245f9d7b$var$qk = 0, $23bcd42a245f9d7b$var$rk = 0, $23bcd42a245f9d7b$var$sk = null, $23bcd42a245f9d7b$var$tk = null, $23bcd42a245f9d7b$var$fk = 0, $23bcd42a245f9d7b$var$Gj = Infinity, $23bcd42a245f9d7b$var$uk = null, $23bcd42a245f9d7b$var$Oi = !1, $23bcd42a245f9d7b$var$Pi = null, $23bcd42a245f9d7b$var$Ri = null, $23bcd42a245f9d7b$var$vk = !1, $23bcd42a245f9d7b$var$wk = null, $23bcd42a245f9d7b$var$xk = 0, $23bcd42a245f9d7b$var$yk = 0, $23bcd42a245f9d7b$var$zk = null, $23bcd42a245f9d7b$var$Ak = -1, $23bcd42a245f9d7b$var$Bk = 0;
function $23bcd42a245f9d7b$var$R() {
    return 0 !== ($23bcd42a245f9d7b$var$K & 6) ? $23bcd42a245f9d7b$var$B() : -1 !== $23bcd42a245f9d7b$var$Ak ? $23bcd42a245f9d7b$var$Ak : $23bcd42a245f9d7b$var$Ak = $23bcd42a245f9d7b$var$B();
}
function $23bcd42a245f9d7b$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($23bcd42a245f9d7b$var$K & 2) && 0 !== $23bcd42a245f9d7b$var$Z) return $23bcd42a245f9d7b$var$Z & -$23bcd42a245f9d7b$var$Z;
    if (null !== $23bcd42a245f9d7b$var$Kg.transition) return 0 === $23bcd42a245f9d7b$var$Bk && ($23bcd42a245f9d7b$var$Bk = $23bcd42a245f9d7b$var$yc()), $23bcd42a245f9d7b$var$Bk;
    a = $23bcd42a245f9d7b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $23bcd42a245f9d7b$var$jd(a.type);
    return a;
}
function $23bcd42a245f9d7b$var$gi(a, b, c, d) {
    if (50 < $23bcd42a245f9d7b$var$yk) throw $23bcd42a245f9d7b$var$yk = 0, $23bcd42a245f9d7b$var$zk = null, Error($23bcd42a245f9d7b$var$p(185));
    $23bcd42a245f9d7b$var$Ac(a, c, d);
    if (0 === ($23bcd42a245f9d7b$var$K & 2) || a !== $23bcd42a245f9d7b$var$Q) a === $23bcd42a245f9d7b$var$Q && (0 === ($23bcd42a245f9d7b$var$K & 2) && ($23bcd42a245f9d7b$var$qk |= c), 4 === $23bcd42a245f9d7b$var$T && $23bcd42a245f9d7b$var$Ck(a, $23bcd42a245f9d7b$var$Z)), $23bcd42a245f9d7b$var$Dk(a, d), 1 === c && 0 === $23bcd42a245f9d7b$var$K && 0 === (b.mode & 1) && ($23bcd42a245f9d7b$var$Gj = $23bcd42a245f9d7b$var$B() + 500, $23bcd42a245f9d7b$var$fg && $23bcd42a245f9d7b$var$jg());
}
function $23bcd42a245f9d7b$var$Dk(a, b) {
    var c = a.callbackNode;
    $23bcd42a245f9d7b$var$wc(a, b);
    var d = $23bcd42a245f9d7b$var$uc(a, a === $23bcd42a245f9d7b$var$Q ? $23bcd42a245f9d7b$var$Z : 0);
    if (0 === d) null !== c && $23bcd42a245f9d7b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $23bcd42a245f9d7b$var$bc(c);
        if (1 === b) 0 === a.tag ? $23bcd42a245f9d7b$var$ig($23bcd42a245f9d7b$var$Ek.bind(null, a)) : $23bcd42a245f9d7b$var$hg($23bcd42a245f9d7b$var$Ek.bind(null, a)), $23bcd42a245f9d7b$var$Jf(function() {
            0 === ($23bcd42a245f9d7b$var$K & 6) && $23bcd42a245f9d7b$var$jg();
        }), c = null;
        else {
            switch($23bcd42a245f9d7b$var$Dc(d)){
                case 1:
                    c = $23bcd42a245f9d7b$var$fc;
                    break;
                case 4:
                    c = $23bcd42a245f9d7b$var$gc;
                    break;
                case 16:
                    c = $23bcd42a245f9d7b$var$hc;
                    break;
                case 536870912:
                    c = $23bcd42a245f9d7b$var$jc;
                    break;
                default:
                    c = $23bcd42a245f9d7b$var$hc;
            }
            c = $23bcd42a245f9d7b$var$Fk(c, $23bcd42a245f9d7b$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $23bcd42a245f9d7b$var$Gk(a, b) {
    $23bcd42a245f9d7b$var$Ak = -1;
    $23bcd42a245f9d7b$var$Bk = 0;
    if (0 !== ($23bcd42a245f9d7b$var$K & 6)) throw Error($23bcd42a245f9d7b$var$p(327));
    var c = a.callbackNode;
    if ($23bcd42a245f9d7b$var$Hk() && a.callbackNode !== c) return null;
    var d = $23bcd42a245f9d7b$var$uc(a, a === $23bcd42a245f9d7b$var$Q ? $23bcd42a245f9d7b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $23bcd42a245f9d7b$var$Ik(a, d);
    else {
        b = d;
        var e = $23bcd42a245f9d7b$var$K;
        $23bcd42a245f9d7b$var$K |= 2;
        var f = $23bcd42a245f9d7b$var$Jk();
        if ($23bcd42a245f9d7b$var$Q !== a || $23bcd42a245f9d7b$var$Z !== b) $23bcd42a245f9d7b$var$uk = null, $23bcd42a245f9d7b$var$Gj = $23bcd42a245f9d7b$var$B() + 500, $23bcd42a245f9d7b$var$Kk(a, b);
        for(;;)try {
            $23bcd42a245f9d7b$var$Lk();
            break;
        } catch (h) {
            $23bcd42a245f9d7b$var$Mk(a, h);
        }
        $23bcd42a245f9d7b$var$$g();
        $23bcd42a245f9d7b$var$mk.current = f;
        $23bcd42a245f9d7b$var$K = e;
        null !== $23bcd42a245f9d7b$var$Y ? b = 0 : ($23bcd42a245f9d7b$var$Q = null, $23bcd42a245f9d7b$var$Z = 0, b = $23bcd42a245f9d7b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $23bcd42a245f9d7b$var$xc(a), 0 !== e && (d = e, b = $23bcd42a245f9d7b$var$Nk(a, e)));
        if (1 === b) throw c = $23bcd42a245f9d7b$var$pk, $23bcd42a245f9d7b$var$Kk(a, 0), $23bcd42a245f9d7b$var$Ck(a, d), $23bcd42a245f9d7b$var$Dk(a, $23bcd42a245f9d7b$var$B()), c;
        if (6 === b) $23bcd42a245f9d7b$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$23bcd42a245f9d7b$var$Ok(e) && (b = $23bcd42a245f9d7b$var$Ik(a, d), 2 === b && (f = $23bcd42a245f9d7b$var$xc(a), 0 !== f && (d = f, b = $23bcd42a245f9d7b$var$Nk(a, f))), 1 === b)) throw c = $23bcd42a245f9d7b$var$pk, $23bcd42a245f9d7b$var$Kk(a, 0), $23bcd42a245f9d7b$var$Ck(a, d), $23bcd42a245f9d7b$var$Dk(a, $23bcd42a245f9d7b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($23bcd42a245f9d7b$var$p(345));
                case 2:
                    $23bcd42a245f9d7b$var$Pk(a, $23bcd42a245f9d7b$var$tk, $23bcd42a245f9d7b$var$uk);
                    break;
                case 3:
                    $23bcd42a245f9d7b$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $23bcd42a245f9d7b$var$fk + 500 - $23bcd42a245f9d7b$var$B(), 10 < b)) {
                        if (0 !== $23bcd42a245f9d7b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $23bcd42a245f9d7b$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $23bcd42a245f9d7b$var$Ff($23bcd42a245f9d7b$var$Pk.bind(null, a, $23bcd42a245f9d7b$var$tk, $23bcd42a245f9d7b$var$uk), b);
                        break;
                    }
                    $23bcd42a245f9d7b$var$Pk(a, $23bcd42a245f9d7b$var$tk, $23bcd42a245f9d7b$var$uk);
                    break;
                case 4:
                    $23bcd42a245f9d7b$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $23bcd42a245f9d7b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $23bcd42a245f9d7b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $23bcd42a245f9d7b$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $23bcd42a245f9d7b$var$Ff($23bcd42a245f9d7b$var$Pk.bind(null, a, $23bcd42a245f9d7b$var$tk, $23bcd42a245f9d7b$var$uk), d);
                        break;
                    }
                    $23bcd42a245f9d7b$var$Pk(a, $23bcd42a245f9d7b$var$tk, $23bcd42a245f9d7b$var$uk);
                    break;
                case 5:
                    $23bcd42a245f9d7b$var$Pk(a, $23bcd42a245f9d7b$var$tk, $23bcd42a245f9d7b$var$uk);
                    break;
                default:
                    throw Error($23bcd42a245f9d7b$var$p(329));
            }
        }
    }
    $23bcd42a245f9d7b$var$Dk(a, $23bcd42a245f9d7b$var$B());
    return a.callbackNode === c ? $23bcd42a245f9d7b$var$Gk.bind(null, a) : null;
}
function $23bcd42a245f9d7b$var$Nk(a, b) {
    var c = $23bcd42a245f9d7b$var$sk;
    a.current.memoizedState.isDehydrated && ($23bcd42a245f9d7b$var$Kk(a, b).flags |= 256);
    a = $23bcd42a245f9d7b$var$Ik(a, b);
    2 !== a && (b = $23bcd42a245f9d7b$var$tk, $23bcd42a245f9d7b$var$tk = c, null !== b && $23bcd42a245f9d7b$var$Fj(b));
    return a;
}
function $23bcd42a245f9d7b$var$Fj(a) {
    null === $23bcd42a245f9d7b$var$tk ? $23bcd42a245f9d7b$var$tk = a : $23bcd42a245f9d7b$var$tk.push.apply($23bcd42a245f9d7b$var$tk, a);
}
function $23bcd42a245f9d7b$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$23bcd42a245f9d7b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $23bcd42a245f9d7b$var$Ck(a, b) {
    b &= ~$23bcd42a245f9d7b$var$rk;
    b &= ~$23bcd42a245f9d7b$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $23bcd42a245f9d7b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $23bcd42a245f9d7b$var$Ek(a) {
    if (0 !== ($23bcd42a245f9d7b$var$K & 6)) throw Error($23bcd42a245f9d7b$var$p(327));
    $23bcd42a245f9d7b$var$Hk();
    var b = $23bcd42a245f9d7b$var$uc(a, 0);
    if (0 === (b & 1)) return $23bcd42a245f9d7b$var$Dk(a, $23bcd42a245f9d7b$var$B()), null;
    var c = $23bcd42a245f9d7b$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $23bcd42a245f9d7b$var$xc(a);
        0 !== d && (b = d, c = $23bcd42a245f9d7b$var$Nk(a, d));
    }
    if (1 === c) throw c = $23bcd42a245f9d7b$var$pk, $23bcd42a245f9d7b$var$Kk(a, 0), $23bcd42a245f9d7b$var$Ck(a, b), $23bcd42a245f9d7b$var$Dk(a, $23bcd42a245f9d7b$var$B()), c;
    if (6 === c) throw Error($23bcd42a245f9d7b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $23bcd42a245f9d7b$var$Pk(a, $23bcd42a245f9d7b$var$tk, $23bcd42a245f9d7b$var$uk);
    $23bcd42a245f9d7b$var$Dk(a, $23bcd42a245f9d7b$var$B());
    return null;
}
function $23bcd42a245f9d7b$var$Qk(a, b) {
    var c = $23bcd42a245f9d7b$var$K;
    $23bcd42a245f9d7b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $23bcd42a245f9d7b$var$K = c, 0 === $23bcd42a245f9d7b$var$K && ($23bcd42a245f9d7b$var$Gj = $23bcd42a245f9d7b$var$B() + 500, $23bcd42a245f9d7b$var$fg && $23bcd42a245f9d7b$var$jg());
    }
}
function $23bcd42a245f9d7b$var$Rk(a) {
    null !== $23bcd42a245f9d7b$var$wk && 0 === $23bcd42a245f9d7b$var$wk.tag && 0 === ($23bcd42a245f9d7b$var$K & 6) && $23bcd42a245f9d7b$var$Hk();
    var b = $23bcd42a245f9d7b$var$K;
    $23bcd42a245f9d7b$var$K |= 1;
    var c = $23bcd42a245f9d7b$var$ok.transition, d = $23bcd42a245f9d7b$var$C;
    try {
        if ($23bcd42a245f9d7b$var$ok.transition = null, $23bcd42a245f9d7b$var$C = 1, a) return a();
    } finally{
        $23bcd42a245f9d7b$var$C = d, $23bcd42a245f9d7b$var$ok.transition = c, $23bcd42a245f9d7b$var$K = b, 0 === ($23bcd42a245f9d7b$var$K & 6) && $23bcd42a245f9d7b$var$jg();
    }
}
function $23bcd42a245f9d7b$var$Hj() {
    $23bcd42a245f9d7b$var$fj = $23bcd42a245f9d7b$var$ej.current;
    $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$ej);
}
function $23bcd42a245f9d7b$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $23bcd42a245f9d7b$var$Gf(c));
    if (null !== $23bcd42a245f9d7b$var$Y) for(c = $23bcd42a245f9d7b$var$Y.return; null !== c;){
        var d = c;
        $23bcd42a245f9d7b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $23bcd42a245f9d7b$var$$f();
                break;
            case 3:
                $23bcd42a245f9d7b$var$zh();
                $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$Wf);
                $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$H);
                $23bcd42a245f9d7b$var$Eh();
                break;
            case 5:
                $23bcd42a245f9d7b$var$Bh(d);
                break;
            case 4:
                $23bcd42a245f9d7b$var$zh();
                break;
            case 13:
                $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$L);
                break;
            case 19:
                $23bcd42a245f9d7b$var$E($23bcd42a245f9d7b$var$L);
                break;
            case 10:
                $23bcd42a245f9d7b$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $23bcd42a245f9d7b$var$Hj();
        }
        c = c.return;
    }
    $23bcd42a245f9d7b$var$Q = a;
    $23bcd42a245f9d7b$var$Y = a = $23bcd42a245f9d7b$var$Pg(a.current, null);
    $23bcd42a245f9d7b$var$Z = $23bcd42a245f9d7b$var$fj = b;
    $23bcd42a245f9d7b$var$T = 0;
    $23bcd42a245f9d7b$var$pk = null;
    $23bcd42a245f9d7b$var$rk = $23bcd42a245f9d7b$var$qk = $23bcd42a245f9d7b$var$rh = 0;
    $23bcd42a245f9d7b$var$tk = $23bcd42a245f9d7b$var$sk = null;
    if (null !== $23bcd42a245f9d7b$var$fh) {
        for(b = 0; b < $23bcd42a245f9d7b$var$fh.length; b++)if (c = $23bcd42a245f9d7b$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $23bcd42a245f9d7b$var$fh = null;
    }
    return a;
}
function $23bcd42a245f9d7b$var$Mk(a, b) {
    do {
        var c = $23bcd42a245f9d7b$var$Y;
        try {
            $23bcd42a245f9d7b$var$$g();
            $23bcd42a245f9d7b$var$Fh.current = $23bcd42a245f9d7b$var$Rh;
            if ($23bcd42a245f9d7b$var$Ih) {
                for(var d = $23bcd42a245f9d7b$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $23bcd42a245f9d7b$var$Ih = !1;
            }
            $23bcd42a245f9d7b$var$Hh = 0;
            $23bcd42a245f9d7b$var$O = $23bcd42a245f9d7b$var$N = $23bcd42a245f9d7b$var$M = null;
            $23bcd42a245f9d7b$var$Jh = !1;
            $23bcd42a245f9d7b$var$Kh = 0;
            $23bcd42a245f9d7b$var$nk.current = null;
            if (null === c || null === c.return) {
                $23bcd42a245f9d7b$var$T = 1;
                $23bcd42a245f9d7b$var$pk = b;
                $23bcd42a245f9d7b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $23bcd42a245f9d7b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $23bcd42a245f9d7b$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $23bcd42a245f9d7b$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $23bcd42a245f9d7b$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $23bcd42a245f9d7b$var$Si(f, l, b);
                            $23bcd42a245f9d7b$var$tj();
                            break a;
                        }
                        k = Error($23bcd42a245f9d7b$var$p(426));
                    }
                } else if ($23bcd42a245f9d7b$var$I && h.mode & 1) {
                    var J = $23bcd42a245f9d7b$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $23bcd42a245f9d7b$var$Vi(J, g, h, f, b);
                        $23bcd42a245f9d7b$var$Jg($23bcd42a245f9d7b$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $23bcd42a245f9d7b$var$Ji(k, h);
                4 !== $23bcd42a245f9d7b$var$T && ($23bcd42a245f9d7b$var$T = 2);
                null === $23bcd42a245f9d7b$var$sk ? $23bcd42a245f9d7b$var$sk = [
                    f
                ] : $23bcd42a245f9d7b$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $23bcd42a245f9d7b$var$Ni(f, k, b);
                            $23bcd42a245f9d7b$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $23bcd42a245f9d7b$var$Ri || !$23bcd42a245f9d7b$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $23bcd42a245f9d7b$var$Qi(f, h, b);
                                $23bcd42a245f9d7b$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $23bcd42a245f9d7b$var$Sk(c);
        } catch (na) {
            b = na;
            $23bcd42a245f9d7b$var$Y === c && null !== c && ($23bcd42a245f9d7b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $23bcd42a245f9d7b$var$Jk() {
    var a = $23bcd42a245f9d7b$var$mk.current;
    $23bcd42a245f9d7b$var$mk.current = $23bcd42a245f9d7b$var$Rh;
    return null === a ? $23bcd42a245f9d7b$var$Rh : a;
}
function $23bcd42a245f9d7b$var$tj() {
    if (0 === $23bcd42a245f9d7b$var$T || 3 === $23bcd42a245f9d7b$var$T || 2 === $23bcd42a245f9d7b$var$T) $23bcd42a245f9d7b$var$T = 4;
    null === $23bcd42a245f9d7b$var$Q || 0 === ($23bcd42a245f9d7b$var$rh & 268435455) && 0 === ($23bcd42a245f9d7b$var$qk & 268435455) || $23bcd42a245f9d7b$var$Ck($23bcd42a245f9d7b$var$Q, $23bcd42a245f9d7b$var$Z);
}
function $23bcd42a245f9d7b$var$Ik(a, b) {
    var c = $23bcd42a245f9d7b$var$K;
    $23bcd42a245f9d7b$var$K |= 2;
    var d = $23bcd42a245f9d7b$var$Jk();
    if ($23bcd42a245f9d7b$var$Q !== a || $23bcd42a245f9d7b$var$Z !== b) $23bcd42a245f9d7b$var$uk = null, $23bcd42a245f9d7b$var$Kk(a, b);
    for(;;)try {
        $23bcd42a245f9d7b$var$Tk();
        break;
    } catch (e) {
        $23bcd42a245f9d7b$var$Mk(a, e);
    }
    $23bcd42a245f9d7b$var$$g();
    $23bcd42a245f9d7b$var$K = c;
    $23bcd42a245f9d7b$var$mk.current = d;
    if (null !== $23bcd42a245f9d7b$var$Y) throw Error($23bcd42a245f9d7b$var$p(261));
    $23bcd42a245f9d7b$var$Q = null;
    $23bcd42a245f9d7b$var$Z = 0;
    return $23bcd42a245f9d7b$var$T;
}
function $23bcd42a245f9d7b$var$Tk() {
    for(; null !== $23bcd42a245f9d7b$var$Y;)$23bcd42a245f9d7b$var$Uk($23bcd42a245f9d7b$var$Y);
}
function $23bcd42a245f9d7b$var$Lk() {
    for(; null !== $23bcd42a245f9d7b$var$Y && !$23bcd42a245f9d7b$var$cc();)$23bcd42a245f9d7b$var$Uk($23bcd42a245f9d7b$var$Y);
}
function $23bcd42a245f9d7b$var$Uk(a) {
    var b = $23bcd42a245f9d7b$var$Vk(a.alternate, a, $23bcd42a245f9d7b$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $23bcd42a245f9d7b$var$Sk(a) : $23bcd42a245f9d7b$var$Y = b;
    $23bcd42a245f9d7b$var$nk.current = null;
}
function $23bcd42a245f9d7b$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $23bcd42a245f9d7b$var$Ej(c, b, $23bcd42a245f9d7b$var$fj), null !== c) {
                $23bcd42a245f9d7b$var$Y = c;
                return;
            }
        } else {
            c = $23bcd42a245f9d7b$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $23bcd42a245f9d7b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $23bcd42a245f9d7b$var$T = 6;
                $23bcd42a245f9d7b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $23bcd42a245f9d7b$var$Y = b;
            return;
        }
        $23bcd42a245f9d7b$var$Y = b = a;
    }while (null !== b);
    0 === $23bcd42a245f9d7b$var$T && ($23bcd42a245f9d7b$var$T = 5);
}
function $23bcd42a245f9d7b$var$Pk(a, b, c) {
    var d = $23bcd42a245f9d7b$var$C, e = $23bcd42a245f9d7b$var$ok.transition;
    try {
        $23bcd42a245f9d7b$var$ok.transition = null, $23bcd42a245f9d7b$var$C = 1, $23bcd42a245f9d7b$var$Wk(a, b, c, d);
    } finally{
        $23bcd42a245f9d7b$var$ok.transition = e, $23bcd42a245f9d7b$var$C = d;
    }
    return null;
}
function $23bcd42a245f9d7b$var$Wk(a, b, c, d) {
    do $23bcd42a245f9d7b$var$Hk();
    while (null !== $23bcd42a245f9d7b$var$wk);
    if (0 !== ($23bcd42a245f9d7b$var$K & 6)) throw Error($23bcd42a245f9d7b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($23bcd42a245f9d7b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $23bcd42a245f9d7b$var$Bc(a, f);
    a === $23bcd42a245f9d7b$var$Q && ($23bcd42a245f9d7b$var$Y = $23bcd42a245f9d7b$var$Q = null, $23bcd42a245f9d7b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $23bcd42a245f9d7b$var$vk || ($23bcd42a245f9d7b$var$vk = !0, $23bcd42a245f9d7b$var$Fk($23bcd42a245f9d7b$var$hc, function() {
        $23bcd42a245f9d7b$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $23bcd42a245f9d7b$var$ok.transition;
        $23bcd42a245f9d7b$var$ok.transition = null;
        var g = $23bcd42a245f9d7b$var$C;
        $23bcd42a245f9d7b$var$C = 1;
        var h = $23bcd42a245f9d7b$var$K;
        $23bcd42a245f9d7b$var$K |= 4;
        $23bcd42a245f9d7b$var$nk.current = null;
        $23bcd42a245f9d7b$var$Oj(a, c);
        $23bcd42a245f9d7b$var$dk(c, a);
        $23bcd42a245f9d7b$var$Oe($23bcd42a245f9d7b$var$Df);
        $23bcd42a245f9d7b$var$dd = !!$23bcd42a245f9d7b$var$Cf;
        $23bcd42a245f9d7b$var$Df = $23bcd42a245f9d7b$var$Cf = null;
        a.current = c;
        $23bcd42a245f9d7b$var$hk(c, a, e);
        $23bcd42a245f9d7b$var$dc();
        $23bcd42a245f9d7b$var$K = h;
        $23bcd42a245f9d7b$var$C = g;
        $23bcd42a245f9d7b$var$ok.transition = f;
    } else a.current = c;
    $23bcd42a245f9d7b$var$vk && ($23bcd42a245f9d7b$var$vk = !1, $23bcd42a245f9d7b$var$wk = a, $23bcd42a245f9d7b$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($23bcd42a245f9d7b$var$Ri = null);
    $23bcd42a245f9d7b$var$mc(c.stateNode, d);
    $23bcd42a245f9d7b$var$Dk(a, $23bcd42a245f9d7b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($23bcd42a245f9d7b$var$Oi) throw $23bcd42a245f9d7b$var$Oi = !1, a = $23bcd42a245f9d7b$var$Pi, $23bcd42a245f9d7b$var$Pi = null, a;
    0 !== ($23bcd42a245f9d7b$var$xk & 1) && 0 !== a.tag && $23bcd42a245f9d7b$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $23bcd42a245f9d7b$var$zk ? $23bcd42a245f9d7b$var$yk++ : ($23bcd42a245f9d7b$var$yk = 0, $23bcd42a245f9d7b$var$zk = a) : $23bcd42a245f9d7b$var$yk = 0;
    $23bcd42a245f9d7b$var$jg();
    return null;
}
function $23bcd42a245f9d7b$var$Hk() {
    if (null !== $23bcd42a245f9d7b$var$wk) {
        var a = $23bcd42a245f9d7b$var$Dc($23bcd42a245f9d7b$var$xk), b = $23bcd42a245f9d7b$var$ok.transition, c = $23bcd42a245f9d7b$var$C;
        try {
            $23bcd42a245f9d7b$var$ok.transition = null;
            $23bcd42a245f9d7b$var$C = 16 > a ? 16 : a;
            if (null === $23bcd42a245f9d7b$var$wk) var d = !1;
            else {
                a = $23bcd42a245f9d7b$var$wk;
                $23bcd42a245f9d7b$var$wk = null;
                $23bcd42a245f9d7b$var$xk = 0;
                if (0 !== ($23bcd42a245f9d7b$var$K & 6)) throw Error($23bcd42a245f9d7b$var$p(331));
                var e = $23bcd42a245f9d7b$var$K;
                $23bcd42a245f9d7b$var$K |= 4;
                for($23bcd42a245f9d7b$var$V = a.current; null !== $23bcd42a245f9d7b$var$V;){
                    var f = $23bcd42a245f9d7b$var$V, g = f.child;
                    if (0 !== ($23bcd42a245f9d7b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($23bcd42a245f9d7b$var$V = l; null !== $23bcd42a245f9d7b$var$V;){
                                    var m = $23bcd42a245f9d7b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $23bcd42a245f9d7b$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $23bcd42a245f9d7b$var$V = q;
                                    else for(; null !== $23bcd42a245f9d7b$var$V;){
                                        m = $23bcd42a245f9d7b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $23bcd42a245f9d7b$var$Sj(m);
                                        if (m === l) {
                                            $23bcd42a245f9d7b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $23bcd42a245f9d7b$var$V = r;
                                            break;
                                        }
                                        $23bcd42a245f9d7b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $23bcd42a245f9d7b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $23bcd42a245f9d7b$var$V = g;
                    else b: for(; null !== $23bcd42a245f9d7b$var$V;){
                        f = $23bcd42a245f9d7b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $23bcd42a245f9d7b$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $23bcd42a245f9d7b$var$V = x;
                            break b;
                        }
                        $23bcd42a245f9d7b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($23bcd42a245f9d7b$var$V = w; null !== $23bcd42a245f9d7b$var$V;){
                    g = $23bcd42a245f9d7b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $23bcd42a245f9d7b$var$V = u;
                    else b: for(g = w; null !== $23bcd42a245f9d7b$var$V;){
                        h = $23bcd42a245f9d7b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $23bcd42a245f9d7b$var$Qj(9, h);
                            }
                        } catch (na) {
                            $23bcd42a245f9d7b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $23bcd42a245f9d7b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $23bcd42a245f9d7b$var$V = F;
                            break b;
                        }
                        $23bcd42a245f9d7b$var$V = h.return;
                    }
                }
                $23bcd42a245f9d7b$var$K = e;
                $23bcd42a245f9d7b$var$jg();
                if ($23bcd42a245f9d7b$var$lc && "function" === typeof $23bcd42a245f9d7b$var$lc.onPostCommitFiberRoot) try {
                    $23bcd42a245f9d7b$var$lc.onPostCommitFiberRoot($23bcd42a245f9d7b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $23bcd42a245f9d7b$var$C = c, $23bcd42a245f9d7b$var$ok.transition = b;
        }
    }
    return !1;
}
function $23bcd42a245f9d7b$var$Xk(a, b, c) {
    b = $23bcd42a245f9d7b$var$Ji(c, b);
    b = $23bcd42a245f9d7b$var$Ni(a, b, 1);
    a = $23bcd42a245f9d7b$var$nh(a, b, 1);
    b = $23bcd42a245f9d7b$var$R();
    null !== a && ($23bcd42a245f9d7b$var$Ac(a, 1, b), $23bcd42a245f9d7b$var$Dk(a, b));
}
function $23bcd42a245f9d7b$var$W(a, b, c) {
    if (3 === a.tag) $23bcd42a245f9d7b$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $23bcd42a245f9d7b$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $23bcd42a245f9d7b$var$Ri || !$23bcd42a245f9d7b$var$Ri.has(d))) {
                a = $23bcd42a245f9d7b$var$Ji(c, a);
                a = $23bcd42a245f9d7b$var$Qi(b, a, 1);
                b = $23bcd42a245f9d7b$var$nh(b, a, 1);
                a = $23bcd42a245f9d7b$var$R();
                null !== b && ($23bcd42a245f9d7b$var$Ac(b, 1, a), $23bcd42a245f9d7b$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $23bcd42a245f9d7b$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $23bcd42a245f9d7b$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $23bcd42a245f9d7b$var$Q === a && ($23bcd42a245f9d7b$var$Z & c) === c && (4 === $23bcd42a245f9d7b$var$T || 3 === $23bcd42a245f9d7b$var$T && ($23bcd42a245f9d7b$var$Z & 130023424) === $23bcd42a245f9d7b$var$Z && 500 > $23bcd42a245f9d7b$var$B() - $23bcd42a245f9d7b$var$fk ? $23bcd42a245f9d7b$var$Kk(a, 0) : $23bcd42a245f9d7b$var$rk |= c);
    $23bcd42a245f9d7b$var$Dk(a, b);
}
function $23bcd42a245f9d7b$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $23bcd42a245f9d7b$var$sc, $23bcd42a245f9d7b$var$sc <<= 1, 0 === ($23bcd42a245f9d7b$var$sc & 130023424) && ($23bcd42a245f9d7b$var$sc = 4194304)));
    var c = $23bcd42a245f9d7b$var$R();
    a = $23bcd42a245f9d7b$var$ih(a, b);
    null !== a && ($23bcd42a245f9d7b$var$Ac(a, b, c), $23bcd42a245f9d7b$var$Dk(a, c));
}
function $23bcd42a245f9d7b$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $23bcd42a245f9d7b$var$Yk(a, c);
}
function $23bcd42a245f9d7b$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($23bcd42a245f9d7b$var$p(314));
    }
    null !== d && d.delete(b);
    $23bcd42a245f9d7b$var$Yk(a, c);
}
var $23bcd42a245f9d7b$var$Vk;
$23bcd42a245f9d7b$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $23bcd42a245f9d7b$var$Wf.current) $23bcd42a245f9d7b$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $23bcd42a245f9d7b$var$dh = !1, $23bcd42a245f9d7b$var$yj(a, b, c);
            $23bcd42a245f9d7b$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $23bcd42a245f9d7b$var$dh = !1, $23bcd42a245f9d7b$var$I && 0 !== (b.flags & 1048576) && $23bcd42a245f9d7b$var$ug(b, $23bcd42a245f9d7b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $23bcd42a245f9d7b$var$ij(a, b);
            a = b.pendingProps;
            var e = $23bcd42a245f9d7b$var$Yf(b, $23bcd42a245f9d7b$var$H.current);
            $23bcd42a245f9d7b$var$ch(b, c);
            e = $23bcd42a245f9d7b$var$Nh(null, b, d, a, e, c);
            var f = $23bcd42a245f9d7b$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $23bcd42a245f9d7b$var$Zf(d) ? (f = !0, $23bcd42a245f9d7b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $23bcd42a245f9d7b$var$kh(b), e.updater = $23bcd42a245f9d7b$var$Ei, b.stateNode = e, e._reactInternals = b, $23bcd42a245f9d7b$var$Ii(b, d, a, c), b = $23bcd42a245f9d7b$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $23bcd42a245f9d7b$var$I && f && $23bcd42a245f9d7b$var$vg(b), $23bcd42a245f9d7b$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $23bcd42a245f9d7b$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $23bcd42a245f9d7b$var$Zk(d);
                a = $23bcd42a245f9d7b$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $23bcd42a245f9d7b$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $23bcd42a245f9d7b$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $23bcd42a245f9d7b$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $23bcd42a245f9d7b$var$$i(null, b, d, $23bcd42a245f9d7b$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($23bcd42a245f9d7b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $23bcd42a245f9d7b$var$Ci(d, e), $23bcd42a245f9d7b$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $23bcd42a245f9d7b$var$Ci(d, e), $23bcd42a245f9d7b$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $23bcd42a245f9d7b$var$kj(b);
                if (null === a) throw Error($23bcd42a245f9d7b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $23bcd42a245f9d7b$var$lh(a, b);
                $23bcd42a245f9d7b$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $23bcd42a245f9d7b$var$Ji(Error($23bcd42a245f9d7b$var$p(423)), b);
                        b = $23bcd42a245f9d7b$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $23bcd42a245f9d7b$var$Ji(Error($23bcd42a245f9d7b$var$p(424)), b);
                        b = $23bcd42a245f9d7b$var$lj(a, b, d, c, e);
                        break a;
                    } else for($23bcd42a245f9d7b$var$yg = $23bcd42a245f9d7b$var$Lf(b.stateNode.containerInfo.firstChild), $23bcd42a245f9d7b$var$xg = b, $23bcd42a245f9d7b$var$I = !0, $23bcd42a245f9d7b$var$zg = null, c = $23bcd42a245f9d7b$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $23bcd42a245f9d7b$var$Ig();
                    if (d === e) {
                        b = $23bcd42a245f9d7b$var$Zi(a, b, c);
                        break a;
                    }
                    $23bcd42a245f9d7b$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $23bcd42a245f9d7b$var$Ah(b), null === a && $23bcd42a245f9d7b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $23bcd42a245f9d7b$var$Ef(d, e) ? g = null : null !== f && $23bcd42a245f9d7b$var$Ef(d, f) && (b.flags |= 32), $23bcd42a245f9d7b$var$gj(a, b), $23bcd42a245f9d7b$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $23bcd42a245f9d7b$var$Eg(b), null;
        case 13:
            return $23bcd42a245f9d7b$var$oj(a, b, c);
        case 4:
            return $23bcd42a245f9d7b$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $23bcd42a245f9d7b$var$Ug(b, null, d, c) : $23bcd42a245f9d7b$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $23bcd42a245f9d7b$var$Ci(d, e), $23bcd42a245f9d7b$var$Yi(a, b, d, e, c);
        case 7:
            return $23bcd42a245f9d7b$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $23bcd42a245f9d7b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $23bcd42a245f9d7b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $23bcd42a245f9d7b$var$G($23bcd42a245f9d7b$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($23bcd42a245f9d7b$var$He(f.value, g)) {
                        if (f.children === e.children && !$23bcd42a245f9d7b$var$Wf.current) {
                            b = $23bcd42a245f9d7b$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $23bcd42a245f9d7b$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $23bcd42a245f9d7b$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($23bcd42a245f9d7b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $23bcd42a245f9d7b$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $23bcd42a245f9d7b$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $23bcd42a245f9d7b$var$ch(b, c), e = $23bcd42a245f9d7b$var$eh(e), d = d(e), b.flags |= 1, $23bcd42a245f9d7b$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $23bcd42a245f9d7b$var$Ci(d, b.pendingProps), e = $23bcd42a245f9d7b$var$Ci(d.type, e), $23bcd42a245f9d7b$var$$i(a, b, d, e, c);
        case 15:
            return $23bcd42a245f9d7b$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $23bcd42a245f9d7b$var$Ci(d, e), $23bcd42a245f9d7b$var$ij(a, b), b.tag = 1, $23bcd42a245f9d7b$var$Zf(d) ? (a = !0, $23bcd42a245f9d7b$var$cg(b)) : a = !1, $23bcd42a245f9d7b$var$ch(b, c), $23bcd42a245f9d7b$var$Gi(b, d, e), $23bcd42a245f9d7b$var$Ii(b, d, e, c), $23bcd42a245f9d7b$var$jj(null, b, d, !0, a, c);
        case 19:
            return $23bcd42a245f9d7b$var$xj(a, b, c);
        case 22:
            return $23bcd42a245f9d7b$var$dj(a, b, c);
    }
    throw Error($23bcd42a245f9d7b$var$p(156, b.tag));
};
function $23bcd42a245f9d7b$var$Fk(a, b) {
    return $23bcd42a245f9d7b$var$ac(a, b);
}
function $23bcd42a245f9d7b$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $23bcd42a245f9d7b$var$Bg(a, b, c, d) {
    return new $23bcd42a245f9d7b$var$$k(a, b, c, d);
}
function $23bcd42a245f9d7b$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $23bcd42a245f9d7b$var$Zk(a) {
    if ("function" === typeof a) return $23bcd42a245f9d7b$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $23bcd42a245f9d7b$var$Da) return 11;
        if (a === $23bcd42a245f9d7b$var$Ga) return 14;
    }
    return 2;
}
function $23bcd42a245f9d7b$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $23bcd42a245f9d7b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $23bcd42a245f9d7b$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $23bcd42a245f9d7b$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $23bcd42a245f9d7b$var$ya:
            return $23bcd42a245f9d7b$var$Tg(c.children, e, f, b);
        case $23bcd42a245f9d7b$var$za:
            g = 8;
            e |= 8;
            break;
        case $23bcd42a245f9d7b$var$Aa:
            return a = $23bcd42a245f9d7b$var$Bg(12, c, b, e | 2), a.elementType = $23bcd42a245f9d7b$var$Aa, a.lanes = f, a;
        case $23bcd42a245f9d7b$var$Ea:
            return a = $23bcd42a245f9d7b$var$Bg(13, c, b, e), a.elementType = $23bcd42a245f9d7b$var$Ea, a.lanes = f, a;
        case $23bcd42a245f9d7b$var$Fa:
            return a = $23bcd42a245f9d7b$var$Bg(19, c, b, e), a.elementType = $23bcd42a245f9d7b$var$Fa, a.lanes = f, a;
        case $23bcd42a245f9d7b$var$Ia:
            return $23bcd42a245f9d7b$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $23bcd42a245f9d7b$var$Ba:
                    g = 10;
                    break a;
                case $23bcd42a245f9d7b$var$Ca:
                    g = 9;
                    break a;
                case $23bcd42a245f9d7b$var$Da:
                    g = 11;
                    break a;
                case $23bcd42a245f9d7b$var$Ga:
                    g = 14;
                    break a;
                case $23bcd42a245f9d7b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($23bcd42a245f9d7b$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $23bcd42a245f9d7b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $23bcd42a245f9d7b$var$Tg(a, b, c, d) {
    a = $23bcd42a245f9d7b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $23bcd42a245f9d7b$var$pj(a, b, c, d) {
    a = $23bcd42a245f9d7b$var$Bg(22, a, d, b);
    a.elementType = $23bcd42a245f9d7b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $23bcd42a245f9d7b$var$Qg(a, b, c) {
    a = $23bcd42a245f9d7b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $23bcd42a245f9d7b$var$Sg(a, b, c) {
    b = $23bcd42a245f9d7b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $23bcd42a245f9d7b$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $23bcd42a245f9d7b$var$zc(0);
    this.expirationTimes = $23bcd42a245f9d7b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $23bcd42a245f9d7b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $23bcd42a245f9d7b$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $23bcd42a245f9d7b$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $23bcd42a245f9d7b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $23bcd42a245f9d7b$var$kh(f);
    return a;
}
function $23bcd42a245f9d7b$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $23bcd42a245f9d7b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $23bcd42a245f9d7b$var$dl(a) {
    if (!a) return $23bcd42a245f9d7b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($23bcd42a245f9d7b$var$Vb(a) !== a || 1 !== a.tag) throw Error($23bcd42a245f9d7b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($23bcd42a245f9d7b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($23bcd42a245f9d7b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($23bcd42a245f9d7b$var$Zf(c)) return $23bcd42a245f9d7b$var$bg(a, c, b);
    }
    return b;
}
function $23bcd42a245f9d7b$var$el(a, b, c, d, e, f, g, h, k) {
    a = $23bcd42a245f9d7b$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $23bcd42a245f9d7b$var$dl(null);
    c = a.current;
    d = $23bcd42a245f9d7b$var$R();
    e = $23bcd42a245f9d7b$var$yi(c);
    f = $23bcd42a245f9d7b$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $23bcd42a245f9d7b$var$nh(c, f, e);
    a.current.lanes = e;
    $23bcd42a245f9d7b$var$Ac(a, e, d);
    $23bcd42a245f9d7b$var$Dk(a, d);
    return a;
}
function $23bcd42a245f9d7b$var$fl(a, b, c, d) {
    var e = b.current, f = $23bcd42a245f9d7b$var$R(), g = $23bcd42a245f9d7b$var$yi(e);
    c = $23bcd42a245f9d7b$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $23bcd42a245f9d7b$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $23bcd42a245f9d7b$var$nh(e, b, g);
    null !== a && ($23bcd42a245f9d7b$var$gi(a, e, g, f), $23bcd42a245f9d7b$var$oh(a, e, g));
    return g;
}
function $23bcd42a245f9d7b$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $23bcd42a245f9d7b$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $23bcd42a245f9d7b$var$il(a, b) {
    $23bcd42a245f9d7b$var$hl(a, b);
    (a = a.alternate) && $23bcd42a245f9d7b$var$hl(a, b);
}
function $23bcd42a245f9d7b$var$jl() {
    return null;
}
var $23bcd42a245f9d7b$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $23bcd42a245f9d7b$var$ll(a) {
    this._internalRoot = a;
}
$23bcd42a245f9d7b$var$ml.prototype.render = $23bcd42a245f9d7b$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($23bcd42a245f9d7b$var$p(409));
    $23bcd42a245f9d7b$var$fl(a, b, null, null);
};
$23bcd42a245f9d7b$var$ml.prototype.unmount = $23bcd42a245f9d7b$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $23bcd42a245f9d7b$var$Rk(function() {
            $23bcd42a245f9d7b$var$fl(null, a, null, null);
        });
        b[$23bcd42a245f9d7b$var$uf] = null;
    }
};
function $23bcd42a245f9d7b$var$ml(a) {
    this._internalRoot = a;
}
$23bcd42a245f9d7b$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $23bcd42a245f9d7b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $23bcd42a245f9d7b$var$Qc.length && 0 !== b && b < $23bcd42a245f9d7b$var$Qc[c].priority; c++);
        $23bcd42a245f9d7b$var$Qc.splice(c, 0, a);
        0 === c && $23bcd42a245f9d7b$var$Vc(a);
    }
};
function $23bcd42a245f9d7b$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $23bcd42a245f9d7b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $23bcd42a245f9d7b$var$pl() {}
function $23bcd42a245f9d7b$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $23bcd42a245f9d7b$var$gl(g);
                f.call(a);
            };
        }
        var g = $23bcd42a245f9d7b$var$el(b, d, a, 0, null, !1, !1, "", $23bcd42a245f9d7b$var$pl);
        a._reactRootContainer = g;
        a[$23bcd42a245f9d7b$var$uf] = g.current;
        $23bcd42a245f9d7b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $23bcd42a245f9d7b$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $23bcd42a245f9d7b$var$gl(k);
            h.call(a);
        };
    }
    var k = $23bcd42a245f9d7b$var$bl(a, 0, !1, null, null, !1, !1, "", $23bcd42a245f9d7b$var$pl);
    a._reactRootContainer = k;
    a[$23bcd42a245f9d7b$var$uf] = k.current;
    $23bcd42a245f9d7b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $23bcd42a245f9d7b$var$Rk(function() {
        $23bcd42a245f9d7b$var$fl(b, k, c, d);
    });
    return k;
}
function $23bcd42a245f9d7b$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $23bcd42a245f9d7b$var$gl(g);
                h.call(a);
            };
        }
        $23bcd42a245f9d7b$var$fl(b, g, a, e);
    } else g = $23bcd42a245f9d7b$var$ql(c, b, a, e, d);
    return $23bcd42a245f9d7b$var$gl(g);
}
$23bcd42a245f9d7b$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $23bcd42a245f9d7b$var$tc(b.pendingLanes);
                0 !== c && ($23bcd42a245f9d7b$var$Cc(b, c | 1), $23bcd42a245f9d7b$var$Dk(b, $23bcd42a245f9d7b$var$B()), 0 === ($23bcd42a245f9d7b$var$K & 6) && ($23bcd42a245f9d7b$var$Gj = $23bcd42a245f9d7b$var$B() + 500, $23bcd42a245f9d7b$var$jg()));
            }
            break;
        case 13:
            $23bcd42a245f9d7b$var$Rk(function() {
                var b = $23bcd42a245f9d7b$var$ih(a, 1);
                if (null !== b) {
                    var c = $23bcd42a245f9d7b$var$R();
                    $23bcd42a245f9d7b$var$gi(b, a, 1, c);
                }
            }), $23bcd42a245f9d7b$var$il(a, 1);
    }
};
$23bcd42a245f9d7b$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $23bcd42a245f9d7b$var$ih(a, 134217728);
        if (null !== b) {
            var c = $23bcd42a245f9d7b$var$R();
            $23bcd42a245f9d7b$var$gi(b, a, 134217728, c);
        }
        $23bcd42a245f9d7b$var$il(a, 134217728);
    }
};
$23bcd42a245f9d7b$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $23bcd42a245f9d7b$var$yi(a), c = $23bcd42a245f9d7b$var$ih(a, b);
        if (null !== c) {
            var d = $23bcd42a245f9d7b$var$R();
            $23bcd42a245f9d7b$var$gi(c, a, b, d);
        }
        $23bcd42a245f9d7b$var$il(a, b);
    }
};
$23bcd42a245f9d7b$var$Hc = function() {
    return $23bcd42a245f9d7b$var$C;
};
$23bcd42a245f9d7b$var$Ic = function(a, b) {
    var c = $23bcd42a245f9d7b$var$C;
    try {
        return $23bcd42a245f9d7b$var$C = a, b();
    } finally{
        $23bcd42a245f9d7b$var$C = c;
    }
};
$23bcd42a245f9d7b$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $23bcd42a245f9d7b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $23bcd42a245f9d7b$var$Db(d);
                        if (!e) throw Error($23bcd42a245f9d7b$var$p(90));
                        $23bcd42a245f9d7b$var$Wa(d);
                        $23bcd42a245f9d7b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $23bcd42a245f9d7b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $23bcd42a245f9d7b$var$fb(a, !!c.multiple, b, !1);
    }
};
$23bcd42a245f9d7b$var$Gb = $23bcd42a245f9d7b$var$Qk;
$23bcd42a245f9d7b$var$Hb = $23bcd42a245f9d7b$var$Rk;
var $23bcd42a245f9d7b$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $23bcd42a245f9d7b$var$Cb,
        $23bcd42a245f9d7b$var$ue,
        $23bcd42a245f9d7b$var$Db,
        $23bcd42a245f9d7b$var$Eb,
        $23bcd42a245f9d7b$var$Fb,
        $23bcd42a245f9d7b$var$Qk
    ]
}, $23bcd42a245f9d7b$var$tl = {
    findFiberByHostInstance: $23bcd42a245f9d7b$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $23bcd42a245f9d7b$var$ul = {
    bundleType: $23bcd42a245f9d7b$var$tl.bundleType,
    version: $23bcd42a245f9d7b$var$tl.version,
    rendererPackageName: $23bcd42a245f9d7b$var$tl.rendererPackageName,
    rendererConfig: $23bcd42a245f9d7b$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $23bcd42a245f9d7b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $23bcd42a245f9d7b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $23bcd42a245f9d7b$var$tl.findFiberByHostInstance || $23bcd42a245f9d7b$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $23bcd42a245f9d7b$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$23bcd42a245f9d7b$var$vl.isDisabled && $23bcd42a245f9d7b$var$vl.supportsFiber) try {
        $23bcd42a245f9d7b$var$kc = $23bcd42a245f9d7b$var$vl.inject($23bcd42a245f9d7b$var$ul), $23bcd42a245f9d7b$var$lc = $23bcd42a245f9d7b$var$vl;
    } catch (a) {}
}
$23bcd42a245f9d7b$export$ae55be85d98224ed = $23bcd42a245f9d7b$var$sl;
$23bcd42a245f9d7b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$23bcd42a245f9d7b$var$nl(b)) throw Error($23bcd42a245f9d7b$var$p(200));
    return $23bcd42a245f9d7b$var$cl(a, b, null, c);
};
$23bcd42a245f9d7b$export$882461b6382ed46c = function(a, b) {
    if (!$23bcd42a245f9d7b$var$nl(a)) throw Error($23bcd42a245f9d7b$var$p(299));
    var c = !1, d = "", e = $23bcd42a245f9d7b$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $23bcd42a245f9d7b$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$23bcd42a245f9d7b$var$uf] = b.current;
    $23bcd42a245f9d7b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $23bcd42a245f9d7b$var$ll(b);
};
$23bcd42a245f9d7b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($23bcd42a245f9d7b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($23bcd42a245f9d7b$var$p(268, a));
    }
    a = $23bcd42a245f9d7b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$23bcd42a245f9d7b$export$cd75ccfd720a3cd4 = function(a) {
    return $23bcd42a245f9d7b$var$Rk(a);
};
$23bcd42a245f9d7b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$23bcd42a245f9d7b$var$ol(b)) throw Error($23bcd42a245f9d7b$var$p(200));
    return $23bcd42a245f9d7b$var$rl(null, a, b, !0, c);
};
$23bcd42a245f9d7b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$23bcd42a245f9d7b$var$nl(a)) throw Error($23bcd42a245f9d7b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $23bcd42a245f9d7b$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $23bcd42a245f9d7b$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$23bcd42a245f9d7b$var$uf] = b.current;
    $23bcd42a245f9d7b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $23bcd42a245f9d7b$var$ml(b);
};
$23bcd42a245f9d7b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$23bcd42a245f9d7b$var$ol(b)) throw Error($23bcd42a245f9d7b$var$p(200));
    return $23bcd42a245f9d7b$var$rl(null, a, b, !1, c);
};
$23bcd42a245f9d7b$export$502457920280e6be = function(a) {
    if (!$23bcd42a245f9d7b$var$ol(a)) throw Error($23bcd42a245f9d7b$var$p(40));
    return a._reactRootContainer ? ($23bcd42a245f9d7b$var$Rk(function() {
        $23bcd42a245f9d7b$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$23bcd42a245f9d7b$var$uf] = null;
        });
    }), !0) : !1;
};
$23bcd42a245f9d7b$export$c78a37762a8d58e1 = $23bcd42a245f9d7b$var$Qk;
$23bcd42a245f9d7b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$23bcd42a245f9d7b$var$ol(c)) throw Error($23bcd42a245f9d7b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($23bcd42a245f9d7b$var$p(38));
    return $23bcd42a245f9d7b$var$rl(a, b, c, !1, d);
};
$23bcd42a245f9d7b$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fOxuK", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ks7lO"));

});
parcelRegister("ks7lO", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $ee3c1fdfe8a0ae81$export$c4744153514ff05d; }, function (v) { return $ee3c1fdfe8a0ae81$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $ee3c1fdfe8a0ae81$export$3e506c1ccc9cc1a7; }, function (v) { return $ee3c1fdfe8a0ae81$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $ee3c1fdfe8a0ae81$export$e26fe2ed2fa76875; }, function (v) { return $ee3c1fdfe8a0ae81$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $ee3c1fdfe8a0ae81$export$502329bbf4b505b1; }, function (v) { return $ee3c1fdfe8a0ae81$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $ee3c1fdfe8a0ae81$export$6e3807111c4874c4; }, function (v) { return $ee3c1fdfe8a0ae81$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $ee3c1fdfe8a0ae81$export$c27134553091fb3a; }, function (v) { return $ee3c1fdfe8a0ae81$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $ee3c1fdfe8a0ae81$export$33ee1acdc04fd2a2; }, function (v) { return $ee3c1fdfe8a0ae81$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $ee3c1fdfe8a0ae81$export$b00a404bbd5edef2; }, function (v) { return $ee3c1fdfe8a0ae81$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $ee3c1fdfe8a0ae81$export$8352ce38b91d0c62; }, function (v) { return $ee3c1fdfe8a0ae81$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $ee3c1fdfe8a0ae81$export$d66a1c1c77bd778b; }, function (v) { return $ee3c1fdfe8a0ae81$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $ee3c1fdfe8a0ae81$export$d3dfb8e4810cb555; }, function (v) { return $ee3c1fdfe8a0ae81$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $ee3c1fdfe8a0ae81$export$839f9183b0465a69; }, function (v) { return $ee3c1fdfe8a0ae81$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $ee3c1fdfe8a0ae81$export$72fdf0e06517287b; }, function (v) { return $ee3c1fdfe8a0ae81$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $ee3c1fdfe8a0ae81$export$4b844e58a3e414b4; }, function (v) { return $ee3c1fdfe8a0ae81$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $ee3c1fdfe8a0ae81$export$816d2913ae6b83b1; }, function (v) { return $ee3c1fdfe8a0ae81$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $ee3c1fdfe8a0ae81$export$61bcfe829111a1d0; }, function (v) { return $ee3c1fdfe8a0ae81$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $ee3c1fdfe8a0ae81$export$7ee8c9beb337bc3f; }, function (v) { return $ee3c1fdfe8a0ae81$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $ee3c1fdfe8a0ae81$export$b5836b71941fa3ed; }, function (v) { return $ee3c1fdfe8a0ae81$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $ee3c1fdfe8a0ae81$export$cf845f2c119da08a; }, function (v) { return $ee3c1fdfe8a0ae81$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ee3c1fdfe8a0ae81$export$c4744153514ff05d;
var $ee3c1fdfe8a0ae81$export$3e506c1ccc9cc1a7;
var $ee3c1fdfe8a0ae81$export$e26fe2ed2fa76875;
var $ee3c1fdfe8a0ae81$export$502329bbf4b505b1;
var $ee3c1fdfe8a0ae81$export$6e3807111c4874c4;
var $ee3c1fdfe8a0ae81$export$c27134553091fb3a;
var $ee3c1fdfe8a0ae81$export$33ee1acdc04fd2a2;
var $ee3c1fdfe8a0ae81$export$b00a404bbd5edef2;
var $ee3c1fdfe8a0ae81$export$8352ce38b91d0c62;
var $ee3c1fdfe8a0ae81$export$d66a1c1c77bd778b;
var $ee3c1fdfe8a0ae81$export$d3dfb8e4810cb555;
var $ee3c1fdfe8a0ae81$export$839f9183b0465a69;
var $ee3c1fdfe8a0ae81$export$72fdf0e06517287b;
var $ee3c1fdfe8a0ae81$export$4b844e58a3e414b4;
var $ee3c1fdfe8a0ae81$export$816d2913ae6b83b1;
var $ee3c1fdfe8a0ae81$export$61bcfe829111a1d0;
var $ee3c1fdfe8a0ae81$export$7ee8c9beb337bc3f;
var $ee3c1fdfe8a0ae81$export$b5836b71941fa3ed;
var $ee3c1fdfe8a0ae81$export$cf845f2c119da08a;
"use strict";
function $ee3c1fdfe8a0ae81$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $ee3c1fdfe8a0ae81$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $ee3c1fdfe8a0ae81$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $ee3c1fdfe8a0ae81$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $ee3c1fdfe8a0ae81$var$g(C, c)) n < e && 0 > $ee3c1fdfe8a0ae81$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $ee3c1fdfe8a0ae81$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $ee3c1fdfe8a0ae81$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ee3c1fdfe8a0ae81$var$l = performance;
    $ee3c1fdfe8a0ae81$export$c4744153514ff05d = function() {
        return $ee3c1fdfe8a0ae81$var$l.now();
    };
} else {
    var $ee3c1fdfe8a0ae81$var$p = Date, $ee3c1fdfe8a0ae81$var$q = $ee3c1fdfe8a0ae81$var$p.now();
    $ee3c1fdfe8a0ae81$export$c4744153514ff05d = function() {
        return $ee3c1fdfe8a0ae81$var$p.now() - $ee3c1fdfe8a0ae81$var$q;
    };
}
var $ee3c1fdfe8a0ae81$var$r = [], $ee3c1fdfe8a0ae81$var$t = [], $ee3c1fdfe8a0ae81$var$u = 1, $ee3c1fdfe8a0ae81$var$v = null, $ee3c1fdfe8a0ae81$var$y = 3, $ee3c1fdfe8a0ae81$var$z = !1, $ee3c1fdfe8a0ae81$var$A = !1, $ee3c1fdfe8a0ae81$var$B = !1, $ee3c1fdfe8a0ae81$var$D = "function" === typeof setTimeout ? setTimeout : null, $ee3c1fdfe8a0ae81$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $ee3c1fdfe8a0ae81$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $ee3c1fdfe8a0ae81$var$G(a) {
    for(var b = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$t); null !== b;){
        if (null === b.callback) $ee3c1fdfe8a0ae81$var$k($ee3c1fdfe8a0ae81$var$t);
        else if (b.startTime <= a) $ee3c1fdfe8a0ae81$var$k($ee3c1fdfe8a0ae81$var$t), b.sortIndex = b.expirationTime, $ee3c1fdfe8a0ae81$var$f($ee3c1fdfe8a0ae81$var$r, b);
        else break;
        b = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$t);
    }
}
function $ee3c1fdfe8a0ae81$var$H(a) {
    $ee3c1fdfe8a0ae81$var$B = !1;
    $ee3c1fdfe8a0ae81$var$G(a);
    if (!$ee3c1fdfe8a0ae81$var$A) {
        if (null !== $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r)) $ee3c1fdfe8a0ae81$var$A = !0, $ee3c1fdfe8a0ae81$var$I($ee3c1fdfe8a0ae81$var$J);
        else {
            var b = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$t);
            null !== b && $ee3c1fdfe8a0ae81$var$K($ee3c1fdfe8a0ae81$var$H, b.startTime - a);
        }
    }
}
function $ee3c1fdfe8a0ae81$var$J(a, b) {
    $ee3c1fdfe8a0ae81$var$A = !1;
    $ee3c1fdfe8a0ae81$var$B && ($ee3c1fdfe8a0ae81$var$B = !1, $ee3c1fdfe8a0ae81$var$E($ee3c1fdfe8a0ae81$var$L), $ee3c1fdfe8a0ae81$var$L = -1);
    $ee3c1fdfe8a0ae81$var$z = !0;
    var c = $ee3c1fdfe8a0ae81$var$y;
    try {
        $ee3c1fdfe8a0ae81$var$G(b);
        for($ee3c1fdfe8a0ae81$var$v = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r); null !== $ee3c1fdfe8a0ae81$var$v && (!($ee3c1fdfe8a0ae81$var$v.expirationTime > b) || a && !$ee3c1fdfe8a0ae81$var$M());){
            var d = $ee3c1fdfe8a0ae81$var$v.callback;
            if ("function" === typeof d) {
                $ee3c1fdfe8a0ae81$var$v.callback = null;
                $ee3c1fdfe8a0ae81$var$y = $ee3c1fdfe8a0ae81$var$v.priorityLevel;
                var e = d($ee3c1fdfe8a0ae81$var$v.expirationTime <= b);
                b = $ee3c1fdfe8a0ae81$export$c4744153514ff05d();
                "function" === typeof e ? $ee3c1fdfe8a0ae81$var$v.callback = e : $ee3c1fdfe8a0ae81$var$v === $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r) && $ee3c1fdfe8a0ae81$var$k($ee3c1fdfe8a0ae81$var$r);
                $ee3c1fdfe8a0ae81$var$G(b);
            } else $ee3c1fdfe8a0ae81$var$k($ee3c1fdfe8a0ae81$var$r);
            $ee3c1fdfe8a0ae81$var$v = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r);
        }
        if (null !== $ee3c1fdfe8a0ae81$var$v) var w = !0;
        else {
            var m = $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$t);
            null !== m && $ee3c1fdfe8a0ae81$var$K($ee3c1fdfe8a0ae81$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $ee3c1fdfe8a0ae81$var$v = null, $ee3c1fdfe8a0ae81$var$y = c, $ee3c1fdfe8a0ae81$var$z = !1;
    }
}
var $ee3c1fdfe8a0ae81$var$N = !1, $ee3c1fdfe8a0ae81$var$O = null, $ee3c1fdfe8a0ae81$var$L = -1, $ee3c1fdfe8a0ae81$var$P = 5, $ee3c1fdfe8a0ae81$var$Q = -1;
function $ee3c1fdfe8a0ae81$var$M() {
    return $ee3c1fdfe8a0ae81$export$c4744153514ff05d() - $ee3c1fdfe8a0ae81$var$Q < $ee3c1fdfe8a0ae81$var$P ? !1 : !0;
}
function $ee3c1fdfe8a0ae81$var$R() {
    if (null !== $ee3c1fdfe8a0ae81$var$O) {
        var a = $ee3c1fdfe8a0ae81$export$c4744153514ff05d();
        $ee3c1fdfe8a0ae81$var$Q = a;
        var b = !0;
        try {
            b = $ee3c1fdfe8a0ae81$var$O(!0, a);
        } finally{
            b ? $ee3c1fdfe8a0ae81$var$S() : ($ee3c1fdfe8a0ae81$var$N = !1, $ee3c1fdfe8a0ae81$var$O = null);
        }
    } else $ee3c1fdfe8a0ae81$var$N = !1;
}
var $ee3c1fdfe8a0ae81$var$S;
if ("function" === typeof $ee3c1fdfe8a0ae81$var$F) $ee3c1fdfe8a0ae81$var$S = function() {
    $ee3c1fdfe8a0ae81$var$F($ee3c1fdfe8a0ae81$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ee3c1fdfe8a0ae81$var$T = new MessageChannel, $ee3c1fdfe8a0ae81$var$U = $ee3c1fdfe8a0ae81$var$T.port2;
    $ee3c1fdfe8a0ae81$var$T.port1.onmessage = $ee3c1fdfe8a0ae81$var$R;
    $ee3c1fdfe8a0ae81$var$S = function() {
        $ee3c1fdfe8a0ae81$var$U.postMessage(null);
    };
} else $ee3c1fdfe8a0ae81$var$S = function() {
    $ee3c1fdfe8a0ae81$var$D($ee3c1fdfe8a0ae81$var$R, 0);
};
function $ee3c1fdfe8a0ae81$var$I(a) {
    $ee3c1fdfe8a0ae81$var$O = a;
    $ee3c1fdfe8a0ae81$var$N || ($ee3c1fdfe8a0ae81$var$N = !0, $ee3c1fdfe8a0ae81$var$S());
}
function $ee3c1fdfe8a0ae81$var$K(a, b) {
    $ee3c1fdfe8a0ae81$var$L = $ee3c1fdfe8a0ae81$var$D(function() {
        a($ee3c1fdfe8a0ae81$export$c4744153514ff05d());
    }, b);
}
$ee3c1fdfe8a0ae81$export$3e506c1ccc9cc1a7 = 5;
$ee3c1fdfe8a0ae81$export$e26fe2ed2fa76875 = 1;
$ee3c1fdfe8a0ae81$export$502329bbf4b505b1 = 4;
$ee3c1fdfe8a0ae81$export$6e3807111c4874c4 = 3;
$ee3c1fdfe8a0ae81$export$c27134553091fb3a = null;
$ee3c1fdfe8a0ae81$export$33ee1acdc04fd2a2 = 2;
$ee3c1fdfe8a0ae81$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$ee3c1fdfe8a0ae81$export$8352ce38b91d0c62 = function() {
    $ee3c1fdfe8a0ae81$var$A || $ee3c1fdfe8a0ae81$var$z || ($ee3c1fdfe8a0ae81$var$A = !0, $ee3c1fdfe8a0ae81$var$I($ee3c1fdfe8a0ae81$var$J));
};
$ee3c1fdfe8a0ae81$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ee3c1fdfe8a0ae81$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$ee3c1fdfe8a0ae81$export$d3dfb8e4810cb555 = function() {
    return $ee3c1fdfe8a0ae81$var$y;
};
$ee3c1fdfe8a0ae81$export$839f9183b0465a69 = function() {
    return $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r);
};
$ee3c1fdfe8a0ae81$export$72fdf0e06517287b = function(a) {
    switch($ee3c1fdfe8a0ae81$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $ee3c1fdfe8a0ae81$var$y;
    }
    var c = $ee3c1fdfe8a0ae81$var$y;
    $ee3c1fdfe8a0ae81$var$y = b;
    try {
        return a();
    } finally{
        $ee3c1fdfe8a0ae81$var$y = c;
    }
};
$ee3c1fdfe8a0ae81$export$4b844e58a3e414b4 = function() {};
$ee3c1fdfe8a0ae81$export$816d2913ae6b83b1 = function() {};
$ee3c1fdfe8a0ae81$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $ee3c1fdfe8a0ae81$var$y;
    $ee3c1fdfe8a0ae81$var$y = a;
    try {
        return b();
    } finally{
        $ee3c1fdfe8a0ae81$var$y = c;
    }
};
$ee3c1fdfe8a0ae81$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $ee3c1fdfe8a0ae81$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $ee3c1fdfe8a0ae81$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $ee3c1fdfe8a0ae81$var$f($ee3c1fdfe8a0ae81$var$t, a), null === $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$r) && a === $ee3c1fdfe8a0ae81$var$h($ee3c1fdfe8a0ae81$var$t) && ($ee3c1fdfe8a0ae81$var$B ? ($ee3c1fdfe8a0ae81$var$E($ee3c1fdfe8a0ae81$var$L), $ee3c1fdfe8a0ae81$var$L = -1) : $ee3c1fdfe8a0ae81$var$B = !0, $ee3c1fdfe8a0ae81$var$K($ee3c1fdfe8a0ae81$var$H, c - d))) : (a.sortIndex = e, $ee3c1fdfe8a0ae81$var$f($ee3c1fdfe8a0ae81$var$r, a), $ee3c1fdfe8a0ae81$var$A || $ee3c1fdfe8a0ae81$var$z || ($ee3c1fdfe8a0ae81$var$A = !0, $ee3c1fdfe8a0ae81$var$I($ee3c1fdfe8a0ae81$var$J)));
    return a;
};
$ee3c1fdfe8a0ae81$export$b5836b71941fa3ed = $ee3c1fdfe8a0ae81$var$M;
$ee3c1fdfe8a0ae81$export$cf845f2c119da08a = function(a) {
    var b = $ee3c1fdfe8a0ae81$var$y;
    return function() {
        var c = $ee3c1fdfe8a0ae81$var$y;
        $ee3c1fdfe8a0ae81$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $ee3c1fdfe8a0ae81$var$y = c;
        }
    };
};

});



parcelRegister("arFVW", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $79acf41daaf53572$export$a7c73072b1a182ae; }, function (v) { return $79acf41daaf53572$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $79acf41daaf53572$export$9f27bc3417b4524d; }, function (v) { return $79acf41daaf53572$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $79acf41daaf53572$export$db77ccec0bb4ccac; }, function (v) { return $79acf41daaf53572$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $79acf41daaf53572$export$8392c0c9d3dcbd35; }, function (v) { return $79acf41daaf53572$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $79acf41daaf53572$export$ffb0004e005737fa; }, function (v) { return $79acf41daaf53572$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $79acf41daaf53572$export$b624eff549462981; }, function (v) { return $79acf41daaf53572$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $79acf41daaf53572$export$7897aa7841a5380c; }, function (v) { return $79acf41daaf53572$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $79acf41daaf53572$export$602eac185826482c; }, function (v) { return $79acf41daaf53572$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $79acf41daaf53572$export$e2c29f18771995cb; }, function (v) { return $79acf41daaf53572$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $79acf41daaf53572$export$5f8d39834fd61797; }, function (v) { return $79acf41daaf53572$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $79acf41daaf53572$export$74bf444e3cd11ea5; }, function (v) { return $79acf41daaf53572$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $79acf41daaf53572$export$998bcd577473dd93; }, function (v) { return $79acf41daaf53572$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $79acf41daaf53572$export$92387174baf9b227; }, function (v) { return $79acf41daaf53572$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $79acf41daaf53572$export$ec112efeb987d9c6; }, function (v) { return $79acf41daaf53572$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $79acf41daaf53572$export$b706b080d889d2c9; }, function (v) { return $79acf41daaf53572$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $79acf41daaf53572$export$5be5a87408f70ddc; }, function (v) { return $79acf41daaf53572$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $79acf41daaf53572$export$45a5e7f76e0caa8d; }, function (v) { return $79acf41daaf53572$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $79acf41daaf53572$export$455c2e768291efa6; }, function (v) { return $79acf41daaf53572$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $79acf41daaf53572$export$9522e17588c12572; }, function (v) { return $79acf41daaf53572$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $79acf41daaf53572$export$2110ac352bb060b9; }, function (v) { return $79acf41daaf53572$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $79acf41daaf53572$export$56885ab8b9c456ab; }, function (v) { return $79acf41daaf53572$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $79acf41daaf53572$export$d927fcb6adf8f9de; }, function (v) { return $79acf41daaf53572$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $79acf41daaf53572$export$b82d16f27459e05a; }, function (v) { return $79acf41daaf53572$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $79acf41daaf53572$export$522c17b4f5e123e8; }, function (v) { return $79acf41daaf53572$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $79acf41daaf53572$export$1aabd8a0274ecfd6; }, function (v) { return $79acf41daaf53572$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $79acf41daaf53572$export$3d6c20d97e46b957; }, function (v) { return $79acf41daaf53572$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $79acf41daaf53572$export$9b621391a187a31a; }, function (v) { return $79acf41daaf53572$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $79acf41daaf53572$export$f5bbd400c2f4426f; }, function (v) { return $79acf41daaf53572$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $79acf41daaf53572$export$a7c73072b1a182ae;
var $79acf41daaf53572$export$9f27bc3417b4524d;
var $79acf41daaf53572$export$db77ccec0bb4ccac;
var $79acf41daaf53572$export$8392c0c9d3dcbd35;
var $79acf41daaf53572$export$ffb0004e005737fa;
var $79acf41daaf53572$export$b624eff549462981;
var $79acf41daaf53572$export$7897aa7841a5380c;
var $79acf41daaf53572$export$602eac185826482c;
var $79acf41daaf53572$export$e2c29f18771995cb;
var $79acf41daaf53572$export$5f8d39834fd61797;
var $79acf41daaf53572$export$74bf444e3cd11ea5;
var $79acf41daaf53572$export$998bcd577473dd93;
var $79acf41daaf53572$export$92387174baf9b227;
var $79acf41daaf53572$export$ec112efeb987d9c6;
var $79acf41daaf53572$export$b706b080d889d2c9;
var $79acf41daaf53572$export$5be5a87408f70ddc;
var $79acf41daaf53572$export$45a5e7f76e0caa8d;
var $79acf41daaf53572$export$455c2e768291efa6;
var $79acf41daaf53572$export$9522e17588c12572;
var $79acf41daaf53572$export$2110ac352bb060b9;
var $79acf41daaf53572$export$56885ab8b9c456ab;
var $79acf41daaf53572$export$d927fcb6adf8f9de;
var $79acf41daaf53572$export$b82d16f27459e05a;
var $79acf41daaf53572$export$522c17b4f5e123e8;
var $79acf41daaf53572$export$1aabd8a0274ecfd6;
var $79acf41daaf53572$export$3d6c20d97e46b957;
var $79acf41daaf53572$export$9b621391a187a31a;
var $79acf41daaf53572$export$f5bbd400c2f4426f;
"use strict";
var $79acf41daaf53572$var$b = Symbol.for("react.element"), $79acf41daaf53572$var$c = Symbol.for("react.portal"), $79acf41daaf53572$var$d = Symbol.for("react.fragment"), $79acf41daaf53572$var$e = Symbol.for("react.strict_mode"), $79acf41daaf53572$var$f = Symbol.for("react.profiler"), $79acf41daaf53572$var$g = Symbol.for("react.provider"), $79acf41daaf53572$var$h = Symbol.for("react.context"), $79acf41daaf53572$var$k = Symbol.for("react.server_context"), $79acf41daaf53572$var$l = Symbol.for("react.forward_ref"), $79acf41daaf53572$var$m = Symbol.for("react.suspense"), $79acf41daaf53572$var$n = Symbol.for("react.suspense_list"), $79acf41daaf53572$var$p = Symbol.for("react.memo"), $79acf41daaf53572$var$q = Symbol.for("react.lazy"), $79acf41daaf53572$var$t = Symbol.for("react.offscreen"), $79acf41daaf53572$var$u;
$79acf41daaf53572$var$u = Symbol.for("react.module.reference");
function $79acf41daaf53572$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $79acf41daaf53572$var$b:
                switch(a = a.type, a){
                    case $79acf41daaf53572$var$d:
                    case $79acf41daaf53572$var$f:
                    case $79acf41daaf53572$var$e:
                    case $79acf41daaf53572$var$m:
                    case $79acf41daaf53572$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $79acf41daaf53572$var$k:
                            case $79acf41daaf53572$var$h:
                            case $79acf41daaf53572$var$l:
                            case $79acf41daaf53572$var$q:
                            case $79acf41daaf53572$var$p:
                            case $79acf41daaf53572$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $79acf41daaf53572$var$c:
                return r;
        }
    }
}
$79acf41daaf53572$export$a7c73072b1a182ae = $79acf41daaf53572$var$h;
$79acf41daaf53572$export$9f27bc3417b4524d = $79acf41daaf53572$var$g;
$79acf41daaf53572$export$db77ccec0bb4ccac = $79acf41daaf53572$var$b;
$79acf41daaf53572$export$8392c0c9d3dcbd35 = $79acf41daaf53572$var$l;
$79acf41daaf53572$export$ffb0004e005737fa = $79acf41daaf53572$var$d;
$79acf41daaf53572$export$b624eff549462981 = $79acf41daaf53572$var$q;
$79acf41daaf53572$export$7897aa7841a5380c = $79acf41daaf53572$var$p;
$79acf41daaf53572$export$602eac185826482c = $79acf41daaf53572$var$c;
$79acf41daaf53572$export$e2c29f18771995cb = $79acf41daaf53572$var$f;
$79acf41daaf53572$export$5f8d39834fd61797 = $79acf41daaf53572$var$e;
$79acf41daaf53572$export$74bf444e3cd11ea5 = $79acf41daaf53572$var$m;
$79acf41daaf53572$export$998bcd577473dd93 = $79acf41daaf53572$var$n;
$79acf41daaf53572$export$92387174baf9b227 = function() {
    return !1;
};
$79acf41daaf53572$export$ec112efeb987d9c6 = function() {
    return !1;
};
$79acf41daaf53572$export$b706b080d889d2c9 = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$h;
};
$79acf41daaf53572$export$5be5a87408f70ddc = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$g;
};
$79acf41daaf53572$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $79acf41daaf53572$var$b;
};
$79acf41daaf53572$export$455c2e768291efa6 = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$l;
};
$79acf41daaf53572$export$9522e17588c12572 = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$d;
};
$79acf41daaf53572$export$2110ac352bb060b9 = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$q;
};
$79acf41daaf53572$export$56885ab8b9c456ab = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$p;
};
$79acf41daaf53572$export$d927fcb6adf8f9de = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$c;
};
$79acf41daaf53572$export$b82d16f27459e05a = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$f;
};
$79acf41daaf53572$export$522c17b4f5e123e8 = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$e;
};
$79acf41daaf53572$export$1aabd8a0274ecfd6 = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$m;
};
$79acf41daaf53572$export$3d6c20d97e46b957 = function(a) {
    return $79acf41daaf53572$var$v(a) === $79acf41daaf53572$var$n;
};
$79acf41daaf53572$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $79acf41daaf53572$var$d || a === $79acf41daaf53572$var$f || a === $79acf41daaf53572$var$e || a === $79acf41daaf53572$var$m || a === $79acf41daaf53572$var$n || a === $79acf41daaf53572$var$t || "object" === typeof a && null !== a && (a.$$typeof === $79acf41daaf53572$var$q || a.$$typeof === $79acf41daaf53572$var$p || a.$$typeof === $79acf41daaf53572$var$g || a.$$typeof === $79acf41daaf53572$var$h || a.$$typeof === $79acf41daaf53572$var$l || a.$$typeof === $79acf41daaf53572$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$79acf41daaf53572$export$f5bbd400c2f4426f = $79acf41daaf53572$var$v;

});

parcelRegister("efd5V", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $a5ec9fb5b44e6fa7$export$2b8d127b894957b9; }, function (v) { return $a5ec9fb5b44e6fa7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $a5ec9fb5b44e6fa7$export$cea3a54a6425200c; }, function (v) { return $a5ec9fb5b44e6fa7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $a5ec9fb5b44e6fa7$export$a7c73072b1a182ae; }, function (v) { return $a5ec9fb5b44e6fa7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $a5ec9fb5b44e6fa7$export$9f27bc3417b4524d; }, function (v) { return $a5ec9fb5b44e6fa7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $a5ec9fb5b44e6fa7$export$db77ccec0bb4ccac; }, function (v) { return $a5ec9fb5b44e6fa7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $a5ec9fb5b44e6fa7$export$8392c0c9d3dcbd35; }, function (v) { return $a5ec9fb5b44e6fa7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a5ec9fb5b44e6fa7$export$ffb0004e005737fa; }, function (v) { return $a5ec9fb5b44e6fa7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $a5ec9fb5b44e6fa7$export$b624eff549462981; }, function (v) { return $a5ec9fb5b44e6fa7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $a5ec9fb5b44e6fa7$export$7897aa7841a5380c; }, function (v) { return $a5ec9fb5b44e6fa7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $a5ec9fb5b44e6fa7$export$602eac185826482c; }, function (v) { return $a5ec9fb5b44e6fa7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $a5ec9fb5b44e6fa7$export$e2c29f18771995cb; }, function (v) { return $a5ec9fb5b44e6fa7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a5ec9fb5b44e6fa7$export$5f8d39834fd61797; }, function (v) { return $a5ec9fb5b44e6fa7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a5ec9fb5b44e6fa7$export$74bf444e3cd11ea5; }, function (v) { return $a5ec9fb5b44e6fa7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $a5ec9fb5b44e6fa7$export$92387174baf9b227; }, function (v) { return $a5ec9fb5b44e6fa7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $a5ec9fb5b44e6fa7$export$ec112efeb987d9c6; }, function (v) { return $a5ec9fb5b44e6fa7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $a5ec9fb5b44e6fa7$export$b706b080d889d2c9; }, function (v) { return $a5ec9fb5b44e6fa7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $a5ec9fb5b44e6fa7$export$5be5a87408f70ddc; }, function (v) { return $a5ec9fb5b44e6fa7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $a5ec9fb5b44e6fa7$export$45a5e7f76e0caa8d; }, function (v) { return $a5ec9fb5b44e6fa7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $a5ec9fb5b44e6fa7$export$455c2e768291efa6; }, function (v) { return $a5ec9fb5b44e6fa7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $a5ec9fb5b44e6fa7$export$9522e17588c12572; }, function (v) { return $a5ec9fb5b44e6fa7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $a5ec9fb5b44e6fa7$export$2110ac352bb060b9; }, function (v) { return $a5ec9fb5b44e6fa7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $a5ec9fb5b44e6fa7$export$56885ab8b9c456ab; }, function (v) { return $a5ec9fb5b44e6fa7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $a5ec9fb5b44e6fa7$export$d927fcb6adf8f9de; }, function (v) { return $a5ec9fb5b44e6fa7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $a5ec9fb5b44e6fa7$export$b82d16f27459e05a; }, function (v) { return $a5ec9fb5b44e6fa7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $a5ec9fb5b44e6fa7$export$522c17b4f5e123e8; }, function (v) { return $a5ec9fb5b44e6fa7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $a5ec9fb5b44e6fa7$export$1aabd8a0274ecfd6; }, function (v) { return $a5ec9fb5b44e6fa7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $a5ec9fb5b44e6fa7$export$9b621391a187a31a; }, function (v) { return $a5ec9fb5b44e6fa7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $a5ec9fb5b44e6fa7$export$f5bbd400c2f4426f; }, function (v) { return $a5ec9fb5b44e6fa7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a5ec9fb5b44e6fa7$export$2b8d127b894957b9;
var $a5ec9fb5b44e6fa7$export$cea3a54a6425200c;
var $a5ec9fb5b44e6fa7$export$a7c73072b1a182ae;
var $a5ec9fb5b44e6fa7$export$9f27bc3417b4524d;
var $a5ec9fb5b44e6fa7$export$db77ccec0bb4ccac;
var $a5ec9fb5b44e6fa7$export$8392c0c9d3dcbd35;
var $a5ec9fb5b44e6fa7$export$ffb0004e005737fa;
var $a5ec9fb5b44e6fa7$export$b624eff549462981;
var $a5ec9fb5b44e6fa7$export$7897aa7841a5380c;
var $a5ec9fb5b44e6fa7$export$602eac185826482c;
var $a5ec9fb5b44e6fa7$export$e2c29f18771995cb;
var $a5ec9fb5b44e6fa7$export$5f8d39834fd61797;
var $a5ec9fb5b44e6fa7$export$74bf444e3cd11ea5;
var $a5ec9fb5b44e6fa7$export$92387174baf9b227;
var $a5ec9fb5b44e6fa7$export$ec112efeb987d9c6;
var $a5ec9fb5b44e6fa7$export$b706b080d889d2c9;
var $a5ec9fb5b44e6fa7$export$5be5a87408f70ddc;
var $a5ec9fb5b44e6fa7$export$45a5e7f76e0caa8d;
var $a5ec9fb5b44e6fa7$export$455c2e768291efa6;
var $a5ec9fb5b44e6fa7$export$9522e17588c12572;
var $a5ec9fb5b44e6fa7$export$2110ac352bb060b9;
var $a5ec9fb5b44e6fa7$export$56885ab8b9c456ab;
var $a5ec9fb5b44e6fa7$export$d927fcb6adf8f9de;
var $a5ec9fb5b44e6fa7$export$b82d16f27459e05a;
var $a5ec9fb5b44e6fa7$export$522c17b4f5e123e8;
var $a5ec9fb5b44e6fa7$export$1aabd8a0274ecfd6;
var $a5ec9fb5b44e6fa7$export$9b621391a187a31a;
var $a5ec9fb5b44e6fa7$export$f5bbd400c2f4426f;
"use strict";
var $a5ec9fb5b44e6fa7$var$b = "function" === typeof Symbol && Symbol.for, $a5ec9fb5b44e6fa7$var$c = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.element") : 60103, $a5ec9fb5b44e6fa7$var$d = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.portal") : 60106, $a5ec9fb5b44e6fa7$var$e = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.fragment") : 60107, $a5ec9fb5b44e6fa7$var$f = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.strict_mode") : 60108, $a5ec9fb5b44e6fa7$var$g = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.profiler") : 60114, $a5ec9fb5b44e6fa7$var$h = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.provider") : 60109, $a5ec9fb5b44e6fa7$var$k = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.context") : 60110, $a5ec9fb5b44e6fa7$var$l = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.async_mode") : 60111, $a5ec9fb5b44e6fa7$var$m = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a5ec9fb5b44e6fa7$var$n = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.forward_ref") : 60112, $a5ec9fb5b44e6fa7$var$p = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.suspense") : 60113, $a5ec9fb5b44e6fa7$var$q = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.suspense_list") : 60120, $a5ec9fb5b44e6fa7$var$r = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.memo") : 60115, $a5ec9fb5b44e6fa7$var$t = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.lazy") : 60116, $a5ec9fb5b44e6fa7$var$v = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.block") : 60121, $a5ec9fb5b44e6fa7$var$w = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.fundamental") : 60117, $a5ec9fb5b44e6fa7$var$x = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.responder") : 60118, $a5ec9fb5b44e6fa7$var$y = $a5ec9fb5b44e6fa7$var$b ? Symbol.for("react.scope") : 60119;
function $a5ec9fb5b44e6fa7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a5ec9fb5b44e6fa7$var$c:
                switch(a = a.type, a){
                    case $a5ec9fb5b44e6fa7$var$l:
                    case $a5ec9fb5b44e6fa7$var$m:
                    case $a5ec9fb5b44e6fa7$var$e:
                    case $a5ec9fb5b44e6fa7$var$g:
                    case $a5ec9fb5b44e6fa7$var$f:
                    case $a5ec9fb5b44e6fa7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a5ec9fb5b44e6fa7$var$k:
                            case $a5ec9fb5b44e6fa7$var$n:
                            case $a5ec9fb5b44e6fa7$var$t:
                            case $a5ec9fb5b44e6fa7$var$r:
                            case $a5ec9fb5b44e6fa7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a5ec9fb5b44e6fa7$var$d:
                return u;
        }
    }
}
function $a5ec9fb5b44e6fa7$var$A(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$m;
}
$a5ec9fb5b44e6fa7$export$2b8d127b894957b9 = $a5ec9fb5b44e6fa7$var$l;
$a5ec9fb5b44e6fa7$export$cea3a54a6425200c = $a5ec9fb5b44e6fa7$var$m;
$a5ec9fb5b44e6fa7$export$a7c73072b1a182ae = $a5ec9fb5b44e6fa7$var$k;
$a5ec9fb5b44e6fa7$export$9f27bc3417b4524d = $a5ec9fb5b44e6fa7$var$h;
$a5ec9fb5b44e6fa7$export$db77ccec0bb4ccac = $a5ec9fb5b44e6fa7$var$c;
$a5ec9fb5b44e6fa7$export$8392c0c9d3dcbd35 = $a5ec9fb5b44e6fa7$var$n;
$a5ec9fb5b44e6fa7$export$ffb0004e005737fa = $a5ec9fb5b44e6fa7$var$e;
$a5ec9fb5b44e6fa7$export$b624eff549462981 = $a5ec9fb5b44e6fa7$var$t;
$a5ec9fb5b44e6fa7$export$7897aa7841a5380c = $a5ec9fb5b44e6fa7$var$r;
$a5ec9fb5b44e6fa7$export$602eac185826482c = $a5ec9fb5b44e6fa7$var$d;
$a5ec9fb5b44e6fa7$export$e2c29f18771995cb = $a5ec9fb5b44e6fa7$var$g;
$a5ec9fb5b44e6fa7$export$5f8d39834fd61797 = $a5ec9fb5b44e6fa7$var$f;
$a5ec9fb5b44e6fa7$export$74bf444e3cd11ea5 = $a5ec9fb5b44e6fa7$var$p;
$a5ec9fb5b44e6fa7$export$92387174baf9b227 = function(a) {
    return $a5ec9fb5b44e6fa7$var$A(a) || $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$l;
};
$a5ec9fb5b44e6fa7$export$ec112efeb987d9c6 = $a5ec9fb5b44e6fa7$var$A;
$a5ec9fb5b44e6fa7$export$b706b080d889d2c9 = function(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$k;
};
$a5ec9fb5b44e6fa7$export$5be5a87408f70ddc = function(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$h;
};
$a5ec9fb5b44e6fa7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a5ec9fb5b44e6fa7$var$c;
};
$a5ec9fb5b44e6fa7$export$455c2e768291efa6 = function(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$n;
};
$a5ec9fb5b44e6fa7$export$9522e17588c12572 = function(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$e;
};
$a5ec9fb5b44e6fa7$export$2110ac352bb060b9 = function(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$t;
};
$a5ec9fb5b44e6fa7$export$56885ab8b9c456ab = function(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$r;
};
$a5ec9fb5b44e6fa7$export$d927fcb6adf8f9de = function(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$d;
};
$a5ec9fb5b44e6fa7$export$b82d16f27459e05a = function(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$g;
};
$a5ec9fb5b44e6fa7$export$522c17b4f5e123e8 = function(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$f;
};
$a5ec9fb5b44e6fa7$export$1aabd8a0274ecfd6 = function(a) {
    return $a5ec9fb5b44e6fa7$var$z(a) === $a5ec9fb5b44e6fa7$var$p;
};
$a5ec9fb5b44e6fa7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a5ec9fb5b44e6fa7$var$e || a === $a5ec9fb5b44e6fa7$var$m || a === $a5ec9fb5b44e6fa7$var$g || a === $a5ec9fb5b44e6fa7$var$f || a === $a5ec9fb5b44e6fa7$var$p || a === $a5ec9fb5b44e6fa7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a5ec9fb5b44e6fa7$var$t || a.$$typeof === $a5ec9fb5b44e6fa7$var$r || a.$$typeof === $a5ec9fb5b44e6fa7$var$h || a.$$typeof === $a5ec9fb5b44e6fa7$var$k || a.$$typeof === $a5ec9fb5b44e6fa7$var$n || a.$$typeof === $a5ec9fb5b44e6fa7$var$w || a.$$typeof === $a5ec9fb5b44e6fa7$var$x || a.$$typeof === $a5ec9fb5b44e6fa7$var$y || a.$$typeof === $a5ec9fb5b44e6fa7$var$v);
};
$a5ec9fb5b44e6fa7$export$f5bbd400c2f4426f = $a5ec9fb5b44e6fa7$var$z;

});

parcelRegister("jtAZT", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $e2dd6ca73773b9a6$export$a143d493d941bafc; }, function (v) { return $e2dd6ca73773b9a6$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $e2dd6ca73773b9a6$export$e4cf37d7f6fb9e0a; }, function (v) { return $e2dd6ca73773b9a6$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $e2dd6ca73773b9a6$export$f99ded8fe4b79145; }, function (v) { return $e2dd6ca73773b9a6$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $e2dd6ca73773b9a6$export$599f31c3813fae4d; }, function (v) { return $e2dd6ca73773b9a6$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e2dd6ca73773b9a6$export$a143d493d941bafc;
var $e2dd6ca73773b9a6$export$e4cf37d7f6fb9e0a;
var $e2dd6ca73773b9a6$export$f99ded8fe4b79145;
var $e2dd6ca73773b9a6$export$599f31c3813fae4d;
"use strict";

var $gxC2H = parcelRequire("gxC2H");

var $8YfQz = parcelRequire("8YfQz");
var $e2dd6ca73773b9a6$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$e2dd6ca73773b9a6$export$a143d493d941bafc = $e2dd6ca73773b9a6$var$Buffer;
$e2dd6ca73773b9a6$export$e4cf37d7f6fb9e0a = $e2dd6ca73773b9a6$var$SlowBuffer;
$e2dd6ca73773b9a6$export$f99ded8fe4b79145 = 50;
var $e2dd6ca73773b9a6$var$K_MAX_LENGTH = 0x7fffffff;
$e2dd6ca73773b9a6$export$599f31c3813fae4d = $e2dd6ca73773b9a6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e2dd6ca73773b9a6$var$Buffer.TYPED_ARRAY_SUPPORT = $e2dd6ca73773b9a6$var$typedArraySupport();
if (!$e2dd6ca73773b9a6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e2dd6ca73773b9a6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e2dd6ca73773b9a6$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e2dd6ca73773b9a6$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e2dd6ca73773b9a6$var$createBuffer(length) {
    if (length > $e2dd6ca73773b9a6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e2dd6ca73773b9a6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e2dd6ca73773b9a6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e2dd6ca73773b9a6$var$allocUnsafe(arg);
    }
    return $e2dd6ca73773b9a6$var$from(arg, encodingOrOffset, length);
}
$e2dd6ca73773b9a6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e2dd6ca73773b9a6$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $e2dd6ca73773b9a6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e2dd6ca73773b9a6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e2dd6ca73773b9a6$var$isInstance(value, ArrayBuffer) || value && $e2dd6ca73773b9a6$var$isInstance(value.buffer, ArrayBuffer)) return $e2dd6ca73773b9a6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($e2dd6ca73773b9a6$var$isInstance(value, SharedArrayBuffer) || value && $e2dd6ca73773b9a6$var$isInstance(value.buffer, SharedArrayBuffer))) return $e2dd6ca73773b9a6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e2dd6ca73773b9a6$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $e2dd6ca73773b9a6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $e2dd6ca73773b9a6$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e2dd6ca73773b9a6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e2dd6ca73773b9a6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e2dd6ca73773b9a6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e2dd6ca73773b9a6$var$Buffer, Uint8Array);
function $e2dd6ca73773b9a6$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e2dd6ca73773b9a6$var$alloc(size, fill, encoding) {
    $e2dd6ca73773b9a6$var$assertSize(size);
    if (size <= 0) return $e2dd6ca73773b9a6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $e2dd6ca73773b9a6$var$createBuffer(size).fill(fill, encoding) : $e2dd6ca73773b9a6$var$createBuffer(size).fill(fill);
    return $e2dd6ca73773b9a6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e2dd6ca73773b9a6$var$Buffer.alloc = function(size, fill, encoding) {
    return $e2dd6ca73773b9a6$var$alloc(size, fill, encoding);
};
function $e2dd6ca73773b9a6$var$allocUnsafe(size) {
    $e2dd6ca73773b9a6$var$assertSize(size);
    return $e2dd6ca73773b9a6$var$createBuffer(size < 0 ? 0 : $e2dd6ca73773b9a6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e2dd6ca73773b9a6$var$Buffer.allocUnsafe = function(size) {
    return $e2dd6ca73773b9a6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e2dd6ca73773b9a6$var$Buffer.allocUnsafeSlow = function(size) {
    return $e2dd6ca73773b9a6$var$allocUnsafe(size);
};
function $e2dd6ca73773b9a6$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$e2dd6ca73773b9a6$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $e2dd6ca73773b9a6$var$byteLength(string, encoding) | 0;
    var buf = $e2dd6ca73773b9a6$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e2dd6ca73773b9a6$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $e2dd6ca73773b9a6$var$checked(array.length) | 0;
    var buf = $e2dd6ca73773b9a6$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e2dd6ca73773b9a6$var$fromArrayView(arrayView) {
    if ($e2dd6ca73773b9a6$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $e2dd6ca73773b9a6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e2dd6ca73773b9a6$var$fromArrayLike(arrayView);
}
function $e2dd6ca73773b9a6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e2dd6ca73773b9a6$var$Buffer.prototype);
    return buf;
}
function $e2dd6ca73773b9a6$var$fromObject(obj) {
    if ($e2dd6ca73773b9a6$var$Buffer.isBuffer(obj)) {
        var len = $e2dd6ca73773b9a6$var$checked(obj.length) | 0;
        var buf = $e2dd6ca73773b9a6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $e2dd6ca73773b9a6$var$numberIsNaN(obj.length)) return $e2dd6ca73773b9a6$var$createBuffer(0);
        return $e2dd6ca73773b9a6$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $e2dd6ca73773b9a6$var$fromArrayLike(obj.data);
}
function $e2dd6ca73773b9a6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e2dd6ca73773b9a6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e2dd6ca73773b9a6$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $e2dd6ca73773b9a6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e2dd6ca73773b9a6$var$Buffer.alloc(+length);
}
$e2dd6ca73773b9a6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e2dd6ca73773b9a6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e2dd6ca73773b9a6$var$Buffer.compare = function compare(a, b) {
    if ($e2dd6ca73773b9a6$var$isInstance(a, Uint8Array)) a = $e2dd6ca73773b9a6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e2dd6ca73773b9a6$var$isInstance(b, Uint8Array)) b = $e2dd6ca73773b9a6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(a) || !$e2dd6ca73773b9a6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e2dd6ca73773b9a6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$e2dd6ca73773b9a6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e2dd6ca73773b9a6$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $e2dd6ca73773b9a6$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($e2dd6ca73773b9a6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $e2dd6ca73773b9a6$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e2dd6ca73773b9a6$var$byteLength(string, encoding) {
    if ($e2dd6ca73773b9a6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e2dd6ca73773b9a6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $e2dd6ca73773b9a6$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $e2dd6ca73773b9a6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e2dd6ca73773b9a6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e2dd6ca73773b9a6$var$Buffer.byteLength = $e2dd6ca73773b9a6$var$byteLength;
function $e2dd6ca73773b9a6$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $e2dd6ca73773b9a6$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $e2dd6ca73773b9a6$var$utf8Slice(this, start, end);
        case "ascii":
            return $e2dd6ca73773b9a6$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $e2dd6ca73773b9a6$var$latin1Slice(this, start, end);
        case "base64":
            return $e2dd6ca73773b9a6$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $e2dd6ca73773b9a6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e2dd6ca73773b9a6$var$Buffer.prototype._isBuffer = true;
function $e2dd6ca73773b9a6$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$e2dd6ca73773b9a6$var$swap(this, i, i + 1);
    return this;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $e2dd6ca73773b9a6$var$swap(this, i, i + 3);
        $e2dd6ca73773b9a6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $e2dd6ca73773b9a6$var$swap(this, i, i + 7);
        $e2dd6ca73773b9a6$var$swap(this, i + 1, i + 6);
        $e2dd6ca73773b9a6$var$swap(this, i + 2, i + 5);
        $e2dd6ca73773b9a6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $e2dd6ca73773b9a6$var$utf8Slice(this, 0, length);
    return $e2dd6ca73773b9a6$var$slowToString.apply(this, arguments);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.toLocaleString = $e2dd6ca73773b9a6$var$Buffer.prototype.toString;
$e2dd6ca73773b9a6$var$Buffer.prototype.equals = function equals(b) {
    if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $e2dd6ca73773b9a6$var$Buffer.compare(this, b) === 0;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $e2dd6ca73773b9a6$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($e2dd6ca73773b9a6$var$customInspectSymbol) $e2dd6ca73773b9a6$var$Buffer.prototype[$e2dd6ca73773b9a6$var$customInspectSymbol] = $e2dd6ca73773b9a6$var$Buffer.prototype.inspect;
$e2dd6ca73773b9a6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e2dd6ca73773b9a6$var$isInstance(target, Uint8Array)) target = $e2dd6ca73773b9a6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e2dd6ca73773b9a6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e2dd6ca73773b9a6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $e2dd6ca73773b9a6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e2dd6ca73773b9a6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e2dd6ca73773b9a6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e2dd6ca73773b9a6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $e2dd6ca73773b9a6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e2dd6ca73773b9a6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e2dd6ca73773b9a6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e2dd6ca73773b9a6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e2dd6ca73773b9a6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e2dd6ca73773b9a6$var$utf8Write(buf, string, offset, length) {
    return $e2dd6ca73773b9a6$var$blitBuffer($e2dd6ca73773b9a6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e2dd6ca73773b9a6$var$asciiWrite(buf, string, offset, length) {
    return $e2dd6ca73773b9a6$var$blitBuffer($e2dd6ca73773b9a6$var$asciiToBytes(string), buf, offset, length);
}
function $e2dd6ca73773b9a6$var$base64Write(buf, string, offset, length) {
    return $e2dd6ca73773b9a6$var$blitBuffer($e2dd6ca73773b9a6$var$base64ToBytes(string), buf, offset, length);
}
function $e2dd6ca73773b9a6$var$ucs2Write(buf, string, offset, length) {
    return $e2dd6ca73773b9a6$var$blitBuffer($e2dd6ca73773b9a6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e2dd6ca73773b9a6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $e2dd6ca73773b9a6$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $e2dd6ca73773b9a6$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $e2dd6ca73773b9a6$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $e2dd6ca73773b9a6$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $e2dd6ca73773b9a6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e2dd6ca73773b9a6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e2dd6ca73773b9a6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gxC2H.fromByteArray(buf);
    else return $gxC2H.fromByteArray(buf.slice(start, end));
}
function $e2dd6ca73773b9a6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e2dd6ca73773b9a6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $e2dd6ca73773b9a6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e2dd6ca73773b9a6$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $e2dd6ca73773b9a6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e2dd6ca73773b9a6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e2dd6ca73773b9a6$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e2dd6ca73773b9a6$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e2dd6ca73773b9a6$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $e2dd6ca73773b9a6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e2dd6ca73773b9a6$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e2dd6ca73773b9a6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e2dd6ca73773b9a6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$e2dd6ca73773b9a6$var$Buffer.prototype.readUintLE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUintBE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUint8 = $e2dd6ca73773b9a6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUint16LE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUint16BE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUint32LE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readUint32BE = $e2dd6ca73773b9a6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, true, 23, 4);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, false, 23, 4);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, true, 52, 8);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, false, 52, 8);
};
function $e2dd6ca73773b9a6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUintLE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e2dd6ca73773b9a6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUintBE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e2dd6ca73773b9a6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUint8 = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUint16LE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUint16BE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUint32LE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeUint32BE = $e2dd6ca73773b9a6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e2dd6ca73773b9a6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $e2dd6ca73773b9a6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e2dd6ca73773b9a6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $e2dd6ca73773b9a6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e2dd6ca73773b9a6$var$writeFloat(this, value, offset, true, noAssert);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e2dd6ca73773b9a6$var$writeFloat(this, value, offset, false, noAssert);
};
function $e2dd6ca73773b9a6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e2dd6ca73773b9a6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e2dd6ca73773b9a6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e2dd6ca73773b9a6$var$writeDouble(this, value, offset, true, noAssert);
};
$e2dd6ca73773b9a6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e2dd6ca73773b9a6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e2dd6ca73773b9a6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e2dd6ca73773b9a6$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e2dd6ca73773b9a6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$e2dd6ca73773b9a6$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $e2dd6ca73773b9a6$var$Buffer.isBuffer(val) ? val : $e2dd6ca73773b9a6$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $e2dd6ca73773b9a6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e2dd6ca73773b9a6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e2dd6ca73773b9a6$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $e2dd6ca73773b9a6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $e2dd6ca73773b9a6$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e2dd6ca73773b9a6$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e2dd6ca73773b9a6$var$base64ToBytes(str) {
    return $gxC2H.toByteArray($e2dd6ca73773b9a6$var$base64clean(str));
}
function $e2dd6ca73773b9a6$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e2dd6ca73773b9a6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e2dd6ca73773b9a6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $e2dd6ca73773b9a6$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("gxC2H", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $c0ad3cdf54feed88$export$d622b2ad8d90c771; }, function (v) { return $c0ad3cdf54feed88$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $c0ad3cdf54feed88$export$6100ba28696e12de; }, function (v) { return $c0ad3cdf54feed88$export$6100ba28696e12de = v; });
var $c0ad3cdf54feed88$export$a48f0734ac7c2329;
var $c0ad3cdf54feed88$export$d622b2ad8d90c771;
var $c0ad3cdf54feed88$export$6100ba28696e12de;
"use strict";
$c0ad3cdf54feed88$export$a48f0734ac7c2329 = $c0ad3cdf54feed88$var$byteLength;
$c0ad3cdf54feed88$export$d622b2ad8d90c771 = $c0ad3cdf54feed88$var$toByteArray;
$c0ad3cdf54feed88$export$6100ba28696e12de = $c0ad3cdf54feed88$var$fromByteArray;
var $c0ad3cdf54feed88$var$lookup = [];
var $c0ad3cdf54feed88$var$revLookup = [];
var $c0ad3cdf54feed88$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $c0ad3cdf54feed88$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $c0ad3cdf54feed88$var$i = 0, $c0ad3cdf54feed88$var$len = $c0ad3cdf54feed88$var$code.length; $c0ad3cdf54feed88$var$i < $c0ad3cdf54feed88$var$len; ++$c0ad3cdf54feed88$var$i){
    $c0ad3cdf54feed88$var$lookup[$c0ad3cdf54feed88$var$i] = $c0ad3cdf54feed88$var$code[$c0ad3cdf54feed88$var$i];
    $c0ad3cdf54feed88$var$revLookup[$c0ad3cdf54feed88$var$code.charCodeAt($c0ad3cdf54feed88$var$i)] = $c0ad3cdf54feed88$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$c0ad3cdf54feed88$var$revLookup["-".charCodeAt(0)] = 62;
$c0ad3cdf54feed88$var$revLookup["_".charCodeAt(0)] = 63;
function $c0ad3cdf54feed88$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $c0ad3cdf54feed88$var$byteLength(b64) {
    var lens = $c0ad3cdf54feed88$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c0ad3cdf54feed88$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c0ad3cdf54feed88$var$toByteArray(b64) {
    var tmp;
    var lens = $c0ad3cdf54feed88$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $c0ad3cdf54feed88$var$Arr($c0ad3cdf54feed88$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i)] << 18 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i)] << 2 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i)] << 10 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $c0ad3cdf54feed88$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $c0ad3cdf54feed88$var$tripletToBase64(num) {
    return $c0ad3cdf54feed88$var$lookup[num >> 18 & 0x3F] + $c0ad3cdf54feed88$var$lookup[num >> 12 & 0x3F] + $c0ad3cdf54feed88$var$lookup[num >> 6 & 0x3F] + $c0ad3cdf54feed88$var$lookup[num & 0x3F];
}
function $c0ad3cdf54feed88$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($c0ad3cdf54feed88$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $c0ad3cdf54feed88$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($c0ad3cdf54feed88$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($c0ad3cdf54feed88$var$lookup[tmp >> 2] + $c0ad3cdf54feed88$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($c0ad3cdf54feed88$var$lookup[tmp >> 10] + $c0ad3cdf54feed88$var$lookup[tmp >> 4 & 0x3F] + $c0ad3cdf54feed88$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("8YfQz", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $68803832b4b2ccb4$export$aafa59e2e03f2942; }, function (v) { return $68803832b4b2ccb4$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $68803832b4b2ccb4$export$68d8715fc104d294; }, function (v) { return $68803832b4b2ccb4$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $68803832b4b2ccb4$export$aafa59e2e03f2942;
var $68803832b4b2ccb4$export$68d8715fc104d294;
$68803832b4b2ccb4$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$68803832b4b2ccb4$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("cahqm", function(module, exports) {

$parcel$export(module.exports, "BaseError", function () { return $8db3ef46c918dfbd$export$a490eb03cb7a0a5e; });

var $cpUWL = parcelRequire("cpUWL");
let $8db3ef46c918dfbd$var$errorConfig = {
    getDocsUrl: ({ docsBaseUrl: docsBaseUrl, docsPath: docsPath = "", docsSlug: docsSlug })=>docsPath ? `${docsBaseUrl ?? "https://viem.sh"}${docsPath}${docsSlug ? `#${docsSlug}` : ""}` : undefined,
    version: `viem@${(0, $cpUWL.version)}`
};
function $8db3ef46c918dfbd$export$4ac109df0c5244e9(config) {
    $8db3ef46c918dfbd$var$errorConfig = config;
}
class $8db3ef46c918dfbd$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = (()=>{
            if (args.cause instanceof $8db3ef46c918dfbd$export$a490eb03cb7a0a5e) return args.cause.details;
            if (args.cause?.message) return args.cause.message;
            return args.details;
        })();
        const docsPath = (()=>{
            if (args.cause instanceof $8db3ef46c918dfbd$export$a490eb03cb7a0a5e) return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        })();
        const docsUrl = $8db3ef46c918dfbd$var$errorConfig.getDocsUrl?.({
            ...args,
            docsPath: docsPath
        });
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsUrl ? [
                `Docs: ${docsUrl}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            ...$8db3ef46c918dfbd$var$errorConfig.version ? [
                `Version: ${$8db3ef46c918dfbd$var$errorConfig.version}`
            ] : []
        ].join("\n");
        super(message, args.cause ? {
            cause: args.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseError"
        });
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.name = args.name ?? this.name;
        this.shortMessage = shortMessage;
        this.version = (0, $cpUWL.version);
    }
    walk(fn) {
        return $8db3ef46c918dfbd$var$walk(this, fn);
    }
}
function $8db3ef46c918dfbd$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err && err.cause !== undefined) return $8db3ef46c918dfbd$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("cpUWL", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $90a3fe4cdec49ef1$export$83d89fbfd8236492; });
const $90a3fe4cdec49ef1$export$83d89fbfd8236492 = "2.23.2";

});


parcelRegister("16Qvp", function(module, exports) {

$parcel$export(module.exports, "isHex", function () { return $0cef147d0767fdc4$export$8a9b6341a7c96bc; });
function $0cef147d0767fdc4$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});

parcelRegister("f1Ntt", function(module, exports) {

$parcel$export(module.exports, "decodeErrorResult", function () { return $af0d5399e2105914$export$8f7898b7bcae6080; });

var $4a4RY = parcelRequire("4a4RY");

var $8p1we = parcelRequire("8p1we");

var $fdb51 = parcelRequire("fdb51");

var $9BbzE = parcelRequire("9BbzE");

var $hCHkb = parcelRequire("hCHkb");

var $c3VTt = parcelRequire("c3VTt");
function $af0d5399e2105914$export$8f7898b7bcae6080(parameters) {
    const { abi: abi, data: data } = parameters;
    const signature = (0, $fdb51.slice)(data, 0, 4);
    if (signature === "0x") throw new (0, $8p1we.AbiDecodingZeroDataError)();
    const abi_ = [
        ...abi || [],
        (0, $4a4RY.solidityError),
        (0, $4a4RY.solidityPanic)
    ];
    const abiItem = abi_.find((x)=>x.type === "error" && signature === (0, $9BbzE.toFunctionSelector)((0, $c3VTt.formatAbiItem)(x)));
    if (!abiItem) throw new (0, $8p1we.AbiErrorSignatureNotFoundError)(signature, {
        docsPath: "/docs/contract/decodeErrorResult"
    });
    return {
        abiItem: abiItem,
        args: "inputs" in abiItem && abiItem.inputs && abiItem.inputs.length > 0 ? (0, $hCHkb.decodeAbiParameters)(abiItem.inputs, (0, $fdb51.slice)(data, 4)) : undefined,
        errorName: abiItem.name
    };
}

});
parcelRegister("4a4RY", function(module, exports) {

$parcel$export(module.exports, "panicReasons", function () { return $307bdf9b0ff7fe1a$export$a618024566d3d221; });
$parcel$export(module.exports, "solidityError", function () { return $307bdf9b0ff7fe1a$export$730e9cc7aaa8ca20; });
$parcel$export(module.exports, "solidityPanic", function () { return $307bdf9b0ff7fe1a$export$e45b3aea1c5b33e6; });
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
const $307bdf9b0ff7fe1a$export$a618024566d3d221 = {
    1: "An `assert` condition failed.",
    17: "Arithmetic operation resulted in underflow or overflow.",
    18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
    33: "Attempted to convert to an invalid type.",
    34: "Attempted to access a storage byte array that is incorrectly encoded.",
    49: "Performed `.pop()` on an empty array",
    50: "Array index is out of bounds.",
    65: "Allocated too much memory or created an array which is too large.",
    81: "Attempted to call a zero-initialized variable of internal function type."
};
const $307bdf9b0ff7fe1a$export$730e9cc7aaa8ca20 = {
    inputs: [
        {
            name: "message",
            type: "string"
        }
    ],
    name: "Error",
    type: "error"
};
const $307bdf9b0ff7fe1a$export$e45b3aea1c5b33e6 = {
    inputs: [
        {
            name: "reason",
            type: "uint256"
        }
    ],
    name: "Panic",
    type: "error"
};

});

parcelRegister("8p1we", function(module, exports) {

$parcel$export(module.exports, "AbiConstructorNotFoundError", function () { return $61e1d622eb9e0933$export$efa723f306cf6168; });
$parcel$export(module.exports, "AbiConstructorParamsNotFoundError", function () { return $61e1d622eb9e0933$export$4faec14323ef9c47; });
$parcel$export(module.exports, "AbiDecodingDataSizeTooSmallError", function () { return $61e1d622eb9e0933$export$7a409e433c5f3a8c; });
$parcel$export(module.exports, "AbiDecodingZeroDataError", function () { return $61e1d622eb9e0933$export$a063cde4013f1935; });
$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", function () { return $61e1d622eb9e0933$export$a851da9bf50b557; });
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", function () { return $61e1d622eb9e0933$export$19c281dc8e23a2ea; });
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", function () { return $61e1d622eb9e0933$export$20737d495bb13c2d; });
$parcel$export(module.exports, "AbiErrorSignatureNotFoundError", function () { return $61e1d622eb9e0933$export$8959cb729fefe1ea; });
$parcel$export(module.exports, "AbiEventSignatureEmptyTopicsError", function () { return $61e1d622eb9e0933$export$f83210ce5f9b901f; });
$parcel$export(module.exports, "AbiEventSignatureNotFoundError", function () { return $61e1d622eb9e0933$export$3b44baeac92e4d3a; });
$parcel$export(module.exports, "AbiEventNotFoundError", function () { return $61e1d622eb9e0933$export$c7be62baad13b157; });
$parcel$export(module.exports, "AbiFunctionNotFoundError", function () { return $61e1d622eb9e0933$export$c4faa308ea7f9b2; });
$parcel$export(module.exports, "AbiFunctionOutputsNotFoundError", function () { return $61e1d622eb9e0933$export$26f2edb605108b34; });
$parcel$export(module.exports, "AbiItemAmbiguityError", function () { return $61e1d622eb9e0933$export$fdbba54ba15f2c2d; });
$parcel$export(module.exports, "BytesSizeMismatchError", function () { return $61e1d622eb9e0933$export$a0eb884ede5c87eb; });
$parcel$export(module.exports, "DecodeLogDataMismatch", function () { return $61e1d622eb9e0933$export$3978f86c08fc8c25; });
$parcel$export(module.exports, "DecodeLogTopicsMismatch", function () { return $61e1d622eb9e0933$export$6d7c6f419cf52377; });
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", function () { return $61e1d622eb9e0933$export$53ed98b886965f49; });
$parcel$export(module.exports, "InvalidAbiDecodingTypeError", function () { return $61e1d622eb9e0933$export$cf94ccff0ff97c65; });
$parcel$export(module.exports, "InvalidArrayError", function () { return $61e1d622eb9e0933$export$710dd6d4f78cc47e; });
$parcel$export(module.exports, "InvalidDefinitionTypeError", function () { return $61e1d622eb9e0933$export$81781a0fcfb9ed95; });

var $c3VTt = parcelRequire("c3VTt");

var $lsLGO = parcelRequire("lsLGO");

var $cahqm = parcelRequire("cahqm");
class $61e1d622eb9e0933$export$efa723f306cf6168 extends (0, $cahqm.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "A constructor was not found on the ABI.",
            "Make sure you are using the correct ABI and that the constructor exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorNotFoundError"
        });
    }
}
class $61e1d622eb9e0933$export$4faec14323ef9c47 extends (0, $cahqm.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
            "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorParamsNotFoundError"
        });
    }
}
class $61e1d622eb9e0933$export$68a7b570091cba69 extends (0, $cahqm.BaseError) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            "Size must be in increments of 32 bytes (size % 32 === 0)."
        ].join("\n"), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeInvalidError"
        });
    }
}
class $61e1d622eb9e0933$export$7a409e433c5f3a8c extends (0, $cahqm.BaseError) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $c3VTt.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeTooSmallError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $61e1d622eb9e0933$export$a063cde4013f1935 extends (0, $cahqm.BaseError) {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.', {
            name: "AbiDecodingZeroDataError"
        });
    }
}
class $61e1d622eb9e0933$export$a851da9bf50b557 extends (0, $cahqm.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingArrayLengthMismatchError"
        });
    }
}
class $61e1d622eb9e0933$export$19c281dc8e23a2ea extends (0, $cahqm.BaseError) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $lsLGO.size)(value)}) does not match expected size (bytes${expectedSize}).`, {
            name: "AbiEncodingBytesSizeMismatchError"
        });
    }
}
class $61e1d622eb9e0933$export$20737d495bb13c2d extends (0, $cahqm.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            "ABI encoding params/values length mismatch.",
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingLengthMismatchError"
        });
    }
}
class $61e1d622eb9e0933$export$d47cf5ef47eda817 extends (0, $cahqm.BaseError) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            "Cannot encode error result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the inputs exist on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorInputsNotFoundError"
        });
    }
}
class $61e1d622eb9e0933$export$86b719574b683f04 extends (0, $cahqm.BaseError) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorNotFoundError"
        });
    }
}
class $61e1d622eb9e0933$export$8959cb729fefe1ea extends (0, $cahqm.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it.",
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorSignatureNotFoundError"
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $61e1d622eb9e0933$export$f83210ce5f9b901f extends (0, $cahqm.BaseError) {
    constructor({ docsPath: docsPath }){
        super("Cannot extract event signature from empty topics.", {
            docsPath: docsPath,
            name: "AbiEventSignatureEmptyTopicsError"
        });
    }
}
class $61e1d622eb9e0933$export$3b44baeac92e4d3a extends (0, $cahqm.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventSignatureNotFoundError"
        });
    }
}
class $61e1d622eb9e0933$export$c7be62baad13b157 extends (0, $cahqm.BaseError) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventNotFoundError"
        });
    }
}
class $61e1d622eb9e0933$export$c4faa308ea7f9b2 extends (0, $cahqm.BaseError) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionNotFoundError"
        });
    }
}
class $61e1d622eb9e0933$export$26f2edb605108b34 extends (0, $cahqm.BaseError) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            "Cannot decode function result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionOutputsNotFoundError"
        });
    }
}
class $61e1d622eb9e0933$export$14373147a0e60810 extends (0, $cahqm.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionSignatureNotFoundError"
        });
    }
}
class $61e1d622eb9e0933$export$fdbba54ba15f2c2d extends (0, $cahqm.BaseError) {
    constructor(x, y){
        super("Found ambiguous types in overloaded ABI items.", {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $c3VTt.formatAbiItem)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $c3VTt.formatAbiItem)(y.abiItem)}\``,
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ],
            name: "AbiItemAmbiguityError"
        });
    }
}
class $61e1d622eb9e0933$export$a0eb884ede5c87eb extends (0, $cahqm.BaseError) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`, {
            name: "BytesSizeMismatchError"
        });
    }
}
class $61e1d622eb9e0933$export$3978f86c08fc8c25 extends (0, $cahqm.BaseError) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $c3VTt.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "DecodeLogDataMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $61e1d622eb9e0933$export$6d7c6f419cf52377 extends (0, $cahqm.BaseError) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ""} on event "${(0, $c3VTt.formatAbiItem)(abiItem, {
                includeName: true
            })}".`
        ].join("\n"), {
            name: "DecodeLogTopicsMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $61e1d622eb9e0933$export$53ed98b886965f49 extends (0, $cahqm.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiEncodingType"
        });
    }
}
class $61e1d622eb9e0933$export$cf94ccff0ff97c65 extends (0, $cahqm.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiDecodingType"
        });
    }
}
class $61e1d622eb9e0933$export$710dd6d4f78cc47e extends (0, $cahqm.BaseError) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join("\n"), {
            name: "InvalidArrayError"
        });
    }
}
class $61e1d622eb9e0933$export$81781a0fcfb9ed95 extends (0, $cahqm.BaseError) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join("\n"), {
            name: "InvalidDefinitionTypeError"
        });
    }
}
class $61e1d622eb9e0933$export$a16541e2fe420ef1 extends (0, $cahqm.BaseError) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`, {
            name: "UnsupportedPackedAbiType"
        });
    }
}

});
parcelRegister("c3VTt", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $8c82ac5be1721038$export$dc5d0ff4fc2fdee1; });
$parcel$export(module.exports, "formatAbiParams", function () { return $8c82ac5be1721038$export$849e499971de75b3; });

var $8p1we = parcelRequire("8p1we");
function $8c82ac5be1721038$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error") throw new (0, $8p1we.InvalidDefinitionTypeError)(abiItem.type);
    return `${abiItem.name}(${$8c82ac5be1721038$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $8c82ac5be1721038$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return "";
    return params.map((param)=>$8c82ac5be1721038$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ", " : ",");
}
function $8c82ac5be1721038$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith("tuple")) return `(${$8c82ac5be1721038$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : "");
}

});

parcelRegister("lsLGO", function(module, exports) {

$parcel$export(module.exports, "size", function () { return $fa01349e8044db86$export$346677f925de839c; });

var $16Qvp = parcelRequire("16Qvp");
function $fa01349e8044db86$export$346677f925de839c(value) {
    if ((0, $16Qvp.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});


parcelRegister("fdb51", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $b130aa2959f69e65$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "sliceHex", function () { return $b130aa2959f69e65$export$728fe14c970402fe; });
$parcel$export(module.exports, "sliceBytes", function () { return $b130aa2959f69e65$export$8bac03c8c1da551; });

var $8piNh = parcelRequire("8piNh");

var $16Qvp = parcelRequire("16Qvp");

var $lsLGO = parcelRequire("lsLGO");
function $b130aa2959f69e65$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $16Qvp.isHex)(value, {
        strict: false
    })) return $b130aa2959f69e65$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $b130aa2959f69e65$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $b130aa2959f69e65$var$assertStartOffset(value, start) {
    if (typeof start === "number" && start > 0 && start > (0, $lsLGO.size)(value) - 1) throw new (0, $8piNh.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: "start",
        size: (0, $lsLGO.size)(value)
    });
}
function $b130aa2959f69e65$var$assertEndOffset(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && (0, $lsLGO.size)(value) !== end - start) throw new (0, $8piNh.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: "end",
        size: (0, $lsLGO.size)(value)
    });
}
function $b130aa2959f69e65$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $b130aa2959f69e65$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $b130aa2959f69e65$var$assertEndOffset(value, start, end);
    return value;
}
function $b130aa2959f69e65$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $b130aa2959f69e65$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $b130aa2959f69e65$var$assertEndOffset(value, start, end);
    return value;
}

});
parcelRegister("8piNh", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", function () { return $61ef3c9b5ef50b4a$export$cfcd41bba8b36dbd; });
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", function () { return $61ef3c9b5ef50b4a$export$70445dc308a7f3d5; });
$parcel$export(module.exports, "InvalidBytesLengthError", function () { return $61ef3c9b5ef50b4a$export$8a5469becf223114; });

var $cahqm = parcelRequire("cahqm");
class $61ef3c9b5ef50b4a$export$cfcd41bba8b36dbd extends (0, $cahqm.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`, {
            name: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $61ef3c9b5ef50b4a$export$70445dc308a7f3d5 extends (0, $cahqm.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`, {
            name: "SizeExceedsPaddingSizeError"
        });
    }
}
class $61ef3c9b5ef50b4a$export$8a5469becf223114 extends (0, $cahqm.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`, {
            name: "InvalidBytesLengthError"
        });
    }
}

});


parcelRegister("9BbzE", function(module, exports) {

$parcel$export(module.exports, "toFunctionSelector", function () { return $01cdafadfa6a8c71$export$e2442488533809cb; });

var $fdb51 = parcelRequire("fdb51");

var $brzgk = parcelRequire("brzgk");
const $01cdafadfa6a8c71$export$e2442488533809cb = (fn)=>(0, $fdb51.slice)((0, $brzgk.toSignatureHash)(fn), 0, 4);

});
parcelRegister("brzgk", function(module, exports) {

$parcel$export(module.exports, "toSignatureHash", function () { return $854d91af20bcc8fa$export$d809beebc9c913db; });

var $auPd7 = parcelRequire("auPd7");

var $bI3Po = parcelRequire("bI3Po");
function $854d91af20bcc8fa$export$d809beebc9c913db(fn) {
    return (0, $auPd7.hashSignature)((0, $bI3Po.toSignature)(fn));
}

});
parcelRegister("auPd7", function(module, exports) {

$parcel$export(module.exports, "hashSignature", function () { return $7a446e11055a9f92$export$77bbcd7aaec17976; });

var $cY7Yq = parcelRequire("cY7Yq");

var $diQni = parcelRequire("diQni");
const $7a446e11055a9f92$var$hash = (value)=>(0, $diQni.keccak256)((0, $cY7Yq.toBytes)(value));
function $7a446e11055a9f92$export$77bbcd7aaec17976(sig) {
    return $7a446e11055a9f92$var$hash(sig);
}

});
parcelRegister("cY7Yq", function(module, exports) {

$parcel$export(module.exports, "toBytes", function () { return $97114608ba6fcb0a$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "hexToBytes", function () { return $97114608ba6fcb0a$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "stringToBytes", function () { return $97114608ba6fcb0a$export$c8dd6bc66a63753c; });

var $cahqm = parcelRequire("cahqm");

var $16Qvp = parcelRequire("16Qvp");

var $iPnWm = parcelRequire("iPnWm");

var $9GGVO = parcelRequire("9GGVO");

var $jW8ut = parcelRequire("jW8ut");
const $97114608ba6fcb0a$var$encoder = /*#__PURE__*/ new TextEncoder();
function $97114608ba6fcb0a$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $97114608ba6fcb0a$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $97114608ba6fcb0a$export$771517697a68241(value, opts);
    if ((0, $16Qvp.isHex)(value)) return $97114608ba6fcb0a$export$31c96b9df38bc8d4(value, opts);
    return $97114608ba6fcb0a$export$c8dd6bc66a63753c(value, opts);
}
function $97114608ba6fcb0a$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $9GGVO.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $iPnWm.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $97114608ba6fcb0a$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $97114608ba6fcb0a$var$charCodeToBase16(char) {
    if (char >= $97114608ba6fcb0a$var$charCodeMap.zero && char <= $97114608ba6fcb0a$var$charCodeMap.nine) return char - $97114608ba6fcb0a$var$charCodeMap.zero;
    if (char >= $97114608ba6fcb0a$var$charCodeMap.A && char <= $97114608ba6fcb0a$var$charCodeMap.F) return char - ($97114608ba6fcb0a$var$charCodeMap.A - 10);
    if (char >= $97114608ba6fcb0a$var$charCodeMap.a && char <= $97114608ba6fcb0a$var$charCodeMap.f) return char - ($97114608ba6fcb0a$var$charCodeMap.a - 10);
    return undefined;
}
function $97114608ba6fcb0a$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $9GGVO.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $iPnWm.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $97114608ba6fcb0a$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $97114608ba6fcb0a$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $cahqm.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $97114608ba6fcb0a$export$49ad9be85c347998(value, opts) {
    const hex = (0, $jW8ut.numberToHex)(value, opts);
    return $97114608ba6fcb0a$export$31c96b9df38bc8d4(hex);
}
function $97114608ba6fcb0a$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $97114608ba6fcb0a$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $9GGVO.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $iPnWm.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("iPnWm", function(module, exports) {

$parcel$export(module.exports, "pad", function () { return $db4f8f781a7b86f8$export$5d04458e2a6c373e; });
$parcel$export(module.exports, "padHex", function () { return $db4f8f781a7b86f8$export$1bcd51c0fce8ee55; });

var $8piNh = parcelRequire("8piNh");
function $db4f8f781a7b86f8$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $db4f8f781a7b86f8$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $db4f8f781a7b86f8$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $db4f8f781a7b86f8$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $8piNh.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $db4f8f781a7b86f8$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $8piNh.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});

parcelRegister("9GGVO", function(module, exports) {

$parcel$export(module.exports, "assertSize", function () { return $70d95698695791c0$export$2af489edb7fa35fe; });
$parcel$export(module.exports, "hexToNumber", function () { return $70d95698695791c0$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBigInt", function () { return $70d95698695791c0$export$92a44656ec81b584; });
$parcel$export(module.exports, "hexToString", function () { return $70d95698695791c0$export$f4bc7e46f3eb3ac3; });
$parcel$export(module.exports, "hexToBool", function () { return $70d95698695791c0$export$bde1d77e6fe6c41e; });

var $8PKwo = parcelRequire("8PKwo");

var $lsLGO = parcelRequire("lsLGO");

var $geW6W = parcelRequire("geW6W");

var $cY7Yq = parcelRequire("cY7Yq");
function $70d95698695791c0$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $lsLGO.size)(hexOrBytes) > size) throw new (0, $8PKwo.SizeOverflowError)({
        givenSize: (0, $lsLGO.size)(hexOrBytes),
        maxSize: size
    });
}
function $70d95698695791c0$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $70d95698695791c0$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $70d95698695791c0$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $70d95698695791c0$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $70d95698695791c0$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $cY7Yq.hexToBytes)(hex, opts);
}
function $70d95698695791c0$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $70d95698695791c0$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $70d95698695791c0$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $70d95698695791c0$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $geW6W.trim)(hex);
    }
    if ((0, $geW6W.trim)(hex) === "0x00") return false;
    if ((0, $geW6W.trim)(hex) === "0x01") return true;
    throw new (0, $8PKwo.InvalidHexBooleanError)(hex);
}
function $70d95698695791c0$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($70d95698695791c0$export$92a44656ec81b584(hex, opts));
}
function $70d95698695791c0$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $cY7Yq.hexToBytes)(hex);
    if (opts.size) {
        $70d95698695791c0$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $geW6W.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("8PKwo", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", function () { return $66e72c594f605dd9$export$47d164a8071229a9; });
$parcel$export(module.exports, "InvalidBytesBooleanError", function () { return $66e72c594f605dd9$export$52fc62e5266c8838; });
$parcel$export(module.exports, "InvalidHexBooleanError", function () { return $66e72c594f605dd9$export$f574ac54e35514c; });
$parcel$export(module.exports, "SizeOverflowError", function () { return $66e72c594f605dd9$export$beb44ed4f8747d0e; });

var $cahqm = parcelRequire("cahqm");
class $66e72c594f605dd9$export$47d164a8071229a9 extends (0, $cahqm.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, {
            name: "IntegerOutOfRangeError"
        });
    }
}
class $66e72c594f605dd9$export$52fc62e5266c8838 extends (0, $cahqm.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
            name: "InvalidBytesBooleanError"
        });
    }
}
class $66e72c594f605dd9$export$f574ac54e35514c extends (0, $cahqm.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, {
            name: "InvalidHexBooleanError"
        });
    }
}
class $66e72c594f605dd9$export$ef05eafd11dd4a83 extends (0, $cahqm.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`, {
            name: "InvalidHexValueError"
        });
    }
}
class $66e72c594f605dd9$export$beb44ed4f8747d0e extends (0, $cahqm.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, {
            name: "SizeOverflowError"
        });
    }
}

});

parcelRegister("geW6W", function(module, exports) {

$parcel$export(module.exports, "trim", function () { return $bd2b07cb5af1961f$export$87c2784dc9fc4ab; });
function $bd2b07cb5af1961f$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});


parcelRegister("jW8ut", function(module, exports) {

$parcel$export(module.exports, "toHex", function () { return $03bedf0cf581c468$export$7ea66e3774a60b67; });
$parcel$export(module.exports, "numberToHex", function () { return $03bedf0cf581c468$export$4e87185b7ecfeec4; });
$parcel$export(module.exports, "stringToHex", function () { return $03bedf0cf581c468$export$551c48dea6f88e6d; });
$parcel$export(module.exports, "boolToHex", function () { return $03bedf0cf581c468$export$b5c95dec4f62ef7a; });
$parcel$export(module.exports, "bytesToHex", function () { return $03bedf0cf581c468$export$58b867e287a802c8; });

var $8PKwo = parcelRequire("8PKwo");

var $iPnWm = parcelRequire("iPnWm");

var $9GGVO = parcelRequire("9GGVO");
const $03bedf0cf581c468$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $03bedf0cf581c468$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $03bedf0cf581c468$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $03bedf0cf581c468$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $03bedf0cf581c468$export$b5c95dec4f62ef7a(value, opts);
    return $03bedf0cf581c468$export$58b867e287a802c8(value, opts);
}
function $03bedf0cf581c468$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $9GGVO.assertSize)(hex, {
            size: opts.size
        });
        return (0, $iPnWm.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $03bedf0cf581c468$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $03bedf0cf581c468$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $9GGVO.assertSize)(hex, {
            size: opts.size
        });
        return (0, $iPnWm.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $03bedf0cf581c468$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $8PKwo.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $iPnWm.pad)(hex, {
        size: size
    });
    return hex;
}
const $03bedf0cf581c468$var$encoder = /*#__PURE__*/ new TextEncoder();
function $03bedf0cf581c468$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $03bedf0cf581c468$var$encoder.encode(value_);
    return $03bedf0cf581c468$export$58b867e287a802c8(value, opts);
}

});


parcelRegister("diQni", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $9af5955840544004$export$f8151fce47ad1c35; });

var $dRsfY = parcelRequire("dRsfY");

var $16Qvp = parcelRequire("16Qvp");

var $cY7Yq = parcelRequire("cY7Yq");

var $jW8ut = parcelRequire("jW8ut");
function $9af5955840544004$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $dRsfY.keccak_256)((0, $16Qvp.isHex)(value, {
        strict: false
    }) ? (0, $cY7Yq.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $jW8ut.toHex)(bytes);
}

});
parcelRegister("dRsfY", function(module, exports) {

$parcel$export(module.exports, "keccak_256", function () { return $a17624cc075472ae$export$860ddaa9ca84a66d; });
/**
 * SHA3 (keccak) hash function, based on a new "Sponge function" design.
 * Different from older hashes, the internal state is bigger than output size.
 *
 * Check out [FIPS-202](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.202.pdf),
 * [Website](https://keccak.team/keccak.html),
 * [the differences between SHA-3 and Keccak](https://crypto.stackexchange.com/questions/15727/what-are-the-key-differences-between-the-draft-sha-3-standard-and-the-keccak-sub).
 *
 * Check out `sha3-addons` module for cSHAKE, k12, and others.
 * @module
 */ 
var $3k0hy = parcelRequire("3k0hy");

var $lkrgK = parcelRequire("lkrgK");

var $6ynrP = parcelRequire("6ynrP");
// Various per round constants calculations
const $a17624cc075472ae$var$SHA3_PI = [];
const $a17624cc075472ae$var$SHA3_ROTL = [];
const $a17624cc075472ae$var$_SHA3_IOTA = [];
const $a17624cc075472ae$var$_0n = /* @__PURE__ */ BigInt(0);
const $a17624cc075472ae$var$_1n = /* @__PURE__ */ BigInt(1);
const $a17624cc075472ae$var$_2n = /* @__PURE__ */ BigInt(2);
const $a17624cc075472ae$var$_7n = /* @__PURE__ */ BigInt(7);
const $a17624cc075472ae$var$_256n = /* @__PURE__ */ BigInt(256);
const $a17624cc075472ae$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $a17624cc075472ae$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $a17624cc075472ae$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $a17624cc075472ae$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $a17624cc075472ae$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $a17624cc075472ae$var$_1n ^ (R >> $a17624cc075472ae$var$_7n) * $a17624cc075472ae$var$_0x71n) % $a17624cc075472ae$var$_256n;
        if (R & $a17624cc075472ae$var$_2n) t ^= $a17624cc075472ae$var$_1n << ($a17624cc075472ae$var$_1n << /* @__PURE__ */ BigInt(j)) - $a17624cc075472ae$var$_1n;
    }
    $a17624cc075472ae$var$_SHA3_IOTA.push(t);
}
const [$a17624cc075472ae$var$SHA3_IOTA_H, $a17624cc075472ae$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $lkrgK.split)($a17624cc075472ae$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $a17624cc075472ae$var$rotlH = (h, l, s)=>s > 32 ? (0, $lkrgK.rotlBH)(h, l, s) : (0, $lkrgK.rotlSH)(h, l, s);
const $a17624cc075472ae$var$rotlL = (h, l, s)=>s > 32 ? (0, $lkrgK.rotlBL)(h, l, s) : (0, $lkrgK.rotlSL)(h, l, s);
function $a17624cc075472ae$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $a17624cc075472ae$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $a17624cc075472ae$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $a17624cc075472ae$var$SHA3_ROTL[t];
            const Th = $a17624cc075472ae$var$rotlH(curH, curL, shift);
            const Tl = $a17624cc075472ae$var$rotlL(curH, curL, shift);
            const PI = $a17624cc075472ae$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $a17624cc075472ae$var$SHA3_IOTA_H[round];
        s[1] ^= $a17624cc075472ae$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $a17624cc075472ae$export$f7374b8b4498bc2e extends (0, $6ynrP.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $3k0hy.anumber)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        // 0 < blockLen < 200
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $6ynrP.u32)(this.state);
    }
    keccak() {
        if (!(0, $6ynrP.isLE)) (0, $6ynrP.byteSwap32)(this.state32);
        $a17624cc075472ae$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $6ynrP.isLE)) (0, $6ynrP.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $3k0hy.aexists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $6ynrP.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $3k0hy.aexists)(this, false);
        (0, $3k0hy.abytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $3k0hy.anumber)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $3k0hy.aoutput)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $a17624cc075472ae$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $a17624cc075472ae$var$gen = (suffix, blockLen, outputLen)=>(0, $6ynrP.wrapConstructor)(()=>new $a17624cc075472ae$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $a17624cc075472ae$export$fe6c2b96a79338e9 = /* @__PURE__ */ $a17624cc075472ae$var$gen(0x06, 144, 28);
const $a17624cc075472ae$export$76e19b6966813b14 = /* @__PURE__ */ $a17624cc075472ae$var$gen(0x06, 136, 32);
const $a17624cc075472ae$export$a58509fa80f30d15 = /* @__PURE__ */ $a17624cc075472ae$var$gen(0x06, 104, 48);
const $a17624cc075472ae$export$20ed324dbdf09b7c = /* @__PURE__ */ $a17624cc075472ae$var$gen(0x06, 72, 64);
const $a17624cc075472ae$export$2f7fb3c6fac246bc = /* @__PURE__ */ $a17624cc075472ae$var$gen(0x01, 144, 28);
const $a17624cc075472ae$export$860ddaa9ca84a66d = /* @__PURE__ */ $a17624cc075472ae$var$gen(0x01, 136, 32);
const $a17624cc075472ae$export$46fcdeb4c5686552 = /* @__PURE__ */ $a17624cc075472ae$var$gen(0x01, 104, 48);
const $a17624cc075472ae$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $a17624cc075472ae$var$gen(0x01, 72, 64);
const $a17624cc075472ae$var$genShake = (suffix, blockLen, outputLen)=>(0, $6ynrP.wrapXOFConstructorWithOpts)((opts = {})=>new $a17624cc075472ae$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $a17624cc075472ae$export$f43dc3bb86efbba2 = /* @__PURE__ */ $a17624cc075472ae$var$genShake(0x1f, 168, 16);
const $a17624cc075472ae$export$c240d011f1520440 = /* @__PURE__ */ $a17624cc075472ae$var$genShake(0x1f, 136, 32);

});
parcelRegister("3k0hy", function(module, exports) {

$parcel$export(module.exports, "anumber", function () { return $26b3756253b03935$export$75364c6cb16d43b6; });
$parcel$export(module.exports, "abytes", function () { return $26b3756253b03935$export$e8a750b9efad93f5; });
$parcel$export(module.exports, "ahash", function () { return $26b3756253b03935$export$3ff5a4f04de7e52e; });
$parcel$export(module.exports, "aexists", function () { return $26b3756253b03935$export$20871f6b1d047d77; });
$parcel$export(module.exports, "aoutput", function () { return $26b3756253b03935$export$e8e53abee12b995e; });
/**
 * Internal assertion helpers.
 * @module
 */ /** Asserts something is positive integer. */ function $26b3756253b03935$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, got " + n);
}
/** Is number an Uint8Array? Copied from utils for perf. */ function $26b3756253b03935$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
/** Asserts something is Uint8Array. */ function $26b3756253b03935$export$e8a750b9efad93f5(b, ...lengths) {
    if (!$26b3756253b03935$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length " + lengths + ", got length=" + b.length);
}
/** Asserts something is hash */ function $26b3756253b03935$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $26b3756253b03935$export$75364c6cb16d43b6(h.outputLen);
    $26b3756253b03935$export$75364c6cb16d43b6(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $26b3756253b03935$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
/** Asserts output is properly-sized byte array */ function $26b3756253b03935$export$e8e53abee12b995e(out, instance) {
    $26b3756253b03935$export$e8a750b9efad93f5(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least " + min);
}

});

parcelRegister("lkrgK", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $f8709e542e57e25d$export$65980d18b75784e2; });
$parcel$export(module.exports, "rotlSH", function () { return $f8709e542e57e25d$export$4b80a2917447870e; });
$parcel$export(module.exports, "rotlSL", function () { return $f8709e542e57e25d$export$20652918a7b63b3; });
$parcel$export(module.exports, "rotlBH", function () { return $f8709e542e57e25d$export$a52f14bf902f9977; });
$parcel$export(module.exports, "rotlBL", function () { return $f8709e542e57e25d$export$5d12cc1da441323f; });
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $f8709e542e57e25d$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $f8709e542e57e25d$var$_32n = /* @__PURE__ */ BigInt(32);
function $f8709e542e57e25d$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $f8709e542e57e25d$var$U32_MASK64),
        l: Number(n >> $f8709e542e57e25d$var$_32n & $f8709e542e57e25d$var$U32_MASK64)
    };
    return {
        h: Number(n >> $f8709e542e57e25d$var$_32n & $f8709e542e57e25d$var$U32_MASK64) | 0,
        l: Number(n & $f8709e542e57e25d$var$U32_MASK64) | 0
    };
}
function $f8709e542e57e25d$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $f8709e542e57e25d$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $f8709e542e57e25d$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $f8709e542e57e25d$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $f8709e542e57e25d$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $f8709e542e57e25d$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $f8709e542e57e25d$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $f8709e542e57e25d$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $f8709e542e57e25d$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $f8709e542e57e25d$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $f8709e542e57e25d$export$a088d44bd387d2a3 = (_h, l)=>l;
const $f8709e542e57e25d$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $f8709e542e57e25d$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $f8709e542e57e25d$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $f8709e542e57e25d$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $f8709e542e57e25d$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $f8709e542e57e25d$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $f8709e542e57e25d$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $f8709e542e57e25d$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $f8709e542e57e25d$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $f8709e542e57e25d$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $f8709e542e57e25d$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $f8709e542e57e25d$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $f8709e542e57e25d$var$u64 = {
    fromBig: $f8709e542e57e25d$export$9625d4333cb56c3f,
    split: $f8709e542e57e25d$export$65980d18b75784e2,
    toBig: $f8709e542e57e25d$export$30f78adcaaa2eb7,
    shrSH: $f8709e542e57e25d$export$75aa78dc5bd52853,
    shrSL: $f8709e542e57e25d$export$a0225ff0aee14e25,
    rotrSH: $f8709e542e57e25d$export$97f812dfd830ca87,
    rotrSL: $f8709e542e57e25d$export$60987e30e2c9d9d,
    rotrBH: $f8709e542e57e25d$export$af9c7fbac44dcb76,
    rotrBL: $f8709e542e57e25d$export$f619171d6d5ac414,
    rotr32H: $f8709e542e57e25d$export$a088d44bd387d2a3,
    rotr32L: $f8709e542e57e25d$export$8415aae4d1f69577,
    rotlSH: $f8709e542e57e25d$export$4b80a2917447870e,
    rotlSL: $f8709e542e57e25d$export$20652918a7b63b3,
    rotlBH: $f8709e542e57e25d$export$a52f14bf902f9977,
    rotlBL: $f8709e542e57e25d$export$5d12cc1da441323f,
    add: $f8709e542e57e25d$export$e16d8520af44a096,
    add3L: $f8709e542e57e25d$export$c0c22b91f08911f,
    add3H: $f8709e542e57e25d$export$ef7b26044977a8ec,
    add4L: $f8709e542e57e25d$export$2f4e199c560f545d,
    add4H: $f8709e542e57e25d$export$e909220d675a7741,
    add5H: $f8709e542e57e25d$export$b45ee8d78c965098,
    add5L: $f8709e542e57e25d$export$d732b061fe9c9ae4
};
var $f8709e542e57e25d$export$2e2bcd8739ae039 = $f8709e542e57e25d$var$u64;

});

parcelRegister("6ynrP", function(module, exports) {

$parcel$export(module.exports, "u32", function () { return $4c581b4e84afda29$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "createView", function () { return $4c581b4e84afda29$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $4c581b4e84afda29$export$466993d7d0d272aa; });
$parcel$export(module.exports, "isLE", function () { return $4c581b4e84afda29$export$a0f88e38d4cf9577; });
$parcel$export(module.exports, "byteSwap32", function () { return $4c581b4e84afda29$export$97b40fc37f25d711; });
$parcel$export(module.exports, "toBytes", function () { return $4c581b4e84afda29$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $4c581b4e84afda29$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $4c581b4e84afda29$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $4c581b4e84afda29$export$f081816339df1972; });
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", function () { return $4c581b4e84afda29$export$e18964dbd6e083c1; });
$parcel$export(module.exports, "randomBytes", function () { return $4c581b4e84afda29$export$5f828d93ff035aa8; });
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $6rrJw = parcelRequire("6rrJw");

var $3k0hy = parcelRequire("3k0hy");
function $4c581b4e84afda29$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $4c581b4e84afda29$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $4c581b4e84afda29$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $4c581b4e84afda29$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $4c581b4e84afda29$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $4c581b4e84afda29$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $4c581b4e84afda29$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $4c581b4e84afda29$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $4c581b4e84afda29$export$4a0a88cc2d284e7f = $4c581b4e84afda29$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$4c581b4e84afda29$export$a4170f7f8be47425(n);
function $4c581b4e84afda29$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $4c581b4e84afda29$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $4c581b4e84afda29$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $4c581b4e84afda29$export$58b867e287a802c8(bytes) {
    (0, $3k0hy.abytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $4c581b4e84afda29$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $4c581b4e84afda29$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $4c581b4e84afda29$var$asciiToBase16(ch) {
    if (ch >= $4c581b4e84afda29$var$asciis._0 && ch <= $4c581b4e84afda29$var$asciis._9) return ch - $4c581b4e84afda29$var$asciis._0; // '2' => 50-48
    if (ch >= $4c581b4e84afda29$var$asciis.A && ch <= $4c581b4e84afda29$var$asciis.F) return ch - ($4c581b4e84afda29$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $4c581b4e84afda29$var$asciis.a && ch <= $4c581b4e84afda29$var$asciis.f) return ch - ($4c581b4e84afda29$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $4c581b4e84afda29$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $4c581b4e84afda29$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $4c581b4e84afda29$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $4c581b4e84afda29$export$bdd553fddd433dcb = async ()=>{};
async function $4c581b4e84afda29$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $4c581b4e84afda29$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $4c581b4e84afda29$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got " + typeof str);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $4c581b4e84afda29$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $4c581b4e84afda29$export$3df70a15530b5e81(data);
    (0, $3k0hy.abytes)(data);
    return data;
}
function $4c581b4e84afda29$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $3k0hy.abytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $4c581b4e84afda29$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
function $4c581b4e84afda29$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $4c581b4e84afda29$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($4c581b4e84afda29$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $4c581b4e84afda29$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($4c581b4e84afda29$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $4c581b4e84afda29$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($4c581b4e84afda29$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $4c581b4e84afda29$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $6rrJw.crypto) && typeof (0, $6rrJw.crypto).getRandomValues === "function") return (0, $6rrJw.crypto).getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ((0, $6rrJw.crypto) && typeof (0, $6rrJw.crypto).randomBytes === "function") return (0, $6rrJw.crypto).randomBytes(bytesLength);
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("6rrJw", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $4b0ac6ef86f9b225$export$7effb53edfc7fa2d; });
const $4b0ac6ef86f9b225$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});





parcelRegister("bI3Po", function(module, exports) {

$parcel$export(module.exports, "toSignature", function () { return $8866c5f03ebad3bf$export$d075a2fd83e0ecb; });

var $l2jn0 = parcelRequire("l2jn0");

var $drJGv = parcelRequire("drJGv");
const $8866c5f03ebad3bf$export$d075a2fd83e0ecb = (def)=>{
    const def_ = (()=>{
        if (typeof def === "string") return def;
        return (0, $l2jn0.formatAbiItem)(def);
    })();
    return (0, $drJGv.normalizeSignature)(def_);
};

});
parcelRegister("l2jn0", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", function () { return $f508cf5c36908669$export$dc5d0ff4fc2fdee1; });

var $41jdK = parcelRequire("41jdK");
function $f508cf5c36908669$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === "function") return `function ${abiItem.name}(${(0, $41jdK.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== "nonpayable" ? ` ${abiItem.stateMutability}` : ""}${abiItem.outputs?.length ? ` returns (${(0, $41jdK.formatAbiParameters)(abiItem.outputs)})` : ""}`;
    if (abiItem.type === "event") return `event ${abiItem.name}(${(0, $41jdK.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === "error") return `error ${abiItem.name}(${(0, $41jdK.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === "constructor") return `constructor(${(0, $41jdK.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    if (abiItem.type === "fallback") return `fallback() external${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    return "receive() external payable";
}

});
parcelRegister("41jdK", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", function () { return $2ed62a4872f84c01$export$c55dbda1a081631e; });

var $eakux = parcelRequire("eakux");
function $2ed62a4872f84c01$export$c55dbda1a081631e(abiParameters) {
    let params = "";
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $eakux.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ", ";
    }
    return params;
}

});
parcelRegister("eakux", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", function () { return $a501e50d44ea8bc0$export$c75e01ebc733dc6b; });

var $1tjrf = parcelRequire("1tjrf");
// https://regexr.com/7f7rv
const $a501e50d44ea8bc0$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $a501e50d44ea8bc0$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($a501e50d44ea8bc0$var$tupleRegex.test(abiParameter.type) && "components" in abiParameter) {
        type = "(";
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $a501e50d44ea8bc0$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ", ";
        }
        const result = (0, $1tjrf.execTyped)($a501e50d44ea8bc0$var$tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ""}`;
        return $a501e50d44ea8bc0$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    // Add `indexed` to type if in `abiParameter`
    if ("indexed" in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    // Return human-readable ABI parameter
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}

});
parcelRegister("1tjrf", function(module, exports) {

$parcel$export(module.exports, "execTyped", function () { return $112793f8205f9327$export$1cca4755fb17f5bd; });
$parcel$export(module.exports, "bytesRegex", function () { return $112793f8205f9327$export$94d7303c0d9f263a; });
$parcel$export(module.exports, "integerRegex", function () { return $112793f8205f9327$export$45902cc189596eef; });
$parcel$export(module.exports, "isTupleRegex", function () { return $112793f8205f9327$export$5c1628af1434aed0; });
// TODO: This looks cool. Need to check the performance of `new RegExp` versus defined inline though.
// https://twitter.com/GabrielVergnaud/status/1622906834343366657
function $112793f8205f9327$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $112793f8205f9327$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $112793f8205f9327$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $112793f8205f9327$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});




parcelRegister("drJGv", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", function () { return $9ca13bfbe8125325$export$5cba87ebe4d0307a; });

var $cahqm = parcelRequire("cahqm");
function $9ca13bfbe8125325$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = "";
    let level = 0;
    let result = "";
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $cahqm.BaseError)("Unable to normalize signature.");
    return result;
}

});




parcelRegister("hCHkb", function(module, exports) {

$parcel$export(module.exports, "decodeAbiParameters", function () { return $cd47979b2938ff6b$export$84d51ac2fffabd56; });

var $8p1we = parcelRequire("8p1we");

var $siouQ = parcelRequire("siouQ");

var $d3xcE = parcelRequire("d3xcE");

var $lsLGO = parcelRequire("lsLGO");

var $fdb51 = parcelRequire("fdb51");

var $geW6W = parcelRequire("geW6W");

var $koCi5 = parcelRequire("koCi5");

var $cY7Yq = parcelRequire("cY7Yq");

var $jW8ut = parcelRequire("jW8ut");

var $hxvKS = parcelRequire("hxvKS");
function $cd47979b2938ff6b$export$84d51ac2fffabd56(params, data) {
    const bytes = typeof data === "string" ? (0, $cY7Yq.hexToBytes)(data) : data;
    const cursor = (0, $d3xcE.createCursor)(bytes);
    if ((0, $lsLGO.size)(bytes) === 0 && params.length > 0) throw new (0, $8p1we.AbiDecodingZeroDataError)();
    if ((0, $lsLGO.size)(data) && (0, $lsLGO.size)(data) < 32) throw new (0, $8p1we.AbiDecodingDataSizeTooSmallError)({
        data: typeof data === "string" ? data : (0, $jW8ut.bytesToHex)(data),
        params: params,
        size: (0, $lsLGO.size)(data)
    });
    let consumed = 0;
    const values = [];
    for(let i = 0; i < params.length; ++i){
        const param = params[i];
        cursor.setPosition(consumed);
        const [data, consumed_] = $cd47979b2938ff6b$var$decodeParameter(cursor, param, {
            staticPosition: 0
        });
        consumed += consumed_;
        values.push(data);
    }
    return values;
}
function $cd47979b2938ff6b$var$decodeParameter(cursor, param, { staticPosition: staticPosition }) {
    const arrayComponents = (0, $hxvKS.getArrayComponents)(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $cd47979b2938ff6b$var$decodeArray(cursor, {
            ...param,
            type: type
        }, {
            length: length,
            staticPosition: staticPosition
        });
    }
    if (param.type === "tuple") return $cd47979b2938ff6b$var$decodeTuple(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type === "address") return $cd47979b2938ff6b$var$decodeAddress(cursor);
    if (param.type === "bool") return $cd47979b2938ff6b$var$decodeBool(cursor);
    if (param.type.startsWith("bytes")) return $cd47979b2938ff6b$var$decodeBytes(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type.startsWith("uint") || param.type.startsWith("int")) return $cd47979b2938ff6b$var$decodeNumber(cursor, param);
    if (param.type === "string") return $cd47979b2938ff6b$var$decodeString(cursor, {
        staticPosition: staticPosition
    });
    throw new (0, $8p1we.InvalidAbiDecodingTypeError)(param.type, {
        docsPath: "/docs/contract/decodeAbiParameters"
    });
}
////////////////////////////////////////////////////////////////////
// Type Decoders
const $cd47979b2938ff6b$var$sizeOfLength = 32;
const $cd47979b2938ff6b$var$sizeOfOffset = 32;
function $cd47979b2938ff6b$var$decodeAddress(cursor) {
    const value = cursor.readBytes(32);
    return [
        (0, $siouQ.checksumAddress)((0, $jW8ut.bytesToHex)((0, $fdb51.sliceBytes)(value, -20))),
        32
    ];
}
function $cd47979b2938ff6b$var$decodeArray(cursor, param, { length: length, staticPosition: staticPosition }) {
    // If the length of the array is not known in advance (dynamic array),
    // this means we will need to wonder off to the pointer and decode.
    if (!length) {
        // Dealing with a dynamic type, so get the offset of the array data.
        const offset = (0, $koCi5.bytesToNumber)(cursor.readBytes($cd47979b2938ff6b$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const startOfData = start + $cd47979b2938ff6b$var$sizeOfLength;
        // Get the length of the array from the offset.
        cursor.setPosition(start);
        const length = (0, $koCi5.bytesToNumber)(cursor.readBytes($cd47979b2938ff6b$var$sizeOfLength));
        // Check if the array has any dynamic children.
        const dynamicChild = $cd47979b2938ff6b$var$hasDynamicChild(param);
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            // If any of the children is dynamic, then all elements will be offset pointer, thus size of one slot (32 bytes).
            // Otherwise, elements will be the size of their encoding (consumed bytes).
            cursor.setPosition(startOfData + (dynamicChild ? i * 32 : consumed));
            const [data, consumed_] = $cd47979b2938ff6b$var$decodeParameter(cursor, param, {
                staticPosition: startOfData
            });
            consumed += consumed_;
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($cd47979b2938ff6b$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the array data.
        const offset = (0, $koCi5.bytesToNumber)(cursor.readBytes($cd47979b2938ff6b$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const value = [];
        for(let i = 0; i < length; ++i){
            // Move cursor along to the next slot (next offset pointer).
            cursor.setPosition(start + i * 32);
            const [data] = $cd47979b2938ff6b$var$decodeParameter(cursor, param, {
                staticPosition: start
            });
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance and the array is deeply static,
    // then we can just decode each element in sequence.
    let consumed = 0;
    const value = [];
    for(let i = 0; i < length; ++i){
        const [data, consumed_] = $cd47979b2938ff6b$var$decodeParameter(cursor, param, {
            staticPosition: staticPosition + consumed
        });
        consumed += consumed_;
        value.push(data);
    }
    return [
        value,
        consumed
    ];
}
function $cd47979b2938ff6b$var$decodeBool(cursor) {
    return [
        (0, $koCi5.bytesToBool)(cursor.readBytes(32), {
            size: 32
        }),
        32
    ];
}
function $cd47979b2938ff6b$var$decodeBytes(cursor, param, { staticPosition: staticPosition }) {
    const [_, size] = param.type.split("bytes");
    if (!size) {
        // Dealing with dynamic types, so get the offset of the bytes data.
        const offset = (0, $koCi5.bytesToNumber)(cursor.readBytes(32));
        // Set position of the cursor to start of bytes data.
        cursor.setPosition(staticPosition + offset);
        const length = (0, $koCi5.bytesToNumber)(cursor.readBytes(32));
        // If there is no length, we have zero data.
        if (length === 0) {
            // As we have gone wondering, restore to the original position + next slot.
            cursor.setPosition(staticPosition + 32);
            return [
                "0x",
                32
            ];
        }
        const data = cursor.readBytes(length);
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            (0, $jW8ut.bytesToHex)(data),
            32
        ];
    }
    const value = (0, $jW8ut.bytesToHex)(cursor.readBytes(Number.parseInt(size), 32));
    return [
        value,
        32
    ];
}
function $cd47979b2938ff6b$var$decodeNumber(cursor, param) {
    const signed = param.type.startsWith("int");
    const size = Number.parseInt(param.type.split("int")[1] || "256");
    const value = cursor.readBytes(32);
    return [
        size > 48 ? (0, $koCi5.bytesToBigInt)(value, {
            signed: signed
        }) : (0, $koCi5.bytesToNumber)(value, {
            signed: signed
        }),
        32
    ];
}
function $cd47979b2938ff6b$var$decodeTuple(cursor, param, { staticPosition: staticPosition }) {
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name: name })=>!name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($cd47979b2938ff6b$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the tuple data.
        const offset = (0, $koCi5.bytesToNumber)(cursor.readBytes($cd47979b2938ff6b$var$sizeOfOffset));
        // Start is the static position of referencing slot + offset.
        const start = staticPosition + offset;
        for(let i = 0; i < param.components.length; ++i){
            const component = param.components[i];
            cursor.setPosition(start + consumed);
            const [data, consumed_] = $cd47979b2938ff6b$var$decodeParameter(cursor, component, {
                staticPosition: start
            });
            consumed += consumed_;
            value[hasUnnamedChild ? i : component?.name] = data;
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(let i = 0; i < param.components.length; ++i){
        const component = param.components[i];
        const [data, consumed_] = $cd47979b2938ff6b$var$decodeParameter(cursor, component, {
            staticPosition: staticPosition
        });
        value[hasUnnamedChild ? i : component?.name] = data;
        consumed += consumed_;
    }
    return [
        value,
        consumed
    ];
}
function $cd47979b2938ff6b$var$decodeString(cursor, { staticPosition: staticPosition }) {
    // Get offset to start of string data.
    const offset = (0, $koCi5.bytesToNumber)(cursor.readBytes(32));
    // Start is the static position of current slot + offset.
    const start = staticPosition + offset;
    cursor.setPosition(start);
    const length = (0, $koCi5.bytesToNumber)(cursor.readBytes(32));
    // If there is no length, we have zero data (empty string).
    if (length === 0) {
        cursor.setPosition(staticPosition + 32);
        return [
            "",
            32
        ];
    }
    const data = cursor.readBytes(length, 32);
    const value = (0, $koCi5.bytesToString)((0, $geW6W.trim)(data));
    // As we have gone wondering, restore to the original position + next slot.
    cursor.setPosition(staticPosition + 32);
    return [
        value,
        32
    ];
}
function $cd47979b2938ff6b$var$hasDynamicChild(param) {
    const { type: type } = param;
    if (type === "string") return true;
    if (type === "bytes") return true;
    if (type.endsWith("[]")) return true;
    if (type === "tuple") return param.components?.some($cd47979b2938ff6b$var$hasDynamicChild);
    const arrayComponents = (0, $hxvKS.getArrayComponents)(param.type);
    if (arrayComponents && $cd47979b2938ff6b$var$hasDynamicChild({
        ...param,
        type: arrayComponents[1]
    })) return true;
    return false;
}

});
parcelRegister("siouQ", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", function () { return $0550e2537253cdcb$export$9ff46e8f6df13548; });
$parcel$export(module.exports, "getAddress", function () { return $0550e2537253cdcb$export$88411125f012957a; });

var $62VqX = parcelRequire("62VqX");

var $cY7Yq = parcelRequire("cY7Yq");

var $diQni = parcelRequire("diQni");

var $2iCjp = parcelRequire("2iCjp");

var $8Ghey = parcelRequire("8Ghey");
const $0550e2537253cdcb$var$checksumAddressCache = /*#__PURE__*/ new (0, $2iCjp.LruMap)(8192);
function $0550e2537253cdcb$export$9ff46e8f6df13548(address_, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if ($0550e2537253cdcb$var$checksumAddressCache.has(`${address_}.${chainId}`)) return $0550e2537253cdcb$var$checksumAddressCache.get(`${address_}.${chainId}`);
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $diQni.keccak256)((0, $cY7Yq.stringToBytes)(hexAddress), "bytes");
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    const result = `0x${address.join("")}`;
    $0550e2537253cdcb$var$checksumAddressCache.set(`${address_}.${chainId}`, result);
    return result;
}
function $0550e2537253cdcb$export$88411125f012957a(address, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if (!(0, $8Ghey.isAddress)(address, {
        strict: false
    })) throw new (0, $62VqX.InvalidAddressError)({
        address: address
    });
    return $0550e2537253cdcb$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("62VqX", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", function () { return $466f7b29717b7ee8$export$66c44d927ffead98; });

var $cahqm = parcelRequire("cahqm");
class $466f7b29717b7ee8$export$66c44d927ffead98 extends (0, $cahqm.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`, {
            metaMessages: [
                "- Address must be a hex value of 20 bytes (40 hex characters).",
                "- Address must match its checksum counterpart."
            ],
            name: "InvalidAddressError"
        });
    }
}

});

parcelRegister("2iCjp", function(module, exports) {

$parcel$export(module.exports, "LruMap", function () { return $1acafb305d0de6c1$export$fcb3b6cad79d7e3a; });
/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ class $1acafb305d0de6c1$export$fcb3b6cad79d7e3a extends Map {
    constructor(size){
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    get(key) {
        const value = super.get(key);
        if (super.has(key) && value !== undefined) {
            this.delete(key);
            super.set(key, value);
        }
        return value;
    }
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) {
            const firstKey = this.keys().next().value;
            if (firstKey) this.delete(firstKey);
        }
        return this;
    }
}

});

parcelRegister("8Ghey", function(module, exports) {

$parcel$export(module.exports, "isAddress", function () { return $651f9d42e168f918$export$977e255126d763d6; });

var $2iCjp = parcelRequire("2iCjp");

var $siouQ = parcelRequire("siouQ");
const $651f9d42e168f918$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
const $651f9d42e168f918$export$ef83598cc5072ce = /*#__PURE__*/ new (0, $2iCjp.LruMap)(8192);
function $651f9d42e168f918$export$977e255126d763d6(address, options) {
    const { strict: strict = true } = options ?? {};
    const cacheKey = `${address}.${strict}`;
    if ($651f9d42e168f918$export$ef83598cc5072ce.has(cacheKey)) return $651f9d42e168f918$export$ef83598cc5072ce.get(cacheKey);
    const result = (()=>{
        if (!$651f9d42e168f918$var$addressRegex.test(address)) return false;
        if (address.toLowerCase() === address) return true;
        if (strict) return (0, $siouQ.checksumAddress)(address) === address;
        return true;
    })();
    $651f9d42e168f918$export$ef83598cc5072ce.set(cacheKey, result);
    return result;
}

});


parcelRegister("d3xcE", function(module, exports) {

$parcel$export(module.exports, "createCursor", function () { return $98154f98fe0984cb$export$fb542681b7c0dc55; });

var $2bJrV = parcelRequire("2bJrV");
const $98154f98fe0984cb$var$staticCursor = {
    bytes: new Uint8Array(),
    dataView: new DataView(new ArrayBuffer(0)),
    position: 0,
    positionReadCount: new Map(),
    recursiveReadCount: 0,
    recursiveReadLimit: Number.POSITIVE_INFINITY,
    assertReadLimit () {
        if (this.recursiveReadCount >= this.recursiveReadLimit) throw new (0, $2bJrV.RecursiveReadLimitExceededError)({
            count: this.recursiveReadCount + 1,
            limit: this.recursiveReadLimit
        });
    },
    assertPosition (position) {
        if (position < 0 || position > this.bytes.length - 1) throw new (0, $2bJrV.PositionOutOfBoundsError)({
            length: this.bytes.length,
            position: position
        });
    },
    decrementPosition (offset) {
        if (offset < 0) throw new (0, $2bJrV.NegativeOffsetError)({
            offset: offset
        });
        const position = this.position - offset;
        this.assertPosition(position);
        this.position = position;
    },
    getReadCount (position) {
        return this.positionReadCount.get(position || this.position) || 0;
    },
    incrementPosition (offset) {
        if (offset < 0) throw new (0, $2bJrV.NegativeOffsetError)({
            offset: offset
        });
        const position = this.position + offset;
        this.assertPosition(position);
        this.position = position;
    },
    inspectByte (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectBytes (length, position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + length - 1);
        return this.bytes.subarray(position, position + length);
    },
    inspectUint8 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectUint16 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 1);
        return this.dataView.getUint16(position);
    },
    inspectUint24 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 2);
        return (this.dataView.getUint16(position) << 8) + this.dataView.getUint8(position + 2);
    },
    inspectUint32 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 3);
        return this.dataView.getUint32(position);
    },
    pushByte (byte) {
        this.assertPosition(this.position);
        this.bytes[this.position] = byte;
        this.position++;
    },
    pushBytes (bytes) {
        this.assertPosition(this.position + bytes.length - 1);
        this.bytes.set(bytes, this.position);
        this.position += bytes.length;
    },
    pushUint8 (value) {
        this.assertPosition(this.position);
        this.bytes[this.position] = value;
        this.position++;
    },
    pushUint16 (value) {
        this.assertPosition(this.position + 1);
        this.dataView.setUint16(this.position, value);
        this.position += 2;
    },
    pushUint24 (value) {
        this.assertPosition(this.position + 2);
        this.dataView.setUint16(this.position, value >> 8);
        this.dataView.setUint8(this.position + 2, value & 255);
        this.position += 3;
    },
    pushUint32 (value) {
        this.assertPosition(this.position + 3);
        this.dataView.setUint32(this.position, value);
        this.position += 4;
    },
    readByte () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectByte();
        this.position++;
        return value;
    },
    readBytes (length, size) {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectBytes(length);
        this.position += size ?? length;
        return value;
    },
    readUint8 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint8();
        this.position += 1;
        return value;
    },
    readUint16 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint16();
        this.position += 2;
        return value;
    },
    readUint24 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint24();
        this.position += 3;
        return value;
    },
    readUint32 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint32();
        this.position += 4;
        return value;
    },
    get remaining () {
        return this.bytes.length - this.position;
    },
    setPosition (position) {
        const oldPosition = this.position;
        this.assertPosition(position);
        this.position = position;
        return ()=>this.position = oldPosition;
    },
    _touch () {
        if (this.recursiveReadLimit === Number.POSITIVE_INFINITY) return;
        const count = this.getReadCount();
        this.positionReadCount.set(this.position, count + 1);
        if (count > 0) this.recursiveReadCount++;
    }
};
function $98154f98fe0984cb$export$fb542681b7c0dc55(bytes, { recursiveReadLimit: recursiveReadLimit = 8192 } = {}) {
    const cursor = Object.create($98154f98fe0984cb$var$staticCursor);
    cursor.bytes = bytes;
    cursor.dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    cursor.positionReadCount = new Map();
    cursor.recursiveReadLimit = recursiveReadLimit;
    return cursor;
}

});
parcelRegister("2bJrV", function(module, exports) {

$parcel$export(module.exports, "NegativeOffsetError", function () { return $197fdd266e9b2586$export$4741ff085e62ac19; });
$parcel$export(module.exports, "PositionOutOfBoundsError", function () { return $197fdd266e9b2586$export$72dcc4230cbf50ba; });
$parcel$export(module.exports, "RecursiveReadLimitExceededError", function () { return $197fdd266e9b2586$export$4952f5c6336a7cc7; });

var $cahqm = parcelRequire("cahqm");
class $197fdd266e9b2586$export$4741ff085e62ac19 extends (0, $cahqm.BaseError) {
    constructor({ offset: offset }){
        super(`Offset \`${offset}\` cannot be negative.`, {
            name: "NegativeOffsetError"
        });
    }
}
class $197fdd266e9b2586$export$72dcc4230cbf50ba extends (0, $cahqm.BaseError) {
    constructor({ length: length, position: position }){
        super(`Position \`${position}\` is out of bounds (\`0 < position < ${length}\`).`, {
            name: "PositionOutOfBoundsError"
        });
    }
}
class $197fdd266e9b2586$export$4952f5c6336a7cc7 extends (0, $cahqm.BaseError) {
    constructor({ count: count, limit: limit }){
        super(`Recursive read limit of \`${limit}\` exceeded (recursive read count: \`${count}\`).`, {
            name: "RecursiveReadLimitExceededError"
        });
    }
}

});


parcelRegister("koCi5", function(module, exports) {

$parcel$export(module.exports, "bytesToNumber", function () { return $ed93c04d46848034$export$c0cca17bcf674749; });
$parcel$export(module.exports, "bytesToBigInt", function () { return $ed93c04d46848034$export$2a52511e4f35930a; });
$parcel$export(module.exports, "bytesToBool", function () { return $ed93c04d46848034$export$aa06fda122958d5d; });
$parcel$export(module.exports, "bytesToString", function () { return $ed93c04d46848034$export$7c746b75f47c9c7d; });

var $8PKwo = parcelRequire("8PKwo");

var $geW6W = parcelRequire("geW6W");

var $9GGVO = parcelRequire("9GGVO");

var $jW8ut = parcelRequire("jW8ut");
function $ed93c04d46848034$export$de2da3025c30316c(bytes, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $ed93c04d46848034$export$c0cca17bcf674749(bytes, opts);
    if (to === "bigint") return $ed93c04d46848034$export$2a52511e4f35930a(bytes, opts);
    if (to === "boolean") return $ed93c04d46848034$export$aa06fda122958d5d(bytes, opts);
    if (to === "string") return $ed93c04d46848034$export$7c746b75f47c9c7d(bytes, opts);
    return (0, $jW8ut.bytesToHex)(bytes, opts);
}
function $ed93c04d46848034$export$2a52511e4f35930a(bytes, opts = {}) {
    if (typeof opts.size !== "undefined") (0, $9GGVO.assertSize)(bytes, {
        size: opts.size
    });
    const hex = (0, $jW8ut.bytesToHex)(bytes, opts);
    return (0, $9GGVO.hexToBigInt)(hex, opts);
}
function $ed93c04d46848034$export$aa06fda122958d5d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $9GGVO.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $geW6W.trim)(bytes);
    }
    if (bytes.length > 1 || bytes[0] > 1) throw new (0, $8PKwo.InvalidBytesBooleanError)(bytes);
    return Boolean(bytes[0]);
}
function $ed93c04d46848034$export$c0cca17bcf674749(bytes, opts = {}) {
    if (typeof opts.size !== "undefined") (0, $9GGVO.assertSize)(bytes, {
        size: opts.size
    });
    const hex = (0, $jW8ut.bytesToHex)(bytes, opts);
    return (0, $9GGVO.hexToNumber)(hex, opts);
}
function $ed93c04d46848034$export$7c746b75f47c9c7d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $9GGVO.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $geW6W.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});

parcelRegister("hxvKS", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", function () { return $cc4e26a4e374ccab$export$448ea0950d6dd7d7; });
$parcel$export(module.exports, "getArrayComponents", function () { return $cc4e26a4e374ccab$export$ab502cfdbb1a0d07; });

var $8p1we = parcelRequire("8p1we");

var $62VqX = parcelRequire("62VqX");

var $cahqm = parcelRequire("cahqm");

var $8PKwo = parcelRequire("8PKwo");

var $8Ghey = parcelRequire("8Ghey");

var $jnwfF = parcelRequire("jnwfF");

var $iPnWm = parcelRequire("iPnWm");

var $lsLGO = parcelRequire("lsLGO");

var $fdb51 = parcelRequire("fdb51");

var $jW8ut = parcelRequire("jW8ut");

var $8x9TH = parcelRequire("8x9TH");
function $cc4e26a4e374ccab$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $8p1we.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $cc4e26a4e374ccab$var$prepareParams({
        params: params,
        values: values
    });
    const data = $cc4e26a4e374ccab$var$encodeParams(preparedParams);
    if (data.length === 0) return "0x";
    return data;
}
function $cc4e26a4e374ccab$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($cc4e26a4e374ccab$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $cc4e26a4e374ccab$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $cc4e26a4e374ccab$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $cc4e26a4e374ccab$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === "tuple") return $cc4e26a4e374ccab$var$encodeTuple(value, {
        param: param
    });
    if (param.type === "address") return $cc4e26a4e374ccab$var$encodeAddress(value);
    if (param.type === "bool") return $cc4e26a4e374ccab$var$encodeBool(value);
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
        const signed = param.type.startsWith("int");
        const [, , size = "256"] = (0, $8x9TH.integerRegex).exec(param.type) ?? [];
        return $cc4e26a4e374ccab$var$encodeNumber(value, {
            signed: signed,
            size: Number(size)
        });
    }
    if (param.type.startsWith("bytes")) return $cc4e26a4e374ccab$var$encodeBytes(value, {
        param: param
    });
    if (param.type === "string") return $cc4e26a4e374ccab$var$encodeString(value);
    throw new (0, $8p1we.InvalidAbiEncodingTypeError)(param.type, {
        docsPath: "/docs/contract/encodeAbiParameters"
    });
}
function $cc4e26a4e374ccab$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $lsLGO.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $jW8ut.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $lsLGO.size)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $jnwfF.concat)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $cc4e26a4e374ccab$var$encodeAddress(value) {
    if (!(0, $8Ghey.isAddress)(value)) throw new (0, $62VqX.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $iPnWm.padHex)(value.toLowerCase())
    };
}
function $cc4e26a4e374ccab$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $8p1we.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $8p1we.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $cc4e26a4e374ccab$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $cc4e26a4e374ccab$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $jW8ut.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $jnwfF.concat)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $jnwfF.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $cc4e26a4e374ccab$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split("bytes");
    const bytesSize = (0, $lsLGO.size)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $iPnWm.padHex)(value_, {
            dir: "right",
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $jnwfF.concat)([
                (0, $iPnWm.padHex)((0, $jW8ut.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== Number.parseInt(paramSize)) throw new (0, $8p1we.AbiEncodingBytesSizeMismatchError)({
        expectedSize: Number.parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $iPnWm.padHex)(value, {
            dir: "right"
        })
    };
}
function $cc4e26a4e374ccab$var$encodeBool(value) {
    if (typeof value !== "boolean") throw new (0, $cahqm.BaseError)(`Invalid boolean value: "${value}" (type: ${typeof value}). Expected: \`true\` or \`false\`.`);
    return {
        dynamic: false,
        encoded: (0, $iPnWm.padHex)((0, $jW8ut.boolToHex)(value))
    };
}
function $cc4e26a4e374ccab$var$encodeNumber(value, { signed: signed, size: size = 256 }) {
    if (typeof size === "number") {
        const max = 2n ** (BigInt(size) - (signed ? 1n : 0n)) - 1n;
        const min = signed ? -max - 1n : 0n;
        if (value > max || value < min) throw new (0, $8PKwo.IntegerOutOfRangeError)({
            max: max.toString(),
            min: min.toString(),
            signed: signed,
            size: size / 8,
            value: value.toString()
        });
    }
    return {
        dynamic: false,
        encoded: (0, $jW8ut.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $cc4e26a4e374ccab$var$encodeString(value) {
    const hexValue = (0, $jW8ut.stringToHex)(value);
    const partsLength = Math.ceil((0, $lsLGO.size)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $iPnWm.padHex)((0, $fdb51.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
    }));
    return {
        dynamic: true,
        encoded: (0, $jnwfF.concat)([
            (0, $iPnWm.padHex)((0, $jW8ut.numberToHex)((0, $lsLGO.size)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $cc4e26a4e374ccab$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $cc4e26a4e374ccab$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $cc4e26a4e374ccab$var$encodeParams(preparedParams) : (0, $jnwfF.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $cc4e26a4e374ccab$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});
parcelRegister("jnwfF", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $e1b92ecc23ec5ab8$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatHex", function () { return $e1b92ecc23ec5ab8$export$f6cc0b64b5a999af; });
function $e1b92ecc23ec5ab8$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === "string") return $e1b92ecc23ec5ab8$export$f6cc0b64b5a999af(values);
    return $e1b92ecc23ec5ab8$export$287dd7971339c972(values);
}
function $e1b92ecc23ec5ab8$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $e1b92ecc23ec5ab8$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}

});

parcelRegister("8x9TH", function(module, exports) {

$parcel$export(module.exports, "bytesRegex", function () { return $63691531bb34ab7b$export$94d7303c0d9f263a; });
$parcel$export(module.exports, "integerRegex", function () { return $63691531bb34ab7b$export$45902cc189596eef; });
const $63691531bb34ab7b$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $63691531bb34ab7b$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $63691531bb34ab7b$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

});




parcelRegister("6fuj2", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $48cba6ebafdbf921$export$fac44ee5b035f737; });
const $48cba6ebafdbf921$export$fac44ee5b035f737 = (value, replacer, space)=>JSON.stringify(value, (key, value_)=>{
        const value = typeof value_ === "bigint" ? value_.toString() : value_;
        return typeof replacer === "function" ? replacer(key, value) : value;
    }, space);

});

parcelRegister("jXNUH", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", function () { return $e88a3ec9a5292185$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getUrl", function () { return $e88a3ec9a5292185$export$94df0e59ebebf4a7; });
const $e88a3ec9a5292185$export$b7fbffef12272e40 = (address)=>address;
const $e88a3ec9a5292185$export$94df0e59ebebf4a7 = (url)=>url;

});

parcelRegister("aBz5G", function(module, exports) {

$parcel$export(module.exports, "HttpRequestError", function () { return $7b8894582b845f07$export$715ba3385e9f2cf0; });
$parcel$export(module.exports, "RpcRequestError", function () { return $7b8894582b845f07$export$a823590631c47261; });
$parcel$export(module.exports, "TimeoutError", function () { return $7b8894582b845f07$export$66d311bf29d5c89c; });

var $6fuj2 = parcelRequire("6fuj2");

var $cahqm = parcelRequire("cahqm");

var $jXNUH = parcelRequire("jXNUH");
class $7b8894582b845f07$export$715ba3385e9f2cf0 extends (0, $cahqm.BaseError) {
    constructor({ body: body, cause: cause, details: details, headers: headers, status: status, url: url }){
        super("HTTP request failed.", {
            cause: cause,
            details: details,
            metaMessages: [
                status && `Status: ${status}`,
                `URL: ${(0, $jXNUH.getUrl)(url)}`,
                body && `Request body: ${(0, $6fuj2.stringify)(body)}`
            ].filter(Boolean),
            name: "HttpRequestError"
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
    }
}
class $7b8894582b845f07$export$e1d72a3a26ed1bc extends (0, $cahqm.BaseError) {
    constructor({ body: body, cause: cause, details: details, url: url }){
        super("WebSocket request failed.", {
            cause: cause,
            details: details,
            metaMessages: [
                `URL: ${(0, $jXNUH.getUrl)(url)}`,
                body && `Request body: ${(0, $6fuj2.stringify)(body)}`
            ].filter(Boolean),
            name: "WebSocketRequestError"
        });
    }
}
class $7b8894582b845f07$export$a823590631c47261 extends (0, $cahqm.BaseError) {
    constructor({ body: body, error: error, url: url }){
        super("RPC Request failed.", {
            cause: error,
            details: error.message,
            metaMessages: [
                `URL: ${(0, $jXNUH.getUrl)(url)}`,
                `Request body: ${(0, $6fuj2.stringify)(body)}`
            ],
            name: "RpcRequestError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = error.code;
        this.data = error.data;
    }
}
class $7b8894582b845f07$export$a52f6cfb6f69ff4d extends (0, $cahqm.BaseError) {
    constructor({ url: url } = {}){
        super("The socket has been closed.", {
            metaMessages: [
                url && `URL: ${(0, $jXNUH.getUrl)(url)}`
            ].filter(Boolean),
            name: "SocketClosedError"
        });
    }
}
class $7b8894582b845f07$export$66d311bf29d5c89c extends (0, $cahqm.BaseError) {
    constructor({ body: body, url: url }){
        super("The request took too long to respond.", {
            details: "The request timed out.",
            metaMessages: [
                `URL: ${(0, $jXNUH.getUrl)(url)}`,
                `Request body: ${(0, $6fuj2.stringify)(body)}`
            ],
            name: "TimeoutError"
        });
    }
}

});

parcelRegister("cjGvc", function(module, exports) {

$parcel$export(module.exports, "call", function () { return $8f783a7527a14a97$export$848feb93d8f32b9b; });

var $jACxY = parcelRequire("jACxY");

var $gbEG8 = parcelRequire("gbEG8");

var $6Dftn = parcelRequire("6Dftn");

var $bBiK3 = parcelRequire("bBiK3");

var $6agEo = parcelRequire("6agEo");

var $cahqm = parcelRequire("cahqm");

var $iz4Cu = parcelRequire("iz4Cu");

var $hfefF = parcelRequire("hfefF");

var $dzDwb = parcelRequire("dzDwb");

var $fUU8L = parcelRequire("fUU8L");

var $aYJZ1 = parcelRequire("aYJZ1");

var $fVVQ8 = parcelRequire("fVVQ8");

var $jW8ut = parcelRequire("jW8ut");

var $3zih5 = parcelRequire("3zih5");

var $fcbjO = parcelRequire("fcbjO");

var $ksIKp = parcelRequire("ksIKp");

var $aeVPU = parcelRequire("aeVPU");

var $l7x0m = parcelRequire("l7x0m");

var $1OSs0 = parcelRequire("1OSs0");

async function $8f783a7527a14a97$export$848feb93d8f32b9b(client, args) {
    const { account: account_ = client.account, batch: batch = Boolean(client.batch?.multicall), blockNumber: blockNumber, blockTag: blockTag = "latest", accessList: accessList, blobs: blobs, code: code, data: data_, factory: factory, factoryData: factoryData, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, stateOverride: stateOverride, ...rest } = args;
    const account = account_ ? (0, $gbEG8.parseAccount)(account_) : undefined;
    if (code && (factory || factoryData)) throw new (0, $cahqm.BaseError)("Cannot provide both `code` & `factory`/`factoryData` as parameters.");
    if (code && to) throw new (0, $cahqm.BaseError)("Cannot provide both `code` & `to` as parameters.");
    // Check if the call is deployless via bytecode.
    const deploylessCallViaBytecode = code && data_;
    // Check if the call is deployless via a factory.
    const deploylessCallViaFactory = factory && factoryData && to && data_;
    const deploylessCall = deploylessCallViaBytecode || deploylessCallViaFactory;
    const data = (()=>{
        if (deploylessCallViaBytecode) return $8f783a7527a14a97$var$toDeploylessCallViaBytecodeData({
            code: code,
            data: data_
        });
        if (deploylessCallViaFactory) return $8f783a7527a14a97$var$toDeploylessCallViaFactoryData({
            data: data_,
            factory: factory,
            factoryData: factoryData,
            to: to
        });
        return data_;
    })();
    try {
        (0, $1OSs0.assertRequest)(args);
        const blockNumberHex = blockNumber ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcStateOverride = (0, $l7x0m.serializeStateOverride)(stateOverride);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $ksIKp.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $fcbjO.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            blobs: blobs,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerBlobGas: maxFeePerBlobGas,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: deploylessCall ? undefined : to,
            value: value
        });
        if (batch && $8f783a7527a14a97$var$shouldPerformMulticall({
            request: request
        }) && !rpcStateOverride) try {
            return await $8f783a7527a14a97$var$scheduleMulticall(client, {
                ...request,
                blockNumber: blockNumber,
                blockTag: blockTag
            });
        } catch (err) {
            if (!(err instanceof (0, $iz4Cu.ClientChainNotConfiguredError)) && !(err instanceof (0, $iz4Cu.ChainDoesNotSupportContract))) throw err;
        }
        const response = await client.request({
            method: "eth_call",
            params: rpcStateOverride ? [
                request,
                block,
                rpcStateOverride
            ] : [
                request,
                block
            ]
        });
        if (response === "0x") return {
            data: undefined
        };
        return {
            data: response
        };
    } catch (err) {
        const data = $8f783a7527a14a97$export$6ef1a527f868ca75(err);
        // Check for CCIP-Read offchain lookup signature.
        const { offchainLookup: offchainLookup, offchainLookupSignature: offchainLookupSignature } = await (parcelRequire("7Nmpn"));
        if (client.ccipRead !== false && data?.slice(0, 10) === offchainLookupSignature && to) return {
            data: await offchainLookup(client, {
                data: data,
                to: to
            })
        };
        // Check for counterfactual deployment error.
        if (deploylessCall && data?.slice(0, 10) === "0x101bb98d") throw new (0, $hfefF.CounterfactualDeploymentFailedError)({
            factory: factory
        });
        throw (0, $3zih5.getCallError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}
// We only want to perform a scheduled multicall if:
// - The request has calldata,
// - The request has a target address,
// - The target address is not already the aggregate3 signature,
// - The request has no other properties (`nonce`, `gas`, etc cannot be sent with a multicall).
function $8f783a7527a14a97$var$shouldPerformMulticall({ request: request }) {
    const { data: data, to: to, ...request_ } = request;
    if (!data) return false;
    if (data.startsWith((0, $bBiK3.aggregate3Signature))) return false;
    if (!to) return false;
    if (Object.values(request_).filter((x)=>typeof x !== "undefined").length > 0) return false;
    return true;
}
async function $8f783a7527a14a97$var$scheduleMulticall(client, args) {
    const { batchSize: batchSize = 1024, wait: wait = 0 } = typeof client.batch?.multicall === "object" ? client.batch.multicall : {};
    const { blockNumber: blockNumber, blockTag: blockTag = "latest", data: data, multicallAddress: multicallAddress_, to: to } = args;
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new (0, $iz4Cu.ClientChainNotConfiguredError)();
        multicallAddress = (0, $fVVQ8.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const blockNumberHex = blockNumber ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
    const block = blockNumberHex || blockTag;
    const { schedule: schedule } = (0, $aeVPU.createBatchScheduler)({
        id: `${client.uid}.${block}`,
        wait: wait,
        shouldSplitBatch (args) {
            const size = args.reduce((size, { data: data })=>size + (data.length - 2), 0);
            return size > batchSize * 2;
        },
        fn: async (requests)=>{
            const calls = requests.map((request)=>({
                    allowFailure: true,
                    callData: request.data,
                    target: request.to
                }));
            const calldata = (0, $aYJZ1.encodeFunctionData)({
                abi: (0, $6Dftn.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3"
            });
            const data = await client.request({
                method: "eth_call",
                params: [
                    {
                        data: calldata,
                        to: multicallAddress
                    },
                    block
                ]
            });
            return (0, $dzDwb.decodeFunctionResult)({
                abi: (0, $6Dftn.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3",
                data: data || "0x"
            });
        }
    });
    const [{ returnData: returnData, success: success }] = await schedule({
        data: data,
        to: to
    });
    if (!success) throw new (0, $hfefF.RawContractError)({
        data: returnData
    });
    if (returnData === "0x") return {
        data: undefined
    };
    return {
        data: returnData
    };
}
function $8f783a7527a14a97$var$toDeploylessCallViaBytecodeData(parameters) {
    const { code: code, data: data } = parameters;
    return (0, $fUU8L.encodeDeployData)({
        abi: (0, $jACxY.parseAbi)([
            "constructor(bytes, bytes)"
        ]),
        bytecode: (0, $6agEo.deploylessCallViaBytecodeBytecode),
        args: [
            code,
            data
        ]
    });
}
function $8f783a7527a14a97$var$toDeploylessCallViaFactoryData(parameters) {
    const { data: data, factory: factory, factoryData: factoryData, to: to } = parameters;
    return (0, $fUU8L.encodeDeployData)({
        abi: (0, $jACxY.parseAbi)([
            "constructor(address, bytes, address, bytes)"
        ]),
        bytecode: (0, $6agEo.deploylessCallViaFactoryBytecode),
        args: [
            to,
            data,
            factory,
            factoryData
        ]
    });
}
function $8f783a7527a14a97$export$6ef1a527f868ca75(err) {
    if (!(err instanceof (0, $cahqm.BaseError))) return undefined;
    const error = err.walk();
    return typeof error?.data === "object" ? error.data?.data : error.data;
}

});
parcelRegister("jACxY", function(module, exports) {

$parcel$export(module.exports, "parseAbi", function () { return $e42f47bf2b8e612f$export$4ab3f466fb8f069; });

var $3PjHL = parcelRequire("3PjHL");

var $jzGfv = parcelRequire("jzGfv");

var $4hT4E = parcelRequire("4hT4E");
function $e42f47bf2b8e612f$export$4ab3f466fb8f069(signatures) {
    const structs = (0, $jzGfv.parseStructs)(signatures);
    const abi = [];
    const length = signatures.length;
    for(let i = 0; i < length; i++){
        const signature = signatures[i];
        if ((0, $3PjHL.isStructSignature)(signature)) continue;
        abi.push((0, $4hT4E.parseSignature)(signature, structs));
    }
    return abi;
}

});
parcelRegister("3PjHL", function(module, exports) {

$parcel$export(module.exports, "isErrorSignature", function () { return $2c956b82f50da3f1$export$33be303020ecaff5; });
$parcel$export(module.exports, "execErrorSignature", function () { return $2c956b82f50da3f1$export$a8b67e842e5c116d; });
$parcel$export(module.exports, "isEventSignature", function () { return $2c956b82f50da3f1$export$7912f33b3b4526ca; });
$parcel$export(module.exports, "execEventSignature", function () { return $2c956b82f50da3f1$export$87d5ec49338ff6f; });
$parcel$export(module.exports, "isFunctionSignature", function () { return $2c956b82f50da3f1$export$fa8ae1a8bca33200; });
$parcel$export(module.exports, "execFunctionSignature", function () { return $2c956b82f50da3f1$export$8a14253893829398; });
$parcel$export(module.exports, "isStructSignature", function () { return $2c956b82f50da3f1$export$130f77ea18c25fb8; });
$parcel$export(module.exports, "execStructSignature", function () { return $2c956b82f50da3f1$export$432f3b6c467d7b70; });
$parcel$export(module.exports, "isConstructorSignature", function () { return $2c956b82f50da3f1$export$7ec9623fe58e8638; });
$parcel$export(module.exports, "execConstructorSignature", function () { return $2c956b82f50da3f1$export$4713f9c79c855460; });
$parcel$export(module.exports, "isFallbackSignature", function () { return $2c956b82f50da3f1$export$f99ebae7027f9f2f; });
$parcel$export(module.exports, "execFallbackSignature", function () { return $2c956b82f50da3f1$export$3a925f26585db196; });
$parcel$export(module.exports, "isReceiveSignature", function () { return $2c956b82f50da3f1$export$555d9bfe0f07ab3d; });
$parcel$export(module.exports, "modifiers", function () { return $2c956b82f50da3f1$export$c2f15f629432a51d; });
$parcel$export(module.exports, "eventModifiers", function () { return $2c956b82f50da3f1$export$e4045f69b6b17e16; });
$parcel$export(module.exports, "functionModifiers", function () { return $2c956b82f50da3f1$export$d304f1652f422b6b; });

var $1tjrf = parcelRequire("1tjrf");
// https://regexr.com/7gmok
const $2c956b82f50da3f1$var$errorSignatureRegex = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $2c956b82f50da3f1$export$33be303020ecaff5(signature) {
    return $2c956b82f50da3f1$var$errorSignatureRegex.test(signature);
}
function $2c956b82f50da3f1$export$a8b67e842e5c116d(signature) {
    return (0, $1tjrf.execTyped)($2c956b82f50da3f1$var$errorSignatureRegex, signature);
}
// https://regexr.com/7gmoq
const $2c956b82f50da3f1$var$eventSignatureRegex = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $2c956b82f50da3f1$export$7912f33b3b4526ca(signature) {
    return $2c956b82f50da3f1$var$eventSignatureRegex.test(signature);
}
function $2c956b82f50da3f1$export$87d5ec49338ff6f(signature) {
    return (0, $1tjrf.execTyped)($2c956b82f50da3f1$var$eventSignatureRegex, signature);
}
// https://regexr.com/7gmot
const $2c956b82f50da3f1$var$functionSignatureRegex = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function $2c956b82f50da3f1$export$fa8ae1a8bca33200(signature) {
    return $2c956b82f50da3f1$var$functionSignatureRegex.test(signature);
}
function $2c956b82f50da3f1$export$8a14253893829398(signature) {
    return (0, $1tjrf.execTyped)($2c956b82f50da3f1$var$functionSignatureRegex, signature);
}
// https://regexr.com/7gmp3
const $2c956b82f50da3f1$var$structSignatureRegex = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function $2c956b82f50da3f1$export$130f77ea18c25fb8(signature) {
    return $2c956b82f50da3f1$var$structSignatureRegex.test(signature);
}
function $2c956b82f50da3f1$export$432f3b6c467d7b70(signature) {
    return (0, $1tjrf.execTyped)($2c956b82f50da3f1$var$structSignatureRegex, signature);
}
// https://regexr.com/78u01
const $2c956b82f50da3f1$var$constructorSignatureRegex = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function $2c956b82f50da3f1$export$7ec9623fe58e8638(signature) {
    return $2c956b82f50da3f1$var$constructorSignatureRegex.test(signature);
}
function $2c956b82f50da3f1$export$4713f9c79c855460(signature) {
    return (0, $1tjrf.execTyped)($2c956b82f50da3f1$var$constructorSignatureRegex, signature);
}
// https://regexr.com/7srtn
const $2c956b82f50da3f1$var$fallbackSignatureRegex = /^fallback\(\) external(?:\s(?<stateMutability>payable{1}))?$/;
function $2c956b82f50da3f1$export$f99ebae7027f9f2f(signature) {
    return $2c956b82f50da3f1$var$fallbackSignatureRegex.test(signature);
}
function $2c956b82f50da3f1$export$3a925f26585db196(signature) {
    return (0, $1tjrf.execTyped)($2c956b82f50da3f1$var$fallbackSignatureRegex, signature);
}
// https://regexr.com/78u1k
const $2c956b82f50da3f1$var$receiveSignatureRegex = /^receive\(\) external payable$/;
function $2c956b82f50da3f1$export$555d9bfe0f07ab3d(signature) {
    return $2c956b82f50da3f1$var$receiveSignatureRegex.test(signature);
}
const $2c956b82f50da3f1$export$c2f15f629432a51d = new Set([
    "memory",
    "indexed",
    "storage",
    "calldata"
]);
const $2c956b82f50da3f1$export$e4045f69b6b17e16 = new Set([
    "indexed"
]);
const $2c956b82f50da3f1$export$d304f1652f422b6b = new Set([
    "calldata",
    "memory",
    "storage"
]);

});

parcelRegister("jzGfv", function(module, exports) {

$parcel$export(module.exports, "parseStructs", function () { return $e4020f021afcee95$export$6e5e6f927c48b857; });

var $1tjrf = parcelRequire("1tjrf");

var $16aXz = parcelRequire("16aXz");

var $02ifr = parcelRequire("02ifr");

var $5bUPq = parcelRequire("5bUPq");

var $jIzP7 = parcelRequire("jIzP7");

var $3PjHL = parcelRequire("3PjHL");

var $4hT4E = parcelRequire("4hT4E");
function $e4020f021afcee95$export$6e5e6f927c48b857(signatures) {
    // Create "shallow" version of each struct (and filter out non-structs or invalid structs)
    const shallowStructs = {};
    const signaturesLength = signatures.length;
    for(let i = 0; i < signaturesLength; i++){
        const signature = signatures[i];
        if (!(0, $3PjHL.isStructSignature)(signature)) continue;
        const match = (0, $3PjHL.execStructSignature)(signature);
        if (!match) throw new (0, $5bUPq.InvalidSignatureError)({
            signature: signature,
            type: "struct"
        });
        const properties = match.properties.split(";");
        const components = [];
        const propertiesLength = properties.length;
        for(let k = 0; k < propertiesLength; k++){
            const property = properties[k];
            const trimmed = property.trim();
            if (!trimmed) continue;
            const abiParameter = (0, $4hT4E.parseAbiParameter)(trimmed, {
                type: "struct"
            });
            components.push(abiParameter);
        }
        if (!components.length) throw new (0, $5bUPq.InvalidStructSignatureError)({
            signature: signature
        });
        shallowStructs[match.name] = components;
    }
    // Resolve nested structs inside each parameter
    const resolvedStructs = {};
    const entries = Object.entries(shallowStructs);
    const entriesLength = entries.length;
    for(let i = 0; i < entriesLength; i++){
        const [name, parameters] = entries[i];
        resolvedStructs[name] = $e4020f021afcee95$var$resolveStructs(parameters, shallowStructs);
    }
    return resolvedStructs;
}
const $e4020f021afcee95$var$typeWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function $e4020f021afcee95$var$resolveStructs(abiParameters, structs, ancestors = new Set()) {
    const components = [];
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        const isTuple = (0, $1tjrf.isTupleRegex).test(abiParameter.type);
        if (isTuple) components.push(abiParameter);
        else {
            const match = (0, $1tjrf.execTyped)($e4020f021afcee95$var$typeWithoutTupleRegex, abiParameter.type);
            if (!match?.type) throw new (0, $02ifr.InvalidAbiTypeParameterError)({
                abiParameter: abiParameter
            });
            const { array: array, type: type } = match;
            if (type in structs) {
                if (ancestors.has(type)) throw new (0, $jIzP7.CircularReferenceError)({
                    type: type
                });
                components.push({
                    ...abiParameter,
                    type: `tuple${array ?? ""}`,
                    components: $e4020f021afcee95$var$resolveStructs(structs[type] ?? [], structs, new Set([
                        ...ancestors,
                        type
                    ]))
                });
            } else {
                if ((0, $4hT4E.isSolidityType)(type)) components.push(abiParameter);
                else throw new (0, $16aXz.UnknownTypeError)({
                    type: type
                });
            }
        }
    }
    return components;
}

});
parcelRegister("16aXz", function(module, exports) {

$parcel$export(module.exports, "InvalidAbiItemError", function () { return $0cceda5b5fb5d8ae$export$a4e0854b60f599b6; });
$parcel$export(module.exports, "UnknownTypeError", function () { return $0cceda5b5fb5d8ae$export$9e77a92da3bcd5ca; });
$parcel$export(module.exports, "UnknownSolidityTypeError", function () { return $0cceda5b5fb5d8ae$export$5a36348a2ac471a3; });

var $ggoPp = parcelRequire("ggoPp");
class $0cceda5b5fb5d8ae$export$a4e0854b60f599b6 extends (0, $ggoPp.BaseError) {
    constructor({ signature: signature }){
        super("Failed to parse ABI item.", {
            details: `parseAbiItem(${JSON.stringify(signature, null, 2)})`,
            docsPath: "/api/human#parseabiitem-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiItemError"
        });
    }
}
class $0cceda5b5fb5d8ae$export$9e77a92da3bcd5ca extends (0, $ggoPp.BaseError) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownTypeError"
        });
    }
}
class $0cceda5b5fb5d8ae$export$5a36348a2ac471a3 extends (0, $ggoPp.BaseError) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSolidityTypeError"
        });
    }
}

});
parcelRegister("ggoPp", function(module, exports) {

$parcel$export(module.exports, "BaseError", function () { return $bd71664c599436d2$export$a490eb03cb7a0a5e; });

var $jOqQx = parcelRequire("jOqQx");
class $bd71664c599436d2$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = args.cause instanceof $bd71664c599436d2$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $bd71664c599436d2$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: https://abitype.dev${docsPath}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: abitype@${(0, $jOqQx.version)}`
        ].join("\n");
        super(message);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiTypeError"
        });
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
}

});
parcelRegister("jOqQx", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e6c782f9642f2e72$export$83d89fbfd8236492; });
const $e6c782f9642f2e72$export$83d89fbfd8236492 = "1.0.8";

});



parcelRegister("02ifr", function(module, exports) {

$parcel$export(module.exports, "InvalidAbiParametersError", function () { return $006e57b6ea4a1213$export$f35df31806e96ff; });
$parcel$export(module.exports, "InvalidParameterError", function () { return $006e57b6ea4a1213$export$e569b97a5d46005c; });
$parcel$export(module.exports, "SolidityProtectedKeywordError", function () { return $006e57b6ea4a1213$export$58697cc8f790f211; });
$parcel$export(module.exports, "InvalidModifierError", function () { return $006e57b6ea4a1213$export$f837e6b0dee0e468; });
$parcel$export(module.exports, "InvalidFunctionModifierError", function () { return $006e57b6ea4a1213$export$7afd0f25b8fdbbd8; });
$parcel$export(module.exports, "InvalidAbiTypeParameterError", function () { return $006e57b6ea4a1213$export$b5451545b6c52dc8; });

var $ggoPp = parcelRequire("ggoPp");
class $006e57b6ea4a1213$export$bdcd4054531f5b35 extends (0, $ggoPp.BaseError) {
    constructor({ param: param }){
        super("Failed to parse ABI parameter.", {
            details: `parseAbiParameter(${JSON.stringify(param, null, 2)})`,
            docsPath: "/api/human#parseabiparameter-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParameterError"
        });
    }
}
class $006e57b6ea4a1213$export$f35df31806e96ff extends (0, $ggoPp.BaseError) {
    constructor({ params: params }){
        super("Failed to parse ABI parameters.", {
            details: `parseAbiParameters(${JSON.stringify(params, null, 2)})`,
            docsPath: "/api/human#parseabiparameters-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParametersError"
        });
    }
}
class $006e57b6ea4a1213$export$e569b97a5d46005c extends (0, $ggoPp.BaseError) {
    constructor({ param: param }){
        super("Invalid ABI parameter.", {
            details: param
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParameterError"
        });
    }
}
class $006e57b6ea4a1213$export$58697cc8f790f211 extends (0, $ggoPp.BaseError) {
    constructor({ param: param, name: name }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `"${name}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SolidityProtectedKeywordError"
        });
    }
}
class $006e57b6ea4a1213$export$f837e6b0dee0e468 extends (0, $ggoPp.BaseError) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidModifierError"
        });
    }
}
class $006e57b6ea4a1213$export$7afd0f25b8fdbbd8 extends (0, $ggoPp.BaseError) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`,
                `Data location can only be specified for array, struct, or mapping types, but "${modifier}" was given.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidFunctionModifierError"
        });
    }
}
class $006e57b6ea4a1213$export$b5451545b6c52dc8 extends (0, $ggoPp.BaseError) {
    constructor({ abiParameter: abiParameter }){
        super("Invalid ABI parameter.", {
            details: JSON.stringify(abiParameter, null, 2),
            metaMessages: [
                "ABI parameter type is invalid."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiTypeParameterError"
        });
    }
}

});

parcelRegister("5bUPq", function(module, exports) {

$parcel$export(module.exports, "InvalidSignatureError", function () { return $3c7a0fc7b6e64fb0$export$ccc2f68ef106615a; });
$parcel$export(module.exports, "UnknownSignatureError", function () { return $3c7a0fc7b6e64fb0$export$3727c00c40963d37; });
$parcel$export(module.exports, "InvalidStructSignatureError", function () { return $3c7a0fc7b6e64fb0$export$769955518e5ea753; });

var $ggoPp = parcelRequire("ggoPp");
class $3c7a0fc7b6e64fb0$export$ccc2f68ef106615a extends (0, $ggoPp.BaseError) {
    constructor({ signature: signature, type: type }){
        super(`Invalid ${type} signature.`, {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSignatureError"
        });
    }
}
class $3c7a0fc7b6e64fb0$export$3727c00c40963d37 extends (0, $ggoPp.BaseError) {
    constructor({ signature: signature }){
        super("Unknown signature.", {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSignatureError"
        });
    }
}
class $3c7a0fc7b6e64fb0$export$769955518e5ea753 extends (0, $ggoPp.BaseError) {
    constructor({ signature: signature }){
        super("Invalid struct signature.", {
            details: signature,
            metaMessages: [
                "No properties exist."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidStructSignatureError"
        });
    }
}

});

parcelRegister("jIzP7", function(module, exports) {

$parcel$export(module.exports, "CircularReferenceError", function () { return $e5adea2990de34c6$export$3b7cb2315fb6b103; });

var $ggoPp = parcelRequire("ggoPp");
class $e5adea2990de34c6$export$3b7cb2315fb6b103 extends (0, $ggoPp.BaseError) {
    constructor({ type: type }){
        super("Circular reference detected.", {
            metaMessages: [
                `Struct "${type}" is a circular reference.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "CircularReferenceError"
        });
    }
}

});

parcelRegister("4hT4E", function(module, exports) {

$parcel$export(module.exports, "parseSignature", function () { return $31f378883ceec683$export$dc1dc22ccf24efef; });
$parcel$export(module.exports, "splitParameters", function () { return $31f378883ceec683$export$8350908b11ff5aef; });
$parcel$export(module.exports, "parseAbiParameter", function () { return $31f378883ceec683$export$357229f9e2d85552; });
$parcel$export(module.exports, "isSolidityType", function () { return $31f378883ceec683$export$640ecc6f40db6417; });

var $1tjrf = parcelRequire("1tjrf");

var $16aXz = parcelRequire("16aXz");

var $02ifr = parcelRequire("02ifr");

var $5bUPq = parcelRequire("5bUPq");

var $gz28G = parcelRequire("gz28G");

var $1tyVB = parcelRequire("1tyVB");

var $3PjHL = parcelRequire("3PjHL");
function $31f378883ceec683$export$dc1dc22ccf24efef(signature, structs = {}) {
    if ((0, $3PjHL.isFunctionSignature)(signature)) return $31f378883ceec683$export$d79eb8ab55e2a331(signature, structs);
    if ((0, $3PjHL.isEventSignature)(signature)) return $31f378883ceec683$export$25d6467a8776aab1(signature, structs);
    if ((0, $3PjHL.isErrorSignature)(signature)) return $31f378883ceec683$export$c1ace8fbd46164f1(signature, structs);
    if ((0, $3PjHL.isConstructorSignature)(signature)) return $31f378883ceec683$export$57fb927a1bb13269(signature, structs);
    if ((0, $3PjHL.isFallbackSignature)(signature)) return $31f378883ceec683$export$59f3352106efd66(signature);
    if ((0, $3PjHL.isReceiveSignature)(signature)) return {
        type: "receive",
        stateMutability: "payable"
    };
    throw new (0, $5bUPq.UnknownSignatureError)({
        signature: signature
    });
}
function $31f378883ceec683$export$d79eb8ab55e2a331(signature, structs = {}) {
    const match = (0, $3PjHL.execFunctionSignature)(signature);
    if (!match) throw new (0, $5bUPq.InvalidSignatureError)({
        signature: signature,
        type: "function"
    });
    const inputParams = $31f378883ceec683$export$8350908b11ff5aef(match.parameters);
    const inputs = [];
    const inputLength = inputParams.length;
    for(let i = 0; i < inputLength; i++)inputs.push($31f378883ceec683$export$357229f9e2d85552(inputParams[i], {
        modifiers: (0, $3PjHL.functionModifiers),
        structs: structs,
        type: "function"
    }));
    const outputs = [];
    if (match.returns) {
        const outputParams = $31f378883ceec683$export$8350908b11ff5aef(match.returns);
        const outputLength = outputParams.length;
        for(let i = 0; i < outputLength; i++)outputs.push($31f378883ceec683$export$357229f9e2d85552(outputParams[i], {
            modifiers: (0, $3PjHL.functionModifiers),
            structs: structs,
            type: "function"
        }));
    }
    return {
        name: match.name,
        type: "function",
        stateMutability: match.stateMutability ?? "nonpayable",
        inputs: inputs,
        outputs: outputs
    };
}
function $31f378883ceec683$export$25d6467a8776aab1(signature, structs = {}) {
    const match = (0, $3PjHL.execEventSignature)(signature);
    if (!match) throw new (0, $5bUPq.InvalidSignatureError)({
        signature: signature,
        type: "event"
    });
    const params = $31f378883ceec683$export$8350908b11ff5aef(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for(let i = 0; i < length; i++)abiParameters.push($31f378883ceec683$export$357229f9e2d85552(params[i], {
        modifiers: (0, $3PjHL.eventModifiers),
        structs: structs,
        type: "event"
    }));
    return {
        name: match.name,
        type: "event",
        inputs: abiParameters
    };
}
function $31f378883ceec683$export$c1ace8fbd46164f1(signature, structs = {}) {
    const match = (0, $3PjHL.execErrorSignature)(signature);
    if (!match) throw new (0, $5bUPq.InvalidSignatureError)({
        signature: signature,
        type: "error"
    });
    const params = $31f378883ceec683$export$8350908b11ff5aef(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for(let i = 0; i < length; i++)abiParameters.push($31f378883ceec683$export$357229f9e2d85552(params[i], {
        structs: structs,
        type: "error"
    }));
    return {
        name: match.name,
        type: "error",
        inputs: abiParameters
    };
}
function $31f378883ceec683$export$57fb927a1bb13269(signature, structs = {}) {
    const match = (0, $3PjHL.execConstructorSignature)(signature);
    if (!match) throw new (0, $5bUPq.InvalidSignatureError)({
        signature: signature,
        type: "constructor"
    });
    const params = $31f378883ceec683$export$8350908b11ff5aef(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for(let i = 0; i < length; i++)abiParameters.push($31f378883ceec683$export$357229f9e2d85552(params[i], {
        structs: structs,
        type: "constructor"
    }));
    return {
        type: "constructor",
        stateMutability: match.stateMutability ?? "nonpayable",
        inputs: abiParameters
    };
}
function $31f378883ceec683$export$59f3352106efd66(signature) {
    const match = (0, $3PjHL.execFallbackSignature)(signature);
    if (!match) throw new (0, $5bUPq.InvalidSignatureError)({
        signature: signature,
        type: "fallback"
    });
    return {
        type: "fallback",
        stateMutability: match.stateMutability ?? "nonpayable"
    };
}
const $31f378883ceec683$var$abiParameterWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $31f378883ceec683$var$abiParameterWithTupleRegex = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $31f378883ceec683$var$dynamicIntegerRegex = /^u?int$/;
function $31f378883ceec683$export$357229f9e2d85552(param, options) {
    // optional namespace cache by `type`
    const parameterCacheKey = (0, $1tyVB.getParameterCacheKey)(param, options?.type, options?.structs);
    if ((0, $1tyVB.parameterCache).has(parameterCacheKey)) return (0, $1tyVB.parameterCache).get(parameterCacheKey);
    const isTuple = (0, $1tjrf.isTupleRegex).test(param);
    const match = (0, $1tjrf.execTyped)(isTuple ? $31f378883ceec683$var$abiParameterWithTupleRegex : $31f378883ceec683$var$abiParameterWithoutTupleRegex, param);
    if (!match) throw new (0, $02ifr.InvalidParameterError)({
        param: param
    });
    if (match.name && $31f378883ceec683$export$d83e1b8970d84409(match.name)) throw new (0, $02ifr.SolidityProtectedKeywordError)({
        param: param,
        name: match.name
    });
    const name = match.name ? {
        name: match.name
    } : {};
    const indexed = match.modifier === "indexed" ? {
        indexed: true
    } : {};
    const structs = options?.structs ?? {};
    let type;
    let components = {};
    if (isTuple) {
        type = "tuple";
        const params = $31f378883ceec683$export$8350908b11ff5aef(match.type);
        const components_ = [];
        const length = params.length;
        for(let i = 0; i < length; i++)// remove `modifiers` from `options` to prevent from being added to tuple components
        components_.push($31f378883ceec683$export$357229f9e2d85552(params[i], {
            structs: structs
        }));
        components = {
            components: components_
        };
    } else if (match.type in structs) {
        type = "tuple";
        components = {
            components: structs[match.type]
        };
    } else if ($31f378883ceec683$var$dynamicIntegerRegex.test(match.type)) type = `${match.type}256`;
    else {
        type = match.type;
        if (!(options?.type === "struct") && !$31f378883ceec683$export$640ecc6f40db6417(type)) throw new (0, $16aXz.UnknownSolidityTypeError)({
            type: type
        });
    }
    if (match.modifier) {
        // Check if modifier exists, but is not allowed (e.g. `indexed` in `functionModifiers`)
        if (!options?.modifiers?.has?.(match.modifier)) throw new (0, $02ifr.InvalidModifierError)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
        // Check if resolved `type` is valid if there is a function modifier
        if ((0, $3PjHL.functionModifiers).has(match.modifier) && !$31f378883ceec683$export$7265528696368a9(type, !!match.array)) throw new (0, $02ifr.InvalidFunctionModifierError)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
    }
    const abiParameter = {
        type: `${type}${match.array ?? ""}`,
        ...name,
        ...indexed,
        ...components
    };
    (0, $1tyVB.parameterCache).set(parameterCacheKey, abiParameter);
    return abiParameter;
}
function $31f378883ceec683$export$8350908b11ff5aef(params, result = [], current = "", depth = 0) {
    const length = params.trim().length;
    // biome-ignore lint/correctness/noUnreachable: recursive
    for(let i = 0; i < length; i++){
        const char = params[i];
        const tail = params.slice(i + 1);
        switch(char){
            case ",":
                return depth === 0 ? $31f378883ceec683$export$8350908b11ff5aef(tail, [
                    ...result,
                    current.trim()
                ]) : $31f378883ceec683$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
            case "(":
                return $31f378883ceec683$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth + 1);
            case ")":
                return $31f378883ceec683$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth - 1);
            default:
                return $31f378883ceec683$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
        }
    }
    if (current === "") return result;
    if (depth !== 0) throw new (0, $gz28G.InvalidParenthesisError)({
        current: current,
        depth: depth
    });
    result.push(current.trim());
    return result;
}
function $31f378883ceec683$export$640ecc6f40db6417(type) {
    return type === "address" || type === "bool" || type === "function" || type === "string" || (0, $1tjrf.bytesRegex).test(type) || (0, $1tjrf.integerRegex).test(type);
}
const $31f378883ceec683$var$protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function $31f378883ceec683$export$d83e1b8970d84409(name) {
    return name === "address" || name === "bool" || name === "function" || name === "string" || name === "tuple" || (0, $1tjrf.bytesRegex).test(name) || (0, $1tjrf.integerRegex).test(name) || $31f378883ceec683$var$protectedKeywordsRegex.test(name);
}
function $31f378883ceec683$export$7265528696368a9(type, isArray) {
    return isArray || type === "bytes" || type === "string" || type === "tuple";
}

});
parcelRegister("gz28G", function(module, exports) {

$parcel$export(module.exports, "InvalidParenthesisError", function () { return $c0f192f8ffea022c$export$a13d6673dbe1ad6e; });

var $ggoPp = parcelRequire("ggoPp");
class $c0f192f8ffea022c$export$a13d6673dbe1ad6e extends (0, $ggoPp.BaseError) {
    constructor({ current: current, depth: depth }){
        super("Unbalanced parentheses.", {
            metaMessages: [
                `"${current.trim()}" has too many ${depth > 0 ? "opening" : "closing"} parentheses.`
            ],
            details: `Depth "${depth}"`
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParenthesisError"
        });
    }
}

});

parcelRegister("1tyVB", function(module, exports) {

$parcel$export(module.exports, "getParameterCacheKey", function () { return $113397e11309ce90$export$516f1eedf0355404; });
$parcel$export(module.exports, "parameterCache", function () { return $113397e11309ce90$export$da1654d628010643; });
/**
 * Gets {@link parameterCache} cache key namespaced by {@link type}. This prevents parameters from being accessible to types that don't allow them (e.g. `string indexed foo` not allowed outside of `type: 'event'`).
 * @param param ABI parameter string
 * @param type ABI parameter type
 * @returns Cache key for {@link parameterCache}
 */ function $113397e11309ce90$export$516f1eedf0355404(param, type, structs) {
    let structKey = "";
    if (structs) for (const struct of Object.entries(structs)){
        if (!struct) continue;
        let propertyKey = "";
        for (const property of struct[1])propertyKey += `[${property.type}${property.name ? `:${property.name}` : ""}]`;
        structKey += `(${struct[0]}{${propertyKey}})`;
    }
    if (type) return `${type}:${param}${structKey}`;
    return param;
}
const $113397e11309ce90$export$da1654d628010643 = new Map([
    // Unnamed
    [
        "address",
        {
            type: "address"
        }
    ],
    [
        "bool",
        {
            type: "bool"
        }
    ],
    [
        "bytes",
        {
            type: "bytes"
        }
    ],
    [
        "bytes32",
        {
            type: "bytes32"
        }
    ],
    [
        "int",
        {
            type: "int256"
        }
    ],
    [
        "int256",
        {
            type: "int256"
        }
    ],
    [
        "string",
        {
            type: "string"
        }
    ],
    [
        "uint",
        {
            type: "uint256"
        }
    ],
    [
        "uint8",
        {
            type: "uint8"
        }
    ],
    [
        "uint16",
        {
            type: "uint16"
        }
    ],
    [
        "uint24",
        {
            type: "uint24"
        }
    ],
    [
        "uint32",
        {
            type: "uint32"
        }
    ],
    [
        "uint64",
        {
            type: "uint64"
        }
    ],
    [
        "uint96",
        {
            type: "uint96"
        }
    ],
    [
        "uint112",
        {
            type: "uint112"
        }
    ],
    [
        "uint160",
        {
            type: "uint160"
        }
    ],
    [
        "uint192",
        {
            type: "uint192"
        }
    ],
    [
        "uint256",
        {
            type: "uint256"
        }
    ],
    // Named
    [
        "address owner",
        {
            type: "address",
            name: "owner"
        }
    ],
    [
        "address to",
        {
            type: "address",
            name: "to"
        }
    ],
    [
        "bool approved",
        {
            type: "bool",
            name: "approved"
        }
    ],
    [
        "bytes _data",
        {
            type: "bytes",
            name: "_data"
        }
    ],
    [
        "bytes data",
        {
            type: "bytes",
            name: "data"
        }
    ],
    [
        "bytes signature",
        {
            type: "bytes",
            name: "signature"
        }
    ],
    [
        "bytes32 hash",
        {
            type: "bytes32",
            name: "hash"
        }
    ],
    [
        "bytes32 r",
        {
            type: "bytes32",
            name: "r"
        }
    ],
    [
        "bytes32 root",
        {
            type: "bytes32",
            name: "root"
        }
    ],
    [
        "bytes32 s",
        {
            type: "bytes32",
            name: "s"
        }
    ],
    [
        "string name",
        {
            type: "string",
            name: "name"
        }
    ],
    [
        "string symbol",
        {
            type: "string",
            name: "symbol"
        }
    ],
    [
        "string tokenURI",
        {
            type: "string",
            name: "tokenURI"
        }
    ],
    [
        "uint tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint8 v",
        {
            type: "uint8",
            name: "v"
        }
    ],
    [
        "uint256 balance",
        {
            type: "uint256",
            name: "balance"
        }
    ],
    [
        "uint256 tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint256 value",
        {
            type: "uint256",
            name: "value"
        }
    ],
    // Indexed
    [
        "event:address indexed from",
        {
            type: "address",
            name: "from",
            indexed: true
        }
    ],
    [
        "event:address indexed to",
        {
            type: "address",
            name: "to",
            indexed: true
        }
    ],
    [
        "event:uint indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ],
    [
        "event:uint256 indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ]
]);

});




parcelRegister("gbEG8", function(module, exports) {

$parcel$export(module.exports, "parseAccount", function () { return $bc8d3a577a712bb1$export$11027cbf6cf15da2; });
function $bc8d3a577a712bb1$export$11027cbf6cf15da2(account) {
    if (typeof account === "string") return {
        address: account,
        type: "json-rpc"
    };
    return account;
}

});

parcelRegister("6Dftn", function(module, exports) {

$parcel$export(module.exports, "multicall3Abi", function () { return $4d42632d98b60b1d$export$4e233219477ffb48; });
$parcel$export(module.exports, "universalResolverResolveAbi", function () { return $4d42632d98b60b1d$export$400f1d40cf4f98fe; });
$parcel$export(module.exports, "universalResolverReverseAbi", function () { return $4d42632d98b60b1d$export$fd0db820daeebac9; });
$parcel$export(module.exports, "textResolverAbi", function () { return $4d42632d98b60b1d$export$4e6990b9fd834e88; });
$parcel$export(module.exports, "addressResolverAbi", function () { return $4d42632d98b60b1d$export$4c61cc2994c5d90b; });
$parcel$export(module.exports, "universalSignatureValidatorAbi", function () { return $4d42632d98b60b1d$export$b10682c3fa53fbd1; });
$parcel$export(module.exports, "erc20Abi", function () { return $4d42632d98b60b1d$export$891152826cc2370a; });
/* [Multicall3](https://github.com/mds1/multicall) */ const $4d42632d98b60b1d$export$4e233219477ffb48 = [
    {
        inputs: [
            {
                components: [
                    {
                        name: "target",
                        type: "address"
                    },
                    {
                        name: "allowFailure",
                        type: "bool"
                    },
                    {
                        name: "callData",
                        type: "bytes"
                    }
                ],
                name: "calls",
                type: "tuple[]"
            }
        ],
        name: "aggregate3",
        outputs: [
            {
                components: [
                    {
                        name: "success",
                        type: "bool"
                    },
                    {
                        name: "returnData",
                        type: "bytes"
                    }
                ],
                name: "returnData",
                type: "tuple[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $4d42632d98b60b1d$var$universalResolverErrors = [
    {
        inputs: [],
        name: "ResolverNotFound",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverWildcardNotSupported",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverNotContract",
        type: "error"
    },
    {
        inputs: [
            {
                name: "returnData",
                type: "bytes"
            }
        ],
        name: "ResolverError",
        type: "error"
    },
    {
        inputs: [
            {
                components: [
                    {
                        name: "status",
                        type: "uint16"
                    },
                    {
                        name: "message",
                        type: "string"
                    }
                ],
                name: "errors",
                type: "tuple[]"
            }
        ],
        name: "HttpError",
        type: "error"
    }
];
const $4d42632d98b60b1d$export$400f1d40cf4f98fe = [
    ...$4d42632d98b60b1d$var$universalResolverErrors,
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    },
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            },
            {
                name: "gateways",
                type: "string[]"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    }
];
const $4d42632d98b60b1d$export$fd0db820daeebac9 = [
    ...$4d42632d98b60b1d$var$universalResolverErrors,
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    },
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            },
            {
                type: "string[]",
                name: "gateways"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    }
];
const $4d42632d98b60b1d$export$4e6990b9fd834e88 = [
    {
        name: "text",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "key",
                type: "string"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    }
];
const $4d42632d98b60b1d$export$4c61cc2994c5d90b = [
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "coinType",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            }
        ]
    }
];
const $4d42632d98b60b1d$export$429a705aa5b352c0 = [
    {
        name: "isValidSignature",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "hash",
                type: "bytes32"
            },
            {
                name: "signature",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes4"
            }
        ]
    }
];
const $4d42632d98b60b1d$export$b10682c3fa53fbd1 = [
    {
        inputs: [
            {
                name: "_signer",
                type: "address"
            },
            {
                name: "_hash",
                type: "bytes32"
            },
            {
                name: "_signature",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                name: "_signer",
                type: "address"
            },
            {
                name: "_hash",
                type: "bytes32"
            },
            {
                name: "_signature",
                type: "bytes"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function",
        name: "isValidSig"
    }
];
const $4d42632d98b60b1d$export$891152826cc2370a = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];
const $4d42632d98b60b1d$export$1c8d119bf9c799eb = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];
const $4d42632d98b60b1d$export$da6511eb7df6e9f8 = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                name: "approved",
                type: "bool"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "payable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "getApproved",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "isApprovedForAll",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "operator",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "ownerOf",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "owner",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "id",
                type: "uint256"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "setApprovalForAll",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "operator",
                type: "address"
            },
            {
                name: "approved",
                type: "bool"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenURI",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "tokeId",
                type: "uint256"
            }
        ],
        outputs: []
    }
];
const $4d42632d98b60b1d$export$82934a3bb3a99370 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Deposit",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Withdraw",
        type: "event"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                name: "assetTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "deposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxDeposit",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxMint",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxRedeem",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxWithdraw",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "mint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewDeposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewMint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewRedeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewWithdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "redeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                name: "totalManagedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "withdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];

});

parcelRegister("bBiK3", function(module, exports) {

$parcel$export(module.exports, "aggregate3Signature", function () { return $8721b0239fc44786$export$25fd9a7ba13a8409; });
const $8721b0239fc44786$export$25fd9a7ba13a8409 = "0x82ad56cb";

});

parcelRegister("6agEo", function(module, exports) {

$parcel$export(module.exports, "deploylessCallViaBytecodeBytecode", function () { return $47d097b6ccf439fa$export$b8650f6504de1536; });
$parcel$export(module.exports, "deploylessCallViaFactoryBytecode", function () { return $47d097b6ccf439fa$export$b03493bdbcb80605; });
$parcel$export(module.exports, "universalSignatureValidatorByteCode", function () { return $47d097b6ccf439fa$export$76c7202cd92b9dbb; });
const $47d097b6ccf439fa$export$b8650f6504de1536 = "0x608060405234801561001057600080fd5b5060405161018e38038061018e83398101604081905261002f91610124565b6000808351602085016000f59050803b61004857600080fd5b6000808351602085016000855af16040513d6000823e81610067573d81fd5b3d81f35b634e487b7160e01b600052604160045260246000fd5b600082601f83011261009257600080fd5b81516001600160401b038111156100ab576100ab61006b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156100d9576100d961006b565b6040528181528382016020018510156100f157600080fd5b60005b82811015610110576020818601810151838301820152016100f4565b506000918101602001919091529392505050565b6000806040838503121561013757600080fd5b82516001600160401b0381111561014d57600080fd5b61015985828601610081565b602085015190935090506001600160401b0381111561017757600080fd5b61018385828601610081565b915050925092905056fe";
const $47d097b6ccf439fa$export$b03493bdbcb80605 = "0x608060405234801561001057600080fd5b506040516102c03803806102c083398101604081905261002f916101e6565b836001600160a01b03163b6000036100e457600080836001600160a01b03168360405161005c9190610270565b6000604051808303816000865af19150503d8060008114610099576040519150601f19603f3d011682016040523d82523d6000602084013e61009e565b606091505b50915091508115806100b857506001600160a01b0386163b155b156100e1578060405163101bb98d60e01b81526004016100d8919061028c565b60405180910390fd5b50505b6000808451602086016000885af16040513d6000823e81610103573d81fd5b3d81f35b80516001600160a01b038116811461011e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561015457818101518382015260200161013c565b50506000910152565b600082601f83011261016e57600080fd5b81516001600160401b0381111561018757610187610123565b604051601f8201601f19908116603f011681016001600160401b03811182821017156101b5576101b5610123565b6040528181528382016020018510156101cd57600080fd5b6101de826020830160208701610139565b949350505050565b600080600080608085870312156101fc57600080fd5b61020585610107565b60208601519094506001600160401b0381111561022157600080fd5b61022d8782880161015d565b93505061023c60408601610107565b60608601519092506001600160401b0381111561025857600080fd5b6102648782880161015d565b91505092959194509250565b60008251610282818460208701610139565b9190910192915050565b60208152600082518060208401526102ab816040850160208701610139565b601f01601f1916919091016040019291505056fe";
const $47d097b6ccf439fa$export$76c7202cd92b9dbb = "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";

});

parcelRegister("iz4Cu", function(module, exports) {

$parcel$export(module.exports, "ChainDoesNotSupportContract", function () { return $d83f1444711eeb29$export$f2b2bfa70417796b; });
$parcel$export(module.exports, "ChainMismatchError", function () { return $d83f1444711eeb29$export$535d82255cc17992; });
$parcel$export(module.exports, "ChainNotFoundError", function () { return $d83f1444711eeb29$export$b7f33b26fea1ae0b; });
$parcel$export(module.exports, "ClientChainNotConfiguredError", function () { return $d83f1444711eeb29$export$64807f0e18658482; });
$parcel$export(module.exports, "InvalidChainIdError", function () { return $d83f1444711eeb29$export$4836eb835ffca5b2; });

var $cahqm = parcelRequire("cahqm");
class $d83f1444711eeb29$export$f2b2bfa70417796b extends (0, $cahqm.BaseError) {
    constructor({ blockNumber: blockNumber, chain: chain, contract: contract }){
        super(`Chain "${chain.name}" does not support contract "${contract.name}".`, {
            metaMessages: [
                "This could be due to any of the following:",
                ...blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? [
                    `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`
                ] : [
                    `- The chain does not have the contract "${contract.name}" configured.`
                ]
            ],
            name: "ChainDoesNotSupportContract"
        });
    }
}
class $d83f1444711eeb29$export$535d82255cc17992 extends (0, $cahqm.BaseError) {
    constructor({ chain: chain, currentChainId: currentChainId }){
        super(`The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} \u{2013} ${chain.name}).`, {
            metaMessages: [
                `Current Chain ID:  ${currentChainId}`,
                `Expected Chain ID: ${chain.id} \u{2013} ${chain.name}`
            ],
            name: "ChainMismatchError"
        });
    }
}
class $d83f1444711eeb29$export$b7f33b26fea1ae0b extends (0, $cahqm.BaseError) {
    constructor(){
        super([
            "No chain was provided to the request.",
            "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
        ].join("\n"), {
            name: "ChainNotFoundError"
        });
    }
}
class $d83f1444711eeb29$export$64807f0e18658482 extends (0, $cahqm.BaseError) {
    constructor(){
        super("No chain was provided to the Client.", {
            name: "ClientChainNotConfiguredError"
        });
    }
}
class $d83f1444711eeb29$export$4836eb835ffca5b2 extends (0, $cahqm.BaseError) {
    constructor({ chainId: chainId }){
        super(typeof chainId === "number" ? `Chain ID "${chainId}" is invalid.` : "Chain ID is invalid.", {
            name: "InvalidChainIdError"
        });
    }
}

});

parcelRegister("hfefF", function(module, exports) {

$parcel$export(module.exports, "CallExecutionError", function () { return $c8dee47a7ce866ab$export$e67b04e2cd29b7d; });
$parcel$export(module.exports, "ContractFunctionExecutionError", function () { return $c8dee47a7ce866ab$export$399e62fddbe24423; });
$parcel$export(module.exports, "ContractFunctionRevertedError", function () { return $c8dee47a7ce866ab$export$b3a6b9663001535f; });
$parcel$export(module.exports, "ContractFunctionZeroDataError", function () { return $c8dee47a7ce866ab$export$46f5208cdcd5a621; });
$parcel$export(module.exports, "CounterfactualDeploymentFailedError", function () { return $c8dee47a7ce866ab$export$4fec38f081e68d02; });
$parcel$export(module.exports, "RawContractError", function () { return $c8dee47a7ce866ab$export$5b877bc4d7d9d460; });

var $gbEG8 = parcelRequire("gbEG8");

var $4a4RY = parcelRequire("4a4RY");

var $f1Ntt = parcelRequire("f1Ntt");

var $c3VTt = parcelRequire("c3VTt");

var $gmmgT = parcelRequire("gmmgT");

var $3BoTD = parcelRequire("3BoTD");

var $g36WF = parcelRequire("g36WF");

var $6yGUx = parcelRequire("6yGUx");

var $8p1we = parcelRequire("8p1we");

var $cahqm = parcelRequire("cahqm");

var $2IagT = parcelRequire("2IagT");

var $3a3vr = parcelRequire("3a3vr");

var $jXNUH = parcelRequire("jXNUH");
class $c8dee47a7ce866ab$export$e67b04e2cd29b7d extends (0, $cahqm.BaseError) {
    constructor(cause, { account: account_, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, stateOverride: stateOverride }){
        const account = account_ ? (0, $gbEG8.parseAccount)(account_) : undefined;
        let prettyArgs = (0, $3a3vr.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $g36WF.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $6yGUx.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $6yGUx.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $6yGUx.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        if (stateOverride) prettyArgs += `\n${(0, $2IagT.prettyStateOverride)(stateOverride)}`;
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Raw Call Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "CallExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class $c8dee47a7ce866ab$export$399e62fddbe24423 extends (0, $cahqm.BaseError) {
    constructor(cause, { abi: abi, args: args, contractAddress: contractAddress, docsPath: docsPath, functionName: functionName, sender: sender }){
        const abiItem = (0, $3BoTD.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        const formattedArgs = abiItem ? (0, $gmmgT.formatAbiItemWithArgs)({
            abiItem: abiItem,
            args: args,
            includeFunctionName: false,
            includeName: false
        }) : undefined;
        const functionWithParams = abiItem ? (0, $c3VTt.formatAbiItem)(abiItem, {
            includeName: true
        }) : undefined;
        const prettyArgs = (0, $3a3vr.prettyPrint)({
            address: contractAddress && (0, $jXNUH.getContractAddress)(contractAddress),
            function: functionWithParams,
            args: formattedArgs && formattedArgs !== "()" && `${[
                ...Array(functionName?.length ?? 0).keys()
            ].map(()=>" ").join("")}${formattedArgs}`,
            sender: sender
        });
        super(cause.shortMessage || `An unknown error occurred while executing the contract function "${functionName}".`, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                prettyArgs && "Contract Call:",
                prettyArgs
            ].filter(Boolean),
            name: "ContractFunctionExecutionError"
        });
        Object.defineProperty(this, "abi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formattedArgs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "functionName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abi = abi;
        this.args = args;
        this.cause = cause;
        this.contractAddress = contractAddress;
        this.functionName = functionName;
        this.sender = sender;
    }
}
class $c8dee47a7ce866ab$export$b3a6b9663001535f extends (0, $cahqm.BaseError) {
    constructor({ abi: abi, data: data, functionName: functionName, message: message }){
        let cause;
        let decodedData = undefined;
        let metaMessages;
        let reason;
        if (data && data !== "0x") try {
            decodedData = (0, $f1Ntt.decodeErrorResult)({
                abi: abi,
                data: data
            });
            const { abiItem: abiItem, errorName: errorName, args: errorArgs } = decodedData;
            if (errorName === "Error") reason = errorArgs[0];
            else if (errorName === "Panic") {
                const [firstArg] = errorArgs;
                reason = (0, $4a4RY.panicReasons)[firstArg];
            } else {
                const errorWithParams = abiItem ? (0, $c3VTt.formatAbiItem)(abiItem, {
                    includeName: true
                }) : undefined;
                const formattedArgs = abiItem && errorArgs ? (0, $gmmgT.formatAbiItemWithArgs)({
                    abiItem: abiItem,
                    args: errorArgs,
                    includeFunctionName: false,
                    includeName: false
                }) : undefined;
                metaMessages = [
                    errorWithParams ? `Error: ${errorWithParams}` : "",
                    formattedArgs && formattedArgs !== "()" ? `       ${[
                        ...Array(errorName?.length ?? 0).keys()
                    ].map(()=>" ").join("")}${formattedArgs}` : ""
                ];
            }
        } catch (err) {
            cause = err;
        }
        else if (message) reason = message;
        let signature;
        if (cause instanceof (0, $8p1we.AbiErrorSignatureNotFoundError)) {
            signature = cause.signature;
            metaMessages = [
                `Unable to decode signature "${signature}" as it was not found on the provided ABI.`,
                "Make sure you are using the correct ABI and that the error exists on it.",
                `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
            ];
        }
        super(reason && reason !== "execution reverted" || signature ? [
            `The contract function "${functionName}" reverted with the following ${signature ? "signature" : "reason"}:`,
            reason || signature
        ].join("\n") : `The contract function "${functionName}" reverted.`, {
            cause: cause,
            metaMessages: metaMessages,
            name: "ContractFunctionRevertedError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "raw", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = decodedData;
        this.raw = data;
        this.reason = reason;
        this.signature = signature;
    }
}
class $c8dee47a7ce866ab$export$46f5208cdcd5a621 extends (0, $cahqm.BaseError) {
    constructor({ functionName: functionName }){
        super(`The contract function "${functionName}" returned no data ("0x").`, {
            metaMessages: [
                "This could be due to any of the following:",
                `  - The contract does not have the function "${functionName}",`,
                "  - The parameters passed to the contract function may be invalid, or",
                "  - The address is not a contract."
            ],
            name: "ContractFunctionZeroDataError"
        });
    }
}
class $c8dee47a7ce866ab$export$4fec38f081e68d02 extends (0, $cahqm.BaseError) {
    constructor({ factory: factory }){
        super(`Deployment for counterfactual contract call failed${factory ? ` for factory "${factory}".` : ""}`, {
            metaMessages: [
                "Please ensure:",
                "- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).",
                "- The `factoryData` is a valid encoded function call for contract deployment function on the factory."
            ],
            name: "CounterfactualDeploymentFailedError"
        });
    }
}
class $c8dee47a7ce866ab$export$5b877bc4d7d9d460 extends (0, $cahqm.BaseError) {
    constructor({ data: data, message: message }){
        super(message || "", {
            name: "RawContractError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
    }
}

});
parcelRegister("gmmgT", function(module, exports) {

$parcel$export(module.exports, "formatAbiItemWithArgs", function () { return $be8ffa0affe32ddd$export$5266ec2b0e3e9205; });

var $6fuj2 = parcelRequire("6fuj2");
function $be8ffa0affe32ddd$export$5266ec2b0e3e9205({ abiItem: abiItem, args: args, includeFunctionName: includeFunctionName = true, includeName: includeName = false }) {
    if (!("name" in abiItem)) return;
    if (!("inputs" in abiItem)) return;
    if (!abiItem.inputs) return;
    return `${includeFunctionName ? abiItem.name : ""}(${abiItem.inputs.map((input, i)=>`${includeName && input.name ? `${input.name}: ` : ""}${typeof args[i] === "object" ? (0, $6fuj2.stringify)(args[i]) : args[i]}`).join(", ")})`;
}

});

parcelRegister("3BoTD", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", function () { return $29f823b41aa04b2f$export$99b134cd177e9574; });

var $8p1we = parcelRequire("8p1we");

var $16Qvp = parcelRequire("16Qvp");

var $8Ghey = parcelRequire("8Ghey");

var $1VVjR = parcelRequire("1VVjR");

var $9BbzE = parcelRequire("9BbzE");
function $29f823b41aa04b2f$export$99b134cd177e9574(parameters) {
    const { abi: abi, args: args = [], name: name } = parameters;
    const isSelector = (0, $16Qvp.isHex)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === "function") return (0, $9BbzE.toFunctionSelector)(abiItem) === name;
            if (abiItem.type === "event") return (0, $1VVjR.toEventSelector)(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!("inputs" in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $29f823b41aa04b2f$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $29f823b41aa04b2f$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $8p1we.AbiItemAmbiguityError)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $29f823b41aa04b2f$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return (0, $8Ghey.isAddress)(arg, {
                strict: false
            });
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $29f823b41aa04b2f$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$29f823b41aa04b2f$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            return false;
    }
}
function $29f823b41aa04b2f$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return $29f823b41aa04b2f$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return (0, $8Ghey.isAddress)(args[parameterIndex], {
                strict: false
            });
            if (types.includes("address") && types.includes("bytes")) return (0, $8Ghey.isAddress)(args[parameterIndex], {
                strict: false
            });
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}

});
parcelRegister("1VVjR", function(module, exports) {

$parcel$export(module.exports, "toEventSelector", function () { return $168793b835557826$export$351f40ec61b2972; });

var $brzgk = parcelRequire("brzgk");
const $168793b835557826$export$351f40ec61b2972 = (0, $brzgk.toSignatureHash);

});


parcelRegister("g36WF", function(module, exports) {

$parcel$export(module.exports, "formatEther", function () { return $baf2505571480956$export$11bc63b4c03ea518; });

var $3IKOD = parcelRequire("3IKOD");

var $iwa3L = parcelRequire("iwa3L");
function $baf2505571480956$export$11bc63b4c03ea518(wei, unit = "wei") {
    return (0, $iwa3L.formatUnits)(wei, (0, $3IKOD.etherUnits)[unit]);
}

});
parcelRegister("3IKOD", function(module, exports) {

$parcel$export(module.exports, "etherUnits", function () { return $2b59cbc2461dee37$export$5bbd813111ed9646; });
$parcel$export(module.exports, "gweiUnits", function () { return $2b59cbc2461dee37$export$a26120bf8be88528; });
$parcel$export(module.exports, "weiUnits", function () { return $2b59cbc2461dee37$export$b959b3594ea07183; });
const $2b59cbc2461dee37$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
const $2b59cbc2461dee37$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
const $2b59cbc2461dee37$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});

parcelRegister("iwa3L", function(module, exports) {

$parcel$export(module.exports, "formatUnits", function () { return $d7b304d363c6be6a$export$bd39b96f71da1885; });
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $d7b304d363c6be6a$export$bd39b96f71da1885(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith("-");
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, "0");
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ];
    fraction = fraction.replace(/(0+)$/, "");
    return `${negative ? "-" : ""}${integer || "0"}${fraction ? `.${fraction}` : ""}`;
}

});


parcelRegister("6yGUx", function(module, exports) {

$parcel$export(module.exports, "formatGwei", function () { return $4c67343fd55fb8b8$export$a716d64a7f646b61; });

var $3IKOD = parcelRequire("3IKOD");

var $iwa3L = parcelRequire("iwa3L");
function $4c67343fd55fb8b8$export$a716d64a7f646b61(wei, unit = "wei") {
    return (0, $iwa3L.formatUnits)(wei, (0, $3IKOD.gweiUnits)[unit]);
}

});

parcelRegister("2IagT", function(module, exports) {

$parcel$export(module.exports, "AccountStateConflictError", function () { return $1f97a885e158b71a$export$eb92af66de2d34c1; });
$parcel$export(module.exports, "StateAssignmentConflictError", function () { return $1f97a885e158b71a$export$3f829f5a43fdcc2e; });
$parcel$export(module.exports, "prettyStateOverride", function () { return $1f97a885e158b71a$export$d08c47f9c4a87c67; });

var $cahqm = parcelRequire("cahqm");
class $1f97a885e158b71a$export$eb92af66de2d34c1 extends (0, $cahqm.BaseError) {
    constructor({ address: address }){
        super(`State for account "${address}" is set multiple times.`, {
            name: "AccountStateConflictError"
        });
    }
}
class $1f97a885e158b71a$export$3f829f5a43fdcc2e extends (0, $cahqm.BaseError) {
    constructor(){
        super("state and stateDiff are set on the same account.", {
            name: "StateAssignmentConflictError"
        });
    }
}
function $1f97a885e158b71a$export$4afb15becff191ad(stateMapping) {
    return stateMapping.reduce((pretty, { slot: slot, value: value })=>{
        return `${pretty}        ${slot}: ${value}\n`;
    }, "");
}
function $1f97a885e158b71a$export$d08c47f9c4a87c67(stateOverride) {
    return stateOverride.reduce((pretty, { address: address, ...state })=>{
        let val = `${pretty}    ${address}:\n`;
        if (state.nonce) val += `      nonce: ${state.nonce}\n`;
        if (state.balance) val += `      balance: ${state.balance}\n`;
        if (state.code) val += `      code: ${state.code}\n`;
        if (state.state) {
            val += "      state:\n";
            val += $1f97a885e158b71a$export$4afb15becff191ad(state.state);
        }
        if (state.stateDiff) {
            val += "      stateDiff:\n";
            val += $1f97a885e158b71a$export$4afb15becff191ad(state.stateDiff);
        }
        return val;
    }, "  State Override:\n").slice(0, -1);
}

});

parcelRegister("3a3vr", function(module, exports) {

$parcel$export(module.exports, "prettyPrint", function () { return $24d506873f89f031$export$cde3d1388a9feac3; });
$parcel$export(module.exports, "FeeConflictError", function () { return $24d506873f89f031$export$4e13f9693b10724d; });
$parcel$export(module.exports, "InvalidLegacyVError", function () { return $24d506873f89f031$export$8ffce3f13fa2ade4; });
$parcel$export(module.exports, "InvalidSerializableTransactionError", function () { return $24d506873f89f031$export$f2282ba9c8899971; });
$parcel$export(module.exports, "InvalidStorageKeySizeError", function () { return $24d506873f89f031$export$f5e370fd7cd91580; });
$parcel$export(module.exports, "TransactionExecutionError", function () { return $24d506873f89f031$export$17fc407b5aeb1e96; });
$parcel$export(module.exports, "TransactionNotFoundError", function () { return $24d506873f89f031$export$23c42bc218867b7c; });
$parcel$export(module.exports, "TransactionReceiptNotFoundError", function () { return $24d506873f89f031$export$df65591684d92652; });
$parcel$export(module.exports, "WaitForTransactionReceiptTimeoutError", function () { return $24d506873f89f031$export$69578a09754f4b33; });

var $g36WF = parcelRequire("g36WF");

var $6yGUx = parcelRequire("6yGUx");

var $cahqm = parcelRequire("cahqm");
function $24d506873f89f031$export$cde3d1388a9feac3(args) {
    const entries = Object.entries(args).map(([key, value])=>{
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    const maxLength = entries.reduce((acc, [key])=>Math.max(acc, key.length), 0);
    return entries.map(([key, value])=>`  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}
class $24d506873f89f031$export$4e13f9693b10724d extends (0, $cahqm.BaseError) {
    constructor(){
        super([
            "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
            "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
        ].join("\n"), {
            name: "FeeConflictError"
        });
    }
}
class $24d506873f89f031$export$8ffce3f13fa2ade4 extends (0, $cahqm.BaseError) {
    constructor({ v: v }){
        super(`Invalid \`v\` value "${v}". Expected 27 or 28.`, {
            name: "InvalidLegacyVError"
        });
    }
}
class $24d506873f89f031$export$f2282ba9c8899971 extends (0, $cahqm.BaseError) {
    constructor({ transaction: transaction }){
        super("Cannot infer a transaction type from provided transaction.", {
            metaMessages: [
                "Provided Transaction:",
                "{",
                $24d506873f89f031$export$cde3d1388a9feac3(transaction),
                "}",
                "",
                "To infer the type, either provide:",
                "- a `type` to the Transaction, or",
                "- an EIP-1559 Transaction with `maxFeePerGas`, or",
                "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
                "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
                "- an EIP-7702 Transaction with `authorizationList`, or",
                "- a Legacy Transaction with `gasPrice`"
            ],
            name: "InvalidSerializableTransactionError"
        });
    }
}
class $24d506873f89f031$export$e410925d6bb07863 extends (0, $cahqm.BaseError) {
    constructor({ serializedType: serializedType }){
        super(`Serialized transaction type "${serializedType}" is invalid.`, {
            name: "InvalidSerializedTransactionType"
        });
        Object.defineProperty(this, "serializedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedType = serializedType;
    }
}
class $24d506873f89f031$export$75fa267d8b74b3b9 extends (0, $cahqm.BaseError) {
    constructor({ attributes: attributes, serializedTransaction: serializedTransaction, type: type }){
        const missing = Object.entries(attributes).map(([key, value])=>typeof value === "undefined" ? key : undefined).filter(Boolean);
        super(`Invalid serialized transaction of type "${type}" was provided.`, {
            metaMessages: [
                `Serialized Transaction: "${serializedTransaction}"`,
                missing.length > 0 ? `Missing Attributes: ${missing.join(", ")}` : ""
            ].filter(Boolean),
            name: "InvalidSerializedTransactionError"
        });
        Object.defineProperty(this, "serializedTransaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedTransaction = serializedTransaction;
        this.type = type;
    }
}
class $24d506873f89f031$export$f5e370fd7cd91580 extends (0, $cahqm.BaseError) {
    constructor({ storageKey: storageKey }){
        super(`Size for storage key "${storageKey}" is invalid. Expected 32 bytes. Got ${Math.floor((storageKey.length - 2) / 2)} bytes.`, {
            name: "InvalidStorageKeySizeError"
        });
    }
}
class $24d506873f89f031$export$17fc407b5aeb1e96 extends (0, $cahqm.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = $24d506873f89f031$export$cde3d1388a9feac3({
            chain: chain && `${chain?.name} (id: ${chain?.id})`,
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $g36WF.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $6yGUx.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $6yGUx.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $6yGUx.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Request Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "TransactionExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class $24d506873f89f031$export$23c42bc218867b7c extends (0, $cahqm.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag, hash: hash, index: index }){
        let identifier = "Transaction";
        if (blockTag && index !== undefined) identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
        if (blockHash && index !== undefined) identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
        if (blockNumber && index !== undefined) identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
        if (hash) identifier = `Transaction with hash "${hash}"`;
        super(`${identifier} could not be found.`, {
            name: "TransactionNotFoundError"
        });
    }
}
class $24d506873f89f031$export$df65591684d92652 extends (0, $cahqm.BaseError) {
    constructor({ hash: hash }){
        super(`Transaction receipt with hash "${hash}" could not be found. The Transaction may not be processed on a block yet.`, {
            name: "TransactionReceiptNotFoundError"
        });
    }
}
class $24d506873f89f031$export$69578a09754f4b33 extends (0, $cahqm.BaseError) {
    constructor({ hash: hash }){
        super(`Timed out while waiting for transaction with hash "${hash}" to be confirmed.`, {
            name: "WaitForTransactionReceiptTimeoutError"
        });
    }
}

});


parcelRegister("dzDwb", function(module, exports) {

$parcel$export(module.exports, "decodeFunctionResult", function () { return $9e1d32b5ee2e999c$export$3a05a90c230f925; });

var $8p1we = parcelRequire("8p1we");

var $hCHkb = parcelRequire("hCHkb");

var $3BoTD = parcelRequire("3BoTD");
const $9e1d32b5ee2e999c$var$docsPath = "/docs/contract/decodeFunctionResult";
function $9e1d32b5ee2e999c$export$3a05a90c230f925(parameters) {
    const { abi: abi, args: args, functionName: functionName, data: data } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $3BoTD.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $8p1we.AbiFunctionNotFoundError)(functionName, {
            docsPath: $9e1d32b5ee2e999c$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $8p1we.AbiFunctionNotFoundError)(undefined, {
        docsPath: $9e1d32b5ee2e999c$var$docsPath
    });
    if (!abiItem.outputs) throw new (0, $8p1we.AbiFunctionOutputsNotFoundError)(abiItem.name, {
        docsPath: $9e1d32b5ee2e999c$var$docsPath
    });
    const values = (0, $hCHkb.decodeAbiParameters)(abiItem.outputs, data);
    if (values && values.length > 1) return values;
    if (values && values.length === 1) return values[0];
    return undefined;
}

});

parcelRegister("fUU8L", function(module, exports) {

$parcel$export(module.exports, "encodeDeployData", function () { return $b967a24e2d6900e1$export$d7a7276006273fbd; });

var $8p1we = parcelRequire("8p1we");

var $jnwfF = parcelRequire("jnwfF");

var $hxvKS = parcelRequire("hxvKS");
const $b967a24e2d6900e1$var$docsPath = "/docs/contract/encodeDeployData";
function $b967a24e2d6900e1$export$d7a7276006273fbd(parameters) {
    const { abi: abi, args: args, bytecode: bytecode } = parameters;
    if (!args || args.length === 0) return bytecode;
    const description = abi.find((x)=>"type" in x && x.type === "constructor");
    if (!description) throw new (0, $8p1we.AbiConstructorNotFoundError)({
        docsPath: $b967a24e2d6900e1$var$docsPath
    });
    if (!("inputs" in description)) throw new (0, $8p1we.AbiConstructorParamsNotFoundError)({
        docsPath: $b967a24e2d6900e1$var$docsPath
    });
    if (!description.inputs || description.inputs.length === 0) throw new (0, $8p1we.AbiConstructorParamsNotFoundError)({
        docsPath: $b967a24e2d6900e1$var$docsPath
    });
    const data = (0, $hxvKS.encodeAbiParameters)(description.inputs, args);
    return (0, $jnwfF.concatHex)([
        bytecode,
        data
    ]);
}

});

parcelRegister("aYJZ1", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", function () { return $7fe32d43ce401daa$export$f4ee15df45da9f03; });

var $jnwfF = parcelRequire("jnwfF");

var $hxvKS = parcelRequire("hxvKS");

var $6qkR3 = parcelRequire("6qkR3");
function $7fe32d43ce401daa$export$f4ee15df45da9f03(parameters) {
    const { args: args } = parameters;
    const { abi: abi, functionName: functionName } = (()=>{
        if (parameters.abi.length === 1 && parameters.functionName?.startsWith("0x")) return parameters;
        return (0, $6qkR3.prepareEncodeFunctionData)(parameters);
    })();
    const abiItem = abi[0];
    const signature = functionName;
    const data = "inputs" in abiItem && abiItem.inputs ? (0, $hxvKS.encodeAbiParameters)(abiItem.inputs, args ?? []) : undefined;
    return (0, $jnwfF.concatHex)([
        signature,
        data ?? "0x"
    ]);
}

});
parcelRegister("6qkR3", function(module, exports) {

$parcel$export(module.exports, "prepareEncodeFunctionData", function () { return $4ad559125fc48cb1$export$bb3e0a434581ff8; });

var $8p1we = parcelRequire("8p1we");

var $9BbzE = parcelRequire("9BbzE");

var $c3VTt = parcelRequire("c3VTt");

var $3BoTD = parcelRequire("3BoTD");
const $4ad559125fc48cb1$var$docsPath = "/docs/contract/encodeFunctionData";
function $4ad559125fc48cb1$export$bb3e0a434581ff8(parameters) {
    const { abi: abi, args: args, functionName: functionName } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $3BoTD.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $8p1we.AbiFunctionNotFoundError)(functionName, {
            docsPath: $4ad559125fc48cb1$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $8p1we.AbiFunctionNotFoundError)(undefined, {
        docsPath: $4ad559125fc48cb1$var$docsPath
    });
    return {
        abi: [
            abiItem
        ],
        functionName: (0, $9BbzE.toFunctionSelector)((0, $c3VTt.formatAbiItem)(abiItem))
    };
}

});


parcelRegister("fVVQ8", function(module, exports) {

$parcel$export(module.exports, "getChainContractAddress", function () { return $b9990bac3f567db7$export$cf4414608a078996; });

var $iz4Cu = parcelRequire("iz4Cu");
function $b9990bac3f567db7$export$cf4414608a078996({ blockNumber: blockNumber, chain: chain, contract: name }) {
    const contract = chain?.contracts?.[name];
    if (!contract) throw new (0, $iz4Cu.ChainDoesNotSupportContract)({
        chain: chain,
        contract: {
            name: name
        }
    });
    if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber) throw new (0, $iz4Cu.ChainDoesNotSupportContract)({
        blockNumber: blockNumber,
        chain: chain,
        contract: {
            name: name,
            blockCreated: contract.blockCreated
        }
    });
    return contract.address;
}

});

parcelRegister("3zih5", function(module, exports) {

$parcel$export(module.exports, "getCallError", function () { return $2992d0f10a8acf0f$export$7a3a4dfb724485e1; });

var $hfefF = parcelRequire("hfefF");

var $iWaDR = parcelRequire("iWaDR");

var $iZm7e = parcelRequire("iZm7e");
function $2992d0f10a8acf0f$export$7a3a4dfb724485e1(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $iZm7e.getNodeError)(err, args);
        if (cause instanceof (0, $iWaDR.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $hfefF.CallExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});
parcelRegister("iWaDR", function(module, exports) {

$parcel$export(module.exports, "ExecutionRevertedError", function () { return $dc95e6048f133d4f$export$a558573a20f90d54; });
$parcel$export(module.exports, "FeeCapTooHighError", function () { return $dc95e6048f133d4f$export$63c545de2a2ec844; });
$parcel$export(module.exports, "FeeCapTooLowError", function () { return $dc95e6048f133d4f$export$dbd5936ae1758966; });
$parcel$export(module.exports, "NonceTooHighError", function () { return $dc95e6048f133d4f$export$6147426561fdc965; });
$parcel$export(module.exports, "NonceTooLowError", function () { return $dc95e6048f133d4f$export$2bb6d6395b589b3b; });
$parcel$export(module.exports, "NonceMaxValueError", function () { return $dc95e6048f133d4f$export$71cf1d500f9be262; });
$parcel$export(module.exports, "InsufficientFundsError", function () { return $dc95e6048f133d4f$export$b276096bbba16879; });
$parcel$export(module.exports, "IntrinsicGasTooHighError", function () { return $dc95e6048f133d4f$export$7ad883b4998b9615; });
$parcel$export(module.exports, "IntrinsicGasTooLowError", function () { return $dc95e6048f133d4f$export$813ccdcce0428bcf; });
$parcel$export(module.exports, "TransactionTypeNotSupportedError", function () { return $dc95e6048f133d4f$export$a20c52a8beca5c20; });
$parcel$export(module.exports, "TipAboveFeeCapError", function () { return $dc95e6048f133d4f$export$6ef9dd5e2f836046; });
$parcel$export(module.exports, "UnknownNodeError", function () { return $dc95e6048f133d4f$export$d6085363229de344; });

var $6yGUx = parcelRequire("6yGUx");

var $cahqm = parcelRequire("cahqm");
class $dc95e6048f133d4f$export$a558573a20f90d54 extends (0, $cahqm.BaseError) {
    constructor({ cause: cause, message: message } = {}){
        const reason = message?.replace("execution reverted: ", "")?.replace("execution reverted", "");
        super(`Execution reverted ${reason ? `with reason: ${reason}` : "for an unknown reason"}.`, {
            cause: cause,
            name: "ExecutionRevertedError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$a558573a20f90d54, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty($dc95e6048f133d4f$export$a558573a20f90d54, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /execution reverted/
});
class $dc95e6048f133d4f$export$63c545de2a2ec844 extends (0, $cahqm.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $6yGUx.formatGwei)(maxFeePerGas)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
            cause: cause,
            name: "FeeCapTooHighError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$63c545de2a2ec844, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class $dc95e6048f133d4f$export$dbd5936ae1758966 extends (0, $cahqm.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $6yGUx.formatGwei)(maxFeePerGas)}` : ""} gwei) cannot be lower than the block base fee.`, {
            cause: cause,
            name: "FeeCapTooLowError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$dbd5936ae1758966, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class $dc95e6048f133d4f$export$6147426561fdc965 extends (0, $cahqm.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is higher than the next one expected.`, {
            cause: cause,
            name: "NonceTooHighError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$6147426561fdc965, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too high/
});
class $dc95e6048f133d4f$export$2bb6d6395b589b3b extends (0, $cahqm.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super([
            `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is lower than the current nonce of the account.`,
            "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
        ].join("\n"), {
            cause: cause,
            name: "NonceTooLowError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$2bb6d6395b589b3b, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too low|transaction already imported|already known/
});
class $dc95e6048f133d4f$export$71cf1d500f9be262 extends (0, $cahqm.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}exceeds the maximum allowed nonce.`, {
            cause: cause,
            name: "NonceMaxValueError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$71cf1d500f9be262, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce has max value/
});
class $dc95e6048f133d4f$export$b276096bbba16879 extends (0, $cahqm.BaseError) {
    constructor({ cause: cause } = {}){
        super([
            "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
        ].join("\n"), {
            cause: cause,
            metaMessages: [
                "This error could arise when the account does not have enough funds to:",
                " - pay for the total gas fee,",
                " - pay for the value to send.",
                " ",
                "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
                " - `gas` is the amount of gas needed for transaction to execute,",
                " - `gas fee` is the gas fee,",
                " - `value` is the amount of ether to send to the recipient."
            ],
            name: "InsufficientFundsError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$b276096bbba16879, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /insufficient funds|exceeds transaction sender account balance/
});
class $dc95e6048f133d4f$export$7ad883b4998b9615 extends (0, $cahqm.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
            cause: cause,
            name: "IntrinsicGasTooHighError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$7ad883b4998b9615, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too high|gas limit reached/
});
class $dc95e6048f133d4f$export$813ccdcce0428bcf extends (0, $cahqm.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction is too low.`, {
            cause: cause,
            name: "IntrinsicGasTooLowError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$813ccdcce0428bcf, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too low/
});
class $dc95e6048f133d4f$export$a20c52a8beca5c20 extends (0, $cahqm.BaseError) {
    constructor({ cause: cause }){
        super("The transaction type is not supported for this chain.", {
            cause: cause,
            name: "TransactionTypeNotSupportedError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$a20c52a8beca5c20, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /transaction type not valid/
});
class $dc95e6048f133d4f$export$6ef9dd5e2f836046 extends (0, $cahqm.BaseError) {
    constructor({ cause: cause, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas } = {}){
        super([
            `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas ? ` = ${(0, $6yGUx.formatGwei)(maxPriorityFeePerGas)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $6yGUx.formatGwei)(maxFeePerGas)} gwei` : ""}).`
        ].join("\n"), {
            cause: cause,
            name: "TipAboveFeeCapError"
        });
    }
}
Object.defineProperty($dc95e6048f133d4f$export$6ef9dd5e2f836046, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class $dc95e6048f133d4f$export$d6085363229de344 extends (0, $cahqm.BaseError) {
    constructor({ cause: cause }){
        super(`An error occurred while executing: ${cause?.shortMessage}`, {
            cause: cause,
            name: "UnknownNodeError"
        });
    }
}

});

parcelRegister("iZm7e", function(module, exports) {

$parcel$export(module.exports, "getNodeError", function () { return $dd2f14317d584599$export$218ee3a1c831c34e; });

var $cahqm = parcelRequire("cahqm");

var $iWaDR = parcelRequire("iWaDR");

var $aBz5G = parcelRequire("aBz5G");

var $iy34j = parcelRequire("iy34j");
function $dd2f14317d584599$export$620efda101db5601(err) {
    return err instanceof (0, $iy34j.TransactionRejectedRpcError) || err instanceof (0, $iy34j.InvalidInputRpcError) || err instanceof (0, $aBz5G.RpcRequestError) && err.code === (0, $iWaDR.ExecutionRevertedError).code;
}
function $dd2f14317d584599$export$218ee3a1c831c34e(err, args) {
    const message = (err.details || "").toLowerCase();
    const executionRevertedError = err instanceof (0, $cahqm.BaseError) ? err.walk((e)=>e?.code === (0, $iWaDR.ExecutionRevertedError).code) : err;
    if (executionRevertedError instanceof (0, $cahqm.BaseError)) return new (0, $iWaDR.ExecutionRevertedError)({
        cause: err,
        message: executionRevertedError.details
    });
    if ((0, $iWaDR.ExecutionRevertedError).nodeMessage.test(message)) return new (0, $iWaDR.ExecutionRevertedError)({
        cause: err,
        message: err.details
    });
    if ((0, $iWaDR.FeeCapTooHighError).nodeMessage.test(message)) return new (0, $iWaDR.FeeCapTooHighError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $iWaDR.FeeCapTooLowError).nodeMessage.test(message)) return new (0, $iWaDR.FeeCapTooLowError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $iWaDR.NonceTooHighError).nodeMessage.test(message)) return new (0, $iWaDR.NonceTooHighError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $iWaDR.NonceTooLowError).nodeMessage.test(message)) return new (0, $iWaDR.NonceTooLowError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $iWaDR.NonceMaxValueError).nodeMessage.test(message)) return new (0, $iWaDR.NonceMaxValueError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $iWaDR.InsufficientFundsError).nodeMessage.test(message)) return new (0, $iWaDR.InsufficientFundsError)({
        cause: err
    });
    if ((0, $iWaDR.IntrinsicGasTooHighError).nodeMessage.test(message)) return new (0, $iWaDR.IntrinsicGasTooHighError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $iWaDR.IntrinsicGasTooLowError).nodeMessage.test(message)) return new (0, $iWaDR.IntrinsicGasTooLowError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $iWaDR.TransactionTypeNotSupportedError).nodeMessage.test(message)) return new (0, $iWaDR.TransactionTypeNotSupportedError)({
        cause: err
    });
    if ((0, $iWaDR.TipAboveFeeCapError).nodeMessage.test(message)) return new (0, $iWaDR.TipAboveFeeCapError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas,
        maxPriorityFeePerGas: args?.maxPriorityFeePerGas
    });
    return new (0, $iWaDR.UnknownNodeError)({
        cause: err
    });
}

});
parcelRegister("iy34j", function(module, exports) {

$parcel$export(module.exports, "ParseRpcError", function () { return $d80dc857752c072d$export$aa31e6432f136746; });
$parcel$export(module.exports, "InvalidRequestRpcError", function () { return $d80dc857752c072d$export$ff7b9f15f3eb8d4d; });
$parcel$export(module.exports, "MethodNotFoundRpcError", function () { return $d80dc857752c072d$export$4c4044ac99c8d2d3; });
$parcel$export(module.exports, "InvalidParamsRpcError", function () { return $d80dc857752c072d$export$c600faffd3cbd390; });
$parcel$export(module.exports, "InternalRpcError", function () { return $d80dc857752c072d$export$4e62fafb20e19fd7; });
$parcel$export(module.exports, "InvalidInputRpcError", function () { return $d80dc857752c072d$export$3ba2994324ab015e; });
$parcel$export(module.exports, "ResourceNotFoundRpcError", function () { return $d80dc857752c072d$export$466772c50c6d6751; });
$parcel$export(module.exports, "ResourceUnavailableRpcError", function () { return $d80dc857752c072d$export$270451347568a637; });
$parcel$export(module.exports, "TransactionRejectedRpcError", function () { return $d80dc857752c072d$export$f714565c9176e28; });
$parcel$export(module.exports, "MethodNotSupportedRpcError", function () { return $d80dc857752c072d$export$b106fe05a02d89c5; });
$parcel$export(module.exports, "LimitExceededRpcError", function () { return $d80dc857752c072d$export$2c6f5ab73129d9d7; });
$parcel$export(module.exports, "JsonRpcVersionUnsupportedError", function () { return $d80dc857752c072d$export$662f3764fa426a13; });
$parcel$export(module.exports, "UserRejectedRequestError", function () { return $d80dc857752c072d$export$4af5b080d9e9e1a6; });
$parcel$export(module.exports, "UnauthorizedProviderError", function () { return $d80dc857752c072d$export$cc1057a5779c7ffa; });
$parcel$export(module.exports, "UnsupportedProviderMethodError", function () { return $d80dc857752c072d$export$6a557500ae315a49; });
$parcel$export(module.exports, "ProviderDisconnectedError", function () { return $d80dc857752c072d$export$abb104bf1dd9c38b; });
$parcel$export(module.exports, "ChainDisconnectedError", function () { return $d80dc857752c072d$export$ef186cf1cda0444; });
$parcel$export(module.exports, "SwitchChainError", function () { return $d80dc857752c072d$export$d4ddb31968a9d366; });
$parcel$export(module.exports, "UnknownRpcError", function () { return $d80dc857752c072d$export$bfc830e1ec76e31b; });

var $cahqm = parcelRequire("cahqm");

var $aBz5G = parcelRequire("aBz5G");
const $d80dc857752c072d$var$unknownErrorCode = -1;
class $d80dc857752c072d$export$5460eff990f31920 extends (0, $cahqm.BaseError) {
    constructor(cause, { code: code, docsPath: docsPath, metaMessages: metaMessages, name: name, shortMessage: shortMessage }){
        super(shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: metaMessages || cause?.metaMessages,
            name: name || "RpcError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name || cause.name;
        this.code = cause instanceof (0, $aBz5G.RpcRequestError) ? cause.code : code ?? $d80dc857752c072d$var$unknownErrorCode;
    }
}
class $d80dc857752c072d$export$417589b978208a8f extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause, options){
        super(cause, options);
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = options.data;
    }
}
class $d80dc857752c072d$export$aa31e6432f136746 extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$aa31e6432f136746.code,
            name: "ParseRpcError",
            shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$aa31e6432f136746, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32700
});
class $d80dc857752c072d$export$ff7b9f15f3eb8d4d extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$ff7b9f15f3eb8d4d.code,
            name: "InvalidRequestRpcError",
            shortMessage: "JSON is not a valid request object."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$ff7b9f15f3eb8d4d, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32600
});
class $d80dc857752c072d$export$4c4044ac99c8d2d3 extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $d80dc857752c072d$export$4c4044ac99c8d2d3.code,
            name: "MethodNotFoundRpcError",
            shortMessage: `The method${method ? ` "${method}"` : ""} does not exist / is not available.`
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$4c4044ac99c8d2d3, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32601
});
class $d80dc857752c072d$export$c600faffd3cbd390 extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$c600faffd3cbd390.code,
            name: "InvalidParamsRpcError",
            shortMessage: [
                "Invalid parameters were provided to the RPC method.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$c600faffd3cbd390, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32602
});
class $d80dc857752c072d$export$4e62fafb20e19fd7 extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$4e62fafb20e19fd7.code,
            name: "InternalRpcError",
            shortMessage: "An internal error was received."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$4e62fafb20e19fd7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32603
});
class $d80dc857752c072d$export$3ba2994324ab015e extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$3ba2994324ab015e.code,
            name: "InvalidInputRpcError",
            shortMessage: [
                "Missing or invalid parameters.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$3ba2994324ab015e, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32000
});
class $d80dc857752c072d$export$466772c50c6d6751 extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$466772c50c6d6751.code,
            name: "ResourceNotFoundRpcError",
            shortMessage: "Requested resource not found."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceNotFoundRpcError"
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$466772c50c6d6751, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32001
});
class $d80dc857752c072d$export$270451347568a637 extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$270451347568a637.code,
            name: "ResourceUnavailableRpcError",
            shortMessage: "Requested resource not available."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$270451347568a637, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32002
});
class $d80dc857752c072d$export$f714565c9176e28 extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$f714565c9176e28.code,
            name: "TransactionRejectedRpcError",
            shortMessage: "Transaction creation failed."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$f714565c9176e28, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32003
});
class $d80dc857752c072d$export$b106fe05a02d89c5 extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $d80dc857752c072d$export$b106fe05a02d89c5.code,
            name: "MethodNotSupportedRpcError",
            shortMessage: `Method${method ? ` "${method}"` : ""} is not supported.`
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$b106fe05a02d89c5, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32004
});
class $d80dc857752c072d$export$2c6f5ab73129d9d7 extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$2c6f5ab73129d9d7.code,
            name: "LimitExceededRpcError",
            shortMessage: "Request exceeds defined limit."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$2c6f5ab73129d9d7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32005
});
class $d80dc857752c072d$export$662f3764fa426a13 extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$662f3764fa426a13.code,
            name: "JsonRpcVersionUnsupportedError",
            shortMessage: "Version of JSON-RPC protocol is not supported."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$662f3764fa426a13, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32006
});
class $d80dc857752c072d$export$4af5b080d9e9e1a6 extends $d80dc857752c072d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$4af5b080d9e9e1a6.code,
            name: "UserRejectedRequestError",
            shortMessage: "User rejected the request."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$4af5b080d9e9e1a6, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4001
});
class $d80dc857752c072d$export$cc1057a5779c7ffa extends $d80dc857752c072d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$cc1057a5779c7ffa.code,
            name: "UnauthorizedProviderError",
            shortMessage: "The requested method and/or account has not been authorized by the user."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$cc1057a5779c7ffa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4100
});
class $d80dc857752c072d$export$6a557500ae315a49 extends $d80dc857752c072d$export$417589b978208a8f {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $d80dc857752c072d$export$6a557500ae315a49.code,
            name: "UnsupportedProviderMethodError",
            shortMessage: `The Provider does not support the requested method${method ? ` " ${method}"` : ""}.`
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$6a557500ae315a49, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4200
});
class $d80dc857752c072d$export$abb104bf1dd9c38b extends $d80dc857752c072d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$abb104bf1dd9c38b.code,
            name: "ProviderDisconnectedError",
            shortMessage: "The Provider is disconnected from all chains."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$abb104bf1dd9c38b, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4900
});
class $d80dc857752c072d$export$ef186cf1cda0444 extends $d80dc857752c072d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$ef186cf1cda0444.code,
            name: "ChainDisconnectedError",
            shortMessage: "The Provider is not connected to the requested chain."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$ef186cf1cda0444, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4901
});
class $d80dc857752c072d$export$d4ddb31968a9d366 extends $d80dc857752c072d$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $d80dc857752c072d$export$d4ddb31968a9d366.code,
            name: "SwitchChainError",
            shortMessage: "An error occurred when attempting to switch chain."
        });
    }
}
Object.defineProperty($d80dc857752c072d$export$d4ddb31968a9d366, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4902
});
class $d80dc857752c072d$export$bfc830e1ec76e31b extends $d80dc857752c072d$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            name: "UnknownRpcError",
            shortMessage: "An unknown RPC error occurred."
        });
    }
}

});



parcelRegister("fcbjO", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $b100c1a1f3cbe745$export$f9380c9a627682d3; });
/**
 * @description Picks out the keys from `value` that exist in the formatter..
 */ function $b100c1a1f3cbe745$export$f9380c9a627682d3(value_, { format: format }) {
    if (!format) return {};
    const value = {};
    function extract_(formatted) {
        const keys = Object.keys(formatted);
        for (const key of keys){
            if (key in value_) value[key] = value_[key];
            if (formatted[key] && typeof formatted[key] === "object" && !Array.isArray(formatted[key])) extract_(formatted[key]);
        }
    }
    const formatted = format(value_ || {});
    extract_(formatted);
    return value;
}

});

parcelRegister("ksIKp", function(module, exports) {

$parcel$export(module.exports, "formatTransactionRequest", function () { return $ee592217c351cf71$export$d23fcba447c86a8e; });

var $jW8ut = parcelRequire("jW8ut");

var $awA7s = parcelRequire("awA7s");
const $ee592217c351cf71$export$b2a848539dcbb25f = {
    legacy: "0x0",
    eip2930: "0x1",
    eip1559: "0x2",
    eip4844: "0x3",
    eip7702: "0x4"
};
function $ee592217c351cf71$export$d23fcba447c86a8e(request) {
    const rpcRequest = {};
    if (typeof request.authorizationList !== "undefined") rpcRequest.authorizationList = $ee592217c351cf71$var$formatAuthorizationList(request.authorizationList);
    if (typeof request.accessList !== "undefined") rpcRequest.accessList = request.accessList;
    if (typeof request.blobVersionedHashes !== "undefined") rpcRequest.blobVersionedHashes = request.blobVersionedHashes;
    if (typeof request.blobs !== "undefined") {
        if (typeof request.blobs[0] !== "string") rpcRequest.blobs = request.blobs.map((x)=>(0, $jW8ut.bytesToHex)(x));
        else rpcRequest.blobs = request.blobs;
    }
    if (typeof request.data !== "undefined") rpcRequest.data = request.data;
    if (typeof request.from !== "undefined") rpcRequest.from = request.from;
    if (typeof request.gas !== "undefined") rpcRequest.gas = (0, $jW8ut.numberToHex)(request.gas);
    if (typeof request.gasPrice !== "undefined") rpcRequest.gasPrice = (0, $jW8ut.numberToHex)(request.gasPrice);
    if (typeof request.maxFeePerBlobGas !== "undefined") rpcRequest.maxFeePerBlobGas = (0, $jW8ut.numberToHex)(request.maxFeePerBlobGas);
    if (typeof request.maxFeePerGas !== "undefined") rpcRequest.maxFeePerGas = (0, $jW8ut.numberToHex)(request.maxFeePerGas);
    if (typeof request.maxPriorityFeePerGas !== "undefined") rpcRequest.maxPriorityFeePerGas = (0, $jW8ut.numberToHex)(request.maxPriorityFeePerGas);
    if (typeof request.nonce !== "undefined") rpcRequest.nonce = (0, $jW8ut.numberToHex)(request.nonce);
    if (typeof request.to !== "undefined") rpcRequest.to = request.to;
    if (typeof request.type !== "undefined") rpcRequest.type = $ee592217c351cf71$export$b2a848539dcbb25f[request.type];
    if (typeof request.value !== "undefined") rpcRequest.value = (0, $jW8ut.numberToHex)(request.value);
    return rpcRequest;
}
const $ee592217c351cf71$export$aba208618cee26e3 = /*#__PURE__*/ (0, $awA7s.defineFormatter)("transactionRequest", $ee592217c351cf71$export$d23fcba447c86a8e);
//////////////////////////////////////////////////////////////////////////////
function $ee592217c351cf71$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization)=>({
            address: authorization.contractAddress,
            r: authorization.r,
            s: authorization.s,
            chainId: (0, $jW8ut.numberToHex)(authorization.chainId),
            nonce: (0, $jW8ut.numberToHex)(authorization.nonce),
            ...typeof authorization.yParity !== "undefined" ? {
                yParity: (0, $jW8ut.numberToHex)(authorization.yParity)
            } : {},
            ...typeof authorization.v !== "undefined" && typeof authorization.yParity === "undefined" ? {
                v: (0, $jW8ut.numberToHex)(authorization.v)
            } : {}
        }));
}

});
parcelRegister("awA7s", function(module, exports) {

$parcel$export(module.exports, "defineFormatter", function () { return $7a98e9102f9adcdd$export$5d08535cc975931a; });
function $7a98e9102f9adcdd$export$5d08535cc975931a(type, format) {
    return ({ exclude: exclude, format: overrides })=>{
        return {
            exclude: exclude,
            format: (args)=>{
                const formatted = format(args);
                if (exclude) for (const key of exclude)delete formatted[key];
                return {
                    ...formatted,
                    ...overrides(args)
                };
            },
            type: type
        };
    };
}

});


parcelRegister("aeVPU", function(module, exports) {

$parcel$export(module.exports, "createBatchScheduler", function () { return $77481340ff2a8350$export$24d3fde68b7c4167; });

var $4bijw = parcelRequire("4bijw");
const $77481340ff2a8350$var$schedulerCache = /*#__PURE__*/ new Map();
function $77481340ff2a8350$export$24d3fde68b7c4167({ fn: fn, id: id, shouldSplitBatch: shouldSplitBatch, wait: wait = 0, sort: sort }) {
    const exec = async ()=>{
        const scheduler = getScheduler();
        flush();
        const args = scheduler.map(({ args: args })=>args);
        if (args.length === 0) return;
        fn(args).then((data)=>{
            if (sort && Array.isArray(data)) data.sort(sort);
            for(let i = 0; i < scheduler.length; i++){
                const { resolve: resolve } = scheduler[i];
                resolve?.([
                    data[i],
                    data
                ]);
            }
        }).catch((err)=>{
            for(let i = 0; i < scheduler.length; i++){
                const { reject: reject } = scheduler[i];
                reject?.(err);
            }
        });
    };
    const flush = ()=>$77481340ff2a8350$var$schedulerCache.delete(id);
    const getBatchedArgs = ()=>getScheduler().map(({ args: args })=>args);
    const getScheduler = ()=>$77481340ff2a8350$var$schedulerCache.get(id) || [];
    const setScheduler = (item)=>$77481340ff2a8350$var$schedulerCache.set(id, [
            ...getScheduler(),
            item
        ]);
    return {
        flush: flush,
        async schedule (args) {
            const { promise: promise, resolve: resolve, reject: reject } = (0, $4bijw.withResolvers)();
            const split = shouldSplitBatch?.([
                ...getBatchedArgs(),
                args
            ]);
            if (split) exec();
            const hasActiveScheduler = getScheduler().length > 0;
            if (hasActiveScheduler) {
                setScheduler({
                    args: args,
                    resolve: resolve,
                    reject: reject
                });
                return promise;
            }
            setScheduler({
                args: args,
                resolve: resolve,
                reject: reject
            });
            setTimeout(exec, wait);
            return promise;
        }
    };
}

});
parcelRegister("4bijw", function(module, exports) {

$parcel$export(module.exports, "withResolvers", function () { return $30b66545bf36e166$export$88ce28fd4287e6ef; });
/** @internal */ function $30b66545bf36e166$export$88ce28fd4287e6ef() {
    let resolve = ()=>undefined;
    let reject = ()=>undefined;
    const promise = new Promise((resolve_, reject_)=>{
        resolve = resolve_;
        reject = reject_;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}

});


parcelRegister("l7x0m", function(module, exports) {

$parcel$export(module.exports, "serializeStateOverride", function () { return $f603da7c54fa8a54$export$f6da3c954eb711d6; });

var $62VqX = parcelRequire("62VqX");

var $8piNh = parcelRequire("8piNh");

var $2IagT = parcelRequire("2IagT");

var $8Ghey = parcelRequire("8Ghey");

var $jW8ut = parcelRequire("jW8ut");
function $f603da7c54fa8a54$export$29e73cd11b306a76(stateMapping) {
    if (!stateMapping || stateMapping.length === 0) return undefined;
    return stateMapping.reduce((acc, { slot: slot, value: value })=>{
        if (slot.length !== 66) throw new (0, $8piNh.InvalidBytesLengthError)({
            size: slot.length,
            targetSize: 66,
            type: "hex"
        });
        if (value.length !== 66) throw new (0, $8piNh.InvalidBytesLengthError)({
            size: value.length,
            targetSize: 66,
            type: "hex"
        });
        acc[slot] = value;
        return acc;
    }, {});
}
function $f603da7c54fa8a54$export$ff6c86decd3de345(parameters) {
    const { balance: balance, nonce: nonce, state: state, stateDiff: stateDiff, code: code } = parameters;
    const rpcAccountStateOverride = {};
    if (code !== undefined) rpcAccountStateOverride.code = code;
    if (balance !== undefined) rpcAccountStateOverride.balance = (0, $jW8ut.numberToHex)(balance);
    if (nonce !== undefined) rpcAccountStateOverride.nonce = (0, $jW8ut.numberToHex)(nonce);
    if (state !== undefined) rpcAccountStateOverride.state = $f603da7c54fa8a54$export$29e73cd11b306a76(state);
    if (stateDiff !== undefined) {
        if (rpcAccountStateOverride.state) throw new (0, $2IagT.StateAssignmentConflictError)();
        rpcAccountStateOverride.stateDiff = $f603da7c54fa8a54$export$29e73cd11b306a76(stateDiff);
    }
    return rpcAccountStateOverride;
}
function $f603da7c54fa8a54$export$f6da3c954eb711d6(parameters) {
    if (!parameters) return undefined;
    const rpcStateOverride = {};
    for (const { address: address, ...accountState } of parameters){
        if (!(0, $8Ghey.isAddress)(address, {
            strict: false
        })) throw new (0, $62VqX.InvalidAddressError)({
            address: address
        });
        if (rpcStateOverride[address]) throw new (0, $2IagT.AccountStateConflictError)({
            address: address
        });
        rpcStateOverride[address] = $f603da7c54fa8a54$export$ff6c86decd3de345(accountState);
    }
    return rpcStateOverride;
}

});

parcelRegister("1OSs0", function(module, exports) {

$parcel$export(module.exports, "assertRequest", function () { return $1534b2bb041771ee$export$5378021d985ceaf8; });

var $gbEG8 = parcelRequire("gbEG8");

var $64pxN = parcelRequire("64pxN");

var $62VqX = parcelRequire("62VqX");

var $iWaDR = parcelRequire("iWaDR");

var $3a3vr = parcelRequire("3a3vr");

var $8Ghey = parcelRequire("8Ghey");
function $1534b2bb041771ee$export$5378021d985ceaf8(args) {
    const { account: account_, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, to: to } = args;
    const account = account_ ? (0, $gbEG8.parseAccount)(account_) : undefined;
    if (account && !(0, $8Ghey.isAddress)(account.address)) throw new (0, $62VqX.InvalidAddressError)({
        address: account.address
    });
    if (to && !(0, $8Ghey.isAddress)(to)) throw new (0, $62VqX.InvalidAddressError)({
        address: to
    });
    if (typeof gasPrice !== "undefined" && (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined")) throw new (0, $3a3vr.FeeConflictError)();
    if (maxFeePerGas && maxFeePerGas > (0, $64pxN.maxUint256)) throw new (0, $iWaDR.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $iWaDR.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}

});
parcelRegister("64pxN", function(module, exports) {

$parcel$export(module.exports, "maxUint256", function () { return $46b6ee5094a06ccc$export$48de485e50a67ffa; });
const $46b6ee5094a06ccc$export$bdd7109439799cdf = 2n ** (8n - 1n) - 1n;
const $46b6ee5094a06ccc$export$eee94935c9b963a1 = 2n ** (16n - 1n) - 1n;
const $46b6ee5094a06ccc$export$e91fe5d90cd4a2f6 = 2n ** (24n - 1n) - 1n;
const $46b6ee5094a06ccc$export$25c0796c740353c4 = 2n ** (32n - 1n) - 1n;
const $46b6ee5094a06ccc$export$ac2072b1e721a92d = 2n ** (40n - 1n) - 1n;
const $46b6ee5094a06ccc$export$7b7c71fa48943f3 = 2n ** (48n - 1n) - 1n;
const $46b6ee5094a06ccc$export$e27ce19a567c9842 = 2n ** (56n - 1n) - 1n;
const $46b6ee5094a06ccc$export$a51b0cf29ddb8e40 = 2n ** (64n - 1n) - 1n;
const $46b6ee5094a06ccc$export$347f40d3f7572e5a = 2n ** (72n - 1n) - 1n;
const $46b6ee5094a06ccc$export$940f45cde4f61aed = 2n ** (80n - 1n) - 1n;
const $46b6ee5094a06ccc$export$13cad54caf92841d = 2n ** (88n - 1n) - 1n;
const $46b6ee5094a06ccc$export$872296ce91d7dabe = 2n ** (96n - 1n) - 1n;
const $46b6ee5094a06ccc$export$404112bd52c31da4 = 2n ** (104n - 1n) - 1n;
const $46b6ee5094a06ccc$export$1d4284abecdbf56d = 2n ** (112n - 1n) - 1n;
const $46b6ee5094a06ccc$export$35201a0fd5d34f18 = 2n ** (120n - 1n) - 1n;
const $46b6ee5094a06ccc$export$92415df5352289c7 = 2n ** (128n - 1n) - 1n;
const $46b6ee5094a06ccc$export$ccb03f6a03d6e182 = 2n ** (136n - 1n) - 1n;
const $46b6ee5094a06ccc$export$cbf030aa46ccd63 = 2n ** (144n - 1n) - 1n;
const $46b6ee5094a06ccc$export$33ad14852d23a660 = 2n ** (152n - 1n) - 1n;
const $46b6ee5094a06ccc$export$6429af277dbaae06 = 2n ** (160n - 1n) - 1n;
const $46b6ee5094a06ccc$export$2b154fcf8b3c7a42 = 2n ** (168n - 1n) - 1n;
const $46b6ee5094a06ccc$export$6ba90f949100477a = 2n ** (176n - 1n) - 1n;
const $46b6ee5094a06ccc$export$a353fb8a621e38fd = 2n ** (184n - 1n) - 1n;
const $46b6ee5094a06ccc$export$ad4f6360abea4fa4 = 2n ** (192n - 1n) - 1n;
const $46b6ee5094a06ccc$export$381549e0b0f272ab = 2n ** (200n - 1n) - 1n;
const $46b6ee5094a06ccc$export$a083a4afa1a2c00c = 2n ** (208n - 1n) - 1n;
const $46b6ee5094a06ccc$export$ee8f6a880c431cd3 = 2n ** (216n - 1n) - 1n;
const $46b6ee5094a06ccc$export$a8672844e0af1027 = 2n ** (224n - 1n) - 1n;
const $46b6ee5094a06ccc$export$57c45c845403e7a5 = 2n ** (232n - 1n) - 1n;
const $46b6ee5094a06ccc$export$e8e88f55ae4a3354 = 2n ** (240n - 1n) - 1n;
const $46b6ee5094a06ccc$export$ebbd894fe518c064 = 2n ** (248n - 1n) - 1n;
const $46b6ee5094a06ccc$export$e4d673aa7367981c = 2n ** (256n - 1n) - 1n;
const $46b6ee5094a06ccc$export$ef9b9e1988c51720 = -(2n ** (8n - 1n));
const $46b6ee5094a06ccc$export$b923fba4a82cad48 = -(2n ** (16n - 1n));
const $46b6ee5094a06ccc$export$7b0286602251a7c7 = -(2n ** (24n - 1n));
const $46b6ee5094a06ccc$export$5f0d0d25b56bbb4f = -(2n ** (32n - 1n));
const $46b6ee5094a06ccc$export$4c07a8deea2258b1 = -(2n ** (40n - 1n));
const $46b6ee5094a06ccc$export$6a6c2e4f279545ff = -(2n ** (48n - 1n));
const $46b6ee5094a06ccc$export$1739c13d967d68b1 = -(2n ** (56n - 1n));
const $46b6ee5094a06ccc$export$14e6fedf9fb9d75c = -(2n ** (64n - 1n));
const $46b6ee5094a06ccc$export$bc3defde0bfb8bd = -(2n ** (72n - 1n));
const $46b6ee5094a06ccc$export$8efa66e0d946dfd2 = -(2n ** (80n - 1n));
const $46b6ee5094a06ccc$export$80ab8bed90b29bfe = -(2n ** (88n - 1n));
const $46b6ee5094a06ccc$export$39c4444aac2d0d86 = -(2n ** (96n - 1n));
const $46b6ee5094a06ccc$export$28fd4a9e64dafe7b = -(2n ** (104n - 1n));
const $46b6ee5094a06ccc$export$38cae674fedc8f74 = -(2n ** (112n - 1n));
const $46b6ee5094a06ccc$export$6779113dfecc5d69 = -(2n ** (120n - 1n));
const $46b6ee5094a06ccc$export$93cc92d28d07644b = -(2n ** (128n - 1n));
const $46b6ee5094a06ccc$export$4acf8238e6d61d3e = -(2n ** (136n - 1n));
const $46b6ee5094a06ccc$export$ac974246b2ca90ec = -(2n ** (144n - 1n));
const $46b6ee5094a06ccc$export$77d4dfc3aa958440 = -(2n ** (152n - 1n));
const $46b6ee5094a06ccc$export$a9a1ab546428ca6f = -(2n ** (160n - 1n));
const $46b6ee5094a06ccc$export$aca1dbffc71a377a = -(2n ** (168n - 1n));
const $46b6ee5094a06ccc$export$1ca77ffa68208066 = -(2n ** (176n - 1n));
const $46b6ee5094a06ccc$export$e74092b0e35f2385 = -(2n ** (184n - 1n));
const $46b6ee5094a06ccc$export$5f53c97c87f852f4 = -(2n ** (192n - 1n));
const $46b6ee5094a06ccc$export$df01e80cffe255dc = -(2n ** (200n - 1n));
const $46b6ee5094a06ccc$export$155f043c7b06e008 = -(2n ** (208n - 1n));
const $46b6ee5094a06ccc$export$195a5ffec9c679b8 = -(2n ** (216n - 1n));
const $46b6ee5094a06ccc$export$b1ee6eacfb96c50c = -(2n ** (224n - 1n));
const $46b6ee5094a06ccc$export$16bdbfee8230ad51 = -(2n ** (232n - 1n));
const $46b6ee5094a06ccc$export$5715ad8f9991a9a2 = -(2n ** (240n - 1n));
const $46b6ee5094a06ccc$export$9146117a246b63ab = -(2n ** (248n - 1n));
const $46b6ee5094a06ccc$export$5d31694d80b27ae5 = -(2n ** (256n - 1n));
const $46b6ee5094a06ccc$export$7db2ab1a72670716 = 2n ** 8n - 1n;
const $46b6ee5094a06ccc$export$e4e112958a94d87f = 2n ** 16n - 1n;
const $46b6ee5094a06ccc$export$1bea6075c2df6828 = 2n ** 24n - 1n;
const $46b6ee5094a06ccc$export$48716e5eecd83bf7 = 2n ** 32n - 1n;
const $46b6ee5094a06ccc$export$dc2184b5c9263ac7 = 2n ** 40n - 1n;
const $46b6ee5094a06ccc$export$e639b3656891925b = 2n ** 48n - 1n;
const $46b6ee5094a06ccc$export$bea470c1abdb1310 = 2n ** 56n - 1n;
const $46b6ee5094a06ccc$export$3f17b1570950699c = 2n ** 64n - 1n;
const $46b6ee5094a06ccc$export$8135da85ae9b595b = 2n ** 72n - 1n;
const $46b6ee5094a06ccc$export$caa80683240e3b73 = 2n ** 80n - 1n;
const $46b6ee5094a06ccc$export$8e50c223f761a8cf = 2n ** 88n - 1n;
const $46b6ee5094a06ccc$export$621d3d87b73138e5 = 2n ** 96n - 1n;
const $46b6ee5094a06ccc$export$4e5098f4748a9a4d = 2n ** 104n - 1n;
const $46b6ee5094a06ccc$export$1435b580b943ede2 = 2n ** 112n - 1n;
const $46b6ee5094a06ccc$export$4362e740aadf7dab = 2n ** 120n - 1n;
const $46b6ee5094a06ccc$export$380ebe6b2fc5caa9 = 2n ** 128n - 1n;
const $46b6ee5094a06ccc$export$6c13d06e0cefb9aa = 2n ** 136n - 1n;
const $46b6ee5094a06ccc$export$fe2d415b41e5f433 = 2n ** 144n - 1n;
const $46b6ee5094a06ccc$export$c2f2754e23c5488a = 2n ** 152n - 1n;
const $46b6ee5094a06ccc$export$34fcca92c372a91b = 2n ** 160n - 1n;
const $46b6ee5094a06ccc$export$32e3523cb82cc8a0 = 2n ** 168n - 1n;
const $46b6ee5094a06ccc$export$d36711d6637bde95 = 2n ** 176n - 1n;
const $46b6ee5094a06ccc$export$9211611648dd09a2 = 2n ** 184n - 1n;
const $46b6ee5094a06ccc$export$4e61cbaa2231cfdd = 2n ** 192n - 1n;
const $46b6ee5094a06ccc$export$9187c63f331d335b = 2n ** 200n - 1n;
const $46b6ee5094a06ccc$export$7f910799edc7ae97 = 2n ** 208n - 1n;
const $46b6ee5094a06ccc$export$64506e5a2676ecb0 = 2n ** 216n - 1n;
const $46b6ee5094a06ccc$export$a060896418206521 = 2n ** 224n - 1n;
const $46b6ee5094a06ccc$export$18b000c2bc5e114 = 2n ** 232n - 1n;
const $46b6ee5094a06ccc$export$253bb52e7f7a3909 = 2n ** 240n - 1n;
const $46b6ee5094a06ccc$export$d5a8ad83a637081c = 2n ** 248n - 1n;
const $46b6ee5094a06ccc$export$48de485e50a67ffa = 2n ** 256n - 1n;

});


parcelRegister("7Nmpn", function(module, exports) {


module.exports = (parcelRequire("3WFuy"))((parcelRequire("gm4sb")).resolve("8Jql3")).then(()=>parcelRequire("4eniX"));

});
parcelRegister("3WFuy", function(module, exports) {
"use strict";

var $667pM = parcelRequire("667pM");
module.exports = $667pM(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("667pM", function(module, exports) {
"use strict";
var $47090e09928e24bd$var$cachedBundles = {};
var $47090e09928e24bd$var$cachedPreloads = {};
var $47090e09928e24bd$var$cachedPrefetches = {};
function $47090e09928e24bd$var$getCache(type) {
    switch(type){
        case "preload":
            return $47090e09928e24bd$var$cachedPreloads;
        case "prefetch":
            return $47090e09928e24bd$var$cachedPrefetches;
        default:
            return $47090e09928e24bd$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $47090e09928e24bd$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("46gat", function(module, exports) {

$parcel$export(module.exports, "proxy", function () { return $c841d4c6bd431637$export$923f96dd5afa9ce6; });
$parcel$export(module.exports, "getVersion", function () { return $c841d4c6bd431637$export$c506eb22e615ba4a; });
$parcel$export(module.exports, "subscribe", function () { return $c841d4c6bd431637$export$ec068583843480e7; });
$parcel$export(module.exports, "snapshot", function () { return $c841d4c6bd431637$export$b8801ea43165ed7d; });
$parcel$export(module.exports, "ref", function () { return $c841d4c6bd431637$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "unstable_buildProxyFunction", function () { return $c841d4c6bd431637$export$e7b04d37d9502758; });

var $3tJXS = parcelRequire("3tJXS");
var $c841d4c6bd431637$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla.mjs"
});
const $c841d4c6bd431637$var$isObject = (x)=>typeof x === "object" && x !== null;
const $c841d4c6bd431637$var$proxyStateMap = /* @__PURE__ */ new WeakMap();
const $c841d4c6bd431637$var$refSet = /* @__PURE__ */ new WeakSet();
const $c841d4c6bd431637$var$buildProxyFunction = (objectIs = Object.is, newProxy = (target, handler)=>new Proxy(target, handler), canProxy = (x)=>$c841d4c6bd431637$var$isObject(x) && !$c841d4c6bd431637$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer), defaultHandlePromise = (promise)=>{
    switch(promise.status){
        case "fulfilled":
            return promise.value;
        case "rejected":
            throw promise.reason;
        default:
            throw promise;
    }
}, snapCache = /* @__PURE__ */ new WeakMap(), createSnapshot = (target, version, handlePromise = defaultHandlePromise)=>{
    const cache = snapCache.get(target);
    if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
    const snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
    (0, $3tJXS.markToTrack)(snap, true);
    snapCache.set(target, [
        version,
        snap
    ]);
    Reflect.ownKeys(target).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(snap, key)) return;
        const value = Reflect.get(target, key);
        const desc = {
            value: value,
            enumerable: true,
            // This is intentional to avoid copying with proxy-compare.
            // It's still non-writable, so it avoids assigning a value.
            configurable: true
        };
        if ($c841d4c6bd431637$var$refSet.has(value)) (0, $3tJXS.markToTrack)(value, false);
        else if (value instanceof Promise) {
            delete desc.value;
            desc.get = ()=>handlePromise(value);
        } else if ($c841d4c6bd431637$var$proxyStateMap.has(value)) {
            const [target2, ensureVersion] = $c841d4c6bd431637$var$proxyStateMap.get(value);
            desc.value = createSnapshot(target2, ensureVersion(), handlePromise);
        }
        Object.defineProperty(snap, key, desc);
    });
    return Object.preventExtensions(snap);
}, proxyCache = /* @__PURE__ */ new WeakMap(), versionHolder = [
    1,
    1
], proxyFunction = (initialObject)=>{
    if (!$c841d4c6bd431637$var$isObject(initialObject)) throw new Error("object required");
    const found = proxyCache.get(initialObject);
    if (found) return found;
    let version = versionHolder[0];
    const listeners = /* @__PURE__ */ new Set();
    const notifyUpdate = (op, nextVersion = ++versionHolder[0])=>{
        if (version !== nextVersion) {
            version = nextVersion;
            listeners.forEach((listener)=>listener(op, nextVersion));
        }
    };
    let checkVersion = versionHolder[1];
    const ensureVersion = (nextCheckVersion = ++versionHolder[1])=>{
        if (checkVersion !== nextCheckVersion && !listeners.size) {
            checkVersion = nextCheckVersion;
            propProxyStates.forEach(([propProxyState])=>{
                const propVersion = propProxyState[1](nextCheckVersion);
                if (propVersion > version) version = propVersion;
            });
        }
        return version;
    };
    const createPropListener = (prop)=>(op, nextVersion)=>{
            const newOp = [
                ...op
            ];
            newOp[1] = [
                prop,
                ...newOp[1]
            ];
            notifyUpdate(newOp, nextVersion);
        };
    const propProxyStates = /* @__PURE__ */ new Map();
    const addPropListener = (prop, propProxyState)=>{
        if (($c841d4c6bd431637$import_meta.env ? $c841d4c6bd431637$import_meta.env.MODE : void 0) !== "production" && propProxyStates.has(prop)) throw new Error("prop listener already exists");
        if (listeners.size) {
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        } else propProxyStates.set(prop, [
            propProxyState
        ]);
    };
    const removePropListener = (prop)=>{
        var _a;
        const entry = propProxyStates.get(prop);
        if (entry) {
            propProxyStates.delete(prop);
            (_a = entry[1]) == null || _a.call(entry);
        }
    };
    const addListener = (listener)=>{
        listeners.add(listener);
        if (listeners.size === 1) propProxyStates.forEach(([propProxyState, prevRemove], prop)=>{
            if (($c841d4c6bd431637$import_meta.env ? $c841d4c6bd431637$import_meta.env.MODE : void 0) !== "production" && prevRemove) throw new Error("remove already exists");
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        });
        const removeListener = ()=>{
            listeners.delete(listener);
            if (listeners.size === 0) propProxyStates.forEach(([propProxyState, remove], prop)=>{
                if (remove) {
                    remove();
                    propProxyStates.set(prop, [
                        propProxyState
                    ]);
                }
            });
        };
        return removeListener;
    };
    const baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
    const handler = {
        deleteProperty (target, prop) {
            const prevValue = Reflect.get(target, prop);
            removePropListener(prop);
            const deleted = Reflect.deleteProperty(target, prop);
            if (deleted) notifyUpdate([
                "delete",
                [
                    prop
                ],
                prevValue
            ]);
            return deleted;
        },
        set (target, prop, value, receiver) {
            const hasPrevValue = Reflect.has(target, prop);
            const prevValue = Reflect.get(target, prop, receiver);
            if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
            removePropListener(prop);
            if ($c841d4c6bd431637$var$isObject(value)) value = (0, $3tJXS.getUntracked)(value) || value;
            let nextValue = value;
            if (value instanceof Promise) value.then((v)=>{
                value.status = "fulfilled";
                value.value = v;
                notifyUpdate([
                    "resolve",
                    [
                        prop
                    ],
                    v
                ]);
            }).catch((e)=>{
                value.status = "rejected";
                value.reason = e;
                notifyUpdate([
                    "reject",
                    [
                        prop
                    ],
                    e
                ]);
            });
            else {
                if (!$c841d4c6bd431637$var$proxyStateMap.has(value) && canProxy(value)) nextValue = proxyFunction(value);
                const childProxyState = !$c841d4c6bd431637$var$refSet.has(nextValue) && $c841d4c6bd431637$var$proxyStateMap.get(nextValue);
                if (childProxyState) addPropListener(prop, childProxyState);
            }
            Reflect.set(target, prop, nextValue, receiver);
            notifyUpdate([
                "set",
                [
                    prop
                ],
                value,
                prevValue
            ]);
            return true;
        }
    };
    const proxyObject = newProxy(baseObject, handler);
    proxyCache.set(initialObject, proxyObject);
    const proxyState = [
        baseObject,
        ensureVersion,
        createSnapshot,
        addListener
    ];
    $c841d4c6bd431637$var$proxyStateMap.set(proxyObject, proxyState);
    Reflect.ownKeys(initialObject).forEach((key)=>{
        const desc = Object.getOwnPropertyDescriptor(initialObject, key);
        if ("value" in desc) {
            proxyObject[key] = initialObject[key];
            delete desc.value;
            delete desc.writable;
        }
        Object.defineProperty(baseObject, key, desc);
    });
    return proxyObject;
})=>[
        // public functions
        proxyFunction,
        // shared state
        $c841d4c6bd431637$var$proxyStateMap,
        $c841d4c6bd431637$var$refSet,
        // internal things
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
const [$c841d4c6bd431637$var$defaultProxyFunction] = $c841d4c6bd431637$var$buildProxyFunction();
function $c841d4c6bd431637$export$923f96dd5afa9ce6(initialObject = {}) {
    return $c841d4c6bd431637$var$defaultProxyFunction(initialObject);
}
function $c841d4c6bd431637$export$c506eb22e615ba4a(proxyObject) {
    const proxyState = $c841d4c6bd431637$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $c841d4c6bd431637$export$ec068583843480e7(proxyObject, callback, notifyInSync) {
    const proxyState = $c841d4c6bd431637$var$proxyStateMap.get(proxyObject);
    if (($c841d4c6bd431637$import_meta.env ? $c841d4c6bd431637$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    let promise;
    const ops = [];
    const addListener = proxyState[3];
    let isListenerActive = false;
    const listener = (op)=>{
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(()=>{
            promise = void 0;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    const removeListener = addListener(listener);
    isListenerActive = true;
    return ()=>{
        isListenerActive = false;
        removeListener();
    };
}
function $c841d4c6bd431637$export$b8801ea43165ed7d(proxyObject, handlePromise) {
    const proxyState = $c841d4c6bd431637$var$proxyStateMap.get(proxyObject);
    if (($c841d4c6bd431637$import_meta.env ? $c841d4c6bd431637$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    const [target, ensureVersion, createSnapshot] = proxyState;
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $c841d4c6bd431637$export$eff4d24c3ff7876e(obj) {
    $c841d4c6bd431637$var$refSet.add(obj);
    return obj;
}
const $c841d4c6bd431637$export$e7b04d37d9502758 = $c841d4c6bd431637$var$buildProxyFunction;

});
parcelRegister("3tJXS", function(module, exports) {

$parcel$export(module.exports, "getUntracked", function () { return $2887bc2ac3f95083$export$80d2cee7ee556e99; });
$parcel$export(module.exports, "markToTrack", function () { return $2887bc2ac3f95083$export$2c8383c890e26a1c; });
const $2887bc2ac3f95083$var$e = Symbol(), $2887bc2ac3f95083$var$t = Symbol(), $2887bc2ac3f95083$var$r = "a", $2887bc2ac3f95083$var$n = "w";
let $2887bc2ac3f95083$var$o = (e, t)=>new Proxy(e, t);
const $2887bc2ac3f95083$var$s = Object.getPrototypeOf, $2887bc2ac3f95083$var$c = new WeakMap, $2887bc2ac3f95083$var$l = (e)=>e && ($2887bc2ac3f95083$var$c.has(e) ? $2887bc2ac3f95083$var$c.get(e) : $2887bc2ac3f95083$var$s(e) === Object.prototype || $2887bc2ac3f95083$var$s(e) === Array.prototype), $2887bc2ac3f95083$var$f = (e)=>"object" == typeof e && null !== e, $2887bc2ac3f95083$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($2887bc2ac3f95083$var$s(e), t);
}, $2887bc2ac3f95083$var$u = (e)=>e[$2887bc2ac3f95083$var$t] || e, $2887bc2ac3f95083$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$2887bc2ac3f95083$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $2887bc2ac3f95083$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $2887bc2ac3f95083$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$2887bc2ac3f95083$var$r].get(o);
                if (s || (s = {}, c[$2887bc2ac3f95083$var$r].set(o, s)), e === $2887bc2ac3f95083$var$n) s[$2887bc2ac3f95083$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $2887bc2ac3f95083$var$t ? o : (f("k", n), $2887bc2ac3f95083$export$7865d0c7f908de6b(Reflect.get(e, n), c[$2887bc2ac3f95083$var$r], c.c, c.t)),
            has: (t, n)=>n === $2887bc2ac3f95083$var$e ? (l = !0, c[$2887bc2ac3f95083$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($2887bc2ac3f95083$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $2887bc2ac3f95083$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$2887bc2ac3f95083$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $2887bc2ac3f95083$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$2887bc2ac3f95083$var$f(e) || !$2887bc2ac3f95083$var$f(t)) return !0;
    const s = r.get($2887bc2ac3f95083$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$2887bc2ac3f95083$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $2887bc2ac3f95083$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $2887bc2ac3f95083$export$badc26589cf7bb38 = (t)=>!!$2887bc2ac3f95083$var$l(t) && $2887bc2ac3f95083$var$e in t, $2887bc2ac3f95083$export$80d2cee7ee556e99 = (e)=>$2887bc2ac3f95083$var$l(e) && e[$2887bc2ac3f95083$var$t] || null, $2887bc2ac3f95083$export$2c8383c890e26a1c = (e, t = !0)=>{
    $2887bc2ac3f95083$var$c.set(e, t);
}, $2887bc2ac3f95083$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $2887bc2ac3f95083$var$f(e) && s.add(e);
        const i = $2887bc2ac3f95083$var$f(e) && t.get($2887bc2ac3f95083$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$2887bc2ac3f95083$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $2887bc2ac3f95083$export$9b4d5450dbd8e67e = (e)=>{
    $2887bc2ac3f95083$var$o = e;
};

});


parcelRegister("1oeam", function(module, exports) {

$parcel$export(module.exports, "initializeTheming", function () { return (parcelRequire("cRWGJ")).initializeTheming; });
$parcel$export(module.exports, "setColorTheme", function () { return (parcelRequire("cRWGJ")).setColorTheme; });
$parcel$export(module.exports, "setThemeVariables", function () { return (parcelRequire("cRWGJ")).setThemeVariables; });
$parcel$export(module.exports, "UiHelperUtil", function () { return (parcelRequire("fRkfl")).UiHelperUtil; });
$parcel$export(module.exports, "TransactionUtil", function () { return (parcelRequire("aaIXL")).TransactionUtil; });
$parcel$export(module.exports, "customElement", function () { return (parcelRequire("3SCaV")).customElement; });

var $aBu8J = parcelRequire("aBu8J");

var $iVPOS = parcelRequire("iVPOS");

var $62Qzz = parcelRequire("62Qzz");

var $fkEpZ = parcelRequire("fkEpZ");

var $avm78 = parcelRequire("avm78");

var $9fe4A = parcelRequire("9fe4A");

var $2SjI8 = parcelRequire("2SjI8");

var $7xM3j = parcelRequire("7xM3j");

var $fCVjD = parcelRequire("fCVjD");

var $hY3Wq = parcelRequire("hY3Wq");

var $QXOPA = parcelRequire("QXOPA");

var $2Ecf9 = parcelRequire("2Ecf9");

var $46WDJ = parcelRequire("46WDJ");

var $eqei8 = parcelRequire("eqei8");

var $idObs = parcelRequire("idObs");

var $7WcdO = parcelRequire("7WcdO");

var $ij079 = parcelRequire("ij079");

var $eAc7C = parcelRequire("eAc7C");

var $eIHDH = parcelRequire("eIHDH");

var $9SgY8 = parcelRequire("9SgY8");

var $dKNW7 = parcelRequire("dKNW7");

var $fI5Lg = parcelRequire("fI5Lg");

var $jAflF = parcelRequire("jAflF");

var $lAcfs = parcelRequire("lAcfs");

var $diX7K = parcelRequire("diX7K");

var $3l1Vc = parcelRequire("3l1Vc");

var $kvxnU = parcelRequire("kvxnU");

var $7bMnp = parcelRequire("7bMnp");

var $fBWP9 = parcelRequire("fBWP9");

var $5BV2y = parcelRequire("5BV2y");

var $gtEBj = parcelRequire("gtEBj");

var $15zeU = parcelRequire("15zeU");

var $hnysB = parcelRequire("hnysB");

var $WQoSR = parcelRequire("WQoSR");

var $dkCo4 = parcelRequire("dkCo4");

var $eiKZE = parcelRequire("eiKZE");

var $grd5c = parcelRequire("grd5c");

var $dO7Zu = parcelRequire("dO7Zu");

var $kc9Rd = parcelRequire("kc9Rd");

var $knJqU = parcelRequire("knJqU");

var $6tuq4 = parcelRequire("6tuq4");

var $7gR77 = parcelRequire("7gR77");

var $cvCkY = parcelRequire("cvCkY");

var $b8wWW = parcelRequire("b8wWW");

var $gqmC4 = parcelRequire("gqmC4");

var $iBndS = parcelRequire("iBndS");

var $9pEI0 = parcelRequire("9pEI0");

var $hgfjM = parcelRequire("hgfjM");

var $bPX90 = parcelRequire("bPX90");

var $3Cynl = parcelRequire("3Cynl");

var $276Mo = parcelRequire("276Mo");

var $gga5t = parcelRequire("gga5t");

var $iDl5h = parcelRequire("iDl5h");

var $cRWGJ = parcelRequire("cRWGJ");

var $fRkfl = parcelRequire("fRkfl");

var $aaIXL = parcelRequire("aaIXL");

var $3SCaV = parcelRequire("3SCaV");
$parcel$exportWildcard(module.exports, $aBu8J);
$parcel$exportWildcard(module.exports, $iVPOS);
$parcel$exportWildcard(module.exports, $62Qzz);
$parcel$exportWildcard(module.exports, $fkEpZ);
$parcel$exportWildcard(module.exports, $avm78);
$parcel$exportWildcard(module.exports, $9fe4A);
$parcel$exportWildcard(module.exports, $2SjI8);
$parcel$exportWildcard(module.exports, $7xM3j);
$parcel$exportWildcard(module.exports, $fCVjD);
$parcel$exportWildcard(module.exports, $hY3Wq);
$parcel$exportWildcard(module.exports, $QXOPA);
$parcel$exportWildcard(module.exports, $2Ecf9);
$parcel$exportWildcard(module.exports, $46WDJ);
$parcel$exportWildcard(module.exports, $eqei8);
$parcel$exportWildcard(module.exports, $idObs);
$parcel$exportWildcard(module.exports, $7WcdO);
$parcel$exportWildcard(module.exports, $ij079);
$parcel$exportWildcard(module.exports, $eAc7C);
$parcel$exportWildcard(module.exports, $eIHDH);
$parcel$exportWildcard(module.exports, $9SgY8);
$parcel$exportWildcard(module.exports, $dKNW7);
$parcel$exportWildcard(module.exports, $fI5Lg);
$parcel$exportWildcard(module.exports, $jAflF);
$parcel$exportWildcard(module.exports, $lAcfs);
$parcel$exportWildcard(module.exports, $diX7K);
$parcel$exportWildcard(module.exports, $3l1Vc);
$parcel$exportWildcard(module.exports, $kvxnU);
$parcel$exportWildcard(module.exports, $7bMnp);
$parcel$exportWildcard(module.exports, $fBWP9);
$parcel$exportWildcard(module.exports, $5BV2y);
$parcel$exportWildcard(module.exports, $gtEBj);
$parcel$exportWildcard(module.exports, $15zeU);
$parcel$exportWildcard(module.exports, $hnysB);
$parcel$exportWildcard(module.exports, $WQoSR);
$parcel$exportWildcard(module.exports, $dkCo4);
$parcel$exportWildcard(module.exports, $eiKZE);
$parcel$exportWildcard(module.exports, $grd5c);
$parcel$exportWildcard(module.exports, $dO7Zu);
$parcel$exportWildcard(module.exports, $kc9Rd);
$parcel$exportWildcard(module.exports, $knJqU);
$parcel$exportWildcard(module.exports, $6tuq4);
$parcel$exportWildcard(module.exports, $7gR77);
$parcel$exportWildcard(module.exports, $cvCkY);
$parcel$exportWildcard(module.exports, $b8wWW);
$parcel$exportWildcard(module.exports, $gqmC4);
$parcel$exportWildcard(module.exports, $iBndS);
$parcel$exportWildcard(module.exports, $9pEI0);
$parcel$exportWildcard(module.exports, $hgfjM);
$parcel$exportWildcard(module.exports, $bPX90);
$parcel$exportWildcard(module.exports, $3Cynl);
$parcel$exportWildcard(module.exports, $276Mo);
$parcel$exportWildcard(module.exports, $gga5t);
$parcel$exportWildcard(module.exports, $iDl5h);

});
parcelRegister("aBu8J", function(module, exports) {

$parcel$export(module.exports, "WuiCard", function () { return $7b84bd3dd3d6d4c9$export$9de547c596d443f7; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $8bYvU = parcelRequire("8bYvU");
var $7b84bd3dd3d6d4c9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7b84bd3dd3d6d4c9$export$9de547c596d443f7 = class WuiCard extends (0, $75o4B.LitElement) {
    render() {
        return (0, $B77rE.html)`<slot></slot>`;
    }
};
$7b84bd3dd3d6d4c9$export$9de547c596d443f7.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $8bYvU.default)
];
$7b84bd3dd3d6d4c9$export$9de547c596d443f7 = $7b84bd3dd3d6d4c9$var$__decorate([
    (0, $3SCaV.customElement)("wui-card")
], $7b84bd3dd3d6d4c9$export$9de547c596d443f7);

});
parcelRegister("fU32g", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("dckYz")).css; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("B77rE")).html; });
$parcel$export(module.exports, "LitElement", function () { return (parcelRequire("75o4B")).LitElement; });
$parcel$export(module.exports, "svg", function () { return (parcelRequire("B77rE")).svg; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("dckYz")).unsafeCSS; });
parcelRequire("69ugF");
parcelRequire("B77rE");
parcelRequire("75o4B");
parcelRequire("94cNC");

});
parcelRegister("69ugF", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", function () { return $47ab0fe0aec73b94$export$7312b35fbf521afb; });
$parcel$export(module.exports, "notEqual", function () { return $47ab0fe0aec73b94$export$53a6892c50694894; });
$parcel$export(module.exports, "ReactiveElement", function () { return $47ab0fe0aec73b94$export$c7c07a37856565d; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("dckYz")).css; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("dckYz")).unsafeCSS; });

var $dckYz = parcelRequire("dckYz");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $47ab0fe0aec73b94$var$i, defineProperty: $47ab0fe0aec73b94$var$e, getOwnPropertyDescriptor: $47ab0fe0aec73b94$var$r, getOwnPropertyNames: $47ab0fe0aec73b94$var$h, getOwnPropertySymbols: $47ab0fe0aec73b94$var$o, getPrototypeOf: $47ab0fe0aec73b94$var$n } = Object, $47ab0fe0aec73b94$var$a = globalThis, $47ab0fe0aec73b94$var$c = $47ab0fe0aec73b94$var$a.trustedTypes, $47ab0fe0aec73b94$var$l = $47ab0fe0aec73b94$var$c ? $47ab0fe0aec73b94$var$c.emptyScript : "", $47ab0fe0aec73b94$var$p = $47ab0fe0aec73b94$var$a.reactiveElementPolyfillSupport, $47ab0fe0aec73b94$var$d = (t, s)=>t, $47ab0fe0aec73b94$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $47ab0fe0aec73b94$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $47ab0fe0aec73b94$export$53a6892c50694894 = (t, s)=>!$47ab0fe0aec73b94$var$i(t, s), $47ab0fe0aec73b94$var$y = {
    attribute: !0,
    type: String,
    converter: $47ab0fe0aec73b94$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $47ab0fe0aec73b94$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $47ab0fe0aec73b94$var$a.litPropertyMetadata ??= new WeakMap;
class $47ab0fe0aec73b94$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $47ab0fe0aec73b94$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $47ab0fe0aec73b94$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $47ab0fe0aec73b94$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $47ab0fe0aec73b94$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($47ab0fe0aec73b94$var$d("elementProperties"))) return;
        const t = $47ab0fe0aec73b94$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($47ab0fe0aec73b94$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($47ab0fe0aec73b94$var$d("properties"))) {
            const t = this.properties, s = [
                ...$47ab0fe0aec73b94$var$h(t),
                ...$47ab0fe0aec73b94$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $dckYz.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $dckYz.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $dckYz.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $47ab0fe0aec73b94$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $47ab0fe0aec73b94$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $47ab0fe0aec73b94$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$47ab0fe0aec73b94$export$c7c07a37856565d.elementStyles = [], $47ab0fe0aec73b94$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $47ab0fe0aec73b94$export$c7c07a37856565d[$47ab0fe0aec73b94$var$d("elementProperties")] = new Map, $47ab0fe0aec73b94$export$c7c07a37856565d[$47ab0fe0aec73b94$var$d("finalized")] = new Map, $47ab0fe0aec73b94$var$p?.({
    ReactiveElement: $47ab0fe0aec73b94$export$c7c07a37856565d
}), ($47ab0fe0aec73b94$var$a.reactiveElementVersions ??= []).push("2.0.4");

});
parcelRegister("dckYz", function(module, exports) {

$parcel$export(module.exports, "unsafeCSS", function () { return $99bcaab7bb61e59f$export$8d80f9cac07cdb3; });
$parcel$export(module.exports, "css", function () { return $99bcaab7bb61e59f$export$dbf350e5966cf602; });
$parcel$export(module.exports, "adoptStyles", function () { return $99bcaab7bb61e59f$export$2ca4a66ec4cecb90; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return $99bcaab7bb61e59f$export$ee69dfd951e24778; });
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $99bcaab7bb61e59f$var$t = globalThis, $99bcaab7bb61e59f$export$b4d10f6001c083c2 = $99bcaab7bb61e59f$var$t.ShadowRoot && (void 0 === $99bcaab7bb61e59f$var$t.ShadyCSS || $99bcaab7bb61e59f$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $99bcaab7bb61e59f$var$s = Symbol(), $99bcaab7bb61e59f$var$o = new WeakMap;
class $99bcaab7bb61e59f$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $99bcaab7bb61e59f$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($99bcaab7bb61e59f$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $99bcaab7bb61e59f$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $99bcaab7bb61e59f$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $99bcaab7bb61e59f$export$8d80f9cac07cdb3 = (t)=>new $99bcaab7bb61e59f$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $99bcaab7bb61e59f$var$s), $99bcaab7bb61e59f$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $99bcaab7bb61e59f$export$505d1e8739bad805(o, t, $99bcaab7bb61e59f$var$s);
}, $99bcaab7bb61e59f$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($99bcaab7bb61e59f$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $99bcaab7bb61e59f$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $99bcaab7bb61e59f$export$ee69dfd951e24778 = $99bcaab7bb61e59f$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $99bcaab7bb61e59f$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("B77rE", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $06f8fa84595b14ad$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "svg", function () { return $06f8fa84595b14ad$export$7ed1367e7fa1ad68; });
$parcel$export(module.exports, "noChange", function () { return $06f8fa84595b14ad$export$9c068ae9cc5db4e8; });
$parcel$export(module.exports, "nothing", function () { return $06f8fa84595b14ad$export$45b790e32b2810ee; });
$parcel$export(module.exports, "_$LH", function () { return $06f8fa84595b14ad$export$8613d1ca9052b22e; });
$parcel$export(module.exports, "render", function () { return $06f8fa84595b14ad$export$b3890eb0ae9dca99; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $06f8fa84595b14ad$var$n = globalThis, $06f8fa84595b14ad$var$c = $06f8fa84595b14ad$var$n.trustedTypes, $06f8fa84595b14ad$var$h = $06f8fa84595b14ad$var$c ? $06f8fa84595b14ad$var$c.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $06f8fa84595b14ad$var$f = "$lit$", $06f8fa84595b14ad$var$v = `lit$${Math.random().toFixed(9).slice(2)}$`, $06f8fa84595b14ad$var$m = "?" + $06f8fa84595b14ad$var$v, $06f8fa84595b14ad$var$_ = `<${$06f8fa84595b14ad$var$m}>`, $06f8fa84595b14ad$var$w = document, $06f8fa84595b14ad$var$lt = ()=>$06f8fa84595b14ad$var$w.createComment(""), $06f8fa84595b14ad$var$st = (t)=>null === t || "object" != typeof t && "function" != typeof t, $06f8fa84595b14ad$var$g = Array.isArray, $06f8fa84595b14ad$var$$ = (t)=>$06f8fa84595b14ad$var$g(t) || "function" == typeof t?.[Symbol.iterator], $06f8fa84595b14ad$var$x = "[ 	\n\f\r]", $06f8fa84595b14ad$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $06f8fa84595b14ad$var$E = /-->/g, $06f8fa84595b14ad$var$k = />/g, $06f8fa84595b14ad$var$O = RegExp(`>|${$06f8fa84595b14ad$var$x}(?:([^\\s"'>=/]+)(${$06f8fa84595b14ad$var$x}*=${$06f8fa84595b14ad$var$x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $06f8fa84595b14ad$var$S = /'/g, $06f8fa84595b14ad$var$j = /"/g, $06f8fa84595b14ad$var$M = /^(?:script|style|textarea|title)$/i, $06f8fa84595b14ad$var$P = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $06f8fa84595b14ad$export$c0bb0b647f701bb5 = $06f8fa84595b14ad$var$P(1), $06f8fa84595b14ad$export$7ed1367e7fa1ad68 = $06f8fa84595b14ad$var$P(2), $06f8fa84595b14ad$export$47d5b44d225be5b4 = $06f8fa84595b14ad$var$P(3), $06f8fa84595b14ad$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $06f8fa84595b14ad$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $06f8fa84595b14ad$var$V = new WeakMap, $06f8fa84595b14ad$var$I = $06f8fa84595b14ad$var$w.createTreeWalker($06f8fa84595b14ad$var$w, 129);
function $06f8fa84595b14ad$var$N(t, i) {
    if (!$06f8fa84595b14ad$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $06f8fa84595b14ad$var$h ? $06f8fa84595b14ad$var$h.createHTML(i) : i;
}
const $06f8fa84595b14ad$var$U = (t, i)=>{
    const s = t.length - 1, e = [];
    let h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $06f8fa84595b14ad$var$T;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let r, l, c = -1, a = 0;
        for(; a < s.length && (n.lastIndex = a, l = n.exec(s), null !== l);)a = n.lastIndex, n === $06f8fa84595b14ad$var$T ? "!--" === l[1] ? n = $06f8fa84595b14ad$var$E : void 0 !== l[1] ? n = $06f8fa84595b14ad$var$k : void 0 !== l[2] ? ($06f8fa84595b14ad$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $06f8fa84595b14ad$var$O) : void 0 !== l[3] && (n = $06f8fa84595b14ad$var$O) : n === $06f8fa84595b14ad$var$O ? ">" === l[0] ? (n = h ?? $06f8fa84595b14ad$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $06f8fa84595b14ad$var$O : '"' === l[3] ? $06f8fa84595b14ad$var$j : $06f8fa84595b14ad$var$S) : n === $06f8fa84595b14ad$var$j || n === $06f8fa84595b14ad$var$S ? n = $06f8fa84595b14ad$var$O : n === $06f8fa84595b14ad$var$E || n === $06f8fa84595b14ad$var$k ? n = $06f8fa84595b14ad$var$T : (n = $06f8fa84595b14ad$var$O, h = void 0);
        const u = n === $06f8fa84595b14ad$var$O && t[i + 1].startsWith("/>") ? " " : "";
        o += n === $06f8fa84595b14ad$var$T ? s + $06f8fa84595b14ad$var$_ : c >= 0 ? (e.push(r), s.slice(0, c) + $06f8fa84595b14ad$var$f + s.slice(c) + $06f8fa84595b14ad$var$v + u) : s + $06f8fa84595b14ad$var$v + (-2 === c ? i : u);
    }
    return [
        $06f8fa84595b14ad$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $06f8fa84595b14ad$var$B {
    constructor({ strings: t, _$litType$: i }, s){
        let e;
        this.parts = [];
        let h = 0, o = 0;
        const n = t.length - 1, r = this.parts, [l, a] = $06f8fa84595b14ad$var$U(t, i);
        if (this.el = $06f8fa84595b14ad$var$B.createElement(l, s), $06f8fa84595b14ad$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (e = $06f8fa84595b14ad$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                if (e.hasAttributes()) for (const t of e.getAttributeNames())if (t.endsWith($06f8fa84595b14ad$var$f)) {
                    const i = a[o++], s = e.getAttribute(t).split($06f8fa84595b14ad$var$v), n = /([.?@])?(.*)/.exec(i);
                    r.push({
                        type: 1,
                        index: h,
                        name: n[2],
                        strings: s,
                        ctor: "." === n[1] ? $06f8fa84595b14ad$var$Y : "?" === n[1] ? $06f8fa84595b14ad$var$Z : "@" === n[1] ? $06f8fa84595b14ad$var$q : $06f8fa84595b14ad$var$G
                    }), e.removeAttribute(t);
                } else t.startsWith($06f8fa84595b14ad$var$v) && (r.push({
                    type: 6,
                    index: h
                }), e.removeAttribute(t));
                if ($06f8fa84595b14ad$var$M.test(e.tagName)) {
                    const t = e.textContent.split($06f8fa84595b14ad$var$v), i = t.length - 1;
                    if (i > 0) {
                        e.textContent = $06f8fa84595b14ad$var$c ? $06f8fa84595b14ad$var$c.emptyScript : "";
                        for(let s = 0; s < i; s++)e.append(t[s], $06f8fa84595b14ad$var$lt()), $06f8fa84595b14ad$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t[i], $06f8fa84595b14ad$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $06f8fa84595b14ad$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = e.data.indexOf($06f8fa84595b14ad$var$v, t + 1));)r.push({
                        type: 7,
                        index: h
                    }), t += $06f8fa84595b14ad$var$v.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $06f8fa84595b14ad$var$w.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $06f8fa84595b14ad$var$z(t, i, s = t, e) {
    if (i === $06f8fa84595b14ad$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s.o?.[e] : s.l;
    const o = $06f8fa84595b14ad$var$st(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s.o ??= [])[e] = h : s.l = h), void 0 !== h && (i = $06f8fa84595b14ad$var$z(t, h._$AS(t, i.values), h, e)), i;
}
class $06f8fa84595b14ad$var$F {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $06f8fa84595b14ad$var$w).importNode(i, !0);
        $06f8fa84595b14ad$var$I.currentNode = e;
        let h = $06f8fa84595b14ad$var$I.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $06f8fa84595b14ad$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $06f8fa84595b14ad$var$K(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $06f8fa84595b14ad$var$I.nextNode(), o++);
        }
        return $06f8fa84595b14ad$var$I.currentNode = $06f8fa84595b14ad$var$w, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $06f8fa84595b14ad$var$et {
    get _$AU() {
        return this._$AM?._$AU ?? this.v;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $06f8fa84595b14ad$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $06f8fa84595b14ad$var$z(this, t, i), $06f8fa84595b14ad$var$st(t) ? t === $06f8fa84595b14ad$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $06f8fa84595b14ad$export$45b790e32b2810ee && this._$AR(), this._$AH = $06f8fa84595b14ad$export$45b790e32b2810ee) : t !== this._$AH && t !== $06f8fa84595b14ad$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $06f8fa84595b14ad$var$$(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $06f8fa84595b14ad$export$45b790e32b2810ee && $06f8fa84595b14ad$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($06f8fa84595b14ad$var$w.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $06f8fa84595b14ad$var$B.createElement($06f8fa84595b14ad$var$N(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $06f8fa84595b14ad$var$F(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $06f8fa84595b14ad$var$V.get(t.strings);
        return void 0 === i && $06f8fa84595b14ad$var$V.set(t.strings, i = new $06f8fa84595b14ad$var$B(t)), i;
    }
    k(t) {
        $06f8fa84595b14ad$var$g(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $06f8fa84595b14ad$var$et(this.O($06f8fa84595b14ad$var$lt()), this.O($06f8fa84595b14ad$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this.v = t, this._$AP?.(t));
    }
}
class $06f8fa84595b14ad$var$G {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $06f8fa84595b14ad$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $06f8fa84595b14ad$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $06f8fa84595b14ad$var$z(this, t, i, 0), o = !$06f8fa84595b14ad$var$st(t) || t !== this._$AH && t !== $06f8fa84595b14ad$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $06f8fa84595b14ad$var$z(this, e[s + n], i, n), r === $06f8fa84595b14ad$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$06f8fa84595b14ad$var$st(r) || r !== this._$AH[n], r === $06f8fa84595b14ad$export$45b790e32b2810ee ? t = $06f8fa84595b14ad$export$45b790e32b2810ee : t !== $06f8fa84595b14ad$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $06f8fa84595b14ad$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $06f8fa84595b14ad$var$Y extends $06f8fa84595b14ad$var$G {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $06f8fa84595b14ad$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $06f8fa84595b14ad$var$Z extends $06f8fa84595b14ad$var$G {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $06f8fa84595b14ad$export$45b790e32b2810ee);
    }
}
class $06f8fa84595b14ad$var$q extends $06f8fa84595b14ad$var$G {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $06f8fa84595b14ad$var$z(this, t, i, 0) ?? $06f8fa84595b14ad$export$45b790e32b2810ee) === $06f8fa84595b14ad$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $06f8fa84595b14ad$export$45b790e32b2810ee && s !== $06f8fa84595b14ad$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $06f8fa84595b14ad$export$45b790e32b2810ee && (s === $06f8fa84595b14ad$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $06f8fa84595b14ad$var$K {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $06f8fa84595b14ad$var$z(this, t);
    }
}
const $06f8fa84595b14ad$export$8613d1ca9052b22e = {
    M: $06f8fa84595b14ad$var$f,
    P: $06f8fa84595b14ad$var$v,
    A: $06f8fa84595b14ad$var$m,
    C: 1,
    L: $06f8fa84595b14ad$var$U,
    R: $06f8fa84595b14ad$var$F,
    D: $06f8fa84595b14ad$var$$,
    V: $06f8fa84595b14ad$var$z,
    I: $06f8fa84595b14ad$var$et,
    H: $06f8fa84595b14ad$var$G,
    N: $06f8fa84595b14ad$var$Z,
    U: $06f8fa84595b14ad$var$q,
    B: $06f8fa84595b14ad$var$Y,
    F: $06f8fa84595b14ad$var$K
}, $06f8fa84595b14ad$var$Re = $06f8fa84595b14ad$var$n.litHtmlPolyfillSupport;
$06f8fa84595b14ad$var$Re?.($06f8fa84595b14ad$var$B, $06f8fa84595b14ad$var$et), ($06f8fa84595b14ad$var$n.litHtmlVersions ??= []).push("3.2.0");
const $06f8fa84595b14ad$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $06f8fa84595b14ad$var$et(i.insertBefore($06f8fa84595b14ad$var$lt(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("75o4B", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("dckYz")).css; });
$parcel$export(module.exports, "ReactiveElement", function () { return (parcelRequire("69ugF")).ReactiveElement; });
$parcel$export(module.exports, "unsafeCSS", function () { return (parcelRequire("dckYz")).unsafeCSS; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("B77rE")).html; });
$parcel$export(module.exports, "noChange", function () { return (parcelRequire("B77rE")).noChange; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("B77rE")).render; });
$parcel$export(module.exports, "svg", function () { return (parcelRequire("B77rE")).svg; });

$parcel$export(module.exports, "LitElement", function () { return $528bac7adda6c155$export$3f2f9f5909897157; });

var $69ugF = parcelRequire("69ugF");

var $B77rE = parcelRequire("B77rE");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $528bac7adda6c155$export$3f2f9f5909897157 extends (0, $69ugF.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.o = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = (0, $B77rE.render)(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this.o?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.o?.setConnected(!1);
    }
    render() {
        return 0, $B77rE.noChange;
    }
}
$528bac7adda6c155$export$3f2f9f5909897157._$litElement$ = !0, $528bac7adda6c155$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $528bac7adda6c155$export$3f2f9f5909897157
});
const $528bac7adda6c155$var$f = globalThis.litElementPolyfillSupport;
$528bac7adda6c155$var$f?.({
    LitElement: $528bac7adda6c155$export$3f2f9f5909897157
});
const $528bac7adda6c155$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.0");

});

parcelRegister("94cNC", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $699e6a74a8cf9954$export$6acf61af03e62db = !1;

});


parcelRegister("cRWGJ", function(module, exports) {

$parcel$export(module.exports, "initializeTheming", function () { return $95e7f58315b143a2$export$8ee9916a43f985de; });
$parcel$export(module.exports, "setColorTheme", function () { return $95e7f58315b143a2$export$718db041b82c5d23; });
$parcel$export(module.exports, "setThemeVariables", function () { return $95e7f58315b143a2$export$b6ed091aa8078e9b; });
$parcel$export(module.exports, "resetStyles", function () { return $95e7f58315b143a2$export$6b6f359a824920a4; });
$parcel$export(module.exports, "elementStyles", function () { return $95e7f58315b143a2$export$e7ba49a1dbca65c7; });
$parcel$export(module.exports, "colorStyles", function () { return $95e7f58315b143a2$export$ab44001f5690ee9c; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
let $95e7f58315b143a2$var$themeTag = undefined;
let $95e7f58315b143a2$var$darkModeTag = undefined;
let $95e7f58315b143a2$var$lightModeTag = undefined;
function $95e7f58315b143a2$export$8ee9916a43f985de(themeVariables, themeMode) {
    $95e7f58315b143a2$var$themeTag = document.createElement("style");
    $95e7f58315b143a2$var$darkModeTag = document.createElement("style");
    $95e7f58315b143a2$var$lightModeTag = document.createElement("style");
    $95e7f58315b143a2$var$themeTag.textContent = $95e7f58315b143a2$var$createRootStyles(themeVariables).core.cssText;
    $95e7f58315b143a2$var$darkModeTag.textContent = $95e7f58315b143a2$var$createRootStyles(themeVariables).dark.cssText;
    $95e7f58315b143a2$var$lightModeTag.textContent = $95e7f58315b143a2$var$createRootStyles(themeVariables).light.cssText;
    document.head.appendChild($95e7f58315b143a2$var$themeTag);
    document.head.appendChild($95e7f58315b143a2$var$darkModeTag);
    document.head.appendChild($95e7f58315b143a2$var$lightModeTag);
    $95e7f58315b143a2$export$718db041b82c5d23(themeMode);
}
function $95e7f58315b143a2$export$718db041b82c5d23(themeMode) {
    if ($95e7f58315b143a2$var$darkModeTag && $95e7f58315b143a2$var$lightModeTag) {
        if (themeMode === "light") {
            $95e7f58315b143a2$var$darkModeTag.removeAttribute("media");
            $95e7f58315b143a2$var$lightModeTag.media = "enabled";
        } else {
            $95e7f58315b143a2$var$lightModeTag.removeAttribute("media");
            $95e7f58315b143a2$var$darkModeTag.media = "enabled";
        }
    }
}
function $95e7f58315b143a2$export$b6ed091aa8078e9b(themeVariables) {
    if ($95e7f58315b143a2$var$themeTag && $95e7f58315b143a2$var$darkModeTag && $95e7f58315b143a2$var$lightModeTag) {
        $95e7f58315b143a2$var$themeTag.textContent = $95e7f58315b143a2$var$createRootStyles(themeVariables).core.cssText;
        $95e7f58315b143a2$var$darkModeTag.textContent = $95e7f58315b143a2$var$createRootStyles(themeVariables).dark.cssText;
        $95e7f58315b143a2$var$lightModeTag.textContent = $95e7f58315b143a2$var$createRootStyles(themeVariables).light.cssText;
    }
}
function $95e7f58315b143a2$var$createRootStyles(themeVariables) {
    return {
        core: (0, $dckYz.css)`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
      :root {
        --w3m-color-mix-strength: ${(0, $dckYz.unsafeCSS)(themeVariables?.["--w3m-color-mix-strength"] ? `${themeVariables["--w3m-color-mix-strength"]}%` : "0%")};
        --w3m-font-family: ${(0, $dckYz.unsafeCSS)(themeVariables?.["--w3m-font-family"] || "Inter, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;")};
        --w3m-font-size-master: ${(0, $dckYz.unsafeCSS)(themeVariables?.["--w3m-font-size-master"] || "10px")};
        --w3m-border-radius-master: ${(0, $dckYz.unsafeCSS)(themeVariables?.["--w3m-border-radius-master"] || "4px")};
        --w3m-z-index: ${(0, $dckYz.unsafeCSS)(themeVariables?.["--w3m-z-index"] || 100)};

        --wui-font-family: var(--w3m-font-family);

        --wui-font-size-micro: var(--w3m-font-size-master);
        --wui-font-size-tiny: calc(var(--w3m-font-size-master) * 1.2);
        --wui-font-size-small: calc(var(--w3m-font-size-master) * 1.4);
        --wui-font-size-paragraph: calc(var(--w3m-font-size-master) * 1.6);
        --wui-font-size-large: calc(var(--w3m-font-size-master) * 2);
        --wui-font-size-medium-title: calc(var(--w3m-font-size-master) * 2.4);
        --wui-font-size-2xl: calc(var(--w3m-font-size-master) * 4);

        --wui-border-radius-5xs: var(--w3m-border-radius-master);
        --wui-border-radius-4xs: calc(var(--w3m-border-radius-master) * 1.5);
        --wui-border-radius-3xs: calc(var(--w3m-border-radius-master) * 2);
        --wui-border-radius-xxs: calc(var(--w3m-border-radius-master) * 3);
        --wui-border-radius-xs: calc(var(--w3m-border-radius-master) * 4);
        --wui-border-radius-s: calc(var(--w3m-border-radius-master) * 5);
        --wui-border-radius-m: calc(var(--w3m-border-radius-master) * 7);
        --wui-border-radius-l: calc(var(--w3m-border-radius-master) * 9);
        --wui-border-radius-3xl: calc(var(--w3m-border-radius-master) * 20);

        --wui-font-weight-light: 400;
        --wui-font-weight-regular: 500;
        --wui-font-weight-medium: 600;
        --wui-font-weight-bold: 700;

        --wui-letter-spacing-2xl: -1.6px;
        --wui-letter-spacing-medium-title: -0.96px;
        --wui-letter-spacing-large: -0.8px;
        --wui-letter-spacing-paragraph: -0.64px;
        --wui-letter-spacing-small: -0.56px;
        --wui-letter-spacing-tiny: -0.48px;
        --wui-letter-spacing-micro: -0.2px;

        --wui-spacing-0: 0px;
        --wui-spacing-4xs: 2px;
        --wui-spacing-3xs: 4px;
        --wui-spacing-xxs: 6px;
        --wui-spacing-2xs: 7px;
        --wui-spacing-xs: 8px;
        --wui-spacing-1xs: 10px;
        --wui-spacing-s: 12px;
        --wui-spacing-m: 14px;
        --wui-spacing-l: 16px;
        --wui-spacing-2l: 18px;
        --wui-spacing-xl: 20px;
        --wui-spacing-xxl: 24px;
        --wui-spacing-2xl: 32px;
        --wui-spacing-3xl: 40px;
        --wui-spacing-4xl: 90px;

        --wui-icon-box-size-xxs: 14px;
        --wui-icon-box-size-xs: 20px;
        --wui-icon-box-size-sm: 24px;
        --wui-icon-box-size-md: 32px;
        --wui-icon-box-size-lg: 40px;
        --wui-icon-box-size-xl: 64px;

        --wui-icon-size-inherit: inherit;
        --wui-icon-size-xxs: 10px;
        --wui-icon-size-xs: 12px;
        --wui-icon-size-sm: 14px;
        --wui-icon-size-md: 16px;
        --wui-icon-size-mdl: 18px;
        --wui-icon-size-lg: 20px;
        --wui-icon-size-xl: 24px;

        --wui-wallet-image-size-inherit: inherit;
        --wui-wallet-image-size-sm: 40px;
        --wui-wallet-image-size-md: 56px;
        --wui-wallet-image-size-lg: 80px;

        --wui-visual-size-size-inherit: inherit;
        --wui-visual-size-sm: 40px;
        --wui-visual-size-md: 55px;
        --wui-visual-size-lg: 80px;

        --wui-box-size-md: 100px;
        --wui-box-size-lg: 120px;

        --wui-ease-out-power-2: cubic-bezier(0, 0, 0.22, 1);
        --wui-ease-out-power-1: cubic-bezier(0, 0, 0.55, 1);

        --wui-ease-in-power-3: cubic-bezier(0.66, 0, 1, 1);
        --wui-ease-in-power-2: cubic-bezier(0.45, 0, 1, 1);
        --wui-ease-in-power-1: cubic-bezier(0.3, 0, 1, 1);

        --wui-ease-inout-power-1: cubic-bezier(0.45, 0, 0.55, 1);

        --wui-duration-lg: 200ms;
        --wui-duration-md: 125ms;
        --wui-duration-sm: 75ms;

        --wui-path-network-sm: path(
          'M15.4 2.1a5.21 5.21 0 0 1 5.2 0l11.61 6.7a5.21 5.21 0 0 1 2.61 4.52v13.4c0 1.87-1 3.59-2.6 4.52l-11.61 6.7c-1.62.93-3.6.93-5.22 0l-11.6-6.7a5.21 5.21 0 0 1-2.61-4.51v-13.4c0-1.87 1-3.6 2.6-4.52L15.4 2.1Z'
        );

        --wui-path-network-md: path(
          'M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z'
        );

        --wui-path-network-lg: path(
          'M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z'
        );

        --wui-width-network-sm: 36px;
        --wui-width-network-md: 48px;
        --wui-width-network-lg: 86px;

        --wui-height-network-sm: 40px;
        --wui-height-network-md: 54px;
        --wui-height-network-lg: 96px;

        --wui-icon-size-network-sm: 16px;
        --wui-icon-size-network-md: 24px;
        --wui-icon-size-network-lg: 42px;

        --wui-color-inherit: inherit;

        --wui-color-inverse-100: #fff;
        --wui-color-inverse-000: #000;

        --wui-cover: rgba(20, 20, 20, 0.8);

        --wui-color-modal-bg: var(--wui-color-modal-bg-base);

        --wui-color-blue-100: var(--wui-color-blue-base-100);

        --wui-color-accent-100: var(--wui-color-accent-base-100);
        --wui-color-accent-090: var(--wui-color-accent-base-090);
        --wui-color-accent-080: var(--wui-color-accent-base-080);

        --wui-accent-glass-090: var(--wui-accent-glass-base-090);
        --wui-accent-glass-080: var(--wui-accent-glass-base-080);
        --wui-accent-glass-020: var(--wui-accent-glass-base-020);
        --wui-accent-glass-015: var(--wui-accent-glass-base-015);
        --wui-accent-glass-010: var(--wui-accent-glass-base-010);
        --wui-accent-glass-005: var(--wui-accent-glass-base-005);
        --wui-accent-glass-002: var(--wui-accent-glass-base-002);

        --wui-color-fg-100: var(--wui-color-fg-base-100);
        --wui-color-fg-125: var(--wui-color-fg-base-125);
        --wui-color-fg-150: var(--wui-color-fg-base-150);
        --wui-color-fg-175: var(--wui-color-fg-base-175);
        --wui-color-fg-200: var(--wui-color-fg-base-200);
        --wui-color-fg-225: var(--wui-color-fg-base-225);
        --wui-color-fg-250: var(--wui-color-fg-base-250);
        --wui-color-fg-275: var(--wui-color-fg-base-275);
        --wui-color-fg-300: var(--wui-color-fg-base-300);

        --wui-color-bg-100: var(--wui-color-bg-base-100);
        --wui-color-bg-125: var(--wui-color-bg-base-125);
        --wui-color-bg-150: var(--wui-color-bg-base-150);
        --wui-color-bg-175: var(--wui-color-bg-base-175);
        --wui-color-bg-200: var(--wui-color-bg-base-200);
        --wui-color-bg-225: var(--wui-color-bg-base-225);
        --wui-color-bg-250: var(--wui-color-bg-base-250);
        --wui-color-bg-275: var(--wui-color-bg-base-275);
        --wui-color-bg-300: var(--wui-color-bg-base-300);

        --wui-color-success-100: var(--wui-color-success-base-100);
        --wui-color-error-100: var(--wui-color-error-base-100);

        --wui-icon-box-bg-error-100: var(--wui-icon-box-bg-error-base-100);
        --wui-icon-box-bg-blue-100: var(--wui-icon-box-bg-blue-base-100);
        --wui-icon-box-bg-success-100: var(--wui-icon-box-bg-success-base-100);
        --wui-icon-box-bg-inverse-100: var(--wui-icon-box-bg-inverse-base-100);

        --wui-all-wallets-bg-100: var(--wui-all-wallets-bg-base-100);

        --wui-avatar-border: var(--wui-avatar-border-base);

        --wui-thumbnail-border: var(--wui-thumbnail-border-base);

        --wui-box-shadow-blue: rgba(71, 161, 255, 0.16);
      }

      @supports (background: color-mix(in srgb, white 50%, black)) {
        :root {
          --wui-color-modal-bg: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-modal-bg-base)
          );

          --wui-box-shadow-blue: color-mix(in srgb, var(--wui-color-accent-100) 16%, transparent);

          --wui-color-accent-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            var(--w3m-default)
          );
          --wui-color-accent-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            var(--w3m-default)
          );

          --wui-color-accent-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-color-accent-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );

          --wui-accent-glass-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-accent-glass-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );
          --wui-accent-glass-020: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 20%,
            transparent
          );
          --wui-accent-glass-015: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 15%,
            transparent
          );
          --wui-accent-glass-010: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 10%,
            transparent
          );
          --wui-accent-glass-005: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 5%,
            transparent
          );
          --wui-color-accent-002: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 2%,
            transparent
          );

          --wui-color-fg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-100)
          );
          --wui-color-fg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-125)
          );
          --wui-color-fg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-150)
          );
          --wui-color-fg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-175)
          );
          --wui-color-fg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-200)
          );
          --wui-color-fg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-225)
          );
          --wui-color-fg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-250)
          );
          --wui-color-fg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-275)
          );
          --wui-color-fg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-300)
          );

          --wui-color-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-100)
          );
          --wui-color-bg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-125)
          );
          --wui-color-bg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-150)
          );
          --wui-color-bg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-175)
          );
          --wui-color-bg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-200)
          );
          --wui-color-bg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-225)
          );
          --wui-color-bg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-250)
          );
          --wui-color-bg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-275)
          );
          --wui-color-bg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-300)
          );

          --wui-color-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-success-base-100)
          );
          --wui-color-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-error-base-100)
          );

          --wui-icon-box-bg-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-error-base-100)
          );
          --wui-icon-box-bg-accent-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-blue-base-100)
          );
          --wui-icon-box-bg-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-success-base-100)
          );
          --wui-icon-box-bg-inverse-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-inverse-base-100)
          );

          --wui-all-wallets-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-all-wallets-bg-base-100)
          );

          --wui-avatar-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-avatar-border-base)
          );

          --wui-thumbnail-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-thumbnail-border-base)
          );
        }
      }
    `,
        light: (0, $dckYz.css)`
      :root {
        --w3m-color-mix: ${(0, $dckYz.unsafeCSS)(themeVariables?.["--w3m-color-mix"] || "#fff")};
        --w3m-accent: ${(0, $dckYz.unsafeCSS)(themeVariables?.["--w3m-accent"] || "#47a1ff")};
        --w3m-default: #fff;

        --wui-color-modal-bg-base: #191a1a;

        --wui-color-blue-base-100: #47a1ff;

        --wui-color-accent-base-100: var(--w3m-accent);
        --wui-color-accent-base-090: #59aaff;
        --wui-color-accent-base-080: #6cb4ff;

        --wui-accent-glass-base-090: rgba(71, 161, 255, 0.9);
        --wui-accent-glass-base-080: rgba(71, 161, 255, 0.8);
        --wui-accent-glass-base-020: rgba(71, 161, 255, 0.2);
        --wui-accent-glass-base-015: rgba(71, 161, 255, 0.15);
        --wui-accent-glass-base-010: rgba(71, 161, 255, 0.1);
        --wui-accent-glass-base-005: rgba(71, 161, 255, 0.05);
        --wui-accent-glass-base-002: rgba(71, 161, 255, 0.02);

        --wui-color-fg-base-100: #e4e7e7;
        --wui-color-fg-base-125: #d0d5d5;
        --wui-color-fg-base-150: #a8b1b1;
        --wui-color-fg-base-175: #a8b0b0;
        --wui-color-fg-base-200: #949e9e;
        --wui-color-fg-base-225: #868f8f;
        --wui-color-fg-base-250: #788080;
        --wui-color-fg-base-275: #788181;
        --wui-color-fg-base-300: #6e7777;

        --wui-color-bg-base-100: #141414;
        --wui-color-bg-base-125: #191a1a;
        --wui-color-bg-base-150: #1e1f1f;
        --wui-color-bg-base-175: #222525;
        --wui-color-bg-base-200: #272a2a;
        --wui-color-bg-base-225: #2c3030;
        --wui-color-bg-base-250: #313535;
        --wui-color-bg-base-275: #363b3b;
        --wui-color-bg-base-300: #3b4040;

        --wui-color-success-base-100: #26d962;
        --wui-color-error-base-100: #f25a67;

        --wui-success-glass-001: rgba(38, 217, 98, 0.01);
        --wui-success-glass-002: rgba(38, 217, 98, 0.02);
        --wui-success-glass-005: rgba(38, 217, 98, 0.05);
        --wui-success-glass-010: rgba(38, 217, 98, 0.1);
        --wui-success-glass-015: rgba(38, 217, 98, 0.15);
        --wui-success-glass-020: rgba(38, 217, 98, 0.2);
        --wui-success-glass-025: rgba(38, 217, 98, 0.25);
        --wui-success-glass-030: rgba(38, 217, 98, 0.3);
        --wui-success-glass-060: rgba(38, 217, 98, 0.6);
        --wui-success-glass-080: rgba(38, 217, 98, 0.8);

        --wui-error-glass-001: rgba(242, 90, 103, 0.01);
        --wui-error-glass-002: rgba(242, 90, 103, 0.02);
        --wui-error-glass-005: rgba(242, 90, 103, 0.05);
        --wui-error-glass-010: rgba(242, 90, 103, 0.1);
        --wui-error-glass-015: rgba(242, 90, 103, 0.15);
        --wui-error-glass-020: rgba(242, 90, 103, 0.2);
        --wui-error-glass-025: rgba(242, 90, 103, 0.25);
        --wui-error-glass-030: rgba(242, 90, 103, 0.3);
        --wui-error-glass-060: rgba(242, 90, 103, 0.6);
        --wui-error-glass-080: rgba(242, 90, 103, 0.8);

        --wui-icon-box-bg-error-base-100: #3c2426;
        --wui-icon-box-bg-blue-base-100: #20303f;
        --wui-icon-box-bg-success-base-100: #1f3a28;
        --wui-icon-box-bg-inverse-base-100: #243240;

        --wui-all-wallets-bg-base-100: #222b35;

        --wui-avatar-border-base: #252525;

        --wui-thumbnail-border-base: #252525;

        --wui-gray-glass-001: rgba(255, 255, 255, 0.01);
        --wui-gray-glass-002: rgba(255, 255, 255, 0.02);
        --wui-gray-glass-005: rgba(255, 255, 255, 0.05);
        --wui-gray-glass-010: rgba(255, 255, 255, 0.1);
        --wui-gray-glass-015: rgba(255, 255, 255, 0.15);
        --wui-gray-glass-020: rgba(255, 255, 255, 0.2);
        --wui-gray-glass-025: rgba(255, 255, 255, 0.25);
        --wui-gray-glass-030: rgba(255, 255, 255, 0.3);
        --wui-gray-glass-060: rgba(255, 255, 255, 0.6);
        --wui-gray-glass-080: rgba(255, 255, 255, 0.8);
      }
    `,
        dark: (0, $dckYz.css)`
      :root {
        --w3m-color-mix: ${(0, $dckYz.unsafeCSS)(themeVariables?.["--w3m-color-mix"] || "#000")};
        --w3m-accent: ${(0, $dckYz.unsafeCSS)(themeVariables?.["--w3m-accent"] || "#3396ff")};
        --w3m-default: #000;

        --wui-color-modal-bg-base: #fff;

        --wui-color-blue-base-100: #3396ff;

        --wui-color-accent-base-100: var(--w3m-accent);
        --wui-color-accent-base-090: #2d7dd2;
        --wui-color-accent-base-080: #2978cc;

        --wui-accent-glass-base-090: rgba(51, 150, 255, 0.9);
        --wui-accent-glass-base-080: rgba(51, 150, 255, 0.8);
        --wui-accent-glass-base-020: rgba(51, 150, 255, 0.2);
        --wui-accent-glass-base-015: rgba(51, 150, 255, 0.15);
        --wui-accent-glass-base-010: rgba(51, 150, 255, 0.1);
        --wui-accent-glass-base-005: rgba(51, 150, 255, 0.05);
        --wui-accent-glass-base-002: rgba(51, 150, 255, 0.02);

        --wui-color-fg-base-100: #141414;
        --wui-color-fg-base-125: #2d3131;
        --wui-color-fg-base-150: #474d4d;
        --wui-color-fg-base-175: #636d6d;
        --wui-color-fg-base-200: #798686;
        --wui-color-fg-base-225: #828f8f;
        --wui-color-fg-base-250: #8b9797;
        --wui-color-fg-base-275: #95a0a0;
        --wui-color-fg-base-300: #9ea9a9;

        --wui-color-bg-base-100: #ffffff;
        --wui-color-bg-base-125: #f5fafa;
        --wui-color-bg-base-150: #f3f8f8;
        --wui-color-bg-base-175: #eef4f4;
        --wui-color-bg-base-200: #eaf1f1;
        --wui-color-bg-base-225: #e5eded;
        --wui-color-bg-base-250: #e1e9e9;
        --wui-color-bg-base-275: #dce7e7;
        --wui-color-bg-base-300: #d8e3e3;

        --wui-color-success-base-100: #26b562;
        --wui-color-error-base-100: #f05142;

        --wui-success-glass-001: rgba(38, 181, 98, 0.01);
        --wui-success-glass-002: rgba(38, 181, 98, 0.02);
        --wui-success-glass-005: rgba(38, 181, 98, 0.05);
        --wui-success-glass-010: rgba(38, 181, 98, 0.1);
        --wui-success-glass-015: rgba(38, 181, 98, 0.15);
        --wui-success-glass-020: rgba(38, 181, 98, 0.2);
        --wui-success-glass-025: rgba(38, 181, 98, 0.25);
        --wui-success-glass-030: rgba(38, 181, 98, 0.3);
        --wui-success-glass-060: rgba(38, 181, 98, 0.6);
        --wui-success-glass-080: rgba(38, 181, 98, 0.8);

        --wui-error-glass-001: rgba(240, 81, 66, 0.01);
        --wui-error-glass-002: rgba(240, 81, 66, 0.02);
        --wui-error-glass-005: rgba(240, 81, 66, 0.05);
        --wui-error-glass-010: rgba(240, 81, 66, 0.1);
        --wui-error-glass-015: rgba(240, 81, 66, 0.15);
        --wui-error-glass-020: rgba(240, 81, 66, 0.2);
        --wui-error-glass-025: rgba(240, 81, 66, 0.25);
        --wui-error-glass-030: rgba(240, 81, 66, 0.3);
        --wui-error-glass-060: rgba(240, 81, 66, 0.6);
        --wui-error-glass-080: rgba(240, 81, 66, 0.8);

        --wui-icon-box-bg-error-base-100: #f4dfdd;
        --wui-icon-box-bg-blue-base-100: #d9ecfb;
        --wui-icon-box-bg-success-base-100: #daf0e4;
        --wui-icon-box-bg-inverse-base-100: #dcecfc;

        --wui-all-wallets-bg-base-100: #e8f1fa;

        --wui-avatar-border-base: #f3f4f4;

        --wui-thumbnail-border-base: #eaefef;

        --wui-gray-glass-001: rgba(0, 0, 0, 0.01);
        --wui-gray-glass-002: rgba(0, 0, 0, 0.02);
        --wui-gray-glass-005: rgba(0, 0, 0, 0.05);
        --wui-gray-glass-010: rgba(0, 0, 0, 0.1);
        --wui-gray-glass-015: rgba(0, 0, 0, 0.15);
        --wui-gray-glass-020: rgba(0, 0, 0, 0.2);
        --wui-gray-glass-025: rgba(0, 0, 0, 0.25);
        --wui-gray-glass-030: rgba(0, 0, 0, 0.3);
        --wui-gray-glass-060: rgba(0, 0, 0, 0.6);
        --wui-gray-glass-080: rgba(0, 0, 0, 0.8);
      }
    `
    };
}
const $95e7f58315b143a2$export$6b6f359a824920a4 = (0, $dckYz.css)`
  *,
  *::after,
  *::before,
  :host {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-style: normal;
    text-rendering: optimizeSpeed;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    font-family: var(--wui-font-family);
    backface-visibility: hidden;
  }
`;
const $95e7f58315b143a2$export$e7ba49a1dbca65c7 = (0, $dckYz.css)`
  button,
  a {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);
    outline: none;
    border: 1px solid transparent;
    column-gap: var(--wui-spacing-3xs);
    background-color: transparent;
    text-decoration: none;
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-gray-glass-005);
    }

    button:active:enabled {
      transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
      background-color: var(--wui-gray-glass-010);
    }

    button[data-variant='fill']:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button[data-variant='accentBg']:hover:enabled {
      background: var(--wui-accent-glass-015);
    }

    button[data-variant='accentBg']:active:enabled {
      background: var(--wui-accent-glass-020);
    }
  }

  button:disabled {
    cursor: not-allowed;
    background-color: var(--wui-gray-glass-005);
  }

  button[data-variant='shade']:disabled,
  button[data-variant='accent']:disabled,
  button[data-variant='accentBg']:disabled {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-gray-glass-015);
    filter: grayscale(1);
  }

  button:disabled > wui-wallet-image,
  button:disabled > wui-all-wallets-image,
  button:disabled > wui-network-image,
  button:disabled > wui-image,
  button:disabled > wui-icon-box,
  button:disabled > wui-transaction-visual,
  button:disabled > wui-logo {
    filter: grayscale(1);
  }

  button:focus-visible,
  a:focus-visible {
    border: 1px solid var(--wui-color-accent-100);
    background-color: var(--wui-gray-glass-005);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  button[data-variant='fill']:focus-visible {
    background-color: var(--wui-color-accent-090);
  }

  button[data-variant='fill'] {
    color: var(--wui-color-inverse-100);
    background-color: var(--wui-color-accent-100);
  }

  button[data-variant='fill']:disabled {
    color: var(--wui-gray-glass-015);
    background-color: var(--wui-gray-glass-015);
  }

  button[data-variant='fill']:disabled > wui-icon {
    color: var(--wui-gray-glass-015);
  }

  button[data-variant='shade'] {
    color: var(--wui-color-fg-200);
  }

  button[data-variant='accent'],
  button[data-variant='accentBg'] {
    color: var(--wui-color-accent-100);
  }

  button[data-variant='accentBg'] {
    background: var(--wui-accent-glass-010);
    border: 1px solid var(--wui-accent-glass-010);
  }

  button[data-variant='fullWidth'] {
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    height: 56px;
    border: none;
    background-color: var(--wui-gray-glass-002);
    color: var(--wui-color-fg-200);
    gap: var(--wui-spacing-xs);
  }

  button:active:enabled {
    background-color: var(--wui-gray-glass-010);
  }

  button[data-variant='fill']:active:enabled {
    background-color: var(--wui-color-accent-080);
    border: 1px solid var(--wui-gray-glass-010);
  }

  input {
    border: none;
    outline: none;
    appearance: none;
  }
`;
const $95e7f58315b143a2$export$ab44001f5690ee9c = (0, $dckYz.css)`
  .wui-color-inherit {
    color: var(--wui-color-inherit);
  }

  .wui-color-accent-100 {
    color: var(--wui-color-accent-100);
  }

  .wui-color-error-100 {
    color: var(--wui-color-error-100);
  }

  .wui-color-success-100 {
    color: var(--wui-color-success-100);
  }

  .wui-color-inverse-100 {
    color: var(--wui-color-inverse-100);
  }

  .wui-color-inverse-000 {
    color: var(--wui-color-inverse-000);
  }

  .wui-color-fg-100 {
    color: var(--wui-color-fg-100);
  }

  .wui-color-fg-200 {
    color: var(--wui-color-fg-200);
  }

  .wui-color-fg-300 {
    color: var(--wui-color-fg-300);
  }

  .wui-bg-color-inherit {
    background-color: var(--wui-color-inherit);
  }

  .wui-bg-color-blue-100 {
    background-color: var(--wui-color-accent-100);
  }

  .wui-bg-color-error-100 {
    background-color: var(--wui-color-error-100);
  }

  .wui-bg-color-success-100 {
    background-color: var(--wui-color-success-100);
  }

  .wui-bg-color-inverse-100 {
    background-color: var(--wui-color-inverse-100);
  }

  .wui-bg-color-inverse-000 {
    background-color: var(--wui-color-inverse-000);
  }

  .wui-bg-color-fg-100 {
    background-color: var(--wui-color-fg-100);
  }

  .wui-bg-color-fg-200 {
    background-color: var(--wui-color-fg-200);
  }

  .wui-bg-color-fg-300 {
    background-color: var(--wui-color-fg-300);
  }
`;

});

parcelRegister("3SCaV", function(module, exports) {

$parcel$export(module.exports, "customElement", function () { return $2d3407076b9800be$export$da64fc29f17f9d0e; });
function $2d3407076b9800be$var$standardCustomElement(tagName, descriptor) {
    const { kind: kind, elements: elements } = descriptor;
    return {
        kind: kind,
        elements: elements,
        finisher (clazz) {
            if (!customElements.get(tagName)) customElements.define(tagName, clazz);
        }
    };
}
function $2d3407076b9800be$var$legacyCustomElement(tagName, clazz) {
    if (!customElements.get(tagName)) customElements.define(tagName, clazz);
    return clazz;
}
function $2d3407076b9800be$export$da64fc29f17f9d0e(tagName) {
    return function create(classOrDescriptor) {
        return typeof classOrDescriptor === "function" ? $2d3407076b9800be$var$legacyCustomElement(tagName, classOrDescriptor) : $2d3407076b9800be$var$standardCustomElement(tagName, classOrDescriptor);
    };
}

});

parcelRegister("8bYvU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f6e4a9464e4aea3$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $5f6e4a9464e4aea3$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
    border-radius: clamp(0px, var(--wui-border-radius-l), 44px);
    box-shadow: 0 0 0 1px var(--wui-gray-glass-005);
    background-color: var(--wui-color-modal-bg);
    overflow: hidden;
  }
`;

});


parcelRegister("iVPOS", function(module, exports) {

$parcel$export(module.exports, "WuiIcon", function () { return $dc85bf2e57f45ab8$export$10b8e15b42b9fa26; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $6WVCq = parcelRequire("6WVCq");

var $7KwMl = parcelRequire("7KwMl");

var $8Dxkh = parcelRequire("8Dxkh");

var $8j159 = parcelRequire("8j159");

var $8VYFi = parcelRequire("8VYFi");

var $1Sixi = parcelRequire("1Sixi");

var $374zC = parcelRequire("374zC");

var $53Qy9 = parcelRequire("53Qy9");

var $8HfEV = parcelRequire("8HfEV");

var $is6yM = parcelRequire("is6yM");

var $b6act = parcelRequire("b6act");

var $cIm9i = parcelRequire("cIm9i");

var $lvhmN = parcelRequire("lvhmN");

var $7KmVH = parcelRequire("7KmVH");

var $h4mfr = parcelRequire("h4mfr");

var $fJfyt = parcelRequire("fJfyt");

var $j3Fj4 = parcelRequire("j3Fj4");

var $awSsd = parcelRequire("awSsd");

var $5CEWq = parcelRequire("5CEWq");

var $hcEpG = parcelRequire("hcEpG");

var $j2uQq = parcelRequire("j2uQq");

var $gy0tB = parcelRequire("gy0tB");

var $1Kd1g = parcelRequire("1Kd1g");

var $eiZ1j = parcelRequire("eiZ1j");

var $k7Qfa = parcelRequire("k7Qfa");

var $jgrOc = parcelRequire("jgrOc");

var $eEYlf = parcelRequire("eEYlf");

var $21Mdu = parcelRequire("21Mdu");

var $gkpAY = parcelRequire("gkpAY");

var $9WYDr = parcelRequire("9WYDr");

var $4WwOq = parcelRequire("4WwOq");

var $eo6lu = parcelRequire("eo6lu");

var $gvAfw = parcelRequire("gvAfw");

var $b1LSP = parcelRequire("b1LSP");

var $jBjKS = parcelRequire("jBjKS");

var $4xAYU = parcelRequire("4xAYU");

var $1lnAY = parcelRequire("1lnAY");

var $hpS9l = parcelRequire("hpS9l");

var $hV2A2 = parcelRequire("hV2A2");

var $kg5pG = parcelRequire("kg5pG");

var $f9X7j = parcelRequire("f9X7j");

var $2A3VN = parcelRequire("2A3VN");

var $kou21 = parcelRequire("kou21");

var $66bJO = parcelRequire("66bJO");

var $hlRHp = parcelRequire("hlRHp");

var $5wAYM = parcelRequire("5wAYM");

var $3htPj = parcelRequire("3htPj");

var $4YR4s = parcelRequire("4YR4s");

var $fFqfy = parcelRequire("fFqfy");

var $aT95G = parcelRequire("aT95G");

var $iZ2y1 = parcelRequire("iZ2y1");

var $e5T3Z = parcelRequire("e5T3Z");

var $BM3cM = parcelRequire("BM3cM");

var $4tPqI = parcelRequire("4tPqI");

var $6nxvY = parcelRequire("6nxvY");

var $28rn4 = parcelRequire("28rn4");

var $flH6b = parcelRequire("flH6b");

var $1GBK0 = parcelRequire("1GBK0");

var $9taPd = parcelRequire("9taPd");

var $8Cwu8 = parcelRequire("8Cwu8");

var $ktmt2 = parcelRequire("ktmt2");

var $dPv6D = parcelRequire("dPv6D");

var $3zmm4 = parcelRequire("3zmm4");
var $dc85bf2e57f45ab8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $dc85bf2e57f45ab8$var$svgOptions = {
    add: (0, $gy0tB.addSvg),
    allWallets: (0, $7KwMl.allWalletsSvg),
    arrowBottomCircle: (0, $8Dxkh.arrowBottomCircleSvg),
    appStore: (0, $8j159.appStoreSvg),
    apple: (0, $8VYFi.appleSvg),
    arrowBottom: (0, $1Sixi.arrowBottomSvg),
    arrowLeft: (0, $374zC.arrowLeftSvg),
    arrowRight: (0, $53Qy9.arrowRightSvg),
    arrowTop: (0, $8HfEV.arrowTopSvg),
    bank: (0, $ktmt2.bankSvg),
    browser: (0, $is6yM.browserSvg),
    card: (0, $dPv6D.cardSvg),
    checkmark: (0, $b6act.checkmarkSvg),
    chevronBottom: (0, $cIm9i.chevronBottomSvg),
    chevronLeft: (0, $lvhmN.chevronLeftSvg),
    chevronRight: (0, $7KmVH.chevronRightSvg),
    chevronTop: (0, $h4mfr.chevronTopSvg),
    chromeStore: (0, $fJfyt.chromeStoreSvg),
    clock: (0, $j3Fj4.clockSvg),
    close: (0, $awSsd.closeSvg),
    compass: (0, $hcEpG.compassSvg),
    coinPlaceholder: (0, $5CEWq.coinPlaceholderSvg),
    copy: (0, $j2uQq.copySvg),
    cursor: (0, $1Kd1g.cursorSvg),
    desktop: (0, $eiZ1j.desktopSvg),
    disconnect: (0, $k7Qfa.disconnectSvg),
    discord: (0, $jgrOc.discordSvg),
    etherscan: (0, $eEYlf.etherscanSvg),
    extension: (0, $21Mdu.extensionSvg),
    externalLink: (0, $gkpAY.externalLinkSvg),
    facebook: (0, $9WYDr.facebookSvg),
    filters: (0, $4WwOq.filtersSvg),
    github: (0, $eo6lu.githubSvg),
    google: (0, $gvAfw.googleSvg),
    helpCircle: (0, $b1LSP.helpCircleSvg),
    infoCircle: (0, $jBjKS.infoCircleSvg),
    mail: (0, $4xAYU.mailSvg),
    mobile: (0, $1lnAY.mobileSvg),
    networkPlaceholder: (0, $hpS9l.networkPlaceholderSvg),
    nftPlaceholder: (0, $hV2A2.nftPlaceholderSvg),
    off: (0, $kg5pG.offSvg),
    playStore: (0, $f9X7j.playStoreSvg),
    plus: (0, $3zmm4.plusSvg),
    qrCode: (0, $2A3VN.qrCodeIcon),
    recycleHorizontal: (0, $8Cwu8.recycleHorizontalSvg),
    refresh: (0, $kou21.refreshSvg),
    search: (0, $66bJO.searchSvg),
    send: (0, $hlRHp.sendSvg),
    swapHorizontal: (0, $5wAYM.swapHorizontalSvg),
    swapHorizontalMedium: (0, $4YR4s.swapHorizontalMediumSvg),
    swapHorizontalBold: (0, $3htPj.swapHorizontalBoldSvg),
    swapVertical: (0, $fFqfy.swapVerticalSvg),
    telegram: (0, $aT95G.telegramSvg),
    twitch: (0, $iZ2y1.twitchSvg),
    twitter: (0, $e5T3Z.twitterSvg),
    twitterIcon: (0, $BM3cM.twitterIconSvg),
    verify: (0, $4tPqI.verifySvg),
    verifyFilled: (0, $6nxvY.verifyFilledSvg),
    wallet: (0, $flH6b.walletSvg),
    walletConnect: (0, $1GBK0.walletConnectSvg),
    walletPlaceholder: (0, $28rn4.walletPlaceholderSvg),
    warningCircle: (0, $9taPd.warningCircleSvg)
};
let $dc85bf2e57f45ab8$export$10b8e15b42b9fa26 = class WuiIcon extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "copy";
        this.color = "fg-300";
    }
    render() {
        this.style.cssText = `
      --local-color: ${`var(--wui-color-${this.color});`}
      --local-width: ${`var(--wui-icon-size-${this.size});`}
    `;
        return (0, $B77rE.html)`${$dc85bf2e57f45ab8$var$svgOptions[this.name]}`;
    }
};
$dc85bf2e57f45ab8$export$10b8e15b42b9fa26.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.colorStyles),
    (0, $6WVCq.default)
];
$dc85bf2e57f45ab8$var$__decorate([
    (0, $cG9dN.property)()
], $dc85bf2e57f45ab8$export$10b8e15b42b9fa26.prototype, "size", void 0);
$dc85bf2e57f45ab8$var$__decorate([
    (0, $cG9dN.property)()
], $dc85bf2e57f45ab8$export$10b8e15b42b9fa26.prototype, "name", void 0);
$dc85bf2e57f45ab8$var$__decorate([
    (0, $cG9dN.property)()
], $dc85bf2e57f45ab8$export$10b8e15b42b9fa26.prototype, "color", void 0);
$dc85bf2e57f45ab8$export$10b8e15b42b9fa26 = $dc85bf2e57f45ab8$var$__decorate([
    (0, $3SCaV.customElement)("wui-icon")
], $dc85bf2e57f45ab8$export$10b8e15b42b9fa26);

});
parcelRegister("39dvr", function(module, exports) {
$parcel$export(module.exports, "property", function () { return (parcelRequire("cG9dN")).property; });
$parcel$export(module.exports, "state", function () { return (parcelRequire("aJMo2")).state; });
parcelRequire("2mFCb");
parcelRequire("cG9dN");
parcelRequire("aJMo2");
parcelRequire("hbS9d");
parcelRequire("9mHAH");
parcelRequire("5ZR5I");
parcelRequire("4cx46");
parcelRequire("idPU8");
parcelRequire("9gKLx");

});
parcelRegister("2mFCb", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1b8deab510a48edf$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("cG9dN", function(module, exports) {

$parcel$export(module.exports, "property", function () { return $93b08f7b93bfae02$export$d541bacb2bda4494; });

var $69ugF = parcelRequire("69ugF");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $93b08f7b93bfae02$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $69ugF.defaultConverter),
    reflect: !1,
    hasChanged: (0, $69ugF.notEqual)
}, $93b08f7b93bfae02$export$8d623b1670eb40f4 = (t = $93b08f7b93bfae02$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $93b08f7b93bfae02$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $93b08f7b93bfae02$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("aJMo2", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $7d13a3eda461d4db$export$ca000e230c0caa3e; });

var $cG9dN = parcelRequire("cG9dN");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7d13a3eda461d4db$export$ca000e230c0caa3e(r) {
    return (0, $cG9dN.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("hbS9d", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c83d7759ec3189fb$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("9mHAH", function(module, exports) {

var $dVSoC = parcelRequire("dVSoC");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $6d17fb63bb38d622$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $dVSoC.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $dVSoC.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("dVSoC", function(module, exports) {

$parcel$export(module.exports, "desc", function () { return $a24acb2e1f5f3fb2$export$51987bb50e1f6752; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a24acb2e1f5f3fb2$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("5ZR5I", function(module, exports) {

var $dVSoC = parcelRequire("dVSoC");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $45dbd51085dec4a9$var$e;
function $45dbd51085dec4a9$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $dVSoC.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($45dbd51085dec4a9$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("4cx46", function(module, exports) {

var $dVSoC = parcelRequire("dVSoC");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $30f1ee78684d1785$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $dVSoC.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("idPU8", function(module, exports) {

var $dVSoC = parcelRequire("dVSoC");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $036c6a211fc08f43$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $dVSoC.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("9gKLx", function(module, exports) {

var $dVSoC = parcelRequire("dVSoC");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $6bf9e25bd6610611$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $dVSoC.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("6WVCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50f4dabef4fb0061$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $50f4dabef4fb0061$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: flex;
    aspect-ratio: 1 / 1;
    color: var(--local-color);
    width: var(--local-width);
  }

  svg {
    width: inherit;
    height: inherit;
    object-fit: contain;
    object-position: center;
  }
`;

});

parcelRegister("7KwMl", function(module, exports) {

$parcel$export(module.exports, "allWalletsSvg", function () { return $5a4641720651ec0c$export$7d5fd172cc1c231a; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $5a4641720651ec0c$export$7d5fd172cc1c231a = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 24 24">
  <path
    style="fill: var(--wui-color-accent-100);"
    d="M10.2 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM10.2 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Z"
  />
</svg>`;

});

parcelRegister("8Dxkh", function(module, exports) {

$parcel$export(module.exports, "arrowBottomCircleSvg", function () { return $649bd12259c64057$export$33eab3b897a3adc1; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $649bd12259c64057$export$33eab3b897a3adc1 = (0, $B77rE.svg)`<svg
  fill="none"
  viewBox="0 0 21 20"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10.5 2.42908C6.31875 2.42908 2.92859 5.81989 2.92859 10.0034C2.92859 14.1869 6.31875 17.5777 10.5 17.5777C14.6813 17.5777 18.0714 14.1869 18.0714 10.0034C18.0714 5.81989 14.6813 2.42908 10.5 2.42908ZM0.928589 10.0034C0.928589 4.71596 5.21355 0.429077 10.5 0.429077C15.7865 0.429077 20.0714 4.71596 20.0714 10.0034C20.0714 15.2908 15.7865 19.5777 10.5 19.5777C5.21355 19.5777 0.928589 15.2908 0.928589 10.0034ZM10.5 5.75003C11.0523 5.75003 11.5 6.19774 11.5 6.75003L11.5 10.8343L12.7929 9.54137C13.1834 9.15085 13.8166 9.15085 14.2071 9.54137C14.5976 9.9319 14.5976 10.5651 14.2071 10.9556L11.2071 13.9556C10.8166 14.3461 10.1834 14.3461 9.79291 13.9556L6.79291 10.9556C6.40239 10.5651 6.40239 9.9319 6.79291 9.54137C7.18343 9.15085 7.8166 9.15085 8.20712 9.54137L9.50002 10.8343L9.50002 6.75003C9.50002 6.19774 9.94773 5.75003 10.5 5.75003Z"
    clip-rule="evenodd"
  /></svg
>`;

});

parcelRegister("8j159", function(module, exports) {

$parcel$export(module.exports, "appStoreSvg", function () { return $60c0efeea5ee9609$export$bda99385bd09fbb7; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $60c0efeea5ee9609$export$bda99385bd09fbb7 = (0, $B77rE.svg)`
<svg width="36" height="36">
  <path
    d="M28.724 0H7.271A7.269 7.269 0 0 0 0 7.272v21.46A7.268 7.268 0 0 0 7.271 36H28.73A7.272 7.272 0 0 0 36 28.728V7.272A7.275 7.275 0 0 0 28.724 0Z"
    fill="url(#a)"
  />
  <path
    d="m17.845 8.271.729-1.26a1.64 1.64 0 1 1 2.843 1.638l-7.023 12.159h5.08c1.646 0 2.569 1.935 1.853 3.276H6.434a1.632 1.632 0 0 1-1.638-1.638c0-.909.73-1.638 1.638-1.638h4.176l5.345-9.265-1.67-2.898a1.642 1.642 0 0 1 2.844-1.638l.716 1.264Zm-6.317 17.5-1.575 2.732a1.64 1.64 0 1 1-2.844-1.638l1.17-2.025c1.323-.41 2.398-.095 3.249.931Zm13.56-4.954h4.262c.909 0 1.638.729 1.638 1.638 0 .909-.73 1.638-1.638 1.638h-2.367l1.597 2.772c.45.788.185 1.782-.602 2.241a1.642 1.642 0 0 1-2.241-.603c-2.69-4.666-4.711-8.159-6.052-10.485-1.372-2.367-.391-4.743.576-5.549 1.075 1.846 2.682 4.631 4.828 8.348Z"
    fill="#fff"
  />
  <defs>
    <linearGradient id="a" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
      <stop stop-color="#18BFFB" />
      <stop offset="1" stop-color="#2072F3" />
    </linearGradient>
  </defs>
</svg>`;

});

parcelRegister("8VYFi", function(module, exports) {

$parcel$export(module.exports, "appleSvg", function () { return $6812b46f0fcabb98$export$3f5c85d1c093200; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $6812b46f0fcabb98$export$3f5c85d1c093200 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#000" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M28.77 23.3c-.69 1.99-2.75 5.52-4.87 5.56-1.4.03-1.86-.84-3.46-.84-1.61 0-2.12.81-3.45.86-2.25.1-5.72-5.1-5.72-9.62 0-4.15 2.9-6.2 5.42-6.25 1.36-.02 2.64.92 3.47.92.83 0 2.38-1.13 4.02-.97.68.03 2.6.28 3.84 2.08-3.27 2.14-2.76 6.61.75 8.25ZM24.2 7.88c-2.47.1-4.49 2.69-4.2 4.84 2.28.17 4.47-2.39 4.2-4.84Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("1Sixi", function(module, exports) {

$parcel$export(module.exports, "arrowBottomSvg", function () { return $15d936775392a2c9$export$6f382756ddebc10; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $15d936775392a2c9$export$6f382756ddebc10 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 1.99a1 1 0 0 1 1 1v7.58l2.46-2.46a1 1 0 0 1 1.41 1.42L7.7 13.69a1 1 0 0 1-1.41 0L2.12 9.53A1 1 0 0 1 3.54 8.1L6 10.57V3a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("374zC", function(module, exports) {

$parcel$export(module.exports, "arrowLeftSvg", function () { return $244592c0d045b9d6$export$539cc194b4601565; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $244592c0d045b9d6$export$539cc194b4601565 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M13 7.99a1 1 0 0 1-1 1H4.4l2.46 2.46a1 1 0 1 1-1.41 1.41L1.29 8.7a1 1 0 0 1 0-1.41L5.46 3.1a1 1 0 0 1 1.41 1.42L4.41 6.99H12a1 1 0 0 1 1 1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("53Qy9", function(module, exports) {

$parcel$export(module.exports, "arrowRightSvg", function () { return $3af5fee0491c1166$export$8c76deeccbfa0068; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $3af5fee0491c1166$export$8c76deeccbfa0068 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M1 7.99a1 1 0 0 1 1-1h7.58L7.12 4.53A1 1 0 1 1 8.54 3.1l4.16 4.17a1 1 0 0 1 0 1.41l-4.16 4.17a1 1 0 1 1-1.42-1.41l2.46-2.46H2a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("8HfEV", function(module, exports) {

$parcel$export(module.exports, "arrowTopSvg", function () { return $654e7c7862f347ae$export$2903aa7e1dab2e70; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $654e7c7862f347ae$export$2903aa7e1dab2e70 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 13.99a1 1 0 0 1-1-1V5.4L3.54 7.86a1 1 0 0 1-1.42-1.41L6.3 2.28a1 1 0 0 1 1.41 0l4.17 4.17a1 1 0 1 1-1.41 1.41L8 5.4v7.59a1 1 0 0 1-1 1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("is6yM", function(module, exports) {

$parcel$export(module.exports, "browserSvg", function () { return $d6efee306e2a569a$export$9a659d11e13bcec5; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $d6efee306e2a569a$export$9a659d11e13bcec5 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4 6.4a1 1 0 0 1-.46.89 6.98 6.98 0 0 0 .38 6.18A7 7 0 0 0 16.46 7.3a1 1 0 0 1-.47-.92 7 7 0 0 0-12 .03Zm-2.02-.5a9 9 0 1 1 16.03 8.2A9 9 0 0 1 1.98 5.9Z"
    clip-rule="evenodd"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.03 8.63c-1.46-.3-2.72-.75-3.6-1.35l-.02-.01-.14-.11a1 1 0 0 1 1.2-1.6l.1.08c.6.4 1.52.74 2.69 1 .16-.99.39-1.88.67-2.65.3-.79.68-1.5 1.15-2.02A2.58 2.58 0 0 1 9.99 1c.8 0 1.45.44 1.92.97.47.52.84 1.23 1.14 2.02.29.77.52 1.66.68 2.64a8 8 0 0 0 2.7-1l.26-.18h.48a1 1 0 0 1 .12 2c-.86.51-2.01.91-3.34 1.18a22.24 22.24 0 0 1-.03 3.19c1.45.29 2.7.73 3.58 1.31a1 1 0 0 1-1.1 1.68c-.6-.4-1.56-.76-2.75-1-.15.8-.36 1.55-.6 2.2-.3.79-.67 1.5-1.14 2.02-.47.53-1.12.97-1.92.97-.8 0-1.45-.44-1.91-.97a6.51 6.51 0 0 1-1.15-2.02c-.24-.65-.44-1.4-.6-2.2-1.18.24-2.13.6-2.73.99a1 1 0 1 1-1.1-1.67c.88-.58 2.12-1.03 3.57-1.31a22.03 22.03 0 0 1-.04-3.2Zm2.2-1.7c.15-.86.34-1.61.58-2.24.24-.65.51-1.12.76-1.4.25-.28.4-.29.42-.29.03 0 .17.01.42.3.25.27.52.74.77 1.4.23.62.43 1.37.57 2.22a19.96 19.96 0 0 1-3.52 0Zm-.18 4.6a20.1 20.1 0 0 1-.03-2.62 21.95 21.95 0 0 0 3.94 0 20.4 20.4 0 0 1-.03 2.63 21.97 21.97 0 0 0-3.88 0Zm.27 2c.13.66.3 1.26.49 1.78.24.65.51 1.12.76 1.4.25.28.4.29.42.29.03 0 .17-.01.42-.3.25-.27.52-.74.77-1.4.19-.5.36-1.1.49-1.78a20.03 20.03 0 0 0-3.35 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("b6act", function(module, exports) {

$parcel$export(module.exports, "checkmarkSvg", function () { return $81482ac8aa043784$export$1e994e99baa45d19; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $81482ac8aa043784$export$1e994e99baa45d19 = (0, $B77rE.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="12"
  viewBox="0 0 12 12"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.537 2.34245C10.8997 2.64654 10.9471 3.187 10.6429 3.54959L5.61072 9.54757C5.45645 9.73144 5.23212 9.84222 4.99229 9.85295C4.75247 9.86368 4.51914 9.77337 4.34906 9.60401L1.40881 6.6761C1.07343 6.34213 1.07238 5.7996 1.40647 5.46433C1.74055 5.12906 2.28326 5.12801 2.61865 5.46198L4.89731 7.73108L9.32942 2.44834C9.63362 2.08576 10.1743 2.03835 10.537 2.34245Z"
    fill="currentColor"
  /></svg
>`;

});

parcelRegister("cIm9i", function(module, exports) {

$parcel$export(module.exports, "chevronBottomSvg", function () { return $941ac66cfeedbbff$export$515090d56df26148; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $941ac66cfeedbbff$export$515090d56df26148 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M1.46 4.96a1 1 0 0 1 1.41 0L8 10.09l5.13-5.13a1 1 0 1 1 1.41 1.41l-5.83 5.84a1 1 0 0 1-1.42 0L1.46 6.37a1 1 0 0 1 0-1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("lvhmN", function(module, exports) {

$parcel$export(module.exports, "chevronLeftSvg", function () { return $fa79f6de1af4b36a$export$dd4e32e981ac6b2; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $fa79f6de1af4b36a$export$dd4e32e981ac6b2 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M11.04 1.46a1 1 0 0 1 0 1.41L5.91 8l5.13 5.13a1 1 0 1 1-1.41 1.41L3.79 8.71a1 1 0 0 1 0-1.42l5.84-5.83a1 1 0 0 1 1.41 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("7KmVH", function(module, exports) {

$parcel$export(module.exports, "chevronRightSvg", function () { return $5a3e9da07687b1d6$export$79c9cf11f1aff07c; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $5a3e9da07687b1d6$export$79c9cf11f1aff07c = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.96 14.54a1 1 0 0 1 0-1.41L10.09 8 4.96 2.87a1 1 0 0 1 1.41-1.41l5.84 5.83a1 1 0 0 1 0 1.42l-5.84 5.83a1 1 0 0 1-1.41 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("h4mfr", function(module, exports) {

$parcel$export(module.exports, "chevronTopSvg", function () { return $c6d411630103d8bc$export$95ea2c128f24f835; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $c6d411630103d8bc$export$95ea2c128f24f835 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M14.54 11.04a1 1 0 0 1-1.41 0L8 5.92l-5.13 5.12a1 1 0 1 1-1.41-1.41l5.83-5.84a1 1 0 0 1 1.42 0l5.83 5.84a1 1 0 0 1 0 1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("fJfyt", function(module, exports) {

$parcel$export(module.exports, "chromeStoreSvg", function () { return $b7371fe0c4459f6d$export$a97c1f844e68ea51; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $b7371fe0c4459f6d$export$a97c1f844e68ea51 = (0, $B77rE.svg)`<svg width="36" height="36" fill="none">
  <path
    fill="#fff"
    fill-opacity=".05"
    d="M0 14.94c0-5.55 0-8.326 1.182-10.4a9 9 0 0 1 3.359-3.358C6.614 0 9.389 0 14.94 0h6.12c5.55 0 8.326 0 10.4 1.182a9 9 0 0 1 3.358 3.359C36 6.614 36 9.389 36 14.94v6.12c0 5.55 0 8.326-1.182 10.4a9 9 0 0 1-3.359 3.358C29.386 36 26.611 36 21.06 36h-6.12c-5.55 0-8.326 0-10.4-1.182a9 9 0 0 1-3.358-3.359C0 29.386 0 26.611 0 21.06v-6.12Z"
  />
  <path
    stroke="#fff"
    stroke-opacity=".05"
    d="M14.94.5h6.12c2.785 0 4.84 0 6.46.146 1.612.144 2.743.43 3.691.97a8.5 8.5 0 0 1 3.172 3.173c.541.948.826 2.08.971 3.692.145 1.62.146 3.675.146 6.459v6.12c0 2.785 0 4.84-.146 6.46-.145 1.612-.43 2.743-.97 3.691a8.5 8.5 0 0 1-3.173 3.172c-.948.541-2.08.826-3.692.971-1.62.145-3.674.146-6.459.146h-6.12c-2.784 0-4.84 0-6.46-.146-1.612-.145-2.743-.43-3.691-.97a8.5 8.5 0 0 1-3.172-3.173c-.541-.948-.827-2.08-.971-3.692C.5 25.9.5 23.845.5 21.06v-6.12c0-2.784 0-4.84.146-6.46.144-1.612.43-2.743.97-3.691A8.5 8.5 0 0 1 4.79 1.617C5.737 1.076 6.869.79 8.48.646 10.1.5 12.156.5 14.94.5Z"
  />
  <path
    fill="url(#a)"
    d="M17.998 10.8h12.469a14.397 14.397 0 0 0-24.938.001l6.234 10.798.006-.001a7.19 7.19 0 0 1 6.23-10.799Z"
  />
  <path
    fill="url(#b)"
    d="m24.237 21.598-6.234 10.798A14.397 14.397 0 0 0 30.47 10.798H18.002l-.002.006a7.191 7.191 0 0 1 6.237 10.794Z"
  />
  <path
    fill="url(#c)"
    d="M11.765 21.601 5.531 10.803A14.396 14.396 0 0 0 18.001 32.4l6.235-10.798-.004-.004a7.19 7.19 0 0 1-12.466.004Z"
  />
  <path fill="#fff" d="M18 25.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" />
  <path fill="#1A73E8" d="M18 23.7a5.7 5.7 0 1 0 0-11.4 5.7 5.7 0 0 0 0 11.4Z" />
  <defs>
    <linearGradient
      id="a"
      x1="6.294"
      x2="41.1"
      y1="5.995"
      y2="5.995"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#D93025" />
      <stop offset="1" stop-color="#EA4335" />
    </linearGradient>
    <linearGradient
      id="b"
      x1="20.953"
      x2="37.194"
      y1="32.143"
      y2="2.701"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FCC934" />
      <stop offset="1" stop-color="#FBBC04" />
    </linearGradient>
    <linearGradient
      id="c"
      x1="25.873"
      x2="9.632"
      y1="31.2"
      y2="1.759"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#1E8E3E" />
      <stop offset="1" stop-color="#34A853" />
    </linearGradient>
  </defs>
</svg>`;

});

parcelRegister("j3Fj4", function(module, exports) {

$parcel$export(module.exports, "clockSvg", function () { return $ddfe56c336f672c9$export$36e96663783b415c; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $ddfe56c336f672c9$export$36e96663783b415c = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 2.99a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-4a1 1 0 0 1 1 1v2.58l1.85 1.85a1 1 0 0 1-1.41 1.42L6.29 8.69A1 1 0 0 1 6 8v-3a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("awSsd", function(module, exports) {

$parcel$export(module.exports, "closeSvg", function () { return $7aa721fb6faccb5b$export$e973b7b7b0b44400; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $7aa721fb6faccb5b$export$e973b7b7b0b44400 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M2.54 2.54a1 1 0 0 1 1.42 0L8 6.6l4.04-4.05a1 1 0 1 1 1.42 1.42L9.4 8l4.05 4.04a1 1 0 0 1-1.42 1.42L8 9.4l-4.04 4.05a1 1 0 0 1-1.42-1.42L6.6 8 2.54 3.96a1 1 0 0 1 0-1.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("5CEWq", function(module, exports) {

$parcel$export(module.exports, "coinPlaceholderSvg", function () { return $418042700b5e90ca$export$c48cbfcb1f749517; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $418042700b5e90ca$export$c48cbfcb1f749517 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10 3a7 7 0 0 0-6.85 8.44l8.29-8.3C10.97 3.06 10.49 3 10 3Zm3.49.93-9.56 9.56c.32.55.71 1.06 1.16 1.5L15 5.1a7.03 7.03 0 0 0-1.5-1.16Zm2.7 2.8-9.46 9.46a7 7 0 0 0 9.46-9.46ZM1.99 5.9A9 9 0 1 1 18 14.09 9 9 0 0 1 1.98 5.91Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("hcEpG", function(module, exports) {

$parcel$export(module.exports, "compassSvg", function () { return $c862e7ddbd2a1418$export$9fe5dd11ac55c8d4; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $c862e7ddbd2a1418$export$9fe5dd11ac55c8d4 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm10.66-2.65a1 1 0 0 1 .23 1.06L9.83 9.24a1 1 0 0 1-.59.58l-2.83 1.06A1 1 0 0 1 5.13 9.6l1.06-2.82a1 1 0 0 1 .58-.59L9.6 5.12a1 1 0 0 1 1.06.23ZM7.9 7.89l-.13.35.35-.13.12-.35-.34.13Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("j2uQq", function(module, exports) {

$parcel$export(module.exports, "copySvg", function () { return $ddc621567be1ef3b$export$ec40c5c35ef5dd82; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $ddc621567be1ef3b$export$ec40c5c35ef5dd82 = (0, $B77rE.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.21498 1.28565H10.5944C11.1458 1.28562 11.6246 1.2856 12.0182 1.32093C12.4353 1.35836 12.853 1.44155 13.2486 1.66724C13.7005 1.92498 14.0749 2.29935 14.3326 2.75122C14.5583 3.14689 14.6415 3.56456 14.6789 3.9817C14.7143 4.37531 14.7142 4.85403 14.7142 5.40545V6.78489C14.7142 7.33631 14.7143 7.81503 14.6789 8.20865C14.6415 8.62578 14.5583 9.04345 14.3326 9.43912C14.0749 9.89099 13.7005 10.2654 13.2486 10.5231C12.853 10.7488 12.4353 10.832 12.0182 10.8694C11.7003 10.8979 11.3269 10.9034 10.9045 10.9045C10.9034 11.3269 10.8979 11.7003 10.8694 12.0182C10.832 12.4353 10.7488 12.853 10.5231 13.2486C10.2654 13.7005 9.89099 14.0749 9.43912 14.3326C9.04345 14.5583 8.62578 14.6415 8.20865 14.6789C7.81503 14.7143 7.33631 14.7142 6.78489 14.7142H5.40545C4.85403 14.7142 4.37531 14.7143 3.9817 14.6789C3.56456 14.6415 3.14689 14.5583 2.75122 14.3326C2.29935 14.0749 1.92498 13.7005 1.66724 13.2486C1.44155 12.853 1.35836 12.4353 1.32093 12.0182C1.2856 11.6246 1.28562 11.1458 1.28565 10.5944V9.21498C1.28562 8.66356 1.2856 8.18484 1.32093 7.79122C1.35836 7.37409 1.44155 6.95642 1.66724 6.56074C1.92498 6.10887 2.29935 5.73451 2.75122 5.47677C3.14689 5.25108 3.56456 5.16789 3.9817 5.13045C4.2996 5.10192 4.67301 5.09645 5.09541 5.09541C5.09645 4.67302 5.10192 4.2996 5.13045 3.9817C5.16789 3.56456 5.25108 3.14689 5.47676 2.75122C5.73451 2.29935 6.10887 1.92498 6.56074 1.66724C6.95642 1.44155 7.37409 1.35836 7.79122 1.32093C8.18484 1.2856 8.66356 1.28562 9.21498 1.28565ZM5.09541 7.09552C4.68397 7.09667 4.39263 7.10161 4.16046 7.12245C3.88053 7.14757 3.78516 7.18949 3.74214 7.21403C3.60139 7.29431 3.48478 7.41091 3.4045 7.55166C3.37997 7.59468 3.33804 7.69005 3.31292 7.96999C3.28659 8.26345 3.28565 8.65147 3.28565 9.25708V10.5523C3.28565 11.1579 3.28659 11.5459 3.31292 11.8394C3.33804 12.1193 3.37997 12.2147 3.4045 12.2577C3.48478 12.3985 3.60139 12.5151 3.74214 12.5954C3.78516 12.6199 3.88053 12.6618 4.16046 12.6869C4.45393 12.7133 4.84195 12.7142 5.44755 12.7142H6.74279C7.3484 12.7142 7.73641 12.7133 8.02988 12.6869C8.30981 12.6618 8.40518 12.6199 8.44821 12.5954C8.58895 12.5151 8.70556 12.3985 8.78584 12.2577C8.81038 12.2147 8.8523 12.1193 8.87742 11.8394C8.89825 11.6072 8.90319 11.3159 8.90435 10.9045C8.48219 10.9034 8.10898 10.8979 7.79122 10.8694C7.37409 10.832 6.95641 10.7488 6.56074 10.5231C6.10887 10.2654 5.73451 9.89099 5.47676 9.43912C5.25108 9.04345 5.16789 8.62578 5.13045 8.20865C5.10194 7.89089 5.09645 7.51767 5.09541 7.09552ZM7.96999 3.31292C7.69005 3.33804 7.59468 3.37997 7.55166 3.4045C7.41091 3.48478 7.29431 3.60139 7.21403 3.74214C7.18949 3.78516 7.14757 3.88053 7.12245 4.16046C7.09611 4.45393 7.09517 4.84195 7.09517 5.44755V6.74279C7.09517 7.3484 7.09611 7.73641 7.12245 8.02988C7.14757 8.30981 7.18949 8.40518 7.21403 8.4482C7.29431 8.58895 7.41091 8.70556 7.55166 8.78584C7.59468 8.81038 7.69005 8.8523 7.96999 8.87742C8.26345 8.90376 8.65147 8.9047 9.25708 8.9047H10.5523C11.1579 8.9047 11.5459 8.90376 11.8394 8.87742C12.1193 8.8523 12.2147 8.81038 12.2577 8.78584C12.3985 8.70556 12.5151 8.58895 12.5954 8.4482C12.6199 8.40518 12.6618 8.30981 12.6869 8.02988C12.7133 7.73641 12.7142 7.3484 12.7142 6.74279V5.44755C12.7142 4.84195 12.7133 4.45393 12.6869 4.16046C12.6618 3.88053 12.6199 3.78516 12.5954 3.74214C12.5151 3.60139 12.3985 3.48478 12.2577 3.4045C12.2147 3.37997 12.1193 3.33804 11.8394 3.31292C11.5459 3.28659 11.1579 3.28565 10.5523 3.28565H9.25708C8.65147 3.28565 8.26345 3.28659 7.96999 3.31292Z"
    fill="#788181"
  /></svg
>`;

});

parcelRegister("gy0tB", function(module, exports) {

$parcel$export(module.exports, "addSvg", function () { return $c0c030e9cf889af8$export$ca7db417ce6a3550; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $c0c030e9cf889af8$export$ca7db417ce6a3550 = (0, $B77rE.svg)`<svg
  width="14"
  height="14"
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.0023 0.875C7.48571 0.875 7.8776 1.26675 7.8776 1.75V6.125H12.2541C12.7375 6.125 13.1294 6.51675 13.1294 7C13.1294 7.48325 12.7375 7.875 12.2541 7.875H7.8776V12.25C7.8776 12.7332 7.48571 13.125 7.0023 13.125C6.51889 13.125 6.12701 12.7332 6.12701 12.25V7.875H1.75054C1.26713 7.875 0.875244 7.48325 0.875244 7C0.875244 6.51675 1.26713 6.125 1.75054 6.125H6.12701V1.75C6.12701 1.26675 6.51889 0.875 7.0023 0.875Z"
    fill="#47A1FF"
  /></svg
>`;

});

parcelRegister("1Kd1g", function(module, exports) {

$parcel$export(module.exports, "cursorSvg", function () { return $14542fada1bd4d59$export$615c57907ad3661f; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $14542fada1bd4d59$export$615c57907ad3661f = (0, $B77rE.svg)` <svg fill="none" viewBox="0 0 13 4">
  <path fill="currentColor" d="M.5 0h12L8.9 3.13a3.76 3.76 0 0 1-4.8 0L.5 0Z" />
</svg>`;

});

parcelRegister("eiZ1j", function(module, exports) {

$parcel$export(module.exports, "desktopSvg", function () { return $a6a2147b026cd2a8$export$7a2123fcf97e10d1; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $a6a2147b026cd2a8$export$7a2123fcf97e10d1 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M13.66 2H6.34c-1.07 0-1.96 0-2.68.08-.74.08-1.42.25-2.01.68a4 4 0 0 0-.89.89c-.43.6-.6 1.27-.68 2.01C0 6.38 0 7.26 0 8.34v.89c0 1.07 0 1.96.08 2.68.08.74.25 1.42.68 2.01a4 4 0 0 0 .89.89c.6.43 1.27.6 2.01.68a27 27 0 0 0 2.68.08h7.32a27 27 0 0 0 2.68-.08 4.03 4.03 0 0 0 2.01-.68 4 4 0 0 0 .89-.89c.43-.6.6-1.27.68-2.01.08-.72.08-1.6.08-2.68v-.89c0-1.07 0-1.96-.08-2.68a4.04 4.04 0 0 0-.68-2.01 4 4 0 0 0-.89-.89c-.6-.43-1.27-.6-2.01-.68C15.62 2 14.74 2 13.66 2ZM2.82 4.38c.2-.14.48-.25 1.06-.31C4.48 4 5.25 4 6.4 4h7.2c1.15 0 1.93 0 2.52.07.58.06.86.17 1.06.31a2 2 0 0 1 .44.44c.14.2.25.48.31 1.06.07.6.07 1.37.07 2.52v.77c0 1.15 0 1.93-.07 2.52-.06.58-.17.86-.31 1.06a2 2 0 0 1-.44.44c-.2.14-.48.25-1.06.32-.6.06-1.37.06-2.52.06H6.4c-1.15 0-1.93 0-2.52-.06-.58-.07-.86-.18-1.06-.32a2 2 0 0 1-.44-.44c-.14-.2-.25-.48-.31-1.06C2 11.1 2 10.32 2 9.17V8.4c0-1.15 0-1.93.07-2.52.06-.58.17-.86.31-1.06a2 2 0 0 1 .44-.44Z"
    clip-rule="evenodd"
  />
  <path fill="currentColor" d="M6.14 17.57a1 1 0 1 0 0 2h7.72a1 1 0 1 0 0-2H6.14Z" />
</svg>`;

});

parcelRegister("k7Qfa", function(module, exports) {

$parcel$export(module.exports, "disconnectSvg", function () { return $ea6cfc9c65675583$export$50fbdab79b8f082d; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $ea6cfc9c65675583$export$50fbdab79b8f082d = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.07 1h.57a1 1 0 0 1 0 2h-.52c-.98 0-1.64 0-2.14.06-.48.05-.7.14-.84.24-.13.1-.25.22-.34.35-.1.14-.2.35-.25.83-.05.5-.05 1.16-.05 2.15v2.74c0 .99 0 1.65.05 2.15.05.48.14.7.25.83.1.14.2.25.34.35.14.1.36.2.84.25.5.05 1.16.05 2.14.05h.52a1 1 0 0 1 0 2h-.57c-.92 0-1.69 0-2.3-.07a3.6 3.6 0 0 1-1.8-.61c-.3-.22-.57-.49-.8-.8a3.6 3.6 0 0 1-.6-1.79C.5 11.11.5 10.35.5 9.43V6.58c0-.92 0-1.7.06-2.31a3.6 3.6 0 0 1 .62-1.8c.22-.3.48-.57.79-.79a3.6 3.6 0 0 1 1.8-.61C4.37 1 5.14 1 6.06 1ZM9.5 3a1 1 0 0 1 1.42 0l4.28 4.3a1 1 0 0 1 0 1.4L10.93 13a1 1 0 0 1-1.42-1.42L12.1 9H6.8a1 1 0 1 1 0-2h5.3L9.51 4.42a1 1 0 0 1 0-1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("jgrOc", function(module, exports) {

$parcel$export(module.exports, "discordSvg", function () { return $e0651529610f96c3$export$29470bd7472aef51; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $e0651529610f96c3$export$29470bd7472aef51 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5865F2" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M25.71 28.15C30.25 28 32 25.02 32 25.02c0-6.61-2.96-11.98-2.96-11.98-2.96-2.22-5.77-2.15-5.77-2.15l-.29.32c3.5 1.07 5.12 2.61 5.12 2.61a16.75 16.75 0 0 0-10.34-1.93l-.35.04a15.43 15.43 0 0 0-5.88 1.9s1.71-1.63 5.4-2.7l-.2-.24s-2.81-.07-5.77 2.15c0 0-2.96 5.37-2.96 11.98 0 0 1.73 2.98 6.27 3.13l1.37-1.7c-2.6-.79-3.6-2.43-3.6-2.43l.58.35.09.06.08.04.02.01.08.05a17.25 17.25 0 0 0 4.52 1.58 14.4 14.4 0 0 0 8.3-.86c.72-.27 1.52-.66 2.37-1.21 0 0-1.03 1.68-3.72 2.44.61.78 1.35 1.67 1.35 1.67Zm-9.55-9.6c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28.01-1.25-.93-2.28-2.1-2.28Zm7.5 0c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28 0-1.25-.93-2.28-2.1-2.28Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("eEYlf", function(module, exports) {

$parcel$export(module.exports, "etherscanSvg", function () { return $aac39bb71f221f4c$export$fad2d5a54496223b; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $aac39bb71f221f4c$export$fad2d5a54496223b = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="M4.25 7a.63.63 0 0 0-.63.63v3.97c0 .28-.2.51-.47.54l-.75.07a.93.93 0 0 1-.9-.47A7.51 7.51 0 0 1 5.54.92a7.5 7.5 0 0 1 9.54 4.62c.12.35.06.72-.16 1-.74.97-1.68 1.78-2.6 2.44V4.44a.64.64 0 0 0-.63-.64h-1.06c-.35 0-.63.3-.63.64v5.5c0 .23-.12.42-.32.5l-.52.23V6.05c0-.36-.3-.64-.64-.64H7.45c-.35 0-.64.3-.64.64v4.97c0 .25-.17.46-.4.52a5.8 5.8 0 0 0-.45.11v-4c0-.36-.3-.65-.64-.65H4.25ZM14.07 12.4A7.49 7.49 0 0 1 3.6 14.08c4.09-.58 9.14-2.5 11.87-6.6v.03a7.56 7.56 0 0 1-1.41 4.91Z"
  />
</svg>`;

});

parcelRegister("21Mdu", function(module, exports) {

$parcel$export(module.exports, "extensionSvg", function () { return $17a113952956753e$export$df81a22cbcc6237a; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $17a113952956753e$export$df81a22cbcc6237a = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.71 2.99a.57.57 0 0 0-.57.57 1 1 0 0 1-1 1c-.58 0-.96 0-1.24.03-.27.03-.37.07-.42.1a.97.97 0 0 0-.36.35c-.04.08-.09.21-.11.67a2.57 2.57 0 0 1 0 5.13c.02.45.07.6.11.66.09.15.21.28.36.36.07.04.21.1.67.12a2.57 2.57 0 0 1 5.12 0c.46-.03.6-.08.67-.12a.97.97 0 0 0 .36-.36c.03-.04.07-.14.1-.41.02-.29.03-.66.03-1.24a1 1 0 0 1 1-1 .57.57 0 0 0 0-1.15 1 1 0 0 1-1-1c0-.58 0-.95-.03-1.24a1.04 1.04 0 0 0-.1-.42.97.97 0 0 0-.36-.36 1.04 1.04 0 0 0-.42-.1c-.28-.02-.65-.02-1.24-.02a1 1 0 0 1-1-1 .57.57 0 0 0-.57-.57ZM5.15 13.98a1 1 0 0 0 .99-1v-.78a.57.57 0 0 1 1.14 0v.78a1 1 0 0 0 .99 1H8.36a66.26 66.26 0 0 0 .73 0 3.78 3.78 0 0 0 1.84-.38c.46-.26.85-.64 1.1-1.1.23-.4.32-.8.36-1.22.02-.2.03-.4.03-.63a2.57 2.57 0 0 0 0-4.75c0-.23-.01-.44-.03-.63a2.96 2.96 0 0 0-.35-1.22 2.97 2.97 0 0 0-1.1-1.1c-.4-.22-.8-.31-1.22-.35a8.7 8.7 0 0 0-.64-.04 2.57 2.57 0 0 0-4.74 0c-.23 0-.44.02-.63.04-.42.04-.83.13-1.22.35-.46.26-.84.64-1.1 1.1-.33.57-.37 1.2-.39 1.84a21.39 21.39 0 0 0 0 .72v.1a1 1 0 0 0 1 .99h.78a.57.57 0 0 1 0 1.15h-.77a1 1 0 0 0-1 .98v.1a63.87 63.87 0 0 0 0 .73c0 .64.05 1.27.38 1.83.26.47.64.85 1.1 1.11.56.32 1.2.37 1.84.38a20.93 20.93 0 0 0 .72 0h.1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("gkpAY", function(module, exports) {

$parcel$export(module.exports, "externalLinkSvg", function () { return $be325e50dc4c4d5b$export$34a422f948687038; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $be325e50dc4c4d5b$export$34a422f948687038 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.74 3.99a1 1 0 0 1 1-1H11a1 1 0 0 1 1 1v6.26a1 1 0 0 1-2 0V6.4l-6.3 6.3a1 1 0 0 1-1.4-1.42l6.29-6.3H4.74a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("9WYDr", function(module, exports) {

$parcel$export(module.exports, "facebookSvg", function () { return $73e890b03d703f96$export$1ff5018c782ba6f; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $73e890b03d703f96$export$1ff5018c782ba6f = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1877F2" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M26 12.38h-2.89c-.92 0-1.61.38-1.61 1.34v1.66H26l-.36 4.5H21.5v12H17v-12h-3v-4.5h3V12.5c0-3.03 1.6-4.62 5.2-4.62H26v4.5Z"
        />
      </g>
    </g>
    <path
      fill="#1877F2"
      d="M40 20a20 20 0 1 0-23.13 19.76V25.78H11.8V20h5.07v-4.4c0-5.02 3-7.79 7.56-7.79 2.19 0 4.48.4 4.48.4v4.91h-2.53c-2.48 0-3.25 1.55-3.25 3.13V20h5.54l-.88 5.78h-4.66v13.98A20 20 0 0 0 40 20Z"
    />
    <path
      fill="#fff"
      d="m27.79 25.78.88-5.78h-5.55v-3.75c0-1.58.78-3.13 3.26-3.13h2.53V8.2s-2.3-.39-4.48-.39c-4.57 0-7.55 2.77-7.55 7.78V20H11.8v5.78h5.07v13.98a20.15 20.15 0 0 0 6.25 0V25.78h4.67Z"
    />
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("4WwOq", function(module, exports) {

$parcel$export(module.exports, "filtersSvg", function () { return $39960807aa26fe9d$export$9261929cf6dcbff0; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $39960807aa26fe9d$export$9261929cf6dcbff0 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 3a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm2.63 5.25a1 1 0 0 1 1-1h8.75a1 1 0 1 1 0 2H3.63a1 1 0 0 1-1-1Zm2.62 5.25a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2h-3.5a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("eo6lu", function(module, exports) {

$parcel$export(module.exports, "githubSvg", function () { return $a7983aaf52a1ba50$export$f094865edb198013; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $a7983aaf52a1ba50$export$f094865edb198013 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1B1F23" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M8 19.89a12 12 0 1 1 15.8 11.38c-.6.12-.8-.26-.8-.57v-3.3c0-1.12-.4-1.85-.82-2.22 2.67-.3 5.48-1.31 5.48-5.92 0-1.31-.47-2.38-1.24-3.22.13-.3.54-1.52-.12-3.18 0 0-1-.32-3.3 1.23a11.54 11.54 0 0 0-6 0c-2.3-1.55-3.3-1.23-3.3-1.23a4.32 4.32 0 0 0-.12 3.18 4.64 4.64 0 0 0-1.24 3.22c0 4.6 2.8 5.63 5.47 5.93-.34.3-.65.83-.76 1.6-.69.31-2.42.84-3.5-1 0 0-.63-1.15-1.83-1.23 0 0-1.18-.02-.09.73 0 0 .8.37 1.34 1.76 0 0 .7 2.14 4.03 1.41v2.24c0 .31-.2.68-.8.57A12 12 0 0 1 8 19.9Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("gvAfw", function(module, exports) {

$parcel$export(module.exports, "googleSvg", function () { return $c04ba8f304b235cc$export$62a66155552ed9b0; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $c04ba8f304b235cc$export$62a66155552ed9b0 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#fff" fill-opacity=".05" />
      <g clip-path="url(#c)">
        <path
          fill="#4285F4"
          d="M20 17.7v4.65h6.46a5.53 5.53 0 0 1-2.41 3.61l3.9 3.02c2.26-2.09 3.57-5.17 3.57-8.82 0-.85-.08-1.67-.22-2.46H20Z"
        />
        <path
          fill="#34A853"
          d="m13.27 22.17-.87.67-3.11 2.42A12 12 0 0 0 20 31.9c3.24 0 5.96-1.07 7.94-2.9l-3.9-3.03A7.15 7.15 0 0 1 20 27.12a7.16 7.16 0 0 1-6.72-4.94v-.01Z"
        />
        <path
          fill="#FBBC05"
          d="M9.29 14.5a11.85 11.85 0 0 0 0 10.76l3.99-3.1a7.19 7.19 0 0 1 0-4.55l-4-3.1Z"
        />
        <path
          fill="#EA4335"
          d="M20 12.66c1.77 0 3.34.61 4.6 1.8l3.43-3.44A11.51 11.51 0 0 0 20 7.89c-4.7 0-8.74 2.69-10.71 6.62l3.99 3.1A7.16 7.16 0 0 1 20 12.66Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("b1LSP", function(module, exports) {

$parcel$export(module.exports, "helpCircleSvg", function () { return $8074ee5830b1536b$export$cbf7b9dd25929c90; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $8074ee5830b1536b$export$cbf7b9dd25929c90 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="M8.51 5.66a.83.83 0 0 0-.57-.2.83.83 0 0 0-.52.28.8.8 0 0 0-.25.52 1 1 0 0 1-2 0c0-.75.34-1.43.81-1.91a2.75 2.75 0 0 1 4.78 1.92c0 1.24-.8 1.86-1.25 2.2l-.04.03c-.47.36-.5.43-.5.65a1 1 0 1 1-2 0c0-1.25.8-1.86 1.24-2.2l.04-.04c.47-.36.5-.43.5-.65 0-.3-.1-.49-.24-.6ZM9.12 11.87a1.13 1.13 0 1 1-2.25 0 1.13 1.13 0 0 1 2.25 0Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("jBjKS", function(module, exports) {

$parcel$export(module.exports, "infoCircleSvg", function () { return $03aeb8f7aff928a0$export$313082e449e2d152; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $03aeb8f7aff928a0$export$313082e449e2d152 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    d="M6 10.49a1 1 0 1 0 2 0v-2a1 1 0 0 0-2 0v2ZM7 4.49a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 14.99a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5-7a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("4xAYU", function(module, exports) {

$parcel$export(module.exports, "mailSvg", function () { return $34e6ee3a468c5bda$export$a9b1939cca165cd6; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $34e6ee3a468c5bda$export$a9b1939cca165cd6 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.83 1.34h6.34c.68 0 1.26 0 1.73.04.5.05.97.15 1.42.4.52.3.95.72 1.24 1.24.26.45.35.92.4 1.42.04.47.04 1.05.04 1.73v3.71c0 .69 0 1.26-.04 1.74-.05.5-.14.97-.4 1.41-.3.52-.72.95-1.24 1.25-.45.25-.92.35-1.42.4-.47.03-1.05.03-1.73.03H4.83c-.68 0-1.26 0-1.73-.04-.5-.04-.97-.14-1.42-.4-.52-.29-.95-.72-1.24-1.24a3.39 3.39 0 0 1-.4-1.41A20.9 20.9 0 0 1 0 9.88v-3.7c0-.7 0-1.27.04-1.74.05-.5.14-.97.4-1.42.3-.52.72-.95 1.24-1.24.45-.25.92-.35 1.42-.4.47-.04 1.05-.04 1.73-.04ZM3.28 3.38c-.36.03-.51.08-.6.14-.21.11-.39.29-.5.5a.8.8 0 0 0-.08.19l5.16 3.44c.45.3 1.03.3 1.48 0L13.9 4.2a.79.79 0 0 0-.08-.2c-.11-.2-.29-.38-.5-.5-.09-.05-.24-.1-.6-.13-.37-.04-.86-.04-1.6-.04H4.88c-.73 0-1.22 0-1.6.04ZM14 6.54 9.85 9.31a3.33 3.33 0 0 1-3.7 0L2 6.54v3.3c0 .74 0 1.22.03 1.6.04.36.1.5.15.6.11.2.29.38.5.5.09.05.24.1.6.14.37.03.86.03 1.6.03h6.25c.73 0 1.22 0 1.6-.03.35-.03.5-.09.6-.14.2-.12.38-.3.5-.5.05-.1.1-.24.14-.6.03-.38.03-.86.03-1.6v-3.3Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("1lnAY", function(module, exports) {

$parcel$export(module.exports, "mobileSvg", function () { return $0faa0e2353a9e16d$export$b6a7821857ebc7d7; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $0faa0e2353a9e16d$export$b6a7821857ebc7d7 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path fill="currentColor" d="M10.81 5.81a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3 4.75A4.75 4.75 0 0 1 7.75 0h4.5A4.75 4.75 0 0 1 17 4.75v10.5A4.75 4.75 0 0 1 12.25 20h-4.5A4.75 4.75 0 0 1 3 15.25V4.75ZM7.75 2A2.75 2.75 0 0 0 5 4.75v10.5A2.75 2.75 0 0 0 7.75 18h4.5A2.75 2.75 0 0 0 15 15.25V4.75A2.75 2.75 0 0 0 12.25 2h-4.5Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("hpS9l", function(module, exports) {

$parcel$export(module.exports, "networkPlaceholderSvg", function () { return $cadec67945eedbc1$export$8eef6146d36b9527; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $cadec67945eedbc1$export$8eef6146d36b9527 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 22 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M16.32 13.62a3.14 3.14 0 1 1-.99 1.72l-1.6-.93a3.83 3.83 0 0 1-3.71 1 3.66 3.66 0 0 1-1.74-1l-1.6.94a3.14 3.14 0 1 1-1-1.73l1.6-.94a3.7 3.7 0 0 1 0-2 3.81 3.81 0 0 1 1.8-2.33c.29-.17.6-.3.92-.38V6.1a3.14 3.14 0 1 1 2 0l-.01.02v1.85H12a3.82 3.82 0 0 1 2.33 1.8 3.7 3.7 0 0 1 .39 2.91l1.6.93ZM2.6 16.54a1.14 1.14 0 0 0 1.98-1.14 1.14 1.14 0 0 0-1.98 1.14ZM11 2.01a1.14 1.14 0 1 0 0 2.28 1.14 1.14 0 0 0 0-2.28Zm1.68 10.45c.08-.19.14-.38.16-.58v-.05l.02-.13v-.13a1.92 1.92 0 0 0-.24-.8l-.11-.15a1.89 1.89 0 0 0-.74-.6 1.86 1.86 0 0 0-.77-.17h-.19a1.97 1.97 0 0 0-.89.34 1.98 1.98 0 0 0-.61.74 1.99 1.99 0 0 0-.16.9v.05a1.87 1.87 0 0 0 .24.74l.1.15c.12.16.26.3.42.42l.16.1.13.07.04.02a1.84 1.84 0 0 0 .76.17h.17a2 2 0 0 0 .91-.35 1.78 1.78 0 0 0 .52-.58l.03-.05a.84.84 0 0 0 .05-.11Zm5.15 4.5a1.14 1.14 0 0 0 1.14-1.97 1.13 1.13 0 0 0-1.55.41c-.32.55-.13 1.25.41 1.56Z"
    clip-rule="evenodd"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.63 9.43a1.5 1.5 0 1 0 1.5-2.6 1.5 1.5 0 0 0-1.5 2.6Zm.32-1.55a.5.5 0 0 1 .68-.19.5.5 0 0 1 .18.68.5.5 0 0 1-.68.19.5.5 0 0 1-.18-.68ZM17.94 8.88a1.5 1.5 0 1 1-2.6-1.5 1.5 1.5 0 1 1 2.6 1.5ZM16.9 7.69a.5.5 0 0 0-.68.19.5.5 0 0 0 .18.68.5.5 0 0 0 .68-.19.5.5 0 0 0-.18-.68ZM9.75 17.75a1.5 1.5 0 1 1 2.6 1.5 1.5 1.5 0 1 1-2.6-1.5Zm1.05 1.18a.5.5 0 0 0 .68-.18.5.5 0 0 0-.18-.68.5.5 0 0 0-.68.18.5.5 0 0 0 .18.68Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("hV2A2", function(module, exports) {

$parcel$export(module.exports, "nftPlaceholderSvg", function () { return $d0b9c2ed3a9f3c46$export$cacef02b4679549a; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $d0b9c2ed3a9f3c46$export$cacef02b4679549a = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.13 1h1.71c1.46 0 2.63 0 3.56.1.97.1 1.8.33 2.53.85a5 5 0 0 1 1.1 1.11c.53.73.75 1.56.86 2.53.1.93.1 2.1.1 3.55v1.72c0 1.45 0 2.62-.1 3.55-.1.97-.33 1.8-.86 2.53a5 5 0 0 1-1.1 1.1c-.73.53-1.56.75-2.53.86-.93.1-2.1.1-3.55.1H9.13c-1.45 0-2.62 0-3.56-.1-.96-.1-1.8-.33-2.52-.85a5 5 0 0 1-1.1-1.11 5.05 5.05 0 0 1-.86-2.53c-.1-.93-.1-2.1-.1-3.55V9.14c0-1.45 0-2.62.1-3.55.1-.97.33-1.8.85-2.53a5 5 0 0 1 1.1-1.1 5.05 5.05 0 0 1 2.53-.86C6.51 1 7.67 1 9.13 1ZM5.79 3.09a3.1 3.1 0 0 0-1.57.48 3 3 0 0 0-.66.67c-.24.32-.4.77-.48 1.56-.1.82-.1 1.88-.1 3.4v1.6c0 1.15 0 2.04.05 2.76l.41-.42c.5-.5.93-.92 1.32-1.24.41-.33.86-.6 1.43-.7a3 3 0 0 1 .94 0c.35.06.66.2.95.37a17.11 17.11 0 0 0 .8.45c.1-.08.2-.2.41-.4l.04-.03a27 27 0 0 1 1.95-1.84 4.03 4.03 0 0 1 1.91-.94 4 4 0 0 1 1.25 0c.73.11 1.33.46 1.91.94l.64.55V9.2c0-1.52 0-2.58-.1-3.4a3.1 3.1 0 0 0-.48-1.56 3 3 0 0 0-.66-.67 3.1 3.1 0 0 0-1.56-.48C13.37 3 12.3 3 10.79 3h-1.6c-1.52 0-2.59 0-3.4.09Zm11.18 10-.04-.05a26.24 26.24 0 0 0-1.83-1.74c-.45-.36-.73-.48-.97-.52a2 2 0 0 0-.63 0c-.24.04-.51.16-.97.52-.46.38-1.01.93-1.83 1.74l-.02.02c-.17.18-.34.34-.49.47a2.04 2.04 0 0 1-1.08.5 1.97 1.97 0 0 1-1.25-.27l-.79-.46-.02-.02a.65.65 0 0 0-.24-.1 1 1 0 0 0-.31 0c-.08.02-.21.06-.49.28-.3.24-.65.59-1.2 1.14l-.56.56-.65.66a3 3 0 0 0 .62.6c.33.24.77.4 1.57.49.81.09 1.88.09 3.4.09h1.6c1.52 0 2.58 0 3.4-.09a3.1 3.1 0 0 0 1.56-.48 3 3 0 0 0 .66-.67c.24-.32.4-.77.49-1.56l.07-1.12Zm-8.02-1.03ZM4.99 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("kg5pG", function(module, exports) {

$parcel$export(module.exports, "offSvg", function () { return $ebf980404f4a7d6b$export$7ec09ee48c3bf315; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $ebf980404f4a7d6b$export$7ec09ee48c3bf315 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8 0a1 1 0 0 1 1 1v5.38a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1ZM5.26 2.6a1 1 0 0 1-.28 1.39 5.46 5.46 0 1 0 6.04 0 1 1 0 1 1 1.1-1.67 7.46 7.46 0 1 1-8.25 0 1 1 0 0 1 1.4.28Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("f9X7j", function(module, exports) {

$parcel$export(module.exports, "playStoreSvg", function () { return $b0958db288a21d96$export$65007b9f28ed0950; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $b0958db288a21d96$export$65007b9f28ed0950 = (0, $B77rE.svg)` <svg
  width="36"
  height="36"
  fill="none"
>
  <path
    d="M0 8a8 8 0 0 1 8-8h20a8 8 0 0 1 8 8v20a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"
    fill="#fff"
    fill-opacity=".05"
  />
  <path
    d="m18.262 17.513-8.944 9.49v.01a2.417 2.417 0 0 0 3.56 1.452l.026-.017 10.061-5.803-4.703-5.132Z"
    fill="#EA4335"
  />
  <path
    d="m27.307 15.9-.008-.008-4.342-2.52-4.896 4.36 4.913 4.912 4.325-2.494a2.42 2.42 0 0 0 .008-4.25Z"
    fill="#FBBC04"
  />
  <path
    d="M9.318 8.997c-.05.202-.084.403-.084.622V26.39c0 .218.025.42.084.621l9.246-9.247-9.246-8.768Z"
    fill="#4285F4"
  />
  <path
    d="m18.33 18 4.627-4.628-10.053-5.828a2.427 2.427 0 0 0-3.586 1.444L18.329 18Z"
    fill="#34A853"
  />
  <path
    d="M8 .5h20A7.5 7.5 0 0 1 35.5 8v20a7.5 7.5 0 0 1-7.5 7.5H8A7.5 7.5 0 0 1 .5 28V8A7.5 7.5 0 0 1 8 .5Z"
    stroke="#fff"
    stroke-opacity=".05"
  />
</svg>`;

});

parcelRegister("2A3VN", function(module, exports) {

$parcel$export(module.exports, "qrCodeIcon", function () { return $1e11fe3a3cf389c7$export$b033e2eb4807deba; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $1e11fe3a3cf389c7$export$b033e2eb4807deba = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M3 6a3 3 0 0 1 3-3h1a1 1 0 1 0 0-2H6a5 5 0 0 0-5 5v1a1 1 0 0 0 2 0V6ZM13 1a1 1 0 1 0 0 2h1a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0V6a5 5 0 0 0-5-5h-1ZM3 13a1 1 0 1 0-2 0v1a5 5 0 0 0 5 5h1a1 1 0 1 0 0-2H6a3 3 0 0 1-3-3v-1ZM19 13a1 1 0 1 0-2 0v1a3 3 0 0 1-3 3h-1a1 1 0 1 0 0 2h1.01a5 5 0 0 0 5-5v-1ZM5.3 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05A1.5 1.5 0 0 0 9.2 8.14c.06-.2.06-.43.06-.89s0-.7-.06-.89A1.5 1.5 0 0 0 8.14 5.3c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM10.8 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM5.26 12.75c0-.46 0-.7.05-.89a1.5 1.5 0 0 1 1.06-1.06c.19-.05.42-.05.89-.05.46 0 .7 0 .88.05.52.14.93.54 1.06 1.06.06.2.06.43.06.89s0 .7-.06.89a1.5 1.5 0 0 1-1.06 1.06c-.19.05-.42.05-.88.05-.47 0-.7 0-.9-.05a1.5 1.5 0 0 1-1.05-1.06c-.05-.2-.05-.43-.05-.89ZM10.8 11.86c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06Z"
  />
</svg>`;

});

parcelRegister("kou21", function(module, exports) {

$parcel$export(module.exports, "refreshSvg", function () { return $ed8d58330c7cbc83$export$bbe3b42eaaf82fae; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $ed8d58330c7cbc83$export$bbe3b42eaaf82fae = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 14 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.94 1.04a1 1 0 0 1 .7 1.23l-.48 1.68a5.85 5.85 0 0 1 8.53 4.32 5.86 5.86 0 0 1-11.4 2.56 1 1 0 0 1 1.9-.57 3.86 3.86 0 1 0 1.83-4.5l1.87.53a1 1 0 0 1-.55 1.92l-4.1-1.15a1 1 0 0 1-.69-1.23l1.16-4.1a1 1 0 0 1 1.23-.7Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("66bJO", function(module, exports) {

$parcel$export(module.exports, "searchSvg", function () { return $470c68848891834d$export$28881e95f40c5f68; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $470c68848891834d$export$28881e95f40c5f68 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.36 4.21a5.14 5.14 0 1 0 0 10.29 5.14 5.14 0 0 0 0-10.29ZM1.64 9.36a7.71 7.71 0 1 1 14 4.47l2.52 2.5a1.29 1.29 0 1 1-1.82 1.83l-2.51-2.51A7.71 7.71 0 0 1 1.65 9.36Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("hlRHp", function(module, exports) {

$parcel$export(module.exports, "sendSvg", function () { return $ca1e0d571135aca5$export$cc4f2fc255fe3f38; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $ca1e0d571135aca5$export$cc4f2fc255fe3f38 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 21 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M14.3808 4.34812C13.72 4.47798 12.8501 4.7587 11.5748 5.17296L9.00869 6.00646C6.90631 6.68935 5.40679 7.17779 4.38121 7.63178C3.87166 7.85734 3.5351 8.05091 3.32022 8.22035C3.11183 8.38466 3.07011 8.48486 3.05969 8.51817C2.98058 8.77103 2.98009 9.04195 3.05831 9.29509C3.06861 9.32844 3.10998 9.42878 3.31777 9.59384C3.53205 9.76404 3.86792 9.95881 4.37667 10.1862C5.29287 10.5957 6.58844 11.0341 8.35529 11.6164L10.8876 8.59854C11.2426 8.17547 11.8733 8.12028 12.2964 8.47528C12.7195 8.83029 12.7746 9.46104 12.4196 9.88412L9.88738 12.9019C10.7676 14.5408 11.4244 15.7406 11.9867 16.5718C12.299 17.0333 12.5491 17.3303 12.7539 17.5117C12.9526 17.6877 13.0586 17.711 13.0932 17.7154C13.3561 17.7484 13.6228 17.7009 13.8581 17.5791C13.8891 17.563 13.9805 17.5046 14.1061 17.2708C14.2357 17.0298 14.3679 16.6647 14.5015 16.1237C14.7705 15.0349 14.9912 13.4733 15.2986 11.2843L15.6738 8.61249C15.8603 7.28456 15.9857 6.37917 15.9989 5.7059C16.012 5.03702 15.9047 4.8056 15.8145 4.69183C15.7044 4.55297 15.5673 4.43792 15.4114 4.35365C15.2837 4.28459 15.0372 4.2191 14.3808 4.34812ZM7.99373 13.603C6.11919 12.9864 4.6304 12.4902 3.5606 12.0121C2.98683 11.7557 2.4778 11.4808 2.07383 11.1599C1.66337 10.8339 1.31312 10.4217 1.14744 9.88551C0.949667 9.24541 0.950886 8.56035 1.15094 7.92096C1.31852 7.38534 1.67024 6.97442 2.08185 6.64985C2.48697 6.33041 2.99697 6.05734 3.57166 5.80295C4.70309 5.3021 6.30179 4.78283 8.32903 4.12437L11.0196 3.25042C12.2166 2.86159 13.2017 2.54158 13.9951 2.38566C14.8065 2.22618 15.6202 2.19289 16.3627 2.59437C16.7568 2.80747 17.1035 3.09839 17.3818 3.4495C17.9062 4.111 18.0147 4.91815 17.9985 5.74496C17.9827 6.55332 17.8386 7.57903 17.6636 8.82534L17.2701 11.6268C16.9737 13.7376 16.7399 15.4022 16.4432 16.6034C16.2924 17.2135 16.1121 17.7632 15.8678 18.2176C15.6197 18.6794 15.2761 19.0971 14.7777 19.3551C14.1827 19.6632 13.5083 19.7833 12.8436 19.6997C12.2867 19.6297 11.82 19.3563 11.4277 19.0087C11.0415 18.6666 10.6824 18.213 10.3302 17.6925C9.67361 16.722 8.92648 15.342 7.99373 13.603Z"
    clip-rule="evenodd"
  />
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  ></svg></svg
>`;

});

parcelRegister("5wAYM", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalSvg", function () { return $405ca03e53f010e7$export$43cc65051e9f7716; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $405ca03e53f010e7$export$43cc65051e9f7716 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.76.3a1 1 0 0 1 0 1.4L4.07 4.4h9a1 1 0 1 1 0 2h-9l2.69 2.68a1 1 0 1 1-1.42 1.42L.95 6.09a1 1 0 0 1 0-1.4l4.4-4.4a1 1 0 0 1 1.4 0Zm6.49 9.21a1 1 0 0 1 1.41 0l4.39 4.4a1 1 0 0 1 0 1.4l-4.39 4.4a1 1 0 0 1-1.41-1.42l2.68-2.68h-9a1 1 0 0 1 0-2h9l-2.68-2.68a1 1 0 0 1 0-1.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("3htPj", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalBoldSvg", function () { return $263a18949849e9af$export$6929881544dda4e0; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $263a18949849e9af$export$6929881544dda4e0 = (0, $B77rE.svg)`<svg width="10" height="10" viewBox="0 0 10 10">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.77986 0.566631C4.0589 0.845577 4.0589 1.29784 3.77986 1.57678L3.08261 2.2738H6.34184C6.73647 2.2738 7.05637 2.5936 7.05637 2.98808C7.05637 3.38257 6.73647 3.70237 6.34184 3.70237H3.08261L3.77986 4.39938C4.0589 4.67833 4.0589 5.13059 3.77986 5.40954C3.50082 5.68848 3.04841 5.68848 2.76937 5.40954L0.852346 3.49316C0.573306 3.21421 0.573306 2.76195 0.852346 2.48301L2.76937 0.566631C3.04841 0.287685 3.50082 0.287685 3.77986 0.566631ZM6.22 4.59102C6.49904 4.31208 6.95145 4.31208 7.23049 4.59102L9.14751 6.5074C9.42655 6.78634 9.42655 7.23861 9.14751 7.51755L7.23049 9.43393C6.95145 9.71287 6.49904 9.71287 6.22 9.43393C5.94096 9.15498 5.94096 8.70272 6.22 8.42377L6.91725 7.72676L3.65802 7.72676C3.26339 7.72676 2.94349 7.40696 2.94349 7.01247C2.94349 6.61798 3.26339 6.29819 3.65802 6.29819L6.91725 6.29819L6.22 5.60117C5.94096 5.32223 5.94096 4.86997 6.22 4.59102Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("4YR4s", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalMediumSvg", function () { return $3a05eec80e380a2e$export$f0d7b23b1c8e0312; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $3a05eec80e380a2e$export$f0d7b23b1c8e0312 = (0, $B77rE.svg)`<svg
  width="14"
  height="14"
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.7306 3.24213C14.0725 3.58384 14.0725 4.13786 13.7306 4.47957L10.7418 7.46737C10.4 7.80908 9.84581 7.80908 9.50399 7.46737C9.16216 7.12567 9.16216 6.57165 9.50399 6.22994L10.9986 4.73585H5.34082C4.85741 4.73585 4.46553 4.3441 4.46553 3.86085C4.46553 3.3776 4.85741 2.98585 5.34082 2.98585L10.9986 2.98585L9.50399 1.49177C9.16216 1.15006 9.16216 0.596037 9.50399 0.254328C9.84581 -0.0873803 10.4 -0.0873803 10.7418 0.254328L13.7306 3.24213ZM9.52515 10.1352C9.52515 10.6185 9.13327 11.0102 8.64986 11.0102L2.9921 11.0102L4.48669 12.5043C4.82852 12.846 4.82852 13.4001 4.48669 13.7418C4.14487 14.0835 3.59066 14.0835 3.24884 13.7418L0.26003 10.754C0.0958806 10.5899 0.0036621 10.3673 0.00366211 10.1352C0.00366212 9.90318 0.0958806 9.68062 0.26003 9.51652L3.24884 6.52872C3.59066 6.18701 4.14487 6.18701 4.48669 6.52872C4.82851 6.87043 4.82851 7.42445 4.48669 7.76616L2.9921 9.26024L8.64986 9.26024C9.13327 9.26024 9.52515 9.65199 9.52515 10.1352Z"
    fill="currentColor"
  />
</svg>

`;

});

parcelRegister("fFqfy", function(module, exports) {

$parcel$export(module.exports, "swapVerticalSvg", function () { return $b67f0c0cd6f3f646$export$8fbc1b2c09145763; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $b67f0c0cd6f3f646$export$8fbc1b2c09145763 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 14 14">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.48 2.18a1 1 0 0 1 1.41 0l2.68 2.68a1 1 0 1 1-1.41 1.42l-.98-.98v4.56a1 1 0 0 1-2 0V5.3l-.97.98A1 1 0 0 1 .79 4.86l2.69-2.68Zm6.34 2.93a1 1 0 0 1 1 1v4.56l.97-.98a1 1 0 1 1 1.42 1.42l-2.69 2.68a1 1 0 0 1-1.41 0l-2.68-2.68a1 1 0 0 1 1.41-1.42l.98.98V6.1a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("aT95G", function(module, exports) {

$parcel$export(module.exports, "telegramSvg", function () { return $7ed617a61551a6e9$export$367999698d7de87a; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $7ed617a61551a6e9$export$367999698d7de87a = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5865F2" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M25.71 28.15C30.25 28 32 25.02 32 25.02c0-6.61-2.96-11.98-2.96-11.98-2.96-2.22-5.77-2.15-5.77-2.15l-.29.32c3.5 1.07 5.12 2.61 5.12 2.61a16.75 16.75 0 0 0-10.34-1.93l-.35.04a15.43 15.43 0 0 0-5.88 1.9s1.71-1.63 5.4-2.7l-.2-.24s-2.81-.07-5.77 2.15c0 0-2.96 5.37-2.96 11.98 0 0 1.73 2.98 6.27 3.13l1.37-1.7c-2.6-.79-3.6-2.43-3.6-2.43l.58.35.09.06.08.04.02.01.08.05a17.25 17.25 0 0 0 4.52 1.58 14.4 14.4 0 0 0 8.3-.86c.72-.27 1.52-.66 2.37-1.21 0 0-1.03 1.68-3.72 2.44.61.78 1.35 1.67 1.35 1.67Zm-9.55-9.6c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28.01-1.25-.93-2.28-2.1-2.28Zm7.5 0c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28 0-1.25-.93-2.28-2.1-2.28Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("iZ2y1", function(module, exports) {

$parcel$export(module.exports, "twitchSvg", function () { return $dd1fe66be97ab0e1$export$759b73a5195b6264; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $dd1fe66be97ab0e1$export$759b73a5195b6264 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5A3E85" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M18.22 25.7 20 23.91h3.34l2.1-2.1v-6.68H15.4v8.78h2.82v1.77Zm3.87-8.16h1.25v3.66H22.1v-3.66Zm-3.34 0H20v3.66h-1.25v-3.66ZM20 7.9a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm6.69 14.56-3.66 3.66h-2.72l-1.77 1.78h-1.88V26.1H13.3v-9.82l.94-2.4H26.7v8.56Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("e5T3Z", function(module, exports) {

$parcel$export(module.exports, "twitterSvg", function () { return $a42c3ebbe737fb72$export$dd8df3e26aa6585; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $a42c3ebbe737fb72$export$dd8df3e26aa6585 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1D9BF0" />
      <path
        fill="#fff"
        d="M30 13.81c-.74.33-1.53.55-2.36.65.85-.51 1.5-1.32 1.8-2.27-.79.47-1.66.8-2.6 1a4.1 4.1 0 0 0-7 3.73c-3.4-.17-6.42-1.8-8.45-4.28a4.1 4.1 0 0 0 1.27 5.47c-.67-.02-1.3-.2-1.86-.5a4.1 4.1 0 0 0 3.3 4.07c-.58.15-1.21.19-1.86.07a4.1 4.1 0 0 0 3.83 2.85A8.25 8.25 0 0 1 10 26.3a11.62 11.62 0 0 0 6.29 1.84c7.62 0 11.92-6.44 11.66-12.2.8-.59 1.5-1.3 2.05-2.13Z"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("BM3cM", function(module, exports) {

$parcel$export(module.exports, "twitterIconSvg", function () { return $0718baaef5c695d1$export$d6bfd63304732c58; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $0718baaef5c695d1$export$d6bfd63304732c58 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="m14.36 4.74.01.42c0 4.34-3.3 9.34-9.34 9.34A9.3 9.3 0 0 1 0 13.03a6.6 6.6 0 0 0 4.86-1.36 3.29 3.29 0 0 1-3.07-2.28c.5.1 1 .07 1.48-.06A3.28 3.28 0 0 1 .64 6.11v-.04c.46.26.97.4 1.49.41A3.29 3.29 0 0 1 1.11 2.1a9.32 9.32 0 0 0 6.77 3.43 3.28 3.28 0 0 1 5.6-3 6.59 6.59 0 0 0 2.08-.8 3.3 3.3 0 0 1-1.45 1.82A6.53 6.53 0 0 0 16 3.04c-.44.66-1 1.23-1.64 1.7Z"
  />
</svg>`;

});

parcelRegister("4tPqI", function(module, exports) {

$parcel$export(module.exports, "verifySvg", function () { return $3431c3c4f0fd8928$export$dddaa7bddf7e22f; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $3431c3c4f0fd8928$export$dddaa7bddf7e22f = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 28 28">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M18.1 4.76c-.42-.73-1.33-1.01-2.09-.66l-1.42.66c-.37.18-.8.18-1.18 0l-1.4-.65a1.63 1.63 0 0 0-2.1.66l-.84 1.45c-.2.34-.53.59-.92.67l-1.7.35c-.83.17-1.39.94-1.3 1.78l.19 1.56c.04.39-.08.78-.33 1.07l-1.12 1.3c-.52.6-.52 1.5 0 2.11L5 16.38c.25.3.37.68.33 1.06l-.18 1.57c-.1.83.46 1.6 1.28 1.78l1.7.35c.4.08.73.32.93.66l.84 1.43a1.63 1.63 0 0 0 2.09.66l1.41-.66c.37-.17.8-.17 1.18 0l1.43.67c.76.35 1.66.07 2.08-.65l.86-1.45c.2-.34.54-.58.92-.66l1.68-.35A1.63 1.63 0 0 0 22.84 19l-.18-1.57a1.4 1.4 0 0 1 .33-1.06l1.12-1.32c.52-.6.52-1.5 0-2.11l-1.12-1.3a1.4 1.4 0 0 1-.33-1.07l.18-1.57c.1-.83-.46-1.6-1.28-1.77l-1.68-.35a1.4 1.4 0 0 1-.92-.66l-.86-1.47Zm-3.27-3.2a4.43 4.43 0 0 1 5.69 1.78l.54.93 1.07.22a4.43 4.43 0 0 1 3.5 4.84l-.11.96.7.83a4.43 4.43 0 0 1 .02 5.76l-.72.85.1.96a4.43 4.43 0 0 1-3.5 4.84l-1.06.22-.54.92a4.43 4.43 0 0 1-5.68 1.77l-.84-.4-.82.39a4.43 4.43 0 0 1-5.7-1.79l-.51-.89-1.09-.22a4.43 4.43 0 0 1-3.5-4.84l.1-.96-.72-.85a4.43 4.43 0 0 1 .01-5.76l.71-.83-.1-.95a4.43 4.43 0 0 1 3.5-4.84l1.08-.23.53-.9a4.43 4.43 0 0 1 5.7-1.8l.81.38.83-.39ZM18.2 9.4c.65.42.84 1.28.42 1.93l-4.4 6.87a1.4 1.4 0 0 1-2.26.14L9.5 15.39a1.4 1.4 0 0 1 2.15-1.8l1.23 1.48 3.38-5.26a1.4 1.4 0 0 1 1.93-.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("6nxvY", function(module, exports) {

$parcel$export(module.exports, "verifyFilledSvg", function () { return $4a4ee35e91cf22fc$export$1f9737848f580d88; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $4a4ee35e91cf22fc$export$1f9737848f580d88 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 14 14">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="m4.1 12.43-.45-.78-.93-.2a1.65 1.65 0 0 1-1.31-1.8l.1-.86-.61-.71a1.65 1.65 0 0 1 0-2.16l.6-.7-.09-.85c-.1-.86.47-1.64 1.3-1.81l.94-.2.45-.78A1.65 1.65 0 0 1 6.23.9l.77.36.78-.36c.77-.36 1.69-.07 2.12.66l.47.8.91.2c.84.17 1.4.95 1.31 1.8l-.1.86.6.7c.54.62.54 1.54.01 2.16l-.6.71.09.86c.1.85-.47 1.63-1.3 1.8l-.92.2-.47.79a1.65 1.65 0 0 1-2.12.66L7 12.74l-.77.36c-.78.35-1.7.07-2.13-.67Zm5.74-6.9a1 1 0 1 0-1.68-1.07L6.32 7.3l-.55-.66a1 1 0 0 0-1.54 1.28l1.43 1.71a1 1 0 0 0 1.61-.1l2.57-4Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("28rn4", function(module, exports) {

$parcel$export(module.exports, "walletPlaceholderSvg", function () { return $18e18f72a8c6f354$export$e1456ec7b14fe70e; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $18e18f72a8c6f354$export$e1456ec7b14fe70e = (0, $B77rE.svg)`
  <svg fill="none" viewBox="0 0 48 44">
    <path
      style="fill: var(--wui-color-bg-300);"
      d="M4.56 8.64c-1.23 1.68-1.23 4.08-1.23 8.88v8.96c0 4.8 0 7.2 1.23 8.88.39.55.87 1.02 1.41 1.42C7.65 38 10.05 38 14.85 38h14.3c4.8 0 7.2 0 8.88-1.22a6.4 6.4 0 0 0 1.41-1.42c.83-1.14 1.1-2.6 1.19-4.92a6.4 6.4 0 0 0 5.16-4.65c.21-.81.21-1.8.21-3.79 0-1.98 0-2.98-.22-3.79a6.4 6.4 0 0 0-5.15-4.65c-.1-2.32-.36-3.78-1.19-4.92a6.4 6.4 0 0 0-1.41-1.42C36.35 6 33.95 6 29.15 6h-14.3c-4.8 0-7.2 0-8.88 1.22a6.4 6.4 0 0 0-1.41 1.42Z"
    />
    <path
      style="fill: var(--wui-color-fg-200);"
      fill-rule="evenodd"
      d="M2.27 11.33a6.4 6.4 0 0 1 6.4-6.4h26.66a6.4 6.4 0 0 1 6.4 6.4v1.7a6.4 6.4 0 0 1 5.34 6.3v5.34a6.4 6.4 0 0 1-5.34 6.3v1.7a6.4 6.4 0 0 1-6.4 6.4H8.67a6.4 6.4 0 0 1-6.4-6.4V11.33ZM39.6 31.07h-6.93a9.07 9.07 0 1 1 0-18.14h6.93v-1.6a4.27 4.27 0 0 0-4.27-4.26H8.67a4.27 4.27 0 0 0-4.27 4.26v21.34a4.27 4.27 0 0 0 4.27 4.26h26.66a4.27 4.27 0 0 0 4.27-4.26v-1.6Zm-6.93-16a6.93 6.93 0 0 0 0 13.86h8a4.27 4.27 0 0 0 4.26-4.26v-5.34a4.27 4.27 0 0 0-4.26-4.26h-8Z"
      clip-rule="evenodd"
    />
  </svg>
`;

});

parcelRegister("flH6b", function(module, exports) {

$parcel$export(module.exports, "walletSvg", function () { return $b2ca3fae93cf41b0$export$9025df5921500944; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $b2ca3fae93cf41b0$export$9025df5921500944 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 5.5c0-1.8 1.46-3.25 3.25-3.25H14.5c1.8 0 3.25 1.46 3.25 3.25v.28A3.25 3.25 0 0 1 20 8.88v2.24c0 1.45-.94 2.68-2.25 3.1v.28c0 1.8-1.46 3.25-3.25 3.25H3.25A3.25 3.25 0 0 1 0 14.5v-9Zm15.75 8.88h-2.38a4.38 4.38 0 0 1 0-8.76h2.38V5.5c0-.69-.56-1.25-1.25-1.25H3.25C2.56 4.25 2 4.81 2 5.5v9c0 .69.56 1.25 1.25 1.25H14.5c.69 0 1.25-.56 1.25-1.25v-.13Zm-2.38-6.76a2.37 2.37 0 1 0 0 4.75h3.38c.69 0 1.25-.55 1.25-1.24V8.87c0-.69-.56-1.24-1.25-1.24h-3.38Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("1GBK0", function(module, exports) {

$parcel$export(module.exports, "walletConnectSvg", function () { return $13a6fd4543d5d172$export$84e288e571149f90; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $13a6fd4543d5d172$export$84e288e571149f90 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 96 67">
  <path
    fill="currentColor"
    d="M25.32 18.8a32.56 32.56 0 0 1 45.36 0l1.5 1.47c.63.62.63 1.61 0 2.22l-5.15 5.05c-.31.3-.82.3-1.14 0l-2.07-2.03a22.71 22.71 0 0 0-31.64 0l-2.22 2.18c-.31.3-.82.3-1.14 0l-5.15-5.05a1.55 1.55 0 0 1 0-2.22l1.65-1.62Zm56.02 10.44 4.59 4.5c.63.6.63 1.6 0 2.21l-20.7 20.26c-.62.61-1.63.61-2.26 0L48.28 41.83a.4.4 0 0 0-.56 0L33.03 56.21c-.63.61-1.64.61-2.27 0L10.07 35.95a1.55 1.55 0 0 1 0-2.22l4.59-4.5a1.63 1.63 0 0 1 2.27 0L31.6 43.63a.4.4 0 0 0 .57 0l14.69-14.38a1.63 1.63 0 0 1 2.26 0l14.69 14.38a.4.4 0 0 0 .57 0l14.68-14.38a1.63 1.63 0 0 1 2.27 0Z"
  />
  <path
    stroke="#000"
    stroke-opacity=".1"
    d="M25.67 19.15a32.06 32.06 0 0 1 44.66 0l1.5 1.48c.43.42.43 1.09 0 1.5l-5.15 5.05a.31.31 0 0 1-.44 0l-2.07-2.03a23.21 23.21 0 0 0-32.34 0l-2.22 2.18a.31.31 0 0 1-.44 0l-5.15-5.05a1.05 1.05 0 0 1 0-1.5l1.65-1.63ZM81 29.6l4.6 4.5c.42.41.42 1.09 0 1.5l-20.7 20.26c-.43.43-1.14.43-1.57 0L48.63 41.47a.9.9 0 0 0-1.26 0L32.68 55.85c-.43.43-1.14.43-1.57 0L10.42 35.6a1.05 1.05 0 0 1 0-1.5l4.59-4.5a1.13 1.13 0 0 1 1.57 0l14.68 14.38a.9.9 0 0 0 1.27 0l-.35-.35.35.35L47.22 29.6a1.13 1.13 0 0 1 1.56 0l14.7 14.38a.9.9 0 0 0 1.26 0L79.42 29.6a1.13 1.13 0 0 1 1.57 0Z"
  />
</svg>`;

});

parcelRegister("9taPd", function(module, exports) {

$parcel$export(module.exports, "warningCircleSvg", function () { return $6e4f381b5e8f7079$export$6e55d6021a3f4197; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $6e4f381b5e8f7079$export$6e55d6021a3f4197 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M11 6.67a1 1 0 1 0-2 0v2.66a1 1 0 0 0 2 0V6.67ZM10 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("8Cwu8", function(module, exports) {

$parcel$export(module.exports, "recycleHorizontalSvg", function () { return $646b122e90a95a7f$export$abad67e618866d01; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $646b122e90a95a7f$export$abad67e618866d01 = (0, $B77rE.svg)`<svg
  fill="none"
  viewBox="0 0 21 20"
>
  <path
    fill="currentColor"
    d="M8.8071 0.292893C9.19763 0.683417 9.19763 1.31658 8.8071 1.70711L6.91421 3.6H11.8404C14.3368 3.6 16.5533 5.1975 17.3427 7.56588L17.4487 7.88377C17.6233 8.40772 17.3402 8.97404 16.8162 9.14868C16.2923 9.32333 15.726 9.04017 15.5513 8.51623L15.4453 8.19834C14.9281 6.64664 13.476 5.6 11.8404 5.6H6.91421L8.8071 7.49289C9.19763 7.88342 9.19763 8.51658 8.8071 8.90711C8.41658 9.29763 7.78341 9.29763 7.39289 8.90711L3.79289 5.30711C3.40236 4.91658 3.40236 4.28342 3.79289 3.89289L7.39289 0.292893C7.78341 -0.0976311 8.41658 -0.0976311 8.8071 0.292893ZM4.18377 10.8513C4.70771 10.6767 5.27403 10.9598 5.44868 11.4838L5.55464 11.8017C6.07188 13.3534 7.52401 14.4 9.15964 14.4L14.0858 14.4L12.1929 12.5071C11.8024 12.1166 11.8024 11.4834 12.1929 11.0929C12.5834 10.7024 13.2166 10.7024 13.6071 11.0929L17.2071 14.6929C17.5976 15.0834 17.5976 15.7166 17.2071 16.1071L13.6071 19.7071C13.2166 20.0976 12.5834 20.0976 12.1929 19.7071C11.8024 19.3166 11.8024 18.6834 12.1929 18.2929L14.0858 16.4L9.15964 16.4C6.66314 16.4 4.44674 14.8025 3.65728 12.4341L3.55131 12.1162C3.37667 11.5923 3.65983 11.026 4.18377 10.8513Z"
  /></svg
>`;

});

parcelRegister("ktmt2", function(module, exports) {

$parcel$export(module.exports, "bankSvg", function () { return $ee77f19c46e1b68e$export$b7cc4752b6244394; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $ee77f19c46e1b68e$export$b7cc4752b6244394 = (0, $B77rE.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="13"
  viewBox="0 0 12 13"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.61391 1.57124C5.85142 1.42873 6.14813 1.42873 6.38564 1.57124L11.0793 4.38749C11.9179 4.89067 11.5612 6.17864 10.5832 6.17864H9.96398V10.0358H10.2854C10.6996 10.0358 11.0354 10.3716 11.0354 10.7858C11.0354 11.2 10.6996 11.5358 10.2854 11.5358H1.71416C1.29995 11.5358 0.964172 11.2 0.964172 10.7858C0.964172 10.3716 1.29995 10.0358 1.71416 10.0358H2.03558L2.03558 6.17864H1.41637C0.438389 6.17864 0.0816547 4.89066 0.920263 4.38749L5.61391 1.57124ZM3.53554 6.17864V10.0358H5.24979V6.17864H3.53554ZM6.74976 6.17864V10.0358H8.46401V6.17864H6.74976ZM8.64913 4.67864H3.35043L5.99978 3.089L8.64913 4.67864Z"
    fill="currentColor"
  /></svg
>`;

});

parcelRegister("dPv6D", function(module, exports) {

$parcel$export(module.exports, "cardSvg", function () { return $a1182aca4d14c439$export$996b002521801861; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $a1182aca4d14c439$export$996b002521801861 = (0, $B77rE.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="13"
  viewBox="0 0 12 13"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.16072 2C4.17367 2 4.18665 2 4.19968 2L7.83857 2C8.36772 1.99998 8.82398 1.99996 9.19518 2.04018C9.5895 2.0829 9.97577 2.17811 10.3221 2.42971C10.5131 2.56849 10.6811 2.73647 10.8198 2.92749C11.0714 3.27379 11.1666 3.66007 11.2094 4.0544C11.2496 4.42561 11.2496 4.88188 11.2495 5.41105V7.58896C11.2496 8.11812 11.2496 8.57439 11.2094 8.94561C11.1666 9.33994 11.0714 9.72621 10.8198 10.0725C10.6811 10.2635 10.5131 10.4315 10.3221 10.5703C9.97577 10.8219 9.5895 10.9171 9.19518 10.9598C8.82398 11 8.36772 11 7.83856 11H4.16073C3.63157 11 3.17531 11 2.80411 10.9598C2.40979 10.9171 2.02352 10.8219 1.67722 10.5703C1.48621 10.4315 1.31824 10.2635 1.17946 10.0725C0.927858 9.72621 0.832652 9.33994 0.78993 8.94561C0.749713 8.5744 0.749733 8.11813 0.749757 7.58896L0.749758 5.45C0.749758 5.43697 0.749758 5.42399 0.749757 5.41104C0.749733 4.88188 0.749713 4.42561 0.78993 4.0544C0.832652 3.66007 0.927858 3.27379 1.17946 2.92749C1.31824 2.73647 1.48621 2.56849 1.67722 2.42971C2.02352 2.17811 2.40979 2.0829 2.80411 2.04018C3.17531 1.99996 3.63157 1.99998 4.16072 2ZM2.96567 3.53145C2.69897 3.56034 2.60687 3.60837 2.55888 3.64324C2.49521 3.6895 2.43922 3.74549 2.39296 3.80916C2.35809 3.85715 2.31007 3.94926 2.28117 4.21597C2.26629 4.35335 2.25844 4.51311 2.25431 4.70832H9.74498C9.74085 4.51311 9.733 4.35335 9.71812 4.21597C9.68922 3.94926 9.6412 3.85715 9.60633 3.80916C9.56007 3.74549 9.50408 3.6895 9.44041 3.64324C9.39242 3.60837 9.30031 3.56034 9.03362 3.53145C8.75288 3.50103 8.37876 3.5 7.79961 3.5H4.19968C3.62053 3.5 3.24641 3.50103 2.96567 3.53145ZM9.74956 6.20832H2.24973V7.55C2.24973 8.12917 2.25076 8.5033 2.28117 8.78404C2.31007 9.05074 2.35809 9.14285 2.39296 9.19084C2.43922 9.25451 2.49521 9.31051 2.55888 9.35677C2.60687 9.39163 2.69897 9.43966 2.96567 9.46856C3.24641 9.49897 3.62053 9.5 4.19968 9.5H7.79961C8.37876 9.5 8.75288 9.49897 9.03362 9.46856C9.30032 9.43966 9.39242 9.39163 9.44041 9.35677C9.50408 9.31051 9.56007 9.25451 9.60633 9.19084C9.6412 9.14285 9.68922 9.05075 9.71812 8.78404C9.74854 8.5033 9.74956 8.12917 9.74956 7.55V6.20832ZM6.74963 8C6.74963 7.58579 7.08541 7.25 7.49961 7.25H8.2496C8.6638 7.25 8.99958 7.58579 8.99958 8C8.99958 8.41422 8.6638 8.75 8.2496 8.75H7.49961C7.08541 8.75 6.74963 8.41422 6.74963 8Z"
    fill="currentColor"
  /></svg
>`;

});

parcelRegister("3zmm4", function(module, exports) {

$parcel$export(module.exports, "plusSvg", function () { return $2995fb305500b0ed$export$f392b38d2d3751; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $2995fb305500b0ed$export$f392b38d2d3751 = (0, $B77rE.svg)`<svg
  width="13"
  height="12"
  viewBox="0 0 13 12"
  fill="none"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.794373 5.99982C0.794373 5.52643 1.17812 5.14268 1.6515 5.14268H5.643V1.15109C5.643 0.677701 6.02675 0.293946 6.50012 0.293945C6.9735 0.293946 7.35725 0.677701 7.35725 1.15109V5.14268H11.3488C11.8221 5.14268 12.2059 5.52643 12.2059 5.99982C12.2059 6.47321 11.8221 6.85696 11.3488 6.85696H7.35725V10.8486C7.35725 11.3219 6.9735 11.7057 6.50012 11.7057C6.02675 11.7057 5.643 11.3219 5.643 10.8486V6.85696H1.6515C1.17812 6.85696 0.794373 6.47321 0.794373 5.99982Z"
  /></svg
>`;

});


parcelRegister("62Qzz", function(module, exports) {

$parcel$export(module.exports, "WuiImage", function () { return $466bb5d0afba2f51$export$6985d0bcc76e605c; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $4QAyi = parcelRequire("4QAyi");
var $466bb5d0afba2f51$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $466bb5d0afba2f51$export$6985d0bcc76e605c = class WuiImage extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.src = "./path/to/image.jpg";
        this.alt = "Image";
    }
    render() {
        return (0, $B77rE.html)`<img src=${this.src} alt=${this.alt} />`;
    }
};
$466bb5d0afba2f51$export$6985d0bcc76e605c.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.colorStyles),
    (0, $4QAyi.default)
];
$466bb5d0afba2f51$var$__decorate([
    (0, $cG9dN.property)()
], $466bb5d0afba2f51$export$6985d0bcc76e605c.prototype, "src", void 0);
$466bb5d0afba2f51$var$__decorate([
    (0, $cG9dN.property)()
], $466bb5d0afba2f51$export$6985d0bcc76e605c.prototype, "alt", void 0);
$466bb5d0afba2f51$export$6985d0bcc76e605c = $466bb5d0afba2f51$var$__decorate([
    (0, $3SCaV.customElement)("wui-image")
], $466bb5d0afba2f51$export$6985d0bcc76e605c);

});
parcelRegister("4QAyi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38785f45e37ff04e$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $38785f45e37ff04e$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
    width: 100%;
    height: 100%;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    border-radius: inherit;
  }
`;

});


parcelRegister("fkEpZ", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingHexagon", function () { return $b2981375452f3305$export$8429fc8b8d557b81; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $aMCC7 = parcelRequire("aMCC7");
var $b2981375452f3305$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b2981375452f3305$export$8429fc8b8d557b81 = class WuiLoadingHexagon extends (0, $75o4B.LitElement) {
    render() {
        return (0, $B77rE.html)`
      <svg viewBox="0 0 54 59">
        <path
          id="wui-loader-path"
          d="M17.22 5.295c3.877-2.277 5.737-3.363 7.72-3.726a11.44 11.44 0 0 1 4.12 0c1.983.363 3.844 1.45 7.72 3.726l6.065 3.562c3.876 2.276 5.731 3.372 7.032 4.938a11.896 11.896 0 0 1 2.06 3.63c.683 1.928.688 4.11.688 8.663v7.124c0 4.553-.005 6.735-.688 8.664a11.896 11.896 0 0 1-2.06 3.63c-1.3 1.565-3.156 2.66-7.032 4.937l-6.065 3.563c-3.877 2.276-5.737 3.362-7.72 3.725a11.46 11.46 0 0 1-4.12 0c-1.983-.363-3.844-1.449-7.72-3.726l-6.065-3.562c-3.876-2.276-5.731-3.372-7.032-4.938a11.885 11.885 0 0 1-2.06-3.63c-.682-1.928-.688-4.11-.688-8.663v-7.124c0-4.553.006-6.735.688-8.664a11.885 11.885 0 0 1 2.06-3.63c1.3-1.565 3.156-2.66 7.032-4.937l6.065-3.562Z"
        />
        <use xlink:href="#wui-loader-path"></use>
      </svg>
    `;
    }
};
$b2981375452f3305$export$8429fc8b8d557b81.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $aMCC7.default)
];
$b2981375452f3305$export$8429fc8b8d557b81 = $b2981375452f3305$var$__decorate([
    (0, $3SCaV.customElement)("wui-loading-hexagon")
], $b2981375452f3305$export$8429fc8b8d557b81);

});
parcelRegister("aMCC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d9c56f67d761255$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $7d9c56f67d761255$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
    width: var(--wui-box-size-lg);
    height: var(--wui-box-size-lg);
  }

  svg {
    width: var(--wui-box-size-lg);
    height: var(--wui-box-size-lg);
    fill: none;
    stroke: transparent;
    stroke-linecap: round;
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  use {
    stroke: var(--wui-color-accent-100);
    stroke-width: 2px;
    stroke-dasharray: 54, 118;
    stroke-dashoffset: 172;
    animation: dash 1s linear infinite;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0px;
    }
  }
`;

});


parcelRegister("avm78", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingSpinner", function () { return $7a5df4050ae92efb$export$3a84ab9b4ee14f8a; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $8iCND = parcelRequire("8iCND");
var $7a5df4050ae92efb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7a5df4050ae92efb$export$3a84ab9b4ee14f8a = class WuiLoadingSpinner extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.color = "accent-100";
        this.size = "lg";
    }
    render() {
        this.style.cssText = `--local-color: var(--wui-color-${this.color});`;
        this.dataset["size"] = this.size;
        return (0, $B77rE.html)`<svg viewBox="25 25 50 50">
      <circle r="20" cy="50" cx="50"></circle>
    </svg>`;
    }
};
$7a5df4050ae92efb$export$3a84ab9b4ee14f8a.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $8iCND.default)
];
$7a5df4050ae92efb$var$__decorate([
    (0, $cG9dN.property)()
], $7a5df4050ae92efb$export$3a84ab9b4ee14f8a.prototype, "color", void 0);
$7a5df4050ae92efb$var$__decorate([
    (0, $cG9dN.property)()
], $7a5df4050ae92efb$export$3a84ab9b4ee14f8a.prototype, "size", void 0);
$7a5df4050ae92efb$export$3a84ab9b4ee14f8a = $7a5df4050ae92efb$var$__decorate([
    (0, $3SCaV.customElement)("wui-loading-spinner")
], $7a5df4050ae92efb$export$3a84ab9b4ee14f8a);

});
parcelRegister("8iCND", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60ae19f4f868c944$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $60ae19f4f868c944$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: flex;
  }

  :host([data-size='sm']) > svg {
    width: 12px;
    height: 12px;
  }

  :host([data-size='md']) > svg {
    width: 16px;
    height: 16px;
  }

  :host([data-size='lg']) > svg {
    width: 24px;
    height: 24px;
  }

  :host([data-size='xl']) > svg {
    width: 32px;
    height: 32px;
  }

  svg {
    animation: rotate 2s linear infinite;
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  circle {
    fill: none;
    stroke: var(--local-color);
    stroke-width: 4px;
    stroke-dasharray: 1, 124;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  :host([data-size='md']) > svg > circle {
    stroke-width: 6px;
  }

  :host([data-size='sm']) > svg > circle {
    stroke-width: 8px;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 124;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 124;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dashoffset: -125;
    }
  }
`;

});


parcelRegister("9fe4A", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingThumbnail", function () { return $6bb06e5d7bc41643$export$a8f5e0b29edd5ad2; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $6fGI5 = parcelRequire("6fGI5");
var $6bb06e5d7bc41643$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $6bb06e5d7bc41643$export$a8f5e0b29edd5ad2 = class WuiLoadingThumbnail extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.radius = 36;
    }
    render() {
        return this.svgLoaderTemplate();
    }
    svgLoaderTemplate() {
        const radius = this.radius > 50 ? 50 : this.radius;
        const standardValue = 36;
        const radiusFactor = standardValue - radius;
        const dashArrayStart = 116 + radiusFactor;
        const dashArrayEnd = 245 + radiusFactor;
        const dashOffset = 360 + radiusFactor * 1.75;
        return (0, $B77rE.html)`
      <svg viewBox="0 0 110 110" width="110" height="110">
        <rect
          x="2"
          y="2"
          width="106"
          height="106"
          rx=${radius}
          stroke-dasharray="${dashArrayStart} ${dashArrayEnd}"
          stroke-dashoffset=${dashOffset}
        />
      </svg>
    `;
    }
};
$6bb06e5d7bc41643$export$a8f5e0b29edd5ad2.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $6fGI5.default)
];
$6bb06e5d7bc41643$var$__decorate([
    (0, $cG9dN.property)({
        type: Number
    })
], $6bb06e5d7bc41643$export$a8f5e0b29edd5ad2.prototype, "radius", void 0);
$6bb06e5d7bc41643$export$a8f5e0b29edd5ad2 = $6bb06e5d7bc41643$var$__decorate([
    (0, $3SCaV.customElement)("wui-loading-thumbnail")
], $6bb06e5d7bc41643$export$a8f5e0b29edd5ad2);

});
parcelRegister("6fGI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48d5462363e09148$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $48d5462363e09148$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
    width: var(--wui-box-size-md);
    height: var(--wui-box-size-md);
  }

  svg {
    width: var(--wui-box-size-md);
    height: var(--wui-box-size-md);
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  rect {
    fill: none;
    stroke: var(--wui-color-accent-100);
    stroke-width: 4px;
    stroke-linecap: round;
    animation: dash 1s linear infinite;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0px;
    }
  }
`;

});


parcelRegister("2SjI8", function(module, exports) {

$parcel$export(module.exports, "WuiShimmer", function () { return $217fea13d4ba74bd$export$22033065aa649938; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $3SCaV = parcelRequire("3SCaV");

var $3vnLQ = parcelRequire("3vnLQ");
var $217fea13d4ba74bd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $217fea13d4ba74bd$export$22033065aa649938 = class WuiShimmer extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.width = "";
        this.height = "";
        this.borderRadius = "m";
    }
    render() {
        this.style.cssText = `
      width: ${this.width};
      height: ${this.height};
      border-radius: ${`clamp(0px,var(--wui-border-radius-${this.borderRadius}), 40px)`};
    `;
        return (0, $B77rE.html)`<slot></slot>`;
    }
};
$217fea13d4ba74bd$export$22033065aa649938.styles = [
    (0, $3vnLQ.default)
];
$217fea13d4ba74bd$var$__decorate([
    (0, $cG9dN.property)()
], $217fea13d4ba74bd$export$22033065aa649938.prototype, "width", void 0);
$217fea13d4ba74bd$var$__decorate([
    (0, $cG9dN.property)()
], $217fea13d4ba74bd$export$22033065aa649938.prototype, "height", void 0);
$217fea13d4ba74bd$var$__decorate([
    (0, $cG9dN.property)()
], $217fea13d4ba74bd$export$22033065aa649938.prototype, "borderRadius", void 0);
$217fea13d4ba74bd$export$22033065aa649938 = $217fea13d4ba74bd$var$__decorate([
    (0, $3SCaV.customElement)("wui-shimmer")
], $217fea13d4ba74bd$export$22033065aa649938);

});
parcelRegister("3vnLQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28d6b4b633e5c8af$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $28d6b4b633e5c8af$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
    background: linear-gradient(
      120deg,
      var(--wui-color-bg-200) 5%,
      var(--wui-color-bg-200) 48%,
      var(--wui-color-bg-300) 55%,
      var(--wui-color-bg-300) 60%,
      var(--wui-color-bg-300) calc(60% + 10px),
      var(--wui-color-bg-200) calc(60% + 12px),
      var(--wui-color-bg-200) 100%
    );
    background-size: 250%;
    animation: shimmer 3s linear infinite reverse;
  }

  @keyframes shimmer {
    from {
      background-position: -250% 0;
    }
    to {
      background-position: 250% 0;
    }
  }
`;

});


parcelRegister("7xM3j", function(module, exports) {

$parcel$export(module.exports, "WuiText", function () { return $57e0e3af68f66b39$export$406e1aa02d8022e4; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("aiEEF");
var $enRru = parcelRequire("enRru");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $d3yoT = parcelRequire("d3yoT");
var $57e0e3af68f66b39$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $57e0e3af68f66b39$export$406e1aa02d8022e4 = class WuiText extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "paragraph-500";
        this.color = "fg-300";
        this.align = "left";
    }
    render() {
        const classes = {
            [`wui-font-${this.variant}`]: true,
            [`wui-color-${this.color}`]: true
        };
        this.style.cssText = `
      --local-align: ${this.align};
      --local-color: var(--wui-color-${this.color});
    `;
        return (0, $B77rE.html)`<slot class=${(0, $enRru.classMap)(classes)}></slot>`;
    }
};
$57e0e3af68f66b39$export$406e1aa02d8022e4.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $d3yoT.default)
];
$57e0e3af68f66b39$var$__decorate([
    (0, $cG9dN.property)()
], $57e0e3af68f66b39$export$406e1aa02d8022e4.prototype, "variant", void 0);
$57e0e3af68f66b39$var$__decorate([
    (0, $cG9dN.property)()
], $57e0e3af68f66b39$export$406e1aa02d8022e4.prototype, "color", void 0);
$57e0e3af68f66b39$var$__decorate([
    (0, $cG9dN.property)()
], $57e0e3af68f66b39$export$406e1aa02d8022e4.prototype, "align", void 0);
$57e0e3af68f66b39$export$406e1aa02d8022e4 = $57e0e3af68f66b39$var$__decorate([
    (0, $3SCaV.customElement)("wui-text")
], $57e0e3af68f66b39$export$406e1aa02d8022e4);

});
parcelRegister("aiEEF", function(module, exports) {
$parcel$export(module.exports, "classMap", function () { return (parcelRequire("enRru")).classMap; });
parcelRequire("enRru");

});
parcelRegister("enRru", function(module, exports) {

$parcel$export(module.exports, "classMap", function () { return $a78cab3605e063c6$export$56cc687933817664; });

var $B77rE = parcelRequire("B77rE");

var $amTA7 = parcelRequire("amTA7");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a78cab3605e063c6$export$56cc687933817664 = (0, $amTA7.directive)(class extends (0, $amTA7.Directive) {
    constructor(s){
        if (super(s), s.type !== (0, $amTA7.PartType).ATTRIBUTE || "class" !== s.name || s.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(t, [s]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== t.strings && (this.nt = new Set(t.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(s);
        }
        const i = t.element.classList;
        for (const t of this.st)t in s || (i.remove(t), this.st.delete(t));
        for(const t in s){
            const r = !!s[t];
            r === this.st.has(t) || this.nt?.has(t) || (r ? (i.add(t), this.st.add(t)) : (i.remove(t), this.st.delete(t)));
        }
        return 0, $B77rE.noChange;
    }
});

});
parcelRegister("amTA7", function(module, exports) {

$parcel$export(module.exports, "PartType", function () { return $78c712ce9d90051b$export$9ba3b3f20a85bfa; });
$parcel$export(module.exports, "directive", function () { return $78c712ce9d90051b$export$99b43ad1ed32e735; });
$parcel$export(module.exports, "Directive", function () { return $78c712ce9d90051b$export$befdefbdce210f91; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $78c712ce9d90051b$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $78c712ce9d90051b$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $78c712ce9d90051b$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this.t = t, this._$AM = e, this.i = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("d3yoT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98163d67026a0b86$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $98163d67026a0b86$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: inline-flex !important;
  }

  slot {
    display: inline-block;
    font-style: normal;
    font-family: var(--wui-font-family);
    font-feature-settings:
      'tnum' on,
      'lnum' on,
      'case' on;
    line-height: 130%;
    font-weight: var(--wui-font-weight-regular);
    overflow: inherit;
    text-overflow: inherit;
    text-align: var(--local-align);
    color: var(--local-color);
  }

  .wui-font-medium-title-600 {
    font-size: var(--wui-font-size-medium-title);
    letter-spacing: var(--wui-letter-spacing-medium-title);
  }

  .wui-font-large-500,
  .wui-font-large-600,
  .wui-font-large-700 {
    font-size: var(--wui-font-size-large);
    letter-spacing: var(--wui-letter-spacing-large);
  }

  .wui-font-2xl-500,
  .wui-font-2xl-600,
  .wui-font-2xl-700 {
    font-size: var(--wui-font-size-2xl);
    letter-spacing: var(--wui-letter-spacing-2xl);
  }

  .wui-font-paragraph-500,
  .wui-font-paragraph-600,
  .wui-font-paragraph-700 {
    font-size: var(--wui-font-size-paragraph);
    letter-spacing: var(--wui-letter-spacing-paragraph);
  }

  .wui-font-small-400,
  .wui-font-small-500,
  .wui-font-small-600 {
    font-size: var(--wui-font-size-small);
    letter-spacing: var(--wui-letter-spacing-small);
  }

  .wui-font-tiny-400,
  .wui-font-tiny-500,
  .wui-font-tiny-600 {
    font-size: var(--wui-font-size-tiny);
    letter-spacing: var(--wui-letter-spacing-tiny);
  }

  .wui-font-micro-700,
  .wui-font-micro-600 {
    font-size: var(--wui-font-size-micro);
    letter-spacing: var(--wui-letter-spacing-micro);
    text-transform: uppercase;
  }

  .wui-font-tiny-400,
  .wui-font-small-400,
  .wui-font-paragraph-400 {
    font-weight: var(--wui-font-weight-light);
  }

  .wui-font-large-700,
  .wui-font-paragraph-700,
  .wui-font-micro-700 {
    font-weight: var(--wui-font-weight-bold);
  }

  .wui-font-medium-title-600,
  .wui-font-large-600,
  .wui-font-paragraph-600,
  .wui-font-small-600,
  .wui-font-tiny-600,
  .wui-font-micro-600 {
    font-weight: var(--wui-font-weight-medium);
  }
`;

});


parcelRegister("fCVjD", function(module, exports) {

$parcel$export(module.exports, "WuiVisual", function () { return $b606dd5333ee1ed7$export$e6365a334c1a5845; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $iB4uR = parcelRequire("iB4uR");

var $gYFr9 = parcelRequire("gYFr9");

var $cvHgb = parcelRequire("cvHgb");

var $bpeHA = parcelRequire("bpeHA");

var $79wSf = parcelRequire("79wSf");

var $9Ac1N = parcelRequire("9Ac1N");

var $gTShT = parcelRequire("gTShT");

var $jDI3s = parcelRequire("jDI3s");

var $Yc47d = parcelRequire("Yc47d");

var $cYyyE = parcelRequire("cYyyE");

var $a04bd = parcelRequire("a04bd");

var $zifee = parcelRequire("zifee");

var $8KK8R = parcelRequire("8KK8R");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $f0whZ = parcelRequire("f0whZ");

var $cgTKA = parcelRequire("cgTKA");

var $cG0Ff = parcelRequire("cG0Ff");

var $8pqNx = parcelRequire("8pqNx");

var $i1BCz = parcelRequire("i1BCz");

var $993kq = parcelRequire("993kq");
var $b606dd5333ee1ed7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $b606dd5333ee1ed7$var$svgOptions = {
    browser: (0, $iB4uR.browserSvg),
    dao: (0, $gYFr9.daoSvg),
    defi: (0, $cvHgb.defiSvg),
    defiAlt: (0, $bpeHA.defiAltSvg),
    eth: (0, $79wSf.ethSvg),
    layers: (0, $9Ac1N.layersSvg),
    lock: (0, $gTShT.lockSvg),
    login: (0, $jDI3s.loginSvg),
    network: (0, $Yc47d.networkSvg),
    nft: (0, $cYyyE.nftSvg),
    noun: (0, $a04bd.nounSvg),
    profile: (0, $zifee.profileSvg),
    system: (0, $8KK8R.systemSvg),
    coinbase: (0, $f0whZ.coinbaseSvg),
    onrampCard: (0, $i1BCz.onrampCardSvg),
    moonpay: (0, $cgTKA.moonpaySvg),
    stripe: (0, $cG0Ff.stripeSvg),
    paypal: (0, $8pqNx.paypalSvg)
};
let $b606dd5333ee1ed7$export$e6365a334c1a5845 = class WuiVisual extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.name = "browser";
        this.size = "md";
    }
    render() {
        this.style.cssText = `
       --local-size: var(--wui-visual-size-${this.size});
   `;
        return (0, $B77rE.html)`${$b606dd5333ee1ed7$var$svgOptions[this.name]}`;
    }
};
$b606dd5333ee1ed7$export$e6365a334c1a5845.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $993kq.default)
];
$b606dd5333ee1ed7$var$__decorate([
    (0, $cG9dN.property)()
], $b606dd5333ee1ed7$export$e6365a334c1a5845.prototype, "name", void 0);
$b606dd5333ee1ed7$var$__decorate([
    (0, $cG9dN.property)()
], $b606dd5333ee1ed7$export$e6365a334c1a5845.prototype, "size", void 0);
$b606dd5333ee1ed7$export$e6365a334c1a5845 = $b606dd5333ee1ed7$var$__decorate([
    (0, $3SCaV.customElement)("wui-visual")
], $b606dd5333ee1ed7$export$e6365a334c1a5845);

});
parcelRegister("iB4uR", function(module, exports) {

$parcel$export(module.exports, "browserSvg", function () { return $d89f2bab32b74993$export$9a659d11e13bcec5; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $d89f2bab32b74993$export$9a659d11e13bcec5 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#1DC956" rx="30" />
  <circle cx="30" cy="30" r="3" fill="#fff" />
  <path
    fill="#2BEE6C"
    stroke="#fff"
    stroke-width="2"
    d="m45.32 17.9-.88-.42.88.42.02-.05c.1-.2.21-.44.26-.7l-.82-.15.82.16a2 2 0 0 0-.24-1.4c-.13-.23-.32-.42-.47-.57a8.42 8.42 0 0 1-.04-.04l-.04-.04a2.9 2.9 0 0 0-.56-.47l-.51.86.5-.86a2 2 0 0 0-1.4-.24c-.26.05-.5.16-.69.26l-.05.02-15.05 7.25-.1.05c-1.14.55-1.85.89-2.46 1.37a7 7 0 0 0-1.13 1.14c-.5.6-.83 1.32-1.38 2.45l-.05.11-7.25 15.05-.02.05c-.1.2-.21.43-.26.69a2 2 0 0 0 .24 1.4l.85-.5-.85.5c.13.23.32.42.47.57l.04.04.04.04c.15.15.34.34.56.47a2 2 0 0 0 1.41.24l-.2-.98.2.98c.25-.05.5-.17.69-.26l.05-.02-.42-.87.42.87 15.05-7.25.1-.05c1.14-.55 1.85-.89 2.46-1.38a7 7 0 0 0 1.13-1.13 12.87 12.87 0 0 0 1.43-2.56l7.25-15.05Z"
  />
  <path
    fill="#1DC956"
    d="M33.38 32.72 30.7 29.3 15.86 44.14l.2.2a1 1 0 0 0 1.14.2l15.1-7.27a3 3 0 0 0 1.08-4.55Z"
  />
  <path
    fill="#86F999"
    d="m26.62 27.28 2.67 3.43 14.85-14.85-.2-.2a1 1 0 0 0-1.14-.2l-15.1 7.27a3 3 0 0 0-1.08 4.55Z"
  />
  <circle cx="30" cy="30" r="3" fill="#fff" transform="rotate(45 30 30)" />
  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />
</svg> `;

});

parcelRegister("gYFr9", function(module, exports) {

$parcel$export(module.exports, "daoSvg", function () { return $c5c2646eb67574aa$export$4c380a6200fee43; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $c5c2646eb67574aa$export$4c380a6200fee43 = (0, $B77rE.svg)`<svg viewBox="0 0 60 60" fill="none">
  <g clip-path="url(#clip0_7734_50402)">
    <path
      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"
      fill="#EB8B47"
    />
    <path
      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"
      stroke="#062B2B"
      stroke-opacity="0.1"
    />
    <path
      d="M19 52C24.5228 52 29 47.5228 29 42C29 36.4772 24.5228 32 19 32C13.4772 32 9 36.4772 9 42C9 47.5228 13.4772 52 19 52Z"
      fill="#FF974C"
      stroke="white"
      stroke-width="2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.8437 8.3264C42.4507 7.70891 41.5493 7.70891 41.1564 8.32641L28.978 27.4638C28.5544 28.1295 29.0326 29.0007 29.8217 29.0007H54.1783C54.9674 29.0007 55.4456 28.1295 55.022 27.4638L42.8437 8.3264Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.3348 11.6456C42.659 11.7608 42.9061 12.1492 43.4005 12.926L50.7332 24.4488C51.2952 25.332 51.5763 25.7737 51.5254 26.1382C51.4915 26.3808 51.3698 26.6026 51.1833 26.7614C50.9031 27 50.3796 27 49.3327 27H34.6673C33.6204 27 33.0969 27 32.8167 26.7614C32.6302 26.6026 32.5085 26.3808 32.4746 26.1382C32.4237 25.7737 32.7048 25.332 33.2669 24.4488L40.5995 12.926C41.0939 12.1492 41.341 11.7608 41.6652 11.6456C41.8818 11.5687 42.1182 11.5687 42.3348 11.6456ZM35.0001 26.999C38.8661 26.999 42.0001 23.865 42.0001 19.999C42.0001 23.865 45.1341 26.999 49.0001 26.999H35.0001Z"
      fill="#FF974C"
    />
    <path
      d="M10.1061 9.35712C9.9973 9.67775 9.99867 10.0388 9.99978 10.3323C9.99989 10.3611 10 10.3893 10 10.4167V25.5833C10 25.6107 9.99989 25.6389 9.99978 25.6677C9.99867 25.9612 9.9973 26.3222 10.1061 26.6429C10.306 27.2317 10.7683 27.694 11.3571 27.8939C11.6777 28.0027 12.0388 28.0013 12.3323 28.0002C12.3611 28.0001 12.3893 28 12.4167 28H19C24.5228 28 29 23.5228 29 18C29 12.4772 24.5228 8 19 8H12.4167C12.3893 8 12.3611 7.99989 12.3323 7.99978C12.0388 7.99867 11.6778 7.9973 11.3571 8.10614C10.7683 8.306 10.306 8.76834 10.1061 9.35712Z"
      fill="#FF974C"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="19" cy="18" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />
    <circle cx="19" cy="42" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="clip0_7734_50402">
      <rect width="60" height="60" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("cvHgb", function(module, exports) {

$parcel$export(module.exports, "defiSvg", function () { return $91b9efd4cb314fd1$export$400ef2a1f7fc3217; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $91b9efd4cb314fd1$export$400ef2a1f7fc3217 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <path
      fill="#1DC956"
      d="M0 25.01c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02.11 15.65.11 24.9.11h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.13 60 15.76 60 25v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-3.45 1.97-8.08 1.97-17.33 1.97H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 49.1 0 44.46 0 35.21v-10.2Z"
    />
    <path
      fill="#2BEE6C"
      d="M16.1 60c-3.82-.18-6.4-.64-8.53-1.86a15 15 0 0 1-5.6-5.6C.55 50.06.16 46.97.04 41.98L4.2 40.6a4 4 0 0 0 2.48-2.39l4.65-12.4a2 2 0 0 1 2.5-1.2l2.53.84a2 2 0 0 0 2.43-1l2.96-5.94a2 2 0 0 1 3.7.32l3.78 12.58a2 2 0 0 0 3.03 1.09l3.34-2.23a2 2 0 0 0 .65-.7l5.3-9.72a2 2 0 0 1 1.42-1.01l4.14-.69a2 2 0 0 1 1.6.44l3.9 3.24a2 2 0 0 0 2.7-.12l4.62-4.63c.08 2.2.08 4.8.08 7.93v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-2.13 1.22-4.7 1.68-8.54 1.86H16.11Z"
    />
    <path
      fill="#fff"
      d="m.07 43.03-.05-2.1 3.85-1.28a3 3 0 0 0 1.86-1.79l4.66-12.4a3 3 0 0 1 3.75-1.8l2.53.84a1 1 0 0 0 1.21-.5l2.97-5.94a3 3 0 0 1 5.56.48l3.77 12.58a1 1 0 0 0 1.51.55l3.34-2.23a1 1 0 0 0 .33-.35l5.3-9.71a3 3 0 0 1 2.14-1.53l4.13-.69a3 3 0 0 1 2.41.66l3.9 3.24a1 1 0 0 0 1.34-.06l5.28-5.28c.05.85.08 1.75.1 2.73L56 22.41a3 3 0 0 1-4.04.19l-3.9-3.25a1 1 0 0 0-.8-.21l-4.13.69a1 1 0 0 0-.72.5l-5.3 9.72a3 3 0 0 1-.97 1.05l-3.34 2.23a3 3 0 0 1-4.53-1.63l-3.78-12.58a1 1 0 0 0-1.85-.16l-2.97 5.94a3 3 0 0 1-3.63 1.5l-2.53-.84a1 1 0 0 0-1.25.6l-4.65 12.4a5 5 0 0 1-3.1 3L.07 43.02Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M49.5 19a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      clip-rule="evenodd"
    />
    <path fill="#fff" d="M45 .28v59.66l-2 .1V.19c.7.02 1.37.05 2 .1Z" />
    <path fill="#2BEE6C" d="M47.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
    <path
      stroke="#fff"
      stroke-opacity=".1"
      d="M.5 25.01c0-4.63 0-8.08.24-10.8.25-2.7.73-4.64 1.66-6.28a14.5 14.5 0 0 1 5.42-5.41C9.46 1.58 11.39 1.1 14.1.85A133 133 0 0 1 24.9.61h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.67a14.5 14.5 0 0 1 5.42 5.4c.93 1.65 1.41 3.58 1.66 6.3.24 2.71.24 6.16.24 10.79v10.2c0 4.64 0 8.08-.24 10.8-.25 2.7-.73 4.65-1.66 6.28a14.5 14.5 0 0 1-5.42 5.42c-1.63.93-3.57 1.41-6.28 1.66-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.66a14.5 14.5 0 0 1-5.42-5.42C1.47 50.66 1 48.72.74 46.01A133 133 0 0 1 .5 35.2v-10.2Z"
    />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("bpeHA", function(module, exports) {

$parcel$export(module.exports, "defiAltSvg", function () { return $84dd6f07dbeb1f4b$export$f1568dd015c8f3b9; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $84dd6f07dbeb1f4b$export$f1568dd015c8f3b9 = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#C653C6" rx="30" />
    <path
      fill="#E87DE8"
      d="M57.98.01v19.5a4.09 4.09 0 0 0-2.63 2.29L50.7 34.2a2 2 0 0 1-2.5 1.2l-2.53-.84a2 2 0 0 0-2.42 1l-2.97 5.94a2 2 0 0 1-3.7-.32L32.8 28.6a2 2 0 0 0-3.02-1.09l-3.35 2.23a2 2 0 0 0-.64.7l-5.3 9.72a2 2 0 0 1-1.43 1.01l-4.13.69a2 2 0 0 1-1.61-.44l-3.9-3.24a2 2 0 0 0-2.69.12L2.1 42.93.02 43V.01h57.96Z"
    />
    <path
      fill="#fff"
      d="m61.95 16.94.05 2.1-3.85 1.28a3 3 0 0 0-1.86 1.79l-4.65 12.4a3 3 0 0 1-3.76 1.8l-2.53-.84a1 1 0 0 0-1.2.5l-2.98 5.94a3 3 0 0 1-5.55-.48l-3.78-12.58a1 1 0 0 0-1.5-.55l-3.35 2.23a1 1 0 0 0-.32.35l-5.3 9.72a3 3 0 0 1-2.14 1.52l-4.14.69a3 3 0 0 1-2.41-.66l-3.9-3.24a1 1 0 0 0-1.34.06l-5.28 5.28c-.05-.84-.08-1.75-.1-2.73l3.97-3.96a3 3 0 0 1 4.04-.19l3.89 3.25a1 1 0 0 0 .8.21l4.14-.68a1 1 0 0 0 .71-.51l5.3-9.71a3 3 0 0 1 .97-1.06l3.34-2.23a3 3 0 0 1 4.54 1.63l3.77 12.58a1 1 0 0 0 1.86.16l2.96-5.93a3 3 0 0 1 3.64-1.5l2.52.83a1 1 0 0 0 1.25-.6l4.66-12.4a5 5 0 0 1 3.1-2.99l4.43-1.48Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M35.5 27a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      clip-rule="evenodd"
    />
    <path fill="#fff" d="M31 0v60h-2V0h2Z" />
    <path fill="#E87DE8" d="M33.5 27a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("79wSf", function(module, exports) {

$parcel$export(module.exports, "ethSvg", function () { return $5352dfc0a5f5e519$export$9c7a8a6662d6e69b; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $5352dfc0a5f5e519$export$9c7a8a6662d6e69b = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#987DE8" rx="30" />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="m15.48 28.37 11.97-19.3a3 3 0 0 1 5.1 0l11.97 19.3a6 6 0 0 1 .9 3.14v.03a6 6 0 0 1-1.16 3.56L33.23 50.2a4 4 0 0 1-6.46 0L15.73 35.1a6 6 0 0 1-1.15-3.54v-.03a6 6 0 0 1 .9-3.16Z"
      clip-rule="evenodd"
    />
    <path
      fill="#643CDD"
      d="M30.84 10.11a1 1 0 0 0-.84-.46V24.5l12.6 5.53a2 2 0 0 0-.28-1.4L30.84 10.11Z"
    />
    <path
      fill="#BDADEB"
      d="M30 9.65a1 1 0 0 0-.85.46L17.66 28.64a2 2 0 0 0-.26 1.39L30 24.5V9.65Z"
    />
    <path
      fill="#643CDD"
      d="M30 50.54a1 1 0 0 0 .8-.4l11.24-15.38c.3-.44-.2-1-.66-.73l-9.89 5.68a3 3 0 0 1-1.5.4v10.43Z"
    />
    <path
      fill="#BDADEB"
      d="m17.97 34.76 11.22 15.37c.2.28.5.41.8.41V40.11a3 3 0 0 1-1.49-.4l-9.88-5.68c-.47-.27-.97.3-.65.73Z"
    />
    <path
      fill="#401AB3"
      d="M42.6 30.03 30 24.5v13.14a3 3 0 0 0 1.5-.4l10.14-5.83a2 2 0 0 0 .95-1.38Z"
    />
    <path
      fill="#7C5AE2"
      d="M30 37.64V24.46l-12.6 5.57a2 2 0 0 0 .97 1.39l10.13 5.82a3 3 0 0 0 1.5.4Z"
    />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("9Ac1N", function(module, exports) {

$parcel$export(module.exports, "layersSvg", function () { return $6fa0ce5d7ae91cd9$export$92af4cd19d37b5ea; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $6fa0ce5d7ae91cd9$export$92af4cd19d37b5ea = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#1DC956" rx="3" />
  <path
    fill="#1FAD7E"
    stroke="#fff"
    stroke-width="2"
    d="m30.49 29.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"
  />
  <path
    fill="#2BEE6C"
    stroke="#fff"
    stroke-width="2"
    d="m30.49 19.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"
  />
  <path
    fill="#86F999"
    stroke="#fff"
    stroke-width="2"
    d="m46.69 21.06-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-6.32-3.51-.18-.1c-2.33-1.3-3.72-2.06-5.22-2.33a9 9 0 0 0-3.08 0c-1.5.27-2.9 1.04-5.22 2.33l-.17.1-6.33 3.51-.05.03c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45Z"
  />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("gTShT", function(module, exports) {

$parcel$export(module.exports, "lockSvg", function () { return $c4dbe4c1ca1addb5$export$70be6a782cc364be; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $c4dbe4c1ca1addb5$export$70be6a782cc364be = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#C653C6" rx="3" />
  <path
    fill="#fff"
    d="M20.03 15.22C20 15.6 20 16.07 20 17v2.8c0 1.14 0 1.7-.2 2.12-.15.31-.3.5-.58.71-.37.28-1.06.42-2.43.7-.59.12-1.11.29-1.6.51a9 9 0 0 0-4.35 4.36C10 30 10 32.34 10 37c0 4.66 0 7 .84 8.8a9 9 0 0 0 4.36 4.36C17 51 19.34 51 24 51h12c4.66 0 7 0 8.8-.84a9 9 0 0 0 4.36-4.36C50 44 50 41.66 50 37c0-4.66 0-7-.84-8.8a9 9 0 0 0-4.36-4.36c-.48-.22-1-.39-1.6-.5-1.36-.29-2.05-.43-2.42-.7-.27-.22-.43-.4-.58-.72-.2-.42-.2-.98-.2-2.11V17c0-.93 0-1.4-.03-1.78a9 9 0 0 0-8.19-8.19C31.4 7 30.93 7 30 7s-1.4 0-1.78.03a9 9 0 0 0-8.19 8.19Z"
  />
  <path
    fill="#E87DE8"
    d="M22 17c0-.93 0-1.4.04-1.78a7 7 0 0 1 6.18-6.18C28.6 9 29.07 9 30 9s1.4 0 1.78.04a7 7 0 0 1 6.18 6.18c.04.39.04.85.04 1.78v4.5a1.5 1.5 0 0 1-3 0V17c0-.93 0-1.4-.08-1.78a4 4 0 0 0-3.14-3.14C31.39 12 30.93 12 30 12s-1.4 0-1.78.08a4 4 0 0 0-3.14 3.14c-.08.39-.08.85-.08 1.78v4.5a1.5 1.5 0 0 1-3 0V17Z"
  />
  <path
    fill="#E87DE8"
    fill-rule="evenodd"
    d="M12 36.62c0-4.32 0-6.48.92-8.09a7 7 0 0 1 2.61-2.61C17.14 25 19.3 25 23.62 25h6.86c.46 0 .7 0 .9.02 2.73.22 4.37 2.43 4.62 4.98.27-2.7 2.11-5 5.02-5A6.98 6.98 0 0 1 48 31.98v5.4c0 4.32 0 6.48-.92 8.09a7 7 0 0 1-2.61 2.61c-1.61.92-3.77.92-8.09.92h-5.86c-.46 0-.7 0-.9-.02-2.73-.22-4.37-2.43-4.62-4.98-.26 2.58-1.94 4.82-4.71 4.99l-.7.01c-.55 0-.82 0-1.05-.02a7 7 0 0 1-6.52-6.52c-.02-.23-.02-.5-.02-1.05v-4.79Zm21.24-.27a4 4 0 1 0-6.48 0 31.28 31.28 0 0 1 1.57 2.23c.17.4.17.81.17 1.24V42.5a1.5 1.5 0 0 0 3 0V39.82c0-.43 0-.85.17-1.24.09-.2.58-.87 1.57-2.23Z"
    clip-rule="evenodd"
  />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("jDI3s", function(module, exports) {

$parcel$export(module.exports, "loginSvg", function () { return $e4c3d5347d6835a4$export$c9aa74efff8430c; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $e4c3d5347d6835a4$export$c9aa74efff8430c = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <path
      fill="#EB8B47"
      d="M0 24.9c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02 0 15.65 0 24.9 0h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.02 60 15.65 60 24.9v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6C48.98 60 44.35 60 35.1 60H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 48.98 0 44.35 0 35.1V24.9Z"
    />
    <path
      stroke="#062B2B"
      stroke-opacity=".1"
      d="M.5 24.9c0-4.64 0-8.08.24-10.8.25-2.7.73-4.65 1.66-6.28A14.5 14.5 0 0 1 7.82 2.4C9.46 1.47 11.39 1 14.1.74A133 133 0 0 1 24.9.5h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.66a14.5 14.5 0 0 1 5.42 5.42c.93 1.63 1.41 3.57 1.66 6.28.24 2.72.24 6.16.24 10.8v10.2c0 4.63 0 8.08-.24 10.8-.25 2.7-.73 4.64-1.66 6.28a14.5 14.5 0 0 1-5.42 5.41c-1.63.94-3.57 1.42-6.28 1.67-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.67a14.5 14.5 0 0 1-5.42-5.4C1.47 50.53 1 48.6.74 45.88A133 133 0 0 1 .5 35.1V24.9Z"
    />
    <path
      fill="#FF974C"
      stroke="#fff"
      stroke-width="2"
      d="M39.2 29.2a13 13 0 1 0-18.4 0l1.3 1.28a12.82 12.82 0 0 1 2.1 2.39 6 6 0 0 1 .6 1.47c.2.76.2 1.56.2 3.17v11.24c0 1.08 0 1.61.13 2.12a4 4 0 0 0 .41.98c.26.45.64.83 1.4 1.6l.3.29c.65.65.98.98 1.36 1.09.26.07.54.07.8 0 .38-.11.7-.44 1.36-1.1l3.48-3.47c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.47-.48c-.65-.65-.98-.98-1.09-1.36a1.5 1.5 0 0 1 0-.8c.1-.38.44-.7 1.1-1.36l.47-.48c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.48-.5c-.65-.64-.98-.97-1.08-1.35a1.5 1.5 0 0 1 0-.79c.1-.38.42-.7 1.06-1.36l5.46-5.55Z"
    />
    <circle cx="30" cy="17" r="4" fill="#EB8B47" stroke="#fff" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("Yc47d", function(module, exports) {

$parcel$export(module.exports, "networkSvg", function () { return $0b4ef6a4f01370e9$export$1a3efa751581ed0a; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $0b4ef6a4f01370e9$export$1a3efa751581ed0a = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#00ACE6" rx="30" />
    <circle cx="64" cy="39" r="50" fill="#1AC6FF" stroke="#fff" stroke-width="2" />
    <circle cx="78" cy="30" r="50" fill="#4DD2FF" stroke="#fff" stroke-width="2" />
    <circle cx="72" cy="15" r="35" fill="#80DFFF" stroke="#fff" stroke-width="2" />
    <circle cx="34" cy="-17" r="45" stroke="#fff" stroke-width="2" />
    <circle cx="34" cy="-5" r="50" stroke="#fff" stroke-width="2" />
    <circle cx="30" cy="45" r="4" fill="#4DD2FF" stroke="#fff" stroke-width="2" />
    <circle cx="39.5" cy="27.5" r="4" fill="#80DFFF" stroke="#fff" stroke-width="2" />
    <circle cx="16" cy="24" r="4" fill="#19C6FF" stroke="#fff" stroke-width="2" />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("cYyyE", function(module, exports) {

$parcel$export(module.exports, "nftSvg", function () { return $9725e518fe768041$export$1c5022265b1a9f1f; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $9725e518fe768041$export$1c5022265b1a9f1f = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#C653C6" rx="3" />
    <path
      fill="#E87DE8"
      stroke="#fff"
      stroke-width="2"
      d="M52.1 47.34c0-4.24-1.44-9.55-5.9-12.4a2.86 2.86 0 0 0-1.6-3.89v-.82c0-1.19-.52-2.26-1.35-3a4.74 4.74 0 0 0-2.4-6.26v-5.5a11.31 11.31 0 1 0-22.63 0v2.15a3.34 3.34 0 0 0-1.18 5.05 4.74 4.74 0 0 0-.68 6.44A5.22 5.22 0 0 0 14 35.92c-3.06 4.13-6.1 8.3-6.1 15.64 0 2.67.37 4.86.74 6.39a20.3 20.3 0 0 0 .73 2.39l.02.04v.01l.92-.39-.92.4.26.6h38.26l.3-.49-.87-.51.86.5.02-.01.03-.07a16.32 16.32 0 0 0 .57-1.05c.36-.72.85-1.74 1.33-2.96a25.51 25.51 0 0 0 1.94-9.07Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M26.5 29.5c-3-.5-5.5-3-5.5-7v-7c0-.47 0-.7.03-.9a3 3 0 0 1 2.58-2.57c.2-.03.42-.03.89-.03 2 0 2.5-2.5 2.5-2.5s0 2.5 2.5 2.5c1.4 0 2.1 0 2.65.23a3 3 0 0 1 1.62 1.62c.23.55.23 1.25.23 2.65v6c0 4-3 7-6.5 7 1.35.23 4 0 6.5-2v9.53C34 38.5 31.5 40 28 40s-6-1.5-6-2.97L24 34l2.5 1.5v-6ZM26 47h4.5c2.5 0 3 4 3 5.5h-3l-1-1.5H26v-4Zm-6.25 5.5H24V57h-8c0-1 1-4.5 3.75-4.5Z"
      clip-rule="evenodd"
    />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="3" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("a04bd", function(module, exports) {

$parcel$export(module.exports, "nounSvg", function () { return $747d2586ae76baf5$export$3bfdd1a0cad16fad; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $747d2586ae76baf5$export$3bfdd1a0cad16fad = (0, $B77rE.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#794CFF" rx="3" />
  <path
    fill="#987DE8"
    stroke="#fff"
    stroke-width="2"
    d="M33 22.5v-1H16v5H8.5V36H13v-5h3v7.5h17V31h1v7.5h17v-17H34v5h-1v-4Z"
  />
  <path fill="#fff" d="M37.5 25h10v10h-10z" />
  <path fill="#4019B2" d="M42.5 25h5v10h-5z" />
  <path fill="#fff" d="M19.5 25h10v10h-10z" />
  <path fill="#4019B2" d="M24.5 25h5v10h-5z" />
  <path fill="#fff" d="M12 30.5h4V37h-4v-6.5Z" />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("zifee", function(module, exports) {

$parcel$export(module.exports, "profileSvg", function () { return $06a16c003c614a55$export$f1a0ec1d6376e59; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $06a16c003c614a55$export$f1a0ec1d6376e59 = (0, $B77rE.svg)`<svg
  viewBox="0 0 60 60"
  fill="none"
>
  <g clip-path="url(#1)">
    <rect width="60" height="60" rx="30" fill="#00ACE6" />
    <path
      d="M59 73C59 89.0163 46.0163 102 30 102C13.9837 102 1 89.0163 1 73C1 56.9837 12 44 30 44C48 44 59 56.9837 59 73Z"
      fill="#1AC6FF"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M18.6904 19.9015C19.6264 15.3286 23.3466 11.8445 27.9708 11.2096C29.3231 11.024 30.6751 11.0238 32.0289 11.2096C36.6532 11.8445 40.3733 15.3286 41.3094 19.9015C41.4868 20.7681 41.6309 21.6509 41.7492 22.5271C41.8811 23.5041 41.8811 24.4944 41.7492 25.4715C41.6309 26.3476 41.4868 27.2304 41.3094 28.097C40.3733 32.6699 36.6532 36.154 32.0289 36.7889C30.6772 36.9744 29.3216 36.9743 27.9708 36.7889C23.3466 36.154 19.6264 32.6699 18.6904 28.097C18.513 27.2304 18.3689 26.3476 18.2506 25.4715C18.1186 24.4944 18.1186 23.5041 18.2506 22.5271C18.3689 21.6509 18.513 20.7681 18.6904 19.9015Z"
      fill="#1AC6FF"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="24.5" cy="23.5" r="1.5" fill="white" />
    <circle cx="35.5" cy="23.5" r="1.5" fill="white" />
    <path
      d="M31 20L28 28H32"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="white" stroke-opacity="0.1" />
  <defs>
    <clipPath id="1">
      <rect width="60" height="60" rx="30" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("8KK8R", function(module, exports) {

$parcel$export(module.exports, "systemSvg", function () { return $65f669713adb350b$export$5752b741a746ef10; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $65f669713adb350b$export$5752b741a746ef10 = (0, $B77rE.svg)`<svg viewBox="0 0 60 60" fill="none">
  <g clip-path="url(#1)">
    <path
      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"
      fill="#794CFF"
    />
    <path
      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"
      stroke="#062B2B"
      stroke-opacity="0.1"
    />
    <path
      d="M35.1403 31.5016C35.1193 30.9637 35.388 30.4558 35.8446 30.1707C36.1207 29.9982 36.4761 29.8473 36.7921 29.7685C37.3143 29.6382 37.8664 29.7977 38.2386 30.1864C38.8507 30.8257 39.3004 31.6836 39.8033 32.408C40.2796 33.0942 41.4695 33.2512 41.9687 32.5047C42.4839 31.7341 42.9405 30.8229 43.572 30.1399C43.9375 29.7447 44.4866 29.5756 45.0111 29.6967C45.3283 29.7701 45.6863 29.9147 45.9655 30.0823C46.4269 30.3595 46.7045 30.8626 46.6928 31.4008C46.6731 32.3083 46.3764 33.2571 46.2158 34.1473C46.061 35.0048 46.9045 35.8337 47.7592 35.664C48.6464 35.4878 49.5899 35.1747 50.497 35.1391C51.0348 35.1181 51.5427 35.3868 51.8279 35.8433C52.0004 36.1195 52.1513 36.4749 52.2301 36.7908C52.3604 37.3131 52.2009 37.8651 51.8121 38.2374C51.1729 38.8495 50.3151 39.2991 49.5908 39.8019C48.9046 40.2782 48.7473 41.4683 49.4939 41.9675C50.2644 42.4827 51.1757 42.9393 51.8587 43.5708C52.2539 43.9362 52.423 44.4854 52.3018 45.0099C52.2285 45.3271 52.0839 45.6851 51.9162 45.9642C51.6391 46.4257 51.1359 46.7032 50.5978 46.6916C49.6903 46.6719 48.7417 46.3753 47.8516 46.2146C46.9939 46.0598 46.1648 46.9035 46.3346 47.7583C46.5108 48.6454 46.8239 49.5888 46.8594 50.4958C46.8805 51.0336 46.6117 51.5415 46.1552 51.8267C45.879 51.9992 45.5236 52.15 45.2077 52.2289C44.6854 52.3592 44.1334 52.1997 43.7611 51.8109C43.1491 51.1718 42.6996 50.314 42.1968 49.5897C41.7203 48.9034 40.5301 48.7463 40.0309 49.493C39.5157 50.2634 39.0592 51.1746 38.4278 51.8574C38.0623 52.2527 37.5132 52.4218 36.9887 52.3006C36.6715 52.2273 36.3135 52.0826 36.0343 51.915C35.5729 51.6379 35.2953 51.1347 35.307 50.5966C35.3267 49.6891 35.6233 48.7405 35.7839 47.8505C35.9388 46.9928 35.0951 46.1636 34.2402 46.3334C33.3531 46.5096 32.4098 46.8227 31.5028 46.8582C30.9649 46.8793 30.457 46.6105 30.1719 46.154C29.9994 45.8778 29.8485 45.5224 29.7697 45.2065C29.6394 44.6842 29.7989 44.1322 30.1877 43.7599C30.8269 43.1479 31.6847 42.6982 32.4091 42.1954C33.0954 41.7189 33.2522 40.5289 32.5056 40.0297C31.7351 39.5145 30.824 39.058 30.1411 38.4265C29.7459 38.0611 29.5768 37.5119 29.698 36.9875C29.7713 36.6702 29.9159 36.3122 30.0836 36.0331C30.3607 35.5717 30.8638 35.2941 31.402 35.3058C32.3095 35.3255 33.2583 35.6221 34.1485 35.7828C35.006 35.9376 35.8349 35.094 35.6652 34.2393C35.489 33.3521 35.1759 32.4087 35.1403 31.5016Z"
      fill="#906EF7"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M20.7706 8.22357C20.9036 7.51411 21.5231 7 22.2449 7H23.7551C24.4769 7 25.0964 7.51411 25.2294 8.22357C25.5051 9.69403 25.4829 11.6321 27.1202 12.2606C27.3092 12.3331 27.4958 12.4105 27.6798 12.4926C29.2818 13.2072 30.6374 11.8199 31.8721 10.9752C32.4678 10.5676 33.2694 10.6421 33.7798 11.1525L34.8477 12.2204C35.3581 12.7308 35.4326 13.5323 35.025 14.128C34.1802 15.3627 32.7931 16.7183 33.5077 18.3202C33.5898 18.5043 33.6672 18.6909 33.7398 18.88C34.3683 20.5171 36.3061 20.4949 37.7764 20.7706C38.4859 20.9036 39 21.5231 39 22.2449V23.7551C39 24.4769 38.4859 25.0964 37.7764 25.2294C36.3061 25.5051 34.3685 25.483 33.7401 27.1201C33.6675 27.3093 33.59 27.4961 33.5079 27.6803C32.7934 29.282 34.1803 30.6374 35.025 31.8719C35.4326 32.4677 35.3581 33.2692 34.8477 33.7796L33.7798 34.8475C33.2694 35.3579 32.4678 35.4324 31.8721 35.0248C30.6376 34.1801 29.2823 32.7934 27.6806 33.508C27.4962 33.5903 27.3093 33.6678 27.12 33.7405C25.483 34.3688 25.5051 36.3062 25.2294 37.7764C25.0964 38.4859 24.4769 39 23.7551 39H22.2449C21.5231 39 20.9036 38.4859 20.7706 37.7764C20.4949 36.3062 20.517 34.3688 18.88 33.7405C18.6908 33.6678 18.5039 33.5903 18.3196 33.5081C16.7179 32.7936 15.3625 34.1804 14.1279 35.0251C13.5322 35.4327 12.7307 35.3582 12.2203 34.8478L11.1524 33.7799C10.642 33.2695 10.5675 32.4679 10.9751 31.8722C11.8198 30.6376 13.2067 29.2822 12.4922 27.6804C12.41 27.4962 12.3325 27.3093 12.2599 27.1201C11.6315 25.483 9.69392 25.5051 8.22357 25.2294C7.51411 25.0964 7 24.4769 7 23.7551V22.2449C7 21.5231 7.51411 20.9036 8.22357 20.7706C9.69394 20.4949 11.6317 20.5171 12.2602 18.88C12.3328 18.6909 12.4103 18.5042 12.4924 18.3201C13.207 16.7181 11.8198 15.3625 10.975 14.1278C10.5674 13.5321 10.6419 12.7305 11.1523 12.2201L12.2202 11.1522C12.7306 10.6418 13.5322 10.5673 14.1279 10.9749C15.3626 11.8197 16.7184 13.2071 18.3204 12.4925C18.5044 12.4105 18.6909 12.3331 18.8799 12.2606C20.5171 11.6321 20.4949 9.69403 20.7706 8.22357Z"
      fill="#906EF7"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="23" cy="23" r="6" fill="#794CFF" stroke="white" stroke-width="2" />
    <circle cx="41" cy="41" r="4" fill="#794CFF" stroke="white" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="1">
      <rect width="60" height="60" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("f0whZ", function(module, exports) {

$parcel$export(module.exports, "coinbaseSvg", function () { return $aecfe7120ed03a01$export$8661898196b83c8c; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $aecfe7120ed03a01$export$8661898196b83c8c = (0, $B77rE.svg)`<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <g clip-path="url(#clip0_187_29)">
    <path d="M1.18187e-05 15.8055C1.18187e-05 9.8015 -5.19442e-07 6.91338 1.69991e-08 0C4.5 3.72236e-05 9.62249 0 16.5 0L23.5 4.31399e-05C29.9349 4.31399e-05 35.5 0.000206332 40 3.73468e-05C40 2.77754 40 9.36708 40 15.8055V22.8364C40 29.2647 40 33.7962 40 40C31.5 40 29.8337 40 23.4 40H16.6C10.5092 40 6.50004 40 4.04289e-05 40C3.05176e-05 32.2453 1.18187e-05 29.6382 1.18187e-05 22.8364V15.8055Z" fill="#0052FF"/>
    <path d="M20.0236 26.5C16.4342 26.5 13.5236 23.5931 13.5236 20C13.5236 16.4069 16.4342 13.5 20.0236 13.5C23.2411 13.5 25.9134 15.8472 26.4261 18.9167H32.9731C32.4206 12.2433 26.8342 7 20.02 7C12.8411 7 7.02002 12.8211 7.02002 20C7.02002 27.1789 12.8411 33 20.02 33C26.8342 33 32.4206 27.7567 32.9731 21.0833H26.4225C25.9061 24.1528 23.2411 26.5 20.0236 26.5Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_187_29">
      <rect width="40" height="40" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

});

parcelRegister("cgTKA", function(module, exports) {

$parcel$export(module.exports, "moonpaySvg", function () { return $8ef23983c03e2763$export$a9ed45040996931e; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $8ef23983c03e2763$export$a9ed45040996931e = (0, $B77rE.svg)`
  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"
        fill="#7D00FF"
      />
      <path
        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"
        stroke="#fff"
        stroke-opacity=".05"
      />
      <path
        d="M28.306 15.381a3.69 3.69 0 1 0 0-7.381 3.69 3.69 0 0 0 0 7.381ZM16.987 32a8.991 8.991 0 1 1 .016-17.983A8.991 8.991 0 0 1 16.988 32Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    </defs>
  </svg>
`;

});

parcelRegister("cG0Ff", function(module, exports) {

$parcel$export(module.exports, "stripeSvg", function () { return $93a9ec357db0b45a$export$e3fac6a9cb8f9c7b; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $93a9ec357db0b45a$export$e3fac6a9cb8f9c7b = (0, $B77rE.svg)`
  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"
        fill="#635BFF"
      />
      <path
        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"
        stroke="#fff"
        stroke-opacity=".05"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.299 15.147c0-1.028.844-1.424 2.242-1.424 2.004 0 4.536.607 6.54 1.688V9.213C24.892 8.343 22.73 8 20.541 8c-5.354 0-8.915 2.796-8.915 7.464 0 7.279 10.022 6.118 10.022 9.257 0 1.213-1.055 1.609-2.531 1.609-2.19 0-4.985-.897-7.2-2.11v6.277a18.283 18.283 0 0 0 7.2 1.503c5.485 0 9.257-2.716 9.257-7.437-.027-7.86-10.075-6.462-10.075-9.416Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    </defs>
  </svg>
`;

});

parcelRegister("8pqNx", function(module, exports) {

$parcel$export(module.exports, "paypalSvg", function () { return $61f572095fef6c15$export$aa910b71a02cb299; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $61f572095fef6c15$export$aa910b71a02cb299 = (0, $B77rE.svg)`
  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"
        fill="#fff"
      />
      <path
        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"
        stroke="#fff"
        stroke-opacity=".05"
      />
      <path
        d="M18.606 12.642a.781.781 0 0 0-.771.66l-1.281 8.125a.78.78 0 0 1 .77-.66h3.755a7.668 7.668 0 0 0 7.57-6.49 6.26 6.26 0 0 0 .075-.843c-.96-.504-2.089-.792-3.325-.792h-6.793Z"
        fill="#001C64"
      />
      <path
        d="M28.724 13.434c-.006.282-.03.564-.075.843a7.668 7.668 0 0 1-7.57 6.491h-3.754a.78.78 0 0 0-.771.66l-1.916 12.15a.634.634 0 0 0 .626.734h4.075a.781.781 0 0 0 .77-.66l1.074-6.807a.781.781 0 0 1 .772-.66h2.4a7.668 7.668 0 0 0 7.57-6.491c.415-2.651-.92-5.064-3.201-6.26Z"
        fill="#0070E0"
      />
      <path
        d="M13.977 7.226a.78.78 0 0 0-.771.658l-3.198 20.277a.634.634 0 0 0 .626.733h4.742l1.178-7.467 1.281-8.125a.782.782 0 0 1 .771-.66H25.4c1.237 0 2.364.289 3.325.792.065-3.4-2.74-6.208-6.599-6.208h-8.148Z"
        fill="#003087"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    </defs>
  </svg>
`;

});

parcelRegister("i1BCz", function(module, exports) {

$parcel$export(module.exports, "onrampCardSvg", function () { return $d1f580bfcb36ea80$export$bfa60d0bcc3bcad2; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $d1f580bfcb36ea80$export$bfa60d0bcc3bcad2 = (0, $B77rE.svg)`<svg width="60" height="60" viewBox="0 0 60 60" fill="none">
<g clip-path="url(#clip0_13859_31161)">
  <path d="M0 24.8995C0 15.6481 0 11.0223 1.97053 7.56763C3.3015 5.2342 5.23468 3.30101 7.56812 1.97004C11.0228 -0.000488281 15.6485 -0.000488281 24.9 -0.000488281H35.1C44.3514 -0.000488281 48.9772 -0.000488281 52.4319 1.97004C54.7653 3.30101 56.6985 5.2342 58.0295 7.56763C60 11.0223 60 15.6481 60 24.8995V35.0995C60 44.351 60 48.9767 58.0295 52.4314C56.6985 54.7648 54.7653 56.698 52.4319 58.029C48.9772 59.9995 44.3514 59.9995 35.1 59.9995H24.9C15.6485 59.9995 11.0228 59.9995 7.56812 58.029C5.23468 56.698 3.3015 54.7648 1.97053 52.4314C0 48.9767 0 44.351 0 35.0995V24.8995Z" fill="#EB8B47"/>
  <path d="M0.5 24.8995C0.5 20.2647 0.50047 16.8216 0.744315 14.1045C0.987552 11.3941 1.46987 9.45455 2.40484 7.81536C3.69145 5.55971 5.56019 3.69096 7.81585 2.40435C9.45504 1.46938 11.3946 0.987064 14.105 0.743826C16.8221 0.499981 20.2652 0.499512 24.9 0.499512H35.1C39.7348 0.499512 43.1779 0.499981 45.895 0.743826C48.6054 0.987064 50.545 1.46938 52.1841 2.40435C54.4398 3.69096 56.3086 5.55971 57.5952 7.81536C58.5301 9.45455 59.0124 11.3941 59.2557 14.1045C59.4995 16.8216 59.5 20.2647 59.5 24.8995V35.0995C59.5 39.7343 59.4995 43.1774 59.2557 45.8945C59.0124 48.6049 58.5301 50.5445 57.5952 52.1837C56.3086 54.4393 54.4398 56.3081 52.1841 57.5947C50.545 58.5296 48.6054 59.012 45.895 59.2552C43.1779 59.499 39.7348 59.4995 35.1 59.4995H24.9C20.2652 59.4995 16.8221 59.499 14.105 59.2552C11.3946 59.012 9.45504 58.5296 7.81585 57.5947C5.56019 56.3081 3.69145 54.4393 2.40484 52.1837C1.46987 50.5445 0.987552 48.6049 0.744315 45.8945C0.50047 43.1774 0.5 39.7343 0.5 35.0995V24.8995Z" stroke="#141414" stroke-opacity="0.1"/>
  <path d="M13 26.0335C13 21.7838 13 19.659 14.0822 18.1694C14.4318 17.6883 14.8548 17.2653 15.3359 16.9157C16.8255 15.8335 18.9503 15.8335 23.2 15.8335H36.8C41.0497 15.8335 43.1745 15.8335 44.6641 16.9157C45.1452 17.2653 45.5682 17.6883 45.9178 18.1694C47 19.659 47 21.7838 47 26.0335V33.9668C47 38.2165 47 40.3414 45.9178 41.831C45.5682 42.312 45.1452 42.7351 44.6641 43.0846C43.1745 44.1668 41.0497 44.1668 36.8 44.1668H23.2C18.9503 44.1668 16.8255 44.1668 15.3359 43.0846C14.8548 42.7351 14.4318 42.312 14.0822 41.831C13 40.3414 13 38.2165 13 33.9668V26.0335Z" fill="#FF974C" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M39.5 36.667H36.6666" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M45.2 23.0645H14.8C14.0501 23.0645 13.6751 23.0645 13.4122 23.2554C13.3273 23.3171 13.2527 23.3918 13.191 23.4767C13 23.7395 13 24.1145 13 24.8645V27.2645C13 28.0144 13 28.3894 13.191 28.6522C13.2527 28.7371 13.3273 28.8118 13.4122 28.8735C13.6751 29.0645 14.0501 29.0645 14.8 29.0645H45.2C45.9499 29.0645 46.3249 29.0645 46.5878 28.8735C46.6727 28.8118 46.7473 28.7371 46.809 28.6522C47 28.3894 47 28.0144 47 27.2645V24.8645C47 24.1145 47 23.7395 46.809 23.4767C46.7473 23.3918 46.6727 23.3171 46.5878 23.2554C46.3249 23.0645 45.9499 23.0645 45.2 23.0645Z" fill="white" fill-opacity="0.4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
  <clipPath id="clip0_13859_31161">
    <rect width="60" height="60" fill="white"/>
  </clipPath>
</defs>
</svg>`;

});

parcelRegister("993kq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a87894df504e313$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $6a87894df504e313$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
    width: var(--local-size);
    height: var(--local-size);
  }

  :host svg {
    width: 100%;
    height: 100%;
  }
`;

});


parcelRegister("hY3Wq", function(module, exports) {

$parcel$export(module.exports, "WuiAccountButton", function () { return $d14b18ee837a0823$export$bfec9622ebde4e9e; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("aVsFR");
var $lC4jx = parcelRequire("lC4jx");
parcelRequire("62Qzz");
parcelRequire("7xM3j");
parcelRequire("276Mo");

var $cRWGJ = parcelRequire("cRWGJ");

var $fRkfl = parcelRequire("fRkfl");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("2Ecf9");
parcelRequire("9SgY8");

var $hkgA3 = parcelRequire("hkgA3");
var $d14b18ee837a0823$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d14b18ee837a0823$export$bfec9622ebde4e9e = class WuiAccountButton extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.networkSrc = undefined;
        this.avatarSrc = undefined;
        this.balance = undefined;
        this.isUnsupportedChain = undefined;
        this.disabled = false;
        this.isProfileName = false;
        this.address = "";
        this.charsStart = 4;
        this.charsEnd = 6;
    }
    render() {
        return (0, $B77rE.html)`
      <button
        ?disabled=${this.disabled}
        class=${(0, $lC4jx.ifDefined)(this.balance ? undefined : "local-no-balance")}
      >
        ${this.balanceTemplate()}
        <wui-flex gap="xxs" alignItems="center">
          <wui-avatar
            .imageSrc=${this.avatarSrc}
            alt=${this.address}
            address=${this.address}
          ></wui-avatar>
          <wui-text variant="paragraph-600" color="inherit">
            ${(0, $fRkfl.UiHelperUtil).getTruncateString({
            string: this.address,
            charsStart: this.isProfileName ? 18 : this.charsStart,
            charsEnd: this.isProfileName ? 0 : this.charsEnd,
            truncate: this.isProfileName ? "end" : "middle"
        })}
          </wui-text>
        </wui-flex>
      </button>
    `;
    }
    balanceTemplate() {
        if (this.isUnsupportedChain) return (0, $B77rE.html)` <wui-icon-box
          size="sm"
          iconColor="error-100"
          backgroundColor="error-100"
          icon="warningCircle"
        ></wui-icon-box>
        <wui-text variant="paragraph-600" color="inherit"> Switch Network</wui-text>`;
        if (this.balance) {
            const networkElement = this.networkSrc ? (0, $B77rE.html)`<wui-image src=${this.networkSrc}></wui-image>` : (0, $B77rE.html)`
            <wui-icon-box
              size="sm"
              iconColor="fg-200"
              backgroundColor="fg-300"
              icon="networkPlaceholder"
            ></wui-icon-box>
          `;
            return (0, $B77rE.html)`
        ${networkElement}
        <wui-text variant="paragraph-600" color="inherit"> ${this.balance} </wui-text>
      `;
        }
        return null;
    }
};
$d14b18ee837a0823$export$bfec9622ebde4e9e.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $hkgA3.default)
];
$d14b18ee837a0823$var$__decorate([
    (0, $cG9dN.property)()
], $d14b18ee837a0823$export$bfec9622ebde4e9e.prototype, "networkSrc", void 0);
$d14b18ee837a0823$var$__decorate([
    (0, $cG9dN.property)()
], $d14b18ee837a0823$export$bfec9622ebde4e9e.prototype, "avatarSrc", void 0);
$d14b18ee837a0823$var$__decorate([
    (0, $cG9dN.property)()
], $d14b18ee837a0823$export$bfec9622ebde4e9e.prototype, "balance", void 0);
$d14b18ee837a0823$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $d14b18ee837a0823$export$bfec9622ebde4e9e.prototype, "isUnsupportedChain", void 0);
$d14b18ee837a0823$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $d14b18ee837a0823$export$bfec9622ebde4e9e.prototype, "disabled", void 0);
$d14b18ee837a0823$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $d14b18ee837a0823$export$bfec9622ebde4e9e.prototype, "isProfileName", void 0);
$d14b18ee837a0823$var$__decorate([
    (0, $cG9dN.property)()
], $d14b18ee837a0823$export$bfec9622ebde4e9e.prototype, "address", void 0);
$d14b18ee837a0823$var$__decorate([
    (0, $cG9dN.property)()
], $d14b18ee837a0823$export$bfec9622ebde4e9e.prototype, "charsStart", void 0);
$d14b18ee837a0823$var$__decorate([
    (0, $cG9dN.property)()
], $d14b18ee837a0823$export$bfec9622ebde4e9e.prototype, "charsEnd", void 0);
$d14b18ee837a0823$export$bfec9622ebde4e9e = $d14b18ee837a0823$var$__decorate([
    (0, $3SCaV.customElement)("wui-account-button")
], $d14b18ee837a0823$export$bfec9622ebde4e9e);

});
parcelRegister("aVsFR", function(module, exports) {
$parcel$export(module.exports, "ifDefined", function () { return (parcelRequire("lC4jx")).ifDefined; });
parcelRequire("lC4jx");

});
parcelRegister("lC4jx", function(module, exports) {

$parcel$export(module.exports, "ifDefined", function () { return $fbc07e48bb154f5f$export$f68dd208b5df064d; });

var $B77rE = parcelRequire("B77rE");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fbc07e48bb154f5f$export$f68dd208b5df064d = (t)=>t ?? (0, $B77rE.nothing);

});


parcelRegister("276Mo", function(module, exports) {

$parcel$export(module.exports, "WuiFlex", function () { return $18a17e83e2ae6d5a$export$cb455767ea18ce95; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $cRWGJ = parcelRequire("cRWGJ");

var $fRkfl = parcelRequire("fRkfl");

var $3SCaV = parcelRequire("3SCaV");

var $1q1cl = parcelRequire("1q1cl");
var $18a17e83e2ae6d5a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $18a17e83e2ae6d5a$export$cb455767ea18ce95 = class WuiFlex extends (0, $75o4B.LitElement) {
    render() {
        this.style.cssText = `
      flex-direction: ${this.flexDirection};
      flex-wrap: ${this.flexWrap};
      flex-basis: ${this.flexBasis};
      flex-grow: ${this.flexGrow};
      flex-shrink: ${this.flexShrink};
      align-items: ${this.alignItems};
      justify-content: ${this.justifyContent};
      column-gap: ${this.columnGap && `var(--wui-spacing-${this.columnGap})`};
      row-gap: ${this.rowGap && `var(--wui-spacing-${this.rowGap})`};
      gap: ${this.gap && `var(--wui-spacing-${this.gap})`};
      padding-top: ${this.padding && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.padding, 0)};
      padding-right: ${this.padding && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.padding, 1)};
      padding-bottom: ${this.padding && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.padding, 2)};
      padding-left: ${this.padding && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.padding, 3)};
      margin-top: ${this.margin && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.margin, 0)};
      margin-right: ${this.margin && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.margin, 1)};
      margin-bottom: ${this.margin && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.margin, 2)};
      margin-left: ${this.margin && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.margin, 3)};
    `;
        return (0, $B77rE.html)`<slot></slot>`;
    }
};
$18a17e83e2ae6d5a$export$cb455767ea18ce95.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $1q1cl.default)
];
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "flexDirection", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "flexWrap", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "flexBasis", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "flexGrow", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "flexShrink", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "alignItems", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "justifyContent", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "columnGap", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "rowGap", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "gap", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "padding", void 0);
$18a17e83e2ae6d5a$var$__decorate([
    (0, $cG9dN.property)()
], $18a17e83e2ae6d5a$export$cb455767ea18ce95.prototype, "margin", void 0);
$18a17e83e2ae6d5a$export$cb455767ea18ce95 = $18a17e83e2ae6d5a$var$__decorate([
    (0, $3SCaV.customElement)("wui-flex")
], $18a17e83e2ae6d5a$export$cb455767ea18ce95);

});
parcelRegister("fRkfl", function(module, exports) {

$parcel$export(module.exports, "UiHelperUtil", function () { return $b8bb82c56bfd6edb$export$be769b74c01bc1bc; });
const $b8bb82c56bfd6edb$export$be769b74c01bc1bc = {
    getSpacingStyles (spacing, index) {
        if (Array.isArray(spacing)) return spacing[index] ? `var(--wui-spacing-${spacing[index]})` : undefined;
        else if (typeof spacing === "string") return `var(--wui-spacing-${spacing})`;
        return undefined;
    },
    getFormattedDate (date) {
        return new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric"
        }).format(date);
    },
    getHostName (url) {
        const newUrl = new URL(url);
        return newUrl.hostname;
    },
    getTruncateString ({ string: string, charsStart: charsStart, charsEnd: charsEnd, truncate: truncate }) {
        if (string.length <= charsStart + charsEnd) return string;
        if (truncate === "end") return `${string.substring(0, charsStart)}...`;
        else if (truncate === "start") return `...${string.substring(string.length - charsEnd)}`;
        return `${string.substring(0, Math.floor(charsStart))}...${string.substring(string.length - Math.floor(charsEnd))}`;
    },
    generateAvatarColors (address) {
        const hash = address.toLowerCase().replace(/^0x/iu, "");
        const baseColor = hash.substring(0, 6);
        const rgbColor = this.hexToRgb(baseColor);
        const masterBorderRadius = getComputedStyle(document.documentElement).getPropertyValue("--w3m-border-radius-master");
        const radius = Number(masterBorderRadius?.replace("px", ""));
        const edge = 100 - 3 * radius;
        const gradientCircle = `${edge}% ${edge}% at 65% 40%`;
        const colors = [];
        for(let i = 0; i < 5; i += 1){
            const tintedColor = this.tintColor(rgbColor, 0.15 * i);
            colors.push(`rgb(${tintedColor[0]}, ${tintedColor[1]}, ${tintedColor[2]})`);
        }
        return `
    --local-color-1: ${colors[0]};
    --local-color-2: ${colors[1]};
    --local-color-3: ${colors[2]};
    --local-color-4: ${colors[3]};
    --local-color-5: ${colors[4]};
    --local-radial-circle: ${gradientCircle}
   `;
    },
    hexToRgb (hex) {
        const bigint = parseInt(hex, 16);
        const r = bigint >> 16 & 255;
        const g = bigint >> 8 & 255;
        const b = bigint & 255;
        return [
            r,
            g,
            b
        ];
    },
    tintColor (rgb, tint) {
        const [r, g, b] = rgb;
        const tintedR = Math.round(r + (255 - r) * tint);
        const tintedG = Math.round(g + (255 - g) * tint);
        const tintedB = Math.round(b + (255 - b) * tint);
        return [
            tintedR,
            tintedG,
            tintedB
        ];
    },
    isNumber (character) {
        const regex = {
            number: /^[0-9]+$/u
        };
        return regex.number.test(character);
    },
    getColorTheme (theme) {
        if (theme) return theme;
        else if (typeof window !== "undefined" && window.matchMedia) {
            if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
            return "light";
        }
        return "dark";
    }
};

});

parcelRegister("1q1cl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1089260f8eeb0b9d$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $1089260f8eeb0b9d$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: flex;
    width: inherit;
    height: inherit;
  }
`;

});


parcelRegister("2Ecf9", function(module, exports) {

$parcel$export(module.exports, "WuiAvatar", function () { return $1ed8d07944d5072a$export$21cc36693be5eb11; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("62Qzz");

var $cRWGJ = parcelRequire("cRWGJ");

var $fRkfl = parcelRequire("fRkfl");

var $3SCaV = parcelRequire("3SCaV");

var $4AzXJ = parcelRequire("4AzXJ");
var $1ed8d07944d5072a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1ed8d07944d5072a$export$21cc36693be5eb11 = class WuiAvatar extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.alt = undefined;
        this.address = undefined;
    }
    render() {
        return (0, $B77rE.html)`${this.visualTemplate()}`;
    }
    visualTemplate() {
        if (this.imageSrc) {
            this.dataset["variant"] = "image";
            return (0, $B77rE.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "avatar"}></wui-image>`;
        } else if (this.address) {
            this.dataset["variant"] = "generated";
            const cssColors = (0, $fRkfl.UiHelperUtil).generateAvatarColors(this.address);
            this.style.cssText = cssColors;
            return null;
        }
        this.dataset["variant"] = "default";
        return null;
    }
};
$1ed8d07944d5072a$export$21cc36693be5eb11.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $4AzXJ.default)
];
$1ed8d07944d5072a$var$__decorate([
    (0, $cG9dN.property)()
], $1ed8d07944d5072a$export$21cc36693be5eb11.prototype, "imageSrc", void 0);
$1ed8d07944d5072a$var$__decorate([
    (0, $cG9dN.property)()
], $1ed8d07944d5072a$export$21cc36693be5eb11.prototype, "alt", void 0);
$1ed8d07944d5072a$var$__decorate([
    (0, $cG9dN.property)()
], $1ed8d07944d5072a$export$21cc36693be5eb11.prototype, "address", void 0);
$1ed8d07944d5072a$export$21cc36693be5eb11 = $1ed8d07944d5072a$var$__decorate([
    (0, $3SCaV.customElement)("wui-avatar")
], $1ed8d07944d5072a$export$21cc36693be5eb11);

});
parcelRegister("4AzXJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35766b98f8b2666d$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $35766b98f8b2666d$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
    width: var(--wui-icon-box-size-xl);
    height: var(--wui-icon-box-size-xl);
    border-radius: var(--wui-border-radius-3xl);
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    overflow: hidden;
    position: relative;
  }

  :host([data-variant='generated']) {
    --mixed-local-color-1: var(--local-color-1);
    --mixed-local-color-2: var(--local-color-2);
    --mixed-local-color-3: var(--local-color-3);
    --mixed-local-color-4: var(--local-color-4);
    --mixed-local-color-5: var(--local-color-5);
  }

  @supports (background: color-mix(in srgb, white 50%, black)) {
    :host([data-variant='generated']) {
      --mixed-local-color-1: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-1)
      );
      --mixed-local-color-2: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-2)
      );
      --mixed-local-color-3: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-3)
      );
      --mixed-local-color-4: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-4)
      );
      --mixed-local-color-5: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-5)
      );
    }
  }

  :host([data-variant='generated']) {
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    background: radial-gradient(
      var(--local-radial-circle),
      #fff 0.52%,
      var(--mixed-local-color-5) 31.25%,
      var(--mixed-local-color-3) 51.56%,
      var(--mixed-local-color-2) 65.63%,
      var(--mixed-local-color-1) 82.29%,
      var(--mixed-local-color-4) 100%
    );
  }

  :host([data-variant='default']) {
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    background: radial-gradient(
      75.29% 75.29% at 64.96% 24.36%,
      #fff 0.52%,
      #f5ccfc 31.25%,
      #dba4f5 51.56%,
      #9a8ee8 65.63%,
      #6493da 82.29%,
      #6ebdea 100%
    );
  }
`;

});


parcelRegister("9SgY8", function(module, exports) {

$parcel$export(module.exports, "WuiIconBox", function () { return $730651e231a971de$export$df20651935c1141; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $4gTPv = parcelRequire("4gTPv");
var $730651e231a971de$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $730651e231a971de$export$df20651935c1141 = class WuiIconBox extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.backgroundColor = "accent-100";
        this.iconColor = "accent-100";
        this.background = "transparent";
        this.border = false;
        this.borderColor = "wui-color-bg-125";
        this.icon = "copy";
    }
    render() {
        const iconSize = this.iconSize || this.size;
        const isLg = this.size === "lg";
        const isXl = this.size === "xl";
        const bgMix = isLg ? "12%" : "16%";
        const borderRadius = isLg ? "xxs" : isXl ? "s" : "3xl";
        const isGray = this.background === "gray";
        const isOpaque = this.background === "opaque";
        const isColorChange = this.backgroundColor === "accent-100" && isOpaque || this.backgroundColor === "success-100" && isOpaque || this.backgroundColor === "error-100" && isOpaque || this.backgroundColor === "inverse-100" && isOpaque;
        let bgValueVariable = `var(--wui-color-${this.backgroundColor})`;
        if (isColorChange) bgValueVariable = `var(--wui-icon-box-bg-${this.backgroundColor})`;
        else if (isGray) bgValueVariable = `var(--wui-gray-${this.backgroundColor})`;
        this.style.cssText = `
       --local-bg-value: ${bgValueVariable};
       --local-bg-mix: ${isColorChange || isGray ? `100%` : bgMix};
       --local-border-radius: var(--wui-border-radius-${borderRadius});
       --local-size: var(--wui-icon-box-size-${this.size});
       --local-border: ${this.borderColor === "wui-color-bg-125" ? `2px` : `1px`} solid ${this.border ? `var(--${this.borderColor})` : `transparent`}
   `;
        return (0, $B77rE.html)` <wui-icon color=${this.iconColor} size=${iconSize} name=${this.icon}></wui-icon> `;
    }
};
$730651e231a971de$export$df20651935c1141.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $4gTPv.default)
];
$730651e231a971de$var$__decorate([
    (0, $cG9dN.property)()
], $730651e231a971de$export$df20651935c1141.prototype, "size", void 0);
$730651e231a971de$var$__decorate([
    (0, $cG9dN.property)()
], $730651e231a971de$export$df20651935c1141.prototype, "backgroundColor", void 0);
$730651e231a971de$var$__decorate([
    (0, $cG9dN.property)()
], $730651e231a971de$export$df20651935c1141.prototype, "iconColor", void 0);
$730651e231a971de$var$__decorate([
    (0, $cG9dN.property)()
], $730651e231a971de$export$df20651935c1141.prototype, "iconSize", void 0);
$730651e231a971de$var$__decorate([
    (0, $cG9dN.property)()
], $730651e231a971de$export$df20651935c1141.prototype, "background", void 0);
$730651e231a971de$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $730651e231a971de$export$df20651935c1141.prototype, "border", void 0);
$730651e231a971de$var$__decorate([
    (0, $cG9dN.property)()
], $730651e231a971de$export$df20651935c1141.prototype, "borderColor", void 0);
$730651e231a971de$var$__decorate([
    (0, $cG9dN.property)()
], $730651e231a971de$export$df20651935c1141.prototype, "icon", void 0);
$730651e231a971de$export$df20651935c1141 = $730651e231a971de$var$__decorate([
    (0, $3SCaV.customElement)("wui-icon-box")
], $730651e231a971de$export$df20651935c1141);

});
parcelRegister("4gTPv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31c3f6ac9fdca34f$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $31c3f6ac9fdca34f$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    background-color: var(--wui-gray-glass-020);
    border-radius: var(--local-border-radius);
    border: var(--local-border);
    box-sizing: content-box;
    width: var(--local-size);
    height: var(--local-size);
    min-height: var(--local-size);
    min-width: var(--local-size);
  }

  @supports (background: color-mix(in srgb, white 50%, black)) {
    :host {
      background-color: color-mix(in srgb, var(--local-bg-value) var(--local-bg-mix), transparent);
    }
  }
`;

});


parcelRegister("hkgA3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9d12a796ec8d356$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $c9d12a796ec8d356$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
    background: var(--wui-gray-glass-002);
    display: flex;
    gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) var(--wui-spacing-3xs)
      var(--wui-spacing-xs);
    border: 1px solid var(--wui-gray-glass-005);
  }

  button:disabled {
    background: var(--wui-gray-glass-015);
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-flex > wui-text {
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-image,
  button:disabled > wui-icon-box,
  button:disabled > wui-flex > wui-avatar {
    filter: grayscale(1);
  }

  button:has(wui-image) {
    padding: var(--wui-spacing-3xs) var(--wui-spacing-3xs) var(--wui-spacing-3xs)
      var(--wui-spacing-xs);
  }

  wui-text {
    color: var(--wui-color-fg-100);
  }

  wui-flex > wui-text {
    color: var(--wui-color-fg-200);
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);
  }

  wui-image,
  wui-icon-box {
    border-radius: var(--wui-border-radius-3xl);
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  wui-flex {
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-005);
    background: var(--wui-gray-glass-005);
    padding: 4px var(--wui-spacing-m) 4px var(--wui-spacing-xxs);
  }

  button.local-no-balance {
    border-radius: 0px;
    border: none;
    background: transparent;
  }

  wui-avatar {
    width: 20px;
    height: 20px;
    box-shadow: 0 0 0 2px var(--wui-accent-glass-010);
  }

  @media (max-width: 500px) {
    button {
      gap: 0px;
      padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) !important;
      height: 32px;
    }
    wui-image,
    wui-icon-box,
    button > wui-text {
      visibility: hidden;
      width: 0px;
      height: 0px;
    }
    button {
      border-radius: 0px;
      border: none;
      background: transparent;
      padding: 0px;
    }
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled > wui-flex > wui-text {
      color: var(--wui-color-fg-175);
    }

    button:active:enabled > wui-flex > wui-text {
      color: var(--wui-color-fg-175);
    }
  }
`;

});


parcelRegister("QXOPA", function(module, exports) {

$parcel$export(module.exports, "WuiAllWalletsImage", function () { return $09f34238da479bb2$export$92558ad1dd06e644; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("aVsFR");
var $lC4jx = parcelRequire("lC4jx");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("cvCkY");
parcelRequire("9SgY8");

var $bpEQm = parcelRequire("bpEQm");
var $09f34238da479bb2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $09f34238da479bb2$var$TOTAL_IMAGES = 4;
let $09f34238da479bb2$export$92558ad1dd06e644 = class WuiAllWalletsImage extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.walletImages = [];
    }
    render() {
        const isPlaceholders = this.walletImages.length < $09f34238da479bb2$var$TOTAL_IMAGES;
        return (0, $B77rE.html)`${this.walletImages.slice(0, $09f34238da479bb2$var$TOTAL_IMAGES).map(({ src: src, walletName: walletName })=>(0, $B77rE.html)`
            <wui-wallet-image
              size="inherit"
              imageSrc=${src}
              name=${(0, $lC4jx.ifDefined)(walletName)}
            ></wui-wallet-image>
          `)}
      ${isPlaceholders ? [
            ...Array($09f34238da479bb2$var$TOTAL_IMAGES - this.walletImages.length)
        ].map(()=>(0, $B77rE.html)` <wui-wallet-image size="inherit" name=""></wui-wallet-image>`) : null}
      <wui-flex>
        <wui-icon-box
          size="xxs"
          iconSize="xxs"
          iconcolor="success-100"
          backgroundcolor="success-100"
          icon="checkmark"
          background="opaque"
        ></wui-icon-box>
      </wui-flex>`;
    }
};
$09f34238da479bb2$export$92558ad1dd06e644.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $bpEQm.default)
];
$09f34238da479bb2$var$__decorate([
    (0, $cG9dN.property)({
        type: Array
    })
], $09f34238da479bb2$export$92558ad1dd06e644.prototype, "walletImages", void 0);
$09f34238da479bb2$export$92558ad1dd06e644 = $09f34238da479bb2$var$__decorate([
    (0, $3SCaV.customElement)("wui-all-wallets-image")
], $09f34238da479bb2$export$92558ad1dd06e644);

});
parcelRegister("cvCkY", function(module, exports) {

$parcel$export(module.exports, "WuiWalletImage", function () { return $91b61e439962e8bd$export$2df48f4f4e74a226; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("62Qzz");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("9SgY8");

var $gpCc4 = parcelRequire("gpCc4");
var $91b61e439962e8bd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $91b61e439962e8bd$export$2df48f4f4e74a226 = class WuiWalletImage extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "";
        this.installed = false;
        this.badgeSize = "xs";
    }
    render() {
        let borderRadius = "xxs";
        if (this.size === "lg") borderRadius = "m";
        else if (this.size === "md") borderRadius = "xs";
        else borderRadius = "xxs";
        this.style.cssText = `
       --local-border-radius: var(--wui-border-radius-${borderRadius});
       --local-size: var(--wui-wallet-image-size-${this.size});
   `;
        if (this.walletIcon) this.dataset["walletIcon"] = this.walletIcon;
        return (0, $B77rE.html)`
      <wui-flex justifyContent="center" alignItems="center"> ${this.templateVisual()} </wui-flex>
    `;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $B77rE.html)`<wui-image src=${this.imageSrc} alt=${this.name}></wui-image>`;
        else if (this.walletIcon) return (0, $B77rE.html)`<wui-icon
        data-parent-size="md"
        size="md"
        color="inherit"
        name=${this.walletIcon}
      ></wui-icon>`;
        return (0, $B77rE.html)`<wui-icon
      data-parent-size=${this.size}
      size="inherit"
      color="inherit"
      name="walletPlaceholder"
    ></wui-icon>`;
    }
};
$91b61e439962e8bd$export$2df48f4f4e74a226.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $gpCc4.default)
];
$91b61e439962e8bd$var$__decorate([
    (0, $cG9dN.property)()
], $91b61e439962e8bd$export$2df48f4f4e74a226.prototype, "size", void 0);
$91b61e439962e8bd$var$__decorate([
    (0, $cG9dN.property)()
], $91b61e439962e8bd$export$2df48f4f4e74a226.prototype, "name", void 0);
$91b61e439962e8bd$var$__decorate([
    (0, $cG9dN.property)()
], $91b61e439962e8bd$export$2df48f4f4e74a226.prototype, "imageSrc", void 0);
$91b61e439962e8bd$var$__decorate([
    (0, $cG9dN.property)()
], $91b61e439962e8bd$export$2df48f4f4e74a226.prototype, "walletIcon", void 0);
$91b61e439962e8bd$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $91b61e439962e8bd$export$2df48f4f4e74a226.prototype, "installed", void 0);
$91b61e439962e8bd$var$__decorate([
    (0, $cG9dN.property)()
], $91b61e439962e8bd$export$2df48f4f4e74a226.prototype, "badgeSize", void 0);
$91b61e439962e8bd$export$2df48f4f4e74a226 = $91b61e439962e8bd$var$__decorate([
    (0, $3SCaV.customElement)("wui-wallet-image")
], $91b61e439962e8bd$export$2df48f4f4e74a226);

});
parcelRegister("gpCc4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf2c9ba210e79d45$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $bf2c9ba210e79d45$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    background-color: var(--wui-gray-glass-002);
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--local-size);
    height: var(--local-size);
    border-radius: inherit;
    border-radius: var(--local-border-radius);
  }

  :host > wui-flex {
    overflow: hidden;
    border-radius: inherit;
    border-radius: var(--local-border-radius);
  }

  :host::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  :host([name='Extension'])::after {
    border: 1px solid var(--wui-accent-glass-010);
  }

  :host([data-wallet-icon='allWallets']) {
    background-color: var(--wui-all-wallets-bg-100);
  }

  :host([data-wallet-icon='allWallets'])::after {
    border: 1px solid var(--wui-accent-glass-010);
  }

  wui-icon[data-parent-size='inherit'] {
    width: 75%;
    height: 75%;
    align-items: center;
  }

  wui-icon[data-parent-size='sm'] {
    width: 18px;
    height: 18px;
  }

  wui-icon[data-parent-size='md'] {
    width: 24px;
    height: 24px;
  }

  wui-icon[data-parent-size='lg'] {
    width: 42px;
    height: 42px;
  }

  wui-icon[data-parent-size='full'] {
    width: 100%;
    height: 100%;
  }

  :host > wui-icon-box {
    position: absolute;
    overflow: hidden;
    right: -1px;
    bottom: -2px;
    z-index: 1;
    border: 2px solid var(--wui-color-bg-base-150, #1e1f1f);
    padding: 1px;
  }
`;

});


parcelRegister("bpEQm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84f1b62f7f11a485$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $84f1b62f7f11a485$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    border-radius: var(--wui-border-radius-xxs);
    width: 40px;
    height: 40px;
    overflow: hidden;
    background: var(--wui-gray-glass-002);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--wui-spacing-4xs);
    padding: 3.75px !important;
  }

  :host::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  :host > wui-wallet-image {
    width: 14px;
    height: 14px;
    border-radius: var(--wui-border-radius-5xs);
  }

  :host > wui-flex {
    padding: 2px;
    position: fixed;
    overflow: hidden;
    left: 34px;
    bottom: 8px;
    background: var(--dark-background-150, #1e1f1f);
    border-radius: 50%;
    z-index: 2;
    display: flex;
  }
`;

});


parcelRegister("46WDJ", function(module, exports) {

$parcel$export(module.exports, "WuiButton", function () { return $2fe535a31027da88$export$5496564a8aaab1b8; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("avm78");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $7tOna = parcelRequire("7tOna");
var $2fe535a31027da88$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $2fe535a31027da88$var$TEXT_VARIANT_BY_SIZE = {
    xs: "small-600",
    sm: "paragraph-600",
    md: "small-600",
    mdl: "small-600",
    lg: "paragraph-600"
};
let $2fe535a31027da88$export$5496564a8aaab1b8 = class WuiButton extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.disabled = false;
        this.fullWidth = false;
        this.loading = false;
        this.variant = "fill";
        this.hasIconLeft = false;
        this.hasIconRight = false;
        this.borderRadius = "m";
    }
    render() {
        this.style.cssText = `
    --local-width: ${this.fullWidth ? "100%" : "auto"};
    --local-opacity-100: ${this.loading ? 0 : 1};
    --local-opacity-000: ${this.loading ? 1 : 0};
    --local-border-radius: var(--wui-border-radius-${this.borderRadius});
    `;
        const textVariant = this.textVariant ?? $2fe535a31027da88$var$TEXT_VARIANT_BY_SIZE[this.size];
        return (0, $B77rE.html)`
      <button
        data-variant=${this.variant}
        data-icon-left=${this.hasIconLeft}
        data-icon-right=${this.hasIconRight}
        data-size=${this.size}
        ?disabled=${this.disabled || this.loading}
        ontouchstart
      >
        ${this.loadingTemplate()}
        <slot name="iconLeft" @slotchange=${()=>this.handleSlotLeftChange()}></slot>
        <wui-text variant=${textVariant} color="inherit">
          <slot></slot>
        </wui-text>
        <slot name="iconRight" @slotchange=${()=>this.handleSlotRightChange()}></slot>
      </button>
    `;
    }
    handleSlotLeftChange() {
        this.hasIconLeft = true;
    }
    handleSlotRightChange() {
        this.hasIconRight = true;
    }
    loadingTemplate() {
        if (this.loading) return (0, $B77rE.html)`<wui-loading-spinner color="fg-300"></wui-loading-spinner>`;
        return (0, $B77rE.html)``;
    }
};
$2fe535a31027da88$export$5496564a8aaab1b8.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $7tOna.default)
];
$2fe535a31027da88$var$__decorate([
    (0, $cG9dN.property)()
], $2fe535a31027da88$export$5496564a8aaab1b8.prototype, "size", void 0);
$2fe535a31027da88$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $2fe535a31027da88$export$5496564a8aaab1b8.prototype, "disabled", void 0);
$2fe535a31027da88$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $2fe535a31027da88$export$5496564a8aaab1b8.prototype, "fullWidth", void 0);
$2fe535a31027da88$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $2fe535a31027da88$export$5496564a8aaab1b8.prototype, "loading", void 0);
$2fe535a31027da88$var$__decorate([
    (0, $cG9dN.property)()
], $2fe535a31027da88$export$5496564a8aaab1b8.prototype, "variant", void 0);
$2fe535a31027da88$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $2fe535a31027da88$export$5496564a8aaab1b8.prototype, "hasIconLeft", void 0);
$2fe535a31027da88$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $2fe535a31027da88$export$5496564a8aaab1b8.prototype, "hasIconRight", void 0);
$2fe535a31027da88$var$__decorate([
    (0, $cG9dN.property)()
], $2fe535a31027da88$export$5496564a8aaab1b8.prototype, "borderRadius", void 0);
$2fe535a31027da88$var$__decorate([
    (0, $cG9dN.property)()
], $2fe535a31027da88$export$5496564a8aaab1b8.prototype, "textVariant", void 0);
$2fe535a31027da88$export$5496564a8aaab1b8 = $2fe535a31027da88$var$__decorate([
    (0, $3SCaV.customElement)("wui-button")
], $2fe535a31027da88$export$5496564a8aaab1b8);

});
parcelRegister("7tOna", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $572250cb72950ecc$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $572250cb72950ecc$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    width: var(--local-width);
    position: relative;
  }

  button {
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--local-border-radius);
    width: var(--local-width);
  }

  button:disabled {
    border: 1px solid var(--wui-gray-glass-010);
  }

  /* xs settings */
  button[data-size='xs'] {
    padding: var(--wui-spacing-xs) var(--wui-spacing-1xs);
  }

  button[data-size='xs'][data-icon-left='true'][data-icon-right='false'] {
    padding-left: var(--wui-spacing-xxs);
  }

  button[data-size='xs'][data-icon-right='true'][data-icon-left='false'] {
    padding-right: var(--wui-spacing-xxs);
  }

  /* sm settings */
  button[data-size='sm'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-s);
  }

  button[data-size='sm'][data-icon-left='true'][data-icon-right='false'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-s) var(--wui-spacing-xxs)
      var(--wui-spacing-xs);
  }

  button[data-size='sm'][data-icon-right='true'][data-icon-left='false'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-xs) var(--wui-spacing-xxs)
      var(--wui-spacing-s);
  }

  /* md settings */
  button[data-size='md'] {
    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-l);
  }

  button[data-size='md'][data-icon-left='true'][data-icon-right='false'] {
    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-s);
  }

  button[data-size='md'][data-icon-right='true'][data-icon-left='false'] {
    padding: 8.2px var(--wui-spacing-s) 9px var(--wui-spacing-l);
  }

  /* lg settings */
  button[data-size='lg'] {
    padding: var(--wui-spacing-m) var(--wui-spacing-2l);
  }

  button[data-size='lg'][data-icon-left='true'][data-icon-right='false'] {
    padding-left: var(--wui-spacing-m);
  }

  button[data-size='lg'][data-icon-right='true'][data-icon-left='false'] {
    padding-right: var(--wui-spacing-m);
  }

  button > wui-text {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  ::slotted(*) {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  wui-loading-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transition: all 200ms ease-in-out;
    transform: translate(-50%, -50%);
    opacity: var(--local-opacity-000);
  }
`;

});


parcelRegister("eqei8", function(module, exports) {

$parcel$export(module.exports, "WuiCardSelectLoader", function () { return $a7fe9469ed938abc$export$fc388e944144bd3a; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $lEK4b = parcelRequire("lEK4b");
parcelRequire("2SjI8");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $5dniJ = parcelRequire("5dniJ");
var $a7fe9469ed938abc$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a7fe9469ed938abc$export$fc388e944144bd3a = class WuiCardSelectLoader extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.type = "wallet";
    }
    render() {
        return (0, $B77rE.html)`
      ${this.shimmerTemplate()}
      <wui-shimmer width="56px" height="20px" borderRadius="xs"></wui-shimmer>
    `;
    }
    shimmerTemplate() {
        if (this.type === "network") return (0, $B77rE.html)` <wui-shimmer
          data-type=${this.type}
          width="48px"
          height="54px"
          borderRadius="xs"
        ></wui-shimmer>
        ${0, $lEK4b.networkSvgMd}`;
        return (0, $B77rE.html)`<wui-shimmer width="56px" height="56px" borderRadius="xs"></wui-shimmer>`;
    }
};
$a7fe9469ed938abc$export$fc388e944144bd3a.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $5dniJ.default)
];
$a7fe9469ed938abc$var$__decorate([
    (0, $cG9dN.property)()
], $a7fe9469ed938abc$export$fc388e944144bd3a.prototype, "type", void 0);
$a7fe9469ed938abc$export$fc388e944144bd3a = $a7fe9469ed938abc$var$__decorate([
    (0, $3SCaV.customElement)("wui-card-select-loader")
], $a7fe9469ed938abc$export$fc388e944144bd3a);

});
parcelRegister("lEK4b", function(module, exports) {

$parcel$export(module.exports, "networkSvgMd", function () { return $fc41113d070bb6cd$export$711c5994129523c4; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $fc41113d070bb6cd$export$711c5994129523c4 = (0, $B77rE.svg)`<svg  viewBox="0 0 48 54" fill="none">
  <path
    d="M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z"
  />
</svg>`;

});

parcelRegister("5dniJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cc03dc5ed256804$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $3cc03dc5ed256804$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) 10px;
    background-color: var(--wui-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
    position: relative;
  }

  wui-shimmer[data-type='network'] {
    border: none;
    -webkit-clip-path: var(--wui-path-network);
    clip-path: var(--wui-path-network);
  }

  svg {
    position: absolute;
    width: 48px;
    height: 54px;
    z-index: 1;
  }

  svg > path {
    stroke: var(--wui-gray-glass-010);
    stroke-width: 1px;
  }
`;

});


parcelRegister("idObs", function(module, exports) {

$parcel$export(module.exports, "WuiCardSelect", function () { return $d4405e5cb1c44c74$export$815c16e0af51756a; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("aVsFR");
var $lC4jx = parcelRequire("lC4jx");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("hnysB");
parcelRequire("cvCkY");

var $so0bo = parcelRequire("so0bo");
var $d4405e5cb1c44c74$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d4405e5cb1c44c74$export$815c16e0af51756a = class WuiCardSelect extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.name = "Unknown";
        this.type = "wallet";
        this.imageSrc = undefined;
        this.disabled = false;
        this.selected = false;
        this.installed = false;
    }
    render() {
        return (0, $B77rE.html)`
      <button data-selected=${(0, $lC4jx.ifDefined)(this.selected)} ?disabled=${this.disabled} ontouchstart>
        ${this.imageTemplate()}
        <wui-text variant="tiny-500" color=${this.selected ? "accent-100" : "inherit"}>
          ${this.name}
        </wui-text>
      </button>
    `;
    }
    imageTemplate() {
        if (this.type === "network") return (0, $B77rE.html)`
        <wui-network-image
          .selected=${this.selected}
          imageSrc=${(0, $lC4jx.ifDefined)(this.imageSrc)}
          name=${this.name}
        >
        </wui-network-image>
      `;
        return (0, $B77rE.html)`
      <wui-wallet-image
        size="md"
        imageSrc=${(0, $lC4jx.ifDefined)(this.imageSrc)}
        name=${this.name}
        .installed=${this.installed}
        badgeSize="sm"
      >
      </wui-wallet-image>
    `;
    }
};
$d4405e5cb1c44c74$export$815c16e0af51756a.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $so0bo.default)
];
$d4405e5cb1c44c74$var$__decorate([
    (0, $cG9dN.property)()
], $d4405e5cb1c44c74$export$815c16e0af51756a.prototype, "name", void 0);
$d4405e5cb1c44c74$var$__decorate([
    (0, $cG9dN.property)()
], $d4405e5cb1c44c74$export$815c16e0af51756a.prototype, "type", void 0);
$d4405e5cb1c44c74$var$__decorate([
    (0, $cG9dN.property)()
], $d4405e5cb1c44c74$export$815c16e0af51756a.prototype, "imageSrc", void 0);
$d4405e5cb1c44c74$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $d4405e5cb1c44c74$export$815c16e0af51756a.prototype, "disabled", void 0);
$d4405e5cb1c44c74$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $d4405e5cb1c44c74$export$815c16e0af51756a.prototype, "selected", void 0);
$d4405e5cb1c44c74$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $d4405e5cb1c44c74$export$815c16e0af51756a.prototype, "installed", void 0);
$d4405e5cb1c44c74$export$815c16e0af51756a = $d4405e5cb1c44c74$var$__decorate([
    (0, $3SCaV.customElement)("wui-card-select")
], $d4405e5cb1c44c74$export$815c16e0af51756a);

});
parcelRegister("hnysB", function(module, exports) {

$parcel$export(module.exports, "WuiNetworkImage", function () { return $ca6f50c28485b248$export$4dc5510728d31c71; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $8zAcp = parcelRequire("8zAcp");

var $lEK4b = parcelRequire("lEK4b");

var $h8yzE = parcelRequire("h8yzE");
parcelRequire("iVPOS");
parcelRequire("62Qzz");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $bFC2I = parcelRequire("bFC2I");
var $ca6f50c28485b248$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ca6f50c28485b248$export$4dc5510728d31c71 = class WuiNetworkImage extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "uknown";
        this.selected = false;
    }
    render() {
        const networkImagesBySize = {
            sm: (0, $8zAcp.networkSvgSm),
            md: (0, $lEK4b.networkSvgMd),
            lg: (0, $h8yzE.networkSvgLg)
        };
        this.style.cssText = `
      --local-stroke: ${this.selected ? "var(--wui-color-accent-100)" : "var(--wui-gray-glass-010)"};
      --local-path: var(--wui-path-network-${this.size});
      --local-width:  var(--wui-width-network-${this.size});
      --local-height:  var(--wui-height-network-${this.size});
      --local-icon-size:  var(--wui-icon-size-network-${this.size});
    `;
        return (0, $B77rE.html)`${this.templateVisual()} ${networkImagesBySize[this.size]}`;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $B77rE.html)`<wui-image src=${this.imageSrc} alt=${this.name}></wui-image>`;
        return (0, $B77rE.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$ca6f50c28485b248$export$4dc5510728d31c71.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $bFC2I.default)
];
$ca6f50c28485b248$var$__decorate([
    (0, $cG9dN.property)()
], $ca6f50c28485b248$export$4dc5510728d31c71.prototype, "size", void 0);
$ca6f50c28485b248$var$__decorate([
    (0, $cG9dN.property)()
], $ca6f50c28485b248$export$4dc5510728d31c71.prototype, "name", void 0);
$ca6f50c28485b248$var$__decorate([
    (0, $cG9dN.property)()
], $ca6f50c28485b248$export$4dc5510728d31c71.prototype, "imageSrc", void 0);
$ca6f50c28485b248$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $ca6f50c28485b248$export$4dc5510728d31c71.prototype, "selected", void 0);
$ca6f50c28485b248$export$4dc5510728d31c71 = $ca6f50c28485b248$var$__decorate([
    (0, $3SCaV.customElement)("wui-network-image")
], $ca6f50c28485b248$export$4dc5510728d31c71);

});
parcelRegister("8zAcp", function(module, exports) {

$parcel$export(module.exports, "networkSvgSm", function () { return $63ddac0077012148$export$a36e707df42c73a2; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $63ddac0077012148$export$a36e707df42c73a2 = (0, $B77rE.svg)`
  <svg fill="none" viewBox="0 0 36 40">
    <path
      d="M15.4 2.1a5.21 5.21 0 0 1 5.2 0l11.61 6.7a5.21 5.21 0 0 1 2.61 4.52v13.4c0 1.87-1 3.59-2.6 4.52l-11.61 6.7c-1.62.93-3.6.93-5.22 0l-11.6-6.7a5.21 5.21 0 0 1-2.61-4.51v-13.4c0-1.87 1-3.6 2.6-4.52L15.4 2.1Z"
    />
  </svg>
`;

});

parcelRegister("h8yzE", function(module, exports) {

$parcel$export(module.exports, "networkSvgLg", function () { return $c79e00adf67e9193$export$d2869a6a8000adfa; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
const $c79e00adf67e9193$export$d2869a6a8000adfa = (0, $B77rE.svg)`<svg width="86" height="96" fill="none">
  <path
    d="M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z"
  />
</svg>`;

});

parcelRegister("bFC2I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87f1088bf1b35d4a$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $87f1088bf1b35d4a$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--local-width);
    height: var(--local-height);
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    fill: var(--wui-gray-glass-002);
  }

  svg > path {
    stroke: var(--local-stroke);
    transition: stroke var(--wui-ease-out-power-1) var(--wui-duration-lg);
  }

  wui-image {
    width: 100%;
    height: 100%;
    -webkit-clip-path: var(--local-path);
    clip-path: var(--local-path);
    background: var(--wui-gray-glass-002);
  }

  wui-icon {
    transform: translateY(-5%);
    width: var(--local-icon-size);
    height: var(--local-icon-size);
  }
`;

});


parcelRegister("so0bo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05553bed3f18b8eb$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $05553bed3f18b8eb$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  button {
    flex-direction: column;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) var(--wui-spacing-0);
    background-color: var(--wui-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
  }

  button > wui-text {
    color: var(--wui-color-fg-100);
    max-width: var(--wui-icon-box-size-xl);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: center;
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  [data-selected='true'] {
    background-color: var(--wui-accent-glass-020);
  }

  @media (hover: hover) and (pointer: fine) {
    [data-selected='true']:hover:enabled {
      background-color: var(--wui-accent-glass-015);
    }
  }

  [data-selected='true']:active:enabled {
    background-color: var(--wui-accent-glass-010);
  }
`;

});


parcelRegister("7WcdO", function(module, exports) {

$parcel$export(module.exports, "WuiChip", function () { return $5c776e27eaea4cbf$export$418286c4c7ff87c6; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("62Qzz");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $fRkfl = parcelRequire("fRkfl");

var $3SCaV = parcelRequire("3SCaV");

var $523Bn = parcelRequire("523Bn");
var $5c776e27eaea4cbf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5c776e27eaea4cbf$export$418286c4c7ff87c6 = class WuiChip extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "fill";
        this.imageSrc = undefined;
        this.disabled = false;
        this.icon = "externalLink";
        this.href = "";
        this.text = undefined;
    }
    render() {
        const isSmall = this.variant === "success" || this.variant === "transparent" || this.variant === "shadeSmall";
        const textVariant = isSmall ? "small-600" : "paragraph-600";
        return (0, $B77rE.html)`
      <a
        rel="noreferrer"
        target="_blank"
        href=${this.href}
        class=${this.disabled ? "disabled" : ""}
        data-variant=${this.variant}
      >
        ${this.imageTemplate()}
        <wui-text variant=${textVariant} color="inherit">
          ${this.title ? this.title : (0, $fRkfl.UiHelperUtil).getHostName(this.href)}
        </wui-text>
        <wui-icon name=${this.icon} color="inherit" size="inherit"></wui-icon>
      </a>
    `;
    }
    imageTemplate() {
        if (this.imageSrc) return (0, $B77rE.html)`<wui-image src=${this.imageSrc}></wui-image>`;
        return null;
    }
};
$5c776e27eaea4cbf$export$418286c4c7ff87c6.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $523Bn.default)
];
$5c776e27eaea4cbf$var$__decorate([
    (0, $cG9dN.property)()
], $5c776e27eaea4cbf$export$418286c4c7ff87c6.prototype, "variant", void 0);
$5c776e27eaea4cbf$var$__decorate([
    (0, $cG9dN.property)()
], $5c776e27eaea4cbf$export$418286c4c7ff87c6.prototype, "imageSrc", void 0);
$5c776e27eaea4cbf$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $5c776e27eaea4cbf$export$418286c4c7ff87c6.prototype, "disabled", void 0);
$5c776e27eaea4cbf$var$__decorate([
    (0, $cG9dN.property)()
], $5c776e27eaea4cbf$export$418286c4c7ff87c6.prototype, "icon", void 0);
$5c776e27eaea4cbf$var$__decorate([
    (0, $cG9dN.property)()
], $5c776e27eaea4cbf$export$418286c4c7ff87c6.prototype, "href", void 0);
$5c776e27eaea4cbf$var$__decorate([
    (0, $cG9dN.property)()
], $5c776e27eaea4cbf$export$418286c4c7ff87c6.prototype, "text", void 0);
$5c776e27eaea4cbf$export$418286c4c7ff87c6 = $5c776e27eaea4cbf$var$__decorate([
    (0, $3SCaV.customElement)("wui-chip")
], $5c776e27eaea4cbf$export$418286c4c7ff87c6);

});
parcelRegister("523Bn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a9feee738d1e3d4$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $3a9feee738d1e3d4$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  a {
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-image {
    border-radius: var(--wui-border-radius-3xl);
    overflow: hidden;
  }

  a.disabled > wui-icon,
  a.disabled > wui-image {
    filter: grayscale(1);
  }

  a[data-variant='fill'] {
    color: var(--wui-color-inverse-100);
    background-color: var(--wui-color-accent-100);
  }

  a[data-variant='shade'],
  a[data-variant='shadeSmall'] {
    background-color: transparent;
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-200);
  }

  a[data-variant='success'] {
    column-gap: var(--wui-spacing-xxs);
    border: 1px solid var(--wui-success-glass-010);
    background-color: var(--wui-success-glass-010);
    color: var(--wui-color-success-100);
  }

  a[data-variant='error'] {
    column-gap: var(--wui-spacing-xxs);
    border: 1px solid var(--wui-error-glass-010);
    background-color: var(--wui-error-glass-010);
    color: var(--wui-color-error-100);
  }

  a[data-variant='transparent'] {
    column-gap: var(--wui-spacing-xxs);
    background-color: transparent;
    color: var(--wui-color-fg-150);
  }

  a[data-variant='transparent'],
  a[data-variant='success'],
  a[data-variant='shadeSmall'],
  a[data-variant='error'] {
    padding: 7px var(--wui-spacing-s) 7px 10px;
  }

  a[data-variant='transparent']:has(wui-text:first-child),
  a[data-variant='success']:has(wui-text:first-child),
  a[data-variant='shadeSmall']:has(wui-text:first-child),
  a[data-variant='error']:has(wui-text:first-child) {
    padding: 7px var(--wui-spacing-s);
  }

  a[data-variant='fill'],
  a[data-variant='shade'] {
    column-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-xxs)
      var(--wui-spacing-xs);
  }

  a[data-variant='fill']:has(wui-text:first-child),
  a[data-variant='shade']:has(wui-text:first-child) {
    padding: 9px var(--wui-spacing-m) 9px var(--wui-spacing-m);
  }

  a[data-variant='fill'] > wui-image,
  a[data-variant='shade'] > wui-image {
    width: 24px;
    height: 24px;
  }

  a[data-variant='fill'] > wui-image {
    box-shadow: inset 0 0 0 1px var(--wui-color-accent-090);
  }

  a[data-variant='shade'] > wui-image,
  a[data-variant='shadeSmall'] > wui-image {
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-010);
  }

  a[data-variant='fill'] > wui-icon,
  a[data-variant='shade'] > wui-icon {
    width: 14px;
    height: 14px;
  }

  a[data-variant='transparent'] > wui-image,
  a[data-variant='success'] > wui-image,
  a[data-variant='shadeSmall'] > wui-image,
  a[data-variant='error'] > wui-image {
    width: 14px;
    height: 14px;
  }

  a[data-variant='transparent'] > wui-icon,
  a[data-variant='success'] > wui-icon,
  a[data-variant='shadeSmall'] > wui-icon,
  a[data-variant='error'] > wui-icon {
    width: 12px;
    height: 12px;
  }

  a[data-variant='fill']:focus-visible {
    background-color: var(--wui-color-accent-090);
  }

  a[data-variant='shade']:focus-visible,
  a[data-variant='shadeSmall']:focus-visible {
    background-color: var(--wui-gray-glass-015);
  }

  a[data-variant='transparent']:focus-visible {
    background-color: var(--wui-gray-glass-005);
  }

  a[data-variant='success']:focus-visible {
    background-color: var(--wui-success-glass-015);
  }

  a[data-variant='error']:focus-visible {
    background-color: var(--wui-error-glass-015);
  }

  a.disabled {
    color: var(--wui-gray-glass-015);
    background-color: var(--wui-gray-glass-015);
    pointer-events: none;
  }

  @media (hover: hover) and (pointer: fine) {
    a[data-variant='fill']:hover {
      background-color: var(--wui-color-accent-090);
    }

    a[data-variant='shade']:hover,
    a[data-variant='shadeSmall']:hover {
      background-color: var(--wui-gray-glass-015);
    }

    a[data-variant='transparent']:hover {
      background-color: var(--wui-gray-glass-005);
    }

    a[data-variant='success']:hover {
      background-color: var(--wui-success-glass-015);
    }

    a[data-variant='error']:hover {
      background-color: var(--wui-error-glass-015);
    }
  }

  a[data-variant='fill']:active {
    background-color: var(--wui-color-accent-080);
  }

  a[data-variant='shade']:active,
  a[data-variant='shadeSmall']:active {
    background-color: var(--wui-gray-glass-020);
  }

  a[data-variant='transparent']:active {
    background-color: var(--wui-gray-glass-010);
  }

  a[data-variant='success']:active {
    background-color: var(--wui-success-glass-020);
  }

  a[data-variant='error']:active {
    background-color: var(--wui-error-glass-020);
  }
`;

});


parcelRegister("ij079", function(module, exports) {

$parcel$export(module.exports, "WuiConnectButton", function () { return $d53a1708aacb9143$export$7e12422df5cbb04c; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("avm78");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $7JpNW = parcelRequire("7JpNW");
var $d53a1708aacb9143$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d53a1708aacb9143$export$7e12422df5cbb04c = class WuiConnectButton extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.loading = false;
    }
    render() {
        const textVariant = this.size === "md" ? "paragraph-600" : "small-600";
        return (0, $B77rE.html)`
      <button data-size=${this.size} ?disabled=${this.loading} ontouchstart>
        ${this.loadingTemplate()}
        <wui-text variant=${textVariant} color=${this.loading ? "accent-100" : "inherit"}>
          <slot></slot>
        </wui-text>
      </button>
    `;
    }
    loadingTemplate() {
        if (!this.loading) return null;
        return (0, $B77rE.html)`<wui-loading-spinner size=${this.size} color="accent-100"></wui-loading-spinner>`;
    }
};
$d53a1708aacb9143$export$7e12422df5cbb04c.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $7JpNW.default)
];
$d53a1708aacb9143$var$__decorate([
    (0, $cG9dN.property)()
], $d53a1708aacb9143$export$7e12422df5cbb04c.prototype, "size", void 0);
$d53a1708aacb9143$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $d53a1708aacb9143$export$7e12422df5cbb04c.prototype, "loading", void 0);
$d53a1708aacb9143$export$7e12422df5cbb04c = $d53a1708aacb9143$var$__decorate([
    (0, $3SCaV.customElement)("wui-connect-button")
], $d53a1708aacb9143$export$7e12422df5cbb04c);

});
parcelRegister("7JpNW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a10c0a1cf330b53$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $5a10c0a1cf330b53$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    display: block;
  }

  button {
    background: var(--wui-color-accent-100);
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-m);
    gap: var(--wui-spacing-xs);
  }

  button.loading {
    background: var(--wui-gray-glass-010);
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    border: 1px solid var(--wui-gray-glass-010);
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button:active:enabled {
      background-color: var(--wui-color-accent-080);
    }
  }

  button:focus-visible {
    border: 1px solid var(--wui-gray-glass-010);
    background-color: var(--wui-color-accent-090);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  button[data-size='sm'] {
    padding: 6.75px 10px 7.25px;
  }

  ::slotted(*) {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  button > wui-text {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
    color: var(--wui-color-inverse-100);
  }

  button[data-size='md'] {
    padding: 9px var(--wui-spacing-l) 9px var(--wui-spacing-l);
  }

  button[data-size='md'] + wui-text {
    padding-left: var(--wui-spacing-3xs);
  }

  @media (max-width: 500px) {
    button[data-size='md'] {
      height: 32px;
      padding: 5px 12px;
    }

    button[data-size='md'] > wui-text > slot {
      font-size: 14px !important;
    }
  }

  wui-loading-spinner {
    width: 14px;
    height: 14px;
  }

  wui-loading-spinner::slotted(svg) {
    width: 10px !important;
    height: 10px !important;
  }

  button[data-size='sm'] > wui-loading-spinner {
    width: 12px;
    height: 12px;
  }
`;

});


parcelRegister("eAc7C", function(module, exports) {

$parcel$export(module.exports, "WuiCtaButton", function () { return $a9ddd4a1e81f8dff$export$4cb12aabb6d5d23c; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("7xM3j");
parcelRequire("46WDJ");
parcelRequire("276Mo");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $1vzM3 = parcelRequire("1vzM3");
var $a9ddd4a1e81f8dff$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a9ddd4a1e81f8dff$export$4cb12aabb6d5d23c = class WuiCtaButton extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.label = "";
        this.buttonLabel = "";
    }
    render() {
        return (0, $B77rE.html)`
      <wui-flex
        justifyContent="space-between"
        alignItems="center"
        .padding=${[
            "1xs",
            "2l",
            "1xs",
            "2l"
        ]}
      >
        <wui-text variant="paragraph-500" color="fg-200">${this.label}</wui-text>
        <wui-button size="sm" variant="accent">
          ${this.buttonLabel}
          <wui-icon size="xs" color="inherit" slot="iconRight" name="chevronRight"></wui-icon>
        </wui-button>
      </wui-flex>
    `;
    }
};
$a9ddd4a1e81f8dff$export$4cb12aabb6d5d23c.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $1vzM3.default)
];
$a9ddd4a1e81f8dff$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $a9ddd4a1e81f8dff$export$4cb12aabb6d5d23c.prototype, "disabled", void 0);
$a9ddd4a1e81f8dff$var$__decorate([
    (0, $cG9dN.property)()
], $a9ddd4a1e81f8dff$export$4cb12aabb6d5d23c.prototype, "label", void 0);
$a9ddd4a1e81f8dff$var$__decorate([
    (0, $cG9dN.property)()
], $a9ddd4a1e81f8dff$export$4cb12aabb6d5d23c.prototype, "buttonLabel", void 0);
$a9ddd4a1e81f8dff$export$4cb12aabb6d5d23c = $a9ddd4a1e81f8dff$var$__decorate([
    (0, $3SCaV.customElement)("wui-cta-button")
], $a9ddd4a1e81f8dff$export$4cb12aabb6d5d23c);

});
parcelRegister("1vzM3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11946fae6a474144$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $11946fae6a474144$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  wui-flex {
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;

});


parcelRegister("eIHDH", function(module, exports) {

$parcel$export(module.exports, "WuiEmailInput", function () { return $ab77069b975ed81e$export$99face4607bb46ea; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("lAcfs");

var $iw5Xz = parcelRequire("iw5Xz");
var $ab77069b975ed81e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ab77069b975ed81e$export$99face4607bb46ea = class WuiEmailInput extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
    }
    render() {
        return (0, $B77rE.html)`
      <wui-input-text
        placeholder="Email"
        icon="mail"
        size="md"
        .disabled=${this.disabled}
        .value=${this.value}
        data-testid="wui-email-input"
      ></wui-input-text>
      ${this.templateError()}
    `;
    }
    templateError() {
        if (this.errorMessage) return (0, $B77rE.html)`<wui-text variant="tiny-500" color="error-100">${this.errorMessage}</wui-text>`;
        return null;
    }
};
$ab77069b975ed81e$export$99face4607bb46ea.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $iw5Xz.default)
];
$ab77069b975ed81e$var$__decorate([
    (0, $cG9dN.property)()
], $ab77069b975ed81e$export$99face4607bb46ea.prototype, "errorMessage", void 0);
$ab77069b975ed81e$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $ab77069b975ed81e$export$99face4607bb46ea.prototype, "disabled", void 0);
$ab77069b975ed81e$var$__decorate([
    (0, $cG9dN.property)()
], $ab77069b975ed81e$export$99face4607bb46ea.prototype, "value", void 0);
$ab77069b975ed81e$export$99face4607bb46ea = $ab77069b975ed81e$var$__decorate([
    (0, $3SCaV.customElement)("wui-email-input")
], $ab77069b975ed81e$export$99face4607bb46ea);

});
parcelRegister("lAcfs", function(module, exports) {

$parcel$export(module.exports, "WuiInputText", function () { return $fb66760214a9291a$export$487c694bc02cf7da; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("aVsFR");
var $lC4jx = parcelRequire("lC4jx");
parcelRequire("b7QUT");
var $iqKB3 = parcelRequire("iqKB3");
parcelRequire("iVPOS");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $02XjS = parcelRequire("02XjS");
var $fb66760214a9291a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $fb66760214a9291a$export$487c694bc02cf7da = class WuiInputText extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.inputElementRef = (0, $iqKB3.createRef)();
        this.size = "md";
        this.disabled = false;
        this.placeholder = "";
        this.type = "text";
    }
    render() {
        const sizeClass = `wui-size-${this.size}`;
        return (0, $B77rE.html)` ${this.templateIcon()}
      <input
        ${(0, $iqKB3.ref)(this.inputElementRef)}
        class=${sizeClass}
        type=${this.type}
        enterkeyhint=${(0, $lC4jx.ifDefined)(this.enterKeyHint)}
        ?disabled=${this.disabled}
        placeholder=${this.placeholder}
        @input=${this.dispatchInputChangeEvent.bind(this)}
        value=${(0, $lC4jx.ifDefined)(this.value)}
        .value=${this.value || ""}
      />
      <slot></slot>`;
    }
    templateIcon() {
        if (this.icon) return (0, $B77rE.html)`<wui-icon
        data-input=${this.size}
        size=${this.size}
        color="inherit"
        name=${this.icon}
      ></wui-icon>`;
        return null;
    }
    dispatchInputChangeEvent() {
        this.dispatchEvent(new CustomEvent("inputChange", {
            detail: this.inputElementRef.value?.value,
            bubbles: true,
            composed: true
        }));
    }
};
$fb66760214a9291a$export$487c694bc02cf7da.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $02XjS.default)
];
$fb66760214a9291a$var$__decorate([
    (0, $cG9dN.property)()
], $fb66760214a9291a$export$487c694bc02cf7da.prototype, "size", void 0);
$fb66760214a9291a$var$__decorate([
    (0, $cG9dN.property)()
], $fb66760214a9291a$export$487c694bc02cf7da.prototype, "icon", void 0);
$fb66760214a9291a$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $fb66760214a9291a$export$487c694bc02cf7da.prototype, "disabled", void 0);
$fb66760214a9291a$var$__decorate([
    (0, $cG9dN.property)()
], $fb66760214a9291a$export$487c694bc02cf7da.prototype, "placeholder", void 0);
$fb66760214a9291a$var$__decorate([
    (0, $cG9dN.property)()
], $fb66760214a9291a$export$487c694bc02cf7da.prototype, "type", void 0);
$fb66760214a9291a$var$__decorate([
    (0, $cG9dN.property)()
], $fb66760214a9291a$export$487c694bc02cf7da.prototype, "keyHint", void 0);
$fb66760214a9291a$var$__decorate([
    (0, $cG9dN.property)()
], $fb66760214a9291a$export$487c694bc02cf7da.prototype, "value", void 0);
$fb66760214a9291a$export$487c694bc02cf7da = $fb66760214a9291a$var$__decorate([
    (0, $3SCaV.customElement)("wui-input-text")
], $fb66760214a9291a$export$487c694bc02cf7da);

});
parcelRegister("b7QUT", function(module, exports) {
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("iqKB3")).createRef; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("iqKB3")).ref; });
parcelRequire("iqKB3");

});
parcelRegister("iqKB3", function(module, exports) {

$parcel$export(module.exports, "createRef", function () { return $d6aecccde946f6d8$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "ref", function () { return $d6aecccde946f6d8$export$eff4d24c3ff7876e; });

var $B77rE = parcelRequire("B77rE");

var $i7Y0d = parcelRequire("i7Y0d");

var $amTA7 = parcelRequire("amTA7");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d6aecccde946f6d8$export$7d1e3a5e95ceca43 = ()=>new $d6aecccde946f6d8$var$Zt;
class $d6aecccde946f6d8$var$Zt {
}
const $d6aecccde946f6d8$var$qt = new WeakMap, $d6aecccde946f6d8$export$eff4d24c3ff7876e = (0, $amTA7.directive)(class extends (0, $i7Y0d.AsyncDirective) {
    render(t) {
        return 0, $B77rE.nothing;
    }
    update(t, [i]) {
        const s = i !== this.Y;
        return s && void 0 !== this.Y && this.rt(void 0), (s || this.lt !== this.ct) && (this.Y = i, this.ht = t.options?.host, this.rt(this.ct = t.element)), $B77rE.nothing;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.Y) {
            const i = this.ht ?? globalThis;
            let s = $d6aecccde946f6d8$var$qt.get(i);
            void 0 === s && (s = new WeakMap, $d6aecccde946f6d8$var$qt.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
        } else this.Y.value = t;
    }
    get lt() {
        return "function" == typeof this.Y ? $d6aecccde946f6d8$var$qt.get(this.ht ?? globalThis)?.get(this.Y) : this.Y?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});

});
parcelRegister("i7Y0d", function(module, exports) {

$parcel$export(module.exports, "AsyncDirective", function () { return $d3276ca9682dc79f$export$7d025501802325e; });

var $8CQOf = parcelRequire("8CQOf");

var $amTA7 = parcelRequire("amTA7");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d3276ca9682dc79f$var$mt = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $d3276ca9682dc79f$var$mt(i, t);
    return !0;
}, $d3276ca9682dc79f$var$_t = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $d3276ca9682dc79f$var$wt = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $d3276ca9682dc79f$var$gt(t);
    }
};
function $d3276ca9682dc79f$var$bt(i) {
    void 0 !== this._$AN ? ($d3276ca9682dc79f$var$_t(this), this._$AM = i, $d3276ca9682dc79f$var$wt(this)) : this._$AM = i;
}
function $d3276ca9682dc79f$var$yt(i, t = !1, e = 0) {
    const s = this._$AH, o = this._$AN;
    if (void 0 !== o && 0 !== o.size) {
        if (t) {
            if (Array.isArray(s)) for(let i = e; i < s.length; i++)$d3276ca9682dc79f$var$mt(s[i], !1), $d3276ca9682dc79f$var$_t(s[i]);
            else null != s && ($d3276ca9682dc79f$var$mt(s, !1), $d3276ca9682dc79f$var$_t(s));
        } else $d3276ca9682dc79f$var$mt(this, i);
    }
}
const $d3276ca9682dc79f$var$gt = (i)=>{
    i.type == (0, $amTA7.PartType).CHILD && (i._$AP ??= $d3276ca9682dc79f$var$yt, i._$AQ ??= $d3276ca9682dc79f$var$bt);
};
class $d3276ca9682dc79f$export$7d025501802325e extends (0, $amTA7.Directive) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $d3276ca9682dc79f$var$wt(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($d3276ca9682dc79f$var$mt(this, i), $d3276ca9682dc79f$var$_t(this));
    }
    setValue(i) {
        if ((0, $8CQOf.isSingleExpression)(this.t)) this.t._$AI(i, this);
        else {
            const t = [
                ...this.t._$AH
            ];
            t[this.i] = i, this.t._$AI(t, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}

});
parcelRegister("8CQOf", function(module, exports) {

$parcel$export(module.exports, "isSingleExpression", function () { return $647ad632645c817c$export$7f431ad0fff82fd9; });

var $B77rE = parcelRequire("B77rE");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $647ad632645c817c$var$et } = (0, $B77rE._$LH), $647ad632645c817c$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $647ad632645c817c$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $647ad632645c817c$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $647ad632645c817c$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $647ad632645c817c$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $647ad632645c817c$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $647ad632645c817c$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $647ad632645c817c$var$lt = ()=>document.createComment(""), $647ad632645c817c$export$291b2338ad9b0b30 = (o, t, i)=>{
    const n = o._$AA.parentNode, e = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        const t = n.insertBefore($647ad632645c817c$var$lt(), e), l = n.insertBefore($647ad632645c817c$var$lt(), e);
        i = new $647ad632645c817c$var$et(t, l, o, o.options);
    } else {
        const t = i._$AB.nextSibling, l = i._$AM, c = l !== o;
        if (c) {
            let t;
            i._$AQ?.(o), i._$AM = o, void 0 !== i._$AP && (t = o._$AU) !== l._$AU && i._$AP(t);
        }
        if (t !== e || c) {
            let o = i._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                n.insertBefore(o, e), o = t;
            }
        }
    }
    return i;
}, $647ad632645c817c$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $647ad632645c817c$var$ht = {}, $647ad632645c817c$export$ea70d9dd5965b1c8 = (o, t = $647ad632645c817c$var$ht)=>o._$AH = t, $647ad632645c817c$export$59e9bce518cde500 = (o)=>o._$AH, $647ad632645c817c$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $647ad632645c817c$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};

});




parcelRegister("02XjS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $008e33ac96c2409f$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $008e33ac96c2409f$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    width: 100%;
    display: inline-block;
    color: var(--wui-color-fg-275);
  }

  input {
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-gray-glass-005);
    background: var(--wui-gray-glass-005);
    font-size: var(--wui-font-size-paragraph);
    font-weight: var(--wui-font-weight-light);
    letter-spacing: var(--wui-letter-spacing-paragraph);
    color: var(--wui-color-fg-100);
    transition: all var(--wui-ease-inout-power-1) var(--wui-duration-lg);
    caret-color: var(--wui-color-accent-100);
  }

  input:disabled {
    cursor: not-allowed;
    border: 1px solid var(--wui-gray-glass-010);
  }

  input:disabled::placeholder,
  input:disabled + wui-icon {
    color: var(--wui-color-fg-300);
  }

  input::placeholder {
    color: var(--wui-color-fg-275);
  }

  input:focus:enabled {
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
    background-color: var(--wui-gray-glass-010);
    border: 1px solid var(--wui-color-accent-100);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  input:hover:enabled {
    background-color: var(--wui-gray-glass-010);
  }

  wui-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .wui-size-sm {
    padding: 9px var(--wui-spacing-m) 10px var(--wui-spacing-s);
  }

  wui-icon + .wui-size-sm {
    padding: 9px var(--wui-spacing-m) 10px 36px;
  }

  wui-icon[data-input='sm'] {
    left: var(--wui-spacing-s);
  }

  .wui-size-md {
    padding: 15px var(--wui-spacing-m) var(--wui-spacing-l) var(--wui-spacing-m);
  }

  wui-icon + .wui-size-md,
  wui-loading-spinner + .wui-size-md {
    padding: 10.5px var(--wui-spacing-3xl) 10.5px 40px;
  }

  wui-icon[data-input='md'] {
    left: var(--wui-spacing-l);
  }

  .wui-size-lg {
    padding: var(--wui-spacing-s) var(--wui-spacing-s) var(--wui-spacing-s) var(--wui-spacing-l);
    letter-spacing: var(--wui-letter-spacing-medium-title);
    font-size: var(--wui-font-size-medium-title);
    font-weight: var(--wui-font-weight-light);
    line-height: 130%;
    color: var(--wui-color-fg-100);
    height: 64px;
  }

  wui-icon + .wui-size-lg,
  wui-loading-spinner + .wui-size-lg {
    padding-left: 50px;
  }

  wui-icon[data-input='lg'] {
    left: var(--wui-spacing-l);
  }

  input:placeholder-shown ~ ::slotted(wui-input-element),
  input:placeholder-shown ~ ::slotted(wui-icon) {
    opacity: 0;
    pointer-events: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  ::slotted(wui-input-element),
  ::slotted(wui-icon) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: all var(--wui-ease-in-power-2) var(--wui-duration-md);
  }

  ::slotted(wui-input-element) {
    right: var(--wui-spacing-m);
  }

  ::slotted(wui-icon) {
    right: 0px;
  }
`;

});


parcelRegister("iw5Xz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7afd6a924c799a2$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $d7afd6a924c799a2$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    display: inline-block;
  }

  wui-text {
    margin: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-0) var(--wui-spacing-m);
  }
`;

});


parcelRegister("dKNW7", function(module, exports) {

$parcel$export(module.exports, "WuiIconLink", function () { return $a0364e93a8dc87a0$export$5a944ba239383166; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $whyUu = parcelRequire("whyUu");
var $a0364e93a8dc87a0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a0364e93a8dc87a0$export$5a944ba239383166 = class WuiIconLink extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.disabled = false;
        this.icon = "copy";
        this.iconColor = "inherit";
    }
    render() {
        const borderRadius = this.size === "lg" ? "--wui-border-radius-xs" : "--wui-border-radius-xxs";
        const padding = this.size === "lg" ? "--wui-spacing-1xs" : "--wui-spacing-2xs";
        this.style.cssText = `
    --local-border-radius: var(${borderRadius});
    --local-padding: var(${padding});
`;
        return (0, $B77rE.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-icon color=${this.iconColor} size=${this.size} name=${this.icon}></wui-icon>
      </button>
    `;
    }
};
$a0364e93a8dc87a0$export$5a944ba239383166.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $cRWGJ.colorStyles),
    (0, $whyUu.default)
];
$a0364e93a8dc87a0$var$__decorate([
    (0, $cG9dN.property)()
], $a0364e93a8dc87a0$export$5a944ba239383166.prototype, "size", void 0);
$a0364e93a8dc87a0$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $a0364e93a8dc87a0$export$5a944ba239383166.prototype, "disabled", void 0);
$a0364e93a8dc87a0$var$__decorate([
    (0, $cG9dN.property)()
], $a0364e93a8dc87a0$export$5a944ba239383166.prototype, "icon", void 0);
$a0364e93a8dc87a0$var$__decorate([
    (0, $cG9dN.property)()
], $a0364e93a8dc87a0$export$5a944ba239383166.prototype, "iconColor", void 0);
$a0364e93a8dc87a0$export$5a944ba239383166 = $a0364e93a8dc87a0$var$__decorate([
    (0, $3SCaV.customElement)("wui-icon-link")
], $a0364e93a8dc87a0$export$5a944ba239383166);

});
parcelRegister("whyUu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06109cbbe5397c6e$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $06109cbbe5397c6e$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  button {
    border-radius: var(--local-border-radius);
    color: var(--wui-color-fg-100);
    padding: var(--local-padding);
  }

  @media (max-width: 700px) {
    button {
      padding: var(--wui-spacing-s);
    }
  }

  button > wui-icon {
    pointer-events: none;
  }

  button:disabled > wui-icon {
    color: var(--wui-color-bg-300) !important;
  }

  button:disabled {
    background-color: transparent;
  }
`;

});


parcelRegister("fI5Lg", function(module, exports) {

$parcel$export(module.exports, "WuiInputElement", function () { return $b6ff6f21465e575b$export$673191bf93fc142c; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $7d08Z = parcelRequire("7d08Z");
var $b6ff6f21465e575b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b6ff6f21465e575b$export$673191bf93fc142c = class WuiInputElement extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.icon = "copy";
    }
    render() {
        return (0, $B77rE.html)`
      <button>
        <wui-icon color="inherit" size="xxs" name=${this.icon}></wui-icon>
      </button>
    `;
    }
};
$b6ff6f21465e575b$export$673191bf93fc142c.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $7d08Z.default)
];
$b6ff6f21465e575b$var$__decorate([
    (0, $cG9dN.property)()
], $b6ff6f21465e575b$export$673191bf93fc142c.prototype, "icon", void 0);
$b6ff6f21465e575b$export$673191bf93fc142c = $b6ff6f21465e575b$var$__decorate([
    (0, $3SCaV.customElement)("wui-input-element")
], $b6ff6f21465e575b$export$673191bf93fc142c);

});
parcelRegister("7d08Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53f9dbe1fa971b08$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $53f9dbe1fa971b08$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  button {
    background-color: var(--wui-color-fg-300);
    border-radius: var(--wui-border-radius-4xs);
    width: 16px;
    height: 16px;
  }

  button:disabled {
    background-color: var(--wui-color-bg-300);
  }

  wui-icon {
    color: var(--wui-color-bg-200) !important;
  }

  button:focus-visible {
    background-color: var(--wui-color-fg-250);
    border: 1px solid var(--wui-color-accent-100);
  }

  button:active:enabled {
    background-color: var(--wui-color-fg-225);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-fg-250);
    }
  }
`;

});


parcelRegister("jAflF", function(module, exports) {

$parcel$export(module.exports, "WuiInputNumeric", function () { return $e41d4900e7215e87$export$230332bec9d0029b; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $x9SCI = parcelRequire("x9SCI");
var $e41d4900e7215e87$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e41d4900e7215e87$export$230332bec9d0029b = class WuiInputNumeric extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.value = "";
    }
    render() {
        return (0, $B77rE.html)`<input
      type="number"
      maxlength="1"
      inputmode="numeric"
      autofocus
      ?disabled=${this.disabled}
      value=${this.value}
    /> `;
    }
};
$e41d4900e7215e87$export$230332bec9d0029b.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $x9SCI.default)
];
$e41d4900e7215e87$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $e41d4900e7215e87$export$230332bec9d0029b.prototype, "disabled", void 0);
$e41d4900e7215e87$var$__decorate([
    (0, $cG9dN.property)({
        type: String
    })
], $e41d4900e7215e87$export$230332bec9d0029b.prototype, "value", void 0);
$e41d4900e7215e87$export$230332bec9d0029b = $e41d4900e7215e87$var$__decorate([
    (0, $3SCaV.customElement)("wui-input-numeric")
], $e41d4900e7215e87$export$230332bec9d0029b);

});
parcelRegister("x9SCI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $063abf262f83374a$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $063abf262f83374a$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    display: inline-block;
  }

  input {
    width: 50px;
    height: 50px;
    background: var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-gray-glass-005);
    font-family: var(--wui-font-family);
    font-size: var(--wui-font-size-large);
    font-weight: var(--wui-font-weight-regular);
    letter-spacing: var(--wui-letter-spacing-large);
    text-align: center;
    color: var(--wui-color-fg-100);
    caret-color: var(--wui-color-accent-100);
    transition: all var(--wui-ease-inout-power-1) var(--wui-duration-lg);
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    padding: 0px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  input:disabled {
    cursor: not-allowed;
    border: 1px solid var(--wui-gray-glass-010);
    background: var(--wui-gray-glass-005);
  }

  input:focus:enabled {
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
    background-color: var(--wui-gray-glass-015);
    border: 1px solid var(--wui-color-accent-100);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }
  @media (hover: hover) and (pointer: fine) {
    input:hover:enabled {
      background-color: var(--wui-gray-glass-015);
    }
  }
`;

});


parcelRegister("diX7K", function(module, exports) {

$parcel$export(module.exports, "WuiLink", function () { return $9afad1908003cdfa$export$f279fe723271abb; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $jh5nx = parcelRequire("jh5nx");
var $9afad1908003cdfa$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9afad1908003cdfa$export$f279fe723271abb = class WuiLink extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.color = "inherit";
    }
    render() {
        return (0, $B77rE.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <slot name="iconLeft"></slot>
        <wui-text variant="small-600" color=${this.color}>
          <slot></slot>
        </wui-text>
        <slot name="iconRight"></slot>
      </button>
    `;
    }
};
$9afad1908003cdfa$export$f279fe723271abb.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $jh5nx.default)
];
$9afad1908003cdfa$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $9afad1908003cdfa$export$f279fe723271abb.prototype, "disabled", void 0);
$9afad1908003cdfa$var$__decorate([
    (0, $cG9dN.property)()
], $9afad1908003cdfa$export$f279fe723271abb.prototype, "color", void 0);
$9afad1908003cdfa$export$f279fe723271abb = $9afad1908003cdfa$var$__decorate([
    (0, $3SCaV.customElement)("wui-link")
], $9afad1908003cdfa$export$f279fe723271abb);

});
parcelRegister("jh5nx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e083c6f5147631eb$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $e083c6f5147631eb$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  button {
    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);
    border-radius: var(--wui-border-radius-3xs);
    background-color: transparent;
    color: var(--wui-color-accent-100);
  }

  button:disabled {
    background-color: transparent;
    color: var(--wui-gray-glass-015);
  }
`;

});


parcelRegister("3l1Vc", function(module, exports) {

$parcel$export(module.exports, "WuiListItem", function () { return $26e4d2db9f786e1d$export$cd9b2e41f828fc8a; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("aVsFR");
var $lC4jx = parcelRequire("lC4jx");
parcelRequire("iVPOS");
parcelRequire("62Qzz");
parcelRequire("avm78");
parcelRequire("7xM3j");
parcelRequire("276Mo");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("9SgY8");

var $5GFp0 = parcelRequire("5GFp0");
var $26e4d2db9f786e1d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $26e4d2db9f786e1d$export$cd9b2e41f828fc8a = class WuiListItem extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "icon";
        this.disabled = false;
        this.imageSrc = undefined;
        this.alt = undefined;
        this.chevron = false;
        this.loading = false;
    }
    render() {
        return (0, $B77rE.html)`
      <button
        ?disabled=${this.loading ? true : Boolean(this.disabled)}
        data-loading=${this.loading}
        data-iconvariant=${(0, $lC4jx.ifDefined)(this.iconVariant)}
        ontouchstart
      >
        ${this.loadingTemplate()} ${this.visualTemplate()}
        <wui-flex gap="3xs">
          <slot></slot>
        </wui-flex>
        ${this.chevronTemplate()}
      </button>
    `;
    }
    visualTemplate() {
        if (this.variant === "image" && this.imageSrc) return (0, $B77rE.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "list item"}></wui-image>`;
        if (this.iconVariant === "square" && this.icon && this.variant === "icon") return (0, $B77rE.html)`<wui-icon name=${this.icon}></wui-icon>`;
        if (this.variant === "icon" && this.icon && this.iconVariant) {
            const color = [
                "blue",
                "square-blue"
            ].includes(this.iconVariant) ? "accent-100" : "fg-200";
            const size = this.iconVariant === "square-blue" ? "mdl" : "md";
            const iconSize = this.iconSize ? this.iconSize : size;
            return (0, $B77rE.html)`
        <wui-icon-box
          data-variant=${this.iconVariant}
          icon=${this.icon}
          iconSize=${iconSize}
          background="transparent"
          iconColor=${color}
          backgroundColor=${color}
          size=${size}
        ></wui-icon-box>
      `;
        }
        return null;
    }
    loadingTemplate() {
        if (this.loading) return (0, $B77rE.html)`<wui-loading-spinner color="fg-300"></wui-loading-spinner>`;
        return (0, $B77rE.html)``;
    }
    chevronTemplate() {
        if (this.chevron) return (0, $B77rE.html)`<wui-icon size="inherit" color="fg-200" name="chevronRight"></wui-icon>`;
        return null;
    }
};
$26e4d2db9f786e1d$export$cd9b2e41f828fc8a.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $5GFp0.default)
];
$26e4d2db9f786e1d$var$__decorate([
    (0, $cG9dN.property)()
], $26e4d2db9f786e1d$export$cd9b2e41f828fc8a.prototype, "icon", void 0);
$26e4d2db9f786e1d$var$__decorate([
    (0, $cG9dN.property)()
], $26e4d2db9f786e1d$export$cd9b2e41f828fc8a.prototype, "iconSize", void 0);
$26e4d2db9f786e1d$var$__decorate([
    (0, $cG9dN.property)()
], $26e4d2db9f786e1d$export$cd9b2e41f828fc8a.prototype, "variant", void 0);
$26e4d2db9f786e1d$var$__decorate([
    (0, $cG9dN.property)()
], $26e4d2db9f786e1d$export$cd9b2e41f828fc8a.prototype, "iconVariant", void 0);
$26e4d2db9f786e1d$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $26e4d2db9f786e1d$export$cd9b2e41f828fc8a.prototype, "disabled", void 0);
$26e4d2db9f786e1d$var$__decorate([
    (0, $cG9dN.property)()
], $26e4d2db9f786e1d$export$cd9b2e41f828fc8a.prototype, "imageSrc", void 0);
$26e4d2db9f786e1d$var$__decorate([
    (0, $cG9dN.property)()
], $26e4d2db9f786e1d$export$cd9b2e41f828fc8a.prototype, "alt", void 0);
$26e4d2db9f786e1d$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $26e4d2db9f786e1d$export$cd9b2e41f828fc8a.prototype, "chevron", void 0);
$26e4d2db9f786e1d$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $26e4d2db9f786e1d$export$cd9b2e41f828fc8a.prototype, "loading", void 0);
$26e4d2db9f786e1d$export$cd9b2e41f828fc8a = $26e4d2db9f786e1d$var$__decorate([
    (0, $3SCaV.customElement)("wui-list-item")
], $26e4d2db9f786e1d$export$cd9b2e41f828fc8a);

});
parcelRegister("5GFp0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4240fda7bbeda31d$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $4240fda7bbeda31d$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 11px 18px 11px var(--wui-spacing-s);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  button[data-iconvariant='square'],
  button[data-iconvariant='square-blue'] {
    padding: 6px 18px 6px 9px;
  }

  button > wui-flex {
    flex: 1;
  }

  button > wui-image {
    width: 32px;
    height: 32px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
    border-radius: var(--wui-border-radius-3xl);
  }

  button > wui-icon {
    width: 36px;
    height: 36px;
  }

  button > wui-icon-box[data-variant='blue'] {
    box-shadow: 0 0 0 2px var(--wui-accent-glass-005);
  }

  button > wui-icon-box[data-variant='overlay'] {
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  button > wui-icon-box[data-variant='square-blue'] {
    border-radius: var(--wui-border-radius-3xs);
    position: relative;
    border: none;
    width: 36px;
    height: 36px;
  }

  button > wui-icon-box[data-variant='square-blue']::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-accent-glass-010);
    pointer-events: none;
  }

  button > wui-icon:last-child {
    width: 14px;
    height: 14px;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  button[data-loading='true'] > wui-icon {
    transition: opacity 200ms ease-in-out;
    opacity: 0;
  }

  wui-loading-spinner {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

});


parcelRegister("kvxnU", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionListItem", function () { return $eee09961f6b5f53d$export$ee516ccb0af19908; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $3SCaV = parcelRequire("3SCaV");

var $ldaes = parcelRequire("ldaes");

var $cRWGJ = parcelRequire("cRWGJ");
parcelRequire("7xM3j");
parcelRequire("6tuq4");
parcelRequire("aVsFR");
var $lC4jx = parcelRequire("lC4jx");

var $5cBcL = parcelRequire("5cBcL");
var $eee09961f6b5f53d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $eee09961f6b5f53d$export$ee516ccb0af19908 = class WuiTransactionListItem extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.type = "approve";
        this.onlyDirectionIcon = false;
        this.images = [];
        this.price = [];
        this.amount = [];
        this.symbol = [];
    }
    render() {
        return (0, $B77rE.html)`
      <wui-flex>
        <wui-transaction-visual
          .status=${this.status}
          direction=${(0, $lC4jx.ifDefined)(this.direction)}
          type=${this.type}
          onlyDirectionIcon=${(0, $lC4jx.ifDefined)(this.onlyDirectionIcon)}
          .images=${this.images}
        ></wui-transaction-visual>
        <wui-flex flexDirection="column" gap="3xs">
          <wui-text variant="paragraph-600" color="fg-100">
            ${(0, $ldaes.TransactionTypePastTense)[this.type] || this.type}
          </wui-text>
          <wui-flex class="description-container">
            ${this.templateDescription()} ${this.templateSecondDescription()}
          </wui-flex>
        </wui-flex>
        <wui-text variant="micro-700" color="fg-300"><span>${this.date}</span></wui-text>
      </wui-flex>
    `;
    }
    templateDescription() {
        const description = this.descriptions?.[0];
        return description ? (0, $B77rE.html)`
          <wui-text variant="small-500" color="fg-200">
            <span>${description}</span>
          </wui-text>
        ` : null;
    }
    templateSecondDescription() {
        const description = this.descriptions?.[1];
        return description ? (0, $B77rE.html)`
          <wui-icon class="description-separator-icon" size="xxs" name="arrowRight"></wui-icon>
          <wui-text variant="small-400" color="fg-200">
            <span>${description}</span>
          </wui-text>
        ` : null;
    }
};
$eee09961f6b5f53d$export$ee516ccb0af19908.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $5cBcL.default)
];
$eee09961f6b5f53d$var$__decorate([
    (0, $cG9dN.property)()
], $eee09961f6b5f53d$export$ee516ccb0af19908.prototype, "type", void 0);
$eee09961f6b5f53d$var$__decorate([
    (0, $cG9dN.property)({
        type: Array
    })
], $eee09961f6b5f53d$export$ee516ccb0af19908.prototype, "descriptions", void 0);
$eee09961f6b5f53d$var$__decorate([
    (0, $cG9dN.property)()
], $eee09961f6b5f53d$export$ee516ccb0af19908.prototype, "date", void 0);
$eee09961f6b5f53d$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $eee09961f6b5f53d$export$ee516ccb0af19908.prototype, "onlyDirectionIcon", void 0);
$eee09961f6b5f53d$var$__decorate([
    (0, $cG9dN.property)()
], $eee09961f6b5f53d$export$ee516ccb0af19908.prototype, "status", void 0);
$eee09961f6b5f53d$var$__decorate([
    (0, $cG9dN.property)()
], $eee09961f6b5f53d$export$ee516ccb0af19908.prototype, "direction", void 0);
$eee09961f6b5f53d$var$__decorate([
    (0, $cG9dN.property)({
        type: Array
    })
], $eee09961f6b5f53d$export$ee516ccb0af19908.prototype, "images", void 0);
$eee09961f6b5f53d$var$__decorate([
    (0, $cG9dN.property)({
        type: Array
    })
], $eee09961f6b5f53d$export$ee516ccb0af19908.prototype, "price", void 0);
$eee09961f6b5f53d$var$__decorate([
    (0, $cG9dN.property)({
        type: Array
    })
], $eee09961f6b5f53d$export$ee516ccb0af19908.prototype, "amount", void 0);
$eee09961f6b5f53d$var$__decorate([
    (0, $cG9dN.property)({
        type: Array
    })
], $eee09961f6b5f53d$export$ee516ccb0af19908.prototype, "symbol", void 0);
$eee09961f6b5f53d$export$ee516ccb0af19908 = $eee09961f6b5f53d$var$__decorate([
    (0, $3SCaV.customElement)("wui-transaction-list-item")
], $eee09961f6b5f53d$export$ee516ccb0af19908);

});
parcelRegister("ldaes", function(module, exports) {

$parcel$export(module.exports, "TransactionTypePastTense", function () { return $f712bfc734ad6f7a$export$1c6b44bd2bf7f8fa; });
var $f712bfc734ad6f7a$export$1c6b44bd2bf7f8fa;
(function(TransactionTypePastTense) {
    TransactionTypePastTense["approve"] = "approved";
    TransactionTypePastTense["bought"] = "bought";
    TransactionTypePastTense["borrow"] = "borrowed";
    TransactionTypePastTense["burn"] = "burnt";
    TransactionTypePastTense["cancel"] = "canceled";
    TransactionTypePastTense["claim"] = "claimed";
    TransactionTypePastTense["deploy"] = "deployed";
    TransactionTypePastTense["deposit"] = "deposited";
    TransactionTypePastTense["execute"] = "executed";
    TransactionTypePastTense["mint"] = "minted";
    TransactionTypePastTense["receive"] = "received";
    TransactionTypePastTense["repay"] = "repaid";
    TransactionTypePastTense["send"] = "sent";
    TransactionTypePastTense["sell"] = "sold";
    TransactionTypePastTense["stake"] = "staked";
    TransactionTypePastTense["trade"] = "swapped";
    TransactionTypePastTense["unstake"] = "unstaked";
    TransactionTypePastTense["withdraw"] = "withdrawn";
})($f712bfc734ad6f7a$export$1c6b44bd2bf7f8fa || ($f712bfc734ad6f7a$export$1c6b44bd2bf7f8fa = {}));

});

parcelRegister("6tuq4", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionVisual", function () { return $4b6d0c2ed1e9f539$export$98664c16c41f47e3; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("62Qzz");
parcelRequire("9SgY8");

var $3Q5oD = parcelRequire("3Q5oD");
var $4b6d0c2ed1e9f539$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4b6d0c2ed1e9f539$export$98664c16c41f47e3 = class WuiTransactionVisual extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.images = [];
        this.secondImage = {
            type: undefined,
            url: ""
        };
    }
    render() {
        const [firstImage, secondImage] = this.images;
        const isLeftNFT = firstImage?.type === "NFT";
        const isRightNFT = secondImage?.url ? secondImage.type === "NFT" : isLeftNFT;
        const leftRadius = isLeftNFT ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
        const rightRadius = isRightNFT ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
        this.style.cssText = `
    --local-left-border-radius: ${leftRadius};
    --local-right-border-radius: ${rightRadius};
    `;
        return (0, $B77rE.html)`<wui-flex> ${this.templateVisual()} ${this.templateIcon()} </wui-flex>`;
    }
    templateVisual() {
        const [firstImage, secondImage] = this.images;
        const firstImageType = firstImage?.type;
        const haveTwoImages = this.images.length === 2;
        if (haveTwoImages && (firstImage?.url || secondImage?.url)) return (0, $B77rE.html)`<div class="swap-images-container">
        ${firstImage?.url ? (0, $B77rE.html)`<wui-image src=${firstImage.url} alt="Transaction image"></wui-image>` : null}
        ${secondImage?.url ? (0, $B77rE.html)`<wui-image src=${secondImage.url} alt="Transaction image"></wui-image>` : null}
      </div>`;
        else if (firstImage?.url) return (0, $B77rE.html)`<wui-image src=${firstImage.url} alt="Transaction image"></wui-image>`;
        else if (firstImageType === "NFT") return (0, $B77rE.html)`<wui-icon size="inherit" color="fg-200" name="nftPlaceholder"></wui-icon>`;
        return (0, $B77rE.html)`<wui-icon size="inherit" color="fg-200" name="coinPlaceholder"></wui-icon>`;
    }
    templateIcon() {
        let color = "accent-100";
        let icon = undefined;
        icon = this.getIcon();
        if (this.status) color = this.getStatusColor();
        if (!icon) return null;
        return (0, $B77rE.html)`
      <wui-icon-box
        size="xxs"
        iconColor=${color}
        backgroundColor=${color}
        background="opaque"
        icon=${icon}
        ?border=${true}
        borderColor="wui-color-bg-125"
      ></wui-icon-box>
    `;
    }
    getDirectionIcon() {
        switch(this.direction){
            case "in":
                return "arrowBottom";
            case "out":
                return "arrowTop";
            default:
                return undefined;
        }
    }
    getIcon() {
        if (this.onlyDirectionIcon) return this.getDirectionIcon();
        if (this.type === "trade") return "swapHorizontalBold";
        else if (this.type === "approve") return "checkmark";
        else if (this.type === "cancel") return "close";
        return this.getDirectionIcon();
    }
    getStatusColor() {
        switch(this.status){
            case "confirmed":
                return "success-100";
            case "failed":
                return "error-100";
            case "pending":
                return "inverse-100";
            default:
                return "accent-100";
        }
    }
};
$4b6d0c2ed1e9f539$export$98664c16c41f47e3.styles = [
    (0, $3Q5oD.default)
];
$4b6d0c2ed1e9f539$var$__decorate([
    (0, $cG9dN.property)()
], $4b6d0c2ed1e9f539$export$98664c16c41f47e3.prototype, "type", void 0);
$4b6d0c2ed1e9f539$var$__decorate([
    (0, $cG9dN.property)()
], $4b6d0c2ed1e9f539$export$98664c16c41f47e3.prototype, "status", void 0);
$4b6d0c2ed1e9f539$var$__decorate([
    (0, $cG9dN.property)()
], $4b6d0c2ed1e9f539$export$98664c16c41f47e3.prototype, "direction", void 0);
$4b6d0c2ed1e9f539$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $4b6d0c2ed1e9f539$export$98664c16c41f47e3.prototype, "onlyDirectionIcon", void 0);
$4b6d0c2ed1e9f539$var$__decorate([
    (0, $cG9dN.property)({
        type: Array
    })
], $4b6d0c2ed1e9f539$export$98664c16c41f47e3.prototype, "images", void 0);
$4b6d0c2ed1e9f539$var$__decorate([
    (0, $cG9dN.property)({
        type: Object
    })
], $4b6d0c2ed1e9f539$export$98664c16c41f47e3.prototype, "secondImage", void 0);
$4b6d0c2ed1e9f539$export$98664c16c41f47e3 = $4b6d0c2ed1e9f539$var$__decorate([
    (0, $3SCaV.customElement)("wui-transaction-visual")
], $4b6d0c2ed1e9f539$export$98664c16c41f47e3);

});
parcelRegister("3Q5oD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cba6a0849c17ac1$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $2cba6a0849c17ac1$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host > wui-flex {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 40px;
    height: 40px;
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
    background-color: var(--wui-gray-glass-005);
  }

  :host > wui-flex wui-image {
    display: block;
  }

  :host > wui-flex,
  :host > wui-flex wui-image,
  .swap-images-container,
  .swap-images-container.nft,
  wui-image.nft {
    border-top-left-radius: var(--local-left-border-radius);
    border-top-right-radius: var(--local-right-border-radius);
    border-bottom-left-radius: var(--local-left-border-radius);
    border-bottom-right-radius: var(--local-right-border-radius);
  }

  wui-icon {
    width: 20px;
    height: 20px;
  }

  wui-icon-box {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translate(20%, 20%);
  }

  .swap-images-container {
    position: relative;
    width: 40px;
    height: 40px;
    overflow: hidden;
  }

  .swap-images-container wui-image:first-child {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    left: 0%;
    clip-path: inset(0px calc(50% + 2px) 0px 0%);
  }

  .swap-images-container wui-image:last-child {
    clip-path: inset(0px 0px 0px calc(50% + 2px));
  }
`;

});


parcelRegister("5cBcL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9aeedf2582a77c$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $3c9aeedf2582a77c$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host > wui-flex:first-child {
    align-items: center;
    column-gap: var(--wui-spacing-s);
    padding: 6.5px var(--wui-spacing-xs) 6.5px var(--wui-spacing-xs);
    width: 100%;
  }

  :host > wui-flex:first-child wui-text:nth-child(1) {
    text-transform: capitalize;
  }

  wui-transaction-visual {
    width: 40px;
    height: 40px;
  }

  wui-flex {
    flex: 1;
  }

  :host wui-flex wui-flex {
    overflow: hidden;
  }

  :host .description-container wui-text span {
    word-break: break-all;
  }

  :host .description-container wui-text {
    overflow: hidden;
  }

  :host .description-separator-icon {
    margin: 0px 6px;
  }

  :host wui-text > span {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
`;

});


parcelRegister("7bMnp", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionListItemLoader", function () { return $53bf160f29cbdceb$export$994c2d15662c37cc; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");

var $3SCaV = parcelRequire("3SCaV");

var $cRWGJ = parcelRequire("cRWGJ");
parcelRequire("7xM3j");
parcelRequire("6tuq4");

var $p4JLA = parcelRequire("p4JLA");
var $53bf160f29cbdceb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $53bf160f29cbdceb$export$994c2d15662c37cc = class WuiTransactionListItemLoader extends (0, $75o4B.LitElement) {
    render() {
        return (0, $B77rE.html)`
      <wui-flex alignItems="center">
        <wui-shimmer width="40px" height="40px"></wui-shimmer>
        <wui-flex flexDirection="column" gap="2xs">
          <wui-shimmer width="72px" height="16px" borderRadius="4xs"></wui-shimmer>
          <wui-shimmer width="148px" height="14px" borderRadius="4xs"></wui-shimmer>
        </wui-flex>
        <wui-shimmer width="24px" height="12px" borderRadius="5xs"></wui-shimmer>
      </wui-flex>
    `;
    }
};
$53bf160f29cbdceb$export$994c2d15662c37cc.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $p4JLA.default)
];
$53bf160f29cbdceb$export$994c2d15662c37cc = $53bf160f29cbdceb$var$__decorate([
    (0, $3SCaV.customElement)("wui-transaction-list-item-loader")
], $53bf160f29cbdceb$export$994c2d15662c37cc);

});
parcelRegister("p4JLA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04b6029dfcc6d38d$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $04b6029dfcc6d38d$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host > wui-flex:first-child {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
  }

  wui-flex {
    display: flex;
    flex: 1;
  }
`;

});


parcelRegister("fBWP9", function(module, exports) {

$parcel$export(module.exports, "WuiListWallet", function () { return $b5d7f0ec091bde43$export$fe01be9b7ff81a09; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("9SgY8");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("QXOPA");
parcelRequire("kc9Rd");
parcelRequire("cvCkY");

var $lXq3c = parcelRequire("lXq3c");
var $b5d7f0ec091bde43$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b5d7f0ec091bde43$export$fe01be9b7ff81a09 = class WuiListWallet extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.walletImages = [];
        this.imageSrc = "";
        this.name = "";
        this.installed = false;
        this.disabled = false;
        this.showAllWallets = false;
    }
    render() {
        return (0, $B77rE.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        ${this.templateAllWallets()} ${this.templateWalletImage()}
        <wui-text variant="paragraph-500" color="inherit">${this.name}</wui-text>
        ${this.templateStatus()}
      </button>
    `;
    }
    templateAllWallets() {
        if (this.showAllWallets && this.imageSrc) return (0, $B77rE.html)` <wui-all-wallets-image .imageeSrc=${this.imageSrc}> </wui-all-wallets-image> `;
        else if (this.showAllWallets && this.walletIcon) return (0, $B77rE.html)` <wui-wallet-image .walletIcon=${this.walletIcon} size="sm"> </wui-wallet-image> `;
        return null;
    }
    templateWalletImage() {
        if (!this.showAllWallets && this.imageSrc) return (0, $B77rE.html)`<wui-wallet-image
        size="sm"
        imageSrc=${this.imageSrc}
        name=${this.name}
        .installed=${this.installed}
      ></wui-wallet-image>`;
        else if (!this.showAllWallets && !this.imageSrc) return (0, $B77rE.html)`<wui-wallet-image size="sm" name=${this.name}></wui-wallet-image>`;
        return null;
    }
    templateStatus() {
        if (this.tagLabel && this.tagVariant) return (0, $B77rE.html)`<wui-tag variant=${this.tagVariant}>${this.tagLabel}</wui-tag>`;
        else if (this.icon) return (0, $B77rE.html)`<wui-icon color="inherit" size="sm" name=${this.icon}></wui-icon>`;
        return null;
    }
};
$b5d7f0ec091bde43$export$fe01be9b7ff81a09.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $lXq3c.default)
];
$b5d7f0ec091bde43$var$__decorate([
    (0, $cG9dN.property)({
        type: Array
    })
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09.prototype, "walletImages", void 0);
$b5d7f0ec091bde43$var$__decorate([
    (0, $cG9dN.property)()
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09.prototype, "imageSrc", void 0);
$b5d7f0ec091bde43$var$__decorate([
    (0, $cG9dN.property)()
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09.prototype, "name", void 0);
$b5d7f0ec091bde43$var$__decorate([
    (0, $cG9dN.property)()
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09.prototype, "tagLabel", void 0);
$b5d7f0ec091bde43$var$__decorate([
    (0, $cG9dN.property)()
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09.prototype, "tagVariant", void 0);
$b5d7f0ec091bde43$var$__decorate([
    (0, $cG9dN.property)()
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09.prototype, "icon", void 0);
$b5d7f0ec091bde43$var$__decorate([
    (0, $cG9dN.property)()
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09.prototype, "walletIcon", void 0);
$b5d7f0ec091bde43$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09.prototype, "installed", void 0);
$b5d7f0ec091bde43$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09.prototype, "disabled", void 0);
$b5d7f0ec091bde43$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09.prototype, "showAllWallets", void 0);
$b5d7f0ec091bde43$export$fe01be9b7ff81a09 = $b5d7f0ec091bde43$var$__decorate([
    (0, $3SCaV.customElement)("wui-list-wallet")
], $b5d7f0ec091bde43$export$fe01be9b7ff81a09);

});
parcelRegister("kc9Rd", function(module, exports) {

$parcel$export(module.exports, "WuiTag", function () { return $03cb4cb1ebb5787f$export$989e5aad4666150; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $9ynUd = parcelRequire("9ynUd");
var $03cb4cb1ebb5787f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $03cb4cb1ebb5787f$export$989e5aad4666150 = class WuiTag extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "main";
    }
    render() {
        this.dataset["variant"] = this.variant;
        return (0, $B77rE.html)`
      <wui-text data-variant=${this.variant} variant="micro-700" color="inherit">
        <slot></slot>
      </wui-text>
    `;
    }
};
$03cb4cb1ebb5787f$export$989e5aad4666150.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $9ynUd.default)
];
$03cb4cb1ebb5787f$var$__decorate([
    (0, $cG9dN.property)()
], $03cb4cb1ebb5787f$export$989e5aad4666150.prototype, "variant", void 0);
$03cb4cb1ebb5787f$export$989e5aad4666150 = $03cb4cb1ebb5787f$var$__decorate([
    (0, $3SCaV.customElement)("wui-tag")
], $03cb4cb1ebb5787f$export$989e5aad4666150);

});
parcelRegister("9ynUd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f49d53308c97584$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $6f49d53308c97584$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
    padding: 3.5px 5px !important;
    border-radius: var(--wui-border-radius-5xs);
  }

  :host([data-variant='main']) {
    background-color: var(--wui-accent-glass-015);
    color: var(--wui-color-accent-100);
  }

  :host([data-variant='shade']) {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-200);
  }

  :host([data-variant='success']) {
    background-color: var(--wui-icon-box-bg-success-100);
    color: var(--wui-color-success-100);
  }

  :host([data-variant='error']) {
    background-color: var(--wui-icon-box-bg-error-100);
    color: var(--wui-color-error-100);
  }
`;

});


parcelRegister("lXq3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffc350c32ab8f825$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $ffc350c32ab8f825$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-100);
  }

  button > wui-text:nth-child(2) {
    display: flex;
    flex: 1;
  }

  wui-icon {
    color: var(--wui-color-fg-200) !important;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-tag {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-300);
  }
`;

});


parcelRegister("5BV2y", function(module, exports) {

$parcel$export(module.exports, "WuiLogoSelect", function () { return $415ca7705bbfc475$export$aadc276ee48f1572; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("gtEBj");

var $i4ioZ = parcelRequire("i4ioZ");
var $415ca7705bbfc475$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $415ca7705bbfc475$export$aadc276ee48f1572 = class WuiLogoSelect extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.logo = "google";
        this.disabled = false;
    }
    render() {
        return (0, $B77rE.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-logo logo=${this.logo}></wui-logo>
      </button>
    `;
    }
};
$415ca7705bbfc475$export$aadc276ee48f1572.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $i4ioZ.default)
];
$415ca7705bbfc475$var$__decorate([
    (0, $cG9dN.property)()
], $415ca7705bbfc475$export$aadc276ee48f1572.prototype, "logo", void 0);
$415ca7705bbfc475$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $415ca7705bbfc475$export$aadc276ee48f1572.prototype, "disabled", void 0);
$415ca7705bbfc475$export$aadc276ee48f1572 = $415ca7705bbfc475$var$__decorate([
    (0, $3SCaV.customElement)("wui-logo-select")
], $415ca7705bbfc475$export$aadc276ee48f1572);

});
parcelRegister("gtEBj", function(module, exports) {

$parcel$export(module.exports, "WuiLogo", function () { return $03187f5fee9163a5$export$e515c2183ed1fdbc; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $1yDYP = parcelRequire("1yDYP");
var $03187f5fee9163a5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $03187f5fee9163a5$export$e515c2183ed1fdbc = class WuiLogo extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.logo = "google";
    }
    render() {
        return (0, $B77rE.html)`<wui-icon color="inherit" size="inherit" name=${this.logo}></wui-icon> `;
    }
};
$03187f5fee9163a5$export$e515c2183ed1fdbc.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $1yDYP.default)
];
$03187f5fee9163a5$var$__decorate([
    (0, $cG9dN.property)()
], $03187f5fee9163a5$export$e515c2183ed1fdbc.prototype, "logo", void 0);
$03187f5fee9163a5$export$e515c2183ed1fdbc = $03187f5fee9163a5$var$__decorate([
    (0, $3SCaV.customElement)("wui-logo")
], $03187f5fee9163a5$export$e515c2183ed1fdbc);

});
parcelRegister("1yDYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1227faa34768a648$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $1227faa34768a648$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-010);
    overflow: hidden;
  }

  wui-icon {
    width: 100%;
    height: 100%;
  }
`;

});


parcelRegister("i4ioZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d276dffca40d9ab3$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $d276dffca40d9ab3$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
  }

  button {
    width: 50px;
    height: 50px;
    background: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;

});


parcelRegister("15zeU", function(module, exports) {

$parcel$export(module.exports, "WuiNetworkButton", function () { return $0cb197e8e93efcec$export$bb00a3a9463dc4a7; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("62Qzz");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("9SgY8");

var $8t3c3 = parcelRequire("8t3c3");
var $0cb197e8e93efcec$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0cb197e8e93efcec$export$bb00a3a9463dc4a7 = class WuiNetworkButton extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.isUnsupportedChain = undefined;
        this.disabled = false;
    }
    render() {
        return (0, $B77rE.html)`
      <button ?disabled=${this.disabled}>
        ${this.visualTemplate()}
        <wui-text variant="paragraph-600" color="inherit">
          <slot></slot>
        </wui-text>
      </button>
    `;
    }
    visualTemplate() {
        if (this.isUnsupportedChain) return (0, $B77rE.html)`
        <wui-icon-box
          size="sm"
          iconColor="error-100"
          backgroundColor="error-100"
          icon="warningCircle"
        ></wui-icon-box>
      `;
        if (this.imageSrc) return (0, $B77rE.html)`<wui-image src=${this.imageSrc}></wui-image>`;
        return (0, $B77rE.html)`
      <wui-icon-box
        size="sm"
        iconColor="inverse-100"
        backgroundColor="fg-100"
        icon="networkPlaceholder"
      ></wui-icon-box>
    `;
    }
};
$0cb197e8e93efcec$export$bb00a3a9463dc4a7.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $8t3c3.default)
];
$0cb197e8e93efcec$var$__decorate([
    (0, $cG9dN.property)()
], $0cb197e8e93efcec$export$bb00a3a9463dc4a7.prototype, "imageSrc", void 0);
$0cb197e8e93efcec$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $0cb197e8e93efcec$export$bb00a3a9463dc4a7.prototype, "isUnsupportedChain", void 0);
$0cb197e8e93efcec$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $0cb197e8e93efcec$export$bb00a3a9463dc4a7.prototype, "disabled", void 0);
$0cb197e8e93efcec$export$bb00a3a9463dc4a7 = $0cb197e8e93efcec$var$__decorate([
    (0, $3SCaV.customElement)("wui-network-button")
], $0cb197e8e93efcec$export$bb00a3a9463dc4a7);

});
parcelRegister("8t3c3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62a38250a2a8ae31$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $62a38250a2a8ae31$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
    display: flex;
    gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-2xs) var(--wui-spacing-s) var(--wui-spacing-2xs)
      var(--wui-spacing-xs);
    border: 1px solid var(--wui-gray-glass-010);
    background-color: var(--wui-gray-glass-005);
    color: var(--wui-color-fg-100);
  }

  button:disabled {
    border: 1px solid var(--wui-gray-glass-005);
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-gray-glass-010);
    }

    button:active:enabled {
      background-color: var(--wui-gray-glass-015);
    }
  }

  wui-image,
  wui-icon-box {
    border-radius: var(--wui-border-radius-3xl);
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }
`;

});


parcelRegister("WQoSR", function(module, exports) {

$parcel$export(module.exports, "WuiOtp", function () { return $0b0e10834dcb10bd$export$443bf27d3bf7bc18; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
var $aJMo2 = parcelRequire("aJMo2");
parcelRequire("276Mo");

var $cRWGJ = parcelRequire("cRWGJ");

var $fRkfl = parcelRequire("fRkfl");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("jAflF");

var $wloQq = parcelRequire("wloQq");
var $0b0e10834dcb10bd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0b0e10834dcb10bd$export$443bf27d3bf7bc18 = class WuiOtp extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.length = 6;
        this.otp = "";
        this.values = Array.from({
            length: this.length
        }).map(()=>"");
        this.numerics = [];
        this.shouldInputBeEnabled = (index)=>{
            const previousInputs = this.values.slice(0, index);
            return previousInputs.every((input)=>input !== "");
        };
        this.handleKeyDown = (e, index)=>{
            const inputElement = e.target;
            const input = this.getInputElement(inputElement);
            const keyArr = [
                "ArrowLeft",
                "ArrowRight",
                "Shift",
                "Delete"
            ];
            if (!input) return;
            if (keyArr.includes(e.key)) e.preventDefault();
            const currentCaretPos = input.selectionStart;
            switch(e.key){
                case "ArrowLeft":
                    if (currentCaretPos) input.setSelectionRange(currentCaretPos + 1, currentCaretPos + 1);
                    this.focusInputField("prev", index);
                    break;
                case "ArrowRight":
                    this.focusInputField("next", index);
                    break;
                case "Shift":
                    this.focusInputField("next", index);
                    break;
                case "Delete":
                    if (input.value === "") this.focusInputField("prev", index);
                    else this.updateInput(input, index, "");
                    break;
                case "Backspace":
                    if (input.value === "") this.focusInputField("prev", index);
                    else this.updateInput(input, index, "");
                    break;
                default:
            }
        };
        this.focusInputField = (dir, index)=>{
            if (dir === "next") {
                const nextIndex = index + 1;
                if (!this.shouldInputBeEnabled(nextIndex)) return;
                const numeric = this.numerics[nextIndex < this.length ? nextIndex : index];
                const input = numeric ? this.getInputElement(numeric) : undefined;
                if (input) {
                    input.disabled = false;
                    input.focus();
                }
            }
            if (dir === "prev") {
                const nextIndex = index - 1;
                const numeric = this.numerics[nextIndex > -1 ? nextIndex : index];
                const input = numeric ? this.getInputElement(numeric) : undefined;
                if (input) input.focus();
            }
        };
    }
    firstUpdated() {
        if (this.otp) this.values = this.otp.split("");
        const numericElements = this.shadowRoot?.querySelectorAll("wui-input-numeric");
        if (numericElements) this.numerics = Array.from(numericElements);
        this.numerics[0]?.focus();
    }
    render() {
        return (0, $B77rE.html)`
      <wui-flex gap="xxs" data-testid="wui-otp-input">
        ${Array.from({
            length: this.length
        }).map((_, index)=>(0, $B77rE.html)`
            <wui-input-numeric
              @input=${(e)=>this.handleInput(e, index)}
              @click=${(e)=>this.selectInput(e)}
              @keydown=${(e)=>this.handleKeyDown(e, index)}
              .disabled=${!this.shouldInputBeEnabled(index)}
              .value=${this.values[index] || ""}
            >
            </wui-input-numeric>
          `)}
      </wui-flex>
    `;
    }
    updateInput(element, index, value) {
        const numeric = this.numerics[index];
        const input = element || (numeric ? this.getInputElement(numeric) : undefined);
        if (input) {
            input.value = value;
            this.values = this.values.map((val, i)=>i === index ? value : val);
        }
    }
    selectInput(e) {
        const targetElement = e.target;
        if (targetElement) {
            const inputElement = this.getInputElement(targetElement);
            inputElement?.select();
        }
    }
    handleInput(e, index) {
        const inputElement = e.target;
        const input = this.getInputElement(inputElement);
        if (input) {
            const inputValue = input.value;
            if (e.inputType === "insertFromPaste") this.handlePaste(input, inputValue, index);
            else {
                const isValid = (0, $fRkfl.UiHelperUtil).isNumber(inputValue);
                if (isValid && e.data) {
                    this.updateInput(input, index, e.data);
                    this.focusInputField("next", index);
                } else this.updateInput(input, index, "");
            }
        }
        this.dispatchInputChangeEvent();
    }
    handlePaste(input, inputValue, index) {
        const value = inputValue[0];
        const isValid = value && (0, $fRkfl.UiHelperUtil).isNumber(value);
        if (isValid) {
            this.updateInput(input, index, value);
            const inputString = inputValue.substring(1);
            if (index + 1 < this.length && inputString.length) {
                const nextNumeric = this.numerics[index + 1];
                const nextInput = nextNumeric ? this.getInputElement(nextNumeric) : undefined;
                if (nextInput) this.handlePaste(nextInput, inputString, index + 1);
            } else this.focusInputField("next", index);
        } else this.updateInput(input, index, "");
    }
    getInputElement(el) {
        if (el.shadowRoot?.querySelector("input")) return el.shadowRoot.querySelector("input");
        return null;
    }
    dispatchInputChangeEvent() {
        const value = this.values.join("");
        this.dispatchEvent(new CustomEvent("inputChange", {
            detail: value,
            bubbles: true,
            composed: true
        }));
    }
};
$0b0e10834dcb10bd$export$443bf27d3bf7bc18.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $wloQq.default)
];
$0b0e10834dcb10bd$var$__decorate([
    (0, $cG9dN.property)({
        type: Number
    })
], $0b0e10834dcb10bd$export$443bf27d3bf7bc18.prototype, "length", void 0);
$0b0e10834dcb10bd$var$__decorate([
    (0, $cG9dN.property)({
        type: String
    })
], $0b0e10834dcb10bd$export$443bf27d3bf7bc18.prototype, "otp", void 0);
$0b0e10834dcb10bd$var$__decorate([
    (0, $aJMo2.state)()
], $0b0e10834dcb10bd$export$443bf27d3bf7bc18.prototype, "values", void 0);
$0b0e10834dcb10bd$export$443bf27d3bf7bc18 = $0b0e10834dcb10bd$var$__decorate([
    (0, $3SCaV.customElement)("wui-otp")
], $0b0e10834dcb10bd$export$443bf27d3bf7bc18);

});
parcelRegister("wloQq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $061396cff930ec3e$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $061396cff930ec3e$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    display: block;
  }
`;

});


parcelRegister("dkCo4", function(module, exports) {

$parcel$export(module.exports, "WuiQrCode", function () { return $9b4aeb897186608d$export$29f6e16532a663bf; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("62Qzz");

var $1Bmkj = parcelRequire("1Bmkj");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $gnTQN = parcelRequire("gnTQN");
var $9b4aeb897186608d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9b4aeb897186608d$export$29f6e16532a663bf = class WuiQrCode extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.uri = "";
        this.size = 0;
        this.theme = "dark";
        this.imageSrc = undefined;
        this.alt = undefined;
    }
    render() {
        this.dataset["theme"] = this.theme;
        this.style.cssText = `--local-size: ${this.size}px`;
        return (0, $B77rE.html)`${this.templateVisual()} ${this.templateSvg()}`;
    }
    templateSvg() {
        const size = this.theme === "light" ? this.size : this.size - 32;
        return (0, $B77rE.svg)`
      <svg height=${size} width=${size}>
        ${(0, $1Bmkj.QrCodeUtil).generate(this.uri, size, size / 4)}
      </svg>
    `;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $B77rE.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "logo"}></wui-image>`;
        return (0, $B77rE.html)`<wui-icon size="inherit" color="inherit" name="walletConnect"></wui-icon>`;
    }
};
$9b4aeb897186608d$export$29f6e16532a663bf.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $gnTQN.default)
];
$9b4aeb897186608d$var$__decorate([
    (0, $cG9dN.property)()
], $9b4aeb897186608d$export$29f6e16532a663bf.prototype, "uri", void 0);
$9b4aeb897186608d$var$__decorate([
    (0, $cG9dN.property)({
        type: Number
    })
], $9b4aeb897186608d$export$29f6e16532a663bf.prototype, "size", void 0);
$9b4aeb897186608d$var$__decorate([
    (0, $cG9dN.property)()
], $9b4aeb897186608d$export$29f6e16532a663bf.prototype, "theme", void 0);
$9b4aeb897186608d$var$__decorate([
    (0, $cG9dN.property)()
], $9b4aeb897186608d$export$29f6e16532a663bf.prototype, "imageSrc", void 0);
$9b4aeb897186608d$var$__decorate([
    (0, $cG9dN.property)()
], $9b4aeb897186608d$export$29f6e16532a663bf.prototype, "alt", void 0);
$9b4aeb897186608d$export$29f6e16532a663bf = $9b4aeb897186608d$var$__decorate([
    (0, $3SCaV.customElement)("wui-qr-code")
], $9b4aeb897186608d$export$29f6e16532a663bf);

});
parcelRegister("1Bmkj", function(module, exports) {

$parcel$export(module.exports, "QrCodeUtil", function () { return $12aa90ba49118e5f$export$2faef7998946735; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");

var $105fR = parcelRequire("105fR");
const $12aa90ba49118e5f$var$CONNECTING_ERROR_MARGIN = 0.1;
const $12aa90ba49118e5f$var$CIRCLE_SIZE_MODIFIER = 2.5;
const $12aa90ba49118e5f$var$QRCODE_MATRIX_MARGIN = 7;
function $12aa90ba49118e5f$var$isAdjecentDots(cy, otherCy, cellSize) {
    if (cy === otherCy) return false;
    const diff = cy - otherCy < 0 ? otherCy - cy : cy - otherCy;
    return diff <= cellSize + $12aa90ba49118e5f$var$CONNECTING_ERROR_MARGIN;
}
function $12aa90ba49118e5f$var$getMatrix(value, errorCorrectionLevel) {
    const arr = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($105fR))).create(value, {
        errorCorrectionLevel: errorCorrectionLevel
    }).modules.data, 0);
    const sqrt = Math.sqrt(arr.length);
    return arr.reduce((rows, key, index)=>(index % sqrt === 0 ? rows.push([
            key
        ]) : rows[rows.length - 1].push(key)) && rows, []);
}
const $12aa90ba49118e5f$export$2faef7998946735 = {
    generate (uri, size, logoSize) {
        const dotColor = "#141414";
        const edgeColor = "transparent";
        const strokeWidth = 5;
        const dots = [];
        const matrix = $12aa90ba49118e5f$var$getMatrix(uri, "Q");
        const cellSize = size / matrix.length;
        const qrList = [
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 0,
                y: 1
            }
        ];
        qrList.forEach(({ x: x, y: y })=>{
            const x1 = (matrix.length - $12aa90ba49118e5f$var$QRCODE_MATRIX_MARGIN) * cellSize * x;
            const y1 = (matrix.length - $12aa90ba49118e5f$var$QRCODE_MATRIX_MARGIN) * cellSize * y;
            const borderRadius = 0.45;
            for(let i = 0; i < qrList.length; i += 1){
                const dotSize = cellSize * ($12aa90ba49118e5f$var$QRCODE_MATRIX_MARGIN - i * 2);
                dots.push((0, $B77rE.svg)`
            <rect
              fill=${i === 2 ? dotColor : edgeColor}
              width=${i === 0 ? dotSize - strokeWidth : dotSize}
              rx= ${i === 0 ? (dotSize - strokeWidth) * borderRadius : dotSize * borderRadius}
              ry= ${i === 0 ? (dotSize - strokeWidth) * borderRadius : dotSize * borderRadius}
              stroke=${dotColor}
              stroke-width=${i === 0 ? strokeWidth : 0}
              height=${i === 0 ? dotSize - strokeWidth : dotSize}
              x= ${i === 0 ? y1 + cellSize * i + strokeWidth / 2 : y1 + cellSize * i}
              y= ${i === 0 ? x1 + cellSize * i + strokeWidth / 2 : x1 + cellSize * i}
            />
          `);
            }
        });
        const clearArenaSize = Math.floor((logoSize + 25) / cellSize);
        const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
        const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
        const circles = [];
        matrix.forEach((row, i)=>{
            row.forEach((_, j)=>{
                if (matrix[i][j]) {
                    if (!(i < $12aa90ba49118e5f$var$QRCODE_MATRIX_MARGIN && j < $12aa90ba49118e5f$var$QRCODE_MATRIX_MARGIN || i > matrix.length - ($12aa90ba49118e5f$var$QRCODE_MATRIX_MARGIN + 1) && j < $12aa90ba49118e5f$var$QRCODE_MATRIX_MARGIN || i < $12aa90ba49118e5f$var$QRCODE_MATRIX_MARGIN && j > matrix.length - ($12aa90ba49118e5f$var$QRCODE_MATRIX_MARGIN + 1))) {
                        if (!(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd)) {
                            const cx = i * cellSize + cellSize / 2;
                            const cy = j * cellSize + cellSize / 2;
                            circles.push([
                                cx,
                                cy
                            ]);
                        }
                    }
                }
            });
        });
        const circlesToConnect = {};
        circles.forEach(([cx, cy])=>{
            if (circlesToConnect[cx]) circlesToConnect[cx]?.push(cy);
            else circlesToConnect[cx] = [
                cy
            ];
        });
        Object.entries(circlesToConnect).map(([cx, cys])=>{
            const newCys = cys.filter((cy)=>cys.every((otherCy)=>!$12aa90ba49118e5f$var$isAdjecentDots(cy, otherCy, cellSize)));
            return [
                Number(cx),
                newCys
            ];
        }).forEach(([cx, cys])=>{
            cys.forEach((cy)=>{
                dots.push((0, $B77rE.svg)`<circle cx=${cx} cy=${cy} fill=${dotColor} r=${cellSize / $12aa90ba49118e5f$var$CIRCLE_SIZE_MODIFIER} />`);
            });
        });
        Object.entries(circlesToConnect).filter(([_, cys])=>cys.length > 1).map(([cx, cys])=>{
            const newCys = cys.filter((cy)=>cys.some((otherCy)=>$12aa90ba49118e5f$var$isAdjecentDots(cy, otherCy, cellSize)));
            return [
                Number(cx),
                newCys
            ];
        }).map(([cx, cys])=>{
            cys.sort((a, b)=>a < b ? -1 : 1);
            const groups = [];
            for (const cy of cys){
                const group = groups.find((item)=>item.some((otherCy)=>$12aa90ba49118e5f$var$isAdjecentDots(cy, otherCy, cellSize)));
                if (group) group.push(cy);
                else groups.push([
                    cy
                ]);
            }
            return [
                cx,
                groups.map((item)=>[
                        item[0],
                        item[item.length - 1]
                    ])
            ];
        }).forEach(([cx, groups])=>{
            groups.forEach(([y1, y2])=>{
                dots.push((0, $B77rE.svg)`
              <line
                x1=${cx}
                x2=${cx}
                y1=${y1}
                y2=${y2}
                stroke=${dotColor}
                stroke-width=${cellSize / ($12aa90ba49118e5f$var$CIRCLE_SIZE_MODIFIER / 2)}
                stroke-linecap="round"
              />
            `);
            });
        });
        return dots;
    }
};

});
parcelRegister("105fR", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $0ba9de07fdc988d2$export$185802fd694ee1f5; }, function (v) { return $0ba9de07fdc988d2$export$185802fd694ee1f5 = v; });
$parcel$export(module.exports, "toCanvas", function () { return $0ba9de07fdc988d2$export$f87f6982d1fd4f81; }, function (v) { return $0ba9de07fdc988d2$export$f87f6982d1fd4f81 = v; });
$parcel$export(module.exports, "toDataURL", function () { return $0ba9de07fdc988d2$export$723e4939e5a27c8; }, function (v) { return $0ba9de07fdc988d2$export$723e4939e5a27c8 = v; });
$parcel$export(module.exports, "toString", function () { return $0ba9de07fdc988d2$export$f84e8e69fd4488a5; }, function (v) { return $0ba9de07fdc988d2$export$f84e8e69fd4488a5 = v; });
var $0ba9de07fdc988d2$export$185802fd694ee1f5;
var $0ba9de07fdc988d2$export$f87f6982d1fd4f81;
var $0ba9de07fdc988d2$export$723e4939e5a27c8;
// only svg for now.
var $0ba9de07fdc988d2$export$f84e8e69fd4488a5;

var $hSajL = parcelRequire("hSajL");

var $fowdr = parcelRequire("fowdr");

var $4lbw2 = parcelRequire("4lbw2");

var $7zRSF = parcelRequire("7zRSF");
function $0ba9de07fdc988d2$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$hSajL()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $fowdr.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $fowdr.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$0ba9de07fdc988d2$export$185802fd694ee1f5 = $fowdr.create;
$0ba9de07fdc988d2$export$f87f6982d1fd4f81 = $0ba9de07fdc988d2$var$renderCanvas.bind(null, $4lbw2.render);
$0ba9de07fdc988d2$export$723e4939e5a27c8 = $0ba9de07fdc988d2$var$renderCanvas.bind(null, $4lbw2.renderToDataURL);
$0ba9de07fdc988d2$export$f84e8e69fd4488a5 = $0ba9de07fdc988d2$var$renderCanvas.bind(null, function(data, _, opts) {
    return $7zRSF.render(data, opts);
});

});
parcelRegister("hSajL", function(module, exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};

});

parcelRegister("fowdr", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $b3521648e2caae77$export$185802fd694ee1f5; }, function (v) { return $b3521648e2caae77$export$185802fd694ee1f5 = v; });
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $b3521648e2caae77$export$185802fd694ee1f5;

var $dgYI8 = parcelRequire("dgYI8");

var $hBBC6 = parcelRequire("hBBC6");

var $idELN = parcelRequire("idELN");

var $kVpL6 = parcelRequire("kVpL6");

var $dqKGw = parcelRequire("dqKGw");

var $5bHJ2 = parcelRequire("5bHJ2");

var $ikAG8 = parcelRequire("ikAG8");

var $9dIYU = parcelRequire("9dIYU");

var $d4Tdf = parcelRequire("d4Tdf");

var $elc7K = parcelRequire("elc7K");

var $58L1x = parcelRequire("58L1x");

var $66Qbf = parcelRequire("66Qbf");

var $6Kupr = parcelRequire("6Kupr");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $b3521648e2caae77$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $5bHJ2.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $b3521648e2caae77$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $b3521648e2caae77$var$setupAlignmentPattern(matrix, version) {
    const pos = $dqKGw.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $b3521648e2caae77$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $elc7K.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $b3521648e2caae77$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $58L1x.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $b3521648e2caae77$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $b3521648e2caae77$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $idELN();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $66Qbf.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $dgYI8.getSymbolTotalCodewords(version);
    const ecTotalCodewords = $9dIYU.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $b3521648e2caae77$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $b3521648e2caae77$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $dgYI8.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $9dIYU.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $9dIYU.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $d4Tdf(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $b3521648e2caae77$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $6Kupr.fromArray(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $6Kupr.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $elc7K.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $6Kupr.fromString(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $elc7K.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $b3521648e2caae77$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $dgYI8.getSymbolSize(version);
    const modules = new $kVpL6(moduleCount);
    // Add function modules
    $b3521648e2caae77$var$setupFinderPattern(modules, version);
    $b3521648e2caae77$var$setupTimingPattern(modules);
    $b3521648e2caae77$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $b3521648e2caae77$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $b3521648e2caae77$var$setupVersionInfo(modules, version);
    // Add data codewords
    $b3521648e2caae77$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $ikAG8.getBestMask(modules, $b3521648e2caae77$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $ikAG8.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    $b3521648e2caae77$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$b3521648e2caae77$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $hBBC6.M;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $hBBC6.from(options.errorCorrectionLevel, $hBBC6.M);
        version = $elc7K.from(options.version);
        mask = $ikAG8.from(options.maskPattern);
        if (options.toSJISFunc) $dgYI8.setToSJISFunction(options.toSJISFunc);
    }
    return $b3521648e2caae77$var$createSymbol(data, version, errorCorrectionLevel, mask);
};

});
parcelRegister("dgYI8", function(module, exports) {

$parcel$export(module.exports, "getSymbolSize", function () { return $9a9bdce3e3254362$export$8d4a06d3facd414b; }, function (v) { return $9a9bdce3e3254362$export$8d4a06d3facd414b = v; });
$parcel$export(module.exports, "getSymbolTotalCodewords", function () { return $9a9bdce3e3254362$export$b05dac13c7a35c32; }, function (v) { return $9a9bdce3e3254362$export$b05dac13c7a35c32 = v; });
$parcel$export(module.exports, "getBCHDigit", function () { return $9a9bdce3e3254362$export$ed1d66da50968976; }, function (v) { return $9a9bdce3e3254362$export$ed1d66da50968976 = v; });
$parcel$export(module.exports, "setToSJISFunction", function () { return $9a9bdce3e3254362$export$6733b14783f975c2; }, function (v) { return $9a9bdce3e3254362$export$6733b14783f975c2 = v; });
$parcel$export(module.exports, "isKanjiModeEnabled", function () { return $9a9bdce3e3254362$export$ce5b1274f8597fa0; }, function (v) { return $9a9bdce3e3254362$export$ce5b1274f8597fa0 = v; });
$parcel$export(module.exports, "toSJIS", function () { return $9a9bdce3e3254362$export$43dd553ecded716d; }, function (v) { return $9a9bdce3e3254362$export$43dd553ecded716d = v; });
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $9a9bdce3e3254362$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $9a9bdce3e3254362$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $9a9bdce3e3254362$export$ed1d66da50968976;
var $9a9bdce3e3254362$export$6733b14783f975c2;
var $9a9bdce3e3254362$export$ce5b1274f8597fa0;
var $9a9bdce3e3254362$export$43dd553ecded716d;
let $9a9bdce3e3254362$var$toSJISFunction;
const $9a9bdce3e3254362$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$9a9bdce3e3254362$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$9a9bdce3e3254362$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $9a9bdce3e3254362$var$CODEWORDS_COUNT[version];
};
$9a9bdce3e3254362$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$9a9bdce3e3254362$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $9a9bdce3e3254362$var$toSJISFunction = f;
};
$9a9bdce3e3254362$export$ce5b1274f8597fa0 = function() {
    return typeof $9a9bdce3e3254362$var$toSJISFunction !== "undefined";
};
$9a9bdce3e3254362$export$43dd553ecded716d = function toSJIS(kanji) {
    return $9a9bdce3e3254362$var$toSJISFunction(kanji);
};

});

parcelRegister("hBBC6", function(module, exports) {

$parcel$export(module.exports, "L", function () { return $cd1311a5e5cf762d$export$61196ced6d74a310; }, function (v) { return $cd1311a5e5cf762d$export$61196ced6d74a310 = v; });
$parcel$export(module.exports, "M", function () { return $cd1311a5e5cf762d$export$3a1a48c8f6ef640e; }, function (v) { return $cd1311a5e5cf762d$export$3a1a48c8f6ef640e = v; });
$parcel$export(module.exports, "Q", function () { return $cd1311a5e5cf762d$export$3722cfe417b6ed86; }, function (v) { return $cd1311a5e5cf762d$export$3722cfe417b6ed86 = v; });
$parcel$export(module.exports, "H", function () { return $cd1311a5e5cf762d$export$7f8ddf7c7c20b3cd; }, function (v) { return $cd1311a5e5cf762d$export$7f8ddf7c7c20b3cd = v; });
$parcel$export(module.exports, "isValid", function () { return $cd1311a5e5cf762d$export$1ea939691cdc45b8; }, function (v) { return $cd1311a5e5cf762d$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $cd1311a5e5cf762d$export$6788812c4e6611e6; }, function (v) { return $cd1311a5e5cf762d$export$6788812c4e6611e6 = v; });
var $cd1311a5e5cf762d$export$61196ced6d74a310;
var $cd1311a5e5cf762d$export$3a1a48c8f6ef640e;
var $cd1311a5e5cf762d$export$3722cfe417b6ed86;
var $cd1311a5e5cf762d$export$7f8ddf7c7c20b3cd;
var $cd1311a5e5cf762d$export$1ea939691cdc45b8;
var $cd1311a5e5cf762d$export$6788812c4e6611e6;
$cd1311a5e5cf762d$export$61196ced6d74a310 = {
    bit: 1
};
$cd1311a5e5cf762d$export$3a1a48c8f6ef640e = {
    bit: 0
};
$cd1311a5e5cf762d$export$3722cfe417b6ed86 = {
    bit: 3
};
$cd1311a5e5cf762d$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $cd1311a5e5cf762d$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $cd1311a5e5cf762d$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $cd1311a5e5cf762d$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $cd1311a5e5cf762d$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $cd1311a5e5cf762d$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$cd1311a5e5cf762d$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$cd1311a5e5cf762d$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($cd1311a5e5cf762d$export$1ea939691cdc45b8(value)) return value;
    try {
        return $cd1311a5e5cf762d$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});

parcelRegister("idELN", function(module, exports) {
function $d43910ef037a0593$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$d43910ef037a0593$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $d43910ef037a0593$var$BitBuffer;

});

parcelRegister("kVpL6", function(module, exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $f3bd1ca8b4beaaba$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $f3bd1ca8b4beaaba$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $f3bd1ca8b4beaaba$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $f3bd1ca8b4beaaba$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $f3bd1ca8b4beaaba$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = $f3bd1ca8b4beaaba$var$BitMatrix;

});

parcelRegister("dqKGw", function(module, exports) {

$parcel$export(module.exports, "getRowColCoords", function () { return $9c71eab61b0e9349$export$cb05537eb8e57a83; }, function (v) { return $9c71eab61b0e9349$export$cb05537eb8e57a83 = v; });
$parcel$export(module.exports, "getPositions", function () { return $9c71eab61b0e9349$export$c39457c570f2b189; }, function (v) { return $9c71eab61b0e9349$export$c39457c570f2b189 = v; });
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $9c71eab61b0e9349$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $9c71eab61b0e9349$export$c39457c570f2b189;

var $dgYI8 = parcelRequire("dgYI8");
var $9c71eab61b0e9349$require$getSymbolSize = $dgYI8.getSymbolSize;
$9c71eab61b0e9349$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $9c71eab61b0e9349$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$9c71eab61b0e9349$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $9c71eab61b0e9349$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

});

parcelRegister("5bHJ2", function(module, exports) {

$parcel$export(module.exports, "getPositions", function () { return $3c6fe5c9fb472bc8$export$c39457c570f2b189; }, function (v) { return $3c6fe5c9fb472bc8$export$c39457c570f2b189 = v; });
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $3c6fe5c9fb472bc8$export$c39457c570f2b189;

var $dgYI8 = parcelRequire("dgYI8");
var $3c6fe5c9fb472bc8$require$getSymbolSize = $dgYI8.getSymbolSize;
const $3c6fe5c9fb472bc8$var$FINDER_PATTERN_SIZE = 7;
$3c6fe5c9fb472bc8$export$c39457c570f2b189 = function getPositions(version) {
    const size = $3c6fe5c9fb472bc8$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $3c6fe5c9fb472bc8$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $3c6fe5c9fb472bc8$var$FINDER_PATTERN_SIZE
        ]
    ];
};

});

parcelRegister("ikAG8", function(module, exports) {

$parcel$export(module.exports, "Patterns", function () { return $d5868bdf855537a6$export$7ed115685df827af; }, function (v) { return $d5868bdf855537a6$export$7ed115685df827af = v; });
$parcel$export(module.exports, "isValid", function () { return $d5868bdf855537a6$export$1ea939691cdc45b8; }, function (v) { return $d5868bdf855537a6$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $d5868bdf855537a6$export$6788812c4e6611e6; }, function (v) { return $d5868bdf855537a6$export$6788812c4e6611e6 = v; });
$parcel$export(module.exports, "getPenaltyN1", function () { return $d5868bdf855537a6$export$a5fd3a02c14d0b3e; }, function (v) { return $d5868bdf855537a6$export$a5fd3a02c14d0b3e = v; });
$parcel$export(module.exports, "getPenaltyN2", function () { return $d5868bdf855537a6$export$9a9385107a518e46; }, function (v) { return $d5868bdf855537a6$export$9a9385107a518e46 = v; });
$parcel$export(module.exports, "getPenaltyN3", function () { return $d5868bdf855537a6$export$ade754353f0dc75e; }, function (v) { return $d5868bdf855537a6$export$ade754353f0dc75e = v; });
$parcel$export(module.exports, "getPenaltyN4", function () { return $d5868bdf855537a6$export$3ff6f04d40d9962b; }, function (v) { return $d5868bdf855537a6$export$3ff6f04d40d9962b = v; });
$parcel$export(module.exports, "applyMask", function () { return $d5868bdf855537a6$export$a1c9aa9c0e8ba394; }, function (v) { return $d5868bdf855537a6$export$a1c9aa9c0e8ba394 = v; });
$parcel$export(module.exports, "getBestMask", function () { return $d5868bdf855537a6$export$fe9625aaceb0e563; }, function (v) { return $d5868bdf855537a6$export$fe9625aaceb0e563 = v; });
/**
 * Data mask pattern reference
 * @type {Object}
 */ var $d5868bdf855537a6$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $d5868bdf855537a6$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $d5868bdf855537a6$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $d5868bdf855537a6$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $d5868bdf855537a6$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $d5868bdf855537a6$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $d5868bdf855537a6$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $d5868bdf855537a6$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $d5868bdf855537a6$export$fe9625aaceb0e563;
$d5868bdf855537a6$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $d5868bdf855537a6$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$d5868bdf855537a6$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$d5868bdf855537a6$export$6788812c4e6611e6 = function from(value) {
    return $d5868bdf855537a6$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$d5868bdf855537a6$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $d5868bdf855537a6$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $d5868bdf855537a6$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $d5868bdf855537a6$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $d5868bdf855537a6$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$d5868bdf855537a6$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $d5868bdf855537a6$var$PenaltyScores.N2;
};
$d5868bdf855537a6$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $d5868bdf855537a6$var$PenaltyScores.N3;
};
$d5868bdf855537a6$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $d5868bdf855537a6$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $d5868bdf855537a6$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $d5868bdf855537a6$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $d5868bdf855537a6$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $d5868bdf855537a6$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $d5868bdf855537a6$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $d5868bdf855537a6$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $d5868bdf855537a6$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $d5868bdf855537a6$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $d5868bdf855537a6$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$d5868bdf855537a6$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $d5868bdf855537a6$var$getMaskAt(pattern, row, col));
    }
};
$d5868bdf855537a6$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($d5868bdf855537a6$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $d5868bdf855537a6$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $d5868bdf855537a6$export$a5fd3a02c14d0b3e(data) + $d5868bdf855537a6$export$9a9385107a518e46(data) + $d5868bdf855537a6$export$ade754353f0dc75e(data) + $d5868bdf855537a6$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $d5868bdf855537a6$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

});

parcelRegister("9dIYU", function(module, exports) {

$parcel$export(module.exports, "getBlocksCount", function () { return $6b683853311fba3e$export$41a1fc627aca72b9; }, function (v) { return $6b683853311fba3e$export$41a1fc627aca72b9 = v; });
$parcel$export(module.exports, "getTotalCodewordsCount", function () { return $6b683853311fba3e$export$683d1b3e8a1a8438; }, function (v) { return $6b683853311fba3e$export$683d1b3e8a1a8438 = v; });
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $6b683853311fba3e$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $6b683853311fba3e$export$683d1b3e8a1a8438;

var $hBBC6 = parcelRequire("hBBC6");
const $6b683853311fba3e$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $6b683853311fba3e$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$6b683853311fba3e$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $hBBC6.L:
            return $6b683853311fba3e$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $hBBC6.M:
            return $6b683853311fba3e$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $hBBC6.Q:
            return $6b683853311fba3e$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $hBBC6.H:
            return $6b683853311fba3e$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$6b683853311fba3e$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $hBBC6.L:
            return $6b683853311fba3e$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $hBBC6.M:
            return $6b683853311fba3e$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $hBBC6.Q:
            return $6b683853311fba3e$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $hBBC6.H:
            return $6b683853311fba3e$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

});

parcelRegister("d4Tdf", function(module, exports) {

var $4VAF9 = parcelRequire("4VAF9");
function $98567a2ee26fcdc2$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $98567a2ee26fcdc2$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $4VAF9.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $98567a2ee26fcdc2$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $4VAF9.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = $98567a2ee26fcdc2$var$ReedSolomonEncoder;

});
parcelRegister("4VAF9", function(module, exports) {

$parcel$export(module.exports, "mul", function () { return $3968ecbc4fe77271$export$6e3a27864ab166fe; }, function (v) { return $3968ecbc4fe77271$export$6e3a27864ab166fe = v; });
$parcel$export(module.exports, "mod", function () { return $3968ecbc4fe77271$export$842a2cf37af977e1; }, function (v) { return $3968ecbc4fe77271$export$842a2cf37af977e1 = v; });
$parcel$export(module.exports, "generateECPolynomial", function () { return $3968ecbc4fe77271$export$7b8be06a973a9d05; }, function (v) { return $3968ecbc4fe77271$export$7b8be06a973a9d05 = v; });
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $3968ecbc4fe77271$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $3968ecbc4fe77271$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $3968ecbc4fe77271$export$7b8be06a973a9d05;

var $6eDHa = parcelRequire("6eDHa");
$3968ecbc4fe77271$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $6eDHa.mul(p1[i], p2[j]);
    return coeff;
};
$3968ecbc4fe77271$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $6eDHa.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$3968ecbc4fe77271$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $3968ecbc4fe77271$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $6eDHa.exp(i)
    ]));
    return poly;
};

});
parcelRegister("6eDHa", function(module, exports) {

$parcel$export(module.exports, "exp", function () { return $48a2d78574204da9$export$b310ec824aaee37f; }, function (v) { return $48a2d78574204da9$export$b310ec824aaee37f = v; });
$parcel$export(module.exports, "mul", function () { return $48a2d78574204da9$export$6e3a27864ab166fe; }, function (v) { return $48a2d78574204da9$export$6e3a27864ab166fe = v; });
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $48a2d78574204da9$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $48a2d78574204da9$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $48a2d78574204da9$export$6e3a27864ab166fe;
const $48a2d78574204da9$var$EXP_TABLE = new Uint8Array(512);
const $48a2d78574204da9$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $48a2d78574204da9$var$EXP_TABLE[i] = x;
        $48a2d78574204da9$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$48a2d78574204da9$var$EXP_TABLE[i] = $48a2d78574204da9$var$EXP_TABLE[i - 255];
})();
$48a2d78574204da9$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $48a2d78574204da9$var$LOG_TABLE[n];
};
$48a2d78574204da9$export$b310ec824aaee37f = function exp(n) {
    return $48a2d78574204da9$var$EXP_TABLE[n];
};
$48a2d78574204da9$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $48a2d78574204da9$var$EXP_TABLE[$48a2d78574204da9$var$LOG_TABLE[x] + $48a2d78574204da9$var$LOG_TABLE[y]];
};

});



parcelRegister("elc7K", function(module, exports) {

$parcel$export(module.exports, "getCapacity", function () { return $a70c6e6b778a16cd$export$55b283886ec2d3fb; }, function (v) { return $a70c6e6b778a16cd$export$55b283886ec2d3fb = v; });
$parcel$export(module.exports, "from", function () { return $a70c6e6b778a16cd$export$6788812c4e6611e6; }, function (v) { return $a70c6e6b778a16cd$export$6788812c4e6611e6 = v; });
$parcel$export(module.exports, "getBestVersionForData", function () { return $a70c6e6b778a16cd$export$264e969aa7a8ff7e; }, function (v) { return $a70c6e6b778a16cd$export$264e969aa7a8ff7e = v; });
$parcel$export(module.exports, "getEncodedBits", function () { return $a70c6e6b778a16cd$export$eee5438974ef6f0e; }, function (v) { return $a70c6e6b778a16cd$export$eee5438974ef6f0e = v; });
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $a70c6e6b778a16cd$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $a70c6e6b778a16cd$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $a70c6e6b778a16cd$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $a70c6e6b778a16cd$export$eee5438974ef6f0e;

var $dgYI8 = parcelRequire("dgYI8");

var $9dIYU = parcelRequire("9dIYU");

var $hBBC6 = parcelRequire("hBBC6");

var $66Qbf = parcelRequire("66Qbf");

var $imitY = parcelRequire("imitY");
// Generator polynomial used to encode version information
const $a70c6e6b778a16cd$var$G18 = 7973;
const $a70c6e6b778a16cd$var$G18_BCH = $dgYI8.getBCHDigit($a70c6e6b778a16cd$var$G18);
function $a70c6e6b778a16cd$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $a70c6e6b778a16cd$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $a70c6e6b778a16cd$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $66Qbf.getCharCountIndicator(mode, version) + 4;
}
function $a70c6e6b778a16cd$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $a70c6e6b778a16cd$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $a70c6e6b778a16cd$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $a70c6e6b778a16cd$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $a70c6e6b778a16cd$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $66Qbf.MIXED)) return currentVersion;
    }
    return undefined;
}
$a70c6e6b778a16cd$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($imitY.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
$a70c6e6b778a16cd$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$imitY.isValid(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $66Qbf.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $dgYI8.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $9dIYU.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $66Qbf.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $a70c6e6b778a16cd$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $66Qbf.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case $66Qbf.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case $66Qbf.KANJI:
            return Math.floor(usableBits / 13);
        case $66Qbf.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
$a70c6e6b778a16cd$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $hBBC6.from(errorCorrectionLevel, $hBBC6.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return $a70c6e6b778a16cd$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $a70c6e6b778a16cd$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$a70c6e6b778a16cd$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$imitY.isValid(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($dgYI8.getBCHDigit(d) - $a70c6e6b778a16cd$var$G18_BCH >= 0)d ^= $a70c6e6b778a16cd$var$G18 << $dgYI8.getBCHDigit(d) - $a70c6e6b778a16cd$var$G18_BCH;
    return version << 12 | d;
};

});
parcelRegister("66Qbf", function(module, exports) {

$parcel$export(module.exports, "NUMERIC", function () { return $472bc78dfb49fb2f$export$4d318981b5a83836; }, function (v) { return $472bc78dfb49fb2f$export$4d318981b5a83836 = v; });
$parcel$export(module.exports, "ALPHANUMERIC", function () { return $472bc78dfb49fb2f$export$376a9ed239d6c1c8; }, function (v) { return $472bc78dfb49fb2f$export$376a9ed239d6c1c8 = v; });
$parcel$export(module.exports, "BYTE", function () { return $472bc78dfb49fb2f$export$8f4bf8f7eb581284; }, function (v) { return $472bc78dfb49fb2f$export$8f4bf8f7eb581284 = v; });
$parcel$export(module.exports, "KANJI", function () { return $472bc78dfb49fb2f$export$a4d452c2363c8e12; }, function (v) { return $472bc78dfb49fb2f$export$a4d452c2363c8e12 = v; });
$parcel$export(module.exports, "MIXED", function () { return $472bc78dfb49fb2f$export$bb410559a65d3418; }, function (v) { return $472bc78dfb49fb2f$export$bb410559a65d3418 = v; });
$parcel$export(module.exports, "getCharCountIndicator", function () { return $472bc78dfb49fb2f$export$e79764af6ffaeb8d; }, function (v) { return $472bc78dfb49fb2f$export$e79764af6ffaeb8d = v; });
$parcel$export(module.exports, "getBestModeForData", function () { return $472bc78dfb49fb2f$export$1bd4c93ffb42e55e; }, function (v) { return $472bc78dfb49fb2f$export$1bd4c93ffb42e55e = v; });
$parcel$export(module.exports, "toString", function () { return $472bc78dfb49fb2f$export$f84e8e69fd4488a5; }, function (v) { return $472bc78dfb49fb2f$export$f84e8e69fd4488a5 = v; });
$parcel$export(module.exports, "isValid", function () { return $472bc78dfb49fb2f$export$1ea939691cdc45b8; }, function (v) { return $472bc78dfb49fb2f$export$1ea939691cdc45b8 = v; });
$parcel$export(module.exports, "from", function () { return $472bc78dfb49fb2f$export$6788812c4e6611e6; }, function (v) { return $472bc78dfb49fb2f$export$6788812c4e6611e6 = v; });
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $472bc78dfb49fb2f$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $472bc78dfb49fb2f$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $472bc78dfb49fb2f$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $472bc78dfb49fb2f$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $472bc78dfb49fb2f$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $472bc78dfb49fb2f$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $472bc78dfb49fb2f$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $472bc78dfb49fb2f$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $472bc78dfb49fb2f$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $472bc78dfb49fb2f$export$6788812c4e6611e6;

var $imitY = parcelRequire("imitY");

var $8WykY = parcelRequire("8WykY");
$472bc78dfb49fb2f$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$472bc78dfb49fb2f$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$472bc78dfb49fb2f$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$472bc78dfb49fb2f$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$472bc78dfb49fb2f$export$bb410559a65d3418 = {
    bit: -1
};
$472bc78dfb49fb2f$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$imitY.isValid(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$472bc78dfb49fb2f$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($8WykY.testNumeric(dataStr)) return $472bc78dfb49fb2f$export$4d318981b5a83836;
    else if ($8WykY.testAlphanumeric(dataStr)) return $472bc78dfb49fb2f$export$376a9ed239d6c1c8;
    else if ($8WykY.testKanji(dataStr)) return $472bc78dfb49fb2f$export$a4d452c2363c8e12;
    else return $472bc78dfb49fb2f$export$8f4bf8f7eb581284;
};
$472bc78dfb49fb2f$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$472bc78dfb49fb2f$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $472bc78dfb49fb2f$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $472bc78dfb49fb2f$export$4d318981b5a83836;
        case "alphanumeric":
            return $472bc78dfb49fb2f$export$376a9ed239d6c1c8;
        case "kanji":
            return $472bc78dfb49fb2f$export$a4d452c2363c8e12;
        case "byte":
            return $472bc78dfb49fb2f$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$472bc78dfb49fb2f$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($472bc78dfb49fb2f$export$1ea939691cdc45b8(value)) return value;
    try {
        return $472bc78dfb49fb2f$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});
parcelRegister("imitY", function(module, exports) {

$parcel$export(module.exports, "isValid", function () { return $d5d89e45e49e2028$export$1ea939691cdc45b8; }, function (v) { return $d5d89e45e49e2028$export$1ea939691cdc45b8 = v; });
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $d5d89e45e49e2028$export$1ea939691cdc45b8;
$d5d89e45e49e2028$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

});

parcelRegister("8WykY", function(module, exports) {

$parcel$export(module.exports, "KANJI", function () { return $682e6028ef94bc4b$export$a4d452c2363c8e12; }, function (v) { return $682e6028ef94bc4b$export$a4d452c2363c8e12 = v; });
$parcel$export(module.exports, "BYTE_KANJI", function () { return $682e6028ef94bc4b$export$9df7c29d562bab83; }, function (v) { return $682e6028ef94bc4b$export$9df7c29d562bab83 = v; });
$parcel$export(module.exports, "BYTE", function () { return $682e6028ef94bc4b$export$8f4bf8f7eb581284; }, function (v) { return $682e6028ef94bc4b$export$8f4bf8f7eb581284 = v; });
$parcel$export(module.exports, "NUMERIC", function () { return $682e6028ef94bc4b$export$4d318981b5a83836; }, function (v) { return $682e6028ef94bc4b$export$4d318981b5a83836 = v; });
$parcel$export(module.exports, "ALPHANUMERIC", function () { return $682e6028ef94bc4b$export$376a9ed239d6c1c8; }, function (v) { return $682e6028ef94bc4b$export$376a9ed239d6c1c8 = v; });
$parcel$export(module.exports, "testKanji", function () { return $682e6028ef94bc4b$export$175f16aef75a4569; }, function (v) { return $682e6028ef94bc4b$export$175f16aef75a4569 = v; });
$parcel$export(module.exports, "testNumeric", function () { return $682e6028ef94bc4b$export$50b7f9bf92c74274; }, function (v) { return $682e6028ef94bc4b$export$50b7f9bf92c74274 = v; });
$parcel$export(module.exports, "testAlphanumeric", function () { return $682e6028ef94bc4b$export$4ba5f52893b4ac97; }, function (v) { return $682e6028ef94bc4b$export$4ba5f52893b4ac97 = v; });
var $682e6028ef94bc4b$export$a4d452c2363c8e12;
var $682e6028ef94bc4b$export$9df7c29d562bab83;
var $682e6028ef94bc4b$export$8f4bf8f7eb581284;
var $682e6028ef94bc4b$export$4d318981b5a83836;
var $682e6028ef94bc4b$export$376a9ed239d6c1c8;
var $682e6028ef94bc4b$export$175f16aef75a4569;
var $682e6028ef94bc4b$export$50b7f9bf92c74274;
var $682e6028ef94bc4b$export$4ba5f52893b4ac97;
const $682e6028ef94bc4b$var$numeric = "[0-9]+";
const $682e6028ef94bc4b$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $682e6028ef94bc4b$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$682e6028ef94bc4b$var$kanji = $682e6028ef94bc4b$var$kanji.replace(/u/g, "\\u");
const $682e6028ef94bc4b$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $682e6028ef94bc4b$var$kanji + ")(?:.|[\r\n]))+";
$682e6028ef94bc4b$export$a4d452c2363c8e12 = new RegExp($682e6028ef94bc4b$var$kanji, "g");
$682e6028ef94bc4b$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$682e6028ef94bc4b$export$8f4bf8f7eb581284 = new RegExp($682e6028ef94bc4b$var$byte, "g");
$682e6028ef94bc4b$export$4d318981b5a83836 = new RegExp($682e6028ef94bc4b$var$numeric, "g");
$682e6028ef94bc4b$export$376a9ed239d6c1c8 = new RegExp($682e6028ef94bc4b$var$alphanumeric, "g");
const $682e6028ef94bc4b$var$TEST_KANJI = new RegExp("^" + $682e6028ef94bc4b$var$kanji + "$");
const $682e6028ef94bc4b$var$TEST_NUMERIC = new RegExp("^" + $682e6028ef94bc4b$var$numeric + "$");
const $682e6028ef94bc4b$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$682e6028ef94bc4b$export$175f16aef75a4569 = function testKanji(str) {
    return $682e6028ef94bc4b$var$TEST_KANJI.test(str);
};
$682e6028ef94bc4b$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $682e6028ef94bc4b$var$TEST_NUMERIC.test(str);
};
$682e6028ef94bc4b$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $682e6028ef94bc4b$var$TEST_ALPHANUMERIC.test(str);
};

});



parcelRegister("58L1x", function(module, exports) {

$parcel$export(module.exports, "getEncodedBits", function () { return $3be22d139fbad2e0$export$eee5438974ef6f0e; }, function (v) { return $3be22d139fbad2e0$export$eee5438974ef6f0e = v; });
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $3be22d139fbad2e0$export$eee5438974ef6f0e;

var $dgYI8 = parcelRequire("dgYI8");
const $3be22d139fbad2e0$var$G15 = 1335;
const $3be22d139fbad2e0$var$G15_MASK = 21522;
const $3be22d139fbad2e0$var$G15_BCH = $dgYI8.getBCHDigit($3be22d139fbad2e0$var$G15);
$3be22d139fbad2e0$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($dgYI8.getBCHDigit(d) - $3be22d139fbad2e0$var$G15_BCH >= 0)d ^= $3be22d139fbad2e0$var$G15 << $dgYI8.getBCHDigit(d) - $3be22d139fbad2e0$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $3be22d139fbad2e0$var$G15_MASK;
};

});

parcelRegister("6Kupr", function(module, exports) {

$parcel$export(module.exports, "fromArray", function () { return $4e9ea09c493ec79a$export$571d59b505e6bb4e; }, function (v) { return $4e9ea09c493ec79a$export$571d59b505e6bb4e = v; });
$parcel$export(module.exports, "fromString", function () { return $4e9ea09c493ec79a$export$3004f64547af360e; }, function (v) { return $4e9ea09c493ec79a$export$3004f64547af360e = v; });
$parcel$export(module.exports, "rawSplit", function () { return $4e9ea09c493ec79a$export$89ab1afb9839589b; }, function (v) { return $4e9ea09c493ec79a$export$89ab1afb9839589b = v; });
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $4e9ea09c493ec79a$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $4e9ea09c493ec79a$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $4e9ea09c493ec79a$export$89ab1afb9839589b;

var $66Qbf = parcelRequire("66Qbf");

var $3hMMB = parcelRequire("3hMMB");

var $jhcLK = parcelRequire("jhcLK");

var $47Qr7 = parcelRequire("47Qr7");

var $kwHF1 = parcelRequire("kwHF1");

var $8WykY = parcelRequire("8WykY");

var $dgYI8 = parcelRequire("dgYI8");

var $7hI6X = parcelRequire("7hI6X");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $4e9ea09c493ec79a$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $4e9ea09c493ec79a$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $4e9ea09c493ec79a$var$getSegmentsFromString(dataStr) {
    const numSegs = $4e9ea09c493ec79a$var$getSegments($8WykY.NUMERIC, $66Qbf.NUMERIC, dataStr);
    const alphaNumSegs = $4e9ea09c493ec79a$var$getSegments($8WykY.ALPHANUMERIC, $66Qbf.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($dgYI8.isKanjiModeEnabled()) {
        byteSegs = $4e9ea09c493ec79a$var$getSegments($8WykY.BYTE, $66Qbf.BYTE, dataStr);
        kanjiSegs = $4e9ea09c493ec79a$var$getSegments($8WykY.KANJI, $66Qbf.KANJI, dataStr);
    } else {
        byteSegs = $4e9ea09c493ec79a$var$getSegments($8WykY.BYTE_KANJI, $66Qbf.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $4e9ea09c493ec79a$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $66Qbf.NUMERIC:
            return $3hMMB.getBitsLength(length);
        case $66Qbf.ALPHANUMERIC:
            return $jhcLK.getBitsLength(length);
        case $66Qbf.KANJI:
            return $kwHF1.getBitsLength(length);
        case $66Qbf.BYTE:
            return $47Qr7.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $4e9ea09c493ec79a$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $4e9ea09c493ec79a$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $66Qbf.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $66Qbf.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $66Qbf.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $66Qbf.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $66Qbf.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $66Qbf.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $66Qbf.BYTE,
                        length: $4e9ea09c493ec79a$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $66Qbf.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $66Qbf.BYTE,
                        length: $4e9ea09c493ec79a$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $4e9ea09c493ec79a$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $4e9ea09c493ec79a$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $4e9ea09c493ec79a$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $4e9ea09c493ec79a$var$getSegmentBitsLength(node.length, node.mode) + 4 + $66Qbf.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $4e9ea09c493ec79a$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $66Qbf.getBestModeForData(data);
    mode = $66Qbf.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $66Qbf.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $66Qbf.toString(mode) + ".\n Suggested mode is: " + $66Qbf.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $66Qbf.KANJI && !$dgYI8.isKanjiModeEnabled()) mode = $66Qbf.BYTE;
    switch(mode){
        case $66Qbf.NUMERIC:
            return new $3hMMB(data);
        case $66Qbf.ALPHANUMERIC:
            return new $jhcLK(data);
        case $66Qbf.KANJI:
            return new $kwHF1(data);
        case $66Qbf.BYTE:
            return new $47Qr7(data);
    }
}
$4e9ea09c493ec79a$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($4e9ea09c493ec79a$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($4e9ea09c493ec79a$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$4e9ea09c493ec79a$export$3004f64547af360e = function fromString(data, version) {
    const segs = $4e9ea09c493ec79a$var$getSegmentsFromString(data, $dgYI8.isKanjiModeEnabled());
    const nodes = $4e9ea09c493ec79a$var$buildNodes(segs);
    const graph = $4e9ea09c493ec79a$var$buildGraph(nodes, version);
    const path = $7hI6X.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $4e9ea09c493ec79a$export$571d59b505e6bb4e($4e9ea09c493ec79a$var$mergeSegments(optimizedSegs));
};
$4e9ea09c493ec79a$export$89ab1afb9839589b = function rawSplit(data) {
    return $4e9ea09c493ec79a$export$571d59b505e6bb4e($4e9ea09c493ec79a$var$getSegmentsFromString(data, $dgYI8.isKanjiModeEnabled()));
};

});
parcelRegister("3hMMB", function(module, exports) {

var $66Qbf = parcelRequire("66Qbf");
function $2648cce711718264$var$NumericData(data) {
    this.mode = $66Qbf.NUMERIC;
    this.data = data.toString();
}
$2648cce711718264$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$2648cce711718264$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$2648cce711718264$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $2648cce711718264$var$NumericData.getBitsLength(this.data.length);
};
$2648cce711718264$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = $2648cce711718264$var$NumericData;

});

parcelRegister("jhcLK", function(module, exports) {

var $66Qbf = parcelRequire("66Qbf");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $e089828b288a4483$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $e089828b288a4483$var$AlphanumericData(data) {
    this.mode = $66Qbf.ALPHANUMERIC;
    this.data = data;
}
$e089828b288a4483$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$e089828b288a4483$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$e089828b288a4483$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $e089828b288a4483$var$AlphanumericData.getBitsLength(this.data.length);
};
$e089828b288a4483$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $e089828b288a4483$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $e089828b288a4483$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($e089828b288a4483$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = $e089828b288a4483$var$AlphanumericData;

});

parcelRegister("47Qr7", function(module, exports) {

var $gI1CL = parcelRequire("gI1CL");

var $66Qbf = parcelRequire("66Qbf");
function $30107da9a1317a29$var$ByteData(data) {
    this.mode = $66Qbf.BYTE;
    if (typeof data === "string") data = $gI1CL(data);
    this.data = new Uint8Array(data);
}
$30107da9a1317a29$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$30107da9a1317a29$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$30107da9a1317a29$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $30107da9a1317a29$var$ByteData.getBitsLength(this.data.length);
};
$30107da9a1317a29$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = $30107da9a1317a29$var$ByteData;

});
parcelRegister("gI1CL", function(module, exports) {
"use strict";
module.exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};

});


parcelRegister("kwHF1", function(module, exports) {

var $66Qbf = parcelRequire("66Qbf");

var $dgYI8 = parcelRequire("dgYI8");
function $ef18a9e226176411$var$KanjiData(data) {
    this.mode = $66Qbf.KANJI;
    this.data = data;
}
$ef18a9e226176411$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$ef18a9e226176411$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$ef18a9e226176411$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $ef18a9e226176411$var$KanjiData.getBitsLength(this.data.length);
};
$ef18a9e226176411$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $dgYI8.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = $ef18a9e226176411$var$KanjiData;

});

parcelRegister("7hI6X", function(module, exports) {
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $54dc56861643c1f2$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $54dc56861643c1f2$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $54dc56861643c1f2$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $54dc56861643c1f2$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $54dc56861643c1f2$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = $54dc56861643c1f2$var$dijkstra;

});



parcelRegister("4lbw2", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $32920e5f9c5b24ed$export$b3890eb0ae9dca99; }, function (v) { return $32920e5f9c5b24ed$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "renderToDataURL", function () { return $32920e5f9c5b24ed$export$c3e5526bbaf70a25; }, function (v) { return $32920e5f9c5b24ed$export$c3e5526bbaf70a25 = v; });
var $32920e5f9c5b24ed$export$b3890eb0ae9dca99;
var $32920e5f9c5b24ed$export$c3e5526bbaf70a25;

var $gx0Gx = parcelRequire("gx0Gx");
function $32920e5f9c5b24ed$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $32920e5f9c5b24ed$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$32920e5f9c5b24ed$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $32920e5f9c5b24ed$var$getCanvasElement();
    opts = $gx0Gx.getOptions(opts);
    const size = $gx0Gx.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $gx0Gx.qrToImageData(image.data, qrData, opts);
    $32920e5f9c5b24ed$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$32920e5f9c5b24ed$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $32920e5f9c5b24ed$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

});
parcelRegister("gx0Gx", function(module, exports) {

$parcel$export(module.exports, "getOptions", function () { return $c090426e77b3b191$export$d2312e68e1f5ad00; }, function (v) { return $c090426e77b3b191$export$d2312e68e1f5ad00 = v; });
$parcel$export(module.exports, "getScale", function () { return $c090426e77b3b191$export$5cdac61cf538712e; }, function (v) { return $c090426e77b3b191$export$5cdac61cf538712e = v; });
$parcel$export(module.exports, "getImageWidth", function () { return $c090426e77b3b191$export$c3a1a1f268a8142b; }, function (v) { return $c090426e77b3b191$export$c3a1a1f268a8142b = v; });
$parcel$export(module.exports, "qrToImageData", function () { return $c090426e77b3b191$export$83136f57c739c5f3; }, function (v) { return $c090426e77b3b191$export$83136f57c739c5f3 = v; });
var $c090426e77b3b191$export$d2312e68e1f5ad00;
var $c090426e77b3b191$export$5cdac61cf538712e;
var $c090426e77b3b191$export$c3a1a1f268a8142b;
var $c090426e77b3b191$export$83136f57c739c5f3;
function $c090426e77b3b191$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$c090426e77b3b191$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c090426e77b3b191$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $c090426e77b3b191$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c090426e77b3b191$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c090426e77b3b191$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c090426e77b3b191$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c090426e77b3b191$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c090426e77b3b191$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

});


parcelRegister("7zRSF", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $584598ddbe0e8dbe$export$b3890eb0ae9dca99; }, function (v) { return $584598ddbe0e8dbe$export$b3890eb0ae9dca99 = v; });
var $584598ddbe0e8dbe$export$b3890eb0ae9dca99;

var $gx0Gx = parcelRequire("gx0Gx");
function $584598ddbe0e8dbe$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $584598ddbe0e8dbe$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $584598ddbe0e8dbe$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $584598ddbe0e8dbe$var$svgCmd("M", col + margin, 0.5 + row + margin) : $584598ddbe0e8dbe$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $584598ddbe0e8dbe$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$584598ddbe0e8dbe$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $gx0Gx.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $584598ddbe0e8dbe$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $584598ddbe0e8dbe$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $584598ddbe0e8dbe$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};

});



parcelRegister("gnTQN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beda1e164609f153$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $beda1e164609f153$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    user-select: none;
    display: block;
    overflow: hidden;
    aspect-ratio: 1 / 1;
    width: var(--local-size);
  }

  :host([data-theme='dark']) {
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px);
    background-color: var(--wui-color-inverse-100);
    padding: var(--wui-spacing-l);
  }

  :host([data-theme='light']) {
    box-shadow: 0 0 0 1px var(--wui-color-bg-125);
    background-color: var(--wui-color-bg-125);
  }

  svg:first-child,
  wui-image,
  wui-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }

  wui-image {
    width: 25%;
    height: 25%;
    border-radius: var(--wui-border-radius-xs);
  }

  wui-icon {
    width: 100%;
    height: 100%;
    color: #3396ff !important;
    transform: translateY(-50%) translateX(-50%) scale(0.25);
  }
`;

});


parcelRegister("eiKZE", function(module, exports) {

$parcel$export(module.exports, "WuiSearchBar", function () { return $a697330ca6c260b5$export$208b8ce22c764062; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("b7QUT");
var $iqKB3 = parcelRequire("iqKB3");
parcelRequire("fI5Lg");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("lAcfs");

var $aylup = parcelRequire("aylup");
var $a697330ca6c260b5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a697330ca6c260b5$export$208b8ce22c764062 = class WuiSearchBar extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.inputComponentRef = (0, $iqKB3.createRef)();
    }
    render() {
        return (0, $B77rE.html)`
      <wui-input-text
        ${(0, $iqKB3.ref)(this.inputComponentRef)}
        placeholder="Search wallet"
        icon="search"
        type="search"
        enterKeyHint="search"
        size="sm"
      >
        <wui-input-element @click=${this.clearValue} icon="close"></wui-input-element>
      </wui-input-text>
    `;
    }
    clearValue() {
        const inputComponent = this.inputComponentRef.value;
        const inputElement = inputComponent?.inputElementRef.value;
        if (inputElement) {
            inputElement.value = "";
            inputElement.focus();
            inputElement.dispatchEvent(new Event("input"));
        }
    }
};
$a697330ca6c260b5$export$208b8ce22c764062.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $aylup.default)
];
$a697330ca6c260b5$export$208b8ce22c764062 = $a697330ca6c260b5$var$__decorate([
    (0, $3SCaV.customElement)("wui-search-bar")
], $a697330ca6c260b5$export$208b8ce22c764062);

});
parcelRegister("aylup", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aedbfbc4f84afc7$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $7aedbfbc4f84afc7$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    display: inline-block;
    width: 100%;
  }
`;

});


parcelRegister("grd5c", function(module, exports) {

$parcel$export(module.exports, "WuiSnackbar", function () { return $bf7950f5ee958d6f$export$864d710a9db8f7a3; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("9SgY8");

var $5XGFc = parcelRequire("5XGFc");
var $bf7950f5ee958d6f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bf7950f5ee958d6f$export$864d710a9db8f7a3 = class WuiSnackbar extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.backgroundColor = "accent-100";
        this.iconColor = "accent-100";
        this.icon = "checkmark";
        this.message = "";
    }
    render() {
        return (0, $B77rE.html)`
      <wui-icon-box
        size="sm"
        iconSize="xs"
        iconColor=${this.iconColor}
        backgroundColor=${this.backgroundColor}
        icon=${this.icon}
        background="opaque"
      ></wui-icon-box>
      <wui-text variant="paragraph-500" color="fg-100">${this.message}</wui-text>
    `;
    }
};
$bf7950f5ee958d6f$export$864d710a9db8f7a3.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $5XGFc.default)
];
$bf7950f5ee958d6f$var$__decorate([
    (0, $cG9dN.property)()
], $bf7950f5ee958d6f$export$864d710a9db8f7a3.prototype, "backgroundColor", void 0);
$bf7950f5ee958d6f$var$__decorate([
    (0, $cG9dN.property)()
], $bf7950f5ee958d6f$export$864d710a9db8f7a3.prototype, "iconColor", void 0);
$bf7950f5ee958d6f$var$__decorate([
    (0, $cG9dN.property)()
], $bf7950f5ee958d6f$export$864d710a9db8f7a3.prototype, "icon", void 0);
$bf7950f5ee958d6f$var$__decorate([
    (0, $cG9dN.property)()
], $bf7950f5ee958d6f$export$864d710a9db8f7a3.prototype, "message", void 0);
$bf7950f5ee958d6f$export$864d710a9db8f7a3 = $bf7950f5ee958d6f$var$__decorate([
    (0, $3SCaV.customElement)("wui-snackbar")
], $bf7950f5ee958d6f$export$864d710a9db8f7a3);

});
parcelRegister("5XGFc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45738e826b00c269$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $45738e826b00c269$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: flex;
    column-gap: var(--wui-spacing-xs);
    align-items: center;
    padding: var(--wui-spacing-xs) var(--wui-spacing-m) var(--wui-spacing-xs) var(--wui-spacing-xs);
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-005);
    box-sizing: border-box;
    max-height: 40px;
    background-color: var(--wui-color-bg-175);
    box-shadow:
      0px 14px 64px -4px rgba(0, 0, 0, 0.15),
      0px 8px 22px -6px rgba(0, 0, 0, 0.15);
  }
`;

});


parcelRegister("dO7Zu", function(module, exports) {

$parcel$export(module.exports, "WuiTabs", function () { return $a0d624af5cb271b7$export$78c669163db53348; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
var $aJMo2 = parcelRequire("aJMo2");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $hGxCl = parcelRequire("hGxCl");
var $a0d624af5cb271b7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a0d624af5cb271b7$export$78c669163db53348 = class WuiTabs extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.tabs = [];
        this.onTabChange = ()=>null;
        this.buttons = [];
        this.disabled = false;
        this.activeTab = 0;
        this.localTabWidth = "100px";
        this.isDense = false;
    }
    render() {
        this.isDense = this.tabs.length > 3;
        this.style.cssText = `
      --local-tab: ${this.activeTab};
      --local-tab-width: ${this.localTabWidth};
    `;
        this.dataset["type"] = this.isDense ? "flex" : "block";
        return this.tabs.map((tab, index)=>{
            const isActive = index === this.activeTab;
            return (0, $B77rE.html)`
        <button
          ?disabled=${this.disabled}
          @click=${()=>this.onTabClick(index)}
          data-active=${isActive}
        >
          <wui-icon size="xs" color="inherit" name=${tab.icon}></wui-icon>
          <wui-text variant="small-600" color="inherit"> ${tab.label} </wui-text>
        </button>
      `;
        });
    }
    firstUpdated() {
        if (this.shadowRoot && this.isDense) {
            this.buttons = [
                ...this.shadowRoot.querySelectorAll("button")
            ];
            setTimeout(()=>{
                this.animateTabs(0, true);
            }, 0);
        }
    }
    onTabClick(index) {
        if (this.buttons) this.animateTabs(index, false);
        this.activeTab = index;
        this.onTabChange(index);
    }
    animateTabs(index, initialAnimation) {
        const passiveBtn = this.buttons[this.activeTab];
        const activeBtn = this.buttons[index];
        const passiveBtnText = passiveBtn?.querySelector("wui-text");
        const activeBtnText = activeBtn?.querySelector("wui-text");
        const activeBtnBounds = activeBtn?.getBoundingClientRect();
        const activeBtnTextBounds = activeBtnText?.getBoundingClientRect();
        if (passiveBtn && passiveBtnText && !initialAnimation && index !== this.activeTab) {
            passiveBtnText.animate([
                {
                    opacity: 0
                }
            ], {
                duration: 50,
                easing: "ease",
                fill: "forwards"
            });
            passiveBtn.animate([
                {
                    width: `34px`
                }
            ], {
                duration: 500,
                easing: "ease",
                fill: "forwards"
            });
        }
        if (activeBtn && activeBtnBounds && activeBtnTextBounds && activeBtnText) {
            if (index !== this.activeTab || initialAnimation) {
                this.localTabWidth = `${Math.round(activeBtnBounds.width + activeBtnTextBounds.width) + 6}px`;
                activeBtn.animate([
                    {
                        width: `${activeBtnBounds.width + activeBtnTextBounds.width}px`
                    }
                ], {
                    duration: initialAnimation ? 0 : 500,
                    fill: "forwards",
                    easing: "ease"
                });
                activeBtnText.animate([
                    {
                        opacity: 1
                    }
                ], {
                    duration: initialAnimation ? 0 : 125,
                    delay: initialAnimation ? 0 : 200,
                    fill: "forwards",
                    easing: "ease"
                });
            }
        }
    }
};
$a0d624af5cb271b7$export$78c669163db53348.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $hGxCl.default)
];
$a0d624af5cb271b7$var$__decorate([
    (0, $cG9dN.property)({
        type: Array
    })
], $a0d624af5cb271b7$export$78c669163db53348.prototype, "tabs", void 0);
$a0d624af5cb271b7$var$__decorate([
    (0, $cG9dN.property)()
], $a0d624af5cb271b7$export$78c669163db53348.prototype, "onTabChange", void 0);
$a0d624af5cb271b7$var$__decorate([
    (0, $cG9dN.property)({
        type: Array
    })
], $a0d624af5cb271b7$export$78c669163db53348.prototype, "buttons", void 0);
$a0d624af5cb271b7$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $a0d624af5cb271b7$export$78c669163db53348.prototype, "disabled", void 0);
$a0d624af5cb271b7$var$__decorate([
    (0, $aJMo2.state)()
], $a0d624af5cb271b7$export$78c669163db53348.prototype, "activeTab", void 0);
$a0d624af5cb271b7$var$__decorate([
    (0, $aJMo2.state)()
], $a0d624af5cb271b7$export$78c669163db53348.prototype, "localTabWidth", void 0);
$a0d624af5cb271b7$var$__decorate([
    (0, $aJMo2.state)()
], $a0d624af5cb271b7$export$78c669163db53348.prototype, "isDense", void 0);
$a0d624af5cb271b7$export$78c669163db53348 = $a0d624af5cb271b7$var$__decorate([
    (0, $3SCaV.customElement)("wui-tabs")
], $a0d624af5cb271b7$export$78c669163db53348);

});
parcelRegister("hGxCl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03529672320b7587$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $03529672320b7587$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: inline-flex;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-3xl);
    padding: var(--wui-spacing-3xs);
    position: relative;
    height: 36px;
    overflow: hidden;
  }

  :host::before {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 4px;
    left: 4px;
    display: block;
    width: var(--local-tab-width);
    height: 28px;
    border-radius: var(--wui-border-radius-3xl);
    background-color: var(--wui-gray-glass-002);
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-002);
    transform: translateX(calc(var(--local-tab) * var(--local-tab-width)));
    transition: transform var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  :host([data-type='flex'])::before {
    left: 3px;
    transform: translateX(calc((var(--local-tab) * 34px) + (var(--local-tab) * 4px)));
  }

  :host([data-type='flex']) {
    display: flex;
    padding: 0px 0px 0px 12px;
    gap: 4px;
  }

  :host([data-type='flex']) > button > wui-text {
    position: absolute;
    left: 18px;
    opacity: 0;
  }

  button[data-active='true'] > wui-icon,
  button[data-active='true'] > wui-text {
    color: var(--wui-color-fg-100);
  }

  button[data-active='false'] > wui-icon,
  button[data-active='false'] > wui-text {
    color: var(--wui-color-fg-200);
  }

  button[data-active='true']:disabled,
  button[data-active='false']:disabled {
    background-color: transparent;
    opacity: 0.5;
    cursor: not-allowed;
  }

  button[data-active='true']:disabled > wui-text {
    color: var(--wui-color-fg-200);
  }

  button[data-active='false']:disabled > wui-text {
    color: var(--wui-color-fg-300);
  }

  button > wui-icon,
  button > wui-text {
    pointer-events: none;
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  button {
    width: var(--local-tab-width);
  }

  :host([data-type='flex']) > button {
    width: 34px;
    position: relative;
    display: flex;
    justify-content: flex-start;
  }

  button:hover:enabled,
  button:active:enabled {
    background-color: transparent !important;
  }

  button:hover:enabled > wui-icon,
  button:active:enabled > wui-icon {
    color: var(--wui-color-fg-125);
  }

  button:hover:enabled > wui-text,
  button:active:enabled > wui-text {
    color: var(--wui-color-fg-125);
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
  }
`;

});


parcelRegister("knJqU", function(module, exports) {

$parcel$export(module.exports, "WuiTooltip", function () { return $ed6932af74aed2c0$export$eee74dbee7f7f64b; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $64nY0 = parcelRequire("64nY0");
var $ed6932af74aed2c0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ed6932af74aed2c0$export$eee74dbee7f7f64b = class WuiTooltip extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.placement = "top";
        this.message = "";
    }
    render() {
        return (0, $B77rE.html)`<wui-icon
        data-placement=${this.placement}
        color="fg-100"
        size="inherit"
        name="cursor"
      ></wui-icon>
      <wui-text color="inherit" variant="small-500">${this.message}</wui-text>`;
    }
};
$ed6932af74aed2c0$export$eee74dbee7f7f64b.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $64nY0.default)
];
$ed6932af74aed2c0$var$__decorate([
    (0, $cG9dN.property)()
], $ed6932af74aed2c0$export$eee74dbee7f7f64b.prototype, "placement", void 0);
$ed6932af74aed2c0$var$__decorate([
    (0, $cG9dN.property)()
], $ed6932af74aed2c0$export$eee74dbee7f7f64b.prototype, "message", void 0);
$ed6932af74aed2c0$export$eee74dbee7f7f64b = $ed6932af74aed2c0$var$__decorate([
    (0, $3SCaV.customElement)("wui-tooltip")
], $ed6932af74aed2c0$export$eee74dbee7f7f64b);

});
parcelRegister("64nY0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46b5b51aa28f77e1$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $46b5b51aa28f77e1$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
    padding: 9px var(--wui-spacing-s) 10px var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xxs);
    background-color: var(--wui-color-fg-100);
    color: var(--wui-color-bg-100);
    position: relative;
  }

  wui-icon {
    position: absolute;
    width: 12px !important;
    height: 4px !important;
  }

  wui-icon[data-placement='top'] {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 95%);
  }

  wui-icon[data-placement='bottom'] {
    top: 0;
    left: 50%;
    transform: translate(-50%, -95%) rotate(180deg);
  }

  wui-icon[data-placement='right'] {
    top: 50%;
    left: 0;
    transform: translate(-65%, -50%) rotate(90deg);
  }

  wui-icon[data-placement='left'] {
    top: 50%;
    right: 0%;
    transform: translate(65%, -50%) rotate(270deg);
  }
`;

});


parcelRegister("7gR77", function(module, exports) {

$parcel$export(module.exports, "WuiVisualThumbnail", function () { return $54b33a588d7a3755$export$fb0fe7c7cc2031fe; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("62Qzz");
parcelRequire("iVPOS");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $jx6Bf = parcelRequire("jx6Bf");
var $54b33a588d7a3755$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $54b33a588d7a3755$export$fb0fe7c7cc2031fe = class WuiVisualThumbnail extends (0, $75o4B.LitElement) {
    render() {
        this.style.cssText = `--local-border-radius: ${this.borderRadiusFull ? "1000px" : "20px"};`;
        return (0, $B77rE.html)`${this.templateVisual()}`;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $B77rE.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? ""}></wui-image>`;
        return (0, $B77rE.html)`<wui-icon
      data-parent-size="md"
      size="inherit"
      color="inherit"
      name="walletPlaceholder"
    ></wui-icon>`;
    }
};
$54b33a588d7a3755$export$fb0fe7c7cc2031fe.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $jx6Bf.default)
];
$54b33a588d7a3755$var$__decorate([
    (0, $cG9dN.property)()
], $54b33a588d7a3755$export$fb0fe7c7cc2031fe.prototype, "imageSrc", void 0);
$54b33a588d7a3755$var$__decorate([
    (0, $cG9dN.property)()
], $54b33a588d7a3755$export$fb0fe7c7cc2031fe.prototype, "alt", void 0);
$54b33a588d7a3755$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $54b33a588d7a3755$export$fb0fe7c7cc2031fe.prototype, "borderRadiusFull", void 0);
$54b33a588d7a3755$export$fb0fe7c7cc2031fe = $54b33a588d7a3755$var$__decorate([
    (0, $3SCaV.customElement)("wui-visual-thumbnail")
], $54b33a588d7a3755$export$fb0fe7c7cc2031fe);

});
parcelRegister("jx6Bf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e38637fb43bfee5c$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $e38637fb43bfee5c$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--wui-icon-box-size-xl);
    height: var(--wui-icon-box-size-xl);
    box-shadow: 0 0 0 8px var(--wui-thumbnail-border);
    border-radius: var(--local-border-radius);
    overflow: hidden;
  }

  wui-icon {
    width: 32px;
    height: 32px;
  }
`;

});


parcelRegister("b8wWW", function(module, exports) {

$parcel$export(module.exports, "WuiNoticeCard", function () { return $81ba0031b740239f$export$bdf6de60cd1210c8; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("276Mo");
parcelRequire("7xM3j");
parcelRequire("46WDJ");
parcelRequire("9SgY8");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $7IkA7 = parcelRequire("7IkA7");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
var $81ba0031b740239f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $81ba0031b740239f$export$bdf6de60cd1210c8 = class WuiNoticeCard extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.label = "";
        this.description = "";
        this.icon = "wallet";
    }
    render() {
        return (0, $B77rE.html)`
      <button>
        <wui-flex gap="m" alignItems="center" justifyContent="space-between">
          <wui-icon-box
            size="lg"
            iconcolor="accent-100"
            backgroundcolor="accent-100"
            icon=${this.icon}
            background="transparent"
          ></wui-icon-box>

          <wui-flex flexDirection="column" gap="3xs">
            <wui-text variant="paragraph-500" color="fg-100">${this.label}</wui-text>
            <wui-text variant="small-400" color="fg-200">${this.description}</wui-text>
          </wui-flex>

          <wui-icon size="md" color="fg-200" name="chevronRight"></wui-icon>
        </wui-flex>
      </button>
    `;
    }
};
$81ba0031b740239f$export$bdf6de60cd1210c8.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $7IkA7.default)
];
$81ba0031b740239f$var$__decorate([
    (0, $cG9dN.property)()
], $81ba0031b740239f$export$bdf6de60cd1210c8.prototype, "label", void 0);
$81ba0031b740239f$var$__decorate([
    (0, $cG9dN.property)()
], $81ba0031b740239f$export$bdf6de60cd1210c8.prototype, "description", void 0);
$81ba0031b740239f$var$__decorate([
    (0, $cG9dN.property)()
], $81ba0031b740239f$export$bdf6de60cd1210c8.prototype, "icon", void 0);
$81ba0031b740239f$export$bdf6de60cd1210c8 = $81ba0031b740239f$var$__decorate([
    (0, $3SCaV.customElement)("wui-notice-card")
], $81ba0031b740239f$export$bdf6de60cd1210c8);

});
parcelRegister("7IkA7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59dc9b8bdb7e12ed$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $59dc9b8bdb7e12ed$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: block;
  }

  button {
    width: 100%;
    display: block;
    padding-top: var(--wui-spacing-l);
    padding-bottom: var(--wui-spacing-l);
    padding-left: var(--wui-spacing-s);
    padding-right: var(--wui-spacing-2l);
    border-radius: var(--wui-border-radius-s);
    background-color: var(--wui-accent-glass-015);
  }

  button:hover {
    background-color: var(--wui-accent-glass-010) !important;
  }

  button:active {
    background-color: var(--wui-accent-glass-020) !important;
  }
`;

});


parcelRegister("gqmC4", function(module, exports) {

$parcel$export(module.exports, "WuiListAccordion", function () { return $bf509d8d00b7b3f0$export$f885ba019a6ba4db; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("7xM3j");
parcelRequire("276Mo");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $gDvOl = parcelRequire("gDvOl");
var $bf509d8d00b7b3f0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $bf509d8d00b7b3f0$var$MAX_HEIGHT = 100;
let $bf509d8d00b7b3f0$export$f885ba019a6ba4db = class WuiListAccordion extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.textTitle = "";
        this.overflowedContent = "";
        this.toggled = false;
        this.enableAccordion = false;
        this.scrollElement = undefined;
        this.scrollHeightElement = 0;
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("textTitle") || changedProperties.has("overflowedContent")) setTimeout(()=>{
            this.checkHeight();
        }, 1);
    }
    checkHeight() {
        this.updateComplete.then(()=>{
            const heightElement = this.shadowRoot?.querySelector(".heightContent");
            const textElement = this.shadowRoot?.querySelector(".textContent");
            if (heightElement && textElement) {
                this.scrollElement = heightElement;
                const scrollHeight = textElement?.scrollHeight;
                if (scrollHeight && scrollHeight > $bf509d8d00b7b3f0$var$MAX_HEIGHT) {
                    this.enableAccordion = true;
                    this.scrollHeightElement = scrollHeight;
                    this.requestUpdate();
                }
            }
        });
    }
    render() {
        return (0, $B77rE.html)`
      <button ontouchstart @click=${()=>this.onClick()}>
        <wui-flex justifyContent="space-between" alignItems="center">
          <wui-text variant="paragraph-500" color="fg-100">${this.textTitle}</wui-text>
          ${this.chevronTemplate()}
        </wui-flex>
        <div
          data-active=${this.enableAccordion ? Boolean(this.toggled) : true}
          class="overflowedContent"
        >
          <div class="heightContent">
            <wui-text class="textContent" variant="paragraph-400" color="fg-200">
              <pre>${this.overflowedContent}</pre>
            </wui-text>
          </div>
        </div>
      </button>
    `;
    }
    onClick() {
        const icon = this.shadowRoot?.querySelector("wui-icon");
        if (this.enableAccordion) {
            this.toggled = !this.toggled;
            this.requestUpdate();
            if (this.scrollElement) this.scrollElement.animate([
                {
                    maxHeight: this.toggled ? `${$bf509d8d00b7b3f0$var$MAX_HEIGHT}px` : `${this.scrollHeightElement}px`
                },
                {
                    maxHeight: this.toggled ? `${this.scrollHeightElement}px` : `${$bf509d8d00b7b3f0$var$MAX_HEIGHT}px`
                }
            ], {
                duration: 300,
                fill: "forwards",
                easing: "ease"
            });
            if (icon) icon.animate([
                {
                    transform: this.toggled ? `rotate(0deg)` : `rotate(180deg)`
                },
                {
                    transform: this.toggled ? `rotate(180deg)` : `rotate(0deg)`
                }
            ], {
                duration: 300,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    chevronTemplate() {
        if (this.enableAccordion) return (0, $B77rE.html)` <wui-icon color="fg-100" size="sm" name="chevronBottom"></wui-icon>`;
        return null;
    }
};
$bf509d8d00b7b3f0$export$f885ba019a6ba4db.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $gDvOl.default)
];
$bf509d8d00b7b3f0$var$__decorate([
    (0, $cG9dN.property)()
], $bf509d8d00b7b3f0$export$f885ba019a6ba4db.prototype, "textTitle", void 0);
$bf509d8d00b7b3f0$var$__decorate([
    (0, $cG9dN.property)()
], $bf509d8d00b7b3f0$export$f885ba019a6ba4db.prototype, "overflowedContent", void 0);
$bf509d8d00b7b3f0$export$f885ba019a6ba4db = $bf509d8d00b7b3f0$var$__decorate([
    (0, $3SCaV.customElement)("wui-list-accordion")
], $bf509d8d00b7b3f0$export$f885ba019a6ba4db);

});
parcelRegister("gDvOl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1c8f6e25bef19dc$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $c1c8f6e25bef19dc$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  button {
    height: auto;
    position: relative;
    flex-direction: column;
    gap: var(--wui-spacing-s);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  .overflowedContent {
    width: 100%;
    overflow: hidden;
  }

  .overflowedContent[data-active='false']:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top, var(--wui-color-bg-200), transparent);
    border-bottom-left-radius: var(--wui-border-radius-xs);
    border-bottom-right-radius: var(--wui-border-radius-xs);
  }

  .heightContent {
    max-height: 100px;
  }

  pre {
    text-align: left;
    white-space: pre-wrap;
    height: auto;
    overflow-x: auto;
    overflow-wrap: anywhere;
  }
`;

});


parcelRegister("iBndS", function(module, exports) {

$parcel$export(module.exports, "WuiListContent", function () { return $d8adb244c7311745$export$621c7f09b7560b89; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("62Qzz");
parcelRequire("7xM3j");
parcelRequire("276Mo");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $1x92N = parcelRequire("1x92N");
var $d8adb244c7311745$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d8adb244c7311745$export$621c7f09b7560b89 = class WuiListContent extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.textTitle = "";
        this.textValue = undefined;
    }
    render() {
        return (0, $B77rE.html)`
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color=${this.textValue ? "fg-200" : "fg-100"}>
          ${this.textTitle}
        </wui-text>
        ${this.templateContent()}
      </wui-flex>
    `;
    }
    templateContent() {
        if (this.imageSrc) return (0, $B77rE.html)`<wui-image src=${this.imageSrc} alt=${this.textTitle}></wui-image>`;
        else if (this.textValue) return (0, $B77rE.html)` <wui-text variant="paragraph-400" color="fg-100"> ${this.textValue} </wui-text>`;
        return (0, $B77rE.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$d8adb244c7311745$export$621c7f09b7560b89.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $1x92N.default)
];
$d8adb244c7311745$var$__decorate([
    (0, $cG9dN.property)()
], $d8adb244c7311745$export$621c7f09b7560b89.prototype, "imageSrc", void 0);
$d8adb244c7311745$var$__decorate([
    (0, $cG9dN.property)()
], $d8adb244c7311745$export$621c7f09b7560b89.prototype, "textTitle", void 0);
$d8adb244c7311745$var$__decorate([
    (0, $cG9dN.property)()
], $d8adb244c7311745$export$621c7f09b7560b89.prototype, "textValue", void 0);
$d8adb244c7311745$export$621c7f09b7560b89 = $d8adb244c7311745$var$__decorate([
    (0, $3SCaV.customElement)("wui-list-content")
], $d8adb244c7311745$export$621c7f09b7560b89);

});
parcelRegister("1x92N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11dfe37766e3ecda$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $11dfe37766e3ecda$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: flex;
    column-gap: var(--wui-spacing-s);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  wui-image {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-icon {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
  }
`;

});


parcelRegister("9pEI0", function(module, exports) {

$parcel$export(module.exports, "WuiListNetwork", function () { return $6da606c84e997bb8$export$f7ecfb3cf2878ec8; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");
parcelRequire("hnysB");

var $3aE4G = parcelRequire("3aE4G");
var $6da606c84e997bb8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $6da606c84e997bb8$export$f7ecfb3cf2878ec8 = class WuiListNetwork extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = "";
        this.name = "";
        this.disabled = false;
    }
    render() {
        return (0, $B77rE.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        ${this.templateNetworkImage()}
        <wui-text variant="paragraph-500" color="inherit">${this.name}</wui-text>
      </button>
    `;
    }
    templateNetworkImage() {
        if (this.imageSrc) return (0, $B77rE.html)`<wui-network-image
        size="sm"
        imageSrc=${this.imageSrc}
        name=${this.name}
      ></wui-network-image>`;
        if (!this.imageSrc) return (0, $B77rE.html)`<wui-network-image size="sm" name=${this.name}></wui-network-image>`;
        return null;
    }
};
$6da606c84e997bb8$export$f7ecfb3cf2878ec8.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $3aE4G.default)
];
$6da606c84e997bb8$var$__decorate([
    (0, $cG9dN.property)()
], $6da606c84e997bb8$export$f7ecfb3cf2878ec8.prototype, "imageSrc", void 0);
$6da606c84e997bb8$var$__decorate([
    (0, $cG9dN.property)()
], $6da606c84e997bb8$export$f7ecfb3cf2878ec8.prototype, "name", void 0);
$6da606c84e997bb8$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $6da606c84e997bb8$export$f7ecfb3cf2878ec8.prototype, "disabled", void 0);
$6da606c84e997bb8$export$f7ecfb3cf2878ec8 = $6da606c84e997bb8$var$__decorate([
    (0, $3SCaV.customElement)("wui-list-network")
], $6da606c84e997bb8$export$f7ecfb3cf2878ec8);

});
parcelRegister("3aE4G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24f1643f23c5937a$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $24f1643f23c5937a$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-100);
  }

  button > wui-text:nth-child(2) {
    display: flex;
    flex: 1;
  }

  wui-icon {
    color: var(--wui-color-fg-200) !important;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-tag {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-300);
  }
`;

});


parcelRegister("hgfjM", function(module, exports) {

$parcel$export(module.exports, "WuiListWalletTransaction", function () { return $c90fd0216bbc0e5b$export$fc79cdc2df8cc885; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("62Qzz");
parcelRequire("7xM3j");
parcelRequire("7WcdO");
parcelRequire("276Mo");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $jnyGm = parcelRequire("jnyGm");
var $c90fd0216bbc0e5b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $c90fd0216bbc0e5b$export$fc79cdc2df8cc885 = class WuiListWalletTransaction extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.amount = "";
        this.networkCurreny = "";
        this.networkImageUrl = "";
        this.receiverAddress = "";
        this.addressExplorerUrl = "";
    }
    render() {
        return (0, $B77rE.html)`
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color="fg-200">Sending</wui-text>
        <wui-flex gap="xs" alignItems="center">
          <wui-text variant="paragraph-400" color="fg-100">
            ${this.amount} ${this.networkCurreny}
          </wui-text>
          ${this.templateNetworkVisual()}
        </wui-flex>
      </wui-flex>
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color="fg-200">To</wui-text>
        <wui-chip
          icon="externalLink"
          variant="shadeSmall"
          href=${this.addressExplorerUrl}
          title=${this.receiverAddress}
        ></wui-chip>
      </wui-flex>
    `;
    }
    templateNetworkVisual() {
        if (this.networkImageUrl) return (0, $B77rE.html)`<wui-image src=${this.networkImageUrl} alt="Network Image"></wui-image>`;
        return (0, $B77rE.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$c90fd0216bbc0e5b$export$fc79cdc2df8cc885.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $jnyGm.default)
];
$c90fd0216bbc0e5b$var$__decorate([
    (0, $cG9dN.property)()
], $c90fd0216bbc0e5b$export$fc79cdc2df8cc885.prototype, "amount", void 0);
$c90fd0216bbc0e5b$var$__decorate([
    (0, $cG9dN.property)()
], $c90fd0216bbc0e5b$export$fc79cdc2df8cc885.prototype, "networkCurreny", void 0);
$c90fd0216bbc0e5b$var$__decorate([
    (0, $cG9dN.property)()
], $c90fd0216bbc0e5b$export$fc79cdc2df8cc885.prototype, "networkImageUrl", void 0);
$c90fd0216bbc0e5b$var$__decorate([
    (0, $cG9dN.property)()
], $c90fd0216bbc0e5b$export$fc79cdc2df8cc885.prototype, "receiverAddress", void 0);
$c90fd0216bbc0e5b$var$__decorate([
    (0, $cG9dN.property)()
], $c90fd0216bbc0e5b$export$fc79cdc2df8cc885.prototype, "addressExplorerUrl", void 0);
$c90fd0216bbc0e5b$export$fc79cdc2df8cc885 = $c90fd0216bbc0e5b$var$__decorate([
    (0, $3SCaV.customElement)("wui-list-wallet-transaction")
], $c90fd0216bbc0e5b$export$fc79cdc2df8cc885);

});
parcelRegister("jnyGm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1bb117ba68249db$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $e1bb117ba68249db$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: flex;
    flex-direction: column;
    gap: var(--wui-spacing-l);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  wui-image {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-icon {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
  }
`;

});


parcelRegister("bPX90", function(module, exports) {

$parcel$export(module.exports, "WuiOnRampActivityItem", function () { return $89e255f8e7223146$export$73478a01e052eaa5; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("iVPOS");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $hwVx9 = parcelRequire("hwVx9");
parcelRequire("3aODI");
var $aHgTP = parcelRequire("aHgTP");
var $89e255f8e7223146$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $89e255f8e7223146$export$73478a01e052eaa5 = class WuiOnRampActivityItem extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.color = "inherit";
        this.label = "Bought";
        this.purchaseValue = "";
        this.purchaseCurrency = "";
        this.date = "";
        this.completed = false;
        this.inProgress = false;
        this.failed = false;
        this.onClick = null;
        this.symbol = "";
    }
    firstUpdated() {
        if (!this.icon) this.fetchTokenImage();
    }
    render() {
        return (0, $B77rE.html)`
      <wui-flex>
        ${this.imageTemplate()}
        <wui-flex flexDirection="column" gap="4xs" flexGrow="1">
          <wui-flex gap="xxs" alignItems="center" justifyContent="flex-start">
            ${this.statusIconTemplate()}
            <wui-text variant="paragraph-500" color="fg-100"> ${this.label}</wui-text>
          </wui-flex>
          <wui-text variant="small-400" color="fg-200">
            + ${this.purchaseValue} ${this.purchaseCurrency}
          </wui-text>
        </wui-flex>
        ${this.inProgress ? (0, $B77rE.html)`<wui-loading-spinner color="fg-200" size="md"></wui-loading-spinner>` : (0, $B77rE.html)`<wui-text variant="micro-700" color="fg-300"><span>${this.date}</span></wui-text>`}
      </wui-flex>
    `;
    }
    async fetchTokenImage() {
        await (0, $aHgTP.ApiController)._fetchTokenImage(this.purchaseCurrency);
    }
    statusIconTemplate() {
        if (this.inProgress) return null;
        return this.completed ? this.boughtIconTemplate() : this.errorIconTemplate();
    }
    errorIconTemplate() {
        return (0, $B77rE.html)`<wui-icon-box
      size="xxs"
      iconColor="error-100"
      backgroundColor="error-100"
      background="opaque"
      icon="close"
      borderColor="wui-color-bg-125"
    ></wui-icon-box>`;
    }
    imageTemplate() {
        const icon = this.icon || `https://avatar.vercel.sh/andrew.svg?size=50&text=${this.symbol}`;
        return (0, $B77rE.html)`<wui-flex class="purchase-image-container">
      <wui-image src=${icon}></wui-image>
    </wui-flex>`;
    }
    boughtIconTemplate() {
        return (0, $B77rE.html)`<wui-icon-box
      size="xxs"
      iconColor="success-100"
      backgroundColor="success-100"
      background="opaque"
      icon="arrowBottom"
      borderColor="wui-color-bg-125"
    ></wui-icon-box>`;
    }
};
$89e255f8e7223146$export$73478a01e052eaa5.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $hwVx9.default)
];
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "disabled", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)()
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "color", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)()
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "label", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)()
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "purchaseValue", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)()
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "purchaseCurrency", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)()
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "date", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "completed", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "inProgress", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "failed", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)()
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "onClick", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)()
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "symbol", void 0);
$89e255f8e7223146$var$__decorate([
    (0, $cG9dN.property)()
], $89e255f8e7223146$export$73478a01e052eaa5.prototype, "icon", void 0);
$89e255f8e7223146$export$73478a01e052eaa5 = $89e255f8e7223146$var$__decorate([
    (0, $3SCaV.customElement)("wui-onramp-activity-item")
], $89e255f8e7223146$export$73478a01e052eaa5);

});
parcelRegister("hwVx9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc320dd5957db78e$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $cc320dd5957db78e$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    width: 100%;
  }

  :host > wui-flex {
    width: 100%;
    padding: var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xs);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--wui-spacing-s);
  }

  :host > wui-flex:hover {
    background-color: var(--wui-gray-glass-002);
  }

  .purchase-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: var(--wui-icon-box-size-lg);
    height: var(--wui-icon-box-size-lg);
  }

  .purchase-image-container wui-image {
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: calc(var(--wui-icon-box-size-lg) / 2);
  }

  .purchase-image-container wui-image::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    border-radius: calc(var(--wui-icon-box-size-lg) / 2);
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
  }

  .purchase-image-container wui-icon-box {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translate(20%, 20%);
  }
`;

});

parcelRegister("3aODI", function(module, exports) {

$parcel$export(module.exports, "ModalController", function () { return (parcelRequire("nBm8O")).ModalController; });
$parcel$export(module.exports, "RouterController", function () { return (parcelRequire("3OaCj")).RouterController; });
$parcel$export(module.exports, "AccountController", function () { return (parcelRequire("7mucr")).AccountController; });
$parcel$export(module.exports, "NetworkController", function () { return (parcelRequire("8A6Jz")).NetworkController; });
$parcel$export(module.exports, "OnRampController", function () { return (parcelRequire("79hu3")).OnRampController; });
$parcel$export(module.exports, "ConnectionController", function () { return (parcelRequire("5n5Ql")).ConnectionController; });
$parcel$export(module.exports, "SIWEController", function () { return (parcelRequire("jIUUu")).SIWEController; });
$parcel$export(module.exports, "ConnectorController", function () { return (parcelRequire("01g6R")).ConnectorController; });
$parcel$export(module.exports, "SnackController", function () { return (parcelRequire("dXr1O")).SnackController; });
$parcel$export(module.exports, "ApiController", function () { return (parcelRequire("aHgTP")).ApiController; });
$parcel$export(module.exports, "AssetController", function () { return (parcelRequire("b2pRm")).AssetController; });
$parcel$export(module.exports, "ThemeController", function () { return (parcelRequire("jGPEs")).ThemeController; });
$parcel$export(module.exports, "OptionsController", function () { return (parcelRequire("cPOJT")).OptionsController; });
$parcel$export(module.exports, "BlockchainApiController", function () { return (parcelRequire("5PCU5")).BlockchainApiController; });
$parcel$export(module.exports, "PublicStateController", function () { return (parcelRequire("9q2Kw")).PublicStateController; });
$parcel$export(module.exports, "EventsController", function () { return (parcelRequire("dUlgM")).EventsController; });
$parcel$export(module.exports, "TransactionsController", function () { return (parcelRequire("i2H8M")).TransactionsController; });
$parcel$export(module.exports, "AssetUtil", function () { return (parcelRequire("3jnn6")).AssetUtil; });
$parcel$export(module.exports, "ConstantsUtil", function () { return (parcelRequire("QVM5q")).ConstantsUtil; });
$parcel$export(module.exports, "CoreHelperUtil", function () { return (parcelRequire("23VhR")).CoreHelperUtil; });
$parcel$export(module.exports, "StorageUtil", function () { return (parcelRequire("6sZsT")).StorageUtil; });
$parcel$export(module.exports, "RouterUtil", function () { return (parcelRequire("1hoT1")).RouterUtil; });
$parcel$export(module.exports, "CryptoUtil", function () { return (parcelRequire("9Ezhj")).CryptoUtil; });

var $nBm8O = parcelRequire("nBm8O");

var $3OaCj = parcelRequire("3OaCj");

var $7mucr = parcelRequire("7mucr");

var $8A6Jz = parcelRequire("8A6Jz");

var $79hu3 = parcelRequire("79hu3");

var $5n5Ql = parcelRequire("5n5Ql");

var $jIUUu = parcelRequire("jIUUu");

var $01g6R = parcelRequire("01g6R");

var $dXr1O = parcelRequire("dXr1O");

var $aHgTP = parcelRequire("aHgTP");

var $b2pRm = parcelRequire("b2pRm");

var $jGPEs = parcelRequire("jGPEs");

var $cPOJT = parcelRequire("cPOJT");

var $5PCU5 = parcelRequire("5PCU5");

var $9q2Kw = parcelRequire("9q2Kw");

var $dUlgM = parcelRequire("dUlgM");

var $i2H8M = parcelRequire("i2H8M");

var $3jnn6 = parcelRequire("3jnn6");

var $QVM5q = parcelRequire("QVM5q");

var $23VhR = parcelRequire("23VhR");

var $6sZsT = parcelRequire("6sZsT");

var $1hoT1 = parcelRequire("1hoT1");

var $9Ezhj = parcelRequire("9Ezhj");

});
parcelRegister("nBm8O", function(module, exports) {

$parcel$export(module.exports, "ModalController", function () { return $046f203e662ab076$export$d507f25e63650365; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");

var $7mucr = parcelRequire("7mucr");

var $aHgTP = parcelRequire("aHgTP");

var $dUlgM = parcelRequire("dUlgM");

var $9q2Kw = parcelRequire("9q2Kw");

var $3OaCj = parcelRequire("3OaCj");
const $046f203e662ab076$var$state = (0, $46gat.proxy)({
    loading: false,
    open: false
});
const $046f203e662ab076$export$d507f25e63650365 = {
    state: $046f203e662ab076$var$state,
    subscribe (callback) {
        return (0, $46gat.subscribe)($046f203e662ab076$var$state, ()=>callback($046f203e662ab076$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($046f203e662ab076$var$state, key, callback);
    },
    async open (options) {
        await (0, $aHgTP.ApiController).state.prefetchPromise;
        const connected = (0, $7mucr.AccountController).state.isConnected;
        if (options?.view) (0, $3OaCj.RouterController).reset(options.view);
        else if (connected) (0, $3OaCj.RouterController).reset("Account");
        else (0, $3OaCj.RouterController).reset("Connect");
        $046f203e662ab076$var$state.open = true;
        (0, $9q2Kw.PublicStateController).set({
            open: true
        });
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "MODAL_OPEN",
            properties: {
                connected: connected
            }
        });
    },
    close () {
        const connected = (0, $7mucr.AccountController).state.isConnected;
        $046f203e662ab076$var$state.open = false;
        (0, $9q2Kw.PublicStateController).set({
            open: false
        });
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "MODAL_CLOSE",
            properties: {
                connected: connected
            }
        });
    },
    setLoading (loading) {
        $046f203e662ab076$var$state.loading = loading;
    }
};

});
parcelRegister("8skqG", function(module, exports) {

$parcel$export(module.exports, "subscribeKey", function () { return $9afba5e587b9c645$export$7faad7f6b3708314; });

var $46gat = parcelRequire("46gat");
var $9afba5e587b9c645$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla/utils.mjs"
});
function $9afba5e587b9c645$export$7faad7f6b3708314(proxyObject, key, callback, notifyInSync) {
    let prevValue = proxyObject[key];
    return (0, $46gat.subscribe)(proxyObject, ()=>{
        const nextValue = proxyObject[key];
        if (!Object.is(prevValue, nextValue)) callback(prevValue = nextValue);
    }, notifyInSync);
}
let $9afba5e587b9c645$var$currentCleanups;
function $9afba5e587b9c645$export$3db5d71bdb2d5499(callback, options) {
    let alive = true;
    const cleanups = /* @__PURE__ */ new Set();
    const subscriptions = /* @__PURE__ */ new Map();
    const cleanup = ()=>{
        if (alive) {
            alive = false;
            cleanups.forEach((clean)=>clean());
            cleanups.clear();
            subscriptions.forEach((unsubscribe)=>unsubscribe());
            subscriptions.clear();
        }
    };
    const revalidate = ()=>{
        if (!alive) return;
        cleanups.forEach((clean)=>clean());
        cleanups.clear();
        const proxiesToSubscribe = /* @__PURE__ */ new Set();
        const parent = $9afba5e587b9c645$var$currentCleanups;
        $9afba5e587b9c645$var$currentCleanups = cleanups;
        try {
            const cleanupReturn = callback((proxyObject)=>{
                proxiesToSubscribe.add(proxyObject);
                return proxyObject;
            });
            if (cleanupReturn) cleanups.add(cleanupReturn);
        } finally{
            $9afba5e587b9c645$var$currentCleanups = parent;
        }
        subscriptions.forEach((unsubscribe, proxyObject)=>{
            if (proxiesToSubscribe.has(proxyObject)) proxiesToSubscribe.delete(proxyObject);
            else {
                subscriptions.delete(proxyObject);
                unsubscribe();
            }
        });
        proxiesToSubscribe.forEach((proxyObject)=>{
            const unsubscribe = (0, $46gat.subscribe)(proxyObject, revalidate, options == null ? void 0 : options.sync);
            subscriptions.set(proxyObject, unsubscribe);
        });
    };
    if ($9afba5e587b9c645$var$currentCleanups) $9afba5e587b9c645$var$currentCleanups.add(cleanup);
    revalidate();
    return cleanup;
}
const $9afba5e587b9c645$var$DEVTOOLS = Symbol();
function $9afba5e587b9c645$export$6922d3b3a607469e(proxyObject, options) {
    if (typeof options === "string") {
        console.warn("string name option is deprecated, use { name }. https://github.com/pmndrs/valtio/pull/400");
        options = {
            name: options
        };
    }
    const { enabled: enabled, name: name = "", ...rest } = options || {};
    let extension;
    try {
        extension = (enabled != null ? enabled : ($9afba5e587b9c645$import_meta.env ? $9afba5e587b9c645$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
    } catch  {}
    if (!extension) {
        if (($9afba5e587b9c645$import_meta.env ? $9afba5e587b9c645$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[Warning] Please install/enable Redux devtools extension");
        return;
    }
    let isTimeTraveling = false;
    const devtools2 = extension.connect({
        name: name,
        ...rest
    });
    const unsub1 = (0, $46gat.subscribe)(proxyObject, (ops)=>{
        const action = ops.filter(([_, path])=>path[0] !== $9afba5e587b9c645$var$DEVTOOLS).map(([op, path])=>`${op}:${path.map(String).join(".")}`).join(", ");
        if (!action) return;
        if (isTimeTraveling) isTimeTraveling = false;
        else {
            const snapWithoutDevtools = Object.assign({}, (0, $46gat.snapshot)(proxyObject));
            delete snapWithoutDevtools[$9afba5e587b9c645$var$DEVTOOLS];
            devtools2.send({
                type: action,
                updatedAt: /* @__PURE__ */ new Date().toLocaleString()
            }, snapWithoutDevtools);
        }
    });
    const unsub2 = devtools2.subscribe((message)=>{
        var _a, _b, _c, _d, _e, _f;
        if (message.type === "ACTION" && message.payload) try {
            Object.assign(proxyObject, JSON.parse(message.payload));
        } catch (e) {
            console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", e);
        }
        if (message.type === "DISPATCH" && message.state) {
            if (((_a = message.payload) == null ? void 0 : _a.type) === "JUMP_TO_ACTION" || ((_b = message.payload) == null ? void 0 : _b.type) === "JUMP_TO_STATE") {
                isTimeTraveling = true;
                const state = JSON.parse(message.state);
                Object.assign(proxyObject, state);
            }
            proxyObject[$9afba5e587b9c645$var$DEVTOOLS] = message;
        } else if (message.type === "DISPATCH" && ((_c = message.payload) == null ? void 0 : _c.type) === "COMMIT") devtools2.init((0, $46gat.snapshot)(proxyObject));
        else if (message.type === "DISPATCH" && ((_d = message.payload) == null ? void 0 : _d.type) === "IMPORT_STATE") {
            const actions = (_e = message.payload.nextLiftedState) == null ? void 0 : _e.actionsById;
            const computedStates = ((_f = message.payload.nextLiftedState) == null ? void 0 : _f.computedStates) || [];
            isTimeTraveling = true;
            computedStates.forEach(({ state: state }, index)=>{
                const action = actions[index] || "No action found";
                Object.assign(proxyObject, state);
                if (index === 0) devtools2.init((0, $46gat.snapshot)(proxyObject));
                else devtools2.send(action, (0, $46gat.snapshot)(proxyObject));
            });
        }
    });
    devtools2.init((0, $46gat.snapshot)(proxyObject));
    return ()=>{
        unsub1();
        unsub2 == null || unsub2();
    };
}
const $9afba5e587b9c645$var$sourceObjectMap = /* @__PURE__ */ new WeakMap();
const $9afba5e587b9c645$var$derivedObjectMap = /* @__PURE__ */ new WeakMap();
const $9afba5e587b9c645$var$markPending = (sourceObject, callback)=>{
    const sourceObjectEntry = $9afba5e587b9c645$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        sourceObjectEntry[0].forEach((subscription)=>{
            const { d: derivedObject } = subscription;
            if (sourceObject !== derivedObject) $9afba5e587b9c645$var$markPending(derivedObject);
        });
        ++sourceObjectEntry[2];
        if (callback) sourceObjectEntry[3].add(callback);
    }
};
const $9afba5e587b9c645$var$checkPending = (sourceObject, callback)=>{
    const sourceObjectEntry = $9afba5e587b9c645$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry == null ? void 0 : sourceObjectEntry[2]) {
        sourceObjectEntry[3].add(callback);
        return true;
    }
    return false;
};
const $9afba5e587b9c645$var$unmarkPending = (sourceObject)=>{
    const sourceObjectEntry = $9afba5e587b9c645$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        --sourceObjectEntry[2];
        if (!sourceObjectEntry[2]) {
            sourceObjectEntry[3].forEach((callback)=>callback());
            sourceObjectEntry[3].clear();
        }
        sourceObjectEntry[0].forEach((subscription)=>{
            const { d: derivedObject } = subscription;
            if (sourceObject !== derivedObject) $9afba5e587b9c645$var$unmarkPending(derivedObject);
        });
    }
};
const $9afba5e587b9c645$var$addSubscription = (subscription)=>{
    const { s: sourceObject, d: derivedObject } = subscription;
    let derivedObjectEntry = $9afba5e587b9c645$var$derivedObjectMap.get(derivedObject);
    if (!derivedObjectEntry) {
        derivedObjectEntry = [
            /* @__PURE__ */ new Set()
        ];
        $9afba5e587b9c645$var$derivedObjectMap.set(subscription.d, derivedObjectEntry);
    }
    derivedObjectEntry[0].add(subscription);
    let sourceObjectEntry = $9afba5e587b9c645$var$sourceObjectMap.get(sourceObject);
    if (!sourceObjectEntry) {
        const subscriptions = /* @__PURE__ */ new Set();
        const unsubscribe = (0, $46gat.subscribe)(sourceObject, (ops)=>{
            subscriptions.forEach((subscription2)=>{
                const { d: derivedObject2, c: callback, n: notifyInSync, i: ignoreKeys } = subscription2;
                if (sourceObject === derivedObject2 && ops.every((op)=>op[1].length === 1 && ignoreKeys.includes(op[1][0]))) return;
                if (subscription2.p) return;
                $9afba5e587b9c645$var$markPending(sourceObject, callback);
                if (notifyInSync) $9afba5e587b9c645$var$unmarkPending(sourceObject);
                else subscription2.p = Promise.resolve().then(()=>{
                    delete subscription2.p;
                    $9afba5e587b9c645$var$unmarkPending(sourceObject);
                });
            });
        }, true);
        sourceObjectEntry = [
            subscriptions,
            unsubscribe,
            0,
            /* @__PURE__ */ new Set()
        ];
        $9afba5e587b9c645$var$sourceObjectMap.set(sourceObject, sourceObjectEntry);
    }
    sourceObjectEntry[0].add(subscription);
};
const $9afba5e587b9c645$var$removeSubscription = (subscription)=>{
    const { s: sourceObject, d: derivedObject } = subscription;
    const derivedObjectEntry = $9afba5e587b9c645$var$derivedObjectMap.get(derivedObject);
    derivedObjectEntry == null || derivedObjectEntry[0].delete(subscription);
    if ((derivedObjectEntry == null ? void 0 : derivedObjectEntry[0].size) === 0) $9afba5e587b9c645$var$derivedObjectMap.delete(derivedObject);
    const sourceObjectEntry = $9afba5e587b9c645$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        const [subscriptions, unsubscribe] = sourceObjectEntry;
        subscriptions.delete(subscription);
        if (!subscriptions.size) {
            unsubscribe();
            $9afba5e587b9c645$var$sourceObjectMap.delete(sourceObject);
        }
    }
};
const $9afba5e587b9c645$var$listSubscriptions = (derivedObject)=>{
    const derivedObjectEntry = $9afba5e587b9c645$var$derivedObjectMap.get(derivedObject);
    if (derivedObjectEntry) return Array.from(derivedObjectEntry[0]);
    return [];
};
const $9afba5e587b9c645$export$5bb85a5dcd872eb9 = {
    add: $9afba5e587b9c645$var$addSubscription,
    remove: $9afba5e587b9c645$var$removeSubscription,
    list: $9afba5e587b9c645$var$listSubscriptions
};
function $9afba5e587b9c645$export$78ed5b3305815fc7(derivedFns, options) {
    const proxyObject = (options == null ? void 0 : options.proxy) || (0, $46gat.proxy)({});
    const notifyInSync = !!(options == null ? void 0 : options.sync);
    const derivedKeys = Object.keys(derivedFns);
    derivedKeys.forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(proxyObject, key)) throw new Error("object property already defined");
        const fn = derivedFns[key];
        let lastDependencies = null;
        const evaluate = ()=>{
            if (lastDependencies) {
                if (Array.from(lastDependencies).map(([p])=>$9afba5e587b9c645$var$checkPending(p, evaluate)).some((isPending)=>isPending)) return;
                if (Array.from(lastDependencies).every(([p, entry])=>(0, $46gat.getVersion)(p) === entry.v)) return;
            }
            const dependencies = /* @__PURE__ */ new Map();
            const get = (p)=>{
                dependencies.set(p, {
                    v: (0, $46gat.getVersion)(p)
                });
                return p;
            };
            const value = fn(get);
            const subscribeToDependencies = ()=>{
                dependencies.forEach((entry, p)=>{
                    var _a;
                    const lastSubscription = (_a = lastDependencies == null ? void 0 : lastDependencies.get(p)) == null ? void 0 : _a.s;
                    if (lastSubscription) entry.s = lastSubscription;
                    else {
                        const subscription = {
                            s: p,
                            // sourceObject
                            d: proxyObject,
                            // derivedObject
                            k: key,
                            // derived key
                            c: evaluate,
                            // callback
                            n: notifyInSync,
                            i: derivedKeys
                        };
                        $9afba5e587b9c645$var$addSubscription(subscription);
                        entry.s = subscription;
                    }
                });
                lastDependencies == null || lastDependencies.forEach((entry, p)=>{
                    if (!dependencies.has(p) && entry.s) $9afba5e587b9c645$var$removeSubscription(entry.s);
                });
                lastDependencies = dependencies;
            };
            if (value instanceof Promise) value.finally(subscribeToDependencies);
            else subscribeToDependencies();
            proxyObject[key] = value;
        };
        evaluate();
    });
    return proxyObject;
}
function $9afba5e587b9c645$export$992ed2abb18cb90(proxyObject, options) {
    const keysToDelete = (options == null ? void 0 : options.delete) ? /* @__PURE__ */ new Set() : null;
    $9afba5e587b9c645$var$listSubscriptions(proxyObject).forEach((subscription)=>{
        const { k: key } = subscription;
        if (!(options == null ? void 0 : options.keys) || options.keys.includes(key)) {
            $9afba5e587b9c645$var$removeSubscription(subscription);
            if (keysToDelete) keysToDelete.add(key);
        }
    });
    if (keysToDelete) keysToDelete.forEach((key)=>{
        delete proxyObject[key];
    });
}
function $9afba5e587b9c645$export$b84fff6f79a56fa3(proxyObject, computedFns_FAKE, targetObject = proxyObject) {
    if (($9afba5e587b9c645$import_meta.env ? $9afba5e587b9c645$import_meta.env.MODE : void 0) !== "production") console.warn("addComputed is deprecated. Please consider using `derive`. Falling back to emulation with derive. https://github.com/pmndrs/valtio/pull/201");
    const derivedFns = {};
    Object.keys(computedFns_FAKE).forEach((key)=>{
        derivedFns[key] = (get)=>computedFns_FAKE[key](get(proxyObject));
    });
    return $9afba5e587b9c645$export$78ed5b3305815fc7(derivedFns, {
        proxy: targetObject
    });
}
function $9afba5e587b9c645$export$64a33e9109220e08(initialObject, computedFns) {
    if (($9afba5e587b9c645$import_meta.env ? $9afba5e587b9c645$import_meta.env.MODE : void 0) !== "production") console.warn('proxyWithComputed is deprecated. Please follow "Computed Properties" guide in docs.');
    Object.keys(computedFns).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(initialObject, key)) throw new Error("object property already defined");
        const computedFn = computedFns[key];
        const { get: get, set: set } = typeof computedFn === "function" ? {
            get: computedFn
        } : computedFn;
        const desc = {};
        desc.get = ()=>get((0, $46gat.snapshot)(proxyObject));
        if (set) desc.set = (newValue)=>set(proxyObject, newValue);
        Object.defineProperty(initialObject, key, desc);
    });
    const proxyObject = (0, $46gat.proxy)(initialObject);
    return proxyObject;
}
const $9afba5e587b9c645$var$isObject = (x)=>typeof x === "object" && x !== null;
let $9afba5e587b9c645$var$refSet;
const $9afba5e587b9c645$var$deepClone = (obj)=>{
    if (!$9afba5e587b9c645$var$refSet) $9afba5e587b9c645$var$refSet = (0, $46gat.unstable_buildProxyFunction)()[2];
    if (!$9afba5e587b9c645$var$isObject(obj) || $9afba5e587b9c645$var$refSet.has(obj)) return obj;
    const baseObject = Array.isArray(obj) ? [] : Object.create(Object.getPrototypeOf(obj));
    Reflect.ownKeys(obj).forEach((key)=>{
        baseObject[key] = $9afba5e587b9c645$var$deepClone(obj[key]);
    });
    return baseObject;
};
function $9afba5e587b9c645$export$32f3091caa3ecf1e(initialValue, skipSubscribe = false) {
    const proxyObject = (0, $46gat.proxy)({
        value: initialValue,
        history: (0, $46gat.ref)({
            wip: void 0,
            // to avoid infinite loop
            snapshots: [],
            index: -1
        }),
        clone: $9afba5e587b9c645$var$deepClone,
        canUndo: ()=>proxyObject.history.index > 0,
        undo: ()=>{
            if (proxyObject.canUndo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[--proxyObject.history.index]);
        },
        canRedo: ()=>proxyObject.history.index < proxyObject.history.snapshots.length - 1,
        redo: ()=>{
            if (proxyObject.canRedo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[++proxyObject.history.index]);
        },
        saveHistory: ()=>{
            proxyObject.history.snapshots.splice(proxyObject.history.index + 1);
            proxyObject.history.snapshots.push((0, $46gat.snapshot)(proxyObject).value);
            ++proxyObject.history.index;
        },
        subscribe: ()=>(0, $46gat.subscribe)(proxyObject, (ops)=>{
                if (ops.every((op)=>op[1][0] === "value" && (op[0] !== "set" || op[2] !== proxyObject.history.wip))) proxyObject.saveHistory();
            })
    });
    proxyObject.saveHistory();
    if (!skipSubscribe) proxyObject.subscribe();
    return proxyObject;
}
function $9afba5e587b9c645$export$339ebc24fb22ad80(initialValues) {
    const set = (0, $46gat.proxy)({
        data: Array.from(new Set(initialValues)),
        has (value) {
            return this.data.indexOf(value) !== -1;
        },
        add (value) {
            let hasProxy = false;
            if (typeof value === "object" && value !== null) hasProxy = this.data.indexOf((0, $46gat.proxy)(value)) !== -1;
            if (this.data.indexOf(value) === -1 && !hasProxy) this.data.push(value);
            return this;
        },
        delete (value) {
            const index = this.data.indexOf(value);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear () {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        forEach (cb) {
            this.data.forEach((value)=>{
                cb(value, value, this);
            });
        },
        get [Symbol.toStringTag] () {
            return "Set";
        },
        toJSON () {
            return new Set(this.data);
        },
        [Symbol.iterator] () {
            return this.data[Symbol.iterator]();
        },
        values () {
            return this.data.values();
        },
        keys () {
            return this.data.values();
        },
        entries () {
            return new Set(this.data).entries();
        }
    });
    Object.defineProperties(set, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(set);
    return set;
}
function $9afba5e587b9c645$export$17aaac2670e0d2b9(entries) {
    const map = (0, $46gat.proxy)({
        data: Array.from(entries || []),
        has (key) {
            return this.data.some((p)=>p[0] === key);
        },
        set (key, value) {
            const record = this.data.find((p)=>p[0] === key);
            if (record) record[1] = value;
            else this.data.push([
                key,
                value
            ]);
            return this;
        },
        get (key) {
            var _a;
            return (_a = this.data.find((p)=>p[0] === key)) == null ? void 0 : _a[1];
        },
        delete (key) {
            const index = this.data.findIndex((p)=>p[0] === key);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear () {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        toJSON () {
            return new Map(this.data);
        },
        forEach (cb) {
            this.data.forEach((p)=>{
                cb(p[1], p[0], this);
            });
        },
        keys () {
            return this.data.map((p)=>p[0]).values();
        },
        values () {
            return this.data.map((p)=>p[1]).values();
        },
        entries () {
            return new Map(this.data).entries();
        },
        get [Symbol.toStringTag] () {
            return "Map";
        },
        [Symbol.iterator] () {
            return this.entries();
        }
    });
    Object.defineProperties(map, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(map);
    return map;
}

});

parcelRegister("7mucr", function(module, exports) {

$parcel$export(module.exports, "AccountController", function () { return $55c2037f5851c1a5$export$3a40b83c1282ee40; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");

var $23VhR = parcelRequire("23VhR");
const $55c2037f5851c1a5$var$state = (0, $46gat.proxy)({
    isConnected: false
});
const $55c2037f5851c1a5$export$3a40b83c1282ee40 = {
    state: $55c2037f5851c1a5$var$state,
    subscribe (callback) {
        return (0, $46gat.subscribe)($55c2037f5851c1a5$var$state, ()=>callback($55c2037f5851c1a5$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($55c2037f5851c1a5$var$state, key, callback);
    },
    setIsConnected (isConnected) {
        $55c2037f5851c1a5$var$state.isConnected = isConnected;
    },
    setCaipAddress (caipAddress) {
        $55c2037f5851c1a5$var$state.caipAddress = caipAddress;
        $55c2037f5851c1a5$var$state.address = caipAddress ? (0, $23VhR.CoreHelperUtil).getPlainAddress(caipAddress) : undefined;
    },
    setBalance (balance, balanceSymbol) {
        $55c2037f5851c1a5$var$state.balance = balance;
        $55c2037f5851c1a5$var$state.balanceSymbol = balanceSymbol;
    },
    setProfileName (profileName) {
        $55c2037f5851c1a5$var$state.profileName = profileName;
    },
    setProfileImage (profileImage) {
        $55c2037f5851c1a5$var$state.profileImage = profileImage;
    },
    setAddressExplorerUrl (explorerUrl) {
        $55c2037f5851c1a5$var$state.addressExplorerUrl = explorerUrl;
    },
    resetAccount () {
        $55c2037f5851c1a5$var$state.isConnected = false;
        $55c2037f5851c1a5$var$state.caipAddress = undefined;
        $55c2037f5851c1a5$var$state.address = undefined;
        $55c2037f5851c1a5$var$state.balance = undefined;
        $55c2037f5851c1a5$var$state.balanceSymbol = undefined;
        $55c2037f5851c1a5$var$state.profileName = undefined;
        $55c2037f5851c1a5$var$state.profileImage = undefined;
        $55c2037f5851c1a5$var$state.addressExplorerUrl = undefined;
    }
};

});
parcelRegister("23VhR", function(module, exports) {

$parcel$export(module.exports, "CoreHelperUtil", function () { return $18084c9cf0c3729d$export$d8fe68a4208d58ff; });

var $QVM5q = parcelRequire("QVM5q");
const $18084c9cf0c3729d$export$d8fe68a4208d58ff = {
    isMobile () {
        if (typeof window !== "undefined") return Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent));
        return false;
    },
    isAndroid () {
        const ua = window.navigator.userAgent.toLowerCase();
        return $18084c9cf0c3729d$export$d8fe68a4208d58ff.isMobile() && ua.includes("android");
    },
    isIos () {
        const ua = window.navigator.userAgent.toLowerCase();
        return $18084c9cf0c3729d$export$d8fe68a4208d58ff.isMobile() && (ua.includes("iphone") || ua.includes("ipad"));
    },
    isClient () {
        return typeof window !== "undefined";
    },
    isPairingExpired (expiry) {
        return expiry ? expiry - Date.now() <= (0, $QVM5q.ConstantsUtil).TEN_SEC_MS : true;
    },
    isAllowedRetry (lastRetry) {
        return Date.now() - lastRetry >= (0, $QVM5q.ConstantsUtil).ONE_SEC_MS;
    },
    copyToClopboard (text) {
        navigator.clipboard.writeText(text);
    },
    getPairingExpiry () {
        return Date.now() + (0, $QVM5q.ConstantsUtil).FOUR_MINUTES_MS;
    },
    getPlainAddress (caipAddress) {
        return caipAddress.split(":")[2];
    },
    async wait (milliseconds) {
        return new Promise((resolve)=>{
            setTimeout(resolve, milliseconds);
        });
    },
    debounce (func, timeout = 500) {
        let timer = undefined;
        return (...args)=>{
            function next() {
                func(...args);
            }
            if (timer) clearTimeout(timer);
            timer = setTimeout(next, timeout);
        };
    },
    isHttpUrl (url) {
        return url.startsWith("http://") || url.startsWith("https://");
    },
    formatNativeUrl (appUrl, wcUri) {
        if ($18084c9cf0c3729d$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatUniversalUrl(appUrl, wcUri);
        let safeAppUrl = appUrl;
        if (!safeAppUrl.includes("://")) {
            safeAppUrl = appUrl.replaceAll("/", "").replaceAll(":", "");
            safeAppUrl = `${safeAppUrl}://`;
        }
        if (!safeAppUrl.endsWith("/")) safeAppUrl = `${safeAppUrl}/`;
        const encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: `${safeAppUrl}wc?uri=${encodedWcUrl}`,
            href: safeAppUrl
        };
    },
    formatUniversalUrl (appUrl, wcUri) {
        if (!$18084c9cf0c3729d$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatNativeUrl(appUrl, wcUri);
        let safeAppUrl = appUrl;
        if (!safeAppUrl.endsWith("/")) safeAppUrl = `${safeAppUrl}/`;
        const encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: `${safeAppUrl}wc?uri=${encodedWcUrl}`,
            href: safeAppUrl
        };
    },
    openHref (href, target, features) {
        window.open(href, target, features || "noreferrer noopener");
    },
    async preloadImage (src) {
        const imagePromise = new Promise((resolve, reject)=>{
            const image = new Image();
            image.onload = resolve;
            image.onerror = reject;
            image.crossOrigin = "anonymous";
            image.src = src;
        });
        return Promise.race([
            imagePromise,
            $18084c9cf0c3729d$export$d8fe68a4208d58ff.wait(2000)
        ]);
    },
    formatBalance (balance, symbol) {
        let formattedBalance = undefined;
        if (balance === "0") formattedBalance = "0.000";
        else if (typeof balance === "string") {
            const number = Number(balance);
            if (number) formattedBalance = number.toString().match(/^-?\d+(?:\.\d{0,3})?/u)?.[0];
        }
        return formattedBalance ? `${formattedBalance} ${symbol ?? ""}` : `0.000 ${symbol ?? ""}`;
    },
    formatBalance2 (balance, symbol) {
        let formattedBalance = undefined;
        if (balance === "0") formattedBalance = "0";
        else if (typeof balance === "string") {
            const number = Number(balance);
            if (number) formattedBalance = number.toString().match(/^-?\d+(?:\.\d{0,3})?/u)?.[0];
        }
        return {
            value: formattedBalance ?? "0",
            rest: formattedBalance === "0" ? "000" : "",
            symbol: symbol
        };
    },
    isRestrictedRegion () {
        try {
            const { timeZone: timeZone } = new Intl.DateTimeFormat().resolvedOptions();
            const capTimeZone = timeZone.toUpperCase();
            return (0, $QVM5q.ConstantsUtil).RESTRICTED_TIMEZONES.includes(capTimeZone);
        } catch  {
            return false;
        }
    },
    getApiUrl () {
        return $18084c9cf0c3729d$export$d8fe68a4208d58ff.isRestrictedRegion() ? "https://api.web3modal.org" : "https://api.web3modal.com";
    },
    getBlockchainApiUrl () {
        return $18084c9cf0c3729d$export$d8fe68a4208d58ff.isRestrictedRegion() ? "https://rpc.walletconnect.org" : "https://rpc.walletconnect.com";
    },
    getAnalyticsUrl () {
        return $18084c9cf0c3729d$export$d8fe68a4208d58ff.isRestrictedRegion() ? "https://pulse.walletconnect.org" : "https://pulse.walletconnect.com";
    },
    getUUID () {
        if (crypto?.randomUUID) return crypto.randomUUID();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (c)=>{
            const r = Math.random() * 16 | 0;
            const v = c === "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    },
    parseError (error) {
        if (typeof error === "string") return error;
        else if (typeof error?.issues?.[0]?.message === "string") return error.issues[0].message;
        else if (error instanceof Error) return error.message;
        return "Unknown error";
    },
    sortRequestedNetworks (approvedIds, requestedNetworks = []) {
        const approvedIndexMap = {};
        if (requestedNetworks && approvedIds) {
            approvedIds.forEach((id, index)=>{
                approvedIndexMap[id] = index;
            });
            requestedNetworks.sort((a, b)=>{
                const indexA = approvedIndexMap[a.id];
                const indexB = approvedIndexMap[b.id];
                if (indexA !== undefined && indexB !== undefined) return indexA - indexB;
                else if (indexA !== undefined) return -1;
                else if (indexB !== undefined) return 1;
                return 0;
            });
        }
        return requestedNetworks;
    }
};

});
parcelRegister("QVM5q", function(module, exports) {

$parcel$export(module.exports, "ONRAMP_PROVIDERS", function () { return $09f1ac45ec882979$export$e021b4b4649620f6; });
$parcel$export(module.exports, "ConstantsUtil", function () { return $09f1ac45ec882979$export$aafe1f751f1bc52a; });
const $09f1ac45ec882979$var$SECURE_SITE = "https://secure.walletconnect.com";
const $09f1ac45ec882979$export$e021b4b4649620f6 = [
    {
        label: "Coinbase",
        name: "coinbase",
        feeRange: "1-2%",
        url: ""
    }
];
const $09f1ac45ec882979$export$aafe1f751f1bc52a = {
    FOUR_MINUTES_MS: 240000,
    TEN_SEC_MS: 10000,
    ONE_SEC_MS: 1000,
    SECURE_SITE: $09f1ac45ec882979$var$SECURE_SITE,
    SECURE_SITE_DASHBOARD: `${$09f1ac45ec882979$var$SECURE_SITE}/dashboard`,
    SECURE_SITE_FAVICON: `${$09f1ac45ec882979$var$SECURE_SITE}/images/favicon.png`,
    RESTRICTED_TIMEZONES: [
        "ASIA/SHANGHAI",
        "ASIA/URUMQI",
        "ASIA/CHONGQING",
        "ASIA/HARBIN",
        "ASIA/KASHGAR",
        "ASIA/MACAU",
        "ASIA/HONG_KONG",
        "ASIA/MACAO",
        "ASIA/BEIJING",
        "ASIA/HARBIN"
    ],
    CONNECTOR_RDNS_MAP: {
        coinbaseWallet: "com.coinbase.wallet"
    },
    WC_COINBASE_PAY_SDK_CHAINS: [
        "ethereum",
        "arbitrum",
        "polygon",
        "avalanche-c-chain",
        "optimism",
        "celo",
        "base"
    ],
    WC_COINBASE_PAY_SDK_FALLBACK_CHAIN: "ethereum",
    WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP: {
        Ethereum: "ethereum",
        "Arbitrum One": "arbitrum",
        Polygon: "polygon",
        Avalanche: "avalanche-c-chain",
        "OP Mainnet": "optimism",
        Celo: "celo",
        Base: "base"
    },
    WC_COINBASE_ONRAMP_APP_ID: "bf18c88d-495a-463b-b249-0b9d3656cf5e"
};

});



parcelRegister("aHgTP", function(module, exports) {

$parcel$export(module.exports, "ApiController", function () { return $7c9b076d4ae48ddc$export$99411f73957952af; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");

var $23VhR = parcelRequire("23VhR");

var $5pVbp = parcelRequire("5pVbp");

var $6sZsT = parcelRequire("6sZsT");

var $b2pRm = parcelRequire("b2pRm");

var $01g6R = parcelRequire("01g6R");

var $8A6Jz = parcelRequire("8A6Jz");

var $cPOJT = parcelRequire("cPOJT");
const $7c9b076d4ae48ddc$var$baseUrl = (0, $23VhR.CoreHelperUtil).getApiUrl();
const $7c9b076d4ae48ddc$export$644d8ea042df96a6 = new (0, $5pVbp.FetchUtil)({
    baseUrl: $7c9b076d4ae48ddc$var$baseUrl
});
const $7c9b076d4ae48ddc$var$entries = "40";
const $7c9b076d4ae48ddc$var$recommendedEntries = "4";
const $7c9b076d4ae48ddc$var$state = (0, $46gat.proxy)({
    page: 1,
    count: 0,
    featured: [],
    recommended: [],
    wallets: [],
    search: [],
    isAnalyticsEnabled: false
});
const $7c9b076d4ae48ddc$export$99411f73957952af = {
    state: $7c9b076d4ae48ddc$var$state,
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($7c9b076d4ae48ddc$var$state, key, callback);
    },
    _getApiHeaders () {
        const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $cPOJT.OptionsController).state;
        return {
            "x-project-id": projectId,
            "x-sdk-type": sdkType,
            "x-sdk-version": sdkVersion
        };
    },
    async _fetchWalletImage (imageId) {
        const imageUrl = `${$7c9b076d4ae48ddc$export$644d8ea042df96a6.baseUrl}/getWalletImage/${imageId}`;
        const blob = await $7c9b076d4ae48ddc$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $7c9b076d4ae48ddc$export$99411f73957952af._getApiHeaders()
        });
        (0, $b2pRm.AssetController).setWalletImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchNetworkImage (imageId) {
        const imageUrl = `${$7c9b076d4ae48ddc$export$644d8ea042df96a6.baseUrl}/public/getAssetImage/${imageId}`;
        const blob = await $7c9b076d4ae48ddc$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $7c9b076d4ae48ddc$export$99411f73957952af._getApiHeaders()
        });
        (0, $b2pRm.AssetController).setNetworkImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchConnectorImage (imageId) {
        const imageUrl = `${$7c9b076d4ae48ddc$export$644d8ea042df96a6.baseUrl}/public/getAssetImage/${imageId}`;
        const blob = await $7c9b076d4ae48ddc$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $7c9b076d4ae48ddc$export$99411f73957952af._getApiHeaders()
        });
        (0, $b2pRm.AssetController).setConnectorImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchCurrencyImage (countryCode) {
        const imageUrl = `${$7c9b076d4ae48ddc$export$644d8ea042df96a6.baseUrl}/public/getCurrencyImage/${countryCode}`;
        const blob = await $7c9b076d4ae48ddc$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $7c9b076d4ae48ddc$export$99411f73957952af._getApiHeaders()
        });
        (0, $b2pRm.AssetController).setCurrencyImage(countryCode, URL.createObjectURL(blob));
    },
    async _fetchTokenImage (symbol) {
        const imageUrl = `${$7c9b076d4ae48ddc$export$644d8ea042df96a6.baseUrl}/public/getTokenImage/${symbol}`;
        const blob = await $7c9b076d4ae48ddc$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $7c9b076d4ae48ddc$export$99411f73957952af._getApiHeaders()
        });
        (0, $b2pRm.AssetController).setTokenImage(symbol, URL.createObjectURL(blob));
    },
    async fetchNetworkImages () {
        const { requestedCaipNetworks: requestedCaipNetworks } = (0, $8A6Jz.NetworkController).state;
        const ids = requestedCaipNetworks?.map(({ imageId: imageId })=>imageId).filter(Boolean);
        if (ids) await Promise.allSettled(ids.map((id)=>$7c9b076d4ae48ddc$export$99411f73957952af._fetchNetworkImage(id)));
    },
    async fetchConnectorImages () {
        const { connectors: connectors } = (0, $01g6R.ConnectorController).state;
        const ids = connectors.map(({ imageId: imageId })=>imageId).filter(Boolean);
        await Promise.allSettled(ids.map((id)=>$7c9b076d4ae48ddc$export$99411f73957952af._fetchConnectorImage(id)));
    },
    async fetchCurrencyImages (currencies = []) {
        await Promise.allSettled(currencies.map((currency)=>$7c9b076d4ae48ddc$export$99411f73957952af._fetchCurrencyImage(currency)));
    },
    async fetchTokenImages (tokens = []) {
        await Promise.allSettled(tokens.map((token)=>$7c9b076d4ae48ddc$export$99411f73957952af._fetchTokenImage(token)));
    },
    async fetchFeaturedWallets () {
        const { featuredWalletIds: featuredWalletIds } = (0, $cPOJT.OptionsController).state;
        if (featuredWalletIds?.length) {
            const { data: data } = await $7c9b076d4ae48ddc$export$644d8ea042df96a6.get({
                path: "/getWallets",
                headers: $7c9b076d4ae48ddc$export$99411f73957952af._getApiHeaders(),
                params: {
                    page: "1",
                    entries: featuredWalletIds?.length ? String(featuredWalletIds.length) : $7c9b076d4ae48ddc$var$recommendedEntries,
                    include: featuredWalletIds?.join(",")
                }
            });
            data.sort((a, b)=>featuredWalletIds.indexOf(a.id) - featuredWalletIds.indexOf(b.id));
            const images = data.map((d)=>d.image_id).filter(Boolean);
            await Promise.allSettled(images.map((id)=>$7c9b076d4ae48ddc$export$99411f73957952af._fetchWalletImage(id)));
            $7c9b076d4ae48ddc$var$state.featured = data;
        }
    },
    async fetchRecommendedWallets () {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds, featuredWalletIds: featuredWalletIds } = (0, $cPOJT.OptionsController).state;
        const exclude = [
            ...excludeWalletIds ?? [],
            ...featuredWalletIds ?? []
        ].filter(Boolean);
        const { data: data, count: count } = await $7c9b076d4ae48ddc$export$644d8ea042df96a6.get({
            path: "/getWallets",
            headers: $7c9b076d4ae48ddc$export$99411f73957952af._getApiHeaders(),
            params: {
                page: "1",
                entries: $7c9b076d4ae48ddc$var$recommendedEntries,
                include: includeWalletIds?.join(","),
                exclude: exclude?.join(",")
            }
        });
        const recent = (0, $6sZsT.StorageUtil).getRecentWallets();
        const recommendedImages = data.map((d)=>d.image_id).filter(Boolean);
        const recentImages = recent.map((r)=>r.image_id).filter(Boolean);
        await Promise.allSettled([
            ...recommendedImages,
            ...recentImages
        ].map((id)=>$7c9b076d4ae48ddc$export$99411f73957952af._fetchWalletImage(id)));
        $7c9b076d4ae48ddc$var$state.recommended = data;
        $7c9b076d4ae48ddc$var$state.count = count ?? 0;
    },
    async fetchWallets ({ page: page }) {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds, featuredWalletIds: featuredWalletIds } = (0, $cPOJT.OptionsController).state;
        const exclude = [
            ...$7c9b076d4ae48ddc$var$state.recommended.map(({ id: id })=>id),
            ...excludeWalletIds ?? [],
            ...featuredWalletIds ?? []
        ].filter(Boolean);
        const { data: data, count: count } = await $7c9b076d4ae48ddc$export$644d8ea042df96a6.get({
            path: "/getWallets",
            headers: $7c9b076d4ae48ddc$export$99411f73957952af._getApiHeaders(),
            params: {
                page: String(page),
                entries: $7c9b076d4ae48ddc$var$entries,
                include: includeWalletIds?.join(","),
                exclude: exclude.join(",")
            }
        });
        const images = data.map((w)=>w.image_id).filter(Boolean);
        await Promise.allSettled([
            ...images.map((id)=>$7c9b076d4ae48ddc$export$99411f73957952af._fetchWalletImage(id)),
            (0, $23VhR.CoreHelperUtil).wait(300)
        ]);
        $7c9b076d4ae48ddc$var$state.wallets = [
            ...$7c9b076d4ae48ddc$var$state.wallets,
            ...data
        ];
        $7c9b076d4ae48ddc$var$state.count = count > $7c9b076d4ae48ddc$var$state.count ? count : $7c9b076d4ae48ddc$var$state.count;
        $7c9b076d4ae48ddc$var$state.page = page;
    },
    async searchWallet ({ search: search }) {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds } = (0, $cPOJT.OptionsController).state;
        $7c9b076d4ae48ddc$var$state.search = [];
        const { data: data } = await $7c9b076d4ae48ddc$export$644d8ea042df96a6.get({
            path: "/getWallets",
            headers: $7c9b076d4ae48ddc$export$99411f73957952af._getApiHeaders(),
            params: {
                page: "1",
                entries: "100",
                search: search,
                include: includeWalletIds?.join(","),
                exclude: excludeWalletIds?.join(",")
            }
        });
        const images = data.map((w)=>w.image_id).filter(Boolean);
        await Promise.allSettled([
            ...images.map((id)=>$7c9b076d4ae48ddc$export$99411f73957952af._fetchWalletImage(id)),
            (0, $23VhR.CoreHelperUtil).wait(300)
        ]);
        $7c9b076d4ae48ddc$var$state.search = data;
    },
    prefetch () {
        const promises = [
            $7c9b076d4ae48ddc$export$99411f73957952af.fetchFeaturedWallets(),
            $7c9b076d4ae48ddc$export$99411f73957952af.fetchRecommendedWallets(),
            $7c9b076d4ae48ddc$export$99411f73957952af.fetchNetworkImages(),
            $7c9b076d4ae48ddc$export$99411f73957952af.fetchConnectorImages()
        ];
        if ((0, $cPOJT.OptionsController).state.enableAnalytics === undefined) promises.push($7c9b076d4ae48ddc$export$99411f73957952af.fetchAnalyticsConfig());
        $7c9b076d4ae48ddc$var$state.prefetchPromise = Promise.race([
            Promise.allSettled(promises),
            (0, $23VhR.CoreHelperUtil).wait(3000)
        ]);
    },
    async fetchAnalyticsConfig () {
        const { isAnalyticsEnabled: isAnalyticsEnabled } = await $7c9b076d4ae48ddc$export$644d8ea042df96a6.get({
            path: "/getAnalyticsConfig",
            headers: $7c9b076d4ae48ddc$export$99411f73957952af._getApiHeaders()
        });
        (0, $cPOJT.OptionsController).setEnableAnalytics(isAnalyticsEnabled);
    }
};

});
parcelRegister("5pVbp", function(module, exports) {

$parcel$export(module.exports, "FetchUtil", function () { return $3f1ba4ebadf6b27b$export$ed6eff17d860976a; });
class $3f1ba4ebadf6b27b$export$ed6eff17d860976a {
    constructor({ baseUrl: baseUrl }){
        this.baseUrl = baseUrl;
    }
    async get({ headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "GET",
            headers: headers,
            signal: signal,
            cache: "no-cache"
        });
        return response.json();
    }
    async getBlob({ headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "GET",
            headers: headers,
            signal: signal
        });
        return response.blob();
    }
    async post({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "POST",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    async put({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "PUT",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    async delete({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "DELETE",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    createUrl({ path: path, params: params }) {
        const url = new URL(path, this.baseUrl);
        if (params) Object.entries(params).forEach(([key, value])=>{
            if (value) url.searchParams.append(key, value);
        });
        return url;
    }
}

});

parcelRegister("6sZsT", function(module, exports) {

$parcel$export(module.exports, "StorageUtil", function () { return $4b55094a44ae9b1f$export$d4382c6359971b24; });
const $4b55094a44ae9b1f$var$WC_DEEPLINK = "WALLETCONNECT_DEEPLINK_CHOICE";
const $4b55094a44ae9b1f$var$W3M_RECENT = "@w3m/recent";
const $4b55094a44ae9b1f$var$W3M_CONNECTED_WALLET_IMAGE_URL = "@w3m/connected_wallet_image_url";
const $4b55094a44ae9b1f$var$W3M_CONNECTED_CONNECTOR = "@w3m/connected_connector";
const $4b55094a44ae9b1f$export$d4382c6359971b24 = {
    setWalletConnectDeepLink ({ href: href, name: name }) {
        try {
            localStorage.setItem($4b55094a44ae9b1f$var$WC_DEEPLINK, JSON.stringify({
                href: href,
                name: name
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    getWalletConnectDeepLink () {
        try {
            const deepLink = localStorage.getItem($4b55094a44ae9b1f$var$WC_DEEPLINK);
            if (deepLink) return JSON.parse(deepLink);
        } catch  {
            console.info("Unable to get WalletConnect deep link");
        }
        return undefined;
    },
    deleteWalletConnectDeepLink () {
        try {
            localStorage.removeItem($4b55094a44ae9b1f$var$WC_DEEPLINK);
        } catch  {
            console.info("Unable to delete WalletConnect deep link");
        }
    },
    setWeb3ModalRecent (wallet) {
        try {
            const recentWallets = $4b55094a44ae9b1f$export$d4382c6359971b24.getRecentWallets();
            const exists = recentWallets.find((w)=>w.id === wallet.id);
            if (!exists) {
                recentWallets.unshift(wallet);
                if (recentWallets.length > 2) recentWallets.pop();
                localStorage.setItem($4b55094a44ae9b1f$var$W3M_RECENT, JSON.stringify(recentWallets));
            }
        } catch  {
            console.info("Unable to set Web3Modal recent");
        }
    },
    getRecentWallets () {
        try {
            const recent = localStorage.getItem($4b55094a44ae9b1f$var$W3M_RECENT);
            return recent ? JSON.parse(recent) : [];
        } catch  {
            console.info("Unable to get Web3Modal recent");
        }
        return [];
    },
    setConnectedWalletImageUrl (imageUrl) {
        try {
            localStorage.setItem($4b55094a44ae9b1f$var$W3M_CONNECTED_WALLET_IMAGE_URL, imageUrl);
        } catch  {
            console.info("Unable to set Connected Wallet Image Url");
        }
    },
    getConnectedWalletImageUrl () {
        try {
            return localStorage.getItem($4b55094a44ae9b1f$var$W3M_CONNECTED_WALLET_IMAGE_URL);
        } catch  {
            console.info("Unable to set Connected Wallet Image Url");
        }
        return undefined;
    },
    setConnectedConnector (connectorType) {
        try {
            localStorage.setItem($4b55094a44ae9b1f$var$W3M_CONNECTED_CONNECTOR, connectorType);
        } catch  {
            console.info("Unable to set Connected Connector");
        }
    },
    getConnectedConnector () {
        try {
            return localStorage.getItem($4b55094a44ae9b1f$var$W3M_CONNECTED_CONNECTOR);
        } catch  {
            console.info("Unable to get Connected Connector");
        }
        return undefined;
    }
};

});

parcelRegister("b2pRm", function(module, exports) {

$parcel$export(module.exports, "AssetController", function () { return $8093f0cfcd2c5b57$export$4f2a98fee99335; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");
const $8093f0cfcd2c5b57$var$state = (0, $46gat.proxy)({
    walletImages: {},
    networkImages: {},
    connectorImages: {},
    tokenImages: {},
    currencyImages: {}
});
const $8093f0cfcd2c5b57$export$4f2a98fee99335 = {
    state: $8093f0cfcd2c5b57$var$state,
    subscribeNetworkImages (callback) {
        return (0, $46gat.subscribe)($8093f0cfcd2c5b57$var$state.networkImages, ()=>callback($8093f0cfcd2c5b57$var$state.networkImages));
    },
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($8093f0cfcd2c5b57$var$state, key, callback);
    },
    subscribe (callback) {
        return (0, $46gat.subscribe)($8093f0cfcd2c5b57$var$state, ()=>callback($8093f0cfcd2c5b57$var$state));
    },
    setWalletImage (key, value) {
        $8093f0cfcd2c5b57$var$state.walletImages[key] = value;
    },
    setNetworkImage (key, value) {
        $8093f0cfcd2c5b57$var$state.networkImages[key] = value;
    },
    setConnectorImage (key, value) {
        $8093f0cfcd2c5b57$var$state.connectorImages[key] = value;
    },
    setTokenImage (key, value) {
        $8093f0cfcd2c5b57$var$state.tokenImages[key] = value;
    },
    setCurrencyImage (key, value) {
        $8093f0cfcd2c5b57$var$state.currencyImages[key] = value;
    }
};

});

parcelRegister("01g6R", function(module, exports) {

$parcel$export(module.exports, "ConnectorController", function () { return $003c9721a80e48d9$export$c83edcb4eee2f517; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");

var $cPOJT = parcelRequire("cPOJT");

var $jGPEs = parcelRequire("jGPEs");
const $003c9721a80e48d9$var$state = (0, $46gat.proxy)({
    connectors: []
});
const $003c9721a80e48d9$export$c83edcb4eee2f517 = {
    state: $003c9721a80e48d9$var$state,
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($003c9721a80e48d9$var$state, key, callback);
    },
    setConnectors (connectors) {
        $003c9721a80e48d9$var$state.connectors = connectors.map((c)=>(0, $46gat.ref)(c));
    },
    addConnector (connector) {
        $003c9721a80e48d9$var$state.connectors.push((0, $46gat.ref)(connector));
        if (connector.id === "w3mEmail") {
            const emailConnector = connector;
            const optionsState = (0, $46gat.snapshot)((0, $cPOJT.OptionsController).state);
            emailConnector?.provider?.syncDappData?.({
                metadata: optionsState.metadata,
                sdkVersion: optionsState.sdkVersion,
                projectId: optionsState.projectId
            });
            emailConnector.provider.syncTheme({
                themeMode: (0, $jGPEs.ThemeController).getSnapshot().themeMode,
                themeVariables: (0, $jGPEs.ThemeController).getSnapshot().themeVariables
            });
        }
    },
    getEmailConnector () {
        return $003c9721a80e48d9$var$state.connectors.find((c)=>c.type === "EMAIL");
    },
    getAnnouncedConnectorRdns () {
        return $003c9721a80e48d9$var$state.connectors.filter((c)=>c.type === "ANNOUNCED").map((c)=>c.info?.rdns);
    },
    getConnectors () {
        return $003c9721a80e48d9$var$state.connectors;
    }
};

});
parcelRegister("cPOJT", function(module, exports) {

$parcel$export(module.exports, "OptionsController", function () { return $95819b3832e5724b$export$1f4c428077fc6173; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");
const $95819b3832e5724b$var$state = (0, $46gat.proxy)({
    projectId: "",
    sdkType: "w3m",
    sdkVersion: "html-wagmi-undefined"
});
const $95819b3832e5724b$export$1f4c428077fc6173 = {
    state: $95819b3832e5724b$var$state,
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($95819b3832e5724b$var$state, key, callback);
    },
    setProjectId (projectId) {
        $95819b3832e5724b$var$state.projectId = projectId;
    },
    setAllWallets (allWallets) {
        $95819b3832e5724b$var$state.allWallets = allWallets;
    },
    setIncludeWalletIds (includeWalletIds) {
        $95819b3832e5724b$var$state.includeWalletIds = includeWalletIds;
    },
    setExcludeWalletIds (excludeWalletIds) {
        $95819b3832e5724b$var$state.excludeWalletIds = excludeWalletIds;
    },
    setFeaturedWalletIds (featuredWalletIds) {
        $95819b3832e5724b$var$state.featuredWalletIds = featuredWalletIds;
    },
    setTokens (tokens) {
        $95819b3832e5724b$var$state.tokens = tokens;
    },
    setTermsConditionsUrl (termsConditionsUrl) {
        $95819b3832e5724b$var$state.termsConditionsUrl = termsConditionsUrl;
    },
    setPrivacyPolicyUrl (privacyPolicyUrl) {
        $95819b3832e5724b$var$state.privacyPolicyUrl = privacyPolicyUrl;
    },
    setCustomWallets (customWallets) {
        $95819b3832e5724b$var$state.customWallets = customWallets;
    },
    setEnableAnalytics (enableAnalytics) {
        $95819b3832e5724b$var$state.enableAnalytics = enableAnalytics;
    },
    setSdkVersion (sdkVersion) {
        $95819b3832e5724b$var$state.sdkVersion = sdkVersion;
    },
    setMetadata (metadata) {
        $95819b3832e5724b$var$state.metadata = metadata;
    },
    setOnrampEnabled (enableOnramp) {
        $95819b3832e5724b$var$state.enableOnramp = enableOnramp;
    }
};

});

parcelRegister("jGPEs", function(module, exports) {

$parcel$export(module.exports, "ThemeController", function () { return $e55a017b5c41963d$export$e18d4112326e72bf; });

var $46gat = parcelRequire("46gat");

var $01g6R = parcelRequire("01g6R");
const $e55a017b5c41963d$var$state = (0, $46gat.proxy)({
    themeMode: "dark",
    themeVariables: {}
});
const $e55a017b5c41963d$export$e18d4112326e72bf = {
    state: $e55a017b5c41963d$var$state,
    subscribe (callback) {
        return (0, $46gat.subscribe)($e55a017b5c41963d$var$state, ()=>callback($e55a017b5c41963d$var$state));
    },
    setThemeMode (themeMode) {
        $e55a017b5c41963d$var$state.themeMode = themeMode;
        try {
            const emailConnector = (0, $01g6R.ConnectorController).getEmailConnector();
            if (emailConnector) emailConnector.provider.syncTheme({
                themeMode: $e55a017b5c41963d$export$e18d4112326e72bf.getSnapshot().themeMode
            });
        } catch  {
            console.info("Unable to sync theme to email connector");
        }
    },
    setThemeVariables (themeVariables) {
        $e55a017b5c41963d$var$state.themeVariables = {
            ...$e55a017b5c41963d$var$state.themeVariables,
            ...themeVariables
        };
        try {
            const emailConnector = (0, $01g6R.ConnectorController).getEmailConnector();
            if (emailConnector) emailConnector.provider.syncTheme({
                themeVariables: $e55a017b5c41963d$export$e18d4112326e72bf.getSnapshot().themeVariables
            });
        } catch  {
            console.info("Unable to sync theme to email connector");
        }
    },
    getSnapshot () {
        return (0, $46gat.snapshot)($e55a017b5c41963d$var$state);
    }
};

});


parcelRegister("8A6Jz", function(module, exports) {

$parcel$export(module.exports, "NetworkController", function () { return $63f6e8c82ff8e5eb$export$c63f10f788d47d86; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");

var $9q2Kw = parcelRequire("9q2Kw");

var $dUlgM = parcelRequire("dUlgM");

var $nBm8O = parcelRequire("nBm8O");

var $23VhR = parcelRequire("23VhR");
const $63f6e8c82ff8e5eb$var$state = (0, $46gat.proxy)({
    supportsAllNetworks: true,
    isDefaultCaipNetwork: false
});
const $63f6e8c82ff8e5eb$export$c63f10f788d47d86 = {
    state: $63f6e8c82ff8e5eb$var$state,
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($63f6e8c82ff8e5eb$var$state, key, callback);
    },
    _getClient () {
        if (!$63f6e8c82ff8e5eb$var$state._client) throw new Error("NetworkController client not set");
        return $63f6e8c82ff8e5eb$var$state._client;
    },
    setClient (client) {
        $63f6e8c82ff8e5eb$var$state._client = (0, $46gat.ref)(client);
    },
    setCaipNetwork (caipNetwork) {
        $63f6e8c82ff8e5eb$var$state.caipNetwork = caipNetwork;
        (0, $9q2Kw.PublicStateController).set({
            selectedNetworkId: caipNetwork?.id
        });
        this.checkIfSupportedNetwork();
    },
    setDefaultCaipNetwork (caipNetwork) {
        $63f6e8c82ff8e5eb$var$state.caipNetwork = caipNetwork;
        (0, $9q2Kw.PublicStateController).set({
            selectedNetworkId: caipNetwork?.id
        });
        $63f6e8c82ff8e5eb$var$state.isDefaultCaipNetwork = true;
    },
    setRequestedCaipNetworks (requestedNetworks) {
        $63f6e8c82ff8e5eb$var$state.requestedCaipNetworks = requestedNetworks;
    },
    getRequestedCaipNetworks () {
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, requestedCaipNetworks: requestedCaipNetworks } = $63f6e8c82ff8e5eb$var$state;
        const approvedIds = approvedCaipNetworkIds;
        const requestedNetworks = requestedCaipNetworks;
        return (0, $23VhR.CoreHelperUtil).sortRequestedNetworks(approvedIds, requestedNetworks);
    },
    async getApprovedCaipNetworksData () {
        const data = await this._getClient().getApprovedCaipNetworksData();
        $63f6e8c82ff8e5eb$var$state.supportsAllNetworks = data.supportsAllNetworks;
        $63f6e8c82ff8e5eb$var$state.approvedCaipNetworkIds = data.approvedCaipNetworkIds;
    },
    async switchActiveNetwork (network) {
        await this._getClient().switchCaipNetwork(network);
        $63f6e8c82ff8e5eb$var$state.caipNetwork = network;
        if (network) (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "SWITCH_NETWORK",
            properties: {
                network: network.id
            }
        });
    },
    checkIfSupportedNetwork () {
        $63f6e8c82ff8e5eb$var$state.isUnsupportedChain = !$63f6e8c82ff8e5eb$var$state.requestedCaipNetworks?.some((network)=>network.id === $63f6e8c82ff8e5eb$var$state.caipNetwork?.id);
        if ($63f6e8c82ff8e5eb$var$state.isUnsupportedChain) this.showUnsupportedChainUI();
    },
    resetNetwork () {
        if (!$63f6e8c82ff8e5eb$var$state.isDefaultCaipNetwork) $63f6e8c82ff8e5eb$var$state.caipNetwork = undefined;
        $63f6e8c82ff8e5eb$var$state.approvedCaipNetworkIds = undefined;
        $63f6e8c82ff8e5eb$var$state.supportsAllNetworks = true;
    },
    showUnsupportedChainUI () {
        setTimeout(()=>{
            (0, $nBm8O.ModalController).open({
                view: "UnsupportedChain"
            });
        }, 300);
    }
};

});
parcelRegister("9q2Kw", function(module, exports) {

$parcel$export(module.exports, "PublicStateController", function () { return $6db8acbba106269b$export$24bc8c77cb7c530; });

var $46gat = parcelRequire("46gat");
const $6db8acbba106269b$var$state = (0, $46gat.proxy)({
    open: false,
    selectedNetworkId: undefined
});
const $6db8acbba106269b$export$24bc8c77cb7c530 = {
    state: $6db8acbba106269b$var$state,
    subscribe (callback) {
        return (0, $46gat.subscribe)($6db8acbba106269b$var$state, ()=>callback($6db8acbba106269b$var$state));
    },
    set (newState) {
        Object.assign($6db8acbba106269b$var$state, {
            ...$6db8acbba106269b$var$state,
            ...newState
        });
    }
};

});

parcelRegister("dUlgM", function(module, exports) {

$parcel$export(module.exports, "EventsController", function () { return $a20101027ee19343$export$23ca5cb260756952; });

var $46gat = parcelRequire("46gat");

var $23VhR = parcelRequire("23VhR");

var $5pVbp = parcelRequire("5pVbp");

var $cPOJT = parcelRequire("cPOJT");
const $a20101027ee19343$var$baseUrl = (0, $23VhR.CoreHelperUtil).getAnalyticsUrl();
const $a20101027ee19343$var$api = new (0, $5pVbp.FetchUtil)({
    baseUrl: $a20101027ee19343$var$baseUrl
});
const $a20101027ee19343$var$excluded = [
    "MODAL_CREATED"
];
const $a20101027ee19343$var$state = (0, $46gat.proxy)({
    timestamp: Date.now(),
    data: {
        type: "track",
        event: "MODAL_CREATED"
    }
});
const $a20101027ee19343$export$23ca5cb260756952 = {
    state: $a20101027ee19343$var$state,
    subscribe (callback) {
        return (0, $46gat.subscribe)($a20101027ee19343$var$state, ()=>callback($a20101027ee19343$var$state));
    },
    _getApiHeaders () {
        const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $cPOJT.OptionsController).state;
        return {
            "x-project-id": projectId,
            "x-sdk-type": sdkType,
            "x-sdk-version": sdkVersion
        };
    },
    async _sendAnalyticsEvent (payload) {
        try {
            if ($a20101027ee19343$var$excluded.includes(payload.data.event) || typeof window === "undefined") return;
            await $a20101027ee19343$var$api.post({
                path: "/e",
                headers: $a20101027ee19343$export$23ca5cb260756952._getApiHeaders(),
                body: {
                    eventId: (0, $23VhR.CoreHelperUtil).getUUID(),
                    url: window.location.href,
                    domain: window.location.hostname,
                    timestamp: payload.timestamp,
                    props: payload.data
                }
            });
        } catch  {}
    },
    sendEvent (data) {
        $a20101027ee19343$var$state.timestamp = Date.now();
        $a20101027ee19343$var$state.data = data;
        if ((0, $cPOJT.OptionsController).state.enableAnalytics) $a20101027ee19343$export$23ca5cb260756952._sendAnalyticsEvent($a20101027ee19343$var$state);
    }
};

});



parcelRegister("3OaCj", function(module, exports) {

$parcel$export(module.exports, "RouterController", function () { return $2c5e46e9391dc37a$export$5ceead2526330ba8; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");
const $2c5e46e9391dc37a$var$state = (0, $46gat.proxy)({
    view: "Connect",
    history: [
        "Connect"
    ]
});
const $2c5e46e9391dc37a$export$5ceead2526330ba8 = {
    state: $2c5e46e9391dc37a$var$state,
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($2c5e46e9391dc37a$var$state, key, callback);
    },
    push (view, data) {
        if (view !== $2c5e46e9391dc37a$var$state.view) {
            $2c5e46e9391dc37a$var$state.view = view;
            $2c5e46e9391dc37a$var$state.history.push(view);
            $2c5e46e9391dc37a$var$state.data = data;
        }
    },
    reset (view) {
        $2c5e46e9391dc37a$var$state.view = view;
        $2c5e46e9391dc37a$var$state.history = [
            view
        ];
    },
    replace (view, data) {
        if ($2c5e46e9391dc37a$var$state.history.length > 1 && $2c5e46e9391dc37a$var$state.history.at(-1) !== view) {
            $2c5e46e9391dc37a$var$state.view = view;
            $2c5e46e9391dc37a$var$state.history[$2c5e46e9391dc37a$var$state.history.length - 1] = view;
            $2c5e46e9391dc37a$var$state.data = data;
        }
    },
    goBack () {
        if ($2c5e46e9391dc37a$var$state.history.length > 1) {
            $2c5e46e9391dc37a$var$state.history.pop();
            const [last] = $2c5e46e9391dc37a$var$state.history.slice(-1);
            if (last) $2c5e46e9391dc37a$var$state.view = last;
        }
    },
    goBackToIndex (historyIndex) {
        if ($2c5e46e9391dc37a$var$state.history.length > 1) {
            $2c5e46e9391dc37a$var$state.history = $2c5e46e9391dc37a$var$state.history.slice(0, historyIndex + 1);
            const [last] = $2c5e46e9391dc37a$var$state.history.slice(-1);
            if (last) $2c5e46e9391dc37a$var$state.view = last;
        }
    }
};

});


parcelRegister("79hu3", function(module, exports) {

$parcel$export(module.exports, "OnRampController", function () { return $5346ef8dd2886184$export$8cdcd0d64858bea7; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");

var $QVM5q = parcelRequire("QVM5q");

var $5PCU5 = parcelRequire("5PCU5");

var $aHgTP = parcelRequire("aHgTP");
const $5346ef8dd2886184$var$USDC_CURRENCY_DEFAULT = {
    id: "2b92315d-eab7-5bef-84fa-089a131333f5",
    name: "USD Coin",
    symbol: "USDC",
    networks: [
        {
            name: "ethereum-mainnet",
            display_name: "Ethereum",
            chain_id: "1",
            contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
        },
        {
            name: "polygon-mainnet",
            display_name: "Polygon",
            chain_id: "137",
            contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
        }
    ]
};
const $5346ef8dd2886184$var$USD_CURRENCY_DEFAULT = {
    id: "USD",
    payment_method_limits: [
        {
            id: "card",
            min: "10.00",
            max: "7500.00"
        },
        {
            id: "ach_bank_account",
            min: "10.00",
            max: "25000.00"
        }
    ]
};
const $5346ef8dd2886184$var$state = (0, $46gat.proxy)({
    providers: (0, $QVM5q.ONRAMP_PROVIDERS),
    selectedProvider: null,
    error: null,
    purchaseCurrency: $5346ef8dd2886184$var$USDC_CURRENCY_DEFAULT,
    paymentCurrency: $5346ef8dd2886184$var$USD_CURRENCY_DEFAULT,
    purchaseCurrencies: [
        $5346ef8dd2886184$var$USDC_CURRENCY_DEFAULT
    ],
    paymentCurrencies: [],
    quotesLoading: false
});
const $5346ef8dd2886184$export$8cdcd0d64858bea7 = {
    state: $5346ef8dd2886184$var$state,
    subscribe (callback) {
        return (0, $46gat.subscribe)($5346ef8dd2886184$var$state, ()=>callback($5346ef8dd2886184$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($5346ef8dd2886184$var$state, key, callback);
    },
    setSelectedProvider (provider) {
        $5346ef8dd2886184$var$state.selectedProvider = provider;
    },
    setPurchaseCurrency (currency) {
        $5346ef8dd2886184$var$state.purchaseCurrency = currency;
    },
    setPaymentCurrency (currency) {
        $5346ef8dd2886184$var$state.paymentCurrency = currency;
    },
    setPurchaseAmount (amount) {
        this.state.purchaseAmount = amount;
    },
    setPaymentAmount (amount) {
        this.state.paymentAmount = amount;
    },
    async getAvailableCurrencies () {
        const options = await (0, $5PCU5.BlockchainApiController).getOnrampOptions();
        $5346ef8dd2886184$var$state.purchaseCurrencies = options.purchaseCurrencies;
        $5346ef8dd2886184$var$state.paymentCurrencies = options.paymentCurrencies;
        $5346ef8dd2886184$var$state.paymentCurrency = options.paymentCurrencies[0] || $5346ef8dd2886184$var$USD_CURRENCY_DEFAULT;
        $5346ef8dd2886184$var$state.purchaseCurrency = options.purchaseCurrencies[0] || $5346ef8dd2886184$var$USDC_CURRENCY_DEFAULT;
        await (0, $aHgTP.ApiController).fetchCurrencyImages(options.paymentCurrencies.map((currency)=>currency.id));
        await (0, $aHgTP.ApiController).fetchTokenImages(options.purchaseCurrencies.map((currency)=>currency.symbol));
    },
    async getQuote () {
        $5346ef8dd2886184$var$state.quotesLoading = true;
        const quote = await (0, $5PCU5.BlockchainApiController).getOnrampQuote({
            purchaseCurrency: $5346ef8dd2886184$var$state.purchaseCurrency,
            paymentCurrency: $5346ef8dd2886184$var$state.paymentCurrency,
            amount: $5346ef8dd2886184$var$state.paymentAmount?.toString() || "0",
            network: $5346ef8dd2886184$var$state.purchaseCurrency?.name
        });
        $5346ef8dd2886184$var$state.quotesLoading = false;
        $5346ef8dd2886184$var$state.purchaseAmount = Number(quote.purchaseAmount.amount);
        return quote;
    }
};

});
parcelRegister("5PCU5", function(module, exports) {

$parcel$export(module.exports, "BlockchainApiController", function () { return $43efe4a125f14d7e$export$9c45fcf03cadbfaa; });

var $23VhR = parcelRequire("23VhR");

var $5pVbp = parcelRequire("5pVbp");

var $cPOJT = parcelRequire("cPOJT");
const $43efe4a125f14d7e$var$DEFAULT_OPTIONS = {
    purchaseCurrencies: [
        {
            id: "2b92315d-eab7-5bef-84fa-089a131333f5",
            name: "USD Coin",
            symbol: "USDC",
            networks: [
                {
                    name: "ethereum-mainnet",
                    display_name: "Ethereum",
                    chain_id: "1",
                    contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
                },
                {
                    name: "polygon-mainnet",
                    display_name: "Polygon",
                    chain_id: "137",
                    contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
                }
            ]
        },
        {
            id: "2b92315d-eab7-5bef-84fa-089a131333f5",
            name: "Ether",
            symbol: "ETH",
            networks: [
                {
                    name: "ethereum-mainnet",
                    display_name: "Ethereum",
                    chain_id: "1",
                    contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
                },
                {
                    name: "polygon-mainnet",
                    display_name: "Polygon",
                    chain_id: "137",
                    contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
                }
            ]
        }
    ],
    paymentCurrencies: [
        {
            id: "USD",
            payment_method_limits: [
                {
                    id: "card",
                    min: "10.00",
                    max: "7500.00"
                },
                {
                    id: "ach_bank_account",
                    min: "10.00",
                    max: "25000.00"
                }
            ]
        },
        {
            id: "EUR",
            payment_method_limits: [
                {
                    id: "card",
                    min: "10.00",
                    max: "7500.00"
                },
                {
                    id: "ach_bank_account",
                    min: "10.00",
                    max: "25000.00"
                }
            ]
        }
    ]
};
const $43efe4a125f14d7e$var$baseUrl = (0, $23VhR.CoreHelperUtil).getBlockchainApiUrl();
const $43efe4a125f14d7e$var$api = new (0, $5pVbp.FetchUtil)({
    baseUrl: $43efe4a125f14d7e$var$baseUrl
});
const $43efe4a125f14d7e$export$9c45fcf03cadbfaa = {
    fetchIdentity ({ caipChainId: caipChainId, address: address }) {
        return $43efe4a125f14d7e$var$api.get({
            path: `/v1/identity/${address}`,
            params: {
                chainId: caipChainId,
                projectId: (0, $cPOJT.OptionsController).state.projectId
            }
        });
    },
    fetchTransactions ({ account: account, projectId: projectId, cursor: cursor, onramp: onramp, signal: signal }) {
        const queryParams = cursor ? {
            cursor: cursor
        } : {};
        return $43efe4a125f14d7e$var$api.get({
            path: `/v1/account/${account}/history?projectId=${projectId}${onramp ? `&onramp=${onramp}` : ""}`,
            params: queryParams,
            signal: signal
        });
    },
    async generateOnRampURL ({ destinationWallets: destinationWallets, partnerUserId: partnerUserId, defaultNetwork: defaultNetwork, purchaseAmount: purchaseAmount, paymentAmount: paymentAmount }) {
        const response = await $43efe4a125f14d7e$var$api.post({
            path: `/v1/generators/onrampurl?projectId=${(0, $cPOJT.OptionsController).state.projectId}`,
            body: {
                destinationWallets: destinationWallets,
                defaultNetwork: defaultNetwork,
                partnerUserId: partnerUserId,
                defaultExperience: "buy",
                presetCryptoAmount: purchaseAmount,
                presetFiatAmount: paymentAmount
            }
        });
        return response.url;
    },
    async getOnrampOptions () {
        try {
            const response = await $43efe4a125f14d7e$var$api.get({
                path: `/v1/onramp/options?projectId=${(0, $cPOJT.OptionsController).state.projectId}`
            });
            return response;
        } catch (e) {
            return $43efe4a125f14d7e$var$DEFAULT_OPTIONS;
        }
    },
    async getOnrampQuote ({ purchaseCurrency: purchaseCurrency, paymentCurrency: paymentCurrency, amount: amount, network: network }) {
        try {
            const response = await $43efe4a125f14d7e$var$api.post({
                path: `/v1/onramp/quote?projectId=${(0, $cPOJT.OptionsController).state.projectId}`,
                body: {
                    purchaseCurrency: purchaseCurrency,
                    paymentCurrency: paymentCurrency,
                    amount: amount,
                    network: network
                }
            });
            return response;
        } catch (e) {
            return {
                coinbaseFee: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                networkFee: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                paymentSubtotal: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                paymentTotal: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                purchaseAmount: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                quoteId: "mocked-quote-id"
            };
        }
    }
};

});


parcelRegister("5n5Ql", function(module, exports) {

$parcel$export(module.exports, "ConnectionController", function () { return $3e93a21b3aa02909$export$303deccbe6e8c782; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");

var $23VhR = parcelRequire("23VhR");

var $6sZsT = parcelRequire("6sZsT");

var $i2H8M = parcelRequire("i2H8M");
const $3e93a21b3aa02909$var$state = (0, $46gat.proxy)({
    wcError: false,
    buffering: false
});
const $3e93a21b3aa02909$export$303deccbe6e8c782 = {
    state: $3e93a21b3aa02909$var$state,
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($3e93a21b3aa02909$var$state, key, callback);
    },
    _getClient () {
        if (!$3e93a21b3aa02909$var$state._client) throw new Error("ConnectionController client not set");
        return $3e93a21b3aa02909$var$state._client;
    },
    setClient (client) {
        $3e93a21b3aa02909$var$state._client = (0, $46gat.ref)(client);
    },
    connectWalletConnect () {
        $3e93a21b3aa02909$var$state.wcPromise = this._getClient().connectWalletConnect((uri)=>{
            $3e93a21b3aa02909$var$state.wcUri = uri;
            $3e93a21b3aa02909$var$state.wcPairingExpiry = (0, $23VhR.CoreHelperUtil).getPairingExpiry();
        });
        (0, $6sZsT.StorageUtil).setConnectedConnector("WALLET_CONNECT");
    },
    async connectExternal (options) {
        await this._getClient().connectExternal?.(options);
        (0, $6sZsT.StorageUtil).setConnectedConnector(options.type);
    },
    async signMessage (message) {
        return this._getClient().signMessage(message);
    },
    checkInstalled (ids) {
        return this._getClient().checkInstalled?.(ids);
    },
    resetWcConnection () {
        $3e93a21b3aa02909$var$state.wcUri = undefined;
        $3e93a21b3aa02909$var$state.wcPairingExpiry = undefined;
        $3e93a21b3aa02909$var$state.wcPromise = undefined;
        $3e93a21b3aa02909$var$state.wcLinking = undefined;
        $3e93a21b3aa02909$var$state.recentWallet = undefined;
        (0, $i2H8M.TransactionsController).resetTransactions();
        (0, $6sZsT.StorageUtil).deleteWalletConnectDeepLink();
    },
    setWcLinking (wcLinking) {
        $3e93a21b3aa02909$var$state.wcLinking = wcLinking;
    },
    setWcError (wcError) {
        $3e93a21b3aa02909$var$state.wcError = wcError;
        $3e93a21b3aa02909$var$state.buffering = false;
    },
    setRecentWallet (wallet) {
        $3e93a21b3aa02909$var$state.recentWallet = wallet;
    },
    setBuffering (buffering) {
        $3e93a21b3aa02909$var$state.buffering = buffering;
    },
    async disconnect () {
        await this._getClient().disconnect();
        this.resetWcConnection();
    }
};

});
parcelRegister("i2H8M", function(module, exports) {

$parcel$export(module.exports, "TransactionsController", function () { return $d229e0b635ffbe6e$export$da1e018e28e23fb0; });

var $46gat = parcelRequire("46gat");

var $cPOJT = parcelRequire("cPOJT");

var $dUlgM = parcelRequire("dUlgM");

var $dXr1O = parcelRequire("dXr1O");

var $5PCU5 = parcelRequire("5PCU5");
const $d229e0b635ffbe6e$var$state = (0, $46gat.proxy)({
    transactions: [],
    coinbaseTransactions: {},
    transactionsByYear: {},
    loading: false,
    empty: false,
    next: undefined
});
const $d229e0b635ffbe6e$export$da1e018e28e23fb0 = {
    state: $d229e0b635ffbe6e$var$state,
    subscribe (callback) {
        return (0, $46gat.subscribe)($d229e0b635ffbe6e$var$state, ()=>callback($d229e0b635ffbe6e$var$state));
    },
    async fetchTransactions (accountAddress, onramp) {
        const { projectId: projectId } = (0, $cPOJT.OptionsController).state;
        if (!projectId || !accountAddress) throw new Error("Transactions can't be fetched without a projectId and an accountAddress");
        $d229e0b635ffbe6e$var$state.loading = true;
        try {
            const response = await (0, $5PCU5.BlockchainApiController).fetchTransactions({
                account: accountAddress,
                projectId: projectId,
                cursor: $d229e0b635ffbe6e$var$state.next,
                onramp: onramp
            });
            const nonSpamTransactions = this.filterSpamTransactions(response.data);
            const filteredTransactions = [
                ...$d229e0b635ffbe6e$var$state.transactions,
                ...nonSpamTransactions
            ];
            $d229e0b635ffbe6e$var$state.loading = false;
            if (onramp === "coinbase") $d229e0b635ffbe6e$var$state.coinbaseTransactions = this.groupTransactionsByYearAndMonth($d229e0b635ffbe6e$var$state.coinbaseTransactions, response.data);
            else {
                $d229e0b635ffbe6e$var$state.transactions = filteredTransactions;
                $d229e0b635ffbe6e$var$state.transactionsByYear = this.groupTransactionsByYearAndMonth($d229e0b635ffbe6e$var$state.transactionsByYear, nonSpamTransactions);
            }
            $d229e0b635ffbe6e$var$state.empty = filteredTransactions.length === 0;
            $d229e0b635ffbe6e$var$state.next = response.next ? response.next : undefined;
        } catch (error) {
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "ERROR_FETCH_TRANSACTIONS",
                properties: {
                    address: accountAddress,
                    projectId: projectId,
                    cursor: $d229e0b635ffbe6e$var$state.next
                }
            });
            (0, $dXr1O.SnackController).showError("Failed to fetch transactions");
            $d229e0b635ffbe6e$var$state.loading = false;
            $d229e0b635ffbe6e$var$state.empty = true;
        }
    },
    groupTransactionsByYearAndMonth (transactionsMap = {}, transactions = []) {
        const grouped = transactionsMap;
        transactions.forEach((transaction)=>{
            const year = new Date(transaction.metadata.minedAt).getFullYear();
            const month = new Date(transaction.metadata.minedAt).getMonth();
            const yearTransactions = grouped[year] ?? {};
            const monthTransactions = yearTransactions[month] ?? [];
            const newMonthTransactions = monthTransactions.filter((tx)=>tx.id !== transaction.id);
            grouped[year] = {
                ...yearTransactions,
                [month]: [
                    ...newMonthTransactions,
                    transaction
                ].sort((a, b)=>new Date(b.metadata.minedAt).getTime() - new Date(a.metadata.minedAt).getTime())
            };
        });
        return grouped;
    },
    filterSpamTransactions (transactions) {
        return transactions.filter((transaction)=>{
            const isAllSpam = transaction.transfers.every((transfer)=>transfer.nft_info?.flags.is_spam === true);
            return !isAllSpam;
        });
    },
    resetTransactions () {
        $d229e0b635ffbe6e$var$state.transactions = [];
        $d229e0b635ffbe6e$var$state.transactionsByYear = {};
        $d229e0b635ffbe6e$var$state.loading = false;
        $d229e0b635ffbe6e$var$state.empty = false;
        $d229e0b635ffbe6e$var$state.next = undefined;
    }
};

});
parcelRegister("dXr1O", function(module, exports) {

$parcel$export(module.exports, "SnackController", function () { return $a295c04d1bfe5870$export$506cae4b4f746de7; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");

var $23VhR = parcelRequire("23VhR");
const $a295c04d1bfe5870$var$state = (0, $46gat.proxy)({
    message: "",
    variant: "success",
    open: false
});
const $a295c04d1bfe5870$export$506cae4b4f746de7 = {
    state: $a295c04d1bfe5870$var$state,
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($a295c04d1bfe5870$var$state, key, callback);
    },
    showSuccess (message) {
        $a295c04d1bfe5870$var$state.message = message;
        $a295c04d1bfe5870$var$state.variant = "success";
        $a295c04d1bfe5870$var$state.open = true;
    },
    showError (message) {
        const errorMessage = (0, $23VhR.CoreHelperUtil).parseError(message);
        $a295c04d1bfe5870$var$state.message = errorMessage;
        $a295c04d1bfe5870$var$state.variant = "error";
        $a295c04d1bfe5870$var$state.open = true;
    },
    hide () {
        $a295c04d1bfe5870$var$state.open = false;
    }
};

});



parcelRegister("jIUUu", function(module, exports) {

$parcel$export(module.exports, "SIWEController", function () { return $e5be458a3aeb26bf$export$3ff5b538099e7763; });

var $8skqG = parcelRequire("8skqG");

var $46gat = parcelRequire("46gat");
const $e5be458a3aeb26bf$var$state = (0, $46gat.proxy)({
    status: "uninitialized",
    isSiweEnabled: false
});
const $e5be458a3aeb26bf$export$3ff5b538099e7763 = {
    state: $e5be458a3aeb26bf$var$state,
    subscribeKey (key, callback) {
        return (0, $8skqG.subscribeKey)($e5be458a3aeb26bf$var$state, key, callback);
    },
    subscribe (callback) {
        return (0, $46gat.subscribe)($e5be458a3aeb26bf$var$state, ()=>callback($e5be458a3aeb26bf$var$state));
    },
    _getClient () {
        if (!$e5be458a3aeb26bf$var$state._client) throw new Error("SIWEController client not set");
        return $e5be458a3aeb26bf$var$state._client;
    },
    async getNonce () {
        const client = this._getClient();
        const nonce = await client.getNonce();
        this.setNonce(nonce);
        return nonce;
    },
    async getSession () {
        const client = this._getClient();
        const session = await client.getSession();
        if (session) {
            this.setSession(session);
            this.setStatus("success");
        }
        return session;
    },
    createMessage (args) {
        const client = this._getClient();
        const message = client.createMessage(args);
        this.setMessage(message);
        return message;
    },
    async verifyMessage (args) {
        const client = this._getClient();
        const isValid = await client.verifyMessage(args);
        return isValid;
    },
    async signIn () {
        const client = this._getClient();
        const session = await client.signIn();
        return session;
    },
    async signOut () {
        const client = this._getClient();
        await client.signOut();
        this.setStatus("ready");
        client.onSignOut?.();
    },
    onSignIn (args) {
        const client = this._getClient();
        client.onSignIn?.(args);
    },
    onSignOut () {
        const client = this._getClient();
        client.onSignOut?.();
    },
    setSIWEClient (client) {
        $e5be458a3aeb26bf$var$state._client = (0, $46gat.ref)(client);
        $e5be458a3aeb26bf$var$state.status = "ready";
        $e5be458a3aeb26bf$var$state.isSiweEnabled = client.options.enabled;
    },
    setNonce (nonce) {
        $e5be458a3aeb26bf$var$state.nonce = nonce;
    },
    setStatus (status) {
        $e5be458a3aeb26bf$var$state.status = status;
    },
    setMessage (message) {
        $e5be458a3aeb26bf$var$state.message = message;
    },
    setSession (session) {
        $e5be458a3aeb26bf$var$state.session = session;
    }
};

});

parcelRegister("3jnn6", function(module, exports) {

$parcel$export(module.exports, "AssetUtil", function () { return $26954693c702dab5$export$2a2d471f51b1e9cb; });

var $b2pRm = parcelRequire("b2pRm");
const $26954693c702dab5$export$2a2d471f51b1e9cb = {
    getWalletImage (wallet) {
        if (wallet?.image_url) return wallet?.image_url;
        if (wallet?.image_id) return (0, $b2pRm.AssetController).state.walletImages[wallet.image_id];
        return undefined;
    },
    getNetworkImage (network) {
        if (network?.imageUrl) return network?.imageUrl;
        if (network?.imageId) return (0, $b2pRm.AssetController).state.networkImages[network.imageId];
        return undefined;
    },
    getConnectorImage (connector) {
        if (connector?.imageUrl) return connector.imageUrl;
        if (connector?.imageId) return (0, $b2pRm.AssetController).state.connectorImages[connector.imageId];
        return undefined;
    }
};

});

parcelRegister("1hoT1", function(module, exports) {

$parcel$export(module.exports, "RouterUtil", function () { return $0eeaaee8be1b00d2$export$12c6341a287a74e0; });

var $3OaCj = parcelRequire("3OaCj");

var $nBm8O = parcelRequire("nBm8O");
const $0eeaaee8be1b00d2$export$12c6341a287a74e0 = {
    goBackOrCloseModal () {
        if ((0, $3OaCj.RouterController).state.history.length > 1) (0, $3OaCj.RouterController).goBack();
        else (0, $nBm8O.ModalController).close();
    },
    navigateAfterNetworkSwitch () {
        const { history: history } = (0, $3OaCj.RouterController).state;
        const networkSelectIndex = history.findIndex((name)=>name === "Networks");
        if (networkSelectIndex >= 1) (0, $3OaCj.RouterController).goBackToIndex(networkSelectIndex - 1);
        else (0, $nBm8O.ModalController).close();
    }
};

});

parcelRegister("9Ezhj", function(module, exports) {

$parcel$export(module.exports, "CryptoUtil", function () { return $707336fdf968ba77$export$a0deb7908713d08d; });

var $jOVnk = parcelRequire("jOVnk");

var $2Fz4m = parcelRequire("2Fz4m");

var $jtAZT = parcelRequire("jtAZT");
var $707336fdf968ba77$require$Buffer = $jtAZT.Buffer;
const $707336fdf968ba77$var$STORE_KEY_PRIVATE_KEY = "STORE_KEY_PRIVATE_KEY";
const $707336fdf968ba77$var$STORE_KEY_PUBLIC_JWK = "STORE_KEY_PUBLIC_JWK";
const $707336fdf968ba77$var$ALGO_NAME = "ECDSA";
const $707336fdf968ba77$var$ALGO_CURVE = "P-256";
const $707336fdf968ba77$var$EC_GEN_PARAMS = {
    name: $707336fdf968ba77$var$ALGO_NAME,
    namedCurve: $707336fdf968ba77$var$ALGO_CURVE
};
const $707336fdf968ba77$export$a0deb7908713d08d = {
    async getIndexedDB () {
        return (0, $2Fz4m.openDB)("web3modal-indexedDB", 1, {
            upgrade (database) {
                database.createObjectStore("keypairs");
            }
        });
    },
    async generateMagicKP () {
        const db = await this.getIndexedDB();
        const { subtle: subtle } = window.crypto;
        const kp = await subtle.generateKey($707336fdf968ba77$var$EC_GEN_PARAMS, false, [
            "sign"
        ]);
        const jwkPublicKey = await subtle.exportKey("jwk", kp.publicKey);
        await db.put("keypairs", kp.privateKey, $707336fdf968ba77$var$STORE_KEY_PRIVATE_KEY);
        await db.put("keypairs", jwkPublicKey, $707336fdf968ba77$var$STORE_KEY_PUBLIC_JWK);
    },
    async getOrCreateMagicPublicKey () {
        try {
            const db = await this.getIndexedDB();
            const storedKey = await db.get("keypairs", $707336fdf968ba77$var$STORE_KEY_PUBLIC_JWK);
            if (storedKey) return storedKey;
            await this.generateMagicKP();
            return db.get("keypairs", $707336fdf968ba77$var$STORE_KEY_PUBLIC_JWK);
        } catch (e) {
            console.error("getPublicKey error", e);
            return null;
        }
    },
    async createJwt () {
        const publicJwk = await this.getOrCreateMagicPublicKey();
        if (!publicJwk) {
            console.info("unable to create public key or webcrypto is unsupported");
            return undefined;
        }
        const { subtle: subtle } = window.crypto;
        const db = await this.getIndexedDB();
        const privateJwk = await db.get("keypairs", $707336fdf968ba77$var$STORE_KEY_PRIVATE_KEY);
        if (!privateJwk || !subtle) {
            console.info("unable to find private key or webcrypto unsupported");
            return undefined;
        }
        const claims = {
            iat: Math.floor(new Date().getTime() / 1000),
            jti: (0, $jOVnk.nanoid)()
        };
        const headers = {
            typ: "dpop+jwt",
            alg: "ES256",
            jwk: publicJwk
        };
        const jws = {
            protected: this.strToUrlBase64(JSON.stringify(headers)),
            claims: this.strToUrlBase64(JSON.stringify(claims))
        };
        const data = this.strToUint8(`${jws.protected}.${jws.claims}`);
        const sigType = {
            name: $707336fdf968ba77$var$ALGO_NAME,
            hash: {
                name: "SHA-256"
            }
        };
        const sig = this.uint8ToUrlBase64(new Uint8Array(await subtle.sign(sigType, privateJwk, data)));
        return `${jws.protected}.${jws.claims}.${sig}`;
    },
    strToUrlBase64 (str) {
        return this.binToUrlBase64(this.utf8ToBinaryString(str));
    },
    strToUint8 (str) {
        return new TextEncoder().encode(str);
    },
    binToUrlBase64 (bin) {
        return $707336fdf968ba77$require$Buffer.from(bin, "latin1").toString("base64").replace(/\+/gu, "-").replace(/\//gu, "_").replace(/[=]+/gu, "");
    },
    utf8ToBinaryString (str) {
        const escstr = encodeURIComponent(str);
        return escstr.replace(/%(?:[0-9A-F]{2})/gu, (_, p1)=>String.fromCharCode(parseInt(p1, 16)));
    },
    uint8ToUrlBase64 (uint8) {
        let bin = "";
        uint8.forEach((code)=>{
            bin += String.fromCharCode(code);
        });
        return this.binToUrlBase64(bin);
    }
};

});
parcelRegister("jOVnk", function(module, exports) {

$parcel$export(module.exports, "nanoid", function () { return $e6df315b2b8d9c5b$export$ac4959f4f1338dfc; });

var $2GBXf = parcelRequire("2GBXf");
let $e6df315b2b8d9c5b$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $e6df315b2b8d9c5b$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $e6df315b2b8d9c5b$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$e6df315b2b8d9c5b$export$a5cee9e955a615e5(alphabet, size, $e6df315b2b8d9c5b$export$4385e60b38654f68);
let $e6df315b2b8d9c5b$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let bytes = crypto.getRandomValues(new Uint8Array(size));
    while(size--)id += (0, $2GBXf.urlAlphabet)[bytes[size] & 63];
    return id;
};

});
parcelRegister("2GBXf", function(module, exports) {

$parcel$export(module.exports, "urlAlphabet", function () { return $1f4cf1ffdf15b60b$export$2b646eea95309f00; });
const $1f4cf1ffdf15b60b$export$2b646eea95309f00 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

});


parcelRegister("2Fz4m", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $1f1a9d1fc8f9fcc5$export$ca0ed41b1a2af7e; });
const $1f1a9d1fc8f9fcc5$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $1f1a9d1fc8f9fcc5$var$idbProxyableTypes;
let $1f1a9d1fc8f9fcc5$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $1f1a9d1fc8f9fcc5$var$getIdbProxyableTypes() {
    return $1f1a9d1fc8f9fcc5$var$idbProxyableTypes || ($1f1a9d1fc8f9fcc5$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $1f1a9d1fc8f9fcc5$var$getCursorAdvanceMethods() {
    return $1f1a9d1fc8f9fcc5$var$cursorAdvanceMethods || ($1f1a9d1fc8f9fcc5$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $1f1a9d1fc8f9fcc5$var$transactionDoneMap = new WeakMap();
const $1f1a9d1fc8f9fcc5$var$transformCache = new WeakMap();
const $1f1a9d1fc8f9fcc5$var$reverseTransformCache = new WeakMap();
function $1f1a9d1fc8f9fcc5$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($1f1a9d1fc8f9fcc5$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $1f1a9d1fc8f9fcc5$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $1f1a9d1fc8f9fcc5$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($1f1a9d1fc8f9fcc5$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $1f1a9d1fc8f9fcc5$var$transactionDoneMap.set(tx, done);
}
let $1f1a9d1fc8f9fcc5$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $1f1a9d1fc8f9fcc5$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $1f1a9d1fc8f9fcc5$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $1f1a9d1fc8f9fcc5$var$replaceTraps(callback) {
    $1f1a9d1fc8f9fcc5$var$idbProxyTraps = callback($1f1a9d1fc8f9fcc5$var$idbProxyTraps);
}
function $1f1a9d1fc8f9fcc5$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($1f1a9d1fc8f9fcc5$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($1f1a9d1fc8f9fcc5$export$debb760848ca95a(this), args);
        return $1f1a9d1fc8f9fcc5$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $1f1a9d1fc8f9fcc5$export$4997ffc0176396a6(func.apply($1f1a9d1fc8f9fcc5$export$debb760848ca95a(this), args));
    };
}
function $1f1a9d1fc8f9fcc5$var$transformCachableValue(value) {
    if (typeof value === "function") return $1f1a9d1fc8f9fcc5$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $1f1a9d1fc8f9fcc5$var$cacheDonePromiseForTransaction(value);
    if ($1f1a9d1fc8f9fcc5$var$instanceOfAny(value, $1f1a9d1fc8f9fcc5$var$getIdbProxyableTypes())) return new Proxy(value, $1f1a9d1fc8f9fcc5$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $1f1a9d1fc8f9fcc5$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $1f1a9d1fc8f9fcc5$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($1f1a9d1fc8f9fcc5$var$transformCache.has(value)) return $1f1a9d1fc8f9fcc5$var$transformCache.get(value);
    const newValue = $1f1a9d1fc8f9fcc5$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $1f1a9d1fc8f9fcc5$var$transformCache.set(value, newValue);
        $1f1a9d1fc8f9fcc5$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $1f1a9d1fc8f9fcc5$export$debb760848ca95a = (value)=>$1f1a9d1fc8f9fcc5$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $1f1a9d1fc8f9fcc5$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $1f1a9d1fc8f9fcc5$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade($1f1a9d1fc8f9fcc5$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $1f1a9d1fc8f9fcc5$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $1f1a9d1fc8f9fcc5$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $1f1a9d1fc8f9fcc5$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $1f1a9d1fc8f9fcc5$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $1f1a9d1fc8f9fcc5$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $1f1a9d1fc8f9fcc5$var$cachedMethods = new Map();
function $1f1a9d1fc8f9fcc5$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($1f1a9d1fc8f9fcc5$var$cachedMethods.get(prop)) return $1f1a9d1fc8f9fcc5$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $1f1a9d1fc8f9fcc5$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $1f1a9d1fc8f9fcc5$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $1f1a9d1fc8f9fcc5$var$cachedMethods.set(prop, method);
    return method;
}
$1f1a9d1fc8f9fcc5$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$1f1a9d1fc8f9fcc5$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$1f1a9d1fc8f9fcc5$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $1f1a9d1fc8f9fcc5$var$advanceMethodProps = [
    "continue",
    "continuePrimaryKey",
    "advance"
];
const $1f1a9d1fc8f9fcc5$var$methodMap = {};
const $1f1a9d1fc8f9fcc5$var$advanceResults = new WeakMap();
const $1f1a9d1fc8f9fcc5$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $1f1a9d1fc8f9fcc5$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$1f1a9d1fc8f9fcc5$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $1f1a9d1fc8f9fcc5$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $1f1a9d1fc8f9fcc5$var$methodMap[prop] = function(...args) {
            $1f1a9d1fc8f9fcc5$var$advanceResults.set(this, $1f1a9d1fc8f9fcc5$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $1f1a9d1fc8f9fcc5$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $1f1a9d1fc8f9fcc5$var$cursorIteratorTraps);
    $1f1a9d1fc8f9fcc5$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $1f1a9d1fc8f9fcc5$var$reverseTransformCache.set(proxiedCursor, $1f1a9d1fc8f9fcc5$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($1f1a9d1fc8f9fcc5$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $1f1a9d1fc8f9fcc5$var$advanceResults.delete(proxiedCursor);
    }
}
function $1f1a9d1fc8f9fcc5$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $1f1a9d1fc8f9fcc5$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === "iterate" && $1f1a9d1fc8f9fcc5$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$1f1a9d1fc8f9fcc5$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($1f1a9d1fc8f9fcc5$var$isIteratorProp(target, prop)) return $1f1a9d1fc8f9fcc5$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $1f1a9d1fc8f9fcc5$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));

});




parcelRegister("3Cynl", function(module, exports) {

$parcel$export(module.exports, "WuiOnRampProviderItem", function () { return $2a2f95f35812050b$export$164d942f06e4d92f; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("3aODI");
var $3jnn6 = parcelRequire("3jnn6");
var $8A6Jz = parcelRequire("8A6Jz");
parcelRequire("iVPOS");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $8SvDL = parcelRequire("8SvDL");
parcelRequire("aVsFR");
var $lC4jx = parcelRequire("lC4jx");
var $2a2f95f35812050b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2a2f95f35812050b$export$164d942f06e4d92f = class WuiOnRampProviderItem extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.color = "inherit";
        this.label = "";
        this.feeRange = "";
        this.loading = false;
        this.onClick = null;
    }
    render() {
        return (0, $B77rE.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-visual name=${(0, $lC4jx.ifDefined)(this.name)} class="provider-image"></wui-visual>
        <wui-flex flexDirection="column" gap="4xs">
          <wui-text variant="paragraph-500" color="fg-100">${this.label}</wui-text>
          <wui-flex alignItems="center" justifyContent="flex-start" gap="l">
            <wui-text variant="tiny-500" color="fg-100">
              <wui-text variant="tiny-400" color="fg-200">Fees</wui-text>
              ${this.feeRange}
            </wui-text>
            <wui-flex gap="xxs">
              <wui-icon name="bank" size="xs" color="fg-150"></wui-icon>
              <wui-icon name="card" size="xs" color="fg-150"></wui-icon>
            </wui-flex>
            ${this.networksTemplate()}
          </wui-flex>
        </wui-flex>
        ${this.loading ? (0, $B77rE.html)`<wui-loading-spinner color="fg-200" size="md"></wui-loading-spinner>` : (0, $B77rE.html)`<wui-icon name="chevronRight" color="fg-200" size="sm"></wui-icon>`}
      </button>
    `;
    }
    networksTemplate() {
        const networks = (0, $8A6Jz.NetworkController).getRequestedCaipNetworks();
        const slicedNetworks = networks?.filter((network)=>network?.imageId)?.slice(0, 5);
        return (0, $B77rE.html)`
      <wui-flex class="networks">
        ${slicedNetworks?.map((network)=>(0, $B77rE.html)`
            <wui-flex class="network-icon">
              <wui-image src=${(0, $lC4jx.ifDefined)((0, $3jnn6.AssetUtil).getNetworkImage(network))}></wui-image>
            </wui-flex>
          `)}
      </wui-flex>
    `;
    }
};
$2a2f95f35812050b$export$164d942f06e4d92f.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $cRWGJ.elementStyles),
    (0, $8SvDL.default)
];
$2a2f95f35812050b$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $2a2f95f35812050b$export$164d942f06e4d92f.prototype, "disabled", void 0);
$2a2f95f35812050b$var$__decorate([
    (0, $cG9dN.property)()
], $2a2f95f35812050b$export$164d942f06e4d92f.prototype, "color", void 0);
$2a2f95f35812050b$var$__decorate([
    (0, $cG9dN.property)()
], $2a2f95f35812050b$export$164d942f06e4d92f.prototype, "name", void 0);
$2a2f95f35812050b$var$__decorate([
    (0, $cG9dN.property)()
], $2a2f95f35812050b$export$164d942f06e4d92f.prototype, "label", void 0);
$2a2f95f35812050b$var$__decorate([
    (0, $cG9dN.property)()
], $2a2f95f35812050b$export$164d942f06e4d92f.prototype, "feeRange", void 0);
$2a2f95f35812050b$var$__decorate([
    (0, $cG9dN.property)({
        type: Boolean
    })
], $2a2f95f35812050b$export$164d942f06e4d92f.prototype, "loading", void 0);
$2a2f95f35812050b$var$__decorate([
    (0, $cG9dN.property)()
], $2a2f95f35812050b$export$164d942f06e4d92f.prototype, "onClick", void 0);
$2a2f95f35812050b$export$164d942f06e4d92f = $2a2f95f35812050b$var$__decorate([
    (0, $3SCaV.customElement)("wui-onramp-provider-item")
], $2a2f95f35812050b$export$164d942f06e4d92f);

});
parcelRegister("8SvDL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $676be9042a93b30f$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $676be9042a93b30f$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  button {
    padding: var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xs);
    background-color: var(--wui-gray-glass-002);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--wui-spacing-s);
    transition: background-color 0.2s linear;
  }

  button:hover {
    background-color: var(--wui-gray-glass-005);
  }

  .provider-image {
    width: var(--wui-spacing-3xl);
    min-width: var(--wui-spacing-3xl);
    height: var(--wui-spacing-3xl);
    border-radius: calc(var(--wui-border-radius-xs) - calc(var(--wui-spacing-s) / 2));
    position: relative;
    overflow: hidden;
  }

  .provider-image::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    border-radius: calc(var(--wui-border-radius-xs) - calc(var(--wui-spacing-s) / 2));
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
  }

  .network-icon {
    width: var(--wui-spacing-m);
    height: var(--wui-spacing-m);
    border-radius: calc(var(--wui-spacing-m) / 2);
    overflow: hidden;
    box-shadow:
      0 0 0 3px var(--wui-gray-glass-002),
      0 0 0 3px var(--wui-color-modal-bg);
    transition: box-shadow 0.2s linear;
  }

  button:hover .network-icon {
    box-shadow:
      0 0 0 3px var(--wui-gray-glass-005),
      0 0 0 3px var(--wui-color-modal-bg);
  }
`;

});


parcelRegister("gga5t", function(module, exports) {

$parcel$export(module.exports, "WuiGrid", function () { return $bd65f7170356cfdb$export$834debd63a0ca469; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");

var $cRWGJ = parcelRequire("cRWGJ");

var $fRkfl = parcelRequire("fRkfl");

var $3SCaV = parcelRequire("3SCaV");

var $1LU7x = parcelRequire("1LU7x");
var $bd65f7170356cfdb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bd65f7170356cfdb$export$834debd63a0ca469 = class WuiGrid extends (0, $75o4B.LitElement) {
    render() {
        this.style.cssText = `
      grid-template-rows: ${this.gridTemplateRows};
      grid-template-columns: ${this.gridTemplateColumns};
      justify-items: ${this.justifyItems};
      align-items: ${this.alignItems};
      justify-content: ${this.justifyContent};
      align-content: ${this.alignContent};
      column-gap: ${this.columnGap && `var(--wui-spacing-${this.columnGap})`};
      row-gap: ${this.rowGap && `var(--wui-spacing-${this.rowGap})`};
      gap: ${this.gap && `var(--wui-spacing-${this.gap})`};
      padding-top: ${this.padding && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.padding, 0)};
      padding-right: ${this.padding && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.padding, 1)};
      padding-bottom: ${this.padding && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.padding, 2)};
      padding-left: ${this.padding && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.padding, 3)};
      margin-top: ${this.margin && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.margin, 0)};
      margin-right: ${this.margin && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.margin, 1)};
      margin-bottom: ${this.margin && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.margin, 2)};
      margin-left: ${this.margin && (0, $fRkfl.UiHelperUtil).getSpacingStyles(this.margin, 3)};
    `;
        return (0, $B77rE.html)`<slot></slot>`;
    }
};
$bd65f7170356cfdb$export$834debd63a0ca469.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $1LU7x.default)
];
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "gridTemplateRows", void 0);
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "gridTemplateColumns", void 0);
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "justifyItems", void 0);
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "alignItems", void 0);
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "justifyContent", void 0);
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "alignContent", void 0);
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "columnGap", void 0);
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "rowGap", void 0);
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "gap", void 0);
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "padding", void 0);
$bd65f7170356cfdb$var$__decorate([
    (0, $cG9dN.property)()
], $bd65f7170356cfdb$export$834debd63a0ca469.prototype, "margin", void 0);
$bd65f7170356cfdb$export$834debd63a0ca469 = $bd65f7170356cfdb$var$__decorate([
    (0, $3SCaV.customElement)("wui-grid")
], $bd65f7170356cfdb$export$834debd63a0ca469);

});
parcelRegister("1LU7x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14a5b69a715eb280$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $14a5b69a715eb280$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    display: grid;
    width: inherit;
    height: inherit;
  }
`;

});


parcelRegister("iDl5h", function(module, exports) {

$parcel$export(module.exports, "WuiSeparator", function () { return $d90c395d549d94f8$export$987a8443516753c9; });
parcelRequire("fU32g");
var $B77rE = parcelRequire("B77rE");
var $75o4B = parcelRequire("75o4B");
parcelRequire("39dvr");
var $cG9dN = parcelRequire("cG9dN");
parcelRequire("7xM3j");

var $cRWGJ = parcelRequire("cRWGJ");

var $3SCaV = parcelRequire("3SCaV");

var $58dKk = parcelRequire("58dKk");
var $d90c395d549d94f8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d90c395d549d94f8$export$987a8443516753c9 = class WuiSeparator extends (0, $75o4B.LitElement) {
    constructor(){
        super(...arguments);
        this.text = "";
    }
    render() {
        return (0, $B77rE.html)`${this.template()}`;
    }
    template() {
        if (this.text) return (0, $B77rE.html)`<wui-text variant="small-500" color="fg-200">${this.text}</wui-text>`;
        return null;
    }
};
$d90c395d549d94f8$export$987a8443516753c9.styles = [
    (0, $cRWGJ.resetStyles),
    (0, $58dKk.default)
];
$d90c395d549d94f8$var$__decorate([
    (0, $cG9dN.property)()
], $d90c395d549d94f8$export$987a8443516753c9.prototype, "text", void 0);
$d90c395d549d94f8$export$987a8443516753c9 = $d90c395d549d94f8$var$__decorate([
    (0, $3SCaV.customElement)("wui-separator")
], $d90c395d549d94f8$export$987a8443516753c9);

});
parcelRegister("58dKk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bc85cd48437518c$export$2e2bcd8739ae039; });
parcelRequire("fU32g");
var $dckYz = parcelRequire("dckYz");
var $3bc85cd48437518c$export$2e2bcd8739ae039 = (0, $dckYz.css)`
  :host {
    position: relative;
    display: flex;
    width: 100%;
    height: 1px;
    background-color: var(--wui-gray-glass-005);
    justify-content: center;
    align-items: center;
  }

  :host > wui-text {
    position: absolute;
    padding: 0px 10px;
    background-color: var(--wui-color-modal-bg);
  }
`;

});


parcelRegister("aaIXL", function(module, exports) {

$parcel$export(module.exports, "TransactionUtil", function () { return $767db7432e55525f$export$445ed8d5992cc5e0; });
parcelRequire("8WlrT");
var $8ntrV = parcelRequire("8ntrV");

var $fRkfl = parcelRequire("fRkfl");
const $767db7432e55525f$var$FLOAT_FIXED_VALUE = 3;
const $767db7432e55525f$var$plusTypes = [
    "receive",
    "deposit",
    "borrow",
    "claim"
];
const $767db7432e55525f$var$minusTypes = [
    "withdraw",
    "repay",
    "burn"
];
const $767db7432e55525f$export$445ed8d5992cc5e0 = {
    getMonthName (monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber);
        return date.toLocaleString("en-US", {
            month: "long"
        });
    },
    getTransactionGroupTitle (year, month) {
        const currentYear = (0, $8ntrV.DateUtil).getYear();
        const monthName = this.getMonthName(month);
        const isCurrentYear = year === currentYear;
        const groupTitle = isCurrentYear ? monthName : `${monthName} ${year}`;
        return groupTitle;
    },
    getTransactionImages (transfers) {
        const [transfer, secondTransfer] = transfers;
        const isAllNFT = Boolean(transfer) && transfers?.every((item)=>Boolean(item.nft_info));
        const haveMultipleTransfers = transfers?.length > 1;
        const haveTwoTransfers = transfers?.length === 2;
        if (haveTwoTransfers && !isAllNFT) return [
            this.getTransactionImage(transfer),
            this.getTransactionImage(secondTransfer)
        ];
        if (haveMultipleTransfers) return transfers.map((item)=>this.getTransactionImage(item));
        return [
            this.getTransactionImage(transfer)
        ];
    },
    getTransactionImage (transfer) {
        return {
            type: $767db7432e55525f$export$445ed8d5992cc5e0.getTransactionTransferTokenType(transfer),
            url: $767db7432e55525f$export$445ed8d5992cc5e0.getTransactionImageURL(transfer)
        };
    },
    getTransactionImageURL (transfer) {
        let imageURL = undefined;
        const isNFT = Boolean(transfer?.nft_info);
        const isFungible = Boolean(transfer?.fungible_info);
        if (transfer && isNFT) imageURL = transfer?.nft_info?.content?.preview?.url;
        else if (transfer && isFungible) imageURL = transfer?.fungible_info?.icon?.url;
        return imageURL;
    },
    getTransactionTransferTokenType (transfer) {
        if (transfer?.fungible_info) return "FUNGIBLE";
        else if (transfer?.nft_info) return "NFT";
        return undefined;
    },
    getTransactionDescriptions (transaction) {
        const type = transaction?.metadata?.operationType;
        const transfers = transaction?.transfers;
        const haveTransfer = transaction?.transfers?.length > 0;
        const haveMultipleTransfers = transaction?.transfers?.length > 1;
        const isFungible = haveTransfer && transfers?.every((transfer)=>Boolean(transfer?.fungible_info));
        const [firstTransfer, secondTransfer] = transfers;
        let firstDescription = this.getTransferDescription(firstTransfer);
        let secondDescription = this.getTransferDescription(secondTransfer);
        if (!haveTransfer) {
            const isSendOrReceive = type === "send" || type === "receive";
            if (isSendOrReceive && isFungible) {
                firstDescription = (0, $fRkfl.UiHelperUtil).getTruncateString({
                    string: transaction?.metadata.sentFrom,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                secondDescription = (0, $fRkfl.UiHelperUtil).getTruncateString({
                    string: transaction?.metadata.sentTo,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                return [
                    firstDescription,
                    secondDescription
                ];
            }
            return [
                transaction.metadata.status
            ];
        }
        if (haveMultipleTransfers) return transfers.map((item)=>this.getTransferDescription(item));
        let prefix = "";
        if ($767db7432e55525f$var$plusTypes.includes(type)) prefix = "+";
        else if ($767db7432e55525f$var$minusTypes.includes(type)) prefix = "-";
        firstDescription = prefix.concat(firstDescription);
        return [
            firstDescription
        ];
    },
    getTransferDescription (transfer) {
        let description = "";
        if (!transfer) return description;
        if (transfer?.nft_info) description = transfer?.nft_info?.name || "-";
        else if (transfer?.fungible_info) description = this.getFungibleTransferDescription(transfer) || "-";
        return description;
    },
    getFungibleTransferDescription (transfer) {
        if (!transfer) return null;
        const quantity = this.getQuantityFixedValue(transfer?.quantity.numeric);
        const description = [
            quantity,
            transfer?.fungible_info?.symbol
        ].join(" ").trim();
        return description;
    },
    getQuantityFixedValue (value) {
        if (!value) return null;
        const parsedValue = parseFloat(value);
        return parsedValue.toFixed($767db7432e55525f$var$FLOAT_FIXED_VALUE);
    }
};

});
parcelRegister("8WlrT", function(module, exports) {

$parcel$export(module.exports, "DateUtil", function () { return (parcelRequire("8ntrV")).DateUtil; });

var $8ntrV = parcelRequire("8ntrV");

});
parcelRegister("8ntrV", function(module, exports) {

$parcel$export(module.exports, "DateUtil", function () { return $619750c57e1fed7f$export$9b575f14aa5e09a1; });

var $NxnF7 = parcelRequire("NxnF7");

var $jxYDn = parcelRequire("jxYDn");

var $7Xq6P = parcelRequire("7Xq6P");
(0, (/*@__PURE__*/$parcel$interopDefault($NxnF7))).extend((0, (/*@__PURE__*/$parcel$interopDefault($7Xq6P))));
(0, (/*@__PURE__*/$parcel$interopDefault($NxnF7))).extend((0, (/*@__PURE__*/$parcel$interopDefault($jxYDn))));
(0, (/*@__PURE__*/$parcel$interopDefault($NxnF7))).updateLocale("en", {
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "%s sec",
        m: "1 min",
        mm: "%d min",
        h: "1 hr",
        hh: "%d hrs",
        d: "1 d",
        dd: "%d d",
        M: "1 mo",
        MM: "%d mo",
        y: "1 yr",
        yy: "%d yr"
    }
});
const $619750c57e1fed7f$export$9b575f14aa5e09a1 = {
    getYear (date = new Date().toISOString()) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($NxnF7)))(date).year();
    },
    getRelativeDateFromNow (date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($NxnF7)))(date).fromNow(true);
    },
    formatDate (date, format = "DD MMM") {
        return (0, (/*@__PURE__*/$parcel$interopDefault($NxnF7)))(date).format(format);
    }
};

});
parcelRegister("NxnF7", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("jxYDn", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return function(e, n, t) {
        t.updateLocale = function(e, n) {
            var o = t.Ls[e];
            if (o) return (n ? Object.keys(n) : []).forEach(function(e) {
                o[e] = n[e];
            }), o;
        };
    };
});

});

parcelRegister("7Xq6P", function(module, exports) {
!function(r, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

});





parcelRegister("8llE9", function(module, exports) {

$parcel$export(module.exports, "W3mModal", function () { return $61311372f5fb5eec$export$8f54aa55129a8184; });
parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $aHgTP = parcelRequire("aHgTP");
var $5n5Ql = parcelRequire("5n5Ql");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $3OaCj = parcelRequire("3OaCj");
var $jIUUu = parcelRequire("jIUUu");
var $dXr1O = parcelRequire("dXr1O");
var $jGPEs = parcelRequire("jGPEs");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
var $cRWGJ = parcelRequire("cRWGJ");
var $fRkfl = parcelRequire("fRkfl");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");

var $cYYm5 = parcelRequire("cYYm5");
var $61311372f5fb5eec$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $61311372f5fb5eec$var$SCROLL_LOCK = "scroll-lock";
let $61311372f5fb5eec$export$8f54aa55129a8184 = class W3mModal extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.abortController = undefined;
        this.open = (0, $nBm8O.ModalController).state.open;
        this.caipAddress = (0, $7mucr.AccountController).state.caipAddress;
        this.isSiweEnabled = (0, $jIUUu.SIWEController).state.isSiweEnabled;
        this.initializeTheming();
        (0, $aHgTP.ApiController).prefetch();
        this.unsubscribe.push((0, $nBm8O.ModalController).subscribeKey("open", (val)=>val ? this.onOpen() : this.onClose()), (0, $jIUUu.SIWEController).subscribeKey("isSiweEnabled", (isEnabled)=>{
            this.isSiweEnabled = isEnabled;
        }), (0, $7mucr.AccountController).subscribe((newAccountState)=>this.onNewAccountState(newAccountState)));
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "MODAL_LOADED"
        });
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.onRemoveKeyboardListener();
    }
    render() {
        return this.open ? (0, $gDLfI.html)`
          <wui-flex @click=${this.onOverlayClick.bind(this)}>
            <wui-card role="alertdialog" aria-modal="true" tabindex="0">
              <w3m-header></w3m-header>
              <w3m-router></w3m-router>
              <w3m-snackbar></w3m-snackbar>
            </wui-card>
          </wui-flex>
        ` : null;
    }
    async onOverlayClick(event) {
        if (event.target === event.currentTarget) await this.handleClose();
    }
    async handleClose() {
        if (this.isSiweEnabled && (0, $jIUUu.SIWEController).state.status !== "success") await (0, $5n5Ql.ConnectionController).disconnect();
        (0, $nBm8O.ModalController).close();
    }
    initializeTheming() {
        const { themeVariables: themeVariables, themeMode: themeMode } = (0, $jGPEs.ThemeController).state;
        const defaultThemeMode = (0, $fRkfl.UiHelperUtil).getColorTheme(themeMode);
        (0, $cRWGJ.initializeTheming)(themeVariables, defaultThemeMode);
    }
    async onClose() {
        this.onScrollUnlock();
        await this.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards"
        }).finished;
        (0, $dXr1O.SnackController).hide();
        this.open = false;
        this.onRemoveKeyboardListener();
    }
    async onOpen() {
        this.onScrollLock();
        this.open = true;
        await this.animate([
            {
                opacity: 0
            },
            {
                opacity: 1
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards",
            delay: 300
        }).finished;
        this.onAddKeyboardListener();
    }
    onScrollLock() {
        const styleTag = document.createElement("style");
        styleTag.dataset["w3m"] = $61311372f5fb5eec$var$SCROLL_LOCK;
        styleTag.textContent = `
      html, body {
        touch-action: none;
        overflow: hidden;
        overscroll-behavior: contain;
      }
      w3m-modal {
        pointer-events: auto;
      }
    `;
        document.head.appendChild(styleTag);
    }
    onScrollUnlock() {
        const styleTag = document.head.querySelector(`style[data-w3m="${$61311372f5fb5eec$var$SCROLL_LOCK}"]`);
        if (styleTag) styleTag.remove();
    }
    onAddKeyboardListener() {
        this.abortController = new AbortController();
        const card = this.shadowRoot?.querySelector("wui-card");
        card?.focus();
        window.addEventListener("keydown", (event)=>{
            if (event.key === "Escape") this.handleClose();
            else if (event.key === "Tab") {
                const { tagName: tagName } = event.target;
                if (tagName && !tagName.includes("W3M-") && !tagName.includes("WUI-")) card?.focus();
            }
        }, this.abortController);
    }
    onRemoveKeyboardListener() {
        this.abortController?.abort();
        this.abortController = undefined;
    }
    async onNewAccountState(newState) {
        const { isConnected: isConnected, caipAddress: newCaipAddress } = newState;
        if (this.isSiweEnabled) {
            if (isConnected && !this.caipAddress) this.caipAddress = newCaipAddress;
            if (isConnected && newCaipAddress && this.caipAddress !== newCaipAddress) {
                await (0, $jIUUu.SIWEController).signOut();
                this.onSiweNavigation();
                this.caipAddress = newCaipAddress;
            }
            try {
                const session = await (0, $jIUUu.SIWEController).getSession();
                if (session && !isConnected) await (0, $jIUUu.SIWEController).signOut();
                else if (isConnected && !session) this.onSiweNavigation();
            } catch (error) {
                if (isConnected) this.onSiweNavigation();
            }
        }
    }
    onSiweNavigation() {
        if (this.open) (0, $3OaCj.RouterController).push("ConnectingSiwe");
        else (0, $nBm8O.ModalController).open({
            view: "ConnectingSiwe"
        });
    }
};
$61311372f5fb5eec$export$8f54aa55129a8184.styles = (0, $cYYm5.default);
$61311372f5fb5eec$var$__decorate([
    (0, $hdnNF.state)()
], $61311372f5fb5eec$export$8f54aa55129a8184.prototype, "open", void 0);
$61311372f5fb5eec$var$__decorate([
    (0, $hdnNF.state)()
], $61311372f5fb5eec$export$8f54aa55129a8184.prototype, "caipAddress", void 0);
$61311372f5fb5eec$var$__decorate([
    (0, $hdnNF.state)()
], $61311372f5fb5eec$export$8f54aa55129a8184.prototype, "isSiweEnabled", void 0);
$61311372f5fb5eec$export$8f54aa55129a8184 = $61311372f5fb5eec$var$__decorate([
    (0, $3SCaV.customElement)("w3m-modal")
], $61311372f5fb5eec$export$8f54aa55129a8184);

});
parcelRegister("4Jfqv", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("88H1e")).css; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("gDLfI")).html; });
$parcel$export(module.exports, "LitElement", function () { return (parcelRequire("dlgVE")).LitElement; });
parcelRequire("kaMqH");
parcelRequire("gDLfI");
parcelRequire("dlgVE");
parcelRequire("jcuge");

});
parcelRegister("kaMqH", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", function () { return $eafa4eee2bb5a735$export$7312b35fbf521afb; });
$parcel$export(module.exports, "notEqual", function () { return $eafa4eee2bb5a735$export$53a6892c50694894; });
$parcel$export(module.exports, "ReactiveElement", function () { return $eafa4eee2bb5a735$export$c7c07a37856565d; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("88H1e")).css; });

var $88H1e = parcelRequire("88H1e");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $eafa4eee2bb5a735$var$i, defineProperty: $eafa4eee2bb5a735$var$e, getOwnPropertyDescriptor: $eafa4eee2bb5a735$var$r, getOwnPropertyNames: $eafa4eee2bb5a735$var$h, getOwnPropertySymbols: $eafa4eee2bb5a735$var$o, getPrototypeOf: $eafa4eee2bb5a735$var$n } = Object, $eafa4eee2bb5a735$var$a = globalThis, $eafa4eee2bb5a735$var$c = $eafa4eee2bb5a735$var$a.trustedTypes, $eafa4eee2bb5a735$var$l = $eafa4eee2bb5a735$var$c ? $eafa4eee2bb5a735$var$c.emptyScript : "", $eafa4eee2bb5a735$var$p = $eafa4eee2bb5a735$var$a.reactiveElementPolyfillSupport, $eafa4eee2bb5a735$var$d = (t, s)=>t, $eafa4eee2bb5a735$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $eafa4eee2bb5a735$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $eafa4eee2bb5a735$export$53a6892c50694894 = (t, s)=>!$eafa4eee2bb5a735$var$i(t, s), $eafa4eee2bb5a735$var$y = {
    attribute: !0,
    type: String,
    converter: $eafa4eee2bb5a735$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $eafa4eee2bb5a735$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $eafa4eee2bb5a735$var$a.litPropertyMetadata ??= new WeakMap;
class $eafa4eee2bb5a735$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $eafa4eee2bb5a735$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $eafa4eee2bb5a735$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $eafa4eee2bb5a735$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $eafa4eee2bb5a735$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($eafa4eee2bb5a735$var$d("elementProperties"))) return;
        const t = $eafa4eee2bb5a735$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($eafa4eee2bb5a735$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($eafa4eee2bb5a735$var$d("properties"))) {
            const t = this.properties, s = [
                ...$eafa4eee2bb5a735$var$h(t),
                ...$eafa4eee2bb5a735$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $88H1e.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $88H1e.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $88H1e.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $eafa4eee2bb5a735$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $eafa4eee2bb5a735$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $eafa4eee2bb5a735$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$eafa4eee2bb5a735$export$c7c07a37856565d.elementStyles = [], $eafa4eee2bb5a735$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $eafa4eee2bb5a735$export$c7c07a37856565d[$eafa4eee2bb5a735$var$d("elementProperties")] = new Map, $eafa4eee2bb5a735$export$c7c07a37856565d[$eafa4eee2bb5a735$var$d("finalized")] = new Map, $eafa4eee2bb5a735$var$p?.({
    ReactiveElement: $eafa4eee2bb5a735$export$c7c07a37856565d
}), ($eafa4eee2bb5a735$var$a.reactiveElementVersions ??= []).push("2.0.4");

});
parcelRegister("88H1e", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $5ed070bf4f2f0826$export$dbf350e5966cf602; });
$parcel$export(module.exports, "adoptStyles", function () { return $5ed070bf4f2f0826$export$2ca4a66ec4cecb90; });
$parcel$export(module.exports, "getCompatibleStyle", function () { return $5ed070bf4f2f0826$export$ee69dfd951e24778; });
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $5ed070bf4f2f0826$var$t = globalThis, $5ed070bf4f2f0826$export$b4d10f6001c083c2 = $5ed070bf4f2f0826$var$t.ShadowRoot && (void 0 === $5ed070bf4f2f0826$var$t.ShadyCSS || $5ed070bf4f2f0826$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $5ed070bf4f2f0826$var$s = Symbol(), $5ed070bf4f2f0826$var$o = new WeakMap;
class $5ed070bf4f2f0826$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $5ed070bf4f2f0826$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($5ed070bf4f2f0826$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $5ed070bf4f2f0826$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $5ed070bf4f2f0826$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $5ed070bf4f2f0826$export$8d80f9cac07cdb3 = (t)=>new $5ed070bf4f2f0826$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $5ed070bf4f2f0826$var$s), $5ed070bf4f2f0826$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $5ed070bf4f2f0826$export$505d1e8739bad805(o, t, $5ed070bf4f2f0826$var$s);
}, $5ed070bf4f2f0826$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($5ed070bf4f2f0826$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $5ed070bf4f2f0826$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $5ed070bf4f2f0826$export$ee69dfd951e24778 = $5ed070bf4f2f0826$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $5ed070bf4f2f0826$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("gDLfI", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $c1d4f13559c68def$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "noChange", function () { return $c1d4f13559c68def$export$9c068ae9cc5db4e8; });
$parcel$export(module.exports, "nothing", function () { return $c1d4f13559c68def$export$45b790e32b2810ee; });
$parcel$export(module.exports, "_$LH", function () { return $c1d4f13559c68def$export$8613d1ca9052b22e; });
$parcel$export(module.exports, "render", function () { return $c1d4f13559c68def$export$b3890eb0ae9dca99; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c1d4f13559c68def$var$n = globalThis, $c1d4f13559c68def$var$c = $c1d4f13559c68def$var$n.trustedTypes, $c1d4f13559c68def$var$h = $c1d4f13559c68def$var$c ? $c1d4f13559c68def$var$c.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $c1d4f13559c68def$var$f = "$lit$", $c1d4f13559c68def$var$v = `lit$${Math.random().toFixed(9).slice(2)}$`, $c1d4f13559c68def$var$m = "?" + $c1d4f13559c68def$var$v, $c1d4f13559c68def$var$_ = `<${$c1d4f13559c68def$var$m}>`, $c1d4f13559c68def$var$w = document, $c1d4f13559c68def$var$lt = ()=>$c1d4f13559c68def$var$w.createComment(""), $c1d4f13559c68def$var$st = (t)=>null === t || "object" != typeof t && "function" != typeof t, $c1d4f13559c68def$var$g = Array.isArray, $c1d4f13559c68def$var$$ = (t)=>$c1d4f13559c68def$var$g(t) || "function" == typeof t?.[Symbol.iterator], $c1d4f13559c68def$var$x = "[ 	\n\f\r]", $c1d4f13559c68def$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $c1d4f13559c68def$var$E = /-->/g, $c1d4f13559c68def$var$k = />/g, $c1d4f13559c68def$var$O = RegExp(`>|${$c1d4f13559c68def$var$x}(?:([^\\s"'>=/]+)(${$c1d4f13559c68def$var$x}*=${$c1d4f13559c68def$var$x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $c1d4f13559c68def$var$S = /'/g, $c1d4f13559c68def$var$j = /"/g, $c1d4f13559c68def$var$M = /^(?:script|style|textarea|title)$/i, $c1d4f13559c68def$var$P = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $c1d4f13559c68def$export$c0bb0b647f701bb5 = $c1d4f13559c68def$var$P(1), $c1d4f13559c68def$export$7ed1367e7fa1ad68 = $c1d4f13559c68def$var$P(2), $c1d4f13559c68def$export$47d5b44d225be5b4 = $c1d4f13559c68def$var$P(3), $c1d4f13559c68def$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $c1d4f13559c68def$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $c1d4f13559c68def$var$V = new WeakMap, $c1d4f13559c68def$var$I = $c1d4f13559c68def$var$w.createTreeWalker($c1d4f13559c68def$var$w, 129);
function $c1d4f13559c68def$var$N(t, i) {
    if (!$c1d4f13559c68def$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $c1d4f13559c68def$var$h ? $c1d4f13559c68def$var$h.createHTML(i) : i;
}
const $c1d4f13559c68def$var$U = (t, i)=>{
    const s = t.length - 1, e = [];
    let h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $c1d4f13559c68def$var$T;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let r, l, c = -1, a = 0;
        for(; a < s.length && (n.lastIndex = a, l = n.exec(s), null !== l);)a = n.lastIndex, n === $c1d4f13559c68def$var$T ? "!--" === l[1] ? n = $c1d4f13559c68def$var$E : void 0 !== l[1] ? n = $c1d4f13559c68def$var$k : void 0 !== l[2] ? ($c1d4f13559c68def$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $c1d4f13559c68def$var$O) : void 0 !== l[3] && (n = $c1d4f13559c68def$var$O) : n === $c1d4f13559c68def$var$O ? ">" === l[0] ? (n = h ?? $c1d4f13559c68def$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $c1d4f13559c68def$var$O : '"' === l[3] ? $c1d4f13559c68def$var$j : $c1d4f13559c68def$var$S) : n === $c1d4f13559c68def$var$j || n === $c1d4f13559c68def$var$S ? n = $c1d4f13559c68def$var$O : n === $c1d4f13559c68def$var$E || n === $c1d4f13559c68def$var$k ? n = $c1d4f13559c68def$var$T : (n = $c1d4f13559c68def$var$O, h = void 0);
        const u = n === $c1d4f13559c68def$var$O && t[i + 1].startsWith("/>") ? " " : "";
        o += n === $c1d4f13559c68def$var$T ? s + $c1d4f13559c68def$var$_ : c >= 0 ? (e.push(r), s.slice(0, c) + $c1d4f13559c68def$var$f + s.slice(c) + $c1d4f13559c68def$var$v + u) : s + $c1d4f13559c68def$var$v + (-2 === c ? i : u);
    }
    return [
        $c1d4f13559c68def$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $c1d4f13559c68def$var$B {
    constructor({ strings: t, _$litType$: i }, s){
        let e;
        this.parts = [];
        let h = 0, o = 0;
        const n = t.length - 1, r = this.parts, [l, a] = $c1d4f13559c68def$var$U(t, i);
        if (this.el = $c1d4f13559c68def$var$B.createElement(l, s), $c1d4f13559c68def$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (e = $c1d4f13559c68def$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                if (e.hasAttributes()) for (const t of e.getAttributeNames())if (t.endsWith($c1d4f13559c68def$var$f)) {
                    const i = a[o++], s = e.getAttribute(t).split($c1d4f13559c68def$var$v), n = /([.?@])?(.*)/.exec(i);
                    r.push({
                        type: 1,
                        index: h,
                        name: n[2],
                        strings: s,
                        ctor: "." === n[1] ? $c1d4f13559c68def$var$Y : "?" === n[1] ? $c1d4f13559c68def$var$Z : "@" === n[1] ? $c1d4f13559c68def$var$q : $c1d4f13559c68def$var$G
                    }), e.removeAttribute(t);
                } else t.startsWith($c1d4f13559c68def$var$v) && (r.push({
                    type: 6,
                    index: h
                }), e.removeAttribute(t));
                if ($c1d4f13559c68def$var$M.test(e.tagName)) {
                    const t = e.textContent.split($c1d4f13559c68def$var$v), i = t.length - 1;
                    if (i > 0) {
                        e.textContent = $c1d4f13559c68def$var$c ? $c1d4f13559c68def$var$c.emptyScript : "";
                        for(let s = 0; s < i; s++)e.append(t[s], $c1d4f13559c68def$var$lt()), $c1d4f13559c68def$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t[i], $c1d4f13559c68def$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $c1d4f13559c68def$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = e.data.indexOf($c1d4f13559c68def$var$v, t + 1));)r.push({
                        type: 7,
                        index: h
                    }), t += $c1d4f13559c68def$var$v.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $c1d4f13559c68def$var$w.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $c1d4f13559c68def$var$z(t, i, s = t, e) {
    if (i === $c1d4f13559c68def$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s.o?.[e] : s.l;
    const o = $c1d4f13559c68def$var$st(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s.o ??= [])[e] = h : s.l = h), void 0 !== h && (i = $c1d4f13559c68def$var$z(t, h._$AS(t, i.values), h, e)), i;
}
class $c1d4f13559c68def$var$F {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $c1d4f13559c68def$var$w).importNode(i, !0);
        $c1d4f13559c68def$var$I.currentNode = e;
        let h = $c1d4f13559c68def$var$I.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $c1d4f13559c68def$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $c1d4f13559c68def$var$K(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $c1d4f13559c68def$var$I.nextNode(), o++);
        }
        return $c1d4f13559c68def$var$I.currentNode = $c1d4f13559c68def$var$w, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $c1d4f13559c68def$var$et {
    get _$AU() {
        return this._$AM?._$AU ?? this.v;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $c1d4f13559c68def$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $c1d4f13559c68def$var$z(this, t, i), $c1d4f13559c68def$var$st(t) ? t === $c1d4f13559c68def$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $c1d4f13559c68def$export$45b790e32b2810ee && this._$AR(), this._$AH = $c1d4f13559c68def$export$45b790e32b2810ee) : t !== this._$AH && t !== $c1d4f13559c68def$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $c1d4f13559c68def$var$$(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $c1d4f13559c68def$export$45b790e32b2810ee && $c1d4f13559c68def$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($c1d4f13559c68def$var$w.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $c1d4f13559c68def$var$B.createElement($c1d4f13559c68def$var$N(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $c1d4f13559c68def$var$F(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $c1d4f13559c68def$var$V.get(t.strings);
        return void 0 === i && $c1d4f13559c68def$var$V.set(t.strings, i = new $c1d4f13559c68def$var$B(t)), i;
    }
    k(t) {
        $c1d4f13559c68def$var$g(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $c1d4f13559c68def$var$et(this.O($c1d4f13559c68def$var$lt()), this.O($c1d4f13559c68def$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this.v = t, this._$AP?.(t));
    }
}
class $c1d4f13559c68def$var$G {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $c1d4f13559c68def$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $c1d4f13559c68def$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $c1d4f13559c68def$var$z(this, t, i, 0), o = !$c1d4f13559c68def$var$st(t) || t !== this._$AH && t !== $c1d4f13559c68def$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $c1d4f13559c68def$var$z(this, e[s + n], i, n), r === $c1d4f13559c68def$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$c1d4f13559c68def$var$st(r) || r !== this._$AH[n], r === $c1d4f13559c68def$export$45b790e32b2810ee ? t = $c1d4f13559c68def$export$45b790e32b2810ee : t !== $c1d4f13559c68def$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $c1d4f13559c68def$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $c1d4f13559c68def$var$Y extends $c1d4f13559c68def$var$G {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $c1d4f13559c68def$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $c1d4f13559c68def$var$Z extends $c1d4f13559c68def$var$G {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $c1d4f13559c68def$export$45b790e32b2810ee);
    }
}
class $c1d4f13559c68def$var$q extends $c1d4f13559c68def$var$G {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $c1d4f13559c68def$var$z(this, t, i, 0) ?? $c1d4f13559c68def$export$45b790e32b2810ee) === $c1d4f13559c68def$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $c1d4f13559c68def$export$45b790e32b2810ee && s !== $c1d4f13559c68def$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $c1d4f13559c68def$export$45b790e32b2810ee && (s === $c1d4f13559c68def$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $c1d4f13559c68def$var$K {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $c1d4f13559c68def$var$z(this, t);
    }
}
const $c1d4f13559c68def$export$8613d1ca9052b22e = {
    M: $c1d4f13559c68def$var$f,
    P: $c1d4f13559c68def$var$v,
    A: $c1d4f13559c68def$var$m,
    C: 1,
    L: $c1d4f13559c68def$var$U,
    R: $c1d4f13559c68def$var$F,
    D: $c1d4f13559c68def$var$$,
    V: $c1d4f13559c68def$var$z,
    I: $c1d4f13559c68def$var$et,
    H: $c1d4f13559c68def$var$G,
    N: $c1d4f13559c68def$var$Z,
    U: $c1d4f13559c68def$var$q,
    B: $c1d4f13559c68def$var$Y,
    F: $c1d4f13559c68def$var$K
}, $c1d4f13559c68def$var$Re = $c1d4f13559c68def$var$n.litHtmlPolyfillSupport;
$c1d4f13559c68def$var$Re?.($c1d4f13559c68def$var$B, $c1d4f13559c68def$var$et), ($c1d4f13559c68def$var$n.litHtmlVersions ??= []).push("3.2.0");
const $c1d4f13559c68def$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $c1d4f13559c68def$var$et(i.insertBefore($c1d4f13559c68def$var$lt(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("dlgVE", function(module, exports) {
$parcel$export(module.exports, "css", function () { return (parcelRequire("88H1e")).css; });
$parcel$export(module.exports, "ReactiveElement", function () { return (parcelRequire("kaMqH")).ReactiveElement; });
$parcel$export(module.exports, "html", function () { return (parcelRequire("gDLfI")).html; });
$parcel$export(module.exports, "noChange", function () { return (parcelRequire("gDLfI")).noChange; });
$parcel$export(module.exports, "render", function () { return (parcelRequire("gDLfI")).render; });

$parcel$export(module.exports, "LitElement", function () { return $9b6a5e4007b09181$export$3f2f9f5909897157; });

var $kaMqH = parcelRequire("kaMqH");

var $gDLfI = parcelRequire("gDLfI");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $9b6a5e4007b09181$export$3f2f9f5909897157 extends (0, $kaMqH.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.o = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = (0, $gDLfI.render)(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this.o?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.o?.setConnected(!1);
    }
    render() {
        return 0, $gDLfI.noChange;
    }
}
$9b6a5e4007b09181$export$3f2f9f5909897157._$litElement$ = !0, $9b6a5e4007b09181$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $9b6a5e4007b09181$export$3f2f9f5909897157
});
const $9b6a5e4007b09181$var$f = globalThis.litElementPolyfillSupport;
$9b6a5e4007b09181$var$f?.({
    LitElement: $9b6a5e4007b09181$export$3f2f9f5909897157
});
const $9b6a5e4007b09181$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.0");

});

parcelRegister("jcuge", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $dfa69c7b71084d83$export$6acf61af03e62db = !1;

});


parcelRegister("bkCde", function(module, exports) {
$parcel$export(module.exports, "property", function () { return (parcelRequire("8c6bF")).property; });
$parcel$export(module.exports, "state", function () { return (parcelRequire("hdnNF")).state; });
parcelRequire("i8OdO");
parcelRequire("8c6bF");
parcelRequire("hdnNF");
parcelRequire("elRTm");
parcelRequire("cJKNq");
parcelRequire("bdIf1");
parcelRequire("5xUFe");
parcelRequire("48D52");
parcelRequire("7RGuc");

});
parcelRegister("i8OdO", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d34fee5c152606f7$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("8c6bF", function(module, exports) {

$parcel$export(module.exports, "property", function () { return $5f743e570d5c0ac6$export$d541bacb2bda4494; });

var $kaMqH = parcelRequire("kaMqH");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $5f743e570d5c0ac6$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $kaMqH.defaultConverter),
    reflect: !1,
    hasChanged: (0, $kaMqH.notEqual)
}, $5f743e570d5c0ac6$export$8d623b1670eb40f4 = (t = $5f743e570d5c0ac6$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $5f743e570d5c0ac6$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $5f743e570d5c0ac6$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("hdnNF", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $c8861cc6332a28d9$export$ca000e230c0caa3e; });

var $8c6bF = parcelRequire("8c6bF");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c8861cc6332a28d9$export$ca000e230c0caa3e(r) {
    return (0, $8c6bF.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("elRTm", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $a72cd4a7580d638d$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("cJKNq", function(module, exports) {

var $dJnk3 = parcelRequire("dJnk3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $945dfcc0963c0f10$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $dJnk3.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $dJnk3.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("dJnk3", function(module, exports) {

$parcel$export(module.exports, "desc", function () { return $9ff191afde3e44e3$export$51987bb50e1f6752; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9ff191afde3e44e3$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("bdIf1", function(module, exports) {

var $dJnk3 = parcelRequire("dJnk3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $82b33a000c8b5d3a$var$e;
function $82b33a000c8b5d3a$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $dJnk3.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($82b33a000c8b5d3a$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("5xUFe", function(module, exports) {

var $dJnk3 = parcelRequire("dJnk3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $409bfd1bb3078e26$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $dJnk3.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("48D52", function(module, exports) {

var $dJnk3 = parcelRequire("dJnk3");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $303639481043082b$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $dJnk3.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("7RGuc", function(module, exports) {

var $dJnk3 = parcelRequire("dJnk3");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5b9e707ef1f45447$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $dJnk3.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("cYYm5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9739e7e68d23cd62$export$2e2bcd8739ae039; });
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $9739e7e68d23cd62$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host {
    z-index: var(--w3m-z-index);
    display: block;
    backface-visibility: hidden;
    will-change: opacity;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    opacity: 0;
    background-color: var(--wui-cover);
  }

  @keyframes zoom-in {
    0% {
      transform: scale(0.95) translateY(0);
    }
    100% {
      transform: scale(1) translateY(0);
    }
  }

  @keyframes slide-in {
    0% {
      transform: scale(1) translateY(50px);
    }
    100% {
      transform: scale(1) translateY(0);
    }
  }

  wui-card {
    max-width: 360px;
    width: 100%;
    position: relative;
    animation-delay: 0.3s;
    animation-duration: 0.2s;
    animation-name: zoom-in;
    animation-fill-mode: backwards;
    animation-timing-function: var(--wui-ease-out-power-2);
    outline: none;
  }

  wui-flex {
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  @media (max-height: 700px) and (min-width: 431px) {
    wui-flex {
      align-items: flex-start;
    }

    wui-card {
      margin: var(--wui-spacing-xxl) 0px;
    }
  }

  @media (max-width: 430px) {
    wui-flex {
      align-items: flex-end;
    }

    wui-card {
      max-width: 100%;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom: none;
      animation-name: slide-in;
    }
  }
`;

});


parcelRegister("fDWVA", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("jN5Zi", function(module, exports) {

$parcel$export(module.exports, "recoverAddress", function () { return $e6873cf63dac9d98$export$23cc18f96d8510e2; });

var $g6q8u = parcelRequire("g6q8u");

var $fxmOm = parcelRequire("fxmOm");
async function $e6873cf63dac9d98$export$23cc18f96d8510e2({ hash: hash, signature: signature }) {
    return (0, $g6q8u.publicKeyToAddress)(await (0, $fxmOm.recoverPublicKey)({
        hash: hash,
        signature: signature
    }));
}

});
parcelRegister("g6q8u", function(module, exports) {

$parcel$export(module.exports, "publicKeyToAddress", function () { return $bb917af3323358ac$export$462669520a9d12d1; });

var $siouQ = parcelRequire("siouQ");

var $diQni = parcelRequire("diQni");
function $bb917af3323358ac$export$462669520a9d12d1(publicKey) {
    const address = (0, $diQni.keccak256)(`0x${publicKey.substring(4)}`).substring(26);
    return (0, $siouQ.checksumAddress)(`0x${address}`);
}

});

parcelRegister("fxmOm", function(module, exports) {

$parcel$export(module.exports, "recoverPublicKey", function () { return $b4fba1e822236884$export$952dd09fbe0232b7; });

var $16Qvp = parcelRequire("16Qvp");

var $9GGVO = parcelRequire("9GGVO");

var $jW8ut = parcelRequire("jW8ut");

async function $b4fba1e822236884$export$952dd09fbe0232b7({ hash: hash, signature: signature }) {
    const hashHex = (0, $16Qvp.isHex)(hash) ? hash : (0, $jW8ut.toHex)(hash);
    const { secp256k1: secp256k1 } = await Promise.resolve((parcelRequire("1qSNR")));
    const signature_ = (()=>{
        // typeof signature: `Signature`
        if (typeof signature === "object" && "r" in signature && "s" in signature) {
            const { r: r, s: s, v: v, yParity: yParity } = signature;
            const yParityOrV = Number(yParity ?? v);
            const recoveryBit = $b4fba1e822236884$var$toRecoveryBit(yParityOrV);
            return new secp256k1.Signature((0, $9GGVO.hexToBigInt)(r), (0, $9GGVO.hexToBigInt)(s)).addRecoveryBit(recoveryBit);
        }
        // typeof signature: `Hex | ByteArray`
        const signatureHex = (0, $16Qvp.isHex)(signature) ? signature : (0, $jW8ut.toHex)(signature);
        const yParityOrV = (0, $9GGVO.hexToNumber)(`0x${signatureHex.slice(130)}`);
        const recoveryBit = $b4fba1e822236884$var$toRecoveryBit(yParityOrV);
        return secp256k1.Signature.fromCompact(signatureHex.substring(2, 130)).addRecoveryBit(recoveryBit);
    })();
    const publicKey = signature_.recoverPublicKey(hashHex.substring(2)).toHex(false);
    return `0x${publicKey}`;
}
function $b4fba1e822236884$var$toRecoveryBit(yParityOrV) {
    if (yParityOrV === 0 || yParityOrV === 1) return yParityOrV;
    if (yParityOrV === 27) return 0;
    if (yParityOrV === 28) return 1;
    throw new Error("Invalid yParityOrV value");
}

});
parcelRegister("1qSNR", function(module, exports) {

$parcel$export(module.exports, "secp256k1", function () { return $10b2baecffe66b91$export$529e6123e9353a90; });
/**
 * NIST secp256k1. See [pdf](https://www.secg.org/sec2-v2.pdf).
 *
 * Seems to be rigid (not backdoored)
 * [as per discussion](https://bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975).
 *
 * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
 * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
 * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
 * [See explanation](https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066).
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $ceTyC = parcelRequire("ceTyC");

var $6ynrP = parcelRequire("6ynrP");

var $azH74 = parcelRequire("azH74");

var $7yBGq = parcelRequire("7yBGq");

var $1RHo6 = parcelRequire("1RHo6");

var $lBKww = parcelRequire("lBKww");

var $a4aF3 = parcelRequire("a4aF3");
const $10b2baecffe66b91$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $10b2baecffe66b91$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $10b2baecffe66b91$var$_1n = BigInt(1);
const $10b2baecffe66b91$var$_2n = BigInt(2);
const $10b2baecffe66b91$var$divNearest = (a, b)=>(a + b / $10b2baecffe66b91$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $10b2baecffe66b91$var$sqrtMod(y) {
    const P = $10b2baecffe66b91$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $1RHo6.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $1RHo6.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $1RHo6.pow2)(b9, $10b2baecffe66b91$var$_2n, P) * b2 % P;
    const b22 = (0, $1RHo6.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $1RHo6.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $1RHo6.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $1RHo6.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $1RHo6.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $1RHo6.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $1RHo6.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $1RHo6.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $1RHo6.pow2)(t2, $10b2baecffe66b91$var$_2n, P);
    if (!$10b2baecffe66b91$var$Fpk1.eql($10b2baecffe66b91$var$Fpk1.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $10b2baecffe66b91$var$Fpk1 = (0, $1RHo6.Field)($10b2baecffe66b91$var$secp256k1P, undefined, undefined, {
    sqrt: $10b2baecffe66b91$var$sqrtMod
});
const $10b2baecffe66b91$export$529e6123e9353a90 = (0, $azH74.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $10b2baecffe66b91$var$Fpk1,
    n: $10b2baecffe66b91$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    endo: {
        // Endomorphism, see above
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $10b2baecffe66b91$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$10b2baecffe66b91$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $10b2baecffe66b91$var$divNearest(b2 * k, n);
            const c2 = $10b2baecffe66b91$var$divNearest(-b1 * k, n);
            let k1 = (0, $1RHo6.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $1RHo6.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $ceTyC.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $10b2baecffe66b91$var$_0n = BigInt(0);
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $10b2baecffe66b91$var$TAGGED_HASH_PREFIXES = {};
function $10b2baecffe66b91$var$taggedHash(tag, ...messages) {
    let tagP = $10b2baecffe66b91$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $ceTyC.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $lBKww.concatBytes)(tagH, tagH);
        $10b2baecffe66b91$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $ceTyC.sha256)((0, $lBKww.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $10b2baecffe66b91$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $10b2baecffe66b91$var$numTo32b = (n)=>(0, $lBKww.numberToBytesBE)(n, 32);
const $10b2baecffe66b91$var$modP = (x)=>(0, $1RHo6.mod)(x, $10b2baecffe66b91$var$secp256k1P);
const $10b2baecffe66b91$var$modN = (x)=>(0, $1RHo6.mod)(x, $10b2baecffe66b91$var$secp256k1N);
const $10b2baecffe66b91$var$Point = $10b2baecffe66b91$export$529e6123e9353a90.ProjectivePoint;
const $10b2baecffe66b91$var$GmulAdd = (Q, a, b)=>$10b2baecffe66b91$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $10b2baecffe66b91$var$schnorrGetExtPubKey(priv) {
    let d_ = $10b2baecffe66b91$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $10b2baecffe66b91$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $10b2baecffe66b91$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $10b2baecffe66b91$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $10b2baecffe66b91$var$lift_x(x) {
    (0, $lBKww.aInRange)("x", x, $10b2baecffe66b91$var$_1n, $10b2baecffe66b91$var$secp256k1P); // Fail if x ≥ p.
    const xx = $10b2baecffe66b91$var$modP(x * x);
    const c = $10b2baecffe66b91$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $10b2baecffe66b91$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $10b2baecffe66b91$var$_2n !== $10b2baecffe66b91$var$_0n) y = $10b2baecffe66b91$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $10b2baecffe66b91$var$Point(x, y, $10b2baecffe66b91$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
const $10b2baecffe66b91$var$num = (0, $lBKww.bytesToNumberBE);
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $10b2baecffe66b91$var$challenge(...args) {
    return $10b2baecffe66b91$var$modN($10b2baecffe66b91$var$num($10b2baecffe66b91$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $10b2baecffe66b91$var$schnorrGetPublicKey(privateKey) {
    return $10b2baecffe66b91$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $10b2baecffe66b91$var$schnorrSign(message, privateKey, auxRand = (0, $6ynrP.randomBytes)(32)) {
    const m = (0, $lBKww.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $10b2baecffe66b91$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $lBKww.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $10b2baecffe66b91$var$numTo32b(d ^ $10b2baecffe66b91$var$num($10b2baecffe66b91$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $10b2baecffe66b91$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $10b2baecffe66b91$var$modN($10b2baecffe66b91$var$num(rand)); // Let k' = int(rand) mod n
    if (k_ === $10b2baecffe66b91$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $10b2baecffe66b91$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $10b2baecffe66b91$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($10b2baecffe66b91$var$numTo32b($10b2baecffe66b91$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$10b2baecffe66b91$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $10b2baecffe66b91$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $lBKww.ensureBytes)("signature", signature, 64);
    const m = (0, $lBKww.ensureBytes)("message", message);
    const pub = (0, $lBKww.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $10b2baecffe66b91$var$lift_x($10b2baecffe66b91$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $10b2baecffe66b91$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $lBKww.inRange)(r, $10b2baecffe66b91$var$_1n, $10b2baecffe66b91$var$secp256k1P)) return false;
        const s = $10b2baecffe66b91$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $lBKww.inRange)(s, $10b2baecffe66b91$var$_1n, $10b2baecffe66b91$var$secp256k1N)) return false;
        const e = $10b2baecffe66b91$var$challenge($10b2baecffe66b91$var$numTo32b(r), $10b2baecffe66b91$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $10b2baecffe66b91$var$GmulAdd(P, s, $10b2baecffe66b91$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $10b2baecffe66b91$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $10b2baecffe66b91$var$schnorrGetPublicKey,
        sign: $10b2baecffe66b91$var$schnorrSign,
        verify: $10b2baecffe66b91$var$schnorrVerify,
        utils: {
            randomPrivateKey: $10b2baecffe66b91$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $10b2baecffe66b91$var$lift_x,
            pointToBytes: $10b2baecffe66b91$var$pointToBytes,
            numberToBytesBE: $lBKww.numberToBytesBE,
            bytesToNumberBE: $lBKww.bytesToNumberBE,
            taggedHash: $10b2baecffe66b91$var$taggedHash,
            mod: $1RHo6.mod
        }
    }))();
const $10b2baecffe66b91$var$isoMap = /* @__PURE__ */ (()=>(0, $7yBGq.isogenyMap)($10b2baecffe66b91$var$Fpk1, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $10b2baecffe66b91$var$mapSWU = /* @__PURE__ */ (()=>(0, $a4aF3.mapToCurveSimpleSWU)($10b2baecffe66b91$var$Fpk1, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $10b2baecffe66b91$var$Fpk1.create(BigInt("-11"))
    }))();
const $10b2baecffe66b91$var$htf = /* @__PURE__ */ (()=>(0, $7yBGq.createHasher)($10b2baecffe66b91$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $10b2baecffe66b91$var$mapSWU($10b2baecffe66b91$var$Fpk1.create(scalars[0]));
        return $10b2baecffe66b91$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $10b2baecffe66b91$var$Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $ceTyC.sha256)
    }))();
const $10b2baecffe66b91$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$10b2baecffe66b91$var$htf.hashToCurve)();
const $10b2baecffe66b91$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$10b2baecffe66b91$var$htf.encodeToCurve)();

});
parcelRegister("ceTyC", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $8e91e365effe5c8c$export$bced8d2aada2d1c9; });
/**
 * SHA2-256 a.k.a. sha256. In JS, it is the fastest hash, even faster than Blake3.
 *
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 *
 * Check out [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ 
var $jZ1h5 = parcelRequire("jZ1h5");

var $6ynrP = parcelRequire("6ynrP");
/** Round constants: first 32 bits of fractional parts of the cube roots of the first 64 primes 2..311). */ // prettier-ignore
const $8e91e365effe5c8c$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Initial state: first 32 bits of fractional parts of the square roots of the first 8 primes 2..19. */ // prettier-ignore
const $8e91e365effe5c8c$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/**
 * Temporary buffer, not used to store anything between runs.
 * Named this way because it matches specification.
 */ const $8e91e365effe5c8c$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $8e91e365effe5c8c$export$397b834fceb5b168 extends (0, $jZ1h5.HashMD) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $8e91e365effe5c8c$var$SHA256_IV[0] | 0;
        this.B = $8e91e365effe5c8c$var$SHA256_IV[1] | 0;
        this.C = $8e91e365effe5c8c$var$SHA256_IV[2] | 0;
        this.D = $8e91e365effe5c8c$var$SHA256_IV[3] | 0;
        this.E = $8e91e365effe5c8c$var$SHA256_IV[4] | 0;
        this.F = $8e91e365effe5c8c$var$SHA256_IV[5] | 0;
        this.G = $8e91e365effe5c8c$var$SHA256_IV[6] | 0;
        this.H = $8e91e365effe5c8c$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$8e91e365effe5c8c$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $8e91e365effe5c8c$var$SHA256_W[i - 15];
            const W2 = $8e91e365effe5c8c$var$SHA256_W[i - 2];
            const s0 = (0, $6ynrP.rotr)(W15, 7) ^ (0, $6ynrP.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $6ynrP.rotr)(W2, 17) ^ (0, $6ynrP.rotr)(W2, 19) ^ W2 >>> 10;
            $8e91e365effe5c8c$var$SHA256_W[i] = s1 + $8e91e365effe5c8c$var$SHA256_W[i - 7] + s0 + $8e91e365effe5c8c$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $6ynrP.rotr)(E, 6) ^ (0, $6ynrP.rotr)(E, 11) ^ (0, $6ynrP.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $jZ1h5.Chi)(E, F, G) + $8e91e365effe5c8c$var$SHA256_K[i] + $8e91e365effe5c8c$var$SHA256_W[i] | 0;
            const sigma0 = (0, $6ynrP.rotr)(A, 2) ^ (0, $6ynrP.rotr)(A, 13) ^ (0, $6ynrP.rotr)(A, 22);
            const T2 = sigma0 + (0, $jZ1h5.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $8e91e365effe5c8c$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
/**
 * Constants taken from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf.
 */ class $8e91e365effe5c8c$var$SHA224 extends $8e91e365effe5c8c$export$397b834fceb5b168 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $8e91e365effe5c8c$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $6ynrP.wrapConstructor)(()=>new $8e91e365effe5c8c$export$397b834fceb5b168());
const $8e91e365effe5c8c$export$97b70509d4e397ea = /* @__PURE__ */ (0, $6ynrP.wrapConstructor)(()=>new $8e91e365effe5c8c$var$SHA224());

});
parcelRegister("jZ1h5", function(module, exports) {

$parcel$export(module.exports, "Chi", function () { return $e8c4b3ef6c93e05a$export$d0d97f016526eaf0; });
$parcel$export(module.exports, "Maj", function () { return $e8c4b3ef6c93e05a$export$8b1d810b1bd30adf; });
$parcel$export(module.exports, "HashMD", function () { return $e8c4b3ef6c93e05a$export$f9f830659f932cb2; });
/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ 
var $3k0hy = parcelRequire("3k0hy");

var $6ynrP = parcelRequire("6ynrP");
function $e8c4b3ef6c93e05a$export$b13f930c762582ab(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $e8c4b3ef6c93e05a$export$d0d97f016526eaf0(a, b, c) {
    return a & b ^ ~a & c;
}
function $e8c4b3ef6c93e05a$export$8b1d810b1bd30adf(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $e8c4b3ef6c93e05a$export$f9f830659f932cb2 extends (0, $6ynrP.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $6ynrP.createView)(this.buffer);
    }
    update(data) {
        (0, $3k0hy.aexists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $6ynrP.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $6ynrP.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $3k0hy.aexists)(this);
        (0, $3k0hy.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $e8c4b3ef6c93e05a$export$b13f930c762582ab(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $6ynrP.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});


parcelRegister("azH74", function(module, exports) {

$parcel$export(module.exports, "createCurve", function () { return $7b2e9d97e069a197$export$3f2f6721dd02558a; });
/**
 * Utilities for short weierstrass curves, combined with noble-hashes.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $4TAUb = parcelRequire("4TAUb");

var $6ynrP = parcelRequire("6ynrP");

var $a4aF3 = parcelRequire("a4aF3");
function $7b2e9d97e069a197$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $4TAUb.hmac)(hash, key, (0, $6ynrP.concatBytes)(...msgs)),
        randomBytes: $6ynrP.randomBytes
    };
}
function $7b2e9d97e069a197$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $a4aF3.weierstrass)({
            ...curveDef,
            ...$7b2e9d97e069a197$export$adaba664e531641c(hash)
        });
    return {
        ...create(defHash),
        create: create
    };
}

});
parcelRegister("4TAUb", function(module, exports) {

$parcel$export(module.exports, "hmac", function () { return $3908ed132f56c150$export$355af40f8ab02f34; });
/**
 * HMAC: RFC2104 message authentication code.
 * @module
 */ 
var $3k0hy = parcelRequire("3k0hy");

var $6ynrP = parcelRequire("6ynrP");
class $3908ed132f56c150$export$7b9cf41ebec74f45 extends (0, $6ynrP.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $3k0hy.ahash)(hash);
        const key = (0, $6ynrP.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $3k0hy.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $3k0hy.aexists)(this);
        (0, $3k0hy.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $3908ed132f56c150$export$355af40f8ab02f34 = (hash, key, message)=>new $3908ed132f56c150$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$3908ed132f56c150$export$355af40f8ab02f34.create = (hash, key)=>new $3908ed132f56c150$export$7b9cf41ebec74f45(hash, key);

});

parcelRegister("a4aF3", function(module, exports) {

$parcel$export(module.exports, "weierstrass", function () { return $75428c2a37621dad$export$350b8ea6f1c27fae; });
$parcel$export(module.exports, "mapToCurveSimpleSWU", function () { return $75428c2a37621dad$export$cc7fea9756a17416; });
/**
 * Short Weierstrass curve methods. The formula is: y² = x³ + ax + b.
 *
 * ### Design rationale for types
 *
 * * Interaction between classes from different curves should fail:
 *   `k256.Point.BASE.add(p256.Point.BASE)`
 * * For this purpose we want to use `instanceof` operator, which is fast and works during runtime
 * * Different calls of `curve()` would return different classes -
 *   `curve(params) !== curve(params)`: if somebody decided to monkey-patch their curve,
 *   it won't affect others
 *
 * TypeScript can't infer types for classes created inside a function. Classes is one instance
 * of nominative types in TypeScript and interfaces only check for shape, so it's hard to create
 * unique type for every function call.
 *
 * We can use generic types via some param, like curve opts, but that would:
 *     1. Enable interaction between `curve(params)` and `curve(params)` (curves of same params)
 *     which is hard to debug.
 *     2. Params can be generic and we can't enforce them to be constant value:
 *     if somebody creates curve from non-constant params,
 *     it would be allowed to interact with other curves with non-constant params
 *
 * @todo https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-7.html#unique-symbol
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $JlvR0 = parcelRequire("JlvR0");

var $1RHo6 = parcelRequire("1RHo6");

var $lBKww = parcelRequire("lBKww");
function $75428c2a37621dad$var$validateSigVerOpts(opts) {
    if (opts.lowS !== undefined) (0, $lBKww.abool)("lowS", opts.lowS);
    if (opts.prehash !== undefined) (0, $lBKww.abool)("prehash", opts.prehash);
}
function $75428c2a37621dad$var$validatePointOpts(curve) {
    const opts = (0, $JlvR0.validateBasic)(curve);
    $lBKww.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("invalid endomorphism, can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("invalid endomorphism, expected beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
const { bytesToNumberBE: $75428c2a37621dad$var$b2n, hexToBytes: $75428c2a37621dad$var$h2b } = $lBKww;
class $75428c2a37621dad$export$523a36accd0afb37 extends Error {
    constructor(m = ""){
        super(m);
    }
}
const $75428c2a37621dad$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: $75428c2a37621dad$export$523a36accd0afb37,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = $75428c2a37621dad$export$56ac33195d7076db;
            if (tag < 0 || tag > 256) throw new E("tlv.encode: wrong tag");
            if (data.length & 1) throw new E("tlv.encode: unpadded data");
            const dataLen = data.length / 2;
            const len = $lBKww.numberToHexUnpadded(dataLen);
            if (len.length / 2 & 128) throw new E("tlv.encode: long form length too big");
            // length of length with long form flag
            const lenLen = dataLen > 127 ? $lBKww.numberToHexUnpadded(len.length / 2 | 128) : "";
            const t = $lBKww.numberToHexUnpadded(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = $75428c2a37621dad$export$56ac33195d7076db;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E("tlv.encode: wrong tag");
            if (data.length < 2 || data[pos++] !== tag) throw new E("tlv.decode: wrong tlv");
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E("tlv.decode(long): indefinite length not supported");
                if (lenLen > 4) throw new E("tlv.decode(long): byte length is too big"); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E("tlv.decode: length bytes not complete");
                if (lengthBytes[0] === 0) throw new E("tlv.decode(long): zero leftmost byte");
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E("tlv.decode(long): not minimal encoding");
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E("tlv.decode: wrong value length");
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = $75428c2a37621dad$export$56ac33195d7076db;
            if (num < $75428c2a37621dad$var$_0n) throw new E("integer: negative integers are not allowed");
            let hex = $lBKww.numberToHexUnpadded(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = "00" + hex;
            if (hex.length & 1) throw new E("unexpected DER parsing assertion: unpadded hex");
            return hex;
        },
        decode (data) {
            const { Err: E } = $75428c2a37621dad$export$56ac33195d7076db;
            if (data[0] & 128) throw new E("invalid signature integer: negative");
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E("invalid signature integer: unnecessary leading zero");
            return $75428c2a37621dad$var$b2n(data);
        }
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = $75428c2a37621dad$export$56ac33195d7076db;
        const data = typeof hex === "string" ? $75428c2a37621dad$var$h2b(hex) : hex;
        $lBKww.abytes(data);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E("invalid signature: left bytes after parsing");
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E("invalid signature: left bytes after parsing");
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = $75428c2a37621dad$export$56ac33195d7076db;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $75428c2a37621dad$var$_0n = BigInt(0), $75428c2a37621dad$var$_1n = BigInt(1), $75428c2a37621dad$var$_2n = BigInt(2), $75428c2a37621dad$var$_3n = BigInt(3), $75428c2a37621dad$var$_4n = BigInt(4);
function $75428c2a37621dad$export$fa783af82e4fe0fc(opts) {
    const CURVE = $75428c2a37621dad$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const Fn = (0, $1RHo6.Field)(CURVE.n, CURVE.nBitLength);
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $lBKww.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return $lBKww.inRange(num, $75428c2a37621dad$var$_1n, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: N } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if ($lBKww.isBytes(key)) key = $lBKww.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("invalid private key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $lBKww.bytesToNumberBE((0, $lBKww.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error("invalid private key, expected hex or " + nByteLength + " bytes, got " + typeof key);
        }
        if (wrapPrivateKey) num = (0, $1RHo6.mod)(num, N); // disabled by default, enabled for BLS
        $lBKww.aInRange("private key", num, $75428c2a37621dad$var$_1n, N); // num in range [1..N-1]
        return num;
    }
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    const toAffineMemo = (0, $lBKww.memoized)((p, iz)=>{
        const { px: x, py: y, pz: z } = p;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE)) return {
            x: x,
            y: y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
        const ax = Fp.mul(x, iz);
        const ay = Fp.mul(y, iz);
        const zz = Fp.mul(z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $lBKww.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py)) return;
            throw new Error("bad point: ZERO");
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
        if (!p.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
            Object.freeze(this);
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $lBKww.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return (0, $JlvR0.pippenger)(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $75428c2a37621dad$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $75428c2a37621dad$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            const { endo: endo, n: N } = CURVE;
            $lBKww.aInRange("scalar", sc, $75428c2a37621dad$var$_0n, N);
            const I = Point.ZERO;
            if (sc === $75428c2a37621dad$var$_0n) return I;
            if (this.is0() || sc === $75428c2a37621dad$var$_1n) return this;
            // Case a: no endomorphism. Case b: has precomputes.
            if (!endo || wnaf.hasPrecomputes(this)) return wnaf.wNAFCachedUnsafe(this, sc, Point.normalizeZ);
            // Case c: endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(sc);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $75428c2a37621dad$var$_0n || k2 > $75428c2a37621dad$var$_0n){
                if (k1 & $75428c2a37621dad$var$_1n) k1p = k1p.add(d);
                if (k2 & $75428c2a37621dad$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $75428c2a37621dad$var$_1n;
                k2 >>= $75428c2a37621dad$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo, n: N } = CURVE;
            $lBKww.aInRange("scalar", scalar, $75428c2a37621dad$var$_1n, N);
            let point, fake; // Fake point is used to const-time mult
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(scalar);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $75428c2a37621dad$var$_0n || a === $75428c2a37621dad$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $75428c2a37621dad$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $75428c2a37621dad$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            (0, $lBKww.abool)("isCompressed", isCompressed);
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            (0, $lBKww.abool)("isCompressed", isCompressed);
            return $lBKww.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $JlvR0.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $75428c2a37621dad$var$validateOpts(curve) {
    const opts = (0, $JlvR0.validateBasic)(curve);
    $lBKww.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $75428c2a37621dad$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $75428c2a37621dad$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return (0, $1RHo6.mod)(a, CURVE_ORDER);
    }
    function invN(a) {
        return (0, $1RHo6.invert)(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $75428c2a37621dad$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $lBKww.concatBytes;
            (0, $lBKww.abool)("isCompressed", isCompressed);
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $lBKww.bytesToNumberBE(tail);
                if (!$lBKww.inRange(x, $75428c2a37621dad$var$_1n, Fp.ORDER)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                const isYOdd = (y & $75428c2a37621dad$var$_1n) === $75428c2a37621dad$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else {
                const cl = compressedLen;
                const ul = uncompressedLen;
                throw new Error("invalid Point, expected length of " + cl + ", or uncompressed " + ul + ", got " + len);
            }
        }
    });
    const numToNByteStr = (num)=>$lBKww.bytesToHex($lBKww.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $75428c2a37621dad$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$lBKww.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $lBKww.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $75428c2a37621dad$export$56ac33195d7076db.toSig((0, $lBKww.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            $lBKww.aInRange("r", this.r, $75428c2a37621dad$var$_1n, CURVE_ORDER); // r in [1..N]
            $lBKww.aInRange("s", this.s, $75428c2a37621dad$var$_1n, CURVE_ORDER); // s in [1..N]
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $lBKww.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $lBKww.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $75428c2a37621dad$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $lBKww.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = (0, $1RHo6.getMinHashLength)(CURVE.n);
            return (0, $1RHo6.mapHashToField)(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $lBKww.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // Our custom check "just in case"
        if (bytes.length > 8192) throw new Error("input is too large");
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $lBKww.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $lBKww.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        $lBKww.aInRange("num < 2^" + CURVE.nBitLength, num, $75428c2a37621dad$var$_0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return $lBKww.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order,
    // this will be invalid at least for P521. Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $lBKww.ensureBytes)("msgHash", msgHash);
        $75428c2a37621dad$var$validateSigVerOpts(opts);
        if (prehash) msgHash = (0, $lBKww.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $lBKww.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $lBKww.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $75428c2a37621dad$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $75428c2a37621dad$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $75428c2a37621dad$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $lBKww.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $lBKww.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $lBKww.ensureBytes)("publicKey", publicKey);
        const { lowS: lowS, prehash: prehash, format: format } = opts;
        // Verify opts, deduce signature format
        $75428c2a37621dad$var$validateSigVerOpts(opts);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        if (format !== undefined && format !== "compact" && format !== "der") throw new Error("format must be compact or der");
        const isHex = typeof sg === "string" || $lBKww.isBytes(sg);
        const isObj = !isHex && !format && typeof sg === "object" && sg !== null && typeof sg.r === "bigint" && typeof sg.s === "bigint";
        if (!isHex && !isObj) throw new Error("invalid signature, expected Uint8Array, hex string or Signature instance");
        let _sig = undefined;
        let P;
        try {
            if (isObj) _sig = new Signature(sg.r, sg.s);
            if (isHex) {
                // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
                // Since DER can also be 2*nByteLength bytes, we check for it first.
                try {
                    if (format !== "compact") _sig = Signature.fromDER(sg);
                } catch (derError) {
                    if (!(derError instanceof $75428c2a37621dad$export$56ac33195d7076db.Err)) throw derError;
                }
                if (!_sig && format !== "der") _sig = Signature.fromCompact(sg);
            }
            P = Point.fromHex(publicKey);
        } catch (error) {
            return false;
        }
        if (!_sig) return false;
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $75428c2a37621dad$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $75428c2a37621dad$var$_0n;
    for(let o = q - $75428c2a37621dad$var$_1n; o % $75428c2a37621dad$var$_2n === $75428c2a37621dad$var$_0n; o /= $75428c2a37621dad$var$_2n)l += $75428c2a37621dad$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $75428c2a37621dad$var$_2n << c1 - $75428c2a37621dad$var$_1n - $75428c2a37621dad$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $75428c2a37621dad$var$_2n;
    const c2 = (q - $75428c2a37621dad$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $75428c2a37621dad$var$_1n) / $75428c2a37621dad$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $75428c2a37621dad$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $75428c2a37621dad$var$_1n) / $75428c2a37621dad$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $75428c2a37621dad$var$_1n; i--){
            let tv5 = i - $75428c2a37621dad$var$_2n; // 18.    tv5 = i - 2
            tv5 = $75428c2a37621dad$var$_2n << tv5 - $75428c2a37621dad$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $75428c2a37621dad$var$_4n === $75428c2a37621dad$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $75428c2a37621dad$var$_3n) / $75428c2a37621dad$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $75428c2a37621dad$export$cc7fea9756a17416(Fp, opts) {
    (0, $1RHo6.validateField)(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $75428c2a37621dad$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});
parcelRegister("JlvR0", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "pippenger", function () { return pippenger; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $1RHo6 = parcelRequire("1RHo6");

var $lBKww = parcelRequire("lBKww");
const _0n = BigInt(0);
const _1n = BigInt(1);
function constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error("invalid window size, expected [1.." + bits + "], got W=" + W);
}
function calcWOpts(W, bits) {
    validateW(W, bits);
    const windows = Math.ceil(bits / W) + 1; // +1, because
    const windowSize = 2 ** (W - 1); // -1 because we skip zero
    return {
        windows: windows,
        windowSize: windowSize
    };
}
function validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error("array expected");
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error("invalid point at index " + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error("array of scalars expected");
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error("invalid scalar at index " + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
function getW(P) {
    return pointWindowSizes.get(P) || 1;
}
function wNAF(c, bits) {
    return {
        constTimeNegate: constTimeNegate,
        hasPrecomputes (elm) {
            return getW(elm) !== 1;
        },
        // non-const time multiplication ladder
        unsafeLadder (elm, n, p = c.ZERO) {
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @param elm Point instance
         * @param W window size
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = calcWOpts(W, bits);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        /**
         * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @param acc accumulator point to add result of multiplication
         * @returns point
         */ wNAFUnsafe (W, precomputes, n, acc = c.ZERO) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                if (n === _0n) break; // No need to go over empty scalar
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                if (wbits === 0) continue;
                let curr = precomputes[offset + Math.abs(wbits) - 1]; // -1 because we skip zero
                if (wbits < 0) curr = curr.negate();
                // NOTE: by re-using acc, we can save a lot of additions in case of MSM
                acc = acc.add(curr);
            }
            return acc;
        },
        getPrecomputes (W, P, transform) {
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return comp;
        },
        wNAFCached (P, n, transform) {
            const W = getW(P);
            return this.wNAF(W, this.getPrecomputes(W, P, transform), n);
        },
        wNAFCachedUnsafe (P, n, transform, prev) {
            const W = getW(P);
            if (W === 1) return this.unsafeLadder(P, n, prev); // For W=1 ladder is ~x2 faster
            return this.wNAFUnsafe(W, this.getPrecomputes(W, P, transform), n, prev);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize (P, W) {
            validateW(W, bits);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
function pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    if (points.length !== scalars.length) throw new Error("arrays of points and scalars must have equal length");
    const zero = c.ZERO;
    const wbits = (0, $lBKww.bitLen)(BigInt(points.length));
    const windowSize = wbits > 12 ? wbits - 3 : wbits > 4 ? wbits - 2 : wbits ? 2 : 1; // in bits
    const MASK = (1 << windowSize) - 1;
    const buckets = new Array(MASK + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < scalars.length; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & BigInt(MASK));
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
function precomputeMSMUnsafe(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ validateW(windowSize, fieldN.BITS);
    validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = BigInt((1 << windowSize) - 1);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error("array of scalars must be smaller than array of points");
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function validateBasic(curve) {
    (0, $1RHo6.validateField)(curve.Fp);
    (0, $lBKww.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $1RHo6.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("1RHo6", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $15bc659528219973$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow2", function () { return $15bc659528219973$export$fa569bd808b67eef; });
$parcel$export(module.exports, "invert", function () { return $15bc659528219973$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "validateField", function () { return $15bc659528219973$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $15bc659528219973$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $15bc659528219973$export$a455218a85c89869; });
$parcel$export(module.exports, "getMinHashLength", function () { return $15bc659528219973$export$d058763b563056af; });
$parcel$export(module.exports, "mapHashToField", function () { return $15bc659528219973$export$20cb21dbfa61dac3; });
/**
 * Utils for modular division and finite fields.
 * A finite field over 11 is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $lBKww = parcelRequire("lBKww");
// prettier-ignore
const $15bc659528219973$var$_0n = BigInt(0), $15bc659528219973$var$_1n = BigInt(1), $15bc659528219973$var$_2n = /* @__PURE__ */ BigInt(2), $15bc659528219973$var$_3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const $15bc659528219973$var$_4n = /* @__PURE__ */ BigInt(4), $15bc659528219973$var$_5n = /* @__PURE__ */ BigInt(5), $15bc659528219973$var$_8n = /* @__PURE__ */ BigInt(8);
// prettier-ignore
const $15bc659528219973$var$_9n = /* @__PURE__ */ BigInt(9), $15bc659528219973$var$_16n = /* @__PURE__ */ BigInt(16);
function $15bc659528219973$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $15bc659528219973$var$_0n ? result : b + result;
}
function $15bc659528219973$export$9c297f60e22e3389(num, power, modulo) {
    if (power < $15bc659528219973$var$_0n) throw new Error("invalid exponent, negatives unsupported");
    if (modulo <= $15bc659528219973$var$_0n) throw new Error("invalid modulus");
    if (modulo === $15bc659528219973$var$_1n) return $15bc659528219973$var$_0n;
    let res = $15bc659528219973$var$_1n;
    while(power > $15bc659528219973$var$_0n){
        if (power & $15bc659528219973$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $15bc659528219973$var$_1n;
    }
    return res;
}
function $15bc659528219973$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $15bc659528219973$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $15bc659528219973$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $15bc659528219973$var$_0n) throw new Error("invert: expected non-zero number");
    if (modulo <= $15bc659528219973$var$_0n) throw new Error("invert: expected positive modulus, got " + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $15bc659528219973$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $15bc659528219973$var$_0n, y = $15bc659528219973$var$_1n, u = $15bc659528219973$var$_1n, v = $15bc659528219973$var$_0n;
    while(a !== $15bc659528219973$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $15bc659528219973$var$_1n) throw new Error("invert: does not exist");
    return $15bc659528219973$export$842a2cf37af977e1(x, modulo);
}
function $15bc659528219973$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $15bc659528219973$var$_1n) / $15bc659528219973$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $15bc659528219973$var$_1n, S = 0; Q % $15bc659528219973$var$_2n === $15bc659528219973$var$_0n; Q /= $15bc659528219973$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $15bc659528219973$var$_2n; Z < P && $15bc659528219973$export$9c297f60e22e3389(Z, legendreC, P) !== P - $15bc659528219973$var$_1n; Z++){
        // Crash instead of infinity loop, we cannot reasonable count until P.
        if (Z > 1000) throw new Error("Cannot find square root: likely non-prime P");
    }
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $15bc659528219973$var$_1n) / $15bc659528219973$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $15bc659528219973$var$_1n) / $15bc659528219973$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $15bc659528219973$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $15bc659528219973$export$33bda048c6b8ea7d(P) {
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $15bc659528219973$var$_4n === $15bc659528219973$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $15bc659528219973$var$_1n) / $15bc659528219973$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $15bc659528219973$var$_8n === $15bc659528219973$var$_5n) {
        const c1 = (P - $15bc659528219973$var$_5n) / $15bc659528219973$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $15bc659528219973$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $15bc659528219973$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $15bc659528219973$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $15bc659528219973$export$69f29ab1f3e9a234(P);
}
const $15bc659528219973$export$7806f13ad5078b2f = (num, modulo)=>($15bc659528219973$export$842a2cf37af977e1(num, modulo) & $15bc659528219973$var$_1n) === $15bc659528219973$var$_1n;
// prettier-ignore
const $15bc659528219973$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $15bc659528219973$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $15bc659528219973$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $lBKww.validateObject)(field, opts);
}
function $15bc659528219973$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $15bc659528219973$var$_0n) throw new Error("invalid exponent, negatives unsupported");
    if (power === $15bc659528219973$var$_0n) return f.ONE;
    if (power === $15bc659528219973$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $15bc659528219973$var$_0n){
        if (power & $15bc659528219973$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $15bc659528219973$var$_1n;
    }
    return p;
}
function $15bc659528219973$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $15bc659528219973$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $15bc659528219973$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $15bc659528219973$export$77ed22730026dd0d(order) {
    const legendreConst = (order - $15bc659528219973$var$_1n) / $15bc659528219973$var$_2n; // Integer arithmetic
    return (f, x)=>f.pow(x, legendreConst);
}
function $15bc659528219973$export$5e2b6e87f2891ea7(f) {
    const legendre = $15bc659528219973$export$77ed22730026dd0d(f.ORDER);
    return (x)=>{
        const p = legendre(f, x);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $15bc659528219973$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $15bc659528219973$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $15bc659528219973$var$_0n) throw new Error("invalid field: expected ORDER > 0, got " + ORDER);
    const { nBitLength: BITS, nByteLength: BYTES } = $15bc659528219973$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER: ORDER,
        isLE: isLE,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $lBKww.bitMask)(BITS),
        ZERO: $15bc659528219973$var$_0n,
        ONE: $15bc659528219973$var$_1n,
        create: (num)=>$15bc659528219973$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error("invalid field element: expected bigint, got " + typeof num);
            return $15bc659528219973$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $15bc659528219973$var$_0n,
        isOdd: (num)=>(num & $15bc659528219973$var$_1n) === $15bc659528219973$var$_1n,
        neg: (num)=>$15bc659528219973$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$15bc659528219973$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$15bc659528219973$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$15bc659528219973$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$15bc659528219973$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$15bc659528219973$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$15bc659528219973$export$842a2cf37af977e1(lhs * $15bc659528219973$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$15bc659528219973$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>{
            if (!sqrtP) sqrtP = $15bc659528219973$export$33bda048c6b8ea7d(ORDER);
            return sqrtP(f, n);
        }),
        invertBatch: (lst)=>$15bc659528219973$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $lBKww.numberToBytesLE)(num, BYTES) : (0, $lBKww.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error("Field.fromBytes: expected " + BYTES + " bytes, got " + bytes.length);
            return isLE ? (0, $lBKww.bytesToNumberLE)(bytes) : (0, $lBKww.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $15bc659528219973$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $15bc659528219973$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $15bc659528219973$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $lBKww.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $15bc659528219973$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error("hashToPrivateScalar: expected " + minLen + "-1024 bytes of input, got " + hashLen);
    const num = isLE ? (0, $lBKww.bytesToNumberLE)(hash) : (0, $lBKww.bytesToNumberBE)(hash);
    return $15bc659528219973$export$842a2cf37af977e1(num, groupOrder - $15bc659528219973$var$_1n) + $15bc659528219973$var$_1n;
}
function $15bc659528219973$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $15bc659528219973$export$d058763b563056af(fieldOrder) {
    const length = $15bc659528219973$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $15bc659528219973$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $15bc659528219973$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $15bc659528219973$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error("expected " + minLen + "-1024 bytes of input, got " + len);
    const num = isLE ? (0, $lBKww.bytesToNumberLE)(key) : (0, $lBKww.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $15bc659528219973$export$842a2cf37af977e1(num, fieldOrder - $15bc659528219973$var$_1n) + $15bc659528219973$var$_1n;
    return isLE ? (0, $lBKww.numberToBytesLE)(reduced, fieldLen) : (0, $lBKww.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("lBKww", function(module, exports) {

$parcel$export(module.exports, "isBytes", function () { return $fbb124421e810011$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "abytes", function () { return $fbb124421e810011$export$e8a750b9efad93f5; });
$parcel$export(module.exports, "abool", function () { return $fbb124421e810011$export$809304d28d77d92d; });
$parcel$export(module.exports, "bytesToHex", function () { return $fbb124421e810011$export$58b867e287a802c8; });
$parcel$export(module.exports, "numberToHexUnpadded", function () { return $fbb124421e810011$export$4ed2545b622827c1; });
$parcel$export(module.exports, "hexToNumber", function () { return $fbb124421e810011$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBytes", function () { return $fbb124421e810011$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $fbb124421e810011$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $fbb124421e810011$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $fbb124421e810011$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $fbb124421e810011$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "numberToVarBytesBE", function () { return $fbb124421e810011$export$80ee8c1914de6dde; });
$parcel$export(module.exports, "ensureBytes", function () { return $fbb124421e810011$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $fbb124421e810011$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $fbb124421e810011$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $fbb124421e810011$export$3df70a15530b5e81; });
$parcel$export(module.exports, "inRange", function () { return $fbb124421e810011$export$ddf89a9c5af38f94; });
$parcel$export(module.exports, "aInRange", function () { return $fbb124421e810011$export$86cc12b5dde3c1e4; });
$parcel$export(module.exports, "bitLen", function () { return $fbb124421e810011$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitGet", function () { return $fbb124421e810011$export$9577d112d1fd46ad; });
$parcel$export(module.exports, "bitSet", function () { return $fbb124421e810011$export$967bb2b9787441cb; });
$parcel$export(module.exports, "bitMask", function () { return $fbb124421e810011$export$803efa2fa1c7279; });
$parcel$export(module.exports, "createHmacDrbg", function () { return $fbb124421e810011$export$d459d139192e4fba; });
$parcel$export(module.exports, "validateObject", function () { return $fbb124421e810011$export$381bae2d0f08004f; });
$parcel$export(module.exports, "notImplemented", function () { return $fbb124421e810011$export$94a5f06e658f87e2; });
$parcel$export(module.exports, "memoized", function () { return $fbb124421e810011$export$9756366f7cb6f62b; });
/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $fbb124421e810011$var$_0n = /* @__PURE__ */ BigInt(0);
const $fbb124421e810011$var$_1n = /* @__PURE__ */ BigInt(1);
const $fbb124421e810011$var$_2n = /* @__PURE__ */ BigInt(2);
function $fbb124421e810011$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $fbb124421e810011$export$e8a750b9efad93f5(item) {
    if (!$fbb124421e810011$export$c6fabfbfd097fc30(item)) throw new Error("Uint8Array expected");
}
function $fbb124421e810011$export$809304d28d77d92d(title, value) {
    if (typeof value !== "boolean") throw new Error(title + " boolean expected, got " + value);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $fbb124421e810011$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $fbb124421e810011$export$58b867e287a802c8(bytes) {
    $fbb124421e810011$export$e8a750b9efad93f5(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $fbb124421e810011$var$hexes[bytes[i]];
    return hex;
}
function $fbb124421e810011$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? "0" + hex : hex;
}
function $fbb124421e810011$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    return hex === "" ? $fbb124421e810011$var$_0n : BigInt("0x" + hex); // Big Endian
}
// We use optimized technique to convert hex string to byte array
const $fbb124421e810011$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $fbb124421e810011$var$asciiToBase16(ch) {
    if (ch >= $fbb124421e810011$var$asciis._0 && ch <= $fbb124421e810011$var$asciis._9) return ch - $fbb124421e810011$var$asciis._0; // '2' => 50-48
    if (ch >= $fbb124421e810011$var$asciis.A && ch <= $fbb124421e810011$var$asciis.F) return ch - ($fbb124421e810011$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $fbb124421e810011$var$asciis.a && ch <= $fbb124421e810011$var$asciis.f) return ch - ($fbb124421e810011$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $fbb124421e810011$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $fbb124421e810011$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $fbb124421e810011$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
function $fbb124421e810011$export$d609354794974f8(bytes) {
    return $fbb124421e810011$export$d57f2bacc26b4249($fbb124421e810011$export$58b867e287a802c8(bytes));
}
function $fbb124421e810011$export$d67b1d03392107e7(bytes) {
    $fbb124421e810011$export$e8a750b9efad93f5(bytes);
    return $fbb124421e810011$export$d57f2bacc26b4249($fbb124421e810011$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $fbb124421e810011$export$1459dafd057611cb(n, len) {
    return $fbb124421e810011$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $fbb124421e810011$export$ba2172e58d139f6d(n, len) {
    return $fbb124421e810011$export$1459dafd057611cb(n, len).reverse();
}
function $fbb124421e810011$export$80ee8c1914de6dde(n) {
    return $fbb124421e810011$export$31c96b9df38bc8d4($fbb124421e810011$export$4ed2545b622827c1(n));
}
function $fbb124421e810011$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $fbb124421e810011$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(title + " must be hex string or Uint8Array, cause: " + e);
    }
    else if ($fbb124421e810011$export$c6fabfbfd097fc30(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + " must be hex string or Uint8Array");
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(title + " of length " + expectedLength + " expected, got " + len);
    return res;
}
function $fbb124421e810011$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $fbb124421e810011$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $fbb124421e810011$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $fbb124421e810011$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const $fbb124421e810011$var$isPosBig = (n)=>typeof n === "bigint" && $fbb124421e810011$var$_0n <= n;
function $fbb124421e810011$export$ddf89a9c5af38f94(n, min, max) {
    return $fbb124421e810011$var$isPosBig(n) && $fbb124421e810011$var$isPosBig(min) && $fbb124421e810011$var$isPosBig(max) && min <= n && n < max;
}
function $fbb124421e810011$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$fbb124421e810011$export$ddf89a9c5af38f94(n, min, max)) throw new Error("expected valid " + title + ": " + min + " <= n < " + max + ", got " + n);
}
function $fbb124421e810011$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $fbb124421e810011$var$_0n; n >>= $fbb124421e810011$var$_1n, len += 1);
    return len;
}
function $fbb124421e810011$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $fbb124421e810011$var$_1n;
}
function $fbb124421e810011$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $fbb124421e810011$var$_1n : $fbb124421e810011$var$_0n) << BigInt(pos);
}
const $fbb124421e810011$export$803efa2fa1c7279 = (n)=>($fbb124421e810011$var$_2n << BigInt(n - 1)) - $fbb124421e810011$var$_1n;
// DRBG
const $fbb124421e810011$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $fbb124421e810011$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $fbb124421e810011$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $fbb124421e810011$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $fbb124421e810011$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $fbb124421e810011$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($fbb124421e810011$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($fbb124421e810011$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $fbb124421e810011$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $fbb124421e810011$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $fbb124421e810011$export$c6fabfbfd097fc30(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $fbb124421e810011$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $fbb124421e810011$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error("invalid validator function");
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error("param " + String(fieldName) + " is invalid. Expected " + type + ", got " + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
const $fbb124421e810011$export$94a5f06e658f87e2 = ()=>{
    throw new Error("not implemented");
};
function $fbb124421e810011$export$9756366f7cb6f62b(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});





parcelRegister("7yBGq", function(module, exports) {

$parcel$export(module.exports, "isogenyMap", function () { return $5808f07b65f1ff8b$export$9393380cf1075f28; });
$parcel$export(module.exports, "createHasher", function () { return $5808f07b65f1ff8b$export$14b114effbc08b6b; });

var $1RHo6 = parcelRequire("1RHo6");

var $lBKww = parcelRequire("lBKww");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $5808f07b65f1ff8b$var$os2ip = (0, $lBKww.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $5808f07b65f1ff8b$var$i2osp(value, length) {
    $5808f07b65f1ff8b$var$anum(value);
    $5808f07b65f1ff8b$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error("invalid I2OSP input: " + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $5808f07b65f1ff8b$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $5808f07b65f1ff8b$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $5808f07b65f1ff8b$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $lBKww.abytes)(msg);
    (0, $lBKww.abytes)(DST);
    $5808f07b65f1ff8b$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $lBKww.concatBytes)((0, $lBKww.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error("expand_message_xmd: invalid lenInBytes");
    const DST_prime = (0, $lBKww.concatBytes)(DST, $5808f07b65f1ff8b$var$i2osp(DST.length, 1));
    const Z_pad = $5808f07b65f1ff8b$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $5808f07b65f1ff8b$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $lBKww.concatBytes)(Z_pad, msg, l_i_b_str, $5808f07b65f1ff8b$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $lBKww.concatBytes)(b_0, $5808f07b65f1ff8b$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $5808f07b65f1ff8b$var$strxor(b_0, b[i - 1]),
            $5808f07b65f1ff8b$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $lBKww.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $lBKww.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $5808f07b65f1ff8b$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $lBKww.abytes)(msg);
    (0, $lBKww.abytes)(DST);
    $5808f07b65f1ff8b$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $lBKww.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($5808f07b65f1ff8b$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($5808f07b65f1ff8b$var$i2osp(DST.length, 1)).digest();
}
function $5808f07b65f1ff8b$export$97cdd5ee18de8172(msg, count, options) {
    (0, $lBKww.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    (0, $lBKww.abytes)(msg);
    $5808f07b65f1ff8b$var$anum(count);
    const DST = typeof _DST === "string" ? (0, $lBKww.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $5808f07b65f1ff8b$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $5808f07b65f1ff8b$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $1RHo6.mod)($5808f07b65f1ff8b$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $5808f07b65f1ff8b$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $5808f07b65f1ff8b$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $5808f07b65f1ff8b$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $5808f07b65f1ff8b$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error("mapToCurve: expected array of bigints");
            for (const i of scalars)if (typeof i !== "bigint") throw new Error("mapToCurve: expected array of bigints");
            const P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});




parcelRegister("13kYf", function(module, exports) {

$parcel$export(module.exports, "isAddressEqual", function () { return $0c46569757ed119c$export$34ca016df7f376b8; });

var $62VqX = parcelRequire("62VqX");

var $8Ghey = parcelRequire("8Ghey");
function $0c46569757ed119c$export$34ca016df7f376b8(a, b) {
    if (!(0, $8Ghey.isAddress)(a, {
        strict: false
    })) throw new (0, $62VqX.InvalidAddressError)({
        address: a
    });
    if (!(0, $8Ghey.isAddress)(b, {
        strict: false
    })) throw new (0, $62VqX.InvalidAddressError)({
        address: b
    });
    return a.toLowerCase() === b.toLowerCase();
}

});

parcelRegister("hSwM1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $d040e6f16e02aebf$export$bf730a2d8bf68b42; }, function (v) { return $d040e6f16e02aebf$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d040e6f16e02aebf$export$bf730a2d8bf68b42;
"use strict";

var $bnENU = parcelRequire("bnENU");

var $hgGhm = parcelRequire("hgGhm");
function $d040e6f16e02aebf$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d040e6f16e02aebf$var$objectIs = "function" === typeof Object.is ? Object.is : $d040e6f16e02aebf$var$is, $d040e6f16e02aebf$var$useSyncExternalStore = $hgGhm.useSyncExternalStore, $d040e6f16e02aebf$var$useRef = $bnENU.useRef, $d040e6f16e02aebf$var$useEffect = $bnENU.useEffect, $d040e6f16e02aebf$var$useMemo = $bnENU.useMemo, $d040e6f16e02aebf$var$useDebugValue = $bnENU.useDebugValue;
$d040e6f16e02aebf$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d040e6f16e02aebf$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d040e6f16e02aebf$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d040e6f16e02aebf$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d040e6f16e02aebf$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d040e6f16e02aebf$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d040e6f16e02aebf$var$useDebugValue(value);
    return value;
};

});
parcelRegister("hgGhm", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aTguG"));

});
parcelRegister("aTguG", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $7edbd5c2e3aa4744$export$306c0aa65ff9ec16; }, function (v) { return $7edbd5c2e3aa4744$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7edbd5c2e3aa4744$export$306c0aa65ff9ec16;
"use strict";

var $bnENU = parcelRequire("bnENU");
function $7edbd5c2e3aa4744$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $7edbd5c2e3aa4744$var$objectIs = "function" === typeof Object.is ? Object.is : $7edbd5c2e3aa4744$var$is, $7edbd5c2e3aa4744$var$useState = $bnENU.useState, $7edbd5c2e3aa4744$var$useEffect = $bnENU.useEffect, $7edbd5c2e3aa4744$var$useLayoutEffect = $bnENU.useLayoutEffect, $7edbd5c2e3aa4744$var$useDebugValue = $bnENU.useDebugValue;
function $7edbd5c2e3aa4744$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $7edbd5c2e3aa4744$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $7edbd5c2e3aa4744$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $7edbd5c2e3aa4744$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $7edbd5c2e3aa4744$var$useEffect(function() {
        $7edbd5c2e3aa4744$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $7edbd5c2e3aa4744$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $7edbd5c2e3aa4744$var$useDebugValue(value);
    return value;
}
function $7edbd5c2e3aa4744$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$7edbd5c2e3aa4744$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $7edbd5c2e3aa4744$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $7edbd5c2e3aa4744$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $7edbd5c2e3aa4744$var$useSyncExternalStore$1 : $7edbd5c2e3aa4744$var$useSyncExternalStore$2;
$7edbd5c2e3aa4744$export$306c0aa65ff9ec16 = void 0 !== $bnENU.useSyncExternalStore ? $bnENU.useSyncExternalStore : $7edbd5c2e3aa4744$var$shim;

});



parcelRegister("eLDY1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93c5a1596399f68c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "EventEmitter", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("goI5y")))); });

var $goI5y = parcelRequire("goI5y");
var $93c5a1596399f68c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($goI5y)));

});
parcelRegister("goI5y", function(module, exports) {
"use strict";
var $bf01165135d42183$var$has = Object.prototype.hasOwnProperty, $bf01165135d42183$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $bf01165135d42183$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $bf01165135d42183$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $bf01165135d42183$var$Events().__proto__) $bf01165135d42183$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $bf01165135d42183$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $bf01165135d42183$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $bf01165135d42183$var$EE(fn, context || emitter, once), evt = $bf01165135d42183$var$prefix ? $bf01165135d42183$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $bf01165135d42183$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $bf01165135d42183$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $bf01165135d42183$var$EventEmitter() {
    this._events = new $bf01165135d42183$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $bf01165135d42183$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($bf01165135d42183$var$has.call(events, name)) names.push($bf01165135d42183$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $bf01165135d42183$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $bf01165135d42183$var$prefix ? $bf01165135d42183$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $bf01165135d42183$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $bf01165135d42183$var$prefix ? $bf01165135d42183$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $bf01165135d42183$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $bf01165135d42183$var$prefix ? $bf01165135d42183$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $bf01165135d42183$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $bf01165135d42183$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $bf01165135d42183$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $bf01165135d42183$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $bf01165135d42183$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $bf01165135d42183$var$prefix ? $bf01165135d42183$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $bf01165135d42183$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $bf01165135d42183$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $bf01165135d42183$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $bf01165135d42183$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $bf01165135d42183$var$prefix ? $bf01165135d42183$var$prefix + event : event;
        if (this._events[evt]) $bf01165135d42183$var$clearEvent(this, evt);
    } else {
        this._events = new $bf01165135d42183$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$bf01165135d42183$var$EventEmitter.prototype.off = $bf01165135d42183$var$EventEmitter.prototype.removeListener;
$bf01165135d42183$var$EventEmitter.prototype.addListener = $bf01165135d42183$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$bf01165135d42183$var$EventEmitter.prefixed = $bf01165135d42183$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$bf01165135d42183$var$EventEmitter.EventEmitter = $bf01165135d42183$var$EventEmitter;
module.exports = $bf01165135d42183$var$EventEmitter;

});


parcelRegister("c1sze", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3WFuy"))((parcelRequire("gm4sb")).resolve("iruWC")),
    (parcelRequire("3WFuy"))((parcelRequire("gm4sb")).resolve("cikrI"))
]).then(()=>parcelRequire("vZmee"));

});

parcelRegister("gAQsM", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("3WFuy"))((parcelRequire("gm4sb")).resolve("iruWC")),
    (parcelRequire("3WFuy"))((parcelRequire("gm4sb")).resolve("2To9q"))
]).then(()=>parcelRequire("iKNmu"));

});

parcelRegister("jNXYh", function(module, exports) {


module.exports = (parcelRequire("3WFuy"))((parcelRequire("gm4sb")).resolve("03t25")).then(()=>parcelRequire("bLyNa"));

});

parcelRegister("1ZJZa", function(module, exports) {

$parcel$export(module.exports, "PUBLIC_KEY_LENGTH", function () { return $173f28bad64492c8$export$84fc0a248cc54343; });
$parcel$export(module.exports, "PublicKey", function () { return $173f28bad64492c8$export$ca8b6604d6ce14de; });
$parcel$export(module.exports, "SIGNATURE_LENGTH_IN_BYTES", function () { return $173f28bad64492c8$export$14aee086fde78fa6; });
$parcel$export(module.exports, "VersionedMessage", function () { return $173f28bad64492c8$export$b0a61927d00ede7f; });
$parcel$export(module.exports, "TransactionInstruction", function () { return $173f28bad64492c8$export$a7a3aa8360ac9f59; });
$parcel$export(module.exports, "Transaction", function () { return $173f28bad64492c8$export$febc5573c75cefb0; });
$parcel$export(module.exports, "VersionedTransaction", function () { return $173f28bad64492c8$export$232cc3f078dcc284; });
$parcel$export(module.exports, "SystemProgram", function () { return $173f28bad64492c8$export$d8c4e17726848113; });
$parcel$export(module.exports, "Connection", function () { return $173f28bad64492c8$export$98b66c25bb38499d; });

var $gynfp = parcelRequire("gynfp");

var $1ycX9 = parcelRequire("1ycX9");

var $kn7SP = parcelRequire("kn7SP");

var $cqBHq = parcelRequire("cqBHq");

var $iIvsQ = parcelRequire("iIvsQ");

var $iBK9E = parcelRequire("iBK9E");

var $Bz0HP = parcelRequire("Bz0HP");

var $dZYIo = parcelRequire("dZYIo");

var $78ONe = parcelRequire("78ONe");

var $5iF24 = parcelRequire("5iF24");

var $e4v9r = parcelRequire("e4v9r");

var $6xU83 = parcelRequire("6xU83");

var $3ZrHu = parcelRequire("3ZrHu");
/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $173f28bad64492c8$var$generatePrivateKey = (0, $1ycX9.ed25519).utils.randomPrivateKey;
const $173f28bad64492c8$var$generateKeypair = ()=>{
    const privateScalar = (0, $1ycX9.ed25519).utils.randomPrivateKey();
    const publicKey = $173f28bad64492c8$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $173f28bad64492c8$var$getPublicKey = (0, $1ycX9.ed25519).getPublicKey;
function $173f28bad64492c8$var$isOnCurve(publicKey) {
    try {
        (0, $1ycX9.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $173f28bad64492c8$var$sign = (message, secretKey)=>(0, $1ycX9.ed25519).sign(message, secretKey.slice(0, 32));
const $173f28bad64492c8$var$verify = (0, $1ycX9.ed25519).verify;
const $173f28bad64492c8$var$toBuffer = (arr)=>{
    if ((0, $gynfp.Buffer).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $gynfp.Buffer).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $gynfp.Buffer).from(arr);
};
// Class wrapping a plain object
class $173f28bad64492c8$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $gynfp.Buffer).from((0, $iBK9E.serialize)($173f28bad64492c8$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $iBK9E.deserialize)($173f28bad64492c8$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $iBK9E.deserializeUnchecked)($173f28bad64492c8$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $173f28bad64492c8$export$deb82508dd66d288 extends $173f28bad64492c8$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = "";
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $173f28bad64492c8$export$68d13ce9b4cc48f3 = new Map();
var $173f28bad64492c8$var$_PublicKey;
/**
 * Maximum length of derived pubkey seed
 */ const $173f28bad64492c8$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $173f28bad64492c8$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $173f28bad64492c8$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $173f28bad64492c8$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ class $173f28bad64492c8$export$ca8b6604d6ce14de extends $173f28bad64492c8$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($173f28bad64492c8$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).decode(value);
                if (decoded.length != $173f28bad64492c8$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($kn7SP)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($kn7SP)))(value);
            if (this._bn.byteLength() > $173f28bad64492c8$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $173f28bad64492c8$export$ca8b6604d6ce14de($173f28bad64492c8$var$uniquePublicKeyCounter);
        $173f28bad64492c8$var$uniquePublicKeyCounter += 1;
        return new $173f28bad64492c8$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $gynfp.Buffer));
        if (b.length === $173f28bad64492c8$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $gynfp.Buffer).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [Symbol.toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $gynfp.Buffer).concat([
            fromPublicKey.toBuffer(),
            (0, $gynfp.Buffer).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $iIvsQ.sha256)(buffer);
        return new $173f28bad64492c8$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $gynfp.Buffer).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $173f28bad64492c8$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $gynfp.Buffer).concat([
                buffer,
                $173f28bad64492c8$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $gynfp.Buffer).concat([
            buffer,
            programId.toBuffer(),
            (0, $gynfp.Buffer).from("ProgramDerivedAddress")
        ]);
        const publicKeyBytes = (0, $iIvsQ.sha256)(buffer);
        if ($173f28bad64492c8$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $173f28bad64492c8$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $gynfp.Buffer).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $173f28bad64492c8$export$ca8b6604d6ce14de(pubkeyData);
        return $173f28bad64492c8$var$isOnCurve(pubkey.toBytes());
    }
}
$173f28bad64492c8$var$_PublicKey = $173f28bad64492c8$export$ca8b6604d6ce14de;
$173f28bad64492c8$export$ca8b6604d6ce14de.default = new $173f28bad64492c8$var$_PublicKey("11111111111111111111111111111111");
$173f28bad64492c8$export$68d13ce9b4cc48f3.set($173f28bad64492c8$export$ca8b6604d6ce14de, {
    kind: "struct",
    fields: [
        [
            "_bn",
            "u256"
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $173f28bad64492c8$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $173f28bad64492c8$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error("bad secret key size");
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $173f28bad64492c8$var$toBuffer($173f28bad64492c8$var$generatePrivateKey());
            this._publicKey = $173f28bad64492c8$var$toBuffer($173f28bad64492c8$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $173f28bad64492c8$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $gynfp.Buffer).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $173f28bad64492c8$export$42bd37c1c64962b6 = new $173f28bad64492c8$export$ca8b6604d6ce14de("BPFLoader1111111111111111111111111111111111");
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $173f28bad64492c8$export$4c6d5b89e1596f26 = 1232;
const $173f28bad64492c8$export$3c3793d809f8b858 = 0x7f;
const $173f28bad64492c8$export$14aee086fde78fa6 = 64;
class $173f28bad64492c8$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($173f28bad64492c8$export$718fcd78527f88ed.prototype, "name", {
    value: "TransactionExpiredBlockheightExceededError"
});
class $173f28bad64492c8$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + "unknown if it succeeded or failed. Check signature " + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($173f28bad64492c8$export$b822204c22e46bdf.prototype, "name", {
    value: "TransactionExpiredTimeoutError"
});
class $173f28bad64492c8$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($173f28bad64492c8$export$a3e7565a95f5a1e5.prototype, "name", {
    value: "TransactionExpiredNonceInvalidError"
});
class $173f28bad64492c8$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error("Account index overflow encountered during compilation");
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error("Encountered an unknown instruction account key during compilation");
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $173f28bad64492c8$var$publicKey = (property = "publicKey")=>{
    return $Bz0HP.blob(32, property);
};
/**
 * Layout for a signature
 */ const $173f28bad64492c8$var$signature = (property = "signature")=>{
    return $Bz0HP.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $173f28bad64492c8$var$rustString = (property = "string")=>{
    const rsl = $Bz0HP.struct([
        $Bz0HP.u32("length"),
        $Bz0HP.u32("lengthPadding"),
        $Bz0HP.blob($Bz0HP.offset($Bz0HP.u32(), -8), "chars")
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data["chars"].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $gynfp.Buffer).from(str, "utf8")
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $Bz0HP.u32().span + $Bz0HP.u32().span + (0, $gynfp.Buffer).from(str, "utf8").length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $173f28bad64492c8$var$authorized = (property = "authorized")=>{
    return $Bz0HP.struct([
        $173f28bad64492c8$var$publicKey("staker"),
        $173f28bad64492c8$var$publicKey("withdrawer")
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $173f28bad64492c8$var$lockup = (property = "lockup")=>{
    return $Bz0HP.struct([
        $Bz0HP.ns64("unixTimestamp"),
        $Bz0HP.ns64("epoch"),
        $173f28bad64492c8$var$publicKey("custodian")
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $173f28bad64492c8$var$voteInit = (property = "voteInit")=>{
    return $Bz0HP.struct([
        $173f28bad64492c8$var$publicKey("nodePubkey"),
        $173f28bad64492c8$var$publicKey("authorizedVoter"),
        $173f28bad64492c8$var$publicKey("authorizedWithdrawer"),
        $Bz0HP.u8("commission")
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $173f28bad64492c8$var$voteAuthorizeWithSeedArgs = (property = "voteAuthorizeWithSeedArgs")=>{
    return $Bz0HP.struct([
        $Bz0HP.u32("voteAuthorizationType"),
        $173f28bad64492c8$var$publicKey("currentAuthorityDerivedKeyOwnerPubkey"),
        $173f28bad64492c8$var$rustString("currentAuthorityDerivedKeySeed"),
        $173f28bad64492c8$var$publicKey("newAuthorized")
    ], property);
};
function $173f28bad64492c8$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === "function") return item.alloc(fields[item.property]);
        else if ("count" in item && "elementLayout" in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ("fields" in item) // This is a `Structure` whose size needs to be recursively measured.
        return $173f28bad64492c8$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $173f28bad64492c8$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $173f28bad64492c8$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $173f28bad64492c8$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
class $173f28bad64492c8$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $173f28bad64492c8$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $173f28bad64492c8$var$assert(mapEntries.length <= 256, "Max static account keys length exceeded");
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $173f28bad64492c8$var$assert(writableSigners.length > 0, "Expected at least one writable signer key");
            const [payerAddress] = writableSigners[0];
            $173f28bad64492c8$var$assert(payerAddress === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $173f28bad64492c8$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $173f28bad64492c8$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $173f28bad64492c8$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $173f28bad64492c8$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $173f28bad64492c8$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $173f28bad64492c8$var$assert(lookupTableIndex < 256, "Max lookup table index exceeded");
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
const $173f28bad64492c8$var$END_OF_BUFFER_ERROR_MESSAGE = "Reached end of buffer unexpectedly";
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $173f28bad64492c8$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($173f28bad64492c8$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $173f28bad64492c8$var$guardedSplice(byteArray, ...args) {
    const [start] = args;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + (args[1] ?? 0) > byteArray.length : start >= byteArray.length) throw new Error($173f28bad64492c8$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.splice(...args);
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $173f28bad64492c8$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $173f28bad64492c8$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return "legacy";
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $173f28bad64492c8$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $173f28bad64492c8$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $173f28bad64492c8$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).encode(ix.data)
            }));
        return new $173f28bad64492c8$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $173f28bad64492c8$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).decode(instruction.data));
            let keyIndicesCount = [];
            $173f28bad64492c8$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $173f28bad64492c8$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $gynfp.Buffer).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $gynfp.Buffer).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $173f28bad64492c8$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $gynfp.Buffer).alloc($173f28bad64492c8$export$4c6d5b89e1596f26);
        (0, $gynfp.Buffer).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $Bz0HP.struct([
                $Bz0HP.u8("programIdIndex"),
                $Bz0HP.blob(instruction.keyIndicesCount.length, "keyIndicesCount"),
                $Bz0HP.seq($Bz0HP.u8("keyIndex"), instruction.keyIndices.length, "keyIndices"),
                $Bz0HP.blob(instruction.dataLength.length, "dataLength"),
                $Bz0HP.seq($Bz0HP.u8("userdatum"), instruction.data.length, "data")
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $Bz0HP.struct([
            $Bz0HP.blob(1, "numRequiredSignatures"),
            $Bz0HP.blob(1, "numReadonlySignedAccounts"),
            $Bz0HP.blob(1, "numReadonlyUnsignedAccounts"),
            $Bz0HP.blob(keyCount.length, "keyCount"),
            $Bz0HP.seq($173f28bad64492c8$var$publicKey("key"), numKeys, "keys"),
            $173f28bad64492c8$var$publicKey("recentBlockhash")
        ]);
        const transaction = {
            numRequiredSignatures: (0, $gynfp.Buffer).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $gynfp.Buffer).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $gynfp.Buffer).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $gynfp.Buffer).from(keyCount),
            keys: this.accountKeys.map((key)=>$173f28bad64492c8$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).decode(this.recentBlockhash)
        };
        let signData = (0, $gynfp.Buffer).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = $173f28bad64492c8$var$guardedShift(byteArray);
        if (numRequiredSignatures !== (numRequiredSignatures & $173f28bad64492c8$export$3c3793d809f8b858)) throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
        const numReadonlySignedAccounts = $173f28bad64492c8$var$guardedShift(byteArray);
        const numReadonlyUnsignedAccounts = $173f28bad64492c8$var$guardedShift(byteArray);
        const accountCount = $173f28bad64492c8$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = $173f28bad64492c8$var$guardedSplice(byteArray, 0, $173f28bad64492c8$export$84fc0a248cc54343);
            accountKeys.push(new $173f28bad64492c8$export$ca8b6604d6ce14de((0, $gynfp.Buffer).from(account)));
        }
        const recentBlockhash = $173f28bad64492c8$var$guardedSplice(byteArray, 0, $173f28bad64492c8$export$84fc0a248cc54343);
        const instructionCount = $173f28bad64492c8$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $173f28bad64492c8$var$guardedShift(byteArray);
            const accountCount = $173f28bad64492c8$var$decodeLength(byteArray);
            const accounts = $173f28bad64492c8$var$guardedSplice(byteArray, 0, accountCount);
            const dataLength = $173f28bad64492c8$var$decodeLength(byteArray);
            const dataSlice = $173f28bad64492c8$var$guardedSplice(byteArray, 0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).encode((0, $gynfp.Buffer).from(dataSlice));
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).encode((0, $gynfp.Buffer).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $173f28bad64492c8$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $173f28bad64492c8$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && "accountKeysFromLookups" in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && "addressLookupTableAccounts" in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error("Failed to get account keys because address table lookups were not resolved");
        return new $173f28bad64492c8$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $173f28bad64492c8$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $173f28bad64492c8$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $173f28bad64492c8$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $173f28bad64492c8$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $173f28bad64492c8$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $173f28bad64492c8$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $Bz0HP.struct([
            $Bz0HP.u8("prefix"),
            $Bz0HP.struct([
                $Bz0HP.u8("numRequiredSignatures"),
                $Bz0HP.u8("numReadonlySignedAccounts"),
                $Bz0HP.u8("numReadonlyUnsignedAccounts")
            ], "header"),
            $Bz0HP.blob(encodedStaticAccountKeysLength.length, "staticAccountKeysLength"),
            $Bz0HP.seq($173f28bad64492c8$var$publicKey(), this.staticAccountKeys.length, "staticAccountKeys"),
            $173f28bad64492c8$var$publicKey("recentBlockhash"),
            $Bz0HP.blob(encodedInstructionsLength.length, "instructionsLength"),
            $Bz0HP.blob(serializedInstructions.length, "serializedInstructions"),
            $Bz0HP.blob(encodedAddressTableLookupsLength.length, "addressTableLookupsLength"),
            $Bz0HP.blob(serializedAddressTableLookups.length, "serializedAddressTableLookups")
        ]);
        const serializedMessage = new Uint8Array($173f28bad64492c8$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($173f28bad64492c8$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $173f28bad64492c8$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $173f28bad64492c8$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $Bz0HP.struct([
                $Bz0HP.u8("programIdIndex"),
                $Bz0HP.blob(encodedAccountKeyIndexesLength.length, "encodedAccountKeyIndexesLength"),
                $Bz0HP.seq($Bz0HP.u8(), instruction.accountKeyIndexes.length, "accountKeyIndexes"),
                $Bz0HP.blob(encodedDataLength.length, "encodedDataLength"),
                $Bz0HP.blob(instruction.data.length, "data")
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($173f28bad64492c8$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $173f28bad64492c8$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $173f28bad64492c8$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $Bz0HP.struct([
                $173f28bad64492c8$var$publicKey("accountKey"),
                $Bz0HP.blob(encodedWritableIndexesLength.length, "encodedWritableIndexesLength"),
                $Bz0HP.seq($Bz0HP.u8(), lookup.writableIndexes.length, "writableIndexes"),
                $Bz0HP.blob(encodedReadonlyIndexesLength.length, "encodedReadonlyIndexesLength"),
                $Bz0HP.seq($Bz0HP.u8(), lookup.readonlyIndexes.length, "readonlyIndexes")
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = $173f28bad64492c8$var$guardedShift(byteArray);
        const maskedPrefix = prefix & $173f28bad64492c8$export$3c3793d809f8b858;
        $173f28bad64492c8$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $173f28bad64492c8$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: $173f28bad64492c8$var$guardedShift(byteArray),
            numReadonlySignedAccounts: $173f28bad64492c8$var$guardedShift(byteArray),
            numReadonlyUnsignedAccounts: $173f28bad64492c8$var$guardedShift(byteArray)
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $173f28bad64492c8$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $173f28bad64492c8$export$ca8b6604d6ce14de($173f28bad64492c8$var$guardedSplice(byteArray, 0, $173f28bad64492c8$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).encode($173f28bad64492c8$var$guardedSplice(byteArray, 0, $173f28bad64492c8$export$84fc0a248cc54343));
        const instructionCount = $173f28bad64492c8$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $173f28bad64492c8$var$guardedShift(byteArray);
            const accountKeyIndexesLength = $173f28bad64492c8$var$decodeLength(byteArray);
            const accountKeyIndexes = $173f28bad64492c8$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
            const dataLength = $173f28bad64492c8$var$decodeLength(byteArray);
            const data = new Uint8Array($173f28bad64492c8$var$guardedSplice(byteArray, 0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $173f28bad64492c8$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $173f28bad64492c8$export$ca8b6604d6ce14de($173f28bad64492c8$var$guardedSplice(byteArray, 0, $173f28bad64492c8$export$84fc0a248cc54343));
            const writableIndexesLength = $173f28bad64492c8$var$decodeLength(byteArray);
            const writableIndexes = $173f28bad64492c8$var$guardedSplice(byteArray, 0, writableIndexesLength);
            const readonlyIndexesLength = $173f28bad64492c8$var$decodeLength(byteArray);
            const readonlyIndexes = $173f28bad64492c8$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $173f28bad64492c8$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $173f28bad64492c8$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $173f28bad64492c8$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return "legacy";
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $173f28bad64492c8$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === "legacy") return $173f28bad64492c8$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $173f28bad64492c8$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $173f28bad64492c8$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $173f28bad64492c8$var$DEFAULT_SIGNATURE = (0, $gynfp.Buffer).alloc($173f28bad64492c8$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $173f28bad64492c8$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $gynfp.Buffer).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $173f28bad64492c8$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, "nonceInfo")) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, "lastValidBlockHeight")) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error("No instructions");
        items.forEach((item)=>{
            if ("instructions" in item) this.instructions = this.instructions.concat(item.instructions);
            else if ("data" in item && "programId" in item && "keys" in item) this.instructions.push(item);
            else this.instructions.push(new $173f28bad64492c8$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error("Transaction recentBlockhash required");
        if (instructions.length < 1) console.warn("No instructions provided");
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error("Transaction fee payer required");
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: "best fit",
                usage: "sort",
                sensitivity: "variant",
                ignorePunctuation: false,
                numeric: false,
                caseFirst: "lower"
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), "en", options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $173f28bad64492c8$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$173f28bad64492c8$var$assert(keyIndex >= 0));
        });
        return new $173f28bad64492c8$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $173f28bad64492c8$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $173f28bad64492c8$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $173f28bad64492c8$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $gynfp.Buffer).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$173f28bad64492c8$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = "Signature verification failed.";
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? "" : "(s)"} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join("`, `")}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? "" : "(s)"} [\`${sigErrors.missing.map((p)=>p.toBase58()).join("`, `")}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $173f28bad64492c8$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $gynfp.Buffer).alloc(transactionLength);
        $173f28bad64492c8$var$assert(signatures.length < 256);
        (0, $gynfp.Buffer).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $173f28bad64492c8$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $gynfp.Buffer).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $173f28bad64492c8$var$assert(wireTransaction.length <= $173f28bad64492c8$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$173f28bad64492c8$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $173f28bad64492c8$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $173f28bad64492c8$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $173f28bad64492c8$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $173f28bad64492c8$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = $173f28bad64492c8$var$guardedSplice(byteArray, 0, $173f28bad64492c8$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).encode((0, $gynfp.Buffer).from(signature)));
        }
        return $173f28bad64492c8$export$febc5573c75cefb0.populate($173f28bad64492c8$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $173f28bad64492c8$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).encode($173f28bad64492c8$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $173f28bad64492c8$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $173f28bad64492c8$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $173f28bad64492c8$var$assert(numWritableSignedAccounts > 0, "Message header is invalid");
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $173f28bad64492c8$var$assert(numWritableUnsignedAccounts >= 0, "Message header is invalid");
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error("Failed to decompile message because no account keys were found");
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $173f28bad64492c8$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $173f28bad64492c8$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $173f28bad64492c8$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $173f28bad64492c8$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $173f28bad64492c8$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $173f28bad64492c8$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $173f28bad64492c8$var$assert(signatures.length === message.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures");
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($173f28bad64492c8$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $173f28bad64492c8$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $Bz0HP.struct([
            $Bz0HP.blob(encodedSignaturesLength.length, "encodedSignaturesLength"),
            $Bz0HP.seq($173f28bad64492c8$var$signature(), this.signatures.length, "signatures"),
            $Bz0HP.blob(serializedMessage.length, "serializedMessage")
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $173f28bad64492c8$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($173f28bad64492c8$var$guardedSplice(byteArray, 0, $173f28bad64492c8$export$14aee086fde78fa6)));
        const message = $173f28bad64492c8$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $173f28bad64492c8$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $173f28bad64492c8$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $173f28bad64492c8$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $173f28bad64492c8$var$assert(signature.byteLength === 64, "Signature must be 64 bytes long");
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $173f28bad64492c8$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $173f28bad64492c8$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $173f28bad64492c8$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $173f28bad64492c8$var$NUM_SLOTS_PER_SECOND = $173f28bad64492c8$var$NUM_TICKS_PER_SECOND / $173f28bad64492c8$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $173f28bad64492c8$var$MS_PER_SLOT = 1000 / $173f28bad64492c8$var$NUM_SLOTS_PER_SECOND;
const $173f28bad64492c8$export$393aa1412d47050e = new $173f28bad64492c8$export$ca8b6604d6ce14de("SysvarC1ock11111111111111111111111111111111");
const $173f28bad64492c8$export$2b71d479444d2f4 = new $173f28bad64492c8$export$ca8b6604d6ce14de("SysvarEpochSchedu1e111111111111111111111111");
const $173f28bad64492c8$export$54419cc1a3ece8d6 = new $173f28bad64492c8$export$ca8b6604d6ce14de("Sysvar1nstructions1111111111111111111111111");
const $173f28bad64492c8$export$e74201139e9833db = new $173f28bad64492c8$export$ca8b6604d6ce14de("SysvarRecentB1ockHashes11111111111111111111");
const $173f28bad64492c8$export$970d0190cdb3a8e9 = new $173f28bad64492c8$export$ca8b6604d6ce14de("SysvarRent111111111111111111111111111111111");
const $173f28bad64492c8$export$da3b38d796bc1af1 = new $173f28bad64492c8$export$ca8b6604d6ce14de("SysvarRewards111111111111111111111111111111");
const $173f28bad64492c8$export$7b3a057916a4a7ae = new $173f28bad64492c8$export$ca8b6604d6ce14de("SysvarS1otHashes111111111111111111111111111");
const $173f28bad64492c8$export$3272815bf0633907 = new $173f28bad64492c8$export$ca8b6604d6ce14de("SysvarS1otHistory11111111111111111111111111");
const $173f28bad64492c8$export$ca994171317280ea = new $173f28bad64492c8$export$ca8b6604d6ce14de("SysvarStakeHistory1111111111111111111111111");
class $173f28bad64492c8$export$121e803f723b3045 extends Error {
    constructor({ action: action, signature: signature, transactionMessage: transactionMessage, logs: logs }){
        const maybeLogsOutput = logs ? `Logs: \n${JSON.stringify(logs.slice(-10), null, 2)}. ` : "";
        const guideText = "\nCatch the `SendTransactionError` and call `getLogs()` on it for full details.";
        let message;
        switch(action){
            case "send":
                message = `Transaction ${signature} resulted in an error. \n` + `${transactionMessage}. ` + maybeLogsOutput + guideText;
                break;
            case "simulate":
                message = `Simulation failed. \nMessage: ${transactionMessage}. \n` + maybeLogsOutput + guideText;
                break;
            default:
                message = `Unknown action '${((a)=>a)(action)}'`;
        }
        super(message);
        this.signature = void 0;
        this.transactionMessage = void 0;
        this.transactionLogs = void 0;
        this.signature = signature;
        this.transactionMessage = transactionMessage;
        this.transactionLogs = logs ? logs : undefined;
    }
    get transactionError() {
        return {
            message: this.transactionMessage,
            logs: Array.isArray(this.transactionLogs) ? this.transactionLogs : undefined
        };
    }
    /* @deprecated Use `await getLogs()` instead */ get logs() {
        const cachedLogs = this.transactionLogs;
        if (cachedLogs != null && typeof cachedLogs === "object" && "then" in cachedLogs) return undefined;
        return cachedLogs;
    }
    async getLogs(connection) {
        if (!Array.isArray(this.transactionLogs)) this.transactionLogs = new Promise((resolve, reject)=>{
            connection.getTransaction(this.signature).then((tx)=>{
                if (tx && tx.meta && tx.meta.logMessages) {
                    const logs = tx.meta.logMessages;
                    this.transactionLogs = logs;
                    resolve(logs);
                } else reject(new Error("Log messages not found"));
            }).catch(reject);
        });
        return await this.transactionLogs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $173f28bad64492c8$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $173f28bad64492c8$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = "SolanaJSONRPCError";
    }
}
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $173f28bad64492c8$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) {
        if (signature != null) throw new $173f28bad64492c8$export$121e803f723b3045({
            action: "send",
            signature: signature,
            transactionMessage: `Status: (${JSON.stringify(status)})`
        });
        throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    }
    return signature;
}
// zzz
function $173f28bad64492c8$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $173f28bad64492c8$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $173f28bad64492c8$var$getAlloc(type, fields);
    const data = (0, $gynfp.Buffer).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $173f28bad64492c8$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $173f28bad64492c8$export$d1cc579b1c48f515 = $Bz0HP.nu64("lamportsPerSignature");
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $173f28bad64492c8$var$NonceAccountLayout = $Bz0HP.struct([
    $Bz0HP.u32("version"),
    $Bz0HP.u32("state"),
    $173f28bad64492c8$var$publicKey("authorizedPubkey"),
    $173f28bad64492c8$var$publicKey("nonce"),
    $Bz0HP.struct([
        $173f28bad64492c8$export$d1cc579b1c48f515
    ], "feeCalculator")
]);
const $173f28bad64492c8$export$7126250b6d8bd94a = $173f28bad64492c8$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $173f28bad64492c8$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $173f28bad64492c8$var$NonceAccountLayout.decode($173f28bad64492c8$var$toBuffer(buffer), 0);
        return new $173f28bad64492c8$export$ed1c2356ce604759({
            authorizedPubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $173f28bad64492c8$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
const $173f28bad64492c8$var$encodeDecode = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
const $173f28bad64492c8$var$bigInt = (length)=>(property)=>{
        const layout = (0, $Bz0HP.blob)(length, property);
        const { encode: encode, decode: decode } = $173f28bad64492c8$var$encodeDecode(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $dZYIo.toBigIntLE)((0, $gynfp.Buffer).from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $dZYIo.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $173f28bad64492c8$var$u64 = $173f28bad64492c8$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $173f28bad64492c8$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Bz0HP.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($173f28bad64492c8$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a SystemInstruction");
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $173f28bad64492c8$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $173f28bad64492c8$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $173f28bad64492c8$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $173f28bad64492c8$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $173f28bad64492c8$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $173f28bad64492c8$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($173f28bad64492c8$export$d8c4e17726848113.programId)) throw new Error("invalid instruction; programId is not SystemProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $173f28bad64492c8$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $Bz0HP.ns64("lamports"),
            $Bz0HP.ns64("space"),
            $173f28bad64492c8$var$publicKey("programId")
        ])
    },
    Assign: {
        index: 1,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$publicKey("programId")
        ])
    },
    Transfer: {
        index: 2,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$u64("lamports")
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$publicKey("base"),
            $173f28bad64492c8$var$rustString("seed"),
            $Bz0HP.ns64("lamports"),
            $Bz0HP.ns64("space"),
            $173f28bad64492c8$var$publicKey("programId")
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction")
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $Bz0HP.ns64("lamports")
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$publicKey("authorized")
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$publicKey("authorized")
        ])
    },
    Allocate: {
        index: 8,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $Bz0HP.ns64("space")
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$publicKey("base"),
            $173f28bad64492c8$var$rustString("seed"),
            $Bz0HP.ns64("space"),
            $173f28bad64492c8$var$publicKey("programId")
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$publicKey("base"),
            $173f28bad64492c8$var$rustString("seed"),
            $173f28bad64492c8$var$publicKey("programId")
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$u64("lamports"),
            $173f28bad64492c8$var$rustString("seed"),
            $173f28bad64492c8$var$publicKey("programId")
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction")
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $173f28bad64492c8$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $173f28bad64492c8$export$74bdf41d8d1e7108.Create;
        const data = $173f28bad64492c8$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $173f28bad64492c8$var$toBuffer(params.programId.toBuffer())
        });
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $173f28bad64492c8$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $173f28bad64492c8$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $173f28bad64492c8$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $173f28bad64492c8$export$74bdf41d8d1e7108.Transfer;
            data = $173f28bad64492c8$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $173f28bad64492c8$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $173f28bad64492c8$var$encodeData(type, {
                base: $173f28bad64492c8$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $173f28bad64492c8$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $173f28bad64492c8$export$74bdf41d8d1e7108.Assign;
            data = $173f28bad64492c8$var$encodeData(type, {
                programId: $173f28bad64492c8$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $173f28bad64492c8$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $173f28bad64492c8$var$encodeData(type, {
            base: $173f28bad64492c8$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $173f28bad64492c8$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (!params.basePubkey.equals(params.fromPubkey)) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $173f28bad64492c8$export$febc5573c75cefb0();
        if ("basePubkey" in params && "seed" in params) transaction.add($173f28bad64492c8$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $173f28bad64492c8$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($173f28bad64492c8$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $173f28bad64492c8$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $173f28bad64492c8$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $173f28bad64492c8$var$encodeData(type, {
            authorized: $173f28bad64492c8$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $173f28bad64492c8$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $173f28bad64492c8$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $173f28bad64492c8$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $173f28bad64492c8$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $173f28bad64492c8$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $173f28bad64492c8$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $173f28bad64492c8$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $173f28bad64492c8$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $173f28bad64492c8$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $173f28bad64492c8$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $173f28bad64492c8$var$encodeData(type, {
            authorized: $173f28bad64492c8$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $173f28bad64492c8$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $173f28bad64492c8$var$encodeData(type, {
                base: $173f28bad64492c8$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $173f28bad64492c8$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $173f28bad64492c8$export$74bdf41d8d1e7108.Allocate;
            data = $173f28bad64492c8$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$173f28bad64492c8$export$d8c4e17726848113.programId = new $173f28bad64492c8$export$ca8b6604d6ce14de("11111111111111111111111111111111");
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $173f28bad64492c8$var$CHUNK_SIZE = $173f28bad64492c8$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $173f28bad64492c8$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $173f28bad64492c8$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, "confirmed");
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error("Program load failed, account is already executable");
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $173f28bad64492c8$export$febc5573c75cefb0();
                    transaction.add($173f28bad64492c8$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $173f28bad64492c8$export$febc5573c75cefb0();
                    transaction.add($173f28bad64492c8$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $173f28bad64492c8$export$febc5573c75cefb0();
                    transaction.add($173f28bad64492c8$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $173f28bad64492c8$export$febc5573c75cefb0().add($173f28bad64492c8$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $173f28bad64492c8$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            });
        }
        const dataLayout = $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $Bz0HP.u32("offset"),
            $Bz0HP.u32("bytesLength"),
            $Bz0HP.u32("bytesLengthPadding"),
            $Bz0HP.seq($Bz0HP.u8("byte"), $Bz0HP.offset($Bz0HP.u32(), -8), "bytes")
        ]);
        const chunkSize = $173f28bad64492c8$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $gynfp.Buffer).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $173f28bad64492c8$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($173f28bad64492c8$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes("solana.com")) {
                const REQUESTS_PER_SECOND = 4;
                await $173f28bad64492c8$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $Bz0HP.struct([
                $Bz0HP.u32("instruction")
            ]);
            const data = (0, $gynfp.Buffer).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $173f28bad64492c8$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $173f28bad64492c8$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = "processed";
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($173f28bad64492c8$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$173f28bad64492c8$export$3b0d6d7590275603.chunkSize = $173f28bad64492c8$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ const $173f28bad64492c8$export$59833422f998b937 = new $173f28bad64492c8$export$ca8b6604d6ce14de("BPFLoader2111111111111111111111111111111111");
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ class $173f28bad64492c8$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $173f28bad64492c8$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $173f28bad64492c8$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $173f28bad64492c8$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $173f28bad64492c8$var$fastStableStringify$1;
var $173f28bad64492c8$var$hasRequiredFastStableStringify;
function $173f28bad64492c8$var$requireFastStableStringify() {
    if ($173f28bad64492c8$var$hasRequiredFastStableStringify) return $173f28bad64492c8$var$fastStableStringify$1;
    $173f28bad64492c8$var$hasRequiredFastStableStringify = 1;
    var objToString = Object.prototype.toString;
    var objKeys = Object.keys || function(obj) {
        var keys = [];
        for(var name in obj)keys.push(name);
        return keys;
    };
    function stringify(val, isArrayProp) {
        var i, max, str, keys, key, propVal, toStr;
        if (val === true) return "true";
        if (val === false) return "false";
        switch(typeof val){
            case "object":
                if (val === null) return null;
                else if (val.toJSON && typeof val.toJSON === "function") return stringify(val.toJSON(), isArrayProp);
                else {
                    toStr = objToString.call(val);
                    if (toStr === "[object Array]") {
                        str = "[";
                        max = val.length - 1;
                        for(i = 0; i < max; i++)str += stringify(val[i], true) + ",";
                        if (max > -1) str += stringify(val[i], true);
                        return str + "]";
                    } else if (toStr === "[object Object]") {
                        // only object is left
                        keys = objKeys(val).sort();
                        max = keys.length;
                        str = "";
                        i = 0;
                        while(i < max){
                            key = keys[i];
                            propVal = stringify(val[key], false);
                            if (propVal !== undefined) {
                                if (str) str += ",";
                                str += JSON.stringify(key) + ":" + propVal;
                            }
                            i++;
                        }
                        return "{" + str + "}";
                    } else return JSON.stringify(val);
                }
            case "function":
            case "undefined":
                return isArrayProp ? null : undefined;
            case "string":
                return JSON.stringify(val);
            default:
                return isFinite(val) ? val : null;
        }
    }
    $173f28bad64492c8$var$fastStableStringify$1 = function(val) {
        var returnVal = stringify(val, false);
        if (returnVal !== undefined) return "" + returnVal;
    };
    return $173f28bad64492c8$var$fastStableStringify$1;
}
var $173f28bad64492c8$var$fastStableStringifyExports = /*@__PURE__*/ $173f28bad64492c8$var$requireFastStableStringify();
var $173f28bad64492c8$var$fastStableStringify = /*@__PURE__*/ $173f28bad64492c8$var$getDefaultExportFromCjs($173f28bad64492c8$var$fastStableStringifyExports);
const $173f28bad64492c8$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $173f28bad64492c8$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $173f28bad64492c8$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $173f28bad64492c8$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $173f28bad64492c8$var$trailingZeros($173f28bad64492c8$var$nextPowerOfTwo(slot + $173f28bad64492c8$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $173f28bad64492c8$var$trailingZeros($173f28bad64492c8$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $173f28bad64492c8$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $173f28bad64492c8$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $173f28bad64492c8$var$trailingZeros($173f28bad64492c8$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
var $173f28bad64492c8$var$fetchImpl = globalThis.fetch;
class $173f28bad64492c8$var$RpcWebSocketClient extends (0, $e4v9r.CommonClient) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, $e4v9r.WebSocket)(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ("socket" in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error("Tried to call a JSON-RPC method `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error("Tried to send a JSON-RPC notification `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $173f28bad64492c8$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $173f28bad64492c8$var$LOOKUP_TABLE_META_SIZE = 56;
class $173f28bad64492c8$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt("0xffffffffffffffff");
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $173f28bad64492c8$var$decodeData($173f28bad64492c8$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $173f28bad64492c8$var$LOOKUP_TABLE_META_SIZE;
        $173f28bad64492c8$var$assert(serializedAddressesLen >= 0, "lookup table is invalid");
        $173f28bad64492c8$var$assert(serializedAddressesLen % 32 === 0, "lookup table is invalid");
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $Bz0HP.struct([
            $Bz0HP.seq($173f28bad64492c8$var$publicKey(), numSerializedAddresses, "addresses")
        ]).decode(accountData.slice($173f28bad64492c8$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $173f28bad64492c8$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $173f28bad64492c8$export$ca8b6604d6ce14de(address))
        };
    }
}
const $173f28bad64492c8$var$LookupTableMetaLayout = {
    index: 1,
    layout: $Bz0HP.struct([
        $Bz0HP.u32("typeIndex"),
        $173f28bad64492c8$var$u64("deactivationSlot"),
        $Bz0HP.nu64("lastExtendedSlot"),
        $Bz0HP.u8("lastExtendedStartIndex"),
        $Bz0HP.u8(),
        // option
        $Bz0HP.seq($173f28bad64492c8$var$publicKey(), $Bz0HP.offset($Bz0HP.u8(), -1), "authority")
    ])
};
const $173f28bad64492c8$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $173f28bad64492c8$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($173f28bad64492c8$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith("https:") ? "wss:" : "ws:";
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to agave-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? "" : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $173f28bad64492c8$var$PublicKeyFromString = (0, $78ONe.coerce)((0, $78ONe.instance)($173f28bad64492c8$export$ca8b6604d6ce14de), (0, $78ONe.string)(), (value)=>new $173f28bad64492c8$export$ca8b6604d6ce14de(value));
const $173f28bad64492c8$var$RawAccountDataResult = (0, $78ONe.tuple)([
    (0, $78ONe.string)(),
    (0, $78ONe.literal)("base64")
]);
const $173f28bad64492c8$var$BufferFromRawAccountData = (0, $78ONe.coerce)((0, $78ONe.instance)((0, $gynfp.Buffer)), $173f28bad64492c8$var$RawAccountDataResult, (value)=>(0, $gynfp.Buffer).from(value[0], "base64"));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $173f28bad64492c8$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $173f28bad64492c8$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
    return putativeUrl;
}
/** @internal */ function $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === "string") commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $173f28bad64492c8$var$applyDefaultMemcmpEncodingToFilters(filters) {
    return filters.map((filter)=>"memcmp" in filter ? {
            ...filter,
            memcmp: {
                ...filter.memcmp,
                encoding: filter.memcmp.encoding ?? "base58"
            }
        } : filter);
}
/**
 * @internal
 */ function $173f28bad64492c8$var$createRpcResult(result) {
    return (0, $78ONe.union)([
        (0, $78ONe.type)({
            jsonrpc: (0, $78ONe.literal)("2.0"),
            id: (0, $78ONe.string)(),
            result: result
        }),
        (0, $78ONe.type)({
            jsonrpc: (0, $78ONe.literal)("2.0"),
            id: (0, $78ONe.string)(),
            error: (0, $78ONe.type)({
                code: (0, $78ONe.unknown)(),
                message: (0, $78ONe.string)(),
                data: (0, $78ONe.optional)((0, $78ONe.any)())
            })
        })
    ]);
}
const $173f28bad64492c8$var$UnknownRpcResult = $173f28bad64492c8$var$createRpcResult((0, $78ONe.unknown)());
/**
 * @internal
 */ function $173f28bad64492c8$var$jsonRpcResult(schema) {
    return (0, $78ONe.coerce)($173f28bad64492c8$var$createRpcResult(schema), $173f28bad64492c8$var$UnknownRpcResult, (value)=>{
        if ("error" in value) return value;
        else return {
            ...value,
            result: (0, $78ONe.create)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $173f28bad64492c8$var$jsonRpcResultAndContext(value) {
    return $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.type)({
        context: (0, $78ONe.type)({
            slot: (0, $78ONe.number)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $173f28bad64492c8$var$notificationResultAndContext(value) {
    return (0, $78ONe.type)({
        context: (0, $78ONe.type)({
            slot: (0, $78ONe.number)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $173f28bad64492c8$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $173f28bad64492c8$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $173f28bad64492c8$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $173f28bad64492c8$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $173f28bad64492c8$var$GetInflationGovernorResult = (0, $78ONe.type)({
    foundation: (0, $78ONe.number)(),
    foundationTerm: (0, $78ONe.number)(),
    initial: (0, $78ONe.number)(),
    taper: (0, $78ONe.number)(),
    terminal: (0, $78ONe.number)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $173f28bad64492c8$var$GetInflationRewardResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.array)((0, $78ONe.nullable)((0, $78ONe.type)({
    epoch: (0, $78ONe.number)(),
    effectiveSlot: (0, $78ONe.number)(),
    amount: (0, $78ONe.number)(),
    postBalance: (0, $78ONe.number)(),
    commission: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.number)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $173f28bad64492c8$var$GetRecentPrioritizationFeesResult = (0, $78ONe.array)((0, $78ONe.type)({
    slot: (0, $78ONe.number)(),
    prioritizationFee: (0, $78ONe.number)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $173f28bad64492c8$var$GetInflationRateResult = (0, $78ONe.type)({
    total: (0, $78ONe.number)(),
    validator: (0, $78ONe.number)(),
    foundation: (0, $78ONe.number)(),
    epoch: (0, $78ONe.number)()
});
/**
 * Information about the current epoch
 */ const $173f28bad64492c8$var$GetEpochInfoResult = (0, $78ONe.type)({
    epoch: (0, $78ONe.number)(),
    slotIndex: (0, $78ONe.number)(),
    slotsInEpoch: (0, $78ONe.number)(),
    absoluteSlot: (0, $78ONe.number)(),
    blockHeight: (0, $78ONe.optional)((0, $78ONe.number)()),
    transactionCount: (0, $78ONe.optional)((0, $78ONe.number)())
});
const $173f28bad64492c8$var$GetEpochScheduleResult = (0, $78ONe.type)({
    slotsPerEpoch: (0, $78ONe.number)(),
    leaderScheduleSlotOffset: (0, $78ONe.number)(),
    warmup: (0, $78ONe.boolean)(),
    firstNormalEpoch: (0, $78ONe.number)(),
    firstNormalSlot: (0, $78ONe.number)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $173f28bad64492c8$var$GetLeaderScheduleResult = (0, $78ONe.record)((0, $78ONe.string)(), (0, $78ONe.array)((0, $78ONe.number)()));
/**
 * Transaction error or null
 */ const $173f28bad64492c8$var$TransactionErrorResult = (0, $78ONe.nullable)((0, $78ONe.union)([
    (0, $78ONe.type)({}),
    (0, $78ONe.string)()
]));
/**
 * Signature status for a transaction
 */ const $173f28bad64492c8$var$SignatureStatusResult = (0, $78ONe.type)({
    err: $173f28bad64492c8$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $173f28bad64492c8$var$SignatureReceivedResult = (0, $78ONe.literal)("receivedSignature");
/**
 * Version info for a node
 */ const $173f28bad64492c8$var$VersionResult = (0, $78ONe.type)({
    "solana-core": (0, $78ONe.string)(),
    "feature-set": (0, $78ONe.optional)((0, $78ONe.number)())
});
const $173f28bad64492c8$var$ParsedInstructionStruct = (0, $78ONe.type)({
    program: (0, $78ONe.string)(),
    programId: $173f28bad64492c8$var$PublicKeyFromString,
    parsed: (0, $78ONe.unknown)()
});
const $173f28bad64492c8$var$PartiallyDecodedInstructionStruct = (0, $78ONe.type)({
    programId: $173f28bad64492c8$var$PublicKeyFromString,
    accounts: (0, $78ONe.array)($173f28bad64492c8$var$PublicKeyFromString),
    data: (0, $78ONe.string)()
});
const $173f28bad64492c8$var$SimulatedTransactionResponseStruct = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.type)({
    err: (0, $78ONe.nullable)((0, $78ONe.union)([
        (0, $78ONe.type)({}),
        (0, $78ONe.string)()
    ])),
    logs: (0, $78ONe.nullable)((0, $78ONe.array)((0, $78ONe.string)())),
    accounts: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)((0, $78ONe.nullable)((0, $78ONe.type)({
        executable: (0, $78ONe.boolean)(),
        owner: (0, $78ONe.string)(),
        lamports: (0, $78ONe.number)(),
        data: (0, $78ONe.array)((0, $78ONe.string)()),
        rentEpoch: (0, $78ONe.optional)((0, $78ONe.number)())
    }))))),
    unitsConsumed: (0, $78ONe.optional)((0, $78ONe.number)()),
    returnData: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.type)({
        programId: (0, $78ONe.string)(),
        data: (0, $78ONe.tuple)([
            (0, $78ONe.string)(),
            (0, $78ONe.literal)("base64")
        ])
    }))),
    innerInstructions: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)((0, $78ONe.type)({
        index: (0, $78ONe.number)(),
        instructions: (0, $78ONe.array)((0, $78ONe.union)([
            $173f28bad64492c8$var$ParsedInstructionStruct,
            $173f28bad64492c8$var$PartiallyDecodedInstructionStruct
        ]))
    }))))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $173f28bad64492c8$var$BlockProductionResponseStruct = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.type)({
    byIdentity: (0, $78ONe.record)((0, $78ONe.string)(), (0, $78ONe.array)((0, $78ONe.number)())),
    range: (0, $78ONe.type)({
        firstSlot: (0, $78ONe.number)(),
        lastSlot: (0, $78ONe.number)()
    })
}));
/**
 * A performance sample
 */ function $173f28bad64492c8$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $173f28bad64492c8$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($5iF24)))(async (request, callback)=>{
        const options = {
            method: "POST",
            body: request,
            agent: agent,
            headers: Object.assign({
                "Content-Type": "application/json"
            }, httpHeaders || {}, $173f28bad64492c8$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $173f28bad64492c8$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $173f28bad64492c8$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $173f28bad64492c8$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $173f28bad64492c8$var$GetInflationGovernorRpcResult = $173f28bad64492c8$var$jsonRpcResult($173f28bad64492c8$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $173f28bad64492c8$var$GetInflationRateRpcResult = $173f28bad64492c8$var$jsonRpcResult($173f28bad64492c8$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $173f28bad64492c8$var$GetRecentPrioritizationFeesRpcResult = $173f28bad64492c8$var$jsonRpcResult($173f28bad64492c8$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $173f28bad64492c8$var$GetEpochInfoRpcResult = $173f28bad64492c8$var$jsonRpcResult($173f28bad64492c8$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $173f28bad64492c8$var$GetEpochScheduleRpcResult = $173f28bad64492c8$var$jsonRpcResult($173f28bad64492c8$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $173f28bad64492c8$var$GetLeaderScheduleRpcResult = $173f28bad64492c8$var$jsonRpcResult($173f28bad64492c8$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $173f28bad64492c8$var$SlotRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.number)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $173f28bad64492c8$var$GetSupplyRpcResult = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.type)({
    total: (0, $78ONe.number)(),
    circulating: (0, $78ONe.number)(),
    nonCirculating: (0, $78ONe.number)(),
    nonCirculatingAccounts: (0, $78ONe.array)($173f28bad64492c8$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $173f28bad64492c8$var$TokenAmountResult = (0, $78ONe.type)({
    amount: (0, $78ONe.string)(),
    uiAmount: (0, $78ONe.nullable)((0, $78ONe.number)()),
    decimals: (0, $78ONe.number)(),
    uiAmountString: (0, $78ONe.optional)((0, $78ONe.string)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $173f28bad64492c8$var$GetTokenLargestAccountsResult = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.array)((0, $78ONe.type)({
    address: $173f28bad64492c8$var$PublicKeyFromString,
    amount: (0, $78ONe.string)(),
    uiAmount: (0, $78ONe.nullable)((0, $78ONe.number)()),
    decimals: (0, $78ONe.number)(),
    uiAmountString: (0, $78ONe.optional)((0, $78ONe.string)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $173f28bad64492c8$var$GetTokenAccountsByOwner = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.array)((0, $78ONe.type)({
    pubkey: $173f28bad64492c8$var$PublicKeyFromString,
    account: (0, $78ONe.type)({
        executable: (0, $78ONe.boolean)(),
        owner: $173f28bad64492c8$var$PublicKeyFromString,
        lamports: (0, $78ONe.number)(),
        data: $173f28bad64492c8$var$BufferFromRawAccountData,
        rentEpoch: (0, $78ONe.number)()
    })
})));
const $173f28bad64492c8$var$ParsedAccountDataResult = (0, $78ONe.type)({
    program: (0, $78ONe.string)(),
    parsed: (0, $78ONe.unknown)(),
    space: (0, $78ONe.number)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $173f28bad64492c8$var$GetParsedTokenAccountsByOwner = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.array)((0, $78ONe.type)({
    pubkey: $173f28bad64492c8$var$PublicKeyFromString,
    account: (0, $78ONe.type)({
        executable: (0, $78ONe.boolean)(),
        owner: $173f28bad64492c8$var$PublicKeyFromString,
        lamports: (0, $78ONe.number)(),
        data: $173f28bad64492c8$var$ParsedAccountDataResult,
        rentEpoch: (0, $78ONe.number)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $173f28bad64492c8$var$GetLargestAccountsRpcResult = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.array)((0, $78ONe.type)({
    lamports: (0, $78ONe.number)(),
    address: $173f28bad64492c8$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $173f28bad64492c8$var$AccountInfoResult = (0, $78ONe.type)({
    executable: (0, $78ONe.boolean)(),
    owner: $173f28bad64492c8$var$PublicKeyFromString,
    lamports: (0, $78ONe.number)(),
    data: $173f28bad64492c8$var$BufferFromRawAccountData,
    rentEpoch: (0, $78ONe.number)()
});
/**
 * @internal
 */ const $173f28bad64492c8$var$KeyedAccountInfoResult = (0, $78ONe.type)({
    pubkey: $173f28bad64492c8$var$PublicKeyFromString,
    account: $173f28bad64492c8$var$AccountInfoResult
});
const $173f28bad64492c8$var$ParsedOrRawAccountData = (0, $78ONe.coerce)((0, $78ONe.union)([
    (0, $78ONe.instance)((0, $gynfp.Buffer)),
    $173f28bad64492c8$var$ParsedAccountDataResult
]), (0, $78ONe.union)([
    $173f28bad64492c8$var$RawAccountDataResult,
    $173f28bad64492c8$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $78ONe.create)(value, $173f28bad64492c8$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $173f28bad64492c8$var$ParsedAccountInfoResult = (0, $78ONe.type)({
    executable: (0, $78ONe.boolean)(),
    owner: $173f28bad64492c8$var$PublicKeyFromString,
    lamports: (0, $78ONe.number)(),
    data: $173f28bad64492c8$var$ParsedOrRawAccountData,
    rentEpoch: (0, $78ONe.number)()
});
const $173f28bad64492c8$var$KeyedParsedAccountInfoResult = (0, $78ONe.type)({
    pubkey: $173f28bad64492c8$var$PublicKeyFromString,
    account: $173f28bad64492c8$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $173f28bad64492c8$var$StakeActivationResult = (0, $78ONe.type)({
    state: (0, $78ONe.union)([
        (0, $78ONe.literal)("active"),
        (0, $78ONe.literal)("inactive"),
        (0, $78ONe.literal)("activating"),
        (0, $78ONe.literal)("deactivating")
    ]),
    active: (0, $78ONe.number)(),
    inactive: (0, $78ONe.number)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $173f28bad64492c8$var$GetConfirmedSignaturesForAddress2RpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.array)((0, $78ONe.type)({
    signature: (0, $78ONe.string)(),
    slot: (0, $78ONe.number)(),
    err: $173f28bad64492c8$var$TransactionErrorResult,
    memo: (0, $78ONe.nullable)((0, $78ONe.string)()),
    blockTime: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.number)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $173f28bad64492c8$var$GetSignaturesForAddressRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.array)((0, $78ONe.type)({
    signature: (0, $78ONe.string)(),
    slot: (0, $78ONe.number)(),
    err: $173f28bad64492c8$var$TransactionErrorResult,
    memo: (0, $78ONe.nullable)((0, $78ONe.string)()),
    blockTime: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.number)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $173f28bad64492c8$var$AccountNotificationResult = (0, $78ONe.type)({
    subscription: (0, $78ONe.number)(),
    result: $173f28bad64492c8$var$notificationResultAndContext($173f28bad64492c8$var$AccountInfoResult)
});
/**
 * @internal
 */ const $173f28bad64492c8$var$ProgramAccountInfoResult = (0, $78ONe.type)({
    pubkey: $173f28bad64492c8$var$PublicKeyFromString,
    account: $173f28bad64492c8$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $173f28bad64492c8$var$ProgramAccountNotificationResult = (0, $78ONe.type)({
    subscription: (0, $78ONe.number)(),
    result: $173f28bad64492c8$var$notificationResultAndContext($173f28bad64492c8$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $173f28bad64492c8$var$SlotInfoResult = (0, $78ONe.type)({
    parent: (0, $78ONe.number)(),
    slot: (0, $78ONe.number)(),
    root: (0, $78ONe.number)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $173f28bad64492c8$var$SlotNotificationResult = (0, $78ONe.type)({
    subscription: (0, $78ONe.number)(),
    result: $173f28bad64492c8$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $173f28bad64492c8$var$SlotUpdateResult = (0, $78ONe.union)([
    (0, $78ONe.type)({
        type: (0, $78ONe.union)([
            (0, $78ONe.literal)("firstShredReceived"),
            (0, $78ONe.literal)("completed"),
            (0, $78ONe.literal)("optimisticConfirmation"),
            (0, $78ONe.literal)("root")
        ]),
        slot: (0, $78ONe.number)(),
        timestamp: (0, $78ONe.number)()
    }),
    (0, $78ONe.type)({
        type: (0, $78ONe.literal)("createdBank"),
        parent: (0, $78ONe.number)(),
        slot: (0, $78ONe.number)(),
        timestamp: (0, $78ONe.number)()
    }),
    (0, $78ONe.type)({
        type: (0, $78ONe.literal)("frozen"),
        slot: (0, $78ONe.number)(),
        timestamp: (0, $78ONe.number)(),
        stats: (0, $78ONe.type)({
            numTransactionEntries: (0, $78ONe.number)(),
            numSuccessfulTransactions: (0, $78ONe.number)(),
            numFailedTransactions: (0, $78ONe.number)(),
            maxTransactionsPerEntry: (0, $78ONe.number)()
        })
    }),
    (0, $78ONe.type)({
        type: (0, $78ONe.literal)("dead"),
        slot: (0, $78ONe.number)(),
        timestamp: (0, $78ONe.number)(),
        err: (0, $78ONe.string)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $173f28bad64492c8$var$SlotUpdateNotificationResult = (0, $78ONe.type)({
    subscription: (0, $78ONe.number)(),
    result: $173f28bad64492c8$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $173f28bad64492c8$var$SignatureNotificationResult = (0, $78ONe.type)({
    subscription: (0, $78ONe.number)(),
    result: $173f28bad64492c8$var$notificationResultAndContext((0, $78ONe.union)([
        $173f28bad64492c8$var$SignatureStatusResult,
        $173f28bad64492c8$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $173f28bad64492c8$var$RootNotificationResult = (0, $78ONe.type)({
    subscription: (0, $78ONe.number)(),
    result: (0, $78ONe.number)()
});
const $173f28bad64492c8$var$ContactInfoResult = (0, $78ONe.type)({
    pubkey: (0, $78ONe.string)(),
    gossip: (0, $78ONe.nullable)((0, $78ONe.string)()),
    tpu: (0, $78ONe.nullable)((0, $78ONe.string)()),
    rpc: (0, $78ONe.nullable)((0, $78ONe.string)()),
    version: (0, $78ONe.nullable)((0, $78ONe.string)())
});
const $173f28bad64492c8$var$VoteAccountInfoResult = (0, $78ONe.type)({
    votePubkey: (0, $78ONe.string)(),
    nodePubkey: (0, $78ONe.string)(),
    activatedStake: (0, $78ONe.number)(),
    epochVoteAccount: (0, $78ONe.boolean)(),
    epochCredits: (0, $78ONe.array)((0, $78ONe.tuple)([
        (0, $78ONe.number)(),
        (0, $78ONe.number)(),
        (0, $78ONe.number)()
    ])),
    commission: (0, $78ONe.number)(),
    lastVote: (0, $78ONe.number)(),
    rootSlot: (0, $78ONe.nullable)((0, $78ONe.number)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $173f28bad64492c8$var$GetVoteAccounts = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.type)({
    current: (0, $78ONe.array)($173f28bad64492c8$var$VoteAccountInfoResult),
    delinquent: (0, $78ONe.array)($173f28bad64492c8$var$VoteAccountInfoResult)
}));
const $173f28bad64492c8$var$ConfirmationStatus = (0, $78ONe.union)([
    (0, $78ONe.literal)("processed"),
    (0, $78ONe.literal)("confirmed"),
    (0, $78ONe.literal)("finalized")
]);
const $173f28bad64492c8$var$SignatureStatusResponse = (0, $78ONe.type)({
    slot: (0, $78ONe.number)(),
    confirmations: (0, $78ONe.nullable)((0, $78ONe.number)()),
    err: $173f28bad64492c8$var$TransactionErrorResult,
    confirmationStatus: (0, $78ONe.optional)($173f28bad64492c8$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $173f28bad64492c8$var$GetSignatureStatusesRpcResult = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.array)((0, $78ONe.nullable)($173f28bad64492c8$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $173f28bad64492c8$var$GetMinimumBalanceForRentExemptionRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.number)());
const $173f28bad64492c8$var$AddressTableLookupStruct = (0, $78ONe.type)({
    accountKey: $173f28bad64492c8$var$PublicKeyFromString,
    writableIndexes: (0, $78ONe.array)((0, $78ONe.number)()),
    readonlyIndexes: (0, $78ONe.array)((0, $78ONe.number)())
});
const $173f28bad64492c8$var$ConfirmedTransactionResult = (0, $78ONe.type)({
    signatures: (0, $78ONe.array)((0, $78ONe.string)()),
    message: (0, $78ONe.type)({
        accountKeys: (0, $78ONe.array)((0, $78ONe.string)()),
        header: (0, $78ONe.type)({
            numRequiredSignatures: (0, $78ONe.number)(),
            numReadonlySignedAccounts: (0, $78ONe.number)(),
            numReadonlyUnsignedAccounts: (0, $78ONe.number)()
        }),
        instructions: (0, $78ONe.array)((0, $78ONe.type)({
            accounts: (0, $78ONe.array)((0, $78ONe.number)()),
            data: (0, $78ONe.string)(),
            programIdIndex: (0, $78ONe.number)()
        })),
        recentBlockhash: (0, $78ONe.string)(),
        addressTableLookups: (0, $78ONe.optional)((0, $78ONe.array)($173f28bad64492c8$var$AddressTableLookupStruct))
    })
});
const $173f28bad64492c8$var$AnnotatedAccountKey = (0, $78ONe.type)({
    pubkey: $173f28bad64492c8$var$PublicKeyFromString,
    signer: (0, $78ONe.boolean)(),
    writable: (0, $78ONe.boolean)(),
    source: (0, $78ONe.optional)((0, $78ONe.union)([
        (0, $78ONe.literal)("transaction"),
        (0, $78ONe.literal)("lookupTable")
    ]))
});
const $173f28bad64492c8$var$ConfirmedTransactionAccountsModeResult = (0, $78ONe.type)({
    accountKeys: (0, $78ONe.array)($173f28bad64492c8$var$AnnotatedAccountKey),
    signatures: (0, $78ONe.array)((0, $78ONe.string)())
});
const $173f28bad64492c8$var$ParsedInstructionResult = (0, $78ONe.type)({
    parsed: (0, $78ONe.unknown)(),
    program: (0, $78ONe.string)(),
    programId: $173f28bad64492c8$var$PublicKeyFromString
});
const $173f28bad64492c8$var$RawInstructionResult = (0, $78ONe.type)({
    accounts: (0, $78ONe.array)($173f28bad64492c8$var$PublicKeyFromString),
    data: (0, $78ONe.string)(),
    programId: $173f28bad64492c8$var$PublicKeyFromString
});
const $173f28bad64492c8$var$InstructionResult = (0, $78ONe.union)([
    $173f28bad64492c8$var$RawInstructionResult,
    $173f28bad64492c8$var$ParsedInstructionResult
]);
const $173f28bad64492c8$var$UnknownInstructionResult = (0, $78ONe.union)([
    (0, $78ONe.type)({
        parsed: (0, $78ONe.unknown)(),
        program: (0, $78ONe.string)(),
        programId: (0, $78ONe.string)()
    }),
    (0, $78ONe.type)({
        accounts: (0, $78ONe.array)((0, $78ONe.string)()),
        data: (0, $78ONe.string)(),
        programId: (0, $78ONe.string)()
    })
]);
const $173f28bad64492c8$var$ParsedOrRawInstruction = (0, $78ONe.coerce)($173f28bad64492c8$var$InstructionResult, $173f28bad64492c8$var$UnknownInstructionResult, (value)=>{
    if ("accounts" in value) return (0, $78ONe.create)(value, $173f28bad64492c8$var$RawInstructionResult);
    else return (0, $78ONe.create)(value, $173f28bad64492c8$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $173f28bad64492c8$var$ParsedConfirmedTransactionResult = (0, $78ONe.type)({
    signatures: (0, $78ONe.array)((0, $78ONe.string)()),
    message: (0, $78ONe.type)({
        accountKeys: (0, $78ONe.array)($173f28bad64492c8$var$AnnotatedAccountKey),
        instructions: (0, $78ONe.array)($173f28bad64492c8$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $78ONe.string)(),
        addressTableLookups: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)($173f28bad64492c8$var$AddressTableLookupStruct)))
    })
});
const $173f28bad64492c8$var$TokenBalanceResult = (0, $78ONe.type)({
    accountIndex: (0, $78ONe.number)(),
    mint: (0, $78ONe.string)(),
    owner: (0, $78ONe.optional)((0, $78ONe.string)()),
    programId: (0, $78ONe.optional)((0, $78ONe.string)()),
    uiTokenAmount: $173f28bad64492c8$var$TokenAmountResult
});
const $173f28bad64492c8$var$LoadedAddressesResult = (0, $78ONe.type)({
    writable: (0, $78ONe.array)($173f28bad64492c8$var$PublicKeyFromString),
    readonly: (0, $78ONe.array)($173f28bad64492c8$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $173f28bad64492c8$var$ConfirmedTransactionMetaResult = (0, $78ONe.type)({
    err: $173f28bad64492c8$var$TransactionErrorResult,
    fee: (0, $78ONe.number)(),
    innerInstructions: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)((0, $78ONe.type)({
        index: (0, $78ONe.number)(),
        instructions: (0, $78ONe.array)((0, $78ONe.type)({
            accounts: (0, $78ONe.array)((0, $78ONe.number)()),
            data: (0, $78ONe.string)(),
            programIdIndex: (0, $78ONe.number)()
        }))
    })))),
    preBalances: (0, $78ONe.array)((0, $78ONe.number)()),
    postBalances: (0, $78ONe.array)((0, $78ONe.number)()),
    logMessages: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)((0, $78ONe.string)()))),
    preTokenBalances: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)($173f28bad64492c8$var$TokenBalanceResult))),
    postTokenBalances: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)($173f28bad64492c8$var$TokenBalanceResult))),
    loadedAddresses: (0, $78ONe.optional)($173f28bad64492c8$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $78ONe.optional)((0, $78ONe.number)())
});
/**
 * @internal
 */ const $173f28bad64492c8$var$ParsedConfirmedTransactionMetaResult = (0, $78ONe.type)({
    err: $173f28bad64492c8$var$TransactionErrorResult,
    fee: (0, $78ONe.number)(),
    innerInstructions: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)((0, $78ONe.type)({
        index: (0, $78ONe.number)(),
        instructions: (0, $78ONe.array)($173f28bad64492c8$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $78ONe.array)((0, $78ONe.number)()),
    postBalances: (0, $78ONe.array)((0, $78ONe.number)()),
    logMessages: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)((0, $78ONe.string)()))),
    preTokenBalances: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)($173f28bad64492c8$var$TokenBalanceResult))),
    postTokenBalances: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.array)($173f28bad64492c8$var$TokenBalanceResult))),
    loadedAddresses: (0, $78ONe.optional)($173f28bad64492c8$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $78ONe.optional)((0, $78ONe.number)())
});
const $173f28bad64492c8$var$TransactionVersionStruct = (0, $78ONe.union)([
    (0, $78ONe.literal)(0),
    (0, $78ONe.literal)("legacy")
]);
/** @internal */ const $173f28bad64492c8$var$RewardsResult = (0, $78ONe.type)({
    pubkey: (0, $78ONe.string)(),
    lamports: (0, $78ONe.number)(),
    postBalance: (0, $78ONe.nullable)((0, $78ONe.number)()),
    rewardType: (0, $78ONe.nullable)((0, $78ONe.string)()),
    commission: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.number)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $173f28bad64492c8$var$GetBlockRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.type)({
    blockhash: (0, $78ONe.string)(),
    previousBlockhash: (0, $78ONe.string)(),
    parentSlot: (0, $78ONe.number)(),
    transactions: (0, $78ONe.array)((0, $78ONe.type)({
        transaction: $173f28bad64492c8$var$ConfirmedTransactionResult,
        meta: (0, $78ONe.nullable)($173f28bad64492c8$var$ConfirmedTransactionMetaResult),
        version: (0, $78ONe.optional)($173f28bad64492c8$var$TransactionVersionStruct)
    })),
    rewards: (0, $78ONe.optional)((0, $78ONe.array)($173f28bad64492c8$var$RewardsResult)),
    blockTime: (0, $78ONe.nullable)((0, $78ONe.number)()),
    blockHeight: (0, $78ONe.nullable)((0, $78ONe.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $173f28bad64492c8$var$GetNoneModeBlockRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.type)({
    blockhash: (0, $78ONe.string)(),
    previousBlockhash: (0, $78ONe.string)(),
    parentSlot: (0, $78ONe.number)(),
    rewards: (0, $78ONe.optional)((0, $78ONe.array)($173f28bad64492c8$var$RewardsResult)),
    blockTime: (0, $78ONe.nullable)((0, $78ONe.number)()),
    blockHeight: (0, $78ONe.nullable)((0, $78ONe.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $173f28bad64492c8$var$GetAccountsModeBlockRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.type)({
    blockhash: (0, $78ONe.string)(),
    previousBlockhash: (0, $78ONe.string)(),
    parentSlot: (0, $78ONe.number)(),
    transactions: (0, $78ONe.array)((0, $78ONe.type)({
        transaction: $173f28bad64492c8$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $78ONe.nullable)($173f28bad64492c8$var$ConfirmedTransactionMetaResult),
        version: (0, $78ONe.optional)($173f28bad64492c8$var$TransactionVersionStruct)
    })),
    rewards: (0, $78ONe.optional)((0, $78ONe.array)($173f28bad64492c8$var$RewardsResult)),
    blockTime: (0, $78ONe.nullable)((0, $78ONe.number)()),
    blockHeight: (0, $78ONe.nullable)((0, $78ONe.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $173f28bad64492c8$var$GetParsedBlockRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.type)({
    blockhash: (0, $78ONe.string)(),
    previousBlockhash: (0, $78ONe.string)(),
    parentSlot: (0, $78ONe.number)(),
    transactions: (0, $78ONe.array)((0, $78ONe.type)({
        transaction: $173f28bad64492c8$var$ParsedConfirmedTransactionResult,
        meta: (0, $78ONe.nullable)($173f28bad64492c8$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $78ONe.optional)($173f28bad64492c8$var$TransactionVersionStruct)
    })),
    rewards: (0, $78ONe.optional)((0, $78ONe.array)($173f28bad64492c8$var$RewardsResult)),
    blockTime: (0, $78ONe.nullable)((0, $78ONe.number)()),
    blockHeight: (0, $78ONe.nullable)((0, $78ONe.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $173f28bad64492c8$var$GetParsedAccountsModeBlockRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.type)({
    blockhash: (0, $78ONe.string)(),
    previousBlockhash: (0, $78ONe.string)(),
    parentSlot: (0, $78ONe.number)(),
    transactions: (0, $78ONe.array)((0, $78ONe.type)({
        transaction: $173f28bad64492c8$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $78ONe.nullable)($173f28bad64492c8$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $78ONe.optional)($173f28bad64492c8$var$TransactionVersionStruct)
    })),
    rewards: (0, $78ONe.optional)((0, $78ONe.array)($173f28bad64492c8$var$RewardsResult)),
    blockTime: (0, $78ONe.nullable)((0, $78ONe.number)()),
    blockHeight: (0, $78ONe.nullable)((0, $78ONe.number)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $173f28bad64492c8$var$GetParsedNoneModeBlockRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.type)({
    blockhash: (0, $78ONe.string)(),
    previousBlockhash: (0, $78ONe.string)(),
    parentSlot: (0, $78ONe.number)(),
    rewards: (0, $78ONe.optional)((0, $78ONe.array)($173f28bad64492c8$var$RewardsResult)),
    blockTime: (0, $78ONe.nullable)((0, $78ONe.number)()),
    blockHeight: (0, $78ONe.nullable)((0, $78ONe.number)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $173f28bad64492c8$var$GetConfirmedBlockRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.type)({
    blockhash: (0, $78ONe.string)(),
    previousBlockhash: (0, $78ONe.string)(),
    parentSlot: (0, $78ONe.number)(),
    transactions: (0, $78ONe.array)((0, $78ONe.type)({
        transaction: $173f28bad64492c8$var$ConfirmedTransactionResult,
        meta: (0, $78ONe.nullable)($173f28bad64492c8$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $78ONe.optional)((0, $78ONe.array)($173f28bad64492c8$var$RewardsResult)),
    blockTime: (0, $78ONe.nullable)((0, $78ONe.number)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $173f28bad64492c8$var$GetBlockSignaturesRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.type)({
    blockhash: (0, $78ONe.string)(),
    previousBlockhash: (0, $78ONe.string)(),
    parentSlot: (0, $78ONe.number)(),
    signatures: (0, $78ONe.array)((0, $78ONe.string)()),
    blockTime: (0, $78ONe.nullable)((0, $78ONe.number)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $173f28bad64492c8$var$GetTransactionRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.type)({
    slot: (0, $78ONe.number)(),
    meta: (0, $78ONe.nullable)($173f28bad64492c8$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.number)())),
    transaction: $173f28bad64492c8$var$ConfirmedTransactionResult,
    version: (0, $78ONe.optional)($173f28bad64492c8$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $173f28bad64492c8$var$GetParsedTransactionRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.type)({
    slot: (0, $78ONe.number)(),
    transaction: $173f28bad64492c8$var$ParsedConfirmedTransactionResult,
    meta: (0, $78ONe.nullable)($173f28bad64492c8$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $78ONe.optional)((0, $78ONe.nullable)((0, $78ONe.number)())),
    version: (0, $78ONe.optional)($173f28bad64492c8$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $173f28bad64492c8$var$GetLatestBlockhashRpcResult = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.type)({
    blockhash: (0, $78ONe.string)(),
    lastValidBlockHeight: (0, $78ONe.number)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $173f28bad64492c8$var$IsBlockhashValidRpcResult = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.boolean)());
const $173f28bad64492c8$var$PerfSampleResult = (0, $78ONe.type)({
    slot: (0, $78ONe.number)(),
    numTransactions: (0, $78ONe.number)(),
    numSlots: (0, $78ONe.number)(),
    samplePeriodSecs: (0, $78ONe.number)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $173f28bad64492c8$var$GetRecentPerformanceSamplesRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.array)($173f28bad64492c8$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $173f28bad64492c8$var$GetFeeCalculatorRpcResult = $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.nullable)((0, $78ONe.type)({
    feeCalculator: (0, $78ONe.type)({
        lamportsPerSignature: (0, $78ONe.number)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $173f28bad64492c8$var$RequestAirdropRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.string)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $173f28bad64492c8$var$SendTransactionRpcResult = $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.string)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $173f28bad64492c8$var$LogsResult = (0, $78ONe.type)({
    err: $173f28bad64492c8$var$TransactionErrorResult,
    logs: (0, $78ONe.array)((0, $78ONe.string)()),
    signature: (0, $78ONe.string)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $173f28bad64492c8$var$LogsNotificationResult = (0, $78ONe.type)({
    result: $173f28bad64492c8$var$notificationResultAndContext($173f28bad64492c8$var$LogsResult),
    subscription: (0, $78ONe.number)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $173f28bad64492c8$var$COMMON_HTTP_HEADERS = {
    "solana-client": `js/${"1.0.0-maintenance"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $173f28bad64492c8$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $173f28bad64492c8$var$fastStableStringify(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest("getBlockHeight", args);
                        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.number)()));
                        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get block height information");
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === "string") this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $173f28bad64492c8$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $173f28bad64492c8$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $173f28bad64492c8$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $173f28bad64492c8$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $173f28bad64492c8$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $173f28bad64492c8$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on("open", this._wsOnOpen.bind(this));
        this._rpcWebSocket.on("error", this._wsOnError.bind(this));
        this._rpcWebSocket.on("close", this._wsOnClose.bind(this));
        this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBalance", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.number)()));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get balance of account " + publicKey.toBase58() + ": " + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest("getBlockTime", [
            slot
        ]);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.nullable)((0, $78ONe.number)())));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest("minimumLedgerSlot", []);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.number)()));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get minimum ledger slot");
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest("getFirstAvailableBlock", []);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$SlotRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get first available block");
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === "string") configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest("getSupply", [
            configArg
        ]);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetSupplyRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get supply");
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenSupply", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResultAndContext($173f28bad64492c8$var$TokenAmountResult));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get token supply");
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenAccountBalance", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResultAndContext($173f28bad64492c8$var$TokenAmountResult));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get token account balance");
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetTokenAccountsByOwner);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetParsedTokenAccountsByOwner);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest("getLargestAccounts", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetLargestAccountsRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get largest accounts");
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenLargestAccounts", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetTokenLargestAccountsResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get token largest accounts");
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.nullable)($173f28bad64492c8$var$AccountInfoResult)));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.nullable)($173f28bad64492c8$var$ParsedAccountInfoResult)));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get info about account " + publicKey.toBase58() + ": " + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.array)((0, $78ONe.nullable)($173f28bad64492c8$var$ParsedAccountInfoResult))));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.array)((0, $78ONe.nullable)($173f28bad64492c8$var$AccountInfoResult))));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   *
   * @deprecated Deprecated since RPC v1.18; will be removed in a future version.
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getStakeActivation", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult($173f28bad64492c8$var$StakeActivationResult));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || "base64", {
            ...configWithoutEncoding,
            ...configWithoutEncoding.filters ? {
                filters: $173f28bad64492c8$var$applyDefaultMemcmpEncodingToFilters(configWithoutEncoding.filters)
            } : null
        });
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const baseSchema = (0, $78ONe.array)($173f28bad64492c8$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResultAndContext(baseSchema)) : (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult(baseSchema));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.array)($173f28bad64492c8$var$KeyedParsedAccountInfoResult)));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == "string") rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($cqBHq))).decode(rawSignature);
        } catch (err) {
            throw new Error("signature must be base58 encoded: " + rawSignature);
        }
        $173f28bad64492c8$var$assert(decodedSignature.length === 64, "signature has invalid length");
        if (typeof strategy === "string") return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ("lastValidBlockHeight" in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $173f28bad64492c8$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === "subscribed") resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case "confirmed":
                            case "single":
                            case "singleGossip":
                                if (value.confirmationStatus === "processed") return;
                                break;
                            case "finalized":
                            case "max":
                            case "root":
                                if (value.confirmationStatus === "processed" || value.confirmationStatus === "confirmed") return;
                                break;
                            // exhaust enums to ensure full coverage
                            case "processed":
                            case "recent":
                        }
                        done = true;
                        resolve({
                            __type: $173f28bad64492c8$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $173f28bad64492c8$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $173f28bad64492c8$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $173f28bad64492c8$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $173f28bad64492c8$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $173f28bad64492c8$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $173f28bad64492c8$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $173f28bad64492c8$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $173f28bad64492c8$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || "finalized";
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case "processed":
                        case "recent":
                            if (confirmationStatus !== "processed" && confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $173f28bad64492c8$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "confirmed":
                        case "single":
                        case "singleGossip":
                            if (confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $173f28bad64492c8$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "finalized":
                        case "max":
                        case "root":
                            if (confirmationStatus !== "finalized") throw new $173f28bad64492c8$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $173f28bad64492c8$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case "processed":
                case "recent":
                case "single":
                case "confirmed":
                case "singleGossip":
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $173f28bad64492c8$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $173f28bad64492c8$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $173f28bad64492c8$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest("getClusterNodes", []);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.array)($173f28bad64492c8$var$ContactInfoResult)));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get cluster nodes");
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getVoteAccounts", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetVoteAccounts);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get vote accounts");
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlot", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.number)()));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get slot");
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlotLeader", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.string)()));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leader");
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest("getSlotLeaders", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.array)($173f28bad64492c8$var$PublicKeyFromString)));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leaders");
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $173f28bad64492c8$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest("getSignatureStatuses", params);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetSignatureStatusesRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get signature status");
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransactionCount", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.number)()));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction count");
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since RPC v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getInflationGovernor", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetInflationGovernorRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation");
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getInflationReward", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetInflationRewardResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation reward");
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest("getInflationRate", []);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetInflationRateRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation rate");
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getEpochInfo", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetEpochInfoRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch info");
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest("getEpochSchedule", []);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetEpochScheduleRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch schedule");
        const epochSchedule = res.result;
        return new $173f28bad64492c8$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest("getLeaderSchedule", []);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetLeaderScheduleRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get leader schedule");
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest("getMinimumBalanceForRentExemption", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ("error" in res) {
            console.warn("Unable to fetch minimum balance for rent exemption");
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const { context: context, value: { blockhash: blockhash } } = await this.getLatestBlockhashAndContext(commitment);
        const feeCalculator = {
            get lamportsPerSignature () {
                throw new Error("The capability to fetch `lamportsPerSignature` using the `getRecentBlockhash` API is no longer offered by the network. Use the `getFeeForMessage` API to obtain the fee for a given message.");
            },
            toJSON () {
                return {};
            }
        };
        return {
            context: context,
            value: {
                blockhash: blockhash,
                feeCalculator: feeCalculator
            }
        };
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest("getRecentPerformanceSamples", limit ? [
            limit
        ] : []);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetRecentPerformanceSamplesRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get recent performance samples");
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeCalculatorForBlockhash", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetFeeCalculatorRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get fee calculator");
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $173f28bad64492c8$var$toBuffer(message.serialize()).toString("base64");
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeForMessage", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.nullable)((0, $78ONe.number)())));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get fee for message");
        if (res.result === null) throw new Error("invalid blockhash");
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest("getRecentPrioritizationFees", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetRecentPrioritizationFeesRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get recent prioritization fees");
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since RPC v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getLatestBlockhash", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetLatestBlockhashRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get latest blockhash");
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("isBlockhashValid", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$IsBlockhashValidRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to determine if the blockhash `" + blockhash + "`is valid");
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest("getVersion", []);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult($173f28bad64492c8$var$VersionResult));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get version");
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest("getGenesisHash", []);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.string)()));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get genesis hash");
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetBlockRpcResult);
                        if ("error" in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $173f28bad64492c8$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(e, "failed to get confirmed block");
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetParsedAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetParsedNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetParsedBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(e, "failed to get block");
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === "string") commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, "base64", extra);
        const unsafeRes = await this._rpcRequest("getBlockProduction", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$BlockProductionResponseStruct);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get block production information");
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetTransactionRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $173f28bad64492c8$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed", config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetTransactionRpcResult);
            if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $173f28bad64492c8$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetConfirmedBlockRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $173f28bad64492c8$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $173f28bad64492c8$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getBlocks", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResult((0, $78ONe.array)((0, $78ONe.number)())));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get blocks");
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get block");
        const result = res.result;
        if (!result) throw new Error("Block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetTransactionRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        const message = new $173f28bad64492c8$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $173f28bad64492c8$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed");
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since RPC v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!("until" in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, "finalized");
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot("finalized");
        while(!("before" in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getSignaturesForAddress} instead.
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getConfirmedSignaturesForAddress2", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed signatures for address");
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getSignaturesForAddress", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$GetSignaturesForAddressRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, "failed to get signatures for address");
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $173f28bad64492c8$export$5b2310da10e607da({
            key: accountKey,
            state: $173f28bad64492c8$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $173f28bad64492c8$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get nonce for account " + nonceAccount.toBase58() + ": " + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest("requestAirdrop", [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$RequestAirdropRpcResult);
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $173f28bad64492c8$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $173f28bad64492c8$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash("finalized");
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $173f28bad64492c8$var$sleep($173f28bad64492c8$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $173f28bad64492c8$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, "base64", configArg);
        const unsafeRes = await this._rpcRequest("getStakeMinimumDelegation", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$jsonRpcResultAndContext((0, $78ONe.number)()));
        if ("error" in res) throw new $173f28bad64492c8$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ("message" in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $gynfp.Buffer).from(wireTransaction).toString("base64");
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error("Invalid arguments");
            const config = configOrSigners || {};
            config.encoding = "base64";
            if (!("commitment" in config)) config.commitment = this.commitment;
            if (configOrSigners && typeof configOrSigners === "object" && "innerInstructions" in configOrSigners) config.innerInstructions = configOrSigners.innerInstructions;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest("simulateTransaction", args);
            const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$SimulatedTransactionResponseStruct);
            if ("error" in res) throw new Error("failed to simulate transaction: " + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $173f28bad64492c8$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $173f28bad64492c8$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $173f28bad64492c8$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error("Invalid arguments");
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString("base64");
        const config = {
            encoding: "base64",
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config["accounts"] = {
                encoding: "base64",
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        if (configOrSigners && typeof configOrSigners === "object" && "innerInstructions" in configOrSigners) config.innerInstructions = configOrSigners.innerInstructions;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("simulateTransaction", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$SimulatedTransactionResponseStruct);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = "\n    ";
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $173f28bad64492c8$export$121e803f723b3045({
                action: "simulate",
                signature: "",
                transactionMessage: res.error.message,
                logs: logs
            });
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ("version" in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $173f28bad64492c8$var$toBuffer(rawTransaction).toString("base64");
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: "base64"
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = skipPreflight === true ? "processed" // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
         : options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("sendTransaction", args);
        const res = (0, $78ONe.create)(unsafeRes, $173f28bad64492c8$var$SendTransactionRpcResult);
        if ("error" in res) {
            let logs = undefined;
            if ("data" in res.error) logs = res.error.data.logs;
            throw new $173f28bad64492c8$export$121e803f723b3045({
                action: skipPreflight ? "send" : "simulate",
                signature: "",
                transactionMessage: res.error.message,
                logs: logs
            });
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify("ping");
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error("ws error:", err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: "pending"
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case "pending":
                case "unsubscribed":
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === "unsubscribed") delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "subscribing"
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: "subscribed"
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            console.error(`Received ${e instanceof Error ? "" : "JSON-RPC "}error calling \`${method}\``, {
                                args: args,
                                error: e
                            });
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "pending"
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case "subscribed":
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: "subscribed"
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: "unsubscribed"
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $78ONe.create)(notification, $173f28bad64492c8$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $173f28bad64492c8$var$fastStableStringify([
            subscriptionConfig.method,
            args
        ]);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: "pending"
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $173f28bad64492c8$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in an {@link AccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    onAccountChange(publicKey, callback, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64", config);
        return this._makeSubscription({
            callback: callback,
            method: "accountSubscribe",
            unsubscribeMethod: "accountUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "account change");
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $78ONe.create)(notification, $173f28bad64492c8$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in a {@link ProgramAccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    onProgramAccountChange(programId, callback, commitmentOrConfig, maybeFilters) {
        const { commitment: commitment, config: config } = $173f28bad64492c8$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64" /* encoding */ , config ? config : maybeFilters ? {
            filters: $173f28bad64492c8$var$applyDefaultMemcmpEncodingToFilters(maybeFilters)
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: "programSubscribe",
            unsubscribeMethod: "programUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "program account change");
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === "object" ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: "logsSubscribe",
            unsubscribeMethod: "logsUnsubscribe"
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "logs");
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $78ONe.create)(notification, $173f28bad64492c8$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $78ONe.create)(notification, $173f28bad64492c8$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotSubscribe",
            unsubscribeMethod: "slotUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot change");
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $78ONe.create)(notification, $173f28bad64492c8$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotsUpdatesSubscribe",
            unsubscribeMethod: "slotsUpdatesUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot update");
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn("Ignored unsubscribe request because an active subscription with id " + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + "could not be found.");
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            "confirmed",
            "finalized"
        ].includes(commitment)) throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $78ONe.create)(notification, $173f28bad64492c8$var$SignatureNotificationResult);
        if (result.value !== "receivedSignature") /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === "receivedSignature" ? [
            {
                type: "received"
            },
            result.context
        ] : [
            {
                type: "status",
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === "status") {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || "finalized" // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "signature result");
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $78ONe.create)(notification, $173f28bad64492c8$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "rootSubscribe",
            unsubscribeMethod: "rootUnsubscribe"
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "root change");
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $173f28bad64492c8$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $173f28bad64492c8$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $173f28bad64492c8$export$c53bca448cf33676($173f28bad64492c8$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error("bad secret key size");
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $173f28bad64492c8$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error("provided secretKey is invalid");
            }
        }
        return new $173f28bad64492c8$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $173f28bad64492c8$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $173f28bad64492c8$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $173f28bad64492c8$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $173f28bad64492c8$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$u64("recentSlot"),
            $Bz0HP.u8("bumpSeed")
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction")
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$u64(),
            $Bz0HP.seq($173f28bad64492c8$var$publicKey(), $Bz0HP.offset($Bz0HP.u32(), -8), "addresses")
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction")
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction")
        ])
    }
});
class $173f28bad64492c8$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Bz0HP.u32("instruction");
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($173f28bad64492c8$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $173f28bad64492c8$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($173f28bad64492c8$export$5147a345798de168.programId)) throw new Error("invalid instruction; programId is not AddressLookupTable Program");
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $173f28bad64492c8$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $173f28bad64492c8$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $dZYIo.toBufferLE)(BigInt(params.recentSlot), 8)
        ], this.programId);
        const type = $173f28bad64492c8$export$7d102200c3a357d6.CreateLookupTable;
        const data = $173f28bad64492c8$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $173f28bad64492c8$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $173f28bad64492c8$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $173f28bad64492c8$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $173f28bad64492c8$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $173f28bad64492c8$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $173f28bad64492c8$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $173f28bad64492c8$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $173f28bad64492c8$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $173f28bad64492c8$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $173f28bad64492c8$export$7d102200c3a357d6.CloseLookupTable;
        const data = $173f28bad64492c8$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$173f28bad64492c8$export$5147a345798de168.programId = new $173f28bad64492c8$export$ca8b6604d6ce14de("AddressLookupTab1e1111111111111111111111111");
/**
 * Compute Budget Instruction class
 */ class $173f28bad64492c8$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Bz0HP.u8("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($173f28bad64492c8$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($173f28bad64492c8$export$11585db5942bcdb7.programId)) throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $173f28bad64492c8$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $Bz0HP.struct([
            $Bz0HP.u8("instruction"),
            $Bz0HP.u32("units"),
            $Bz0HP.u32("additionalFee")
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $Bz0HP.struct([
            $Bz0HP.u8("instruction"),
            $Bz0HP.u32("bytes")
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $Bz0HP.struct([
            $Bz0HP.u8("instruction"),
            $Bz0HP.u32("units")
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $Bz0HP.struct([
            $Bz0HP.u8("instruction"),
            $173f28bad64492c8$var$u64("microLamports")
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $173f28bad64492c8$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $173f28bad64492c8$export$b7c79c50764da3d6.RequestUnits;
        const data = $173f28bad64492c8$var$encodeData(type, params);
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $173f28bad64492c8$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $173f28bad64492c8$var$encodeData(type, params);
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $173f28bad64492c8$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $173f28bad64492c8$var$encodeData(type, params);
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $173f28bad64492c8$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $173f28bad64492c8$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$173f28bad64492c8$export$11585db5942bcdb7.programId = new $173f28bad64492c8$export$ca8b6604d6ce14de("ComputeBudget111111111111111111111111111111");
const $173f28bad64492c8$var$PRIVATE_KEY_BYTES$1 = 64;
const $173f28bad64492c8$var$PUBLIC_KEY_BYTES$1 = 32;
const $173f28bad64492c8$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $173f28bad64492c8$var$ED25519_INSTRUCTION_LAYOUT = $Bz0HP.struct([
    $Bz0HP.u8("numSignatures"),
    $Bz0HP.u8("padding"),
    $Bz0HP.u16("signatureOffset"),
    $Bz0HP.u16("signatureInstructionIndex"),
    $Bz0HP.u16("publicKeyOffset"),
    $Bz0HP.u16("publicKeyInstructionIndex"),
    $Bz0HP.u16("messageDataOffset"),
    $Bz0HP.u16("messageDataSize"),
    $Bz0HP.u16("messageInstructionIndex")
]);
class $173f28bad64492c8$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $173f28bad64492c8$var$assert(publicKey.length === $173f28bad64492c8$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$173f28bad64492c8$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $173f28bad64492c8$var$assert(signature.length === $173f28bad64492c8$var$SIGNATURE_BYTES, `Signature must be ${$173f28bad64492c8$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $173f28bad64492c8$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $gynfp.Buffer).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $173f28bad64492c8$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $173f28bad64492c8$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $173f28bad64492c8$var$assert(privateKey.length === $173f28bad64492c8$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$173f28bad64492c8$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $173f28bad64492c8$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $173f28bad64492c8$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$173f28bad64492c8$export$e5087aea02631e.programId = new $173f28bad64492c8$export$ca8b6604d6ce14de("Ed25519SigVerify111111111111111111111111111");
const $173f28bad64492c8$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $3ZrHu.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $3ZrHu.secp256k1).utils.isValidPrivateKey;
const $173f28bad64492c8$var$publicKeyCreate = (0, $3ZrHu.secp256k1).getPublicKey;
const $173f28bad64492c8$var$PRIVATE_KEY_BYTES = 32;
const $173f28bad64492c8$var$ETHEREUM_ADDRESS_BYTES = 20;
const $173f28bad64492c8$var$PUBLIC_KEY_BYTES = 64;
const $173f28bad64492c8$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $173f28bad64492c8$var$SECP256K1_INSTRUCTION_LAYOUT = $Bz0HP.struct([
    $Bz0HP.u8("numSignatures"),
    $Bz0HP.u16("signatureOffset"),
    $Bz0HP.u8("signatureInstructionIndex"),
    $Bz0HP.u16("ethAddressOffset"),
    $Bz0HP.u8("ethAddressInstructionIndex"),
    $Bz0HP.u16("messageDataOffset"),
    $Bz0HP.u16("messageDataSize"),
    $Bz0HP.u8("messageInstructionIndex"),
    $Bz0HP.blob(20, "ethAddress"),
    $Bz0HP.blob(64, "signature"),
    $Bz0HP.u8("recoveryId")
]);
class $173f28bad64492c8$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $173f28bad64492c8$var$assert(publicKey.length === $173f28bad64492c8$var$PUBLIC_KEY_BYTES, `Public key must be ${$173f28bad64492c8$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $gynfp.Buffer).from((0, $6xU83.keccak_256)($173f28bad64492c8$var$toBuffer(publicKey))).slice(-$173f28bad64492c8$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $173f28bad64492c8$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $173f28bad64492c8$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === "string") {
            if (rawAddress.startsWith("0x")) ethAddress = (0, $gynfp.Buffer).from(rawAddress.substr(2), "hex");
            else ethAddress = (0, $gynfp.Buffer).from(rawAddress, "hex");
        } else ethAddress = rawAddress;
        $173f28bad64492c8$var$assert(ethAddress.length === $173f28bad64492c8$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$173f28bad64492c8$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $173f28bad64492c8$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $gynfp.Buffer).alloc($173f28bad64492c8$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $173f28bad64492c8$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $173f28bad64492c8$var$toBuffer(signature),
            ethAddress: $173f28bad64492c8$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($173f28bad64492c8$var$toBuffer(message), $173f28bad64492c8$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $173f28bad64492c8$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $173f28bad64492c8$var$assert(pkey.length === $173f28bad64492c8$var$PRIVATE_KEY_BYTES, `Private key must be ${$173f28bad64492c8$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $173f28bad64492c8$var$toBuffer(pkey);
            const publicKey = $173f28bad64492c8$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $gynfp.Buffer).from((0, $6xU83.keccak_256)($173f28bad64492c8$var$toBuffer(message)));
            const [signature, recoveryId] = $173f28bad64492c8$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$173f28bad64492c8$export$d85dd4c1161d13c9.programId = new $173f28bad64492c8$export$ca8b6604d6ce14de("KeccakSecp256k11111111111111111111111111111");
var $173f28bad64492c8$var$_Lockup;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $173f28bad64492c8$export$18aac71979bdd08f = new $173f28bad64492c8$export$ca8b6604d6ce14de("StakeConfig11111111111111111111111111111111");
/**
 * Stake account authority info
 */ class $173f28bad64492c8$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $173f28bad64492c8$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$173f28bad64492c8$var$_Lockup = $173f28bad64492c8$export$e7f3941ade35598c;
$173f28bad64492c8$export$e7f3941ade35598c.default = new $173f28bad64492c8$var$_Lockup(0, 0, $173f28bad64492c8$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $173f28bad64492c8$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Bz0HP.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($173f28bad64492c8$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a StakeInstruction");
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $173f28bad64492c8$export$9ac74ae66932a145(new $173f28bad64492c8$export$ca8b6604d6ce14de(authorized.staker), new $173f28bad64492c8$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $173f28bad64492c8$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $173f28bad64492c8$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $173f28bad64492c8$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($173f28bad64492c8$export$df86f933e9f8fb15.programId)) throw new Error("invalid instruction; programId is not StakeProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $173f28bad64492c8$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$authorized(),
            $173f28bad64492c8$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$publicKey("newAuthorized"),
            $Bz0HP.u32("stakeAuthorizationType")
        ])
    },
    Delegate: {
        index: 2,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction")
        ])
    },
    Split: {
        index: 3,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $Bz0HP.ns64("lamports")
        ])
    },
    Withdraw: {
        index: 4,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $Bz0HP.ns64("lamports")
        ])
    },
    Deactivate: {
        index: 5,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction")
        ])
    },
    Merge: {
        index: 7,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$publicKey("newAuthorized"),
            $Bz0HP.u32("stakeAuthorizationType"),
            $173f28bad64492c8$var$rustString("authoritySeed"),
            $173f28bad64492c8$var$publicKey("authorityOwner")
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $173f28bad64492c8$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $173f28bad64492c8$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $173f28bad64492c8$export$e7f3941ade35598c.default;
        const type = $173f28bad64492c8$export$c89793bd2bba8b2e.Initialize;
        const data = $173f28bad64492c8$var$encodeData(type, {
            authorized: {
                staker: $173f28bad64492c8$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $173f28bad64492c8$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $173f28bad64492c8$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $173f28bad64492c8$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $173f28bad64492c8$export$febc5573c75cefb0();
        transaction.add($173f28bad64492c8$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $173f28bad64492c8$export$febc5573c75cefb0();
        transaction.add($173f28bad64492c8$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $173f28bad64492c8$export$c89793bd2bba8b2e.Delegate;
        const data = $173f28bad64492c8$var$encodeData(type);
        return new $173f28bad64492c8$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $173f28bad64492c8$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $173f28bad64492c8$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $173f28bad64492c8$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $173f28bad64492c8$export$c89793bd2bba8b2e.Authorize;
        const data = $173f28bad64492c8$var$encodeData(type, {
            newAuthorized: $173f28bad64492c8$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $173f28bad64492c8$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $173f28bad64492c8$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $173f28bad64492c8$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $173f28bad64492c8$var$encodeData(type, {
            newAuthorized: $173f28bad64492c8$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $173f28bad64492c8$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $173f28bad64492c8$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $173f28bad64492c8$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $173f28bad64492c8$export$c89793bd2bba8b2e.Split;
        const data = $173f28bad64492c8$var$encodeData(type, {
            lamports: lamports
        });
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params, // Compute the cost of allocating the new stake account in lamports
    rentExemptReserve) {
        const transaction = new $173f28bad64492c8$export$febc5573c75cefb0();
        transaction.add($173f28bad64492c8$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: rentExemptReserve,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
    rentExemptReserve) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $173f28bad64492c8$export$febc5573c75cefb0();
        transaction.add($173f28bad64492c8$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        if (rentExemptReserve && rentExemptReserve > 0) transaction.add($173f28bad64492c8$export$d8c4e17726848113.transfer({
            fromPubkey: params.authorizedPubkey,
            toPubkey: splitStakePubkey,
            lamports: rentExemptReserve
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $173f28bad64492c8$export$c89793bd2bba8b2e.Merge;
        const data = $173f28bad64492c8$var$encodeData(type);
        return new $173f28bad64492c8$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $173f28bad64492c8$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $173f28bad64492c8$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $173f28bad64492c8$export$c89793bd2bba8b2e.Withdraw;
        const data = $173f28bad64492c8$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $173f28bad64492c8$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $173f28bad64492c8$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $173f28bad64492c8$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $173f28bad64492c8$export$c89793bd2bba8b2e.Deactivate;
        const data = $173f28bad64492c8$var$encodeData(type);
        return new $173f28bad64492c8$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $173f28bad64492c8$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$173f28bad64492c8$export$df86f933e9f8fb15.programId = new $173f28bad64492c8$export$ca8b6604d6ce14de("Stake11111111111111111111111111111111111111");
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $173f28bad64492c8$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $173f28bad64492c8$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ class $173f28bad64492c8$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $Bz0HP.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a VoteInstruction");
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $173f28bad64492c8$export$3f9d1b16ff840d7(new $173f28bad64492c8$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $173f28bad64492c8$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $173f28bad64492c8$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $173f28bad64492c8$var$decodeData$1($173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($173f28bad64492c8$export$83db2bc702bee1eb.programId)) throw new Error("invalid instruction; programId is not VoteProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$publicKey("newAuthorized"),
            $Bz0HP.u32("voteAuthorizationType")
        ])
    },
    Withdraw: {
        index: 3,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $Bz0HP.ns64("lamports")
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $Bz0HP.struct([
            $Bz0HP.u32("instruction"),
            $173f28bad64492c8$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $173f28bad64492c8$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $173f28bad64492c8$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $173f28bad64492c8$var$encodeData(type, {
            voteInit: {
                nodePubkey: $173f28bad64492c8$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $173f28bad64492c8$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $173f28bad64492c8$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $173f28bad64492c8$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $173f28bad64492c8$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $173f28bad64492c8$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $173f28bad64492c8$export$febc5573c75cefb0();
        transaction.add($173f28bad64492c8$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $173f28bad64492c8$var$encodeData(type, {
            newAuthorized: $173f28bad64492c8$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $173f28bad64492c8$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $173f28bad64492c8$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $173f28bad64492c8$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $173f28bad64492c8$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $173f28bad64492c8$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $173f28bad64492c8$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $173f28bad64492c8$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $173f28bad64492c8$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $173f28bad64492c8$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error("Withdraw will leave vote account with insufficient funds.");
        return $173f28bad64492c8$export$83db2bc702bee1eb.withdraw(params);
    }
    /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ static updateValidatorIdentity(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, nodePubkey: nodePubkey } = params;
        const type = $173f28bad64492c8$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
        const data = $173f28bad64492c8$var$encodeData(type);
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: nodePubkey,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $173f28bad64492c8$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$173f28bad64492c8$export$83db2bc702bee1eb.programId = new $173f28bad64492c8$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $173f28bad64492c8$export$83db2bc702bee1eb.space = 3762;
const $173f28bad64492c8$export$afdb09d3afdde87c = new $173f28bad64492c8$export$ca8b6604d6ce14de("Va1idator1nfo111111111111111111111111111111");
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $173f28bad64492c8$var$InfoString = (0, $78ONe.type)({
    name: (0, $78ONe.string)(),
    website: (0, $78ONe.optional)((0, $78ONe.string)()),
    details: (0, $78ONe.optional)((0, $78ONe.string)()),
    iconUrl: (0, $78ONe.optional)((0, $78ONe.string)()),
    keybaseUsername: (0, $78ONe.optional)((0, $78ONe.string)())
});
/**
 * ValidatorInfo class
 */ class $173f28bad64492c8$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $173f28bad64492c8$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $173f28bad64492c8$export$ca8b6604d6ce14de($173f28bad64492c8$var$guardedSplice(byteArray, 0, $173f28bad64492c8$export$84fc0a248cc54343));
            const isSigner = $173f28bad64492c8$var$guardedShift(byteArray) === 1;
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($173f28bad64492c8$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $173f28bad64492c8$var$rustString().decode((0, $gynfp.Buffer).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $78ONe.assert)(info, $173f28bad64492c8$var$InfoString);
                return new $173f28bad64492c8$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $173f28bad64492c8$export$90bca02a3aea0768 = new $173f28bad64492c8$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $173f28bad64492c8$var$VoteAccountLayout = $Bz0HP.struct([
    $173f28bad64492c8$var$publicKey("nodePubkey"),
    $173f28bad64492c8$var$publicKey("authorizedWithdrawer"),
    $Bz0HP.u8("commission"),
    $Bz0HP.nu64(),
    // votes.length
    $Bz0HP.seq($Bz0HP.struct([
        $Bz0HP.nu64("slot"),
        $Bz0HP.u32("confirmationCount")
    ]), $Bz0HP.offset($Bz0HP.u32(), -8), "votes"),
    $Bz0HP.u8("rootSlotValid"),
    $Bz0HP.nu64("rootSlot"),
    $Bz0HP.nu64(),
    // authorizedVoters.length
    $Bz0HP.seq($Bz0HP.struct([
        $Bz0HP.nu64("epoch"),
        $173f28bad64492c8$var$publicKey("authorizedVoter")
    ]), $Bz0HP.offset($Bz0HP.u32(), -8), "authorizedVoters"),
    $Bz0HP.struct([
        $Bz0HP.seq($Bz0HP.struct([
            $173f28bad64492c8$var$publicKey("authorizedPubkey"),
            $Bz0HP.nu64("epochOfLastAuthorizedSwitch"),
            $Bz0HP.nu64("targetEpoch")
        ]), 32, "buf"),
        $Bz0HP.nu64("idx"),
        $Bz0HP.u8("isEmpty")
    ], "priorVoters"),
    $Bz0HP.nu64(),
    // epochCredits.length
    $Bz0HP.seq($Bz0HP.struct([
        $Bz0HP.nu64("epoch"),
        $Bz0HP.nu64("credits"),
        $Bz0HP.nu64("prevCredits")
    ]), $Bz0HP.offset($Bz0HP.u32(), -8), "epochCredits"),
    $Bz0HP.struct([
        $Bz0HP.nu64("slot"),
        $Bz0HP.nu64("timestamp")
    ], "lastTimestamp")
]);
/**
 * VoteAccount class
 */ class $173f28bad64492c8$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $173f28bad64492c8$var$VoteAccountLayout.decode($173f28bad64492c8$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $173f28bad64492c8$export$89ef186f708d638b({
            nodePubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $173f28bad64492c8$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($173f28bad64492c8$var$parseAuthorizedVoter),
            priorVoters: $173f28bad64492c8$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $173f28bad64492c8$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $173f28bad64492c8$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $173f28bad64492c8$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $173f28bad64492c8$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $173f28bad64492c8$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($173f28bad64492c8$var$parsePriorVoters),
        ...buf.slice(0, idx).map($173f28bad64492c8$var$parsePriorVoters)
    ];
}
const $173f28bad64492c8$var$endpoint = {
    http: {
        devnet: "http://api.devnet.solana.com",
        testnet: "http://api.testnet.solana.com",
        "mainnet-beta": "http://api.mainnet-beta.solana.com/"
    },
    https: {
        devnet: "https://api.devnet.solana.com",
        testnet: "https://api.testnet.solana.com",
        "mainnet-beta": "https://api.mainnet-beta.solana.com/"
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $173f28bad64492c8$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? "http" : "https";
    if (!cluster) return $173f28bad64492c8$var$endpoint[key]["devnet"];
    const url = $173f28bad64492c8$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $173f28bad64492c8$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "lastValidBlockHeight")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "nonceValue")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) {
        if (signature != null) throw new $173f28bad64492c8$export$121e803f723b3045({
            action: sendOptions?.skipPreflight ? "send" : "simulate",
            signature: signature,
            transactionMessage: `Status: (${JSON.stringify(status)})`
        });
        throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    }
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $173f28bad64492c8$export$5f6a2f2669741bbe = 1000000000;

});
parcelRegister("gynfp", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c0d1dad15cdb40e8$export$a143d493d941bafc; }, function (v) { return $c0d1dad15cdb40e8$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c0d1dad15cdb40e8$export$f99ded8fe4b79145; }, function (v) { return $c0d1dad15cdb40e8$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c0d1dad15cdb40e8$export$a143d493d941bafc;
var $c0d1dad15cdb40e8$export$e4cf37d7f6fb9e0a;
var $c0d1dad15cdb40e8$export$f99ded8fe4b79145;
var $c0d1dad15cdb40e8$export$599f31c3813fae4d;
"use strict";

var $gxC2H = parcelRequire("gxC2H");

var $8YfQz = parcelRequire("8YfQz");
const $c0d1dad15cdb40e8$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c0d1dad15cdb40e8$export$a143d493d941bafc = $c0d1dad15cdb40e8$var$Buffer;
$c0d1dad15cdb40e8$export$e4cf37d7f6fb9e0a = $c0d1dad15cdb40e8$var$SlowBuffer;
$c0d1dad15cdb40e8$export$f99ded8fe4b79145 = 50;
const $c0d1dad15cdb40e8$var$K_MAX_LENGTH = 0x7fffffff;
$c0d1dad15cdb40e8$export$599f31c3813fae4d = $c0d1dad15cdb40e8$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c0d1dad15cdb40e8$var$Buffer.TYPED_ARRAY_SUPPORT = $c0d1dad15cdb40e8$var$typedArraySupport();
if (!$c0d1dad15cdb40e8$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c0d1dad15cdb40e8$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c0d1dad15cdb40e8$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$c0d1dad15cdb40e8$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c0d1dad15cdb40e8$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$c0d1dad15cdb40e8$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c0d1dad15cdb40e8$var$createBuffer(length) {
    if (length > $c0d1dad15cdb40e8$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c0d1dad15cdb40e8$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c0d1dad15cdb40e8$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c0d1dad15cdb40e8$var$allocUnsafe(arg);
    }
    return $c0d1dad15cdb40e8$var$from(arg, encodingOrOffset, length);
}
$c0d1dad15cdb40e8$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c0d1dad15cdb40e8$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c0d1dad15cdb40e8$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c0d1dad15cdb40e8$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c0d1dad15cdb40e8$var$isInstance(value, ArrayBuffer) || value && $c0d1dad15cdb40e8$var$isInstance(value.buffer, ArrayBuffer)) return $c0d1dad15cdb40e8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c0d1dad15cdb40e8$var$isInstance(value, SharedArrayBuffer) || value && $c0d1dad15cdb40e8$var$isInstance(value.buffer, SharedArrayBuffer))) return $c0d1dad15cdb40e8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c0d1dad15cdb40e8$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c0d1dad15cdb40e8$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c0d1dad15cdb40e8$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c0d1dad15cdb40e8$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c0d1dad15cdb40e8$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c0d1dad15cdb40e8$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c0d1dad15cdb40e8$var$Buffer, Uint8Array);
function $c0d1dad15cdb40e8$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c0d1dad15cdb40e8$var$alloc(size, fill, encoding) {
    $c0d1dad15cdb40e8$var$assertSize(size);
    if (size <= 0) return $c0d1dad15cdb40e8$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c0d1dad15cdb40e8$var$createBuffer(size).fill(fill, encoding) : $c0d1dad15cdb40e8$var$createBuffer(size).fill(fill);
    return $c0d1dad15cdb40e8$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c0d1dad15cdb40e8$var$Buffer.alloc = function(size, fill, encoding) {
    return $c0d1dad15cdb40e8$var$alloc(size, fill, encoding);
};
function $c0d1dad15cdb40e8$var$allocUnsafe(size) {
    $c0d1dad15cdb40e8$var$assertSize(size);
    return $c0d1dad15cdb40e8$var$createBuffer(size < 0 ? 0 : $c0d1dad15cdb40e8$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c0d1dad15cdb40e8$var$Buffer.allocUnsafe = function(size) {
    return $c0d1dad15cdb40e8$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c0d1dad15cdb40e8$var$Buffer.allocUnsafeSlow = function(size) {
    return $c0d1dad15cdb40e8$var$allocUnsafe(size);
};
function $c0d1dad15cdb40e8$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c0d1dad15cdb40e8$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $c0d1dad15cdb40e8$var$byteLength(string, encoding) | 0;
    let buf = $c0d1dad15cdb40e8$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c0d1dad15cdb40e8$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c0d1dad15cdb40e8$var$checked(array.length) | 0;
    const buf = $c0d1dad15cdb40e8$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c0d1dad15cdb40e8$var$fromArrayView(arrayView) {
    if ($c0d1dad15cdb40e8$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c0d1dad15cdb40e8$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c0d1dad15cdb40e8$var$fromArrayLike(arrayView);
}
function $c0d1dad15cdb40e8$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c0d1dad15cdb40e8$var$Buffer.prototype);
    return buf;
}
function $c0d1dad15cdb40e8$var$fromObject(obj) {
    if ($c0d1dad15cdb40e8$var$Buffer.isBuffer(obj)) {
        const len = $c0d1dad15cdb40e8$var$checked(obj.length) | 0;
        const buf = $c0d1dad15cdb40e8$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c0d1dad15cdb40e8$var$numberIsNaN(obj.length)) return $c0d1dad15cdb40e8$var$createBuffer(0);
        return $c0d1dad15cdb40e8$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c0d1dad15cdb40e8$var$fromArrayLike(obj.data);
}
function $c0d1dad15cdb40e8$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c0d1dad15cdb40e8$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c0d1dad15cdb40e8$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c0d1dad15cdb40e8$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c0d1dad15cdb40e8$var$Buffer.alloc(+length);
}
$c0d1dad15cdb40e8$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c0d1dad15cdb40e8$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c0d1dad15cdb40e8$var$Buffer.compare = function compare(a, b) {
    if ($c0d1dad15cdb40e8$var$isInstance(a, Uint8Array)) a = $c0d1dad15cdb40e8$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c0d1dad15cdb40e8$var$isInstance(b, Uint8Array)) b = $c0d1dad15cdb40e8$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c0d1dad15cdb40e8$var$Buffer.isBuffer(a) || !$c0d1dad15cdb40e8$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c0d1dad15cdb40e8$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c0d1dad15cdb40e8$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c0d1dad15cdb40e8$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c0d1dad15cdb40e8$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c0d1dad15cdb40e8$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c0d1dad15cdb40e8$var$Buffer.isBuffer(buf)) buf = $c0d1dad15cdb40e8$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c0d1dad15cdb40e8$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c0d1dad15cdb40e8$var$byteLength(string, encoding) {
    if ($c0d1dad15cdb40e8$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c0d1dad15cdb40e8$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c0d1dad15cdb40e8$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c0d1dad15cdb40e8$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c0d1dad15cdb40e8$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c0d1dad15cdb40e8$var$Buffer.byteLength = $c0d1dad15cdb40e8$var$byteLength;
function $c0d1dad15cdb40e8$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c0d1dad15cdb40e8$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c0d1dad15cdb40e8$var$utf8Slice(this, start, end);
        case "ascii":
            return $c0d1dad15cdb40e8$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c0d1dad15cdb40e8$var$latin1Slice(this, start, end);
        case "base64":
            return $c0d1dad15cdb40e8$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c0d1dad15cdb40e8$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c0d1dad15cdb40e8$var$Buffer.prototype._isBuffer = true;
function $c0d1dad15cdb40e8$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c0d1dad15cdb40e8$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$c0d1dad15cdb40e8$var$swap(this, i, i + 1);
    return this;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $c0d1dad15cdb40e8$var$swap(this, i, i + 3);
        $c0d1dad15cdb40e8$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $c0d1dad15cdb40e8$var$swap(this, i, i + 7);
        $c0d1dad15cdb40e8$var$swap(this, i + 1, i + 6);
        $c0d1dad15cdb40e8$var$swap(this, i + 2, i + 5);
        $c0d1dad15cdb40e8$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c0d1dad15cdb40e8$var$utf8Slice(this, 0, length);
    return $c0d1dad15cdb40e8$var$slowToString.apply(this, arguments);
};
$c0d1dad15cdb40e8$var$Buffer.prototype.toLocaleString = $c0d1dad15cdb40e8$var$Buffer.prototype.toString;
$c0d1dad15cdb40e8$var$Buffer.prototype.equals = function equals(b) {
    if (!$c0d1dad15cdb40e8$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c0d1dad15cdb40e8$var$Buffer.compare(this, b) === 0;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $c0d1dad15cdb40e8$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c0d1dad15cdb40e8$var$customInspectSymbol) $c0d1dad15cdb40e8$var$Buffer.prototype[$c0d1dad15cdb40e8$var$customInspectSymbol] = $c0d1dad15cdb40e8$var$Buffer.prototype.inspect;
$c0d1dad15cdb40e8$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c0d1dad15cdb40e8$var$isInstance(target, Uint8Array)) target = $c0d1dad15cdb40e8$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c0d1dad15cdb40e8$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c0d1dad15cdb40e8$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c0d1dad15cdb40e8$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c0d1dad15cdb40e8$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c0d1dad15cdb40e8$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c0d1dad15cdb40e8$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c0d1dad15cdb40e8$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c0d1dad15cdb40e8$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c0d1dad15cdb40e8$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c0d1dad15cdb40e8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c0d1dad15cdb40e8$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c0d1dad15cdb40e8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c0d1dad15cdb40e8$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c0d1dad15cdb40e8$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c0d1dad15cdb40e8$var$utf8Write(buf, string, offset, length) {
    return $c0d1dad15cdb40e8$var$blitBuffer($c0d1dad15cdb40e8$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c0d1dad15cdb40e8$var$asciiWrite(buf, string, offset, length) {
    return $c0d1dad15cdb40e8$var$blitBuffer($c0d1dad15cdb40e8$var$asciiToBytes(string), buf, offset, length);
}
function $c0d1dad15cdb40e8$var$base64Write(buf, string, offset, length) {
    return $c0d1dad15cdb40e8$var$blitBuffer($c0d1dad15cdb40e8$var$base64ToBytes(string), buf, offset, length);
}
function $c0d1dad15cdb40e8$var$ucs2Write(buf, string, offset, length) {
    return $c0d1dad15cdb40e8$var$blitBuffer($c0d1dad15cdb40e8$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c0d1dad15cdb40e8$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c0d1dad15cdb40e8$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c0d1dad15cdb40e8$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c0d1dad15cdb40e8$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c0d1dad15cdb40e8$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c0d1dad15cdb40e8$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c0d1dad15cdb40e8$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c0d1dad15cdb40e8$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gxC2H.fromByteArray(buf);
    else return $gxC2H.fromByteArray(buf.slice(start, end));
}
function $c0d1dad15cdb40e8$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c0d1dad15cdb40e8$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c0d1dad15cdb40e8$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c0d1dad15cdb40e8$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c0d1dad15cdb40e8$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c0d1dad15cdb40e8$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c0d1dad15cdb40e8$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c0d1dad15cdb40e8$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c0d1dad15cdb40e8$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $c0d1dad15cdb40e8$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c0d1dad15cdb40e8$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c0d1dad15cdb40e8$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c0d1dad15cdb40e8$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c0d1dad15cdb40e8$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c0d1dad15cdb40e8$var$Buffer.prototype.readUintLE = $c0d1dad15cdb40e8$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readUintBE = $c0d1dad15cdb40e8$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readUint8 = $c0d1dad15cdb40e8$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readUint16LE = $c0d1dad15cdb40e8$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readUint16BE = $c0d1dad15cdb40e8$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readUint32LE = $c0d1dad15cdb40e8$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readUint32BE = $c0d1dad15cdb40e8$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readBigUInt64LE = $c0d1dad15cdb40e8$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c0d1dad15cdb40e8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c0d1dad15cdb40e8$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c0d1dad15cdb40e8$var$Buffer.prototype.readBigUInt64BE = $c0d1dad15cdb40e8$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c0d1dad15cdb40e8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c0d1dad15cdb40e8$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c0d1dad15cdb40e8$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readBigInt64LE = $c0d1dad15cdb40e8$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c0d1dad15cdb40e8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c0d1dad15cdb40e8$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c0d1dad15cdb40e8$var$Buffer.prototype.readBigInt64BE = $c0d1dad15cdb40e8$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c0d1dad15cdb40e8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c0d1dad15cdb40e8$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c0d1dad15cdb40e8$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, true, 23, 4);
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, false, 23, 4);
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, true, 52, 8);
};
$c0d1dad15cdb40e8$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, false, 52, 8);
};
function $c0d1dad15cdb40e8$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c0d1dad15cdb40e8$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c0d1dad15cdb40e8$var$Buffer.prototype.writeUintLE = $c0d1dad15cdb40e8$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c0d1dad15cdb40e8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeUintBE = $c0d1dad15cdb40e8$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c0d1dad15cdb40e8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeUint8 = $c0d1dad15cdb40e8$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeUint16LE = $c0d1dad15cdb40e8$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeUint16BE = $c0d1dad15cdb40e8$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeUint32LE = $c0d1dad15cdb40e8$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeUint32BE = $c0d1dad15cdb40e8$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c0d1dad15cdb40e8$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c0d1dad15cdb40e8$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c0d1dad15cdb40e8$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c0d1dad15cdb40e8$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c0d1dad15cdb40e8$var$Buffer.prototype.writeBigUInt64LE = $c0d1dad15cdb40e8$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c0d1dad15cdb40e8$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c0d1dad15cdb40e8$var$Buffer.prototype.writeBigUInt64BE = $c0d1dad15cdb40e8$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c0d1dad15cdb40e8$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c0d1dad15cdb40e8$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c0d1dad15cdb40e8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c0d1dad15cdb40e8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeBigInt64LE = $c0d1dad15cdb40e8$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c0d1dad15cdb40e8$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$c0d1dad15cdb40e8$var$Buffer.prototype.writeBigInt64BE = $c0d1dad15cdb40e8$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c0d1dad15cdb40e8$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $c0d1dad15cdb40e8$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c0d1dad15cdb40e8$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c0d1dad15cdb40e8$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c0d1dad15cdb40e8$var$writeFloat(this, value, offset, true, noAssert);
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c0d1dad15cdb40e8$var$writeFloat(this, value, offset, false, noAssert);
};
function $c0d1dad15cdb40e8$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c0d1dad15cdb40e8$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c0d1dad15cdb40e8$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c0d1dad15cdb40e8$var$writeDouble(this, value, offset, true, noAssert);
};
$c0d1dad15cdb40e8$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c0d1dad15cdb40e8$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c0d1dad15cdb40e8$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c0d1dad15cdb40e8$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c0d1dad15cdb40e8$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c0d1dad15cdb40e8$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c0d1dad15cdb40e8$var$Buffer.isBuffer(val) ? val : $c0d1dad15cdb40e8$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c0d1dad15cdb40e8$var$errors = {};
function $c0d1dad15cdb40e8$var$E(sym, getMessage, Base) {
    $c0d1dad15cdb40e8$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$c0d1dad15cdb40e8$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$c0d1dad15cdb40e8$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c0d1dad15cdb40e8$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c0d1dad15cdb40e8$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c0d1dad15cdb40e8$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c0d1dad15cdb40e8$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c0d1dad15cdb40e8$var$checkBounds(buf, offset, byteLength) {
    $c0d1dad15cdb40e8$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c0d1dad15cdb40e8$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c0d1dad15cdb40e8$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c0d1dad15cdb40e8$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $c0d1dad15cdb40e8$var$checkBounds(buf, offset, byteLength);
}
function $c0d1dad15cdb40e8$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $c0d1dad15cdb40e8$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $c0d1dad15cdb40e8$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c0d1dad15cdb40e8$var$validateNumber(value, type);
        throw new $c0d1dad15cdb40e8$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $c0d1dad15cdb40e8$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c0d1dad15cdb40e8$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c0d1dad15cdb40e8$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c0d1dad15cdb40e8$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c0d1dad15cdb40e8$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c0d1dad15cdb40e8$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c0d1dad15cdb40e8$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c0d1dad15cdb40e8$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c0d1dad15cdb40e8$var$base64ToBytes(str) {
    return $gxC2H.toByteArray($c0d1dad15cdb40e8$var$base64clean(str));
}
function $c0d1dad15cdb40e8$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c0d1dad15cdb40e8$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c0d1dad15cdb40e8$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c0d1dad15cdb40e8$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c0d1dad15cdb40e8$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $c0d1dad15cdb40e8$var$BufferBigIntNotDefined : fn;
}
function $c0d1dad15cdb40e8$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});

parcelRegister("1ycX9", function(module, exports) {

$parcel$export(module.exports, "ed25519", function () { return $121303a103d9163b$export$f63794f4a09a19c1; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $98YOf = parcelRequire("98YOf");

var $emVFP = parcelRequire("emVFP");

var $aWjVl = parcelRequire("aWjVl");

var $6WoFF = parcelRequire("6WoFF");

var $4ALPe = parcelRequire("4ALPe");

var $4kbdz = parcelRequire("4kbdz");

var $hX21w = parcelRequire("hX21w");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ const $121303a103d9163b$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
const $121303a103d9163b$var$ED25519_SQRT_M1 = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $121303a103d9163b$var$_0n = BigInt(0), $121303a103d9163b$var$_1n = BigInt(1), $121303a103d9163b$var$_2n = BigInt(2), $121303a103d9163b$var$_3n = BigInt(3);
// prettier-ignore
const $121303a103d9163b$var$_5n = BigInt(5), $121303a103d9163b$var$_8n = BigInt(8);
function $121303a103d9163b$var$ed25519_pow_2_252_3(x) {
    // prettier-ignore
    const _10n = BigInt(10), _20n = BigInt(20), _40n = BigInt(40), _80n = BigInt(80);
    const P = $121303a103d9163b$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $4ALPe.pow2)(b2, $121303a103d9163b$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $4ALPe.pow2)(b4, $121303a103d9163b$var$_1n, P) * x % P; // x^31
    const b10 = (0, $4ALPe.pow2)(b5, $121303a103d9163b$var$_5n, P) * b5 % P;
    const b20 = (0, $4ALPe.pow2)(b10, _10n, P) * b10 % P;
    const b40 = (0, $4ALPe.pow2)(b20, _20n, P) * b20 % P;
    const b80 = (0, $4ALPe.pow2)(b40, _40n, P) * b40 % P;
    const b160 = (0, $4ALPe.pow2)(b80, _80n, P) * b80 % P;
    const b240 = (0, $4ALPe.pow2)(b160, _80n, P) * b80 % P;
    const b250 = (0, $4ALPe.pow2)(b240, _10n, P) * b10 % P;
    const pow_p_5_8 = (0, $4ALPe.pow2)(b250, $121303a103d9163b$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $121303a103d9163b$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $121303a103d9163b$var$uvRatio(u, v) {
    const P = $121303a103d9163b$var$ED25519_P;
    const v3 = (0, $4ALPe.mod)(v * v * v, P); // v³
    const v7 = (0, $4ALPe.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $121303a103d9163b$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $4ALPe.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $4ALPe.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $4ALPe.mod)(x * $121303a103d9163b$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $4ALPe.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $4ALPe.mod)(-u * $121303a103d9163b$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $4ALPe.isNegativeLE)(x, P)) x = (0, $4ALPe.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
const $121303a103d9163b$export$5ce3305f0d0b8e6f = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $121303a103d9163b$var$Fp = /* @__PURE__ */ (()=>(0, $4ALPe.Field)($121303a103d9163b$var$ED25519_P, undefined, true))();
const $121303a103d9163b$var$ed25519Defaults = /* @__PURE__ */ (()=>({
        // Param: a
        a: BigInt(-1),
        // d is equal to -121665/121666 over finite field.
        // Negative number is P - number, and division is invert(number, P)
        d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
        Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
        $121303a103d9163b$var$Fp,
        // Subgroup order: how many points curve has
        // 2n**252n + 27742317777372353535851937790883648493n;
        n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
        // Cofactor
        h: $121303a103d9163b$var$_8n,
        // Base point (x, y) aka generator point
        Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
        Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
        hash: (0, $98YOf.sha512),
        randomBytes: $emVFP.randomBytes,
        adjustScalarBytes: $121303a103d9163b$var$adjustScalarBytes,
        uvRatio: // dom2
        // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
        // Constant-time, u/√v
        $121303a103d9163b$var$uvRatio
    }))();
const $121303a103d9163b$export$f63794f4a09a19c1 = /* @__PURE__ */ (()=>(0, $aWjVl.twistedEdwards)($121303a103d9163b$var$ed25519Defaults))();
function $121303a103d9163b$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $emVFP.concatBytes)((0, $emVFP.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
const $121303a103d9163b$export$1bc11da7986b0196 = /* @__PURE__ */ (()=>(0, $aWjVl.twistedEdwards)({
        ...$121303a103d9163b$var$ed25519Defaults,
        domain: $121303a103d9163b$var$ed25519_domain
    }))();
const $121303a103d9163b$export$473acbb6f701cbb6 = /* @__PURE__ */ (()=>(0, $aWjVl.twistedEdwards)(Object.assign({}, $121303a103d9163b$var$ed25519Defaults, {
        domain: $121303a103d9163b$var$ed25519_domain,
        prehash: (0, $98YOf.sha512)
    })))();
const $121303a103d9163b$export$dab9625394da700 = /* @__PURE__ */ (()=>(0, $4kbdz.montgomery)({
        P: $121303a103d9163b$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $121303a103d9163b$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $121303a103d9163b$var$ed25519_pow_2_252_3(x);
            return (0, $4ALPe.mod)((0, $4ALPe.pow2)(pow_p_5_8, $121303a103d9163b$var$_3n, P) * b2, P);
        },
        adjustScalarBytes: $121303a103d9163b$var$adjustScalarBytes,
        randomBytes: $emVFP.randomBytes
    }))();
function $121303a103d9163b$export$78609ae56f1edf04(edwardsPub) {
    const { y: y } = $121303a103d9163b$export$f63794f4a09a19c1.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $121303a103d9163b$var$Fp.toBytes($121303a103d9163b$var$Fp.create((_1n + y) * $121303a103d9163b$var$Fp.inv(_1n - y)));
}
const $121303a103d9163b$export$84bc39a6e4664b07 = $121303a103d9163b$export$78609ae56f1edf04; // deprecated
function $121303a103d9163b$export$c32b0f86cebbdf19(edwardsPriv) {
    const hashed = $121303a103d9163b$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $121303a103d9163b$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $121303a103d9163b$var$ELL2_C1 = /* @__PURE__ */ (()=>($121303a103d9163b$var$Fp.ORDER + $121303a103d9163b$var$_3n) / $121303a103d9163b$var$_8n)(); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $121303a103d9163b$var$ELL2_C2 = /* @__PURE__ */ (()=>$121303a103d9163b$var$Fp.pow($121303a103d9163b$var$_2n, $121303a103d9163b$var$ELL2_C1))(); // 2. c2 = 2^c1
const $121303a103d9163b$var$ELL2_C3 = /* @__PURE__ */ (()=>$121303a103d9163b$var$Fp.sqrt($121303a103d9163b$var$Fp.neg($121303a103d9163b$var$Fp.ONE)))(); // 3. c3 = sqrt(-1)
// prettier-ignore
function $121303a103d9163b$var$map_to_curve_elligator2_curve25519(u) {
    const ELL2_C4 = ($121303a103d9163b$var$Fp.ORDER - $121303a103d9163b$var$_5n) / $121303a103d9163b$var$_8n; // 4. c4 = (q - 5) / 8       # Integer arithmetic
    const ELL2_J = BigInt(486662);
    let tv1 = $121303a103d9163b$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $121303a103d9163b$var$Fp.mul(tv1, $121303a103d9163b$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $121303a103d9163b$var$Fp.add(tv1, $121303a103d9163b$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $121303a103d9163b$var$Fp.neg(ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $121303a103d9163b$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $121303a103d9163b$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $121303a103d9163b$var$Fp.mul(tv1, ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $121303a103d9163b$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $121303a103d9163b$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $121303a103d9163b$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $121303a103d9163b$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $121303a103d9163b$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $121303a103d9163b$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $121303a103d9163b$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $121303a103d9163b$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $121303a103d9163b$var$Fp.pow(tv2, ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $121303a103d9163b$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $121303a103d9163b$var$Fp.mul(y11, $121303a103d9163b$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $121303a103d9163b$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $121303a103d9163b$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $121303a103d9163b$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $121303a103d9163b$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $121303a103d9163b$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $121303a103d9163b$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $121303a103d9163b$var$Fp.mul(y21, $121303a103d9163b$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $121303a103d9163b$var$Fp.mul(y21, $121303a103d9163b$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $121303a103d9163b$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $121303a103d9163b$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $121303a103d9163b$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $121303a103d9163b$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $121303a103d9163b$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $121303a103d9163b$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $121303a103d9163b$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $121303a103d9163b$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $121303a103d9163b$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $121303a103d9163b$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $121303a103d9163b$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $121303a103d9163b$var$Fp.cmov(y, $121303a103d9163b$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $121303a103d9163b$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $121303a103d9163b$var$ELL2_C1_EDWARDS = /* @__PURE__ */ (()=>(0, $4ALPe.FpSqrtEven)($121303a103d9163b$var$Fp, $121303a103d9163b$var$Fp.neg(BigInt(486664))))(); // sgn0(c1) MUST equal 0
function $121303a103d9163b$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $121303a103d9163b$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $121303a103d9163b$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $121303a103d9163b$var$Fp.mul(xn, $121303a103d9163b$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $121303a103d9163b$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $121303a103d9163b$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $121303a103d9163b$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $121303a103d9163b$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $121303a103d9163b$var$Fp.eql(tv1, $121303a103d9163b$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $121303a103d9163b$var$Fp.cmov(xn, $121303a103d9163b$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $121303a103d9163b$var$Fp.cmov(xd, $121303a103d9163b$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $121303a103d9163b$var$Fp.cmov(yn, $121303a103d9163b$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $121303a103d9163b$var$Fp.cmov(yd, $121303a103d9163b$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $121303a103d9163b$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $121303a103d9163b$var$Fp.mul(xn, inv[0]),
        y: $121303a103d9163b$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $121303a103d9163b$var$htf = /* @__PURE__ */ (()=>(0, $6WoFF.createHasher)($121303a103d9163b$export$f63794f4a09a19c1.ExtendedPoint, (scalars)=>$121303a103d9163b$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $121303a103d9163b$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $98YOf.sha512)
    }))();
const $121303a103d9163b$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$121303a103d9163b$var$htf.hashToCurve)();
const $121303a103d9163b$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$121303a103d9163b$var$htf.encodeToCurve)();
function $121303a103d9163b$var$assertRstPoint(other) {
    if (!(other instanceof $121303a103d9163b$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $121303a103d9163b$var$SQRT_M1 = $121303a103d9163b$var$ED25519_SQRT_M1;
// √(ad - 1)
const $121303a103d9163b$var$SQRT_AD_MINUS_ONE = /* @__PURE__ */ BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $121303a103d9163b$var$INVSQRT_A_MINUS_D = /* @__PURE__ */ BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $121303a103d9163b$var$ONE_MINUS_D_SQ = /* @__PURE__ */ BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $121303a103d9163b$var$D_MINUS_ONE_SQ = /* @__PURE__ */ BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $121303a103d9163b$var$invertSqrt = (number)=>$121303a103d9163b$var$uvRatio($121303a103d9163b$var$_1n, number);
const $121303a103d9163b$var$MAX_255B = /* @__PURE__ */ BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $121303a103d9163b$var$bytes255ToNumberLE = (bytes)=>$121303a103d9163b$export$f63794f4a09a19c1.CURVE.Fp.create((0, $hX21w.bytesToNumberLE)(bytes) & $121303a103d9163b$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $121303a103d9163b$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $121303a103d9163b$export$f63794f4a09a19c1.CURVE;
    const P = $121303a103d9163b$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
    const mod = $121303a103d9163b$export$f63794f4a09a19c1.CURVE.Fp.create;
    const r = mod($121303a103d9163b$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $121303a103d9163b$var$_1n) * $121303a103d9163b$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $121303a103d9163b$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $4ALPe.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $121303a103d9163b$var$_1n) * $121303a103d9163b$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $121303a103d9163b$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($121303a103d9163b$var$_1n - s2); // 12
    const W3 = mod($121303a103d9163b$var$_1n + s2); // 13
    return new $121303a103d9163b$export$f63794f4a09a19c1.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $121303a103d9163b$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $121303a103d9163b$var$RistPoint($121303a103d9163b$export$f63794f4a09a19c1.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $hX21w.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $121303a103d9163b$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $121303a103d9163b$var$calcElligatorRistrettoMap(r1);
        const r2 = $121303a103d9163b$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $121303a103d9163b$var$calcElligatorRistrettoMap(r2);
        return new $121303a103d9163b$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $hX21w.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = $121303a103d9163b$export$f63794f4a09a19c1.CURVE;
        const P = $121303a103d9163b$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $121303a103d9163b$export$f63794f4a09a19c1.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $121303a103d9163b$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $hX21w.equalBytes)((0, $hX21w.numberToBytesLE)(s, 32), hex) || (0, $4ALPe.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($121303a103d9163b$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($121303a103d9163b$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $121303a103d9163b$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $4ALPe.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $4ALPe.isNegativeLE)(t, P) || y === $121303a103d9163b$var$_0n) throw new Error(emsg);
        return new $121303a103d9163b$var$RistPoint(new $121303a103d9163b$export$f63794f4a09a19c1.ExtendedPoint(x, y, $121303a103d9163b$var$_1n, t));
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = $121303a103d9163b$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $121303a103d9163b$export$f63794f4a09a19c1.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $121303a103d9163b$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $4ALPe.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $121303a103d9163b$var$SQRT_M1);
            let _y = mod(x * $121303a103d9163b$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $121303a103d9163b$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $4ALPe.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $4ALPe.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $hX21w.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $hX21w.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $121303a103d9163b$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = $121303a103d9163b$export$f63794f4a09a19c1.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $121303a103d9163b$var$assertRstPoint(other);
        return new $121303a103d9163b$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $121303a103d9163b$var$assertRstPoint(other);
        return new $121303a103d9163b$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $121303a103d9163b$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $121303a103d9163b$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
    double() {
        return new $121303a103d9163b$var$RistPoint(this.ep.double());
    }
    negate() {
        return new $121303a103d9163b$var$RistPoint(this.ep.negate());
    }
}
const $121303a103d9163b$export$5e87c4f36f27816d = /* @__PURE__ */ (()=>{
    if (!$121303a103d9163b$var$RistPoint.BASE) $121303a103d9163b$var$RistPoint.BASE = new $121303a103d9163b$var$RistPoint($121303a103d9163b$export$f63794f4a09a19c1.ExtendedPoint.BASE);
    if (!$121303a103d9163b$var$RistPoint.ZERO) $121303a103d9163b$var$RistPoint.ZERO = new $121303a103d9163b$var$RistPoint($121303a103d9163b$export$f63794f4a09a19c1.ExtendedPoint.ZERO);
    return $121303a103d9163b$var$RistPoint;
})();
const $121303a103d9163b$export$c9ad4c0d917ad3 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $emVFP.utf8ToBytes)(d) : d;
    const uniform_bytes = (0, $6WoFF.expand_message_xmd)(msg, DST, 64, (0, $98YOf.sha512));
    const P = $121303a103d9163b$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
const $121303a103d9163b$export$667ef88de7a83a7f = $121303a103d9163b$export$c9ad4c0d917ad3; // legacy

});
parcelRegister("98YOf", function(module, exports) {

$parcel$export(module.exports, "sha512", function () { return $6a8407e072fbfd7e$export$a888d2532e6dc7bb; });

var $k2w2A = parcelRequire("k2w2A");

var $lHKrl = parcelRequire("lHKrl");

var $emVFP = parcelRequire("emVFP");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$6a8407e072fbfd7e$var$SHA512_Kh, $6a8407e072fbfd7e$var$SHA512_Kl] = /* @__PURE__ */ (()=>(0, $lHKrl.default).split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $6a8407e072fbfd7e$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $6a8407e072fbfd7e$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $6a8407e072fbfd7e$export$d655fdb8a1cad5df extends (0, $k2w2A.HashMD) {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $6a8407e072fbfd7e$var$SHA512_W_H[i] = view.getUint32(offset);
            $6a8407e072fbfd7e$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $6a8407e072fbfd7e$var$SHA512_W_H[i - 15] | 0;
            const W15l = $6a8407e072fbfd7e$var$SHA512_W_L[i - 15] | 0;
            const s0h = (0, $lHKrl.default).rotrSH(W15h, W15l, 1) ^ (0, $lHKrl.default).rotrSH(W15h, W15l, 8) ^ (0, $lHKrl.default).shrSH(W15h, W15l, 7);
            const s0l = (0, $lHKrl.default).rotrSL(W15h, W15l, 1) ^ (0, $lHKrl.default).rotrSL(W15h, W15l, 8) ^ (0, $lHKrl.default).shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $6a8407e072fbfd7e$var$SHA512_W_H[i - 2] | 0;
            const W2l = $6a8407e072fbfd7e$var$SHA512_W_L[i - 2] | 0;
            const s1h = (0, $lHKrl.default).rotrSH(W2h, W2l, 19) ^ (0, $lHKrl.default).rotrBH(W2h, W2l, 61) ^ (0, $lHKrl.default).shrSH(W2h, W2l, 6);
            const s1l = (0, $lHKrl.default).rotrSL(W2h, W2l, 19) ^ (0, $lHKrl.default).rotrBL(W2h, W2l, 61) ^ (0, $lHKrl.default).shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = (0, $lHKrl.default).add4L(s0l, s1l, $6a8407e072fbfd7e$var$SHA512_W_L[i - 7], $6a8407e072fbfd7e$var$SHA512_W_L[i - 16]);
            const SUMh = (0, $lHKrl.default).add4H(SUMl, s0h, s1h, $6a8407e072fbfd7e$var$SHA512_W_H[i - 7], $6a8407e072fbfd7e$var$SHA512_W_H[i - 16]);
            $6a8407e072fbfd7e$var$SHA512_W_H[i] = SUMh | 0;
            $6a8407e072fbfd7e$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = (0, $lHKrl.default).rotrSH(Eh, El, 14) ^ (0, $lHKrl.default).rotrSH(Eh, El, 18) ^ (0, $lHKrl.default).rotrBH(Eh, El, 41);
            const sigma1l = (0, $lHKrl.default).rotrSL(Eh, El, 14) ^ (0, $lHKrl.default).rotrSL(Eh, El, 18) ^ (0, $lHKrl.default).rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = (0, $lHKrl.default).add5L(Hl, sigma1l, CHIl, $6a8407e072fbfd7e$var$SHA512_Kl[i], $6a8407e072fbfd7e$var$SHA512_W_L[i]);
            const T1h = (0, $lHKrl.default).add5H(T1ll, Hh, sigma1h, CHIh, $6a8407e072fbfd7e$var$SHA512_Kh[i], $6a8407e072fbfd7e$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = (0, $lHKrl.default).rotrSH(Ah, Al, 28) ^ (0, $lHKrl.default).rotrBH(Ah, Al, 34) ^ (0, $lHKrl.default).rotrBH(Ah, Al, 39);
            const sigma0l = (0, $lHKrl.default).rotrSL(Ah, Al, 28) ^ (0, $lHKrl.default).rotrBL(Ah, Al, 34) ^ (0, $lHKrl.default).rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = (0, $lHKrl.default).add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = (0, $lHKrl.default).add3L(T1l, sigma0l, MAJl);
            Ah = (0, $lHKrl.default).add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = (0, $lHKrl.default).add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = (0, $lHKrl.default).add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = (0, $lHKrl.default).add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = (0, $lHKrl.default).add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = (0, $lHKrl.default).add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = (0, $lHKrl.default).add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = (0, $lHKrl.default).add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = (0, $lHKrl.default).add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $6a8407e072fbfd7e$var$SHA512_W_H.fill(0);
        $6a8407e072fbfd7e$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $6a8407e072fbfd7e$var$SHA512_224 extends $6a8407e072fbfd7e$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $6a8407e072fbfd7e$var$SHA512_256 extends $6a8407e072fbfd7e$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $6a8407e072fbfd7e$var$SHA384 extends $6a8407e072fbfd7e$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
const $6a8407e072fbfd7e$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $emVFP.wrapConstructor)(()=>new $6a8407e072fbfd7e$export$d655fdb8a1cad5df());
const $6a8407e072fbfd7e$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $emVFP.wrapConstructor)(()=>new $6a8407e072fbfd7e$var$SHA512_224());
const $6a8407e072fbfd7e$export$c78786b6da86db2a = /* @__PURE__ */ (0, $emVFP.wrapConstructor)(()=>new $6a8407e072fbfd7e$var$SHA512_256());
const $6a8407e072fbfd7e$export$612d47d55dedde45 = /* @__PURE__ */ (0, $emVFP.wrapConstructor)(()=>new $6a8407e072fbfd7e$var$SHA384());

});
parcelRegister("k2w2A", function(module, exports) {

$parcel$export(module.exports, "Chi", function () { return $e96cd92f7439dae2$export$d0d97f016526eaf0; });
$parcel$export(module.exports, "Maj", function () { return $e96cd92f7439dae2$export$8b1d810b1bd30adf; });
$parcel$export(module.exports, "HashMD", function () { return $e96cd92f7439dae2$export$f9f830659f932cb2; });

var $3eA0j = parcelRequire("3eA0j");

var $emVFP = parcelRequire("emVFP");
// Polyfill for Safari 14
function $e96cd92f7439dae2$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
const $e96cd92f7439dae2$export$d0d97f016526eaf0 = (a, b, c)=>a & b ^ ~a & c;
const $e96cd92f7439dae2$export$8b1d810b1bd30adf = (a, b, c)=>a & b ^ a & c ^ b & c;
class $e96cd92f7439dae2$export$f9f830659f932cb2 extends (0, $emVFP.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $emVFP.createView)(this.buffer);
    }
    update(data) {
        (0, $3eA0j.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $emVFP.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $emVFP.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $3eA0j.exists)(this);
        (0, $3eA0j.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $e96cd92f7439dae2$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $emVFP.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});
parcelRegister("3eA0j", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $25ae9b8c7f08625e$export$98e628dec113755e; });
$parcel$export(module.exports, "bytes", function () { return $25ae9b8c7f08625e$export$b3317979f9250576; });
$parcel$export(module.exports, "hash", function () { return $25ae9b8c7f08625e$export$d6af199866bfb566; });
$parcel$export(module.exports, "exists", function () { return $25ae9b8c7f08625e$export$f7e9f41ea797a17; });
$parcel$export(module.exports, "output", function () { return $25ae9b8c7f08625e$export$c789db2c85949867; });
function $25ae9b8c7f08625e$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $25ae9b8c7f08625e$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
function $25ae9b8c7f08625e$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $25ae9b8c7f08625e$export$b3317979f9250576(b, ...lengths) {
    if (!$25ae9b8c7f08625e$export$c6fabfbfd097fc30(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $25ae9b8c7f08625e$export$d6af199866bfb566(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $25ae9b8c7f08625e$export$98e628dec113755e(h.outputLen);
    $25ae9b8c7f08625e$export$98e628dec113755e(h.blockLen);
}
function $25ae9b8c7f08625e$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $25ae9b8c7f08625e$export$c789db2c85949867(out, instance) {
    $25ae9b8c7f08625e$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $25ae9b8c7f08625e$var$assert = {
    number: $25ae9b8c7f08625e$export$98e628dec113755e,
    bool: $25ae9b8c7f08625e$export$87b259aa03e3d267,
    bytes: $25ae9b8c7f08625e$export$b3317979f9250576,
    hash: $25ae9b8c7f08625e$export$d6af199866bfb566,
    exists: $25ae9b8c7f08625e$export$f7e9f41ea797a17,
    output: $25ae9b8c7f08625e$export$c789db2c85949867
};
var $25ae9b8c7f08625e$export$2e2bcd8739ae039 = $25ae9b8c7f08625e$var$assert;

});

parcelRegister("emVFP", function(module, exports) {

$parcel$export(module.exports, "u32", function () { return $a75fdb8a07db9395$export$8bacf4ad828c7fe7; });
$parcel$export(module.exports, "createView", function () { return $a75fdb8a07db9395$export$d7febe7b891e79f0; });
$parcel$export(module.exports, "rotr", function () { return $a75fdb8a07db9395$export$466993d7d0d272aa; });
$parcel$export(module.exports, "isLE", function () { return $a75fdb8a07db9395$export$a0f88e38d4cf9577; });
$parcel$export(module.exports, "byteSwap32", function () { return $a75fdb8a07db9395$export$97b40fc37f25d711; });
$parcel$export(module.exports, "bytesToHex", function () { return $a75fdb8a07db9395$export$58b867e287a802c8; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $a75fdb8a07db9395$export$3df70a15530b5e81; });
$parcel$export(module.exports, "toBytes", function () { return $a75fdb8a07db9395$export$30a71edf0753ed6b; });
$parcel$export(module.exports, "concatBytes", function () { return $a75fdb8a07db9395$export$287dd7971339c972; });
$parcel$export(module.exports, "Hash", function () { return $a75fdb8a07db9395$export$ab85ecd77ce6a5cd; });
$parcel$export(module.exports, "wrapConstructor", function () { return $a75fdb8a07db9395$export$f081816339df1972; });
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", function () { return $a75fdb8a07db9395$export$e18964dbd6e083c1; });
$parcel$export(module.exports, "randomBytes", function () { return $a75fdb8a07db9395$export$5f828d93ff035aa8; });
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $3hDC8 = parcelRequire("3hDC8");

var $3eA0j = parcelRequire("3eA0j");
function $a75fdb8a07db9395$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
const $a75fdb8a07db9395$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $a75fdb8a07db9395$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $a75fdb8a07db9395$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $a75fdb8a07db9395$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $a75fdb8a07db9395$export$ac5e39599698b562 = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
const $a75fdb8a07db9395$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
const $a75fdb8a07db9395$export$a4170f7f8be47425 = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
const $a75fdb8a07db9395$export$4a0a88cc2d284e7f = $a75fdb8a07db9395$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$a75fdb8a07db9395$export$a4170f7f8be47425(n);
function $a75fdb8a07db9395$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $a75fdb8a07db9395$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $a75fdb8a07db9395$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $a75fdb8a07db9395$export$58b867e287a802c8(bytes) {
    (0, $3eA0j.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a75fdb8a07db9395$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $a75fdb8a07db9395$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $a75fdb8a07db9395$var$asciiToBase16(char) {
    if (char >= $a75fdb8a07db9395$var$asciis._0 && char <= $a75fdb8a07db9395$var$asciis._9) return char - $a75fdb8a07db9395$var$asciis._0;
    if (char >= $a75fdb8a07db9395$var$asciis._A && char <= $a75fdb8a07db9395$var$asciis._F) return char - ($a75fdb8a07db9395$var$asciis._A - 10);
    if (char >= $a75fdb8a07db9395$var$asciis._a && char <= $a75fdb8a07db9395$var$asciis._f) return char - ($a75fdb8a07db9395$var$asciis._a - 10);
    return;
}
function $a75fdb8a07db9395$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $a75fdb8a07db9395$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $a75fdb8a07db9395$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $a75fdb8a07db9395$export$bdd553fddd433dcb = async ()=>{};
async function $a75fdb8a07db9395$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $a75fdb8a07db9395$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $a75fdb8a07db9395$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $a75fdb8a07db9395$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $a75fdb8a07db9395$export$3df70a15530b5e81(data);
    (0, $3eA0j.bytes)(data);
    return data;
}
function $a75fdb8a07db9395$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $3eA0j.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $a75fdb8a07db9395$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $a75fdb8a07db9395$var$toStr = {}.toString;
function $a75fdb8a07db9395$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $a75fdb8a07db9395$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $a75fdb8a07db9395$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($a75fdb8a07db9395$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $a75fdb8a07db9395$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a75fdb8a07db9395$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $a75fdb8a07db9395$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a75fdb8a07db9395$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $a75fdb8a07db9395$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $3hDC8.crypto) && typeof (0, $3hDC8.crypto).getRandomValues === "function") return (0, $3hDC8.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("3hDC8", function(module, exports) {

$parcel$export(module.exports, "crypto", function () { return $2641b02e48824087$export$7effb53edfc7fa2d; });
const $2641b02e48824087$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("lHKrl", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $fcd1a3283edf2495$export$65980d18b75784e2; });
$parcel$export(module.exports, "rotlSH", function () { return $fcd1a3283edf2495$export$4b80a2917447870e; });
$parcel$export(module.exports, "rotlSL", function () { return $fcd1a3283edf2495$export$20652918a7b63b3; });
$parcel$export(module.exports, "rotlBH", function () { return $fcd1a3283edf2495$export$a52f14bf902f9977; });
$parcel$export(module.exports, "rotlBL", function () { return $fcd1a3283edf2495$export$5d12cc1da441323f; });
$parcel$export(module.exports, "default", function () { return $fcd1a3283edf2495$export$2e2bcd8739ae039; });
const $fcd1a3283edf2495$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $fcd1a3283edf2495$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $fcd1a3283edf2495$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $fcd1a3283edf2495$var$U32_MASK64),
        l: Number(n >> $fcd1a3283edf2495$var$_32n & $fcd1a3283edf2495$var$U32_MASK64)
    };
    return {
        h: Number(n >> $fcd1a3283edf2495$var$_32n & $fcd1a3283edf2495$var$U32_MASK64) | 0,
        l: Number(n & $fcd1a3283edf2495$var$U32_MASK64) | 0
    };
}
function $fcd1a3283edf2495$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $fcd1a3283edf2495$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $fcd1a3283edf2495$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $fcd1a3283edf2495$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $fcd1a3283edf2495$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $fcd1a3283edf2495$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $fcd1a3283edf2495$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $fcd1a3283edf2495$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $fcd1a3283edf2495$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $fcd1a3283edf2495$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $fcd1a3283edf2495$export$a088d44bd387d2a3 = (_h, l)=>l;
const $fcd1a3283edf2495$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $fcd1a3283edf2495$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $fcd1a3283edf2495$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $fcd1a3283edf2495$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $fcd1a3283edf2495$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $fcd1a3283edf2495$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $fcd1a3283edf2495$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $fcd1a3283edf2495$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $fcd1a3283edf2495$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $fcd1a3283edf2495$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $fcd1a3283edf2495$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $fcd1a3283edf2495$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $fcd1a3283edf2495$var$u64 = {
    fromBig: $fcd1a3283edf2495$export$9625d4333cb56c3f,
    split: $fcd1a3283edf2495$export$65980d18b75784e2,
    toBig: $fcd1a3283edf2495$export$30f78adcaaa2eb7,
    shrSH: $fcd1a3283edf2495$export$75aa78dc5bd52853,
    shrSL: $fcd1a3283edf2495$export$a0225ff0aee14e25,
    rotrSH: $fcd1a3283edf2495$export$97f812dfd830ca87,
    rotrSL: $fcd1a3283edf2495$export$60987e30e2c9d9d,
    rotrBH: $fcd1a3283edf2495$export$af9c7fbac44dcb76,
    rotrBL: $fcd1a3283edf2495$export$f619171d6d5ac414,
    rotr32H: $fcd1a3283edf2495$export$a088d44bd387d2a3,
    rotr32L: $fcd1a3283edf2495$export$8415aae4d1f69577,
    rotlSH: $fcd1a3283edf2495$export$4b80a2917447870e,
    rotlSL: $fcd1a3283edf2495$export$20652918a7b63b3,
    rotlBH: $fcd1a3283edf2495$export$a52f14bf902f9977,
    rotlBL: $fcd1a3283edf2495$export$5d12cc1da441323f,
    add: $fcd1a3283edf2495$export$e16d8520af44a096,
    add3L: $fcd1a3283edf2495$export$c0c22b91f08911f,
    add3H: $fcd1a3283edf2495$export$ef7b26044977a8ec,
    add4L: $fcd1a3283edf2495$export$2f4e199c560f545d,
    add4H: $fcd1a3283edf2495$export$e909220d675a7741,
    add5H: $fcd1a3283edf2495$export$b45ee8d78c965098,
    add5L: $fcd1a3283edf2495$export$d732b061fe9c9ae4
};
var $fcd1a3283edf2495$export$2e2bcd8739ae039 = $fcd1a3283edf2495$var$u64;

});


parcelRegister("aWjVl", function(module, exports) {

$parcel$export(module.exports, "twistedEdwards", function () { return $7f6ec69dc561266f$export$f0c1eee63ea541eb; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y²

var $c97Ta = parcelRequire("c97Ta");

var $4ALPe = parcelRequire("4ALPe");

var $hX21w = parcelRequire("hX21w");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $7f6ec69dc561266f$var$_0n = BigInt(0), $7f6ec69dc561266f$var$_1n = BigInt(1), $7f6ec69dc561266f$var$_2n = BigInt(2), $7f6ec69dc561266f$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $7f6ec69dc561266f$var$VERIFY_DEFAULT = {
    zip215: true
};
function $7f6ec69dc561266f$var$validateOpts(curve) {
    const opts = (0, $c97Ta.validateBasic)(curve);
    $hX21w.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
function $7f6ec69dc561266f$export$f0c1eee63ea541eb(curveDef) {
    const CURVE = $7f6ec69dc561266f$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    const MASK = $7f6ec69dc561266f$var$_2n << BigInt(nByteLength * 8) - $7f6ec69dc561266f$var$_1n;
    const modP = Fp.create; // Function overrides
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $7f6ec69dc561266f$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        (0, $hX21w.abool)("phflag", phflag);
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    // 0 <= n < MASK
    // Coordinates larger than Fp.ORDER are allowed for zip215
    function aCoordinate(title, n) {
        $hX21w.aInRange("coordinate " + title, n, $7f6ec69dc561266f$var$_0n, MASK);
    }
    function assertPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    const toAffineMemo = (0, $hX21w.memoized)((p, iz)=>{
        const { ex: x, ey: y, ez: z } = p;
        const is0 = p.is0();
        if (iz == null) iz = is0 ? $7f6ec69dc561266f$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
        const ax = modP(x * iz);
        const ay = modP(y * iz);
        const zz = modP(z * iz);
        if (is0) return {
            x: $7f6ec69dc561266f$var$_0n,
            y: $7f6ec69dc561266f$var$_1n
        };
        if (zz !== $7f6ec69dc561266f$var$_1n) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    const assertValidMemo = (0, $hX21w.memoized)((p)=>{
        const { a: a, d: d } = CURVE;
        if (p.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
        // Equation in affine coordinates: ax² + y² = 1 + dx²y²
        // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
        const { ex: X, ey: Y, ez: Z, et: T } = p;
        const X2 = modP(X * X); // X²
        const Y2 = modP(Y * Y); // Y²
        const Z2 = modP(Z * Z); // Z²
        const Z4 = modP(Z2 * Z2); // Z⁴
        const aX2 = modP(X2 * a); // aX²
        const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
        const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
        if (left !== right) throw new Error("bad point: equation left != right (1)");
        // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
        const XY = modP(X * Y);
        const ZT = modP(Z * T);
        if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        return true;
    });
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            aCoordinate("x", ex);
            aCoordinate("y", ey);
            aCoordinate("z", ez);
            aCoordinate("t", et);
            Object.freeze(this);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            aCoordinate("x", x);
            aCoordinate("y", y);
            return new Point(x, y, $7f6ec69dc561266f$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            assertValidMemo(this);
        }
        // Compare one point to another.
        equals(other) {
            assertPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($7f6ec69dc561266f$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            assertPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $7f6ec69dc561266f$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $7f6ec69dc561266f$var$_2n * T2);
                const D = modP(T1 * $7f6ec69dc561266f$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const n = scalar;
            $hX21w.aInRange("scalar", n, $7f6ec69dc561266f$var$_1n, CURVE_ORDER); // 1 <= scalar < L
            const { p: p, f: f } = this.wNAF(n);
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        multiplyUnsafe(scalar) {
            const n = scalar;
            $hX21w.aInRange("scalar", n, $7f6ec69dc561266f$var$_0n, CURVE_ORDER); // 0 <= scalar < L
            if (n === $7f6ec69dc561266f$var$_0n) return I;
            if (this.equals(I) || n === $7f6ec69dc561266f$var$_1n) return this;
            if (this.equals(G)) return this.wNAF(n).p;
            return wnaf.unsafeLadder(this, n);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $7f6ec69dc561266f$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $hX21w.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            (0, $hX21w.abool)("zip215", zip215);
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $hX21w.bytesToNumberLE(normed);
            // RFC8032 prohibits >= p, but ZIP215 doesn't
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            const max = zip215 ? MASK : Fp.ORDER;
            $hX21w.aInRange("pointHex.y", y, $7f6ec69dc561266f$var$_0n, max);
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $7f6ec69dc561266f$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $7f6ec69dc561266f$var$_1n) === $7f6ec69dc561266f$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $7f6ec69dc561266f$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $hX21w.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $7f6ec69dc561266f$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $hX21w.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $7f6ec69dc561266f$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($7f6ec69dc561266f$var$_0n, $7f6ec69dc561266f$var$_1n, $7f6ec69dc561266f$var$_1n, $7f6ec69dc561266f$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $c97Ta.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $4ALPe.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($hX21w.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = nByteLength;
        key = (0, $hX21w.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $hX21w.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $hX21w.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $hX21w.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $hX21w.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        $hX21w.aInRange("signature.s", s, $7f6ec69dc561266f$var$_0n, CURVE_ORDER); // 0 <= s < l
        const res = $hX21w.concatBytes(R, $hX21w.numberToBytesLE(s, Fp.BYTES));
        return (0, $hX21w.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    const verifyOpts = $7f6ec69dc561266f$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $hX21w.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $hX21w.ensureBytes)("message", msg);
        if (zip215 !== undefined) (0, $hX21w.abool)("zip215", zip215);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $hX21w.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        let A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}

});
parcelRegister("c97Ta", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $4ALPe = parcelRequire("4ALPe");

var $hX21w = parcelRequire("hX21w");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const validateW = (W)=>{
        if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error(`Wrong window size=${W}, should be [1..${bits}]`);
    };
    const opts = (W)=>{
        validateW(W);
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, n, transform) {
            const W = pointWindowSizes.get(P) || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize (P, W) {
            validateW(W);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
function validateBasic(curve) {
    (0, $4ALPe.validateField)(curve.Fp);
    (0, $hX21w.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $4ALPe.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("4ALPe", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $357f9f515d07e0e5$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow", function () { return $357f9f515d07e0e5$export$9c297f60e22e3389; });
$parcel$export(module.exports, "pow2", function () { return $357f9f515d07e0e5$export$fa569bd808b67eef; });
$parcel$export(module.exports, "invert", function () { return $357f9f515d07e0e5$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "isNegativeLE", function () { return $357f9f515d07e0e5$export$7806f13ad5078b2f; });
$parcel$export(module.exports, "validateField", function () { return $357f9f515d07e0e5$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $357f9f515d07e0e5$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $357f9f515d07e0e5$export$a455218a85c89869; });
$parcel$export(module.exports, "FpSqrtEven", function () { return $357f9f515d07e0e5$export$1d7b691df0888e02; });
$parcel$export(module.exports, "getMinHashLength", function () { return $357f9f515d07e0e5$export$d058763b563056af; });
$parcel$export(module.exports, "mapHashToField", function () { return $357f9f515d07e0e5$export$20cb21dbfa61dac3; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $hX21w = parcelRequire("hX21w");
// prettier-ignore
const $357f9f515d07e0e5$var$_0n = BigInt(0), $357f9f515d07e0e5$var$_1n = BigInt(1), $357f9f515d07e0e5$var$_2n = BigInt(2), $357f9f515d07e0e5$var$_3n = BigInt(3);
// prettier-ignore
const $357f9f515d07e0e5$var$_4n = BigInt(4), $357f9f515d07e0e5$var$_5n = BigInt(5), $357f9f515d07e0e5$var$_8n = BigInt(8);
// prettier-ignore
const $357f9f515d07e0e5$var$_9n = BigInt(9), $357f9f515d07e0e5$var$_16n = BigInt(16);
function $357f9f515d07e0e5$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $357f9f515d07e0e5$var$_0n ? result : b + result;
}
function $357f9f515d07e0e5$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $357f9f515d07e0e5$var$_0n || power < $357f9f515d07e0e5$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $357f9f515d07e0e5$var$_1n) return $357f9f515d07e0e5$var$_0n;
    let res = $357f9f515d07e0e5$var$_1n;
    while(power > $357f9f515d07e0e5$var$_0n){
        if (power & $357f9f515d07e0e5$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $357f9f515d07e0e5$var$_1n;
    }
    return res;
}
function $357f9f515d07e0e5$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $357f9f515d07e0e5$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $357f9f515d07e0e5$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $357f9f515d07e0e5$var$_0n || modulo <= $357f9f515d07e0e5$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $357f9f515d07e0e5$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $357f9f515d07e0e5$var$_0n, y = $357f9f515d07e0e5$var$_1n, u = $357f9f515d07e0e5$var$_1n, v = $357f9f515d07e0e5$var$_0n;
    while(a !== $357f9f515d07e0e5$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $357f9f515d07e0e5$var$_1n) throw new Error("invert: does not exist");
    return $357f9f515d07e0e5$export$842a2cf37af977e1(x, modulo);
}
function $357f9f515d07e0e5$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $357f9f515d07e0e5$var$_1n) / $357f9f515d07e0e5$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $357f9f515d07e0e5$var$_1n, S = 0; Q % $357f9f515d07e0e5$var$_2n === $357f9f515d07e0e5$var$_0n; Q /= $357f9f515d07e0e5$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $357f9f515d07e0e5$var$_2n; Z < P && $357f9f515d07e0e5$export$9c297f60e22e3389(Z, legendreC, P) !== P - $357f9f515d07e0e5$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $357f9f515d07e0e5$var$_1n) / $357f9f515d07e0e5$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $357f9f515d07e0e5$var$_1n) / $357f9f515d07e0e5$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $357f9f515d07e0e5$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $357f9f515d07e0e5$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $357f9f515d07e0e5$var$_4n === $357f9f515d07e0e5$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $357f9f515d07e0e5$var$_1n) / $357f9f515d07e0e5$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $357f9f515d07e0e5$var$_8n === $357f9f515d07e0e5$var$_5n) {
        const c1 = (P - $357f9f515d07e0e5$var$_5n) / $357f9f515d07e0e5$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $357f9f515d07e0e5$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $357f9f515d07e0e5$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $357f9f515d07e0e5$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $357f9f515d07e0e5$export$69f29ab1f3e9a234(P);
}
const $357f9f515d07e0e5$export$7806f13ad5078b2f = (num, modulo)=>($357f9f515d07e0e5$export$842a2cf37af977e1(num, modulo) & $357f9f515d07e0e5$var$_1n) === $357f9f515d07e0e5$var$_1n;
// prettier-ignore
const $357f9f515d07e0e5$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $357f9f515d07e0e5$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $357f9f515d07e0e5$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $hX21w.validateObject)(field, opts);
}
function $357f9f515d07e0e5$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $357f9f515d07e0e5$var$_0n) throw new Error("Expected power > 0");
    if (power === $357f9f515d07e0e5$var$_0n) return f.ONE;
    if (power === $357f9f515d07e0e5$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $357f9f515d07e0e5$var$_0n){
        if (power & $357f9f515d07e0e5$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $357f9f515d07e0e5$var$_1n;
    }
    return p;
}
function $357f9f515d07e0e5$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $357f9f515d07e0e5$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $357f9f515d07e0e5$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $357f9f515d07e0e5$export$77ed22730026dd0d(order) {
    // (a | p) ≡ 1    if a is a square (mod p), quadratic residue
    // (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreConst = (order - $357f9f515d07e0e5$var$_1n) / $357f9f515d07e0e5$var$_2n; // Integer arithmetic
    return (f, x)=>f.pow(x, legendreConst);
}
function $357f9f515d07e0e5$export$5e2b6e87f2891ea7(f) {
    const legendre = $357f9f515d07e0e5$export$77ed22730026dd0d(f.ORDER);
    return (x)=>{
        const p = legendre(f, x);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $357f9f515d07e0e5$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $357f9f515d07e0e5$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $357f9f515d07e0e5$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $357f9f515d07e0e5$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $357f9f515d07e0e5$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $hX21w.bitMask)(BITS),
        ZERO: $357f9f515d07e0e5$var$_0n,
        ONE: $357f9f515d07e0e5$var$_1n,
        create: (num)=>$357f9f515d07e0e5$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $357f9f515d07e0e5$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $357f9f515d07e0e5$var$_0n,
        isOdd: (num)=>(num & $357f9f515d07e0e5$var$_1n) === $357f9f515d07e0e5$var$_1n,
        neg: (num)=>$357f9f515d07e0e5$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$357f9f515d07e0e5$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$357f9f515d07e0e5$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$357f9f515d07e0e5$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$357f9f515d07e0e5$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$357f9f515d07e0e5$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$357f9f515d07e0e5$export$842a2cf37af977e1(lhs * $357f9f515d07e0e5$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$357f9f515d07e0e5$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$357f9f515d07e0e5$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $hX21w.numberToBytesLE)(num, BYTES) : (0, $hX21w.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $hX21w.bytesToNumberLE)(bytes) : (0, $hX21w.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $357f9f515d07e0e5$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $357f9f515d07e0e5$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $357f9f515d07e0e5$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $hX21w.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $357f9f515d07e0e5$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $hX21w.bytesToNumberLE)(hash) : (0, $hX21w.bytesToNumberBE)(hash);
    return $357f9f515d07e0e5$export$842a2cf37af977e1(num, groupOrder - $357f9f515d07e0e5$var$_1n) + $357f9f515d07e0e5$var$_1n;
}
function $357f9f515d07e0e5$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $357f9f515d07e0e5$export$d058763b563056af(fieldOrder) {
    const length = $357f9f515d07e0e5$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $357f9f515d07e0e5$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $357f9f515d07e0e5$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $357f9f515d07e0e5$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $hX21w.bytesToNumberBE)(key) : (0, $hX21w.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $357f9f515d07e0e5$export$842a2cf37af977e1(num, fieldOrder - $357f9f515d07e0e5$var$_1n) + $357f9f515d07e0e5$var$_1n;
    return isLE ? (0, $hX21w.numberToBytesLE)(reduced, fieldLen) : (0, $hX21w.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("hX21w", function(module, exports) {

$parcel$export(module.exports, "isBytes", function () { return $d1198433ffb0b5aa$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "abytes", function () { return $d1198433ffb0b5aa$export$e8a750b9efad93f5; });
$parcel$export(module.exports, "abool", function () { return $d1198433ffb0b5aa$export$809304d28d77d92d; });
$parcel$export(module.exports, "bytesToHex", function () { return $d1198433ffb0b5aa$export$58b867e287a802c8; });
$parcel$export(module.exports, "numberToHexUnpadded", function () { return $d1198433ffb0b5aa$export$4ed2545b622827c1; });
$parcel$export(module.exports, "hexToNumber", function () { return $d1198433ffb0b5aa$export$d57f2bacc26b4249; });
$parcel$export(module.exports, "hexToBytes", function () { return $d1198433ffb0b5aa$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $d1198433ffb0b5aa$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $d1198433ffb0b5aa$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $d1198433ffb0b5aa$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $d1198433ffb0b5aa$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "numberToVarBytesBE", function () { return $d1198433ffb0b5aa$export$80ee8c1914de6dde; });
$parcel$export(module.exports, "ensureBytes", function () { return $d1198433ffb0b5aa$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $d1198433ffb0b5aa$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $d1198433ffb0b5aa$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $d1198433ffb0b5aa$export$3df70a15530b5e81; });
$parcel$export(module.exports, "inRange", function () { return $d1198433ffb0b5aa$export$ddf89a9c5af38f94; });
$parcel$export(module.exports, "aInRange", function () { return $d1198433ffb0b5aa$export$86cc12b5dde3c1e4; });
$parcel$export(module.exports, "bitLen", function () { return $d1198433ffb0b5aa$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitGet", function () { return $d1198433ffb0b5aa$export$9577d112d1fd46ad; });
$parcel$export(module.exports, "bitSet", function () { return $d1198433ffb0b5aa$export$967bb2b9787441cb; });
$parcel$export(module.exports, "bitMask", function () { return $d1198433ffb0b5aa$export$803efa2fa1c7279; });
$parcel$export(module.exports, "createHmacDrbg", function () { return $d1198433ffb0b5aa$export$d459d139192e4fba; });
$parcel$export(module.exports, "validateObject", function () { return $d1198433ffb0b5aa$export$381bae2d0f08004f; });
$parcel$export(module.exports, "notImplemented", function () { return $d1198433ffb0b5aa$export$94a5f06e658f87e2; });
$parcel$export(module.exports, "memoized", function () { return $d1198433ffb0b5aa$export$9756366f7cb6f62b; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $d1198433ffb0b5aa$var$_0n = /* @__PURE__ */ BigInt(0);
const $d1198433ffb0b5aa$var$_1n = /* @__PURE__ */ BigInt(1);
const $d1198433ffb0b5aa$var$_2n = /* @__PURE__ */ BigInt(2);
function $d1198433ffb0b5aa$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $d1198433ffb0b5aa$export$e8a750b9efad93f5(item) {
    if (!$d1198433ffb0b5aa$export$c6fabfbfd097fc30(item)) throw new Error("Uint8Array expected");
}
function $d1198433ffb0b5aa$export$809304d28d77d92d(title, value) {
    if (typeof value !== "boolean") throw new Error(`${title} must be valid boolean, got "${value}".`);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $d1198433ffb0b5aa$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $d1198433ffb0b5aa$export$58b867e287a802c8(bytes) {
    $d1198433ffb0b5aa$export$e8a750b9efad93f5(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $d1198433ffb0b5aa$var$hexes[bytes[i]];
    return hex;
}
function $d1198433ffb0b5aa$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $d1198433ffb0b5aa$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
// We use optimized technique to convert hex string to byte array
const $d1198433ffb0b5aa$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $d1198433ffb0b5aa$var$asciiToBase16(char) {
    if (char >= $d1198433ffb0b5aa$var$asciis._0 && char <= $d1198433ffb0b5aa$var$asciis._9) return char - $d1198433ffb0b5aa$var$asciis._0;
    if (char >= $d1198433ffb0b5aa$var$asciis._A && char <= $d1198433ffb0b5aa$var$asciis._F) return char - ($d1198433ffb0b5aa$var$asciis._A - 10);
    if (char >= $d1198433ffb0b5aa$var$asciis._a && char <= $d1198433ffb0b5aa$var$asciis._f) return char - ($d1198433ffb0b5aa$var$asciis._a - 10);
    return;
}
function $d1198433ffb0b5aa$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $d1198433ffb0b5aa$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $d1198433ffb0b5aa$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
function $d1198433ffb0b5aa$export$d609354794974f8(bytes) {
    return $d1198433ffb0b5aa$export$d57f2bacc26b4249($d1198433ffb0b5aa$export$58b867e287a802c8(bytes));
}
function $d1198433ffb0b5aa$export$d67b1d03392107e7(bytes) {
    $d1198433ffb0b5aa$export$e8a750b9efad93f5(bytes);
    return $d1198433ffb0b5aa$export$d57f2bacc26b4249($d1198433ffb0b5aa$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $d1198433ffb0b5aa$export$1459dafd057611cb(n, len) {
    return $d1198433ffb0b5aa$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $d1198433ffb0b5aa$export$ba2172e58d139f6d(n, len) {
    return $d1198433ffb0b5aa$export$1459dafd057611cb(n, len).reverse();
}
function $d1198433ffb0b5aa$export$80ee8c1914de6dde(n) {
    return $d1198433ffb0b5aa$export$31c96b9df38bc8d4($d1198433ffb0b5aa$export$4ed2545b622827c1(n));
}
function $d1198433ffb0b5aa$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $d1198433ffb0b5aa$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($d1198433ffb0b5aa$export$c6fabfbfd097fc30(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $d1198433ffb0b5aa$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $d1198433ffb0b5aa$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $d1198433ffb0b5aa$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $d1198433ffb0b5aa$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const $d1198433ffb0b5aa$var$isPosBig = (n)=>typeof n === "bigint" && $d1198433ffb0b5aa$var$_0n <= n;
function $d1198433ffb0b5aa$export$ddf89a9c5af38f94(n, min, max) {
    return $d1198433ffb0b5aa$var$isPosBig(n) && $d1198433ffb0b5aa$var$isPosBig(min) && $d1198433ffb0b5aa$var$isPosBig(max) && min <= n && n < max;
}
function $d1198433ffb0b5aa$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$d1198433ffb0b5aa$export$ddf89a9c5af38f94(n, min, max)) throw new Error(`expected valid ${title}: ${min} <= n < ${max}, got ${typeof n} ${n}`);
}
function $d1198433ffb0b5aa$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $d1198433ffb0b5aa$var$_0n; n >>= $d1198433ffb0b5aa$var$_1n, len += 1);
    return len;
}
function $d1198433ffb0b5aa$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $d1198433ffb0b5aa$var$_1n;
}
function $d1198433ffb0b5aa$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $d1198433ffb0b5aa$var$_1n : $d1198433ffb0b5aa$var$_0n) << BigInt(pos);
}
const $d1198433ffb0b5aa$export$803efa2fa1c7279 = (n)=>($d1198433ffb0b5aa$var$_2n << BigInt(n - 1)) - $d1198433ffb0b5aa$var$_1n;
// DRBG
const $d1198433ffb0b5aa$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $d1198433ffb0b5aa$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $d1198433ffb0b5aa$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $d1198433ffb0b5aa$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $d1198433ffb0b5aa$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $d1198433ffb0b5aa$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($d1198433ffb0b5aa$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($d1198433ffb0b5aa$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $d1198433ffb0b5aa$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $d1198433ffb0b5aa$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $d1198433ffb0b5aa$export$c6fabfbfd097fc30(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $d1198433ffb0b5aa$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $d1198433ffb0b5aa$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
const $d1198433ffb0b5aa$export$94a5f06e658f87e2 = ()=>{
    throw new Error("not implemented");
};
function $d1198433ffb0b5aa$export$9756366f7cb6f62b(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});




parcelRegister("6WoFF", function(module, exports) {

$parcel$export(module.exports, "expand_message_xmd", function () { return $50db4c00b1f5d94c$export$3df78c69af9fc85d; });
$parcel$export(module.exports, "isogenyMap", function () { return $50db4c00b1f5d94c$export$9393380cf1075f28; });
$parcel$export(module.exports, "createHasher", function () { return $50db4c00b1f5d94c$export$14b114effbc08b6b; });

var $4ALPe = parcelRequire("4ALPe");

var $hX21w = parcelRequire("hX21w");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $50db4c00b1f5d94c$var$os2ip = (0, $hX21w.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $50db4c00b1f5d94c$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $50db4c00b1f5d94c$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $50db4c00b1f5d94c$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $50db4c00b1f5d94c$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $hX21w.abytes)(msg);
    (0, $hX21w.abytes)(DST);
    $50db4c00b1f5d94c$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $hX21w.concatBytes)((0, $hX21w.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $hX21w.concatBytes)(DST, $50db4c00b1f5d94c$var$i2osp(DST.length, 1));
    const Z_pad = $50db4c00b1f5d94c$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $50db4c00b1f5d94c$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $hX21w.concatBytes)(Z_pad, msg, l_i_b_str, $50db4c00b1f5d94c$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $hX21w.concatBytes)(b_0, $50db4c00b1f5d94c$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $50db4c00b1f5d94c$var$strxor(b_0, b[i - 1]),
            $50db4c00b1f5d94c$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $hX21w.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $hX21w.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $50db4c00b1f5d94c$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $hX21w.abytes)(msg);
    (0, $hX21w.abytes)(DST);
    $50db4c00b1f5d94c$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $hX21w.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($50db4c00b1f5d94c$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($50db4c00b1f5d94c$var$i2osp(DST.length, 1)).digest();
}
function $50db4c00b1f5d94c$export$97cdd5ee18de8172(msg, count, options) {
    (0, $hX21w.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    (0, $hX21w.abytes)(msg);
    $50db4c00b1f5d94c$var$anum(count);
    const DST = typeof _DST === "string" ? (0, $hX21w.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $50db4c00b1f5d94c$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $50db4c00b1f5d94c$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $4ALPe.mod)($50db4c00b1f5d94c$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $50db4c00b1f5d94c$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $50db4c00b1f5d94c$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $50db4c00b1f5d94c$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $50db4c00b1f5d94c$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error("mapToCurve: expected array of bigints");
            for (const i of scalars)if (typeof i !== "bigint") throw new Error(`mapToCurve: expected array of bigints, got ${i} in array`);
            const P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});

parcelRegister("4kbdz", function(module, exports) {

$parcel$export(module.exports, "montgomery", function () { return $3261bb55cf3b5291$export$bdbee0d01bf914a7; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $4ALPe = parcelRequire("4ALPe");

var $hX21w = parcelRequire("hX21w");
const $3261bb55cf3b5291$var$_0n = BigInt(0);
const $3261bb55cf3b5291$var$_1n = BigInt(1);
function $3261bb55cf3b5291$var$validateOpts(curve) {
    (0, $hX21w.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
function $3261bb55cf3b5291$export$bdbee0d01bf914a7(curveDef) {
    const CURVE = $3261bb55cf3b5291$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $4ALPe.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $4ALPe.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(u, scalar) {
        (0, $hX21w.aInRange)("u", u, $3261bb55cf3b5291$var$_0n, P);
        (0, $hX21w.aInRange)("scalar", scalar, $3261bb55cf3b5291$var$_0n, P);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = scalar;
        const x_1 = u;
        let x_2 = $3261bb55cf3b5291$var$_1n;
        let z_2 = $3261bb55cf3b5291$var$_0n;
        let x_3 = u;
        let z_3 = $3261bb55cf3b5291$var$_1n;
        let swap = $3261bb55cf3b5291$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $3261bb55cf3b5291$var$_0n; t--){
            const k_t = k >> t & $3261bb55cf3b5291$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $hX21w.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        const u = (0, $hX21w.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        if (fieldLen === 32) u[31] &= 127; // 0b0111_1111
        return (0, $hX21w.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $hX21w.ensureBytes)("scalar", n);
        const len = bytes.length;
        if (len !== montgomeryBytes && len !== fieldLen) throw new Error(`Expected ${montgomeryBytes} or ${fieldLen} bytes, got ${len}`);
        return (0, $hX21w.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $3261bb55cf3b5291$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}

});


parcelRegister("kn7SP", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("1S6xU")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("1S6xU", function(module, exports) {
"use strict";

});


parcelRegister("cqBHq", function(module, exports) {

var $ctcOF = parcelRequire("ctcOF");
var $90c52811bdf347c8$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $ctcOF($90c52811bdf347c8$var$ALPHABET);

});
parcelRegister("ctcOF", function(module, exports) {
"use strict";

var $fFpVy = parcelRequire("fFpVy");
var $91422280bedb6844$require$_Buffer = $fFpVy.Buffer;
function $91422280bedb6844$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $91422280bedb6844$require$_Buffer.from(source);
        if (!$91422280bedb6844$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $91422280bedb6844$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $91422280bedb6844$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $91422280bedb6844$var$base;

});
parcelRegister("fFpVy", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $jtAZT = parcelRequire("jtAZT");
var $b67ecbf7b07a8203$var$Buffer = $jtAZT.Buffer;
// alternative to using Object.keys for old browsers
function $b67ecbf7b07a8203$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($b67ecbf7b07a8203$var$Buffer.from && $b67ecbf7b07a8203$var$Buffer.alloc && $b67ecbf7b07a8203$var$Buffer.allocUnsafe && $b67ecbf7b07a8203$var$Buffer.allocUnsafeSlow) module.exports = $jtAZT;
else {
    // Copy properties from require('buffer')
    $b67ecbf7b07a8203$var$copyProps($jtAZT, module.exports);
    module.exports.Buffer = $b67ecbf7b07a8203$var$SafeBuffer;
}
function $b67ecbf7b07a8203$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $b67ecbf7b07a8203$var$Buffer(arg, encodingOrOffset, length);
}
$b67ecbf7b07a8203$var$SafeBuffer.prototype = Object.create($b67ecbf7b07a8203$var$Buffer.prototype);
// Copy static methods from Buffer
$b67ecbf7b07a8203$var$copyProps($b67ecbf7b07a8203$var$Buffer, $b67ecbf7b07a8203$var$SafeBuffer);
$b67ecbf7b07a8203$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $b67ecbf7b07a8203$var$Buffer(arg, encodingOrOffset, length);
};
$b67ecbf7b07a8203$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $b67ecbf7b07a8203$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$b67ecbf7b07a8203$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $b67ecbf7b07a8203$var$Buffer(size);
};
$b67ecbf7b07a8203$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $jtAZT.SlowBuffer(size);
};

});



parcelRegister("iIvsQ", function(module, exports) {

$parcel$export(module.exports, "sha256", function () { return $0384349dba359a04$export$bced8d2aada2d1c9; });

var $k2w2A = parcelRequire("k2w2A");

var $emVFP = parcelRequire("emVFP");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $0384349dba359a04$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const $0384349dba359a04$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $0384349dba359a04$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $0384349dba359a04$var$SHA256 extends (0, $k2w2A.HashMD) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $0384349dba359a04$var$SHA256_IV[0] | 0;
        this.B = $0384349dba359a04$var$SHA256_IV[1] | 0;
        this.C = $0384349dba359a04$var$SHA256_IV[2] | 0;
        this.D = $0384349dba359a04$var$SHA256_IV[3] | 0;
        this.E = $0384349dba359a04$var$SHA256_IV[4] | 0;
        this.F = $0384349dba359a04$var$SHA256_IV[5] | 0;
        this.G = $0384349dba359a04$var$SHA256_IV[6] | 0;
        this.H = $0384349dba359a04$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$0384349dba359a04$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $0384349dba359a04$var$SHA256_W[i - 15];
            const W2 = $0384349dba359a04$var$SHA256_W[i - 2];
            const s0 = (0, $emVFP.rotr)(W15, 7) ^ (0, $emVFP.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $emVFP.rotr)(W2, 17) ^ (0, $emVFP.rotr)(W2, 19) ^ W2 >>> 10;
            $0384349dba359a04$var$SHA256_W[i] = s1 + $0384349dba359a04$var$SHA256_W[i - 7] + s0 + $0384349dba359a04$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $emVFP.rotr)(E, 6) ^ (0, $emVFP.rotr)(E, 11) ^ (0, $emVFP.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $k2w2A.Chi)(E, F, G) + $0384349dba359a04$var$SHA256_K[i] + $0384349dba359a04$var$SHA256_W[i] | 0;
            const sigma0 = (0, $emVFP.rotr)(A, 2) ^ (0, $emVFP.rotr)(A, 13) ^ (0, $emVFP.rotr)(A, 22);
            const T2 = sigma0 + (0, $k2w2A.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $0384349dba359a04$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $0384349dba359a04$var$SHA224 extends $0384349dba359a04$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $0384349dba359a04$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $emVFP.wrapConstructor)(()=>new $0384349dba359a04$var$SHA256());
const $0384349dba359a04$export$97b70509d4e397ea = /* @__PURE__ */ (0, $emVFP.wrapConstructor)(()=>new $0384349dba359a04$var$SHA224());

});

parcelRegister("iBK9E", function(module, exports) {

var $jtAZT = parcelRequire("jtAZT");
var $d8bf7c0a741d143e$require$Buffer = $jtAZT.Buffer;
"use strict";
var $d8bf7c0a741d143e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d8bf7c0a741d143e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d8bf7c0a741d143e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $d8bf7c0a741d143e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $d8bf7c0a741d143e$var$__createBinding(result, mod, k);
    }
    $d8bf7c0a741d143e$var$__setModuleDefault(result, mod);
    return result;
};
var $d8bf7c0a741d143e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeUnchecked = module.exports.deserialize = module.exports.serialize = module.exports.BinaryReader = module.exports.BinaryWriter = module.exports.BorshError = module.exports.baseDecode = module.exports.baseEncode = void 0;

const $d8bf7c0a741d143e$var$bn_js_1 = $d8bf7c0a741d143e$var$__importDefault((parcelRequire("kn7SP")));

const $d8bf7c0a741d143e$var$bs58_1 = $d8bf7c0a741d143e$var$__importDefault((parcelRequire("e31xV")));

// TODO: Make sure this polyfill not included when not required
const $d8bf7c0a741d143e$var$encoding = $d8bf7c0a741d143e$var$__importStar((parcelRequire("vCpi5")));
const $d8bf7c0a741d143e$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $d8bf7c0a741d143e$var$encoding.TextDecoder : TextDecoder;
const $d8bf7c0a741d143e$var$textDecoder = new $d8bf7c0a741d143e$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $d8bf7c0a741d143e$var$baseEncode(value) {
    if (typeof value === "string") value = $d8bf7c0a741d143e$require$Buffer.from(value, "utf8");
    return $d8bf7c0a741d143e$var$bs58_1.default.encode($d8bf7c0a741d143e$require$Buffer.from(value));
}
module.exports.baseEncode = $d8bf7c0a741d143e$var$baseEncode;
function $d8bf7c0a741d143e$var$baseDecode(value) {
    return $d8bf7c0a741d143e$require$Buffer.from($d8bf7c0a741d143e$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $d8bf7c0a741d143e$var$baseDecode;
const $d8bf7c0a741d143e$var$INITIAL_LENGTH = 1024;
class $d8bf7c0a741d143e$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
module.exports.BorshError = $d8bf7c0a741d143e$var$BorshError;
/// Binary encoder.
class $d8bf7c0a741d143e$var$BinaryWriter {
    constructor(){
        this.buf = $d8bf7c0a741d143e$require$Buffer.alloc($d8bf7c0a741d143e$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $d8bf7c0a741d143e$require$Buffer.concat([
            this.buf,
            $d8bf7c0a741d143e$require$Buffer.alloc($d8bf7c0a741d143e$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($d8bf7c0a741d143e$require$Buffer.from(new $d8bf7c0a741d143e$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($d8bf7c0a741d143e$require$Buffer.from(new $d8bf7c0a741d143e$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($d8bf7c0a741d143e$require$Buffer.from(new $d8bf7c0a741d143e$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($d8bf7c0a741d143e$require$Buffer.from(new $d8bf7c0a741d143e$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $d8bf7c0a741d143e$require$Buffer.concat([
            $d8bf7c0a741d143e$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $d8bf7c0a741d143e$require$Buffer.alloc($d8bf7c0a741d143e$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $d8bf7c0a741d143e$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($d8bf7c0a741d143e$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
module.exports.BinaryWriter = $d8bf7c0a741d143e$var$BinaryWriter;
function $d8bf7c0a741d143e$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $d8bf7c0a741d143e$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $d8bf7c0a741d143e$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $d8bf7c0a741d143e$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $d8bf7c0a741d143e$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $d8bf7c0a741d143e$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $d8bf7c0a741d143e$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $d8bf7c0a741d143e$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $d8bf7c0a741d143e$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $d8bf7c0a741d143e$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$d8bf7c0a741d143e$var$__decorate([
    $d8bf7c0a741d143e$var$handlingRangeError
], $d8bf7c0a741d143e$var$BinaryReader.prototype, "readU8", null);
$d8bf7c0a741d143e$var$__decorate([
    $d8bf7c0a741d143e$var$handlingRangeError
], $d8bf7c0a741d143e$var$BinaryReader.prototype, "readU16", null);
$d8bf7c0a741d143e$var$__decorate([
    $d8bf7c0a741d143e$var$handlingRangeError
], $d8bf7c0a741d143e$var$BinaryReader.prototype, "readU32", null);
$d8bf7c0a741d143e$var$__decorate([
    $d8bf7c0a741d143e$var$handlingRangeError
], $d8bf7c0a741d143e$var$BinaryReader.prototype, "readU64", null);
$d8bf7c0a741d143e$var$__decorate([
    $d8bf7c0a741d143e$var$handlingRangeError
], $d8bf7c0a741d143e$var$BinaryReader.prototype, "readU128", null);
$d8bf7c0a741d143e$var$__decorate([
    $d8bf7c0a741d143e$var$handlingRangeError
], $d8bf7c0a741d143e$var$BinaryReader.prototype, "readU256", null);
$d8bf7c0a741d143e$var$__decorate([
    $d8bf7c0a741d143e$var$handlingRangeError
], $d8bf7c0a741d143e$var$BinaryReader.prototype, "readU512", null);
$d8bf7c0a741d143e$var$__decorate([
    $d8bf7c0a741d143e$var$handlingRangeError
], $d8bf7c0a741d143e$var$BinaryReader.prototype, "readString", null);
$d8bf7c0a741d143e$var$__decorate([
    $d8bf7c0a741d143e$var$handlingRangeError
], $d8bf7c0a741d143e$var$BinaryReader.prototype, "readFixedArray", null);
$d8bf7c0a741d143e$var$__decorate([
    $d8bf7c0a741d143e$var$handlingRangeError
], $d8bf7c0a741d143e$var$BinaryReader.prototype, "readArray", null);
module.exports.BinaryReader = $d8bf7c0a741d143e$var$BinaryReader;
function $d8bf7c0a741d143e$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $d8bf7c0a741d143e$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$d8bf7c0a741d143e$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $d8bf7c0a741d143e$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $d8bf7c0a741d143e$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$d8bf7c0a741d143e$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $d8bf7c0a741d143e$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $d8bf7c0a741d143e$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $d8bf7c0a741d143e$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $d8bf7c0a741d143e$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $d8bf7c0a741d143e$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $d8bf7c0a741d143e$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $d8bf7c0a741d143e$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $d8bf7c0a741d143e$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $d8bf7c0a741d143e$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $d8bf7c0a741d143e$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $d8bf7c0a741d143e$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $d8bf7c0a741d143e$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $d8bf7c0a741d143e$var$serialize(schema, obj, Writer = $d8bf7c0a741d143e$var$BinaryWriter) {
    const writer = new Writer();
    $d8bf7c0a741d143e$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
module.exports.serialize = $d8bf7c0a741d143e$var$serialize;
function $d8bf7c0a741d143e$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$d8bf7c0a741d143e$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($d8bf7c0a741d143e$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$d8bf7c0a741d143e$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $d8bf7c0a741d143e$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $d8bf7c0a741d143e$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $d8bf7c0a741d143e$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $d8bf7c0a741d143e$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $d8bf7c0a741d143e$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $d8bf7c0a741d143e$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $d8bf7c0a741d143e$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $d8bf7c0a741d143e$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $d8bf7c0a741d143e$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $d8bf7c0a741d143e$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $d8bf7c0a741d143e$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $d8bf7c0a741d143e$var$deserialize(schema, classType, buffer, Reader = $d8bf7c0a741d143e$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $d8bf7c0a741d143e$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $d8bf7c0a741d143e$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
module.exports.deserialize = $d8bf7c0a741d143e$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $d8bf7c0a741d143e$var$deserializeUnchecked(schema, classType, buffer, Reader = $d8bf7c0a741d143e$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $d8bf7c0a741d143e$var$deserializeStruct(schema, classType, reader);
}
module.exports.deserializeUnchecked = $d8bf7c0a741d143e$var$deserializeUnchecked;

});
parcelRegister("e31xV", function(module, exports) {

var $ctcOF = parcelRequire("ctcOF");
var $a3a28b8d337e9788$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $ctcOF($a3a28b8d337e9788$var$ALPHABET);

});

parcelRegister("vCpi5", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $05f0b02dc348963e$export$88fb0cfd153261a7; }, function (v) { return $05f0b02dc348963e$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $05f0b02dc348963e$export$9c6b53e35bc51b5c; }, function (v) { return $05f0b02dc348963e$export$9c6b53e35bc51b5c = v; });
var $05f0b02dc348963e$export$88fb0cfd153261a7;
var $05f0b02dc348963e$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $05f0b02dc348963e$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $05f0b02dc348963e$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $05f0b02dc348963e$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $05f0b02dc348963e$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $05f0b02dc348963e$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $05f0b02dc348963e$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$05f0b02dc348963e$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $05f0b02dc348963e$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $05f0b02dc348963e$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $05f0b02dc348963e$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $05f0b02dc348963e$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $05f0b02dc348963e$var$TextDecoder(encoding, options) {
    if (!(this instanceof $05f0b02dc348963e$var$TextDecoder)) return new $05f0b02dc348963e$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $05f0b02dc348963e$var$DEFAULT_ENCODING;
    if (encoding !== $05f0b02dc348963e$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $05f0b02dc348963e$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$05f0b02dc348963e$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $05f0b02dc348963e$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $05f0b02dc348963e$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $05f0b02dc348963e$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $05f0b02dc348963e$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $05f0b02dc348963e$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $05f0b02dc348963e$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $05f0b02dc348963e$var$TextEncoder(encoding, options) {
    if (!(this instanceof $05f0b02dc348963e$var$TextEncoder)) return new $05f0b02dc348963e$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $05f0b02dc348963e$var$DEFAULT_ENCODING;
    if (encoding !== $05f0b02dc348963e$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $05f0b02dc348963e$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$05f0b02dc348963e$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $05f0b02dc348963e$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $05f0b02dc348963e$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $05f0b02dc348963e$var$Stream($05f0b02dc348963e$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $05f0b02dc348963e$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $05f0b02dc348963e$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $05f0b02dc348963e$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $05f0b02dc348963e$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $05f0b02dc348963e$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $05f0b02dc348963e$var$end_of_stream) return $05f0b02dc348963e$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($05f0b02dc348963e$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($05f0b02dc348963e$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($05f0b02dc348963e$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($05f0b02dc348963e$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $05f0b02dc348963e$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$05f0b02dc348963e$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $05f0b02dc348963e$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $05f0b02dc348963e$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $05f0b02dc348963e$var$end_of_stream) return $05f0b02dc348963e$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($05f0b02dc348963e$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($05f0b02dc348963e$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($05f0b02dc348963e$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($05f0b02dc348963e$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$05f0b02dc348963e$export$88fb0cfd153261a7 = $05f0b02dc348963e$var$TextEncoder;
$05f0b02dc348963e$export$9c6b53e35bc51b5c = $05f0b02dc348963e$var$TextDecoder;

});


parcelRegister("Bz0HP", function(module, exports) {
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.s16 = module.exports.s8 = module.exports.nu64be = module.exports.u48be = module.exports.u40be = module.exports.u32be = module.exports.u24be = module.exports.u16be = module.exports.nu64 = module.exports.u48 = module.exports.u40 = module.exports.u32 = module.exports.u24 = module.exports.u16 = module.exports.u8 = module.exports.offset = module.exports.greedy = module.exports.Constant = module.exports.UTF8 = module.exports.CString = module.exports.Blob = module.exports.Boolean = module.exports.BitField = module.exports.BitStructure = module.exports.VariantLayout = module.exports.Union = module.exports.UnionLayoutDiscriminator = module.exports.UnionDiscriminator = module.exports.Structure = module.exports.Sequence = module.exports.DoubleBE = module.exports.Double = module.exports.FloatBE = module.exports.Float = module.exports.NearInt64BE = module.exports.NearInt64 = module.exports.NearUInt64BE = module.exports.NearUInt64 = module.exports.IntBE = module.exports.Int = module.exports.UIntBE = module.exports.UInt = module.exports.OffsetLayout = module.exports.GreedyCount = module.exports.ExternalLayout = module.exports.bindConstructorLayout = module.exports.nameWithProperty = module.exports.Layout = module.exports.uint8ArrayToBuffer = module.exports.checkUint8Array = void 0;
module.exports.constant = module.exports.utf8 = module.exports.cstr = module.exports.blob = module.exports.unionLayoutDiscriminator = module.exports.union = module.exports.seq = module.exports.bits = module.exports.struct = module.exports.f64be = module.exports.f64 = module.exports.f32be = module.exports.f32 = module.exports.ns64be = module.exports.s48be = module.exports.s40be = module.exports.s32be = module.exports.s24be = module.exports.s16be = module.exports.ns64 = module.exports.s48 = module.exports.s40 = module.exports.s32 = module.exports.s24 = void 0;

var $edvwf = parcelRequire("edvwf");
/* Check if a value is a Uint8Array.
 *
 * @ignore */ function $070e9d263900ead0$var$checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError("b must be a Uint8Array");
}
module.exports.checkUint8Array = $070e9d263900ead0$var$checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function $070e9d263900ead0$var$uint8ArrayToBuffer(b) {
    $070e9d263900ead0$var$checkUint8Array(b);
    return $edvwf.Buffer.from(b.buffer, b.byteOffset, b.length);
}
module.exports.uint8ArrayToBuffer = $070e9d263900ead0$var$uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $070e9d263900ead0$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ makeDestinationObject() {
        return {};
    }
    /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ fromArray(values) {
        return undefined;
    }
}
module.exports.Layout = $070e9d263900ead0$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $070e9d263900ead0$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
module.exports.nameWithProperty = $070e9d263900ead0$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $070e9d263900ead0$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Object.prototype.hasOwnProperty.call(Class, "layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $070e9d263900ead0$var$Layout)) throw new TypeError("layout must be a Layout");
    if (Object.prototype.hasOwnProperty.call(layout, "boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value (b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value (b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
module.exports.bindConstructorLayout = $070e9d263900ead0$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $070e9d263900ead0$var$ExternalLayout extends $070e9d263900ead0$var$Layout {
    /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
module.exports.ExternalLayout = $070e9d263900ead0$var$ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $070e9d263900ead0$var$GreedyCount extends $070e9d263900ead0$var$ExternalLayout {
    constructor(elementSpan = 1, property){
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset = 0) {
        $070e9d263900ead0$var$checkUint8Array(b);
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
module.exports.GreedyCount = $070e9d263900ead0$var$GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$OffsetLayout extends $070e9d263900ead0$var$ExternalLayout {
    constructor(layout, offset = 0, property){
        if (!(layout instanceof $070e9d263900ead0$var$Layout)) throw new TypeError("layout must be a Layout");
        if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $070e9d263900ead0$var$UInt || this.layout instanceof $070e9d263900ead0$var$UIntBE;
    }
    /** @override */ decode(b, offset = 0) {
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        return this.layout.encode(src, b, offset + this.offset);
    }
}
module.exports.OffsetLayout = $070e9d263900ead0$var$OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$UInt extends $070e9d263900ead0$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $070e9d263900ead0$var$uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UInt = $070e9d263900ead0$var$UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$UIntBE extends $070e9d263900ead0$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $070e9d263900ead0$var$uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.UIntBE = $070e9d263900ead0$var$UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$Int extends $070e9d263900ead0$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $070e9d263900ead0$var$uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
        return this.span;
    }
}
module.exports.Int = $070e9d263900ead0$var$Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$IntBE extends $070e9d263900ead0$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $070e9d263900ead0$var$uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
        return this.span;
    }
}
module.exports.IntBE = $070e9d263900ead0$var$IntBE;
const $070e9d263900ead0$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $070e9d263900ead0$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $070e9d263900ead0$var$V2E32);
    const lo32 = src - hi32 * $070e9d263900ead0$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $070e9d263900ead0$var$roundedInt64(hi32, lo32) {
    return hi32 * $070e9d263900ead0$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$NearUInt64 extends $070e9d263900ead0$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $070e9d263900ead0$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readUInt32LE(offset + 4);
        return $070e9d263900ead0$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $070e9d263900ead0$var$divmodInt64(src);
        const buffer = $070e9d263900ead0$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64 = $070e9d263900ead0$var$NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$NearUInt64BE extends $070e9d263900ead0$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $070e9d263900ead0$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readUInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $070e9d263900ead0$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $070e9d263900ead0$var$divmodInt64(src);
        const buffer = $070e9d263900ead0$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearUInt64BE = $070e9d263900ead0$var$NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$NearInt64 extends $070e9d263900ead0$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $070e9d263900ead0$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readInt32LE(offset + 4);
        return $070e9d263900ead0$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $070e9d263900ead0$var$divmodInt64(src);
        const buffer = $070e9d263900ead0$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64 = $070e9d263900ead0$var$NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$NearInt64BE extends $070e9d263900ead0$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $070e9d263900ead0$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $070e9d263900ead0$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $070e9d263900ead0$var$divmodInt64(src);
        const buffer = $070e9d263900ead0$var$uint8ArrayToBuffer(b);
        buffer.writeInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
module.exports.NearInt64BE = $070e9d263900ead0$var$NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$Float extends $070e9d263900ead0$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $070e9d263900ead0$var$uint8ArrayToBuffer(b).writeFloatLE(src, offset);
        return 4;
    }
}
module.exports.Float = $070e9d263900ead0$var$Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$FloatBE extends $070e9d263900ead0$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $070e9d263900ead0$var$uint8ArrayToBuffer(b).writeFloatBE(src, offset);
        return 4;
    }
}
module.exports.FloatBE = $070e9d263900ead0$var$FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$Double extends $070e9d263900ead0$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $070e9d263900ead0$var$uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
        return 8;
    }
}
module.exports.Double = $070e9d263900ead0$var$Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$DoubleBE extends $070e9d263900ead0$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $070e9d263900ead0$var$uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
        return 8;
    }
}
module.exports.DoubleBE = $070e9d263900ead0$var$DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$Sequence extends $070e9d263900ead0$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $070e9d263900ead0$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $070e9d263900ead0$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $070e9d263900ead0$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        let count = this.count;
        if (count instanceof $070e9d263900ead0$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $070e9d263900ead0$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset = 0) {
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $070e9d263900ead0$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
module.exports.Sequence = $070e9d263900ead0$var$Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$Structure extends $070e9d263900ead0$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $070e9d263900ead0$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {
        // ignore error
        }
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        $070e9d263900ead0$var$checkUint8Array(b);
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ encode(src, b, offset = 0) {
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
    /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
        return undefined;
    }
}
module.exports.Structure = $070e9d263900ead0$var$Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $070e9d263900ead0$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ decode(b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ encode(src, b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
}
module.exports.UnionDiscriminator = $070e9d263900ead0$var$UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $070e9d263900ead0$var$UnionLayoutDiscriminator extends $070e9d263900ead0$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $070e9d263900ead0$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
module.exports.UnionLayoutDiscriminator = $070e9d263900ead0$var$UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$Union extends $070e9d263900ead0$var$Layout {
    constructor(discr, defaultLayout, property){
        let discriminator;
        if (discr instanceof $070e9d263900ead0$var$UInt || discr instanceof $070e9d263900ead0$var$UIntBE) discriminator = new $070e9d263900ead0$var$UnionLayoutDiscriminator(new $070e9d263900ead0$var$OffsetLayout(discr));
        else if (discr instanceof $070e9d263900ead0$var$ExternalLayout && discr.isCount()) discriminator = new $070e9d263900ead0$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $070e9d263900ead0$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $070e9d263900ead0$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof $070e9d263900ead0$var$UInt || discr instanceof $070e9d263900ead0$var$UIntBE)) span += discriminator.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ this.usesPrefixDiscriminator = discr instanceof $070e9d263900ead0$var$UInt || discr instanceof $070e9d263900ead0$var$UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ defaultGetSourceVariant(src) {
        if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
            if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ decode(b, offset = 0) {
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        const clo = this.registry[discr];
        if (undefined === clo) {
            const defaultLayout = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            // defaultLayout.property can be undefined, but this is allowed by buffer-layout
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ encode(src, b, offset = 0) {
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            // this.defaultLayout is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            // clo.property is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $070e9d263900ead0$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ getVariant(vb, offset = 0) {
        let variant;
        if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
        else variant = vb;
        return this.registry[variant];
    }
}
module.exports.Union = $070e9d263900ead0$var$Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$VariantLayout extends $070e9d263900ead0$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $070e9d263900ead0$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $070e9d263900ead0$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ let span = 0;
        if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
        return contentOffset + span;
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset = 0) {
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
        return undefined;
    }
}
module.exports.VariantLayout = $070e9d263900ead0$var$VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $070e9d263900ead0$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$BitStructure extends $070e9d263900ead0$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $070e9d263900ead0$var$UInt || word instanceof $070e9d263900ead0$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $070e9d263900ead0$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset = 0) {
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ addField(bits, property) {
        const bf = new $070e9d263900ead0$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
    // eslint-disable-next-line @typescript-eslint/ban-types
    addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        const bf = new $070e9d263900ead0$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
}
module.exports.BitStructure = $070e9d263900ead0$var$BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $070e9d263900ead0$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $070e9d263900ead0$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = $070e9d263900ead0$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field. */ decode(b, offset) {
        const word = this.container._packedGetValue();
        const wordValue = $070e9d263900ead0$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if ("number" !== typeof value || !Number.isInteger(value) || value !== $070e9d263900ead0$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($070e9d263900ead0$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $070e9d263900ead0$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($070e9d263900ead0$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
module.exports.BitField = $070e9d263900ead0$var$BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $070e9d263900ead0$var$Boolean extends $070e9d263900ead0$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ decode(b, offset) {
        return !!super.decode(b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        super.encode(value);
    }
}
module.exports.Boolean = $070e9d263900ead0$var$Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$Blob extends $070e9d263900ead0$var$Layout {
    constructor(length, property){
        if (!(length instanceof $070e9d263900ead0$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $070e9d263900ead0$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $070e9d263900ead0$var$ExternalLayout) span = src.length;
        if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError($070e9d263900ead0$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Uint8Array as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Uint8Array");
        const srcBuffer = $070e9d263900ead0$var$uint8ArrayToBuffer(src);
        $070e9d263900ead0$var$uint8ArrayToBuffer(b).write(srcBuffer.toString("hex"), offset, span, "hex");
        if (this.length instanceof $070e9d263900ead0$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
module.exports.Blob = $070e9d263900ead0$var$Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$CString extends $070e9d263900ead0$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset = 0) {
        $070e9d263900ead0$var$checkUint8Array(b);
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $edvwf.Buffer.from(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        const buffer = $070e9d263900ead0$var$uint8ArrayToBuffer(b);
        srcb.copy(buffer, offset);
        buffer[offset + span] = 0;
        return span + 1;
    }
}
module.exports.CString = $070e9d263900ead0$var$CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$UTF8 extends $070e9d263900ead0$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset = 0) {
        $070e9d263900ead0$var$checkUint8Array(b);
        return b.length - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return $070e9d263900ead0$var$uint8ArrayToBuffer(b).slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $edvwf.Buffer.from(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy($070e9d263900ead0$var$uint8ArrayToBuffer(b), offset);
        return span;
    }
}
module.exports.UTF8 = $070e9d263900ead0$var$UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $070e9d263900ead0$var$Constant extends $070e9d263900ead0$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
module.exports.Constant = $070e9d263900ead0$var$Constant;
/** Factory for {@link GreedyCount}. */ module.exports.greedy = (elementSpan, property)=>new $070e9d263900ead0$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ module.exports.offset = (layout, offset, property)=>new $070e9d263900ead0$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ module.exports.u8 = (property)=>new $070e9d263900ead0$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16 = (property)=>new $070e9d263900ead0$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24 = (property)=>new $070e9d263900ead0$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32 = (property)=>new $070e9d263900ead0$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40 = (property)=>new $070e9d263900ead0$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48 = (property)=>new $070e9d263900ead0$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64 = (property)=>new $070e9d263900ead0$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ module.exports.u16be = (property)=>new $070e9d263900ead0$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ module.exports.u24be = (property)=>new $070e9d263900ead0$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ module.exports.u32be = (property)=>new $070e9d263900ead0$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ module.exports.u40be = (property)=>new $070e9d263900ead0$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ module.exports.u48be = (property)=>new $070e9d263900ead0$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ module.exports.nu64be = (property)=>new $070e9d263900ead0$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ module.exports.s8 = (property)=>new $070e9d263900ead0$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16 = (property)=>new $070e9d263900ead0$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24 = (property)=>new $070e9d263900ead0$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32 = (property)=>new $070e9d263900ead0$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40 = (property)=>new $070e9d263900ead0$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48 = (property)=>new $070e9d263900ead0$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64 = (property)=>new $070e9d263900ead0$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ module.exports.s16be = (property)=>new $070e9d263900ead0$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ module.exports.s24be = (property)=>new $070e9d263900ead0$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ module.exports.s32be = (property)=>new $070e9d263900ead0$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ module.exports.s40be = (property)=>new $070e9d263900ead0$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ module.exports.s48be = (property)=>new $070e9d263900ead0$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ module.exports.ns64be = (property)=>new $070e9d263900ead0$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ module.exports.f32 = (property)=>new $070e9d263900ead0$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ module.exports.f32be = (property)=>new $070e9d263900ead0$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ module.exports.f64 = (property)=>new $070e9d263900ead0$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ module.exports.f64be = (property)=>new $070e9d263900ead0$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ module.exports.struct = (fields, property, decodePrefixes)=>new $070e9d263900ead0$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ module.exports.bits = (word, msb, property)=>new $070e9d263900ead0$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ module.exports.seq = (elementLayout, count, property)=>new $070e9d263900ead0$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ module.exports.union = (discr, defaultLayout, property)=>new $070e9d263900ead0$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ module.exports.unionLayoutDiscriminator = (layout, property)=>new $070e9d263900ead0$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ module.exports.blob = (length, property)=>new $070e9d263900ead0$var$Blob(length, property);
/** Factory for {@link CString} values. */ module.exports.cstr = (property)=>new $070e9d263900ead0$var$CString(property);
/** Factory for {@link UTF8} values. */ module.exports.utf8 = (maxSpan, property)=>new $070e9d263900ead0$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ module.exports.constant = (value, property)=>new $070e9d263900ead0$var$Constant(value, property);

});
parcelRegister("edvwf", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $a59aba9ebd5e117f$export$a143d493d941bafc; }, function (v) { return $a59aba9ebd5e117f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $a59aba9ebd5e117f$export$f99ded8fe4b79145; }, function (v) { return $a59aba9ebd5e117f$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $a59aba9ebd5e117f$export$a143d493d941bafc;
var $a59aba9ebd5e117f$export$e4cf37d7f6fb9e0a;
var $a59aba9ebd5e117f$export$f99ded8fe4b79145;
var $a59aba9ebd5e117f$export$599f31c3813fae4d;
"use strict";

var $gxC2H = parcelRequire("gxC2H");

var $8YfQz = parcelRequire("8YfQz");
const $a59aba9ebd5e117f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$a59aba9ebd5e117f$export$a143d493d941bafc = $a59aba9ebd5e117f$var$Buffer;
$a59aba9ebd5e117f$export$e4cf37d7f6fb9e0a = $a59aba9ebd5e117f$var$SlowBuffer;
$a59aba9ebd5e117f$export$f99ded8fe4b79145 = 50;
const $a59aba9ebd5e117f$var$K_MAX_LENGTH = 0x7fffffff;
$a59aba9ebd5e117f$export$599f31c3813fae4d = $a59aba9ebd5e117f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a59aba9ebd5e117f$var$Buffer.TYPED_ARRAY_SUPPORT = $a59aba9ebd5e117f$var$typedArraySupport();
if (!$a59aba9ebd5e117f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a59aba9ebd5e117f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a59aba9ebd5e117f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$a59aba9ebd5e117f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a59aba9ebd5e117f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$a59aba9ebd5e117f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a59aba9ebd5e117f$var$createBuffer(length) {
    if (length > $a59aba9ebd5e117f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a59aba9ebd5e117f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a59aba9ebd5e117f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a59aba9ebd5e117f$var$allocUnsafe(arg);
    }
    return $a59aba9ebd5e117f$var$from(arg, encodingOrOffset, length);
}
$a59aba9ebd5e117f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a59aba9ebd5e117f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $a59aba9ebd5e117f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a59aba9ebd5e117f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($a59aba9ebd5e117f$var$isInstance(value, ArrayBuffer) || value && $a59aba9ebd5e117f$var$isInstance(value.buffer, ArrayBuffer)) return $a59aba9ebd5e117f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($a59aba9ebd5e117f$var$isInstance(value, SharedArrayBuffer) || value && $a59aba9ebd5e117f$var$isInstance(value.buffer, SharedArrayBuffer))) return $a59aba9ebd5e117f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a59aba9ebd5e117f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $a59aba9ebd5e117f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $a59aba9ebd5e117f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a59aba9ebd5e117f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a59aba9ebd5e117f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a59aba9ebd5e117f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a59aba9ebd5e117f$var$Buffer, Uint8Array);
function $a59aba9ebd5e117f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a59aba9ebd5e117f$var$alloc(size, fill, encoding) {
    $a59aba9ebd5e117f$var$assertSize(size);
    if (size <= 0) return $a59aba9ebd5e117f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $a59aba9ebd5e117f$var$createBuffer(size).fill(fill, encoding) : $a59aba9ebd5e117f$var$createBuffer(size).fill(fill);
    return $a59aba9ebd5e117f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a59aba9ebd5e117f$var$Buffer.alloc = function(size, fill, encoding) {
    return $a59aba9ebd5e117f$var$alloc(size, fill, encoding);
};
function $a59aba9ebd5e117f$var$allocUnsafe(size) {
    $a59aba9ebd5e117f$var$assertSize(size);
    return $a59aba9ebd5e117f$var$createBuffer(size < 0 ? 0 : $a59aba9ebd5e117f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a59aba9ebd5e117f$var$Buffer.allocUnsafe = function(size) {
    return $a59aba9ebd5e117f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a59aba9ebd5e117f$var$Buffer.allocUnsafeSlow = function(size) {
    return $a59aba9ebd5e117f$var$allocUnsafe(size);
};
function $a59aba9ebd5e117f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$a59aba9ebd5e117f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $a59aba9ebd5e117f$var$byteLength(string, encoding) | 0;
    let buf = $a59aba9ebd5e117f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a59aba9ebd5e117f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $a59aba9ebd5e117f$var$checked(array.length) | 0;
    const buf = $a59aba9ebd5e117f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a59aba9ebd5e117f$var$fromArrayView(arrayView) {
    if ($a59aba9ebd5e117f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $a59aba9ebd5e117f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a59aba9ebd5e117f$var$fromArrayLike(arrayView);
}
function $a59aba9ebd5e117f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a59aba9ebd5e117f$var$Buffer.prototype);
    return buf;
}
function $a59aba9ebd5e117f$var$fromObject(obj) {
    if ($a59aba9ebd5e117f$var$Buffer.isBuffer(obj)) {
        const len = $a59aba9ebd5e117f$var$checked(obj.length) | 0;
        const buf = $a59aba9ebd5e117f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $a59aba9ebd5e117f$var$numberIsNaN(obj.length)) return $a59aba9ebd5e117f$var$createBuffer(0);
        return $a59aba9ebd5e117f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $a59aba9ebd5e117f$var$fromArrayLike(obj.data);
}
function $a59aba9ebd5e117f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a59aba9ebd5e117f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a59aba9ebd5e117f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $a59aba9ebd5e117f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a59aba9ebd5e117f$var$Buffer.alloc(+length);
}
$a59aba9ebd5e117f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a59aba9ebd5e117f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a59aba9ebd5e117f$var$Buffer.compare = function compare(a, b) {
    if ($a59aba9ebd5e117f$var$isInstance(a, Uint8Array)) a = $a59aba9ebd5e117f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a59aba9ebd5e117f$var$isInstance(b, Uint8Array)) b = $a59aba9ebd5e117f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a59aba9ebd5e117f$var$Buffer.isBuffer(a) || !$a59aba9ebd5e117f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a59aba9ebd5e117f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$a59aba9ebd5e117f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a59aba9ebd5e117f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $a59aba9ebd5e117f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($a59aba9ebd5e117f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$a59aba9ebd5e117f$var$Buffer.isBuffer(buf)) buf = $a59aba9ebd5e117f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a59aba9ebd5e117f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a59aba9ebd5e117f$var$byteLength(string, encoding) {
    if ($a59aba9ebd5e117f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a59aba9ebd5e117f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $a59aba9ebd5e117f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $a59aba9ebd5e117f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a59aba9ebd5e117f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a59aba9ebd5e117f$var$Buffer.byteLength = $a59aba9ebd5e117f$var$byteLength;
function $a59aba9ebd5e117f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $a59aba9ebd5e117f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $a59aba9ebd5e117f$var$utf8Slice(this, start, end);
        case "ascii":
            return $a59aba9ebd5e117f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $a59aba9ebd5e117f$var$latin1Slice(this, start, end);
        case "base64":
            return $a59aba9ebd5e117f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $a59aba9ebd5e117f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a59aba9ebd5e117f$var$Buffer.prototype._isBuffer = true;
function $a59aba9ebd5e117f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a59aba9ebd5e117f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$a59aba9ebd5e117f$var$swap(this, i, i + 1);
    return this;
};
$a59aba9ebd5e117f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $a59aba9ebd5e117f$var$swap(this, i, i + 3);
        $a59aba9ebd5e117f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a59aba9ebd5e117f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $a59aba9ebd5e117f$var$swap(this, i, i + 7);
        $a59aba9ebd5e117f$var$swap(this, i + 1, i + 6);
        $a59aba9ebd5e117f$var$swap(this, i + 2, i + 5);
        $a59aba9ebd5e117f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a59aba9ebd5e117f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $a59aba9ebd5e117f$var$utf8Slice(this, 0, length);
    return $a59aba9ebd5e117f$var$slowToString.apply(this, arguments);
};
$a59aba9ebd5e117f$var$Buffer.prototype.toLocaleString = $a59aba9ebd5e117f$var$Buffer.prototype.toString;
$a59aba9ebd5e117f$var$Buffer.prototype.equals = function equals(b) {
    if (!$a59aba9ebd5e117f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $a59aba9ebd5e117f$var$Buffer.compare(this, b) === 0;
};
$a59aba9ebd5e117f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $a59aba9ebd5e117f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($a59aba9ebd5e117f$var$customInspectSymbol) $a59aba9ebd5e117f$var$Buffer.prototype[$a59aba9ebd5e117f$var$customInspectSymbol] = $a59aba9ebd5e117f$var$Buffer.prototype.inspect;
$a59aba9ebd5e117f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a59aba9ebd5e117f$var$isInstance(target, Uint8Array)) target = $a59aba9ebd5e117f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a59aba9ebd5e117f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a59aba9ebd5e117f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a59aba9ebd5e117f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $a59aba9ebd5e117f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a59aba9ebd5e117f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a59aba9ebd5e117f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a59aba9ebd5e117f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $a59aba9ebd5e117f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a59aba9ebd5e117f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a59aba9ebd5e117f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a59aba9ebd5e117f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a59aba9ebd5e117f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a59aba9ebd5e117f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a59aba9ebd5e117f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a59aba9ebd5e117f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a59aba9ebd5e117f$var$utf8Write(buf, string, offset, length) {
    return $a59aba9ebd5e117f$var$blitBuffer($a59aba9ebd5e117f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a59aba9ebd5e117f$var$asciiWrite(buf, string, offset, length) {
    return $a59aba9ebd5e117f$var$blitBuffer($a59aba9ebd5e117f$var$asciiToBytes(string), buf, offset, length);
}
function $a59aba9ebd5e117f$var$base64Write(buf, string, offset, length) {
    return $a59aba9ebd5e117f$var$blitBuffer($a59aba9ebd5e117f$var$base64ToBytes(string), buf, offset, length);
}
function $a59aba9ebd5e117f$var$ucs2Write(buf, string, offset, length) {
    return $a59aba9ebd5e117f$var$blitBuffer($a59aba9ebd5e117f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a59aba9ebd5e117f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $a59aba9ebd5e117f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $a59aba9ebd5e117f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $a59aba9ebd5e117f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $a59aba9ebd5e117f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $a59aba9ebd5e117f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a59aba9ebd5e117f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a59aba9ebd5e117f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gxC2H.fromByteArray(buf);
    else return $gxC2H.fromByteArray(buf.slice(start, end));
}
function $a59aba9ebd5e117f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a59aba9ebd5e117f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $a59aba9ebd5e117f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a59aba9ebd5e117f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $a59aba9ebd5e117f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a59aba9ebd5e117f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a59aba9ebd5e117f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a59aba9ebd5e117f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a59aba9ebd5e117f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $a59aba9ebd5e117f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a59aba9ebd5e117f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a59aba9ebd5e117f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a59aba9ebd5e117f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a59aba9ebd5e117f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$a59aba9ebd5e117f$var$Buffer.prototype.readUintLE = $a59aba9ebd5e117f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a59aba9ebd5e117f$var$Buffer.prototype.readUintBE = $a59aba9ebd5e117f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a59aba9ebd5e117f$var$Buffer.prototype.readUint8 = $a59aba9ebd5e117f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a59aba9ebd5e117f$var$Buffer.prototype.readUint16LE = $a59aba9ebd5e117f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a59aba9ebd5e117f$var$Buffer.prototype.readUint16BE = $a59aba9ebd5e117f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a59aba9ebd5e117f$var$Buffer.prototype.readUint32LE = $a59aba9ebd5e117f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a59aba9ebd5e117f$var$Buffer.prototype.readUint32BE = $a59aba9ebd5e117f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a59aba9ebd5e117f$var$Buffer.prototype.readBigUInt64LE = $a59aba9ebd5e117f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $a59aba9ebd5e117f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a59aba9ebd5e117f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$a59aba9ebd5e117f$var$Buffer.prototype.readBigUInt64BE = $a59aba9ebd5e117f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $a59aba9ebd5e117f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a59aba9ebd5e117f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$a59aba9ebd5e117f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a59aba9ebd5e117f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a59aba9ebd5e117f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a59aba9ebd5e117f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a59aba9ebd5e117f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a59aba9ebd5e117f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a59aba9ebd5e117f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a59aba9ebd5e117f$var$Buffer.prototype.readBigInt64LE = $a59aba9ebd5e117f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $a59aba9ebd5e117f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a59aba9ebd5e117f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$a59aba9ebd5e117f$var$Buffer.prototype.readBigInt64BE = $a59aba9ebd5e117f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $a59aba9ebd5e117f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a59aba9ebd5e117f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$a59aba9ebd5e117f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, true, 23, 4);
};
$a59aba9ebd5e117f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, false, 23, 4);
};
$a59aba9ebd5e117f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, true, 52, 8);
};
$a59aba9ebd5e117f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, false, 52, 8);
};
function $a59aba9ebd5e117f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a59aba9ebd5e117f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$a59aba9ebd5e117f$var$Buffer.prototype.writeUintLE = $a59aba9ebd5e117f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a59aba9ebd5e117f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeUintBE = $a59aba9ebd5e117f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a59aba9ebd5e117f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeUint8 = $a59aba9ebd5e117f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeUint16LE = $a59aba9ebd5e117f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeUint16BE = $a59aba9ebd5e117f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeUint32LE = $a59aba9ebd5e117f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeUint32BE = $a59aba9ebd5e117f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a59aba9ebd5e117f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $a59aba9ebd5e117f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $a59aba9ebd5e117f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $a59aba9ebd5e117f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$a59aba9ebd5e117f$var$Buffer.prototype.writeBigUInt64LE = $a59aba9ebd5e117f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $a59aba9ebd5e117f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$a59aba9ebd5e117f$var$Buffer.prototype.writeBigUInt64BE = $a59aba9ebd5e117f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $a59aba9ebd5e117f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$a59aba9ebd5e117f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a59aba9ebd5e117f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a59aba9ebd5e117f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeBigInt64LE = $a59aba9ebd5e117f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $a59aba9ebd5e117f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$a59aba9ebd5e117f$var$Buffer.prototype.writeBigInt64BE = $a59aba9ebd5e117f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $a59aba9ebd5e117f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $a59aba9ebd5e117f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $a59aba9ebd5e117f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a59aba9ebd5e117f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a59aba9ebd5e117f$var$writeFloat(this, value, offset, true, noAssert);
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a59aba9ebd5e117f$var$writeFloat(this, value, offset, false, noAssert);
};
function $a59aba9ebd5e117f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a59aba9ebd5e117f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a59aba9ebd5e117f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a59aba9ebd5e117f$var$writeDouble(this, value, offset, true, noAssert);
};
$a59aba9ebd5e117f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a59aba9ebd5e117f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a59aba9ebd5e117f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a59aba9ebd5e117f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a59aba9ebd5e117f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$a59aba9ebd5e117f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $a59aba9ebd5e117f$var$Buffer.isBuffer(val) ? val : $a59aba9ebd5e117f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $a59aba9ebd5e117f$var$errors = {};
function $a59aba9ebd5e117f$var$E(sym, getMessage, Base) {
    $a59aba9ebd5e117f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$a59aba9ebd5e117f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$a59aba9ebd5e117f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$a59aba9ebd5e117f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $a59aba9ebd5e117f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $a59aba9ebd5e117f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $a59aba9ebd5e117f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $a59aba9ebd5e117f$var$checkBounds(buf, offset, byteLength) {
    $a59aba9ebd5e117f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $a59aba9ebd5e117f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $a59aba9ebd5e117f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $a59aba9ebd5e117f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $a59aba9ebd5e117f$var$checkBounds(buf, offset, byteLength);
}
function $a59aba9ebd5e117f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $a59aba9ebd5e117f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $a59aba9ebd5e117f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $a59aba9ebd5e117f$var$validateNumber(value, type);
        throw new $a59aba9ebd5e117f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $a59aba9ebd5e117f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $a59aba9ebd5e117f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $a59aba9ebd5e117f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a59aba9ebd5e117f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a59aba9ebd5e117f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $a59aba9ebd5e117f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $a59aba9ebd5e117f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a59aba9ebd5e117f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a59aba9ebd5e117f$var$base64ToBytes(str) {
    return $gxC2H.toByteArray($a59aba9ebd5e117f$var$base64clean(str));
}
function $a59aba9ebd5e117f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a59aba9ebd5e117f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a59aba9ebd5e117f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $a59aba9ebd5e117f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $a59aba9ebd5e117f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $a59aba9ebd5e117f$var$BufferBigIntNotDefined : fn;
}
function $a59aba9ebd5e117f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});


parcelRegister("dZYIo", function(module, exports) {

var $jtAZT = parcelRequire("jtAZT");
var $a3101195c7029864$require$Buffer = $jtAZT.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
let $a3101195c7029864$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $a3101195c7029864$var$toBigIntLE(buf) {
    {
        const reversed = $a3101195c7029864$require$Buffer.from(buf);
        reversed.reverse();
        const hex = reversed.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $a3101195c7029864$var$converter.toBigInt(buf, false);
}
module.exports.toBigIntLE = $a3101195c7029864$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $a3101195c7029864$var$toBigIntBE(buf) {
    {
        const hex = buf.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $a3101195c7029864$var$converter.toBigInt(buf, true);
}
module.exports.toBigIntBE = $a3101195c7029864$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $a3101195c7029864$var$toBufferLE(num, width) {
    {
        const hex = num.toString(16);
        const buffer = $a3101195c7029864$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $a3101195c7029864$var$converter.fromBigInt(num, $a3101195c7029864$require$Buffer.allocUnsafe(width), false);
}
module.exports.toBufferLE = $a3101195c7029864$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $a3101195c7029864$var$toBufferBE(num, width) {
    {
        const hex = num.toString(16);
        return $a3101195c7029864$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
    }
    return $a3101195c7029864$var$converter.fromBigInt(num, $a3101195c7029864$require$Buffer.allocUnsafe(width), true);
}
module.exports.toBufferBE = $a3101195c7029864$var$toBufferBE;

});

parcelRegister("78ONe", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $3f1371efea3648aa$export$a7a9523472993e97; });
$parcel$export(module.exports, "create", function () { return $3f1371efea3648aa$export$185802fd694ee1f5; });
$parcel$export(module.exports, "type", function () { return $3f1371efea3648aa$export$bf9fb029d174d554; });
$parcel$export(module.exports, "optional", function () { return $3f1371efea3648aa$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "any", function () { return $3f1371efea3648aa$export$4154a199d7d90455; });
$parcel$export(module.exports, "array", function () { return $3f1371efea3648aa$export$2f23118c22fb2630; });
$parcel$export(module.exports, "boolean", function () { return $3f1371efea3648aa$export$4a21f16c33752377; });
$parcel$export(module.exports, "instance", function () { return $3f1371efea3648aa$export$9544d5bb712b01ea; });
$parcel$export(module.exports, "literal", function () { return $3f1371efea3648aa$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "nullable", function () { return $3f1371efea3648aa$export$133fc36489ac9add; });
$parcel$export(module.exports, "number", function () { return $3f1371efea3648aa$export$98e628dec113755e; });
$parcel$export(module.exports, "record", function () { return $3f1371efea3648aa$export$e5185e241753e543; });
$parcel$export(module.exports, "string", function () { return $3f1371efea3648aa$export$22b082955e083ec3; });
$parcel$export(module.exports, "tuple", function () { return $3f1371efea3648aa$export$65e3907585753458; });
$parcel$export(module.exports, "union", function () { return $3f1371efea3648aa$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "unknown", function () { return $3f1371efea3648aa$export$19282c40b967aec6; });
$parcel$export(module.exports, "coerce", function () { return $3f1371efea3648aa$export$8c14e57e778d3873; });
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $3f1371efea3648aa$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, explanation: explanation, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : `At path: ${path.join(".")} -- ${message}`;
        super(explanation ?? msg);
        if (explanation != null) this.cause = msg;
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            return cached ?? (cached = [
                failure,
                ...failures()
            ]);
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $3f1371efea3648aa$var$isIterable(x) {
    return $3f1371efea3648aa$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $3f1371efea3648aa$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a non-array object.
 */ function $3f1371efea3648aa$var$isNonArrayObject(x) {
    return $3f1371efea3648aa$var$isObject(x) && !Array.isArray(x);
}
/**
 * Check if a value is a plain object.
 */ function $3f1371efea3648aa$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $3f1371efea3648aa$var$print(value) {
    if (typeof value === "symbol") return value.toString();
    return typeof value === "string" ? JSON.stringify(value) : `${value}`;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $3f1371efea3648aa$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $3f1371efea3648aa$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = `Expected a value of type \`${type}\`${refinement ? ` with refinement \`${refinement}\`` : ""}, but received: \`${$3f1371efea3648aa$var$print(value)}\`` } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $3f1371efea3648aa$var$toFailures(result, context, struct, value) {
    if (!$3f1371efea3648aa$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $3f1371efea3648aa$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $3f1371efea3648aa$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch,
        mask: mask
    };
    if (coerce) value = struct.coercer(value, ctx);
    let status = "valid";
    for (const failure of struct.validator(value, ctx)){
        failure.explanation = options.message;
        status = "not_valid";
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $3f1371efea3648aa$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask,
            message: options.message
        });
        for (const t of ts){
            if (t[0]) {
                status = t[0].refinement != null ? "not_refined" : "not_valid";
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($3f1371efea3648aa$var$isObject(value)) {
                    if (v !== undefined || k in value) value[k] = v;
                }
            }
        }
    }
    if (status !== "not_valid") for (const failure of struct.refiner(value, ctx)){
        failure.explanation = options.message;
        status = "not_refined";
        yield [
            failure,
            undefined
        ];
    }
    if (status === "valid") yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $3f1371efea3648aa$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $3f1371efea3648aa$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $3f1371efea3648aa$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ assert(value, message) {
        return $3f1371efea3648aa$export$a7a9523472993e97(value, this, message);
    }
    /**
     * Create a value with the struct's coercion logic, then validate it.
     */ create(value, message) {
        return $3f1371efea3648aa$export$185802fd694ee1f5(value, this, message);
    }
    /**
     * Check if a value passes the struct's validation.
     */ is(value) {
        return $3f1371efea3648aa$export$226b3eccf92c9ed9(value, this);
    }
    /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema. Masking applies recursively to
     * props of `object` structs only.
     */ mask(value, message) {
        return $3f1371efea3648aa$export$d99f0801a68bbcf1(value, this, message);
    }
    /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `coerce` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful. Also, `mask` will turn on
     * masking of the unknown `object` props recursively if passed.
     */ validate(value, options = {}) {
        return $3f1371efea3648aa$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $3f1371efea3648aa$export$a7a9523472993e97(value, struct, message) {
    const result = $3f1371efea3648aa$export$a22775fa5e2eebd9(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $3f1371efea3648aa$export$185802fd694ee1f5(value, struct, message) {
    const result = $3f1371efea3648aa$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $3f1371efea3648aa$export$d99f0801a68bbcf1(value, struct, message) {
    const result = $3f1371efea3648aa$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $3f1371efea3648aa$export$226b3eccf92c9ed9(value, struct) {
    const result = $3f1371efea3648aa$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $3f1371efea3648aa$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $3f1371efea3648aa$var$run(value, struct, options);
    const tuple = $3f1371efea3648aa$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $3f1371efea3648aa$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $3f1371efea3648aa$export$e6e34fd1f2686227(...Structs) {
    const isType = Structs[0].type === "type";
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return isType ? $3f1371efea3648aa$export$bf9fb029d174d554(schema) : $3f1371efea3648aa$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $3f1371efea3648aa$export$f36d6a7a5c09a23e(name, validator) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $3f1371efea3648aa$export$cdd73fc4100a6ef4(struct, log) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $3f1371efea3648aa$export$7077912c31975674(fn) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            const struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $3f1371efea3648aa$export$488013bae63b21da(fn) {
    let struct;
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            struct ?? (struct = fn());
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            struct ?? (struct = fn());
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            struct ?? (struct = fn());
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            struct ?? (struct = fn());
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $3f1371efea3648aa$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    switch(struct.type){
        case "type":
            return $3f1371efea3648aa$export$bf9fb029d174d554(subschema);
        default:
            return $3f1371efea3648aa$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $3f1371efea3648aa$export$e45945969df8035a(struct) {
    const isStruct = struct instanceof $3f1371efea3648aa$export$eabc71f011df675a;
    const schema = isStruct ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $3f1371efea3648aa$export$516e28dec6a4b6d4(schema[key]);
    if (isStruct && struct.type === "type") return $3f1371efea3648aa$export$bf9fb029d174d554(schema);
    return $3f1371efea3648aa$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $3f1371efea3648aa$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    switch(struct.type){
        case "type":
            return $3f1371efea3648aa$export$bf9fb029d174d554(subschema);
        default:
            return $3f1371efea3648aa$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $3f1371efea3648aa$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $3f1371efea3648aa$export$4154a199d7d90455() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $3f1371efea3648aa$export$2f23118c22fb2630(Element) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array value, but received: ${$3f1371efea3648aa$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function $3f1371efea3648aa$export$a0f65b52274bcc00() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("bigint", (value)=>{
        return typeof value === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $3f1371efea3648aa$export$4a21f16c33752377() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $3f1371efea3648aa$export$324d90190a8b822a() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || `Expected a valid \`Date\` object, but received: ${$3f1371efea3648aa$var$print(value)}`;
    });
}
function $3f1371efea3648aa$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$3f1371efea3648aa$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || `Expected one of \`${description}\`, but received: ${$3f1371efea3648aa$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $3f1371efea3648aa$export$86951950244e2001() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || `Expected a function, but received: ${$3f1371efea3648aa$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $3f1371efea3648aa$export$9544d5bb712b01ea(Class) {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || `Expected a \`${Class.name}\` instance, but received: ${$3f1371efea3648aa$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an integer.
 */ function $3f1371efea3648aa$export$32744b5b3bba4764() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || `Expected an integer, but received: ${$3f1371efea3648aa$var$print(value)}`;
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function $3f1371efea3648aa$export$bc86dfbf7795668c(Structs) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $3f1371efea3648aa$export$c8ec6e1ec9fefcb0(constant) {
    const description = $3f1371efea3648aa$var$print(constant);
    const t = typeof constant;
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || `Expected the literal \`${description}\`, but received: ${$3f1371efea3648aa$var$print(value)}`;
        }
    });
}
function $3f1371efea3648aa$export$871de8747c9eaa88(Key, Value) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || `Expected a \`Map\` object, but received: ${$3f1371efea3648aa$var$print(value)}`;
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $3f1371efea3648aa$export$b3e22bcfd64c1022() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $3f1371efea3648aa$export$133fc36489ac9add(struct) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $3f1371efea3648aa$export$98e628dec113755e() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || `Expected a number, but received: ${$3f1371efea3648aa$var$print(value)}`;
    });
}
function $3f1371efea3648aa$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $3f1371efea3648aa$export$b3e22bcfd64c1022();
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $3f1371efea3648aa$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $3f1371efea3648aa$var$isNonArrayObject(value) || `Expected an object, but received: ${$3f1371efea3648aa$var$print(value)}`;
        },
        coercer (value, ctx) {
            if (!$3f1371efea3648aa$var$isNonArrayObject(value)) return value;
            const coerced = {
                ...value
            };
            // The `object` struct has special behaviour enabled by the mask flag.
            // When masking, properties that are not in the schema are deleted from
            // the coerced object instead of eventually failing validaiton.
            if (ctx.mask && schema) {
                for(const key in coerced)if (schema[key] === undefined) delete coerced[key];
            }
            return coerced;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $3f1371efea3648aa$export$516e28dec6a4b6d4(struct) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $3f1371efea3648aa$export$e5185e241753e543(Key, Value) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($3f1371efea3648aa$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $3f1371efea3648aa$var$isNonArrayObject(value) || `Expected an object, but received: ${$3f1371efea3648aa$var$print(value)}`;
        },
        coercer (value) {
            return $3f1371efea3648aa$var$isNonArrayObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $3f1371efea3648aa$export$efdc1e5bdb609bb() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $3f1371efea3648aa$export$adaa4cf7ef1b65be(Element) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || `Expected a \`Set\` object, but received: ${$3f1371efea3648aa$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $3f1371efea3648aa$export$22b082955e083ec3() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || `Expected a string, but received: ${$3f1371efea3648aa$var$print(value)}`;
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function $3f1371efea3648aa$export$65e3907585753458(Structs) {
    const Never = $3f1371efea3648aa$export$b3e22bcfd64c1022();
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Structs.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Structs[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array, but received: ${$3f1371efea3648aa$var$print(value)}`;
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $3f1371efea3648aa$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($3f1371efea3648aa$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $3f1371efea3648aa$var$isNonArrayObject(value) || `Expected an object, but received: ${$3f1371efea3648aa$var$print(value)}`;
        },
        coercer (value) {
            return $3f1371efea3648aa$var$isNonArrayObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function $3f1371efea3648aa$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        type: "union",
        schema: null,
        coercer (value, ctx) {
            for (const S of Structs){
                const [error, coerced] = S.validate(value, {
                    coerce: true,
                    mask: ctx.mask
                });
                if (!error) return coerced;
            }
            return value;
        },
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $3f1371efea3648aa$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                `Expected the value to satisfy a union of \`${description}\`, but received: ${$3f1371efea3648aa$var$print(value)}`,
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $3f1371efea3648aa$export$19282c40b967aec6() {
    return $3f1371efea3648aa$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $3f1371efea3648aa$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $3f1371efea3648aa$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $3f1371efea3648aa$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $3f1371efea3648aa$export$8c14e57e778d3873(struct, $3f1371efea3648aa$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $3f1371efea3648aa$var$isPlainObject(x) && $3f1371efea3648aa$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $3f1371efea3648aa$export$41f369984ed28930(struct) {
    return $3f1371efea3648aa$export$8c14e57e778d3873(struct, $3f1371efea3648aa$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $3f1371efea3648aa$export$6e22c362a0406a2c(struct) {
    return $3f1371efea3648aa$export$edc9d475108b3212(struct, "empty", (value)=>{
        const size = $3f1371efea3648aa$var$getSize(value);
        return size === 0 || `Expected an empty ${struct.type} but received one with a size of \`${size}\``;
    });
}
function $3f1371efea3648aa$var$getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $3f1371efea3648aa$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $3f1371efea3648aa$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || `Expected a ${struct.type} less than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $3f1371efea3648aa$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $3f1371efea3648aa$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || `Expected a ${struct.type} greater than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function $3f1371efea3648aa$export$6ce6c9218151d511(struct) {
    return $3f1371efea3648aa$export$edc9d475108b3212(struct, "nonempty", (value)=>{
        const size = $3f1371efea3648aa$var$getSize(value);
        return size > 0 || `Expected a nonempty ${struct.type} but received an empty one`;
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $3f1371efea3648aa$export$24f82734ea047e6f(struct, regexp) {
    return $3f1371efea3648aa$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || `Expected a ${struct.type} matching \`/${regexp.source}/\` but received "${value}"`;
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $3f1371efea3648aa$export$346677f925de839c(struct, min, max = min) {
    const expected = `Expected a ${struct.type}`;
    const of = min === max ? `of \`${min}\`` : `between \`${min}\` and \`${max}\``;
    return $3f1371efea3648aa$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || `${expected} ${of} but received \`${value}\``;
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || `${expected} with a size ${of} but received one with a size of \`${size}\``;
        } else {
            const { length: length } = value;
            return min <= length && length <= max || `${expected} with a length ${of} but received one with a length of \`${length}\``;
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $3f1371efea3648aa$export$edc9d475108b3212(struct, name, refiner) {
    return new $3f1371efea3648aa$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $3f1371efea3648aa$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}

});

parcelRegister("5iF24", function(module, exports) {
"use strict";

var $98G0o = parcelRequire("98G0o");
var $3dbe765c0aadef06$require$uuid = $98G0o.default;

var $kjKxv = parcelRequire("kjKxv");
/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ const $3dbe765c0aadef06$var$ClientBrowser = function(callServer, options) {
    if (!(this instanceof $3dbe765c0aadef06$var$ClientBrowser)) return new $3dbe765c0aadef06$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== "undefined" ? options.reviver : null,
        replacer: typeof options.replacer !== "undefined" ? options.replacer : null,
        generator: typeof options.generator !== "undefined" ? options.generator : function() {
            return $3dbe765c0aadef06$require$uuid();
        },
        version: typeof options.version !== "undefined" ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === "boolean" ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
module.exports = $3dbe765c0aadef06$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $3dbe765c0aadef06$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    const self = this;
    let request = null;
    // is this a batch request?
    const isBatch = Array.isArray(method) && typeof params === "function";
    if (this.options.version === 1 && isBatch) throw new TypeError("JSON-RPC 1.0 does not support batching");
    // is this a raw request?
    const isRaw = !isBatch && method && typeof method === "object" && typeof params === "function";
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === "function") {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        const hasCallback = typeof callback === "function";
        try {
            request = $kjKxv(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    let message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $3dbe765c0aadef06$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    let response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            const isError = function(res) {
                return typeof res.error !== "undefined";
            };
            const isNotError = function(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};

});
parcelRegister("98G0o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a7571ca5df03169$export$2e2bcd8739ae039; });

var $jT8nb = parcelRequire("jT8nb");

var $gpKZd = parcelRequire("gpKZd");
function $6a7571ca5df03169$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $jT8nb.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $gpKZd.default)(rnds);
}
var $6a7571ca5df03169$export$2e2bcd8739ae039 = $6a7571ca5df03169$var$v4;

});
parcelRegister("jT8nb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7a9a60e4ea5ecd4$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $e7a9a60e4ea5ecd4$var$getRandomValues;
var $e7a9a60e4ea5ecd4$var$rnds8 = new Uint8Array(16);
function $e7a9a60e4ea5ecd4$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$e7a9a60e4ea5ecd4$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $e7a9a60e4ea5ecd4$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$e7a9a60e4ea5ecd4$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $e7a9a60e4ea5ecd4$var$getRandomValues($e7a9a60e4ea5ecd4$var$rnds8);
}

});

parcelRegister("gpKZd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf336da3ae0dfc30$export$2e2bcd8739ae039; });

var $03inA = parcelRequire("03inA");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $bf336da3ae0dfc30$var$byteToHex = [];
for(var $bf336da3ae0dfc30$var$i = 0; $bf336da3ae0dfc30$var$i < 256; ++$bf336da3ae0dfc30$var$i)$bf336da3ae0dfc30$var$byteToHex.push(($bf336da3ae0dfc30$var$i + 0x100).toString(16).substr(1));
function $bf336da3ae0dfc30$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($bf336da3ae0dfc30$var$byteToHex[arr[offset + 0]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 1]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 2]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 3]] + "-" + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 4]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 5]] + "-" + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 6]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 7]] + "-" + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 8]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 9]] + "-" + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 10]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 11]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 12]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 13]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 14]] + $bf336da3ae0dfc30$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $03inA.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $bf336da3ae0dfc30$export$2e2bcd8739ae039 = $bf336da3ae0dfc30$var$stringify;

});
parcelRegister("03inA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $009e89b04b253aca$export$2e2bcd8739ae039; });

var $5zuKs = parcelRequire("5zuKs");
function $009e89b04b253aca$var$validate(uuid) {
    return typeof uuid === "string" && (0, $5zuKs.default).test(uuid);
}
var $009e89b04b253aca$export$2e2bcd8739ae039 = $009e89b04b253aca$var$validate;

});
parcelRegister("5zuKs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40e8129f180aa153$export$2e2bcd8739ae039; });
var $40e8129f180aa153$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("kjKxv", function(module, exports) {
"use strict";

var $98G0o = parcelRequire("98G0o");
var $eca9aec4aceb3290$require$uuid = $98G0o.default;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ const $eca9aec4aceb3290$var$generateRequest = function(method, params, id, options) {
    if (typeof method !== "string") throw new TypeError(method + " must be a string");
    options = options || {};
    // check valid version provided
    const version = typeof options.version === "number" ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + " must be 1 or 2");
    const request = {
        method: method
    };
    if (version === 2) request.jsonrpc = "2.0";
    if (params) {
        // params given, but invalid?
        if (typeof params !== "object" && !Array.isArray(params)) throw new TypeError(params + " must be an object, array or omitted");
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === "undefined") {
        const generator = typeof options.generator === "function" ? options.generator : function() {
            return $eca9aec4aceb3290$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
module.exports = $eca9aec4aceb3290$var$generateRequest;

});


parcelRegister("e4v9r", function(module, exports) {

$parcel$export(module.exports, "WebSocket", function () { return $22ba34910cc15d64$export$3909fb301d3dc8c9; });
$parcel$export(module.exports, "CommonClient", function () { return $22ba34910cc15d64$export$b43a6d9568fa5272; });

var $doK0q = parcelRequire("doK0q");
parcelRequire("eLDY1");
var $goI5y = parcelRequire("goI5y");
// node_modules/esbuild-plugin-polyfill-node/polyfills/buffer.js
var $22ba34910cc15d64$var$WebSocketBrowserImpl = class extends (0, (/*@__PURE__*/$parcel$interopDefault($goI5y))) {
    socket;
    /** Instantiate a WebSocket class
  * @constructor
  * @param {String} address - url to a websocket server
  * @param {(Object)} options - websocket options
  * @param {(String|Array)} protocols - a list of protocols
  * @return {WebSocketBrowserImpl} - returns a WebSocket instance
  */ constructor(address, options, protocols){
        super();
        this.socket = new window.WebSocket(address, protocols);
        this.socket.onopen = ()=>this.emit("open");
        this.socket.onmessage = (event)=>this.emit("message", event.data);
        this.socket.onerror = (error)=>this.emit("error", error);
        this.socket.onclose = (event)=>{
            this.emit("close", event.code, event.reason);
        };
    }
    /**
  * Sends data through a websocket connection
  * @method
  * @param {(String|Object)} data - data to be sent via websocket
  * @param {Object} optionsOrCallback - ws options
  * @param {Function} callback - a callback called once the data is sent
  * @return {Undefined}
  */ send(data, optionsOrCallback, callback) {
        const cb = callback || optionsOrCallback;
        try {
            this.socket.send(data);
            cb();
        } catch (error) {
            cb(error);
        }
    }
    /**
  * Closes an underlying socket
  * @method
  * @param {Number} code - status code explaining why the connection is being closed
  * @param {String} reason - a description why the connection is closing
  * @return {Undefined}
  * @throws {Error}
  */ close(code, reason) {
        this.socket.close(code, reason);
    }
    addEventListener(type, listener, options) {
        this.socket.addEventListener(type, listener, options);
    }
};
function $22ba34910cc15d64$export$3909fb301d3dc8c9(address, options) {
    return new $22ba34910cc15d64$var$WebSocketBrowserImpl(address, options);
}
// src/lib/utils.ts
var $22ba34910cc15d64$export$9fd32f4b4353d82d = class {
    encode(value) {
        return JSON.stringify(value);
    }
    decode(value) {
        return JSON.parse(value);
    }
};
// src/lib/client.ts
var $22ba34910cc15d64$export$b43a6d9568fa5272 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($goI5y))) {
    address;
    rpc_id;
    queue;
    options;
    autoconnect;
    ready;
    reconnect;
    reconnect_timer_id;
    reconnect_interval;
    max_reconnects;
    rest_options;
    current_reconnects;
    generate_request_id;
    socket;
    webSocketFactory;
    dataPack;
    /**
  * Instantiate a Client class.
  * @constructor
  * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
  * @param {String} address - url to a websocket server
  * @param {Object} options - ws options object with reconnect parameters
  * @param {Function} generate_request_id - custom generation request Id
  * @param {DataPack} dataPack - data pack contains encoder and decoder
  * @return {CommonClient}
  */ constructor(webSocketFactory, address = "ws://localhost:8080", { autoconnect: autoconnect = true, reconnect: reconnect = true, reconnect_interval: reconnect_interval = 1e3, max_reconnects: max_reconnects = 5, ...rest_options } = {}, generate_request_id, dataPack){
        super();
        this.webSocketFactory = webSocketFactory;
        this.queue = {};
        this.rpc_id = 0;
        this.address = address;
        this.autoconnect = autoconnect;
        this.ready = false;
        this.reconnect = reconnect;
        this.reconnect_timer_id = void 0;
        this.reconnect_interval = reconnect_interval;
        this.max_reconnects = max_reconnects;
        this.rest_options = rest_options;
        this.current_reconnects = 0;
        this.generate_request_id = generate_request_id || (()=>++this.rpc_id);
        if (!dataPack) this.dataPack = new $22ba34910cc15d64$export$9fd32f4b4353d82d();
        else this.dataPack = dataPack;
        if (this.autoconnect) this._connect(this.address, {
            autoconnect: this.autoconnect,
            reconnect: this.reconnect,
            reconnect_interval: this.reconnect_interval,
            max_reconnects: this.max_reconnects,
            ...this.rest_options
        });
    }
    /**
  * Connects to a defined server if not connected already.
  * @method
  * @return {Undefined}
  */ connect() {
        if (this.socket) return;
        this._connect(this.address, {
            autoconnect: this.autoconnect,
            reconnect: this.reconnect,
            reconnect_interval: this.reconnect_interval,
            max_reconnects: this.max_reconnects,
            ...this.rest_options
        });
    }
    /**
  * Calls a registered RPC method on server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object|Array} params - optional method parameters
  * @param {Number} timeout - RPC reply timeout value
  * @param {Object} ws_opts - options passed to ws
  * @return {Promise}
  */ call(method, params, timeout, ws_opts) {
        if (!ws_opts && "object" === typeof timeout) {
            ws_opts = timeout;
            timeout = null;
        }
        return new Promise((resolve, reject)=>{
            if (!this.ready) return reject(new Error("socket not ready"));
            const rpc_id = this.generate_request_id(method, params);
            const message = {
                jsonrpc: "2.0",
                method: method,
                params: params || void 0,
                id: rpc_id
            };
            this.socket.send(this.dataPack.encode(message), ws_opts, (error)=>{
                if (error) return reject(error);
                this.queue[rpc_id] = {
                    promise: [
                        resolve,
                        reject
                    ]
                };
                if (timeout) this.queue[rpc_id].timeout = setTimeout(()=>{
                    delete this.queue[rpc_id];
                    reject(new Error("reply timeout"));
                }, timeout);
            });
        });
    }
    /**
  * Logins with the other side of the connection.
  * @method
  * @param {Object} params - Login credentials object
  * @return {Promise}
  */ async login(params) {
        const resp = await this.call("rpc.login", params);
        if (!resp) throw new Error("authentication failed");
        return resp;
    }
    /**
  * Fetches a list of client's methods registered on server.
  * @method
  * @return {Array}
  */ async listMethods() {
        return await this.call("__listMethods");
    }
    /**
  * Sends a JSON-RPC 2.0 notification to server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object} params - optional method parameters
  * @return {Promise}
  */ notify(method, params) {
        return new Promise((resolve, reject)=>{
            if (!this.ready) return reject(new Error("socket not ready"));
            const message = {
                jsonrpc: "2.0",
                method: method,
                params: params
            };
            this.socket.send(this.dataPack.encode(message), (error)=>{
                if (error) return reject(error);
                resolve();
            });
        });
    }
    /**
  * Subscribes for a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ async subscribe(event) {
        if (typeof event === "string") event = [
            event
        ];
        const result = await this.call("rpc.on", event);
        if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
        return result;
    }
    /**
  * Unsubscribes from a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ async unsubscribe(event) {
        if (typeof event === "string") event = [
            event
        ];
        const result = await this.call("rpc.off", event);
        if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed unsubscribing from an event with: " + result);
        return result;
    }
    /**
  * Closes a WebSocket connection gracefully.
  * @method
  * @param {Number} code - socket close code
  * @param {String} data - optional data to be sent before closing
  * @return {Undefined}
  */ close(code, data) {
        this.socket.close(code || 1e3, data);
    }
    /**
  * Enable / disable automatic reconnection.
  * @method
  * @param {Boolean} reconnect - enable / disable reconnection
  * @return {Undefined}
  */ setAutoReconnect(reconnect) {
        this.reconnect = reconnect;
    }
    /**
  * Set the interval between reconnection attempts.
  * @method
  * @param {Number} interval - reconnection interval in milliseconds
  * @return {Undefined}
  */ setReconnectInterval(interval) {
        this.reconnect_interval = interval;
    }
    /**
  * Set the maximum number of reconnection attempts.
  * @method
  * @param {Number} max_reconnects - maximum reconnection attempts
  * @return {Undefined}
  */ setMaxReconnects(max_reconnects) {
        this.max_reconnects = max_reconnects;
    }
    /**
  * Connection/Message handler.
  * @method
  * @private
  * @param {String} address - WebSocket API address
  * @param {Object} options - ws options object
  * @return {Undefined}
  */ _connect(address, options) {
        clearTimeout(this.reconnect_timer_id);
        this.socket = this.webSocketFactory(address, options);
        this.socket.addEventListener("open", ()=>{
            this.ready = true;
            this.emit("open");
            this.current_reconnects = 0;
        });
        this.socket.addEventListener("message", ({ data: message })=>{
            if (message instanceof ArrayBuffer) message = (0, $doK0q.Buffer).from(message).toString();
            try {
                message = this.dataPack.decode(message);
            } catch (error) {
                return;
            }
            if (message.notification && this.listeners(message.notification).length) {
                if (!Object.keys(message.params).length) return this.emit(message.notification);
                const args = [
                    message.notification
                ];
                if (message.params.constructor === Object) args.push(message.params);
                else for(let i = 0; i < message.params.length; i++)args.push(message.params[i]);
                return Promise.resolve().then(()=>{
                    this.emit.apply(this, args);
                });
            }
            if (!this.queue[message.id]) {
                if (message.method) return Promise.resolve().then(()=>{
                    this.emit(message.method, message?.params);
                });
                return;
            }
            if ("error" in message === "result" in message) this.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
            if (this.queue[message.id].timeout) clearTimeout(this.queue[message.id].timeout);
            if (message.error) this.queue[message.id].promise[1](message.error);
            else this.queue[message.id].promise[0](message.result);
            delete this.queue[message.id];
        });
        this.socket.addEventListener("error", (error)=>this.emit("error", error));
        this.socket.addEventListener("close", ({ code: code, reason: reason })=>{
            if (this.ready) setTimeout(()=>this.emit("close", code, reason), 0);
            this.ready = false;
            this.socket = void 0;
            if (code === 1e3) return;
            this.current_reconnects++;
            if (this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0)) this.reconnect_timer_id = setTimeout(()=>this._connect(address, options), this.reconnect_interval);
        });
    }
};
// src/index.browser.ts
var $22ba34910cc15d64$export$1f2bb630327ac4b6 = class extends $22ba34910cc15d64$export$b43a6d9568fa5272 {
    constructor(address = "ws://localhost:8080", { autoconnect: autoconnect = true, reconnect: reconnect = true, reconnect_interval: reconnect_interval = 1e3, max_reconnects: max_reconnects = 5 } = {}, generate_request_id){
        super($22ba34910cc15d64$export$3909fb301d3dc8c9, address, {
            autoconnect: autoconnect,
            reconnect: reconnect,
            reconnect_interval: reconnect_interval,
            max_reconnects: max_reconnects
        }, generate_request_id);
    }
};
 //# sourceMappingURL=out.js.map

});
parcelRegister("doK0q", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $9c11340b6b4fd8cc$export$a143d493d941bafc; }, function (v) { return $9c11340b6b4fd8cc$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $9c11340b6b4fd8cc$export$f99ded8fe4b79145; }, function (v) { return $9c11340b6b4fd8cc$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $9c11340b6b4fd8cc$export$a143d493d941bafc;
var $9c11340b6b4fd8cc$export$e4cf37d7f6fb9e0a;
var $9c11340b6b4fd8cc$export$f99ded8fe4b79145;
var $9c11340b6b4fd8cc$export$599f31c3813fae4d;
"use strict";

var $gxC2H = parcelRequire("gxC2H");

var $8YfQz = parcelRequire("8YfQz");
const $9c11340b6b4fd8cc$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$9c11340b6b4fd8cc$export$a143d493d941bafc = $9c11340b6b4fd8cc$var$Buffer;
$9c11340b6b4fd8cc$export$e4cf37d7f6fb9e0a = $9c11340b6b4fd8cc$var$SlowBuffer;
$9c11340b6b4fd8cc$export$f99ded8fe4b79145 = 50;
const $9c11340b6b4fd8cc$var$K_MAX_LENGTH = 0x7fffffff;
$9c11340b6b4fd8cc$export$599f31c3813fae4d = $9c11340b6b4fd8cc$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $9c11340b6b4fd8cc$var$Buffer.TYPED_ARRAY_SUPPORT = $9c11340b6b4fd8cc$var$typedArraySupport();
if (!$9c11340b6b4fd8cc$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $9c11340b6b4fd8cc$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($9c11340b6b4fd8cc$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$9c11340b6b4fd8cc$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($9c11340b6b4fd8cc$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$9c11340b6b4fd8cc$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $9c11340b6b4fd8cc$var$createBuffer(length) {
    if (length > $9c11340b6b4fd8cc$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $9c11340b6b4fd8cc$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $9c11340b6b4fd8cc$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $9c11340b6b4fd8cc$var$allocUnsafe(arg);
    }
    return $9c11340b6b4fd8cc$var$from(arg, encodingOrOffset, length);
}
$9c11340b6b4fd8cc$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $9c11340b6b4fd8cc$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $9c11340b6b4fd8cc$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $9c11340b6b4fd8cc$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($9c11340b6b4fd8cc$var$isInstance(value, ArrayBuffer) || value && $9c11340b6b4fd8cc$var$isInstance(value.buffer, ArrayBuffer)) return $9c11340b6b4fd8cc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($9c11340b6b4fd8cc$var$isInstance(value, SharedArrayBuffer) || value && $9c11340b6b4fd8cc$var$isInstance(value.buffer, SharedArrayBuffer))) return $9c11340b6b4fd8cc$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $9c11340b6b4fd8cc$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $9c11340b6b4fd8cc$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $9c11340b6b4fd8cc$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $9c11340b6b4fd8cc$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $9c11340b6b4fd8cc$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($9c11340b6b4fd8cc$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($9c11340b6b4fd8cc$var$Buffer, Uint8Array);
function $9c11340b6b4fd8cc$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $9c11340b6b4fd8cc$var$alloc(size, fill, encoding) {
    $9c11340b6b4fd8cc$var$assertSize(size);
    if (size <= 0) return $9c11340b6b4fd8cc$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $9c11340b6b4fd8cc$var$createBuffer(size).fill(fill, encoding) : $9c11340b6b4fd8cc$var$createBuffer(size).fill(fill);
    return $9c11340b6b4fd8cc$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $9c11340b6b4fd8cc$var$Buffer.alloc = function(size, fill, encoding) {
    return $9c11340b6b4fd8cc$var$alloc(size, fill, encoding);
};
function $9c11340b6b4fd8cc$var$allocUnsafe(size) {
    $9c11340b6b4fd8cc$var$assertSize(size);
    return $9c11340b6b4fd8cc$var$createBuffer(size < 0 ? 0 : $9c11340b6b4fd8cc$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $9c11340b6b4fd8cc$var$Buffer.allocUnsafe = function(size) {
    return $9c11340b6b4fd8cc$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $9c11340b6b4fd8cc$var$Buffer.allocUnsafeSlow = function(size) {
    return $9c11340b6b4fd8cc$var$allocUnsafe(size);
};
function $9c11340b6b4fd8cc$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$9c11340b6b4fd8cc$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $9c11340b6b4fd8cc$var$byteLength(string, encoding) | 0;
    let buf = $9c11340b6b4fd8cc$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $9c11340b6b4fd8cc$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $9c11340b6b4fd8cc$var$checked(array.length) | 0;
    const buf = $9c11340b6b4fd8cc$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $9c11340b6b4fd8cc$var$fromArrayView(arrayView) {
    if ($9c11340b6b4fd8cc$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $9c11340b6b4fd8cc$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $9c11340b6b4fd8cc$var$fromArrayLike(arrayView);
}
function $9c11340b6b4fd8cc$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $9c11340b6b4fd8cc$var$Buffer.prototype);
    return buf;
}
function $9c11340b6b4fd8cc$var$fromObject(obj) {
    if ($9c11340b6b4fd8cc$var$Buffer.isBuffer(obj)) {
        const len = $9c11340b6b4fd8cc$var$checked(obj.length) | 0;
        const buf = $9c11340b6b4fd8cc$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $9c11340b6b4fd8cc$var$numberIsNaN(obj.length)) return $9c11340b6b4fd8cc$var$createBuffer(0);
        return $9c11340b6b4fd8cc$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $9c11340b6b4fd8cc$var$fromArrayLike(obj.data);
}
function $9c11340b6b4fd8cc$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $9c11340b6b4fd8cc$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $9c11340b6b4fd8cc$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $9c11340b6b4fd8cc$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $9c11340b6b4fd8cc$var$Buffer.alloc(+length);
}
$9c11340b6b4fd8cc$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $9c11340b6b4fd8cc$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$9c11340b6b4fd8cc$var$Buffer.compare = function compare(a, b) {
    if ($9c11340b6b4fd8cc$var$isInstance(a, Uint8Array)) a = $9c11340b6b4fd8cc$var$Buffer.from(a, a.offset, a.byteLength);
    if ($9c11340b6b4fd8cc$var$isInstance(b, Uint8Array)) b = $9c11340b6b4fd8cc$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$9c11340b6b4fd8cc$var$Buffer.isBuffer(a) || !$9c11340b6b4fd8cc$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$9c11340b6b4fd8cc$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$9c11340b6b4fd8cc$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $9c11340b6b4fd8cc$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $9c11340b6b4fd8cc$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($9c11340b6b4fd8cc$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$9c11340b6b4fd8cc$var$Buffer.isBuffer(buf)) buf = $9c11340b6b4fd8cc$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$9c11340b6b4fd8cc$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $9c11340b6b4fd8cc$var$byteLength(string, encoding) {
    if ($9c11340b6b4fd8cc$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $9c11340b6b4fd8cc$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $9c11340b6b4fd8cc$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $9c11340b6b4fd8cc$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $9c11340b6b4fd8cc$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$9c11340b6b4fd8cc$var$Buffer.byteLength = $9c11340b6b4fd8cc$var$byteLength;
function $9c11340b6b4fd8cc$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $9c11340b6b4fd8cc$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $9c11340b6b4fd8cc$var$utf8Slice(this, start, end);
        case "ascii":
            return $9c11340b6b4fd8cc$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $9c11340b6b4fd8cc$var$latin1Slice(this, start, end);
        case "base64":
            return $9c11340b6b4fd8cc$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $9c11340b6b4fd8cc$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$9c11340b6b4fd8cc$var$Buffer.prototype._isBuffer = true;
function $9c11340b6b4fd8cc$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$9c11340b6b4fd8cc$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$9c11340b6b4fd8cc$var$swap(this, i, i + 1);
    return this;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $9c11340b6b4fd8cc$var$swap(this, i, i + 3);
        $9c11340b6b4fd8cc$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $9c11340b6b4fd8cc$var$swap(this, i, i + 7);
        $9c11340b6b4fd8cc$var$swap(this, i + 1, i + 6);
        $9c11340b6b4fd8cc$var$swap(this, i + 2, i + 5);
        $9c11340b6b4fd8cc$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $9c11340b6b4fd8cc$var$utf8Slice(this, 0, length);
    return $9c11340b6b4fd8cc$var$slowToString.apply(this, arguments);
};
$9c11340b6b4fd8cc$var$Buffer.prototype.toLocaleString = $9c11340b6b4fd8cc$var$Buffer.prototype.toString;
$9c11340b6b4fd8cc$var$Buffer.prototype.equals = function equals(b) {
    if (!$9c11340b6b4fd8cc$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $9c11340b6b4fd8cc$var$Buffer.compare(this, b) === 0;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $9c11340b6b4fd8cc$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($9c11340b6b4fd8cc$var$customInspectSymbol) $9c11340b6b4fd8cc$var$Buffer.prototype[$9c11340b6b4fd8cc$var$customInspectSymbol] = $9c11340b6b4fd8cc$var$Buffer.prototype.inspect;
$9c11340b6b4fd8cc$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($9c11340b6b4fd8cc$var$isInstance(target, Uint8Array)) target = $9c11340b6b4fd8cc$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$9c11340b6b4fd8cc$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $9c11340b6b4fd8cc$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($9c11340b6b4fd8cc$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $9c11340b6b4fd8cc$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($9c11340b6b4fd8cc$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $9c11340b6b4fd8cc$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $9c11340b6b4fd8cc$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $9c11340b6b4fd8cc$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$9c11340b6b4fd8cc$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $9c11340b6b4fd8cc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$9c11340b6b4fd8cc$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $9c11340b6b4fd8cc$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $9c11340b6b4fd8cc$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($9c11340b6b4fd8cc$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $9c11340b6b4fd8cc$var$utf8Write(buf, string, offset, length) {
    return $9c11340b6b4fd8cc$var$blitBuffer($9c11340b6b4fd8cc$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $9c11340b6b4fd8cc$var$asciiWrite(buf, string, offset, length) {
    return $9c11340b6b4fd8cc$var$blitBuffer($9c11340b6b4fd8cc$var$asciiToBytes(string), buf, offset, length);
}
function $9c11340b6b4fd8cc$var$base64Write(buf, string, offset, length) {
    return $9c11340b6b4fd8cc$var$blitBuffer($9c11340b6b4fd8cc$var$base64ToBytes(string), buf, offset, length);
}
function $9c11340b6b4fd8cc$var$ucs2Write(buf, string, offset, length) {
    return $9c11340b6b4fd8cc$var$blitBuffer($9c11340b6b4fd8cc$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$9c11340b6b4fd8cc$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $9c11340b6b4fd8cc$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $9c11340b6b4fd8cc$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $9c11340b6b4fd8cc$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $9c11340b6b4fd8cc$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $9c11340b6b4fd8cc$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$9c11340b6b4fd8cc$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $9c11340b6b4fd8cc$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gxC2H.fromByteArray(buf);
    else return $gxC2H.fromByteArray(buf.slice(start, end));
}
function $9c11340b6b4fd8cc$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $9c11340b6b4fd8cc$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $9c11340b6b4fd8cc$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $9c11340b6b4fd8cc$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $9c11340b6b4fd8cc$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $9c11340b6b4fd8cc$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $9c11340b6b4fd8cc$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $9c11340b6b4fd8cc$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $9c11340b6b4fd8cc$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $9c11340b6b4fd8cc$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $9c11340b6b4fd8cc$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$9c11340b6b4fd8cc$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $9c11340b6b4fd8cc$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $9c11340b6b4fd8cc$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$9c11340b6b4fd8cc$var$Buffer.prototype.readUintLE = $9c11340b6b4fd8cc$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readUintBE = $9c11340b6b4fd8cc$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readUint8 = $9c11340b6b4fd8cc$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readUint16LE = $9c11340b6b4fd8cc$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readUint16BE = $9c11340b6b4fd8cc$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readUint32LE = $9c11340b6b4fd8cc$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readUint32BE = $9c11340b6b4fd8cc$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readBigUInt64LE = $9c11340b6b4fd8cc$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $9c11340b6b4fd8cc$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9c11340b6b4fd8cc$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$9c11340b6b4fd8cc$var$Buffer.prototype.readBigUInt64BE = $9c11340b6b4fd8cc$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $9c11340b6b4fd8cc$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9c11340b6b4fd8cc$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$9c11340b6b4fd8cc$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readBigInt64LE = $9c11340b6b4fd8cc$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $9c11340b6b4fd8cc$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9c11340b6b4fd8cc$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$9c11340b6b4fd8cc$var$Buffer.prototype.readBigInt64BE = $9c11340b6b4fd8cc$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $9c11340b6b4fd8cc$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9c11340b6b4fd8cc$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$9c11340b6b4fd8cc$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, true, 23, 4);
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, false, 23, 4);
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, true, 52, 8);
};
$9c11340b6b4fd8cc$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, false, 52, 8);
};
function $9c11340b6b4fd8cc$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$9c11340b6b4fd8cc$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$9c11340b6b4fd8cc$var$Buffer.prototype.writeUintLE = $9c11340b6b4fd8cc$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $9c11340b6b4fd8cc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeUintBE = $9c11340b6b4fd8cc$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $9c11340b6b4fd8cc$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeUint8 = $9c11340b6b4fd8cc$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeUint16LE = $9c11340b6b4fd8cc$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeUint16BE = $9c11340b6b4fd8cc$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeUint32LE = $9c11340b6b4fd8cc$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeUint32BE = $9c11340b6b4fd8cc$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $9c11340b6b4fd8cc$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $9c11340b6b4fd8cc$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $9c11340b6b4fd8cc$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $9c11340b6b4fd8cc$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$9c11340b6b4fd8cc$var$Buffer.prototype.writeBigUInt64LE = $9c11340b6b4fd8cc$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $9c11340b6b4fd8cc$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$9c11340b6b4fd8cc$var$Buffer.prototype.writeBigUInt64BE = $9c11340b6b4fd8cc$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $9c11340b6b4fd8cc$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$9c11340b6b4fd8cc$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $9c11340b6b4fd8cc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $9c11340b6b4fd8cc$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeBigInt64LE = $9c11340b6b4fd8cc$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $9c11340b6b4fd8cc$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$9c11340b6b4fd8cc$var$Buffer.prototype.writeBigInt64BE = $9c11340b6b4fd8cc$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $9c11340b6b4fd8cc$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $9c11340b6b4fd8cc$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $9c11340b6b4fd8cc$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$9c11340b6b4fd8cc$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $9c11340b6b4fd8cc$var$writeFloat(this, value, offset, true, noAssert);
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $9c11340b6b4fd8cc$var$writeFloat(this, value, offset, false, noAssert);
};
function $9c11340b6b4fd8cc$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9c11340b6b4fd8cc$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$9c11340b6b4fd8cc$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $9c11340b6b4fd8cc$var$writeDouble(this, value, offset, true, noAssert);
};
$9c11340b6b4fd8cc$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $9c11340b6b4fd8cc$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$9c11340b6b4fd8cc$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$9c11340b6b4fd8cc$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$9c11340b6b4fd8cc$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$9c11340b6b4fd8cc$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $9c11340b6b4fd8cc$var$Buffer.isBuffer(val) ? val : $9c11340b6b4fd8cc$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $9c11340b6b4fd8cc$var$errors = {};
function $9c11340b6b4fd8cc$var$E(sym, getMessage, Base) {
    $9c11340b6b4fd8cc$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$9c11340b6b4fd8cc$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$9c11340b6b4fd8cc$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$9c11340b6b4fd8cc$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $9c11340b6b4fd8cc$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $9c11340b6b4fd8cc$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $9c11340b6b4fd8cc$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $9c11340b6b4fd8cc$var$checkBounds(buf, offset, byteLength) {
    $9c11340b6b4fd8cc$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $9c11340b6b4fd8cc$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $9c11340b6b4fd8cc$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $9c11340b6b4fd8cc$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $9c11340b6b4fd8cc$var$checkBounds(buf, offset, byteLength);
}
function $9c11340b6b4fd8cc$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $9c11340b6b4fd8cc$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $9c11340b6b4fd8cc$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $9c11340b6b4fd8cc$var$validateNumber(value, type);
        throw new $9c11340b6b4fd8cc$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $9c11340b6b4fd8cc$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $9c11340b6b4fd8cc$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $9c11340b6b4fd8cc$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $9c11340b6b4fd8cc$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($9c11340b6b4fd8cc$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $9c11340b6b4fd8cc$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $9c11340b6b4fd8cc$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $9c11340b6b4fd8cc$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $9c11340b6b4fd8cc$var$base64ToBytes(str) {
    return $gxC2H.toByteArray($9c11340b6b4fd8cc$var$base64clean(str));
}
function $9c11340b6b4fd8cc$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $9c11340b6b4fd8cc$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $9c11340b6b4fd8cc$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $9c11340b6b4fd8cc$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $9c11340b6b4fd8cc$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $9c11340b6b4fd8cc$var$BufferBigIntNotDefined : fn;
}
function $9c11340b6b4fd8cc$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});


parcelRegister("6xU83", function(module, exports) {

$parcel$export(module.exports, "keccak_256", function () { return $4c415d31f0155e02$export$860ddaa9ca84a66d; });

var $3eA0j = parcelRequire("3eA0j");

var $lHKrl = parcelRequire("lHKrl");

var $emVFP = parcelRequire("emVFP");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $4c415d31f0155e02$var$SHA3_PI = [];
const $4c415d31f0155e02$var$SHA3_ROTL = [];
const $4c415d31f0155e02$var$_SHA3_IOTA = [];
const $4c415d31f0155e02$var$_0n = /* @__PURE__ */ BigInt(0);
const $4c415d31f0155e02$var$_1n = /* @__PURE__ */ BigInt(1);
const $4c415d31f0155e02$var$_2n = /* @__PURE__ */ BigInt(2);
const $4c415d31f0155e02$var$_7n = /* @__PURE__ */ BigInt(7);
const $4c415d31f0155e02$var$_256n = /* @__PURE__ */ BigInt(256);
const $4c415d31f0155e02$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $4c415d31f0155e02$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $4c415d31f0155e02$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $4c415d31f0155e02$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $4c415d31f0155e02$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $4c415d31f0155e02$var$_1n ^ (R >> $4c415d31f0155e02$var$_7n) * $4c415d31f0155e02$var$_0x71n) % $4c415d31f0155e02$var$_256n;
        if (R & $4c415d31f0155e02$var$_2n) t ^= $4c415d31f0155e02$var$_1n << ($4c415d31f0155e02$var$_1n << /* @__PURE__ */ BigInt(j)) - $4c415d31f0155e02$var$_1n;
    }
    $4c415d31f0155e02$var$_SHA3_IOTA.push(t);
}
const [$4c415d31f0155e02$var$SHA3_IOTA_H, $4c415d31f0155e02$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $lHKrl.split)($4c415d31f0155e02$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $4c415d31f0155e02$var$rotlH = (h, l, s)=>s > 32 ? (0, $lHKrl.rotlBH)(h, l, s) : (0, $lHKrl.rotlSH)(h, l, s);
const $4c415d31f0155e02$var$rotlL = (h, l, s)=>s > 32 ? (0, $lHKrl.rotlBL)(h, l, s) : (0, $lHKrl.rotlSL)(h, l, s);
function $4c415d31f0155e02$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $4c415d31f0155e02$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $4c415d31f0155e02$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $4c415d31f0155e02$var$SHA3_ROTL[t];
            const Th = $4c415d31f0155e02$var$rotlH(curH, curL, shift);
            const Tl = $4c415d31f0155e02$var$rotlL(curH, curL, shift);
            const PI = $4c415d31f0155e02$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $4c415d31f0155e02$var$SHA3_IOTA_H[round];
        s[1] ^= $4c415d31f0155e02$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $4c415d31f0155e02$export$f7374b8b4498bc2e extends (0, $emVFP.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $3eA0j.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $emVFP.u32)(this.state);
    }
    keccak() {
        if (!(0, $emVFP.isLE)) (0, $emVFP.byteSwap32)(this.state32);
        $4c415d31f0155e02$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $emVFP.isLE)) (0, $emVFP.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $3eA0j.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $emVFP.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $3eA0j.exists)(this, false);
        (0, $3eA0j.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $3eA0j.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $3eA0j.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $4c415d31f0155e02$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $4c415d31f0155e02$var$gen = (suffix, blockLen, outputLen)=>(0, $emVFP.wrapConstructor)(()=>new $4c415d31f0155e02$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $4c415d31f0155e02$export$fe6c2b96a79338e9 = /* @__PURE__ */ $4c415d31f0155e02$var$gen(0x06, 144, 28);
const $4c415d31f0155e02$export$76e19b6966813b14 = /* @__PURE__ */ $4c415d31f0155e02$var$gen(0x06, 136, 32);
const $4c415d31f0155e02$export$a58509fa80f30d15 = /* @__PURE__ */ $4c415d31f0155e02$var$gen(0x06, 104, 48);
const $4c415d31f0155e02$export$20ed324dbdf09b7c = /* @__PURE__ */ $4c415d31f0155e02$var$gen(0x06, 72, 64);
const $4c415d31f0155e02$export$2f7fb3c6fac246bc = /* @__PURE__ */ $4c415d31f0155e02$var$gen(0x01, 144, 28);
const $4c415d31f0155e02$export$860ddaa9ca84a66d = /* @__PURE__ */ $4c415d31f0155e02$var$gen(0x01, 136, 32);
const $4c415d31f0155e02$export$46fcdeb4c5686552 = /* @__PURE__ */ $4c415d31f0155e02$var$gen(0x01, 104, 48);
const $4c415d31f0155e02$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $4c415d31f0155e02$var$gen(0x01, 72, 64);
const $4c415d31f0155e02$var$genShake = (suffix, blockLen, outputLen)=>(0, $emVFP.wrapXOFConstructorWithOpts)((opts = {})=>new $4c415d31f0155e02$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $4c415d31f0155e02$export$f43dc3bb86efbba2 = /* @__PURE__ */ $4c415d31f0155e02$var$genShake(0x1f, 168, 16);
const $4c415d31f0155e02$export$c240d011f1520440 = /* @__PURE__ */ $4c415d31f0155e02$var$genShake(0x1f, 136, 32);

});

parcelRegister("3ZrHu", function(module, exports) {

$parcel$export(module.exports, "secp256k1", function () { return $2e7c8e501eeaa857$export$529e6123e9353a90; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $iIvsQ = parcelRequire("iIvsQ");

var $emVFP = parcelRequire("emVFP");

var $Xe11V = parcelRequire("Xe11V");

var $6WoFF = parcelRequire("6WoFF");

var $4ALPe = parcelRequire("4ALPe");

var $hX21w = parcelRequire("hX21w");

var $hqIJ6 = parcelRequire("hqIJ6");
const $2e7c8e501eeaa857$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $2e7c8e501eeaa857$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $2e7c8e501eeaa857$var$_1n = BigInt(1);
const $2e7c8e501eeaa857$var$_2n = BigInt(2);
const $2e7c8e501eeaa857$var$divNearest = (a, b)=>(a + b / $2e7c8e501eeaa857$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $2e7c8e501eeaa857$var$sqrtMod(y) {
    const P = $2e7c8e501eeaa857$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $4ALPe.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $4ALPe.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $4ALPe.pow2)(b9, $2e7c8e501eeaa857$var$_2n, P) * b2 % P;
    const b22 = (0, $4ALPe.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $4ALPe.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $4ALPe.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $4ALPe.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $4ALPe.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $4ALPe.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $4ALPe.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $4ALPe.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $4ALPe.pow2)(t2, $2e7c8e501eeaa857$var$_2n, P);
    if (!$2e7c8e501eeaa857$var$Fp.eql($2e7c8e501eeaa857$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $2e7c8e501eeaa857$var$Fp = (0, $4ALPe.Field)($2e7c8e501eeaa857$var$secp256k1P, undefined, undefined, {
    sqrt: $2e7c8e501eeaa857$var$sqrtMod
});
const $2e7c8e501eeaa857$export$529e6123e9353a90 = (0, $Xe11V.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $2e7c8e501eeaa857$var$Fp,
    n: $2e7c8e501eeaa857$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $2e7c8e501eeaa857$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$2e7c8e501eeaa857$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $2e7c8e501eeaa857$var$divNearest(b2 * k, n);
            const c2 = $2e7c8e501eeaa857$var$divNearest(-b1 * k, n);
            let k1 = (0, $4ALPe.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $4ALPe.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $iIvsQ.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $2e7c8e501eeaa857$var$_0n = BigInt(0);
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $2e7c8e501eeaa857$var$TAGGED_HASH_PREFIXES = {};
function $2e7c8e501eeaa857$var$taggedHash(tag, ...messages) {
    let tagP = $2e7c8e501eeaa857$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $iIvsQ.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $hX21w.concatBytes)(tagH, tagH);
        $2e7c8e501eeaa857$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $iIvsQ.sha256)((0, $hX21w.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $2e7c8e501eeaa857$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $2e7c8e501eeaa857$var$numTo32b = (n)=>(0, $hX21w.numberToBytesBE)(n, 32);
const $2e7c8e501eeaa857$var$modP = (x)=>(0, $4ALPe.mod)(x, $2e7c8e501eeaa857$var$secp256k1P);
const $2e7c8e501eeaa857$var$modN = (x)=>(0, $4ALPe.mod)(x, $2e7c8e501eeaa857$var$secp256k1N);
const $2e7c8e501eeaa857$var$Point = $2e7c8e501eeaa857$export$529e6123e9353a90.ProjectivePoint;
const $2e7c8e501eeaa857$var$GmulAdd = (Q, a, b)=>$2e7c8e501eeaa857$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $2e7c8e501eeaa857$var$schnorrGetExtPubKey(priv) {
    let d_ = $2e7c8e501eeaa857$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $2e7c8e501eeaa857$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $2e7c8e501eeaa857$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $2e7c8e501eeaa857$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $2e7c8e501eeaa857$var$lift_x(x) {
    (0, $hX21w.aInRange)("x", x, $2e7c8e501eeaa857$var$_1n, $2e7c8e501eeaa857$var$secp256k1P); // Fail if x ≥ p.
    const xx = $2e7c8e501eeaa857$var$modP(x * x);
    const c = $2e7c8e501eeaa857$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $2e7c8e501eeaa857$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $2e7c8e501eeaa857$var$_2n !== $2e7c8e501eeaa857$var$_0n) y = $2e7c8e501eeaa857$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $2e7c8e501eeaa857$var$Point(x, y, $2e7c8e501eeaa857$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
const $2e7c8e501eeaa857$var$num = (0, $hX21w.bytesToNumberBE);
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $2e7c8e501eeaa857$var$challenge(...args) {
    return $2e7c8e501eeaa857$var$modN($2e7c8e501eeaa857$var$num($2e7c8e501eeaa857$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $2e7c8e501eeaa857$var$schnorrGetPublicKey(privateKey) {
    return $2e7c8e501eeaa857$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $2e7c8e501eeaa857$var$schnorrSign(message, privateKey, auxRand = (0, $emVFP.randomBytes)(32)) {
    const m = (0, $hX21w.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $2e7c8e501eeaa857$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $hX21w.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $2e7c8e501eeaa857$var$numTo32b(d ^ $2e7c8e501eeaa857$var$num($2e7c8e501eeaa857$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $2e7c8e501eeaa857$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $2e7c8e501eeaa857$var$modN($2e7c8e501eeaa857$var$num(rand)); // Let k' = int(rand) mod n
    if (k_ === $2e7c8e501eeaa857$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $2e7c8e501eeaa857$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $2e7c8e501eeaa857$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($2e7c8e501eeaa857$var$numTo32b($2e7c8e501eeaa857$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$2e7c8e501eeaa857$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $2e7c8e501eeaa857$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $hX21w.ensureBytes)("signature", signature, 64);
    const m = (0, $hX21w.ensureBytes)("message", message);
    const pub = (0, $hX21w.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $2e7c8e501eeaa857$var$lift_x($2e7c8e501eeaa857$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $2e7c8e501eeaa857$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $hX21w.inRange)(r, $2e7c8e501eeaa857$var$_1n, $2e7c8e501eeaa857$var$secp256k1P)) return false;
        const s = $2e7c8e501eeaa857$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $hX21w.inRange)(s, $2e7c8e501eeaa857$var$_1n, $2e7c8e501eeaa857$var$secp256k1N)) return false;
        const e = $2e7c8e501eeaa857$var$challenge($2e7c8e501eeaa857$var$numTo32b(r), $2e7c8e501eeaa857$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $2e7c8e501eeaa857$var$GmulAdd(P, s, $2e7c8e501eeaa857$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $2e7c8e501eeaa857$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $2e7c8e501eeaa857$var$schnorrGetPublicKey,
        sign: $2e7c8e501eeaa857$var$schnorrSign,
        verify: $2e7c8e501eeaa857$var$schnorrVerify,
        utils: {
            randomPrivateKey: $2e7c8e501eeaa857$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $2e7c8e501eeaa857$var$lift_x,
            pointToBytes: $2e7c8e501eeaa857$var$pointToBytes,
            numberToBytesBE: $hX21w.numberToBytesBE,
            bytesToNumberBE: $hX21w.bytesToNumberBE,
            taggedHash: $2e7c8e501eeaa857$var$taggedHash,
            mod: $4ALPe.mod
        }
    }))();
const $2e7c8e501eeaa857$var$isoMap = /* @__PURE__ */ (()=>(0, $6WoFF.isogenyMap)($2e7c8e501eeaa857$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $2e7c8e501eeaa857$var$mapSWU = /* @__PURE__ */ (()=>(0, $hqIJ6.mapToCurveSimpleSWU)($2e7c8e501eeaa857$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $2e7c8e501eeaa857$var$Fp.create(BigInt("-11"))
    }))();
const $2e7c8e501eeaa857$var$htf = /* @__PURE__ */ (()=>(0, $6WoFF.createHasher)($2e7c8e501eeaa857$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $2e7c8e501eeaa857$var$mapSWU($2e7c8e501eeaa857$var$Fp.create(scalars[0]));
        return $2e7c8e501eeaa857$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $2e7c8e501eeaa857$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $iIvsQ.sha256)
    }))();
const $2e7c8e501eeaa857$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$2e7c8e501eeaa857$var$htf.hashToCurve)();
const $2e7c8e501eeaa857$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$2e7c8e501eeaa857$var$htf.encodeToCurve)();

});
parcelRegister("Xe11V", function(module, exports) {

$parcel$export(module.exports, "createCurve", function () { return $0b2062031202c7de$export$3f2f6721dd02558a; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $f9Spz = parcelRequire("f9Spz");

var $emVFP = parcelRequire("emVFP");

var $hqIJ6 = parcelRequire("hqIJ6");
function $0b2062031202c7de$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $f9Spz.hmac)(hash, key, (0, $emVFP.concatBytes)(...msgs)),
        randomBytes: $emVFP.randomBytes
    };
}
function $0b2062031202c7de$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $hqIJ6.weierstrass)({
            ...curveDef,
            ...$0b2062031202c7de$export$adaba664e531641c(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}

});
parcelRegister("f9Spz", function(module, exports) {

$parcel$export(module.exports, "hmac", function () { return $b091e744c885380b$export$355af40f8ab02f34; });

var $3eA0j = parcelRequire("3eA0j");

var $emVFP = parcelRequire("emVFP");
class $b091e744c885380b$export$7b9cf41ebec74f45 extends (0, $emVFP.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $3eA0j.hash)(hash);
        const key = (0, $emVFP.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $3eA0j.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $3eA0j.exists)(this);
        (0, $3eA0j.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $b091e744c885380b$export$355af40f8ab02f34 = (hash, key, message)=>new $b091e744c885380b$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$b091e744c885380b$export$355af40f8ab02f34.create = (hash, key)=>new $b091e744c885380b$export$7b9cf41ebec74f45(hash, key);

});

parcelRegister("hqIJ6", function(module, exports) {

$parcel$export(module.exports, "weierstrass", function () { return $cb078f200e6d001e$export$350b8ea6f1c27fae; });
$parcel$export(module.exports, "mapToCurveSimpleSWU", function () { return $cb078f200e6d001e$export$cc7fea9756a17416; });
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $c97Ta = parcelRequire("c97Ta");

var $4ALPe = parcelRequire("4ALPe");

var $hX21w = parcelRequire("hX21w");
function $cb078f200e6d001e$var$validateSigVerOpts(opts) {
    if (opts.lowS !== undefined) (0, $hX21w.abool)("lowS", opts.lowS);
    if (opts.prehash !== undefined) (0, $hX21w.abool)("prehash", opts.prehash);
}
function $cb078f200e6d001e$var$validatePointOpts(curve) {
    const opts = (0, $c97Ta.validateBasic)(curve);
    $hX21w.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $cb078f200e6d001e$var$b2n, hexToBytes: $cb078f200e6d001e$var$h2b } = $hX21w;
const $cb078f200e6d001e$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $cb078f200e6d001e$export$56ac33195d7076db;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $cb078f200e6d001e$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $cb078f200e6d001e$export$56ac33195d7076db;
        const data = typeof hex === "string" ? $cb078f200e6d001e$var$h2b(hex) : hex;
        $hX21w.abytes(data);
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $cb078f200e6d001e$export$56ac33195d7076db._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $cb078f200e6d001e$export$56ac33195d7076db._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $cb078f200e6d001e$var$_0n = BigInt(0), $cb078f200e6d001e$var$_1n = BigInt(1), $cb078f200e6d001e$var$_2n = BigInt(2), $cb078f200e6d001e$var$_3n = BigInt(3), $cb078f200e6d001e$var$_4n = BigInt(4);
function $cb078f200e6d001e$export$fa783af82e4fe0fc(opts) {
    const CURVE = $cb078f200e6d001e$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $hX21w.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return $hX21w.inRange(num, $cb078f200e6d001e$var$_1n, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: N } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if ($hX21w.isBytes(key)) key = $hX21w.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $hX21w.bytesToNumberBE((0, $hX21w.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $4ALPe.mod(num, N); // disabled by default, enabled for BLS
        $hX21w.aInRange("private key", num, $cb078f200e6d001e$var$_1n, N); // num in range [1..N-1]
        return num;
    }
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    const toAffineMemo = (0, $hX21w.memoized)((p, iz)=>{
        const { px: x, py: y, pz: z } = p;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE)) return {
            x: x,
            y: y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
        const ax = Fp.mul(x, iz);
        const ay = Fp.mul(y, iz);
        const zz = Fp.mul(z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $hX21w.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is wrong representation of ZERO and is always invalid.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py)) return;
            throw new Error("bad point: ZERO");
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
        if (!p.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
            Object.freeze(this);
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $hX21w.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $cb078f200e6d001e$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $cb078f200e6d001e$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            $hX21w.aInRange("scalar", sc, $cb078f200e6d001e$var$_0n, CURVE.n);
            const I = Point.ZERO;
            if (sc === $cb078f200e6d001e$var$_0n) return I;
            if (sc === $cb078f200e6d001e$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, sc);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(sc);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $cb078f200e6d001e$var$_0n || k2 > $cb078f200e6d001e$var$_0n){
                if (k1 & $cb078f200e6d001e$var$_1n) k1p = k1p.add(d);
                if (k2 & $cb078f200e6d001e$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $cb078f200e6d001e$var$_1n;
                k2 >>= $cb078f200e6d001e$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo, n: N } = CURVE;
            $hX21w.aInRange("scalar", scalar, $cb078f200e6d001e$var$_1n, N);
            let point, fake; // Fake point is used to const-time mult
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(scalar);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $cb078f200e6d001e$var$_0n || a === $cb078f200e6d001e$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $cb078f200e6d001e$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $cb078f200e6d001e$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            (0, $hX21w.abool)("isCompressed", isCompressed);
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            (0, $hX21w.abool)("isCompressed", isCompressed);
            return $hX21w.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $c97Ta.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $cb078f200e6d001e$var$validateOpts(curve) {
    const opts = (0, $c97Ta.validateBasic)(curve);
    $hX21w.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $cb078f200e6d001e$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $cb078f200e6d001e$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return $4ALPe.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $4ALPe.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $cb078f200e6d001e$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $hX21w.concatBytes;
            (0, $hX21w.abool)("isCompressed", isCompressed);
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $hX21w.bytesToNumberBE(tail);
                if (!$hX21w.inRange(x, $cb078f200e6d001e$var$_1n, Fp.ORDER)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                const isYOdd = (y & $cb078f200e6d001e$var$_1n) === $cb078f200e6d001e$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$hX21w.bytesToHex($hX21w.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $cb078f200e6d001e$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$hX21w.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $hX21w.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $cb078f200e6d001e$export$56ac33195d7076db.toSig((0, $hX21w.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            $hX21w.aInRange("r", this.r, $cb078f200e6d001e$var$_1n, CURVE_ORDER); // r in [1..N]
            $hX21w.aInRange("s", this.s, $cb078f200e6d001e$var$_1n, CURVE_ORDER); // s in [1..N]
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $hX21w.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $hX21w.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $cb078f200e6d001e$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $hX21w.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $4ALPe.getMinHashLength(CURVE.n);
            return $4ALPe.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $hX21w.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $hX21w.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $hX21w.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        $hX21w.aInRange(`num < 2^${CURVE.nBitLength}`, num, $cb078f200e6d001e$var$_0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return $hX21w.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $hX21w.ensureBytes)("msgHash", msgHash);
        $cb078f200e6d001e$var$validateSigVerOpts(opts);
        if (prehash) msgHash = (0, $hX21w.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $hX21w.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $hX21w.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $cb078f200e6d001e$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $cb078f200e6d001e$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $cb078f200e6d001e$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $hX21w.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $hX21w.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $hX21w.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        $cb078f200e6d001e$var$validateSigVerOpts(opts);
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || $hX21w.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $cb078f200e6d001e$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $cb078f200e6d001e$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $cb078f200e6d001e$var$_0n;
    for(let o = q - $cb078f200e6d001e$var$_1n; o % $cb078f200e6d001e$var$_2n === $cb078f200e6d001e$var$_0n; o /= $cb078f200e6d001e$var$_2n)l += $cb078f200e6d001e$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $cb078f200e6d001e$var$_2n << c1 - $cb078f200e6d001e$var$_1n - $cb078f200e6d001e$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $cb078f200e6d001e$var$_2n;
    const c2 = (q - $cb078f200e6d001e$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $cb078f200e6d001e$var$_1n) / $cb078f200e6d001e$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $cb078f200e6d001e$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $cb078f200e6d001e$var$_1n) / $cb078f200e6d001e$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $cb078f200e6d001e$var$_1n; i--){
            let tv5 = i - $cb078f200e6d001e$var$_2n; // 18.    tv5 = i - 2
            tv5 = $cb078f200e6d001e$var$_2n << tv5 - $cb078f200e6d001e$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $cb078f200e6d001e$var$_4n === $cb078f200e6d001e$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $cb078f200e6d001e$var$_3n) / $cb078f200e6d001e$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $cb078f200e6d001e$export$cc7fea9756a17416(Fp, opts) {
    $4ALPe.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $cb078f200e6d001e$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});




parcelRegister("Q6eBv", function(module, exports) {

$parcel$export(module.exports, "wNAF", function () { return wNAF; });
$parcel$export(module.exports, "pippenger", function () { return pippenger; });
$parcel$export(module.exports, "validateBasic", function () { return validateBasic; });
/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $i2UKs = parcelRequire("i2UKs");

var $O98NX = parcelRequire("O98NX");
const _0n = BigInt(0);
const _1n = BigInt(1);
function constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error("invalid window size, expected [1.." + bits + "], got W=" + W);
}
function calcWOpts(W, bits) {
    validateW(W, bits);
    const windows = Math.ceil(bits / W) + 1; // +1, because
    const windowSize = 2 ** (W - 1); // -1 because we skip zero
    return {
        windows: windows,
        windowSize: windowSize
    };
}
function validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error("array expected");
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error("invalid point at index " + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error("array of scalars expected");
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error("invalid scalar at index " + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
function getW(P) {
    return pointWindowSizes.get(P) || 1;
}
function wNAF(c, bits) {
    return {
        constTimeNegate: constTimeNegate,
        hasPrecomputes (elm) {
            return getW(elm) !== 1;
        },
        // non-const time multiplication ladder
        unsafeLadder (elm, n, p = c.ZERO) {
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @param elm Point instance
         * @param W window size
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = calcWOpts(W, bits);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        /**
         * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @param acc accumulator point to add result of multiplication
         * @returns point
         */ wNAFUnsafe (W, precomputes, n, acc = c.ZERO) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                if (n === _0n) break; // No need to go over empty scalar
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                if (wbits === 0) continue;
                let curr = precomputes[offset + Math.abs(wbits) - 1]; // -1 because we skip zero
                if (wbits < 0) curr = curr.negate();
                // NOTE: by re-using acc, we can save a lot of additions in case of MSM
                acc = acc.add(curr);
            }
            return acc;
        },
        getPrecomputes (W, P, transform) {
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return comp;
        },
        wNAFCached (P, n, transform) {
            const W = getW(P);
            return this.wNAF(W, this.getPrecomputes(W, P, transform), n);
        },
        wNAFCachedUnsafe (P, n, transform, prev) {
            const W = getW(P);
            if (W === 1) return this.unsafeLadder(P, n, prev); // For W=1 ladder is ~x2 faster
            return this.wNAFUnsafe(W, this.getPrecomputes(W, P, transform), n, prev);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize (P, W) {
            validateW(W, bits);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
function pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    if (points.length !== scalars.length) throw new Error("arrays of points and scalars must have equal length");
    const zero = c.ZERO;
    const wbits = (0, $O98NX.bitLen)(BigInt(points.length));
    const windowSize = wbits > 12 ? wbits - 3 : wbits > 4 ? wbits - 2 : wbits ? 2 : 1; // in bits
    const MASK = (1 << windowSize) - 1;
    const buckets = new Array(MASK + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < scalars.length; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & BigInt(MASK));
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
function precomputeMSMUnsafe(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ validateW(windowSize, fieldN.BITS);
    validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = BigInt((1 << windowSize) - 1);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error("array of scalars must be smaller than array of points");
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function validateBasic(curve) {
    (0, $i2UKs.validateField)(curve.Fp);
    (0, $O98NX.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $i2UKs.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("i2UKs", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $d2346ef48427cc24$export$842a2cf37af977e1; });
$parcel$export(module.exports, "pow", function () { return $d2346ef48427cc24$export$9c297f60e22e3389; });
$parcel$export(module.exports, "pow2", function () { return $d2346ef48427cc24$export$fa569bd808b67eef; });
$parcel$export(module.exports, "isNegativeLE", function () { return $d2346ef48427cc24$export$7806f13ad5078b2f; });
$parcel$export(module.exports, "validateField", function () { return $d2346ef48427cc24$export$bd454f0cef11418d; });
$parcel$export(module.exports, "nLength", function () { return $d2346ef48427cc24$export$c79df43ecd7e66c2; });
$parcel$export(module.exports, "Field", function () { return $d2346ef48427cc24$export$a455218a85c89869; });
$parcel$export(module.exports, "FpSqrtEven", function () { return $d2346ef48427cc24$export$1d7b691df0888e02; });
/**
 * Utils for modular division and finite fields.
 * A finite field over 11 is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $O98NX = parcelRequire("O98NX");
// prettier-ignore
const $d2346ef48427cc24$var$_0n = BigInt(0), $d2346ef48427cc24$var$_1n = BigInt(1), $d2346ef48427cc24$var$_2n = /* @__PURE__ */ BigInt(2), $d2346ef48427cc24$var$_3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const $d2346ef48427cc24$var$_4n = /* @__PURE__ */ BigInt(4), $d2346ef48427cc24$var$_5n = /* @__PURE__ */ BigInt(5), $d2346ef48427cc24$var$_8n = /* @__PURE__ */ BigInt(8);
// prettier-ignore
const $d2346ef48427cc24$var$_9n = /* @__PURE__ */ BigInt(9), $d2346ef48427cc24$var$_16n = /* @__PURE__ */ BigInt(16);
function $d2346ef48427cc24$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $d2346ef48427cc24$var$_0n ? result : b + result;
}
function $d2346ef48427cc24$export$9c297f60e22e3389(num, power, modulo) {
    if (power < $d2346ef48427cc24$var$_0n) throw new Error("invalid exponent, negatives unsupported");
    if (modulo <= $d2346ef48427cc24$var$_0n) throw new Error("invalid modulus");
    if (modulo === $d2346ef48427cc24$var$_1n) return $d2346ef48427cc24$var$_0n;
    let res = $d2346ef48427cc24$var$_1n;
    while(power > $d2346ef48427cc24$var$_0n){
        if (power & $d2346ef48427cc24$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $d2346ef48427cc24$var$_1n;
    }
    return res;
}
function $d2346ef48427cc24$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $d2346ef48427cc24$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $d2346ef48427cc24$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $d2346ef48427cc24$var$_0n) throw new Error("invert: expected non-zero number");
    if (modulo <= $d2346ef48427cc24$var$_0n) throw new Error("invert: expected positive modulus, got " + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $d2346ef48427cc24$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $d2346ef48427cc24$var$_0n, y = $d2346ef48427cc24$var$_1n, u = $d2346ef48427cc24$var$_1n, v = $d2346ef48427cc24$var$_0n;
    while(a !== $d2346ef48427cc24$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $d2346ef48427cc24$var$_1n) throw new Error("invert: does not exist");
    return $d2346ef48427cc24$export$842a2cf37af977e1(x, modulo);
}
function $d2346ef48427cc24$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $d2346ef48427cc24$var$_1n) / $d2346ef48427cc24$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $d2346ef48427cc24$var$_1n, S = 0; Q % $d2346ef48427cc24$var$_2n === $d2346ef48427cc24$var$_0n; Q /= $d2346ef48427cc24$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $d2346ef48427cc24$var$_2n; Z < P && $d2346ef48427cc24$export$9c297f60e22e3389(Z, legendreC, P) !== P - $d2346ef48427cc24$var$_1n; Z++){
        // Crash instead of infinity loop, we cannot reasonable count until P.
        if (Z > 1000) throw new Error("Cannot find square root: likely non-prime P");
    }
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $d2346ef48427cc24$var$_1n) / $d2346ef48427cc24$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $d2346ef48427cc24$var$_1n) / $d2346ef48427cc24$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $d2346ef48427cc24$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $d2346ef48427cc24$export$33bda048c6b8ea7d(P) {
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $d2346ef48427cc24$var$_4n === $d2346ef48427cc24$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $d2346ef48427cc24$var$_1n) / $d2346ef48427cc24$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $d2346ef48427cc24$var$_8n === $d2346ef48427cc24$var$_5n) {
        const c1 = (P - $d2346ef48427cc24$var$_5n) / $d2346ef48427cc24$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $d2346ef48427cc24$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $d2346ef48427cc24$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $d2346ef48427cc24$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $d2346ef48427cc24$export$69f29ab1f3e9a234(P);
}
const $d2346ef48427cc24$export$7806f13ad5078b2f = (num, modulo)=>($d2346ef48427cc24$export$842a2cf37af977e1(num, modulo) & $d2346ef48427cc24$var$_1n) === $d2346ef48427cc24$var$_1n;
// prettier-ignore
const $d2346ef48427cc24$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $d2346ef48427cc24$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $d2346ef48427cc24$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $O98NX.validateObject)(field, opts);
}
function $d2346ef48427cc24$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $d2346ef48427cc24$var$_0n) throw new Error("invalid exponent, negatives unsupported");
    if (power === $d2346ef48427cc24$var$_0n) return f.ONE;
    if (power === $d2346ef48427cc24$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $d2346ef48427cc24$var$_0n){
        if (power & $d2346ef48427cc24$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $d2346ef48427cc24$var$_1n;
    }
    return p;
}
function $d2346ef48427cc24$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $d2346ef48427cc24$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $d2346ef48427cc24$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $d2346ef48427cc24$export$77ed22730026dd0d(order) {
    const legendreConst = (order - $d2346ef48427cc24$var$_1n) / $d2346ef48427cc24$var$_2n; // Integer arithmetic
    return (f, x)=>f.pow(x, legendreConst);
}
function $d2346ef48427cc24$export$5e2b6e87f2891ea7(f) {
    const legendre = $d2346ef48427cc24$export$77ed22730026dd0d(f.ORDER);
    return (x)=>{
        const p = legendre(f, x);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $d2346ef48427cc24$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $d2346ef48427cc24$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $d2346ef48427cc24$var$_0n) throw new Error("invalid field: expected ORDER > 0, got " + ORDER);
    const { nBitLength: BITS, nByteLength: BYTES } = $d2346ef48427cc24$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("invalid field: expected ORDER of <= 2048 bytes");
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER: ORDER,
        isLE: isLE,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $O98NX.bitMask)(BITS),
        ZERO: $d2346ef48427cc24$var$_0n,
        ONE: $d2346ef48427cc24$var$_1n,
        create: (num)=>$d2346ef48427cc24$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error("invalid field element: expected bigint, got " + typeof num);
            return $d2346ef48427cc24$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $d2346ef48427cc24$var$_0n,
        isOdd: (num)=>(num & $d2346ef48427cc24$var$_1n) === $d2346ef48427cc24$var$_1n,
        neg: (num)=>$d2346ef48427cc24$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$d2346ef48427cc24$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$d2346ef48427cc24$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$d2346ef48427cc24$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$d2346ef48427cc24$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$d2346ef48427cc24$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$d2346ef48427cc24$export$842a2cf37af977e1(lhs * $d2346ef48427cc24$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$d2346ef48427cc24$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>{
            if (!sqrtP) sqrtP = $d2346ef48427cc24$export$33bda048c6b8ea7d(ORDER);
            return sqrtP(f, n);
        }),
        invertBatch: (lst)=>$d2346ef48427cc24$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $O98NX.numberToBytesLE)(num, BYTES) : (0, $O98NX.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error("Field.fromBytes: expected " + BYTES + " bytes, got " + bytes.length);
            return isLE ? (0, $O98NX.bytesToNumberLE)(bytes) : (0, $O98NX.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $d2346ef48427cc24$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $d2346ef48427cc24$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $d2346ef48427cc24$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $O98NX.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $d2346ef48427cc24$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error("hashToPrivateScalar: expected " + minLen + "-1024 bytes of input, got " + hashLen);
    const num = isLE ? (0, $O98NX.bytesToNumberLE)(hash) : (0, $O98NX.bytesToNumberBE)(hash);
    return $d2346ef48427cc24$export$842a2cf37af977e1(num, groupOrder - $d2346ef48427cc24$var$_1n) + $d2346ef48427cc24$var$_1n;
}
function $d2346ef48427cc24$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $d2346ef48427cc24$export$d058763b563056af(fieldOrder) {
    const length = $d2346ef48427cc24$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $d2346ef48427cc24$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $d2346ef48427cc24$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $d2346ef48427cc24$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error("expected " + minLen + "-1024 bytes of input, got " + len);
    const num = isLE ? (0, $O98NX.bytesToNumberLE)(key) : (0, $O98NX.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $d2346ef48427cc24$export$842a2cf37af977e1(num, fieldOrder - $d2346ef48427cc24$var$_1n) + $d2346ef48427cc24$var$_1n;
    return isLE ? (0, $O98NX.numberToBytesLE)(reduced, fieldLen) : (0, $O98NX.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("O98NX", function(module, exports) {

$parcel$export(module.exports, "abytes", function () { return $096bc2d75348a621$export$e8a750b9efad93f5; });
$parcel$export(module.exports, "abool", function () { return $096bc2d75348a621$export$809304d28d77d92d; });
$parcel$export(module.exports, "bytesToHex", function () { return $096bc2d75348a621$export$58b867e287a802c8; });
$parcel$export(module.exports, "bytesToNumberBE", function () { return $096bc2d75348a621$export$d609354794974f8; });
$parcel$export(module.exports, "bytesToNumberLE", function () { return $096bc2d75348a621$export$d67b1d03392107e7; });
$parcel$export(module.exports, "numberToBytesBE", function () { return $096bc2d75348a621$export$1459dafd057611cb; });
$parcel$export(module.exports, "numberToBytesLE", function () { return $096bc2d75348a621$export$ba2172e58d139f6d; });
$parcel$export(module.exports, "ensureBytes", function () { return $096bc2d75348a621$export$3cb5d50a3a30e837; });
$parcel$export(module.exports, "concatBytes", function () { return $096bc2d75348a621$export$287dd7971339c972; });
$parcel$export(module.exports, "equalBytes", function () { return $096bc2d75348a621$export$2aa59cef064b0333; });
$parcel$export(module.exports, "utf8ToBytes", function () { return $096bc2d75348a621$export$3df70a15530b5e81; });
$parcel$export(module.exports, "aInRange", function () { return $096bc2d75348a621$export$86cc12b5dde3c1e4; });
$parcel$export(module.exports, "bitLen", function () { return $096bc2d75348a621$export$e93ef600c41761a9; });
$parcel$export(module.exports, "bitMask", function () { return $096bc2d75348a621$export$803efa2fa1c7279; });
$parcel$export(module.exports, "validateObject", function () { return $096bc2d75348a621$export$381bae2d0f08004f; });
$parcel$export(module.exports, "memoized", function () { return $096bc2d75348a621$export$9756366f7cb6f62b; });
/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $096bc2d75348a621$var$_0n = /* @__PURE__ */ BigInt(0);
const $096bc2d75348a621$var$_1n = /* @__PURE__ */ BigInt(1);
const $096bc2d75348a621$var$_2n = /* @__PURE__ */ BigInt(2);
function $096bc2d75348a621$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $096bc2d75348a621$export$e8a750b9efad93f5(item) {
    if (!$096bc2d75348a621$export$c6fabfbfd097fc30(item)) throw new Error("Uint8Array expected");
}
function $096bc2d75348a621$export$809304d28d77d92d(title, value) {
    if (typeof value !== "boolean") throw new Error(title + " boolean expected, got " + value);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $096bc2d75348a621$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $096bc2d75348a621$export$58b867e287a802c8(bytes) {
    $096bc2d75348a621$export$e8a750b9efad93f5(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $096bc2d75348a621$var$hexes[bytes[i]];
    return hex;
}
function $096bc2d75348a621$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? "0" + hex : hex;
}
function $096bc2d75348a621$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    return hex === "" ? $096bc2d75348a621$var$_0n : BigInt("0x" + hex); // Big Endian
}
// We use optimized technique to convert hex string to byte array
const $096bc2d75348a621$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $096bc2d75348a621$var$asciiToBase16(ch) {
    if (ch >= $096bc2d75348a621$var$asciis._0 && ch <= $096bc2d75348a621$var$asciis._9) return ch - $096bc2d75348a621$var$asciis._0; // '2' => 50-48
    if (ch >= $096bc2d75348a621$var$asciis.A && ch <= $096bc2d75348a621$var$asciis.F) return ch - ($096bc2d75348a621$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $096bc2d75348a621$var$asciis.a && ch <= $096bc2d75348a621$var$asciis.f) return ch - ($096bc2d75348a621$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $096bc2d75348a621$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $096bc2d75348a621$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $096bc2d75348a621$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
function $096bc2d75348a621$export$d609354794974f8(bytes) {
    return $096bc2d75348a621$export$d57f2bacc26b4249($096bc2d75348a621$export$58b867e287a802c8(bytes));
}
function $096bc2d75348a621$export$d67b1d03392107e7(bytes) {
    $096bc2d75348a621$export$e8a750b9efad93f5(bytes);
    return $096bc2d75348a621$export$d57f2bacc26b4249($096bc2d75348a621$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $096bc2d75348a621$export$1459dafd057611cb(n, len) {
    return $096bc2d75348a621$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $096bc2d75348a621$export$ba2172e58d139f6d(n, len) {
    return $096bc2d75348a621$export$1459dafd057611cb(n, len).reverse();
}
function $096bc2d75348a621$export$80ee8c1914de6dde(n) {
    return $096bc2d75348a621$export$31c96b9df38bc8d4($096bc2d75348a621$export$4ed2545b622827c1(n));
}
function $096bc2d75348a621$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $096bc2d75348a621$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(title + " must be hex string or Uint8Array, cause: " + e);
    }
    else if ($096bc2d75348a621$export$c6fabfbfd097fc30(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + " must be hex string or Uint8Array");
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(title + " of length " + expectedLength + " expected, got " + len);
    return res;
}
function $096bc2d75348a621$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $096bc2d75348a621$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $096bc2d75348a621$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $096bc2d75348a621$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const $096bc2d75348a621$var$isPosBig = (n)=>typeof n === "bigint" && $096bc2d75348a621$var$_0n <= n;
function $096bc2d75348a621$export$ddf89a9c5af38f94(n, min, max) {
    return $096bc2d75348a621$var$isPosBig(n) && $096bc2d75348a621$var$isPosBig(min) && $096bc2d75348a621$var$isPosBig(max) && min <= n && n < max;
}
function $096bc2d75348a621$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$096bc2d75348a621$export$ddf89a9c5af38f94(n, min, max)) throw new Error("expected valid " + title + ": " + min + " <= n < " + max + ", got " + n);
}
function $096bc2d75348a621$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $096bc2d75348a621$var$_0n; n >>= $096bc2d75348a621$var$_1n, len += 1);
    return len;
}
function $096bc2d75348a621$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $096bc2d75348a621$var$_1n;
}
function $096bc2d75348a621$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $096bc2d75348a621$var$_1n : $096bc2d75348a621$var$_0n) << BigInt(pos);
}
const $096bc2d75348a621$export$803efa2fa1c7279 = (n)=>($096bc2d75348a621$var$_2n << BigInt(n - 1)) - $096bc2d75348a621$var$_1n;
// DRBG
const $096bc2d75348a621$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $096bc2d75348a621$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $096bc2d75348a621$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $096bc2d75348a621$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $096bc2d75348a621$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $096bc2d75348a621$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($096bc2d75348a621$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($096bc2d75348a621$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $096bc2d75348a621$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $096bc2d75348a621$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $096bc2d75348a621$export$c6fabfbfd097fc30(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $096bc2d75348a621$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $096bc2d75348a621$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error("invalid validator function");
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error("param " + String(fieldName) + " is invalid. Expected " + type + ", got " + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
const $096bc2d75348a621$export$94a5f06e658f87e2 = ()=>{
    throw new Error("not implemented");
};
function $096bc2d75348a621$export$9756366f7cb6f62b(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});



parcelRegister("gJbOl", function(module, exports) {

var $br7kb = parcelRequire("br7kb");
const $c2da02b71e273c94$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $br7kb($c2da02b71e273c94$var$ALPHABET);

});
parcelRegister("br7kb", function(module, exports) {
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $8537e5cf6d93afaf$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $8537e5cf6d93afaf$var$base;

});


parcelRegister("4bt7m", function(module, exports) {

$parcel$export(module.exports, "SolanaSignAndSendTransaction", function () { return $30bec6acb53031c1$export$dd64f32469f35f81; });
/** Name of the feature. */ const $30bec6acb53031c1$export$dd64f32469f35f81 = "solana:signAndSendTransaction";

});

parcelRegister("840Oq", function(module, exports) {

$parcel$export(module.exports, "SolanaSignTransaction", function () { return $5def53c8e7b03394$export$54187c3796d0ecb; });
/** Name of the feature. */ const $5def53c8e7b03394$export$54187c3796d0ecb = "solana:signTransaction";

});

parcelRegister("5sd65", function(module, exports) {

$parcel$export(module.exports, "SolanaSignMessage", function () { return $3f89ba150df7441d$export$22c7939a38084172; });
/** Name of the feature. */ const $3f89ba150df7441d$export$22c7939a38084172 = "solana:signMessage";

});

parcelRegister("1ttxg", function(module, exports) {
/* UAParser.js v1.0.38
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.38", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("infFV", function(module, exports) {


module.exports = (parcelRequire("3WFuy"))((parcelRequire("gm4sb")).resolve("dsuua")).then(()=>parcelRequire("d3Itw"));

});

parcelRegister("eEFR0", function(module, exports) {


module.exports = (parcelRequire("3WFuy"))((parcelRequire("gm4sb")).resolve("6uGNf")).then(()=>parcelRequire("1Xp2o"));

});

parcelRegister("hA0xX", function(module, exports) {

$parcel$export(module.exports, "Tensor", function () { return wt; });
$parcel$export(module.exports, "Variable", function () { return St; });
$parcel$export(module.exports, "tidy", function () { return Ze; });
$parcel$export(module.exports, "tensor", function () { return Fn; });
$parcel$export(module.exports, "scalar", function () { return On; });
$parcel$export(module.exports, "tensor1d", function () { return Mn; });
$parcel$export(module.exports, "tensor2d", function () { return Bn; });
$parcel$export(module.exports, "tensor3d", function () { return Pn; });
$parcel$export(module.exports, "tensor4d", function () { return Ln; });
$parcel$export(module.exports, "zeros", function () { return Gn; });
$parcel$export(module.exports, "fill", function () { return Hn; });
$parcel$export(module.exports, "concat", function () { return Yn; });
$parcel$export(module.exports, "expandDims", function () { return wr; });
$parcel$export(module.exports, "reshape", function () { return Or; });
$parcel$export(module.exports, "tile", function () { return Lr; });
$parcel$export(module.exports, "pad", function () { return Ir; });
$parcel$export(module.exports, "stack", function () { return Pr; });
$parcel$export(module.exports, "unstack", function () { return Ur; });
$parcel$export(module.exports, "softmax", function () { return go; });
$parcel$export(module.exports, "clipByValue", function () { return hu; });
$parcel$export(module.exports, "exp", function () { return vu; });
$parcel$export(module.exports, "neg", function () { return wu; });
$parcel$export(module.exports, "sigmoid", function () { return Iu; });
$parcel$export(module.exports, "batchNorm", function () { return ju; });
$parcel$export(module.exports, "add", function () { return rc; });
$parcel$export(module.exports, "div", function () { return sc; });
$parcel$export(module.exports, "mul", function () { return gc; });
$parcel$export(module.exports, "sub", function () { return Cc; });
$parcel$export(module.exports, "conv2d", function () { return qc; });
$parcel$export(module.exports, "depthwiseConv2d", function () { return Yc; });
$parcel$export(module.exports, "separableConv2d", function () { return Jc; });
$parcel$export(module.exports, "matMul", function () { return el; });
$parcel$export(module.exports, "maxPool", function () { return hl; });
$parcel$export(module.exports, "avgPool", function () { return fl; });
$parcel$export(module.exports, "slice", function () { return ml; });
$parcel$export(module.exports, "slice3d", function () { return xl; });
$parcel$export(module.exports, "max", function () { return Sl; });
$parcel$export(module.exports, "relu", function () { return Bl; });
$parcel$export(module.exports, "transpose", function () { return Wl; });
$parcel$export(module.exports, "image", function () { return Oh; });
$parcel$export(module.exports, "io", function () { return ed; });
$parcel$export(module.exports, "browser", function () { return id; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $cmlvI = parcelRequire("cmlvI");

var $jtAZT = parcelRequire("jtAZT");
var $ccc6390119ecc6e0$require$Buffer = $jtAZT.Buffer;
var t = function(e, n) {
    return (t = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
    })(e, n);
};
function e(e, n) {
    function r() {
        this.constructor = e;
    }
    t(e, n), e.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r);
}
function n(t, e, n, r) {
    return new (n || (n = Promise))(function(o, a) {
        function i(t) {
            try {
                u(r.next(t));
            } catch (t) {
                a(t);
            }
        }
        function s(t) {
            try {
                u(r.throw(t));
            } catch (t) {
                a(t);
            }
        }
        function u(t) {
            t.done ? o(t.value) : new n(function(e) {
                e(t.value);
            }).then(i, s);
        }
        u((r = r.apply(t, e || [])).next());
    });
}
function r(t, e) {
    var n, r, o, a, i = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function s(a) {
        return function(s) {
            return function(a) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; i;)try {
                    if (n = 1, r && (o = 2 & a[0] ? r.return : a[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, a[1])).done) return o;
                    switch(r = 0, o && (a = [
                        2 & a[0],
                        o.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            o = a;
                            break;
                        case 4:
                            return i.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            i.label++, r = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(o = (o = i.trys).length > 0 && o[o.length - 1]) && (6 === a[0] || 2 === a[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                                i.label = a[1];
                                break;
                            }
                            if (6 === a[0] && i.label < o[1]) {
                                i.label = o[1], o = a;
                                break;
                            }
                            if (o && i.label < o[2]) {
                                i.label = o[2], i.ops.push(a);
                                break;
                            }
                            o[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    a = e.call(t, i);
                } catch (t) {
                    a = [
                        6,
                        t
                    ], r = 0;
                } finally{
                    n = o = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                s
            ]);
        };
    }
}
var o = function() {
    function t(t) {
        this.global = t, this.flags = {}, this.flagRegistry = {}, this.urlFlags = {}, this.populateURLFlags();
    }
    return t.prototype.setPlatform = function(t, e) {
        null != this.platform && console.warn("Platform " + this.platformName + " has already been set. Overwriting the platform with " + e + "."), this.platformName = t, this.platform = e;
    }, t.prototype.registerFlag = function(t, e, n) {
        if (this.flagRegistry[t] = {
            evaluationFn: e,
            setHook: n
        }, null != this.urlFlags[t]) {
            var r = this.urlFlags[t];
            console.warn("Setting feature override from URL " + t + ": " + r + "."), this.set(t, r);
        }
    }, t.prototype.get = function(t) {
        return t in this.flags ? this.flags[t] : (this.flags[t] = this.evaluateFlag(t), this.flags[t]);
    }, t.prototype.getNumber = function(t) {
        return this.get(t);
    }, t.prototype.getBool = function(t) {
        return this.get(t);
    }, t.prototype.getFlags = function() {
        return this.flags;
    }, Object.defineProperty(t.prototype, "features", {
        get: function() {
            return this.flags;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.set = function(t, e) {
        if (null == this.flagRegistry[t]) throw new Error("Cannot set flag " + t + " as it has not been registered.");
        this.flags[t] = e, null != this.flagRegistry[t].setHook && this.flagRegistry[t].setHook(e);
    }, t.prototype.evaluateFlag = function(t) {
        if (null == this.flagRegistry[t]) throw new Error("Cannot evaluate flag '" + t + "': no evaluation function found.");
        return this.flagRegistry[t].evaluationFn();
    }, t.prototype.setFlags = function(t) {
        this.flags = Object.assign({}, t);
    }, t.prototype.reset = function() {
        this.flags = {}, this.urlFlags = {}, this.populateURLFlags();
    }, t.prototype.populateURLFlags = function() {
        var t = this;
        if (void 0 !== this.global && void 0 !== this.global.location && void 0 !== this.global.location.search) {
            var e, n, r = (e = this.global.location.search, n = {}, e.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, function(t) {
                for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
                return a(n, e[0], e[1]), e.join("=");
            }), n);
            if ("tfjsflags" in r) r.tfjsflags.split(",").forEach(function(e) {
                var n = e.split(":"), r = n[0], o = n[1];
                t.urlFlags[r] = function(t, e) {
                    if ("true" === (e = e.toLowerCase()) || "false" === e) return "true" === e;
                    if ("" + +e === e) return +e;
                    throw new Error("Could not parse value flag value " + e + " for flag " + t + ".");
                }(r, o);
            });
        }
    }, t;
}();
function a(t, e, n) {
    t[decodeURIComponent(e)] = decodeURIComponent(n || "");
}
function i() {
    return s;
}
var s = null;
var u = new Map, c = new Map;
function l(t, e) {
    var n = g(t, e);
    return u.get(n);
}
function h(t) {
    return c.get(t);
}
function f(t) {
    for(var e = u.entries(), n = [];;){
        var r = e.next(), o = r.done, a = r.value;
        if (o) break;
        var i = a[0], s = a[1];
        i.split("_")[0] === t && n.push(s);
    }
    return n;
}
function d(t) {
    var e = t.kernelName, n = t.backendName, r = g(e, n);
    if (u.has(r)) throw new Error("The kernel '" + e + "' for backend '" + n + "' is already registered");
    u.set(r, t);
}
function p(t) {
    var e = t.kernelName;
    c.has(e) && console.warn("Overriding the gradient for '" + e + "'"), c.set(e, t);
}
function v(t, e) {
    var n = g(t, e);
    if (!u.has(n)) throw new Error("The kernel '" + t + "' for backend '" + e + "' is not registered");
    u.delete(n);
}
function m(t) {
    if (!c.has(t)) throw new Error("The gradient '" + t + "' for backend is not registered");
    c.delete(t);
}
function g(t, e) {
    return e + "_" + t;
}
function y(t) {
    for(var e = t.length, n = 0, r = 0; e > 0;)r = Math.random() * e | 0, n = t[--e], t[e] = t[r], t[r] = n;
}
function x(t, e, n) {
    return Math.max(t, Math.min(e, n));
}
function b(t) {
    return t % 2 == 0 ? t : t + 1;
}
function w(t) {
    for(var e = 0, n = 0; n < t.length; n++)e += t[n];
    return e;
}
function C(t, e) {
    if (!t) throw new Error("string" == typeof e ? e : e());
}
function E(t, e, n) {
    void 0 === n && (n = ""), C(S(t, e), function() {
        return n + " Shapes " + t + " and " + e + " must match";
    });
}
function R(t) {
    C(null != t, function() {
        return "The input to the tensor constructor must be a non-null value.";
    });
}
function I(t, e, n) {
    if (void 0 === e && (e = []), void 0 === n && (n = !1), null == e && (e = []), Array.isArray(t) || V(t) && !n) for(var r = 0; r < t.length; ++r)I(t[r], e, n);
    else e.push(t);
    return e;
}
function k(t) {
    if (0 === t.length) return 1;
    for(var e = t[0], n = 1; n < t.length; n++)e *= t[n];
    return e;
}
function S(t, e) {
    if (t === e) return !0;
    if (null == t || null == e) return !1;
    if (t.length !== e.length) return !1;
    for(var n = 0; n < t.length; n++)if (t[n] !== e[n]) return !1;
    return !0;
}
function A(t) {
    return t % 1 == 0;
}
function D(t) {
    if (null != Math.tanh) return Math.tanh(t);
    if (t === 1 / 0) return 1;
    if (t === -1 / 0) return -1;
    var e = Math.exp(2 * t);
    return (e - 1) / (e + 1);
}
function T(t) {
    var e = Math.ceil(Math.sqrt(t));
    return [
        e,
        Math.ceil(t / e)
    ];
}
function N(t, e) {
    return e <= t.length ? t : t + " ".repeat(e - t.length);
}
function F(t, e, n) {
    return void 0 === e && (e = function(t) {
        return 0;
    }), new Promise(function(r, o) {
        var a = 0, i = function() {
            if (t()) r();
            else {
                a++;
                var s = e(a);
                null != n && a >= n ? o() : setTimeout(i, s);
            }
        };
        i();
    });
}
function _(t, e) {
    for(var n = 1, r = -1, o = 0; o < t.length; ++o)if (t[o] >= 0) n *= t[o];
    else if (-1 === t[o]) {
        if (-1 !== r) throw Error("Shapes can only have 1 implicit size. Found -1 at dim " + r + " and dim " + o);
        r = o;
    } else if (t[o] < 0) throw Error("Shapes can not be < 0. Found " + t[o] + " at dim " + o);
    if (-1 === r) {
        if (e > 0 && e !== n) throw Error("Size(" + e + ") must match the product of shape " + t);
        return t;
    }
    if (0 === n) throw Error("Cannot infer the missing size in [" + t + "] when there are 0 elements");
    if (e % n != 0) throw Error("The implicit shape can't be a fractional number. Got " + e + " / " + n);
    var a = t.slice();
    return a[r] = e / n, a;
}
function O(t, e) {
    var n = e.length;
    return C((t = null == t ? e.map(function(t, e) {
        return e;
    }) : [].concat(t)).every(function(t) {
        return t >= -n && t < n;
    }), function() {
        return "All values in axis param must be in range [-" + n + ", " + n + ") but got axis " + t;
    }), C(t.every(function(t) {
        return A(t);
    }), function() {
        return "All values in axis param must be integers but got axis " + t;
    }), t.map(function(t) {
        return t < 0 ? n + t : t;
    });
}
function M(t, e) {
    for(var n = [], r = [], o = null != e && Array.isArray(e) && 0 === e.length, a = null == e || o ? null : O(e, t).sort(), i = 0, s = 0; s < t.length; ++s){
        if (null != a) {
            if (a[i] === s && 1 !== t[s]) throw new Error("Can't squeeze axis " + s + " since its dim '" + t[s] + "' is not 1");
            (null == a[i] || a[i] > s) && 1 === t[s] && (n.push(t[s]), r.push(s)), a[i] <= s && i++;
        }
        1 !== t[s] && (n.push(t[s]), r.push(s));
    }
    return {
        newShape: n,
        keptDims: r
    };
}
function B(t, e) {
    var n = null;
    if (null == t || "float32" === t) n = new Float32Array(e);
    else if ("int32" === t) n = new Int32Array(e);
    else {
        if ("bool" !== t) throw new Error("Unknown data type " + t);
        n = new Uint8Array(e);
    }
    return n;
}
function P(t, e) {
    var n = null;
    if (null == t || "float32" === t) n = new Float32Array(e);
    else if ("int32" === t) n = new Int32Array(e);
    else if ("bool" === t) n = new Uint8Array(e);
    else {
        if ("string" !== t) throw new Error("Unknown data type " + t);
        n = new Array(e);
    }
    return n;
}
function L(t, e) {
    for(var n = 0; n < t.length; n++){
        var r = t[n];
        if (isNaN(r) || !isFinite(r)) throw Error("A tensor of type " + e + " being uploaded contains " + r + ".");
    }
}
function W(t) {
    return "bool" === t || "complex64" === t || "float32" === t || "int32" === t || "string" === t;
}
function U(t, e) {
    return "complex64" !== e && ("float32" !== e || "complex64" === t) && ("int32" !== e || "float32" === t || "complex64" === t) && ("bool" !== e || "bool" !== t);
}
function V(t) {
    return t instanceof Float32Array || t instanceof Int32Array || t instanceof Uint8Array;
}
function z(t) {
    if ("float32" === t || "int32" === t) return 4;
    if ("complex64" === t) return 8;
    if ("bool" === t) return 1;
    throw new Error("Unknown dtype " + t);
}
function G(t) {
    if (null == t) return 0;
    var e = 0;
    return t.forEach(function(t) {
        return e += t.length;
    }), e;
}
function H(t) {
    return "string" == typeof t || t instanceof String;
}
function q(t) {
    return "boolean" == typeof t;
}
function K(t) {
    return "number" == typeof t;
}
function j(t) {
    return Array.isArray(t) ? j(t[0]) : t instanceof Float32Array ? "float32" : t instanceof Int32Array || t instanceof Uint8Array ? "int32" : K(t) ? "float32" : H(t) ? "string" : q(t) ? "bool" : "float32";
}
function X(t) {
    return !!(t && t.constructor && t.call && t.apply);
}
function Y(t, e) {
    for(var n = e; n < t; ++n)if (t % n == 0) return n;
    return t;
}
function $(t) {
    var e = t.length;
    if (e < 2) return [];
    var n = new Array(e - 1);
    n[e - 2] = t[e - 1];
    for(var r = e - 3; r >= 0; --r)n[r] = n[r + 1] * t[r + 1];
    return n;
}
function Q(t, e, n) {
    if ("string" === e) throw new Error("Cannot convert a string[] to a TypedArray");
    if (Array.isArray(t) && (t = I(t)), n && L(t, e), function(t, e) {
        return t instanceof Float32Array && "float32" === e || t instanceof Int32Array && "int32" === e || t instanceof Uint8Array && "bool" === e;
    }(t, e)) return t;
    if (null == e || "float32" === e || "complex64" === e) return new Float32Array(t);
    if ("int32" === e) return new Int32Array(t);
    if ("bool" === e) {
        for(var r = new Uint8Array(t.length), o = 0; o < r.length; ++o)0 !== Math.round(t[o]) && (r[o] = 1);
        return r;
    }
    throw new Error("Unknown data type " + e);
}
function J(t, e) {
    if (0 === t.length) return e[0];
    var n = t.reduce(function(t, e) {
        return t * e;
    });
    if (0 === n) return [];
    if (n !== e.length) throw new Error("[" + t + "] does not match the input size.");
    return function t(e, n, r) {
        var o = new Array;
        if (1 === n.length) for(var a = n[0], i = 0; i < a; i++)o[i] = r[e + i];
        else {
            a = n[0];
            var s = n.slice(1), u = s.reduce(function(t, e) {
                return t * e;
            });
            for(i = 0; i < a; i++)o[i] = t(e + i * u, s, r);
        }
        return o;
    }(0, t, e);
}
function Z(t, e) {
    for(var n = tt(t, e), r = 0; r < n.length; r++)n[r] = 1;
    return n;
}
function tt(t, e) {
    if (null == e || "float32" === e || "complex64" === e) return new Float32Array(t);
    if ("int32" === e) return new Int32Array(t);
    if ("bool" === e) return new Uint8Array(t);
    throw new Error("Unknown data type " + e);
}
function et() {
    return i().platform.now();
}
function nt(t) {
    t.forEach(function(e) {
        C(Number.isInteger(e) && e >= 0, function() {
            return "Tensor must have a shape comprised of positive integers but got shape [" + t + "].";
        });
    });
}
function rt(t, e) {
    return void 0 === e && (e = "utf-8"), e = e || "utf-8", i().platform.encode(t, e);
}
function ot(t, e) {
    return void 0 === e && (e = "utf-8"), e = e || "utf-8", i().platform.decode(t, e);
}
function at(t, e, n) {
    if (0 === e) return 0;
    if (1 === e) return t[0];
    for(var r = t[t.length - 1], o = 0; o < t.length - 1; ++o)r += n[o] * t[o];
    return r;
}
function it(t, e, n) {
    if (0 === e) return [];
    if (1 === e) return [
        t
    ];
    for(var r = new Array(e), o = 0; o < r.length - 1; ++o)r[o] = Math.floor(t / n[o]), t -= r[o] * n[o];
    return r[r.length - 1] = t, r;
}
var st = Object.freeze({
    shuffle: y,
    clamp: x,
    nearestLargerEven: b,
    sum: w,
    randUniform: function(t, e) {
        var n = Math.random();
        return e * n + (1 - n) * t;
    },
    distSquared: function(t, e) {
        for(var n = 0, r = 0; r < t.length; r++){
            var o = Number(t[r]) - Number(e[r]);
            n += o * o;
        }
        return n;
    },
    assert: C,
    assertShapesMatch: E,
    assertNonNull: R,
    flatten: I,
    sizeFromShape: k,
    isScalarShape: function(t) {
        return 0 === t.length;
    },
    arraysEqual: S,
    isInt: A,
    tanh: D,
    sizeToSquarishShape: T,
    createShuffledIndices: function(t) {
        for(var e = new Uint32Array(t), n = 0; n < t; ++n)e[n] = n;
        return y(e), e;
    },
    rightPad: N,
    repeatedTry: F,
    inferFromImplicitShape: _,
    parseAxisParam: O,
    squeezeShape: M,
    getTypedArrayFromDType: B,
    getArrayFromDType: P,
    checkConversionForErrors: L,
    isValidDtype: W,
    hasEncodingLoss: U,
    isTypedArray: V,
    bytesPerElement: z,
    bytesFromStringArray: G,
    isString: H,
    isBoolean: q,
    isNumber: K,
    inferDtype: j,
    isFunction: X,
    nearestDivisor: Y,
    computeStrides: $,
    toTypedArray: Q,
    toNestedArray: J,
    makeOnesTypedArray: Z,
    makeZerosTypedArray: tt,
    now: et,
    assertNonNegativeIntegerDimensions: nt,
    fetch: function(t, e) {
        return i().platform.fetch(t, e);
    },
    encodeString: rt,
    decodeString: ot,
    locToIndex: at,
    indexToLoc: it
}), ut = function() {
    function t(t, e) {
        this.backendTimer = t, this.logger = e, null == e && (this.logger = new ct);
    }
    return t.prototype.profileKernel = function(t, e, n) {
        var r, o = this, a = this.backendTimer.time(function() {
            r = n();
        });
        return r.forEach(function(n) {
            n.data().then(function(r) {
                !function(t, e, n) {
                    if ("float32" !== e) return !1;
                    for(var r = 0; r < t.length; r++){
                        var o = t[r];
                        if (isNaN(o) || !isFinite(o)) return console.warn("Found " + o + " in the result of '" + n + "'"), !0;
                    }
                }(r, n.dtype, t), a.then(function(a) {
                    var i = "";
                    null != a.getExtraProfileInfo && (i = a.getExtraProfileInfo()), o.logger.logKernelProfile(t, n, r, a.kernelMs, e, i);
                });
            });
        }), r;
    }, t;
}();
var ct = function() {
    function t() {}
    return t.prototype.logKernelProfile = function(t, e, n, r, o, a) {
        var i = "number" == typeof r ? N(r + "ms", 9) : r.error, s = N(t, 25), u = e.rank, c = e.size, l = N(e.shape.toString(), 14), h = "";
        for(var f in o){
            var d = o[f].shape || e.shape, p = d.length;
            h += f + ": " + p + "D " + (p > 0 ? d : "") + " ";
        }
        console.log("%c" + s + "	%c" + i + "	%c" + u + "D " + l + "	%c" + c + "	%c" + h + "	%c" + a, "font-weight:bold", "color:red", "color:blue", "color: orange", "color: green", "color: steelblue");
    }, t;
}();
var lt = 20, ht = 3, ft = 7;
function dt(t, e, n, r) {
    var o = $(e), a = function(t, e, n, r) {
        var o = k(e), a = r[r.length - 1], i = new Array(a).fill(0), s = e.length, u = "complex64" === n ? mt(t) : t;
        if (s > 1) for(var c = 0; c < o / a; c++)for(var l = c * a, h = 0; h < a; h++)i[h] = Math.max(i[h], pt(u[l + h], 0, n).length);
        return i;
    }(t, e, n, o), i = e.length, s = function t(e, n, r, o, a, i) {
        void 0 === i && (i = !0);
        var s = "complex64" === r ? 2 : 1, u = n[0], c = n.length;
        if (0 === c) return "complex64" === r ? [
            pt(mt(e)[0], 0, r)
        ] : "bool" === r ? [
            vt(e[0])
        ] : [
            e[0].toString()
        ];
        if (1 === c) {
            if (u > lt) {
                var l = ht * s, h = Array.from(e.slice(0, l)), f = Array.from(e.slice((u - ht) * s, u * s));
                return "complex64" === r && (h = mt(h), f = mt(f)), [
                    "[" + h.map(function(t, e) {
                        return pt(t, a[e], r);
                    }).join(", ") + ", ..., " + f.map(function(t, e) {
                        return pt(t, a[u - ht + e], r);
                    }).join(", ") + "]"
                ];
            }
            return [
                "[" + ("complex64" === r ? mt(e) : Array.from(e)).map(function(t, e) {
                    return pt(t, a[e], r);
                }).join(", ") + "]"
            ];
        }
        var d = n.slice(1), p = o.slice(1), v = o[0] * s, m = [];
        if (u > lt) {
            for(var g = 0; g < ht; g++){
                var y = (x = g * v) + v;
                m.push.apply(m, t(e.slice(x, y), d, r, p, a, !1));
            }
            m.push("...");
            for(g = u - ht; g < u; g++){
                y = (x = g * v) + v;
                m.push.apply(m, t(e.slice(x, y), d, r, p, a, g === u - 1));
            }
        } else for(g = 0; g < u; g++){
            var x;
            y = (x = g * v) + v;
            m.push.apply(m, t(e.slice(x, y), d, r, p, a, g === u - 1));
        }
        var b = 2 === c ? "," : "";
        m[0] = "[" + m[0] + b;
        for(g = 1; g < m.length - 1; g++)m[g] = " " + m[g] + b;
        var w = ",\n";
        for(g = 2; g < c; g++)w += "\n";
        return m[m.length - 1] = " " + m[m.length - 1] + "]" + (i ? "" : w), m;
    }(t, e, n, o, a), u = [
        "Tensor"
    ];
    return r && (u.push("  dtype: " + n), u.push("  rank: " + i), u.push("  shape: [" + e + "]"), u.push("  values:")), u.push(s.map(function(t) {
        return "    " + t;
    }).join("\n")), u.join("\n");
}
function pt(t, e, n) {
    return N(Array.isArray(t) ? parseFloat(t[0].toFixed(ft)) + " + " + parseFloat(t[1].toFixed(ft)) + "j" : H(t) ? "'" + t + "'" : "bool" === n ? vt(t) : parseFloat(t.toFixed(ft)).toString(), e);
}
function vt(t) {
    return 0 === t ? "false" : "true";
}
function mt(t) {
    for(var e = [], n = 0; n < t.length; n += 2)e.push([
        t[n],
        t[n + 1]
    ]);
    return e;
}
var gt = function() {
    function t(t, e, n) {
        var r = this;
        if (this.dtype = e, this.shape = t.slice(), this.size = k(t), null != n) {
            var o = n.length;
            C(o === this.size, function() {
                return "Length of values '" + o + "' does not match the size inferred by the shape '" + r.size + "'.";
            });
        }
        if ("complex64" === e) throw new Error("complex64 dtype TensorBuffers are not supported. Please create a TensorBuffer for the real and imaginary parts separately and call tf.complex(real, imag).");
        this.values = n || P(e, this.size), this.strides = $(t);
    }
    return t.prototype.set = function(t) {
        for(var e = this, n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
        0 === n.length && (n = [
            0
        ]), C(n.length === this.rank, function() {
            return "The number of provided coordinates (" + n.length + ") must match the rank (" + e.rank + ")";
        });
        var o = this.locToIndex(n);
        this.values[o] = t;
    }, t.prototype.get = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        0 === t.length && (t = [
            0
        ]);
        for(var n = 0, r = 0, o = t; r < o.length; r++){
            var a = o[r];
            if (a < 0 || a >= this.shape[n]) {
                var i = "Requested out of range element at " + t + ".   Buffer shape=" + this.shape;
                throw new Error(i);
            }
            n++;
        }
        for(var s = t[t.length - 1], u = 0; u < t.length - 1; ++u)s += this.strides[u] * t[u];
        return this.values[s];
    }, t.prototype.locToIndex = function(t) {
        if (0 === this.rank) return 0;
        if (1 === this.rank) return t[0];
        for(var e = t[t.length - 1], n = 0; n < t.length - 1; ++n)e += this.strides[n] * t[n];
        return e;
    }, t.prototype.indexToLoc = function(t) {
        if (0 === this.rank) return [];
        if (1 === this.rank) return [
            t
        ];
        for(var e = new Array(this.shape.length), n = 0; n < e.length - 1; ++n)e[n] = Math.floor(t / this.strides[n]), t -= e[n] * this.strides[n];
        return e[e.length - 1] = t, e;
    }, Object.defineProperty(t.prototype, "rank", {
        get: function() {
            return this.shape.length;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.toTensor = function() {
        return yt().makeTensor(this.values, this.shape, this.dtype);
    }, t;
}(), yt = null, xt = null, bt = null;
var wt = function() {
    function t(t, e, n, r) {
        this.kept = !1, this.isDisposedInternal = !1, this.shape = t.slice(), this.dtype = e || "float32", this.size = k(t), this.strides = $(t), this.dataId = n, this.id = r, this.rankType = this.rank < 5 ? this.rank.toString() : "higher";
    }
    return t.prototype.flatten = function() {
        return this.throwIfDisposed(), this.as1D();
    }, t.prototype.asScalar = function() {
        return this.throwIfDisposed(), C(1 === this.size, function() {
            return "The array must have only 1 element.";
        }), this.reshape([]);
    }, t.prototype.as1D = function() {
        return this.throwIfDisposed(), this.reshape([
            this.size
        ]);
    }, t.prototype.as2D = function(t, e) {
        return this.throwIfDisposed(), this.reshape([
            t,
            e
        ]);
    }, t.prototype.as3D = function(t, e, n) {
        return this.throwIfDisposed(), this.reshape([
            t,
            e,
            n
        ]);
    }, t.prototype.as4D = function(t, e, n, r) {
        return this.throwIfDisposed(), this.reshape([
            t,
            e,
            n,
            r
        ]);
    }, t.prototype.as5D = function(t, e, n, r, o) {
        return this.throwIfDisposed(), this.reshape([
            t,
            e,
            n,
            r,
            o
        ]);
    }, t.prototype.asType = function(t) {
        return this.throwIfDisposed(), xt.cast(this, t);
    }, Object.defineProperty(t.prototype, "rank", {
        get: function() {
            return this.shape.length;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.buffer = function() {
        return n(this, void 0, void 0, function() {
            var t;
            return r(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.data()
                        ];
                    case 1:
                        return t = e.sent(), [
                            2,
                            xt.buffer(this.shape, this.dtype, t)
                        ];
                }
            });
        });
    }, t.prototype.bufferSync = function() {
        return xt.buffer(this.shape, this.dtype, this.dataSync());
    }, t.prototype.array = function() {
        return n(this, void 0, void 0, function() {
            var t;
            return r(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.data()
                        ];
                    case 1:
                        return t = e.sent(), [
                            2,
                            J(this.shape, t)
                        ];
                }
            });
        });
    }, t.prototype.arraySync = function() {
        return J(this.shape, this.dataSync());
    }, t.prototype.data = function() {
        return n(this, void 0, void 0, function() {
            var t, e;
            return r(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.throwIfDisposed(), t = yt().read(this.dataId), "string" !== this.dtype ? [
                            3,
                            2
                        ] : [
                            4,
                            t
                        ];
                    case 1:
                        e = n.sent();
                        try {
                            return [
                                2,
                                e.map(function(t) {
                                    return ot(t);
                                })
                            ];
                        } catch (t) {
                            throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
                        }
                        n.label = 2;
                    case 2:
                        return [
                            2,
                            t
                        ];
                }
            });
        });
    }, t.prototype.dataSync = function() {
        this.throwIfDisposed();
        var t = yt().readSync(this.dataId);
        if ("string" === this.dtype) try {
            return t.map(function(t) {
                return ot(t);
            });
        } catch (t) {
            throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
        }
        return t;
    }, t.prototype.bytes = function() {
        return n(this, void 0, void 0, function() {
            var t;
            return r(this, function(e) {
                switch(e.label){
                    case 0:
                        return this.throwIfDisposed(), [
                            4,
                            yt().read(this.dataId)
                        ];
                    case 1:
                        return t = e.sent(), "string" === this.dtype ? [
                            2,
                            t
                        ] : [
                            2,
                            new Uint8Array(t.buffer)
                        ];
                }
            });
        });
    }, t.prototype.dispose = function() {
        this.isDisposed || (yt().disposeTensor(this), this.isDisposedInternal = !0);
    }, Object.defineProperty(t.prototype, "isDisposed", {
        get: function() {
            return this.isDisposedInternal;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.throwIfDisposed = function() {
        if (this.isDisposed) throw new Error("Tensor is disposed.");
    }, t.prototype.toFloat = function() {
        return this.asType("float32");
    }, t.prototype.toInt = function() {
        return this.asType("int32");
    }, t.prototype.toBool = function() {
        return this.asType("bool");
    }, t.prototype.print = function(t) {
        return void 0 === t && (t = !1), xt.print(this, t);
    }, t.prototype.reshape = function(t) {
        return this.throwIfDisposed(), xt.reshape(this, t);
    }, t.prototype.reshapeAs = function(t) {
        return this.throwIfDisposed(), this.reshape(t.shape);
    }, t.prototype.expandDims = function(t) {
        return void 0 === t && (t = 0), xt.expandDims(this, t);
    }, t.prototype.cumsum = function(t, e, n) {
        return void 0 === t && (t = 0), void 0 === e && (e = !1), void 0 === n && (n = !1), xt.cumsum(this, t, e, n);
    }, t.prototype.squeeze = function(t) {
        return this.throwIfDisposed(), xt.squeeze(this, t);
    }, t.prototype.clone = function() {
        return this.throwIfDisposed(), xt.clone(this);
    }, t.prototype.oneHot = function(t, e, n) {
        return this.throwIfDisposed(), xt.oneHot(this, t, e, n);
    }, t.prototype.toString = function(t) {
        return void 0 === t && (t = !1), dt(this.dataSync(), this.shape, this.dtype, t);
    }, t.prototype.tile = function(t) {
        return this.throwIfDisposed(), xt.tile(this, t);
    }, t.prototype.gather = function(t, e) {
        return void 0 === e && (e = 0), this.throwIfDisposed(), xt.gather(this, t, e);
    }, t.prototype.matMul = function(t, e, n) {
        return void 0 === e && (e = !1), void 0 === n && (n = !1), this.throwIfDisposed(), xt.matMul(this, t, e, n);
    }, t.prototype.dot = function(t) {
        return this.throwIfDisposed(), xt.dot(this, t);
    }, t.prototype.norm = function(t, e, n) {
        return void 0 === t && (t = "euclidean"), void 0 === e && (e = null), void 0 === n && (n = !1), this.throwIfDisposed(), xt.norm(this, t, e, n);
    }, t.prototype.slice = function(t, e) {
        return this.throwIfDisposed(), xt.slice(this, t, e);
    }, t.prototype.reverse = function(t) {
        return this.throwIfDisposed(), xt.reverse(this, t);
    }, t.prototype.concat = function(e, n) {
        return void 0 === n && (n = 0), this.throwIfDisposed(), e instanceof t && (e = [
            e
        ]), xt.concat([
            this
        ].concat(e), n);
    }, t.prototype.split = function(t, e) {
        return void 0 === e && (e = 0), this.throwIfDisposed(), xt.split(this, t, e);
    }, t.prototype.stack = function(t, e) {
        return void 0 === e && (e = 0), xt.stack([
            this,
            t
        ], e);
    }, t.prototype.unstack = function(t) {
        return void 0 === t && (t = 0), xt.unstack(this, t);
    }, t.prototype.pad = function(t, e) {
        return void 0 === e && (e = 0), xt.pad(this, t, e);
    }, t.prototype.batchNormalization = function(t, e, n, r, o) {
        return void 0 === n && (n = .001), bt("tf.batchNormalization() is going away. Use tf.batchNorm() instead, and note the positional argument change of scale, offset, and varianceEpsilon"), this.batchNorm(t, e, o, r, n);
    }, t.prototype.batchNorm = function(t, e, n, r, o) {
        return void 0 === o && (o = .001), this.throwIfDisposed(), xt.batchNorm(this, t, e, n, r, o);
    }, t.prototype.all = function(t, e) {
        return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), xt.all(this, t, e);
    }, t.prototype.any = function(t, e) {
        return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), xt.any(this, t, e);
    }, t.prototype.logSumExp = function(t, e) {
        return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), xt.logSumExp(this, t, e);
    }, t.prototype.sum = function(t, e) {
        return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), xt.sum(this, t, e);
    }, t.prototype.prod = function(t, e) {
        return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), xt.prod(this, t, e);
    }, t.prototype.mean = function(t, e) {
        return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), xt.mean(this, t, e);
    }, t.prototype.min = function(t, e) {
        return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), xt.min(this, t, e);
    }, t.prototype.max = function(t, e) {
        return void 0 === t && (t = null), void 0 === e && (e = !1), this.throwIfDisposed(), xt.max(this, t, e);
    }, t.prototype.argMin = function(t) {
        return void 0 === t && (t = null), this.throwIfDisposed(), xt.argMin(this, t);
    }, t.prototype.argMax = function(t) {
        return void 0 === t && (t = null), this.throwIfDisposed(), xt.argMax(this, t);
    }, t.prototype.cast = function(t) {
        return this.throwIfDisposed(), xt.cast(this, t);
    }, t.prototype.add = function(t) {
        return this.throwIfDisposed(), xt.add(this, t);
    }, t.prototype.addStrict = function(t) {
        return this.throwIfDisposed(), xt.addStrict(this, t);
    }, t.prototype.atan2 = function(t) {
        return this.throwIfDisposed(), xt.atan2(this, t);
    }, t.prototype.sub = function(t) {
        return this.throwIfDisposed(), xt.sub(this, t);
    }, t.prototype.subStrict = function(t) {
        return this.throwIfDisposed(), xt.subStrict(this, t);
    }, t.prototype.pow = function(t) {
        return this.throwIfDisposed(), xt.pow(this, t);
    }, t.prototype.powStrict = function(t) {
        return this.throwIfDisposed(), xt.powStrict(this, t);
    }, t.prototype.mul = function(t) {
        return this.throwIfDisposed(), xt.mul(this, t);
    }, t.prototype.mulStrict = function(t) {
        return this.throwIfDisposed(), xt.mulStrict(this, t);
    }, t.prototype.div = function(t) {
        return this.throwIfDisposed(), xt.div(this, t);
    }, t.prototype.divNoNan = function(t) {
        return this.throwIfDisposed(), xt.divNoNan(this, t);
    }, t.prototype.floorDiv = function(t) {
        return this.throwIfDisposed(), xt.floorDiv(this, t);
    }, t.prototype.divStrict = function(t) {
        return this.throwIfDisposed(), xt.divStrict(this, t);
    }, t.prototype.minimum = function(t) {
        return this.throwIfDisposed(), xt.minimum(this, t);
    }, t.prototype.minimumStrict = function(t) {
        return this.throwIfDisposed(), xt.minimumStrict(this, t);
    }, t.prototype.maximum = function(t) {
        return this.throwIfDisposed(), xt.maximum(this, t);
    }, t.prototype.maximumStrict = function(t) {
        return this.throwIfDisposed(), xt.maximumStrict(this, t);
    }, t.prototype.mod = function(t) {
        return this.throwIfDisposed(), xt.mod(this, t);
    }, t.prototype.modStrict = function(t) {
        return this.throwIfDisposed(), xt.modStrict(this, t);
    }, t.prototype.squaredDifferenceStrict = function(t) {
        return this.throwIfDisposed(), xt.squaredDifferenceStrict(this, t);
    }, t.prototype.transpose = function(t) {
        return this.throwIfDisposed(), xt.transpose(this, t);
    }, t.prototype.notEqual = function(t) {
        return this.throwIfDisposed(), xt.notEqual(this, t);
    }, t.prototype.notEqualStrict = function(t) {
        return this.throwIfDisposed(), xt.notEqualStrict(this, t);
    }, t.prototype.less = function(t) {
        return this.throwIfDisposed(), xt.less(this, t);
    }, t.prototype.lessStrict = function(t) {
        return this.throwIfDisposed(), xt.lessStrict(this, t);
    }, t.prototype.equal = function(t) {
        return this.throwIfDisposed(), xt.equal(this, t);
    }, t.prototype.equalStrict = function(t) {
        return this.throwIfDisposed(), xt.equalStrict(this, t);
    }, t.prototype.lessEqual = function(t) {
        return this.throwIfDisposed(), xt.lessEqual(this, t);
    }, t.prototype.lessEqualStrict = function(t) {
        return this.throwIfDisposed(), xt.lessEqualStrict(this, t);
    }, t.prototype.greater = function(t) {
        return this.throwIfDisposed(), xt.greater(this, t);
    }, t.prototype.greaterStrict = function(t) {
        return this.throwIfDisposed(), xt.greaterStrict(this, t);
    }, t.prototype.greaterEqual = function(t) {
        return this.throwIfDisposed(), xt.greaterEqual(this, t);
    }, t.prototype.greaterEqualStrict = function(t) {
        return this.throwIfDisposed(), xt.greaterEqualStrict(this, t);
    }, t.prototype.logicalAnd = function(t) {
        return this.throwIfDisposed(), xt.logicalAnd(this, t);
    }, t.prototype.logicalOr = function(t) {
        return this.throwIfDisposed(), xt.logicalOr(this, t);
    }, t.prototype.logicalNot = function() {
        return this.throwIfDisposed(), xt.logicalNot(this);
    }, t.prototype.logicalXor = function(t) {
        return this.throwIfDisposed(), xt.logicalXor(this, t);
    }, t.prototype.where = function(t, e) {
        return this.throwIfDisposed(), xt.where(t, this, e);
    }, t.prototype.neg = function() {
        return this.throwIfDisposed(), xt.neg(this);
    }, t.prototype.ceil = function() {
        return this.throwIfDisposed(), xt.ceil(this);
    }, t.prototype.floor = function() {
        return this.throwIfDisposed(), xt.floor(this);
    }, t.prototype.sign = function() {
        return this.throwIfDisposed(), xt.sign(this);
    }, t.prototype.isNaN = function() {
        return this.throwIfDisposed(), xt.isNaN(this);
    }, t.prototype.isInf = function() {
        return this.throwIfDisposed(), xt.isInf(this);
    }, t.prototype.isFinite = function() {
        return this.throwIfDisposed(), xt.isFinite(this);
    }, t.prototype.exp = function() {
        return this.throwIfDisposed(), xt.exp(this);
    }, t.prototype.expm1 = function() {
        return this.throwIfDisposed(), xt.expm1(this);
    }, t.prototype.log = function() {
        return this.throwIfDisposed(), xt.log(this);
    }, t.prototype.log1p = function() {
        return this.throwIfDisposed(), xt.log1p(this);
    }, t.prototype.sqrt = function() {
        return this.throwIfDisposed(), xt.sqrt(this);
    }, t.prototype.rsqrt = function() {
        return this.throwIfDisposed(), xt.rsqrt(this);
    }, t.prototype.square = function() {
        return this.throwIfDisposed(), xt.square(this);
    }, t.prototype.reciprocal = function() {
        return this.throwIfDisposed(), xt.reciprocal(this);
    }, t.prototype.abs = function() {
        return this.throwIfDisposed(), xt.abs(this);
    }, t.prototype.clipByValue = function(t, e) {
        return this.throwIfDisposed(), xt.clipByValue(this, t, e);
    }, t.prototype.relu = function() {
        return this.throwIfDisposed(), xt.relu(this);
    }, t.prototype.relu6 = function() {
        return this.throwIfDisposed(), xt.relu6(this);
    }, t.prototype.elu = function() {
        return this.throwIfDisposed(), xt.elu(this);
    }, t.prototype.selu = function() {
        return this.throwIfDisposed(), xt.selu(this);
    }, t.prototype.leakyRelu = function(t) {
        return void 0 === t && (t = .2), this.throwIfDisposed(), xt.leakyRelu(this, t);
    }, t.prototype.prelu = function(t) {
        return this.throwIfDisposed(), xt.prelu(this, t);
    }, t.prototype.sigmoid = function() {
        return this.throwIfDisposed(), xt.sigmoid(this);
    }, t.prototype.logSigmoid = function() {
        return this.throwIfDisposed(), xt.logSigmoid(this);
    }, t.prototype.softplus = function() {
        return this.throwIfDisposed(), xt.softplus(this);
    }, t.prototype.zerosLike = function() {
        return this.throwIfDisposed(), xt.zerosLike(this);
    }, t.prototype.onesLike = function() {
        return this.throwIfDisposed(), xt.onesLike(this);
    }, t.prototype.sin = function() {
        return this.throwIfDisposed(), xt.sin(this);
    }, t.prototype.cos = function() {
        return this.throwIfDisposed(), xt.cos(this);
    }, t.prototype.tan = function() {
        return this.throwIfDisposed(), xt.tan(this);
    }, t.prototype.asin = function() {
        return this.throwIfDisposed(), xt.asin(this);
    }, t.prototype.acos = function() {
        return this.throwIfDisposed(), xt.acos(this);
    }, t.prototype.atan = function() {
        return this.throwIfDisposed(), xt.atan(this);
    }, t.prototype.sinh = function() {
        return this.throwIfDisposed(), xt.sinh(this);
    }, t.prototype.cosh = function() {
        return this.throwIfDisposed(), xt.cosh(this);
    }, t.prototype.tanh = function() {
        return this.throwIfDisposed(), xt.tanh(this);
    }, t.prototype.asinh = function() {
        return this.throwIfDisposed(), xt.asinh(this);
    }, t.prototype.acosh = function() {
        return this.throwIfDisposed(), xt.acosh(this);
    }, t.prototype.atanh = function() {
        return this.throwIfDisposed(), xt.atanh(this);
    }, t.prototype.erf = function() {
        return this.throwIfDisposed(), xt.erf(this);
    }, t.prototype.round = function() {
        return this.throwIfDisposed(), xt.round(this);
    }, t.prototype.step = function(t) {
        return void 0 === t && (t = 0), this.throwIfDisposed(), xt.step(this, t);
    }, t.prototype.softmax = function(t) {
        return void 0 === t && (t = -1), this.throwIfDisposed(), xt.softmax(this, t);
    }, t.prototype.logSoftmax = function(t) {
        return void 0 === t && (t = -1), this.throwIfDisposed(), xt.logSoftmax(this, t);
    }, t.prototype.resizeBilinear = function(t, e) {
        return void 0 === e && (e = !1), this.throwIfDisposed(), xt.image.resizeBilinear(this, t, e);
    }, t.prototype.resizeNearestNeighbor = function(t, e) {
        return void 0 === e && (e = !1), this.throwIfDisposed(), xt.image.resizeNearestNeighbor(this, t, e);
    }, t.prototype.conv1d = function(t, e, n, r, o, a) {
        return void 0 === r && (r = "NWC"), void 0 === o && (o = 1), this.throwIfDisposed(), xt.conv1d(this, t, e, n, r, o, a);
    }, t.prototype.conv2d = function(t, e, n, r, o, a) {
        return void 0 === r && (r = "NHWC"), void 0 === o && (o = [
            1,
            1
        ]), this.throwIfDisposed(), xt.conv2d(this, t, e, n, r, o, a);
    }, t.prototype.conv2dTranspose = function(t, e, n, r, o) {
        return this.throwIfDisposed(), xt.conv2dTranspose(this, t, e, n, r, o);
    }, t.prototype.depthwiseConv2D = function(t, e, n, r, o, a) {
        return void 0 === r && (r = "NHWC"), void 0 === o && (o = [
            1,
            1
        ]), this.throwIfDisposed(), xt.depthwiseConv2d(this, t, e, n, r, o, a);
    }, t.prototype.separableConv2d = function(t, e, n, r, o, a) {
        return void 0 === o && (o = [
            1,
            1
        ]), void 0 === a && (a = "NHWC"), this.throwIfDisposed(), xt.separableConv2d(this, t, e, n, r, o, a);
    }, t.prototype.avgPool = function(t, e, n, r) {
        return this.throwIfDisposed(), xt.avgPool(this, t, e, n, r);
    }, t.prototype.maxPool = function(t, e, n, r) {
        return this.throwIfDisposed(), xt.maxPool(this, t, e, n, r);
    }, t.prototype.localResponseNormalization = function(t, e, n, r) {
        return void 0 === t && (t = 5), void 0 === e && (e = 1), void 0 === n && (n = 1), void 0 === r && (r = .5), xt.localResponseNormalization(this, t, e, n, r);
    }, t.prototype.pool = function(t, e, n, r, o) {
        return this.throwIfDisposed(), xt.pool(this, t, e, n, r, o);
    }, t.prototype.variable = function(t, e, n) {
        return void 0 === t && (t = !0), this.throwIfDisposed(), yt().makeVariable(this, t, e, n);
    }, t.prototype.unsortedSegmentSum = function(t, e) {
        return this.throwIfDisposed(), xt.unsortedSegmentSum(this, t, e);
    }, t.prototype.batchToSpaceND = function(t, e) {
        return this.throwIfDisposed(), xt.batchToSpaceND(this, t, e);
    }, t.prototype.spaceToBatchND = function(t, e) {
        return this.throwIfDisposed(), xt.spaceToBatchND(this, t, e);
    }, t.prototype.topk = function(t, e) {
        return void 0 === t && (t = 1), void 0 === e && (e = !0), this.throwIfDisposed(), xt.topk(this, t, e);
    }, t.prototype.stridedSlice = function(t, e, n, r, o, a, i, s) {
        return void 0 === r && (r = 0), void 0 === o && (o = 0), void 0 === a && (a = 0), void 0 === i && (i = 0), void 0 === s && (s = 0), this.throwIfDisposed(), xt.stridedSlice(this, t, e, n, r, o, a, i, s);
    }, t.prototype.depthToSpace = function(t, e) {
        return this.throwIfDisposed(), xt.depthToSpace(this, t, e);
    }, t.prototype.fft = function() {
        return this.throwIfDisposed(), xt.spectral.fft(this);
    }, t.prototype.ifft = function() {
        return this.throwIfDisposed(), xt.spectral.ifft(this);
    }, t.prototype.rfft = function() {
        return this.throwIfDisposed(), xt.spectral.rfft(this);
    }, t.prototype.irfft = function() {
        return this.throwIfDisposed(), xt.spectral.irfft(this);
    }, t;
}();
Object.defineProperty(wt, Symbol.hasInstance, {
    value: function(t) {
        return !!t && null != t.dataId && null != t.shape && null != t.dtype;
    }
});
var Ct, Et, Rt, It, kt, St = function(t) {
    function n(e, n, r, o) {
        var a = t.call(this, e.shape, e.dtype, e.dataId, o) || this;
        return a.trainable = n, a.name = r, a;
    }
    return e(n, t), n.prototype.assign = function(t) {
        if (t.dtype !== this.dtype) throw new Error("dtype of the new value (" + t.dtype + ") and previous value (" + this.dtype + ") must match");
        if (!S(t.shape, this.shape)) throw new Error("shape of the new value (" + t.shape + ") and previous value (" + this.shape + ") must match");
        yt().disposeTensor(this), this.dataId = t.dataId, yt().incRef(this, null);
    }, n.prototype.dispose = function() {
        yt().disposeVariable(this), this.isDisposedInternal = !0;
    }, n;
}(wt);
Object.defineProperty(St, Symbol.hasInstance, {
    value: function(t) {
        return t instanceof wt && null != t.assign && t.assign instanceof Function;
    }
}), function(t) {
    t.R0 = "R0", t.R1 = "R1", t.R2 = "R2", t.R3 = "R3", t.R4 = "R4", t.R5 = "R5", t.R6 = "R6";
}(Ct || (Ct = {})), function(t) {
    t.float32 = "float32", t.int32 = "int32", t.bool = "int32", t.complex64 = "complex64";
}(Et || (Et = {})), function(t) {
    t.float32 = "float32", t.int32 = "int32", t.bool = "bool", t.complex64 = "complex64";
}(Rt || (Rt = {})), function(t) {
    t.float32 = "float32", t.int32 = "float32", t.bool = "float32", t.complex64 = "complex64";
}(It || (It = {})), function(t) {
    t.float32 = "complex64", t.int32 = "complex64", t.bool = "complex64", t.complex64 = "complex64";
}(kt || (kt = {}));
var At = {
    float32: It,
    int32: Et,
    bool: Rt,
    complex64: kt
};
function Dt(t, e) {
    if ("string" === t || "string" === e) {
        if ("string" === t && "string" === e) return "string";
        throw new Error("Can not upcast " + t + " with " + e);
    }
    return At[t][e];
}
function Tt(t) {
    return Dt(t, "int32");
}
function Nt(t, e) {
    if (t.dtype === e.dtype) return [
        t,
        e
    ];
    var n = Dt(t.dtype, e.dtype);
    return [
        t.cast(n),
        e.cast(n)
    ];
}
function Ft(t, e) {
    C(t.dtype === e.dtype, function() {
        return "The dtypes of the first(" + t.dtype + ") and second(" + e.dtype + ") input must match";
    });
}
function _t(t) {
    var e = [];
    return function t(e, n, r) {
        if (null == e) return;
        if (e instanceof wt) return void n.push(e);
        if (o = e, !Array.isArray(o) && "object" != typeof o) return;
        var o;
        var a = e;
        for(var i in a){
            var s = a[i];
            r.has(s) || (r.add(s), t(s, n, r));
        }
    }(t, e, new Set), e;
}
var Ot, Mt = Object.freeze({
    makeTypesMatch: Nt,
    assertTypesMatch: Ft,
    isTensorInList: function(t, e) {
        return e.some(function(e) {
            return e.id === t.id;
        });
    },
    getTensorsInContainer: _t
}), Bt = function() {
    function t() {
        this.registeredVariables = {}, this.nextTapeNodeId = 0, this.numBytes = 0, this.numTensors = 0, this.numStringTensors = 0, this.numDataBuffers = 0, this.gradientDepth = 0, this.kernelDepth = 0, this.scopeStack = [], this.numDataMovesStack = [], this.nextScopeId = 0, this.tensorInfo = new WeakMap, this.profiling = !1, this.activeProfile = {
            newBytes: 0,
            newTensors: 0,
            peakBytes: 0,
            kernels: [],
            result: null
        };
    }
    return t.prototype.dispose = function() {
        for(var t in this.registeredVariables)this.registeredVariables[t].dispose();
    }, t;
}(), Pt = function() {
    function t(t) {
        this.ENV = t, this.registry = {}, this.registryFactory = {}, this.pendingBackendInitId = 0, this.state = new Bt;
    }
    return t.prototype.ready = function() {
        return n(this, void 0, void 0, function() {
            var t, e, n;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        if (null != this.pendingBackendInit) return [
                            2,
                            this.pendingBackendInit.then(function() {})
                        ];
                        if (null != this.backendInstance) return [
                            2
                        ];
                        t = this.getSortedBackends(), e = 0, r.label = 1;
                    case 1:
                        return e < t.length ? (n = t[e], [
                            4,
                            this.initializeBackend(n).success
                        ]) : [
                            3,
                            5
                        ];
                    case 2:
                        return r.sent() ? [
                            4,
                            this.setBackend(n)
                        ] : [
                            3,
                            4
                        ];
                    case 3:
                        return r.sent(), [
                            2
                        ];
                    case 4:
                        return e++, [
                            3,
                            1
                        ];
                    case 5:
                        throw new Error("Could not initialize any backends, all backend initializations failed.");
                }
            });
        });
    }, Object.defineProperty(t.prototype, "backend", {
        get: function() {
            if (null != this.pendingBackendInit) throw new Error("Backend '" + this.backendName + "' has not yet been initialized. Make sure to await tf.ready() or await tf.setBackend() before calling other methods");
            if (null == this.backendInstance) {
                var t = this.initializeBackendsAndReturnBest(), e = t.name;
                if (t.asyncInit) throw new Error("The highest priority backend '" + e + "' has not yet been initialized. Make sure to await tf.ready() or await tf.setBackend() before calling other methods");
                this.setBackend(e);
            }
            return this.backendInstance;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.backendNames = function() {
        return Object.keys(this.registryFactory);
    }, t.prototype.findBackend = function(t) {
        if (!(t in this.registry)) {
            if (!(t in this.registryFactory)) return null;
            if (this.initializeBackend(t).asyncInit) return null;
        }
        return this.registry[t];
    }, t.prototype.findBackendFactory = function(t) {
        return t in this.registryFactory ? this.registryFactory[t].factory : null;
    }, t.prototype.registerBackend = function(t, e, n) {
        return void 0 === n && (n = 1), t in this.registryFactory ? (console.warn(t + " backend was already registered. Reusing existing backend factory."), !1) : (this.registryFactory[t] = {
            factory: e,
            priority: n
        }, !0);
    }, t.prototype.setBackend = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n, o;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        if (null == this.registryFactory[t]) throw new Error("Backend name '" + t + "' not found in registry");
                        return this.backendName = t, null != this.registry[t] ? [
                            3,
                            4
                        ] : (this.backendInstance = null, e = this.initializeBackend(t), n = e.success, e.asyncInit ? [
                            4,
                            n
                        ] : [
                            3,
                            2
                        ]);
                    case 1:
                        return o = r.sent(), [
                            3,
                            3
                        ];
                    case 2:
                        o = n, r.label = 3;
                    case 3:
                        if (!o) return [
                            2,
                            !1
                        ];
                        r.label = 4;
                    case 4:
                        return this.backendInstance = this.registry[t], this.setupRegisteredKernels(), this.profiler = new ut(this.backendInstance), [
                            2,
                            !0
                        ];
                }
            });
        });
    }, t.prototype.setupRegisteredKernels = function() {
        var t = this;
        f(this.backendName).forEach(function(e) {
            null != e.setupFunc && e.setupFunc(t.backendInstance);
        });
    }, t.prototype.disposeRegisteredKernels = function(t) {
        var e = this;
        f(t).forEach(function(n) {
            null != n.disposeFunc && n.disposeFunc(e.registry[t]);
        });
    }, t.prototype.initializeBackend = function(t) {
        var e = this, n = this.registryFactory[t];
        if (null == n) throw new Error("Cannot initialize backend " + t + ", no registration found.");
        try {
            var r = n.factory();
            if (Promise.resolve(r) === r) {
                var o = ++this.pendingBackendInitId, a = r.then(function(n) {
                    return !(o < e.pendingBackendInitId) && (e.registry[t] = n, e.pendingBackendInit = null, !0);
                }).catch(function(n) {
                    return !(o < e.pendingBackendInitId) && (e.pendingBackendInit = null, console.warn("Initialization of backend " + t + " failed"), console.warn(n.stack || n.message), !1);
                });
                return this.pendingBackendInit = a, {
                    success: a,
                    asyncInit: !0
                };
            }
            return this.registry[t] = r, {
                success: !0,
                asyncInit: !1
            };
        } catch (e) {
            return console.warn("Initialization of backend " + t + " failed"), console.warn(e.stack || e.message), {
                success: !1,
                asyncInit: !1
            };
        }
    }, t.prototype.removeBackend = function(t) {
        if (!(t in this.registryFactory)) throw new Error(t + " backend not found in registry");
        this.backendName === t && null != this.pendingBackendInit && this.pendingBackendInitId++, t in this.registry && (this.disposeRegisteredKernels(t), this.registry[t].dispose(), delete this.registry[t]), delete this.registryFactory[t], this.backendName === t && (this.pendingBackendInit = null, this.backendName = null, this.backendInstance = null);
    }, t.prototype.getSortedBackends = function() {
        var t = this;
        if (0 === Object.keys(this.registryFactory).length) throw new Error("No backend found in registry.");
        return Object.keys(this.registryFactory).sort(function(e, n) {
            return t.registryFactory[n].priority - t.registryFactory[e].priority;
        });
    }, t.prototype.initializeBackendsAndReturnBest = function() {
        for(var t = this.getSortedBackends(), e = 0; e < t.length; e++){
            var n = t[e], r = this.initializeBackend(n), o = r.success, a = r.asyncInit;
            if (a || o) return {
                name: n,
                asyncInit: a
            };
        }
        throw new Error("Could not initialize any backends, all backend initializations failed.");
    }, t.prototype.moveData = function(t, e) {
        var n = this.state.tensorInfo.get(e), r = n.backend, o = this.readSync(e);
        r.disposeData(e), n.backend = t, t.move(e, o, n.shape, n.dtype), this.shouldCheckForMemLeaks() && this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1]++;
    }, t.prototype.tidy = function(t, e) {
        var n, r = this, o = null;
        if (null == e) {
            if ("function" != typeof t) throw new Error("Please provide a function to tidy()");
            e = t;
        } else {
            if ("string" != typeof t && !(t instanceof String)) throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
            if ("function" != typeof e) throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
            o = t;
        }
        return this.scopedRun(function() {
            return r.startScope(o);
        }, function() {
            return r.endScope(n);
        }, function() {
            return (n = e()) instanceof Promise && console.error("Cannot return a Promise inside of tidy."), n;
        });
    }, t.prototype.scopedRun = function(t, e, n) {
        t();
        try {
            var r = n();
            return e(), r;
        } catch (t) {
            throw e(), t;
        }
    }, t.prototype.nextTensorId = function() {
        return t.nextTensorId++;
    }, t.prototype.nextVariableId = function() {
        return t.nextVariableId++;
    }, t.prototype.clone = function(t) {
        var e = this.makeTensorFromDataId(t.dataId, t.shape, t.dtype), n = {
            x: t
        };
        return this.addTapeNode(this.state.activeScope.name, n, [
            e
        ], function(t) {
            return {
                x: function() {
                    return t.toFloat();
                }
            };
        }, []), e;
    }, t.prototype.runKernel = function(t, e, n, r, o) {
        return this.runKernelFunc(null, e, null, t, n, r, o);
    }, t.prototype.shouldCheckForMemLeaks = function() {
        return this.ENV.getBool("IS_TEST");
    }, t.prototype.checkKernelForMemLeak = function(t, e, n) {
        var r = this.backend.numDataIds(), o = 0;
        n.forEach(function(t) {
            o += "complex64" === t.dtype ? 3 : 1;
        });
        var a = this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1], i = r - e - o - a;
        if (i > 0) throw new Error("Backend '" + this.backendName + "' has an internal memory leak (" + i + " data ids) after running '" + t + "'");
    }, t.prototype.runKernelFunc = function(t, e, n, r, o, a, i) {
        var s, u = this;
        void 0 === a && (a = []), void 0 === i && (i = []);
        var c = [], h = this.isTapeOn();
        null == r && (r = null != this.state.activeScope ? this.state.activeScope.name : "");
        var f, d = function(t) {
            h && (c = t.map(function(t) {
                return u.keep(u.clone(t));
            }));
        }, p = this.state.numBytes, v = this.state.numTensors;
        this.shouldCheckForMemLeaks() && this.state.numDataMovesStack.push(0);
        var m, g = l(r, this.backendName);
        return f = null != g ? function() {
            var t = u.backend.numDataIds();
            m = g.kernelFunc({
                inputs: e,
                attrs: o,
                backend: u.backend
            });
            var n = Array.isArray(m) ? m : [
                m
            ];
            u.shouldCheckForMemLeaks() && u.checkKernelForMemLeak(r, t, n);
            var s = n.map(function(t) {
                var e = t.dataId, n = t.shape, r = t.dtype;
                return u.makeTensorFromDataId(e, n, r);
            }), c = s.filter(function(t, e) {
                return i[e];
            });
            return d((a || []).slice().concat(c)), s;
        } : function() {
            var e = u.backend.numDataIds();
            m = u.tidy(function() {
                return t(u.backend, d);
            });
            var n = Array.isArray(m) ? m : [
                m
            ];
            return u.shouldCheckForMemLeaks() && u.checkKernelForMemLeak(r, e, n), n;
        }, this.scopedRun(function() {
            return u.state.kernelDepth++;
        }, function() {
            return u.state.kernelDepth--;
        }, function() {
            s = u.ENV.getBool("DEBUG") ? u.profiler.profileKernel(r, e, function() {
                return f();
            }) : f();
        }), h && this.addTapeNode(r, e, s, n, c), this.state.profiling && this.state.activeProfile.kernels.push({
            name: r,
            bytesAdded: this.state.numBytes - p,
            totalBytesSnapshot: this.state.numBytes,
            tensorsAdded: this.state.numTensors - v,
            totalTensorsSnapshot: this.state.numTensors,
            inputShapes: Object.keys(e).map(function(t) {
                return e[t].shape;
            }),
            outputShapes: s.map(function(t) {
                return t.shape;
            })
        }), Array.isArray(m) ? s : s[0];
    }, t.prototype.makeTensor = function(t, e, n, r) {
        if (null == t) throw new Error("Values passed to engine.makeTensor() are null");
        n = n || "float32", r = r || this.backend;
        var o = t;
        "string" === n && H(t[0]) && (o = t.map(function(t) {
            return rt(t);
        }));
        var a = r.write(o, e, n), i = new wt(e, n, a, this.nextTensorId());
        if (this.incRef(i, r), "string" === n) {
            var s = this.state.tensorInfo.get(a), u = G(o);
            this.state.numBytes += u - s.bytes, s.bytes = u;
        }
        return i;
    }, t.prototype.makeTensorFromDataId = function(t, e, n, r) {
        var o = new wt(e, n = n || "float32", t, this.nextTensorId());
        return this.incRef(o, r), o;
    }, t.prototype.makeVariable = function(t, e, n, r) {
        void 0 === e && (e = !0), n = n || this.nextVariableId().toString(), null != r && r !== t.dtype && (t = t.asType(r));
        var o = new St(t, e, n, this.nextTensorId());
        if (null != this.state.registeredVariables[o.name]) throw new Error("Variable with name " + o.name + " was already registered");
        return this.state.registeredVariables[o.name] = o, this.incRef(o, this.backend), o;
    }, t.prototype.incRef = function(t, e) {
        var n = this.state.tensorInfo.has(t.dataId) ? this.state.tensorInfo.get(t.dataId).refCount : 0;
        if (this.state.numTensors++, "string" === t.dtype && this.state.numStringTensors++, 0 === n) {
            this.state.numDataBuffers++;
            var r = 0;
            "complex64" !== t.dtype && "string" !== t.dtype && (r = t.size * z(t.dtype)), this.state.tensorInfo.set(t.dataId, {
                backend: e || this.backend,
                dtype: t.dtype,
                shape: t.shape,
                bytes: r,
                refCount: 0
            }), this.state.numBytes += r;
        }
        this.state.tensorInfo.get(t.dataId).refCount++, t instanceof St || this.track(t);
    }, t.prototype.disposeTensor = function(t) {
        if (this.state.tensorInfo.has(t.dataId)) {
            this.state.numTensors--, "string" === t.dtype && this.state.numStringTensors--;
            var e = this.state.tensorInfo.get(t.dataId);
            e.refCount <= 1 ? ("complex64" !== t.dtype && (this.state.numBytes -= e.bytes), this.state.numDataBuffers--, e.backend.disposeData(t.dataId), this.state.tensorInfo.delete(t.dataId)) : this.state.tensorInfo.get(t.dataId).refCount--;
        }
    }, t.prototype.disposeVariables = function() {
        for(var t in this.state.registeredVariables){
            var e = this.state.registeredVariables[t];
            this.disposeVariable(e);
        }
    }, t.prototype.disposeVariable = function(t) {
        this.disposeTensor(t), null != this.state.registeredVariables[t.name] && delete this.state.registeredVariables[t.name];
    }, t.prototype.memory = function() {
        var t = this.backend.memory();
        return t.numTensors = this.state.numTensors, t.numDataBuffers = this.state.numDataBuffers, t.numBytes = this.state.numBytes, this.state.numStringTensors > 0 && (t.unreliable = !0, null == t.reasons && (t.reasons = []), t.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)")), t;
    }, t.prototype.profile = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n;
            return r(this, function(r) {
                return this.state.profiling = !0, e = this.state.numBytes, n = this.state.numTensors, this.state.activeProfile.kernels = [], this.state.activeProfile.result = t(), this.state.profiling = !1, this.state.activeProfile.peakBytes = Math.max.apply(Math, this.state.activeProfile.kernels.map(function(t) {
                    return t.totalBytesSnapshot;
                })), this.state.activeProfile.newBytes = this.state.numBytes - e, this.state.activeProfile.newTensors = this.state.numTensors - n, [
                    2,
                    this.state.activeProfile
                ];
            });
        });
    }, t.prototype.isTapeOn = function() {
        return this.state.gradientDepth > 0 && 0 === this.state.kernelDepth;
    }, t.prototype.addTapeNode = function(t, e, n, r, o) {
        var a = this, i = {
            id: this.state.nextTapeNodeId++,
            kernelName: t,
            inputs: e,
            outputs: n,
            saved: o
        }, s = h(t);
        null != s && (r = s.gradFunc), null != r && (i.gradient = function(t) {
            return t = t.map(function(t, e) {
                if (null == t) {
                    var r = n[e], o = tt(r.size, r.dtype);
                    return a.makeTensor(o, r.shape, r.dtype);
                }
                return t;
            }), r(t.length > 1 ? t : t[0], o);
        }), this.state.activeTape.push(i);
    }, t.prototype.keep = function(t) {
        return t.kept = !0, t;
    }, t.prototype.startTape = function() {
        0 === this.state.gradientDepth && (this.state.activeTape = []), this.state.gradientDepth++;
    }, t.prototype.endTape = function() {
        this.state.gradientDepth--;
    }, t.prototype.startScope = function(t) {
        var e = {
            track: [],
            name: "unnamed scope",
            id: this.state.nextScopeId++
        };
        t && (e.name = t), this.state.scopeStack.push(e), this.state.activeScope = e;
    }, t.prototype.endScope = function(t) {
        for(var e = this, n = _t(t), r = new Set(n.map(function(t) {
            return t.id;
        })), o = 0; o < this.state.activeScope.track.length; o++){
            var a = this.state.activeScope.track[o];
            a.kept || r.has(a.id) || a.dispose();
        }
        var i = this.state.scopeStack.pop();
        this.state.activeScope = 0 === this.state.scopeStack.length ? null : this.state.scopeStack[this.state.scopeStack.length - 1], n.forEach(function(t) {
            t.kept || t.scopeId !== i.id || e.track(t);
        });
    }, t.prototype.gradients = function(t, e, n, r) {
        var o = this;
        if (void 0 === r && (r = !1), C(e.length > 0, function() {
            return "gradients() received an empty list of xs.";
        }), null != n && "float32" !== n.dtype) throw new Error("dy must have 'float32' dtype, but has '" + n.dtype + "'");
        var a = this.scopedRun(function() {
            return o.startTape();
        }, function() {
            return o.endTape();
        }, function() {
            return o.tidy("forward", t);
        });
        C(a instanceof wt, function() {
            return "The result y returned by f() must be a tensor.";
        });
        var i = function(t, e, n) {
            for(var r = {}, o = {}, a = 0; a < e.length; a++)r[e[a].id] = !0;
            for(a = 0; a < t.length; a++){
                var i = (p = t[a]).inputs;
                for(var s in i){
                    for(var u = i[s], c = !1, l = 0; l < e.length; l++)if (r[u.id]) {
                        p.outputs.forEach(function(t) {
                            return r[t.id] = !0;
                        }), c = !0, o[p.id] = !0;
                        break;
                    }
                    if (c) break;
                }
            }
            var h = {};
            h[n.id] = !0;
            var f = {};
            for(a = t.length - 1; a >= 0; a--)for(i = (p = t[a]).inputs, l = 0; l < p.outputs.length; l++)if (h[p.outputs[l].id]) {
                for(var s in i)h[i[s].id] = !0, f[p.id] = !0;
                break;
            }
            var d = [];
            for(a = 0; a < t.length; a++){
                var p;
                if (o[(p = t[a]).id] && f[p.id]) {
                    var v = {};
                    for(var s in p.inputs){
                        var m = p.inputs[s];
                        r[m.id] && (v[s] = m);
                    }
                    var g = Object.assign({}, p);
                    g.inputs = v, g.outputs = p.outputs, d.push(g);
                }
            }
            return d;
        }(this.state.activeTape, e, a);
        if (!r && 0 === i.length && e.length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
        return this.tidy("backward", function() {
            var t, r, s = {};
            s[a.id] = null == n ? (t = a.shape, r = Z(k(t), "float32"), Lt.makeTensor(r, t, "float32")) : n, function(t, e, n) {
                for(var r = function(r) {
                    var o = e[r], a = [];
                    if (o.outputs.forEach(function(e) {
                        var n = t[e.id];
                        null != n ? a.push(n) : a.push(null);
                    }), null == o.gradient) throw new Error("Cannot compute gradient: gradient function not found for " + o.kernelName + ".");
                    var i = o.gradient(a), s = function(e) {
                        if (!(e in i)) throw new Error("Cannot backprop through input " + e + ". Available gradients found: " + Object.keys(i) + ".");
                        var r = n(function() {
                            return i[e]();
                        });
                        if ("float32" !== r.dtype) throw new Error("Error in gradient for op " + o.kernelName + ". The gradient of input " + e + " must have 'float32' dtype, but has '" + r.dtype + "'");
                        var a = o.inputs[e];
                        if (!S(r.shape, a.shape)) throw new Error("Error in gradient for op " + o.kernelName + ". The gradient of input '" + e + "' has shape '" + r.shape + "', which does not match the shape of the input '" + a.shape + "'");
                        if (null == t[a.id]) t[a.id] = r;
                        else {
                            var s = t[a.id];
                            t[a.id] = s.add(r), s.dispose();
                        }
                    };
                    for(var u in o.inputs)s(u);
                }, o = e.length - 1; o >= 0; o--)r(o);
            }(s, i, function(t) {
                return o.tidy(t);
            });
            var u = e.map(function(t) {
                return s[t.id];
            });
            return 0 === o.state.gradientDepth && (o.state.activeTape.forEach(function(t) {
                for(var e = 0, n = t.saved; e < n.length; e++)n[e].dispose();
            }), o.state.activeTape = null), {
                value: a,
                grads: u
            };
        });
    }, t.prototype.customGrad = function(t) {
        var e = this;
        return C(X(t), function() {
            return "The f passed in customGrad(f) must be a function.";
        }), function() {
            for(var n, r = [], o = 0; o < arguments.length; o++)r[o] = arguments[o];
            C(r.every(function(t) {
                return t instanceof wt;
            }), function() {
                return "The args passed in customGrad(f)(x1, x2,...) must all be tensors";
            });
            var a = {};
            return r.forEach(function(t, e) {
                a[e] = t;
            }), e.runKernelFunc(function(e, o) {
                return C((n = t.apply(void 0, r.concat([
                    o
                ]))).value instanceof wt, function() {
                    return "The function f passed in customGrad(f) must return an object where `obj.value` is a tensor";
                }), C(X(n.gradFunc), function() {
                    return "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function.";
                }), n.value;
            }, a, function(t, e) {
                var o = n.gradFunc(t, e), a = Array.isArray(o) ? o : [
                    o
                ];
                C(a.length === r.length, function() {
                    return "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...).";
                }), C(a.every(function(t) {
                    return t instanceof wt;
                }), function() {
                    return "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors.";
                });
                var i = {};
                return a.forEach(function(t, e) {
                    i[e] = function() {
                        return t;
                    };
                }), i;
            });
        };
    }, t.prototype.readSync = function(t) {
        return this.state.tensorInfo.get(t).backend.readSync(t);
    }, t.prototype.read = function(t) {
        return this.state.tensorInfo.get(t).backend.read(t);
    }, t.prototype.time = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        return e = et(), [
                            4,
                            this.backend.time(t)
                        ];
                    case 1:
                        return (n = r.sent()).wallMs = et() - e, [
                            2,
                            n
                        ];
                }
            });
        });
    }, t.prototype.track = function(t) {
        return null != this.state.activeScope && (t.scopeId = this.state.activeScope.id, this.state.activeScope.track.push(t)), t;
    }, Object.defineProperty(t.prototype, "registeredVariables", {
        get: function() {
            return this.state.registeredVariables;
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.reset = function() {
        for(var t in this.pendingBackendInitId++, this.state.dispose(), this.ENV.reset(), this.state = new Bt, this.registry)this.disposeRegisteredKernels(t), this.registry[t].dispose(), delete this.registry[t];
        this.backendName = null, this.backendInstance = null, this.pendingBackendInit = null;
    }, t.nextTensorId = 0, t.nextVariableId = 0, t;
}();
var Lt = function() {
    var t = function() {
        if (null == Ot) {
            var t = void 0;
            if ("undefined" != typeof window) t = window;
            else if ("undefined" != typeof $parcel$global) t = $parcel$global;
            else if ("undefined" != typeof $cmlvI) t = $cmlvI;
            else {
                if ("undefined" == typeof self) throw new Error("Could not find a global object");
                t = self;
            }
            Ot = t;
        }
        return Ot;
    }();
    if (null == t._tfengine) {
        var e = new o(t);
        t._tfengine = new Pt(e);
    }
    return function(t) {
        s = t;
    }(t._tfengine.ENV), yt = function() {
        return t._tfengine;
    }, t._tfengine;
}();
function Wt() {
    return "undefined" != typeof window && null != window.document || "undefined" != typeof WorkerGlobalScope;
}
var Ut = i();
Ut.registerFlag("DEBUG", function() {
    return !1;
}, function(t) {
    t && console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
}), Ut.registerFlag("IS_BROWSER", function() {
    return Wt();
}), Ut.registerFlag("IS_NODE", function() {
    return "undefined" != typeof $cmlvI && void 0 !== $cmlvI.versions && void 0 !== $cmlvI.versions.node;
}), Ut.registerFlag("IS_CHROME", function() {
    return "undefined" != typeof navigator && null != navigator && null != navigator.userAgent && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
}), Ut.registerFlag("PROD", function() {
    return !1;
}), Ut.registerFlag("TENSORLIKE_CHECK_SHAPE_CONSISTENCY", function() {
    return Ut.getBool("DEBUG");
}), Ut.registerFlag("DEPRECATION_WARNINGS_ENABLED", function() {
    return !0;
}), Ut.registerFlag("IS_TEST", function() {
    return !1;
});
var Vt, zt, Gt, Ht = {}, qt = {
    alpha: !1,
    antialias: !1,
    premultipliedAlpha: !1,
    preserveDrawingBuffer: !1,
    depth: !1,
    stencil: !1,
    failIfMajorPerformanceCaveat: !0
};
function Kt(t, e) {
    Ht[t] = e;
}
function jt(t) {
    t in Ht || (Ht[t] = function(t) {
        if (1 !== t && 2 !== t) throw new Error("Cannot get WebGL rendering context, WebGL is disabled.");
        var e = function(t) {
            if ("undefined" != typeof OffscreenCanvas && 2 === t) return new OffscreenCanvas(300, 150);
            if ("undefined" != typeof document) return document.createElement("canvas");
            throw new Error("Cannot create a canvas in this context");
        }(t);
        if (e.addEventListener("webglcontextlost", function(e) {
            e.preventDefault(), delete Ht[t];
        }, !1), 1 === t) return e.getContext("webgl", qt) || e.getContext("experimental-webgl", qt);
        return e.getContext("webgl2", qt);
    }(t));
    var e = Ht[t];
    return e.isContextLost() ? (delete Ht[t], jt(t)) : (e.disable(e.DEPTH_TEST), e.disable(e.STENCIL_TEST), e.disable(e.BLEND), e.disable(e.DITHER), e.disable(e.POLYGON_OFFSET_FILL), e.disable(e.SAMPLE_COVERAGE), e.enable(e.SCISSOR_TEST), e.enable(e.CULL_FACE), e.cullFace(e.BACK), Ht[t]);
}
function Xt(t, e) {
    return [
        e,
        t
    ];
}
function Yt(t) {
    var e = k(t);
    return T(Math.ceil(e / 4));
}
function $t(t, e) {
    return [
        Math.max(1, Math.ceil(e / 2)),
        Math.max(1, Math.ceil(t / 2))
    ];
}
function Qt(t, e) {
    var n, r, o, a, s, u, c, l, h, f = t;
    return 2 === i().getNumber("WEBGL_VERSION") ? (n = f.R32F, r = f.R16F, o = f.RGBA16F, a = f.RGBA32F, s = f.RED, u = 4, c = 1, l = f.HALF_FLOAT, h = f.FLOAT) : (n = t.RGBA, r = t.RGBA, o = t.RGBA, a = f.RGBA, s = t.RGBA, u = 4, c = 4, l = null != e ? e.HALF_FLOAT_OES : null, h = t.FLOAT), {
        internalFormatFloat: n,
        internalFormatHalfFloat: r,
        internalFormatPackedHalfFloat: o,
        internalFormatPackedFloat: a,
        textureFormatFloat: s,
        downloadTextureFormat: t.RGBA,
        downloadUnpackNumChannels: u,
        defaultNumChannels: c,
        textureTypeHalfFloat: l,
        textureTypeFloat: h
    };
}
function Jt(t, e, n) {
    var r = n();
    return e && function(t) {
        var e = t.getError();
        if (e !== t.NO_ERROR) throw new Error("WebGL Error: " + ne(t, e));
    }(t), r;
}
!function(t) {
    t[t.DENSE = 0] = "DENSE", t[t.SHARED_BATCH = 1] = "SHARED_BATCH";
}(Vt || (Vt = {})), function(t) {
    t[t.RENDER = 0] = "RENDER", t[t.UPLOAD = 1] = "UPLOAD", t[t.PIXELS = 2] = "PIXELS", t[t.DOWNLOAD = 3] = "DOWNLOAD";
}(zt || (zt = {})), function(t) {
    t[t.UNPACKED_FLOAT16 = 0] = "UNPACKED_FLOAT16", t[t.UNPACKED_FLOAT32 = 1] = "UNPACKED_FLOAT32", t[t.PACKED_4X1_UNSIGNED_BYTE = 2] = "PACKED_4X1_UNSIGNED_BYTE", t[t.PACKED_2X2_FLOAT32 = 3] = "PACKED_2X2_FLOAT32", t[t.PACKED_2X2_FLOAT16 = 4] = "PACKED_2X2_FLOAT16";
}(Gt || (Gt = {}));
var Zt = 5.96e-8, te = 65504;
function ee(t) {
    return !!(i().getBool("WEBGL_RENDER_FLOAT32_ENABLED") || 0 === t || Zt < Math.abs(t) && Math.abs(t) < te);
}
function ne(t, e) {
    switch(e){
        case t.NO_ERROR:
            return "NO_ERROR";
        case t.INVALID_ENUM:
            return "INVALID_ENUM";
        case t.INVALID_VALUE:
            return "INVALID_VALUE";
        case t.INVALID_OPERATION:
            return "INVALID_OPERATION";
        case t.INVALID_FRAMEBUFFER_OPERATION:
            return "INVALID_FRAMEBUFFER_OPERATION";
        case t.OUT_OF_MEMORY:
            return "OUT_OF_MEMORY";
        case t.CONTEXT_LOST_WEBGL:
            return "CONTEXT_LOST_WEBGL";
        default:
            return "Unknown error code " + e;
    }
}
function re(t, e, n) {
    return ke(t, e, function() {
        return t.getExtension(n);
    }, 'Extension "' + n + '" not supported on this browser.');
}
function oe(t, e, n) {
    var r = ke(t, e, function() {
        return t.createShader(t.VERTEX_SHADER);
    }, "Unable to create vertex WebGLShader.");
    if (Jt(t, e, function() {
        return t.shaderSource(r, n);
    }), Jt(t, e, function() {
        return t.compileShader(r);
    }), !1 === t.getShaderParameter(r, t.COMPILE_STATUS)) throw console.log(t.getShaderInfoLog(r)), new Error("Failed to compile vertex shader.");
    return r;
}
function ae(t, e, n) {
    var r = ke(t, e, function() {
        return t.createShader(t.FRAGMENT_SHADER);
    }, "Unable to create fragment WebGLShader.");
    if (Jt(t, e, function() {
        return t.shaderSource(r, n);
    }), Jt(t, e, function() {
        return t.compileShader(r);
    }), !1 === t.getShaderParameter(r, t.COMPILE_STATUS)) throw function(t, e) {
        var n = ue.exec(e);
        if (null == n) return console.log("Couldn't parse line number in error: " + e), void console.log(t);
        for(var r = +n[1], o = t.split("\n"), a = o.length.toString().length + 2, i = o.map(function(t, e) {
            return N((e + 1).toString(), a) + t;
        }), s = 0, u = 0; u < i.length; u++)s = Math.max(i[u].length, s);
        var c = i.slice(0, r - 1), l = i.slice(r - 1, r), h = i.slice(r);
        console.log(c.join("\n")), console.log(e.split("\n")[0]), console.log("%c " + N(l[0], s), "border:1px solid red; background-color:#e3d2d2; color:#a61717"), console.log(h.join("\n"));
    }(n, t.getShaderInfoLog(r)), new Error("Failed to compile fragment shader.");
    return r;
}
var ie, se, ue = /ERROR: [0-9]+:([0-9]+):/g;
function ce(t, e) {
    return ke(t, e, function() {
        return t.createProgram();
    }, "Unable to create WebGLProgram.");
}
function le(t, e, n) {
    if (Jt(t, e, function() {
        return t.linkProgram(n);
    }), !1 === t.getProgramParameter(n, t.LINK_STATUS)) throw console.log(t.getProgramInfoLog(n)), new Error("Failed to link vertex and fragment shaders.");
}
function he(t, e, n) {
    if (Jt(t, e, function() {
        return t.validateProgram(n);
    }), !1 === t.getProgramParameter(n, t.VALIDATE_STATUS)) throw console.log(t.getProgramInfoLog(n)), new Error("Shader program validation failed.");
}
function fe(t, e, n) {
    var r = ke(t, e, function() {
        return t.createBuffer();
    }, "Unable to create WebGLBuffer");
    return Jt(t, e, function() {
        return t.bindBuffer(t.ARRAY_BUFFER, r);
    }), Jt(t, e, function() {
        return t.bufferData(t.ARRAY_BUFFER, n, t.STATIC_DRAW);
    }), r;
}
function de(t, e, n) {
    var r = ke(t, e, function() {
        return t.createBuffer();
    }, "Unable to create WebGLBuffer");
    return Jt(t, e, function() {
        return t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, r);
    }), Jt(t, e, function() {
        return t.bufferData(t.ELEMENT_ARRAY_BUFFER, n, t.STATIC_DRAW);
    }), r;
}
function pe(t, e) {
    return ke(t, e, function() {
        return t.createTexture();
    }, "Unable to create WebGLTexture.");
}
function ve(t, e) {
    var n = i().getNumber("WEBGL_MAX_TEXTURE_SIZE");
    if (t <= 0 || e <= 0) {
        var r = "[" + t + "x" + e + "]";
        throw new Error("Requested texture size " + r + " is invalid.");
    }
    if (t > n || e > n) {
        r = "[" + t + "x" + e + "]";
        throw new Error("Requested texture size " + r + " greater than WebGL maximum on this browser / GPU " + ("[" + n + "x" + n + "]") + ".");
    }
}
function me(t, e) {
    return ke(t, e, function() {
        return t.createFramebuffer();
    }, "Unable to create WebGLFramebuffer.");
}
function ge(t, e, n, r, o, a, i, s) {
    var u = t.getAttribLocation(n, r);
    return -1 !== u && (Jt(t, e, function() {
        return t.bindBuffer(t.ARRAY_BUFFER, o);
    }), Jt(t, e, function() {
        return t.vertexAttribPointer(u, a, t.FLOAT, !1, i, s);
    }), Jt(t, e, function() {
        return t.enableVertexAttribArray(u);
    }), !0);
}
function ye(t, e, n, r) {
    Se(t, r), Jt(t, e, function() {
        return t.activeTexture(t.TEXTURE0 + r);
    }), Jt(t, e, function() {
        return t.bindTexture(t.TEXTURE_2D, n);
    });
}
function xe(t, e, n, r) {
    return ke(t, e, function() {
        return t.getUniformLocation(n, r);
    }, 'uniform "' + r + '" not present in program.');
}
function be(t, e, n) {
    return t.getUniformLocation(e, n);
}
function we(t, e, n, r, o, a) {
    Jt(t, e, function() {
        return ye(t, e, r, a);
    }), Jt(t, e, function() {
        return t.uniform1i(o, a);
    });
}
function Ce(t, e, n, r) {
    Jt(t, e, function() {
        return t.bindFramebuffer(t.FRAMEBUFFER, r);
    }), Jt(t, e, function() {
        return t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, n, 0);
    });
}
function Ee(t, e, n) {
    Jt(t, e, function() {
        return t.bindFramebuffer(t.FRAMEBUFFER, n);
    }), Jt(t, e, function() {
        return t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, null, 0);
    });
}
function Re(t) {
    var e = t.checkFramebufferStatus(t.FRAMEBUFFER);
    if (e !== t.FRAMEBUFFER_COMPLETE) throw new Error("Error binding framebuffer: " + Ie(t, e));
}
function Ie(t, e) {
    switch(e){
        case t.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
            return "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
        case t.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
            return "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
        case t.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
            return "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
        case t.FRAMEBUFFER_UNSUPPORTED:
            return "FRAMEBUFFER_UNSUPPORTED";
        default:
            return "unknown error " + e;
    }
}
function ke(t, e, n, r) {
    var o = Jt(t, e, function() {
        return n();
    });
    if (null == o) throw new Error(r);
    return o;
}
function Se(t, e) {
    var n = t.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1, r = e + t.TEXTURE0;
    if (r < t.TEXTURE0 || r > n) throw new Error("textureUnit must be in " + ("[gl.TEXTURE0, gl.TEXTURE" + n + "]") + ".");
}
function Ae(t, e) {
    return void 0 === e && (e = 2), k(t.slice(0, t.length - e));
}
function De(t) {
    if (0 === t.length) throw Error("Cannot get rows and columns of an empty shape array.");
    return [
        t.length > 1 ? t[t.length - 2] : 1,
        t[t.length - 1]
    ];
}
function Te(t) {
    var e = [
        1,
        1,
        1
    ];
    return 0 === t.length || 1 === t.length && 1 === t[0] || (e = [
        Ae(t)
    ].concat(De(t))), e;
}
function Ne(t, e) {
    var n;
    void 0 === e && (e = !1);
    var r = i().getNumber("WEBGL_MAX_TEXTURE_SIZE");
    if (e && (r *= 2, 1 === (t = t.map(function(e, n) {
        return n >= t.length - 2 ? b(t[n]) : t[n];
    })).length && (t = [
        2,
        t[0]
    ])), 2 !== t.length) {
        var o = M(t);
        t = o.newShape;
    }
    var a = k(t);
    if (t.length <= 1 && a <= r) return [
        1,
        a
    ];
    if (2 === t.length && t[0] <= r && t[1] <= r) return t;
    if (3 === t.length && t[0] * t[1] <= r && t[2] <= r) return [
        t[0] * t[1],
        t[2]
    ];
    if (3 === t.length && t[0] <= r && t[1] * t[2] <= r) return [
        t[0],
        t[1] * t[2]
    ];
    if (4 === t.length && t[0] * t[1] * t[2] <= r && t[3] <= r) return [
        t[0] * t[1] * t[2],
        t[3]
    ];
    if (4 === t.length && t[0] <= r && t[1] * t[2] * t[3] <= r) return [
        t[0],
        t[1] * t[2] * t[3]
    ];
    if (e) {
        var s = Ae(t), u = 2, c = 2;
        return t.length && (u = (n = De(t))[0], c = n[1]), T(a = s * (u / 2) * (c / 2)).map(function(t) {
            return 2 * t;
        });
    }
    return T(a);
}
function Fe(t) {
    return t % 2 == 0;
}
function _e(t, e) {
    if (S(t = t.slice(-2), e = e.slice(-2))) return !0;
    if (!t.length || !e.length) return !0;
    if (0 === t[0] || 0 === t[1] || 0 === e[0] || 0 === e[1]) return !0;
    if (t.length !== e.length) {
        var n = t.slice(-1)[0], r = e.slice(-1)[0];
        if (n === r) return !0;
        if (Fe(n) && Fe(r) && (1 === t[0] || 1 === e[0])) return !0;
    }
    return t[1] === e[1] && Fe(t[0]) && Fe(e[0]);
}
function Oe(t) {
    if (null == ie) {
        var e = jt(t);
        ie = e.getParameter(e.MAX_TEXTURE_SIZE);
    }
    return ie;
}
function Me(t) {
    if (null == se) {
        var e = jt(t);
        se = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS);
    }
    return Math.min(16, se);
}
function Be(t) {
    if (0 === t) return 0;
    var e = jt(t);
    return Pe(e, "EXT_disjoint_timer_query_webgl2") && 2 === t ? 2 : Pe(e, "EXT_disjoint_timer_query") ? 1 : 0;
}
function Pe(t, e) {
    return null != t.getExtension(e);
}
function Le(t) {
    try {
        if (null != jt(t)) return !0;
    } catch (t) {
        return !1;
    }
    return !1;
}
function We(t) {
    if (0 === t) return !1;
    var e = jt(t);
    if (1 === t) {
        if (!Pe(e, "OES_texture_float")) return !1;
    } else if (!Pe(e, "EXT_color_buffer_float")) return !1;
    return Ve(e);
}
function Ue(t) {
    if (0 === t) return !1;
    var e = jt(t);
    if (1 !== t) {
        if (Pe(e, "EXT_color_buffer_float")) return Ve(e);
        if (Pe(e, "EXT_color_buffer_half_float")) {
            var n = e.getExtension("EXT_color_buffer_half_float");
            return function(t, e) {
                var n = Qt(t, e), r = t.createTexture();
                t.bindTexture(t.TEXTURE_2D, r);
                t.texImage2D(t.TEXTURE_2D, 0, n.internalFormatHalfFloat, 1, 1, 0, n.textureFormatFloat, n.textureTypeHalfFloat, null);
                var o = t.createFramebuffer();
                t.bindFramebuffer(t.FRAMEBUFFER, o), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, r, 0);
                var a = t.checkFramebufferStatus(t.FRAMEBUFFER) === t.FRAMEBUFFER_COMPLETE;
                return t.bindTexture(t.TEXTURE_2D, null), t.bindFramebuffer(t.FRAMEBUFFER, null), t.deleteTexture(r), t.deleteFramebuffer(o), a;
            }(e, n);
        }
        return !1;
    }
    return !!Pe(e, "OES_texture_float") && !!Pe(e, "WEBGL_color_buffer_float") && Ve(e);
}
function Ve(t) {
    var e = Qt(t), n = t.createTexture();
    t.bindTexture(t.TEXTURE_2D, n);
    t.texImage2D(t.TEXTURE_2D, 0, e.internalFormatFloat, 1, 1, 0, e.textureFormatFloat, e.textureTypeFloat, null);
    var r = t.createFramebuffer();
    t.bindFramebuffer(t.FRAMEBUFFER, r), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, n, 0);
    var o = t.checkFramebufferStatus(t.FRAMEBUFFER) === t.FRAMEBUFFER_COMPLETE;
    return t.bindTexture(t.TEXTURE_2D, null), t.bindFramebuffer(t.FRAMEBUFFER, null), t.deleteTexture(n), t.deleteFramebuffer(r), o;
}
function ze(t) {
    return 2 === t && null != jt(t).fenceSync;
}
var Ge = Object.freeze({
    callAndCheck: Jt,
    canBeRepresented: ee,
    getWebGLErrorMessage: ne,
    getExtensionOrThrow: re,
    createVertexShader: oe,
    createFragmentShader: ae,
    createProgram: ce,
    linkProgram: le,
    validateProgram: he,
    createStaticVertexBuffer: fe,
    createStaticIndexBuffer: de,
    getNumChannels: function() {
        return 2 === i().getNumber("WEBGL_VERSION") ? 1 : 4;
    },
    createTexture: pe,
    validateTextureSize: ve,
    createFramebuffer: me,
    bindVertexBufferToProgramAttribute: ge,
    bindTextureUnit: ye,
    unbindTextureUnit: function(t, e, n) {
        Se(t, n), Jt(t, e, function() {
            return t.activeTexture(t.TEXTURE0 + n);
        }), Jt(t, e, function() {
            return t.bindTexture(t.TEXTURE_2D, null);
        });
    },
    getProgramUniformLocationOrThrow: xe,
    getProgramUniformLocation: be,
    bindTextureToProgramUniformSampler: we,
    bindCanvasToFramebuffer: function(t, e) {
        Jt(t, e, function() {
            return t.bindFramebuffer(t.FRAMEBUFFER, null);
        }), Jt(t, e, function() {
            return t.viewport(0, 0, t.canvas.width, t.canvas.height);
        }), Jt(t, e, function() {
            return t.scissor(0, 0, t.canvas.width, t.canvas.height);
        });
    },
    bindColorTextureToFramebuffer: Ce,
    unbindColorTextureFromFramebuffer: Ee,
    validateFramebuffer: Re,
    getFramebufferErrorMessage: Ie,
    getBatchDim: Ae,
    getRowsCols: De,
    getShapeAs3D: Te,
    getTextureShapeFromLogicalShape: Ne,
    isReshapeFree: _e,
    getWebGLMaxTextureSize: Oe,
    resetMaxTextureSize: function() {
        ie = null;
    },
    resetMaxTexturesInShader: function() {
        se = null;
    },
    getMaxTexturesInShader: Me,
    getWebGLDisjointQueryTimerVersion: Be,
    hasExtension: Pe,
    isWebGLVersionEnabled: Le,
    isCapableOfRenderingToFloatTexture: We,
    isDownloadFloatTextureEnabled: Ue,
    isWebGLFenceEnabled: ze
}), He = i();
function qe() {
    i().set("PROD", !0);
}
function Ke() {
    i().set("DEBUG", !0);
}
function je() {
    i().set("DEPRECATION_WARNINGS_ENABLED", !1), console.warn("TensorFlow.js deprecation warnings have been disabled.");
}
function Xe(t) {
    i().getBool("DEPRECATION_WARNINGS_ENABLED") && console.warn(t + " You can disable deprecation warnings with tf.disableDeprecationWarnings().");
}
function Ye() {
    Lt.disposeVariables();
}
function $e() {
    return Lt;
}
function Qe() {
    return Lt.memory();
}
function Je(t) {
    return Lt.profile(t);
}
function Ze(t, e) {
    return Lt.tidy(t, e);
}
function tn(t) {
    _t(t).forEach(function(t) {
        return t.dispose();
    });
}
function en(t) {
    return Lt.keep(t);
}
function nn(t) {
    return Lt.time(t);
}
function rn(t) {
    return Lt.setBackend(t);
}
function on() {
    return Lt.ready();
}
function an() {
    return Lt.backendName;
}
function sn(t) {
    Lt.removeBackend(t);
}
function un(t) {
    return Lt.findBackend(t);
}
function cn(t) {
    return Lt.findBackendFactory(t);
}
function ln(t, e, n) {
    return void 0 === n && (n = 1), Lt.registerBackend(t, e, n);
}
function hn() {
    return Lt.backend;
}
function fn(t, e) {
    i().setPlatform(t, e);
}
function dn() {
    for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
    i().getBool("IS_TEST") || console.warn.apply(console, t);
}
function pn(t, e) {
    var n = t;
    if (V(t)) return "string" === e ? [] : [
        t.length
    ];
    if (!Array.isArray(t)) return [];
    for(var r = []; Array.isArray(n) || V(n) && "string" !== e;)r.push(n.length), n = n[0];
    return Array.isArray(t) && i().getBool("TENSORLIKE_CHECK_SHAPE_CONSISTENCY") && function t(e, n, r) {
        if (r = r || [], !Array.isArray(e) && !V(e)) return void C(0 === n.length, function() {
            return "Element arr[" + r.join("][") + "] is a primitive, but should be an array/TypedArray of " + n[0] + " elements";
        });
        C(n.length > 0, function() {
            return "Element arr[" + r.join("][") + "] should be a primitive, but is an array of " + e.length + " elements";
        }), C(e.length === n[0], function() {
            return "Element arr[" + r.join("][") + "] should have " + n[0] + " elements, but has " + e.length + " elements";
        });
        for(var o = n.slice(1), a = 0; a < e.length; ++a)t(e[a], o, r.concat(a));
    }(t, r, []), r;
}
function vn(t, e, n, r) {
    if (null != t && ("numeric" !== t && t !== e || "numeric" === t && "string" === e)) throw new Error("Argument '" + n + "' passed to '" + r + "' must be " + t + " tensor, but got " + e + " tensor");
}
function mn(t, e, n, r) {
    if (void 0 === r && (r = "numeric"), t instanceof wt) return vn(r, t.dtype, e, n), t;
    var o = j(t);
    if ("string" !== o && [
        "bool",
        "int32",
        "float32"
    ].indexOf(r) >= 0 && (o = r), vn(r, o, e, n), null == t || !V(t) && !Array.isArray(t) && "number" != typeof t && "boolean" != typeof t && "string" != typeof t) {
        var a = null == t ? "null" : t.constructor.name;
        throw new Error("Argument '" + e + "' passed to '" + n + "' must be a Tensor or TensorLike, but got '" + a + "'");
    }
    var s = pn(t, o);
    V(t) || Array.isArray(t) || (t = [
        t
    ]);
    var u = "string" !== o ? Q(t, o, i().getBool("DEBUG")) : I(t, [], !0);
    return Lt.makeTensor(u, s, o);
}
function gn(t, e, n, r) {
    if (void 0 === r && (r = "numeric"), !Array.isArray(t)) throw new Error("Argument " + e + " passed to " + n + " must be a `Tensor[]` or `TensorLike[]`");
    return t.map(function(t, r) {
        return mn(t, e + "[" + r + "]", n);
    }, r);
}
function yn(t, e) {
    for(var n = 0; n < t.length; ++n)if (t[t.length - n - 1] !== e - 1 - n) return !1;
    return !0;
}
function xn(t, e, n) {
    for(var r = t.length + e.length, o = [], a = 0, i = 0, s = 0; s < r; s++)-1 === n.indexOf(s) ? o.push(t[a++]) : o.push(e[i++]);
    return o;
}
function bn(t, e) {
    for(var n = [], r = t.length, o = 0; o < r; o++)-1 === e.indexOf(o) && n.push(t[o]);
    return [
        n,
        e.map(function(e) {
            return t[e];
        })
    ];
}
function wn(t, e) {
    return xn(t, e.map(function(t) {
        return 1;
    }), e);
}
function Cn(t, e, n) {
    C(yn(e, n), function() {
        return t + " supports only inner-most axes for now. Got axes " + e + " and rank-" + n + " input.";
    });
}
function En(t, e) {
    if (yn(t, e)) return null;
    for(var n = [], r = 0; r < e; ++r)-1 === t.indexOf(r) && n.push(r);
    return t.forEach(function(t) {
        return n.push(t);
    }), n;
}
function Rn(t) {
    return t.map(function(t, e) {
        return [
            e,
            t
        ];
    }).sort(function(t, e) {
        return t[1] - e[1];
    }).map(function(t) {
        return t[0];
    });
}
function In(t, e) {
    for(var n = [], r = e - t; r < e; ++r)n.push(r);
    return n;
}
function kn(t, e) {
    var n = t[0].length;
    t.forEach(function(t, e) {
        C(t.length === n, function() {
            return "Error in concat" + n + "D: rank of tensors[" + e + "] must be the same as the rank of the rest (" + n + ")";
        });
    }), C(e >= 0 && e < n, function() {
        return "Error in concat" + n + "D: axis must be between 0 and " + (n - 1) + ".";
    });
    var r = t[0];
    t.forEach(function(t, o) {
        for(var a = 0; a < n; a++)C(a === e || t[a] === r[a], function() {
            return "Error in concat" + n + "D: Shape of tensors[" + o + "] (" + t + ") does not match the shape of the rest (" + r + ") along the non-concatenated axis " + o + ".";
        });
    });
}
function Sn(t, e) {
    for(var n = t[0].slice(), r = 1; r < t.length; r++)n[e] += t[r][e];
    return n;
}
function An(t) {
    var e = Object.keys(t);
    if (1 !== e.length) throw new Error("Please provide an object with a single key (operation name) mapping to a function. Got an object with " + e.length + " keys.");
    var n = e[0], r = t[n];
    n.endsWith("_") && (n = n.substring(0, n.length - 1));
    var o = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        Lt.startScope(n);
        try {
            var o = r.apply(void 0, t);
            return o instanceof Promise && console.error("Cannot return a Promise inside of tidy."), Lt.endScope(o), o;
        } catch (t) {
            throw Lt.endScope(null), t;
        }
    };
    return Object.defineProperty(o, "name", {
        value: n,
        configurable: !0
    }), o;
}
He.registerFlag("HAS_WEBGL", function() {
    return He.getNumber("WEBGL_VERSION") > 0;
}), He.registerFlag("WEBGL_VERSION", function() {
    return Le(2) ? 2 : Le(1) ? 1 : 0;
}), He.registerFlag("WEBGL_BUFFER_SUPPORTED", function() {
    return 2 === He.get("WEBGL_VERSION");
}), He.registerFlag("WEBGL_CPU_FORWARD", function() {
    return !0;
}), He.registerFlag("WEBGL_FORCE_F16_TEXTURES", function() {
    return !1;
}), He.registerFlag("WEBGL_PACK", function() {
    return He.getBool("HAS_WEBGL");
}), He.registerFlag("WEBGL_PACK_NORMALIZATION", function() {
    return He.getBool("WEBGL_PACK");
}), He.registerFlag("WEBGL_PACK_CLIP", function() {
    return He.getBool("WEBGL_PACK");
}), He.registerFlag("WEBGL_PACK_DEPTHWISECONV", function() {
    return !1;
}), He.registerFlag("WEBGL_PACK_BINARY_OPERATIONS", function() {
    return He.getBool("WEBGL_PACK");
}), He.registerFlag("WEBGL_PACK_UNARY_OPERATIONS", function() {
    return He.getBool("WEBGL_PACK");
}), He.registerFlag("WEBGL_PACK_ARRAY_OPERATIONS", function() {
    return He.getBool("WEBGL_PACK");
}), He.registerFlag("WEBGL_PACK_IMAGE_OPERATIONS", function() {
    return He.getBool("WEBGL_PACK");
}), He.registerFlag("WEBGL_PACK_REDUCE", function() {
    return He.getBool("WEBGL_PACK");
}), He.registerFlag("WEBGL_LAZILY_UNPACK", function() {
    return He.getBool("WEBGL_PACK");
}), He.registerFlag("WEBGL_CONV_IM2COL", function() {
    return He.getBool("WEBGL_PACK");
}), He.registerFlag("WEBGL_MAX_TEXTURE_SIZE", function() {
    return Oe(He.getNumber("WEBGL_VERSION"));
}), He.registerFlag("WEBGL_MAX_TEXTURES_IN_SHADER", function() {
    return Me(He.getNumber("WEBGL_VERSION"));
}), He.registerFlag("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION", function() {
    var t = He.getNumber("WEBGL_VERSION");
    return 0 === t ? 0 : Be(t);
}), He.registerFlag("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE", function() {
    var t;
    return He.getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 && (t = navigator.userAgent || navigator.vendor || window.opera, !(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))));
}), He.registerFlag("WEBGL_RENDER_FLOAT32_CAPABLE", function() {
    return We(He.getNumber("WEBGL_VERSION"));
}), He.registerFlag("WEBGL_RENDER_FLOAT32_ENABLED", function() {
    return !He.getBool("WEBGL_FORCE_F16_TEXTURES") && He.getBool("WEBGL_RENDER_FLOAT32_CAPABLE");
}), He.registerFlag("WEBGL_DOWNLOAD_FLOAT_ENABLED", function() {
    return Ue(He.getNumber("WEBGL_VERSION"));
}), He.registerFlag("WEBGL_FENCE_API_ENABLED", function() {
    return ze(He.getNumber("WEBGL_VERSION"));
}), He.registerFlag("WEBGL_SIZE_UPLOAD_UNIFORM", function() {
    return He.getBool("WEBGL_RENDER_FLOAT32_ENABLED") ? 4 : 0;
}), bt = Xe;
var Dn = An({
    complex_: function(t, e) {
        var n = mn(t, "real", "complex"), r = mn(e, "imag", "complex");
        return E(n.shape, r.shape, "real and imag shapes, " + n.shape + " and " + r.shape + ", must match in call to tf.complex()."), Lt.runKernelFunc(function(t) {
            return t.complex(n, r);
        }, {
            $real: n,
            $imag: r
        });
    }
}), Tn = An({
    real_: function(t) {
        var e = mn(t, "input", "real");
        return Lt.runKernelFunc(function(t) {
            return t.real(e);
        }, {
            $input: e
        });
    }
}), Nn = An({
    imag_: function(t) {
        var e = mn(t, "input", "imag");
        return Lt.runKernelFunc(function(t) {
            return t.imag(e);
        }, {
            $input: e
        });
    }
});
function Fn(t, e, n) {
    return _n(t, e, pn(t, n), n);
}
function _n(t, e, n, r) {
    if (null == r && (r = j(t)), "complex64" === r) throw new Error("Cannot construct a complex64 tensor directly. Please use tf.complex(real, imag).");
    if (!V(t) && !Array.isArray(t) && "number" != typeof t && "boolean" != typeof t && "string" != typeof t) throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");
    if (null != e) {
        nt(e);
        var o = k(e), a = k(n);
        C(o === a, function() {
            return "Based on the provided shape, [" + e + "], the tensor should have " + o + " values but has " + a;
        });
        for(var s = 0; s < n.length; ++s){
            var u = n[s], c = s !== n.length - 1 || u !== k(e.slice(s));
            C(n[s] === e[s] || !c, function() {
                return "Error creating a new Tensor. Inferred shape (" + n + ") does not match the provided shape (" + e + "). ";
            });
        }
    }
    return V(t) || Array.isArray(t) || (t = [
        t
    ]), e = e || n, t = "string" !== r ? Q(t, r, i().getBool("DEBUG")) : I(t, [], !0), Lt.makeTensor(t, e, r);
}
function On(t, e) {
    if ((V(t) && "string" !== e || Array.isArray(t)) && "complex64" !== e) throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");
    if ("string" === e && V(t) && !(t instanceof Uint8Array)) throw new Error("When making a scalar from encoded string, the value must be `Uint8Array`.");
    return _n(t, [], [], e);
}
function Mn(t, e) {
    R(t);
    var n = pn(t, e);
    if (1 !== n.length) throw new Error("tensor1d() requires values to be a flat/TypedArray");
    return _n(t, null, n, e);
}
function Bn(t, e, n) {
    if (R(t), null != e && 2 !== e.length) throw new Error("tensor2d() requires shape to have two numbers");
    var r = pn(t, n);
    if (2 !== r.length && 1 !== r.length) throw new Error("tensor2d() requires values to be number[][] or flat/TypedArray");
    if (1 === r.length && null == e) throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
    return _n(t, e, r, n);
}
function Pn(t, e, n) {
    if (R(t), null != e && 3 !== e.length) throw new Error("tensor3d() requires shape to have three numbers");
    var r = pn(t, n);
    if (3 !== r.length && 1 !== r.length) throw new Error("tensor3d() requires values to be number[][][] or flat/TypedArray");
    if (1 === r.length && null == e) throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");
    return _n(t, e, r, n);
}
function Ln(t, e, n) {
    if (R(t), null != e && 4 !== e.length) throw new Error("tensor4d() requires shape to have four numbers");
    var r = pn(t, n);
    if (4 !== r.length && 1 !== r.length) throw new Error("tensor4d() requires values to be number[][][][] or flat/TypedArray");
    if (1 === r.length && null == e) throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");
    return _n(t, e, r, n);
}
function Wn(t, e, n) {
    if (R(t), null != e && 5 !== e.length) throw new Error("tensor5d() requires shape to have five numbers");
    var r = pn(t, n);
    if (5 !== r.length && 1 !== r.length) throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");
    if (1 === r.length && null == e) throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");
    return _n(t, e, r, n);
}
function Un(t, e, n) {
    if (R(t), null != e && 6 !== e.length) throw new Error("tensor6d() requires shape to have six numbers");
    var r = pn(t, n);
    if (6 !== r.length && 1 !== r.length) throw new Error("tensor6d() requires values to be number[][][][][][] or flat/TypedArray");
    if (1 === r.length && null == e) throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");
    return _n(t, e = e || r, r, n);
}
function Vn(t, e, n, r) {
    return void 0 === e && (e = !0), Lt.makeVariable(t, e, n, r);
}
function zn(t, e) {
    if (void 0 === e && (e = "float32"), "complex64" === e) {
        var n = zn(t, "float32"), r = Gn(t, "float32");
        return Dn(n, r);
    }
    var o = Z(k(t), e);
    return Lt.makeTensor(o, t, e);
}
function Gn(t, e) {
    if (void 0 === e && (e = "float32"), "complex64" === e) {
        var n = Gn(t, "float32"), r = Gn(t, "float32");
        return Dn(n, r);
    }
    var o = tt(k(t), e);
    return Lt.makeTensor(o, t, e);
}
function Hn(t, e, n) {
    return Lt.runKernelFunc(function(r) {
        return r.fill(t, e, n);
    }, {});
}
function qn(t, e, n) {
    if (n <= 0) throw new Error("The number of values should be positive.");
    return Lt.runKernelFunc(function(r) {
        return r.linspace(t, e, n);
    }, {});
}
function Kn(t, e, n, r) {
    if (void 0 === n && (n = 1), void 0 === r && (r = "float32"), 0 === n) throw new Error("Cannot have a step of zero");
    if (t === e || t < e && n < 0 || e < t && n > 1) return Gn([
        0
    ], r);
    var o = tt(Math.abs(Math.ceil((e - t) / n)), r);
    e < t && 1 === n && (n = -1), o[0] = t;
    for(var a = 1; a < o.length; a++)o[a] = o[a - 1] + n;
    return Mn(o, r);
}
var jn = An({
    onesLike_: function(t) {
        var e = mn(t, "x", "onesLike");
        if ("complex64" === e.dtype) {
            var n = jn(Tn(e)), r = Xn(Nn(e));
            return Dn(n, r);
        }
        return Lt.runKernelFunc(function(t) {
            return t.onesLike(e);
        }, {
            $x: e
        }, function(t, e) {
            return {
                $x: function() {
                    return Xn(t);
                }
            };
        });
    }
}), Xn = An({
    zerosLike_: function(t) {
        var e = mn(t, "x", "zerosLike");
        return Lt.runKernelFunc(function(t) {
            return t.zerosLike(e);
        }, {
            $x: e
        }, function(t, e) {
            return {
                $x: function() {
                    return Xn(t);
                }
            };
        });
    }
});
var Yn = An({
    concat_: function(t, e) {
        void 0 === e && (e = 0), C(t.length >= 1, function() {
            return "Pass at least one tensor to concat";
        });
        var n = gn(t, "tensors", "concat");
        "complex64" === n[0].dtype && n.forEach(function(t) {
            if ("complex64" !== t.dtype) throw new Error("Cannot concatenate complex64 tensors with a tensor\n          with dtype " + t.dtype + ". ");
        }), e = O(e, n[0].shape)[0];
        var r = Sn(n.map(function(t) {
            return t.shape;
        }), e);
        if (0 === k(r)) return Fn([], r);
        if (1 === (n = n.filter(function(t) {
            return t.size > 0;
        })).length) return n[0];
        var o = n.map(function(t) {
            return t.shape;
        });
        kn(o, e);
        var a = n, i = {
            axis: e
        };
        return Lt.runKernelFunc(function(t) {
            return t.concat(n, e);
        }, a, function(t) {
            var n = o.map(function(t) {
                return t[e];
            });
            return tr(t, n, e).map(function(t) {
                return function() {
                    return t;
                };
            });
        }, "Concat", i);
    }
}), $n = An({
    concat1d_: function(t) {
        return Yn(t, 0);
    }
}), Qn = An({
    concat2d_: function(t, e) {
        return Yn(t, e);
    }
}), Jn = An({
    concat3d_: function(t, e) {
        return Yn(t, e);
    }
}), Zn = An({
    concat4d_: function(t, e) {
        return Yn(t, e);
    }
}), tr = An({
    split_: function(t, e, n) {
        void 0 === n && (n = 0);
        var r, o = mn(t, "x", "split");
        return n = O(n, o.shape)[0], "number" == typeof e ? (C(o.shape[n] % e == 0, function() {
            return "Number of splits must evenly divide the axis.";
        }), r = new Array(e).fill(o.shape[n] / e)) : (C(o.shape[n] === e.reduce(function(t, e) {
            return t + e;
        }), function() {
            return "The sum of sizes must match the size of the axis dimension.";
        }), r = e), Lt.runKernelFunc(function(t) {
            return t.split(o, r, n);
        }, {
            $x: o
        }, function(t) {
            return {
                $x: function() {
                    return Yn(t, n);
                }
            };
        });
    }
});
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
function er(t, e) {
    return t(e = {
        exports: {}
    }, e.exports), e.exports;
}
var nr = er(function(t) {
    !function(t, e, n) {
        function r(t) {
            var e, n = this, r = (e = 4022871197, function(t) {
                t = t.toString();
                for(var n = 0; n < t.length; n++){
                    var r = .02519603282416938 * (e += t.charCodeAt(n));
                    r -= e = r >>> 0, e = (r *= e) >>> 0, e += 4294967296 * (r -= e);
                }
                return 2.3283064365386963e-10 * (e >>> 0);
            });
            n.next = function() {
                var t = 2091639 * n.s0 + 2.3283064365386963e-10 * n.c;
                return n.s0 = n.s1, n.s1 = n.s2, n.s2 = t - (n.c = 0 | t);
            }, n.c = 1, n.s0 = r(" "), n.s1 = r(" "), n.s2 = r(" "), n.s0 -= r(t), n.s0 < 0 && (n.s0 += 1), n.s1 -= r(t), n.s1 < 0 && (n.s1 += 1), n.s2 -= r(t), n.s2 < 0 && (n.s2 += 1), r = null;
        }
        function o(t, e) {
            return e.c = t.c, e.s0 = t.s0, e.s1 = t.s1, e.s2 = t.s2, e;
        }
        function a(t, e) {
            var n = new r(t), a = e && e.state, i = n.next;
            return i.int32 = function() {
                return 4294967296 * n.next() | 0;
            }, i.double = function() {
                return i() + 11102230246251565e-32 * (2097152 * i() | 0);
            }, i.quick = i, a && ("object" == typeof a && o(a, n), i.state = function() {
                return o(n, {});
            }), i;
        }
        e && e.exports ? e.exports = a : n && n.amd ? n(function() {
            return a;
        }) : this.alea = a;
    }(0, t, !1);
}), rr = er(function(t) {
    !function(t, e, n) {
        function r(t) {
            var e = this, n = "";
            e.x = 0, e.y = 0, e.z = 0, e.w = 0, e.next = function() {
                var t = e.x ^ e.x << 11;
                return e.x = e.y, e.y = e.z, e.z = e.w, e.w ^= e.w >>> 19 ^ t ^ t >>> 8;
            }, t === (0 | t) ? e.x = t : n += t;
            for(var r = 0; r < n.length + 64; r++)e.x ^= 0 | n.charCodeAt(r), e.next();
        }
        function o(t, e) {
            return e.x = t.x, e.y = t.y, e.z = t.z, e.w = t.w, e;
        }
        function a(t, e) {
            var n = new r(t), a = e && e.state, i = function() {
                return (n.next() >>> 0) / 4294967296;
            };
            return i.double = function() {
                do var t = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / 2097152;
                while (0 === t);
                return t;
            }, i.int32 = n.next, i.quick = i, a && ("object" == typeof a && o(a, n), i.state = function() {
                return o(n, {});
            }), i;
        }
        e && e.exports ? e.exports = a : n && n.amd ? n(function() {
            return a;
        }) : this.xor128 = a;
    }(0, t, !1);
}), or = er(function(t) {
    !function(t, e, n) {
        function r(t) {
            var e = this, n = "";
            e.next = function() {
                var t = e.x ^ e.x >>> 2;
                return e.x = e.y, e.y = e.z, e.z = e.w, e.w = e.v, (e.d = e.d + 362437 | 0) + (e.v = e.v ^ e.v << 4 ^ t ^ t << 1) | 0;
            }, e.x = 0, e.y = 0, e.z = 0, e.w = 0, e.v = 0, t === (0 | t) ? e.x = t : n += t;
            for(var r = 0; r < n.length + 64; r++)e.x ^= 0 | n.charCodeAt(r), r == n.length && (e.d = e.x << 10 ^ e.x >>> 4), e.next();
        }
        function o(t, e) {
            return e.x = t.x, e.y = t.y, e.z = t.z, e.w = t.w, e.v = t.v, e.d = t.d, e;
        }
        function a(t, e) {
            var n = new r(t), a = e && e.state, i = function() {
                return (n.next() >>> 0) / 4294967296;
            };
            return i.double = function() {
                do var t = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / 2097152;
                while (0 === t);
                return t;
            }, i.int32 = n.next, i.quick = i, a && ("object" == typeof a && o(a, n), i.state = function() {
                return o(n, {});
            }), i;
        }
        e && e.exports ? e.exports = a : n && n.amd ? n(function() {
            return a;
        }) : this.xorwow = a;
    }(0, t, !1);
}), ar = er(function(t) {
    !function(t, e, n) {
        function r(t) {
            var e = this;
            e.next = function() {
                var t, n, r = e.x, o = e.i;
                return t = r[o], n = (t ^= t >>> 7) ^ t << 24, n ^= (t = r[o + 1 & 7]) ^ t >>> 10, n ^= (t = r[o + 3 & 7]) ^ t >>> 3, n ^= (t = r[o + 4 & 7]) ^ t << 7, t = r[o + 7 & 7], n ^= (t ^= t << 13) ^ t << 9, r[o] = n, e.i = o + 1 & 7, n;
            }, function(t, e) {
                var n, r = [];
                if (e === (0 | e)) r[0] = e;
                else for(e = "" + e, n = 0; n < e.length; ++n)r[7 & n] = r[7 & n] << 15 ^ e.charCodeAt(n) + r[n + 1 & 7] << 13;
                for(; r.length < 8;)r.push(0);
                for(n = 0; n < 8 && 0 === r[n]; ++n);
                for(8 == n ? r[7] = -1 : r[n], t.x = r, t.i = 0, n = 256; n > 0; --n)t.next();
            }(e, t);
        }
        function o(t, e) {
            return e.x = t.x.slice(), e.i = t.i, e;
        }
        function a(t, e) {
            null == t && (t = +new Date);
            var n = new r(t), a = e && e.state, i = function() {
                return (n.next() >>> 0) / 4294967296;
            };
            return i.double = function() {
                do var t = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / 2097152;
                while (0 === t);
                return t;
            }, i.int32 = n.next, i.quick = i, a && (a.x && o(a, n), i.state = function() {
                return o(n, {});
            }), i;
        }
        e && e.exports ? e.exports = a : n && n.amd ? n(function() {
            return a;
        }) : this.xorshift7 = a;
    }(0, t, !1);
}), ir = er(function(t) {
    !function(t, e, n) {
        function r(t) {
            var e = this;
            e.next = function() {
                var t, n, r = e.w, o = e.X, a = e.i;
                return e.w = r = r + 1640531527 | 0, n = o[a + 34 & 127], t = o[a = a + 1 & 127], n ^= n << 13, t ^= t << 17, n ^= n >>> 15, t ^= t >>> 12, n = o[a] = n ^ t, e.i = a, n + (r ^ r >>> 16) | 0;
            }, function(t, e) {
                var n, r, o, a, i, s = [], u = 128;
                for(e === (0 | e) ? (r = e, e = null) : (e += "\0", r = 0, u = Math.max(u, e.length)), o = 0, a = -32; a < u; ++a)e && (r ^= e.charCodeAt((a + 32) % e.length)), 0 === a && (i = r), r ^= r << 10, r ^= r >>> 15, r ^= r << 4, r ^= r >>> 13, a >= 0 && (i = i + 1640531527 | 0, o = 0 == (n = s[127 & a] ^= r + i) ? o + 1 : 0);
                for(o >= 128 && (s[127 & (e && e.length || 0)] = -1), o = 127, a = 512; a > 0; --a)r = s[o + 34 & 127], n = s[o = o + 1 & 127], r ^= r << 13, n ^= n << 17, r ^= r >>> 15, n ^= n >>> 12, s[o] = r ^ n;
                t.w = i, t.X = s, t.i = o;
            }(e, t);
        }
        function o(t, e) {
            return e.i = t.i, e.w = t.w, e.X = t.X.slice(), e;
        }
        function a(t, e) {
            null == t && (t = +new Date);
            var n = new r(t), a = e && e.state, i = function() {
                return (n.next() >>> 0) / 4294967296;
            };
            return i.double = function() {
                do var t = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / 2097152;
                while (0 === t);
                return t;
            }, i.int32 = n.next, i.quick = i, a && (a.X && o(a, n), i.state = function() {
                return o(n, {});
            }), i;
        }
        e && e.exports ? e.exports = a : n && n.amd ? n(function() {
            return a;
        }) : this.xor4096 = a;
    }(0, t, !1);
}), sr = er(function(t) {
    !function(t, e, n) {
        function r(t) {
            var e = this, n = "";
            e.next = function() {
                var t = e.b, n = e.c, r = e.d, o = e.a;
                return t = t << 25 ^ t >>> 7 ^ n, n = n - r | 0, r = r << 24 ^ r >>> 8 ^ o, o = o - t | 0, e.b = t = t << 20 ^ t >>> 12 ^ n, e.c = n = n - r | 0, e.d = r << 16 ^ n >>> 16 ^ o, e.a = o - t | 0;
            }, e.a = 0, e.b = 0, e.c = -1640531527, e.d = 1367130551, t === Math.floor(t) ? (e.a = t / 4294967296 | 0, e.b = 0 | t) : n += t;
            for(var r = 0; r < n.length + 20; r++)e.b ^= 0 | n.charCodeAt(r), e.next();
        }
        function o(t, e) {
            return e.a = t.a, e.b = t.b, e.c = t.c, e.d = t.d, e;
        }
        function a(t, e) {
            var n = new r(t), a = e && e.state, i = function() {
                return (n.next() >>> 0) / 4294967296;
            };
            return i.double = function() {
                do var t = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / 2097152;
                while (0 === t);
                return t;
            }, i.int32 = n.next, i.quick = i, a && ("object" == typeof a && o(a, n), i.state = function() {
                return o(n, {});
            }), i;
        }
        e && e.exports ? e.exports = a : n && n.amd ? n(function() {
            return a;
        }) : this.tychei = a;
    }(0, t, !1);
});

var ur = er(function(t) {
    !function(e, n) {
        var r, o = this, a = 256, i = 6, s = "random", u = n.pow(a, i), c = n.pow(2, 52), l = 2 * c, h = a - 1;
        function f(t, h, f) {
            var g = [], y = v(function t(e, n) {
                var r, o = [], a = typeof e;
                if (n && "object" == a) for(r in e)try {
                    o.push(t(e[r], n - 1));
                } catch (t) {}
                return o.length ? o : "string" == a ? e : e + "\0";
            }((h = 1 == h ? {
                entropy: !0
            } : h || {}).entropy ? [
                t,
                m(e)
            ] : null == t ? function() {
                try {
                    var t;
                    return r && (t = r.randomBytes) ? t = t(a) : (t = new Uint8Array(a), (o.crypto || o.msCrypto).getRandomValues(t)), m(t);
                } catch (t) {
                    var n = o.navigator, i = n && n.plugins;
                    return [
                        +new Date,
                        o,
                        i,
                        o.screen,
                        m(e)
                    ];
                }
            }() : t, 3), g), x = new d(g), b = function() {
                for(var t = x.g(i), e = u, n = 0; t < c;)t = (t + n) * a, e *= a, n = x.g(1);
                for(; t >= l;)t /= 2, e /= 2, n >>>= 1;
                return (t + n) / e;
            };
            return b.int32 = function() {
                return 0 | x.g(4);
            }, b.quick = function() {
                return x.g(4) / 4294967296;
            }, b.double = b, v(m(x.S), e), (h.pass || f || function(t, e, r, o) {
                return o && (o.S && p(o, x), t.state = function() {
                    return p(x, {});
                }), r ? (n[s] = t, e) : t;
            })(b, y, "global" in h ? h.global : this == n, h.state);
        }
        function d(t) {
            var e, n = t.length, r = this, o = 0, i = r.i = r.j = 0, s = r.S = [];
            for(n || (t = [
                n++
            ]); o < a;)s[o] = o++;
            for(o = 0; o < a; o++)s[o] = s[i = h & i + t[o % n] + (e = s[o])], s[i] = e;
            (r.g = function(t) {
                for(var e, n = 0, o = r.i, i = r.j, s = r.S; t--;)e = s[o = h & o + 1], n = n * a + s[h & (s[o] = s[i = h & i + e]) + (s[i] = e)];
                return r.i = o, r.j = i, n;
            })(a);
        }
        function p(t, e) {
            return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
        }
        function v(t, e) {
            for(var n, r = t + "", o = 0; o < r.length;)e[h & o] = h & (n ^= 19 * e[h & o]) + r.charCodeAt(o++);
            return m(e);
        }
        function m(t) {
            return String.fromCharCode.apply(0, t);
        }
        if (n["seed" + s] = f, v(n.random(), e), t.exports) {
            t.exports = f;
            try {
                r = (parcelRequire("1S6xU"));
            } catch (t) {}
        }
    }([], Math);
});
ur.alea = nr, ur.xor128 = rr, ur.xorwow = or, ur.xorshift7 = ar, ur.xor4096 = ir, ur.tychei = sr;
var cr = ur.alea, lr = function() {
    function t(t, e, n, r, o) {
        this.mean = t, this.stdDev = e, this.dtype = n, this.nextVal = NaN, this.truncated = r, this.truncated && (this.upper = this.mean + 2 * this.stdDev, this.lower = this.mean - 2 * this.stdDev);
        var a = o || Math.random();
        this.random = cr(a.toString());
    }
    return t.prototype.nextValue = function() {
        if (!isNaN(this.nextVal)) {
            var t = this.nextVal;
            return this.nextVal = NaN, t;
        }
        for(var e, n, r = !1; !r;){
            var o = void 0, a = void 0, i = void 0;
            do i = (o = 2 * this.random() - 1) * o + (a = 2 * this.random() - 1) * a;
            while (i >= 1 || 0 === i);
            var s = Math.sqrt(-2 * Math.log(i) / i);
            e = this.mean + this.stdDev * o * s, n = this.mean + this.stdDev * a * s, this.truncated && !this.isValidTruncated(e) || (r = !0);
        }
        return this.truncated && !this.isValidTruncated(n) || (this.nextVal = this.convertValue(n)), this.convertValue(e);
    }, t.prototype.convertValue = function(t) {
        return null == this.dtype || "float32" === this.dtype ? t : Math.round(t);
    }, t.prototype.isValidTruncated = function(t) {
        return t <= this.upper && t >= this.lower;
    }, t;
}(), hr = function() {
    function t(t, e, n, r) {
        this.alpha = t, this.beta = 1 / e, this.dtype = n;
        var o = r || Math.random();
        this.randu = cr(o.toString()), this.randn = new lr(0, 1, n, !1, this.randu()), this.d = t < 1 ? t + 2 / 3 : t - 1 / 3, this.c = 1 / Math.sqrt(9 * this.d);
    }
    return t.prototype.nextValue = function() {
        for(var t, e, n, r, o, a;;){
            do r = this.randn.nextValue(), a = 1 + this.c * r;
            while (a <= 0);
            if (a *= a * a, e = 1 - .331 * (t = r * r) * t, n = .5 * t + this.d * (1 - a + Math.log(a)), (o = this.randu()) < e || Math.log(o) < n) break;
        }
        return a = 1 / this.beta * this.d * a, this.alpha < 1 && (a *= Math.pow(this.randu(), 1 / this.alpha)), this.convertValue(a);
    }, t.prototype.convertValue = function(t) {
        return "float32" === this.dtype ? t : Math.round(t);
    }, t;
}(), fr = function() {
    function t(t, e, n, r) {
        var o = this;
        if (void 0 === t && (t = 0), void 0 === e && (e = 1), this.canReturnFloat = function() {
            return null == o.dtype || "float32" === o.dtype;
        }, this.min = t, this.range = e - t, this.dtype = n, null == r && (r = Math.random()), "number" == typeof r && (r = r.toString()), !this.canReturnFloat() && this.range <= 1) throw new Error("The difference between " + t + " - " + e + " <= 1 and dtype is not float");
        this.random = cr(r);
    }
    return t.prototype.convertValue = function(t) {
        return this.canReturnFloat() ? t : Math.round(t);
    }, t.prototype.nextValue = function() {
        return this.convertValue(this.min + this.range * this.random());
    }, t;
}();
function dr(t, e, n) {
    return void 0 === e && (e = "float32"), e = e || "float32", nt(t), new gt(t, e, n);
}
function pr(t, e) {
    void 0 === e && (e = !1), console.log(t.toString(e));
}
var vr = An({
    batchToSpaceND_: function(t, e, n) {
        var r = mn(t, "x", "batchToSpaceND"), o = e.reduce(function(t, e) {
            return t * e;
        });
        return C(r.rank >= 1 + e.length, function() {
            return "input rank is " + r.rank + " but should be > than blockShape.length " + e.length;
        }), C(n.length === e.length, function() {
            return "crops.length is " + n.length + " but should be equal to blockShape.length  " + e.length;
        }), C(r.shape[0] % o == 0, function() {
            return "input tensor batch is " + r.shape[0] + " but is not divisible by the product of the elements of blockShape " + e.join(" * ") + " === " + o;
        }), Lt.runKernelFunc(function(t) {
            return t.batchToSpaceND(r, e, n);
        }, {
            $x: r
        }, function(t) {
            return {
                $x: function() {
                    return t.spaceToBatchND(e, n);
                }
            };
        });
    }
}), mr = An({
    broadcastTo_: function(t, e) {
        var n = mn(t, "broadcastTo", "x"), r = n.shape;
        if (e.some(function(t) {
            return !(t > 0) || t % 1 != 0;
        })) throw new Error("broadcastTo(): Invalid broadcast shape [" + e + "].");
        if (e.length < n.rank) throw new Error("broadcastTo(): shape.length=" + e.length + " < input.rank=" + n.rank + ".");
        if (e.length > n.rank) {
            for(var o = n.shape.slice(); o.length < e.length;)o.unshift(1);
            n = n.reshape(o);
        }
        for(var a = Array.from(e), i = e.length - 1; i >= 0; i--)if (n.shape[i] === e[i]) a[i] = 1;
        else if (1 !== n.shape[i]) throw new Error("broadcastTo(): [" + r + "] cannot be broadcast to [" + e + "].");
        var s = a.map(function(t, e) {
            return t > 1 ? e : -1;
        }).filter(function(t) {
            return t >= 0;
        });
        return 0 === s.length ? n.clone() : Lt.runKernelFunc(function(t) {
            return t.tile(n, a);
        }, {
            input: n
        }, function(t) {
            return {
                input: function() {
                    return t.sum(s, !0);
                }
            };
        });
    }
}), gr = An({
    cast_: function(t, e) {
        var n = mn(t, "x", "cast");
        if (!W(e)) throw new Error("Failed to cast to unknown dtype " + e);
        if ("string" === e && "string" !== n.dtype || "string" !== e && "string" === n.dtype) throw new Error("Only strings can be casted to strings");
        var r = {
            dtype: e
        };
        return Lt.runKernelFunc(function(t) {
            return t.cast(n, e);
        }, {
            x: n
        }, function(t) {
            return {
                x: function() {
                    return t.clone();
                }
            };
        }, "Cast", r);
    }
}), yr = An({
    clone_: function(t) {
        var e = mn(t, "x", "clone", null);
        return Lt.runKernelFunc(function() {
            return Lt.makeTensorFromDataId(e.dataId, e.shape, e.dtype);
        }, {
            $x: e
        }, function(t) {
            return {
                $x: function() {
                    return t.toFloat();
                }
            };
        });
    }
}), xr = An({
    cumsum_: function(t, e, n, r) {
        void 0 === e && (e = 0), void 0 === n && (n = !1), void 0 === r && (r = !1);
        var o = mn(t, "x", "cumsum"), a = En([
            e |= 0
        ], o.rank), i = o;
        null != a && (i = o.transpose(a));
        var s = In(1, o.rank)[0], u = Lt.runKernelFunc(function(t) {
            return t.cumsum(i, s, n, r);
        }, {
            permutedX: i
        }, function(t) {
            return {
                permutedX: function() {
                    return t.cumsum(e, n, !r);
                }
            };
        });
        return null != a && (u = u.transpose(a)), u;
    }
}), br = An({
    depthToSpace_: function(t, e, n) {
        void 0 === n && (n = "NHWC");
        var r = mn(t, "x", "depthToSpace"), o = "NHWC" === n ? r.shape[1] : r.shape[2], a = "NHWC" === n ? r.shape[2] : r.shape[3], i = "NHWC" === n ? r.shape[3] : r.shape[1];
        return C(o * e >= 0, function() {
            return "Negative dimension size caused by overflow when multiplying\n      " + o + " and " + e + "  for depthToSpace with input shape\n      " + r.shape;
        }), C(a * e >= 0, function() {
            return "Negative dimension size caused by overflow when multiplying\n      " + a + " and " + e + " for depthToSpace with input shape\n          " + r.shape;
        }), C(i % (e * e) == 0, function() {
            return "Dimension size must be evenly divisible by " + e * e + " but is " + i + " for depthToSpace with input shape " + r.shape;
        }), Lt.runKernelFunc(function(t) {
            return t.depthToSpace(r, e, n);
        }, {
            $x: r
        });
    }
}), wr = An({
    expandDims_: function(t, e) {
        void 0 === e && (e = 0);
        var n = mn(t, "x", "expandDims", null);
        C(e <= n.rank, function() {
            return "Axis must be <= rank of the tensor";
        });
        var r = n.shape.slice();
        return e < 0 && (C(-(n.rank + 1) <= e, function() {
            return "Axis must be in the interval [" + -(n.rank + 1) + ", " + n.rank + "]";
        }), e = n.rank + e + 1), r.splice(e, 0, 1), Or(n, r);
    }
}), Cr = An({
    eye_: function(t, e, n, r) {
        void 0 === r && (r = "float32"), null == e && (e = t);
        for(var o = dr([
            t,
            e
        ], r), a = t <= e ? t : e, i = 0; i < a; ++i)o.set(1, i, i);
        var s = o.toTensor().as2D(t, e);
        if (null == n) return s;
        if (1 === n.length) return Lr(wr(s, 0), [
            n[0],
            1,
            1
        ]);
        if (2 === n.length) return Lr(wr(wr(s, 0), 0), [
            n[0],
            n[1],
            1,
            1
        ]);
        if (3 === n.length) return Lr(wr(wr(wr(s, 0), 0), 0), [
            n[0],
            n[1],
            n[2],
            1,
            1
        ]);
        throw new Error("eye() currently supports only 1D and 2D batchShapes, but received " + n.length + "D.");
    }
}), Er = An({
    multinomial_: function(t, e, n, r) {
        void 0 === r && (r = !1);
        var o = mn(t, "logits", "multinomial"), a = o.size, i = o.rank;
        if (a < 2) throw new Error("Error in multinomial: you need at least 2 outcomes, but got " + a + ".");
        if (i > 2) throw new Error("Rank of probabilities must be 1 or 2, but is " + i);
        n = n || Math.random();
        var s = 1 === i ? o.as2D(1, -1) : o, u = Lt.runKernelFunc(function(t) {
            return t.multinomial(s, r, e, n);
        }, {
            logits2D: s
        });
        return 1 === i ? u.as1D() : u;
    }
}), Rr = An({
    oneHot_: function(t, e, n, r) {
        if (void 0 === n && (n = 1), void 0 === r && (r = 0), e < 2) throw new Error("Error in oneHot: depth must be >=2, but it is " + e);
        var o = mn(t, "indices", "oneHot", "int32"), a = o.shape.concat([
            e
        ]);
        return o = o.flatten(), Lt.runKernelFunc(function(t) {
            return t.oneHot(o, e, n, r);
        }, {
            $indices: o
        }, function(t) {
            return {
                $indices: function() {
                    return Gn(o.shape, "float32");
                }
            };
        }).reshape(a);
    }
}), Ir = An({
    pad_: function(t, e, n) {
        void 0 === n && (n = 0);
        var r = mn(t, "x", "pad");
        if (0 === r.rank) throw new Error("pad(scalar) is not defined. Pass non-scalar to pad");
        var o = {
            paddings: e,
            constantValue: n
        };
        return Lt.runKernelFunc(function(t) {
            return t.pad(r, e, n);
        }, {
            x: r
        }, function(t) {
            var n = e.map(function(t) {
                return t[0];
            });
            return {
                x: function() {
                    return t.slice(n, r.shape);
                }
            };
        }, "PadV2", o);
    }
}), kr = An({
    pad1d_: function(t, e, n) {
        return void 0 === n && (n = 0), C(2 === e.length, function() {
            return "Invalid number of paddings. Must be length of 2.";
        }), Ir(t, [
            e
        ], n);
    }
}), Sr = An({
    pad2d_: function(t, e, n) {
        return void 0 === n && (n = 0), C(2 === e.length && 2 === e[0].length && 2 === e[1].length, function() {
            return "Invalid number of paddings. Must be length of 2 each.";
        }), Ir(t, e, n);
    }
}), Ar = An({
    pad3d_: function(t, e, n) {
        return void 0 === n && (n = 0), C(3 === e.length && 2 === e[0].length && 2 === e[1].length && 2 === e[2].length, function() {
            return "Invalid number of paddings. Must be length of 2 each.";
        }), Ir(t, e, n);
    }
}), Dr = An({
    pad4d_: function(t, e, n) {
        return void 0 === n && (n = 0), C(4 === e.length && 2 === e[0].length && 2 === e[1].length && 2 === e[2].length && 2 === e[3].length, function() {
            return "Invalid number of paddings. Must be length of 2 each.";
        }), Ir(t, e, n);
    }
}), Tr = An({
    rand_: function(t, e, n) {
        var r = k(t), o = null;
        if (null == n || "float32" === n) o = new Float32Array(r);
        else if ("int32" === n) o = new Int32Array(r);
        else {
            if ("bool" !== n) throw new Error("Unknown data type " + n);
            o = new Uint8Array(r);
        }
        for(var a = 0; a < r; a++)o[a] = e();
        return Lt.makeTensor(o, t, n);
    }
}), Nr = An({
    randomNormal_: function(t, e, n, r, o) {
        if (void 0 === e && (e = 0), void 0 === n && (n = 1), null != r && "bool" === r) throw new Error("Unsupported data type " + r);
        for(var a = new lr(e, n, r, !1, o), i = dr(t, r), s = 0; s < i.values.length; s++)i.values[s] = a.nextValue();
        return i.toTensor();
    }
}), Fr = An({
    randomGamma_: function(t, e, n, r, o) {
        if (void 0 === n && (n = 1), void 0 === r && (r = "float32"), null == n && (n = 1), null == r && (r = "float32"), "float32" !== r && "int32" !== r) throw new Error("Unsupported data type " + r);
        for(var a = new hr(e, n, r, o), i = dr(t, r), s = 0; s < i.values.length; s++)i.values[s] = a.nextValue();
        return i.toTensor();
    }
}), _r = An({
    randomUniform_: function(t, e, n, r, o) {
        void 0 === e && (e = 0), void 0 === n && (n = 1), void 0 === r && (r = "float32");
        for(var a = dr(t, r), i = new fr(e, n, null, o), s = 0; s < a.values.length; s++)a.values[s] = i.nextValue();
        return a.toTensor();
    }
}), Or = An({
    reshape_: function(t, e) {
        var n = mn(t, "x", "reshape", null);
        e = _(e, n.size), C(n.size === k(e), function() {
            return "new shape and old shape must have the same number of elements.";
        });
        var r = {
            shape: e
        };
        return Lt.runKernelFunc(function(t) {
            return t.reshape(n, e);
        }, {
            x: n
        }, function(t) {
            return {
                x: function() {
                    return t.reshape(n.shape);
                }
            };
        }, "Reshape", r);
    }
}), Mr = An({
    spaceToBatchND_: function(t, e, n) {
        var r = mn(t, "x", "spaceToBatchND");
        return C(r.rank >= 1 + e.length, function() {
            return "input rank " + r.rank + " should be > than [blockShape] " + e.length;
        }), C(n.length === e.length, function() {
            return "paddings.shape[0] " + n.length + " must be equal to [blockShape] " + e.length;
        }), C(r.shape.reduce(function(t, r, o) {
            return o > 0 && o <= e.length ? t && (r + n[o - 1][0] + n[o - 1][1]) % e[o - 1] == 0 : t;
        }, !0), function() {
            return "input spatial dimensions " + r.shape.slice(1) + " with paddings " + n.toString() + " must be divisible by blockShapes " + e.toString();
        }), Lt.runKernelFunc(function(t) {
            return t.spaceToBatchND(r, e, n);
        }, {
            $x: r
        }, function(t) {
            return {
                $x: function() {
                    return t.batchToSpaceND(e, n);
                }
            };
        });
    }
}), Br = An({
    squeeze_: function(t, e) {
        var n = mn(t, "x", "squeeze");
        return Or(n, M(n.shape, e).newShape);
    }
}), Pr = An({
    stack_: function(t, e) {
        void 0 === e && (e = 0);
        var n = gn(t, "tensors", "stack");
        if (C(n.length >= 1, function() {
            return "Pass at least one tensor to tf.stack";
        }), 1 === n.length) return n[0].expandDims(e);
        var r = n[0].rank, o = n[0].shape, a = n[0].dtype;
        C(e <= r, function() {
            return "Axis must be <= rank of the tensor";
        }), n.forEach(function(t) {
            E(o, t.shape, "All tensors passed to stack must have matching shapes");
        }), n.forEach(function(t) {
            C(a === t.dtype, function() {
                return "All tensors passed to stack must have matching dtypes";
            });
        });
        var i = n.map(function(t) {
            return t.expandDims(e);
        });
        return Yn(i, e);
    }
}), Lr = An({
    tile_: function(t, e) {
        var n = mn(t, "x", "tile", null);
        C(n.rank === e.length, function() {
            return "Error in transpose: rank of input " + n.rank + " must match length of reps " + e + ".";
        });
        var r = [
            n
        ], o = {
            reps: e
        };
        return Lt.runKernelFunc(function(t, r) {
            var o = t.tile(n, e);
            return r([
                n
            ]), o;
        }, {
            x: n
        }, function(t, n) {
            var r = n[0];
            return {
                x: function() {
                    var n = Xn(r);
                    if (1 === r.rank) for(var o = 0; o < e[0]; ++o)n = n.add(t.slice([
                        o * r.shape[0]
                    ], [
                        r.shape[0]
                    ]));
                    else if (2 === r.rank) for(o = 0; o < e[0]; ++o)for(var a = 0; a < e[1]; ++a)n = n.add(t.slice([
                        o * r.shape[0],
                        a * r.shape[1]
                    ], [
                        r.shape[0],
                        r.shape[1]
                    ]));
                    else if (3 === r.rank) for(o = 0; o < e[0]; ++o)for(a = 0; a < e[1]; ++a)for(var i = 0; i < e[2]; ++i)n = n.add(t.slice([
                        o * r.shape[0],
                        a * r.shape[1],
                        i * r.shape[2]
                    ], [
                        r.shape[0],
                        r.shape[1],
                        r.shape[2]
                    ]));
                    else {
                        if (4 !== r.rank) throw new Error("Gradient for tile operation is not implemented for rank-" + r.rank + " tensors yet.");
                        for(o = 0; o < e[0]; ++o)for(a = 0; a < e[1]; ++a)for(i = 0; i < e[2]; ++i)for(var s = 0; s < e[3]; ++s)n = n.add(t.slice([
                            o * r.shape[0],
                            a * r.shape[1],
                            i * r.shape[2],
                            s * r.shape[3]
                        ], [
                            r.shape[0],
                            r.shape[1],
                            r.shape[2],
                            r.shape[3]
                        ]));
                    }
                    return n;
                }
            };
        }, "Tile", o, r);
    }
}), Wr = An({
    truncatedNormal_: function(t, e, n, r, o) {
        if (void 0 === e && (e = 0), void 0 === n && (n = 1), null != r && "bool" === r) throw new Error("Unsupported data type " + r);
        for(var a = new lr(e, n, r, !0, o), i = dr(t, r), s = 0; s < i.values.length; s++)i.values[s] = a.nextValue();
        return i.toTensor();
    }
}), Ur = An({
    unstack_: function(t, e) {
        void 0 === e && (e = 0), e = e || 0;
        var n = mn(t, "x", "unstack");
        C(e >= -n.shape.length && e < n.shape.length, function() {
            return "Axis = " + e + " is not in [-" + n.shape.length + ", " + n.shape.length + ")";
        }), e < 0 && (e += n.shape.length);
        var r = {
            axis: e
        };
        return Lt.runKernelFunc(function(t) {
            return t.unstack(n, e);
        }, {
            x: n
        }, function(t) {
            return {
                x: function() {
                    return Pr(t, e);
                }
            };
        }, "Unpack", r);
    }
}), Vr = function(t, e) {
    return n(this, void 0, void 0, function() {
        var n, o, a, i, s, u, c, l, h, f;
        return r(this, function(r) {
            switch(r.label){
                case 0:
                    return n = mn(t, "x", "setdiff1d"), o = mn(e, "y", "setdiff1d"), C(n.dtype === o.dtype, function() {
                        return "x and y should have the same dtype, but got x (" + n.dtype + ") and y (" + o.dtype + ").";
                    }), C(1 === n.rank, function() {
                        return "x should be 1D tensor, but got x (" + n.shape + ").";
                    }), C(1 === o.rank, function() {
                        return "y should be 1D tensor, but got y (" + o.shape + ").";
                    }), [
                        4,
                        n.data()
                    ];
                case 1:
                    return a = r.sent(), [
                        4,
                        o.data()
                    ];
                case 2:
                    for(i = r.sent(), s = new Set(i), u = 0, h = 0; h < a.length; h++)s.has(a[h]) || u++;
                    for(c = new gt([
                        u
                    ], n.dtype), l = new gt([
                        u
                    ], "int32"), h = 0, f = 0; h < a.length; h++)s.has(a[h]) || (c.values[f] = a[h], l.values[f] = h, f++);
                    return [
                        2,
                        [
                            c.toTensor(),
                            l.toTensor()
                        ]
                    ];
            }
        });
    });
};
function zr(t, e, n, r) {
    void 0 === r && (r = !0);
    var o = [];
    if (r) (o = o.concat(e.slice(0))).push(t[0] / n), o = o.concat(t.slice(1));
    else {
        o = o.concat(t[0]);
        for(var a = e.length, i = 0; i < a; ++i)o = o.concat([
            t[i + 1] / e[i],
            e[i]
        ]);
        o = o.concat(t.slice(a + 1));
    }
    return o;
}
function Gr(t, e, n) {
    void 0 === n && (n = !0);
    var r = [];
    if (n) {
        r.push(e);
        for(var o = e + 1; o < t; ++o)o <= 2 * e ? (r.push(o), r.push(o - (e + 1))) : r.push(o);
    } else {
        var a = [], i = [];
        for(o = 1; o < t; ++o)o >= 2 * e + 1 || o % 2 == 1 ? i.push(o) : a.push(o);
        r.push.apply(r, a), r.push(0), r.push.apply(r, i);
    }
    return r;
}
function Hr(t, e, n, r) {
    void 0 === r && (r = !0);
    var o = [];
    r ? o.push(t[0] / n) : o.push(t[0] * n);
    for(var a = 1; a < t.length; ++a)a <= e.length ? r ? o.push(e[a - 1] * t[a]) : o.push(t[a] / e[a - 1]) : o.push(t[a]);
    return o;
}
function qr(t, e) {
    for(var n = [
        0
    ], r = 0; r < e; ++r)n.push(t[r][0]);
    return n;
}
function Kr(t, e, n) {
    for(var r = t.slice(0, 1), o = 0; o < n; ++o)r.push(t[o + 1] - e[o][0] - e[o][1]);
    return r;
}
function jr(t, e) {
    if (t.rank < 1) throw new Error("tf.gatherND() expects the input to be rank 1 or higher, but the rank was " + t.rank + ".");
    if (e.rank < 1) throw new Error("tf.gatherND() expects the indices to be rank 1 or higher, but the rank was " + e.rank + ".");
    if ("int32" !== e.dtype) throw new Error("tf.gatherND() expects the indices to be int32 type, but the dtype was " + e.dtype + ".");
    if (e.shape[e.rank - 1] > t.rank) throw new Error("index innermost dimension length must be <= tensor rank; saw: " + e.shape[e.rank - 1] + " vs. " + t.rank);
    if (0 === t.size) throw new Error("Requested more than 0 entries, but input is empty. Input shape: " + t.shape + ".");
    for(var n = e.shape, r = n[n.length - 1], o = 1, a = 0; a < n.length - 1; ++a)o *= n[a];
    var i = t.shape, s = n.slice();
    s.pop();
    var u = 1;
    for(a = r; a < t.rank; ++a)u *= i[a], s.push(i[a]);
    var c = $(t.shape).map(function(t) {
        return t / u;
    }).concat([
        1
    ]).slice(0, r);
    return [
        s,
        o,
        u,
        c
    ];
}
var Xr = Object.freeze({
    prepareAndValidate: jr
}), Yr = 30;
function $r(t) {
    return t <= Yr ? t : Y(t, Math.floor(Math.sqrt(t)));
}
function Qr(t, e, n) {
    var r = e.rank > 1 ? e.shape[e.rank - 1] : 1, o = e.rank > 1 ? e.rank - 1 : 1, a = "Must have updates.shape = indices.shape[:batchDim] + shape[sliceDim:], got updates.shape: " + n.shape + ", indices.shape: " + e.shape + ", shape: " + t + ", sliceDim: " + r + ", and batchDim: " + o + ".";
    if (n.rank < o) throw new Error(a + " update.rank < " + o + ". ");
    if (t.length < r + (n.rank - o)) throw new Error(a + " Output shape length < " + (r + (n.rank - o)));
    if (n.rank !== o + t.length - r) throw new Error(a + " update.rank != " + (o + t.length - r));
    for(var i = 0; i < o; ++i)if (n.shape[i] !== e.shape[i]) throw new Error(a + " updates.shape[" + i + "] (" + n.shape[i] + ") != indices.shape[" + i + "] (" + e.shape[i] + ").");
    for(i = 0; i < n.rank - o; ++i)if (n.shape[i + o] !== t[i + r]) throw new Error(a + " updates.shape[" + (i + o) + "] (" + n.shape[i + o] + ") != shape[" + (i + o) + "] (" + t[i + o] + ")");
}
function Jr(t, e, n) {
    if (e.rank < 1) throw new Error("tf.scatterND() expects the indices to be rank 1 or higher, but the rank was " + e.rank + ".");
    if (t.rank < 1) throw new Error("tf.scatterND() expects the updates to be rank 1 or higher, but the rank was " + t.rank + ".");
    if ("int32" !== e.dtype) throw new Error("The dtype of 'indices' should be int32, but got dtype: " + e.dtype);
    if (n.length < 1) throw new Error("Output rank must be greater or equal to 1, but got shape: " + n);
    if (0 === n.length) {
        if (0 === e.size) throw new Error("Indices specified for empty output. indices shape: " + e.shape);
        if (0 === t.size) throw new Error("Updates specified for empty output. updates shape: " + t.shape);
    }
    Qr(n, e, t);
}
function Zr(t, e, n) {
    for(var r = e.shape.length, o = r > 1 ? e.shape[r - 1] : 1, a = n.length, i = 1, s = o; s < a; ++s)i *= n[s];
    var u = o < 1 ? 1 : o;
    return {
        sliceRank: o,
        numUpdates: k(e.shape) / u,
        sliceSize: i,
        strides: $(n.slice(0, o)).concat([
            1
        ]),
        outputSize: k(n)
    };
}
var to = Object.freeze({
    validateUpdateShape: Qr,
    validateInput: Jr,
    calculateShapes: Zr
});
function eo(t, e, n) {
    C(t.rank === e.length, function() {
        return "Error in slice" + t.rank + "D: Length of begin " + e + " must match the rank of the array (" + t.rank + ").";
    }), C(t.rank === n.length, function() {
        return "Error in slice" + t.rank + "D: Length of size " + n + " must match the rank of the array (" + t.rank + ").";
    });
    for(var r = function(r) {
        C(e[r] + n[r] <= t.shape[r], function() {
            return "Error in slice" + t.rank + "D: begin[" + r + "] + size[" + r + "] (" + (e[r] + n[r]) + ") would overflow input.shape[" + r + "] (" + t.shape[r] + ")";
        });
    }, o = 0; o < t.rank; ++o)r(o);
}
function no(t) {
    for(var e = [], n = 0; t > 0;)1 & t && e.push(n), t /= 2, n++;
    return e;
}
function ro(t, e, n) {
    for(var r = [], o = 0; o < t.length; o++)r[o] = Math.ceil((e[o] - t[o]) / n[o]);
    return r;
}
function oo(t, e, n, r, o) {
    var a = e[o], i = n[o] || 1;
    (t & 1 << o || null == a) && (a = i > 0 ? Number.MIN_SAFE_INTEGER : Number.MAX_SAFE_INTEGER);
    var s = r[o];
    return a < 0 && (a += s), a = x(0, a, s - 1);
}
function ao(t, e, n, r, o) {
    var a = e[o], i = n[o] || 1;
    (t & 1 << o || null == a) && (a = i > 0 ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER);
    var s = r[o];
    return a < 0 && (a += s), a = i > 0 ? x(0, a, s) : x(-1, a, s - 1);
}
function io(t, e, n) {
    for(var r = n.length, o = 0; o < n.length; o++)if (n[o] > 1) {
        r = o;
        break;
    }
    for(o = r + 1; o < n.length; o++)if (e[o] > 0 || n[o] !== t[o]) return !1;
    return !0;
}
function so(t, e) {
    for(var n = t.length > 0 ? t[t.length - 1] : 1, r = 0; r < t.length - 1; r++)n += t[r] * e[r];
    return n;
}
var uo = Object.freeze({
    assertParamsValid: eo,
    maskToAxes: no,
    computeOutShape: ro,
    startForAxis: oo,
    stopForAxis: ao,
    isSliceContinous: io,
    computeFlatOffset: so
});
function co(t) {
    return C(X(t), function() {
        return "The f passed in grad(f) must be a function";
    }), function(e, n) {
        var r = mn(e, "x", "tf.grad", null), o = null != n ? mn(n, "dy", "tf.grad") : null;
        return Lt.tidy(function() {
            var e = Lt.gradients(function() {
                return t(r);
            }, [
                r
            ], o), n = e.value, a = e.grads;
            return null != o && E(n.shape, o.shape, "The shape of dy passed in grad(f)(x, dy) must match the shape returned by f(x)"), mo(a), a[0];
        });
    };
}
function lo(t) {
    return C(X(t), function() {
        return "The f passed in grads(f) must be a function";
    }), function(e, n) {
        C(Array.isArray(e), function() {
            return "The args passed in grads(f)(args) must be an array of `Tensor`s or `TensorLike`s";
        });
        var r = gn(e, "args", "tf.grads", null), o = null != n ? mn(n, "dy", "tf.grads") : null;
        return Lt.tidy(function() {
            var e = Lt.gradients(function() {
                return t.apply(void 0, r);
            }, r, o), n = e.value, a = e.grads;
            return null != o && E(n.shape, o.shape, "The shape of dy passed in grads(f)([x1,...], dy) must match the shape returned by f([x1,...])"), mo(a), a;
        });
    };
}
function ho(t) {
    return C(X(t), function() {
        return "The f passed in valueAndGrad(f) must be a function";
    }), function(e, n) {
        C(e instanceof wt, function() {
            return "The x passed in valueAndGrad(f)(x) must be a tensor";
        }), C(null == n || n instanceof wt, function() {
            return "The dy passed in valueAndGrad(f)(x, dy) must be a tensor";
        });
        var r = Lt.gradients(function() {
            return t(e);
        }, [
            e
        ], n), o = r.grads, a = r.value;
        return mo(o), {
            grad: o[0],
            value: a
        };
    };
}
function fo(t) {
    return C(X(t), function() {
        return "The f passed in valueAndGrads(f) must be a function";
    }), function(e, n) {
        C(Array.isArray(e) && e.every(function(t) {
            return t instanceof wt;
        }), function() {
            return "The args passed in valueAndGrads(f)(args) must be array of tensors";
        }), C(null == n || n instanceof wt, function() {
            return "The dy passed in valueAndGrads(f)(args, dy) must be a tensor";
        });
        var r = Lt.gradients(function() {
            return t.apply(void 0, e);
        }, e, n);
        return null != n && E(r.value.shape, n.shape, "The shape of dy passed in valueAndGrads(f)([x1,...], dy) must match the shape returned by f([x1,...])"), mo(r.grads), r;
    };
}
function po(t, e) {
    C(X(t), function() {
        return "The f passed in variableGrads(f) must be a function";
    }), C(null == e || Array.isArray(e) && e.every(function(t) {
        return t instanceof St;
    }), function() {
        return "The varList passed in variableGrads(f, varList) must be an array of variables";
    });
    var n = null != e;
    if (!n) for(var r in e = [], Lt.registeredVariables)e.push(Lt.registeredVariables[r]);
    var o = n ? e.filter(function(t) {
        return !t.trainable;
    }) : null, a = e.length;
    C((e = e.filter(function(t) {
        return t.trainable;
    })).length > 0, function() {
        return "variableGrads() expects at least one of the input variables to be trainable, but none of the " + a + " variables is trainable.";
    });
    var i = Lt.gradients(t, e, null, !0), s = i.value, u = i.grads;
    C(u.some(function(t) {
        return null != t;
    }), function() {
        return "Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize().";
    }), C(0 === s.rank, function() {
        return "The f passed in variableGrads(f) must return a scalar, but it returned a rank-" + s.rank + " tensor";
    });
    var c = {};
    return e.forEach(function(t, e) {
        null != u[e] && (c[t.name] = u[e]);
    }), null != o && o.forEach(function(t) {
        return c[t.name] = null;
    }), {
        value: s,
        grads: c
    };
}
function vo(t) {
    return Lt.customGrad(t);
}
function mo(t) {
    if (t.filter(function(t) {
        return null == t;
    }).length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that\n    the f you passed encloses all operations that lead from x to y.");
}
var go = An({
    softmax_: function(t, e) {
        void 0 === e && (e = -1);
        var n = mn(t, "logits", "softmax", "float32");
        if (-1 === e && (e = n.rank - 1), e !== n.rank - 1) throw Error("Softmax along a non-last dimension is not yet supported. Logits was rank " + n.rank + " and dim was " + e);
        return Lt.runKernelFunc(function(t, r) {
            var o = t.softmax(n, e);
            return r([
                o
            ]), o;
        }, {
            logits: n
        }, function(t, n) {
            var r = n[0], o = t.mul(r);
            return {
                logits: function() {
                    return o.sub(o.sum([
                        e
                    ], !0).mul(r));
                }
            };
        }, "Softmax", {
            dim: e
        }, [], [
            !0
        ]);
    }
}), yo = An({
    logSoftmax_: function(t, e) {
        void 0 === e && (e = -1);
        var n = mn(t, "logits", "logSoftmax");
        if (-1 === e && (e = n.rank - 1), e !== n.rank - 1) throw Error("Log Softmax along a non-last dimension is not yet supported. Logits was rank " + n.rank + " and axis was " + e);
        return vo(function(t, n) {
            var r = t.max(e, !0), o = t.sub(r), a = o.toFloat().sub(o.exp().sum(e, !0).log());
            n([
                a
            ]);
            return {
                value: a,
                gradFunc: function(t, n) {
                    var r = n[0].exp();
                    return t.sub(t.sum(e, !0).mul(r));
                }
            };
        })(n);
    }
}), xo = function() {
    function t(t, e) {
        this.backend = t, this.dataMover = e, this.data = new WeakMap, this.dataIdsCount = 0;
    }
    return t.prototype.get = function(t) {
        return this.data.has(t) || this.dataMover.moveData(this.backend, t), this.data.get(t);
    }, t.prototype.set = function(t, e) {
        this.dataIdsCount++, this.data.set(t, e);
    }, t.prototype.has = function(t) {
        return this.data.has(t);
    }, t.prototype.delete = function(t) {
        return this.dataIdsCount--, this.data.delete(t);
    }, t.prototype.numDataIds = function() {
        return this.dataIdsCount;
    }, t;
}(), bo = function() {
    function t() {}
    return t.prototype.time = function(t) {
        return wo("time");
    }, t.prototype.read = function(t) {
        return wo("read");
    }, t.prototype.readSync = function(t) {
        return wo("readSync");
    }, t.prototype.numDataIds = function() {
        return wo("numDataIds");
    }, t.prototype.disposeData = function(t) {
        return wo("disposeData");
    }, t.prototype.write = function(t, e, n) {
        return wo("write");
    }, t.prototype.move = function(t, e, n, r) {
        return wo("move");
    }, t.prototype.memory = function() {
        return wo("memory");
    }, t.prototype.floatPrecision = function() {
        return wo("floatPrecision");
    }, t.prototype.epsilon = function() {
        return 32 === this.floatPrecision() ? 1e-7 : 1e-4;
    }, t.prototype.batchMatMul = function(t, e, n, r) {
        return wo("batchMatMul");
    }, t.prototype.fusedBatchMatMul = function(t) {
        t.a, t.b, t.transposeA, t.transposeB, t.bias, t.activation, t.preluActivationWeights;
        return wo("fusedBatchMatMul");
    }, t.prototype.slice = function(t, e, n) {
        return wo("slice");
    }, t.prototype.stridedSlice = function(t, e, n, r) {
        return wo("stridedSlice");
    }, t.prototype.unstack = function(t, e) {
        return wo("unstack");
    }, t.prototype.reverse = function(t, e) {
        return wo("reverse");
    }, t.prototype.concat = function(t, e) {
        return wo("concat");
    }, t.prototype.neg = function(t) {
        return wo("neg");
    }, t.prototype.add = function(t, e) {
        return wo("add");
    }, t.prototype.addN = function(t) {
        return wo("addN");
    }, t.prototype.subtract = function(t, e) {
        return wo("subtract");
    }, t.prototype.multiply = function(t, e) {
        return wo("multiply");
    }, t.prototype.realDivide = function(t, e) {
        return wo("realDivide");
    }, t.prototype.floorDiv = function(t, e) {
        return wo("floorDiv");
    }, t.prototype.sum = function(t, e) {
        return wo("sum");
    }, t.prototype.prod = function(t, e) {
        return wo("prod");
    }, t.prototype.unsortedSegmentSum = function(t, e, n) {
        return wo("unsortedSegmentSum");
    }, t.prototype.argMin = function(t, e) {
        return wo("argMin");
    }, t.prototype.argMax = function(t, e) {
        return wo("argMax");
    }, t.prototype.equal = function(t, e) {
        return wo("equal");
    }, t.prototype.notEqual = function(t, e) {
        return wo("notEqual");
    }, t.prototype.less = function(t, e) {
        return wo("less");
    }, t.prototype.lessEqual = function(t, e) {
        return wo("lessEqual");
    }, t.prototype.greater = function(t, e) {
        return wo("greater");
    }, t.prototype.greaterEqual = function(t, e) {
        return wo("greaterEqual");
    }, t.prototype.logicalNot = function(t) {
        return wo("logicalNot");
    }, t.prototype.logicalAnd = function(t, e) {
        return wo("logicalAnd");
    }, t.prototype.logicalOr = function(t, e) {
        return wo("logicalOr");
    }, t.prototype.where = function(t) {
        return wo("where");
    }, t.prototype.select = function(t, e, n) {
        return wo("select");
    }, t.prototype.topk = function(t, e, n) {
        return wo("topk");
    }, t.prototype.min = function(t, e) {
        return wo("min");
    }, t.prototype.minimum = function(t, e) {
        return wo("minimum");
    }, t.prototype.mod = function(t, e) {
        return wo("mod");
    }, t.prototype.max = function(t, e) {
        return wo("max");
    }, t.prototype.maximum = function(t, e) {
        return wo("maximum");
    }, t.prototype.all = function(t, e) {
        return wo("all");
    }, t.prototype.any = function(t, e) {
        return wo("any");
    }, t.prototype.squaredDifference = function(t, e) {
        return wo("squaredDifference");
    }, t.prototype.ceil = function(t) {
        return wo("ceil");
    }, t.prototype.floor = function(t) {
        return wo("floor");
    }, t.prototype.round = function(t) {
        return wo("round");
    }, t.prototype.sign = function(t) {
        return wo("sign");
    }, t.prototype.isNaN = function(t) {
        return wo("isNaN");
    }, t.prototype.isInf = function(t) {
        return wo("isInf");
    }, t.prototype.isFinite = function(t) {
        return wo("isFinite");
    }, t.prototype.pow = function(t, e) {
        return wo("pow");
    }, t.prototype.exp = function(t) {
        return wo("exp");
    }, t.prototype.expm1 = function(t) {
        return wo("expm1");
    }, t.prototype.softmax = function(t, e) {
        return wo("softmax");
    }, t.prototype.log = function(t) {
        return wo("log");
    }, t.prototype.log1p = function(t) {
        return wo("log1p");
    }, t.prototype.sqrt = function(t) {
        return wo("sqrt");
    }, t.prototype.rsqrt = function(t) {
        return wo("rsqrt");
    }, t.prototype.square = function(t) {
        return wo("square");
    }, t.prototype.reciprocal = function(t) {
        return wo("reciprocal");
    }, t.prototype.relu = function(t) {
        return wo("relu");
    }, t.prototype.relu6 = function(t) {
        return wo("relu6");
    }, t.prototype.prelu = function(t, e) {
        return wo("prelu");
    }, t.prototype.elu = function(t) {
        return wo("elu");
    }, t.prototype.eluDer = function(t, e) {
        return wo("eluDer");
    }, t.prototype.selu = function(t) {
        return wo("selu");
    }, t.prototype.int = function(t) {
        return wo("int");
    }, t.prototype.clip = function(t, e, n) {
        return wo("clip");
    }, t.prototype.abs = function(t) {
        return wo("abs");
    }, t.prototype.complexAbs = function(t) {
        return wo("complexAbs");
    }, t.prototype.sigmoid = function(t) {
        return wo("sigmoid");
    }, t.prototype.softplus = function(t) {
        return wo("softplus");
    }, t.prototype.sin = function(t) {
        return wo("sin");
    }, t.prototype.cos = function(t) {
        return wo("cos");
    }, t.prototype.tan = function(t) {
        return wo("tan");
    }, t.prototype.asin = function(t) {
        return wo("asin");
    }, t.prototype.acos = function(t) {
        return wo("acos");
    }, t.prototype.atan = function(t) {
        return wo("atan");
    }, t.prototype.atan2 = function(t, e) {
        return wo("atan2");
    }, t.prototype.sinh = function(t) {
        return wo("sinh");
    }, t.prototype.cosh = function(t) {
        return wo("cosh");
    }, t.prototype.tanh = function(t) {
        return wo("tanh");
    }, t.prototype.asinh = function(t) {
        return wo("asinh");
    }, t.prototype.acosh = function(t) {
        return wo("acosh");
    }, t.prototype.atanh = function(t) {
        return wo("atanh");
    }, t.prototype.erf = function(t) {
        return wo("erf");
    }, t.prototype.step = function(t, e) {
        return wo("step");
    }, t.prototype.fusedConv2d = function(t) {
        t.input, t.filter, t.convInfo, t.bias, t.activation, t.preluActivationWeights;
        return wo("fusedConv2d");
    }, t.prototype.conv2d = function(t, e, n) {
        return wo("conv2d");
    }, t.prototype.conv2dDerInput = function(t, e, n) {
        return wo("conv2dDerInput");
    }, t.prototype.conv2dDerFilter = function(t, e, n) {
        return wo("conv2dDerFilter");
    }, t.prototype.fusedDepthwiseConv2D = function(t) {
        t.input, t.filter, t.convInfo, t.bias, t.activation, t.preluActivationWeights;
        return wo("fusedDepthwiseConv2D");
    }, t.prototype.depthwiseConv2D = function(t, e, n) {
        return wo("depthwiseConv2D");
    }, t.prototype.depthwiseConv2DDerInput = function(t, e, n) {
        return wo("depthwiseConv2DDerInput");
    }, t.prototype.depthwiseConv2DDerFilter = function(t, e, n) {
        return wo("depthwiseConv2DDerFilter");
    }, t.prototype.conv3d = function(t, e, n) {
        return wo("conv3d");
    }, t.prototype.conv3dDerInput = function(t, e, n) {
        return wo("conv3dDerInput");
    }, t.prototype.conv3dDerFilter = function(t, e, n) {
        return wo("conv3dDerFilter");
    }, t.prototype.maxPool = function(t, e) {
        return wo("maxPool");
    }, t.prototype.maxPoolBackprop = function(t, e, n, r) {
        return wo("maxPoolBackprop");
    }, t.prototype.avgPool = function(t, e) {
        return wo("avgPool");
    }, t.prototype.avgPoolBackprop = function(t, e, n) {
        return wo("avgPoolBackprop");
    }, t.prototype.avgPool3d = function(t, e) {
        return wo("avgPool3d");
    }, t.prototype.avgPool3dBackprop = function(t, e, n) {
        return wo("avgPool3dBackprop");
    }, t.prototype.maxPool3d = function(t, e) {
        return wo("maxPool3d");
    }, t.prototype.maxPool3dBackprop = function(t, e, n, r) {
        return wo("maxPool3dBackprop");
    }, t.prototype.reshape = function(t, e) {
        return wo("reshape");
    }, t.prototype.cast = function(t, e) {
        return wo("cast");
    }, t.prototype.tile = function(t, e) {
        return wo("tile");
    }, t.prototype.pad = function(t, e, n) {
        return wo("pad");
    }, t.prototype.transpose = function(t, e) {
        return wo("transpose");
    }, t.prototype.gather = function(t, e, n) {
        return wo("gather");
    }, t.prototype.gatherND = function(t, e) {
        return wo("gatherND");
    }, t.prototype.scatterND = function(t, e, n) {
        return wo("scatterND");
    }, t.prototype.batchToSpaceND = function(t, e, n) {
        return wo("batchToSpaceND");
    }, t.prototype.spaceToBatchND = function(t, e, n) {
        return wo("spaceToBatchND");
    }, t.prototype.resizeBilinear = function(t, e, n, r) {
        return wo("resizeBilinear");
    }, t.prototype.resizeBilinearBackprop = function(t, e, n) {
        return wo("resizeBilinearBackprop");
    }, t.prototype.resizeNearestNeighbor = function(t, e, n, r) {
        return wo("resizeNearestNeighbor");
    }, t.prototype.resizeNearestNeighborBackprop = function(t, e, n) {
        return wo("resizeNearestNeighborBackprop");
    }, t.prototype.batchNormalization = function(t, e, n, r, o, a) {
        return wo("batchNormalization");
    }, t.prototype.localResponseNormalization4D = function(t, e, n, r, o) {
        return wo("localResponseNormalization4D");
    }, t.prototype.LRNGrad = function(t, e, n, r, o, a, i) {
        return wo("LRNGrad");
    }, t.prototype.multinomial = function(t, e, n, r) {
        return wo("multinomial");
    }, t.prototype.oneHot = function(t, e, n, r) {
        return wo("oneHot");
    }, t.prototype.cumsum = function(t, e, n, r) {
        return wo("cumsum");
    }, t.prototype.nonMaxSuppression = function(t, e, n, r, o) {
        return wo("nonMaxSuppression");
    }, t.prototype.fft = function(t) {
        return wo("fft");
    }, t.prototype.ifft = function(t) {
        return wo("ifft");
    }, t.prototype.complex = function(t, e) {
        return wo("complex");
    }, t.prototype.real = function(t) {
        return wo("real");
    }, t.prototype.imag = function(t) {
        return wo("imag");
    }, t.prototype.cropAndResize = function(t, e, n, r, o, a) {
        return wo("cropAndResize");
    }, t.prototype.depthToSpace = function(t, e, n) {
        return wo("depthToSpace");
    }, t.prototype.split = function(t, e, n) {
        return wo("split");
    }, t.prototype.sparseToDense = function(t, e, n, r) {
        return wo("sparseToDense");
    }, t.prototype.diag = function(t) {
        return wo("diag");
    }, t.prototype.fill = function(t, e, n) {
        return wo("fill");
    }, t.prototype.onesLike = function(t) {
        return wo("onesLike");
    }, t.prototype.zerosLike = function(t) {
        return wo("zerosLike");
    }, t.prototype.linspace = function(t, e, n) {
        return wo("linspace");
    }, t.prototype.dispose = function() {
        return wo("dispose");
    }, t;
}();
function wo(t) {
    throw new Error("'" + t + "' not yet implemented or not found in the registry. Did you forget to import the kernel?");
}
function Co(t, e) {
    for(var n = t.length, r = [], o = 0; o < n; o++){
        var a = n - 1 - o, i = t[a] || 1;
        (e[e.length - 1 - o] || 1) > 1 && 1 === i && r.unshift(a);
    }
    return r;
}
function Eo(t, e) {
    for(var n = [], r = 0; r < e.length; r++){
        var o = t[t.length - r - 1], a = e.length - r - 1, i = e[a];
        (null == o || 1 === o && i > 1) && n.unshift(a);
    }
    return n;
}
function Ro(t, e) {
    for(var n = [], r = Math.max(t.length, e.length), o = 0; o < r; o++){
        var a = t[t.length - o - 1];
        null == a && (a = 1);
        var i = e[e.length - o - 1];
        if (null == i && (i = 1), 1 === a) n.unshift(i);
        else if (1 === i) n.unshift(a);
        else {
            if (a !== i) throw Error("Operands could not be broadcast together with shapes " + t + " and " + e + ".");
            n.unshift(a);
        }
    }
    return n;
}
function Io(t, e, n, r, o, a, i) {
    void 0 === i && (i = "channelsLast");
    var s, u = To(e), c = u[0], l = u[1];
    if ("channelsLast" === i) s = [
        c,
        l,
        t[3],
        t[3]
    ];
    else {
        if ("channelsFirst" !== i) throw new Error("Unknown dataFormat " + i);
        s = [
            c,
            l,
            t[1],
            t[1]
        ];
    }
    return So(t, s, n, r, o, a, !1, i);
}
function ko(t, e, n, r, o, a, i) {
    void 0 === i && (i = "NDHWC");
    var s, u, c = No(e), l = c[0], h = c[1], f = c[2];
    if ("NDHWC" === i) u = "channelsLast", s = [
        l,
        h,
        f,
        t[4],
        t[4]
    ];
    else {
        if ("NCDHW" !== i) throw new Error("Unknown dataFormat " + i);
        u = "channelsFirst", s = [
            l,
            h,
            f,
            t[1],
            t[1]
        ];
    }
    return Ao(t, s, n, r, o, !1, u, a);
}
function So(t, e, n, r, o, a, i, s) {
    void 0 === i && (i = !1), void 0 === s && (s = "channelsLast");
    var u = [
        -1,
        -1,
        -1,
        -1
    ], c = u[0], l = u[1], h = u[2], f = u[3];
    if ("channelsLast" === s) c = t[0], l = t[1], h = t[2], f = t[3];
    else {
        if ("channelsFirst" !== s) throw new Error("Unknown dataFormat " + s);
        c = t[0], f = t[1], l = t[2], h = t[3];
    }
    var d, p = e[0], v = e[1], m = e[3], g = To(n), y = g[0], x = g[1], b = To(r), w = b[0], E = b[1], R = Fo(p, w), I = Fo(v, E), k = function(t, e, n, r, o, a, i, s) {
        var u, c, l;
        if ("number" == typeof t) {
            u = {
                top: t,
                bottom: t,
                left: t,
                right: t,
                type: 0 === t ? "VALID" : "NUMBER"
            };
            var h = function(t, e, n, r, o) {
                null == r && (r = Do(t, e, n));
                var a = t[0], i = t[1], s = _o((a - e + 2 * r) / n + 1, o);
                C(A(s), function() {
                    return "The output # of rows (" + s + ") must be an integer. Change the stride and/or zero pad parameters";
                });
                var u = _o((i - e + 2 * r) / n + 1, o);
                return C(A(u), function() {
                    return "The output # of columns (" + u + ") must be an integer. Change the stride and/or zero pad parameters";
                }), [
                    s,
                    u
                ];
            }([
                e,
                n
            ], a, r, t, s);
            c = h[0], l = h[1];
        } else if ("same" === t) {
            c = Math.ceil(e / r), l = Math.ceil(n / o);
            var f = Math.max(0, (c - 1) * r + a - e), d = Math.max(0, (l - 1) * o + i - n), p = Math.floor(f / 2), v = f - p, m = Math.floor(d / 2);
            u = {
                top: p,
                bottom: v,
                left: m,
                right: d - m,
                type: "SAME"
            };
        } else {
            if ("valid" !== t) throw Error("Unknown padding parameter: " + t);
            u = {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                type: "VALID"
            }, c = Math.ceil((e - a + 1) / r), l = Math.ceil((n - i + 1) / o);
        }
        return {
            padInfo: u,
            outHeight: c,
            outWidth: l
        };
    }(o, l, h, y, x, R, I, a), S = k.padInfo, D = k.outHeight, T = k.outWidth, N = i ? m * f : m;
    return "channelsFirst" === s ? d = [
        c,
        N,
        D,
        T
    ] : "channelsLast" === s && (d = [
        c,
        D,
        T,
        N
    ]), {
        batchSize: c,
        dataFormat: s,
        inHeight: l,
        inWidth: h,
        inChannels: f,
        outHeight: D,
        outWidth: T,
        outChannels: N,
        padInfo: S,
        strideHeight: y,
        strideWidth: x,
        filterHeight: p,
        filterWidth: v,
        effectiveFilterHeight: R,
        effectiveFilterWidth: I,
        dilationHeight: w,
        dilationWidth: E,
        inShape: t,
        outShape: d,
        filterShape: e
    };
}
function Ao(t, e, n, r, o, a, i, s) {
    void 0 === a && (a = !1), void 0 === i && (i = "channelsLast");
    var u = [
        -1,
        -1,
        -1,
        -1,
        -1
    ], c = u[0], l = u[1], h = u[2], f = u[3], d = u[4];
    if ("channelsLast" === i) c = t[0], l = t[1], h = t[2], f = t[3], d = t[4];
    else {
        if ("channelsFirst" !== i) throw new Error("Unknown dataFormat " + i);
        c = t[0], d = t[1], l = t[2], h = t[3], f = t[4];
    }
    var p, v = e[0], m = e[1], g = e[2], y = e[4], x = No(n), b = x[0], w = x[1], E = x[2], R = No(r), I = R[0], k = R[1], S = R[2], D = Fo(v, I), T = Fo(m, k), N = Fo(g, S), F = function(t, e, n, r, o, a, i, s, u, c, l) {
        var h, f, d, p;
        if ("number" == typeof t) {
            h = {
                top: t,
                bottom: t,
                left: t,
                right: t,
                front: t,
                back: t,
                type: 0 === t ? "VALID" : "NUMBER"
            };
            var v = function(t, e, n, r, o, a) {
                null == o && (o = Do(t, e, r));
                var i = t[0], s = t[1], u = t[2], c = _o((i - e + 2 * o) / r + 1, a);
                C(A(c), function() {
                    return "The output # of depths (" + c + ") must be an integer. Change the stride and/or zero pad parameters";
                });
                var l = _o((s - e + 2 * o) / r + 1, a);
                C(A(l), function() {
                    return "The output # of rows (" + l + ") must be an integer. Change the stride and/or zero pad parameters";
                });
                var h = _o((u - e + 2 * o) / r + 1, a);
                return C(A(h), function() {
                    return "The output # of columns (" + h + ") must be an integer. Change the stride and/or zero pad parameters";
                }), [
                    c,
                    l,
                    h,
                    n
                ];
            }([
                e,
                n,
                r,
                1
            ], s, 1, o, t, l);
            f = v[0], d = v[1], p = v[2];
        } else if ("same" === t) {
            f = Math.ceil(e / o), d = Math.ceil(n / a), p = Math.ceil(r / i);
            var m = (f - 1) * o + s - e, g = (d - 1) * a + u - n, y = (p - 1) * i + c - r, x = Math.floor(m / 2), b = m - x, w = Math.floor(g / 2), E = g - w, R = Math.floor(y / 2);
            h = {
                top: w,
                bottom: E,
                left: R,
                right: y - R,
                front: x,
                back: b,
                type: "SAME"
            };
        } else {
            if ("valid" !== t) throw Error("Unknown padding parameter: " + t);
            h = {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                front: 0,
                back: 0,
                type: "VALID"
            }, f = Math.ceil((e - s + 1) / o), d = Math.ceil((n - u + 1) / a), p = Math.ceil((r - c + 1) / i);
        }
        return {
            padInfo: h,
            outDepth: f,
            outHeight: d,
            outWidth: p
        };
    }(o, l, h, f, b, w, E, D, T, N, s), _ = F.padInfo, O = F.outDepth, M = F.outHeight, B = F.outWidth, P = a ? y * d : y;
    return "channelsFirst" === i ? p = [
        c,
        P,
        O,
        M,
        B
    ] : "channelsLast" === i && (p = [
        c,
        O,
        M,
        B,
        P
    ]), {
        batchSize: c,
        dataFormat: i,
        inDepth: l,
        inHeight: h,
        inWidth: f,
        inChannels: d,
        outDepth: O,
        outHeight: M,
        outWidth: B,
        outChannels: P,
        padInfo: _,
        strideDepth: b,
        strideHeight: w,
        strideWidth: E,
        filterDepth: v,
        filterHeight: m,
        filterWidth: g,
        effectiveFilterDepth: D,
        effectiveFilterHeight: T,
        effectiveFilterWidth: N,
        dilationDepth: I,
        dilationHeight: k,
        dilationWidth: S,
        inShape: t,
        outShape: p,
        filterShape: e
    };
}
function Do(t, e, n, r) {
    void 0 === r && (r = 1);
    var o = Fo(e, r);
    return Math.floor((t[0] * (n - 1) - n + o) / 2);
}
function To(t) {
    return "number" == typeof t ? [
        t,
        t,
        t
    ] : 2 === t.length ? [
        t[0],
        t[1],
        1
    ] : t;
}
function No(t) {
    return "number" == typeof t ? [
        t,
        t,
        t
    ] : t;
}
function Fo(t, e) {
    return e <= 1 ? t : t + (t - 1) * (e - 1);
}
function _o(t, e) {
    if (!e) return t;
    switch(e){
        case "round":
            return Math.round(t);
        case "ceil":
            return Math.ceil(t);
        case "floor":
            return Math.floor(t);
        default:
            throw new Error("Unknown roundingMode " + e);
    }
}
function Oo(t) {
    var e = To(t), n = e[0], r = e[1], o = e[2];
    return 1 === n && 1 === r && 1 === o;
}
function Mo(t, e) {
    return Oo(t) || Oo(e);
}
function Bo(t) {
    if ("NHWC" === t) return "channelsLast";
    if ("NCHW" === t) return "channelsFirst";
    throw new Error("Unknown dataFormat " + t);
}
function Po(t, e, n) {
    if ("complex64" === e) {
        if ("complex64" === t.dtype) return t.clone();
        var r = Gn(t.shape), o = t.toFloat(), a = n.complex(o, r);
        return r.dispose(), o.dispose(), a;
    }
    if (!U(t.dtype, e)) return Lt.makeTensorFromDataId(t.dataId, t.shape, e);
    if ("complex64" === t.dtype) {
        var i = n.real(t);
        a = i.cast(e);
        return i.dispose(), a;
    }
    if ("int32" === e) return n.int(t);
    if ("bool" === e) {
        var s = On(0, t.dtype);
        a = n.notEqual(t, s);
        return s.dispose(), a;
    }
    throw new Error("Error in Cast: failed to cast " + t.dtype + " to " + e);
}
function Lo(t, e) {
    return Lt.makeTensorFromDataId(t.dataId, e, t.dtype);
}
function Wo(t, e, n) {
    var r = (e - t) / (n - 1), o = tt(n, "float32");
    o[0] = t;
    for(var a = 1; a < o.length; a++)o[a] = o[a - 1] + r;
    return Mn(o, "float32");
}
var Uo = Object.freeze({
    castTensor: Po,
    reshapeTensor: Lo,
    linspaceImpl: Wo,
    upcastType: Dt,
    axesAreInnerMostDims: yn,
    combineLocations: xn,
    computeOutAndReduceShapes: bn,
    expandShapeToKeepDim: wn,
    assertAxesAreInnerMostDims: Cn,
    getAxesPermutation: En,
    getUndoAxesPermutation: Rn,
    getInnerMostAxes: In,
    getBroadcastDims: Co,
    getReductionAxes: Eo,
    assertAndGetBroadcastShape: Ro,
    assertParamsConsistent: kn,
    computeOutShape: Sn,
    computePool2DInfo: Io,
    computePool3DInfo: ko,
    computeConv2DInfo: So,
    computeConv3DInfo: Ao,
    computeDefaultPad: Do,
    tupleValuesAreOne: Oo,
    eitherStridesOrDilationsAreOne: Mo,
    convertConv2DDataFormat: Bo,
    PARALLELIZE_THRESHOLD: Yr,
    computeOptimalWindowSize: $r
});
function Vo(t, e) {
    if (t.length !== e.length) throw new Error("Cannot merge real and imag arrays of different lengths. real:" + t.length + ", imag: " + e.length + ".");
    for(var n = new Float32Array(2 * t.length), r = 0; r < n.length; r += 2)n[r] = t[r / 2], n[r + 1] = e[r / 2];
    return n;
}
function zo(t, e) {
    return {
        real: t[2 * e],
        imag: t[2 * e + 1]
    };
}
function Go(t, e, n, r) {
    t[2 * r] = e, t[2 * r + 1] = n;
}
function Ho(t, e, n) {
    var r = (n ? 2 : -2) * Math.PI * (t / e);
    return {
        real: Math.cos(r),
        imag: Math.sin(r)
    };
}
function qo(t, e, n) {
    var r = function(t, e, n) {
        return function(t, e, n) {
            var r = 0, o = t.length, a = 0, i = !1;
            for(; r < o;){
                var s = n(e, t[a = r + (o - r >>> 1)]);
                s > 0 ? r = a + 1 : (o = a, i = !s);
            }
            return i ? r : -r - 1;
        }(t, e, n || Ko);
    }(t, e, n), o = r < 0 ? -(r + 1) : r;
    t.splice(o, 0, e);
}
function Ko(t, e) {
    return t > e ? 1 : t < e ? -1 : 0;
}
function jo(t, e, n, r, o) {
    return Yo(t, e, n, r, o, 0).selectedIndices;
}
function Xo(t, e, n, r, o, a) {
    var i = Yo(t, e, n, r, o, a, !0);
    return i.numValidOutputs.dispose(), {
        selectedIndices: i.selectedIndices,
        selectedScores: i.selectedScores
    };
}
function Yo(t, e, n, r, o, a, i, s) {
    void 0 === i && (i = !1), void 0 === s && (s = !1);
    for(var u = Array.from(e).map(function(t, e) {
        return {
            score: t,
            boxIndex: e,
            suppressBeginIndex: 0
        };
    }).filter(function(t) {
        return t.score > o;
    }).sort(Jo), c = a > 0 ? -0.5 / a : 0, l = [], h = []; l.length < n && u.length > 0;){
        var f = u.pop(), d = f.score, p = f.boxIndex, v = f.suppressBeginIndex;
        if (d < o) break;
        for(var m = !1, g = l.length - 1; g >= v; --g){
            var y = $o(t, p, l[g]);
            if (y >= r) {
                m = !0;
                break;
            }
            if (f.score = f.score * Qo(r, c, y), f.score <= o) break;
        }
        f.suppressBeginIndex = l.length, m || (f.score === d ? (l.push(p), h.push(f.score)) : f.score > o && qo(u, f, Jo));
    }
    var x = l.length;
    return s && (l.fill(0, x), h.fill(0, x)), {
        selectedIndices: Mn(l, "int32"),
        selectedScores: Mn(h, "float32"),
        numValidOutputs: On(x, "int32")
    };
}
function $o(t, e, n) {
    var r = t.subarray(4 * e, 4 * e + 4), o = t.subarray(4 * n, 4 * n + 4), a = Math.min(r[0], r[2]), i = Math.min(r[1], r[3]), s = Math.max(r[0], r[2]), u = Math.max(r[1], r[3]), c = Math.min(o[0], o[2]), l = Math.min(o[1], o[3]), h = Math.max(o[0], o[2]), f = Math.max(o[1], o[3]), d = (s - a) * (u - i), p = (h - c) * (f - l);
    if (d <= 0 || p <= 0) return 0;
    var v = Math.max(a, c), m = Math.max(i, l), g = Math.min(s, h), y = Math.min(u, f), x = Math.max(g - v, 0) * Math.max(y - m, 0);
    return x / (d + p - x);
}
function Qo(t, e, n) {
    var r = Math.exp(e * n * n);
    return n <= t ? r : 0;
}
function Jo(t, e) {
    return t.score - e.score || t.score === e.score && e.boxIndex - t.boxIndex;
}
function Zo(t, e, n) {
    var r = new Array(t.rank).fill(0), o = t.shape.slice();
    return e.map(function(e) {
        o[n] = e;
        var a = t.slice(r, o);
        return r[n] += e, a;
    });
}
function ta(t, e) {
    for(var n = new Array(t.rank), r = 0; r < n.length; r++)n[r] = t.shape[r] * e[r];
    var o = dr(n, t.dtype);
    for(r = 0; r < o.values.length; ++r){
        for(var a = o.indexToLoc(r), i = new Array(t.rank), s = 0; s < i.length; s++)i[s] = a[s] % t.shape[s];
        var u = t.locToIndex(i);
        o.values[r] = t.values[u];
    }
    return o.toTensor();
}
function ea(t, e, n, r, o) {
    for(var a = e[e.length - 1], i = [
        t.length / a,
        a
    ], s = i[0], u = i[1], c = B(n, s * r), l = B("int32", s * r), h = 0; h < s; h++){
        for(var f = h * u, d = t.subarray(f, f + u), p = [], v = 0; v < d.length; v++)p.push({
            value: d[v],
            index: v
        });
        p.sort(function(t, e) {
            return e.value - t.value;
        });
        var m = h * r, g = c.subarray(m, m + r), y = l.subarray(m, m + r);
        for(v = 0; v < r; v++)g[v] = p[v].value, y[v] = p[v].index;
    }
    var x = e.slice();
    return x[x.length - 1] = r, [
        Fn(c, x, n),
        Fn(l, x, "int32")
    ];
}
function na(t, e) {
    for(var n = [], r = 0; r < e.length; r++)e[r] && n.push(r);
    var o = dr(t, "int32"), a = dr([
        n.length,
        t.length
    ], "int32");
    for(r = 0; r < n.length; r++){
        var i = o.indexToLoc(n[r]), s = r * t.length;
        a.values.set(i, s);
    }
    return a.toTensor();
}
var ra = function(t, e) {
    this.outputShape = [], this.outputShape = t, this.variableNames = e.map(function(t, e) {
        return "T" + e;
    });
    var n = [];
    this.variableNames.forEach(function(t) {
        n.push("float v" + t + " = get" + t + "AtOutCoords();");
    });
    var r = this.variableNames.map(function(t) {
        return "v" + t;
    }).join(" + ");
    this.userCode = "\n      void main() {\n        " + n.join("\n        ") + "\n\n        float result = " + r + ";\n        setOutput(result);\n      }\n    ";
}, oa = function(t, e) {
    this.outputShape = [], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.variableNames = e.map(function(t, e) {
        return "T" + e;
    });
    var n = [];
    this.variableNames.forEach(function(t) {
        n.push("vec4 v" + t + " = get" + t + "AtOutCoords();");
    });
    var r = this.variableNames.map(function(t) {
        return "v" + t;
    }).join(" + ");
    this.userCode = "\n      void main() {\n        " + n.join("\n        ") + "\n\n        vec4 result = " + r + ";\n        setOutput(result);\n      }\n    ";
}, aa = function(t, e, n) {
    this.variableNames = [
        "A"
    ];
    var r = t.windowSize, o = t.batchSize, a = t.inSize, i = Math.ceil(a / r);
    n || this.variableNames.push("bestIndicesA"), this.outputShape = [
        o,
        i
    ];
    var s = "max" === e ? ">" : "<", u = n ? "inOffset + i;" : "round(getBestIndicesA(batch, inOffset + i));";
    this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * " + r + ";\n\n        int bestIndex = inOffset;\n        float bestValue = getA(batch, bestIndex);\n\n        for (int i = 0; i < " + r + "; i++) {\n          int inIdx = " + u + ";\n          float candidate = getA(batch, inIdx);\n          if (candidate " + s + " bestValue) {\n            bestValue = candidate;\n            bestIndex = inIdx;\n          }\n        }\n        setOutput(float(bestIndex));\n      }\n    ";
};
function ia(t, e) {
    return [
        "x",
        "y",
        "z",
        "w",
        "u",
        "v"
    ].slice(0, e).map(function(e) {
        return t + "." + e;
    });
}
function sa(t, e) {
    return 1 === e ? [
        t
    ] : ia(t, e);
}
function ua() {
    var t, e, n, r, o, a, s, u, c, l;
    return 2 === i().getNumber("WEBGL_VERSION") ? (t = "#version 300 es", e = "in", n = "out", r = "in", o = "texture", a = "outputColor", s = "out vec4 outputColor;", u = "\n      bool isnan_custom(float val) {\n        return (val > 0.0 || val < 0.0) ? false : val != 0.0;\n      }\n\n      bvec4 isnan_custom(vec4 val) {\n        return bvec4(isnan_custom(val.x),\n          isnan_custom(val.y), isnan_custom(val.z), isnan_custom(val.w));\n      }\n\n      #define isnan(value) isnan_custom(value)\n    ", c = "", l = "\n      #define round(value) newRound(value)\n      int newRound(float value) {\n        return int(floor(value + 0.5));\n      }\n\n      ivec4 newRound(vec4 value) {\n        return ivec4(floor(value + vec4(0.5)));\n      }\n    ") : (t = "", e = "attribute", n = "varying", r = "varying", o = "texture2D", a = "gl_FragColor", s = "", u = "\n      #define isnan(value) isnan_custom(value)\n      bool isnan_custom(float val) {\n        return (val > 0. || val < 1. || val == 0.) ? false : true;\n      }\n      bvec4 isnan_custom(vec4 val) {\n        return bvec4(isnan(val.x), isnan(val.y), isnan(val.z), isnan(val.w));\n      }\n    ", c = "\n      uniform float INFINITY;\n\n      bool isinf(float val) {\n        return abs(val) == INFINITY;\n      }\n      bvec4 isinf(vec4 val) {\n        return equal(abs(val), vec4(INFINITY));\n      }\n    ", l = "\n      int round(float value) {\n        return int(floor(value + 0.5));\n      }\n\n      ivec4 round(vec4 value) {\n        return ivec4(floor(value + vec4(0.5)));\n      }\n    "), {
        version: t,
        attribute: e,
        varyingVs: n,
        varyingFs: r,
        texture2D: o,
        output: a,
        defineOutput: s,
        defineSpecialNaN: u,
        defineSpecialInf: c,
        defineRound: l
    };
}
function ca(t, e, n) {
    void 0 === n && (n = "index");
    var r = $(e);
    return r.map(function(e, o) {
        return "int " + t[o] + " = " + n + " / " + e + "; " + (o === r.length - 1 ? "int " + t[o + 1] + " = " + n + " - " + t[o] + " * " + e : "index -= " + t[o] + " * " + e) + ";";
    }).join("");
}
function la(t) {
    var e = $(t).map(function(t) {
        return t.toString();
    });
    return "\n  int getFlatIndex(ivec3 coords) {\n    return coords.x * " + e[0] + " + coords.y * " + e[1] + " + coords.z;\n  }\n";
}
var ha = "\n  const float FLOAT_MAX = 1.70141184e38;\n  const float FLOAT_MIN = 1.17549435e-38;\n\n  lowp vec4 encode_float(highp float v) {\n    if (isnan(v)) {\n      return vec4(255, 255, 255, 255);\n    }\n\n    highp float av = abs(v);\n\n    if(av < FLOAT_MIN) {\n      return vec4(0.0, 0.0, 0.0, 0.0);\n    } else if(v > FLOAT_MAX) {\n      return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;\n    } else if(v < -FLOAT_MAX) {\n      return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;\n    }\n\n    highp vec4 c = vec4(0,0,0,0);\n\n    highp float e = floor(log2(av));\n    highp float m = exp2(fract(log2(av))) - 1.0;\n\n    c[2] = floor(128.0 * m);\n    m -= c[2] / 128.0;\n    c[1] = floor(32768.0 * m);\n    m -= c[1] / 32768.0;\n    c[0] = floor(8388608.0 * m);\n\n    highp float ebias = e + 127.0;\n    c[3] = floor(ebias / 2.0);\n    ebias -= c[3] * 2.0;\n    c[2] += floor(ebias) * 128.0;\n\n    c[3] += 128.0 * step(0.0, -v);\n\n    return c / 255.0;\n  }\n";
function fa(t, e, n, r) {
    var o = [];
    t.forEach(function(t) {
        var e = k(t.shapeInfo.logicalShape);
        t.shapeInfo.isUniform ? o.push("uniform float " + t.name + (e > 1 ? "[" + e + "]" : "") + ";") : (o.push("uniform sampler2D " + t.name + ";"), o.push("uniform int offset" + t.name + ";"));
    });
    var a, i, s = o.join("\n"), u = t.map(function(t) {
        return function(t, e, n) {
            void 0 === n && (n = !1);
            var r = "";
            r += n ? pa(t) : da(t);
            var o = t.shapeInfo.logicalShape, a = e.logicalShape;
            o.length <= a.length && (r += n ? function(t, e) {
                var n, r = t.name, o = r.charAt(0).toUpperCase() + r.slice(1), a = "get" + o + "AtOutCoords", i = t.shapeInfo.logicalShape.length, s = e.logicalShape.length, u = Co(t.shapeInfo.logicalShape, e.logicalShape), c = wa(s), l = s - i, h = [
                    "x",
                    "y",
                    "z",
                    "w",
                    "u",
                    "v"
                ];
                n = 0 === i ? "" : s < 2 && u.length >= 1 ? "coords = 0;" : u.map(function(t) {
                    return "coords." + h[t + l] + " = 0;";
                }).join("\n");
                var f = "";
                f = s < 2 && i > 0 ? "coords" : t.shapeInfo.logicalShape.map(function(t, e) {
                    return "coords." + h[e + l];
                }).join(", ");
                var d = "return outputValue;", p = 1 === k(t.shapeInfo.logicalShape), v = 1 === k(e.logicalShape);
                if (1 !== i || p || v) {
                    if (p && !v) d = 1 === s ? "\n        return vec4(outputValue.x, outputValue.x, 0., 0.);\n      " : "\n        return vec4(outputValue.x);\n      ";
                    else if (u.length) {
                        var m = i - 2, g = i - 1;
                        u.indexOf(m) > -1 && u.indexOf(g) > -1 ? d = "return vec4(outputValue.x);" : u.indexOf(m) > -1 ? d = "return vec4(outputValue.x, outputValue.y, outputValue.x, outputValue.y);" : u.indexOf(g) > -1 && (d = "return vec4(outputValue.xx, outputValue.zz);");
                    }
                } else d = "\n      return vec4(outputValue.xy, outputValue.xy);\n    ";
                return "\n    vec4 " + a + "() {\n      " + c + " coords = getOutputCoords();\n      " + n + "\n      vec4 outputValue = get" + o + "(" + f + ");\n      " + d + "\n    }\n  ";
            }(t, e) : function(t, e) {
                var n = t.name, r = n.charAt(0).toUpperCase() + n.slice(1), o = "get" + r + "AtOutCoords", a = e.texShape, i = t.shapeInfo.texShape, s = t.shapeInfo.logicalShape.length, u = e.logicalShape.length;
                if (!t.shapeInfo.isUniform && s === u && null == t.shapeInfo.flatOffset && S(i, a)) return "\n      float " + o + "() {\n        return sampleTexture(" + n + ", resultUV);\n      }\n    ";
                var c, l = wa(u), h = Co(t.shapeInfo.logicalShape, e.logicalShape), f = u - s, d = [
                    "x",
                    "y",
                    "z",
                    "w",
                    "u",
                    "v"
                ];
                c = 0 === s ? "" : u < 2 && h.length >= 1 ? "coords = 0;" : h.map(function(t) {
                    return "coords." + d[t + f] + " = 0;";
                }).join("\n");
                var p = "";
                p = u < 2 && s > 0 ? "coords" : t.shapeInfo.logicalShape.map(function(t, e) {
                    return "coords." + d[e + f];
                }).join(", ");
                return "\n    float " + o + "() {\n      " + l + " coords = getOutputCoords();\n      " + c + "\n      return get" + r + "(" + p + ");\n    }\n  ";
            }(t, e));
            return r;
        }(t, e, r);
    }).join("\n"), c = e.texShape, l = ua(), h = function(t) {
        return "\n    float sampleTexture(sampler2D textureSampler, vec2 uv) {\n      return " + t.texture2D + "(textureSampler, uv).r;\n    }\n  ";
    }(l), f = function(t) {
        return t.version + "\n    precision highp float;\n    precision highp int;\n    precision highp sampler2D;\n    " + t.varyingFs + " vec2 resultUV;\n    " + t.defineOutput + "\n    const vec2 halfCR = vec2(0.5, 0.5);\n\n    struct ivec5\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n    };\n\n    struct ivec6\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n      int v;\n    };\n\n    uniform float NAN;\n    " + t.defineSpecialNaN + "\n    " + t.defineSpecialInf + "\n    " + t.defineRound + "\n\n    int imod(int x, int y) {\n      return x - y * (x / y);\n    }\n\n    int idiv(int a, int b, float sign) {\n      int res = a / b;\n      int mod = imod(a, b);\n      if (sign < 0. && mod != 0) {\n        res -= 1;\n      }\n      return res;\n    }\n\n    //Based on the work of Dave Hoskins\n    //https://www.shadertoy.com/view/4djSRW\n    #define HASHSCALE1 443.8975\n    float random(float seed){\n      vec2 p = resultUV * seed;\n      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);\n      p3 += dot(p3, p3.yzx + 19.19);\n      return fract((p3.x + p3.y) * p3.z);\n    }\n\n    " + va + "\n    " + ma + "\n    " + ga + "\n  ";
    }(l);
    return e.isPacked ? (a = function(t, e) {
        switch(t.length){
            case 0:
                return "\n    int getOutputCoords() {\n      return 0;\n    }\n  ";
            case 1:
                return function(t, e) {
                    var n = [
                        Math.ceil(e[0] / 2),
                        Math.ceil(e[1] / 2)
                    ];
                    if (1 === n[0]) return "\n      int getOutputCoords() {\n        return 2 * int(resultUV.x * " + n[1] + ".0);\n      }\n    ";
                    if (1 === n[1]) return "\n      int getOutputCoords() {\n        return 2 * int(resultUV.y * " + n[0] + ".0);\n      }\n    ";
                    return "\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n      return 2 * (resTexRC.x * " + n[1] + " + resTexRC.y);\n    }\n  ";
                }(0, e);
            case 2:
                return function(t, e) {
                    var n = [
                        Math.ceil(e[0] / 2),
                        Math.ceil(e[1] / 2)
                    ];
                    if (S(t, e)) return "\n      ivec2 getOutputCoords() {\n        return 2 * ivec2(resultUV.yx * vec2(" + n[0] + ", " + n[1] + "));\n      }\n    ";
                    var r = Math.ceil(t[1] / 2);
                    return "\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n\n      int index = resTexRC.x * " + n[1] + " + resTexRC.y;\n      int r = 2 * (index / " + r + ");\n      int c = imod(index, " + r + ") * 2;\n\n      return ivec2(r, c);\n    }\n  ";
                }(t, e);
            case 3:
                return n = t, r = e, o = [
                    Math.ceil(r[0] / 2),
                    Math.ceil(r[1] / 2)
                ], a = Math.ceil(n[2] / 2), i = a * Math.ceil(n[1] / 2), "\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + o[0] + ", " + o[1] + "));\n      int index = resTexRC.x * " + o[1] + " + resTexRC.y;\n\n      int b = index / " + i + ";\n      index -= b * " + i + ";\n\n      int r = 2 * (index / " + a + ");\n      int c = imod(index, " + a + ") * 2;\n\n      return ivec3(b, r, c);\n    }\n  ";
            default:
                return function(t, e) {
                    for(var n = [
                        Math.ceil(e[0] / 2),
                        Math.ceil(e[1] / 2)
                    ], r = Math.ceil(t[t.length - 1] / 2), o = r * Math.ceil(t[t.length - 2] / 2), a = o, i = "", s = "b, r, c", u = 2; u < t.length - 1; u++)a *= t[t.length - u - 1], i = "\n      int b" + u + " = index / " + a + ";\n      index -= b" + u + " * " + a + ";\n    " + i, s = "b" + u + ", " + s;
                    return "\n    ivec" + t.length + " getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n      int index = resTexRC.x * " + n[1] + " + resTexRC.y;\n\n      " + i + "\n\n      int b = index / " + o + ";\n      index -= b * " + o + ";\n\n      int r = 2 * (index / " + r + ");\n      int c = imod(index, " + r + ") * 2;\n\n      return ivec" + t.length + "(" + s + ");\n    }\n  ";
                }(t, e);
        }
        var n, r, o, a, i;
    }(e.logicalShape, c), i = function(t) {
        return "\n    void setOutput(vec4 val) {\n      " + t.output + " = val;\n    }\n  ";
    }(l)) : (a = function(t, e) {
        switch(t.length){
            case 0:
                return "\n    int getOutputCoords() {\n      return 0;\n    }\n  ";
            case 1:
                return function(t, e) {
                    if (1 === e[0]) return "\n      int getOutputCoords() {\n        return int(resultUV.x * " + e[1] + ".0);\n      }\n    ";
                    if (1 === e[1]) return "\n      int getOutputCoords() {\n        return int(resultUV.y * " + e[0] + ".0);\n      }\n    ";
                    return "\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + e[0] + ", " + e[1] + "));\n      return resTexRC.x * " + e[1] + " + resTexRC.y;\n    }\n  ";
                }(0, e);
            case 2:
                return function(t, e) {
                    if (S(t, e)) return "\n      ivec2 getOutputCoords() {\n        return ivec2(resultUV.yx * vec2(" + e[0] + ", " + e[1] + "));\n      }\n    ";
                    if (1 === t[1]) return "\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(" + e[0] + ", " + e[1] + "));\n        int index = resTexRC.x * " + e[1] + " + resTexRC.y;\n        return ivec2(index, 0);\n      }\n    ";
                    if (1 === t[0]) return "\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(" + e[0] + ", " + e[1] + "));\n        int index = resTexRC.x * " + e[1] + " + resTexRC.y;\n        return ivec2(0, index);\n      }\n    ";
                    return "\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + e[0] + ", " + e[1] + "));\n      int index = resTexRC.x * " + e[1] + " + resTexRC.y;\n      int r = index / " + t[1] + ";\n      int c = index - r * " + t[1] + ";\n      return ivec2(r, c);\n    }\n  ";
                }(t, e);
            case 3:
                return n = e, r = ca([
                    "r",
                    "c",
                    "d"
                ], t), "\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(" + n[0] + ", " + n[1] + "));\n      int index = resTexRC.x * " + n[1] + " + resTexRC.y;\n      " + r + "\n      return ivec3(r, c, d);\n    }\n  ";
            case 4:
                return function(t, e) {
                    var n = ca([
                        "r",
                        "c",
                        "d",
                        "d2"
                    ], t);
                    return "\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(" + e[0] + ", " + e[1] + "));\n      int index = resTexRC.x * " + e[1] + " + resTexRC.y;\n      " + n + "\n      return ivec4(r, c, d, d2);\n    }\n  ";
                }(t, e);
            case 5:
                return function(t, e) {
                    var n = ca([
                        "r",
                        "c",
                        "d",
                        "d2",
                        "d3"
                    ], t);
                    return "\n    ivec5 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx * vec2(" + e[0] + ",\n                             " + e[1] + "));\n\n      int index = resTexRC.x * " + e[1] + " + resTexRC.y;\n\n      " + n + "\n\n      ivec5 outShape = ivec5(r, c, d, d2, d3);\n      return outShape;\n    }\n  ";
                }(t, e);
            case 6:
                return function(t, e) {
                    var n = ca([
                        "r",
                        "c",
                        "d",
                        "d2",
                        "d3",
                        "d4"
                    ], t);
                    return "\n    ivec6 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(" + e[0] + ", " + e[1] + "));\n      int index = resTexRC.x * " + e[1] + " + resTexRC.y;\n\n      " + n + "\n\n      ivec6 result = ivec6(r, c, d, d2, d3, d4);\n      return result;\n    }\n  ";
                }(t, e);
            default:
                throw new Error(t.length + "-D output sampling is not yet supported");
        }
        var n, r;
    }(e.logicalShape, c), i = function(t) {
        return "\n    void setOutput(float val) {\n      " + t.output + " = vec4(val, 0, 0, 0);\n    }\n  ";
    }(l)), r && (f += ya), [
        f,
        h,
        i,
        s,
        a,
        u,
        n
    ].join("\n");
}
function da(t) {
    var e = t.shapeInfo.logicalShape;
    switch(e.length){
        case 0:
            return function(t) {
                var e = t.name, n = "get" + e.charAt(0).toUpperCase() + e.slice(1);
                if (t.shapeInfo.isUniform) return "float " + n + "() {return " + e + ";}";
                var r = t.shapeInfo.texShape, o = r[0], a = r[1];
                if (1 === o && 1 === a) return "\n      float " + n + "() {\n        return sampleTexture(" + e + ", halfCR);\n      }\n    ";
                var i = t.shapeInfo.texShape, s = i[0], u = i[1], c = xa(e);
                return "\n    float " + n + "() {\n      vec2 uv = uvFromFlat(" + s + ", " + u + ", " + c + ");\n      return sampleTexture(" + e + ", uv);\n    }\n  ";
            }(t);
        case 1:
            return function(t) {
                var e = t.name, n = "get" + e.charAt(0).toUpperCase() + e.slice(1);
                if (t.shapeInfo.isUniform) return "\n      float " + n + "(int index) {\n        " + ba(t) + "\n      }\n    ";
                var r = t.shapeInfo.texShape, o = r[0], a = r[1];
                if (1 === a && 1 === o) return "\n      float " + n + "(int index) {\n        return sampleTexture(" + e + ", halfCR);\n      }\n    ";
                var i = xa(e);
                if (1 === a) return "\n      float " + n + "(int index) {\n        vec2 uv = vec2(0.5, (float(index + " + i + ") + 0.5) / " + o + ".0);\n        return sampleTexture(" + e + ", uv);\n      }\n    ";
                if (1 === o) return "\n      float " + n + "(int index) {\n        vec2 uv = vec2((float(index + " + i + ") + 0.5) / " + a + ".0, 0.5);\n        return sampleTexture(" + e + ", uv);\n      }\n    ";
                return "\n    float " + n + "(int index) {\n      vec2 uv = uvFromFlat(" + o + ", " + a + ", index + " + i + ");\n      return sampleTexture(" + e + ", uv);\n    }\n  ";
            }(t);
        case 2:
            return function(t) {
                var e = t.shapeInfo.logicalShape, n = t.name, r = "get" + n.charAt(0).toUpperCase() + n.slice(1), o = t.shapeInfo.texShape;
                if (null != o && S(e, o)) {
                    var a = o[0], i = o[1];
                    return "\n    float " + r + "(int row, int col) {\n      vec2 uv = (vec2(col, row) + halfCR) / vec2(" + i + ".0, " + a + ".0);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
                }
                var s = M(e), u = s.newShape, c = s.keptDims, l = u;
                if (l.length < e.length) {
                    var h = Ca(t, l);
                    return "\n      " + da(h) + "\n      float " + r + "(int row, int col) {\n        return " + r + "(" + Ea([
                        "row",
                        "col"
                    ], c) + ");\n      }\n    ";
                }
                if (t.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col) {\n        int index = round(dot(vec2(row, col), vec2(" + e[1] + ", 1)));\n        " + ba(t) + "\n      }\n    ";
                var f = o[0], d = o[1], p = xa(n);
                if (1 === d) return "\n    float " + r + "(int row, int col) {\n      float index = dot(vec3(row, col, " + p + "), vec3(" + e[1] + ", 1, 1));\n      vec2 uv = vec2(0.5, (index + 0.5) / " + f + ".0);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
                if (1 === f) return "\n    float " + r + "(int row, int col) {\n      float index = dot(vec3(row, col, " + p + "), vec3(" + e[1] + ", 1, 1));\n      vec2 uv = vec2((index + 0.5) / " + d + ".0, 0.5);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
                return "\n  float " + r + "(int row, int col) {\n    // Explicitly use integer operations as dot() only works on floats.\n    int index = row * " + e[1] + " + col + " + p + ";\n    vec2 uv = uvFromFlat(" + f + ", " + d + ", index);\n    return sampleTexture(" + n + ", uv);\n  }\n";
            }(t);
        case 3:
            return function(t) {
                var e = t.shapeInfo.logicalShape, n = t.name, r = "get" + n.charAt(0).toUpperCase() + n.slice(1), o = e[1] * e[2], a = e[2], i = M(e), s = i.newShape, u = i.keptDims, c = s;
                if (c.length < e.length) {
                    var l = Ca(t, c);
                    return "\n        " + da(l) + "\n        float " + r + "(int row, int col, int depth) {\n          return " + r + "(" + Ea([
                        "row",
                        "col",
                        "depth"
                    ], u) + ");\n        }\n      ";
                }
                if (t.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth) {\n        int index = round(dot(vec3(row, col, depth),\n                          vec3(" + o + ", " + a + ", 1)));\n        " + ba(t) + "\n      }\n    ";
                var h = t.shapeInfo.texShape, f = h[0], d = h[1], p = t.shapeInfo.flatOffset;
                if (d === o && null == p) return "\n        float " + r + "(int row, int col, int depth) {\n          float texR = float(row);\n          float texC = dot(vec2(col, depth), vec2(" + a + ", 1));\n          vec2 uv = (vec2(texC, texR) + halfCR) /\n                     vec2(" + d + ".0, " + f + ".0);\n          return sampleTexture(" + n + ", uv);\n        }\n      ";
                if (d === a && null == p) return "\n    float " + r + "(int row, int col, int depth) {\n      float texR = dot(vec2(row, col), vec2(" + e[1] + ", 1));\n      float texC = float(depth);\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + d + ".0, " + f + ".0);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
                var v = xa(n);
                return "\n      float " + r + "(int row, int col, int depth) {\n        // Explicitly use integer operations as dot() only works on floats.\n        int index = row * " + o + " + col * " + a + " + depth + " + v + ";\n        vec2 uv = uvFromFlat(" + f + ", " + d + ", index);\n        return sampleTexture(" + n + ", uv);\n      }\n  ";
            }(t);
        case 4:
            return function(t) {
                var e = t.shapeInfo.logicalShape, n = t.name, r = "get" + n.charAt(0).toUpperCase() + n.slice(1), o = e[3], a = e[2] * o, i = e[1] * a, s = M(e), u = s.newShape, c = s.keptDims;
                if (u.length < e.length) {
                    var l = Ca(t, u);
                    return "\n      " + da(l) + "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        return " + r + "(" + Ea([
                        "row",
                        "col",
                        "depth",
                        "depth2"
                    ], c) + ");\n      }\n    ";
                }
                if (t.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        int index = round(dot(vec4(row, col, depth, depth2),\n                          vec4(" + i + ", " + a + ", " + o + ", 1)));\n        " + ba(t) + "\n      }\n    ";
                var h = t.shapeInfo.flatOffset, f = t.shapeInfo.texShape, d = f[0], p = f[1];
                if (p === i && null == h) return "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        float texR = float(row);\n        float texC =\n            dot(vec3(col, depth, depth2),\n                vec3(" + a + ", " + o + ", 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + p + ".0, " + d + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    ";
                if (p === o && null == h) return "\n      float " + r + "(int row, int col, int depth, int depth2) {\n        float texR = dot(vec3(row, col, depth),\n                         vec3(" + e[1] * e[2] + ", " + e[2] + ", 1));\n        float texC = float(depth2);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + p + ".0, " + d + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    ";
                var v = xa(n);
                return "\n    float " + r + "(int row, int col, int depth, int depth2) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * " + i + " + col * " + a + " +\n          depth * " + o + " + depth2;\n      vec2 uv = uvFromFlat(" + d + ", " + p + ", index + " + v + ");\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
            }(t);
        case 5:
            return function(t) {
                var e = t.shapeInfo.logicalShape, n = t.name, r = "get" + n.charAt(0).toUpperCase() + n.slice(1), o = e[4], a = e[3] * o, i = e[2] * a, s = e[1] * i, u = M(e), c = u.newShape, l = u.keptDims;
                if (c.length < e.length) {
                    var h = Ca(t, c);
                    return "\n      " + da(h) + "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        return " + r + "(" + Ea([
                        "row",
                        "col",
                        "depth",
                        "depth2",
                        "depth3"
                    ], l) + ");\n      }\n    ";
                }
                if (t.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        float index = dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + s + ", " + i + ", " + a + ", " + o + ")) +\n          depth3;\n        " + ba(t) + "\n      }\n    ";
                var f = t.shapeInfo.flatOffset, d = t.shapeInfo.texShape, p = d[0], v = d[1];
                if (v === s && null == f) return "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        int texR = row;\n        float texC = dot(vec4(col, depth, depth2, depth3),\n                         vec4(" + i + ", " + a + ", " + o + ", 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + v + ".0, " + p + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    ";
                if (v === o && null == f) return "\n      float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n        float texR = dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + e[1] * e[2] * e[3] + ",\n               " + e[2] * e[3] + ", " + e[3] + ", 1));\n        int texC = depth3;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + v + ".0, " + p + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    ";
                var m = xa(n);
                return "\n    float " + r + "(int row, int col, int depth, int depth2, int depth3) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * " + s + " + col * " + i + " + depth * " + a + " +\n          depth2 * " + o + " + depth3 + " + m + ";\n      vec2 uv = uvFromFlat(" + p + ", " + v + ", index);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
            }(t);
        case 6:
            return function(t) {
                var e = t.shapeInfo.logicalShape, n = t.name, r = "get" + n.charAt(0).toUpperCase() + n.slice(1), o = M(e), a = o.newShape, i = o.keptDims;
                if (a.length < e.length) {
                    var s = Ca(t, a);
                    return "\n      " + da(s) + "\n      float " + r + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        return " + r + "(" + Ea([
                        "row",
                        "col",
                        "depth",
                        "depth2",
                        "depth3",
                        "depth4"
                    ], i) + ");\n      }\n    ";
                }
                var u = e[5], c = e[4] * u, l = e[3] * c, h = e[2] * l, f = e[1] * h;
                if (t.shapeInfo.isUniform) return "\n      float " + r + "(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n        int index = round(dot(\n          vec4(row, col, depth, depth2),\n          vec4(" + f + ", " + h + ", " + l + ", " + c + ")) +\n          dot(\n            vec2(depth3, depth4),\n            vec2(" + u + ", 1)));\n        " + ba(t) + "\n      }\n    ";
                var d = t.shapeInfo.flatOffset, p = t.shapeInfo.texShape, v = p[0], m = p[1];
                if (m === f && null == d) return "\n      float " + r + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        int texR = row;\n        float texC = dot(vec4(col, depth, depth2, depth3),\n          vec4(" + h + ", " + l + ", " + c + ", " + u + ")) +\n               float(depth4);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(" + m + ".0, " + v + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    ";
                if (m === u && null == d) return "\n      float " + r + "(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        float texR = dot(vec4(row, col, depth, depth2),\n          vec4(" + e[1] * e[2] * e[3] * e[4] + ",\n               " + e[2] * e[3] * e[4] + ",\n               " + e[3] * e[4] + ",\n               " + e[4] + ")) + float(depth3);\n        int texC = depth4;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(" + m + ".0, " + v + ".0);\n        return sampleTexture(" + n + ", uv);\n      }\n    ";
                var g = xa(n);
                return "\n    float " + r + "(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * " + f + " + col * " + h + " + depth * " + l + " +\n          depth2 * " + c + " + depth3 * " + u + " + depth4 + " + g + ";\n      vec2 uv = uvFromFlat(" + v + ", " + m + ", index);\n      return sampleTexture(" + n + ", uv);\n    }\n  ";
            }(t);
        default:
            throw new Error(e.length + "-D input sampling is not yet supported");
    }
}
function pa(t) {
    var e, n, r;
    switch(t.shapeInfo.logicalShape.length){
        case 0:
            return e = t.name, n = "get" + e.charAt(0).toUpperCase() + e.slice(1), r = ua(), "\n    vec4 " + n + "() {\n      return " + r.texture2D + "(" + e + ", halfCR);\n    }\n  ";
        case 1:
            return function(t) {
                var e = t.name, n = "get" + e.charAt(0).toUpperCase() + e.slice(1), r = t.shapeInfo.texShape, o = [
                    Math.ceil(r[0] / 2),
                    Math.ceil(r[1] / 2)
                ], a = ua();
                return "\n    vec4 " + n + "(int index) {\n      vec2 uv = packedUVfrom1D(\n        " + o[0] + ", " + o[1] + ", index);\n      return " + a.texture2D + "(" + e + ", uv);\n    }\n  ";
            }(t);
        case 2:
            return function(t) {
                var e = t.shapeInfo.logicalShape, n = t.name, r = "get" + n.charAt(0).toUpperCase() + n.slice(1), o = t.shapeInfo.texShape, a = o[0], i = o[1], s = ua();
                if (null != o && S(e, o)) return "\n      vec4 " + r + "(int row, int col) {\n        vec2 uv = (vec2(col, row) + halfCR) / vec2(" + i + ".0, " + a + ".0);\n\n        return " + s.texture2D + "(" + n + ", uv);\n      }\n    ";
                var u = [
                    Math.ceil(o[0] / 2),
                    Math.ceil(o[1] / 2)
                ], c = Math.ceil(e[1] / 2);
                return "\n    vec4 " + r + "(int row, int col) {\n      vec2 uv = packedUVfrom2D(" + c + ", " + u[0] + ", " + u[1] + ", row, col);\n      return " + s.texture2D + "(" + n + ", uv);\n    }\n  ";
            }(t);
        case 3:
            return function(t) {
                var e = t.shapeInfo.logicalShape, n = t.name, r = "get" + n.charAt(0).toUpperCase() + n.slice(1), o = t.shapeInfo.texShape, a = [
                    Math.ceil(o[0] / 2),
                    Math.ceil(o[1] / 2)
                ];
                if (1 === e[0]) {
                    var i = e.slice(1), s = Ca(t, i);
                    return "\n        " + pa(s) + "\n        vec4 " + r + "(int b, int row, int col) {\n          return " + r + "(" + Ea([
                        "b",
                        "row",
                        "col"
                    ], [
                        1,
                        2
                    ]) + ");\n        }\n      ";
                }
                var u = a[0], c = a[1], l = Math.ceil(e[2] / 2), h = l * Math.ceil(e[1] / 2), f = ua();
                return "\n    vec4 " + r + "(int b, int row, int col) {\n      vec2 uv = packedUVfrom3D(\n        " + u + ", " + c + ", " + h + ", " + l + ", b, row, col);\n      return " + f.texture2D + "(" + n + ", uv);\n    }\n  ";
            }(t);
        default:
            return function(t) {
                for(var e = t.shapeInfo.logicalShape, n = e.length, r = t.name, o = "get" + r.charAt(0).toUpperCase() + r.slice(1), a = t.shapeInfo.texShape, i = [
                    Math.ceil(a[0] / 2),
                    Math.ceil(a[1] / 2)
                ], s = i[0], u = i[1], c = Math.ceil(e[n - 1] / 2), l = c * Math.ceil(e[n - 2] / 2), h = "int b, int row, int col", f = "b * " + l + " + (row / 2) * " + c + " + (col / 2)", d = 2; d < n - 1; d++)h = "int b" + d + ", " + h, l *= e[n - d - 1], f = "b" + d + " * " + l + " + " + f;
                var p = ua();
                return "\n    vec4 " + o + "(" + h + ") {\n      int index = " + f + ";\n      int texR = index / " + u + ";\n      int texC = index - texR * " + u + ";\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + u + ", " + s + ");\n      return " + p.texture2D + "(" + r + ", uv);\n    }\n  ";
            }(t);
    }
}
var va = "\nvec2 uvFromFlat(int texNumR, int texNumC, int index) {\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom1D(int texNumR, int texNumC, int index) {\n  int texelIndex = index / 2;\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n", ma = "\nvec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,\n  int texNumC, int row, int col) {\n  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n", ga = "\nvec2 packedUVfrom3D(int texNumR, int texNumC,\n    int texelsInBatch, int texelsInLogicalRow, int b,\n    int row, int col) {\n  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n", ya = "\n  float getChannel(vec4 frag, vec2 innerDims) {\n    vec2 modCoord = mod(innerDims, 2.);\n    return modCoord.x == 0. ?\n      (modCoord.y == 0. ? frag.r : frag.g) :\n      (modCoord.y == 0. ? frag.b : frag.a);\n  }\n  float getChannel(vec4 frag, int dim) {\n    float modCoord = mod(float(dim), 2.);\n    return modCoord == 0. ? frag.r : frag.g;\n  }\n";
function xa(t) {
    return "offset" + t;
}
function ba(t) {
    var e = t.name, n = k(t.shapeInfo.logicalShape);
    return n < 2 ? "return " + e + ";" : "\n    for (int i = 0; i < " + n + "; i++) {\n      if (i == index) {\n        return " + e + "[i];\n      }\n    }\n  ";
}
function wa(t) {
    if (t <= 1) return "int";
    if (2 === t) return "ivec2";
    if (3 === t) return "ivec3";
    if (4 === t) return "ivec4";
    if (5 === t) return "ivec5";
    if (6 === t) return "ivec6";
    throw Error("GPU for rank " + t + " is not yet supported");
}
function Ca(t, e) {
    var n = JSON.parse(JSON.stringify(t));
    return n.shapeInfo.logicalShape = e, n;
}
function Ea(t, e) {
    return e.map(function(e) {
        return t[e];
    }).join(", ");
}
var Ra = function(t, e, n, r) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !0, this.packedOutput = !0, C(t.length > 2, function() {
        return "Packed arg" + (n.charAt(0).toUpperCase() + n.slice(1)) + " supports only inputs with rank above 2.";
    });
    var o = t[t.length - 1], a = Math.ceil(o / e);
    this.outputShape = t.slice(0, -1), a > 1 && this.outputShape.push(a), r || this.variableNames.push("bestIndicesA");
    var i, s, u = this.outputShape, c = u.length, l = wa(c), h = sa("coords", c);
    if (1 === a) {
        var f = wa(s = c + 1);
        i = "\n        " + f + " sourceLocR = " + f + "(" + h.join() + ", 0);\n        ++" + h[c - 1] + ";\n        " + f + " sourceLocG = " + f + "(" + h.join() + ", 0);\n        ++" + h[c - 2] + ";\n        " + f + " sourceLocA = " + f + "(" + h.join() + ", 0);\n        --" + h[c - 1] + ";\n        " + f + " sourceLocB = " + f + "(" + h.join() + ", 0);\n        --" + h[c - 2] + ";";
    } else s = c, i = "\n        " + l + " sourceLocR = coords;\n        ++" + h[c - 1] + ";\n        " + l + " sourceLocG = coords;\n        ++" + h[c - 2] + ";\n        " + l + " sourceLocA = coords;\n        --" + h[c - 1] + ";\n        " + l + " sourceLocB = coords;\n        --" + h[c - 2] + ";";
    var d = [
        "x",
        "y",
        "z",
        "w",
        "u",
        "v"
    ].slice(0, s), p = "." + d[s - 1], v = d.map(function(t) {
        return "int " + t;
    }), m = sa("sourceLocR", s - 1).concat("inIdx.r"), g = sa("sourceLocG", s - 1).concat("inIdx.g"), y = sa("sourceLocB", s - 1).concat("inIdx.b"), x = sa("sourceLocA", s - 1).concat("inIdx.a"), b = "max" === n ? "greaterThan" : "lessThan", w = r ? "" : "\n          inIdx = round(vec4(getBestIndicesAChannel(" + m.join() + "),\n                             getBestIndicesAChannel(" + g.join() + "),\n                             getBestIndicesAChannel(" + y.join() + "),\n                             getBestIndicesAChannel(" + x.join() + ")));", E = "vec4(\n            getAChannel(" + m.join() + "),\n            hasNextCol ? getAChannel(" + g.join() + ") : 0.,\n            hasNextRow ? getAChannel(" + y.join() + ") : 0.,\n            hasNextRow && hasNextCol ? getAChannel(" + x.join() + ") : 0.)", R = r ? "" : "\n      float getBestIndicesAChannel(" + v.join() + ") {\n        return getChannel(getBestIndicesA(" + d.join() + "),\n                                          vec2(" + d.slice(-2).join() + "));\n      }";
    this.userCode = "\n      float getAChannel(" + v.join() + ") {\n        return getChannel(getA(" + d.join() + "),\n                               vec2(" + d.slice(-2).join() + "));\n      }\n      " + R + "\n      void main() {\n        " + l + " coords = getOutputCoords();\n        bool hasNextCol = " + h[c - 1] + " < " + (u[c - 1] - 1) + ";\n        bool hasNextRow = " + h[c - 2] + " < " + (u[c - 2] - 1) + ";\n        " + i + "\n        ivec4 srcIdx = ivec4(sourceLocR" + p + ", sourceLocG" + p + ",\n          sourceLocB" + p + ", sourceLocA" + p + ") * " + e + ";\n        ivec4 inIdx = srcIdx;\n        vec4 bestIndex = vec4(inIdx);\n        vec4 bestValue = " + E + ";\n\n        for (int i = 0; i < " + e + "; i++) {\n          inIdx = srcIdx;\n          " + w + "\n          vec4 candidate = " + E + ";\n          bvec4 nan = isnan(candidate);\n          bvec4 replace = bvec4(\n            vec4(" + b + "(candidate, bestValue)) * (vec4(1.0) - vec4(nan)));\n\n          bestValue = vec4(replace.x  ? candidate.x : bestValue.x,\n                           replace.y  ? candidate.y : bestValue.y,\n                           replace.z  ? candidate.z : bestValue.z,\n                           replace.w  ? candidate.w : bestValue.w);\n          bestIndex = mix(bestIndex, vec4(inIdx), vec4(replace));\n          srcIdx++;\n        }\n        setOutput(bestIndex);\n      }\n    ";
}, Ia = function(t) {
    this.variableNames = [
        "dy"
    ], this.outputShape = t.inShape;
    var e = t.filterHeight, n = t.filterWidth, r = t.strideHeight, o = t.strideWidth, a = t.dilationHeight, i = t.dilationWidth, s = t.effectiveFilterHeight, u = t.effectiveFilterWidth, c = s - 1 - t.padInfo.top, l = u - 1 - t.padInfo.left, h = 1 / (e * n);
    this.userCode = "\n      const ivec2 pads = ivec2(" + c + ", " + l + ");\n      const float avgMultiplier = float(" + h + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + s + ";\n            wR += " + a + ") {\n          float dyR = float(dyRCorner + wR) / " + r + ".0;\n\n          if (dyR < 0.0 || dyR >= " + t.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < " + u + ";\n            wC+= " + i + ") {\n            float dyC = float(dyCCorner + wC) / " + o + ".0;\n\n            if (dyC < 0.0 || dyC >= " + t.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n\n            dotProd += dyValue * avgMultiplier;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, ka = function(t) {
    this.variableNames = [
        "dy"
    ], this.outputShape = t.inShape;
    var e = t.filterDepth, n = t.filterHeight, r = t.filterWidth, o = t.strideDepth, a = t.strideHeight, i = t.strideWidth, s = t.dilationDepth, u = t.dilationHeight, c = t.dilationWidth, l = t.effectiveFilterDepth, h = t.effectiveFilterHeight, f = t.effectiveFilterWidth, d = l - 1 - t.padInfo.front, p = h - 1 - t.padInfo.top, v = f - 1 - t.padInfo.left, m = 1 / (e * n * r);
    this.userCode = "\n      const ivec3 pads = ivec3(" + d + ", " + p + ", " + v + ");\n      const float avgMultiplier = float(" + m + ");\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyDCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get\n        // dx(xD, xR, xC, ch).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int wD = 0; wD < " + l + ";\n            wD += " + s + ") {\n          float dyD = float(dyDCorner + wD) / " + o + ".0;\n\n          if (dyD < 0.0 || dyD >= " + t.outDepth + ".0 || fract(dyD) > 0.0) {\n            continue;\n          }\n          int idyD = int(dyD);\n\n          for (int wR = 0; wR < " + h + ";\n              wR += " + u + ") {\n            float dyR = float(dyRCorner + wR) / " + a + ".0;\n\n            if (dyR < 0.0 || dyR >= " + t.outHeight + ".0 ||\n                fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            for (int wC = 0; wC < " + f + ";\n                wC += " + c + ") {\n              float dyC = float(dyCCorner + wC) / " + i + ".0;\n\n              if (dyC < 0.0 || dyC >= " + t.outWidth + ".0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              float dyValue = getDy(batch, idyD, idyR, idyC, ch);\n\n              dotProd += dyValue * avgMultiplier;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, Sa = function(t, e, n, r, o, a) {
    this.outputShape = [], this.variableNames = [
        "x",
        "mean",
        "variance"
    ], Ro(t, e), Ro(t, n);
    var i = "0.0";
    null != r && (Ro(t, r), this.variableNames.push("offset"), i = "getOffsetAtOutCoords()");
    var s = "1.0";
    null != o && (Ro(t, o), this.variableNames.push("scale"), s = "getScaleAtOutCoords()"), this.outputShape = t, this.userCode = "\n      void main() {\n        float x = getXAtOutCoords();\n        float mean = getMeanAtOutCoords();\n        float variance = getVarianceAtOutCoords();\n        float offset = " + i + ";\n        float scale = " + s + ";\n        float inv = scale * inversesqrt(variance + float(" + a + "));\n        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));\n      }\n    ";
}, Aa = function(t, e, n, r, o, a) {
    this.packedInputs = !0, this.packedOutput = !0, this.variableNames = [
        "x",
        "mean",
        "variance"
    ], Ro(t, e), Ro(t, n);
    var i = "vec4(0.0)";
    null != r && (Ro(t, r), this.variableNames.push("offset"), i = "getOffsetAtOutCoords()");
    var s = "vec4(1.0)";
    null != o && (Ro(t, o), this.variableNames.push("scale"), s = "getScaleAtOutCoords()"), this.outputShape = t, this.userCode = "\n      void main() {\n        vec4 offset = " + i + ";\n        vec4 scale = " + s + ";\n\n        vec4 x = getXAtOutCoords();\n        vec4 mean = getMeanAtOutCoords();\n        vec4 variance = getVarianceAtOutCoords();\n\n        vec4 inv = scale * inversesqrt(variance + vec4(" + a + "));\n\n        setOutput((x - mean) * inv + offset);\n      }\n    ";
}, Da = "return areal * breal - aimag * bimag;", Ta = "return areal * bimag + aimag * breal;", Na = function(t, e, n) {
    this.variableNames = [
        "AReal",
        "AImag",
        "BReal",
        "BImag"
    ], this.outputShape = Ro(e, n), this.userCode = "\n      float binaryOpComplex(\n          float areal, float aimag, float breal, float bimag) {\n        " + t + "\n      }\n\n      void main() {\n        float areal = getARealAtOutCoords();\n        float aimag = getAImagAtOutCoords();\n        float breal = getBRealAtOutCoords();\n        float bimag = getBImagAtOutCoords();\n        setOutput(binaryOpComplex(areal, aimag, breal, bimag));\n      }\n    ";
}, Fa = "return a + b;", _a = "return a - b;", Oa = "return a * b;", Ma = "return (a < 0.) ? b * a : a;", Ba = function(t, e, n) {
    this.variableNames = [
        "A",
        "B"
    ], this.outputShape = Ro(e, n), this.userCode = "\n      float binaryOperation(float a, float b) {\n        " + t + "\n      }\n\n      void main() {\n        float a = getAAtOutCoords();\n        float b = getBAtOutCoords();\n        setOutput(binaryOperation(a, b));\n      }\n    ";
}, Pa = "\n  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));\n  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);\n", La = function(t, e, n, r) {
    void 0 === r && (r = !1), this.variableNames = [
        "A",
        "B"
    ], this.supportsBroadcasting = !0, this.packedInputs = !0, this.packedOutput = !0, this.outputShape = Ro(e, n);
    var o = this.outputShape.length, a = "";
    if (r) {
        if (0 === o || 1 === k(this.outputShape)) a = "\n          result.y = 0.;\n          result.z = 0.;\n          result.w = 0.;\n        ";
        else if (a = "\n          " + wa(o) + " coords = getOutputCoords();\n        ", 1 === o) a += "\n            result.y = (coords + 1) >= " + this.outputShape[0] + " ? 0. : result.y;\n            result.z = 0.;\n            result.w = 0.;\n          ";
        else {
            var i = sa("coords", o);
            a += "\n            bool nextRowOutOfBounds =\n              (" + i[o - 2] + " + 1) >= " + this.outputShape[o - 2] + ";\n            bool nextColOutOfBounds =\n              (" + i[o - 1] + " + 1) >= " + this.outputShape[o - 1] + ";\n            result.y = nextColOutOfBounds ? 0. : result.y;\n            result.z = nextRowOutOfBounds ? 0. : result.z;\n            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;\n          ";
        }
    }
    this.userCode = "\n      vec4 binaryOperation(vec4 a, vec4 b) {\n        " + t + "\n      }\n\n      void main() {\n        vec4 a = getAAtOutCoords();\n        vec4 b = getBAtOutCoords();\n\n        vec4 result = binaryOperation(a, b);\n        " + a + "\n\n        setOutput(result);\n      }\n    ";
}, Wa = function() {
    function t(t) {
        this.variableNames = [
            "A"
        ], this.outputShape = t, this.userCode = "\n      uniform float minVal;\n      uniform float maxVal;\n\n      void main() {\n        float value = getAAtOutCoords();\n        if (isnan(value)) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, minVal, maxVal));\n      }\n    ";
    }
    return t.prototype.getCustomSetupFunc = function(t, e) {
        var n = this;
        return function(r, o) {
            null == n.minLoc && (n.minLoc = r.getUniformLocationNoThrow(o, "minVal"), n.maxLoc = r.getUniformLocationNoThrow(o, "maxVal")), r.gl.uniform1f(n.minLoc, t), r.gl.uniform1f(n.maxLoc, e);
        };
    }, t;
}(), Ua = function() {
    function t(t) {
        this.variableNames = [
            "A"
        ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.userCode = "\n      uniform float minVal;\n      uniform float maxVal;\n\n      void main() {\n        vec4 value = getAAtOutCoords();\n\n        if (any(isnan(value))) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, vec4(minVal), vec4(maxVal)));\n      }\n    ";
    }
    return t.prototype.getCustomSetupFunc = function(t, e) {
        var n = this;
        return function(r, o) {
            null == n.minLoc && (n.minLoc = r.getUniformLocationNoThrow(o, "minVal"), n.maxLoc = r.getUniformLocationNoThrow(o, "maxVal")), r.gl.uniform1f(n.minLoc, t), r.gl.uniform1f(n.maxLoc, e);
        };
    }, t;
}(), Va = function(t) {
    this.variableNames = [
        "real",
        "imag"
    ], this.outputShape = t, this.userCode = "\n      void main() {\n        float re = abs(getRealAtOutCoords());\n        float im = abs(getImagAtOutCoords());\n        float mx = max(re, im);\n\n        // sadly the length function in glsl is not underflow-safe\n        // (at least not on Intel GPUs). So the safe solution is\n        // to ensure underflow-safety in all cases.\n        setOutput(\n          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))\n        );\n      }\n    ";
}, za = function(t) {
    this.outputShape = [], this.outputShape = Sn(t, 1), this.variableNames = t.map(function(t, e) {
        return "T" + e;
    });
    var e = new Array(t.length - 1);
    e[0] = t[0][1];
    for(var n = 1; n < e.length; n++)e[n] = e[n - 1] + t[n][1];
    var r = [
        "if (yC < " + e[0] + ") setOutput(getT0(yR, yC));"
    ];
    for(n = 1; n < e.length; n++){
        var o = e[n - 1];
        r.push("else if (yC < " + e[n] + ") setOutput(getT" + n + "(yR, yC-" + o + "));");
    }
    var a = e.length, i = e[e.length - 1];
    r.push("else setOutput(getT" + a + "(yR, yC-" + i + "));"), this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int yR = coords.x;\n        int yC = coords.y;\n\n        " + r.join("\n        ") + "\n      }\n    ";
}, Ga = function(t, e) {
    this.packedInputs = !0, this.packedOutput = !0, this.outputShape = [], this.outputShape = Sn(t, e);
    var n = this.outputShape, r = n.length, o = wa(r), a = sa("coords", r), i = [
        "x",
        "y",
        "z",
        "w",
        "u",
        "v"
    ].slice(0, r);
    this.variableNames = t.map(function(t, e) {
        return "T" + e;
    });
    var s = new Array(t.length - 1);
    s[0] = t[0][e];
    for(var u = 1; u < s.length; u++)s[u] = s[u - 1] + t[u][e];
    var c = i[e], l = i.slice(-2), h = i.join(), f = "if (" + c + " < " + s[0] + ") {\n        return getChannel(\n            getT0(" + h + "), vec2(" + l.join() + "));\n        }";
    for(u = 1; u < s.length; u++){
        var d = s[u - 1];
        f += "\n        if (" + c + " < " + s[u] + "  && " + c + " >= " + s[u - 1] + ") {\n          return getChannel(\n            getT" + u + "(" + Ha(i, c, d) + "),\n            vec2(" + Ha(l, c, d) + "));\n        }";
    }
    var p = s.length, v = s[s.length - 1];
    f += "\n        return getChannel(\n          getT" + p + "(" + Ha(i, c, v) + "),\n          vec2(" + Ha(l, c, v) + "));", this.userCode = "\n      float getValue(" + i.map(function(t) {
        return "int " + t;
    }) + ") {\n        " + f + "\n      }\n\n      void main() {\n        " + o + " coords = getOutputCoords();\n        vec4 result = vec4(getValue(" + a + "), 0., 0., 0.);\n\n        " + a[r - 1] + " = " + a[r - 1] + " + 1;\n        if (" + a[r - 1] + " < " + n[r - 1] + ") {\n          result.g = getValue(" + a + ");\n        }\n\n        " + a[r - 2] + " = " + a[r - 2] + " + 1;\n        if (" + a[r - 2] + " < " + n[r - 2] + ") {\n          result.a = getValue(" + a + ");\n        }\n\n        " + a[r - 1] + " = " + a[r - 1] + " - 1;\n        if (" + a[r - 2] + " < " + n[r - 2] + " &&\n            " + a[r - 1] + " < " + n[r - 1] + ") {\n          result.b = getValue(" + a + ");\n        }\n        setOutput(result);\n      }\n    ";
};
function Ha(t, e, n) {
    var r = t.indexOf(e);
    return t.map(function(t, e) {
        return e === r ? t + " - " + n : t;
    }).join();
}
var qa = function(t) {
    this.variableNames = [
        "x",
        "dy"
    ], this.outputShape = t.filterShape;
    var e = t.strideHeight, n = t.strideWidth, r = t.padInfo.top, o = t.padInfo.left, a = "channelsLast" === t.dataFormat;
    this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int d2 = coords.w;\n\n        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int b = 0; b < " + t.batchSize + "; b++) {\n          for (int yR = 0; yR < " + t.outHeight + "; yR++) {\n            int xR = wR + yR * " + e + " - " + r + ";\n\n            if (xR < 0 || xR >= " + t.inHeight + ") {\n              continue;\n            }\n\n            for (int yC = 0; yC < " + t.outWidth + "; yC++) {\n              int xC = wC + yC * " + n + " - " + o + ";\n\n              if (xC < 0 || xC >= " + t.inWidth + ") {\n                continue;\n              }\n\n              if (" + a + ") {\n                float dyValue = getDy(b, yR, yC, d2);\n                float xValue = getX(b, xR, xC, d1);\n                dotProd += (xValue * dyValue);\n              } else {\n                float dyValue = getDy(b, d2, yR, yC);\n                float xValue = getX(b, d1, xR, xC);\n                dotProd += (xValue * dyValue);\n              }\n\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, Ka = function(t) {
    this.variableNames = [
        "dy",
        "W"
    ], this.outputShape = t.inShape;
    var e = t.filterHeight, n = t.filterWidth, r = t.strideHeight, o = t.strideWidth, a = "channelsLast" === t.dataFormat, i = e - 1 - t.padInfo.top, s = n - 1 - t.padInfo.left, u = a ? 1 : 2, c = a ? 2 : 3, l = a ? 3 : 1;
    this.userCode = "\n      const ivec2 pads = ivec2(" + i + ", " + s + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[" + l + "];\n\n        ivec2 dyCorner = ivec2(coords[" + u + "], coords[" + c + "]) - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + e + "; wR++) {\n          float dyR = float(dyRCorner + wR) / " + r + ".0;\n\n          if (dyR < 0.0 || dyR >= " + t.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = " + e + " - 1 - wR;\n\n          for (int wC = 0; wC < " + n + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + o + ".0;\n\n            if (dyC < 0.0 || dyC >= " + t.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = " + n + " - 1 - wC;\n\n            for (int d2 = 0; d2 < " + t.outChannels + "; d2++) {\n\n              if (" + a + ") {\n                float xValue = getDy(batch, idyR, idyC, d2);\n                float wValue = getW(wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              } else {\n                float xValue = getDy(batch, d2, idyR, idyC);\n                float wValue = getW(wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              }\n\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, ja = function(t) {
    this.variableNames = [
        "x",
        "dy"
    ], this.outputShape = t.filterShape;
    var e = t.strideDepth, n = t.strideHeight, r = t.strideWidth, o = t.padInfo.front, a = t.padInfo.top, i = t.padInfo.left;
    this.userCode = "\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int wF = coords.x;\n        int wR = coords.y;\n        int wC = coords.z;\n        int d1 = coords.w;\n        int d2 = coords.u;\n\n        float dotProd = 0.0;\n\n        for (int b = 0; b < " + t.batchSize + "; b++) {\n          for (int yF = 0; yF < " + t.outDepth + "; yF++) {\n            int xF = wF + yF * " + e + " - " + o + ";\n\n            if (xF < 0 || xF >= " + t.inDepth + ") {\n              continue;\n            }\n\n            for (int yR = 0; yR < " + t.outHeight + "; yR++) {\n              int xR = wR + yR * " + n + " - " + a + ";\n\n              if (xR < 0 || xR >= " + t.inHeight + ") {\n                continue;\n              }\n\n              for (int yC = 0; yC < " + t.outWidth + "; yC++) {\n                int xC = wC + yC * " + r + " - " + i + ";\n\n                if (xC < 0 || xC >= " + t.inWidth + ") {\n                  continue;\n                }\n\n                float dyValue = getDy(b, yF, yR, yC, d2);\n                float xValue = getX(b, xF, xR, xC, d1);\n                dotProd += (xValue * dyValue);\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, Xa = function(t) {
    this.variableNames = [
        "dy",
        "W"
    ], this.outputShape = t.inShape;
    var e = t.filterDepth, n = t.filterHeight, r = t.filterWidth, o = t.strideDepth, a = t.strideHeight, i = t.strideWidth, s = e - 1 - t.padInfo.front, u = n - 1 - t.padInfo.top, c = r - 1 - t.padInfo.left;
    this.userCode = "\n      const ivec3 pads = ivec3(" + s + ", " + u + ", " + c + ");\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int d1 = coords.u;\n\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyFCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        float dotProd = 0.0;\n        for (int wF = 0; wF < " + e + "; wF++) {\n          float dyF = float(dyFCorner + wF) / " + o + ".0;\n\n          if (dyF < 0.0 || dyF >= " + t.outDepth + ".0 || fract(dyF) > 0.0) {\n            continue;\n          }\n          int idyF = int(dyF);\n\n          int wFPerm = " + e + " - 1 - wF;\n\n          for (int wR = 0; wR < " + n + "; wR++) {\n            float dyR = float(dyRCorner + wR) / " + a + ".0;\n\n            if (dyR < 0.0 || dyR >= " + t.outHeight + ".0 ||\n              fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            int wRPerm = " + n + " - 1 - wR;\n\n            for (int wC = 0; wC < " + r + "; wC++) {\n              float dyC = float(dyCCorner + wC) / " + i + ".0;\n\n              if (dyC < 0.0 || dyC >= " + t.outWidth + ".0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              int wCPerm = " + r + " - 1 - wC;\n\n              for (int d2 = 0; d2 < " + t.outChannels + "; d2++) {\n                float xValue = getDy(batch, idyF, idyR, idyC, d2);\n                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, Ya = function(t) {
    this.variableNames = [
        "x",
        "dy"
    ], this.outputShape = t.filterShape;
    var e = t.strideHeight, n = t.strideWidth, r = t.padInfo.top, o = t.padInfo.left, a = t.outChannels / t.inChannels;
    this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int dm = coords.w;\n        int d2 = d1 * " + a + " + dm;\n\n        float dotProd = 0.0;\n\n        // TO DO: Vec4 over the batch size\n        for (int b = 0; b < " + t.batchSize + "; b++) {\n          for (int yR = 0; yR < " + t.outHeight + "; yR++) {\n            int xR = wR + yR * " + e + " - " + r + ";\n\n            if (xR < 0 || xR >= " + t.inHeight + ") {\n              continue;\n            }\n\n            for (int yC = 0; yC < " + t.outWidth + "; yC++) {\n              int xC = wC + yC * " + n + " - " + o + ";\n\n              if (xC < 0 || xC >= " + t.inWidth + ") {\n                continue;\n              }\n\n              float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, $a = function(t) {
    this.variableNames = [
        "dy",
        "W"
    ], this.outputShape = t.inShape;
    var e = t.filterHeight, n = t.filterWidth, r = t.strideHeight, o = t.strideWidth, a = e - 1 - t.padInfo.top, i = n - 1 - t.padInfo.left, s = t.outChannels / t.inChannels;
    this.userCode = "\n      const ivec2 pads = ivec2(" + a + ", " + i + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n        ivec2 dyCorner = coords.yz - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        float dotProd = 0.0;\n\n        for (int wR = 0; wR < " + e + "; wR++) {\n          float dyR = float(dyRCorner + wR) / " + r + ".0;\n\n          if (dyR < 0.0 || dyR >= " + t.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = " + e + " - 1 - wR;\n\n          for (int wC = 0; wC < " + n + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + o + ".0;\n\n            if (dyC < 0.0 || dyC >= " + t.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = " + n + " - 1 - wC;\n\n            // TO DO: Vec4 over the channelMul\n            for (int dm = 0; dm < " + s + "; dm++) {\n              int d2 = d1 * " + s + " + dm;\n              float xValue = getDy(batch, idyR, idyC, d2);\n              float wValue = getW(wRPerm, wCPerm, d1, dm);\n              dotProd += xValue * wValue;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, Qa = function(t, e, n, r) {
    void 0 === e && (e = !1), void 0 === n && (n = null), void 0 === r && (r = !1), this.variableNames = [
        "x",
        "W"
    ], this.outputShape = t.outShape;
    var o = t.padInfo.top, a = t.padInfo.left, i = t.strideHeight, s = t.strideWidth, u = t.dilationHeight, c = t.dilationWidth, l = t.filterHeight, h = t.filterWidth, f = 4 * Math.floor(t.inChannels / 4), d = t.inChannels % 4, p = "channelsLast" === t.dataFormat, v = p ? 1 : 2, m = p ? 2 : 3, g = p ? 3 : 1, y = "", x = "";
    n && (y = r ? "float activation(float a) {\n          float b = getPreluActivationWeightsAtOutCoords();\n          " + n + "\n        }" : "\n          float activation(float x) {\n            " + n + "\n          }\n        ", x = "result = activation(result);");
    var b = e ? "result += getBiasAtOutCoords();" : "";
    e && this.variableNames.push("bias"), r && this.variableNames.push("preluActivationWeights"), this.userCode = "\n      " + y + "\n\n      const ivec2 strides = ivec2(" + i + ", " + s + ");\n      const ivec2 pads = ivec2(" + o + ", " + a + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d2 = coords[" + g + "];\n\n        ivec2 xRCCorner =\n            ivec2(coords[" + v + "], coords[" + m + "]) * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + l + "; wR++) {\n          int xR = xRCorner + wR * " + u + ";\n\n          if (xR < 0 || xR >= " + t.inHeight + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + h + "; wC++) {\n            int xC = xCCorner + wC * " + c + ";\n\n            if (xC < 0 || xC >= " + t.inWidth + ") {\n              continue;\n            }\n\n            for (int d1 = 0; d1 < " + f + "; d1 += 4) {\n              vec4 wValues = vec4(\n                getW(wR, wC, d1, d2),\n                getW(wR, wC, d1 + 1, d2),\n                getW(wR, wC, d1 + 2, d2),\n                getW(wR, wC, d1 + 3, d2)\n              );\n\n              if (" + p + ") {\n                vec4 xValues = vec4(\n                  getX(batch, xR, xC, d1),\n                  getX(batch, xR, xC, d1 + 1),\n                  getX(batch, xR, xC, d1 + 2),\n                  getX(batch, xR, xC, d1 + 3)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec4 xValues = vec4(\n                  getX(batch, d1, xR, xC),\n                  getX(batch, d1 + 1, xR, xC),\n                  getX(batch, d1 + 2, xR, xC),\n                  getX(batch, d1 + 3, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n            }\n\n            if (" + (1 === d) + ") {\n\n              if (" + p + ") {\n                dotProd +=\n                    getX(batch, xR, xC, " + f + ") *\n                    getW(wR, wC, " + f + ", d2);\n              } else {\n                dotProd +=\n                    getX(batch, " + f + ", xR, xC) *\n                    getW(wR, wC, " + f + ", d2);\n              }\n\n            } else if (" + (2 === d) + ") {\n              vec2 wValues = vec2(\n                getW(wR, wC, " + f + ", d2),\n                getW(wR, wC, " + f + " + 1, d2)\n              );\n\n              if (" + p + ") {\n                vec2 xValues = vec2(\n                  getX(batch, xR, xC, " + f + "),\n                  getX(batch, xR, xC, " + f + " + 1)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec2 xValues = vec2(\n                  getX(batch, " + f + ", xR, xC),\n                  getX(batch, " + f + " + 1, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n\n            } else if (" + (3 === d) + ") {\n              vec3 wValues = vec3(\n                getW(wR, wC, " + f + ", d2),\n                getW(wR, wC, " + f + " + 1, d2),\n                getW(wR, wC, " + f + " + 2, d2)\n              );\n\n              if (" + p + ") {\n                vec3 xValues = vec3(\n                  getX(batch, xR, xC, " + f + "),\n                  getX(batch, xR, xC, " + f + " + 1),\n                  getX(batch, xR, xC, " + f + " + 2)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec3 xValues = vec3(\n                  getX(batch, " + f + ", xR, xC),\n                  getX(batch, " + f + " + 1, xR, xC),\n                  getX(batch, " + f + " + 2, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n\n            }\n          }\n        }\n\n        float result = dotProd;\n        " + b + "\n        " + x + "\n        setOutput(result);\n      }\n    ";
}, Ja = function(t) {
    this.variableNames = [
        "x",
        "W"
    ], this.outputShape = t.outShape;
    var e = t.padInfo.front, n = t.padInfo.top, r = t.padInfo.left, o = t.strideDepth, a = t.strideHeight, i = t.strideWidth, s = t.dilationDepth, u = t.dilationHeight, c = t.dilationWidth, l = t.filterDepth, h = t.filterHeight, f = t.filterWidth, d = 4 * Math.floor(t.inChannels / 4), p = t.inChannels % 4;
    this.userCode = "\n      const ivec3 strides = ivec3(" + o + ", " + a + ", " + i + ");\n      const ivec3 pads = ivec3(" + e + ", " + n + ", " + r + ");\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int d2 = coords.u;\n\n        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n        int xFCorner = xFRCCorner.x;\n        int xRCorner = xFRCCorner.y;\n        int xCCorner = xFRCCorner.z;\n\n        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get\n        // y(yF, yR, yC, d2). ? = to be determined. : = across all\n        // values in that axis.\n        float dotProd = 0.0;\n        for (int wF = 0; wF < " + l + "; wF++) {\n          int xF = xFCorner + wF * " + s + ";\n\n          if (xF < 0 || xF >= " + t.inDepth + ") {\n            continue;\n          }\n\n          for (int wR = 0; wR < " + h + "; wR++) {\n            int xR = xRCorner + wR * " + u + ";\n\n            if (xR < 0 || xR >= " + t.inHeight + ") {\n              continue;\n            }\n\n            for (int wC = 0; wC < " + f + "; wC++) {\n              int xC = xCCorner + wC * " + c + ";\n\n              if (xC < 0 || xC >= " + t.inWidth + ") {\n                continue;\n              }\n\n              for (int d1 = 0; d1 < " + d + "; d1 += 4) {\n                vec4 xValues = vec4(\n                  getX(batch, xF, xR, xC, d1),\n                  getX(batch, xF, xR, xC, d1 + 1),\n                  getX(batch, xF, xR, xC, d1 + 2),\n                  getX(batch, xF, xR, xC, d1 + 3)\n                );\n                vec4 wValues = vec4(\n                  getW(wF, wR, wC, d1, d2),\n                  getW(wF, wR, wC, d1 + 1, d2),\n                  getW(wF, wR, wC, d1 + 2, d2),\n                  getW(wF, wR, wC, d1 + 3, d2)\n                );\n\n                dotProd += dot(xValues, wValues);\n              }\n\n              if (" + (1 === p) + ") {\n                dotProd +=\n                  getX(batch, xF, xR, xC, " + d + ") *\n                  getW(wF, wR, wC, " + d + ", d2);\n              } else if (" + (2 === p) + ") {\n                vec2 xValues = vec2(\n                  getX(batch, xF, xR, xC, " + d + "),\n                  getX(batch, xF, xR, xC, " + d + " + 1)\n                );\n                vec2 wValues = vec2(\n                  getW(wF, wR, wC, " + d + ", d2),\n                  getW(wF, wR, wC, " + d + " + 1, d2)\n                );\n                dotProd += dot(xValues, wValues);\n              } else if (" + (3 === p) + ") {\n                vec3 xValues = vec3(\n                  getX(batch, xF, xR, xC, " + d + "),\n                  getX(batch, xF, xR, xC, " + d + " + 1),\n                  getX(batch, xF, xR, xC, " + d + " + 2)\n                );\n                vec3 wValues = vec3(\n                  getW(wF, wR, wC, " + d + ", d2),\n                  getW(wF, wR, wC, " + d + " + 1, d2),\n                  getW(wF, wR, wC, " + d + " + 2, d2)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, Za = function(t, e, n, r) {
    void 0 === e && (e = !1), void 0 === n && (n = null), void 0 === r && (r = !1), this.variableNames = [
        "x",
        "W"
    ], this.outputShape = t.outShape;
    var o = t.inHeight, a = t.inWidth, i = t.padInfo.top, s = t.padInfo.left, u = t.strideHeight, c = t.strideWidth, l = t.dilationHeight, h = t.dilationWidth, f = t.filterHeight, d = t.filterWidth, p = t.outChannels / t.inChannels, v = "", m = "";
    n && (v = r ? "float activation(float a) {\n          float b = getPreluActivationWeightsAtOutCoords();\n          " + n + "\n        }" : "\n          float activation(float x) {\n            " + n + "\n          }\n        ", m = "result = activation(result);");
    var g = e ? "result += getBiasAtOutCoords();" : "";
    e && this.variableNames.push("bias"), r && this.variableNames.push("preluActivationWeights"), this.userCode = "\n      " + v + "\n\n      const ivec2 strides = ivec2(" + u + ", " + c + ");\n      const ivec2 pads = ivec2(" + i + ", " + s + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2 / " + p + ";\n        int q = d2 - d1 * " + p + ";\n\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        // TO DO(dsmilkov): Flatten the two for loops and vec4 the operations.\n        for (int wR = 0; wR < " + f + "; wR++) {\n          int xR = xRCorner + wR * " + l + ";\n\n          if (xR < 0 || xR >= " + o + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + d + "; wC++) {\n            int xC = xCCorner + wC * " + h + ";\n\n            if (xC < 0 || xC >= " + a + ") {\n              continue;\n            }\n\n            float xVal = getX(batch, xR, xC, d1);\n            float wVal = getW(wR, wC, d1, q);\n            dotProd += xVal * wVal;\n          }\n        }\n\n        float result = dotProd;\n        " + g + "\n        " + m + "\n        setOutput(result);\n      }\n    ";
}, ti = function(t, e, n, r) {
    void 0 === e && (e = !1), void 0 === n && (n = null), void 0 === r && (r = !1), this.variableNames = [
        "x",
        "W"
    ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t.outShape;
    for(var o = t.inHeight, a = t.inWidth, i = t.padInfo.top, s = t.padInfo.left, u = t.strideHeight, c = t.strideWidth, l = t.dilationHeight, h = t.dilationWidth, f = t.filterHeight, d = t.filterWidth, p = d, v = "int xR; int xC; int xCOffset;", m = 0; m < f; m++)for(var g = 0; g < d; g++)v += "\n          vec4 xTexelR" + m + "C" + 2 * g + " = vec4(0.);\n          vec4 wR" + m + "C" + g + " = vec4(0.);\n          vec4 xR" + m + "C" + g + " = vec4(0.);";
    for(m = 0; m < f; m++)for(var y = 0; y < p; y++){
        if (v += "\n          xR = xRCorner + " + m * l + ";\n          xC = xCCorner + " + (g = 2 * y) * h + ";\n        ", 1 === c) {
            if (g < d && (v += s % 2 == 1 ? "\n                xCOffset = xC + 1;\n                if(xR >= 0 && xR < " + o + " && xCOffset >= 0 && xCOffset < " + a + ") {\n                  xTexelR" + m + "C" + g + " = getX(batch, xR, xCOffset, d1);\n\n                  // Need to manually clear unused channels in case\n                  // we're reading from recycled texture.\n                  if(xCOffset + 1 >= " + a + ") {\n                    xTexelR" + m + "C" + g + ".zw = vec2(0.);\n                  }\n                } else {\n                  xTexelR" + m + "C" + g + " = vec4(0.);\n                }\n\n                xCOffset = xC + 1 - 2;\n                if(xR >= 0 && xR < " + o + " && xCOffset >= 0 && xCOffset < " + a + ") {\n                  vec4 previous = getX(batch, xR, xCOffset, d1);\n\n                  // Need to manually clear unused channels in case\n                  // we're reading from recycled texture.\n                  if(xCOffset + 1 >= " + a + ") {\n                    previous.zw = vec2(0.);\n                  }\n\n                  xR" + m + "C" + g + " = vec4(previous.zw, xTexelR" + m + "C" + g + ".xy);\n                } else {\n                  xR" + m + "C" + g + " = vec4(0, 0, xTexelR" + m + "C" + g + ".xy);\n                }\n              " : "\n                if(xR >= 0 && xR < " + o + " && xC >= 0 && xC < " + a + ") {\n                  xTexelR" + m + "C" + g + " = getX(batch, xR, xC, d1);\n                } else {\n                  xTexelR" + m + "C" + g + " = vec4(0.);\n                }\n\n                xR" + m + "C" + g + " = xTexelR" + m + "C" + g + ";\n              ", g + 1 < d)) {
                var x = s % 2 == 0 ? b(h) : h;
                h % 2 == 0 && s % 2 == 1 || h % 2 != 0 && s % 2 != 1 ? (v += "\n                  xCOffset = xC + " + s % 2 + " + " + x + ";\n\n                  if(xR >= 0 && xR < " + o + " &&\n                    xCOffset >= 0 && xCOffset < " + a + ") {\n                    xTexelR" + m + "C" + (g + 2) + " = getX(batch, xR, xCOffset, d1);\n                  }\n                ", h > 1 && (v += "\n                    xCOffset -= 2;\n                    if(xR >= 0 && xR < " + o + " &&\n                      xCOffset >= 0 && xCOffset < " + a + ") {\n                      xTexelR" + m + "C" + g + " = getX(batch, xR, xCOffset, d1);\n                    } else {\n                      xTexelR" + m + "C" + g + " = vec4(0.);\n                    }\n                  "), v += "\n                  xR" + m + "C" + (g + 1) + " = vec4(\n                    xTexelR" + m + "C" + g + ".zw, xTexelR" + m + "C" + (g + 2) + ".xy);\n                ") : v += "\n                  xCOffset = xC + " + x + ";\n\n                  if(xR >= 0 && xR < " + o + " &&\n                    xCOffset >= 0 && xCOffset < " + a + ") {\n                    xTexelR" + m + "C" + (g + 2) + " = getX(batch, xR, xCOffset, d1);\n                  }\n\n                  xR" + m + "C" + (g + 1) + " = xTexelR" + m + "C" + (g + 2) + ";\n                ";
            }
        } else g < d && (v += "\n              if(xR >= 0 && xR < " + o + ") {\n            ", s % 2 == 1 ? (v += "\n                xCOffset = xC + 1 - " + c + ";\n                if(xCOffset >= 0 && xCOffset < " + a + ") {\n                  xTexelR" + m + "C" + g + " = getX(batch, xR, xCOffset, d1);\n                } else {\n                  xTexelR" + m + "C" + g + " = vec4(0.);\n                }\n\n                if(xC + 1 >= 0 && xC + 1 < " + a + ") {\n                  xTexelR" + m + "C" + (g + 2) + " = getX(batch, xR, xC + 1, d1);\n                } else {\n                  xTexelR" + m + "C" + (g + 2) + " = vec4(0.);\n                }\n\n                xR" + m + "C" + g + " = vec4(\n                  xTexelR" + m + "C" + g + ".zw, xTexelR" + m + "C" + (g + 2) + ".zw);\n              ", g + 1 < d && (v += "\n                  vec4 final = vec4(0.);\n                  xCOffset = xC + 1 + " + c + ";\n                  if(xCOffset >= 0 && xCOffset < " + a + ") {\n                    final = getX(batch, xR, xCOffset, d1);\n                  }\n                  xR" + m + "C" + (g + 1) + " = vec4(xTexelR" + m + "C" + (g + 2) + ".xy, final.xy);\n                ")) : (v += "\n                if(xC >= 0 && xC < " + a + ") {\n                  xTexelR" + m + "C" + g + " = getX(batch, xR, xC, d1);\n                } else {\n                  xTexelR" + m + "C" + g + " = vec4(0.);\n                }\n\n                xCOffset = xC + " + c + ";\n                if(xCOffset >= 0 && xCOffset < " + a + ") {\n                  xTexelR" + m + "C" + (g + 2) + " = getX(batch, xR, xCOffset, d1);\n                } else {\n                  xTexelR" + m + "C" + (g + 2) + " = vec4(0.);\n                }\n\n                xR" + m + "C" + g + " = vec4(\n                  xTexelR" + m + "C" + g + ".xy, xTexelR" + m + "C" + (g + 2) + ".xy);\n              ", g + 1 < d && (v += "\n                  xR" + m + "C" + (g + 1) + " = vec4(\n                    xTexelR" + m + "C" + g + ".zw, xTexelR" + m + "C" + (g + 2) + ".zw);\n                ")), v += "}");
        g < d && (v += "\n            vec4 wTexelR" + m + "C" + g + " = getW(" + m + ", " + g + ", d1, q);\n            wR" + m + "C" + g + " = vec4(wTexelR" + m + "C" + g + ".xz, wTexelR" + m + "C" + g + ".xz);\n          ", g + 1 < d && (v += "\n              vec4 wTexelR" + m + "C" + (g + 1) + " = getW(" + m + ", " + (g + 1) + ", d1, q);\n              wR" + m + "C" + (g + 1) + " =\n                vec4(wTexelR" + m + "C" + (g + 1) + ".xz, wTexelR" + m + "C" + (g + 1) + ".xz);"));
    }
    for(m = 0; m < f; m++)for(g = 0; g < d; g++)v += "dotProd += xR" + m + "C" + g + " * wR" + m + "C" + g + ";";
    var w = "", C = "";
    n && (w = r ? "vec4 activation(vec4 a) {\n          vec4 b = getPreluActivationWeightsAtOutCoords();\n          " + n + "\n        }" : "vec4 activation(vec4 x) {\n          " + n + "\n        }", C = "result = activation(result);");
    var E = e ? "result += getBiasAtOutCoords();" : "";
    e && this.variableNames.push("bias"), r && this.variableNames.push("preluActivationWeights"), this.userCode = "\n      " + w + "\n\n      const ivec2 strides = ivec2(" + u + ", " + c + ");\n      const ivec2 pads = ivec2(" + i + ", " + s + ");\n\n      void main() {\n\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2;\n        int q = 0;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        vec4 dotProd = vec4(0.);\n\n        " + v + "\n\n        vec4 result = dotProd;\n        " + E + "\n        " + C + "\n        setOutput(result);\n      }\n    ";
}, ei = function(t, e, n, r, o) {
    this.variableNames = [
        "Image",
        "Boxes",
        "BoxInd"
    ], this.outputShape = [];
    var a = t[0], i = t[1], s = t[2], u = t[3], c = e[0], l = n[0], h = n[1];
    this.outputShape = [
        c,
        l,
        h,
        u
    ];
    var f = "bilinear" === r ? 1 : 0, d = [
        i - 1 + ".0",
        s - 1 + ".0"
    ], p = d[0], v = d[1], m = l > 1 ? [
        "" + (i - 1) / (l - 1),
        "(y2-y1) * height_ratio",
        "y1*" + p + " + float(y)*(height_scale)"
    ] : [
        "0.0",
        "0.0",
        "0.5 * (y1+y2) * " + p
    ], g = m[0], y = m[1], x = m[2], b = h > 1 ? [
        "" + (s - 1) / (h - 1),
        "(x2-x1) * width_ratio",
        "x1*" + v + " + float(x)*(width_scale)"
    ] : [
        "0.0",
        "0.0",
        "0.5 * (x1+x2) * " + v
    ], w = b[0], C = b[1], E = b[2];
    this.userCode = "\n      const float height_ratio = float(" + g + ");\n      const float width_ratio = float(" + w + ");\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int y = coords[1];\n        int x = coords[2];\n        int d = coords[3];\n\n        // get box vals\n        float y1 = getBoxes(b,0);\n        float x1 = getBoxes(b,1);\n        float y2 = getBoxes(b,2);\n        float x2 = getBoxes(b,3);\n\n        // get image in batch index\n        int bInd = round(getBoxInd(b));\n        if(bInd < 0 || bInd >= " + a + ") {\n          return;\n        }\n\n        float height_scale = " + y + ";\n        float width_scale = " + C + ";\n\n        float in_y = " + x + ";\n        if( in_y < 0.0 || in_y > " + p + " ) {\n          setOutput(float(" + o + "));\n          return;\n        }\n        float in_x = " + E + ";\n        if( in_x < 0.0 || in_x > " + v + " ) {\n          setOutput(float(" + o + "));\n          return;\n        }\n\n        vec2 sourceFracIndexCR = vec2(in_x,in_y);\n        if(" + f + " == 1) {\n          // Compute the four integer indices.\n          ivec2 sourceFloorCR = ivec2(sourceFracIndexCR);\n          ivec2 sourceCeilCR = ivec2(ceil(sourceFracIndexCR));\n\n          float topLeft = getImage(b, sourceFloorCR.y, sourceFloorCR.x, d);\n          float bottomLeft = getImage(b, sourceCeilCR.y, sourceFloorCR.x, d);\n          float topRight = getImage(b, sourceFloorCR.y, sourceCeilCR.x, d);\n          float bottomRight = getImage(b, sourceCeilCR.y, sourceCeilCR.x, d);\n\n          vec2 fracCR = sourceFracIndexCR - vec2(sourceFloorCR);\n\n          float top = topLeft + (topRight - topLeft) * fracCR.x;\n          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;\n          float newValue = top + (bottom - top) * fracCR.y;\n          setOutput(newValue);\n        } else {\n          // Compute the coordinators of nearest neighbor point.\n          ivec2 sourceNearestCR = ivec2(floor(\n            sourceFracIndexCR + vec2(0.5,0.5)));\n          float newValue = getImage(b, sourceNearestCR.y, sourceNearestCR.x, d);\n          setOutput(newValue);\n        }\n      }\n    ";
}, ni = function(t, e, n) {
    this.variableNames = [
        "x"
    ], this.outputShape = t;
    var r = t.length, o = t[t.length - 1], a = n ? "<" : ">";
    this.userCode = "\n      int getIndex(int i) {\n        " + (n ? "return " + o + " -i - 1;" : "return i;") + "\n      }\n\n      void main() {\n        " + wa(r) + " coords = getOutputCoords();\n        int end = " + ri(r, "coords") + ";\n        float val = 0.0;\n        for (int i = " + o + " - 1; i >= 0; i -= 1) {\n          int idx = getIndex(i);\n          if (idx " + a + " end) {\n            continue;\n          }\n          if (idx == end && " + e + ") {\n            continue;\n          }\n          " + ri(r, "coords") + " = idx;\n          val += getX(" + function(t, e) {
        if (1 === t) return "" + e;
        if (2 === t) return e + ".x, " + e + ".y";
        if (3 === t) return e + ".x, " + e + ".y, " + e + ".z";
        if (4 === t) return e + ".x, " + e + ".y, " + e + ".z, " + e + ".w";
        throw Error("Cumulative sum for rank " + t + " is not yet supported");
    }(r, "coords") + ");\n        }\n        setOutput(val);\n      }\n    ";
};
function ri(t, e) {
    if (1 === t) return "" + e;
    if (2 === t) return e + ".y";
    if (3 === t) return e + ".z";
    if (4 === t) return e + ".w";
    throw Error("Cumulative sum for rank " + t + " is not yet supported");
}
var oi = function(t) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !1, this.packedOutput = !0, this.outPackingScheme = Vt.DENSE;
    var e = Yt(t), n = ua();
    this.outputShape = t, this.userCode = "\n      ivec3 outCoordsFromFlatIndex(int index) {\n        " + ca([
        "r",
        "c",
        "d"
    ], t) + "\n        return ivec3(r, c, d);\n      }\n\n      void main() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n          vec2(" + e[0] + ", " + e[1] + "));\n        int index = 4 * (resTexRC.x * " + e[1] + " + resTexRC.y);\n\n        vec4 result = vec4(0.);\n\n        for (int i=0; i<4; i++) {\n          int flatIndex = index + i;\n          ivec3 rc = outCoordsFromFlatIndex(flatIndex);\n          result[i] = getA(rc.x, rc.y, rc.z);\n        }\n\n        " + n.output + " = result;\n      }\n    ";
}, ai = function(t) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !0, this.packedOutput = !0, this.outPackingScheme = Vt.DENSE;
    var e = Yt(t), n = ua();
    this.outputShape = t, this.userCode = "\n      ivec3 outCoordsFromFlatIndex(int index) {\n        " + ca([
        "r",
        "c",
        "d"
    ], t) + "\n        return ivec3(r, c, d);\n      }\n\n      void main() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n          vec2(" + e[0] + ", " + e[1] + "));\n        int index = 4 * (resTexRC.x * " + e[1] + " + resTexRC.y);\n\n        vec4 result = vec4(0.);\n\n        for (int i=0; i<4; i++) {\n          int flatIndex = index + i;\n          ivec3 rc = outCoordsFromFlatIndex(flatIndex);\n          result[i] = getChannel(getA(rc.x, rc.y, rc.z), vec2(rc.y, rc.z));\n        }\n\n        " + n.output + " = result;\n      }\n    ";
}, ii = function() {
    function t(t, e, n) {
        this.variableNames = [
            "x"
        ], this.outputShape = [], this.outputShape = t, this.blockSize = e, this.dataFormat = n, this.userCode = "\n    void main() {\n      ivec4 coords = getOutputCoords();\n      int b = coords[0];\n      int h = " + this.getHeightCoordString() + ";\n      int w = " + this.getWidthCoordString() + ";\n      int d = " + this.getDepthCoordString() + ";\n\n      int in_h = h / " + e + ";\n      int offset_h = imod(h, " + e + ");\n      int in_w = w / " + e + ";\n      int offset_w = imod(w, " + e + ");\n      int offset_d = (offset_h * " + e + " + offset_w) *\n        " + this.getOutputDepthSize() + ";\n      int in_d = d + offset_d;\n\n      float result = " + this.getInputSamplingString() + ";\n      setOutput(result);\n    }\n  ";
    }
    return t.prototype.getHeightCoordString = function() {
        return "NHWC" === this.dataFormat ? "coords[1]" : "coords[2]";
    }, t.prototype.getWidthCoordString = function() {
        return "NHWC" === this.dataFormat ? "coords[2]" : "coords[3]";
    }, t.prototype.getDepthCoordString = function() {
        return "NHWC" === this.dataFormat ? "coords[3]" : "coords[1]";
    }, t.prototype.getOutputDepthSize = function() {
        return "NHWC" === this.dataFormat ? this.outputShape[3] : this.outputShape[1];
    }, t.prototype.getInputSamplingString = function() {
        return "NHWC" === this.dataFormat ? "getX(b, in_h, in_w, in_d)" : "getX(b, in_d, in_h, in_w)";
    }, t;
}(), si = function(t) {
    this.variableNames = [
        "X"
    ], this.outputShape = [
        t,
        t
    ], this.userCode = "\n      void main() {\n          ivec2 coords = getOutputCoords();\n          float val = coords[0] == coords[1] ? getX(coords[0]) : 0.0;\n          setOutput(val);\n      }\n    ";
}, ui = function(t) {
    this.variableNames = [
        "A"
    ], this.outTexUsage = zt.DOWNLOAD;
    var e = ua();
    this.outputShape = t, this.userCode = "\n      " + ha + "\n\n      void main() {\n        float x = getAAtOutCoords();\n        " + e.output + " = encode_float(x);\n      }\n    ";
}, ci = function(t) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !0, this.packedOutput = !1, this.outTexUsage = zt.DOWNLOAD;
    var e = ua();
    this.outputShape = t, this.userCode = "\n      " + ha + "\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n        float x = getChannel(getAAtOutCoords(), vec2(coords.y, coords.z));\n        " + e.output + " = encode_float(x);\n      }\n    ";
}, li = function(t, e, n) {
    void 0 === n && (n = !1), this.variableNames = [
        "A"
    ];
    var r = ua(), o = e[0], a = e[1];
    this.outputShape = t;
    var i = "result";
    n && (i = "floor(result * 255. + 0.5)"), this.userCode = "\n      " + la(t) + "\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n\n        int flatIndex = getFlatIndex(coords);\n        int offset = imod(flatIndex, 4);\n\n        flatIndex = idiv(flatIndex, 4, 1.);\n        \n        int r = flatIndex / " + a + ";\n        int c = imod(flatIndex, " + a + ");\n        vec2 uv = (vec2(c, r) + halfCR) / vec2(" + a + ".0, " + o + ".0);\n        vec4 values = " + r.texture2D + "(A, uv);\n\n        float result;\n\n        if(offset == 0) {\n          result = values[0];\n        } else if(offset == 1) {\n          result = values[1];\n        } else if(offset == 2) {\n          result = values[2];\n        } else {\n          result = values[3];\n        }\n\n        " + r.output + " = vec4(" + i + ", 0., 0., 0.);\n      }\n    ";
}, hi = function(t, e, n) {
    void 0 === n && (n = !1), this.variableNames = [
        "A"
    ], this.packedInputs = !1, this.packedOutput = !0;
    var r = ua(), o = e[0], a = e[1];
    this.outputShape = t;
    var i = "", s = "result";
    n && (s = "floor(result * 255. + 0.5)");
    for(var u = 0; u <= 1; u++)for(var c = 0; c <= 1; c++){
        var l = 2 * u + c;
        i += "\n          localCoords = coords;\n          if(localCoords[2] + " + c + " < " + t[2] + ") {\n            localCoords[2] += " + c + ";\n            if(localCoords[1] + " + u + " < " + t[1] + ") {\n              localCoords[1] += " + u + ";\n\n              flatIndex = getFlatIndex(localCoords);\n              offset = imod(flatIndex, 4);\n\n              flatIndex = idiv(flatIndex, 4, 1.);\n\n              r = flatIndex / " + a + ";\n              c = imod(flatIndex, " + a + ");\n              uv = (vec2(c, r) + halfCR) / vec2(" + a + ".0, " + o + ".0);\n              values = " + r.texture2D + "(A, uv);\n\n              if(offset == 0) {\n                result[" + l + "] = values[0];\n              } else if(offset == 1) {\n                result[" + l + "] = values[1];\n              } else if(offset == 2) {\n                result[" + l + "] = values[2];\n              } else {\n                result[" + l + "] = values[3];\n              }\n            }\n          }\n        ";
    }
    this.userCode = "\n      " + la(t) + "\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n\n        vec4 result = vec4(0.);\n        int flatIndex, r, c, offset;\n        ivec3 localCoords;\n        vec2 uv;\n        vec4 values;\n\n        " + i + "\n\n        " + r.output + " = " + s + ";\n      }\n    ";
}, fi = "return real * expR - imag * expI;", di = "return real * expI + imag * expR;", pi = function(t, e, n) {
    this.variableNames = [
        "real",
        "imag"
    ];
    var r = e[1];
    this.outputShape = e;
    var o = n ? "2.0 * " + Math.PI : "-2.0 * " + Math.PI, a = n ? r + ".0" : "1.0";
    this.userCode = "\n      const float exponentMultiplier = " + o + ";\n\n      float unaryOpComplex(float real, float expR, float imag, float expI) {\n        " + t + "\n      }\n\n      float mulMatDFT(int batch, int index) {\n        float indexRatio = float(index) / float(" + r + ");\n        float exponentMultiplierTimesIndexRatio =\n            exponentMultiplier * indexRatio;\n\n        float result = 0.0;\n\n        for (int i = 0; i < " + r + "; i++) {\n          // x = (-2|2 * PI / N) * index * i;\n          float x = exponentMultiplierTimesIndexRatio * float(i);\n          float expR = cos(x);\n          float expI = sin(x);\n          float real = getReal(batch, i);\n          float imag = getImag(batch, i);\n\n          result +=\n              unaryOpComplex(real, expR, imag, expI) / " + a + ";\n        }\n\n        return result;\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        setOutput(mulMatDFT(coords[0], coords[1]));\n      }\n    ";
}, vi = function() {
    function t(t, e) {
        this.outputShape = [], this.variableNames = [
            "x"
        ], this.outputShape = t, this.userCode = "\n      uniform float value;\n      void main() {\n        // Input can be obtained from uniform value.\n        setOutput(value);\n      }\n    ";
    }
    return t.prototype.getCustomSetupFunc = function(t) {
        var e = this;
        return function(n, r) {
            null == e.valueLoc && (e.valueLoc = n.getUniformLocationNoThrow(r, "value")), n.gl.uniform1f(e.valueLoc, t);
        };
    }, t;
}(), mi = function(t, e, n) {
    this.variableNames = [
        "A",
        "indices"
    ];
    var r = t.slice();
    r[n] = e, this.outputShape = r, this.rank = r.length;
    var o = wa(this.rank), a = function(t, e) {
        var n = t.length;
        if (n > 4) throw Error("Gather for rank " + n + " is not yet supported");
        if (1 === n) return "int(getIndices(resRC))";
        for(var r = [
            "resRC.x",
            "resRC.y",
            "resRC.z",
            "resRC.w"
        ], o = [], a = 0; a < t.length; a++)a === e ? o.push("int(getIndices(" + r[a] + "))") : o.push("" + r[a]);
        return o.join();
    }(t, n);
    this.userCode = "\n      void main() {\n        " + o + " resRC = getOutputCoords();\n        setOutput(getA(" + a + "));\n      }\n    ";
};
var gi = function(t, e, n) {
    this.sliceDim = t, this.strides = e, this.variableNames = [
        "x",
        "indices"
    ], this.outputShape = n;
    var r = wa(e.length), o = wa(n.length), a = this.sliceDim > 1 ? "strides[j]" : "strides";
    this.userCode = "\n        " + r + " strides = " + r + "(" + this.strides + ");\n         void main() {\n          " + o + " coords = getOutputCoords();\n          int flattenIndex = 0;\n          for (int j = 0; j < " + this.sliceDim + "; j++) {\n            int index = round(getIndices(coords[0], j));\n            flattenIndex += index * " + a + ";\n          }\n          setOutput(getX(flattenIndex, coords[1]));\n        }\n      ";
};
function yi(t, e) {
    var n = ua();
    return oe(t, e, n.version + "\n    precision highp float;\n    " + n.attribute + " vec3 clipSpacePos;\n    " + n.attribute + " vec2 uv;\n    " + n.varyingVs + " vec2 resultUV;\n\n    void main() {\n      gl_Position = vec4(clipSpacePos, 1);\n      resultUV = uv;\n    }");
}
function xi(t, e) {
    return fe(t, e, new Float32Array([
        -1,
        1,
        0,
        0,
        1,
        -1,
        -1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        -1,
        0,
        1,
        0
    ]));
}
function bi(t, e) {
    return de(t, e, new Uint16Array([
        0,
        1,
        2,
        2,
        1,
        3
    ]));
}
function wi(t, e, n, r, o, a, i) {
    ve(n, r);
    var s = pe(t, e), u = t.TEXTURE_2D;
    return Jt(t, e, function() {
        return t.bindTexture(u, s);
    }), Jt(t, e, function() {
        return t.texParameteri(u, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE);
    }), Jt(t, e, function() {
        return t.texParameteri(u, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE);
    }), Jt(t, e, function() {
        return t.texParameteri(u, t.TEXTURE_MIN_FILTER, t.NEAREST);
    }), Jt(t, e, function() {
        return t.texParameteri(u, t.TEXTURE_MAG_FILTER, t.NEAREST);
    }), Jt(t, e, function() {
        return t.texImage2D(u, 0, o, n, r, 0, a, i, null);
    }), Jt(t, e, function() {
        return t.bindTexture(t.TEXTURE_2D, null);
    }), s;
}
function Ci(t, e, n, r, o) {
    var a = Xt(n, r);
    return wi(t, e, a[0], a[1], o.internalFormatFloat, o.textureFormatFloat, t.FLOAT);
}
function Ei(t, e, n, r, o) {
    var a = Xt(n, r);
    return wi(t, e, a[0], a[1], o.internalFormatHalfFloat, o.textureFormatFloat, o.textureTypeHalfFloat);
}
function Ri(t, e, n, r, o) {
    var a = Xt(n, r);
    return wi(t, e, a[0], a[1], t.RGBA, t.RGBA, t.UNSIGNED_BYTE);
}
function Ii(t, e, n, r, o) {
    var a = $t(n, r);
    return wi(t, e, a[0], a[1], o.internalFormatPackedFloat, t.RGBA, t.FLOAT);
}
function ki(t, e, n, r, o) {
    var a = $t(n, r);
    return wi(t, e, a[0], a[1], o.internalFormatPackedHalfFloat, t.RGBA, o.textureTypeHalfFloat);
}
function Si(t, e, n, r) {
    return Jt(t, e, function() {
        return t.bindBuffer(t.ARRAY_BUFFER, r);
    }), ge(t, e, n, "clipSpacePos", r, 3, 20, 0) && ge(t, e, n, "uv", r, 2, 20, 12);
}
function Ai(t, e, n, r, o, a, i) {
    var s, u, c;
    Jt(t, e, function() {
        return t.bindTexture(t.TEXTURE_2D, n);
    }), a instanceof Uint8Array ? (s = new Uint8Array(r * o * 4), u = t.UNSIGNED_BYTE, c = t.RGBA) : (s = new Float32Array(r * o * 4), u = t.FLOAT, c = i.internalFormatPackedFloat), s.set(a), Jt(t, e, function() {
        return t.texImage2D(t.TEXTURE_2D, 0, c, r, o, 0, t.RGBA, u, s);
    }), Jt(t, e, function() {
        return t.bindTexture(t.TEXTURE_2D, null);
    });
}
function Di(t, e, n, r) {
    Jt(t, e, function() {
        return t.bindTexture(t.TEXTURE_2D, n);
    }), r.data instanceof Uint8Array ? Jt(t, e, function() {
        return t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, r.width, r.height, 0, t.RGBA, t.UNSIGNED_BYTE, r.data);
    }) : Jt(t, e, function() {
        return t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, r);
    }), Jt(t, e, function() {
        return t.bindTexture(t.TEXTURE_2D, null);
    });
}
function Ti(t, e, n, r, o) {
    var a = t.createBuffer();
    Jt(t, e, function() {
        return t.bindBuffer(t.PIXEL_PACK_BUFFER, a);
    });
    var i = 16 * n * r;
    return Jt(t, e, function() {
        return t.bufferData(t.PIXEL_PACK_BUFFER, i, t.STREAM_READ);
    }), Jt(t, e, function() {
        return t.readPixels(0, 0, r, n, t.RGBA, t.FLOAT, 0);
    }), Jt(t, e, function() {
        return t.bindBuffer(t.PIXEL_PACK_BUFFER, null);
    }), a;
}
function Ni(t, e, n) {
    var r = t, o = new Float32Array(n);
    return r.bindBuffer(r.PIXEL_PACK_BUFFER, e), r.getBufferSubData(r.PIXEL_PACK_BUFFER, 0, o), r.bindBuffer(r.PIXEL_PACK_BUFFER, null), o;
}
function Fi(t, e, n, r, o) {
    var a = Xt(n, r), i = a[0], s = a[1], u = new Uint8Array(n * r * 4);
    return Jt(t, e, function() {
        return t.readPixels(0, 0, i, s, o.downloadTextureFormat, t.UNSIGNED_BYTE, u);
    }), new Float32Array(u.buffer);
}
function _i(t, e, n, r, o, a, i, s) {
    var u = t, c = new Float32Array(function(t, e) {
        var n = $t(t, e);
        return n[0] * n[1] * 4;
    }(a, i));
    return u.bindBuffer(u.PIXEL_PACK_BUFFER, e), u.getBufferSubData(u.PIXEL_PACK_BUFFER, 0, c), u.bindBuffer(u.PIXEL_PACK_BUFFER, null), c;
}
function Oi(t, e, n, r) {
    var o = new Float32Array(n * r * 4);
    return Jt(t, e, function() {
        return t.readPixels(0, 0, r, n, t.RGBA, t.FLOAT, o);
    }), o;
}
var Mi = Object.freeze({
    createVertexShader: yi,
    createVertexBuffer: xi,
    createIndexBuffer: bi,
    createFloat32MatrixTexture: Ci,
    createFloat16MatrixTexture: Ei,
    createUnsignedBytesMatrixTexture: Ri,
    createPackedMatrixTexture: Ii,
    createFloat16PackedMatrixTexture: ki,
    bindVertexProgramAttributeStreams: Si,
    uploadDenseMatrixToTexture: Ai,
    uploadPixelDataToTexture: Di,
    createBufferFromOutputTexture: Ti,
    downloadFloat32MatrixFromBuffer: Ni,
    downloadByteEncodedFloatMatrixFromOutputTexture: Fi,
    downloadPackedMatrixFromBuffer: _i,
    downloadMatrixFromPackedOutputTexture: Oi
}), Bi = function() {
    function t(t) {
        this.outputTexture = null, this.program = null, this.disposed = !1, this.vertexAttrsAreBound = !1, this.itemsToPoll = [];
        var e = i().getNumber("WEBGL_VERSION");
        null != t ? (this.gl = t, Kt(e, t)) : this.gl = jt(e);
        var n = "WEBGL_color_buffer_float";
        if (1 === i().getNumber("WEBGL_VERSION")) {
            if (this.textureFloatExtension = re(this.gl, this.debug, "OES_texture_float"), Pe(this.gl, "OES_texture_half_float")) this.textureHalfFloatExtension = re(this.gl, this.debug, "OES_texture_half_float");
            else if (i().get("WEBGL_FORCE_F16_TEXTURES")) throw new Error("GL context does not support half float textures, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
            if (this.colorBufferFloatExtension = this.gl.getExtension(n), Pe(this.gl, "EXT_color_buffer_half_float")) this.colorBufferHalfFloatExtension = re(this.gl, this.debug, "EXT_color_buffer_half_float");
            else if (i().get("WEBGL_FORCE_F16_TEXTURES")) throw new Error("GL context does not support color renderable half floats, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
        } else if (n = "EXT_color_buffer_float", Pe(this.gl, n)) this.colorBufferFloatExtension = this.gl.getExtension(n);
        else {
            if (!Pe(this.gl, "EXT_color_buffer_half_float")) throw new Error("GL context does not support color renderable floats");
            this.colorBufferHalfFloatExtension = this.gl.getExtension("EXT_color_buffer_half_float");
        }
        this.vertexBuffer = xi(this.gl, this.debug), this.indexBuffer = bi(this.gl, this.debug), this.framebuffer = me(this.gl, this.debug), this.textureConfig = Qt(this.gl, this.textureHalfFloatExtension);
    }
    return Object.defineProperty(t.prototype, "debug", {
        get: function() {
            return i().getBool("DEBUG");
        },
        enumerable: !0,
        configurable: !0
    }), t.prototype.dispose = function() {
        var t = this;
        if (!this.disposed) {
            null != this.program && console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing."), null != this.outputTexture && console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");
            var e = this.gl;
            Jt(e, this.debug, function() {
                return e.finish();
            }), Jt(e, this.debug, function() {
                return e.bindFramebuffer(e.FRAMEBUFFER, null);
            }), Jt(e, this.debug, function() {
                return e.deleteFramebuffer(t.framebuffer);
            }), Jt(e, this.debug, function() {
                return e.bindBuffer(e.ARRAY_BUFFER, null);
            }), Jt(e, this.debug, function() {
                return e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, null);
            }), Jt(e, this.debug, function() {
                return e.deleteBuffer(t.indexBuffer);
            }), this.disposed = !0;
        }
    }, t.prototype.createFloat32MatrixTexture = function(t, e) {
        return this.throwIfDisposed(), Ci(this.gl, this.debug, t, e, this.textureConfig);
    }, t.prototype.createFloat16MatrixTexture = function(t, e) {
        return this.throwIfDisposed(), Ei(this.gl, this.debug, t, e, this.textureConfig);
    }, t.prototype.createUnsignedBytesMatrixTexture = function(t, e) {
        return this.throwIfDisposed(), Ri(this.gl, this.debug, t, e, this.textureConfig);
    }, t.prototype.uploadPixelDataToTexture = function(t, e) {
        this.throwIfDisposed(), Di(this.gl, this.debug, t, e);
    }, t.prototype.uploadDenseMatrixToTexture = function(t, e, n, r) {
        this.throwIfDisposed(), Ai(this.gl, this.debug, t, e, n, r, this.textureConfig);
    }, t.prototype.createFloat16PackedMatrixTexture = function(t, e) {
        return this.throwIfDisposed(), ki(this.gl, this.debug, t, e, this.textureConfig);
    }, t.prototype.createPackedMatrixTexture = function(t, e) {
        return this.throwIfDisposed(), Ii(this.gl, this.debug, t, e, this.textureConfig);
    }, t.prototype.deleteMatrixTexture = function(t) {
        var e = this;
        this.throwIfDisposed(), this.outputTexture === t && (Ee(this.gl, this.debug, this.framebuffer), this.outputTexture = null), Jt(this.gl, this.debug, function() {
            return e.gl.deleteTexture(t);
        });
    }, t.prototype.downloadByteEncodedFloatMatrixFromOutputTexture = function(t, e, n) {
        var r = this;
        return this.downloadMatrixDriver(t, function() {
            return Fi(r.gl, r.debug, e, n, r.textureConfig);
        });
    }, t.prototype.downloadPackedMatrixFromBuffer = function(t, e, n, r, o, a) {
        return _i(this.gl, t, 0, 0, 0, o, a, this.textureConfig);
    }, t.prototype.downloadFloat32MatrixFromBuffer = function(t, e) {
        return Ni(this.gl, t, e);
    }, t.prototype.createBufferFromTexture = function(t, e, n) {
        this.bindTextureToFrameBuffer(t);
        var r = Ti(this.gl, this.debug, e, n, this.textureConfig);
        return this.unbindTextureToFrameBuffer(), r;
    }, t.prototype.createAndWaitForFence = function() {
        var t = this.createFence(this.gl);
        return this.pollFence(t);
    }, t.prototype.createFence = function(t) {
        var e, n, r = this;
        if (i().getBool("WEBGL_FENCE_API_ENABLED")) {
            var o = t, a = o.fenceSync(o.SYNC_GPU_COMMANDS_COMPLETE, 0);
            t.flush(), n = function() {
                var t = o.clientWaitSync(a, 0, 0);
                return t === o.ALREADY_SIGNALED || t === o.CONDITION_SATISFIED;
            }, e = a;
        } else i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? (e = this.beginQuery(), this.endQuery(), n = function() {
            return r.isQueryAvailable(e, i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"));
        }) : n = function() {
            return !0;
        };
        return {
            query: e,
            isFencePassed: n
        };
    }, t.prototype.downloadMatrixFromPackedTexture = function(t, e, n) {
        var r = this;
        return this.downloadMatrixDriver(t, function() {
            return Oi(r.gl, r.debug, e, n);
        });
    }, t.prototype.createProgram = function(t) {
        this.throwIfDisposed();
        var e = this.gl, n = ae(e, this.debug, t), r = yi(e, this.debug), o = ce(e, this.debug);
        return Jt(e, this.debug, function() {
            return e.attachShader(o, r);
        }), Jt(e, this.debug, function() {
            return e.attachShader(o, n);
        }), le(e, this.debug, o), this.debug && he(e, this.debug, o), this.vertexAttrsAreBound || (this.setProgram(o), this.vertexAttrsAreBound = Si(e, this.debug, this.program, this.vertexBuffer)), o;
    }, t.prototype.deleteProgram = function(t) {
        var e = this;
        this.throwIfDisposed(), t === this.program && (this.program = null), null != t && Jt(this.gl, this.debug, function() {
            return e.gl.deleteProgram(t);
        });
    }, t.prototype.setProgram = function(t) {
        var e = this;
        this.throwIfDisposed(), this.program = t, null != this.program && this.debug && he(this.gl, this.debug, this.program), Jt(this.gl, this.debug, function() {
            return e.gl.useProgram(t);
        });
    }, t.prototype.getUniformLocation = function(t, e, n) {
        return void 0 === n && (n = !0), this.throwIfDisposed(), n ? xe(this.gl, this.debug, t, e) : be(this.gl, t, e);
    }, t.prototype.getAttributeLocation = function(t, e) {
        var n = this;
        return this.throwIfDisposed(), Jt(this.gl, this.debug, function() {
            return n.gl.getAttribLocation(t, e);
        });
    }, t.prototype.getUniformLocationNoThrow = function(t, e) {
        return this.throwIfDisposed(), this.gl.getUniformLocation(t, e);
    }, t.prototype.setInputMatrixTexture = function(t, e, n) {
        this.throwIfDisposed(), this.throwIfNoProgram(), we(this.gl, this.debug, this.program, t, e, n);
    }, t.prototype.setOutputMatrixTexture = function(t, e, n) {
        this.setOutputMatrixTextureDriver(t, n, e);
    }, t.prototype.setOutputPackedMatrixTexture = function(t, e, n) {
        this.throwIfDisposed();
        var r = $t(e, n), o = r[0], a = r[1];
        this.setOutputMatrixTextureDriver(t, o, a);
    }, t.prototype.setOutputMatrixWriteRegion = function(t, e, n, r) {
        this.setOutputMatrixWriteRegionDriver(n, t, r, e);
    }, t.prototype.setOutputPackedMatrixWriteRegion = function(t, e, n, r) {
        throw new Error("setOutputPackedMatrixWriteRegion not implemented.");
    }, t.prototype.debugValidate = function() {
        null != this.program && he(this.gl, this.debug, this.program), Re(this.gl);
    }, t.prototype.executeProgram = function() {
        this.throwIfDisposed(), this.throwIfNoProgram();
        var t = this.gl;
        this.debug && this.debugValidate(), Jt(t, this.debug, function() {
            return t.drawElements(t.TRIANGLES, 6, t.UNSIGNED_SHORT, 0);
        });
    }, t.prototype.blockUntilAllProgramsCompleted = function() {
        var t = this;
        this.throwIfDisposed(), Jt(this.gl, this.debug, function() {
            return t.gl.finish();
        });
    }, t.prototype.getQueryTimerExtension = function() {
        return null == this.disjointQueryTimerExtension && (this.disjointQueryTimerExtension = re(this.gl, this.debug, 2 === i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") ? "EXT_disjoint_timer_query_webgl2" : "EXT_disjoint_timer_query")), this.disjointQueryTimerExtension;
    }, t.prototype.getQueryTimerExtensionWebGL2 = function() {
        return this.getQueryTimerExtension();
    }, t.prototype.getQueryTimerExtensionWebGL1 = function() {
        return this.getQueryTimerExtension();
    }, t.prototype.beginQuery = function() {
        if (2 === i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")) {
            var t = this.gl, e = this.getQueryTimerExtensionWebGL2(), n = t.createQuery();
            return t.beginQuery(e.TIME_ELAPSED_EXT, n), n;
        }
        var r = this.getQueryTimerExtensionWebGL1(), o = r.createQueryEXT();
        return r.beginQueryEXT(r.TIME_ELAPSED_EXT, o), o;
    }, t.prototype.endQuery = function() {
        if (2 !== i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")) {
            var t = this.getQueryTimerExtensionWebGL1();
            t.endQueryEXT(t.TIME_ELAPSED_EXT);
        } else {
            var e = this.gl, n = this.getQueryTimerExtensionWebGL2();
            e.endQuery(n.TIME_ELAPSED_EXT);
        }
    }, t.prototype.waitForQueryAndGetTime = function(t) {
        return n(this, void 0, void 0, function() {
            var e = this;
            return r(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            F(function() {
                                return e.disposed || e.isQueryAvailable(t, i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"));
                            })
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            this.getQueryTime(t, i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))
                        ];
                }
            });
        });
    }, t.prototype.getQueryTime = function(t, e) {
        if (0 === e) return null;
        if (2 === e) {
            var n = this.gl;
            return n.getQueryParameter(t, n.QUERY_RESULT) / 1e6;
        }
        var r = this.getQueryTimerExtensionWebGL1();
        return r.getQueryObjectEXT(t, r.QUERY_RESULT_EXT) / 1e6;
    }, t.prototype.isQueryAvailable = function(t, e) {
        if (0 === e) return !0;
        if (2 === e) {
            var n = this.gl, r = this.getQueryTimerExtensionWebGL2(), o = n.getQueryParameter(t, n.QUERY_RESULT_AVAILABLE);
            return null == this.disjoint && (this.disjoint = this.gl.getParameter(r.GPU_DISJOINT_EXT)), o && !this.disjoint;
        }
        o = (r = this.getQueryTimerExtensionWebGL1()).getQueryObjectEXT(t, r.QUERY_RESULT_AVAILABLE_EXT);
        return null == this.disjoint && (this.disjoint = this.gl.getParameter(r.GPU_DISJOINT_EXT)), o && !this.disjoint;
    }, t.prototype.pollFence = function(t) {
        var e = this;
        return new Promise(function(n) {
            e.addItemToPoll(function() {
                return t.isFencePassed();
            }, function() {
                return n();
            });
        });
    }, t.prototype.pollItems = function() {
        for(var t = function(t) {
            for(var e = 0; e < t.length; ++e){
                if (!t[e]()) break;
            }
            return e - 1;
        }(this.itemsToPoll.map(function(t) {
            return t.isDoneFn;
        })), e = 0; e <= t; ++e)(0, this.itemsToPoll[e].resolveFn)();
        this.itemsToPoll = this.itemsToPoll.slice(t + 1);
    }, t.prototype.addItemToPoll = function(t, e) {
        var n = this;
        this.itemsToPoll.push({
            isDoneFn: t,
            resolveFn: e
        }), this.itemsToPoll.length > 1 || F(function() {
            return n.pollItems(), 0 === n.itemsToPoll.length;
        });
    }, t.prototype.bindTextureToFrameBuffer = function(t) {
        this.throwIfDisposed(), Ce(this.gl, this.debug, t, this.framebuffer), this.debug && Re(this.gl);
    }, t.prototype.unbindTextureToFrameBuffer = function() {
        null != this.outputTexture ? (Ce(this.gl, this.debug, this.outputTexture, this.framebuffer), this.debug && Re(this.gl)) : Ee(this.gl, this.debug, this.framebuffer);
    }, t.prototype.downloadMatrixDriver = function(t, e) {
        this.bindTextureToFrameBuffer(t);
        var n = e();
        return this.unbindTextureToFrameBuffer(), n;
    }, t.prototype.setOutputMatrixTextureDriver = function(t, e, n) {
        this.throwIfDisposed();
        var r = this.gl;
        Ce(r, this.debug, t, this.framebuffer), this.debug && Re(r), this.outputTexture = t, Jt(r, this.debug, function() {
            return r.viewport(0, 0, e, n);
        }), Jt(r, this.debug, function() {
            return r.scissor(0, 0, e, n);
        });
    }, t.prototype.setOutputMatrixWriteRegionDriver = function(t, e, n, r) {
        var o = this;
        this.throwIfDisposed(), Jt(this.gl, this.debug, function() {
            return o.gl.scissor(t, e, n, r);
        });
    }, t.prototype.throwIfDisposed = function() {
        if (this.disposed) throw new Error("Attempted to use disposed GPGPUContext.");
    }, t.prototype.throwIfNoProgram = function() {
        if (null == this.program) throw new Error("No GPU program is currently set.");
    }, t;
}();
function Pi(t, e) {
    if (t.length !== e.length) throw Error("Binary was compiled with " + t.length + " inputs, but was executed with " + e.length + " inputs");
    t.forEach(function(t, n) {
        var r = t.logicalShape, o = e[n], a = o.shape;
        if (!S(r, a)) throw Error("Binary was compiled with different shapes than the current args. Shapes " + r + " and " + a + " must match");
        if (!t.isUniform || !o.isUniform) {
            var i = t.texShape, s = o.isUniform ? null : o.texData.texShape;
            if (!S(i, s)) throw Error("Binary was compiled with different texture shapes than the current args. Shape " + i + " and " + s + " must match");
        }
    });
}
var Li = function(t, e, n) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t;
    for(var r = n.filterWidth, o = n.inChannels, a = n.strideWidth, i = n.strideHeight, s = n.padInfo, u = n.outWidth, c = n.dilationWidth, l = n.dilationHeight, h = n.dataFormat, f = s.left, d = s.top, p = o * r, v = ua(), m = "channelsLast" === h, g = m ? 0 : 1, y = m ? 1 : 2, x = "", b = 0; b <= 1; b++)for(var w = 0; w <= 1; w++)x += "\n          blockIndex = rc.y + " + w + ";\n          pos = rc.x + " + b + ";\n\n          if(blockIndex < " + t[1] + " && pos < " + t[0] + ") {\n            offsetY = int(blockIndex / (" + u + ")) * " + i + " - " + d + ";\n            d0 = offsetY + " + l + " * (pos / " + p + ");\n\n            if(d0 < " + e[g] + " && d0 >= 0) {\n\n              offsetX = int(mod(float(blockIndex), " + u + ".) * " + a + ". - " + f + ".);\n              d1 = offsetX + " + c + " * (int(mod(float(pos), " + p + ".) / " + o + ".));\n\n              if(d1 < " + e[y] + " && d1 >= 0) {\n\n                ch = int(mod(float(pos), " + o + ".));\n\n                if (" + m + ") {\n                  innerDims = vec2(d1, ch);\n                  result[" + (2 * b + w) + "] = getChannel(\n                    getA(d0, int(innerDims.x),\n                    int(innerDims.y)), innerDims);\n                } else {\n                  innerDims = vec2(d0, d1);\n                  result[" + (2 * b + w) + "] = getChannel(\n                    getA(ch, int(innerDims.x),\n                    int(innerDims.y)), innerDims);\n                }\n              }\n            }\n          }\n        ";
    this.userCode = "\n      void main() {\n        ivec2 rc = getOutputCoords();\n\n        vec4 result = vec4(0);\n\n        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;\n        vec2 innerDims;\n\n        " + x + "\n\n        " + v.output + " = result;\n      }\n    ";
}, Wi = function(t, e, n, r, o) {
    this.variableNames = [
        "x"
    ], this.outputShape = [];
    var a, i = e, s = t[3] - 1;
    this.outputShape = t;
    var u = "float(" + n + ") + float(" + r + ") * sum";
    a = .5 === o ? "inversesqrt(" + u + ")" : 1 === o ? "1.0/(" + u + ")" : "exp(log(" + u + ") * float(-" + o + "));", this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n        int d = coords[3];\n        float x = getX(b, r, c, d);\n        float sum = 0.0;\n        for (int j = -" + i + "; j <= " + i + "; j++) {\n          int idx = d + j;\n          if (idx >= 0 && idx <=  " + s + ") {\n            float z = getX(b, r, c, idx);\n            sum += z * z;\n          }\n        }\n        float val = x * " + a + ";\n        setOutput(val);\n      }\n    ";
}, Ui = function(t, e, n, r, o) {
    this.variableNames = [
        "inputImage",
        "outputImage",
        "dy"
    ], this.outputShape = [], this.outputShape = t, this.depth = t[3], this.depthRadius = e, this.bias = n, this.alpha = r, this.beta = o, this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n\n        float result = 0.0;\n        for (int d = 0; d < " + this.depth + "; ++d) {\n          int depthBegin = int(max(0.0, float(d - " + e + ")));\n          int depthEnd = int(min(float(" + this.depth + "),\n              float(d + " + e + " + 1)));\n\n          const int MIN_DEPTH_BEGIN = 0;\n          const int MAX_DEPTH_END = " + this.depth + ";\n\n          float norm = 0.0;\n          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd) {\n              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);\n            }\n            else {\n              break;\n            }\n          }\n\n          norm = float(" + r + ") * norm + float(" + n + ");\n\n          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd){\n              float dyi = -2.0 * float(" + r + ")\n                * float(" + o + ")\n                * getInputImage(b ,r ,c, k) * getOutputImage(b, r, c, d)\n                / norm;\n              if (k == d) {\n                dyi += pow(norm, -1.0 * " + o + ");\n              }\n              if (k == coords[3]) {\n                dyi *= getDy(b, r, c, d);\n                result += dyi;\n              }\n            }\n            else {\n              break;\n            }\n          }\n      }\n      setOutput(result);\n      }\n    ";
}, Vi = function(t, e, n, r, o) {
    this.variableNames = [
        "x"
    ], this.outputShape = [], this.packedInputs = !0, this.packedOutput = !0;
    var a, i = e, s = t[3] - 1;
    this.outputShape = t;
    var u = "float(" + n + ") + float(" + r + ") * sum";
    a = .5 === o ? "inversesqrt(" + u + ")" : 1 === o ? "1.0/(" + u + ")" : "exp(log(" + u + ") * float(-" + o + "));", this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords.x;\n        int r = coords.y;\n        int c = coords.z;\n        int d = coords.w;\n\n        bool hasNextCol = d < " + this.outputShape[3] + ";\n        bool hasNextRow = c < " + this.outputShape[2] + ";\n\n        vec4 sum = vec4(0.);\n        vec4 xFragAtOutputCoords = getX(b, r, c, d);\n\n        vec4 xAtOutputCoords = vec4(\n          getChannel(xFragAtOutputCoords, vec2(c, d)),\n          hasNextCol ?\n            getChannel(xFragAtOutputCoords, vec2(c, d + 1)) : 0.0,\n          hasNextRow ?\n            getChannel(xFragAtOutputCoords , vec2(c + 1, d)) : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getChannel(xFragAtOutputCoords, vec2(c + 1, d + 1)) : 0.0\n        );\n\n        int firstChannel = d - " + i + ";\n        vec2 cache = vec2(0.);\n        if(firstChannel >= 0){\n          vec4 firstChannelFrag = getX(b, r, c, firstChannel);\n          cache.x = getChannel(firstChannelFrag, vec2(c, firstChannel));\n            if(hasNextRow){\n              cache.y = getChannel(firstChannelFrag, vec2(c + 1, firstChannel));\n            }\n        }\n\n        ivec2 depth = ivec2(d, d + 1);\n        for (int j = - " + i + "; j <= " + i + "; j++) {\n          ivec2 idx = depth + j;\n          bvec2 aboveLowerBound = greaterThanEqual(idx, ivec2(0));\n          bvec2 belowUpperBound = lessThanEqual(idx, ivec2(" + s + "));\n\n          bool depthInRange = aboveLowerBound.x && belowUpperBound.x;\n          bool depthPlusOneInRange = aboveLowerBound.y && belowUpperBound.y;\n\n          if(depthInRange || depthPlusOneInRange){\n            vec4 z = vec4(0.);\n            vec4 xFragAtCurrentDepth;\n            z.xz = cache.xy;\n            if(depthPlusOneInRange && hasNextCol){\n              xFragAtCurrentDepth = idx.y != d ?\n                getX(b, r, c, idx.y) : xFragAtOutputCoords;\n              z.y = getChannel(xFragAtCurrentDepth, vec2(c, idx.y));\n              if(hasNextRow){\n                z.w = getChannel(xFragAtCurrentDepth, vec2(c + 1, idx.y));\n              }\n            }\n            cache.xy = z.yw;\n            sum += z * z;\n          }\n        }\n        vec4 result = xAtOutputCoords * " + a + ";\n        setOutput(result);\n      }\n    ";
}, zi = function(t) {
    this.variableNames = [
        "dy",
        "maxPos"
    ], this.outputShape = t.inShape;
    var e = t.strideHeight, n = t.strideWidth, r = t.dilationHeight, o = t.effectiveFilterHeight, a = t.effectiveFilterWidth, i = o - 1 - t.padInfo.top, s = a - 1 - t.padInfo.left, u = o * a - 1;
    this.userCode = "\n      const ivec2 pads = ivec2(" + i + ", " + s + ");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < " + o + ";\n          wR += " + r + ") {\n          float dyR = float(dyRCorner + wR) / " + e + ".0;\n\n          if (dyR < 0.0 || dyR >= " + t.outHeight + ".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < " + a + "; wC++) {\n            float dyC = float(dyCCorner + wC) / " + n + ".0;\n\n            if (dyC < 0.0 || dyC >= " + t.outWidth + ".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n            int maxPosValue = " + u + " - int(getMaxPos(b, idyR, idyC, d));\n\n            // Get the current value, check it against the value from the\n            // position matrix.\n            int curPosValue = wR * " + a + " + wC;\n            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n            dotProd += dyValue * mask;\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, Gi = function(t) {
    this.variableNames = [
        "dy",
        "maxPos"
    ], this.outputShape = t.inShape;
    var e = t.strideDepth, n = t.strideHeight, r = t.strideWidth, o = t.dilationDepth, a = t.dilationHeight, i = t.dilationWidth, s = t.effectiveFilterDepth, u = t.effectiveFilterHeight, c = t.effectiveFilterWidth, l = s - 1 - t.padInfo.front, h = u - 1 - t.padInfo.top, f = c - 1 - t.padInfo.left, d = s * u * c - 1;
    this.userCode = "\n      const ivec3 pads = ivec3(" + l + ", " + h + ", " + f + ");\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyDCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get\n        // dx(xD, xR, xC, ch).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int wD = 0; wD < " + s + ";\n           wD += " + o + ") {\n          float dyD = float(dyDCorner + wD) / " + e + ".0;\n\n          if (dyD < 0.0 || dyD >= " + t.outDepth + ".0 || fract(dyD) > 0.0) {\n            continue;\n          }\n          int idyD = int(dyD);\n\n          for (int wR = 0; wR < " + u + ";\n              wR += " + a + ") {\n            float dyR = float(dyRCorner + wR) / " + n + ".0;\n\n            if (dyR < 0.0 || dyR >= " + t.outHeight + ".0 ||\n                fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            for (int wC = 0; wC < " + c + ";\n                wC += " + i + ") {\n              float dyC = float(dyCCorner + wC) / " + r + ".0;\n\n              if (dyC < 0.0 || dyC >= " + t.outWidth + ".0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              float dyValue = getDy(batch, idyD, idyR, idyC, ch);\n              int maxPosValue = " + d + " -\n                  int(getMaxPos(batch, idyD, idyR, idyC, ch));\n\n              // Get the current value, check it against the value from the\n              // position matrix.\n              int curPosValue =\n                  wD * " + u + " * " + c + " +\n                  wR * " + c + " + wC;\n              float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n              dotProd += dyValue * mask;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    ";
}, Hi = function(t, e, n, r, o, a, i) {
    void 0 === n && (n = !1), void 0 === r && (r = !1), void 0 === o && (o = !1), void 0 === a && (a = null), void 0 === i && (i = !1), this.variableNames = [
        "matrixA",
        "matrixB"
    ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = e;
    var s = n ? t[1] : t[2], u = Math.ceil(s / 2), c = n ? "i * 2, rc.y" : "rc.y, i * 2", l = r ? "rc.z, i * 2" : "i * 2, rc.z", h = n ? [
        "a.xxyy",
        "a.zzww"
    ] : [
        "a.xxzz",
        "a.yyww"
    ], f = r ? [
        "b.xzxz",
        "b.ywyw"
    ] : [
        "b.xyxy",
        "b.zwzw"
    ], d = "", p = "";
    a && (d = i ? "vec4 activation(vec4 a) {\n          vec4 b = getPreluActivationWeightsAtOutCoords();\n          " + a + "\n        }" : "vec4 activation(vec4 x) {\n          " + a + "\n        }", p = "result = activation(result);");
    var v = o ? "result += getBiasAtOutCoords();" : "";
    o && this.variableNames.push("bias"), i && this.variableNames.push("preluActivationWeights"), this.userCode = "\n      " + d + "\n\n      const float sharedDimension = " + u + ".0;\n\n      vec4 dot2x2ARowBCol(ivec3 rc) {\n        vec4 result = vec4(0);\n        for (int i = 0; i < " + u + "; i++) {\n          vec4 a = getMatrixA(rc.x, " + c + ");\n          vec4 b = getMatrixB(rc.x, " + l + ");\n\n          // These swizzled products need to be separately added.\n          // See: https://github.com/tensorflow/tfjs/issues/1735\n          result += (" + h[0] + " * " + f[0] + ");\n          result += (" + h[1] + " * " + f[1] + ");\n        }\n        return result;\n      }\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n        vec4 result = dot2x2ARowBCol(rc);\n\n        " + v + "\n\n        " + p + "\n\n        setOutput(result);\n      }\n    ";
}, qi = function() {
    function t(t, e, n) {
        this.variableNames = [
            "probs"
        ], this.outputShape = [
            t,
            n
        ], this.userCode = "\n      uniform float seed;\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n\n        float r = random(seed);\n        float cdf = 0.0;\n\n        for (int i = 0; i < " + (e - 1) + "; i++) {\n          cdf += getProbs(batch, i);\n\n          if (r < cdf) {\n            setOutput(float(i));\n            return;\n          }\n        }\n\n        // If no other event happened, last event happened.\n        setOutput(float(" + (e - 1) + "));\n      }\n    ";
    }
    return t.prototype.getCustomSetupFunc = function(t) {
        var e = this;
        return function(n, r) {
            null == e.seedLoc && (e.seedLoc = n.getUniformLocation(r, "seed")), n.gl.uniform1f(e.seedLoc, t);
        };
    }, t;
}(), Ki = function(t, e, n, r) {
    this.variableNames = [
        "indices"
    ], this.outputShape = [
        t,
        e
    ], this.userCode = "\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int index = round(getIndices(coords.x));\n        setOutput(mix(float(" + r + "), float(" + n + "),\n                      float(index == coords.y)));\n      }\n    ";
}, ji = function(t) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !1, this.packedOutput = !0, this.outputShape = t;
    var e = t.length;
    if (0 === e) this.userCode = "\n        void main() {\n          setOutput(vec4(getA(), 0., 0., 0.));\n        }\n      ";
    else {
        var n = sa("rc", e), r = wa(e), o = function(t, e, n) {
            if (1 === t) return "rc > " + e[0];
            for(var r = "", o = t - 2; o < t; o++)r += n[o] + " >= " + e[o], o < t - 1 && (r += "||");
            return r;
        }(e, t, n), a = function(t, e, n, r) {
            if (1 === t) return "";
            var o = r.slice(-2);
            return "\n    int r = " + o[0] + ";\n    int c = " + o[1] + ";\n    int rp1 = r + 1;\n    int cp1 = c + 1;\n\n    bool cEdge = cp1 >= " + e + ";\n    bool rEdge = rp1 >= " + n + ";\n  ";
        }(e, t[t.length - 1], t[t.length - 2], n), i = function(t, e) {
            var n = t.length, r = function(t, e) {
                for(var n = [], r = 0; r <= 1; r++)for(var o = 0; o <= 1; o++){
                    for(var a = (0 === r ? "r" : "rp1") + ", " + (0 === o ? "c" : "cp1"), i = 2; i < t; i++)a = e[e.length - 1 - i] + "," + a;
                    n.push(a);
                }
                return n;
            }(n, e);
            return 1 === n ? "getA(rc),\n            rc + 1 >= " + t[0] + " ? 0. : getA(rc + 1),\n            0, 0" : "getA(" + r[0] + "),\n          cEdge ? 0. : getA(" + r[1] + "),\n          rEdge ? 0. : getA(" + r[2] + "),\n          rEdge || cEdge ? 0. : getA(" + r[3] + ")";
        }(t, n);
        this.userCode = "\n        void main() {\n          " + r + " rc = getOutputCoords();\n\n          if(" + o + ") {\n            setOutput(vec4(0));\n          } else {\n            " + a + "\n\n            setOutput(vec4(" + i + "));\n          }\n        }\n      ";
    }
};
var Xi = function(t, e, n) {
    this.variableNames = [
        "x"
    ], this.outputShape = e.map(function(e, n) {
        return e[0] + t[n] + e[1];
    });
    var r = t.length, o = wa(r), a = e.map(function(t) {
        return t[0];
    }).join(","), i = e.map(function(e, n) {
        return e[0] + t[n];
    }).join(","), s = [
        "coords[0]",
        "coords[1]",
        "coords[2]",
        "coords[3]"
    ].slice(0, r);
    this.userCode = 1 !== r ? "\n      " + o + " start = " + o + "(" + a + ");\n      " + o + " end = " + o + "(" + i + ");\n\n      void main() {\n        " + o + " outC = getOutputCoords();\n        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {\n          setOutput(float(" + n + "));\n        } else {\n          " + o + " coords = outC - start;\n          setOutput(getX(" + s + "));\n        }\n      }\n    " : "\n        int start = " + a + ";\n        int end = " + i + ";\n\n        void main() {\n          int outC = getOutputCoords();\n          if (outC < start || outC >= end) {\n            setOutput(float(" + n + "));\n          } else {\n            setOutput(getX(outC - start));\n          }\n        }\n      ";
}, Yi = function(t, e, n) {
    this.variableNames = [
        "x"
    ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = e.map(function(e, n) {
        return e[0] + t[n] + e[1];
    });
    for(var r = t.length, o = wa(r), a = e.map(function(t) {
        return t[0];
    }).join(","), i = e.map(function(e, n) {
        return e[0] + t[n];
    }).join(","), s = sa("rc", r), u = sa("source", r), c = s[r - 1] + " < " + this.outputShape[r - 1], l = 1 === r ? "source" : "vec2(" + u.slice(-2).join() + ")", h = [
        o + " rc = outputLoc;",
        s[r - 1] + " += 1;\n       if(" + c + ") {\n      ",
        1 === r ? "" : "}\n       rc = outputLoc;\n       " + s[r - 2] + " += 1;\n       if(" + s[r - 2] + " < " + this.outputShape[r - 2] + ") {",
        1 === r ? "" : "  " + s[r - 1] + " += 1;\n         if(" + c + ") {"
    ], f = 1 === r ? "rc < start || rc >= end" : "any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))", d = "", p = 0, v = 1 === r ? 2 : 4; p < v; p++)d += "\n        " + h[p] + "\n        if (" + f + ") {\n          result[" + p + "] = float(" + n + ");\n        } else {\n          " + o + " source = rc - start;\n          result[" + p + "] = getChannel(getX(" + u.join() + "), " + l + ");\n        }\n      ";
    d += 1 === r ? "} " : "}}", this.userCode = "\n      const " + o + " start = " + o + "(" + a + ");\n      const " + o + " end = " + o + "(" + i + ");\n\n      void main() {\n        " + o + " outputLoc = getOutputCoords();\n        vec4 result = vec4(0.);\n        " + d + "\n        setOutput(result);\n      }\n    ";
}, $i = function(t, e, n) {
    if (this.variableNames = [
        "x"
    ], "avg" === e && n) throw new Error("Cannot compute positions for average pool.");
    var r = t.filterWidth, o = t.strideHeight, a = t.strideWidth, i = t.dilationHeight, s = t.dilationWidth, u = t.effectiveFilterHeight, c = t.effectiveFilterWidth, l = t.padInfo.top, h = t.padInfo.left;
    this.outputShape = t.outShape;
    var f = "avg" === e, d = "0.0";
    if (f || (d = "-1.0 / 1e-20"), n) this.userCode = "\n        const ivec2 strides = ivec2(" + o + ", " + a + ");\n        const ivec2 pads = ivec2(" + l + ", " + h + ");\n\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int batch = coords[0];\n          int d = coords[3];\n\n          ivec2 xRCCorner = coords.yz * strides - pads;\n          int xRCorner = xRCCorner.x;\n          int xCCorner = xRCCorner.y;\n\n          // max/min x(?, ?, d) to get y(yR, yC, d).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n          float avgValue = 0.0;\n\n          for (int wR = 0; wR < " + u + ";\n              wR += " + i + ") {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= " + t.inHeight + ") {\n              continue;\n            }\n\n            for (int wC = 0; wC < " + c + ";\n                wC += " + s + ") {\n              int xC = xCCorner + wC;\n\n              if (xC < 0 || xC >= " + t.inWidth + ") {\n                continue;\n              }\n\n              float value = getX(batch, xR, xC, d);\n\n              // If a min / max value has already been found, use it. If not,\n              // use the current value.\n              float currMinMaxValue = mix(\n                  value, minMaxValue, minMaxValueFound);\n              if (value >= currMinMaxValue) {\n                minMaxValue = value;\n                minMaxValueFound = 1.0;\n                minMaxPosition = wR * " + c + " + wC;\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      ";
    else {
        var p = e + "(" + e + "(" + e + "(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";
        "avg" === e && (p = "avgValue / count");
        var v = 4 * Math.floor(r / 4), m = r % 4, g = "\n      if (" + f + ") {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = max(values, minMaxValue);\n      }\n    ";
        this.userCode = "\n      const ivec2 strides = ivec2(" + o + ", " + a + ");\n      const ivec2 pads = ivec2(" + l + ", " + h + ");\n      const float initializationValue = " + d + ";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xR, int xC, int d) {\n        if (xC < 0 || xC >= " + t.inWidth + ") {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xR, xC, d);\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d = coords[3];\n\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // max/min x(?, ?, d) to get y(yR, yC, d).\n        // ? = to be determined\n        vec4 minMaxValue = vec4(" + d + ");\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wR = 0; wR < " + u + ";\n            wR += " + i + ") {\n          int xR = xRCorner + wR;\n\n          if (xR < 0 || xR >= " + t.inHeight + ") {\n            continue;\n          }\n\n          for (int wC = 0; wC < " + v + "; wC += 4) {\n            int xC = xCCorner + wC * " + s + ";\n\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + s + ", d),\n              getValue(batch, xR, xC + 2 * " + s + ", d),\n              getValue(batch, xR, xC + 3 * " + s + ", d)\n            );\n\n            " + g + "\n          }\n\n          int xC = xCCorner + " + v + ";\n          if (" + (1 === m) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              initializationValue,\n              initializationValue,\n              initializationValue\n            );\n\n            " + g + "\n          } else if (" + (2 === m) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + s + ", d),\n              initializationValue,\n              initializationValue\n            );\n\n            " + g + "\n          } else if (" + (3 === m) + ") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + " + s + ", d),\n              getValue(batch, xR, xC + 2 * " + s + ", d),\n              initializationValue\n            );\n\n            " + g + "\n          }\n        }\n        setOutput(" + p + ");\n      }\n    ";
    }
}, Qi = function(t, e, n) {
    if (this.variableNames = [
        "x"
    ], "avg" === e && n) throw new Error("Cannot compute positions for average pool.");
    var r = t.filterWidth, o = t.strideDepth, a = t.strideHeight, i = t.strideWidth, s = t.dilationDepth, u = t.dilationHeight, c = t.dilationWidth, l = t.effectiveFilterDepth, h = t.effectiveFilterHeight, f = t.effectiveFilterWidth, d = t.padInfo.front, p = t.padInfo.top, v = t.padInfo.left;
    this.outputShape = t.outShape;
    var m = "avg" === e, g = "0.0";
    if (m || (g = "-1.0 / 1e-20"), n) this.userCode = "\n        const ivec3 strides =\n            ivec3(" + o + ", " + a + ", " + i + ");\n        const ivec3 pads = ivec3(" + d + ", " + p + ", " + v + ");\n\n        void main() {\n          ivec5 coords = getOutputCoords();\n          int batch = coords.x;\n          int ch = coords.u;\n\n          ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n          int xDCorner = xCorner.x;\n          int xRCorner = xCorner.y;\n          int xCCorner = xCorner.z;\n\n          // max/min x(?, ?, ?, ch) to get y(yD, yR, yC, ch).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n\n          for (int wD = 0; wD < " + l + ";\n              wD += " + s + ") {\n            int xD = xDCorner + wD;\n\n            if (xD < 0 || xD >= " + t.inDepth + ") {\n              continue;\n            }\n\n            for (int wR = 0; wR < " + h + ";\n                wR += " + u + ") {\n              int xR = xRCorner + wR;\n\n              if (xR < 0 || xR >= " + t.inHeight + ") {\n                continue;\n              }\n\n              for (int wC = 0; wC < " + f + ";\n                  wC += " + c + ") {\n                int xC = xCCorner + wC;\n\n                if (xC < 0 || xC >= " + t.inWidth + ") {\n                  continue;\n                }\n\n                float value = getX(batch, xD, xR, xC, ch);\n\n                // If a min / max value has already been found, use it. If not,\n                // use the current value.\n                float currMinMaxValue = mix(\n                    value, minMaxValue, minMaxValueFound);\n                if (value >= currMinMaxValue) {\n                  minMaxValue = value;\n                  minMaxValueFound = 1.0;\n                  minMaxPosition =\n                      wD * " + h + " * " + f + " +\n                      wR * " + f + " + wC;;\n                }\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      ";
    else {
        var y = e + "(" + e + "(" + e + "(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";
        "avg" === e && (y = "avgValue / count");
        var x = 4 * Math.floor(r / 4), b = r % 4, w = "\n      if (" + m + ") {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = max(values, minMaxValue);\n      }\n    ";
        this.userCode = "\n      const ivec3 strides =\n        ivec3(" + o + ", " + a + ", " + i + ");\n      const ivec3 pads = ivec3(" + d + ", " + p + ", " + v + ");\n      const float initializationValue = " + g + ";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xD, int xR, int xC, int ch) {\n        if (xC < 0 || xC >= " + t.inWidth + ") {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xD, xR, xC, ch);\n      }\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n        int xDCorner = xCorner.x;\n        int xRCorner = xCorner.y;\n        int xCCorner = xCorner.z;\n\n        // max/min x(?, ?, ?, d) to get y(yD, yR, yC, ch).\n        // ? = to be determined\n        vec4 minMaxValue = vec4(" + g + ");\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wD = 0; wD < " + l + ";\n            wD += " + s + ") {\n          int xD = xDCorner + wD;\n\n          if (xD < 0 || xD >= " + t.inDepth + ") {\n            continue;\n          }\n\n          for (int wR = 0; wR < " + h + ";\n            wR += " + u + ") {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= " + t.inHeight + ") {\n              continue;\n            }\n\n            for (int wC = 0; wC < " + x + "; wC += 4) {\n              int xC = xCCorner + wC * " + c + ";\n\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + " + c + ", ch),\n                getValue(batch, xD, xR, xC + 2 * " + c + ", ch),\n                getValue(batch, xD, xR, xC + 3 * " + c + ", ch)\n              );\n\n              " + w + "\n            }\n\n            int xC = xCCorner + " + x + ";\n            if (" + (1 === b) + ") {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                initializationValue,\n                initializationValue,\n                initializationValue\n              );\n\n              " + w + "\n            } else if (" + (2 === b) + ") {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + " + c + ", ch),\n                initializationValue,\n                initializationValue\n              );\n\n              " + w + "\n            } else if (" + (3 === b) + ") {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + " + c + ", ch),\n                getValue(batch, xD, xR, xC + 2 * " + c + ", ch),\n                initializationValue\n              );\n\n              " + w + "\n            }\n          }\n          setOutput(" + y + ");\n        }\n      }\n    ";
    }
}, Ji = function(t, e) {
    this.variableNames = [
        "x"
    ];
    var n = t.windowSize, r = t.batchSize, o = t.inSize, a = Math.ceil(o / n);
    this.outputShape = [
        r,
        a
    ];
    var i = "0.0", s = "";
    "prod" === e ? i = "1.0" : "min" === e ? (i = "1.0 / 1e-20", s = "min") : "max" === e && (i = "-1.0 / 1e-20", s = "max");
    var u = e + "(" + e + "(" + e + "(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";
    "sum" === e ? u = "sumValue" : "prod" === e ? u = "prodValue" : "all" === e ? u = "allValue" : "any" === e && (u = "anyValue");
    var c = 4 * Math.floor(n / 4), l = n % 4, h = "\n      if (" + ("sum" === e) + ") {\n        sumValue += dot(values, ones);\n      } else if (" + ("prod" === e) + ") {\n        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);\n        prodValue *= tmp[0] * tmp[1];\n      } else {\n        minMaxValue = " + s + "(values, minMaxValue);\n      }\n    ", f = "vec4";
    "all" === e ? (i = "1.0", h = "\n        bool reducedAllValue = all(values);\n        float floatedReducedAllValue = float(reducedAllValue);\n        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);\n      ", f = "bvec4") : "any" === e && (i = "0.0", h = "\n        bool reducedAnyValue = any(values);\n        float floatedReducedAnyValue = float(reducedAnyValue);\n        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);\n      ", f = "bvec4");
    var d = "";
    o % n > 0 && (d = "\n        if (inIdx < 0 || inIdx >= " + o + ") {\n          return initializationValue;\n        }\n      "), this.userCode = "\n      const float initializationValue = " + i + ";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float getValue(int batch, int inIdx) {\n        " + d + "\n        return getX(batch, inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * " + n + ";\n\n        vec4 minMaxValue = vec4(" + i + ");\n        float prodValue = 1.0;\n        float sumValue = 0.0;\n        float allValue = 1.0;\n        float anyValue = 0.0;\n\n        for (int i = 0; i < " + c + "; i += 4) {\n          int inIdx = inOffset + i;\n          " + f + " values = " + f + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          " + h + "\n        }\n\n        int inIdx = inOffset + " + c + ";\n        if (" + (1 === l) + ") {\n          " + f + " values = " + f + "(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          " + h + "\n        } else if (" + (2 === l) + ") {\n          " + f + " values = " + f + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          " + h + "\n        } else if (" + (3 === l) + ") {\n          " + f + " values = " + f + "(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          " + h + "\n        }\n        setOutput(" + u + ");\n      }\n    ";
}, Zi = function(t, e) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t;
    for(var n = "", r = 0; r < 4; r++){
        var o = "thisRC = rc;";
        r % 2 == 1 && (o += "thisRC.z += 1;"), r > 1 && (o += "thisRC.y += 1;"), n += "\n        " + o + "\n        " + (r > 0 ? "if(thisRC.y < rows && thisRC.z < cols){" : "") + "\n          int flatIndex = getFlatIndex(thisRC);\n\n          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);\n          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));\n\n          result[" + r + "] =\n            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);\n        " + (r > 0 ? "}" : "") + "\n      ";
    }
    this.userCode = "\n      \n    ivec3 inputCoordsFromReshapedOutCoords(int index) {\n      " + ca([
        "r",
        "c",
        "d"
    ], e) + "\n      return ivec3(r, c, d);\n    }\n  \n      " + la(t) + "\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n\n        vec4 result = vec4(0.);\n\n        ivec3 thisRC;\n        int rows = " + t[1] + ";\n        int cols = " + t[2] + ";\n\n        " + n + "\n\n        setOutput(result);\n      }\n    ";
};
var ts = function(t, e, n) {
    this.variableNames = [
        "dy"
    ], this.outputShape = [], this.outputShape = e.shape;
    var r = e.shape, o = r[1], a = r[2], i = t.shape, s = i[1], u = i[2], c = [
        n && s > 1 ? o - 1 : o,
        n && u > 1 ? a - 1 : a
    ], l = [
        n && s > 1 ? s - 1 : s,
        n && u > 1 ? u - 1 : u
    ], h = c[0] / l[0], f = c[1] / l[1], d = 1 / h, p = 1 / f, v = 2 * Math.ceil(d) + 2, m = 2 * Math.ceil(p) + 2;
    this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(" + h + ");\n        const float widthScale = float(" + f + ");\n\n        const float invHeightScale = float(" + d + ");\n        const float invWidthScale = float(" + p + ");\n\n        const int winHeight = int(" + v + ");\n        const int winWidth = int(" + m + ");\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(startRLerp - float(winHeight / 2));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(startCLerp - float(winWidth / 2));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= " + s + ") {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= " + u + ") {\n              continue;\n            }\n\n            float dxR = float(dyR) * heightScale;\n            int topDxRIndex = int(floor(dxR));\n            int bottomDxRIndex = int(min(ceil(dxR), " + (o - 1) + ".0));\n            float dxRLerp = dxR - float(topDxRIndex);\n            float inverseDxRLerp = 1.0 - dxRLerp;\n\n            float dxC = float(dyC) * widthScale;\n            int leftDxCIndex = int(floor(dxC));\n            int rightDxCIndex = int(min(ceil(dxC), " + (a - 1) + ".0));\n            float dxCLerp = dxC - float(leftDxCIndex);\n            float inverseDxCLerp = 1.0 - dxCLerp;\n\n            if (r == topDxRIndex && c == leftDxCIndex) {\n              // topLeft\n              accumulator +=\n                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;\n            }\n\n            if (r == topDxRIndex && c == rightDxCIndex) {\n              // topRight\n              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == leftDxCIndex) {\n              // bottomLeft\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == rightDxCIndex) {\n              // bottomRight\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    ";
}, es = function(t, e, n, r) {
    this.variableNames = [
        "A"
    ], this.outputShape = [];
    var o = t[0], a = t[1], i = t[2], s = t[3];
    this.outputShape = [
        o,
        e,
        n,
        s
    ];
    var u = [
        r && e > 1 ? a - 1 : a,
        r && n > 1 ? i - 1 : i
    ], c = [
        r && e > 1 ? e - 1 : e,
        r && n > 1 ? n - 1 : n
    ];
    this.userCode = "\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          " + u[0] / c[0] + ",\n          " + u[1] / c[1] + ");\n      const vec2 inputShapeRC = vec2(" + a + ".0, " + i + ".0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the four integer indices.\n        ivec2 sourceFloorRC = ivec2(sourceFracIndexRC);\n        ivec2 sourceCeilRC = ivec2(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);\n        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);\n        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);\n        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n        float top = topLeft + (topRight - topLeft) * fracRC.y;\n        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n        float newValue = top + (bottom - top) * fracRC.x;\n\n        setOutput(newValue);\n      }\n    ";
}, ns = function(t, e, n, r) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = [];
    var o = t[0], a = t[1], i = t[2], s = t[3];
    this.outputShape = [
        o,
        e,
        n,
        s
    ];
    var u = [
        r && e > 1 ? a - 1 : a,
        r && n > 1 ? i - 1 : i
    ], c = [
        r && e > 1 ? e - 1 : e,
        r && n > 1 ? n - 1 : n
    ];
    this.userCode = "\n      const vec3 effectiveInputOverOutputRatioRC = vec3(\n          " + u[0] / c[0] + ",\n          " + u[1] / c[1] + ",\n          " + u[1] / c[1] + ");\n      const vec3 inputShapeRC = vec3(" + a + ".0, " + i + ".0,\n                                     " + i + ".0);\n\n      float getAValue(int b, int r, int c, int d) {\n        return getChannel(getA(b, r, c, d), vec2(c, d));\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        // Calculate values for next column in yRC.z.\n        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);\n\n        // Fractional source index.\n        vec3 sourceFracIndexRC = vec3(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the four integer indices.\n        ivec3 sourceFloorRC = ivec3(sourceFracIndexRC);\n        ivec3 sourceCeilRC = ivec3(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        // Should we calculate next column and row elements in 2x2 packed cell.\n        bool hasNextCol = d < " + (s - 1) + ";\n        bool hasNextRow = coords.z < " + (n - 1) + ";\n\n        // In parallel, construct four corners for all four components in\n        // packed 2x2 cell.\n        vec4 topLeft = vec4(\n          getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d),\n          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d + 1) : 0.0);\n\n        vec4 bottomLeft = vec4(\n          getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d),\n          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d + 1) : 0.0);\n\n        vec4 topRight = vec4(\n          getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d),\n          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d + 1) : 0.0);\n\n        vec4 bottomRight = vec4(\n          getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d),\n          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d + 1) : 0.0);\n\n        vec3 fracRC = sourceFracIndexRC - vec3(sourceFloorRC);\n\n        vec4 top = mix(topLeft, topRight, fracRC.yyzz);\n        vec4 bottom = mix(bottomLeft, bottomRight, fracRC.yyzz);\n        vec4 newValue = mix(top, bottom, fracRC.x);\n\n        setOutput(newValue);\n      }\n    ";
}, rs = function(t, e, n) {
    this.variableNames = [
        "dy"
    ], this.outputShape = [], this.outputShape = e.shape;
    var r = e.shape, o = r[1], a = r[2], i = t.shape, s = i[1], u = i[2], c = [
        n && s > 1 ? o - 1 : o,
        n && u > 1 ? a - 1 : a
    ], l = [
        n && s > 1 ? s - 1 : s,
        n && u > 1 ? u - 1 : u
    ], h = c[0] / l[0], f = c[1] / l[1], d = 1 / h, p = 1 / f, v = 2 * Math.ceil(d) + 2, m = 2 * Math.ceil(p) + 2;
    this.userCode = "\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(" + h + ");\n        const float widthScale = float(" + f + ");\n\n        const float invHeightScale = float(" + d + ");\n        const float invWidthScale = float(" + p + ");\n\n        const int winHeight = int(" + v + ");\n        const int winWidth = int(" + m + ");\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(floor(startRLerp - float(winHeight / 2)));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(floor(startCLerp - float(winWidth / 2)));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= " + s + ") {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= " + u + ") {\n              continue;\n            }\n\n            float sourceFracRow =\n              float(" + c[0] + ") *\n                (float(dyR) / float(" + l[0] + "));\n\n            float sourceFracCol =\n                float(" + c[1] + ") *\n                  (float(dyC) / float(" + l[1] + "));\n\n            int sourceNearestRow = int(min(\n                float(int(" + o + ") - 1),\n                " + n + " ? float(round(sourceFracRow)) :\n                                  float(floor(sourceFracRow))));\n\n            int sourceNearestCol = int(min(\n                float(int(" + a + ") - 1),\n                " + n + " ? float(round(sourceFracCol)) :\n                                  float(floor(sourceFracCol))));\n\n            if (r == sourceNearestRow && c == sourceNearestCol) {\n              accumulator += getDy(b, dyR, dyC, d);\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    ";
}, os = function(t, e, n, r) {
    this.variableNames = [
        "A"
    ], this.outputShape = [];
    var o = t[0], a = t[1], i = t[2], s = t[3];
    this.outputShape = [
        o,
        e,
        n,
        s
    ];
    var u = [
        r && e > 1 ? a - 1 : a,
        r && n > 1 ? i - 1 : i
    ], c = [
        r && e > 1 ? e - 1 : e,
        r && n > 1 ? n - 1 : n
    ], l = r ? "0.5" : "0.0";
    this.userCode = "\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          " + u[0] / c[0] + ",\n          " + u[1] / c[1] + ");\n      const vec2 inputShapeRC = vec2(" + a + ".0, " + i + ".0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the coordinators of nearest neighbor point.\n        ivec2 sourceNearestRC = ivec2(\n          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + " + l + ")));\n\n        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);\n\n        setOutput(newValue);\n      }\n    ";
}, as = function(t, e) {
    this.variableNames = [
        "x"
    ];
    var n = t.length;
    if (n > 4) throw new Error("WebGL backend: Reverse of rank-" + n + " tensor is not yet supported");
    if (this.outputShape = t, 1 !== n) {
        var r = t.map(function(n, r) {
            return function(n) {
                return -1 !== e.indexOf(n) && 1 !== t[n] ? t[n] + " - coords[" + n + "] - 1" : "coords[" + n + "]";
            }(r);
        }).join(","), o = wa(n);
        this.userCode = "\n      void main() {\n        " + o + " coords = getOutputCoords();\n        setOutput(getX(" + r + "));\n      }\n    ";
    } else this.userCode = "\n        void main() {\n          int coord = getOutputCoords();\n          setOutput(getX(" + t[0] + " - coord - 1));\n        }\n      ";
}, is = function(t, e) {
    this.variableNames = [
        "x"
    ], this.packedInputs = !0, this.packedOutput = !0;
    var n = t.length;
    if (n > 4) throw new Error("WebGL backend: Reverse of rank-" + n + " tensor is not yet supported");
    this.outputShape = t;
    var r = sa("rc", n), o = r[n - 1] + " + 1 < " + this.outputShape[n - 1], a = r[n - 2] + " + 1 < " + this.outputShape[n - 2], i = wa(n);
    function s(n) {
        var r = t.map(function(r, o) {
            return function(n, r) {
                return -1 !== e.indexOf(n) && 1 !== t[n] ? t[n] + " - " + r[n] + " - 1" : "" + r[n];
            }(o, n);
        });
        return "getChannel(getX(" + r.join(",") + "), vec2(" + r.slice(-2).join(",") + "))";
    }
    this.userCode = 1 === n ? "\n        void main(){\n          int rc = getOutputCoords();\n          vec4 result = vec4(0.);\n          result.r = getChannel(getX(" + t[0] + " - rc - 1),\n            " + t[0] + " - rc - 1);\n          if(" + o + "){\n              result.g = getChannel(getX(" + t[0] + " - (rc  + 1) - 1),\n                " + t[0] + " - (rc  + 1) - 1);\n          }\n          setOutput(result);\n        }\n      " : "\n        void main() {\n          " + i + " rc = getOutputCoords();\n          vec4 result = vec4(0.);\n          result.r = " + function(t) {
        return s(t);
    }(r.slice()) + ";\n          if(" + o + "){\n            result.g = " + function(t) {
        return t[n - 1] = "(" + t[n - 1] + " + 1)", s(t);
    }(r.slice()) + ";\n          }\n          if(" + a + ") {\n            result.b = " + function(t) {
        return t[n - 2] = "(" + t[n - 2] + " + 1)", s(t);
    }(r.slice()) + ";\n            if(" + o + ") {\n              result.a = " + function(t) {
        return t[n - 1] = "(" + t[n - 1] + " + 1)", t[n - 2] = "(" + t[n - 2] + " + 1)", s(t);
    }(r.slice()) + ";\n            }\n          }\n          setOutput(result);\n        }\n    ";
}, ss = function(t, e, n, r, o, a, i) {
    void 0 === i && (i = !0), this.variableNames = [
        "updates",
        "indices",
        "defaultValue"
    ], this.outputShape = a;
    var s = wa(o.length), u = wa(a.length), c = "";
    1 === n ? c = "i" : 2 === n && (c = "i, j");
    var l = "getIndices(" + c + ")", h = "";
    1 === r ? h = "i" : 2 === r && (h = "i, coords[1]");
    var f = "getUpdates(" + h + ")", d = e > 1 ? "strides[j]" : "strides";
    this.userCode = "\n        " + s + " strides = " + s + "(" + o + ");\n\n        void main() {\n          " + u + " coords = getOutputCoords();\n          float sum = 0.0;\n          bool found = false;\n          for (int i = 0; i < " + t + "; i++) {\n            int flattenedIndex = 0;\n            for (int j = 0; j < " + e + "; j++) {\n              int index = round(" + l + ");\n              flattenedIndex += index * " + d + ";\n            }\n            if (flattenedIndex == coords[0]) {\n              sum += " + f + ";\n              found = true;\n            }\n          }\n          setOutput(mix(getDefaultValue(), sum, float(found)));\n        }\n      ";
}, us = function(t, e) {
    this.variableNames = [
        "x",
        "segmentIds"
    ];
    var n = t.windowSize, r = t.batchSize, o = t.inSize, a = t.numSegments, i = a * Math.ceil(o / n);
    this.outputShape = [
        r,
        i
    ];
    var s = 4 * Math.floor(n / 4), u = n % 4, c = "\n        sumValue += dot(values, segFilter);\n    ", l = "";
    o % n > 0 && (l = "\n        if (inIdx < 0 || inIdx >= " + o + ") {\n          return initializationValue;\n        }\n      ");
    var h = "";
    o % n > 0 && (h = "\n        if (inIdx < 0 || inIdx >= " + o + ") {\n          return -1.0;\n        }\n      "), this.userCode = "\n      const float initializationValue = 0.0;\n\n      float getValue(int batch, int inIdx) {\n        " + l + "\n        return getX(batch, inIdx);\n      }\n\n      float getSegmentIdAtIndex(int inIdx) {\n        " + h + "\n        return getSegmentIds(inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = int(floor(float(outIdx) / float(\n          " + a + ")) * float(" + n + "));\n        int currentSeg = int(mod(float(outIdx), float(" + a + ")));\n\n        float sumValue = 0.0;\n\n        for (int i = 0; i < " + s + "; i += 4) {\n          int inIdx = inOffset + i;\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0\n          );\n\n          " + c + "\n        }\n\n        int inIdx = inOffset + " + s + ";\n        if (" + (1 === u) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            0,\n            0,\n            0\n          );\n\n          " + c + "\n        } else if (" + (2 === u) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n              0,\n              0\n          );\n\n          " + c + "\n        } else if (" + (3 === u) + ") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            0\n          );\n\n          " + c + "\n        }\n        setOutput(sumValue);\n      }\n    ";
}, cs = function(t, e, n) {
    var r, o;
    if (this.variableNames = [
        "c",
        "a",
        "b"
    ], this.outputShape = e, n > 4) throw Error("Where for rank " + n + " is not yet supported");
    if (1 === n) o = "resRC", r = "resRC";
    else {
        for(var a = [
            "resRC.x",
            "resRC.y",
            "resRC.z",
            "resRC.w"
        ], i = [], s = [], u = 0; u < e.length; u++)s.push("" + a[u]), u < t && i.push("" + a[u]);
        r = i.join(), o = s.join();
    }
    var c = wa(n);
    this.userCode = "\n      void main() {\n        " + c + " resRC = getOutputCoords();\n        float cVal = getC(" + r + ");\n        if (cVal >= 1.0) {\n          setOutput(getA(" + o + "));\n        } else {\n          setOutput(getB(" + o + "));\n        }\n      }\n    ";
}, ls = function() {
    function t(t) {
        this.variableNames = [
            "source"
        ], this.outputShape = t, this.rank = t.length;
        var e, n = wa(this.rank), r = "uniform int start[" + this.rank + "];", o = function(t) {
            if (1 === t) return "sourceLoc";
            if (t <= 6) return hs.slice(0, t).map(function(t) {
                return "sourceLoc." + t;
            }).join(",");
            throw Error("Slicing for rank " + t + " is not yet supported");
        }(this.rank);
        e = "\n        " + n + " sourceLoc;\n        " + n + " coords = getOutputCoords();\n        " + t.map(function(t, e) {
            return "sourceLoc." + hs[e] + " = start[" + e + "] + coords." + hs[e] + ";";
        }).join("\n") + "\n      ", this.userCode = "\n      " + r + "\n      void main() {\n        " + e + "\n        setOutput(getSource(" + o + "));\n      }\n    ";
    }
    return t.prototype.getCustomSetupFunc = function(t) {
        var e = this;
        if (t.length !== this.rank) throw Error("The rank (" + this.rank + ") of the program must match the length of start (" + t.length + ")");
        return function(n, r) {
            null == e.startLoc && (e.startLoc = n.getUniformLocationNoThrow(r, "start"), null == e.startLoc) || n.gl.uniform1iv(e.startLoc, t);
        };
    }, t;
}(), hs = [
    "x",
    "y",
    "z",
    "w",
    "u",
    "v"
];
var fs = function() {
    function t(t) {
        this.variableNames = [
            "source"
        ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.rank = t.length;
        var e = wa(this.rank), n = sa("coords", this.rank), r = sa("sourceLoc", this.rank), o = 1 === this.rank ? "sourceLoc" : "vec2(" + r.slice(-2).join() + ")", a = "getChannel(getSource(" + r.join() + "), " + o + ")", i = "\n      result.x = " + a + ";\n      if (++" + n[this.rank - 1] + " < " + t[this.rank - 1] + ") {\n        ++" + r[this.rank - 1] + ";\n        result.y = " + a + ";\n        --" + r[this.rank - 1] + ";\n      }\n    ", s = 1 === this.rank ? "" : "\n      --" + n[this.rank - 1] + ";\n      if (++" + n[this.rank - 2] + " < " + t[this.rank - 2] + ") {\n        ++" + r[this.rank - 2] + ";\n        result.z = " + a + ";\n        if (++" + n[this.rank - 1] + " < " + t[this.rank - 1] + ") {\n          ++" + r[this.rank - 1] + ";\n          result.w = " + a + ";\n        }\n      }\n    ", u = this.rank <= 4 ? "sourceLoc = coords +\n            " + e + "(" + t.map(function(t, e) {
            return "start[" + e + "]";
        }).join() + ");" : t.map(function(t, e) {
            return r[e] + " = " + n[e] + " + start[" + e + "];";
        }).join("\n");
        this.userCode = "\n      uniform int start[" + this.rank + "];\n      void main() {\n        " + e + " coords = getOutputCoords();\n        " + e + " sourceLoc;\n        " + u + "\n        vec4 result = vec4(0.);\n        " + i + "\n        " + s + "\n        setOutput(result);\n      }\n    ";
    }
    return t.prototype.getCustomSetupFunc = function(t) {
        var e = this;
        if (t.length !== this.rank) throw Error("The rank (" + this.rank + ") of the program must match the length of start (" + t.length + ")");
        return function(n, r) {
            null == e.startLoc && (e.startLoc = n.getUniformLocationNoThrow(r, "start"), null == e.startLoc) || n.gl.uniform1iv(e.startLoc, t);
        };
    }, t;
}(), ds = function(t, e, n) {
    this.variableNames = [
        "x"
    ], this.outputShape = n;
    var r = n.length, o = wa(n.length), a = wa(n.length), i = "";
    if (1 === r) i = "coords * strides + begin";
    else {
        var s = 0;
        i = n.map(function(t, e) {
            return s++, 1 === n.length ? "coords * strides[" + e + "] + begin[" + e + "]" : "coords[" + (s - 1) + "] * strides[" + e + "] + begin[" + e + "]";
        }).join(",");
    }
    this.userCode = "\n      " + o + " begin = " + o + "(" + t + ");\n      " + o + " strides = " + o + "(" + e + ");\n\n      void main() {\n        " + a + " coords = getOutputCoords();\n        setOutput(getX(" + i + "));\n      }\n    ";
}, ps = function() {
    function t(t) {
        this.gpgpu = t, this.numUsedTextures = 0, this.numFreeTextures = 0, this.freeTextures = {}, this.logEnabled = !1, this.usedTextures = {};
    }
    return t.prototype.acquireTexture = function(t, e, n) {
        var r, o = vs(e, n), a = ms(t, o, n);
        if (a in this.freeTextures || (this.freeTextures[a] = []), a in this.usedTextures || (this.usedTextures[a] = []), this.freeTextures[a].length > 0) {
            this.numFreeTextures--, this.numUsedTextures++, this.log();
            var i = this.freeTextures[a].shift();
            return this.usedTextures[a].push(i), i;
        }
        return this.numUsedTextures++, this.log(), o === Gt.PACKED_2X2_FLOAT32 ? r = this.gpgpu.createPackedMatrixTexture(t[0], t[1]) : o === Gt.PACKED_2X2_FLOAT16 ? r = this.gpgpu.createFloat16PackedMatrixTexture(t[0], t[1]) : o === Gt.UNPACKED_FLOAT32 ? r = this.gpgpu.createFloat32MatrixTexture(t[0], t[1]) : o === Gt.UNPACKED_FLOAT16 ? r = this.gpgpu.createFloat16MatrixTexture(t[0], t[1]) : o === Gt.PACKED_4X1_UNSIGNED_BYTE && (r = this.gpgpu.createUnsignedBytesMatrixTexture(t[0], t[1])), this.usedTextures[a].push(r), r;
    }, t.prototype.releaseTexture = function(t, e, n, r) {
        if (null != this.freeTextures) {
            var o = ms(e, vs(n, r), r);
            o in this.freeTextures || (this.freeTextures[o] = []), this.freeTextures[o].push(t), this.numFreeTextures++, this.numUsedTextures--;
            var a = this.usedTextures[o], i = a.indexOf(t);
            if (i < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");
            a.splice(i, 1), this.log();
        }
    }, t.prototype.log = function() {
        if (this.logEnabled) {
            var t = this.numFreeTextures + this.numUsedTextures;
            console.log("Free/Used", this.numFreeTextures + " / " + this.numUsedTextures, "(" + t + ")");
        }
    }, t.prototype.getNumUsedTextures = function() {
        return this.numUsedTextures;
    }, t.prototype.getNumFreeTextures = function() {
        return this.numFreeTextures;
    }, t.prototype.dispose = function() {
        var t = this;
        if (null != this.freeTextures) {
            for(var e in this.freeTextures)this.freeTextures[e].forEach(function(e) {
                t.gpgpu.deleteMatrixTexture(e);
            });
            for(var e in this.usedTextures)this.usedTextures[e].forEach(function(e) {
                t.gpgpu.deleteMatrixTexture(e);
            });
            this.freeTextures = null, this.usedTextures = null, this.numUsedTextures = 0, this.numFreeTextures = 0;
        }
    }, t;
}();
function vs(t, e) {
    if (t === zt.UPLOAD) return Gt.PACKED_2X2_FLOAT32;
    if (t === zt.RENDER || null == t) return function(t) {
        return i().getBool("WEBGL_RENDER_FLOAT32_ENABLED") ? t ? Gt.PACKED_2X2_FLOAT32 : Gt.UNPACKED_FLOAT32 : t ? Gt.PACKED_2X2_FLOAT16 : Gt.UNPACKED_FLOAT16;
    }(e);
    if (t === zt.DOWNLOAD || t === zt.PIXELS) return Gt.PACKED_4X1_UNSIGNED_BYTE;
    throw new Error("Unknown logical texture type " + t);
}
function ms(t, e, n) {
    return t[0] + "_" + t[1] + "_" + e + "_" + n;
}
var gs = function(t, e) {
    this.variableNames = [
        "A"
    ];
    for(var n = new Array(t.length), r = 0; r < n.length; r++)n[r] = t[r] * e[r];
    this.outputShape = n, this.rank = n.length;
    var o = wa(this.rank), a = function(t) {
        var e = t.length;
        if (e > 5) throw Error("Tile for rank " + e + " is not yet supported");
        if (1 === e) return "imod(resRC, " + t[0] + ")";
        for(var n = [
            "resRC.x",
            "resRC.y",
            "resRC.z",
            "resRC.w",
            "resRC.u"
        ], r = [], o = 0; o < t.length; o++)r.push("imod(" + n[o] + ", " + t[o] + ")");
        return r.join();
    }(t);
    this.userCode = "\n      void main() {\n        " + o + " resRC = getOutputCoords();\n        setOutput(getA(" + a + "));\n      }\n    ";
};
var ys = function(t, e) {
    this.variableNames = [
        "A"
    ];
    for(var n = new Array(t.length), r = 0; r < n.length; r++)n[r] = t[e[r]];
    this.outputShape = n, this.rank = n.length;
    var o = wa(this.rank), a = function(t) {
        var e = t.length;
        if (e > 6) throw Error("Transpose for rank " + e + " is not yet supported");
        for(var n = [
            "resRC.x",
            "resRC.y",
            "resRC.z",
            "resRC.w",
            "resRC.u",
            "resRC.v"
        ], r = new Array(e), o = 0; o < t.length; o++)r[t[o]] = n[o];
        return r.join();
    }(e);
    this.userCode = "\n    void main() {\n      " + o + " resRC = getOutputCoords();\n      setOutput(getA(" + a + "));\n    }\n    ";
};
var xs = function(t, e) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !0, this.packedOutput = !0;
    for(var n = new Array(t.length), r = 0; r < n.length; r++)n[r] = t[e[r]];
    if (this.outputShape = n, this.rank = n.length, this.rank > 6) throw Error("Packed transpose for rank " + this.rank + " is not yet supported.");
    var o = wa(this.rank), a = ia("rc", this.rank), i = new Array(this.rank);
    for(r = 0; r < e.length; r++)i[e[r]] = a[r];
    var s = "vec2(" + i.slice(-2).join() + ")", u = "++" + a[this.rank - 1] + " < " + n[this.rank - 1], c = "getChannel(getA(" + i.join() + "), " + s + ")";
    this.userCode = "\n    void main() {\n      " + o + " rc = getOutputCoords();\n      vec4 result = vec4(0.);\n      result[0] = " + c + ";\n      if(" + u + ") {\n        result[1] = " + c + ";\n      }\n      --" + a[this.rank - 1] + ";\n      if(++" + a[this.rank - 2] + " < " + n[this.rank - 2] + ") {\n        result[2] = " + c + ";\n        if(" + u + ") {\n          result[3] = " + c + ";\n        }\n      }\n      setOutput(result);\n    }\n    ";
}, bs = 1.7580993408473768, ws = 1.0507009873554805, Cs = function(t, e) {
    this.variableNames = [
        "A"
    ], this.outputShape = t, this.userCode = "\n      float unaryOperation(float x) {\n        " + e + "\n      }\n\n      void main() {\n        float x = getAAtOutCoords();\n        float y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    ";
}, Es = "if (isnan(x)) return x;", Rs = "return x;", Is = "return abs(x);", ks = Es + "\n  return (x < 0.0) ? 0.0 : x;\n", Ss = Es + "\n  return (x < 0.0) ? 0.0 : min(6.0, x);\n", As = "return (x >= 0.0) ? x : (exp(x) - 1.0);", Ds = "\n  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.\n  // see: https://arxiv.org/abs/1706.02515\n  float scaleAlpha = " + bs + ";\n  float scale = " + ws + ";\n  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);\n";
var Ts = "return -x;", Ns = "return ceil(x);", Fs = "return floor(x);", _s = "return exp(x);", Os = "return exp(x) - 1.0;", Ms = Es + "\n  return sin(x);\n", Bs = Es + "\n  return cos(x);\n", Ps = Es + "\n  if (abs(x) > 1.) {\n    return NAN;\n  }\n  return asin(x);\n", Ls = Es + "\n  if (abs(x) > 1.) {\n    return NAN;\n  }\n  return acos(x);\n", Ws = Es + "\n  return atan(x);\n", Us = Es + "return log(x + sqrt(x * x + 1.0));", Vs = Es + "\n  if (x < 1.0) return NAN;\n  return log(x + sqrt(x * x - 1.0));", zs = Es + "\n  if ((x < -1.0) || (x > 1.0)) return NAN;\n  return (log(1.0 + x) - log(1.0 - x)) / 2.0;", Gs = "return x;", Hs = "return x;", qs = "\n  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n", Ks = "\n  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n", js = "\n  vec4 result;\n\n  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);\n  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);\n  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);\n  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);\n\n  return result;\n", Xs = function(t, e) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.userCode = "\n      vec4 unaryOperation(vec4 x) {\n        " + e + "\n      }\n\n      void main() {\n        vec4 x = getAAtOutCoords();\n        vec4 y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    ";
}, Ys = function(t) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !0, this.packedOutput = !1, this.outputShape = t;
    var e = t.length, n = sa("rc", e), r = wa(e), o = function(t, e) {
        if (1 === t) return "rc";
        for(var n = "", r = 0; r < t; r++)n += e[r], r < t - 1 && (n += ",");
        return n;
    }(e, n), a = n.slice(-2), i = e <= 1 ? "rc" : "vec2(" + a.join(",") + ")";
    this.userCode = "\n      void main() {\n        " + r + " rc = getOutputCoords();\n        vec4 packedInput = getA(" + o + ");\n\n        setOutput(getChannel(packedInput, " + i + "));\n      }\n    ";
}, $s = {};
function Qs(t, e) {
    if (void 0 === e && (e = !1), "linear" === t) return e ? Hs : Rs;
    if ("relu" === t) return e ? qs : ks;
    if ("elu" === t) return e ? js : As;
    if ("relu6" === t) return e ? Ks : Ss;
    if ("prelu" === t) return e ? Pa : Ma;
    throw new Error("Activation " + t + " has not been implemented for the WebGL backend.");
}
var Js = 600;
var Zs = function(t) {
    function o(e) {
        var n, r = t.call(this) || this;
        if (r.pendingRead = new WeakMap, r.pendingDisposal = new WeakSet, r.dataRefCount = new WeakMap, r.numBytesInGPU = 0, r.uploadWaitMs = 0, r.downloadWaitMs = 0, r.warnedAboutMemory = !1, r.pendingDeletes = 0, r.disposed = !1, !i().getBool("HAS_WEBGL")) throw new Error("WebGL is not supported on this device");
        if (null == e) {
            var o = jt(i().getNumber("WEBGL_VERSION"));
            r.binaryCache = (n = i().getNumber("WEBGL_VERSION")) in $s ? $s[n] : ($s[n] = {}, $s[n]), r.gpgpu = new Bi(o), r.canvas = o.canvas, r.gpgpuCreatedLocally = !0;
        } else r.gpgpu = e, r.binaryCache = {}, r.gpgpuCreatedLocally = !1, r.canvas = e.gl.canvas;
        return r.textureManager = new ps(r.gpgpu), r.numMBBeforeWarning = null == i().global.screen ? 1024 : i().global.screen.height * i().global.screen.width * window.devicePixelRatio * Js / 1024 / 1024, r.texData = new xo(r, Lt), r;
    }
    return e(o, t), o.prototype.numDataIds = function() {
        return this.texData.numDataIds() + (this.cpuBackend ? this.cpuBackend.numDataIds() : 0) - this.pendingDeletes;
    }, o.prototype.write = function(t, e, n) {
        if (i().getBool("DEBUG") && this.checkNumericalProblems(t), "complex64" === n && null != t) throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");
        var r = {};
        return this.texData.set(r, {
            shape: e,
            dtype: n,
            values: t,
            usage: zt.UPLOAD
        }), r;
    }, o.prototype.move = function(t, e, n, r) {
        if (i().getBool("DEBUG") && this.checkNumericalProblems(e), "complex64" === r) throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");
        this.texData.set(t, {
            shape: n,
            dtype: r,
            values: e,
            usage: zt.UPLOAD
        });
    }, o.prototype.readSync = function(t) {
        var e = this.texData.get(t), n = e.values, r = e.dtype, o = e.complexTensors, a = e.slice, i = e.shape, s = e.isPacked;
        if (null != a) {
            var u = void 0;
            u = s ? new Xs(i, Gs) : new Cs(i, Gs);
            var c = this.runWebGLProgram(u, [
                {
                    dataId: t,
                    shape: i,
                    dtype: r
                }
            ], r), l = this.readSync(c.dataId);
            return this.disposeData(c.dataId), l;
        }
        if (null != n) return this.convertAndCacheOnCPU(t);
        if ("string" === r) return n;
        var h, f, d = null != this.activeTimers;
        (d && (h = et()), "complex64" === r) ? f = Vo(o.real.dataSync(), o.imag.dataSync()) : f = this.getValuesFromTexture(t);
        return d && (this.downloadWaitMs += et() - h), this.convertAndCacheOnCPU(t, f);
    }, o.prototype.read = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n, o, a, s, u, c, l, h, f, d, p, v, m, g, y, x, b, w, C, E, R;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        if (this.pendingRead.has(t)) return e = this.pendingRead.get(t), [
                            2,
                            new Promise(function(t) {
                                return e.push(t);
                            })
                        ];
                        if (n = this.texData.get(t), o = n.values, a = n.shape, s = n.slice, u = n.dtype, c = n.complexTensors, l = n.isPacked, null != s) return h = void 0, h = l ? new Xs(a, Gs) : new Cs(a, Gs), f = this.runWebGLProgram(h, [
                            {
                                dataId: t,
                                shape: a,
                                dtype: u
                            }
                        ], u), d = this.read(f.dataId), this.disposeData(f.dataId), [
                            2,
                            d
                        ];
                        if (null != o) return [
                            2,
                            this.convertAndCacheOnCPU(t)
                        ];
                        if (!i().getBool("WEBGL_DOWNLOAD_FLOAT_ENABLED") && 2 === i().getNumber("WEBGL_VERSION")) throw new Error("tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and WEBGL_VERSION=2 not yet supported.");
                        return p = null, "complex64" !== u && i().get("WEBGL_BUFFER_SUPPORTED") && (v = this.decode(t), m = this.texData.get(v.dataId), p = (R = this.gpgpu).createBufferFromTexture.apply(R, [
                            m.texture
                        ].concat(Yt(a)))), this.pendingRead.set(t, []), "complex64" === u ? [
                            3,
                            2
                        ] : [
                            4,
                            this.gpgpu.createAndWaitForFence()
                        ];
                    case 1:
                        r.sent(), r.label = 2;
                    case 2:
                        return "complex64" !== u ? [
                            3,
                            4
                        ] : [
                            4,
                            Promise.all([
                                c.real.data(),
                                c.imag.data()
                            ])
                        ];
                    case 3:
                        return y = r.sent(), x = y[0], b = y[1], g = Vo(x, b), [
                            3,
                            5
                        ];
                    case 4:
                        null == p ? g = this.getValuesFromTexture(t) : (w = k(a), g = this.gpgpu.downloadFloat32MatrixFromBuffer(p, w)), r.label = 5;
                    case 5:
                        return null != v && this.disposeData(v.dataId), C = this.convertAndCacheOnCPU(t, g), E = this.pendingRead.get(t), this.pendingRead.delete(t), E.forEach(function(t) {
                            return t(C);
                        }), this.pendingDisposal.has(t) && (this.pendingDisposal.delete(t), this.disposeData(t), this.pendingDeletes--), [
                            2,
                            C
                        ];
                }
            });
        });
    }, o.prototype.checkNumericalProblems = function(t) {
        if (null != t) for(var e = 0; e < t.length; e++){
            var n = t[e];
            if (!ee(n)) {
                if (i().getBool("WEBGL_RENDER_FLOAT32_CAPABLE")) throw Error("The value " + n + " cannot be represented with your current settings. Consider enabling float32 rendering: 'tf.env().set('WEBGL_RENDER_FLOAT32_ENABLED', true);'");
                throw Error("The value " + n + " cannot be represented on this device.");
            }
        }
    }, o.prototype.getValuesFromTexture = function(t) {
        var e, n = this.texData.get(t), r = n.shape, o = n.dtype, a = n.isPacked, s = k(r);
        if (i().getBool("WEBGL_DOWNLOAD_FLOAT_ENABLED")) {
            var u = this.decode(t), c = this.texData.get(u.dataId), l = (e = this.gpgpu).downloadMatrixFromPackedTexture.apply(e, [
                c.texture
            ].concat(Yt(r))).subarray(0, s);
            return this.disposeData(u.dataId), l;
        }
        var h = i().getBool("WEBGL_PACK") && !0 === a, f = h ? Te(r) : r, d = h ? new ci(f) : new ui(f), p = this.runWebGLProgram(d, [
            {
                shape: f,
                dtype: o,
                dataId: t
            }
        ], "float32"), v = this.texData.get(p.dataId), m = this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(v.texture, v.texShape[0], v.texShape[1]).subarray(0, s);
        return this.disposeData(p.dataId), m;
    }, o.prototype.time = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n, o, a, s, u, c;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        return e = this.activeTimers, n = [], o = !1, null == this.programTimersStack ? (this.programTimersStack = n, o = !0) : this.activeTimers.push(n), this.activeTimers = n, t(), a = I(this.activeTimers.map(function(t) {
                            return t.query;
                        })).filter(function(t) {
                            return null != t;
                        }), s = I(this.activeTimers.map(function(t) {
                            return t.name;
                        })).filter(function(t) {
                            return null != t;
                        }), this.activeTimers = e, o && (this.programTimersStack = null), u = {
                            uploadWaitMs: this.uploadWaitMs,
                            downloadWaitMs: this.downloadWaitMs,
                            kernelMs: null,
                            wallMs: null
                        }, i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0 ? [
                            4,
                            Promise.all(a)
                        ] : [
                            3,
                            2
                        ];
                    case 1:
                        return c = r.sent(), u.kernelMs = w(c), u.getExtraProfileInfo = function() {
                            return c.map(function(t, e) {
                                return {
                                    name: s[e],
                                    ms: t
                                };
                            }).map(function(t) {
                                return t.name + ": " + t.ms;
                            }).join(", ");
                        }, [
                            3,
                            3
                        ];
                    case 2:
                        u.kernelMs = {
                            error: "WebGL query timers are not supported in this environment."
                        }, r.label = 3;
                    case 3:
                        return this.uploadWaitMs = 0, this.downloadWaitMs = 0, [
                            2,
                            u
                        ];
                }
            });
        });
    }, o.prototype.memory = function() {
        return {
            unreliable: !1,
            numBytesInGPU: this.numBytesInGPU
        };
    }, o.prototype.startTimer = function() {
        return i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0 ? this.gpgpu.beginQuery() : {
            startMs: et(),
            endMs: null
        };
    }, o.prototype.endTimer = function(t) {
        return i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0 ? (this.gpgpu.endQuery(), t) : (t.endMs = et(), t);
    }, o.prototype.getQueryTime = function(t) {
        return n(this, void 0, void 0, function() {
            var e;
            return r(this, function(n) {
                return i().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0 ? [
                    2,
                    this.gpgpu.waitForQueryAndGetTime(t)
                ] : [
                    2,
                    (e = t).endMs - e.startMs
                ];
            });
        });
    }, o.prototype.disposeData = function(t) {
        if (!this.pendingDisposal.has(t)) {
            if (this.pendingRead.has(t)) return this.pendingDisposal.add(t), void this.pendingDeletes++;
            if (this.texData.has(t)) {
                this.releaseGPUData(t);
                var e = this.texData.get(t).complexTensors;
                null != e && (e.real.dispose(), e.imag.dispose()), this.texData.delete(t);
            }
        }
    }, o.prototype.releaseGPUData = function(t) {
        var e = this.texData.get(t), n = e.texture, r = e.dtype, o = e.texShape, a = e.usage, i = e.isPacked, s = e.slice, u = s && s.origDataId || t, c = this.dataRefCount.get(u);
        c > 1 ? this.dataRefCount.set(u, c - 1) : (this.dataRefCount.delete(u), null != n && (this.numBytesInGPU -= this.computeBytes(o, r), this.textureManager.releaseTexture(n, o, a, i)));
        var l = this.texData.get(t);
        l.texture = null, l.texShape = null, l.isPacked = !1, l.slice = null;
    }, o.prototype.getTexture = function(t) {
        return this.uploadToGPU(t), this.texData.get(t).texture;
    }, o.prototype.getDataInfo = function(t) {
        return this.texData.get(t);
    }, o.prototype.getCPUBackend = function() {
        return i().getBool("WEBGL_CPU_FORWARD") ? (null == this.cpuBackend && (this.cpuBackend = Lt.findBackend("cpu")), this.cpuBackend) : null;
    }, o.prototype.shouldExecuteOnCPU = function(t, e) {
        var n = this;
        return void 0 === e && (e = 128), null != this.getCPUBackend() && t.every(function(t) {
            return null == n.texData.get(t.dataId).texture && t.size < e;
        });
    }, o.prototype.getGPGPUContext = function() {
        return this.gpgpu;
    }, o.prototype.complex = function(t, e) {
        var n = this.makeOutput(t.shape, "complex64");
        return this.texData.get(n.dataId).complexTensors = {
            real: Lt.keep(t.clone()),
            imag: Lt.keep(e.clone())
        }, n;
    }, o.prototype.real = function(t) {
        return this.texData.get(t.dataId).complexTensors.real.clone();
    }, o.prototype.imag = function(t) {
        return this.texData.get(t.dataId).complexTensors.imag.clone();
    }, o.prototype.slice = function(t, e, n) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.slice(t, e, n);
        if (0 === k(n)) return Fn([], n, t.dtype);
        var r = this.texData.get(t.dataId).isPacked, o = io(t.shape, e, n);
        if (r || !o) {
            var a = i().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new fs(n) : new ls(n), s = a.getCustomSetupFunc(e);
            return this.compileAndRun(a, [
                t
            ], null, s);
        }
        return this.uploadToGPU(t.dataId), this.shallowSlice(t, e, n);
    }, o.prototype.shallowSlice = function(t, e, n) {
        var r = this.texData.get(t.dataId), o = this.makeOutput(n, t.dtype), a = this.texData.get(o.dataId);
        Object.assign(a, r), a.shape = n, a.dtype = t.dtype;
        var i = so(e, t.strides);
        r.slice && (i += r.slice.flatOffset), a.slice = {
            flatOffset: i,
            origDataId: r.slice && r.slice.origDataId || t.dataId
        };
        var s = this.dataRefCount.get(a.slice.origDataId) || 1;
        return this.dataRefCount.set(a.slice.origDataId, s + 1), o;
    }, o.prototype.stridedSlice = function(t, e, n, r) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.stridedSlice(t, e, n, r);
        var o = ro(e, n, r);
        if (o.some(function(t) {
            return 0 === t;
        })) return Fn([], o);
        var a = new ds(e, r, o);
        return this.compileAndRun(a, [
            t
        ]);
    }, o.prototype.reverse = function(t, e) {
        var n = i().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new is(t.shape, e) : new as(t.shape, e);
        return this.compileAndRun(n, [
            t
        ]);
    }, o.prototype.concat = function(t, e) {
        if ("complex64" === t[0].dtype) {
            var n = t.map(function(t) {
                return Tn(t);
            }), r = t.map(function(t) {
                return Nn(t);
            });
            return Dn(this.concat(n, e), this.concat(r, e));
        }
        if (this.shouldExecuteOnCPU(t)) return this.cpuBackend.concat(t, e);
        if (1 === t.length) return t[0];
        if (t.length > i().getNumber("WEBGL_MAX_TEXTURES_IN_SHADER")) {
            var o = Math.floor(t.length / 2), a = this.concat(t.slice(0, o), e), s = this.concat(t.slice(o), e);
            return this.concat([
                a,
                s
            ], e);
        }
        if (i().getBool("WEBGL_PACK_ARRAY_OPERATIONS") && t[0].rank > 1) {
            var u = new Ga(t.map(function(t) {
                return t.shape;
            }), e);
            return this.compileAndRun(u, t);
        }
        var c = Sn(t.map(function(t) {
            return t.shape;
        }), e), l = t.map(function(t) {
            return t.as2D(-1, k(t.shape.slice(e)));
        }), h = new za(l.map(function(t) {
            return t.shape;
        }));
        return this.compileAndRun(h, l).reshape(c);
    }, o.prototype.neg = function(t) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.neg(t);
        if (i().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, Ts, t.dtype);
        var e = new Cs(t.shape, Ts);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.batchMatMul = function(t, e, n, r) {
        var o = n ? t.shape[2] : t.shape[1], a = r ? e.shape[1] : e.shape[2], i = n ? t.shape[1] : t.shape[2], s = t.shape[0];
        if ((1 === o || 1 === a) && i > 1e3) {
            n && (t = t.transpose([
                0,
                2,
                1
            ])), r && (e = e.transpose([
                0,
                2,
                1
            ]));
            var u = 1 === a ? t : t.as3D(s, i, 1), c = 1 === a ? 2 : 1, l = 1 === a ? e.as3D(s, 1, i) : e;
            return this.multiply(u, l).sum(c, !0);
        }
        var h = Dt(t.dtype, e.dtype), f = new Hi(t.shape, [
            s,
            o,
            a
        ], n, r);
        return this.compileAndRun(f, [
            t,
            e
        ], h);
    }, o.prototype.fusedBatchMatMul = function(t) {
        var e = t.a, n = t.b, r = t.transposeA, o = t.transposeB, a = t.bias, i = t.activation, s = t.preluActivationWeights, u = r ? e.shape[2] : e.shape[1], c = o ? n.shape[1] : n.shape[2], l = e.shape[0], h = Dt(e.dtype, n.dtype), f = null != a, d = null != s, p = i ? Qs(i, !0) : null, v = new Hi(e.shape, [
            l,
            u,
            c
        ], r, o, f, p, d), m = [
            e,
            n
        ];
        return a && m.push(a), s && m.push(s), this.compileAndRun(v, m, h);
    }, o.prototype.multiply = function(t, e) {
        if ("complex64" === t.dtype) {
            var n = this.texData.get(t.dataId), r = this.texData.get(e.dataId), o = new Na(Da, t.shape, e.shape), a = new Na(Ta, t.shape, e.shape), s = [
                this.makeComplexComponentTensorInfo(t, n.complexTensors.real),
                this.makeComplexComponentTensorInfo(t, n.complexTensors.imag),
                this.makeComplexComponentTensorInfo(e, r.complexTensors.real),
                this.makeComplexComponentTensorInfo(e, r.complexTensors.imag)
            ], u = this.compileAndRun(o, s), c = this.compileAndRun(a, s), l = this.complex(u, c);
            return u.dispose(), c.dispose(), l;
        }
        if (this.shouldExecuteOnCPU([
            t,
            e
        ])) return this.cpuBackend.multiply(t, e);
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, Oa, t.dtype);
        var h = new Ba(Oa, t.shape, e.shape);
        return this.compileAndRun(h, [
            t,
            e
        ], t.dtype);
    }, o.prototype.batchNormalization = function(t, e, n, r, o, a) {
        var s = [
            t,
            e,
            n
        ], u = null;
        null != a && (u = a.shape, s.push(a));
        var c = null;
        if (null != o && (c = o.shape, s.push(o)), i().getBool("WEBGL_PACK_NORMALIZATION")) {
            var l = new Aa(t.shape, e.shape, n.shape, u, c, r);
            return this.compileAndRun(l, s);
        }
        var h = new Sa(t.shape, e.shape, n.shape, u, c, r);
        return this.compileAndRun(h, s);
    }, o.prototype.localResponseNormalization4D = function(t, e, n, r, o) {
        var a = i().getBool("WEBGL_PACK_NORMALIZATION") ? new Vi(t.shape, e, n, r, o) : new Wi(t.shape, e, n, r, o);
        return this.compileAndRun(a, [
            t
        ]);
    }, o.prototype.LRNGrad = function(t, e, n, r, o, a, i) {
        var s = new Ui(e.shape, r, o, a, i);
        return this.compileAndRun(s, [
            e,
            n,
            t
        ]);
    }, o.prototype.tile = function(t, e) {
        if ("string" === t.dtype) {
            var n = this.readSync(t.dataId).map(function(t) {
                return ot(t);
            });
            return ta(dr(t.shape, t.dtype, n), e);
        }
        var r = new gs(t.shape, e);
        return this.compileAndRun(r, [
            t
        ]);
    }, o.prototype.pad = function(t, e, n) {
        var r = i().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new Yi(t.shape, e, n) : new Xi(t.shape, e, n);
        return this.compileAndRun(r, [
            t
        ]);
    }, o.prototype.transpose = function(t, e) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.transpose(t, e);
        var n = i().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new xs(t.shape, e) : new ys(t.shape, e);
        return this.compileAndRun(n, [
            t
        ]);
    }, o.prototype.gather = function(t, e, n) {
        if (this.shouldExecuteOnCPU([
            t,
            e
        ])) return this.cpuBackend.gather(t, e, n);
        var r = new mi(t.shape, e.size, n);
        return this.compileAndRun(r, [
            t,
            e
        ]);
    }, o.prototype.batchToSpaceND = function(t, e, n) {
        C(t.rank <= 4, function() {
            return "batchToSpaceND for rank > 4 with a WebGL backend not implemented yet";
        });
        var r = e.reduce(function(t, e) {
            return t * e;
        }), o = zr(t.shape, e, r), a = Gr(o.length, e.length), i = Hr(t.shape, e, r), s = qr(n, e.length), u = Kr(i, n, e.length);
        return t.reshape(o).transpose(a).reshape(i).slice(s, u);
    }, o.prototype.spaceToBatchND = function(t, e, n) {
        C(t.rank <= 4, function() {
            return "spaceToBatchND for rank > 4 with a WebGL backend not implemented yet";
        });
        var r = e.reduce(function(t, e) {
            return t * e;
        }), o = [
            [
                0,
                0
            ]
        ];
        o.push.apply(o, n);
        for(var a = 1 + e.length; a < t.shape.length; ++a)o.push([
            0,
            0
        ]);
        var i = t.pad(o), s = zr(i.shape, e, r, !1), u = Gr(s.length, e.length, !1), c = Hr(i.shape, e, r, !1);
        return i.reshape(s).transpose(u).reshape(c);
    }, o.prototype.reduce = function(t, e, n) {
        var r = t.shape[0], o = t.shape[1], a = $r(o), i = new Ji({
            windowSize: a,
            inSize: o,
            batchSize: r
        }, e), s = this.compileAndRun(i, [
            t
        ], n);
        return 1 === s.shape[1] ? s : this.reduce(s, e, n);
    }, o.prototype.argReduce = function(t, e, n) {
        void 0 === n && (n = null);
        var r = t.shape[0], o = t.shape[1];
        null != n && (r = n.shape[0], o = n.shape[1]);
        var a = $r(o), i = new aa({
            windowSize: a,
            inSize: o,
            batchSize: r
        }, e, null == n), s = [
            t
        ];
        null != n && s.push(n);
        var u = this.compileAndRun(i, s, "int32");
        return 1 === u.shape[1] ? u : this.argReduce(t, e, u);
    }, o.prototype.argReducePacked = function(t, e, n) {
        void 0 === n && (n = null);
        var r = null != n ? n.shape : t.shape, o = $r(r[r.length - 1]), a = new Ra(r, o, e, null == n), i = null == n ? [
            t
        ] : [
            t,
            n
        ], s = this.compileAndRun(a, i, "int32");
        return s.rank === t.rank ? this.argReducePacked(t, e, s) : s;
    }, o.prototype.sum = function(t, e) {
        Cn("sum", e, t.rank);
        var n = bn(t.shape, e), r = n[0], o = k(n[1]), a = t.as2D(-1, o), i = Tt(t.dtype);
        return this.reduce(a, "sum", i).reshape(r);
    }, o.prototype.prod = function(t, e) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.prod(t, e);
        var n = bn(t.shape, e), r = n[0], o = k(n[1]), a = t.as2D(-1, o), i = Tt(t.dtype);
        return this.reduce(a, "prod", i).reshape(r);
    }, o.prototype.unsortedSegmentSum = function(t, e, n) {
        var r = 0, o = En([
            r
        ], t.rank), a = t;
        null != o && (a = t.transpose(o), r = In(1, t.rank)[0]);
        var i = function(t, e, n) {
            for(var r = [], o = t.length, a = 0; a < o; a++)a !== e ? r.push(t[a]) : r.push(n);
            return r;
        }(a.shape, r, n), s = k([
            a.shape[r]
        ]), u = a.as2D(-1, s), c = Tt(t.dtype), l = this.segOpCompute(u, "unsortedSegmentSum", e, c, n).reshape(i);
        return null != o && (l = l.transpose(Rn(o))), l;
    }, o.prototype.segOpCompute = function(t, e, n, r, o) {
        var a = t.shape[0], i = t.shape[1], s = function(t, e) {
            var n, r = !1;
            for(t <= Yr ? (n = t, r = !0) : n = Y(t, Math.floor(Math.sqrt(t))); !r;)n > e || n === t ? r = !0 : n = Y(t, n + 1);
            return n;
        }(i, o), u = new us({
            windowSize: s,
            inSize: i,
            batchSize: a,
            numSegments: o
        }, e), c = this.compileAndRun(u, [
            t,
            n
        ], r);
        return c.shape[1] === o ? c : (n = Kn(0, o).tile([
            i / s
        ]), this.segOpCompute(c, e, n, r, o));
    }, o.prototype.argMinMaxReduce = function(t, e, n) {
        var r = [
            e
        ];
        if (Cn("arg" + n.charAt(0).toUpperCase() + n.slice(1), r, t.rank), !i().getBool("WEBGL_PACK_REDUCE") || t.rank <= 2) {
            var o = bn(t.shape, r), a = o[0], s = k(o[1]), u = t.as2D(-1, s);
            return this.argReduce(u, n).reshape(a);
        }
        return this.argReducePacked(t, n);
    }, o.prototype.argMin = function(t, e) {
        return this.argMinMaxReduce(t, e, "min");
    }, o.prototype.argMax = function(t, e) {
        return this.argMinMaxReduce(t, e, "max");
    }, o.prototype.cumsum = function(t, e, n, r) {
        if (e !== t.rank - 1) throw new Error("WebGL cumsum shader expects an inner-most axis=" + (t.rank - 1) + " but got axis=" + e);
        var o = new ni(t.shape, n, r);
        return this.compileAndRun(o, [
            t
        ]);
    }, o.prototype.equal = function(t, e) {
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, "\n  return vec4(equal(a, b));\n", "bool");
        var n = new Ba("return float(a == b);", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ], "bool");
    }, o.prototype.notEqual = function(t, e) {
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, "\n  return vec4(notEqual(a, b));\n", "bool");
        var n = new Ba("return float(a != b);", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ], "bool");
    }, o.prototype.less = function(t, e) {
        if (this.shouldExecuteOnCPU([
            t,
            e
        ])) return this.cpuBackend.less(t, e);
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, "\n  return vec4(lessThan(a, b));\n", "bool");
        var n = new Ba("return float(a < b);", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ], "bool");
    }, o.prototype.lessEqual = function(t, e) {
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, "\n  return vec4(lessThanEqual(a, b));\n", "bool");
        var n = new Ba("return float(a <= b);", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ], "bool");
    }, o.prototype.greater = function(t, e) {
        if (this.shouldExecuteOnCPU([
            t,
            e
        ])) return this.cpuBackend.greater(t, e);
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, "\n  return vec4(greaterThan(a, b));\n", "bool");
        var n = new Ba("return float(a > b);", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ], "bool");
    }, o.prototype.greaterEqual = function(t, e) {
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, "\n  return vec4(greaterThanEqual(a, b));\n", "bool");
        var n = new Ba("return float(a >= b);", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ], "bool");
    }, o.prototype.logicalNot = function(t) {
        var e = new Cs(t.shape, "return float(!(x >= 1.0));");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.logicalAnd = function(t, e) {
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, "\n  return vec4(\n    vec4(greaterThanEqual(a, vec4(1.0))) *\n    vec4(greaterThanEqual(b, vec4(1.0))));\n", "bool");
        var n = new Ba("return float(a >= 1.0 && b >= 1.0);", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ], "bool");
    }, o.prototype.logicalOr = function(t, e) {
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, "\n  return min(\n    vec4(greaterThanEqual(a, vec4(1.0))) +\n    vec4(greaterThanEqual(b, vec4(1.0))),\n    vec4(1.0));\n", "bool");
        var n = new Ba("return float(a >= 1.0 || b >= 1.0);", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ], "bool");
    }, o.prototype.select = function(t, e, n) {
        var r = new cs(t.rank, e.shape, e.rank);
        return this.compileAndRun(r, [
            t,
            e,
            n
        ], Dt(e.dtype, n.dtype));
    }, o.prototype.where = function(t) {
        dn("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");
        var e = t.dataSync();
        return na(t.shape, e);
    }, o.prototype.topk = function(t, e, n) {
        return ea(t.dataSync(), t.shape, t.dtype, e);
    }, o.prototype.min = function(t, e) {
        Cn("min", e, t.rank);
        var n = bn(t.shape, e), r = n[0], o = k(n[1]), a = t.as2D(-1, o);
        return this.reduce(a, "min", a.dtype).reshape(r);
    }, o.prototype.minimum = function(t, e) {
        if (this.shouldExecuteOnCPU([
            t,
            e
        ])) return this.cpuBackend.minimum(t, e);
        var n = i().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new La("\n  vec4 result = vec4(min(a, b));\n  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));\n  \n  result.r = isNaN.r > 0. ? NAN : result.r;\n  result.g = isNaN.g > 0. ? NAN : result.g;\n  result.b = isNaN.b > 0. ? NAN : result.b;\n  result.a = isNaN.a > 0. ? NAN : result.a;\n\n  return result;\n", t.shape, e.shape) : new Ba("\n  if (isnan(a)) return a;\n  if (isnan(b)) return b;\n\n  return min(a, b);\n", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ]);
    }, o.prototype.mod = function(t, e) {
        var n = i().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new La("\n  vec4 result = mod(a, b);\n  vec4 isNaN = vec4(equal(b, vec4(0.0)));\n  \n  result.r = isNaN.r > 0. ? NAN : result.r;\n  result.g = isNaN.g > 0. ? NAN : result.g;\n  result.b = isNaN.b > 0. ? NAN : result.b;\n  result.a = isNaN.a > 0. ? NAN : result.a;\n\n  return result;\n", t.shape, e.shape) : new Ba("if (b == 0.0) return NAN;\n  return mod(a, b);", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ]);
    }, o.prototype.max = function(t, e) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.max(t, e);
        Cn("max", e, t.rank);
        var n = bn(t.shape, e), r = n[0], o = k(n[1]), a = t.as2D(-1, o);
        return this.reduce(a, "max", a.dtype).reshape(r);
    }, o.prototype.maximum = function(t, e) {
        if (this.shouldExecuteOnCPU([
            t,
            e
        ])) return this.cpuBackend.maximum(t, e);
        var n = i().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new La("\n  vec4 result = vec4(max(a, b));\n  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));\n  \n  result.r = isNaN.r > 0. ? NAN : result.r;\n  result.g = isNaN.g > 0. ? NAN : result.g;\n  result.b = isNaN.b > 0. ? NAN : result.b;\n  result.a = isNaN.a > 0. ? NAN : result.a;\n\n  return result;\n", t.shape, e.shape) : new Ba("\n  if (isnan(a)) return a;\n  if (isnan(b)) return b;\n\n  return max(a, b);\n", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ]);
    }, o.prototype.all = function(t, e) {
        Cn("all", e, t.rank);
        var n = bn(t.shape, e), r = n[0], o = k(n[1]), a = t.as2D(-1, o);
        return this.reduce(a, "all", a.dtype).reshape(r);
    }, o.prototype.any = function(t, e) {
        Cn("any", e, t.rank);
        var n = bn(t.shape, e), r = n[0], o = k(n[1]), a = t.as2D(-1, o);
        return this.reduce(a, "any", a.dtype).reshape(r);
    }, o.prototype.realDivide = function(t, e) {
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, "\n  // vec4 one = vec4(equal(a, b));\n  // return one + (vec4(1.0) - one) * a / b;\n  vec4 result = a / b;\n  if(a.x == b.x) {\n    result.x = 1.;\n  }\n  if(a.y == b.y) {\n    result.y = 1.;\n  }\n  if(a.z == b.z) {\n    result.z = 1.;\n  }\n  if(a.w == b.w) {\n    result.w = 1.;\n  }\n\n  return result;\n", "float32", !0);
        var n = new Ba("\nif (a == b) {\n  return 1.0;\n};\nreturn a / b;", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ], "float32");
    }, o.prototype.floorDiv = function(t, e) {
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, "\n  ivec4 ia = round(a);\n  ivec4 ib = round(b);\n  bvec4 cond = notEqual(ib, ivec4(0));\n  ivec4 result = ivec4(0);\n  vec4 s = sign(a) * sign(b);\n\n  // Windows (D3D) wants guaranteed non-zero int division at compile-time.\n  if (cond[0]) {\n    result[0] = idiv(ia[0], ib[0], s[0]);\n  }\n  if (cond[1]) {\n    result[1] = idiv(ia[1], ib[1], s[1]);\n  }\n  if (cond[2]) {\n    result[2] = idiv(ia[2], ib[2], s[2]);\n  }\n  if (cond[3]) {\n    result[3] = idiv(ia[3], ib[3], s[3]);\n  }\n  return vec4(result);\n", "int32");
        var n = new Ba("\n  float s = sign(a) * sign(b);\n  int ia = round(a);\n  int ib = round(b);\n  if (ib != 0) {\n    // Windows (D3D) wants guaranteed non-zero int division at compile-time.\n    return float(idiv(ia, ib, s));\n  } else {\n    return NAN;\n  }\n", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ], "int32");
    }, o.prototype.add = function(t, e) {
        if ("complex64" === t.dtype && "complex64" === e.dtype) return this.complexSeparableBinaryOp(t, e, Fa);
        if (this.shouldExecuteOnCPU([
            t,
            e
        ])) return this.cpuBackend.add(t, e);
        var n = Dt(t.dtype, e.dtype);
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, Fa, n);
        var r = new Ba(Fa, t.shape, e.shape);
        return this.compileAndRun(r, [
            t,
            e
        ], n);
    }, o.prototype.packedUnaryOp = function(t, e, n) {
        var r = new Xs(t.shape, e);
        return this.compileAndRun(r, [
            t
        ], n);
    }, o.prototype.packedBinaryOp = function(t, e, n, r, o) {
        void 0 === o && (o = !1);
        var a = new La(n, t.shape, e.shape, o);
        return this.compileAndRun(a, [
            t,
            e
        ], r);
    }, o.prototype.complexSeparableBinaryOp = function(t, e, n) {
        var r = this, o = this.texData.get(t.dataId), a = this.texData.get(e.dataId), i = [
            [
                o.complexTensors.real,
                a.complexTensors.real
            ],
            [
                o.complexTensors.imag,
                a.complexTensors.imag
            ]
        ].map(function(o) {
            var a = o[0], i = o[1], s = r.makeComplexComponentTensorInfo(t, a), u = r.makeComplexComponentTensorInfo(e, i), c = new Ba(n, t.shape, e.shape);
            return r.compileAndRun(c, [
                s,
                u
            ], Dt(a.dtype, i.dtype));
        }), s = i[0], u = i[1], c = this.complex(s, u);
        return s.dispose(), u.dispose(), c;
    }, o.prototype.makeComplexComponentTensorInfo = function(t, e) {
        return {
            dataId: e.dataId,
            dtype: e.dtype,
            shape: t.shape
        };
    }, o.prototype.addN = function(t) {
        if (1 === t.length) return t[0];
        if (t.length > i().get("WEBGL_MAX_TEXTURES_IN_SHADER")) {
            var e = Math.floor(t.length / 2), n = this.addN(t.slice(0, e)), r = this.addN(t.slice(e));
            return this.addN([
                n,
                r
            ]);
        }
        var o = t.map(function(t) {
            return t.dtype;
        }).reduce(function(t, e) {
            return Dt(t, e);
        }), a = t.map(function(t) {
            return t.shape;
        }), s = i().getBool("WEBGL_PACK") ? new oa(t[0].shape, a) : new ra(t[0].shape, a);
        return this.compileAndRun(s, t, o);
    }, o.prototype.subtract = function(t, e) {
        if ("complex64" === t.dtype && "complex64" === e.dtype) return this.complexSeparableBinaryOp(t, e, _a);
        if (this.shouldExecuteOnCPU([
            t,
            e
        ])) return this.cpuBackend.subtract(t, e);
        var n = Dt(t.dtype, e.dtype);
        if (i().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, _a, t.dtype);
        var r = new Ba(_a, t.shape, e.shape);
        return this.compileAndRun(r, [
            t,
            e
        ], n);
    }, o.prototype.pow = function(t, e) {
        var n = i().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new La("\n  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.\n  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));\n  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);\n  vec4 result = multiplier * pow(abs(a), b);\n\n  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS\n  bvec4 isExpZero = equal(b, vec4(0.0));\n  result.r = isExpZero.r ? 1.0 : result.r;\n  result.g = isExpZero.g ? 1.0 : result.g;\n  result.b = isExpZero.b ? 1.0 : result.b;\n  result.a = isExpZero.a ? 1.0 : result.a;\n\n  vec4 isNaN = vec4(lessThan(a, vec4(0.0))) * vec4(lessThan(floor(b), b));\n  \n  result.r = isNaN.r > 0. ? NAN : result.r;\n  result.g = isNaN.g > 0. ? NAN : result.g;\n  result.b = isNaN.b > 0. ? NAN : result.b;\n  result.a = isNaN.a > 0. ? NAN : result.a;\n\n  return result;\n", t.shape, e.shape) : new Ba("\nif(a < 0.0 && floor(b) < b){\n  return NAN;\n}\nif (b == 0.0) {\n  return 1.0;\n}\nreturn (round(mod(b, 2.0)) != 1) ?\n    pow(abs(a), b) : sign(a) * pow(abs(a), b);\n", t.shape, e.shape), r = Dt(t.dtype, e.dtype);
        return this.compileAndRun(n, [
            t,
            e
        ], r);
    }, o.prototype.ceil = function(t) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.ceil(t);
        if (i().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, Ns, t.dtype);
        var e = new Cs(t.shape, Ns);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.floor = function(t) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.floor(t);
        if (i().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, Fs, t.dtype);
        var e = new Cs(t.shape, Fs);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.sign = function(t) {
        var e = new Cs(t.shape, "\n  if (isnan(x)) { return 0.0; }\n  return sign(x);\n");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.isNaN = function(t) {
        var e = new Cs(t.shape, "return float(isnan(x));");
        return this.compileAndRun(e, [
            t
        ], "bool");
    }, o.prototype.isInf = function(t) {
        var e = new Cs(t.shape, "return float(isinf(x));");
        return this.compileAndRun(e, [
            t
        ], "bool");
    }, o.prototype.isFinite = function(t) {
        var e = new Cs(t.shape, "return float(!isnan(x) && !isinf(x));");
        return this.compileAndRun(e, [
            t
        ], "bool");
    }, o.prototype.round = function(t) {
        var e = new Cs(t.shape, "\n  // OpenGL ES does not support round function.\n  // The algorithm is based on banker's rounding.\n  float base = floor(x);\n  if ((x - base) < 0.5) {\n    return floor(x);\n  } else if ((x - base) > 0.5) {\n    return ceil(x);\n  } else {\n    if (mod(base, 2.0) == 0.0) {\n      return base;\n    } else {\n      return base + 1.0;\n    }\n  }\n");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.exp = function(t) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.exp(t);
        if (i().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, _s, t.dtype);
        var e = new Cs(t.shape, _s);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.expm1 = function(t) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.expm1(t);
        if (i().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, Os, t.dtype);
        var e = new Cs(t.shape, Os);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.softmax = function(t, e) {
        var n = O([
            e
        ], t.shape), r = this.max(t, n), o = wn(r.shape, n), a = this.subtract(t, r.reshape(o)), i = this.exp(a), s = this.sum(i, n).reshape(o);
        return this.realDivide(i, s);
    }, o.prototype.log = function(t) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.log(t);
        if (i().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, "\n  vec4 result = log(x);\n  vec4 isNaN = vec4(lessThan(x, vec4(0.0)));\n  result.r = isNaN.r == 1.0 ? NAN : result.r;\n  result.g = isNaN.g == 1.0 ? NAN : result.g;\n  result.b = isNaN.b == 1.0 ? NAN : result.b;\n  result.a = isNaN.a == 1.0 ? NAN : result.a;\n\n  return result;\n", t.dtype);
        var e = new Cs(t.shape, "if (x < 0.0) return NAN;\n  return log(x);");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.log1p = function(t) {
        var e = new Cs(t.shape, "return log(1.0 + x);");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.sqrt = function(t) {
        var e = new Cs(t.shape, "return sqrt(x);");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.rsqrt = function(t) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.rsqrt(t);
        var e = new Cs(t.shape, "return inversesqrt(x);");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.reciprocal = function(t) {
        var e = new Cs(t.shape, "return 1.0 / x;");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.relu = function(t) {
        var e;
        return e = i().getBool("WEBGL_PACK") ? new Xs(t.shape, qs) : new Cs(t.shape, ks), this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.relu6 = function(t) {
        var e;
        return e = i().getBool("WEBGL_PACK") ? new Xs(t.shape, Ks) : new Cs(t.shape, Ss), this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.prelu = function(t, e) {
        var n = i().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new La(Pa, t.shape, e.shape) : new Ba(Ma, t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ]);
    }, o.prototype.elu = function(t) {
        if (i().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, js, t.dtype);
        var e = new Cs(t.shape, As);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.eluDer = function(t, e) {
        var n = i().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new La("\n  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));\n  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));\n", t.shape, e.shape) : new Ba("return (b >= 1.0) ? a : a * (b + 1.0);", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ]);
    }, o.prototype.selu = function(t) {
        var e = new Cs(t.shape, Ds);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.int = function(t) {
        var e = new Cs(t.shape, "return float(int(x));");
        return this.compileAndRun(e, [
            t
        ], "int32");
    }, o.prototype.clip = function(t, e, n) {
        var r, o = (r = i().getBool("WEBGL_PACK_CLIP") ? new Ua(t.shape) : new Wa(t.shape)).getCustomSetupFunc(e, n);
        return this.compileAndRun(r, [
            t
        ], null, o);
    }, o.prototype.abs = function(t) {
        if (this.shouldExecuteOnCPU([
            t
        ])) return this.cpuBackend.abs(t);
        if (i().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, Is, t.dtype);
        var e = new Cs(t.shape, Is);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.complexAbs = function(t) {
        var e = this.texData.get(t.dataId), n = new Va(t.shape), r = [
            this.makeComplexComponentTensorInfo(t, e.complexTensors.real),
            this.makeComplexComponentTensorInfo(t, e.complexTensors.imag)
        ];
        return this.compileAndRun(n, r);
    }, o.prototype.sigmoid = function(t) {
        var e = new Cs(t.shape, "return 1.0 / (1.0 + exp(-1.0 * x));");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.softplus = function(t) {
        var e = new Cs(t.shape, "\n  float epsilon = 1.1920928955078125e-7;\n  float threshold = log(epsilon) + 2.0;\n\n  bool too_large = x > -threshold;\n  bool too_small = x < threshold;\n\n  float result;\n  float exp_x = exp(x);\n\n  if (too_large){\n    result = x;\n  }\n  else if (too_small){\n    result = exp_x;\n  }\n  else{\n    result = log(exp_x + 1.0);\n  }\n  return result;\n");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.sin = function(t) {
        var e = new Cs(t.shape, Ms);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.cos = function(t) {
        var e = new Cs(t.shape, Bs);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.tan = function(t) {
        var e = new Cs(t.shape, "return tan(x);");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.asin = function(t) {
        var e = new Cs(t.shape, Ps);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.acos = function(t) {
        var e = new Cs(t.shape, Ls);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.atan = function(t) {
        var e = new Cs(t.shape, Ws);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.atan2 = function(t, e) {
        var n = i().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new La("\n  vec4 result = atan(a, b);\n  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));\n  \n  result.r = isNaN.r > 0. ? NAN : result.r;\n  result.g = isNaN.g > 0. ? NAN : result.g;\n  result.b = isNaN.b > 0. ? NAN : result.b;\n  result.a = isNaN.a > 0. ? NAN : result.a;\n\n  return result;\n", t.shape, e.shape) : new Ba("\n  if (isnan(a)) return a;\n  if (isnan(b)) return b;\n\n  return atan(a, b);\n", t.shape, e.shape);
        return this.compileAndRun(n, [
            t,
            e
        ]);
    }, o.prototype.sinh = function(t) {
        var e = new Cs(t.shape, "\n  float e2x = exp(x);\n  return (e2x - 1.0 / e2x) / 2.0;\n");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.cosh = function(t) {
        var e = new Cs(t.shape, "\n  float e2x = exp(-x);\n  return (e2x + 1.0 / e2x) / 2.0;\n");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.tanh = function(t) {
        var e = new Cs(t.shape, "\n  float e2x = exp(-2.0 * abs(x));\n  return sign(x) * (1.0 - e2x) / (1.0 + e2x);\n");
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.asinh = function(t) {
        var e = new Cs(t.shape, Us);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.acosh = function(t) {
        var e = new Cs(t.shape, Vs);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.atanh = function(t) {
        var e = new Cs(t.shape, zs);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.erf = function(t) {
        var e = new Cs(t.shape, '\n  // Error function is calculated approximately with elementary function.\n  // See "Handbook of Mathematical Functions with Formulas,\n  // Graphs, and Mathematical Tables", Abramowitz and Stegun.\n  float p = 0.3275911;\n  float a1 = 0.254829592;\n  float a2 = -0.284496736;\n  float a3 = 1.421413741;\n  float a4 = -1.453152027;\n  float a5 = 1.061405429;\n\n  float sign = sign(x);\n  x = abs(x);\n  float t = 1.0 / (1.0 + p * x);\n  return sign * (1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x));\n');
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.step = function(t, e) {
        var n = new Cs(t.shape, function(t) {
            return void 0 === t && (t = 0), Es + "\n    return x > 0.0 ? 1.0 : float(" + t + ");\n  ";
        }(e));
        return this.compileAndRun(n, [
            t
        ]);
    }, o.prototype.conv2dByMatMul = function(t, e, n, r, o, a) {
        var s = t.shape, u = this.texData.get(t.dataId), c = n.inChannels, l = s[0] * s[1] * s[2], h = n.outChannels, f = "channelsLast" === n.dataFormat, d = (1 === l || 1 === h) && c > 1e3, p = s[2] % 2 != 0 && !!u.isPacked;
        if (d || !i().getBool("WEBGL_LAZILY_UNPACK") || !i().getBool("WEBGL_PACK_BINARY_OPERATIONS") || !p) {
            var v = f ? s[0] * s[1] * s[2] : s[0] * s[2] * s[3], m = this.reshape(t, [
                1,
                v,
                n.inChannels
            ]), g = this.reshape(e, [
                1,
                n.inChannels,
                n.outChannels
            ]);
            return this.reshape(this.fusedBatchMatMul({
                a: m,
                b: g,
                transposeA: !1,
                transposeB: !1,
                bias: r,
                activation: o,
                preluActivationWeights: a
            }), n.outShape);
        }
        var y = f ? s[0] * s[1] * (s[2] + 1) : s[0] * s[2] * (s[3] + 1), x = {
            dataId: t.dataId,
            shape: [
                1,
                y,
                n.inChannels
            ],
            dtype: t.dtype
        }, b = u.shape;
        u.shape = u.shape.slice(), u.shape[u.shape.length - 2]++, C(_e(u.shape, x.shape), function() {
            return "packed reshape " + u.shape + " to " + x.shape + " isn't free";
        });
        var w = this.reshape(e, [
            1,
            n.inChannels,
            n.outChannels
        ]), E = this.fusedBatchMatMul({
            a: x,
            b: w,
            transposeA: !1,
            transposeB: !1,
            bias: r,
            activation: o,
            preluActivationWeights: a
        }), R = this.texData.get(E.dataId);
        return C(R.isPacked, function() {
            return "batchMatMul result is expected to be packed";
        }), u.shape = b, R.shape = n.outShape, Lt.makeTensorFromDataId(E.dataId, n.outShape, E.dtype);
    }, o.prototype.conv2dWithIm2Row = function(t, e, n, r, o, a) {
        var i = n.filterWidth, s = n.filterHeight, u = n.inChannels, c = n.outWidth, l = n.outHeight, h = "channelsLast" === n.dataFormat, f = i * s * u, d = l * c, p = [
            f,
            d
        ], v = t.squeeze([
            0
        ]), m = e.reshape([
            1,
            f,
            -1
        ]), g = new Li(p, v.shape, n), y = this.compileAndRun(g, [
            v
        ]).reshape([
            1,
            p[0],
            p[1]
        ]), x = null != r, b = null != a, w = o ? Qs(o, !0) : null, C = new Hi(y.shape, [
            1,
            d,
            n.outChannels
        ], !0, !1, x, w, b), E = [
            y,
            m
        ];
        r && E.push(r), b && E.push(a);
        var R = this.compileAndRun(C, E);
        return h ? R.reshape([
            1,
            l,
            c,
            n.outChannels
        ]) : R.reshape([
            1,
            n.outChannels,
            l,
            c
        ]);
    }, o.prototype.fusedConv2d = function(t) {
        var e = t.input, n = t.filter, r = t.convInfo, o = t.bias, a = t.activation, s = t.preluActivationWeights;
        if (1 === r.filterHeight && 1 === r.filterWidth && 1 === r.dilationHeight && 1 === r.dilationWidth && 1 === r.strideHeight && 1 === r.strideWidth && ("SAME" === r.padInfo.type || "VALID" === r.padInfo.type)) return this.conv2dByMatMul(e, n, r, o, a, s);
        if (i().getBool("WEBGL_CONV_IM2COL") && 1 === e.shape[0]) return this.conv2dWithIm2Row(e, n, r, o, a, s);
        var u = null != o, c = null != s, l = a ? Qs(a, !1) : null, h = new Qa(r, u, l, c), f = [
            e,
            n
        ];
        return o && f.push(o), s && f.push(s), this.compileAndRun(h, f);
    }, o.prototype.conv2d = function(t, e, n) {
        if (1 === n.filterHeight && 1 === n.filterWidth && 1 === n.dilationHeight && 1 === n.dilationWidth && 1 === n.strideHeight && 1 === n.strideWidth && ("SAME" === n.padInfo.type || "VALID" === n.padInfo.type)) return this.conv2dByMatMul(t, e, n);
        if (i().getBool("WEBGL_CONV_IM2COL") && 1 === t.shape[0]) return this.conv2dWithIm2Row(t, e, n);
        var r = new Qa(n);
        return this.compileAndRun(r, [
            t,
            e
        ]);
    }, o.prototype.conv2dDerInput = function(t, e, n) {
        var r = new Ka(n);
        return this.compileAndRun(r, [
            t,
            e
        ]);
    }, o.prototype.conv2dDerFilter = function(t, e, n) {
        var r = new qa(n);
        return this.compileAndRun(r, [
            t,
            e
        ]);
    }, o.prototype.fusedDepthwiseConv2D = function(t) {
        var e, n = t.input, r = t.filter, o = t.convInfo, a = t.bias, s = t.activation, u = t.preluActivationWeights, c = i().getBool("WEBGL_PACK_DEPTHWISECONV") && o.strideWidth <= 2 && o.outChannels / o.inChannels == 1, l = s ? Qs(s, c) : null, h = [
            n,
            r
        ], f = null != a, d = null != u;
        return f && h.push(a), d && h.push(u), c ? (e = new ti(o, f, l, d), this.compileAndRun(e, h)) : (e = new Za(o, f, l, d), this.compileAndRun(e, h));
    }, o.prototype.depthwiseConv2D = function(t, e, n) {
        var r;
        return i().getBool("WEBGL_PACK_DEPTHWISECONV") && n.strideWidth <= 2 && n.outChannels / n.inChannels == 1 ? (r = new ti(n), this.compileAndRun(r, [
            t,
            e
        ])) : (r = new Za(n), this.compileAndRun(r, [
            t,
            e
        ]));
    }, o.prototype.depthwiseConv2DDerInput = function(t, e, n) {
        var r = new $a(n);
        return this.compileAndRun(r, [
            t,
            e
        ]);
    }, o.prototype.depthwiseConv2DDerFilter = function(t, e, n) {
        var r = new Ya(n);
        return this.compileAndRun(r, [
            t,
            e
        ]);
    }, o.prototype.conv3d = function(t, e, n) {
        var r = new Ja(n);
        return this.compileAndRun(r, [
            t,
            e
        ]);
    }, o.prototype.conv3dDerInput = function(t, e, n) {
        var r = new Xa(n);
        return this.compileAndRun(r, [
            t,
            e
        ]);
    }, o.prototype.conv3dDerFilter = function(t, e, n) {
        var r = new ja(n);
        return this.compileAndRun(r, [
            t,
            e
        ]);
    }, o.prototype.maxPool = function(t, e) {
        var n = new $i(e, "max", !1);
        return this.compileAndRun(n, [
            t
        ]);
    }, o.prototype.avgPool = function(t, e) {
        var n = new $i(e, "avg", !1);
        return this.compileAndRun(n, [
            t
        ], "float32");
    }, o.prototype.maxPoolBackprop = function(t, e, n, r) {
        var o = new $i(r, "max", !0), a = this.compileAndRun(o, [
            e
        ]), i = new zi(r), s = this.compileAndRun(i, [
            t,
            a
        ], e.dtype);
        return a.dispose(), s;
    }, o.prototype.avgPoolBackprop = function(t, e, n) {
        var r = new Ia(n);
        return this.compileAndRun(r, [
            t
        ], e.dtype);
    }, o.prototype.cast = function(t, e) {
        return Po(t, e, this);
    }, o.prototype.unstack = function(t, e) {
        for(var n = t.shape[e], r = new Array(t.rank - 1), o = 0, a = 0; a < t.rank; a++)a !== e && (r[o++] = t.shape[a]);
        var i = new Array(t.rank).fill(0), s = t.shape.slice();
        s[e] = 1;
        var u = new Array(n);
        for(a = 0; a < u.length; a++)i[e] = a, u[a] = this.slice(t, i, s).reshape(r);
        return u;
    }, o.prototype.avgPool3d = function(t, e) {
        var n = new Qi(e, "avg", !1);
        return this.compileAndRun(n, [
            t
        ], "float32");
    }, o.prototype.avgPool3dBackprop = function(t, e, n) {
        var r = new ka(n);
        return this.compileAndRun(r, [
            t
        ], e.dtype);
    }, o.prototype.maxPool3d = function(t, e) {
        var n = new Qi(e, "max", !1);
        return this.compileAndRun(n, [
            t
        ], "float32");
    }, o.prototype.maxPool3dBackprop = function(t, e, n, r) {
        var o = new Qi(r, "max", !0), a = this.compileAndRun(o, [
            e
        ]), i = new Gi(r), s = this.compileAndRun(i, [
            t,
            a
        ], e.dtype);
        return a.dispose(), s;
    }, o.prototype.reshape = function(t, e) {
        var n = this.texData.get(t.dataId);
        if (n.isPacked && !_e(t.shape, e) && (null === n.texture || !_e(n.shape, e))) {
            var r = this.packedReshape(t, e);
            return Lt.makeTensorFromDataId(r.dataId, r.shape, r.dtype);
        }
        return Lo(t, e);
    }, o.prototype.resizeBilinear = function(t, e, n, r) {
        var o = i().getBool("WEBGL_PACK_IMAGE_OPERATIONS") ? new ns(t.shape, e, n, r) : new es(t.shape, e, n, r);
        return this.compileAndRun(o, [
            t
        ], "float32");
    }, o.prototype.resizeBilinearBackprop = function(t, e, n) {
        var r = new ts(t, e, n);
        return this.compileAndRun(r, [
            t
        ]);
    }, o.prototype.resizeNearestNeighbor = function(t, e, n, r) {
        var o = new os(t.shape, e, n, r);
        return this.compileAndRun(o, [
            t
        ]);
    }, o.prototype.resizeNearestNeighborBackprop = function(t, e, n) {
        var r = new rs(t, e, n);
        return this.compileAndRun(r, [
            t
        ]);
    }, o.prototype.multinomial = function(t, e, n, r) {
        var o = e ? t : go(t), a = o.shape[0], i = o.shape[1], s = new qi(a, i, n), u = s.getCustomSetupFunc(r);
        return this.compileAndRun(s, [
            o
        ], "int32", u);
    }, o.prototype.oneHot = function(t, e, n, r) {
        var o = new Ki(t.size, e, n, r);
        return this.compileAndRun(o, [
            t
        ]);
    }, o.prototype.diag = function(t) {
        var e = new si(t.size);
        return this.compileAndRun(e, [
            t
        ]);
    }, o.prototype.nonMaxSuppression = function(t, e, n, r, o) {
        return dn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead"), jo(t.dataSync(), e.dataSync(), n, r, o);
    }, o.prototype.cropAndResize = function(t, e, n, r, o, a) {
        var i = new ei(t.shape, e.shape, r, o, a);
        return this.compileAndRun(i, [
            t,
            e,
            n
        ], "float32");
    }, o.prototype.depthToSpace = function(t, e, n) {
        C(e > 1, function() {
            return "blockSize should be > 1 for depthToSpace, but was: " + e;
        });
        var r = t.shape[0], o = "NHWC" === n ? t.shape[1] : t.shape[2], a = "NHWC" === n ? t.shape[2] : t.shape[3], i = "NHWC" === n ? t.shape[3] : t.shape[1], s = o * e, u = a * e, c = i / (e * e), l = new ii("NHWC" === n ? [
            r,
            s,
            u,
            c
        ] : [
            r,
            c,
            s,
            u
        ], e, n);
        return this.compileAndRun(l, [
            t
        ]);
    }, o.prototype.split = function(t, e, n) {
        return Zo(t, e, n);
    }, o.prototype.scatterND = function(t, e, n) {
        var r = Zr(0, t, n), o = r.sliceRank, a = r.numUpdates, i = r.sliceSize, s = r.strides, u = r.outputSize, c = [
            u / i,
            i
        ], l = t.reshape([
            a,
            o
        ]), h = e.reshape([
            a,
            i
        ]);
        if (0 === u) return Lo(Fn([]), n);
        var f = On(0), d = new ss(a, o, l.rank, h.rank, s, c);
        return this.compileAndRun(d, [
            h,
            l,
            f
        ]).reshape(n);
    }, o.prototype.sparseToDense = function(t, e, n, r) {
        var o = Zr(0, t, n), a = o.sliceRank, i = o.numUpdates, s = o.strides, u = o.outputSize, c = new ss(i, a, t.rank, e.rank, s, [
            u,
            1
        ], !1);
        return this.compileAndRun(c, [
            e,
            t,
            r
        ]).reshape(n);
    }, o.prototype.fft = function(t) {
        return this.fftImpl(t, !1);
    }, o.prototype.ifft = function(t) {
        return this.fftImpl(t, !0);
    }, o.prototype.fftImpl = function(t, e) {
        var n = this.texData.get(t.dataId), r = new pi(fi, t.shape, e), o = new pi(di, t.shape, e), a = [
            this.makeComplexComponentTensorInfo(t, n.complexTensors.real),
            this.makeComplexComponentTensorInfo(t, n.complexTensors.imag)
        ], i = this.compileAndRun(r, a), s = this.compileAndRun(o, a), u = this.complex(i, s).as2D(t.shape[0], t.shape[1]);
        return i.dispose(), s.dispose(), u;
    }, o.prototype.gatherND = function(t, e) {
        var n = e.shape, r = n[n.length - 1], o = jr(t, e), a = o[0], i = o[1], s = o[2], u = o[3], c = e.reshape([
            i,
            r
        ]), l = t.reshape([
            t.size / s,
            s
        ]), h = new gi(r, u, [
            i,
            s
        ]);
        return this.compileAndRun(h, [
            l,
            c
        ]).reshape(a);
    }, o.prototype.fill = function(t, e, n) {
        if ("string" === (n = n || j(e))) {
            var r = P(n, k(t));
            return r.fill(e), Lt.makeTensor(r, t, n, this);
        }
        var o = new vi(t, e), a = o.getCustomSetupFunc(e);
        return this.compileAndRun(o, [], n, a);
    }, o.prototype.onesLike = function(t) {
        if ("string" === t.dtype) throw new Error("onesLike is not supported under string dtype");
        return this.fill(t.shape, 1, t.dtype);
    }, o.prototype.zerosLike = function(t) {
        return this.fill(t.shape, "string" === t.dtype ? "" : 0, t.dtype);
    }, o.prototype.linspace = function(t, e, n) {
        return Wo(t, e, n);
    }, o.prototype.makeTensorInfo = function(t, e) {
        var n = this.write(null, t, e);
        return this.texData.get(n).usage = null, {
            dataId: n,
            shape: t,
            dtype: e
        };
    }, o.prototype.makeOutput = function(t, e) {
        var n = this.makeTensorInfo(t, e).dataId;
        return Lt.makeTensorFromDataId(n, t, e, this);
    }, o.prototype.unpackTensor = function(t) {
        var e = new Ys(t.shape);
        return this.runWebGLProgram(e, [
            t
        ], t.dtype);
    }, o.prototype.packTensor = function(t) {
        var e = new ji(t.shape);
        return this.runWebGLProgram(e, [
            t
        ], t.dtype, null, !0);
    }, o.prototype.packedReshape = function(t, e) {
        var n = [
            Ae(t.shape)
        ].concat(De(t.shape)), r = {
            dtype: t.dtype,
            shape: n,
            dataId: t.dataId
        }, o = [
            Ae(e)
        ].concat(De(e)), a = new Zi(o, n), i = this.runWebGLProgram(a, [
            r
        ], t.dtype, null, !0);
        return {
            dataId: i.dataId,
            shape: e,
            dtype: i.dtype
        };
    }, o.prototype.decode = function(t) {
        var e, n = this.texData.get(t), r = n.isPacked, o = n.shape, a = n.dtype, i = Te(o);
        e = r ? new ai(i) : new oi(i);
        return {
            dtype: a,
            shape: o,
            dataId: this.runWebGLProgram(e, [
                {
                    shape: i,
                    dtype: a,
                    dataId: t
                }
            ], a, null, !0).dataId
        };
    }, o.prototype.runWebGLProgram = function(t, e, n, r, o) {
        var a = this;
        void 0 === o && (o = !1);
        var s = this.makeTensorInfo(t.outputShape, n), u = this.texData.get(s.dataId);
        if (t.packedOutput && (u.isPacked = !0), t.outPackingScheme === Vt.DENSE) {
            var c = Yt(t.outputShape);
            u.texShape = c.map(function(t) {
                return 2 * t;
            });
        }
        if (null != t.outTexUsage && (u.usage = t.outTexUsage), 0 === k(s.shape)) return u.values = B(s.dtype, 0), s;
        var l = [], h = e.map(function(e) {
            if ("complex64" === e.dtype) throw new Error("GPGPUProgram does not support complex64 input. For complex64 dtypes, please separate the program into real and imaginary parts.");
            var n = a.texData.get(e.dataId);
            if (null == n.texture) {
                if (!t.packedInputs && k(e.shape) <= i().getNumber("WEBGL_SIZE_UPLOAD_UNIFORM")) return {
                    shape: e.shape,
                    texData: null,
                    isUniform: !0,
                    uniformValues: n.values
                };
                t.packedInputs && (n.isPacked = !0, n.shape = e.shape);
            } else if (!!n.isPacked != !!t.packedInputs) e = n.isPacked ? a.unpackTensor(e) : a.packTensor(e), l.push(e), n = a.texData.get(e.dataId);
            else if (n.isPacked && !_e(n.shape, e.shape)) {
                var r = e, o = e.shape;
                e.shape = n.shape, e = a.packedReshape(e, o), l.push(e), n = a.texData.get(e.dataId), r.shape = o;
            }
            return a.uploadToGPU(e.dataId), {
                shape: e.shape,
                texData: n,
                isUniform: !1
            };
        });
        this.uploadToGPU(s.dataId);
        var f, d = {
            shape: s.shape,
            texData: u,
            isUniform: !1
        }, p = function(t, e, n) {
            var r = "";
            e.concat(n).forEach(function(t) {
                var e = null != t.texData && null != t.texData.slice && t.texData.slice.flatOffset > 0, n = t.isUniform ? "uniform" : t.texData.texShape;
                r += t.shape + "_" + n + "_" + e;
            });
            var o = t.userCode, a = t.constructor.name;
            return a += "_" + r + "_" + o;
        }(t, h, d), v = this.getAndSaveBinary(p, function() {
            return function(t, e, n, r) {
                var o = e.userCode, a = n.map(function(t, n) {
                    var r = {
                        logicalShape: t.shape,
                        texShape: t.isUniform ? null : t.texData.texShape,
                        isUniform: t.isUniform,
                        isPacked: !t.isUniform && t.texData.isPacked,
                        flatOffset: null
                    };
                    return null != t.texData && null != t.texData.slice && t.texData.slice.flatOffset > 0 && (r.flatOffset = t.texData.slice.flatOffset), {
                        name: e.variableNames[n],
                        shapeInfo: r
                    };
                }), s = a.map(function(t) {
                    return t.shapeInfo;
                }), u = {
                    logicalShape: r.shape,
                    texShape: r.texData.texShape,
                    isUniform: !1,
                    isPacked: r.texData.isPacked,
                    flatOffset: null
                }, c = fa(a, u, o, e.packedInputs), l = t.createProgram(c), h = null, f = t.getUniformLocation(l, "NAN", !1);
                1 === i().getNumber("WEBGL_VERSION") && (h = t.getUniformLocation(l, "INFINITY", !1));
                for(var d = {}, p = 0; p < e.variableNames.length; p++){
                    var v = e.variableNames[p];
                    d[v] = t.getUniformLocation(l, v, !1), d["offset" + v] = t.getUniformLocation(l, "offset" + v, !1);
                }
                return {
                    program: e,
                    source: c,
                    webGLProgram: l,
                    uniformLocations: d,
                    inShapeInfos: s,
                    outShapeInfo: u,
                    infLoc: h,
                    nanLoc: f
                };
            }(a.gpgpu, t, h, d);
        }), m = null != this.activeTimers;
        if (m && (f = this.startTimer()), function(t, e, n, r, o) {
            Pi(e.inShapeInfos, n), Pi([
                e.outShapeInfo
            ], [
                r
            ]);
            var a = r.texData.texture, s = r.texData.texShape;
            r.texData.isPacked ? t.setOutputPackedMatrixTexture(a, s[0], s[1]) : t.setOutputMatrixTexture(a, s[0], s[1]), t.setProgram(e.webGLProgram), 1 === i().getNumber("WEBGL_VERSION") && null !== e.infLoc && t.gl.uniform1f(e.infLoc, 1 / 0), null !== e.nanLoc && t.gl.uniform1f(e.nanLoc, NaN), n.forEach(function(n, r) {
                var o = e.program.variableNames[r], a = e.uniformLocations[o], i = e.uniformLocations["offset" + o];
                if (null != a) {
                    if (n.isUniform) {
                        if (k(n.shape) < 2) t.gl.uniform1f(a, n.uniformValues[0]);
                        else {
                            var s = n.uniformValues;
                            s instanceof Float32Array || (s = new Float32Array(s)), t.gl.uniform1fv(a, s);
                        }
                    } else null != n.texData.slice && null != i && t.gl.uniform1i(i, n.texData.slice.flatOffset), t.setInputMatrixTexture(n.texData.texture, a, r);
                }
            }), null != o && o(t, e.webGLProgram), t.executeProgram();
        }(this.gpgpu, v, h, d, r), l.forEach(function(t) {
            return a.disposeData(t.dataId);
        }), m && (f = this.endTimer(f), this.activeTimers.push({
            name: t.constructor.name,
            query: this.getQueryTime(f)
        })), !i().getBool("WEBGL_LAZILY_UNPACK") && u.isPacked && !1 === o) {
            var g = this.unpackTensor(s);
            return this.disposeData(s.dataId), g;
        }
        return s;
    }, o.prototype.compileAndRun = function(t, e, n, r, o) {
        void 0 === o && (o = !1), n = n || e[0].dtype;
        var a = this.runWebGLProgram(t, e, n, r, o);
        return Lt.makeTensorFromDataId(a.dataId, a.shape, a.dtype);
    }, o.prototype.getAndSaveBinary = function(t, e) {
        return t in this.binaryCache || (this.binaryCache[t] = e()), this.binaryCache[t];
    }, o.prototype.getTextureManager = function() {
        return this.textureManager;
    }, o.prototype.dispose = function() {
        var t = this;
        if (!this.disposed) {
            if (!i().getBool("IS_TEST")) Object.keys(this.binaryCache).forEach(function(e) {
                t.gpgpu.deleteProgram(t.binaryCache[e].webGLProgram), delete t.binaryCache[e];
            });
            this.textureManager.dispose(), null != this.canvas && "undefined" != typeof HTMLCanvasElement && this.canvas instanceof HTMLCanvasElement ? this.canvas.remove() : this.canvas = null, this.gpgpuCreatedLocally && (this.gpgpu.program = null, this.gpgpu.dispose()), this.disposed = !0;
        }
    }, o.prototype.floatPrecision = function() {
        var t = this;
        return null == this.floatPrecisionValue && (this.floatPrecisionValue = Ze(function() {
            if (!i().get("WEBGL_RENDER_FLOAT32_ENABLED")) {
                var e = i().getBool("DEBUG");
                i().set("DEBUG", !1);
                var n = t.abs(On(1e-8)).dataSync()[0];
                if (i().set("DEBUG", e), n > 0) return 32;
            }
            return 16;
        })), this.floatPrecisionValue;
    }, o.prototype.epsilon = function() {
        return 32 === this.floatPrecision() ? 1e-7 : 1e-4;
    }, o.prototype.uploadToGPU = function(t) {
        var e, n = this.texData.get(t), r = n.shape, o = n.dtype, a = n.values, i = n.texture, s = n.usage, u = n.isPacked;
        if (null == i) {
            var c, l = null != this.activeTimers;
            l && (c = et());
            var h = n.texShape;
            if (null == h && (h = Ne(r, u), n.texShape = h), null != a) {
                var f = Te(r), d = void 0, p = h[1], v = h[0], m = a instanceof Uint8Array;
                u ? (p = (e = $t(h[0], h[1]))[0], v = e[1], d = new hi(f, [
                    v,
                    p
                ], m)) : d = new li(f, [
                    v,
                    p
                ], m);
                var g = this.makeTensorInfo([
                    v,
                    p
                ], o);
                this.texData.get(g.dataId).usage = m ? zt.PIXELS : zt.UPLOAD, this.gpgpu.uploadDenseMatrixToTexture(this.getTexture(g.dataId), p, v, a);
                var y = this.runWebGLProgram(d, [
                    g
                ], o, null, !0), x = this.texData.get(y.dataId);
                n.texture = x.texture, n.texShape = x.texShape, n.isPacked = x.isPacked, n.usage = x.usage, this.disposeData(g.dataId), this.texData.delete(y.dataId), n.values = null, l && (this.uploadWaitMs += et() - c);
            } else {
                var b = this.acquireTexture(h, s, o, u);
                n.texture = b;
            }
        }
    }, o.prototype.convertAndCacheOnCPU = function(t, e) {
        var n = this.texData.get(t), r = n.dtype;
        return this.releaseGPUData(t), null != e && (n.values = function(t, e) {
            if ("float32" === e || "complex64" === e) return t;
            if ("int32" === e || "bool" === e) {
                for(var n = "int32" === e ? new Int32Array(t.length) : new Uint8Array(t.length), r = 0; r < n.length; ++r)n[r] = Math.round(t[r]);
                return n;
            }
            throw new Error("Unknown dtype " + e);
        }(e, r)), n.values;
    }, o.prototype.acquireTexture = function(t, e, n, r) {
        if (this.numBytesInGPU += this.computeBytes(t, n), !this.warnedAboutMemory && this.numBytesInGPU > 1024 * this.numMBBeforeWarning * 1024) {
            var o = (this.numBytesInGPU / 1024 / 1024).toFixed(2);
            this.warnedAboutMemory = !0, console.warn("High memory usage in GPU: " + o + " MB, most likely due to a memory leak");
        }
        return this.textureManager.acquireTexture(t, e, r);
    }, o.prototype.computeBytes = function(t, e) {
        return t[0] * t[1] * z(e);
    }, o;
}(bo);
Wt() && Lt.registerBackend("webgl", function() {
    return new Zs;
}, 2);
var tu = An({
    square_: function(t) {
        var e = mn(t, "x", "square"), n = [
            e
        ];
        return Lt.runKernelFunc(function(t, n) {
            return n([
                e
            ]), t.square(e);
        }, {
            x: e
        }, null, "Square", {}, n, []);
    }
}), eu = "SquaredDifference";
var nu = An({
    squaredDifference_: function(t, e) {
        var n, r = mn(t, "a", "squaredDifference"), o = mn(e, "b", "squaredDifference");
        n = Nt(r, o), r = n[0], o = n[1], Ro(r.shape, o.shape);
        var a = {
            a: r,
            b: o
        }, i = [
            r,
            o
        ];
        return Lt.runKernelFunc(function(t, e) {
            var n = t.squaredDifference(r, o);
            return e([
                r,
                o
            ]), n;
        }, a, function(t, e) {
            var n = e[0], r = e[1], o = On(2);
            return {
                a: function() {
                    return t.mul(n.sub(r).mul(o));
                },
                b: function() {
                    return t.mul(r.sub(n).mul(o));
                }
            };
        }, eu, {}, i, []);
    }
});
var ru = An({
    abs_: function(t) {
        var e = mn(t, "x", "abs");
        return "complex64" === e.dtype ? Lt.runKernelFunc(function(t) {
            return t.complexAbs(e);
        }, {
            $x: e
        }) : Lt.runKernelFunc(function(t, n) {
            var r = t.abs(e);
            return n([
                e
            ]), r;
        }, {
            x: e
        }, function(t, e) {
            var n = e[0];
            return {
                x: function() {
                    return t.mul(n.toFloat().step(-1));
                }
            };
        }, "Abs");
    }
}), ou = An({
    acos_: function(t) {
        var e = mn(t, "x", "acos");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.acos(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.divStrict(On(1).sub(n.toFloat().square()).sqrt()).neg();
                }
            };
        });
    }
}), au = An({
    acosh_: function(t) {
        var e = mn(t, "x", "acosh");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.acosh(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.divStrict(n.toFloat().square().sub(1).sqrt());
                }
            };
        });
    }
}), iu = An({
    asin_: function(t) {
        var e = mn(t, "x", "asin");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.asin(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.divStrict(On(1).sub(n.toFloat().square()).sqrt());
                }
            };
        });
    }
}), su = An({
    asinh_: function(t) {
        var e = mn(t, "x", "asinh");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.asinh(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.divStrict(On(1).add(n.toFloat().square()).sqrt());
                }
            };
        });
    }
}), uu = An({
    atan_: function(t) {
        var e = mn(t, "x", "atan");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.atan(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.div(n.toFloat().square().add(1));
                }
            };
        });
    }
}), cu = An({
    atanh_: function(t) {
        var e = mn(t, "x", "atanh");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.atanh(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.div(On(1).sub(n.toFloat().square()));
                }
            };
        });
    }
}), lu = An({
    ceil_: function(t) {
        var e = mn(t, "x", "ceil");
        return Lt.runKernelFunc(function(t) {
            return t.ceil(e);
        }, {
            $x: e
        }, function(t) {
            return {
                $x: function() {
                    return Xn(t);
                }
            };
        });
    }
}), hu = An({
    clipByValue_: function(t, e, n) {
        var r = mn(t, "x", "clipByValue");
        C(e <= n, function() {
            return "Error in clip: min (" + e + ") must be less than or equal to max (" + n + ").";
        });
        var o = [
            r
        ], a = {
            min: e,
            max: n
        };
        return Lt.runKernelFunc(function(t, o) {
            var a = t.clip(r, e, n);
            return o([
                r
            ]), a;
        }, {
            x: r
        }, function(t, r) {
            var o = r[0];
            return {
                x: function() {
                    return t.where(o.greaterEqual(e).logicalAnd(o.lessEqual(n)), Xn(t));
                }
            };
        }, "ClipByValue", a, o);
    }
}), fu = An({
    cos_: function(t) {
        var e = mn(t, "x", "cos"), n = [
            e
        ];
        return Lt.runKernelFunc(function(t, n) {
            var r = t.cos(e);
            return n([
                e
            ]), r;
        }, {
            x: e
        }, function(t, e) {
            var n = e[0];
            return {
                x: function() {
                    return n.toFloat().sin().neg().mul(t);
                }
            };
        }, "Cos", {}, n);
    }
}), du = An({
    cosh_: function(t) {
        var e = mn(t, "x", "cosh");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.cosh(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return n.toFloat().sinh().mulStrict(t);
                }
            };
        });
    }
}), pu = An({
    erf_: function(t) {
        var e = mn(t, "x", "erf");
        return C("int32" === e.dtype || "float32" === e.dtype, function() {
            return "Input dtype must be `int32` or `float32`.";
        }), "int32" === e.dtype && (e = e.toFloat()), Lt.runKernelFunc(function(t, n) {
            var r = t.erf(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.mul(n.square().neg().exp().mul(2 / Math.sqrt(Math.PI)));
                }
            };
        });
    }
}), vu = An({
    exp_: function(t) {
        var e = mn(t, "x", "exp");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.exp(e);
            return n([
                r
            ]), r;
        }, {
            x: e
        }, function(t, e) {
            return {
                x: function() {
                    return t.mulStrict(e[0]);
                }
            };
        }, "Exp", {}, [], [
            !0
        ]);
    }
}), mu = An({
    expm1_: function(t) {
        var e = mn(t, "x", "expm1");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.expm1(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.mul(n.exp());
                }
            };
        });
    }
}), gu = An({
    floor_: function(t) {
        var e = mn(t, "x", "floor");
        return Lt.runKernelFunc(function(t) {
            return t.floor(e);
        }, {
            $x: e
        }, function(t) {
            return {
                $x: function() {
                    return Xn(t);
                }
            };
        });
    }
}), yu = An({
    log_: function(t) {
        var e = mn(t, "x", "log"), n = [
            e
        ];
        return Lt.runKernelFunc(function(t, n) {
            var r = t.log(e);
            return n([
                e
            ]), r;
        }, {
            x: e
        }, function(t, e) {
            var n = e[0];
            return {
                x: function() {
                    return t.div(n.toFloat());
                }
            };
        }, "Log", {}, n);
    }
}), xu = An({
    log1p_: function(t) {
        var e = mn(t, "x", "log1p");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.log1p(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.div(n.add(1));
                }
            };
        });
    }
}), bu = An({
    logSigmoid_: function(t) {
        var e = mn(t, "x", "logSigmoid");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.softplus(e.neg()).neg();
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.mul(n.neg().sigmoid());
                }
            };
        });
    }
}), wu = An({
    neg_: function(t) {
        var e = mn(t, "x", "neg"), n = [
            e
        ];
        return Lt.runKernelFunc(function(t) {
            return t.neg(e);
        }, {
            x: e
        }, function(t) {
            return {
                x: function() {
                    return t.neg();
                }
            };
        }, "Neg", {}, n);
    }
}), Cu = An({
    reciprocal_: function(t) {
        var e = mn(t, "x", "reciprocal");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.reciprocal(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.div(n.square().neg());
                }
            };
        });
    }
}), Eu = An({
    round_: function(t) {
        var e = mn(t, "x", "round");
        return Lt.runKernelFunc(function(t) {
            return t.round(e);
        }, {
            $x: e
        }, function(t) {
            return {
                $x: function() {
                    return Xn(t);
                }
            };
        });
    }
}), Ru = An({
    rsqrt_: function(t) {
        var e = mn(t, "x", "rsqrt"), n = [
            e
        ];
        return Lt.runKernelFunc(function(t, n) {
            var r = t.rsqrt(e);
            return n([
                e
            ]), r;
        }, {
            x: e
        }, function(t, e) {
            var n = e[0];
            return {
                x: function() {
                    return t.div(n.pow(1.5).mul(2)).neg();
                }
            };
        }, "Rsqrt", {}, n);
    }
}), Iu = An({
    sigmoid_: function(t) {
        var e = mn(t, "x", "sigmoid");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.sigmoid(e);
            return n([
                r
            ]), r;
        }, {
            x: e
        }, function(t, e) {
            var n = e[0];
            return {
                x: function() {
                    return t.mul(n.mul(On(1).sub(n)));
                }
            };
        }, "Sigmoid");
    }
}), ku = An({
    sign_: function(t) {
        var e = mn(t, "x", "sign");
        return Lt.runKernelFunc(function(t) {
            return t.sign(e);
        }, {
            $x: e
        }, function(t) {
            return {
                $x: function() {
                    return Xn(t);
                }
            };
        });
    }
}), Su = An({
    isNaN_: function(t) {
        var e = mn(t, "x", "isNaN");
        return Lt.runKernelFunc(function(t) {
            return t.isNaN(e);
        }, {
            $x: e
        }, function(t) {
            return {
                $x: function() {
                    return Xn(t);
                }
            };
        });
    }
}), Au = An({
    isInf_: function(t) {
        var e = mn(t, "x", "isInf");
        return Lt.runKernelFunc(function(t) {
            return t.isInf(e);
        }, {
            $x: e
        }, function(t) {
            return {
                $x: function() {
                    return Xn(t);
                }
            };
        });
    }
}), Du = An({
    isFinite_: function(t) {
        var e = mn(t, "x", "isFinite");
        return Lt.runKernelFunc(function(t) {
            return t.isFinite(e);
        }, {
            $x: e
        }, function(t) {
            return {
                $x: function() {
                    return Xn(t);
                }
            };
        });
    }
}), Tu = An({
    sin_: function(t) {
        var e = mn(t, "x", "sin"), n = [
            e
        ];
        return Lt.runKernelFunc(function(t, n) {
            var r = t.sin(e);
            return n([
                e
            ]), r;
        }, {
            x: e
        }, function(t, e) {
            var n = e[0];
            return {
                x: function() {
                    return n.toFloat().cos().mul(t);
                }
            };
        }, "Sin", {}, n);
    }
}), Nu = An({
    sinh_: function(t) {
        var e = mn(t, "x", "sinh");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.sinh(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return n.toFloat().cosh().mulStrict(t);
                }
            };
        });
    }
}), Fu = An({
    softplus_: function(t) {
        var e = mn(t, "x", "softplus");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.softplus(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.mul(n.sigmoid());
                }
            };
        });
    }
}), _u = An({
    sqrt_: function(t) {
        var e = mn(t, "x", "sqrt");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.sqrt(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.div(n.toFloat().sqrt().mul(2));
                }
            };
        });
    }
}), Ou = An({
    step_: function(t, e) {
        void 0 === e && (e = 0);
        var n = mn(t, "x", "step");
        return Lt.runKernelFunc(function(t) {
            return t.step(n, e);
        }, {
            $x: n
        }, function(t) {
            return {
                $x: function() {
                    return Xn(t);
                }
            };
        });
    }
}), Mu = An({
    tan_: function(t) {
        var e = mn(t, "x", "tan");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.tan(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return t.div(n.cos().square());
                }
            };
        });
    }
}), Bu = An({
    tanh_: function(t) {
        var e = mn(t, "x", "tanh");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.tanh(e);
            return n([
                r
            ]), r;
        }, {
            x: e
        }, function(t, e) {
            var n = e[0];
            return {
                x: function() {
                    return On(1).sub(n.square()).mulStrict(t);
                }
            };
        }, "Tanh", {}, null, [
            !0
        ]);
    }
});
function Pu(t, e, n, r, o, a) {
    var i, s, u = mn(t, "x", "batchNorm"), c = mn(e, "mean", "batchNorm"), l = mn(n, "variance", "batchNorm");
    return null != o && (i = mn(o, "scale", "batchNorm")), null != r && (s = mn(r, "offset", "batchNorm")), C(2 === u.rank, function() {
        return "Error in batchNorm3D: x must be rank 3 but got rank " + u.rank + ".";
    }), C(2 === c.rank || 1 === c.rank, function() {
        return "Error in batchNorm2D: mean must be rank 2 or rank 1 but got rank " + c.rank + ".";
    }), C(2 === l.rank || 1 === l.rank, function() {
        return "Error in batchNorm2D: variance must be rank 2 or rank 1 but got rank " + l.rank + ".";
    }), null != i && C(2 === i.rank || 1 === i.rank, function() {
        return "Error in batchNorm2D: scale must be rank 2 or rank 1 but got rank " + i.rank + ".";
    }), null != s && C(2 === s.rank || 1 === s.rank, function() {
        return "Error in batchNorm2D: offset must be rank 2 or rank 1 but got rank " + s.rank + ".";
    }), Uu(u, c, l, s, i, a);
}
function Lu(t, e, n, r, o, a) {
    var i, s, u = mn(t, "x", "batchNorm"), c = mn(e, "mean", "batchNorm"), l = mn(n, "variance", "batchNorm");
    return null != o && (i = mn(o, "scale", "batchNorm")), null != r && (s = mn(r, "offset", "batchNorm")), C(3 === u.rank, function() {
        return "Error in batchNorm3D: x must be rank 3 but got rank " + u.rank + ".";
    }), C(3 === c.rank || 1 === c.rank, function() {
        return "Error in batchNorm3D: mean must be rank 3 or rank 1 but got rank " + c.rank + ".";
    }), C(3 === l.rank || 1 === l.rank, function() {
        return "Error in batchNorm3D: variance must be rank 3 or rank 1 but got rank " + l.rank + ".";
    }), null != i && C(3 === i.rank || 1 === i.rank, function() {
        return "Error in batchNorm3D: scale must be rank 3 or rank 1 but got rank " + i.rank + ".";
    }), null != s && C(3 === s.rank || 1 === s.rank, function() {
        return "Error in batchNorm3D: offset must be rank 3 or rank 1 but got rank " + s.rank + ".";
    }), Uu(u, c, l, s, i, a);
}
function Wu(t, e, n, r, o, a) {
    var i, s, u = mn(t, "x", "batchNorm"), c = mn(e, "mean", "batchNorm"), l = mn(n, "variance", "batchNorm");
    return null != o && (i = mn(o, "scale", "batchNorm")), null != r && (s = mn(r, "offset", "batchNorm")), C(4 === u.rank, function() {
        return "Error in batchNorm4D: x must be rank 4 but got rank " + u.rank + ".";
    }), C(4 === c.rank || 1 === c.rank, function() {
        return "Error in batchNorm4D: mean must be rank 4 or rank 1 but got rank " + c.rank + ".";
    }), C(4 === l.rank || 1 === l.rank, function() {
        return "Error in batchNorm4D: variance must be rank 4 or rank 1 but got rank " + l.rank + ".";
    }), null != i && C(4 === i.rank || 1 === i.rank, function() {
        return "Error in batchNorm4D: scale must be rank 4 or rank 1 but got rank " + i.rank + ".";
    }), null != s && C(4 === s.rank || 1 === s.rank, function() {
        return "Error in batchNorm4D: offset must be rank 4 or rank 1 but got rank " + s.rank + ".";
    }), Uu(u, c, l, s, i, a);
}
function Uu(t, e, n, r, o, a) {
    null == a && (a = .001);
    var i, s, u, c = mn(t, "x", "batchNorm"), l = mn(e, "mean", "batchNorm"), h = mn(n, "variance", "batchNorm");
    null != o && (i = mn(o, "scale", "batchNorm")), null != r && (s = mn(r, "offset", "batchNorm")), C(l.rank === h.rank, function() {
        return "Batch normalization gradient requires mean and variance to have equal ranks.";
    }), C(null == s || l.rank === s.rank, function() {
        return "Batch normalization gradient requires mean and offset to have equal ranks.";
    }), C(null == i || l.rank === i.rank, function() {
        return "Batch normalization gradient requires mean and scale to have equal ranks.";
    }), u = 0 === c.rank || 1 === c.rank ? c.as4D(1, 1, 1, c.size) : 2 === c.rank ? c.as4D(1, 1, c.shape[0], c.shape[1]) : 3 === c.rank ? c.as4D(1, c.shape[0], c.shape[1], c.shape[2]) : c;
    var f = [
        c,
        l,
        h,
        i
    ];
    return Lt.runKernelFunc(function(t, e) {
        var n = t.batchNormalization(u, Vu(l), Vu(h), a, Vu(i), Vu(s));
        return e([
            c,
            l,
            h,
            i
        ]), n;
    }, {
        x: c,
        mean: l,
        variance: h,
        scale: i,
        offset: s
    }, function(t, e) {
        var n = e, r = n[0], o = n[1], i = n[2], s = n[3], c = null == s ? On(1) : s, l = Eo(o.shape, u.shape), h = [];
        if (1 === o.rank) {
            for(var f = 0; f < u.shape.length - 1; ++f)h.push(u.shape[f]);
            h.push(1);
        }
        var d = r.sub(o), p = t.mul(c), v = Ru(i.add(On(a))), m = v.mul(v).mul(v).mul(On(-0.5));
        return {
            x: function() {
                return 1 === o.rank ? t.mul(Lr(v.as4D(1, 1, 1, o.shape[0]), h)).mul(c).reshape(r.shape) : t.mul(v).mul(c).reshape(r.shape);
            },
            mean: function() {
                var t = v.mul(On(-1)).mul(p);
                return 1 === o.rank && (t = t.sum(l)), t.reshape(o.shape);
            },
            variance: function() {
                var t = m.mul(d).mul(p);
                return 1 === o.rank && (t = t.sum(l)), t.reshape(o.shape);
            },
            scale: function() {
                var e = d.mul(v), n = t.mul(e);
                return 1 === o.rank && (n = n.sum(l)), n.reshape(o.shape);
            },
            offset: function() {
                var e = t;
                return 1 === o.rank && (e = e.sum(l)), e.reshape(o.shape);
            }
        };
    }, "BatchNormalization", {
        varianceEpsilon: a
    }, f).reshape(c.shape);
}
function Vu(t) {
    return null == t ? null : 0 === t.rank ? t.as1D() : 1 === t.rank ? t : 2 === t.rank ? t.as4D(1, 1, t.shape[0], t.shape[1]) : 3 === t.rank ? t.as4D(1, t.shape[0], t.shape[1], t.shape[2]) : t;
}
function zu() {
    Xe("tf.batchNormalization() is going away. Use tf.batchNorm() instead, and note the positional argument change of scale, offset, and varianceEpsilon");
}
var Gu = An({
    batchNormalization2d_: function(t, e, n, r, o, a) {
        return void 0 === r && (r = .001), zu(), Pu(t, e, n, a, o, r);
    }
}), Hu = An({
    batchNormalization3d_: function(t, e, n, r, o, a) {
        return void 0 === r && (r = .001), zu(), Lu(t, e, n, a, o, r);
    }
}), qu = An({
    batchNormalization4d_: function(t, e, n, r, o, a) {
        return void 0 === r && (r = .001), zu(), Wu(t, e, n, a, o, r);
    }
}), Ku = An({
    batchNormalization_: function(t, e, n, r, o, a) {
        return void 0 === r && (r = .001), zu(), Uu(t, e, n, a, o, r);
    }
}), ju = An({
    batchNorm_: Uu
}), Xu = An({
    batchNorm2d_: Pu
}), Yu = An({
    batchNorm3d_: Lu
}), $u = An({
    batchNorm4d_: Wu
});
var Qu = An({
    logicalAnd_: function(t, e) {
        var n = mn(t, "a", "logicalAnd", "bool"), r = mn(e, "b", "logicalAnd", "bool");
        return Ro(n.shape, r.shape), Lt.runKernelFunc(function(t) {
            return t.logicalAnd(n, r);
        }, {
            a: n,
            b: r
        }, null, "LogicalAnd");
    }
}), Ju = An({
    logicalNot_: function(t) {
        var e = mn(t, "x", "logicalNot", "bool");
        return Lt.runKernelFunc(function(t) {
            return t.logicalNot(e);
        }, {
            $x: e
        });
    }
}), Zu = An({
    logicalOr_: function(t, e) {
        var n = mn(t, "a", "logicalOr", "bool"), r = mn(e, "b", "logicalOr", "bool");
        return Ro(n.shape, r.shape), Lt.runKernelFunc(function(t) {
            return t.logicalOr(n, r);
        }, {
            $a: n,
            $b: r
        });
    }
}), tc = An({
    logicalXor_: function(t, e) {
        var n = mn(t, "a", "logicalXor", "bool"), r = mn(e, "b", "logicalXor", "bool");
        return Ro(n.shape, r.shape), Zu(t, e).logicalAnd(Qu(t, e).logicalNot());
    }
}), ec = An({
    where_: function(t, e, n) {
        var r = mn(e, "a", "where"), o = mn(n, "b", "where"), a = mn(t, "condition", "where", "bool");
        return E(r.shape, o.shape, "Error in where: "), 1 === a.rank ? C(a.shape[0] === r.shape[0], function() {
            return "The first dimension of `a` must match the size of `condition`.";
        }) : E(a.shape, o.shape, "Error in where: "), Lt.runKernelFunc(function(t, e) {
            var n = t.select(a, r, o);
            return e([
                a
            ]), n;
        }, {
            $condition: a,
            $a: r,
            $b: o
        }, function(t, e) {
            var n = e[0];
            return {
                $condition: function() {
                    return Xn(n).toFloat();
                },
                $a: function() {
                    return t.mul(n.cast(t.dtype));
                },
                $b: function() {
                    return t.mul(n.logicalNot().cast(t.dtype));
                }
            };
        });
    }
}), nc = function(t) {
    return n(this, void 0, void 0, function() {
        var e, n, o;
        return r(this, function(r) {
            switch(r.label){
                case 0:
                    return [
                        4,
                        (e = mn(t, "condition", "whereAsync", "bool")).data()
                    ];
                case 1:
                    return n = r.sent(), o = na(e.shape, n), t !== e && e.dispose(), [
                        2,
                        o
                    ];
            }
        });
    });
};
var rc = An({
    add_: function(t, e) {
        var n, r = mn(t, "a", "add"), o = mn(e, "b", "add");
        n = Nt(r, o), r = n[0], o = n[1];
        var a = Ro(r.shape, o.shape);
        return Lt.runKernelFunc(function(t) {
            return t.add(r, o);
        }, {
            a: r,
            b: o
        }, function(t) {
            return {
                a: function() {
                    var e = t, n = Eo(r.shape, a);
                    return n.length > 0 && (e = e.sum(n)), e.reshape(r.shape);
                },
                b: function() {
                    var e = t, n = Eo(o.shape, a);
                    return n.length > 0 && (e = e.sum(n)), e.reshape(o.shape);
                }
            };
        }, "Add");
    }
}), oc = An({
    addN_: function(t) {
        C(Array.isArray(t), function() {
            return "The argument passed to tf.addN() must be a list of tensors";
        }), C(t.length >= 1, function() {
            return "Must pass at least one tensor to tf.addN(), but got " + t.length;
        });
        var e = t.map(function(t, e) {
            return mn(t, "tensors" + e, "addN");
        }), n = e[0];
        e.forEach(function(t) {
            if (t.dtype !== n.dtype) throw new Error("All tensors passed to tf.addN() must have the same dtype");
        }), e.forEach(function(t) {
            if (!S(t.shape, n.shape)) throw new Error("All tensors passed to tf.addN() must have the same shape");
        });
        var r = e;
        return Lt.runKernelFunc(function(t) {
            return t.addN(e);
        }, r, function(t) {
            var n = {};
            return e.forEach(function(e, r) {
                n[r] = function() {
                    return t.clone();
                };
            }), n;
        }, "AddN");
    }
}), ac = An({
    addStrict_: function(t, e) {
        var n = mn(t, "a", "addStrict"), r = mn(e, "b", "addStrict");
        return E(n.shape, r.shape, "Error in addStrict: "), n.add(r);
    }
}), ic = An({
    atan2_: function(t, e) {
        var n, r = mn(t, "a", "atan2"), o = mn(e, "b", "atan2");
        n = Nt(r, o), r = n[0], o = n[1];
        var a = Ro(r.shape, o.shape);
        return Lt.runKernelFunc(function(t, e) {
            var n = t.atan2(r, o);
            return e([
                r,
                o
            ]), n;
        }, {
            $a: r,
            $b: o
        }, function(t, e) {
            var n = e[0], r = e[1];
            return {
                $a: function() {
                    var e = rc(n.square(), r.square()), o = t.mul(r.div(e)), i = Eo(n.shape, a);
                    return i.length > 0 && (o = o.sum(i)), o.reshape(n.shape);
                },
                $b: function() {
                    var e = rc(n.square(), r.square()), o = wu(t.mul(n.div(e))), i = Eo(r.shape, a);
                    return i.length > 0 && (o = o.sum(i)), o.reshape(r.shape);
                }
            };
        });
    }
}), sc = An({
    div_: function(t, e) {
        var n, r = mn(t, "a", "div"), o = mn(e, "b", "div");
        if (n = Nt(r, o), r = n[0], o = n[1], "int32" === r.dtype && "int32" === o.dtype) return lc(r, o);
        var a = Ro(r.shape, o.shape);
        return Lt.runKernelFunc(function(t, e) {
            var n = t.realDivide(r, o);
            return e([
                r,
                o
            ]), n;
        }, {
            a: r,
            b: o
        }, function(t, e) {
            var n = e[0], r = e[1];
            return {
                a: function() {
                    var e = t.div(r.toFloat()), o = Eo(n.shape, a);
                    return o.length > 0 ? e.sum(o).reshape(n.shape) : e;
                },
                b: function() {
                    var e = t.mul(n.toFloat()), o = Eo(r.shape, a);
                    o.length > 0 && (e = e.sum(o).reshape(r.shape));
                    var i = r.square();
                    return e.div(i.toFloat()).neg();
                }
            };
        }, "Div");
    }
}), uc = An({
    divNoNan_: function(t, e) {
        var n, r = mn(t, "a", "div"), o = mn(e, "b", "div");
        r = (n = Nt(r, o))[0], o = n[1];
        var a = sc(r, o), i = Xn(a), s = o.equal(i);
        return ec(s, i, a);
    }
}), cc = An({
    divStrict_: function(t, e) {
        var n = mn(t, "a", "div"), r = mn(e, "b", "div");
        return E(n.shape, r.shape, "Error in divideStrict: "), n.div(r);
    }
}), lc = An({
    floorDiv_: function(t, e) {
        var n, r = mn(t, "a", "floorDiv"), o = mn(e, "b", "floorDiv");
        n = Nt(r, o), r = n[0], o = n[1];
        var a = Ro(r.shape, o.shape);
        return Lt.runKernelFunc(function(t, e) {
            var n = t.floorDiv(r, o);
            return e([
                r,
                o
            ]), n;
        }, {
            a: r,
            b: o
        }, function(t, e) {
            var n = e[0], r = e[1];
            return {
                a: function() {
                    var e = t.div(r.toFloat()), o = Eo(n.shape, a);
                    return o.length > 0 ? e.sum(o).reshape(n.shape) : e;
                },
                b: function() {
                    var e = t.mul(n.toFloat()), o = Eo(r.shape, a);
                    o.length > 0 && (e = e.sum(o).reshape(r.shape));
                    var i = r.square();
                    return e.div(i.toFloat()).neg();
                }
            };
        }, "FloorDiv");
    }
}), hc = An({
    maximum_: function(t, e) {
        var n, r = mn(t, "a", "maximum"), o = mn(e, "b", "maximum");
        return n = Nt(r, o), r = n[0], o = n[1], "bool" === r.dtype && (r = r.toInt(), o = o.toInt()), Ro(r.shape, o.shape), Lt.runKernelFunc(function(t, e) {
            var n = t.maximum(r, o);
            return e([
                r,
                o
            ]), n;
        }, {
            a: r,
            b: o
        }, function(t, e) {
            var n = e[0], r = e[1];
            return {
                a: function() {
                    return t.mul(n.greaterEqual(r).toFloat());
                },
                b: function() {
                    return t.mul(n.less(r).toFloat());
                }
            };
        }, "Maximum");
    }
}), fc = An({
    maximumStrict_: function(t, e) {
        var n = mn(t, "a", "maximumStrict"), r = mn(e, "b", "maximumStrict");
        return E(n.shape, r.shape, "Error in maximumStrict: "), n.maximum(r);
    }
}), dc = An({
    minimum_: function(t, e) {
        var n, r = mn(t, "a", "minimum"), o = mn(e, "b", "minimum");
        return n = Nt(r, o), r = n[0], o = n[1], "bool" === r.dtype && (r = r.toInt(), o = o.toInt()), Ro(r.shape, o.shape), Lt.runKernelFunc(function(t, e) {
            var n = t.minimum(r, o);
            return e([
                r,
                o
            ]), n;
        }, {
            a: r,
            b: o
        }, function(t, e) {
            var n = e[0], r = e[1];
            return {
                a: function() {
                    return t.mul(n.lessEqual(r).toFloat());
                },
                b: function() {
                    return t.mul(n.greater(r).toFloat());
                }
            };
        }, "Minimum");
    }
}), pc = An({
    minimumStrict_: function(t, e) {
        var n = mn(t, "a", "minimumStrict"), r = mn(e, "b", "minimumStrict");
        return E(n.shape, r.shape, "Error in minimumStrict: "), n.minimum(r);
    }
}), vc = An({
    mod_: function(t, e) {
        var n, r = mn(t, "a", "mod"), o = mn(e, "b", "mod");
        n = Nt(r, o), r = n[0], o = n[1];
        var a = Ro(r.shape, o.shape);
        return Lt.runKernelFunc(function(t, e) {
            var n = t.mod(r, o);
            return e([
                r,
                o
            ]), n;
        }, {
            $a: r,
            $b: o
        }, function(t, e) {
            var n = e[0], r = e[1];
            return {
                $a: function() {
                    var e = Eo(n.shape, a);
                    return e.length > 0 ? t.sum(e).reshape(n.shape) : t;
                },
                $b: function() {
                    var e = t.mul(n.div(r).floor().neg()), o = Eo(r.shape, a);
                    return o.length > 0 ? e.sum(o).reshape(r.shape) : e;
                }
            };
        });
    }
}), mc = An({
    modStrict_: function(t, e) {
        var n = mn(t, "a", "modStrict"), r = mn(e, "b", "modStrict");
        return E(n.shape, r.shape, "Error in modStrict: "), n.mod(r);
    }
}), gc = An({
    mul_: function(t, e) {
        var n, r = mn(t, "a", "mul"), o = mn(e, "b", "mul");
        n = Nt(r, o), r = n[0], o = n[1];
        var a = Ro(r.shape, o.shape);
        return Lt.runKernelFunc(function(t, e) {
            var n = t.multiply(r, o);
            return e([
                r,
                o
            ]), n;
        }, {
            a: r,
            b: o
        }, function(t, e) {
            var n = e[0], r = e[1];
            return {
                a: function() {
                    var e = t.mul(r.toFloat()), o = Eo(n.shape, a);
                    return o.length > 0 ? e.sum(o).reshape(n.shape) : e;
                },
                b: function() {
                    var e = t.mul(n.toFloat()), o = Eo(r.shape, a);
                    return o.length > 0 ? e.sum(o).reshape(r.shape) : e;
                }
            };
        }, "Mul");
    }
}), yc = An({
    mulStrict_: function(t, e) {
        var n = mn(t, "a", "mul"), r = mn(e, "b", "mul");
        return E(n.shape, r.shape, "Error in multiplyStrict: "), n.mul(r);
    }
}), xc = An({
    pow_: function(t, e) {
        var n, r = mn(t, "base", "pow"), o = mn(e, "exp", "pow");
        n = Nt(r, o), r = n[0], o = n[1];
        var a = Ro(r.shape, o.shape), i = [
            r,
            o
        ];
        return Lt.runKernelFunc(function(t, e) {
            var n = t.pow(r, o);
            return e([
                r,
                o,
                n
            ]), n;
        }, {
            a: r,
            b: o
        }, function(t, e) {
            var n = e[0], r = e[1], o = e[2];
            return {
                a: function() {
                    var e = r.toFloat(), o = t.mul(e.mul(n.pow(e.sub(On(1))))), i = Eo(n.shape, a);
                    return i.length > 0 && (o = o.sum(i)), o.reshape(n.shape);
                },
                b: function() {
                    var e = n.greater(0), i = n.log().where(e, Xn(n)), s = t.mul(o.mul(i)), u = Eo(r.shape, a);
                    return u.length > 0 && (s = s.sum(u)), s.reshape(r.shape);
                }
            };
        }, "Pow", {}, i, [
            !0
        ]);
    }
}), bc = An({
    powStrict_: function(t, e) {
        return E(t.shape, e.shape, "Error in powStrict: "), t.pow(e);
    }
}), wc = An({
    squaredDifferenceStrict_: function(t, e) {
        var n = mn(t, "a", "squaredDifferenceStrict"), r = mn(e, "b", "squaredDifferenceStrict");
        return E(n.shape, r.shape, "Error in squaredDifferenceStrict: "), n.squaredDifference(r);
    }
}), Cc = An({
    sub_: function(t, e) {
        var n, r = mn(t, "a", "sub"), o = mn(e, "b", "sub");
        n = Nt(r, o), r = n[0], o = n[1];
        var a = Ro(r.shape, o.shape);
        return Lt.runKernelFunc(function(t) {
            return t.subtract(r, o);
        }, {
            a: r,
            b: o
        }, function(t) {
            return {
                a: function() {
                    var e = t, n = Eo(r.shape, a);
                    return n.length > 0 && (e = e.sum(n)), e.reshape(r.shape);
                },
                b: function() {
                    var e = t, n = Eo(o.shape, a);
                    return n.length > 0 && (e = e.sum(n)), e.neg().reshape(o.shape);
                }
            };
        }, "Sub");
    }
}), Ec = An({
    subStrict_: function(t, e) {
        var n = mn(t, "a", "subStrict"), r = mn(e, "b", "subStrict");
        return E(n.shape, r.shape, "Error in subStrict: "), n.sub(r);
    }
});
var Rc = An({
    equal_: function(t, e) {
        var n, r = mn(t, "a", "equal"), o = mn(e, "b", "equal");
        return n = Nt(r, o), r = n[0], o = n[1], Ro(r.shape, o.shape), Lt.runKernelFunc(function(t) {
            return t.equal(r, o);
        }, {
            $a: r,
            $b: o
        });
    }
}), Ic = An({
    equalStrict_: function(t, e) {
        var n = mn(t, "a", "equalStrict"), r = mn(e, "b", "equalStrict");
        return E(n.shape, r.shape, "Error in equalStrict: "), n.equal(r);
    }
}), kc = An({
    greater_: function(t, e) {
        var n, r = mn(t, "a", "greater"), o = mn(e, "b", "greater");
        return n = Nt(r, o), r = n[0], o = n[1], Ro(r.shape, o.shape), Lt.runKernelFunc(function(t) {
            return t.greater(r, o);
        }, {
            a: r,
            b: o
        }, null, "Greater");
    }
}), Sc = An({
    greaterEqual_: function(t, e) {
        var n, r = mn(t, "a", "greaterEqual"), o = mn(e, "b", "greaterEqual");
        return n = Nt(r, o), r = n[0], o = n[1], Ro(r.shape, o.shape), Lt.runKernelFunc(function(t, e) {
            var n = t.greaterEqual(r, o);
            return e([
                r,
                o
            ]), n;
        }, {
            a: r,
            b: o
        }, function(t, e) {
            var n = e[0], r = e[1];
            return {
                a: function() {
                    return Xn(n);
                },
                b: function() {
                    return Xn(r);
                }
            };
        }, "GreaterEqual");
    }
}), Ac = An({
    greaterEqualStrict_: function(t, e) {
        var n = mn(t, "a", "greaterEqualStrict"), r = mn(e, "b", "greaterEqualStrict");
        return E(n.shape, r.shape, "Error in greaterEqualStrict: "), n.greaterEqual(r);
    }
}), Dc = An({
    greaterStrict_: function(t, e) {
        var n = mn(t, "a", "greaterStrict"), r = mn(e, "b", "greaterStrict");
        return E(n.shape, r.shape, "Error in greaterStrict: "), n.greater(r);
    }
}), Tc = An({
    less_: function(t, e) {
        var n, r = mn(t, "a", "less"), o = mn(e, "b", "less");
        return n = Nt(r, o), r = n[0], o = n[1], Ro(r.shape, o.shape), Lt.runKernelFunc(function(t) {
            return t.less(r, o);
        }, {
            a: r,
            b: o
        }, null, "Less");
    }
}), Nc = An({
    lessEqual_: function(t, e) {
        var n, r = mn(t, "a", "lessEqual"), o = mn(e, "b", "lessEqual");
        return n = Nt(r, o), r = n[0], o = n[1], Ro(r.shape, o.shape), Lt.runKernelFunc(function(t, e) {
            var n = t.lessEqual(r, o);
            return e([
                r,
                o
            ]), n;
        }, {
            a: r,
            b: o
        }, null, "LessEqual");
    }
}), Fc = An({
    lessEqualStrict_: function(t, e) {
        var n = mn(t, "a", "lessEqualStrict"), r = mn(e, "b", "lessEqualStrict");
        return E(n.shape, r.shape, "Error in lessEqualStrict: "), n.lessEqual(r);
    }
}), _c = An({
    lessStrict_: function(t, e) {
        var n = mn(t, "a", "lessStrict"), r = mn(e, "b", "lessStrict");
        return E(n.shape, r.shape, "Error in lessStrict: "), n.less(r);
    }
}), Oc = An({
    notEqual_: function(t, e) {
        var n, r = mn(t, "a", "notEqual"), o = mn(e, "b", "notEqual");
        return n = Nt(r, o), r = n[0], o = n[1], Ro(r.shape, o.shape), Lt.runKernelFunc(function(t) {
            return t.notEqual(r, o);
        }, {
            a: r,
            b: o
        }, null, "NotEqual");
    }
}), Mc = An({
    notEqualStrict_: function(t, e) {
        var n = mn(t, "a", "notEqualStrict"), r = mn(e, "b", "notEqualStrict");
        return E(n.shape, r.shape, "Error in notEqualStrict: "), n.notEqual(r);
    }
});
function Bc(t, e) {
    for(var n = [], r = t; r < e; ++r)n.push(r);
    return n;
}
function Pc(t) {
    for(var e = [], n = 0; n < t.length; ++n)for(var r = 0; r < t[n].length; ++r)e.push(t[n][r]);
    return e;
}
var Lc = An({
    gather_: function(t, e, n) {
        void 0 === n && (n = 0);
        var r = mn(t, "x", "gather"), o = mn(e, "indices", "gather", "int32");
        n = O(n, r.shape)[0];
        var a = function(t, e, n) {
            for(var r = t.shape[n], o = [], a = 1, i = 1, s = 0; s < n; s++)o.push(t.shape[s]), a *= t.shape[s];
            for(s = 0; s < e.rank; s++)o.push(e.shape[s]);
            for(s = n + 1; s < t.rank; s++)o.push(t.shape[s]), i *= t.shape[s];
            return {
                batchSize: a,
                sliceSize: i,
                dimSize: r,
                outputShape: o
            };
        }(r, o, n);
        return Lt.runKernelFunc(function(t, e) {
            var a = t.gather(r, o.flatten(), n);
            return e([
                o
            ]), a;
        }, {
            x: r,
            indices: o
        }, function(t, e) {
            var o = e[0];
            return {
                x: function() {
                    var e = r.shape, a = o.size, i = e.slice(0, n), s = i.length, u = e.slice(n, e.length).slice(1), c = u.length, l = Bc(0, s), h = Bc(s + 1, s + 1 + c), f = Pc([
                        i,
                        [
                            a
                        ],
                        u
                    ]), d = t.reshape(f), p = o.reshape([
                        a
                    ]), v = Pc([
                        [
                            s
                        ],
                        l,
                        h
                    ]), m = d.transpose(v), g = Wc(m, p, r.shape[n]), y = Rn(v);
                    return g = g.transpose(y);
                },
                indices: function() {
                    return o;
                }
            };
        }, "Gather", {
            axis: n
        }).reshape(a.outputShape);
    }
}), Wc = An({
    unsortedSegmentSum_: function(t, e, n) {
        var r = mn(t, "x", "unsortedSegmentSum"), o = mn(e, "segmentIds", "unsortedSegmentSum", "int32");
        return C(A(n), function() {
            return "numSegments must be of dtype int";
        }), Lt.runKernelFunc(function(t, e) {
            var a = t.unsortedSegmentSum(r, o, n);
            return e([
                o
            ]), a;
        }, {
            $x: r
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return function(t, e) {
                        for(var n = hc(e, Xn(e)), r = Lc(t, n), o = Sc(e, On(0, "int32")), a = r.rank - o.rank, i = 0; i < a; ++i)o = wr(o, i + 1);
                        o = Qu(o, zn(r.shape, "bool"));
                        var s = Xn(r);
                        return ec(o, r, s);
                    }(t, n);
                }
            };
        });
    }
});
var Uc = function(t, e, o) {
    return n(this, void 0, void 0, function() {
        var n, a, i, s, u, c, l, h, f, d, p, v, m;
        return r(this, function(r) {
            switch(r.label){
                case 0:
                    for(n = mn(t, "tensor", "boolMask"), a = mn(e, "mask", "boolMask", "bool"), i = null == o ? 0 : o, s = a.rank, u = n.shape, C(s > 0, function() {
                        return "mask cannot be scalar";
                    }), E(u.slice(i, i + s), a.shape, "mask's shape must match the first K dimensions of tensor's shape,"), c = 1, l = i; l < i + s; l++)c *= u[l];
                    return h = u.slice(0, i).concat([
                        c
                    ], u.slice(i + s)), f = n.reshape(h), d = a.reshape([
                        -1
                    ]), [
                        4,
                        nc(d)
                    ];
                case 1:
                    return p = r.sent(), v = p.squeeze([
                        1
                    ]), m = Lc(f, v, i), t !== n && n.dispose(), e !== a && a.dispose(), v.dispose(), f.dispose(), d.dispose(), p.dispose(), [
                        2,
                        m
                    ];
            }
        });
    });
};
function Vc(t, e, n, r, o, a, i) {
    void 0 === a && (a = "NHWC"), C(t.length === e.rank, function() {
        return "Length of inShape (" + t.length + ") and rank of dy (" + e.rank + ") must match";
    });
    var s = t, u = e, c = !1;
    3 === e.rank && (c = !0, u = e.as4D(1, e.shape[0], e.shape[1], e.shape[2]), s = [
        1,
        t[0],
        t[1],
        t[2]
    ]), C(4 === s.length, function() {
        return "Error in conv2dDerInput: inShape must be length 4, but got length " + s.length + ".";
    }), C(4 === u.rank, function() {
        return "Error in conv2dDerInput: dy must be rank 4, but got rank " + u.rank;
    }), C(4 === n.rank, function() {
        return "Error in conv2dDerInput: filter must be rank 4, but got rank " + n.rank;
    });
    var l = "NHWC" === a ? s[3] : s[1], h = "NHWC" === a ? u.shape[3] : u.shape[1];
    C(l === n.shape[2], function() {
        return "Error in conv2dDerInput: depth of input (" + l + ") must match input depth for filter " + n.shape[2] + ".";
    }), C(h === n.shape[3], function() {
        return "Error in conv2dDerInput: depth of output (" + h + ") must match output depth for filter " + n.shape[3] + ".";
    }), null != i && C(A(o), function() {
        return "Error in conv2dDerInput: pad must be an integer when using, dimRoundingMode " + i + " but got pad " + o + ".";
    });
    var f = Bo(a), d = So(s, n.shape, r, 1, o, i, !1, f), p = Lt.runKernelFunc(function(t, e) {
        var r = t.conv2dDerInput(u, n, d);
        return e([
            n,
            u
        ]), r;
    }, {
        dy4D: u,
        filter: n
    }, function(t, e) {
        var n = e[0], s = e[1];
        return {
            dy4D: function() {
                return qc(t, n, r, o, a, 1, i);
            },
            filter: function() {
                return jc(t, s, n.shape, r, o, a, i);
            }
        };
    });
    return c ? p.as3D(p.shape[1], p.shape[2], p.shape[3]) : p;
}
function zc(t) {
    var e = function(t) {
        return "number" == typeof t ? [
            t,
            t,
            t
        ] : 2 === t.length ? [
            t[0],
            t[1],
            1
        ] : t;
    }(t), n = e[0], r = e[1], o = e[2];
    return 1 === n && 1 === r && 1 === o;
}
function Gc(t, e, n, r, o) {
    C(t.length === e.rank, function() {
        return "Length of inShape (" + t.length + ") and rank of dy (" + e.rank + ") must match";
    });
    var a = t, i = e, s = !1;
    4 === e.rank && (s = !0, i = e.as5D(1, e.shape[0], e.shape[1], e.shape[2], e.shape[3]), a = [
        1,
        t[0],
        t[1],
        t[2],
        t[3]
    ]);
    var u = a[4], c = i.shape[4];
    C(5 === a.length, function() {
        return "Error in conv3dDerInput: inShape must be length 5, but got length " + a.length + ".";
    }), C(5 === i.rank, function() {
        return "Error in conv3dDerInput: dy must be rank 5, but got rank " + i.rank;
    }), C(5 === n.rank, function() {
        return "Error in conv3dDerInput: filter must be rank 5, but got rank " + n.rank;
    }), C(u === n.shape[3], function() {
        return "Error in conv3dDerInput: depth of input (" + u + ") must match input depth for filter " + n.shape[3] + ".";
    }), C(c === n.shape[4], function() {
        return "Error in conv3dDerInput: depth of output (" + c + ") must match output depth for filter " + n.shape[4] + ".";
    });
    var l = Ao(a, n.shape, r, 1, o), h = Lt.runKernelFunc(function(t) {
        return t.conv3dDerInput(i, n, l);
    }, {
        dy5D: i
    });
    return s ? h.as4D(h.shape[1], h.shape[2], h.shape[3], h.shape[4]) : h;
}
var Hc = An({
    conv1d_: function(t, e, n, r, o, a, i) {
        void 0 === o && (o = "NWC"), void 0 === a && (a = 1);
        var s = mn(t, "x", "conv1d"), u = mn(e, "filter", "conv1d"), c = s, l = !1;
        2 === s.rank && (l = !0, c = s.as3D(1, s.shape[0], s.shape[1])), C(3 === c.rank, function() {
            return "Error in conv1d: input must be rank 3, but got rank " + c.rank + ".";
        }), C(3 === u.rank, function() {
            return "Error in conv1d: filter must be rank 3, but got rank " + u.rank + ".";
        }), null != i && C(A(r), function() {
            return "Error in conv1d: pad must be an integer when using, dimRoundingMode " + i + " but got pad " + r + ".";
        }), C(c.shape[2] === u.shape[1], function() {
            return "Error in conv1d: depth of input (" + c.shape[2] + ") must match input depth for filter " + u.shape[1] + ".";
        }), C(Mo(n, a), function() {
            return "Error in conv1D: Either stride or dilation must be 1. Got stride " + n + " and dilation '" + a + "'";
        }), C("NWC" === o, function() {
            return "Error in conv1d: got dataFormat of " + o + " but only NWC is currently supported.";
        });
        var h = u.as4D(1, u.shape[0], u.shape[1], u.shape[2]), f = c.as4D(c.shape[0], 1, c.shape[1], c.shape[2]), d = qc(f, h, [
            1,
            n
        ], r, "NHWC", [
            1,
            a
        ], i);
        return l ? d.as2D(d.shape[2], d.shape[3]) : d.as3D(d.shape[0], d.shape[2], d.shape[3]);
    }
}), qc = An({
    conv2d_: function(t, e, n, r, o, a, i) {
        void 0 === o && (o = "NHWC"), void 0 === a && (a = [
            1,
            1
        ]);
        var s = mn(t, "x", "conv2d"), u = mn(e, "filter", "conv2d"), c = s, l = !1;
        3 === s.rank && (l = !0, c = s.as4D(1, s.shape[0], s.shape[1], s.shape[2])), C(4 === c.rank, function() {
            return "Error in conv2d: input must be rank 4, but got rank " + c.rank + ".";
        }), C(4 === u.rank, function() {
            return "Error in conv2d: filter must be rank 4, but got rank " + u.rank + ".";
        }), null != i && C(A(r), function() {
            return "Error in conv2d: pad must be an integer when using, dimRoundingMode " + i + " but got pad " + r + ".";
        });
        var h = "NHWC" === o ? c.shape[3] : c.shape[1];
        C(h === u.shape[2], function() {
            return "Error in conv2d: depth of input (" + h + ") must match input depth for filter " + u.shape[2] + ".";
        }), C(Mo(n, a), function() {
            return "Error in conv2D: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + a + "'";
        });
        var f = Bo(o), d = So(c.shape, u.shape, n, a, r, i, !1, f), p = [
            u,
            c
        ], v = Lt.runKernelFunc(function(t, e) {
            var n = t.conv2d(c, u, d);
            return e([
                u,
                c
            ]), n;
        }, {
            x: c,
            filter: u
        }, function(t, e) {
            var i = e, s = i[0], u = i[1];
            return C(Oo(a), function() {
                return "Error in gradient of conv2D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '" + a + "'";
            }), {
                x: function() {
                    return Xc(u.shape, t, s, n, r, o);
                },
                filter: function() {
                    return jc(u, t, s.shape, n, r, o);
                }
            };
        }, "Conv2D", d, p);
        return l ? v.as3D(v.shape[1], v.shape[2], v.shape[3]) : v;
    }
}), Kc = An({
    conv3d_: function(t, e, n, r, o, a) {
        void 0 === o && (o = "NDHWC"), void 0 === a && (a = [
            1,
            1,
            1
        ]);
        var i = mn(t, "x", "conv3d"), s = mn(e, "filter", "conv3d"), u = i, c = !1;
        4 === i.rank && (c = !0, u = i.as5D(1, i.shape[0], i.shape[1], i.shape[2], i.shape[3])), C(5 === u.rank, function() {
            return "Error in conv3d: input must be rank 5, but got rank " + u.rank + ".";
        }), C(5 === s.rank, function() {
            return "Error in conv3d: filter must be rank 5, but got rank " + s.rank + ".";
        }), C(u.shape[4] === s.shape[3], function() {
            return "Error in conv3d: depth of input (" + u.shape[4] + ") must match input depth for filter " + s.shape[3] + ".";
        }), C(function(t, e) {
            return zc(t) || zc(e);
        }(n, a), function() {
            return "Error in conv3D: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + a + "'";
        }), C("NDHWC" === o, function() {
            return "Error in conv3d: got dataFormat of " + o + " but only NDHWC is currently supported.";
        });
        var l = Ao(u.shape, s.shape, n, a, r), h = Lt.runKernelFunc(function(t, e) {
            var n = t.conv3d(u, s, l);
            return e([
                u,
                s
            ]), n;
        }, {
            x: u,
            $filter: s
        }, function(t, e) {
            C(zc(a), function() {
                return "Error in gradient of conv3D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '" + a + "'";
            });
            var o = e[0], i = e[1];
            return {
                x: function() {
                    return Gc(o.shape, t, i, n, r);
                },
                $filter: function() {
                    return function(t, e, n, r, o) {
                        var a = t;
                        4 === t.rank && (a = t.as5D(1, t.shape[0], t.shape[1], t.shape[2], t.shape[3]));
                        var i = e;
                        4 === i.rank && (i = e.as5D(1, e.shape[0], e.shape[1], e.shape[2], e.shape[3]));
                        C(5 === a.rank, function() {
                            return "Error in conv3dDerFilter: input must be rank 5, but got shape " + a.shape + ".";
                        }), C(5 === i.rank, function() {
                            return "Error in conv3dDerFilter: dy must be rank 5, but got shape " + i.shape + ".";
                        }), C(5 === n.length, function() {
                            return "Error in conv3dDerFilter: filterShape must be length 5, but got " + n + ".";
                        }), C(a.shape[4] === n[3], function() {
                            return "Error in conv3dDerFilter: depth of input " + a.shape[4] + ") must match input depth in filter (" + n[3] + ".";
                        }), C(i.shape[4] === n[4], function() {
                            return "Error in conv3dDerFilter: depth of dy (" + i.shape[4] + ") must match output depth for filter (" + n[4] + ").";
                        });
                        var s = Ao(a.shape, n, r, 1, o);
                        return Lt.runKernelFunc(function(t) {
                            return t.conv3dDerFilter(a, i, s);
                        }, {
                            x5D: a,
                            dy5D: i
                        });
                    }(o, t, i.shape, n, r);
                }
            };
        });
        return c ? h.as4D(h.shape[1], h.shape[2], h.shape[3], h.shape[4]) : h;
    }
}), jc = An({
    conv2dDerFilter_: function(t, e, n, r, o, a, i) {
        void 0 === a && (a = "NHWC");
        var s = t;
        3 === t.rank && (s = t.as4D(1, t.shape[0], t.shape[1], t.shape[2]));
        var u = e;
        3 === u.rank && (u = e.as4D(1, e.shape[0], e.shape[1], e.shape[2])), C(4 === s.rank, function() {
            return "Error in conv2dDerFilter: input must be rank 4, but got shape " + s.shape + ".";
        }), C(4 === u.rank, function() {
            return "Error in conv2dDerFilter: dy must be rank 4, but got shape " + u.shape + ".";
        }), C(4 === n.length, function() {
            return "Error in conv2dDerFilter: filterShape must be length 4, but got " + n + ".";
        });
        var c = "NHWC" === a ? s.shape[3] : s.shape[1], l = "NHWC" === a ? u.shape[3] : u.shape[1];
        C(c === n[2], function() {
            return "Error in conv2dDerFilter: depth of input " + c + ") must match input depth in filter (" + n[2] + ".";
        }), C(l === n[3], function() {
            return "Error in conv2dDerFilter: depth of dy (" + l + ") must match output depth for filter (" + n[3] + ").";
        }), null != i && C(A(o), function() {
            return "Error in conv2dDerFilter: pad must be an integer when using, dimRoundingMode " + i + " but got pad " + o + ".";
        });
        var h = Bo(a), f = So(s.shape, n, r, 1, o, i, !1, h);
        return Lt.runKernelFunc(function(t) {
            return t.conv2dDerFilter(s, u, f);
        }, {
            x4D: s,
            dy4D: u
        });
    }
}), Xc = An({
    conv2dDerInput_: Vc
}), Yc = An({
    depthwiseConv2d_: function(t, e, n, r, o, a, i) {
        void 0 === o && (o = "NHWC"), void 0 === a && (a = [
            1,
            1
        ]);
        var s = mn(t, "x", "depthwiseConv2d"), u = mn(e, "filter", "depthwiseConv2d"), c = s, l = !1;
        3 === s.rank && (l = !0, c = s.as4D(1, s.shape[0], s.shape[1], s.shape[2])), C(4 === c.rank, function() {
            return "Error in depthwiseConv2d: input must be rank 4, but got rank " + c.rank + ".";
        }), C(4 === u.rank, function() {
            return "Error in depthwiseConv2d: filter must be rank 4, but got rank " + u.rank + ".";
        }), C(c.shape[3] === u.shape[2], function() {
            return "Error in depthwiseConv2d: number of input channels (" + c.shape[3] + ") must match the inChannels dimension in filter " + u.shape[2] + ".";
        }), null == a && (a = [
            1,
            1
        ]), C(Mo(n, a), function() {
            return "Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + a + "'";
        }), null != i && C(A(r), function() {
            return "Error in depthwiseConv2d: pad must be an integer when using, dimRoundingMode " + i + " but got pad " + r + ".";
        });
        var h = So(c.shape, u.shape, n, a, r, i, !0), f = [
            c,
            u
        ], d = Lt.runKernelFunc(function(t, e) {
            var n = t.depthwiseConv2D(c, u, h);
            return e([
                c,
                u
            ]), n;
        }, {
            x: c,
            filter: u
        }, function(t, e) {
            C(Oo(a), function() {
                return "Error in gradient of depthwiseConv2d: dilation rates greater than 1 are not yet supported. Got dilations '" + a + "'";
            });
            var n = e[0], r = e[1];
            return {
                x: function() {
                    return $c(n.shape, t, r, h);
                },
                filter: function() {
                    return Qc(n, t, r.shape, h);
                }
            };
        }, "DepthwiseConv2dNative", h, f);
        return l ? d.as3D(d.shape[1], d.shape[2], d.shape[3]) : d;
    }
}), $c = An({
    depthwiseConv2dDerInput_: function(t, e, n, r) {
        var o = e, a = !1;
        3 === e.rank && (a = !0, o = e.as4D(1, e.shape[0], e.shape[1], e.shape[2]));
        var i = Lt.runKernelFunc(function(t) {
            return t.depthwiseConv2DDerInput(o, n, r);
        }, {
            dy4D: o
        });
        return a ? i.as3D(i.shape[1], i.shape[2], i.shape[3]) : i;
    }
}), Qc = An({
    depthwiseConv2dDerFilter_: function(t, e, n, r) {
        var o = t;
        3 === t.rank && (o = t.as4D(1, t.shape[0], t.shape[1], t.shape[2]));
        var a = e;
        return 3 === a.rank && (a = e.as4D(1, e.shape[0], e.shape[1], e.shape[2])), Lt.runKernelFunc(function(t) {
            return t.depthwiseConv2DDerFilter(o, a, r);
        }, {
            x4D: o,
            dy4D: a
        });
    }
}), Jc = An({
    separableConv2d_: function(t, e, n, r, o, a, i) {
        void 0 === a && (a = [
            1,
            1
        ]), void 0 === i && (i = "NHWC");
        var s = mn(t, "x", "separableConv2d"), u = mn(e, "depthwiseFilter", "separableConv2d"), c = mn(n, "pointwiseFilter", "separableConv2d"), l = s, h = !1;
        if (3 === s.rank && (h = !0, l = s.as4D(1, s.shape[0], s.shape[1], s.shape[2])), "NCHW" === i) throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
        C(4 === l.rank, function() {
            return "Error in separableConv2d: input must be rank 4, but got rank " + l.rank + ".";
        }), C(4 === u.rank, function() {
            return "Error in separableConv2d: depthwise filter must be rank 4, but got rank " + u.rank + ".";
        }), C(4 === c.rank, function() {
            return "Error in separableConv2d: pointwise filter must be rank 4, but got rank " + u.rank + ".";
        }), C(1 === c.shape[0], function() {
            return "Error in separableConv2d: the first dimension of pointwise filter  must be 1, but got " + c.shape[0] + ".";
        }), C(1 === c.shape[1], function() {
            return "Error in separableConv2d: the second dimension of pointwise filter must be 1, but got " + c.shape[1] + ".";
        });
        var f = u.shape[2], d = u.shape[3];
        C(c.shape[2] === f * d, function() {
            return "Error in separableConv2d: the third dimension of pointwise filter must be " + f * d + ", but got " + c.shape[2] + ".";
        });
        var p = Yc(l, u, r, o, i, a), v = qc(p, c, 1, "valid", i);
        return h ? v.as3D(v.shape[1], v.shape[2], v.shape[3]) : v;
    }
}), Zc = An({
    conv2dTranspose_: function(t, e, n, r, o, a) {
        return Vc(n, mn(t, "x", "conv2dTranspose"), mn(e, "filter", "conv2dTranspose"), r, o, "NHWC", a);
    }
}), tl = An({
    conv3dTranspose_: function(t, e, n, r, o) {
        return Gc(n, mn(t, "x", "conv3dTranspose"), mn(e, "filter", "conv3dTranspose"), r, o);
    }
});
var el = An({
    matMul_: function(t, e, n, r) {
        var o;
        void 0 === n && (n = !1), void 0 === r && (r = !1);
        var a = mn(t, "a", "matMul"), i = mn(e, "b", "matMul");
        o = Nt(a, i), a = o[0], i = o[1];
        var s = n ? a.shape[a.rank - 2] : a.shape[a.rank - 1], u = r ? i.shape[i.rank - 1] : i.shape[i.rank - 2], c = n ? a.shape[a.rank - 1] : a.shape[a.rank - 2], l = r ? i.shape[i.rank - 2] : i.shape[i.rank - 1], h = a.shape.slice(0, -2), f = i.shape.slice(0, -2), d = k(h), p = k(f);
        C(a.rank >= 2 && i.rank >= 2 && a.rank === i.rank, function() {
            return "Error in matMul: inputs must have the same rank of at least 2, got ranks " + a.rank + " and " + i.rank + ".";
        }), C(S(h, f), function() {
            return "Error in matMul: outer dimensions (" + h + ") and (" + f + ") of Tensors with shapes " + a.shape + " and " + i.shape + " must match.";
        }), C(s === u, function() {
            return "Error in matMul: inner shapes (" + s + ") and (" + u + ") of Tensors with shapes " + a.shape + " and " + i.shape + " and transposeA=" + n + " and transposeB=" + r + " must match.";
        });
        var v = a.shape.slice(0, -2).concat([
            c,
            l
        ]), m = n ? a.as3D(d, s, c) : a.as3D(d, c, s), g = r ? i.as3D(p, l, u) : i.as3D(p, u, l), y = {
            transposeA: n,
            transposeB: r
        };
        return Lt.runKernelFunc(function(t, e) {
            var o = t.batchMatMul(m, g, n, r);
            return e([
                m,
                g
            ]), o;
        }, {
            a: m,
            b: g
        }, function(t, e) {
            var o = e, a = o[0], i = o[1];
            return n || r ? !n && r ? {
                a: function() {
                    return t.matMul(i, !1, !1);
                },
                b: function() {
                    return t.matMul(a, !0, !1);
                }
            } : n && !r ? {
                a: function() {
                    return i.matMul(t, !1, !0);
                },
                b: function() {
                    return a.matMul(t, !1, !1);
                }
            } : {
                a: function() {
                    return i.matMul(t, !0, !0);
                },
                b: function() {
                    return t.matMul(a, !0, !0);
                }
            } : {
                a: function() {
                    return t.matMul(i, !1, !0);
                },
                b: function() {
                    return a.matMul(t, !0, !1);
                }
            };
        }, "BatchMatMul", y).reshape(v);
    }
}), nl = An({
    dot_: function(t, e) {
        var n = mn(t, "t1", "dot"), r = mn(e, "t2", "dot");
        C(!(1 !== n.rank && 2 !== n.rank || 1 !== r.rank && 2 !== r.rank), function() {
            return "Error in dot: inputs must all be rank 1 or 2, but got ranks " + n.rank + " and " + r.rank + ".";
        });
        var o = 1 === n.rank ? n.size : n.shape[1], a = 1 === r.rank ? r.size : r.shape[0];
        return C(o === a, function() {
            return "Error in dot: inner dimensions of inputs must match, but got " + o + " and " + a + ".";
        }), 1 === n.rank && 1 === r.rank ? n.as2D(1, -1).matMul(r.as2D(-1, 1)).asScalar() : 1 === n.rank && 2 === r.rank ? n.as2D(1, -1).matMul(r.as2D(r.shape[0], r.shape[1])).as1D() : 2 === n.rank && 1 === r.rank ? n.matMul(r.as2D(-1, 1)).as1D() : n.matMul(r.as2D(r.shape[0], r.shape[1]));
    }
}), rl = An({
    outerProduct_: function(t, e) {
        var n = mn(t, "v1", "outerProduct"), r = mn(e, "v2", "outerProduct");
        return C(1 === n.rank && 1 === r.rank, function() {
            return "Error in outerProduct: inputs must be rank 1, but got ranks " + n.rank + " and " + r.rank + ".";
        }), n.as2D(-1, 1).matMul(r.as2D(1, -1));
    }
});
var ol = An({
    reverse_: function(t, e) {
        var n = mn(t, "x", "reverse");
        if (0 === n.rank) return n.clone();
        var r = O(e, n.shape);
        return Lt.runKernelFunc(function(t) {
            return t.reverse(n, r);
        }, {
            $x: n
        }, function(t) {
            return {
                $x: function() {
                    return t.reverse(r);
                }
            };
        }).reshapeAs(n);
    }
}), al = An({
    reverse1d_: function(t) {
        var e = mn(t, "x", "reverse");
        return C(1 === e.rank, function() {
            return "Error in reverse1D: x must be rank 1 but got rank " + e.rank + ".";
        }), ol(e, 0);
    }
}), il = An({
    reverse2d_: function(t, e) {
        var n = mn(t, "x", "reverse");
        return C(2 === n.rank, function() {
            return "Error in reverse2D: x must be rank 2 but got rank " + n.rank + ".";
        }), ol(n, e);
    }
}), sl = An({
    reverse3d_: function(t, e) {
        var n = mn(t, "x", "reverse");
        return C(3 === n.rank, function() {
            return "Error in reverse3D: x must be rank 3 but got rank " + n.rank + ".";
        }), ol(n, e);
    }
}), ul = An({
    reverse4d_: function(t, e) {
        var n = mn(t, "x", "reverse");
        return C(4 === n.rank, function() {
            return "Error in reverse4D: x must be rank 4 but got rank " + n.rank + ".";
        }), ol(n, e);
    }
});
function cl(t, e, n, r, o, a) {
    var i = mn(t, "x", "maxPool"), s = i, u = !1;
    3 === i.rank && (u = !0, s = i.as4D(1, i.shape[0], i.shape[1], i.shape[2])), null == r && (r = [
        1,
        1
    ]), C(4 === s.rank, function() {
        return "Error in maxPool: input must be rank 4 but got rank " + s.rank + ".";
    }), C(Mo(n, r), function() {
        return "Error in maxPool: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + r + "'";
    }), null != a && C(A(o), function() {
        return "Error in maxPool: pad must be an integer when using, dimRoundingMode " + a + " but got pad " + o + ".";
    });
    var c = Io(s.shape, e, n, r, o, a);
    if (1 === c.filterWidth && 1 === c.filterHeight && S(c.inShape, c.outShape)) return i.clone();
    var l = [
        s
    ], h = Lt.runKernelFunc(function(t, e) {
        var n = t.maxPool(s, c);
        return e([
            s,
            n
        ]), n;
    }, {
        x: s
    }, function(t, a) {
        var i = a[0], s = a[1];
        return {
            x: function() {
                return function(t, e, n, r, o, a, i, s) {
                    var u = mn(t, "dy", "maxPoolBackprop"), c = mn(e, "input", "maxPoolBackprop"), l = mn(n, "output", "maxPoolBackprop");
                    C(c.rank === u.rank, function() {
                        return "Rank of input (" + c.rank + ") does not match rank of dy (" + u.rank + ")";
                    }), null == a && (a = [
                        1,
                        1
                    ]);
                    C(Mo(o, a), function() {
                        return "Error in maxPoolBackProp: Either strides or dilations must be 1. Got strides " + o + " and dilations '" + a + "'";
                    }), C(4 === u.rank, function() {
                        return "Error in maxPoolBackprop: dy must be rank 4 but got rank " + u.rank + ".";
                    }), C(4 === c.rank, function() {
                        return "Error in maxPoolBackprop: input must be rank 4 but got rank " + c.rank + ".";
                    }), null != s && C(A(i), function() {
                        return "Error in maxPoolBackprop: pad must be an integer when using, dimRoundingMode " + s + " but got pad " + i + ".";
                    });
                    var h = Io(c.shape, r, o, a, i, s);
                    return Lt.runKernelFunc(function(t) {
                        return t.maxPoolBackprop(u, c, l, h);
                    }, {
                        $dy: u,
                        $input: c
                    });
                }(t, i, s, e, n, r, o);
            }
        };
    }, "MaxPool", c, l);
    return u ? h.as3D(h.shape[1], h.shape[2], h.shape[3]) : h;
}
function ll(t, e, n, r, o, a) {
    var i = mn(t, "x", "avgPool", "float32");
    null == r && (r = [
        1,
        1
    ]), C(Mo(n, r), function() {
        return "Error in avgPool: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + r + "'";
    });
    var s = i, u = !1;
    3 === i.rank && (u = !0, s = i.as4D(1, i.shape[0], i.shape[1], i.shape[2])), C(4 === s.rank, function() {
        return "Error in avgPool: x must be rank 4 but got rank " + s.rank + ".";
    }), null != a && C(A(o), function() {
        return "Error in avgPool: pad must be an integer when using, dimRoundingMode " + a + " but got pad " + o + ".";
    });
    var c = Io(s.shape, e, n, r, o, a);
    if (1 === c.filterWidth && 1 === c.filterHeight && S(c.inShape, c.outShape)) return i.clone();
    var l = Lt.runKernelFunc(function(t) {
        return t.avgPool(s, c);
    }, {
        x: s
    }, function(t) {
        return {
            x: function() {
                return function(t, e, n, r, o, a) {
                    var i = mn(t, "dy", "avgPoolBackprop"), s = mn(e, "input", "avgPoolBackprop");
                    C(s.rank === i.rank, function() {
                        return "Rank of input (" + s.rank + ") does not match rank of dy (" + i.rank + ")";
                    }), null == o && (o = [
                        1,
                        1
                    ]);
                    C(Mo(r, o), function() {
                        return "Error in avgPoolBackprop: Either strides or dilations must be 1. Got strides " + r + " and dilations '" + o + "'";
                    });
                    var u = s, c = i, l = !1;
                    3 === s.rank && (l = !0, u = s.as4D(1, s.shape[0], s.shape[1], s.shape[2]), c = i.as4D(1, i.shape[0], i.shape[1], i.shape[2]));
                    C(4 === c.rank, function() {
                        return "Error in avgPoolBackprop: dy must be rank 4 but got rank " + c.rank + ".";
                    }), C(4 === u.rank, function() {
                        return "Error in avgPoolBackprop: input must be rank 4 but got rank " + u.rank + ".";
                    });
                    var h = Io(u.shape, n, r, o, a), f = Lt.runKernelFunc(function(t) {
                        return t.avgPoolBackprop(c, u, h);
                    }, {
                        dy4D: c,
                        input4D: u
                    });
                    if (l) return f.as3D(f.shape[1], f.shape[2], f.shape[3]);
                    return f;
                }(t, s, e, n, r, o);
            }
        };
    }, "AvgPool", c);
    return l = l.cast(i.dtype), u ? l.as3D(l.shape[1], l.shape[2], l.shape[3]) : l;
}
var hl = An({
    maxPool_: function(t, e, n, r, o) {
        return cl(t, e, n, 1, r, o);
    }
}), fl = An({
    avgPool_: function(t, e, n, r, o) {
        return ll(t, e, n, 1, r, o);
    }
}), dl = An({
    pool_: function(t, e, n, r, o, a) {
        null == o && (o = [
            1,
            1
        ]), null == a && (a = 1), 0 === r && (r = "valid");
        var i = mn(t, "x", "maxPool"), s = i, u = !1;
        3 === i.rank && (u = !0, s = i.as4D(1, i.shape[0], i.shape[1], i.shape[2])), C(Mo(a, o), function() {
            return "Error in pool: Either strides or dilations must be 1. Got strides " + a + " and dilations '" + o + "'";
        });
        var c, l = Io(s.shape, e, a, o, r), h = [
            l.dilationHeight,
            l.dilationWidth
        ];
        c = "same" === r ? function(t, e) {
            var n = t.map(function(t, n) {
                return t + (t - 1) * (e[n] - 1);
            }).map(function(t) {
                return t - 1;
            }), r = n.map(function(t) {
                return Math.floor(t / 2);
            }), o = n.map(function(t, e) {
                return t - r[e];
            });
            return n.map(function(t, e) {
                return [
                    r[e],
                    o[e]
                ];
            });
        }([
            l.filterHeight,
            l.filterWidth
        ], h) : [
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        var f = 1 === h[0] && 1 === h[1], d = function(t, e, n) {
            var r = n.map(function(t) {
                return t[0];
            }), o = n.map(function(t) {
                return t[1];
            }), a = t.concat(r, o), i = e.map(function(t, e) {
                return (t - a[e] % t) % t;
            }), s = o.map(function(t, e) {
                return t + i[e];
            }), u = e.map(function(t, e) {
                return [
                    r[e],
                    s[e]
                ];
            }), c = e.map(function(t, e) {
                return [
                    0,
                    i[e]
                ];
            });
            return [
                u,
                c
            ];
        }([
            l.inHeight,
            l.inWidth
        ], h, c), p = d[0], v = d[1], m = f ? r : "valid", g = f ? s : Mr(s, h, p), y = ("avg" === n ? function() {
            return ll(g, e, a, 1, m);
        } : function() {
            return cl(g, e, a, 1, m);
        })(), x = f ? y : vr(y, h, v);
        return u ? x.as3D(x.shape[1], x.shape[2], x.shape[3]) : x;
    }
}), pl = An({
    maxPool3d_: function(t, e, n, r, o, a, i) {
        void 0 === a && (a = "NDHWC");
        var s = mn(t, "x", "maxPool3d"), u = s, c = !1;
        4 === s.rank && (c = !0, u = s.as5D(1, s.shape[0], s.shape[1], s.shape[2], s.shape[3])), null == i && (i = [
            1,
            1,
            1
        ]), C(5 === u.rank, function() {
            return "Error in maxPool3d: x must be rank 5 but got rank " + u.rank + ".";
        }), C("NDHWC" === a, function() {
            return "Error in maxPool3d: Only NDHWC is currently supported, but got dataFormat of " + a;
        }), C(Mo(n, i), function() {
            return "Error in maxPool3d: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + i + "'";
        }), null != o && C(A(r), function() {
            return "Error in maxPool3d: pad must be an integer when using, dimRoundingMode " + o + " but got pad " + r + ".";
        });
        var l = ko(u.shape, e, n, i, r, o, a), h = Lt.runKernelFunc(function(t, e) {
            var n = t.maxPool3d(u, l);
            return e([
                u,
                n
            ]), n;
        }, {
            x: u
        }, function(t, a) {
            var s = a[0], u = a[1];
            return {
                x: function() {
                    return function(t, e, n, r, o, a, i, s) {
                        var u = mn(t, "dy", "maxPool3dBackprop"), c = mn(e, "input", "maxPool3dBackprop"), l = mn(n, "output", "maxPool3dBackprop"), h = u, f = c, d = l, p = !1;
                        4 === c.rank && (p = !0, h = u.as5D(1, u.shape[0], u.shape[1], u.shape[2], u.shape[3]), f = c.as5D(1, c.shape[0], c.shape[1], c.shape[2], c.shape[3]), d = l.as5D(1, l.shape[0], l.shape[1], l.shape[2], l.shape[3]));
                        C(5 === h.rank, function() {
                            return "Error in maxPool3dBackprop: dy must be rank 5 but got rank " + h.rank + ".";
                        }), C(5 === f.rank, function() {
                            return "Error in maxPool3dBackprop: input must be rank 5 but got rank " + f.rank + ".";
                        }), C(5 === d.rank, function() {
                            return "Error in maxPool3dBackprop: output must be rank 5 but got rank " + d.rank + ".";
                        }), null == a && (a = [
                            1,
                            1,
                            1
                        ]);
                        C(Mo(o, a), function() {
                            return "Error in maxPool3dBackprop: Either strides or dilations must be 1. Got strides " + o + " and dilations '" + a + "'";
                        }), null != s && C(A(i), function() {
                            return "Error in maxPool3dBackprop: pad must be an integer when using, dimRoundingMode " + s + " but got pad " + i + ".";
                        });
                        var v = ko(f.shape, r, o, a, i, s), m = Lt.runKernelFunc(function(t) {
                            return t.maxPool3dBackprop(h, f, d, v);
                        }, {
                            dy5D: h,
                            input5D: f
                        });
                        if (p) return m.as4D(m.shape[1], m.shape[2], m.shape[3], m.shape[4]);
                        return m;
                    }(t, s, u, e, n, i, r, o);
                }
            };
        });
        return c ? h.as4D(h.shape[1], h.shape[2], h.shape[3], h.shape[4]) : h;
    }
}), vl = An({
    avgPool3d_: function(t, e, n, r, o, a, i) {
        void 0 === a && (a = "NDHWC");
        var s = mn(t, "x", "avgPool3d", "float32"), u = s, c = !1;
        4 === s.rank && (c = !0, u = s.as5D(1, s.shape[0], s.shape[1], s.shape[2], s.shape[3])), null == i && (i = [
            1,
            1,
            1
        ]), C(5 === u.rank, function() {
            return "Error in avgPool3d: x must be rank 5 but got rank " + u.rank + ".";
        }), C("NDHWC" === a, function() {
            return "Error in avgPool3d: Only NDHWC is currently supported, but got dataFormat of " + a;
        }), C(Mo(n, i), function() {
            return "Error in avgPool3d: Either strides or dilations must be 1. Got strides " + n + " and dilations '" + i + "'";
        }), null != o && C(A(r), function() {
            return "Error in avgPool3d: pad must be an integer when using, dimRoundingMode " + o + " but got pad " + r + ".";
        });
        var l = ko(u.shape, e, n, i, r, o, a), h = Lt.runKernelFunc(function(t) {
            return t.avgPool3d(u, l);
        }, {
            x: u
        }, function(t) {
            return {
                x: function() {
                    return function(t, e, n, r, o, a, i) {
                        var s = mn(t, "dy", "avgPool3dBackprop"), u = mn(e, "input", "avgPool3dBackprop"), c = s, l = u, h = !1;
                        4 === u.rank && (h = !0, c = s.as5D(1, s.shape[0], s.shape[1], s.shape[2], s.shape[3]), l = u.as5D(1, u.shape[0], u.shape[1], u.shape[2], u.shape[3]));
                        C(5 === c.rank, function() {
                            return "Error in avgPool3dBackprop: dy must be rank 5 but got rank " + c.rank + ".";
                        }), C(5 === l.rank, function() {
                            return "Error in avgPool3dBackprop: input must be rank 5 but got rank " + l.rank + ".";
                        }), null == o && (o = [
                            1,
                            1,
                            1
                        ]);
                        C(Mo(r, o), function() {
                            return "Error in avgPool3dBackprop: Either strides or dilations must be 1. Got strides " + r + " and dilations '" + o + "'";
                        }), null != i && C(A(a), function() {
                            return "Error in maxPool3dBackprop: pad must be an integer when using, dimRoundingMode " + i + " but got pad " + a + ".";
                        });
                        var f = ko(l.shape, n, r, o, a, i), d = Lt.runKernelFunc(function(t) {
                            return t.avgPool3dBackprop(c, l, f);
                        }, {
                            dy5D: c,
                            input5D: l
                        });
                        if (h) return d.as4D(d.shape[1], d.shape[2], d.shape[3], d.shape[4]);
                        return d;
                    }(t, u, e, n, i, r, o);
                }
            };
        });
        return h = h.cast(u.dtype), c ? h.as4D(h.shape[1], h.shape[2], h.shape[3], h.shape[4]) : h;
    }
});
var ml = An({
    slice_: function(t, e, n) {
        var r, o, a = mn(t, "x", "slice");
        if (0 === a.rank) throw new Error("Slicing scalar is not possible");
        (r = "number" == typeof e ? [
            e
        ].concat(new Array(a.rank - 1).fill(0)) : e.length < a.rank ? e.concat(new Array(a.rank - e.length).fill(0)) : e.slice()).forEach(function(t) {
            C(-1 !== t, function() {
                return "slice() does not support negative begin indexing.";
            });
        }), o = (o = null == n ? new Array(a.rank).fill(-1) : "number" == typeof n ? [
            n
        ].concat(new Array(a.rank - 1).fill(-1)) : n.length < a.rank ? n.concat(new Array(a.rank - n.length).fill(-1)) : n).map(function(t, e) {
            return t >= 0 ? t : (C(-1 === t, function() {
                return "Negative size values should be exactly -1 but got " + t + " for the slice() size at index " + e + ".";
            }), a.shape[e] - r[e]);
        }), eo(a, r, o);
        var i = a.shape, s = {
            begin: r,
            size: o
        };
        return Lt.runKernelFunc(function(t) {
            return t.slice(a, r, o);
        }, {
            x: a
        }, function(t) {
            for(var e = [], n = 0; n < t.rank; n++)e.push([
                r[n],
                i[n] - r[n] - o[n]
            ]);
            return {
                x: function() {
                    return t.pad(e);
                }
            };
        }, "Slice", s);
    }
}), gl = An({
    slice1d_: function(t, e, n) {
        var r = mn(t, "x", "slice1d");
        return C(1 === r.rank, function() {
            return "slice1d expects a rank-1 tensor, but got a rank-" + r.rank + " tensor";
        }), ml(r, [
            e
        ], [
            n
        ]);
    }
}), yl = An({
    slice2d_: function(t, e, n) {
        var r = mn(t, "x", "slice2d");
        return C(2 === r.rank, function() {
            return "slice2d expects a rank-2 tensor, but got a rank-" + r.rank + " tensor";
        }), ml(r, e, n);
    }
}), xl = An({
    slice3d_: function(t, e, n) {
        var r = mn(t, "x", "slice3d");
        return C(3 === r.rank, function() {
            return "slice3d expects a rank-3 tensor, but got a rank-" + r.rank + " tensor";
        }), ml(r, e, n);
    }
}), bl = An({
    slice4d_: function(t, e, n) {
        var r = mn(t, "x", "slice4d");
        return C(4 === r.rank, function() {
            return "slice4d expects a rank-4 tensor, but got a rank-" + r.rank + " tensor";
        }), ml(r, e, n);
    }
});
function wl(t, e, n, r, o) {
    return e.rank < n.rank && (e = e.reshape(wn(e.shape, r))), t.rank < n.rank && (t = t.reshape(wn(t.shape, r))), {
        x: function() {
            var r = t.mul(n.equal(e).cast(t.dtype));
            return null == o ? r : r.transpose(o);
        }
    };
}
var Cl = An({
    all_: function(t, e, n) {
        void 0 === e && (e = null), void 0 === n && (n = !1);
        var r = mn(t, "x", "all", "bool"), o = O(e, r.shape), a = o, i = En(a, r.rank);
        null != i && (r = r.transpose(i), a = In(a.length, r.rank));
        var s = Lt.runKernelFunc(function(t) {
            return t.all(r, a);
        }, {
            $x: r
        });
        if (n) {
            var u = wn(s.shape, o);
            return s.reshape(u);
        }
        return s;
    }
}), El = An({
    any_: function(t, e, n) {
        void 0 === e && (e = null), void 0 === n && (n = !1);
        var r = mn(t, "x", "any", "bool"), o = O(e, r.shape), a = o, i = En(a, r.rank);
        null != i && (r = r.transpose(i), a = In(a.length, r.rank));
        var s = Lt.runKernelFunc(function(t) {
            return t.any(r, a);
        }, {
            $x: r
        });
        if (n) {
            var u = wn(s.shape, o);
            return s.reshape(u);
        }
        return s;
    }
}), Rl = An({
    argMax_: function(t, e) {
        void 0 === e && (e = 0);
        var n = mn(t, "x", "argMax");
        null == e && (e = 0);
        var r = O(e, n.shape), o = En(r, n.rank);
        null != o && (n = n.transpose(o), r = In(r.length, n.rank));
        var a = {
            axis: r[0]
        }, i = [
            n
        ];
        return Lt.runKernelFunc(function(t, e) {
            var o = t.argMax(n, r[0]);
            return e([
                n
            ]), o;
        }, {
            x: n
        }, function(t, e) {
            var n = e[0];
            return {
                x: function() {
                    return Xn(n);
                }
            };
        }, "ArgMax", a, i);
    }
}), Il = An({
    argMin_: function(t, e) {
        void 0 === e && (e = 0);
        var n = mn(t, "x", "argMin");
        null == e && (e = 0);
        var r = O(e, n.shape), o = En(r, n.rank);
        return null != o && (n = n.transpose(o), r = In(r.length, n.rank)), Lt.runKernelFunc(function(t, e) {
            var o = t.argMin(n, r[0]);
            return e([
                n
            ]), o;
        }, {
            $x: n
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return Xn(n);
                }
            };
        });
    }
}), kl = An({
    logSumExp_: function(t, e, n) {
        void 0 === e && (e = null), void 0 === n && (n = !1);
        var r = mn(t, "x", "logSumExp"), o = O(e, r.shape), a = r.max(o, !0), i = r.sub(a).exp().sum(o).log(), s = a.reshape(i.shape).add(i);
        if (n) {
            var u = wn(s.shape, o);
            return s.reshape(u);
        }
        return s;
    }
}), Sl = An({
    max_: function(t, e, n) {
        void 0 === e && (e = null), void 0 === n && (n = !1);
        var r = mn(t, "x", "max"), o = r, a = O(e, r.shape), i = a, s = En(i, r.rank);
        null != s && (r = r.transpose(s), i = In(i.length, r.rank));
        var u = [
            r
        ], c = Lt.runKernelFunc(function(t, e) {
            var n = t.max(r, i);
            return e([
                o,
                n
            ]), n;
        }, {
            x: r
        }, function(t, e) {
            return wl(t, e[1], e[0], a, s);
        }, "Max", {
            axes: i
        }, u, [
            !0
        ]);
        if (n) {
            var l = wn(c.shape, a);
            c = c.reshape(l);
        }
        return c;
    }
}), Al = An({
    mean_: function(t, e, n) {
        void 0 === e && (e = null), void 0 === n && (n = !1);
        var r = mn(t, "x", "mean"), o = O(e, r.shape), a = k(bn(r.shape, o)[1]);
        return vo(function(t) {
            var r = On(a);
            return {
                value: (r.dtype === t.dtype ? t : t.cast(r.dtype)).div(r).sum(e, n),
                gradFunc: function(e) {
                    var n = t.shape.slice();
                    return o.forEach(function(t) {
                        n[t] = 1;
                    }), e.reshape(n).mul(zn(t.shape, "float32")).div(a);
                }
            };
        })(r);
    }
}), Dl = An({
    min_: function(t, e, n) {
        void 0 === e && (e = null), void 0 === n && (n = !1);
        var r = mn(t, "x", "min"), o = r, a = O(e, r.shape), i = a, s = En(i, r.rank);
        null != s && (r = r.transpose(s), i = In(i.length, r.rank));
        var u = [
            r
        ], c = Lt.runKernelFunc(function(t, e) {
            var n = t.min(r, i);
            return e([
                o,
                n
            ]), n;
        }, {
            x: r
        }, function(t, e) {
            return wl(t, e[1], e[0], a, s);
        }, "Min", {
            axes: i
        }, u, [
            !0
        ]);
        if (n) {
            var l = wn(c.shape, a);
            c = c.reshape(l);
        }
        return c;
    }
}), Tl = An({
    moments_: function(t, e, n) {
        void 0 === e && (e = null), void 0 === n && (n = !1);
        var r = O(e, (t = mn(t, "x", "moments")).shape), o = t.mean(r, n), a = o.shape;
        n || (a = wn(o.shape, r));
        var i = t.toFloat().sub(o.reshape(a)).square();
        return {
            mean: o,
            variance: i.mean(r, n)
        };
    }
}), Nl = An({
    sum_: function(t, e, n) {
        void 0 === e && (e = null), void 0 === n && (n = !1);
        var r = mn(t, "x", "sum");
        "bool" === r.dtype && (r = r.toInt());
        var o = O(e, r.shape);
        return vo(function(t) {
            var e = En(o, t.rank), r = o, a = t;
            null != e && (a = t.transpose(e), r = In(r.length, t.rank));
            var i = function(e) {
                var n = t.shape.slice();
                return o.forEach(function(t) {
                    n[t] = 1;
                }), e.reshape(n).mul(zn(t.shape, "float32"));
            }, s = {
                axes: r
            }, u = Lt.runKernelFunc(function(t) {
                return t.sum(a, r);
            }, {
                x: a
            }, function(t) {
                return {
                    x: function() {
                        return i(t);
                    }
                };
            }, "Sum", s);
            if (n) {
                var c = wn(u.shape, o);
                u = u.reshape(c);
            }
            return {
                value: u,
                gradFunc: i
            };
        })(r);
    }
}), Fl = An({
    prod_: function(t, e, n) {
        void 0 === e && (e = null), void 0 === n && (n = !1);
        var r = mn(t, "x", "prod");
        "bool" === r.dtype && (r = r.toInt());
        var o = O(e, r.shape), a = En(o, r.rank), i = o, s = r;
        null != a && (s = r.transpose(a), i = In(i.length, r.rank));
        var u = Lt.runKernelFunc(function(t) {
            return t.prod(s, i);
        }, {
            permutedX: s
        });
        if (n) {
            var c = wn(u.shape, o);
            u = u.reshape(c);
        }
        return u;
    }
});
var _l = An({
    elu_: function(t) {
        var e = mn(t, "x", "elu");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.elu(e);
            return n([
                r
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    return Lt.runKernelFunc(function(e) {
                        return e.eluDer(t, n);
                    }, {
                        dy: t,
                        y: n
                    });
                }
            };
        });
    }
}), Ol = An({
    leakyRelu_: function(t, e) {
        void 0 === e && (e = .2);
        var n = mn(t, "x", "leakyRelu");
        return hc(On(e).mul(n), n);
    }
}), Ml = An({
    prelu_: function(t, e) {
        var n = mn(t, "x", "prelu"), r = mn(e, "alpha", "prelu");
        return Lt.runKernelFunc(function(t, e) {
            var o = t.prelu(n, r);
            return e([
                n,
                r
            ]), o;
        }, {
            x: n,
            alpha: r
        }, function(t, e) {
            var n = e[0], r = e[1], o = n.greater(0);
            return {
                x: function() {
                    return ec(o, t, t.mul(r));
                },
                alpha: function() {
                    var e = ec(o, Xn(t), t.mul(n)), a = Eo(r.shape, t.shape);
                    return a.length > 0 && (e = e.sum(a)), e.reshape(r.shape);
                }
            };
        }, "Prelu");
    }
}), Bl = An({
    relu_: function(t) {
        var e = mn(t, "x", "relu");
        return "bool" === e.dtype ? e.toInt() : Lt.runKernelFunc(function(t, n) {
            var r = t.relu(e);
            return n([
                e
            ]), r;
        }, {
            x: e
        }, function(t, e) {
            var n = e[0];
            return {
                x: function() {
                    return t.mulStrict(n.step().toFloat());
                }
            };
        }, "Relu");
    }
}), Pl = An({
    relu6_: function(t) {
        var e = mn(t, "x", "relu6");
        return "bool" === e.dtype ? e.toInt() : Lt.runKernelFunc(function(t, n) {
            var r = t.relu6(e);
            return n([
                e
            ]), r;
        }, {
            x: e
        }, function(t, e) {
            var n = e[0], r = n.lessEqual(6).mul(n.step());
            return {
                x: function() {
                    return t.mulStrict(r.toFloat());
                }
            };
        }, "Relu6");
    }
}), Ll = An({
    selu_: function(t) {
        var e = mn(t, "x", "selu");
        return Lt.runKernelFunc(function(t, n) {
            var r = t.selu(e);
            return n([
                e
            ]), r;
        }, {
            $x: e
        }, function(t, e) {
            var n = e[0];
            return {
                $x: function() {
                    var e = n.greater(On(0)), r = On(bs), o = On(ws), a = t.mul(o), i = t.mul(r).mul(n.toFloat().exp());
                    return ec(e, a, i);
                }
            };
        });
    }
});
var Wl = An({
    transpose_: function(t, e) {
        var n = mn(t, "x", "transpose");
        if (null == e && (e = n.shape.map(function(t, e) {
            return e;
        }).reverse()), C(n.rank === e.length, function() {
            return "Error in transpose: rank of input " + n.rank + " must match length of perm " + e + ".";
        }), e.forEach(function(t) {
            C(t >= 0 && t < n.rank, function() {
                return "All entries in 'perm' must be between 0 and " + (n.rank - 1) + " but got " + e;
            });
        }), n.rank <= 1) return n.clone();
        var r = {
            perm: e
        };
        return Lt.runKernelFunc(function(t) {
            return t.transpose(n, e);
        }, {
            x: n
        }, function(t) {
            var n = Rn(e);
            return {
                x: function() {
                    return t.transpose(n);
                }
            };
        }, "Transpose", r);
    }
});
var Ul = An({
    localResponseNormalization_: function(t, e, n, r, o) {
        void 0 === e && (e = 5), void 0 === n && (n = 1), void 0 === r && (r = 1), void 0 === o && (o = .5);
        var a = mn(t, "x", "localResponseNormalization");
        C(4 === a.rank || 3 === a.rank, function() {
            return "Error in localResponseNormalization: x must be rank 3 or 4 but got\n               rank " + a.rank + ".";
        }), C(A(e), function() {
            return "Error in localResponseNormalization: depthRadius must be an integer but got depthRadius " + e + ".";
        });
        var i = a, s = !1;
        3 === a.rank && (s = !0, i = a.as4D(1, a.shape[0], a.shape[1], a.shape[2]));
        var u = Lt.runKernelFunc(function(t, a) {
            var s = t.localResponseNormalization4D(i, e, n, r, o);
            return a([
                i,
                s
            ]), s;
        }, {
            x4D: i
        }, function(t, a) {
            var i = a[0], s = a[1];
            return {
                x4D: function() {
                    return Lt.runKernelFunc(function(a) {
                        return a.LRNGrad(t, i, s, e, n, r, o);
                    }, {});
                }
            };
        });
        return s ? u.as3D(u.shape[1], u.shape[2], u.shape[3]) : u;
    }
});
var Vl = An({
    norm_: function(t, e, n, r) {
        void 0 === e && (e = "euclidean"), void 0 === n && (n = null), void 0 === r && (r = !1);
        var o = function t(e, n, r) {
            void 0 === r && (r = null);
            if (0 === e.rank) return e.abs();
            if (1 !== e.rank && null === r) return t(e.reshape([
                -1
            ]), n, r);
            if (1 === e.rank || "number" == typeof r || Array.isArray(r) && 1 === r.length) {
                if (1 === n) return e.abs().sum(r);
                if (n === 1 / 0) return e.abs().max(r);
                if (n === -1 / 0) return e.abs().min(r);
                if ("euclidean" === n || 2 === n) return e.abs().pow(On(2, "int32")).sum(r).sqrt();
                throw new Error("Error in norm: invalid ord value: " + n);
            }
            if (Array.isArray(r) && 2 === r.length) {
                if (1 === n) return e.abs().sum(r[0]).max(r[1] - 1);
                if (n === 1 / 0) return e.abs().sum(r[1]).max(r[0]);
                if (n === -1 / 0) return e.abs().sum(r[1]).min(r[0]);
                if ("fro" === n || "euclidean" === n) return e.square().sum(r).sqrt();
                throw new Error("Error in norm: invalid ord value: " + n);
            }
            throw new Error("Error in norm: invalid axis: " + r);
        }(t = mn(t, "x", "norm"), e, n), a = o.shape;
        if (r) {
            var i = O(n, t.shape);
            a = wn(o.shape, i);
        }
        return o.reshape(a);
    }
});
var zl = An({
    basicLSTMCell_: function(t, e, n, r, o, a) {
        var i = mn(t, "forgetBias", "basicLSTMCell"), s = mn(e, "lstmKernel", "basicLSTMCell"), u = mn(n, "lstmBias", "basicLSTMCell"), c = mn(r, "data", "basicLSTMCell"), l = mn(o, "c", "basicLSTMCell"), h = mn(a, "h", "basicLSTMCell"), f = c.concat(h, 1).matMul(s).add(u), d = f.shape[0], p = f.shape[1] / 4, v = [
            d,
            p
        ], m = f.slice([
            0,
            0
        ], v), g = f.slice([
            0,
            p
        ], v), y = f.slice([
            0,
            2 * p
        ], v), x = f.slice([
            0,
            3 * p
        ], v), b = m.sigmoid().mulStrict(g.tanh()).addStrict(l.mulStrict(i.add(y).sigmoid())), w = b.tanh().mulStrict(x.sigmoid());
        return [
            b,
            w
        ];
    }
}), Gl = An({
    multiRNNCell_: function(t, e, n, r) {
        for(var o = mn(e, "data", "multiRNNCell"), a = gn(n, "c", "multiRNNCell"), i = gn(r, "h", "multiRNNCell"), s = o, u = [], c = 0; c < t.length; c++){
            var l = t[c](s, a[c], i[c]);
            u.push(l[0]), u.push(l[1]), s = l[1];
        }
        var h = [], f = [];
        for(c = 0; c < u.length; c += 2)h.push(u[c]), f.push(u[c + 1]);
        return [
            h,
            f
        ];
    }
});
var Hl = An({
    movingAverage_: function(t, e, n, r, o) {
        void 0 === o && (o = !0);
        var a = mn(t, "v", "movingAverage"), i = mn(e, "x", "movingAverage"), s = mn(n, "decay", "movingAverage");
        Ft(a, i), C(S(a.shape, i.shape), function() {
            return "Shape mismatch in v and x";
        });
        var u = On(1), c = u.sub(s), l = i.sub(a).mul(c);
        if (o) {
            C(null != r, function() {
                return "When using zeroDebias: true, step is required.";
            });
            var h = mn(r, "step", "movingAverage");
            l = l.div(u.sub(xc(s, h)));
        }
        return a.add(l);
    }
});
var ql = An({
    stridedSlice_: function(t, e, n, r, o, a, i, s, u) {
        if (void 0 === o && (o = 0), void 0 === a && (a = 0), void 0 === i && (i = 0), void 0 === s && (s = 0), void 0 === u && (u = 0), null == r && (r = new Array(e.length)), 0 !== i) throw new Error("ellipsis mask is not yet supported");
        var c = mn(t, "x", "stridedSlice"), l = no(s), h = c.shape.slice();
        l.forEach(function(t) {
            e[t] = 0, n[t] = 1, h.splice(t, 0, 1);
        }), c = c.reshape(h);
        for(var f = 0; f < c.rank; f++)e[f] = oo(o, e, r, c.shape, f), n[f] = ao(a, n, r, c.shape, f), r[f] = r[f] || 1;
        var d = no(u);
        d.forEach(function(t) {
            n[t] = e[t] + 1, r[t] = 1;
        });
        var p = ro(e, n, r), v = p.filter(function(t, e) {
            return -1 === d.indexOf(e);
        });
        return r.every(function(t) {
            return 1 === t;
        }) ? ml(c, e, p).reshape(v) : Lt.runKernelFunc(function(t) {
            return t.stridedSlice(c, e, n, r);
        }, {
            $x: c
        }).reshape(v);
    }
});
var Kl = An({
    topk_: function(t, e, n) {
        void 0 === e && (e = 1), void 0 === n && (n = !0);
        var r = mn(t, "x", "topk");
        if (0 === r.rank) throw new Error("topk() expects the input to be of rank 1 or higher");
        var o = r.shape[r.shape.length - 1];
        if (e > o) throw new Error("'k' passed to topk() must be <= the last dimension (" + o + ") but got " + e);
        var a = Lt.runKernelFunc(function(t) {
            return t.topk(r, e, n);
        }, {
            $x: r
        });
        return {
            values: a[0],
            indices: a[1]
        };
    }
});
var jl = An({
    scatterND_: function(t, e, n) {
        var r = mn(t, "indices", "scatterND", "int32"), o = mn(e, "updates", "scatterND");
        return Jr(o, r, n), Lt.runKernelFunc(function(t) {
            return t.scatterND(r, o, n);
        }, {
            indices: r,
            updates: o
        }, null, "ScatterNd", {
            shape: n
        });
    }
});
var Xl = An({
    fft_: function(t) {
        C("complex64" === t.dtype, function() {
            return "The dtype for tf.spectral.fft() must be complex64 but got " + t.dtype + ".";
        });
        var e = t.shape[t.shape.length - 1], n = t.size / e, r = t.as2D(n, e);
        return Lt.runKernelFunc(function(t) {
            return t.fft(r);
        }, {
            input: t
        }).reshape(t.shape);
    }
}), Yl = An({
    ifft_: function(t) {
        C("complex64" === t.dtype, function() {
            return "The dtype for tf.spectral.ifft() must be complex64 but got " + t.dtype + ".";
        });
        var e = t.shape[t.shape.length - 1], n = t.size / e, r = t.as2D(n, e);
        return Lt.runKernelFunc(function(t) {
            return t.ifft(r);
        }, {
            input: t
        }).reshape(t.shape);
    }
}), $l = An({
    rfft_: function(t, e) {
        C("float32" === t.dtype, function() {
            return "The dtype for rfft() must be real value but got " + t.dtype;
        });
        var n, r = t.shape[t.shape.length - 1], o = t.size / r;
        if (null != e && e < r) {
            var a = t.shape.map(function(t) {
                return 0;
            }), i = t.shape.map(function(t) {
                return t;
            });
            i[t.shape.length - 1] = e, n = t.slice(a, i), r = e;
        } else if (null != e && e > r) {
            var s = t.shape.map(function(t) {
                return t;
            });
            s[t.shape.length - 1] = e - r, n = t.concat(Gn(s), t.shape.length - 1), r = e;
        } else n = t;
        var u = n.zerosLike(), c = Dn(n, u).as2D(o, r), l = Xl(c), h = Math.floor(r / 2) + 1, f = Tn(l), d = Nn(l), p = f.split([
            h,
            r - h
        ], f.shape.length - 1), v = d.split([
            h,
            r - h
        ], d.shape.length - 1), m = n.shape.slice();
        return m[n.shape.length - 1] = h, Dn(p[0], v[0]).reshape(m);
    }
}), Ql = An({
    irfft_: function(t) {
        var e = t.shape[t.shape.length - 1], n = t.size / e;
        if (e <= 2) {
            var r = t.as2D(n, e), o = Yl(r);
            return Tn(o);
        }
        var a = [
            n,
            2 * (e - 1)
        ], i = Tn(t).as2D(n, e), s = Nn(t).as2D(n, e), u = i.slice([
            0,
            1
        ], [
            n,
            e - 2
        ]).reverse(1), c = s.slice([
            0,
            1
        ], [
            n,
            e - 2
        ]).reverse(1).mul(On(-1)), l = i.concat(u, 1), h = s.concat(c, 1);
        return r = Dn(l, h).as2D(a[0], a[1]), o = Yl(r), Tn(o);
    }
}), Jl = Object.freeze({
    fft: Xl,
    ifft: Yl,
    rfft: $l,
    irfft: Ql
});
var Zl = An({
    sparseToDense_: function(t, e, n, r) {
        void 0 === r && (r = 0);
        var o = mn(t, "sparseIndices", "sparseToDense", "int32"), a = mn(e, "sparseValues", "sparseToDense"), i = mn(r, "defaultValue", "sparseToDense", a.dtype);
        return function(t, e, n, r) {
            if ("int32" !== t.dtype) throw new Error("tf.sparseToDense() expects the indices to be int32 type, but the dtype was " + t.dtype + ".");
            if (t.rank > 2) throw new Error("sparseIndices should be a scalar, vector, or matrix, but got shape " + t.shape + ".");
            var o = t.rank > 0 ? t.shape[0] : 1, a = t.rank > 1 ? t.shape[1] : 1;
            if (n.length !== a) throw new Error("outputShape has incorrect number of elements:, " + n.length + ", should be: " + a + ".");
            var i = e.size;
            if (0 !== e.rank && (1 !== e.rank || i !== o)) throw new Error("sparseValues has incorrect shape " + e.shape + ", should be [] or [" + o + "]");
            if (e.dtype !== r.dtype) throw new Error("sparseValues.dtype must match defaultValues.dtype");
        }(o, a, n, i), Lt.runKernelFunc(function(t) {
            return t.sparseToDense(o, a, n, i);
        }, {
            $sparseIndices: o,
            $sparseValues: a,
            $defaultValue: i
        });
    }
});
var th = An({
    gatherND_: function(t, e) {
        var n = mn(e, "indices", "gatherND", "int32"), r = mn(t, "x", "gatherND");
        return Lt.runKernelFunc(function(t) {
            return t.gatherND(r, n);
        }, {
            x: r,
            indices: n
        }, null, "GatherNd");
    }
});
var eh = An({
    diag_: function(t) {
        var e = mn(t, "x", "diag").flatten(), n = t.shape.concat(t.shape);
        return Lt.runKernelFunc(function(t) {
            return t.diag(e);
        }, {
            $x: e
        }).reshape(n);
    }
});
var nh = An({
    dropout_: function(t, e, n, r) {
        var o = mn(t, "x", "dropout");
        if (C("float32" === o.dtype, function() {
            return "x has to be a floating point tensor since it's going to be scaled, but got a " + o.dtype + " tensor instead.";
        }), C(e >= 0 && e < 1, function() {
            return "rate must be a float in the range [0, 1), but got " + e + ".";
        }), 0 === e) return t instanceof wt ? o.clone() : o;
        var a = function(t, e) {
            if (null == e) return t.shape.slice();
            if (S(t.shape, e)) return e;
            if (t.shape.length === e.length) {
                for(var n = [], r = 0; r < t.shape.length; r++)null == e[r] && null != t.shape[r] ? n.push(t.shape[r]) : n.push(e[r]);
                return n;
            }
            return e;
        }(o, n), i = 1 - e, s = _r(a, 0, 1, "float32", r).add(i).floor().div(i);
        return o.mul(s);
    }
});
function rh(t, e, n) {
    for(var r = 1 - t % 2, o = new Float32Array(t), a = 0; a < t; ++a){
        var i = 2 * Math.PI * a / (t + r - 1);
        o[a] = e - n * Math.cos(i);
    }
    return Mn(o, "float32");
}
var oh = An({
    hannWindow_: function(t) {
        return rh(t, .5, .5);
    }
}), ah = An({
    hammingWindow_: function(t) {
        return rh(t, .54, .46);
    }
}), ih = An({
    frame_: function(t, e, n, r, o) {
        void 0 === r && (r = !1), void 0 === o && (o = 0);
        for(var a = 0, i = []; a + e <= t.size;)i.push(ml(t, a, e)), a += n;
        if (r) for(; a < t.size;){
            var s = a + e - t.size, u = Yn([
                ml(t, a, e - s),
                Hn([
                    s
                ], o)
            ]);
            i.push(u), a += n;
        }
        return 0 === i.length ? Bn([], [
            0,
            e
        ]) : Yn(i).as2D(i.length, e);
    }
}), sh = An({
    stft_: function(t, e, n, r, o) {
        var a;
        void 0 === o && (o = oh), null == r && (a = e, r = Math.floor(Math.pow(2, Math.ceil(Math.log(a) / Math.log(2)))));
        for(var i = ih(t, e, n), s = gc(i, o(e)), u = [], c = 0; c < i.shape[0]; c++)u.push($l(s.slice([
            c,
            0
        ], [
            1,
            e
        ]), r));
        return Yn(u);
    }
}), uh = Object.freeze({
    hannWindow: oh,
    hammingWindow: ah,
    frame: ih,
    stft: sh
});
var ch, lh = function(t, e, o) {
    return void 0 === o && (o = 1), n(this, void 0, void 0, function() {
        var n, a, i, s, u, c, l, h, f, d, p, v, m, g;
        return r(this, function(r) {
            switch(r.label){
                case 0:
                    return n = mn(t, "predictions", "inTopK"), a = mn(e, "targets", "inTopK"), C(n.rank > 1, function() {
                        return "inTopK() expects the predictions to be of rank 2 or higher, but got " + n.rank;
                    }), C(n.rank - 1 === a.rank, function() {
                        return "predictions rank should be 1 larger than targets rank, but got predictions rank " + n.rank + " and targets rank " + a.rank;
                    }), E(n.shape.slice(0, n.shape.length - 1), a.shape, "predictions's shape should be align with the targets' shape, except the last dimension."), i = n.shape[n.shape.length - 1], C(o > 0 && o <= i, function() {
                        return "'k' passed to inTopK() must be > 0 && <= the predictions last dimension (" + i + "), but got " + o;
                    }), [
                        4,
                        n.data()
                    ];
                case 1:
                    return s = r.sent(), [
                        4,
                        a.data()
                    ];
                case 2:
                    for(u = r.sent(), c = [
                        s.length / i,
                        i
                    ], h = c[1], f = B("bool", l = c[0]), d = 0; d < l; d++){
                        for(p = d * h, v = s.subarray(p, p + h), m = [], g = 0; g < v.length; g++)m.push({
                            value: v[g],
                            index: g
                        });
                        for(m.sort(function(t, e) {
                            return e.value - t.value;
                        }), f[d] = 0, g = 0; g < o; g++)if (m[g].index === u[d]) {
                            f[d] = 1;
                            break;
                        }
                    }
                    return t !== n && n.dispose(), e !== a && a.dispose(), [
                        2,
                        Fn(f, a.shape, "bool")
                    ];
            }
        });
    });
};
!function(t) {
    t[t.NONE = 0] = "NONE", t[t.MEAN = 1] = "MEAN", t[t.SUM = 2] = "SUM", t[t.SUM_BY_NONZERO_WEIGHTS = 3] = "SUM_BY_NONZERO_WEIGHTS";
}(ch || (ch = {}));
var hh = An({
    absoluteDifference_: function(t, e, n, r) {
        void 0 === r && (r = ch.SUM_BY_NONZERO_WEIGHTS);
        var o = mn(t, "labels", "absoluteDifference"), a = mn(e, "predictions", "absoluteDifference"), i = null;
        null != n && (i = mn(n, "weights", "absoluteDifference")), E(o.shape, a.shape, "Error in absoluteDifference: ");
        var s = o.sub(a).abs();
        return fh(s, i, r);
    }
}), fh = An({
    computeWeightedLoss_: function(t, e, n) {
        void 0 === n && (n = ch.SUM_BY_NONZERO_WEIGHTS);
        var r = mn(t, "losses", "computeWeightedLoss"), o = null;
        null != e && (o = mn(e, "weights", "computeWeightedLoss"));
        var a = null == o ? r : r.mul(o);
        if (n === ch.NONE) return a;
        if (n === ch.SUM) return a.sum();
        if (n === ch.MEAN) {
            if (null == o) return a.mean();
            var i = r.size / o.size, s = a.sum().div(o.sum());
            return i > 1 ? s.div(On(i)) : s;
        }
        if (n === ch.SUM_BY_NONZERO_WEIGHTS) {
            if (null == o) return a.sum().div(On(r.size));
            var u = o.mul(zn(r.shape)).notEqual(On(0)).sum().toFloat();
            return a.sum().div(u);
        }
        throw Error("Unknown reduction: " + n);
    }
}), dh = An({
    cosineDistance_: function(t, e, n, r, o) {
        void 0 === o && (o = ch.SUM_BY_NONZERO_WEIGHTS);
        var a = mn(t, "labels", "cosineDistance"), i = mn(e, "predictions", "cosineDistance"), s = null;
        null != r && (s = mn(r, "weights", "cosineDistance")), E(a.shape, i.shape, "Error in cosineDistance: ");
        var u = On(1).sub(a.mul(i).sum(n, !0));
        return fh(u, s, o);
    }
}), ph = An({
    hingeLoss_: function(t, e, n, r) {
        void 0 === r && (r = ch.SUM_BY_NONZERO_WEIGHTS);
        var o = mn(t, "labels", "hingeLoss"), a = mn(e, "predictions", "hingeLoss"), i = null;
        null != n && (i = mn(n, "weights", "hingeLoss")), E(o.shape, a.shape, "Error in hingeLoss: ");
        var s = On(1);
        o = On(2).mul(o).sub(s);
        var u = s.sub(o.mul(a)).relu();
        return fh(u, i, r);
    }
}), vh = An({
    huberLoss_: function(t, e, n, r, o) {
        void 0 === r && (r = 1), void 0 === o && (o = ch.SUM_BY_NONZERO_WEIGHTS);
        var a = mn(t, "labels", "huberLoss"), i = mn(e, "predictions", "huberLoss"), s = null;
        null != n && (s = mn(n, "weights", "huberLoss")), E(a.shape, i.shape, "Error in huberLoss: ");
        var u = On(r), c = i.sub(a).abs(), l = dc(c, u), h = c.sub(l), f = On(.5).mul(l.square()).add(u.mul(h));
        return fh(f, s, o);
    }
}), mh = An({
    logLoss_: function(t, e, n, r, o) {
        void 0 === r && (r = 1e-7), void 0 === o && (o = ch.SUM_BY_NONZERO_WEIGHTS);
        var a = mn(t, "labels", "logLoss"), i = mn(e, "predictions", "logLoss"), s = null;
        null != n && (s = mn(n, "weights", "logLoss")), E(a.shape, i.shape, "Error in logLoss: ");
        var u = On(1), c = On(r), l = a.mul(i.add(c).log()).neg().sub(u.sub(a).mul(u.sub(i).add(c).log()));
        return fh(l, s, o);
    }
}), gh = An({
    meanSquaredError_: function(t, e, n, r) {
        void 0 === r && (r = ch.SUM_BY_NONZERO_WEIGHTS);
        var o = mn(t, "labels", "meanSquaredError"), a = mn(e, "predictions", "meanSquaredError"), i = null;
        null != n && (i = mn(n, "weights", "meanSquaredError")), E(o.shape, a.shape, "Error in meanSquaredError: ");
        var s = o.squaredDifference(a);
        return fh(s, i, r);
    }
}), yh = An({
    sigmoidCrossEntropy_: function(t, e, n, r, o) {
        void 0 === r && (r = 0), void 0 === o && (o = ch.SUM_BY_NONZERO_WEIGHTS);
        var a = mn(t, "multiClassLabels", "sigmoidCrossEntropy"), i = mn(e, "logits", "sigmoidCrossEntropy"), s = null;
        if (null != n && (s = mn(n, "weights", "sigmoidCrossEntropy")), E(a.shape, i.shape, "Error in sigmoidCrossEntropy: "), r > 0) {
            var u = On(r), c = On(1), l = On(.5);
            a = a.mul(c.sub(u)).add(l.mul(u));
        }
        var h = function(t, e) {
            var n = mn(t, "labels", "sigmoidCrossEntropyWithLogits"), r = mn(e, "logits", "sigmoidCrossEntropyWithLogits");
            E(n.shape, r.shape, "Error in sigmoidCrossEntropyWithLogits: ");
            var o = r.relu(), a = r.mul(n), i = r.abs().neg().exp().log1p();
            return o.sub(a).add(i);
        }(a, i);
        return fh(h, s, o);
    }
}), xh = An({
    softmaxCrossEntropy_: function(t, e, n, r, o) {
        void 0 === r && (r = 0), void 0 === o && (o = ch.SUM_BY_NONZERO_WEIGHTS);
        var a = mn(t, "onehotLabels", "softmaxCrossEntropy"), i = mn(e, "logits", "softmaxCrossEntropy"), s = null;
        if (null != n && (s = mn(n, "weights", "softmaxCrossEntropy")), E(a.shape, i.shape, "Error in softmaxCrossEntropy: "), r > 0) {
            var u = On(r), c = On(1), l = On(a.shape[1]);
            a = a.mul(c.sub(u)).add(u.div(l));
        }
        var h = function(t, e, n) {
            if (void 0 === n && (n = -1), -1 === n && (n = e.rank - 1), n !== e.rank - 1) throw Error("Softmax cross entropy along a non-last dimension is not yet supported. Labels / logits was rank " + e.rank + " and dim was " + n);
            return vo(function(t, e, r) {
                var o = e.logSumExp([
                    n
                ], !0), a = e.toFloat().sub(o);
                r([
                    t,
                    a
                ]);
                return {
                    value: a.mul(t).neg().sum([
                        n
                    ]),
                    gradFunc: function(t, e) {
                        var r = e[0], o = e[1], a = wn(t.shape, [
                            n
                        ]);
                        return [
                            t.reshape(a).mul(r.toFloat().sub(o.exp())),
                            t.reshape(a).mul(o.exp().sub(r.toFloat()))
                        ];
                    }
                };
            })(t, e);
        }(a, i);
        return fh(h, s, o);
    }
}), bh = Object.freeze({
    get Reduction () {
        return ch;
    },
    absoluteDifference: hh,
    computeWeightedLoss: fh,
    cosineDistance: dh,
    hingeLoss: ph,
    huberLoss: vh,
    logLoss: mh,
    meanSquaredError: gh,
    sigmoidCrossEntropy: yh,
    softmaxCrossEntropy: xh
});
function wh(t, e) {
    return void 0 === e && (e = !1), Lt.tidy(function() {
        if (2 !== t.shape.length) throw new Error("qr2d() requires a 2D Tensor, but got a " + t.shape.length + "D Tensor.");
        for(var n = t.shape[0], r = t.shape[1], o = Cr(n), a = t.clone(), i = Bn([
            [
                1
            ]
        ], [
            1,
            1
        ]), s = i.clone(), u = n >= r ? r : n, c = function(t) {
            var e, u = a, c = s, l = o;
            e = Lt.tidy(function() {
                var e = a.slice([
                    t,
                    t
                ], [
                    n - t,
                    1
                ]), u = e.norm(), c = a.slice([
                    t,
                    t
                ], [
                    1,
                    1
                ]), l = Bn([
                    [
                        -1
                    ]
                ]).where(c.greater(0), Bn([
                    [
                        1
                    ]
                ])), h = c.sub(l.mul(u)), f = e.div(h);
                s = 1 === f.shape[0] ? i.clone() : i.concat(f.slice([
                    1,
                    0
                ], [
                    f.shape[0] - 1,
                    f.shape[1]
                ]), 0);
                var d = l.matMul(h).div(u).neg(), p = a.slice([
                    t,
                    0
                ], [
                    n - t,
                    r
                ]), v = d.mul(s);
                if (0 === t) a = p.sub(v.matMul(s.transpose().matMul(p)));
                else {
                    var m = p.sub(v.matMul(s.transpose().matMul(p)));
                    a = a.slice([
                        0,
                        0
                    ], [
                        t,
                        r
                    ]).concat(m, 0);
                }
                var g = o.slice([
                    0,
                    t
                ], [
                    n,
                    o.shape[1] - t
                ]);
                if (0 === t) o = g.sub(g.matMul(s).matMul(v.transpose()));
                else {
                    var y = g.sub(g.matMul(s).matMul(v.transpose()));
                    o = o.slice([
                        0,
                        0
                    ], [
                        n,
                        t
                    ]).concat(y, 1);
                }
                return [
                    s,
                    a,
                    o
                ];
            }), s = e[0], a = e[1], o = e[2], tn([
                u,
                c,
                l
            ]);
        }, l = 0; l < u; ++l)c(l);
        return !e && n > r && (o = o.slice([
            0,
            0
        ], [
            n,
            r
        ]), a = a.slice([
            0,
            0
        ], [
            r,
            r
        ])), [
            o,
            a
        ];
    });
}
var Ch = An({
    bandPart_: function(t, e, n) {
        if (e % 1 != 0) throw new Error("bandPart(): numLower must be an integer, got " + e + ".");
        if (n % 1 != 0) throw new Error("bandPart(): numUpper must be an integer, got " + n + ".");
        var r = mn(t, "a", "bandPart");
        if (r.rank < 2) throw new Error("bandPart(): Rank must be at least 2, got " + r.rank + ".");
        var o = r.shape, a = r.shape.slice(-2), i = a[0], s = a[1];
        if (!(e <= i)) throw new Error("bandPart(): numLower (" + e + ") must not be greater than the number of rows (" + i + ").");
        if (!(n <= s)) throw new Error("bandPart(): numUpper (" + n + ") must not be greater than the number of columns (" + s + ").");
        e < 0 && (e = i), n < 0 && (n = s);
        var u = Kn(0, i, 1, "int32").reshape([
            -1,
            1
        ]), c = Kn(0, s, 1, "int32"), l = Cc(u, c), h = Qu(l.lessEqual(On(+e, "int32")), l.greaterEqual(On(-n, "int32"))), f = Gn([
            i,
            s
        ], r.dtype);
        return Pr(Ur(r.reshape([
            -1,
            i,
            s
        ])).map(function(t) {
            return ec(h, t, f);
        })).reshape(o);
    }
}), Eh = An({
    gramSchmidt_: function(t) {
        var e;
        if (Array.isArray(t)) {
            e = !1, C(null != t && t.length > 0, function() {
                return "Gram-Schmidt process: input must not be null, undefined, or empty";
            });
            for(var n = t[0].shape[0], r = function(e) {
                C(t[e].shape[0] === n, function() {
                    return "Gram-Schmidt: Non-unique lengths found in the input vectors: (" + t[e].shape[0] + " vs. " + n + ")";
                });
            }, o = 1; o < t.length; ++o)r(o);
        } else e = !0, t = tr(t, t.shape[0], 0).map(function(t) {
            return Br(t, [
                0
            ]);
        });
        C(t.length <= t[0].shape[0], function() {
            return "Gram-Schmidt: Number of vectors (" + t.length + ") exceeds number of dimensions (" + t[0].shape[0] + ").";
        });
        var a = [], i = t, s = function(t) {
            a.push(Lt.tidy(function() {
                var e = i[t];
                if (t > 0) for(var n = 0; n < t; ++n){
                    var r = Nl(a[n].mulStrict(e)).mul(a[n]);
                    e = e.sub(r);
                }
                return e.div(Vl(e, "euclidean"));
            }));
        };
        for(o = 0; o < t.length; ++o)s(o);
        return e ? Pr(a, 0) : a;
    }
}), Rh = An({
    qr_: function(t, e) {
        if (void 0 === e && (e = !1), t.rank < 2) throw new Error("qr() requires input tensor to have a rank >= 2, but got rank " + t.rank);
        if (2 === t.rank) return wh(t, e);
        var n = t.shape.slice(0, t.shape.length - 2).reduce(function(t, e) {
            return t * e;
        }), r = Ur(t.reshape([
            n,
            t.shape[t.shape.length - 2],
            t.shape[t.shape.length - 1]
        ]), 0), o = [], a = [];
        return r.forEach(function(t) {
            var n = wh(t, e), r = n[0], i = n[1];
            o.push(r), a.push(i);
        }), [
            Pr(o, 0).reshape(t.shape),
            Pr(a, 0).reshape(t.shape)
        ];
    }
}), Ih = Object.freeze({
    bandPart: Ch,
    gramSchmidt: Eh,
    qr: Rh
});
function kh(t, e, n, r, o, a) {
    null == r && (r = .5), null == o && (o = Number.NEGATIVE_INFINITY), null == a && (a = 0);
    var i = t.shape[0];
    return n = Math.min(n, i), C(0 <= r && r <= 1, function() {
        return "iouThreshold must be in [0, 1], but was '" + r + "'";
    }), C(2 === t.rank, function() {
        return "boxes must be a 2D tensor, but was of rank '" + t.rank + "'";
    }), C(4 === t.shape[1], function() {
        return "boxes must have 4 columns, but 2nd dimension was " + t.shape[1];
    }), C(1 === e.rank, function() {
        return "scores must be a 1D tensor";
    }), C(e.shape[0] === i, function() {
        return "scores has incompatible shape with boxes. Expected " + i + ", but was " + e.shape[0];
    }), C(0 <= a && a <= 1, function() {
        return "softNmsSigma must be in [0, 1], but was '" + a + "'";
    }), {
        maxOutputSize: n,
        iouThreshold: r,
        scoreThreshold: o,
        softNmsSigma: a
    };
}
var Sh = An({
    resizeBilinear_: function(t, e, n) {
        void 0 === n && (n = !1);
        var r = mn(t, "images", "resizeBilinear");
        C(3 === r.rank || 4 === r.rank, function() {
            return "Error in resizeBilinear: x must be rank 3 or 4, but got rank " + r.rank + ".";
        }), C(2 === e.length, function() {
            return "Error in resizeBilinear: new shape must 2D, but got shape " + e + ".";
        });
        var o = r, a = !1;
        3 === r.rank && (a = !0, o = r.as4D(1, r.shape[0], r.shape[1], r.shape[2]));
        var i = e[0], s = e[1], u = Lt.runKernelFunc(function(t, e) {
            return e([
                o
            ]), t.resizeBilinear(o, i, s, n);
        }, {
            x: o
        }, function(t, e) {
            return {
                x: function() {
                    return Lt.runKernelFunc(function(r) {
                        return r.resizeBilinearBackprop(t, e[0], n);
                    }, {});
                }
            };
        }, "ResizeBilinear", {
            alignCorners: n,
            newHeight: i,
            newWidth: s
        });
        return a ? u.as3D(u.shape[1], u.shape[2], u.shape[3]) : u;
    }
}), Ah = An({
    resizeNearestNeighbor_: function(t, e, n) {
        void 0 === n && (n = !1);
        var r = mn(t, "images", "resizeNearestNeighbor");
        C(3 === r.rank || 4 === r.rank, function() {
            return "Error in resizeNearestNeighbor: x must be rank 3 or 4, but got rank " + r.rank + ".";
        }), C(2 === e.length, function() {
            return "Error in resizeNearestNeighbor: new shape must 2D, but got shape " + e + ".";
        }), C("float32" === r.dtype || "int32" === r.dtype, function() {
            return "`images` must have `int32` or `float32` as dtype";
        });
        var o = r, a = !1;
        3 === r.rank && (a = !0, o = r.as4D(1, r.shape[0], r.shape[1], r.shape[2]));
        var i = e[0], s = e[1], u = Lt.runKernelFunc(function(t, e) {
            return e([
                o
            ]), t.resizeNearestNeighbor(o, i, s, n);
        }, {
            batchImages: o
        }, function(t, e) {
            return {
                batchImages: function() {
                    return Lt.runKernelFunc(function(r) {
                        return r.resizeNearestNeighborBackprop(t, e[0], n);
                    }, {});
                }
            };
        });
        return a ? u.as3D(u.shape[1], u.shape[2], u.shape[3]) : u;
    }
}), Dh = An({
    nonMaxSuppression_: function(t, e, n, r, o) {
        void 0 === r && (r = .5), void 0 === o && (o = Number.NEGATIVE_INFINITY);
        var a = mn(t, "boxes", "nonMaxSuppression"), i = mn(e, "scores", "nonMaxSuppression"), s = kh(a, i, n, r, o);
        n = s.maxOutputSize, r = s.iouThreshold, o = s.scoreThreshold;
        var u = {
            maxOutputSize: n,
            iouThreshold: r,
            scoreThreshold: o
        };
        return Lt.runKernelFunc(function(t) {
            return t.nonMaxSuppression(a, i, n, r, o);
        }, {
            boxes: a,
            scores: i
        }, null, "NonMaxSuppressionV3", u);
    }
}), Th = function(t, e, o, a, i) {
    return void 0 === a && (a = .5), void 0 === i && (i = Number.NEGATIVE_INFINITY), n(this, void 0, void 0, function() {
        var n, s, u, c, l, h, f;
        return r(this, function(r) {
            switch(r.label){
                case 0:
                    return n = mn(t, "boxes", "nonMaxSuppressionAsync"), s = mn(e, "scores", "nonMaxSuppressionAsync"), u = kh(n, s, o, a, i), o = u.maxOutputSize, a = u.iouThreshold, i = u.scoreThreshold, [
                        4,
                        Promise.all([
                            n.data(),
                            s.data()
                        ])
                    ];
                case 1:
                    return c = r.sent(), l = c[0], h = c[1], f = jo(l, h, o, a, i), n !== t && n.dispose(), s !== e && s.dispose(), [
                        2,
                        f
                    ];
            }
        });
    });
}, Nh = An({
    nonMaxSuppressionWithScore_: function(t, e, n, r, o, a) {
        void 0 === r && (r = .5), void 0 === o && (o = Number.NEGATIVE_INFINITY), void 0 === a && (a = 0);
        var i = mn(t, "boxes", "nonMaxSuppression"), s = mn(e, "scores", "nonMaxSuppression"), u = kh(i, s, n, r, o, a), c = {
            maxOutputSize: n = u.maxOutputSize,
            iouThreshold: r = u.iouThreshold,
            scoreThreshold: o = u.scoreThreshold,
            softNmsSigma: a = u.softNmsSigma
        }, l = Lt.runKernel("NonMaxSuppressionV5", {
            boxes: i,
            scores: s
        }, c);
        return {
            selectedIndices: l[0],
            selectedScores: l[1]
        };
    }
}), Fh = function(t, e, o, a, i, s) {
    return void 0 === a && (a = .5), void 0 === i && (i = Number.NEGATIVE_INFINITY), void 0 === s && (s = 0), n(this, void 0, void 0, function() {
        var n, u, c, l, h, f, d;
        return r(this, function(r) {
            switch(r.label){
                case 0:
                    return n = mn(t, "boxes", "nonMaxSuppressionAsync"), u = mn(e, "scores", "nonMaxSuppressionAsync"), c = kh(n, u, o, a, i, s), o = c.maxOutputSize, a = c.iouThreshold, i = c.scoreThreshold, s = c.softNmsSigma, [
                        4,
                        Promise.all([
                            n.data(),
                            u.data()
                        ])
                    ];
                case 1:
                    return l = r.sent(), h = l[0], f = l[1], d = Xo(h, f, o, a, i, s), n !== t && n.dispose(), u !== e && u.dispose(), [
                        2,
                        d
                    ];
            }
        });
    });
}, _h = An({
    cropAndResize_: function(t, e, n, r, o, a) {
        var i = mn(t, "image", "cropAndResize"), s = mn(e, "boxes", "cropAndResize", "float32"), u = mn(n, "boxInd", "cropAndResize", "int32");
        o = o || "bilinear", a = a || 0;
        var c = s.shape[0];
        return C(4 === i.rank, function() {
            return "Error in cropAndResize: image must be rank 4,but got rank " + i.rank + ".";
        }), C(2 === s.rank && 4 === s.shape[1], function() {
            return "Error in cropAndResize: boxes must be have size [" + c + ",4] but had shape " + s.shape + ".";
        }), C(1 === u.rank && u.shape[0] === c, function() {
            return "Error in cropAndResize: boxInd must be have size [" + c + "] but had shape " + s.shape + ".";
        }), C(2 === r.length, function() {
            return "Error in cropAndResize: cropSize must be of length 2, but got length " + r.length + ".";
        }), C(r[0] >= 1 && r[1] >= 1, function() {
            return "cropSize must be atleast [1,1], but was " + r;
        }), C("bilinear" === o || "nearest" === o, function() {
            return "method must be bilinear or nearest, but was " + o;
        }), Lt.runKernelFunc(function(t, e) {
            return t.cropAndResize(i, s, u, r, o, a);
        }, {
            images: i,
            boxes: s,
            boxInd: u
        }, null, "CropAndResize", {
            method: o,
            extrapolationValue: a,
            cropSize: r
        });
    }
}), Oh = Object.freeze({
    resizeBilinear: Sh,
    resizeNearestNeighbor: Ah,
    nonMaxSuppression: Dh,
    nonMaxSuppressionAsync: Th,
    nonMaxSuppressionWithScore: Nh,
    nonMaxSuppressionWithScoreAsync: Fh,
    cropAndResize: _h
}), Mh = function(t, e) {
    return !(t > 0) || "linear" === e;
}, Bh = function(t, e, n) {
    if (null == n || "linear" === n) return t;
    if ("relu" === n) return t.mul(e.step());
    throw new Error("Gradient for activation " + n + " has not been implemented yet.");
}, Ph = function(t, e) {
    var n = e, r = Eo(t.shape, e.shape);
    return r.length > 0 && (n = n.sum(r)), n.reshape(t.shape);
}, Lh = function(t, e, n) {
    if ("linear" === e) return t;
    if ("relu" === e) return Bl(t);
    if ("elu" === e) return _l(t);
    if ("relu6" === e) return Pl(t);
    if ("prelu" === e) return Ml(t, n);
    throw new Error("Unknown fused activation " + e + ".");
};
var Wh = An({
    fusedMatMul_: function(t) {
        var e, n = t.a, r = t.b, o = t.transposeA, a = void 0 !== o && o, i = t.transposeB, s = void 0 !== i && i, u = t.bias, c = t.activation, l = void 0 === c ? "linear" : c, h = t.preluActivationWeights;
        if (!1 === Mh(Lt.state.gradientDepth, l)) {
            var f = el(n, r, a, s);
            return null != u && (f = rc(f, u)), Lh(f, l, h);
        }
        var d = mn(n, "a", "fused matMul"), p = mn(r, "b", "fused matMul");
        e = Nt(d, p), d = e[0], p = e[1];
        var v = a ? d.shape[d.rank - 2] : d.shape[d.rank - 1], m = s ? p.shape[p.rank - 1] : p.shape[p.rank - 2], g = a ? d.shape[d.rank - 1] : d.shape[d.rank - 2], y = s ? p.shape[p.rank - 2] : p.shape[p.rank - 1], x = d.shape.slice(0, -2), b = p.shape.slice(0, -2), w = k(x), E = k(b);
        C(d.rank >= 2 && p.rank >= 2 && d.rank === p.rank, function() {
            return "Error in fused matMul: inputs must have the same rank of at least 2, got ranks " + d.rank + " and " + p.rank + ".";
        }), C(S(x, b), function() {
            return "Error in fused matMul: outer dimensions (" + x + ") and (" + b + ") of Tensors with shapes " + d.shape + " and " + p.shape + " must match.";
        }), C(v === m, function() {
            return "Error in fused matMul: inner shapes (" + v + ") and (" + m + ") of Tensors with shapes " + d.shape + " and " + p.shape + " and transposeA=" + a + " and transposeB=" + s + " must match.";
        });
        var R, I, A = d.shape.slice(0, -2).concat([
            g,
            y
        ]), D = a ? d.as3D(w, v, g) : d.as3D(w, g, v), T = s ? p.as3D(E, y, m) : p.as3D(E, m, y);
        null != u && Ro(A, (R = Nt(R = mn(u, "bias", "fused matMul"), d)[0]).shape), null != h && (I = mn(h, "prelu weights", "fused matMul"));
        var N = {
            a: D,
            b: T
        };
        null != u && (N.bias = R), null != h && (N.preluActivationWeights = I);
        var F = [
            D,
            T
        ];
        return Lt.runKernelFunc(function(t, e) {
            var n = t.fusedBatchMatMul({
                a: D,
                b: T,
                transposeA: a,
                transposeB: s,
                bias: R,
                activation: l,
                preluActivationWeights: I
            });
            return e([
                D,
                T,
                n
            ]), n;
        }, N, function(t, e) {
            var n = e[0], r = e[1], o = e[2], i = Bh(t, o, l), c = {};
            return null != u && (c = {
                bias: function() {
                    return Ph(R, i);
                }
            }), a || s ? !a && s ? Object.assign({
                a: function() {
                    return i.matMul(r, !1, !1);
                },
                b: function() {
                    return i.matMul(n, !0, !1);
                }
            }, c) : a && !s ? Object.assign({
                a: function() {
                    return r.matMul(i, !1, !0);
                },
                b: function() {
                    return n.matMul(i, !1, !1);
                }
            }, c) : Object.assign({
                a: function() {
                    return r.matMul(i, !0, !0);
                },
                b: function() {
                    return i.matMul(n, !0, !0);
                }
            }, c) : Object.assign({
                a: function() {
                    return i.matMul(r, !1, !0);
                },
                b: function() {
                    return n.matMul(i, !0, !1);
                }
            }, c);
        }, "_FusedMatMul", {
            transposeA: a,
            transposeB: s,
            activation: l
        }, F, [
            !0
        ]).reshape(A);
    }
}), Uh = An({
    fusedConv2d_: function(t) {
        var e = t.x, n = t.filter, r = t.strides, o = t.pad, a = t.dataFormat, i = void 0 === a ? "NHWC" : a, s = t.dilations, u = void 0 === s ? [
            1,
            1
        ] : s, c = t.dimRoundingMode, l = t.bias, h = t.activation, f = void 0 === h ? "linear" : h, d = t.preluActivationWeights;
        if (f = f || "linear", !1 === Mh(Lt.state.gradientDepth, f)) {
            var p = qc(e, n, r, o, i, u, c);
            return null != l && (p = rc(p, l)), Lh(p, f, d);
        }
        var v = mn(e, "x", "conv2d"), m = mn(n, "filter", "conv2d"), g = v, y = !1;
        3 === v.rank && (y = !0, g = v.as4D(1, v.shape[0], v.shape[1], v.shape[2])), C(4 === g.rank, function() {
            return "Error in fused conv2d: input must be rank 4, but got rank " + g.rank + ".";
        }), C(4 === m.rank, function() {
            return "Error in fused conv2d: filter must be rank 4, but got rank " + m.rank + ".";
        }), null != c && C(A(o), function() {
            return "Error in fused conv2d: pad must be an integer when using, dimRoundingMode " + c + " but got pad " + o + ".";
        }), C(g.shape[3] === m.shape[2], function() {
            return "Error in conv2d: depth of input (" + g.shape[3] + ") must match input depth for filter " + m.shape[2] + ".";
        }), C(Mo(r, u), function() {
            return "Error in conv2D: Either strides or dilations must be 1. Got strides " + r + " and dilations '" + u + "'";
        }), C("NHWC" === i, function() {
            return "Error in conv2d: got dataFormat of " + i + " but only NHWC is currently supported.";
        });
        var x, b, w = So(g.shape, m.shape, r, u, o, c);
        null != l && (x = Nt(x = mn(l, "bias", "fused conv2d"), v)[0], Ro(w.outShape, x.shape)), null != d && (b = mn(d, "prelu weights", "fused conv2d"));
        var E = {
            x: g,
            filter: m
        };
        null != l && (E.bias = x), null != d && (E.preluActivationWeights = b);
        var R = [
            m,
            g
        ], I = Lt.runKernelFunc(function(t, e) {
            var n = t.fusedConv2d({
                input: g,
                filter: m,
                convInfo: w,
                bias: x,
                activation: f,
                preluActivationWeights: b
            });
            return e([
                m,
                g,
                n
            ]), n;
        }, E, function(t, e) {
            var n = e, a = n[0], i = n[1], s = n[2], c = Bh(t, s, f);
            C(Oo(u), function() {
                return "Error in gradient of fused conv2D: dilation rates greater than 1 are not yet supported in gradients. Got dilations '" + u + "'";
            });
            var h = {};
            return null != l && (h = {
                bias: function() {
                    return Ph(x, c);
                }
            }), Object.assign({
                x: function() {
                    return Xc(i.shape, c, a, r, o);
                },
                filter: function() {
                    return jc(i, c, a.shape, r, o);
                }
            }, h);
        }, "FusedConv2D", {
            convInfo: w,
            activation: f
        }, R, [
            !0
        ]);
        return y ? I.as3D(I.shape[1], I.shape[2], I.shape[3]) : I;
    }
}), Vh = An({
    fusedDepthwiseConv2d_: function(t) {
        var e = t.x, n = t.filter, r = t.strides, o = t.pad, a = t.dataFormat, i = void 0 === a ? "NHWC" : a, s = t.dilations, u = void 0 === s ? [
            1,
            1
        ] : s, c = t.dimRoundingMode, l = t.bias, h = t.activation, f = void 0 === h ? "linear" : h, d = t.preluActivationWeights;
        if (!1 === Mh(Lt.state.gradientDepth, f)) {
            var p = Yc(e, n, r, o, i, u, c);
            return null != l && (p = rc(p, l)), Lh(p, f, d);
        }
        var v = mn(e, "x", "depthwiseConv2d"), m = mn(n, "filter", "depthwiseConv2d"), g = v, y = !1;
        3 === v.rank && (y = !0, g = v.as4D(1, v.shape[0], v.shape[1], v.shape[2])), C(4 === g.rank, function() {
            return "Error in fused depthwiseConv2d: input must be rank 4, but got rank " + g.rank + ".";
        }), C(4 === m.rank, function() {
            return "Error in fused depthwiseConv2d: filter must be rank 4, but got rank " + m.rank + ".";
        }), C(g.shape[3] === m.shape[2], function() {
            return "Error in fused depthwiseConv2d: number of input channels (" + g.shape[3] + ") must match the inChannels dimension in filter " + m.shape[2] + ".";
        }), null == u && (u = [
            1,
            1
        ]), C(Mo(r, u), function() {
            return "Error in fused depthwiseConv2d: Either strides or dilations must be 1. Got strides " + r + " and dilations '" + u + "'";
        }), null != c && C(A(o), function() {
            return "Error in fused depthwiseConv2d: pad must be an integer when using dimRoundingMode " + c + " but got pad " + o + ".";
        });
        var x, b, w = So(g.shape, m.shape, r, u, o, c, !0);
        null != l && (x = Nt(x = mn(l, "bias", "fused conv2d"), v)[0], Ro(w.outShape, x.shape)), null != d && (b = mn(d, "prelu weights", "fused depthwiseConv2d"));
        var E = {
            x: g,
            filter: m
        };
        null != l && (E.bias = x), null != d && (E.preluActivationWeights = b);
        var R = [
            m,
            g
        ], I = Lt.runKernelFunc(function(t, e) {
            var n = t.fusedDepthwiseConv2D({
                input: g,
                filter: m,
                convInfo: w,
                bias: x,
                activation: f,
                preluActivationWeights: b
            });
            return e([
                m,
                g,
                n
            ]), n;
        }, E, function(t, e) {
            C(Oo(u), function() {
                return "Error in gradient of fused depthwiseConv2d: dilation rates greater than 1 are not yet supported. Got dilations '" + u + "'";
            });
            var n = e[0], r = e[1], o = e[2], a = Bh(t, o, f), i = {};
            return null != l && (i = {
                bias: function() {
                    return Ph(x, a);
                }
            }), Object.assign({
                x: function() {
                    return $c(r.shape, a, n, w);
                },
                filter: function() {
                    return Qc(r, a, n.shape, w);
                }
            }, i);
        }, "FusedDepthwiseConv2D", {
            convInfo: w,
            activation: f
        }, R, [
            !0
        ]);
        return y ? I.as3D(I.shape[1], I.shape[2], I.shape[3]) : I;
    }
}), zh = Object.freeze({
    matMul: Wh,
    conv2d: Uh,
    depthwiseConv2d: Vh
}), Gh = Object.freeze({
    image: Oh,
    linalg: Ih,
    losses: bh,
    spectral: Jl,
    fused: zh,
    signal: uh,
    square: tu,
    squaredDifference: nu,
    conv1d: Hc,
    conv2d: qc,
    conv3d: Kc,
    depthwiseConv2d: Yc,
    separableConv2d: Jc,
    conv2dTranspose: Zc,
    conv3dTranspose: tl,
    op: An,
    batchNormalization2d: Gu,
    batchNormalization3d: Hu,
    batchNormalization4d: qu,
    batchNormalization: Ku,
    batchNorm: ju,
    batchNorm2d: Xu,
    batchNorm3d: Yu,
    batchNorm4d: $u,
    booleanMaskAsync: Uc,
    complex: Dn,
    real: Tn,
    imag: Nn,
    concat: Yn,
    concat1d: $n,
    concat2d: Qn,
    concat3d: Jn,
    concat4d: Zn,
    split: tr,
    matMul: el,
    dot: nl,
    outerProduct: rl,
    reverse: ol,
    reverse1d: al,
    reverse2d: il,
    reverse3d: sl,
    reverse4d: ul,
    maxPool: hl,
    avgPool: fl,
    pool: dl,
    maxPool3d: pl,
    avgPool3d: vl,
    slice: ml,
    slice1d: gl,
    slice2d: yl,
    slice3d: xl,
    slice4d: bl,
    abs: ru,
    acos: ou,
    acosh: au,
    asin: iu,
    asinh: su,
    atan: uu,
    atanh: cu,
    ceil: lu,
    clipByValue: hu,
    cos: fu,
    cosh: du,
    erf: pu,
    exp: vu,
    expm1: mu,
    floor: gu,
    log: yu,
    log1p: xu,
    logSigmoid: bu,
    neg: wu,
    reciprocal: Cu,
    round: Eu,
    rsqrt: Ru,
    sigmoid: Iu,
    sign: ku,
    isNaN: Su,
    isInf: Au,
    isFinite: Du,
    sin: Tu,
    sinh: Nu,
    softplus: Fu,
    sqrt: _u,
    step: Ou,
    tan: Mu,
    tanh: Bu,
    all: Cl,
    any: El,
    argMax: Rl,
    argMin: Il,
    logSumExp: kl,
    max: Sl,
    mean: Al,
    min: Dl,
    moments: Tl,
    sum: Nl,
    prod: Fl,
    equal: Rc,
    equalStrict: Ic,
    greater: kc,
    greaterEqual: Sc,
    greaterEqualStrict: Ac,
    greaterStrict: Dc,
    less: Tc,
    lessEqual: Nc,
    lessEqualStrict: Fc,
    lessStrict: _c,
    notEqual: Oc,
    notEqualStrict: Mc,
    add: rc,
    addN: oc,
    addStrict: ac,
    atan2: ic,
    div: sc,
    divNoNan: uc,
    divStrict: cc,
    floorDiv: lc,
    maximum: hc,
    maximumStrict: fc,
    minimum: dc,
    minimumStrict: pc,
    mod: vc,
    modStrict: mc,
    mul: gc,
    mulStrict: yc,
    pow: xc,
    powStrict: bc,
    squaredDifferenceStrict: wc,
    sub: Cc,
    subStrict: Ec,
    elu: _l,
    leakyRelu: Ol,
    prelu: Ml,
    relu: Bl,
    relu6: Pl,
    selu: Ll,
    logicalAnd: Qu,
    logicalNot: Ju,
    logicalOr: Zu,
    logicalXor: tc,
    where: ec,
    whereAsync: nc,
    buffer: dr,
    print: pr,
    batchToSpaceND: vr,
    broadcastTo: mr,
    cast: gr,
    clone: yr,
    cumsum: xr,
    depthToSpace: br,
    expandDims: wr,
    eye: Cr,
    multinomial: Er,
    oneHot: Rr,
    pad: Ir,
    pad1d: kr,
    pad2d: Sr,
    pad3d: Ar,
    pad4d: Dr,
    rand: Tr,
    randomNormal: Nr,
    randomGamma: Fr,
    randomUniform: _r,
    reshape: Or,
    spaceToBatchND: Mr,
    squeeze: Br,
    stack: Pr,
    tile: Lr,
    truncatedNormal: Wr,
    unstack: Ur,
    setdiff1dAsync: Vr,
    fill: Hn,
    linspace: qn,
    ones: zn,
    range: Kn,
    scalar: On,
    tensor: Fn,
    tensor1d: Mn,
    tensor2d: Bn,
    tensor3d: Pn,
    tensor4d: Ln,
    tensor5d: Wn,
    tensor6d: Un,
    variable: Vn,
    zeros: Gn,
    onesLike: jn,
    zerosLike: Xn,
    transpose: Wl,
    softmax: go,
    logSoftmax: yo,
    localResponseNormalization: Ul,
    norm: Vl,
    gather: Lc,
    unsortedSegmentSum: Wc,
    basicLSTMCell: zl,
    multiRNNCell: Gl,
    movingAverage: Hl,
    stridedSlice: ql,
    topk: Kl,
    scatterND: jl,
    fft: Xl,
    ifft: Yl,
    rfft: $l,
    irfft: Ql,
    sparseToDense: Zl,
    gatherND: th,
    diag: eh,
    dropout: nh,
    hannWindow: oh,
    hammingWindow: ah,
    frame: ih,
    stft: sh,
    inTopKAsync: lh
});
function Hh(t, e) {
    Array.isArray(t) || (t = [
        t
    ]), t.forEach(function(t) {
        null != t && C("complex64" !== t.dtype, function() {
            return e + " does not support complex64 tensors.";
        });
    });
}
function qh(t, e, n, r) {
    if ("linear" === n) return t.linear(e);
    if ("relu" === n) return t.relu(e);
    if ("elu" === n) return t.elu(e);
    if ("relu6" === n) return t.relu6(e);
    if ("prelu" === n) return t.prelu(e, r);
    throw new Error("Activation " + n + " has not been implemented for the CPU backend.");
}
var Kh = function(t) {
    function o() {
        var e = t.call(this) || this;
        return e.blockSize = 48, e.firstUse = !0, e.data = new xo(e, Lt), e;
    }
    return e(o, t), o.prototype.write = function(t, e, n) {
        this.firstUse && (this.firstUse = !1, i().get("IS_NODE") && dn("\n============================\nHi there \uD83D\uDC4B. Looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, which binds to TensorFlow C++, by running npm i @tensorflow/tfjs-node, or npm i @tensorflow/tfjs-node-gpu if you have CUDA. Then call require('@tensorflow/tfjs-node'); (-gpu suffix for CUDA) at the start of your program. Visit https://github.com/tensorflow/tfjs-node for more details.\n============================"));
        var r = {};
        return this.data.set(r, {
            values: t,
            dtype: n
        }), r;
    }, o.prototype.move = function(t, e, n, r) {
        this.data.set(t, {
            values: e,
            dtype: r
        });
    }, o.prototype.numDataIds = function() {
        return this.data.numDataIds();
    }, o.prototype.read = function(t) {
        return n(this, void 0, void 0, function() {
            return r(this, function(e) {
                return [
                    2,
                    this.readSync(t)
                ];
            });
        });
    }, o.prototype.readSync = function(t) {
        var e = this.data.get(t), n = e.dtype, r = e.complexTensors;
        return "complex64" === n ? Vo(this.readSync(r.real.dataId), this.readSync(r.imag.dataId)) : this.data.get(t).values;
    }, o.prototype.bufferSync = function(t) {
        var e = this.readSync(t.dataId), n = e;
        if ("string" === t.dtype) try {
            n = e.map(function(t) {
                return ot(t);
            });
        } catch (t) {
            throw new Error("Failed to decode encoded string bytes into utf-8");
        }
        return dr(t.shape, t.dtype, n);
    }, o.prototype.makeOutput = function(t, e, n) {
        var r = this.write(t, e, n);
        return Lt.makeTensorFromDataId(r, e, n, this);
    }, o.prototype.disposeData = function(t) {
        if (this.data.has(t)) {
            var e = this.data.get(t).complexTensors;
            null != e && (e.real.dispose(), e.imag.dispose()), this.data.delete(t);
        }
    }, o.prototype.time = function(t) {
        return n(this, void 0, void 0, function() {
            var e;
            return r(this, function(n) {
                return e = et(), t(), [
                    2,
                    {
                        kernelMs: et() - e
                    }
                ];
            });
        });
    }, o.prototype.memory = function() {
        return {
            unreliable: !0,
            reasons: [
                "The reported memory is an upper bound. Due to automatic garbage collection, the true allocated memory may be less."
            ]
        };
    }, o.prototype.complex = function(t, e) {
        var n = this.makeOutput(null, t.shape, "complex64");
        return this.data.get(n.dataId).complexTensors = {
            real: Lt.keep(t.clone()),
            imag: Lt.keep(e.clone())
        }, n;
    }, o.prototype.real = function(t) {
        return this.data.get(t.dataId).complexTensors.real.clone();
    }, o.prototype.imag = function(t) {
        return this.data.get(t.dataId).complexTensors.imag.clone();
    }, o.prototype.slice = function(t, e, n) {
        if (Hh(t, "slice"), io(t.shape, e, n)) {
            var r = so(e, t.strides), o = k(n);
            return Fn(this.readSync(t.dataId).subarray(r, r + o), n, t.dtype);
        }
        for(var a = dr(n, t.dtype), i = this.bufferSync(t), s = 0; s < a.size; ++s){
            var u = a.indexToLoc(s).map(function(t, n) {
                return t + e[n];
            });
            a.values[s] = i.get.apply(i, u);
        }
        return a.toTensor();
    }, o.prototype.stridedSlice = function(t, e, n, r) {
        Hh(t, "stridedSlice");
        var o = ro(e, n, r);
        if (o.some(function(t) {
            return 0 === t;
        })) return Fn([], o);
        for(var a = dr(o, t.dtype), i = this.bufferSync(t), s = 0; s < a.size; s++){
            for(var u = a.indexToLoc(s), c = new Array(u.length), l = 0; l < c.length; l++)c[l] = u[l] * r[l] + e[l];
            a.set.apply(a, [
                i.get.apply(i, c)
            ].concat(u));
        }
        return a.toTensor();
    }, o.prototype.diag = function(t) {
        for(var e = this.readSync(t.dataId), n = dr([
            t.size,
            t.size
        ], t.dtype), r = n.values, o = 0; o < e.length; o++)r[o * t.size + o] = e[o];
        return n.toTensor();
    }, o.prototype.unstack = function(t, e) {
        for(var n = t.shape[e], r = new Array(t.rank - 1), o = 0, a = 0; a < t.rank; a++)a !== e && (r[o++] = t.shape[a]);
        var i = new Array(t.rank).fill(0), s = t.shape.slice();
        s[e] = 1;
        var u = new Array(n);
        for(a = 0; a < u.length; a++)i[e] = a, u[a] = this.slice(t, i, s).reshape(r);
        return u;
    }, o.prototype.reverse = function(t, e) {
        Hh(t, "reverse");
        for(var n = dr(t.shape, t.dtype), r = this.bufferSync(t), o = function(o) {
            var a = n.indexToLoc(o), i = a.slice();
            e.forEach(function(e) {
                return i[e] = t.shape[e] - 1 - i[e];
            }), n.set.apply(n, [
                r.get.apply(r, i)
            ].concat(a));
        }, a = 0; a < n.size; a++)o(a);
        return n.toTensor();
    }, o.prototype.concat = function(t, e) {
        var n = this;
        if ("complex64" === t[0].dtype) {
            var r = t.map(function(t) {
                return Tn(t);
            }), o = t.map(function(t) {
                return Nn(t);
            });
            return Dn(this.concat(r, e), this.concat(o, e));
        }
        var a = t.map(function(t) {
            var n = k(t.shape.slice(e));
            return t.as2D(-1, n);
        }), i = Sn(a.map(function(t) {
            return t.shape;
        }), 1), s = dr(i, t[0].dtype).values;
        if (1 === a[0].shape[0]) {
            var u = 0;
            a.forEach(function(t) {
                s.set(n.readSync(t.dataId), u), u += t.size;
            });
        } else {
            var c = 0;
            a.forEach(function(t) {
                for(var e = n.readSync(t.dataId), r = 0, o = 0; o < t.shape[0]; ++o)for(var a = o * i[1] + c, u = 0; u < t.shape[1]; ++u)s[a + u] = e[r++];
                c += t.shape[1];
            });
        }
        var l = Sn(t.map(function(t) {
            return t.shape;
        }), e);
        return Fn(s, l, t[0].dtype);
    }, o.prototype.neg = function(t) {
        return Hh(t, "neg"), this.multiply(On(-1), t);
    }, o.prototype.add = function(t, e) {
        return "complex64" === t.dtype || "complex64" === e.dtype ? this.broadcastedBinaryComplexOp(t.cast("complex64"), e.cast("complex64"), function(t, e, n, r) {
            return {
                real: t + n,
                imag: e + r
            };
        }) : this.broadcastedBinaryOp(t, e, Dt(t.dtype, e.dtype), function(t, e) {
            return t + e;
        });
    }, o.prototype.addN = function(t) {
        var e = this;
        Hh(t, "addN");
        for(var n = t.map(function(t) {
            return e.readSync(t.dataId);
        }), r = dr(t[0].shape, t[0].dtype), o = r.values, a = 0; a < t.length; a++)for(var i = n[a], s = 0; s < o.length; s++)o[s] += i[s];
        return r.toTensor();
    }, o.prototype.softmax = function(t, e) {
        var n = O([
            e
        ], t.shape), r = this.max(t, n), o = wn(r.shape, n), a = this.subtract(t, r.reshape(o)), i = this.exp(a), s = this.sum(i, n).reshape(o);
        return this.realDivide(i, s);
    }, o.prototype.subtract = function(t, e) {
        return "complex64" === t.dtype || "complex64" === e.dtype ? this.broadcastedBinaryComplexOp(t.cast("complex64"), e.cast("complex64"), function(t, e, n, r) {
            return {
                real: t - n,
                imag: e - r
            };
        }) : this.broadcastedBinaryOp(t, e, Dt(t.dtype, e.dtype), function(t, e) {
            return t - e;
        });
    }, o.prototype.pow = function(t, e) {
        return Hh([
            t,
            e
        ], "pow"), this.broadcastedBinaryOp(t, e, t.dtype, function(t, e) {
            return Math.pow(t, e);
        });
    }, o.prototype.batchMatMul = function(t, e, n, r) {
        Hh([
            t,
            e
        ], "matMul");
        for(var o = n ? t.shape[1] : t.shape[2], a = n ? t.shape[2] : t.shape[1], i = r ? e.shape[1] : e.shape[2], s = t.shape[0], u = this.readSync(t.dataId), c = this.readSync(e.dataId), l = n ? [
            t.strides[0],
            1,
            t.strides[1]
        ] : [
            t.strides[0],
            t.strides[1],
            1
        ], h = l[0], f = l[1], d = l[2], p = r ? [
            1,
            e.strides[1],
            e.strides[0]
        ] : [
            e.strides[1],
            1,
            e.strides[0]
        ], v = p[0], m = p[1], g = p[2], y = a * i, x = dr([
            s,
            a,
            i
        ], t.dtype), b = x.values, w = this.blockSize, C = 0; C < s; C++)for(var E = 0; E < a; E += w)for(var R = 0; R < i; R += w)for(var I = 0; I < o; I += w)for(var k = Math.min(E + w, a), S = Math.min(R + w, i), A = Math.min(I + w, o), D = E; D < k; D++)for(var T = R; T < S; T++){
            for(var N = 0, F = I; F < A; F++)N += u[C * h + D * f + F * d] * c[F * v + T * m + C * g];
            b[C * y + (D * i + T)] += N;
        }
        return x.toTensor();
    }, o.prototype.fusedBatchMatMul = function(t) {
        var e = t.a, n = t.b, r = t.transposeA, o = t.transposeB, a = t.bias, i = t.activation, s = t.preluActivationWeights, u = this.batchMatMul(e, n, r, o);
        return a && (u = this.add(u, a)), i && (u = qh(this, u, i, s)), u;
    }, o.prototype.multiply = function(t, e) {
        return "complex64" === t.dtype || "complex64" === e.dtype ? this.broadcastedBinaryComplexOp(t.cast("complex64"), e.cast("complex64"), function(t, e, n, r) {
            return {
                real: t * n - e * r,
                imag: t * r + e * n
            };
        }) : this.broadcastedBinaryOp(t, e, Dt(t.dtype, e.dtype), function(t, e) {
            return t * e;
        });
    }, o.prototype.realDivide = function(t, e) {
        Hh([
            t,
            e
        ], "realDivide");
        return this.broadcastedBinaryOp(t, e, "float32", function(t, e) {
            return t / e;
        });
    }, o.prototype.floorDiv = function(t, e) {
        Hh([
            t,
            e
        ], "floorDiv");
        return this.broadcastedBinaryOp(t, e, "int32", function(t, e) {
            return Math.floor(t / e);
        });
    }, o.prototype.sum = function(t, e) {
        Hh(t, "sum"), Cn("sum", e, t.rank);
        for(var n = bn(t.shape, e), r = n[0], o = n[1], a = Gn(r, Dt(t.dtype, "int32")), i = k(o), s = this.readSync(a.dataId), u = this.readSync(t.dataId), c = 0; c < s.length; ++c){
            for(var l = c * i, h = 0, f = 0; f < i; ++f)h += u[l + f];
            s[c] = h;
        }
        return a;
    }, o.prototype.prod = function(t, e) {
        Hh(t, "sum");
        for(var n = bn(t.shape, e), r = n[0], o = n[1], a = Gn(r, Dt(t.dtype, "int32")), i = k(o), s = this.readSync(a.dataId), u = this.readSync(t.dataId), c = 0; c < s.length; ++c){
            for(var l = c * i, h = 1, f = 0; f < i; ++f)h *= u[l + f];
            s[c] = h;
        }
        return a;
    }, o.prototype.unsortedSegmentSum = function(t, e, n) {
        Hh(t, "unsortedSegmentSum");
        for(var r = [], o = t.rank - e.rank, a = 0; a < o; ++a)e = e.expandDims(a + 1);
        for(a = 0; a < n; ++a){
            var i = On(a, "int32"), s = Rc(i, e).asType("float32").mul(t).sum(0);
            r.push(s);
        }
        return Pr(r);
    }, o.prototype.argMin = function(t, e) {
        Hh(t, "argMin");
        var n = [
            e
        ];
        Cn("argMin", n, t.rank);
        for(var r = bn(t.shape, n), o = r[0], a = r[1], i = Gn(o, "int32"), s = k(a), u = this.readSync(i.dataId), c = this.readSync(t.dataId), l = 0; l < u.length; ++l){
            for(var h = l * s, f = c[h], d = 0, p = 0; p < s; ++p){
                var v = c[h + p];
                v < f && (f = v, d = p);
            }
            u[l] = d;
        }
        return i;
    }, o.prototype.argMax = function(t, e) {
        Hh(t, "argMax");
        var n = [
            e
        ];
        Cn("argMax", n, t.rank);
        for(var r = bn(t.shape, n), o = r[0], a = r[1], i = Gn(o, "int32"), s = k(a), u = this.readSync(i.dataId), c = this.readSync(t.dataId), l = 0; l < u.length; ++l){
            for(var h = l * s, f = c[h], d = 0, p = 0; p < s; ++p){
                var v = c[h + p];
                v > f && (f = v, d = p);
            }
            u[l] = d;
        }
        return i;
    }, o.prototype.cumsum = function(t, e, n, r) {
        if (Hh(t, "cumsum"), e !== t.rank - 1) throw new Error("backend.cumsum in CPU expects an inner-most axis=" + (t.rank - 1) + " but got axis=" + e);
        for(var o = Dt(t.dtype, "int32"), a = Gn(t.shape, o), i = this.readSync(a.dataId), s = this.readSync(t.dataId), u = t.shape[t.rank - 1], c = r ? function(t, e) {
            return t + u - e - 1;
        } : function(t, e) {
            return t + e;
        }, l = 0; l < s.length; l += u)for(var h = 0; h < u; h++){
            var f = c(l, h);
            if (0 === h) i[f] = n ? 0 : s[f];
            else {
                var d = c(l, h - 1);
                i[f] = n ? s[d] + i[d] : s[f] + i[d];
            }
        }
        return a;
    }, o.prototype.equal = function(t, e) {
        return Hh([
            t,
            e
        ], "equal"), this.broadcastedBinaryOp(t, e, "bool", function(t, e) {
            return t === e ? 1 : 0;
        });
    }, o.prototype.notEqual = function(t, e) {
        return Hh([
            t,
            e
        ], "notEqual"), this.broadcastedBinaryOp(t, e, "bool", function(t, e) {
            return t !== e ? 1 : 0;
        });
    }, o.prototype.less = function(t, e) {
        return Hh([
            t,
            e
        ], "less"), this.broadcastedBinaryOp(t, e, "bool", function(t, e) {
            return t < e ? 1 : 0;
        });
    }, o.prototype.lessEqual = function(t, e) {
        return Hh([
            t,
            e
        ], "lessEqual"), this.broadcastedBinaryOp(t, e, "bool", function(t, e) {
            return t <= e ? 1 : 0;
        });
    }, o.prototype.greater = function(t, e) {
        return Hh([
            t,
            e
        ], "greater"), this.broadcastedBinaryOp(t, e, "bool", function(t, e) {
            return t > e ? 1 : 0;
        });
    }, o.prototype.greaterEqual = function(t, e) {
        return Hh([
            t,
            e
        ], "greaterEqual"), this.broadcastedBinaryOp(t, e, "bool", function(t, e) {
            return t >= e ? 1 : 0;
        });
    }, o.prototype.logicalNot = function(t) {
        Hh(t, "logicalNot");
        for(var e = this.readSync(t.dataId), n = new Uint8Array(e.length), r = 0; r < e.length; ++r)n[r] = e[r] ? 0 : 1;
        return this.makeOutput(n, t.shape, "bool");
    }, o.prototype.logicalAnd = function(t, e) {
        return Hh([
            t,
            e
        ], "logicalAnd"), this.broadcastedBinaryOp(t, e, "bool", function(t, e) {
            return t && e;
        });
    }, o.prototype.logicalOr = function(t, e) {
        return Hh([
            t,
            e
        ], "logicalOr"), this.broadcastedBinaryOp(t, e, "bool", function(t, e) {
            return t || e;
        });
    }, o.prototype.select = function(t, e, n) {
        Hh([
            t,
            e,
            n
        ], "select");
        for(var r = this.readSync(t.dataId), o = this.readSync(e.dataId), a = this.readSync(n.dataId), i = Gn(e.shape, Dt(e.dtype, n.dtype)), s = this.readSync(i.dataId), u = 0, c = 0 === t.rank || t.rank > 1 || 1 === e.rank ? 1 : k(e.shape.slice(1)), l = 0; l < r.length; l++)for(var h = 0; h < c; h++)1 === r[l] ? s[u++] = o[l] : s[u++] = a[l];
        return i;
    }, o.prototype.where = function(t) {
        Hh([
            t
        ], "where");
        var e = this.readSync(t.dataId);
        return na(t.shape, e);
    }, o.prototype.topk = function(t, e, n) {
        return Hh(t, "topk"), ea(this.readSync(t.dataId), t.shape, t.dtype, e);
    }, o.prototype.min = function(t, e) {
        Hh(t, "min"), Cn("min", e, t.rank);
        for(var n = bn(t.shape, e), r = n[0], o = n[1], a = Gn(r, t.dtype), i = k(o), s = this.readSync(a.dataId), u = this.readSync(t.dataId), c = 0; c < s.length; ++c){
            for(var l = c * i, h = u[l], f = 0; f < i; ++f){
                var d = u[l + f];
                d < h && (h = d);
            }
            s[c] = h;
        }
        return a;
    }, o.prototype.minimum = function(t, e) {
        return Hh([
            t,
            e
        ], "minimum"), this.broadcastedBinaryOp(t, e, t.dtype, function(t, e) {
            return Math.min(t, e);
        });
    }, o.prototype.mod = function(t, e) {
        return Hh([
            t,
            e
        ], "mod"), this.broadcastedBinaryOp(t, e, t.dtype, function(t, e) {
            var n = t % e;
            return t < 0 && e < 0 || t >= 0 && e >= 0 ? n : (n + e) % e;
        });
    }, o.prototype.max = function(t, e) {
        Hh(t, "max"), Cn("max", e, t.rank);
        for(var n = bn(t.shape, e), r = n[0], o = n[1], a = Gn(r, t.dtype), i = k(o), s = this.readSync(a.dataId), u = this.readSync(t.dataId), c = 0; c < s.length; ++c){
            for(var l = c * i, h = u[l], f = 0; f < i; ++f){
                var d = u[l + f];
                d > h && (h = d);
            }
            s[c] = h;
        }
        return a;
    }, o.prototype.maximum = function(t, e) {
        return Hh([
            t,
            e
        ], "maximum"), this.broadcastedBinaryOp(t, e, t.dtype, function(t, e) {
            return Math.max(t, e);
        });
    }, o.prototype.all = function(t, e) {
        Hh(t, "all"), Cn("all", e, t.rank);
        for(var n = bn(t.shape, e), r = n[0], o = n[1], a = Gn(r, t.dtype), i = k(o), s = this.readSync(a.dataId), u = this.readSync(t.dataId), c = 0; c < s.length; ++c){
            for(var l = c * i, h = u[l], f = 0; f < i; ++f){
                var d = u[l + f];
                h = h && d;
            }
            s[c] = h;
        }
        return a;
    }, o.prototype.any = function(t, e) {
        Hh(t, "any"), Cn("any", e, t.rank);
        for(var n = bn(t.shape, e), r = n[0], o = n[1], a = Gn(r, t.dtype), i = k(o), s = this.readSync(a.dataId), u = this.readSync(t.dataId), c = 0; c < s.length; ++c){
            for(var l = c * i, h = u[l], f = 0; f < i; ++f){
                var d = u[l + f];
                h = h || d;
            }
            s[c] = h;
        }
        return a;
    }, o.prototype.squaredDifference = function(t, e) {
        return Hh([
            t,
            e
        ], "squaredDifference"), this.broadcastedBinaryOp(t, e, t.dtype, function(t, e) {
            var n = t - e;
            return n * n;
        });
    }, o.prototype.ceil = function(t) {
        Hh(t, "ceil");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r)n[r] = Math.ceil(e[r]);
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.floor = function(t) {
        Hh(t, "floor");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r)n[r] = Math.floor(e[r]);
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.sign = function(t) {
        Hh(t, "x");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r)e[r] < 0 ? n[r] = -1 : e[r] > 0 ? n[r] = 1 : n[r] = 0;
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.isNaN = function(t) {
        Hh(t, "x");
        for(var e = this.readSync(t.dataId), n = new Uint8Array(e.length), r = 0; r < e.length; ++r)Number.isNaN(e[r]) && (n[r] = 1);
        return this.makeOutput(n, t.shape, "bool");
    }, o.prototype.isInf = function(t) {
        Hh(t, "x");
        for(var e = this.readSync(t.dataId), n = new Uint8Array(e.length), r = 0; r < e.length; ++r)Math.abs(e[r]) === 1 / 0 && (n[r] = 1);
        return this.makeOutput(n, t.shape, "bool");
    }, o.prototype.isFinite = function(t) {
        Hh(t, "x");
        for(var e = this.readSync(t.dataId), n = new Uint8Array(e.length), r = 0; r < e.length; ++r)Number.isFinite(e[r]) && (n[r] = 1);
        return this.makeOutput(n, t.shape, "bool");
    }, o.prototype.round = function(t) {
        Hh(t, "round");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r){
            var o = Math.floor(e[r]);
            e[r] - o < .5 ? n[r] = Math.floor(e[r]) : e[r] - o > .5 ? n[r] = Math.ceil(e[r]) : n[r] = o % 2 == 0 ? o : o + 1;
        }
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.exp = function(t) {
        Hh(t, "exp");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r)n[r] = Math.exp(e[r]);
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.expm1 = function(t) {
        Hh(t, "expm1");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r)n[r] = Math.expm1(e[r]);
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.log = function(t) {
        Hh(t, "log");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r){
            var o = e[r];
            n[r] = Math.log(o);
        }
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.log1p = function(t) {
        Hh(t, "log1p");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r){
            var o = e[r];
            n[r] = Math.log1p(o);
        }
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.sqrt = function(t) {
        Hh(t, "sqrt");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r){
            var o = e[r];
            n[r] = Math.sqrt(o);
        }
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.rsqrt = function(t) {
        Hh(t, "rsqrt");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r){
            var o = e[r];
            n[r] = 1 / Math.sqrt(o);
        }
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.reciprocal = function(t) {
        Hh(t, "reciprocal");
        for(var e = this.readSync(t.dataId), n = new Float32Array(e.length), r = 0; r < e.length; ++r)n[r] = 1 / e[r];
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.linear = function(t) {
        return t;
    }, o.prototype.relu = function(t) {
        Hh(t, "relu");
        for(var e = Gn(t.shape, t.dtype), n = this.readSync(e.dataId), r = this.readSync(t.dataId), o = 0; o < r.length; ++o)n[o] = Math.max(0, r[o]);
        return e;
    }, o.prototype.relu6 = function(t) {
        Hh(t, "relu");
        for(var e = Gn(t.shape, t.dtype), n = this.readSync(e.dataId), r = this.readSync(t.dataId), o = 0; o < r.length; ++o)n[o] = Math.min(Math.max(0, r[o]), 6);
        return e;
    }, o.prototype.prelu = function(t, e) {
        return Hh([
            t,
            e
        ], "prelu"), this.broadcastedBinaryOp(t, e, t.dtype, function(t, e) {
            return t < 0 ? e * t : t;
        });
    }, o.prototype.elu = function(t) {
        Hh(t, "elu");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r){
            var o = n[r];
            e[r] = o >= 0 ? o : Math.exp(o) - 1;
        }
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.eluDer = function(t, e) {
        Hh([
            t,
            e
        ], "eluDer");
        for(var n = new Float32Array(e.size), r = this.readSync(e.dataId), o = this.readSync(t.dataId), a = 0; a < r.length; ++a){
            var i = r[a];
            n[a] = i >= 1 ? o[a] : o[a] * (i + 1);
        }
        return this.makeOutput(n, e.shape, "float32");
    }, o.prototype.selu = function(t) {
        Hh(t, "selu");
        for(var e = bs, n = ws, r = new Float32Array(t.size), o = this.readSync(t.dataId), a = 0; a < o.length; ++a){
            var i = o[a];
            r[a] = i >= 0 ? n * i : e * (Math.exp(i) - 1);
        }
        return this.makeOutput(r, t.shape, "float32");
    }, o.prototype.clip = function(t, e, n) {
        Hh(t, "clip");
        for(var r = new Float32Array(t.size), o = this.readSync(t.dataId), a = 0; a < o.length; ++a){
            var i = o[a];
            r[a] = i > n ? n : i < e ? e : i;
        }
        return this.makeOutput(r, t.shape, "float32");
    }, o.prototype.abs = function(t) {
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.abs(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.complexAbs = function(t) {
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < t.size; ++r){
            var o = n[2 * r], a = n[2 * r + 1];
            e[r] = Math.hypot(o, a);
        }
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.int = function(t) {
        Hh(t, "int");
        for(var e = new Int32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = n[r];
        return this.makeOutput(e, t.shape, "int32");
    }, o.prototype.sigmoid = function(t) {
        Hh(t, "sigmoid");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = 1 / (1 + Math.exp(-n[r]));
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.softplus = function(t) {
        Hh(t, "softplus");
        for(var e = Math.log(1.1920928955078125e-7) + 2, n = new Float32Array(t.size), r = this.readSync(t.dataId), o = 0; o < r.length; ++o){
            var a = r[o] > -e, i = r[o] < e, s = Math.exp(r[o]), u = void 0;
            u = i ? s : a ? r[o] : Math.log(1 + s), n[o] = u;
        }
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.sin = function(t) {
        Hh(t, "sin");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.sin(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.cos = function(t) {
        Hh(t, "cos");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.cos(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.tan = function(t) {
        Hh(t, "tan");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.tan(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.asin = function(t) {
        Hh(t, "asin");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.asin(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.acos = function(t) {
        Hh(t, "acos");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.acos(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.atan = function(t) {
        Hh(t, "atan");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.atan(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.atan2 = function(t, e) {
        return Hh([
            t,
            e
        ], "atan2"), this.broadcastedBinaryOp(t, e, t.dtype, function(t, e) {
            return Math.atan2(t, e);
        });
    }, o.prototype.sinh = function(t) {
        Hh(t, "sinh");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.sinh(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.cosh = function(t) {
        Hh(t, "cosh");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.cosh(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.tanh = function(t) {
        Hh(t, "tanh");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = D(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.asinh = function(t) {
        Hh(t, "asinh");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.asinh(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.acosh = function(t) {
        Hh(t, "acosh");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.acosh(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.atanh = function(t) {
        Hh(t, "atanh");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r)e[r] = Math.atanh(n[r]);
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.erf = function(t) {
        Hh(t, "erf");
        for(var e = new Float32Array(t.size), n = this.readSync(t.dataId), r = 0; r < n.length; ++r){
            var o = Math.sign(n[r]), a = Math.abs(n[r]), i = 1 / (1 + .3275911 * a);
            e[r] = o * (1 - ((((1.061405429 * i - 1.453152027) * i + 1.421413741) * i - .284496736) * i + .254829592) * i * Math.exp(-a * a));
        }
        return this.makeOutput(e, t.shape, "float32");
    }, o.prototype.step = function(t, e) {
        void 0 === e && (e = 0), Hh(t, "step");
        for(var n = new Float32Array(t.size), r = this.readSync(t.dataId), o = 0; o < r.length; ++o){
            var a = r[o];
            isNaN(a) ? n[o] = NaN : n[o] = a > 0 ? 1 : e;
        }
        return this.makeOutput(n, t.shape, "float32");
    }, o.prototype.fusedConv2d = function(t) {
        var e = t.input, n = t.filter, r = t.convInfo, o = t.bias, a = t.activation, i = t.preluActivationWeights, s = this.conv2d(e, n, r);
        return o && (s = this.add(s, o)), a && (s = qh(this, s, a, i)), s;
    }, o.prototype.conv2d = function(t, e, n) {
        Hh([
            t,
            e
        ], "conv2d");
        for(var r = n.filterHeight, o = n.filterWidth, a = n.dilationHeight, i = n.dilationWidth, s = n.padInfo.left, u = n.padInfo.top, c = "channelsLast" === n.dataFormat, l = dr(n.outShape, t.dtype), h = t.strides[0], f = c ? t.strides[1] : t.strides[2], d = c ? t.strides[2] : 1, p = c ? 1 : t.strides[1], v = l.strides[0], m = c ? l.strides[1] : l.strides[2], g = c ? l.strides[2] : 1, y = c ? 1 : l.strides[1], x = this.readSync(t.dataId), b = this.readSync(e.dataId), w = l.values, C = 0; C < n.batchSize; ++C)for(var E = C * h, R = C * v, I = 0; I < n.outHeight; ++I)for(var k = R + I * m, S = I * n.strideHeight - u, A = 0; A < r; A++){
            var D = S + A * a;
            if (!(D < 0 || D >= n.inHeight)) for(var T = A * e.strides[0], N = E + D * f, F = 0; F < n.outWidth; ++F)for(var _ = k + F * g, O = F * n.strideWidth - s, M = 0; M < o; M++){
                var B = O + M * i;
                if (!(B < 0 || B >= n.inWidth)) for(var P = N + B * d, L = T + M * e.strides[1], W = 0; W < n.inChannels; ++W){
                    for(var U = x[P + W * p], V = 0; V < n.outChannels; ++V)w[_ + V * y] += U * b[L + V];
                    L += n.outChannels;
                }
            }
        }
        return l.toTensor();
    }, o.prototype.conv3d = function(t, e, n) {
        for(var r = n.filterDepth, o = n.filterHeight, a = n.filterWidth, i = n.dilationDepth, s = n.dilationHeight, u = n.dilationWidth, c = n.padInfo.front, l = n.padInfo.left, h = n.padInfo.top, f = dr(n.outShape, t.dtype), d = this.readSync(t.dataId), p = this.readSync(e.dataId), v = f.values, m = 0; m < n.batchSize; ++m)for(var g = m * t.strides[0], y = m * f.strides[0], x = 0; x < n.outDepth; ++x)for(var b = y + x * f.strides[1], w = x * n.strideDepth - c, C = 0; C < r; C++){
            var E = w + C * i;
            if (!(E < 0 || E >= n.inDepth)) for(var R = C * e.strides[0], I = g + E * t.strides[1], k = 0; k < n.outHeight; ++k)for(var S = b + k * f.strides[2], A = k * n.strideHeight - h, D = 0; D < o; D++){
                var T = A + D * s;
                if (!(T < 0 || T >= n.inHeight)) for(var N = R + D * e.strides[1], F = I + T * t.strides[2], _ = 0; _ < n.outWidth; ++_)for(var O = S + _ * n.outChannels, M = _ * n.strideWidth - l, B = 0; B < a; B++){
                    var P = M + B * u;
                    if (!(P < 0 || P >= n.inWidth)) for(var L = N + B * e.strides[2], W = F + P * n.inChannels, U = L, V = 0; V < n.inChannels; ++V){
                        for(var z = d[W + V], G = 0; G < n.outChannels; ++G)v[O + G] += z * p[U + G];
                        U += n.outChannels;
                    }
                }
            }
        }
        return f.toTensor();
    }, o.prototype.conv2dDerInput = function(t, e, n) {
        Hh([
            t,
            e
        ], "conv2dDerInput");
        for(var r = dr(n.inShape, "float32"), o = r.values, a = this.readSync(t.dataId), i = this.readSync(e.dataId), s = e.strides, u = s[0], c = s[1], l = s[2], h = n.batchSize, f = n.filterHeight, d = n.filterWidth, p = n.inChannels, v = n.inHeight, m = n.inWidth, g = n.outChannels, y = n.outHeight, x = n.outWidth, b = n.strideHeight, w = n.strideWidth, C = n.dataFormat, E = f - 1 - n.padInfo.top, R = d - 1 - n.padInfo.left, I = "channelsLast" === C, k = r.strides[0], S = I ? r.strides[1] : r.strides[2], A = I ? r.strides[2] : 1, D = I ? 1 : r.strides[1], T = t.strides[0], N = I ? t.strides[1] : t.strides[2], F = I ? t.strides[2] : 1, _ = I ? 1 : t.strides[1], O = 0; O < h; ++O)for(var M = 0; M < p; ++M)for(var B = 0; B < v; ++B)for(var P = B - E, L = Math.max(0, Math.ceil(P / b)), W = Math.min(y, (f + P) / b), U = 0; U < m; ++U){
            for(var V = U - R, z = Math.max(0, Math.ceil(V / w)), G = Math.min(x, (d + V) / w), H = 0, q = L; q < W; ++q)for(var K = q * b - P, j = z; j < G; ++j)for(var X = T * O + N * q + F * j, Y = u * (f - 1 - K) + c * (d - 1 - (j * w - V)) + l * M, $ = 0; $ < g; ++$)H += a[X + _ * $] * i[Y + $];
            o[k * O + S * B + A * U + D * M] = H;
        }
        return r.toTensor();
    }, o.prototype.conv3dDerInput = function(t, e, n) {
        for(var r = dr(n.inShape, "float32"), o = r.values, a = r.strides, i = a[0], s = a[1], u = a[2], c = a[3], l = this.readSync(t.dataId), h = t.strides, f = h[0], d = h[1], p = h[2], v = h[3], m = this.readSync(e.dataId), g = e.strides, y = g[0], x = g[1], b = g[2], w = g[3], C = n.batchSize, E = n.filterDepth, R = n.filterHeight, I = n.filterWidth, k = n.inChannels, S = n.inDepth, A = n.inHeight, D = n.inWidth, T = n.outChannels, N = n.outDepth, F = n.outHeight, _ = n.outWidth, O = n.strideDepth, M = n.strideHeight, B = n.strideWidth, P = E - 1 - n.padInfo.front, L = R - 1 - n.padInfo.top, W = I - 1 - n.padInfo.left, U = 0; U < C; ++U)for(var V = 0; V < k; ++V)for(var z = 0; z < S; ++z)for(var G = z - P, H = Math.max(0, Math.ceil(G / O)), q = Math.min(N, (E + G) / O), K = 0; K < A; ++K)for(var j = K - L, X = Math.max(0, Math.ceil(j / M)), Y = Math.min(F, (R + j) / M), $ = 0; $ < D; ++$){
            for(var Q = $ - W, J = Math.max(0, Math.ceil(Q / B)), Z = Math.min(_, (I + Q) / B), tt = 0, et = H; et < q; ++et)for(var nt = et * O - G, rt = X; rt < Y; ++rt)for(var ot = rt * M - j, at = J; at < Z; ++at)for(var it = f * U + d * et + p * rt + v * at, st = y * (E - 1 - nt) + x * (R - 1 - ot) + b * (I - 1 - (at * B - Q)) + w * V, ut = 0; ut < T; ++ut)tt += l[it + ut] * m[st + ut];
            o[i * U + s * z + u * K + c * $ + V] = tt;
        }
        return r.toTensor();
    }, o.prototype.conv2dDerFilter = function(t, e, n) {
        Hh([
            t,
            e
        ], "conv2dDerFilter");
        for(var r = n.strideHeight, o = n.strideWidth, a = n.filterHeight, i = n.filterWidth, s = "channelsLast" === n.dataFormat, u = dr(n.filterShape, "float32"), c = n.padInfo.left, l = n.padInfo.top, h = this.bufferSync(t), f = this.bufferSync(e), d = 0; d < a; ++d)for(var p = Math.max(0, Math.ceil((l - d) / r)), v = Math.min(n.outHeight, (n.inHeight + l - d) / r), m = 0; m < i; ++m)for(var g = Math.max(0, Math.ceil((c - m) / o)), y = Math.min(n.outWidth, (n.inWidth + c - m) / o), x = 0; x < n.inChannels; ++x)for(var b = 0; b < n.outChannels; ++b){
            for(var w = 0, C = 0; C < n.batchSize; ++C)for(var E = p; E < v; ++E)for(var R = d + E * r - l, I = g; I < y; ++I){
                var k = m + I * o - c;
                w += s ? h.get(C, R, k, x) * f.get(C, E, I, b) : h.get(C, x, R, k) * f.get(C, b, E, I);
            }
            u.set(w, d, m, x, b);
        }
        return u.toTensor();
    }, o.prototype.conv3dDerFilter = function(t, e, n) {
        for(var r = n.strideDepth, o = n.strideHeight, a = n.strideWidth, i = n.filterDepth, s = n.filterHeight, u = n.filterWidth, c = dr(n.filterShape, "float32"), l = c.values, h = c.strides, f = h[0], d = h[1], p = h[2], v = h[3], m = this.readSync(e.dataId), g = e.strides, y = g[0], x = g[1], b = g[2], w = g[3], C = this.readSync(t.dataId), E = t.strides, R = E[0], I = E[1], k = E[2], S = E[3], A = n.padInfo.front, D = n.padInfo.left, T = n.padInfo.top, N = 0; N < i; ++N)for(var F = Math.max(0, Math.ceil((A - N) / r)), _ = Math.min(n.outDepth, (n.inDepth + A - N) / r), O = N * f, M = 0; M < s; ++M)for(var B = Math.max(0, Math.ceil((T - M) / o)), P = Math.min(n.outHeight, (n.inHeight + T - M) / o), L = M * d + O, W = 0; W < u; ++W)for(var U = Math.max(0, Math.ceil((D - W) / a)), V = Math.min(n.outWidth, (n.inWidth + D - W) / a), z = W * p + L, G = 0; G < n.inChannels; ++G)for(var H = G * v + z, q = 0; q < n.outChannels; ++q){
            for(var K = 0, j = 0; j < n.batchSize; ++j)for(var X = j * R, Y = j * y, $ = F; $ < _; ++$)for(var Q = (N + $ * r - A) * I + X, J = $ * x + Y, Z = B; Z < P; ++Z)for(var tt = (M + Z * o - T) * k + Q, et = Z * b + J, nt = U; nt < V; ++nt){
                var rt = nt * w + et;
                K += C[(W + nt * a - D) * S + tt + G] * m[rt + q];
            }
            l[H + q] = K;
        }
        return c.toTensor();
    }, o.prototype.fusedDepthwiseConv2D = function(t) {
        var e = t.input, n = t.filter, r = t.convInfo, o = t.bias, a = t.activation, i = t.preluActivationWeights, s = this.depthwiseConv2D(e, n, r);
        return o && (s = this.add(s, o)), a && (s = qh(this, s, a, i)), s;
    }, o.prototype.depthwiseConv2D = function(t, e, n) {
        Hh([
            t,
            e
        ], "depthwiseConv2D");
        for(var r = n.filterHeight, o = n.filterWidth, a = n.dilationHeight, i = n.dilationWidth, s = n.padInfo.left, u = n.padInfo.top, c = n.outChannels / n.inChannels, l = dr(n.outShape, t.dtype), h = this.readSync(t.dataId), f = this.readSync(e.dataId), d = l.values, p = 0; p < n.batchSize; ++p)for(var v = p * t.strides[0], m = p * l.strides[0], g = 0; g < n.outHeight; ++g)for(var y = m + g * l.strides[1], x = g * n.strideHeight - s, b = 0; b < r; ++b){
            var w = x + b * a;
            if (!(w < 0 || w >= n.inHeight)) for(var C = b * e.strides[0], E = v + w * t.strides[1], R = 0; R < n.outWidth; ++R)for(var I = y + R * l.strides[2], k = R * n.strideWidth - u, S = 0; S < o; ++S){
                var A = k + S * i;
                if (!(A < 0 || A >= n.inWidth)) for(var D = C + S * e.strides[1], T = E + A * n.inChannels, N = I, F = D, _ = 0; _ < n.inChannels; ++_){
                    for(var O = h[T + _], M = 0; M < c; ++M)d[N + M] += O * f[F + M];
                    N += c, F += c;
                }
            }
        }
        return l.toTensor();
    }, o.prototype.depthwiseConv2DDerInput = function(t, e, n) {
        Hh([
            t,
            e
        ], "depthwiseConv2DDerInput");
        for(var r = dr(n.inShape, "float32"), o = r.values, a = r.strides, i = a[0], s = a[1], u = a[2], c = this.readSync(t.dataId), l = t.strides, h = l[0], f = l[1], d = l[2], p = this.readSync(e.dataId), v = e.strides, m = v[0], g = v[1], y = v[2], x = n.batchSize, b = n.filterHeight, w = n.filterWidth, C = n.inChannels, E = n.inHeight, R = n.inWidth, I = n.outChannels, k = n.outHeight, S = n.outWidth, A = n.strideHeight, D = n.strideWidth, T = b - 1 - n.padInfo.top, N = w - 1 - n.padInfo.left, F = I / C, _ = 0; _ < x; ++_)for(var O = 0; O < C; ++O)for(var M = 0; M < E; ++M)for(var B = M - T, P = Math.max(0, Math.ceil(B / A)), L = Math.min(k, (b + B) / A), W = 0; W < R; ++W){
            for(var U = W - N, V = Math.max(0, Math.ceil(U / D)), z = Math.min(S, (w + U) / D), G = 0, H = P; H < L; ++H)for(var q = H * A - B, K = V; K < z; ++K)for(var j = h * _ + f * H + d * K, X = m * (b - 1 - q) + g * (w - 1 - (K * D - U)) + y * O, Y = 0; Y < F; ++Y)G += c[j + (O * F + Y)] * p[X + Y];
            o[i * _ + s * M + u * W + O] = G;
        }
        return r.toTensor();
    }, o.prototype.depthwiseConv2DDerFilter = function(t, e, n) {
        Hh([
            t,
            e
        ], "depthwiseConv2DDerFilter");
        for(var r = n.strideHeight, o = n.strideWidth, a = n.filterHeight, i = n.filterWidth, s = dr(n.filterShape, "float32"), u = n.padInfo.left, c = n.padInfo.top, l = n.outChannels / n.inChannels, h = this.bufferSync(t), f = this.bufferSync(e), d = 0; d < a; ++d)for(var p = Math.max(0, Math.ceil((c - d) / r)), v = Math.min(n.outHeight, (n.inHeight + c - d) / r), m = 0; m < i; ++m)for(var g = Math.max(0, Math.ceil((u - m) / o)), y = Math.min(n.outWidth, (n.inWidth + u - m) / o), x = 0; x < n.outChannels; ++x){
            for(var b = Math.trunc(x / l), w = x % l, C = 0, E = 0; E < n.batchSize; ++E)for(var R = p; R < v; ++R)for(var I = d + R * r - c, k = g; k < y; ++k){
                var S = m + k * o - u;
                C += h.get(E, I, S, b) * f.get(E, R, k, x);
            }
            s.set(C, d, m, b, w);
        }
        return s.toTensor();
    }, o.prototype.tile = function(t, e) {
        return Hh(t, "tile"), ta(this.bufferSync(t), e);
    }, o.prototype.pad = function(t, e, n) {
        Hh(t, "pad");
        var r = e.map(function(e, n) {
            return e[0] + t.shape[n] + e[1];
        }), o = e.map(function(t) {
            return t[0];
        }), a = this.bufferSync(t), i = dr(r, t.dtype);
        0 !== n && i.values.fill(n);
        for(var s = 0; s < t.size; s++){
            var u = a.indexToLoc(s), c = u.map(function(t, e) {
                return t + o[e];
            });
            i.set.apply(i, [
                a.get.apply(a, u)
            ].concat(c));
        }
        return i.toTensor();
    }, o.prototype.transpose = function(t, e) {
        Hh(t, "transpose");
        for(var n = new Array(t.rank), r = 0; r < n.length; r++)n[r] = t.shape[e[r]];
        var o = this.readSync(t.dataId), a = dr(n, t.dtype), i = this.bufferSync(t);
        for(r = 0; r < t.size; ++r){
            for(var s = i.indexToLoc(r), u = new Array(s.length), c = 0; c < u.length; c++)u[c] = s[e[c]];
            var l = a.locToIndex(u);
            a.values[l] = o[r];
        }
        return a.toTensor();
    }, o.prototype.gather = function(t, e, n) {
        Hh([
            t,
            e
        ], "gather");
        var r = t.shape.slice(), o = this.readSync(e.dataId);
        r[n] = o.length;
        for(var a = dr(r, t.dtype), i = this.bufferSync(t), s = 0; s < a.size; ++s){
            var u = a.indexToLoc(s), c = u.slice();
            c[n] = o[u[n]];
            var l = i.locToIndex(c);
            a.values[s] = i.values[l];
        }
        return a.toTensor();
    }, o.prototype.batchToSpaceND = function(t, e, n) {
        Hh([
            t
        ], "batchToSpaceND");
        var r = e.reduce(function(t, e) {
            return t * e;
        }), o = zr(t.shape, e, r), a = Gr(o.length, e.length), i = Hr(t.shape, e, r), s = qr(n, e.length), u = Kr(i, n, e.length);
        return t.reshape(o).transpose(a).reshape(i).slice(s, u);
    }, o.prototype.spaceToBatchND = function(t, e, n) {
        Hh([
            t
        ], "spaceToBatchND");
        var r = e.reduce(function(t, e) {
            return t * e;
        }), o = [
            [
                0,
                0
            ]
        ];
        o.push.apply(o, n);
        for(var a = 1 + e.length; a < t.shape.length; ++a)o.push([
            0,
            0
        ]);
        var i = t.pad(o), s = zr(i.shape, e, r, !1), u = Gr(s.length, e.length, !1), c = Hr(i.shape, e, r, !1);
        return i.reshape(s).transpose(u).reshape(c);
    }, o.prototype.pool = function(t, e, n) {
        Hh(t, "pool");
        for(var r = e.strideHeight, o = e.strideWidth, a = e.dilationHeight, i = e.dilationWidth, s = e.effectiveFilterHeight, u = e.effectiveFilterWidth, c = e.padInfo.top, l = e.padInfo.left, h = "max" === n ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY, f = this.readSync(t.dataId), d = dr(e.outShape, t.dtype), p = d.values, v = e.outShape[1] * e.outShape[2] * e.outShape[3], m = e.outShape[2] * e.outShape[3], g = e.outShape[3], y = 0; y < e.batchSize; ++y)for(var x = y * v, b = y * t.strides[0], w = 0; w < e.inChannels; ++w)for(var C = 0; C < e.outHeight; ++C)for(var E = C * r - c, R = Math.max(0, E), I = Math.min(e.inHeight, s + E), k = x + C * m, S = 0; S < e.outWidth; ++S){
            for(var A = S * o - l, D = Math.max(0, A), T = Math.min(e.inWidth, u + A), N = h, F = 0, _ = 0, O = R; O < I; O += a){
                for(var M = b + O * t.strides[1], B = D; B < T; B += i){
                    var P = f[M + B * t.strides[2] + w];
                    "max" === n && P > N ? N = P : "avg" === n && (F += P, _++);
                }
                if (isNaN(N)) break;
            }
            p[k + S * g + w] = "avg" === n ? F / _ : N;
        }
        return d.toTensor();
    }, o.prototype.maxPool = function(t, e) {
        return this.pool(t, e, "max");
    }, o.prototype.maxPoolPositions = function(t, e) {
        for(var n = dr(e.outShape, "int32"), r = e.strideHeight, o = e.strideWidth, a = e.dilationHeight, i = e.dilationWidth, s = e.effectiveFilterHeight, u = e.effectiveFilterWidth, c = e.padInfo.top, l = e.padInfo.left, h = this.bufferSync(t), f = 0; f < e.batchSize; ++f)for(var d = 0; d < e.inChannels; ++d)for(var p = 0; p < e.outHeight; ++p){
            for(var v = p * r - c, m = v; m < 0;)m += a;
            for(var g = Math.min(e.inHeight, s + v), y = 0; y < e.outWidth; ++y){
                for(var x = y * o - l, b = x; b < 0;)b += i;
                for(var w = Math.min(e.inWidth, u + x), C = Number.NEGATIVE_INFINITY, E = -1, R = m; R < g; R += a)for(var I = R - v, k = b; k < w; k += i){
                    var S = k - x, A = h.get(f, R, k, d);
                    A > C && (C = A, E = I * u + S);
                }
                n.set(E, f, p, y, d);
            }
        }
        return n.toTensor();
    }, o.prototype.maxPoolBackprop = function(t, e, n, r) {
        Hh([
            e,
            n
        ], "maxPoolBackprop");
        for(var o = this.maxPoolPositions(e, r), a = r.strideHeight, i = r.strideWidth, s = r.dilationHeight, u = r.dilationWidth, c = r.effectiveFilterHeight, l = r.effectiveFilterWidth, h = l - 1 - r.padInfo.left, f = c - 1 - r.padInfo.top, d = dr(e.shape, "float32"), p = this.bufferSync(o), v = this.bufferSync(t), m = 0; m < r.batchSize; ++m)for(var g = 0; g < r.inChannels; ++g)for(var y = 0; y < r.inHeight; ++y)for(var x = 0; x < r.inWidth; ++x){
            for(var b = y - f, w = x - h, C = 0, E = 0; E < c; E += s){
                var R = (b + E) / a;
                if (!(R < 0 || R >= r.outHeight || Math.floor(R) !== R)) for(var I = 0; I < l; I += u){
                    var k = (w + I) / i;
                    if (!(k < 0 || k >= r.outWidth || Math.floor(k) !== k)) {
                        var S = c * l - 1 - p.get(m, R, k, g) === E * l + I ? 1 : 0;
                        if (0 !== S) C += v.get(m, R, k, g) * S;
                    }
                }
            }
            d.set(C, m, y, x, g);
        }
        return d.toTensor();
    }, o.prototype.avgPoolBackprop = function(t, e, n) {
        Hh([
            t,
            e
        ], "avgPoolBackprop");
        for(var r = n.strideHeight, o = n.strideWidth, a = n.filterHeight, i = n.filterWidth, s = n.dilationHeight, u = n.dilationWidth, c = n.effectiveFilterHeight, l = n.effectiveFilterWidth, h = l - 1 - n.padInfo.left, f = c - 1 - n.padInfo.top, d = dr(e.shape, "float32"), p = 1 / (a * i), v = this.bufferSync(t), m = 0; m < n.batchSize; ++m)for(var g = 0; g < n.inChannels; ++g)for(var y = 0; y < n.inHeight; ++y)for(var x = 0; x < n.inWidth; ++x){
            for(var b = y - f, w = x - h, C = 0, E = 0; E < c; E += s){
                var R = (b + E) / r;
                if (!(R < 0 || R >= n.outHeight || Math.floor(R) !== R)) for(var I = 0; I < l; I += u){
                    var k = (w + I) / o;
                    if (!(k < 0 || k >= n.outWidth || Math.floor(k) !== k)) C += v.get(m, R, k, g);
                }
            }
            d.set(C * p, m, y, x, g);
        }
        return d.toTensor();
    }, o.prototype.pool3d = function(t, e, n) {
        Hh(t, "pool3d");
        for(var r = e.strideDepth, o = e.strideHeight, a = e.strideWidth, i = e.dilationDepth, s = e.dilationHeight, u = e.dilationWidth, c = e.effectiveFilterDepth, l = e.effectiveFilterHeight, h = e.effectiveFilterWidth, f = e.padInfo.front, d = e.padInfo.top, p = e.padInfo.left, v = "max" === n ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY, m = this.readSync(t.dataId), g = dr(e.outShape, t.dtype), y = g.values, x = e.outShape[1] * e.outShape[2] * e.outShape[3] * e.outShape[4], b = e.outShape[2] * e.outShape[3] * e.outShape[4], w = e.outShape[3] * e.outShape[4], C = e.outShape[4], E = 0; E < e.batchSize; ++E)for(var R = E * x, I = E * t.strides[0], k = 0; k < e.inChannels; ++k)for(var S = 0; S < e.outDepth; ++S){
            for(var A = S * r - f, D = A; D < 0;)D += i;
            for(var T = Math.min(e.inDepth, c + A), N = R + S * b, F = 0; F < e.outHeight; ++F){
                for(var _ = F * o - d, O = _; O < 0;)O += s;
                for(var M = Math.min(e.inHeight, l + _), B = N + F * w, P = 0; P < e.outWidth; ++P){
                    for(var L = P * a - p, W = L; W < 0;)W += u;
                    for(var U = Math.min(e.inWidth, h + L), V = B + P * C, z = v, G = 0, H = 0, q = D; q < T; q += i){
                        for(var K = I + q * t.strides[1], j = O; j < M; j += s){
                            for(var X = K + j * t.strides[2], Y = W; Y < U; Y += u){
                                var $ = m[X + Y * t.strides[3] + k];
                                if ("max" === n && $ > z ? z = $ : "avg" === n && (G += $, H++), isNaN(z)) break;
                            }
                            if (isNaN(z)) break;
                        }
                        if (isNaN(z)) break;
                    }
                    y[V + k] = "avg" === n ? G / H : z;
                }
            }
        }
        return g.toTensor();
    }, o.prototype.avgPool3d = function(t, e) {
        return Hh(t, "avgPool3d"), this.pool3d(t, e, "avg").toFloat();
    }, o.prototype.avgPool3dBackprop = function(t, e, n) {
        Hh([
            t,
            e
        ], "avgPool3dBackprop");
        for(var r = n.strideDepth, o = n.strideHeight, a = n.strideWidth, i = n.filterDepth, s = n.filterHeight, u = n.filterWidth, c = n.dilationDepth, l = n.dilationHeight, h = n.dilationWidth, f = n.effectiveFilterDepth, d = n.effectiveFilterHeight, p = n.effectiveFilterWidth, v = f - 1 - n.padInfo.front, m = p - 1 - n.padInfo.left, g = d - 1 - n.padInfo.top, y = dr(e.shape, "float32"), x = 1 / (i * s * u), b = this.bufferSync(t), w = 0; w < n.batchSize; ++w)for(var C = 0; C < n.inChannels; ++C)for(var E = 0; E < n.inDepth; ++E)for(var R = 0; R < n.inHeight; ++R)for(var I = 0; I < n.inWidth; ++I){
            for(var k = E - v, S = R - g, A = I - m, D = 0, T = 0; T < f; T += c){
                var N = (k + T) / r;
                if (!(N < 0 || N >= n.outDepth || Math.floor(N) !== N)) for(var F = 0; F < d; F += l){
                    var _ = (S + F) / o;
                    if (!(_ < 0 || _ >= n.outHeight || Math.floor(_) !== _)) for(var O = 0; O < p; O += h){
                        var M = (A + O) / a;
                        if (!(M < 0 || M >= n.outWidth || Math.floor(M) !== M)) D += b.get(w, N, _, M, C);
                    }
                }
            }
            y.set(D * x, w, E, R, I, C);
        }
        return y.toTensor();
    }, o.prototype.maxPool3d = function(t, e) {
        return Hh(t, "maxPool3d"), this.pool3d(t, e, "max").toFloat();
    }, o.prototype.maxPool3dPositions = function(t, e) {
        for(var n = dr(e.outShape, "int32"), r = e.strideDepth, o = e.strideHeight, a = e.strideWidth, i = e.dilationDepth, s = e.dilationHeight, u = e.dilationWidth, c = e.effectiveFilterDepth, l = e.effectiveFilterHeight, h = e.effectiveFilterWidth, f = e.padInfo.front, d = e.padInfo.top, p = e.padInfo.left, v = this.bufferSync(t), m = 0; m < e.batchSize; ++m)for(var g = 0; g < e.inChannels; ++g)for(var y = 0; y < e.outDepth; ++y){
            for(var x = y * r - f, b = x; b < 0;)b += i;
            for(var w = Math.min(e.inDepth, c + x), C = 0; C < e.outHeight; ++C){
                for(var E = C * o - d, R = E; R < 0;)R += s;
                for(var I = Math.min(e.inHeight, l + E), k = 0; k < e.outWidth; ++k){
                    for(var S = k * a - p, A = S; A < 0;)A += u;
                    for(var D = Math.min(e.inWidth, h + S), T = Number.NEGATIVE_INFINITY, N = -1, F = b; F < w; F += i)for(var _ = F - x, O = R; O < I; O += s)for(var M = O - E, B = A; B < D; B += u){
                        var P = B - S, L = v.get(m, F, O, B, g);
                        L >= T && (T = L, N = _ * l * h + M * l + P);
                    }
                    n.set(N, m, y, C, k, g);
                }
            }
        }
        return n.toTensor();
    }, o.prototype.maxPool3dBackprop = function(t, e, n, r) {
        Hh([
            e,
            n
        ], "maxPool3dBackprop");
        for(var o = this.maxPool3dPositions(e, r), a = r.strideDepth, i = r.strideHeight, s = r.strideWidth, u = r.dilationDepth, c = r.dilationHeight, l = r.dilationWidth, h = r.effectiveFilterDepth, f = r.effectiveFilterHeight, d = r.effectiveFilterWidth, p = h - 1 - r.padInfo.front, v = d - 1 - r.padInfo.left, m = f - 1 - r.padInfo.top, g = dr(e.shape, "float32"), y = this.bufferSync(o), x = this.bufferSync(t), b = 0; b < r.batchSize; ++b)for(var w = 0; w < r.inChannels; ++w)for(var C = 0; C < r.inDepth; ++C)for(var E = 0; E < r.inHeight; ++E)for(var R = 0; R < r.inWidth; ++R){
            for(var I = C - p, k = E - m, S = R - v, A = 0, D = 0; D < h; D += u){
                var T = (I + D) / a;
                if (!(T < 0 || T >= r.outDepth || Math.floor(T) !== T)) for(var N = 0; N < f; N += c){
                    var F = (k + N) / i;
                    if (!(F < 0 || F >= r.outHeight || Math.floor(F) !== F)) for(var _ = 0; _ < d; _ += l){
                        var O = (S + _) / s;
                        if (!(O < 0 || O >= r.outWidth || Math.floor(O) !== O)) {
                            var M = h * f * d - 1 - y.get(b, T, F, O, w) === D * f * d + N * d + _ ? 1 : 0;
                            if (0 !== M) A += x.get(b, T, F, O, w) * M;
                        }
                    }
                }
            }
            g.set(A, b, C, E, R, w);
        }
        return g.toTensor();
    }, o.prototype.cast = function(t, e) {
        return Po(t, e, this);
    }, o.prototype.reshape = function(t, e) {
        return Lo(t, e);
    }, o.prototype.avgPool = function(t, e) {
        return Hh(t, "avgPool"), this.pool(t, e, "avg").toFloat();
    }, o.prototype.resizeBilinear = function(t, e, n, r) {
        Hh(t, "resizeBilinear");
        for(var o = t.shape, a = o[0], i = o[1], s = o[2], u = o[3], c = this.readSync(t.dataId), l = new Float32Array(k([
            a,
            e,
            n,
            u
        ])), h = [
            r && e > 1 ? i - 1 : i,
            r && n > 1 ? s - 1 : s
        ], f = [
            r && e > 1 ? e - 1 : e,
            r && n > 1 ? n - 1 : n
        ], d = 0, p = h[0] / f[0], v = h[1] / f[1], m = 0; m < a; m++)for(var g = 0; g < e; g++)for(var y = p * g, x = Math.floor(y), b = y - x, w = Math.min(i - 1, Math.ceil(y)), C = m * t.strides[0] + x * t.strides[1], E = m * t.strides[0] + w * t.strides[1], R = 0; R < n; R++)for(var I = v * R, S = Math.floor(I), A = I - S, D = Math.min(s - 1, Math.ceil(I)), T = C + S * t.strides[2], N = E + S * t.strides[2], F = C + D * t.strides[2], _ = E + D * t.strides[2], O = 0; O < u; O++){
            var M = c[T + O], B = c[N + O], P = M + (c[F + O] - M) * A, L = P + (B + (c[_ + O] - B) * A - P) * b;
            l[d++] = L;
        }
        return Fn(l, [
            a,
            e,
            n,
            u
        ]);
    }, o.prototype.resizeBilinearBackprop = function(t, e, n) {
        Hh([
            t,
            e
        ], "resizeBilinearBackprop");
        for(var r = e.shape, o = r[0], a = r[1], i = r[2], s = r[3], u = t.shape, c = u[1], l = u[2], h = new Float32Array(o * a * i * s), f = [
            n && c > 1 ? a - 1 : a,
            n && l > 1 ? i - 1 : i
        ], d = [
            n && c > 1 ? c - 1 : c,
            n && l > 1 ? l - 1 : l
        ], p = f[0] / d[0], v = f[1] / d[1], m = this.readSync(t.dataId), g = 0, y = 0; y < o; y++)for(var x = y * e.strides[0], b = 0; b < c; b++)for(var w = b * p, C = Math.floor(w), E = Math.min(Math.ceil(w), a - 1), R = x + C * e.strides[1], I = x + E * e.strides[1], k = w - C, S = 1 - k, A = 0; A < l; A++)for(var D = A * v, T = Math.floor(D), N = Math.min(Math.ceil(D), i - 1), F = D - T, _ = 1 - F, O = R + T * e.strides[2], M = R + N * e.strides[2], B = I + T * e.strides[2], P = I + N * e.strides[2], L = S * _, W = S * F, U = k * _, V = k * F, z = 0; z < s; z++){
            var G = m[g++];
            h[O + z] += G * L, h[M + z] += G * W, h[B + z] += G * U, h[P + z] += G * V;
        }
        return Ln(h, [
            o,
            i,
            a,
            s
        ], e.dtype);
    }, o.prototype.resizeNearestNeighbor = function(t, e, n, r) {
        Hh(t, "resizeNearestNeighbor");
        for(var o = t.shape, a = o[0], i = o[1], s = o[2], u = o[3], c = this.readSync(t.dataId), l = new Float32Array(a * e * n * u), h = [
            r && e > 1 ? i - 1 : i,
            r && n > 1 ? s - 1 : s
        ], f = [
            r && e > 1 ? e - 1 : e,
            r && n > 1 ? n - 1 : n
        ], d = h[0] / f[0], p = h[1] / f[1], v = 0, m = 0; m < a; m++)for(var g = m * t.strides[0], y = 0; y < e; y++)for(var x = d * y, b = g + Math.min(i - 1, r ? Math.round(x) : Math.floor(x)) * t.strides[1], w = 0; w < n; w++)for(var C = p * w, E = b + Math.min(s - 1, r ? Math.round(C) : Math.floor(C)) * t.strides[2], R = 0; R < u; R++){
            var I = c[E + R];
            l[v++] = I;
        }
        return Fn(l, [
            a,
            e,
            n,
            u
        ], t.dtype);
    }, o.prototype.resizeNearestNeighborBackprop = function(t, e, n) {
        Hh([
            t,
            e
        ], "resizeNearestNeighborBackprop");
        for(var r = e.shape, o = r[0], a = r[1], i = r[2], s = r[3], u = t.shape, c = u[1], l = u[2], h = new Float32Array(o * a * i * s), f = this.readSync(t.dataId), d = [
            n && c > 1 ? a - 1 : a,
            n && l > 1 ? i - 1 : i
        ], p = [
            n && c > 1 ? c - 1 : c,
            n && l > 1 ? l - 1 : l
        ], v = d[0] / p[0], m = d[1] / p[1], g = 1 / v, y = 1 / m, x = 2 * Math.ceil(g) + 2, b = 2 * Math.ceil(y) + 2, w = 0; w < o; w++)for(var C = w * e.strides[0], E = 0; E < a; E++)for(var R = C + E * e.strides[1], I = Math.floor(E * g), k = Math.floor(I - x / 2), S = 0; S < i; S++)for(var A = R + S * e.strides[2], D = Math.floor(S * y), T = Math.floor(D - b / 2), N = 0; N < s; N++){
            for(var F = 0, _ = 0; _ < x; _++){
                var O = _ + k;
                if (!(O < 0 || O >= c)) {
                    var M = C + O * t.strides[1], B = O * v;
                    if (E === Math.min(a - 1, n ? Math.round(B) : Math.floor(B))) for(var P = 0; P < b; P++){
                        var L = P + T;
                        if (!(L < 0 || L >= l)) {
                            var W = M + L * t.strides[2], U = L * m;
                            S === Math.min(i - 1, n ? Math.round(U) : Math.floor(U)) && (F += f[W + N]);
                        }
                    }
                }
            }
            h[A + N] = F;
        }
        return Ln(h, e.shape, e.dtype);
    }, o.prototype.batchNormalization = function(t, e, n, r, o, a) {
        Hh([
            t,
            e,
            n,
            o,
            a
        ], "batchNorm");
        for(var i = this.readSync(t.dataId), s = this.readSync(e.dataId), u = this.readSync(n.dataId), c = o ? this.readSync(o.dataId) : new Float32Array([
            1
        ]), l = a ? this.readSync(a.dataId) : new Float32Array([
            0
        ]), h = new Float32Array(i.length), f = l.length, d = c.length, p = u.length, v = s.length, m = 0, g = 0, y = 0, x = 0, b = 0; b < i.length; ++b)h[b] = l[m++] + (i[b] - s[g++]) * c[y++] / Math.sqrt(u[x++] + r), m >= f && (m = 0), g >= v && (g = 0), y >= d && (y = 0), x >= p && (x = 0);
        return Ln(h, t.shape);
    }, o.prototype.localResponseNormalization4D = function(t, e, n, r, o) {
        Hh(t, "localResponseNormalization4D");
        var a = t.shape[3], i = a - 1, s = this.readSync(t.dataId), u = t.size, c = new Float32Array(u);
        function l(t) {
            for(var n = t % a, r = t - n + Math.max(0, n - e), o = t - n + Math.min(n + e, i), u = 0; r <= o; r++){
                var c = s[r];
                u += c * c;
            }
            return u;
        }
        for(var h = 0; h < u; h++){
            var f = l(h), d = s[h] * Math.pow(n + r * f, -o);
            c[h] = d;
        }
        return Ln(c, t.shape);
    }, o.prototype.LRNGrad = function(t, e, n, r, o, a, i) {
        Hh(t, "LRNGrad");
        for(var s = t.shape[3], u = this.readSync(t.dataId), c = this.readSync(e.dataId), l = this.readSync(n.dataId), h = new Float32Array(t.size), f = t.size, d = 0; d < f; d++){
            for(var p = d % s, v = d - p + Math.max(0, p - r), m = d - p + Math.min(s, p + r + 1), g = 0, y = v; y < m; y++)g += Math.pow(c[y], 2);
            g = a * g + o;
            for(y = v; y < m; y++){
                var x = -2 * a * i * c[y] * l[d] / g;
                d === y && (x += Math.pow(g, -i)), x *= u[d], h[y] += x;
            }
        }
        return Ln(h, t.shape);
    }, o.prototype.multinomial = function(t, e, n, r) {
        Hh(t, "multinomial");
        for(var o = e ? t : go(t), a = o.shape[0], i = o.shape[1], s = Gn([
            a,
            n
        ], "int32"), u = this.readSync(s.dataId), c = this.readSync(o.dataId), l = 0; l < a; ++l){
            var h = l * i, f = new Float32Array(i - 1);
            f[0] = c[h];
            for(var d = 1; d < f.length; ++d)f[d] = f[d - 1] + c[h + d];
            for(var p = cr(r.toString()), v = l * n, m = 0; m < n; ++m){
                var g = p();
                u[v + m] = f.length;
                for(var y = 0; y < f.length; y++)if (g < f[y]) {
                    u[v + m] = y;
                    break;
                }
            }
        }
        return s;
    }, o.prototype.oneHot = function(t, e, n, r) {
        Hh(t, "oneHot");
        var o = new Float32Array(t.size * e);
        o.fill(r);
        for(var a = this.readSync(t.dataId), i = 0; i < t.size; ++i)a[i] >= 0 && a[i] < e && (o[i * e + a[i]] = n);
        return Bn(o, [
            t.size,
            e
        ], "int32");
    }, o.prototype.nonMaxSuppression = function(t, e, n, r, o) {
        return Hh(t, "nonMaxSuppression"), jo(this.readSync(t.dataId), this.readSync(e.dataId), n, r, o);
    }, o.prototype.fft = function(t) {
        return this.fftBatch(t, !1);
    }, o.prototype.ifft = function(t) {
        return this.fftBatch(t, !0);
    }, o.prototype.fftBatch = function(t, e) {
        for(var n = t.shape[0], r = t.shape[1], o = dr(t.shape, "float32"), a = dr(t.shape, "float32"), i = Tn(t).as2D(n, r), s = Nn(t).as2D(n, r), u = 0; u < n; u++)for(var c = i.slice([
            u,
            0
        ], [
            1,
            r
        ]), l = s.slice([
            u,
            0
        ], [
            1,
            r
        ]), h = Dn(c, l), f = this.readSync(this.fftImpl(h, e).dataId), d = 0; d < r; d++){
            var p = zo(f, d);
            o.values[u * r + d] = p.real, a.values[u * r + d] = p.imag;
        }
        return Dn(o.toTensor(), a.toTensor()).as2D(n, r);
    }, o.prototype.fftImpl = function(t, e) {
        var n = t.as1D(), r = n.size;
        if (this.isExponentOf2(r)) {
            var o = this.fftRadix2(n, r, e).as2D(t.shape[0], t.shape[1]);
            return e && (o = Dn(Tn(o).div(On(r)), Nn(o).div(On(r)))), o;
        }
        var a = this.readSync(t.dataId), i = function(t) {
            for(var e = new Float32Array(t.length / 2), n = new Float32Array(t.length / 2), r = 0; r < t.length; r += 2)e[r / 2] = t[r], n[r / 2] = t[r + 1];
            return {
                real: e,
                imag: n
            };
        }(this.fourierTransformByMatmul(a, r, e));
        return Dn(i.real, i.imag).as2D(t.shape[0], t.shape[1]);
    }, o.prototype.isExponentOf2 = function(t) {
        return 0 == (t & t - 1);
    }, o.prototype.fftRadix2 = function(t, e, n) {
        if (1 === e) return t;
        var r = this.readSync(t.dataId), o = e / 2, a = function(t) {
            for(var e = Math.ceil(t.length / 4), n = new Float32Array(e), r = new Float32Array(e), o = 0; o < t.length; o += 4)n[Math.floor(o / 4)] = t[o], r[Math.floor(o / 4)] = t[o + 1];
            return {
                real: n,
                imag: r
            };
        }(r), i = Dn(a.real, a.imag).as1D(), s = function(t) {
            for(var e = Math.floor(t.length / 4), n = new Float32Array(e), r = new Float32Array(e), o = 2; o < t.length; o += 4)n[Math.floor(o / 4)] = t[o], r[Math.floor(o / 4)] = t[o + 1];
            return {
                real: n,
                imag: r
            };
        }(r), u = Dn(s.real, s.imag).as1D();
        i = this.fftRadix2(i, o, n), u = this.fftRadix2(u, o, n);
        var c = function(t, e) {
            for(var n = new Float32Array(t / 2), r = new Float32Array(t / 2), o = 0; o < Math.ceil(t / 2); o++){
                var a = (e ? 2 : -2) * Math.PI * (o / t);
                n[o] = Math.cos(a), r[o] = Math.sin(a);
            }
            return {
                real: n,
                imag: r
            };
        }(e, n), l = Dn(c.real, c.imag).mul(u), h = i.add(l), f = i.sub(l), d = Tn(h).concat(Tn(f)), p = Nn(h).concat(Nn(f));
        return Dn(d, p).as1D();
    }, o.prototype.fourierTransformByMatmul = function(t, e, n) {
        for(var r = new Float32Array(2 * e), o = 0; o < e; o++){
            for(var a = 0, i = 0, s = 0; s < e; s++){
                var u = Ho(o * s, e, n), c = zo(t, s);
                a += c.real * u.real - c.imag * u.imag, i += c.real * u.imag + c.imag * u.real;
            }
            n && (a /= e, i /= e), Go(r, a, i, o);
        }
        return r;
    }, o.prototype.depthToSpace = function(t, e, n) {
        C("NHWC" === n, function() {
            return "Only NHWC dataFormat supported on CPU for depthToSpace. Got " + n;
        }), C(e > 1, function() {
            return "blockSize should be > 1 for depthToSpace, but was: " + e;
        });
        for(var r = t.shape[0], o = t.shape[1], a = t.shape[2], i = t.shape[3], s = o * e, u = a * e, c = i / (e * e), l = this.readSync(t.dataId), h = new Float32Array(r * s * u * c), f = 0, d = 0; d < r; ++d)for(var p = 0; p < s; ++p)for(var v = Math.floor(p / e), m = p % e, g = 0; g < u; ++g)for(var y = Math.floor(g / e), x = (m * e + g % e) * c, b = 0; b < c; ++b){
            var w = b + x + i * (y + a * (v + o * d));
            h[f++] = l[w];
        }
        return Ln(h, [
            r,
            s,
            u,
            c
        ]);
    }, o.prototype.broadcastedBinaryOp = function(t, e, n, r) {
        var o = Ro(t.shape, e.shape), a = dr(o, n), i = this.readSync(t.dataId), s = this.readSync(e.dataId), u = Co(t.shape, o), c = Co(e.shape, o), l = a.values;
        if (u.length + c.length === 0) for(var h = 0; h < l.length; ++h)l[h] = r(i[h % i.length], s[h % s.length]);
        else {
            var f = this.bufferSync(t), d = this.bufferSync(e), p = function(n) {
                var o = a.indexToLoc(n), h = o.slice(-t.rank);
                u.forEach(function(t) {
                    return h[t] = 0;
                });
                var p = f.locToIndex(h), v = o.slice(-e.rank);
                c.forEach(function(t) {
                    return v[t] = 0;
                });
                var m = d.locToIndex(v);
                l[n] = r(i[p], s[m]);
            };
            for(h = 0; h < l.length; ++h)p(h);
        }
        return a.toTensor();
    }, o.prototype.broadcastedBinaryComplexOp = function(t, e, n) {
        var r = Ro(t.shape, e.shape), o = dr(r, "float32"), a = dr(r, "float32"), i = this.readSync(t.dataId), s = this.readSync(e.dataId), u = Co(t.shape, r), c = Co(e.shape, r), l = o.values, h = a.values;
        if (u.length + c.length === 0) for(var f = 0; f < l.length; f++){
            var d = f % i.length, p = f % s.length, v = n(i[2 * d], i[2 * d + 1], s[2 * p], s[2 * p + 1]);
            l[f] = v.real, h[f] = v.imag;
        }
        else {
            var m = this.bufferSync(this.data.get(t.dataId).complexTensors.real), g = this.bufferSync(this.data.get(e.dataId).complexTensors.real), y = function(r) {
                var a = o.indexToLoc(r), f = a.slice(-t.rank);
                u.forEach(function(t) {
                    return f[t] = 0;
                });
                var d = m.locToIndex(f), p = a.slice(-e.rank);
                c.forEach(function(t) {
                    return p[t] = 0;
                });
                var v = g.locToIndex(p), y = n(i[2 * d], i[2 * d + 1], s[2 * v], s[2 * v + 1]);
                l[r] = y.real, h[r] = y.imag;
            };
            for(f = 0; f < l.length; f++)y(f);
        }
        return this.complex(o.toTensor(), a.toTensor());
    }, o.prototype.split = function(t, e, n) {
        return Zo(t, e, n);
    }, o.prototype.dispose = function() {}, o.prototype.floatPrecision = function() {
        return 32;
    }, o.prototype.epsilon = function() {
        return 1e-7;
    }, o.prototype.cropAndResize = function(t, e, n, r, o, a) {
        for(var i = t.shape, s = i[0], u = i[1], c = i[2], l = i[3], h = e.shape[0], f = r[0], d = r[1], p = dr([
            h,
            f,
            d,
            l
        ], "float32"), v = this.readSync(e.dataId), m = this.readSync(n.dataId), g = this.readSync(t.dataId), y = t.strides, x = p.strides, b = 0; b < h; b++){
            var w = 4 * b, C = v[w], E = v[w + 1], R = v[w + 2], I = v[w + 3], k = m[b];
            if (!(k >= s)) for(var S = f > 1 ? (R - C) * (u - 1) / (f - 1) : 0, A = d > 1 ? (I - E) * (c - 1) / (d - 1) : 0, D = 0; D < f; D++){
                var T = f > 1 ? C * (u - 1) + D * S : .5 * (C + R) * (u - 1);
                if (T < 0 || T > u - 1) for(var N = 0; N < d; N++)for(var F = 0; F < l; F++){
                    var _ = F + N * x[2] + D * x[1] + b * x[0];
                    p.values[_] = a;
                }
                else if ("bilinear" === o) {
                    var O = Math.floor(T), M = Math.ceil(T), B = T - O;
                    for(N = 0; N < d; N++){
                        if ((q = d > 1 ? E * (c - 1) + N * A : .5 * (E + I) * (c - 1)) < 0 || q > c - 1) for(F = 0; F < l; F++){
                            _ = F + N * x[2] + D * x[1] + b * x[0];
                            p.values[_] = a;
                        }
                        else {
                            var P = Math.floor(q), L = Math.ceil(q), W = q - P;
                            for(F = 0; F < l; F++){
                                var U = g[_ = F + P * y[2] + O * y[1] + k * y[0]], V = g[_ = F + L * y[2] + O * y[1] + k * y[0]], z = g[_ = F + P * y[2] + M * y[1] + k * y[0]], G = U + (V - U) * W, H = z + (g[_ = F + L * y[2] + M * y[1] + k * y[0]] - z) * W;
                                _ = F + N * x[2] + D * x[1] + b * x[0], p.values[_] = G + (H - G) * B;
                            }
                        }
                    }
                } else for(N = 0; N < d; ++N){
                    var q;
                    if ((q = d > 1 ? E * (c - 1) + N * A : .5 * (E + I) * (c - 1)) < 0 || q > c - 1) for(F = 0; F < l; F++){
                        _ = F + N * x[2] + D * x[1] + b * x[0];
                        p.values[_] = a;
                    }
                    else {
                        var K = Math.round(q), j = Math.round(T);
                        for(F = 0; F < l; F++){
                            var X = F + K * y[2] + j * y[1] + k * y[0], Y = F + N * x[2] + D * x[1] + b * x[0];
                            p.values[Y] = g[X];
                        }
                    }
                }
            }
        }
        return p.toTensor();
    }, o.prototype.sparseToDense = function(t, e, n, r) {
        var o = Zr(0, t, n), a = o.sliceRank, i = o.numUpdates, s = o.sliceSize, u = o.strides, c = o.outputSize;
        return this.scatter(t, e, n, c, s, i, a, u, r, !1);
    }, o.prototype.gatherND = function(t, e) {
        var n = e.shape, r = n[n.length - 1], o = jr(t, e), a = o[0], i = o[1], s = o[2], u = o[3];
        if (0 === i) return Fn([], a, t.dtype);
        for(var c = new gt([
            i,
            s
        ], t.dtype), l = this.readSync(e.dataId), h = this.readSync(t.dataId), f = 0; f < i; f++){
            for(var d = [], p = 0, v = 0; v < r; v++){
                var m = l[f * r + v];
                p += m * u[v], d.push(m);
            }
            if (p < 0 || p >= t.size / s) throw new Error("Invalid indices: " + d + " does not index into " + t.shape);
            for(var g = 0; g < s; g++)c.values[f * s + g] = h[p * s + g];
        }
        return c.toTensor().reshape(a);
    }, o.prototype.scatterND = function(t, e, n) {
        var r = Zr(0, t, n), o = r.sliceRank, a = r.numUpdates, i = r.sliceSize, s = r.strides, u = r.outputSize, c = On(0);
        return this.scatter(t, e, n, u, i, a, o, s, c, !0);
    }, o.prototype.fill = function(t, e, n) {
        var r = P(n = n || j(e), k(t));
        return r.fill(e), Lt.makeTensor(r, t, n, this);
    }, o.prototype.onesLike = function(t) {
        if ("string" === t.dtype) throw new Error("onesLike is not supported for string tensors");
        return this.fill(t.shape, 1, t.dtype);
    }, o.prototype.zerosLike = function(t) {
        var e = P(t.dtype, k(t.shape));
        return this.makeOutput(e, t.shape, t.dtype);
    }, o.prototype.linspace = function(t, e, n) {
        return Wo(t, e, n);
    }, o.prototype.scatter = function(t, e, n, r, o, a, i, s, u, c) {
        var l = [
            r / o,
            o
        ], h = this.readSync(t.dataId), f = this.readSync(e.dataId);
        if (0 === r) return Fn([], n, e.dtype);
        var d = new gt(l, e.dtype);
        d.values.fill(this.readSync(u.dataId)[0]);
        for(var p = 0; p < a; p++){
            for(var v = [], m = 0, g = 0; g < i; g++){
                var y = h[p * i + g];
                v.push(y), m += y * s[g];
            }
            if (m < 0 || m >= r / o) throw new Error("Invalid indices: " + v + " does not index into " + n);
            for(var x = 0; x < o; x++)c ? d.values[m * o + x] += f[p * o + x] : d.values[m * o + x] = 0 === e.rank ? f[0] : f[p * o + x];
        }
        return d.toTensor().reshape(n);
    }, o;
}(bo);
Lt.registerBackend("cpu", function() {
    return new Kh;
}, 1);
for(var jh = 0, Xh = [
    {
        kernelName: "NonMaxSuppressionV5",
        backendName: "cpu",
        kernelFunc: function(t) {
            var e = t.inputs, n = t.backend, r = t.attrs, o = e, a = o.boxes, i = o.scores, s = r, u = s.maxOutputSize, c = s.iouThreshold, l = s.scoreThreshold, h = s.softNmsSigma, f = n;
            Hh(a, "NonMaxSuppressionWithScore");
            var d = Xo(f.data.get(a.dataId).values, f.data.get(i.dataId).values, u, c, l, h);
            return [
                d.selectedIndices,
                d.selectedScores
            ];
        }
    },
    {
        kernelName: "Square",
        backendName: "cpu",
        kernelFunc: function(t) {
            var e = t.inputs, n = t.backend, r = e.x, o = n;
            Hh(r, "square");
            for(var a = o.data.get(r.dataId).values, i = new Float32Array(a.length), s = 0; s < a.length; ++s){
                var u = a[s];
                i[s] = u * u;
            }
            return {
                dataId: o.write(i, r.shape, r.dtype),
                shape: r.shape,
                dtype: r.dtype
            };
        }
    },
    {
        kernelName: eu,
        backendName: "cpu",
        kernelFunc: function(t) {
            var e = t.inputs, n = t.backend, r = e, o = r.a, a = r.b, i = n;
            Hh([
                o,
                a
            ], eu);
            var s = i.data.get(o.dataId).values, u = i.data.get(a.dataId).values, c = function(t, e, n, r, o, a) {
                var i = Ro(t, e), s = i.length, u = $(i), c = B(o, k(i)), l = t.length, h = e.length, f = $(t), d = $(e), p = Co(t, i), v = Co(e, i);
                if (p.length + v.length === 0) for(var m = 0; m < c.length; ++m)c[m] = a(n[m % n.length], r[m % r.length]);
                else {
                    var g = function(t) {
                        var e = it(t, s, u), o = e.slice(-l);
                        p.forEach(function(t) {
                            return o[t] = 0;
                        });
                        var i = at(o, l, f), m = e.slice(-h);
                        v.forEach(function(t) {
                            return m[t] = 0;
                        });
                        var g = at(m, h, d);
                        c[t] = a(n[i], r[g]);
                    };
                    for(m = 0; m < c.length; ++m)g(m);
                }
                return [
                    c,
                    i
                ];
            }(o.shape, a.shape, s, u, o.dtype, function(t, e) {
                var n = t - e;
                return n * n;
            }), l = c[0], h = c[1];
            return {
                dataId: i.write(l, h, o.dtype),
                shape: h,
                dtype: o.dtype
            };
        }
    }
]; jh < Xh.length; jh++)d(Xh[jh]);
var Yh, $h = function(t) {
    this.variableNames = [
        "A"
    ];
    var e = ua(), n = t[0], r = t[1];
    this.outputShape = t, this.userCode = "\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(" + r + ".0, " + n + ".0);\n\n        vec4 values = " + e.texture2D + "(A, uv);\n        float value;\n        if (depth == 0) {\n          value = values.r;\n        } else if (depth == 1) {\n          value = values.g;\n        } else if (depth == 2) {\n          value = values.b;\n        } else if (depth == 3) {\n          value = values.a;\n        }\n\n        setOutput(floor(value * 255.0 + 0.5));\n      }\n    ";
}, Qh = function(t) {
    this.variableNames = [
        "A"
    ], this.packedInputs = !1, this.packedOutput = !0;
    var e = ua(), n = t[0], r = t[1];
    this.outputShape = t, this.userCode = "\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n\n        vec4 result = vec4(0.);\n\n        for(int row=0; row<=1; row++) {\n          for(int col=0; col<=1; col++) {\n            texC = coords[1] + row;\n            depth = coords[2] + col;\n\n            vec2 uv = (vec2(texC, texR) + halfCR) /\n                       vec2(" + r + ".0, " + n + ".0);\n            vec4 values = " + e.texture2D + "(A, uv);\n            float value;\n            if (depth == 0) {\n              value = values.r;\n            } else if (depth == 1) {\n              value = values.g;\n            } else if (depth == 2) {\n              value = values.b;\n            } else if (depth == 3) {\n              value = values.a;\n            }\n\n            result[row * 2 + col] = floor(value * 255.0 + 0.5);\n          }\n        }\n\n        " + e.output + " = result;\n      }\n    ";
};
for(var Jh = 0, Zh = [
    {
        kernelName: "FromPixels",
        backendName: "webgl",
        kernelFunc: function(t) {
            var e = t.inputs, n = t.backend, r = t.attrs, o = e.pixels, a = r.numChannels, s = "undefined" != typeof HTMLVideoElement && o instanceof HTMLVideoElement, u = "undefined" != typeof HTMLImageElement && o instanceof HTMLImageElement, c = s ? [
                o.videoWidth,
                o.videoHeight
            ] : [
                o.width,
                o.height
            ], l = c[0], h = c[1], f = [
                h,
                l
            ], d = [
                h,
                l,
                a
            ];
            (u || s) && (null == Yh && (Yh = document.createElement("canvas").getContext("2d")), Yh.canvas.width = l, Yh.canvas.height = h, Yh.drawImage(o, 0, 0, l, h), o = Yh.canvas);
            var p = n.makeTensorInfo(f, "int32");
            n.texData.get(p.dataId).usage = zt.PIXELS, n.gpgpu.uploadPixelDataToTexture(n.getTexture(p.dataId), o);
            var v = i().getBool("WEBGL_PACK") ? new Qh(d) : new $h(d), m = n.runWebGLProgram(v, [
                p
            ], "int32");
            return n.disposeData(p.dataId), m;
        }
    },
    {
        kernelName: "NonMaxSuppressionV5",
        backendName: "webgl",
        kernelFunc: function(t) {
            var e = t.inputs, n = t.backend, r = t.attrs;
            dn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
            var o = e, a = o.boxes, i = o.scores, s = r, u = s.maxOutputSize, c = s.iouThreshold, l = s.scoreThreshold, h = s.softNmsSigma, f = n, d = Xo(f.readSync(a.dataId), f.readSync(i.dataId), u, c, l, h);
            return [
                d.selectedIndices,
                d.selectedScores
            ];
        }
    },
    {
        kernelName: "Square",
        backendName: "webgl",
        kernelFunc: function(t) {
            var e = t.inputs, n = t.backend, r = e.x, o = n, a = new Cs(r.shape, "return x * x;");
            return o.runWebGLProgram(a, [
                r
            ], r.dtype);
        }
    },
    {
        kernelName: eu,
        backendName: "webgl",
        kernelFunc: function(t) {
            var e = t.inputs, n = t.backend, r = e, o = r.a, a = r.b, s = n, u = i().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new La("return (a - b) * (a - b);", o.shape, a.shape) : new Ba("return (a - b) * (a - b);", o.shape, a.shape);
            return s.compileAndRun(u, [
                o,
                a
            ]);
        }
    }
]; Jh < Zh.length; Jh++)d(Zh[Jh]);
for(var tf = 0, ef = [
    {
        kernelName: "Square",
        gradFunc: function(t, e) {
            var n = e[0];
            return {
                x: function() {
                    return t.mul(n.toFloat().mul(2));
                }
            };
        }
    },
    {
        kernelName: eu,
        gradFunc: function(t, e) {
            var n = e[0], r = e[1], o = On(2);
            return {
                a: function() {
                    return gc(t, gc(o, Cc(n, r)));
                },
                b: function() {
                    return gc(t, gc(o, Cc(r, n)));
                }
            };
        }
    }
]; tf < ef.length; tf++)p(ef[tf]);
var nf = function() {
    function t() {}
    return t.prototype.fetch = function(t, e) {
        return fetch(t, e);
    }, t.prototype.now = function() {
        return performance.now();
    }, t.prototype.encode = function(t, e) {
        if ("utf-8" !== e && "utf8" !== e) throw new Error("Browser's encoder only supports utf-8, but got " + e);
        return null == this.textEncoder && (this.textEncoder = new TextEncoder), this.textEncoder.encode(t);
    }, t.prototype.decode = function(t, e) {
        return new TextDecoder(e).decode(t);
    }, t;
}();
i().get("IS_BROWSER") && i().setPlatform("browser", new nf);
var rf;

var of = function() {
    return (parcelRequire("1S6xU"));
};

var af = function() {
    function t() {
        this.util = (parcelRequire("1S6xU")), this.textEncoder = new this.util.TextEncoder;
    }
    return t.prototype.fetch = function(t, e) {
        return null != i().global.fetch ? i().global.fetch(t, e) : (null == rf && (rf = of()), rf(t, e));
    }, t.prototype.now = function() {
        var t = $cmlvI.hrtime();
        return 1e3 * t[0] + t[1] / 1e6;
    }, t.prototype.encode = function(t, e) {
        if ("utf-8" !== e && "utf8" !== e) throw new Error("Node built-in encoder only supports utf-8, but got " + e);
        return this.textEncoder.encode(t);
    }, t.prototype.decode = function(t, e) {
        return 0 === t.length ? "" : new this.util.TextDecoder(e).decode(t);
    }, t;
}();
i().get("IS_NODE") && i().setPlatform("node", new af);
var sf = {
    float32: 4,
    int32: 4,
    uint16: 2,
    uint8: 1,
    bool: 1
}, uf = 4;
function cf(t, e) {
    for(var n = {}, r = 0, o = function(e) {
        var o = e.name, a = e.dtype, i = e.shape, s = k(i), u = void 0;
        if (("quantization" in e)) {
            var c = e.quantization;
            if ("uint8" !== c.dtype && "uint16" !== c.dtype) throw new Error("Weight " + e.name + " has unknown quantization dtype " + c.dtype + ". Supported quantization dtypes are: 'uint8' and 'uint16'.");
            var l = sf[c.dtype], h = t.slice(r, r + s * l), f = "uint8" === c.dtype ? new Uint8Array(h) : new Uint16Array(h);
            if ("float32" === a) u = Float32Array.from(f, function(t) {
                return t * c.scale + c.min;
            });
            else {
                if ("int32" !== a) throw new Error("Unsupported dtype in weight '" + o + "': " + a);
                u = Int32Array.from(f, function(t) {
                    return Math.round(t * c.scale + c.min);
                });
            }
            r += s * l;
        } else if ("string" === a) {
            var d = k(e.shape);
            u = [];
            for(var p = 0; p < d; p++){
                var v = new Uint32Array(t.slice(r, r + uf))[0];
                r += uf;
                var m = new Uint8Array(t.slice(r, r + v));
                u.push(m), r += v;
            }
        } else {
            var g = sf[a];
            h = t.slice(r, r + s * g);
            if ("float32" === a) u = new Float32Array(h);
            else if ("int32" === a) u = new Int32Array(h);
            else {
                if ("bool" !== a) throw new Error("Unsupported dtype in weight '" + o + "': " + a);
                u = new Uint8Array(h);
            }
            r += s * g;
        }
        n[o] = Fn(u, i, a);
    }, a = 0, i = e; a < i.length; a++)o(i[a]);
    return n;
}
function lf(t) {
    if (null === t) throw new Error("Invalid input value: " + JSON.stringify(t));
    var e = 0, n = [];
    t.forEach(function(t) {
        if (e += t.byteLength, n.push(t.byteLength === t.buffer.byteLength ? t : new t.constructor(t)), !(t instanceof Float32Array || t instanceof Int32Array || t instanceof Uint8Array)) throw new Error("Unsupported TypedArray subtype: " + t.constructor.name);
    });
    var r = new Uint8Array(e), o = 0;
    return n.forEach(function(t) {
        r.set(new Uint8Array(t.buffer), o), o += t.byteLength;
    }), r.buffer;
}
var hf = "undefined" != typeof $ccc6390119ecc6e0$require$Buffer && ("undefined" == typeof Blob || "undefined" == typeof atob || "undefined" == typeof btoa);
function ff(t) {
    return hf ? $ccc6390119ecc6e0$require$Buffer.byteLength(t) : new Blob([
        t
    ]).size;
}
function df(t) {
    var e = 0;
    t.forEach(function(t) {
        e += t.byteLength;
    });
    var n = new Uint8Array(e), r = 0;
    return t.forEach(function(t) {
        n.set(new Uint8Array(t), r), r += t.byteLength;
    }), n.buffer;
}
function pf(t) {
    for(t = t.trim(); t.endsWith("/");)t = t.slice(0, t.length - 1);
    var e = t.split("/");
    return e[e.length - 1];
}
function vf(t) {
    if (t.modelTopology instanceof ArrayBuffer) throw new Error("Expected JSON model topology, received ArrayBuffer.");
    return {
        dateSaved: new Date,
        modelTopologyType: "JSON",
        modelTopologyBytes: null == t.modelTopology ? 0 : ff(JSON.stringify(t.modelTopology)),
        weightSpecsBytes: null == t.weightSpecs ? 0 : ff(JSON.stringify(t.weightSpecs)),
        weightDataBytes: null == t.weightData ? 0 : t.weightData.byteLength
    };
}
var mf = function() {
    function t() {
        this.saveRouters = [], this.loadRouters = [];
    }
    return t.getInstance = function() {
        return null == t.instance && (t.instance = new t), t.instance;
    }, t.registerSaveRouter = function(e) {
        t.getInstance().saveRouters.push(e);
    }, t.registerLoadRouter = function(e) {
        t.getInstance().loadRouters.push(e);
    }, t.getSaveHandlers = function(e) {
        return t.getHandlers(e, "save");
    }, t.getLoadHandlers = function(e, n) {
        return t.getHandlers(e, "load", n);
    }, t.getHandlers = function(e, n, r) {
        var o = [];
        return ("load" === n ? t.getInstance().loadRouters : t.getInstance().saveRouters).forEach(function(t) {
            var n = t(e, r);
            null !== n && o.push(n);
        }), o;
    }, t;
}(), gf = "://", yf = function() {
    function t() {
        this.managers = {};
    }
    return t.getInstance = function() {
        return null == t.instance && (t.instance = new t), t.instance;
    }, t.registerManager = function(e, n) {
        C(null != e, function() {
            return "scheme must not be undefined or null.";
        }), e.endsWith(gf) && (e = e.slice(0, e.indexOf(gf))), C(e.length > 0, function() {
            return "scheme must not be an empty string.";
        });
        var r = t.getInstance();
        C(null == r.managers[e], function() {
            return "A model store manager is already registered for scheme '" + e + "'.";
        }), r.managers[e] = n;
    }, t.getManager = function(t) {
        var e = this.getInstance().managers[t];
        if (null == e) throw new Error("Cannot find model manager for scheme '" + t + "'");
        return e;
    }, t.getSchemes = function() {
        return Object.keys(this.getInstance().managers);
    }, t;
}();
function xf(t) {
    if (-1 === t.indexOf(gf)) throw new Error("The url string provided does not contain a scheme. Supported schemes are: " + yf.getSchemes().join(","));
    return {
        scheme: t.split(gf)[0],
        path: t.split(gf)[1]
    };
}
function bf(t, e, o) {
    return void 0 === o && (o = !1), n(this, void 0, void 0, function() {
        var n, a, i, s, u, c, l, h, f;
        return r(this, function(r) {
            switch(r.label){
                case 0:
                    return C(t !== e, function() {
                        return "Old path and new path are the same: '" + t + "'";
                    }), C((n = mf.getLoadHandlers(t)).length > 0, function() {
                        return "Copying failed because no load handler is found for source URL " + t + ".";
                    }), C(n.length < 2, function() {
                        return "Copying failed because more than one (" + n.length + ") load handlers for source URL " + t + ".";
                    }), a = n[0], C((i = mf.getSaveHandlers(e)).length > 0, function() {
                        return "Copying failed because no save handler is found for destination URL " + e + ".";
                    }), C(i.length < 2, function() {
                        return "Copying failed because more than one (" + n.length + ") save handlers for destination URL " + e + ".";
                    }), s = i[0], u = xf(t).scheme, c = xf(t).path, l = u === xf(t).scheme, [
                        4,
                        a.load()
                    ];
                case 1:
                    return h = r.sent(), o && l ? [
                        4,
                        yf.getManager(u).removeModel(c)
                    ] : [
                        3,
                        3
                    ];
                case 2:
                    r.sent(), r.label = 3;
                case 3:
                    return [
                        4,
                        s.save(h)
                    ];
                case 4:
                    return f = r.sent(), !o || l ? [
                        3,
                        6
                    ] : [
                        4,
                        yf.getManager(u).removeModel(c)
                    ];
                case 5:
                    r.sent(), r.label = 6;
                case 6:
                    return [
                        2,
                        f.modelArtifactsInfo
                    ];
            }
        });
    });
}
var wf = "models_store", Cf = "model_info_store";
function Ef() {
    if (!i().getBool("IS_BROWSER")) throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
    var t = window || self, e = t.indexedDB || t.mozIndexedDB || t.webkitIndexedDB || t.msIndexedDB || t.shimIndexedDB;
    if (null == e) throw new Error("The current browser does not appear to support IndexedDB.");
    return e;
}
function Rf(t) {
    var e = t.result;
    e.createObjectStore(wf, {
        keyPath: "modelPath"
    }), e.createObjectStore(Cf, {
        keyPath: "modelPath"
    });
}
var If = function() {
    function t(t) {
        if (this.indexedDB = Ef(), null == t || !t) throw new Error("For IndexedDB, modelPath must not be null, undefined or empty.");
        this.modelPath = t;
    }
    return t.prototype.save = function(t) {
        return n(this, void 0, void 0, function() {
            return r(this, function(e) {
                if (t.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
                return [
                    2,
                    this.databaseAction(this.modelPath, t)
                ];
            });
        });
    }, t.prototype.load = function() {
        return n(this, void 0, void 0, function() {
            return r(this, function(t) {
                return [
                    2,
                    this.databaseAction(this.modelPath)
                ];
            });
        });
    }, t.prototype.databaseAction = function(t, e) {
        var n = this;
        return new Promise(function(t, r) {
            var o = n.indexedDB.open("tensorflowjs", 1);
            o.onupgradeneeded = function() {
                return Rf(o);
            }, o.onsuccess = function() {
                var a = o.result;
                if (null == e) {
                    var i = a.transaction(wf, "readonly"), s = i.objectStore(wf).get(n.modelPath);
                    s.onsuccess = function() {
                        if (null == s.result) return a.close(), r(new Error("Cannot find model with path '" + n.modelPath + "' in IndexedDB."));
                        t(s.result.modelArtifacts);
                    }, s.onerror = function(t) {
                        return a.close(), r(s.error);
                    }, i.oncomplete = function() {
                        return a.close();
                    };
                } else {
                    var u, c = vf(e), l = a.transaction(Cf, "readwrite"), h = l.objectStore(Cf), f = h.put({
                        modelPath: n.modelPath,
                        modelArtifactsInfo: c
                    });
                    f.onsuccess = function() {
                        var o = (u = a.transaction(wf, "readwrite")).objectStore(wf).put({
                            modelPath: n.modelPath,
                            modelArtifacts: e,
                            modelArtifactsInfo: c
                        });
                        o.onsuccess = function() {
                            return t({
                                modelArtifactsInfo: c
                            });
                        }, o.onerror = function(t) {
                            var e = (h = l.objectStore(Cf)).delete(n.modelPath);
                            e.onsuccess = function() {
                                return a.close(), r(o.error);
                            }, e.onerror = function(t) {
                                return a.close(), r(o.error);
                            };
                        };
                    }, f.onerror = function(t) {
                        return a.close(), r(f.error);
                    }, l.oncomplete = function() {
                        null == u ? a.close() : u.oncomplete = function() {
                            return a.close();
                        };
                    };
                }
            }, o.onerror = function(t) {
                return r(o.error);
            };
        });
    }, t.URL_SCHEME = "indexeddb://", t;
}(), kf = function(t) {
    var e;
    return i().getBool("IS_BROWSER") && !Array.isArray(t) && t.startsWith(If.URL_SCHEME) ? (e = t.slice(If.URL_SCHEME.length), new If(e)) : null;
};
mf.registerSaveRouter(kf), mf.registerLoadRouter(kf);
var Sf = function() {
    function t() {
        this.indexedDB = Ef();
    }
    return t.prototype.listModels = function() {
        return n(this, void 0, void 0, function() {
            var t = this;
            return r(this, function(e) {
                return [
                    2,
                    new Promise(function(e, n) {
                        var r = t.indexedDB.open("tensorflowjs", 1);
                        r.onupgradeneeded = function() {
                            return Rf(r);
                        }, r.onsuccess = function() {
                            var t = r.result, o = t.transaction(Cf, "readonly"), a = o.objectStore(Cf).getAll();
                            a.onsuccess = function() {
                                for(var t = {}, n = 0, r = a.result; n < r.length; n++){
                                    var o = r[n];
                                    t[o.modelPath] = o.modelArtifactsInfo;
                                }
                                e(t);
                            }, a.onerror = function(e) {
                                return t.close(), n(a.error);
                            }, o.oncomplete = function() {
                                return t.close();
                            };
                        }, r.onerror = function(t) {
                            return n(r.error);
                        };
                    })
                ];
            });
        });
    }, t.prototype.removeModel = function(t) {
        return n(this, void 0, void 0, function() {
            var e = this;
            return r(this, function(n) {
                var r;
                return t = (r = t).startsWith(If.URL_SCHEME) ? r.slice(If.URL_SCHEME.length) : r, [
                    2,
                    new Promise(function(n, r) {
                        var o = e.indexedDB.open("tensorflowjs", 1);
                        o.onupgradeneeded = function() {
                            return Rf(o);
                        }, o.onsuccess = function() {
                            var e, a = o.result, i = a.transaction(Cf, "readwrite"), s = i.objectStore(Cf), u = s.get(t);
                            u.onsuccess = function() {
                                if (null == u.result) return a.close(), r(new Error("Cannot find model with path '" + t + "' in IndexedDB."));
                                var o = s.delete(t), i = function() {
                                    var o = (e = a.transaction(wf, "readwrite")).objectStore(wf).delete(t);
                                    o.onsuccess = function() {
                                        return n(u.result.modelArtifactsInfo);
                                    }, o.onerror = function(t) {
                                        return r(u.error);
                                    };
                                };
                                o.onsuccess = i, o.onerror = function(t) {
                                    return i(), a.close(), r(u.error);
                                };
                            }, u.onerror = function(t) {
                                return a.close(), r(u.error);
                            }, i.oncomplete = function() {
                                null == e ? a.close() : e.oncomplete = function() {
                                    return a.close();
                                };
                            };
                        }, o.onerror = function(t) {
                            return r(o.error);
                        };
                    })
                ];
            });
        });
    }, t;
}();
if (i().getBool("IS_BROWSER")) try {
    yf.registerManager(If.URL_SCHEME, new Sf);
} catch (t) {}
var Af = "/", Df = "tensorflowjs_models", Tf = "info", Nf = "model_topology", Ff = "weight_specs", _f = "weight_data", Of = "model_metadata";
function Mf(t) {
    return {
        info: [
            Df,
            t,
            Tf
        ].join(Af),
        topology: [
            Df,
            t,
            Nf
        ].join(Af),
        weightSpecs: [
            Df,
            t,
            Ff
        ].join(Af),
        weightData: [
            Df,
            t,
            _f
        ].join(Af),
        modelMetadata: [
            Df,
            t,
            Of
        ].join(Af)
    };
}
function Bf(t) {
    var e = t.split(Af);
    if (e.length < 3) throw new Error("Invalid key format: " + t);
    return e.slice(1, e.length - 1).join(Af);
}
var Pf = function() {
    function t(t) {
        if (!i().getBool("IS_BROWSER") || "undefined" == typeof window || void 0 === window.localStorage) throw new Error("The current environment does not support local storage.");
        if (this.LS = window.localStorage, null == t || !t) throw new Error("For local storage, modelPath must not be null, undefined or empty.");
        this.modelPath = t, this.keys = Mf(this.modelPath);
    }
    return t.prototype.save = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n, o;
            return r(this, function(r) {
                if (t.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
                e = JSON.stringify(t.modelTopology), n = JSON.stringify(t.weightSpecs), o = vf(t);
                try {
                    return this.LS.setItem(this.keys.info, JSON.stringify(o)), this.LS.setItem(this.keys.topology, e), this.LS.setItem(this.keys.weightSpecs, n), this.LS.setItem(this.keys.weightData, function(t) {
                        if (hf) return $ccc6390119ecc6e0$require$Buffer.from(t).toString("base64");
                        for(var e = new Uint8Array(t), n = "", r = 0, o = e.length; r < o; r++)n += String.fromCharCode(e[r]);
                        return btoa(n);
                    }(t.weightData)), this.LS.setItem(this.keys.modelMetadata, JSON.stringify({
                        format: t.format,
                        generatedBy: t.generatedBy,
                        convertedBy: t.convertedBy,
                        userDefinedMetadata: t.userDefinedMetadata
                    })), [
                        2,
                        {
                            modelArtifactsInfo: o
                        }
                    ];
                } catch (t) {
                    throw this.LS.removeItem(this.keys.info), this.LS.removeItem(this.keys.topology), this.LS.removeItem(this.keys.weightSpecs), this.LS.removeItem(this.keys.weightData), this.LS.removeItem(this.keys.modelMetadata), new Error("Failed to save model '" + this.modelPath + "' to local storage: size quota being exceeded is a possible cause of this failure: modelTopologyBytes=" + o.modelTopologyBytes + ", weightSpecsBytes=" + o.weightSpecsBytes + ", weightDataBytes=" + o.weightDataBytes + ".");
                }
                return [
                    2
                ];
            });
        });
    }, t.prototype.load = function() {
        return n(this, void 0, void 0, function() {
            var t, e, n, o, a, i, s;
            return r(this, function(r) {
                if (null == (t = JSON.parse(this.LS.getItem(this.keys.info)))) throw new Error("In local storage, there is no model with name '" + this.modelPath + "'");
                if ("JSON" !== t.modelTopologyType) throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
                if (e = {}, null == (n = JSON.parse(this.LS.getItem(this.keys.topology)))) throw new Error("In local storage, the topology of model '" + this.modelPath + "' is missing.");
                if (e.modelTopology = n, null == (o = JSON.parse(this.LS.getItem(this.keys.weightSpecs)))) throw new Error("In local storage, the weight specs of model '" + this.modelPath + "' are missing.");
                if (e.weightSpecs = o, null != (a = this.LS.getItem(this.keys.modelMetadata)) && (i = JSON.parse(a), e.format = i.format, e.generatedBy = i.generatedBy, e.convertedBy = i.convertedBy, e.userDefinedMetadata = i.userDefinedMetadata), null == (s = this.LS.getItem(this.keys.weightData))) throw new Error("In local storage, the binary weight values of model '" + this.modelPath + "' are missing.");
                return e.weightData = function(t) {
                    if (hf) {
                        var e = $ccc6390119ecc6e0$require$Buffer.from(t, "base64");
                        return e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength);
                    }
                    for(var n = atob(t), r = new Uint8Array(n.length), o = 0; o < n.length; ++o)r.set([
                        n.charCodeAt(o)
                    ], o);
                    return r.buffer;
                }(s), [
                    2,
                    e
                ];
            });
        });
    }, t.URL_SCHEME = "localstorage://", t;
}(), Lf = function(t) {
    var e;
    return i().getBool("IS_BROWSER") && !Array.isArray(t) && t.startsWith(Pf.URL_SCHEME) ? (e = t.slice(Pf.URL_SCHEME.length), new Pf(e)) : null;
};
mf.registerSaveRouter(Lf), mf.registerLoadRouter(Lf);
var Wf = function() {
    function t() {
        C(i().getBool("IS_BROWSER"), function() {
            return "Current environment is not a web browser";
        }), C("undefined" == typeof window || void 0 !== window.localStorage, function() {
            return "Current browser does not appear to support localStorage";
        }), this.LS = window.localStorage;
    }
    return t.prototype.listModels = function() {
        return n(this, void 0, void 0, function() {
            var t, e, n, o, a, i;
            return r(this, function(r) {
                for(t = {}, e = Df + Af, n = Af + Tf, o = 0; o < this.LS.length; ++o)(a = this.LS.key(o)).startsWith(e) && a.endsWith(n) && (i = Bf(a), t[i] = JSON.parse(this.LS.getItem(a)));
                return [
                    2,
                    t
                ];
            });
        });
    }, t.prototype.removeModel = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n;
            return r(this, function(r) {
                var o;
                if (t = (o = t).startsWith(Pf.URL_SCHEME) ? o.slice(Pf.URL_SCHEME.length) : o, e = Mf(t), null == this.LS.getItem(e.info)) throw new Error("Cannot find model at path '" + t + "'");
                return n = JSON.parse(this.LS.getItem(e.info)), this.LS.removeItem(e.info), this.LS.removeItem(e.topology), this.LS.removeItem(e.weightSpecs), this.LS.removeItem(e.weightData), [
                    2,
                    n
                ];
            });
        });
    }, t;
}();
if (i().getBool("IS_BROWSER")) try {
    yf.registerManager(Pf.URL_SCHEME, new Wf);
} catch (t) {}
var Uf = "model", Vf = ".json", zf = ".weights.bin";
function Gf(t) {
    return new Promise(function(t) {
        return setTimeout(t);
    }).then(t);
}
var Hf = function() {
    function t(e) {
        if (!i().getBool("IS_BROWSER")) throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
        e.startsWith(t.URL_SCHEME) && (e = e.slice(t.URL_SCHEME.length)), null != e && 0 !== e.length || (e = Uf), this.modelTopologyFileName = e + Vf, this.weightDataFileName = e + zf;
    }
    return t.prototype.save = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n, o, a, i, s;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        if ("undefined" == typeof document) throw new Error("Browser downloads are not supported in this environment since `document` is not present");
                        if (e = window.URL.createObjectURL(new Blob([
                            t.weightData
                        ], {
                            type: "application/octet-stream"
                        })), !(t.modelTopology instanceof ArrayBuffer)) return [
                            3,
                            1
                        ];
                        throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");
                    case 1:
                        return n = [
                            {
                                paths: [
                                    "./" + this.weightDataFileName
                                ],
                                weights: t.weightSpecs
                            }
                        ], o = {
                            modelTopology: t.modelTopology,
                            format: t.format,
                            generatedBy: t.generatedBy,
                            convertedBy: t.convertedBy,
                            weightsManifest: n
                        }, a = window.URL.createObjectURL(new Blob([
                            JSON.stringify(o)
                        ], {
                            type: "application/json"
                        })), (i = null == this.jsonAnchor ? document.createElement("a") : this.jsonAnchor).download = this.modelTopologyFileName, i.href = a, [
                            4,
                            Gf(function() {
                                return i.dispatchEvent(new MouseEvent("click"));
                            })
                        ];
                    case 2:
                        return r.sent(), null == t.weightData ? [
                            3,
                            4
                        ] : ((s = null == this.weightDataAnchor ? document.createElement("a") : this.weightDataAnchor).download = this.weightDataFileName, s.href = e, [
                            4,
                            Gf(function() {
                                return s.dispatchEvent(new MouseEvent("click"));
                            })
                        ]);
                    case 3:
                        r.sent(), r.label = 4;
                    case 4:
                        return [
                            2,
                            {
                                modelArtifactsInfo: vf(t)
                            }
                        ];
                }
            });
        });
    }, t.URL_SCHEME = "downloads://", t;
}(), qf = function() {
    function t(t) {
        if (null == t || t.length < 1) throw new Error("When calling browserFiles, at least 1 file is required, but received " + t);
        this.files = t;
    }
    return t.prototype.load = function() {
        return n(this, void 0, void 0, function() {
            var t, e, n = this;
            return r(this, function(r) {
                return t = this.files[0], e = this.files.slice(1), [
                    2,
                    new Promise(function(r, o) {
                        var a = new FileReader;
                        a.onload = function(a) {
                            var i = JSON.parse(a.target.result), s = i.modelTopology;
                            if (null != s) {
                                0 === e.length && r({
                                    modelTopology: s
                                });
                                var u = i.weightsManifest;
                                if (null != u) {
                                    var c;
                                    try {
                                        c = n.checkManifestAndWeightFiles(u, e);
                                    } catch (t) {
                                        return void o(t);
                                    }
                                    var l = [], h = [], f = [];
                                    u.forEach(function(t) {
                                        t.paths.forEach(function(t) {
                                            h.push(t), f.push(null);
                                        }), l.push.apply(l, t.weights);
                                    }), u.forEach(function(t) {
                                        t.paths.forEach(function(t) {
                                            var e = new FileReader;
                                            e.onload = function(e) {
                                                var n = e.target.result, o = h.indexOf(t);
                                                f[o] = n, -1 === f.indexOf(null) && r({
                                                    modelTopology: s,
                                                    weightSpecs: l,
                                                    weightData: df(f),
                                                    format: i.format,
                                                    generatedBy: i.generatedBy,
                                                    convertedBy: i.convertedBy,
                                                    userDefinedMetadata: i.userDefinedMetadata
                                                });
                                            }, e.onerror = function(e) {
                                                return o("Failed to weights data from file of path '" + t + "'.");
                                            }, e.readAsArrayBuffer(c[t]);
                                        });
                                    });
                                } else o(new Error("weightManifest field is missing from file " + t.name));
                            } else o(new Error("modelTopology field is missing from file " + t.name));
                        }, a.onerror = function(e) {
                            return o("Failed to read model topology and weights manifest JSON from file '" + t.name + "'. BrowserFiles supports loading Keras-style tf.Model artifacts only.");
                        }, a.readAsText(t);
                    })
                ];
            });
        });
    }, t.prototype.checkManifestAndWeightFiles = function(t, e) {
        for(var n = [], r = e.map(function(t) {
            return pf(t.name);
        }), o = {}, a = 0, i = t; a < i.length; a++)i[a].paths.forEach(function(t) {
            var a = pf(t);
            if (-1 !== n.indexOf(a)) throw new Error("Duplicate file basename found in weights manifest: '" + a + "'");
            if (n.push(a), -1 === r.indexOf(a)) throw new Error("Weight file with basename '" + a + "' is not provided.");
            o[t] = e[r.indexOf(a)];
        });
        if (n.length !== e.length) throw new Error("Mismatch in the number of files in weights manifest (" + n.length + ") and the number of weight files provided (" + e.length + ").");
        return o;
    }, t;
}();
function Kf(t, e, n, r) {
    !function(t) {
        C(null != t && Array.isArray(t) && t.length > 0, function() {
            return "promises must be a none empty array";
        });
    }(t), function(t, e) {
        C(t >= 0 && t <= 1, function() {
            return "Progress fraction must be in range [0, 1], but got startFraction " + t;
        }), C(e >= 0 && e <= 1, function() {
            return "Progress fraction must be in range [0, 1], but got endFraction " + e;
        }), C(e >= t, function() {
            return "startFraction must be no more than endFraction, but got startFraction " + t + " and endFraction " + e;
        });
    }(n = null == n ? 0 : n, r = null == r ? 1 : r);
    var o = 0;
    return Promise.all(t.map(function(a) {
        return a.then(function(a) {
            var i = n + ++o / t.length * (r - n);
            return e(i), a;
        }), a;
    }));
}
function jf(t, e) {
    return n(this, void 0, void 0, function() {
        var n, o, a, s, u, c, l, h, f;
        return r(this, function(r) {
            switch(r.label){
                case 0:
                    return null == e && (e = {}), n = null == e.fetchFunc ? i().platform.fetch : e.fetchFunc, o = t.map(function(t) {
                        return n(t, e.requestInit, {
                            isBinary: !0
                        });
                    }), a = 0, s = .5, null != e.onProgress ? [
                        3,
                        2
                    ] : [
                        4,
                        Promise.all(o)
                    ];
                case 1:
                    return u = r.sent(), [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        Kf(o, e.onProgress, a, s)
                    ];
                case 3:
                    u = r.sent(), r.label = 4;
                case 4:
                    return c = u.map(function(t) {
                        return t.arrayBuffer();
                    }), l = .5, h = 1, null != e.onProgress ? [
                        3,
                        6
                    ] : [
                        4,
                        Promise.all(c)
                    ];
                case 5:
                    return f = r.sent(), [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        Kf(c, e.onProgress, l, h)
                    ];
                case 7:
                    f = r.sent(), r.label = 8;
                case 8:
                    return [
                        2,
                        f
                    ];
            }
        });
    });
}
function Xf(t) {
    var e = this;
    return function(o, a, i) {
        return void 0 === a && (a = ""), n(e, void 0, void 0, function() {
            var e, n, s, u, c, l, h, f, d, p;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        if (e = o.map(function() {
                            return !1;
                        }), n = {}, s = null != i ? i.map(function() {
                            return !1;
                        }) : [], u = [], o.forEach(function(t, r) {
                            var o = 0;
                            t.weights.forEach(function(t) {
                                var a = "quantization" in t ? t.quantization.dtype : t.dtype, c = sf[a] * k(t.shape), l = function() {
                                    e[r] = !0, null == n[r] && (n[r] = []), n[r].push({
                                        manifestEntry: t,
                                        groupOffset: o,
                                        sizeBytes: c
                                    });
                                };
                                null != i ? i.forEach(function(e, n) {
                                    e === t.name && (l(), s[n] = !0);
                                }) : l(), u.push(t.name), o += c;
                            });
                        }), !s.every(function(t) {
                            return t;
                        })) throw c = i.filter(function(t, e) {
                            return !s[e];
                        }), new Error("Could not find weights in manifest with names: " + c.join(", ") + ". \nManifest JSON has weights with names: " + u.join(", ") + ".");
                        return l = e.reduce(function(t, e, n) {
                            return e && t.push(n), t;
                        }, []), h = [], l.forEach(function(t) {
                            o[t].paths.forEach(function(t) {
                                var e = a + (a.endsWith("/") ? "" : "/") + t;
                                h.push(e);
                            });
                        }), [
                            4,
                            t(h)
                        ];
                    case 1:
                        return f = r.sent(), d = {}, p = 0, l.forEach(function(t) {
                            for(var e = o[t].paths.length, r = 0, a = 0; a < e; a++)r += f[p + a].byteLength;
                            for(var i = new ArrayBuffer(r), s = new Uint8Array(i), u = 0, c = 0; c < e; c++){
                                var l = new Uint8Array(f[p + c]);
                                s.set(l, u), u += l.byteLength;
                            }
                            n[t].forEach(function(t) {
                                var e = cf(i.slice(t.groupOffset, t.groupOffset + t.sizeBytes), [
                                    t.manifestEntry
                                ]);
                                for(var n in e)d[n] = e[n];
                            }), p += e;
                        }), [
                            2,
                            d
                        ];
                }
            });
        });
    };
}
mf.registerSaveRouter(function(t) {
    return i().getBool("IS_BROWSER") && !Array.isArray(t) && t.startsWith(Hf.URL_SCHEME) ? function(t) {
        void 0 === t && (t = "model");
        return new Hf(t);
    }(t.slice(Hf.URL_SCHEME.length)) : null;
});
var Yf = function() {
    function t(t, e) {
        if (this.DEFAULT_METHOD = "POST", null == e && (e = {}), this.weightPathPrefix = e.weightPathPrefix, this.onProgress = e.onProgress, null != e.fetchFunc ? (C("function" == typeof e.fetchFunc, function() {
            return "Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)";
        }), this.fetch = e.fetchFunc) : this.fetch = i().platform.fetch, C(null != t && t.length > 0, function() {
            return "URL path for http must not be null, undefined or empty.";
        }), Array.isArray(t) && C(2 === t.length, function() {
            return "URL paths for http must have a length of 2, (actual length is " + t.length + ").";
        }), this.path = t, null != e.requestInit && null != e.requestInit.body) throw new Error("requestInit is expected to have no pre-existing body, but has one.");
        this.requestInit = e.requestInit || {};
    }
    return t.prototype.save = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n, o, a;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        if (t.modelTopology instanceof ArrayBuffer) throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
                        return (e = Object.assign({
                            method: this.DEFAULT_METHOD
                        }, this.requestInit)).body = new FormData, n = [
                            {
                                paths: [
                                    "./model.weights.bin"
                                ],
                                weights: t.weightSpecs
                            }
                        ], o = {
                            modelTopology: t.modelTopology,
                            format: t.format,
                            generatedBy: t.generatedBy,
                            convertedBy: t.convertedBy,
                            userDefinedMetadata: t.userDefinedMetadata,
                            weightsManifest: n
                        }, e.body.append("model.json", new Blob([
                            JSON.stringify(o)
                        ], {
                            type: "application/json"
                        }), "model.json"), null != t.weightData && e.body.append("model.weights.bin", new Blob([
                            t.weightData
                        ], {
                            type: "application/octet-stream"
                        }), "model.weights.bin"), [
                            4,
                            this.fetch(this.path, e)
                        ];
                    case 1:
                        if ((a = r.sent()).ok) return [
                            2,
                            {
                                modelArtifactsInfo: vf(t),
                                responses: [
                                    a
                                ]
                            }
                        ];
                        throw new Error("BrowserHTTPRequest.save() failed due to HTTP response status " + a.status + ".");
                }
            });
        });
    }, t.prototype.load = function() {
        return n(this, void 0, void 0, function() {
            var t, e, n, o, a, i, s, u, c, l, h, f;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.fetch(this.path, this.requestInit)
                        ];
                    case 1:
                        if (!(t = r.sent()).ok) throw new Error("Request to " + this.path + " failed with status code " + t.status + ". Please verify this URL points to the model JSON of the model to load.");
                        r.label = 2;
                    case 2:
                        return r.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]), [
                            4,
                            t.json()
                        ];
                    case 3:
                        return e = r.sent(), [
                            3,
                            5
                        ];
                    case 4:
                        throw r.sent(), n = "Failed to parse model JSON of response from " + this.path + ".", this.path.endsWith(".pb") ? n += " Your path contains a .pb file extension. Support for .pb models have been removed in TensorFlow.js 1.0 in favor of .json models. You can re-convert your Python TensorFlow model using the TensorFlow.js 1.0 conversion scripts or you can convert your.pb models with the 'pb2json'NPM script in the tensorflow/tfjs-converter repository." : n += " Please make sure the server is serving valid JSON for this request.", new Error(n);
                    case 5:
                        if (o = e.modelTopology, a = e.weightsManifest, i = e.generatedBy, s = e.convertedBy, u = e.format, c = e.userDefinedMetadata, null == o && null == a) throw new Error("The JSON from HTTP path " + this.path + " contains neither model topology or manifest for weights.");
                        return null == a ? [
                            3,
                            7
                        ] : [
                            4,
                            this.loadWeights(a)
                        ];
                    case 6:
                        f = r.sent(), l = f[0], h = f[1], r.label = 7;
                    case 7:
                        return [
                            2,
                            {
                                modelTopology: o,
                                weightSpecs: l,
                                weightData: h,
                                userDefinedMetadata: c,
                                generatedBy: i,
                                convertedBy: s,
                                format: u
                            }
                        ];
                }
            });
        });
    }, t.prototype.loadWeights = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n, o, a, i, s, u, c, l, h, f;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        for(e = Array.isArray(this.path) ? this.path[1] : this.path, n = function(t) {
                            var e = t.lastIndexOf("/"), n = t.lastIndexOf("?"), r = t.substring(0, e), o = n > e ? t.substring(n) : "";
                            return [
                                r + "/",
                                o
                            ];
                        }(e), o = n[0], a = n[1], i = this.weightPathPrefix || o, s = [], u = 0, c = t; u < c.length; u++)l = c[u], s.push.apply(s, l.weights);
                        return h = [], t.forEach(function(t) {
                            t.paths.forEach(function(t) {
                                h.push(i + t + a);
                            });
                        }), [
                            4,
                            jf(h, {
                                requestInit: this.requestInit,
                                fetchFunc: this.fetch,
                                onProgress: this.onProgress
                            })
                        ];
                    case 1:
                        return f = r.sent(), [
                            2,
                            [
                                s,
                                df(f)
                            ]
                        ];
                }
            });
        });
    }, t.URL_SCHEME_REGEX = /^https?:\/\//, t;
}();
function $f(t) {
    return null != t.match(Yf.URL_SCHEME_REGEX);
}
var Qf = function(t, e) {
    if ("undefined" == typeof fetch) return null;
    return (Array.isArray(t) ? t.every(function(t) {
        return $f(t);
    }) : $f(t)) ? Jf(t, {
        onProgress: e
    }) : null;
};
function Jf(t, e) {
    return new Yf(t, e);
}
mf.registerSaveRouter(Qf), mf.registerLoadRouter(Qf);
var Zf = function() {
    function t(t) {
        this.modelArtifacts = t;
    }
    return t.prototype.load = function() {
        return n(this, void 0, void 0, function() {
            return r(this, function(t) {
                return [
                    2,
                    this.modelArtifacts
                ];
            });
        });
    }, t;
}(), td = function() {
    function t(t) {
        this.saveHandler = t;
    }
    return t.prototype.save = function(t) {
        return n(this, void 0, void 0, function() {
            return r(this, function(e) {
                return [
                    2,
                    this.saveHandler(t)
                ];
            });
        });
    }, t;
}();
var ed = Object.freeze({
    browserFiles: function(t) {
        return new qf(t);
    },
    browserHTTPRequest: function(t, e) {
        return Jf(t, e);
    },
    concatenateArrayBuffers: df,
    decodeWeights: cf,
    encodeWeights: function(t, e) {
        return n(this, void 0, void 0, function() {
            var o, a, i, s, u, c = this;
            return r(this, function(l) {
                switch(l.label){
                    case 0:
                        for(o = [], a = [], i = Array.isArray(t) ? t.map(function(t) {
                            return t.name;
                        }) : Object.keys(t), s = function(s) {
                            var u = i[s], l = Array.isArray(t) ? t[s].tensor : t[u];
                            if ("float32" !== l.dtype && "int32" !== l.dtype && "bool" !== l.dtype && "string" !== l.dtype) throw new Error("Unsupported dtype in weight '" + u + "': " + l.dtype);
                            var h = {
                                name: u,
                                shape: l.shape,
                                dtype: l.dtype
                            };
                            if ("string" === l.dtype) {
                                var f = new Promise(function(t) {
                                    return n(c, void 0, void 0, function() {
                                        var e, n, o, a, i, s, u;
                                        return r(this, function(r) {
                                            switch(r.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        l.bytes()
                                                    ];
                                                case 1:
                                                    for(e = r.sent(), n = e.reduce(function(t, e) {
                                                        return t + e.length;
                                                    }, 0) + uf * e.length, o = new Uint8Array(n), a = 0, i = 0; i < e.length; i++)s = e[i], u = new Uint8Array(new Uint32Array([
                                                        s.length
                                                    ]).buffer), o.set(u, a), a += uf, o.set(s, a), a += s.length;
                                                    return t(o), [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                });
                                a.push(f);
                            } else a.push(l.data());
                            null != e && (h.group = e), o.push(h);
                        }, u = 0; u < i.length; ++u)s(u);
                        return [
                            4,
                            Promise.all(a)
                        ];
                    case 1:
                        return [
                            2,
                            {
                                data: lf(l.sent()),
                                specs: o
                            }
                        ];
                }
            });
        });
    },
    fromMemory: function(t, e, n, r) {
        return 1 === arguments.length ? null != t.modelTopology || null != t.weightSpecs ? new Zf(t) : (console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release."), new Zf({
            modelTopology: t
        })) : (console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release."), new Zf({
            modelTopology: t,
            weightSpecs: e,
            weightData: n,
            trainingConfig: r
        }));
    },
    getLoadHandlers: function(t, e) {
        return mf.getLoadHandlers(t, e);
    },
    getModelArtifactsInfoForJSON: vf,
    getSaveHandlers: function(t) {
        return mf.getSaveHandlers(t);
    },
    http: Jf,
    isHTTPScheme: $f,
    loadWeights: function(t, e, o, a) {
        return void 0 === e && (e = ""), n(this, void 0, void 0, function() {
            return r(this, function(n) {
                return [
                    2,
                    Xf(function(t) {
                        return jf(t, {
                            requestInit: a
                        });
                    })(t, e, o)
                ];
            });
        });
    },
    registerLoadRouter: function(t) {
        return mf.registerLoadRouter(t);
    },
    registerSaveRouter: function(t) {
        return mf.registerSaveRouter(t);
    },
    weightsLoaderFactory: Xf,
    withSaveHandler: function(t) {
        return new td(t);
    },
    copyModel: function(t, e) {
        return n(this, void 0, void 0, function() {
            return r(this, function(n) {
                return [
                    2,
                    bf(t, e, !1)
                ];
            });
        });
    },
    listModels: function() {
        return n(this, void 0, void 0, function() {
            var t, e, n, o, a, i, s;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        t = yf.getSchemes(), e = {}, n = 0, o = t, r.label = 1;
                    case 1:
                        return n < o.length ? (a = o[n], [
                            4,
                            yf.getManager(a).listModels()
                        ]) : [
                            3,
                            4
                        ];
                    case 2:
                        for(s in i = r.sent())e[a + gf + s] = i[s];
                        r.label = 3;
                    case 3:
                        return n++, [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2,
                            e
                        ];
                }
            });
        });
    },
    moveModel: function(t, e) {
        return n(this, void 0, void 0, function() {
            return r(this, function(n) {
                return [
                    2,
                    bf(t, e, !0)
                ];
            });
        });
    },
    removeModel: function(t) {
        return n(this, void 0, void 0, function() {
            var e;
            return r(this, function(n) {
                return e = xf(t), [
                    2,
                    yf.getManager(e.scheme).removeModel(e.path)
                ];
            });
        });
    }
});
var nd, rd = An({
    confusionMatrix_: function(t, e, n) {
        var r = mn(t, "labels", "confusionMatrix"), o = mn(e, "predictions", "confusionMatrix");
        C(null == n || n > 0 && Number.isInteger(n), function() {
            return "If provided, numClasses must be a positive integer, but got " + n;
        }), C(1 === r.rank, function() {
            return "Expected the rank of labels to be 1, but got " + r.rank;
        }), C(1 === o.rank, function() {
            return "Expected the rank of predictions to be 1, but got " + o.rank;
        }), C(r.shape[0] === o.shape[0], function() {
            return "Mismatch in the number of examples: " + r.shape[0] + " vs. " + o.shape[0] + ". Labels and predictions should have the same number of elements.";
        }), C(n > 0 && Number.isInteger(n), function() {
            return "numClasses is required to be a positive integer, but got " + n;
        });
        var a = Rr(r.asType("int32"), n), i = Rr(o.asType("int32"), n);
        return a.transpose().matMul(i).asType("int32");
    }
}), od = Object.freeze({
    confusionMatrix: rd
});
var ad = An({
    fromPixels_: function(t, e) {
        if (void 0 === e && (e = 3), e > 4) throw new Error("Cannot construct Tensor with more than 4 channels from pixels.");
        if (null == t) throw new Error("pixels passed to tf.browser.fromPixels() can not be null");
        var n = !1, r = !1, o = !1, a = !1, i = !1;
        if (t.data instanceof Uint8Array) n = !0;
        else if ("undefined" != typeof ImageData && t instanceof ImageData) r = !0;
        else if ("undefined" != typeof HTMLVideoElement && t instanceof HTMLVideoElement) o = !0;
        else if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement) a = !0;
        else {
            if (null == t.getContext) throw new Error("pixels passed to tf.browser.fromPixels() must be either an HTMLVideoElement, HTMLImageElement, HTMLCanvasElement, ImageData in browser, or OffscreenCanvas, ImageData in webworker or {data: Uint32Array, width: number, height: number}, but was " + t.constructor.name);
            i = !0;
        }
        if (o) {
            if (o && t.readyState < 2) throw new Error("The video element has not loaded data yet. Please wait for `loadeddata` event on the <video> element.");
        }
        if (null != l("FromPixels", Lt.backendName)) return Lt.runKernel("FromPixels", {
            pixels: t
        }, {
            numChannels: e
        });
        var s, u, c = o ? [
            t.videoWidth,
            t.videoHeight
        ] : [
            t.width,
            t.height
        ], h = c[0], f = c[1];
        if (i ? s = t.getContext("2d").getImageData(0, 0, h, f).data : r || n ? s = t.data : (a || o) && (null == nd && (nd = document.createElement("canvas").getContext("2d")), nd.canvas.width = h, nd.canvas.height = f, nd.drawImage(t, 0, 0, h, f), s = nd.getImageData(0, 0, h, f).data), 4 === e) u = new Int32Array(s);
        else {
            var d = h * f;
            u = new Int32Array(d * e);
            for(var p = 0; p < d; p++)for(var v = 0; v < e; ++v)u[p * e + v] = s[4 * p + v];
        }
        return Pn(u, [
            f,
            h,
            e
        ], "int32");
    }
}), id = Object.freeze({
    toPixels: function(t, e) {
        return n(this, void 0, void 0, function() {
            var n, o, a, i, s, u, c, l, h, f, d, p, v, m, g, y, x, b, w, C, E, R, I;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        if (n = mn(t, "img", "toPixels"), t instanceof wt || (n = n.toInt()), 2 !== n.rank && 3 !== n.rank) throw new Error("toPixels only supports rank 2 or 3 tensors, got rank " + n.rank + ".");
                        if (o = n.shape.slice(0, 2), a = o[0], i = o[1], (s = 2 === n.rank ? 1 : n.shape[2]) > 4 || 2 === s) throw new Error("toPixels only supports depth of size 1, 3 or 4 but got " + s);
                        return [
                            4,
                            n.data()
                        ];
                    case 1:
                        return u = r.sent(), c = n.min(), l = n.max(), [
                            4,
                            Promise.all([
                                c.data(),
                                l.data()
                            ])
                        ];
                    case 2:
                        if (h = r.sent(), f = h[0], d = h[1], p = f[0], v = d[0], c.dispose(), l.dispose(), "float32" === n.dtype) {
                            if (p < 0 || v > 1) throw new Error("Tensor values for a float32 Tensor must be in the range [0 - 1] but got range [" + p + " - " + v + "].");
                        } else {
                            if ("int32" !== n.dtype) throw new Error("Unsupported type for toPixels: " + n.dtype + ". Please use float32 or int32 tensors.");
                            if (p < 0 || v > 255) throw new Error("Tensor values for a int32 Tensor must be in the range [0 - 255] but got range [" + p + " - " + v + "].");
                        }
                        for(m = "float32" === n.dtype ? 255 : 1, g = new Uint8ClampedArray(i * a * 4), y = 0; y < a * i; ++y)x = void 0, b = void 0, w = void 0, C = void 0, 1 === s ? (x = u[y] * m, b = u[y] * m, w = u[y] * m, C = 255) : 3 === s ? (x = u[3 * y] * m, b = u[3 * y + 1] * m, w = u[3 * y + 2] * m, C = 255) : 4 === s && (x = u[4 * y] * m, b = u[4 * y + 1] * m, w = u[4 * y + 2] * m, C = u[4 * y + 3] * m), g[(E = 4 * y) + 0] = Math.round(x), g[E + 1] = Math.round(b), g[E + 2] = Math.round(w), g[E + 3] = Math.round(C);
                        return null != e && (e.width = i, e.height = a, R = e.getContext("2d"), I = new ImageData(g, i, a), R.putImageData(I, 0, 0)), n !== t && n.dispose(), [
                            2,
                            g
                        ];
                }
            });
        });
    },
    fromPixels: ad
}), sd = function() {
    function t() {}
    return t.prototype.getClassName = function() {
        return this.constructor.className;
    }, t.fromConfig = function(t, e) {
        return new t(e);
    }, t;
}(), ud = function() {
    function t() {
        this.classNameMap = {};
    }
    return t.getMap = function() {
        return null == t.instance && (t.instance = new t), t.instance;
    }, t.register = function(e) {
        t.getMap().classNameMap[e.className] = [
            e,
            e.fromConfig
        ];
    }, t;
}();
function cd(t) {
    C(null != t.className, function() {
        return "Class being registered does not have the static className property defined.";
    }), C("string" == typeof t.className, function() {
        return "className is required to be a string, but got type " + typeof t.className;
    }), C(t.className.length > 0, function() {
        return "Class being registered has an empty-string as its className, which is disallowed.";
    }), ud.register(t);
}
var ld = Object.freeze({
    Serializable: sd,
    SerializationMap: ud,
    registerClass: cd
}), hd = .001, fd = .1;
function dd() {
    return 32 === Lt.backend.floatPrecision() ? hd : fd;
}
function pd(t, e, n) {
    var r = !0;
    if ((V(t) || V(e)) && (r = !1), V(t) && V(e) && (r = !0), r) {
        var o = t.constructor.name, a = e.constructor.name;
        if (o !== a) throw new Error("Arrays are of different type. Actual: " + o + ". Expected: " + a);
    }
    if (Array.isArray(t) && Array.isArray(e)) {
        var i = pn(t), s = pn(e);
        if (!S(i, s)) throw new Error("Arrays have different shapes. Actual: [" + i + "]. Expected: [" + s + "]");
    }
    var u = V(t) ? t : I(t), c = V(e) ? e : I(e);
    if (u.length !== c.length) throw new Error("Arrays have different lengths actual: " + u.length + " vs expected: " + c.length + ".\nActual:   " + u + ".\nExpected: " + c + ".");
    for(var l = 0; l < c.length; ++l){
        var h = u[l], f = c[l];
        if (!n(h, f)) throw new Error("Arrays differ: actual[" + l + "] = " + h + ", expected[" + l + "] = " + f + ".\nActual:   " + u + ".\nExpected: " + c + ".");
    }
}
function vd(t, e, n) {
    return !isFinite(t) && !isFinite(e) || !(isNaN(t) || isNaN(e) || Math.abs(t - e) > n);
}
var md = Object.freeze({
    TEST_EPSILON_FLOAT16: fd,
    expectArraysClose: function(t, e, n) {
        return null == n && (n = dd()), pd(t, e, function(t, e) {
            return vd(t, e, n);
        });
    },
    testEpsilon: dd,
    expectPromiseToFail: function(t, e) {
        t().then(function() {
            return e.fail();
        }, function() {
            return e();
        });
    },
    expectArraysEqual: function(t, e) {
        var n = "string" == typeof e || "number" == typeof e || "boolean" == typeof e ? [
            e
        ] : e;
        return H(t) || H(t[0]) || H(e) || H(e[0]) ? pd(t, n, function(t, e) {
            return t == e;
        }) : pd(t, e, function(t, e) {
            return vd(t, e, 0);
        });
    },
    expectNumbersClose: function(t, e, n) {
        if (null == n && (n = dd()), !vd(t, e, n)) throw new Error("Numbers differ: actual === " + t + ", expected === " + e);
    },
    expectValuesInRange: function(t, e, n) {
        for(var r = 0; r < t.length; r++)if (t[r] < e || t[r] > n) throw new Error("Value out of range:" + t[r] + " low: " + e + ", high: " + n);
    },
    expectArrayBuffersEqual: function(t, e) {
        expect(new Float32Array(t)).toEqual(new Float32Array(e));
    }
}), gd = "1.7.0";
var yd = Object.freeze({
    gpgpu_util: Mi,
    webgl_util: Ge,
    forceHalfFloat: function() {
        i().set("WEBGL_FORCE_F16_TEXTURES", !0);
    },
    MathBackendWebGL: Zs,
    setWebGLContext: Kt,
    GPGPUContext: Bi
}), xd = function(t) {
    function o() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return e(o, t), o.prototype.minimize = function(t, e, n) {
        void 0 === e && (e = !1);
        var r = this.computeGradients(t, n), o = r.value, a = r.grads;
        if (null != n) {
            var i = n.map(function(t) {
                return {
                    name: t.name,
                    tensor: a[t.name]
                };
            });
            this.applyGradients(i);
        } else this.applyGradients(a);
        return tn(a), e ? o : (o.dispose(), null);
    }, Object.defineProperty(o.prototype, "iterations", {
        get: function() {
            return null == this.iterations_ && (this.iterations_ = 0), this.iterations_;
        },
        enumerable: !0,
        configurable: !0
    }), o.prototype.incrementIterations = function() {
        this.iterations_ = this.iterations + 1;
    }, o.prototype.computeGradients = function(t, e) {
        return po(t, e);
    }, o.prototype.dispose = function() {
        null != this.iterations_ && tn(this.iterations_);
    }, o.prototype.saveIterations = function() {
        return n(this, void 0, void 0, function() {
            return r(this, function(t) {
                return null == this.iterations_ && (this.iterations_ = 0), [
                    2,
                    {
                        name: "iter",
                        tensor: On(this.iterations_, "int32")
                    }
                ];
            });
        });
    }, o.prototype.getWeights = function() {
        return n(this, void 0, void 0, function() {
            return r(this, function(t) {
                throw new Error("getWeights() is not implemented for this optimizer yet.");
            });
        });
    }, o.prototype.setWeights = function(t) {
        return n(this, void 0, void 0, function() {
            return r(this, function(t) {
                throw new Error("setWeights() is not implemented for this optimizer class " + this.getClassName());
            });
        });
    }, o.prototype.extractIterations = function(t) {
        return n(this, void 0, void 0, function() {
            var e;
            return r(this, function(n) {
                switch(n.label){
                    case 0:
                        return e = this, [
                            4,
                            t[0].tensor.data()
                        ];
                    case 1:
                        return e.iterations_ = n.sent()[0], [
                            2,
                            t.slice(1)
                        ];
                }
            });
        });
    }, o;
}(sd);
Object.defineProperty(xd, Symbol.hasInstance, {
    value: function(t) {
        return null != t.minimize && null != t.computeGradients && null != t.applyGradients;
    }
});
var bd = function(t) {
    function o(e, n, r) {
        void 0 === r && (r = null);
        var o = t.call(this) || this;
        return o.learningRate = e, o.rho = n, o.epsilon = r, o.accumulatedGrads = [], o.accumulatedUpdates = [], null == r && (o.epsilon = Lt.backend.epsilon()), o;
    }
    return e(o, t), o.prototype.applyGradients = function(t) {
        var e = this;
        (Array.isArray(t) ? t.map(function(t) {
            return t.name;
        }) : Object.keys(t)).forEach(function(n, r) {
            var o = Lt.registeredVariables[n];
            null == e.accumulatedGrads[r] && (e.accumulatedGrads[r] = {
                originalName: n + "/accum_grad",
                variable: Ze(function() {
                    return Xn(o).variable(!1);
                })
            }), null == e.accumulatedUpdates[r] && (e.accumulatedUpdates[r] = {
                originalName: n + "/accum_var",
                variable: Ze(function() {
                    return Xn(o).variable(!1);
                })
            });
            var a = Array.isArray(t) ? t[r].tensor : t[n];
            if (null != a) {
                var i = e.accumulatedGrads[r].variable, s = e.accumulatedUpdates[r].variable;
                Ze(function() {
                    var t = i.mul(e.rho).add(a.square().mul(1 - e.rho)), n = s.add(e.epsilon).sqrt().div(i.add(e.epsilon).sqrt()).mul(a), r = s.mul(e.rho).add(n.square().mul(1 - e.rho));
                    i.assign(t), s.assign(r);
                    var u = n.mul(-e.learningRate).add(o);
                    o.assign(u);
                });
            }
        }), this.incrementIterations();
    }, o.prototype.dispose = function() {
        null != this.accumulatedUpdates && (tn(this.accumulatedGrads.map(function(t) {
            return t.variable;
        })), tn(this.accumulatedUpdates.map(function(t) {
            return t.variable;
        })));
    }, o.prototype.getWeights = function() {
        return n(this, void 0, void 0, function() {
            var t;
            return r(this, function(e) {
                switch(e.label){
                    case 0:
                        return t = this.accumulatedGrads.concat(this.accumulatedUpdates), [
                            4,
                            this.saveIterations()
                        ];
                    case 1:
                        return [
                            2,
                            [
                                e.sent()
                            ].concat(t.map(function(t) {
                                return {
                                    name: t.originalName,
                                    tensor: t.variable
                                };
                            }))
                        ];
                }
            });
        });
    }, o.prototype.setWeights = function(t) {
        return n(this, void 0, void 0, function() {
            var e;
            return r(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.extractIterations(t)
                        ];
                    case 1:
                        return t = n.sent(), e = t.length / 2, this.accumulatedGrads = t.slice(0, e).map(function(t) {
                            return {
                                originalName: t.name,
                                variable: t.tensor.variable(!1)
                            };
                        }), this.accumulatedUpdates = t.slice(e, 2 * e).map(function(t) {
                            return {
                                originalName: t.name,
                                variable: t.tensor.variable(!1)
                            };
                        }), [
                            2
                        ];
                }
            });
        });
    }, o.prototype.getConfig = function() {
        return {
            learningRate: this.learningRate,
            rho: this.rho,
            epsilon: this.epsilon
        };
    }, o.fromConfig = function(t, e) {
        return new t(e.learningRate, e.rho, e.epsilon);
    }, o.className = "Adadelta", o;
}(xd);
cd(bd);
var wd = function(t) {
    function o(e, n) {
        void 0 === n && (n = .1);
        var r = t.call(this) || this;
        return r.learningRate = e, r.initialAccumulatorValue = n, r.accumulatedGrads = [], r;
    }
    return e(o, t), o.prototype.applyGradients = function(t) {
        var e = this;
        (Array.isArray(t) ? t.map(function(t) {
            return t.name;
        }) : Object.keys(t)).forEach(function(n, r) {
            var o = Lt.registeredVariables[n];
            if (null == e.accumulatedGrads[r]) e.accumulatedGrads[r] = {
                originalName: n + "/accumulator",
                variable: Ze(function() {
                    return Hn(o.shape, e.initialAccumulatorValue).variable(!1);
                })
            };
            var a = Array.isArray(t) ? t[r].tensor : t[n];
            if (null != a) {
                var i = e.accumulatedGrads[r].variable;
                Ze(function() {
                    var t = i.add(a.square());
                    i.assign(t);
                    var n = a.div(t.add(Lt.backend.epsilon()).sqrt()).mul(-e.learningRate).add(o);
                    o.assign(n);
                });
            }
        }), this.incrementIterations();
    }, o.prototype.dispose = function() {
        null != this.accumulatedGrads && tn(this.accumulatedGrads.map(function(t) {
            return t.variable;
        }));
    }, o.prototype.getWeights = function() {
        return n(this, void 0, void 0, function() {
            return r(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.saveIterations()
                        ];
                    case 1:
                        return [
                            2,
                            [
                                t.sent()
                            ].concat(this.accumulatedGrads.map(function(t) {
                                return {
                                    name: t.originalName,
                                    tensor: t.variable
                                };
                            }))
                        ];
                }
            });
        });
    }, o.prototype.setWeights = function(t) {
        return n(this, void 0, void 0, function() {
            return r(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.extractIterations(t)
                        ];
                    case 1:
                        return t = e.sent(), this.accumulatedGrads = t.map(function(t) {
                            return {
                                originalName: t.name,
                                variable: t.tensor.variable(!1)
                            };
                        }), [
                            2
                        ];
                }
            });
        });
    }, o.prototype.getConfig = function() {
        return {
            learningRate: this.learningRate,
            initialAccumulatorValue: this.initialAccumulatorValue
        };
    }, o.fromConfig = function(t, e) {
        return new t(e.learningRate, e.initialAccumulatorValue);
    }, o.className = "Adagrad", o;
}(xd);
cd(wd);
var Cd = function(t) {
    function o(e, n, r, o) {
        void 0 === o && (o = null);
        var a = t.call(this) || this;
        return a.learningRate = e, a.beta1 = n, a.beta2 = r, a.epsilon = o, a.accumulatedFirstMoment = [], a.accumulatedSecondMoment = [], Ze(function() {
            a.accBeta1 = On(n).variable(), a.accBeta2 = On(r).variable();
        }), null == o && (a.epsilon = Lt.backend.epsilon()), a;
    }
    return e(o, t), o.prototype.applyGradients = function(t) {
        var e = this, n = Array.isArray(t) ? t.map(function(t) {
            return t.name;
        }) : Object.keys(t);
        Ze(function() {
            var r = Cc(1, e.accBeta1), o = Cc(1, e.accBeta2);
            n.forEach(function(n, a) {
                var i = Lt.registeredVariables[n];
                null == e.accumulatedFirstMoment[a] && (e.accumulatedFirstMoment[a] = {
                    originalName: n + "/m",
                    variable: Ze(function() {
                        return Xn(i).variable(!1);
                    })
                }), null == e.accumulatedSecondMoment[a] && (e.accumulatedSecondMoment[a] = {
                    originalName: n + "/v",
                    variable: Ze(function() {
                        return Xn(i).variable(!1);
                    })
                });
                var s = Array.isArray(t) ? t[a].tensor : t[n];
                if (null != s) {
                    var u = e.accumulatedFirstMoment[a].variable, c = e.accumulatedSecondMoment[a].variable, l = u.mul(e.beta1).add(s.mul(1 - e.beta1)), h = c.mul(e.beta2).add(s.square().mul(1 - e.beta2)), f = l.div(r), d = h.div(o);
                    u.assign(l), c.assign(h);
                    var p = f.div(d.sqrt().add(e.epsilon)).mul(-e.learningRate).add(i);
                    i.assign(p);
                }
            }), e.accBeta1.assign(e.accBeta1.mul(e.beta1)), e.accBeta2.assign(e.accBeta2.mul(e.beta2));
        }), this.incrementIterations();
    }, o.prototype.dispose = function() {
        this.accBeta1.dispose(), this.accBeta2.dispose(), null != this.accumulatedFirstMoment && tn(this.accumulatedFirstMoment.map(function(t) {
            return t.variable;
        })), null != this.accumulatedSecondMoment && tn(this.accumulatedSecondMoment.map(function(t) {
            return t.variable;
        }));
    }, o.prototype.getWeights = function() {
        return n(this, void 0, void 0, function() {
            var t;
            return r(this, function(e) {
                switch(e.label){
                    case 0:
                        return t = this.accumulatedFirstMoment.concat(this.accumulatedSecondMoment), [
                            4,
                            this.saveIterations()
                        ];
                    case 1:
                        return [
                            2,
                            [
                                e.sent()
                            ].concat(t.map(function(t) {
                                return {
                                    name: t.originalName,
                                    tensor: t.variable
                                };
                            }))
                        ];
                }
            });
        });
    }, o.prototype.setWeights = function(t) {
        return n(this, void 0, void 0, function() {
            var e, n = this;
            return r(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.extractIterations(t)
                        ];
                    case 1:
                        return t = r.sent(), Ze(function() {
                            n.accBeta1.assign(xc(n.beta1, n.iterations_ + 1)), n.accBeta2.assign(xc(n.beta2, n.iterations_ + 1));
                        }), e = t.length / 2, this.accumulatedFirstMoment = t.slice(0, e).map(function(t) {
                            return {
                                originalName: t.name,
                                variable: t.tensor.variable(!1)
                            };
                        }), this.accumulatedSecondMoment = t.slice(e, 2 * e).map(function(t) {
                            return {
                                originalName: t.name,
                                variable: t.tensor.variable(!1)
                            };
                        }), [
                            2
                        ];
                }
            });
        });
    }, o.prototype.getConfig = function() {
        return {
            learningRate: this.learningRate,
            beta1: this.beta1,
            beta2: this.beta2,
            epsilon: this.epsilon
        };
    }, o.fromConfig = function(t, e) {
        return new t(e.learningRate, e.beta1, e.beta2, e.epsilon);
    }, o.className = "Adam", o;
}(xd);
cd(Cd);
var Ed = function(t) {
    function o(e, n, r, o, a) {
        void 0 === o && (o = null), void 0 === a && (a = 0);
        var i = t.call(this) || this;
        return i.learningRate = e, i.beta1 = n, i.beta2 = r, i.epsilon = o, i.decay = a, i.accumulatedFirstMoment = [], i.accumulatedWeightedInfNorm = [], Ze(function() {
            i.iteration = On(0).variable(), i.accBeta1 = On(n).variable();
        }), null == o && (i.epsilon = Lt.backend.epsilon()), i;
    }
    return e(o, t), o.prototype.applyGradients = function(t) {
        var e = this, n = Array.isArray(t) ? t.map(function(t) {
            return t.name;
        }) : Object.keys(t);
        Ze(function() {
            var r = Cc(1, e.accBeta1), o = sc(-e.learningRate, e.iteration.mul(e.decay).add(1));
            n.forEach(function(n, a) {
                var i = Lt.registeredVariables[n];
                null == e.accumulatedFirstMoment[a] && (e.accumulatedFirstMoment[a] = {
                    originalName: n + "/m",
                    variable: Xn(i).variable(!1)
                }), null == e.accumulatedWeightedInfNorm[a] && (e.accumulatedWeightedInfNorm[a] = {
                    originalName: n + "/v",
                    variable: Xn(i).variable(!1)
                });
                var s = Array.isArray(t) ? t[a].tensor : t[n];
                if (null != s) {
                    var u = e.accumulatedFirstMoment[a].variable, c = e.accumulatedWeightedInfNorm[a].variable, l = u.mul(e.beta1).add(s.mul(1 - e.beta1)), h = c.mul(e.beta2), f = s.abs(), d = h.maximum(f);
                    u.assign(l), c.assign(d);
                    var p = o.div(r).mul(l.div(d.add(e.epsilon))).add(i);
                    i.assign(p);
                }
            }), e.iteration.assign(e.iteration.add(1)), e.accBeta1.assign(e.accBeta1.mul(e.beta1));
        }), this.incrementIterations();
    }, o.prototype.dispose = function() {
        this.accBeta1.dispose(), this.iteration.dispose(), null != this.accumulatedFirstMoment && tn(this.accumulatedFirstMoment.map(function(t) {
            return t.variable;
        })), null != this.accumulatedWeightedInfNorm && tn(this.accumulatedWeightedInfNorm.map(function(t) {
            return t.variable;
        }));
    }, o.prototype.getWeights = function() {
        return n(this, void 0, void 0, function() {
            return r(this, function(t) {
                throw new Error("getWeights() is not implemented for Adamax yet.");
            });
        });
    }, o.prototype.setWeights = function(t) {
        return n(this, void 0, void 0, function() {
            return r(this, function(t) {
                throw new Error("setWeights() is not implemented for Adamax yet.");
            });
        });
    }, o.prototype.getConfig = function() {
        return {
            learningRate: this.learningRate,
            beta1: this.beta1,
            beta2: this.beta2,
            epsilon: this.epsilon,
            decay: this.decay
        };
    }, o.fromConfig = function(t, e) {
        return new t(e.learningRate, e.beta1, e.beta2, e.epsilon, e.decay);
    }, o.className = "Adamax", o;
}(xd);
cd(Ed);
var Rd = function(t) {
    function o(e) {
        var n = t.call(this) || this;
        return n.learningRate = e, n.setLearningRate(e), n;
    }
    return e(o, t), o.prototype.applyGradients = function(t) {
        var e = this;
        (Array.isArray(t) ? t.map(function(t) {
            return t.name;
        }) : Object.keys(t)).forEach(function(n, r) {
            var o = Array.isArray(t) ? t[r].tensor : t[n];
            if (null != o) {
                var a = Lt.registeredVariables[n];
                Ze(function() {
                    var t = e.c.mul(o).add(a);
                    a.assign(t);
                });
            }
        }), this.incrementIterations();
    }, o.prototype.setLearningRate = function(t) {
        this.learningRate = t, null != this.c && this.c.dispose(), this.c = en(On(-t));
    }, o.prototype.dispose = function() {
        this.c.dispose();
    }, o.prototype.getWeights = function() {
        return n(this, void 0, void 0, function() {
            return r(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.saveIterations()
                        ];
                    case 1:
                        return [
                            2,
                            [
                                t.sent()
                            ]
                        ];
                }
            });
        });
    }, o.prototype.setWeights = function(t) {
        return n(this, void 0, void 0, function() {
            return r(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.extractIterations(t)
                        ];
                    case 1:
                        if (0 !== (t = e.sent()).length) throw new Error("SGD optimizer does not have settable weights.");
                        return [
                            2
                        ];
                }
            });
        });
    }, o.prototype.getConfig = function() {
        return {
            learningRate: this.learningRate
        };
    }, o.fromConfig = function(t, e) {
        return new t(e.learningRate);
    }, o.className = "SGD", o;
}(xd);
cd(Rd);
var Id = function(t) {
    function o(e, n, r) {
        void 0 === r && (r = !1);
        var o = t.call(this, e) || this;
        return o.learningRate = e, o.momentum = n, o.useNesterov = r, o.accumulations = [], o.m = On(o.momentum), o;
    }
    return e(o, t), o.prototype.applyGradients = function(t) {
        var e = this;
        (Array.isArray(t) ? t.map(function(t) {
            return t.name;
        }) : Object.keys(t)).forEach(function(n, r) {
            var o = Lt.registeredVariables[n];
            if (null == e.accumulations[r]) e.accumulations[r] = {
                originalName: n + "/momentum",
                variable: Ze(function() {
                    return Xn(o).variable(!1);
                })
            };
            var a = e.accumulations[r].variable, i = Array.isArray(t) ? t[r].tensor : t[n];
            null != i && Ze(function() {
                var t, n = e.m.mul(a).add(i);
                t = e.useNesterov ? e.c.mul(i.add(n.mul(e.m))).add(o) : e.c.mul(n).add(o), a.assign(n), o.assign(t);
            });
        }), this.incrementIterations();
    }, o.prototype.dispose = function() {
        this.m.dispose(), null != this.accumulations && tn(this.accumulations.map(function(t) {
            return t.variable;
        }));
    }, o.prototype.setMomentum = function(t) {
        this.momentum = t;
    }, o.prototype.getWeights = function() {
        return n(this, void 0, void 0, function() {
            return r(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.saveIterations()
                        ];
                    case 1:
                        return [
                            2,
                            [
                                t.sent()
                            ].concat(this.accumulations.map(function(t) {
                                return {
                                    name: t.originalName,
                                    tensor: t.variable
                                };
                            }))
                        ];
                }
            });
        });
    }, o.prototype.setWeights = function(t) {
        return n(this, void 0, void 0, function() {
            return r(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.extractIterations(t)
                        ];
                    case 1:
                        return t = e.sent(), this.accumulations = t.map(function(t) {
                            return {
                                originalName: t.name,
                                variable: t.tensor.variable(!1)
                            };
                        }), [
                            2
                        ];
                }
            });
        });
    }, o.prototype.getConfig = function() {
        return {
            learningRate: this.learningRate,
            momentum: this.momentum,
            useNesterov: this.useNesterov
        };
    }, o.fromConfig = function(t, e) {
        return new t(e.learningRate, e.momentum, e.useNesterov);
    }, o.className = "Momentum", o;
}(Rd);
cd(Id);
var kd = function(t) {
    function o(e, n, r, o, a) {
        void 0 === n && (n = .9), void 0 === r && (r = 0), void 0 === o && (o = null), void 0 === a && (a = !1);
        var i = t.call(this) || this;
        if (i.learningRate = e, i.decay = n, i.momentum = r, i.epsilon = o, i.accumulatedMeanSquares = [], i.accumulatedMoments = [], i.accumulatedMeanGrads = [], i.centered = a, null == o && (i.epsilon = Lt.backend.epsilon()), null == e) throw new Error("learningRate for RMSPropOptimizer must be defined.");
        return i;
    }
    return e(o, t), o.prototype.applyGradients = function(t) {
        var e = this;
        (Array.isArray(t) ? t.map(function(t) {
            return t.name;
        }) : Object.keys(t)).forEach(function(n, r) {
            var o = Lt.registeredVariables[n];
            null == e.accumulatedMeanSquares[r] && (e.accumulatedMeanSquares[r] = {
                originalName: n + "/rms",
                variable: Ze(function() {
                    return Xn(o).variable(!1);
                })
            }), null == e.accumulatedMoments[r] && (e.accumulatedMoments[r] = {
                originalName: n + "/momentum",
                variable: Ze(function() {
                    return Xn(o).variable(!1);
                })
            }), null == e.accumulatedMeanGrads[r] && e.centered && (e.accumulatedMeanGrads[r] = {
                originalName: n + "/mg",
                variable: Ze(function() {
                    return Xn(o).variable(!1);
                })
            });
            var a = Array.isArray(t) ? t[r].tensor : t[n];
            if (null != a) {
                var i = e.accumulatedMeanSquares[r].variable, s = e.accumulatedMoments[r].variable;
                Ze(function() {
                    var t = i.mul(e.decay).add(a.square().mul(1 - e.decay));
                    if (e.centered) {
                        var n = e.accumulatedMeanGrads[r].variable, u = n.mul(e.decay).add(a.mul(1 - e.decay)), c = s.mul(e.momentum).add(a.mul(e.learningRate).div(t.sub(u.square().add(e.epsilon)).sqrt()));
                        i.assign(t), n.assign(u), s.assign(c);
                        var l = o.sub(c);
                        o.assign(l);
                    } else {
                        var h = i.mul(e.decay).add(a.square().mul(1 - e.decay));
                        c = s.mul(e.momentum).add(a.mul(e.learningRate).div(h.add(e.epsilon).sqrt()));
                        i.assign(h), s.assign(c);
                        l = o.sub(c);
                        o.assign(l);
                    }
                });
            }
        }), this.incrementIterations();
    }, o.prototype.dispose = function() {
        null != this.accumulatedMeanSquares && tn(this.accumulatedMeanSquares.map(function(t) {
            return t.variable;
        })), null != this.accumulatedMeanGrads && this.centered && tn(this.accumulatedMeanGrads.map(function(t) {
            return t.variable;
        })), null != this.accumulatedMoments && tn(this.accumulatedMoments.map(function(t) {
            return t.variable;
        }));
    }, o.prototype.getWeights = function() {
        return n(this, void 0, void 0, function() {
            var t;
            return r(this, function(e) {
                switch(e.label){
                    case 0:
                        return t = this.accumulatedMeanSquares.concat(this.accumulatedMoments), this.centered && t.push.apply(t, this.accumulatedMeanGrads), [
                            4,
                            this.saveIterations()
                        ];
                    case 1:
                        return [
                            2,
                            [
                                e.sent()
                            ].concat(t.map(function(t) {
                                return {
                                    name: t.originalName,
                                    tensor: t.variable
                                };
                            }))
                        ];
                }
            });
        });
    }, o.prototype.setWeights = function(t) {
        return n(this, void 0, void 0, function() {
            var e;
            return r(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.extractIterations(t)
                        ];
                    case 1:
                        return t = n.sent(), e = this.centered ? t.length / 3 : t.length / 2, this.accumulatedMeanSquares = t.slice(0, e).map(function(t) {
                            return {
                                originalName: t.name,
                                variable: t.tensor.variable(!1)
                            };
                        }), this.accumulatedMoments = t.slice(e, 2 * e).map(function(t) {
                            return {
                                originalName: t.name,
                                variable: t.tensor.variable(!1)
                            };
                        }), this.centered && (this.accumulatedMeanGrads = t.slice(2 * e, 3 * e).map(function(t) {
                            return {
                                originalName: t.name,
                                variable: t.tensor.variable(!1)
                            };
                        })), [
                            2
                        ];
                }
            });
        });
    }, o.prototype.getConfig = function() {
        return {
            learningRate: this.learningRate,
            decay: this.decay,
            momentum: this.momentum,
            epsilon: this.epsilon,
            centered: this.centered
        };
    }, o.fromConfig = function(t, e) {
        return new t(e.learningRate, e.decay, e.momentum, e.epsilon, e.centered);
    }, o.className = "RMSProp", o;
}(xd);
cd(kd);
var Sd = function() {
    function t() {}
    return t.sgd = function(t) {
        return new Rd(t);
    }, t.momentum = function(t, e, n) {
        return void 0 === n && (n = !1), new Id(t, e, n);
    }, t.rmsprop = function(t, e, n, r, o) {
        return void 0 === e && (e = .9), void 0 === n && (n = 0), void 0 === r && (r = null), void 0 === o && (o = !1), new kd(t, e, n, r, o);
    }, t.adam = function(t, e, n, r) {
        return void 0 === t && (t = .001), void 0 === e && (e = .9), void 0 === n && (n = .999), void 0 === r && (r = null), new Cd(t, e, n, r);
    }, t.adadelta = function(t, e, n) {
        return void 0 === t && (t = .001), void 0 === e && (e = .95), void 0 === n && (n = null), new bd(t, e, n);
    }, t.adamax = function(t, e, n, r, o) {
        return void 0 === t && (t = .002), void 0 === e && (e = .9), void 0 === n && (n = .999), void 0 === r && (r = null), void 0 === o && (o = 0), new Ed(t, e, n, r, o);
    }, t.adagrad = function(t, e) {
        return void 0 === e && (e = .1), new wd(t, e);
    }, t;
}(), Ad = {
    sgd: Sd.sgd,
    momentum: Sd.momentum,
    adadelta: Sd.adadelta,
    adagrad: Sd.adagrad,
    rmsprop: Sd.rmsprop,
    adamax: Sd.adamax,
    adam: Sd.adam
}, Dd = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : "undefined" != typeof setImmediate ? setImmediate : function(t) {
    return t();
};
function Td() {
    return new Promise(function(t) {
        return Dd(function() {
            return t();
        });
    });
}
wt.prototype.squaredDifference = function(t) {
    return nu(this, t);
}, xt = Gh;

});

var $7476e21157772a88$exports = {};
"use strict";

$7476e21157772a88$exports = (parcelRequire("8f2hE"));


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e220b74bfca43248$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $9f77e1e9786bb6f1$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $9f77e1e9786bb6f1$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $9f77e1e9786bb6f1$var$isGlobalObj(window) || typeof self == "object" && $9f77e1e9786bb6f1$var$isGlobalObj(self) || typeof $parcel$global == "object" && $9f77e1e9786bb6f1$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $9f77e1e9786bb6f1$export$256479dc0cea61c4() {
    return $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $9f77e1e9786bb6f1$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}


/** Prefix for logging strings */ const $b41a73a19cf590b7$var$PREFIX = "Sentry Logger ";
const $b41a73a19cf590b7$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $b41a73a19cf590b7$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $b41a73a19cf590b7$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($b41a73a19cf590b7$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $b41a73a19cf590b7$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $b41a73a19cf590b7$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $e220b74bfca43248$export$16a28057038b10ef) $b41a73a19cf590b7$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $b41a73a19cf590b7$export$cda52e2a8927a2ca(()=>{
                (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).console[name](`${$b41a73a19cf590b7$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $b41a73a19cf590b7$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $b41a73a19cf590b7$export$af88d00dbe7f521 = $b41a73a19cf590b7$var$makeLogger();


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6e4b0bb231b9da18$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $9394cb5a9147bec2$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $9394cb5a9147bec2$export$7740643b9eeaf0c4() {
    return Date.now() / $9394cb5a9147bec2$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $9394cb5a9147bec2$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $9394cb5a9147bec2$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $9394cb5a9147bec2$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $9394cb5a9147bec2$export$ee52dced521e3e18 = $9394cb5a9147bec2$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $9394cb5a9147bec2$export$c5907b5a8838db13 = $9394cb5a9147bec2$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $9394cb5a9147bec2$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $9394cb5a9147bec2$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $9394cb5a9147bec2$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $9394cb5a9147bec2$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $9394cb5a9147bec2$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $9394cb5a9147bec2$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

// eslint-disable-next-line @typescript-eslint/unbound-method
const $3bf951bd5aad5f95$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$e6127cc7fe7395c3(wat) {
    switch($3bf951bd5aad5f95$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $3bf951bd5aad5f95$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$var$isBuiltin(wat, className) {
    return $3bf951bd5aad5f95$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$9f9636d330b71954(wat) {
    return $3bf951bd5aad5f95$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$ef9e2056653f0c8e(wat) {
    return $3bf951bd5aad5f95$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$12e869b2a583f783(wat) {
    return $3bf951bd5aad5f95$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$844ec244b1367d54(wat) {
    return $3bf951bd5aad5f95$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$c3825b437cbdea5c(wat) {
    return wat === null || $3bf951bd5aad5f95$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$53b83ca8eaab0383(wat) {
    return $3bf951bd5aad5f95$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $3bf951bd5aad5f95$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $3bf951bd5aad5f95$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$49841c62b9eff15(wat) {
    return $3bf951bd5aad5f95$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $3bf951bd5aad5f95$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$bc2894c7158efbac(wat) {
    return $3bf951bd5aad5f95$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $3bf951bd5aad5f95$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



// eslint-disable-next-line deprecation/deprecation
const $61a396c4768b6eee$var$WINDOW = (0, $9f77e1e9786bb6f1$export$256479dc0cea61c4)();
const $61a396c4768b6eee$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $61a396c4768b6eee$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $61a396c4768b6eee$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $61a396c4768b6eee$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $61a396c4768b6eee$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($61a396c4768b6eee$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $3bf951bd5aad5f95$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $61a396c4768b6eee$export$1cfafeee2987818b() {
    try {
        return $61a396c4768b6eee$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $61a396c4768b6eee$export$c660c1f3ab49225c(selector) {
    if ($61a396c4768b6eee$var$WINDOW.document && $61a396c4768b6eee$var$WINDOW.document.querySelector) return $61a396c4768b6eee$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $61a396c4768b6eee$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$61a396c4768b6eee$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $7c3b646f45fbc7a6$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $7c3b646f45fbc7a6$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7c3b646f45fbc7a6$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $3bf951bd5aad5f95$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $7c3b646f45fbc7a6$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $3bf951bd5aad5f95$export$844ec244b1367d54)(value)) return false;
    if ((0, $3bf951bd5aad5f95$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $3bf951bd5aad5f95$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $7c3b646f45fbc7a6$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$7c3b646f45fbc7a6$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $a607c0e596f98f0e$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $a607c0e596f98f0e$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $a607c0e596f98f0e$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $e220b74bfca43248$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $a607c0e596f98f0e$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $a607c0e596f98f0e$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $a607c0e596f98f0e$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $a607c0e596f98f0e$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $a607c0e596f98f0e$export$62ff257738bf57f5(value) {
    if ((0, $3bf951bd5aad5f95$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$a607c0e596f98f0e$var$getOwnProperties(value)
    };
    else if ((0, $3bf951bd5aad5f95$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $a607c0e596f98f0e$var$serializeEventTarget(value.target),
            currentTarget: $a607c0e596f98f0e$var$serializeEventTarget(value.currentTarget),
            ...$a607c0e596f98f0e$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $3bf951bd5aad5f95$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $a607c0e596f98f0e$var$serializeEventTarget(target) {
    try {
        return (0, $3bf951bd5aad5f95$export$45a5e7f76e0caa8d)(target) ? (0, $61a396c4768b6eee$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $a607c0e596f98f0e$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $a607c0e596f98f0e$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($a607c0e596f98f0e$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $7c3b646f45fbc7a6$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $7c3b646f45fbc7a6$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $a607c0e596f98f0e$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $a607c0e596f98f0e$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $a607c0e596f98f0e$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($a607c0e596f98f0e$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $a607c0e596f98f0e$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($a607c0e596f98f0e$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $a607c0e596f98f0e$var$isPojo(input) {
    if (!(0, $3bf951bd5aad5f95$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $a607c0e596f98f0e$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $3bf951bd5aad5f95$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $29b59487f55d4d6d$export$19f53698e68b2496() {
    const gbl = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $29b59487f55d4d6d$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $29b59487f55d4d6d$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $29b59487f55d4d6d$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $29b59487f55d4d6d$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $29b59487f55d4d6d$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $29b59487f55d4d6d$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $29b59487f55d4d6d$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $29b59487f55d4d6d$export$d364f2020ab30578(input) {
    const match = input.match($29b59487f55d4d6d$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $29b59487f55d4d6d$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $7c3b646f45fbc7a6$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $7c3b646f45fbc7a6$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $7c3b646f45fbc7a6$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $29b59487f55d4d6d$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $a607c0e596f98f0e$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $29b59487f55d4d6d$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $239550e5bfa4cdaf$export$849dbeeeda01ae98 = "production";





/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $7ae781ad592dc19e$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($7ae781ad592dc19e$var$States || ($7ae781ad592dc19e$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $7ae781ad592dc19e$export$1fda8aa4d135f8aa(value) {
    return new $7ae781ad592dc19e$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $7ae781ad592dc19e$export$78e43115b553f358(reason) {
    return new $7ae781ad592dc19e$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $7ae781ad592dc19e$export$6f292d4960313241 {
    constructor(executor){
        $7ae781ad592dc19e$export$6f292d4960313241.prototype.__init.call(this);
        $7ae781ad592dc19e$export$6f292d4960313241.prototype.__init2.call(this);
        $7ae781ad592dc19e$export$6f292d4960313241.prototype.__init3.call(this);
        $7ae781ad592dc19e$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $7ae781ad592dc19e$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $7ae781ad592dc19e$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $7ae781ad592dc19e$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($7ae781ad592dc19e$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($7ae781ad592dc19e$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $7ae781ad592dc19e$var$States.PENDING) return;
            if ((0, $3bf951bd5aad5f95$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $7ae781ad592dc19e$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $7ae781ad592dc19e$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $7ae781ad592dc19e$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $57f9a4f4cc6ad6aa$export$3c4238858b85e8ac() {
    return (0, $9f77e1e9786bb6f1$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $57f9a4f4cc6ad6aa$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $57f9a4f4cc6ad6aa$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $57f9a4f4cc6ad6aa$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $7ae781ad592dc19e$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && processor.id && result === null && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $3bf951bd5aad5f95$export$f5b060c2914b97c8)(result)) result.then((final)=>$57f9a4f4cc6ad6aa$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $57f9a4f4cc6ad6aa$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $1087116ededa03fe$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $9394cb5a9147bec2$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $29b59487f55d4d6d$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$1087116ededa03fe$var$sessionToJSON(session)
    };
    if (context) $1087116ededa03fe$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $1087116ededa03fe$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $9394cb5a9147bec2$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $29b59487f55d4d6d$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $1087116ededa03fe$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $1087116ededa03fe$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $1087116ededa03fe$var$sessionToJSON(session) {
    return (0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}











/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $3a675c46791ec8bf$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $99ae90780097d0d9$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $99ae90780097d0d9$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $99ae90780097d0d9$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $886040b9c3125f7f$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $886040b9c3125f7f$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $886040b9c3125f7f$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $886040b9c3125f7f$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $886040b9c3125f7f$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($886040b9c3125f7f$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $886040b9c3125f7f$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $886040b9c3125f7f$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $886040b9c3125f7f$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $886040b9c3125f7f$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $886040b9c3125f7f$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($886040b9c3125f7f$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($886040b9c3125f7f$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $886040b9c3125f7f$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $886040b9c3125f7f$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $886040b9c3125f7f$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $886040b9c3125f7f$var$defaultFunctionName;
        return fn.name || $886040b9c3125f7f$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $886040b9c3125f7f$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $886040b9c3125f7f$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $99ae90780097d0d9$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $22dd55058e9e130a$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $22dd55058e9e130a$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $22dd55058e9e130a$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $22dd55058e9e130a$export$a3295358bff77e(object, depth);
    if ($22dd55058e9e130a$var$jsonSize(normalized) > maxSize) return $22dd55058e9e130a$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $22dd55058e9e130a$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $3a675c46791ec8bf$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $3bf951bd5aad5f95$export$c9f5652083b8129d)(value)) return value;
    const stringified = $22dd55058e9e130a$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $22dd55058e9e130a$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $a607c0e596f98f0e$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $22dd55058e9e130a$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $22dd55058e9e130a$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $3bf951bd5aad5f95$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $3bf951bd5aad5f95$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $886040b9c3125f7f$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $22dd55058e9e130a$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $22dd55058e9e130a$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $22dd55058e9e130a$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $22dd55058e9e130a$var$jsonSize(value) {
    return $22dd55058e9e130a$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $22dd55058e9e130a$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}









const $8044f95bb562571d$export$9ca9946bd449ac06 = "baggage";
const $8044f95bb562571d$export$6e69537d67fa20f = "sentry-";
const $8044f95bb562571d$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $8044f95bb562571d$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $8044f95bb562571d$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $3bf951bd5aad5f95$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $8044f95bb562571d$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $8044f95bb562571d$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($8044f95bb562571d$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($8044f95bb562571d$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $8044f95bb562571d$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$8044f95bb562571d$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $8044f95bb562571d$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $8044f95bb562571d$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $8044f95bb562571d$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $8044f95bb562571d$export$bdd844ddb2def819) {
            (0, $e220b74bfca43248$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $bc4f744a1969ef3e$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $bc4f744a1969ef3e$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($bc4f744a1969ef3e$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $bc4f744a1969ef3e$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $bc4f744a1969ef3e$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $8044f95bb562571d$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $29b59487f55d4d6d$export$19f53698e68b2496)(),
            spanId: (0, $29b59487f55d4d6d$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $29b59487f55d4d6d$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $29b59487f55d4d6d$export$19f53698e68b2496)().substring(16),
            spanId: (0, $29b59487f55d4d6d$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $bc4f744a1969ef3e$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $bc4f744a1969ef3e$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $8044f95bb562571d$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $29b59487f55d4d6d$export$19f53698e68b2496)(),
        spanId: (0, $29b59487f55d4d6d$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $29b59487f55d4d6d$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $29b59487f55d4d6d$export$19f53698e68b2496)().substring(16),
        spanId: (0, $29b59487f55d4d6d$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $bc4f744a1969ef3e$export$f35d907436da45cf(traceId = (0, $29b59487f55d4d6d$export$19f53698e68b2496)(), spanId = (0, $29b59487f55d4d6d$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $671479e013e13387$export$208d5b368507fb8b = 0x0;
const $671479e013e13387$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $671479e013e13387$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $671479e013e13387$export$92d8c23565496537(span);
    return (0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $671479e013e13387$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $671479e013e13387$export$5caecac1caaf3a71(span);
    return (0, $bc4f744a1969ef3e$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $671479e013e13387$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $671479e013e13387$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $671479e013e13387$var$ensureTimestampInSeconds(input.getTime());
    return (0, $9394cb5a9147bec2$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $671479e013e13387$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $671479e013e13387$export$92d8c23565496537(span) {
    if ($671479e013e13387$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $671479e013e13387$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $671479e013e13387$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $671479e013e13387$export$eb571cd9b5d98de8);
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $396e448d0bac3ce2$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $29b59487f55d4d6d$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $9394cb5a9147bec2$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $396e448d0bac3ce2$var$applyClientOptions(prepared, options);
    $396e448d0bac3ce2$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $396e448d0bac3ce2$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $396e448d0bac3ce2$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $29b59487f55d4d6d$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $87c509af48029df6$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $7e62f078ea95fd11$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $7e62f078ea95fd11$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $7e62f078ea95fd11$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $57f9a4f4cc6ad6aa$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $57f9a4f4cc6ad6aa$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $396e448d0bac3ce2$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $396e448d0bac3ce2$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $396e448d0bac3ce2$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $239550e5bfa4cdaf$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $7c3b646f45fbc7a6$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $7c3b646f45fbc7a6$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $7c3b646f45fbc7a6$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $396e448d0bac3ce2$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $396e448d0bac3ce2$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $396e448d0bac3ce2$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $396e448d0bac3ce2$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $396e448d0bac3ce2$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $396e448d0bac3ce2$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $396e448d0bac3ce2$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $22dd55058e9e130a$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $22dd55058e9e130a$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $22dd55058e9e130a$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $22dd55058e9e130a$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $22dd55058e9e130a$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $671479e013e13387$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $22dd55058e9e130a$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $396e448d0bac3ce2$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $87c509af48029df6$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $396e448d0bac3ce2$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($396e448d0bac3ce2$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($396e448d0bac3ce2$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $396e448d0bac3ce2$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $87c509af48029df6$export$775b6bb06e53a214) || typeof hint === "function";
}
const $396e448d0bac3ce2$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $396e448d0bac3ce2$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$396e448d0bac3ce2$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $3db6b415fb112a98$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().captureException(exception, (0, $396e448d0bac3ce2$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $3db6b415fb112a98$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $3db6b415fb112a98$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $3db6b415fb112a98$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $3db6b415fb112a98$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $3db6b415fb112a98$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $3db6b415fb112a98$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $3db6b415fb112a98$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $3db6b415fb112a98$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $3db6b415fb112a98$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $3db6b415fb112a98$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $3db6b415fb112a98$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $3db6b415fb112a98$export$9a4fed82c350c2bd(callback) {
    return (0, $81a5bf896f2147fb$export$70d775fb1f267027)(()=>{
        return callback((0, $81a5bf896f2147fb$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $3db6b415fb112a98$export$e57ac09b143d92a2(span, callback) {
    return $3db6b415fb112a98$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $3db6b415fb112a98$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $3db6b415fb112a98$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $3db6b415fb112a98$export$c7be4b0125a10cba();
    const client = $3db6b415fb112a98$export$6bb76d6eba7e258c();
    if (!client) (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $29b59487f55d4d6d$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $3db6b415fb112a98$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $3db6b415fb112a98$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $9394cb5a9147bec2$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $3db6b415fb112a98$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $9394cb5a9147bec2$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $3bf951bd5aad5f95$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $3db6b415fb112a98$export$4909b86c8034bf73(timeout) {
    const client = $3db6b415fb112a98$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $3db6b415fb112a98$export$8360e631d277ea4d(timeout) {
    const client = $3db6b415fb112a98$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $3db6b415fb112a98$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $3db6b415fb112a98$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $3db6b415fb112a98$export$3f95c6f800b78024() {
    return !!$3db6b415fb112a98$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $3db6b415fb112a98$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $3db6b415fb112a98$export$c0d84948cecf78d8(context) {
    const client = $3db6b415fb112a98$export$6bb76d6eba7e258c();
    const isolationScope = (0, $81a5bf896f2147fb$export$68f3af03034c9e90)();
    const currentScope = $3db6b415fb112a98$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $239550e5bfa4cdaf$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $1087116ededa03fe$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $1087116ededa03fe$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $3db6b415fb112a98$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $3db6b415fb112a98$export$17a5be43989a0bc1() {
    const isolationScope = (0, $81a5bf896f2147fb$export$68f3af03034c9e90)();
    const currentScope = $3db6b415fb112a98$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $1087116ededa03fe$export$56521d9ba90f62ee)(session);
    $3db6b415fb112a98$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $3db6b415fb112a98$var$_sendSessionUpdate() {
    const isolationScope = (0, $81a5bf896f2147fb$export$68f3af03034c9e90)();
    const currentScope = $3db6b415fb112a98$export$c7be4b0125a10cba();
    const client = $3db6b415fb112a98$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $3db6b415fb112a98$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $3db6b415fb112a98$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $3db6b415fb112a98$var$_sendSessionUpdate();
}


/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $4df687300fc9fd7e$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}



/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $1156abcd48160615$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
        environment: options.environment || (0, $239550e5bfa4cdaf$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $1156abcd48160615$export$a117f995597e25df(span) {
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $1156abcd48160615$export$366bad00d6815eed((0, $671479e013e13387$export$92d8c23565496537)(span).trace_id || "", client, (0, $3db6b415fb112a98$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $4df687300fc9fd7e$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $671479e013e13387$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $671479e013e13387$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $7e62f078ea95fd11$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $7e62f078ea95fd11$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $7e62f078ea95fd11$var$applySpanToEvent(event, span);
    $7e62f078ea95fd11$var$applyFingerprintToEvent(event, fingerprint);
    $7e62f078ea95fd11$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $7e62f078ea95fd11$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $7e62f078ea95fd11$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $7e62f078ea95fd11$export$b1a120a2871faa46(data, "extra", extra);
    $7e62f078ea95fd11$export$b1a120a2871faa46(data, "tags", tags);
    $7e62f078ea95fd11$export$b1a120a2871faa46(data, "user", user);
    $7e62f078ea95fd11$export$b1a120a2871faa46(data, "contexts", contexts);
    $7e62f078ea95fd11$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $7e62f078ea95fd11$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $7e62f078ea95fd11$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $a607c0e596f98f0e$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $a607c0e596f98f0e$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $a607c0e596f98f0e$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $a607c0e596f98f0e$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $7e62f078ea95fd11$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $7e62f078ea95fd11$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $7e62f078ea95fd11$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $671479e013e13387$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $4df687300fc9fd7e$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $1156abcd48160615$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $671479e013e13387$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $7e62f078ea95fd11$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $29b59487f55d4d6d$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $87c509af48029df6$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $87c509af48029df6$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $87c509af48029df6$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $87c509af48029df6$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $87c509af48029df6$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $87c509af48029df6$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $1087116ededa03fe$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $87c509af48029df6$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $3bf951bd5aad5f95$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $87c509af48029df6$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $87c509af48029df6$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $9394cb5a9147bec2$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $7e62f078ea95fd11$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $57f9a4f4cc6ad6aa$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $57f9a4f4cc6ad6aa$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $29b59487f55d4d6d$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $29b59487f55d4d6d$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $29b59487f55d4d6d$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $87c509af48029df6$export$aa55d5ab8e05984f() {
    if (!$87c509af48029df6$var$globalScope) $87c509af48029df6$var$globalScope = new $87c509af48029df6$export$775b6bb06e53a214();
    return $87c509af48029df6$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $87c509af48029df6$export$c83048efd17527d6(scope) {
    $87c509af48029df6$var$globalScope = scope;
}
function $87c509af48029df6$var$generatePropagationContext() {
    return {
        traceId: (0, $29b59487f55d4d6d$export$19f53698e68b2496)(),
        spanId: (0, $29b59487f55d4d6d$export$19f53698e68b2496)().substring(16)
    };
}



const $153615ea3378e6bf$export$31499a9cd224b78c = "7.120.3";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $81a5bf896f2147fb$export$24a86ef7798177e4 = parseFloat((0, $153615ea3378e6bf$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $81a5bf896f2147fb$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $81a5bf896f2147fb$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $81a5bf896f2147fb$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $87c509af48029df6$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $87c509af48029df6$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $3bf951bd5aad5f95$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $29b59487f55d4d6d$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $29b59487f55d4d6d$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $29b59487f55d4d6d$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $81a5bf896f2147fb$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $9394cb5a9147bec2$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $b41a73a19cf590b7$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $81a5bf896f2147fb$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $81a5bf896f2147fb$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $6e4b0bb231b9da18$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $1087116ededa03fe$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $239550e5bfa4cdaf$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $1087116ededa03fe$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $1087116ededa03fe$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $81a5bf896f2147fb$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $81a5bf896f2147fb$export$19eade501500c6c1() {
    (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a5bf896f2147fb$export$4188a14ad302d1bc(hub) {
    const registry = $81a5bf896f2147fb$export$19eade501500c6c1();
    const oldHub = $81a5bf896f2147fb$export$bfa8a924a84a76b7(registry);
    $81a5bf896f2147fb$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a5bf896f2147fb$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $81a5bf896f2147fb$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $81a5bf896f2147fb$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $81a5bf896f2147fb$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $81a5bf896f2147fb$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $81a5bf896f2147fb$var$getGlobalHub(registry = $81a5bf896f2147fb$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$81a5bf896f2147fb$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $81a5bf896f2147fb$export$bfa8a924a84a76b7(registry).isOlderThan($81a5bf896f2147fb$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $81a5bf896f2147fb$export$849f05434e95d2f2(registry, new $81a5bf896f2147fb$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $81a5bf896f2147fb$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $81a5bf896f2147fb$export$236689a79f5aa020(carrier, parent = $81a5bf896f2147fb$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$81a5bf896f2147fb$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $81a5bf896f2147fb$export$bfa8a924a84a76b7(carrier).isOlderThan($81a5bf896f2147fb$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $81a5bf896f2147fb$export$849f05434e95d2f2(carrier, new $81a5bf896f2147fb$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $81a5bf896f2147fb$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $81a5bf896f2147fb$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $81a5bf896f2147fb$export$70d775fb1f267027(callback, options = {}) {
    const registry = $81a5bf896f2147fb$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $81a5bf896f2147fb$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $81a5bf896f2147fb$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9f77e1e9786bb6f1$export$7e223ec222791509)("hub", ()=>new $81a5bf896f2147fb$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $81a5bf896f2147fb$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}







// We keep the handlers globally
const $f4fa49712c63c05b$var$handlers = {};
const $f4fa49712c63c05b$var$instrumented = {};
/** Add a handler function. */ function $f4fa49712c63c05b$export$a4e09611e30da72e(type, handler) {
    $f4fa49712c63c05b$var$handlers[type] = $f4fa49712c63c05b$var$handlers[type] || [];
    $f4fa49712c63c05b$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f4fa49712c63c05b$export$b17eab759a1cb5fe() {
    Object.keys($f4fa49712c63c05b$var$handlers).forEach((key)=>{
        $f4fa49712c63c05b$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f4fa49712c63c05b$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f4fa49712c63c05b$var$instrumented[type]) {
        instrumentFn();
        $f4fa49712c63c05b$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f4fa49712c63c05b$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f4fa49712c63c05b$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e220b74bfca43248$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $886040b9c3125f7f$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $34acaeea83ea86b2$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $34acaeea83ea86b2$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $f4fa49712c63c05b$export$a4e09611e30da72e)(type, handler);
    (0, $f4fa49712c63c05b$export$e18d6c5462c01368)(type, $34acaeea83ea86b2$var$instrumentError);
}
function $34acaeea83ea86b2$var$instrumentError() {
    $34acaeea83ea86b2$var$_oldOnErrorHandler = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).onerror;
    (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $f4fa49712c63c05b$export$b18c893e424d3127)("error", handlerData);
        if ($34acaeea83ea86b2$var$_oldOnErrorHandler && !$34acaeea83ea86b2$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $34acaeea83ea86b2$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $4ad8b212cefcd10a$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4ad8b212cefcd10a$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $f4fa49712c63c05b$export$a4e09611e30da72e)(type, handler);
    (0, $f4fa49712c63c05b$export$e18d6c5462c01368)(type, $4ad8b212cefcd10a$var$instrumentUnhandledRejection);
}
function $4ad8b212cefcd10a$var$instrumentUnhandledRejection() {
    $4ad8b212cefcd10a$var$_oldOnUnhandledRejectionHandler = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $f4fa49712c63c05b$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($4ad8b212cefcd10a$var$_oldOnUnhandledRejectionHandler && !$4ad8b212cefcd10a$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $4ad8b212cefcd10a$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $172ec3e9266d794c$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $172ec3e9266d794c$export$8e9a29865c0a1226 = (0, $bc4f744a1969ef3e$export$8e9a29865c0a1226);


let $30855a1a762e91d9$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $30855a1a762e91d9$export$637857c1d87b640c() {
    if ($30855a1a762e91d9$var$errorsInstrumented) return;
    $30855a1a762e91d9$var$errorsInstrumented = true;
    (0, $34acaeea83ea86b2$export$55b5c3ba2194f0c6)($30855a1a762e91d9$var$errorCallback);
    (0, $4ad8b212cefcd10a$export$8bf4fc6858821a4e)($30855a1a762e91d9$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $30855a1a762e91d9$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $172ec3e9266d794c$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$30855a1a762e91d9$var$errorCallback.tag = "sentry_tracingErrorCallback";




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $1c43e0d42e0e8f9a$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $1c43e0d42e0e8f9a$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $1c43e0d42e0e8f9a$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $3bf951bd5aad5f95$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $9124dedf66cdeaeb$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $62c81aedcfeed3b4$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)();
    const scope = (0, $3db6b415fb112a98$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $62c81aedcfeed3b4$var$normalizeContext(context);
    const activeSpan = $62c81aedcfeed3b4$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $1c43e0d42e0e8f9a$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $62c81aedcfeed3b4$export$a1bd95187356f372(context, callback) {
    const spanContext = $62c81aedcfeed3b4$var$normalizeContext(context);
    return (0, $81a5bf896f2147fb$export$70d775fb1f267027)(()=>{
        return (0, $3db6b415fb112a98$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $62c81aedcfeed3b4$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $1c43e0d42e0e8f9a$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $671479e013e13387$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $62c81aedcfeed3b4$export$cb9e396e6b90b703 = $62c81aedcfeed3b4$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $62c81aedcfeed3b4$export$c10292ad04b92aea(context, callback) {
    const spanContext = $62c81aedcfeed3b4$var$normalizeContext(context);
    return (0, $81a5bf896f2147fb$export$70d775fb1f267027)(()=>{
        return (0, $3db6b415fb112a98$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $62c81aedcfeed3b4$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $1c43e0d42e0e8f9a$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $671479e013e13387$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $62c81aedcfeed3b4$export$63dbba021a6b4047(context) {
    if (!(0, $9124dedf66cdeaeb$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $62c81aedcfeed3b4$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $62c81aedcfeed3b4$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $3db6b415fb112a98$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $62c81aedcfeed3b4$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $62c81aedcfeed3b4$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $3db6b415fb112a98$export$c7be4b0125a10cba)().getSpan();
}
const $62c81aedcfeed3b4$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $3db6b415fb112a98$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $bc4f744a1969ef3e$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $6e4b0bb231b9da18$export$16a28057038b10ef) && traceparentData) (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $81a5bf896f2147fb$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $62c81aedcfeed3b4$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $9124dedf66cdeaeb$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $81a5bf896f2147fb$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $1156abcd48160615$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $671479e013e13387$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $62c81aedcfeed3b4$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $62c81aedcfeed3b4$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $671479e013e13387$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $62c81aedcfeed3b4$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $62c81aedcfeed3b4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $62c81aedcfeed3b4$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $a607c0e596f98f0e$export$e73679ffaf56810e)(span, $62c81aedcfeed3b4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $a607c0e596f98f0e$export$e73679ffaf56810e)(span, $62c81aedcfeed3b4$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $62c81aedcfeed3b4$export$c08fbc656a245d03(span) {
    return {
        scope: span[$62c81aedcfeed3b4$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$62c81aedcfeed3b4$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $89f1339a53836bdd$var$SPAN_METRIC_SUMMARY;
function $89f1339a53836bdd$var$getMetricStorageForSpan(span) {
    return $89f1339a53836bdd$var$SPAN_METRIC_SUMMARY ? $89f1339a53836bdd$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $89f1339a53836bdd$export$2e7205e45c58797d(span) {
    const storage = $89f1339a53836bdd$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $a607c0e596f98f0e$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $89f1339a53836bdd$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $62c81aedcfeed3b4$export$1be426a8e585c83e)();
    if (span) {
        const storage = $89f1339a53836bdd$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$89f1339a53836bdd$var$SPAN_METRIC_SUMMARY) $89f1339a53836bdd$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $89f1339a53836bdd$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $b64cf2cfbf638e41$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $b64cf2cfbf638e41$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $b64cf2cfbf638e41$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $b64cf2cfbf638e41$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $b64cf2cfbf638e41$export$1efec95406bbe327 = "profile_id";




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $44f3cf13c355753b$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($44f3cf13c355753b$export$beb8e6a823e89c5d || ($44f3cf13c355753b$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $44f3cf13c355753b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $44f3cf13c355753b$export$ac65c70d78fcdb55 = $44f3cf13c355753b$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $44f3cf13c355753b$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $44f3cf13c355753b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $fdc3bf4a3421635a$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $fdc3bf4a3421635a$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $29b59487f55d4d6d$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $29b59487f55d4d6d$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $9394cb5a9147bec2$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $b64cf2cfbf638e41$export$cca8dd30f57f805e)]: spanContext.origin || "manual",
            [(0, $b64cf2cfbf638e41$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $b64cf2cfbf638e41$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $b64cf2cfbf638e41$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $b64cf2cfbf638e41$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $b64cf2cfbf638e41$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $671479e013e13387$export$eb571cd9b5d98de8) : (0, $671479e013e13387$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $fdc3bf4a3421635a$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $4df687300fc9fd7e$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $6e4b0bb231b9da18$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $671479e013e13387$export$92d8c23565496537)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $44f3cf13c355753b$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $4df687300fc9fd7e$export$c4c6a79b1260ca1b)(this);
        if ((0, $6e4b0bb231b9da18$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $671479e013e13387$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $671479e013e13387$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $671479e013e13387$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $b64cf2cfbf638e41$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $b64cf2cfbf638e41$export$cca8dd30f57f805e],
            _metrics_summary: (0, $89f1339a53836bdd$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $b64cf2cfbf638e41$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $11461e6bdf751496$export$febc5573c75cefb0 extends (0, $fdc3bf4a3421635a$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $b64cf2cfbf638e41$export$d7a7d984b0791405] && {
                source: this._attributes[0, $b64cf2cfbf638e41$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $b64cf2cfbf638e41$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $b64cf2cfbf638e41$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $b64cf2cfbf638e41$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $fdc3bf4a3421635a$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $671479e013e13387$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $1156abcd48160615$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $671479e013e13387$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $671479e013e13387$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $62c81aedcfeed3b4$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $671479e013e13387$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $1156abcd48160615$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $89f1339a53836bdd$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $1f9ce71cf3e2f64b$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $1f9ce71cf3e2f64b$var$FINISH_REASON_TAG = "finishReason";
const $1f9ce71cf3e2f64b$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $1f9ce71cf3e2f64b$export$370d6113c18ba86c extends (0, $fdc3bf4a3421635a$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $671479e013e13387$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $1f9ce71cf3e2f64b$export$b279e6bd7040371f extends (0, $11461e6bdf751496$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $1f9ce71cf3e2f64b$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $1f9ce71cf3e2f64b$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $1f9ce71cf3e2f64b$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $1f9ce71cf3e2f64b$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $1f9ce71cf3e2f64b$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $671479e013e13387$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($1f9ce71cf3e2f64b$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $671479e013e13387$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $671479e013e13387$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $6e4b0bb231b9da18$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $1f9ce71cf3e2f64b$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $1f9ce71cf3e2f64b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $1f9ce71cf3e2f64b$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $9394cb5a9147bec2$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $1f9ce71cf3e2f64b$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $1f9ce71cf3e2f64b$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $5d4ff9db4d5f5e54$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $9124dedf66cdeaeb$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $b64cf2cfbf638e41$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $b64cf2cfbf638e41$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $b64cf2cfbf638e41$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $b64cf2cfbf638e41$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$5d4ff9db4d5f5e54$export$2603c8d332a51c42(sampleRate)) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $671479e013e13387$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $5d4ff9db4d5f5e54$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $3bf951bd5aad5f95$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $e52ff8b8565c13ba$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $671479e013e13387$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $e52ff8b8565c13ba$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $11461e6bdf751496$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $5d4ff9db4d5f5e54$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $e52ff8b8565c13ba$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $1f9ce71cf3e2f64b$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $5d4ff9db4d5f5e54$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $e52ff8b8565c13ba$export$653d0ef2bad9cdf9() {
    const carrier = (0, $81a5bf896f2147fb$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $e52ff8b8565c13ba$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $e52ff8b8565c13ba$var$traceHeaders;
    (0, $30855a1a762e91d9$export$637857c1d87b640c)();
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $378a0866582ba15c$var$WINDOW = (0, $9f77e1e9786bb6f1$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $378a0866582ba15c$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $378a0866582ba15c$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $378a0866582ba15c$var$WINDOW && !!$378a0866582ba15c$var$WINDOW.history.pushState && !!$378a0866582ba15c$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $ad8d7abadbaf360a$var$WINDOW = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1);
let $ad8d7abadbaf360a$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ad8d7abadbaf360a$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $f4fa49712c63c05b$export$a4e09611e30da72e)(type, handler);
    (0, $f4fa49712c63c05b$export$e18d6c5462c01368)(type, $ad8d7abadbaf360a$var$instrumentHistory);
}
function $ad8d7abadbaf360a$var$instrumentHistory() {
    if (!(0, $378a0866582ba15c$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $ad8d7abadbaf360a$var$WINDOW.onpopstate;
    $ad8d7abadbaf360a$var$WINDOW.onpopstate = function(...args) {
        const to = $ad8d7abadbaf360a$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $ad8d7abadbaf360a$var$lastHref;
        $ad8d7abadbaf360a$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $f4fa49712c63c05b$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $ad8d7abadbaf360a$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $ad8d7abadbaf360a$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $f4fa49712c63c05b$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $a607c0e596f98f0e$export$9563e054e6f787fb)($ad8d7abadbaf360a$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $a607c0e596f98f0e$export$9563e054e6f787fb)($ad8d7abadbaf360a$var$WINDOW.history, "replaceState", historyReplacementFunction);
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $cdbfb4dff083691a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






const $fc47782e547d1d4c$export$56d8a8a25bd48b81 = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $6e69082dbf18de8f$export$6f18f55521af71a1() {
    if ((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document) (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $172ec3e9266d794c$export$a7feb32fdd923295)();
        if ((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $671479e013e13387$export$92d8c23565496537)(activeTransaction);
            (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $b067c45f2d6a8481$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $25a5f5ca7c2615b2$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $493c146c6925262a$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $493c146c6925262a$export$6431553786c94949 = ()=>{
    if ((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $493c146c6925262a$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eba5bd929f1cb27d$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $493c146c6925262a$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4067390fb1522991$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $493c146c6925262a$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document && (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.prerendering || (0, $eba5bd929f1cb27d$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $25a5f5ca7c2615b2$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $4f9538cff2e8e5ad$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd0c0b13032a2d8e$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $d7f74d20bfdc3f17$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $4067390fb1522991$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $4f9538cff2e8e5ad$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $b067c45f2d6a8481$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $fd0c0b13032a2d8e$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $217d1ee68f9a7bac$var$firstHiddenTime = -1;
const $217d1ee68f9a7bac$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document && (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.visibilityState) $217d1ee68f9a7bac$var$firstHiddenTime = (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $217d1ee68f9a7bac$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $fd0c0b13032a2d8e$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $217d1ee68f9a7bac$var$firstHiddenTime = timeStamp;
    }, true);
};
const $217d1ee68f9a7bac$export$443f86b2c77012c4 = ()=>{
    if ($217d1ee68f9a7bac$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $217d1ee68f9a7bac$var$initHiddenTime();
        $217d1ee68f9a7bac$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $217d1ee68f9a7bac$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $f5d68c0416c3429f$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $217d1ee68f9a7bac$export$443f86b2c77012c4)();
    const metric = (0, $4067390fb1522991$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $4f9538cff2e8e5ad$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $b067c45f2d6a8481$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $fd0c0b13032a2d8e$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $c36b69e2ef656a33$var$interactionCountEstimate = 0;
let $c36b69e2ef656a33$var$minKnownInteractionId = Infinity;
let $c36b69e2ef656a33$var$maxKnownInteractionId = 0;
const $c36b69e2ef656a33$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $c36b69e2ef656a33$var$minKnownInteractionId = Math.min($c36b69e2ef656a33$var$minKnownInteractionId, e.interactionId);
            $c36b69e2ef656a33$var$maxKnownInteractionId = Math.max($c36b69e2ef656a33$var$maxKnownInteractionId, e.interactionId);
            $c36b69e2ef656a33$var$interactionCountEstimate = $c36b69e2ef656a33$var$maxKnownInteractionId ? ($c36b69e2ef656a33$var$maxKnownInteractionId - $c36b69e2ef656a33$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $c36b69e2ef656a33$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $c36b69e2ef656a33$export$8a962f2683a476d1 = ()=>{
    return $c36b69e2ef656a33$var$po ? $c36b69e2ef656a33$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $c36b69e2ef656a33$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $c36b69e2ef656a33$var$po) return;
    $c36b69e2ef656a33$var$po = (0, $4f9538cff2e8e5ad$export$d1203567a167490e)("event", $c36b69e2ef656a33$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $28a866d8237e736f$var$getInteractionCountForNavigation = ()=>{
    return (0, $c36b69e2ef656a33$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $28a866d8237e736f$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $28a866d8237e736f$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $28a866d8237e736f$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $28a866d8237e736f$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $28a866d8237e736f$var$longestInteractionList[$28a866d8237e736f$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $28a866d8237e736f$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $28a866d8237e736f$var$longestInteractionList.length < $28a866d8237e736f$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $28a866d8237e736f$var$longestInteractionMap[interaction.id] = interaction;
            $28a866d8237e736f$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $28a866d8237e736f$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $28a866d8237e736f$var$longestInteractionList.splice($28a866d8237e736f$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $28a866d8237e736f$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $28a866d8237e736f$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($28a866d8237e736f$var$longestInteractionList.length - 1, Math.floor($28a866d8237e736f$var$getInteractionCountForNavigation() / 50));
    return $28a866d8237e736f$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $28a866d8237e736f$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $c36b69e2ef656a33$export$67d90cda6b78a2eb)();
    const metric = (0, $4067390fb1522991$export$3c29b44508a0612b)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $28a866d8237e736f$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$28a866d8237e736f$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $28a866d8237e736f$var$processEntry(entry);
            }
        });
        const inp = $28a866d8237e736f$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $4f9538cff2e8e5ad$export$d1203567a167490e)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $b067c45f2d6a8481$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $fd0c0b13032a2d8e$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $28a866d8237e736f$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7ee364ced4eb379c$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $7ee364ced4eb379c$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $217d1ee68f9a7bac$export$443f86b2c77012c4)();
    const metric = (0, $4067390fb1522991$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $eba5bd929f1cb27d$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $4f9538cff2e8e5ad$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $b067c45f2d6a8481$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$7ee364ced4eb379c$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $7ee364ced4eb379c$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            if ((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $fd0c0b13032a2d8e$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $1b02014631d13df4$var$whenReady = (callback)=>{
    if (!(0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document) return;
    if ((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>$1b02014631d13df4$var$whenReady(callback), true);
    else if ((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$1b02014631d13df4$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $1b02014631d13df4$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $4067390fb1522991$export$3c29b44508a0612b)("TTFB");
    const report = (0, $b067c45f2d6a8481$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $1b02014631d13df4$var$whenReady(()=>{
        const navEntry = (0, $493c146c6925262a$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $eba5bd929f1cb27d$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $31a1d834278e4fc7$var$handlers = {};
const $31a1d834278e4fc7$var$instrumented = {};
let $31a1d834278e4fc7$var$_previousCls;
let $31a1d834278e4fc7$var$_previousFid;
let $31a1d834278e4fc7$var$_previousLcp;
let $31a1d834278e4fc7$var$_previousTtfb;
let $31a1d834278e4fc7$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $31a1d834278e4fc7$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $31a1d834278e4fc7$var$addMetricObserver("cls", callback, $31a1d834278e4fc7$var$instrumentCls, $31a1d834278e4fc7$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $31a1d834278e4fc7$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $31a1d834278e4fc7$var$addMetricObserver("lcp", callback, $31a1d834278e4fc7$var$instrumentLcp, $31a1d834278e4fc7$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $31a1d834278e4fc7$export$699d9529c099a797(callback) {
    return $31a1d834278e4fc7$var$addMetricObserver("ttfb", callback, $31a1d834278e4fc7$var$instrumentTtfb, $31a1d834278e4fc7$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31a1d834278e4fc7$export$2707d7471c0b918f(callback) {
    return $31a1d834278e4fc7$var$addMetricObserver("fid", callback, $31a1d834278e4fc7$var$instrumentFid, $31a1d834278e4fc7$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31a1d834278e4fc7$export$da3b76aa2022cbd7(callback) {
    return $31a1d834278e4fc7$var$addMetricObserver("inp", callback, $31a1d834278e4fc7$var$instrumentInp, $31a1d834278e4fc7$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31a1d834278e4fc7$export$69816c1a049f8db6(type, callback) {
    $31a1d834278e4fc7$var$addHandler(type, callback);
    if (!$31a1d834278e4fc7$var$instrumented[type]) {
        $31a1d834278e4fc7$var$instrumentPerformanceObserver(type);
        $31a1d834278e4fc7$var$instrumented[type] = true;
    }
    return $31a1d834278e4fc7$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $31a1d834278e4fc7$var$triggerHandlers(type, data) {
    const typeHandlers = $31a1d834278e4fc7$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $886040b9c3125f7f$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $31a1d834278e4fc7$var$instrumentCls() {
    return (0, $d7f74d20bfdc3f17$export$a7873055838e5ad8)((metric)=>{
        $31a1d834278e4fc7$var$triggerHandlers("cls", {
            metric: metric
        });
        $31a1d834278e4fc7$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $31a1d834278e4fc7$var$instrumentFid() {
    return (0, $f5d68c0416c3429f$export$39705a25c49af873)((metric)=>{
        $31a1d834278e4fc7$var$triggerHandlers("fid", {
            metric: metric
        });
        $31a1d834278e4fc7$var$_previousFid = metric;
    });
}
function $31a1d834278e4fc7$var$instrumentLcp() {
    return (0, $7ee364ced4eb379c$export$947b1626ab8d5632)((metric)=>{
        $31a1d834278e4fc7$var$triggerHandlers("lcp", {
            metric: metric
        });
        $31a1d834278e4fc7$var$_previousLcp = metric;
    });
}
function $31a1d834278e4fc7$var$instrumentTtfb() {
    return (0, $1b02014631d13df4$export$33a01e6c5f2c7e33)((metric)=>{
        $31a1d834278e4fc7$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $31a1d834278e4fc7$var$_previousTtfb = metric;
    });
}
function $31a1d834278e4fc7$var$instrumentInp() {
    return (0, $28a866d8237e736f$export$7df4b36ecaed99e1)((metric)=>{
        $31a1d834278e4fc7$var$triggerHandlers("inp", {
            metric: metric
        });
        $31a1d834278e4fc7$var$_previousInp = metric;
    });
}
function $31a1d834278e4fc7$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $31a1d834278e4fc7$var$addHandler(type, callback);
    let stopListening;
    if (!$31a1d834278e4fc7$var$instrumented[type]) {
        stopListening = instrumentFn();
        $31a1d834278e4fc7$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $31a1d834278e4fc7$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $31a1d834278e4fc7$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $4f9538cff2e8e5ad$export$d1203567a167490e)(type, (entries)=>{
        $31a1d834278e4fc7$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $31a1d834278e4fc7$var$addHandler(type, handler) {
    $31a1d834278e4fc7$var$handlers[type] = $31a1d834278e4fc7$var$handlers[type] || [];
    $31a1d834278e4fc7$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $31a1d834278e4fc7$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $31a1d834278e4fc7$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}




/** Regular expression used to parse a Dsn. */ const $4905f485f0a9bd0e$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $4905f485f0a9bd0e$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $4905f485f0a9bd0e$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $4905f485f0a9bd0e$export$b892860177f70a30(str) {
    const match = $4905f485f0a9bd0e$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $b41a73a19cf590b7$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $4905f485f0a9bd0e$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $4905f485f0a9bd0e$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $4905f485f0a9bd0e$var$validateDsn(dsn) {
    if (!(0, $e220b74bfca43248$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$4905f485f0a9bd0e$var$isValidProtocol(protocol)) {
        (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $4905f485f0a9bd0e$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $4905f485f0a9bd0e$export$b892860177f70a30(from) : $4905f485f0a9bd0e$var$dsnFromComponents(from);
    if (!components || !$4905f485f0a9bd0e$var$validateDsn(components)) return undefined;
    return components;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $ff4effe96b979cde$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $ff4effe96b979cde$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $ff4effe96b979cde$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $ff4effe96b979cde$export$604a45d95a155e2b(envelope, types) {
    return $ff4effe96b979cde$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $ff4effe96b979cde$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $ff4effe96b979cde$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $ff4effe96b979cde$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $ff4effe96b979cde$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $22dd55058e9e130a$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $ff4effe96b979cde$var$concatBuffers(parts);
}
function $ff4effe96b979cde$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $ff4effe96b979cde$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $ff4effe96b979cde$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $ff4effe96b979cde$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $ff4effe96b979cde$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $ff4effe96b979cde$export$b11169581eeaf237(type) {
    return $ff4effe96b979cde$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $ff4effe96b979cde$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $ff4effe96b979cde$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4905f485f0a9bd0e$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}


/**
 * Create envelope from Span item.
 */ function $5064b06453ee3d2d$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $4905f485f0a9bd0e$export$44d472fbb931a776)(dsn);
    const items = spans.map($5064b06453ee3d2d$var$createSpanItem);
    return (0, $ff4effe96b979cde$export$f93f7f385160c44e)(headers, items);
}
function $5064b06453ee3d2d$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $ab85fee531e065c3$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $172ec3e9266d794c$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2b74f4160aaa03f7$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2b74f4160aaa03f7$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $2b74f4160aaa03f7$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2b74f4160aaa03f7$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}






/**
 * Checks if a given value is a valid measurement value.
 */ function $b2b75bdd2de8e1dc$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $b2b75bdd2de8e1dc$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $013b4661fc951e7b$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $013b4661fc951e7b$var$msToSec(time) {
    return time / 1000;
}
function $013b4661fc951e7b$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81) && (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).addEventListener && (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).performance;
}
let $013b4661fc951e7b$var$_performanceCursor = 0;
let $013b4661fc951e7b$var$_measurements = {};
let $013b4661fc951e7b$var$_lcpEntry;
let $013b4661fc951e7b$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $013b4661fc951e7b$export$7c69f0412d101b88() {
    const performance = $013b4661fc951e7b$var$getBrowserPerformanceAPI();
    if (performance && (0, $9394cb5a9147bec2$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $013b4661fc951e7b$var$_trackFID();
        const clsCallback = $013b4661fc951e7b$var$_trackCLS();
        const lcpCallback = $013b4661fc951e7b$var$_trackLCP();
        const ttfbCallback = $013b4661fc951e7b$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $013b4661fc951e7b$export$f396d19077034ad2() {
    (0, $31a1d834278e4fc7$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $172ec3e9266d794c$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $013b4661fc951e7b$var$msToSec((0, $9394cb5a9147bec2$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $013b4661fc951e7b$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $013b4661fc951e7b$export$e27543e0976315e4() {
    (0, $31a1d834278e4fc7$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $172ec3e9266d794c$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $013b4661fc951e7b$var$msToSec((0, $9394cb5a9147bec2$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $013b4661fc951e7b$var$msToSec(entry.duration);
                const span = {
                    description: (0, $61a396c4768b6eee$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $61a396c4768b6eee$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $013b4661fc951e7b$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $013b4661fc951e7b$var$getBrowserPerformanceAPI();
    if (performance && (0, $9394cb5a9147bec2$export$baf075a948ffc0bf)) {
        const inpCallback = $013b4661fc951e7b$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $013b4661fc951e7b$var$_trackCLS() {
    return (0, $31a1d834278e4fc7$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $013b4661fc951e7b$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $013b4661fc951e7b$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $013b4661fc951e7b$var$_trackLCP() {
    return (0, $31a1d834278e4fc7$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $013b4661fc951e7b$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $013b4661fc951e7b$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $013b4661fc951e7b$var$_trackFID() {
    return (0, $31a1d834278e4fc7$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $013b4661fc951e7b$var$msToSec((0, $9394cb5a9147bec2$export$baf075a948ffc0bf));
        const startTime = $013b4661fc951e7b$var$msToSec(entry.startTime);
        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $013b4661fc951e7b$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $013b4661fc951e7b$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $013b4661fc951e7b$var$_trackTtfb() {
    return (0, $31a1d834278e4fc7$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        $013b4661fc951e7b$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
const $013b4661fc951e7b$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $013b4661fc951e7b$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $31a1d834278e4fc7$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $013b4661fc951e7b$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $013b4661fc951e7b$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $013b4661fc951e7b$var$msToSec((0, $9394cb5a9147bec2$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $013b4661fc951e7b$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $fdc3bf4a3421635a$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $61a396c4768b6eee$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $013b4661fc951e7b$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $5064b06453ee3d2d$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $013b4661fc951e7b$export$5f8fa6b3467a7443(transaction) {
    const performance = $013b4661fc951e7b$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).performance.getEntries || !(0, $9394cb5a9147bec2$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $013b4661fc951e7b$var$msToSec((0, $9394cb5a9147bec2$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $671479e013e13387$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($013b4661fc951e7b$var$_performanceCursor).forEach((entry)=>{
        const startTime = $013b4661fc951e7b$var$msToSec(entry.startTime);
        const duration = $013b4661fc951e7b$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $013b4661fc951e7b$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $013b4661fc951e7b$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $217d1ee68f9a7bac$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $013b4661fc951e7b$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $013b4661fc951e7b$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $013b4661fc951e7b$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $013b4661fc951e7b$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $013b4661fc951e7b$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $013b4661fc951e7b$var$_addTtfbRequestTimeToMeasurements($013b4661fc951e7b$var$_measurements);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$013b4661fc951e7b$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $013b4661fc951e7b$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $013b4661fc951e7b$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $013b4661fc951e7b$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $013b4661fc951e7b$var$_measurements["mark.fid"];
        if (fidMark && $013b4661fc951e7b$var$_measurements["fid"]) {
            // create span for FID
            (0, $b2b75bdd2de8e1dc$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $013b4661fc951e7b$var$msToSec($013b4661fc951e7b$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $013b4661fc951e7b$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $013b4661fc951e7b$var$_measurements)) delete $013b4661fc951e7b$var$_measurements.cls;
        Object.keys($013b4661fc951e7b$var$_measurements).forEach((measurementName)=>{
            (0, $ab85fee531e065c3$export$7cc31b475d33a706)(measurementName, $013b4661fc951e7b$var$_measurements[measurementName].value, $013b4661fc951e7b$var$_measurements[measurementName].unit);
        });
        $013b4661fc951e7b$var$_tagMetricInfo(transaction);
    }
    $013b4661fc951e7b$var$_lcpEntry = undefined;
    $013b4661fc951e7b$var$_clsEntry = undefined;
    $013b4661fc951e7b$var$_measurements = {};
}
/** Create measure related spans */ function $013b4661fc951e7b$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $b2b75bdd2de8e1dc$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $013b4661fc951e7b$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $013b4661fc951e7b$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $013b4661fc951e7b$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $013b4661fc951e7b$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $013b4661fc951e7b$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $013b4661fc951e7b$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $013b4661fc951e7b$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $b2b75bdd2de8e1dc$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $013b4661fc951e7b$var$msToSec(start),
        endTimestamp: timeOrigin + $013b4661fc951e7b$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $013b4661fc951e7b$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $b2b75bdd2de8e1dc$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $013b4661fc951e7b$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $013b4661fc951e7b$var$msToSec(entry.responseEnd)
        });
        (0, $b2b75bdd2de8e1dc$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $013b4661fc951e7b$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $013b4661fc951e7b$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $013b4661fc951e7b$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $2b74f4160aaa03f7$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $013b4661fc951e7b$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $013b4661fc951e7b$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $013b4661fc951e7b$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $b2b75bdd2de8e1dc$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $013b4661fc951e7b$var$_trackNavigator(transaction) {
    const navigator = (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $b2b75bdd2de8e1dc$export$27169ccae1b439e3)(connection.rtt)) $013b4661fc951e7b$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $b2b75bdd2de8e1dc$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $b2b75bdd2de8e1dc$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $013b4661fc951e7b$var$_tagMetricInfo(transaction) {
    if ($013b4661fc951e7b$var$_lcpEntry) {
        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($013b4661fc951e7b$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $61a396c4768b6eee$export$5647df6b7814ac86)($013b4661fc951e7b$var$_lcpEntry.element));
        if ($013b4661fc951e7b$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $013b4661fc951e7b$var$_lcpEntry.id);
        if ($013b4661fc951e7b$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $013b4661fc951e7b$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $013b4661fc951e7b$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($013b4661fc951e7b$var$_clsEntry && $013b4661fc951e7b$var$_clsEntry.sources) {
        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $013b4661fc951e7b$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $61a396c4768b6eee$export$5647df6b7814ac86)(source.node)));
    }
}
function $013b4661fc951e7b$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $013b4661fc951e7b$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $013b4661fc951e7b$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $493c146c6925262a$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Measurements] Adding TTFB Request Time");
        _measurements["ttfb.requestTime"] = {
            value: responseStart - requestStart,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $013b4661fc951e7b$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $9124dedf66cdeaeb$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $5d4ff9db4d5f5e54$export$2603c8d332a51c42)(sampleRate)) {
        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Tracing] Discarding interaction span because of invalid sample rate.");
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}







// eslint-disable-next-line deprecation/deprecation
const $9e723db1e8b7a171$var$WINDOW = (0, $9f77e1e9786bb6f1$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $9e723db1e8b7a171$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $9e723db1e8b7a171$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $9e723db1e8b7a171$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $9e723db1e8b7a171$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $9e723db1e8b7a171$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $9e723db1e8b7a171$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $9e723db1e8b7a171$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$9e723db1e8b7a171$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($9e723db1e8b7a171$export$18cf36ed71d733e7($9e723db1e8b7a171$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $9e723db1e8b7a171$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $9e723db1e8b7a171$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $e220b74bfca43248$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $9e723db1e8b7a171$export$531055a6c684a70a() {
    return "ReportingObserver" in $9e723db1e8b7a171$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $9e723db1e8b7a171$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$9e723db1e8b7a171$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}




/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6f452264ed38498f$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $f4fa49712c63c05b$export$a4e09611e30da72e)(type, handler);
    (0, $f4fa49712c63c05b$export$e18d6c5462c01368)(type, $6f452264ed38498f$var$instrumentFetch);
}
function $6f452264ed38498f$var$instrumentFetch() {
    if (!(0, $9e723db1e8b7a171$export$c82d238e23c40b21)()) return;
    (0, $a607c0e596f98f0e$export$9563e054e6f787fb)((0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $6f452264ed38498f$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $f4fa49712c63c05b$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $f4fa49712c63c05b$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $f4fa49712c63c05b$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $6f452264ed38498f$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $6f452264ed38498f$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($6f452264ed38498f$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $6f452264ed38498f$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $6f452264ed38498f$var$getUrlFromResource(url),
            method: $6f452264ed38498f$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $6f452264ed38498f$var$getUrlFromResource(arg),
        method: $6f452264ed38498f$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $6324c6a4679c00bc$var$WINDOW = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1);
const $6324c6a4679c00bc$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6324c6a4679c00bc$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $f4fa49712c63c05b$export$a4e09611e30da72e)(type, handler);
    (0, $f4fa49712c63c05b$export$e18d6c5462c01368)(type, $6324c6a4679c00bc$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $6324c6a4679c00bc$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$6324c6a4679c00bc$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $a607c0e596f98f0e$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $3bf951bd5aad5f95$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $6324c6a4679c00bc$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$6324c6a4679c00bc$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$6324c6a4679c00bc$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $f4fa49712c63c05b$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $a607c0e596f98f0e$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $a607c0e596f98f0e$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$6324c6a4679c00bc$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $3bf951bd5aad5f95$export$844ec244b1367d54)(header) && (0, $3bf951bd5aad5f95$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $a607c0e596f98f0e$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$6324c6a4679c00bc$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $f4fa49712c63c05b$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $6324c6a4679c00bc$var$parseUrl(url) {
    if ((0, $3bf951bd5aad5f95$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}




/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $681e88b16514e749$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $9124dedf66cdeaeb$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $681e88b16514e749$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $3db6b415fb112a98$export$c7be4b0125a10cba)();
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $681e88b16514e749$var$getFullURL(url);
    const host = fullUrl ? (0, $2b74f4160aaa03f7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $62c81aedcfeed3b4$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $b64cf2cfbf638e41$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $681e88b16514e749$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $681e88b16514e749$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $81a5bf896f2147fb$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $671479e013e13387$export$7e9f8ae9e4a328ab)(span) : (0, $bc4f744a1969ef3e$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $8044f95bb562571d$export$56766feef403f365)(dsc || (span ? (0, $1156abcd48160615$export$a117f995597e25df)(span) : (0, $1156abcd48160615$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $3bf951bd5aad5f95$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $3bf951bd5aad5f95$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $8044f95bb562571d$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $8044f95bb562571d$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $681e88b16514e749$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $681e88b16514e749$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $44f3cf13c355753b$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus("internal_error");
    span.end();
}




/* eslint-disable max-lines */ const $8abcc3d2614c67e5$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $8abcc3d2614c67e5$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $8abcc3d2614c67e5$export$15bd0305d05ad07b,
    tracePropagationTargets: $8abcc3d2614c67e5$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $8abcc3d2614c67e5$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $8abcc3d2614c67e5$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $8abcc3d2614c67e5$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$8abcc3d2614c67e5$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $6f452264ed38498f$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $681e88b16514e749$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $8abcc3d2614c67e5$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $2b74f4160aaa03f7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                "http.url": fullUrl,
                "server.address": host
            });
        }
        if (enableHTTPTimings && createdSpan) $8abcc3d2614c67e5$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $6324c6a4679c00bc$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $8abcc3d2614c67e5$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $8abcc3d2614c67e5$var$addHTTPTimings(createdSpan);
    });
}
function $8abcc3d2614c67e5$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $8abcc3d2614c67e5$var$addHTTPTimings(span) {
    const { url: url } = (0, $671479e013e13387$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $31a1d834278e4fc7$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($8abcc3d2614c67e5$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $8abcc3d2614c67e5$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $8abcc3d2614c67e5$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $8abcc3d2614c67e5$var$getAbsoluteTime(time = 0) {
    return (((0, $9394cb5a9147bec2$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $8abcc3d2614c67e5$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $8abcc3d2614c67e5$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $9394cb5a9147bec2$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $8abcc3d2614c67e5$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $8abcc3d2614c67e5$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $8abcc3d2614c67e5$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $8abcc3d2614c67e5$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $8abcc3d2614c67e5$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $8abcc3d2614c67e5$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $8abcc3d2614c67e5$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $8abcc3d2614c67e5$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $8abcc3d2614c67e5$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $8abcc3d2614c67e5$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $8abcc3d2614c67e5$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $7c3b646f45fbc7a6$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $8abcc3d2614c67e5$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $8abcc3d2614c67e5$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $6324c6a4679c00bc$export$55b6bb1e45c6cf59];
    if (!(0, $9124dedf66cdeaeb$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $44f3cf13c355753b$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $3db6b415fb112a98$export$c7be4b0125a10cba)();
    const isolationScope = (0, $81a5bf896f2147fb$export$68f3af03034c9e90)();
    const fullUrl = $8abcc3d2614c67e5$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $2b74f4160aaa03f7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $62c81aedcfeed3b4$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $b64cf2cfbf638e41$export$cca8dd30f57f805e)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $671479e013e13387$export$7e9f8ae9e4a328ab)(span) : (0, $bc4f744a1969ef3e$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $8044f95bb562571d$export$56766feef403f365)(dsc || (span ? (0, $1156abcd48160615$export$a117f995597e25df)(span) : (0, $1156abcd48160615$export$366bad00d6815eed)(traceId, client, scope)));
        $8abcc3d2614c67e5$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $8abcc3d2614c67e5$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $8044f95bb562571d$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $8abcc3d2614c67e5$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



const $b96e0b3274f71e54$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $b96e0b3274f71e54$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $1f9ce71cf3e2f64b$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $8abcc3d2614c67e5$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $b96e0b3274f71e54$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $cdbfb4dff083691a$export$16a28057038b10ef) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $e52ff8b8565c13ba$export$653d0ef2bad9cdf9)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$b96e0b3274f71e54$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $013b4661fc951e7b$export$7c69f0412d101b88)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $013b4661fc951e7b$export$f17d06681a4744a3)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $013b4661fc951e7b$export$f396d19077034ad2)();
    if (options._experiments.enableInteractions) (0, $013b4661fc951e7b$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $b96e0b3274f71e54$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $b96e0b3274f71e54$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $bc4f744a1969ef3e$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $e52ff8b8565c13ba$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document) {
            (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $013b4661fc951e7b$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $b96e0b3274f71e54$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $cdbfb4dff083691a$export$16a28057038b10ef) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            let activeSpan;
            let startingUrl = (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).location && (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).location.href;
            if (client.on) {
                client.on("startNavigationSpan", (context)=>{
                    if (activeSpan) {
                        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $671479e013e13387$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "navigation",
                        ...context
                    });
                });
                client.on("startPageLoadSpan", (context)=>{
                    if (activeSpan) {
                        (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $671479e013e13387$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "pageload",
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).location) {
                const context = {
                    name: (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $9394cb5a9147bec2$export$baf075a948ffc0bf) ? (0, $9394cb5a9147bec2$export$baf075a948ffc0bf) / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: {
                        [(0, $b64cf2cfbf638e41$export$d7a7d984b0791405)]: "url"
                    }
                };
                $b96e0b3274f71e54$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).location) (0, $ad8d7abadbaf360a$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).location.pathname,
                        origin: "auto.navigation.browser",
                        attributes: {
                            [(0, $b64cf2cfbf638e41$export$d7a7d984b0791405)]: "url"
                        }
                    };
                    $b96e0b3274f71e54$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $6e69082dbf18de8f$export$6f18f55521af71a1)();
            if (_experiments.enableInteractions) $b96e0b3274f71e54$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $b96e0b3274f71e54$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $8abcc3d2614c67e5$export$864489cb3478db3e)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $b96e0b3274f71e54$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startPageLoadSpan", spanOptions);
    const span = (0, $62c81aedcfeed3b4$export$1be426a8e585c83e)();
    const op = span && (0, $671479e013e13387$export$92d8c23565496537)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $b96e0b3274f71e54$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startNavigationSpan", spanOptions);
    const span = (0, $62c81aedcfeed3b4$export$1be426a8e585c83e)();
    const op = span && (0, $671479e013e13387$export$92d8c23565496537)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $b96e0b3274f71e54$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $61a396c4768b6eee$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $b96e0b3274f71e54$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $172ec3e9266d794c$export$a7feb32fdd923295)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $cdbfb4dff083691a$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $fc47782e547d1d4c$export$56d8a8a25bd48b81);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $b64cf2cfbf638e41$export$d7a7d984b0791405)]: latestRoute.context ? $b96e0b3274f71e54$var$getSource(latestRoute.context) : "url"
            }
        };
        inflightInteractionTransaction = (0, $e52ff8b8565c13ba$export$479dbd817e392a4f)(// eslint-disable-next-line deprecation/deprecation
        (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach((type)=>{
        if ((0, $fc47782e547d1d4c$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $b96e0b3274f71e54$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $b96e0b3274f71e54$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $b96e0b3274f71e54$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $172ec3e9266d794c$export$a7feb32fdd923295)();
        const currentScope = (0, $3db6b415fb112a98$export$c7be4b0125a10cba)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($b96e0b3274f71e54$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === "first-input") {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $b96e0b3274f71e54$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $b96e0b3274f71e54$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $31a1d834278e4fc7$export$69816c1a049f8db6)("event", handleEntries);
    (0, $31a1d834278e4fc7$export$69816c1a049f8db6)("first-input", handleEntries);
}
function $b96e0b3274f71e54$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $b64cf2cfbf638e41$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $b64cf2cfbf638e41$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}








const $c4d1b7c490359157$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $c4d1b7c490359157$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $c4d1b7c490359157$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $29b59487f55d4d6d$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $c4d1b7c490359157$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $c4d1b7c490359157$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $c4d1b7c490359157$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $c4d1b7c490359157$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $c4d1b7c490359157$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $c4d1b7c490359157$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($c4d1b7c490359157$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $57f9a4f4cc6ad6aa$export$8e4e25f54d456511), (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c));
        $c4d1b7c490359157$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $c4d1b7c490359157$export$2d8f5188773bcddd(integration) {
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $c4d1b7c490359157$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $c4d1b7c490359157$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $c4d1b7c490359157$export$2323046b9414659f(fn) {
    return fn;
}


let $afd02b252f8a8be3$var$originalFunctionToString;
const $afd02b252f8a8be3$var$INTEGRATION_NAME = "FunctionToString";
const $afd02b252f8a8be3$var$SETUP_CLIENTS = new WeakMap();
const $afd02b252f8a8be3$var$_functionToStringIntegration = ()=>{
    return {
        name: $afd02b252f8a8be3$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $afd02b252f8a8be3$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $a607c0e596f98f0e$export$e6cc1e135e2092e5)(this);
                    const context = $afd02b252f8a8be3$var$SETUP_CLIENTS.has((0, $3db6b415fb112a98$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $afd02b252f8a8be3$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $afd02b252f8a8be3$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $afd02b252f8a8be3$export$7918117e9202e4fb = (0, $c4d1b7c490359157$export$2323046b9414659f)($afd02b252f8a8be3$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $afd02b252f8a8be3$export$da4704525c20ae79 = (0, $c4d1b7c490359157$export$afa219bf23651160)($afd02b252f8a8be3$var$INTEGRATION_NAME, $afd02b252f8a8be3$export$7918117e9202e4fb);


const $3b1cd42980396243$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $3b1cd42980396243$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $3b1cd42980396243$var$_getIngestEndpoint(dsn) {
    return `${$3b1cd42980396243$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $3b1cd42980396243$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $a607c0e596f98f0e$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $3b1cd42980396243$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $3b1cd42980396243$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$3b1cd42980396243$var$_getIngestEndpoint(dsn)}?${$3b1cd42980396243$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $3b1cd42980396243$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $4905f485f0a9bd0e$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$3b1cd42980396243$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $4905f485f0a9bd0e$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $9b70cef98a6e8120$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $9b70cef98a6e8120$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $9b70cef98a6e8120$var$INTEGRATION_NAME = "InboundFilters";
const $9b70cef98a6e8120$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $9b70cef98a6e8120$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $9b70cef98a6e8120$var$_mergeOptions(options, clientOptions);
            return $9b70cef98a6e8120$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $9b70cef98a6e8120$export$cb3c5c2ceb9818ba = (0, $c4d1b7c490359157$export$2323046b9414659f)($9b70cef98a6e8120$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $9b70cef98a6e8120$export$2ffbb5359dcc6be4 = (0, $c4d1b7c490359157$export$afa219bf23651160)($9b70cef98a6e8120$var$INTEGRATION_NAME, $9b70cef98a6e8120$export$cb3c5c2ceb9818ba);
function $9b70cef98a6e8120$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $9b70cef98a6e8120$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $9b70cef98a6e8120$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $9b70cef98a6e8120$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $9b70cef98a6e8120$var$_isSentryError(event)) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $29b59487f55d4d6d$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($9b70cef98a6e8120$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $29b59487f55d4d6d$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($9b70cef98a6e8120$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $29b59487f55d4d6d$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($9b70cef98a6e8120$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $29b59487f55d4d6d$export$4157119e2b157127)(event)}.\nUrl: ${$9b70cef98a6e8120$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$9b70cef98a6e8120$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $29b59487f55d4d6d$export$4157119e2b157127)(event)}.\nUrl: ${$9b70cef98a6e8120$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $9b70cef98a6e8120$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $9b70cef98a6e8120$var$_getPossibleEventMessages(event).some((message)=>(0, $7c3b646f45fbc7a6$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $9b70cef98a6e8120$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $7c3b646f45fbc7a6$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $9b70cef98a6e8120$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $9b70cef98a6e8120$var$_getEventFilterUrl(event);
    return !url ? false : (0, $7c3b646f45fbc7a6$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $9b70cef98a6e8120$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $9b70cef98a6e8120$var$_getEventFilterUrl(event);
    return !url ? true : (0, $7c3b646f45fbc7a6$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $9b70cef98a6e8120$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $6e4b0bb231b9da18$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $29b59487f55d4d6d$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $9b70cef98a6e8120$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $9b70cef98a6e8120$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $9b70cef98a6e8120$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $9b70cef98a6e8120$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $29b59487f55d4d6d$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $f01c197441fe4ea2$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $6e4b0bb231b9da18$export$16a28057038b10ef) (0, $b41a73a19cf590b7$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $b41a73a19cf590b7$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $3db6b415fb112a98$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $f01c197441fe4ea2$export$ecb76f41d43c0e43(client);
    $f01c197441fe4ea2$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $f01c197441fe4ea2$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $f01c197441fe4ea2$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}




/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $857c8bb226f0159d$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $153615ea3378e6bf$export$31499a9cd224b78c)
            })),
        version: (0, $153615ea3378e6bf$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/** An error emitted by Sentry SDKs and related utilities. */ class $87555fe64c3a27e3$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $23d3938fd7d56dc9$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $23d3938fd7d56dc9$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $ff4effe96b979cde$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4905f485f0a9bd0e$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $ff4effe96b979cde$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $23d3938fd7d56dc9$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $ff4effe96b979cde$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $23d3938fd7d56dc9$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $ff4effe96b979cde$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $ff4effe96b979cde$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







/**
 * Generate bucket key from metric properties.
 */ function $a204f95dac488df0$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $a607c0e596f98f0e$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $a204f95dac488df0$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $a204f95dac488df0$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $a204f95dac488df0$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $a204f95dac488df0$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $a204f95dac488df0$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $a204f95dac488df0$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $a204f95dac488df0$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $a204f95dac488df0$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $a204f95dac488df0$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $a204f95dac488df0$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $a204f95dac488df0$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $a204f95dac488df0$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $a204f95dac488df0$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $c23d8c59531d3a8f$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $4905f485f0a9bd0e$export$44d472fbb931a776)(dsn);
    const item = $c23d8c59531d3a8f$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $ff4effe96b979cde$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $c23d8c59531d3a8f$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $a204f95dac488df0$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $465c00039fff35ce$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $465c00039fff35ce$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $4905f485f0a9bd0e$export$128827c3562ec0cb)(options.dsn);
        else (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $3b1cd42980396243$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $29b59487f55d4d6d$export$6de4ffac6a2f1098)(exception)) {
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log($465c00039fff35ce$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $3bf951bd5aad5f95$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $3bf951bd5aad5f95$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $29b59487f55d4d6d$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log($465c00039fff35ce$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $1087116ededa03fe$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $7ae781ad592dc19e$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $c4d1b7c490359157$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $c4d1b7c490359157$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $23d3938fd7d56dc9$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $ff4effe96b979cde$export$d650323442802f6f)(env, (0, $ff4effe96b979cde$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $23d3938fd7d56dc9$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $c23d8c59531d3a8f$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $c4d1b7c490359157$export$51abed9797baa598)(this, integrations);
        (0, $c4d1b7c490359157$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $1087116ededa03fe$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $7ae781ad592dc19e$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $81a5bf896f2147fb$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $396e448d0bac3ce2$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $1156abcd48160615$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $6e4b0bb231b9da18$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $465c00039fff35ce$var$isTransactionEvent(event);
        const isError = $465c00039fff35ce$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $7ae781ad592dc19e$export$78e43115b553f358)(new (0, $87555fe64c3a27e3$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $87555fe64c3a27e3$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $465c00039fff35ce$var$processBeforeSend(options, prepared, hint);
            return $465c00039fff35ce$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $87555fe64c3a27e3$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $87555fe64c3a27e3$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $87555fe64c3a27e3$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $465c00039fff35ce$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $3bf951bd5aad5f95$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $3bf951bd5aad5f95$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $87555fe64c3a27e3$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $87555fe64c3a27e3$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $3bf951bd5aad5f95$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $87555fe64c3a27e3$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $465c00039fff35ce$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($465c00039fff35ce$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($465c00039fff35ce$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $465c00039fff35ce$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $465c00039fff35ce$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $465c00039fff35ce$export$9aac0b9f77928fbf(callback) {
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $3d4c85e7bfb14e37$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $9394cb5a9147bec2$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $ff4effe96b979cde$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $18FZq = parcelRequire("18FZq");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b70abbea0a5a3a89$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $3988ac231f744a1f$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $3988ac231f744a1f$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $3988ac231f744a1f$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $3988ac231f744a1f$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $3bf951bd5aad5f95$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $3988ac231f744a1f$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $22dd55058e9e130a$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $3988ac231f744a1f$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $3988ac231f744a1f$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $3988ac231f744a1f$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $3988ac231f744a1f$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $3988ac231f744a1f$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $3988ac231f744a1f$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $3988ac231f744a1f$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($3988ac231f744a1f$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $3988ac231f744a1f$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $3988ac231f744a1f$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $3988ac231f744a1f$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $29b59487f55d4d6d$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $7ae781ad592dc19e$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $3988ac231f744a1f$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $3988ac231f744a1f$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $7ae781ad592dc19e$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $3988ac231f744a1f$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $3bf951bd5aad5f95$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $3988ac231f744a1f$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $3bf951bd5aad5f95$export$ef9e2056653f0c8e)(exception) || (0, $3bf951bd5aad5f95$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $3988ac231f744a1f$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $3bf951bd5aad5f95$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $3988ac231f744a1f$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $29b59487f55d4d6d$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $3bf951bd5aad5f95$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $3988ac231f744a1f$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $3bf951bd5aad5f95$export$53b83ca8eaab0383)(exception) || (0, $3bf951bd5aad5f95$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $3988ac231f744a1f$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $29b59487f55d4d6d$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $3988ac231f744a1f$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $29b59487f55d4d6d$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $29b59487f55d4d6d$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $3988ac231f744a1f$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $3988ac231f744a1f$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $3bf951bd5aad5f95$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $3988ac231f744a1f$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $a607c0e596f98f0e$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $3bf951bd5aad5f95$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $3bf951bd5aad5f95$export$9671ea99bd126ace)(exception)) {
        const className = $3988ac231f744a1f$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $3988ac231f744a1f$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $bb1e42842e238087$export$56d8a8a25bd48b81 = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1);
let $bb1e42842e238087$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $bb1e42842e238087$export$b79738ab10c590b2() {
    return $bb1e42842e238087$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $bb1e42842e238087$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $bb1e42842e238087$var$ignoreOnError++;
    setTimeout(()=>{
        $bb1e42842e238087$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $bb1e42842e238087$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $a607c0e596f98f0e$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$bb1e42842e238087$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $bb1e42842e238087$export$1265a142ff5ba165();
            (0, $3db6b415fb112a98$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $29b59487f55d4d6d$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $29b59487f55d4d6d$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $3db6b415fb112a98$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $a607c0e596f98f0e$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $a607c0e596f98f0e$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $62c9ccec7ef1d779$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $4905f485f0a9bd0e$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $62c9ccec7ef1d779$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $ff4effe96b979cde$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $62c9ccec7ef1d779$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $ab66f0c8c2bbfb80$export$1df9218a526d318d extends (0, $465c00039fff35ce$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $bb1e42842e238087$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $18FZq.getSDKSource)();
        (0, $857c8bb226f0159d$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $bb1e42842e238087$export$56d8a8a25bd48b81).document) (0, $bb1e42842e238087$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $bb1e42842e238087$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $3988ac231f744a1f$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $3988ac231f744a1f$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $62c9ccec7ef1d779$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $3d4c85e7bfb14e37$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $4905f485f0a9bd0e$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $13156ec00db7db00$var$WINDOW = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1);
const $13156ec00db7db00$var$DEBOUNCE_DURATION = 1000;
let $13156ec00db7db00$var$debounceTimerID;
let $13156ec00db7db00$var$lastCapturedEventType;
let $13156ec00db7db00$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $13156ec00db7db00$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $f4fa49712c63c05b$export$a4e09611e30da72e)(type, handler);
    (0, $f4fa49712c63c05b$export$e18d6c5462c01368)(type, $13156ec00db7db00$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $13156ec00db7db00$export$3014bbf0af0e1d4a() {
    if (!$13156ec00db7db00$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $f4fa49712c63c05b$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $13156ec00db7db00$var$makeDOMEventHandler(triggerDOMHandler, true);
    $13156ec00db7db00$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $13156ec00db7db00$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $13156ec00db7db00$var$WINDOW[target] && $13156ec00db7db00$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $a607c0e596f98f0e$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $13156ec00db7db00$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $a607c0e596f98f0e$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $13156ec00db7db00$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $13156ec00db7db00$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $13156ec00db7db00$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $13156ec00db7db00$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $13156ec00db7db00$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $13156ec00db7db00$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($13156ec00db7db00$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $a607c0e596f98f0e$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $a607c0e596f98f0e$export$e73679ffaf56810e)(target, "_sentryId", (0, $29b59487f55d4d6d$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$13156ec00db7db00$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $13156ec00db7db00$var$lastCapturedEventType = event.type;
            $13156ec00db7db00$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($13156ec00db7db00$var$debounceTimerID);
        $13156ec00db7db00$var$debounceTimerID = $13156ec00db7db00$var$WINDOW.setTimeout(()=>{
            $13156ec00db7db00$var$lastCapturedEventTargetId = undefined;
            $13156ec00db7db00$var$lastCapturedEventType = undefined;
        }, $13156ec00db7db00$var$DEBOUNCE_DURATION);
    };
}
function $13156ec00db7db00$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5c42b873ac7c2926$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $f4fa49712c63c05b$export$a4e09611e30da72e)(type, handler);
    (0, $f4fa49712c63c05b$export$e18d6c5462c01368)(type, $5c42b873ac7c2926$var$instrumentConsole);
}
function $5c42b873ac7c2926$var$instrumentConsole() {
    if (!("console" in (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1))) return;
    (0, $b41a73a19cf590b7$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).console)) return;
        (0, $a607c0e596f98f0e$export$9563e054e6f787fb)((0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $b41a73a19cf590b7$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $f4fa49712c63c05b$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $b41a73a19cf590b7$export$77c4ce905194557b)[level];
                log && log.apply((0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $418805b2b882b689$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $418805b2b882b689$export$e01cef29b4327697(level) {
    return $418805b2b882b689$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $418805b2b882b689$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $418805b2b882b689$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $44a06f4e5b4072d8$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $44a06f4e5b4072d8$var$INTEGRATION_NAME = "Breadcrumbs";
const $44a06f4e5b4072d8$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $44a06f4e5b4072d8$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $5c42b873ac7c2926$export$1d6e0d073f9e6723)($44a06f4e5b4072d8$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $13156ec00db7db00$export$5aeffd3db2cf9df7)($44a06f4e5b4072d8$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $6324c6a4679c00bc$export$26ace48dd54c9aea)($44a06f4e5b4072d8$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $6f452264ed38498f$export$f75d3c772c923df0)($44a06f4e5b4072d8$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $ad8d7abadbaf360a$export$3f18c56c58114e75)($44a06f4e5b4072d8$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $44a06f4e5b4072d8$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $44a06f4e5b4072d8$export$c079d904b326663a = (0, $c4d1b7c490359157$export$2323046b9414659f)($44a06f4e5b4072d8$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $44a06f4e5b4072d8$export$2dc68d50d56fbbd = (0, $c4d1b7c490359157$export$afa219bf23651160)($44a06f4e5b4072d8$var$INTEGRATION_NAME, $44a06f4e5b4072d8$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $44a06f4e5b4072d8$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $3db6b415fb112a98$export$6bb76d6eba7e258c)() !== client) return;
        (0, $3db6b415fb112a98$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $29b59487f55d4d6d$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $44a06f4e5b4072d8$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $3db6b415fb112a98$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $44a06f4e5b4072d8$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$44a06f4e5b4072d8$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$44a06f4e5b4072d8$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $44a06f4e5b4072d8$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $44a06f4e5b4072d8$var$_isEvent(event) ? event.target : event;
            target = (0, $61a396c4768b6eee$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $61a396c4768b6eee$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $3db6b415fb112a98$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $44a06f4e5b4072d8$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $3db6b415fb112a98$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $418805b2b882b689$export$d771ef054122c30a)(handlerData.level),
            message: (0, $7c3b646f45fbc7a6$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $7c3b646f45fbc7a6$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $3db6b415fb112a98$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $44a06f4e5b4072d8$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $3db6b415fb112a98$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $6324c6a4679c00bc$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $3db6b415fb112a98$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $44a06f4e5b4072d8$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $3db6b415fb112a98$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3db6b415fb112a98$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3db6b415fb112a98$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $44a06f4e5b4072d8$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $3db6b415fb112a98$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $2b74f4160aaa03f7$export$7a5253c0f62e0150)((0, $bb1e42842e238087$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $2b74f4160aaa03f7$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $2b74f4160aaa03f7$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $3db6b415fb112a98$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $44a06f4e5b4072d8$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $fb31777e454d2130$var$INTEGRATION_NAME = "Dedupe";
const $fb31777e454d2130$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $fb31777e454d2130$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($fb31777e454d2130$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $fb31777e454d2130$export$6d39aa44cd0c7567 = (0, $c4d1b7c490359157$export$2323046b9414659f)($fb31777e454d2130$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $fb31777e454d2130$export$688d98c249d31ad3 = (0, $c4d1b7c490359157$export$afa219bf23651160)($fb31777e454d2130$var$INTEGRATION_NAME, $fb31777e454d2130$export$6d39aa44cd0c7567);
function $fb31777e454d2130$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($fb31777e454d2130$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($fb31777e454d2130$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $fb31777e454d2130$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$fb31777e454d2130$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fb31777e454d2130$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $fb31777e454d2130$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $fb31777e454d2130$var$_getExceptionFromEvent(previousEvent);
    const currentException = $fb31777e454d2130$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$fb31777e454d2130$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fb31777e454d2130$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $fb31777e454d2130$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $fb31777e454d2130$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $fb31777e454d2130$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $fb31777e454d2130$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $fb31777e454d2130$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $fb31777e454d2130$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $4899863f245f4a95$var$INTEGRATION_NAME = "GlobalHandlers";
const $4899863f245f4a95$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $4899863f245f4a95$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $4899863f245f4a95$var$_installGlobalOnErrorHandler(client);
                $4899863f245f4a95$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $4899863f245f4a95$var$_installGlobalOnUnhandledRejectionHandler(client);
                $4899863f245f4a95$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $4899863f245f4a95$export$66acc70e8cf2b71a = (0, $c4d1b7c490359157$export$2323046b9414659f)($4899863f245f4a95$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4899863f245f4a95$export$204155decbc90e5a = (0, $c4d1b7c490359157$export$afa219bf23651160)($4899863f245f4a95$var$INTEGRATION_NAME, $4899863f245f4a95$export$66acc70e8cf2b71a);
function $4899863f245f4a95$var$_installGlobalOnErrorHandler(client) {
    (0, $34acaeea83ea86b2$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $4899863f245f4a95$var$getOptions();
        if ((0, $3db6b415fb112a98$export$6bb76d6eba7e258c)() !== client || (0, $bb1e42842e238087$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $3bf951bd5aad5f95$export$844ec244b1367d54)(msg) ? $4899863f245f4a95$var$_eventFromIncompleteOnError(msg, url, line, column) : $4899863f245f4a95$var$_enhanceEventWithInitialFrame((0, $3988ac231f744a1f$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $3db6b415fb112a98$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $4899863f245f4a95$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $4ad8b212cefcd10a$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $4899863f245f4a95$var$getOptions();
        if ((0, $3db6b415fb112a98$export$6bb76d6eba7e258c)() !== client || (0, $bb1e42842e238087$export$b79738ab10c590b2)()) return;
        const error = $4899863f245f4a95$var$_getUnhandledRejectionError(e);
        const event = (0, $3bf951bd5aad5f95$export$c3825b437cbdea5c)(error) ? $4899863f245f4a95$var$_eventFromRejectionWithPrimitive(error) : (0, $3988ac231f744a1f$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $3db6b415fb112a98$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $4899863f245f4a95$var$_getUnhandledRejectionError(error) {
    if ((0, $3bf951bd5aad5f95$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $4899863f245f4a95$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4899863f245f4a95$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $3bf951bd5aad5f95$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $4899863f245f4a95$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4899863f245f4a95$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $3bf951bd5aad5f95$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $61a396c4768b6eee$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $4899863f245f4a95$var$globalHandlerLog(type) {
    (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $4899863f245f4a95$var$getOptions() {
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $d2f205a07aa031ed$var$INTEGRATION_NAME = "HttpContext";
const $d2f205a07aa031ed$var$_httpContextIntegration = ()=>{
    return {
        name: $d2f205a07aa031ed$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $bb1e42842e238087$export$56d8a8a25bd48b81).navigator && !(0, $bb1e42842e238087$export$56d8a8a25bd48b81).location && !(0, $bb1e42842e238087$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $bb1e42842e238087$export$56d8a8a25bd48b81).location && (0, $bb1e42842e238087$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $bb1e42842e238087$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $bb1e42842e238087$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $d2f205a07aa031ed$export$1378794447170364 = (0, $c4d1b7c490359157$export$2323046b9414659f)($d2f205a07aa031ed$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d2f205a07aa031ed$export$5d2ee9a544b09a94 = (0, $c4d1b7c490359157$export$afa219bf23651160)($d2f205a07aa031ed$var$INTEGRATION_NAME, $d2f205a07aa031ed$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $9944204147948e3c$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $3bf951bd5aad5f95$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $9944204147948e3c$var$truncateAggregateExceptions($9944204147948e3c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $9944204147948e3c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $3bf951bd5aad5f95$export$49034edbe6b62415)(error[key], Error)) {
        $9944204147948e3c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $9944204147948e3c$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $9944204147948e3c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $3bf951bd5aad5f95$export$49034edbe6b62415)(childError, Error)) {
            $9944204147948e3c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $9944204147948e3c$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $9944204147948e3c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $9944204147948e3c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $9944204147948e3c$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $9944204147948e3c$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $7c3b646f45fbc7a6$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $74ab2655069b0c45$var$DEFAULT_KEY = "cause";
const $74ab2655069b0c45$var$DEFAULT_LIMIT = 5;
const $74ab2655069b0c45$var$INTEGRATION_NAME = "LinkedErrors";
const $74ab2655069b0c45$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ab2655069b0c45$var$DEFAULT_LIMIT;
    const key = options.key || $74ab2655069b0c45$var$DEFAULT_KEY;
    return {
        name: $74ab2655069b0c45$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $9944204147948e3c$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $3988ac231f744a1f$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $74ab2655069b0c45$export$ebabb00eb7f3a395 = (0, $c4d1b7c490359157$export$2323046b9414659f)($74ab2655069b0c45$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $74ab2655069b0c45$export$8d1e60aaf616fb4f = (0, $c4d1b7c490359157$export$afa219bf23651160)($74ab2655069b0c45$var$INTEGRATION_NAME, $74ab2655069b0c45$export$ebabb00eb7f3a395);





const $6c1d2a112cd448ec$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $6c1d2a112cd448ec$var$INTEGRATION_NAME = "TryCatch";
const $6c1d2a112cd448ec$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $6c1d2a112cd448ec$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $a607c0e596f98f0e$export$9563e054e6f787fb)((0, $bb1e42842e238087$export$56d8a8a25bd48b81), "setTimeout", $6c1d2a112cd448ec$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $a607c0e596f98f0e$export$9563e054e6f787fb)((0, $bb1e42842e238087$export$56d8a8a25bd48b81), "setInterval", $6c1d2a112cd448ec$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $a607c0e596f98f0e$export$9563e054e6f787fb)((0, $bb1e42842e238087$export$56d8a8a25bd48b81), "requestAnimationFrame", $6c1d2a112cd448ec$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $bb1e42842e238087$export$56d8a8a25bd48b81)) (0, $a607c0e596f98f0e$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $6c1d2a112cd448ec$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $6c1d2a112cd448ec$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($6c1d2a112cd448ec$var$_wrapEventTarget);
            }
        }
    };
};
const $6c1d2a112cd448ec$export$59bfe9f1c76150e = (0, $c4d1b7c490359157$export$2323046b9414659f)($6c1d2a112cd448ec$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $6c1d2a112cd448ec$export$f1a018517668e6d3 = (0, $c4d1b7c490359157$export$afa219bf23651160)($6c1d2a112cd448ec$var$INTEGRATION_NAME, $6c1d2a112cd448ec$export$59bfe9f1c76150e);
function $6c1d2a112cd448ec$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $bb1e42842e238087$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $886040b9c3125f7f$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6c1d2a112cd448ec$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $bb1e42842e238087$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $886040b9c3125f7f$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $6c1d2a112cd448ec$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $a607c0e596f98f0e$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $886040b9c3125f7f$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $a607c0e596f98f0e$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $886040b9c3125f7f$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $bb1e42842e238087$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $6c1d2a112cd448ec$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $bb1e42842e238087$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $a607c0e596f98f0e$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $bb1e42842e238087$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $886040b9c3125f7f$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $bb1e42842e238087$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $886040b9c3125f7f$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $a607c0e596f98f0e$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $e99cf19e03dee577$var$UNKNOWN_FUNCTION = "?";
const $e99cf19e03dee577$var$OPERA10_PRIORITY = 10;
const $e99cf19e03dee577$var$OPERA11_PRIORITY = 20;
const $e99cf19e03dee577$var$CHROME_PRIORITY = 30;
const $e99cf19e03dee577$var$WINJS_PRIORITY = 40;
const $e99cf19e03dee577$var$GECKO_PRIORITY = 50;
function $e99cf19e03dee577$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $e99cf19e03dee577$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e99cf19e03dee577$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e99cf19e03dee577$var$chromeStackParserFn = (line)=>{
    const parts = $e99cf19e03dee577$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $e99cf19e03dee577$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e99cf19e03dee577$var$extractSafariExtensionDetails(parts[1] || $e99cf19e03dee577$var$UNKNOWN_FUNCTION, parts[2]);
        return $e99cf19e03dee577$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e99cf19e03dee577$export$263a749fff749872 = [
    $e99cf19e03dee577$var$CHROME_PRIORITY,
    $e99cf19e03dee577$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e99cf19e03dee577$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e99cf19e03dee577$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e99cf19e03dee577$var$gecko = (line)=>{
    const parts = $e99cf19e03dee577$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $e99cf19e03dee577$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $e99cf19e03dee577$var$UNKNOWN_FUNCTION;
        [func, filename] = $e99cf19e03dee577$var$extractSafariExtensionDetails(func, filename);
        return $e99cf19e03dee577$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e99cf19e03dee577$export$cdba47a5dd2804d = [
    $e99cf19e03dee577$var$GECKO_PRIORITY,
    $e99cf19e03dee577$var$gecko
];
const $e99cf19e03dee577$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e99cf19e03dee577$var$winjs = (line)=>{
    const parts = $e99cf19e03dee577$var$winjsRegex.exec(line);
    return parts ? $e99cf19e03dee577$var$createFrame(parts[2], parts[1] || $e99cf19e03dee577$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e99cf19e03dee577$export$179460296da408e8 = [
    $e99cf19e03dee577$var$WINJS_PRIORITY,
    $e99cf19e03dee577$var$winjs
];
const $e99cf19e03dee577$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e99cf19e03dee577$var$opera10 = (line)=>{
    const parts = $e99cf19e03dee577$var$opera10Regex.exec(line);
    return parts ? $e99cf19e03dee577$var$createFrame(parts[2], parts[3] || $e99cf19e03dee577$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $e99cf19e03dee577$export$f892b52c880ffc7a = [
    $e99cf19e03dee577$var$OPERA10_PRIORITY,
    $e99cf19e03dee577$var$opera10
];
const $e99cf19e03dee577$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e99cf19e03dee577$var$opera11 = (line)=>{
    const parts = $e99cf19e03dee577$var$opera11Regex.exec(line);
    return parts ? $e99cf19e03dee577$var$createFrame(parts[5], parts[3] || parts[4] || $e99cf19e03dee577$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $e99cf19e03dee577$export$af11af13f09fb0dc = [
    $e99cf19e03dee577$var$OPERA11_PRIORITY,
    $e99cf19e03dee577$var$opera11
];
const $e99cf19e03dee577$export$7197c0fe6554c079 = [
    $e99cf19e03dee577$export$263a749fff749872,
    $e99cf19e03dee577$export$cdba47a5dd2804d,
    $e99cf19e03dee577$export$179460296da408e8
];
const $e99cf19e03dee577$export$2b2b997d81bf3907 = (0, $886040b9c3125f7f$export$a5739666fb2d03d4)(...$e99cf19e03dee577$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e99cf19e03dee577$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $e99cf19e03dee577$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $4a51996874e47461$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $4a51996874e47461$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $4a51996874e47461$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $4a51996874e47461$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $4a51996874e47461$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $4a51996874e47461$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $4a51996874e47461$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $4a51996874e47461$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $0b9ae849859ab66f$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $7ae781ad592dc19e$export$78e43115b553f358)(new (0, $87555fe64c3a27e3$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $7ae781ad592dc19e$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $7ae781ad592dc19e$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $5dd2b27aee4c7a94$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $5dd2b27aee4c7a94$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $0b9ae849859ab66f$export$85a4f67f852183e6)(options.bufferSize || $5dd2b27aee4c7a94$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $ff4effe96b979cde$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $ff4effe96b979cde$export$b11169581eeaf237)(type);
            if ((0, $4a51996874e47461$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $5dd2b27aee4c7a94$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $7ae781ad592dc19e$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $ff4effe96b979cde$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $ff4effe96b979cde$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $5dd2b27aee4c7a94$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $ff4effe96b979cde$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $ff4effe96b979cde$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $4a51996874e47461$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $87555fe64c3a27e3$export$5949942ba2a7c0e2)) {
                (0, $6e4b0bb231b9da18$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $7ae781ad592dc19e$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $5dd2b27aee4c7a94$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $47e92fc752bb3368$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $47e92fc752bb3368$export$8be2119ce08e3379() {
    if ($47e92fc752bb3368$var$cachedFetchImpl) return $47e92fc752bb3368$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $9e723db1e8b7a171$export$18cf36ed71d733e7)((0, $bb1e42842e238087$export$56d8a8a25bd48b81).fetch)) return $47e92fc752bb3368$var$cachedFetchImpl = (0, $bb1e42842e238087$export$56d8a8a25bd48b81).fetch.bind((0, $bb1e42842e238087$export$56d8a8a25bd48b81));
    const document = (0, $bb1e42842e238087$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $bb1e42842e238087$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $47e92fc752bb3368$var$cachedFetchImpl = fetchImpl.bind((0, $bb1e42842e238087$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $47e92fc752bb3368$export$d499686d2dd738c6() {
    $47e92fc752bb3368$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $924d22a185c2a754$export$b2311068c46d7cc8(options, nativeFetch = (0, $47e92fc752bb3368$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $47e92fc752bb3368$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $7ae781ad592dc19e$export$78e43115b553f358)(e);
        }
    }
    return (0, $5dd2b27aee4c7a94$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $71460899c434e798$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $71460899c434e798$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $7ae781ad592dc19e$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $71460899c434e798$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $5dd2b27aee4c7a94$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $f20da0caacd4dcf5$export$5ef831fccfce35e5 = [
    (0, $9b70cef98a6e8120$export$cb3c5c2ceb9818ba)(),
    (0, $afd02b252f8a8be3$export$7918117e9202e4fb)(),
    (0, $6c1d2a112cd448ec$export$59bfe9f1c76150e)(),
    (0, $44a06f4e5b4072d8$export$c079d904b326663a)(),
    (0, $4899863f245f4a95$export$66acc70e8cf2b71a)(),
    (0, $74ab2655069b0c45$export$ebabb00eb7f3a395)(),
    (0, $fb31777e454d2130$export$6d39aa44cd0c7567)(),
    (0, $d2f205a07aa031ed$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $f20da0caacd4dcf5$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$f20da0caacd4dcf5$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $f20da0caacd4dcf5$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $f20da0caacd4dcf5$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $bb1e42842e238087$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $bb1e42842e238087$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $bb1e42842e238087$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $886040b9c3125f7f$export$1d5cf88b347146d4)(options.stackParser || (0, $e99cf19e03dee577$export$2b2b997d81bf3907)),
        integrations: (0, $c4d1b7c490359157$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $9e723db1e8b7a171$export$edf3cb81fd7d2a3e)() ? (0, $924d22a185c2a754$export$b2311068c46d7cc8) : (0, $71460899c434e798$export$5e1441cee30d5a39))
    };
    (0, $f01c197441fe4ea2$export$5333c3f1c58d9bc1)((0, $ab66f0c8c2bbfb80$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $f20da0caacd4dcf5$var$startSessionTracking();
}
const $f20da0caacd4dcf5$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $81a5bf896f2147fb$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $bb1e42842e238087$export$56d8a8a25bd48b81).document) {
        (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $bb1e42842e238087$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $3b1cd42980396243$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $bb1e42842e238087$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $bb1e42842e238087$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $bb1e42842e238087$export$56d8a8a25bd48b81).document.head || (0, $bb1e42842e238087$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $f20da0caacd4dcf5$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $f20da0caacd4dcf5$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f20da0caacd4dcf5$export$4997ffc0176396a6(fn) {
    return (0, $bb1e42842e238087$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $f20da0caacd4dcf5$var$startSessionTracking() {
    if (typeof (0, $bb1e42842e238087$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $b70abbea0a5a3a89$export$16a28057038b10ef) && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $3db6b415fb112a98$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $3db6b415fb112a98$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $ad8d7abadbaf360a$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $3db6b415fb112a98$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $3db6b415fb112a98$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $f20da0caacd4dcf5$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $7e5720515a763331$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $857c8bb226f0159d$export$b9f95b027256052c)(opts, "react");
    (0, $f20da0caacd4dcf5$export$2cd8252107eb640b)(opts);
}

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $1a8a1c27bdf50fc2$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $45e7406d4e8d2868$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $gjQGW = parcelRequire("gjQGW");

/**
 * Returns true if we are in the browser.
 */ function $4a89a3c7e0a00992$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $gjQGW.isNodeEnv)() || $4a89a3c7e0a00992$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $4a89a3c7e0a00992$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).process !== undefined && (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1).process.type === "renderer");
}


/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
function $7b20f9262c86507a$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $7b20f9262c86507a$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $7b20f9262c86507a$var$checkDsn(url, dsn) || $7b20f9262c86507a$var$checkTunnel(url, tunnel);
}
function $7b20f9262c86507a$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $7b20f9262c86507a$var$removeTrailingSlash(url) === $7b20f9262c86507a$var$removeTrailingSlash(tunnel);
}
function $7b20f9262c86507a$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $7b20f9262c86507a$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function $7b20f9262c86507a$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $e2f0a84b44552346$var$WINDOW = (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1);
const $e2f0a84b44552346$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $e2f0a84b44552346$var$REPLAY_EVENT_NAME = "replay_event";
const $e2f0a84b44552346$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $e2f0a84b44552346$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $e2f0a84b44552346$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $e2f0a84b44552346$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $e2f0a84b44552346$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $e2f0a84b44552346$var$BUFFER_CHECKOUT_TIME = 60000;
const $e2f0a84b44552346$var$RETRY_BASE_INTERVAL = 5000;
const $e2f0a84b44552346$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $e2f0a84b44552346$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $e2f0a84b44552346$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $e2f0a84b44552346$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $e2f0a84b44552346$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $e2f0a84b44552346$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $e2f0a84b44552346$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $e2f0a84b44552346$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $e2f0a84b44552346$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $e2f0a84b44552346$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $e2f0a84b44552346$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $e2f0a84b44552346$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($e2f0a84b44552346$var$NodeType$1 || ($e2f0a84b44552346$var$NodeType$1 = {}));
function $e2f0a84b44552346$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $e2f0a84b44552346$var$isShadowRoot(n) {
    const host = $e2f0a84b44552346$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($e2f0a84b44552346$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $e2f0a84b44552346$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $e2f0a84b44552346$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $e2f0a84b44552346$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $e2f0a84b44552346$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $e2f0a84b44552346$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $e2f0a84b44552346$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $e2f0a84b44552346$var$stringifyRule(rule) {
    let importStringified;
    if ($e2f0a84b44552346$var$isCSSImportRule(rule)) try {
        importStringified = $e2f0a84b44552346$var$stringifyStylesheet(rule.styleSheet) || $e2f0a84b44552346$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($e2f0a84b44552346$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $e2f0a84b44552346$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $e2f0a84b44552346$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $e2f0a84b44552346$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $e2f0a84b44552346$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $e2f0a84b44552346$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $e2f0a84b44552346$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $e2f0a84b44552346$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $e2f0a84b44552346$var$createMirror() {
    return new $e2f0a84b44552346$var$Mirror();
}
function $e2f0a84b44552346$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $e2f0a84b44552346$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $e2f0a84b44552346$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $e2f0a84b44552346$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $e2f0a84b44552346$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $e2f0a84b44552346$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $e2f0a84b44552346$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$e2f0a84b44552346$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $e2f0a84b44552346$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $e2f0a84b44552346$var$toLowerCase(type) : null;
}
function $e2f0a84b44552346$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $e2f0a84b44552346$var$_id = 1;
const $e2f0a84b44552346$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $e2f0a84b44552346$var$IGNORED_NODE = -2;
function $e2f0a84b44552346$var$genId() {
    return $e2f0a84b44552346$var$_id++;
}
function $e2f0a84b44552346$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $e2f0a84b44552346$var$toLowerCase(element.tagName);
    if ($e2f0a84b44552346$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $e2f0a84b44552346$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $e2f0a84b44552346$var$canvasService;
let $e2f0a84b44552346$var$canvasCtx;
const $e2f0a84b44552346$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $e2f0a84b44552346$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $e2f0a84b44552346$var$URL_WWW_MATCH = /^www\..*/i;
const $e2f0a84b44552346$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $e2f0a84b44552346$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($e2f0a84b44552346$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($e2f0a84b44552346$var$URL_PROTOCOL_MATCH.test(filePath) || $e2f0a84b44552346$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($e2f0a84b44552346$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$e2f0a84b44552346$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $e2f0a84b44552346$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $e2f0a84b44552346$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $e2f0a84b44552346$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($e2f0a84b44552346$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($e2f0a84b44552346$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $e2f0a84b44552346$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $e2f0a84b44552346$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $e2f0a84b44552346$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $e2f0a84b44552346$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $e2f0a84b44552346$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $e2f0a84b44552346$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $e2f0a84b44552346$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $e2f0a84b44552346$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $e2f0a84b44552346$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $e2f0a84b44552346$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $e2f0a84b44552346$var$absoluteToStylesheet(value, $e2f0a84b44552346$var$getHref());
    else if (tagName === "object" && name === "data") return $e2f0a84b44552346$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $e2f0a84b44552346$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $e2f0a84b44552346$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $e2f0a84b44552346$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $e2f0a84b44552346$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $e2f0a84b44552346$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $e2f0a84b44552346$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($e2f0a84b44552346$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $e2f0a84b44552346$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $e2f0a84b44552346$var$distanceToMatch(el, $e2f0a84b44552346$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $e2f0a84b44552346$var$distanceToMatch(el, $e2f0a84b44552346$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $e2f0a84b44552346$var$distanceToMatch(el, $e2f0a84b44552346$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $e2f0a84b44552346$var$distanceToMatch(el, $e2f0a84b44552346$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $e2f0a84b44552346$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $e2f0a84b44552346$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $e2f0a84b44552346$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $e2f0a84b44552346$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $e2f0a84b44552346$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $e2f0a84b44552346$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $e2f0a84b44552346$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $e2f0a84b44552346$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $e2f0a84b44552346$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $e2f0a84b44552346$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $e2f0a84b44552346$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $e2f0a84b44552346$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $e2f0a84b44552346$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($e2f0a84b44552346$var$_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = $e2f0a84b44552346$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $e2f0a84b44552346$var$absoluteToStylesheet(textContent, $e2f0a84b44552346$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $e2f0a84b44552346$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $e2f0a84b44552346$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $e2f0a84b44552346$var$maskInputValue({
            isMasked: $e2f0a84b44552346$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $e2f0a84b44552346$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $e2f0a84b44552346$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $e2f0a84b44552346$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $e2f0a84b44552346$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$e2f0a84b44552346$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $e2f0a84b44552346$var$transformAttribute(doc, tagName, $e2f0a84b44552346$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $e2f0a84b44552346$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $e2f0a84b44552346$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $e2f0a84b44552346$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $e2f0a84b44552346$var$absoluteToStylesheet(cssText, $e2f0a84b44552346$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $e2f0a84b44552346$var$getInputType(el);
        const value = $e2f0a84b44552346$var$getInputValue(el, $e2f0a84b44552346$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $e2f0a84b44552346$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $e2f0a84b44552346$var$shouldMaskInput({
                type: type,
                tagName: $e2f0a84b44552346$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $e2f0a84b44552346$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$e2f0a84b44552346$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$e2f0a84b44552346$var$canvasService) {
            $e2f0a84b44552346$var$canvasService = doc.createElement("canvas");
            $e2f0a84b44552346$var$canvasCtx = $e2f0a84b44552346$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $e2f0a84b44552346$var$canvasService.width = image.naturalWidth;
                $e2f0a84b44552346$var$canvasService.height = image.naturalHeight;
                $e2f0a84b44552346$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $e2f0a84b44552346$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $e2f0a84b44552346$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $e2f0a84b44552346$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $e2f0a84b44552346$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $e2f0a84b44552346$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $e2f0a84b44552346$var$NodeType$1.Comment) return true;
    else if (sn.type === $e2f0a84b44552346$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($e2f0a84b44552346$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "application-name" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.rel) === "icon" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($e2f0a84b44552346$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "robots" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "googlebot" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "author" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "generator" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "framework" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "publisher" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "progid" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "verification" || $e2f0a84b44552346$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $e2f0a84b44552346$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $e2f0a84b44552346$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($e2f0a84b44552346$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $e2f0a84b44552346$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $e2f0a84b44552346$var$IGNORED_NODE;
    else id = $e2f0a84b44552346$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $e2f0a84b44552346$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $e2f0a84b44552346$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $e2f0a84b44552346$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $e2f0a84b44552346$var$NodeType$1.Document || serializedNode.type === $e2f0a84b44552346$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $e2f0a84b44552346$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $e2f0a84b44552346$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($e2f0a84b44552346$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $e2f0a84b44552346$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $e2f0a84b44552346$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $e2f0a84b44552346$var$isShadowRoot(n.parentNode) && $e2f0a84b44552346$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $e2f0a84b44552346$var$NodeType$1.Element && serializedNode.tagName === "iframe") $e2f0a84b44552346$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $e2f0a84b44552346$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $e2f0a84b44552346$var$NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") $e2f0a84b44552346$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $e2f0a84b44552346$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $e2f0a84b44552346$var$snapshot(n, options) {
    const { mirror: mirror = new $e2f0a84b44552346$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $e2f0a84b44552346$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $e2f0a84b44552346$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $e2f0a84b44552346$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $e2f0a84b44552346$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $e2f0a84b44552346$var$_mirror = {
    map: {},
    getId () {
        console.error($e2f0a84b44552346$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($e2f0a84b44552346$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($e2f0a84b44552346$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($e2f0a84b44552346$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($e2f0a84b44552346$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $e2f0a84b44552346$var$_mirror = new Proxy($e2f0a84b44552346$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($e2f0a84b44552346$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $e2f0a84b44552346$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $e2f0a84b44552346$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $e2f0a84b44552346$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $e2f0a84b44552346$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $e2f0a84b44552346$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$e2f0a84b44552346$var$hookSetter(target, key, original || {}, true);
}
function $e2f0a84b44552346$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $e2f0a84b44552346$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $e2f0a84b44552346$var$nowTimestamp = ()=>new Date().getTime();
function $e2f0a84b44552346$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $e2f0a84b44552346$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $e2f0a84b44552346$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $e2f0a84b44552346$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $e2f0a84b44552346$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $e2f0a84b44552346$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $e2f0a84b44552346$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $e2f0a84b44552346$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $e2f0a84b44552346$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $e2f0a84b44552346$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $e2f0a84b44552346$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $e2f0a84b44552346$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $e2f0a84b44552346$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $e2f0a84b44552346$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $e2f0a84b44552346$var$distanceToMatch(el, $e2f0a84b44552346$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $e2f0a84b44552346$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $e2f0a84b44552346$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $e2f0a84b44552346$var$IGNORED_NODE;
}
function $e2f0a84b44552346$var$isAncestorRemoved(target, mirror) {
    if ($e2f0a84b44552346$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $e2f0a84b44552346$var$isAncestorRemoved(target.parentNode, mirror);
}
function $e2f0a84b44552346$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $e2f0a84b44552346$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $e2f0a84b44552346$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $e2f0a84b44552346$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $e2f0a84b44552346$var$hasShadowRoot(n) {
    return Boolean($e2f0a84b44552346$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $e2f0a84b44552346$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $1a8a1c27bdf50fc2$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $e2f0a84b44552346$var$getShadowHost(n) {
    let shadowHost = null;
    if ($e2f0a84b44552346$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $e2f0a84b44552346$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $e2f0a84b44552346$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $e2f0a84b44552346$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $e2f0a84b44552346$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $e2f0a84b44552346$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $e2f0a84b44552346$var$shadowHostInDom(n);
}
const $e2f0a84b44552346$var$cachedImplementations = {};
function $e2f0a84b44552346$var$getImplementation(name) {
    const cached = $e2f0a84b44552346$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $e2f0a84b44552346$var$cachedImplementations[name] = impl.bind(window);
}
function $e2f0a84b44552346$var$onRequestAnimationFrame(...rest) {
    return $e2f0a84b44552346$var$getImplementation("requestAnimationFrame")(...rest);
}
function $e2f0a84b44552346$var$setTimeout$1(...rest) {
    return $e2f0a84b44552346$var$getImplementation("setTimeout")(...rest);
}
function $e2f0a84b44552346$var$clearTimeout$1(...rest) {
    return $e2f0a84b44552346$var$getImplementation("clearTimeout")(...rest);
}
var $e2f0a84b44552346$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($e2f0a84b44552346$var$EventType || {});
var $e2f0a84b44552346$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($e2f0a84b44552346$var$IncrementalSource || {});
var $e2f0a84b44552346$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($e2f0a84b44552346$var$MouseInteractions || {});
var $e2f0a84b44552346$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($e2f0a84b44552346$var$PointerTypes || {});
function $e2f0a84b44552346$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $e2f0a84b44552346$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $e2f0a84b44552346$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $e2f0a84b44552346$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $e2f0a84b44552346$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $e2f0a84b44552346$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $e2f0a84b44552346$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $e2f0a84b44552346$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $e2f0a84b44552346$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $e2f0a84b44552346$var$IGNORED_NODE;
                while(nextId === $e2f0a84b44552346$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$e2f0a84b44552346$var$inDom(n)) return;
                const parentId = $e2f0a84b44552346$var$isShadowRoot(n.parentNode) ? this.mirror.getId($e2f0a84b44552346$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $e2f0a84b44552346$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($e2f0a84b44552346$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($e2f0a84b44552346$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($e2f0a84b44552346$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($e2f0a84b44552346$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$e2f0a84b44552346$var$isAncestorInSet(this.droppedSet, n) && !$e2f0a84b44552346$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($e2f0a84b44552346$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($e2f0a84b44552346$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$e2f0a84b44552346$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $e2f0a84b44552346$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $e2f0a84b44552346$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $e2f0a84b44552346$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $e2f0a84b44552346$var$getInputValue(target, tagName, type);
                            const isInputMasked = $e2f0a84b44552346$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $e2f0a84b44552346$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $e2f0a84b44552346$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($e2f0a84b44552346$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$e2f0a84b44552346$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $e2f0a84b44552346$var$transformAttribute(this.doc, $e2f0a84b44552346$var$toLowerCase(target.tagName), $e2f0a84b44552346$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($e2f0a84b44552346$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $e2f0a84b44552346$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($e2f0a84b44552346$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $e2f0a84b44552346$var$isIgnored(n, this.mirror) || !$e2f0a84b44552346$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $e2f0a84b44552346$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($e2f0a84b44552346$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$e2f0a84b44552346$var$moveKey(nodeId, parentId)]) $e2f0a84b44552346$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $e2f0a84b44552346$var$isShadowRoot(m.target) && $e2f0a84b44552346$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($e2f0a84b44552346$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$e2f0a84b44552346$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$e2f0a84b44552346$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($e2f0a84b44552346$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $e2f0a84b44552346$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$e2f0a84b44552346$var$deepDelete(addsSet, childN));
}
function $e2f0a84b44552346$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $e2f0a84b44552346$var$_isParentRemoved(removes, n, mirror);
}
function $e2f0a84b44552346$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $e2f0a84b44552346$var$_isParentRemoved(removes, parentNode, mirror);
}
function $e2f0a84b44552346$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $e2f0a84b44552346$var$_isAncestorInSet(set, n);
}
function $e2f0a84b44552346$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $e2f0a84b44552346$var$_isAncestorInSet(set, parentNode);
}
let $e2f0a84b44552346$var$errorHandler;
function $e2f0a84b44552346$var$registerErrorHandler(handler) {
    $e2f0a84b44552346$var$errorHandler = handler;
}
function $e2f0a84b44552346$var$unregisterErrorHandler() {
    $e2f0a84b44552346$var$errorHandler = undefined;
}
const $e2f0a84b44552346$var$callbackWrapper = (cb)=>{
    if (!$e2f0a84b44552346$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($e2f0a84b44552346$var$errorHandler && $e2f0a84b44552346$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $e2f0a84b44552346$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $e2f0a84b44552346$var$mutationBuffers = [];
function $e2f0a84b44552346$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $e2f0a84b44552346$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $e2f0a84b44552346$var$MutationBuffer();
    $e2f0a84b44552346$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $e2f0a84b44552346$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($e2f0a84b44552346$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $e2f0a84b44552346$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $e2f0a84b44552346$var$throttle$1($e2f0a84b44552346$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $e2f0a84b44552346$var$callbackWrapper($e2f0a84b44552346$var$throttle$1($e2f0a84b44552346$var$callbackWrapper((evt)=>{
        const target = $e2f0a84b44552346$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $e2f0a84b44552346$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $e2f0a84b44552346$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $e2f0a84b44552346$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $e2f0a84b44552346$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $e2f0a84b44552346$var$IncrementalSource.MouseMove : $e2f0a84b44552346$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $e2f0a84b44552346$var$on("mousemove", updatePosition, doc),
        $e2f0a84b44552346$var$on("touchmove", updatePosition, doc),
        $e2f0a84b44552346$var$on("drag", updatePosition, doc)
    ];
    return $e2f0a84b44552346$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $e2f0a84b44552346$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $e2f0a84b44552346$var$getEventTarget(event);
            if ($e2f0a84b44552346$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $e2f0a84b44552346$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $e2f0a84b44552346$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $e2f0a84b44552346$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $e2f0a84b44552346$var$PointerTypes.Touch) {
                    if ($e2f0a84b44552346$var$MouseInteractions[eventKey] === $e2f0a84b44552346$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($e2f0a84b44552346$var$MouseInteractions[eventKey] === $e2f0a84b44552346$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $e2f0a84b44552346$var$PointerTypes.Pen;
            } else if ($e2f0a84b44552346$var$legacy_isTouchEvent(event)) pointerType = $e2f0a84b44552346$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $e2f0a84b44552346$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $e2f0a84b44552346$var$PointerTypes.Mouse) pointerType = null;
            } else if ($e2f0a84b44552346$var$MouseInteractions[eventKey] === $e2f0a84b44552346$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $e2f0a84b44552346$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $e2f0a84b44552346$var$callbackWrapper(mouseInteractionCb)({
                type: $e2f0a84b44552346$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($e2f0a84b44552346$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $e2f0a84b44552346$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($e2f0a84b44552346$var$MouseInteractions[eventKey]){
            case $e2f0a84b44552346$var$MouseInteractions.MouseDown:
            case $e2f0a84b44552346$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $e2f0a84b44552346$var$MouseInteractions.TouchStart:
            case $e2f0a84b44552346$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($e2f0a84b44552346$var$on(eventName, handler, doc));
    });
    return $e2f0a84b44552346$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $e2f0a84b44552346$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $e2f0a84b44552346$var$callbackWrapper($e2f0a84b44552346$var$throttle$1($e2f0a84b44552346$var$callbackWrapper((evt)=>{
        const target = $e2f0a84b44552346$var$getEventTarget(evt);
        if (!target || $e2f0a84b44552346$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $e2f0a84b44552346$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $e2f0a84b44552346$var$on("scroll", updatePosition, doc);
}
function $e2f0a84b44552346$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $e2f0a84b44552346$var$callbackWrapper($e2f0a84b44552346$var$throttle$1($e2f0a84b44552346$var$callbackWrapper(()=>{
        const height = $e2f0a84b44552346$var$getWindowHeight();
        const width = $e2f0a84b44552346$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $e2f0a84b44552346$var$on("resize", updateDimension, win);
}
const $e2f0a84b44552346$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $e2f0a84b44552346$var$lastInputValueMap = new WeakMap();
function $e2f0a84b44552346$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $e2f0a84b44552346$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $e2f0a84b44552346$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $e2f0a84b44552346$var$INPUT_TAGS.indexOf(tagName) < 0 || $e2f0a84b44552346$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $e2f0a84b44552346$var$getInputType(target);
        let text = $e2f0a84b44552346$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $e2f0a84b44552346$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $e2f0a84b44552346$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $e2f0a84b44552346$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $e2f0a84b44552346$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $e2f0a84b44552346$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $e2f0a84b44552346$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $e2f0a84b44552346$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $e2f0a84b44552346$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$e2f0a84b44552346$var$on(eventName, $e2f0a84b44552346$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$e2f0a84b44552346$var$hookSetter(p[0], p[1], {
            set () {
                $e2f0a84b44552346$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $e2f0a84b44552346$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $e2f0a84b44552346$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($e2f0a84b44552346$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $e2f0a84b44552346$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $e2f0a84b44552346$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $e2f0a84b44552346$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $e2f0a84b44552346$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $e2f0a84b44552346$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $e2f0a84b44552346$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $e2f0a84b44552346$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $e2f0a84b44552346$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $e2f0a84b44552346$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $e2f0a84b44552346$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $e2f0a84b44552346$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $e2f0a84b44552346$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $e2f0a84b44552346$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($e2f0a84b44552346$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($e2f0a84b44552346$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($e2f0a84b44552346$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($e2f0a84b44552346$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $e2f0a84b44552346$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $e2f0a84b44552346$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$e2f0a84b44552346$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $e2f0a84b44552346$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $e2f0a84b44552346$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$e2f0a84b44552346$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $e2f0a84b44552346$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $e2f0a84b44552346$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $e2f0a84b44552346$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $e2f0a84b44552346$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $e2f0a84b44552346$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($e2f0a84b44552346$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $e2f0a84b44552346$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $e2f0a84b44552346$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $e2f0a84b44552346$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $e2f0a84b44552346$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $e2f0a84b44552346$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $e2f0a84b44552346$var$getIdAndStyleId($e2f0a84b44552346$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $e2f0a84b44552346$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $e2f0a84b44552346$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $e2f0a84b44552346$var$getIdAndStyleId($e2f0a84b44552346$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $e2f0a84b44552346$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $e2f0a84b44552346$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $e2f0a84b44552346$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $e2f0a84b44552346$var$callbackWrapper((type)=>$e2f0a84b44552346$var$throttle$1($e2f0a84b44552346$var$callbackWrapper((event)=>{
            const target = $e2f0a84b44552346$var$getEventTarget(event);
            if (!target || $e2f0a84b44552346$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $e2f0a84b44552346$var$on("play", handler(0), doc),
        $e2f0a84b44552346$var$on("pause", handler(1), doc),
        $e2f0a84b44552346$var$on("seeked", handler(2), doc),
        $e2f0a84b44552346$var$on("volumechange", handler(3), doc),
        $e2f0a84b44552346$var$on("ratechange", handler(4), doc)
    ];
    return $e2f0a84b44552346$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $e2f0a84b44552346$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $e2f0a84b44552346$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            $e2f0a84b44552346$var$setTimeout$1($e2f0a84b44552346$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $e2f0a84b44552346$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $e2f0a84b44552346$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $e2f0a84b44552346$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $e2f0a84b44552346$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $e2f0a84b44552346$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $e2f0a84b44552346$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $e2f0a84b44552346$var$on("selectionchange", updateSelection);
}
function $e2f0a84b44552346$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $e2f0a84b44552346$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $e2f0a84b44552346$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $e2f0a84b44552346$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $e2f0a84b44552346$var$initMoveObserver(o);
    const mouseInteractionHandler = $e2f0a84b44552346$var$initMouseInteractionObserver(o);
    const scrollHandler = $e2f0a84b44552346$var$initScrollObserver(o);
    const viewportResizeHandler = $e2f0a84b44552346$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $e2f0a84b44552346$var$initInputObserver(o);
    const mediaInteractionHandler = $e2f0a84b44552346$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $e2f0a84b44552346$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $e2f0a84b44552346$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $e2f0a84b44552346$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $e2f0a84b44552346$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $e2f0a84b44552346$var$initSelectionObserver(o);
    const customElementObserver = $e2f0a84b44552346$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $e2f0a84b44552346$var$callbackWrapper(()=>{
        $e2f0a84b44552346$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $e2f0a84b44552346$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $e2f0a84b44552346$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $e2f0a84b44552346$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $e2f0a84b44552346$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $e2f0a84b44552346$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $e2f0a84b44552346$var$CrossOriginIframeMirror($e2f0a84b44552346$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $e2f0a84b44552346$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $e2f0a84b44552346$var$CrossOriginIframeMirror($e2f0a84b44552346$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $e2f0a84b44552346$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $e2f0a84b44552346$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $e2f0a84b44552346$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $e2f0a84b44552346$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $e2f0a84b44552346$var$EventType.Meta:
            case $e2f0a84b44552346$var$EventType.Load:
            case $e2f0a84b44552346$var$EventType.DomContentLoaded:
                return false;
            case $e2f0a84b44552346$var$EventType.Plugin:
                return e;
            case $e2f0a84b44552346$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $e2f0a84b44552346$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $e2f0a84b44552346$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $e2f0a84b44552346$var$IncrementalSource.Drag:
                    case $e2f0a84b44552346$var$IncrementalSource.TouchMove:
                    case $e2f0a84b44552346$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $e2f0a84b44552346$var$IncrementalSource.ViewportResize:
                        return false;
                    case $e2f0a84b44552346$var$IncrementalSource.MediaInteraction:
                    case $e2f0a84b44552346$var$IncrementalSource.MouseInteraction:
                    case $e2f0a84b44552346$var$IncrementalSource.Scroll:
                    case $e2f0a84b44552346$var$IncrementalSource.CanvasMutation:
                    case $e2f0a84b44552346$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $e2f0a84b44552346$var$IncrementalSource.StyleSheetRule:
                    case $e2f0a84b44552346$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $e2f0a84b44552346$var$IncrementalSource.Font:
                        return e;
                    case $e2f0a84b44552346$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $e2f0a84b44552346$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $e2f0a84b44552346$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $e2f0a84b44552346$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $e2f0a84b44552346$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $e2f0a84b44552346$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$e2f0a84b44552346$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $e2f0a84b44552346$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($e2f0a84b44552346$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $e2f0a84b44552346$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($e2f0a84b44552346$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($e2f0a84b44552346$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $e2f0a84b44552346$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $e2f0a84b44552346$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $e2f0a84b44552346$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $e2f0a84b44552346$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $e2f0a84b44552346$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $e2f0a84b44552346$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $e2f0a84b44552346$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let $e2f0a84b44552346$var$wrappedEmit;
let $e2f0a84b44552346$var$_takeFullSnapshot;
const $e2f0a84b44552346$var$mirror = $e2f0a84b44552346$var$createMirror();
function $e2f0a84b44552346$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $e2f0a84b44552346$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $e2f0a84b44552346$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $e2f0a84b44552346$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $e2f0a84b44552346$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $e2f0a84b44552346$var$nowTimestamp();
        if ((0, $45e7406d4e8d2868$export$3cc482e6b02f32f7)([
            $e2f0a84b44552346$var$mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== $e2f0a84b44552346$var$EventType.FullSnapshot && !(e.type === $e2f0a84b44552346$var$EventType.IncrementalSnapshot && e.data.source === $e2f0a84b44552346$var$IncrementalSource.Mutation)) $e2f0a84b44552346$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $45e7406d4e8d2868$export$3cc482e6b02f32f7)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $e2f0a84b44552346$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $e2f0a84b44552346$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $e2f0a84b44552346$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $e2f0a84b44552346$var$wrappedEmit({
            type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
            data: {
                source: $e2f0a84b44552346$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$e2f0a84b44552346$var$wrappedEmit({
            type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
            data: {
                source: $e2f0a84b44552346$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$e2f0a84b44552346$var$wrappedEmit({
            type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
            data: {
                source: $e2f0a84b44552346$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$e2f0a84b44552346$var$wrappedEmit({
            type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
            data: {
                source: $e2f0a84b44552346$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $e2f0a84b44552346$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $e2f0a84b44552346$var$IframeManagerNoop() : new $e2f0a84b44552346$var$IframeManager({
        mirror: $e2f0a84b44552346$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $e2f0a84b44552346$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $e2f0a84b44552346$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $e2f0a84b44552346$var$ProcessedNodeManager();
    const canvasManager = $e2f0a84b44552346$var$_getCanvasManager(getCanvasManager, {
        mirror: $e2f0a84b44552346$var$mirror,
        win: window,
        mutationCb: (p)=>$e2f0a84b44552346$var$wrappedEmit({
                type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                data: {
                    source: $e2f0a84b44552346$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $e2f0a84b44552346$var$ShadowDomManagerNoop() : new $e2f0a84b44552346$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $e2f0a84b44552346$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        $e2f0a84b44552346$var$wrappedEmit({
            type: $e2f0a84b44552346$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $e2f0a84b44552346$var$getWindowWidth(),
                height: $e2f0a84b44552346$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $e2f0a84b44552346$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $e2f0a84b44552346$var$snapshot(document, {
            mirror: $e2f0a84b44552346$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($e2f0a84b44552346$var$isSerializedIframe(n, $e2f0a84b44552346$var$mirror)) iframeManager.addIframe(n);
                if ($e2f0a84b44552346$var$isSerializedStylesheet(n, $e2f0a84b44552346$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($e2f0a84b44552346$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $e2f0a84b44552346$var$wrappedEmit({
            type: $e2f0a84b44552346$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $e2f0a84b44552346$var$getWindowScroll(window)
            }
        });
        $e2f0a84b44552346$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $e2f0a84b44552346$var$mirror.getId(document));
    };
    $e2f0a84b44552346$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $e2f0a84b44552346$var$callbackWrapper($e2f0a84b44552346$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$e2f0a84b44552346$var$wrappedEmit({
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$e2f0a84b44552346$var$wrappedEmit({
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $e2f0a84b44552346$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$e2f0a84b44552346$var$wrappedEmit({
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $e2f0a84b44552346$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$e2f0a84b44552346$var$wrappedEmit({
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $e2f0a84b44552346$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$e2f0a84b44552346$var$wrappedEmit({
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $e2f0a84b44552346$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$e2f0a84b44552346$var$wrappedEmit({
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $e2f0a84b44552346$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$e2f0a84b44552346$var$wrappedEmit({
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $e2f0a84b44552346$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$e2f0a84b44552346$var$wrappedEmit({
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $e2f0a84b44552346$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $e2f0a84b44552346$var$wrappedEmit({
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $e2f0a84b44552346$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $e2f0a84b44552346$var$wrappedEmit({
                        type: $e2f0a84b44552346$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $e2f0a84b44552346$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $e2f0a84b44552346$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $45e7406d4e8d2868$export$3cc482e6b02f32f7)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$e2f0a84b44552346$var$wrappedEmit({
                                        type: $e2f0a84b44552346$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($e2f0a84b44552346$var$on("DOMContentLoaded", ()=>{
                $e2f0a84b44552346$var$wrappedEmit({
                    type: $e2f0a84b44552346$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($e2f0a84b44552346$var$on("load", ()=>{
                $e2f0a84b44552346$var$wrappedEmit({
                    type: $e2f0a84b44552346$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $e2f0a84b44552346$var$_takeFullSnapshot = undefined;
            $e2f0a84b44552346$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $e2f0a84b44552346$var$takeFullSnapshot(isCheckout) {
    if (!$e2f0a84b44552346$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $e2f0a84b44552346$var$_takeFullSnapshot(isCheckout);
}
$e2f0a84b44552346$var$record.mirror = $e2f0a84b44552346$var$mirror;
$e2f0a84b44552346$var$record.takeFullSnapshot = $e2f0a84b44552346$var$takeFullSnapshot;
function $e2f0a84b44552346$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $e2f0a84b44552346$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $e2f0a84b44552346$var$CanvasManagerNoop();
    }
}
const $e2f0a84b44552346$var$ReplayEventTypeIncrementalSnapshot = 3;
const $e2f0a84b44552346$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $e2f0a84b44552346$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $e2f0a84b44552346$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $e2f0a84b44552346$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $e2f0a84b44552346$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $22dd55058e9e130a$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $e2f0a84b44552346$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $e2f0a84b44552346$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($e2f0a84b44552346$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $e2f0a84b44552346$var$getClickTargetNode(event) {
    const target = $e2f0a84b44552346$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $e2f0a84b44552346$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $e2f0a84b44552346$var$getTargetNode(event) {
    if ($e2f0a84b44552346$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $e2f0a84b44552346$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $e2f0a84b44552346$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $e2f0a84b44552346$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$e2f0a84b44552346$var$handlers) {
        $e2f0a84b44552346$var$handlers = [];
        $e2f0a84b44552346$var$monkeyPatchWindowOpen();
    }
    $e2f0a84b44552346$var$handlers.push(cb);
    return ()=>{
        const pos = $e2f0a84b44552346$var$handlers ? $e2f0a84b44552346$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $e2f0a84b44552346$var$handlers.splice(pos, 1);
    };
}
function $e2f0a84b44552346$var$monkeyPatchWindowOpen() {
    (0, $a607c0e596f98f0e$export$9563e054e6f787fb)($e2f0a84b44552346$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($e2f0a84b44552346$var$handlers) try {
                $e2f0a84b44552346$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($e2f0a84b44552346$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $e2f0a84b44552346$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $e2f0a84b44552346$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $e2f0a84b44552346$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $e2f0a84b44552346$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $e2f0a84b44552346$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($e2f0a84b44552346$var$ignoreElement(node, this._ignoreSelector) || !$e2f0a84b44552346$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $e2f0a84b44552346$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $e2f0a84b44552346$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $e2f0a84b44552346$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $e2f0a84b44552346$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $e2f0a84b44552346$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $e2f0a84b44552346$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $e2f0a84b44552346$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $e2f0a84b44552346$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $e2f0a84b44552346$var$ignoreElement(node, ignoreSelector) {
    if (!$e2f0a84b44552346$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $e2f0a84b44552346$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $e2f0a84b44552346$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $e2f0a84b44552346$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$e2f0a84b44552346$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $e2f0a84b44552346$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $e2f0a84b44552346$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($e2f0a84b44552346$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $e2f0a84b44552346$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $e2f0a84b44552346$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $e2f0a84b44552346$var$isIncrementalEvent(event) {
    return event.type === $e2f0a84b44552346$var$ReplayEventTypeIncrementalSnapshot;
}
function $e2f0a84b44552346$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $e2f0a84b44552346$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $e2f0a84b44552346$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $e2f0a84b44552346$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($e2f0a84b44552346$var$NodeType || ($e2f0a84b44552346$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $e2f0a84b44552346$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $e2f0a84b44552346$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($e2f0a84b44552346$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $e2f0a84b44552346$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $e2f0a84b44552346$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $e2f0a84b44552346$var$handleClick(replay.clickDetector, result, $e2f0a84b44552346$var$getClickTargetNode(handlerData.event));
        $e2f0a84b44552346$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $e2f0a84b44552346$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $e2f0a84b44552346$var$record.mirror.getId(target);
    const node = nodeId && $e2f0a84b44552346$var$record.mirror.getNode(nodeId);
    const meta = node && $e2f0a84b44552346$var$record.mirror.getMeta(node);
    const element = meta && $e2f0a84b44552346$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $e2f0a84b44552346$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $e2f0a84b44552346$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $e2f0a84b44552346$var$handleDom(handlerData) {
    const { target: target, message: message } = $e2f0a84b44552346$var$getDomTarget(handlerData);
    return $e2f0a84b44552346$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$e2f0a84b44552346$var$getBaseDomBreadcrumb(target, message)
    });
}
function $e2f0a84b44552346$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $e2f0a84b44552346$var$getClickTargetNode(handlerData.event) : $e2f0a84b44552346$var$getTargetNode(handlerData.event);
        message = (0, $61a396c4768b6eee$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $e2f0a84b44552346$var$isElement(node) {
    return node.type === $e2f0a84b44552346$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $e2f0a84b44552346$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $e2f0a84b44552346$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $e2f0a84b44552346$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $e2f0a84b44552346$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $e2f0a84b44552346$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $61a396c4768b6eee$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $e2f0a84b44552346$var$getBaseDomBreadcrumb(target, message);
    return $e2f0a84b44552346$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $e2f0a84b44552346$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $e2f0a84b44552346$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $e2f0a84b44552346$var$createResourceEntry,
    paint: $e2f0a84b44552346$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $e2f0a84b44552346$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $e2f0a84b44552346$var$createPerformanceEntries(entries) {
    return entries.map($e2f0a84b44552346$var$createPerformanceEntry).filter(Boolean);
}
function $e2f0a84b44552346$var$createPerformanceEntry(entry) {
    if (!$e2f0a84b44552346$var$ENTRY_TYPES[entry.entryType]) return null;
    return $e2f0a84b44552346$var$ENTRY_TYPES[entry.entryType](entry);
}
function $e2f0a84b44552346$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $9394cb5a9147bec2$export$baf075a948ffc0bf) || $e2f0a84b44552346$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $e2f0a84b44552346$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $e2f0a84b44552346$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $e2f0a84b44552346$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $e2f0a84b44552346$var$getAbsoluteTime(startTime),
        end: $e2f0a84b44552346$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $e2f0a84b44552346$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $e2f0a84b44552346$var$getAbsoluteTime(startTime),
        end: $e2f0a84b44552346$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $e2f0a84b44552346$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $e2f0a84b44552346$var$getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $e2f0a84b44552346$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $e2f0a84b44552346$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $31a1d834278e4fc7$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $31a1d834278e4fc7$export$3fd4b53331200102)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($e2f0a84b44552346$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e2f0a84b44552346$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $e2f0a84b44552346$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $e2f0a84b44552346$var$e() {
    const e = new Blob([
        $e2f0a84b44552346$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $e2f0a84b44552346$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$e2f0a84b44552346$var$DEBUG_BUILD) return;
    (0, $b41a73a19cf590b7$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $e2f0a84b44552346$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $e2f0a84b44552346$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$e2f0a84b44552346$var$DEBUG_BUILD) return;
    (0, $b41a73a19cf590b7$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $e2f0a84b44552346$var$addLogBreadcrumb(message);
    }, 0);
}
function $e2f0a84b44552346$var$addLogBreadcrumb(message) {
    (0, $3db6b415fb112a98$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $e2f0a84b44552346$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$e2f0a84b44552346$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $e2f0a84b44552346$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $e2f0a84b44552346$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $e2f0a84b44552346$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $e2f0a84b44552346$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $e2f0a84b44552346$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $e2f0a84b44552346$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $e2f0a84b44552346$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $e2f0a84b44552346$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $e2f0a84b44552346$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $e2f0a84b44552346$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $e2f0a84b44552346$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $e2f0a84b44552346$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $e2f0a84b44552346$var$EventBufferArray();
        this._compression = new $e2f0a84b44552346$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $e2f0a84b44552346$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $e2f0a84b44552346$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $e2f0a84b44552346$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $e2f0a84b44552346$var$logInfo("[Replay] Using simple buffer");
    return new $e2f0a84b44552346$var$EventBufferArray();
}
function $e2f0a84b44552346$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $e2f0a84b44552346$var$_getWorkerUrl();
        if (!workerUrl) return;
        $e2f0a84b44552346$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $e2f0a84b44552346$var$EventBufferProxy(worker);
    } catch (error) {
        $e2f0a84b44552346$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $e2f0a84b44552346$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $e2f0a84b44552346$var$e();
    return "";
}
/** If sessionStorage is available. */ function $e2f0a84b44552346$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $e2f0a84b44552346$var$WINDOW && !!$e2f0a84b44552346$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $e2f0a84b44552346$var$clearSession(replay) {
    $e2f0a84b44552346$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $e2f0a84b44552346$var$deleteSession() {
    if (!$e2f0a84b44552346$var$hasSessionStorage()) return;
    try {
        $e2f0a84b44552346$var$WINDOW.sessionStorage.removeItem($e2f0a84b44552346$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $e2f0a84b44552346$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $e2f0a84b44552346$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $29b59487f55d4d6d$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $e2f0a84b44552346$var$saveSession(session) {
    if (!$e2f0a84b44552346$var$hasSessionStorage()) return;
    try {
        $e2f0a84b44552346$var$WINDOW.sessionStorage.setItem($e2f0a84b44552346$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $e2f0a84b44552346$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $e2f0a84b44552346$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $e2f0a84b44552346$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $e2f0a84b44552346$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $e2f0a84b44552346$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $e2f0a84b44552346$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $e2f0a84b44552346$var$fetchSession(traceInternals) {
    if (!$e2f0a84b44552346$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $e2f0a84b44552346$var$WINDOW.sessionStorage.getItem($e2f0a84b44552346$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $e2f0a84b44552346$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $e2f0a84b44552346$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $e2f0a84b44552346$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $e2f0a84b44552346$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $e2f0a84b44552346$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $e2f0a84b44552346$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $e2f0a84b44552346$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$e2f0a84b44552346$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $e2f0a84b44552346$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $e2f0a84b44552346$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $e2f0a84b44552346$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $e2f0a84b44552346$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$e2f0a84b44552346$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $e2f0a84b44552346$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $e2f0a84b44552346$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $e2f0a84b44552346$var$isCustomEvent(event) {
    return event.type === $e2f0a84b44552346$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $e2f0a84b44552346$var$addEventSync(replay, event, isCheckout) {
    if (!$e2f0a84b44552346$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $e2f0a84b44552346$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $e2f0a84b44552346$var$addEvent(replay, event, isCheckout) {
    if (!$e2f0a84b44552346$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $e2f0a84b44552346$var$_addEvent(replay, event, isCheckout);
}
async function $e2f0a84b44552346$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $e2f0a84b44552346$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $e2f0a84b44552346$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $e2f0a84b44552346$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $e2f0a84b44552346$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $e2f0a84b44552346$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $e2f0a84b44552346$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $e2f0a84b44552346$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $e2f0a84b44552346$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $e2f0a84b44552346$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $e2f0a84b44552346$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $e2f0a84b44552346$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $e2f0a84b44552346$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $e2f0a84b44552346$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$e2f0a84b44552346$var$isErrorEvent(event) && !$e2f0a84b44552346$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($e2f0a84b44552346$var$isTransactionEvent(event)) {
            $e2f0a84b44552346$var$handleTransactionEvent(replay, event);
            return;
        }
        $e2f0a84b44552346$var$handleErrorEvent(replay, event);
    };
}
function $e2f0a84b44552346$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $e2f0a84b44552346$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $e2f0a84b44552346$var$isBaseTransportSend() {
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $e2f0a84b44552346$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$e2f0a84b44552346$var$isErrorEvent(event)) return;
        $e2f0a84b44552346$var$handleHydrationError(replay, event);
    };
}
function $e2f0a84b44552346$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $e2f0a84b44552346$var$createBreadcrumb({
            category: "replay.hydrate-error"
        });
        $e2f0a84b44552346$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $e2f0a84b44552346$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $e2f0a84b44552346$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $e2f0a84b44552346$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $e2f0a84b44552346$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $e2f0a84b44552346$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $e2f0a84b44552346$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $e2f0a84b44552346$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $e2f0a84b44552346$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($e2f0a84b44552346$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$e2f0a84b44552346$var$isErrorEvent(event) && !$e2f0a84b44552346$var$isTransactionEvent(event) && !$e2f0a84b44552346$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($e2f0a84b44552346$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $e2f0a84b44552346$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($e2f0a84b44552346$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $e2f0a84b44552346$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $e2f0a84b44552346$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $e2f0a84b44552346$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $e2f0a84b44552346$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $e2f0a84b44552346$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $e2f0a84b44552346$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $e2f0a84b44552346$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $e2f0a84b44552346$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($e2f0a84b44552346$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $7b20f9262c86507a$export$d92e61f5600202af)(url, (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $e2f0a84b44552346$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($e2f0a84b44552346$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $e2f0a84b44552346$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $e2f0a84b44552346$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $e2f0a84b44552346$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $e2f0a84b44552346$var$handleFetch(handlerData);
        $e2f0a84b44552346$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $e2f0a84b44552346$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $6324c6a4679c00bc$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $e2f0a84b44552346$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $e2f0a84b44552346$var$handleXhr(handlerData);
        $e2f0a84b44552346$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $e2f0a84b44552346$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $e2f0a84b44552346$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $e2f0a84b44552346$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $e2f0a84b44552346$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $e2f0a84b44552346$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $e2f0a84b44552346$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $e2f0a84b44552346$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $a607c0e596f98f0e$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $e2f0a84b44552346$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $e2f0a84b44552346$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $e2f0a84b44552346$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $e2f0a84b44552346$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $e2f0a84b44552346$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $e2f0a84b44552346$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $e2f0a84b44552346$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $e2f0a84b44552346$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $e2f0a84b44552346$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $e2f0a84b44552346$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $e2f0a84b44552346$var$urlMatches(url, urls) {
    const fullUrl = $e2f0a84b44552346$var$getFullUrl(url);
    return (0, $7c3b646f45fbc7a6$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $e2f0a84b44552346$var$getFullUrl(url, baseURI = $e2f0a84b44552346$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($e2f0a84b44552346$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $e2f0a84b44552346$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $e2f0a84b44552346$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $e2f0a84b44552346$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $e2f0a84b44552346$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $e2f0a84b44552346$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $e2f0a84b44552346$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $e2f0a84b44552346$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $e2f0a84b44552346$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $e2f0a84b44552346$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $e2f0a84b44552346$var$urlMatches(url, options.networkDetailAllowUrls) && !$e2f0a84b44552346$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $e2f0a84b44552346$var$_getRequestInfo(options, hint.input, requestBodySize) : $e2f0a84b44552346$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $e2f0a84b44552346$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $e2f0a84b44552346$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $e2f0a84b44552346$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $e2f0a84b44552346$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $e2f0a84b44552346$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $e2f0a84b44552346$var$getBodyString(requestBody);
    const data = $e2f0a84b44552346$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $e2f0a84b44552346$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $e2f0a84b44552346$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $e2f0a84b44552346$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $e2f0a84b44552346$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $e2f0a84b44552346$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $e2f0a84b44552346$var$_parseFetchResponseBody(response);
    const result = $e2f0a84b44552346$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $e2f0a84b44552346$var$mergeWarning(result, warning);
    return result;
}
function $e2f0a84b44552346$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $e2f0a84b44552346$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $e2f0a84b44552346$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $e2f0a84b44552346$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $e2f0a84b44552346$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return $e2f0a84b44552346$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $e2f0a84b44552346$var$_parseFetchResponseBody(response) {
    const res = $e2f0a84b44552346$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $e2f0a84b44552346$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $e2f0a84b44552346$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $e2f0a84b44552346$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $e2f0a84b44552346$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $e2f0a84b44552346$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $e2f0a84b44552346$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $e2f0a84b44552346$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $e2f0a84b44552346$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $e2f0a84b44552346$var$getAllowedHeaders(headers, allowedHeaders);
}
function $e2f0a84b44552346$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $e2f0a84b44552346$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $e2f0a84b44552346$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $e2f0a84b44552346$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $e2f0a84b44552346$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $e2f0a84b44552346$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $e2f0a84b44552346$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $e2f0a84b44552346$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $e2f0a84b44552346$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $e2f0a84b44552346$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $e2f0a84b44552346$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $e2f0a84b44552346$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $e2f0a84b44552346$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$e2f0a84b44552346$var$urlMatches(url, options.networkDetailAllowUrls) || $e2f0a84b44552346$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $e2f0a84b44552346$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $e2f0a84b44552346$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $6324c6a4679c00bc$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $e2f0a84b44552346$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $e2f0a84b44552346$var$getAllowedHeaders($e2f0a84b44552346$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $e2f0a84b44552346$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $e2f0a84b44552346$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $e2f0a84b44552346$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $e2f0a84b44552346$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $e2f0a84b44552346$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $e2f0a84b44552346$var$mergeWarning(response, responseWarning) : response
    };
}
function $e2f0a84b44552346$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $e2f0a84b44552346$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $e2f0a84b44552346$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $e2f0a84b44552346$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $e2f0a84b44552346$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $e2f0a84b44552346$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $e2f0a84b44552346$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$e2f0a84b44552346$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $6f452264ed38498f$export$f75d3c772c923df0)($e2f0a84b44552346$var$handleFetchSpanListener(replay));
            (0, $6324c6a4679c00bc$export$26ace48dd54c9aea)($e2f0a84b44552346$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $e2f0a84b44552346$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($e2f0a84b44552346$var$_isXhrBreadcrumb(breadcrumb) && $e2f0a84b44552346$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $e2f0a84b44552346$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $e2f0a84b44552346$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($e2f0a84b44552346$var$_isFetchBreadcrumb(breadcrumb) && $e2f0a84b44552346$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $e2f0a84b44552346$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $e2f0a84b44552346$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("Error when enriching network breadcrumb");
    }
}
function $e2f0a84b44552346$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $e2f0a84b44552346$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $e2f0a84b44552346$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $e2f0a84b44552346$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $e2f0a84b44552346$var$_LAST_BREADCRUMB = null;
function $e2f0a84b44552346$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $e2f0a84b44552346$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $e2f0a84b44552346$var$handleScope(scope);
        if (!result) return;
        $e2f0a84b44552346$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $e2f0a84b44552346$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($e2f0a84b44552346$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $e2f0a84b44552346$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$e2f0a84b44552346$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return $e2f0a84b44552346$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $e2f0a84b44552346$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $e2f0a84b44552346$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $e2f0a84b44552346$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $e2f0a84b44552346$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $e2f0a84b44552346$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $22dd55058e9e130a$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $e2f0a84b44552346$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $e2f0a84b44552346$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $e2f0a84b44552346$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $e2f0a84b44552346$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $3db6b415fb112a98$export$c7be4b0125a10cba)();
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    scope.addScopeListener($e2f0a84b44552346$var$handleScopeListener(replay));
    (0, $13156ec00db7db00$export$5aeffd3db2cf9df7)($e2f0a84b44552346$var$handleDomListener(replay));
    (0, $ad8d7abadbaf360a$export$3f18c56c58114e75)($e2f0a84b44552346$var$handleHistorySpanListener(replay));
    $e2f0a84b44552346$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $e2f0a84b44552346$var$handleGlobalEventListener(replay, !$e2f0a84b44552346$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $465c00039fff35ce$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($e2f0a84b44552346$var$hasHooks(client)) {
        client.on("beforeSendEvent", $e2f0a84b44552346$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $e2f0a84b44552346$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e2f0a84b44552346$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $e2f0a84b44552346$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($e2f0a84b44552346$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $e2f0a84b44552346$var$createMemoryEntry($e2f0a84b44552346$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $e2f0a84b44552346$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $e2f0a84b44552346$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $e2f0a84b44552346$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $e2f0a84b44552346$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$e2f0a84b44552346$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $e2f0a84b44552346$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $e2f0a84b44552346$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $e2f0a84b44552346$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $e2f0a84b44552346$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $e2f0a84b44552346$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $e2f0a84b44552346$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $e2f0a84b44552346$var$addEventSync(replay, $e2f0a84b44552346$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $e2f0a84b44552346$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $ff4effe96b979cde$export$f93f7f385160c44e)((0, $ff4effe96b979cde$export$92b6093782fe661b)(replayEvent, (0, $ff4effe96b979cde$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $e2f0a84b44552346$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $e2f0a84b44552346$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $396e448d0bac3ce2$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $81a5bf896f2147fb$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $e2f0a84b44552346$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $e2f0a84b44552346$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    const scope = (0, $3db6b415fb112a98$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $e2f0a84b44552346$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $e2f0a84b44552346$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $e2f0a84b44552346$var$logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $e2f0a84b44552346$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($e2f0a84b44552346$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $e2f0a84b44552346$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $4a51996874e47461$export$699aff705e0d49d4)({}, response);
    if ((0, $4a51996874e47461$export$6c91fec22056810a)(rateLimits, "replay")) throw new $e2f0a84b44552346$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $e2f0a84b44552346$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $e2f0a84b44552346$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $e2f0a84b44552346$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $e2f0a84b44552346$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $e2f0a84b44552346$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $e2f0a84b44552346$var$TransportStatusCodeError || err instanceof $e2f0a84b44552346$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $3db6b415fb112a98$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if ($e2f0a84b44552346$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $3db6b415fb112a98$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $e2f0a84b44552346$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$e2f0a84b44552346$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $e2f0a84b44552346$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $e2f0a84b44552346$var$THROTTLED = "__THROTTLED";
const $e2f0a84b44552346$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e2f0a84b44552346$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $e2f0a84b44552346$var$SKIPPED : $e2f0a84b44552346$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $e2f0a84b44552346$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $e2f0a84b44552346$var$ReplayContainer.prototype.__init.call(this);
        $e2f0a84b44552346$var$ReplayContainer.prototype.__init2.call(this);
        $e2f0a84b44552346$var$ReplayContainer.prototype.__init3.call(this);
        $e2f0a84b44552346$var$ReplayContainer.prototype.__init4.call(this);
        $e2f0a84b44552346$var$ReplayContainer.prototype.__init5.call(this);
        $e2f0a84b44552346$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $e2f0a84b44552346$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $e2f0a84b44552346$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $e2f0a84b44552346$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $e2f0a84b44552346$var$throttle((event, isCheckout)=>$e2f0a84b44552346$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($e2f0a84b44552346$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $e2f0a84b44552346$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $e2f0a84b44552346$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $e2f0a84b44552346$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $e2f0a84b44552346$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $e2f0a84b44552346$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $e2f0a84b44552346$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $e2f0a84b44552346$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $e2f0a84b44552346$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $e2f0a84b44552346$var$BUFFER_CHECKOUT_TIME
                },
                emit: $e2f0a84b44552346$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $e2f0a84b44552346$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $e2f0a84b44552346$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $e2f0a84b44552346$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $e2f0a84b44552346$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $e2f0a84b44552346$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $e2f0a84b44552346$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$e2f0a84b44552346$var$WINDOW.location.pathname}${$e2f0a84b44552346$var$WINDOW.location.hash}${$e2f0a84b44552346$var$WINDOW.location.search}`;
        const url = `${$e2f0a84b44552346$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $e2f0a84b44552346$var$THROTTLED) {
            const breadcrumb = $e2f0a84b44552346$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$e2f0a84b44552346$var$addEventSync(this, {
                    type: $e2f0a84b44552346$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $3db6b415fb112a98$export$c7be4b0125a10cba)().getTransaction();
        const attributes = lastTransaction && (0, $671479e013e13387$export$92d8c23565496537)(lastTransaction).data || {};
        const source = attributes[0, $b64cf2cfbf638e41$export$d7a7d984b0791405];
        if (!lastTransaction || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $671479e013e13387$export$92d8c23565496537)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $e2f0a84b44552346$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("[Replay]", error);
        if ($e2f0a84b44552346$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $3db6b415fb112a98$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $e2f0a84b44552346$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($e2f0a84b44552346$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $e2f0a84b44552346$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $e2f0a84b44552346$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $e2f0a84b44552346$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $e2f0a84b44552346$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $e2f0a84b44552346$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $e2f0a84b44552346$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $e2f0a84b44552346$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $e2f0a84b44552346$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $e2f0a84b44552346$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $e2f0a84b44552346$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($e2f0a84b44552346$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $e2f0a84b44552346$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $e2f0a84b44552346$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $e2f0a84b44552346$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $e2f0a84b44552346$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $e2f0a84b44552346$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $e2f0a84b44552346$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $e2f0a84b44552346$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($e2f0a84b44552346$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $e2f0a84b44552346$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $e2f0a84b44552346$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $e2f0a84b44552346$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $e2f0a84b44552346$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $e2f0a84b44552346$var$DEBUG_BUILD && (0, $b41a73a19cf590b7$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $e2f0a84b44552346$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $e2f0a84b44552346$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $e2f0a84b44552346$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        (0, $b41a73a19cf590b7$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
        });
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $e2f0a84b44552346$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $e2f0a84b44552346$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $e2f0a84b44552346$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $e2f0a84b44552346$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $e2f0a84b44552346$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $e2f0a84b44552346$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $e2f0a84b44552346$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $e2f0a84b44552346$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $e2f0a84b44552346$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $e2f0a84b44552346$var$_initialized = false;
const $e2f0a84b44552346$export$2832a2ae028f5e28 = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $e2f0a84b44552346$export$6b59b88de1ff9cb7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $e2f0a84b44552346$export$6b59b88de1ff9cb7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $e2f0a84b44552346$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $e2f0a84b44552346$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $e2f0a84b44552346$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $e2f0a84b44552346$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $e2f0a84b44552346$export$6b59b88de1ff9cb7.id;
        const privacyOptions = $e2f0a84b44552346$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$e2f0a84b44552346$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $e2f0a84b44552346$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $e2f0a84b44552346$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $e2f0a84b44552346$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $e2f0a84b44552346$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $e2f0a84b44552346$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$e2f0a84b44552346$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $4a89a3c7e0a00992$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $e2f0a84b44552346$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $e2f0a84b44552346$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $4a89a3c7e0a00992$export$4e09c449d6c407f7)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $e2f0a84b44552346$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $e2f0a84b44552346$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$e2f0a84b44552346$export$6b59b88de1ff9cb7.__initStatic();
/** Parse Replay-related options from SDK options */ function $e2f0a84b44552346$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $a607c0e596f98f0e$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        (0, $b41a73a19cf590b7$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $b41a73a19cf590b7$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $e2f0a84b44552346$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$e2f0a84b44552346$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $e2f0a84b44552346$export$81cc0d0f72285d1() {
    const client = (0, $3db6b415fb112a98$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName && client.getIntegrationByName("Replay");
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $e2f0a84b44552346$export$b28310b2f161456b = $e2f0a84b44552346$export$81cc0d0f72285d1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ const $e2f0a84b44552346$export$d7706faf7ab354bf = $e2f0a84b44552346$export$2832a2ae028f5e28;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
class $e2f0a84b44552346$export$a35c789ed37ee0f7 extends $e2f0a84b44552346$export$6b59b88de1ff9cb7 {
}




const $73971d057111abc9$var$INTEGRATION_NAME = "CaptureConsole";
const $73971d057111abc9$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, $b41a73a19cf590b7$export$2a2b1d2252a69ecb);
    return {
        name: $73971d057111abc9$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (!("console" in (0, $9f77e1e9786bb6f1$export$f1a6cdb1459e81d1))) return;
            (0, $5c42b873ac7c2926$export$1d6e0d073f9e6723)(({ args: args, level: level })=>{
                if ((0, $3db6b415fb112a98$export$6bb76d6eba7e258c)() !== client || !levels.includes(level)) return;
                $73971d057111abc9$var$consoleHandler(args, level);
            });
        }
    };
};
const $73971d057111abc9$export$caa9b6c4a4144db4 = (0, $c4d1b7c490359157$export$2323046b9414659f)($73971d057111abc9$var$_captureConsoleIntegration);
/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $73971d057111abc9$export$25a43cb5b5c58c08 = (0, $c4d1b7c490359157$export$afa219bf23651160)($73971d057111abc9$var$INTEGRATION_NAME, $73971d057111abc9$export$caa9b6c4a4144db4);
function $73971d057111abc9$var$consoleHandler(args, level) {
    const captureContext = {
        level: (0, $418805b2b882b689$export$d771ef054122c30a)(level),
        extra: {
            arguments: args
        }
    };
    (0, $3db6b415fb112a98$export$ec58d9285c204497)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = "console";
            (0, $29b59487f55d4d6d$export$c69a9a0313b03bb1)(event, {
                handled: false,
                type: "console"
            });
            return event;
        });
        if (level === "assert" && args[0] === false) {
            const message = `Assertion failed: ${(0, $7c3b646f45fbc7a6$export$465e9d514283d4fd)(args.slice(1), " ") || "console.assert"}`;
            scope.setExtra("arguments", args.slice(1));
            (0, $3db6b415fb112a98$export$45654777c133ae80)(message, captureContext);
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (level === "error" && error) {
            (0, $3db6b415fb112a98$export$f5282963edea4a68)(error, captureContext);
            return;
        }
        const message = (0, $7c3b646f45fbc7a6$export$465e9d514283d4fd)(args, " ");
        (0, $3db6b415fb112a98$export$45654777c133ae80)(message, captureContext);
    });
}


parcelRequire("bnENU");
var $a818400b9257b505$export$882461b6382ed46c;
var $a818400b9257b505$export$757ceba2d55c277e;
"use strict";
var $93b772b00f04f226$exports = {};
"use strict";
function $93b772b00f04f226$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($93b772b00f04f226$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$93b772b00f04f226$var$checkDCE();

$93b772b00f04f226$exports = (parcelRequire("34ehV"));


var $a818400b9257b505$var$i;
$a818400b9257b505$export$882461b6382ed46c = $93b772b00f04f226$exports.createRoot;
$a818400b9257b505$export$757ceba2d55c277e = $93b772b00f04f226$exports.hydrateRoot;



parcelRequire("bnENU");

var $bnENU = parcelRequire("bnENU");
let $4df2ddb463d53338$var$isReconnecting = false;
async function $4df2ddb463d53338$export$f0e7018a430fa792(config, parameters = {}) {
    // If already reconnecting, do nothing
    if ($4df2ddb463d53338$var$isReconnecting) return [];
    $4df2ddb463d53338$var$isReconnecting = true;
    config.setState((x)=>({
            ...x,
            status: x.current ? "reconnecting" : "connecting"
        }));
    const connectors = [];
    if (parameters.connectors?.length) for (const connector_ of parameters.connectors){
        let connector;
        // "Register" connector if not already created
        if (typeof connector_ === "function") connector = config._internal.connectors.setup(connector_);
        else connector = connector_;
        connectors.push(connector);
    }
    else connectors.push(...config.connectors);
    // Try recently-used connectors first
    let recentConnectorId;
    try {
        recentConnectorId = await config.storage?.getItem("recentConnectorId");
    } catch  {}
    const scores = {};
    for (const [, connection] of config.state.connections)scores[connection.connector.id] = 1;
    if (recentConnectorId) scores[recentConnectorId] = 0;
    const sorted = Object.keys(scores).length > 0 ? [
        ...connectors
    ].sort((a, b)=>(scores[a.id] ?? 10) - (scores[b.id] ?? 10)) : connectors;
    // Iterate through each connector and try to connect
    let connected = false;
    const connections = [];
    const providers = [];
    for (const connector of sorted){
        const provider = await connector.getProvider().catch(()=>undefined);
        if (!provider) continue;
        // If we already have an instance of this connector's provider,
        // then we have already checked it (ie. injected connectors can
        // share the same `window.ethereum` instance, so we don't want to
        // connect to it again).
        if (providers.some((x)=>x === provider)) continue;
        const isAuthorized = await connector.isAuthorized();
        if (!isAuthorized) continue;
        const data = await connector.connect({
            isReconnecting: true
        }).catch(()=>null);
        if (!data) continue;
        connector.emitter.off("connect", config._internal.events.connect);
        connector.emitter.on("change", config._internal.events.change);
        connector.emitter.on("disconnect", config._internal.events.disconnect);
        config.setState((x)=>{
            const connections = new Map(connected ? x.connections : new Map()).set(connector.uid, {
                accounts: data.accounts,
                chainId: data.chainId,
                connector: connector
            });
            return {
                ...x,
                current: connected ? x.current : connector.uid,
                connections: connections
            };
        });
        connections.push({
            accounts: data.accounts,
            chainId: data.chainId,
            connector: connector
        });
        providers.push(provider);
        connected = true;
    }
    // Prevent overwriting connected status from race condition
    if (config.state.status === "reconnecting" || config.state.status === "connecting") {
        // If connecting didn't succeed, set to disconnected
        if (!connected) config.setState((x)=>({
                ...x,
                connections: new Map(),
                current: null,
                status: "disconnected"
            }));
        else config.setState((x)=>({
                ...x,
                status: "connected"
            }));
    }
    $4df2ddb463d53338$var$isReconnecting = false;
    return connections;
}


function $a2cffef46ed94abf$export$fa8d919ba61d84db(config, parameters) {
    const { initialState: initialState, reconnectOnMount: reconnectOnMount } = parameters;
    if (initialState && !config._internal.store.persist.hasHydrated()) config.setState({
        ...initialState,
        chainId: config.chains.some((x)=>x.id === initialState.chainId) ? initialState.chainId : config.chains[0].id,
        connections: reconnectOnMount ? initialState.connections : new Map(),
        status: reconnectOnMount ? "reconnecting" : "disconnected"
    });
    return {
        async onMount () {
            if (config._internal.ssr) {
                await config._internal.store.persist.rehydrate();
                if (config._internal.mipd) config._internal.connectors.setState((connectors)=>{
                    const rdnsSet = new Set();
                    for (const connector of connectors ?? [])if (connector.rdns) {
                        const rdnsValues = Array.isArray(connector.rdns) ? connector.rdns : [
                            connector.rdns
                        ];
                        for (const rdns of rdnsValues)rdnsSet.add(rdns);
                    }
                    const mipdConnectors = [];
                    const providers = config._internal.mipd?.getProviders() ?? [];
                    for (const provider of providers){
                        if (rdnsSet.has(provider.info.rdns)) continue;
                        const connectorFn = config._internal.connectors.providerDetailToConnector(provider);
                        const connector = config._internal.connectors.setup(connectorFn);
                        mipdConnectors.push(connector);
                    }
                    return [
                        ...connectors,
                        ...mipdConnectors
                    ];
                });
            }
            if (reconnectOnMount) (0, $4df2ddb463d53338$export$f0e7018a430fa792)(config);
            else if (config.storage) // Reset connections that may have been hydrated from storage.
            config.setState((x)=>({
                    ...x,
                    connections: new Map()
                }));
        }
    };
}



var $bnENU = parcelRequire("bnENU");
"use client";
function $94094c232692426b$export$f49feec8afe53ddd(parameters) {
    const { children: children, config: config, initialState: initialState, reconnectOnMount: reconnectOnMount = true } = parameters;
    const { onMount: onMount } = (0, $a2cffef46ed94abf$export$fa8d919ba61d84db)(config, {
        initialState: initialState,
        reconnectOnMount: reconnectOnMount
    });
    // Hydrate for non-SSR
    if (!config._internal.ssr) onMount();
    // Hydrate for SSR
    const active = (0, $bnENU.useRef)(true);
    // biome-ignore lint/correctness/useExhaustiveDependencies: `queryKey` not required
    (0, $bnENU.useEffect)(()=>{
        if (!active.current) return;
        if (!config._internal.ssr) return;
        onMount();
        return ()=>{
            active.current = false;
        };
    }, []);
    return children;
}


"use client";
const $91be27bdcb92956c$export$da7c16611087c70c = (0, $bnENU.createContext)(undefined);
function $91be27bdcb92956c$export$a28463dc600bc9f8(parameters) {
    const { children: children, config: config } = parameters;
    const props = {
        value: config
    };
    return (0, $bnENU.createElement)((0, $94094c232692426b$export$f49feec8afe53ddd), parameters, (0, $bnENU.createElement)($91be27bdcb92956c$export$da7c16611087c70c.Provider, props, children));
}


/**
 * React Router DOM v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bnENU = parcelRequire("bnENU");

/**
 * @remix-run/router v1.16.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $330c05c147b5954a$var$_extends() {
    $330c05c147b5954a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $330c05c147b5954a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $330c05c147b5954a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($330c05c147b5954a$export$e19cd5f9376f8cee || ($330c05c147b5954a$export$e19cd5f9376f8cee = {}));
const $330c05c147b5954a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $330c05c147b5954a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $330c05c147b5954a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $330c05c147b5954a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $330c05c147b5954a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $330c05c147b5954a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $330c05c147b5954a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $330c05c147b5954a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $330c05c147b5954a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $330c05c147b5954a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $330c05c147b5954a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $330c05c147b5954a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $330c05c147b5954a$export$fe53371bee54353d(to);
    }
    return $330c05c147b5954a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $330c05c147b5954a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $330c05c147b5954a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $330c05c147b5954a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $330c05c147b5954a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $330c05c147b5954a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $330c05c147b5954a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $330c05c147b5954a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $330c05c147b5954a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $330c05c147b5954a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $330c05c147b5954a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $330c05c147b5954a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $330c05c147b5954a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $330c05c147b5954a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $330c05c147b5954a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $330c05c147b5954a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $330c05c147b5954a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $330c05c147b5954a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $330c05c147b5954a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($330c05c147b5954a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $330c05c147b5954a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $330c05c147b5954a$export$e19cd5f9376f8cee.Push;
        let location = $330c05c147b5954a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $330c05c147b5954a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $330c05c147b5954a$export$e19cd5f9376f8cee.Replace;
        let location = $330c05c147b5954a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $330c05c147b5954a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $330c05c147b5954a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $330c05c147b5954a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($330c05c147b5954a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($330c05c147b5954a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $330c05c147b5954a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($330c05c147b5954a$var$ResultType || ($330c05c147b5954a$var$ResultType = {}));
const $330c05c147b5954a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $330c05c147b5954a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $330c05c147b5954a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $330c05c147b5954a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $330c05c147b5954a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($330c05c147b5954a$var$isIndexRoute(route)) {
            let indexRoute = $330c05c147b5954a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $330c05c147b5954a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $330c05c147b5954a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $330c05c147b5954a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $330c05c147b5954a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $330c05c147b5954a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $330c05c147b5954a$var$flattenRoutes(routes);
    $330c05c147b5954a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $330c05c147b5954a$var$decodePath(pathname);
        matches = $330c05c147b5954a$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $330c05c147b5954a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $330c05c147b5954a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $330c05c147b5954a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $330c05c147b5954a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $330c05c147b5954a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $330c05c147b5954a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $330c05c147b5954a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $330c05c147b5954a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $330c05c147b5954a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $330c05c147b5954a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $330c05c147b5954a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $330c05c147b5954a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $330c05c147b5954a$var$paramRe = /^:[\w-]+$/;
const $330c05c147b5954a$var$dynamicSegmentValue = 3;
const $330c05c147b5954a$var$indexRouteValue = 2;
const $330c05c147b5954a$var$emptySegmentValue = 1;
const $330c05c147b5954a$var$staticSegmentValue = 10;
const $330c05c147b5954a$var$splatPenalty = -2;
const $330c05c147b5954a$var$isSplat = (s)=>s === "*";
function $330c05c147b5954a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($330c05c147b5954a$var$isSplat)) initialScore += $330c05c147b5954a$var$splatPenalty;
    if (index) initialScore += $330c05c147b5954a$var$indexRouteValue;
    return segments.filter((s)=>!$330c05c147b5954a$var$isSplat(s)).reduce((score, segment)=>score + ($330c05c147b5954a$var$paramRe.test(segment) ? $330c05c147b5954a$var$dynamicSegmentValue : segment === "" ? $330c05c147b5954a$var$emptySegmentValue : $330c05c147b5954a$var$staticSegmentValue), initialScore);
}
function $330c05c147b5954a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $330c05c147b5954a$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $330c05c147b5954a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $330c05c147b5954a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $330c05c147b5954a$export$a5c6d149b50c1d86($330c05c147b5954a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $330c05c147b5954a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $330c05c147b5954a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $330c05c147b5954a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $330c05c147b5954a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $330c05c147b5954a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $330c05c147b5954a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $330c05c147b5954a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $330c05c147b5954a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $330c05c147b5954a$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $330c05c147b5954a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $330c05c147b5954a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $330c05c147b5954a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $330c05c147b5954a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $330c05c147b5954a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $330c05c147b5954a$var$normalizeSearch(search),
        hash: $330c05c147b5954a$var$normalizeHash(hash)
    };
}
function $330c05c147b5954a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $330c05c147b5954a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $330c05c147b5954a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $330c05c147b5954a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $330c05c147b5954a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $330c05c147b5954a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $330c05c147b5954a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $330c05c147b5954a$var$_extends({}, toArg);
        $330c05c147b5954a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $330c05c147b5954a$var$getInvalidPathError("?", "pathname", "search", to));
        $330c05c147b5954a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $330c05c147b5954a$var$getInvalidPathError("#", "pathname", "hash", to));
        $330c05c147b5954a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $330c05c147b5954a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $330c05c147b5954a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $330c05c147b5954a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $330c05c147b5954a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $330c05c147b5954a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $330c05c147b5954a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $330c05c147b5954a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $330c05c147b5954a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $330c05c147b5954a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $330c05c147b5954a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $330c05c147b5954a$export$42a99a7a4bc0e76a extends Error {
}
class $330c05c147b5954a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $330c05c147b5954a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $330c05c147b5954a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $330c05c147b5954a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $330c05c147b5954a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $330c05c147b5954a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $330c05c147b5954a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $330c05c147b5954a$var$unwrapTrackedPromise(value) {
    if (!$330c05c147b5954a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $330c05c147b5954a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $330c05c147b5954a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $330c05c147b5954a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $330c05c147b5954a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $330c05c147b5954a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $330c05c147b5954a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $330c05c147b5954a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $330c05c147b5954a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $330c05c147b5954a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $330c05c147b5954a$var$validMutationMethods = new Set($330c05c147b5954a$var$validMutationMethodsArr);
const $330c05c147b5954a$var$validRequestMethodsArr = [
    "get",
    ...$330c05c147b5954a$var$validMutationMethodsArr
];
const $330c05c147b5954a$var$validRequestMethods = new Set($330c05c147b5954a$var$validRequestMethodsArr);
const $330c05c147b5954a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $330c05c147b5954a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $330c05c147b5954a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $330c05c147b5954a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $330c05c147b5954a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $330c05c147b5954a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $330c05c147b5954a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $330c05c147b5954a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $330c05c147b5954a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $330c05c147b5954a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $330c05c147b5954a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $330c05c147b5954a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $330c05c147b5954a$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $330c05c147b5954a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $330c05c147b5954a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $330c05c147b5954a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $330c05c147b5954a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $330c05c147b5954a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $330c05c147b5954a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $330c05c147b5954a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $330c05c147b5954a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $330c05c147b5954a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$330c05c147b5954a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($330c05c147b5954a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $330c05c147b5954a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $330c05c147b5954a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $330c05c147b5954a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $330c05c147b5954a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $330c05c147b5954a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $330c05c147b5954a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $330c05c147b5954a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $330c05c147b5954a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $330c05c147b5954a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($330c05c147b5954a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $330c05c147b5954a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $330c05c147b5954a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $330c05c147b5954a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $330c05c147b5954a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $330c05c147b5954a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $330c05c147b5954a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $330c05c147b5954a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $330c05c147b5954a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $330c05c147b5954a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $330c05c147b5954a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $330c05c147b5954a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $330c05c147b5954a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $330c05c147b5954a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $330c05c147b5954a$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $330c05c147b5954a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $330c05c147b5954a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $330c05c147b5954a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $330c05c147b5954a$var$findNearestBoundary(matches).route.id,
            {
                type: $330c05c147b5954a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $330c05c147b5954a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $330c05c147b5954a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $330c05c147b5954a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $330c05c147b5954a$var$_extends({
            matches: matches
        }, $330c05c147b5954a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $330c05c147b5954a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $330c05c147b5954a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $330c05c147b5954a$var$ResultType.error,
            error: $330c05c147b5954a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($330c05c147b5954a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $330c05c147b5954a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($330c05c147b5954a$var$isDeferredResult(result)) throw $330c05c147b5954a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($330c05c147b5954a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $330c05c147b5954a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $330c05c147b5954a$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $330c05c147b5954a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $330c05c147b5954a$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $330c05c147b5954a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $330c05c147b5954a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $330c05c147b5954a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $330c05c147b5954a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $330c05c147b5954a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$330c05c147b5954a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($330c05c147b5954a$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $330c05c147b5954a$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $330c05c147b5954a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $330c05c147b5954a$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $330c05c147b5954a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $330c05c147b5954a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $330c05c147b5954a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $330c05c147b5954a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $330c05c147b5954a$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $330c05c147b5954a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $330c05c147b5954a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $330c05c147b5954a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $330c05c147b5954a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($330c05c147b5954a$var$isRedirectResult(actionResult) || $330c05c147b5954a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $330c05c147b5954a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($330c05c147b5954a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $330c05c147b5954a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $330c05c147b5954a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($330c05c147b5954a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($330c05c147b5954a$var$isDeferredResult(actionResult)) throw $330c05c147b5954a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $330c05c147b5954a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $330c05c147b5954a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $330c05c147b5954a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $330c05c147b5954a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $330c05c147b5954a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $330c05c147b5954a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $330c05c147b5954a$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $330c05c147b5954a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $330c05c147b5954a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $330c05c147b5954a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $330c05c147b5954a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $330c05c147b5954a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $330c05c147b5954a$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($330c05c147b5954a$var$isDeferredResult(result)) result = await $330c05c147b5954a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $330c05c147b5954a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($330c05c147b5954a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $330c05c147b5954a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($330c05c147b5954a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $330c05c147b5954a$export$3e9cee6b33872309(!$330c05c147b5954a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $330c05c147b5954a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $330c05c147b5954a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $330c05c147b5954a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $330c05c147b5954a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($330c05c147b5954a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $330c05c147b5954a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $330c05c147b5954a$export$e19cd5f9376f8cee.Replace : $330c05c147b5954a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $330c05c147b5954a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($330c05c147b5954a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $330c05c147b5954a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $330c05c147b5954a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $330c05c147b5954a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $330c05c147b5954a$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($330c05c147b5954a$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $330c05c147b5954a$var$ResultType.redirect,
                        response: $330c05c147b5954a$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $330c05c147b5954a$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $330c05c147b5954a$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $330c05c147b5954a$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $330c05c147b5954a$var$ResultType.error,
                    error: $330c05c147b5954a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $330c05c147b5954a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $330c05c147b5954a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $330c05c147b5954a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $330c05c147b5954a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $330c05c147b5954a$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $330c05c147b5954a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $330c05c147b5954a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $330c05c147b5954a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $330c05c147b5954a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $330c05c147b5954a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $330c05c147b5954a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $330c05c147b5954a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $330c05c147b5954a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$330c05c147b5954a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $330c05c147b5954a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $330c05c147b5954a$export$4d0306f8f6a4585b = Symbol("deferred");
function $330c05c147b5954a$export$3336b097a6fbc59a(routes, opts) {
    $330c05c147b5954a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $330c05c147b5954a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $330c05c147b5954a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $330c05c147b5954a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $330c05c147b5954a$var$createLocation("", $330c05c147b5954a$export$fe53371bee54353d(url), null, "default");
        let matches = $330c05c147b5954a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$330c05c147b5954a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $330c05c147b5954a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $330c05c147b5954a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $330c05c147b5954a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $330c05c147b5954a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($330c05c147b5954a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $330c05c147b5954a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $330c05c147b5954a$var$createLocation("", $330c05c147b5954a$export$fe53371bee54353d(url), null, "default");
        let matches = $330c05c147b5954a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$330c05c147b5954a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $330c05c147b5954a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $330c05c147b5954a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $330c05c147b5954a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $330c05c147b5954a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $330c05c147b5954a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($330c05c147b5954a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$330c05c147b5954a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $330c05c147b5954a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($330c05c147b5954a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $330c05c147b5954a$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $330c05c147b5954a$var$isResponse(result) ? result : $330c05c147b5954a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($330c05c147b5954a$var$isHandlerResult(e) && $330c05c147b5954a$var$isResponse(e.result)) {
                if (e.type === $330c05c147b5954a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($330c05c147b5954a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $330c05c147b5954a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $330c05c147b5954a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $330c05c147b5954a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($330c05c147b5954a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($330c05c147b5954a$var$isDeferredResult(result)) {
            let error = $330c05c147b5954a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $330c05c147b5954a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($330c05c147b5954a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($330c05c147b5954a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $330c05c147b5954a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $330c05c147b5954a$var$_extends({}, context, {
                statusCode: $330c05c147b5954a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $330c05c147b5954a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $330c05c147b5954a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $330c05c147b5954a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $330c05c147b5954a$var$isErrorResult(pendingActionResult[1]) ? $330c05c147b5954a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $330c05c147b5954a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $330c05c147b5954a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $330c05c147b5954a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $330c05c147b5954a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $330c05c147b5954a$var$callDataStrategyImpl(unstable_dataStrategy || $330c05c147b5954a$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($330c05c147b5954a$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $330c05c147b5954a$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($330c05c147b5954a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $330c05c147b5954a$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $330c05c147b5954a$export$fec11da027c70692(routes, context, error) {
    let newContext = $330c05c147b5954a$var$_extends({}, context, {
        statusCode: $330c05c147b5954a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $330c05c147b5954a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $330c05c147b5954a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $330c05c147b5954a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $330c05c147b5954a$export$cae722b0cc860f13(to ? to : ".", $330c05c147b5954a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $330c05c147b5954a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$330c05c147b5954a$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $330c05c147b5954a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $330c05c147b5954a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $330c05c147b5954a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$330c05c147b5954a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$330c05c147b5954a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $330c05c147b5954a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $330c05c147b5954a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $330c05c147b5954a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$330c05c147b5954a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$330c05c147b5954a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $330c05c147b5954a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $330c05c147b5954a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $330c05c147b5954a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $330c05c147b5954a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $330c05c147b5954a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($330c05c147b5954a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $330c05c147b5954a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $330c05c147b5954a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $330c05c147b5954a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $330c05c147b5954a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $330c05c147b5954a$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $330c05c147b5954a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $330c05c147b5954a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $330c05c147b5954a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($330c05c147b5954a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $330c05c147b5954a$var$shouldRevalidateLoader(match, $330c05c147b5954a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $330c05c147b5954a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $330c05c147b5954a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $330c05c147b5954a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $330c05c147b5954a$var$shouldRevalidateLoader(fetcherMatch, $330c05c147b5954a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $330c05c147b5954a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $330c05c147b5954a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $330c05c147b5954a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $330c05c147b5954a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $330c05c147b5954a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $330c05c147b5954a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$330c05c147b5954a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $330c05c147b5954a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $330c05c147b5954a$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $330c05c147b5954a$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $330c05c147b5954a$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $330c05c147b5954a$var$ResultType.data,
                    result: undefined
                });
            };
            return $330c05c147b5954a$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$330c05c147b5954a$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $330c05c147b5954a$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $330c05c147b5954a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $330c05c147b5954a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $330c05c147b5954a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $330c05c147b5954a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $330c05c147b5954a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $330c05c147b5954a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $330c05c147b5954a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $330c05c147b5954a$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($330c05c147b5954a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $330c05c147b5954a$var$ResultType.error,
                error: e
            };
        }
        if (type === $330c05c147b5954a$var$ResultType.error) return {
            type: $330c05c147b5954a$var$ResultType.error,
            error: new $330c05c147b5954a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $330c05c147b5954a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $330c05c147b5954a$var$ResultType.error) return {
        type: $330c05c147b5954a$var$ResultType.error,
        error: result,
        statusCode: $330c05c147b5954a$export$972111febbeef05b(result) ? result.status : status
    };
    if ($330c05c147b5954a$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $330c05c147b5954a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $330c05c147b5954a$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $330c05c147b5954a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $330c05c147b5954a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$330c05c147b5954a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $330c05c147b5954a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $330c05c147b5954a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($330c05c147b5954a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $330c05c147b5954a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $330c05c147b5954a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($330c05c147b5954a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $330c05c147b5954a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $330c05c147b5954a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $330c05c147b5954a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $330c05c147b5954a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $330c05c147b5954a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $330c05c147b5954a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $330c05c147b5954a$export$3e9cee6b33872309(!$330c05c147b5954a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($330c05c147b5954a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $330c05c147b5954a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $330c05c147b5954a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($330c05c147b5954a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $330c05c147b5954a$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $330c05c147b5954a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $330c05c147b5954a$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($330c05c147b5954a$var$isErrorResult(result)) {
            let boundaryMatch = $330c05c147b5954a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $330c05c147b5954a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($330c05c147b5954a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $330c05c147b5954a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($330c05c147b5954a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $330c05c147b5954a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $330c05c147b5954a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $330c05c147b5954a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $330c05c147b5954a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $330c05c147b5954a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $330c05c147b5954a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $330c05c147b5954a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $330c05c147b5954a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $330c05c147b5954a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $330c05c147b5954a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $330c05c147b5954a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($330c05c147b5954a$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $330c05c147b5954a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $330c05c147b5954a$export$8ccf933b0513f8d0(path) : path;
    return $330c05c147b5954a$export$fe53371bee54353d($330c05c147b5954a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $330c05c147b5954a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $330c05c147b5954a$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $330c05c147b5954a$var$ResultType.data || result.type === $330c05c147b5954a$var$ResultType.error);
}
function $330c05c147b5954a$var$isRedirectHandlerResult(result) {
    return $330c05c147b5954a$var$isResponse(result.result) && $330c05c147b5954a$var$redirectStatusCodes.has(result.result.status);
}
function $330c05c147b5954a$var$isDeferredResult(result) {
    return result.type === $330c05c147b5954a$var$ResultType.deferred;
}
function $330c05c147b5954a$var$isErrorResult(result) {
    return result.type === $330c05c147b5954a$var$ResultType.error;
}
function $330c05c147b5954a$var$isRedirectResult(result) {
    return (result && result.type) === $330c05c147b5954a$var$ResultType.redirect;
}
function $330c05c147b5954a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $330c05c147b5954a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $330c05c147b5954a$var$isRedirectResponse(result) {
    if (!$330c05c147b5954a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $330c05c147b5954a$var$isValidMethod(method) {
    return $330c05c147b5954a$var$validRequestMethods.has(method.toLowerCase());
}
function $330c05c147b5954a$var$isMutationMethod(method) {
    return $330c05c147b5954a$var$validMutationMethods.has(method.toLowerCase());
}
async function $330c05c147b5954a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$330c05c147b5954a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($330c05c147b5954a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $330c05c147b5954a$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $330c05c147b5954a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $330c05c147b5954a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $330c05c147b5954a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $330c05c147b5954a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $330c05c147b5954a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $330c05c147b5954a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $330c05c147b5954a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $330c05c147b5954a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $330c05c147b5954a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $330c05c147b5954a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $330c05c147b5954a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $330c05c147b5954a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $330c05c147b5954a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $330c05c147b5954a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $330c05c147b5954a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $330c05c147b5954a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $330c05c147b5954a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($330c05c147b5954a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $330c05c147b5954a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($330c05c147b5954a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $330c05c147b5954a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bnENU = parcelRequire("bnENU");

function $6738ab3539650fb6$var$_extends() {
    $6738ab3539650fb6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6738ab3539650fb6$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6738ab3539650fb6$export$3add0d5dce533e2e = /*#__PURE__*/ $bnENU.createContext(null);
const $6738ab3539650fb6$export$145dfa71566a64dc = /*#__PURE__*/ $bnENU.createContext(null);
const $6738ab3539650fb6$var$AwaitContext = /*#__PURE__*/ $bnENU.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6738ab3539650fb6$export$26749e8557646306 = /*#__PURE__*/ $bnENU.createContext(null);
const $6738ab3539650fb6$export$c7914228fb69b0f5 = /*#__PURE__*/ $bnENU.createContext(null);
const $6738ab3539650fb6$export$9072aa6dd1f93057 = /*#__PURE__*/ $bnENU.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6738ab3539650fb6$var$RouteErrorContext = /*#__PURE__*/ $bnENU.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $6738ab3539650fb6$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6738ab3539650fb6$export$9c954a9d03d32f4a() && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $bnENU.useContext($6738ab3539650fb6$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6738ab3539650fb6$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $330c05c147b5954a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $6738ab3539650fb6$export$9c954a9d03d32f4a() {
    return $bnENU.useContext($6738ab3539650fb6$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $6738ab3539650fb6$export$45d76561a5302f2b() {
    !$6738ab3539650fb6$export$9c954a9d03d32f4a() && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    return $bnENU.useContext($6738ab3539650fb6$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $6738ab3539650fb6$export$1b3f31771c5d07c() {
    return $bnENU.useContext($6738ab3539650fb6$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $6738ab3539650fb6$export$6c330e8992e8a295(pattern) {
    !$6738ab3539650fb6$export$9c954a9d03d32f4a() && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $6738ab3539650fb6$export$45d76561a5302f2b();
    return $bnENU.useMemo(()=>(0, $330c05c147b5954a$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6738ab3539650fb6$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6738ab3539650fb6$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bnENU.useContext($6738ab3539650fb6$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bnENU.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $6738ab3539650fb6$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bnENU.useContext($6738ab3539650fb6$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6738ab3539650fb6$var$useNavigateStable() : $6738ab3539650fb6$var$useNavigateUnstable();
}
function $6738ab3539650fb6$var$useNavigateUnstable() {
    !$6738ab3539650fb6$export$9c954a9d03d32f4a() && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $bnENU.useContext($6738ab3539650fb6$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $bnENU.useContext($6738ab3539650fb6$export$26749e8557646306);
    let { matches: matches } = $bnENU.useContext($6738ab3539650fb6$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6738ab3539650fb6$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $330c05c147b5954a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $bnENU.useRef(false);
    $6738ab3539650fb6$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bnENU.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $330c05c147b5954a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $330c05c147b5954a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6738ab3539650fb6$var$OutletContext = /*#__PURE__*/ $bnENU.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $6738ab3539650fb6$export$4138103a3ae699cc() {
    return $bnENU.useContext($6738ab3539650fb6$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $6738ab3539650fb6$export$a3be3530d8e40d0b(context) {
    let outlet = $bnENU.useContext($6738ab3539650fb6$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $6738ab3539650fb6$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bnENU.useContext($6738ab3539650fb6$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $6738ab3539650fb6$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $bnENU.useContext($6738ab3539650fb6$export$26749e8557646306);
    let { matches: matches } = $bnENU.useContext($6738ab3539650fb6$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6738ab3539650fb6$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $330c05c147b5954a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $bnENU.useMemo(()=>(0, $330c05c147b5954a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $6738ab3539650fb6$export$5d3fca4a98652595(routes, locationArg) {
    return $6738ab3539650fb6$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6738ab3539650fb6$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$6738ab3539650fb6$export$9c954a9d03d32f4a() && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $bnENU.useContext($6738ab3539650fb6$export$26749e8557646306);
    let { matches: parentMatches } = $bnENU.useContext($6738ab3539650fb6$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6738ab3539650fb6$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $330c05c147b5954a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $330c05c147b5954a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6738ab3539650fb6$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $330c05c147b5954a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $330c05c147b5954a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6738ab3539650fb6$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $330c05c147b5954a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6738ab3539650fb6$var$DefaultErrorComponent() {
    let error = $6738ab3539650fb6$export$ed527bf60f6e05f2();
    let message = (0, $330c05c147b5954a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $bnENU.createElement($bnENU.Fragment, null, /*#__PURE__*/ $bnENU.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $bnENU.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $bnENU.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6738ab3539650fb6$var$defaultErrorElement = /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$var$DefaultErrorComponent, null);
class $6738ab3539650fb6$var$RenderErrorBoundary extends $bnENU.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6738ab3539650fb6$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $bnENU.useContext($6738ab3539650fb6$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6738ab3539650fb6$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $6738ab3539650fb6$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6738ab3539650fb6$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $bnENU.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6738ab3539650fb6$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6738ab3539650fb6$var$DataRouterHook || {});
var $6738ab3539650fb6$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6738ab3539650fb6$var$DataRouterStateHook || {});
function $6738ab3539650fb6$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6738ab3539650fb6$var$useDataRouterContext(hookName) {
    let ctx = $bnENU.useContext($6738ab3539650fb6$export$3add0d5dce533e2e);
    !ctx && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $6738ab3539650fb6$var$useDataRouterState(hookName) {
    let state = $bnENU.useContext($6738ab3539650fb6$export$145dfa71566a64dc);
    !state && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    return state;
}
function $6738ab3539650fb6$var$useRouteContext(hookName) {
    let route = $bnENU.useContext($6738ab3539650fb6$export$9072aa6dd1f93057);
    !route && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6738ab3539650fb6$var$useCurrentRouteId(hookName) {
    let route = $6738ab3539650fb6$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6738ab3539650fb6$export$5fc8298006ad9e58() {
    return $6738ab3539650fb6$var$useCurrentRouteId($6738ab3539650fb6$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6738ab3539650fb6$export$d0fd4b7106de2769() {
    let state = $6738ab3539650fb6$var$useDataRouterState($6738ab3539650fb6$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6738ab3539650fb6$export$600dc272ed516c15() {
    let dataRouterContext = $6738ab3539650fb6$var$useDataRouterContext($6738ab3539650fb6$var$DataRouterHook.UseRevalidator);
    let state = $6738ab3539650fb6$var$useDataRouterState($6738ab3539650fb6$var$DataRouterStateHook.UseRevalidator);
    return $bnENU.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6738ab3539650fb6$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6738ab3539650fb6$var$useDataRouterState($6738ab3539650fb6$var$DataRouterStateHook.UseMatches);
    return $bnENU.useMemo(()=>matches.map((m)=>(0, $330c05c147b5954a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6738ab3539650fb6$export$1448a5050d252c4d() {
    let state = $6738ab3539650fb6$var$useDataRouterState($6738ab3539650fb6$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6738ab3539650fb6$var$useCurrentRouteId($6738ab3539650fb6$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6738ab3539650fb6$export$fd5d37484eab868d(routeId) {
    let state = $6738ab3539650fb6$var$useDataRouterState($6738ab3539650fb6$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6738ab3539650fb6$export$fdc00f3f26066d5e() {
    let state = $6738ab3539650fb6$var$useDataRouterState($6738ab3539650fb6$var$DataRouterStateHook.UseActionData);
    let routeId = $6738ab3539650fb6$var$useCurrentRouteId($6738ab3539650fb6$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6738ab3539650fb6$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $bnENU.useContext($6738ab3539650fb6$var$RouteErrorContext);
    let state = $6738ab3539650fb6$var$useDataRouterState($6738ab3539650fb6$var$DataRouterStateHook.UseRouteError);
    let routeId = $6738ab3539650fb6$var$useCurrentRouteId($6738ab3539650fb6$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6738ab3539650fb6$export$78a72ddb39bdd145() {
    let value = $bnENU.useContext($6738ab3539650fb6$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6738ab3539650fb6$export$17f53340677d5831() {
    let value = $bnENU.useContext($6738ab3539650fb6$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6738ab3539650fb6$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6738ab3539650fb6$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6738ab3539650fb6$var$useDataRouterContext($6738ab3539650fb6$var$DataRouterHook.UseBlocker);
    let state = $6738ab3539650fb6$var$useDataRouterState($6738ab3539650fb6$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $bnENU.useState("");
    let blockerFunction = $bnENU.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6738ab3539650fb6$var$_extends({}, currentLocation, {
                pathname: (0, $330c05c147b5954a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6738ab3539650fb6$var$_extends({}, nextLocation, {
                pathname: (0, $330c05c147b5954a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $bnENU.useEffect(()=>{
        let key = String(++$6738ab3539650fb6$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $bnENU.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $330c05c147b5954a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6738ab3539650fb6$var$useNavigateStable() {
    let { router: router } = $6738ab3539650fb6$var$useDataRouterContext($6738ab3539650fb6$var$DataRouterHook.UseNavigateStable);
    let id = $6738ab3539650fb6$var$useCurrentRouteId($6738ab3539650fb6$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $bnENU.useRef(false);
    $6738ab3539650fb6$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bnENU.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6738ab3539650fb6$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6738ab3539650fb6$var$alreadyWarned = {};
function $6738ab3539650fb6$var$warningOnce(key, cond, message) {
    if (!cond && !$6738ab3539650fb6$var$alreadyWarned[key]) $6738ab3539650fb6$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6738ab3539650fb6$var$START_TRANSITION = "startTransition";
const $6738ab3539650fb6$var$startTransitionImpl = $bnENU[$6738ab3539650fb6$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6738ab3539650fb6$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bnENU.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bnENU.useCallback((newState)=>{
        if (v7_startTransition && $6738ab3539650fb6$var$startTransitionImpl) $6738ab3539650fb6$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bnENU.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bnENU.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bnENU.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bnENU.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bnENU.createElement($bnENU.Fragment, null, /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $6738ab3539650fb6$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $6738ab3539650fb6$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $6738ab3539650fb6$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $bnENU.useRef();
    if (historyRef.current == null) historyRef.current = (0, $330c05c147b5954a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bnENU.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bnENU.useCallback((newState)=>{
        v7_startTransition && $6738ab3539650fb6$var$startTransitionImpl ? $6738ab3539650fb6$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bnENU.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $6738ab3539650fb6$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6738ab3539650fb6$export$9c954a9d03d32f4a() && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $bnENU.useContext($6738ab3539650fb6$export$26749e8557646306);
    let { matches: matches } = $bnENU.useContext($6738ab3539650fb6$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6738ab3539650fb6$export$45d76561a5302f2b();
    let navigate = $6738ab3539650fb6$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $330c05c147b5954a$export$cae722b0cc860f13)(to, (0, $330c05c147b5954a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bnENU.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $6738ab3539650fb6$export$910ae8079b2c2852(props) {
    return $6738ab3539650fb6$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $6738ab3539650fb6$export$e7b0ac011bb776c6(_props) {
    (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $6738ab3539650fb6$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $330c05c147b5954a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$6738ab3539650fb6$export$9c954a9d03d32f4a() && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bnENU.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $6738ab3539650fb6$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $330c05c147b5954a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bnENU.useMemo(()=>{
        let trailingPathname = (0, $330c05c147b5954a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $6738ab3539650fb6$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6738ab3539650fb6$export$5d3fca4a98652595($6738ab3539650fb6$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6738ab3539650fb6$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$var$ResolveAwait, null, children));
}
var $6738ab3539650fb6$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6738ab3539650fb6$var$AwaitRenderStatus || {});
const $6738ab3539650fb6$var$neverSettledPromise = new Promise(()=>{});
class $6738ab3539650fb6$var$AwaitErrorBoundary extends $bnENU.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6738ab3539650fb6$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6738ab3539650fb6$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6738ab3539650fb6$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $6738ab3539650fb6$var$AwaitRenderStatus.error : "_data" in promise ? $6738ab3539650fb6$var$AwaitRenderStatus.success : $6738ab3539650fb6$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6738ab3539650fb6$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6738ab3539650fb6$var$AwaitRenderStatus.error && promise._error instanceof (0, $330c05c147b5954a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $6738ab3539650fb6$var$neverSettledPromise;
        if (status === $6738ab3539650fb6$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6738ab3539650fb6$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6738ab3539650fb6$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $bnENU.createElement($6738ab3539650fb6$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6738ab3539650fb6$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6738ab3539650fb6$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $bnENU.createElement($bnENU.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $6738ab3539650fb6$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $bnENU.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $bnENU.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bnENU.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6738ab3539650fb6$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6738ab3539650fb6$export$e7b0ac011bb776c6) && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6738ab3539650fb6$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6738ab3539650fb6$export$daf73786167a7f72(matches) {
    return $6738ab3539650fb6$var$_renderMatches(matches);
}
function $6738ab3539650fb6$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $bnENU.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $bnENU.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $bnENU.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6738ab3539650fb6$export$f30f7e456d254e83(routes, opts) {
    return (0, $330c05c147b5954a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6738ab3539650fb6$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $330c05c147b5954a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6738ab3539650fb6$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $f0e8e6c6e69cddf0$var$_extends() {
    $f0e8e6c6e69cddf0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f0e8e6c6e69cddf0$var$_extends.apply(this, arguments);
}
function $f0e8e6c6e69cddf0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $f0e8e6c6e69cddf0$var$defaultMethod = "get";
const $f0e8e6c6e69cddf0$var$defaultEncType = "application/x-www-form-urlencoded";
function $f0e8e6c6e69cddf0$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $f0e8e6c6e69cddf0$var$isButtonElement(object) {
    return $f0e8e6c6e69cddf0$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $f0e8e6c6e69cddf0$var$isFormElement(object) {
    return $f0e8e6c6e69cddf0$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $f0e8e6c6e69cddf0$var$isInputElement(object) {
    return $f0e8e6c6e69cddf0$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $f0e8e6c6e69cddf0$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $f0e8e6c6e69cddf0$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$f0e8e6c6e69cddf0$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $f0e8e6c6e69cddf0$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $f0e8e6c6e69cddf0$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $f0e8e6c6e69cddf0$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $f0e8e6c6e69cddf0$var$_formDataSupportsSubmitter = null;
function $f0e8e6c6e69cddf0$var$isFormDataSubmitterSupported() {
    if ($f0e8e6c6e69cddf0$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $f0e8e6c6e69cddf0$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $f0e8e6c6e69cddf0$var$_formDataSupportsSubmitter = true;
    }
    return $f0e8e6c6e69cddf0$var$_formDataSupportsSubmitter;
}
const $f0e8e6c6e69cddf0$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $f0e8e6c6e69cddf0$var$getFormEncType(encType) {
    if (encType != null && !$f0e8e6c6e69cddf0$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $f0e8e6c6e69cddf0$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($f0e8e6c6e69cddf0$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $330c05c147b5954a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $f0e8e6c6e69cddf0$var$defaultMethod;
        encType = $f0e8e6c6e69cddf0$var$getFormEncType(target.getAttribute("enctype")) || $f0e8e6c6e69cddf0$var$defaultEncType;
        formData = new FormData(target);
    } else if ($f0e8e6c6e69cddf0$var$isButtonElement(target) || $f0e8e6c6e69cddf0$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $330c05c147b5954a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $f0e8e6c6e69cddf0$var$defaultMethod;
        encType = $f0e8e6c6e69cddf0$var$getFormEncType(target.getAttribute("formenctype")) || $f0e8e6c6e69cddf0$var$getFormEncType(form.getAttribute("enctype")) || $f0e8e6c6e69cddf0$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$f0e8e6c6e69cddf0$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($f0e8e6c6e69cddf0$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $f0e8e6c6e69cddf0$var$defaultMethod;
        action = null;
        encType = $f0e8e6c6e69cddf0$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $f0e8e6c6e69cddf0$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $f0e8e6c6e69cddf0$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $f0e8e6c6e69cddf0$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $f0e8e6c6e69cddf0$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $f0e8e6c6e69cddf0$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $f0e8e6c6e69cddf0$export$1f3f55432a00e06d(routes, opts) {
    return (0, $330c05c147b5954a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f0e8e6c6e69cddf0$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $330c05c147b5954a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $f0e8e6c6e69cddf0$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6738ab3539650fb6$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $f0e8e6c6e69cddf0$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $330c05c147b5954a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f0e8e6c6e69cddf0$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $330c05c147b5954a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $f0e8e6c6e69cddf0$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6738ab3539650fb6$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $f0e8e6c6e69cddf0$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $f0e8e6c6e69cddf0$var$_extends({}, state, {
        errors: $f0e8e6c6e69cddf0$var$deserializeErrors(state.errors)
    });
    return state;
}
function $f0e8e6c6e69cddf0$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $330c05c147b5954a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $f0e8e6c6e69cddf0$export$7ad602f0e94e62d1 = /*#__PURE__*/ $bnENU.createContext({
    isTransitioning: false
});
const $f0e8e6c6e69cddf0$export$148fd98d095596d4 = /*#__PURE__*/ $bnENU.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $f0e8e6c6e69cddf0$var$START_TRANSITION = "startTransition";
const $f0e8e6c6e69cddf0$var$startTransitionImpl = $bnENU[$f0e8e6c6e69cddf0$var$START_TRANSITION];
const $f0e8e6c6e69cddf0$var$FLUSH_SYNC = "flushSync";
const $f0e8e6c6e69cddf0$var$flushSyncImpl = $93b772b00f04f226$exports[$f0e8e6c6e69cddf0$var$FLUSH_SYNC];
const $f0e8e6c6e69cddf0$var$USE_ID = "useId";
const $f0e8e6c6e69cddf0$var$useIdImpl = $bnENU[$f0e8e6c6e69cddf0$var$USE_ID];
function $f0e8e6c6e69cddf0$var$startTransitionSafe(cb) {
    if ($f0e8e6c6e69cddf0$var$startTransitionImpl) $f0e8e6c6e69cddf0$var$startTransitionImpl(cb);
    else cb();
}
function $f0e8e6c6e69cddf0$var$flushSyncSafe(cb) {
    if ($f0e8e6c6e69cddf0$var$flushSyncImpl) $f0e8e6c6e69cddf0$var$flushSyncImpl(cb);
    else cb();
}
class $f0e8e6c6e69cddf0$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f0e8e6c6e69cddf0$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bnENU.useState(router.state);
    let [pendingState, setPendingState] = $bnENU.useState();
    let [vtContext, setVtContext] = $bnENU.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bnENU.useState();
    let [transition, setTransition] = $bnENU.useState();
    let [interruption, setInterruption] = $bnENU.useState();
    let fetcherData = $bnENU.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $bnENU.useCallback((cb)=>{
        if (v7_startTransition) $f0e8e6c6e69cddf0$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $bnENU.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $f0e8e6c6e69cddf0$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $f0e8e6c6e69cddf0$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $f0e8e6c6e69cddf0$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $f0e8e6c6e69cddf0$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $f0e8e6c6e69cddf0$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bnENU.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $bnENU.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $f0e8e6c6e69cddf0$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $bnENU.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $bnENU.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $bnENU.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $bnENU.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bnENU.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bnENU.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bnENU.createElement($bnENU.Fragment, null, /*#__PURE__*/ $bnENU.createElement((0, $6738ab3539650fb6$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bnENU.createElement((0, $6738ab3539650fb6$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $bnENU.createElement($f0e8e6c6e69cddf0$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $bnENU.createElement($f0e8e6c6e69cddf0$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $bnENU.createElement((0, $6738ab3539650fb6$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bnENU.createElement($f0e8e6c6e69cddf0$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $f0e8e6c6e69cddf0$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $6738ab3539650fb6$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $f0e8e6c6e69cddf0$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $bnENU.useRef();
    if (historyRef.current == null) historyRef.current = (0, $330c05c147b5954a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bnENU.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bnENU.useCallback((newState)=>{
        v7_startTransition && $f0e8e6c6e69cddf0$var$startTransitionImpl ? $f0e8e6c6e69cddf0$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bnENU.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bnENU.createElement((0, $6738ab3539650fb6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $f0e8e6c6e69cddf0$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $bnENU.useRef();
    if (historyRef.current == null) historyRef.current = (0, $330c05c147b5954a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bnENU.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bnENU.useCallback((newState)=>{
        v7_startTransition && $f0e8e6c6e69cddf0$var$startTransitionImpl ? $f0e8e6c6e69cddf0$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bnENU.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bnENU.createElement((0, $6738ab3539650fb6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $f0e8e6c6e69cddf0$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $bnENU.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bnENU.useCallback((newState)=>{
        v7_startTransition && $f0e8e6c6e69cddf0$var$startTransitionImpl ? $f0e8e6c6e69cddf0$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bnENU.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bnENU.createElement((0, $6738ab3539650fb6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $f0e8e6c6e69cddf0$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $f0e8e6c6e69cddf0$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $f0e8e6c6e69cddf0$export$a6c7ac8248d6e38a = /*#__PURE__*/ $bnENU.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $f0e8e6c6e69cddf0$var$_objectWithoutPropertiesLoose(_ref7, $f0e8e6c6e69cddf0$var$_excluded);
    let { basename: basename } = $bnENU.useContext((0, $6738ab3539650fb6$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $f0e8e6c6e69cddf0$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($f0e8e6c6e69cddf0$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $330c05c147b5954a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $6738ab3539650fb6$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $f0e8e6c6e69cddf0$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $bnENU.createElement("a", $f0e8e6c6e69cddf0$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $f0e8e6c6e69cddf0$export$b0d92dbee9b5b60d = /*#__PURE__*/ $bnENU.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $f0e8e6c6e69cddf0$var$_objectWithoutPropertiesLoose(_ref8, $f0e8e6c6e69cddf0$var$_excluded2);
    let path = (0, $6738ab3539650fb6$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $6738ab3539650fb6$export$45d76561a5302f2b)();
    let routerState = $bnENU.useContext((0, $6738ab3539650fb6$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $bnENU.useContext((0, $6738ab3539650fb6$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $f0e8e6c6e69cddf0$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $330c05c147b5954a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $bnENU.createElement($f0e8e6c6e69cddf0$export$a6c7ac8248d6e38a, $f0e8e6c6e69cddf0$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $f0e8e6c6e69cddf0$export$a7fed597f4b8afd8 = /*#__PURE__*/ $bnENU.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $f0e8e6c6e69cddf0$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $f0e8e6c6e69cddf0$var$_objectWithoutPropertiesLoose(_ref9, $f0e8e6c6e69cddf0$var$_excluded3);
    let submit = $f0e8e6c6e69cddf0$export$47c85c6e3a081d3();
    let formAction = $f0e8e6c6e69cddf0$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $bnENU.createElement("form", $f0e8e6c6e69cddf0$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $f0e8e6c6e69cddf0$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $f0e8e6c6e69cddf0$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $f0e8e6c6e69cddf0$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($f0e8e6c6e69cddf0$var$DataRouterHook || ($f0e8e6c6e69cddf0$var$DataRouterHook = {}));
var $f0e8e6c6e69cddf0$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($f0e8e6c6e69cddf0$var$DataRouterStateHook || ($f0e8e6c6e69cddf0$var$DataRouterStateHook = {}));
// Internal hooks
function $f0e8e6c6e69cddf0$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $f0e8e6c6e69cddf0$var$useDataRouterContext(hookName) {
    let ctx = $bnENU.useContext((0, $6738ab3539650fb6$export$3add0d5dce533e2e));
    !ctx && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $f0e8e6c6e69cddf0$var$useDataRouterState(hookName) {
    let state = $bnENU.useContext((0, $6738ab3539650fb6$export$145dfa71566a64dc));
    !state && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $f0e8e6c6e69cddf0$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $6738ab3539650fb6$export$9770f232ac06a008)();
    let location = (0, $6738ab3539650fb6$export$45d76561a5302f2b)();
    let path = (0, $6738ab3539650fb6$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $bnENU.useCallback((event)=>{
        if ($f0e8e6c6e69cddf0$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $330c05c147b5954a$export$fe53371bee54353d)(location) === (0, $330c05c147b5954a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $f0e8e6c6e69cddf0$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $bnENU.useRef($f0e8e6c6e69cddf0$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bnENU.useRef(false);
    let location = (0, $6738ab3539650fb6$export$45d76561a5302f2b)();
    let searchParams = $bnENU.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $f0e8e6c6e69cddf0$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $6738ab3539650fb6$export$9770f232ac06a008)();
    let setSearchParams = $bnENU.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $f0e8e6c6e69cddf0$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $f0e8e6c6e69cddf0$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $f0e8e6c6e69cddf0$var$fetcherId = 0;
let $f0e8e6c6e69cddf0$var$getUniqueFetcherId = ()=>"__" + String(++$f0e8e6c6e69cddf0$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $f0e8e6c6e69cddf0$export$47c85c6e3a081d3() {
    let { router: router } = $f0e8e6c6e69cddf0$var$useDataRouterContext($f0e8e6c6e69cddf0$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $bnENU.useContext((0, $6738ab3539650fb6$export$26749e8557646306));
    let currentRouteId = (0, $6738ab3539650fb6$export$5fc8298006ad9e58)();
    return $bnENU.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $f0e8e6c6e69cddf0$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $f0e8e6c6e69cddf0$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $f0e8e6c6e69cddf0$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $f0e8e6c6e69cddf0$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $bnENU.useContext((0, $6738ab3539650fb6$export$26749e8557646306));
    let routeContext = $bnENU.useContext((0, $6738ab3539650fb6$export$9072aa6dd1f93057));
    !routeContext && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $f0e8e6c6e69cddf0$var$_extends({}, (0, $6738ab3539650fb6$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $6738ab3539650fb6$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $330c05c147b5954a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $330c05c147b5954a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $f0e8e6c6e69cddf0$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $f0e8e6c6e69cddf0$var$useDataRouterContext($f0e8e6c6e69cddf0$var$DataRouterHook.UseFetcher);
    let state = $f0e8e6c6e69cddf0$var$useDataRouterState($f0e8e6c6e69cddf0$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $bnENU.useContext($f0e8e6c6e69cddf0$export$148fd98d095596d4);
    let route = $bnENU.useContext((0, $6738ab3539650fb6$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    !route && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $f0e8e6c6e69cddf0$var$useIdImpl ? $f0e8e6c6e69cddf0$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $bnENU.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($f0e8e6c6e69cddf0$var$getUniqueFetcherId());
    // Registration/cleanup
    $bnENU.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $bnENU.useCallback((href, opts)=>{
        !routeId && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $f0e8e6c6e69cddf0$export$47c85c6e3a081d3();
    let submit = $bnENU.useCallback((target, opts)=>{
        submitImpl(target, $f0e8e6c6e69cddf0$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $bnENU.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $bnENU.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $bnENU.createElement($f0e8e6c6e69cddf0$export$a7fed597f4b8afd8, $f0e8e6c6e69cddf0$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $330c05c147b5954a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bnENU.useMemo(()=>$f0e8e6c6e69cddf0$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $f0e8e6c6e69cddf0$export$fa996778a3a31087() {
    let state = $f0e8e6c6e69cddf0$var$useDataRouterState($f0e8e6c6e69cddf0$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $f0e8e6c6e69cddf0$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $f0e8e6c6e69cddf0$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $f0e8e6c6e69cddf0$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $f0e8e6c6e69cddf0$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $f0e8e6c6e69cddf0$var$useDataRouterContext($f0e8e6c6e69cddf0$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $f0e8e6c6e69cddf0$var$useDataRouterState($f0e8e6c6e69cddf0$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $bnENU.useContext((0, $6738ab3539650fb6$export$26749e8557646306));
    let location = (0, $6738ab3539650fb6$export$45d76561a5302f2b)();
    let matches = (0, $6738ab3539650fb6$export$2378eb7f5ff86053)();
    let navigation = (0, $6738ab3539650fb6$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $bnENU.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $f0e8e6c6e69cddf0$var$usePageHide($bnENU.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $f0e8e6c6e69cddf0$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $f0e8e6c6e69cddf0$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($f0e8e6c6e69cddf0$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bnENU.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $f0e8e6c6e69cddf0$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $f0e8e6c6e69cddf0$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bnENU.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($f0e8e6c6e69cddf0$var$_extends({}, location, {
                    pathname: (0, $330c05c147b5954a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($f0e8e6c6e69cddf0$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bnENU.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $f0e8e6c6e69cddf0$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bnENU.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $f0e8e6c6e69cddf0$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bnENU.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $f0e8e6c6e69cddf0$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $6738ab3539650fb6$export$b273b3273281a049)(when);
    $bnENU.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bnENU.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $f0e8e6c6e69cddf0$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $bnENU.useContext($f0e8e6c6e69cddf0$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $330c05c147b5954a$export$3e9cee6b33872309)(false);
    let { basename: basename } = $f0e8e6c6e69cddf0$var$useDataRouterContext($f0e8e6c6e69cddf0$var$DataRouterHook.useViewTransitionState);
    let path = (0, $6738ab3539650fb6$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $330c05c147b5954a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $330c05c147b5954a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $330c05c147b5954a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $330c05c147b5954a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $0b1513b4017d5424$exports = {};
"use strict";

$0b1513b4017d5424$exports = (parcelRequire("arFVW"));



var $bnENU = parcelRequire("bnENU");
var $20f77fb53211c1e4$exports = {};
//
$20f77fb53211c1e4$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $56007f36a369b8c9$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $56007f36a369b8c9$export$2e2bcd8739ae039 = $56007f36a369b8c9$var$stylis_min;


var $8ac4542d04fd9a75$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $8ac4542d04fd9a75$export$2e2bcd8739ae039 = $8ac4542d04fd9a75$var$unitlessKeys;


function $09c78fe27e28a265$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $36a1dd22c4442fcf$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $36a1dd22c4442fcf$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $09c78fe27e28a265$export$2e2bcd8739ae039)(function(prop) {
    return $36a1dd22c4442fcf$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $531230f68f91e026$exports = {};
"use strict";
var $5d1bdabb6aff82a6$exports = {};
"use strict";

$5d1bdabb6aff82a6$exports = (parcelRequire("efd5V"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $531230f68f91e026$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $531230f68f91e026$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $531230f68f91e026$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $531230f68f91e026$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $531230f68f91e026$var$TYPE_STATICS = {};
$531230f68f91e026$var$TYPE_STATICS[$5d1bdabb6aff82a6$exports.ForwardRef] = $531230f68f91e026$var$FORWARD_REF_STATICS;
$531230f68f91e026$var$TYPE_STATICS[$5d1bdabb6aff82a6$exports.Memo] = $531230f68f91e026$var$MEMO_STATICS;
function $531230f68f91e026$var$getStatics(component) {
    // React v16.11 and below
    if ($5d1bdabb6aff82a6$exports.isMemo(component)) return $531230f68f91e026$var$MEMO_STATICS;
     // React v16.12 and above
    return $531230f68f91e026$var$TYPE_STATICS[component["$$typeof"]] || $531230f68f91e026$var$REACT_STATICS;
}
var $531230f68f91e026$var$defineProperty = Object.defineProperty;
var $531230f68f91e026$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $531230f68f91e026$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $531230f68f91e026$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $531230f68f91e026$var$getPrototypeOf = Object.getPrototypeOf;
var $531230f68f91e026$var$objectPrototype = Object.prototype;
function $531230f68f91e026$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($531230f68f91e026$var$objectPrototype) {
            var inheritedComponent = $531230f68f91e026$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $531230f68f91e026$var$objectPrototype) $531230f68f91e026$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $531230f68f91e026$var$getOwnPropertyNames(sourceComponent);
        if ($531230f68f91e026$var$getOwnPropertySymbols) keys = keys.concat($531230f68f91e026$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $531230f68f91e026$var$getStatics(targetComponent);
        var sourceStatics = $531230f68f91e026$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$531230f68f91e026$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $531230f68f91e026$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $531230f68f91e026$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$531230f68f91e026$exports = $531230f68f91e026$var$hoistNonReactStatics;



var $cmlvI = parcelRequire("cmlvI");
function $2952da92fd5b9db2$var$y() {
    return ($2952da92fd5b9db2$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $2952da92fd5b9db2$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $2952da92fd5b9db2$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $0b1513b4017d5424$exports.typeOf)(t);
}, $2952da92fd5b9db2$var$S = Object.freeze([]), $2952da92fd5b9db2$var$w = Object.freeze({});
function $2952da92fd5b9db2$var$E(e) {
    return "function" == typeof e;
}
function $2952da92fd5b9db2$var$b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $2952da92fd5b9db2$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $2952da92fd5b9db2$var$N = ("undefined" != typeof $cmlvI && void 0 !== $cmlvI.env && undefined, "data-styled"), $2952da92fd5b9db2$export$83d89fbfd8236492 = "5.3.11", $2952da92fd5b9db2$var$C = "undefined" != typeof window && "HTMLElement" in window, $2952da92fd5b9db2$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $cmlvI && void 0 !== $cmlvI.env && false), $2952da92fd5b9db2$var$P = {}, $2952da92fd5b9db2$var$O = {};
function $2952da92fd5b9db2$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $2952da92fd5b9db2$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $2952da92fd5b9db2$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $2952da92fd5b9db2$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $2952da92fd5b9db2$var$T = new Map, $2952da92fd5b9db2$var$x = new Map, $2952da92fd5b9db2$var$k = 1, $2952da92fd5b9db2$var$V = function(e) {
    if ($2952da92fd5b9db2$var$T.has(e)) return $2952da92fd5b9db2$var$T.get(e);
    for(; $2952da92fd5b9db2$var$x.has($2952da92fd5b9db2$var$k);)$2952da92fd5b9db2$var$k++;
    var t = $2952da92fd5b9db2$var$k++;
    return $2952da92fd5b9db2$var$T.set(e, t), $2952da92fd5b9db2$var$x.set(t, e), t;
}, $2952da92fd5b9db2$var$B = function(e) {
    return $2952da92fd5b9db2$var$x.get(e);
}, $2952da92fd5b9db2$var$z = function(e, t) {
    t >= $2952da92fd5b9db2$var$k && ($2952da92fd5b9db2$var$k = t + 1), $2952da92fd5b9db2$var$T.set(e, t), $2952da92fd5b9db2$var$x.set(t, e);
}, $2952da92fd5b9db2$var$M = "style[" + $2952da92fd5b9db2$var$N + '][data-styled-version="5.3.11"]', $2952da92fd5b9db2$var$G = new RegExp("^" + $2952da92fd5b9db2$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $2952da92fd5b9db2$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $2952da92fd5b9db2$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($2952da92fd5b9db2$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($2952da92fd5b9db2$var$z(u, c), $2952da92fd5b9db2$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $2952da92fd5b9db2$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $2952da92fd5b9db2$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($2952da92fd5b9db2$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($2952da92fd5b9db2$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $2952da92fd5b9db2$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $2952da92fd5b9db2$var$H = function() {
    function e(e) {
        var t = this.element = $2952da92fd5b9db2$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $2952da92fd5b9db2$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $2952da92fd5b9db2$var$$ = function() {
    function e(e) {
        var t = this.element = $2952da92fd5b9db2$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $2952da92fd5b9db2$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $2952da92fd5b9db2$var$U = $2952da92fd5b9db2$var$C, $2952da92fd5b9db2$var$J = {
    isServer: !$2952da92fd5b9db2$var$C,
    useCSSOMInjection: !$2952da92fd5b9db2$var$I
}, $2952da92fd5b9db2$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $2952da92fd5b9db2$var$w), void 0 === t && (t = {}), this.options = $2952da92fd5b9db2$var$y({}, $2952da92fd5b9db2$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $2952da92fd5b9db2$var$C && $2952da92fd5b9db2$var$U && ($2952da92fd5b9db2$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($2952da92fd5b9db2$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($2952da92fd5b9db2$var$N) && ($2952da92fd5b9db2$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $2952da92fd5b9db2$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($2952da92fd5b9db2$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $2952da92fd5b9db2$var$W(o) : r ? new $2952da92fd5b9db2$var$H(o) : new $2952da92fd5b9db2$var$$(o), new $2952da92fd5b9db2$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($2952da92fd5b9db2$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($2952da92fd5b9db2$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($2952da92fd5b9db2$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $2952da92fd5b9db2$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $2952da92fd5b9db2$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $2952da92fd5b9db2$var$Z = /(a)(d)/gi, $2952da92fd5b9db2$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $2952da92fd5b9db2$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $2952da92fd5b9db2$var$K(t % 52) + n;
    return ($2952da92fd5b9db2$var$K(t % 52) + n).replace($2952da92fd5b9db2$var$Z, "$1-$2");
}
var $2952da92fd5b9db2$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $2952da92fd5b9db2$var$te = function(e) {
    return $2952da92fd5b9db2$var$ee(5381, e);
};
function $2952da92fd5b9db2$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($2952da92fd5b9db2$var$E(n) && !$2952da92fd5b9db2$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $2952da92fd5b9db2$var$re = $2952da92fd5b9db2$var$te("5.3.11"), $2952da92fd5b9db2$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $2952da92fd5b9db2$var$ne(e), this.componentId = t, this.baseHash = $2952da92fd5b9db2$var$ee($2952da92fd5b9db2$var$re, t), this.baseStyle = n, $2952da92fd5b9db2$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $2952da92fd5b9db2$var$_e(this.rules, e, t, n).join(""), i = $2952da92fd5b9db2$var$Q($2952da92fd5b9db2$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $2952da92fd5b9db2$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $2952da92fd5b9db2$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $2952da92fd5b9db2$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $2952da92fd5b9db2$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $2952da92fd5b9db2$var$se = /^\s*\/\/.*$/gm, $2952da92fd5b9db2$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $2952da92fd5b9db2$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $2952da92fd5b9db2$var$w : e, i = s.options, a = void 0 === i ? $2952da92fd5b9db2$var$w : i, c = s.plugins, u = void 0 === c ? $2952da92fd5b9db2$var$S : c, l = new (0, $56007f36a369b8c9$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $2952da92fd5b9db2$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($2952da92fd5b9db2$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $2952da92fd5b9db2$var$D(15), $2952da92fd5b9db2$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $2952da92fd5b9db2$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createContext(), $2952da92fd5b9db2$export$91317688fc694efa = $2952da92fd5b9db2$export$8c190ef828af4c86.Consumer, $2952da92fd5b9db2$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createContext(), $2952da92fd5b9db2$var$de = ($2952da92fd5b9db2$var$le.Consumer, new $2952da92fd5b9db2$var$X), $2952da92fd5b9db2$var$he = $2952da92fd5b9db2$var$ae();
function $2952da92fd5b9db2$var$pe() {
    return (0, $bnENU.useContext)($2952da92fd5b9db2$export$8c190ef828af4c86) || $2952da92fd5b9db2$var$de;
}
function $2952da92fd5b9db2$var$fe() {
    return (0, $bnENU.useContext)($2952da92fd5b9db2$var$le) || $2952da92fd5b9db2$var$he;
}
function $2952da92fd5b9db2$export$a473771da2f0ff7c(e) {
    var t = (0, $bnENU.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $2952da92fd5b9db2$var$pe(), u = (0, $bnENU.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $bnENU.useMemo)(function() {
        return $2952da92fd5b9db2$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $bnENU.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($20f77fb53211c1e4$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement($2952da92fd5b9db2$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement($2952da92fd5b9db2$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $2952da92fd5b9db2$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $2952da92fd5b9db2$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $2952da92fd5b9db2$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $2952da92fd5b9db2$var$he), this.name + e.hash;
    }, e;
}(), $2952da92fd5b9db2$var$ve = /([A-Z])/, $2952da92fd5b9db2$var$ge = /([A-Z])/g, $2952da92fd5b9db2$var$Se = /^ms-/, $2952da92fd5b9db2$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $2952da92fd5b9db2$var$Ee(e) {
    return $2952da92fd5b9db2$var$ve.test(e) ? e.replace($2952da92fd5b9db2$var$ge, $2952da92fd5b9db2$var$we).replace($2952da92fd5b9db2$var$Se, "-ms-") : e;
}
var $2952da92fd5b9db2$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $2952da92fd5b9db2$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $2952da92fd5b9db2$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($2952da92fd5b9db2$var$be(e)) return "";
    if ($2952da92fd5b9db2$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($2952da92fd5b9db2$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $2952da92fd5b9db2$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $2952da92fd5b9db2$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $2952da92fd5b9db2$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$2952da92fd5b9db2$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $2952da92fd5b9db2$var$E(t[i]) ? s.push($2952da92fd5b9db2$var$Ee(i) + ":", t[i], ";") : $2952da92fd5b9db2$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($2952da92fd5b9db2$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $8ac4542d04fd9a75$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $2952da92fd5b9db2$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $2952da92fd5b9db2$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $2952da92fd5b9db2$var$E(e) || $2952da92fd5b9db2$var$g(e) ? $2952da92fd5b9db2$var$Ne($2952da92fd5b9db2$var$_e($2952da92fd5b9db2$var$v($2952da92fd5b9db2$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $2952da92fd5b9db2$var$Ne($2952da92fd5b9db2$var$_e($2952da92fd5b9db2$var$v(e, n)));
}
var $2952da92fd5b9db2$var$Ce = /invalid hook call/i, $2952da92fd5b9db2$var$Ie = new Set, $2952da92fd5b9db2$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $2952da92fd5b9db2$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $2952da92fd5b9db2$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $2952da92fd5b9db2$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $2952da92fd5b9db2$var$De = /(^-|-$)/g;
function $2952da92fd5b9db2$var$je(e) {
    return e.replace($2952da92fd5b9db2$var$Re, "-").replace($2952da92fd5b9db2$var$De, "");
}
var $2952da92fd5b9db2$var$Te = function(e) {
    return $2952da92fd5b9db2$var$Q($2952da92fd5b9db2$var$te(e) >>> 0);
};
function $2952da92fd5b9db2$var$xe(e) {
    return "string" == typeof e && true;
}
var $2952da92fd5b9db2$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $2952da92fd5b9db2$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $2952da92fd5b9db2$var$Be(e, t, n) {
    var r = e[n];
    $2952da92fd5b9db2$var$ke(t) && $2952da92fd5b9db2$var$ke(r) ? $2952da92fd5b9db2$var$ze(r, t) : e[n] = t;
}
function $2952da92fd5b9db2$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($2952da92fd5b9db2$var$ke(i)) for(var a in i)$2952da92fd5b9db2$var$Ve(a) && $2952da92fd5b9db2$var$Be(e, i[a], a);
    }
    return e;
}
var $2952da92fd5b9db2$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createContext(), $2952da92fd5b9db2$export$b631efc24e9d5e2f = $2952da92fd5b9db2$export$2c657da244d00bd6.Consumer;
function $2952da92fd5b9db2$export$d8964aec282183a3(e) {
    var t = (0, $bnENU.useContext)($2952da92fd5b9db2$export$2c657da244d00bd6), n = (0, $bnENU.useMemo)(function() {
        return function(e, t) {
            if (!e) return $2952da92fd5b9db2$var$D(14);
            if ($2952da92fd5b9db2$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $2952da92fd5b9db2$var$D(8) : t ? $2952da92fd5b9db2$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement($2952da92fd5b9db2$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $2952da92fd5b9db2$var$Fe = {};
function $2952da92fd5b9db2$var$Ye(e, t, n) {
    var o = $2952da92fd5b9db2$export$7ba318d8d2f06c76(e), i = !$2952da92fd5b9db2$var$xe(e), a = t.attrs, c = void 0 === a ? $2952da92fd5b9db2$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $2952da92fd5b9db2$var$je(e);
        $2952da92fd5b9db2$var$Fe[n] = ($2952da92fd5b9db2$var$Fe[n] || 0) + 1;
        var r = n + "-" + $2952da92fd5b9db2$var$Te("5.3.11" + n + $2952da92fd5b9db2$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $2952da92fd5b9db2$var$xe(e) ? "styled." + e : "Styled(" + $2952da92fd5b9db2$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $2952da92fd5b9db2$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $2952da92fd5b9db2$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $2952da92fd5b9db2$var$w);
                var r = $2952da92fd5b9db2$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $2952da92fd5b9db2$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($2952da92fd5b9db2$var$Oe(t, (0, $bnENU.useContext)($2952da92fd5b9db2$export$2c657da244d00bd6), a) || $2952da92fd5b9db2$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $2952da92fd5b9db2$var$pe(), s = $2952da92fd5b9db2$var$fe(), i = t ? e.generateAndInjectStyles($2952da92fd5b9db2$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $2952da92fd5b9db2$var$xe(b), N = v !== t ? $2952da92fd5b9db2$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $36a1dd22c4442fcf$export$2e2bcd8739ae039), b) : !_ || (0, $36a1dd22c4442fcf$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $2952da92fd5b9db2$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $bnENU.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $2952da92fd5b9db2$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($2952da92fd5b9db2$var$xe(e) ? e : $2952da92fd5b9db2$var$je($2952da92fd5b9db2$var$b(e)));
        return $2952da92fd5b9db2$var$Ye(e, $2952da92fd5b9db2$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $2952da92fd5b9db2$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($531230f68f91e026$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $2952da92fd5b9db2$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $2952da92fd5b9db2$var$w), !(0, $0b1513b4017d5424$exports.isValidElementType)(r)) return $2952da92fd5b9db2$var$D(1, String(r));
        var s = function() {
            return t(r, o, $2952da92fd5b9db2$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $2952da92fd5b9db2$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $2952da92fd5b9db2$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($2952da92fd5b9db2$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $2952da92fd5b9db2$var$qe[e] = $2952da92fd5b9db2$var$qe(e);
});
var $2952da92fd5b9db2$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $2952da92fd5b9db2$var$ne(e), $2952da92fd5b9db2$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($2952da92fd5b9db2$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $2952da92fd5b9db2$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $2952da92fd5b9db2$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $2952da92fd5b9db2$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $2952da92fd5b9db2$var$Te(JSON.stringify(i)), u = new $2952da92fd5b9db2$var$He(i, a);
    function d(e) {
        var t = $2952da92fd5b9db2$var$pe(), n = $2952da92fd5b9db2$var$fe(), o = (0, $bnENU.useContext)($2952da92fd5b9db2$export$2c657da244d00bd6), d = (0, $bnENU.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $bnENU.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $2952da92fd5b9db2$var$P, n, o);
        else {
            var s = $2952da92fd5b9db2$var$y({}, t, {
                theme: $2952da92fd5b9db2$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).memo(d);
}
function $2952da92fd5b9db2$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $2952da92fd5b9db2$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $2952da92fd5b9db2$var$Te(o);
    return new $2952da92fd5b9db2$var$ye(s, o);
}
var $2952da92fd5b9db2$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $2952da92fd5b9db2$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $2952da92fd5b9db2$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $2952da92fd5b9db2$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $2952da92fd5b9db2$var$D(2);
            var n = ((t = {})[$2952da92fd5b9db2$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $2952da92fd5b9db2$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("style", $2952da92fd5b9db2$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $2952da92fd5b9db2$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $2952da92fd5b9db2$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement($2952da92fd5b9db2$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $2952da92fd5b9db2$var$D(3);
    }, e;
}(), $2952da92fd5b9db2$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).forwardRef(function(t, n) {
        var o = (0, $bnENU.useContext)($2952da92fd5b9db2$export$2c657da244d00bd6), i = e.defaultProps, a = $2952da92fd5b9db2$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement(e, $2952da92fd5b9db2$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($531230f68f91e026$exports)))(t, e), t.displayName = "WithTheme(" + $2952da92fd5b9db2$var$b(e) + ")", t;
}, $2952da92fd5b9db2$export$93d4e7f90805808f = function() {
    return (0, $bnENU.useContext)($2952da92fd5b9db2$export$2c657da244d00bd6);
}, $2952da92fd5b9db2$export$5c87cfe6c475f500 = {
    StyleSheet: $2952da92fd5b9db2$var$X,
    masterSheet: $2952da92fd5b9db2$var$de
};
var $2952da92fd5b9db2$export$2e2bcd8739ae039 = $2952da92fd5b9db2$var$qe;



parcelRequire("bnENU");
function $591ac205d4dd229c$var$RadomLogo({ logoProps: logoProps, ...props }) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        width: "120",
        height: "32",
        viewBox: "0 0 120 32",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "black",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("g", {
                clipPath: "url(#clip0_526_40)",
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M0.499695 2.35787C0.688149 2.35787 0.863681 2.35787 1.03921 2.35787C4.26879 2.35787 7.49836 2.35571 10.7279 2.35894C12.7277 2.3611 14.7102 2.49248 16.5808 3.29583C19.6715 4.62255 21.2555 7.28461 21.2189 10.9019C21.1888 13.9117 19.1782 16.184 16.5808 17.2146C15.8367 17.5096 15.0322 17.6496 14.2666 17.8962C14.0641 17.9619 13.9047 18.1601 13.726 18.2979C13.9295 18.4056 14.1233 18.5671 14.3398 18.6113C15.1432 18.775 15.9767 18.8277 16.7596 19.056C18.2317 19.4857 19.1169 20.5637 19.6219 21.9679C20.5373 24.5126 21.4354 27.0637 22.3378 29.6116C22.3787 29.7279 22.3981 29.8518 22.439 30.0187C22.2754 30.037 22.1429 30.0628 22.0104 30.0639C20.6826 30.0672 19.3548 30.0542 18.0271 30.0736C17.662 30.079 17.4983 29.9821 17.4046 29.5998C16.9179 27.6172 16.4031 25.6422 15.883 23.6672C15.2627 21.311 13.8024 20.0349 11.2804 19.8486C9.19122 19.6946 7.08915 19.7162 4.99353 19.6462C4.56385 19.6322 4.55201 19.8723 4.55201 20.1943C4.55847 23.244 4.55631 26.2948 4.55631 29.3446C4.55631 29.8256 4.31007 30.0661 3.81757 30.0661C2.72561 30.0661 1.63365 30.0661 0.499695 30.0661V2.35787H0.499695ZM4.55631 16.1958C4.79108 16.1958 4.98276 16.1958 5.17552 16.1958C6.82639 16.1958 8.47725 16.1743 10.1281 16.2023C11.387 16.2238 12.5823 15.9675 13.7443 15.5142C16.5754 14.4093 17.8687 11.478 16.724 8.68994C15.9993 6.92385 14.5401 6.06127 12.7342 5.95466C10.2121 5.80605 7.67928 5.85558 5.15183 5.79528C4.67693 5.78451 4.54232 5.92881 4.54555 6.40372C4.56493 9.54391 4.55524 12.6841 4.55524 15.8243C4.55524 15.9266 4.55524 16.03 4.55524 16.1958H4.55631Z"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M119.786 30.0476H116.058V29.4618C116.058 25.5678 116.063 21.6738 116.052 17.7798C116.051 17.2079 116.009 16.6307 115.929 16.0643C115.659 14.183 114.493 13.1104 112.585 12.951C110.393 12.7679 108.503 14.1151 107.891 16.3927C107.67 17.2122 107.557 18.0845 107.548 18.9342C107.511 22.433 107.532 25.9318 107.532 29.4316C107.532 29.6233 107.532 29.8161 107.532 30.0369H103.777C103.777 29.7999 103.777 29.591 103.777 29.3821C103.777 25.6496 103.797 21.9171 103.762 18.1847C103.753 17.2596 103.651 16.3174 103.442 15.4171C102.89 13.0286 100.663 12.6118 99.0872 13.0985C97.1456 13.6994 96.1193 15.1737 95.6239 17.027C95.3827 17.9316 95.2912 18.8976 95.2793 19.8377C95.2384 23.0317 95.2643 26.2258 95.2643 29.4198C95.2643 29.6126 95.2643 29.8053 95.2643 30.0638C94.0538 30.0638 92.893 30.0702 91.7332 30.0519C91.6449 30.0509 91.5199 29.8947 91.4822 29.7859C91.437 29.6578 91.4672 29.5027 91.4672 29.3584C91.4672 23.1136 91.4672 16.8687 91.4672 10.6249C91.4672 10.1526 91.6994 9.91672 92.1639 9.91743C93.1676 9.91743 94.1712 9.91743 95.2223 9.91743C95.331 11.004 95.2449 12.0454 95.0112 13.077C94.9563 13.3215 94.8583 13.5605 94.8324 13.8071C94.8109 14.0117 94.868 14.225 94.8906 14.4339C95.0618 14.2853 95.2836 14.1668 95.3924 13.9816C95.6832 13.4895 95.891 12.9489 96.1915 12.4632C97.5602 10.2523 100.258 9.15608 102.766 9.80651C104.532 10.2642 105.669 11.4326 106.307 13.1147C106.39 13.3322 106.416 13.5767 106.53 13.7748C106.616 13.9256 106.793 14.1087 106.94 14.1162C107.086 14.1248 107.3 13.9676 107.387 13.8244C107.674 13.3505 107.882 12.8272 108.184 12.3641C109.533 10.2943 111.419 9.34453 113.905 9.67298C115.165 9.83882 116.329 10.177 117.358 11.0019C118.694 12.0734 119.32 13.4959 119.582 15.1059C119.735 16.0384 119.792 16.9958 119.798 17.9424C119.822 21.8181 119.809 25.6938 119.808 29.5706C119.808 29.7106 119.792 29.8506 119.782 30.0476H119.786Z"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M65.5957 30.0652C64.4273 30.0652 63.3159 30.076 62.2057 30.049C62.0904 30.0458 61.888 29.8304 61.8815 29.7066C61.8223 28.5199 61.8632 27.3428 62.2713 26.2024C62.3413 26.0064 62.2563 25.7544 62.2433 25.5283C62.0646 25.6844 61.7943 25.805 61.72 26.001C60.9748 27.9545 59.6233 29.3114 57.6515 29.937C54.5533 30.9192 51.7179 30.3452 49.3089 28.1322C47.2596 26.2498 46.3905 23.7837 46.1687 21.0797C45.949 18.4036 46.4562 15.8697 47.881 13.5544C49.5824 10.7911 52.5719 9.35995 55.782 9.6464C57.6881 9.81655 59.3271 10.5478 60.5731 12.0069C61.0297 12.5411 61.3162 13.2206 61.6758 13.8366C61.748 13.9593 61.7695 14.1252 61.8664 14.2178C61.9774 14.3233 62.1464 14.3685 62.2897 14.4396C62.3263 14.2964 62.4243 14.137 62.3909 14.0121C61.3194 9.99747 62.0786 5.91069 61.9009 1.86269C61.9009 1.84761 61.916 1.83254 61.9472 1.77438H65.5968V30.0652H65.5957ZM49.8592 19.9673C49.9626 20.7286 50.0078 21.5029 50.1833 22.247C50.5193 23.675 51.1687 24.9801 52.3748 25.846C54.9625 27.7025 58.4473 27.0919 60.2651 24.7034C62.1863 22.1781 62.3963 19.3664 61.0695 16.5417C59.8193 13.8796 57.2401 12.428 54.073 13.2809C53.2804 13.4941 52.5848 13.8409 51.9946 14.4364C50.4709 15.9731 49.9141 17.8576 49.8581 19.9683L49.8592 19.9673Z"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M28.6953 16.1755H25.0554C25.1749 15.0663 25.526 14.0713 26.0838 13.1473C26.9486 11.7161 28.2344 10.7911 29.7862 10.2645C32.4654 9.3556 35.1738 9.33191 37.8671 10.2203C40.4904 11.0861 41.9743 12.9427 42.39 15.6435C42.5397 16.6149 42.6258 17.6045 42.6334 18.5866C42.6614 22.2653 42.6452 25.9439 42.6441 29.6236C42.6441 29.7475 42.6301 29.8713 42.6215 30.0296H38.8847C38.8471 28.691 38.7954 27.3719 39.2067 26.0828C39.2832 25.8448 39.3521 25.6004 39.378 25.3538C39.3898 25.2407 39.2864 25.1147 39.2358 24.9952C39.113 25.0695 38.9364 25.1147 38.8761 25.2235C38.5908 25.7393 38.3851 26.3057 38.0642 26.7957C36.2453 29.5709 33.5929 30.609 30.3838 30.3085C28.2311 30.1071 26.3972 29.1993 25.2223 27.3126C23.1536 23.9883 24.825 19.8315 28.6468 18.6599C30.456 18.1053 32.3276 18.1193 34.1863 18.0008C35.1695 17.9384 36.1548 17.8641 37.1327 17.7434C39.253 17.4818 39.1378 15.9634 38.4152 14.6269C37.9392 13.7461 37.0616 13.3648 36.1301 13.1613C34.5148 12.8081 32.8897 12.779 31.283 13.2087C29.9315 13.5705 29.1077 14.4643 28.8062 15.8341C28.7836 15.9386 28.7405 16.0387 28.6953 16.1744V16.1755ZM38.8104 19.2694C38.1665 19.9715 37.4094 20.286 36.5888 20.4357C35.3913 20.6532 34.1809 20.7986 32.9867 21.029C31.8861 21.2422 30.7414 21.3898 29.7183 21.813C27.9285 22.5517 27.6238 24.9909 29.0786 26.2164C29.7732 26.8022 30.61 26.9573 31.4876 26.9756C36.2033 27.0789 38.9967 23.5252 38.8115 19.2694H38.8104Z"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M88.2782 19.9631C88.3051 22.5035 87.688 24.8565 86.0953 26.8864C84.5597 28.8442 82.5201 29.9512 80.0723 30.2722C78.0456 30.5371 76.0674 30.3271 74.2011 29.4225C71.8848 28.2993 70.3427 26.4708 69.5102 24.0704C68.512 21.1908 68.527 18.2875 69.6922 15.4542C71.2516 11.6625 74.563 9.53676 78.6831 9.6046C81.8287 9.65629 84.438 10.8172 86.3268 13.392C87.5114 15.0073 88.0962 16.8542 88.2728 18.8357C88.3062 19.2083 88.2771 19.5873 88.2771 19.9631H88.2782ZM84.5446 19.7025C84.5554 18.6493 84.3174 17.3905 83.7057 16.221C82.6741 14.2481 81.0706 13.1379 78.8167 13.0646C76.5401 12.9903 74.7288 13.8766 73.6401 15.8979C72.1206 18.7172 72.1475 21.5925 73.8005 24.3482C75.8186 27.7135 80.4589 27.4798 82.4694 25.4413C83.9706 23.9196 84.5554 22.0534 84.5446 19.7025Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("clipPath", {
                    id: "clip0_526_40",
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("rect", {
                        width: "119.315",
                        height: "28.6268",
                        transform: "translate(0.498489 1.77344)"
                    })
                })
            })
        ]
    });
}
var $591ac205d4dd229c$export$2e2bcd8739ae039 = $591ac205d4dd229c$var$RadomLogo;



parcelRequire("bnENU");



var $bnENU = parcelRequire("bnENU");
const $afdf282d9c361d03$var$API_BASE_URLS = {
    local: "http://127.0.0.1:3000",
    // local: 'https://api.radom.com',
    test: "https://api.test.radom.network",
    prod: "https://api.radom.com"
};
const $afdf282d9c361d03$var$STAGE_VALUE = ("test" ?? "local").toLowerCase();
const $afdf282d9c361d03$export$f9865a0a7f208c15 = $afdf282d9c361d03$var$STAGE_VALUE in $afdf282d9c361d03$var$API_BASE_URLS ? $afdf282d9c361d03$var$STAGE_VALUE : "prod";
const $afdf282d9c361d03$export$1345fde192f5a83e = $afdf282d9c361d03$export$f9865a0a7f208c15 === "prod";
const $afdf282d9c361d03$export$c3ee1e672e1e24e7 = (0, $afdf282d9c361d03$var$API_BASE_URLS[$afdf282d9c361d03$export$f9865a0a7f208c15]);
var $afdf282d9c361d03$export$8fe7e62e076ddbb5;
(function(RADOM_COLORS) {
    RADOM_COLORS["BLACK"] = "#282828";
    RADOM_COLORS["BLUE"] = "rgb(7, 7, 40)";
    RADOM_COLORS["NEW_BLUE"] = "#3464E6";
    RADOM_COLORS["BLUE_ALT"] = "#0E259C";
    RADOM_COLORS["BLUE_MED"] = "#0F1D4B";
    RADOM_COLORS["PURPLE"] = "#9F76EA";
    RADOM_COLORS["ORANGE"] = "#FF6648";
    RADOM_COLORS["ORANGE_MED"] = "#FF8972";
    RADOM_COLORS["ORANGE_LIGHT"] = "#FFDBD4";
    RADOM_COLORS["ORANGE_LIGHTEST"] = "#FFF2EFAA";
    RADOM_COLORS["SUCCESS"] = "#36AF67";
    RADOM_COLORS["SUCCESS_LIGHT"] = "#d8f3e3";
    RADOM_COLORS["WARNING"] = "#F79009";
    RADOM_COLORS["WARNING_LIGHT"] = "#FEF0C7";
    RADOM_COLORS["INFO"] = "#5490EC";
    RADOM_COLORS["INFO_LIGHT"] = "#d1e1fa";
    RADOM_COLORS["ERROR"] = "#FF5252";
    RADOM_COLORS["ERROR_LIGHT"] = "#ffdfdf";
    RADOM_COLORS["GRAY_DARKEST"] = "#636576";
    RADOM_COLORS["GRAY_DARKER"] = "#9B9EB1";
    RADOM_COLORS["GRAY_DARK"] = "#E2E4EF";
    RADOM_COLORS["GRAY_MED"] = "#EFF0F8";
    RADOM_COLORS["GRAY_LIGHTEST"] = "#F8F8FB";
    RADOM_COLORS["INPUT_PLACEHOLDER"] = "#9ba3af";
    RADOM_COLORS["NICE_GREEN"] = "#4bb69c";
    RADOM_COLORS["NICE_BLUE"] = "#07053f";
    RADOM_COLORS["NEW_GRAY_1"] = "#33324F";
    RADOM_COLORS["DARK_BLUE"] = "#07053f";
    RADOM_COLORS["BLUE4"] = "#3464e6";
    RADOM_COLORS["BLUE5"] = "#618afa";
    RADOM_COLORS["BLUE7"] = "#e7ecff";
    RADOM_COLORS["GRAY4"] = "#8D91AC";
    RADOM_COLORS["GRAY8"] = "#E3E5F0";
    RADOM_COLORS["GRAY9"] = "#eff0f8";
    RADOM_COLORS["RED50"] = "#ffecf0";
    RADOM_COLORS["RED300"] = "#ffa9b9";
    RADOM_COLORS["RED900"] = "#dc082e";
    RADOM_COLORS["INPUT_DEFAULT"] = "rgb(239 240 248 / 60%)";
})($afdf282d9c361d03$export$8fe7e62e076ddbb5 || ($afdf282d9c361d03$export$8fe7e62e076ddbb5 = {}));
var $afdf282d9c361d03$export$a794f8af63328e6b;
(function(WINDOW_SIZE) {
    WINDOW_SIZE["MOBILE_SMALL"] = "320px";
    WINDOW_SIZE["MOBILE_MEDIUM"] = "375px";
    WINDOW_SIZE["MOBILE_LARGE"] = "425px";
    WINDOW_SIZE["TABLET"] = "768px";
    WINDOW_SIZE["LAPTOP"] = "1024px";
    WINDOW_SIZE["LAPTOP_LARGE"] = "1440px";
    WINDOW_SIZE["DESKTOP"] = "2560px";
})($afdf282d9c361d03$export$a794f8af63328e6b || ($afdf282d9c361d03$export$a794f8af63328e6b = {}));
const $afdf282d9c361d03$export$aa70fbbb12382d3 = (seconds)=>{
    const intervals = {
        1: "Second",
        60: "Minute",
        [3600]: "Hour",
        [86400]: "Day",
        [604800]: "Week",
        [2592000]: "Month",
        [7776000]: "Quarter",
        [15552000]: "Six Months",
        [31536000]: "Year"
    };
    if (intervals[seconds]) return intervals[seconds];
    if (seconds > 31536000) {
        const years = (seconds / 31536000).toFixed(1);
        return `${years} Years`;
    }
    if (seconds > 2592000) {
        const months = (seconds / 2592000).toFixed(1);
        return `${months} Months`;
    }
    if (seconds > 86400) {
        const days = (seconds / 86400).toFixed(1);
        return `${days} Days`;
    }
    if (seconds > 3600) {
        const hours = (seconds / 3600).toFixed(1);
        return `${hours} Hours`;
    }
    if (seconds > 60) {
        const minutes = (seconds / 60).toFixed(1);
        return `${minutes} Minutes`;
    }
    return `${seconds} Seconds`;
};
const $afdf282d9c361d03$export$d82eb24974fa9fd = (numSeconds)=>{
    if ($afdf282d9c361d03$export$aa70fbbb12382d3(numSeconds)) return $afdf282d9c361d03$export$aa70fbbb12382d3(numSeconds);
    return `${numSeconds} seconds`;
};
const $afdf282d9c361d03$var$RADOM_CONTRACT_ADDRESSES = {
    31337: "0x749a0F73869eb0b0389F37B2Cee2b8DE5B358baB",
    5: "0x9D4B6432c290D4c393Bbe8fa30b72e240c008F17",
    80001: "0x987296974b23c050d6Eb2BE0CB2A60a1e9CeBa4e",
    4002: "0x819b60B377f99f1c1e8d40B53538b5Dbe1B4a37B",
    11155111: "0x8BBAaaE8225455ce62FCA83FF761fF4895bdD27B",
    1313161555: "0xc17C78B13f9594D974AF55921751B0919E4f377D",
    43113: "0xCc8401Fbca27934D4bFC762FEbb667ACdb976F88",
    534353: "0x3a909d378A6504287C03E0B19FdfB12f84c229e7",
    137: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    56: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    1: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    1313161554: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    250: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    43114: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    66: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028"
};
const $afdf282d9c361d03$export$ce84370551d92e53 = (chainId)=>{
    if ($afdf282d9c361d03$var$RADOM_CONTRACT_ADDRESSES[chainId]) return $afdf282d9c361d03$var$RADOM_CONTRACT_ADDRESSES[chainId];
    return $afdf282d9c361d03$var$RADOM_CONTRACT_ADDRESSES[31337];
};
const $afdf282d9c361d03$export$cb8c5ae35c7906d6 = {
    RadomDevNet: "http://localhost:9545",
    GoerliTestnet: "https://goerli.etherscan.io",
    PolygonTestnet: "https://mumbai.polygonscan.com",
    FantomTestnet: "https://testnet.ftmscan.com",
    SepoliaTestnet: "https://sepolia.etherscan.io",
    BitcoinTestnet: "https://mempool.space/testnet",
    Bitcoin: "https://mempool.space",
    AuroraTestnet: "https://explorer.testnet.aurora.dev",
    Aurora: "https://explorer.aurora.dev",
    Arbitrum: "https://arbiscan.io",
    Ethereum: "https://etherscan.io",
    Fantom: "https://ftmscan.com",
    AvalancheTestnet: "https://testnet.snowtrace.io",
    Avalanche: "https://snowtrace.io",
    ScrollTestnet: "https://blockscout.scroll.io",
    Polygon: "https://polygonscan.com",
    BNB: "https://bscscan.com",
    BNBTestnet: "https://testnet.bscscan.com",
    PolkadotTestnet: "https://westend.subscan.io",
    Polkadot: "https://polkadot.subscan.io",
    TronTestnet: "https://nile.tronscan.org/#",
    Tron: "https://tronscan.org/#"
};
const $afdf282d9c361d03$export$e324f73a87016a95 = new Set([
    "Afghanistan",
    "Belarus",
    "Central African Republic",
    "Cuba",
    "Democratic Republic of the Congo",
    "Ethiopia",
    "Iran",
    "Iraq",
    "Libya",
    "Mali",
    "Myanmar",
    "Nicaragua",
    "North Korea",
    "Russia",
    "Somalia",
    "South Sudan",
    "Sudan",
    "Syria",
    "Venezuela",
    "Yemen"
]);
const $afdf282d9c361d03$export$1a56b0c6dfb40ff0 = new Set([
    "Antarctica",
    "Baker Island",
    "Bouvet Island",
    "Heard Island and McDonald Islands",
    "Howland Island",
    "Jarvis Island",
    "Johnston Atoll",
    "Kingman Reef",
    "Palmyra Atoll",
    "Paracel Islands",
    "South Georgia"
]);




parcelRequire("bnENU");




const $a404f1924ec00259$var$Spin = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  from {
      transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const $a404f1924ec00259$var$Spinner = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 20px;
  height: 20px;
  margin: 0;
  background: transparent;
  border-top: 2px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE};
  border-right: 2px solid transparent;
  border-radius: 50%;
  animation: .5s ${$a404f1924ec00259$var$Spin} linear infinite;
`;
var $a404f1924ec00259$export$2e2bcd8739ae039 = $a404f1924ec00259$var$Spinner;


const $d589b7ebc11d644f$var$PrimaryButtonInner = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).button`
  background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK};
  border-radius: 10px;
  padding: 11px 20px;
  outline: 0;
  border: 0;
  color: #FFF;
  cursor: pointer;
  transition: 0.18s ease background-color, 0.18s ease opacity, 0.12s ease transform, 0.18s ease box-shadow;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.2;
  min-height: 44px;
  height: fit-content;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transform: scale(1);

  :hover {
    filter: brightness(0.98);
  }
  
  :active {
    transform: translateY(1px);
  }

  :focus-visible {
    box-shadow: 0 0 0 3px rgba(52, 100, 230, 0.24);
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;

    :active {
      color: #FFF;
    }
  }
`;
const $d589b7ebc11d644f$export$ac16a6a04d9b7c84 = ({ disabled: disabled, ...props })=>// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($d589b7ebc11d644f$var$PrimaryButtonInner, {
        style: props.style,
        disabled: props.isLoading || disabled,
        ...props,
        children: props.isLoading ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {
            style: {
                borderColor: props.spinnerColor ?? "white"
            }
        }) : props.children
    });
const $d589b7ebc11d644f$export$f861551692d63a2e = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).button`
  border: 1px solid;
  border-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE};
  border-radius: 10px;
  padding: 10px 18px;
  outline: 0;
  background: none;
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE};
  cursor: pointer;
  transition: 0.18s ease opacity, 0.12s ease transform, 0.18s ease box-shadow;
  font-size: 14px;
  font-weight: 500;
  height: fit-content;
  user-select: none;
  
  :hover {
    opacity: 0.9;
  }

  :disabled {
    cursor: default;
    border-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE_LIGHT};
    color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE_LIGHT};
    :hover {
      opacity: 1;
    }
  }
  
  :active {
    opacity: 0.72;
    transform: translateY(1px);
  }

  :focus-visible {
    box-shadow: 0 0 0 3px rgba(52, 100, 230, 0.18);
  }
`;
const $d589b7ebc11d644f$export$eeafbfd890eadf04 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).a`
  border: 1px solid;
  border-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE};
  border-radius: 5px;
  padding: 5px 20px;
  outline: 0;
  background: none;
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE};
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 12px;
  height: fit-content;
  user-select: none;
  text-decoration: none;
  
  :hover {
    opacity: 0.75;
  }
  
  :active {
    opacity: 0.5;
  }
`;
const $d589b7ebc11d644f$export$eeb919efb9beb575 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).a`
  background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE};
  border-radius: 5px;
  padding: 10px 30px;
  outline: 0;
  border: 0;
  color: #FFF;
  cursor: pointer;
  transition: 0.2s ease all;
  text-decoration: none;
  font-size: 14px;
  height: fit-content;
  user-select: none;
  
  :hover {
      opacity: 0.75;
  }
  
  :active {
      background-color: #ffd6ce;
      color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE};
  }
`;
const $d589b7ebc11d644f$export$c25acd513dcc8062 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).button`
  border: 0;
  border-radius: 5px;
  padding: 5px 20px;
  outline: 0;
  background: none;
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE};
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 12px;
  height: fit-content;
  user-select: none;
  display: flex;
  align-items: center;
  
  :hover {
    opacity: 0.75;
  }
  
  :active {
    opacity: 0.5;
  }
`;





var $bnENU = parcelRequire("bnENU");




var $bnENU = parcelRequire("bnENU");


const $aeddef6c40752364$export$ac81a72f0c3b6512 = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  from {
    background-color: rgba(7, 7, 40, 0);
  }
  to {
    background-color: rgba(7, 7, 40, 0.75);
  }
`;
const $aeddef6c40752364$export$f9ae25e7d5fbc8b9 = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`    
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;
const $aeddef6c40752364$export$c4535d5c0dad4021 = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  from {
    /* transform: scaleY(0); */
    height: 0;
  }
  to {
    /* transform: scaleY(1) */
    height: fit-content;
  }
`;
const $aeddef6c40752364$export$b953c4562f8602be = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  from {
    /* transform: scaleY(1) */
  }
  to {
    /* transform: scaleY(0) */
  }
`;
const $aeddef6c40752364$export$bd7370ffb2917ab7 = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const $aeddef6c40752364$export$21430ab519d0e9c = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
  }
 100% {
    opacity: 0;
  }
`;




parcelRequire("bnENU");


const $1e598fd09e90fe12$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        ...props,
        stroke: "white",
        fill: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("circle", {
                    cx: "12",
                    cy: "11.9999",
                    r: "9",
                    strokeWidth: "0",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("rect", {
                    x: "12",
                    y: "8",
                    width: "0.01",
                    height: "0.01",
                    strokeWidth: "3",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                    d: "M12 12V16",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
const $1e598fd09e90fe12$export$d648041142d9183e = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)($1e598fd09e90fe12$export$2957fc44b3d2481)`
  transition: all ease-in-out 0.2s;
  cursor: pointer;
  opacity: 0.3;
  
  :hover {
    opacity: 1;
  }
`;


const $b18c92e2e4b17921$var$TooltipMessage = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0px;
  padding: 15px;
  border-radius: 5px;
  background-color: white;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.25);
  font-size: 14px;
  width: max-content;
  max-width: 200px;
  z-index: 100;
  animation: ${(0, $aeddef6c40752364$export$f9ae25e7d5fbc8b9)} 0.2s;
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST};
  font-weight: 400;
`;
const $b18c92e2e4b17921$var$Tooltip = (props)=>{
    const [open, setOpen] = (0, $bnENU.useState)(false);
    const container = (0, $bnENU.useRef)(null);
    const [top, setTop] = (0, $bnENU.useState)(0);
    const [left, setLeft] = (0, $bnENU.useState)(0);
    (0, $bnENU.useEffect)(()=>{
        if (!container.current) return;
        const rect = container.current.getBoundingClientRect();
        setTop(rect.top);
        setLeft(rect.left + rect.width + 10);
    }, [
        container,
        open
    ]);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        ref: container,
        style: {
            position: "relative",
            fontSize: 0
        },
        onMouseEnter: ()=>!props.disabled && setOpen(true),
        onMouseLeave: ()=>setOpen(false),
        children: [
            props.children ? props.children : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $1e598fd09e90fe12$export$d648041142d9183e), {
                width: 20
            }),
            open && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($b18c92e2e4b17921$var$TooltipMessage, {
                style: {
                    top: top,
                    left: left,
                    ...props.style
                },
                children: props.message
            })
        ]
    });
};
var $b18c92e2e4b17921$export$2e2bcd8739ae039 = $b18c92e2e4b17921$var$Tooltip;




var $bnENU = parcelRequire("bnENU");



parcelRequire("bnENU");
function $34655a3478656274$export$65be7b63f510f362(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("svg", {
        width: "10",
        height: "6",
        viewBox: "0 0 10 6",
        fill: "black",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
            d: "M5.39802 5.94478L9.9767 1.36609L8.90021 0.288086L5.39802 3.79257L1.89658 0.288086L0.819336 1.36533L5.39802 5.94478Z"
        })
    });
}




const $3de4cfeabec36e0d$export$df140987c38a308d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createContext({
    closeDropdown: ()=>{}
});
const $3de4cfeabec36e0d$var$DropdownWrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  user-select: none;
  cursor: ${({ disabled: disabled })=>disabled ? "not-allowed" : "pointer"};
  opacity: ${({ disabled: disabled })=>disabled ? 0.5 : 1};
  position: relative;
`;
const $3de4cfeabec36e0d$var$DropdownInner = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  border: 1px solid;
  padding: 8px 12px;
  border-radius: 10px;
  transition: 0.2s ease all;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
  justify-content: space-between;
  height: 100%;
  
  background-color: ${({ transparent: transparent, boxColor: boxColor = "white" })=>transparent ? "transparent" : boxColor};
  border-color: ${({ open: open, transparent: transparent })=>transparent ? "transparent" : open ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE5 : "#d3dae8"};
  
  ${({ open: open, transparent: transparent, disabled: disabled })=>open ? "box-shadow: 0 0 0 3px rgb(97 138 250 / 18%);" : !transparent && !disabled && "box-shadow: 0 1px 2px rgb(15 23 42 / 4%);"}

  :hover {
    background-color: ${({ transparent: transparent })=>transparent ? "transparent" : "white"};
    ${({ open: open, transparent: transparent, disabled: disabled })=>!open && !transparent && !disabled && "border-color: #c4ccde;"}
  }

  :active {
    opacity: 1;
  }
`;
const $3de4cfeabec36e0d$var$DropdownContent = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  cursor: auto;
  position: fixed;
  z-index: 99;
  opacity: ${({ visible: visible })=>visible ? 1 : 0};
  visibility: ${({ visible: visible })=>visible ? "visible" : "hidden"};
  pointer-events: ${({ visible: visible })=>visible ? "auto" : "none"};
  transform: ${({ visible: visible })=>visible ? "translateY(0) scale(1)" : "translateY(-6px) scale(0.985)"};
  transform-origin: 50% 0;
  transition:
    opacity 0.18s ease,
    transform 0.18s ease,
    visibility 0.18s ease;
`;
const $3de4cfeabec36e0d$var$DropdownContentInner = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  max-height: 40vh;
  transform-origin: 50% 0;
  background-color: white;
  box-shadow: 0 20px 28px rgba(15, 23, 42, 0.12);
  border: 1px solid #dbe2ef;
  border-radius: 10px;
  ${({ overflow: overflow })=>overflow ? `overflow: ${overflow}` : "overflow: auto"}
`;
const $3de4cfeabec36e0d$export$6648d5fa18559e7f = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  cursor: pointer;
  padding: 10px;
  transition: 0.2s ease all;
  opacity: 1;

  :hover {
    background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST};
  }

  :active {
    opacity: 0.5;
  }
`;
const $3de4cfeabec36e0d$export$57450dd360325866 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)((0, $f0e8e6c6e69cddf0$export$a6c7ac8248d6e38a))`
  cursor: pointer;
  padding: 10px;
  transition: 0.2s ease all;
  opacity: 1;
  font-size: 14px;
  width: 100%;
  display: block;
  text-decoration: none;
  color: black;

  :hover {
    background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST};
  }

  :active {
    opacity: 0.5;
  }
`;
const $3de4cfeabec36e0d$export$5d302286c68f338 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  width: 100%;
  min-height: 42px;
  line-height: 16px;
  align-items: center;
  justify-content: space-between;
`;
const $3de4cfeabec36e0d$export$1d74d2b90d306635 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  overflow-y: auto;
`;
const $3de4cfeabec36e0d$export$fe2cc6a6c0693b4a = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).input`
  background-color: transparent;
  width: 100%;
  border: none;
  outline: none;
  flex-grow: 1;
  padding: 10px 12px;
  font-size: 14px;
`;
class $3de4cfeabec36e0d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).Component {
    componentWillUnmount() {
        window.removeEventListener("mousedown", this.onMouseDown);
        document.removeEventListener("wheel", this.repositionDropdown);
        window.removeEventListener("resize", this.repositionDropdown);
        this.dropdownResizeObserver?.disconnect();
    }
    render() {
        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($3de4cfeabec36e0d$var$DropdownWrapper, {
            style: this.props.containerStyle,
            ref: (dropdownWrapper)=>{
                if (dropdownWrapper) this.dropdownWrapper = dropdownWrapper;
            },
            disabled: this.props.disabled,
            role: "button",
            "aria-haspopup": "listbox",
            "aria-expanded": this.state.open,
            tabIndex: this.props.disabled ? -1 : 0,
            onFocus: (e)=>{
                if (this.props.openOnFocus && e.currentTarget === e.target && !this.state.open && !this.props.disabled) {
                    this.skipNextInnerClickToggle = true;
                    this.toggleDropdown(true);
                }
            },
            onKeyDown: (e)=>{
                this.props.onKeyDown?.(e);
                if (e.defaultPrevented) return;
                if (e.currentTarget !== e.target) return;
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.toggleDropdown();
                    return;
                }
                if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                    e.preventDefault();
                    this.toggleDropdown(true);
                    return;
                }
                if (e.key === "Escape" && this.state.open) {
                    e.preventDefault();
                    this.toggleDropdown(false);
                }
            },
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($3de4cfeabec36e0d$var$DropdownInner, {
                    transparent: this.props.transparent,
                    open: this.state.open,
                    onClick: this.onInnerClick,
                    disabled: this.props.disabled,
                    boxColor: this.props.innerStyle?.backgroundColor,
                    style: this.props.outerStyle,
                    children: [
                        this.props.selectedContent,
                        !this.props.noChevron && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                            fill: this.props.whiteChevron ? "white" : "black",
                            style: {
                                opacity: 0.3,
                                transition: "0.2s ease all",
                                transform: this.state.open ? "rotate(180deg)" : "rotate(0deg)",
                                minWidth: 15
                            }
                        })
                    ]
                }),
                this.state.open && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($3de4cfeabec36e0d$var$DropdownContent, {
                    style: {
                        minWidth: this.dropdownWrapper?.clientWidth,
                        top: this.state.top,
                        left: this.state.left
                    },
                    ref: (r)=>{
                        if (!r || r === this.dropdownContent) return;
                        this.dropdownResizeObserver?.disconnect();
                        this.dropdownResizeObserver = new ResizeObserver(this.repositionDropdown);
                        this.dropdownResizeObserver.observe(r);
                        this.dropdownContent = r;
                        this.repositionDropdown();
                    },
                    visible: this.state.open,
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($3de4cfeabec36e0d$export$df140987c38a308d.Provider, {
                        value: {
                            closeDropdown: ()=>this.toggleDropdown(false)
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($3de4cfeabec36e0d$var$DropdownContentInner, {
                            overflow: this.props.overflow,
                            style: {
                                maxHeight: this.state.maxHeight,
                                ...this.props.innerStyle
                            },
                            children: this.props.dropdownContent
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.dropdownResizeObserver = null;
        this.skipNextInnerClickToggle = false;
        this.state = {
            open: false,
            top: 0,
            left: 0,
            maxHeight: 320
        };
        this.componentDidUpdate = (prevProps, prevState)=>{
            if (prevProps.dropdownContent !== this.props.dropdownContent) this.repositionDropdown();
            if (!prevState.open && this.state.open) this.repositionDropdown();
        };
        this.onMouseDown = (e)=>{
            if (!this.dropdownWrapper || !this.state.open) return;
            const isClickInDropdown = this.dropdownWrapper === e.target || this.dropdownWrapper.contains(e.target) || !document.contains(e.target);
            if (!isClickInDropdown) this.toggleDropdown(false);
        };
        this.componentDidMount = ()=>{
            window.addEventListener("mousedown", this.onMouseDown);
            if (this.props.onCloseFn) this.props.onCloseFn(()=>this.toggleDropdown(false));
        };
        this.toggleDropdown = (open = !this.state.open)=>{
            if (this.props.disabled) return;
            if (open) {
                document.addEventListener("wheel", this.repositionDropdown);
                window.addEventListener("resize", this.repositionDropdown);
            } else {
                document.removeEventListener("wheel", this.repositionDropdown);
                window.removeEventListener("resize", this.repositionDropdown);
            }
            if (this.state.open && !open && this.props.onClose) this.props.onClose();
            this.setState({
                open: open
            }, ()=>{
                if (open) this.props.onClick?.();
            });
        };
        this.onInnerClick = ()=>{
            // For focus-open dropdowns (e.g. searchable selectors), a mouse click can first
            // open on focus and then immediately trigger a click toggle that closes it.
            // Skip the first click after focus-open, then allow click toggling.
            if (this.props.openOnFocus) {
                if (this.skipNextInnerClickToggle) {
                    this.skipNextInnerClickToggle = false;
                    return;
                }
                this.toggleDropdown(!this.state.open);
                return;
            }
            this.toggleDropdown();
        };
        this.repositionDropdown = ()=>{
            if (!this.dropdownWrapper || !this.dropdownContent || !this.state.open) return;
            const wrapper = this.dropdownWrapper.getBoundingClientRect();
            const rect = this.dropdownContent.getBoundingClientRect();
            const viewportPadding = 8;
            const bottomAlign = wrapper.height + wrapper.top + 5;
            const topAlign = wrapper.y - rect.height - 5;
            const availableBelow = window.innerHeight - bottomAlign - viewportPadding;
            const availableAbove = wrapper.top - viewportPadding - 8;
            let top = bottomAlign;
            let shouldOpenAbove = false;
            if (bottomAlign + rect.height > window.innerHeight - viewportPadding && topAlign >= viewportPadding) {
                // Position dropdown above dropdownWrapper when there is better space above.
                top = topAlign;
                shouldOpenAbove = true;
            } else if (bottomAlign + rect.height > window.innerHeight - viewportPadding && topAlign < viewportPadding) {
                top = Math.max(viewportPadding, window.innerHeight - rect.height - viewportPadding);
                shouldOpenAbove = availableAbove > availableBelow;
            }
            let left = wrapper.x;
            if (left + rect.width > window.innerWidth - viewportPadding) left = wrapper.x - rect.width + wrapper.width;
            left = Math.max(viewportPadding, Math.min(left, window.innerWidth - rect.width - viewportPadding));
            const availableHeight = Math.floor(shouldOpenAbove ? availableAbove : window.innerHeight - top - viewportPadding);
            const configuredMaxHeight = this.props.dropdownMaxHeight ?? 360;
            const viewportMaxHeight = Math.floor(window.innerHeight * 0.55);
            const dynamicMaxHeight = Math.max(170, Math.min(availableHeight, configuredMaxHeight, viewportMaxHeight));
            this.setState((prev)=>{
                if (prev.top === top && prev.left === left && prev.maxHeight === dynamicMaxHeight) return null;
                return {
                    top: top,
                    left: left,
                    maxHeight: dynamicMaxHeight
                };
            });
        };
    }
}
const $3de4cfeabec36e0d$export$4de0267be2e75e64 = ({ label: label, selectedContent: selectedContent, dropdownContent: dropdownContent, onCloseFn: onCloseFn })=>{
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                children: label
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($3de4cfeabec36e0d$export$2e2bcd8739ae039, {
                selectedContent: selectedContent,
                dropdownContent: dropdownContent,
                onCloseFn: onCloseFn
            })
        ]
    });
};


const $196480508fc60042$export$e6d6b58188820b8a = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  font-size: 12px;
  align-items: center;
  justify-content: center;
`;
const $196480508fc60042$export$1e8407dccf0d27b6 = `
  border: 1px solid #cfd7e5;
  background-color: white;
  border-radius: 8px;
  padding: 9px 12px;
  min-height: 42px;
  width: 100%;
  outline: none;
  box-shadow: none;
  transition: 0.2s ease all;
  color: #1f2937;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 400;

  &:hover {
    border-color: #bcc6da;
  }

  :focus,
  :focus-visible {
    border: 1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE5};
    box-shadow: 0 0 0 3px rgb(97 138 250 / 18%);
  }

  ::placeholder {
    color: #919db2;
  }
`;
const $196480508fc60042$export$15a6a1d6cb047a38 = {
    borderColor: "#df1b41",
    boxShadow: "0 1px 1px rgba(15, 23, 42, 0.06), 0 0 0 2px rgba(223, 27, 65, 0.14)"
};
const $196480508fc60042$export$d0c7d80884f46f7d = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  color: #df1b41;
  font-size: 12px;
  line-height: 1.35;
  margin-top: -2px;
`;
const $196480508fc60042$var$DropdownListItem = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  cursor: pointer;

  :hover {
    background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST};
  }
`;
const $196480508fc60042$export$f5c9f3c2c4054eec = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).textarea`
  ${$196480508fc60042$export$1e8407dccf0d27b6}
  border-radius: 10px;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  min-height: 50px;
`;
const $196480508fc60042$export$2f76e18b94e54146 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  max-width: min-content;
  background-color: #f3f5fa;
  border-radius: 999px;
  padding: 2px 8px;
  border: 1px solid #e5e9f3;
  color: #6b7280;
  font-size: 10px;
  user-select: none;
`;
const $196480508fc60042$export$68fd390833cbc0fe = ({ label: label, value: value, onChange: onChange, placeholder: placeholder, onKeyDown: onKeyDown, required: required, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 10
        },
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    gap: 5
                },
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$export$76d3231fec538b73, {
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                            children: label
                        })
                    }),
                    !required && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$export$2f76e18b94e54146, {
                        children: "Optional"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$export$f5c9f3c2c4054eec, {
                style: {
                    maxHeight: 100
                },
                value: value,
                onChange: onChange,
                placeholder: placeholder,
                onKeyDown: onKeyDown,
                required: required,
                disabled: disabled
            })
        ]
    });
};
const $196480508fc60042$var$TextInputWithLabel_ = ({ label: label, tooltip: tooltip, value: value, onChange: onChange, placeholder: placeholder, pattern: pattern, onKeyDown: onKeyDown, required: required, disabled: disabled, ref: ref, as: as, style: style, inputStyle: inputStyle, isInvalid: isInvalid, validationError: validationError, ...props })=>{
    const hasValidationError = isInvalid === true || Boolean(validationError);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 10,
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                    gap: 5
                },
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$export$76d3231fec538b73, {
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                            children: label
                        })
                    }),
                    !required && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$export$2f76e18b94e54146, {
                        children: "Optional"
                    }),
                    tooltip && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $b18c92e2e4b17921$export$2e2bcd8739ae039), {
                        message: tooltip
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$export$c86715117507e8e5, {
                type: "text",
                value: value,
                onChange: onChange,
                placeholder: placeholder,
                pattern: pattern,
                onKeyDown: onKeyDown,
                disabled: disabled,
                required: required,
                "aria-invalid": hasValidationError,
                style: {
                    ...inputStyle,
                    ...hasValidationError ? $196480508fc60042$export$15a6a1d6cb047a38 : undefined
                },
                ...props
            }),
            validationError && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$export$d0c7d80884f46f7d, {
                children: validationError
            })
        ]
    });
};
const $196480508fc60042$export$30c69c51aadaa8e4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).memo($196480508fc60042$var$TextInputWithLabel_);
const $196480508fc60042$export$328374105a880465 = ({ label: label, type: type = "text", value: value, onChange: onChange, placeholder: placeholder, pattern: pattern, onKeyDown: onKeyDown, required: required, disabled: disabled, suggestionList: suggestionList, setSelectedItems: setSelectedItems, inputStyle: inputStyle, isInvalid: isInvalid, validationError: validationError })=>{
    const wrapperRef = (0, $bnENU.useRef)(null);
    const [showSuggestions, setShowSuggestions] = (0, $bnENU.useState)(false);
    const [highlightedIndex, setHighlightedIndex] = (0, $bnENU.useState)(-1);
    const listboxIdRef = (0, $bnENU.useRef)(`autocomplete-${Math.random().toString(36).slice(2, 9)}`);
    const hasValidationError = isInvalid === true || Boolean(validationError);
    const onItemSelect = (e, item)=>{
        e.preventDefault();
        e.stopPropagation();
        setSelectedItems([
            item
        ]);
        setShowSuggestions(false);
        setHighlightedIndex(-1);
    };
    (0, $bnENU.useEffect)(()=>{
        const hasSuggestions = (suggestionList?.length ?? 0) > 0;
        setShowSuggestions(hasSuggestions);
        setHighlightedIndex((currentIndex)=>{
            if (!hasSuggestions) return -1;
            if (currentIndex < 0) return 0;
            if (currentIndex >= suggestionList.length) return suggestionList.length - 1;
            return currentIndex;
        });
    }, [
        suggestionList
    ]);
    (0, $bnENU.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSuggestions(false);
                setHighlightedIndex(-1);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    (0, $bnENU.useEffect)(()=>{
        if (!showSuggestions || highlightedIndex < 0) return;
        const activeItemId = `${listboxIdRef.current}-${highlightedIndex}`;
        document.getElementById(activeItemId)?.scrollIntoView({
            block: "nearest"
        });
    }, [
        showSuggestions,
        highlightedIndex
    ]);
    const handleKeyDown = (e)=>{
        const listLength = suggestionList?.length ?? 0;
        const hasSuggestions = showSuggestions && listLength > 0;
        if (hasSuggestions && e.key === "ArrowDown") {
            e.preventDefault();
            setHighlightedIndex((prev)=>(prev + 1) % listLength);
            return;
        }
        if (hasSuggestions && e.key === "ArrowUp") {
            e.preventDefault();
            setHighlightedIndex((prev)=>prev <= 0 ? listLength - 1 : prev - 1);
            return;
        }
        if (hasSuggestions && e.key === "Enter") {
            const indexToUse = highlightedIndex >= 0 ? highlightedIndex : 0;
            const selected = suggestionList[indexToUse];
            if (selected) {
                onItemSelect(e, selected);
                return;
            }
        }
        if (e.key === "Escape") {
            setShowSuggestions(false);
            setHighlightedIndex(-1);
            return;
        }
        onKeyDown?.(e);
    };
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        ref: wrapperRef,
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 10,
            position: "relative",
            width: "100%"
        },
        children: [
            label && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$export$76d3231fec538b73, {
                children: label
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$export$c86715117507e8e5, {
                type: type,
                value: value,
                onChange: onChange,
                placeholder: placeholder,
                pattern: pattern,
                onKeyDown: handleKeyDown,
                onFocus: ()=>{
                    if ((suggestionList?.length ?? 0) > 0) {
                        setShowSuggestions(true);
                        setHighlightedIndex(0);
                    }
                },
                required: required,
                disabled: disabled,
                "aria-invalid": hasValidationError,
                style: {
                    ...inputStyle,
                    ...hasValidationError ? $196480508fc60042$export$15a6a1d6cb047a38 : undefined
                },
                role: "combobox",
                "aria-autocomplete": "list",
                "aria-expanded": showSuggestions,
                "aria-controls": listboxIdRef.current,
                "aria-activedescendant": showSuggestions && highlightedIndex >= 0 ? `${listboxIdRef.current}-${highlightedIndex}` : undefined
            }),
            validationError && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$export$d0c7d80884f46f7d, {
                children: validationError
            }),
            showSuggestions && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                id: listboxIdRef.current,
                role: "listbox",
                style: {
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    width: "100%",
                    marginTop: 4,
                    background: "white",
                    borderRadius: 5,
                    boxShadow: `0 0 5px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                    zIndex: 999,
                    fontSize: 14
                },
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $3de4cfeabec36e0d$export$1d74d2b90d306635), {
                    children: suggestionList?.map((item, index)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($196480508fc60042$var$DropdownListItem, {
                            id: `${listboxIdRef.current}-${index}`,
                            onClick: (e)=>onItemSelect(e, item),
                            role: "option",
                            "aria-selected": index === highlightedIndex,
                            style: {
                                backgroundColor: index === highlightedIndex ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST : "transparent"
                            },
                            children: item
                        }, item))
                })
            })
        ]
    });
};
const $196480508fc60042$export$76d3231fec538b73 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-weight: 400;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  color: #5f6b7c;
  opacity: 1;
  font-size: 13px;
`;
const $196480508fc60042$export$c86715117507e8e5 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).input`
  ${$196480508fc60042$export$1e8407dccf0d27b6}

  ${({ pattern: pattern })=>pattern && `
    :invalid {
      border: 1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR};
    }`}
`;
const $196480508fc60042$export$5014dc5df9fcd12f = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  padding: 6px;
  display: flex;
  gap: 2px;
  border: 1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  box-shadow: 0 1px 1px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST};
  border-radius: 4px;

  :focus-within {
    outline: 1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED};
  }
`;
const $196480508fc60042$export$7a08dc9d28557b90 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).input`
  border: 0;
  width: 100%;

  :focus {
    outline: none;
    border: none;
  }
`;
const $196480508fc60042$export$bd0cf18531183c14 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  max-width: min-content;
  background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED};
  border-radius: 5px;
  padding: 3px 5px;
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST};
  font-size: 12px;
  user-select: none;
`;



parcelRequire("bnENU");
function $a6503dca462d11a6$var$Arrow(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M19 12L5 12",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M12 19L19 12L12 5",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
var $a6503dca462d11a6$export$2e2bcd8739ae039 = $a6503dca462d11a6$var$Arrow;



parcelRequire("bnENU");
function $604fb7faec27af0d$var$S(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "6 6 12 12",
        stroke: "rgba(0,0,0, 0.25)",
        strokeWidth: "1",
        ...props,
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
            d: "M7 7L17 17M7 17L17 7",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
var $604fb7faec27af0d$export$2e2bcd8739ae039 = $604fb7faec27af0d$var$S;


/**
 * @module color-parse
 */ var $66fec0d521d36461$exports = {};
"use strict";
$66fec0d521d36461$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $ff4d1d2dc87740be$export$2e2bcd8739ae039 = $ff4d1d2dc87740be$var$parse;
/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */ //FIXME: use external hue detector
var $ff4d1d2dc87740be$var$baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */ function $ff4d1d2dc87740be$var$parse(cstr) {
    var m, parts = [], alpha = 1, space;
    if (typeof cstr === "string") {
        cstr = cstr.toLowerCase();
        //keyword
        if ((0, (/*@__PURE__*/$parcel$interopDefault($66fec0d521d36461$exports)))[cstr]) {
            parts = (0, (/*@__PURE__*/$parcel$interopDefault($66fec0d521d36461$exports)))[cstr].slice();
            space = "rgb";
        } else if (cstr === "transparent") {
            alpha = 0;
            space = "rgb";
            parts = [
                0,
                0,
                0
            ];
        } else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
            var base = cstr.slice(1);
            var size = base.length;
            var isShort = size <= 4;
            alpha = 1;
            if (isShort) {
                parts = [
                    parseInt(base[0] + base[0], 16),
                    parseInt(base[1] + base[1], 16),
                    parseInt(base[2] + base[2], 16)
                ];
                if (size === 4) alpha = parseInt(base[3] + base[3], 16) / 255;
            } else {
                parts = [
                    parseInt(base[0] + base[1], 16),
                    parseInt(base[2] + base[3], 16),
                    parseInt(base[4] + base[5], 16)
                ];
                if (size === 8) alpha = parseInt(base[6] + base[7], 16) / 255;
            }
            if (!parts[0]) parts[0] = 0;
            if (!parts[1]) parts[1] = 0;
            if (!parts[2]) parts[2] = 0;
            space = "rgb";
        } else if (m = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
            var name = m[1];
            var isRGB = name === "rgb";
            var base = name.replace(/a$/, "");
            space = base;
            var size = base === "cmyk" ? 4 : base === "gray" ? 1 : 3;
            parts = m[2].trim().split(/\s*[,\/]\s*|\s+/).map(function(x, i) {
                //<percentage>
                if (/%$/.test(x)) {
                    //alpha
                    if (i === size) return parseFloat(x) / 100;
                    //rgb
                    if (base === "rgb") return parseFloat(x) * 255 / 100;
                    return parseFloat(x);
                } else if (base[i] === "h") {
                    //<deg>
                    if (/deg$/.test(x)) return parseFloat(x);
                    else if ($ff4d1d2dc87740be$var$baseHues[x] !== undefined) return $ff4d1d2dc87740be$var$baseHues[x];
                }
                return parseFloat(x);
            });
            if (name === base) parts.push(1);
            alpha = isRGB ? 1 : parts[size] === undefined ? 1 : parts[size];
            parts = parts.slice(0, size);
        } else if (cstr.length > 10 && /[0-9](?:\s|\/)/.test(cstr)) {
            parts = cstr.match(/([0-9]+)/g).map(function(value) {
                return parseFloat(value);
            });
            space = cstr.match(/([a-z])/ig).join("").toLowerCase();
        }
    } else if (!isNaN(cstr)) {
        space = "rgb";
        parts = [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ];
    } else if (Array.isArray(cstr) || cstr.length) {
        parts = [
            cstr[0],
            cstr[1],
            cstr[2]
        ];
        space = "rgb";
        alpha = cstr.length === 4 ? cstr[3] : 1;
    } else if (cstr instanceof Object) {
        if (cstr.r != null || cstr.red != null || cstr.R != null) {
            space = "rgb";
            parts = [
                cstr.r || cstr.red || cstr.R || 0,
                cstr.g || cstr.green || cstr.G || 0,
                cstr.b || cstr.blue || cstr.B || 0
            ];
        } else {
            space = "hsl";
            parts = [
                cstr.h || cstr.hue || cstr.H || 0,
                cstr.s || cstr.saturation || cstr.S || 0,
                cstr.l || cstr.lightness || cstr.L || cstr.b || cstr.brightness
            ];
        }
        alpha = cstr.a || cstr.alpha || cstr.opacity || 1;
        if (cstr.opacity != null) alpha /= 100;
    }
    return {
        space: space,
        values: parts,
        alpha: alpha
    };
}


var $d938669f6f2263ad$exports = {};

$parcel$export($d938669f6f2263ad$exports, "parse", function () { return $d938669f6f2263ad$export$98e6a39c04603d36; }, function (v) { return $d938669f6f2263ad$export$98e6a39c04603d36 = v; });
$parcel$export($d938669f6f2263ad$exports, "stringify", function () { return $d938669f6f2263ad$export$fac44ee5b035f737; }, function (v) { return $d938669f6f2263ad$export$fac44ee5b035f737 = v; });
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $d938669f6f2263ad$export$98e6a39c04603d36;
var $d938669f6f2263ad$export$fac44ee5b035f737;
var $d938669f6f2263ad$var$GradientParser = $d938669f6f2263ad$var$GradientParser || {};
$d938669f6f2263ad$var$GradientParser.stringify = function() {
    var visitor = {
        "visit_linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_gradient": function(node) {
            var orientation = visitor.visit(node.orientation);
            if (orientation) orientation += ", ";
            return node.type + "(" + orientation + visitor.visit(node.colorStops) + ")";
        },
        "visit_shape": function(node) {
            var result = node.value, at = visitor.visit(node.at), style = visitor.visit(node.style);
            if (style) result += " " + style;
            if (at) result += " at " + at;
            return result;
        },
        "visit_default-radial": function(node) {
            var result = "", at = visitor.visit(node.at);
            if (at) result += at;
            return result;
        },
        "visit_extent-keyword": function(node) {
            var result = node.value, at = visitor.visit(node.at);
            if (at) result += " at " + at;
            return result;
        },
        "visit_position-keyword": function(node) {
            return node.value;
        },
        "visit_position": function(node) {
            return visitor.visit(node.value.x) + " " + visitor.visit(node.value.y);
        },
        "visit_%": function(node) {
            return node.value + "%";
        },
        "visit_em": function(node) {
            return node.value + "em";
        },
        "visit_px": function(node) {
            return node.value + "px";
        },
        "visit_literal": function(node) {
            return visitor.visit_color(node.value, node);
        },
        "visit_hex": function(node) {
            return visitor.visit_color("#" + node.value, node);
        },
        "visit_rgb": function(node) {
            return visitor.visit_color("rgb(" + node.value.join(", ") + ")", node);
        },
        "visit_rgba": function(node) {
            return visitor.visit_color("rgba(" + node.value.join(", ") + ")", node);
        },
        "visit_color": function(resultColor, node) {
            var result = resultColor, length = visitor.visit(node.length);
            if (length) result += " " + length;
            return result;
        },
        "visit_angular": function(node) {
            return node.value + "deg";
        },
        "visit_directional": function(node) {
            return "to " + node.value;
        },
        "visit_array": function(elements) {
            var result = "", size = elements.length;
            elements.forEach(function(element, i) {
                result += visitor.visit(element);
                if (i < size - 1) result += ", ";
            });
            return result;
        },
        "visit": function(element) {
            if (!element) return "";
            var result = "";
            if (element instanceof Array) return visitor.visit_array(element, result);
            else if (element.type) {
                var nodeVisitor = visitor["visit_" + element.type];
                if (nodeVisitor) return nodeVisitor(element);
                else throw Error("Missing visitor visit_" + element.type);
            } else throw Error("Invalid node.");
        }
    };
    return function(root) {
        return visitor.visit(root);
    };
}();
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $d938669f6f2263ad$var$GradientParser = $d938669f6f2263ad$var$GradientParser || {};
$d938669f6f2263ad$var$GradientParser.parse = function() {
    var tokens = {
        linearGradient: /^(\-(webkit|o|ms|moz)\-)?(linear\-gradient)/i,
        repeatingLinearGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-linear\-gradient)/i,
        radialGradient: /^(\-(webkit|o|ms|moz)\-)?(radial\-gradient)/i,
        repeatingRadialGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-radial\-gradient)/i,
        sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|left|right|top|bottom)/i,
        extentKeywords: /^(closest\-side|closest\-corner|farthest\-side|farthest\-corner|contain|cover)/,
        positionKeywords: /^(left|center|right|top|bottom)/i,
        pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
        percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))\%/,
        emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
        angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
        startCall: /^\(/,
        endCall: /^\)/,
        comma: /^,/,
        hexColor: /^\#([0-9a-fA-F]+)/,
        literalColor: /^([a-zA-Z]+)/,
        rgbColor: /^rgb/i,
        rgbaColor: /^rgba/i,
        number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
    };
    var input = "";
    function error(msg) {
        var err = new Error(input + ": " + msg);
        err.source = input;
        throw err;
    }
    function getAST() {
        var ast = matchListDefinitions();
        if (input.length > 0) error("Invalid input not EOF");
        return ast;
    }
    function matchListDefinitions() {
        return matchListing(matchDefinition);
    }
    function matchDefinition() {
        return matchGradient("linear-gradient", tokens.linearGradient, matchLinearOrientation) || matchGradient("repeating-linear-gradient", tokens.repeatingLinearGradient, matchLinearOrientation) || matchGradient("radial-gradient", tokens.radialGradient, matchListRadialOrientations) || matchGradient("repeating-radial-gradient", tokens.repeatingRadialGradient, matchListRadialOrientations);
    }
    function matchGradient(gradientType, pattern, orientationMatcher) {
        return matchCall(pattern, function(captures) {
            var orientation = orientationMatcher();
            if (orientation) {
                if (!scan(tokens.comma)) error("Missing comma before color stops");
            }
            return {
                type: gradientType,
                orientation: orientation,
                colorStops: matchListing(matchColorStop)
            };
        });
    }
    function matchCall(pattern, callback) {
        var captures = scan(pattern);
        if (captures) {
            if (!scan(tokens.startCall)) error("Missing (");
            var result = callback(captures);
            if (!scan(tokens.endCall)) error("Missing )");
            return result;
        }
    }
    function matchLinearOrientation() {
        return matchSideOrCorner() || matchAngle();
    }
    function matchSideOrCorner() {
        return match("directional", tokens.sideOrCorner, 1);
    }
    function matchAngle() {
        return match("angular", tokens.angleValue, 1);
    }
    function matchListRadialOrientations() {
        var radialOrientations, radialOrientation = matchRadialOrientation(), lookaheadCache;
        if (radialOrientation) {
            radialOrientations = [];
            radialOrientations.push(radialOrientation);
            lookaheadCache = input;
            if (scan(tokens.comma)) {
                radialOrientation = matchRadialOrientation();
                if (radialOrientation) radialOrientations.push(radialOrientation);
                else input = lookaheadCache;
            }
        }
        return radialOrientations;
    }
    function matchRadialOrientation() {
        var radialType = matchCircle() || matchEllipse();
        if (radialType) radialType.at = matchAtPosition();
        else {
            var extent = matchExtentKeyword();
            if (extent) {
                radialType = extent;
                var positionAt = matchAtPosition();
                if (positionAt) radialType.at = positionAt;
            } else {
                var defaultPosition = matchPositioning();
                if (defaultPosition) radialType = {
                    type: "default-radial",
                    at: defaultPosition
                };
            }
        }
        return radialType;
    }
    function matchCircle() {
        var circle = match("shape", /^(circle)/i, 0);
        if (circle) circle.style = matchLength() || matchExtentKeyword();
        return circle;
    }
    function matchEllipse() {
        var ellipse = match("shape", /^(ellipse)/i, 0);
        if (ellipse) ellipse.style = matchDistance() || matchExtentKeyword();
        return ellipse;
    }
    function matchExtentKeyword() {
        return match("extent-keyword", tokens.extentKeywords, 1);
    }
    function matchAtPosition() {
        if (match("position", /^at/, 0)) {
            var positioning = matchPositioning();
            if (!positioning) error("Missing positioning value");
            return positioning;
        }
    }
    function matchPositioning() {
        var location = matchCoordinates();
        if (location.x || location.y) return {
            type: "position",
            value: location
        };
    }
    function matchCoordinates() {
        return {
            x: matchDistance(),
            y: matchDistance()
        };
    }
    function matchListing(matcher) {
        var captures = matcher(), result = [];
        if (captures) {
            result.push(captures);
            while(scan(tokens.comma)){
                captures = matcher();
                if (captures) result.push(captures);
                else error("One extra comma");
            }
        }
        return result;
    }
    function matchColorStop() {
        var color = matchColor();
        if (!color) error("Expected color definition");
        color.length = matchDistance();
        return color;
    }
    function matchColor() {
        return matchHexColor() || matchRGBAColor() || matchRGBColor() || matchLiteralColor();
    }
    function matchLiteralColor() {
        return match("literal", tokens.literalColor, 0);
    }
    function matchHexColor() {
        return match("hex", tokens.hexColor, 1);
    }
    function matchRGBColor() {
        return matchCall(tokens.rgbColor, function() {
            return {
                type: "rgb",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchRGBAColor() {
        return matchCall(tokens.rgbaColor, function() {
            return {
                type: "rgba",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchNumber() {
        return scan(tokens.number)[1];
    }
    function matchDistance() {
        return match("%", tokens.percentageValue, 1) || matchPositionKeyword() || matchLength();
    }
    function matchPositionKeyword() {
        return match("position-keyword", tokens.positionKeywords, 1);
    }
    function matchLength() {
        return match("px", tokens.pixelValue, 1) || match("em", tokens.emValue, 1);
    }
    function match(type, pattern, captureIndex) {
        var captures = scan(pattern);
        if (captures) return {
            type: type,
            value: captures[captureIndex]
        };
    }
    function scan(regexp) {
        var captures, blankCaptures;
        blankCaptures = /^[\n\r\t\s]+/.exec(input);
        if (blankCaptures) consume(blankCaptures[0].length);
        captures = regexp.exec(input);
        if (captures) consume(captures[0].length);
        return captures;
    }
    function consume(size) {
        input = input.substr(size);
    }
    return function(code) {
        input = code.toString();
        return getAST();
    };
}();
$d938669f6f2263ad$export$98e6a39c04603d36 = $d938669f6f2263ad$var$GradientParser.parse;
$d938669f6f2263ad$export$fac44ee5b035f737 = $d938669f6f2263ad$var$GradientParser.stringify;


// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $2cbf0d34fe839641$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "(?:01\\d|[24-689])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3[2-8]\\d{9,10}",
                    [
                        11,
                        12
                    ]
                ],
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[0135-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-79]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
            [
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "709\\d{6}|(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|7[67]|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-359]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-4]|5[1-3]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[59]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-9]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|[579]\\d|63)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[235-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "2\\d{8}",
                    [
                        9
                    ]
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $3ad49d0a568a3239$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $2cbf0d34fe839641$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


var $187749ebc16b0fee$var$objectConstructor = {}.constructor;
function $187749ebc16b0fee$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $187749ebc16b0fee$var$objectConstructor;
}


function $f3f1f00db021ee2f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f3f1f00db021ee2f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f3f1f00db021ee2f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f3f1f00db021ee2f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f3f1f00db021ee2f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f3f1f00db021ee2f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f3f1f00db021ee2f$var$_slicedToArray(arr, i) {
    return $f3f1f00db021ee2f$var$_arrayWithHoles(arr) || $f3f1f00db021ee2f$var$_iterableToArrayLimit(arr, i) || $f3f1f00db021ee2f$var$_unsupportedIterableToArray(arr, i) || $f3f1f00db021ee2f$var$_nonIterableRest();
}
function $f3f1f00db021ee2f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f3f1f00db021ee2f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f3f1f00db021ee2f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f3f1f00db021ee2f$var$_arrayLikeToArray(o, minLen);
}
function $f3f1f00db021ee2f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f3f1f00db021ee2f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f3f1f00db021ee2f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f3f1f00db021ee2f$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $f3f1f00db021ee2f$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $f3f1f00db021ee2f$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $187749ebc16b0fee$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $7b729a3d8cef317c$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $7b729a3d8cef317c$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $7b729a3d8cef317c$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $7b729a3d8cef317c$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $7b729a3d8cef317c$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $7b729a3d8cef317c$var$SLASHES = "\uFF0F/";
var $7b729a3d8cef317c$var$DOTS = "\uFF0E.";
var $7b729a3d8cef317c$export$20542845033f576e = " \xa0\xad\u200B\u2060\u3000";
var $7b729a3d8cef317c$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $7b729a3d8cef317c$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $7b729a3d8cef317c$export$7f01587e28f9194 = "".concat($7b729a3d8cef317c$var$DASHES).concat($7b729a3d8cef317c$var$SLASHES).concat($7b729a3d8cef317c$var$DOTS).concat($7b729a3d8cef317c$export$20542845033f576e).concat($7b729a3d8cef317c$var$BRACKETS).concat($7b729a3d8cef317c$var$TILDES);
var $7b729a3d8cef317c$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $13c94d10da24bdff$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $13c94d10da24bdff$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $13c94d10da24bdff$var$_typeof(obj);
}
function $13c94d10da24bdff$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $13c94d10da24bdff$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $13c94d10da24bdff$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $13c94d10da24bdff$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $13c94d10da24bdff$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $13c94d10da24bdff$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $13c94d10da24bdff$var$_setPrototypeOf(subClass, superClass);
}
function $13c94d10da24bdff$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $13c94d10da24bdff$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $13c94d10da24bdff$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $13c94d10da24bdff$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $13c94d10da24bdff$var$_possibleConstructorReturn(this, result);
    };
}
function $13c94d10da24bdff$var$_possibleConstructorReturn(self, call) {
    if (call && ($13c94d10da24bdff$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $13c94d10da24bdff$var$_assertThisInitialized(self);
}
function $13c94d10da24bdff$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $13c94d10da24bdff$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $13c94d10da24bdff$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$13c94d10da24bdff$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $13c94d10da24bdff$var$_construct(Class, arguments, $13c94d10da24bdff$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $13c94d10da24bdff$var$_setPrototypeOf(Wrapper, Class);
    };
    return $13c94d10da24bdff$var$_wrapNativeSuper(Class);
}
function $13c94d10da24bdff$var$_construct(Parent, args, Class) {
    if ($13c94d10da24bdff$var$_isNativeReflectConstruct()) $13c94d10da24bdff$var$_construct = Reflect.construct;
    else $13c94d10da24bdff$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $13c94d10da24bdff$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $13c94d10da24bdff$var$_construct.apply(null, arguments);
}
function $13c94d10da24bdff$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $13c94d10da24bdff$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $13c94d10da24bdff$var$_setPrototypeOf(o, p) {
    $13c94d10da24bdff$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $13c94d10da24bdff$var$_setPrototypeOf(o, p);
}
function $13c94d10da24bdff$var$_getPrototypeOf(o) {
    $13c94d10da24bdff$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $13c94d10da24bdff$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $13c94d10da24bdff$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $13c94d10da24bdff$var$_inherits(ParseError, _Error);
    var _super = $13c94d10da24bdff$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $13c94d10da24bdff$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($13c94d10da24bdff$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $13c94d10da24bdff$var$_createClass(ParseError);
}(/*#__PURE__*/ $13c94d10da24bdff$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $166b3edfb32f0767$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $9c954729eb8f917f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9c954729eb8f917f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9c954729eb8f917f$var$_typeof(obj);
}
function $9c954729eb8f917f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9c954729eb8f917f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9c954729eb8f917f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9c954729eb8f917f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9c954729eb8f917f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $9c954729eb8f917f$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $9c954729eb8f917f$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $9c954729eb8f917f$var$V4 = "1.7.35";
var $9c954729eb8f917f$var$DEFAULT_EXT_PREFIX = " ext. ";
var $9c954729eb8f917f$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $9c954729eb8f917f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $9c954729eb8f917f$var$_classCallCheck(this, Metadata);
        $9c954729eb8f917f$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $9c954729eb8f917f$var$setVersion.call(this, metadata);
    }
    $9c954729eb8f917f$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $9c954729eb8f917f$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $9c954729eb8f917f$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $9c954729eb8f917f$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $9c954729eb8f917f$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $9c954729eb8f917f$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $9c954729eb8f917f$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $9c954729eb8f917f$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $9c954729eb8f917f$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $9c954729eb8f917f$var$getType(this.types(), _type2)) return new $9c954729eb8f917f$var$Type($9c954729eb8f917f$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $9c954729eb8f917f$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $9c954729eb8f917f$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $9c954729eb8f917f$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $9c954729eb8f917f$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $9c954729eb8f917f$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$9c954729eb8f917f$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $9c954729eb8f917f$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $9c954729eb8f917f$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $9c954729eb8f917f$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $9c954729eb8f917f$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $9c954729eb8f917f$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $9c954729eb8f917f$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
    // For that reason, it's not used in this detection algorithm.
    // Instead, it detects by `countries: {}` property existence.
    if (!(0, $187749ebc16b0fee$export$2e2bcd8739ae039)(metadata) || !(0, $187749ebc16b0fee$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $187749ebc16b0fee$export$2e2bcd8739ae039)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $9c954729eb8f917f$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $9c954729eb8f917f$var$typeOf = function typeOf(_) {
    return $9c954729eb8f917f$var$_typeof(_);
};
function $9c954729eb8f917f$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $9c954729eb8f917f$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $9c954729eb8f917f$var$DEFAULT_EXT_PREFIX;
}
function $9c954729eb8f917f$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $9c954729eb8f917f$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $9c954729eb8f917f$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $9c954729eb8f917f$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $166b3edfb32f0767$export$2e2bcd8739ae039)(version, $9c954729eb8f917f$var$V3) === -1) this.v2 = true;
        else if ((0, $166b3edfb32f0767$export$2e2bcd8739ae039)(version, $9c954729eb8f917f$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $e30e46998f26599c$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $e30e46998f26599c$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $7b729a3d8cef317c$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $e30e46998f26599c$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $e30e46998f26599c$var$RFC3966_EXTN_PREFIX + $e30e46998f26599c$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $e30e46998f26599c$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $e30e46998f26599c$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $e30e46998f26599c$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $e30e46998f26599c$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $e30e46998f26599c$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $0aff5aa9bbad2524$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $7b729a3d8cef317c$export$852d1d4a47329634) + "]{" + (0, $7b729a3d8cef317c$export$cd8355bcbe13154) + "}"; //
var $0aff5aa9bbad2524$export$a77dd7471651eee = "[" + (0, $7b729a3d8cef317c$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $7b729a3d8cef317c$export$7f01587e28f9194) + "]*" + "[" + (0, $7b729a3d8cef317c$export$852d1d4a47329634) + "]" + "){3,}" + "[" + (0, $7b729a3d8cef317c$export$7f01587e28f9194) + (0, $7b729a3d8cef317c$export$852d1d4a47329634) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $0aff5aa9bbad2524$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $7b729a3d8cef317c$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $7b729a3d8cef317c$export$7f01587e28f9194) + "]*" + "[" + (0, $7b729a3d8cef317c$export$852d1d4a47329634) + "]" + "){1,2}" + "$", "i");
var $0aff5aa9bbad2524$export$a2d12a04749c087d = $0aff5aa9bbad2524$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $e30e46998f26599c$export$2e2bcd8739ae039)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $0aff5aa9bbad2524$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $0aff5aa9bbad2524$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $0aff5aa9bbad2524$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $0aff5aa9bbad2524$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $7b729a3d8cef317c$export$cd8355bcbe13154) && $0aff5aa9bbad2524$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $0aff5aa9bbad2524$export$4c3f76c95c05197c(number) {
    return $0aff5aa9bbad2524$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $03fae29dbea9b501$var$EXTN_PATTERN = new RegExp("(?:" + (0, $e30e46998f26599c$export$2e2bcd8739ae039)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $03fae29dbea9b501$export$2e2bcd8739ae039(number) {
    var start = number.search($03fae29dbea9b501$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($03fae29dbea9b501$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $dcc6f0ef0e37a279$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $dcc6f0ef0e37a279$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dcc6f0ef0e37a279$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dcc6f0ef0e37a279$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dcc6f0ef0e37a279$var$_arrayLikeToArray(o, minLen);
}
function $dcc6f0ef0e37a279$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $dcc6f0ef0e37a279$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "\uFF10": "0",
    // Fullwidth digit 0
    "\uFF11": "1",
    // Fullwidth digit 1
    "\uFF12": "2",
    // Fullwidth digit 2
    "\uFF13": "3",
    // Fullwidth digit 3
    "\uFF14": "4",
    // Fullwidth digit 4
    "\uFF15": "5",
    // Fullwidth digit 5
    "\uFF16": "6",
    // Fullwidth digit 6
    "\uFF17": "7",
    // Fullwidth digit 7
    "\uFF18": "8",
    // Fullwidth digit 8
    "\uFF19": "9",
    // Fullwidth digit 9
    "\u0660": "0",
    // Arabic-indic digit 0
    "\u0661": "1",
    // Arabic-indic digit 1
    "\u0662": "2",
    // Arabic-indic digit 2
    "\u0663": "3",
    // Arabic-indic digit 3
    "\u0664": "4",
    // Arabic-indic digit 4
    "\u0665": "5",
    // Arabic-indic digit 5
    "\u0666": "6",
    // Arabic-indic digit 6
    "\u0667": "7",
    // Arabic-indic digit 7
    "\u0668": "8",
    // Arabic-indic digit 8
    "\u0669": "9",
    // Arabic-indic digit 9
    "\u06F0": "0",
    // Eastern-Arabic digit 0
    "\u06F1": "1",
    // Eastern-Arabic digit 1
    "\u06F2": "2",
    // Eastern-Arabic digit 2
    "\u06F3": "3",
    // Eastern-Arabic digit 3
    "\u06F4": "4",
    // Eastern-Arabic digit 4
    "\u06F5": "5",
    // Eastern-Arabic digit 5
    "\u06F6": "6",
    // Eastern-Arabic digit 6
    "\u06F7": "7",
    // Eastern-Arabic digit 7
    "\u06F8": "8",
    // Eastern-Arabic digit 8
    "\u06F9": "9" // Eastern-Arabic digit 9
};
function $dcc6f0ef0e37a279$export$1d16fddea1437169(character) {
    return $dcc6f0ef0e37a279$export$2848f3d68c08fe69[character];
}
function $dcc6f0ef0e37a279$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $dcc6f0ef0e37a279$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $dcc6f0ef0e37a279$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $f4abb0ed8c9a6d4f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f4abb0ed8c9a6d4f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f4abb0ed8c9a6d4f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f4abb0ed8c9a6d4f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f4abb0ed8c9a6d4f$var$_arrayLikeToArray(o, minLen);
}
function $f4abb0ed8c9a6d4f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f4abb0ed8c9a6d4f$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $f4abb0ed8c9a6d4f$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $f4abb0ed8c9a6d4f$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $f4abb0ed8c9a6d4f$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === "function") emitEvent("end");
            return;
        }
        return "+";
    } // Allow digits.
    return (0, $dcc6f0ef0e37a279$export$1d16fddea1437169)(character);
}




function $a6d5b3a655357f96$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a6d5b3a655357f96$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a6d5b3a655357f96$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a6d5b3a655357f96$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a6d5b3a655357f96$var$_arrayLikeToArray(o, minLen);
}
function $a6d5b3a655357f96$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a6d5b3a655357f96$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $a6d5b3a655357f96$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $a60eb22392f79030$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $a60eb22392f79030$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $a60eb22392f79030$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $a60eb22392f79030$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $a6d5b3a655357f96$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}


function $fb850403a1870eb7$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $fb850403a1870eb7$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $fb850403a1870eb7$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $a60eb22392f79030$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $84f4c8c65b196754$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}




function $43334150645f8b82$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $43334150645f8b82$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $43334150645f8b82$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $43334150645f8b82$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $43334150645f8b82$var$_arrayLikeToArray(o, minLen);
}
function $43334150645f8b82$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $43334150645f8b82$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $43334150645f8b82$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $84f4c8c65b196754$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($43334150645f8b82$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($43334150645f8b82$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $43334150645f8b82$var$_createForOfIteratorHelperLoose($43334150645f8b82$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($43334150645f8b82$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $43334150645f8b82$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $84f4c8c65b196754$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $cfcdba18ad3613bd$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $43334150645f8b82$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $84f4c8c65b196754$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $bd3a7c9b15cc73de$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $bd3a7c9b15cc73de$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $bd3a7c9b15cc73de$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




var $6d6bb21f3745468c$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $7b729a3d8cef317c$export$852d1d4a47329634) + "])");
function $6d6bb21f3745468c$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($6d6bb21f3745468c$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $427595a8c8ebcdf9$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $12d3ea18f8c5c6f2$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $427595a8c8ebcdf9$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$12d3ea18f8c5c6f2$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$12d3ea18f8c5c6f2$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $12d3ea18f8c5c6f2$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $84f4c8c65b196754$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $84f4c8c65b196754$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $12d3ea18f8c5c6f2$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $a60eb22392f79030$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $93bdfd13082eb0d0$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $9c954729eb8f917f$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $12d3ea18f8c5c6f2$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $12d3ea18f8c5c6f2$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $84f4c8c65b196754$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $84f4c8c65b196754$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $a60eb22392f79030$export$2e2bcd8739ae039)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $ea31f058b21c5c81$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $6d6bb21f3745468c$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $93bdfd13082eb0d0$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $7b729a3d8cef317c$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }





function $286d1410a20837fc$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $7b729a3d8cef317c$export$7f01587e28f9194), "]+"), "g"), " ").trim();
}


var $4a1c324a17bb0e29$export$4f32ad1c51a7a6be = /(\$\d)/;
function $4a1c324a17bb0e29$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($4a1c324a17bb0e29$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $286d1410a20837fc$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $f57d54a0b6acbfd5$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $f57d54a0b6acbfd5$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($f57d54a0b6acbfd5$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $a806e4dcc978569b$var$_slicedToArray(arr, i) {
    return $a806e4dcc978569b$var$_arrayWithHoles(arr) || $a806e4dcc978569b$var$_iterableToArrayLimit(arr, i) || $a806e4dcc978569b$var$_unsupportedIterableToArray(arr, i) || $a806e4dcc978569b$var$_nonIterableRest();
}
function $a806e4dcc978569b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a806e4dcc978569b$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a806e4dcc978569b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a806e4dcc978569b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a806e4dcc978569b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a806e4dcc978569b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a806e4dcc978569b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a806e4dcc978569b$var$_arrayLikeToArray(o, minLen);
}
function $a806e4dcc978569b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a806e4dcc978569b$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $a806e4dcc978569b$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $a806e4dcc978569b$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $0aff5aa9bbad2524$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $a806e4dcc978569b$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}


function $8d62eff53d4f4e1b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $8d62eff53d4f4e1b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8d62eff53d4f4e1b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8d62eff53d4f4e1b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8d62eff53d4f4e1b$var$_arrayLikeToArray(o, minLen);
}
function $8d62eff53d4f4e1b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8d62eff53d4f4e1b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8d62eff53d4f4e1b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8d62eff53d4f4e1b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8d62eff53d4f4e1b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8d62eff53d4f4e1b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8d62eff53d4f4e1b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $8d62eff53d4f4e1b$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $8d62eff53d4f4e1b$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $8d62eff53d4f4e1b$var$_objectSpread($8d62eff53d4f4e1b$var$_objectSpread({}, $8d62eff53d4f4e1b$var$DEFAULT_OPTIONS), options);
    else options = $8d62eff53d4f4e1b$var$DEFAULT_OPTIONS;
    metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $8d62eff53d4f4e1b$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $8d62eff53d4f4e1b$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $8d62eff53d4f4e1b$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $8d62eff53d4f4e1b$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $a806e4dcc978569b$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $8d62eff53d4f4e1b$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $8d62eff53d4f4e1b$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $8d62eff53d4f4e1b$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $8d62eff53d4f4e1b$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $4a1c324a17bb0e29$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $8d62eff53d4f4e1b$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $8d62eff53d4f4e1b$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $84f4c8c65b196754$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $8d62eff53d4f4e1b$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $8d62eff53d4f4e1b$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $9c954729eb8f917f$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $8d62eff53d4f4e1b$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $f57d54a0b6acbfd5$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($8d62eff53d4f4e1b$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}


function $f4abf1c30da18766$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f4abf1c30da18766$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f4abf1c30da18766$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f4abf1c30da18766$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f4abf1c30da18766$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f4abf1c30da18766$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f4abf1c30da18766$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f4abf1c30da18766$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f4abf1c30da18766$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f4abf1c30da18766$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f4abf1c30da18766$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $f4abf1c30da18766$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $f4abf1c30da18766$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $f4abf1c30da18766$var$_classCallCheck(this, PhoneNumber);
        // Validate `countryOrCountryCallingCode` argument.
        if (!countryOrCountryCallingCode) throw new TypeError("First argument is required");
        if (typeof countryOrCountryCallingCode !== "string") throw new TypeError("First argument must be a string");
         // In case of public API use: `constructor(number, metadata)`.
        // Transform the arguments from `constructor(number, metadata)` to
        // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.
        if (typeof countryOrCountryCallingCode === "string") {
            if (countryOrCountryCallingCode[0] === "+" && !nationalNumber) throw new TypeError("`metadata` argument not passed");
            if ((0, $187749ebc16b0fee$export$2e2bcd8739ae039)(nationalNumber) && (0, $187749ebc16b0fee$export$2e2bcd8739ae039)(nationalNumber.countries)) {
                metadata = nationalNumber;
                var e164Number = countryOrCountryCallingCode;
                if (!$f4abf1c30da18766$var$E164_NUMBER_REGEXP.test(e164Number)) throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
                var _extractCountryCallin = (0, $ea31f058b21c5c81$export$2e2bcd8739ae039)(e164Number, undefined, undefined, metadata), _countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
                nationalNumber = number;
                countryOrCountryCallingCode = _countryCallingCode;
                if (!nationalNumber) throw new Error("Invalid `number` argument passed: too short");
            }
        } // Validate `nationalNumber` argument.
        if (!nationalNumber) throw new TypeError("`nationalNumber` argument is required");
        if (typeof nationalNumber !== "string") throw new TypeError("`nationalNumber` argument must be a string");
         // Validate `metadata` argument.
        (0, $9c954729eb8f917f$export$a0b100d4662a8795)(metadata); // Initialize properties.
        var _getCountryAndCountry = $f4abf1c30da18766$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $f4abf1c30da18766$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $bd3a7c9b15cc73de$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $fb850403a1870eb7$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $cfcdba18ad3613bd$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $43334150645f8b82$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $8d62eff53d4f4e1b$export$2e2bcd8739ae039)(this, _format, options ? $f4abf1c30da18766$var$_objectSpread($f4abf1c30da18766$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $f4abf1c30da18766$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $f4abf1c30da18766$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($f4abf1c30da18766$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($f4abf1c30da18766$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}
var $f4abf1c30da18766$var$E164_NUMBER_REGEXP = /^\+\d+$/;








function $d9f158461385f37a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d9f158461385f37a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d9f158461385f37a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d9f158461385f37a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d9f158461385f37a$var$_arrayLikeToArray(o, minLen);
}
function $d9f158461385f37a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d9f158461385f37a$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata); // const matchingCountries = []
    for(var _iterator = $d9f158461385f37a$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $43334150645f8b82$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // If both the `defaultCountry` and the "main" one match the phone number,
        // don't prefer the `defaultCountry` over the "main" one.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
    } // // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}


var $cd765c9d3bc2f522$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $cd765c9d3bc2f522$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($cd765c9d3bc2f522$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $d9f158461385f37a$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $91a2c357c62a959b$export$1ddc7eed78155f68 = "+";
var $91a2c357c62a959b$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $91a2c357c62a959b$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $7b729a3d8cef317c$export$852d1d4a47329634) + "]" + "|" + $91a2c357c62a959b$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $91a2c357c62a959b$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $91a2c357c62a959b$export$1ddc7eed78155f68 + $91a2c357c62a959b$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $7b729a3d8cef317c$export$852d1d4a47329634) + "]" + $91a2c357c62a959b$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $91a2c357c62a959b$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($91a2c357c62a959b$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $91a2c357c62a959b$var$ALPHANUM_ = (0, $7b729a3d8cef317c$export$852d1d4a47329634);
var $91a2c357c62a959b$var$RFC3966_DOMAINLABEL_ = "[" + $91a2c357c62a959b$var$ALPHANUM_ + "]+((\\-)*[" + $91a2c357c62a959b$var$ALPHANUM_ + "])*";
var $91a2c357c62a959b$var$VALID_ALPHA_ = "a-zA-Z";
var $91a2c357c62a959b$var$RFC3966_TOPLABEL_ = "[" + $91a2c357c62a959b$var$VALID_ALPHA_ + "]+((\\-)*[" + $91a2c357c62a959b$var$ALPHANUM_ + "])*";
var $91a2c357c62a959b$var$RFC3966_DOMAINNAME_ = "^(" + $91a2c357c62a959b$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $91a2c357c62a959b$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $91a2c357c62a959b$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($91a2c357c62a959b$var$RFC3966_DOMAINNAME_, "g");
var $91a2c357c62a959b$export$70d485ce3f6de783 = "tel:";
var $91a2c357c62a959b$export$f6d5879d582c3a27 = ";phone-context=";
var $91a2c357c62a959b$export$9e356e12edb00a81 = ";isub=";
function $91a2c357c62a959b$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($91a2c357c62a959b$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $91a2c357c62a959b$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $91a2c357c62a959b$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $91a2c357c62a959b$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $91a2c357c62a959b$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $3913e4bda12563bc$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $91a2c357c62a959b$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $91a2c357c62a959b$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $13c94d10da24bdff$export$2e2bcd8739ae039)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $91a2c357c62a959b$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $91a2c357c62a959b$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $91a2c357c62a959b$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $91a2c357c62a959b$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $91a2c357c62a959b$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $98a1a4a2c797ca15$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $98a1a4a2c797ca15$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $7b729a3d8cef317c$export$207c99ccf3902df8) + (0, $7b729a3d8cef317c$export$852d1d4a47329634) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $98a1a4a2c797ca15$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $7b729a3d8cef317c$export$852d1d4a47329634) + "#" + "]+$");
var $98a1a4a2c797ca15$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $98a1a4a2c797ca15$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $9c954729eb8f917f$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $13c94d10da24bdff$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $98a1a4a2c797ca15$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $13c94d10da24bdff$export$2e2bcd8739ae039)("TOO_SHORT");
            throw new (0, $13c94d10da24bdff$export$2e2bcd8739ae039)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $98a1a4a2c797ca15$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $13c94d10da24bdff$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $7b729a3d8cef317c$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $13c94d10da24bdff$export$2e2bcd8739ae039)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $7b729a3d8cef317c$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $13c94d10da24bdff$export$2e2bcd8739ae039)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $f4abf1c30da18766$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $84f4c8c65b196754$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $98a1a4a2c797ca15$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $fb850403a1870eb7$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $98a1a4a2c797ca15$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $98a1a4a2c797ca15$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $13c94d10da24bdff$export$2e2bcd8739ae039)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($98a1a4a2c797ca15$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($98a1a4a2c797ca15$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $98a1a4a2c797ca15$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $3913e4bda12563bc$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $98a1a4a2c797ca15$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $0aff5aa9bbad2524$export$2e2bcd8739ae039)(number)) {
        if ((0, $0aff5aa9bbad2524$export$4c3f76c95c05197c)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $03fae29dbea9b501$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $98a1a4a2c797ca15$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $98a1a4a2c797ca15$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $ea31f058b21c5c81$export$2e2bcd8739ae039)((0, $f4abb0ed8c9a6d4f$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($98a1a4a2c797ca15$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $9c954729eb8f917f$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $12d3ea18f8c5c6f2$export$2e2bcd8739ae039)((0, $f4abb0ed8c9a6d4f$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $cd765c9d3bc2f522$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $ce4483debc65363a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ce4483debc65363a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ce4483debc65363a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ce4483debc65363a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ce4483debc65363a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ce4483debc65363a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ce4483debc65363a$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $98a1a4a2c797ca15$export$2e2bcd8739ae039)(text, $ce4483debc65363a$var$_objectSpread($ce4483debc65363a$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $a7670ff8c13cde96$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a7670ff8c13cde96$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a7670ff8c13cde96$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a7670ff8c13cde96$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a7670ff8c13cde96$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a7670ff8c13cde96$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a7670ff8c13cde96$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $9c954729eb8f917f$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $a7670ff8c13cde96$var$_objectSpread($a7670ff8c13cde96$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $ce4483debc65363a$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $13c94d10da24bdff$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $aff1ecce57ca4478$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $f3f1f00db021ee2f$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $a7670ff8c13cde96$export$2e2bcd8739ae039)(text, options, metadata);
}


function $e4f11fc5352a5db5$export$da44e4eaa54bc82e() {
    return (0, $3ad49d0a568a3239$export$2e2bcd8739ae039)((0, $aff1ecce57ca4478$export$2e2bcd8739ae039), arguments);
}


function $4f84ffe9ae203298$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $4f84ffe9ae203298$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4f84ffe9ae203298$export$2e2bcd8739ae039(o);
}


function $d12a27f68fbe2a7a$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $4eac89b3ecff60ca$export$2e2bcd8739ae039(value) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $4f84ffe9ae203298$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $57ad6a2f8ace4ec4$export$2e2bcd8739ae039(argument) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $4f84ffe9ae203298$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $83f91475bb6c1912$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $4eac89b3ecff60ca$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $f3af13645545885b$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $1c692760dc7b33ea$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $f3af13645545885b$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $e4a0afd5d1e802ec$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $f3af13645545885b$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $1c692760dc7b33ea$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $e8402968635b99f6$var$MILLISECONDS_IN_DAY = 86400000;
function $e8402968635b99f6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $e8402968635b99f6$var$MILLISECONDS_IN_DAY) + 1;
}





function $a11ed43453ee1d76$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $461b347bdbc56d5f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $a11ed43453ee1d76$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $a11ed43453ee1d76$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $0e501eb373f875f4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $461b347bdbc56d5f$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $a11ed43453ee1d76$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $a7e540d9a67388a2$var$MILLISECONDS_IN_WEEK = 604800000;
function $a7e540d9a67388a2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $a11ed43453ee1d76$export$2e2bcd8739ae039)(date).getTime() - (0, $0e501eb373f875f4$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $a7e540d9a67388a2$var$MILLISECONDS_IN_WEEK) + 1;
}







var $6e3145262e897fb9$var$defaultOptions = {};
function $6e3145262e897fb9$export$430a3269e24b912e() {
    return $6e3145262e897fb9$var$defaultOptions;
}
function $6e3145262e897fb9$export$95365be1b0704abc(newOptions) {
    $6e3145262e897fb9$var$defaultOptions = newOptions;
}


function $a6072dde7f21956b$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $6e3145262e897fb9$export$430a3269e24b912e)();
    var weekStartsOn = (0, $f3af13645545885b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $d6197f3d8fbde7e5$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $6e3145262e897fb9$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $f3af13645545885b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $a6072dde7f21956b$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $a6072dde7f21956b$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $b0cd34b08445503e$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $6e3145262e897fb9$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $f3af13645545885b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $d6197f3d8fbde7e5$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $a6072dde7f21956b$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $486444282030dfb2$var$MILLISECONDS_IN_WEEK = 604800000;
function $486444282030dfb2$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $a6072dde7f21956b$export$2e2bcd8739ae039)(date, options).getTime() - (0, $b0cd34b08445503e$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $486444282030dfb2$var$MILLISECONDS_IN_WEEK) + 1;
}



function $1a58e170c39d3e55$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $ae1f8d3bfec8cc3c$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $ae1f8d3bfec8cc3c$export$2e2bcd8739ae039 = $ae1f8d3bfec8cc3c$var$formatters;


var $918df7d4e8d7cf71$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $918df7d4e8d7cf71$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $ae1f8d3bfec8cc3c$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $d6197f3d8fbde7e5$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $461b347bdbc56d5f$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $ae1f8d3bfec8cc3c$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $486444282030dfb2$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $a7e540d9a67388a2$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $ae1f8d3bfec8cc3c$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $e8402968635b99f6$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $918df7d4e8d7cf71$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $918df7d4e8d7cf71$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $918df7d4e8d7cf71$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $918df7d4e8d7cf71$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $918df7d4e8d7cf71$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $918df7d4e8d7cf71$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $ae1f8d3bfec8cc3c$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $ae1f8d3bfec8cc3c$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $ae1f8d3bfec8cc3c$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $ae1f8d3bfec8cc3c$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $ae1f8d3bfec8cc3c$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $918df7d4e8d7cf71$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $918df7d4e8d7cf71$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $918df7d4e8d7cf71$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $918df7d4e8d7cf71$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $918df7d4e8d7cf71$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $918df7d4e8d7cf71$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $918df7d4e8d7cf71$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $918df7d4e8d7cf71$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $918df7d4e8d7cf71$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $918df7d4e8d7cf71$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $918df7d4e8d7cf71$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(minutes, 2);
}
function $918df7d4e8d7cf71$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $918df7d4e8d7cf71$var$formatTimezone(offset, dirtyDelimiter);
}
function $918df7d4e8d7cf71$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $1a58e170c39d3e55$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $918df7d4e8d7cf71$export$2e2bcd8739ae039 = $918df7d4e8d7cf71$var$formatters;


var $168acdc47657ac1b$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $168acdc47657ac1b$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $168acdc47657ac1b$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $168acdc47657ac1b$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $168acdc47657ac1b$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $168acdc47657ac1b$var$timeLongFormatter(timePattern, formatLong));
};
var $168acdc47657ac1b$var$longFormatters = {
    p: $168acdc47657ac1b$var$timeLongFormatter,
    P: $168acdc47657ac1b$var$dateTimeLongFormatter
};
var $168acdc47657ac1b$export$2e2bcd8739ae039 = $168acdc47657ac1b$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $cc5f146101733a31$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $db69534ad6078474$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $db69534ad6078474$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $db69534ad6078474$export$c6cc36aa33304772(token) {
    return $db69534ad6078474$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $db69534ad6078474$export$c6b49d6dceb604a1(token) {
    return $db69534ad6078474$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $db69534ad6078474$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $e5ea6a74e7a491ea$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $e5ea6a74e7a491ea$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e5ea6a74e7a491ea$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $e5ea6a74e7a491ea$export$2e2bcd8739ae039 = $e5ea6a74e7a491ea$var$formatDistance;


function $d851261eb9e02291$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $814f6f790169bc3a$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $814f6f790169bc3a$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $814f6f790169bc3a$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $814f6f790169bc3a$var$formatLong = {
    date: (0, $d851261eb9e02291$export$2e2bcd8739ae039)({
        formats: $814f6f790169bc3a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $d851261eb9e02291$export$2e2bcd8739ae039)({
        formats: $814f6f790169bc3a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $d851261eb9e02291$export$2e2bcd8739ae039)({
        formats: $814f6f790169bc3a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $814f6f790169bc3a$export$2e2bcd8739ae039 = $814f6f790169bc3a$var$formatLong;


var $0f98770aff11b355$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $0f98770aff11b355$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0f98770aff11b355$var$formatRelativeLocale[token];
};
var $0f98770aff11b355$export$2e2bcd8739ae039 = $0f98770aff11b355$var$formatRelative;


function $384ff0d146f0efde$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $f7a813b8d373a7ca$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $f7a813b8d373a7ca$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $f7a813b8d373a7ca$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $f7a813b8d373a7ca$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $f7a813b8d373a7ca$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $f7a813b8d373a7ca$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $f7a813b8d373a7ca$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $f7a813b8d373a7ca$var$localize = {
    ordinalNumber: $f7a813b8d373a7ca$var$ordinalNumber,
    era: (0, $384ff0d146f0efde$export$2e2bcd8739ae039)({
        values: $f7a813b8d373a7ca$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $384ff0d146f0efde$export$2e2bcd8739ae039)({
        values: $f7a813b8d373a7ca$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $384ff0d146f0efde$export$2e2bcd8739ae039)({
        values: $f7a813b8d373a7ca$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $384ff0d146f0efde$export$2e2bcd8739ae039)({
        values: $f7a813b8d373a7ca$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $384ff0d146f0efde$export$2e2bcd8739ae039)({
        values: $f7a813b8d373a7ca$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f7a813b8d373a7ca$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $f7a813b8d373a7ca$export$2e2bcd8739ae039 = $f7a813b8d373a7ca$var$localize;


function $9dec7ad8643504ac$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $9dec7ad8643504ac$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $9dec7ad8643504ac$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $9dec7ad8643504ac$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $9dec7ad8643504ac$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $2109559b2c38b9a9$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $8d3e7683ff548be5$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $8d3e7683ff548be5$var$parseOrdinalNumberPattern = /\d+/i;
var $8d3e7683ff548be5$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $8d3e7683ff548be5$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $8d3e7683ff548be5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $8d3e7683ff548be5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8d3e7683ff548be5$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $8d3e7683ff548be5$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $8d3e7683ff548be5$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $8d3e7683ff548be5$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $8d3e7683ff548be5$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $8d3e7683ff548be5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $8d3e7683ff548be5$var$match = {
    ordinalNumber: (0, $2109559b2c38b9a9$export$2e2bcd8739ae039)({
        matchPattern: $8d3e7683ff548be5$var$matchOrdinalNumberPattern,
        parsePattern: $8d3e7683ff548be5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $9dec7ad8643504ac$export$2e2bcd8739ae039)({
        matchPatterns: $8d3e7683ff548be5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8d3e7683ff548be5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $9dec7ad8643504ac$export$2e2bcd8739ae039)({
        matchPatterns: $8d3e7683ff548be5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8d3e7683ff548be5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $9dec7ad8643504ac$export$2e2bcd8739ae039)({
        matchPatterns: $8d3e7683ff548be5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8d3e7683ff548be5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $9dec7ad8643504ac$export$2e2bcd8739ae039)({
        matchPatterns: $8d3e7683ff548be5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8d3e7683ff548be5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $9dec7ad8643504ac$export$2e2bcd8739ae039)({
        matchPatterns: $8d3e7683ff548be5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8d3e7683ff548be5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $8d3e7683ff548be5$export$2e2bcd8739ae039 = $8d3e7683ff548be5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $06a86a86a3f7bb82$var$locale = {
    code: "en-US",
    formatDistance: (0, $e5ea6a74e7a491ea$export$2e2bcd8739ae039),
    formatLong: (0, $814f6f790169bc3a$export$2e2bcd8739ae039),
    formatRelative: (0, $0f98770aff11b355$export$2e2bcd8739ae039),
    localize: (0, $f7a813b8d373a7ca$export$2e2bcd8739ae039),
    match: (0, $8d3e7683ff548be5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $06a86a86a3f7bb82$export$2e2bcd8739ae039 = $06a86a86a3f7bb82$var$locale;


var $46f8710aa8a87258$export$2e2bcd8739ae039 = (0, $06a86a86a3f7bb82$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $de2ab8211093dff3$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $de2ab8211093dff3$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $de2ab8211093dff3$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $de2ab8211093dff3$var$doubleQuoteRegExp = /''/g;
var $de2ab8211093dff3$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $de2ab8211093dff3$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $6e3145262e897fb9$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $46f8710aa8a87258$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $f3af13645545885b$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $f3af13645545885b$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $83f91475bb6c1912$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $cc5f146101733a31$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $e4a0afd5d1e802ec$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($de2ab8211093dff3$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $168acdc47657ac1b$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($de2ab8211093dff3$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $de2ab8211093dff3$var$cleanEscapedString(substring);
        var formatter = (0, $918df7d4e8d7cf71$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $db69534ad6078474$export$c6b49d6dceb604a1)(substring)) (0, $db69534ad6078474$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $db69534ad6078474$export$c6cc36aa33304772)(substring)) (0, $db69534ad6078474$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($de2ab8211093dff3$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $de2ab8211093dff3$var$cleanEscapedString(input) {
    var matched = input.match($de2ab8211093dff3$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($de2ab8211093dff3$var$doubleQuoteRegExp, "'");
}



var $bnENU = parcelRequire("bnENU");
let $ebe13ae6beedf8ab$var$e = {
    data: ""
}, $ebe13ae6beedf8ab$var$t = (t)=>{
    if ("object" == typeof window) {
        let e = (t ? t.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), {
            innerHTML: " ",
            id: "_goober"
        });
        return e.nonce = window.__nonce__, e.parentNode || (t || document.head).appendChild(e), e.firstChild;
    }
    return t || $ebe13ae6beedf8ab$var$e;
}, $ebe13ae6beedf8ab$export$54aba348a7896325 = (e)=>{
    let r = $ebe13ae6beedf8ab$var$t(e), l = r.data;
    return r.data = "", l;
}, $ebe13ae6beedf8ab$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $ebe13ae6beedf8ab$var$a = /\/\*[^]*?\*\/|  +/g, $ebe13ae6beedf8ab$var$n = /\n+/g, $ebe13ae6beedf8ab$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $ebe13ae6beedf8ab$var$o(c, n) : n + "{" + $ebe13ae6beedf8ab$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $ebe13ae6beedf8ab$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $ebe13ae6beedf8ab$var$o.p ? $ebe13ae6beedf8ab$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $ebe13ae6beedf8ab$var$c = {}, $ebe13ae6beedf8ab$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $ebe13ae6beedf8ab$var$s(e[r]);
        return t;
    }
    return e;
}, $ebe13ae6beedf8ab$var$i = (e, t, r, i, p)=>{
    let u = $ebe13ae6beedf8ab$var$s(e), d = $ebe13ae6beedf8ab$var$c[u] || ($ebe13ae6beedf8ab$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$ebe13ae6beedf8ab$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $ebe13ae6beedf8ab$var$l.exec(e.replace($ebe13ae6beedf8ab$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($ebe13ae6beedf8ab$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($ebe13ae6beedf8ab$var$n, " ").trim();
            return o[0];
        })(e);
        $ebe13ae6beedf8ab$var$c[d] = $ebe13ae6beedf8ab$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $ebe13ae6beedf8ab$var$c.g ? $ebe13ae6beedf8ab$var$c.g : null;
    return r && ($ebe13ae6beedf8ab$var$c.g = $ebe13ae6beedf8ab$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($ebe13ae6beedf8ab$var$c[d], t, i, f), d;
}, $ebe13ae6beedf8ab$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $ebe13ae6beedf8ab$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $ebe13ae6beedf8ab$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $ebe13ae6beedf8ab$var$i(l.unshift ? l.raw ? $ebe13ae6beedf8ab$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $ebe13ae6beedf8ab$var$t(r.target), r.g, r.o, r.k);
}
let $ebe13ae6beedf8ab$var$d, $ebe13ae6beedf8ab$var$f, $ebe13ae6beedf8ab$var$g, $ebe13ae6beedf8ab$export$442f1a04865e4790 = $ebe13ae6beedf8ab$export$dbf350e5966cf602.bind({
    g: 1
}), $ebe13ae6beedf8ab$export$d25ddfdf17c3ad3e = $ebe13ae6beedf8ab$export$dbf350e5966cf602.bind({
    k: 1
});
function $ebe13ae6beedf8ab$export$de27182ff8187d6c(e, t, r, l) {
    $ebe13ae6beedf8ab$var$o.p = t, $ebe13ae6beedf8ab$var$d = e, $ebe13ae6beedf8ab$var$f = r, $ebe13ae6beedf8ab$var$g = l;
}
function $ebe13ae6beedf8ab$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $ebe13ae6beedf8ab$var$f && $ebe13ae6beedf8ab$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $ebe13ae6beedf8ab$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $ebe13ae6beedf8ab$var$g && i[0] && $ebe13ae6beedf8ab$var$g(c), $ebe13ae6beedf8ab$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}


"use client";
var $71a78e40f6b201d2$var$Z = (e)=>typeof e == "function", $71a78e40f6b201d2$export$d812c8e1906863d0 = (e, t)=>$71a78e40f6b201d2$var$Z(e) ? e(t) : e;
var $71a78e40f6b201d2$var$W = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $71a78e40f6b201d2$var$E = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();
var $71a78e40f6b201d2$var$re = 20, $71a78e40f6b201d2$var$k = "default";
var $71a78e40f6b201d2$var$H = (e, t)=>{
    let { toastLimit: o } = e.settings;
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, o)
            };
        case 1:
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === t.toast.id ? {
                        ...r,
                        ...t.toast
                    } : r)
            };
        case 2:
            let { toast: s } = t;
            return $71a78e40f6b201d2$var$H(e, {
                type: e.toasts.find((r)=>r.id === s.id) ? 1 : 0,
                toast: s
            });
        case 3:
            let { toastId: a } = t;
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === a || a === void 0 ? {
                        ...r,
                        dismissed: !0,
                        visible: !1
                    } : r)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((r)=>r.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let i = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((r)=>({
                        ...r,
                        pauseDuration: r.pauseDuration + i
                    }))
            };
    }
}, $71a78e40f6b201d2$var$v = [], $71a78e40f6b201d2$var$j = {
    toasts: [],
    pausedAt: void 0,
    settings: {
        toastLimit: $71a78e40f6b201d2$var$re
    }
}, $71a78e40f6b201d2$var$f = {}, $71a78e40f6b201d2$var$Y = (e, t = $71a78e40f6b201d2$var$k)=>{
    $71a78e40f6b201d2$var$f[t] = $71a78e40f6b201d2$var$H($71a78e40f6b201d2$var$f[t] || $71a78e40f6b201d2$var$j, e), $71a78e40f6b201d2$var$v.forEach(([o, s])=>{
        o === t && s($71a78e40f6b201d2$var$f[t]);
    });
}, $71a78e40f6b201d2$var$_ = (e)=>Object.keys($71a78e40f6b201d2$var$f).forEach((t)=>$71a78e40f6b201d2$var$Y(e, t)), $71a78e40f6b201d2$var$Q = (e)=>Object.keys($71a78e40f6b201d2$var$f).find((t)=>$71a78e40f6b201d2$var$f[t].toasts.some((o)=>o.id === e)), $71a78e40f6b201d2$var$S = (e = $71a78e40f6b201d2$var$k)=>(t)=>{
        $71a78e40f6b201d2$var$Y(t, e);
    }, $71a78e40f6b201d2$var$se = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $71a78e40f6b201d2$export$3960353ab538dc47 = (e = {}, t = $71a78e40f6b201d2$var$k)=>{
    let [o, s] = (0, $bnENU.useState)($71a78e40f6b201d2$var$f[t] || $71a78e40f6b201d2$var$j), a = (0, $bnENU.useRef)($71a78e40f6b201d2$var$f[t]);
    (0, $bnENU.useEffect)(()=>(a.current !== $71a78e40f6b201d2$var$f[t] && s($71a78e40f6b201d2$var$f[t]), $71a78e40f6b201d2$var$v.push([
            t,
            s
        ]), ()=>{
            let r = $71a78e40f6b201d2$var$v.findIndex(([l])=>l === t);
            r > -1 && $71a78e40f6b201d2$var$v.splice(r, 1);
        }), [
        t
    ]);
    let i = o.toasts.map((r)=>{
        var l, g, T;
        return {
            ...e,
            ...e[r.type],
            ...r,
            removeDelay: r.removeDelay || ((l = e[r.type]) == null ? void 0 : l.removeDelay) || (e == null ? void 0 : e.removeDelay),
            duration: r.duration || ((g = e[r.type]) == null ? void 0 : g.duration) || (e == null ? void 0 : e.duration) || $71a78e40f6b201d2$var$se[r.type],
            style: {
                ...e.style,
                ...(T = e[r.type]) == null ? void 0 : T.style,
                ...r.style
            }
        };
    });
    return {
        ...o,
        toasts: i
    };
};
var $71a78e40f6b201d2$var$ie = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        dismissed: !1,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $71a78e40f6b201d2$var$W()
    }), $71a78e40f6b201d2$var$P = (e)=>(t, o)=>{
        let s = $71a78e40f6b201d2$var$ie(t, e, o);
        return $71a78e40f6b201d2$var$S(s.toasterId || $71a78e40f6b201d2$var$Q(s.id))({
            type: 2,
            toast: s
        }), s.id;
    }, $71a78e40f6b201d2$export$b410431fab84fa58 = (e, t)=>$71a78e40f6b201d2$var$P("blank")(e, t);
$71a78e40f6b201d2$export$b410431fab84fa58.error = $71a78e40f6b201d2$var$P("error");
$71a78e40f6b201d2$export$b410431fab84fa58.success = $71a78e40f6b201d2$var$P("success");
$71a78e40f6b201d2$export$b410431fab84fa58.loading = $71a78e40f6b201d2$var$P("loading");
$71a78e40f6b201d2$export$b410431fab84fa58.custom = $71a78e40f6b201d2$var$P("custom");
$71a78e40f6b201d2$export$b410431fab84fa58.dismiss = (e, t)=>{
    let o = {
        type: 3,
        toastId: e
    };
    t ? $71a78e40f6b201d2$var$S(t)(o) : $71a78e40f6b201d2$var$_(o);
};
$71a78e40f6b201d2$export$b410431fab84fa58.dismissAll = (e)=>$71a78e40f6b201d2$export$b410431fab84fa58.dismiss(void 0, e);
$71a78e40f6b201d2$export$b410431fab84fa58.remove = (e, t)=>{
    let o = {
        type: 4,
        toastId: e
    };
    t ? $71a78e40f6b201d2$var$S(t)(o) : $71a78e40f6b201d2$var$_(o);
};
$71a78e40f6b201d2$export$b410431fab84fa58.removeAll = (e)=>$71a78e40f6b201d2$export$b410431fab84fa58.remove(void 0, e);
$71a78e40f6b201d2$export$b410431fab84fa58.promise = (e, t, o)=>{
    let s = $71a78e40f6b201d2$export$b410431fab84fa58.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return typeof e == "function" && (e = e()), e.then((a)=>{
        let i = t.success ? $71a78e40f6b201d2$export$d812c8e1906863d0(t.success, a) : void 0;
        return i ? $71a78e40f6b201d2$export$b410431fab84fa58.success(i, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }) : $71a78e40f6b201d2$export$b410431fab84fa58.dismiss(s), a;
    }).catch((a)=>{
        let i = t.error ? $71a78e40f6b201d2$export$d812c8e1906863d0(t.error, a) : void 0;
        i ? $71a78e40f6b201d2$export$b410431fab84fa58.error(i, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        }) : $71a78e40f6b201d2$export$b410431fab84fa58.dismiss(s);
    }), e;
};
var $71a78e40f6b201d2$var$ce = 1e3, $71a78e40f6b201d2$export$f46171b59bb094f9 = (e, t = "default")=>{
    let { toasts: o, pausedAt: s } = $71a78e40f6b201d2$export$3960353ab538dc47(e, t), a = (0, $bnENU.useRef)(new Map).current, i = (0, $bnENU.useCallback)((c, m = $71a78e40f6b201d2$var$ce)=>{
        if (a.has(c)) return;
        let p = setTimeout(()=>{
            a.delete(c), r({
                type: 4,
                toastId: c
            });
        }, m);
        a.set(c, p);
    }, []);
    (0, $bnENU.useEffect)(()=>{
        if (s) return;
        let c = Date.now(), m = o.map((p)=>{
            if (p.duration === 1 / 0) return;
            let R = (p.duration || 0) + p.pauseDuration - (c - p.createdAt);
            if (R < 0) {
                p.visible && $71a78e40f6b201d2$export$b410431fab84fa58.dismiss(p.id);
                return;
            }
            return setTimeout(()=>$71a78e40f6b201d2$export$b410431fab84fa58.dismiss(p.id, t), R);
        });
        return ()=>{
            m.forEach((p)=>p && clearTimeout(p));
        };
    }, [
        o,
        s,
        t
    ]);
    let r = (0, $bnENU.useCallback)($71a78e40f6b201d2$var$S(t), [
        t
    ]), l = (0, $bnENU.useCallback)(()=>{
        r({
            type: 5,
            time: Date.now()
        });
    }, [
        r
    ]), g = (0, $bnENU.useCallback)((c, m)=>{
        r({
            type: 1,
            toast: {
                id: c,
                height: m
            }
        });
    }, [
        r
    ]), T = (0, $bnENU.useCallback)(()=>{
        s && r({
            type: 6,
            time: Date.now()
        });
    }, [
        s,
        r
    ]), d = (0, $bnENU.useCallback)((c, m)=>{
        let { reverseOrder: p = !1, gutter: R = 8, defaultPosition: z } = m || {}, O = o.filter((u)=>(u.position || z) === (c.position || z) && u.height), K = O.findIndex((u)=>u.id === c.id), B = O.filter((u, I)=>I < K && u.visible).length;
        return O.filter((u)=>u.visible).slice(...p ? [
            B + 1
        ] : [
            0,
            B
        ]).reduce((u, I)=>u + (I.height || 0) + R, 0);
    }, [
        o
    ]);
    return (0, $bnENU.useEffect)(()=>{
        o.forEach((c)=>{
            if (c.dismissed) i(c.id, c.removeDelay);
            else {
                let m = a.get(c.id);
                m && (clearTimeout(m), a.delete(c.id));
            }
        });
    }, [
        o,
        i
    ]), {
        toasts: o,
        handlers: {
            updateHeight: g,
            startPause: l,
            endPause: T,
            calculateOffset: d
        }
    };
};
var $71a78e40f6b201d2$var$de = (0, $ebe13ae6beedf8ab$export$d25ddfdf17c3ad3e)`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $71a78e40f6b201d2$var$me = (0, $ebe13ae6beedf8ab$export$d25ddfdf17c3ad3e)`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $71a78e40f6b201d2$var$le = (0, $ebe13ae6beedf8ab$export$d25ddfdf17c3ad3e)`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $71a78e40f6b201d2$export$19bc16ee58e19b3d = (0, $ebe13ae6beedf8ab$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$71a78e40f6b201d2$var$de} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$71a78e40f6b201d2$var$me} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$71a78e40f6b201d2$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;
var $71a78e40f6b201d2$var$Te = (0, $ebe13ae6beedf8ab$export$d25ddfdf17c3ad3e)`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $71a78e40f6b201d2$export$647aae5028016fe9 = (0, $ebe13ae6beedf8ab$export$3817b7a54a07cec7)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$71a78e40f6b201d2$var$Te} 1s linear infinite;
`;
var $71a78e40f6b201d2$var$ge = (0, $ebe13ae6beedf8ab$export$d25ddfdf17c3ad3e)`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $71a78e40f6b201d2$var$he = (0, $ebe13ae6beedf8ab$export$d25ddfdf17c3ad3e)`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $71a78e40f6b201d2$export$906a919e30cdbd5c = (0, $ebe13ae6beedf8ab$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$71a78e40f6b201d2$var$ge} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$71a78e40f6b201d2$var$he} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $71a78e40f6b201d2$var$be = (0, $ebe13ae6beedf8ab$export$3817b7a54a07cec7)("div")`
  position: absolute;
`, $71a78e40f6b201d2$var$Se = (0, $ebe13ae6beedf8ab$export$3817b7a54a07cec7)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $71a78e40f6b201d2$var$Ae = (0, $ebe13ae6beedf8ab$export$d25ddfdf17c3ad3e)`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $71a78e40f6b201d2$var$Pe = (0, $ebe13ae6beedf8ab$export$3817b7a54a07cec7)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$71a78e40f6b201d2$var$Ae} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $71a78e40f6b201d2$export$55554e87ff8bb60f = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $bnENU.createElement($71a78e40f6b201d2$var$Pe, null, t) : t : o === "blank" ? null : $bnENU.createElement($71a78e40f6b201d2$var$Se, null, $bnENU.createElement($71a78e40f6b201d2$export$647aae5028016fe9, {
        ...s
    }), o !== "loading" && $bnENU.createElement($71a78e40f6b201d2$var$be, null, o === "error" ? $bnENU.createElement($71a78e40f6b201d2$export$19bc16ee58e19b3d, {
        ...s
    }) : $bnENU.createElement($71a78e40f6b201d2$export$906a919e30cdbd5c, {
        ...s
    })));
};
var $71a78e40f6b201d2$var$Re = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $71a78e40f6b201d2$var$Ee = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $71a78e40f6b201d2$var$ve = "0%{opacity:0;} 100%{opacity:1;}", $71a78e40f6b201d2$var$De = "0%{opacity:1;} 100%{opacity:0;}", $71a78e40f6b201d2$var$Oe = (0, $ebe13ae6beedf8ab$export$3817b7a54a07cec7)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $71a78e40f6b201d2$var$Ie = (0, $ebe13ae6beedf8ab$export$3817b7a54a07cec7)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $71a78e40f6b201d2$var$ke = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [a, i] = $71a78e40f6b201d2$var$E() ? [
        $71a78e40f6b201d2$var$ve,
        $71a78e40f6b201d2$var$De
    ] : [
        $71a78e40f6b201d2$var$Re(s),
        $71a78e40f6b201d2$var$Ee(s)
    ];
    return {
        animation: t ? `${(0, $ebe13ae6beedf8ab$export$d25ddfdf17c3ad3e)(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $ebe13ae6beedf8ab$export$d25ddfdf17c3ad3e)(i)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $71a78e40f6b201d2$export$af68597b0c62c1df = $bnENU.memo(({ toast: e, position: t, style: o, children: s })=>{
    let a = e.height ? $71a78e40f6b201d2$var$ke(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, i = $bnENU.createElement($71a78e40f6b201d2$export$55554e87ff8bb60f, {
        toast: e
    }), r = $bnENU.createElement($71a78e40f6b201d2$var$Ie, {
        ...e.ariaProps
    }, $71a78e40f6b201d2$export$d812c8e1906863d0(e.message, e));
    return $bnENU.createElement($71a78e40f6b201d2$var$Oe, {
        className: e.className,
        style: {
            ...a,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: i,
        message: r
    }) : $bnENU.createElement($bnENU.Fragment, null, i, r));
});
(0, $ebe13ae6beedf8ab$export$de27182ff8187d6c)($bnENU.createElement);
var $71a78e40f6b201d2$var$we = ({ id: e, className: t, style: o, onHeightUpdate: s, children: a })=>{
    let i = $bnENU.useCallback((r)=>{
        if (r) {
            let l = ()=>{
                let g = r.getBoundingClientRect().height;
                s(e, g);
            };
            l(), new MutationObserver(l).observe(r, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $bnENU.createElement("div", {
        ref: i,
        className: t,
        style: o
    }, a);
}, $71a78e40f6b201d2$var$Me = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, a = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $71a78e40f6b201d2$var$E() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...a
    };
}, $71a78e40f6b201d2$var$Ce = (0, $ebe13ae6beedf8ab$export$dbf350e5966cf602)`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $71a78e40f6b201d2$var$D = 16, $71a78e40f6b201d2$export$fb98e3a2a4cd92d7 = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: a, toasterId: i, containerStyle: r, containerClassName: l })=>{
    let { toasts: g, handlers: T } = $71a78e40f6b201d2$export$f46171b59bb094f9(o, i);
    return $bnENU.createElement("div", {
        "data-rht-toaster": i || "",
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $71a78e40f6b201d2$var$D,
            left: $71a78e40f6b201d2$var$D,
            right: $71a78e40f6b201d2$var$D,
            bottom: $71a78e40f6b201d2$var$D,
            pointerEvents: "none",
            ...r
        },
        className: l,
        onMouseEnter: T.startPause,
        onMouseLeave: T.endPause
    }, g.map((d)=>{
        let c = d.position || t, m = T.calculateOffset(d, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), p = $71a78e40f6b201d2$var$Me(c, m);
        return $bnENU.createElement($71a78e40f6b201d2$var$we, {
            id: d.id,
            key: d.id,
            onHeightUpdate: T.updateHeight,
            className: d.visible ? $71a78e40f6b201d2$var$Ce : "",
            style: p
        }, d.type === "custom" ? $71a78e40f6b201d2$export$d812c8e1906863d0(d.message, d) : a ? a(d) : $bnENU.createElement($71a78e40f6b201d2$export$af68597b0c62c1df, {
            toast: d,
            position: c
        }));
    }));
};
var $71a78e40f6b201d2$export$2e2bcd8739ae039 = $71a78e40f6b201d2$export$b410431fab84fa58;


function $8d017118df5fe2e5$export$6badb0ecde4e0bd0(message) {
    (0, $71a78e40f6b201d2$export$2e2bcd8739ae039).error(message, {
        position: "top-center",
        style: {
            fontSize: 14,
            boxSizing: "content-box",
            overflowWrap: "anywhere"
        }
    });
}
const $8d017118df5fe2e5$export$193698062786be9a = (address, decimals = 4)=>{
    if (!address) return "";
    return address.substring(0, decimals) + "..." + address.slice(address.length - decimals);
};
function $8d017118df5fe2e5$export$8121a4101142837f(bgColor, lightColor, darkColor) {
    let color = (0, $ff4d1d2dc87740be$export$2e2bcd8739ae039)(bgColor);
    try {
        const gradientColor = (0, (/*@__PURE__*/$parcel$interopDefault($d938669f6f2263ad$exports))).parse(bgColor);
        color = (0, $ff4d1d2dc87740be$export$2e2bcd8739ae039)(gradientColor[0].colorStops[0].value);
    } catch  {}
    const r = color.values[0];
    const g = color.values[1];
    const b = color.values[2];
    const uicolors = [
        r / 255,
        g / 255,
        b / 255
    ];
    const c = uicolors.map((col)=>{
        if (col <= 0.03928) return col / 12.92;
        return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    const L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.179 ? darkColor : lightColor;
}
function $8d017118df5fe2e5$export$f5dd818bff069720(val, options) {
    return Intl.NumberFormat("en-US", options).format(val);
}
function $8d017118df5fe2e5$export$1e21512880529eb2(address) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(address);
}
function $8d017118df5fe2e5$export$6b8c04140f1b2745(url) {
    const trimmed = url?.trim() ?? "";
    if (!trimmed) return "";
    if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(trimmed) || trimmed.startsWith("//")) return trimmed;
    if (trimmed.startsWith("/") || trimmed.startsWith("./") || trimmed.startsWith("../") || trimmed.startsWith("?") || trimmed.startsWith("#")) return trimmed;
    if (/^[^\s/]+\.[^\s]+$/.test(trimmed)) return `https://${trimmed}`;
    return trimmed;
}
function $8d017118df5fe2e5$export$afe74ba504aa0560(yearsAgo) {
    const today = new Date();
    return new Date(today.getFullYear() - yearsAgo, today.getMonth(), today.getDate());
}
function $8d017118df5fe2e5$export$b50b6e108474309b() {}
function $8d017118df5fe2e5$export$a079a83b07f794bf(v) {
    return !!v && !!v.trim();
}
function $8d017118df5fe2e5$export$565a3e0423f3fda3(d) {
    return {
        datePart: (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(d, "yyyy-MM-dd"),
        timePart: (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(d, "HH:mm:ss")
    };
}
function $8d017118df5fe2e5$export$f9c4d85d720ef909(phone) {
    const phoneNumber = (0, $e4f11fc5352a5db5$export$da44e4eaa54bc82e)(phone);
    return phoneNumber?.isValid() ?? false;
}


"use strict";
function $b091665b6dda5a55$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $cmlvI = parcelRequire("cmlvI");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $8ec53706316d8141$var$toString } = Object.prototype;
const { getPrototypeOf: $8ec53706316d8141$var$getPrototypeOf } = Object;
const $8ec53706316d8141$var$kindOf = ((cache)=>(thing)=>{
        const str = $8ec53706316d8141$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $8ec53706316d8141$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$8ec53706316d8141$var$kindOf(thing) === type;
};
const $8ec53706316d8141$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $8ec53706316d8141$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $8ec53706316d8141$var$isUndefined = $8ec53706316d8141$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $8ec53706316d8141$var$isBuffer(val) {
    return val !== null && !$8ec53706316d8141$var$isUndefined(val) && val.constructor !== null && !$8ec53706316d8141$var$isUndefined(val.constructor) && $8ec53706316d8141$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $8ec53706316d8141$var$isArrayBuffer = $8ec53706316d8141$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $8ec53706316d8141$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $8ec53706316d8141$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $8ec53706316d8141$var$isString = $8ec53706316d8141$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $8ec53706316d8141$var$isFunction = $8ec53706316d8141$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $8ec53706316d8141$var$isNumber = $8ec53706316d8141$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $8ec53706316d8141$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $8ec53706316d8141$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $8ec53706316d8141$var$isPlainObject = (val)=>{
    if ($8ec53706316d8141$var$kindOf(val) !== "object") return false;
    const prototype = $8ec53706316d8141$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $8ec53706316d8141$var$isDate = $8ec53706316d8141$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $8ec53706316d8141$var$isFile = $8ec53706316d8141$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $8ec53706316d8141$var$isBlob = $8ec53706316d8141$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $8ec53706316d8141$var$isFileList = $8ec53706316d8141$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $8ec53706316d8141$var$isStream = (val)=>$8ec53706316d8141$var$isObject(val) && $8ec53706316d8141$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $8ec53706316d8141$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $8ec53706316d8141$var$isFunction(thing.append) && ((kind = $8ec53706316d8141$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $8ec53706316d8141$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $8ec53706316d8141$var$isURLSearchParams = $8ec53706316d8141$var$kindOfTest("URLSearchParams");
const [$8ec53706316d8141$var$isReadableStream, $8ec53706316d8141$var$isRequest, $8ec53706316d8141$var$isResponse, $8ec53706316d8141$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($8ec53706316d8141$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $8ec53706316d8141$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $8ec53706316d8141$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($8ec53706316d8141$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $8ec53706316d8141$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $8ec53706316d8141$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $8ec53706316d8141$var$isContextDefined = (context)=>!$8ec53706316d8141$var$isUndefined(context) && context !== $8ec53706316d8141$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $8ec53706316d8141$var$merge() {
    const { caseless: caseless } = $8ec53706316d8141$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $8ec53706316d8141$var$findKey(result, key) || key;
        if ($8ec53706316d8141$var$isPlainObject(result[targetKey]) && $8ec53706316d8141$var$isPlainObject(val)) result[targetKey] = $8ec53706316d8141$var$merge(result[targetKey], val);
        else if ($8ec53706316d8141$var$isPlainObject(val)) result[targetKey] = $8ec53706316d8141$var$merge({}, val);
        else if ($8ec53706316d8141$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $8ec53706316d8141$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $8ec53706316d8141$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $8ec53706316d8141$var$forEach(b, (val, key)=>{
        if (thisArg && $8ec53706316d8141$var$isFunction(val)) a[key] = (0, $b091665b6dda5a55$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $8ec53706316d8141$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $8ec53706316d8141$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $8ec53706316d8141$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $8ec53706316d8141$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $8ec53706316d8141$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $8ec53706316d8141$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($8ec53706316d8141$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$8ec53706316d8141$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $8ec53706316d8141$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $8ec53706316d8141$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $8ec53706316d8141$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $8ec53706316d8141$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $8ec53706316d8141$var$isHTMLForm = $8ec53706316d8141$var$kindOfTest("HTMLFormElement");
const $8ec53706316d8141$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $8ec53706316d8141$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $8ec53706316d8141$var$isRegExp = $8ec53706316d8141$var$kindOfTest("RegExp");
const $8ec53706316d8141$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $8ec53706316d8141$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $8ec53706316d8141$var$freezeMethods = (obj)=>{
    $8ec53706316d8141$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($8ec53706316d8141$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$8ec53706316d8141$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $8ec53706316d8141$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $8ec53706316d8141$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $8ec53706316d8141$var$noop = ()=>{};
const $8ec53706316d8141$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $8ec53706316d8141$var$isSpecCompliantForm(thing) {
    return !!(thing && $8ec53706316d8141$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $8ec53706316d8141$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($8ec53706316d8141$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $8ec53706316d8141$var$isArray(source) ? [] : {};
                $8ec53706316d8141$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$8ec53706316d8141$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $8ec53706316d8141$var$isAsyncFn = $8ec53706316d8141$var$kindOfTest("AsyncFunction");
const $8ec53706316d8141$var$isThenable = (thing)=>thing && ($8ec53706316d8141$var$isObject(thing) || $8ec53706316d8141$var$isFunction(thing)) && $8ec53706316d8141$var$isFunction(thing.then) && $8ec53706316d8141$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $8ec53706316d8141$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $8ec53706316d8141$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $8ec53706316d8141$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $8ec53706316d8141$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $8ec53706316d8141$var$isFunction($8ec53706316d8141$var$_global.postMessage));
const $8ec53706316d8141$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($8ec53706316d8141$var$_global) : typeof $cmlvI !== "undefined" && $cmlvI.nextTick || $8ec53706316d8141$var$_setImmediate;
var // *********************
$8ec53706316d8141$export$2e2bcd8739ae039 = {
    isArray: $8ec53706316d8141$var$isArray,
    isArrayBuffer: $8ec53706316d8141$var$isArrayBuffer,
    isBuffer: $8ec53706316d8141$var$isBuffer,
    isFormData: $8ec53706316d8141$var$isFormData,
    isArrayBufferView: $8ec53706316d8141$var$isArrayBufferView,
    isString: $8ec53706316d8141$var$isString,
    isNumber: $8ec53706316d8141$var$isNumber,
    isBoolean: $8ec53706316d8141$var$isBoolean,
    isObject: $8ec53706316d8141$var$isObject,
    isPlainObject: $8ec53706316d8141$var$isPlainObject,
    isReadableStream: $8ec53706316d8141$var$isReadableStream,
    isRequest: $8ec53706316d8141$var$isRequest,
    isResponse: $8ec53706316d8141$var$isResponse,
    isHeaders: $8ec53706316d8141$var$isHeaders,
    isUndefined: $8ec53706316d8141$var$isUndefined,
    isDate: $8ec53706316d8141$var$isDate,
    isFile: $8ec53706316d8141$var$isFile,
    isBlob: $8ec53706316d8141$var$isBlob,
    isRegExp: $8ec53706316d8141$var$isRegExp,
    isFunction: $8ec53706316d8141$var$isFunction,
    isStream: $8ec53706316d8141$var$isStream,
    isURLSearchParams: $8ec53706316d8141$var$isURLSearchParams,
    isTypedArray: $8ec53706316d8141$var$isTypedArray,
    isFileList: $8ec53706316d8141$var$isFileList,
    forEach: $8ec53706316d8141$var$forEach,
    merge: $8ec53706316d8141$var$merge,
    extend: $8ec53706316d8141$var$extend,
    trim: $8ec53706316d8141$var$trim,
    stripBOM: $8ec53706316d8141$var$stripBOM,
    inherits: $8ec53706316d8141$var$inherits,
    toFlatObject: $8ec53706316d8141$var$toFlatObject,
    kindOf: $8ec53706316d8141$var$kindOf,
    kindOfTest: $8ec53706316d8141$var$kindOfTest,
    endsWith: $8ec53706316d8141$var$endsWith,
    toArray: $8ec53706316d8141$var$toArray,
    forEachEntry: $8ec53706316d8141$var$forEachEntry,
    matchAll: $8ec53706316d8141$var$matchAll,
    isHTMLForm: $8ec53706316d8141$var$isHTMLForm,
    hasOwnProperty: $8ec53706316d8141$var$hasOwnProperty,
    hasOwnProp: $8ec53706316d8141$var$hasOwnProperty,
    reduceDescriptors: $8ec53706316d8141$var$reduceDescriptors,
    freezeMethods: $8ec53706316d8141$var$freezeMethods,
    toObjectSet: $8ec53706316d8141$var$toObjectSet,
    toCamelCase: $8ec53706316d8141$var$toCamelCase,
    noop: $8ec53706316d8141$var$noop,
    toFiniteNumber: $8ec53706316d8141$var$toFiniteNumber,
    findKey: $8ec53706316d8141$var$findKey,
    global: $8ec53706316d8141$var$_global,
    isContextDefined: $8ec53706316d8141$var$isContextDefined,
    isSpecCompliantForm: $8ec53706316d8141$var$isSpecCompliantForm,
    toJSONObject: $8ec53706316d8141$var$toJSONObject,
    isAsyncFn: $8ec53706316d8141$var$isAsyncFn,
    isThenable: $8ec53706316d8141$var$isThenable,
    setImmediate: $8ec53706316d8141$var$_setImmediate,
    asap: $8ec53706316d8141$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $86bcb7f0f1986474$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $8ec53706316d8141$export$2e2bcd8739ae039).inherits($86bcb7f0f1986474$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $8ec53706316d8141$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $86bcb7f0f1986474$var$prototype = $86bcb7f0f1986474$var$AxiosError.prototype;
const $86bcb7f0f1986474$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $86bcb7f0f1986474$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($86bcb7f0f1986474$var$AxiosError, $86bcb7f0f1986474$var$descriptors);
Object.defineProperty($86bcb7f0f1986474$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$86bcb7f0f1986474$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($86bcb7f0f1986474$var$prototype);
    (0, $8ec53706316d8141$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $86bcb7f0f1986474$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $86bcb7f0f1986474$export$2e2bcd8739ae039 = $86bcb7f0f1986474$var$AxiosError;


// eslint-disable-next-line strict
var $7df2bc1a5989d57d$export$2e2bcd8739ae039 = null;



var $jtAZT = parcelRequire("jtAZT");
var $796bacf20a974bbd$require$Buffer = $jtAZT.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $796bacf20a974bbd$var$isVisitable(thing) {
    return (0, $8ec53706316d8141$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $796bacf20a974bbd$var$removeBrackets(key) {
    return (0, $8ec53706316d8141$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $796bacf20a974bbd$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $796bacf20a974bbd$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $796bacf20a974bbd$var$isFlatArray(arr) {
    return (0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(arr) && !arr.some($796bacf20a974bbd$var$isVisitable);
}
const $796bacf20a974bbd$var$predicates = (0, $8ec53706316d8141$export$2e2bcd8739ae039).toFlatObject((0, $8ec53706316d8141$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $796bacf20a974bbd$var$toFormData(obj, formData, options) {
    if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $7df2bc1a5989d57d$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $8ec53706316d8141$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $8ec53706316d8141$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $796bacf20a974bbd$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(value) && $796bacf20a974bbd$var$isFlatArray(value) || ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isFileList(value) || (0, $8ec53706316d8141$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $8ec53706316d8141$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $796bacf20a974bbd$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $796bacf20a974bbd$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($796bacf20a974bbd$var$isVisitable(value)) return true;
        formData.append($796bacf20a974bbd$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($796bacf20a974bbd$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $796bacf20a974bbd$var$isVisitable
    });
    function build(value, path) {
        if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $8ec53706316d8141$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $796bacf20a974bbd$export$2e2bcd8739ae039 = $796bacf20a974bbd$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $083f2764e85c489c$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $083f2764e85c489c$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $796bacf20a974bbd$export$2e2bcd8739ae039)(params, this, options);
}
const $083f2764e85c489c$var$prototype = $083f2764e85c489c$var$AxiosURLSearchParams.prototype;
$083f2764e85c489c$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$083f2764e85c489c$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $083f2764e85c489c$var$encode);
    } : $083f2764e85c489c$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $083f2764e85c489c$export$2e2bcd8739ae039 = $083f2764e85c489c$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $ec298157471185b6$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $ec298157471185b6$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $ec298157471185b6$var$encode;
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $8ec53706316d8141$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $083f2764e85c489c$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $c827080148be903b$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $c827080148be903b$export$2e2bcd8739ae039 = $c827080148be903b$var$InterceptorManager;





"use strict";
var $d3790466210c96a6$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $473910297e3c168e$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $083f2764e85c489c$export$2e2bcd8739ae039);


"use strict";
var $9716013ed6b604ec$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $642a12c9f7443142$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $32afebfe1ec8af8c$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $473910297e3c168e$export$2e2bcd8739ae039,
        FormData: $9716013ed6b604ec$export$2e2bcd8739ae039,
        Blob: $642a12c9f7443142$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $d22fa846e60d95d4$exports = {};

$parcel$export($d22fa846e60d95d4$exports, "hasBrowserEnv", function () { return $d22fa846e60d95d4$export$c4996c4b7b93b0bf; });
$parcel$export($d22fa846e60d95d4$exports, "navigator", function () { return $d22fa846e60d95d4$export$ec7c8efa7f5790ae; });
$parcel$export($d22fa846e60d95d4$exports, "hasStandardBrowserEnv", function () { return $d22fa846e60d95d4$export$c0bcc9250309d66; });
$parcel$export($d22fa846e60d95d4$exports, "hasStandardBrowserWebWorkerEnv", function () { return $d22fa846e60d95d4$export$c81692cf5af97dac; });
$parcel$export($d22fa846e60d95d4$exports, "origin", function () { return $d22fa846e60d95d4$export$f710a83a91838a36; });
const $d22fa846e60d95d4$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $d22fa846e60d95d4$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $d22fa846e60d95d4$export$c0bcc9250309d66 = $d22fa846e60d95d4$export$c4996c4b7b93b0bf && (!$d22fa846e60d95d4$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($d22fa846e60d95d4$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $d22fa846e60d95d4$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $d22fa846e60d95d4$export$f710a83a91838a36 = $d22fa846e60d95d4$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $42a4be06c3c8448f$export$2e2bcd8739ae039 = {
    ...$d22fa846e60d95d4$exports,
    ...(0, $32afebfe1ec8af8c$export$2e2bcd8739ae039)
};


"use strict";
function $eecef76ac6892bf4$export$2e2bcd8739ae039(data, options) {
    return (0, $796bacf20a974bbd$export$2e2bcd8739ae039)(data, new (0, $42a4be06c3c8448f$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $42a4be06c3c8448f$export$2e2bcd8739ae039).isNode && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $d6144e66671efc5e$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $8ec53706316d8141$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $d6144e66671efc5e$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $d6144e66671efc5e$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $8ec53706316d8141$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $d6144e66671efc5e$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isFormData(formData) && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $8ec53706316d8141$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($d6144e66671efc5e$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $d6144e66671efc5e$export$2e2bcd8739ae039 = $d6144e66671efc5e$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $7f92b841d116b863$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $8ec53706316d8141$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $7f92b841d116b863$var$defaults = {
    transitional: (0, $d3790466210c96a6$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $8ec53706316d8141$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $8ec53706316d8141$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $d6144e66671efc5e$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $8ec53706316d8141$export$2e2bcd8739ae039).isBuffer(data) || (0, $8ec53706316d8141$export$2e2bcd8739ae039).isStream(data) || (0, $8ec53706316d8141$export$2e2bcd8739ae039).isFile(data) || (0, $8ec53706316d8141$export$2e2bcd8739ae039).isBlob(data) || (0, $8ec53706316d8141$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $eecef76ac6892bf4$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $8ec53706316d8141$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $796bacf20a974bbd$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $7f92b841d116b863$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $7f92b841d116b863$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isResponse(data) || (0, $8ec53706316d8141$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).from(e, (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $42a4be06c3c8448f$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $42a4be06c3c8448f$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $7f92b841d116b863$var$defaults.headers[method] = {};
});
var $7f92b841d116b863$export$2e2bcd8739ae039 = $7f92b841d116b863$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $b807f7f7b4b7c70f$var$ignoreDuplicateOf = (0, $8ec53706316d8141$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $b807f7f7b4b7c70f$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $b807f7f7b4b7c70f$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $d6cbab992caa66a3$var$$internals = Symbol("internals");
function $d6cbab992caa66a3$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $d6cbab992caa66a3$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(value) ? value.map($d6cbab992caa66a3$var$normalizeValue) : String(value);
}
function $d6cbab992caa66a3$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $d6cbab992caa66a3$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $d6cbab992caa66a3$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $d6cbab992caa66a3$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $d6cbab992caa66a3$var$buildAccessors(obj, header) {
    const accessorName = (0, $8ec53706316d8141$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $d6cbab992caa66a3$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $d6cbab992caa66a3$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $8ec53706316d8141$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $d6cbab992caa66a3$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$d6cbab992caa66a3$var$isValidHeaderName(header)) setHeaders((0, $b807f7f7b4b7c70f$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $d6cbab992caa66a3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $8ec53706316d8141$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $d6cbab992caa66a3$var$parseTokens(value);
                if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $d6cbab992caa66a3$var$normalizeHeader(header);
        if (header) {
            const key = (0, $8ec53706316d8141$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $d6cbab992caa66a3$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $d6cbab992caa66a3$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $8ec53706316d8141$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $d6cbab992caa66a3$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $d6cbab992caa66a3$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $8ec53706316d8141$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $d6cbab992caa66a3$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $d6cbab992caa66a3$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $d6cbab992caa66a3$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$d6cbab992caa66a3$var$$internals] = this[$d6cbab992caa66a3$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $d6cbab992caa66a3$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $d6cbab992caa66a3$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$d6cbab992caa66a3$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $8ec53706316d8141$export$2e2bcd8739ae039).reduceDescriptors($d6cbab992caa66a3$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $8ec53706316d8141$export$2e2bcd8739ae039).freezeMethods($d6cbab992caa66a3$var$AxiosHeaders);
var $d6cbab992caa66a3$export$2e2bcd8739ae039 = $d6cbab992caa66a3$var$AxiosHeaders;


"use strict";
function $b3cfcee6050c7bf5$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $7f92b841d116b863$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $d6cbab992caa66a3$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $6f8ea35e9063cd9b$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $3d9f8e583f827d33$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $8ec53706316d8141$export$2e2bcd8739ae039).inherits($3d9f8e583f827d33$var$CanceledError, (0, $86bcb7f0f1986474$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $3d9f8e583f827d33$export$2e2bcd8739ae039 = $3d9f8e583f827d33$var$CanceledError;







"use strict";
function $0f37028450a8a422$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $b9dbf7df466729c2$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $c109b3eb4288ff48$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $c109b3eb4288ff48$export$2e2bcd8739ae039 = $c109b3eb4288ff48$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $bc059bbc88fe54d6$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $bc059bbc88fe54d6$export$2e2bcd8739ae039 = $bc059bbc88fe54d6$var$throttle;



const $34f2203d2f158ac9$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $c109b3eb4288ff48$export$2e2bcd8739ae039)(50, 250);
    return (0, $bc059bbc88fe54d6$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $34f2203d2f158ac9$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $34f2203d2f158ac9$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $8ec53706316d8141$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $67314e8d23eb4626$export$2e2bcd8739ae039 = (0, $42a4be06c3c8448f$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $42a4be06c3c8448f$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $42a4be06c3c8448f$export$2e2bcd8739ae039).origin), (0, $42a4be06c3c8448f$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $42a4be06c3c8448f$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $52df524d90a9bb00$export$2e2bcd8739ae039 = (0, $42a4be06c3c8448f$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $8ec53706316d8141$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $8ec53706316d8141$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $8ec53706316d8141$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $b9a6752643e56e41$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $a06926607419edd1$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $93313a66a1615bc3$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $b9a6752643e56e41$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $a06926607419edd1$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $4f62c989d5545619$var$headersToObject = (thing)=>thing instanceof (0, $d6cbab992caa66a3$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $4f62c989d5545619$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isPlainObject(target) && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8ec53706316d8141$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8ec53706316d8141$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($4f62c989d5545619$var$headersToObject(a), $4f62c989d5545619$var$headersToObject(b), prop, true)
    };
    (0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $bf37df15686ee083$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $4f62c989d5545619$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $d6cbab992caa66a3$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $ec298157471185b6$export$2e2bcd8739ae039)((0, $93313a66a1615bc3$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $42a4be06c3c8448f$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $42a4be06c3c8448f$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $42a4be06c3c8448f$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $8ec53706316d8141$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $67314e8d23eb4626$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $52df524d90a9bb00$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $8fba23a3c5bf635b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $8fba23a3c5bf635b$export$2e2bcd8739ae039 = $8fba23a3c5bf635b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $bf37df15686ee083$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $d6cbab992caa66a3$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $d6cbab992caa66a3$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $0f37028450a8a422$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)("Request aborted", (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)("Network Error", (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $d3790466210c96a6$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ETIMEDOUT : (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $34f2203d2f158ac9$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $34f2203d2f158ac9$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $3d9f8e583f827d33$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $b9dbf7df466729c2$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $42a4be06c3c8448f$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $b89089bfb0a2b5e2$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $86bcb7f0f1986474$export$2e2bcd8739ae039) ? err : new (0, $3d9f8e583f827d33$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $8ec53706316d8141$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $b89089bfb0a2b5e2$export$2e2bcd8739ae039 = $b89089bfb0a2b5e2$var$composeSignals;


const $c660601e54ff6039$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c660601e54ff6039$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c660601e54ff6039$var$readStream(iterable))yield* $c660601e54ff6039$export$71b051935044bd5d(chunk, chunkSize);
};
const $c660601e54ff6039$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c660601e54ff6039$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c660601e54ff6039$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $02a9e3284d7c9ebb$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $02a9e3284d7c9ebb$var$isReadableStreamSupported = $02a9e3284d7c9ebb$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $02a9e3284d7c9ebb$var$encodeText = $02a9e3284d7c9ebb$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $02a9e3284d7c9ebb$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $02a9e3284d7c9ebb$var$supportsRequestStream = $02a9e3284d7c9ebb$var$isReadableStreamSupported && $02a9e3284d7c9ebb$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $42a4be06c3c8448f$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $02a9e3284d7c9ebb$var$DEFAULT_CHUNK_SIZE = 65536;
const $02a9e3284d7c9ebb$var$supportsResponseStream = $02a9e3284d7c9ebb$var$isReadableStreamSupported && $02a9e3284d7c9ebb$var$test(()=>(0, $8ec53706316d8141$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $02a9e3284d7c9ebb$var$resolvers = {
    stream: $02a9e3284d7c9ebb$var$supportsResponseStream && ((res)=>res.body)
};
$02a9e3284d7c9ebb$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$02a9e3284d7c9ebb$var$resolvers[type] && ($02a9e3284d7c9ebb$var$resolvers[type] = (0, $8ec53706316d8141$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $02a9e3284d7c9ebb$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $42a4be06c3c8448f$export$2e2bcd8739ae039).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $8ec53706316d8141$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isString(body)) return (await $02a9e3284d7c9ebb$var$encodeText(body)).byteLength;
};
const $02a9e3284d7c9ebb$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $8ec53706316d8141$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $02a9e3284d7c9ebb$var$getBodyLength(body) : length;
};
var $02a9e3284d7c9ebb$export$2e2bcd8739ae039 = $02a9e3284d7c9ebb$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $bf37df15686ee083$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $b89089bfb0a2b5e2$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $02a9e3284d7c9ebb$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $02a9e3284d7c9ebb$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $34f2203d2f158ac9$export$d9fadd12586c18d6)(requestContentLength, (0, $34f2203d2f158ac9$export$c1b28109d46c3592)((0, $34f2203d2f158ac9$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $c660601e54ff6039$export$b0119225647bd83)(_request.body, $02a9e3284d7c9ebb$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $8ec53706316d8141$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $02a9e3284d7c9ebb$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($02a9e3284d7c9ebb$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $8ec53706316d8141$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $34f2203d2f158ac9$export$d9fadd12586c18d6)(responseContentLength, (0, $34f2203d2f158ac9$export$c1b28109d46c3592)((0, $34f2203d2f158ac9$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $c660601e54ff6039$export$b0119225647bd83)(response.body, $02a9e3284d7c9ebb$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $02a9e3284d7c9ebb$var$resolvers[(0, $8ec53706316d8141$export$2e2bcd8739ae039).findKey($02a9e3284d7c9ebb$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $0f37028450a8a422$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $d6cbab992caa66a3$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)("Network Error", (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $a56c4b691a3397a6$var$knownAdapters = {
    http: (0, $7df2bc1a5989d57d$export$2e2bcd8739ae039),
    xhr: (0, $8fba23a3c5bf635b$export$2e2bcd8739ae039),
    fetch: (0, $02a9e3284d7c9ebb$export$2e2bcd8739ae039)
};
(0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach($a56c4b691a3397a6$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $a56c4b691a3397a6$var$renderReason = (reason)=>`- ${reason}`;
const $a56c4b691a3397a6$var$isResolvedHandle = (adapter)=>(0, $8ec53706316d8141$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $a56c4b691a3397a6$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $8ec53706316d8141$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$a56c4b691a3397a6$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $a56c4b691a3397a6$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($a56c4b691a3397a6$var$renderReason).join("\n") : " " + $a56c4b691a3397a6$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $a56c4b691a3397a6$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $83c90e6e57aa4df7$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $3d9f8e583f827d33$export$2e2bcd8739ae039)(null, config);
}
function $83c90e6e57aa4df7$export$2e2bcd8739ae039(config) {
    $83c90e6e57aa4df7$var$throwIfCancellationRequested(config);
    config.headers = (0, $d6cbab992caa66a3$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $b3cfcee6050c7bf5$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $a56c4b691a3397a6$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $7f92b841d116b863$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $83c90e6e57aa4df7$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $b3cfcee6050c7bf5$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $d6cbab992caa66a3$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $6f8ea35e9063cd9b$export$2e2bcd8739ae039)(reason)) {
            $83c90e6e57aa4df7$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $b3cfcee6050c7bf5$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $d6cbab992caa66a3$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $df8864a8897754e8$export$a4ad2735b021c132 = "1.8.4";



"use strict";
const $a2b2edf6325eabd8$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $a2b2edf6325eabd8$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $a2b2edf6325eabd8$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $a2b2edf6325eabd8$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $df8864a8897754e8$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$a2b2edf6325eabd8$var$deprecatedWarnings[opt]) {
            $a2b2edf6325eabd8$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$a2b2edf6325eabd8$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $a2b2edf6325eabd8$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)("options must be an object", (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $86bcb7f0f1986474$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $86bcb7f0f1986474$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $a2b2edf6325eabd8$export$2e2bcd8739ae039 = {
    assertOptions: $a2b2edf6325eabd8$var$assertOptions,
    validators: $a2b2edf6325eabd8$var$validators
};



"use strict";
const $6bd1eed68c530ceb$var$validators = (0, $a2b2edf6325eabd8$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $6bd1eed68c530ceb$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $c827080148be903b$export$2e2bcd8739ae039)(),
            response: new (0, $c827080148be903b$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $4f62c989d5545619$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $a2b2edf6325eabd8$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $6bd1eed68c530ceb$var$validators.transitional($6bd1eed68c530ceb$var$validators.boolean),
            forcedJSONParsing: $6bd1eed68c530ceb$var$validators.transitional($6bd1eed68c530ceb$var$validators.boolean),
            clarifyTimeoutError: $6bd1eed68c530ceb$var$validators.transitional($6bd1eed68c530ceb$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $8ec53706316d8141$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $a2b2edf6325eabd8$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $6bd1eed68c530ceb$var$validators.function,
                serialize: $6bd1eed68c530ceb$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $a2b2edf6325eabd8$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $6bd1eed68c530ceb$var$validators.spelling("baseURL"),
            withXsrfToken: $6bd1eed68c530ceb$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $8ec53706316d8141$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $d6cbab992caa66a3$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $83c90e6e57aa4df7$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $83c90e6e57aa4df7$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $4f62c989d5545619$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $93313a66a1615bc3$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $ec298157471185b6$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $6bd1eed68c530ceb$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $4f62c989d5545619$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $8ec53706316d8141$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $4f62c989d5545619$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $6bd1eed68c530ceb$var$Axios.prototype[method] = generateHTTPMethod();
    $6bd1eed68c530ceb$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $6bd1eed68c530ceb$export$2e2bcd8739ae039 = $6bd1eed68c530ceb$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $a75c987db5a96b51$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $3d9f8e583f827d33$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $a75c987db5a96b51$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $a75c987db5a96b51$export$2e2bcd8739ae039 = $a75c987db5a96b51$var$CancelToken;






"use strict";
function $4da3c009a8db6cf5$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $1de7b7a8f32cfa64$export$2e2bcd8739ae039(payload) {
    return (0, $8ec53706316d8141$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $aef1254c5b98799b$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($aef1254c5b98799b$var$HttpStatusCode).forEach(([key, value])=>{
    $aef1254c5b98799b$var$HttpStatusCode[value] = key;
});
var $aef1254c5b98799b$export$2e2bcd8739ae039 = $aef1254c5b98799b$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5a55d51f5112df3c$var$createInstance(defaultConfig) {
    const context = new (0, $6bd1eed68c530ceb$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $b091665b6dda5a55$export$2e2bcd8739ae039)((0, $6bd1eed68c530ceb$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $8ec53706316d8141$export$2e2bcd8739ae039).extend(instance, (0, $6bd1eed68c530ceb$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $8ec53706316d8141$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5a55d51f5112df3c$var$createInstance((0, $4f62c989d5545619$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5a55d51f5112df3c$var$axios = $5a55d51f5112df3c$var$createInstance((0, $7f92b841d116b863$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5a55d51f5112df3c$var$axios.Axios = (0, $6bd1eed68c530ceb$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5a55d51f5112df3c$var$axios.CanceledError = (0, $3d9f8e583f827d33$export$2e2bcd8739ae039);
$5a55d51f5112df3c$var$axios.CancelToken = (0, $a75c987db5a96b51$export$2e2bcd8739ae039);
$5a55d51f5112df3c$var$axios.isCancel = (0, $6f8ea35e9063cd9b$export$2e2bcd8739ae039);
$5a55d51f5112df3c$var$axios.VERSION = (0, $df8864a8897754e8$export$a4ad2735b021c132);
$5a55d51f5112df3c$var$axios.toFormData = (0, $796bacf20a974bbd$export$2e2bcd8739ae039);
// Expose AxiosError class
$5a55d51f5112df3c$var$axios.AxiosError = (0, $86bcb7f0f1986474$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5a55d51f5112df3c$var$axios.Cancel = $5a55d51f5112df3c$var$axios.CanceledError;
// Expose all/spread
$5a55d51f5112df3c$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5a55d51f5112df3c$var$axios.spread = (0, $4da3c009a8db6cf5$export$2e2bcd8739ae039);
// Expose isAxiosError
$5a55d51f5112df3c$var$axios.isAxiosError = (0, $1de7b7a8f32cfa64$export$2e2bcd8739ae039);
// Expose mergeConfig
$5a55d51f5112df3c$var$axios.mergeConfig = (0, $4f62c989d5545619$export$2e2bcd8739ae039);
$5a55d51f5112df3c$var$axios.AxiosHeaders = (0, $d6cbab992caa66a3$export$2e2bcd8739ae039);
$5a55d51f5112df3c$var$axios.formToJSON = (thing)=>(0, $d6144e66671efc5e$export$2e2bcd8739ae039)((0, $8ec53706316d8141$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5a55d51f5112df3c$var$axios.getAdapter = (0, $a56c4b691a3397a6$export$2e2bcd8739ae039).getAdapter;
$5a55d51f5112df3c$var$axios.HttpStatusCode = (0, $aef1254c5b98799b$export$2e2bcd8739ae039);
$5a55d51f5112df3c$var$axios.default = $5a55d51f5112df3c$var$axios;
var // this module should only have a default export
$5a55d51f5112df3c$export$2e2bcd8739ae039 = $5a55d51f5112df3c$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c9d99de0e348dc62$export$1c00760e9e5a4e95, AxiosError: $c9d99de0e348dc62$export$c1fbed17c2f6a328, CanceledError: $c9d99de0e348dc62$export$1ab0c6b20d94fa14, isCancel: $c9d99de0e348dc62$export$3b22524397b493c6, CancelToken: $c9d99de0e348dc62$export$fd08e3cb425f0d61, VERSION: $c9d99de0e348dc62$export$a4ad2735b021c132, all: $c9d99de0e348dc62$export$84bf76cd7afc7469, Cancel: $c9d99de0e348dc62$export$848c9b7ead0df967, isAxiosError: $c9d99de0e348dc62$export$fbafdbe06a5b5a9a, spread: $c9d99de0e348dc62$export$3ae0fd4797ed47c8, toFormData: $c9d99de0e348dc62$export$10ae0d317ea97f8b, AxiosHeaders: $c9d99de0e348dc62$export$4e7d6ff0f3e6520, HttpStatusCode: $c9d99de0e348dc62$export$a972f69c851492b3, formToJSON: $c9d99de0e348dc62$export$86d7c59254d6a2c9, getAdapter: $c9d99de0e348dc62$export$17ddc20a97d669e2, mergeConfig: $c9d99de0e348dc62$export$7ec1ebcfa9d8bd6a } = (0, $5a55d51f5112df3c$export$2e2bcd8739ae039);



var $43c053927acc0cba$export$8d291ecd86a6c444;
(function(InputFieldDataType) {
    InputFieldDataType["String"] = "String";
    InputFieldDataType["Number"] = "Number";
    InputFieldDataType["Email"] = "Email";
    InputFieldDataType["Address"] = "Address";
    InputFieldDataType["CountryOfResidence"] = "CountryOfResidence";
    InputFieldDataType["Date"] = "Date";
    InputFieldDataType["Name"] = "String";
})($43c053927acc0cba$export$8d291ecd86a6c444 || ($43c053927acc0cba$export$8d291ecd86a6c444 = {}));
const $43c053927acc0cba$var$extractApiErrorMessage = (err, fallback = "Unknown error")=>{
    if (err?.response?.status === 429) return "Too many requests right now. Please wait a few seconds and try again.";
    return err?.response?.data?.error ?? err?.response?.data?.message ?? err?.message ?? fallback;
};
class $43c053927acc0cba$var$Radom {
    constructor(){
        this.inFlightGetRequests = new Map();
        this.dedupeGet = async (cacheKey, fetcher)=>{
            const existingRequest = this.inFlightGetRequests.get(cacheKey);
            if (existingRequest) return await existingRequest;
            const request = fetcher().finally(()=>{
                this.inFlightGetRequests.delete(cacheKey);
            });
            this.inFlightGetRequests.set(cacheKey, request);
            return await request;
        };
        this.getPaymentLink = async (id)=>{
            return await this.dedupeGet(`payment_link:${id}`, async ()=>await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/payment_link/${id}`).then((res)=>res.data).catch((err)=>{
                    throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
                }));
        };
        this.getDonationLink = async (id)=>{
            return await this.dedupeGet(`donation_link:${id}`, async ()=>await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/donation_link/${id}`).then((res)=>res.data).catch((err)=>{
                    throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
                }));
        };
        this.getInvoice = async (id)=>{
            return await this.dedupeGet(`invoice:${id}`, async ()=>await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/invoice/${id}`).then((res)=>res.data).catch((err)=>{
                    throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
                }));
        };
        this.redeemDiscountCode = async (req)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).post(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/discount_code/verify`, req).then((res)=>res.data);
        };
        this.getPriceQuotes = async (from, to)=>{
            const fromCurrencies = from.map((f, i)=>`from[${i}]=${f}`).join("&");
            const toCurrencies = to.map((f, i)=>`to[${i}]=${f}`).join("&");
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/price_quotes?${fromCurrencies}&${toCurrencies}`).then((res)=>res.data);
        };
        this.getCountryGuess = async ()=>{
            try {
                return await this.dedupeGet("country_guess", async ()=>await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/country_guess`).then((res)=>res.data));
            } catch (err) {
                console.warn("Failed to guess country", err?.response?.data ?? err?.message ?? err);
                return null;
            }
        };
        this.getCheckoutSession = async (id, options = {})=>{
            const query = options.refreshOpenBankingStatus ? "?refreshOpenBankingStatus=true" : "";
            const cacheKey = `checkout_session:${id}:${options.refreshOpenBankingStatus === true ? "refresh" : "default"}`;
            const checkoutSession = await this.dedupeGet(cacheKey, async ()=>{
                try {
                    const res = await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/checkout_session/${id}${query}`);
                    return res.data;
                } catch (err) {
                    throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
                }
            });
            return checkoutSession;
        };
        this.trackCheckoutFunnelEvent = async (event)=>{
            try {
                await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).post(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/checkout/funnel/event`, event);
            } catch (err) {
                console.warn("Failed to track checkout funnel event", err?.response?.data ?? err?.message ?? err);
            }
        };
        this.upsertTrfsForCheckoutSession = async (id, trFields)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).put(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/checkout_session/${id}/travel_rule_fields`, trFields).then((res)=>res.data);
        };
        this.updateTrfsForCustomerViaInvoice = async (id, trFields)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).put(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/invoice/${id}/travel_rule_fields`, trFields).then((res)=>res.data).catch((err)=>{
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            });
        };
        this.getSellerProfile = async (address)=>{
            return await this.dedupeGet(`seller:${address}`, async ()=>await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/sellers/${address}`).then((res)=>res.data).catch((err)=>{
                    throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
                }));
        };
        this.createPaymentLinkOrder = async (data)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).post(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/payment_link_order/pending`, data).then((res)=>res.data).catch((err)=>{
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            });
        };
        this.createDonationLinkOrder = async (data)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).post(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/donation_link_order/pending`, data).then((res)=>res.data).catch((err)=>{
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            });
        };
        this.createCheckoutSessionOrder = async (data)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).post(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/checkout/pending`, data).then((res)=>res.data).catch((err)=>{
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            });
        };
        this.createInvoicePayment = async (data)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).post(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/invoices/pending`, data).then((res)=>res.data).catch((err)=>{
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            });
        };
        this.getManagedPaymentStatus = async (paymentId)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/managed_payment_status/${paymentId}`).then((res)=>res.data);
        };
        this.getManagedTokenPaymentStatus = async (paymentId)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/managed_token_payment_status/${paymentId}`).then((res)=>res.data);
        };
        this.completeTokenDelegatePayment = async (paymentId, signature)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).post(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/token_delegate_payment`, {
                paymentId: paymentId,
                signature: signature
            }).then((res)=>res.data).catch((err)=>{
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            });
        };
        this.getSubscription = async (id)=>{
            return await this.dedupeGet(`subscription:${id}`, async ()=>await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/subscription/${id}`).then((res)=>res.data).catch((err)=>{
                    throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
                }));
        };
        this.getSubscriptionBackButtonUrl = async (id)=>{
            return await this.dedupeGet(`subscription_back_button_url:${id}`, async ()=>await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/subscription/${id}/subscription_back_button_url`).then((res)=>res.data).catch((err)=>{
                    throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
                }));
        };
        this.estimateTokenTranferGas = async (network, token)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/estimate_token_transfer_gas?network=${network}&token=${token}`).then((res)=>res.data).catch((err)=>{
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            });
        };
        this.createSubscriptionPayment = async (subscriptionId)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).post(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/subscription/${subscriptionId}/pay`).then((res)=>res.data).catch((err)=>{
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            });
        };
        this.cancelSubscription = async (id)=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).post(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/subscription/${id}/cancel`).then((res)=>res.data).catch((err)=>{
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            });
        };
        this.updateCustomerKycData = async (id, customerForm)=>{
            const data = {
                ...customerForm
            };
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).put(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/checkout/${id}/kyc`, data).then((res)=>res.data).catch((err)=>{
                console.error("Error updating customer KYC data:", err.response?.data || err.message);
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            });
        };
        this.postForm = async (path, body = {})=>{
            return await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).postForm(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}${path}`, body, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            }).then((res)=>res.data);
        };
        this.getGoolgePlaceAutoComplete = async (input, regionCode)=>{
            if (!input) return [];
            try {
                const response = await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/address_suggestion`, {
                    params: {
                        input: input,
                        includedRegionCodes: regionCode
                    }
                });
                return (Array.isArray(response.data) ? response.data : []).map((suggestion)=>{
                    if (typeof suggestion === "string") return suggestion;
                    if (typeof suggestion?.description === "string") return suggestion.description;
                    if (typeof suggestion?.formattedAddress === "string") return suggestion.formattedAddress;
                    if (typeof suggestion?.text === "string") return suggestion.text;
                    if (typeof suggestion?.text?.text === "string") return suggestion.text.text;
                    if (typeof suggestion?.placePrediction?.text?.text === "string") return suggestion.placePrediction.text.text;
                    return "";
                }).filter((suggestion)=>suggestion.trim().length > 0);
            } catch (err) {
                console.error("Error fetching address suggestions:", err.response?.data || err.message);
                return [];
            }
        };
        this.getGooglePlaceAddressDetails = async (input, regionCode)=>{
            if (!input || input.trim().length === 0) return null;
            try {
                const response = await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/address_suggestion/details`, {
                    params: {
                        input: input,
                        includedRegionCodes: regionCode ?? ""
                    }
                });
                return response.data;
            } catch (err) {
                console.error("Error fetching address details:", err.response?.data || err.message);
                return null;
            }
        };
        this.getCustomerMatchEmailDobByDonationLink = async (donationLinkId, email, dob)=>{
            const params = {
                email: email
            };
            if (dob) params.dob = dob;
            try {
                const res = await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).get(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/donation_link/${donationLinkId}/customer`, {
                    params: params
                });
                return res.data;
            } catch (err) {
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            }
        };
        this.createCustomerForDonationLink = async (donationLinkId, customer)=>{
            try {
                const res = await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).put(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/donation_link/${donationLinkId}/customer/kyc`, customer);
                return res.data;
            } catch (err) {
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            }
        };
        this.updateCustomerKycDataByDonationLink = async (donationLinkId, customerEmail, customerDob, updateKycData)=>{
            try {
                const res = await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).put(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/donation_link/${donationLinkId}/customer/kyc`, {
                    customerEmail: customerEmail,
                    customerDob: customerDob,
                    updateKycData: updateKycData
                });
                return res.data;
            } catch (err) {
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            }
        };
        this.submitCustomerKycCheckRequestByDonationLink = async (donationLinkId, customerEmail, customerDob)=>{
            try {
                const res = await (0, $5a55d51f5112df3c$export$2e2bcd8739ae039).put(`${(0, $afdf282d9c361d03$export$c3ee1e672e1e24e7)}/donation_link/${donationLinkId}/customer/kyc`, {
                    customerEmail: customerEmail,
                    customerDob: customerDob
                });
                return res.data;
            } catch (err) {
                throw new Error($43c053927acc0cba$var$extractApiErrorMessage(err));
            }
        };
    }
}
var $43c053927acc0cba$export$2e2bcd8739ae039 = new $43c053927acc0cba$var$Radom();




var $bnENU = parcelRequire("bnENU");
let $c8101c12137113f6$var$modal = undefined;
function $c8101c12137113f6$export$db9d243f55cd9d82(web3modal) {
    if (web3modal) $c8101c12137113f6$var$modal = web3modal;
}
function $c8101c12137113f6$export$7cb034a59823159f() {
    if (!$c8101c12137113f6$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3ModalTheme" hook');
    function setThemeMode(themeMode) {
        $c8101c12137113f6$var$modal?.setThemeMode(themeMode);
    }
    function setThemeVariables(themeVariables) {
        $c8101c12137113f6$var$modal?.setThemeVariables(themeVariables);
    }
    const [themeMode, setInternalThemeMode] = (0, $bnENU.useState)($c8101c12137113f6$var$modal.getThemeMode());
    const [themeVariables, setInternalThemeVariables] = (0, $bnENU.useState)($c8101c12137113f6$var$modal.getThemeVariables());
    (0, $bnENU.useEffect)(()=>{
        const unsubscribe = $c8101c12137113f6$var$modal?.subscribeTheme((state)=>{
            setInternalThemeMode(state.themeMode);
            setInternalThemeVariables(state.themeVariables);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, []);
    return {
        themeMode: themeMode,
        themeVariables: themeVariables,
        setThemeMode: setThemeMode,
        setThemeVariables: setThemeVariables
    };
}
function $c8101c12137113f6$export$69804ca079d47f29() {
    if (!$c8101c12137113f6$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3Modal" hook');
    async function open(options) {
        await $c8101c12137113f6$var$modal?.open(options);
    }
    async function close() {
        await $c8101c12137113f6$var$modal?.close();
    }
    return {
        open: open,
        close: close
    };
}
function $c8101c12137113f6$export$462a1af4ea315fad() {
    if (!$c8101c12137113f6$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3ModalState" hook');
    const [state, setState] = (0, $bnENU.useState)($c8101c12137113f6$var$modal.getState());
    (0, $bnENU.useEffect)(()=>{
        const unsubscribe = $c8101c12137113f6$var$modal?.subscribeState((newState)=>{
            setState({
                ...newState
            });
        });
        return ()=>{
            unsubscribe?.();
        };
    }, []);
    return state;
}
function $c8101c12137113f6$export$cd17534826f46144() {
    if (!$c8101c12137113f6$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3ModalState" hook');
    const [event, setEvents] = (0, $bnENU.useState)($c8101c12137113f6$var$modal.getEvent());
    (0, $bnENU.useEffect)(()=>{
        const unsubscribe = $c8101c12137113f6$var$modal?.subscribeEvents((newEvent)=>{
            setEvents({
                ...newEvent
            });
        });
        return ()=>{
            unsubscribe?.();
        };
    }, []);
    return event;
}



const $d19d50b3b9e9b1ca$export$83d89fbfd8236492 = "2.16.7";


const $a501db443c9fbf99$export$c506eb22e615ba4a = ()=>`@wagmi/core@${0, $d19d50b3b9e9b1ca$export$83d89fbfd8236492}`;


var $2ee97e787be17453$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $2ee97e787be17453$var$_BaseError_instances, $2ee97e787be17453$var$_BaseError_walk;
class $2ee97e787be17453$export$a490eb03cb7a0a5e extends Error {
    get docsBaseUrl() {
        return "https://wagmi.sh/core";
    }
    get version() {
        return (0, $a501db443c9fbf99$export$c506eb22e615ba4a)();
    }
    constructor(shortMessage, options = {}){
        super();
        $2ee97e787be17453$var$_BaseError_instances.add(this);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiCoreError"
        });
        const details = options.cause instanceof $2ee97e787be17453$export$a490eb03cb7a0a5e ? options.cause.details : options.cause?.message ? options.cause.message : options.details;
        const docsPath = options.cause instanceof $2ee97e787be17453$export$a490eb03cb7a0a5e ? options.cause.docsPath || options.docsPath : options.docsPath;
        this.message = [
            shortMessage || "An error occurred.",
            "",
            ...options.metaMessages ? [
                ...options.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: ${this.docsBaseUrl}${docsPath}.html${options.docsSlug ? `#${options.docsSlug}` : ""}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: ${this.version}`
        ].join("\n");
        if (options.cause) this.cause = options.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = options.metaMessages;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $2ee97e787be17453$var$__classPrivateFieldGet(this, $2ee97e787be17453$var$_BaseError_instances, "m", $2ee97e787be17453$var$_BaseError_walk).call(this, this, fn);
    }
}
$2ee97e787be17453$var$_BaseError_instances = new WeakSet(), $2ee97e787be17453$var$_BaseError_walk = function _BaseError_walk(err, fn) {
    if (fn?.(err)) return err;
    if (err.cause) return $2ee97e787be17453$var$__classPrivateFieldGet(this, $2ee97e787be17453$var$_BaseError_instances, "m", _BaseError_walk).call(this, err.cause, fn);
    return err;
};


class $dfd1b5f3c842a678$export$688e5fda4b4631ed extends (0, $2ee97e787be17453$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Chain not configured.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainNotConfiguredError"
        });
    }
}
class $dfd1b5f3c842a678$export$ee7f4e50316bc4b2 extends (0, $2ee97e787be17453$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Connector already connected.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorAlreadyConnectedError"
        });
    }
}
class $dfd1b5f3c842a678$export$d9a3828eace037a6 extends (0, $2ee97e787be17453$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Connector not connected.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorNotConnectedError"
        });
    }
}
class $dfd1b5f3c842a678$export$9f8a797207d6544e extends (0, $2ee97e787be17453$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Connector not found.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorNotFoundError"
        });
    }
}
class $dfd1b5f3c842a678$export$65c369a969e2c62e extends (0, $2ee97e787be17453$export$a490eb03cb7a0a5e) {
    constructor({ address: address, connector: connector }){
        super(`Account "${address}" not found for connector "${connector.name}".`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorAccountNotFoundError"
        });
    }
}
class $dfd1b5f3c842a678$export$6f9c2f3137249d9c extends (0, $2ee97e787be17453$export$a490eb03cb7a0a5e) {
    constructor({ connectionChainId: connectionChainId, connectorChainId: connectorChainId }){
        super(`The current chain of the connector (id: ${connectorChainId}) does not match the connection's chain (id: ${connectionChainId}).`, {
            metaMessages: [
                `Current Chain ID:  ${connectorChainId}`,
                `Expected Chain ID: ${connectionChainId}`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorChainMismatchError"
        });
    }
}
class $dfd1b5f3c842a678$export$58faffcf27ce6845 extends (0, $2ee97e787be17453$export$a490eb03cb7a0a5e) {
    constructor({ connector: connector }){
        super(`Connector "${connector.name}" unavailable while reconnecting.`, {
            details: [
                "During the reconnection step, the only connector methods guaranteed to be available are: `id`, `name`, `type`, `uid`.",
                "All other methods are not guaranteed to be available until reconnection completes and connectors are fully restored.",
                "This error commonly occurs for connectors that asynchronously inject after reconnection has already started."
            ].join(" ")
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorUnavailableReconnectingError"
        });
    }
}


async function $448dd5b08fca5688$export$64605811ab45167f(config, parameters) {
    // "Register" connector if not already created
    let connector;
    if (typeof parameters.connector === "function") connector = config._internal.connectors.setup(parameters.connector);
    else connector = parameters.connector;
    // Check if connector is already connected
    if (connector.uid === config.state.current) throw new (0, $dfd1b5f3c842a678$export$ee7f4e50316bc4b2)();
    try {
        config.setState((x)=>({
                ...x,
                status: "connecting"
            }));
        connector.emitter.emit("message", {
            type: "connecting"
        });
        const { connector: _, ...rest } = parameters;
        const data = await connector.connect(rest);
        const accounts = data.accounts;
        connector.emitter.off("connect", config._internal.events.connect);
        connector.emitter.on("change", config._internal.events.change);
        connector.emitter.on("disconnect", config._internal.events.disconnect);
        await config.storage?.setItem("recentConnectorId", connector.id);
        config.setState((x)=>({
                ...x,
                connections: new Map(x.connections).set(connector.uid, {
                    accounts: accounts,
                    chainId: data.chainId,
                    connector: connector
                }),
                current: connector.uid,
                status: "connected"
            }));
        return {
            accounts: accounts,
            chainId: data.chainId
        };
    } catch (error) {
        config.setState((x)=>({
                ...x,
                // Keep existing connector connected in case of error
                status: x.current ? "connected" : "disconnected"
            }));
        throw error;
    }
}

/** https://wagmi.sh/core/api/actions/disconnect */ async function $a724cc6b117c9948$export$37dfea93db2e14ed(config, parameters = {}) {
    let connector;
    if (parameters.connector) connector = parameters.connector;
    else {
        const { connections: connections, current: current } = config.state;
        const connection = connections.get(current);
        connector = connection?.connector;
    }
    const connections = config.state.connections;
    if (connector) {
        await connector.disconnect();
        connector.emitter.off("change", config._internal.events.change);
        connector.emitter.off("disconnect", config._internal.events.disconnect);
        connector.emitter.on("connect", config._internal.events.connect);
        connections.delete(connector.uid);
    }
    config.setState((x)=>{
        // if no connections exist, move to disconnected state
        if (connections.size === 0) return {
            ...x,
            connections: new Map(),
            current: null,
            status: "disconnected"
        };
        // switch over to another connection
        const nextConnection = connections.values().next().value;
        return {
            ...x,
            connections: new Map(connections),
            current: nextConnection.connector.uid
        };
    });
    // Set recent connector if exists
    {
        const current = config.state.current;
        if (!current) return;
        const connector = config.state.connections.get(current)?.connector;
        if (!connector) return;
        await config.storage?.setItem("recentConnectorId", connector.id);
    }
}

/** https://wagmi.sh/core/api/actions/getAccount */ function $588ed08035d28638$export$4f9234baf34abd0(config) {
    const uid = config.state.current;
    const connection = config.state.connections.get(uid);
    const addresses = connection?.accounts;
    const address = addresses?.[0];
    const chain = config.chains.find((chain)=>chain.id === connection?.chainId);
    const status = config.state.status;
    switch(status){
        case "connected":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: true,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "reconnecting":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: !!address,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: true,
                status: status
            };
        case "connecting":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: false,
                isConnecting: true,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "disconnected":
            return {
                address: undefined,
                addresses: undefined,
                chain: undefined,
                chainId: undefined,
                connector: undefined,
                isConnected: false,
                isConnecting: false,
                isDisconnected: true,
                isReconnecting: false,
                status: status
            };
    }
}


var $iwa3L = parcelRequire("iwa3L");
var $9GGVO = parcelRequire("9GGVO");
var $geW6W = parcelRequire("geW6W");

var $jW8ut = parcelRequire("jW8ut");
async function $1c1667fc515d46a5$export$df96cd8d56be0ab1(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
    const balance = await client.request({
        method: "eth_getBalance",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    });
    return BigInt(balance);
}


/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $b2506b600107942b$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    const action_implicit = client[actionFn.name];
    if (typeof action_implicit === "function") return action_implicit;
    const action_explicit = client[name];
    if (typeof action_explicit === "function") return action_explicit;
    return (params)=>actionFn(client, params);
}



var $3IKOD = parcelRequire("3IKOD");
function $4966a01d31a23c89$export$65f2564e9a9b9222(unit) {
    if (typeof unit === "number") return unit;
    if (unit === "wei") return 0;
    return Math.abs((0, $3IKOD.weiUnits)[unit]);
}



var $hfefF = parcelRequire("hfefF");

var $6Dftn = parcelRequire("6Dftn");

var $8p1we = parcelRequire("8p1we");

var $cahqm = parcelRequire("cahqm");

var $hfefF = parcelRequire("hfefF");

var $dzDwb = parcelRequire("dzDwb");

var $aYJZ1 = parcelRequire("aYJZ1");

var $fVVQ8 = parcelRequire("fVVQ8");

var $8p1we = parcelRequire("8p1we");

var $cahqm = parcelRequire("cahqm");

var $hfefF = parcelRequire("hfefF");

var $aBz5G = parcelRequire("aBz5G");

var $iy34j = parcelRequire("iy34j");
const $768c9bcff606843b$var$EXECUTION_REVERTED_ERROR_CODE = 3;
function $768c9bcff606843b$export$4414444aba6ddd8a(err, { abi: abi, address: address, args: args, docsPath: docsPath, functionName: functionName, sender: sender }) {
    const error = err instanceof (0, $hfefF.RawContractError) ? err : err instanceof (0, $cahqm.BaseError) ? err.walk((err)=>"data" in err) || err.walk() : {};
    const { code: code, data: data, details: details, message: message, shortMessage: shortMessage } = error;
    const cause = (()=>{
        if (err instanceof (0, $8p1we.AbiDecodingZeroDataError)) return new (0, $hfefF.ContractFunctionZeroDataError)({
            functionName: functionName
        });
        if ([
            $768c9bcff606843b$var$EXECUTION_REVERTED_ERROR_CODE,
            (0, $iy34j.InternalRpcError).code
        ].includes(code) && (data || details || message || shortMessage)) return new (0, $hfefF.ContractFunctionRevertedError)({
            abi: abi,
            data: typeof data === "object" ? data.data : data,
            functionName: functionName,
            message: error instanceof (0, $aBz5G.RpcRequestError) ? details : shortMessage ?? message
        });
        return err;
    })();
    return new (0, $hfefF.ContractFunctionExecutionError)(cause, {
        abi: abi,
        args: args,
        contractAddress: address,
        docsPath: docsPath,
        functionName: functionName,
        sender: sender
    });
}


/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $03465ad531816f87$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    const action_implicit = client[actionFn.name];
    if (typeof action_implicit === "function") return action_implicit;
    const action_explicit = client[name];
    if (typeof action_explicit === "function") return action_explicit;
    return (params)=>actionFn(client, params);
}



var $dzDwb = parcelRequire("dzDwb");

var $aYJZ1 = parcelRequire("aYJZ1");



var $cjGvc = parcelRequire("cjGvc");
async function $2ba19faf5017d144$export$43af7de392176737(client, parameters) {
    const { abi: abi, address: address, args: args, functionName: functionName, ...rest } = parameters;
    const calldata = (0, $aYJZ1.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $cjGvc.call), "call")({
            ...rest,
            data: calldata,
            to: address
        });
        return (0, $dzDwb.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
    } catch (error) {
        throw (0, $768c9bcff606843b$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/readContract",
            functionName: functionName
        });
    }
}


async function $dc0d72ee3c69399a$export$60ef70589ee4f7ad(client, parameters) {
    const { allowFailure: allowFailure = true, batchSize: batchSize_, blockNumber: blockNumber, blockTag: blockTag, multicallAddress: multicallAddress_, stateOverride: stateOverride } = parameters;
    const contracts = parameters.contracts;
    const batchSize = batchSize_ ?? (typeof client.batch?.multicall === "object" && client.batch.multicall.batchSize || 1024);
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new Error("client chain not configured. multicallAddress is required.");
        multicallAddress = (0, $fVVQ8.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const chunkedCalls = [
        []
    ];
    let currentChunk = 0;
    let currentChunkSize = 0;
    for(let i = 0; i < contracts.length; i++){
        const { abi: abi, address: address, args: args, functionName: functionName } = contracts[i];
        try {
            const callData = (0, $aYJZ1.encodeFunctionData)({
                abi: abi,
                args: args,
                functionName: functionName
            });
            currentChunkSize += (callData.length - 2) / 2;
            // Check to see if we need to create a new chunk.
            if (// Check if batching is enabled.
            batchSize > 0 && // Check if the current size of the batch exceeds the size limit.
            currentChunkSize > batchSize && // Check if the current chunk is not already empty.
            chunkedCalls[currentChunk].length > 0) {
                currentChunk++;
                currentChunkSize = (callData.length - 2) / 2;
                chunkedCalls[currentChunk] = [];
            }
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: callData,
                    target: address
                }
            ];
        } catch (err) {
            const error = (0, $768c9bcff606843b$export$4414444aba6ddd8a)(err, {
                abi: abi,
                address: address,
                args: args,
                docsPath: "/docs/contract/multicall",
                functionName: functionName
            });
            if (!allowFailure) throw error;
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: "0x",
                    target: address
                }
            ];
        }
    }
    const aggregate3Results = await Promise.allSettled(chunkedCalls.map((calls)=>(0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $2ba19faf5017d144$export$43af7de392176737), "readContract")({
            abi: (0, $6Dftn.multicall3Abi),
            address: multicallAddress,
            args: [
                calls
            ],
            blockNumber: blockNumber,
            blockTag: blockTag,
            functionName: "aggregate3",
            stateOverride: stateOverride
        })));
    const results = [];
    for(let i = 0; i < aggregate3Results.length; i++){
        const result = aggregate3Results[i];
        // If an error occurred in a `readContract` invocation (ie. network error),
        // then append the failure reason to each contract result.
        if (result.status === "rejected") {
            if (!allowFailure) throw result.reason;
            for(let j = 0; j < chunkedCalls[i].length; j++)results.push({
                status: "failure",
                error: result.reason,
                result: undefined
            });
            continue;
        }
        // If the `readContract` call was successful, then decode the results.
        const aggregate3Result = result.value;
        for(let j = 0; j < aggregate3Result.length; j++){
            // Extract the response from `readContract`
            const { returnData: returnData, success: success } = aggregate3Result[j];
            // Extract the request call data from the original call.
            const { callData: callData } = chunkedCalls[i][j];
            // Extract the contract config for this call from the `contracts` argument
            // for decoding.
            const { abi: abi, address: address, functionName: functionName, args: args } = contracts[results.length];
            try {
                if (callData === "0x") throw new (0, $8p1we.AbiDecodingZeroDataError)();
                if (!success) throw new (0, $hfefF.RawContractError)({
                    data: returnData
                });
                const result = (0, $dzDwb.decodeFunctionResult)({
                    abi: abi,
                    args: args,
                    data: returnData,
                    functionName: functionName
                });
                results.push(allowFailure ? {
                    result: result,
                    status: "success"
                } : result);
            } catch (err) {
                const error = (0, $768c9bcff606843b$export$4414444aba6ddd8a)(err, {
                    abi: abi,
                    address: address,
                    args: args,
                    docsPath: "/docs/contract/multicall",
                    functionName: functionName
                });
                if (!allowFailure) throw error;
                results.push({
                    error: error,
                    result: undefined,
                    status: "failure"
                });
            }
        }
    }
    if (results.length !== contracts.length) throw new (0, $cahqm.BaseError)("multicall results mismatch");
    return results;
}



async function $91400b405c4729cd$export$60ef70589ee4f7ad(config, parameters) {
    const { allowFailure: allowFailure = true, chainId: chainId, contracts: contracts, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $b2506b600107942b$export$6ca3170acb89054)(client, (0, $dc0d72ee3c69399a$export$60ef70589ee4f7ad), "multicall");
    return action({
        allowFailure: allowFailure,
        contracts: contracts,
        ...rest
    });
}




function $434c20214b37919e$export$43af7de392176737(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $b2506b600107942b$export$6ca3170acb89054)(client, (0, $2ba19faf5017d144$export$43af7de392176737), "readContract");
    return action(rest);
}


async function $e6ff069a34f21109$export$aa7cd72d27ce4a5(config, parameters) {
    const { allowFailure: allowFailure = true, blockNumber: blockNumber, blockTag: blockTag, ...rest } = parameters;
    const contracts = parameters.contracts;
    try {
        const contractsByChainId = {};
        for (const [index, contract] of contracts.entries()){
            const chainId = contract.chainId ?? config.state.chainId;
            if (!contractsByChainId[chainId]) contractsByChainId[chainId] = [];
            contractsByChainId[chainId]?.push({
                contract: contract,
                index: index
            });
        }
        const promises = ()=>Object.entries(contractsByChainId).map(([chainId, contracts])=>(0, $91400b405c4729cd$export$60ef70589ee4f7ad)(config, {
                    ...rest,
                    allowFailure: allowFailure,
                    blockNumber: blockNumber,
                    blockTag: blockTag,
                    chainId: Number.parseInt(chainId),
                    contracts: contracts.map(({ contract: contract })=>contract)
                }));
        const multicallResults = (await Promise.all(promises())).flat();
        // Reorder the contract results back to the order they were
        // provided in.
        const resultIndexes = Object.values(contractsByChainId).flatMap((contracts)=>contracts.map(({ index: index })=>index));
        return multicallResults.reduce((results, result, index)=>{
            if (results) results[resultIndexes[index]] = result;
            return results;
        }, []);
    } catch (error) {
        if (error instanceof (0, $hfefF.ContractFunctionExecutionError)) throw error;
        const promises = ()=>contracts.map((contract)=>(0, $434c20214b37919e$export$43af7de392176737)(config, {
                    ...contract,
                    blockNumber: blockNumber,
                    blockTag: blockTag
                }));
        if (allowFailure) return (await Promise.allSettled(promises())).map((result)=>{
            if (result.status === "fulfilled") return {
                result: result.value,
                status: "success"
            };
            return {
                error: result.reason,
                result: undefined,
                status: "failure"
            };
        });
        return await Promise.all(promises());
    }
}


async function $fbca91f97c11380e$export$df96cd8d56be0ab1(config, parameters) {
    const { address: address, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, token: tokenAddress, unit: unit = "ether" } = parameters;
    if (tokenAddress) try {
        return await $fbca91f97c11380e$var$getTokenBalance(config, {
            balanceAddress: address,
            chainId: chainId,
            symbolType: "string",
            tokenAddress: tokenAddress
        });
    } catch (error) {
        // In the chance that there is an error upon decoding the contract result,
        // it could be likely that the contract data is represented as bytes32 instead
        // of a string.
        if (error.name === "ContractFunctionExecutionError") {
            const balance = await $fbca91f97c11380e$var$getTokenBalance(config, {
                balanceAddress: address,
                chainId: chainId,
                symbolType: "bytes32",
                tokenAddress: tokenAddress
            });
            const symbol = (0, $9GGVO.hexToString)((0, $geW6W.trim)(balance.symbol, {
                dir: "right"
            }));
            return {
                ...balance,
                symbol: symbol
            };
        }
        throw error;
    }
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $b2506b600107942b$export$6ca3170acb89054)(client, (0, $1c1667fc515d46a5$export$df96cd8d56be0ab1), "getBalance");
    const value = await action(blockNumber ? {
        address: address,
        blockNumber: blockNumber
    } : {
        address: address,
        blockTag: blockTag
    });
    const chain = config.chains.find((x)=>x.id === chainId) ?? client.chain;
    return {
        decimals: chain.nativeCurrency.decimals,
        formatted: (0, $iwa3L.formatUnits)(value, (0, $4966a01d31a23c89$export$65f2564e9a9b9222)(unit)),
        symbol: chain.nativeCurrency.symbol,
        value: value
    };
}
async function $fbca91f97c11380e$var$getTokenBalance(config, parameters) {
    const { balanceAddress: balanceAddress, chainId: chainId, symbolType: symbolType, tokenAddress: tokenAddress, unit: unit } = parameters;
    const contract = {
        abi: [
            {
                type: "function",
                name: "balanceOf",
                stateMutability: "view",
                inputs: [
                    {
                        type: "address"
                    }
                ],
                outputs: [
                    {
                        type: "uint256"
                    }
                ]
            },
            {
                type: "function",
                name: "decimals",
                stateMutability: "view",
                inputs: [],
                outputs: [
                    {
                        type: "uint8"
                    }
                ]
            },
            {
                type: "function",
                name: "symbol",
                stateMutability: "view",
                inputs: [],
                outputs: [
                    {
                        type: symbolType
                    }
                ]
            }
        ],
        address: tokenAddress
    };
    const [value, decimals, symbol] = await (0, $e6ff069a34f21109$export$aa7cd72d27ce4a5)(config, {
        allowFailure: false,
        contracts: [
            {
                ...contract,
                functionName: "balanceOf",
                args: [
                    balanceAddress
                ],
                chainId: chainId
            },
            {
                ...contract,
                functionName: "decimals",
                chainId: chainId
            },
            {
                ...contract,
                functionName: "symbol",
                chainId: chainId
            }
        ]
    });
    const formatted = (0, $iwa3L.formatUnits)(value ?? "0", (0, $4966a01d31a23c89$export$65f2564e9a9b9222)(unit ?? decimals));
    return {
        decimals: decimals,
        formatted: formatted,
        symbol: symbol,
        value: value
    };
}



var $cahqm = parcelRequire("cahqm");
class $d0e43b0b660b9c4c$export$3d9377558041f9cf extends (0, $cahqm.BaseError) {
    constructor({ data: data }){
        super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
            metaMessages: [
                "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
                "",
                `Provided data: ${JSON.stringify(data)}`
            ],
            name: "EnsAvatarInvalidMetadataError"
        });
    }
}
class $d0e43b0b660b9c4c$export$74a8ea52cecec305 extends (0, $cahqm.BaseError) {
    constructor({ reason: reason }){
        super(`ENS NFT avatar URI is invalid. ${reason}`, {
            name: "EnsAvatarInvalidNftUriError"
        });
    }
}
class $d0e43b0b660b9c4c$export$f202ff3d50da14eb extends (0, $cahqm.BaseError) {
    constructor({ uri: uri }){
        super(`Unable to resolve ENS avatar URI "${uri}". The URI may be malformed, invalid, or does not respond with a valid image.`, {
            name: "EnsAvatarUriResolutionError"
        });
    }
}
class $d0e43b0b660b9c4c$export$45137f20297c5e74 extends (0, $cahqm.BaseError) {
    constructor({ namespace: namespace }){
        super(`ENS NFT avatar namespace "${namespace}" is not supported. Must be "erc721" or "erc1155".`, {
            name: "EnsAvatarUnsupportedNamespaceError"
        });
    }
}


const $3a207baf373c9018$var$networkRegex = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/;
const $3a207baf373c9018$var$ipfsHashRegex = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/;
const $3a207baf373c9018$var$base64Regex = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/;
const $3a207baf373c9018$var$dataURIRegex = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function $3a207baf373c9018$export$db9c123edba6463(uri) {
    try {
        const res = await fetch(uri, {
            method: "HEAD"
        });
        // retrieve content type header to check if content is image
        if (res.status === 200) {
            const contentType = res.headers.get("content-type");
            return contentType?.startsWith("image/");
        }
        return false;
    } catch (error) {
        // if error is not cors related then fail
        if (typeof error === "object" && typeof error.response !== "undefined") return false;
        // fail in NodeJS, since the error is not cors but any other network issue
        // biome-ignore lint/suspicious/noPrototypeBuiltins:
        if (!globalThis.hasOwnProperty("Image")) return false;
        // in case of cors, use image api to validate if given url is an actual image
        return new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>{
                resolve(true);
            };
            img.onerror = ()=>{
                resolve(false);
            };
            img.src = uri;
        });
    }
}
function $3a207baf373c9018$export$90df7f536ca3f624(custom, defaultGateway) {
    if (!custom) return defaultGateway;
    if (custom.endsWith("/")) return custom.slice(0, -1);
    return custom;
}
function $3a207baf373c9018$export$9c878106a0d8edac({ uri: uri, gatewayUrls: gatewayUrls }) {
    const isEncoded = $3a207baf373c9018$var$base64Regex.test(uri);
    if (isEncoded) return {
        uri: uri,
        isOnChain: true,
        isEncoded: isEncoded
    };
    const ipfsGateway = $3a207baf373c9018$export$90df7f536ca3f624(gatewayUrls?.ipfs, "https://ipfs.io");
    const arweaveGateway = $3a207baf373c9018$export$90df7f536ca3f624(gatewayUrls?.arweave, "https://arweave.net");
    const networkRegexMatch = uri.match($3a207baf373c9018$var$networkRegex);
    const { protocol: protocol, subpath: subpath, target: target, subtarget: subtarget = "" } = networkRegexMatch?.groups || {};
    const isIPNS = protocol === "ipns:/" || subpath === "ipns/";
    const isIPFS = protocol === "ipfs:/" || subpath === "ipfs/" || $3a207baf373c9018$var$ipfsHashRegex.test(uri);
    if (uri.startsWith("http") && !isIPNS && !isIPFS) {
        let replacedUri = uri;
        if (gatewayUrls?.arweave) replacedUri = uri.replace(/https:\/\/arweave.net/g, gatewayUrls?.arweave);
        return {
            uri: replacedUri,
            isOnChain: false,
            isEncoded: false
        };
    }
    if ((isIPNS || isIPFS) && target) return {
        uri: `${ipfsGateway}/${isIPNS ? "ipns" : "ipfs"}/${target}${subtarget}`,
        isOnChain: false,
        isEncoded: false
    };
    if (protocol === "ar:/" && target) return {
        uri: `${arweaveGateway}/${target}${subtarget || ""}`,
        isOnChain: false,
        isEncoded: false
    };
    let parsedUri = uri.replace($3a207baf373c9018$var$dataURIRegex, "");
    if (parsedUri.startsWith("<svg")) // if svg, base64 encode
    parsedUri = `data:image/svg+xml;base64,${btoa(parsedUri)}`;
    if (parsedUri.startsWith("data:") || parsedUri.startsWith("{")) return {
        uri: parsedUri,
        isOnChain: true,
        isEncoded: false
    };
    throw new (0, $d0e43b0b660b9c4c$export$f202ff3d50da14eb)({
        uri: uri
    });
}
function $3a207baf373c9018$export$9be3fe34a3333ecb(data) {
    // validation check for json data, must include one of theses properties
    if (typeof data !== "object" || !("image" in data) && !("image_url" in data) && !("image_data" in data)) throw new (0, $d0e43b0b660b9c4c$export$3d9377558041f9cf)({
        data: data
    });
    return data.image || data.image_url || data.image_data;
}
async function $3a207baf373c9018$export$b9759ed161b5e3c5({ gatewayUrls: gatewayUrls, uri: uri }) {
    try {
        const res = await fetch(uri).then((res)=>res.json());
        const image = await $3a207baf373c9018$export$1f4e569649d3a793({
            gatewayUrls: gatewayUrls,
            uri: $3a207baf373c9018$export$9be3fe34a3333ecb(res)
        });
        return image;
    } catch  {
        throw new (0, $d0e43b0b660b9c4c$export$f202ff3d50da14eb)({
            uri: uri
        });
    }
}
async function $3a207baf373c9018$export$1f4e569649d3a793({ gatewayUrls: gatewayUrls, uri: uri }) {
    const { uri: resolvedURI, isOnChain: isOnChain } = $3a207baf373c9018$export$9c878106a0d8edac({
        uri: uri,
        gatewayUrls: gatewayUrls
    });
    if (isOnChain) return resolvedURI;
    // check if resolvedURI is an image, if it is return the url
    const isImage = await $3a207baf373c9018$export$db9c123edba6463(resolvedURI);
    if (isImage) return resolvedURI;
    throw new (0, $d0e43b0b660b9c4c$export$f202ff3d50da14eb)({
        uri: uri
    });
}
function $3a207baf373c9018$export$e78cf22c9d52ca8a(uri_) {
    let uri = uri_;
    // parse valid nft spec (CAIP-22/CAIP-29)
    // @see: https://github.com/ChainAgnostic/CAIPs/tree/master/CAIPs
    if (uri.startsWith("did:nft:")) // convert DID to CAIP
    uri = uri.replace("did:nft:", "").replace(/_/g, "/");
    const [reference, asset_namespace, tokenID] = uri.split("/");
    const [eip_namespace, chainID] = reference.split(":");
    const [erc_namespace, contractAddress] = asset_namespace.split(":");
    if (!eip_namespace || eip_namespace.toLowerCase() !== "eip155") throw new (0, $d0e43b0b660b9c4c$export$74a8ea52cecec305)({
        reason: "Only EIP-155 supported"
    });
    if (!chainID) throw new (0, $d0e43b0b660b9c4c$export$74a8ea52cecec305)({
        reason: "Chain ID not found"
    });
    if (!contractAddress) throw new (0, $d0e43b0b660b9c4c$export$74a8ea52cecec305)({
        reason: "Contract address not found"
    });
    if (!tokenID) throw new (0, $d0e43b0b660b9c4c$export$74a8ea52cecec305)({
        reason: "Token ID not found"
    });
    if (!erc_namespace) throw new (0, $d0e43b0b660b9c4c$export$74a8ea52cecec305)({
        reason: "ERC namespace not found"
    });
    return {
        chainID: Number.parseInt(chainID),
        namespace: erc_namespace.toLowerCase(),
        contractAddress: contractAddress,
        tokenID: tokenID
    };
}
async function $3a207baf373c9018$export$29b8ee2b96a1ed4f(client, { nft: nft }) {
    if (nft.namespace === "erc721") return (0, $2ba19faf5017d144$export$43af7de392176737)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "tokenURI",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "tokenId",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "tokenURI",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    if (nft.namespace === "erc1155") return (0, $2ba19faf5017d144$export$43af7de392176737)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "uri",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "_id",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "uri",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    throw new (0, $d0e43b0b660b9c4c$export$45137f20297c5e74)({
        namespace: nft.namespace
    });
}


async function $c833b54068ce4594$export$3713446b2fba5(client, { gatewayUrls: gatewayUrls, record: record }) {
    if (/eip155:/i.test(record)) return $c833b54068ce4594$var$parseNftAvatarUri(client, {
        gatewayUrls: gatewayUrls,
        record: record
    });
    return (0, $3a207baf373c9018$export$1f4e569649d3a793)({
        uri: record,
        gatewayUrls: gatewayUrls
    });
}
async function $c833b54068ce4594$var$parseNftAvatarUri(client, { gatewayUrls: gatewayUrls, record: record }) {
    // parse NFT URI into properties
    const nft = (0, $3a207baf373c9018$export$e78cf22c9d52ca8a)(record);
    // fetch tokenURI from the NFT contract
    const nftUri = await (0, $3a207baf373c9018$export$29b8ee2b96a1ed4f)(client, {
        nft: nft
    });
    // resolve the URI from the fetched tokenURI
    const { uri: resolvedNftUri, isOnChain: isOnChain, isEncoded: isEncoded } = (0, $3a207baf373c9018$export$9c878106a0d8edac)({
        uri: nftUri,
        gatewayUrls: gatewayUrls
    });
    // if the resolved URI is on chain, return the data
    if (isOnChain && (resolvedNftUri.includes("data:application/json;base64,") || resolvedNftUri.startsWith("{"))) {
        const encodedJson = isEncoded ? atob(resolvedNftUri.replace("data:application/json;base64,", "")) : resolvedNftUri;
        const decoded = JSON.parse(encodedJson);
        return (0, $3a207baf373c9018$export$1f4e569649d3a793)({
            uri: (0, $3a207baf373c9018$export$9be3fe34a3333ecb)(decoded),
            gatewayUrls: gatewayUrls
        });
    }
    let uriTokenId = nft.tokenID;
    if (nft.namespace === "erc1155") uriTokenId = uriTokenId.replace("0x", "").padStart(64, "0");
    return (0, $3a207baf373c9018$export$b9759ed161b5e3c5)({
        gatewayUrls: gatewayUrls,
        uri: resolvedNftUri.replace(/(?:0x)?{id}/, uriTokenId)
    });
}




var $6Dftn = parcelRequire("6Dftn");

var $dzDwb = parcelRequire("dzDwb");

var $aYJZ1 = parcelRequire("aYJZ1");

var $fVVQ8 = parcelRequire("fVVQ8");

var $jW8ut = parcelRequire("jW8ut");

var $4a4RY = parcelRequire("4a4RY");

var $cahqm = parcelRequire("cahqm");

var $hfefF = parcelRequire("hfefF");
function $df83d1c433841d94$export$78f90e26b9356cd7(err, callType) {
    if (!(err instanceof (0, $cahqm.BaseError))) return false;
    const cause = err.walk((e)=>e instanceof (0, $hfefF.ContractFunctionRevertedError));
    if (!(cause instanceof (0, $hfefF.ContractFunctionRevertedError))) return false;
    if (cause.data?.errorName === "ResolverNotFound") return true;
    if (cause.data?.errorName === "ResolverWildcardNotSupported") return true;
    if (cause.data?.errorName === "ResolverNotContract") return true;
    if (cause.data?.errorName === "ResolverError") return true;
    if (cause.data?.errorName === "HttpError") return true;
    // Backwards compatibility for older UniversalResolver contracts
    if (cause.reason?.includes("Wildcard on non-extended resolvers is not supported")) return true;
    // No primary name set for address.
    if (callType === "reverse" && cause.reason === (0, $4a4RY.panicReasons)[50]) return true;
    return false;
}



var $jnwfF = parcelRequire("jnwfF");

var $cY7Yq = parcelRequire("cY7Yq");

var $jW8ut = parcelRequire("jW8ut");

var $diQni = parcelRequire("diQni");

var $16Qvp = parcelRequire("16Qvp");
function $a62acde1fc3bcbaa$export$cbf748cac2e87c52(label) {
    if (label.length !== 66) return null;
    if (label.indexOf("[") !== 0) return null;
    if (label.indexOf("]") !== 65) return null;
    const hash = `0x${label.slice(1, 65)}`;
    if (!(0, $16Qvp.isHex)(hash)) return null;
    return hash;
}


function $968536f70dae80fc$export$91d651ee363e1209(name) {
    let result = new Uint8Array(32).fill(0);
    if (!name) return (0, $jW8ut.bytesToHex)(result);
    const labels = name.split(".");
    // Iterate in reverse order building up hash
    for(let i = labels.length - 1; i >= 0; i -= 1){
        const hashFromEncodedLabel = (0, $a62acde1fc3bcbaa$export$cbf748cac2e87c52)(labels[i]);
        const hashed = hashFromEncodedLabel ? (0, $cY7Yq.toBytes)(hashFromEncodedLabel) : (0, $diQni.keccak256)((0, $cY7Yq.stringToBytes)(labels[i]), "bytes");
        result = (0, $diQni.keccak256)((0, $jnwfF.concat)([
            result,
            hashed
        ]), "bytes");
    }
    return (0, $jW8ut.bytesToHex)(result);
}



var $cY7Yq = parcelRequire("cY7Yq");
function $885327ace747f3cf$export$c23ac52da6ff5062(hash) {
    return `[${hash.slice(2)}]`;
}



var $cY7Yq = parcelRequire("cY7Yq");

var $jW8ut = parcelRequire("jW8ut");

var $diQni = parcelRequire("diQni");

function $10af81f6ea282432$export$83615f6c30436a69(label) {
    const result = new Uint8Array(32).fill(0);
    if (!label) return (0, $jW8ut.bytesToHex)(result);
    return (0, $a62acde1fc3bcbaa$export$cbf748cac2e87c52)(label) || (0, $diQni.keccak256)((0, $cY7Yq.stringToBytes)(label));
}


function $9b043beeb0ee5e19$export$8a0899f9ded0844(packet) {
    // strip leading and trailing `.`
    const value = packet.replace(/^\.|\.$/gm, "");
    if (value.length === 0) return new Uint8Array(1);
    const bytes = new Uint8Array((0, $cY7Yq.stringToBytes)(value).byteLength + 2);
    let offset = 0;
    const list = value.split(".");
    for(let i = 0; i < list.length; i++){
        let encoded = (0, $cY7Yq.stringToBytes)(list[i]);
        // if the length is > 255, make the encoded label value a labelhash
        // this is compatible with the universal resolver
        if (encoded.byteLength > 255) encoded = (0, $cY7Yq.stringToBytes)((0, $885327ace747f3cf$export$c23ac52da6ff5062)((0, $10af81f6ea282432$export$83615f6c30436a69)(list[i])));
        bytes[offset] = encoded.length;
        bytes.set(encoded, offset + 1);
        offset += encoded.length + 1;
    }
    if (bytes.byteLength !== offset + 1) return bytes.slice(0, offset + 1);
    return bytes;
}




async function $a6e375d8a4af9666$export$2b2c96dabd62b431(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, key: key, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $fVVQ8.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const readContractParameters = {
            address: universalResolverAddress,
            abi: (0, $6Dftn.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $jW8ut.toHex)((0, $9b043beeb0ee5e19$export$8a0899f9ded0844)(name)),
                (0, $aYJZ1.encodeFunctionData)({
                    abi: (0, $6Dftn.textResolverAbi),
                    functionName: "text",
                    args: [
                        (0, $968536f70dae80fc$export$91d651ee363e1209)(name),
                        key
                    ]
                })
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        };
        const readContractAction = (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $2ba19faf5017d144$export$43af7de392176737), "readContract");
        const res = gatewayUrls ? await readContractAction({
            ...readContractParameters,
            args: [
                ...readContractParameters.args,
                gatewayUrls
            ]
        }) : await readContractAction(readContractParameters);
        if (res[0] === "0x") return null;
        const record = (0, $dzDwb.decodeFunctionResult)({
            abi: (0, $6Dftn.textResolverAbi),
            functionName: "text",
            data: res[0]
        });
        return record === "" ? null : record;
    } catch (err) {
        if (strict) throw err;
        if ((0, $df83d1c433841d94$export$78f90e26b9356cd7)(err, "resolve")) return null;
        throw err;
    }
}


async function $13657efc615be89d$export$65f1d2b9649a54e5(client, { blockNumber: blockNumber, blockTag: blockTag, assetGatewayUrls: assetGatewayUrls, name: name, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress }) {
    const record = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $a6e375d8a4af9666$export$2b2c96dabd62b431), "getEnsText")({
        blockNumber: blockNumber,
        blockTag: blockTag,
        key: "avatar",
        name: name,
        universalResolverAddress: universalResolverAddress,
        gatewayUrls: gatewayUrls,
        strict: strict
    });
    if (!record) return null;
    try {
        return await (0, $c833b54068ce4594$export$3713446b2fba5)(client, {
            record: record,
            gatewayUrls: assetGatewayUrls
        });
    } catch  {
        return null;
    }
}



function $44f135bdb81b9ccf$export$65f1d2b9649a54e5(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $b2506b600107942b$export$6ca3170acb89054)(client, (0, $13657efc615be89d$export$65f1d2b9649a54e5), "getEnsAvatar");
    return action(rest);
}


var $6Dftn = parcelRequire("6Dftn");

var $fVVQ8 = parcelRequire("fVVQ8");

var $jW8ut = parcelRequire("jW8ut");




async function $9857d8fa16446645$export$e1b98d9bc05a9fc2(client, { address: address, blockNumber: blockNumber, blockTag: blockTag, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $fVVQ8.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const reverseNode = `${address.toLowerCase().substring(2)}.addr.reverse`;
    try {
        const readContractParameters = {
            address: universalResolverAddress,
            abi: (0, $6Dftn.universalResolverReverseAbi),
            functionName: "reverse",
            args: [
                (0, $jW8ut.toHex)((0, $9b043beeb0ee5e19$export$8a0899f9ded0844)(reverseNode))
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        };
        const readContractAction = (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $2ba19faf5017d144$export$43af7de392176737), "readContract");
        const [name, resolvedAddress] = gatewayUrls ? await readContractAction({
            ...readContractParameters,
            args: [
                ...readContractParameters.args,
                gatewayUrls
            ]
        }) : await readContractAction(readContractParameters);
        if (address.toLowerCase() !== resolvedAddress.toLowerCase()) return null;
        return name;
    } catch (err) {
        if (strict) throw err;
        if ((0, $df83d1c433841d94$export$78f90e26b9356cd7)(err, "reverse")) return null;
        throw err;
    }
}



function $b3b28e2ddfde4d0a$export$e1b98d9bc05a9fc2(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $b2506b600107942b$export$6ca3170acb89054)(client, (0, $9857d8fa16446645$export$e1b98d9bc05a9fc2), "getEnsName");
    return action(rest);
}


var $gbEG8 = parcelRequire("gbEG8");

var $cahqm = parcelRequire("cahqm");
class $a7181154857b10db$export$62ee6b05f0767f28 extends (0, $cahqm.BaseError) {
    constructor({ docsPath: docsPath } = {}){
        super([
            "Could not find an Account to execute with this Action.",
            "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the Client."
        ].join("\n"), {
            docsPath: docsPath,
            docsSlug: "account",
            name: "AccountNotFoundError"
        });
    }
}
class $a7181154857b10db$export$22c1d840ef5fbc66 extends (0, $cahqm.BaseError) {
    constructor({ docsPath: docsPath, metaMessages: metaMessages, type: type }){
        super(`Account type "${type}" is not supported.`, {
            docsPath: docsPath,
            metaMessages: metaMessages,
            name: "AccountTypeNotSupportedError"
        });
    }
}



var $jW8ut = parcelRequire("jW8ut");
async function $4662c803f63664f1$export$1d9a7a8a40780de(client, { account: account_ = client.account, message: message }) {
    if (!account_) throw new (0, $a7181154857b10db$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/signMessage"
    });
    const account = (0, $gbEG8.parseAccount)(account_);
    if (account.signMessage) return account.signMessage({
        message: message
    });
    const message_ = (()=>{
        if (typeof message === "string") return (0, $jW8ut.stringToHex)(message);
        if (message.raw instanceof Uint8Array) return (0, $jW8ut.toHex)(message.raw);
        return message.raw;
    })();
    return client.request({
        method: "personal_sign",
        params: [
            message_,
            account.address
        ]
    }, {
        retryCount: 0
    });
}




var $gbEG8 = parcelRequire("gbEG8");
const $0daf454b4bda188c$var$size = 256;
let $0daf454b4bda188c$var$index = $0daf454b4bda188c$var$size;
let $0daf454b4bda188c$var$buffer;
function $0daf454b4bda188c$export$e2a22331486dcca0(length = 11) {
    if (!$0daf454b4bda188c$var$buffer || $0daf454b4bda188c$var$index + length > $0daf454b4bda188c$var$size * 2) {
        $0daf454b4bda188c$var$buffer = "";
        $0daf454b4bda188c$var$index = 0;
        for(let i = 0; i < $0daf454b4bda188c$var$size; i++)$0daf454b4bda188c$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $0daf454b4bda188c$var$buffer.substring($0daf454b4bda188c$var$index, $0daf454b4bda188c$var$index++ + length);
}


function $39c00038e35bed34$export$5d730b7aed1a3eb0(parameters) {
    const { batch: batch, cacheTime: cacheTime = parameters.pollingInterval ?? 4000, ccipRead: ccipRead, key: key = "base", name: name = "Base Client", pollingInterval: pollingInterval = 4000, type: type = "base" } = parameters;
    const chain = parameters.chain;
    const account = parameters.account ? (0, $gbEG8.parseAccount)(parameters.account) : undefined;
    const { config: config, request: request, value: value } = parameters.transport({
        chain: chain,
        pollingInterval: pollingInterval
    });
    const transport = {
        ...config,
        ...value
    };
    const client = {
        account: account,
        batch: batch,
        cacheTime: cacheTime,
        ccipRead: ccipRead,
        chain: chain,
        key: key,
        name: name,
        pollingInterval: pollingInterval,
        request: request,
        transport: transport,
        type: type,
        uid: (0, $0daf454b4bda188c$export$e2a22331486dcca0)()
    };
    function extend(base) {
        return (extendFn)=>{
            const extended = extendFn(base);
            for(const key in client)delete extended[key];
            const combined = {
                ...base,
                ...extended
            };
            return Object.assign(combined, {
                extend: extend(combined)
            });
        };
    }
    return Object.assign(client, {
        extend: extend(client)
    });
}
function $39c00038e35bed34$export$3db60a9e016ddd81() {
    return null;
}


var $cahqm = parcelRequire("cahqm");

var $aBz5G = parcelRequire("aBz5G");

var $iy34j = parcelRequire("iy34j");

var $jW8ut = parcelRequire("jW8ut");

var $2iCjp = parcelRequire("2iCjp");
const $3da5a7357dddc24c$export$e89e805418f4d2c = /*#__PURE__*/ new (0, $2iCjp.LruMap)(8192);
function $3da5a7357dddc24c$export$387c3b0c09132fc3(fn, { enabled: enabled = true, id: id }) {
    if (!enabled || !id) return fn();
    if ($3da5a7357dddc24c$export$e89e805418f4d2c.get(id)) return $3da5a7357dddc24c$export$e89e805418f4d2c.get(id);
    const promise = fn().finally(()=>$3da5a7357dddc24c$export$e89e805418f4d2c.delete(id));
    $3da5a7357dddc24c$export$e89e805418f4d2c.set(id, promise);
    return promise;
}


async function $1d2d721ab882bc34$export$5c069c93d2b7493f(time) {
    return new Promise((res)=>setTimeout(res, time));
}


function $32aed14017c02240$export$188df5ecf8e7961a(fn, { delay: delay_ = 100, retryCount: retryCount = 2, shouldRetry: shouldRetry = ()=>true } = {}) {
    return new Promise((resolve, reject)=>{
        const attemptRetry = async ({ count: count = 0 } = {})=>{
            const retry = async ({ error: error })=>{
                const delay = typeof delay_ === "function" ? delay_({
                    count: count,
                    error: error
                }) : delay_;
                if (delay) await (0, $1d2d721ab882bc34$export$5c069c93d2b7493f)(delay);
                attemptRetry({
                    count: count + 1
                });
            };
            try {
                const data = await fn();
                resolve(data);
            } catch (err) {
                if (count < retryCount && await shouldRetry({
                    count: count,
                    error: err
                })) return retry({
                    error: err
                });
                reject(err);
            }
        };
        attemptRetry();
    });
}



var $6fuj2 = parcelRequire("6fuj2");
function $6d6b914b4895d7af$export$6c5295ef7e82f2b2(request, options = {}) {
    return async (args, overrideOptions = {})=>{
        const { dedupe: dedupe = false, methods: methods, retryDelay: retryDelay = 150, retryCount: retryCount = 3, uid: uid } = {
            ...options,
            ...overrideOptions
        };
        const { method: method } = args;
        if (methods?.exclude?.includes(method)) throw new (0, $iy34j.MethodNotSupportedRpcError)(new Error("method not supported"), {
            method: method
        });
        if (methods?.include && !methods.include.includes(method)) throw new (0, $iy34j.MethodNotSupportedRpcError)(new Error("method not supported"), {
            method: method
        });
        const requestId = dedupe ? (0, $jW8ut.stringToHex)(`${uid}.${(0, $6fuj2.stringify)(args)}`) : undefined;
        return (0, $3da5a7357dddc24c$export$387c3b0c09132fc3)(()=>(0, $32aed14017c02240$export$188df5ecf8e7961a)(async ()=>{
                try {
                    return await request(args);
                } catch (err_) {
                    const err = err_;
                    switch(err.code){
                        // -32700
                        case (0, $iy34j.ParseRpcError).code:
                            throw new (0, $iy34j.ParseRpcError)(err);
                        // -32600
                        case (0, $iy34j.InvalidRequestRpcError).code:
                            throw new (0, $iy34j.InvalidRequestRpcError)(err);
                        // -32601
                        case (0, $iy34j.MethodNotFoundRpcError).code:
                            throw new (0, $iy34j.MethodNotFoundRpcError)(err, {
                                method: args.method
                            });
                        // -32602
                        case (0, $iy34j.InvalidParamsRpcError).code:
                            throw new (0, $iy34j.InvalidParamsRpcError)(err);
                        // -32603
                        case (0, $iy34j.InternalRpcError).code:
                            throw new (0, $iy34j.InternalRpcError)(err);
                        // -32000
                        case (0, $iy34j.InvalidInputRpcError).code:
                            throw new (0, $iy34j.InvalidInputRpcError)(err);
                        // -32001
                        case (0, $iy34j.ResourceNotFoundRpcError).code:
                            throw new (0, $iy34j.ResourceNotFoundRpcError)(err);
                        // -32002
                        case (0, $iy34j.ResourceUnavailableRpcError).code:
                            throw new (0, $iy34j.ResourceUnavailableRpcError)(err);
                        // -32003
                        case (0, $iy34j.TransactionRejectedRpcError).code:
                            throw new (0, $iy34j.TransactionRejectedRpcError)(err);
                        // -32004
                        case (0, $iy34j.MethodNotSupportedRpcError).code:
                            throw new (0, $iy34j.MethodNotSupportedRpcError)(err, {
                                method: args.method
                            });
                        // -32005
                        case (0, $iy34j.LimitExceededRpcError).code:
                            throw new (0, $iy34j.LimitExceededRpcError)(err);
                        // -32006
                        case (0, $iy34j.JsonRpcVersionUnsupportedError).code:
                            throw new (0, $iy34j.JsonRpcVersionUnsupportedError)(err);
                        // 4001
                        case (0, $iy34j.UserRejectedRequestError).code:
                            throw new (0, $iy34j.UserRejectedRequestError)(err);
                        // 4100
                        case (0, $iy34j.UnauthorizedProviderError).code:
                            throw new (0, $iy34j.UnauthorizedProviderError)(err);
                        // 4200
                        case (0, $iy34j.UnsupportedProviderMethodError).code:
                            throw new (0, $iy34j.UnsupportedProviderMethodError)(err);
                        // 4900
                        case (0, $iy34j.ProviderDisconnectedError).code:
                            throw new (0, $iy34j.ProviderDisconnectedError)(err);
                        // 4901
                        case (0, $iy34j.ChainDisconnectedError).code:
                            throw new (0, $iy34j.ChainDisconnectedError)(err);
                        // 4902
                        case (0, $iy34j.SwitchChainError).code:
                            throw new (0, $iy34j.SwitchChainError)(err);
                        // CAIP-25: User Rejected Error
                        // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes#rejected-caip-25
                        case 5000:
                            throw new (0, $iy34j.UserRejectedRequestError)(err);
                        default:
                            if (err_ instanceof (0, $cahqm.BaseError)) throw err_;
                            throw new (0, $iy34j.UnknownRpcError)(err);
                    }
                }
            }, {
                delay: ({ count: count, error: error })=>{
                    // If we find a Retry-After header, let's retry after the given time.
                    if (error && error instanceof (0, $aBz5G.HttpRequestError)) {
                        const retryAfter = error?.headers?.get("Retry-After");
                        if (retryAfter?.match(/\d/)) return Number.parseInt(retryAfter) * 1000;
                    }
                    // Otherwise, let's retry with an exponential backoff.
                    return ~~(1 << count) * retryDelay;
                },
                retryCount: retryCount,
                shouldRetry: ({ error: error })=>$6d6b914b4895d7af$export$7bfea3c3d460ecd8(error)
            }), {
            enabled: dedupe,
            id: requestId
        });
    };
}
function $6d6b914b4895d7af$export$7bfea3c3d460ecd8(error) {
    if ("code" in error && typeof error.code === "number") {
        if (error.code === -1) return true; // Unknown error
        if (error.code === (0, $iy34j.LimitExceededRpcError).code) return true;
        if (error.code === (0, $iy34j.InternalRpcError).code) return true;
        return false;
    }
    if (error instanceof (0, $aBz5G.HttpRequestError) && error.status) {
        // Forbidden
        if (error.status === 403) return true;
        // Request Timeout
        if (error.status === 408) return true;
        // Request Entity Too Large
        if (error.status === 413) return true;
        // Too Many Requests
        if (error.status === 429) return true;
        // Internal Server Error
        if (error.status === 500) return true;
        // Bad Gateway
        if (error.status === 502) return true;
        // Service Unavailable
        if (error.status === 503) return true;
        // Gateway Timeout
        if (error.status === 504) return true;
        return false;
    }
    return true;
}



function $008b36b49ba998cf$export$d09f50d9ab7f7b69({ key: key, methods: methods, name: name, request: request, retryCount: retryCount = 3, retryDelay: retryDelay = 150, timeout: timeout, type: type }, value) {
    const uid = (0, $0daf454b4bda188c$export$e2a22331486dcca0)();
    return {
        config: {
            key: key,
            methods: methods,
            name: name,
            request: request,
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: type
        },
        request: (0, $6d6b914b4895d7af$export$6c5295ef7e82f2b2)(request, {
            methods: methods,
            retryCount: retryCount,
            retryDelay: retryDelay,
            uid: uid
        }),
        value: value
    };
}


function $c1b76a8a2251eb69$export$4c00f665f0d4b443(provider, config = {}) {
    const { key: key = "custom", methods: methods, name: name = "Custom Provider", retryDelay: retryDelay } = config;
    return ({ retryCount: defaultRetryCount })=>(0, $008b36b49ba998cf$export$d09f50d9ab7f7b69)({
            key: key,
            methods: methods,
            name: name,
            request: provider.request.bind(provider),
            retryCount: config.retryCount ?? defaultRetryCount,
            retryDelay: retryDelay,
            type: "custom"
        });
}



var $siouQ = parcelRequire("siouQ");
var $gbEG8 = parcelRequire("gbEG8");

async function $b0afaa668a3777c8$export$d784801ca17b4aec(config, parameters = {}) {
    // Get connection
    let connection;
    if (parameters.connector) {
        const { connector: connector } = parameters;
        if (config.state.status === "reconnecting" && !connector.getAccounts && !connector.getChainId) throw new (0, $dfd1b5f3c842a678$export$58faffcf27ce6845)({
            connector: connector
        });
        const [accounts, chainId] = await Promise.all([
            connector.getAccounts().catch((e)=>{
                if (parameters.account === null) return [];
                throw e;
            }),
            connector.getChainId()
        ]);
        connection = {
            accounts: accounts,
            chainId: chainId,
            connector: connector
        };
    } else connection = config.state.connections.get(config.state.current);
    if (!connection) throw new (0, $dfd1b5f3c842a678$export$d9a3828eace037a6)();
    const chainId = parameters.chainId ?? connection.chainId;
    // Check connector using same chainId as connection
    const connectorChainId = await connection.connector.getChainId();
    if (connectorChainId !== connection.chainId) throw new (0, $dfd1b5f3c842a678$export$6f9c2f3137249d9c)({
        connectionChainId: connection.chainId,
        connectorChainId: connectorChainId
    });
    const connector = connection.connector;
    if (connector.getClient) return connector.getClient({
        chainId: chainId
    });
    // Default using `custom` transport
    const account = (0, $gbEG8.parseAccount)(parameters.account ?? connection.accounts[0]);
    if (account) account.address = (0, $siouQ.getAddress)(account.address); // TODO: Checksum address as part of `parseAccount`?
    // If account was provided, check that it exists on the connector
    if (parameters.account && !connection.accounts.some((x)=>x.toLowerCase() === account.address.toLowerCase())) throw new (0, $dfd1b5f3c842a678$export$65c369a969e2c62e)({
        address: account.address,
        connector: connector
    });
    const chain = config.chains.find((chain)=>chain.id === chainId);
    const provider = await connection.connector.getProvider({
        chainId: chainId
    });
    return (0, $39c00038e35bed34$export$5d730b7aed1a3eb0)({
        account: account,
        chain: chain,
        name: "Connector Client",
        transport: (opts)=>(0, $c1b76a8a2251eb69$export$4c00f665f0d4b443)(provider)({
                ...opts,
                retryCount: 0
            })
    });
}


async function $d36ecd36696e227d$export$1d9a7a8a40780de(config, parameters) {
    const { account: account, connector: connector, ...rest } = parameters;
    let client;
    if (typeof account === "object" && account.type === "local") client = config.getClient();
    else client = await (0, $b0afaa668a3777c8$export$d784801ca17b4aec)(config, {
        account: account,
        connector: connector
    });
    const action = (0, $b2506b600107942b$export$6ca3170acb89054)(client, (0, $4662c803f63664f1$export$1d9a7a8a40780de), "signMessage");
    return action({
        ...rest,
        ...account ? {
            account: account
        } : {}
    });
}



class $051d3f9d080da18b$export$43839b3ff6336f15 extends (0, $2ee97e787be17453$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Provider not found.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderNotFoundError"
        });
    }
}
class $051d3f9d080da18b$export$a4296a4b7763e5d8 extends (0, $2ee97e787be17453$export$a490eb03cb7a0a5e) {
    constructor({ connector: connector }){
        super(`"${connector.name}" does not support programmatic chain switching.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SwitchChainNotSupportedError"
        });
    }
}


async function $44fa0065504bf15d$export$15599da40e72d2f(config, parameters) {
    const { addEthereumChainParameter: addEthereumChainParameter, chainId: chainId } = parameters;
    const connection = config.state.connections.get(parameters.connector?.uid ?? config.state.current);
    if (connection) {
        const connector = connection.connector;
        if (!connector.switchChain) throw new (0, $051d3f9d080da18b$export$a4296a4b7763e5d8)({
            connector: connector
        });
        const chain = await connector.switchChain({
            addEthereumChainParameter: addEthereumChainParameter,
            chainId: chainId
        });
        return chain;
    }
    const chain = config.chains.find((x)=>x.id === chainId);
    if (!chain) throw new (0, $dfd1b5f3c842a678$export$688e5fda4b4631ed)();
    config.setState((x)=>({
            ...x,
            chainId: chainId
        }));
    return chain;
}

/** Forked from https://github.com/epoberezkin/fast-deep-equal */ function $baaf6fb615ce5ef3$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        let length;
        let i;
        if (Array.isArray(a) && Array.isArray(b)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;)if (!$baaf6fb615ce5ef3$export$9cb4719e2e525b7a(a[i], b[i])) return false;
            return true;
        }
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key && !$baaf6fb615ce5ef3$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // biome-ignore lint/suspicious/noSelfCompare: <explanation>
    return a !== a && b !== b;
}



function $5bde27009cbbce16$export$30c94aeff2da2ac6(config, parameters) {
    const { onChange: onChange } = parameters;
    return config.subscribe(()=>(0, $588ed08035d28638$export$4f9234baf34abd0)(config), onChange, {
        equalityFn (a, b) {
            const { connector: aConnector, ...aRest } = a;
            const { connector: bConnector, ...bRest } = b;
            return (0, $baaf6fb615ce5ef3$export$9cb4719e2e525b7a)(aRest, bRest) && // check connector separately
            aConnector?.id === bConnector?.id && aConnector?.uid === bConnector?.uid;
        }
    });
}

/** https://wagmi.sh/core/api/actions/watchConnectors */ function $22388fdb59095ab9$export$9c8eec0a0da048a0(config, parameters) {
    const { onChange: onChange } = parameters;
    return config._internal.connectors.subscribe((connectors, prevConnectors)=>{
        onChange(Object.values(connectors), prevConnectors);
    });
}


function $b32ab6fe95d80134$export$b6380ff64616a4fb(chain) {
    return {
        formatters: undefined,
        fees: undefined,
        serializers: undefined,
        ...chain
    };
}


const $6b15c8827610446e$export$536d3e0d2c7baf54 = /*#__PURE__*/ (0, $b32ab6fe95d80134$export$b6380ff64616a4fb)({
    id: 1,
    name: "Ethereum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://eth.merkle.io"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Etherscan",
            url: "https://etherscan.io",
            apiUrl: "https://api.etherscan.io/api"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
            blockCreated: 19258213
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14353601
        }
    }
});


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $3jnn6 = parcelRequire("3jnn6");
var $23VhR = parcelRequire("23VhR");
var $nBm8O = parcelRequire("nBm8O");
var $8A6Jz = parcelRequire("8A6Jz");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $hdnNF = parcelRequire("hdnNF");

var $gDLfI = parcelRequire("gDLfI");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $dc204ff36aaf54c6$export$f68dd208b5df064d = (t)=>t ?? (0, $gDLfI.nothing);




var $03420f5d8a76c734$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $03420f5d8a76c734$export$f039a2838669d98e = class W3mAccountButton extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.balance = "show";
        this.charsStart = 4;
        this.charsEnd = 6;
        this.address = (0, $7mucr.AccountController).state.address;
        this.balanceVal = (0, $7mucr.AccountController).state.balance;
        this.balanceSymbol = (0, $7mucr.AccountController).state.balanceSymbol;
        this.profileName = (0, $7mucr.AccountController).state.profileName;
        this.profileImage = (0, $7mucr.AccountController).state.profileImage;
        this.network = (0, $8A6Jz.NetworkController).state.caipNetwork;
        this.isUnsupportedChain = (0, $8A6Jz.NetworkController).state.isUnsupportedChain;
        this.unsubscribe.push(...[
            (0, $7mucr.AccountController).subscribe((val)=>{
                if (val.isConnected) {
                    this.address = val.address;
                    this.balanceVal = val.balance;
                    this.profileName = val.profileName;
                    this.profileImage = val.profileImage;
                    this.balanceSymbol = val.balanceSymbol;
                } else {
                    this.address = "";
                    this.balanceVal = "";
                    this.profileName = "";
                    this.profileImage = "";
                    this.balanceSymbol = "";
                }
            }),
            (0, $8A6Jz.NetworkController).subscribeKey("caipNetwork", (val)=>this.network = val),
            (0, $8A6Jz.NetworkController).subscribeKey("isUnsupportedChain", (val)=>this.isUnsupportedChain = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const networkImage = (0, $3jnn6.AssetUtil).getNetworkImage(this.network);
        const showBalance = this.balance === "show";
        return (0, $gDLfI.html)`
      <wui-account-button
        .disabled=${Boolean(this.disabled)}
        .isUnsupportedChain=${this.isUnsupportedChain}
        address=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.profileName ?? this.address)}
        ?isProfileName=${Boolean(this.profileName)}
        networkSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(networkImage)}
        avatarSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.profileImage)}
        balance=${showBalance ? (0, $23VhR.CoreHelperUtil).formatBalance(this.balanceVal, this.balanceSymbol) : ""}
        @click=${this.onClick.bind(this)}
        data-testid="account-button"
        .charsStart=${this.charsStart}
        .charsEnd=${this.charsEnd}
      >
      </wui-account-button>
    `;
    }
    onClick() {
        if (this.isUnsupportedChain) (0, $nBm8O.ModalController).open({
            view: "UnsupportedChain"
        });
        else (0, $nBm8O.ModalController).open();
    }
};
$03420f5d8a76c734$var$__decorate([
    (0, $8c6bF.property)({
        type: Boolean
    })
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "disabled", void 0);
$03420f5d8a76c734$var$__decorate([
    (0, $8c6bF.property)()
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "balance", void 0);
$03420f5d8a76c734$var$__decorate([
    (0, $8c6bF.property)()
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "charsStart", void 0);
$03420f5d8a76c734$var$__decorate([
    (0, $8c6bF.property)()
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "charsEnd", void 0);
$03420f5d8a76c734$var$__decorate([
    (0, $hdnNF.state)()
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "address", void 0);
$03420f5d8a76c734$var$__decorate([
    (0, $hdnNF.state)()
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "balanceVal", void 0);
$03420f5d8a76c734$var$__decorate([
    (0, $hdnNF.state)()
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "balanceSymbol", void 0);
$03420f5d8a76c734$var$__decorate([
    (0, $hdnNF.state)()
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "profileName", void 0);
$03420f5d8a76c734$var$__decorate([
    (0, $hdnNF.state)()
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "profileImage", void 0);
$03420f5d8a76c734$var$__decorate([
    (0, $hdnNF.state)()
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "network", void 0);
$03420f5d8a76c734$var$__decorate([
    (0, $hdnNF.state)()
], $03420f5d8a76c734$export$f039a2838669d98e.prototype, "isUnsupportedChain", void 0);
$03420f5d8a76c734$export$f039a2838669d98e = $03420f5d8a76c734$var$__decorate([
    (0, $3SCaV.customElement)("w3m-account-button")
], $03420f5d8a76c734$export$f039a2838669d98e);


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $720064e2bfc62a2b$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host {
    display: block;
    width: max-content;
  }
`;


var $6613d67c632522f7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $6613d67c632522f7$export$857f19a8cabe3497 = class W3mButton extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.balance = undefined;
        this.size = undefined;
        this.label = undefined;
        this.loadingLabel = undefined;
        this.charsStart = 4;
        this.charsEnd = 6;
        this.isAccount = (0, $7mucr.AccountController).state.isConnected;
        this.unsubscribe.push((0, $7mucr.AccountController).subscribeKey("isConnected", (val)=>{
            this.isAccount = val;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return this.isAccount ? (0, $gDLfI.html)`
          <w3m-account-button
            .disabled=${Boolean(this.disabled)}
            balance=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.balance)}
            .charsStart=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.charsStart)}
            .charsEnd=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.charsEnd)}
          >
          </w3m-account-button>
        ` : (0, $gDLfI.html)`
          <w3m-connect-button
            size=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.size)}
            label=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.label)}
            loadingLabel=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.loadingLabel)}
          ></w3m-connect-button>
        `;
    }
};
$6613d67c632522f7$export$857f19a8cabe3497.styles = (0, $720064e2bfc62a2b$export$2e2bcd8739ae039);
$6613d67c632522f7$var$__decorate([
    (0, $8c6bF.property)({
        type: Boolean
    })
], $6613d67c632522f7$export$857f19a8cabe3497.prototype, "disabled", void 0);
$6613d67c632522f7$var$__decorate([
    (0, $8c6bF.property)()
], $6613d67c632522f7$export$857f19a8cabe3497.prototype, "balance", void 0);
$6613d67c632522f7$var$__decorate([
    (0, $8c6bF.property)()
], $6613d67c632522f7$export$857f19a8cabe3497.prototype, "size", void 0);
$6613d67c632522f7$var$__decorate([
    (0, $8c6bF.property)()
], $6613d67c632522f7$export$857f19a8cabe3497.prototype, "label", void 0);
$6613d67c632522f7$var$__decorate([
    (0, $8c6bF.property)()
], $6613d67c632522f7$export$857f19a8cabe3497.prototype, "loadingLabel", void 0);
$6613d67c632522f7$var$__decorate([
    (0, $8c6bF.property)()
], $6613d67c632522f7$export$857f19a8cabe3497.prototype, "charsStart", void 0);
$6613d67c632522f7$var$__decorate([
    (0, $8c6bF.property)()
], $6613d67c632522f7$export$857f19a8cabe3497.prototype, "charsEnd", void 0);
$6613d67c632522f7$var$__decorate([
    (0, $hdnNF.state)()
], $6613d67c632522f7$export$857f19a8cabe3497.prototype, "isAccount", void 0);
$6613d67c632522f7$export$857f19a8cabe3497 = $6613d67c632522f7$var$__decorate([
    (0, $3SCaV.customElement)("w3m-button")
], $6613d67c632522f7$export$857f19a8cabe3497);


parcelRequire("3aODI");
var $nBm8O = parcelRequire("nBm8O");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $hdnNF = parcelRequire("hdnNF");

var $2bcac3e94a07a4ff$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2bcac3e94a07a4ff$export$277240c185e0322e = class W3mConnectButton extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.size = "md";
        this.label = "Connect Wallet";
        this.loadingLabel = "Connecting...";
        this.open = (0, $nBm8O.ModalController).state.open;
        this.loading = (0, $nBm8O.ModalController).state.loading;
        this.unsubscribe.push((0, $nBm8O.ModalController).subscribe((val)=>{
            this.open = val.open;
            this.loading = val.loading;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const isLoading = this.loading || this.open;
        return (0, $gDLfI.html)`
      <wui-connect-button
        size=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.size)}
        .loading=${isLoading}
        @click=${this.onClick.bind(this)}
        data-testid="connect-button"
      >
        ${isLoading ? this.loadingLabel : this.label}
      </wui-connect-button>
    `;
    }
    onClick() {
        if (this.open) (0, $nBm8O.ModalController).close();
        else if (!this.loading) (0, $nBm8O.ModalController).open();
    }
};
$2bcac3e94a07a4ff$var$__decorate([
    (0, $8c6bF.property)()
], $2bcac3e94a07a4ff$export$277240c185e0322e.prototype, "size", void 0);
$2bcac3e94a07a4ff$var$__decorate([
    (0, $8c6bF.property)()
], $2bcac3e94a07a4ff$export$277240c185e0322e.prototype, "label", void 0);
$2bcac3e94a07a4ff$var$__decorate([
    (0, $8c6bF.property)()
], $2bcac3e94a07a4ff$export$277240c185e0322e.prototype, "loadingLabel", void 0);
$2bcac3e94a07a4ff$var$__decorate([
    (0, $hdnNF.state)()
], $2bcac3e94a07a4ff$export$277240c185e0322e.prototype, "open", void 0);
$2bcac3e94a07a4ff$var$__decorate([
    (0, $hdnNF.state)()
], $2bcac3e94a07a4ff$export$277240c185e0322e.prototype, "loading", void 0);
$2bcac3e94a07a4ff$export$277240c185e0322e = $2bcac3e94a07a4ff$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connect-button")
], $2bcac3e94a07a4ff$export$277240c185e0322e);


parcelRequire("8llE9");
parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $3jnn6 = parcelRequire("3jnn6");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $8A6Jz = parcelRequire("8A6Jz");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $8dbd9a9b32e0f8ca$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host {
    display: block;
    width: max-content;
  }
`;


var $19502f36dccaffa6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $19502f36dccaffa6$export$28375bf34267491c = class W3mNetworkButton extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.network = (0, $8A6Jz.NetworkController).state.caipNetwork;
        this.connected = (0, $7mucr.AccountController).state.isConnected;
        this.loading = (0, $nBm8O.ModalController).state.loading;
        this.isUnsupportedChain = (0, $8A6Jz.NetworkController).state.isUnsupportedChain;
        this.unsubscribe.push(...[
            (0, $8A6Jz.NetworkController).subscribeKey("caipNetwork", (val)=>this.network = val),
            (0, $7mucr.AccountController).subscribeKey("isConnected", (val)=>this.connected = val),
            (0, $nBm8O.ModalController).subscribeKey("loading", (val)=>this.loading = val),
            (0, $8A6Jz.NetworkController).subscribeKey("isUnsupportedChain", (val)=>this.isUnsupportedChain = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-network-button
        .disabled=${Boolean(this.disabled || this.loading)}
        .isUnsupportedChain=${this.isUnsupportedChain}
        imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getNetworkImage(this.network))}
        @click=${this.onClick.bind(this)}
      >
        ${this.isUnsupportedChain ? "Switch Network" : this.network?.name ?? (this.connected ? "Unknown Network" : "Select Network")}
      </wui-network-button>
    `;
    }
    onClick() {
        if (!this.loading) {
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "CLICK_NETWORKS"
            });
            (0, $nBm8O.ModalController).open({
                view: "Networks"
            });
        }
    }
};
$19502f36dccaffa6$export$28375bf34267491c.styles = (0, $8dbd9a9b32e0f8ca$export$2e2bcd8739ae039);
$19502f36dccaffa6$var$__decorate([
    (0, $8c6bF.property)({
        type: Boolean
    })
], $19502f36dccaffa6$export$28375bf34267491c.prototype, "disabled", void 0);
$19502f36dccaffa6$var$__decorate([
    (0, $hdnNF.state)()
], $19502f36dccaffa6$export$28375bf34267491c.prototype, "network", void 0);
$19502f36dccaffa6$var$__decorate([
    (0, $hdnNF.state)()
], $19502f36dccaffa6$export$28375bf34267491c.prototype, "connected", void 0);
$19502f36dccaffa6$var$__decorate([
    (0, $hdnNF.state)()
], $19502f36dccaffa6$export$28375bf34267491c.prototype, "loading", void 0);
$19502f36dccaffa6$var$__decorate([
    (0, $hdnNF.state)()
], $19502f36dccaffa6$export$28375bf34267491c.prototype, "isUnsupportedChain", void 0);
$19502f36dccaffa6$export$28375bf34267491c = $19502f36dccaffa6$var$__decorate([
    (0, $3SCaV.customElement)("w3m-network-button")
], $19502f36dccaffa6$export$28375bf34267491c);


parcelRequire("3aODI");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $80d9e6591d6a428a$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host {
    display: block;
    will-change: transform, opacity;
  }
`;


var $20ec4d2c7e091e65$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $20ec4d2c7e091e65$export$ccc15c9e32141a55 = class W3mRouter extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.resizeObserver = undefined;
        this.prevHeight = "0px";
        this.prevHistoryLength = 1;
        this.unsubscribe = [];
        this.view = (0, $3OaCj.RouterController).state.view;
        this.unsubscribe.push((0, $3OaCj.RouterController).subscribeKey("view", (val)=>this.onViewChange(val)));
    }
    firstUpdated() {
        this.resizeObserver = new ResizeObserver(async ([content])=>{
            const height = `${content?.contentRect.height}px`;
            if (this.prevHeight !== "0px") {
                await this.animate([
                    {
                        height: this.prevHeight
                    },
                    {
                        height: height
                    }
                ], {
                    duration: 150,
                    easing: "ease",
                    fill: "forwards"
                }).finished;
                this.style.height = "auto";
            }
            this.prevHeight = height;
        });
        this.resizeObserver.observe(this.getWrapper());
    }
    disconnectedCallback() {
        this.resizeObserver?.unobserve(this.getWrapper());
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $gDLfI.html)`<div>${this.viewTemplate()}</div>`;
    }
    viewTemplate() {
        switch(this.view){
            case "Connect":
                return (0, $gDLfI.html)`<w3m-connect-view></w3m-connect-view>`;
            case "ConnectingWalletConnect":
                return (0, $gDLfI.html)`<w3m-connecting-wc-view></w3m-connecting-wc-view>`;
            case "ConnectingExternal":
                return (0, $gDLfI.html)`<w3m-connecting-external-view></w3m-connecting-external-view>`;
            case "ConnectingSiwe":
                return (0, $gDLfI.html)`<w3m-connecting-siwe-view></w3m-connecting-siwe-view>`;
            case "AllWallets":
                return (0, $gDLfI.html)`<w3m-all-wallets-view></w3m-all-wallets-view>`;
            case "Networks":
                return (0, $gDLfI.html)`<w3m-networks-view></w3m-networks-view>`;
            case "SwitchNetwork":
                return (0, $gDLfI.html)`<w3m-network-switch-view></w3m-network-switch-view>`;
            case "Account":
                return (0, $gDLfI.html)`<w3m-account-view></w3m-account-view>`;
            case "AccountSettings":
                return (0, $gDLfI.html)`<w3m-account-settings-view></w3m-account-settings-view>`;
            case "WhatIsAWallet":
                return (0, $gDLfI.html)`<w3m-what-is-a-wallet-view></w3m-what-is-a-wallet-view>`;
            case "WhatIsANetwork":
                return (0, $gDLfI.html)`<w3m-what-is-a-network-view></w3m-what-is-a-network-view>`;
            case "GetWallet":
                return (0, $gDLfI.html)`<w3m-get-wallet-view></w3m-get-wallet-view>`;
            case "Downloads":
                return (0, $gDLfI.html)`<w3m-downloads-view></w3m-downloads-view>`;
            case "EmailVerifyOtp":
                return (0, $gDLfI.html)`<w3m-email-verify-otp-view></w3m-email-verify-otp-view>`;
            case "EmailVerifyDevice":
                return (0, $gDLfI.html)`<w3m-email-verify-device-view></w3m-email-verify-device-view>`;
            case "ApproveTransaction":
                return (0, $gDLfI.html)`<w3m-approve-transaction-view></w3m-approve-transaction-view>`;
            case "Transactions":
                return (0, $gDLfI.html)`<w3m-transactions-view></w3m-transactions-view>`;
            case "UpgradeEmailWallet":
                return (0, $gDLfI.html)`<w3m-upgrade-wallet-view></w3m-upgrade-wallet-view>`;
            case "UpdateEmailWallet":
                return (0, $gDLfI.html)`<w3m-update-email-wallet-view></w3m-update-email-wallet-view>`;
            case "UpdateEmailPrimaryOtp":
                return (0, $gDLfI.html)`<w3m-update-email-primary-otp-view></w3m-update-email-primary-otp-view>`;
            case "UpdateEmailSecondaryOtp":
                return (0, $gDLfI.html)`<w3m-update-email-secondary-otp-view></w3m-update-email-secondary-otp-view>`;
            case "UnsupportedChain":
                return (0, $gDLfI.html)`<w3m-unsupported-chain-view></w3m-unsupported-chain-view>`;
            case "OnRampProviders":
                return (0, $gDLfI.html)`<w3m-onramp-providers-view></w3m-onramp-providers-view>`;
            case "OnRampActivity":
                return (0, $gDLfI.html)`<w3m-onramp-activity-view></w3m-onramp-activity-view>`;
            case "OnRampTokenSelect":
                return (0, $gDLfI.html)`<w3m-onramp-token-select-view></w3m-onramp-token-select-view>`;
            case "OnRampFiatSelect":
                return (0, $gDLfI.html)`<w3m-onramp-fiat-select-view></w3m-onramp-fiat-select-view>`;
            case "WhatIsABuy":
                return (0, $gDLfI.html)`<w3m-what-is-a-buy-view></w3m-what-is-a-buy-view>`;
            case "BuyInProgress":
                return (0, $gDLfI.html)`<w3m-buy-in-progress-view></w3m-buy-in-progress-view>`;
            default:
                return (0, $gDLfI.html)`<w3m-connect-view></w3m-connect-view>`;
        }
    }
    async onViewChange(newView) {
        const { history: history } = (0, $3OaCj.RouterController).state;
        let xOut = -10;
        let xIn = 10;
        if (history.length < this.prevHistoryLength) {
            xOut = 10;
            xIn = -10;
        }
        this.prevHistoryLength = history.length;
        await this.animate([
            {
                opacity: 1,
                transform: "translateX(0px)"
            },
            {
                opacity: 0,
                transform: `translateX(${xOut}px)`
            }
        ], {
            duration: 150,
            easing: "ease",
            fill: "forwards"
        }).finished;
        this.view = newView;
        await this.animate([
            {
                opacity: 0,
                transform: `translateX(${xIn}px)`
            },
            {
                opacity: 1,
                transform: "translateX(0px)"
            }
        ], {
            duration: 150,
            easing: "ease",
            fill: "forwards",
            delay: 50
        }).finished;
    }
    getWrapper() {
        return this.shadowRoot?.querySelector("div");
    }
};
$20ec4d2c7e091e65$export$ccc15c9e32141a55.styles = (0, $80d9e6591d6a428a$export$2e2bcd8739ae039);
$20ec4d2c7e091e65$var$__decorate([
    (0, $hdnNF.state)()
], $20ec4d2c7e091e65$export$ccc15c9e32141a55.prototype, "view", void 0);
$20ec4d2c7e091e65$export$ccc15c9e32141a55 = $20ec4d2c7e091e65$var$__decorate([
    (0, $3SCaV.customElement)("w3m-router")
], $20ec4d2c7e091e65$export$ccc15c9e32141a55);


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $nBm8O = parcelRequire("nBm8O");
var $79hu3 = parcelRequire("79hu3");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $hdnNF = parcelRequire("hdnNF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $b7bbe179cde6a5c5$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host > wui-flex {
    width: 100%;
    max-width: 360px;
  }

  :host > wui-flex > wui-flex {
    border-radius: var(--wui-border-radius-l);
    width: 100%;
  }

  .amounts-container {
    width: 100%;
  }
`;


var $569ce8a5a1674a7c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $569ce8a5a1674a7c$var$PAYMENT_CURRENCY_SYMBOLS = {
    USD: "$",
    EUR: "\u20AC",
    GBP: "\xa3"
};
const $569ce8a5a1674a7c$var$BUY_PRESET_AMOUNTS = [
    100,
    250,
    500,
    1000
];
let $569ce8a5a1674a7c$export$33bc4f3e369ccb5f = class W3mOnrampWidget extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.connected = (0, $7mucr.AccountController).state.isConnected;
        this.loading = (0, $nBm8O.ModalController).state.loading;
        this.paymentCurrency = (0, $79hu3.OnRampController).state.paymentCurrency;
        this.paymentAmount = (0, $79hu3.OnRampController).state.paymentAmount;
        this.purchaseAmount = (0, $79hu3.OnRampController).state.purchaseAmount;
        this.quoteLoading = (0, $79hu3.OnRampController).state.quotesLoading;
        this.unsubscribe.push(...[
            (0, $7mucr.AccountController).subscribeKey("isConnected", (val)=>{
                this.connected = val;
            }),
            (0, $nBm8O.ModalController).subscribeKey("loading", (val)=>{
                this.loading = val;
            }),
            (0, $79hu3.OnRampController).subscribe((val)=>{
                this.paymentCurrency = val.paymentCurrency;
                this.paymentAmount = val.paymentAmount;
                this.purchaseAmount = val.purchaseAmount;
                this.quoteLoading = val.quotesLoading;
            })
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" justifyContent="center" alignItems="center">
        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <w3m-swap-input
            type="Fiat"
            @inputChange=${this.onPaymentAmountChange.bind(this)}
            .value=${this.paymentAmount || 0}
          ></w3m-swap-input>
          <w3m-swap-input
            type="Token"
            .value=${this.purchaseAmount || 0}
            .loading=${this.quoteLoading}
          ></w3m-swap-input>
          <wui-flex justifyContent="space-evenly" class="amounts-container" gap="xs">
            ${$569ce8a5a1674a7c$var$BUY_PRESET_AMOUNTS.map((amount)=>(0, $gDLfI.html)`<wui-button
                  variant=${this.paymentAmount === amount ? "accentBg" : "shade"}
                  size="xs"
                  textVariant="paragraph-600"
                  fullWidth
                  @click=${()=>this.selectPresetAmount(amount)}
                  >${`${$569ce8a5a1674a7c$var$PAYMENT_CURRENCY_SYMBOLS[this.paymentCurrency?.id || "USD"]} ${amount}`}</wui-button
                >`)}
          </wui-flex>
          ${this.templateButton()}
        </wui-flex>
      </wui-flex>
    `;
    }
    templateButton() {
        return this.connected ? (0, $gDLfI.html)`<wui-button
          @click=${this.getQuotes.bind(this)}
          variant="fill"
          fullWidth
          size="lg"
          borderRadius="xs"
        >
          Get quotes
        </wui-button>` : (0, $gDLfI.html)`<wui-button
          @click=${this.openModal.bind(this)}
          variant="accentBg"
          fullWidth
          size="lg"
          borderRadius="xs"
        >
          Connect wallet
        </wui-button>`;
    }
    getQuotes() {
        if (!this.loading) (0, $nBm8O.ModalController).open({
            view: "OnRampProviders"
        });
    }
    openModal() {
        (0, $nBm8O.ModalController).open({
            view: "Connect"
        });
    }
    async onPaymentAmountChange(event) {
        (0, $79hu3.OnRampController).setPaymentAmount(Number(event.detail));
        await (0, $79hu3.OnRampController).getQuote();
    }
    async selectPresetAmount(amount) {
        (0, $79hu3.OnRampController).setPaymentAmount(amount);
        await (0, $79hu3.OnRampController).getQuote();
    }
};
$569ce8a5a1674a7c$export$33bc4f3e369ccb5f.styles = (0, $b7bbe179cde6a5c5$export$2e2bcd8739ae039);
$569ce8a5a1674a7c$var$__decorate([
    (0, $8c6bF.property)({
        type: Boolean
    })
], $569ce8a5a1674a7c$export$33bc4f3e369ccb5f.prototype, "disabled", void 0);
$569ce8a5a1674a7c$var$__decorate([
    (0, $hdnNF.state)()
], $569ce8a5a1674a7c$export$33bc4f3e369ccb5f.prototype, "connected", void 0);
$569ce8a5a1674a7c$var$__decorate([
    (0, $hdnNF.state)()
], $569ce8a5a1674a7c$export$33bc4f3e369ccb5f.prototype, "loading", void 0);
$569ce8a5a1674a7c$var$__decorate([
    (0, $hdnNF.state)()
], $569ce8a5a1674a7c$export$33bc4f3e369ccb5f.prototype, "paymentCurrency", void 0);
$569ce8a5a1674a7c$var$__decorate([
    (0, $hdnNF.state)()
], $569ce8a5a1674a7c$export$33bc4f3e369ccb5f.prototype, "paymentAmount", void 0);
$569ce8a5a1674a7c$var$__decorate([
    (0, $hdnNF.state)()
], $569ce8a5a1674a7c$export$33bc4f3e369ccb5f.prototype, "purchaseAmount", void 0);
$569ce8a5a1674a7c$var$__decorate([
    (0, $hdnNF.state)()
], $569ce8a5a1674a7c$export$33bc4f3e369ccb5f.prototype, "quoteLoading", void 0);
$569ce8a5a1674a7c$export$33bc4f3e369ccb5f = $569ce8a5a1674a7c$var$__decorate([
    (0, $3SCaV.customElement)("w3m-onramp-widget")
], $569ce8a5a1674a7c$export$33bc4f3e369ccb5f);


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $b2pRm = parcelRequire("b2pRm");
var $5n5Ql = parcelRequire("5n5Ql");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $8A6Jz = parcelRequire("8A6Jz");
var $3OaCj = parcelRequire("3OaCj");
var $dXr1O = parcelRequire("dXr1O");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
var $fRkfl = parcelRequire("fRkfl");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $95930324176f1b2d$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-flex {
    width: 100%;
  }

  wui-icon-link {
    margin-right: calc(var(--wui-icon-box-size-md) * -1);
  }

  .account-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .account-links wui-flex {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    background: red;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding: 10px;
    flex: 1 0 0;

    border-radius: var(--XS, 16px);
    border: 1px solid var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    background: var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    transition: background 0.2s linear;
  }

  .account-links wui-flex:hover {
    background: var(--dark-accent-glass-015, rgba(71, 161, 255, 0.15));
  }

  .account-links wui-flex wui-icon {
    width: var(--S, 20px);
    height: var(--S, 20px);
  }

  .account-links wui-flex wui-icon svg path {
    stroke: #47a1ff;
  }
`;


var $21dbc360cdb93292$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $21dbc360cdb93292$export$b2168ecfa4cbc2f8 = class W3mAccountSettingsView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.usubscribe = [];
        this.networkImages = (0, $b2pRm.AssetController).state.networkImages;
        this.address = (0, $7mucr.AccountController).state.address;
        this.profileImage = (0, $7mucr.AccountController).state.profileImage;
        this.profileName = (0, $7mucr.AccountController).state.profileName;
        this.balance = (0, $7mucr.AccountController).state.balance;
        this.balanceSymbol = (0, $7mucr.AccountController).state.balanceSymbol;
        this.network = (0, $8A6Jz.NetworkController).state.caipNetwork;
        this.disconnecting = false;
        this.usubscribe.push(...[
            (0, $7mucr.AccountController).subscribe((val)=>{
                if (val.address) {
                    this.address = val.address;
                    this.profileImage = val.profileImage;
                    this.profileName = val.profileName;
                    this.balance = val.balance;
                    this.balanceSymbol = val.balanceSymbol;
                } else (0, $nBm8O.ModalController).close();
            })
        ], (0, $8A6Jz.NetworkController).subscribeKey("caipNetwork", (val)=>{
            if (val?.id) this.network = val;
        }));
    }
    disconnectedCallback() {
        this.usubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.address) throw new Error("w3m-account-settings-view: No account provided");
        const networkImage = this.networkImages[this.network?.imageId ?? ""];
        return (0, $gDLfI.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "0",
            "xl",
            "m",
            "xl"
        ]}
        alignItems="center"
        gap="l"
      >
        <wui-avatar
          alt=${this.address}
          address=${this.address}
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.profileImage)}
        ></wui-avatar>
        <wui-flex flexDirection="column" alignItems="center">
          <wui-flex gap="3xs" alignItems="center" justifyContent="center">
            <wui-text variant="large-600" color="fg-100">
              ${this.profileName ? (0, $fRkfl.UiHelperUtil).getTruncateString({
            string: this.profileName,
            charsStart: 20,
            charsEnd: 0,
            truncate: "end"
        }) : (0, $fRkfl.UiHelperUtil).getTruncateString({
            string: this.address,
            charsStart: 4,
            charsEnd: 6,
            truncate: "middle"
        })}
            </wui-text>
            <wui-icon-link
              size="md"
              icon="copy"
              iconColor="fg-200"
              @click=${this.onCopyAddress}
            ></wui-icon-link>
          </wui-flex>
          <wui-flex gap="s" flexDirection="column" alignItems="center">
            <wui-text variant="paragraph-500" color="fg-200">
              ${(0, $23VhR.CoreHelperUtil).formatBalance(this.balance, this.balanceSymbol)}
            </wui-text>
            ${this.explorerBtnTemplate()}
          </wui-flex>
        </wui-flex>
      </wui-flex>

      <wui-flex flexDirection="column" gap="m">
        <wui-flex flexDirection="column" gap="xs" .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]}>
          <wui-list-item
            .variant=${networkImage ? "image" : "icon"}
            iconVariant="overlay"
            icon="networkPlaceholder"
            imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(networkImage)}
            ?chevron=${this.isAllowedNetworkSwitch()}
            @click=${this.onNetworks.bind(this)}
          >
            <wui-text variant="paragraph-500" color="fg-100">
              ${this.network?.name ?? "Unknown"}
            </wui-text>
          </wui-list-item>

          <wui-list-item
            iconVariant="blue"
            icon="swapHorizontalBold"
            iconSize="sm"
            ?chevron=${true}
            @click=${this.onTransactions.bind(this)}
          >
            <wui-text variant="paragraph-500" color="fg-100">Activity</wui-text>
          </wui-list-item>
          <wui-list-item
            variant="icon"
            iconVariant="overlay"
            icon="disconnect"
            ?chevron=${false}
            .loading=${this.disconnecting}
            @click=${this.onDisconnect.bind(this)}
            data-testid="disconnect-button"
          >
            <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
          </wui-list-item>
        </wui-flex>
      </wui-flex>
    `;
    }
    onTransactions() {
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "CLICK_TRANSACTIONS"
        });
        (0, $3OaCj.RouterController).push("Transactions");
    }
    explorerBtnTemplate() {
        const { addressExplorerUrl: addressExplorerUrl } = (0, $7mucr.AccountController).state;
        if (!addressExplorerUrl) return null;
        return (0, $gDLfI.html)`
      <wui-button size="sm" variant="shade" @click=${this.onExplorer.bind(this)}>
        <wui-icon size="sm" color="inherit" slot="iconLeft" name="compass"></wui-icon>
        Block Explorer
        <wui-icon size="sm" color="inherit" slot="iconRight" name="externalLink"></wui-icon>
      </wui-button>
    `;
    }
    isAllowedNetworkSwitch() {
        const { requestedCaipNetworks: requestedCaipNetworks } = (0, $8A6Jz.NetworkController).state;
        const isMultiNetwork = requestedCaipNetworks ? requestedCaipNetworks.length > 1 : false;
        const isValidNetwork = requestedCaipNetworks?.find(({ id: id })=>id === this.network?.id);
        return isMultiNetwork || !isValidNetwork;
    }
    onCopyAddress() {
        try {
            if (this.address) {
                (0, $23VhR.CoreHelperUtil).copyToClopboard(this.address);
                (0, $dXr1O.SnackController).showSuccess("Address copied");
            }
        } catch  {
            (0, $dXr1O.SnackController).showError("Failed to copy");
        }
    }
    onNetworks() {
        if (this.isAllowedNetworkSwitch()) (0, $3OaCj.RouterController).push("Networks");
    }
    async onDisconnect() {
        try {
            this.disconnecting = true;
            await (0, $5n5Ql.ConnectionController).disconnect();
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS"
            });
            (0, $nBm8O.ModalController).close();
        } catch  {
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR"
            });
            (0, $dXr1O.SnackController).showError("Failed to disconnect");
        } finally{
            this.disconnecting = false;
        }
    }
    onExplorer() {
        const { addressExplorerUrl: addressExplorerUrl } = (0, $7mucr.AccountController).state;
        if (addressExplorerUrl) (0, $23VhR.CoreHelperUtil).openHref(addressExplorerUrl, "_blank");
    }
};
$21dbc360cdb93292$export$b2168ecfa4cbc2f8.styles = (0, $95930324176f1b2d$export$2e2bcd8739ae039);
$21dbc360cdb93292$var$__decorate([
    (0, $hdnNF.state)()
], $21dbc360cdb93292$export$b2168ecfa4cbc2f8.prototype, "address", void 0);
$21dbc360cdb93292$var$__decorate([
    (0, $hdnNF.state)()
], $21dbc360cdb93292$export$b2168ecfa4cbc2f8.prototype, "profileImage", void 0);
$21dbc360cdb93292$var$__decorate([
    (0, $hdnNF.state)()
], $21dbc360cdb93292$export$b2168ecfa4cbc2f8.prototype, "profileName", void 0);
$21dbc360cdb93292$var$__decorate([
    (0, $hdnNF.state)()
], $21dbc360cdb93292$export$b2168ecfa4cbc2f8.prototype, "balance", void 0);
$21dbc360cdb93292$var$__decorate([
    (0, $hdnNF.state)()
], $21dbc360cdb93292$export$b2168ecfa4cbc2f8.prototype, "balanceSymbol", void 0);
$21dbc360cdb93292$var$__decorate([
    (0, $hdnNF.state)()
], $21dbc360cdb93292$export$b2168ecfa4cbc2f8.prototype, "network", void 0);
$21dbc360cdb93292$var$__decorate([
    (0, $hdnNF.state)()
], $21dbc360cdb93292$export$b2168ecfa4cbc2f8.prototype, "disconnecting", void 0);
$21dbc360cdb93292$export$b2168ecfa4cbc2f8 = $21dbc360cdb93292$var$__decorate([
    (0, $3SCaV.customElement)("w3m-account-settings-view")
], $21dbc360cdb93292$export$b2168ecfa4cbc2f8);


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $3jnn6 = parcelRequire("3jnn6");
var $5n5Ql = parcelRequire("5n5Ql");
var $01g6R = parcelRequire("01g6R");
var $QVM5q = parcelRequire("QVM5q");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $8A6Jz = parcelRequire("8A6Jz");
var $cPOJT = parcelRequire("cPOJT");
var $3OaCj = parcelRequire("3OaCj");
var $dXr1O = parcelRequire("dXr1O");
var $6sZsT = parcelRequire("6sZsT");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
var $fRkfl = parcelRequire("fRkfl");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $64e8d97a51822d40$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-flex {
    width: 100%;
  }

  :host > wui-flex:first-child {
    transform: translateY(calc(var(--wui-spacing-xxs) * -1));
  }

  wui-icon-link {
    margin-right: calc(var(--wui-icon-box-size-md) * -1);
  }

  wui-notice-card {
    margin-bottom: var(--wui-spacing-3xs);
  }

  w3m-transactions-view {
    max-height: 200px;
  }

  .tab-content-container {
    height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }

  .account-button {
    width: auto;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--wui-spacing-s);
    height: 48px;
    padding: var(--wui-spacing-xs);
    padding-right: var(--wui-spacing-s);
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-002);
    background-color: var(--wui-gray-glass-002);
    border-radius: 24px;
    transaction: background-color 0.2s linear;
  }

  .account-button:hover {
    background-color: var(--wui-gray-glass-005);
  }

  .avatar-container {
    position: relative;
  }

  wui-avatar.avatar {
    width: 32px;
    height: 32px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  wui-avatar.network-avatar {
    width: 16px;
    height: 16px;
    position: absolute;
    left: 100%;
    top: 100%;
    transform: translate(-75%, -75%);
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  .account-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .account-links wui-flex {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    background: red;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding: 10px;
    flex: 1 0 0;

    border-radius: var(--XS, 16px);
    border: 1px solid var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    background: var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    transition: background 0.2s linear;
  }

  .account-links wui-flex:hover {
    background: var(--dark-accent-glass-015, rgba(71, 161, 255, 0.15));
  }

  .account-links wui-flex wui-icon {
    width: var(--S, 20px);
    height: var(--S, 20px);
  }

  .account-links wui-flex wui-icon svg path {
    stroke: #47a1ff;
  }
`;


var $0e0a193d00217d28$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0e0a193d00217d28$export$fb2cfdfbb483d2ac = class W3mAccountView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.address = (0, $7mucr.AccountController).state.address;
        this.profileImage = (0, $7mucr.AccountController).state.profileImage;
        this.profileName = (0, $7mucr.AccountController).state.profileName;
        this.network = (0, $8A6Jz.NetworkController).state.caipNetwork;
        this.disconnecting = false;
        this.balance = (0, $7mucr.AccountController).state.balance;
        this.balanceSymbol = (0, $7mucr.AccountController).state.balanceSymbol;
        this.unsubscribe.push(...[
            (0, $7mucr.AccountController).subscribe((val)=>{
                if (val.address) {
                    this.address = val.address;
                    this.profileImage = val.profileImage;
                    this.profileName = val.profileName;
                    this.balance = val.balance;
                    this.balanceSymbol = val.balanceSymbol;
                } else (0, $nBm8O.ModalController).close();
            })
        ], (0, $8A6Jz.NetworkController).subscribeKey("caipNetwork", (val)=>{
            if (val?.id) this.network = val;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.address) throw new Error("w3m-account-view: No account provided");
        const networkImage = (0, $3jnn6.AssetUtil).getNetworkImage(this.network);
        return (0, $gDLfI.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "0",
            "xl",
            "m",
            "xl"
        ]}
        alignItems="center"
        gap="l"
      >
        <wui-avatar
          alt=${this.address}
          address=${this.address}
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.profileImage === null ? undefined : this.profileImage)}
        ></wui-avatar>
        <wui-flex flexDirection="column" alignItems="center">
          <wui-flex gap="3xs" alignItems="center" justifyContent="center">
            <wui-text variant="medium-title-600" color="fg-100">
              ${this.profileName ? (0, $fRkfl.UiHelperUtil).getTruncateString({
            string: this.profileName,
            charsStart: 20,
            charsEnd: 0,
            truncate: "end"
        }) : (0, $fRkfl.UiHelperUtil).getTruncateString({
            string: this.address,
            charsStart: 4,
            charsEnd: 4,
            truncate: "middle"
        })}
            </wui-text>
            <wui-icon-link
              size="md"
              icon="copy"
              iconColor="fg-200"
              @click=${this.onCopyAddress}
            ></wui-icon-link>
          </wui-flex>
          <wui-text variant="paragraph-500" color="fg-200"
            >${(0, $23VhR.CoreHelperUtil).formatBalance(this.balance, this.balanceSymbol)}</wui-text
          >
        </wui-flex>
        ${this.explorerBtnTemplate()}
      </wui-flex>

      <wui-flex flexDirection="column" gap="xs" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}>
        ${this.emailCardTemplate()} ${this.emailBtnTemplate()}

        <wui-list-item
          .variant=${networkImage ? "image" : "icon"}
          iconVariant="overlay"
          icon="networkPlaceholder"
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(networkImage)}
          ?chevron=${this.isAllowedNetworkSwitch()}
          @click=${this.onNetworks.bind(this)}
          data-testid="w3m-account-select-network"
        >
          <wui-text variant="paragraph-500" color="fg-100">
            ${this.network?.name ?? "Unknown"}
          </wui-text>
        </wui-list-item>
        ${this.onrampTemplate()}
        <wui-list-item
          iconVariant="blue"
          icon="swapHorizontalMedium"
          iconSize="sm"
          ?chevron=${true}
          @click=${this.onTransactions.bind(this)}
        >
          <wui-text variant="paragraph-500" color="fg-100">Activity</wui-text>
        </wui-list-item>
        <wui-list-item
          variant="icon"
          iconVariant="overlay"
          icon="disconnect"
          ?chevron=${false}
          .loading=${this.disconnecting}
          @click=${this.onDisconnect.bind(this)}
          data-testid="disconnect-button"
        >
          <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
        </wui-list-item>
      </wui-flex>
    `;
    }
    onrampTemplate() {
        const { enableOnramp: enableOnramp } = (0, $cPOJT.OptionsController).state;
        if (!enableOnramp) return null;
        return (0, $gDLfI.html)`
      <wui-list-item
        iconVariant="blue"
        icon="card"
        ?chevron=${true}
        @click=${this.handleClickPay.bind(this)}
      >
        <wui-text variant="paragraph-500" color="fg-100">Buy crypto</wui-text>
      </wui-list-item>
    `;
    }
    emailCardTemplate() {
        const type = (0, $6sZsT.StorageUtil).getConnectedConnector();
        const emailConnector = (0, $01g6R.ConnectorController).getEmailConnector();
        const { origin: origin } = location;
        if (!emailConnector || type !== "EMAIL" || origin.includes((0, $QVM5q.ConstantsUtil).SECURE_SITE)) return null;
        return (0, $gDLfI.html)`
      <wui-notice-card
        @click=${this.onGoToUpgradeView.bind(this)}
        label="Upgrade your wallet"
        description="Transition to a self-custodial wallet"
        icon="wallet"
      ></wui-notice-card>
    `;
    }
    handleClickPay() {
        (0, $3OaCj.RouterController).push("OnRampProviders");
    }
    explorerBtnTemplate() {
        const { addressExplorerUrl: addressExplorerUrl } = (0, $7mucr.AccountController).state;
        if (!addressExplorerUrl) return null;
        return (0, $gDLfI.html)`
      <wui-button size="sm" variant="shade" @click=${this.onExplorer.bind(this)}>
        <wui-icon size="sm" color="inherit" slot="iconLeft" name="compass"></wui-icon>
        Block Explorer
        <wui-icon size="sm" color="inherit" slot="iconRight" name="externalLink"></wui-icon>
      </wui-button>
    `;
    }
    emailBtnTemplate() {
        const type = (0, $6sZsT.StorageUtil).getConnectedConnector();
        const emailConnector = (0, $01g6R.ConnectorController).getEmailConnector();
        if (!emailConnector || type !== "EMAIL") return null;
        const email = emailConnector.provider.getEmail() ?? "";
        return (0, $gDLfI.html)`
      <wui-list-item
        variant="icon"
        iconVariant="overlay"
        icon="mail"
        iconSize="sm"
        ?chevron=${true}
        @click=${()=>this.onGoToUpdateEmail(email)}
      >
        <wui-text variant="paragraph-500" color="fg-100">${email}</wui-text>
      </wui-list-item>
    `;
    }
    isAllowedNetworkSwitch() {
        const { requestedCaipNetworks: requestedCaipNetworks } = (0, $8A6Jz.NetworkController).state;
        const isMultiNetwork = requestedCaipNetworks ? requestedCaipNetworks.length > 1 : false;
        const isValidNetwork = requestedCaipNetworks?.find(({ id: id })=>id === this.network?.id);
        return isMultiNetwork || !isValidNetwork;
    }
    onCopyAddress() {
        try {
            if (this.address) {
                (0, $23VhR.CoreHelperUtil).copyToClopboard(this.address);
                (0, $dXr1O.SnackController).showSuccess("Address copied");
            }
        } catch  {
            (0, $dXr1O.SnackController).showError("Failed to copy");
        }
    }
    onNetworks() {
        if (this.isAllowedNetworkSwitch()) {
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "CLICK_NETWORKS"
            });
            (0, $3OaCj.RouterController).push("Networks");
        }
    }
    onTransactions() {
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "CLICK_TRANSACTIONS"
        });
        (0, $3OaCj.RouterController).push("Transactions");
    }
    async onDisconnect() {
        try {
            this.disconnecting = true;
            await (0, $5n5Ql.ConnectionController).disconnect();
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS"
            });
            (0, $nBm8O.ModalController).close();
        } catch  {
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR"
            });
            (0, $dXr1O.SnackController).showError("Failed to disconnect");
        } finally{
            this.disconnecting = false;
        }
    }
    onExplorer() {
        const { addressExplorerUrl: addressExplorerUrl } = (0, $7mucr.AccountController).state;
        if (addressExplorerUrl) (0, $23VhR.CoreHelperUtil).openHref(addressExplorerUrl, "_blank");
    }
    onGoToUpgradeView() {
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "EMAIL_UPGRADE_FROM_MODAL"
        });
        (0, $3OaCj.RouterController).push("UpgradeEmailWallet");
    }
    onGoToUpdateEmail(email) {
        (0, $3OaCj.RouterController).push("UpdateEmailWallet", {
            email: email
        });
    }
};
$0e0a193d00217d28$export$fb2cfdfbb483d2ac.styles = (0, $64e8d97a51822d40$export$2e2bcd8739ae039);
$0e0a193d00217d28$var$__decorate([
    (0, $hdnNF.state)()
], $0e0a193d00217d28$export$fb2cfdfbb483d2ac.prototype, "address", void 0);
$0e0a193d00217d28$var$__decorate([
    (0, $hdnNF.state)()
], $0e0a193d00217d28$export$fb2cfdfbb483d2ac.prototype, "profileImage", void 0);
$0e0a193d00217d28$var$__decorate([
    (0, $hdnNF.state)()
], $0e0a193d00217d28$export$fb2cfdfbb483d2ac.prototype, "profileName", void 0);
$0e0a193d00217d28$var$__decorate([
    (0, $hdnNF.state)()
], $0e0a193d00217d28$export$fb2cfdfbb483d2ac.prototype, "network", void 0);
$0e0a193d00217d28$var$__decorate([
    (0, $hdnNF.state)()
], $0e0a193d00217d28$export$fb2cfdfbb483d2ac.prototype, "disconnecting", void 0);
$0e0a193d00217d28$var$__decorate([
    (0, $hdnNF.state)()
], $0e0a193d00217d28$export$fb2cfdfbb483d2ac.prototype, "balance", void 0);
$0e0a193d00217d28$var$__decorate([
    (0, $hdnNF.state)()
], $0e0a193d00217d28$export$fb2cfdfbb483d2ac.prototype, "balanceSymbol", void 0);
$0e0a193d00217d28$export$fb2cfdfbb483d2ac = $0e0a193d00217d28$var$__decorate([
    (0, $3SCaV.customElement)("w3m-account-view")
], $0e0a193d00217d28$export$fb2cfdfbb483d2ac);


parcelRequire("3aODI");
var $23VhR = parcelRequire("23VhR");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
var $8a052ca51ae98b92$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8a052ca51ae98b92$export$88f35657f4e64778 = class W3mAllWalletsView extends (0, $dlgVE.LitElement) {
    constructor(){
        super(...arguments);
        this.search = "";
        this.onDebouncedSearch = (0, $23VhR.CoreHelperUtil).debounce((value)=>{
            this.search = value;
        });
    }
    render() {
        const isSearch = this.search.length >= 2;
        return (0, $gDLfI.html)`
      <wui-flex padding="s" gap="s">
        <wui-search-bar @inputChange=${this.onInputChange.bind(this)}></wui-search-bar>
        ${this.qrButtonTemplate()}
      </wui-flex>
      ${isSearch ? (0, $gDLfI.html)`<w3m-all-wallets-search query=${this.search}></w3m-all-wallets-search>` : (0, $gDLfI.html)`<w3m-all-wallets-list></w3m-all-wallets-list>`}
    `;
    }
    onInputChange(event) {
        this.onDebouncedSearch(event.detail);
    }
    qrButtonTemplate() {
        if ((0, $23VhR.CoreHelperUtil).isMobile()) return (0, $gDLfI.html)`
        <wui-icon-box
          size="lg"
          iconSize="xl"
          iconColor="accent-100"
          backgroundColor="accent-100"
          icon="qrCode"
          background="transparent"
          border
          borderColor="wui-accent-glass-010"
          @click=${this.onWalletConnectQr.bind(this)}
        ></wui-icon-box>
      `;
        return null;
    }
    onWalletConnectQr() {
        (0, $3OaCj.RouterController).push("ConnectingWalletConnect");
    }
};
$8a052ca51ae98b92$var$__decorate([
    (0, $hdnNF.state)()
], $8a052ca51ae98b92$export$88f35657f4e64778.prototype, "search", void 0);
$8a052ca51ae98b92$export$88f35657f4e64778 = $8a052ca51ae98b92$var$__decorate([
    (0, $3SCaV.customElement)("w3m-all-wallets-view")
], $8a052ca51ae98b92$export$88f35657f4e64778);


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $5PCU5 = parcelRequire("5PCU5");
var $5n5Ql = parcelRequire("5n5Ql");
var $23VhR = parcelRequire("23VhR");
var $79hu3 = parcelRequire("79hu3");
var $cPOJT = parcelRequire("cPOJT");
var $3OaCj = parcelRequire("3OaCj");
var $dXr1O = parcelRequire("dXr1O");
var $jGPEs = parcelRequire("jGPEs");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $9f6414f73c34ad34$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-thumbnail {
    position: absolute;
  }

  wui-visual {
    width: var(--wui-wallet-image-size-lg);
    height: var(--wui-wallet-image-size-lg);
    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));
    position: relative;
    overflow: hidden;
  }

  wui-visual::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
  }

  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  wui-text[align='center'] {
    width: 100%;
    padding: 0px var(--wui-spacing-l);
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  [data-retry='false'] wui-link {
    display: none;
  }

  [data-retry='true'] wui-link {
    display: block;
    opacity: 1;
  }

  wui-link {
    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);
  }
`;


var $efea4e1e69bebc06$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $efea4e1e69bebc06$export$e0ca4e8f314f5325 = class W3mBuyInProgressView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.selectedOnRampProvider = (0, $79hu3.OnRampController).state.selectedProvider;
        this.uri = (0, $5n5Ql.ConnectionController).state.wcUri;
        this.ready = false;
        this.showRetry = false;
        this.buffering = false;
        this.error = false;
        this.startTime = null;
        this.isMobile = false;
        this.onRetry = undefined;
        this.unsubscribe.push(...[
            (0, $79hu3.OnRampController).subscribeKey("selectedProvider", (val)=>{
                this.selectedOnRampProvider = val;
            })
        ]);
        this.watchTransactions();
    }
    disconnectedCallback() {
        if (this.intervalId) clearInterval(this.intervalId);
    }
    render() {
        let label = "Continue in external window";
        if (this.error) label = "Buy failed";
        else if (this.selectedOnRampProvider) label = `Buy in ${this.selectedOnRampProvider?.label}`;
        const subLabel = this.error ? "Buy can be declined from your side or due to and error on the provider app" : `We\u{2019}ll notify you once your Buy is processed`;
        return (0, $gDLfI.html)`
      <wui-flex
        data-error=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.error)}
        data-retry=${this.showRetry}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-visual
            name=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.selectedOnRampProvider?.name)}
            size="lg"
            class="provider-image"
          >
          </wui-visual>

          ${this.error ? null : this.loaderTemplate()}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            border
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text variant="paragraph-500" color=${this.error ? "error-100" : "fg-100"}>
            ${label}
          </wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        ${this.error ? this.tryAgainTemplate() : null}
      </wui-flex>

      <wui-flex .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]} justifyContent="center">
        <wui-link @click=${this.onCopyUri} color="fg-200">
          <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
          Copy link
        </wui-link>
      </wui-flex>
    `;
    }
    watchTransactions() {
        if (!this.selectedOnRampProvider) return;
        switch(this.selectedOnRampProvider.name){
            case "coinbase":
                this.startTime = Date.now();
                this.initializeCoinbaseTransactions();
                break;
            default:
                break;
        }
    }
    async initializeCoinbaseTransactions() {
        await this.watchCoinbaseTransactions();
        this.intervalId = setInterval(()=>this.watchCoinbaseTransactions(), 4000);
    }
    async watchCoinbaseTransactions() {
        try {
            const address = (0, $7mucr.AccountController).state.address;
            const projectId = (0, $cPOJT.OptionsController).state.projectId;
            if (!address) throw new Error("No address found");
            const coinbaseResponse = await (0, $5PCU5.BlockchainApiController).fetchTransactions({
                account: address,
                onramp: "coinbase",
                projectId: projectId
            });
            const newTransactions = coinbaseResponse.data.filter((tx)=>new Date(tx.metadata.minedAt) > new Date(this.startTime) || tx.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS");
            if (newTransactions.length) {
                clearInterval(this.intervalId);
                (0, $3OaCj.RouterController).replace("OnRampActivity");
            } else if (this.startTime && Date.now() - this.startTime >= 180000) {
                clearInterval(this.intervalId);
                this.error = true;
            }
        } catch (error) {
            (0, $dXr1O.SnackController).showError(error);
        }
    }
    onTryAgain() {
        if (!this.selectedOnRampProvider) return;
        this.error = false;
        (0, $23VhR.CoreHelperUtil).openHref(this.selectedOnRampProvider.url, "popupWindow", "width=600,height=800,scrollbars=yes");
    }
    tryAgainTemplate() {
        if (!this.selectedOnRampProvider?.url) return null;
        return (0, $gDLfI.html)`<wui-button variant="accent" @click=${this.onTryAgain.bind(this)}>
      <wui-icon color="inherit" slot="iconLeft" name="refresh"></wui-icon>
      Try again
    </wui-button>`;
    }
    loaderTemplate() {
        const borderRadiusMaster = (0, $jGPEs.ThemeController).state.themeVariables["--w3m-border-radius-master"];
        const radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
        return (0, $gDLfI.html)`<wui-loading-thumbnail radius=${radius * 9}></wui-loading-thumbnail>`;
    }
    onCopyUri() {
        if (!this.selectedOnRampProvider?.url) {
            (0, $dXr1O.SnackController).showError("No link found");
            (0, $3OaCj.RouterController).goBack();
            return;
        }
        try {
            (0, $23VhR.CoreHelperUtil).copyToClopboard(this.selectedOnRampProvider.url);
            (0, $dXr1O.SnackController).showSuccess("Link copied");
        } catch  {
            (0, $dXr1O.SnackController).showError("Failed to copy");
        }
    }
};
$efea4e1e69bebc06$export$e0ca4e8f314f5325.styles = (0, $9f6414f73c34ad34$export$2e2bcd8739ae039);
$efea4e1e69bebc06$var$__decorate([
    (0, $hdnNF.state)()
], $efea4e1e69bebc06$export$e0ca4e8f314f5325.prototype, "selectedOnRampProvider", void 0);
$efea4e1e69bebc06$var$__decorate([
    (0, $hdnNF.state)()
], $efea4e1e69bebc06$export$e0ca4e8f314f5325.prototype, "uri", void 0);
$efea4e1e69bebc06$var$__decorate([
    (0, $hdnNF.state)()
], $efea4e1e69bebc06$export$e0ca4e8f314f5325.prototype, "ready", void 0);
$efea4e1e69bebc06$var$__decorate([
    (0, $hdnNF.state)()
], $efea4e1e69bebc06$export$e0ca4e8f314f5325.prototype, "showRetry", void 0);
$efea4e1e69bebc06$var$__decorate([
    (0, $hdnNF.state)()
], $efea4e1e69bebc06$export$e0ca4e8f314f5325.prototype, "buffering", void 0);
$efea4e1e69bebc06$var$__decorate([
    (0, $hdnNF.state)()
], $efea4e1e69bebc06$export$e0ca4e8f314f5325.prototype, "error", void 0);
$efea4e1e69bebc06$var$__decorate([
    (0, $hdnNF.state)()
], $efea4e1e69bebc06$export$e0ca4e8f314f5325.prototype, "intervalId", void 0);
$efea4e1e69bebc06$var$__decorate([
    (0, $hdnNF.state)()
], $efea4e1e69bebc06$export$e0ca4e8f314f5325.prototype, "startTime", void 0);
$efea4e1e69bebc06$var$__decorate([
    (0, $8c6bF.property)({
        type: Boolean
    })
], $efea4e1e69bebc06$export$e0ca4e8f314f5325.prototype, "isMobile", void 0);
$efea4e1e69bebc06$var$__decorate([
    (0, $8c6bF.property)()
], $efea4e1e69bebc06$export$e0ca4e8f314f5325.prototype, "onRetry", void 0);
$efea4e1e69bebc06$export$e0ca4e8f314f5325 = $efea4e1e69bebc06$var$__decorate([
    (0, $3SCaV.customElement)("w3m-buy-in-progress-view")
], $efea4e1e69bebc06$export$e0ca4e8f314f5325);


parcelRequire("3aODI");
var $aHgTP = parcelRequire("aHgTP");
var $3jnn6 = parcelRequire("3jnn6");
var $5n5Ql = parcelRequire("5n5Ql");
var $01g6R = parcelRequire("01g6R");
var $QVM5q = parcelRequire("QVM5q");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
var $cPOJT = parcelRequire("cPOJT");
var $3OaCj = parcelRequire("3OaCj");
var $6sZsT = parcelRequire("6sZsT");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $8833ebb242571375$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
  }

  wui-flex::-webkit-scrollbar {
    display: none;
  }
`;


var $f81997c3442f6bcd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f81997c3442f6bcd$export$b7220f3d0ae9dbca = class W3mConnectView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $01g6R.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $01g6R.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        <w3m-email-login-widget></w3m-email-login-widget>

        ${this.walletConnectConnectorTemplate()} ${this.recentTemplate()}
        ${this.announcedTemplate()} ${this.injectedTemplate()} ${this.featuredTemplate()}
        ${this.customTemplate()} ${this.recommendedTemplate()} ${this.externalTemplate()}
        ${this.allWalletsTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
    walletConnectConnectorTemplate() {
        if ((0, $23VhR.CoreHelperUtil).isMobile()) return null;
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        return (0, $gDLfI.html)`
      <wui-list-wallet
        imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getConnectorImage(connector))}
        name=${connector.name ?? "Unknown"}
        @click=${()=>this.onConnector(connector)}
        tagLabel="qr code"
        tagVariant="main"
        data-testid="wallet-selector-walletconnect"
      >
      </wui-list-wallet>
    `;
    }
    customTemplate() {
        const { customWallets: customWallets } = (0, $cPOJT.OptionsController).state;
        if (!customWallets?.length) return null;
        const wallets = this.filterOutDuplicateWallets(customWallets);
        return wallets.map((wallet)=>(0, $gDLfI.html)`
        <wui-list-wallet
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getWalletImage(wallet))}
          name=${wallet.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
        >
        </wui-list-wallet>
      `);
    }
    featuredTemplate() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        const { featured: featured } = (0, $aHgTP.ApiController).state;
        if (!featured.length) return null;
        const wallets = this.filterOutDuplicateWallets(featured);
        return wallets.map((wallet)=>(0, $gDLfI.html)`
        <wui-list-wallet
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getWalletImage(wallet))}
          name=${wallet.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
        >
        </wui-list-wallet>
      `);
    }
    recentTemplate() {
        const recent = (0, $6sZsT.StorageUtil).getRecentWallets();
        return recent.map((wallet)=>(0, $gDLfI.html)`
        <wui-list-wallet
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getWalletImage(wallet))}
          name=${wallet.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
          tagLabel="recent"
          tagVariant="shade"
        >
        </wui-list-wallet>
      `);
    }
    announcedTemplate() {
        return this.connectors.map((connector)=>{
            if (connector.type !== "ANNOUNCED") return null;
            return (0, $gDLfI.html)`
        <wui-list-wallet
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getConnectorImage(connector))}
          name=${connector.name ?? "Unknown"}
          @click=${()=>this.onConnector(connector)}
          tagVariant="success"
          .installed=${true}
        >
        </wui-list-wallet>
      `;
        });
    }
    injectedTemplate() {
        return this.connectors.map((connector)=>{
            if (connector.type !== "INJECTED") return null;
            if (!(0, $5n5Ql.ConnectionController).checkInstalled()) return null;
            return (0, $gDLfI.html)`
        <wui-list-wallet
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getConnectorImage(connector))}
          .installed=${true}
          name=${connector.name ?? "Unknown"}
          @click=${()=>this.onConnector(connector)}
        >
        </wui-list-wallet>
      `;
        });
    }
    externalTemplate() {
        const announcedRdns = (0, $01g6R.ConnectorController).getAnnouncedConnectorRdns();
        return this.connectors.map((connector)=>{
            if ([
                "WALLET_CONNECT",
                "INJECTED",
                "ANNOUNCED",
                "EMAIL"
            ].includes(connector.type)) return null;
            if (announcedRdns.includes((0, $QVM5q.ConstantsUtil).CONNECTOR_RDNS_MAP[connector.id])) return null;
            return (0, $gDLfI.html)`
        <wui-list-wallet
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getConnectorImage(connector))}
          name=${connector.name ?? "Unknown"}
          @click=${()=>this.onConnector(connector)}
        >
        </wui-list-wallet>
      `;
        });
    }
    allWalletsTemplate() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        const { allWallets: allWallets } = (0, $cPOJT.OptionsController).state;
        if (!connector || allWallets === "HIDE") return null;
        if (allWallets === "ONLY_MOBILE" && !(0, $23VhR.CoreHelperUtil).isMobile()) return null;
        const count = (0, $aHgTP.ApiController).state.count;
        const featuredCount = (0, $aHgTP.ApiController).state.featured.length;
        const rawCount = count + featuredCount;
        const roundedCount = rawCount < 10 ? rawCount : Math.floor(rawCount / 10) * 10;
        const tagLabel = roundedCount < rawCount ? `${roundedCount}+` : `${roundedCount}`;
        return (0, $gDLfI.html)`
      <wui-list-wallet
        name="All Wallets"
        walletIcon="allWallets"
        showAllWallets
        @click=${this.onAllWallets.bind(this)}
        tagLabel=${tagLabel}
        tagVariant="shade"
        data-testid="all-wallets"
      ></wui-list-wallet>
    `;
    }
    recommendedTemplate() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        const { recommended: recommended } = (0, $aHgTP.ApiController).state;
        const { customWallets: customWallets, featuredWalletIds: featuredWalletIds } = (0, $cPOJT.OptionsController).state;
        const { connectors: connectors } = (0, $01g6R.ConnectorController).state;
        const recent = (0, $6sZsT.StorageUtil).getRecentWallets();
        const injected = connectors.filter((c)=>c.type === "INJECTED");
        const filteredInjected = injected.filter((i)=>i.name !== "Browser Wallet");
        if (featuredWalletIds || customWallets || !recommended.length) return null;
        const overrideLength = filteredInjected.length + recent.length;
        const maxRecommended = Math.max(0, 2 - overrideLength);
        const wallets = this.filterOutDuplicateWallets(recommended).slice(0, maxRecommended);
        return wallets.map((wallet)=>(0, $gDLfI.html)`
        <wui-list-wallet
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getWalletImage(wallet))}
          name=${wallet?.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
        >
        </wui-list-wallet>
      `);
    }
    onConnector(connector) {
        if (connector.type === "WALLET_CONNECT") {
            if ((0, $23VhR.CoreHelperUtil).isMobile()) (0, $3OaCj.RouterController).push("AllWallets");
            else (0, $3OaCj.RouterController).push("ConnectingWalletConnect");
        } else (0, $3OaCj.RouterController).push("ConnectingExternal", {
            connector: connector
        });
    }
    filterOutDuplicateWallets(wallets) {
        const recent = (0, $6sZsT.StorageUtil).getRecentWallets();
        const recentIds = recent.map((wallet)=>wallet.id);
        const filtered = wallets.filter((wallet)=>!recentIds.includes(wallet.id));
        return filtered;
    }
    onAllWallets() {
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "CLICK_ALL_WALLETS"
        });
        (0, $3OaCj.RouterController).push("AllWallets");
    }
    onConnectWallet(wallet) {
        (0, $3OaCj.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$f81997c3442f6bcd$export$b7220f3d0ae9dbca.styles = (0, $8833ebb242571375$export$2e2bcd8739ae039);
$f81997c3442f6bcd$var$__decorate([
    (0, $hdnNF.state)()
], $f81997c3442f6bcd$export$b7220f3d0ae9dbca.prototype, "connectors", void 0);
$f81997c3442f6bcd$export$b7220f3d0ae9dbca = $f81997c3442f6bcd$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connect-view")
], $f81997c3442f6bcd$export$b7220f3d0ae9dbca);


parcelRequire("3aODI");
var $5n5Ql = parcelRequire("5n5Ql");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $3OaCj = parcelRequire("3OaCj");
var $jIUUu = parcelRequire("jIUUu");
var $6sZsT = parcelRequire("6sZsT");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("3aODI");
var $3jnn6 = parcelRequire("3jnn6");
var $5n5Ql = parcelRequire("5n5Ql");
var $23VhR = parcelRequire("23VhR");
var $3OaCj = parcelRequire("3OaCj");
var $dXr1O = parcelRequire("dXr1O");
var $jGPEs = parcelRequire("jGPEs");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $6493ec4a4729150b$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-thumbnail {
    position: absolute;
  }

  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  wui-text[align='center'] {
    width: 100%;
    padding: 0px var(--wui-spacing-l);
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  [data-retry='false'] wui-link {
    display: none;
  }

  [data-retry='true'] wui-link {
    display: block;
    opacity: 1;
  }
`;


var $3f6a710230e36221$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $3f6a710230e36221$export$902e3cfa9f67689d extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.wallet = (0, $3OaCj.RouterController).state.data?.wallet;
        this.connector = (0, $3OaCj.RouterController).state.data?.connector;
        this.timeout = undefined;
        this.secondaryBtnLabel = "Try again";
        this.secondaryBtnIcon = "refresh";
        this.secondaryLabel = "Accept connection request in the wallet";
        this.onConnect = undefined;
        this.onRender = undefined;
        this.onAutoConnect = undefined;
        this.isWalletConnect = true;
        this.unsubscribe = [];
        this.imageSrc = (0, $3jnn6.AssetUtil).getWalletImage(this.wallet) ?? (0, $3jnn6.AssetUtil).getConnectorImage(this.connector);
        this.name = this.wallet?.name ?? this.connector?.name ?? "Wallet";
        this.isRetrying = false;
        this.uri = (0, $5n5Ql.ConnectionController).state.wcUri;
        this.error = (0, $5n5Ql.ConnectionController).state.wcError;
        this.ready = false;
        this.showRetry = false;
        this.buffering = false;
        this.isMobile = false;
        this.onRetry = undefined;
        this.unsubscribe.push(...[
            (0, $5n5Ql.ConnectionController).subscribeKey("wcUri", (val)=>{
                this.uri = val;
                if (this.isRetrying && this.onRetry) {
                    this.isRetrying = false;
                    this.onConnect?.();
                }
            }),
            (0, $5n5Ql.ConnectionController).subscribeKey("wcError", (val)=>this.error = val),
            (0, $5n5Ql.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val)
        ]);
    }
    firstUpdated() {
        this.onAutoConnect?.();
        this.showRetry = !this.onAutoConnect;
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        clearTimeout(this.timeout);
    }
    render() {
        this.onRender?.();
        this.onShowRetry();
        const subLabel = this.error ? "Connection can be declined if a previous request is still active" : this.secondaryLabel;
        let label = `Continue in ${this.name}`;
        if (this.buffering) label = "Connecting...";
        if (this.error) label = "Connection declined";
        return (0, $gDLfI.html)`
      <wui-flex
        data-error=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.error)}
        data-retry=${this.showRetry}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-wallet-image size="lg" imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.imageSrc)}></wui-wallet-image>

          ${this.error ? null : this.loaderTemplate()}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            border
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text variant="paragraph-500" color=${this.error ? "error-100" : "fg-100"}>
            ${label}
          </wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        <wui-button
          variant="accent"
          ?disabled=${!this.error && this.buffering}
          @click=${this.onTryAgain.bind(this)}
        >
          <wui-icon color="inherit" slot="iconLeft" name=${this.secondaryBtnIcon}></wui-icon>
          ${this.secondaryBtnLabel}
        </wui-button>
      </wui-flex>

      ${this.isWalletConnect ? (0, $gDLfI.html)`
            <wui-flex .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]} justifyContent="center">
              <wui-link @click=${this.onCopyUri} color="fg-200">
                <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
                Copy link
              </wui-link>
            </wui-flex>
          ` : null}

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
    onShowRetry() {
        if (this.error && !this.showRetry) {
            this.showRetry = true;
            const retryButton = this.shadowRoot?.querySelector("wui-button");
            retryButton?.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    onTryAgain() {
        if (!this.buffering) {
            (0, $5n5Ql.ConnectionController).setWcError(false);
            if (this.onRetry) {
                this.isRetrying = true;
                this.onRetry?.();
            } else this.onConnect?.();
        }
    }
    loaderTemplate() {
        const borderRadiusMaster = (0, $jGPEs.ThemeController).state.themeVariables["--w3m-border-radius-master"];
        const radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
        return (0, $gDLfI.html)`<wui-loading-thumbnail radius=${radius * 9}></wui-loading-thumbnail>`;
    }
    onCopyUri() {
        try {
            if (this.uri) {
                (0, $23VhR.CoreHelperUtil).copyToClopboard(this.uri);
                (0, $dXr1O.SnackController).showSuccess("Link copied");
            }
        } catch  {
            (0, $dXr1O.SnackController).showError("Failed to copy");
        }
    }
}
$3f6a710230e36221$export$902e3cfa9f67689d.styles = (0, $6493ec4a4729150b$export$2e2bcd8739ae039);
$3f6a710230e36221$var$__decorate([
    (0, $hdnNF.state)()
], $3f6a710230e36221$export$902e3cfa9f67689d.prototype, "uri", void 0);
$3f6a710230e36221$var$__decorate([
    (0, $hdnNF.state)()
], $3f6a710230e36221$export$902e3cfa9f67689d.prototype, "error", void 0);
$3f6a710230e36221$var$__decorate([
    (0, $hdnNF.state)()
], $3f6a710230e36221$export$902e3cfa9f67689d.prototype, "ready", void 0);
$3f6a710230e36221$var$__decorate([
    (0, $hdnNF.state)()
], $3f6a710230e36221$export$902e3cfa9f67689d.prototype, "showRetry", void 0);
$3f6a710230e36221$var$__decorate([
    (0, $hdnNF.state)()
], $3f6a710230e36221$export$902e3cfa9f67689d.prototype, "buffering", void 0);
$3f6a710230e36221$var$__decorate([
    (0, $8c6bF.property)({
        type: Boolean
    })
], $3f6a710230e36221$export$902e3cfa9f67689d.prototype, "isMobile", void 0);
$3f6a710230e36221$var$__decorate([
    (0, $8c6bF.property)()
], $3f6a710230e36221$export$902e3cfa9f67689d.prototype, "onRetry", void 0);


var $4e4c3c02f0d6b119$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $4e4c3c02f0d6b119$var$platformMap = {
    INJECTED: "browser",
    ANNOUNCED: "browser"
};
let $4e4c3c02f0d6b119$export$1d20b0281d81b1fd = class W3mConnectingExternalView extends (0, $3f6a710230e36221$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.connector) throw new Error("w3m-connecting-view: No connector provided");
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.connector.name ?? "Unknown",
                platform: $4e4c3c02f0d6b119$var$platformMap[this.connector.type] ?? "external"
            }
        });
        this.onConnect = this.onConnectProxy.bind(this);
        this.onAutoConnect = this.onConnectProxy.bind(this);
        this.isWalletConnect = false;
    }
    async onConnectProxy() {
        try {
            this.error = false;
            if (this.connector) {
                if (this.connector.imageUrl) (0, $6sZsT.StorageUtil).setConnectedWalletImageUrl(this.connector.imageUrl);
                await (0, $5n5Ql.ConnectionController).connectExternal(this.connector);
                if ((0, $jIUUu.SIWEController).state.isSiweEnabled) (0, $3OaCj.RouterController).push("ConnectingSiwe");
                else (0, $nBm8O.ModalController).close();
                (0, $dUlgM.EventsController).sendEvent({
                    type: "track",
                    event: "CONNECT_SUCCESS",
                    properties: {
                        method: "external"
                    }
                });
            }
        } catch (error) {
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            this.error = true;
        }
    }
};
$4e4c3c02f0d6b119$export$1d20b0281d81b1fd = $4e4c3c02f0d6b119$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-external-view")
], $4e4c3c02f0d6b119$export$1d20b0281d81b1fd);


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $5n5Ql = parcelRequire("5n5Ql");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $cPOJT = parcelRequire("cPOJT");
var $3OaCj = parcelRequire("3OaCj");
var $jIUUu = parcelRequire("jIUUu");
var $dXr1O = parcelRequire("dXr1O");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
var $5604013044d4c665$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5604013044d4c665$export$cbe596dc0e3ac801 = class W3mConnectingSiweView extends (0, $dlgVE.LitElement) {
    constructor(){
        super(...arguments);
        this.dappName = (0, $cPOJT.OptionsController).state.metadata?.name;
        this.isSigning = false;
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex justifyContent="center" .padding=${[
            "2xl",
            "0",
            "xxl",
            "0"
        ]}>
        <w3m-connecting-siwe></w3m-connecting-siwe>
      </wui-flex>
      <wui-flex
        .padding=${[
            "0",
            "4xl",
            "l",
            "4xl"
        ]}
        gap="s"
        justifyContent="space-between"
      >
        <wui-text variant="paragraph-500" align="center" color="fg-100"
          >${this.dappName ?? "Dapp"} needs to connect to your wallet</wui-text
        >
      </wui-flex>
      <wui-flex
        .padding=${[
            "0",
            "3xl",
            "l",
            "3xl"
        ]}
        gap="s"
        justifyContent="space-between"
      >
        <wui-text variant="small-400" align="center" color="fg-200"
          >Sign this message to prove you own this wallet and proceed. Canceling will disconnect
          you.</wui-text
        >
      </wui-flex>
      <wui-flex .padding=${[
            "l",
            "xl",
            "xl",
            "xl"
        ]} gap="s" justifyContent="space-between">
        <wui-button
          size="md"
          ?fullwidth=${true}
          variant="shade"
          @click=${this.onCancel.bind(this)}
          data-testid="w3m-connecting-siwe-cancel"
        >
          Cancel
        </wui-button>
        <wui-button
          size="md"
          ?fullwidth=${true}
          variant="fill"
          @click=${this.onSign.bind(this)}
          ?loading=${this.isSigning}
          data-testid="w3m-connecting-siwe-sign"
        >
          ${this.isSigning ? "Signing..." : "Sign"}
        </wui-button>
      </wui-flex>
    `;
    }
    async onSign() {
        this.isSigning = true;
        (0, $dUlgM.EventsController).sendEvent({
            event: "CLICK_SIGN_SIWE_MESSAGE",
            type: "track"
        });
        try {
            (0, $jIUUu.SIWEController).setStatus("loading");
            const session = await (0, $jIUUu.SIWEController).signIn();
            (0, $jIUUu.SIWEController).setStatus("success");
            (0, $dUlgM.EventsController).sendEvent({
                event: "SIWE_AUTH_SUCCESS",
                type: "track"
            });
            return session;
        } catch (error) {
            (0, $dXr1O.SnackController).showError("Signature declined");
            (0, $jIUUu.SIWEController).setStatus("error");
            return (0, $dUlgM.EventsController).sendEvent({
                event: "SIWE_AUTH_ERROR",
                type: "track"
            });
        } finally{
            this.isSigning = false;
        }
    }
    async onCancel() {
        const { isConnected: isConnected } = (0, $7mucr.AccountController).state;
        if (isConnected) {
            await (0, $5n5Ql.ConnectionController).disconnect();
            (0, $nBm8O.ModalController).close();
        } else (0, $3OaCj.RouterController).push("Connect");
        (0, $dUlgM.EventsController).sendEvent({
            event: "CLICK_CANCEL_SIWE",
            type: "track"
        });
    }
};
$5604013044d4c665$var$__decorate([
    (0, $hdnNF.state)()
], $5604013044d4c665$export$cbe596dc0e3ac801.prototype, "isSigning", void 0);
$5604013044d4c665$export$cbe596dc0e3ac801 = $5604013044d4c665$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-siwe-view")
], $5604013044d4c665$export$cbe596dc0e3ac801);


parcelRequire("3aODI");
var $3jnn6 = parcelRequire("3jnn6");
var $5n5Ql = parcelRequire("5n5Ql");
var $01g6R = parcelRequire("01g6R");
var $QVM5q = parcelRequire("QVM5q");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $3OaCj = parcelRequire("3OaCj");
var $jIUUu = parcelRequire("jIUUu");
var $dXr1O = parcelRequire("dXr1O");
var $6sZsT = parcelRequire("6sZsT");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
var $9d3ea82d9df4d9cf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9d3ea82d9df4d9cf$export$749260f2a44cfead = class W3mConnectingWcView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.interval = undefined;
        this.lastRetry = Date.now();
        this.wallet = (0, $3OaCj.RouterController).state.data?.wallet;
        this.platform = undefined;
        this.platforms = [];
        this.initializeConnection();
        this.interval = setInterval(this.initializeConnection.bind(this), (0, $QVM5q.ConstantsUtil).TEN_SEC_MS);
    }
    disconnectedCallback() {
        clearTimeout(this.interval);
    }
    render() {
        if (!this.wallet) return (0, $gDLfI.html)`<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>`;
        this.determinePlatforms();
        return (0, $gDLfI.html)`
      ${this.headerTemplate()}
      <div>${this.platformTemplate()}</div>
    `;
    }
    async initializeConnection(retry = false) {
        try {
            const { wcPairingExpiry: wcPairingExpiry } = (0, $5n5Ql.ConnectionController).state;
            if (retry || (0, $23VhR.CoreHelperUtil).isPairingExpired(wcPairingExpiry)) {
                (0, $5n5Ql.ConnectionController).connectWalletConnect();
                if (this.wallet) {
                    const url = (0, $3jnn6.AssetUtil).getWalletImage(this.wallet);
                    if (url) (0, $6sZsT.StorageUtil).setConnectedWalletImageUrl(url);
                } else {
                    const connectors = (0, $01g6R.ConnectorController).state.connectors;
                    const connector = connectors.find((c)=>c.type === "WALLET_CONNECT");
                    const url = (0, $3jnn6.AssetUtil).getConnectorImage(connector);
                    if (url) (0, $6sZsT.StorageUtil).setConnectedWalletImageUrl(url);
                }
                await (0, $5n5Ql.ConnectionController).state.wcPromise;
                this.finalizeConnection();
                if ((0, $jIUUu.SIWEController).state.isSiweEnabled) (0, $3OaCj.RouterController).push("ConnectingSiwe");
                else (0, $nBm8O.ModalController).close();
            }
        } catch (error) {
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            (0, $5n5Ql.ConnectionController).setWcError(true);
            if ((0, $23VhR.CoreHelperUtil).isAllowedRetry(this.lastRetry)) {
                (0, $dXr1O.SnackController).showError("Declined");
                this.lastRetry = Date.now();
                this.initializeConnection(true);
            }
        }
    }
    finalizeConnection() {
        const { wcLinking: wcLinking, recentWallet: recentWallet } = (0, $5n5Ql.ConnectionController).state;
        if (wcLinking) (0, $6sZsT.StorageUtil).setWalletConnectDeepLink(wcLinking);
        if (recentWallet) (0, $6sZsT.StorageUtil).setWeb3ModalRecent(recentWallet);
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "CONNECT_SUCCESS",
            properties: {
                method: wcLinking ? "mobile" : "qrcode"
            }
        });
    }
    determinePlatforms() {
        if (!this.wallet) throw new Error("w3m-connecting-wc-view:determinePlatforms No wallet");
        if (this.platform) return;
        const { mobile_link: mobile_link, desktop_link: desktop_link, webapp_link: webapp_link, injected: injected, rdns: rdns } = this.wallet;
        const injectedIds = injected?.map(({ injected_id: injected_id })=>injected_id).filter(Boolean);
        const browserIds = rdns ? [
            rdns
        ] : injectedIds ?? [];
        const isBrowser = browserIds.length;
        const isMobileWc = mobile_link;
        const isWebWc = webapp_link;
        const isBrowserInstalled = (0, $5n5Ql.ConnectionController).checkInstalled(browserIds);
        const isBrowserWc = isBrowser && isBrowserInstalled;
        const isDesktopWc = desktop_link && !(0, $23VhR.CoreHelperUtil).isMobile();
        if (isBrowserWc) this.platforms.push("browser");
        if (isMobileWc) this.platforms.push((0, $23VhR.CoreHelperUtil).isMobile() ? "mobile" : "qrcode");
        if (isWebWc) this.platforms.push("web");
        if (isDesktopWc) this.platforms.push("desktop");
        if (!isBrowserWc && isBrowser) this.platforms.push("unsupported");
        this.platform = this.platforms[0];
    }
    platformTemplate() {
        switch(this.platform){
            case "browser":
                return (0, $gDLfI.html)`<w3m-connecting-wc-browser></w3m-connecting-wc-browser>`;
            case "desktop":
                return (0, $gDLfI.html)`
          <w3m-connecting-wc-desktop .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-desktop>
        `;
            case "web":
                return (0, $gDLfI.html)`
          <w3m-connecting-wc-web .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-web>
        `;
            case "mobile":
                return (0, $gDLfI.html)`
          <w3m-connecting-wc-mobile isMobile .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-mobile>
        `;
            case "qrcode":
                return (0, $gDLfI.html)`<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>`;
            default:
                return (0, $gDLfI.html)`<w3m-connecting-wc-unsupported></w3m-connecting-wc-unsupported>`;
        }
    }
    headerTemplate() {
        const multiPlatform = this.platforms.length > 1;
        if (!multiPlatform) return null;
        return (0, $gDLfI.html)`
      <w3m-connecting-header
        .platforms=${this.platforms}
        .onSelectPlatfrom=${this.onSelectPlatform.bind(this)}
      >
      </w3m-connecting-header>
    `;
    }
    async onSelectPlatform(platform) {
        const container = this.shadowRoot?.querySelector("div");
        if (container) {
            await container.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.platform = platform;
            container.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
};
$9d3ea82d9df4d9cf$var$__decorate([
    (0, $hdnNF.state)()
], $9d3ea82d9df4d9cf$export$749260f2a44cfead.prototype, "platform", void 0);
$9d3ea82d9df4d9cf$var$__decorate([
    (0, $hdnNF.state)()
], $9d3ea82d9df4d9cf$export$749260f2a44cfead.prototype, "platforms", void 0);
$9d3ea82d9df4d9cf$export$749260f2a44cfead = $9d3ea82d9df4d9cf$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-wc-view")
], $9d3ea82d9df4d9cf$export$749260f2a44cfead);


parcelRequire("3aODI");
var $23VhR = parcelRequire("23VhR");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
var $90406cb74a1a2011$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $90406cb74a1a2011$export$72485cd62e8c17e7 = class W3mDownloadsView extends (0, $dlgVE.LitElement) {
    constructor(){
        super(...arguments);
        this.wallet = (0, $3OaCj.RouterController).state.data?.wallet;
    }
    render() {
        if (!this.wallet) throw new Error("w3m-downloads-view");
        return (0, $gDLfI.html)`
      <wui-flex gap="xs" flexDirection="column" .padding=${[
            "s",
            "s",
            "l",
            "s"
        ]}>
        ${this.chromeTemplate()} ${this.iosTemplate()} ${this.androidTemplate()}
        ${this.homepageTemplate()}
      </wui-flex>
    `;
    }
    chromeTemplate() {
        if (!this.wallet?.chrome_store) return null;
        return (0, $gDLfI.html)`<wui-list-item
      variant="icon"
      icon="chromeStore"
      iconVariant="square"
      @click=${this.onChromeStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">Chrome Extension</wui-text>
    </wui-list-item>`;
    }
    iosTemplate() {
        if (!this.wallet?.app_store) return null;
        return (0, $gDLfI.html)`<wui-list-item
      variant="icon"
      icon="appStore"
      iconVariant="square"
      @click=${this.onAppStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">iOS App</wui-text>
    </wui-list-item>`;
    }
    androidTemplate() {
        if (!this.wallet?.play_store) return null;
        return (0, $gDLfI.html)`<wui-list-item
      variant="icon"
      icon="playStore"
      iconVariant="square"
      @click=${this.onPlayStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">Android App</wui-text>
    </wui-list-item>`;
    }
    homepageTemplate() {
        if (!this.wallet?.homepage) return null;
        return (0, $gDLfI.html)`
      <wui-list-item
        variant="icon"
        icon="browser"
        iconVariant="square-blue"
        @click=${this.onHomePage.bind(this)}
        chevron
      >
        <wui-text variant="paragraph-500" color="fg-100">Website</wui-text>
      </wui-list-item>
    `;
    }
    onChromeStore() {
        if (this.wallet?.chrome_store) (0, $23VhR.CoreHelperUtil).openHref(this.wallet.chrome_store, "_blank");
    }
    onAppStore() {
        if (this.wallet?.app_store) (0, $23VhR.CoreHelperUtil).openHref(this.wallet.app_store, "_blank");
    }
    onPlayStore() {
        if (this.wallet?.play_store) (0, $23VhR.CoreHelperUtil).openHref(this.wallet.play_store, "_blank");
    }
    onHomePage() {
        if (this.wallet?.homepage) (0, $23VhR.CoreHelperUtil).openHref(this.wallet.homepage, "_blank");
    }
};
$90406cb74a1a2011$export$72485cd62e8c17e7 = $90406cb74a1a2011$var$__decorate([
    (0, $3SCaV.customElement)("w3m-downloads-view")
], $90406cb74a1a2011$export$72485cd62e8c17e7);


parcelRequire("3aODI");
var $aHgTP = parcelRequire("aHgTP");
var $3jnn6 = parcelRequire("3jnn6");
var $23VhR = parcelRequire("23VhR");
var $cPOJT = parcelRequire("cPOJT");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");

var $b2939ac84b5efad4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $b2939ac84b5efad4$var$EXPLORER = "https://walletconnect.com/explorer";
let $b2939ac84b5efad4$export$24ca15e036ec0442 = class W3mGetWalletView extends (0, $dlgVE.LitElement) {
    render() {
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.recommendedWalletsTemplate()}
        <wui-list-wallet
          name="Explore all"
          showAllWallets
          walletIcon="allWallets"
          icon="externalLink"
          @click=${()=>{
            (0, $23VhR.CoreHelperUtil).openHref("https://walletconnect.com/explorer?type=wallet", "_blank");
        }}
        ></wui-list-wallet>
      </wui-flex>
    `;
    }
    recommendedWalletsTemplate() {
        const { recommended: recommended, featured: featured } = (0, $aHgTP.ApiController).state;
        const { customWallets: customWallets } = (0, $cPOJT.OptionsController).state;
        const wallets = [
            ...featured,
            ...customWallets ?? [],
            ...recommended
        ].slice(0, 4);
        return wallets.map((wallet)=>(0, $gDLfI.html)`
        <wui-list-wallet
          name=${wallet.name ?? "Unknown"}
          tagVariant="main"
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getWalletImage(wallet))}
          @click=${()=>{
                (0, $23VhR.CoreHelperUtil).openHref(wallet.homepage ?? $b2939ac84b5efad4$var$EXPLORER, "_blank");
            }}
        ></wui-list-wallet>
      `);
    }
};
$b2939ac84b5efad4$export$24ca15e036ec0442 = $b2939ac84b5efad4$var$__decorate([
    (0, $3SCaV.customElement)("w3m-get-wallet-view")
], $b2939ac84b5efad4$export$24ca15e036ec0442);


parcelRequire("3aODI");
var $3jnn6 = parcelRequire("3jnn6");
var $8A6Jz = parcelRequire("8A6Jz");
var $3OaCj = parcelRequire("3OaCj");
var $1hoT1 = parcelRequire("1hoT1");
var $jIUUu = parcelRequire("jIUUu");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $25d0b989fe66acca$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-hexagon {
    position: absolute;
  }

  wui-icon-box {
    position: absolute;
    right: 4px;
    bottom: 0;
    opacity: 0;
    transform: scale(0.5);
    z-index: 1;
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  wui-button {
    display: none;
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  wui-button[data-retry='true'] {
    display: block;
    opacity: 1;
  }
`;


var $a6bb3a8c7e6c958e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a6bb3a8c7e6c958e$export$d124f6a585588d61 = class W3mNetworkSwitchView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.network = (0, $3OaCj.RouterController).state.data?.network;
        this.unsubscribe = [];
        this.showRetry = false;
        this.error = false;
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    firstUpdated() {
        this.onSwitchNetwork();
    }
    render() {
        if (!this.network) throw new Error("w3m-network-switch-view: No network provided");
        this.onShowRetry();
        const label = this.error ? "Switch declined" : "Approve in wallet";
        const subLabel = this.error ? "Switch can be declined if chain is not supported by a wallet or previous request is still active" : "Accept connection request in your wallet";
        return (0, $gDLfI.html)`
      <wui-flex
        data-error=${this.error}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "3xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-network-image
            size="lg"
            imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getNetworkImage(this.network))}
          ></wui-network-image>

          ${this.error ? null : (0, $gDLfI.html)`<wui-loading-hexagon></wui-loading-hexagon>`}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            ?border=${true}
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100">${label}</wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        <wui-button
          data-retry=${this.showRetry}
          variant="fill"
          .disabled=${!this.error}
          @click=${this.onSwitchNetwork.bind(this)}
        >
          <wui-icon color="inherit" slot="iconLeft" name="refresh"></wui-icon>
          Try again
        </wui-button>
      </wui-flex>
    `;
    }
    onShowRetry() {
        if (this.error && !this.showRetry) {
            this.showRetry = true;
            const retryButton = this.shadowRoot?.querySelector("wui-button");
            retryButton?.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    async onSwitchNetwork() {
        try {
            this.error = false;
            if (this.network) {
                await (0, $8A6Jz.NetworkController).switchActiveNetwork(this.network);
                if (!(0, $jIUUu.SIWEController).state.isSiweEnabled) (0, $1hoT1.RouterUtil).navigateAfterNetworkSwitch();
            }
        } catch  {
            this.error = true;
        }
    }
};
$a6bb3a8c7e6c958e$export$d124f6a585588d61.styles = (0, $25d0b989fe66acca$export$2e2bcd8739ae039);
$a6bb3a8c7e6c958e$var$__decorate([
    (0, $hdnNF.state)()
], $a6bb3a8c7e6c958e$export$d124f6a585588d61.prototype, "showRetry", void 0);
$a6bb3a8c7e6c958e$var$__decorate([
    (0, $hdnNF.state)()
], $a6bb3a8c7e6c958e$export$d124f6a585588d61.prototype, "error", void 0);
$a6bb3a8c7e6c958e$export$d124f6a585588d61 = $a6bb3a8c7e6c958e$var$__decorate([
    (0, $3SCaV.customElement)("w3m-network-switch-view")
], $a6bb3a8c7e6c958e$export$d124f6a585588d61);


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $3jnn6 = parcelRequire("3jnn6");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
var $8A6Jz = parcelRequire("8A6Jz");
var $3OaCj = parcelRequire("3OaCj");
var $1hoT1 = parcelRequire("1hoT1");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $c0b1d9f930cb9cc8$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host > wui-grid {
    max-height: 360px;
    overflow: auto;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }
`;


var $4ac0af9ea0021f92$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4ac0af9ea0021f92$export$ff1f854e9d8d99b2 = class W3mNetworksView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.caipNetwork = (0, $8A6Jz.NetworkController).state.caipNetwork;
        this.unsubscribe.push((0, $8A6Jz.NetworkController).subscribeKey("caipNetwork", (val)=>this.caipNetwork = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-grid padding="s" gridTemplateColumns="repeat(4, 1fr)" rowGap="l" columnGap="xs">
        ${this.networksTemplate()}
      </wui-grid>

      <wui-separator></wui-separator>

      <wui-flex padding="s" flexDirection="column" gap="m" alignItems="center">
        <wui-text variant="small-400" color="fg-300" align="center">
          Your connected wallet may not support some of the networks available for this dApp
        </wui-text>
        <wui-link @click=${this.onNetworkHelp.bind(this)}>
          <wui-icon size="xs" color="accent-100" slot="iconLeft" name="helpCircle"></wui-icon>
          What is a network
        </wui-link>
      </wui-flex>
    `;
    }
    onNetworkHelp() {
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "CLICK_NETWORK_HELP"
        });
        (0, $3OaCj.RouterController).push("WhatIsANetwork");
    }
    networksTemplate() {
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, requestedCaipNetworks: requestedCaipNetworks, supportsAllNetworks: supportsAllNetworks } = (0, $8A6Jz.NetworkController).state;
        const sortedNetworks = (0, $23VhR.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
        return sortedNetworks?.map((network)=>(0, $gDLfI.html)`
        <wui-card-select
          .selected=${this.caipNetwork?.id === network.id}
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getNetworkImage(network))}
          type="network"
          name=${network.name ?? network.id}
          @click=${()=>this.onSwitchNetwork(network)}
          .disabled=${!supportsAllNetworks && !approvedCaipNetworkIds?.includes(network.id)}
          data-testid=${`w3m-network-switch-${network.name ?? network.id}`}
        ></wui-card-select>
      `);
    }
    async onSwitchNetwork(network) {
        const { isConnected: isConnected } = (0, $7mucr.AccountController).state;
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, supportsAllNetworks: supportsAllNetworks, caipNetwork: caipNetwork } = (0, $8A6Jz.NetworkController).state;
        const { data: data } = (0, $3OaCj.RouterController).state;
        if (isConnected && caipNetwork?.id !== network.id) {
            if (approvedCaipNetworkIds?.includes(network.id)) {
                await (0, $8A6Jz.NetworkController).switchActiveNetwork(network);
                (0, $1hoT1.RouterUtil).navigateAfterNetworkSwitch();
            } else if (supportsAllNetworks) (0, $3OaCj.RouterController).push("SwitchNetwork", {
                ...data,
                network: network
            });
        } else if (!isConnected) {
            (0, $8A6Jz.NetworkController).setCaipNetwork(network);
            (0, $3OaCj.RouterController).push("Connect");
        }
    }
};
$4ac0af9ea0021f92$export$ff1f854e9d8d99b2.styles = (0, $c0b1d9f930cb9cc8$export$2e2bcd8739ae039);
$4ac0af9ea0021f92$var$__decorate([
    (0, $hdnNF.state)()
], $4ac0af9ea0021f92$export$ff1f854e9d8d99b2.prototype, "caipNetwork", void 0);
$4ac0af9ea0021f92$export$ff1f854e9d8d99b2 = $4ac0af9ea0021f92$var$__decorate([
    (0, $3SCaV.customElement)("w3m-networks-view")
], $4ac0af9ea0021f92$export$ff1f854e9d8d99b2);


parcelRequire("8WlrT");
var $8ntrV = parcelRequire("8ntrV");
parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $b2pRm = parcelRequire("b2pRm");
var $79hu3 = parcelRequire("79hu3");
var $cPOJT = parcelRequire("cPOJT");
var $i2H8M = parcelRequire("i2H8M");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
var $aaIXL = parcelRequire("aaIXL");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $81f6d491beeb6e1c$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host > wui-flex {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    padding: var(--wui-spacing-m);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  :host > wui-flex > wui-flex {
    width: 100%;
  }

  wui-transaction-list-item-loader {
    width: 100%;
  }
`;



var $97ae5343c9a94259$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $97ae5343c9a94259$var$LOADING_ITEM_COUNT = 7;
let $97ae5343c9a94259$export$4a0b241548ecf9e5 = class W3mOnRampActivityView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.refetchTimeout = undefined;
        this.selectedOnRampProvider = (0, $79hu3.OnRampController).state.selectedProvider;
        this.loading = false;
        this.coinbaseTransactions = (0, $i2H8M.TransactionsController).state.coinbaseTransactions;
        this.tokenImages = (0, $b2pRm.AssetController).state.tokenImages;
        this.unsubscribe.push(...[
            (0, $79hu3.OnRampController).subscribeKey("selectedProvider", (val)=>{
                this.selectedOnRampProvider = val;
            }),
            (0, $b2pRm.AssetController).subscribeKey("tokenImages", (val)=>this.tokenImages = val),
            ()=>{
                clearTimeout(this.refetchTimeout);
            },
            (0, $i2H8M.TransactionsController).subscribe((val)=>{
                this.coinbaseTransactions = {
                    ...val.coinbaseTransactions
                };
            })
        ]);
        this.fetchTransactions();
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.loading ? this.templateLoading() : this.templateTransactionsByYear()}
      </wui-flex>
    `;
    }
    templateTransactions(transactions) {
        return transactions?.map((transaction)=>{
            const date = (0, $8ntrV.DateUtil).formatDate(transaction?.metadata?.minedAt);
            const transfer = transaction.transfers[0];
            const fungibleInfo = transfer?.fungible_info;
            if (!fungibleInfo) return null;
            const icon = fungibleInfo?.icon?.url || this.tokenImages?.[fungibleInfo.symbol || ""];
            return (0, $gDLfI.html)`
        <wui-onramp-activity-item
          label="Bought"
          .completed=${transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_SUCCESS"}
          .inProgress=${transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS"}
          .failed=${transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_FAILED"}
          purchaseCurrency=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(fungibleInfo.symbol)}
          purchaseValue=${transfer.quantity.numeric}
          date=${date}
          icon=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(icon)}
          symbol=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(fungibleInfo.symbol)}
        ></wui-onramp-activity-item>
      `;
        });
    }
    templateTransactionsByYear() {
        const sortedYearKeys = Object.keys(this.coinbaseTransactions).sort().reverse();
        return sortedYearKeys.map((year)=>{
            const yearInt = parseInt(year, 10);
            const sortedMonthIndexes = new Array(12).fill(null).map((_, idx)=>idx).reverse();
            return sortedMonthIndexes.map((month)=>{
                const groupTitle = (0, $aaIXL.TransactionUtil).getTransactionGroupTitle(yearInt, month);
                const transactions = this.coinbaseTransactions[yearInt]?.[month];
                if (!transactions) return null;
                return (0, $gDLfI.html)`
          <wui-flex flexDirection="column">
            <wui-flex
              alignItems="center"
              flexDirection="row"
              .padding=${[
                    "xs",
                    "s",
                    "s",
                    "s"
                ]}
            >
              <wui-text variant="paragraph-500" color="fg-200">${groupTitle}</wui-text>
            </wui-flex>
            <wui-flex flexDirection="column" gap="xs">
              ${this.templateTransactions(transactions)}
            </wui-flex>
          </wui-flex>
        `;
            });
        });
    }
    async fetchTransactions() {
        const provider = "coinbase";
        if (provider === "coinbase") await this.fetchCoinbaseTransactions();
    }
    async fetchCoinbaseTransactions() {
        const address = (0, $7mucr.AccountController).state.address;
        const projectId = (0, $cPOJT.OptionsController).state.projectId;
        if (!address) throw new Error("No address found");
        if (!projectId) throw new Error("No projectId found");
        this.loading = true;
        await (0, $i2H8M.TransactionsController).fetchTransactions(address, "coinbase");
        this.loading = false;
        this.refetchLoadingTransactions();
    }
    refetchLoadingTransactions() {
        const today = new Date();
        const currentMonthTxs = this.coinbaseTransactions[today.getFullYear()]?.[today.getMonth()] || [];
        const loadingTransactions = currentMonthTxs.filter((transaction)=>transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS");
        if (loadingTransactions.length === 0) {
            clearTimeout(this.refetchTimeout);
            return;
        }
        this.refetchTimeout = setTimeout(async ()=>{
            const address = (0, $7mucr.AccountController).state.address;
            await (0, $i2H8M.TransactionsController).fetchTransactions(address, "coinbase");
            this.refetchLoadingTransactions();
        }, 3000);
    }
    templateLoading() {
        return Array($97ae5343c9a94259$var$LOADING_ITEM_COUNT).fill((0, $gDLfI.html)` <wui-transaction-list-item-loader></wui-transaction-list-item-loader> `).map((item)=>item);
    }
};
$97ae5343c9a94259$export$4a0b241548ecf9e5.styles = (0, $81f6d491beeb6e1c$export$2e2bcd8739ae039);
$97ae5343c9a94259$var$__decorate([
    (0, $hdnNF.state)()
], $97ae5343c9a94259$export$4a0b241548ecf9e5.prototype, "selectedOnRampProvider", void 0);
$97ae5343c9a94259$var$__decorate([
    (0, $hdnNF.state)()
], $97ae5343c9a94259$export$4a0b241548ecf9e5.prototype, "loading", void 0);
$97ae5343c9a94259$var$__decorate([
    (0, $hdnNF.state)()
], $97ae5343c9a94259$export$4a0b241548ecf9e5.prototype, "coinbaseTransactions", void 0);
$97ae5343c9a94259$var$__decorate([
    (0, $hdnNF.state)()
], $97ae5343c9a94259$export$4a0b241548ecf9e5.prototype, "tokenImages", void 0);
$97ae5343c9a94259$export$4a0b241548ecf9e5 = $97ae5343c9a94259$var$__decorate([
    (0, $3SCaV.customElement)("w3m-onramp-activity-view")
], $97ae5343c9a94259$export$4a0b241548ecf9e5);


parcelRequire("3aODI");
var $b2pRm = parcelRequire("b2pRm");
var $nBm8O = parcelRequire("nBm8O");
var $79hu3 = parcelRequire("79hu3");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $17c20708c4c625a1$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host > wui-grid {
    max-height: 360px;
    overflow: auto;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }
`;



var $b922ce714dcf17c8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b922ce714dcf17c8$export$d8e2d72354b51198 = class W3mOnrampFiatSelectView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.selectedCurrency = (0, $79hu3.OnRampController).state.paymentCurrency;
        this.currencies = (0, $79hu3.OnRampController).state.paymentCurrencies;
        this.currencyImages = (0, $b2pRm.AssetController).state.currencyImages;
        this.unsubscribe.push(...[
            (0, $79hu3.OnRampController).subscribe((val)=>{
                this.selectedCurrency = val.paymentCurrency;
                this.currencies = val.paymentCurrencies;
            }),
            (0, $b2pRm.AssetController).subscribeKey("currencyImages", (val)=>this.currencyImages = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.currenciesTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
    currenciesTemplate() {
        return this.currencies.map((currency)=>(0, $gDLfI.html)`
        <wui-list-item
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.currencyImages?.[currency.id])}
          @click=${()=>this.selectCurrency(currency)}
          variant="image"
        >
          <wui-text variant="paragraph-500" color="fg-100">${currency.id}</wui-text>
        </wui-list-item>
      `);
    }
    selectCurrency(currency) {
        if (!currency) return;
        (0, $79hu3.OnRampController).setPaymentCurrency(currency);
        (0, $nBm8O.ModalController).close();
    }
};
$b922ce714dcf17c8$export$d8e2d72354b51198.styles = (0, $17c20708c4c625a1$export$2e2bcd8739ae039);
$b922ce714dcf17c8$var$__decorate([
    (0, $hdnNF.state)()
], $b922ce714dcf17c8$export$d8e2d72354b51198.prototype, "selectedCurrency", void 0);
$b922ce714dcf17c8$var$__decorate([
    (0, $hdnNF.state)()
], $b922ce714dcf17c8$export$d8e2d72354b51198.prototype, "currencies", void 0);
$b922ce714dcf17c8$var$__decorate([
    (0, $hdnNF.state)()
], $b922ce714dcf17c8$export$d8e2d72354b51198.prototype, "currencyImages", void 0);
$b922ce714dcf17c8$export$d8e2d72354b51198 = $b922ce714dcf17c8$var$__decorate([
    (0, $3SCaV.customElement)("w3m-onramp-fiat-select-view")
], $b922ce714dcf17c8$export$d8e2d72354b51198);


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $5PCU5 = parcelRequire("5PCU5");
var $QVM5q = parcelRequire("QVM5q");
var $23VhR = parcelRequire("23VhR");
var $8A6Jz = parcelRequire("8A6Jz");
var $79hu3 = parcelRequire("79hu3");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
var $ff2100b3f0acbf5f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ff2100b3f0acbf5f$export$59a62e1add0f780c = class W3mOnRampProvidersView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.providers = (0, $79hu3.OnRampController).state.providers;
        this.unsubscribe.push(...[
            (0, $79hu3.OnRampController).subscribeKey("providers", (val)=>{
                this.providers = val;
            })
        ]);
    }
    firstUpdated() {
        const urlPromises = this.providers.map(async (provider)=>{
            if (provider.name === "coinbase") return await this.getCoinbaseOnRampURL();
            return Promise.resolve(provider?.url);
        });
        Promise.all(urlPromises).then((urls)=>{
            this.providers = this.providers.map((provider, index)=>({
                    ...provider,
                    url: urls[index] || ""
                }));
        });
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.onRampProvidersTemplate()}
      </wui-flex>
      <w3m-onramp-providers-footer></w3m-onramp-providers-footer>
    `;
    }
    onRampProvidersTemplate() {
        return this.providers.map((provider)=>(0, $gDLfI.html)`
        <wui-onramp-provider-item
          label=${provider.label}
          name=${provider.name}
          feeRange=${provider.feeRange}
          @click=${()=>{
                this.onClickProvider(provider);
            }}
          ?disabled=${!provider.url}
        ></wui-onramp-provider-item>
      `);
    }
    onClickProvider(provider) {
        (0, $79hu3.OnRampController).setSelectedProvider(provider);
        (0, $3OaCj.RouterController).push("BuyInProgress");
        (0, $23VhR.CoreHelperUtil).openHref(provider.url, "popupWindow", "width=600,height=800,scrollbars=yes");
    }
    async getCoinbaseOnRampURL() {
        const address = (0, $7mucr.AccountController).state.address;
        const network = (0, $8A6Jz.NetworkController).state.caipNetwork;
        if (!address) throw new Error("No address found");
        if (!network?.name) throw new Error("No network found");
        const defaultNetwork = (0, $QVM5q.ConstantsUtil).WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP[network.name] ?? (0, $QVM5q.ConstantsUtil).WC_COINBASE_PAY_SDK_FALLBACK_CHAIN;
        const purchaseCurrency = (0, $79hu3.OnRampController).state.purchaseCurrency;
        const assets = purchaseCurrency ? [
            purchaseCurrency.symbol
        ] : (0, $79hu3.OnRampController).state.purchaseCurrencies.map((currency)=>currency.symbol);
        return await (0, $5PCU5.BlockchainApiController).generateOnRampURL({
            defaultNetwork: defaultNetwork,
            destinationWallets: [
                {
                    address: address,
                    blockchains: (0, $QVM5q.ConstantsUtil).WC_COINBASE_PAY_SDK_CHAINS,
                    assets: assets
                }
            ],
            partnerUserId: address,
            purchaseAmount: (0, $79hu3.OnRampController).state.purchaseAmount
        });
    }
};
$ff2100b3f0acbf5f$var$__decorate([
    (0, $hdnNF.state)()
], $ff2100b3f0acbf5f$export$59a62e1add0f780c.prototype, "providers", void 0);
$ff2100b3f0acbf5f$export$59a62e1add0f780c = $ff2100b3f0acbf5f$var$__decorate([
    (0, $3SCaV.customElement)("w3m-onramp-providers-view")
], $ff2100b3f0acbf5f$export$59a62e1add0f780c);


parcelRequire("3aODI");
var $b2pRm = parcelRequire("b2pRm");
var $nBm8O = parcelRequire("nBm8O");
var $79hu3 = parcelRequire("79hu3");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $a214a53aeea9cde5$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host > wui-grid {
    max-height: 360px;
    overflow: auto;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }
`;



var $a26c6962130ee407$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a26c6962130ee407$export$97f0fa712fa488a5 = class W3mOnrampTokensView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.selectedCurrency = (0, $79hu3.OnRampController).state.purchaseCurrencies;
        this.tokens = (0, $79hu3.OnRampController).state.purchaseCurrencies;
        this.tokenImages = (0, $b2pRm.AssetController).state.tokenImages;
        this.unsubscribe.push(...[
            (0, $79hu3.OnRampController).subscribe((val)=>{
                this.selectedCurrency = val.purchaseCurrencies;
                this.tokens = val.purchaseCurrencies;
            }),
            (0, $b2pRm.AssetController).subscribeKey("tokenImages", (val)=>this.tokenImages = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.currenciesTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
    currenciesTemplate() {
        return this.tokens.map((token)=>(0, $gDLfI.html)`
        <wui-list-item
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(this.tokenImages?.[token.symbol])}
          @click=${()=>this.selectToken(token)}
          variant="image"
        >
          <wui-flex gap="3xs" alignItems="center">
            <wui-text variant="paragraph-500" color="fg-100">${token.name}</wui-text>
            <wui-text variant="small-400" color="fg-200">${token.symbol}</wui-text>
          </wui-flex>
        </wui-list-item>
      `);
    }
    selectToken(currency) {
        if (!currency) return;
        (0, $79hu3.OnRampController).setPurchaseCurrency(currency);
        (0, $nBm8O.ModalController).close();
    }
};
$a26c6962130ee407$export$97f0fa712fa488a5.styles = (0, $a214a53aeea9cde5$export$2e2bcd8739ae039);
$a26c6962130ee407$var$__decorate([
    (0, $hdnNF.state)()
], $a26c6962130ee407$export$97f0fa712fa488a5.prototype, "selectedCurrency", void 0);
$a26c6962130ee407$var$__decorate([
    (0, $hdnNF.state)()
], $a26c6962130ee407$export$97f0fa712fa488a5.prototype, "tokens", void 0);
$a26c6962130ee407$var$__decorate([
    (0, $hdnNF.state)()
], $a26c6962130ee407$export$97f0fa712fa488a5.prototype, "tokenImages", void 0);
$a26c6962130ee407$export$97f0fa712fa488a5 = $a26c6962130ee407$var$__decorate([
    (0, $3SCaV.customElement)("w3m-onramp-token-select-view")
], $a26c6962130ee407$export$97f0fa712fa488a5);


parcelRequire("8WlrT");
var $8ntrV = parcelRequire("8ntrV");
parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $dUlgM = parcelRequire("dUlgM");
var $cPOJT = parcelRequire("cPOJT");
var $i2H8M = parcelRequire("i2H8M");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
var $aaIXL = parcelRequire("aaIXL");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $750b6a7ae1f4786a$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host > wui-flex:first-child {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    padding: var(--wui-spacing-m);
  }

  :host > wui-flex:first-child::-webkit-scrollbar {
    display: none;
  }
`;


var $a9901c8515ccb6d3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $a9901c8515ccb6d3$var$PAGINATOR_ID = "last-transaction";
const $a9901c8515ccb6d3$var$LOADING_ITEM_COUNT = 7;
let $a9901c8515ccb6d3$export$5b9982998ebc2231 = class W3mTransactionsView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.paginationObserver = undefined;
        this.address = (0, $7mucr.AccountController).state.address;
        this.transactionsByYear = (0, $i2H8M.TransactionsController).state.transactionsByYear;
        this.loading = (0, $i2H8M.TransactionsController).state.loading;
        this.empty = (0, $i2H8M.TransactionsController).state.empty;
        this.next = (0, $i2H8M.TransactionsController).state.next;
        this.unsubscribe.push(...[
            (0, $7mucr.AccountController).subscribe((val)=>{
                if (val.isConnected) {
                    if (this.address !== val.address) {
                        this.address = val.address;
                        (0, $i2H8M.TransactionsController).resetTransactions();
                        (0, $i2H8M.TransactionsController).fetchTransactions(val.address);
                    }
                }
            }),
            (0, $i2H8M.TransactionsController).subscribe((val)=>{
                this.transactionsByYear = val.transactionsByYear;
                this.loading = val.loading;
                this.empty = val.empty;
                this.next = val.next;
            })
        ]);
    }
    firstUpdated() {
        (0, $i2H8M.TransactionsController).fetchTransactions(this.address);
        this.createPaginationObserver();
    }
    updated() {
        this.setPaginationObserver();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" gap="s">
        ${this.empty ? null : this.templateTransactionsByYear()}
        ${this.loading ? this.templateLoading() : null}
        ${!this.loading && this.empty ? this.templateEmpty() : null}
      </wui-flex>
    `;
    }
    templateTransactionsByYear() {
        const sortedYearKeys = Object.keys(this.transactionsByYear).sort().reverse();
        return sortedYearKeys.map((year, index)=>{
            const isLastGroup = index === sortedYearKeys.length - 1;
            const yearInt = parseInt(year, 10);
            const sortedMonthIndexes = new Array(12).fill(null).map((_, idx)=>idx).reverse();
            return sortedMonthIndexes.map((month)=>{
                const groupTitle = (0, $aaIXL.TransactionUtil).getTransactionGroupTitle(yearInt, month);
                const transactions = this.transactionsByYear[yearInt]?.[month];
                if (!transactions) return null;
                return (0, $gDLfI.html)`
          <wui-flex flexDirection="column">
            <wui-flex
              alignItems="center"
              flexDirection="row"
              .padding=${[
                    "xs",
                    "s",
                    "s",
                    "s"
                ]}
            >
              <wui-text variant="paragraph-500" color="fg-200">${groupTitle}</wui-text>
            </wui-flex>
            <wui-flex flexDirection="column" gap="xs">
              ${this.templateTransactions(transactions, isLastGroup)}
            </wui-flex>
          </wui-flex>
        `;
            });
        });
    }
    templateRenderTransaction(transaction, isLastTransaction) {
        const { date: date, descriptions: descriptions, direction: direction, isAllNFT: isAllNFT, images: images, status: status, transfers: transfers, type: type } = this.getTransactionListItemProps(transaction);
        const haveMultipleTransfers = transfers?.length > 1;
        const haveTwoTransfers = transfers?.length === 2;
        if (haveTwoTransfers && !isAllNFT) return (0, $gDLfI.html)`
        <wui-transaction-list-item
          date=${date}
          .direction=${direction}
          id=${isLastTransaction && this.next ? $a9901c8515ccb6d3$var$PAGINATOR_ID : ""}
          status=${status}
          type=${type}
          .images=${images}
          .descriptions=${descriptions}
        ></wui-transaction-list-item>
      `;
        if (haveMultipleTransfers) return transfers.map((transfer, index)=>{
            const description = (0, $aaIXL.TransactionUtil).getTransferDescription(transfer);
            const isLastTransfer = isLastTransaction && index === transfers.length - 1;
            return (0, $gDLfI.html)` <wui-transaction-list-item
          date=${date}
          direction=${transfer.direction}
          id=${isLastTransfer && this.next ? $a9901c8515ccb6d3$var$PAGINATOR_ID : ""}
          status=${status}
          type=${type}
          .onlyDirectionIcon=${true}
          .images=${[
                images[index]
            ]}
          .descriptions=${[
                description
            ]}
        ></wui-transaction-list-item>`;
        });
        return (0, $gDLfI.html)`
      <wui-transaction-list-item
        date=${date}
        .direction=${direction}
        id=${isLastTransaction && this.next ? $a9901c8515ccb6d3$var$PAGINATOR_ID : ""}
        status=${status}
        type=${type}
        .images=${images}
        .descriptions=${descriptions}
      ></wui-transaction-list-item>
    `;
    }
    templateTransactions(transactions, isLastGroup) {
        return transactions.map((transaction, index)=>{
            const isLastTransaction = isLastGroup && index === transactions.length - 1;
            return (0, $gDLfI.html)`${this.templateRenderTransaction(transaction, isLastTransaction)}`;
        });
    }
    templateEmpty() {
        return (0, $gDLfI.html)`
      <wui-flex
        flexGrow="1"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "3xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-icon-box
          backgroundColor="glass-005"
          background="gray"
          iconColor="fg-200"
          icon="wallet"
          size="lg"
          ?border=${true}
          borderColor="wui-color-bg-125"
        ></wui-icon-box>
        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100"
            >No Transactions yet</wui-text
          >
          <wui-text align="center" variant="small-500" color="fg-200"
            >Start trading on dApps <br />
            to grow your wallet!</wui-text
          >
        </wui-flex>
      </wui-flex>
    `;
    }
    templateLoading() {
        return Array($a9901c8515ccb6d3$var$LOADING_ITEM_COUNT).fill((0, $gDLfI.html)` <wui-transaction-list-item-loader></wui-transaction-list-item-loader> `).map((item)=>item);
    }
    createPaginationObserver() {
        const { projectId: projectId } = (0, $cPOJT.OptionsController).state;
        this.paginationObserver = new IntersectionObserver(([element])=>{
            if (element?.isIntersecting && !this.loading) {
                (0, $i2H8M.TransactionsController).fetchTransactions(this.address);
                (0, $dUlgM.EventsController).sendEvent({
                    type: "track",
                    event: "LOAD_MORE_TRANSACTIONS",
                    properties: {
                        address: this.address,
                        projectId: projectId,
                        cursor: this.next
                    }
                });
            }
        }, {});
        this.setPaginationObserver();
    }
    setPaginationObserver() {
        this.paginationObserver?.disconnect();
        const lastItem = this.shadowRoot?.querySelector(`#${$a9901c8515ccb6d3$var$PAGINATOR_ID}`);
        if (lastItem) this.paginationObserver?.observe(lastItem);
    }
    getTransactionListItemProps(transaction) {
        const date = (0, $8ntrV.DateUtil).formatDate(transaction?.metadata?.minedAt);
        const descriptions = (0, $aaIXL.TransactionUtil).getTransactionDescriptions(transaction);
        const transfers = transaction?.transfers;
        const transfer = transaction?.transfers?.[0];
        const isAllNFT = Boolean(transfer) && transaction?.transfers?.every((item)=>Boolean(item.nft_info));
        const images = (0, $aaIXL.TransactionUtil).getTransactionImages(transfers);
        return {
            date: date,
            direction: transfer?.direction,
            descriptions: descriptions,
            isAllNFT: isAllNFT,
            images: images,
            status: transaction.metadata?.status,
            transfers: transfers,
            type: transaction.metadata?.operationType
        };
    }
};
$a9901c8515ccb6d3$export$5b9982998ebc2231.styles = (0, $750b6a7ae1f4786a$export$2e2bcd8739ae039);
$a9901c8515ccb6d3$var$__decorate([
    (0, $hdnNF.state)()
], $a9901c8515ccb6d3$export$5b9982998ebc2231.prototype, "address", void 0);
$a9901c8515ccb6d3$var$__decorate([
    (0, $hdnNF.state)()
], $a9901c8515ccb6d3$export$5b9982998ebc2231.prototype, "transactionsByYear", void 0);
$a9901c8515ccb6d3$var$__decorate([
    (0, $hdnNF.state)()
], $a9901c8515ccb6d3$export$5b9982998ebc2231.prototype, "loading", void 0);
$a9901c8515ccb6d3$var$__decorate([
    (0, $hdnNF.state)()
], $a9901c8515ccb6d3$export$5b9982998ebc2231.prototype, "empty", void 0);
$a9901c8515ccb6d3$var$__decorate([
    (0, $hdnNF.state)()
], $a9901c8515ccb6d3$export$5b9982998ebc2231.prototype, "next", void 0);
$a9901c8515ccb6d3$export$5b9982998ebc2231 = $a9901c8515ccb6d3$var$__decorate([
    (0, $3SCaV.customElement)("w3m-transactions-view")
], $a9901c8515ccb6d3$export$5b9982998ebc2231);


parcelRequire("3aODI");
var $23VhR = parcelRequire("23VhR");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
var $05729a85703f114c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $05729a85703f114c$var$data = [
    {
        images: [
            "network",
            "layers",
            "system"
        ],
        title: "The system\u2019s nuts and bolts",
        text: "A network is what brings the blockchain to life, as this technical infrastructure allows apps to access the ledger and smart contract services."
    },
    {
        images: [
            "noun",
            "defiAlt",
            "dao"
        ],
        title: "Designed for different uses",
        text: "Each network is designed differently, and may therefore suit certain apps and experiences."
    }
];
let $05729a85703f114c$export$e747cd062ecb4580 = class W3mWhatIsANetworkView extends (0, $dlgVE.LitElement) {
    render() {
        return (0, $gDLfI.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "xl",
            "xl",
            "xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <w3m-help-widget .data=${$05729a85703f114c$var$data}></w3m-help-widget>
        <wui-button
          variant="fill"
          size="sm"
          @click=${()=>{
            (0, $23VhR.CoreHelperUtil).openHref("https://ethereum.org/en/developers/docs/networks/", "_blank");
        }}
        >
          Learn more
          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>
        </wui-button>
      </wui-flex>
    `;
    }
};
$05729a85703f114c$export$e747cd062ecb4580 = $05729a85703f114c$var$__decorate([
    (0, $3SCaV.customElement)("w3m-what-is-a-network-view")
], $05729a85703f114c$export$e747cd062ecb4580);


parcelRequire("3aODI");
var $dUlgM = parcelRequire("dUlgM");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
var $fa6db0485c479294$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $fa6db0485c479294$var$data = [
    {
        images: [
            "login",
            "profile",
            "lock"
        ],
        title: "One login for all of web3",
        text: "Log in to any app by connecting your wallet. Say goodbye to countless passwords!"
    },
    {
        images: [
            "defi",
            "nft",
            "eth"
        ],
        title: "A home for your digital assets",
        text: "A wallet lets you store, send and receive digital assets like cryptocurrencies and NFTs."
    },
    {
        images: [
            "browser",
            "noun",
            "dao"
        ],
        title: "Your gateway to a new web",
        text: "With your wallet, you can explore and interact with DeFi, NFTs, DAOs, and much more."
    }
];
let $fa6db0485c479294$export$16ac3b6705a4e652 = class W3mWhatIsAWalletView extends (0, $dlgVE.LitElement) {
    render() {
        return (0, $gDLfI.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "xl",
            "xl",
            "xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <w3m-help-widget .data=${$fa6db0485c479294$var$data}></w3m-help-widget>
        <wui-button variant="fill" size="sm" @click=${this.onGetWallet.bind(this)}>
          <wui-icon color="inherit" slot="iconLeft" name="wallet"></wui-icon>
          Get a wallet
        </wui-button>
      </wui-flex>
    `;
    }
    onGetWallet() {
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "CLICK_GET_WALLET"
        });
        (0, $3OaCj.RouterController).push("GetWallet");
    }
};
$fa6db0485c479294$export$16ac3b6705a4e652 = $fa6db0485c479294$var$__decorate([
    (0, $3SCaV.customElement)("w3m-what-is-a-wallet-view")
], $fa6db0485c479294$export$16ac3b6705a4e652);


parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("3aODI");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
var $a9baf5bc700a2131$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a9baf5bc700a2131$export$c63d73b9361e157e = class W3mWhatIsABuyView extends (0, $dlgVE.LitElement) {
    render() {
        return (0, $gDLfI.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "3xl",
            "xl",
            "3xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <wui-visual name="onrampCard"></wui-visual>
        <wui-flex flexDirection="column" gap="xs" alignItems="center">
          <wui-text align="center" variant="paragraph-500" color="fg-100">
            Quickly and easily buy digital assets!
          </wui-text>
          <wui-text align="center" variant="small-400" color="fg-200">
            Simply select your preferred onramp provider and add digital assets to your account
            using your credit card or bank transfer
          </wui-text>
        </wui-flex>
        <wui-button @click=${(0, $3OaCj.RouterController).goBack}>
          <wui-icon size="sm" color="inherit" name="add" slot="iconLeft"></wui-icon>
          Buy
        </wui-button>
      </wui-flex>
    `;
    }
};
$a9baf5bc700a2131$export$c63d73b9361e157e = $a9baf5bc700a2131$var$__decorate([
    (0, $3SCaV.customElement)("w3m-what-is-a-buy-view")
], $a9baf5bc700a2131$export$c63d73b9361e157e);


parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("3aODI");
var $01g6R = parcelRequire("01g6R");
var $23VhR = parcelRequire("23VhR");
var $3OaCj = parcelRequire("3OaCj");
var $dXr1O = parcelRequire("dXr1O");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $12c28cd902d52530$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-loading-spinner {
    margin: 9px auto;
  }
`;


const $e23d11511a09400f$export$3ff97a7390ed49be = {
    SECURE_SITE_SDK: "https://secure.walletconnect.com/sdk",
    APP_EVENT_KEY: "@w3m-app/",
    FRAME_EVENT_KEY: "@w3m-frame/",
    RPC_METHOD_KEY: "RPC_",
    STORAGE_KEY: "@w3m-storage/",
    SESSION_TOKEN_KEY: "SESSION_TOKEN_KEY",
    EMAIL_LOGIN_USED_KEY: "EMAIL_LOGIN_USED_KEY",
    LAST_USED_CHAIN_KEY: "LAST_USED_CHAIN_KEY",
    LAST_EMAIL_LOGIN_TIME: "LAST_EMAIL_LOGIN_TIME",
    EMAIL: "EMAIL",
    APP_SWITCH_NETWORK: "@w3m-app/SWITCH_NETWORK",
    APP_CONNECT_EMAIL: "@w3m-app/CONNECT_EMAIL",
    APP_CONNECT_DEVICE: "@w3m-app/CONNECT_DEVICE",
    APP_CONNECT_OTP: "@w3m-app/CONNECT_OTP",
    APP_GET_USER: "@w3m-app/GET_USER",
    APP_SIGN_OUT: "@w3m-app/SIGN_OUT",
    APP_IS_CONNECTED: "@w3m-app/IS_CONNECTED",
    APP_GET_CHAIN_ID: "@w3m-app/GET_CHAIN_ID",
    APP_RPC_REQUEST: "@w3m-app/RPC_REQUEST",
    APP_UPDATE_EMAIL: "@w3m-app/UPDATE_EMAIL",
    APP_UPDATE_EMAIL_PRIMARY_OTP: "@w3m-app/UPDATE_EMAIL_PRIMARY_OTP",
    APP_UPDATE_EMAIL_SECONDARY_OTP: "@w3m-app/UPDATE_EMAIL_SECONDARY_OTP",
    APP_AWAIT_UPDATE_EMAIL: "@w3m-app/AWAIT_UPDATE_EMAIL",
    APP_SYNC_THEME: "@w3m-app/SYNC_THEME",
    APP_SYNC_DAPP_DATA: "@w3m-app/SYNC_DAPP_DATA",
    FRAME_SWITCH_NETWORK_ERROR: "@w3m-frame/SWITCH_NETWORK_ERROR",
    FRAME_SWITCH_NETWORK_SUCCESS: "@w3m-frame/SWITCH_NETWORK_SUCCESS",
    FRAME_CONNECT_EMAIL_ERROR: "@w3m-frame/CONNECT_EMAIL_ERROR",
    FRAME_CONNECT_EMAIL_SUCCESS: "@w3m-frame/CONNECT_EMAIL_SUCCESS",
    FRAME_CONNECT_DEVICE_ERROR: "@w3m-frame/CONNECT_DEVICE_ERROR",
    FRAME_CONNECT_DEVICE_SUCCESS: "@w3m-frame/CONNECT_DEVICE_SUCCESS",
    FRAME_CONNECT_OTP_SUCCESS: "@w3m-frame/CONNECT_OTP_SUCCESS",
    FRAME_CONNECT_OTP_ERROR: "@w3m-frame/CONNECT_OTP_ERROR",
    FRAME_GET_USER_SUCCESS: "@w3m-frame/GET_USER_SUCCESS",
    FRAME_GET_USER_ERROR: "@w3m-frame/GET_USER_ERROR",
    FRAME_SIGN_OUT_SUCCESS: "@w3m-frame/SIGN_OUT_SUCCESS",
    FRAME_SIGN_OUT_ERROR: "@w3m-frame/SIGN_OUT_ERROR",
    FRAME_IS_CONNECTED_SUCCESS: "@w3m-frame/IS_CONNECTED_SUCCESS",
    FRAME_IS_CONNECTED_ERROR: "@w3m-frame/IS_CONNECTED_ERROR",
    FRAME_GET_CHAIN_ID_SUCCESS: "@w3m-frame/GET_CHAIN_ID_SUCCESS",
    FRAME_GET_CHAIN_ID_ERROR: "@w3m-frame/GET_CHAIN_ID_ERROR",
    FRAME_RPC_REQUEST_SUCCESS: "@w3m-frame/RPC_REQUEST_SUCCESS",
    FRAME_RPC_REQUEST_ERROR: "@w3m-frame/RPC_REQUEST_ERROR",
    FRAME_SESSION_UPDATE: "@w3m-frame/SESSION_UPDATE",
    FRAME_UPDATE_EMAIL_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SUCCESS",
    FRAME_UPDATE_EMAIL_ERROR: "@w3m-frame/UPDATE_EMAIL_ERROR",
    FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS: "@w3m-frame/UPDATE_EMAIL_PRIMARY_OTP_SUCCESS",
    FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR: "@w3m-frame/UPDATE_EMAIL_PRIMARY_OTP_ERROR",
    FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SECONDARY_OTP_SUCCESS",
    FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR: "@w3m-frame/UPDATE_EMAIL_SECONDARY_OTP_ERROR",
    FRAME_SYNC_THEME_SUCCESS: "@w3m-frame/SYNC_THEME_SUCCESS",
    FRAME_SYNC_THEME_ERROR: "@w3m-frame/SYNC_THEME_ERROR",
    FRAME_SYNC_DAPP_DATA_SUCCESS: "@w3m-frame/SYNC_DAPP_DATA_SUCCESS",
    FRAME_SYNC_DAPP_DATA_ERROR: "@w3m-frame/SYNC_DAPP_DATA_ERROR"
};
const $e23d11511a09400f$export$9975694bfb286db = {
    SAFE_RPC_METHODS: [
        "eth_accounts",
        "eth_blockNumber",
        "eth_call",
        "eth_chainId",
        "eth_estimateGas",
        "eth_feeHistory",
        "eth_gasPrice",
        "eth_getAccount",
        "eth_getBalance",
        "eth_getBlockByHash",
        "eth_getBlockByNumber",
        "eth_getBlockReceipts",
        "eth_getBlockTransactionCountByHash",
        "eth_getBlockTransactionCountByNumber",
        "eth_getCode",
        "eth_getFilterChanges",
        "eth_getFilterLogs",
        "eth_getLogs",
        "eth_getProof",
        "eth_getStorageAt",
        "eth_getTransactionByBlockHashAndIndex",
        "eth_getTransactionByBlockNumberAndIndex",
        "eth_getTransactionByHash",
        "eth_getTransactionCount",
        "eth_getTransactionReceipt",
        "eth_getUncleCountByBlockHash",
        "eth_getUncleCountByBlockNumber",
        "eth_maxPriorityFeePerGas",
        "eth_newBlockFilter",
        "eth_newFilter",
        "eth_newPendingTransactionFilter",
        "eth_sendRawTransaction",
        "eth_syncing",
        "eth_uninstallFilter"
    ],
    NOT_SAFE_RPC_METHODS: [
        "personal_sign",
        "eth_signTypedData_v4",
        "eth_sendTransaction"
    ],
    GET_CHAIN_ID: "eth_chainId",
    RPC_METHOD_NOT_ALLOWED_MESSAGE: "Requested RPC call is not allowed",
    RPC_METHOD_NOT_ALLOWED_UI_MESSAGE: "Action not allowed"
};


var $8f21a9d693629cf7$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($8f21a9d693629cf7$export$7debb50ef11d5e0b || ($8f21a9d693629cf7$export$7debb50ef11d5e0b = {}));
var $8f21a9d693629cf7$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($8f21a9d693629cf7$export$4aa2142c225fd5c7 || ($8f21a9d693629cf7$export$4aa2142c225fd5c7 = {}));
const $8f21a9d693629cf7$export$5716da67bfaa244d = $8f21a9d693629cf7$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $8f21a9d693629cf7$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $8f21a9d693629cf7$export$5716da67bfaa244d.undefined;
        case "string":
            return $8f21a9d693629cf7$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $8f21a9d693629cf7$export$5716da67bfaa244d.nan : $8f21a9d693629cf7$export$5716da67bfaa244d.number;
        case "boolean":
            return $8f21a9d693629cf7$export$5716da67bfaa244d.boolean;
        case "function":
            return $8f21a9d693629cf7$export$5716da67bfaa244d.function;
        case "bigint":
            return $8f21a9d693629cf7$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $8f21a9d693629cf7$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $8f21a9d693629cf7$export$5716da67bfaa244d.array;
            if (data === null) return $8f21a9d693629cf7$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $8f21a9d693629cf7$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $8f21a9d693629cf7$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $8f21a9d693629cf7$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $8f21a9d693629cf7$export$5716da67bfaa244d.date;
            return $8f21a9d693629cf7$export$5716da67bfaa244d.object;
        default:
            return $8f21a9d693629cf7$export$5716da67bfaa244d.unknown;
    }
};
const $8f21a9d693629cf7$export$5ba560653e4a1035 = $8f21a9d693629cf7$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $8f21a9d693629cf7$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $8f21a9d693629cf7$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $8f21a9d693629cf7$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$8f21a9d693629cf7$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $8f21a9d693629cf7$export$f98dac4b251ab333(issues);
    return error;
};
const $8f21a9d693629cf7$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $8f21a9d693629cf7$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $8f21a9d693629cf7$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$8f21a9d693629cf7$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$8f21a9d693629cf7$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$8f21a9d693629cf7$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $8f21a9d693629cf7$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $8f21a9d693629cf7$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $8f21a9d693629cf7$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $8f21a9d693629cf7$var$overrideErrorMap = $8f21a9d693629cf7$export$341b0b6e0a6f5099;
function $8f21a9d693629cf7$export$1097a8289cfd22d7(map) {
    $8f21a9d693629cf7$var$overrideErrorMap = map;
}
function $8f21a9d693629cf7$export$32f27c719778d4c4() {
    return $8f21a9d693629cf7$var$overrideErrorMap;
}
const $8f21a9d693629cf7$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $8f21a9d693629cf7$export$1526d2e05f74572 = [];
function $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $8f21a9d693629cf7$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $8f21a9d693629cf7$export$32f27c719778d4c4(),
            $8f21a9d693629cf7$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $8f21a9d693629cf7$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $8f21a9d693629cf7$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $8f21a9d693629cf7$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $8f21a9d693629cf7$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $8f21a9d693629cf7$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $8f21a9d693629cf7$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $8f21a9d693629cf7$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $8f21a9d693629cf7$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $8f21a9d693629cf7$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $8f21a9d693629cf7$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $8f21a9d693629cf7$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $8f21a9d693629cf7$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $8f21a9d693629cf7$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($8f21a9d693629cf7$var$errorUtil || ($8f21a9d693629cf7$var$errorUtil = {}));
class $8f21a9d693629cf7$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $8f21a9d693629cf7$var$handleResult = (ctx, result)=>{
    if ($8f21a9d693629cf7$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $8f21a9d693629cf7$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $8f21a9d693629cf7$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $8f21a9d693629cf7$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $8f21a9d693629cf7$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $8f21a9d693629cf7$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $8f21a9d693629cf7$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $8f21a9d693629cf7$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($8f21a9d693629cf7$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $8f21a9d693629cf7$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $8f21a9d693629cf7$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $8f21a9d693629cf7$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($8f21a9d693629cf7$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $8f21a9d693629cf7$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $8f21a9d693629cf7$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $8f21a9d693629cf7$export$a60af00cc0ce2582({
            schema: this,
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $8f21a9d693629cf7$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $8f21a9d693629cf7$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $8f21a9d693629cf7$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $8f21a9d693629cf7$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $8f21a9d693629cf7$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $8f21a9d693629cf7$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $8f21a9d693629cf7$export$a60af00cc0ce2582({
            ...$8f21a9d693629cf7$var$processCreateParams(this._def),
            schema: this,
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $8f21a9d693629cf7$export$bb19b37874861e7e({
            ...$8f21a9d693629cf7$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $8f21a9d693629cf7$export$66b0c798a395271f({
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$8f21a9d693629cf7$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $8f21a9d693629cf7$export$75a44ec6249ac76b({
            ...$8f21a9d693629cf7$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $8f21a9d693629cf7$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $8f21a9d693629cf7$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $8f21a9d693629cf7$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $8f21a9d693629cf7$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $8f21a9d693629cf7$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $8f21a9d693629cf7$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $8f21a9d693629cf7$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $8f21a9d693629cf7$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $8f21a9d693629cf7$var$emojiRegex;
const $8f21a9d693629cf7$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $8f21a9d693629cf7$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $8f21a9d693629cf7$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $8f21a9d693629cf7$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $8f21a9d693629cf7$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $8f21a9d693629cf7$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $8f21a9d693629cf7$export$1230eb29b8d3b502 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        const status = new $8f21a9d693629cf7$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$8f21a9d693629cf7$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$8f21a9d693629cf7$var$emojiRegex) $8f21a9d693629cf7$var$emojiRegex = new RegExp($8f21a9d693629cf7$var$_emojiRegex, "u");
                if (!$8f21a9d693629cf7$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$8f21a9d693629cf7$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$8f21a9d693629cf7$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$8f21a9d693629cf7$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$8f21a9d693629cf7$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $8f21a9d693629cf7$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$8f21a9d693629cf7$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8f21a9d693629cf7$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_string,
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $8f21a9d693629cf7$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$8f21a9d693629cf7$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $8f21a9d693629cf7$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $8f21a9d693629cf7$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $8f21a9d693629cf7$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $8f21a9d693629cf7$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$8f21a9d693629cf7$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $8f21a9d693629cf7$export$1230eb29b8d3b502({
        checks: [],
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $8f21a9d693629cf7$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $8f21a9d693629cf7$export$5b070a55c0c43e09 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $8f21a9d693629cf7$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$8f21a9d693629cf7$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($8f21a9d693629cf7$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8f21a9d693629cf7$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $8f21a9d693629cf7$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $8f21a9d693629cf7$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $8f21a9d693629cf7$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $8f21a9d693629cf7$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $8f21a9d693629cf7$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $8f21a9d693629cf7$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $8f21a9d693629cf7$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $8f21a9d693629cf7$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$8f21a9d693629cf7$export$5b070a55c0c43e09.create = (params)=>{
    return new $8f21a9d693629cf7$export$5b070a55c0c43e09({
        checks: [],
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$67d741fd70ff98f4 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $8f21a9d693629cf7$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8f21a9d693629cf7$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $8f21a9d693629cf7$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $8f21a9d693629cf7$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $8f21a9d693629cf7$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $8f21a9d693629cf7$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $8f21a9d693629cf7$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $8f21a9d693629cf7$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $8f21a9d693629cf7$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$8f21a9d693629cf7$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $8f21a9d693629cf7$export$67d741fd70ff98f4({
        checks: [],
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$723d146f80596191 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        return $8f21a9d693629cf7$export$c6813a8d51f77eaf(input.data);
    }
}
$8f21a9d693629cf7$export$723d146f80596191.create = (params)=>{
    return new $8f21a9d693629cf7$export$723d146f80596191({
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$e974be33bdc55521 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_date
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        const status = new $8f21a9d693629cf7$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $8f21a9d693629cf7$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $8f21a9d693629cf7$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $8f21a9d693629cf7$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$8f21a9d693629cf7$export$e974be33bdc55521.create = (params)=>{
    return new $8f21a9d693629cf7$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodDate,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$bcc3b40f6b638044 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        return $8f21a9d693629cf7$export$c6813a8d51f77eaf(input.data);
    }
}
$8f21a9d693629cf7$export$bcc3b40f6b638044.create = (params)=>{
    return new $8f21a9d693629cf7$export$bcc3b40f6b638044({
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodSymbol,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$4e780e961c30340d extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        return $8f21a9d693629cf7$export$c6813a8d51f77eaf(input.data);
    }
}
$8f21a9d693629cf7$export$4e780e961c30340d.create = (params)=>{
    return new $8f21a9d693629cf7$export$4e780e961c30340d({
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodUndefined,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$a96281f914484f2d extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        return $8f21a9d693629cf7$export$c6813a8d51f77eaf(input.data);
    }
}
$8f21a9d693629cf7$export$a96281f914484f2d.create = (params)=>{
    return new $8f21a9d693629cf7$export$a96281f914484f2d({
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodNull,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$b9d1edb536b4e4eb extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $8f21a9d693629cf7$export$c6813a8d51f77eaf(input.data);
    }
}
$8f21a9d693629cf7$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $8f21a9d693629cf7$export$b9d1edb536b4e4eb({
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodAny,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$ef3b1bb1630977ae extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $8f21a9d693629cf7$export$c6813a8d51f77eaf(input.data);
    }
}
$8f21a9d693629cf7$export$ef3b1bb1630977ae.create = (params)=>{
    return new $8f21a9d693629cf7$export$ef3b1bb1630977ae({
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodUnknown,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$1e576a20c3ce9fb5 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
            code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
            expected: $8f21a9d693629cf7$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $8f21a9d693629cf7$export$9a105a556e65c2c0;
    }
}
$8f21a9d693629cf7$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $8f21a9d693629cf7$export$1e576a20c3ce9fb5({
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodNever,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$7d39f5df85f21031 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        return $8f21a9d693629cf7$export$c6813a8d51f77eaf(input.data);
    }
}
$8f21a9d693629cf7$export$7d39f5df85f21031.create = (params)=>{
    return new $8f21a9d693629cf7$export$7d39f5df85f21031({
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodVoid,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$7acfc3e64785411 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.array) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $8f21a9d693629cf7$export$5ba560653e4a1035.too_big : $8f21a9d693629cf7$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                    code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                    code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $8f21a9d693629cf7$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $8f21a9d693629cf7$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $8f21a9d693629cf7$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $8f21a9d693629cf7$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $8f21a9d693629cf7$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $8f21a9d693629cf7$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $8f21a9d693629cf7$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $8f21a9d693629cf7$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $8f21a9d693629cf7$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $8f21a9d693629cf7$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$8f21a9d693629cf7$export$7acfc3e64785411.create = (schema, params)=>{
    return new $8f21a9d693629cf7$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodArray,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
function $8f21a9d693629cf7$var$deepPartialify(schema) {
    if (schema instanceof $8f21a9d693629cf7$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $8f21a9d693629cf7$export$aa56fec1e9d629b8.create($8f21a9d693629cf7$var$deepPartialify(fieldSchema));
        }
        return new $8f21a9d693629cf7$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $8f21a9d693629cf7$export$7acfc3e64785411) return new $8f21a9d693629cf7$export$7acfc3e64785411({
        ...schema._def,
        type: $8f21a9d693629cf7$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $8f21a9d693629cf7$export$aa56fec1e9d629b8) return $8f21a9d693629cf7$export$aa56fec1e9d629b8.create($8f21a9d693629cf7$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $8f21a9d693629cf7$export$aaac0b8b429cef5) return $8f21a9d693629cf7$export$aaac0b8b429cef5.create($8f21a9d693629cf7$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $8f21a9d693629cf7$export$e2a18bb771d8e6a3) return $8f21a9d693629cf7$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$8f21a9d693629cf7$var$deepPartialify(item)));
    else return schema;
}
class $8f21a9d693629cf7$export$736315c5b55efbad extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $8f21a9d693629cf7$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $8f21a9d693629cf7$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $8f21a9d693629cf7$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $8f21a9d693629cf7$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                        code: $8f21a9d693629cf7$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $8f21a9d693629cf7$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $8f21a9d693629cf7$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $8f21a9d693629cf7$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $8f21a9d693629cf7$var$errorUtil.errToObj;
        return new $8f21a9d693629cf7$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $8f21a9d693629cf7$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $8f21a9d693629cf7$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $8f21a9d693629cf7$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $8f21a9d693629cf7$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $8f21a9d693629cf7$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $8f21a9d693629cf7$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $8f21a9d693629cf7$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $8f21a9d693629cf7$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $8f21a9d693629cf7$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $8f21a9d693629cf7$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $8f21a9d693629cf7$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $8f21a9d693629cf7$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $8f21a9d693629cf7$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $8f21a9d693629cf7$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $8f21a9d693629cf7$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $8f21a9d693629cf7$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $8f21a9d693629cf7$var$createZodEnum($8f21a9d693629cf7$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$8f21a9d693629cf7$export$736315c5b55efbad.create = (shape, params)=>{
    return new $8f21a9d693629cf7$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $8f21a9d693629cf7$export$1e576a20c3ce9fb5.create(),
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodObject,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
$8f21a9d693629cf7$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $8f21a9d693629cf7$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $8f21a9d693629cf7$export$1e576a20c3ce9fb5.create(),
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodObject,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
$8f21a9d693629cf7$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $8f21a9d693629cf7$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $8f21a9d693629cf7$export$1e576a20c3ce9fb5.create(),
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodObject,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$a8b236cb5070a311 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $8f21a9d693629cf7$export$f98dac4b251ab333(result.ctx.common.issues));
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $8f21a9d693629cf7$export$f98dac4b251ab333(issues));
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$8f21a9d693629cf7$export$a8b236cb5070a311.create = (types, params)=>{
    return new $8f21a9d693629cf7$export$a8b236cb5070a311({
        options: types,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodUnion,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $8f21a9d693629cf7$var$getDiscriminator = (type)=>{
    if (type instanceof $8f21a9d693629cf7$export$378d0cfce37406e6) return $8f21a9d693629cf7$var$getDiscriminator(type.schema);
    else if (type instanceof $8f21a9d693629cf7$export$a60af00cc0ce2582) return $8f21a9d693629cf7$var$getDiscriminator(type.innerType());
    else if (type instanceof $8f21a9d693629cf7$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $8f21a9d693629cf7$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $8f21a9d693629cf7$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $8f21a9d693629cf7$export$bb19b37874861e7e) return $8f21a9d693629cf7$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $8f21a9d693629cf7$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $8f21a9d693629cf7$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $8f21a9d693629cf7$export$5ef2424805ac76a3 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.object) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $8f21a9d693629cf7$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $8f21a9d693629cf7$export$5ef2424805ac76a3({
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$8f21a9d693629cf7$var$processCreateParams(params)
        });
    }
}
function $8f21a9d693629cf7$var$mergeValues(a, b) {
    const aType = $8f21a9d693629cf7$export$3e9057828ebd5c7a(a);
    const bType = $8f21a9d693629cf7$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $8f21a9d693629cf7$export$5716da67bfaa244d.object && bType === $8f21a9d693629cf7$export$5716da67bfaa244d.object) {
        const bKeys = $8f21a9d693629cf7$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $8f21a9d693629cf7$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $8f21a9d693629cf7$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $8f21a9d693629cf7$export$5716da67bfaa244d.array && bType === $8f21a9d693629cf7$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $8f21a9d693629cf7$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $8f21a9d693629cf7$export$5716da67bfaa244d.date && bType === $8f21a9d693629cf7$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $8f21a9d693629cf7$export$c02deaf0bb5203d4 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($8f21a9d693629cf7$export$afa861e3c5730743(parsedLeft) || $8f21a9d693629cf7$export$afa861e3c5730743(parsedRight)) return $8f21a9d693629cf7$export$9a105a556e65c2c0;
            const merged = $8f21a9d693629cf7$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                    code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $8f21a9d693629cf7$export$9a105a556e65c2c0;
            }
            if ($8f21a9d693629cf7$export$910b6cdd390341b3(parsedLeft) || $8f21a9d693629cf7$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$8f21a9d693629cf7$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $8f21a9d693629cf7$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodIntersection,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$e2a18bb771d8e6a3 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.array) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $8f21a9d693629cf7$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $8f21a9d693629cf7$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $8f21a9d693629cf7$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $8f21a9d693629cf7$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$8f21a9d693629cf7$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $8f21a9d693629cf7$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$a2acc09968cb4b7f extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.object) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $8f21a9d693629cf7$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $8f21a9d693629cf7$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $8f21a9d693629cf7$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $8f21a9d693629cf7$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $8f21a9d693629cf7$export$19342e026b58ebb7) return new $8f21a9d693629cf7$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodRecord,
            ...$8f21a9d693629cf7$var$processCreateParams(third)
        });
        return new $8f21a9d693629cf7$export$a2acc09968cb4b7f({
            keyType: $8f21a9d693629cf7$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodRecord,
            ...$8f21a9d693629cf7$var$processCreateParams(second)
        });
    }
}
class $8f21a9d693629cf7$export$163b6a2b712d9542 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.map) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $8f21a9d693629cf7$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $8f21a9d693629cf7$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $8f21a9d693629cf7$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $8f21a9d693629cf7$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$8f21a9d693629cf7$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $8f21a9d693629cf7$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodMap,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$977057706f816712 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.set) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                    code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                    code: $8f21a9d693629cf7$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $8f21a9d693629cf7$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $8f21a9d693629cf7$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $8f21a9d693629cf7$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $8f21a9d693629cf7$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $8f21a9d693629cf7$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $8f21a9d693629cf7$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$8f21a9d693629cf7$export$977057706f816712.create = (valueType, params)=>{
    return new $8f21a9d693629cf7$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodSet,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$d4602ba55673f53c extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.function) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $8f21a9d693629cf7$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $8f21a9d693629cf7$export$32f27c719778d4c4(),
                    $8f21a9d693629cf7$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $8f21a9d693629cf7$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $8f21a9d693629cf7$export$32f27c719778d4c4(),
                    $8f21a9d693629cf7$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $8f21a9d693629cf7$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $8f21a9d693629cf7$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $8f21a9d693629cf7$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $8f21a9d693629cf7$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $8f21a9d693629cf7$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $8f21a9d693629cf7$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $8f21a9d693629cf7$export$d4602ba55673f53c({
            ...this._def,
            args: $8f21a9d693629cf7$export$e2a18bb771d8e6a3.create(items).rest($8f21a9d693629cf7$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $8f21a9d693629cf7$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $8f21a9d693629cf7$export$d4602ba55673f53c({
            args: args ? args : $8f21a9d693629cf7$export$e2a18bb771d8e6a3.create([]).rest($8f21a9d693629cf7$export$ef3b1bb1630977ae.create()),
            returns: returns || $8f21a9d693629cf7$export$ef3b1bb1630977ae.create(),
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodFunction,
            ...$8f21a9d693629cf7$var$processCreateParams(params)
        });
    }
}
class $8f21a9d693629cf7$export$378d0cfce37406e6 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$8f21a9d693629cf7$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $8f21a9d693629cf7$export$378d0cfce37406e6({
        getter: getter,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodLazy,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$7e44096782a165d3 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$8f21a9d693629cf7$export$7e44096782a165d3.create = (value, params)=>{
    return new $8f21a9d693629cf7$export$7e44096782a165d3({
        value: value,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodLiteral,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
function $8f21a9d693629cf7$var$createZodEnum(values, params) {
    return new $8f21a9d693629cf7$export$d325d1f0e1c20179({
        values: values,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodEnum,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
}
class $8f21a9d693629cf7$export$d325d1f0e1c20179 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                expected: $8f21a9d693629cf7$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        return $8f21a9d693629cf7$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $8f21a9d693629cf7$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $8f21a9d693629cf7$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$8f21a9d693629cf7$export$d325d1f0e1c20179.create = $8f21a9d693629cf7$var$createZodEnum;
class $8f21a9d693629cf7$export$370b2e8d6d6f5c56 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $8f21a9d693629cf7$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.string && ctx.parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.number) {
            const expectedValues = $8f21a9d693629cf7$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                expected: $8f21a9d693629cf7$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $8f21a9d693629cf7$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        return $8f21a9d693629cf7$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$8f21a9d693629cf7$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $8f21a9d693629cf7$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodNativeEnum,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$3f196b0127d6e50a extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $8f21a9d693629cf7$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $8f21a9d693629cf7$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$8f21a9d693629cf7$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $8f21a9d693629cf7$export$3f196b0127d6e50a({
        type: schema,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodPromise,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$a60af00cc0ce2582 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $8f21a9d693629cf7$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $8f21a9d693629cf7$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $8f21a9d693629cf7$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$8f21a9d693629cf7$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$8f21a9d693629cf7$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $8f21a9d693629cf7$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$8f21a9d693629cf7$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $8f21a9d693629cf7$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
$8f21a9d693629cf7$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $8f21a9d693629cf7$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodEffects,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$aa56fec1e9d629b8 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $8f21a9d693629cf7$export$5716da67bfaa244d.undefined) return $8f21a9d693629cf7$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8f21a9d693629cf7$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $8f21a9d693629cf7$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodOptional,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$aaac0b8b429cef5 extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $8f21a9d693629cf7$export$5716da67bfaa244d.null) return $8f21a9d693629cf7$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8f21a9d693629cf7$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $8f21a9d693629cf7$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodNullable,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$bb19b37874861e7e extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $8f21a9d693629cf7$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$8f21a9d693629cf7$export$bb19b37874861e7e.create = (type, params)=>{
    return new $8f21a9d693629cf7$export$bb19b37874861e7e({
        innerType: type,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$75a44ec6249ac76b extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($8f21a9d693629cf7$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $8f21a9d693629cf7$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $8f21a9d693629cf7$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$8f21a9d693629cf7$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $8f21a9d693629cf7$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
class $8f21a9d693629cf7$export$26ccfa0145e8511f extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8f21a9d693629cf7$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $8f21a9d693629cf7$export$db7caee60e5d514d(ctx, {
                code: $8f21a9d693629cf7$export$5ba560653e4a1035.invalid_type,
                expected: $8f21a9d693629cf7$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $8f21a9d693629cf7$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$8f21a9d693629cf7$export$26ccfa0145e8511f.create = (params)=>{
    return new $8f21a9d693629cf7$export$26ccfa0145e8511f({
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodNaN,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
const $8f21a9d693629cf7$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $8f21a9d693629cf7$export$66b0c798a395271f extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $8f21a9d693629cf7$export$a3c3ef8a0e95c6da extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $8f21a9d693629cf7$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $8f21a9d693629cf7$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $8f21a9d693629cf7$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $8f21a9d693629cf7$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $8f21a9d693629cf7$export$5d1f7ef05c4e493a extends $8f21a9d693629cf7$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($8f21a9d693629cf7$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$8f21a9d693629cf7$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $8f21a9d693629cf7$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $8f21a9d693629cf7$export$558106ce543bd011.ZodReadonly,
        ...$8f21a9d693629cf7$var$processCreateParams(params)
    });
};
const $8f21a9d693629cf7$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $8f21a9d693629cf7$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $8f21a9d693629cf7$export$b9d1edb536b4e4eb.create();
};
const $8f21a9d693629cf7$export$1ee8ee30835eab8b = {
    object: $8f21a9d693629cf7$export$736315c5b55efbad.lazycreate
};
var $8f21a9d693629cf7$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($8f21a9d693629cf7$export$558106ce543bd011 || ($8f21a9d693629cf7$export$558106ce543bd011 = {}));
const $8f21a9d693629cf7$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$8f21a9d693629cf7$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $8f21a9d693629cf7$export$22b082955e083ec3 = $8f21a9d693629cf7$export$1230eb29b8d3b502.create;
const $8f21a9d693629cf7$export$98e628dec113755e = $8f21a9d693629cf7$export$5b070a55c0c43e09.create;
const $8f21a9d693629cf7$export$9e06de0973666692 = $8f21a9d693629cf7$export$26ccfa0145e8511f.create;
const $8f21a9d693629cf7$export$a0f65b52274bcc00 = $8f21a9d693629cf7$export$67d741fd70ff98f4.create;
const $8f21a9d693629cf7$export$4a21f16c33752377 = $8f21a9d693629cf7$export$723d146f80596191.create;
const $8f21a9d693629cf7$export$324d90190a8b822a = $8f21a9d693629cf7$export$e974be33bdc55521.create;
const $8f21a9d693629cf7$export$8f701197936bc2a6 = $8f21a9d693629cf7$export$bcc3b40f6b638044.create;
const $8f21a9d693629cf7$export$1db45310990710a5 = $8f21a9d693629cf7$export$4e780e961c30340d.create;
const $8f21a9d693629cf7$export$7b1b591b262c240 = $8f21a9d693629cf7$export$a96281f914484f2d.create;
const $8f21a9d693629cf7$export$4154a199d7d90455 = $8f21a9d693629cf7$export$b9d1edb536b4e4eb.create;
const $8f21a9d693629cf7$export$19282c40b967aec6 = $8f21a9d693629cf7$export$ef3b1bb1630977ae.create;
const $8f21a9d693629cf7$export$b3e22bcfd64c1022 = $8f21a9d693629cf7$export$1e576a20c3ce9fb5.create;
const $8f21a9d693629cf7$export$490e536ee7389aeb = $8f21a9d693629cf7$export$7d39f5df85f21031.create;
const $8f21a9d693629cf7$export$2f23118c22fb2630 = $8f21a9d693629cf7$export$7acfc3e64785411.create;
const $8f21a9d693629cf7$export$be5493f9613cbbe = $8f21a9d693629cf7$export$736315c5b55efbad.create;
const $8f21a9d693629cf7$export$8fb0df5f40d0b477 = $8f21a9d693629cf7$export$736315c5b55efbad.strictCreate;
const $8f21a9d693629cf7$export$971dd5b0dfd021b6 = $8f21a9d693629cf7$export$a8b236cb5070a311.create;
const $8f21a9d693629cf7$export$4b888e40c4ee26dd = $8f21a9d693629cf7$export$5ef2424805ac76a3.create;
const $8f21a9d693629cf7$export$bc86dfbf7795668c = $8f21a9d693629cf7$export$c02deaf0bb5203d4.create;
const $8f21a9d693629cf7$export$65e3907585753458 = $8f21a9d693629cf7$export$e2a18bb771d8e6a3.create;
const $8f21a9d693629cf7$export$e5185e241753e543 = $8f21a9d693629cf7$export$a2acc09968cb4b7f.create;
const $8f21a9d693629cf7$export$871de8747c9eaa88 = $8f21a9d693629cf7$export$163b6a2b712d9542.create;
const $8f21a9d693629cf7$export$adaa4cf7ef1b65be = $8f21a9d693629cf7$export$977057706f816712.create;
const $8f21a9d693629cf7$export$44e51c8aac7c2deb = $8f21a9d693629cf7$export$d4602ba55673f53c.create;
const $8f21a9d693629cf7$export$488013bae63b21da = $8f21a9d693629cf7$export$378d0cfce37406e6.create;
const $8f21a9d693629cf7$export$c8ec6e1ec9fefcb0 = $8f21a9d693629cf7$export$7e44096782a165d3.create;
const $8f21a9d693629cf7$export$78a99c8d44d72635 = $8f21a9d693629cf7$export$d325d1f0e1c20179.create;
const $8f21a9d693629cf7$export$6fe7eca19ebe5199 = $8f21a9d693629cf7$export$370b2e8d6d6f5c56.create;
const $8f21a9d693629cf7$export$c957ef27a0ebfd4 = $8f21a9d693629cf7$export$3f196b0127d6e50a.create;
const $8f21a9d693629cf7$export$dc573d8a6576cdb3 = $8f21a9d693629cf7$export$a60af00cc0ce2582.create;
const $8f21a9d693629cf7$export$516e28dec6a4b6d4 = $8f21a9d693629cf7$export$aa56fec1e9d629b8.create;
const $8f21a9d693629cf7$export$133fc36489ac9add = $8f21a9d693629cf7$export$aaac0b8b429cef5.create;
const $8f21a9d693629cf7$export$fc37fe19dfda43ee = $8f21a9d693629cf7$export$a60af00cc0ce2582.createWithPreprocess;
const $8f21a9d693629cf7$export$43f28b24e1eb8181 = $8f21a9d693629cf7$export$a3c3ef8a0e95c6da.create;
const $8f21a9d693629cf7$export$3b3d07727c5b702c = ()=>$8f21a9d693629cf7$export$22b082955e083ec3().optional();
const $8f21a9d693629cf7$export$eb150471a61fced6 = ()=>$8f21a9d693629cf7$export$98e628dec113755e().optional();
const $8f21a9d693629cf7$export$269251733cdcbbf1 = ()=>$8f21a9d693629cf7$export$4a21f16c33752377().optional();
const $8f21a9d693629cf7$export$8c14e57e778d3873 = {
    string: (arg)=>$8f21a9d693629cf7$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$8f21a9d693629cf7$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$8f21a9d693629cf7$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$8f21a9d693629cf7$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$8f21a9d693629cf7$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $8f21a9d693629cf7$export$96c94437c95d7862 = $8f21a9d693629cf7$export$9a105a556e65c2c0;
var $8f21a9d693629cf7$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $8f21a9d693629cf7$export$341b0b6e0a6f5099,
    setErrorMap: $8f21a9d693629cf7$export$1097a8289cfd22d7,
    getErrorMap: $8f21a9d693629cf7$export$32f27c719778d4c4,
    makeIssue: $8f21a9d693629cf7$export$244a85fde9c419ed,
    EMPTY_PATH: $8f21a9d693629cf7$export$1526d2e05f74572,
    addIssueToContext: $8f21a9d693629cf7$export$db7caee60e5d514d,
    ParseStatus: $8f21a9d693629cf7$export$5b20a5c3d05c1f6f,
    INVALID: $8f21a9d693629cf7$export$9a105a556e65c2c0,
    DIRTY: $8f21a9d693629cf7$export$325a211da9693fcf,
    OK: $8f21a9d693629cf7$export$c6813a8d51f77eaf,
    isAborted: $8f21a9d693629cf7$export$afa861e3c5730743,
    isDirty: $8f21a9d693629cf7$export$910b6cdd390341b3,
    isValid: $8f21a9d693629cf7$export$1ea939691cdc45b8,
    isAsync: $8f21a9d693629cf7$export$aefee5ebe1dcfd9e,
    get util () {
        return $8f21a9d693629cf7$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $8f21a9d693629cf7$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $8f21a9d693629cf7$export$5716da67bfaa244d,
    getParsedType: $8f21a9d693629cf7$export$3e9057828ebd5c7a,
    ZodType: $8f21a9d693629cf7$export$19342e026b58ebb7,
    ZodString: $8f21a9d693629cf7$export$1230eb29b8d3b502,
    ZodNumber: $8f21a9d693629cf7$export$5b070a55c0c43e09,
    ZodBigInt: $8f21a9d693629cf7$export$67d741fd70ff98f4,
    ZodBoolean: $8f21a9d693629cf7$export$723d146f80596191,
    ZodDate: $8f21a9d693629cf7$export$e974be33bdc55521,
    ZodSymbol: $8f21a9d693629cf7$export$bcc3b40f6b638044,
    ZodUndefined: $8f21a9d693629cf7$export$4e780e961c30340d,
    ZodNull: $8f21a9d693629cf7$export$a96281f914484f2d,
    ZodAny: $8f21a9d693629cf7$export$b9d1edb536b4e4eb,
    ZodUnknown: $8f21a9d693629cf7$export$ef3b1bb1630977ae,
    ZodNever: $8f21a9d693629cf7$export$1e576a20c3ce9fb5,
    ZodVoid: $8f21a9d693629cf7$export$7d39f5df85f21031,
    ZodArray: $8f21a9d693629cf7$export$7acfc3e64785411,
    ZodObject: $8f21a9d693629cf7$export$736315c5b55efbad,
    ZodUnion: $8f21a9d693629cf7$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $8f21a9d693629cf7$export$5ef2424805ac76a3,
    ZodIntersection: $8f21a9d693629cf7$export$c02deaf0bb5203d4,
    ZodTuple: $8f21a9d693629cf7$export$e2a18bb771d8e6a3,
    ZodRecord: $8f21a9d693629cf7$export$a2acc09968cb4b7f,
    ZodMap: $8f21a9d693629cf7$export$163b6a2b712d9542,
    ZodSet: $8f21a9d693629cf7$export$977057706f816712,
    ZodFunction: $8f21a9d693629cf7$export$d4602ba55673f53c,
    ZodLazy: $8f21a9d693629cf7$export$378d0cfce37406e6,
    ZodLiteral: $8f21a9d693629cf7$export$7e44096782a165d3,
    ZodEnum: $8f21a9d693629cf7$export$d325d1f0e1c20179,
    ZodNativeEnum: $8f21a9d693629cf7$export$370b2e8d6d6f5c56,
    ZodPromise: $8f21a9d693629cf7$export$3f196b0127d6e50a,
    ZodEffects: $8f21a9d693629cf7$export$a60af00cc0ce2582,
    ZodTransformer: $8f21a9d693629cf7$export$a60af00cc0ce2582,
    ZodOptional: $8f21a9d693629cf7$export$aa56fec1e9d629b8,
    ZodNullable: $8f21a9d693629cf7$export$aaac0b8b429cef5,
    ZodDefault: $8f21a9d693629cf7$export$bb19b37874861e7e,
    ZodCatch: $8f21a9d693629cf7$export$75a44ec6249ac76b,
    ZodNaN: $8f21a9d693629cf7$export$26ccfa0145e8511f,
    BRAND: $8f21a9d693629cf7$export$cf2deea74cde46b4,
    ZodBranded: $8f21a9d693629cf7$export$66b0c798a395271f,
    ZodPipeline: $8f21a9d693629cf7$export$a3c3ef8a0e95c6da,
    ZodReadonly: $8f21a9d693629cf7$export$5d1f7ef05c4e493a,
    custom: $8f21a9d693629cf7$export$4c00f665f0d4b443,
    Schema: $8f21a9d693629cf7$export$19342e026b58ebb7,
    ZodSchema: $8f21a9d693629cf7$export$19342e026b58ebb7,
    late: $8f21a9d693629cf7$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $8f21a9d693629cf7$export$558106ce543bd011;
    },
    coerce: $8f21a9d693629cf7$export$8c14e57e778d3873,
    any: $8f21a9d693629cf7$export$4154a199d7d90455,
    array: $8f21a9d693629cf7$export$2f23118c22fb2630,
    bigint: $8f21a9d693629cf7$export$a0f65b52274bcc00,
    boolean: $8f21a9d693629cf7$export$4a21f16c33752377,
    date: $8f21a9d693629cf7$export$324d90190a8b822a,
    discriminatedUnion: $8f21a9d693629cf7$export$4b888e40c4ee26dd,
    effect: $8f21a9d693629cf7$export$dc573d8a6576cdb3,
    "enum": $8f21a9d693629cf7$export$78a99c8d44d72635,
    "function": $8f21a9d693629cf7$export$44e51c8aac7c2deb,
    "instanceof": $8f21a9d693629cf7$export$3d916e7c22dbd8b5,
    intersection: $8f21a9d693629cf7$export$bc86dfbf7795668c,
    lazy: $8f21a9d693629cf7$export$488013bae63b21da,
    literal: $8f21a9d693629cf7$export$c8ec6e1ec9fefcb0,
    map: $8f21a9d693629cf7$export$871de8747c9eaa88,
    nan: $8f21a9d693629cf7$export$9e06de0973666692,
    nativeEnum: $8f21a9d693629cf7$export$6fe7eca19ebe5199,
    never: $8f21a9d693629cf7$export$b3e22bcfd64c1022,
    "null": $8f21a9d693629cf7$export$7b1b591b262c240,
    nullable: $8f21a9d693629cf7$export$133fc36489ac9add,
    number: $8f21a9d693629cf7$export$98e628dec113755e,
    object: $8f21a9d693629cf7$export$be5493f9613cbbe,
    oboolean: $8f21a9d693629cf7$export$269251733cdcbbf1,
    onumber: $8f21a9d693629cf7$export$eb150471a61fced6,
    optional: $8f21a9d693629cf7$export$516e28dec6a4b6d4,
    ostring: $8f21a9d693629cf7$export$3b3d07727c5b702c,
    pipeline: $8f21a9d693629cf7$export$43f28b24e1eb8181,
    preprocess: $8f21a9d693629cf7$export$fc37fe19dfda43ee,
    promise: $8f21a9d693629cf7$export$c957ef27a0ebfd4,
    record: $8f21a9d693629cf7$export$e5185e241753e543,
    set: $8f21a9d693629cf7$export$adaa4cf7ef1b65be,
    strictObject: $8f21a9d693629cf7$export$8fb0df5f40d0b477,
    string: $8f21a9d693629cf7$export$22b082955e083ec3,
    symbol: $8f21a9d693629cf7$export$8f701197936bc2a6,
    transformer: $8f21a9d693629cf7$export$dc573d8a6576cdb3,
    tuple: $8f21a9d693629cf7$export$65e3907585753458,
    "undefined": $8f21a9d693629cf7$export$1db45310990710a5,
    union: $8f21a9d693629cf7$export$971dd5b0dfd021b6,
    unknown: $8f21a9d693629cf7$export$19282c40b967aec6,
    "void": $8f21a9d693629cf7$export$490e536ee7389aeb,
    NEVER: $8f21a9d693629cf7$export$96c94437c95d7862,
    ZodIssueCode: $8f21a9d693629cf7$export$5ba560653e4a1035,
    quotelessJson: $8f21a9d693629cf7$export$913eddeaf297cfea,
    ZodError: $8f21a9d693629cf7$export$f98dac4b251ab333
});



const $471ff018cf1b0d4d$var$zError = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    message: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string()
});
function $471ff018cf1b0d4d$var$zType(key) {
    return (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal((0, $e23d11511a09400f$export$3ff97a7390ed49be)[key]);
}
const $471ff018cf1b0d4d$export$89415e8e09b5a4e0 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    accessList: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string()),
    blockHash: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string().nullable(),
    blockNumber: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string().nullable(),
    chainId: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    from: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    gas: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    hash: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    input: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string().nullable(),
    maxFeePerGas: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    maxPriorityFeePerGas: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    nonce: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    r: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    s: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    to: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    transactionIndex: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string().nullable(),
    type: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    v: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    value: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string()
});
const $471ff018cf1b0d4d$export$6f296c19518f2ab2 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    chainId: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).number()
});
const $471ff018cf1b0d4d$export$976f191ce42ce5be = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    email: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string().email()
});
const $471ff018cf1b0d4d$export$3c60c26d0e7c7485 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    otp: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string()
});
const $471ff018cf1b0d4d$export$2b55edadc32e688a = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    chainId: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).optional((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).number())
});
const $471ff018cf1b0d4d$export$65e6e56482b6df27 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    email: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string().email()
});
const $471ff018cf1b0d4d$export$63ec130352b88085 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    otp: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string()
});
const $471ff018cf1b0d4d$export$cbb50d2392bf53e2 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    otp: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string()
});
const $471ff018cf1b0d4d$export$c523bb85fd166f04 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    themeMode: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).optional((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).enum([
        "light",
        "dark"
    ])),
    themeVariables: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).optional((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).record((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(), (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string().or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).number())))
});
const $471ff018cf1b0d4d$export$4ca9ea890e921270 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    metadata: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        name: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
        description: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
        url: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
        icons: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string())
    }).optional(),
    sdkVersion: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    projectId: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string()
});
const $471ff018cf1b0d4d$export$3fc5153b9dd73fc1 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    jwt: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string()
});
const $471ff018cf1b0d4d$export$333a7bf9d10b914 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    action: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).enum([
        "VERIFY_DEVICE",
        "VERIFY_OTP"
    ])
});
const $471ff018cf1b0d4d$export$2d6662dda0084b61 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    email: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string().email(),
    address: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string(),
    chainId: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).number()
});
const $471ff018cf1b0d4d$export$775a450ce21f8fdf = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    isConnected: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).boolean()
});
const $471ff018cf1b0d4d$export$245abc04f43df573 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    chainId: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).number()
});
const $471ff018cf1b0d4d$export$178941fe9bfa6200 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    chainId: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).number()
});
const $471ff018cf1b0d4d$export$bb05e12b7f21caf1 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    newEmail: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string().email()
});
const $471ff018cf1b0d4d$export$d4ce1c0118069cf6 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any();
const $471ff018cf1b0d4d$export$333c606c26a06359 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_accounts")
});
const $471ff018cf1b0d4d$export$ed481a6ef87fb1a4 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_blockNumber")
});
const $471ff018cf1b0d4d$export$3746f30d5256aebc = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_call"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$ced6b8fef5e3a1ae = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_chainId")
});
const $471ff018cf1b0d4d$export$272161a7d614a7de = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_estimateGas"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$601d25f8f10fb73e = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_feeHistory"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$375f72aea2abe32f = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_gasPrice")
});
const $471ff018cf1b0d4d$export$5781e194c9800107 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getAccount"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$e8c54d0244516318 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getBalance"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$ed296586d8ca73e5 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getBlockByHash"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$5930d1a65f85cd1c = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getBlockByNumber"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$728754e9b5ce598 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getBlockReceipts"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$4ddab575d344fe47 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getBlockTransactionCountByHash"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$3a9707a1a95b758c = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getBlockTransactionCountByNumber"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$32d3decd99b4e77c = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getCode"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$70385be35bb1c094 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getFilterChanges"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$67adfcd98750c2a4 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getFilterLogs"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$ec85b0f99f3b0860 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getLogs"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$aad1bb370c749036 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getProof"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$de118eb57c7e99ee = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getStorageAt"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$925a4185b30091ca = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getTransactionByBlockHashAndIndex"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$132e327b9ac8100f = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getTransactionByBlockNumberAndIndex"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$b498be03499c3270 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getTransactionByHash"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$8e3ae636de98a13f = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getTransactionCount"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$ebf4091cc6dfa2ef = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getTransactionReceipt"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$a9e565a5951dbda1 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getUncleCountByBlockHash"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$3e72b948c8cdb33b = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_getUncleCountByBlockNumber"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$35da6e194885ea4f = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_maxPriorityFeePerGas")
});
const $471ff018cf1b0d4d$export$f2d7c90f3596d13e = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_newBlockFilter")
});
const $471ff018cf1b0d4d$export$f6ccc436669a288e = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_newFilter"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$299d889501e7632c = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_newPendingTransactionFilter")
});
const $471ff018cf1b0d4d$export$2f01b91caa317491 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_sendRawTransaction"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$688f7a1e4924e71b = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_syncing"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$1cc394e8ef03e09a = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_uninstallFilter"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$57dc995d18380851 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("personal_sign"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$98d6e3ae5e5869d0 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_signTypedData_v4"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$fc4f4bb7f991c8e0 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    method: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).literal("eth_sendTransaction"),
    params: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).array((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).any())
});
const $471ff018cf1b0d4d$export$583fad842749c757 = (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
    token: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).string()
});
const $471ff018cf1b0d4d$export$238f9986c2bb1b9a = {
    appEvent: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_SWITCH_NETWORK"),
        payload: $471ff018cf1b0d4d$export$6f296c19518f2ab2
    }).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_CONNECT_EMAIL"),
        payload: $471ff018cf1b0d4d$export$976f191ce42ce5be
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_CONNECT_DEVICE"),
        payload: $471ff018cf1b0d4d$export$3fc5153b9dd73fc1
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_CONNECT_OTP"),
        payload: $471ff018cf1b0d4d$export$3c60c26d0e7c7485
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_GET_USER"),
        payload: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).optional($471ff018cf1b0d4d$export$2b55edadc32e688a)
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_SIGN_OUT")
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_IS_CONNECTED"),
        payload: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).optional($471ff018cf1b0d4d$export$583fad842749c757)
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_GET_CHAIN_ID")
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_RPC_REQUEST"),
        payload: $471ff018cf1b0d4d$export$57dc995d18380851.or($471ff018cf1b0d4d$export$fc4f4bb7f991c8e0).or($471ff018cf1b0d4d$export$333c606c26a06359).or($471ff018cf1b0d4d$export$ed481a6ef87fb1a4).or($471ff018cf1b0d4d$export$3746f30d5256aebc).or($471ff018cf1b0d4d$export$ced6b8fef5e3a1ae).or($471ff018cf1b0d4d$export$272161a7d614a7de).or($471ff018cf1b0d4d$export$601d25f8f10fb73e).or($471ff018cf1b0d4d$export$375f72aea2abe32f).or($471ff018cf1b0d4d$export$5781e194c9800107).or($471ff018cf1b0d4d$export$e8c54d0244516318).or($471ff018cf1b0d4d$export$ed296586d8ca73e5).or($471ff018cf1b0d4d$export$5930d1a65f85cd1c).or($471ff018cf1b0d4d$export$728754e9b5ce598).or($471ff018cf1b0d4d$export$4ddab575d344fe47).or($471ff018cf1b0d4d$export$3a9707a1a95b758c).or($471ff018cf1b0d4d$export$32d3decd99b4e77c).or($471ff018cf1b0d4d$export$70385be35bb1c094).or($471ff018cf1b0d4d$export$67adfcd98750c2a4).or($471ff018cf1b0d4d$export$ec85b0f99f3b0860).or($471ff018cf1b0d4d$export$aad1bb370c749036).or($471ff018cf1b0d4d$export$de118eb57c7e99ee).or($471ff018cf1b0d4d$export$925a4185b30091ca).or($471ff018cf1b0d4d$export$132e327b9ac8100f).or($471ff018cf1b0d4d$export$b498be03499c3270).or($471ff018cf1b0d4d$export$8e3ae636de98a13f).or($471ff018cf1b0d4d$export$ebf4091cc6dfa2ef).or($471ff018cf1b0d4d$export$a9e565a5951dbda1).or($471ff018cf1b0d4d$export$3e72b948c8cdb33b).or($471ff018cf1b0d4d$export$35da6e194885ea4f).or($471ff018cf1b0d4d$export$f2d7c90f3596d13e).or($471ff018cf1b0d4d$export$f6ccc436669a288e).or($471ff018cf1b0d4d$export$299d889501e7632c).or($471ff018cf1b0d4d$export$2f01b91caa317491).or($471ff018cf1b0d4d$export$688f7a1e4924e71b).or($471ff018cf1b0d4d$export$1cc394e8ef03e09a).or($471ff018cf1b0d4d$export$57dc995d18380851).or($471ff018cf1b0d4d$export$98d6e3ae5e5869d0).or($471ff018cf1b0d4d$export$fc4f4bb7f991c8e0)
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_UPDATE_EMAIL"),
        payload: $471ff018cf1b0d4d$export$65e6e56482b6df27
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_UPDATE_EMAIL_PRIMARY_OTP"),
        payload: $471ff018cf1b0d4d$export$63ec130352b88085
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_UPDATE_EMAIL_SECONDARY_OTP"),
        payload: $471ff018cf1b0d4d$export$cbb50d2392bf53e2
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_SYNC_THEME"),
        payload: $471ff018cf1b0d4d$export$c523bb85fd166f04
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("APP_SYNC_DAPP_DATA"),
        payload: $471ff018cf1b0d4d$export$4ca9ea890e921270
    })),
    frameEvent: (0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_SWITCH_NETWORK_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    }).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_SWITCH_NETWORK_SUCCESS"),
        payload: $471ff018cf1b0d4d$export$178941fe9bfa6200
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_CONNECT_EMAIL_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_CONNECT_EMAIL_SUCCESS"),
        payload: $471ff018cf1b0d4d$export$333a7bf9d10b914
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_CONNECT_OTP_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_CONNECT_OTP_SUCCESS")
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_CONNECT_DEVICE_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_CONNECT_DEVICE_SUCCESS")
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_GET_USER_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_GET_USER_SUCCESS"),
        payload: $471ff018cf1b0d4d$export$2d6662dda0084b61
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_SIGN_OUT_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_SIGN_OUT_SUCCESS")
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_IS_CONNECTED_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_IS_CONNECTED_SUCCESS"),
        payload: $471ff018cf1b0d4d$export$775a450ce21f8fdf
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_GET_CHAIN_ID_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_GET_CHAIN_ID_SUCCESS"),
        payload: $471ff018cf1b0d4d$export$245abc04f43df573
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_RPC_REQUEST_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_RPC_REQUEST_SUCCESS"),
        payload: $471ff018cf1b0d4d$export$d4ce1c0118069cf6
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_SESSION_UPDATE"),
        payload: $471ff018cf1b0d4d$export$583fad842749c757
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_UPDATE_EMAIL_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_UPDATE_EMAIL_SUCCESS")
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS")
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS"),
        payload: $471ff018cf1b0d4d$export$bb05e12b7f21caf1
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_SYNC_THEME_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_SYNC_THEME_SUCCESS")
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_SYNC_DAPP_DATA_ERROR"),
        payload: $471ff018cf1b0d4d$var$zError
    })).or((0, $8f21a9d693629cf7$export$2e2bcd8739ae039).object({
        type: $471ff018cf1b0d4d$var$zType("FRAME_SYNC_DAPP_DATA_SUCCESS")
    }))
};




const $3c8cd73df7e03d4e$export$500c415dce2853c3 = {
    set (key, value) {
        if ((0, $d8337f636d1cff9e$export$794efc40d8765bc4).isClient) localStorage.setItem(`${(0, $e23d11511a09400f$export$3ff97a7390ed49be).STORAGE_KEY}${key}`, value);
    },
    get (key) {
        if ((0, $d8337f636d1cff9e$export$794efc40d8765bc4).isClient) return localStorage.getItem(`${(0, $e23d11511a09400f$export$3ff97a7390ed49be).STORAGE_KEY}${key}`);
        return null;
    },
    delete (key) {
        if ((0, $d8337f636d1cff9e$export$794efc40d8765bc4).isClient) localStorage.removeItem(`${(0, $e23d11511a09400f$export$3ff97a7390ed49be).STORAGE_KEY}${key}`);
    }
};



const $d8337f636d1cff9e$var$RESTRICTED_TIMEZONES = [
    "ASIA/SHANGHAI",
    "ASIA/URUMQI",
    "ASIA/CHONGQING",
    "ASIA/HARBIN",
    "ASIA/KASHGAR",
    "ASIA/MACAU",
    "ASIA/HONG_KONG",
    "ASIA/MACAO",
    "ASIA/BEIJING",
    "ASIA/HARBIN"
];
const $d8337f636d1cff9e$var$EMAIL_MINIMUM_TIMEOUT = 30000;
const $d8337f636d1cff9e$export$794efc40d8765bc4 = {
    getBlockchainApiUrl () {
        try {
            const { timeZone: timeZone } = new Intl.DateTimeFormat().resolvedOptions();
            const capTimeZone = timeZone.toUpperCase();
            return $d8337f636d1cff9e$var$RESTRICTED_TIMEZONES.includes(capTimeZone) ? "https://rpc.walletconnect.org" : "https://rpc.walletconnect.com";
        } catch  {
            return false;
        }
    },
    checkIfAllowedToTriggerEmail () {
        const lastEmailLoginTime = (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).get((0, $e23d11511a09400f$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            const difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $d8337f636d1cff9e$var$EMAIL_MINIMUM_TIMEOUT) {
                const cooldownSec = Math.ceil(($d8337f636d1cff9e$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
                throw new Error(`Please try again after ${cooldownSec} seconds`);
            }
        }
    },
    getTimeToNextEmailLogin () {
        const lastEmailLoginTime = (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).get((0, $e23d11511a09400f$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            const difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $d8337f636d1cff9e$var$EMAIL_MINIMUM_TIMEOUT) return Math.ceil(($d8337f636d1cff9e$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
        }
        return 0;
    },
    checkIfRequestExists (request) {
        const method = this.getRequestMethod(request);
        return (0, $e23d11511a09400f$export$9975694bfb286db).NOT_SAFE_RPC_METHODS.includes(method) || (0, $e23d11511a09400f$export$9975694bfb286db).SAFE_RPC_METHODS.includes(method);
    },
    getRequestMethod (request) {
        return request?.payload?.method;
    },
    checkIfRequestIsAllowed (request) {
        const method = this.getRequestMethod(request);
        return (0, $e23d11511a09400f$export$9975694bfb286db).SAFE_RPC_METHODS.includes(method);
    },
    isClient: typeof window !== "undefined"
};


class $42c5574de5a4e8b8$export$668e35d4f1b0aa08 {
    constructor(projectId, isAppClient = false){
        this.iframe = null;
        this.rpcUrl = (0, $d8337f636d1cff9e$export$794efc40d8765bc4).getBlockchainApiUrl();
        this.events = {
            onFrameEvent: (callback)=>{
                if ((0, $d8337f636d1cff9e$export$794efc40d8765bc4).isClient) window.addEventListener("message", ({ data: data })=>{
                    if (!data.type?.includes((0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_EVENT_KEY)) return;
                    const frameEvent = (0, $471ff018cf1b0d4d$export$238f9986c2bb1b9a).frameEvent.parse(data);
                    callback(frameEvent);
                });
            },
            onAppEvent: (callback)=>{
                if ((0, $d8337f636d1cff9e$export$794efc40d8765bc4).isClient) window.addEventListener("message", ({ data: data })=>{
                    if (!data.type?.includes((0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_EVENT_KEY)) return;
                    const appEvent = (0, $471ff018cf1b0d4d$export$238f9986c2bb1b9a).appEvent.parse(data);
                    callback(appEvent);
                });
            },
            postAppEvent: (event)=>{
                if ((0, $d8337f636d1cff9e$export$794efc40d8765bc4).isClient) {
                    if (!this.iframe?.contentWindow) throw new Error("W3mFrame: iframe is not set");
                    (0, $471ff018cf1b0d4d$export$238f9986c2bb1b9a).appEvent.parse(event);
                    window.postMessage(event);
                    this.iframe.contentWindow.postMessage(event, "*");
                }
            },
            postFrameEvent: (event)=>{
                if ((0, $d8337f636d1cff9e$export$794efc40d8765bc4).isClient) {
                    if (!parent) throw new Error("W3mFrame: parent is not set");
                    (0, $471ff018cf1b0d4d$export$238f9986c2bb1b9a).frameEvent.parse(event);
                    parent.postMessage(event, "*");
                }
            }
        };
        this.projectId = projectId;
        this.frameLoadPromise = new Promise((resolve, reject)=>{
            this.frameLoadPromiseResolver = {
                resolve: resolve,
                reject: reject
            };
        });
        if (isAppClient) {
            this.frameLoadPromise = new Promise((resolve, reject)=>{
                this.frameLoadPromiseResolver = {
                    resolve: resolve,
                    reject: reject
                };
            });
            if ((0, $d8337f636d1cff9e$export$794efc40d8765bc4).isClient) {
                const iframe = document.createElement("iframe");
                iframe.id = "w3m-iframe";
                iframe.src = `${(0, $e23d11511a09400f$export$3ff97a7390ed49be).SECURE_SITE_SDK}?projectId=${projectId}`;
                iframe.style.position = "fixed";
                iframe.style.zIndex = "999999";
                iframe.style.display = "none";
                iframe.style.opacity = "0";
                iframe.style.borderRadius = `clamp(0px, var(--wui-border-radius-l), 44px)`;
                document.body.appendChild(iframe);
                this.iframe = iframe;
                this.iframe.onload = ()=>{
                    this.frameLoadPromiseResolver?.resolve(undefined);
                };
                this.iframe.onerror = ()=>{
                    this.frameLoadPromiseResolver?.reject("Unable to load email login dependency");
                };
            }
        }
    }
    get networks() {
        const data = [
            1,
            5,
            11155111,
            10,
            420,
            42161,
            421613,
            137,
            80001,
            42220,
            1313161554,
            1313161555,
            56,
            97,
            43114,
            43113,
            324,
            280,
            100,
            8453,
            84531,
            7777777,
            999
        ].map((id)=>({
                [id]: {
                    rpcUrl: `${this.rpcUrl}/v1/?chainId=eip155:${id}&projectId=${this.projectId}`,
                    chainId: id
                }
            }));
        return Object.assign({}, ...data);
    }
}



parcelRequire("3aODI");
var $9Ezhj = parcelRequire("9Ezhj");




class $f921cae03edcbdbc$export$112ca4a9acf9f612 {
    constructor(projectId){
        this.connectEmailResolver = undefined;
        this.connectDeviceResolver = undefined;
        this.connectOtpResolver = undefined;
        this.connectResolver = undefined;
        this.disconnectResolver = undefined;
        this.isConnectedResolver = undefined;
        this.getChainIdResolver = undefined;
        this.switchChainResolver = undefined;
        this.rpcRequestResolver = undefined;
        this.updateEmailResolver = undefined;
        this.updateEmailPrimaryOtpResolver = undefined;
        this.updateEmailSecondaryOtpResolver = undefined;
        this.syncThemeResolver = undefined;
        this.syncDappDataResolver = undefined;
        this.w3mFrame = new (0, $42c5574de5a4e8b8$export$668e35d4f1b0aa08)(projectId, true);
        this.w3mFrame.events.onFrameEvent((event)=>{
            console.log("\uD83D\uDCBB received", event);
            switch(event.type){
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_CONNECT_EMAIL_SUCCESS:
                    return this.onConnectEmailSuccess(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_CONNECT_EMAIL_ERROR:
                    return this.onConnectEmailError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_CONNECT_DEVICE_SUCCESS:
                    return this.onConnectDeviceSuccess();
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_CONNECT_DEVICE_ERROR:
                    return this.onConnectDeviceError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_CONNECT_OTP_SUCCESS:
                    return this.onConnectOtpSuccess();
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_CONNECT_OTP_ERROR:
                    return this.onConnectOtpError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_GET_USER_SUCCESS:
                    return this.onConnectSuccess(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_GET_USER_ERROR:
                    return this.onConnectError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_IS_CONNECTED_SUCCESS:
                    return this.onIsConnectedSuccess(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_IS_CONNECTED_ERROR:
                    return this.onIsConnectedError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_GET_CHAIN_ID_SUCCESS:
                    return this.onGetChainIdSuccess(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_GET_CHAIN_ID_ERROR:
                    return this.onGetChainIdError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_SIGN_OUT_SUCCESS:
                    return this.onSignOutSuccess();
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_SIGN_OUT_ERROR:
                    return this.onSignOutError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_SWITCH_NETWORK_SUCCESS:
                    return this.onSwitchChainSuccess(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_SWITCH_NETWORK_ERROR:
                    return this.onSwitchChainError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_RPC_REQUEST_SUCCESS:
                    return this.onRpcRequestSuccess(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_RPC_REQUEST_ERROR:
                    return this.onRpcRequestError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_SESSION_UPDATE:
                    return this.onSessionUpdate(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_SUCCESS:
                    return this.onUpdateEmailSuccess();
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_ERROR:
                    return this.onUpdateEmailError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS:
                    return this.onUpdateEmailPrimaryOtpSuccess();
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR:
                    return this.onUpdateEmailPrimaryOtpError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS:
                    return this.onUpdateEmailSecondaryOtpSuccess(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR:
                    return this.onUpdateEmailSecondaryOtpError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_SYNC_THEME_SUCCESS:
                    return this.onSyncThemeSuccess();
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_SYNC_THEME_ERROR:
                    return this.onSyncThemeError(event);
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_SYNC_DAPP_DATA_SUCCESS:
                    return this.onSyncDappDataSuccess();
                case (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_SYNC_DAPP_DATA_ERROR:
                    return this.onSyncDappDataError(event);
                default:
                    return null;
            }
        });
    }
    getLoginEmailUsed() {
        return Boolean((0, $3c8cd73df7e03d4e$export$500c415dce2853c3).get((0, $e23d11511a09400f$export$3ff97a7390ed49be).EMAIL_LOGIN_USED_KEY));
    }
    getEmail() {
        return (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).get((0, $e23d11511a09400f$export$3ff97a7390ed49be).EMAIL);
    }
    rejectRpcRequest() {
        this.rpcRequestResolver?.reject();
    }
    async connectEmail(payload) {
        await this.w3mFrame.frameLoadPromise;
        (0, $d8337f636d1cff9e$export$794efc40d8765bc4).checkIfAllowedToTriggerEmail();
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_CONNECT_EMAIL,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.connectEmailResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async connectDevice() {
        await this.w3mFrame.frameLoadPromise;
        const jwt = await (0, $9Ezhj.CryptoUtil).createJwt();
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_CONNECT_DEVICE,
            payload: {
                jwt: jwt || ""
            }
        });
        return new Promise((resolve, reject)=>{
            this.connectDeviceResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async connectOtp(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_CONNECT_OTP,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.connectOtpResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async isConnected() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_IS_CONNECTED,
            payload: undefined
        });
        return new Promise((resolve, reject)=>{
            this.isConnectedResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async getChainId() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_GET_CHAIN_ID
        });
        return new Promise((resolve, reject)=>{
            this.getChainIdResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async updateEmail(payload) {
        await this.w3mFrame.frameLoadPromise;
        (0, $d8337f636d1cff9e$export$794efc40d8765bc4).checkIfAllowedToTriggerEmail();
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_UPDATE_EMAIL,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.updateEmailResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async updateEmailPrimaryOtp(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_UPDATE_EMAIL_PRIMARY_OTP,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.updateEmailPrimaryOtpResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async updateEmailSecondaryOtp(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_UPDATE_EMAIL_SECONDARY_OTP,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.updateEmailSecondaryOtpResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async syncTheme(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_SYNC_THEME,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.syncThemeResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async syncDappData(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_SYNC_DAPP_DATA,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.syncDappDataResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async connect(payload) {
        const chainId = payload?.chainId ?? this.getLastUsedChainId() ?? 1;
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_GET_USER,
            payload: {
                chainId: chainId
            }
        });
        return new Promise((resolve, reject)=>{
            this.connectResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async switchNetwork(chainId) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_SWITCH_NETWORK,
            payload: {
                chainId: chainId
            }
        });
        return new Promise((resolve, reject)=>{
            this.switchChainResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async disconnect() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_SIGN_OUT
        });
        return new Promise((resolve, reject)=>{
            this.disconnectResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async request(req) {
        await this.w3mFrame.frameLoadPromise;
        if ((0, $e23d11511a09400f$export$9975694bfb286db).GET_CHAIN_ID === req.method) return this.getLastUsedChainId();
        this.w3mFrame.events.postAppEvent({
            type: (0, $e23d11511a09400f$export$3ff97a7390ed49be).APP_RPC_REQUEST,
            payload: req
        });
        return new Promise((resolve, reject)=>{
            this.rpcRequestResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    onRpcRequest(callback) {
        this.w3mFrame.events.onAppEvent((event)=>{
            if (event.type.includes((0, $e23d11511a09400f$export$3ff97a7390ed49be).RPC_METHOD_KEY)) callback(event);
        });
    }
    onRpcResponse(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type.includes((0, $e23d11511a09400f$export$3ff97a7390ed49be).RPC_METHOD_KEY)) callback(event);
        });
    }
    onIsConnected(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_GET_USER_SUCCESS) callback();
        });
    }
    onNotConnected(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_IS_CONNECTED_ERROR) callback();
            if (event.type === (0, $e23d11511a09400f$export$3ff97a7390ed49be).FRAME_IS_CONNECTED_SUCCESS && !event.payload.isConnected) callback();
        });
    }
    onConnectEmailSuccess(event) {
        this.connectEmailResolver?.resolve(event.payload);
        this.setNewLastEmailLoginTime();
    }
    onConnectEmailError(event) {
        this.connectEmailResolver?.reject(event.payload.message);
    }
    onConnectDeviceSuccess() {
        this.connectDeviceResolver?.resolve(undefined);
    }
    onConnectDeviceError(event) {
        this.connectDeviceResolver?.reject(event.payload.message);
    }
    onConnectOtpSuccess() {
        this.connectOtpResolver?.resolve(undefined);
    }
    onConnectOtpError(event) {
        this.connectOtpResolver?.reject(event.payload.message);
    }
    onConnectSuccess(event) {
        this.setEmailLoginSuccess(event.payload.email);
        this.setLastUsedChainId(event.payload.chainId);
        this.connectResolver?.resolve(event.payload);
    }
    onConnectError(event) {
        this.connectResolver?.reject(event.payload.message);
    }
    onIsConnectedSuccess(event) {
        if (!event.payload.isConnected) this.deleteEmailLoginCache();
        this.isConnectedResolver?.resolve(event.payload);
    }
    onIsConnectedError(event) {
        this.isConnectedResolver?.reject(event.payload.message);
    }
    onGetChainIdSuccess(event) {
        this.setLastUsedChainId(event.payload.chainId);
        this.getChainIdResolver?.resolve(event.payload);
    }
    onGetChainIdError(event) {
        this.getChainIdResolver?.reject(event.payload.message);
    }
    onSignOutSuccess() {
        this.disconnectResolver?.resolve(undefined);
        this.deleteEmailLoginCache();
    }
    onSignOutError(event) {
        this.disconnectResolver?.reject(event.payload.message);
    }
    onSwitchChainSuccess(event) {
        this.setLastUsedChainId(event.payload.chainId);
        this.switchChainResolver?.resolve(event.payload);
    }
    onSwitchChainError(event) {
        this.switchChainResolver?.reject(event.payload.message);
    }
    onRpcRequestSuccess(event) {
        this.rpcRequestResolver?.resolve(event.payload);
    }
    onRpcRequestError(event) {
        this.rpcRequestResolver?.reject(event.payload.message);
    }
    onSessionUpdate(event) {
        const { payload: payload } = event;
        payload;
    }
    onUpdateEmailSuccess() {
        this.updateEmailResolver?.resolve(undefined);
        this.setNewLastEmailLoginTime();
    }
    onUpdateEmailError(event) {
        this.updateEmailResolver?.reject(event.payload.message);
    }
    onUpdateEmailPrimaryOtpSuccess() {
        this.updateEmailPrimaryOtpResolver?.resolve(undefined);
    }
    onUpdateEmailPrimaryOtpError(event) {
        this.updateEmailPrimaryOtpResolver?.reject(event.payload.message);
    }
    onUpdateEmailSecondaryOtpSuccess(event) {
        const { newEmail: newEmail } = event.payload;
        this.setEmailLoginSuccess(newEmail);
        this.updateEmailSecondaryOtpResolver?.resolve({
            newEmail: newEmail
        });
    }
    onUpdateEmailSecondaryOtpError(event) {
        this.updateEmailSecondaryOtpResolver?.reject(event.payload.message);
    }
    onSyncThemeSuccess() {
        this.syncThemeResolver?.resolve(undefined);
    }
    onSyncThemeError(event) {
        this.syncThemeResolver?.reject(event.payload.message);
    }
    onSyncDappDataSuccess() {
        this.syncDappDataResolver?.resolve(undefined);
    }
    onSyncDappDataError(event) {
        this.syncDappDataResolver?.reject(event.payload.message);
    }
    setNewLastEmailLoginTime() {
        (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).set((0, $e23d11511a09400f$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME, Date.now().toString());
    }
    setEmailLoginSuccess(email) {
        (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).set((0, $e23d11511a09400f$export$3ff97a7390ed49be).EMAIL, email);
        (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).set((0, $e23d11511a09400f$export$3ff97a7390ed49be).EMAIL_LOGIN_USED_KEY, "true");
        (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).delete((0, $e23d11511a09400f$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME);
    }
    deleteEmailLoginCache() {
        (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).delete((0, $e23d11511a09400f$export$3ff97a7390ed49be).EMAIL_LOGIN_USED_KEY);
        (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).delete((0, $e23d11511a09400f$export$3ff97a7390ed49be).EMAIL);
        (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).delete((0, $e23d11511a09400f$export$3ff97a7390ed49be).LAST_USED_CHAIN_KEY);
    }
    setLastUsedChainId(chainId) {
        (0, $3c8cd73df7e03d4e$export$500c415dce2853c3).set((0, $e23d11511a09400f$export$3ff97a7390ed49be).LAST_USED_CHAIN_KEY, `${chainId}`);
    }
    getLastUsedChainId() {
        return Number((0, $3c8cd73df7e03d4e$export$500c415dce2853c3).get((0, $e23d11511a09400f$export$3ff97a7390ed49be).LAST_USED_CHAIN_KEY));
    }
}







var $56eedf5c3e403512$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $56eedf5c3e403512$var$OTP_LENGTH = 6;
let $56eedf5c3e403512$export$84443566fe241bc9 = class W3mEmailOtpWidget extends (0, $dlgVE.LitElement) {
    firstUpdated() {
        this.startOTPTimeout();
    }
    disconnectedCallback() {
        clearTimeout(this.OTPTimeout);
    }
    constructor(){
        super();
        this.loading = false;
        this.timeoutTimeLeft = (0, $d8337f636d1cff9e$export$794efc40d8765bc4).getTimeToNextEmailLogin();
        this.error = "";
        this.otp = "";
        this.email = (0, $3OaCj.RouterController).state.data?.email;
        this.emailConnector = (0, $01g6R.ConnectorController).getEmailConnector();
    }
    render() {
        if (!this.email) throw new Error("w3m-email-otp-widget: No email provided");
        const isResendDisabled = Boolean(this.timeoutTimeLeft);
        const footerLabels = this.getFooterLabels(isResendDisabled);
        return (0, $gDLfI.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "l",
            "0",
            "l",
            "0"
        ]}
        gap="l"
      >
        <wui-flex flexDirection="column" alignItems="center">
          <wui-text variant="paragraph-400" color="fg-100">Enter the code we sent to</wui-text>
          <wui-text variant="paragraph-500" color="fg-100">${this.email}</wui-text>
        </wui-flex>

        <wui-text variant="small-400" color="fg-200">The code expires in 10 minutes</wui-text>

        ${this.loading ? (0, $gDLfI.html)`<wui-loading-spinner size="xl" color="accent-100"></wui-loading-spinner>` : (0, $gDLfI.html)` <wui-flex flexDirection="column" alignItems="center" gap="xs">
              <wui-otp
                dissabled
                length="6"
                @inputChange=${this.onOtpInputChange.bind(this)}
                .otp=${this.otp}
              ></wui-otp>
              ${this.error ? (0, $gDLfI.html)`
                    <wui-text variant="small-400" align="center" color="error-100">
                      ${this.error}. Try Again
                    </wui-text>
                  ` : null}
            </wui-flex>`}

        <wui-flex alignItems="center">
          <wui-text variant="small-400" color="fg-200">${footerLabels.title}</wui-text>
          <wui-link @click=${this.onResendCode.bind(this)} .disabled=${isResendDisabled}>
            ${footerLabels.action}
          </wui-link>
        </wui-flex>
      </wui-flex>
    `;
    }
    startOTPTimeout() {
        this.timeoutTimeLeft = (0, $d8337f636d1cff9e$export$794efc40d8765bc4).getTimeToNextEmailLogin();
        this.OTPTimeout = setInterval(()=>{
            if (this.timeoutTimeLeft > 0) this.timeoutTimeLeft = (0, $d8337f636d1cff9e$export$794efc40d8765bc4).getTimeToNextEmailLogin();
            else clearInterval(this.OTPTimeout);
        }, 1000);
    }
    async onOtpInputChange(event) {
        try {
            if (!this.loading) {
                this.otp = event.detail;
                if (this.emailConnector && this.otp.length === $56eedf5c3e403512$var$OTP_LENGTH) {
                    this.loading = true;
                    await this.onOtpSubmit?.(this.otp);
                }
            }
        } catch (error) {
            this.error = (0, $23VhR.CoreHelperUtil).parseError(error);
            this.loading = false;
        }
    }
    async onResendCode() {
        try {
            if (this.onOtpResend) {
                if (!this.loading && !this.timeoutTimeLeft) {
                    this.error = "";
                    this.otp = "";
                    const emailConnector = (0, $01g6R.ConnectorController).getEmailConnector();
                    if (!emailConnector || !this.email) throw new Error("w3m-email-otp-widget: Unable to resend email");
                    this.loading = true;
                    await this.onOtpResend(this.email);
                    this.startOTPTimeout();
                    (0, $dXr1O.SnackController).showSuccess("Code email resent");
                }
            } else if (this.onStartOver) this.onStartOver();
        } catch (error) {
            (0, $dXr1O.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
    getFooterLabels(isResendDisabled) {
        if (this.onStartOver) return {
            title: "Something wrong?",
            action: `Try again ${isResendDisabled ? `in ${this.timeoutTimeLeft}s` : ""}`
        };
        return {
            title: `Didn't receive it?`,
            action: `Resend ${isResendDisabled ? `in ${this.timeoutTimeLeft}s` : "Code"}`
        };
    }
};
$56eedf5c3e403512$export$84443566fe241bc9.styles = (0, $12c28cd902d52530$export$2e2bcd8739ae039);
$56eedf5c3e403512$var$__decorate([
    (0, $hdnNF.state)()
], $56eedf5c3e403512$export$84443566fe241bc9.prototype, "loading", void 0);
$56eedf5c3e403512$var$__decorate([
    (0, $hdnNF.state)()
], $56eedf5c3e403512$export$84443566fe241bc9.prototype, "timeoutTimeLeft", void 0);
$56eedf5c3e403512$var$__decorate([
    (0, $hdnNF.state)()
], $56eedf5c3e403512$export$84443566fe241bc9.prototype, "error", void 0);
$56eedf5c3e403512$export$84443566fe241bc9 = $56eedf5c3e403512$var$__decorate([
    (0, $3SCaV.customElement)("w3m-email-otp-widget")
], $56eedf5c3e403512$export$84443566fe241bc9);


parcelRequire("3aODI");
var $5n5Ql = parcelRequire("5n5Ql");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $fb84f434a7ab2c9d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $fb84f434a7ab2c9d$export$cf0da95883710edd = class W3mEmailVerifyOtpView extends (0, $56eedf5c3e403512$export$84443566fe241bc9) {
    constructor(){
        super();
        this.onOtpSubmit = async (otp)=>{
            try {
                if (this.emailConnector) {
                    await this.emailConnector.provider.connectOtp({
                        otp: otp
                    });
                    (0, $dUlgM.EventsController).sendEvent({
                        type: "track",
                        event: "EMAIL_VERIFICATION_CODE_PASS"
                    });
                    await (0, $5n5Ql.ConnectionController).connectExternal(this.emailConnector);
                    (0, $nBm8O.ModalController).close();
                    (0, $dUlgM.EventsController).sendEvent({
                        type: "track",
                        event: "CONNECT_SUCCESS",
                        properties: {
                            method: "email"
                        }
                    });
                }
            } catch (error) {
                (0, $dUlgM.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_FAIL"
                });
                throw error;
            }
        };
        this.onOtpResend = async (email)=>{
            if (this.emailConnector) {
                await this.emailConnector.provider.connectEmail({
                    email: email
                });
                (0, $dUlgM.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_SENT"
                });
            }
        };
    }
};
$fb84f434a7ab2c9d$export$cf0da95883710edd = $fb84f434a7ab2c9d$var$__decorate([
    (0, $3SCaV.customElement)("w3m-email-verify-otp-view")
], $fb84f434a7ab2c9d$export$cf0da95883710edd);


parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $125fff618f539361$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-icon-box {
    height: var(--wui-icon-box-size-xl);
    width: var(--wui-icon-box-size-xl);
  }
`;


parcelRequire("3aODI");
var $01g6R = parcelRequire("01g6R");
var $dUlgM = parcelRequire("dUlgM");
var $3OaCj = parcelRequire("3OaCj");
var $dXr1O = parcelRequire("dXr1O");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
var $acde5725a2671d2a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $acde5725a2671d2a$export$442e575aa1acbb10 = class W3mEmailVerifyDeviceView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.email = (0, $3OaCj.RouterController).state.data?.email;
        this.emailConnector = (0, $01g6R.ConnectorController).getEmailConnector();
        this.loading = false;
        this.listenForDeviceApproval();
    }
    render() {
        if (!this.email) throw new Error("w3m-email-verify-device-view: No email provided");
        if (!this.emailConnector) throw new Error("w3m-email-verify-device-view: No email connector provided");
        return (0, $gDLfI.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "xxl",
            "s",
            "xxl",
            "s"
        ]}
        gap="l"
      >
        <wui-icon-box
          size="xl"
          iconcolor="accent-100"
          backgroundcolor="accent-100"
          icon="verify"
          background="opaque"
        ></wui-icon-box>

        <wui-flex flexDirection="column" alignItems="center" gap="s">
          <wui-flex flexDirection="column" alignItems="center">
            <wui-text variant="paragraph-400" color="fg-100">
              Approve the login link we sent to
            </wui-text>
            <wui-text variant="paragraph-400" color="fg-100"><b>${this.email}</b></wui-text>
          </wui-flex>

          <wui-text variant="small-400" color="fg-200" align="center">
            The code expires in 10 minutes
          </wui-text>

          <wui-flex alignItems="center" id="w3m-resend-section">
            <wui-text variant="small-400" color="fg-100" align="center">
              Didn't receive it?
            </wui-text>
            <wui-link @click=${this.onResendCode.bind(this)} .disabled=${this.loading}>
              Resend email
            </wui-link>
          </wui-flex>
        </wui-flex>
      </wui-flex>
    `;
    }
    async listenForDeviceApproval() {
        if (this.emailConnector) try {
            await this.emailConnector.provider.connectDevice();
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "DEVICE_REGISTERED_FOR_EMAIL"
            });
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_VERIFICATION_CODE_SENT"
            });
            (0, $3OaCj.RouterController).replace("EmailVerifyOtp", {
                email: this.email
            });
        } catch (error) {
            (0, $3OaCj.RouterController).goBack();
        }
    }
    async onResendCode() {
        try {
            if (!this.loading) {
                if (!this.emailConnector || !this.email) throw new Error("w3m-email-login-widget: Unable to resend email");
                this.loading = true;
                await this.emailConnector.provider.connectEmail({
                    email: this.email
                });
                (0, $dXr1O.SnackController).showSuccess("Code email resent");
            }
        } catch (error) {
            (0, $dXr1O.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
};
$acde5725a2671d2a$export$442e575aa1acbb10.styles = (0, $125fff618f539361$export$2e2bcd8739ae039);
$acde5725a2671d2a$var$__decorate([
    (0, $hdnNF.state)()
], $acde5725a2671d2a$export$442e575aa1acbb10.prototype, "loading", void 0);
$acde5725a2671d2a$export$442e575aa1acbb10 = $acde5725a2671d2a$var$__decorate([
    (0, $3SCaV.customElement)("w3m-email-verify-device-view")
], $acde5725a2671d2a$export$442e575aa1acbb10);


parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $03cd4aa137e059cb$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  div {
    width: 100%;
    height: 400px;
  }

  [data-ready='false'] {
    transform: scale(1.05);
  }

  @media (max-width: 430px) {
    [data-ready='false'] {
      transform: translateY(-50px);
    }
  }
`;


parcelRequire("3aODI");
var $01g6R = parcelRequire("01g6R");
var $nBm8O = parcelRequire("nBm8O");
var $jGPEs = parcelRequire("jGPEs");
var $78eedf7768eb4d06$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $78eedf7768eb4d06$export$ab9ab0bd09f8f225 = class W3mApproveTransactionView extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.bodyObserver = undefined;
        this.unsubscribe = [];
        this.iframe = document.getElementById("w3m-iframe");
        this.ready = false;
        this.unsubscribe.push((0, $nBm8O.ModalController).subscribeKey("open", (val)=>{
            if (!val) this.onHideIframe();
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.bodyObserver?.unobserve(window.document.body);
    }
    async firstUpdated() {
        const verticalPadding = 10;
        await this.syncTheme();
        this.iframe.style.display = "block";
        const blueprint = this.renderRoot.querySelector("div");
        this.bodyObserver = new ResizeObserver(()=>{
            const data = blueprint?.getBoundingClientRect();
            const dimensions = data ?? {
                left: 0,
                top: 0,
                width: 0,
                height: 0
            };
            this.iframe.style.width = `${dimensions.width}px`;
            this.iframe.style.height = `${dimensions.height - verticalPadding}px`;
            this.iframe.style.left = `${dimensions.left}px`;
            this.iframe.style.top = `${dimensions.top + verticalPadding / 2}px`;
            this.ready = true;
        });
        this.bodyObserver.observe(window.document.body);
    }
    render() {
        if (this.ready) this.onShowIframe();
        return (0, $gDLfI.html)`<div data-ready=${this.ready}></div>`;
    }
    onShowIframe() {
        const isMobile = window.innerWidth <= 430;
        this.iframe.animate([
            {
                opacity: 0,
                transform: isMobile ? "translateY(50px)" : "scale(.95)"
            },
            {
                opacity: 1,
                transform: isMobile ? "translateY(0)" : "scale(1)"
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards",
            delay: 300
        });
    }
    async onHideIframe() {
        await this.iframe.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards"
        }).finished;
        this.iframe.style.display = "none";
    }
    async syncTheme() {
        const emailConnector = (0, $01g6R.ConnectorController).getEmailConnector();
        if (emailConnector) await emailConnector.provider.syncTheme({
            themeVariables: (0, $jGPEs.ThemeController).getSnapshot().themeVariables
        });
    }
};
$78eedf7768eb4d06$export$ab9ab0bd09f8f225.styles = (0, $03cd4aa137e059cb$export$2e2bcd8739ae039);
$78eedf7768eb4d06$var$__decorate([
    (0, $hdnNF.state)()
], $78eedf7768eb4d06$export$ab9ab0bd09f8f225.prototype, "ready", void 0);
$78eedf7768eb4d06$export$ab9ab0bd09f8f225 = $78eedf7768eb4d06$var$__decorate([
    (0, $3SCaV.customElement)("w3m-approve-transaction-view")
], $78eedf7768eb4d06$export$ab9ab0bd09f8f225);


parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("3aODI");
var $QVM5q = parcelRequire("QVM5q");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
var $b4d2f4432ae28732$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b4d2f4432ae28732$export$a1f0d947f01e8672 = class W3mUpgradeWalletView extends (0, $dlgVE.LitElement) {
    render() {
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" alignItems="center" gap="xl" padding="xl">
        <wui-text variant="paragraph-400" color="fg-100">Follow the instructions on</wui-text>
        <wui-chip
          icon="externalLink"
          variant="fill"
          href=${(0, $QVM5q.ConstantsUtil).SECURE_SITE_DASHBOARD}
          imageSrc=${(0, $QVM5q.ConstantsUtil).SECURE_SITE_FAVICON}
        >
        </wui-chip>
        <wui-text variant="small-400" color="fg-200">
          You will have to reconnect for security reasons
        </wui-text>
      </wui-flex>
    `;
    }
};
$b4d2f4432ae28732$export$a1f0d947f01e8672 = $b4d2f4432ae28732$var$__decorate([
    (0, $3SCaV.customElement)("w3m-upgrade-wallet-view")
], $b4d2f4432ae28732$export$a1f0d947f01e8672);


parcelRequire("3aODI");
var $01g6R = parcelRequire("01g6R");
var $dUlgM = parcelRequire("dUlgM");
var $3OaCj = parcelRequire("3OaCj");
var $dXr1O = parcelRequire("dXr1O");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");

var $gDLfI = parcelRequire("gDLfI");

var $gDLfI = parcelRequire("gDLfI");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $2470c47931ca6a36$var$et } = (0, $gDLfI._$LH), $2470c47931ca6a36$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $2470c47931ca6a36$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $2470c47931ca6a36$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $2470c47931ca6a36$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $2470c47931ca6a36$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $2470c47931ca6a36$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $2470c47931ca6a36$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $2470c47931ca6a36$var$lt = ()=>document.createComment(""), $2470c47931ca6a36$export$291b2338ad9b0b30 = (o, t, i)=>{
    const n = o._$AA.parentNode, e = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        const t = n.insertBefore($2470c47931ca6a36$var$lt(), e), l = n.insertBefore($2470c47931ca6a36$var$lt(), e);
        i = new $2470c47931ca6a36$var$et(t, l, o, o.options);
    } else {
        const t = i._$AB.nextSibling, l = i._$AM, c = l !== o;
        if (c) {
            let t;
            i._$AQ?.(o), i._$AM = o, void 0 !== i._$AP && (t = o._$AU) !== l._$AU && i._$AP(t);
        }
        if (t !== e || c) {
            let o = i._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                n.insertBefore(o, e), o = t;
            }
        }
    }
    return i;
}, $2470c47931ca6a36$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $2470c47931ca6a36$var$ht = {}, $2470c47931ca6a36$export$ea70d9dd5965b1c8 = (o, t = $2470c47931ca6a36$var$ht)=>o._$AH = t, $2470c47931ca6a36$export$59e9bce518cde500 = (o)=>o._$AH, $2470c47931ca6a36$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $2470c47931ca6a36$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $59671ffc29178961$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $59671ffc29178961$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $59671ffc29178961$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this.t = t, this._$AM = e, this.i = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6b51034c6d139e92$var$mt = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $6b51034c6d139e92$var$mt(i, t);
    return !0;
}, $6b51034c6d139e92$var$_t = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $6b51034c6d139e92$var$wt = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $6b51034c6d139e92$var$gt(t);
    }
};
function $6b51034c6d139e92$var$bt(i) {
    void 0 !== this._$AN ? ($6b51034c6d139e92$var$_t(this), this._$AM = i, $6b51034c6d139e92$var$wt(this)) : this._$AM = i;
}
function $6b51034c6d139e92$var$yt(i, t = !1, e = 0) {
    const s = this._$AH, o = this._$AN;
    if (void 0 !== o && 0 !== o.size) {
        if (t) {
            if (Array.isArray(s)) for(let i = e; i < s.length; i++)$6b51034c6d139e92$var$mt(s[i], !1), $6b51034c6d139e92$var$_t(s[i]);
            else null != s && ($6b51034c6d139e92$var$mt(s, !1), $6b51034c6d139e92$var$_t(s));
        } else $6b51034c6d139e92$var$mt(this, i);
    }
}
const $6b51034c6d139e92$var$gt = (i)=>{
    i.type == (0, $59671ffc29178961$export$9ba3b3f20a85bfa).CHILD && (i._$AP ??= $6b51034c6d139e92$var$yt, i._$AQ ??= $6b51034c6d139e92$var$bt);
};
class $6b51034c6d139e92$export$7d025501802325e extends (0, $59671ffc29178961$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $6b51034c6d139e92$var$wt(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($6b51034c6d139e92$var$mt(this, i), $6b51034c6d139e92$var$_t(this));
    }
    setValue(i) {
        if ((0, $2470c47931ca6a36$export$7f431ad0fff82fd9)(this.t)) this.t._$AI(i, this);
        else {
            const t = [
                ...this.t._$AH
            ];
            t[this.i] = i, this.t._$AI(t, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3ec5ba488088087c$export$7d1e3a5e95ceca43 = ()=>new $3ec5ba488088087c$var$Zt;
class $3ec5ba488088087c$var$Zt {
}
const $3ec5ba488088087c$var$qt = new WeakMap, $3ec5ba488088087c$export$eff4d24c3ff7876e = (0, $59671ffc29178961$export$99b43ad1ed32e735)(class extends (0, $6b51034c6d139e92$export$7d025501802325e) {
    render(t) {
        return 0, $gDLfI.nothing;
    }
    update(t, [i]) {
        const s = i !== this.Y;
        return s && void 0 !== this.Y && this.rt(void 0), (s || this.lt !== this.ct) && (this.Y = i, this.ht = t.options?.host, this.rt(this.ct = t.element)), $gDLfI.nothing;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.Y) {
            const i = this.ht ?? globalThis;
            let s = $3ec5ba488088087c$var$qt.get(i);
            void 0 === s && (s = new WeakMap, $3ec5ba488088087c$var$qt.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
        } else this.Y.value = t;
    }
    get lt() {
        return "function" == typeof this.Y ? $3ec5ba488088087c$var$qt.get(this.ht ?? globalThis)?.get(this.Y) : this.Y?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});




parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $dd36ff5b53cfbc28$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-email-input {
    width: 100%;
  }

  form {
    width: 100%;
    display: block;
    position: relative;
  }
`;


var $688a194102486d72$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $688a194102486d72$export$6814d6aff4948a0 = class W3mUpdateEmailWalletView extends (0, $dlgVE.LitElement) {
    constructor(){
        super(...arguments);
        this.formRef = (0, $3ec5ba488088087c$export$7d1e3a5e95ceca43)();
        this.initialEmail = (0, $3OaCj.RouterController).state.data?.email ?? "";
        this.email = "";
        this.loading = false;
    }
    firstUpdated() {
        this.formRef.value?.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") this.onSubmitEmail(event);
        });
    }
    render() {
        const showSubmit = !this.loading && this.email.length > 3 && this.email !== this.initialEmail;
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" padding="m" gap="m">
        <form ${(0, $3ec5ba488088087c$export$eff4d24c3ff7876e)(this.formRef)} @submit=${this.onSubmitEmail.bind(this)}>
          <wui-email-input
            value=${this.initialEmail}
            .disabled=${this.loading}
            @inputChange=${this.onEmailInputChange.bind(this)}
          >
          </wui-email-input>
          <input type="submit" hidden />
        </form>

        <wui-flex gap="s">
          <wui-button size="md" variant="shade" fullWidth @click=${(0, $3OaCj.RouterController).goBack}>
            Cancel
          </wui-button>

          <wui-button
            size="md"
            variant="fill"
            fullWidth
            @click=${this.onSubmitEmail.bind(this)}
            .disabled=${!showSubmit}
            .loading=${this.loading}
          >
            Save
          </wui-button>
        </wui-flex>
      </wui-flex>
    `;
    }
    onEmailInputChange(event) {
        this.email = event.detail;
    }
    async onSubmitEmail(event) {
        try {
            if (this.loading) return;
            this.loading = true;
            event.preventDefault();
            const emailConnector = (0, $01g6R.ConnectorController).getEmailConnector();
            if (!emailConnector) throw new Error("w3m-update-email-wallet: Email connector not found");
            await emailConnector.provider.updateEmail({
                email: this.email
            });
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_EDIT"
            });
            (0, $3OaCj.RouterController).replace("UpdateEmailPrimaryOtp", {
                email: this.initialEmail,
                newEmail: this.email
            });
        } catch (error) {
            (0, $dXr1O.SnackController).showError(error);
            this.loading = false;
        }
    }
};
$688a194102486d72$export$6814d6aff4948a0.styles = (0, $dd36ff5b53cfbc28$export$2e2bcd8739ae039);
$688a194102486d72$var$__decorate([
    (0, $hdnNF.state)()
], $688a194102486d72$export$6814d6aff4948a0.prototype, "email", void 0);
$688a194102486d72$var$__decorate([
    (0, $hdnNF.state)()
], $688a194102486d72$export$6814d6aff4948a0.prototype, "loading", void 0);
$688a194102486d72$export$6814d6aff4948a0 = $688a194102486d72$var$__decorate([
    (0, $3SCaV.customElement)("w3m-update-email-wallet-view")
], $688a194102486d72$export$6814d6aff4948a0);


parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");

parcelRequire("3aODI");
var $dUlgM = parcelRequire("dUlgM");
var $3OaCj = parcelRequire("3OaCj");
var $17defb9b5c8b470c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $17defb9b5c8b470c$export$f089084b6501bc5 = class W3mUpdateEmailPrimaryOtpView extends (0, $56eedf5c3e403512$export$84443566fe241bc9) {
    constructor(){
        super();
        this.email = (0, $3OaCj.RouterController).state.data?.email;
        this.onOtpSubmit = async (otp)=>{
            try {
                if (this.emailConnector) {
                    await this.emailConnector.provider.updateEmailPrimaryOtp({
                        otp: otp
                    });
                    (0, $dUlgM.EventsController).sendEvent({
                        type: "track",
                        event: "EMAIL_VERIFICATION_CODE_PASS"
                    });
                    (0, $3OaCj.RouterController).replace("UpdateEmailSecondaryOtp", (0, $3OaCj.RouterController).state.data);
                }
            } catch (error) {
                (0, $dUlgM.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_FAIL"
                });
                throw error;
            }
        };
        this.onStartOver = ()=>{
            (0, $3OaCj.RouterController).replace("UpdateEmailWallet", (0, $3OaCj.RouterController).state.data);
        };
    }
};
$17defb9b5c8b470c$export$f089084b6501bc5 = $17defb9b5c8b470c$var$__decorate([
    (0, $3SCaV.customElement)("w3m-update-email-primary-otp-view")
], $17defb9b5c8b470c$export$f089084b6501bc5);


parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");

parcelRequire("3aODI");
var $dUlgM = parcelRequire("dUlgM");
var $3OaCj = parcelRequire("3OaCj");
var $f8c7e3474a788a38$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f8c7e3474a788a38$export$627b68ac942cb0d6 = class W3mUpdateEmailSecondaryOtpView extends (0, $56eedf5c3e403512$export$84443566fe241bc9) {
    constructor(){
        super();
        this.email = (0, $3OaCj.RouterController).state.data?.newEmail;
        this.onOtpSubmit = async (otp)=>{
            try {
                if (this.emailConnector) {
                    await this.emailConnector.provider.updateEmailSecondaryOtp({
                        otp: otp
                    });
                    (0, $dUlgM.EventsController).sendEvent({
                        type: "track",
                        event: "EMAIL_VERIFICATION_CODE_PASS"
                    });
                    (0, $3OaCj.RouterController).reset("Account");
                }
            } catch (error) {
                (0, $dUlgM.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_FAIL"
                });
                throw error;
            }
        };
        this.onStartOver = ()=>{
            (0, $3OaCj.RouterController).replace("UpdateEmailWallet", (0, $3OaCj.RouterController).state.data);
        };
    }
};
$f8c7e3474a788a38$export$627b68ac942cb0d6 = $f8c7e3474a788a38$var$__decorate([
    (0, $3SCaV.customElement)("w3m-update-email-secondary-otp-view")
], $f8c7e3474a788a38$export$627b68ac942cb0d6);


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $3jnn6 = parcelRequire("3jnn6");
var $5n5Ql = parcelRequire("5n5Ql");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $8A6Jz = parcelRequire("8A6Jz");
var $3OaCj = parcelRequire("3OaCj");
var $1hoT1 = parcelRequire("1hoT1");
var $dXr1O = parcelRequire("dXr1O");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $24ee86e37ea26c5f$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host > wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
  }

  :host > wui-flex::-webkit-scrollbar {
    display: none;
  }
`;


var $2d6d45fc027f9139$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2d6d45fc027f9139$export$db1b0c4a50057bc8 = class W3mUnsupportedChainView extends (0, $dlgVE.LitElement) {
    constructor(){
        super(...arguments);
        this.disconecting = false;
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex class="container" flexDirection="column" gap="0">
        <wui-flex
          class="container"
          flexDirection="column"
          .padding=${[
            "m",
            "xl",
            "xs",
            "xl"
        ]}
          alignItems="center"
          gap="xl"
        >
          <wui-text variant="small-400" color="fg-200" align="center">
            This app doesn’t support your current network. Switch to an available option following
            to continue.
          </wui-text>
        </wui-flex>

        <wui-flex flexDirection="column" padding="s" gap="xs">
          ${this.networksTemplate()}
        </wui-flex>

        <wui-separator text="or"></wui-separator>
        <wui-flex flexDirection="column" padding="s" gap="xs">
          <wui-list-item
            variant="icon"
            iconVariant="overlay"
            icon="disconnect"
            ?chevron=${false}
            .loading=${this.disconecting}
            @click=${this.onDisconnect.bind(this)}
            data-testid="disconnect-button"
          >
            <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
          </wui-list-item>
        </wui-flex>
      </wui-flex>
    `;
    }
    networksTemplate() {
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, requestedCaipNetworks: requestedCaipNetworks } = (0, $8A6Jz.NetworkController).state;
        const sortedNetworks = (0, $23VhR.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
        return sortedNetworks.map((network)=>(0, $gDLfI.html)`
        <wui-list-network
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getNetworkImage(network))}
          name=${network.name ?? "Unknown"}
          @click=${()=>this.onSwitchNetwork(network)}
        >
        </wui-list-network>
      `);
    }
    async onDisconnect() {
        try {
            this.disconecting = true;
            await (0, $5n5Ql.ConnectionController).disconnect();
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS"
            });
            (0, $nBm8O.ModalController).close();
        } catch  {
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR"
            });
            (0, $dXr1O.SnackController).showError("Failed to disconnect");
        } finally{
            this.disconecting = false;
        }
    }
    async onSwitchNetwork(network) {
        const { isConnected: isConnected } = (0, $7mucr.AccountController).state;
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, supportsAllNetworks: supportsAllNetworks, caipNetwork: caipNetwork } = (0, $8A6Jz.NetworkController).state;
        const { data: data } = (0, $3OaCj.RouterController).state;
        if (isConnected && caipNetwork?.id !== network.id) {
            if (approvedCaipNetworkIds?.includes(network.id)) {
                await (0, $8A6Jz.NetworkController).switchActiveNetwork(network);
                (0, $1hoT1.RouterUtil).navigateAfterNetworkSwitch();
            } else if (supportsAllNetworks) (0, $3OaCj.RouterController).push("SwitchNetwork", {
                ...data,
                network: network
            });
        } else if (!isConnected) {
            (0, $8A6Jz.NetworkController).setCaipNetwork(network);
            (0, $3OaCj.RouterController).push("Connect");
        }
    }
};
$2d6d45fc027f9139$export$db1b0c4a50057bc8.styles = (0, $24ee86e37ea26c5f$export$2e2bcd8739ae039);
$2d6d45fc027f9139$var$__decorate([
    (0, $hdnNF.state)()
], $2d6d45fc027f9139$export$db1b0c4a50057bc8.prototype, "disconecting", void 0);
$2d6d45fc027f9139$export$db1b0c4a50057bc8 = $2d6d45fc027f9139$var$__decorate([
    (0, $3SCaV.customElement)("w3m-unsupported-chain-view")
], $2d6d45fc027f9139$export$db1b0c4a50057bc8);


parcelRequire("3aODI");
var $aHgTP = parcelRequire("aHgTP");
var $3jnn6 = parcelRequire("3jnn6");
var $01g6R = parcelRequire("01g6R");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $ee2d6da5d9d4919e$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-grid {
    max-height: clamp(360px, 400px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
    grid-auto-rows: min-content;
    grid-template-columns: repeat(auto-fill, 76px);
  }

  @media (max-width: 435px) {
    wui-grid {
      grid-template-columns: repeat(auto-fill, 77px);
    }
  }

  wui-grid[data-scroll='false'] {
    overflow: hidden;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }

  wui-loading-spinner {
    padding-top: var(--wui-spacing-l);
    padding-bottom: var(--wui-spacing-l);
    justify-content: center;
    grid-column: 1 / span 4;
  }
`;


parcelRequire("3aODI");
var $01g6R = parcelRequire("01g6R");
function $d91568ebc4a59e4b$export$cffc81df24a1f1f1(wallets) {
    const { connectors: connectors } = (0, $01g6R.ConnectorController).state;
    const installedConnectors = connectors.filter((c)=>c.type === "ANNOUNCED").reduce((acum, val)=>{
        if (!val.info?.rdns) return acum;
        acum[val.info.rdns] = true;
        return acum;
    }, {});
    const walletsWithInstalled = wallets.map((wallet)=>({
            ...wallet,
            installed: Boolean(wallet.rdns) && Boolean(installedConnectors[wallet.rdns ?? ""])
        }));
    const sortedWallets = walletsWithInstalled.sort((a, b)=>Number(b.installed) - Number(a.installed));
    return sortedWallets;
}


var $f33b17b3c276d8be$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $f33b17b3c276d8be$var$PAGINATOR_ID = "local-paginator";
let $f33b17b3c276d8be$export$f39175f9037ce7d2 = class W3mAllWalletsList extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.paginationObserver = undefined;
        this.initial = !(0, $aHgTP.ApiController).state.wallets.length;
        this.wallets = (0, $aHgTP.ApiController).state.wallets;
        this.recommended = (0, $aHgTP.ApiController).state.recommended;
        this.featured = (0, $aHgTP.ApiController).state.featured;
        this.unsubscribe.push(...[
            (0, $aHgTP.ApiController).subscribeKey("wallets", (val)=>this.wallets = val),
            (0, $aHgTP.ApiController).subscribeKey("recommended", (val)=>this.recommended = val),
            (0, $aHgTP.ApiController).subscribeKey("featured", (val)=>this.featured = val)
        ]);
    }
    firstUpdated() {
        this.initialFetch();
        this.createPaginationObserver();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.paginationObserver?.disconnect();
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-grid
        data-scroll=${!this.initial}
        .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}
        columnGap="xxs"
        rowGap="l"
        justifyContent="space-between"
      >
        ${this.initial ? this.shimmerTemplate(16) : this.walletsTemplate()}
        ${this.paginationLoaderTemplate()}
      </wui-grid>
    `;
    }
    async initialFetch() {
        const gridEl = this.shadowRoot?.querySelector("wui-grid");
        if (this.initial && gridEl) {
            await (0, $aHgTP.ApiController).fetchWallets({
                page: 1
            });
            await gridEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.initial = false;
            gridEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    shimmerTemplate(items, id) {
        return [
            ...Array(items)
        ].map(()=>(0, $gDLfI.html)`
        <wui-card-select-loader type="wallet" id=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(id)}></wui-card-select-loader>
      `);
    }
    walletsTemplate() {
        const wallets = [
            ...this.featured,
            ...this.recommended,
            ...this.wallets
        ];
        const walletsWithInstalled = (0, $d91568ebc4a59e4b$export$cffc81df24a1f1f1)(wallets);
        return walletsWithInstalled.map((wallet)=>(0, $gDLfI.html)`
        <wui-card-select
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getWalletImage(wallet))}
          type="wallet"
          name=${wallet.name}
          @click=${()=>this.onConnectWallet(wallet)}
          .installed=${wallet.installed}
        ></wui-card-select>
      `);
    }
    paginationLoaderTemplate() {
        const { wallets: wallets, recommended: recommended, featured: featured, count: count } = (0, $aHgTP.ApiController).state;
        const columns = window.innerWidth < 352 ? 3 : 4;
        const currentWallets = wallets.length + recommended.length;
        const minimumRows = Math.ceil(currentWallets / columns);
        let shimmerCount = minimumRows * columns - currentWallets + columns;
        shimmerCount -= wallets.length ? featured.length % columns : 0;
        if (count === 0 && featured.length > 0) return null;
        if (count === 0 || [
            ...featured,
            ...wallets,
            ...recommended
        ].length < count) return this.shimmerTemplate(shimmerCount, $f33b17b3c276d8be$var$PAGINATOR_ID);
        return null;
    }
    createPaginationObserver() {
        const loaderEl = this.shadowRoot?.querySelector(`#${$f33b17b3c276d8be$var$PAGINATOR_ID}`);
        if (loaderEl) {
            this.paginationObserver = new IntersectionObserver(([element])=>{
                if (element?.isIntersecting && !this.initial) {
                    const { page: page, count: count, wallets: wallets } = (0, $aHgTP.ApiController).state;
                    if (wallets.length < count) (0, $aHgTP.ApiController).fetchWallets({
                        page: page + 1
                    });
                }
            });
            this.paginationObserver.observe(loaderEl);
        }
    }
    onConnectWallet(wallet) {
        const { connectors: connectors } = (0, $01g6R.ConnectorController).state;
        const connector = connectors.find(({ explorerId: explorerId })=>explorerId === wallet.id);
        if (connector) (0, $3OaCj.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $3OaCj.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$f33b17b3c276d8be$export$f39175f9037ce7d2.styles = (0, $ee2d6da5d9d4919e$export$2e2bcd8739ae039);
$f33b17b3c276d8be$var$__decorate([
    (0, $hdnNF.state)()
], $f33b17b3c276d8be$export$f39175f9037ce7d2.prototype, "initial", void 0);
$f33b17b3c276d8be$var$__decorate([
    (0, $hdnNF.state)()
], $f33b17b3c276d8be$export$f39175f9037ce7d2.prototype, "wallets", void 0);
$f33b17b3c276d8be$var$__decorate([
    (0, $hdnNF.state)()
], $f33b17b3c276d8be$export$f39175f9037ce7d2.prototype, "recommended", void 0);
$f33b17b3c276d8be$var$__decorate([
    (0, $hdnNF.state)()
], $f33b17b3c276d8be$export$f39175f9037ce7d2.prototype, "featured", void 0);
$f33b17b3c276d8be$export$f39175f9037ce7d2 = $f33b17b3c276d8be$var$__decorate([
    (0, $3SCaV.customElement)("w3m-all-wallets-list")
], $f33b17b3c276d8be$export$f39175f9037ce7d2);


parcelRequire("3aODI");
var $aHgTP = parcelRequire("aHgTP");
var $3jnn6 = parcelRequire("3jnn6");
var $01g6R = parcelRequire("01g6R");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $70c7ae78dae72aeb$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-grid,
  wui-loading-spinner,
  wui-flex {
    height: 360px;
  }

  wui-grid {
    overflow: scroll;
    scrollbar-width: none;
    grid-auto-rows: min-content;
  }

  wui-grid[data-scroll='false'] {
    overflow: hidden;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }

  wui-loading-spinner {
    justify-content: center;
    align-items: center;
  }
`;



var $22444a7b9397a14b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $22444a7b9397a14b$export$65a744e48142d5af = class W3mAllWalletsSearch extends (0, $dlgVE.LitElement) {
    constructor(){
        super(...arguments);
        this.prevQuery = "";
        this.loading = true;
        this.query = "";
    }
    render() {
        this.onSearch();
        return this.loading ? (0, $gDLfI.html)`<wui-loading-spinner color="accent-100"></wui-loading-spinner>` : this.walletsTemplate();
    }
    async onSearch() {
        if (this.query !== this.prevQuery) {
            this.prevQuery = this.query;
            this.loading = true;
            await (0, $aHgTP.ApiController).searchWallet({
                search: this.query
            });
            this.loading = false;
        }
    }
    walletsTemplate() {
        const { search: search } = (0, $aHgTP.ApiController).state;
        const wallets = (0, $d91568ebc4a59e4b$export$cffc81df24a1f1f1)(search);
        if (!search.length) return (0, $gDLfI.html)`
        <wui-flex justifyContent="center" alignItems="center" gap="s" flexDirection="column">
          <wui-icon-box
            size="lg"
            iconColor="fg-200"
            backgroundColor="fg-300"
            icon="wallet"
            background="transparent"
          ></wui-icon-box>
          <wui-text color="fg-200" variant="paragraph-500">No Wallet found</wui-text>
        </wui-flex>
      `;
        return (0, $gDLfI.html)`
      <wui-grid
        .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}
        gridTemplateColumns="repeat(4, 1fr)"
        rowGap="l"
        columnGap="xs"
      >
        ${wallets.map((wallet)=>(0, $gDLfI.html)`
            <wui-card-select
              imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getWalletImage(wallet))}
              type="wallet"
              name=${wallet.name}
              @click=${()=>this.onConnectWallet(wallet)}
              .installed=${wallet.installed}
            ></wui-card-select>
          `)}
      </wui-grid>
    `;
    }
    onConnectWallet(wallet) {
        const { connectors: connectors } = (0, $01g6R.ConnectorController).state;
        const connector = connectors.find(({ explorerId: explorerId })=>explorerId === wallet.id);
        if (connector) (0, $3OaCj.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $3OaCj.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$22444a7b9397a14b$export$65a744e48142d5af.styles = (0, $70c7ae78dae72aeb$export$2e2bcd8739ae039);
$22444a7b9397a14b$var$__decorate([
    (0, $hdnNF.state)()
], $22444a7b9397a14b$export$65a744e48142d5af.prototype, "loading", void 0);
$22444a7b9397a14b$var$__decorate([
    (0, $8c6bF.property)()
], $22444a7b9397a14b$export$65a744e48142d5af.prototype, "query", void 0);
$22444a7b9397a14b$export$65a744e48142d5af = $22444a7b9397a14b$var$__decorate([
    (0, $3SCaV.customElement)("w3m-all-wallets-search")
], $22444a7b9397a14b$export$65a744e48142d5af);


parcelRequire("3aODI");
var $5n5Ql = parcelRequire("5n5Ql");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $hdnNF = parcelRequire("hdnNF");
var $2ff0ef9ba8ac7423$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2ff0ef9ba8ac7423$export$994bb77f05fbbbde = class W3mConnectingHeader extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.platformTabs = [];
        this.unsubscribe = [];
        this.platforms = [];
        this.onSelectPlatfrom = undefined;
        this.buffering = false;
        this.unsubscribe.push((0, $5n5Ql.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val));
    }
    disconnectCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const tabs = this.generateTabs();
        return (0, $gDLfI.html)`
      <wui-flex justifyContent="center" .padding=${[
            "l",
            "0",
            "0",
            "0"
        ]}>
        <wui-tabs
          ?disabled=${this.buffering}
          .tabs=${tabs}
          .onTabChange=${this.onTabChange.bind(this)}
        ></wui-tabs>
      </wui-flex>
    `;
    }
    generateTabs() {
        const tabs = this.platforms.map((platform)=>{
            if (platform === "browser") return {
                label: "Browser",
                icon: "extension",
                platform: "browser"
            };
            else if (platform === "mobile") return {
                label: "Mobile",
                icon: "mobile",
                platform: "mobile"
            };
            else if (platform === "qrcode") return {
                label: "Mobile",
                icon: "mobile",
                platform: "qrcode"
            };
            else if (platform === "web") return {
                label: "Webapp",
                icon: "browser",
                platform: "web"
            };
            else if (platform === "desktop") return {
                label: "Desktop",
                icon: "desktop",
                platform: "desktop"
            };
            return {
                label: "Browser",
                icon: "extension",
                platform: "unsupported"
            };
        });
        this.platformTabs = tabs.map(({ platform: platform })=>platform);
        return tabs;
    }
    onTabChange(index) {
        const tab = this.platformTabs[index];
        if (tab) this.onSelectPlatfrom?.(tab);
    }
};
$2ff0ef9ba8ac7423$var$__decorate([
    (0, $8c6bF.property)({
        type: Array
    })
], $2ff0ef9ba8ac7423$export$994bb77f05fbbbde.prototype, "platforms", void 0);
$2ff0ef9ba8ac7423$var$__decorate([
    (0, $8c6bF.property)()
], $2ff0ef9ba8ac7423$export$994bb77f05fbbbde.prototype, "onSelectPlatfrom", void 0);
$2ff0ef9ba8ac7423$var$__decorate([
    (0, $hdnNF.state)()
], $2ff0ef9ba8ac7423$export$994bb77f05fbbbde.prototype, "buffering", void 0);
$2ff0ef9ba8ac7423$export$994bb77f05fbbbde = $2ff0ef9ba8ac7423$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-header")
], $2ff0ef9ba8ac7423$export$994bb77f05fbbbde);


parcelRequire("3aODI");
var $5n5Ql = parcelRequire("5n5Ql");
var $01g6R = parcelRequire("01g6R");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");

var $29c755f1de32ce37$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $29c755f1de32ce37$export$f6b6073753ecd240 = class W3mConnectingWcBrowser extends (0, $3f6a710230e36221$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-browser: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onAutoConnect = this.onConnectProxy.bind(this);
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "browser"
            }
        });
    }
    async onConnectProxy() {
        try {
            this.error = false;
            const { connectors: connectors } = (0, $01g6R.ConnectorController).state;
            const announcedConnector = connectors.find((c)=>c.type === "ANNOUNCED" && c.info?.rdns === this.wallet?.rdns);
            const injectedConnector = connectors.find((c)=>c.type === "INJECTED");
            if (announcedConnector) await (0, $5n5Ql.ConnectionController).connectExternal(announcedConnector);
            else if (injectedConnector) await (0, $5n5Ql.ConnectionController).connectExternal(injectedConnector);
            (0, $nBm8O.ModalController).close();
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_SUCCESS",
                properties: {
                    method: "browser"
                }
            });
        } catch (error) {
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            this.error = true;
        }
    }
};
$29c755f1de32ce37$export$f6b6073753ecd240 = $29c755f1de32ce37$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-wc-browser")
], $29c755f1de32ce37$export$f6b6073753ecd240);


parcelRequire("3aODI");
var $5n5Ql = parcelRequire("5n5Ql");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");

var $9d73cc8d7a51ae5c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9d73cc8d7a51ae5c$export$99d24518d9937f53 = class W3mConnectingWcDesktop extends (0, $3f6a710230e36221$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-desktop: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onRender = this.onRenderProxy.bind(this);
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "desktop"
            }
        });
    }
    onRenderProxy() {
        if (!this.ready && this.uri) {
            this.ready = true;
            this.timeout = setTimeout(()=>{
                this.onConnect?.();
            }, 200);
        }
    }
    onConnectProxy() {
        if (this.wallet?.desktop_link && this.uri) try {
            this.error = false;
            const { desktop_link: desktop_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $23VhR.CoreHelperUtil).formatNativeUrl(desktop_link, this.uri);
            (0, $5n5Ql.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $5n5Ql.ConnectionController).setRecentWallet(this.wallet);
            (0, $23VhR.CoreHelperUtil).openHref(redirect, "_blank");
        } catch  {
            this.error = true;
        }
    }
};
$9d73cc8d7a51ae5c$export$99d24518d9937f53 = $9d73cc8d7a51ae5c$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-wc-desktop")
], $9d73cc8d7a51ae5c$export$99d24518d9937f53);


parcelRequire("3aODI");
var $5n5Ql = parcelRequire("5n5Ql");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");

var $0c20cfbc4b020e45$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0c20cfbc4b020e45$export$bde153011a6b26 = class W3mConnectingWcMobile extends (0, $3f6a710230e36221$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-mobile: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onRender = this.onRenderProxy.bind(this);
        document.addEventListener("visibilitychange", this.onBuffering.bind(this));
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "mobile"
            }
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("visibilitychange", this.onBuffering.bind(this));
    }
    onRenderProxy() {
        if (!this.ready && this.uri) {
            this.ready = true;
            this.onConnect?.();
        }
    }
    onConnectProxy() {
        if (this.wallet?.mobile_link && this.uri) try {
            this.error = false;
            const { mobile_link: mobile_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $23VhR.CoreHelperUtil).formatNativeUrl(mobile_link, this.uri);
            (0, $5n5Ql.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $5n5Ql.ConnectionController).setRecentWallet(this.wallet);
            (0, $23VhR.CoreHelperUtil).openHref(redirect, "_self");
        } catch  {
            this.error = true;
        }
    }
    onBuffering() {
        const isIos = (0, $23VhR.CoreHelperUtil).isIos();
        if (document?.visibilityState === "visible" && !this.error && isIos) {
            (0, $5n5Ql.ConnectionController).setBuffering(true);
            setTimeout(()=>{
                (0, $5n5Ql.ConnectionController).setBuffering(false);
            }, 5000);
        }
    }
};
$0c20cfbc4b020e45$export$bde153011a6b26 = $0c20cfbc4b020e45$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-wc-mobile")
], $0c20cfbc4b020e45$export$bde153011a6b26);


parcelRequire("3aODI");
var $3jnn6 = parcelRequire("3jnn6");
var $5n5Ql = parcelRequire("5n5Ql");
var $dUlgM = parcelRequire("dUlgM");
var $jGPEs = parcelRequire("jGPEs");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");


parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $ac869de445e6bc07$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  wui-shimmer {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px) !important;
  }

  wui-qr-code {
    opacity: 0;
    animation-duration: 200ms;
    animation-timing-function: ease;
    animation-name: fadein;
    animation-fill-mode: forwards;
  }
`;


var $1847799c72cb5a8d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1847799c72cb5a8d$export$d4369b1b68d9b78a = class W3mConnectingWcQrcode extends (0, $3f6a710230e36221$export$902e3cfa9f67689d) {
    constructor(){
        super();
        this.forceUpdate = ()=>{
            this.requestUpdate();
        };
        window.addEventListener("resize", this.forceUpdate);
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet?.name ?? "WalletConnect",
                platform: "qrcode"
            }
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("resize", this.forceUpdate);
    }
    render() {
        this.onRenderProxy();
        return (0, $gDLfI.html)`
      <wui-flex padding="xl" flexDirection="column" gap="xl" alignItems="center">
        <wui-shimmer borderRadius="l" width="100%"> ${this.qrCodeTemplate()} </wui-shimmer>

        <wui-text variant="paragraph-500" color="fg-100">
          Scan this QR Code with your phone
        </wui-text>
        ${this.copyTemplate()}
      </wui-flex>

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
    onRenderProxy() {
        if (!this.ready && this.uri) this.timeout = setTimeout(()=>{
            this.ready = true;
        }, 200);
    }
    qrCodeTemplate() {
        if (!this.uri || !this.ready) return null;
        const size = this.getBoundingClientRect().width - 40;
        const alt = this.wallet ? this.wallet.name : undefined;
        (0, $5n5Ql.ConnectionController).setWcLinking(undefined);
        (0, $5n5Ql.ConnectionController).setRecentWallet(this.wallet);
        return (0, $gDLfI.html)` <wui-qr-code
      size=${size}
      theme=${(0, $jGPEs.ThemeController).state.themeMode}
      uri=${this.uri}
      imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getWalletImage(this.wallet))}
      alt=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(alt)}
      data-testid="wui-qr-code"
    ></wui-qr-code>`;
    }
    copyTemplate() {
        const inactive = !this.uri || !this.ready;
        return (0, $gDLfI.html)`<wui-link
      .disabled=${inactive}
      @click=${this.onCopyUri}
      color="fg-200"
      data-testid="copy-wc2-uri"
    >
      <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
      Copy link
    </wui-link>`;
    }
};
$1847799c72cb5a8d$export$d4369b1b68d9b78a.styles = (0, $ac869de445e6bc07$export$2e2bcd8739ae039);
$1847799c72cb5a8d$export$d4369b1b68d9b78a = $1847799c72cb5a8d$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-wc-qrcode")
], $1847799c72cb5a8d$export$d4369b1b68d9b78a);


parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $1f288d67f441fd51$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host {
    display: flex;
    justify-content: center;
    gap: var(--wui-spacing-2xl);
  }

  wui-visual-thumbnail:nth-child(1) {
    z-index: 1;
  }
`;


parcelRequire("3aODI");
var $cPOJT = parcelRequire("cPOJT");
var $6sZsT = parcelRequire("6sZsT");
var $bd4dc58f31dcf164$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bd4dc58f31dcf164$export$415fdf721000461b = class W3mConnectingSiwe extends (0, $dlgVE.LitElement) {
    constructor(){
        super(...arguments);
        this.dappImageUrl = (0, $cPOJT.OptionsController).state.metadata?.icons;
        this.walletImageUrl = (0, $6sZsT.StorageUtil).getConnectedWalletImageUrl();
    }
    firstUpdated() {
        const visuals = this.shadowRoot?.querySelectorAll("wui-visual-thumbnail");
        if (visuals?.[0]) this.createAnimation(visuals[0], "translate(18px)");
        if (visuals?.[1]) this.createAnimation(visuals[1], "translate(-18px)");
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-visual-thumbnail
        ?borderRadiusFull=${true}
        .imageSrc=${this.dappImageUrl?.[0]}
      ></wui-visual-thumbnail>
      <wui-visual-thumbnail .imageSrc=${this.walletImageUrl}></wui-visual-thumbnail>
    `;
    }
    createAnimation(element, translation) {
        element.animate([
            {
                transform: "translateX(0px)"
            },
            {
                transform: translation
            }
        ], {
            duration: 1600,
            easing: "cubic-bezier(0.56, 0, 0.48, 1)",
            direction: "alternate",
            iterations: Infinity
        });
    }
};
$bd4dc58f31dcf164$export$415fdf721000461b.styles = (0, $1f288d67f441fd51$export$2e2bcd8739ae039);
$bd4dc58f31dcf164$export$415fdf721000461b = $bd4dc58f31dcf164$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-siwe")
], $bd4dc58f31dcf164$export$415fdf721000461b);


parcelRequire("3aODI");
var $3jnn6 = parcelRequire("3jnn6");
var $dUlgM = parcelRequire("dUlgM");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");

var $a931ff5a44cec845$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a931ff5a44cec845$export$8ced6ff0971fe41b = class W3mConnectingWcUnsupported extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.wallet = (0, $3OaCj.RouterController).state.data?.wallet;
        if (!this.wallet) throw new Error("w3m-connecting-wc-unsupported: No wallet provided");
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "browser"
            }
        });
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-wallet-image
          size="lg"
          imageSrc=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)((0, $3jnn6.AssetUtil).getWalletImage(this.wallet))}
        ></wui-wallet-image>

        <wui-text variant="paragraph-500" color="fg-100">Not Detected</wui-text>
      </wui-flex>

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
};
$a931ff5a44cec845$export$8ced6ff0971fe41b = $a931ff5a44cec845$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-wc-unsupported")
], $a931ff5a44cec845$export$8ced6ff0971fe41b);


parcelRequire("3aODI");
var $5n5Ql = parcelRequire("5n5Ql");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");

var $71fc6ad6879b2aff$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $71fc6ad6879b2aff$export$bdfe677b483cfd66 = class W3mConnectingWcWeb extends (0, $3f6a710230e36221$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-web: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.secondaryBtnLabel = "Open";
        this.secondaryLabel = "Open and continue in a new browser tab";
        this.secondaryBtnIcon = "externalLink";
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "web"
            }
        });
    }
    onConnectProxy() {
        if (this.wallet?.webapp_link && this.uri) try {
            this.error = false;
            const { webapp_link: webapp_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $23VhR.CoreHelperUtil).formatUniversalUrl(webapp_link, this.uri);
            (0, $5n5Ql.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $5n5Ql.ConnectionController).setRecentWallet(this.wallet);
            (0, $23VhR.CoreHelperUtil).openHref(redirect, "_blank");
        } catch  {
            this.error = true;
        }
    }
};
$71fc6ad6879b2aff$export$bdfe677b483cfd66 = $71fc6ad6879b2aff$var$__decorate([
    (0, $3SCaV.customElement)("w3m-connecting-wc-web")
], $71fc6ad6879b2aff$export$bdfe677b483cfd66);


parcelRequire("3aODI");
var $5n5Ql = parcelRequire("5n5Ql");
var $01g6R = parcelRequire("01g6R");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $3OaCj = parcelRequire("3OaCj");
var $jIUUu = parcelRequire("jIUUu");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $c963435eca88eee6$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-icon-link[data-hidden='true'] {
    opacity: 0 !important;
    pointer-events: none;
  }
`;


var $26b5029554fa8cd9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function $26b5029554fa8cd9$var$headings() {
    const connectorName = (0, $3OaCj.RouterController).state.data?.connector?.name;
    const walletName = (0, $3OaCj.RouterController).state.data?.wallet?.name;
    const networkName = (0, $3OaCj.RouterController).state.data?.network?.name;
    const name = walletName ?? connectorName;
    const connectors = (0, $01g6R.ConnectorController).getConnectors();
    const isEmail = connectors.length === 1 && connectors[0]?.id === "w3m-email";
    return {
        Connect: `Connect ${isEmail ? "Email" : ""} Wallet`,
        Account: undefined,
        AccountSettings: undefined,
        ConnectingExternal: name ?? "Connect Wallet",
        ConnectingWalletConnect: name ?? "WalletConnect",
        ConnectingSiwe: "Sign In",
        Networks: "Choose Network",
        SwitchNetwork: networkName ?? "Switch Network",
        AllWallets: "All Wallets",
        WhatIsANetwork: "What is a network?",
        WhatIsAWallet: "What is a wallet?",
        GetWallet: "Get a wallet",
        Downloads: name ? `Get ${name}` : "Downloads",
        EmailVerifyOtp: "Confirm Email",
        EmailVerifyDevice: "Register Device",
        ApproveTransaction: "Approve Transaction",
        Transactions: "Activity",
        UpgradeEmailWallet: "Upgrade your Wallet",
        UpdateEmailWallet: "Edit Email",
        UpdateEmailPrimaryOtp: "Confirm Current Email",
        UpdateEmailSecondaryOtp: "Confirm New Email",
        UnsupportedChain: "Switch Network",
        OnRampProviders: "Choose Provider",
        OnRampActivity: "Activity",
        WhatIsABuy: "What is Buy?",
        BuyInProgress: "Buy",
        OnRampTokenSelect: "Select Token",
        OnRampFiatSelect: "Select Currency"
    };
}
let $26b5029554fa8cd9$export$c6714271d9f13670 = class W3mHeader extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.heading = $26b5029554fa8cd9$var$headings()[(0, $3OaCj.RouterController).state.view];
        this.buffering = false;
        this.showBack = false;
        this.unsubscribe.push((0, $3OaCj.RouterController).subscribeKey("view", (val)=>{
            this.onViewChange(val);
            this.onHistoryChange();
        }), (0, $5n5Ql.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val));
    }
    disconnectCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex .padding=${this.getPadding()} justifyContent="space-between" alignItems="center">
        ${this.dynamicButtonTemplate()} ${this.titleTemplate()}
        <wui-icon-link
          ?disabled=${this.buffering}
          icon="close"
          @click=${this.onClose.bind(this)}
          data-testid="w3m-header-close"
        ></wui-icon-link>
      </wui-flex>
      ${this.separatorTemplate()}
    `;
    }
    onWalletHelp() {
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "CLICK_WALLET_HELP"
        });
        (0, $3OaCj.RouterController).push("WhatIsAWallet");
    }
    async onClose() {
        if ((0, $jIUUu.SIWEController).state.isSiweEnabled && (0, $jIUUu.SIWEController).state.status !== "success") await (0, $5n5Ql.ConnectionController).disconnect();
        (0, $nBm8O.ModalController).close();
    }
    titleTemplate() {
        return (0, $gDLfI.html)`<wui-text variant="paragraph-700" color="fg-100">${this.heading}</wui-text>`;
    }
    dynamicButtonTemplate() {
        const { view: view } = (0, $3OaCj.RouterController).state;
        const isConnectHelp = view === "Connect";
        const isApproveTransaction = view === "ApproveTransaction";
        if (this.showBack && !isApproveTransaction) return (0, $gDLfI.html)`<wui-icon-link
        id="dynamic"
        icon="chevronLeft"
        ?disabled=${this.buffering}
        @click=${this.onGoBack.bind(this)}
      ></wui-icon-link>`;
        return (0, $gDLfI.html)`<wui-icon-link
      data-hidden=${!isConnectHelp}
      id="dynamic"
      icon="helpCircle"
      @click=${this.onWalletHelp.bind(this)}
    ></wui-icon-link>`;
    }
    separatorTemplate() {
        if (!this.heading) return null;
        return (0, $gDLfI.html)`<wui-separator></wui-separator>`;
    }
    getPadding() {
        if (this.heading) return [
            "l",
            "2l",
            "l",
            "2l"
        ];
        return [
            "l",
            "2l",
            "0",
            "2l"
        ];
    }
    async onViewChange(view) {
        const headingEl = this.shadowRoot?.querySelector("wui-text");
        if (headingEl) {
            const preset = $26b5029554fa8cd9$var$headings()[view];
            await headingEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.heading = preset;
            headingEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    async onHistoryChange() {
        const { history: history } = (0, $3OaCj.RouterController).state;
        const buttonEl = this.shadowRoot?.querySelector("#dynamic");
        if (history.length > 1 && !this.showBack && buttonEl) {
            await buttonEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.showBack = true;
            buttonEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        } else if (history.length <= 1 && this.showBack && buttonEl) {
            await buttonEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.showBack = false;
            buttonEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    onGoBack() {
        if ((0, $3OaCj.RouterController).state.view === "ConnectingSiwe") (0, $3OaCj.RouterController).push("Connect");
        else (0, $3OaCj.RouterController).goBack();
    }
};
$26b5029554fa8cd9$export$c6714271d9f13670.styles = [
    (0, $c963435eca88eee6$export$2e2bcd8739ae039)
];
$26b5029554fa8cd9$var$__decorate([
    (0, $hdnNF.state)()
], $26b5029554fa8cd9$export$c6714271d9f13670.prototype, "heading", void 0);
$26b5029554fa8cd9$var$__decorate([
    (0, $hdnNF.state)()
], $26b5029554fa8cd9$export$c6714271d9f13670.prototype, "buffering", void 0);
$26b5029554fa8cd9$var$__decorate([
    (0, $hdnNF.state)()
], $26b5029554fa8cd9$export$c6714271d9f13670.prototype, "showBack", void 0);
$26b5029554fa8cd9$export$c6714271d9f13670 = $26b5029554fa8cd9$var$__decorate([
    (0, $3SCaV.customElement)("w3m-header")
], $26b5029554fa8cd9$export$c6714271d9f13670);


parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $7c1546baf325d1d2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7c1546baf325d1d2$export$c95abd0ceed44b88 = class W3mHelpWidget extends (0, $dlgVE.LitElement) {
    constructor(){
        super(...arguments);
        this.data = [];
    }
    render() {
        return (0, $gDLfI.html)`
      <wui-flex flexDirection="column" alignItems="center" gap="l">
        ${this.data.map((item)=>(0, $gDLfI.html)`
            <wui-flex flexDirection="column" alignItems="center" gap="xl">
              <wui-flex flexDirection="row" justifyContent="center" gap="1xs">
                ${item.images.map((image)=>(0, $gDLfI.html)`<wui-visual name=${image}></wui-visual>`)}
              </wui-flex>
            </wui-flex>
            <wui-flex flexDirection="column" alignItems="center" gap="xxs">
              <wui-text variant="paragraph-500" color="fg-100" align="center">
                ${item.title}
              </wui-text>
              <wui-text variant="small-500" color="fg-200" align="center">${item.text}</wui-text>
            </wui-flex>
          `)}
      </wui-flex>
    `;
    }
};
$7c1546baf325d1d2$var$__decorate([
    (0, $8c6bF.property)({
        type: Array
    })
], $7c1546baf325d1d2$export$c95abd0ceed44b88.prototype, "data", void 0);
$7c1546baf325d1d2$export$c95abd0ceed44b88 = $7c1546baf325d1d2$var$__decorate([
    (0, $3SCaV.customElement)("w3m-help-widget")
], $7c1546baf325d1d2$export$c95abd0ceed44b88);


parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $52419f1337f91604$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host {
    width: 100%;
  }

  wui-loading-spinner {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
  }

  .currency-container {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: all var(--wui-ease-in-power-2) var(--wui-duration-md);
    right: var(--wui-spacing-1xs);
    height: 40px;
    padding: var(--wui-spacing-xs) var(--wui-spacing-1xs) var(--wui-spacing-xs)
      var(--wui-spacing-xs);
    min-width: 95px;
    border-radius: var(--FULL, 1000px);
    border: 1px solid var(--wui-gray-glass-002);
    background: var(--wui-gray-glass-002);
    cursor: pointer;
  }

  .currency-container > wui-image {
    height: 24px;
    width: 24px;
    border-radius: 50%;
  }
`;


parcelRequire("3aODI");
var $b2pRm = parcelRequire("b2pRm");
var $nBm8O = parcelRequire("nBm8O");
var $79hu3 = parcelRequire("79hu3");
var $f58e01c1f6b07943$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f58e01c1f6b07943$export$8c7f6376138a05de = class W3mInputCurrency extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.type = "Token";
        this.value = 0;
        this.currencies = [];
        this.selectedCurrency = this.currencies?.[0];
        this.currencyImages = (0, $b2pRm.AssetController).state.currencyImages;
        this.tokenImages = (0, $b2pRm.AssetController).state.tokenImages;
        this.unsubscribe.push((0, $79hu3.OnRampController).subscribeKey("purchaseCurrency", (val)=>{
            if (!val || this.type === "Fiat") return;
            this.selectedCurrency = this.formatPurchaseCurrency(val);
        }), (0, $79hu3.OnRampController).subscribeKey("paymentCurrency", (val)=>{
            if (!val || this.type === "Token") return;
            this.selectedCurrency = this.formatPaymentCurrency(val);
        }), (0, $79hu3.OnRampController).subscribe((val)=>{
            if (this.type === "Fiat") this.currencies = val.purchaseCurrencies.map(this.formatPurchaseCurrency);
            else this.currencies = val.paymentCurrencies.map(this.formatPaymentCurrency);
        }), (0, $b2pRm.AssetController).subscribe((val)=>{
            this.currencyImages = {
                ...val.currencyImages
            };
            this.tokenImages = {
                ...val.tokenImages
            };
        }));
    }
    firstUpdated() {
        (0, $79hu3.OnRampController).getAvailableCurrencies();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const symbol = this.selectedCurrency?.symbol || "";
        const image = this.currencyImages[symbol] || this.tokenImages[symbol];
        return (0, $gDLfI.html)` <wui-input-text type="number" size="lg" value=${this.value}>
      ${this.selectedCurrency ? (0, $gDLfI.html)` <wui-flex
            class="currency-container"
            justifyContent="space-between"
            alignItems="center"
            gap="xxs"
            @click=${()=>(0, $nBm8O.ModalController).open({
                view: `OnRamp${this.type}Select`
            })}
          >
            <wui-image src=${(0, $dc204ff36aaf54c6$export$f68dd208b5df064d)(image)}></wui-image>
            <wui-text color="fg-100"> ${this.selectedCurrency.symbol} </wui-text>
          </wui-flex>` : (0, $gDLfI.html)`<wui-loading-spinner></wui-loading-spinner>`}
    </wui-input-text>`;
    }
    formatPaymentCurrency(currency) {
        return {
            name: currency.id,
            symbol: currency.id
        };
    }
    formatPurchaseCurrency(currency) {
        return {
            name: currency.name,
            symbol: currency.symbol
        };
    }
};
$f58e01c1f6b07943$export$8c7f6376138a05de.styles = (0, $52419f1337f91604$export$2e2bcd8739ae039);
$f58e01c1f6b07943$var$__decorate([
    (0, $8c6bF.property)({
        type: String
    })
], $f58e01c1f6b07943$export$8c7f6376138a05de.prototype, "type", void 0);
$f58e01c1f6b07943$var$__decorate([
    (0, $8c6bF.property)({
        type: Number
    })
], $f58e01c1f6b07943$export$8c7f6376138a05de.prototype, "value", void 0);
$f58e01c1f6b07943$var$__decorate([
    (0, $hdnNF.state)()
], $f58e01c1f6b07943$export$8c7f6376138a05de.prototype, "currencies", void 0);
$f58e01c1f6b07943$var$__decorate([
    (0, $hdnNF.state)()
], $f58e01c1f6b07943$export$8c7f6376138a05de.prototype, "selectedCurrency", void 0);
$f58e01c1f6b07943$var$__decorate([
    (0, $hdnNF.state)()
], $f58e01c1f6b07943$export$8c7f6376138a05de.prototype, "currencyImages", void 0);
$f58e01c1f6b07943$var$__decorate([
    (0, $hdnNF.state)()
], $f58e01c1f6b07943$export$8c7f6376138a05de.prototype, "tokenImages", void 0);
$f58e01c1f6b07943$export$8c7f6376138a05de = $f58e01c1f6b07943$var$__decorate([
    (0, $3SCaV.customElement)("w3m-swap-input")
], $f58e01c1f6b07943$export$8c7f6376138a05de);


parcelRequire("3aODI");
var $cPOJT = parcelRequire("cPOJT");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $51fe2fa989de2e05$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-flex {
    background-color: var(--wui-gray-glass-005);
  }

  a {
    text-decoration: none;
    color: var(--wui-color-fg-175);
    font-weight: 500;
  }
`;


var $e25c327947dc1870$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e25c327947dc1870$export$c463b51fb31743f5 = class W3mLegalFooter extends (0, $dlgVE.LitElement) {
    render() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $cPOJT.OptionsController).state;
        if (!termsConditionsUrl && !privacyPolicyUrl) return null;
        return (0, $gDLfI.html)`
      <wui-flex .padding=${[
            "m",
            "s",
            "s",
            "s"
        ]} justifyContent="center">
        <wui-text color="fg-250" variant="small-400" align="center">
          By connecting your wallet, you agree to our <br />
          ${this.termsTemplate()} ${this.andTemplate()} ${this.privacyTemplate()}
        </wui-text>
      </wui-flex>
    `;
    }
    andTemplate() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $cPOJT.OptionsController).state;
        return termsConditionsUrl && privacyPolicyUrl ? "and" : "";
    }
    termsTemplate() {
        const { termsConditionsUrl: termsConditionsUrl } = (0, $cPOJT.OptionsController).state;
        if (!termsConditionsUrl) return null;
        return (0, $gDLfI.html)`<a href=${termsConditionsUrl}>Terms of Service</a>`;
    }
    privacyTemplate() {
        const { privacyPolicyUrl: privacyPolicyUrl } = (0, $cPOJT.OptionsController).state;
        if (!privacyPolicyUrl) return null;
        return (0, $gDLfI.html)`<a href=${privacyPolicyUrl}>Privacy Policy</a>`;
    }
};
$e25c327947dc1870$export$c463b51fb31743f5.styles = [
    (0, $51fe2fa989de2e05$export$2e2bcd8739ae039)
];
$e25c327947dc1870$export$c463b51fb31743f5 = $e25c327947dc1870$var$__decorate([
    (0, $3SCaV.customElement)("w3m-legal-footer")
], $e25c327947dc1870$export$c463b51fb31743f5);


parcelRequire("3aODI");
var $23VhR = parcelRequire("23VhR");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
var $fRkfl = parcelRequire("fRkfl");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $8c6bF = parcelRequire("8c6bF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $ad7ba6fc65ed6fcf$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host {
    display: block;
    padding: 0 var(--wui-spacing-xl) var(--wui-spacing-xl);
  }
`;


var $7a918eb3f9961869$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7a918eb3f9961869$export$eabbdf5c2372470b = class W3mMobileDownloadLinks extends (0, $dlgVE.LitElement) {
    constructor(){
        super(...arguments);
        this.wallet = undefined;
    }
    render() {
        if (!this.wallet) {
            this.style.display = "none";
            return null;
        }
        const { name: name, app_store: app_store, play_store: play_store, chrome_store: chrome_store, homepage: homepage } = this.wallet;
        const isMobile = (0, $23VhR.CoreHelperUtil).isMobile();
        const isIos = (0, $23VhR.CoreHelperUtil).isIos();
        const isAndroid = (0, $23VhR.CoreHelperUtil).isAndroid();
        const isMultiple = [
            app_store,
            play_store,
            homepage,
            chrome_store
        ].filter(Boolean).length > 1;
        const shortName = (0, $fRkfl.UiHelperUtil).getTruncateString({
            string: name,
            charsStart: 12,
            charsEnd: 0,
            truncate: "end"
        });
        if (isMultiple && !isMobile) return (0, $gDLfI.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${()=>(0, $3OaCj.RouterController).push("Downloads", {
                wallet: this.wallet
            })}
        ></wui-cta-button>
      `;
        if (!isMultiple && homepage) return (0, $gDLfI.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onHomePage.bind(this)}
        ></wui-cta-button>
      `;
        if (app_store && isIos) return (0, $gDLfI.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onAppStore.bind(this)}
        ></wui-cta-button>
      `;
        if (play_store && isAndroid) return (0, $gDLfI.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onPlayStore.bind(this)}
        ></wui-cta-button>
      `;
        this.style.display = "none";
        return null;
    }
    onAppStore() {
        if (this.wallet?.app_store) (0, $23VhR.CoreHelperUtil).openHref(this.wallet.app_store, "_blank");
    }
    onPlayStore() {
        if (this.wallet?.play_store) (0, $23VhR.CoreHelperUtil).openHref(this.wallet.play_store, "_blank");
    }
    onHomePage() {
        if (this.wallet?.homepage) (0, $23VhR.CoreHelperUtil).openHref(this.wallet.homepage, "_blank");
    }
};
$7a918eb3f9961869$export$eabbdf5c2372470b.styles = [
    (0, $ad7ba6fc65ed6fcf$export$2e2bcd8739ae039)
];
$7a918eb3f9961869$var$__decorate([
    (0, $8c6bF.property)({
        type: Object
    })
], $7a918eb3f9961869$export$eabbdf5c2372470b.prototype, "wallet", void 0);
$7a918eb3f9961869$export$eabbdf5c2372470b = $7a918eb3f9961869$var$__decorate([
    (0, $3SCaV.customElement)("w3m-mobile-download-links")
], $7a918eb3f9961869$export$eabbdf5c2372470b);


parcelRequire("3aODI");
var $cPOJT = parcelRequire("cPOJT");
var $3OaCj = parcelRequire("3OaCj");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $20522348deffe65e$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-flex {
    border-top: 1px solid var(--wui-gray-glass-005);
  }

  a {
    text-decoration: none;
    color: var(--wui-color-fg-175);
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--wui-spacing-3xs);
  }
`;


var $b00e57e101722599$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b00e57e101722599$export$1877b66553939a5b = class W3mOnRampProvidersFooter extends (0, $dlgVE.LitElement) {
    render() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $cPOJT.OptionsController).state;
        if (!termsConditionsUrl && !privacyPolicyUrl) return null;
        return (0, $gDLfI.html)`
      <wui-flex
        .padding=${[
            "m",
            "s",
            "s",
            "s"
        ]}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="s"
      >
        <wui-text color="fg-250" variant="small-400" align="center">
          We work with the best providers to fit your buyer needs, region, and to get you the lowest
          fees
        </wui-text>

        ${this.whatIsBuyTemplate()}
      </wui-flex>
    `;
    }
    whatIsBuyTemplate() {
        return (0, $gDLfI.html)` <wui-link @click=${this.onWhatIsBuy.bind(this)}>
      <wui-icon size="xs" color="accent-100" slot="iconLeft" name="helpCircle"></wui-icon>
      What is Buy
    </wui-link>`;
    }
    onWhatIsBuy() {
        (0, $3OaCj.RouterController).push("WhatIsABuy");
    }
};
$b00e57e101722599$export$1877b66553939a5b.styles = [
    (0, $20522348deffe65e$export$2e2bcd8739ae039)
];
$b00e57e101722599$export$1877b66553939a5b = $b00e57e101722599$var$__decorate([
    (0, $3SCaV.customElement)("w3m-onramp-providers-footer")
], $b00e57e101722599$export$1877b66553939a5b);


parcelRequire("3aODI");
var $dXr1O = parcelRequire("dXr1O");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");
parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $f1ee03c554765860$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  :host {
    display: block;
    position: absolute;
    opacity: 0;
    pointer-events: none;
    top: 11px;
    left: 50%;
    width: max-content;
  }
`;


var $60ff4fed606854cf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $60ff4fed606854cf$var$presets = {
    success: {
        backgroundColor: "success-100",
        iconColor: "success-100",
        icon: "checkmark"
    },
    error: {
        backgroundColor: "error-100",
        iconColor: "error-100",
        icon: "close"
    }
};
let $60ff4fed606854cf$export$a84538312ac1ab9d = class W3mSnackBar extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.timeout = undefined;
        this.open = (0, $dXr1O.SnackController).state.open;
        this.unsubscribe.push((0, $dXr1O.SnackController).subscribeKey("open", (val)=>{
            this.open = val;
            this.onOpen();
        }));
    }
    disconnectedCallback() {
        clearTimeout(this.timeout);
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const { message: message, variant: variant } = (0, $dXr1O.SnackController).state;
        const preset = $60ff4fed606854cf$var$presets[variant];
        return (0, $gDLfI.html)`
      <wui-snackbar
        message=${message}
        backgroundColor=${preset.backgroundColor}
        iconColor=${preset.iconColor}
        icon=${preset.icon}
      ></wui-snackbar>
    `;
    }
    onOpen() {
        clearTimeout(this.timeout);
        if (this.open) {
            this.animate([
                {
                    opacity: 0,
                    transform: "translateX(-50%) scale(0.85)"
                },
                {
                    opacity: 1,
                    transform: "translateX(-50%) scale(1)"
                }
            ], {
                duration: 150,
                fill: "forwards",
                easing: "ease"
            });
            this.timeout = setTimeout(()=>(0, $dXr1O.SnackController).hide(), 2500);
        } else this.animate([
            {
                opacity: 1,
                transform: "translateX(-50%) scale(1)"
            },
            {
                opacity: 0,
                transform: "translateX(-50%) scale(0.85)"
            }
        ], {
            duration: 150,
            fill: "forwards",
            easing: "ease"
        });
    }
};
$60ff4fed606854cf$export$a84538312ac1ab9d.styles = (0, $f1ee03c554765860$export$2e2bcd8739ae039);
$60ff4fed606854cf$var$__decorate([
    (0, $hdnNF.state)()
], $60ff4fed606854cf$export$a84538312ac1ab9d.prototype, "open", void 0);
$60ff4fed606854cf$export$a84538312ac1ab9d = $60ff4fed606854cf$var$__decorate([
    (0, $3SCaV.customElement)("w3m-snackbar")
], $60ff4fed606854cf$export$a84538312ac1ab9d);


parcelRequire("3aODI");
var $01g6R = parcelRequire("01g6R");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
var $3OaCj = parcelRequire("3OaCj");
var $dXr1O = parcelRequire("dXr1O");
parcelRequire("1oeam");
var $3SCaV = parcelRequire("3SCaV");
parcelRequire("4Jfqv");
var $gDLfI = parcelRequire("gDLfI");
var $dlgVE = parcelRequire("dlgVE");
parcelRequire("bkCde");
var $hdnNF = parcelRequire("hdnNF");

parcelRequire("4Jfqv");
var $88H1e = parcelRequire("88H1e");
var $0630c72ada64745f$export$2e2bcd8739ae039 = (0, $88H1e.css)`
  wui-separator {
    margin: var(--wui-spacing-s) calc(var(--wui-spacing-s) * -1);
    width: calc(100% + var(--wui-spacing-s) * 2);
  }

  wui-email-input {
    width: 100%;
  }

  form {
    width: 100%;
    display: block;
    position: relative;
  }

  wui-icon-link,
  wui-loading-spinner {
    position: absolute;
    top: 21px;
    transform: translateY(-50%);
  }

  wui-icon-link {
    right: var(--wui-spacing-xs);
  }

  wui-loading-spinner {
    right: var(--wui-spacing-m);
  }

  .betaBanner {
    padding: 10px 12px 10px 10px;
    border-radius: var(--wui-border-radius-s);
    background: var(--wui-accent-glass-010);
    margin-bottom: var(--wui-spacing-s);
  }
`;


var $e1bce6bb35aca6e2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e1bce6bb35aca6e2$export$73f53e8345d3576d = class W3mEmailLoginWidget extends (0, $dlgVE.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.formRef = (0, $3ec5ba488088087c$export$7d1e3a5e95ceca43)();
        this.connectors = (0, $01g6R.ConnectorController).state.connectors;
        this.email = "";
        this.loading = false;
        this.error = "";
        this.unsubscribe.push((0, $01g6R.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    firstUpdated() {
        this.formRef.value?.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") this.onSubmitEmail(event);
        });
    }
    render() {
        const multipleConnectors = this.connectors.length > 1;
        const connector = this.connectors.find((c)=>c.type === "EMAIL");
        if (!connector) return null;
        return (0, $gDLfI.html)`
      ${this.betaWarningTemplate()}
      <form ${(0, $3ec5ba488088087c$export$eff4d24c3ff7876e)(this.formRef)} @submit=${this.onSubmitEmail.bind(this)}>
        <wui-email-input
          @focus=${this.onFocusEvent.bind(this)}
          .disabled=${this.loading}
          @inputChange=${this.onEmailInputChange.bind(this)}
          .errorMessage=${this.error}
        >
        </wui-email-input>

        ${this.submitButtonTemplate()}${this.loadingTemplate()}
        <input type="submit" hidden />
      </form>

      ${multipleConnectors ? (0, $gDLfI.html)`<wui-separator text="or"></wui-separator>` : null}
    `;
    }
    betaWarningTemplate() {
        const showBetaWarning = true;
        return showBetaWarning ? (0, $gDLfI.html)`
          <wui-flex class="betaBanner" gap="xs" alignItems="center" justifyContent="center">
            <wui-text variant="small-400" color="accent-100">Email login is in beta</wui-text>
          </wui-flex>
        ` : null;
    }
    submitButtonTemplate() {
        const showSubmit = !this.loading && this.email.length > 3;
        return showSubmit ? (0, $gDLfI.html)`
          <wui-icon-link
            size="sm"
            icon="chevronRight"
            iconcolor="accent-100"
            @click=${this.onSubmitEmail.bind(this)}
          >
          </wui-icon-link>
        ` : null;
    }
    loadingTemplate() {
        return this.loading ? (0, $gDLfI.html)`<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>` : null;
    }
    onEmailInputChange(event) {
        this.email = event.detail;
        this.error = "";
    }
    async onSubmitEmail(event) {
        try {
            if (this.loading) return;
            this.loading = true;
            event.preventDefault();
            const emailConnector = (0, $01g6R.ConnectorController).getEmailConnector();
            if (!emailConnector) throw new Error("w3m-email-login-widget: Email connector not found");
            const { action: action } = await emailConnector.provider.connectEmail({
                email: this.email
            });
            (0, $dUlgM.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_SUBMITTED"
            });
            if (action === "VERIFY_OTP") {
                (0, $dUlgM.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_SENT"
                });
                (0, $3OaCj.RouterController).push("EmailVerifyOtp", {
                    email: this.email
                });
            } else if (action === "VERIFY_DEVICE") (0, $3OaCj.RouterController).push("EmailVerifyDevice", {
                email: this.email
            });
        } catch (error) {
            const parsedError = (0, $23VhR.CoreHelperUtil).parseError(error);
            if (parsedError?.includes("Invalid email")) this.error = "Invalid email. Try again.";
            else (0, $dXr1O.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
    onFocusEvent() {
        (0, $dUlgM.EventsController).sendEvent({
            type: "track",
            event: "EMAIL_LOGIN_SELECTED"
        });
    }
};
$e1bce6bb35aca6e2$export$73f53e8345d3576d.styles = (0, $0630c72ada64745f$export$2e2bcd8739ae039);
$e1bce6bb35aca6e2$var$__decorate([
    (0, $hdnNF.state)()
], $e1bce6bb35aca6e2$export$73f53e8345d3576d.prototype, "connectors", void 0);
$e1bce6bb35aca6e2$var$__decorate([
    (0, $hdnNF.state)()
], $e1bce6bb35aca6e2$export$73f53e8345d3576d.prototype, "email", void 0);
$e1bce6bb35aca6e2$var$__decorate([
    (0, $hdnNF.state)()
], $e1bce6bb35aca6e2$export$73f53e8345d3576d.prototype, "loading", void 0);
$e1bce6bb35aca6e2$var$__decorate([
    (0, $hdnNF.state)()
], $e1bce6bb35aca6e2$export$73f53e8345d3576d.prototype, "error", void 0);
$e1bce6bb35aca6e2$export$73f53e8345d3576d = $e1bce6bb35aca6e2$var$__decorate([
    (0, $3SCaV.customElement)("w3m-email-login-widget")
], $e1bce6bb35aca6e2$export$73f53e8345d3576d);


parcelRequire("3aODI");
var $7mucr = parcelRequire("7mucr");
var $5PCU5 = parcelRequire("5PCU5");
var $5n5Ql = parcelRequire("5n5Ql");
var $01g6R = parcelRequire("01g6R");
var $23VhR = parcelRequire("23VhR");
var $dUlgM = parcelRequire("dUlgM");
var $nBm8O = parcelRequire("nBm8O");
var $8A6Jz = parcelRequire("8A6Jz");
var $cPOJT = parcelRequire("cPOJT");
var $9q2Kw = parcelRequire("9q2Kw");
var $jIUUu = parcelRequire("jIUUu");
var $dXr1O = parcelRequire("dXr1O");
var $jGPEs = parcelRequire("jGPEs");
parcelRequire("1oeam");
var $cRWGJ = parcelRequire("cRWGJ");
let $f94122b27f80ef01$var$isInitialized = false;


class $f94122b27f80ef01$export$14b4aa396d4aed9a {
    constructor(options){
        this.initPromise = undefined;
        this.setIsConnected = (isConnected)=>{
            (0, $7mucr.AccountController).setIsConnected(isConnected);
        };
        this.setCaipAddress = (caipAddress)=>{
            (0, $7mucr.AccountController).setCaipAddress(caipAddress);
        };
        this.setBalance = (balance, balanceSymbol)=>{
            (0, $7mucr.AccountController).setBalance(balance, balanceSymbol);
        };
        this.setProfileName = (profileName)=>{
            (0, $7mucr.AccountController).setProfileName(profileName);
        };
        this.setProfileImage = (profileImage)=>{
            (0, $7mucr.AccountController).setProfileImage(profileImage);
        };
        this.resetAccount = ()=>{
            (0, $7mucr.AccountController).resetAccount();
        };
        this.setCaipNetwork = (caipNetwork)=>{
            (0, $8A6Jz.NetworkController).setCaipNetwork(caipNetwork);
        };
        this.getCaipNetwork = ()=>(0, $8A6Jz.NetworkController).state.caipNetwork;
        this.setRequestedCaipNetworks = (requestedCaipNetworks)=>{
            (0, $8A6Jz.NetworkController).setRequestedCaipNetworks(requestedCaipNetworks);
        };
        this.getApprovedCaipNetworksData = ()=>(0, $8A6Jz.NetworkController).getApprovedCaipNetworksData();
        this.resetNetwork = ()=>{
            (0, $8A6Jz.NetworkController).resetNetwork();
        };
        this.setConnectors = (connectors)=>{
            (0, $01g6R.ConnectorController).setConnectors(connectors);
        };
        this.addConnector = (connector)=>{
            (0, $01g6R.ConnectorController).addConnector(connector);
        };
        this.getConnectors = ()=>(0, $01g6R.ConnectorController).getConnectors();
        this.resetWcConnection = ()=>{
            (0, $5n5Ql.ConnectionController).resetWcConnection();
        };
        this.fetchIdentity = (request)=>(0, $5PCU5.BlockchainApiController).fetchIdentity(request);
        this.setAddressExplorerUrl = (addressExplorerUrl)=>{
            (0, $7mucr.AccountController).setAddressExplorerUrl(addressExplorerUrl);
        };
        this.setSIWENonce = (nonce)=>{
            (0, $jIUUu.SIWEController).setNonce(nonce);
        };
        this.setSIWESession = (session)=>{
            (0, $jIUUu.SIWEController).setSession(session);
        };
        this.setSIWEStatus = (status)=>{
            (0, $jIUUu.SIWEController).setStatus(status);
        };
        this.setSIWEMessage = (message)=>{
            (0, $jIUUu.SIWEController).setMessage(message);
        };
        this.initControllers(options);
        this.initOrContinue();
    }
    async open(options) {
        await this.initOrContinue();
        (0, $nBm8O.ModalController).open(options);
    }
    async close() {
        await this.initOrContinue();
        (0, $nBm8O.ModalController).close();
    }
    setLoading(loading) {
        (0, $nBm8O.ModalController).setLoading(loading);
    }
    getThemeMode() {
        return (0, $jGPEs.ThemeController).state.themeMode;
    }
    getThemeVariables() {
        return (0, $jGPEs.ThemeController).state.themeVariables;
    }
    setThemeMode(themeMode) {
        (0, $jGPEs.ThemeController).setThemeMode(themeMode);
        (0, $cRWGJ.setColorTheme)((0, $jGPEs.ThemeController).state.themeMode);
    }
    setThemeVariables(themeVariables) {
        (0, $jGPEs.ThemeController).setThemeVariables(themeVariables);
        (0, $cRWGJ.setThemeVariables)((0, $jGPEs.ThemeController).state.themeVariables);
    }
    subscribeTheme(callback) {
        return (0, $jGPEs.ThemeController).subscribe(callback);
    }
    getState() {
        return {
            ...(0, $9q2Kw.PublicStateController).state
        };
    }
    subscribeState(callback) {
        return (0, $9q2Kw.PublicStateController).subscribe(callback);
    }
    showErrorMessage(message) {
        (0, $dXr1O.SnackController).showError(message);
    }
    showSuccessMessage(message) {
        (0, $dXr1O.SnackController).showSuccess(message);
    }
    getEvent() {
        return {
            ...(0, $dUlgM.EventsController).state
        };
    }
    subscribeEvents(callback) {
        return (0, $dUlgM.EventsController).subscribe(callback);
    }
    subscribeSIWEState(callback) {
        return (0, $jIUUu.SIWEController).subscribe(callback);
    }
    initControllers(options) {
        (0, $8A6Jz.NetworkController).setClient(options.networkControllerClient);
        (0, $8A6Jz.NetworkController).setDefaultCaipNetwork(options.defaultChain);
        (0, $cPOJT.OptionsController).setProjectId(options.projectId);
        (0, $cPOJT.OptionsController).setAllWallets(options.allWallets);
        (0, $cPOJT.OptionsController).setIncludeWalletIds(options.includeWalletIds);
        (0, $cPOJT.OptionsController).setExcludeWalletIds(options.excludeWalletIds);
        (0, $cPOJT.OptionsController).setFeaturedWalletIds(options.featuredWalletIds);
        (0, $cPOJT.OptionsController).setTokens(options.tokens);
        (0, $cPOJT.OptionsController).setTermsConditionsUrl(options.termsConditionsUrl);
        (0, $cPOJT.OptionsController).setPrivacyPolicyUrl(options.privacyPolicyUrl);
        (0, $cPOJT.OptionsController).setCustomWallets(options.customWallets);
        (0, $cPOJT.OptionsController).setEnableAnalytics(options.enableAnalytics);
        (0, $cPOJT.OptionsController).setSdkVersion(options._sdkVersion);
        (0, $5n5Ql.ConnectionController).setClient(options.connectionControllerClient);
        if (options.siweControllerClient) {
            const siweClient = options.siweControllerClient;
            (0, $jIUUu.SIWEController).setSIWEClient(siweClient);
        }
        if (options.metadata) (0, $cPOJT.OptionsController).setMetadata(options.metadata);
        if (options.themeMode) (0, $jGPEs.ThemeController).setThemeMode(options.themeMode);
        if (options.themeVariables) (0, $jGPEs.ThemeController).setThemeVariables(options.themeVariables);
        if (options.enableOnramp) (0, $cPOJT.OptionsController).setOnrampEnabled(Boolean(options.enableOnramp));
    }
    async initOrContinue() {
        if (!this.initPromise && !$f94122b27f80ef01$var$isInitialized && (0, $23VhR.CoreHelperUtil).isClient()) {
            $f94122b27f80ef01$var$isInitialized = true;
            this.initPromise = new Promise(async (resolve)=>{
                await Promise.all([
                    Promise.resolve((parcelRequire("1oeam"))),
                    Promise.resolve((parcelRequire("8llE9")))
                ]);
                const modal = document.createElement("w3m-modal");
                document.body.insertAdjacentElement("beforeend", modal);
                resolve();
            });
        }
        return this.initPromise;
    }
}


parcelRequire("3aODI");
var $23VhR = parcelRequire("23VhR");


const $8782c6f344d77b54$export$aafe1f751f1bc52a = {
    WALLET_CONNECT_CONNECTOR_ID: "walletConnect",
    INJECTED_CONNECTOR_ID: "injected",
    COINBASE_CONNECTOR_ID: "coinbaseWallet",
    COINBASE_SDK_CONNECTOR_ID: "coinbaseWalletSDK",
    SAFE_CONNECTOR_ID: "safe",
    LEDGER_CONNECTOR_ID: "ledger",
    EIP6963_CONNECTOR_ID: "eip6963",
    EMAIL_CONNECTOR_ID: "w3mEmail",
    EIP155: "eip155",
    ADD_CHAIN_METHOD: "wallet_addEthereumChain",
    EIP6963_ANNOUNCE_EVENT: "eip6963:announceProvider",
    EIP6963_REQUEST_EVENT: "eip6963:requestProvider",
    VERSION: "4.0.11-8c88aa26.0"
};



const $92e7988ce4dd22dc$export$fd35d6514357600 = {
    ConnectorExplorerIds: {
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927"
    },
    EIP155NetworkImageIds: {
        1: "692ed6ba-e569-459a-556a-776476829e00",
        42161: "3bff954d-5cb0-47a0-9a23-d20192e74600",
        43114: "30c46e53-e989-45fb-4549-be3bd4eb3b00",
        56: "93564157-2e8e-4ce7-81df-b264dbee9b00",
        250: "06b26297-fe0c-4733-5d6b-ffa5498aac00",
        10: "ab9c186a-c52f-464b-2906-ca59d760a400",
        137: "41d04d42-da3b-4453-8506-668cc0727900",
        100: "02b53f6a-e3d4-479e-1cb4-21178987d100",
        9001: "f926ff41-260d-4028-635e-91913fc28e00",
        324: "b310f07f-4ef7-49f3-7073-2a0a39685800",
        314: "5a73b3dd-af74-424e-cae0-0de859ee9400",
        4689: "34e68754-e536-40da-c153-6ef2e7188a00",
        1088: "3897a66d-40b9-4833-162f-a2c90531c900",
        1284: "161038da-44ae-4ec7-1208-0ea569454b00",
        1285: "f1d73bb6-5450-4e18-38f7-fb6484264a00",
        7777777: "845c60df-d429-4991-e687-91ae45791600",
        42220: "ab781bbc-ccc6-418d-d32d-789b15da1f00",
        8453: "7289c336-3981-4081-c5f4-efc26ac64a00",
        1313161554: "3ff73439-a619-4894-9262-4470c773a100",
        2020: "b8101fc0-9c19-4b6f-ec65-f6dfff106e00",
        2021: "b8101fc0-9c19-4b6f-ec65-f6dfff106e00"
    },
    ConnectorImageIds: {
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "0c2840c3-5b04-4c44-9661-fbd4b49e1800",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID]: "0c2840c3-5b04-4c44-9661-fbd4b49e1800",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "461db637-8616-43ce-035a-d89b8a1d5800",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "54a1aa77-d202-4f8d-0fb2-5d2bb6db0300",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "ef1a1fcf-7fe8-4d69-bd6d-fda1345b4400",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "07ba87ed-43aa-4adf-4540-9e6a2b9cae00"
    },
    ConnectorNamesMap: {
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "Browser Wallet",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "WalletConnect",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "Coinbase",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID]: "Coinbase",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "Ledger",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "Safe"
    },
    ConnectorTypesMap: {
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "INJECTED",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "WALLET_CONNECT",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID]: "ANNOUNCED",
        [(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID]: "EMAIL"
    },
    WalletConnectRpcChainIds: [
        1,
        5,
        11155111,
        10,
        420,
        42161,
        421613,
        137,
        80001,
        42220,
        1313161554,
        1313161555,
        56,
        97,
        43114,
        43113,
        100,
        8453,
        84531,
        7777777,
        999,
        324,
        280
    ]
};



const $f539751c4ba8c8a8$export$518f198897991e39 = {
    caipNetworkIdToNumber (caipnetworkId) {
        return caipnetworkId ? Number(caipnetworkId.split(":")[1]) : undefined;
    },
    getCaipTokens (tokens) {
        if (!tokens) return undefined;
        const caipTokens = {};
        Object.entries(tokens).forEach(([id, token])=>{
            caipTokens[`${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155}:${id}`] = token;
        });
        return caipTokens;
    }
};





var $23VhR = parcelRequire("23VhR");



var $aBz5G = parcelRequire("aBz5G");

var $cahqm = parcelRequire("cahqm");
class $b8e82aa8b5962b28$export$d0a48bf953f3c239 extends (0, $cahqm.BaseError) {
    constructor(){
        super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
            docsPath: "/docs/clients/intro",
            name: "UrlRequiredError"
        });
    }
}



var $aeVPU = parcelRequire("aeVPU");

var $aBz5G = parcelRequire("aBz5G");
function $663c055184be543e$export$e86e19342bc4850e(fn, { errorInstance: errorInstance = new Error("timed out"), timeout: timeout, signal: signal }) {
    return new Promise((resolve, reject)=>{
        (async ()=>{
            let timeoutId;
            try {
                const controller = new AbortController();
                if (timeout > 0) timeoutId = setTimeout(()=>{
                    if (signal) controller.abort();
                    else reject(errorInstance);
                }, timeout); // need to cast because bun globals.d.ts overrides @types/node
                resolve(await fn({
                    signal: controller?.signal || null
                }));
            } catch (err) {
                if (err?.name === "AbortError") reject(errorInstance);
                reject(err);
            } finally{
                clearTimeout(timeoutId);
            }
        })();
    });
}



var $6fuj2 = parcelRequire("6fuj2");
function $ce260eb32d56b4cf$var$createIdStore() {
    return {
        current: 0,
        take () {
            return this.current++;
        },
        reset () {
            this.current = 0;
        }
    };
}
const $ce260eb32d56b4cf$export$94f79fd1fae0679e = /*#__PURE__*/ $ce260eb32d56b4cf$var$createIdStore();


function $fd98cda0bbef8980$export$290dc69d3612792(url, options = {}) {
    return {
        async request (params) {
            const { body: body, onRequest: onRequest = options.onRequest, onResponse: onResponse = options.onResponse, timeout: timeout = options.timeout ?? 10000 } = params;
            const fetchOptions = {
                ...options.fetchOptions ?? {},
                ...params.fetchOptions ?? {}
            };
            const { headers: headers, method: method, signal: signal_ } = fetchOptions;
            try {
                const response = await (0, $663c055184be543e$export$e86e19342bc4850e)(async ({ signal: signal })=>{
                    const init = {
                        ...fetchOptions,
                        body: Array.isArray(body) ? (0, $6fuj2.stringify)(body.map((body)=>({
                                jsonrpc: "2.0",
                                id: body.id ?? (0, $ce260eb32d56b4cf$export$94f79fd1fae0679e).take(),
                                ...body
                            }))) : (0, $6fuj2.stringify)({
                            jsonrpc: "2.0",
                            id: body.id ?? (0, $ce260eb32d56b4cf$export$94f79fd1fae0679e).take(),
                            ...body
                        }),
                        headers: {
                            "Content-Type": "application/json",
                            ...headers
                        },
                        method: method || "POST",
                        signal: signal_ || (timeout > 0 ? signal : null)
                    };
                    const request = new Request(url, init);
                    const args = await onRequest?.(request, init) ?? {
                        ...init,
                        url: url
                    };
                    const response = await fetch(args.url ?? url, args);
                    return response;
                }, {
                    errorInstance: new (0, $aBz5G.TimeoutError)({
                        body: body,
                        url: url
                    }),
                    timeout: timeout,
                    signal: true
                });
                if (onResponse) await onResponse(response);
                let data;
                if (response.headers.get("Content-Type")?.startsWith("application/json")) data = await response.json();
                else {
                    data = await response.text();
                    try {
                        data = JSON.parse(data || "{}");
                    } catch (err) {
                        if (response.ok) throw err;
                        data = {
                            error: data
                        };
                    }
                }
                if (!response.ok) throw new (0, $aBz5G.HttpRequestError)({
                    body: body,
                    details: (0, $6fuj2.stringify)(data.error) || response.statusText,
                    headers: response.headers,
                    status: response.status,
                    url: url
                });
                return data;
            } catch (err) {
                if (err instanceof (0, $aBz5G.HttpRequestError)) throw err;
                if (err instanceof (0, $aBz5G.TimeoutError)) throw err;
                throw new (0, $aBz5G.HttpRequestError)({
                    body: body,
                    cause: err,
                    url: url
                });
            }
        }
    };
}



function $ff2d1e1ca66a97fb$export$7d6f1c8842f9f527(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url, config = {}) {
    const { batch: batch, fetchOptions: fetchOptions, key: key = "http", methods: methods, name: name = "HTTP JSON-RPC", onFetchRequest: onFetchRequest, onFetchResponse: onFetchResponse, retryDelay: retryDelay } = config;
    return ({ chain: chain, retryCount: retryCount_, timeout: timeout_ })=>{
        const { batchSize: batchSize = 1000, wait: wait = 0 } = typeof batch === "object" ? batch : {};
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.http[0];
        if (!url_) throw new (0, $b8e82aa8b5962b28$export$d0a48bf953f3c239)();
        const rpcClient = (0, $fd98cda0bbef8980$export$290dc69d3612792)(url_, {
            fetchOptions: fetchOptions,
            onRequest: onFetchRequest,
            onResponse: onFetchResponse,
            timeout: timeout
        });
        return (0, $008b36b49ba998cf$export$d09f50d9ab7f7b69)({
            key: key,
            methods: methods,
            name: name,
            async request ({ method: method, params: params }) {
                const body = {
                    method: method,
                    params: params
                };
                const { schedule: schedule } = (0, $aeVPU.createBatchScheduler)({
                    id: url_,
                    wait: wait,
                    shouldSplitBatch (requests) {
                        return requests.length > batchSize;
                    },
                    fn: (body)=>rpcClient.request({
                            body: body
                        }),
                    sort: (a, b)=>a.id - b.id
                });
                const fn = async (body)=>batch ? schedule(body) : [
                        await rpcClient.request({
                            body: body
                        })
                    ];
                const [{ error: error, result: result }] = await fn(body);
                if (error) throw new (0, $aBz5G.RpcRequestError)({
                    body: body,
                    error: error,
                    url: url_
                });
                return result;
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "http"
        }, {
            fetchOptions: fetchOptions,
            url: url_
        });
    };
}


function $3721684b5080e7f4$export$1ee567fcdafbf4d8(chain) {
    if (!chain) return undefined;
    return {
        id: `${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155}:${chain.id}`,
        name: chain.name,
        imageId: (0, $92e7988ce4dd22dc$export$fd35d6514357600).EIP155NetworkImageIds[chain.id]
    };
}
async function $3721684b5080e7f4$export$24a8d1cae47a6f(connector) {
    if (!connector) throw new Error("networkControllerClient:getApprovedCaipNetworks - connector is undefined");
    const provider = await connector?.getProvider();
    const ns = provider?.signer?.session?.namespaces;
    const nsMethods = ns?.[(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155]?.methods;
    const nsChains = ns?.[(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155]?.chains;
    return {
        supportsAllNetworks: Boolean(nsMethods?.includes((0, $8782c6f344d77b54$export$aafe1f751f1bc52a).ADD_CHAIN_METHOD)),
        approvedCaipNetworkIds: nsChains
    };
}
function $3721684b5080e7f4$export$94f91666d3e5b28f() {
    return {
        supportsAllNetworks: false,
        approvedCaipNetworkIds: (0, $92e7988ce4dd22dc$export$fd35d6514357600).WalletConnectRpcChainIds.map((id)=>`${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155}:${id}`)
    };
}
function $3721684b5080e7f4$export$867d8b939ab7f43e({ chainId: chainId, projectId: projectId }) {
    const RPC_URL = (0, $23VhR.CoreHelperUtil).getBlockchainApiUrl();
    if (!(0, $92e7988ce4dd22dc$export$fd35d6514357600).WalletConnectRpcChainIds.includes(chainId)) return (0, $ff2d1e1ca66a97fb$export$7d6f1c8842f9f527)();
    return (0, $ff2d1e1ca66a97fb$export$7d6f1c8842f9f527)(`${RPC_URL}/v1/?chainId=${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155}:${chainId}&projectId=${projectId}`);
}



parcelRequire("3aODI");
var $QVM5q = parcelRequire("QVM5q");
class $cb4afcb7b4256971$export$c03599cd5308d12b extends (0, $f94122b27f80ef01$export$14b4aa396d4aed9a) {
    constructor(options){
        const { wagmiConfig: wagmiConfig, siweConfig: siweConfig, defaultChain: defaultChain, tokens: tokens, _sdkVersion: _sdkVersion, ...w3mOptions } = options;
        if (!wagmiConfig) throw new Error("web3modal:constructor - wagmiConfig is undefined");
        if (!w3mOptions.projectId) throw new Error("web3modal:constructor - projectId is undefined");
        const networkControllerClient = {
            switchCaipNetwork: async (caipNetwork)=>{
                const chainId = (0, $f539751c4ba8c8a8$export$518f198897991e39).caipNetworkIdToNumber(caipNetwork?.id);
                if (chainId) await (0, $44fa0065504bf15d$export$15599da40e72d2f)(this.wagmiConfig, {
                    chainId: chainId
                });
            },
            getApprovedCaipNetworksData: async ()=>new Promise((resolve)=>{
                    const connections = new Map(wagmiConfig.state.connections);
                    const connection = connections.get(wagmiConfig.state.current || "");
                    if (connection?.connector?.id === (0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID) resolve((0, $3721684b5080e7f4$export$94f91666d3e5b28f)());
                    else if (connection?.connector?.id === (0, $8782c6f344d77b54$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID) {
                        const connector = wagmiConfig.connectors.find((c)=>c.id === (0, $8782c6f344d77b54$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID);
                        resolve((0, $3721684b5080e7f4$export$24a8d1cae47a6f)(connector));
                    }
                    resolve({
                        approvedCaipNetworkIds: undefined,
                        supportsAllNetworks: true
                    });
                })
        };
        const connectionControllerClient = {
            connectWalletConnect: async (onUri)=>{
                const connector = wagmiConfig.connectors.find((c)=>c.id === (0, $8782c6f344d77b54$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID);
                if (!connector) throw new Error("connectionControllerClient:getWalletConnectUri - connector is undefined");
                const provider = await connector.getProvider();
                provider.on("display_uri", (data)=>{
                    onUri(data);
                });
                const chainId = (0, $f539751c4ba8c8a8$export$518f198897991e39).caipNetworkIdToNumber(this.getCaipNetwork()?.id);
                await (0, $448dd5b08fca5688$export$64605811ab45167f)(this.wagmiConfig, {
                    connector: connector,
                    chainId: chainId
                });
            },
            connectExternal: async ({ id: id, provider: provider, info: info })=>{
                const connector = wagmiConfig.connectors.find((c)=>c.id === id);
                if (!connector) throw new Error("connectionControllerClient:connectExternal - connector is undefined");
                if (provider && info && connector.id === (0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID) connector.setEip6963Wallet?.({
                    provider: provider,
                    info: info
                });
                const chainId = (0, $f539751c4ba8c8a8$export$518f198897991e39).caipNetworkIdToNumber(this.getCaipNetwork()?.id);
                await (0, $448dd5b08fca5688$export$64605811ab45167f)(this.wagmiConfig, {
                    connector: connector,
                    chainId: chainId
                });
            },
            checkInstalled: (ids)=>{
                const injectedConnector = this.getConnectors().find((c)=>c.type === "INJECTED");
                if (!ids) return Boolean(window.ethereum);
                if (injectedConnector) {
                    if (!window?.ethereum) return false;
                    return ids.some((id)=>Boolean(window.ethereum?.[String(id)]));
                }
                return false;
            },
            disconnect: async ()=>{
                await (0, $a724cc6b117c9948$export$37dfea93db2e14ed)(this.wagmiConfig);
                if (siweConfig?.options?.signOutOnDisconnect) await siweConfig.signOut();
            },
            signMessage: async (message)=>(0, $d36ecd36696e227d$export$1d9a7a8a40780de)(this.wagmiConfig, {
                    message: message
                })
        };
        super({
            networkControllerClient: networkControllerClient,
            connectionControllerClient: connectionControllerClient,
            siweControllerClient: siweConfig,
            defaultChain: (0, $3721684b5080e7f4$export$1ee567fcdafbf4d8)(defaultChain),
            tokens: (0, $f539751c4ba8c8a8$export$518f198897991e39).getCaipTokens(tokens),
            _sdkVersion: _sdkVersion ?? `html-wagmi-${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).VERSION}`,
            ...w3mOptions
        });
        this.hasSyncedConnectedAccount = false;
        this.options = undefined;
        this.options = options;
        this.wagmiConfig = wagmiConfig;
        this.syncRequestedNetworks([
            ...wagmiConfig.chains
        ]);
        this.syncConnectors([
            ...wagmiConfig.connectors
        ]);
        (0, $22388fdb59095ab9$export$9c8eec0a0da048a0)(this.wagmiConfig, {
            onChange: (connectors)=>this.syncConnectors(connectors)
        });
        (0, $5bde27009cbbce16$export$30c94aeff2da2ac6)(this.wagmiConfig, {
            onChange: (accountData)=>this.syncAccount({
                    ...accountData
                })
        });
    }
    getState() {
        const state = super.getState();
        return {
            ...state,
            selectedNetworkId: (0, $f539751c4ba8c8a8$export$518f198897991e39).caipNetworkIdToNumber(state.selectedNetworkId)
        };
    }
    subscribeState(callback) {
        return super.subscribeState((state)=>callback({
                ...state,
                selectedNetworkId: (0, $f539751c4ba8c8a8$export$518f198897991e39).caipNetworkIdToNumber(state.selectedNetworkId)
            }));
    }
    syncRequestedNetworks(chains) {
        const requestedCaipNetworks = chains?.map((chain)=>({
                id: `${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155}:${chain.id}`,
                name: chain.name,
                imageId: (0, $92e7988ce4dd22dc$export$fd35d6514357600).EIP155NetworkImageIds[chain.id],
                imageUrl: this.options?.chainImages?.[chain.id]
            }));
        this.setRequestedCaipNetworks(requestedCaipNetworks ?? []);
    }
    async syncAccount({ address: address, isConnected: isConnected, chainId: chainId }) {
        this.resetAccount();
        this.syncNetwork();
        if (isConnected && address && chainId) {
            const caipAddress = `${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155}:${chainId}:${address}`;
            this.setIsConnected(isConnected);
            this.setCaipAddress(caipAddress);
            await Promise.all([
                this.syncProfile(address, chainId),
                this.syncBalance(address, chainId),
                this.getApprovedCaipNetworksData()
            ]);
            this.hasSyncedConnectedAccount = true;
        } else if (!isConnected && this.hasSyncedConnectedAccount) {
            this.resetWcConnection();
            this.resetNetwork();
        }
    }
    async syncNetwork() {
        const { address: address, isConnected: isConnected, chainId: chainId } = (0, $588ed08035d28638$export$4f9234baf34abd0)(this.wagmiConfig);
        const chain = this.wagmiConfig.chains.find((c)=>c.id === chainId);
        if (chain || chainId) {
            const name = chain?.name ?? chainId?.toString();
            const id = Number(chain?.id ?? chainId);
            const caipChainId = `${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155}:${id}`;
            this.setCaipNetwork({
                id: caipChainId,
                name: name,
                imageId: (0, $92e7988ce4dd22dc$export$fd35d6514357600).EIP155NetworkImageIds[id],
                imageUrl: this.options?.chainImages?.[id]
            });
            if (isConnected && address && chainId) {
                const caipAddress = `${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155}:${id}:${address}`;
                this.setCaipAddress(caipAddress);
                if (chain?.blockExplorers?.default?.url) {
                    const url = `${chain.blockExplorers.default.url}/address/${address}`;
                    this.setAddressExplorerUrl(url);
                } else this.setAddressExplorerUrl(undefined);
                if (this.hasSyncedConnectedAccount) {
                    await this.syncProfile(address, chainId);
                    await this.syncBalance(address, chainId);
                }
            }
        }
    }
    async syncProfile(address, chainId) {
        if (chainId !== (0, $6b15c8827610446e$export$536d3e0d2c7baf54).id) {
            this.setProfileName(null);
            this.setProfileImage(null);
            return;
        }
        try {
            const { name: name, avatar: avatar } = await this.fetchIdentity({
                caipChainId: `${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EIP155}:${chainId}`,
                address: address
            });
            this.setProfileName(name);
            this.setProfileImage(avatar);
        } catch  {
            const profileName = await (0, $b3b28e2ddfde4d0a$export$e1b98d9bc05a9fc2)(this.wagmiConfig, {
                address: address,
                chainId: chainId
            });
            if (profileName) {
                this.setProfileName(profileName);
                const profileImage = await (0, $44f135bdb81b9ccf$export$65f1d2b9649a54e5)(this.wagmiConfig, {
                    name: profileName,
                    chainId: chainId
                });
                if (profileImage) this.setProfileImage(profileImage);
            }
        }
    }
    async syncBalance(address, chainId) {
        const chain = this.wagmiConfig.chains.find((c)=>c.id === chainId);
        if (chain) {
            const balance = await (0, $fbca91f97c11380e$export$df96cd8d56be0ab1)(this.wagmiConfig, {
                address: address,
                chainId: chain.id,
                token: this.options?.tokens?.[chain.id]?.address
            });
            this.setBalance(balance.formatted, balance.symbol);
            return;
        }
        this.setBalance(undefined, undefined);
    }
    syncConnectors(connectors) {
        const uniqueIds = new Set();
        const filteredConnectors = connectors.filter((item)=>!uniqueIds.has(item.id) && uniqueIds.add(item.id));
        const w3mConnectors = [];
        const coinbaseSDKId = (0, $8782c6f344d77b54$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID;
        const coinbaseConnector = filteredConnectors.find((c)=>c.id === (0, $QVM5q.ConstantsUtil).CONNECTOR_RDNS_MAP[coinbaseSDKId]);
        filteredConnectors.forEach(({ id: id, name: name, type: type, icon: icon })=>{
            const shouldSkip = coinbaseConnector && id === coinbaseSDKId || (0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID === id;
            if (!shouldSkip) w3mConnectors.push({
                id: id,
                explorerId: (0, $92e7988ce4dd22dc$export$fd35d6514357600).ConnectorExplorerIds[id],
                imageUrl: this.options?.connectorImages?.[id] ?? icon,
                name: (0, $92e7988ce4dd22dc$export$fd35d6514357600).ConnectorNamesMap[id] ?? name,
                imageId: (0, $92e7988ce4dd22dc$export$fd35d6514357600).ConnectorImageIds[id],
                type: (0, $92e7988ce4dd22dc$export$fd35d6514357600).ConnectorTypesMap[type] ?? "EXTERNAL"
            });
        });
        this.setConnectors(w3mConnectors);
        this.syncEmailConnector(filteredConnectors);
    }
    async syncEmailConnector(connectors) {
        const emailConnector = connectors.find(({ id: id })=>id === (0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID);
        if (emailConnector) {
            const provider = await emailConnector.getProvider();
            this.addConnector({
                id: (0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID,
                type: "EMAIL",
                name: "Email",
                provider: provider
            });
            this.listenEmailConnector(emailConnector);
            this.listenModal(emailConnector);
        }
    }
    async listenEmailConnector(connector) {
        if (typeof window !== "undefined" && connector) {
            super.setLoading(true);
            const provider = await connector.getProvider();
            const isLoginEmailUsed = provider.getLoginEmailUsed();
            super.setLoading(isLoginEmailUsed);
            if (isLoginEmailUsed) this.setIsConnected(false);
            provider.onRpcRequest((request)=>{
                if ((0, $d8337f636d1cff9e$export$794efc40d8765bc4).checkIfRequestExists(request)) {
                    if (!(0, $d8337f636d1cff9e$export$794efc40d8765bc4).checkIfRequestIsAllowed(request)) super.open({
                        view: "ApproveTransaction"
                    });
                } else {
                    super.open();
                    const method = (0, $d8337f636d1cff9e$export$794efc40d8765bc4).getRequestMethod(request);
                    console.error((0, $e23d11511a09400f$export$9975694bfb286db).RPC_METHOD_NOT_ALLOWED_MESSAGE, {
                        method: method
                    });
                    setTimeout(()=>{
                        this.showErrorMessage((0, $e23d11511a09400f$export$9975694bfb286db).RPC_METHOD_NOT_ALLOWED_UI_MESSAGE);
                    }, 300);
                    provider.rejectRpcRequest();
                }
            });
            provider.onRpcResponse(()=>{
                super.close();
            });
            provider.onNotConnected(()=>{
                this.setIsConnected(false);
                super.setLoading(false);
            });
            provider.onIsConnected(()=>{
                this.setIsConnected(true);
                super.setLoading(false);
            });
        }
    }
    async listenModal(connector) {
        const provider = await connector.getProvider();
        this.subscribeState((val)=>{
            if (!val.open) provider.rejectRpcRequest();
        });
    }
}



let $1a6c142165b114fb$var$modal = undefined;
function $1a6c142165b114fb$export$14650d4efb17e382(options) {
    if (!$1a6c142165b114fb$var$modal) {
        $1a6c142165b114fb$var$modal = new (0, $cb4afcb7b4256971$export$c03599cd5308d12b)({
            ...options,
            _sdkVersion: `react-wagmi-${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).VERSION}`
        });
        (0, $c8101c12137113f6$export$db9d243f55cd9d82)($1a6c142165b114fb$var$modal);
    }
    return $1a6c142165b114fb$var$modal;
}






function $2411bbe42b2d772c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $371e82258127cd52$var$MILLISECONDS_IN_DAY = 86400000;
function $371e82258127cd52$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $2411bbe42b2d772c$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $2411bbe42b2d772c$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $cc5f146101733a31$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $cc5f146101733a31$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $371e82258127cd52$var$MILLISECONDS_IN_DAY);
}









function $50403809f98fa2f7$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var baseDate = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyBaseDate);
    var defaultOptions = (0, $6e3145262e897fb9$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $46f8710aa8a87258$export$2e2bcd8739ae039);
    var weekStartsOn = (0, $f3af13645545885b$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    if (!locale.formatRelative) throw new RangeError("locale must contain formatRelative property");
    var diff = (0, $371e82258127cd52$export$2e2bcd8739ae039)(date, baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    var token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    var utcDate = (0, $e4a0afd5d1e802ec$export$2e2bcd8739ae039)(date, (0, $cc5f146101733a31$export$2e2bcd8739ae039)(date));
    var utcBaseDate = (0, $e4a0afd5d1e802ec$export$2e2bcd8739ae039)(baseDate, (0, $cc5f146101733a31$export$2e2bcd8739ae039)(baseDate));
    var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}



function $08121a36a9b63f2e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}






function $af9c50b7122d249f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $f3af13645545885b$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $708bbd65a69565bb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $f3af13645545885b$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $7216c1886eb85aab$export$2e2bcd8739ae039(dirtyDate, duration) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    if (!duration || (0, $4f84ffe9ae203298$export$2e2bcd8739ae039)(duration) !== "object") return new Date(NaN);
    var years = duration.years ? (0, $f3af13645545885b$export$2e2bcd8739ae039)(duration.years) : 0;
    var months = duration.months ? (0, $f3af13645545885b$export$2e2bcd8739ae039)(duration.months) : 0;
    var weeks = duration.weeks ? (0, $f3af13645545885b$export$2e2bcd8739ae039)(duration.weeks) : 0;
    var days = duration.days ? (0, $f3af13645545885b$export$2e2bcd8739ae039)(duration.days) : 0;
    var hours = duration.hours ? (0, $f3af13645545885b$export$2e2bcd8739ae039)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, $f3af13645545885b$export$2e2bcd8739ae039)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, $f3af13645545885b$export$2e2bcd8739ae039)(duration.seconds) : 0;
    // Add years and months
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var dateWithMonths = months || years ? (0, $708bbd65a69565bb$export$2e2bcd8739ae039)(date, months + years * 12) : date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, $af9c50b7122d249f$export$2e2bcd8739ae039)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}





// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $c0e6a5e9e42cd93d$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $c0e6a5e9e42cd93d$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $c0e6a5e9e42cd93d$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $371e82258127cd52$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($c0e6a5e9e42cd93d$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $c4053e94986594e8$export$dfd9b671c89acc8e = 7;
var $c4053e94986594e8$export$3913210603d8e9ae = 365.2425;
var $c4053e94986594e8$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $c4053e94986594e8$export$91246f0b9bd9beff = 60000;
var $c4053e94986594e8$export$7f72910d6dfd237a = 3600000;
var $c4053e94986594e8$export$397c2d5776aa9055 = 1000;
var $c4053e94986594e8$export$4dec998e48f9c246 = -$c4053e94986594e8$export$81caae6e1cc7a622;
var $c4053e94986594e8$export$f2f5ae5a8e2d8f9f = 60;
var $c4053e94986594e8$export$3c58128db900d44e = 3;
var $c4053e94986594e8$export$80d7e435f744f319 = 12;
var $c4053e94986594e8$export$4db7641526e3241f = 4;
var $c4053e94986594e8$export$698aec755e92c695 = 3600;
var $c4053e94986594e8$export$a77c1a7ebebe2a5a = 60;
var $c4053e94986594e8$export$815a9362476d2fe3 = $c4053e94986594e8$export$698aec755e92c695 * 24;
var $c4053e94986594e8$export$34804a017b31e2fe = $c4053e94986594e8$export$815a9362476d2fe3 * 7;
var $c4053e94986594e8$export$7271e9e3478110d1 = $c4053e94986594e8$export$815a9362476d2fe3 * $c4053e94986594e8$export$3913210603d8e9ae;
var $c4053e94986594e8$export$8e6600bbdee7dabb = $c4053e94986594e8$export$7271e9e3478110d1 / 12;
var $c4053e94986594e8$export$be1dccf2de902d31 = $c4053e94986594e8$export$8e6600bbdee7dabb * 3;




function $2c3ffbe75c2bc618$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    return (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dateRight).getTime();
}



var $fc33b737a8eafc43$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $fc33b737a8eafc43$var$defaultRoundingMethod = "trunc";
function $fc33b737a8eafc43$export$b6474a47258c1211(method) {
    return method ? $fc33b737a8eafc43$var$roundingMap[method] : $fc33b737a8eafc43$var$roundingMap[$fc33b737a8eafc43$var$defaultRoundingMethod];
}


function $7811864329f491da$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $2c3ffbe75c2bc618$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $c4053e94986594e8$export$7f72910d6dfd237a);
    return (0, $fc33b737a8eafc43$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}






function $02ba2b1cded045af$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $2c3ffbe75c2bc618$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $c4053e94986594e8$export$91246f0b9bd9beff);
    return (0, $fc33b737a8eafc43$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $407d7b6e8a8eba7a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}







function $f9c4a45ba1545cfb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $55d6867bdbbce671$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $ef0b70373e7e1166$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    return (0, $f9c4a45ba1545cfb$export$2e2bcd8739ae039)(date).getTime() === (0, $55d6867bdbbce671$export$2e2bcd8739ae039)(date).getTime();
}


function $096360ed154bb762$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $08121a36a9b63f2e$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $407d7b6e8a8eba7a$export$2e2bcd8739ae039)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $08121a36a9b63f2e$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $ef0b70373e7e1166$export$2e2bcd8739ae039)((0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateLeft)) && difference === 1 && (0, $08121a36a9b63f2e$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}





function $b42a9811b1b67611$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $2c3ffbe75c2bc618$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $fc33b737a8eafc43$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $d82fcb4d8a32d6fc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}




function $ac29e1f134193468$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $08121a36a9b63f2e$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $d82fcb4d8a32d6fc$export$2e2bcd8739ae039)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $08121a36a9b63f2e$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $2a16fa66856ff33d$export$2e2bcd8739ae039(interval) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var start = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(interval.start);
    var end = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(interval.end);
    if (isNaN(start.getTime())) throw new RangeError("Start Date is invalid");
    if (isNaN(end.getTime())) throw new RangeError("End Date is invalid");
    var duration = {};
    duration.years = Math.abs((0, $ac29e1f134193468$export$2e2bcd8739ae039)(end, start));
    var sign = (0, $08121a36a9b63f2e$export$2e2bcd8739ae039)(end, start);
    var remainingMonths = (0, $7216c1886eb85aab$export$2e2bcd8739ae039)(start, {
        years: sign * duration.years
    });
    duration.months = Math.abs((0, $096360ed154bb762$export$2e2bcd8739ae039)(end, remainingMonths));
    var remainingDays = (0, $7216c1886eb85aab$export$2e2bcd8739ae039)(remainingMonths, {
        months: sign * duration.months
    });
    duration.days = Math.abs((0, $c0e6a5e9e42cd93d$export$2e2bcd8739ae039)(end, remainingDays));
    var remainingHours = (0, $7216c1886eb85aab$export$2e2bcd8739ae039)(remainingDays, {
        days: sign * duration.days
    });
    duration.hours = Math.abs((0, $7811864329f491da$export$2e2bcd8739ae039)(end, remainingHours));
    var remainingMinutes = (0, $7216c1886eb85aab$export$2e2bcd8739ae039)(remainingHours, {
        hours: sign * duration.hours
    });
    duration.minutes = Math.abs((0, $02ba2b1cded045af$export$2e2bcd8739ae039)(end, remainingMinutes));
    var remainingSeconds = (0, $7216c1886eb85aab$export$2e2bcd8739ae039)(remainingMinutes, {
        minutes: sign * duration.minutes
    });
    duration.seconds = Math.abs((0, $b42a9811b1b67611$export$2e2bcd8739ae039)(end, remainingSeconds));
    return duration;
}




function $c322f0373ea50904$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $4f84ffe9ae203298$export$2e2bcd8739ae039)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}



var $fDWVA = parcelRequire("fDWVA");

var $bnENU = parcelRequire("bnENU");



var $6Dftn = parcelRequire("6Dftn");

var $dzDwb = parcelRequire("dzDwb");

var $aYJZ1 = parcelRequire("aYJZ1");

var $fVVQ8 = parcelRequire("fVVQ8");

var $geW6W = parcelRequire("geW6W");

var $jW8ut = parcelRequire("jW8ut");





async function $05eb798102efc443$export$24b77c7e87f05b8d(client, { blockNumber: blockNumber, blockTag: blockTag, coinType: coinType, name: name, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $fVVQ8.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const functionData = (0, $aYJZ1.encodeFunctionData)({
            abi: (0, $6Dftn.addressResolverAbi),
            functionName: "addr",
            ...coinType != null ? {
                args: [
                    (0, $968536f70dae80fc$export$91d651ee363e1209)(name),
                    BigInt(coinType)
                ]
            } : {
                args: [
                    (0, $968536f70dae80fc$export$91d651ee363e1209)(name)
                ]
            }
        });
        const readContractParameters = {
            address: universalResolverAddress,
            abi: (0, $6Dftn.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $jW8ut.toHex)((0, $9b043beeb0ee5e19$export$8a0899f9ded0844)(name)),
                functionData
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        };
        const readContractAction = (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $2ba19faf5017d144$export$43af7de392176737), "readContract");
        const res = gatewayUrls ? await readContractAction({
            ...readContractParameters,
            args: [
                ...readContractParameters.args,
                gatewayUrls
            ]
        }) : await readContractAction(readContractParameters);
        if (res[0] === "0x") return null;
        const address = (0, $dzDwb.decodeFunctionResult)({
            abi: (0, $6Dftn.addressResolverAbi),
            args: coinType != null ? [
                (0, $968536f70dae80fc$export$91d651ee363e1209)(name),
                BigInt(coinType)
            ] : undefined,
            functionName: "addr",
            data: res[0]
        });
        if (address === "0x") return null;
        if ((0, $geW6W.trim)(address) === "0x00") return null;
        return address;
    } catch (err) {
        if (strict) throw err;
        if ((0, $df83d1c433841d94$export$78f90e26b9356cd7)(err, "resolve")) return null;
        throw err;
    }
}





var $fVVQ8 = parcelRequire("fVVQ8");

var $jW8ut = parcelRequire("jW8ut");



async function $97226fc80e039432$export$ba1240cd558e6b31(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $fVVQ8.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const [resolverAddress] = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $2ba19faf5017d144$export$43af7de392176737), "readContract")({
        address: universalResolverAddress,
        abi: [
            {
                inputs: [
                    {
                        type: "bytes"
                    }
                ],
                name: "findResolver",
                outputs: [
                    {
                        type: "address"
                    },
                    {
                        type: "bytes32"
                    }
                ],
                stateMutability: "view",
                type: "function"
            }
        ],
        functionName: "findResolver",
        args: [
            (0, $jW8ut.toHex)((0, $9b043beeb0ee5e19$export$8a0899f9ded0844)(name))
        ],
        blockNumber: blockNumber,
        blockTag: blockTag
    });
    return resolverAddress;
}




var $cjGvc = parcelRequire("cjGvc");

var $gbEG8 = parcelRequire("gbEG8");

var $jW8ut = parcelRequire("jW8ut");

var $3zih5 = parcelRequire("3zih5");

var $fcbjO = parcelRequire("fcbjO");

var $ksIKp = parcelRequire("ksIKp");

var $1OSs0 = parcelRequire("1OSs0");
async function $edfa88d98346bb5d$export$db8bba598ef289f1(client, args) {
    const { account: account_ = client.account, blockNumber: blockNumber, blockTag: blockTag = "latest", blobs: blobs, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, to: to, value: value, ...rest } = args;
    const account = account_ ? (0, $gbEG8.parseAccount)(account_) : undefined;
    try {
        (0, $1OSs0.assertRequest)(args);
        const blockNumberHex = blockNumber ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $ksIKp.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $fcbjO.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            blobs: blobs,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerBlobGas: maxFeePerBlobGas,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            to: to,
            value: value
        });
        const response = await client.request({
            method: "eth_createAccessList",
            params: [
                request,
                block
            ]
        });
        return {
            accessList: response.accessList,
            gasUsed: BigInt(response.gasUsed)
        };
    } catch (err) {
        throw (0, $3zih5.getCallError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}


/**
 * Scopes `request` to the filter ID. If the client is a fallback, it will
 * listen for responses and scope the child transport `request` function
 * to the successful filter ID.
 */ function $6183f7820051e41f$export$b7aadf80a875f555(client, { method: method }) {
    const requestMap = {};
    if (client.transport.type === "fallback") client.transport.onResponse?.(({ method: method_, response: id, status: status, transport: transport })=>{
        if (status === "success" && method === method_) requestMap[id] = transport.request;
    });
    return (id)=>requestMap[id] || client.request;
}


async function $77055d3697eae26b$export$651edd5ecf84bf98(client) {
    const getRequest = (0, $6183f7820051e41f$export$b7aadf80a875f555)(client, {
        method: "eth_newBlockFilter"
    });
    const id = await client.request({
        method: "eth_newBlockFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "block"
    };
}



var $8p1we = parcelRequire("8p1we");

var $cahqm = parcelRequire("cahqm");
class $1c2451e15140d0ca$export$f71f080d25382681 extends (0, $cahqm.BaseError) {
    constructor(type){
        super(`Filter type "${type}" is not supported.`, {
            name: "FilterTypeNotSupportedError"
        });
    }
}



var $cY7Yq = parcelRequire("cY7Yq");

var $diQni = parcelRequire("diQni");

var $1VVjR = parcelRequire("1VVjR");

var $hxvKS = parcelRequire("hxvKS");

var $c3VTt = parcelRequire("c3VTt");

var $3BoTD = parcelRequire("3BoTD");
const $c7949e34d5b97d4c$var$docsPath = "/docs/contract/encodeEventTopics";
function $c7949e34d5b97d4c$export$64e9f7ca5ce29acd(parameters) {
    const { abi: abi, eventName: eventName, args: args } = parameters;
    let abiItem = abi[0];
    if (eventName) {
        const item = (0, $3BoTD.getAbiItem)({
            abi: abi,
            name: eventName
        });
        if (!item) throw new (0, $8p1we.AbiEventNotFoundError)(eventName, {
            docsPath: $c7949e34d5b97d4c$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "event") throw new (0, $8p1we.AbiEventNotFoundError)(undefined, {
        docsPath: $c7949e34d5b97d4c$var$docsPath
    });
    const definition = (0, $c3VTt.formatAbiItem)(abiItem);
    const signature = (0, $1VVjR.toEventSelector)(definition);
    let topics = [];
    if (args && "inputs" in abiItem) {
        const indexedInputs = abiItem.inputs?.filter((param)=>"indexed" in param && param.indexed);
        const args_ = Array.isArray(args) ? args : Object.values(args).length > 0 ? indexedInputs?.map((x)=>args[x.name]) ?? [] : [];
        if (args_.length > 0) topics = indexedInputs?.map((param, i)=>{
            if (Array.isArray(args_[i])) return args_[i].map((_, j)=>$c7949e34d5b97d4c$var$encodeArg({
                    param: param,
                    value: args_[i][j]
                }));
            return typeof args_[i] !== "undefined" && args_[i] !== null ? $c7949e34d5b97d4c$var$encodeArg({
                param: param,
                value: args_[i]
            }) : null;
        }) ?? [];
    }
    return [
        signature,
        ...topics
    ];
}
function $c7949e34d5b97d4c$var$encodeArg({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes") return (0, $diQni.keccak256)((0, $cY7Yq.toBytes)(value));
    if (param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) throw new (0, $1c2451e15140d0ca$export$f71f080d25382681)(param.type);
    return (0, $hxvKS.encodeAbiParameters)([
        param
    ], [
        value
    ]);
}



var $jW8ut = parcelRequire("jW8ut");

async function $fcafd5d1a974ea6d$export$36f99fdb90149e8b(client, parameters) {
    const { address: address, abi: abi, args: args, eventName: eventName, fromBlock: fromBlock, strict: strict, toBlock: toBlock } = parameters;
    const getRequest = (0, $6183f7820051e41f$export$b7aadf80a875f555)(client, {
        method: "eth_newFilter"
    });
    const topics = eventName ? (0, $c7949e34d5b97d4c$export$64e9f7ca5ce29acd)({
        abi: abi,
        args: args,
        eventName: eventName
    }) : undefined;
    const id = await client.request({
        method: "eth_newFilter",
        params: [
            {
                address: address,
                fromBlock: typeof fromBlock === "bigint" ? (0, $jW8ut.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $jW8ut.numberToHex)(toBlock) : toBlock,
                topics: topics
            }
        ]
    });
    return {
        abi: abi,
        args: args,
        eventName: eventName,
        id: id,
        request: getRequest(id),
        strict: Boolean(strict),
        type: "event"
    };
}




var $jW8ut = parcelRequire("jW8ut");

async function $7d5f184fcf2b6dc1$export$977ab14bbccde633(client, { address: address, args: args, event: event, events: events_, fromBlock: fromBlock, strict: strict, toBlock: toBlock } = {}) {
    const events = events_ ?? (event ? [
        event
    ] : undefined);
    const getRequest = (0, $6183f7820051e41f$export$b7aadf80a875f555)(client, {
        method: "eth_newFilter"
    });
    let topics = [];
    if (events) {
        const encoded = events.flatMap((event)=>(0, $c7949e34d5b97d4c$export$64e9f7ca5ce29acd)({
                abi: [
                    event
                ],
                eventName: event.name,
                args: args
            }));
        // TODO: Clean up type casting
        topics = [
            encoded
        ];
        if (event) topics = topics[0];
    }
    const id = await client.request({
        method: "eth_newFilter",
        params: [
            {
                address: address,
                fromBlock: typeof fromBlock === "bigint" ? (0, $jW8ut.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $jW8ut.numberToHex)(toBlock) : toBlock,
                ...topics.length ? {
                    topics: topics
                } : {}
            }
        ]
    });
    return {
        abi: events,
        args: args,
        eventName: event ? event.name : undefined,
        fromBlock: fromBlock,
        id: id,
        request: getRequest(id),
        strict: Boolean(strict),
        toBlock: toBlock,
        type: "event"
    };
}



async function $a4c70f021aac4a30$export$d455ed04c3e85241(client) {
    const getRequest = (0, $6183f7820051e41f$export$b7aadf80a875f555)(client, {
        method: "eth_newPendingTransactionFilter"
    });
    const id = await client.request({
        method: "eth_newPendingTransactionFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "transaction"
    };
}



var $gbEG8 = parcelRequire("gbEG8");

var $aYJZ1 = parcelRequire("aYJZ1");



var $gbEG8 = parcelRequire("gbEG8");

var $cahqm = parcelRequire("cahqm");

var $jN5Zi = parcelRequire("jN5Zi");

var $jnwfF = parcelRequire("jnwfF");

var $cY7Yq = parcelRequire("cY7Yq");

var $jW8ut = parcelRequire("jW8ut");

var $cahqm = parcelRequire("cahqm");

var $d3xcE = parcelRequire("d3xcE");

var $cY7Yq = parcelRequire("cY7Yq");

var $jW8ut = parcelRequire("jW8ut");
function $2291411846ceaf93$export$140c78e750979cda(bytes, to = "hex") {
    const encodable = $2291411846ceaf93$var$getEncodable(bytes);
    const cursor = (0, $d3xcE.createCursor)(new Uint8Array(encodable.length));
    encodable.encode(cursor);
    if (to === "hex") return (0, $jW8ut.bytesToHex)(cursor.bytes);
    return cursor.bytes;
}
function $2291411846ceaf93$export$643d3163062ff0f3(bytes, to = "bytes") {
    return $2291411846ceaf93$export$140c78e750979cda(bytes, to);
}
function $2291411846ceaf93$export$e01da38311234e95(hex, to = "hex") {
    return $2291411846ceaf93$export$140c78e750979cda(hex, to);
}
function $2291411846ceaf93$var$getEncodable(bytes) {
    if (Array.isArray(bytes)) return $2291411846ceaf93$var$getEncodableList(bytes.map((x)=>$2291411846ceaf93$var$getEncodable(x)));
    return $2291411846ceaf93$var$getEncodableBytes(bytes);
}
function $2291411846ceaf93$var$getEncodableList(list) {
    const bodyLength = list.reduce((acc, x)=>acc + x.length, 0);
    const sizeOfBodyLength = $2291411846ceaf93$var$getSizeOfLength(bodyLength);
    const length = (()=>{
        if (bodyLength <= 55) return 1 + bodyLength;
        return 1 + sizeOfBodyLength + bodyLength;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bodyLength <= 55) cursor.pushByte(0xc0 + bodyLength);
            else {
                cursor.pushByte(247 + sizeOfBodyLength);
                if (sizeOfBodyLength === 1) cursor.pushUint8(bodyLength);
                else if (sizeOfBodyLength === 2) cursor.pushUint16(bodyLength);
                else if (sizeOfBodyLength === 3) cursor.pushUint24(bodyLength);
                else cursor.pushUint32(bodyLength);
            }
            for (const { encode: encode } of list)encode(cursor);
        }
    };
}
function $2291411846ceaf93$var$getEncodableBytes(bytesOrHex) {
    const bytes = typeof bytesOrHex === "string" ? (0, $cY7Yq.hexToBytes)(bytesOrHex) : bytesOrHex;
    const sizeOfBytesLength = $2291411846ceaf93$var$getSizeOfLength(bytes.length);
    const length = (()=>{
        if (bytes.length === 1 && bytes[0] < 0x80) return 1;
        if (bytes.length <= 55) return 1 + bytes.length;
        return 1 + sizeOfBytesLength + bytes.length;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bytes.length === 1 && bytes[0] < 0x80) cursor.pushBytes(bytes);
            else if (bytes.length <= 55) {
                cursor.pushByte(0x80 + bytes.length);
                cursor.pushBytes(bytes);
            } else {
                cursor.pushByte(183 + sizeOfBytesLength);
                if (sizeOfBytesLength === 1) cursor.pushUint8(bytes.length);
                else if (sizeOfBytesLength === 2) cursor.pushUint16(bytes.length);
                else if (sizeOfBytesLength === 3) cursor.pushUint24(bytes.length);
                else cursor.pushUint32(bytes.length);
                cursor.pushBytes(bytes);
            }
        }
    };
}
function $2291411846ceaf93$var$getSizeOfLength(length) {
    if (length < 256) return 1;
    if (length < 2 ** 16) return 2;
    if (length < 2 ** 24) return 3;
    if (length < 2 ** 32) return 4;
    throw new (0, $cahqm.BaseError)("Length is too large.");
}



var $diQni = parcelRequire("diQni");
function $4d744fb1f474c670$export$52e574e057b290dc(parameters) {
    const { chainId: chainId, contractAddress: contractAddress, nonce: nonce, to: to } = parameters;
    const hash = (0, $diQni.keccak256)((0, $jnwfF.concatHex)([
        "0x05",
        (0, $2291411846ceaf93$export$140c78e750979cda)([
            chainId ? (0, $jW8ut.numberToHex)(chainId) : "0x",
            contractAddress,
            nonce ? (0, $jW8ut.numberToHex)(nonce) : "0x"
        ])
    ]));
    if (to === "bytes") return (0, $cY7Yq.hexToBytes)(hash);
    return hash;
}


async function $36af70ab738a2385$export$415d0315604a8515(parameters) {
    const { authorization: authorization, signature: signature } = parameters;
    return (0, $jN5Zi.recoverAddress)({
        hash: (0, $4d744fb1f474c670$export$52e574e057b290dc)(authorization),
        signature: signature ?? authorization
    });
}



var $jW8ut = parcelRequire("jW8ut");

var $g36WF = parcelRequire("g36WF");

var $6yGUx = parcelRequire("6yGUx");

var $cahqm = parcelRequire("cahqm");

var $3a3vr = parcelRequire("3a3vr");
class $6d6d52ee0900ea36$export$9e393e362ab0c102 extends (0, $cahqm.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = (0, $3a3vr.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $g36WF.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $6yGUx.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $6yGUx.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $6yGUx.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Estimate Gas Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "EstimateGasExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}



var $iWaDR = parcelRequire("iWaDR");

var $iZm7e = parcelRequire("iZm7e");
function $ce3e037031aa1e99$export$f201b805dbcd7c48(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $iZm7e.getNodeError)(err, args);
        if (cause instanceof (0, $iWaDR.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $6d6d52ee0900ea36$export$9e393e362ab0c102)(cause, {
        docsPath: docsPath,
        ...args
    });
}



var $fcbjO = parcelRequire("fcbjO");

var $ksIKp = parcelRequire("ksIKp");

var $l7x0m = parcelRequire("l7x0m");

var $1OSs0 = parcelRequire("1OSs0");

var $gbEG8 = parcelRequire("gbEG8");

var $6yGUx = parcelRequire("6yGUx");

var $cahqm = parcelRequire("cahqm");
class $a660607feec576f5$export$200c092bedf29ac0 extends (0, $cahqm.BaseError) {
    constructor(){
        super("`baseFeeMultiplier` must be greater than 1.", {
            name: "BaseFeeScalarError"
        });
    }
}
class $a660607feec576f5$export$dcf53c0ae183fb46 extends (0, $cahqm.BaseError) {
    constructor(){
        super("Chain does not support EIP-1559 fees.", {
            name: "Eip1559FeesNotSupportedError"
        });
    }
}
class $a660607feec576f5$export$bcf9730904a1086f extends (0, $cahqm.BaseError) {
    constructor({ maxPriorityFeePerGas: maxPriorityFeePerGas }){
        super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${(0, $6yGUx.formatGwei)(maxPriorityFeePerGas)} gwei).`, {
            name: "MaxFeePerGasTooLowError"
        });
    }
}





var $9GGVO = parcelRequire("9GGVO");


var $cahqm = parcelRequire("cahqm");
class $0533198dc39444c8$export$f5a00468af285e38 extends (0, $cahqm.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber }){
        let identifier = "Block";
        if (blockHash) identifier = `Block at hash "${blockHash}"`;
        if (blockNumber) identifier = `Block at number "${blockNumber}"`;
        super(`${identifier} could not be found.`, {
            name: "BlockNotFoundError"
        });
    }
}



var $jW8ut = parcelRequire("jW8ut");

var $awA7s = parcelRequire("awA7s");

var $9GGVO = parcelRequire("9GGVO");

var $awA7s = parcelRequire("awA7s");
const $23c54fd803cb615d$export$cd5f936b62a5e91 = {
    "0x0": "legacy",
    "0x1": "eip2930",
    "0x2": "eip1559",
    "0x3": "eip4844",
    "0x4": "eip7702"
};
function $23c54fd803cb615d$export$b02b16590d26dadc(transaction) {
    const transaction_ = {
        ...transaction,
        blockHash: transaction.blockHash ? transaction.blockHash : null,
        blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
        chainId: transaction.chainId ? (0, $9GGVO.hexToNumber)(transaction.chainId) : undefined,
        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
        maxFeePerBlobGas: transaction.maxFeePerBlobGas ? BigInt(transaction.maxFeePerBlobGas) : undefined,
        maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : undefined,
        nonce: transaction.nonce ? (0, $9GGVO.hexToNumber)(transaction.nonce) : undefined,
        to: transaction.to ? transaction.to : null,
        transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
        type: transaction.type ? $23c54fd803cb615d$export$cd5f936b62a5e91[transaction.type] : undefined,
        typeHex: transaction.type ? transaction.type : undefined,
        value: transaction.value ? BigInt(transaction.value) : undefined,
        v: transaction.v ? BigInt(transaction.v) : undefined
    };
    if (transaction.authorizationList) transaction_.authorizationList = $23c54fd803cb615d$var$formatAuthorizationList(transaction.authorizationList);
    transaction_.yParity = (()=>{
        // If `yParity` is provided, we will use it.
        if (transaction.yParity) return Number(transaction.yParity);
        // If no `yParity` provided, try derive from `v`.
        if (typeof transaction_.v === "bigint") {
            if (transaction_.v === 0n || transaction_.v === 27n) return 0;
            if (transaction_.v === 1n || transaction_.v === 28n) return 1;
            if (transaction_.v >= 35n) return transaction_.v % 2n === 0n ? 1 : 0;
        }
        return undefined;
    })();
    if (transaction_.type === "legacy") {
        delete transaction_.accessList;
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
        delete transaction_.yParity;
    }
    if (transaction_.type === "eip2930") {
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
    }
    if (transaction_.type === "eip1559") delete transaction_.maxFeePerBlobGas;
    return transaction_;
}
const $23c54fd803cb615d$export$c19bdc7dbe69198d = /*#__PURE__*/ (0, $awA7s.defineFormatter)("transaction", $23c54fd803cb615d$export$b02b16590d26dadc);
//////////////////////////////////////////////////////////////////////////////
function $23c54fd803cb615d$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization)=>({
            contractAddress: authorization.address,
            chainId: Number(authorization.chainId),
            nonce: Number(authorization.nonce),
            r: authorization.r,
            s: authorization.s,
            yParity: Number(authorization.yParity)
        }));
}


function $3791204a4fe10280$export$ba1152bc4017d62a(block) {
    const transactions = (block.transactions ?? []).map((transaction)=>{
        if (typeof transaction === "string") return transaction;
        return (0, $23c54fd803cb615d$export$b02b16590d26dadc)(transaction);
    });
    return {
        ...block,
        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
        blobGasUsed: block.blobGasUsed ? BigInt(block.blobGasUsed) : undefined,
        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
        excessBlobGas: block.excessBlobGas ? BigInt(block.excessBlobGas) : undefined,
        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
        hash: block.hash ? block.hash : null,
        logsBloom: block.logsBloom ? block.logsBloom : null,
        nonce: block.nonce ? block.nonce : null,
        number: block.number ? BigInt(block.number) : null,
        size: block.size ? BigInt(block.size) : undefined,
        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
        transactions: transactions,
        totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
    };
}
const $3791204a4fe10280$export$9f35cb3327f1a5c5 = /*#__PURE__*/ (0, $awA7s.defineFormatter)("block", $3791204a4fe10280$export$ba1152bc4017d62a);


async function $40897522faf9b729$export$ea0af84ed2e77902(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, includeTransactions: includeTransactions_ } = {}) {
    const blockTag = blockTag_ ?? "latest";
    const includeTransactions = includeTransactions_ ?? false;
    const blockNumberHex = blockNumber !== undefined ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
    let block = null;
    if (blockHash) block = await client.request({
        method: "eth_getBlockByHash",
        params: [
            blockHash,
            includeTransactions
        ]
    }, {
        dedupe: true
    });
    else block = await client.request({
        method: "eth_getBlockByNumber",
        params: [
            blockNumberHex || blockTag,
            includeTransactions
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (!block) throw new (0, $0533198dc39444c8$export$f5a00468af285e38)({
        blockHash: blockHash,
        blockNumber: blockNumber
    });
    const format = client.chain?.formatters?.block?.format || (0, $3791204a4fe10280$export$ba1152bc4017d62a);
    return format(block);
}


/**
 * Returns the current price of gas (in wei).
 *
 * - Docs: https://viem.sh/docs/actions/public/getGasPrice
 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
 *
 * @param client - Client to use
 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getGasPrice } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasPrice = await getGasPrice(client)
 */ async function $e84282994ef4ec82$export$89c15b50d46d3f8c(client) {
    const gasPrice = await client.request({
        method: "eth_gasPrice"
    });
    return BigInt(gasPrice);
}


async function $19bc8536d1fd29a4$export$fd79a693887f886c(client, args) {
    return $19bc8536d1fd29a4$export$59275bafd388148(client, args);
}
async function $19bc8536d1fd29a4$export$59275bafd388148(client, args) {
    const { block: block_, chain: chain = client.chain, request: request } = args || {};
    try {
        const maxPriorityFeePerGas = chain?.fees?.maxPriorityFeePerGas ?? chain?.fees?.defaultPriorityFee;
        if (typeof maxPriorityFeePerGas === "function") {
            const block = block_ || await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $40897522faf9b729$export$ea0af84ed2e77902), "getBlock")({});
            const maxPriorityFeePerGas_ = await maxPriorityFeePerGas({
                block: block,
                client: client,
                request: request
            });
            if (maxPriorityFeePerGas_ === null) throw new Error();
            return maxPriorityFeePerGas_;
        }
        if (typeof maxPriorityFeePerGas !== "undefined") return maxPriorityFeePerGas;
        const maxPriorityFeePerGasHex = await client.request({
            method: "eth_maxPriorityFeePerGas"
        });
        return (0, $9GGVO.hexToBigInt)(maxPriorityFeePerGasHex);
    } catch  {
        // If the RPC Provider does not support `eth_maxPriorityFeePerGas`
        // fall back to calculating it manually via `gasPrice - baseFeePerGas`.
        // See: https://github.com/ethereum/pm/issues/328#:~:text=eth_maxPriorityFeePerGas%20after%20London%20will%20effectively%20return%20eth_gasPrice%20%2D%20baseFee
        const [block, gasPrice] = await Promise.all([
            block_ ? Promise.resolve(block_) : (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $40897522faf9b729$export$ea0af84ed2e77902), "getBlock")({}),
            (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $e84282994ef4ec82$export$89c15b50d46d3f8c), "getGasPrice")({})
        ]);
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $a660607feec576f5$export$dcf53c0ae183fb46)();
        const maxPriorityFeePerGas = gasPrice - block.baseFeePerGas;
        if (maxPriorityFeePerGas < 0n) return 0n;
        return maxPriorityFeePerGas;
    }
}




async function $e4d35effe014a033$export$8193bed8c46d2831(client, args) {
    return $e4d35effe014a033$export$67115e8707c5a9e(client, args);
}
async function $e4d35effe014a033$export$67115e8707c5a9e(client, args) {
    const { block: block_, chain: chain = client.chain, request: request, type: type = "eip1559" } = args || {};
    const baseFeeMultiplier = await (async ()=>{
        if (typeof chain?.fees?.baseFeeMultiplier === "function") return chain.fees.baseFeeMultiplier({
            block: block_,
            client: client,
            request: request
        });
        return chain?.fees?.baseFeeMultiplier ?? 1.2;
    })();
    if (baseFeeMultiplier < 1) throw new (0, $a660607feec576f5$export$200c092bedf29ac0)();
    const decimals = baseFeeMultiplier.toString().split(".")[1]?.length ?? 0;
    const denominator = 10 ** decimals;
    const multiply = (base)=>base * BigInt(Math.ceil(baseFeeMultiplier * denominator)) / BigInt(denominator);
    const block = block_ ? block_ : await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $40897522faf9b729$export$ea0af84ed2e77902), "getBlock")({});
    if (typeof chain?.fees?.estimateFeesPerGas === "function") {
        const fees = await chain.fees.estimateFeesPerGas({
            block: block_,
            client: client,
            multiply: multiply,
            request: request,
            type: type
        });
        if (fees !== null) return fees;
    }
    if (type === "eip1559") {
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $a660607feec576f5$export$dcf53c0ae183fb46)();
        const maxPriorityFeePerGas = typeof request?.maxPriorityFeePerGas === "bigint" ? request.maxPriorityFeePerGas : await (0, $19bc8536d1fd29a4$export$59275bafd388148)(client, {
            block: block,
            chain: chain,
            request: request
        });
        const baseFeePerGas = multiply(block.baseFeePerGas);
        const maxFeePerGas = request?.maxFeePerGas ?? baseFeePerGas + maxPriorityFeePerGas;
        return {
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas
        };
    }
    const gasPrice = request?.gasPrice ?? multiply(await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $e84282994ef4ec82$export$89c15b50d46d3f8c), "getGasPrice")({}));
    return {
        gasPrice: gasPrice
    };
}





var $9GGVO = parcelRequire("9GGVO");

var $jW8ut = parcelRequire("jW8ut");
async function $7bfc8e45417dbe30$export$b18e66333ec1361e(client, { address: address, blockTag: blockTag = "latest", blockNumber: blockNumber }) {
    const count = await client.request({
        method: "eth_getTransactionCount",
        params: [
            address,
            blockNumber ? (0, $jW8ut.numberToHex)(blockNumber) : blockTag
        ]
    }, {
        dedupe: Boolean(blockNumber)
    });
    return (0, $9GGVO.hexToNumber)(count);
}




var $cY7Yq = parcelRequire("cY7Yq");

var $jW8ut = parcelRequire("jW8ut");
function $70011a5ca3dd93f2$export$b67626aab22a659b(parameters) {
    const { kzg: kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === "string" ? "hex" : "bytes");
    const blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map((x)=>(0, $cY7Yq.hexToBytes)(x)) : parameters.blobs;
    const commitments = [];
    for (const blob of blobs)commitments.push(Uint8Array.from(kzg.blobToKzgCommitment(blob)));
    return to === "bytes" ? commitments : commitments.map((x)=>(0, $jW8ut.bytesToHex)(x));
}



var $cY7Yq = parcelRequire("cY7Yq");

var $jW8ut = parcelRequire("jW8ut");
function $bfa4075f1d370529$export$78a225f8922765eb(parameters) {
    const { kzg: kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === "string" ? "hex" : "bytes");
    const blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map((x)=>(0, $cY7Yq.hexToBytes)(x)) : parameters.blobs;
    const commitments = typeof parameters.commitments[0] === "string" ? parameters.commitments.map((x)=>(0, $cY7Yq.hexToBytes)(x)) : parameters.commitments;
    const proofs = [];
    for(let i = 0; i < blobs.length; i++){
        const blob = blobs[i];
        const commitment = commitments[i];
        proofs.push(Uint8Array.from(kzg.computeBlobKzgProof(blob, commitment)));
    }
    return to === "bytes" ? proofs : proofs.map((x)=>(0, $jW8ut.bytesToHex)(x));
}



var $jW8ut = parcelRequire("jW8ut");

var $ceTyC = parcelRequire("ceTyC");

var $16Qvp = parcelRequire("16Qvp");

var $cY7Yq = parcelRequire("cY7Yq");

var $jW8ut = parcelRequire("jW8ut");
function $2d2cef840556b395$export$bced8d2aada2d1c9(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $ceTyC.sha256)((0, $16Qvp.isHex)(value, {
        strict: false
    }) ? (0, $cY7Yq.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $jW8ut.toHex)(bytes);
}


function $55a412483a0356c4$export$7b2f762c7eb1ecea(parameters) {
    const { commitment: commitment, version: version = 1 } = parameters;
    const to = parameters.to ?? (typeof commitment === "string" ? "hex" : "bytes");
    const versionedHash = (0, $2d2cef840556b395$export$bced8d2aada2d1c9)(commitment, "bytes");
    versionedHash.set([
        version
    ], 0);
    return to === "bytes" ? versionedHash : (0, $jW8ut.bytesToHex)(versionedHash);
}


function $7c2c25fe50bdb9c6$export$e31b3e59dda37b17(parameters) {
    const { commitments: commitments, version: version } = parameters;
    const to = parameters.to ?? (typeof commitments[0] === "string" ? "hex" : "bytes");
    const hashes = [];
    for (const commitment of commitments)hashes.push((0, $55a412483a0356c4$export$7b2f762c7eb1ecea)({
        commitment: commitment,
        to: to,
        version: version
    }));
    return hashes;
}




// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
/** Blob limit per transaction. */ const $a328952d45c0c578$var$blobsPerTransaction = 6;
const $a328952d45c0c578$export$a5d2a246d959344 = 32;
const $a328952d45c0c578$export$57577a1a84b7e334 = 4096;
const $a328952d45c0c578$export$6f30828563a6c6ef = $a328952d45c0c578$export$a5d2a246d959344 * $a328952d45c0c578$export$57577a1a84b7e334;
const $a328952d45c0c578$export$b8db4e3f07d08e09 = $a328952d45c0c578$export$6f30828563a6c6ef * $a328952d45c0c578$var$blobsPerTransaction - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * $a328952d45c0c578$export$57577a1a84b7e334 * $a328952d45c0c578$var$blobsPerTransaction;


// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
const $1b9c967afd9a35a8$export$de38d5f871f0b1cd = 1;



var $cahqm = parcelRequire("cahqm");
class $83b6491e0ebe571c$export$4000e90bfe41caa1 extends (0, $cahqm.BaseError) {
    constructor({ maxSize: maxSize, size: size }){
        super("Blob size is too large.", {
            metaMessages: [
                `Max: ${maxSize} bytes`,
                `Given: ${size} bytes`
            ],
            name: "BlobSizeTooLargeError"
        });
    }
}
class $83b6491e0ebe571c$export$d145394ceab4d1c3 extends (0, $cahqm.BaseError) {
    constructor(){
        super("Blob data must not be empty.", {
            name: "EmptyBlobError"
        });
    }
}
class $83b6491e0ebe571c$export$ebd5b15dd92c680 extends (0, $cahqm.BaseError) {
    constructor({ hash: hash, size: size }){
        super(`Versioned hash "${hash}" size is invalid.`, {
            metaMessages: [
                "Expected: 32",
                `Received: ${size}`
            ],
            name: "InvalidVersionedHashSizeError"
        });
    }
}
class $83b6491e0ebe571c$export$509ed1d312c500 extends (0, $cahqm.BaseError) {
    constructor({ hash: hash, version: version }){
        super(`Versioned hash "${hash}" version is invalid.`, {
            metaMessages: [
                `Expected: ${(0, $1b9c967afd9a35a8$export$de38d5f871f0b1cd)}`,
                `Received: ${version}`
            ],
            name: "InvalidVersionedHashVersionError"
        });
    }
}



var $d3xcE = parcelRequire("d3xcE");

var $lsLGO = parcelRequire("lsLGO");

var $cY7Yq = parcelRequire("cY7Yq");

var $jW8ut = parcelRequire("jW8ut");
function $5fa677a606319823$export$7ec339bd77d6ed92(parameters) {
    const to = parameters.to ?? (typeof parameters.data === "string" ? "hex" : "bytes");
    const data = typeof parameters.data === "string" ? (0, $cY7Yq.hexToBytes)(parameters.data) : parameters.data;
    const size_ = (0, $lsLGO.size)(data);
    if (!size_) throw new (0, $83b6491e0ebe571c$export$d145394ceab4d1c3)();
    if (size_ > (0, $a328952d45c0c578$export$b8db4e3f07d08e09)) throw new (0, $83b6491e0ebe571c$export$4000e90bfe41caa1)({
        maxSize: (0, $a328952d45c0c578$export$b8db4e3f07d08e09),
        size: size_
    });
    const blobs = [];
    let active = true;
    let position = 0;
    while(active){
        const blob = (0, $d3xcE.createCursor)(new Uint8Array((0, $a328952d45c0c578$export$6f30828563a6c6ef)));
        let size = 0;
        while(size < (0, $a328952d45c0c578$export$57577a1a84b7e334)){
            const bytes = data.slice(position, position + ((0, $a328952d45c0c578$export$a5d2a246d959344) - 1));
            // Push a zero byte so the field element doesn't overflow the BLS modulus.
            blob.pushByte(0x00);
            // Push the current segment of data bytes.
            blob.pushBytes(bytes);
            // If we detect that the current segment of data bytes is less than 31 bytes,
            // we can stop processing and push a terminator byte to indicate the end of the blob.
            if (bytes.length < 31) {
                blob.pushByte(0x80);
                active = false;
                break;
            }
            size++;
            position += 31;
        }
        blobs.push(blob);
    }
    return to === "bytes" ? blobs.map((x)=>x.bytes) : blobs.map((x)=>(0, $jW8ut.bytesToHex)(x.bytes));
}


function $bb4ee8a63805c99d$export$44960962e1c9641b(parameters) {
    const { data: data, kzg: kzg, to: to } = parameters;
    const blobs = parameters.blobs ?? (0, $5fa677a606319823$export$7ec339bd77d6ed92)({
        data: data,
        to: to
    });
    const commitments = parameters.commitments ?? (0, $70011a5ca3dd93f2$export$b67626aab22a659b)({
        blobs: blobs,
        kzg: kzg,
        to: to
    });
    const proofs = parameters.proofs ?? (0, $bfa4075f1d370529$export$78a225f8922765eb)({
        blobs: blobs,
        commitments: commitments,
        kzg: kzg,
        to: to
    });
    const sidecars = [];
    for(let i = 0; i < blobs.length; i++)sidecars.push({
        blob: blobs[i],
        commitment: commitments[i],
        proof: proofs[i]
    });
    return sidecars;
}




var $1OSs0 = parcelRequire("1OSs0");

var $3a3vr = parcelRequire("3a3vr");
function $132020cae19f974b$export$944c6678cd5a1ea8(transaction) {
    if (transaction.type) return transaction.type;
    if (typeof transaction.authorizationList !== "undefined") return "eip7702";
    if (typeof transaction.blobs !== "undefined" || typeof transaction.blobVersionedHashes !== "undefined" || typeof transaction.maxFeePerBlobGas !== "undefined" || typeof transaction.sidecars !== "undefined") return "eip4844";
    if (typeof transaction.maxFeePerGas !== "undefined" || typeof transaction.maxPriorityFeePerGas !== "undefined") return "eip1559";
    if (typeof transaction.gasPrice !== "undefined") {
        if (typeof transaction.accessList !== "undefined") return "eip2930";
        return "legacy";
    }
    throw new (0, $3a3vr.InvalidSerializableTransactionError)({
        transaction: transaction
    });
}



var $9GGVO = parcelRequire("9GGVO");
async function $df79c8eb8659d088$export$850fa7b3891187c(client) {
    const chainIdHex = await client.request({
        method: "eth_chainId"
    }, {
        dedupe: true
    });
    return (0, $9GGVO.hexToNumber)(chainIdHex);
}


const $bf5271a93dc90ad4$export$4f3e0c2bc77eca55 = [
    "blobVersionedHashes",
    "chainId",
    "fees",
    "gas",
    "nonce",
    "type"
];
const $bf5271a93dc90ad4$export$1cdc34309351bc26 = /*#__PURE__*/ new Map();
async function $bf5271a93dc90ad4$export$2e8a9232fb815d77(client, args) {
    const { account: account_ = client.account, blobs: blobs, chain: chain, gas: gas, kzg: kzg, nonce: nonce, nonceManager: nonceManager, parameters: parameters = $bf5271a93dc90ad4$export$4f3e0c2bc77eca55, type: type } = args;
    const account = account_ ? (0, $gbEG8.parseAccount)(account_) : account_;
    const request = {
        ...args,
        ...account ? {
            from: account?.address
        } : {}
    };
    let block;
    async function getBlock() {
        if (block) return block;
        block = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $40897522faf9b729$export$ea0af84ed2e77902), "getBlock")({
            blockTag: "latest"
        });
        return block;
    }
    let chainId;
    async function getChainId() {
        if (chainId) return chainId;
        if (chain) return chain.id;
        if (typeof args.chainId !== "undefined") return args.chainId;
        const chainId_ = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $df79c8eb8659d088$export$850fa7b3891187c), "getChainId")({});
        chainId = chainId_;
        return chainId;
    }
    if ((parameters.includes("blobVersionedHashes") || parameters.includes("sidecars")) && blobs && kzg) {
        const commitments = (0, $70011a5ca3dd93f2$export$b67626aab22a659b)({
            blobs: blobs,
            kzg: kzg
        });
        if (parameters.includes("blobVersionedHashes")) {
            const versionedHashes = (0, $7c2c25fe50bdb9c6$export$e31b3e59dda37b17)({
                commitments: commitments,
                to: "hex"
            });
            request.blobVersionedHashes = versionedHashes;
        }
        if (parameters.includes("sidecars")) {
            const proofs = (0, $bfa4075f1d370529$export$78a225f8922765eb)({
                blobs: blobs,
                commitments: commitments,
                kzg: kzg
            });
            const sidecars = (0, $bb4ee8a63805c99d$export$44960962e1c9641b)({
                blobs: blobs,
                commitments: commitments,
                proofs: proofs,
                to: "hex"
            });
            request.sidecars = sidecars;
        }
    }
    if (parameters.includes("chainId")) request.chainId = await getChainId();
    if ((parameters.includes("fees") || parameters.includes("type")) && typeof type === "undefined") try {
        request.type = (0, $132020cae19f974b$export$944c6678cd5a1ea8)(request);
    } catch  {
        let isEip1559Network = $bf5271a93dc90ad4$export$1cdc34309351bc26.get(client.uid);
        if (typeof isEip1559Network === "undefined") {
            const block = await getBlock();
            isEip1559Network = typeof block?.baseFeePerGas === "bigint";
            $bf5271a93dc90ad4$export$1cdc34309351bc26.set(client.uid, isEip1559Network);
        }
        request.type = isEip1559Network ? "eip1559" : "legacy";
    }
    if (parameters.includes("fees")) {
        // TODO(4844): derive blob base fees once https://github.com/ethereum/execution-apis/pull/486 is merged.
        if (request.type !== "legacy" && request.type !== "eip2930") // EIP-1559 fees
        {
            if (typeof request.maxFeePerGas === "undefined" || typeof request.maxPriorityFeePerGas === "undefined") {
                const block = await getBlock();
                const { maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = await (0, $e4d35effe014a033$export$67115e8707c5a9e)(client, {
                    block: block,
                    chain: chain,
                    request: request
                });
                if (typeof args.maxPriorityFeePerGas === "undefined" && args.maxFeePerGas && args.maxFeePerGas < maxPriorityFeePerGas) throw new (0, $a660607feec576f5$export$bcf9730904a1086f)({
                    maxPriorityFeePerGas: maxPriorityFeePerGas
                });
                request.maxPriorityFeePerGas = maxPriorityFeePerGas;
                request.maxFeePerGas = maxFeePerGas;
            }
        } else {
            // Legacy fees
            if (typeof args.maxFeePerGas !== "undefined" || typeof args.maxPriorityFeePerGas !== "undefined") throw new (0, $a660607feec576f5$export$dcf53c0ae183fb46)();
            if (typeof args.gasPrice === "undefined") {
                const block = await getBlock();
                const { gasPrice: gasPrice_ } = await (0, $e4d35effe014a033$export$67115e8707c5a9e)(client, {
                    block: block,
                    chain: chain,
                    request: request,
                    type: "legacy"
                });
                request.gasPrice = gasPrice_;
            }
        }
    }
    if (parameters.includes("gas") && typeof gas === "undefined") request.gas = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $9ee228e9f26c6e59$export$e0580ae1f48db848), "estimateGas")({
        ...request,
        account: account ? {
            address: account.address,
            type: "json-rpc"
        } : account
    });
    if (parameters.includes("nonce") && typeof nonce === "undefined" && account) {
        if (nonceManager) {
            const chainId = await getChainId();
            request.nonce = await nonceManager.consume({
                address: account.address,
                chainId: chainId,
                client: client
            });
        } else request.nonce = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $7bfc8e45417dbe30$export$b18e66333ec1361e), "getTransactionCount")({
            address: account.address,
            blockTag: "pending"
        });
    }
    (0, $1OSs0.assertRequest)(request);
    delete request.parameters;
    return request;
}



async function $9ee228e9f26c6e59$export$e0580ae1f48db848(client, args) {
    const { account: account_ = client.account } = args;
    const account = account_ ? (0, $gbEG8.parseAccount)(account_) : undefined;
    try {
        const { accessList: accessList, authorizationList: authorizationList, blobs: blobs, blobVersionedHashes: blobVersionedHashes, blockNumber: blockNumber, blockTag: blockTag, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value, stateOverride: stateOverride, ...rest } = await (0, $bf5271a93dc90ad4$export$2e8a9232fb815d77)(client, {
            ...args,
            parameters: // Some RPC Providers do not compute versioned hashes from blobs. We will need
            // to compute them.
            account?.type === "local" ? undefined : [
                "blobVersionedHashes"
            ]
        });
        const blockNumberHex = blockNumber ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcStateOverride = (0, $l7x0m.serializeStateOverride)(stateOverride);
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (rest.to) return rest.to;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0) return await (0, $36af70ab738a2385$export$415d0315604a8515)({
                authorization: authorizationList[0]
            }).catch(()=>{
                throw new (0, $cahqm.BaseError)("`to` is required. Could not infer from `authorizationList`");
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        (0, $1OSs0.assertRequest)(args);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $ksIKp.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $fcbjO.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            authorizationList: authorizationList,
            blobs: blobs,
            blobVersionedHashes: blobVersionedHashes,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerBlobGas: maxFeePerBlobGas,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        function estimateGas_rpc(parameters) {
            const { block: block, request: request, rpcStateOverride: rpcStateOverride } = parameters;
            return client.request({
                method: "eth_estimateGas",
                params: rpcStateOverride ? [
                    request,
                    block ?? "latest",
                    rpcStateOverride
                ] : block ? [
                    request,
                    block
                ] : [
                    request
                ]
            });
        }
        let estimate = BigInt(await estimateGas_rpc({
            block: block,
            request: request,
            rpcStateOverride: rpcStateOverride
        }));
        // TODO(7702): Remove this once https://github.com/ethereum/execution-apis/issues/561 is resolved.
        //       Authorization list schema is not implemented on JSON-RPC spec yet, so we need to
        //       manually estimate the gas.
        if (authorizationList) {
            const value = await (0, $1c1667fc515d46a5$export$df96cd8d56be0ab1)(client, {
                address: request.from
            });
            const estimates = await Promise.all(authorizationList.map(async (authorization)=>{
                const { contractAddress: contractAddress } = authorization;
                const estimate = await estimateGas_rpc({
                    block: block,
                    request: {
                        authorizationList: undefined,
                        data: data,
                        from: account?.address,
                        to: contractAddress,
                        value: (0, $jW8ut.numberToHex)(value)
                    },
                    rpcStateOverride: rpcStateOverride
                }).catch(()=>100000n);
                return 2n * BigInt(estimate);
            }));
            estimate += estimates.reduce((acc, curr)=>acc + curr, 0n);
        }
        return estimate;
    } catch (err) {
        throw (0, $ce3e037031aa1e99$export$f201b805dbcd7c48)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}


async function $f8639f2af5400fa8$export$7b896b3a3695de87(client, parameters) {
    const { abi: abi, address: address, args: args, functionName: functionName, dataSuffix: dataSuffix, ...request } = parameters;
    const data = (0, $aYJZ1.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const gas = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $9ee228e9f26c6e59$export$e0580ae1f48db848), "estimateGas")({
            data: `${data}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
            to: address,
            ...request
        });
        return gas;
    } catch (error) {
        const account = request.account ? (0, $gbEG8.parseAccount)(request.account) : undefined;
        throw (0, $768c9bcff606843b$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/estimateContractGas",
            functionName: functionName,
            sender: account?.address
        });
    }
}






/**
 * Returns the base fee per blob gas in wei.
 *
 * - Docs: https://viem.sh/docs/actions/public/getBlobBaseFee
 * - JSON-RPC Methods: [`eth_blobBaseFee`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_blobBaseFee)
 *
 * @param client - Client to use
 * @returns The blob base fee (in wei). {@link GetBlobBaseFeeReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getBlobBaseFee } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const blobBaseFee = await getBlobBaseFee(client)
 */ async function $c5a50262cc7282ea$export$9682cd49f77b48b(client) {
    const baseFee = await client.request({
        method: "eth_blobBaseFee"
    });
    return BigInt(baseFee);
}



/** @internal */ const $22697ee57fa681c1$export$e89e805418f4d2c = /*#__PURE__*/ new Map();
const $22697ee57fa681c1$export$b4c67320c85a8b9d = /*#__PURE__*/ new Map();
function $22697ee57fa681c1$export$e2575ed62a2f107b(cacheKey) {
    const buildCache = (cacheKey, cache)=>({
            clear: ()=>cache.delete(cacheKey),
            get: ()=>cache.get(cacheKey),
            set: (data)=>cache.set(cacheKey, data)
        });
    const promise = buildCache(cacheKey, $22697ee57fa681c1$export$e89e805418f4d2c);
    const response = buildCache(cacheKey, $22697ee57fa681c1$export$b4c67320c85a8b9d);
    return {
        clear: ()=>{
            promise.clear();
            response.clear();
        },
        promise: promise,
        response: response
    };
}
async function $22697ee57fa681c1$export$33b32b3abf8170f0(fn, { cacheKey: cacheKey, cacheTime: cacheTime = Number.POSITIVE_INFINITY }) {
    const cache = $22697ee57fa681c1$export$e2575ed62a2f107b(cacheKey);
    // If a response exists in the cache, and it's not expired, return it
    // and do not invoke the promise.
    // If the max age is 0, the cache is disabled.
    const response = cache.response.get();
    if (response && cacheTime > 0) {
        const age = new Date().getTime() - response.created.getTime();
        if (age < cacheTime) return response.data;
    }
    let promise = cache.promise.get();
    if (!promise) {
        promise = fn();
        // Store the promise in the cache so that subsequent invocations
        // will wait for the same promise to resolve (deduping).
        cache.promise.set(promise);
    }
    try {
        const data = await promise;
        // Store the response in the cache so that subsequent invocations
        // will return the same response.
        cache.response.set({
            created: new Date(),
            data: data
        });
        return data;
    } finally{
        // Clear the promise cache so that subsequent invocations will
        // invoke the promise again.
        cache.promise.clear();
    }
}


const $bbd7d10bf828cb3d$var$cacheKey = (id)=>`blockNumber.${id}`;
function $bbd7d10bf828cb3d$export$bc78c57a2d1b4a2b(id) {
    return (0, $22697ee57fa681c1$export$e2575ed62a2f107b)($bbd7d10bf828cb3d$var$cacheKey(id));
}
async function $bbd7d10bf828cb3d$export$9328b5c92c53a20e(client, { cacheTime: cacheTime = client.cacheTime } = {}) {
    const blockNumberHex = await (0, $22697ee57fa681c1$export$33b32b3abf8170f0)(()=>client.request({
            method: "eth_blockNumber"
        }), {
        cacheKey: $bbd7d10bf828cb3d$var$cacheKey(client.uid),
        cacheTime: cacheTime
    });
    return BigInt(blockNumberHex);
}



var $9GGVO = parcelRequire("9GGVO");

var $jW8ut = parcelRequire("jW8ut");
async function $7d8c55196586ba9b$export$8c2de5be7f4dfc0(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag = "latest" } = {}) {
    const blockNumberHex = blockNumber !== undefined ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
    let count;
    if (blockHash) count = await client.request({
        method: "eth_getBlockTransactionCountByHash",
        params: [
            blockHash
        ]
    }, {
        dedupe: true
    });
    else count = await client.request({
        method: "eth_getBlockTransactionCountByNumber",
        params: [
            blockNumberHex || blockTag
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    return (0, $9GGVO.hexToNumber)(count);
}




var $jW8ut = parcelRequire("jW8ut");
async function $e90fb6cf5f7b7523$export$9a0a9c75ccef13fb(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber !== undefined ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
    const hex = await client.request({
        method: "eth_getCode",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (hex === "0x") return undefined;
    return hex;
}



var $3BoTD = parcelRequire("3BoTD");


// TODO(v3): checksum address.

var $8p1we = parcelRequire("8p1we");

var $13kYf = parcelRequire("13kYf");

var $cY7Yq = parcelRequire("cY7Yq");

var $diQni = parcelRequire("diQni");

var $1VVjR = parcelRequire("1VVjR");

var $8p1we = parcelRequire("8p1we");

var $lsLGO = parcelRequire("lsLGO");

var $1VVjR = parcelRequire("1VVjR");

var $2bJrV = parcelRequire("2bJrV");

var $hCHkb = parcelRequire("hCHkb");

var $c3VTt = parcelRequire("c3VTt");
const $3d9d5458117a88dd$var$docsPath = "/docs/contract/decodeEventLog";
function $3d9d5458117a88dd$export$ec0597e81db3d947(parameters) {
    const { abi: abi, data: data, strict: strict_, topics: topics } = parameters;
    const strict = strict_ ?? true;
    const [signature, ...argTopics] = topics;
    if (!signature) throw new (0, $8p1we.AbiEventSignatureEmptyTopicsError)({
        docsPath: $3d9d5458117a88dd$var$docsPath
    });
    const abiItem = (()=>{
        if (abi.length === 1) return abi[0];
        return abi.find((x)=>x.type === "event" && signature === (0, $1VVjR.toEventSelector)((0, $c3VTt.formatAbiItem)(x)));
    })();
    if (!(abiItem && "name" in abiItem) || abiItem.type !== "event") throw new (0, $8p1we.AbiEventSignatureNotFoundError)(signature, {
        docsPath: $3d9d5458117a88dd$var$docsPath
    });
    const { name: name, inputs: inputs } = abiItem;
    const isUnnamed = inputs?.some((x)=>!("name" in x && x.name));
    let args = isUnnamed ? [] : {};
    // Decode topics (indexed args).
    const indexedInputs = inputs.filter((x)=>"indexed" in x && x.indexed);
    for(let i = 0; i < indexedInputs.length; i++){
        const param = indexedInputs[i];
        const topic = argTopics[i];
        if (!topic) throw new (0, $8p1we.DecodeLogTopicsMismatch)({
            abiItem: abiItem,
            param: param
        });
        args[isUnnamed ? i : param.name || i] = $3d9d5458117a88dd$var$decodeTopic({
            param: param,
            value: topic
        });
    }
    // Decode data (non-indexed args).
    const nonIndexedInputs = inputs.filter((x)=>!("indexed" in x && x.indexed));
    if (nonIndexedInputs.length > 0) {
        if (data && data !== "0x") try {
            const decodedData = (0, $hCHkb.decodeAbiParameters)(nonIndexedInputs, data);
            if (decodedData) {
                if (isUnnamed) args = [
                    ...args,
                    ...decodedData
                ];
                else for(let i = 0; i < nonIndexedInputs.length; i++)args[nonIndexedInputs[i].name] = decodedData[i];
            }
        } catch (err) {
            if (strict) {
                if (err instanceof (0, $8p1we.AbiDecodingDataSizeTooSmallError) || err instanceof (0, $2bJrV.PositionOutOfBoundsError)) throw new (0, $8p1we.DecodeLogDataMismatch)({
                    abiItem: abiItem,
                    data: data,
                    params: nonIndexedInputs,
                    size: (0, $lsLGO.size)(data)
                });
                throw err;
            }
        }
        else if (strict) throw new (0, $8p1we.DecodeLogDataMismatch)({
            abiItem: abiItem,
            data: "0x",
            params: nonIndexedInputs,
            size: 0
        });
    }
    return {
        eventName: name,
        args: Object.values(args).length > 0 ? args : undefined
    };
}
function $3d9d5458117a88dd$var$decodeTopic({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes" || param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) return value;
    const decodedArg = (0, $hCHkb.decodeAbiParameters)([
        param
    ], value) || [];
    return decodedArg[0];
}


function $57796cf7a43e3978$export$7d811a19971cdf46(parameters) {
    const { abi: abi, args: args, logs: logs, strict: strict = true } = parameters;
    const eventName = (()=>{
        if (!parameters.eventName) return undefined;
        if (Array.isArray(parameters.eventName)) return parameters.eventName;
        return [
            parameters.eventName
        ];
    })();
    return logs.map((log)=>{
        try {
            const abiItem = abi.find((abiItem)=>abiItem.type === "event" && log.topics[0] === (0, $1VVjR.toEventSelector)(abiItem));
            if (!abiItem) return null;
            const event = (0, $3d9d5458117a88dd$export$ec0597e81db3d947)({
                ...log,
                abi: [
                    abiItem
                ],
                strict: strict
            });
            // Check that the decoded event name matches the provided event name.
            if (eventName && !eventName.includes(event.eventName)) return null;
            // Check that the decoded event args match the provided args.
            if (!$57796cf7a43e3978$var$includesArgs({
                args: event.args,
                inputs: abiItem.inputs,
                matchArgs: args
            })) return null;
            return {
                ...event,
                ...log
            };
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $8p1we.AbiEventSignatureNotFoundError)) return null;
            if (err instanceof (0, $8p1we.DecodeLogDataMismatch) || err instanceof (0, $8p1we.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if (strict) return null;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return {
                ...log,
                args: isUnnamed ? [] : {},
                eventName: eventName
            };
        }
    }).filter(Boolean);
}
function $57796cf7a43e3978$var$includesArgs(parameters) {
    const { args: args, inputs: inputs, matchArgs: matchArgs } = parameters;
    if (!matchArgs) return true;
    if (!args) return false;
    function isEqual(input, value, arg) {
        try {
            if (input.type === "address") return (0, $13kYf.isAddressEqual)(value, arg);
            if (input.type === "string" || input.type === "bytes") return (0, $diQni.keccak256)((0, $cY7Yq.toBytes)(value)) === arg;
            return value === arg;
        } catch  {
            return false;
        }
    }
    if (Array.isArray(args) && Array.isArray(matchArgs)) return matchArgs.every((value, index)=>{
        if (value === null || value === undefined) return true;
        const input = inputs[index];
        if (!input) return false;
        const value_ = Array.isArray(value) ? value : [
            value
        ];
        return value_.some((value)=>isEqual(input, value, args[index]));
    });
    if (typeof args === "object" && !Array.isArray(args) && typeof matchArgs === "object" && !Array.isArray(matchArgs)) return Object.entries(matchArgs).every(([key, value])=>{
        if (value === null || value === undefined) return true;
        const input = inputs.find((input)=>input.name === key);
        if (!input) return false;
        const value_ = Array.isArray(value) ? value : [
            value
        ];
        return value_.some((value)=>isEqual(input, value, args[key]));
    });
    return false;
}



var $jW8ut = parcelRequire("jW8ut");
function $709e48cfde3e2ced$export$fccdbdc2b9d7893(log, { args: args, eventName: eventName } = {}) {
    return {
        ...log,
        blockHash: log.blockHash ? log.blockHash : null,
        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
        logIndex: log.logIndex ? Number(log.logIndex) : null,
        transactionHash: log.transactionHash ? log.transactionHash : null,
        transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null,
        ...eventName ? {
            args: args,
            eventName: eventName
        } : {}
    };
}


async function $c3b30ee8b148d1e5$export$cb5260c832aab30a(client, { address: address, blockHash: blockHash, fromBlock: fromBlock, toBlock: toBlock, event: event, events: events_, args: args, strict: strict_ } = {}) {
    const strict = strict_ ?? false;
    const events = events_ ?? (event ? [
        event
    ] : undefined);
    let topics = [];
    if (events) {
        const encoded = events.flatMap((event)=>(0, $c7949e34d5b97d4c$export$64e9f7ca5ce29acd)({
                abi: [
                    event
                ],
                eventName: event.name,
                args: events_ ? undefined : args
            }));
        // TODO: Clean up type casting
        topics = [
            encoded
        ];
        if (event) topics = topics[0];
    }
    let logs;
    if (blockHash) logs = await client.request({
        method: "eth_getLogs",
        params: [
            {
                address: address,
                topics: topics,
                blockHash: blockHash
            }
        ]
    });
    else logs = await client.request({
        method: "eth_getLogs",
        params: [
            {
                address: address,
                topics: topics,
                fromBlock: typeof fromBlock === "bigint" ? (0, $jW8ut.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $jW8ut.numberToHex)(toBlock) : toBlock
            }
        ]
    });
    const formattedLogs = logs.map((log)=>(0, $709e48cfde3e2ced$export$fccdbdc2b9d7893)(log));
    if (!events) return formattedLogs;
    return (0, $57796cf7a43e3978$export$7d811a19971cdf46)({
        abi: events,
        args: args,
        logs: formattedLogs,
        strict: strict
    });
}


async function $26e58da49e1ee9ad$export$1e175955db02d8d(client, parameters) {
    const { abi: abi, address: address, args: args, blockHash: blockHash, eventName: eventName, fromBlock: fromBlock, toBlock: toBlock, strict: strict } = parameters;
    const event = eventName ? (0, $3BoTD.getAbiItem)({
        abi: abi,
        name: eventName
    }) : undefined;
    const events = !event ? abi.filter((x)=>x.type === "event") : undefined;
    return (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $c3b30ee8b148d1e5$export$cb5260c832aab30a), "getLogs")({
        address: address,
        args: args,
        blockHash: blockHash,
        event: event,
        events: events,
        fromBlock: fromBlock,
        toBlock: toBlock,
        strict: strict
    });
}



var $cahqm = parcelRequire("cahqm");
class $ce4e9334a1f7ffef$export$3738cbd1470ec0c extends (0, $cahqm.BaseError) {
    constructor({ address: address }){
        super(`No EIP-712 domain found on contract "${address}".`, {
            metaMessages: [
                "Ensure that:",
                `- The contract is deployed at the address "${address}".`,
                "- `eip712Domain()` function exists on the contract.",
                "- `eip712Domain()` function matches signature to ERC-5267 specification."
            ],
            name: "Eip712DomainNotFoundError"
        });
    }
}




async function $272e0cb59ff69f0e$export$78097141abc77755(client, parameters) {
    const { address: address, factory: factory, factoryData: factoryData } = parameters;
    try {
        const [fields, name, version, chainId, verifyingContract, salt, extensions] = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $2ba19faf5017d144$export$43af7de392176737), "readContract")({
            abi: $272e0cb59ff69f0e$var$abi,
            address: address,
            functionName: "eip712Domain",
            factory: factory,
            factoryData: factoryData
        });
        return {
            domain: {
                name: name,
                version: version,
                chainId: Number(chainId),
                verifyingContract: verifyingContract,
                salt: salt
            },
            extensions: extensions,
            fields: fields
        };
    } catch (e) {
        const error = e;
        if (error.name === "ContractFunctionExecutionError" && error.cause.name === "ContractFunctionZeroDataError") throw new (0, $ce4e9334a1f7ffef$export$3738cbd1470ec0c)({
            address: address
        });
        throw error;
    }
}
const $272e0cb59ff69f0e$var$abi = [
    {
        inputs: [],
        name: "eip712Domain",
        outputs: [
            {
                name: "fields",
                type: "bytes1"
            },
            {
                name: "name",
                type: "string"
            },
            {
                name: "version",
                type: "string"
            },
            {
                name: "chainId",
                type: "uint256"
            },
            {
                name: "verifyingContract",
                type: "address"
            },
            {
                name: "salt",
                type: "bytes32"
            },
            {
                name: "extensions",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];



var $jW8ut = parcelRequire("jW8ut");
function $deda3533cd301b66$export$6c26435bc7761d23(feeHistory) {
    return {
        baseFeePerGas: feeHistory.baseFeePerGas.map((value)=>BigInt(value)),
        gasUsedRatio: feeHistory.gasUsedRatio,
        oldestBlock: BigInt(feeHistory.oldestBlock),
        reward: feeHistory.reward?.map((reward)=>reward.map((value)=>BigInt(value)))
    };
}


async function $6ebe895d07245d37$export$66598bc0c00a958e(client, { blockCount: blockCount, blockNumber: blockNumber, blockTag: blockTag = "latest", rewardPercentiles: rewardPercentiles }) {
    const blockNumberHex = blockNumber ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
    const feeHistory = await client.request({
        method: "eth_feeHistory",
        params: [
            (0, $jW8ut.numberToHex)(blockCount),
            blockNumberHex || blockTag,
            rewardPercentiles
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    return (0, $deda3533cd301b66$export$6c26435bc7761d23)(feeHistory);
}




async function $185730381f0589bd$export$e69fa84ce52a94fd(_client, { filter: filter }) {
    const strict = "strict" in filter && filter.strict;
    const logs = await filter.request({
        method: "eth_getFilterChanges",
        params: [
            filter.id
        ]
    });
    if (typeof logs[0] === "string") return logs;
    const formattedLogs = logs.map((log)=>(0, $709e48cfde3e2ced$export$fccdbdc2b9d7893)(log));
    if (!("abi" in filter) || !filter.abi) return formattedLogs;
    return (0, $57796cf7a43e3978$export$7d811a19971cdf46)({
        abi: filter.abi,
        logs: formattedLogs,
        strict: strict
    });
}




async function $4316771872071f67$export$776d3b8c33a8b58(_client, { filter: filter }) {
    const strict = filter.strict ?? false;
    const logs = await filter.request({
        method: "eth_getFilterLogs",
        params: [
            filter.id
        ]
    });
    const formattedLogs = logs.map((log)=>(0, $709e48cfde3e2ced$export$fccdbdc2b9d7893)(log));
    if (!filter.abi) return formattedLogs;
    return (0, $57796cf7a43e3978$export$7d811a19971cdf46)({
        abi: filter.abi,
        logs: formattedLogs,
        strict: strict
    });
}





var $jW8ut = parcelRequire("jW8ut");

var $9GGVO = parcelRequire("9GGVO");
function $9ecca16e6cc55e22$var$formatStorageProof(storageProof) {
    return storageProof.map((proof)=>({
            ...proof,
            value: BigInt(proof.value)
        }));
}
function $9ecca16e6cc55e22$export$f37c234f0c7125e3(proof) {
    return {
        ...proof,
        balance: proof.balance ? BigInt(proof.balance) : undefined,
        nonce: proof.nonce ? (0, $9GGVO.hexToNumber)(proof.nonce) : undefined,
        storageProof: proof.storageProof ? $9ecca16e6cc55e22$var$formatStorageProof(proof.storageProof) : undefined
    };
}


async function $f979dfa0c98310ec$export$4a314c097411dc17(client, { address: address, blockNumber: blockNumber, blockTag: blockTag_, storageKeys: storageKeys }) {
    const blockTag = blockTag_ ?? "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
    const proof = await client.request({
        method: "eth_getProof",
        params: [
            address,
            storageKeys,
            blockNumberHex || blockTag
        ]
    });
    return (0, $9ecca16e6cc55e22$export$f37c234f0c7125e3)(proof);
}



var $jW8ut = parcelRequire("jW8ut");
async function $3004341ed7c3cf5e$export$14e244c1a3c8527e(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest", slot: slot }) {
    const blockNumberHex = blockNumber !== undefined ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
    const data = await client.request({
        method: "eth_getStorageAt",
        params: [
            address,
            slot,
            blockNumberHex || blockTag
        ]
    });
    return data;
}



var $3a3vr = parcelRequire("3a3vr");

var $jW8ut = parcelRequire("jW8ut");

async function $03ec92a3d94d9cd0$export$ec0c6556a09b65b8(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, hash: hash, index: index }) {
    const blockTag = blockTag_ || "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
    let transaction = null;
    if (hash) transaction = await client.request({
        method: "eth_getTransactionByHash",
        params: [
            hash
        ]
    }, {
        dedupe: true
    });
    else if (blockHash) transaction = await client.request({
        method: "eth_getTransactionByBlockHashAndIndex",
        params: [
            blockHash,
            (0, $jW8ut.numberToHex)(index)
        ]
    }, {
        dedupe: true
    });
    else if (blockNumberHex || blockTag) transaction = await client.request({
        method: "eth_getTransactionByBlockNumberAndIndex",
        params: [
            blockNumberHex || blockTag,
            (0, $jW8ut.numberToHex)(index)
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (!transaction) throw new (0, $3a3vr.TransactionNotFoundError)({
        blockHash: blockHash,
        blockNumber: blockNumber,
        blockTag: blockTag,
        hash: hash,
        index: index
    });
    const format = client.chain?.formatters?.transaction?.format || (0, $23c54fd803cb615d$export$b02b16590d26dadc);
    return format(transaction);
}





async function $84bac16b72278397$export$e2ccc904d713b66d(client, { hash: hash, transactionReceipt: transactionReceipt }) {
    const [blockNumber, transaction] = await Promise.all([
        (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $bbd7d10bf828cb3d$export$9328b5c92c53a20e), "getBlockNumber")({}),
        hash ? (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $03ec92a3d94d9cd0$export$ec0c6556a09b65b8), "getTransaction")({
            hash: hash
        }) : undefined
    ]);
    const transactionBlockNumber = transactionReceipt?.blockNumber || transaction?.blockNumber;
    if (!transactionBlockNumber) return 0n;
    return blockNumber - transactionBlockNumber + 1n;
}




var $3a3vr = parcelRequire("3a3vr");

var $9GGVO = parcelRequire("9GGVO");

var $awA7s = parcelRequire("awA7s");


const $9edc82c091c90e5e$export$3f17d120ae0df04 = {
    "0x0": "reverted",
    "0x1": "success"
};
function $9edc82c091c90e5e$export$30da670e49d6fc31(transactionReceipt) {
    const receipt = {
        ...transactionReceipt,
        blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
        contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
        effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
        gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
        logs: transactionReceipt.logs ? transactionReceipt.logs.map((log)=>(0, $709e48cfde3e2ced$export$fccdbdc2b9d7893)(log)) : null,
        to: transactionReceipt.to ? transactionReceipt.to : null,
        transactionIndex: transactionReceipt.transactionIndex ? (0, $9GGVO.hexToNumber)(transactionReceipt.transactionIndex) : null,
        status: transactionReceipt.status ? $9edc82c091c90e5e$export$3f17d120ae0df04[transactionReceipt.status] : null,
        type: transactionReceipt.type ? (0, $23c54fd803cb615d$export$cd5f936b62a5e91)[transactionReceipt.type] || transactionReceipt.type : null
    };
    if (transactionReceipt.blobGasPrice) receipt.blobGasPrice = BigInt(transactionReceipt.blobGasPrice);
    if (transactionReceipt.blobGasUsed) receipt.blobGasUsed = BigInt(transactionReceipt.blobGasUsed);
    return receipt;
}
const $9edc82c091c90e5e$export$8d3f90420000ba71 = /*#__PURE__*/ (0, $awA7s.defineFormatter)("transactionReceipt", $9edc82c091c90e5e$export$30da670e49d6fc31);


async function $965232bcb7f6bc91$export$6b1ceb3cd5f8b21f(client, { hash: hash }) {
    const receipt = await client.request({
        method: "eth_getTransactionReceipt",
        params: [
            hash
        ]
    }, {
        dedupe: true
    });
    if (!receipt) throw new (0, $3a3vr.TransactionReceiptNotFoundError)({
        hash: hash
    });
    const format = client.chain?.formatters?.transactionReceipt?.format || (0, $9edc82c091c90e5e$export$30da670e49d6fc31);
    return format(receipt);
}




/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $c1fd5fae4e22c572$var$_0n = /* @__PURE__ */ BigInt(0);
const $c1fd5fae4e22c572$var$_1n = /* @__PURE__ */ BigInt(1);
const $c1fd5fae4e22c572$var$_2n = /* @__PURE__ */ BigInt(2);
function $c1fd5fae4e22c572$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $c1fd5fae4e22c572$export$e8a750b9efad93f5(item) {
    if (!$c1fd5fae4e22c572$export$c6fabfbfd097fc30(item)) throw new Error("Uint8Array expected");
}
function $c1fd5fae4e22c572$export$809304d28d77d92d(title, value) {
    if (typeof value !== "boolean") throw new Error(title + " boolean expected, got " + value);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $c1fd5fae4e22c572$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $c1fd5fae4e22c572$export$58b867e287a802c8(bytes) {
    $c1fd5fae4e22c572$export$e8a750b9efad93f5(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $c1fd5fae4e22c572$var$hexes[bytes[i]];
    return hex;
}
function $c1fd5fae4e22c572$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? "0" + hex : hex;
}
function $c1fd5fae4e22c572$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    return hex === "" ? $c1fd5fae4e22c572$var$_0n : BigInt("0x" + hex); // Big Endian
}
// We use optimized technique to convert hex string to byte array
const $c1fd5fae4e22c572$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $c1fd5fae4e22c572$var$asciiToBase16(ch) {
    if (ch >= $c1fd5fae4e22c572$var$asciis._0 && ch <= $c1fd5fae4e22c572$var$asciis._9) return ch - $c1fd5fae4e22c572$var$asciis._0; // '2' => 50-48
    if (ch >= $c1fd5fae4e22c572$var$asciis.A && ch <= $c1fd5fae4e22c572$var$asciis.F) return ch - ($c1fd5fae4e22c572$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $c1fd5fae4e22c572$var$asciis.a && ch <= $c1fd5fae4e22c572$var$asciis.f) return ch - ($c1fd5fae4e22c572$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $c1fd5fae4e22c572$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $c1fd5fae4e22c572$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $c1fd5fae4e22c572$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
function $c1fd5fae4e22c572$export$d609354794974f8(bytes) {
    return $c1fd5fae4e22c572$export$d57f2bacc26b4249($c1fd5fae4e22c572$export$58b867e287a802c8(bytes));
}
function $c1fd5fae4e22c572$export$d67b1d03392107e7(bytes) {
    $c1fd5fae4e22c572$export$e8a750b9efad93f5(bytes);
    return $c1fd5fae4e22c572$export$d57f2bacc26b4249($c1fd5fae4e22c572$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $c1fd5fae4e22c572$export$1459dafd057611cb(n, len) {
    return $c1fd5fae4e22c572$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $c1fd5fae4e22c572$export$ba2172e58d139f6d(n, len) {
    return $c1fd5fae4e22c572$export$1459dafd057611cb(n, len).reverse();
}
function $c1fd5fae4e22c572$export$80ee8c1914de6dde(n) {
    return $c1fd5fae4e22c572$export$31c96b9df38bc8d4($c1fd5fae4e22c572$export$4ed2545b622827c1(n));
}
function $c1fd5fae4e22c572$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $c1fd5fae4e22c572$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(title + " must be hex string or Uint8Array, cause: " + e);
    }
    else if ($c1fd5fae4e22c572$export$c6fabfbfd097fc30(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + " must be hex string or Uint8Array");
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(title + " of length " + expectedLength + " expected, got " + len);
    return res;
}
function $c1fd5fae4e22c572$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $c1fd5fae4e22c572$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $c1fd5fae4e22c572$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $c1fd5fae4e22c572$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("string expected");
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const $c1fd5fae4e22c572$var$isPosBig = (n)=>typeof n === "bigint" && $c1fd5fae4e22c572$var$_0n <= n;
function $c1fd5fae4e22c572$export$ddf89a9c5af38f94(n, min, max) {
    return $c1fd5fae4e22c572$var$isPosBig(n) && $c1fd5fae4e22c572$var$isPosBig(min) && $c1fd5fae4e22c572$var$isPosBig(max) && min <= n && n < max;
}
function $c1fd5fae4e22c572$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$c1fd5fae4e22c572$export$ddf89a9c5af38f94(n, min, max)) throw new Error("expected valid " + title + ": " + min + " <= n < " + max + ", got " + n);
}
function $c1fd5fae4e22c572$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $c1fd5fae4e22c572$var$_0n; n >>= $c1fd5fae4e22c572$var$_1n, len += 1);
    return len;
}
function $c1fd5fae4e22c572$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $c1fd5fae4e22c572$var$_1n;
}
function $c1fd5fae4e22c572$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $c1fd5fae4e22c572$var$_1n : $c1fd5fae4e22c572$var$_0n) << BigInt(pos);
}
const $c1fd5fae4e22c572$export$803efa2fa1c7279 = (n)=>($c1fd5fae4e22c572$var$_2n << BigInt(n - 1)) - $c1fd5fae4e22c572$var$_1n;
// DRBG
const $c1fd5fae4e22c572$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $c1fd5fae4e22c572$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $c1fd5fae4e22c572$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $c1fd5fae4e22c572$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $c1fd5fae4e22c572$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $c1fd5fae4e22c572$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($c1fd5fae4e22c572$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($c1fd5fae4e22c572$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $c1fd5fae4e22c572$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $c1fd5fae4e22c572$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $c1fd5fae4e22c572$export$c6fabfbfd097fc30(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $c1fd5fae4e22c572$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $c1fd5fae4e22c572$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error("invalid validator function");
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error("param " + String(fieldName) + " is invalid. Expected " + type + ", got " + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
const $c1fd5fae4e22c572$export$94a5f06e658f87e2 = ()=>{
    throw new Error("not implemented");
};
function $c1fd5fae4e22c572$export$9756366f7cb6f62b(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}



/** @internal */ const $ea1da62cf0bd51fa$export$83d89fbfd8236492 = "0.1.1";


function $4676e083bb8687f5$export$94df0e59ebebf4a7(url) {
    return url;
}
function $4676e083bb8687f5$export$c506eb22e615ba4a() {
    return 0, $ea1da62cf0bd51fa$export$83d89fbfd8236492;
}
function $4676e083bb8687f5$export$cde3d1388a9feac3(args) {
    if (!args) return "";
    const entries = Object.entries(args).map(([key, value])=>{
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    const maxLength = entries.reduce((acc, [key])=>Math.max(acc, key.length), 0);
    return entries.map(([key, value])=>`  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}


class $c35f34add7b31ecb$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, options = {}){
        const details = (()=>{
            if (options.cause instanceof $c35f34add7b31ecb$export$a490eb03cb7a0a5e) {
                if (options.cause.details) return options.cause.details;
                if (options.cause.shortMessage) return options.cause.shortMessage;
            }
            if (options.cause?.message) return options.cause.message;
            return options.details;
        })();
        const docsPath = (()=>{
            if (options.cause instanceof $c35f34add7b31ecb$export$a490eb03cb7a0a5e) return options.cause.docsPath || options.docsPath;
            return options.docsPath;
        })();
        const docsBaseUrl = "https://oxlib.sh";
        const docs = `${docsBaseUrl}${docsPath ?? ""}`;
        const message = [
            shortMessage || "An error occurred.",
            ...options.metaMessages ? [
                "",
                ...options.metaMessages
            ] : [],
            ...details || docsPath ? [
                "",
                details ? `Details: ${details}` : undefined,
                docsPath ? `See: ${docs}` : undefined
            ] : []
        ].filter((x)=>typeof x === "string").join("\n");
        super(message, options.cause ? {
            cause: options.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseError"
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: `ox@${(0, $4676e083bb8687f5$export$c506eb22e615ba4a)()}`
        });
        this.cause = options.cause;
        this.details = details;
        this.docs = docs;
        this.docsPath = docsPath;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $c35f34add7b31ecb$var$walk(this, fn);
    }
}
/** @internal */ function $c35f34add7b31ecb$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err && err.cause) return $c35f34add7b31ecb$var$walk(err.cause, fn);
    return fn ? null : err;
}



const $f3f6abd1159db811$var$bigIntSuffix = "#__bigint";
function $f3f6abd1159db811$export$98e6a39c04603d36(string, reviver) {
    return JSON.parse(string, (key, value_)=>{
        const value = value_;
        if (typeof value === "string" && value.endsWith($f3f6abd1159db811$var$bigIntSuffix)) return BigInt(value.slice(0, -$f3f6abd1159db811$var$bigIntSuffix.length));
        return typeof reviver === "function" ? reviver(key, value) : value;
    });
}
function $f3f6abd1159db811$export$fac44ee5b035f737(value, replacer, space) {
    return JSON.stringify(value, (key, value)=>{
        if (typeof replacer === "function") return replacer(key, value);
        if (typeof value === "bigint") return value.toString() + $f3f6abd1159db811$var$bigIntSuffix;
        return value;
    }, space);
}



function $7f57e098216b65e2$export$2af489edb7fa35fe(bytes, size_) {
    if ($e7decbb70673776d$export$346677f925de839c(bytes) > size_) throw new $e7decbb70673776d$export$beb44ed4f8747d0e({
        givenSize: $e7decbb70673776d$export$346677f925de839c(bytes),
        maxSize: size_
    });
}
function $7f57e098216b65e2$export$98489c993c29af1d(value, start) {
    if (typeof start === "number" && start > 0 && start > $e7decbb70673776d$export$346677f925de839c(value) - 1) throw new $e7decbb70673776d$export$cfcd41bba8b36dbd({
        offset: start,
        position: "start",
        size: $e7decbb70673776d$export$346677f925de839c(value)
    });
}
function $7f57e098216b65e2$export$37e4b9f33692ba2b(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && $e7decbb70673776d$export$346677f925de839c(value) !== end - start) throw new $e7decbb70673776d$export$cfcd41bba8b36dbd({
        offset: end,
        position: "end",
        size: $e7decbb70673776d$export$346677f925de839c(value)
    });
}
const $7f57e098216b65e2$export$1abeefa007f24ab4 = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $7f57e098216b65e2$export$d2f423b5f9925871(char) {
    if (char >= $7f57e098216b65e2$export$1abeefa007f24ab4.zero && char <= $7f57e098216b65e2$export$1abeefa007f24ab4.nine) return char - $7f57e098216b65e2$export$1abeefa007f24ab4.zero;
    if (char >= $7f57e098216b65e2$export$1abeefa007f24ab4.A && char <= $7f57e098216b65e2$export$1abeefa007f24ab4.F) return char - ($7f57e098216b65e2$export$1abeefa007f24ab4.A - 10);
    if (char >= $7f57e098216b65e2$export$1abeefa007f24ab4.a && char <= $7f57e098216b65e2$export$1abeefa007f24ab4.f) return char - ($7f57e098216b65e2$export$1abeefa007f24ab4.a - 10);
    return undefined;
}
function $7f57e098216b65e2$export$5d04458e2a6c373e(bytes, options = {}) {
    const { dir: dir, size: size = 32 } = options;
    if (size === 0) return bytes;
    if (bytes.length > size) throw new $e7decbb70673776d$export$70445dc308a7f3d5({
        size: bytes.length,
        targetSize: size,
        type: "Bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}
function $7f57e098216b65e2$export$87c2784dc9fc4ab(value, options = {}) {
    const { dir: dir = "left" } = options;
    let data = value;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    return data;
}



function $77600f88e03315ad$export$2af489edb7fa35fe(hex, size_) {
    if ($cd0f3b7c2a282c5d$export$346677f925de839c(hex) > size_) throw new $cd0f3b7c2a282c5d$export$beb44ed4f8747d0e({
        givenSize: $cd0f3b7c2a282c5d$export$346677f925de839c(hex),
        maxSize: size_
    });
}
function $77600f88e03315ad$export$98489c993c29af1d(value, start) {
    if (typeof start === "number" && start > 0 && start > $cd0f3b7c2a282c5d$export$346677f925de839c(value) - 1) throw new $cd0f3b7c2a282c5d$export$cfcd41bba8b36dbd({
        offset: start,
        position: "start",
        size: $cd0f3b7c2a282c5d$export$346677f925de839c(value)
    });
}
function $77600f88e03315ad$export$37e4b9f33692ba2b(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && $cd0f3b7c2a282c5d$export$346677f925de839c(value) !== end - start) throw new $cd0f3b7c2a282c5d$export$cfcd41bba8b36dbd({
        offset: end,
        position: "end",
        size: $cd0f3b7c2a282c5d$export$346677f925de839c(value)
    });
}
function $77600f88e03315ad$export$5d04458e2a6c373e(hex_, options = {}) {
    const { dir: dir, size: size = 32 } = options;
    if (size === 0) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new $cd0f3b7c2a282c5d$export$70445dc308a7f3d5({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "Hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $77600f88e03315ad$export$87c2784dc9fc4ab(value, options = {}) {
    const { dir: dir = "left" } = options;
    let data = value.replace("0x", "");
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (data === "0") return "0x";
    if (dir === "right" && data.length % 2 === 1) return `0x${data}0`;
    return `0x${data}`;
}


const $e7decbb70673776d$var$decoder = /*#__PURE__*/ new TextDecoder();
const $e7decbb70673776d$var$encoder = /*#__PURE__*/ new TextEncoder();
function $e7decbb70673776d$export$a7a9523472993e97(value) {
    if (value instanceof Uint8Array) return;
    if (!value) throw new $e7decbb70673776d$export$eda7c289dac6c5ce(value);
    if (typeof value !== "object") throw new $e7decbb70673776d$export$eda7c289dac6c5ce(value);
    if (!("BYTES_PER_ELEMENT" in value)) throw new $e7decbb70673776d$export$eda7c289dac6c5ce(value);
    if (value.BYTES_PER_ELEMENT !== 1 || value.constructor.name !== "Uint8Array") throw new $e7decbb70673776d$export$eda7c289dac6c5ce(value);
}
function $e7decbb70673776d$export$ee1b3e54f0441b22(...values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    for(let i = 0, index = 0; i < values.length; i++){
        const arr = values[i];
        result.set(arr, index);
        index += arr.length;
    }
    return result;
}
function $e7decbb70673776d$export$6788812c4e6611e6(value) {
    if (value instanceof Uint8Array) return value;
    if (typeof value === "string") return $e7decbb70673776d$export$1a8ceedbd5845648(value);
    return $e7decbb70673776d$export$571d59b505e6bb4e(value);
}
function $e7decbb70673776d$export$571d59b505e6bb4e(value) {
    return value instanceof Uint8Array ? value : new Uint8Array(value);
}
function $e7decbb70673776d$export$dbafa4424a806c15(value, options = {}) {
    const { size: size } = options;
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof size === "number") {
        $7f57e098216b65e2$export$2af489edb7fa35fe(bytes, size);
        return $e7decbb70673776d$export$bc3bea8325045070(bytes, size);
    }
    return bytes;
}
function $e7decbb70673776d$export$1a8ceedbd5845648(value, options = {}) {
    const { size: size } = options;
    let hex = value;
    if (size) {
        $77600f88e03315ad$export$2af489edb7fa35fe(value, size);
        hex = $cd0f3b7c2a282c5d$export$7e24a29324041c48(value, size);
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $7f57e098216b65e2$export$d2f423b5f9925871(hexString.charCodeAt(j++));
        const nibbleRight = $7f57e098216b65e2$export$d2f423b5f9925871(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new $c35f34add7b31ecb$export$a490eb03cb7a0a5e(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $e7decbb70673776d$export$7bbb4164c9a77bc2(value, options) {
    const hex = $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(value, options);
    return $e7decbb70673776d$export$1a8ceedbd5845648(hex);
}
function $e7decbb70673776d$export$3004f64547af360e(value, options = {}) {
    const { size: size } = options;
    const bytes = $e7decbb70673776d$var$encoder.encode(value);
    if (typeof size === "number") {
        $7f57e098216b65e2$export$2af489edb7fa35fe(bytes, size);
        return $e7decbb70673776d$export$7e24a29324041c48(bytes, size);
    }
    return bytes;
}
function $e7decbb70673776d$export$248d38f6296296c5(bytesA, bytesB) {
    return (0, $c1fd5fae4e22c572$export$2aa59cef064b0333)(bytesA, bytesB);
}
function $e7decbb70673776d$export$bc3bea8325045070(value, size) {
    return $7f57e098216b65e2$export$5d04458e2a6c373e(value, {
        dir: "left",
        size: size
    });
}
function $e7decbb70673776d$export$7e24a29324041c48(value, size) {
    return $7f57e098216b65e2$export$5d04458e2a6c373e(value, {
        dir: "right",
        size: size
    });
}
function $e7decbb70673776d$export$4385e60b38654f68(length) {
    return crypto.getRandomValues(new Uint8Array(length));
}
function $e7decbb70673776d$export$346677f925de839c(value) {
    return value.length;
}
function $e7decbb70673776d$export$58adb3bec8346d0f(value, start, end, options = {}) {
    const { strict: strict } = options;
    $7f57e098216b65e2$export$98489c993c29af1d(value, start);
    const value_ = value.slice(start, end);
    if (strict) $7f57e098216b65e2$export$37e4b9f33692ba2b(value_, start, end);
    return value_;
}
function $e7decbb70673776d$export$c221a145703ab783(bytes, options = {}) {
    const { size: size } = options;
    if (typeof size !== "undefined") $7f57e098216b65e2$export$2af489edb7fa35fe(bytes, size);
    const hex = $cd0f3b7c2a282c5d$export$de2da3025c30316c(bytes, options);
    return $cd0f3b7c2a282c5d$export$c221a145703ab783(hex, options);
}
function $e7decbb70673776d$export$3c2e6d1b7583eee6(bytes, options = {}) {
    const { size: size } = options;
    let bytes_ = bytes;
    if (typeof size !== "undefined") {
        $7f57e098216b65e2$export$2af489edb7fa35fe(bytes_, size);
        bytes_ = $e7decbb70673776d$export$c5557f40488c48ec(bytes_);
    }
    if (bytes_.length > 1 || bytes_[0] > 1) throw new $e7decbb70673776d$export$52fc62e5266c8838(bytes_);
    return Boolean(bytes_[0]);
}
function $e7decbb70673776d$export$7ea66e3774a60b67(value, options = {}) {
    return $cd0f3b7c2a282c5d$export$de2da3025c30316c(value, options);
}
function $e7decbb70673776d$export$a0a81dc3380ce7d3(bytes, options = {}) {
    const { size: size } = options;
    if (typeof size !== "undefined") $7f57e098216b65e2$export$2af489edb7fa35fe(bytes, size);
    const hex = $cd0f3b7c2a282c5d$export$de2da3025c30316c(bytes, options);
    return $cd0f3b7c2a282c5d$export$a0a81dc3380ce7d3(hex, options);
}
function $e7decbb70673776d$export$f84e8e69fd4488a5(bytes, options = {}) {
    const { size: size } = options;
    let bytes_ = bytes;
    if (typeof size !== "undefined") {
        $7f57e098216b65e2$export$2af489edb7fa35fe(bytes_, size);
        bytes_ = $e7decbb70673776d$export$da8e5da96e287379(bytes_);
    }
    return $e7decbb70673776d$var$decoder.decode(bytes_);
}
function $e7decbb70673776d$export$c5557f40488c48ec(value) {
    return $7f57e098216b65e2$export$87c2784dc9fc4ab(value, {
        dir: "left"
    });
}
function $e7decbb70673776d$export$da8e5da96e287379(value) {
    return $7f57e098216b65e2$export$87c2784dc9fc4ab(value, {
        dir: "right"
    });
}
function $e7decbb70673776d$export$a22775fa5e2eebd9(value) {
    try {
        $e7decbb70673776d$export$a7a9523472993e97(value);
        return true;
    } catch  {
        return false;
    }
}
class $e7decbb70673776d$export$52fc62e5266c8838 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(bytes){
        super(`Bytes value \`${bytes}\` is not a valid boolean.`, {
            metaMessages: [
                "The bytes array must contain a single byte of either a `0` or `1` value."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Bytes.InvalidBytesBooleanError"
        });
    }
}
class $e7decbb70673776d$export$eda7c289dac6c5ce extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(value){
        super(`Value \`${typeof value === "object" ? $f3f6abd1159db811$export$fac44ee5b035f737(value) : value}\` of type \`${typeof value}\` is an invalid Bytes value.`, {
            metaMessages: [
                "Bytes values must be of type `Bytes`."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Bytes.InvalidBytesTypeError"
        });
    }
}
class $e7decbb70673776d$export$beb44ed4f8747d0e extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed \`${maxSize}\` bytes. Given size: \`${givenSize}\` bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Bytes.SizeOverflowError"
        });
    }
}
class $e7decbb70673776d$export$cfcd41bba8b36dbd extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset \`${offset}\` is out-of-bounds (size: \`${size}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Bytes.SliceOffsetOutOfBoundsError"
        });
    }
}
class $e7decbb70673776d$export$70445dc308a7f3d5 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (\`${size}\`) exceeds padding size (\`${targetSize}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Bytes.SizeExceedsPaddingSizeError"
        });
    }
}






const $cd0f3b7c2a282c5d$var$encoder = /*#__PURE__*/ new TextEncoder();
const $cd0f3b7c2a282c5d$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $cd0f3b7c2a282c5d$export$a7a9523472993e97(value, options = {}) {
    const { strict: strict = false } = options;
    if (!value) throw new $cd0f3b7c2a282c5d$export$28b84176f40096b3(value);
    if (typeof value !== "string") throw new $cd0f3b7c2a282c5d$export$28b84176f40096b3(value);
    if (strict) {
        if (!/^0x[0-9a-fA-F]*$/.test(value)) throw new $cd0f3b7c2a282c5d$export$ef05eafd11dd4a83(value);
    }
    if (!value.startsWith("0x")) throw new $cd0f3b7c2a282c5d$export$ef05eafd11dd4a83(value);
}
function $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22(...values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}
function $cd0f3b7c2a282c5d$export$6788812c4e6611e6(value) {
    if (value instanceof Uint8Array) return $cd0f3b7c2a282c5d$export$de2da3025c30316c(value);
    if (Array.isArray(value)) return $cd0f3b7c2a282c5d$export$de2da3025c30316c(new Uint8Array(value));
    return value;
}
function $cd0f3b7c2a282c5d$export$dbafa4424a806c15(value, options = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof options.size === "number") {
        $77600f88e03315ad$export$2af489edb7fa35fe(hex, options.size);
        return $cd0f3b7c2a282c5d$export$bc3bea8325045070(hex, options.size);
    }
    return hex;
}
function $cd0f3b7c2a282c5d$export$de2da3025c30316c(value, options = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $cd0f3b7c2a282c5d$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof options.size === "number") {
        $77600f88e03315ad$export$2af489edb7fa35fe(hex, options.size);
        return $cd0f3b7c2a282c5d$export$7e24a29324041c48(hex, options.size);
    }
    return hex;
}
function $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(value, options = {}) {
    const { signed: signed, size: size } = options;
    const value_ = BigInt(value);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value_ > maxValue || value_ < minValue) {
        const suffix = typeof value === "bigint" ? "n" : "";
        throw new $cd0f3b7c2a282c5d$export$47d164a8071229a9({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value}${suffix}`
        });
    }
    const stringValue = (signed && value_ < 0 ? (1n << BigInt(size * 8)) + BigInt(value_) : value_).toString(16);
    const hex = `0x${stringValue}`;
    if (size) return $cd0f3b7c2a282c5d$export$bc3bea8325045070(hex, size);
    return hex;
}
function $cd0f3b7c2a282c5d$export$3004f64547af360e(value, options = {}) {
    return $cd0f3b7c2a282c5d$export$de2da3025c30316c($cd0f3b7c2a282c5d$var$encoder.encode(value), options);
}
function $cd0f3b7c2a282c5d$export$248d38f6296296c5(hexA, hexB) {
    return (0, $c1fd5fae4e22c572$export$2aa59cef064b0333)($e7decbb70673776d$export$1a8ceedbd5845648(hexA), $e7decbb70673776d$export$1a8ceedbd5845648(hexB));
}
function $cd0f3b7c2a282c5d$export$bc3bea8325045070(value, size) {
    return $77600f88e03315ad$export$5d04458e2a6c373e(value, {
        dir: "left",
        size: size
    });
}
function $cd0f3b7c2a282c5d$export$7e24a29324041c48(value, size) {
    return $77600f88e03315ad$export$5d04458e2a6c373e(value, {
        dir: "right",
        size: size
    });
}
function $cd0f3b7c2a282c5d$export$4385e60b38654f68(length) {
    return $cd0f3b7c2a282c5d$export$de2da3025c30316c($e7decbb70673776d$export$4385e60b38654f68(length));
}
function $cd0f3b7c2a282c5d$export$58adb3bec8346d0f(value, start, end, options = {}) {
    const { strict: strict } = options;
    $77600f88e03315ad$export$98489c993c29af1d(value, start);
    const value_ = `0x${value.replace("0x", "").slice((start ?? 0) * 2, (end ?? value.length) * 2)}`;
    if (strict) $77600f88e03315ad$export$37e4b9f33692ba2b(value_, start, end);
    return value_;
}
function $cd0f3b7c2a282c5d$export$346677f925de839c(value) {
    return Math.ceil((value.length - 2) / 2);
}
function $cd0f3b7c2a282c5d$export$c5557f40488c48ec(value) {
    return $77600f88e03315ad$export$87c2784dc9fc4ab(value, {
        dir: "left"
    });
}
function $cd0f3b7c2a282c5d$export$da8e5da96e287379(value) {
    return $77600f88e03315ad$export$87c2784dc9fc4ab(value, {
        dir: "right"
    });
}
function $cd0f3b7c2a282c5d$export$c221a145703ab783(hex, options = {}) {
    const { signed: signed } = options;
    if (options.size) $77600f88e03315ad$export$2af489edb7fa35fe(hex, options.size);
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max_unsigned = (1n << BigInt(size) * 8n) - 1n;
    const max_signed = max_unsigned >> 1n;
    if (value <= max_signed) return value;
    return value - max_unsigned - 1n;
}
function $cd0f3b7c2a282c5d$export$3c2e6d1b7583eee6(hex, options = {}) {
    if (options.size) $77600f88e03315ad$export$2af489edb7fa35fe(hex, options.size);
    const hex_ = $cd0f3b7c2a282c5d$export$c5557f40488c48ec(hex);
    if (hex_ === "0x") return false;
    if (hex_ === "0x1") return true;
    throw new $cd0f3b7c2a282c5d$export$f574ac54e35514c(hex);
}
function $cd0f3b7c2a282c5d$export$30a71edf0753ed6b(hex, options = {}) {
    return $e7decbb70673776d$export$1a8ceedbd5845648(hex, options);
}
function $cd0f3b7c2a282c5d$export$a0a81dc3380ce7d3(hex, options = {}) {
    const { signed: signed, size: size } = options;
    if (!signed && !size) return Number(hex);
    return Number($cd0f3b7c2a282c5d$export$c221a145703ab783(hex, options));
}
function $cd0f3b7c2a282c5d$export$f84e8e69fd4488a5(hex, options = {}) {
    const { size: size } = options;
    let bytes = $e7decbb70673776d$export$1a8ceedbd5845648(hex);
    if (size) {
        $7f57e098216b65e2$export$2af489edb7fa35fe(bytes, size);
        bytes = $e7decbb70673776d$export$da8e5da96e287379(bytes);
    }
    return new TextDecoder().decode(bytes);
}
function $cd0f3b7c2a282c5d$export$a22775fa5e2eebd9(value, options = {}) {
    const { strict: strict = false } = options;
    try {
        $cd0f3b7c2a282c5d$export$a7a9523472993e97(value, {
            strict: strict
        });
        return true;
    } catch  {
        return false;
    }
}
class $cd0f3b7c2a282c5d$export$47d164a8071229a9 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number \`${value}\` is not in safe${size ? ` ${size * 8}-bit` : ""}${signed ? " signed" : " unsigned"} integer range ${max ? `(\`${min}\` to \`${max}\`)` : `(above \`${min}\`)`}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.IntegerOutOfRangeError"
        });
    }
}
class $cd0f3b7c2a282c5d$export$f574ac54e35514c extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(hex){
        super(`Hex value \`"${hex}"\` is not a valid boolean.`, {
            metaMessages: [
                'The hex value must be `"0x0"` (false) or `"0x1"` (true).'
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.InvalidHexBooleanError"
        });
    }
}
class $cd0f3b7c2a282c5d$export$28b84176f40096b3 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(value){
        super(`Value \`${typeof value === "object" ? $f3f6abd1159db811$export$fac44ee5b035f737(value) : value}\` of type \`${typeof value}\` is an invalid hex type.`, {
            metaMessages: [
                'Hex types must be represented as `"0x${string}"`.'
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.InvalidHexTypeError"
        });
    }
}
class $cd0f3b7c2a282c5d$export$ef05eafd11dd4a83 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(value){
        super(`Value \`${value}\` is an invalid hex value.`, {
            metaMessages: [
                'Hex values must start with `"0x"` and contain only hexadecimal characters (0-9, a-f, A-F).'
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.InvalidHexValueError"
        });
    }
}
class $cd0f3b7c2a282c5d$export$a8e02cec4b9cc2a0 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(value){
        super(`Hex value \`"${value}"\` is an odd length (${value.length - 2} nibbles).`, {
            metaMessages: [
                "It must be an even length."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.InvalidLengthError"
        });
    }
}
class $cd0f3b7c2a282c5d$export$beb44ed4f8747d0e extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed \`${maxSize}\` bytes. Given size: \`${givenSize}\` bytes.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.SizeOverflowError"
        });
    }
}
class $cd0f3b7c2a282c5d$export$cfcd41bba8b36dbd extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset \`${offset}\` is out-of-bounds (size: \`${size}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.SliceOffsetOutOfBoundsError"
        });
    }
}
class $cd0f3b7c2a282c5d$export$70445dc308a7f3d5 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (\`${size}\`) exceeds padding size (\`${targetSize}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Hex.SizeExceedsPaddingSizeError"
        });
    }
}



function $8e27d598201a2829$export$6720e65aed65316f(withdrawal) {
    return {
        ...withdrawal,
        amount: BigInt(withdrawal.amount),
        index: Number(withdrawal.index),
        validatorIndex: Number(withdrawal.validatorIndex)
    };
}
function $8e27d598201a2829$export$28304b15c69ed8d2(withdrawal) {
    return {
        address: withdrawal.address,
        amount: $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(withdrawal.amount),
        index: $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(withdrawal.index),
        validatorIndex: $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(withdrawal.validatorIndex)
    };
}


function $af183df2127ee288$export$6720e65aed65316f(rpcBlockOverrides) {
    return {
        ...rpcBlockOverrides.baseFeePerGas && {
            baseFeePerGas: BigInt(rpcBlockOverrides.baseFeePerGas)
        },
        ...rpcBlockOverrides.blobBaseFee && {
            blobBaseFee: BigInt(rpcBlockOverrides.blobBaseFee)
        },
        ...rpcBlockOverrides.feeRecipient && {
            feeRecipient: rpcBlockOverrides.feeRecipient
        },
        ...rpcBlockOverrides.gasLimit && {
            gasLimit: BigInt(rpcBlockOverrides.gasLimit)
        },
        ...rpcBlockOverrides.number && {
            number: BigInt(rpcBlockOverrides.number)
        },
        ...rpcBlockOverrides.prevRandao && {
            prevRandao: BigInt(rpcBlockOverrides.prevRandao)
        },
        ...rpcBlockOverrides.time && {
            time: BigInt(rpcBlockOverrides.time)
        },
        ...rpcBlockOverrides.withdrawals && {
            withdrawals: rpcBlockOverrides.withdrawals.map($8e27d598201a2829$export$6720e65aed65316f)
        }
    };
}
function $af183df2127ee288$export$28304b15c69ed8d2(blockOverrides) {
    return {
        ...typeof blockOverrides.baseFeePerGas === "bigint" && {
            baseFeePerGas: $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(blockOverrides.baseFeePerGas)
        },
        ...typeof blockOverrides.blobBaseFee === "bigint" && {
            blobBaseFee: $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(blockOverrides.blobBaseFee)
        },
        ...typeof blockOverrides.feeRecipient === "string" && {
            feeRecipient: blockOverrides.feeRecipient
        },
        ...typeof blockOverrides.gasLimit === "bigint" && {
            gasLimit: $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(blockOverrides.gasLimit)
        },
        ...typeof blockOverrides.number === "bigint" && {
            number: $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(blockOverrides.number)
        },
        ...typeof blockOverrides.prevRandao === "bigint" && {
            prevRandao: $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(blockOverrides.prevRandao)
        },
        ...typeof blockOverrides.time === "bigint" && {
            time: $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(blockOverrides.time)
        },
        ...blockOverrides.withdrawals && {
            withdrawals: blockOverrides.withdrawals.map($8e27d598201a2829$export$28304b15c69ed8d2)
        }
    };
}



var $gbEG8 = parcelRequire("gbEG8");

var $8p1we = parcelRequire("8p1we");

var $hfefF = parcelRequire("hfefF");

var $iWaDR = parcelRequire("iWaDR");

var $dzDwb = parcelRequire("dzDwb");

var $aYJZ1 = parcelRequire("aYJZ1");

var $jW8ut = parcelRequire("jW8ut");


var $iZm7e = parcelRequire("iZm7e");



var $ksIKp = parcelRequire("ksIKp");

var $l7x0m = parcelRequire("l7x0m");

var $1OSs0 = parcelRequire("1OSs0");
async function $894419aadf34fa74$export$d7b183d4eabb187b(client, parameters) {
    const { blockNumber: blockNumber, blockTag: blockTag = "latest", blocks: blocks, returnFullTransactions: returnFullTransactions, traceTransfers: traceTransfers, validation: validation } = parameters;
    try {
        const blockStateCalls = [];
        for (const block of blocks){
            const blockOverrides = block.blockOverrides ? $af183df2127ee288$export$28304b15c69ed8d2(block.blockOverrides) : undefined;
            const calls = block.calls.map((call_)=>{
                const call = call_;
                const account = call.account ? (0, $gbEG8.parseAccount)(call.account) : undefined;
                const request = {
                    ...call,
                    data: call.abi ? (0, $aYJZ1.encodeFunctionData)(call) : call.data,
                    from: call.from ?? account?.address
                };
                (0, $1OSs0.assertRequest)(request);
                return (0, $ksIKp.formatTransactionRequest)(request);
            });
            const stateOverrides = block.stateOverrides ? (0, $l7x0m.serializeStateOverride)(block.stateOverrides) : undefined;
            blockStateCalls.push({
                blockOverrides: blockOverrides,
                calls: calls,
                stateOverrides: stateOverrides
            });
        }
        const blockNumberHex = blockNumber ? (0, $jW8ut.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const result = await client.request({
            method: "eth_simulateV1",
            params: [
                {
                    blockStateCalls: blockStateCalls,
                    returnFullTransactions: returnFullTransactions,
                    traceTransfers: traceTransfers,
                    validation: validation
                },
                block
            ]
        });
        return result.map((block, i)=>({
                ...(0, $3791204a4fe10280$export$ba1152bc4017d62a)(block),
                calls: block.calls.map((call, j)=>{
                    const { abi: abi, args: args, functionName: functionName, to: to } = blocks[i].calls[j];
                    const data = call.error?.data ?? call.returnData;
                    const gasUsed = BigInt(call.gasUsed);
                    const logs = call.logs?.map((log)=>(0, $709e48cfde3e2ced$export$fccdbdc2b9d7893)(log));
                    const status = call.status === "0x1" ? "success" : "failure";
                    const result = abi && status === "success" ? (0, $dzDwb.decodeFunctionResult)({
                        abi: abi,
                        data: data,
                        functionName: functionName
                    }) : null;
                    const error = (()=>{
                        if (status === "success") return undefined;
                        let error = undefined;
                        if (call.error?.data === "0x") error = new (0, $8p1we.AbiDecodingZeroDataError)();
                        else if (call.error) error = new (0, $hfefF.RawContractError)(call.error);
                        if (!error) return undefined;
                        return (0, $768c9bcff606843b$export$4414444aba6ddd8a)(error, {
                            abi: abi ?? [],
                            address: to,
                            args: args,
                            functionName: functionName ?? "<unknown>"
                        });
                    })();
                    return {
                        data: data,
                        gasUsed: gasUsed,
                        logs: logs,
                        status: status,
                        ...status === "success" ? {
                            result: result
                        } : {
                            error: error
                        }
                    };
                })
            }));
    } catch (e) {
        const cause = e;
        const error = (0, $iZm7e.getNodeError)(cause, {});
        if (error instanceof (0, $iWaDR.UnknownNodeError)) throw cause;
        throw error;
    }
}



var $l2jn0 = parcelRequire("l2jn0");

var $l2jn0 = parcelRequire("l2jn0");
var $16aXz = parcelRequire("16aXz");

var $3PjHL = parcelRequire("3PjHL");

var $jzGfv = parcelRequire("jzGfv");

var $4hT4E = parcelRequire("4hT4E");
function $3aad363558a8968c$export$1e31c38713b34060(signature) {
    let abiItem;
    if (typeof signature === "string") abiItem = (0, $4hT4E.parseSignature)(signature);
    else {
        const structs = (0, $jzGfv.parseStructs)(signature);
        const length = signature.length;
        for(let i = 0; i < length; i++){
            const signature_ = signature[i];
            if ((0, $3PjHL.isStructSignature)(signature_)) continue;
            abiItem = (0, $4hT4E.parseSignature)(signature_, structs);
            break;
        }
    }
    if (!abiItem) throw new (0, $16aXz.InvalidAbiItemError)({
        signature: signature
    });
    return abiItem;
}



/**
 * RIPEMD-160 legacy hash function.
 * https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
 * https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
 * @module
 */ /**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ /**
 * Internal assertion helpers.
 * @module
 */ /** Asserts something is positive integer. */ function $968702e9cdb77c5b$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, got " + n);
}
/** Is number an Uint8Array? Copied from utils for perf. */ function $968702e9cdb77c5b$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
/** Asserts something is Uint8Array. */ function $968702e9cdb77c5b$export$e8a750b9efad93f5(b, ...lengths) {
    if (!$968702e9cdb77c5b$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length " + lengths + ", got length=" + b.length);
}
/** Asserts something is hash */ function $968702e9cdb77c5b$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $968702e9cdb77c5b$export$75364c6cb16d43b6(h.outputLen);
    $968702e9cdb77c5b$export$75364c6cb16d43b6(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $968702e9cdb77c5b$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
/** Asserts output is properly-sized byte array */ function $968702e9cdb77c5b$export$e8e53abee12b995e(out, instance) {
    $968702e9cdb77c5b$export$e8a750b9efad93f5(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least " + min);
}


/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const $d5514a945cd166e3$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;



function $a611686dec03d2ef$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $a611686dec03d2ef$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $a611686dec03d2ef$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $a611686dec03d2ef$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $a611686dec03d2ef$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $a611686dec03d2ef$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $a611686dec03d2ef$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $a611686dec03d2ef$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $a611686dec03d2ef$export$4a0a88cc2d284e7f = $a611686dec03d2ef$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$a611686dec03d2ef$export$a4170f7f8be47425(n);
function $a611686dec03d2ef$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $a611686dec03d2ef$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $a611686dec03d2ef$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $a611686dec03d2ef$export$58b867e287a802c8(bytes) {
    (0, $968702e9cdb77c5b$export$e8a750b9efad93f5)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a611686dec03d2ef$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $a611686dec03d2ef$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $a611686dec03d2ef$var$asciiToBase16(ch) {
    if (ch >= $a611686dec03d2ef$var$asciis._0 && ch <= $a611686dec03d2ef$var$asciis._9) return ch - $a611686dec03d2ef$var$asciis._0; // '2' => 50-48
    if (ch >= $a611686dec03d2ef$var$asciis.A && ch <= $a611686dec03d2ef$var$asciis.F) return ch - ($a611686dec03d2ef$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $a611686dec03d2ef$var$asciis.a && ch <= $a611686dec03d2ef$var$asciis.f) return ch - ($a611686dec03d2ef$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $a611686dec03d2ef$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $a611686dec03d2ef$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $a611686dec03d2ef$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $a611686dec03d2ef$export$bdd553fddd433dcb = async ()=>{};
async function $a611686dec03d2ef$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $a611686dec03d2ef$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $a611686dec03d2ef$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got " + typeof str);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $a611686dec03d2ef$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $a611686dec03d2ef$export$3df70a15530b5e81(data);
    (0, $968702e9cdb77c5b$export$e8a750b9efad93f5)(data);
    return data;
}
function $a611686dec03d2ef$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $968702e9cdb77c5b$export$e8a750b9efad93f5)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $a611686dec03d2ef$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
function $a611686dec03d2ef$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $a611686dec03d2ef$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($a611686dec03d2ef$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $a611686dec03d2ef$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a611686dec03d2ef$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $a611686dec03d2ef$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a611686dec03d2ef$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $a611686dec03d2ef$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $d5514a945cd166e3$export$7effb53edfc7fa2d) && typeof (0, $d5514a945cd166e3$export$7effb53edfc7fa2d).getRandomValues === "function") return (0, $d5514a945cd166e3$export$7effb53edfc7fa2d).getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ((0, $d5514a945cd166e3$export$7effb53edfc7fa2d) && typeof (0, $d5514a945cd166e3$export$7effb53edfc7fa2d).randomBytes === "function") return (0, $d5514a945cd166e3$export$7effb53edfc7fa2d).randomBytes(bytesLength);
    throw new Error("crypto.getRandomValues must be defined");
}


function $af42758fc44cb2c9$export$b13f930c762582ab(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $af42758fc44cb2c9$export$d0d97f016526eaf0(a, b, c) {
    return a & b ^ ~a & c;
}
function $af42758fc44cb2c9$export$8b1d810b1bd30adf(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $af42758fc44cb2c9$export$f9f830659f932cb2 extends (0, $a611686dec03d2ef$export$ab85ecd77ce6a5cd) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $a611686dec03d2ef$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $968702e9cdb77c5b$export$20871f6b1d047d77)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $a611686dec03d2ef$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $a611686dec03d2ef$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $968702e9cdb77c5b$export$20871f6b1d047d77)(this);
        (0, $968702e9cdb77c5b$export$e8e53abee12b995e)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $af42758fc44cb2c9$export$b13f930c762582ab(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $a611686dec03d2ef$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}



const $d319ea51ae9e93ae$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $d319ea51ae9e93ae$var$Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((_, i)=>i));
const $d319ea51ae9e93ae$var$Pi = /* @__PURE__ */ $d319ea51ae9e93ae$var$Id.map((i)=>(9 * i + 5) % 16);
let $d319ea51ae9e93ae$var$idxL = [
    $d319ea51ae9e93ae$var$Id
];
let $d319ea51ae9e93ae$var$idxR = [
    $d319ea51ae9e93ae$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $d319ea51ae9e93ae$var$idxL,
    $d319ea51ae9e93ae$var$idxR
])j.push(j[i].map((k)=>$d319ea51ae9e93ae$var$Rho[k]));
const $d319ea51ae9e93ae$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $d319ea51ae9e93ae$var$shiftsL = /* @__PURE__ */ $d319ea51ae9e93ae$var$idxL.map((idx, i)=>idx.map((j)=>$d319ea51ae9e93ae$var$shifts[i][j]));
const $d319ea51ae9e93ae$var$shiftsR = /* @__PURE__ */ $d319ea51ae9e93ae$var$idxR.map((idx, i)=>idx.map((j)=>$d319ea51ae9e93ae$var$shifts[i][j]));
const $d319ea51ae9e93ae$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $d319ea51ae9e93ae$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// It's called f() in spec.
function $d319ea51ae9e93ae$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $d319ea51ae9e93ae$var$R_BUF = /* @__PURE__ */ new Uint32Array(16);
class $d319ea51ae9e93ae$export$7b0ccd21718381c9 extends (0, $af42758fc44cb2c9$export$f9f830659f932cb2) {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$d319ea51ae9e93ae$var$R_BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $d319ea51ae9e93ae$var$Kl[group], hbr = $d319ea51ae9e93ae$var$Kr[group]; // prettier-ignore
            const rl = $d319ea51ae9e93ae$var$idxL[group], rr = $d319ea51ae9e93ae$var$idxR[group]; // prettier-ignore
            const sl = $d319ea51ae9e93ae$var$shiftsL[group], sr = $d319ea51ae9e93ae$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = (0, $a611686dec03d2ef$export$ac5e39599698b562)(al + $d319ea51ae9e93ae$var$f(group, bl, cl, dl) + $d319ea51ae9e93ae$var$R_BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = (0, $a611686dec03d2ef$export$ac5e39599698b562)(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = (0, $a611686dec03d2ef$export$ac5e39599698b562)(ar + $d319ea51ae9e93ae$var$f(rGroup, br, cr, dr) + $d319ea51ae9e93ae$var$R_BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = (0, $a611686dec03d2ef$export$ac5e39599698b562)(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $d319ea51ae9e93ae$var$R_BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
const $d319ea51ae9e93ae$export$d1cea0ee4e3f0d3e = /* @__PURE__ */ (0, $a611686dec03d2ef$export$f081816339df1972)(()=>new $d319ea51ae9e93ae$export$7b0ccd21718381c9());


/**
 * SHA3 (keccak) hash function, based on a new "Sponge function" design.
 * Different from older hashes, the internal state is bigger than output size.
 *
 * Check out [FIPS-202](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.202.pdf),
 * [Website](https://keccak.team/keccak.html),
 * [the differences between SHA-3 and Keccak](https://crypto.stackexchange.com/questions/15727/what-are-the-key-differences-between-the-draft-sha-3-standard-and-the-keccak-sub).
 *
 * Check out `sha3-addons` module for cSHAKE, k12, and others.
 * @module
 */ 
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $70c79d7f8e192d06$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $70c79d7f8e192d06$var$_32n = /* @__PURE__ */ BigInt(32);
function $70c79d7f8e192d06$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $70c79d7f8e192d06$var$U32_MASK64),
        l: Number(n >> $70c79d7f8e192d06$var$_32n & $70c79d7f8e192d06$var$U32_MASK64)
    };
    return {
        h: Number(n >> $70c79d7f8e192d06$var$_32n & $70c79d7f8e192d06$var$U32_MASK64) | 0,
        l: Number(n & $70c79d7f8e192d06$var$U32_MASK64) | 0
    };
}
function $70c79d7f8e192d06$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $70c79d7f8e192d06$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $70c79d7f8e192d06$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $70c79d7f8e192d06$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $70c79d7f8e192d06$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $70c79d7f8e192d06$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $70c79d7f8e192d06$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $70c79d7f8e192d06$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $70c79d7f8e192d06$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $70c79d7f8e192d06$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $70c79d7f8e192d06$export$a088d44bd387d2a3 = (_h, l)=>l;
const $70c79d7f8e192d06$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $70c79d7f8e192d06$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $70c79d7f8e192d06$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $70c79d7f8e192d06$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $70c79d7f8e192d06$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $70c79d7f8e192d06$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $70c79d7f8e192d06$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $70c79d7f8e192d06$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $70c79d7f8e192d06$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $70c79d7f8e192d06$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $70c79d7f8e192d06$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $70c79d7f8e192d06$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $70c79d7f8e192d06$var$u64 = {
    fromBig: $70c79d7f8e192d06$export$9625d4333cb56c3f,
    split: $70c79d7f8e192d06$export$65980d18b75784e2,
    toBig: $70c79d7f8e192d06$export$30f78adcaaa2eb7,
    shrSH: $70c79d7f8e192d06$export$75aa78dc5bd52853,
    shrSL: $70c79d7f8e192d06$export$a0225ff0aee14e25,
    rotrSH: $70c79d7f8e192d06$export$97f812dfd830ca87,
    rotrSL: $70c79d7f8e192d06$export$60987e30e2c9d9d,
    rotrBH: $70c79d7f8e192d06$export$af9c7fbac44dcb76,
    rotrBL: $70c79d7f8e192d06$export$f619171d6d5ac414,
    rotr32H: $70c79d7f8e192d06$export$a088d44bd387d2a3,
    rotr32L: $70c79d7f8e192d06$export$8415aae4d1f69577,
    rotlSH: $70c79d7f8e192d06$export$4b80a2917447870e,
    rotlSL: $70c79d7f8e192d06$export$20652918a7b63b3,
    rotlBH: $70c79d7f8e192d06$export$a52f14bf902f9977,
    rotlBL: $70c79d7f8e192d06$export$5d12cc1da441323f,
    add: $70c79d7f8e192d06$export$e16d8520af44a096,
    add3L: $70c79d7f8e192d06$export$c0c22b91f08911f,
    add3H: $70c79d7f8e192d06$export$ef7b26044977a8ec,
    add4L: $70c79d7f8e192d06$export$2f4e199c560f545d,
    add4H: $70c79d7f8e192d06$export$e909220d675a7741,
    add5H: $70c79d7f8e192d06$export$b45ee8d78c965098,
    add5L: $70c79d7f8e192d06$export$d732b061fe9c9ae4
};
var $70c79d7f8e192d06$export$2e2bcd8739ae039 = $70c79d7f8e192d06$var$u64;



// Various per round constants calculations
const $eb38ec23a8870f96$var$SHA3_PI = [];
const $eb38ec23a8870f96$var$SHA3_ROTL = [];
const $eb38ec23a8870f96$var$_SHA3_IOTA = [];
const $eb38ec23a8870f96$var$_0n = /* @__PURE__ */ BigInt(0);
const $eb38ec23a8870f96$var$_1n = /* @__PURE__ */ BigInt(1);
const $eb38ec23a8870f96$var$_2n = /* @__PURE__ */ BigInt(2);
const $eb38ec23a8870f96$var$_7n = /* @__PURE__ */ BigInt(7);
const $eb38ec23a8870f96$var$_256n = /* @__PURE__ */ BigInt(256);
const $eb38ec23a8870f96$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $eb38ec23a8870f96$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $eb38ec23a8870f96$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $eb38ec23a8870f96$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $eb38ec23a8870f96$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $eb38ec23a8870f96$var$_1n ^ (R >> $eb38ec23a8870f96$var$_7n) * $eb38ec23a8870f96$var$_0x71n) % $eb38ec23a8870f96$var$_256n;
        if (R & $eb38ec23a8870f96$var$_2n) t ^= $eb38ec23a8870f96$var$_1n << ($eb38ec23a8870f96$var$_1n << /* @__PURE__ */ BigInt(j)) - $eb38ec23a8870f96$var$_1n;
    }
    $eb38ec23a8870f96$var$_SHA3_IOTA.push(t);
}
const [$eb38ec23a8870f96$var$SHA3_IOTA_H, $eb38ec23a8870f96$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $70c79d7f8e192d06$export$65980d18b75784e2)($eb38ec23a8870f96$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $eb38ec23a8870f96$var$rotlH = (h, l, s)=>s > 32 ? (0, $70c79d7f8e192d06$export$a52f14bf902f9977)(h, l, s) : (0, $70c79d7f8e192d06$export$4b80a2917447870e)(h, l, s);
const $eb38ec23a8870f96$var$rotlL = (h, l, s)=>s > 32 ? (0, $70c79d7f8e192d06$export$5d12cc1da441323f)(h, l, s) : (0, $70c79d7f8e192d06$export$20652918a7b63b3)(h, l, s);
function $eb38ec23a8870f96$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $eb38ec23a8870f96$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $eb38ec23a8870f96$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $eb38ec23a8870f96$var$SHA3_ROTL[t];
            const Th = $eb38ec23a8870f96$var$rotlH(curH, curL, shift);
            const Tl = $eb38ec23a8870f96$var$rotlL(curH, curL, shift);
            const PI = $eb38ec23a8870f96$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $eb38ec23a8870f96$var$SHA3_IOTA_H[round];
        s[1] ^= $eb38ec23a8870f96$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $eb38ec23a8870f96$export$f7374b8b4498bc2e extends (0, $a611686dec03d2ef$export$ab85ecd77ce6a5cd) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $968702e9cdb77c5b$export$75364c6cb16d43b6)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        // 0 < blockLen < 200
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $a611686dec03d2ef$export$8bacf4ad828c7fe7)(this.state);
    }
    keccak() {
        if (!(0, $a611686dec03d2ef$export$a0f88e38d4cf9577)) (0, $a611686dec03d2ef$export$97b40fc37f25d711)(this.state32);
        $eb38ec23a8870f96$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $a611686dec03d2ef$export$a0f88e38d4cf9577)) (0, $a611686dec03d2ef$export$97b40fc37f25d711)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $968702e9cdb77c5b$export$20871f6b1d047d77)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $a611686dec03d2ef$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $968702e9cdb77c5b$export$20871f6b1d047d77)(this, false);
        (0, $968702e9cdb77c5b$export$e8a750b9efad93f5)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $968702e9cdb77c5b$export$75364c6cb16d43b6)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $968702e9cdb77c5b$export$e8e53abee12b995e)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $eb38ec23a8870f96$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $eb38ec23a8870f96$var$gen = (suffix, blockLen, outputLen)=>(0, $a611686dec03d2ef$export$f081816339df1972)(()=>new $eb38ec23a8870f96$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $eb38ec23a8870f96$export$fe6c2b96a79338e9 = /* @__PURE__ */ $eb38ec23a8870f96$var$gen(0x06, 144, 28);
const $eb38ec23a8870f96$export$76e19b6966813b14 = /* @__PURE__ */ $eb38ec23a8870f96$var$gen(0x06, 136, 32);
const $eb38ec23a8870f96$export$a58509fa80f30d15 = /* @__PURE__ */ $eb38ec23a8870f96$var$gen(0x06, 104, 48);
const $eb38ec23a8870f96$export$20ed324dbdf09b7c = /* @__PURE__ */ $eb38ec23a8870f96$var$gen(0x06, 72, 64);
const $eb38ec23a8870f96$export$2f7fb3c6fac246bc = /* @__PURE__ */ $eb38ec23a8870f96$var$gen(0x01, 144, 28);
const $eb38ec23a8870f96$export$860ddaa9ca84a66d = /* @__PURE__ */ $eb38ec23a8870f96$var$gen(0x01, 136, 32);
const $eb38ec23a8870f96$export$46fcdeb4c5686552 = /* @__PURE__ */ $eb38ec23a8870f96$var$gen(0x01, 104, 48);
const $eb38ec23a8870f96$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $eb38ec23a8870f96$var$gen(0x01, 72, 64);
const $eb38ec23a8870f96$var$genShake = (suffix, blockLen, outputLen)=>(0, $a611686dec03d2ef$export$e18964dbd6e083c1)((opts = {})=>new $eb38ec23a8870f96$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $eb38ec23a8870f96$export$f43dc3bb86efbba2 = /* @__PURE__ */ $eb38ec23a8870f96$var$genShake(0x1f, 168, 16);
const $eb38ec23a8870f96$export$c240d011f1520440 = /* @__PURE__ */ $eb38ec23a8870f96$var$genShake(0x1f, 136, 32);


/**
 * SHA2-256 a.k.a. sha256. In JS, it is the fastest hash, even faster than Blake3.
 *
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 *
 * Check out [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ 

/** Round constants: first 32 bits of fractional parts of the cube roots of the first 64 primes 2..311). */ // prettier-ignore
const $6189deb800195365$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Initial state: first 32 bits of fractional parts of the square roots of the first 8 primes 2..19. */ // prettier-ignore
const $6189deb800195365$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/**
 * Temporary buffer, not used to store anything between runs.
 * Named this way because it matches specification.
 */ const $6189deb800195365$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $6189deb800195365$export$397b834fceb5b168 extends (0, $af42758fc44cb2c9$export$f9f830659f932cb2) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $6189deb800195365$var$SHA256_IV[0] | 0;
        this.B = $6189deb800195365$var$SHA256_IV[1] | 0;
        this.C = $6189deb800195365$var$SHA256_IV[2] | 0;
        this.D = $6189deb800195365$var$SHA256_IV[3] | 0;
        this.E = $6189deb800195365$var$SHA256_IV[4] | 0;
        this.F = $6189deb800195365$var$SHA256_IV[5] | 0;
        this.G = $6189deb800195365$var$SHA256_IV[6] | 0;
        this.H = $6189deb800195365$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$6189deb800195365$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $6189deb800195365$var$SHA256_W[i - 15];
            const W2 = $6189deb800195365$var$SHA256_W[i - 2];
            const s0 = (0, $a611686dec03d2ef$export$466993d7d0d272aa)(W15, 7) ^ (0, $a611686dec03d2ef$export$466993d7d0d272aa)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $a611686dec03d2ef$export$466993d7d0d272aa)(W2, 17) ^ (0, $a611686dec03d2ef$export$466993d7d0d272aa)(W2, 19) ^ W2 >>> 10;
            $6189deb800195365$var$SHA256_W[i] = s1 + $6189deb800195365$var$SHA256_W[i - 7] + s0 + $6189deb800195365$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $a611686dec03d2ef$export$466993d7d0d272aa)(E, 6) ^ (0, $a611686dec03d2ef$export$466993d7d0d272aa)(E, 11) ^ (0, $a611686dec03d2ef$export$466993d7d0d272aa)(E, 25);
            const T1 = H + sigma1 + (0, $af42758fc44cb2c9$export$d0d97f016526eaf0)(E, F, G) + $6189deb800195365$var$SHA256_K[i] + $6189deb800195365$var$SHA256_W[i] | 0;
            const sigma0 = (0, $a611686dec03d2ef$export$466993d7d0d272aa)(A, 2) ^ (0, $a611686dec03d2ef$export$466993d7d0d272aa)(A, 13) ^ (0, $a611686dec03d2ef$export$466993d7d0d272aa)(A, 22);
            const T2 = sigma0 + (0, $af42758fc44cb2c9$export$8b1d810b1bd30adf)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $6189deb800195365$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
/**
 * Constants taken from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf.
 */ class $6189deb800195365$var$SHA224 extends $6189deb800195365$export$397b834fceb5b168 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $6189deb800195365$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $a611686dec03d2ef$export$f081816339df1972)(()=>new $6189deb800195365$export$397b834fceb5b168());
const $6189deb800195365$export$97b70509d4e397ea = /* @__PURE__ */ (0, $a611686dec03d2ef$export$f081816339df1972)(()=>new $6189deb800195365$var$SHA224());




function $953d6955755398f7$export$f8151fce47ad1c35(value, options = {}) {
    const { as: as = typeof value === "string" ? "Hex" : "Bytes" } = options;
    const bytes = (0, $eb38ec23a8870f96$export$860ddaa9ca84a66d)($e7decbb70673776d$export$6788812c4e6611e6(value));
    if (as === "Bytes") return bytes;
    return $cd0f3b7c2a282c5d$export$de2da3025c30316c(bytes);
}
function $953d6955755398f7$export$d1cea0ee4e3f0d3e(value, options = {}) {
    const { as: as = typeof value === "string" ? "Hex" : "Bytes" } = options;
    const bytes = (0, $d319ea51ae9e93ae$export$d1cea0ee4e3f0d3e)($e7decbb70673776d$export$6788812c4e6611e6(value));
    if (as === "Bytes") return bytes;
    return $cd0f3b7c2a282c5d$export$de2da3025c30316c(bytes);
}
function $953d6955755398f7$export$bced8d2aada2d1c9(value, options = {}) {
    const { as: as = typeof value === "string" ? "Hex" : "Bytes" } = options;
    const bytes = (0, $6189deb800195365$export$bced8d2aada2d1c9)($e7decbb70673776d$export$6788812c4e6611e6(value));
    if (as === "Bytes") return bytes;
    return $cd0f3b7c2a282c5d$export$de2da3025c30316c(bytes);
}
function $953d6955755398f7$export$a22775fa5e2eebd9(value) {
    return $cd0f3b7c2a282c5d$export$a22775fa5e2eebd9(value) && $cd0f3b7c2a282c5d$export$346677f925de839c(value) === 32;
}




/**
 * @internal
 *
 * Map with a LRU (Least recently used) policy.
 * @see https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ class $32861e3de4965d6f$export$fcb3b6cad79d7e3a extends Map {
    constructor(size){
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    get(key) {
        const value = super.get(key);
        if (super.has(key) && value !== undefined) {
            this.delete(key);
            super.set(key, value);
        }
        return value;
    }
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) {
            const firstKey = this.keys().next().value;
            if (firstKey) this.delete(firstKey);
        }
        return this;
    }
}


const $209a185659384a45$var$caches = {
    checksum: /*#__PURE__*/ new (0, $32861e3de4965d6f$export$fcb3b6cad79d7e3a)(8192)
};
const $209a185659384a45$export$bd4137bcc5170a90 = $209a185659384a45$var$caches.checksum;
function $209a185659384a45$export$42ffd38884aecdac() {
    for (const cache of Object.values($209a185659384a45$var$caches))cache.clear();
}








function $8ccc42b58b91b7ed$export$a7a9523472993e97(publicKey, options = {}) {
    const { compressed: compressed } = options;
    const { prefix: prefix, x: x, y: y } = publicKey;
    // Uncompressed
    if (compressed === false || typeof x === "bigint" && typeof y === "bigint") {
        if (prefix !== 4) throw new $8ccc42b58b91b7ed$export$3a88d45a5a7bba7d({
            prefix: prefix,
            cause: new $8ccc42b58b91b7ed$export$4d0661aaa327ceca()
        });
        return;
    }
    // Compressed
    if (compressed === true || typeof x === "bigint" && typeof y === "undefined") {
        if (prefix !== 3 && prefix !== 2) throw new $8ccc42b58b91b7ed$export$3a88d45a5a7bba7d({
            prefix: prefix,
            cause: new $8ccc42b58b91b7ed$export$8f4dfbe235a43c9a()
        });
        return;
    }
    // Unknown/invalid
    throw new $8ccc42b58b91b7ed$export$beb36eb38197386f({
        publicKey: publicKey
    });
}
function $8ccc42b58b91b7ed$export$80908c17a05abbe5(publicKey) {
    const { x: x, y: y } = publicKey;
    return {
        prefix: y % 2n === 0n ? 2 : 3,
        x: x
    };
}
function $8ccc42b58b91b7ed$export$6788812c4e6611e6(value) {
    const publicKey = (()=>{
        if ($cd0f3b7c2a282c5d$export$a22775fa5e2eebd9(value)) return $8ccc42b58b91b7ed$export$1a8ceedbd5845648(value);
        if ($e7decbb70673776d$export$a22775fa5e2eebd9(value)) return $8ccc42b58b91b7ed$export$de2da3025c30316c(value);
        const { prefix: prefix, x: x, y: y } = value;
        if (typeof x === "bigint" && typeof y === "bigint") return {
            prefix: prefix ?? 0x04,
            x: x,
            y: y
        };
        return {
            prefix: prefix,
            x: x
        };
    })();
    $8ccc42b58b91b7ed$export$a7a9523472993e97(publicKey);
    return publicKey;
}
function $8ccc42b58b91b7ed$export$de2da3025c30316c(publicKey) {
    return $8ccc42b58b91b7ed$export$1a8ceedbd5845648($cd0f3b7c2a282c5d$export$de2da3025c30316c(publicKey));
}
function $8ccc42b58b91b7ed$export$1a8ceedbd5845648(publicKey) {
    if (publicKey.length !== 132 && publicKey.length !== 130 && publicKey.length !== 68) throw new $8ccc42b58b91b7ed$export$3109b9e22011d26e({
        publicKey: publicKey
    });
    if (publicKey.length === 130) {
        const x = BigInt($cd0f3b7c2a282c5d$export$58adb3bec8346d0f(publicKey, 0, 32));
        const y = BigInt($cd0f3b7c2a282c5d$export$58adb3bec8346d0f(publicKey, 32, 64));
        return {
            prefix: 4,
            x: x,
            y: y
        };
    }
    if (publicKey.length === 132) {
        const prefix = Number($cd0f3b7c2a282c5d$export$58adb3bec8346d0f(publicKey, 0, 1));
        const x = BigInt($cd0f3b7c2a282c5d$export$58adb3bec8346d0f(publicKey, 1, 33));
        const y = BigInt($cd0f3b7c2a282c5d$export$58adb3bec8346d0f(publicKey, 33, 65));
        return {
            prefix: prefix,
            x: x,
            y: y
        };
    }
    const prefix = Number($cd0f3b7c2a282c5d$export$58adb3bec8346d0f(publicKey, 0, 1));
    const x = BigInt($cd0f3b7c2a282c5d$export$58adb3bec8346d0f(publicKey, 1, 33));
    return {
        prefix: prefix,
        x: x
    };
}
function $8ccc42b58b91b7ed$export$30a71edf0753ed6b(publicKey, options = {}) {
    return $e7decbb70673776d$export$1a8ceedbd5845648($8ccc42b58b91b7ed$export$7ea66e3774a60b67(publicKey, options));
}
function $8ccc42b58b91b7ed$export$7ea66e3774a60b67(publicKey, options = {}) {
    $8ccc42b58b91b7ed$export$a7a9523472993e97(publicKey);
    const { prefix: prefix, x: x, y: y } = publicKey;
    const { includePrefix: includePrefix = true } = options;
    const publicKey_ = $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22(includePrefix ? $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(prefix, {
        size: 1
    }) : "0x", $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(x, {
        size: 32
    }), // If the public key is not compressed, add the y coordinate.
    typeof y === "bigint" ? $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(y, {
        size: 32
    }) : "0x");
    return publicKey_;
}
function $8ccc42b58b91b7ed$export$a22775fa5e2eebd9(publicKey, options = {}) {
    try {
        $8ccc42b58b91b7ed$export$a7a9523472993e97(publicKey, options);
        return true;
    } catch (error) {
        return false;
    }
}
class $8ccc42b58b91b7ed$export$beb36eb38197386f extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ publicKey: publicKey }){
        super(`Value \`${$f3f6abd1159db811$export$fac44ee5b035f737(publicKey)}\` is not a valid public key.`, {
            metaMessages: [
                "Public key must contain:",
                "- an `x` and `prefix` value (compressed)",
                "- an `x`, `y`, and `prefix` value (uncompressed)"
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "PublicKey.InvalidError"
        });
    }
}
class $8ccc42b58b91b7ed$export$3a88d45a5a7bba7d extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ prefix: prefix, cause: cause }){
        super(`Prefix "${prefix}" is invalid.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "PublicKey.InvalidPrefixError"
        });
    }
}
class $8ccc42b58b91b7ed$export$8f4dfbe235a43c9a extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(){
        super("Prefix must be 2 or 3 for compressed public keys.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "PublicKey.InvalidCompressedPrefixError"
        });
    }
}
class $8ccc42b58b91b7ed$export$4d0661aaa327ceca extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(){
        super("Prefix must be 4 for uncompressed public keys.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "PublicKey.InvalidUncompressedPrefixError"
        });
    }
}
class $8ccc42b58b91b7ed$export$3109b9e22011d26e extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ publicKey: publicKey }){
        super(`Value \`${publicKey}\` is an invalid public key size.`, {
            metaMessages: [
                "Expected: 33 bytes (compressed + prefix), 64 bytes (uncompressed) or 65 bytes (uncompressed + prefix).",
                `Received ${$cd0f3b7c2a282c5d$export$346677f925de839c($cd0f3b7c2a282c5d$export$6788812c4e6611e6(publicKey))} bytes.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "PublicKey.InvalidSerializedSizeError"
        });
    }
}


const $c700ba6db2cf818a$var$addressRegex = /*#__PURE__*/ /^0x[a-fA-F0-9]{40}$/;
function $c700ba6db2cf818a$export$a7a9523472993e97(value, options = {}) {
    const { strict: strict = true } = options;
    if (!$c700ba6db2cf818a$var$addressRegex.test(value)) throw new $c700ba6db2cf818a$export$66c44d927ffead98({
        address: value,
        cause: new $c700ba6db2cf818a$export$14f92a7e583e58f7()
    });
    if (strict) {
        if (value.toLowerCase() === value) return;
        if ($c700ba6db2cf818a$export$bd4137bcc5170a90(value) !== value) throw new $c700ba6db2cf818a$export$66c44d927ffead98({
            address: value,
            cause: new $c700ba6db2cf818a$export$d2f4d6875130f5d5()
        });
    }
}
function $c700ba6db2cf818a$export$bd4137bcc5170a90(address) {
    if ($209a185659384a45$export$bd4137bcc5170a90.has(address)) return $209a185659384a45$export$bd4137bcc5170a90.get(address);
    $c700ba6db2cf818a$export$a7a9523472993e97(address, {
        strict: false
    });
    const hexAddress = address.substring(2).toLowerCase();
    const hash = $953d6955755398f7$export$f8151fce47ad1c35($e7decbb70673776d$export$3004f64547af360e(hexAddress), {
        as: "Bytes"
    });
    const characters = hexAddress.split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && characters[i]) characters[i] = characters[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && characters[i + 1]) characters[i + 1] = characters[i + 1].toUpperCase();
    }
    const result = `0x${characters.join("")}`;
    $209a185659384a45$export$bd4137bcc5170a90.set(address, result);
    return result;
}
function $c700ba6db2cf818a$export$6788812c4e6611e6(address, options = {}) {
    const { checksum: checksumVal = false } = options;
    $c700ba6db2cf818a$export$a7a9523472993e97(address);
    if (checksumVal) return $c700ba6db2cf818a$export$bd4137bcc5170a90(address);
    return address;
}
function $c700ba6db2cf818a$export$346a38bc5d008143(publicKey, options = {}) {
    const address = $953d6955755398f7$export$f8151fce47ad1c35(`0x${$8ccc42b58b91b7ed$export$7ea66e3774a60b67(publicKey).slice(4)}`).substring(26);
    return $c700ba6db2cf818a$export$6788812c4e6611e6(`0x${address}`, options);
}
function $c700ba6db2cf818a$export$248d38f6296296c5(addressA, addressB) {
    $c700ba6db2cf818a$export$a7a9523472993e97(addressA, {
        strict: false
    });
    $c700ba6db2cf818a$export$a7a9523472993e97(addressB, {
        strict: false
    });
    return addressA.toLowerCase() === addressB.toLowerCase();
}
function $c700ba6db2cf818a$export$a22775fa5e2eebd9(address, options = {}) {
    const { strict: strict = true } = options ?? {};
    try {
        $c700ba6db2cf818a$export$a7a9523472993e97(address, {
            strict: strict
        });
        return true;
    } catch  {
        return false;
    }
}
class $c700ba6db2cf818a$export$66c44d927ffead98 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ address: address, cause: cause }){
        super(`Address "${address}" is invalid.`, {
            cause: cause
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Address.InvalidAddressError"
        });
    }
}
class $c700ba6db2cf818a$export$14f92a7e583e58f7 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(){
        super("Address is not a 20 byte (40 hexadecimal character) value.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Address.InvalidInputError"
        });
    }
}
class $c700ba6db2cf818a$export$d2f4d6875130f5d5 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(){
        super("Address does not match its checksum counterpart.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Address.InvalidChecksumError"
        });
    }
}



function $13681e5053a553c3$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = "";
    let level = 0;
    let result = "";
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                "error",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new $c35f34add7b31ecb$export$a490eb03cb7a0a5e("Unable to normalize signature.");
    return result;
}
function $13681e5053a553c3$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return $c700ba6db2cf818a$export$a22775fa5e2eebd9(arg, {
                strict: false
            });
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $13681e5053a553c3$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$13681e5053a553c3$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            return false;
    }
}
function $13681e5053a553c3$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return $13681e5053a553c3$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return $c700ba6db2cf818a$export$a22775fa5e2eebd9(args[parameterIndex], {
                strict: false
            });
            if (types.includes("address") && types.includes("bytes")) return $c700ba6db2cf818a$export$a22775fa5e2eebd9(args[parameterIndex], {
                strict: false
            });
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}


function $db9f9dea108fef3b$export$d9468344d3651243(abiItem) {
    return $l2jn0.formatAbiItem(abiItem);
}
function $db9f9dea108fef3b$export$6788812c4e6611e6(abiItem, options = {}) {
    const { prepare: prepare = true } = options;
    const item = (()=>{
        if (Array.isArray(abiItem)) return $3aad363558a8968c$export$1e31c38713b34060(abiItem);
        if (typeof abiItem === "string") return $3aad363558a8968c$export$1e31c38713b34060(abiItem);
        return abiItem;
    })();
    return {
        ...item,
        ...prepare ? {
            hash: $db9f9dea108fef3b$export$528c5f8ce25bcf7d(item)
        } : {}
    };
}
function $db9f9dea108fef3b$export$5b3993ebf09c61b9(abi, name, options) {
    const { args: args = [], prepare: prepare = true } = options ?? {};
    const isSelector = $cd0f3b7c2a282c5d$export$a22775fa5e2eebd9(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === "function" || abiItem.type === "error") return $db9f9dea108fef3b$export$319b9bd79cec4634(abiItem) === $cd0f3b7c2a282c5d$export$58adb3bec8346d0f(name, 0, 4);
            if (abiItem.type === "event") return $db9f9dea108fef3b$export$528c5f8ce25bcf7d(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) throw new $db9f9dea108fef3b$export$78c95b58762d2106({
        name: name
    });
    if (abiItems.length === 1) return {
        ...abiItems[0],
        ...prepare ? {
            hash: $db9f9dea108fef3b$export$528c5f8ce25bcf7d(abiItems[0])
        } : {}
    };
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!("inputs" in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return {
                ...abiItem,
                ...prepare ? {
                    hash: $db9f9dea108fef3b$export$528c5f8ce25bcf7d(abiItem)
                } : {}
            };
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $13681e5053a553c3$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $13681e5053a553c3$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new $db9f9dea108fef3b$export$54eda30faeedd255({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    const abiItem = (()=>{
        if (matchedAbiItem) return matchedAbiItem;
        const [abiItem, ...overloads] = abiItems;
        return {
            ...abiItem,
            overloads: overloads
        };
    })();
    if (!abiItem) throw new $db9f9dea108fef3b$export$78c95b58762d2106({
        name: name
    });
    return {
        ...abiItem,
        ...prepare ? {
            hash: $db9f9dea108fef3b$export$528c5f8ce25bcf7d(abiItem)
        } : {}
    };
}
function $db9f9dea108fef3b$export$319b9bd79cec4634(abiItem) {
    return $cd0f3b7c2a282c5d$export$58adb3bec8346d0f($db9f9dea108fef3b$export$528c5f8ce25bcf7d(abiItem), 0, 4);
}
function $db9f9dea108fef3b$export$2f768fec5d73d91a(abiItem) {
    const signature = (()=>{
        if (typeof abiItem === "string") return abiItem;
        return $l2jn0.formatAbiItem(abiItem);
    })();
    return $13681e5053a553c3$export$5cba87ebe4d0307a(signature);
}
function $db9f9dea108fef3b$export$528c5f8ce25bcf7d(abiItem) {
    if (typeof abiItem !== "string" && "hash" in abiItem && abiItem.hash) return abiItem.hash;
    return $953d6955755398f7$export$f8151fce47ad1c35($cd0f3b7c2a282c5d$export$3004f64547af360e($db9f9dea108fef3b$export$2f768fec5d73d91a(abiItem)));
}
class $db9f9dea108fef3b$export$54eda30faeedd255 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(x, y){
        super("Found ambiguous types in overloaded ABI Items.", {
            metaMessages: [
                // TODO: abitype to add support for signature-formatted ABI items.
                `\`${x.type}\` in \`${$13681e5053a553c3$export$5cba87ebe4d0307a($l2jn0.formatAbiItem(x.abiItem))}\`, and`,
                `\`${y.type}\` in \`${$13681e5053a553c3$export$5cba87ebe4d0307a($l2jn0.formatAbiItem(y.abiItem))}\``,
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiItem.AmbiguityError"
        });
    }
}
class $db9f9dea108fef3b$export$78c95b58762d2106 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ name: name, data: data, type: type = "item" }){
        const selector = (()=>{
            if (name) return ` with name "${name}"`;
            if (data) return ` with data "${data}"`;
            return "";
        })();
        super(`ABI ${type}${selector} not found.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiItem.NotFoundError"
        });
    }
}
class $db9f9dea108fef3b$export$8a0357024884084b extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ data: data }){
        super(`Selector size is invalid. Expected 4 bytes. Received ${$cd0f3b7c2a282c5d$export$346677f925de839c(data)} bytes ("${data}").`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiItem.InvalidSelectorSizeError"
        });
    }
}



var $41jdK = parcelRequire("41jdK");
var $02ifr = parcelRequire("02ifr");

var $3PjHL = parcelRequire("3PjHL");

var $jzGfv = parcelRequire("jzGfv");

var $4hT4E = parcelRequire("4hT4E");
function $4087c0747b288446$export$660dc560f0dcce7a(params) {
    const abiParameters = [];
    if (typeof params === "string") {
        const parameters = (0, $4hT4E.splitParameters)(params);
        const length = parameters.length;
        for(let i = 0; i < length; i++)abiParameters.push((0, $4hT4E.parseAbiParameter)(parameters[i], {
            modifiers: $3PjHL.modifiers
        }));
    } else {
        const structs = (0, $jzGfv.parseStructs)(params);
        const length = params.length;
        for(let i = 0; i < length; i++){
            const signature = params[i];
            if ((0, $3PjHL.isStructSignature)(signature)) continue;
            const parameters = (0, $4hT4E.splitParameters)(signature);
            const length = parameters.length;
            for(let k = 0; k < length; k++)abiParameters.push((0, $4hT4E.parseAbiParameter)(parameters[k], {
                modifiers: $3PjHL.modifiers,
                structs: structs
            }));
        }
    }
    if (abiParameters.length === 0) throw new (0, $02ifr.InvalidAbiParametersError)({
        params: params
    });
    return abiParameters;
}






const $ba36d6bb061599e8$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $ba36d6bb061599e8$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $ba36d6bb061599e8$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $ba36d6bb061599e8$export$bdd7109439799cdf = 2n ** (8n - 1n) - 1n;
const $ba36d6bb061599e8$export$eee94935c9b963a1 = 2n ** (16n - 1n) - 1n;
const $ba36d6bb061599e8$export$e91fe5d90cd4a2f6 = 2n ** (24n - 1n) - 1n;
const $ba36d6bb061599e8$export$25c0796c740353c4 = 2n ** (32n - 1n) - 1n;
const $ba36d6bb061599e8$export$ac2072b1e721a92d = 2n ** (40n - 1n) - 1n;
const $ba36d6bb061599e8$export$7b7c71fa48943f3 = 2n ** (48n - 1n) - 1n;
const $ba36d6bb061599e8$export$e27ce19a567c9842 = 2n ** (56n - 1n) - 1n;
const $ba36d6bb061599e8$export$a51b0cf29ddb8e40 = 2n ** (64n - 1n) - 1n;
const $ba36d6bb061599e8$export$347f40d3f7572e5a = 2n ** (72n - 1n) - 1n;
const $ba36d6bb061599e8$export$940f45cde4f61aed = 2n ** (80n - 1n) - 1n;
const $ba36d6bb061599e8$export$13cad54caf92841d = 2n ** (88n - 1n) - 1n;
const $ba36d6bb061599e8$export$872296ce91d7dabe = 2n ** (96n - 1n) - 1n;
const $ba36d6bb061599e8$export$404112bd52c31da4 = 2n ** (104n - 1n) - 1n;
const $ba36d6bb061599e8$export$1d4284abecdbf56d = 2n ** (112n - 1n) - 1n;
const $ba36d6bb061599e8$export$35201a0fd5d34f18 = 2n ** (120n - 1n) - 1n;
const $ba36d6bb061599e8$export$92415df5352289c7 = 2n ** (128n - 1n) - 1n;
const $ba36d6bb061599e8$export$ccb03f6a03d6e182 = 2n ** (136n - 1n) - 1n;
const $ba36d6bb061599e8$export$cbf030aa46ccd63 = 2n ** (144n - 1n) - 1n;
const $ba36d6bb061599e8$export$33ad14852d23a660 = 2n ** (152n - 1n) - 1n;
const $ba36d6bb061599e8$export$6429af277dbaae06 = 2n ** (160n - 1n) - 1n;
const $ba36d6bb061599e8$export$2b154fcf8b3c7a42 = 2n ** (168n - 1n) - 1n;
const $ba36d6bb061599e8$export$6ba90f949100477a = 2n ** (176n - 1n) - 1n;
const $ba36d6bb061599e8$export$a353fb8a621e38fd = 2n ** (184n - 1n) - 1n;
const $ba36d6bb061599e8$export$ad4f6360abea4fa4 = 2n ** (192n - 1n) - 1n;
const $ba36d6bb061599e8$export$381549e0b0f272ab = 2n ** (200n - 1n) - 1n;
const $ba36d6bb061599e8$export$a083a4afa1a2c00c = 2n ** (208n - 1n) - 1n;
const $ba36d6bb061599e8$export$ee8f6a880c431cd3 = 2n ** (216n - 1n) - 1n;
const $ba36d6bb061599e8$export$a8672844e0af1027 = 2n ** (224n - 1n) - 1n;
const $ba36d6bb061599e8$export$57c45c845403e7a5 = 2n ** (232n - 1n) - 1n;
const $ba36d6bb061599e8$export$e8e88f55ae4a3354 = 2n ** (240n - 1n) - 1n;
const $ba36d6bb061599e8$export$ebbd894fe518c064 = 2n ** (248n - 1n) - 1n;
const $ba36d6bb061599e8$export$e4d673aa7367981c = 2n ** (256n - 1n) - 1n;
const $ba36d6bb061599e8$export$ef9b9e1988c51720 = -(2n ** (8n - 1n));
const $ba36d6bb061599e8$export$b923fba4a82cad48 = -(2n ** (16n - 1n));
const $ba36d6bb061599e8$export$7b0286602251a7c7 = -(2n ** (24n - 1n));
const $ba36d6bb061599e8$export$5f0d0d25b56bbb4f = -(2n ** (32n - 1n));
const $ba36d6bb061599e8$export$4c07a8deea2258b1 = -(2n ** (40n - 1n));
const $ba36d6bb061599e8$export$6a6c2e4f279545ff = -(2n ** (48n - 1n));
const $ba36d6bb061599e8$export$1739c13d967d68b1 = -(2n ** (56n - 1n));
const $ba36d6bb061599e8$export$14e6fedf9fb9d75c = -(2n ** (64n - 1n));
const $ba36d6bb061599e8$export$bc3defde0bfb8bd = -(2n ** (72n - 1n));
const $ba36d6bb061599e8$export$8efa66e0d946dfd2 = -(2n ** (80n - 1n));
const $ba36d6bb061599e8$export$80ab8bed90b29bfe = -(2n ** (88n - 1n));
const $ba36d6bb061599e8$export$39c4444aac2d0d86 = -(2n ** (96n - 1n));
const $ba36d6bb061599e8$export$28fd4a9e64dafe7b = -(2n ** (104n - 1n));
const $ba36d6bb061599e8$export$38cae674fedc8f74 = -(2n ** (112n - 1n));
const $ba36d6bb061599e8$export$6779113dfecc5d69 = -(2n ** (120n - 1n));
const $ba36d6bb061599e8$export$93cc92d28d07644b = -(2n ** (128n - 1n));
const $ba36d6bb061599e8$export$4acf8238e6d61d3e = -(2n ** (136n - 1n));
const $ba36d6bb061599e8$export$ac974246b2ca90ec = -(2n ** (144n - 1n));
const $ba36d6bb061599e8$export$77d4dfc3aa958440 = -(2n ** (152n - 1n));
const $ba36d6bb061599e8$export$a9a1ab546428ca6f = -(2n ** (160n - 1n));
const $ba36d6bb061599e8$export$aca1dbffc71a377a = -(2n ** (168n - 1n));
const $ba36d6bb061599e8$export$1ca77ffa68208066 = -(2n ** (176n - 1n));
const $ba36d6bb061599e8$export$e74092b0e35f2385 = -(2n ** (184n - 1n));
const $ba36d6bb061599e8$export$5f53c97c87f852f4 = -(2n ** (192n - 1n));
const $ba36d6bb061599e8$export$df01e80cffe255dc = -(2n ** (200n - 1n));
const $ba36d6bb061599e8$export$155f043c7b06e008 = -(2n ** (208n - 1n));
const $ba36d6bb061599e8$export$195a5ffec9c679b8 = -(2n ** (216n - 1n));
const $ba36d6bb061599e8$export$b1ee6eacfb96c50c = -(2n ** (224n - 1n));
const $ba36d6bb061599e8$export$16bdbfee8230ad51 = -(2n ** (232n - 1n));
const $ba36d6bb061599e8$export$5715ad8f9991a9a2 = -(2n ** (240n - 1n));
const $ba36d6bb061599e8$export$9146117a246b63ab = -(2n ** (248n - 1n));
const $ba36d6bb061599e8$export$5d31694d80b27ae5 = -(2n ** (256n - 1n));
const $ba36d6bb061599e8$export$7db2ab1a72670716 = 2n ** 8n - 1n;
const $ba36d6bb061599e8$export$e4e112958a94d87f = 2n ** 16n - 1n;
const $ba36d6bb061599e8$export$1bea6075c2df6828 = 2n ** 24n - 1n;
const $ba36d6bb061599e8$export$48716e5eecd83bf7 = 2n ** 32n - 1n;
const $ba36d6bb061599e8$export$dc2184b5c9263ac7 = 2n ** 40n - 1n;
const $ba36d6bb061599e8$export$e639b3656891925b = 2n ** 48n - 1n;
const $ba36d6bb061599e8$export$bea470c1abdb1310 = 2n ** 56n - 1n;
const $ba36d6bb061599e8$export$3f17b1570950699c = 2n ** 64n - 1n;
const $ba36d6bb061599e8$export$8135da85ae9b595b = 2n ** 72n - 1n;
const $ba36d6bb061599e8$export$caa80683240e3b73 = 2n ** 80n - 1n;
const $ba36d6bb061599e8$export$8e50c223f761a8cf = 2n ** 88n - 1n;
const $ba36d6bb061599e8$export$621d3d87b73138e5 = 2n ** 96n - 1n;
const $ba36d6bb061599e8$export$4e5098f4748a9a4d = 2n ** 104n - 1n;
const $ba36d6bb061599e8$export$1435b580b943ede2 = 2n ** 112n - 1n;
const $ba36d6bb061599e8$export$4362e740aadf7dab = 2n ** 120n - 1n;
const $ba36d6bb061599e8$export$380ebe6b2fc5caa9 = 2n ** 128n - 1n;
const $ba36d6bb061599e8$export$6c13d06e0cefb9aa = 2n ** 136n - 1n;
const $ba36d6bb061599e8$export$fe2d415b41e5f433 = 2n ** 144n - 1n;
const $ba36d6bb061599e8$export$c2f2754e23c5488a = 2n ** 152n - 1n;
const $ba36d6bb061599e8$export$34fcca92c372a91b = 2n ** 160n - 1n;
const $ba36d6bb061599e8$export$32e3523cb82cc8a0 = 2n ** 168n - 1n;
const $ba36d6bb061599e8$export$d36711d6637bde95 = 2n ** 176n - 1n;
const $ba36d6bb061599e8$export$9211611648dd09a2 = 2n ** 184n - 1n;
const $ba36d6bb061599e8$export$4e61cbaa2231cfdd = 2n ** 192n - 1n;
const $ba36d6bb061599e8$export$9187c63f331d335b = 2n ** 200n - 1n;
const $ba36d6bb061599e8$export$7f910799edc7ae97 = 2n ** 208n - 1n;
const $ba36d6bb061599e8$export$64506e5a2676ecb0 = 2n ** 216n - 1n;
const $ba36d6bb061599e8$export$a060896418206521 = 2n ** 224n - 1n;
const $ba36d6bb061599e8$export$18b000c2bc5e114 = 2n ** 232n - 1n;
const $ba36d6bb061599e8$export$253bb52e7f7a3909 = 2n ** 240n - 1n;
const $ba36d6bb061599e8$export$d5a8ad83a637081c = 2n ** 248n - 1n;
const $ba36d6bb061599e8$export$48de485e50a67ffa = 2n ** 256n - 1n;








function $d94ec2cdfef6ff46$export$a522dd3166563240(cursor, param, options) {
    const { checksumAddress: checksumAddress, staticPosition: staticPosition } = options;
    const arrayComponents = $d94ec2cdfef6ff46$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $d94ec2cdfef6ff46$export$81879b02e9646afe(cursor, {
            ...param,
            type: type
        }, {
            checksumAddress: checksumAddress,
            length: length,
            staticPosition: staticPosition
        });
    }
    if (param.type === "tuple") return $d94ec2cdfef6ff46$export$f388ba5c0507726(cursor, param, {
        checksumAddress: checksumAddress,
        staticPosition: staticPosition
    });
    if (param.type === "address") return $d94ec2cdfef6ff46$export$63e61a72b498228b(cursor, {
        checksum: checksumAddress
    });
    if (param.type === "bool") return $d94ec2cdfef6ff46$export$3aa8d860955b6cf2(cursor);
    if (param.type.startsWith("bytes")) return $d94ec2cdfef6ff46$export$c97600adfa527f5b(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type.startsWith("uint") || param.type.startsWith("int")) return $d94ec2cdfef6ff46$export$874d75d651b25595(cursor, param);
    if (param.type === "string") return $d94ec2cdfef6ff46$export$a0fb664af7d0cc44(cursor, {
        staticPosition: staticPosition
    });
    throw new $ed1c7de70afe5565$export$2d4818a25c0cc775(param.type);
}
const $d94ec2cdfef6ff46$var$sizeOfLength = 32;
const $d94ec2cdfef6ff46$var$sizeOfOffset = 32;
function $d94ec2cdfef6ff46$export$63e61a72b498228b(cursor, options = {}) {
    const { checksum: checksum = false } = options;
    const value = cursor.readBytes(32);
    const wrap = (address)=>checksum ? $c700ba6db2cf818a$export$bd4137bcc5170a90(address) : address;
    return [
        wrap($cd0f3b7c2a282c5d$export$de2da3025c30316c($e7decbb70673776d$export$58adb3bec8346d0f(value, -20))),
        32
    ];
}
function $d94ec2cdfef6ff46$export$81879b02e9646afe(cursor, param, options) {
    const { checksumAddress: checksumAddress, length: length, staticPosition: staticPosition } = options;
    // If the length of the array is not known in advance (dynamic array),
    // this means we will need to wonder off to the pointer and decode.
    if (!length) {
        // Dealing with a dynamic type, so get the offset of the array data.
        const offset = $e7decbb70673776d$export$a0a81dc3380ce7d3(cursor.readBytes($d94ec2cdfef6ff46$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const startOfData = start + $d94ec2cdfef6ff46$var$sizeOfLength;
        // Get the length of the array from the offset.
        cursor.setPosition(start);
        const length = $e7decbb70673776d$export$a0a81dc3380ce7d3(cursor.readBytes($d94ec2cdfef6ff46$var$sizeOfLength));
        // Check if the array has any dynamic children.
        const dynamicChild = $d94ec2cdfef6ff46$export$4967d2066aaf3757(param);
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            // If any of the children is dynamic, then all elements will be offset pointer, thus size of one slot (32 bytes).
            // Otherwise, elements will be the size of their encoding (consumed bytes).
            cursor.setPosition(startOfData + (dynamicChild ? i * 32 : consumed));
            const [data, consumed_] = $d94ec2cdfef6ff46$export$a522dd3166563240(cursor, param, {
                checksumAddress: checksumAddress,
                staticPosition: startOfData
            });
            consumed += consumed_;
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($d94ec2cdfef6ff46$export$4967d2066aaf3757(param)) {
        // Dealing with dynamic types, so get the offset of the array data.
        const offset = $e7decbb70673776d$export$a0a81dc3380ce7d3(cursor.readBytes($d94ec2cdfef6ff46$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const value = [];
        for(let i = 0; i < length; ++i){
            // Move cursor along to the next slot (next offset pointer).
            cursor.setPosition(start + i * 32);
            const [data] = $d94ec2cdfef6ff46$export$a522dd3166563240(cursor, param, {
                checksumAddress: checksumAddress,
                staticPosition: start
            });
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance and the array is deeply static,
    // then we can just decode each element in sequence.
    let consumed = 0;
    const value = [];
    for(let i = 0; i < length; ++i){
        const [data, consumed_] = $d94ec2cdfef6ff46$export$a522dd3166563240(cursor, param, {
            checksumAddress: checksumAddress,
            staticPosition: staticPosition + consumed
        });
        consumed += consumed_;
        value.push(data);
    }
    return [
        value,
        consumed
    ];
}
function $d94ec2cdfef6ff46$export$3aa8d860955b6cf2(cursor) {
    return [
        $e7decbb70673776d$export$3c2e6d1b7583eee6(cursor.readBytes(32), {
            size: 32
        }),
        32
    ];
}
function $d94ec2cdfef6ff46$export$c97600adfa527f5b(cursor, param, { staticPosition: staticPosition }) {
    const [_, size] = param.type.split("bytes");
    if (!size) {
        // Dealing with dynamic types, so get the offset of the bytes data.
        const offset = $e7decbb70673776d$export$a0a81dc3380ce7d3(cursor.readBytes(32));
        // Set position of the cursor to start of bytes data.
        cursor.setPosition(staticPosition + offset);
        const length = $e7decbb70673776d$export$a0a81dc3380ce7d3(cursor.readBytes(32));
        // If there is no length, we have zero data.
        if (length === 0) {
            // As we have gone wondering, restore to the original position + next slot.
            cursor.setPosition(staticPosition + 32);
            return [
                "0x",
                32
            ];
        }
        const data = cursor.readBytes(length);
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            $cd0f3b7c2a282c5d$export$de2da3025c30316c(data),
            32
        ];
    }
    const value = $cd0f3b7c2a282c5d$export$de2da3025c30316c(cursor.readBytes(Number.parseInt(size), 32));
    return [
        value,
        32
    ];
}
function $d94ec2cdfef6ff46$export$874d75d651b25595(cursor, param) {
    const signed = param.type.startsWith("int");
    const size = Number.parseInt(param.type.split("int")[1] || "256");
    const value = cursor.readBytes(32);
    return [
        size > 48 ? $e7decbb70673776d$export$c221a145703ab783(value, {
            signed: signed
        }) : $e7decbb70673776d$export$a0a81dc3380ce7d3(value, {
            signed: signed
        }),
        32
    ];
}
function $d94ec2cdfef6ff46$export$f388ba5c0507726(cursor, param, options) {
    const { checksumAddress: checksumAddress, staticPosition: staticPosition } = options;
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name: name })=>!name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($d94ec2cdfef6ff46$export$4967d2066aaf3757(param)) {
        // Dealing with dynamic types, so get the offset of the tuple data.
        const offset = $e7decbb70673776d$export$a0a81dc3380ce7d3(cursor.readBytes($d94ec2cdfef6ff46$var$sizeOfOffset));
        // Start is the static position of referencing slot + offset.
        const start = staticPosition + offset;
        for(let i = 0; i < param.components.length; ++i){
            const component = param.components[i];
            cursor.setPosition(start + consumed);
            const [data, consumed_] = $d94ec2cdfef6ff46$export$a522dd3166563240(cursor, component, {
                checksumAddress: checksumAddress,
                staticPosition: start
            });
            consumed += consumed_;
            value[hasUnnamedChild ? i : component?.name] = data;
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(let i = 0; i < param.components.length; ++i){
        const component = param.components[i];
        const [data, consumed_] = $d94ec2cdfef6ff46$export$a522dd3166563240(cursor, component, {
            checksumAddress: checksumAddress,
            staticPosition: staticPosition
        });
        value[hasUnnamedChild ? i : component?.name] = data;
        consumed += consumed_;
    }
    return [
        value,
        consumed
    ];
}
function $d94ec2cdfef6ff46$export$a0fb664af7d0cc44(cursor, { staticPosition: staticPosition }) {
    // Get offset to start of string data.
    const offset = $e7decbb70673776d$export$a0a81dc3380ce7d3(cursor.readBytes(32));
    // Start is the static position of current slot + offset.
    const start = staticPosition + offset;
    cursor.setPosition(start);
    const length = $e7decbb70673776d$export$a0a81dc3380ce7d3(cursor.readBytes(32));
    // If there is no length, we have zero data (empty string).
    if (length === 0) {
        cursor.setPosition(staticPosition + 32);
        return [
            "",
            32
        ];
    }
    const data = cursor.readBytes(length, 32);
    const value = $e7decbb70673776d$export$f84e8e69fd4488a5($e7decbb70673776d$export$c5557f40488c48ec(data));
    // As we have gone wondering, restore to the original position + next slot.
    cursor.setPosition(staticPosition + 32);
    return [
        value,
        32
    ];
}
function $d94ec2cdfef6ff46$export$8149dc8e3138c55({ checksumAddress: checksumAddress, parameters: parameters, values: values }) {
    const preparedParameters = [];
    for(let i = 0; i < parameters.length; i++)preparedParameters.push($d94ec2cdfef6ff46$export$4901495b934caf20({
        checksumAddress: checksumAddress,
        parameter: parameters[i],
        value: values[i]
    }));
    return preparedParameters;
}
function $d94ec2cdfef6ff46$export$4901495b934caf20({ checksumAddress: checksumAddress = false, parameter: parameter_, value: value }) {
    const parameter = parameter_;
    const arrayComponents = $d94ec2cdfef6ff46$export$ab502cfdbb1a0d07(parameter.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $d94ec2cdfef6ff46$export$5953f05715bb15e3(value, {
            checksumAddress: checksumAddress,
            length: length,
            parameter: {
                ...parameter,
                type: type
            }
        });
    }
    if (parameter.type === "tuple") return $d94ec2cdfef6ff46$export$1990b7ba8cf7db93(value, {
        checksumAddress: checksumAddress,
        parameter: parameter
    });
    if (parameter.type === "address") return $d94ec2cdfef6ff46$export$b149ba8ff44e4e70(value, {
        checksum: checksumAddress
    });
    if (parameter.type === "bool") return $d94ec2cdfef6ff46$export$1b0ad99313e5e2c6(value);
    if (parameter.type.startsWith("uint") || parameter.type.startsWith("int")) {
        const signed = parameter.type.startsWith("int");
        const [, , size = "256"] = (0, $ba36d6bb061599e8$export$45902cc189596eef).exec(parameter.type) ?? [];
        return $d94ec2cdfef6ff46$export$ed41c27e89606957(value, {
            signed: signed,
            size: Number(size)
        });
    }
    if (parameter.type.startsWith("bytes")) return $d94ec2cdfef6ff46$export$2589e87d78677b0d(value, {
        type: parameter.type
    });
    if (parameter.type === "string") return $d94ec2cdfef6ff46$export$8146d2e653b87d6a(value);
    throw new $ed1c7de70afe5565$export$2d4818a25c0cc775(parameter.type);
}
function $d94ec2cdfef6ff46$export$c564cdbbe6da493(preparedParameters) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParameters.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParameters[i];
        if (dynamic) staticSize += 32;
        else staticSize += $cd0f3b7c2a282c5d$export$346677f925de839c(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParameters = [];
    const dynamicParameters = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParameters.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParameters[i];
        if (dynamic) {
            staticParameters.push($cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParameters.push(encoded);
            dynamicSize += $cd0f3b7c2a282c5d$export$346677f925de839c(encoded);
        } else staticParameters.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22(...staticParameters, ...dynamicParameters);
}
function $d94ec2cdfef6ff46$export$b149ba8ff44e4e70(value, options) {
    const { checksum: checksum = false } = options;
    $c700ba6db2cf818a$export$a7a9523472993e97(value, {
        strict: checksum
    });
    return {
        dynamic: false,
        encoded: $cd0f3b7c2a282c5d$export$bc3bea8325045070(value.toLowerCase())
    };
}
function $d94ec2cdfef6ff46$export$5953f05715bb15e3(value, options) {
    const { checksumAddress: checksumAddress, length: length, parameter: parameter } = options;
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new $ed1c7de70afe5565$export$710dd6d4f78cc47e(value);
    if (!dynamic && value.length !== length) throw new $ed1c7de70afe5565$export$1b8b2e17cbff9b06({
        expectedLength: length,
        givenLength: value.length,
        type: `${parameter.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParameters = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $d94ec2cdfef6ff46$export$4901495b934caf20({
            checksumAddress: checksumAddress,
            parameter: parameter,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParameters.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $d94ec2cdfef6ff46$export$c564cdbbe6da493(preparedParameters);
        if (dynamic) {
            const length = $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(preparedParameters.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParameters.length > 0 ? $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22(length, data) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22(...preparedParameters.map(({ encoded: encoded })=>encoded))
    };
}
function $d94ec2cdfef6ff46$export$2589e87d78677b0d(value, { type: type }) {
    const [, parametersize] = type.split("bytes");
    const bytesSize = $cd0f3b7c2a282c5d$export$346677f925de839c(value);
    if (!parametersize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = $cd0f3b7c2a282c5d$export$7e24a29324041c48(value_, Math.ceil((value.length - 2) / 2 / 32) * 32);
        return {
            dynamic: true,
            encoded: $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22($cd0f3b7c2a282c5d$export$bc3bea8325045070($cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(bytesSize, {
                size: 32
            })), value_)
        };
    }
    if (bytesSize !== Number.parseInt(parametersize)) throw new $ed1c7de70afe5565$export$a0eb884ede5c87eb({
        expectedSize: Number.parseInt(parametersize),
        value: value
    });
    return {
        dynamic: false,
        encoded: $cd0f3b7c2a282c5d$export$7e24a29324041c48(value)
    };
}
function $d94ec2cdfef6ff46$export$1b0ad99313e5e2c6(value) {
    if (typeof value !== "boolean") throw new $c35f34add7b31ecb$export$a490eb03cb7a0a5e(`Invalid boolean value: "${value}" (type: ${typeof value}). Expected: \`true\` or \`false\`.`);
    return {
        dynamic: false,
        encoded: $cd0f3b7c2a282c5d$export$bc3bea8325045070($cd0f3b7c2a282c5d$export$dbafa4424a806c15(value))
    };
}
function $d94ec2cdfef6ff46$export$ed41c27e89606957(value, { signed: signed, size: size }) {
    if (typeof size === "number") {
        const max = 2n ** (BigInt(size) - (signed ? 1n : 0n)) - 1n;
        const min = signed ? -max - 1n : 0n;
        if (value > max || value < min) throw new $cd0f3b7c2a282c5d$export$47d164a8071229a9({
            max: max.toString(),
            min: min.toString(),
            signed: signed,
            size: size / 8,
            value: value.toString()
        });
    }
    return {
        dynamic: false,
        encoded: $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(value, {
            size: 32,
            signed: signed
        })
    };
}
function $d94ec2cdfef6ff46$export$8146d2e653b87d6a(value) {
    const hexValue = $cd0f3b7c2a282c5d$export$3004f64547af360e(value);
    const partsLength = Math.ceil($cd0f3b7c2a282c5d$export$346677f925de839c(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push($cd0f3b7c2a282c5d$export$7e24a29324041c48($cd0f3b7c2a282c5d$export$58adb3bec8346d0f(hexValue, i * 32, (i + 1) * 32)));
    return {
        dynamic: true,
        encoded: $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22($cd0f3b7c2a282c5d$export$7e24a29324041c48($cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2($cd0f3b7c2a282c5d$export$346677f925de839c(hexValue), {
            size: 32
        })), ...parts)
    };
}
function $d94ec2cdfef6ff46$export$1990b7ba8cf7db93(value, options) {
    const { checksumAddress: checksumAddress, parameter: parameter } = options;
    let dynamic = false;
    const preparedParameters = [];
    for(let i = 0; i < parameter.components.length; i++){
        const param_ = parameter.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $d94ec2cdfef6ff46$export$4901495b934caf20({
            checksumAddress: checksumAddress,
            parameter: param_,
            value: value[index]
        });
        preparedParameters.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $d94ec2cdfef6ff46$export$c564cdbbe6da493(preparedParameters) : $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22(...preparedParameters.map(({ encoded: encoded })=>encoded))
    };
}
function $d94ec2cdfef6ff46$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}
function $d94ec2cdfef6ff46$export$4967d2066aaf3757(param) {
    const { type: type } = param;
    if (type === "string") return true;
    if (type === "bytes") return true;
    if (type.endsWith("[]")) return true;
    if (type === "tuple") return param.components?.some($d94ec2cdfef6ff46$export$4967d2066aaf3757);
    const arrayComponents = $d94ec2cdfef6ff46$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents && $d94ec2cdfef6ff46$export$4967d2066aaf3757({
        ...param,
        type: arrayComponents[1]
    })) return true;
    return false;
}



const $0326d2dac0bec7a8$var$staticCursor = /*#__PURE__*/ {
    bytes: new Uint8Array(),
    dataView: new DataView(new ArrayBuffer(0)),
    position: 0,
    positionReadCount: new Map(),
    recursiveReadCount: 0,
    recursiveReadLimit: Number.POSITIVE_INFINITY,
    assertReadLimit () {
        if (this.recursiveReadCount >= this.recursiveReadLimit) throw new $0326d2dac0bec7a8$export$4952f5c6336a7cc7({
            count: this.recursiveReadCount + 1,
            limit: this.recursiveReadLimit
        });
    },
    assertPosition (position) {
        if (position < 0 || position > this.bytes.length - 1) throw new $0326d2dac0bec7a8$export$72dcc4230cbf50ba({
            length: this.bytes.length,
            position: position
        });
    },
    decrementPosition (offset) {
        if (offset < 0) throw new $0326d2dac0bec7a8$export$4741ff085e62ac19({
            offset: offset
        });
        const position = this.position - offset;
        this.assertPosition(position);
        this.position = position;
    },
    getReadCount (position) {
        return this.positionReadCount.get(position || this.position) || 0;
    },
    incrementPosition (offset) {
        if (offset < 0) throw new $0326d2dac0bec7a8$export$4741ff085e62ac19({
            offset: offset
        });
        const position = this.position + offset;
        this.assertPosition(position);
        this.position = position;
    },
    inspectByte (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectBytes (length, position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + length - 1);
        return this.bytes.subarray(position, position + length);
    },
    inspectUint8 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectUint16 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 1);
        return this.dataView.getUint16(position);
    },
    inspectUint24 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 2);
        return (this.dataView.getUint16(position) << 8) + this.dataView.getUint8(position + 2);
    },
    inspectUint32 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 3);
        return this.dataView.getUint32(position);
    },
    pushByte (byte) {
        this.assertPosition(this.position);
        this.bytes[this.position] = byte;
        this.position++;
    },
    pushBytes (bytes) {
        this.assertPosition(this.position + bytes.length - 1);
        this.bytes.set(bytes, this.position);
        this.position += bytes.length;
    },
    pushUint8 (value) {
        this.assertPosition(this.position);
        this.bytes[this.position] = value;
        this.position++;
    },
    pushUint16 (value) {
        this.assertPosition(this.position + 1);
        this.dataView.setUint16(this.position, value);
        this.position += 2;
    },
    pushUint24 (value) {
        this.assertPosition(this.position + 2);
        this.dataView.setUint16(this.position, value >> 8);
        this.dataView.setUint8(this.position + 2, value & 255);
        this.position += 3;
    },
    pushUint32 (value) {
        this.assertPosition(this.position + 3);
        this.dataView.setUint32(this.position, value);
        this.position += 4;
    },
    readByte () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectByte();
        this.position++;
        return value;
    },
    readBytes (length, size) {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectBytes(length);
        this.position += size ?? length;
        return value;
    },
    readUint8 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint8();
        this.position += 1;
        return value;
    },
    readUint16 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint16();
        this.position += 2;
        return value;
    },
    readUint24 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint24();
        this.position += 3;
        return value;
    },
    readUint32 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint32();
        this.position += 4;
        return value;
    },
    get remaining () {
        return this.bytes.length - this.position;
    },
    setPosition (position) {
        const oldPosition = this.position;
        this.assertPosition(position);
        this.position = position;
        return ()=>this.position = oldPosition;
    },
    _touch () {
        if (this.recursiveReadLimit === Number.POSITIVE_INFINITY) return;
        const count = this.getReadCount();
        this.positionReadCount.set(this.position, count + 1);
        if (count > 0) this.recursiveReadCount++;
    }
};
function $0326d2dac0bec7a8$export$185802fd694ee1f5(bytes, { recursiveReadLimit: recursiveReadLimit = 8192 } = {}) {
    const cursor = Object.create($0326d2dac0bec7a8$var$staticCursor);
    cursor.bytes = bytes;
    cursor.dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    cursor.positionReadCount = new Map();
    cursor.recursiveReadLimit = recursiveReadLimit;
    return cursor;
}
class $0326d2dac0bec7a8$export$4741ff085e62ac19 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ offset: offset }){
        super(`Offset \`${offset}\` cannot be negative.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Cursor.NegativeOffsetError"
        });
    }
}
class $0326d2dac0bec7a8$export$72dcc4230cbf50ba extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ length: length, position: position }){
        super(`Position \`${position}\` is out of bounds (\`0 < position < ${length}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Cursor.PositionOutOfBoundsError"
        });
    }
}
class $0326d2dac0bec7a8$export$4952f5c6336a7cc7 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ count: count, limit: limit }){
        super(`Recursive read limit of \`${limit}\` exceeded (recursive read count: \`${count}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "Cursor.RecursiveReadLimitExceededError"
        });
    }
}


function $ed1c7de70afe5565$export$2f872c0f2117be69(parameters, data, options = {}) {
    const { as: as = "Array", checksumAddress: checksumAddress = false } = options;
    const bytes = typeof data === "string" ? $e7decbb70673776d$export$1a8ceedbd5845648(data) : data;
    const cursor = $0326d2dac0bec7a8$export$185802fd694ee1f5(bytes);
    if ($e7decbb70673776d$export$346677f925de839c(bytes) === 0 && parameters.length > 0) throw new $ed1c7de70afe5565$export$b8eb32bc991c805c();
    if ($e7decbb70673776d$export$346677f925de839c(bytes) && $e7decbb70673776d$export$346677f925de839c(bytes) < 32) throw new $ed1c7de70afe5565$export$ed7a66fc0baa3ad2({
        data: typeof data === "string" ? data : $cd0f3b7c2a282c5d$export$de2da3025c30316c(data),
        parameters: parameters,
        size: $e7decbb70673776d$export$346677f925de839c(bytes)
    });
    let consumed = 0;
    const values = as === "Array" ? [] : {};
    for(let i = 0; i < parameters.length; ++i){
        const param = parameters[i];
        cursor.setPosition(consumed);
        const [data, consumed_] = $d94ec2cdfef6ff46$export$a522dd3166563240(cursor, param, {
            checksumAddress: checksumAddress,
            staticPosition: 0
        });
        consumed += consumed_;
        if (as === "Array") values.push(data);
        else values[param.name ?? i] = data;
    }
    return values;
}
function $ed1c7de70afe5565$export$c564cdbbe6da493(parameters, values, options) {
    const { checksumAddress: checksumAddress = false } = options ?? {};
    if (parameters.length !== values.length) throw new $ed1c7de70afe5565$export$c4bef8d61dd517cb({
        expectedLength: parameters.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParameters = $d94ec2cdfef6ff46$export$8149dc8e3138c55({
        checksumAddress: checksumAddress,
        parameters: parameters,
        values: values
    });
    const data = $d94ec2cdfef6ff46$export$c564cdbbe6da493(preparedParameters);
    if (data.length === 0) return "0x";
    return data;
}
function $ed1c7de70afe5565$export$92dace262a9f3722(types, values) {
    if (types.length !== values.length) throw new $ed1c7de70afe5565$export$c4bef8d61dd517cb({
        expectedLength: types.length,
        givenLength: values.length
    });
    const data = [];
    for(let i = 0; i < types.length; i++){
        const type = types[i];
        const value = values[i];
        data.push($ed1c7de70afe5565$export$92dace262a9f3722.encode(type, value));
    }
    return $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22(...data);
}
(function(encodePacked) {
    // eslint-disable-next-line jsdoc/require-jsdoc
    function encode(type, value, isArray = false) {
        if (type === "address") {
            const address = value;
            $c700ba6db2cf818a$export$a7a9523472993e97(address);
            return $cd0f3b7c2a282c5d$export$bc3bea8325045070(address.toLowerCase(), isArray ? 32 : 0);
        }
        if (type === "string") return $cd0f3b7c2a282c5d$export$3004f64547af360e(value);
        if (type === "bytes") return value;
        if (type === "bool") return $cd0f3b7c2a282c5d$export$bc3bea8325045070($cd0f3b7c2a282c5d$export$dbafa4424a806c15(value), isArray ? 32 : 1);
        const intMatch = type.match($ba36d6bb061599e8$export$45902cc189596eef);
        if (intMatch) {
            const [_type, baseType, bits = "256"] = intMatch;
            const size = Number.parseInt(bits) / 8;
            return $cd0f3b7c2a282c5d$export$7bbb4164c9a77bc2(value, {
                size: isArray ? 32 : size,
                signed: baseType === "int"
            });
        }
        const bytesMatch = type.match($ba36d6bb061599e8$export$94d7303c0d9f263a);
        if (bytesMatch) {
            const [_type, size] = bytesMatch;
            if (Number.parseInt(size) !== (value.length - 2) / 2) throw new $ed1c7de70afe5565$export$a0eb884ede5c87eb({
                expectedSize: Number.parseInt(size),
                value: value
            });
            return $cd0f3b7c2a282c5d$export$7e24a29324041c48(value, isArray ? 32 : 0);
        }
        const arrayMatch = type.match($ba36d6bb061599e8$export$6cd562aaf6380f0e);
        if (arrayMatch && Array.isArray(value)) {
            const [_type, childType] = arrayMatch;
            const data = [];
            for(let i = 0; i < value.length; i++)data.push(encode(childType, value[i], true));
            if (data.length === 0) return "0x";
            return $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22(...data);
        }
        throw new $ed1c7de70afe5565$export$2d4818a25c0cc775(type);
    }
    encodePacked.encode = encode;
})($ed1c7de70afe5565$export$92dace262a9f3722 || ($ed1c7de70afe5565$export$92dace262a9f3722 = {}));
function $ed1c7de70afe5565$export$d9468344d3651243(parameters) {
    return $41jdK.formatAbiParameters(parameters);
}
function $ed1c7de70afe5565$export$6788812c4e6611e6(parameters) {
    if (Array.isArray(parameters) && typeof parameters[0] === "string") return $4087c0747b288446$export$660dc560f0dcce7a(parameters);
    if (typeof parameters === "string") return $4087c0747b288446$export$660dc560f0dcce7a(parameters);
    return parameters;
}
class $ed1c7de70afe5565$export$ed7a66fc0baa3ad2 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ data: data, parameters: parameters, size: size }){
        super(`Data size of ${size} bytes is too small for given parameters.`, {
            metaMessages: [
                `Params: (${$41jdK.formatAbiParameters(parameters)})`,
                `Data:   ${data} (${size} bytes)`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiParameters.DataSizeTooSmallError"
        });
    }
}
class $ed1c7de70afe5565$export$b8eb32bc991c805c extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.');
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiParameters.ZeroDataError"
        });
    }
}
class $ed1c7de70afe5565$export$1b8b2e17cbff9b06 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super(`Array length mismatch for type \`${type}\`. Expected: \`${expectedLength}\`. Given: \`${givenLength}\`.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiParameters.ArrayLengthMismatchError"
        });
    }
}
class $ed1c7de70afe5565$export$a0eb884ede5c87eb extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${$cd0f3b7c2a282c5d$export$346677f925de839c(value)}) does not match expected size (bytes${expectedSize}).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiParameters.BytesSizeMismatchError"
        });
    }
}
class $ed1c7de70afe5565$export$c4bef8d61dd517cb extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            "ABI encoding parameters/values length mismatch.",
            `Expected length (parameters): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiParameters.LengthMismatchError"
        });
    }
}
class $ed1c7de70afe5565$export$710dd6d4f78cc47e extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(value){
        super(`Value \`${value}\` is not a valid array.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiParameters.InvalidArrayError"
        });
    }
}
class $ed1c7de70afe5565$export$2d4818a25c0cc775 extends $c35f34add7b31ecb$export$a490eb03cb7a0a5e {
    constructor(type){
        super(`Type \`${type}\` is not a valid ABI Type.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiParameters.InvalidTypeError"
        });
    }
}



function $003dc6794a66605a$export$2f872c0f2117be69(abiConstructor, options) {
    const { bytecode: bytecode } = options;
    if (abiConstructor.inputs.length === 0) return undefined;
    const data = options.data.replace(bytecode, "0x");
    return $ed1c7de70afe5565$export$2f872c0f2117be69(abiConstructor.inputs, data);
}
function $003dc6794a66605a$export$c564cdbbe6da493(abiConstructor, options) {
    const { bytecode: bytecode, args: args } = options;
    return $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22(bytecode, abiConstructor.inputs?.length && args?.length ? $ed1c7de70afe5565$export$c564cdbbe6da493(abiConstructor.inputs, args) : "0x");
}
function $003dc6794a66605a$export$d9468344d3651243(abiConstructor) {
    return $l2jn0.formatAbiItem(abiConstructor);
}
function $003dc6794a66605a$export$6788812c4e6611e6(abiConstructor) {
    return $db9f9dea108fef3b$export$6788812c4e6611e6(abiConstructor);
}
function $003dc6794a66605a$export$5b3993ebf09c61b9(abi) {
    const item = abi.find((item)=>item.type === "constructor");
    if (!item) throw new $db9f9dea108fef3b$export$78c95b58762d2106({
        name: "constructor"
    });
    return item;
}



var $l2jn0 = parcelRequire("l2jn0");



function $c4f3dd911c2e06f4$export$13923bea59211b58(abiFunction, data) {
    const { overloads: overloads } = abiFunction;
    if ($cd0f3b7c2a282c5d$export$346677f925de839c(data) < 4) throw new $db9f9dea108fef3b$export$8a0357024884084b({
        data: data
    });
    if (abiFunction.inputs.length === 0) return undefined;
    const item = overloads ? $c4f3dd911c2e06f4$export$5b3993ebf09c61b9([
        abiFunction,
        ...overloads
    ], data) : abiFunction;
    if ($cd0f3b7c2a282c5d$export$346677f925de839c(data) <= 4) return undefined;
    return $ed1c7de70afe5565$export$2f872c0f2117be69(item.inputs, $cd0f3b7c2a282c5d$export$58adb3bec8346d0f(data, 4));
}
function $c4f3dd911c2e06f4$export$6045791062ddb371(abiFunction, data, options = {}) {
    const values = $ed1c7de70afe5565$export$2f872c0f2117be69(abiFunction.outputs, data, options);
    if (values && Object.keys(values).length === 0) return undefined;
    if (values && Object.keys(values).length === 1) {
        if (Array.isArray(values)) return values[0];
        return Object.values(values)[0];
    }
    return values;
}
function $c4f3dd911c2e06f4$export$cfdd1f2478131e3d(abiFunction, ...args) {
    const { overloads: overloads } = abiFunction;
    const item = overloads ? $c4f3dd911c2e06f4$export$5b3993ebf09c61b9([
        abiFunction,
        ...overloads
    ], abiFunction.name, {
        args: args[0]
    }) : abiFunction;
    const selector = $c4f3dd911c2e06f4$export$319b9bd79cec4634(item);
    const data = args.length > 0 ? $ed1c7de70afe5565$export$c564cdbbe6da493(item.inputs, args[0]) : undefined;
    return data ? $cd0f3b7c2a282c5d$export$ee1b3e54f0441b22(selector, data) : selector;
}
function $c4f3dd911c2e06f4$export$863f1296c7a42ceb(abiFunction, output, options = {}) {
    const { as: as = "Array" } = options;
    const values = (()=>{
        if (abiFunction.outputs.length === 1) return [
            output
        ];
        if (Array.isArray(output)) return output;
        if (as === "Object") return Object.values(output);
        return [
            output
        ];
    })();
    return $ed1c7de70afe5565$export$c564cdbbe6da493(abiFunction.outputs, values);
}
function $c4f3dd911c2e06f4$export$d9468344d3651243(abiFunction) {
    return $l2jn0.formatAbiItem(abiFunction);
}
function $c4f3dd911c2e06f4$export$6788812c4e6611e6(abiFunction, options = {}) {
    return $db9f9dea108fef3b$export$6788812c4e6611e6(abiFunction, options);
}
function $c4f3dd911c2e06f4$export$5b3993ebf09c61b9(abi, name, options) {
    const item = $db9f9dea108fef3b$export$5b3993ebf09c61b9(abi, name, options);
    if (item.type !== "function") throw new $db9f9dea108fef3b$export$78c95b58762d2106({
        name: name,
        type: "function"
    });
    return item;
}
function $c4f3dd911c2e06f4$export$319b9bd79cec4634(abiItem) {
    return $db9f9dea108fef3b$export$319b9bd79cec4634(abiItem);
}



var $gbEG8 = parcelRequire("gbEG8");
const $7e5a5d7899cb44ca$export$5eed9fe1d9a721c3 = "0x5FF137D4b0FDCD49DcA30c7CF57E578a026d2789";
const $7e5a5d7899cb44ca$export$3c75833c58f8ce2e = "0x0000000071727De22E5E9d8BAf0edAc6f37da032";
const $7e5a5d7899cb44ca$export$a226f0eb19240a1 = "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee";
const $7e5a5d7899cb44ca$export$3b38e8424a783fc9 = "0x0000000000000000000000000000000000000000";



var $6agEo = parcelRequire("6agEo");

var $cahqm = parcelRequire("cahqm");

var $aYJZ1 = parcelRequire("aYJZ1");

var $9GGVO = parcelRequire("9GGVO");


const $3c0e85c25f2baa58$var$getBalanceCode = "0x6080604052348015600e575f80fd5b5061016d8061001c5f395ff3fe608060405234801561000f575f80fd5b5060043610610029575f3560e01c8063f8b2cb4f1461002d575b5f80fd5b610047600480360381019061004291906100db565b61005d565b604051610054919061011e565b60405180910390f35b5f8173ffffffffffffffffffffffffffffffffffffffff16319050919050565b5f80fd5b5f73ffffffffffffffffffffffffffffffffffffffff82169050919050565b5f6100aa82610081565b9050919050565b6100ba816100a0565b81146100c4575f80fd5b50565b5f813590506100d5816100b1565b92915050565b5f602082840312156100f0576100ef61007d565b5b5f6100fd848285016100c7565b91505092915050565b5f819050919050565b61011881610106565b82525050565b5f6020820190506101315f83018461010f565b9291505056fea26469706673582212203b9fe929fe995c7cf9887f0bdba8a36dd78e8b73f149b17d2d9ad7cd09d2dc6264736f6c634300081a0033";
async function $3c0e85c25f2baa58$export$bc4cac5ece13b6fb(client, parameters) {
    const { blockNumber: blockNumber, blockTag: blockTag, calls: calls, stateOverrides: stateOverrides, traceAssetChanges: traceAssetChanges, traceTransfers: traceTransfers, validation: validation } = parameters;
    const account = parameters.account ? (0, $gbEG8.parseAccount)(parameters.account) : undefined;
    if (traceAssetChanges && !account) throw new (0, $cahqm.BaseError)("`account` is required when `traceAssetChanges` is true");
    // Derive bytecode to extract ETH balance via a contract call.
    const getBalanceData = account ? $003dc6794a66605a$export$c564cdbbe6da493($003dc6794a66605a$export$6788812c4e6611e6("constructor(bytes, bytes)"), {
        bytecode: (0, $6agEo.deploylessCallViaBytecodeBytecode),
        args: [
            $3c0e85c25f2baa58$var$getBalanceCode,
            $c4f3dd911c2e06f4$export$cfdd1f2478131e3d($c4f3dd911c2e06f4$export$6788812c4e6611e6("function getBalance(address)"), [
                account.address
            ])
        ]
    }) : undefined;
    // Fetch ERC20/721 addresses that were "touched" from the calls.
    const assetAddresses = traceAssetChanges ? await Promise.all(parameters.calls.map(async (call)=>{
        if (!call.data && !call.abi) return;
        const { accessList: accessList } = await (0, $edfa88d98346bb5d$export$db8bba598ef289f1)(client, {
            account: account.address,
            ...call,
            data: call.abi ? (0, $aYJZ1.encodeFunctionData)(call) : call.data
        });
        return accessList.map(({ address: address, storageKeys: storageKeys })=>storageKeys.length > 0 ? address : null);
    })).then((x)=>x.flat().filter(Boolean)) : [];
    const resultsStateOverrides = stateOverrides?.map((override)=>{
        if (override.address === account?.address) return {
            ...override,
            nonce: 0
        };
        return override;
    });
    const blocks = await (0, $894419aadf34fa74$export$d7b183d4eabb187b)(client, {
        blockNumber: blockNumber,
        blockTag: blockTag,
        blocks: [
            ...traceAssetChanges ? [
                // ETH pre balances
                {
                    calls: [
                        {
                            data: getBalanceData
                        }
                    ],
                    stateOverrides: stateOverrides
                },
                // Asset pre balances
                {
                    calls: assetAddresses.map((address, i)=>({
                            abi: [
                                $c4f3dd911c2e06f4$export$6788812c4e6611e6("function balanceOf(address) returns (uint256)")
                            ],
                            functionName: "balanceOf",
                            args: [
                                account.address
                            ],
                            to: address,
                            from: (0, $7e5a5d7899cb44ca$export$3b38e8424a783fc9),
                            nonce: i
                        })),
                    stateOverrides: [
                        {
                            address: (0, $7e5a5d7899cb44ca$export$3b38e8424a783fc9),
                            nonce: 0
                        }
                    ]
                }
            ] : [],
            {
                calls: [
                    ...calls,
                    {}
                ].map((call, index)=>({
                        ...call,
                        from: account?.address,
                        nonce: index
                    })),
                stateOverrides: resultsStateOverrides
            },
            ...traceAssetChanges ? [
                // ETH post balances
                {
                    calls: [
                        {
                            data: getBalanceData
                        }
                    ]
                },
                // Asset post balances
                {
                    calls: assetAddresses.map((address, i)=>({
                            abi: [
                                $c4f3dd911c2e06f4$export$6788812c4e6611e6("function balanceOf(address) returns (uint256)")
                            ],
                            functionName: "balanceOf",
                            args: [
                                account.address
                            ],
                            to: address,
                            from: (0, $7e5a5d7899cb44ca$export$3b38e8424a783fc9),
                            nonce: i
                        })),
                    stateOverrides: [
                        {
                            address: (0, $7e5a5d7899cb44ca$export$3b38e8424a783fc9),
                            nonce: 0
                        }
                    ]
                },
                // Decimals
                {
                    calls: assetAddresses.map((address, i)=>({
                            to: address,
                            abi: [
                                $c4f3dd911c2e06f4$export$6788812c4e6611e6("function decimals() returns (uint256)")
                            ],
                            functionName: "decimals",
                            from: (0, $7e5a5d7899cb44ca$export$3b38e8424a783fc9),
                            nonce: i
                        })),
                    stateOverrides: [
                        {
                            address: (0, $7e5a5d7899cb44ca$export$3b38e8424a783fc9),
                            nonce: 0
                        }
                    ]
                },
                // Token URI
                {
                    calls: assetAddresses.map((address, i)=>({
                            to: address,
                            abi: [
                                $c4f3dd911c2e06f4$export$6788812c4e6611e6("function tokenURI(uint256) returns (string)")
                            ],
                            functionName: "tokenURI",
                            args: [
                                0n
                            ],
                            from: (0, $7e5a5d7899cb44ca$export$3b38e8424a783fc9),
                            nonce: i
                        })),
                    stateOverrides: [
                        {
                            address: (0, $7e5a5d7899cb44ca$export$3b38e8424a783fc9),
                            nonce: 0
                        }
                    ]
                },
                // Symbols
                {
                    calls: assetAddresses.map((address, i)=>({
                            to: address,
                            abi: [
                                $c4f3dd911c2e06f4$export$6788812c4e6611e6("function symbol() returns (string)")
                            ],
                            functionName: "symbol",
                            from: (0, $7e5a5d7899cb44ca$export$3b38e8424a783fc9),
                            nonce: i
                        })),
                    stateOverrides: [
                        {
                            address: (0, $7e5a5d7899cb44ca$export$3b38e8424a783fc9),
                            nonce: 0
                        }
                    ]
                }
            ] : []
        ],
        traceTransfers: traceTransfers,
        validation: validation
    });
    const block_results = traceAssetChanges ? blocks[2] : blocks[0];
    const [block_ethPre, block_assetsPre, , block_ethPost, block_assetsPost, block_decimals, block_tokenURI, block_symbols] = traceAssetChanges ? blocks : [];
    // Extract call results from the simulation.
    const { calls: block_calls, ...block } = block_results;
    const results = block_calls.slice(0, -1) ?? [];
    // Extract pre-execution ETH and asset balances.
    const ethPre = block_ethPre?.calls ?? [];
    const assetsPre = block_assetsPre?.calls ?? [];
    const balancesPre = [
        ...ethPre,
        ...assetsPre
    ].map((call)=>call.status === "success" ? (0, $9GGVO.hexToBigInt)(call.data) : null);
    // Extract post-execution ETH and asset balances.
    const ethPost = block_ethPost?.calls ?? [];
    const assetsPost = block_assetsPost?.calls ?? [];
    const balancesPost = [
        ...ethPost,
        ...assetsPost
    ].map((call)=>call.status === "success" ? (0, $9GGVO.hexToBigInt)(call.data) : null);
    // Extract asset symbols & decimals.
    const decimals = (block_decimals?.calls ?? []).map((x)=>x.status === "success" ? x.result : null);
    const symbols = (block_symbols?.calls ?? []).map((x)=>x.status === "success" ? x.result : null);
    const tokenURI = (block_tokenURI?.calls ?? []).map((x)=>x.status === "success" ? x.result : null);
    const changes = [];
    for (const [i, balancePost] of balancesPost.entries()){
        const balancePre = balancesPre[i];
        if (typeof balancePost !== "bigint") continue;
        if (typeof balancePre !== "bigint") continue;
        const decimals_ = decimals[i - 1];
        const symbol_ = symbols[i - 1];
        const tokenURI_ = tokenURI[i - 1];
        const token = (()=>{
            if (i === 0) return {
                address: (0, $7e5a5d7899cb44ca$export$a226f0eb19240a1),
                decimals: 18,
                symbol: "ETH"
            };
            return {
                address: assetAddresses[i - 1],
                decimals: tokenURI_ || decimals_ ? Number(decimals_ ?? 1) : undefined,
                symbol: symbol_ ?? undefined
            };
        })();
        if (changes.some((change)=>change.token.address === token.address)) continue;
        changes.push({
            token: token,
            value: {
                pre: balancePre,
                post: balancePost,
                diff: balancePost - balancePre
            }
        });
    }
    return {
        assetChanges: changes,
        block: block,
        results: results
    };
}



var $gbEG8 = parcelRequire("gbEG8");

var $dzDwb = parcelRequire("dzDwb");

var $aYJZ1 = parcelRequire("aYJZ1");



var $cjGvc = parcelRequire("cjGvc");
async function $dfc06fbd396ee9a5$export$e8798d551e27a374(client, parameters) {
    const { abi: abi, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...callRequest } = parameters;
    const account = callRequest.account ? (0, $gbEG8.parseAccount)(callRequest.account) : client.account;
    const calldata = (0, $aYJZ1.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $cjGvc.call), "call")({
            batch: false,
            data: `${calldata}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
            to: address,
            ...callRequest,
            account: account
        });
        const result = (0, $dzDwb.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
        const minimizedAbi = abi.filter((abiItem)=>"name" in abiItem && abiItem.name === parameters.functionName);
        return {
            result: result,
            request: {
                abi: minimizedAbi,
                address: address,
                args: args,
                dataSuffix: dataSuffix,
                functionName: functionName,
                ...callRequest,
                account: account
            }
        };
    } catch (error) {
        throw (0, $768c9bcff606843b$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/simulateContract",
            functionName: functionName,
            sender: account?.address
        });
    }
}


/**
 * Destroys a [`Filter`](https://viem.sh/docs/glossary/types#filter).
 *
 * - Docs: https://viem.sh/docs/actions/public/uninstallFilter
 * - JSON-RPC Methods: [`eth_uninstallFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_uninstallFilter)
 *
 * Destroys a Filter that was created from one of the following Actions:
 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter)
 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter)
 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter)
 *
 * @param client - Client to use
 * @param parameters - {@link UninstallFilterParameters}
 * @returns A boolean indicating if the Filter was successfully uninstalled. {@link UninstallFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createPendingTransactionFilter, uninstallFilter } from 'viem/public'
 *
 * const filter = await createPendingTransactionFilter(client)
 * const uninstalled = await uninstallFilter(client, { filter })
 * // true
 */ async function $05f0215b061dbadf$export$54eb7d691768f7f3(_client, { filter: filter }) {
    return filter.request({
        method: "eth_uninstallFilter",
        params: [
            filter.id
        ]
    });
}



var $diQni = parcelRequire("diQni");
const $6265a07e68ee15c5$export$39d5d904b514ff63 = "\x19Ethereum Signed Message:\n";



var $jnwfF = parcelRequire("jnwfF");

var $lsLGO = parcelRequire("lsLGO");

var $jW8ut = parcelRequire("jW8ut");
function $1d099fd6332c7799$export$6c55de89b570d8ea(message_) {
    const message = (()=>{
        if (typeof message_ === "string") return (0, $jW8ut.stringToHex)(message_);
        if (typeof message_.raw === "string") return message_.raw;
        return (0, $jW8ut.bytesToHex)(message_.raw);
    })();
    const prefix = (0, $jW8ut.stringToHex)(`${(0, $6265a07e68ee15c5$export$39d5d904b514ff63)}${(0, $lsLGO.size)(message)}`);
    return (0, $jnwfF.concat)([
        prefix,
        message
    ]);
}


function $714e08c9e5517ec5$export$d4c241cec96564c1(message, to_) {
    return (0, $diQni.keccak256)((0, $1d099fd6332c7799$export$6c55de89b570d8ea)(message), to_);
}



var $6Dftn = parcelRequire("6Dftn");

var $6agEo = parcelRequire("6agEo");

var $hfefF = parcelRequire("hfefF");

var $fUU8L = parcelRequire("fUU8L");

var $siouQ = parcelRequire("siouQ");

var $13kYf = parcelRequire("13kYf");

var $16Qvp = parcelRequire("16Qvp");

var $jW8ut = parcelRequire("jW8ut");


var $aYJZ1 = parcelRequire("aYJZ1");
var $9GGVO = parcelRequire("9GGVO");
const $6ebac279083dcd57$export$8511286dc8754b90 = "0x6492649264926492649264926492649264926492649264926492649264926492";
const $6ebac279083dcd57$export$2f840586fca04b0e = "0x0000000000000000000000000000000000000000000000000000000000000000";



var $fdb51 = parcelRequire("fdb51");
function $5e489167c29064a9$export$3d72f97f1f04bf61(signature) {
    return (0, $fdb51.sliceHex)(signature, -32) === (0, $6ebac279083dcd57$export$8511286dc8754b90);
}



var $jN5Zi = parcelRequire("jN5Zi");


var $hxvKS = parcelRequire("hxvKS");

var $jnwfF = parcelRequire("jnwfF");

var $cY7Yq = parcelRequire("cY7Yq");
function $b195d23446040b42$export$950b6c77371336fb(parameters) {
    const { address: address, data: data, signature: signature, to: to = "hex" } = parameters;
    const signature_ = (0, $jnwfF.concatHex)([
        (0, $hxvKS.encodeAbiParameters)([
            {
                type: "address"
            },
            {
                type: "bytes"
            },
            {
                type: "bytes"
            }
        ], [
            address,
            data,
            signature
        ]),
        (0, $6ebac279083dcd57$export$8511286dc8754b90)
    ]);
    if (to === "hex") return signature_;
    return (0, $cY7Yq.hexToBytes)(signature_);
}



var $1qSNR = parcelRequire("1qSNR");

var $9GGVO = parcelRequire("9GGVO");

var $cY7Yq = parcelRequire("cY7Yq");
function $82672c2756dadd8f$export$97951e8415c34ee5({ r: r, s: s, to: to = "hex", v: v, yParity: yParity }) {
    const yParity_ = (()=>{
        if (yParity === 0 || yParity === 1) return yParity;
        if (v && (v === 27n || v === 28n || v >= 35n)) return v % 2n === 0n ? 1 : 0;
        throw new Error("Invalid `v` or `yParity` value");
    })();
    const signature = `0x${new (0, $1qSNR.secp256k1).Signature((0, $9GGVO.hexToBigInt)(r), (0, $9GGVO.hexToBigInt)(s)).toCompactHex()}${yParity_ === 0 ? "1b" : "1c"}`;
    if (to === "hex") return signature;
    return (0, $cY7Yq.hexToBytes)(signature);
}



var $cjGvc = parcelRequire("cjGvc");
async function $5c7c89ce557d9fce$export$434ee6408013d7f2(client, parameters) {
    const { address: address, factory: factory, factoryData: factoryData, hash: hash, signature: signature, universalSignatureVerifierAddress: universalSignatureVerifierAddress = client.chain?.contracts?.universalSignatureVerifier?.address, ...rest } = parameters;
    const signatureHex = (()=>{
        if ((0, $16Qvp.isHex)(signature)) return signature;
        if (typeof signature === "object" && "r" in signature && "s" in signature) return (0, $82672c2756dadd8f$export$97951e8415c34ee5)(signature);
        return (0, $jW8ut.bytesToHex)(signature);
    })();
    const wrappedSignature = await (async ()=>{
        // If no `factory` or `factoryData` is provided, it is assumed that the
        // address is not a Smart Account, or the Smart Account is already deployed.
        if (!factory && !factoryData) return signatureHex;
        // If the signature is already wrapped, return the signature.
        if ((0, $5e489167c29064a9$export$3d72f97f1f04bf61)(signatureHex)) return signatureHex;
        // If the Smart Account is not deployed, wrap the signature with a 6492 wrapper
        // to perform counterfactual validation.
        return (0, $b195d23446040b42$export$950b6c77371336fb)({
            address: factory,
            data: factoryData,
            signature: signatureHex
        });
    })();
    try {
        const args = universalSignatureVerifierAddress ? {
            to: universalSignatureVerifierAddress,
            data: (0, $aYJZ1.encodeFunctionData)({
                abi: (0, $6Dftn.universalSignatureValidatorAbi),
                functionName: "isValidSig",
                args: [
                    address,
                    hash,
                    wrappedSignature
                ]
            }),
            ...rest
        } : {
            data: (0, $fUU8L.encodeDeployData)({
                abi: (0, $6Dftn.universalSignatureValidatorAbi),
                args: [
                    address,
                    hash,
                    wrappedSignature
                ],
                bytecode: (0, $6agEo.universalSignatureValidatorByteCode)
            }),
            ...rest
        };
        const { data: data } = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $cjGvc.call), "call")(args);
        return (0, $9GGVO.hexToBool)(data ?? "0x0");
    } catch (error) {
        // Fallback attempt to verify the signature via ECDSA recovery.
        try {
            const verified = (0, $13kYf.isAddressEqual)((0, $siouQ.getAddress)(address), await (0, $jN5Zi.recoverAddress)({
                hash: hash,
                signature: signature
            }));
            if (verified) return true;
        } catch  {}
        if (error instanceof (0, $hfefF.CallExecutionError)) // if the execution fails, the signature was not valid and an internal method inside of the validator reverted
        // this can happen for many reasons, for example if signer can not be recovered from the signature
        // or if the signature has no valid format
        return false;
        throw error;
    }
}


async function $8273d2017c3d10ce$export$228d0e772cc158cb(client, { address: address, message: message, factory: factory, factoryData: factoryData, signature: signature, ...callRequest }) {
    const hash = (0, $714e08c9e5517ec5$export$d4c241cec96564c1)(message);
    return (0, $5c7c89ce557d9fce$export$434ee6408013d7f2)(client, {
        address: address,
        factory: factory,
        factoryData: factoryData,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}


// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts

var $hxvKS = parcelRequire("hxvKS");

var $jnwfF = parcelRequire("jnwfF");

var $jW8ut = parcelRequire("jW8ut");

var $diQni = parcelRequire("diQni");

var $8p1we = parcelRequire("8p1we");

var $62VqX = parcelRequire("62VqX");

var $6fuj2 = parcelRequire("6fuj2");

var $cahqm = parcelRequire("cahqm");
class $b0aa4b79df1b6ec3$export$2f1f6ca5fa8229f7 extends (0, $cahqm.BaseError) {
    constructor({ domain: domain }){
        super(`Invalid domain "${(0, $6fuj2.stringify)(domain)}".`, {
            metaMessages: [
                "Must be a valid EIP-712 domain."
            ]
        });
    }
}
class $b0aa4b79df1b6ec3$export$7417b0e1e11c4de0 extends (0, $cahqm.BaseError) {
    constructor({ primaryType: primaryType, types: types }){
        super(`Invalid primary type \`${primaryType}\` must be one of \`${JSON.stringify(Object.keys(types))}\`.`, {
            docsPath: "/api/glossary/Errors#typeddatainvalidprimarytypeerror",
            metaMessages: [
                "Check that the primary type is a key in `types`."
            ]
        });
    }
}
class $b0aa4b79df1b6ec3$export$f3b7c25eb573510a extends (0, $cahqm.BaseError) {
    constructor({ type: type }){
        super(`Struct type "${type}" is invalid.`, {
            metaMessages: [
                "Struct type must not be a Solidity type."
            ],
            name: "InvalidStructTypeError"
        });
    }
}



var $8Ghey = parcelRequire("8Ghey");

var $lsLGO = parcelRequire("lsLGO");

var $jW8ut = parcelRequire("jW8ut");

var $8x9TH = parcelRequire("8x9TH");


var $6fuj2 = parcelRequire("6fuj2");
function $a7b6842215f4b8bd$export$ce8e1cf733064451(parameters) {
    const { domain: domain_, message: message_, primaryType: primaryType, types: types } = parameters;
    const normalizeData = (struct, data_)=>{
        const data = {
            ...data_
        };
        for (const param of struct){
            const { name: name, type: type } = param;
            if (type === "address") data[name] = data[name].toLowerCase();
        }
        return data;
    };
    const domain = (()=>{
        if (!types.EIP712Domain) return {};
        if (!domain_) return {};
        return normalizeData(types.EIP712Domain, domain_);
    })();
    const message = (()=>{
        if (primaryType === "EIP712Domain") return undefined;
        return normalizeData(types[primaryType], message_);
    })();
    return (0, $6fuj2.stringify)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
}
function $a7b6842215f4b8bd$export$fac174f558903e26(parameters) {
    const { domain: domain, message: message, primaryType: primaryType, types: types } = parameters;
    const validateData = (struct, data)=>{
        for (const param of struct){
            const { name: name, type: type } = param;
            const value = data[name];
            const integerMatch = type.match((0, $8x9TH.integerRegex));
            if (integerMatch && (typeof value === "number" || typeof value === "bigint")) {
                const [_type, base, size_] = integerMatch;
                // If number cannot be cast to a sized hex value, it is out of range
                // and will throw.
                (0, $jW8ut.numberToHex)(value, {
                    signed: base === "int",
                    size: Number.parseInt(size_) / 8
                });
            }
            if (type === "address" && typeof value === "string" && !(0, $8Ghey.isAddress)(value)) throw new (0, $62VqX.InvalidAddressError)({
                address: value
            });
            const bytesMatch = type.match((0, $8x9TH.bytesRegex));
            if (bytesMatch) {
                const [_type, size_] = bytesMatch;
                if (size_ && (0, $lsLGO.size)(value) !== Number.parseInt(size_)) throw new (0, $8p1we.BytesSizeMismatchError)({
                    expectedSize: Number.parseInt(size_),
                    givenSize: (0, $lsLGO.size)(value)
                });
            }
            const struct = types[type];
            if (struct) {
                $a7b6842215f4b8bd$var$validateReference(type);
                validateData(struct, value);
            }
        }
    };
    // Validate domain types.
    if (types.EIP712Domain && domain) {
        if (typeof domain !== "object") throw new (0, $b0aa4b79df1b6ec3$export$2f1f6ca5fa8229f7)({
            domain: domain
        });
        validateData(types.EIP712Domain, domain);
    }
    // Validate message types.
    if (primaryType !== "EIP712Domain") {
        if (types[primaryType]) validateData(types[primaryType], message);
        else throw new (0, $b0aa4b79df1b6ec3$export$7417b0e1e11c4de0)({
            primaryType: primaryType,
            types: types
        });
    }
}
function $a7b6842215f4b8bd$export$6a292159484ee032({ domain: domain }) {
    return [
        typeof domain?.name === "string" && {
            name: "name",
            type: "string"
        },
        domain?.version && {
            name: "version",
            type: "string"
        },
        (typeof domain?.chainId === "number" || typeof domain?.chainId === "bigint") && {
            name: "chainId",
            type: "uint256"
        },
        domain?.verifyingContract && {
            name: "verifyingContract",
            type: "address"
        },
        domain?.salt && {
            name: "salt",
            type: "bytes32"
        }
    ].filter(Boolean);
}
function $a7b6842215f4b8bd$export$a1ffff851efcaaba({ domain: domain }) {
    return (0, $4428a0d5d5e9f7b0$export$d4e887b08c47faea)({
        domain: domain,
        types: {
            EIP712Domain: $a7b6842215f4b8bd$export$6a292159484ee032({
                domain: domain
            })
        }
    });
}
/** @internal */ function $a7b6842215f4b8bd$var$validateReference(type) {
    // Struct type must not be a Solidity type.
    if (type === "address" || type === "bool" || type === "string" || type.startsWith("bytes") || type.startsWith("uint") || type.startsWith("int")) throw new (0, $b0aa4b79df1b6ec3$export$f3b7c25eb573510a)({
        type: type
    });
}


function $4428a0d5d5e9f7b0$export$9e2bd399d9aaab56(parameters) {
    const { domain: domain = {}, message: message, primaryType: primaryType } = parameters;
    const types = {
        EIP712Domain: (0, $a7b6842215f4b8bd$export$6a292159484ee032)({
            domain: domain
        }),
        ...parameters.types
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $a7b6842215f4b8bd$export$fac174f558903e26)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const parts = [
        "0x1901"
    ];
    if (domain) parts.push($4428a0d5d5e9f7b0$export$d4e887b08c47faea({
        domain: domain,
        types: types
    }));
    if (primaryType !== "EIP712Domain") parts.push($4428a0d5d5e9f7b0$export$4b8f67c208624fdf({
        data: message,
        primaryType: primaryType,
        types: types
    }));
    return (0, $diQni.keccak256)((0, $jnwfF.concat)(parts));
}
function $4428a0d5d5e9f7b0$export$d4e887b08c47faea({ domain: domain, types: types }) {
    return $4428a0d5d5e9f7b0$export$4b8f67c208624fdf({
        data: domain,
        primaryType: "EIP712Domain",
        types: types
    });
}
function $4428a0d5d5e9f7b0$export$4b8f67c208624fdf({ data: data, primaryType: primaryType, types: types }) {
    const encoded = $4428a0d5d5e9f7b0$var$encodeData({
        data: data,
        primaryType: primaryType,
        types: types
    });
    return (0, $diQni.keccak256)(encoded);
}
function $4428a0d5d5e9f7b0$var$encodeData({ data: data, primaryType: primaryType, types: types }) {
    const encodedTypes = [
        {
            type: "bytes32"
        }
    ];
    const encodedValues = [
        $4428a0d5d5e9f7b0$var$hashType({
            primaryType: primaryType,
            types: types
        })
    ];
    for (const field of types[primaryType]){
        const [type, value] = $4428a0d5d5e9f7b0$var$encodeField({
            types: types,
            name: field.name,
            type: field.type,
            value: data[field.name]
        });
        encodedTypes.push(type);
        encodedValues.push(value);
    }
    return (0, $hxvKS.encodeAbiParameters)(encodedTypes, encodedValues);
}
function $4428a0d5d5e9f7b0$var$hashType({ primaryType: primaryType, types: types }) {
    const encodedHashType = (0, $jW8ut.toHex)($4428a0d5d5e9f7b0$export$432cbecf661dce2b({
        primaryType: primaryType,
        types: types
    }));
    return (0, $diQni.keccak256)(encodedHashType);
}
function $4428a0d5d5e9f7b0$export$432cbecf661dce2b({ primaryType: primaryType, types: types }) {
    let result = "";
    const unsortedDeps = $4428a0d5d5e9f7b0$var$findTypeDependencies({
        primaryType: primaryType,
        types: types
    });
    unsortedDeps.delete(primaryType);
    const deps = [
        primaryType,
        ...Array.from(unsortedDeps).sort()
    ];
    for (const type of deps)result += `${type}(${types[type].map(({ name: name, type: t })=>`${t} ${name}`).join(",")})`;
    return result;
}
function $4428a0d5d5e9f7b0$var$findTypeDependencies({ primaryType: primaryType_, types: types }, results = new Set()) {
    const match = primaryType_.match(/^\w*/u);
    const primaryType = match?.[0];
    if (results.has(primaryType) || types[primaryType] === undefined) return results;
    results.add(primaryType);
    for (const field of types[primaryType])$4428a0d5d5e9f7b0$var$findTypeDependencies({
        primaryType: field.type,
        types: types
    }, results);
    return results;
}
function $4428a0d5d5e9f7b0$var$encodeField({ types: types, name: name, type: type, value: value }) {
    if (types[type] !== undefined) return [
        {
            type: "bytes32"
        },
        (0, $diQni.keccak256)($4428a0d5d5e9f7b0$var$encodeData({
            data: value,
            primaryType: type,
            types: types
        }))
    ];
    if (type === "bytes") {
        const prepend = value.length % 2 ? "0" : "";
        value = `0x${prepend + value.slice(2)}`;
        return [
            {
                type: "bytes32"
            },
            (0, $diQni.keccak256)(value)
        ];
    }
    if (type === "string") return [
        {
            type: "bytes32"
        },
        (0, $diQni.keccak256)((0, $jW8ut.toHex)(value))
    ];
    if (type.lastIndexOf("]") === type.length - 1) {
        const parsedType = type.slice(0, type.lastIndexOf("["));
        const typeValuePairs = value.map((item)=>$4428a0d5d5e9f7b0$var$encodeField({
                name: name,
                type: parsedType,
                types: types,
                value: item
            }));
        return [
            {
                type: "bytes32"
            },
            (0, $diQni.keccak256)((0, $hxvKS.encodeAbiParameters)(typeValuePairs.map(([t])=>t), typeValuePairs.map(([, v])=>v)))
        ];
    }
    return [
        {
            type: type
        },
        value
    ];
}



async function $a73108b664069fa3$export$3603b1c1bcd76798(client, parameters) {
    const { address: address, factory: factory, factoryData: factoryData, signature: signature, message: message, primaryType: primaryType, types: types, domain: domain, ...callRequest } = parameters;
    const hash = (0, $4428a0d5d5e9f7b0$export$9e2bd399d9aaab56)({
        message: message,
        primaryType: primaryType,
        types: types,
        domain: domain
    });
    return (0, $5c7c89ce557d9fce$export$434ee6408013d7f2)(client, {
        address: address,
        factory: factory,
        factoryData: factoryData,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}




var $3a3vr = parcelRequire("3a3vr");

/** @internal */ const $74f22d1bc7fc1517$export$94ab3a05cb07971d = /*#__PURE__*/ new Map();
const $74f22d1bc7fc1517$export$b4a4aba7c5f97c17 = /*#__PURE__*/ new Map();
let $74f22d1bc7fc1517$var$callbackCount = 0;
function $74f22d1bc7fc1517$export$d1203567a167490e(observerId, callbacks, fn) {
    const callbackId = ++$74f22d1bc7fc1517$var$callbackCount;
    const getListeners = ()=>$74f22d1bc7fc1517$export$94ab3a05cb07971d.get(observerId) || [];
    const unsubscribe = ()=>{
        const listeners = getListeners();
        $74f22d1bc7fc1517$export$94ab3a05cb07971d.set(observerId, listeners.filter((cb)=>cb.id !== callbackId));
    };
    const unwatch = ()=>{
        const listeners = getListeners();
        if (!listeners.some((cb)=>cb.id === callbackId)) return;
        const cleanup = $74f22d1bc7fc1517$export$b4a4aba7c5f97c17.get(observerId);
        if (listeners.length === 1 && cleanup) cleanup();
        unsubscribe();
    };
    const listeners = getListeners();
    $74f22d1bc7fc1517$export$94ab3a05cb07971d.set(observerId, [
        ...listeners,
        {
            id: callbackId,
            fns: callbacks
        }
    ]);
    if (listeners && listeners.length > 0) return unwatch;
    const emit = {};
    for(const key in callbacks)emit[key] = (...args)=>{
        const listeners = getListeners();
        if (listeners.length === 0) return;
        for (const listener of listeners)listener.fns[key]?.(...args);
    };
    const cleanup = fn(emit);
    if (typeof cleanup === "function") $74f22d1bc7fc1517$export$b4a4aba7c5f97c17.set(observerId, cleanup);
    return unwatch;
}



var $4bijw = parcelRequire("4bijw");


var $6fuj2 = parcelRequire("6fuj2");




var $9GGVO = parcelRequire("9GGVO");



function $39fa57acb3fa83d2$export$e0c10349b2c5e1d4(fn, { emitOnBegin: emitOnBegin, initialWaitTime: initialWaitTime, interval: interval }) {
    let active = true;
    const unwatch = ()=>active = false;
    const watch = async ()=>{
        let data = undefined;
        if (emitOnBegin) data = await fn({
            unpoll: unwatch
        });
        const initialWait = await initialWaitTime?.(data) ?? interval;
        await (0, $1d2d721ab882bc34$export$5c069c93d2b7493f)(initialWait);
        const poll = async ()=>{
            if (!active) return;
            await fn({
                unpoll: unwatch
            });
            await (0, $1d2d721ab882bc34$export$5c069c93d2b7493f)(interval);
            poll();
        };
        poll();
    };
    watch();
    return unwatch;
}



var $6fuj2 = parcelRequire("6fuj2");

function $3d8e554cb4a53fde$export$fc5f622dd0d82466(client, { emitOnBegin: emitOnBegin = false, emitMissed: emitMissed = false, onBlockNumber: onBlockNumber, onError: onError, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = (()=>{
        if (typeof poll_ !== "undefined") return poll_;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    })();
    let prevBlockNumber;
    const pollBlockNumber = ()=>{
        const observerId = (0, $6fuj2.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed,
            pollingInterval
        ]);
        return (0, $74f22d1bc7fc1517$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>(0, $39fa57acb3fa83d2$export$e0c10349b2c5e1d4)(async ()=>{
                try {
                    const blockNumber = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $bbd7d10bf828cb3d$export$9328b5c92c53a20e), "getBlockNumber")({
                        cacheTime: 0
                    });
                    if (prevBlockNumber) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (blockNumber === prevBlockNumber) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (blockNumber - prevBlockNumber > 1 && emitMissed) for(let i = prevBlockNumber + 1n; i < blockNumber; i++){
                            emit.onBlockNumber(i, prevBlockNumber);
                            prevBlockNumber = i;
                        }
                    }
                    // If the next block number is greater than the previous,
                    // it is not in the past, and we can emit the new block number.
                    if (!prevBlockNumber || blockNumber > prevBlockNumber) {
                        emit.onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlockNumber = ()=>{
        const observerId = (0, $6fuj2.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed
        ]);
        return (0, $74f22d1bc7fc1517$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>{
            let active = true;
            let unsubscribe = ()=>active = false;
            (async ()=>{
                try {
                    const transport = (()=>{
                        if (client.transport.type === "fallback") {
                            const transport = client.transport.transports.find((transport)=>transport.config.type === "webSocket");
                            if (!transport) return client.transport;
                            return transport.value;
                        }
                        return client.transport;
                    })();
                    const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                        params: [
                            "newHeads"
                        ],
                        onData (data) {
                            if (!active) return;
                            const blockNumber = (0, $9GGVO.hexToBigInt)(data.result?.number);
                            emit.onBlockNumber(blockNumber, prevBlockNumber);
                            prevBlockNumber = blockNumber;
                        },
                        onError (error) {
                            emit.onError?.(error);
                        }
                    });
                    unsubscribe = unsubscribe_;
                    if (!active) unsubscribe();
                } catch (err) {
                    onError?.(err);
                }
            })();
            return ()=>unsubscribe();
        });
    };
    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
}


async function $f87a726a94dffdff$export$694ec9bdf0bb55cf(client, { confirmations: confirmations = 1, hash: hash, onReplaced: onReplaced, pollingInterval: pollingInterval = client.pollingInterval, retryCount: retryCount = 6, retryDelay: retryDelay = ({ count: count })=>~~(1 << count) * 200, timeout: timeout = 180000 }) {
    const observerId = (0, $6fuj2.stringify)([
        "waitForTransactionReceipt",
        client.uid,
        hash
    ]);
    let transaction;
    let replacedTransaction;
    let receipt;
    let retrying = false;
    const { promise: promise, resolve: resolve, reject: reject } = (0, $4bijw.withResolvers)();
    const timer = timeout ? setTimeout(()=>reject(new (0, $3a3vr.WaitForTransactionReceiptTimeoutError)({
            hash: hash
        })), timeout) : undefined;
    const _unobserve = (0, $74f22d1bc7fc1517$export$d1203567a167490e)(observerId, {
        onReplaced: onReplaced,
        resolve: resolve,
        reject: reject
    }, (emit)=>{
        const _unwatch = (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $3d8e554cb4a53fde$export$fc5f622dd0d82466), "watchBlockNumber")({
            emitMissed: true,
            emitOnBegin: true,
            poll: true,
            pollingInterval: pollingInterval,
            async onBlockNumber (blockNumber_) {
                const done = (fn)=>{
                    clearTimeout(timer);
                    _unwatch();
                    fn();
                    _unobserve();
                };
                let blockNumber = blockNumber_;
                if (retrying) return;
                try {
                    // If we already have a valid receipt, let's check if we have enough
                    // confirmations. If we do, then we can resolve.
                    if (receipt) {
                        if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                        done(()=>emit.resolve(receipt));
                        return;
                    }
                    // Get the transaction to check if it's been replaced.
                    // We need to retry as some RPC Providers may be slow to sync
                    // up mined transactions.
                    if (!transaction) {
                        retrying = true;
                        await (0, $32aed14017c02240$export$188df5ecf8e7961a)(async ()=>{
                            transaction = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $03ec92a3d94d9cd0$export$ec0c6556a09b65b8), "getTransaction")({
                                hash: hash
                            });
                            if (transaction.blockNumber) blockNumber = transaction.blockNumber;
                        }, {
                            delay: retryDelay,
                            retryCount: retryCount
                        });
                        retrying = false;
                    }
                    // Get the receipt to check if it's been processed.
                    receipt = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $965232bcb7f6bc91$export$6b1ceb3cd5f8b21f), "getTransactionReceipt")({
                        hash: hash
                    });
                    // Check if we have enough confirmations. If not, continue polling.
                    if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                    done(()=>emit.resolve(receipt));
                } catch (err) {
                    // If the receipt is not found, the transaction will be pending.
                    // We need to check if it has potentially been replaced.
                    if (err instanceof (0, $3a3vr.TransactionNotFoundError) || err instanceof (0, $3a3vr.TransactionReceiptNotFoundError)) {
                        if (!transaction) {
                            retrying = false;
                            return;
                        }
                        try {
                            replacedTransaction = transaction;
                            // Let's retrieve the transactions from the current block.
                            // We need to retry as some RPC Providers may be slow to sync
                            // up mined blocks.
                            retrying = true;
                            const block = await (0, $32aed14017c02240$export$188df5ecf8e7961a)(()=>(0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $40897522faf9b729$export$ea0af84ed2e77902), "getBlock")({
                                    blockNumber: blockNumber,
                                    includeTransactions: true
                                }), {
                                delay: retryDelay,
                                retryCount: retryCount,
                                shouldRetry: ({ error: error })=>error instanceof (0, $0533198dc39444c8$export$f5a00468af285e38)
                            });
                            retrying = false;
                            const replacementTransaction = block.transactions.find(({ from: from, nonce: nonce })=>from === replacedTransaction.from && nonce === replacedTransaction.nonce);
                            // If we couldn't find a replacement transaction, continue polling.
                            if (!replacementTransaction) return;
                            // If we found a replacement transaction, return it's receipt.
                            receipt = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $965232bcb7f6bc91$export$6b1ceb3cd5f8b21f), "getTransactionReceipt")({
                                hash: replacementTransaction.hash
                            });
                            // Check if we have enough confirmations. If not, continue polling.
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            let reason = "replaced";
                            if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value && replacementTransaction.input === replacedTransaction.input) reason = "repriced";
                            else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) reason = "cancelled";
                            done(()=>{
                                emit.onReplaced?.({
                                    reason: reason,
                                    replacedTransaction: replacedTransaction,
                                    transaction: replacementTransaction,
                                    transactionReceipt: receipt
                                });
                                emit.resolve(receipt);
                            });
                        } catch (err_) {
                            done(()=>emit.reject(err_));
                        }
                    } else done(()=>emit.reject(err));
                }
            }
        });
    });
    return promise;
}







var $6fuj2 = parcelRequire("6fuj2");

function $7e9594a9fd8271da$export$f04bd2888af8db20(client, { blockTag: blockTag = "latest", emitMissed: emitMissed = false, emitOnBegin: emitOnBegin = false, onBlock: onBlock, onError: onError, includeTransactions: includeTransactions_, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = (()=>{
        if (typeof poll_ !== "undefined") return poll_;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    })();
    const includeTransactions = includeTransactions_ ?? false;
    let prevBlock;
    const pollBlocks = ()=>{
        const observerId = (0, $6fuj2.stringify)([
            "watchBlocks",
            client.uid,
            blockTag,
            emitMissed,
            emitOnBegin,
            includeTransactions,
            pollingInterval
        ]);
        return (0, $74f22d1bc7fc1517$export$d1203567a167490e)(observerId, {
            onBlock: onBlock,
            onError: onError
        }, (emit)=>(0, $39fa57acb3fa83d2$export$e0c10349b2c5e1d4)(async ()=>{
                try {
                    const block = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $40897522faf9b729$export$ea0af84ed2e77902), "getBlock")({
                        blockTag: blockTag,
                        includeTransactions: includeTransactions
                    });
                    if (block.number && prevBlock?.number) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (block.number === prevBlock.number) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (block.number - prevBlock.number > 1 && emitMissed) for(let i = prevBlock?.number + 1n; i < block.number; i++){
                            const block = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $40897522faf9b729$export$ea0af84ed2e77902), "getBlock")({
                                blockNumber: i,
                                includeTransactions: includeTransactions
                            });
                            emit.onBlock(block, prevBlock);
                            prevBlock = block;
                        }
                    }
                    if (// If no previous block exists, emit.
                    !prevBlock?.number || // If the block tag is "pending" with no block number, emit.
                    blockTag === "pending" && !block?.number || // If the next block number is greater than the previous block number, emit.
                    // We don't want to emit blocks in the past.
                    block.number && block.number > prevBlock.number) {
                        emit.onBlock(block, prevBlock);
                        prevBlock = block;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlocks = ()=>{
        let active = true;
        let emitFetched = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                if (emitOnBegin) (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $40897522faf9b729$export$ea0af84ed2e77902), "getBlock")({
                    blockTag: blockTag,
                    includeTransactions: includeTransactions
                }).then((block)=>{
                    if (!active) return;
                    if (!emitFetched) return;
                    onBlock(block, undefined);
                    emitFetched = false;
                });
                const transport = (()=>{
                    if (client.transport.type === "fallback") {
                        const transport = client.transport.transports.find((transport)=>transport.config.type === "webSocket");
                        if (!transport) return client.transport;
                        return transport.value;
                    }
                    return client.transport;
                })();
                const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                    params: [
                        "newHeads"
                    ],
                    async onData (data) {
                        if (!active) return;
                        const block = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $40897522faf9b729$export$ea0af84ed2e77902), "getBlock")({
                            blockNumber: data.blockNumber,
                            includeTransactions: includeTransactions
                        }).catch(()=>{});
                        if (!active) return;
                        onBlock(block, prevBlock);
                        emitFetched = false;
                        prevBlock = block;
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return ()=>unsubscribe();
    };
    return enablePolling ? pollBlocks() : subscribeBlocks();
}



var $8p1we = parcelRequire("8p1we");

var $iy34j = parcelRequire("iy34j");







var $6fuj2 = parcelRequire("6fuj2");





function $1b8ffa6441ba7c79$export$2a02a63daa2df376(client, parameters) {
    const { abi: abi, address: address, args: args, batch: batch = true, eventName: eventName, fromBlock: fromBlock, onError: onError, onLogs: onLogs, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval, strict: strict_ } = parameters;
    const enablePolling = (()=>{
        if (typeof poll_ !== "undefined") return poll_;
        if (typeof fromBlock === "bigint") return true;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    })();
    const pollContractEvent = ()=>{
        const strict = strict_ ?? false;
        const observerId = (0, $6fuj2.stringify)([
            "watchContractEvent",
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval,
            strict,
            fromBlock
        ]);
        return (0, $74f22d1bc7fc1517$export$d1203567a167490e)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            let previousBlockNumber;
            if (fromBlock !== undefined) previousBlockNumber = fromBlock - 1n;
            let filter;
            let initialized = false;
            const unwatch = (0, $39fa57acb3fa83d2$export$e0c10349b2c5e1d4)(async ()=>{
                if (!initialized) {
                    try {
                        filter = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $fcafd5d1a974ea6d$export$36f99fdb90149e8b), "createContractEventFilter")({
                            abi: abi,
                            address: address,
                            args: args,
                            eventName: eventName,
                            strict: strict,
                            fromBlock: fromBlock
                        });
                    } catch  {}
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) logs = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $185730381f0589bd$export$e69fa84ce52a94fd), "getFilterChanges")({
                        filter: filter
                    });
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $bbd7d10bf828cb3d$export$9328b5c92c53a20e), "getBlockNumber")({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber < blockNumber) logs = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $26e58da49e1ee9ad$export$1e175955db02d8d), "getContractEvents")({
                            abi: abi,
                            address: address,
                            args: args,
                            eventName: eventName,
                            fromBlock: previousBlockNumber + 1n,
                            toBlock: blockNumber,
                            strict: strict
                        });
                        else logs = [];
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0) return;
                    if (batch) emit.onLogs(logs);
                    else for (const log of logs)emit.onLogs([
                        log
                    ]);
                } catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitialize the filter when this occurs
                    if (filter && err instanceof (0, $iy34j.InvalidInputRpcError)) initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $05f0215b061dbadf$export$54eb7d691768f7f3), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribeContractEvent = ()=>{
        const strict = strict_ ?? false;
        const observerId = (0, $6fuj2.stringify)([
            "watchContractEvent",
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval,
            strict
        ]);
        let active = true;
        let unsubscribe = ()=>active = false;
        return (0, $74f22d1bc7fc1517$export$d1203567a167490e)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            (async ()=>{
                try {
                    const transport = (()=>{
                        if (client.transport.type === "fallback") {
                            const transport = client.transport.transports.find((transport)=>transport.config.type === "webSocket");
                            if (!transport) return client.transport;
                            return transport.value;
                        }
                        return client.transport;
                    })();
                    const topics = eventName ? (0, $c7949e34d5b97d4c$export$64e9f7ca5ce29acd)({
                        abi: abi,
                        eventName: eventName,
                        args: args
                    }) : [];
                    const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                        params: [
                            "logs",
                            {
                                address: address,
                                topics: topics
                            }
                        ],
                        onData (data) {
                            if (!active) return;
                            const log = data.result;
                            try {
                                const { eventName: eventName, args: args } = (0, $3d9d5458117a88dd$export$ec0597e81db3d947)({
                                    abi: abi,
                                    data: log.data,
                                    topics: log.topics,
                                    strict: strict_
                                });
                                const formatted = (0, $709e48cfde3e2ced$export$fccdbdc2b9d7893)(log, {
                                    args: args,
                                    eventName: eventName
                                });
                                emit.onLogs([
                                    formatted
                                ]);
                            } catch (err) {
                                let eventName;
                                let isUnnamed;
                                if (err instanceof (0, $8p1we.DecodeLogDataMismatch) || err instanceof (0, $8p1we.DecodeLogTopicsMismatch)) {
                                    // If strict mode is on, and log data/topics do not match event definition, skip.
                                    if (strict_) return;
                                    eventName = err.abiItem.name;
                                    isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
                                }
                                // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                                const formatted = (0, $709e48cfde3e2ced$export$fccdbdc2b9d7893)(log, {
                                    args: isUnnamed ? [] : {},
                                    eventName: eventName
                                });
                                emit.onLogs([
                                    formatted
                                ]);
                            }
                        },
                        onError (error) {
                            emit.onError?.(error);
                        }
                    });
                    unsubscribe = unsubscribe_;
                    if (!active) unsubscribe();
                } catch (err) {
                    onError?.(err);
                }
            })();
            return ()=>unsubscribe();
        });
    };
    return enablePolling ? pollContractEvent() : subscribeContractEvent();
}






var $6fuj2 = parcelRequire("6fuj2");

var $8p1we = parcelRequire("8p1we");

var $iy34j = parcelRequire("iy34j");








function $afc2327e64abb953$export$f6260ad5441916b4(client, { address: address, args: args, batch: batch = true, event: event, events: events, fromBlock: fromBlock, onError: onError, onLogs: onLogs, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval, strict: strict_ }) {
    const enablePolling = (()=>{
        if (typeof poll_ !== "undefined") return poll_;
        if (typeof fromBlock === "bigint") return true;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    })();
    const strict = strict_ ?? false;
    const pollEvent = ()=>{
        const observerId = (0, $6fuj2.stringify)([
            "watchEvent",
            address,
            args,
            batch,
            client.uid,
            event,
            pollingInterval,
            fromBlock
        ]);
        return (0, $74f22d1bc7fc1517$export$d1203567a167490e)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            let previousBlockNumber;
            if (fromBlock !== undefined) previousBlockNumber = fromBlock - 1n;
            let filter;
            let initialized = false;
            const unwatch = (0, $39fa57acb3fa83d2$export$e0c10349b2c5e1d4)(async ()=>{
                if (!initialized) {
                    try {
                        filter = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $7d5f184fcf2b6dc1$export$977ab14bbccde633), "createEventFilter")({
                            address: address,
                            args: args,
                            event: event,
                            events: events,
                            strict: strict,
                            fromBlock: fromBlock
                        });
                    } catch  {}
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) logs = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $185730381f0589bd$export$e69fa84ce52a94fd), "getFilterChanges")({
                        filter: filter
                    });
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $bbd7d10bf828cb3d$export$9328b5c92c53a20e), "getBlockNumber")({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber !== blockNumber) logs = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $c3b30ee8b148d1e5$export$cb5260c832aab30a), "getLogs")({
                            address: address,
                            args: args,
                            event: event,
                            events: events,
                            fromBlock: previousBlockNumber + 1n,
                            toBlock: blockNumber
                        });
                        else logs = [];
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0) return;
                    if (batch) emit.onLogs(logs);
                    else for (const log of logs)emit.onLogs([
                        log
                    ]);
                } catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitialize the filter when this occurs
                    if (filter && err instanceof (0, $iy34j.InvalidInputRpcError)) initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $05f0215b061dbadf$export$54eb7d691768f7f3), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribeEvent = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const transport = (()=>{
                    if (client.transport.type === "fallback") {
                        const transport = client.transport.transports.find((transport)=>transport.config.type === "webSocket");
                        if (!transport) return client.transport;
                        return transport.value;
                    }
                    return client.transport;
                })();
                const events_ = events ?? (event ? [
                    event
                ] : undefined);
                let topics = [];
                if (events_) {
                    const encoded = events_.flatMap((event)=>(0, $c7949e34d5b97d4c$export$64e9f7ca5ce29acd)({
                            abi: [
                                event
                            ],
                            eventName: event.name,
                            args: args
                        }));
                    // TODO: Clean up type casting
                    topics = [
                        encoded
                    ];
                    if (event) topics = topics[0];
                }
                const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                    params: [
                        "logs",
                        {
                            address: address,
                            topics: topics
                        }
                    ],
                    onData (data) {
                        if (!active) return;
                        const log = data.result;
                        try {
                            const { eventName: eventName, args: args } = (0, $3d9d5458117a88dd$export$ec0597e81db3d947)({
                                abi: events_ ?? [],
                                data: log.data,
                                topics: log.topics,
                                strict: strict
                            });
                            const formatted = (0, $709e48cfde3e2ced$export$fccdbdc2b9d7893)(log, {
                                args: args,
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        } catch (err) {
                            let eventName;
                            let isUnnamed;
                            if (err instanceof (0, $8p1we.DecodeLogDataMismatch) || err instanceof (0, $8p1we.DecodeLogTopicsMismatch)) {
                                // If strict mode is on, and log data/topics do not match event definition, skip.
                                if (strict_) return;
                                eventName = err.abiItem.name;
                                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
                            }
                            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                            const formatted = (0, $709e48cfde3e2ced$export$fccdbdc2b9d7893)(log, {
                                args: isUnnamed ? [] : {},
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        }
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return ()=>unsubscribe();
    };
    return enablePolling ? pollEvent() : subscribeEvent();
}






var $6fuj2 = parcelRequire("6fuj2");



function $2ce4619980026bb9$export$223080172c87e789(client, { batch: batch = true, onError: onError, onTransactions: onTransactions, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const pollPendingTransactions = ()=>{
        const observerId = (0, $6fuj2.stringify)([
            "watchPendingTransactions",
            client.uid,
            batch,
            pollingInterval
        ]);
        return (0, $74f22d1bc7fc1517$export$d1203567a167490e)(observerId, {
            onTransactions: onTransactions,
            onError: onError
        }, (emit)=>{
            let filter;
            const unwatch = (0, $39fa57acb3fa83d2$export$e0c10349b2c5e1d4)(async ()=>{
                try {
                    if (!filter) try {
                        filter = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $a4c70f021aac4a30$export$d455ed04c3e85241), "createPendingTransactionFilter")({});
                        return;
                    } catch (err) {
                        unwatch();
                        throw err;
                    }
                    const hashes = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $185730381f0589bd$export$e69fa84ce52a94fd), "getFilterChanges")({
                        filter: filter
                    });
                    if (hashes.length === 0) return;
                    if (batch) emit.onTransactions(hashes);
                    else for (const hash of hashes)emit.onTransactions([
                        hash
                    ]);
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $05f0215b061dbadf$export$54eb7d691768f7f3), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribePendingTransactions = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newPendingTransactions"
                    ],
                    onData (data) {
                        if (!active) return;
                        const transaction = data.result;
                        onTransactions([
                            transaction
                        ]);
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return ()=>unsubscribe();
    };
    return enablePolling ? pollPendingTransactions() : subscribePendingTransactions();
}



/**
 * @description Parses EIP-4361 formatted message into message fields object.
 *
 * @see https://eips.ethereum.org/EIPS/eip-4361
 *
 * @returns EIP-4361 fields object
 */ function $fe1da3f558a37f65$export$ebbfe406e131b6f6(message) {
    const { scheme: scheme, statement: statement, ...prefix } = message.match($fe1da3f558a37f65$var$prefixRegex)?.groups ?? {};
    const { chainId: chainId, expirationTime: expirationTime, issuedAt: issuedAt, notBefore: notBefore, requestId: requestId, ...suffix } = message.match($fe1da3f558a37f65$var$suffixRegex)?.groups ?? {};
    const resources = message.split("Resources:")[1]?.split("\n- ").slice(1);
    return {
        ...prefix,
        ...suffix,
        ...chainId ? {
            chainId: Number(chainId)
        } : {},
        ...expirationTime ? {
            expirationTime: new Date(expirationTime)
        } : {},
        ...issuedAt ? {
            issuedAt: new Date(issuedAt)
        } : {},
        ...notBefore ? {
            notBefore: new Date(notBefore)
        } : {},
        ...requestId ? {
            requestId: requestId
        } : {},
        ...resources ? {
            resources: resources
        } : {},
        ...scheme ? {
            scheme: scheme
        } : {},
        ...statement ? {
            statement: statement
        } : {}
    };
}
// https://regexr.com/80gdj
const $fe1da3f558a37f65$var$prefixRegex = /^(?:(?<scheme>[a-zA-Z][a-zA-Z0-9+-.]*):\/\/)?(?<domain>[a-zA-Z0-9+-.]*(?::[0-9]{1,5})?) (?:wants you to sign in with your Ethereum account:\n)(?<address>0x[a-fA-F0-9]{40})\n\n(?:(?<statement>.*)\n\n)?/;
// https://regexr.com/80gf9
const $fe1da3f558a37f65$var$suffixRegex = /(?:URI: (?<uri>.+))\n(?:Version: (?<version>.+))\n(?:Chain ID: (?<chainId>\d+))\n(?:Nonce: (?<nonce>[a-zA-Z0-9]+))\n(?:Issued At: (?<issuedAt>.+))(?:\nExpiration Time: (?<expirationTime>.+))?(?:\nNot Before: (?<notBefore>.+))?(?:\nRequest ID: (?<requestId>.+))?/;



var $13kYf = parcelRequire("13kYf");
function $297ea95aab057766$export$d3bfd63549572667(parameters) {
    const { address: address, domain: domain, message: message, nonce: nonce, scheme: scheme, time: time = new Date() } = parameters;
    if (domain && message.domain !== domain) return false;
    if (nonce && message.nonce !== nonce) return false;
    if (scheme && message.scheme !== scheme) return false;
    if (message.expirationTime && time >= message.expirationTime) return false;
    if (message.notBefore && time < message.notBefore) return false;
    try {
        if (!message.address) return false;
        if (address && !(0, $13kYf.isAddressEqual)(message.address, address)) return false;
    } catch  {
        return false;
    }
    return true;
}



async function $e0ad0fb999de9617$export$10c59ebee3bc23e3(client, parameters) {
    const { address: address, domain: domain, message: message, nonce: nonce, scheme: scheme, signature: signature, time: time = new Date(), ...callRequest } = parameters;
    const parsed = (0, $fe1da3f558a37f65$export$ebbfe406e131b6f6)(message);
    if (!parsed.address) return false;
    const isValid = (0, $297ea95aab057766$export$d3bfd63549572667)({
        address: address,
        domain: domain,
        message: parsed,
        nonce: nonce,
        scheme: scheme,
        time: time
    });
    if (!isValid) return false;
    const hash = (0, $714e08c9e5517ec5$export$d4c241cec96564c1)(message);
    return (0, $5c7c89ce557d9fce$export$434ee6408013d7f2)(client, {
        address: parsed.address,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}



/**
 * Sends a **signed** transaction to the network
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendRawTransaction
 * - JSON-RPC Method: [`eth_sendRawTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *
 * @param client - Client to use
 * @param parameters - {@link SendRawTransactionParameters}
 * @returns The transaction hash. {@link SendRawTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendRawTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 *
 * const hash = await sendRawTransaction(client, {
 *   serializedTransaction: '0x02f850018203118080825208808080c080a04012522854168b27e5dc3d5839bab5e6b39e1a0ffd343901ce1622e3d64b48f1a04e00902ae0502c4728cbf12156290df99c3ed7de85b1dbfe20b5c36931733a33'
 * })
 */ async function $0cd48089f36bb811$export$4e309754b4830e29(client, { serializedTransaction: serializedTransaction }) {
    return client.request({
        method: "eth_sendRawTransaction",
        params: [
            serializedTransaction
        ]
    }, {
        retryCount: 0
    });
}


function $b9151f5382b5a6f9$export$8705b583fa097d24(client) {
    return {
        call: (args)=>(0, $cjGvc.call)(client, args),
        createAccessList: (args)=>(0, $edfa88d98346bb5d$export$db8bba598ef289f1)(client, args),
        createBlockFilter: ()=>(0, $77055d3697eae26b$export$651edd5ecf84bf98)(client),
        createContractEventFilter: (args)=>(0, $fcafd5d1a974ea6d$export$36f99fdb90149e8b)(client, args),
        createEventFilter: (args)=>(0, $7d5f184fcf2b6dc1$export$977ab14bbccde633)(client, args),
        createPendingTransactionFilter: ()=>(0, $a4c70f021aac4a30$export$d455ed04c3e85241)(client),
        estimateContractGas: (args)=>(0, $f8639f2af5400fa8$export$7b896b3a3695de87)(client, args),
        estimateGas: (args)=>(0, $9ee228e9f26c6e59$export$e0580ae1f48db848)(client, args),
        getBalance: (args)=>(0, $1c1667fc515d46a5$export$df96cd8d56be0ab1)(client, args),
        getBlobBaseFee: ()=>(0, $c5a50262cc7282ea$export$9682cd49f77b48b)(client),
        getBlock: (args)=>(0, $40897522faf9b729$export$ea0af84ed2e77902)(client, args),
        getBlockNumber: (args)=>(0, $bbd7d10bf828cb3d$export$9328b5c92c53a20e)(client, args),
        getBlockTransactionCount: (args)=>(0, $7d8c55196586ba9b$export$8c2de5be7f4dfc0)(client, args),
        getBytecode: (args)=>(0, $e90fb6cf5f7b7523$export$9a0a9c75ccef13fb)(client, args),
        getChainId: ()=>(0, $df79c8eb8659d088$export$850fa7b3891187c)(client),
        getCode: (args)=>(0, $e90fb6cf5f7b7523$export$9a0a9c75ccef13fb)(client, args),
        getContractEvents: (args)=>(0, $26e58da49e1ee9ad$export$1e175955db02d8d)(client, args),
        getEip712Domain: (args)=>(0, $272e0cb59ff69f0e$export$78097141abc77755)(client, args),
        getEnsAddress: (args)=>(0, $05eb798102efc443$export$24b77c7e87f05b8d)(client, args),
        getEnsAvatar: (args)=>(0, $13657efc615be89d$export$65f1d2b9649a54e5)(client, args),
        getEnsName: (args)=>(0, $9857d8fa16446645$export$e1b98d9bc05a9fc2)(client, args),
        getEnsResolver: (args)=>(0, $97226fc80e039432$export$ba1240cd558e6b31)(client, args),
        getEnsText: (args)=>(0, $a6e375d8a4af9666$export$2b2c96dabd62b431)(client, args),
        getFeeHistory: (args)=>(0, $6ebe895d07245d37$export$66598bc0c00a958e)(client, args),
        estimateFeesPerGas: (args)=>(0, $e4d35effe014a033$export$8193bed8c46d2831)(client, args),
        getFilterChanges: (args)=>(0, $185730381f0589bd$export$e69fa84ce52a94fd)(client, args),
        getFilterLogs: (args)=>(0, $4316771872071f67$export$776d3b8c33a8b58)(client, args),
        getGasPrice: ()=>(0, $e84282994ef4ec82$export$89c15b50d46d3f8c)(client),
        getLogs: (args)=>(0, $c3b30ee8b148d1e5$export$cb5260c832aab30a)(client, args),
        getProof: (args)=>(0, $f979dfa0c98310ec$export$4a314c097411dc17)(client, args),
        estimateMaxPriorityFeePerGas: (args)=>(0, $19bc8536d1fd29a4$export$fd79a693887f886c)(client, args),
        getStorageAt: (args)=>(0, $3004341ed7c3cf5e$export$14e244c1a3c8527e)(client, args),
        getTransaction: (args)=>(0, $03ec92a3d94d9cd0$export$ec0c6556a09b65b8)(client, args),
        getTransactionConfirmations: (args)=>(0, $84bac16b72278397$export$e2ccc904d713b66d)(client, args),
        getTransactionCount: (args)=>(0, $7bfc8e45417dbe30$export$b18e66333ec1361e)(client, args),
        getTransactionReceipt: (args)=>(0, $965232bcb7f6bc91$export$6b1ceb3cd5f8b21f)(client, args),
        multicall: (args)=>(0, $dc0d72ee3c69399a$export$60ef70589ee4f7ad)(client, args),
        prepareTransactionRequest: (args)=>(0, $bf5271a93dc90ad4$export$2e8a9232fb815d77)(client, args),
        readContract: (args)=>(0, $2ba19faf5017d144$export$43af7de392176737)(client, args),
        sendRawTransaction: (args)=>(0, $0cd48089f36bb811$export$4e309754b4830e29)(client, args),
        simulate: (args)=>(0, $894419aadf34fa74$export$d7b183d4eabb187b)(client, args),
        simulateBlocks: (args)=>(0, $894419aadf34fa74$export$d7b183d4eabb187b)(client, args),
        simulateCalls: (args)=>(0, $3c0e85c25f2baa58$export$bc4cac5ece13b6fb)(client, args),
        simulateContract: (args)=>(0, $dfc06fbd396ee9a5$export$e8798d551e27a374)(client, args),
        verifyMessage: (args)=>(0, $8273d2017c3d10ce$export$228d0e772cc158cb)(client, args),
        verifySiweMessage: (args)=>(0, $e0ad0fb999de9617$export$10c59ebee3bc23e3)(client, args),
        verifyTypedData: (args)=>(0, $a73108b664069fa3$export$3603b1c1bcd76798)(client, args),
        uninstallFilter: (args)=>(0, $05f0215b061dbadf$export$54eb7d691768f7f3)(client, args),
        waitForTransactionReceipt: (args)=>(0, $f87a726a94dffdff$export$694ec9bdf0bb55cf)(client, args),
        watchBlocks: (args)=>(0, $7e9594a9fd8271da$export$f04bd2888af8db20)(client, args),
        watchBlockNumber: (args)=>(0, $3d8e554cb4a53fde$export$fc5f622dd0d82466)(client, args),
        watchContractEvent: (args)=>(0, $1b8ffa6441ba7c79$export$2a02a63daa2df376)(client, args),
        watchEvent: (args)=>(0, $afc2327e64abb953$export$f6260ad5441916b4)(client, args),
        watchPendingTransactions: (args)=>(0, $2ce4619980026bb9$export$223080172c87e789)(client, args)
    };
}


function $8085cfeffb1fd5c6$export$d8e090d8c6a7a6ad(parameters) {
    const { key: key = "public", name: name = "Public Client" } = parameters;
    const client = (0, $39c00038e35bed34$export$5d730b7aed1a3eb0)({
        ...parameters,
        key: key,
        name: name,
        type: "publicClient"
    });
    return client.extend((0, $b9151f5382b5a6f9$export$8705b583fa097d24));
}




var $jW8ut = parcelRequire("jW8ut");
async function $b7e12f709b2521f5$export$e648161d6b1bb565(client, { chain: chain }) {
    const { id: id, name: name, nativeCurrency: nativeCurrency, rpcUrls: rpcUrls, blockExplorers: blockExplorers } = chain;
    await client.request({
        method: "wallet_addEthereumChain",
        params: [
            {
                chainId: (0, $jW8ut.numberToHex)(id),
                chainName: name,
                nativeCurrency: nativeCurrency,
                rpcUrls: rpcUrls.default.http,
                blockExplorerUrls: blockExplorers ? Object.values(blockExplorers).map(({ url: url })=>url) : undefined
            }
        ]
    }, {
        dedupe: true,
        retryCount: 0
    });
}



var $fUU8L = parcelRequire("fUU8L");

var $gbEG8 = parcelRequire("gbEG8");


var $cahqm = parcelRequire("cahqm");


var $iz4Cu = parcelRequire("iz4Cu");
function $aa8a473d403dddd9$export$390d312ab46d0597({ chain: chain, currentChainId: currentChainId }) {
    if (!chain) throw new (0, $iz4Cu.ChainNotFoundError)();
    if (currentChainId !== chain.id) throw new (0, $iz4Cu.ChainMismatchError)({
        chain: chain,
        currentChainId: currentChainId
    });
}



var $iWaDR = parcelRequire("iWaDR");

var $3a3vr = parcelRequire("3a3vr");

var $iZm7e = parcelRequire("iZm7e");
function $44e5a0aecfc1938c$export$da1758db1985646e(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $iZm7e.getNodeError)(err, args);
        if (cause instanceof (0, $iWaDR.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $3a3vr.TransactionExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}



var $fcbjO = parcelRequire("fcbjO");

var $ksIKp = parcelRequire("ksIKp");


var $2iCjp = parcelRequire("2iCjp");

var $1OSs0 = parcelRequire("1OSs0");



const $4b2ec44b2feb7c1d$var$supportsWalletNamespace = new (0, $2iCjp.LruMap)(128);
async function $4b2ec44b2feb7c1d$export$8e0e7ffc78696d30(client, parameters) {
    const { account: account_ = client.account, chain: chain = client.chain, accessList: accessList, authorizationList: authorizationList, blobs: blobs, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value, ...rest } = parameters;
    if (typeof account_ === "undefined") throw new (0, $a7181154857b10db$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/sendTransaction"
    });
    const account = account_ ? (0, $gbEG8.parseAccount)(account_) : null;
    try {
        (0, $1OSs0.assertRequest)(parameters);
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (parameters.to) return parameters.to;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0) return await (0, $36af70ab738a2385$export$415d0315604a8515)({
                authorization: authorizationList[0]
            }).catch(()=>{
                throw new (0, $cahqm.BaseError)("`to` is required. Could not infer from `authorizationList`.");
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        if (account?.type === "json-rpc" || account === null) {
            let chainId;
            if (chain !== null) {
                chainId = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $df79c8eb8659d088$export$850fa7b3891187c), "getChainId")({});
                (0, $aa8a473d403dddd9$export$390d312ab46d0597)({
                    currentChainId: chainId,
                    chain: chain
                });
            }
            const chainFormat = client.chain?.formatters?.transactionRequest?.format;
            const format = chainFormat || (0, $ksIKp.formatTransactionRequest);
            const request = format({
                // Pick out extra data that might exist on the chain's transaction request type.
                ...(0, $fcbjO.extract)(rest, {
                    format: chainFormat
                }),
                accessList: accessList,
                authorizationList: authorizationList,
                blobs: blobs,
                chainId: chainId,
                data: data,
                from: account?.address,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                to: to,
                value: value
            });
            const isWalletNamespaceSupported = $4b2ec44b2feb7c1d$var$supportsWalletNamespace.get(client.uid);
            const method = isWalletNamespaceSupported ? "wallet_sendTransaction" : "eth_sendTransaction";
            try {
                return await client.request({
                    method: method,
                    params: [
                        request
                    ]
                }, {
                    retryCount: 0
                });
            } catch (e) {
                if (isWalletNamespaceSupported === false) throw e;
                const error = e;
                // If the transport does not support the method or input, attempt to use the
                // `wallet_sendTransaction` method.
                if (error.name === "InvalidInputRpcError" || error.name === "InvalidParamsRpcError" || error.name === "MethodNotFoundRpcError" || error.name === "MethodNotSupportedRpcError") return await client.request({
                    method: "wallet_sendTransaction",
                    params: [
                        request
                    ]
                }, {
                    retryCount: 0
                }).then((hash)=>{
                    $4b2ec44b2feb7c1d$var$supportsWalletNamespace.set(client.uid, true);
                    return hash;
                }).catch((e)=>{
                    const walletNamespaceError = e;
                    if (walletNamespaceError.name === "MethodNotFoundRpcError" || walletNamespaceError.name === "MethodNotSupportedRpcError") {
                        $4b2ec44b2feb7c1d$var$supportsWalletNamespace.set(client.uid, false);
                        throw error;
                    }
                    throw walletNamespaceError;
                });
                throw error;
            }
        }
        if (account?.type === "local") {
            // Prepare the request for signing (assign appropriate fees, etc.)
            const request = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $bf5271a93dc90ad4$export$2e8a9232fb815d77), "prepareTransactionRequest")({
                account: account,
                accessList: accessList,
                authorizationList: authorizationList,
                blobs: blobs,
                chain: chain,
                data: data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                nonceManager: account.nonceManager,
                parameters: [
                    ...(0, $bf5271a93dc90ad4$export$4f3e0c2bc77eca55),
                    "sidecars"
                ],
                value: value,
                ...rest,
                to: to
            });
            const serializer = chain?.serializers?.transaction;
            const serializedTransaction = await account.signTransaction(request, {
                serializer: serializer
            });
            return await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $0cd48089f36bb811$export$4e309754b4830e29), "sendRawTransaction")({
                serializedTransaction: serializedTransaction
            });
        }
        if (account?.type === "smart") throw new (0, $a7181154857b10db$export$22c1d840ef5fbc66)({
            metaMessages: [
                "Consider using the `sendUserOperation` Action instead."
            ],
            docsPath: "/docs/actions/bundler/sendUserOperation",
            type: "smart"
        });
        throw new (0, $a7181154857b10db$export$22c1d840ef5fbc66)({
            docsPath: "/docs/actions/wallet/sendTransaction",
            type: account?.type
        });
    } catch (err) {
        if (err instanceof (0, $a7181154857b10db$export$22c1d840ef5fbc66)) throw err;
        throw (0, $44e5a0aecfc1938c$export$da1758db1985646e)(err, {
            ...parameters,
            account: account,
            chain: parameters.chain || undefined
        });
    }
}


function $d0c458faec289f85$export$46c7a79747abe6a9(walletClient, parameters) {
    const { abi: abi, args: args, bytecode: bytecode, ...request } = parameters;
    const calldata = (0, $fUU8L.encodeDeployData)({
        abi: abi,
        args: args,
        bytecode: bytecode
    });
    return (0, $4b2ec44b2feb7c1d$export$8e0e7ffc78696d30)(walletClient, {
        ...request,
        data: calldata
    });
}



var $siouQ = parcelRequire("siouQ");
async function $72ccc2f969d8e5c4$export$17d5f00cfd692b8a(client) {
    if (client.account?.type === "local") return [
        client.account.address
    ];
    const addresses = await client.request({
        method: "eth_accounts"
    }, {
        dedupe: true
    });
    return addresses.map((address)=>(0, $siouQ.checksumAddress)(address));
}


/**
 * Gets the wallets current permissions.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/getPermissions
 * - JSON-RPC Methods: [`wallet_getPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @returns The wallet permissions. {@link GetPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await getPermissions(client)
 */ async function $36d549f9fd118435$export$e10fd44ca431fa8e(client) {
    const permissions = await client.request({
        method: "wallet_getPermissions"
    }, {
        dedupe: true
    });
    return permissions;
}




var $siouQ = parcelRequire("siouQ");
async function $c521da7e8fa38531$export$87c5bcc1dede6f06(client) {
    const addresses = await client.request({
        method: "eth_requestAccounts"
    }, {
        dedupe: true,
        retryCount: 0
    });
    return addresses.map((address)=>(0, $siouQ.getAddress)(address));
}


/**
 * Requests permissions for a wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/requestPermissions
 * - JSON-RPC Methods: [`wallet_requestPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @param parameters - {@link RequestPermissionsParameters}
 * @returns The wallet permissions. {@link RequestPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { requestPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await requestPermissions(client, {
 *   eth_accounts: {}
 * })
 */ async function $7e8f0b0a9445c1bd$export$8cec5d3683c6896e(client, permissions) {
    return client.request({
        method: "wallet_requestPermissions",
        params: [
            permissions
        ]
    }, {
        retryCount: 0
    });
}






var $gbEG8 = parcelRequire("gbEG8");



var $jW8ut = parcelRequire("jW8ut");

var $ksIKp = parcelRequire("ksIKp");


var $1OSs0 = parcelRequire("1OSs0");

async function $ea2306d2494fd3df$export$6ad02cc4966b42ab(client, parameters) {
    const { account: account_ = client.account, chain: chain = client.chain, ...transaction } = parameters;
    if (!account_) throw new (0, $a7181154857b10db$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/signTransaction"
    });
    const account = (0, $gbEG8.parseAccount)(account_);
    (0, $1OSs0.assertRequest)({
        account: account,
        ...parameters
    });
    const chainId = await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $df79c8eb8659d088$export$850fa7b3891187c), "getChainId")({});
    if (chain !== null) (0, $aa8a473d403dddd9$export$390d312ab46d0597)({
        currentChainId: chainId,
        chain: chain
    });
    const formatters = chain?.formatters || client.chain?.formatters;
    const format = formatters?.transactionRequest?.format || (0, $ksIKp.formatTransactionRequest);
    if (account.signTransaction) return account.signTransaction({
        ...transaction,
        chainId: chainId
    }, {
        serializer: client.chain?.serializers?.transaction
    });
    return await client.request({
        method: "eth_signTransaction",
        params: [
            {
                ...format(transaction),
                chainId: (0, $jW8ut.numberToHex)(chainId),
                from: account.address
            }
        ]
    }, {
        retryCount: 0
    });
}



var $gbEG8 = parcelRequire("gbEG8");


async function $50597995dc5b6bf6$export$9f05de2db4d31153(client, parameters) {
    const { account: account_ = client.account, domain: domain, message: message, primaryType: primaryType } = parameters;
    if (!account_) throw new (0, $a7181154857b10db$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/signTypedData"
    });
    const account = (0, $gbEG8.parseAccount)(account_);
    const types = {
        EIP712Domain: (0, $a7b6842215f4b8bd$export$6a292159484ee032)({
            domain: domain
        }),
        ...parameters.types
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $a7b6842215f4b8bd$export$fac174f558903e26)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    if (account.signTypedData) return account.signTypedData({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const typedData = (0, $a7b6842215f4b8bd$export$ce8e1cf733064451)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    return client.request({
        method: "eth_signTypedData_v4",
        params: [
            account.address,
            typedData
        ]
    }, {
        retryCount: 0
    });
}



var $jW8ut = parcelRequire("jW8ut");
async function $8b06fc547ffee718$export$15599da40e72d2f(client, { id: id }) {
    await client.request({
        method: "wallet_switchEthereumChain",
        params: [
            {
                chainId: (0, $jW8ut.numberToHex)(id)
            }
        ]
    }, {
        retryCount: 0
    });
}


/**
 * Adds an EVM chain to the wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/watchAsset
 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-747)
 *
 * @param client - Client to use
 * @param parameters - {@link WatchAssetParameters}
 * @returns Boolean indicating if the token was successfully added. {@link WatchAssetReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchAsset } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const success = await watchAsset(client, {
 *   type: 'ERC20',
 *   options: {
 *     address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
 *     decimals: 18,
 *     symbol: 'WETH',
 *   },
 * })
 */ async function $15ee213bbf0fc7c8$export$7eea68d1a70548bd(client, params) {
    const added = await client.request({
        method: "wallet_watchAsset",
        params: params
    }, {
        retryCount: 0
    });
    return added;
}



var $gbEG8 = parcelRequire("gbEG8");


var $aYJZ1 = parcelRequire("aYJZ1");



async function $b4b33cbd7499c5e1$export$4c0f201bc17cbf23(client, parameters) {
    const { abi: abi, account: account_ = client.account, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...request } = parameters;
    if (typeof account_ === "undefined") throw new (0, $a7181154857b10db$export$62ee6b05f0767f28)({
        docsPath: "/docs/contract/writeContract"
    });
    const account = account_ ? (0, $gbEG8.parseAccount)(account_) : null;
    const data = (0, $aYJZ1.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        return await (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $4b2ec44b2feb7c1d$export$8e0e7ffc78696d30), "sendTransaction")({
            data: `${data}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
            to: address,
            account: account,
            ...request
        });
    } catch (error) {
        throw (0, $768c9bcff606843b$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/writeContract",
            functionName: functionName,
            sender: account?.address
        });
    }
}


function $25409e85aa3945c1$export$d07041b4ed194fbc(client) {
    return {
        addChain: (args)=>(0, $b7e12f709b2521f5$export$e648161d6b1bb565)(client, args),
        deployContract: (args)=>(0, $d0c458faec289f85$export$46c7a79747abe6a9)(client, args),
        getAddresses: ()=>(0, $72ccc2f969d8e5c4$export$17d5f00cfd692b8a)(client),
        getChainId: ()=>(0, $df79c8eb8659d088$export$850fa7b3891187c)(client),
        getPermissions: ()=>(0, $36d549f9fd118435$export$e10fd44ca431fa8e)(client),
        prepareTransactionRequest: (args)=>(0, $bf5271a93dc90ad4$export$2e8a9232fb815d77)(client, args),
        requestAddresses: ()=>(0, $c521da7e8fa38531$export$87c5bcc1dede6f06)(client),
        requestPermissions: (args)=>(0, $7e8f0b0a9445c1bd$export$8cec5d3683c6896e)(client, args),
        sendRawTransaction: (args)=>(0, $0cd48089f36bb811$export$4e309754b4830e29)(client, args),
        sendTransaction: (args)=>(0, $4b2ec44b2feb7c1d$export$8e0e7ffc78696d30)(client, args),
        signMessage: (args)=>(0, $4662c803f63664f1$export$1d9a7a8a40780de)(client, args),
        signTransaction: (args)=>(0, $ea2306d2494fd3df$export$6ad02cc4966b42ab)(client, args),
        signTypedData: (args)=>(0, $50597995dc5b6bf6$export$9f05de2db4d31153)(client, args),
        switchChain: (args)=>(0, $8b06fc547ffee718$export$15599da40e72d2f)(client, args),
        watchAsset: (args)=>(0, $15ee213bbf0fc7c8$export$7eea68d1a70548bd)(client, args),
        writeContract: (args)=>(0, $b4b33cbd7499c5e1$export$4c0f201bc17cbf23)(client, args)
    };
}


function $bf4e0381e2c41280$export$362b8ea2edbd9090(parameters) {
    const { key: key = "wallet", name: name = "Wallet Client", transport: transport } = parameters;
    const client = (0, $39c00038e35bed34$export$5d730b7aed1a3eb0)({
        ...parameters,
        key: key,
        name: name,
        transport: transport,
        type: "walletClient"
    });
    return client.extend((0, $25409e85aa3945c1$export$d07041b4ed194fbc));
}


var $6Dftn = parcelRequire("6Dftn");







function $4a68b247381b8806$export$f518c38144e1f9d({ abi: abi, address: address, client: client_ }) {
    const client = client_;
    const [publicClient, walletClient] = (()=>{
        if (!client) return [
            undefined,
            undefined
        ];
        if ("public" in client && "wallet" in client) return [
            client.public,
            client.wallet
        ];
        if ("public" in client) return [
            client.public,
            undefined
        ];
        if ("wallet" in client) return [
            undefined,
            client.wallet
        ];
        return [
            client,
            client
        ];
    })();
    const hasPublicClient = publicClient !== undefined && publicClient !== null;
    const hasWalletClient = walletClient !== undefined && walletClient !== null;
    const contract = {};
    let hasReadFunction = false;
    let hasWriteFunction = false;
    let hasEvent = false;
    for (const item of abi){
        if (item.type === "function") {
            if (item.stateMutability === "view" || item.stateMutability === "pure") hasReadFunction = true;
            else hasWriteFunction = true;
        } else if (item.type === "event") hasEvent = true;
        // Exit early if all flags are `true`
        if (hasReadFunction && hasWriteFunction && hasEvent) break;
    }
    if (hasPublicClient) {
        if (hasReadFunction) contract.read = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $4a68b247381b8806$export$b1d653474fdb0f41(parameters);
                    return (0, $03465ad531816f87$export$6ca3170acb89054)(publicClient, (0, $2ba19faf5017d144$export$43af7de392176737), "readContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
        if (hasWriteFunction) contract.simulate = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $4a68b247381b8806$export$b1d653474fdb0f41(parameters);
                    return (0, $03465ad531816f87$export$6ca3170acb89054)(publicClient, (0, $dfc06fbd396ee9a5$export$e8798d551e27a374), "simulateContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
        if (hasEvent) {
            contract.createEventFilter = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $4a68b247381b8806$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $03465ad531816f87$export$6ca3170acb89054)(publicClient, (0, $fcafd5d1a974ea6d$export$36f99fdb90149e8b), "createContractEventFilter")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
            contract.getEvents = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $4a68b247381b8806$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $03465ad531816f87$export$6ca3170acb89054)(publicClient, (0, $26e58da49e1ee9ad$export$1e175955db02d8d), "getContractEvents")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
            contract.watchEvent = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $4a68b247381b8806$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $03465ad531816f87$export$6ca3170acb89054)(publicClient, (0, $1b8ffa6441ba7c79$export$2a02a63daa2df376), "watchContractEvent")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
        }
    }
    if (hasWalletClient) {
        if (hasWriteFunction) contract.write = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $4a68b247381b8806$export$b1d653474fdb0f41(parameters);
                    return (0, $03465ad531816f87$export$6ca3170acb89054)(walletClient, (0, $b4b33cbd7499c5e1$export$4c0f201bc17cbf23), "writeContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
    }
    if (hasPublicClient || hasWalletClient) {
        if (hasWriteFunction) contract.estimateGas = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $4a68b247381b8806$export$b1d653474fdb0f41(parameters);
                    const client = publicClient ?? walletClient;
                    return (0, $03465ad531816f87$export$6ca3170acb89054)(client, (0, $f8639f2af5400fa8$export$7b896b3a3695de87), "estimateContractGas")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options,
                        account: options.account ?? walletClient.account
                    });
                };
            }
        });
    }
    contract.address = address;
    contract.abi = abi;
    return contract;
}
function $4a68b247381b8806$export$b1d653474fdb0f41(values) {
    const hasArgs = values.length && Array.isArray(values[0]);
    const args = hasArgs ? values[0] : [];
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return {
        args: args,
        options: options
    };
}
function $4a68b247381b8806$export$5d0aafa8249eb606(values, abiEvent) {
    let hasArgs = false;
    // If first item is array, must be `args`
    if (Array.isArray(values[0])) hasArgs = true;
    else if (values.length === 1) // if event has indexed inputs, must have `args`
    hasArgs = abiEvent.inputs.some((x)=>x.indexed);
    else if (values.length === 2) hasArgs = true;
    const args = hasArgs ? values[0] : undefined;
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return {
        args: args,
        options: options
    };
}


var $64pxN = parcelRequire("64pxN");
var $3IKOD = parcelRequire("3IKOD");

var $cahqm = parcelRequire("cahqm");
class $530cf9daaad6f1d8$export$7c1f3850adf73cff extends (0, $cahqm.BaseError) {
    constructor({ value: value }){
        super(`Number \`${value}\` is not a valid decimal number.`, {
            name: "InvalidDecimalNumberError"
        });
    }
}


function $8ee9eff684bd0e3a$export$203ae30b4f6490b3(value, decimals) {
    if (!/^(-?)([0-9]*)\.?([0-9]*)$/.test(value)) throw new (0, $530cf9daaad6f1d8$export$7c1f3850adf73cff)({
        value: value
    });
    let [integer, fraction = "0"] = value.split(".");
    const negative = integer.startsWith("-");
    if (negative) integer = integer.slice(1);
    // trim trailing zeros.
    fraction = fraction.replace(/(0+)$/, "");
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1) integer = `${BigInt(integer) + 1n}`;
        fraction = "";
    } else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals)
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9) fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, "0");
        else fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    } else fraction = fraction.padEnd(decimals, "0");
    return BigInt(`${negative ? "-" : ""}${integer}${fraction}`);
}


function $5316bee174ce871c$export$642c4e67bbdc0bc7(ether, unit = "wei") {
    return (0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(ether, (0, $3IKOD.etherUnits)[unit]);
}





var $bnENU = parcelRequire("bnENU");


const $97ca9eea98d7d956$export$83d89fbfd8236492 = "2.14.16";


const $a7e9d104173e67ab$export$c506eb22e615ba4a = ()=>`wagmi@${0, $97ca9eea98d7d956$export$83d89fbfd8236492}`;


class $6d2a4d9a5f58d445$export$a490eb03cb7a0a5e extends (0, $2ee97e787be17453$export$a490eb03cb7a0a5e) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiError"
        });
    }
    get docsBaseUrl() {
        return "https://wagmi.sh/react";
    }
    get version() {
        return (0, $a7e9d104173e67ab$export$c506eb22e615ba4a)();
    }
}


class $15442d4b606d621c$export$83af591da49c2ea extends (0, $6d2a4d9a5f58d445$export$a490eb03cb7a0a5e) {
    constructor(){
        super("`useConfig` must be used within `WagmiProvider`.", {
            docsPath: "/api/WagmiProvider"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiProviderNotFoundError"
        });
    }
}


"use client";
function $ea535364be670fd7$export$b3611e87cd5ba6ce(parameters = {}) {
    const config = parameters.config ?? (0, $bnENU.useContext)((0, $91be27bdcb92956c$export$da7c16611087c70c));
    if (!config) throw new (0, $15442d4b606d621c$export$83af591da49c2ea)();
    return config;
}




var $bnENU = parcelRequire("bnENU");
var $ef3c52393d3e4969$exports = {};
"use strict";

$ef3c52393d3e4969$exports = (parcelRequire("hSwM1"));


"use client";
const $43271bd7a0a71e72$var$isPlainObject = (obj)=>typeof obj === "object" && !Array.isArray(obj);
function $43271bd7a0a71e72$export$1a0284c6345ef780(subscribe, getSnapshot, getServerSnapshot = getSnapshot, isEqual = (0, $baaf6fb615ce5ef3$export$9cb4719e2e525b7a)) {
    const trackedKeys = (0, $bnENU.useRef)([]);
    const result = (0, $ef3c52393d3e4969$exports.useSyncExternalStoreWithSelector)(subscribe, getSnapshot, getServerSnapshot, (x)=>x, (a, b)=>{
        if ($43271bd7a0a71e72$var$isPlainObject(a) && $43271bd7a0a71e72$var$isPlainObject(b) && trackedKeys.current.length) {
            for (const key of trackedKeys.current){
                const equal = isEqual(a[key], b[key]);
                if (!equal) return false;
            }
            return true;
        }
        return isEqual(a, b);
    });
    return (0, $bnENU.useMemo)(()=>{
        if ($43271bd7a0a71e72$var$isPlainObject(result)) {
            const trackedResult = {
                ...result
            };
            let properties = {};
            for (const [key, value] of Object.entries(trackedResult))properties = {
                ...properties,
                [key]: {
                    configurable: false,
                    enumerable: true,
                    get: ()=>{
                        if (!trackedKeys.current.includes(key)) trackedKeys.current.push(key);
                        return value;
                    }
                }
            };
            Object.defineProperties(trackedResult, properties);
            return trackedResult;
        }
        return result;
    }, [
        result
    ]);
}


"use client";
function $2739213b2d55f551$export$83a8e409853da004(parameters = {}) {
    const config = (0, $ea535364be670fd7$export$b3611e87cd5ba6ce)(parameters);
    return (0, $43271bd7a0a71e72$export$1a0284c6345ef780)((onChange)=>(0, $5bde27009cbbce16$export$30c94aeff2da2ac6)(config, {
            onChange: onChange
        }), ()=>(0, $588ed08035d28638$export$4f9234baf34abd0)(config));
}


var $bnENU = parcelRequire("bnENU");
// src/mutationObserver.ts
// src/mutation.ts
// src/notifyManager.ts
function $cb00b657be35baa3$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const setScheduler = (fn)=>{
        scheduleFn = fn;
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction,
        setScheduler: setScheduler
    };
}
var $cb00b657be35baa3$export$520687f44db6e1ab = $cb00b657be35baa3$export$316a8efd03cd1458();


// src/removable.ts
// src/utils.ts
var $5dfb5b9a80630a8b$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $5dfb5b9a80630a8b$export$8793edee2d425525() {
    return void 0;
}
function $5dfb5b9a80630a8b$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $5dfb5b9a80630a8b$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $5dfb5b9a80630a8b$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $5dfb5b9a80630a8b$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $5dfb5b9a80630a8b$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$5dfb5b9a80630a8b$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $5dfb5b9a80630a8b$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($5dfb5b9a80630a8b$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $5dfb5b9a80630a8b$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$5dfb5b9a80630a8b$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $5dfb5b9a80630a8b$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $5dfb5b9a80630a8b$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $5dfb5b9a80630a8b$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$5dfb5b9a80630a8b$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $5dfb5b9a80630a8b$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$5dfb5b9a80630a8b$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $5dfb5b9a80630a8b$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $5dfb5b9a80630a8b$export$7a8558113332b71e(a) && $5dfb5b9a80630a8b$export$7a8558113332b71e(b);
    if (array || $5dfb5b9a80630a8b$export$53b83ca8eaab0383(a) && $5dfb5b9a80630a8b$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $5dfb5b9a80630a8b$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $5dfb5b9a80630a8b$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $5dfb5b9a80630a8b$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $5dfb5b9a80630a8b$export$53b83ca8eaab0383(o) {
    if (!$5dfb5b9a80630a8b$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$5dfb5b9a80630a8b$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $5dfb5b9a80630a8b$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $5dfb5b9a80630a8b$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $5dfb5b9a80630a8b$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $5dfb5b9a80630a8b$export$77a71fc411098696(prevData, data);
    return data;
}
function $5dfb5b9a80630a8b$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $5dfb5b9a80630a8b$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $5dfb5b9a80630a8b$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $5dfb5b9a80630a8b$export$1aa5a89531b7670d = Symbol();


var $55b970f24c1c5ee7$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $5dfb5b9a80630a8b$export$e539f754e934e270)(this.gcTime)) this.#gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $5dfb5b9a80630a8b$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout) {
            clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};


// src/retryer.ts
// src/focusManager.ts
// src/subscribable.ts
var $d61d2bdd5fa15550$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $7b5df0496e6ff019$export$86f1af424b2ca4de = class extends (0, $d61d2bdd5fa15550$export$d26086b469ecdbcc) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (!(0, $5dfb5b9a80630a8b$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $7b5df0496e6ff019$export$6bf54661be5b02cf = new $7b5df0496e6ff019$export$86f1af424b2ca4de();


// src/onlineManager.ts


var $54b2c43c090d3758$export$58774fb55d5ff7fc = class extends (0, $d61d2bdd5fa15550$export$d26086b469ecdbcc) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (!(0, $5dfb5b9a80630a8b$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $54b2c43c090d3758$export$b113e788b2dd3fdc = new $54b2c43c090d3758$export$58774fb55d5ff7fc();



function $8dc79ca1ee4f70f8$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $8dc79ca1ee4f70f8$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $54b2c43c090d3758$export$b113e788b2dd3fdc).isOnline() : true;
}
var $8dc79ca1ee4f70f8$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $8dc79ca1ee4f70f8$export$986cc6445c1d323(value) {
    return value instanceof $8dc79ca1ee4f70f8$export$a8430ed4188f35a9;
}
function $8dc79ca1ee4f70f8$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $8dc79ca1ee4f70f8$export$a8430ed4188f35a9(cancelOptions));
            config.abort?.();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $7b5df0496e6ff019$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $54b2c43c090d3758$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$8dc79ca1ee4f70f8$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess?.(value);
            continueFn?.();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError?.(value);
            continueFn?.();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved) return;
            const retry = config.retry ?? ((0, $5dfb5b9a80630a8b$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $8dc79ca1ee4f70f8$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $5dfb5b9a80630a8b$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return promise;
        }
    };
}


var $c39499a820a95a1b$export$17b8b19c814bcf56 = class extends (0, $55b970f24c1c5ee7$export$e09608847fcc8c59) {
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $c39499a820a95a1b$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        this.#retryer = (0, $8dc79ca1ee4f70f8$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (!restored) {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await this.#mutationCache.config.onMutate?.(variables, this);
                const context = await this.options.onMutate?.(variables);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this);
            await this.options.onSuccess?.(data, variables, this.state.context);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this);
            await this.options.onSettled?.(data, null, variables, this.state.context);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this);
                await this.options.onError?.(error, variables, this.state.context);
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this);
                await this.options.onSettled?.(void 0, error, variables, this.state.context);
                throw error;
            } finally{
                this.#dispatch({
                    type: "error",
                    error: error
                });
            }
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $c39499a820a95a1b$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}





var $2b163f63612da3bf$export$d3c1860ee66f291a = class extends (0, $d61d2bdd5fa15550$export$d26086b469ecdbcc) {
    #client;
    #currentResult = void 0;
    #currentMutation;
    #mutateOptions;
    constructor(client, options){
        super();
        this.#client = client;
        this.setOptions(options);
        this.bindMethods();
        this.#updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        this.options = this.#client.defaultMutationOptions(options);
        if (!(0, $5dfb5b9a80630a8b$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.#currentMutation,
            observer: this
        });
        if (prevOptions?.mutationKey && this.options.mutationKey && (0, $5dfb5b9a80630a8b$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $5dfb5b9a80630a8b$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (this.#currentMutation?.state.status === "pending") this.#currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.#currentMutation?.removeObserver(this);
    }
    onMutationUpdate(action) {
        this.#updateResult();
        this.#notify(action);
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    reset() {
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = void 0;
        this.#updateResult();
        this.#notify();
    }
    mutate(variables, options) {
        this.#mutateOptions = options;
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
        this.#currentMutation.addObserver(this);
        return this.#currentMutation.execute(variables);
    }
    #updateResult() {
        const state = this.#currentMutation?.state ?? (0, $c39499a820a95a1b$export$a1659b54bac3252a)();
        this.#currentResult = {
            ...state,
            isPending: state.status === "pending",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
    }
    #notify(action) {
        (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            if (this.#mutateOptions && this.hasListeners()) {
                const variables = this.#currentResult.variables;
                const context = this.#currentResult.context;
                if (action?.type === "success") {
                    this.#mutateOptions.onSuccess?.(action.data, variables, context);
                    this.#mutateOptions.onSettled?.(action.data, null, variables, context);
                } else if (action?.type === "error") {
                    this.#mutateOptions.onError?.(action.error, variables, context);
                    this.#mutateOptions.onSettled?.(void 0, action.error, variables, context);
                }
            }
            this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
        });
    }
};



var $bnENU = parcelRequire("bnENU");

"use client";
var $074a53b639ae13c4$export$da112d31b0149f31 = $bnENU.createContext(void 0);
var $074a53b639ae13c4$export$22e77b9572c4fded = (queryClient)=>{
    const client = $bnENU.useContext($074a53b639ae13c4$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $074a53b639ae13c4$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $bnENU.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $7476e21157772a88$exports.jsx)($074a53b639ae13c4$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};


// src/utils.ts
function $685fcd25582b7cef$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $685fcd25582b7cef$export$8793edee2d425525() {}


"use client";
function $180789730b14140c$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $074a53b639ae13c4$export$22e77b9572c4fded)(queryClient);
    const [observer] = $bnENU.useState(()=>new (0, $2b163f63612da3bf$export$d3c1860ee66f291a)(client, options));
    $bnENU.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $bnENU.useSyncExternalStore($bnENU.useCallback((onStoreChange)=>observer.subscribe((0, $cb00b657be35baa3$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $bnENU.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $685fcd25582b7cef$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $685fcd25582b7cef$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}



function $bb495c7e07796073$export$81bca4b1e9392240(config) {
    return {
        mutationFn (variables) {
            return (0, $a724cc6b117c9948$export$37dfea93db2e14ed)(config, variables);
        },
        mutationKey: [
            "disconnect"
        ]
    };
}




let $c5827656916fc9ba$var$previousConnections = [];
function $c5827656916fc9ba$export$82b9f8f75cc709b4(config) {
    const connections = [
        ...config.state.connections.values()
    ];
    if (config.state.status === "reconnecting") return $c5827656916fc9ba$var$previousConnections;
    if ((0, $baaf6fb615ce5ef3$export$9cb4719e2e525b7a)($c5827656916fc9ba$var$previousConnections, connections)) return $c5827656916fc9ba$var$previousConnections;
    $c5827656916fc9ba$var$previousConnections = connections;
    return connections;
}



function $a8a098b047517e0d$export$a7de891c4ee82d0d(config, parameters) {
    const { onChange: onChange } = parameters;
    return config.subscribe(()=>(0, $c5827656916fc9ba$export$82b9f8f75cc709b4)(config), onChange, {
        equalityFn: (0, $baaf6fb615ce5ef3$export$9cb4719e2e525b7a)
    });
}



var $bnENU = parcelRequire("bnENU");

"use client";
function $1e694e1c862c3961$export$e54e57ae932f0754(parameters = {}) {
    const config = (0, $ea535364be670fd7$export$b3611e87cd5ba6ce)(parameters);
    return (0, $bnENU.useSyncExternalStore)((onChange)=>(0, $a8a098b047517e0d$export$a7de891c4ee82d0d)(config, {
            onChange: onChange
        }), ()=>(0, $c5827656916fc9ba$export$82b9f8f75cc709b4)(config), ()=>(0, $c5827656916fc9ba$export$82b9f8f75cc709b4)(config));
}


"use client";
function $9d39a2f446de0538$export$83bebf2fe7fead4e(parameters = {}) {
    const { mutation: mutation } = parameters;
    const config = (0, $ea535364be670fd7$export$b3611e87cd5ba6ce)(parameters);
    const mutationOptions = (0, $bb495c7e07796073$export$81bca4b1e9392240)(config);
    const { mutate: mutate, mutateAsync: mutateAsync, ...result } = (0, $180789730b14140c$export$609860bf8b0084c)({
        ...mutation,
        ...mutationOptions
    });
    return {
        ...result,
        connectors: (0, $1e694e1c862c3961$export$e54e57ae932f0754)({
            config: config
        }).map((connection)=>connection.connector),
        disconnect: mutate,
        disconnectAsync: mutateAsync
    };
}


var $037ea4094b2de8f5$exports = {};

$037ea4094b2de8f5$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "Wave.2a680c9e.svg";


var $18a35bb413290b73$exports = {};

$18a35bb413290b73$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "Wave2.22db6b94.svg";


var $d8717c29a0ad1971$exports = {};

$d8717c29a0ad1971$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "Wave3.ea6ec40e.svg";




parcelRequire("bnENU");
function $d15b0de6bb1f6866$var$Copy(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("g", {
                clipPath: "url(#clip0_3_1274)",
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M16 3H4V16",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M8 7H20V19C20 20.1046 19.1046 21 18 21H10C8.89543 21 8 20.1046 8 19V7Z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("clipPath", {
                    id: "clip0_3_1274",
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
var $d15b0de6bb1f6866$export$2e2bcd8739ae039 = $d15b0de6bb1f6866$var$Copy;



parcelRequire("bnENU");

function $47c8fb8b4a8751d5$var$GasPump(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
        viewBox: "4 2.7 25.33 26.67",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M10 8.03353C9.63181 8.03353 9.33333 8.33201 9.33333 8.70019V14.7002H14.6667V8.70019C14.6667 8.33201 14.3682 8.03353 14 8.03353H10Z"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 2.7002C5.79086 2.7002 4 4.49106 4 6.7002V28.0335C4 28.7699 4.59695 29.3669 5.33333 29.3669H18.6667C19.403 29.3669 20 28.7699 20 28.0335V17.3669H20.9253C21.7367 17.3669 22.36 18.0855 22.2452 18.8888L21.7507 22.3508C21.4227 24.6464 23.204 26.7002 25.5228 26.7002C27.6273 26.7002 29.3333 24.9942 29.3333 22.8897V10.5858C29.3333 9.87857 29.0524 9.20029 28.5523 8.70019L24.2761 4.42405L22.3905 6.30967L24 7.91915V11.8535C24 12.2492 24.1758 12.6244 24.4798 12.8778L26.6667 14.7002V22.8897C26.6667 23.5214 26.1546 24.0335 25.5228 24.0335C24.8268 24.0335 24.2921 23.417 24.3905 22.728L24.8851 19.2659C25.2294 16.8561 23.3595 14.7002 20.9253 14.7002H20V6.7002C20 4.49106 18.2091 2.7002 16 2.7002H8ZM17.3333 6.7002C17.3333 5.96382 16.7364 5.36686 16 5.36686H8C7.26362 5.36686 6.66667 5.96382 6.66667 6.7002V26.7002H17.3333V6.7002Z"
            })
        ]
    });
}
var $47c8fb8b4a8751d5$export$2e2bcd8739ae039 = $47c8fb8b4a8751d5$var$GasPump;





/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $32ac5983a02c513a$export$a143d493d941bafc;
var $32ac5983a02c513a$export$e4cf37d7f6fb9e0a;
var $32ac5983a02c513a$export$f99ded8fe4b79145;
var $32ac5983a02c513a$export$599f31c3813fae4d;
"use strict";

var $gxC2H = parcelRequire("gxC2H");

var $8YfQz = parcelRequire("8YfQz");
const $32ac5983a02c513a$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$32ac5983a02c513a$export$a143d493d941bafc = $32ac5983a02c513a$var$Buffer;
$32ac5983a02c513a$export$e4cf37d7f6fb9e0a = $32ac5983a02c513a$var$SlowBuffer;
$32ac5983a02c513a$export$f99ded8fe4b79145 = 50;
const $32ac5983a02c513a$var$K_MAX_LENGTH = 0x7fffffff;
$32ac5983a02c513a$export$599f31c3813fae4d = $32ac5983a02c513a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $32ac5983a02c513a$var$Buffer.TYPED_ARRAY_SUPPORT = $32ac5983a02c513a$var$typedArraySupport();
if (!$32ac5983a02c513a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $32ac5983a02c513a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($32ac5983a02c513a$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$32ac5983a02c513a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($32ac5983a02c513a$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$32ac5983a02c513a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $32ac5983a02c513a$var$createBuffer(length) {
    if (length > $32ac5983a02c513a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $32ac5983a02c513a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $32ac5983a02c513a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $32ac5983a02c513a$var$allocUnsafe(arg);
    }
    return $32ac5983a02c513a$var$from(arg, encodingOrOffset, length);
}
$32ac5983a02c513a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $32ac5983a02c513a$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $32ac5983a02c513a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $32ac5983a02c513a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($32ac5983a02c513a$var$isInstance(value, ArrayBuffer) || value && $32ac5983a02c513a$var$isInstance(value.buffer, ArrayBuffer)) return $32ac5983a02c513a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($32ac5983a02c513a$var$isInstance(value, SharedArrayBuffer) || value && $32ac5983a02c513a$var$isInstance(value.buffer, SharedArrayBuffer))) return $32ac5983a02c513a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $32ac5983a02c513a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $32ac5983a02c513a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $32ac5983a02c513a$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $32ac5983a02c513a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $32ac5983a02c513a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($32ac5983a02c513a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($32ac5983a02c513a$var$Buffer, Uint8Array);
function $32ac5983a02c513a$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $32ac5983a02c513a$var$alloc(size, fill, encoding) {
    $32ac5983a02c513a$var$assertSize(size);
    if (size <= 0) return $32ac5983a02c513a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $32ac5983a02c513a$var$createBuffer(size).fill(fill, encoding) : $32ac5983a02c513a$var$createBuffer(size).fill(fill);
    return $32ac5983a02c513a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $32ac5983a02c513a$var$Buffer.alloc = function(size, fill, encoding) {
    return $32ac5983a02c513a$var$alloc(size, fill, encoding);
};
function $32ac5983a02c513a$var$allocUnsafe(size) {
    $32ac5983a02c513a$var$assertSize(size);
    return $32ac5983a02c513a$var$createBuffer(size < 0 ? 0 : $32ac5983a02c513a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $32ac5983a02c513a$var$Buffer.allocUnsafe = function(size) {
    return $32ac5983a02c513a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $32ac5983a02c513a$var$Buffer.allocUnsafeSlow = function(size) {
    return $32ac5983a02c513a$var$allocUnsafe(size);
};
function $32ac5983a02c513a$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$32ac5983a02c513a$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $32ac5983a02c513a$var$byteLength(string, encoding) | 0;
    let buf = $32ac5983a02c513a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $32ac5983a02c513a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $32ac5983a02c513a$var$checked(array.length) | 0;
    const buf = $32ac5983a02c513a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $32ac5983a02c513a$var$fromArrayView(arrayView) {
    if ($32ac5983a02c513a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $32ac5983a02c513a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $32ac5983a02c513a$var$fromArrayLike(arrayView);
}
function $32ac5983a02c513a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $32ac5983a02c513a$var$Buffer.prototype);
    return buf;
}
function $32ac5983a02c513a$var$fromObject(obj) {
    if ($32ac5983a02c513a$var$Buffer.isBuffer(obj)) {
        const len = $32ac5983a02c513a$var$checked(obj.length) | 0;
        const buf = $32ac5983a02c513a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $32ac5983a02c513a$var$numberIsNaN(obj.length)) return $32ac5983a02c513a$var$createBuffer(0);
        return $32ac5983a02c513a$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $32ac5983a02c513a$var$fromArrayLike(obj.data);
}
function $32ac5983a02c513a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $32ac5983a02c513a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $32ac5983a02c513a$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $32ac5983a02c513a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $32ac5983a02c513a$var$Buffer.alloc(+length);
}
$32ac5983a02c513a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $32ac5983a02c513a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$32ac5983a02c513a$var$Buffer.compare = function compare(a, b) {
    if ($32ac5983a02c513a$var$isInstance(a, Uint8Array)) a = $32ac5983a02c513a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($32ac5983a02c513a$var$isInstance(b, Uint8Array)) b = $32ac5983a02c513a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$32ac5983a02c513a$var$Buffer.isBuffer(a) || !$32ac5983a02c513a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$32ac5983a02c513a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$32ac5983a02c513a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $32ac5983a02c513a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $32ac5983a02c513a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($32ac5983a02c513a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$32ac5983a02c513a$var$Buffer.isBuffer(buf)) buf = $32ac5983a02c513a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$32ac5983a02c513a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $32ac5983a02c513a$var$byteLength(string, encoding) {
    if ($32ac5983a02c513a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $32ac5983a02c513a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $32ac5983a02c513a$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $32ac5983a02c513a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $32ac5983a02c513a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$32ac5983a02c513a$var$Buffer.byteLength = $32ac5983a02c513a$var$byteLength;
function $32ac5983a02c513a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $32ac5983a02c513a$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $32ac5983a02c513a$var$utf8Slice(this, start, end);
        case "ascii":
            return $32ac5983a02c513a$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $32ac5983a02c513a$var$latin1Slice(this, start, end);
        case "base64":
            return $32ac5983a02c513a$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $32ac5983a02c513a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$32ac5983a02c513a$var$Buffer.prototype._isBuffer = true;
function $32ac5983a02c513a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$32ac5983a02c513a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$32ac5983a02c513a$var$swap(this, i, i + 1);
    return this;
};
$32ac5983a02c513a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $32ac5983a02c513a$var$swap(this, i, i + 3);
        $32ac5983a02c513a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$32ac5983a02c513a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $32ac5983a02c513a$var$swap(this, i, i + 7);
        $32ac5983a02c513a$var$swap(this, i + 1, i + 6);
        $32ac5983a02c513a$var$swap(this, i + 2, i + 5);
        $32ac5983a02c513a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$32ac5983a02c513a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $32ac5983a02c513a$var$utf8Slice(this, 0, length);
    return $32ac5983a02c513a$var$slowToString.apply(this, arguments);
};
$32ac5983a02c513a$var$Buffer.prototype.toLocaleString = $32ac5983a02c513a$var$Buffer.prototype.toString;
$32ac5983a02c513a$var$Buffer.prototype.equals = function equals(b) {
    if (!$32ac5983a02c513a$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $32ac5983a02c513a$var$Buffer.compare(this, b) === 0;
};
$32ac5983a02c513a$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $32ac5983a02c513a$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($32ac5983a02c513a$var$customInspectSymbol) $32ac5983a02c513a$var$Buffer.prototype[$32ac5983a02c513a$var$customInspectSymbol] = $32ac5983a02c513a$var$Buffer.prototype.inspect;
$32ac5983a02c513a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($32ac5983a02c513a$var$isInstance(target, Uint8Array)) target = $32ac5983a02c513a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$32ac5983a02c513a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $32ac5983a02c513a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($32ac5983a02c513a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $32ac5983a02c513a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($32ac5983a02c513a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $32ac5983a02c513a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $32ac5983a02c513a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $32ac5983a02c513a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$32ac5983a02c513a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$32ac5983a02c513a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $32ac5983a02c513a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$32ac5983a02c513a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $32ac5983a02c513a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $32ac5983a02c513a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($32ac5983a02c513a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $32ac5983a02c513a$var$utf8Write(buf, string, offset, length) {
    return $32ac5983a02c513a$var$blitBuffer($32ac5983a02c513a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $32ac5983a02c513a$var$asciiWrite(buf, string, offset, length) {
    return $32ac5983a02c513a$var$blitBuffer($32ac5983a02c513a$var$asciiToBytes(string), buf, offset, length);
}
function $32ac5983a02c513a$var$base64Write(buf, string, offset, length) {
    return $32ac5983a02c513a$var$blitBuffer($32ac5983a02c513a$var$base64ToBytes(string), buf, offset, length);
}
function $32ac5983a02c513a$var$ucs2Write(buf, string, offset, length) {
    return $32ac5983a02c513a$var$blitBuffer($32ac5983a02c513a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$32ac5983a02c513a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $32ac5983a02c513a$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $32ac5983a02c513a$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $32ac5983a02c513a$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $32ac5983a02c513a$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $32ac5983a02c513a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$32ac5983a02c513a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $32ac5983a02c513a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gxC2H.fromByteArray(buf);
    else return $gxC2H.fromByteArray(buf.slice(start, end));
}
function $32ac5983a02c513a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $32ac5983a02c513a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $32ac5983a02c513a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $32ac5983a02c513a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $32ac5983a02c513a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $32ac5983a02c513a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $32ac5983a02c513a$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $32ac5983a02c513a$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $32ac5983a02c513a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $32ac5983a02c513a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $32ac5983a02c513a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$32ac5983a02c513a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $32ac5983a02c513a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $32ac5983a02c513a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$32ac5983a02c513a$var$Buffer.prototype.readUintLE = $32ac5983a02c513a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$32ac5983a02c513a$var$Buffer.prototype.readUintBE = $32ac5983a02c513a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$32ac5983a02c513a$var$Buffer.prototype.readUint8 = $32ac5983a02c513a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$32ac5983a02c513a$var$Buffer.prototype.readUint16LE = $32ac5983a02c513a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$32ac5983a02c513a$var$Buffer.prototype.readUint16BE = $32ac5983a02c513a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$32ac5983a02c513a$var$Buffer.prototype.readUint32LE = $32ac5983a02c513a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$32ac5983a02c513a$var$Buffer.prototype.readUint32BE = $32ac5983a02c513a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$32ac5983a02c513a$var$Buffer.prototype.readBigUInt64LE = $32ac5983a02c513a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $32ac5983a02c513a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $32ac5983a02c513a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$32ac5983a02c513a$var$Buffer.prototype.readBigUInt64BE = $32ac5983a02c513a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $32ac5983a02c513a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $32ac5983a02c513a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$32ac5983a02c513a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$32ac5983a02c513a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$32ac5983a02c513a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$32ac5983a02c513a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$32ac5983a02c513a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$32ac5983a02c513a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$32ac5983a02c513a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$32ac5983a02c513a$var$Buffer.prototype.readBigInt64LE = $32ac5983a02c513a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $32ac5983a02c513a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $32ac5983a02c513a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$32ac5983a02c513a$var$Buffer.prototype.readBigInt64BE = $32ac5983a02c513a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $32ac5983a02c513a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $32ac5983a02c513a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$32ac5983a02c513a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, true, 23, 4);
};
$32ac5983a02c513a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, false, 23, 4);
};
$32ac5983a02c513a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, true, 52, 8);
};
$32ac5983a02c513a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, false, 52, 8);
};
function $32ac5983a02c513a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$32ac5983a02c513a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$32ac5983a02c513a$var$Buffer.prototype.writeUintLE = $32ac5983a02c513a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $32ac5983a02c513a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$32ac5983a02c513a$var$Buffer.prototype.writeUintBE = $32ac5983a02c513a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $32ac5983a02c513a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$32ac5983a02c513a$var$Buffer.prototype.writeUint8 = $32ac5983a02c513a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$32ac5983a02c513a$var$Buffer.prototype.writeUint16LE = $32ac5983a02c513a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$32ac5983a02c513a$var$Buffer.prototype.writeUint16BE = $32ac5983a02c513a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$32ac5983a02c513a$var$Buffer.prototype.writeUint32LE = $32ac5983a02c513a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$32ac5983a02c513a$var$Buffer.prototype.writeUint32BE = $32ac5983a02c513a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $32ac5983a02c513a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $32ac5983a02c513a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $32ac5983a02c513a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $32ac5983a02c513a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$32ac5983a02c513a$var$Buffer.prototype.writeBigUInt64LE = $32ac5983a02c513a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $32ac5983a02c513a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$32ac5983a02c513a$var$Buffer.prototype.writeBigUInt64BE = $32ac5983a02c513a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $32ac5983a02c513a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$32ac5983a02c513a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $32ac5983a02c513a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$32ac5983a02c513a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $32ac5983a02c513a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$32ac5983a02c513a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$32ac5983a02c513a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$32ac5983a02c513a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$32ac5983a02c513a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$32ac5983a02c513a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$32ac5983a02c513a$var$Buffer.prototype.writeBigInt64LE = $32ac5983a02c513a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $32ac5983a02c513a$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$32ac5983a02c513a$var$Buffer.prototype.writeBigInt64BE = $32ac5983a02c513a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $32ac5983a02c513a$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $32ac5983a02c513a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $32ac5983a02c513a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$32ac5983a02c513a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $32ac5983a02c513a$var$writeFloat(this, value, offset, true, noAssert);
};
$32ac5983a02c513a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $32ac5983a02c513a$var$writeFloat(this, value, offset, false, noAssert);
};
function $32ac5983a02c513a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $32ac5983a02c513a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$32ac5983a02c513a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $32ac5983a02c513a$var$writeDouble(this, value, offset, true, noAssert);
};
$32ac5983a02c513a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $32ac5983a02c513a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$32ac5983a02c513a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$32ac5983a02c513a$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$32ac5983a02c513a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$32ac5983a02c513a$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $32ac5983a02c513a$var$Buffer.isBuffer(val) ? val : $32ac5983a02c513a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $32ac5983a02c513a$var$errors = {};
function $32ac5983a02c513a$var$E(sym, getMessage, Base) {
    $32ac5983a02c513a$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$32ac5983a02c513a$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$32ac5983a02c513a$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$32ac5983a02c513a$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $32ac5983a02c513a$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $32ac5983a02c513a$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $32ac5983a02c513a$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $32ac5983a02c513a$var$checkBounds(buf, offset, byteLength) {
    $32ac5983a02c513a$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $32ac5983a02c513a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $32ac5983a02c513a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $32ac5983a02c513a$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $32ac5983a02c513a$var$checkBounds(buf, offset, byteLength);
}
function $32ac5983a02c513a$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $32ac5983a02c513a$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $32ac5983a02c513a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $32ac5983a02c513a$var$validateNumber(value, type);
        throw new $32ac5983a02c513a$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $32ac5983a02c513a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $32ac5983a02c513a$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $32ac5983a02c513a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $32ac5983a02c513a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($32ac5983a02c513a$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $32ac5983a02c513a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $32ac5983a02c513a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $32ac5983a02c513a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $32ac5983a02c513a$var$base64ToBytes(str) {
    return $gxC2H.toByteArray($32ac5983a02c513a$var$base64clean(str));
}
function $32ac5983a02c513a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $32ac5983a02c513a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $32ac5983a02c513a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $32ac5983a02c513a$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $32ac5983a02c513a$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $32ac5983a02c513a$var$BufferBigIntNotDefined : fn;
}
function $32ac5983a02c513a$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


if (typeof window !== "undefined") {
    if (!window.Buffer) window.Buffer = (0, $32ac5983a02c513a$export$a143d493d941bafc);
    if (!window.global) window.global = window;
    if (!window.process) window.process = {};
    if (!window.process?.env) window.process = {
        env: {}
    };
}


/**
 * Announces an EIP-1193 Provider.
 */ function $4e31d713418337b9$export$60dbeacb3287962a(detail) {
    const event = new CustomEvent("eip6963:announceProvider", {
        detail: Object.freeze(detail)
    });
    window.dispatchEvent(event);
    const handler = ()=>window.dispatchEvent(event);
    window.addEventListener("eip6963:requestProvider", handler);
    return ()=>window.removeEventListener("eip6963:requestProvider", handler);
}
function $4e31d713418337b9$export$f262fc9233ecbc18(listener) {
    if (typeof window === "undefined") return;
    const handler = (event)=>listener(event.detail);
    window.addEventListener("eip6963:announceProvider", handler);
    window.dispatchEvent(new CustomEvent("eip6963:requestProvider"));
    return ()=>window.removeEventListener("eip6963:announceProvider", handler);
}


function $22d288f7313aec0a$export$f51a9068ac82ea43() {
    const listeners = new Set();
    let providerDetails = [];
    const request = ()=>(0, $4e31d713418337b9$export$f262fc9233ecbc18)((providerDetail)=>{
            if (providerDetails.some(({ info: info })=>info.uuid === providerDetail.info.uuid)) return;
            providerDetails = [
                ...providerDetails,
                providerDetail
            ];
            listeners.forEach((listener)=>listener(providerDetails, {
                    added: [
                        providerDetail
                    ]
                }));
        });
    let unwatch = request();
    return {
        _listeners () {
            return listeners;
        },
        clear () {
            listeners.forEach((listener)=>listener([], {
                    removed: [
                        ...providerDetails
                    ]
                }));
            providerDetails = [];
        },
        destroy () {
            this.clear();
            listeners.clear();
            unwatch?.();
        },
        findProvider ({ rdns: rdns }) {
            return providerDetails.find((providerDetail)=>providerDetail.info.rdns === rdns);
        },
        getProviders () {
            return providerDetails;
        },
        reset () {
            this.clear();
            unwatch?.();
            unwatch = request();
        },
        subscribe (listener, { emitImmediately: emitImmediately } = {}) {
            listeners.add(listener);
            if (emitImmediately) listener(providerDetails, {
                added: providerDetails
            });
            return ()=>listeners.delete(listener);
        }
    };
}



var $541a880767a0936b$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $541a880767a0936b$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $541a880767a0936b$export$4feba8a1bc8e9afd = $541a880767a0936b$var$reduxImpl;
const $541a880767a0936b$var$trackedConnections = /* @__PURE__ */ new Map();
const $541a880767a0936b$var$getTrackedConnectionState = (name)=>{
    const api = $541a880767a0936b$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $541a880767a0936b$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $541a880767a0936b$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $541a880767a0936b$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $541a880767a0936b$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($541a880767a0936b$import_meta.env ? $541a880767a0936b$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        const { connection: connection, ...connectionInformation } = $541a880767a0936b$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$541a880767a0936b$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($541a880767a0936b$import_meta.env ? $541a880767a0936b$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $541a880767a0936b$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($541a880767a0936b$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($541a880767a0936b$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $541a880767a0936b$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($541a880767a0936b$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $541a880767a0936b$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $541a880767a0936b$export$6922d3b3a607469e = $541a880767a0936b$var$devtoolsImpl;
const $541a880767a0936b$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $541a880767a0936b$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $541a880767a0936b$export$5c593627aef9f076 = $541a880767a0936b$var$subscribeWithSelectorImpl;
const $541a880767a0936b$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $541a880767a0936b$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $541a880767a0936b$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $541a880767a0936b$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $541a880767a0936b$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $541a880767a0936b$var$persistImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $541a880767a0936b$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $541a880767a0936b$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $541a880767a0936b$export$9a6132153fba2e0 = $541a880767a0936b$var$persistImpl;


const $667e73fc927ac14e$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $667e73fc927ac14e$export$f51a9068ac82ea43 = (createState)=>createState ? $667e73fc927ac14e$var$createStoreImpl(createState) : $667e73fc927ac14e$var$createStoreImpl;



var $siouQ = parcelRequire("siouQ");
var $jW8ut = parcelRequire("jW8ut");
var $iy34j = parcelRequire("iy34j");


function $ea4aa100ff3513d7$export$36e7227504c841ea(createConnectorFn) {
    return createConnectorFn;
}


$4a5711e3a5bbc3b2$export$a7a34dad4983656f.type = "injected";
function $4a5711e3a5bbc3b2$export$a7a34dad4983656f(parameters = {}) {
    const { shimDisconnect: shimDisconnect = true, unstable_shimAsyncInject: unstable_shimAsyncInject } = parameters;
    function getTarget() {
        const target = parameters.target;
        if (typeof target === "function") {
            const result = target();
            if (result) return result;
        }
        if (typeof target === "object") return target;
        if (typeof target === "string") return {
            ...$4a5711e3a5bbc3b2$var$targetMap[target] ?? {
                id: target,
                name: `${target[0].toUpperCase()}${target.slice(1)}`,
                provider: `is${target[0].toUpperCase()}${target.slice(1)}`
            }
        };
        return {
            id: "injected",
            name: "Injected",
            provider (window1) {
                return window1?.ethereum;
            }
        };
    }
    let accountsChanged;
    let chainChanged;
    let connect;
    let disconnect;
    return (0, $ea4aa100ff3513d7$export$36e7227504c841ea)((config)=>({
            get icon () {
                return getTarget().icon;
            },
            get id () {
                return getTarget().id;
            },
            get name () {
                return getTarget().name;
            },
            /** @deprecated */ get supportsSimulation () {
                return true;
            },
            type: $4a5711e3a5bbc3b2$export$a7a34dad4983656f.type,
            async setup () {
                const provider = await this.getProvider();
                // Only start listening for events if `target` is set, otherwise `injected()` will also receive events
                if (provider?.on && parameters.target) {
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider.on("connect", connect);
                    }
                    // We shouldn't need to listen for `'accountsChanged'` here since the `'connect'` event should suffice (and wallet shouldn't be connected yet).
                    // Some wallets, like MetaMask, do not implement the `'connect'` event and overload `'accountsChanged'` instead.
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                }
            },
            async connect ({ chainId: chainId, isReconnecting: isReconnecting } = {}) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $051d3f9d080da18b$export$43839b3ff6336f15)();
                let accounts = [];
                if (isReconnecting) accounts = await this.getAccounts().catch(()=>[]);
                else if (shimDisconnect) // Attempt to show another prompt for selecting account if `shimDisconnect` flag is enabled
                try {
                    const permissions = await provider.request({
                        method: "wallet_requestPermissions",
                        params: [
                            {
                                eth_accounts: {}
                            }
                        ]
                    });
                    accounts = permissions[0]?.caveats?.[0]?.value?.map((x)=>(0, $siouQ.getAddress)(x));
                    // `'wallet_requestPermissions'` can return a different order of accounts than `'eth_accounts'`
                    // switch to `'eth_accounts'` ordering if more than one account is connected
                    // https://github.com/wevm/wagmi/issues/4140
                    if (accounts.length > 0) {
                        const sortedAccounts = await this.getAccounts();
                        accounts = sortedAccounts;
                    }
                } catch (err) {
                    const error = err;
                    // Not all injected providers support `wallet_requestPermissions` (e.g. MetaMask iOS).
                    // Only bubble up error if user rejects request
                    if (error.code === (0, $iy34j.UserRejectedRequestError).code) throw new (0, $iy34j.UserRejectedRequestError)(error);
                    // Or prompt is already open
                    if (error.code === (0, $iy34j.ResourceUnavailableRpcError).code) throw error;
                }
                try {
                    if (!accounts?.length && !isReconnecting) {
                        const requestedAccounts = await provider.request({
                            method: "eth_requestAccounts"
                        });
                        accounts = requestedAccounts.map((x)=>(0, $siouQ.getAddress)(x));
                    }
                    // Manage EIP-1193 event listeners
                    // https://eips.ethereum.org/EIPS/eip-1193#events
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    // Switch to chain if provided
                    let currentChainId = await this.getChainId();
                    if (chainId && currentChainId !== chainId) {
                        const chain = await this.switchChain({
                            chainId: chainId
                        }).catch((error)=>{
                            if (error.code === (0, $iy34j.UserRejectedRequestError).code) throw error;
                            return {
                                id: currentChainId
                            };
                        });
                        currentChainId = chain?.id ?? currentChainId;
                    }
                    // Remove disconnected shim if it exists
                    if (shimDisconnect) await config.storage?.removeItem(`${this.id}.disconnected`);
                    // Add connected shim if no target exists
                    if (!parameters.target) await config.storage?.setItem("injected.connected", true);
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (err) {
                    const error = err;
                    if (error.code === (0, $iy34j.UserRejectedRequestError).code) throw new (0, $iy34j.UserRejectedRequestError)(error);
                    if (error.code === (0, $iy34j.ResourceUnavailableRpcError).code) throw new (0, $iy34j.ResourceUnavailableRpcError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $051d3f9d080da18b$export$43839b3ff6336f15)();
                // Manage EIP-1193 event listeners
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                if (!connect) {
                    connect = this.onConnect.bind(this);
                    provider.on("connect", connect);
                }
                // Experimental support for MetaMask disconnect
                // https://github.com/MetaMask/metamask-improvement-proposals/blob/main/MIPs/mip-2.md
                try {
                    // Adding timeout as not all wallets support this method and can hang
                    // https://github.com/wevm/wagmi/issues/4064
                    await (0, $663c055184be543e$export$e86e19342bc4850e)(()=>// TODO: Remove explicit type for viem@3
                        provider.request({
                            // `'wallet_revokePermissions'` added in `viem@2.10.3`
                            method: "wallet_revokePermissions",
                            params: [
                                {
                                    eth_accounts: {}
                                }
                            ]
                        }), {
                        timeout: 100
                    });
                } catch  {}
                // Add shim signalling connector is disconnected
                if (shimDisconnect) await config.storage?.setItem(`${this.id}.disconnected`, true);
                if (!parameters.target) await config.storage?.removeItem("injected.connected");
            },
            async getAccounts () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $051d3f9d080da18b$export$43839b3ff6336f15)();
                const accounts = await provider.request({
                    method: "eth_accounts"
                });
                return accounts.map((x)=>(0, $siouQ.getAddress)(x));
            },
            async getChainId () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $051d3f9d080da18b$export$43839b3ff6336f15)();
                const hexChainId = await provider.request({
                    method: "eth_chainId"
                });
                return Number(hexChainId);
            },
            async getProvider () {
                if (typeof window === "undefined") return undefined;
                let provider;
                const target = getTarget();
                if (typeof target.provider === "function") provider = target.provider(window);
                else if (typeof target.provider === "string") provider = $4a5711e3a5bbc3b2$var$findProvider(window, target.provider);
                else provider = target.provider;
                // Some wallets do not conform to EIP-1193 (e.g. Trust Wallet)
                // https://github.com/wevm/wagmi/issues/3526#issuecomment-1912683002
                if (provider && !provider.removeListener) {
                    // Try using `off` handler if it exists, otherwise noop
                    if ("off" in provider && typeof provider.off === "function") provider.removeListener = provider.off;
                    else provider.removeListener = ()=>{};
                }
                return provider;
            },
            async isAuthorized () {
                try {
                    const isDisconnected = shimDisconnect && // If shim exists in storage, connector is disconnected
                    await config.storage?.getItem(`${this.id}.disconnected`);
                    if (isDisconnected) return false;
                    // Don't allow injected connector to connect if no target is set and it hasn't already connected
                    // (e.g. flag in storage is not set). This prevents a targetless injected connector from connecting
                    // automatically whenever there is a targeted connector configured.
                    if (!parameters.target) {
                        const connected = await config.storage?.getItem("injected.connected");
                        if (!connected) return false;
                    }
                    const provider = await this.getProvider();
                    if (!provider) {
                        if (unstable_shimAsyncInject !== undefined && unstable_shimAsyncInject !== false) {
                            // If no provider is found, check for async injection
                            // https://github.com/wevm/references/issues/167
                            // https://github.com/MetaMask/detect-provider
                            const handleEthereum = async ()=>{
                                if (typeof window !== "undefined") window.removeEventListener("ethereum#initialized", handleEthereum);
                                const provider = await this.getProvider();
                                return !!provider;
                            };
                            const timeout = typeof unstable_shimAsyncInject === "number" ? unstable_shimAsyncInject : 1000;
                            const res = await Promise.race([
                                ...typeof window !== "undefined" ? [
                                    new Promise((resolve)=>window.addEventListener("ethereum#initialized", ()=>resolve(handleEthereum()), {
                                            once: true
                                        }))
                                ] : [],
                                new Promise((resolve)=>setTimeout(()=>resolve(handleEthereum()), timeout))
                            ]);
                            if (res) return true;
                        }
                        throw new (0, $051d3f9d080da18b$export$43839b3ff6336f15)();
                    }
                    // Use retry strategy as some injected wallets (e.g. MetaMask) fail to
                    // immediately resolve JSON-RPC requests on page load.
                    const accounts = await (0, $32aed14017c02240$export$188df5ecf8e7961a)(()=>this.getAccounts());
                    return !!accounts.length;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $051d3f9d080da18b$export$43839b3ff6336f15)();
                const chain = config.chains.find((x)=>x.id === chainId);
                if (!chain) throw new (0, $iy34j.SwitchChainError)(new (0, $dfd1b5f3c842a678$export$688e5fda4b4631ed)());
                const promise = new Promise((resolve)=>{
                    const listener = (data)=>{
                        if ("chainId" in data && data.chainId === chainId) {
                            config.emitter.off("change", listener);
                            resolve();
                        }
                    };
                    config.emitter.on("change", listener);
                });
                try {
                    await Promise.all([
                        provider.request({
                            method: "wallet_switchEthereumChain",
                            params: [
                                {
                                    chainId: (0, $jW8ut.numberToHex)(chainId)
                                }
                            ]
                        })// During `'wallet_switchEthereumChain'`, MetaMask makes a `'net_version'` RPC call to the target chain.
                        // If this request fails, MetaMask does not emit the `'chainChanged'` event, but will still switch the chain.
                        // To counter this behavior, we request and emit the current chain ID to confirm the chain switch either via
                        // this callback or an externally emitted `'chainChanged'` event.
                        // https://github.com/MetaMask/metamask-extension/issues/24247
                        .then(async ()=>{
                            const currentChainId = await this.getChainId();
                            if (currentChainId === chainId) config.emitter.emit("change", {
                                chainId: chainId
                            });
                        }),
                        promise
                    ]);
                    return chain;
                } catch (err) {
                    const error = err;
                    // Indicates chain is not added to provider
                    if (error.code === 4902 || // Unwrapping for MetaMask Mobile
                    // https://github.com/MetaMask/metamask-mobile/issues/2944#issuecomment-976988719
                    error?.data?.originalError?.code === 4902) try {
                        const { default: blockExplorer, ...blockExplorers } = chain.blockExplorers ?? {};
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else if (blockExplorer) blockExplorerUrls = [
                            blockExplorer.url,
                            ...Object.values(blockExplorers).map((x)=>x.url)
                        ];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            chain.rpcUrls.default?.http[0] ?? ""
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $jW8ut.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await Promise.all([
                            provider.request({
                                method: "wallet_addEthereumChain",
                                params: [
                                    addEthereumChain
                                ]
                            }).then(async ()=>{
                                const currentChainId = await this.getChainId();
                                if (currentChainId === chainId) config.emitter.emit("change", {
                                    chainId: chainId
                                });
                                else throw new (0, $iy34j.UserRejectedRequestError)(new Error("User rejected switch after adding network."));
                            }),
                            promise
                        ]);
                        return chain;
                    } catch (error) {
                        throw new (0, $iy34j.UserRejectedRequestError)(error);
                    }
                    if (error.code === (0, $iy34j.UserRejectedRequestError).code) throw new (0, $iy34j.UserRejectedRequestError)(error);
                    throw new (0, $iy34j.SwitchChainError)(error);
                }
            },
            async onAccountsChanged (accounts) {
                // Disconnect if there are no accounts
                if (accounts.length === 0) this.onDisconnect();
                else if (config.emitter.listenerCount("connect")) {
                    const chainId = (await this.getChainId()).toString();
                    this.onConnect({
                        chainId: chainId
                    });
                    // Remove disconnected shim if it exists
                    if (shimDisconnect) await config.storage?.removeItem(`${this.id}.disconnected`);
                } else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $siouQ.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onConnect (connectInfo) {
                const accounts = await this.getAccounts();
                if (accounts.length === 0) return;
                const chainId = Number(connectInfo.chainId);
                config.emitter.emit("connect", {
                    accounts: accounts,
                    chainId: chainId
                });
                // Manage EIP-1193 event listeners
                const provider = await this.getProvider();
                if (provider) {
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                }
            },
            async onDisconnect (error) {
                const provider = await this.getProvider();
                // If MetaMask emits a `code: 1013` error, wait for reconnection before disconnecting
                // https://github.com/MetaMask/providers/pull/120
                if (error && error.code === 1013) {
                    if (provider && !!(await this.getAccounts()).length) return;
                }
                // No need to remove `${this.id}.disconnected` from storage because `onDisconnect` is typically
                // only called when the wallet is disconnected through the wallet's interface, meaning the wallet
                // actually disconnected and we don't need to simulate it.
                config.emitter.emit("disconnect");
                // Manage EIP-1193 event listeners
                if (provider) {
                    if (chainChanged) {
                        provider.removeListener("chainChanged", chainChanged);
                        chainChanged = undefined;
                    }
                    if (disconnect) {
                        provider.removeListener("disconnect", disconnect);
                        disconnect = undefined;
                    }
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider.on("connect", connect);
                    }
                }
            }
        }));
}
const $4a5711e3a5bbc3b2$var$targetMap = {
    coinbaseWallet: {
        id: "coinbaseWallet",
        name: "Coinbase Wallet",
        provider (window1) {
            if (window1?.coinbaseWalletExtension) return window1.coinbaseWalletExtension;
            return $4a5711e3a5bbc3b2$var$findProvider(window1, "isCoinbaseWallet");
        }
    },
    metaMask: {
        id: "metaMask",
        name: "MetaMask",
        provider (window1) {
            return $4a5711e3a5bbc3b2$var$findProvider(window1, (provider)=>{
                if (!provider.isMetaMask) return false;
                // Brave tries to make itself look like MetaMask
                // Could also try RPC `web3_clientVersion` if following is unreliable
                if (provider.isBraveWallet && !provider._events && !provider._state) return false;
                // Other wallets that try to look like MetaMask
                const flags = [
                    "isApexWallet",
                    "isAvalanche",
                    "isBitKeep",
                    "isBlockWallet",
                    "isKuCoinWallet",
                    "isMathWallet",
                    "isOkxWallet",
                    "isOKExWallet",
                    "isOneInchIOSWallet",
                    "isOneInchAndroidWallet",
                    "isOpera",
                    "isPhantom",
                    "isPortal",
                    "isRabby",
                    "isTokenPocket",
                    "isTokenary",
                    "isUniswapWallet",
                    "isZerion"
                ];
                for (const flag of flags)if (provider[flag]) return false;
                return true;
            });
        }
    },
    phantom: {
        id: "phantom",
        name: "Phantom",
        provider (window1) {
            if (window1?.phantom?.ethereum) return window1.phantom?.ethereum;
            return $4a5711e3a5bbc3b2$var$findProvider(window1, "isPhantom");
        }
    }
};
function $4a5711e3a5bbc3b2$var$findProvider(window1, select) {
    function isProvider(provider) {
        if (typeof select === "function") return select(provider);
        if (typeof select === "string") return provider[select];
        return true;
    }
    const ethereum = window1.ethereum;
    if (ethereum?.providers) return ethereum.providers.find((provider)=>isProvider(provider));
    if (ethereum && isProvider(ethereum)) return ethereum;
    return undefined;
}


parcelRequire("eLDY1");
var $goI5y = parcelRequire("goI5y");
class $0c5cc813a7f718dc$export$4293555f241ae35a {
    constructor(uid){
        Object.defineProperty(this, "uid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: uid
        });
        Object.defineProperty(this, "_emitter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new (0, (/*@__PURE__*/$parcel$interopDefault($goI5y)))()
        });
    }
    on(eventName, fn) {
        this._emitter.on(eventName, fn);
    }
    once(eventName, fn) {
        this._emitter.once(eventName, fn);
    }
    off(eventName, fn) {
        this._emitter.off(eventName, fn);
    }
    emit(eventName, ...params) {
        const data = params[0];
        this._emitter.emit(eventName, {
            uid: this.uid,
            ...data
        });
    }
    listenerCount(eventName) {
        return this._emitter.listenerCount(eventName);
    }
}
function $0c5cc813a7f718dc$export$6f5e8f34570e3ad1(uid) {
    return new $0c5cc813a7f718dc$export$4293555f241ae35a(uid);
}


function $09c13ea88c9fee65$export$efcd34ab6248d3cd(value, reviver) {
    return JSON.parse(value, (key, value_)=>{
        let value = value_;
        if (value?.__type === "bigint") value = BigInt(value.value);
        if (value?.__type === "Map") value = new Map(value.value);
        return reviver?.(key, value) ?? value;
    });
}


/**
 * Get the reference key for the circular value
 *
 * @param keys the keys to build the reference key from
 * @param cutoff the maximum number of keys to include
 * @returns the reference key
 */ function $c74d21996b98a54e$var$getReferenceKey(keys, cutoff) {
    return keys.slice(0, cutoff).join(".") || ".";
}
/**
 * Faster `Array.prototype.indexOf` implementation build for slicing / splicing
 *
 * @param array the array to match the value in
 * @param value the value to match
 * @returns the matching index, or -1
 */ function $c74d21996b98a54e$var$getCutoff(array, value) {
    const { length: length } = array;
    for(let index = 0; index < length; ++index){
        if (array[index] === value) return index + 1;
    }
    return 0;
}
/**
 * Create a replacer method that handles circular values
 *
 * @param [replacer] a custom replacer to use for non-circular values
 * @param [circularReplacer] a custom replacer to use for circular methods
 * @returns the value to stringify
 */ function $c74d21996b98a54e$var$createReplacer(replacer, circularReplacer) {
    const hasReplacer = typeof replacer === "function";
    const hasCircularReplacer = typeof circularReplacer === "function";
    const cache = [];
    const keys = [];
    return function replace(key, value) {
        if (typeof value === "object") {
            if (cache.length) {
                const thisCutoff = $c74d21996b98a54e$var$getCutoff(cache, this);
                if (thisCutoff === 0) cache[cache.length] = this;
                else {
                    cache.splice(thisCutoff);
                    keys.splice(thisCutoff);
                }
                keys[keys.length] = key;
                const valueCutoff = $c74d21996b98a54e$var$getCutoff(cache, value);
                if (valueCutoff !== 0) return hasCircularReplacer ? circularReplacer.call(this, key, value, $c74d21996b98a54e$var$getReferenceKey(keys, valueCutoff)) : `[ref=${$c74d21996b98a54e$var$getReferenceKey(keys, valueCutoff)}]`;
            } else {
                cache[0] = value;
                keys[0] = key;
            }
        }
        return hasReplacer ? replacer.call(this, key, value) : value;
    };
}
function $c74d21996b98a54e$export$dfdc1655ccc5b9cb(value, replacer, indent, circularReplacer) {
    return JSON.stringify(value, $c74d21996b98a54e$var$createReplacer((key, value_)=>{
        let value = value_;
        if (typeof value === "bigint") value = {
            __type: "bigint",
            value: value_.toString()
        };
        if (value instanceof Map) value = {
            __type: "Map",
            value: Array.from(value_.entries())
        };
        return replacer?.(key, value) ?? value;
    }, circularReplacer), indent ?? undefined);
}


function $8c740450f9355fb3$export$d184a47a971dd4b9(parameters) {
    const { deserialize: deserialize = (0, $09c13ea88c9fee65$export$efcd34ab6248d3cd), key: prefix = "wagmi", serialize: serialize = (0, $c74d21996b98a54e$export$dfdc1655ccc5b9cb), storage: storage = $8c740450f9355fb3$export$e2ef6c4b988c05b } = parameters;
    function unwrap(value) {
        if (value instanceof Promise) return value.then((x)=>x).catch(()=>null);
        return value;
    }
    return {
        ...storage,
        key: prefix,
        async getItem (key, defaultValue) {
            const value = storage.getItem(`${prefix}.${key}`);
            const unwrapped = await unwrap(value);
            if (unwrapped) return deserialize(unwrapped) ?? null;
            return defaultValue ?? null;
        },
        async setItem (key, value) {
            const storageKey = `${prefix}.${key}`;
            if (value === null) await unwrap(storage.removeItem(storageKey));
            else await unwrap(storage.setItem(storageKey, serialize(value)));
        },
        async removeItem (key) {
            await unwrap(storage.removeItem(`${prefix}.${key}`));
        }
    };
}
const $8c740450f9355fb3$export$e2ef6c4b988c05b = {
    getItem: ()=>null,
    setItem: ()=>{},
    removeItem: ()=>{}
};
function $8c740450f9355fb3$export$c164ff19f266df37() {
    const storage = (()=>{
        if (typeof window !== "undefined" && window.localStorage) return window.localStorage;
        return $8c740450f9355fb3$export$e2ef6c4b988c05b;
    })();
    return {
        getItem (key) {
            return storage.getItem(key);
        },
        removeItem (key) {
            storage.removeItem(key);
        },
        setItem (key, value) {
            try {
                storage.setItem(key, value);
            // silence errors by default (QuotaExceededError, SecurityError, etc.)
            } catch  {}
        }
    };
}



const $5898fd028c950550$var$size = 256;
let $5898fd028c950550$var$index = $5898fd028c950550$var$size;
let $5898fd028c950550$var$buffer;
function $5898fd028c950550$export$e2a22331486dcca0(length = 11) {
    if (!$5898fd028c950550$var$buffer || $5898fd028c950550$var$index + length > $5898fd028c950550$var$size * 2) {
        $5898fd028c950550$var$buffer = "";
        $5898fd028c950550$var$index = 0;
        for(let i = 0; i < $5898fd028c950550$var$size; i++)$5898fd028c950550$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $5898fd028c950550$var$buffer.substring($5898fd028c950550$var$index, $5898fd028c950550$var$index++ + length);
}



function $6018651d757f98d4$export$45a69314cf48a3eb(parameters) {
    const { multiInjectedProviderDiscovery: multiInjectedProviderDiscovery = true, storage: storage = (0, $8c740450f9355fb3$export$d184a47a971dd4b9)({
        storage: (0, $8c740450f9355fb3$export$c164ff19f266df37)()
    }), syncConnectedChain: syncConnectedChain = true, ssr: ssr = false, ...rest } = parameters;
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Set up connectors, clients, etc.
    /////////////////////////////////////////////////////////////////////////////////////////////////
    const mipd = typeof window !== "undefined" && multiInjectedProviderDiscovery ? (0, $22d288f7313aec0a$export$f51a9068ac82ea43)() : undefined;
    const chains = (0, $667e73fc927ac14e$export$f51a9068ac82ea43)(()=>rest.chains);
    const connectors = (0, $667e73fc927ac14e$export$f51a9068ac82ea43)(()=>{
        const collection = [];
        const rdnsSet = new Set();
        for (const connectorFns of rest.connectors ?? []){
            const connector = setup(connectorFns);
            collection.push(connector);
            if (!ssr && connector.rdns) {
                const rdnsValues = typeof connector.rdns === "string" ? [
                    connector.rdns
                ] : connector.rdns;
                for (const rdns of rdnsValues)rdnsSet.add(rdns);
            }
        }
        if (!ssr && mipd) {
            const providers = mipd.getProviders();
            for (const provider of providers){
                if (rdnsSet.has(provider.info.rdns)) continue;
                collection.push(setup(providerDetailToConnector(provider)));
            }
        }
        return collection;
    });
    function setup(connectorFn) {
        // Set up emitter with uid and add to connector so they are "linked" together.
        const emitter = (0, $0c5cc813a7f718dc$export$6f5e8f34570e3ad1)((0, $5898fd028c950550$export$e2a22331486dcca0)());
        const connector = {
            ...connectorFn({
                emitter: emitter,
                chains: chains.getState(),
                storage: storage,
                transports: rest.transports
            }),
            emitter: emitter,
            uid: emitter.uid
        };
        // Start listening for `connect` events on connector setup
        // This allows connectors to "connect" themselves without user interaction (e.g. MetaMask's "Manually connect to current site")
        emitter.on("connect", connect);
        connector.setup?.();
        return connector;
    }
    function providerDetailToConnector(providerDetail) {
        const { info: info } = providerDetail;
        const provider = providerDetail.provider;
        return (0, $4a5711e3a5bbc3b2$export$a7a34dad4983656f)({
            target: {
                ...info,
                id: info.rdns,
                provider: provider
            }
        });
    }
    const clients = new Map();
    function getClient(config = {}) {
        const chainId = config.chainId ?? store.getState().chainId;
        const chain = chains.getState().find((x)=>x.id === chainId);
        // chainId specified and not configured
        if (config.chainId && !chain) throw new (0, $dfd1b5f3c842a678$export$688e5fda4b4631ed)();
        {
            const client = clients.get(store.getState().chainId);
            if (client && !chain) return client;
            if (!chain) throw new (0, $dfd1b5f3c842a678$export$688e5fda4b4631ed)();
        }
        // If a memoized client exists for a chain id, use that.
        {
            const client = clients.get(chainId);
            if (client) return client;
        }
        let client;
        if (rest.client) client = rest.client({
            chain: chain
        });
        else {
            const chainId = chain.id;
            const chainIds = chains.getState().map((x)=>x.id);
            // Grab all properties off `rest` and resolve for use in `createClient`
            const properties = {};
            const entries = Object.entries(rest);
            for (const [key, value] of entries){
                if (key === "chains" || key === "client" || key === "connectors" || key === "transports") continue;
                if (typeof value === "object") {
                    // check if value is chainId-specific since some values can be objects
                    // e.g. { batch: { multicall: { batchSize: 1024 } } }
                    if (chainId in value) properties[key] = value[chainId];
                    else {
                        // check if value is chainId-specific, but does not have value for current chainId
                        const hasChainSpecificValue = chainIds.some((x)=>x in value);
                        if (hasChainSpecificValue) continue;
                        properties[key] = value;
                    }
                } else properties[key] = value;
            }
            client = (0, $39c00038e35bed34$export$5d730b7aed1a3eb0)({
                ...properties,
                chain: chain,
                batch: properties.batch ?? {
                    multicall: true
                },
                transport: (parameters)=>rest.transports[chainId]({
                        ...parameters,
                        connectors: connectors
                    })
            });
        }
        clients.set(chainId, client);
        return client;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Create store
    /////////////////////////////////////////////////////////////////////////////////////////////////
    function getInitialState() {
        return {
            chainId: chains.getState()[0].id,
            connections: new Map(),
            current: null,
            status: "disconnected"
        };
    }
    let currentVersion;
    const prefix = "0.0.0-canary-";
    if ((0, $d19d50b3b9e9b1ca$export$83d89fbfd8236492).startsWith(prefix)) currentVersion = Number.parseInt((0, $d19d50b3b9e9b1ca$export$83d89fbfd8236492).replace(prefix, ""));
    else currentVersion = Number.parseInt((0, $d19d50b3b9e9b1ca$export$83d89fbfd8236492).split(".")[0] ?? "0");
    const store = (0, $667e73fc927ac14e$export$f51a9068ac82ea43)((0, $541a880767a0936b$export$5c593627aef9f076)(// only use persist middleware if storage exists
    storage ? (0, $541a880767a0936b$export$9a6132153fba2e0)(getInitialState, {
        migrate (persistedState, version) {
            if (version === currentVersion) return persistedState;
            const initialState = getInitialState();
            const chainId = validatePersistedChainId(persistedState, initialState.chainId);
            return {
                ...initialState,
                chainId: chainId
            };
        },
        name: "store",
        partialize (state) {
            // Only persist "critical" store properties to preserve storage size.
            return {
                connections: {
                    __type: "Map",
                    value: Array.from(state.connections.entries()).map(([key, connection])=>{
                        const { id: id, name: name, type: type, uid: uid } = connection.connector;
                        const connector = {
                            id: id,
                            name: name,
                            type: type,
                            uid: uid
                        };
                        return [
                            key,
                            {
                                ...connection,
                                connector: connector
                            }
                        ];
                    })
                },
                chainId: state.chainId,
                current: state.current
            };
        },
        merge (persistedState, currentState) {
            // `status` should not be persisted as it messes with reconnection
            if (typeof persistedState === "object" && persistedState && "status" in persistedState) delete persistedState.status;
            // Make sure persisted `chainId` is valid
            const chainId = validatePersistedChainId(persistedState, currentState.chainId);
            return {
                ...currentState,
                ...persistedState,
                chainId: chainId
            };
        },
        skipHydration: ssr,
        storage: storage,
        version: currentVersion
    }) : getInitialState));
    store.setState(getInitialState());
    function validatePersistedChainId(persistedState, defaultChainId) {
        return persistedState && typeof persistedState === "object" && "chainId" in persistedState && typeof persistedState.chainId === "number" && chains.getState().some((x)=>x.id === persistedState.chainId) ? persistedState.chainId : defaultChainId;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Subscribe to changes
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Update default chain when connector chain changes
    if (syncConnectedChain) store.subscribe(({ connections: connections, current: current })=>current ? connections.get(current)?.chainId : undefined, (chainId)=>{
        // If chain is not configured, then don't switch over to it.
        const isChainConfigured = chains.getState().some((x)=>x.id === chainId);
        if (!isChainConfigured) return;
        return store.setState((x)=>({
                ...x,
                chainId: chainId ?? x.chainId
            }));
    });
    // EIP-6963 subscribe for new wallet providers
    mipd?.subscribe((providerDetails)=>{
        const connectorIdSet = new Set();
        const connectorRdnsSet = new Set();
        for (const connector of connectors.getState()){
            connectorIdSet.add(connector.id);
            if (connector.rdns) {
                const rdnsValues = typeof connector.rdns === "string" ? [
                    connector.rdns
                ] : connector.rdns;
                for (const rdns of rdnsValues)connectorRdnsSet.add(rdns);
            }
        }
        const newConnectors = [];
        for (const providerDetail of providerDetails){
            if (connectorRdnsSet.has(providerDetail.info.rdns)) continue;
            const connector = setup(providerDetailToConnector(providerDetail));
            if (connectorIdSet.has(connector.id)) continue;
            newConnectors.push(connector);
        }
        if (storage && !store.persist.hasHydrated()) return;
        connectors.setState((x)=>[
                ...x,
                ...newConnectors
            ], true);
    });
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Emitter listeners
    /////////////////////////////////////////////////////////////////////////////////////////////////
    function change(data) {
        store.setState((x)=>{
            const connection = x.connections.get(data.uid);
            if (!connection) return x;
            return {
                ...x,
                connections: new Map(x.connections).set(data.uid, {
                    accounts: data.accounts ?? connection.accounts,
                    chainId: data.chainId ?? connection.chainId,
                    connector: connection.connector
                })
            };
        });
    }
    function connect(data) {
        // Disable handling if reconnecting/connecting
        if (store.getState().status === "connecting" || store.getState().status === "reconnecting") return;
        store.setState((x)=>{
            const connector = connectors.getState().find((x)=>x.uid === data.uid);
            if (!connector) return x;
            if (connector.emitter.listenerCount("connect")) connector.emitter.off("connect", change);
            if (!connector.emitter.listenerCount("change")) connector.emitter.on("change", change);
            if (!connector.emitter.listenerCount("disconnect")) connector.emitter.on("disconnect", disconnect);
            return {
                ...x,
                connections: new Map(x.connections).set(data.uid, {
                    accounts: data.accounts,
                    chainId: data.chainId,
                    connector: connector
                }),
                current: data.uid,
                status: "connected"
            };
        });
    }
    function disconnect(data) {
        store.setState((x)=>{
            const connection = x.connections.get(data.uid);
            if (connection) {
                const connector = connection.connector;
                if (connector.emitter.listenerCount("change")) connection.connector.emitter.off("change", change);
                if (connector.emitter.listenerCount("disconnect")) connection.connector.emitter.off("disconnect", disconnect);
                if (!connector.emitter.listenerCount("connect")) connection.connector.emitter.on("connect", connect);
            }
            x.connections.delete(data.uid);
            if (x.connections.size === 0) return {
                ...x,
                connections: new Map(),
                current: null,
                status: "disconnected"
            };
            const nextConnection = x.connections.values().next().value;
            return {
                ...x,
                connections: new Map(x.connections),
                current: nextConnection.connector.uid
            };
        });
    }
    return {
        get chains () {
            return chains.getState();
        },
        get connectors () {
            return connectors.getState();
        },
        storage: storage,
        getClient: getClient,
        get state () {
            return store.getState();
        },
        setState (value) {
            let newState;
            if (typeof value === "function") newState = value(store.getState());
            else newState = value;
            // Reset state if it got set to something not matching the base state
            const initialState = getInitialState();
            if (typeof newState !== "object") newState = initialState;
            const isCorrupt = Object.keys(initialState).some((x)=>!(x in newState));
            if (isCorrupt) newState = initialState;
            store.setState(newState, true);
        },
        subscribe (selector, listener, options) {
            return store.subscribe(selector, listener, options ? {
                ...options,
                fireImmediately: options.emitImmediately
            } : undefined);
        },
        _internal: {
            mipd: mipd,
            store: store,
            ssr: Boolean(ssr),
            syncConnectedChain: syncConnectedChain,
            transports: rest.transports,
            chains: {
                setState (value) {
                    const nextChains = typeof value === "function" ? value(chains.getState()) : value;
                    if (nextChains.length === 0) return;
                    return chains.setState(nextChains, true);
                },
                subscribe (listener) {
                    return chains.subscribe(listener);
                }
            },
            connectors: {
                providerDetailToConnector: providerDetailToConnector,
                setup: setup,
                setState (value) {
                    return connectors.setState(typeof value === "function" ? value(connectors.getState()) : value, true);
                },
                subscribe (listener) {
                    return connectors.subscribe(listener);
                }
            },
            events: {
                change: change,
                connect: connect,
                disconnect: disconnect
            }
        }
    };
}




var $siouQ = parcelRequire("siouQ");
var $jW8ut = parcelRequire("jW8ut");
var $iy34j = parcelRequire("iy34j");
$8cdb8635cede6527$export$40dfb463b44d19b.type = "coinbaseWallet";
function $8cdb8635cede6527$export$40dfb463b44d19b(parameters = {}) {
    if (parameters.version === "3" || parameters.headlessMode) return $8cdb8635cede6527$var$version3(parameters);
    return $8cdb8635cede6527$var$version4(parameters);
}

function $8cdb8635cede6527$var$version4(parameters) {
    let walletProvider;
    let accountsChanged;
    let chainChanged;
    let disconnect;
    return (0, $ea4aa100ff3513d7$export$36e7227504c841ea)((config)=>({
            id: "coinbaseWalletSDK",
            name: "Coinbase Wallet",
            rdns: "com.coinbase.wallet",
            type: $8cdb8635cede6527$export$40dfb463b44d19b.type,
            async connect ({ chainId: chainId, ...rest } = {}) {
                try {
                    const provider = await this.getProvider();
                    const accounts = (await provider.request({
                        method: "eth_requestAccounts",
                        params: "instantOnboarding" in rest && rest.instantOnboarding ? [
                            {
                                onboarding: "instant"
                            }
                        ] : []
                    })).map((x)=>(0, $siouQ.getAddress)(x));
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    // Switch to chain if provided
                    let currentChainId = await this.getChainId();
                    if (chainId && currentChainId !== chainId) {
                        const chain = await this.switchChain({
                            chainId: chainId
                        }).catch((error)=>{
                            if (error.code === (0, $iy34j.UserRejectedRequestError).code) throw error;
                            return {
                                id: currentChainId
                            };
                        });
                        currentChainId = chain?.id ?? currentChainId;
                    }
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (error) {
                    if (/(user closed modal|accounts received is empty|user denied account|request rejected)/i.test(error.message)) throw new (0, $iy34j.UserRejectedRequestError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                provider.disconnect();
                provider.close?.();
            },
            async getAccounts () {
                const provider = await this.getProvider();
                return (await provider.request({
                    method: "eth_accounts"
                })).map((x)=>(0, $siouQ.getAddress)(x));
            },
            async getChainId () {
                const provider = await this.getProvider();
                const chainId = await provider.request({
                    method: "eth_chainId"
                });
                return Number(chainId);
            },
            async getProvider () {
                if (!walletProvider) {
                    const preference = (()=>{
                        if (typeof parameters.preference === "string") return {
                            options: parameters.preference
                        };
                        return {
                            ...parameters.preference,
                            options: parameters.preference?.options ?? "all"
                        };
                    })();
                    const { createCoinbaseWalletSDK: createCoinbaseWalletSDK } = await (parcelRequire("c1sze"));
                    const sdk = createCoinbaseWalletSDK({
                        ...parameters,
                        appChainIds: config.chains.map((x)=>x.id),
                        preference: preference
                    });
                    walletProvider = sdk.getProvider();
                }
                return walletProvider;
            },
            async isAuthorized () {
                try {
                    const accounts = await this.getAccounts();
                    return !!accounts.length;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const chain = config.chains.find((chain)=>chain.id === chainId);
                if (!chain) throw new (0, $iy34j.SwitchChainError)(new (0, $dfd1b5f3c842a678$export$688e5fda4b4631ed)());
                const provider = await this.getProvider();
                try {
                    await provider.request({
                        method: "wallet_switchEthereumChain",
                        params: [
                            {
                                chainId: (0, $jW8ut.numberToHex)(chain.id)
                            }
                        ]
                    });
                    return chain;
                } catch (error) {
                    // Indicates chain is not added to provider
                    if (error.code === 4902) try {
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else blockExplorerUrls = chain.blockExplorers?.default.url ? [
                            chain.blockExplorers?.default.url
                        ] : [];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            chain.rpcUrls.default?.http[0] ?? ""
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $jW8ut.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        return chain;
                    } catch (error) {
                        throw new (0, $iy34j.UserRejectedRequestError)(error);
                    }
                    throw new (0, $iy34j.SwitchChainError)(error);
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $siouQ.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                config.emitter.emit("disconnect");
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
            }
        }));
}

function $8cdb8635cede6527$var$version3(parameters) {
    const reloadOnDisconnect = false;
    let sdk;
    let walletProvider;
    let accountsChanged;
    let chainChanged;
    let disconnect;
    return (0, $ea4aa100ff3513d7$export$36e7227504c841ea)((config)=>({
            id: "coinbaseWalletSDK",
            name: "Coinbase Wallet",
            type: $8cdb8635cede6527$export$40dfb463b44d19b.type,
            async connect ({ chainId: chainId } = {}) {
                try {
                    const provider = await this.getProvider();
                    const accounts = (await provider.request({
                        method: "eth_requestAccounts"
                    })).map((x)=>(0, $siouQ.getAddress)(x));
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    // Switch to chain if provided
                    let currentChainId = await this.getChainId();
                    if (chainId && currentChainId !== chainId) {
                        const chain = await this.switchChain({
                            chainId: chainId
                        }).catch((error)=>{
                            if (error.code === (0, $iy34j.UserRejectedRequestError).code) throw error;
                            return {
                                id: currentChainId
                            };
                        });
                        currentChainId = chain?.id ?? currentChainId;
                    }
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (error) {
                    if (/(user closed modal|accounts received is empty|user denied account)/i.test(error.message)) throw new (0, $iy34j.UserRejectedRequestError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                provider.disconnect();
                provider.close();
            },
            async getAccounts () {
                const provider = await this.getProvider();
                return (await provider.request({
                    method: "eth_accounts"
                })).map((x)=>(0, $siouQ.getAddress)(x));
            },
            async getChainId () {
                const provider = await this.getProvider();
                const chainId = await provider.request({
                    method: "eth_chainId"
                });
                return Number(chainId);
            },
            async getProvider () {
                if (!walletProvider) {
                    // Unwrapping import for Vite compatibility.
                    // See: https://github.com/vitejs/vite/issues/9703
                    const CoinbaseWalletSDK = await (async ()=>{
                        const { default: SDK } = await (parcelRequire("gAQsM"));
                        if (typeof SDK !== "function" && typeof SDK.default === "function") return SDK.default;
                        return SDK;
                    })();
                    sdk = new CoinbaseWalletSDK({
                        ...parameters,
                        reloadOnDisconnect: reloadOnDisconnect
                    });
                    // Force types to retrieve private `walletExtension` method from the Coinbase Wallet SDK.
                    const walletExtensionChainId = sdk.walletExtension?.getChainId();
                    const chain = config.chains.find((chain)=>parameters.chainId ? chain.id === parameters.chainId : chain.id === walletExtensionChainId) || config.chains[0];
                    const chainId = parameters.chainId || chain?.id;
                    const jsonRpcUrl = parameters.jsonRpcUrl || chain?.rpcUrls.default.http[0];
                    walletProvider = sdk.makeWeb3Provider(jsonRpcUrl, chainId);
                }
                return walletProvider;
            },
            async isAuthorized () {
                try {
                    const accounts = await this.getAccounts();
                    return !!accounts.length;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const chain = config.chains.find((chain)=>chain.id === chainId);
                if (!chain) throw new (0, $iy34j.SwitchChainError)(new (0, $dfd1b5f3c842a678$export$688e5fda4b4631ed)());
                const provider = await this.getProvider();
                try {
                    await provider.request({
                        method: "wallet_switchEthereumChain",
                        params: [
                            {
                                chainId: (0, $jW8ut.numberToHex)(chain.id)
                            }
                        ]
                    });
                    return chain;
                } catch (error) {
                    // Indicates chain is not added to provider
                    if (error.code === 4902) try {
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else blockExplorerUrls = chain.blockExplorers?.default.url ? [
                            chain.blockExplorers?.default.url
                        ] : [];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            chain.rpcUrls.default?.http[0] ?? ""
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $jW8ut.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        return chain;
                    } catch (error) {
                        throw new (0, $iy34j.UserRejectedRequestError)(error);
                    }
                    throw new (0, $iy34j.SwitchChainError)(error);
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $siouQ.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                config.emitter.emit("disconnect");
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
            }
        }));
}

function $6ffe211568a84a70$export$c04fcecb1d6d70c7(parameters) {
    const { chain: chain } = parameters;
    const fallbackUrl = chain.rpcUrls.default.http[0];
    if (!parameters.transports) return [
        fallbackUrl
    ];
    const transport = parameters.transports?.[chain.id]?.({
        chain: chain
    });
    const transports = transport?.value?.transports || [
        transport
    ];
    return transports.map(({ value: value })=>value?.url || fallbackUrl);
}



var $siouQ = parcelRequire("siouQ");
var $jW8ut = parcelRequire("jW8ut");
var $iy34j = parcelRequire("iy34j");
$1cc85973e09143f6$export$340cc50ae9d9f255.type = "walletConnect";

function $1cc85973e09143f6$export$340cc50ae9d9f255(parameters) {
    const isNewChainsStale = parameters.isNewChainsStale ?? true;
    let provider_;
    let providerPromise;
    const NAMESPACE = "eip155";
    let accountsChanged;
    let chainChanged;
    let connect;
    let displayUri;
    let sessionDelete;
    let disconnect;
    return (0, $ea4aa100ff3513d7$export$36e7227504c841ea)((config)=>({
            id: "walletConnect",
            name: "WalletConnect",
            type: $1cc85973e09143f6$export$340cc50ae9d9f255.type,
            async setup () {
                const provider = await this.getProvider().catch(()=>null);
                if (!provider) return;
                if (!connect) {
                    connect = this.onConnect.bind(this);
                    provider.on("connect", connect);
                }
                if (!sessionDelete) {
                    sessionDelete = this.onSessionDelete.bind(this);
                    provider.on("session_delete", sessionDelete);
                }
            },
            async connect ({ chainId: chainId, ...rest } = {}) {
                try {
                    const provider = await this.getProvider();
                    if (!provider) throw new (0, $051d3f9d080da18b$export$43839b3ff6336f15)();
                    if (!displayUri) {
                        displayUri = this.onDisplayUri;
                        provider.on("display_uri", displayUri);
                    }
                    let targetChainId = chainId;
                    if (!targetChainId) {
                        const state = await config.storage?.getItem("state") ?? {};
                        const isChainSupported = config.chains.some((x)=>x.id === state.chainId);
                        if (isChainSupported) targetChainId = state.chainId;
                        else targetChainId = config.chains[0]?.id;
                    }
                    if (!targetChainId) throw new Error("No chains found on connector.");
                    const isChainsStale = await this.isChainsStale();
                    // If there is an active session with stale chains, disconnect current session.
                    if (provider.session && isChainsStale) await provider.disconnect();
                    // If there isn't an active session or chains are stale, connect.
                    if (!provider.session || isChainsStale) {
                        const optionalChains = config.chains.filter((chain)=>chain.id !== targetChainId).map((optionalChain)=>optionalChain.id);
                        await provider.connect({
                            optionalChains: [
                                targetChainId,
                                ...optionalChains
                            ],
                            ..."pairingTopic" in rest ? {
                                pairingTopic: rest.pairingTopic
                            } : {}
                        });
                        this.setRequestedChainsIds(config.chains.map((x)=>x.id));
                    }
                    // If session exists and chains are authorized, enable provider for required chain
                    const accounts = (await provider.enable()).map((x)=>(0, $siouQ.getAddress)(x));
                    const currentChainId = await this.getChainId();
                    if (displayUri) {
                        provider.removeListener("display_uri", displayUri);
                        displayUri = undefined;
                    }
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    if (!sessionDelete) {
                        sessionDelete = this.onSessionDelete.bind(this);
                        provider.on("session_delete", sessionDelete);
                    }
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (error) {
                    if (/(user rejected|connection request reset)/i.test(error?.message)) throw new (0, $iy34j.UserRejectedRequestError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                try {
                    await provider?.disconnect();
                } catch (error) {
                    if (!/No matching key/i.test(error.message)) throw error;
                } finally{
                    if (chainChanged) {
                        provider?.removeListener("chainChanged", chainChanged);
                        chainChanged = undefined;
                    }
                    if (disconnect) {
                        provider?.removeListener("disconnect", disconnect);
                        disconnect = undefined;
                    }
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider?.on("connect", connect);
                    }
                    if (accountsChanged) {
                        provider?.removeListener("accountsChanged", accountsChanged);
                        accountsChanged = undefined;
                    }
                    if (sessionDelete) {
                        provider?.removeListener("session_delete", sessionDelete);
                        sessionDelete = undefined;
                    }
                    this.setRequestedChainsIds([]);
                }
            },
            async getAccounts () {
                const provider = await this.getProvider();
                return provider.accounts.map((x)=>(0, $siouQ.getAddress)(x));
            },
            async getProvider ({ chainId: chainId } = {}) {
                async function initProvider() {
                    const optionalChains = config.chains.map((x)=>x.id);
                    if (!optionalChains.length) return;
                    const { EthereumProvider: EthereumProvider } = await (parcelRequire("jNXYh"));
                    return await EthereumProvider.init({
                        ...parameters,
                        disableProviderPing: true,
                        optionalChains: optionalChains,
                        projectId: parameters.projectId,
                        rpcMap: Object.fromEntries(config.chains.map((chain)=>{
                            const [url] = (0, $6ffe211568a84a70$export$c04fcecb1d6d70c7)({
                                chain: chain,
                                transports: config.transports
                            });
                            return [
                                chain.id,
                                url
                            ];
                        })),
                        showQrModal: parameters.showQrModal ?? true
                    });
                }
                if (!provider_) {
                    if (!providerPromise) providerPromise = initProvider();
                    provider_ = await providerPromise;
                    provider_?.events.setMaxListeners(Number.POSITIVE_INFINITY);
                }
                if (chainId) await this.switchChain?.({
                    chainId: chainId
                });
                return provider_;
            },
            async getChainId () {
                const provider = await this.getProvider();
                return provider.chainId;
            },
            async isAuthorized () {
                try {
                    const [accounts, provider] = await Promise.all([
                        this.getAccounts(),
                        this.getProvider()
                    ]);
                    // If an account does not exist on the session, then the connector is unauthorized.
                    if (!accounts.length) return false;
                    // If the chains are stale on the session, then the connector is unauthorized.
                    const isChainsStale = await this.isChainsStale();
                    if (isChainsStale && provider.session) {
                        await provider.disconnect().catch(()=>{});
                        return false;
                    }
                    return true;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $051d3f9d080da18b$export$43839b3ff6336f15)();
                const chain = config.chains.find((x)=>x.id === chainId);
                if (!chain) throw new (0, $iy34j.SwitchChainError)(new (0, $dfd1b5f3c842a678$export$688e5fda4b4631ed)());
                try {
                    await Promise.all([
                        new Promise((resolve)=>{
                            const listener = ({ chainId: currentChainId })=>{
                                if (currentChainId === chainId) {
                                    config.emitter.off("change", listener);
                                    resolve();
                                }
                            };
                            config.emitter.on("change", listener);
                        }),
                        provider.request({
                            method: "wallet_switchEthereumChain",
                            params: [
                                {
                                    chainId: (0, $jW8ut.numberToHex)(chainId)
                                }
                            ]
                        })
                    ]);
                    const requestedChains = await this.getRequestedChainsIds();
                    this.setRequestedChainsIds([
                        ...requestedChains,
                        chainId
                    ]);
                    return chain;
                } catch (err) {
                    const error = err;
                    if (/(user rejected)/i.test(error.message)) throw new (0, $iy34j.UserRejectedRequestError)(error);
                    // Indicates chain is not added to provider
                    try {
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else blockExplorerUrls = chain.blockExplorers?.default.url ? [
                            chain.blockExplorers?.default.url
                        ] : [];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            ...chain.rpcUrls.default.http
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $jW8ut.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        const requestedChains = await this.getRequestedChainsIds();
                        this.setRequestedChainsIds([
                            ...requestedChains,
                            chainId
                        ]);
                        return chain;
                    } catch (error) {
                        throw new (0, $iy34j.UserRejectedRequestError)(error);
                    }
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $siouQ.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onConnect (connectInfo) {
                const chainId = Number(connectInfo.chainId);
                const accounts = await this.getAccounts();
                config.emitter.emit("connect", {
                    accounts: accounts,
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                this.setRequestedChainsIds([]);
                config.emitter.emit("disconnect");
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                if (sessionDelete) {
                    provider.removeListener("session_delete", sessionDelete);
                    sessionDelete = undefined;
                }
                if (!connect) {
                    connect = this.onConnect.bind(this);
                    provider.on("connect", connect);
                }
            },
            onDisplayUri (uri) {
                config.emitter.emit("message", {
                    type: "display_uri",
                    data: uri
                });
            },
            onSessionDelete () {
                this.onDisconnect();
            },
            getNamespaceChainsIds () {
                if (!provider_) return [];
                const chainIds = provider_.session?.namespaces[NAMESPACE]?.accounts?.map((account)=>Number.parseInt(account.split(":")[1] || ""));
                return chainIds ?? [];
            },
            async getRequestedChainsIds () {
                return await config.storage?.getItem(this.requestedChainsStorageKey) ?? [];
            },
            /**
         * Checks if the target chains match the chains that were
         * initially requested by the connector for the WalletConnect session.
         * If there is a mismatch, this means that the chains on the connector
         * are considered stale, and need to be revalidated at a later point (via
         * connection).
         *
         * There may be a scenario where a dapp adds a chain to the
         * connector later on, however, this chain will not have been approved or rejected
         * by the wallet. In this case, the chain is considered stale.
         */ async isChainsStale () {
                if (!isNewChainsStale) return false;
                const connectorChains = config.chains.map((x)=>x.id);
                const namespaceChains = this.getNamespaceChainsIds();
                if (namespaceChains.length && !namespaceChains.some((id)=>connectorChains.includes(id))) return false;
                const requestedChains = await this.getRequestedChainsIds();
                return !connectorChains.every((id)=>requestedChains.includes(id));
            },
            async setRequestedChainsIds (chains) {
                await config.storage?.setItem(this.requestedChainsStorageKey, chains);
            },
            get requestedChainsStorageKey () {
                return `${this.id}.requestedChains`;
            }
        }));
}


/** @deprecated use `Number` instead */ function $c3e77733fa71ad9d$export$723927690c88894d(chainId) {
    if (typeof chainId === "string") return Number.parseInt(chainId, chainId.trim().substring(0, 2) === "0x" ? 16 : 10);
    if (typeof chainId === "bigint") return Number(chainId);
    if (typeof chainId === "number") return chainId;
    throw new Error(`Cannot normalize chainId "${chainId}" of type "${typeof chainId}"`);
}




var $siouQ = parcelRequire("siouQ");
var $iy34j = parcelRequire("iy34j");

function $2fc9f374685a6997$export$8ca58e4e52917c25(parameters) {
    return (0, $ea4aa100ff3513d7$export$36e7227504c841ea)((config)=>({
            id: (0, $8782c6f344d77b54$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID,
            name: "Web3Modal Email",
            type: "w3mEmail",
            async connect (options = {}) {
                const provider = await this.getProvider();
                const { address: address, chainId: chainId } = await provider.connect({
                    chainId: options.chainId
                });
                return {
                    accounts: [
                        address
                    ],
                    account: address,
                    chainId: chainId,
                    chain: {
                        id: chainId,
                        unsuported: false
                    }
                };
            },
            async disconnect () {
                const provider = await this.getProvider();
                await provider.disconnect();
            },
            async getAccounts () {
                const provider = await this.getProvider();
                const { address: address } = await provider.connect();
                return [
                    address
                ];
            },
            async getProvider () {
                if (!this.provider) this.provider = new (0, $f921cae03edcbdbc$export$112ca4a9acf9f612)(parameters.options.projectId);
                return Promise.resolve(this.provider);
            },
            async getChainId () {
                const provider = await this.getProvider();
                const { chainId: chainId } = await provider.getChainId();
                return chainId;
            },
            async isAuthorized () {
                const provider = await this.getProvider();
                const { isConnected: isConnected } = await provider.isConnected();
                return isConnected;
            },
            async switchChain ({ chainId: chainId }) {
                try {
                    const chain = config.chains.find((c)=>c.id === chainId);
                    if (!chain) throw new (0, $iy34j.SwitchChainError)(new Error("chain not found on connector."));
                    const provider = await this.getProvider();
                    await provider.switchNetwork(chainId);
                    config.emitter.emit("change", {
                        chainId: (0, $c3e77733fa71ad9d$export$723927690c88894d)(chainId)
                    });
                    return chain;
                } catch (error) {
                    if (error instanceof Error) throw new (0, $iy34j.SwitchChainError)(error);
                    throw error;
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((0, $siouQ.getAddress))
                });
            },
            onChainChanged (chain) {
                const chainId = (0, $c3e77733fa71ad9d$export$723927690c88894d)(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onConnect (connectInfo) {
                const chainId = (0, $c3e77733fa71ad9d$export$723927690c88894d)(connectInfo.chainId);
                const accounts = await this.getAccounts();
                config.emitter.emit("connect", {
                    accounts: accounts,
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                const provider = await this.getProvider();
                await provider.disconnect();
            }
        }));
}



function $87b2c6fa17d09c62$export$134240a34d71525e({ projectId: projectId, chains: chains, metadata: metadata, enableInjected: enableInjected, enableCoinbase: enableCoinbase, enableEmail: enableEmail, enableWalletConnect: enableWalletConnect, enableEIP6963: enableEIP6963, ...wagmiConfig }) {
    const connectors = [];
    const transportsArr = chains.map((chain)=>[
            chain.id,
            (0, $3721684b5080e7f4$export$867d8b939ab7f43e)({
                chainId: chain.id,
                projectId: projectId
            })
        ]);
    const transports = Object.fromEntries(transportsArr);
    if (enableWalletConnect !== false) connectors.push((0, $1cc85973e09143f6$export$340cc50ae9d9f255)({
        projectId: projectId,
        metadata: metadata,
        showQrModal: false
    }));
    if (enableInjected !== false) connectors.push((0, $4a5711e3a5bbc3b2$export$a7a34dad4983656f)({
        shimDisconnect: true
    }));
    if (enableCoinbase !== false) connectors.push((0, $8cdb8635cede6527$export$40dfb463b44d19b)({
        appName: metadata?.name ?? "Unknown",
        appLogoUrl: metadata?.icons[0] ?? "Unknown",
        enableMobileWalletLink: true
    }));
    if (enableEmail === true) connectors.push((0, $2fc9f374685a6997$export$8ca58e4e52917c25)({
        chains: [
            ...chains
        ],
        options: {
            projectId: projectId
        }
    }));
    return (0, $6018651d757f98d4$export$45a69314cf48a3eb)({
        chains: chains,
        multiInjectedProviderDiscovery: enableEIP6963 !== false,
        transports: transports,
        ...wagmiConfig,
        connectors: connectors
    });
}



function $87c7cd6292736e7e$export$14650d4efb17e382(options) {
    return new (0, $cb4afcb7b4256971$export$c03599cd5308d12b)({
        ...options,
        _sdkVersion: `html-wagmi-${(0, $8782c6f344d77b54$export$aafe1f751f1bc52a).VERSION}`
    });
}



const $87066091a14e934d$export$625cf84d855940d4 = /*#__PURE__*/ (0, $b32ab6fe95d80134$export$b6380ff64616a4fb)({
    id: 42161,
    name: "Arbitrum One",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://arb1.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Arbiscan",
            url: "https://arbiscan.io",
            apiUrl: "https://api.arbiscan.io/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 7654707
        }
    }
});


const $c442231210e6099e$export$857f1b5f596fb425 = /*#__PURE__*/ (0, $b32ab6fe95d80134$export$b6380ff64616a4fb)({
    id: 421613,
    name: "Arbitrum Goerli",
    nativeCurrency: {
        name: "Arbitrum Goerli Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://goerli-rollup.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Arbiscan",
            url: "https://goerli.arbiscan.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 88114
        }
    },
    testnet: true
});


const $955bd3ed7956d1ea$export$ca1d15c01fde7266 = /*#__PURE__*/ (0, $b32ab6fe95d80134$export$b6380ff64616a4fb)({
    id: 43114,
    name: "Avalanche",
    nativeCurrency: {
        decimals: 18,
        name: "Avalanche",
        symbol: "AVAX"
    },
    rpcUrls: {
        default: {
            http: [
                "https://api.avax.network/ext/bc/C/rpc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "SnowTrace",
            url: "https://snowtrace.io",
            apiUrl: "https://api.snowtrace.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 11907934
        }
    }
});

/**
 * Predeploy contracts for OP Stack.
 * @see https://github.com/ethereum-optimism/optimism/blob/develop/specs/predeploys.md
 */ const $fa672b3df29e91ac$export$ea30b8ddade7b2c1 = {
    gasPriceOracle: {
        address: "0x420000000000000000000000000000000000000F"
    },
    l1Block: {
        address: "0x4200000000000000000000000000000000000015"
    },
    l2CrossDomainMessenger: {
        address: "0x4200000000000000000000000000000000000007"
    },
    l2Erc721Bridge: {
        address: "0x4200000000000000000000000000000000000014"
    },
    l2StandardBridge: {
        address: "0x4200000000000000000000000000000000000010"
    },
    l2ToL1MessagePasser: {
        address: "0x4200000000000000000000000000000000000016"
    }
};



var $9GGVO = parcelRequire("9GGVO");



const $85a41f8b9e2f6531$export$fe98a034cfb96d55 = {
    block: /*#__PURE__*/ (0, $3791204a4fe10280$export$9f35cb3327f1a5c5)({
        format (args) {
            const transactions = args.transactions?.map((transaction)=>{
                if (typeof transaction === "string") return transaction;
                const formatted = (0, $23c54fd803cb615d$export$b02b16590d26dadc)(transaction);
                if (formatted.typeHex === "0x7e") {
                    formatted.isSystemTx = transaction.isSystemTx;
                    formatted.mint = transaction.mint ? (0, $9GGVO.hexToBigInt)(transaction.mint) : undefined;
                    formatted.sourceHash = transaction.sourceHash;
                    formatted.type = "deposit";
                }
                return formatted;
            });
            return {
                transactions: transactions,
                stateRoot: args.stateRoot
            };
        }
    }),
    transaction: /*#__PURE__*/ (0, $23c54fd803cb615d$export$c19bdc7dbe69198d)({
        format (args) {
            const transaction = {};
            if (args.type === "0x7e") {
                transaction.isSystemTx = args.isSystemTx;
                transaction.mint = args.mint ? (0, $9GGVO.hexToBigInt)(args.mint) : undefined;
                transaction.sourceHash = args.sourceHash;
                transaction.type = "deposit";
            }
            return transaction;
        }
    }),
    transactionReceipt: /*#__PURE__*/ (0, $9edc82c091c90e5e$export$8d3f90420000ba71)({
        format (args) {
            return {
                l1GasPrice: args.l1GasPrice ? (0, $9GGVO.hexToBigInt)(args.l1GasPrice) : null,
                l1GasUsed: args.l1GasUsed ? (0, $9GGVO.hexToBigInt)(args.l1GasUsed) : null,
                l1Fee: args.l1Fee ? (0, $9GGVO.hexToBigInt)(args.l1Fee) : null,
                l1FeeScalar: args.l1FeeScalar ? Number(args.l1FeeScalar) : null
            };
        }
    })
};



var $62VqX = parcelRequire("62VqX");

var $8Ghey = parcelRequire("8Ghey");

var $jnwfF = parcelRequire("jnwfF");

var $jW8ut = parcelRequire("jW8ut");


var $3a3vr = parcelRequire("3a3vr");





var $jnwfF = parcelRequire("jnwfF");

var $geW6W = parcelRequire("geW6W");

var $jW8ut = parcelRequire("jW8ut");


var $jW8ut = parcelRequire("jW8ut");

function $017f3e8eaae93ff7$export$a695669f1a41df5b(authorizationList) {
    if (!authorizationList || authorizationList.length === 0) return [];
    const serializedAuthorizationList = [];
    for (const authorization of authorizationList){
        const { contractAddress: contractAddress, chainId: chainId, nonce: nonce, ...signature } = authorization;
        serializedAuthorizationList.push([
            chainId ? (0, $jW8ut.toHex)(chainId) : "0x",
            contractAddress,
            nonce ? (0, $jW8ut.toHex)(nonce) : "0x",
            ...(0, $e0d077fad19d0614$export$13ef8e144f96fd76)({}, signature)
        ]);
    }
    return serializedAuthorizationList;
}




var $64pxN = parcelRequire("64pxN");

var $62VqX = parcelRequire("62VqX");

var $cahqm = parcelRequire("cahqm");


var $iz4Cu = parcelRequire("iz4Cu");

var $iWaDR = parcelRequire("iWaDR");

var $8Ghey = parcelRequire("8Ghey");

var $lsLGO = parcelRequire("lsLGO");

var $fdb51 = parcelRequire("fdb51");

var $9GGVO = parcelRequire("9GGVO");
function $fdec429c20f0c129$export$c066ee77932a0249(transaction) {
    const { authorizationList: authorizationList } = transaction;
    if (authorizationList) for (const authorization of authorizationList){
        const { contractAddress: contractAddress, chainId: chainId } = authorization;
        if (!(0, $8Ghey.isAddress)(contractAddress)) throw new (0, $62VqX.InvalidAddressError)({
            address: contractAddress
        });
        if (chainId < 0) throw new (0, $iz4Cu.InvalidChainIdError)({
            chainId: chainId
        });
    }
    $fdec429c20f0c129$export$9ce52ad2ebd4d8fd(transaction);
}
function $fdec429c20f0c129$export$7a7b1c9cbdcde679(transaction) {
    const { blobVersionedHashes: blobVersionedHashes } = transaction;
    if (blobVersionedHashes) {
        if (blobVersionedHashes.length === 0) throw new (0, $83b6491e0ebe571c$export$d145394ceab4d1c3)();
        for (const hash of blobVersionedHashes){
            const size_ = (0, $lsLGO.size)(hash);
            const version = (0, $9GGVO.hexToNumber)((0, $fdb51.slice)(hash, 0, 1));
            if (size_ !== 32) throw new (0, $83b6491e0ebe571c$export$ebd5b15dd92c680)({
                hash: hash,
                size: size_
            });
            if (version !== (0, $1b9c967afd9a35a8$export$de38d5f871f0b1cd)) throw new (0, $83b6491e0ebe571c$export$509ed1d312c500)({
                hash: hash,
                version: version
            });
        }
    }
    $fdec429c20f0c129$export$9ce52ad2ebd4d8fd(transaction);
}
function $fdec429c20f0c129$export$9ce52ad2ebd4d8fd(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (chainId <= 0) throw new (0, $iz4Cu.InvalidChainIdError)({
        chainId: chainId
    });
    if (to && !(0, $8Ghey.isAddress)(to)) throw new (0, $62VqX.InvalidAddressError)({
        address: to
    });
    if (maxFeePerGas && maxFeePerGas > (0, $64pxN.maxUint256)) throw new (0, $iWaDR.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $iWaDR.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}
function $fdec429c20f0c129$export$18dc5e03b8985881(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (chainId <= 0) throw new (0, $iz4Cu.InvalidChainIdError)({
        chainId: chainId
    });
    if (to && !(0, $8Ghey.isAddress)(to)) throw new (0, $62VqX.InvalidAddressError)({
        address: to
    });
    if (maxPriorityFeePerGas || maxFeePerGas) throw new (0, $cahqm.BaseError)("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
    if (gasPrice && gasPrice > (0, $64pxN.maxUint256)) throw new (0, $iWaDR.FeeCapTooHighError)({
        maxFeePerGas: gasPrice
    });
}
function $fdec429c20f0c129$export$f9ff7fa58fadd108(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (to && !(0, $8Ghey.isAddress)(to)) throw new (0, $62VqX.InvalidAddressError)({
        address: to
    });
    if (typeof chainId !== "undefined" && chainId <= 0) throw new (0, $iz4Cu.InvalidChainIdError)({
        chainId: chainId
    });
    if (maxPriorityFeePerGas || maxFeePerGas) throw new (0, $cahqm.BaseError)("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
    if (gasPrice && gasPrice > (0, $64pxN.maxUint256)) throw new (0, $iWaDR.FeeCapTooHighError)({
        maxFeePerGas: gasPrice
    });
}




var $62VqX = parcelRequire("62VqX");

var $3a3vr = parcelRequire("3a3vr");

var $8Ghey = parcelRequire("8Ghey");
function $246af03292f78a50$export$736ebd57ab43df1(accessList) {
    if (!accessList || accessList.length === 0) return [];
    const serializedAccessList = [];
    for(let i = 0; i < accessList.length; i++){
        const { address: address, storageKeys: storageKeys } = accessList[i];
        for(let j = 0; j < storageKeys.length; j++){
            if (storageKeys[j].length - 2 !== 64) throw new (0, $3a3vr.InvalidStorageKeySizeError)({
                storageKey: storageKeys[j]
            });
        }
        if (!(0, $8Ghey.isAddress)(address, {
            strict: false
        })) throw new (0, $62VqX.InvalidAddressError)({
            address: address
        });
        serializedAccessList.push([
            address,
            storageKeys
        ]);
    }
    return serializedAccessList;
}


function $e0d077fad19d0614$export$7cb44e9a321cd996(transaction, signature) {
    const type = (0, $132020cae19f974b$export$944c6678cd5a1ea8)(transaction);
    if (type === "eip1559") return $e0d077fad19d0614$var$serializeTransactionEIP1559(transaction, signature);
    if (type === "eip2930") return $e0d077fad19d0614$var$serializeTransactionEIP2930(transaction, signature);
    if (type === "eip4844") return $e0d077fad19d0614$var$serializeTransactionEIP4844(transaction, signature);
    if (type === "eip7702") return $e0d077fad19d0614$var$serializeTransactionEIP7702(transaction, signature);
    return $e0d077fad19d0614$var$serializeTransactionLegacy(transaction, signature);
}
function $e0d077fad19d0614$var$serializeTransactionEIP7702(transaction, signature) {
    const { authorizationList: authorizationList, chainId: chainId, gas: gas, nonce: nonce, to: to, value: value, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, accessList: accessList, data: data } = transaction;
    (0, $fdec429c20f0c129$export$c066ee77932a0249)(transaction);
    const serializedAccessList = (0, $246af03292f78a50$export$736ebd57ab43df1)(accessList);
    const serializedAuthorizationList = (0, $017f3e8eaae93ff7$export$a695669f1a41df5b)(authorizationList);
    return (0, $jnwfF.concatHex)([
        "0x04",
        (0, $2291411846ceaf93$export$140c78e750979cda)([
            (0, $jW8ut.toHex)(chainId),
            nonce ? (0, $jW8ut.toHex)(nonce) : "0x",
            maxPriorityFeePerGas ? (0, $jW8ut.toHex)(maxPriorityFeePerGas) : "0x",
            maxFeePerGas ? (0, $jW8ut.toHex)(maxFeePerGas) : "0x",
            gas ? (0, $jW8ut.toHex)(gas) : "0x",
            to ?? "0x",
            value ? (0, $jW8ut.toHex)(value) : "0x",
            data ?? "0x",
            serializedAccessList,
            serializedAuthorizationList,
            ...$e0d077fad19d0614$export$13ef8e144f96fd76(transaction, signature)
        ])
    ]);
}
function $e0d077fad19d0614$var$serializeTransactionEIP4844(transaction, signature) {
    const { chainId: chainId, gas: gas, nonce: nonce, to: to, value: value, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, accessList: accessList, data: data } = transaction;
    (0, $fdec429c20f0c129$export$7a7b1c9cbdcde679)(transaction);
    let blobVersionedHashes = transaction.blobVersionedHashes;
    let sidecars = transaction.sidecars;
    // If `blobs` are passed, we will need to compute the KZG commitments & proofs.
    if (transaction.blobs && (typeof blobVersionedHashes === "undefined" || typeof sidecars === "undefined")) {
        const blobs = typeof transaction.blobs[0] === "string" ? transaction.blobs : transaction.blobs.map((x)=>(0, $jW8ut.bytesToHex)(x));
        const kzg = transaction.kzg;
        const commitments = (0, $70011a5ca3dd93f2$export$b67626aab22a659b)({
            blobs: blobs,
            kzg: kzg
        });
        if (typeof blobVersionedHashes === "undefined") blobVersionedHashes = (0, $7c2c25fe50bdb9c6$export$e31b3e59dda37b17)({
            commitments: commitments
        });
        if (typeof sidecars === "undefined") {
            const proofs = (0, $bfa4075f1d370529$export$78a225f8922765eb)({
                blobs: blobs,
                commitments: commitments,
                kzg: kzg
            });
            sidecars = (0, $bb4ee8a63805c99d$export$44960962e1c9641b)({
                blobs: blobs,
                commitments: commitments,
                proofs: proofs
            });
        }
    }
    const serializedAccessList = (0, $246af03292f78a50$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $jW8ut.toHex)(chainId),
        nonce ? (0, $jW8ut.toHex)(nonce) : "0x",
        maxPriorityFeePerGas ? (0, $jW8ut.toHex)(maxPriorityFeePerGas) : "0x",
        maxFeePerGas ? (0, $jW8ut.toHex)(maxFeePerGas) : "0x",
        gas ? (0, $jW8ut.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $jW8ut.toHex)(value) : "0x",
        data ?? "0x",
        serializedAccessList,
        maxFeePerBlobGas ? (0, $jW8ut.toHex)(maxFeePerBlobGas) : "0x",
        blobVersionedHashes ?? [],
        ...$e0d077fad19d0614$export$13ef8e144f96fd76(transaction, signature)
    ];
    const blobs = [];
    const commitments = [];
    const proofs = [];
    if (sidecars) for(let i = 0; i < sidecars.length; i++){
        const { blob: blob, commitment: commitment, proof: proof } = sidecars[i];
        blobs.push(blob);
        commitments.push(commitment);
        proofs.push(proof);
    }
    return (0, $jnwfF.concatHex)([
        "0x03",
        sidecars ? (0, $2291411846ceaf93$export$140c78e750979cda)([
            serializedTransaction,
            blobs,
            commitments,
            proofs
        ]) : (0, $2291411846ceaf93$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $e0d077fad19d0614$var$serializeTransactionEIP1559(transaction, signature) {
    const { chainId: chainId, gas: gas, nonce: nonce, to: to, value: value, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, accessList: accessList, data: data } = transaction;
    (0, $fdec429c20f0c129$export$9ce52ad2ebd4d8fd)(transaction);
    const serializedAccessList = (0, $246af03292f78a50$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $jW8ut.toHex)(chainId),
        nonce ? (0, $jW8ut.toHex)(nonce) : "0x",
        maxPriorityFeePerGas ? (0, $jW8ut.toHex)(maxPriorityFeePerGas) : "0x",
        maxFeePerGas ? (0, $jW8ut.toHex)(maxFeePerGas) : "0x",
        gas ? (0, $jW8ut.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $jW8ut.toHex)(value) : "0x",
        data ?? "0x",
        serializedAccessList,
        ...$e0d077fad19d0614$export$13ef8e144f96fd76(transaction, signature)
    ];
    return (0, $jnwfF.concatHex)([
        "0x02",
        (0, $2291411846ceaf93$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $e0d077fad19d0614$var$serializeTransactionEIP2930(transaction, signature) {
    const { chainId: chainId, gas: gas, data: data, nonce: nonce, to: to, value: value, accessList: accessList, gasPrice: gasPrice } = transaction;
    (0, $fdec429c20f0c129$export$18dc5e03b8985881)(transaction);
    const serializedAccessList = (0, $246af03292f78a50$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $jW8ut.toHex)(chainId),
        nonce ? (0, $jW8ut.toHex)(nonce) : "0x",
        gasPrice ? (0, $jW8ut.toHex)(gasPrice) : "0x",
        gas ? (0, $jW8ut.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $jW8ut.toHex)(value) : "0x",
        data ?? "0x",
        serializedAccessList,
        ...$e0d077fad19d0614$export$13ef8e144f96fd76(transaction, signature)
    ];
    return (0, $jnwfF.concatHex)([
        "0x01",
        (0, $2291411846ceaf93$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $e0d077fad19d0614$var$serializeTransactionLegacy(transaction, signature) {
    const { chainId: chainId = 0, gas: gas, data: data, nonce: nonce, to: to, value: value, gasPrice: gasPrice } = transaction;
    (0, $fdec429c20f0c129$export$f9ff7fa58fadd108)(transaction);
    let serializedTransaction = [
        nonce ? (0, $jW8ut.toHex)(nonce) : "0x",
        gasPrice ? (0, $jW8ut.toHex)(gasPrice) : "0x",
        gas ? (0, $jW8ut.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $jW8ut.toHex)(value) : "0x",
        data ?? "0x"
    ];
    if (signature) {
        const v = (()=>{
            // EIP-155 (inferred chainId)
            if (signature.v >= 35n) {
                const inferredChainId = (signature.v - 35n) / 2n;
                if (inferredChainId > 0) return signature.v;
                return 27n + (signature.v === 35n ? 0n : 1n);
            }
            // EIP-155 (explicit chainId)
            if (chainId > 0) return BigInt(chainId * 2) + BigInt(35n + signature.v - 27n);
            // Pre-EIP-155 (no chainId)
            const v = 27n + (signature.v === 27n ? 0n : 1n);
            if (signature.v !== v) throw new (0, $3a3vr.InvalidLegacyVError)({
                v: signature.v
            });
            return v;
        })();
        const r = (0, $geW6W.trim)(signature.r);
        const s = (0, $geW6W.trim)(signature.s);
        serializedTransaction = [
            ...serializedTransaction,
            (0, $jW8ut.toHex)(v),
            r === "0x00" ? "0x" : r,
            s === "0x00" ? "0x" : s
        ];
    } else if (chainId > 0) serializedTransaction = [
        ...serializedTransaction,
        (0, $jW8ut.toHex)(chainId),
        "0x",
        "0x"
    ];
    return (0, $2291411846ceaf93$export$140c78e750979cda)(serializedTransaction);
}
function $e0d077fad19d0614$export$13ef8e144f96fd76(transaction, signature_) {
    const signature = signature_ ?? transaction;
    const { v: v, yParity: yParity } = signature;
    if (typeof signature.r === "undefined") return [];
    if (typeof signature.s === "undefined") return [];
    if (typeof v === "undefined" && typeof yParity === "undefined") return [];
    const r = (0, $geW6W.trim)(signature.r);
    const s = (0, $geW6W.trim)(signature.s);
    const yParity_ = (()=>{
        if (typeof yParity === "number") return yParity ? (0, $jW8ut.toHex)(1) : "0x";
        if (v === 0n) return "0x";
        if (v === 1n) return (0, $jW8ut.toHex)(1);
        return v === 27n ? "0x" : (0, $jW8ut.toHex)(1);
    })();
    return [
        yParity_,
        r === "0x00" ? "0x" : r,
        s === "0x00" ? "0x" : s
    ];
}


function $18698662cadadad8$export$7cb44e9a321cd996(transaction, signature) {
    if ($18698662cadadad8$var$isDeposit(transaction)) return $18698662cadadad8$var$serializeTransactionDeposit(transaction);
    return (0, $e0d077fad19d0614$export$7cb44e9a321cd996)(transaction, signature);
}
const $18698662cadadad8$export$7824249990c72c71 = {
    transaction: $18698662cadadad8$export$7cb44e9a321cd996
};
function $18698662cadadad8$var$serializeTransactionDeposit(transaction) {
    $18698662cadadad8$export$91db50bb3f58e144(transaction);
    const { sourceHash: sourceHash, data: data, from: from, gas: gas, isSystemTx: isSystemTx, mint: mint, to: to, value: value } = transaction;
    const serializedTransaction = [
        sourceHash,
        from,
        to ?? "0x",
        mint ? (0, $jW8ut.toHex)(mint) : "0x",
        value ? (0, $jW8ut.toHex)(value) : "0x",
        gas ? (0, $jW8ut.toHex)(gas) : "0x",
        isSystemTx ? "0x1" : "0x",
        data ?? "0x"
    ];
    return (0, $jnwfF.concatHex)([
        "0x7e",
        (0, $2291411846ceaf93$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $18698662cadadad8$var$isDeposit(transaction) {
    if (transaction.type === "deposit") return true;
    if (typeof transaction.sourceHash !== "undefined") return true;
    return false;
}
function $18698662cadadad8$export$91db50bb3f58e144(transaction) {
    const { from: from, to: to } = transaction;
    if (from && !(0, $8Ghey.isAddress)(from)) throw new (0, $62VqX.InvalidAddressError)({
        address: from
    });
    if (to && !(0, $8Ghey.isAddress)(to)) throw new (0, $62VqX.InvalidAddressError)({
        address: to
    });
}


const $c1abb8e784db6393$export$ca9ff151299322fa = {
    contracts: $fa672b3df29e91ac$export$ea30b8ddade7b2c1,
    formatters: $85a41f8b9e2f6531$export$fe98a034cfb96d55,
    serializers: $18698662cadadad8$export$7824249990c72c71
};



const $8b8a8e7e7953b7e7$var$sourceId = 1; // mainnet
const $8b8a8e7e7953b7e7$export$e2253033e6e1df16 = /*#__PURE__*/ (0, $b32ab6fe95d80134$export$b6380ff64616a4fb)({
    ...(0, $c1abb8e784db6393$export$ca9ff151299322fa),
    id: 8453,
    name: "Base",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://mainnet.base.org"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Basescan",
            url: "https://basescan.org",
            apiUrl: "https://api.basescan.org/api"
        }
    },
    contracts: {
        ...(0, $c1abb8e784db6393$export$ca9ff151299322fa).contracts,
        disputeGameFactory: {
            [$8b8a8e7e7953b7e7$var$sourceId]: {
                address: "0x43edB88C4B80fDD2AdFF2412A7BebF9dF42cB40e"
            }
        },
        l2OutputOracle: {
            [$8b8a8e7e7953b7e7$var$sourceId]: {
                address: "0x56315b90c40730925ec5485cf004d835058518A0"
            }
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 5022
        },
        portal: {
            [$8b8a8e7e7953b7e7$var$sourceId]: {
                address: "0x49048044D57e1C92A77f79988d21Fa8fAF74E97e",
                blockCreated: 17482143
            }
        },
        l1StandardBridge: {
            [$8b8a8e7e7953b7e7$var$sourceId]: {
                address: "0x3154Cf16ccdb4C6d922629664174b904d80F2C35",
                blockCreated: 17482143
            }
        }
    },
    sourceId: $8b8a8e7e7953b7e7$var$sourceId
});


const $5596af4cd10e01ae$export$170e8cdd0c4e59c8 = /*#__PURE__*/ (0, $b32ab6fe95d80134$export$b6380ff64616a4fb)({
    id: 56,
    name: "BNB Smart Chain",
    nativeCurrency: {
        decimals: 18,
        name: "BNB",
        symbol: "BNB"
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.ankr.com/bsc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "BscScan",
            url: "https://bscscan.com",
            apiUrl: "https://api.bscscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 15921452
        }
    }
});


const $58fc31f2a3fd6e20$export$1c182ebff3ea4eef = /*#__PURE__*/ (0, $b32ab6fe95d80134$export$b6380ff64616a4fb)({
    id: 97,
    name: "Binance Smart Chain Testnet",
    nativeCurrency: {
        decimals: 18,
        name: "BNB",
        symbol: "tBNB"
    },
    rpcUrls: {
        default: {
            http: [
                "https://data-seed-prebsc-1-s1.bnbchain.org:8545"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "BscScan",
            url: "https://testnet.bscscan.com",
            apiUrl: "https://api-testnet.bscscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 17422483
        }
    },
    testnet: true
});


const $36f79a8204625dbe$export$b7b19aa0ee06c73 = /*#__PURE__*/ (0, $b32ab6fe95d80134$export$b6380ff64616a4fb)({
    id: 137,
    name: "Polygon",
    nativeCurrency: {
        name: "POL",
        symbol: "POL",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://polygon-rpc.com"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "PolygonScan",
            url: "https://polygonscan.com",
            apiUrl: "https://api.polygonscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 25770160
        }
    }
});


const $4f6980c73ec6ab1b$export$34b6ef3a78067459 = /*#__PURE__*/ (0, $b32ab6fe95d80134$export$b6380ff64616a4fb)({
    id: 80001,
    name: "Polygon Mumbai",
    nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.ankr.com/polygon_mumbai"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "PolygonScan",
            url: "https://mumbai.polygonscan.com",
            apiUrl: "https://api-testnet.polygonscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 25770160
        }
    },
    testnet: true
});


var $786b5fdea564ab1f$exports = {};

$786b5fdea564ab1f$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "ArbitrumLogo.4a7518b6.svg";


var $0f6589a7fd3dabb4$exports = {};

$0f6589a7fd3dabb4$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "AvalancheLogo.ad53a0d0.svg";


var $555311c7b33a42df$exports = {};

$555311c7b33a42df$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "BaseLogo.e87313d9.svg";


var $f9d4be6bd5381211$exports = {};

$f9d4be6bd5381211$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "BAT.1212afba.svg";


var $d049204adf92834d$exports = {};

$d049204adf92834d$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "BNBLogo.3dada3dc.svg";


var $c036c0129724480d$exports = {};

$c036c0129724480d$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "BTCLogo.5558c6c7.svg";


var $f37f8496d4380a6d$exports = {};

$f37f8496d4380a6d$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "BUSDLogo.a70524b3.svg";


var $a2090fb90712ffcb$exports = {};

$a2090fb90712ffcb$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "CardanoLogo.c8e54c54.svg";


var $6870fb60a7305717$exports = {};

$6870fb60a7305717$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "DashLogo.ac107e85.svg";


var $2bfe91bbe3e81fb6$exports = {};

$2bfe91bbe3e81fb6$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "Doge.9d700487.png";


var $fc42ad4ecdaf10b6$exports = {};

$fc42ad4ecdaf10b6$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "DogeLogo.58faeab6.svg";


var $5173ee4100032030$exports = {};

$5173ee4100032030$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "DOT.7e599be5.svg";


var $8e2a7a4543c2cd55$exports = {};

$8e2a7a4543c2cd55$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "EthLogo.b15259c3.svg";


var $520f5deaa7f892c9$exports = {};

$520f5deaa7f892c9$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "LitecoinLogo.f8fad246.svg";


var $36139881f9901c23$exports = {};

$36139881f9901c23$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "PolygonLogo.7d5d4b87.svg";


var $f5d4c423fd761ed8$exports = {};

$f5d4c423fd761ed8$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "Solana.47b69164.svg";


var $e608bbb91d2eed9f$exports = {};

$e608bbb91d2eed9f$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "TetherLogo.85e85692.svg";


var $dded44f1d1b95348$exports = {};

$dded44f1d1b95348$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "TronLogo.a023c6a9.svg";


var $bda59fb5663105ad$exports = {};

$bda59fb5663105ad$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "USDCLogo.08b3a902.svg";


var $076a42c8390623c8$exports = {};

$076a42c8390623c8$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "EURCLogo.3ca41448.svg";


var $837bdcba208a56e9$exports = {};

$837bdcba208a56e9$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "VerseLogo.e24b56c2.png";


var $bb513c2ca486cf78$exports = {};

$bb513c2ca486cf78$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "XMRLogo.26608d9e.svg";


var $956fd38f86d31bc5$exports = {};

$956fd38f86d31bc5$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "ZcashLogo.5ee68c2f.svg";


var $10928f033a12e235$exports = {};

$10928f033a12e235$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "EUROLogo.d27285e3.svg";


var $6986632ba7298c22$exports = {};

$6986632ba7298c22$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "GBPLogo.18d6f7a0.svg";


var $0f7ca32a4d60e934$exports = {};

$0f7ca32a4d60e934$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "BCHLogo.b63c073e.svg";


const $5760199798158999$export$cc4208a8ebc9f985 = {
    Ethereum: (0, $6b15c8827610446e$export$536d3e0d2c7baf54),
    Avalanche: (0, $955bd3ed7956d1ea$export$ca1d15c01fde7266),
    Base: (0, $8b8a8e7e7953b7e7$export$e2253033e6e1df16),
    SepoliaTestnet: {
        id: 11155111,
        network: "sepolia",
        name: "Sepolia",
        nativeCurrency: {
            name: "Sepolia Ether",
            symbol: "SEP",
            decimals: 18
        },
        rpcUrls: {
            alchemy: {
                http: [
                    "https://eth-sepolia.g.alchemy.com/v2"
                ],
                webSocket: [
                    "wss://eth-sepolia.g.alchemy.com/v2"
                ]
            },
            infura: {
                http: [
                    "https://sepolia.infura.io/v3"
                ],
                webSocket: [
                    "wss://sepolia.infura.io/ws/v3"
                ]
            },
            default: {
                http: [
                    "https://ethereum-sepolia-public.nodies.app",
                    "https://0xrpc.io/sep",
                    "https://eth-sepolia.api.onfinality.io/public",
                    "https://sepolia.gateway.tenderly.co",
                    "https://gateway.tenderly.co/public/sepolia",
                    "https://rpc.sepolia.ethpandaops.io",
                    "https://ethereum-sepolia-rpc.publicnode.com",
                    "https://sepolia.drpc.org",
                    "https://api.zan.top/eth-sepolia",
                    "https://rpc.sentio.xyz/sepolia",
                    "https://ethereum-sepolia.rpc.subquery.network/public",
                    "https://1rpc.io/sepolia",
                    "https://eth-sepolia-testnet.api.pocket.network"
                ]
            },
            public: {
                http: [
                    "https://sepolia.drpc.org",
                    "https://ethereum-sepolia-rpc.publicnode.com",
                    "https://1rpc.io/sepolia"
                ]
            }
        },
        blockExplorers: {
            etherscan: {
                name: "Etherscan",
                url: "https://sepolia.etherscan.io"
            },
            default: {
                name: "Etherscan",
                url: "https://sepolia.etherscan.io"
            }
        },
        contracts: {
            multicall3: {
                address: "0xca11bde05977b3631167028862be2a173976ca11",
                blockCreated: 6507670
            }
        },
        testnet: true
    },
    Polygon: (0, $36f79a8204625dbe$export$b7b19aa0ee06c73),
    PolygonTestnet: (0, $4f6980c73ec6ab1b$export$34b6ef3a78067459),
    BNB: (0, $5596af4cd10e01ae$export$170e8cdd0c4e59c8),
    BNBTestnet: (0, $58fc31f2a3fd6e20$export$1c182ebff3ea4eef),
    Arbitrum: (0, $87066091a14e934d$export$625cf84d855940d4),
    ArbitrumTestnet: (0, $c442231210e6099e$export$857f1b5f596fb425)
};
const $5760199798158999$var$chains = Object.values($5760199798158999$export$cc4208a8ebc9f985);
const $5760199798158999$export$e4bb003b4e7478a = "e13bb5b25a3121bba8a056c8dadd0c1c";
const $5760199798158999$var$metadata = {
    name: "Radom",
    description: "Decentralized payments",
    url: "https://radom.com",
    icons: []
};
const $5760199798158999$export$382a3cc012b91987 = (0, $87b2c6fa17d09c62$export$134240a34d71525e)({
    chains: $5760199798158999$var$chains,
    projectId: $5760199798158999$export$e4bb003b4e7478a,
    metadata: $5760199798158999$var$metadata
});
const $5760199798158999$export$ba33f6d94de735b7 = ()=>[
        {
            name: "Bitcoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c036c0129724480d$exports))),
            ticker: "BTC"
        },
        {
            name: "BitcoinTestnet",
            currencyName: "Bitcoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c036c0129724480d$exports))),
            ticker: "BTC",
            isTestnet: true
        },
        {
            name: "Litecoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($520f5deaa7f892c9$exports))),
            ticker: "LTC"
        },
        {
            name: "LitecoinTestnet",
            currencyName: "Litecoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($520f5deaa7f892c9$exports))),
            ticker: "LTC",
            isTestnet: true
        },
        {
            name: "Dogecoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($fc42ad4ecdaf10b6$exports))),
            ticker: "DOGE",
            qrCodeImage: (0, (/*@__PURE__*/$parcel$interopDefault($2bfe91bbe3e81fb6$exports)))
        },
        {
            name: "DogecoinTestnet",
            currencyName: "Dogecoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($fc42ad4ecdaf10b6$exports))),
            ticker: "DOGE",
            isTestnet: true,
            qrCodeImage: (0, (/*@__PURE__*/$parcel$interopDefault($2bfe91bbe3e81fb6$exports)))
        },
        {
            name: "BitcoinCash",
            currencyName: "Bitcoin Cash",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($0f7ca32a4d60e934$exports))),
            ticker: "BCH"
        },
        {
            name: "BitcoinCashTestnet",
            currencyName: "Bitcoin Cash",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($0f7ca32a4d60e934$exports))),
            ticker: "BCH",
            isTestnet: true
        },
        {
            name: "BitcoinSV",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c036c0129724480d$exports))),
            ticker: "BSV"
        },
        {
            name: "Ethereum",
            currencyName: "Ether",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
            ticker: "ETH",
            isWalletSupported: true
        },
        {
            name: "SepoliaTestnet",
            currencyName: "Ether",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
            ticker: "ETH",
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Polygon",
            currencyName: "Matic",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
            ticker: "MATIC",
            isWalletSupported: true
        },
        {
            name: "Avalanche",
            currencyName: "Avalanche",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($0f6589a7fd3dabb4$exports))),
            ticker: "AVAX",
            isWalletSupported: true
        },
        {
            name: "PolygonTestnet",
            currencyName: "Matic",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
            ticker: "MATIC",
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "BNB",
            currencyName: "BNB",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($d049204adf92834d$exports))),
            ticker: "BNB",
            isWalletSupported: true
        },
        {
            name: "BNBTestnet",
            currencyName: "BNB",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($d049204adf92834d$exports))),
            ticker: "BNB",
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Arbitrum",
            currencyName: "ETH",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($786b5fdea564ab1f$exports))),
            ticker: "ETH",
            isWalletSupported: true
        },
        {
            name: "Base",
            currencyName: "ETH",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($555311c7b33a42df$exports))),
            ticker: "ETH",
            isWalletSupported: true
        },
        {
            name: "Sepolia USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 11155111,
                tokenAddress: "0xa4fCE8264370437e718aE207805b4e6233638b9E",
                networkName: "SepoliaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Devnet USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "solana",
                tokenAddress: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
                networkName: "SolanaDevnet",
                cluster: "SolanaDevnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($f5d4c423fd761ed8$exports))),
                decimals: 6
            },
            isTestnet: true,
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "Sepolia Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 11155111,
                tokenAddress: "0xE50d86c6dE38F9754f6777d2925377564Bf79482",
                networkName: "SepoliaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($f9d4be6bd5381211$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 11155111,
                tokenAddress: "0x5D684d37922dAf7Aa2013E65A22880a11C475e25",
                networkName: "SepoliaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Polygon Testnet USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 80001,
                tokenAddress: "0x8f8b1972eea072C3C228EbE8f9FEADe03927D70F",
                networkName: "PolygonTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Polygon Testnet Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 80001,
                tokenAddress: "0x70BE8802e2F3C6652B7e0814B478f66Ec52d9d88",
                networkName: "PolygonTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Polygon Testnet BAT",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($f9d4be6bd5381211$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 80001,
                tokenAddress: "0xd445cAAbb9eA6685D3A512439256866563a16E93",
                networkName: "PolygonTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0x55d398326f99059ff775485246999027b3197955",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($d049204adf92834d$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($d049204adf92834d$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 8453,
                tokenAddress: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
                networkName: "Base",
                subscriptionContract: "0x61dD58140201Af4E77B67a36BaA25e1e560d87E9",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($555311c7b33a42df$exports))),
                decimals: 6
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 42161,
                tokenAddress: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
                networkName: "Arbitrum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($786b5fdea564ab1f$exports))),
                decimals: 6
            },
            isWalletSupported: true
        },
        {
            name: "Bridged USD Coin",
            ticker: "USDC.e",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 42161,
                tokenAddress: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
                networkName: "Arbitrum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($786b5fdea564ab1f$exports))),
                decimals: 6
            },
            isWalletSupported: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 42161,
                tokenAddress: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
                networkName: "Arbitrum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($786b5fdea564ab1f$exports))),
                decimals: 6
            },
            isWalletSupported: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 43114,
                tokenAddress: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
                networkName: "Avalanche",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($0f6589a7fd3dabb4$exports))),
                decimals: 6
            },
            isWalletSupported: true
        },
        {
            name: "Binance USD",
            ticker: "BUSD",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($f37f8496d4380a6d$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($d049204adf92834d$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($f9d4be6bd5381211$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0x101d82428437127bf1608f699cd651e6abf9766e",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($d049204adf92834d$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($f9d4be6bd5381211$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Verse",
            ticker: "VERSE",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($837bdcba208a56e9$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0x249ca82617ec3dfb2589c4c17ab7ec9765350a18",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Bridged USD Coin",
            ticker: "USDC.e",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($f9d4be6bd5381211$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x3cef98bb43d732e2f285ee605a8158cde967d219",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Solana",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($f5d4c423fd761ed8$exports))),
            ticker: "SOL",
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "SolanaTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($f5d4c423fd761ed8$exports))),
            ticker: "SOL",
            isTestnet: true,
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "SolanaDevnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($f5d4c423fd761ed8$exports))),
            ticker: "SOL",
            isTestnet: true,
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "Polkadot",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5173ee4100032030$exports))),
            ticker: "DOT"
        },
        {
            name: "PolkadotTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5173ee4100032030$exports))),
            ticker: "PAS",
            isTestnet: true
        },
        {
            name: "PolkadotAssetHub",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5173ee4100032030$exports))),
            ticker: "DOT"
        },
        {
            name: "Polkadot AssetHub Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "asset",
                cluster: "mainnet",
                tokenAddress: "1984",
                networkName: "PolkadotAssetHub",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5173ee4100032030$exports))),
                decimals: 6
            }
        },
        {
            name: "Polkadot AssetHub USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "asset",
                cluster: "mainnet",
                tokenAddress: "1337",
                networkName: "PolkadotAssetHub",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5173ee4100032030$exports))),
                decimals: 6
            }
        },
        {
            name: "PolkadotAssetHubTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5173ee4100032030$exports))),
            ticker: "PAS",
            isTestnet: true
        },
        {
            name: "Polkadot AssetHub Testnet Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            isTestnet: true,
            tokenInfo: {
                tokenType: "asset",
                cluster: "testnet",
                tokenAddress: "21984",
                networkName: "PolkadotAssetHubTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5173ee4100032030$exports))),
                decimals: 6
            }
        },
        {
            name: "Polkadot AssetHub Testnet USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            isTestnet: true,
            tokenInfo: {
                tokenType: "asset",
                cluster: "testnet",
                tokenAddress: "31337",
                networkName: "PolkadotAssetHubTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5173ee4100032030$exports))),
                decimals: 6
            }
        },
        {
            name: "Solana Testnet USD Coin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            ticker: "USDC",
            isTestnet: true,
            tokenInfo: {
                tokenType: "solana",
                cluster: "testnet",
                tokenAddress: "CpMah17kQEL2wqyMKt3mZBdTnZbkbfx4nqmQMFDP5vwp",
                networkName: "SolanaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
                decimals: 6
            },
            isSolana: true
        },
        {
            name: "Solana Devnet USD Coin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            ticker: "USDC",
            isTestnet: true,
            tokenInfo: {
                tokenType: "solana",
                cluster: "devnet",
                tokenAddress: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
                networkName: "SolanaDevnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
                decimals: 6
            },
            isSolana: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "solana",
                cluster: "mainnet",
                tokenAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
                networkName: "Solana",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($f5d4c423fd761ed8$exports))),
                decimals: 6
            },
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
            tokenInfo: {
                tokenType: "solana",
                cluster: "mainnet",
                tokenAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
                networkName: "Solana",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($f5d4c423fd761ed8$exports))),
                decimals: 6
            },
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "Euro Coin",
            ticker: "EURC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($076a42c8390623c8$exports))),
            tokenInfo: {
                tokenType: "solana",
                cluster: "mainnet",
                tokenAddress: "HzwqbKZw8HxMN6bF2yFZNrht3c2iXXzpKcFu7uBEDKtr",
                networkName: "Solana",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($f5d4c423fd761ed8$exports))),
                decimals: 6
            },
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($f9d4be6bd5381211$exports))),
            tokenInfo: {
                tokenType: "solana",
                cluster: "mainnet",
                tokenAddress: "EPeUFDgHRxs9xxEPVaL6kfGQvCon7jmAWKVUHuux1Tpz",
                networkName: "Solana",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($f5d4c423fd761ed8$exports))),
                decimals: 8
            },
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "Cardano",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($a2090fb90712ffcb$exports))),
            ticker: "ADA"
        },
        {
            name: "Monero",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bb513c2ca486cf78$exports))),
            ticker: "XMR"
        },
        {
            name: "MoneroStagenet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bb513c2ca486cf78$exports))),
            ticker: "XMR",
            isTestnet: true
        },
        {
            name: "Dash",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($6870fb60a7305717$exports))),
            ticker: "DASH"
        },
        {
            name: "Zcash",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($956fd38f86d31bc5$exports))),
            ticker: "ZEC"
        },
        {
            name: "ZcashTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($956fd38f86d31bc5$exports))),
            ticker: "ZEC",
            isTestnet: true
        },
        {
            name: "Tron",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($dded44f1d1b95348$exports))),
            ticker: "TRX"
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "tron",
                networkName: "Tron",
                tokenAddress: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($dded44f1d1b95348$exports))),
                decimals: 6
            }
        },
        {
            name: "TronTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($dded44f1d1b95348$exports))),
            ticker: "TRX",
            isTestnet: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
            tokenInfo: {
                tokenType: "tron",
                networkName: "TronTestnet",
                tokenAddress: "TSrUgwP9NPHKMcWPtHRRWcoxFV4JU6R9qk",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($dded44f1d1b95348$exports))),
                decimals: 6
            },
            isTestnet: true
        },
        {
            name: "Fiat",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($10928f033a12e235$exports))),
            ticker: "EUR",
            isTestnet: false
        },
        {
            name: "Fiat",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($6986632ba7298c22$exports))),
            ticker: "GBP",
            isTestnet: false
        }
    ];
const $5760199798158999$export$8793fab959da70d1 = (network, token)=>{
    const method = $5760199798158999$export$ba33f6d94de735b7().find((m)=>{
        if (token) return m.tokenInfo?.tokenAddress.toLowerCase() === token.toLowerCase() && network.toLowerCase() === m.tokenInfo?.networkName.toLowerCase();
        else return m.name.toLowerCase() === network.toLowerCase();
    });
    if (!method && network === "Fiat") {
        const method = $5760199798158999$export$ba33f6d94de735b7().find((m)=>{
            return m.name.toLowerCase() === "fiat" && m.ticker === token;
        });
        if (method) return method;
    }
    if (!method) {
        const method = $5760199798158999$export$ba33f6d94de735b7().find((m)=>{
            return m.name.toLowerCase() === network.toLowerCase();
        });
        if (method) return method;
    }
    if (!method) return {
        name: "Unknown",
        logo: null,
        ticker: "Unknown"
    };
    return method;
};
const $5760199798158999$export$aab47327b38c6232 = (m)=>{
    if (!m) return false;
    if (m.tokenInfo) {
        if (m.tokenInfo.tokenType === "evm" && m.tokenInfo.subscriptionContract) return true;
    }
    return false;
};
const $5760199798158999$export$e89279dd51bd64b8 = new Set([
    "Polkadot",
    "PolkadotTestnet",
    "PolkadotAssetHub",
    "PolkadotAssetHubTestnet",
    "Monero",
    "MoneroStagenet",
    "BitcoinSV"
]);
const $5760199798158999$var$DELISTED_TOKENS = new Set([
    "0xe9e7cea3dedca5984780bafc599bd69add087d56"
]);
const $5760199798158999$export$53becfa3eb141e16 = (network, token)=>$5760199798158999$export$e89279dd51bd64b8.has(network) || !!token && $5760199798158999$var$DELISTED_TOKENS.has(token.toLowerCase());


function $94d9469e1ad800ce$export$9b8b3c5440f71236(item, currency, priceQuotes) {
    const conversion = priceQuotes.find((p)=>p.from === item.currency && p.to === currency)?.value ?? 1;
    return item.price * (item.quantity ?? 1) * conversion;
}
function $94d9469e1ad800ce$export$d20ac211ddc8e780(dollarNumber) {
    return Math.max(0.5, Math.min(2.5, dollarNumber * 0.008));
}
function $94d9469e1ad800ce$export$61a490a80c552550(value, from, to, priceQuotes, chargeCustomerNetworkFee, paymentMethodDiscount = 0) {
    const conversion = priceQuotes.find((p)=>p.from === from.toUpperCase() && p.to === to.toUpperCase())?.value ?? 1;
    const networkFeeDollarValue = $94d9469e1ad800ce$export$d20ac211ddc8e780(value * (priceQuotes.find((p)=>p.from === from.toUpperCase() && p.to === "USD")?.value ?? 1));
    const networkFeeConvertedValue = networkFeeDollarValue / (priceQuotes.find((p)=>p.from === from.toUpperCase() && p.to === "USD")?.value ?? 1);
    return Number((value * conversion * (1 - paymentMethodDiscount) + (chargeCustomerNetworkFee ? networkFeeConvertedValue * conversion : 0)).toFixed(12));
}
function $94d9469e1ad800ce$export$56eaa5cece9d2d8a(checkoutData, priceQuotes, primaryCurrency, discount) {
    let total = 0;
    let subscriptionTotal = 0;
    const normalizedCheckoutTotal = Number(checkoutData.total);
    if (Number.isFinite(normalizedCheckoutTotal) && normalizedCheckoutTotal > 0) {
        total = normalizedCheckoutTotal;
        return [
            total,
            subscriptionTotal
        ];
    }
    if (checkoutData.products) total += checkoutData.products.reduce((total, p)=>{
        let subTotal = $94d9469e1ad800ce$export$9b8b3c5440f71236({
            ...p.product,
            quantity: p.quantity
        }, primaryCurrency, priceQuotes);
        if (discount?.products.includes(p.product.id)) switch(discount.model.modelType){
            case "fixed":
                subTotal -= discount.model.amountOff;
                break;
            case "percentage":
                subTotal -= subTotal * discount.model.amountOff / 100;
        }
        if (p.product.chargingIntervalSeconds > 0) subscriptionTotal += subTotal;
        return total + subTotal;
    }, 0);
    if (checkoutData.subscription) {
        const subTotal = $94d9469e1ad800ce$export$9b8b3c5440f71236({
            price: Number(checkoutData.subscription.amount),
            currency: checkoutData.subscription.currency,
            quantity: 1
        }, primaryCurrency, priceQuotes);
        total += subTotal;
    }
    if (checkoutData.lineItems) total += checkoutData.lineItems.reduce((total, p)=>{
        const subTotal = $94d9469e1ad800ce$export$9b8b3c5440f71236(p, primaryCurrency, priceQuotes);
        if (p.chargingIntervalSeconds > 0) subscriptionTotal += subTotal;
        return total + subTotal;
    }, 0);
    return [
        total,
        subscriptionTotal
    ];
}



var $105fR = parcelRequire("105fR");


async function $772308ca90c00f76$var$loadImage(src) {
    const image = new Image();
    image.crossOrigin = "anonymous";
    return await new Promise((resolve)=>{
        image.onload = ()=>{
            resolve(image);
        };
        image.src = src;
    });
}
async function $772308ca90c00f76$export$45312203e6f4f22c(paymentMethodDetails, darkColor = "#000000", lightColor = "#ffffff", drawRadius = true) {
    let dataUrl = "";
    const { network: network, token: token, paymentAddress: paymentAddress, amount: amount } = paymentMethodDetails;
    const paymentMethod = (0, $5760199798158999$export$8793fab959da70d1)(network, token);
    switch(paymentMethod.name){
        case "Bitcoin":
        case "BitcoinTestnet":
            dataUrl = `bitcoin:${paymentAddress}?value=${amount}`;
            break;
        case "BitcoinSV":
        case "BitcoinSVTestnet":
            dataUrl = `bitcoinsv:${paymentAddress}?value=${amount}`;
            break;
        case "Dogecoin":
        case "DogecoinTestnet":
            dataUrl = `dogecoin:${paymentAddress}?value=${amount}`;
            break;
        case "Litecoin":
        case "LitecoinTestnet":
            dataUrl = `litecoin:${paymentAddress}}?amount=${amount}`;
            break;
        case "BitcoinCash":
        case "BitcoinCashTestnet":
            dataUrl = `${paymentAddress}}?amount=${amount}`;
            break;
        case "Monero":
        case "MoneroStagenet":
            dataUrl = `monero:${paymentAddress}?tx_amount=${amount}`;
            break;
        case "Ethereum":
        case "SepoliaTestnet":
        case "Polygon":
        case "PolygonTestnet":
        case "BNB":
        case "BNBTestnet":
        case "Arbitrum":
        case "Avalanche":
        case "Base":
        case "ArbitrumTestnet":
            dataUrl = `ethereum:${paymentAddress}?value=${(0, $5316bee174ce871c$export$642c4e67bbdc0bc7)(amount)}`;
            break;
        case "SolanaDevnet":
        case "SolanaTestnet":
        case "Solana":
            dataUrl = `solana:${paymentAddress}?value=${amount}`;
            break;
        case "Zcash":
        case "ZcashTestnet":
            dataUrl = `zcash:${paymentAddress}?value=${amount}`;
            break;
        case "Dogecoin":
            dataUrl = `dogecoin:${paymentAddress}?value=${amount}`;
            break;
        case "Tron":
        case "TronTestnet":
            dataUrl = `tron:${paymentAddress}?value=${(0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(amount, 6)}`;
            break;
        case "PolkadotAssetHub":
        case "PolkadotAssetHubTestnet":
        case "PolkadotTestnet":
        case "Polkadot":
            dataUrl = paymentAddress;
            break;
    }
    switch(paymentMethod.tokenInfo?.networkName){
        case "Ethereum":
        case "SepoliaTestnet":
        case "Polygon":
        case "PolygonTestnet":
        case "BNB":
        case "BNBTestnet":
        case "Arbitrum":
        case "Avalanche":
        case "Base":
        case "ArbitrumTestnet":
            {
                const { tokenAddress: tokenAddress, chainId: chainId, decimals: decimals } = paymentMethod.tokenInfo;
                dataUrl = `ethereum:${tokenAddress}@${chainId}/transfer?address=${paymentAddress}&uint256=${(0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(amount, decimals)}`;
                break;
            }
        case "Solana":
        case "SolanaDevnet":
        case "SolanaTestnet":
            {
                const { tokenAddress: tokenAddress, decimals: decimals, cluster: cluster } = paymentMethod.tokenInfo;
                dataUrl = `solana:${tokenAddress}@${cluster}/transfer?address=${paymentAddress}&uint256=${(0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(amount, decimals)}`;
                break;
            }
        case "Tron":
        case "TronTestnet":
            {
                const { tokenAddress: tokenAddress, decimals: decimals } = paymentMethod.tokenInfo;
                dataUrl = `tron:${tokenAddress}/transfer?address=${paymentAddress}&uint256=${(0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(amount, decimals)}`;
                break;
            }
        case "PolkadotAssetHubTestnet":
        case "PolkadotAssetHub":
            dataUrl = paymentAddress;
            break;
    }
    const width = 500;
    const height = 500;
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    (0, (/*@__PURE__*/$parcel$interopDefault($105fR))).toCanvas(canvas, dataUrl, {
        errorCorrectionLevel: "H",
        margin: 1,
        color: {
            dark: darkColor,
            light: lightColor
        },
        width: 500
    });
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        console.error("Failed to get canvas");
        return await Promise.reject(new Error("Failed to get canvas context"));
    }
    const img = await $772308ca90c00f76$var$loadImage(paymentMethod.qrCodeImage || paymentMethod.logo);
    const maxLogoSize = 100;
    ctx.beginPath();
    ctx.fillStyle = "#ffffff";
    const outlineSize = 20;
    if (paymentMethod.tokenInfo) {
        const imgMax = Math.max(img.width, img.height);
        const imgWidth = img.width / imgMax * maxLogoSize;
        const imgHeight = img.height / imgMax * maxLogoSize;
        const centerX = (500 - imgWidth) / 2;
        const centerY = (500 - imgHeight) / 2;
        if (drawRadius && ctx.roundRect) {
            ctx.roundRect(200 - outlineSize / 2, 200 - outlineSize / 2, maxLogoSize + outlineSize, maxLogoSize + outlineSize, 90);
            ctx.fill();
        }
        const chainImage = await $772308ca90c00f76$var$loadImage(paymentMethod.tokenInfo.logo);
        const chainImgMax = Math.max(chainImage.width, chainImage.height);
        const chainImgWidth = chainImage.width / chainImgMax * maxLogoSize / 2;
        const chainImgHeight = chainImage.height / chainImgMax * maxLogoSize / 2;
        if (drawRadius && ctx.roundRect) {
            ctx.roundRect(centerX + maxLogoSize / 2 + outlineSize - 14, centerX + maxLogoSize / 2 + outlineSize - 14, 70, 70, 90);
            ctx.fill();
        }
        ctx.drawImage(img, centerX, centerY, imgWidth, imgHeight);
        ctx.drawImage(chainImage, centerX + maxLogoSize / 2 + outlineSize + (Math.max(chainImgWidth, chainImgHeight) - chainImgWidth) / 2, centerY + maxLogoSize / 2 + outlineSize + (Math.max(chainImgWidth, chainImgHeight) - chainImgHeight) / 2, chainImgWidth, chainImgHeight);
    } else {
        const imgMax = Math.max(img.width, img.height);
        const imgWidth = img.width / imgMax * maxLogoSize;
        const imgHeight = img.height / imgMax * maxLogoSize;
        const centerX = (500 - imgWidth) / 2;
        const centerY = (500 - imgHeight) / 2;
        if (drawRadius && ctx.roundRect) {
            ctx.roundRect(200 - outlineSize / 2, 200 - outlineSize / 2, maxLogoSize + outlineSize, maxLogoSize + outlineSize, 90);
            ctx.fill();
        }
        ctx.drawImage(img, centerX, centerY, imgWidth, imgHeight);
    }
    const newImg = canvas.toDataURL("image/png");
    return [
        newImg,
        dataUrl
    ];
}





var $bnENU = parcelRequire("bnENU");



parcelRequire("bnENU");

const $d8ee75bdf024b924$var$Dash = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  to {
    stroke-dashoffset: 0;
  }
`;
const $d8ee75bdf024b924$var$AnimatedPath = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).path`
  animation: ${$d8ee75bdf024b924$var$Dash} ${({ animationSpeed: animationSpeed })=>animationSpeed} cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards;
  animation-delay: ${({ animationDelay: animationDelay })=>animationDelay};
`;
function $d8ee75bdf024b924$var$Checkmark({ animationDelay: animationDelay = "0.3s", animationSpeed: animationSpeed = "0.5s", ...props }) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("svg", {
        width: "52",
        height: "52",
        viewBox: "0 0 52 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        strokeWidth: 4,
        stroke: "white",
        ...props,
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($d8ee75bdf024b924$var$AnimatedPath, {
            animationDelay: animationDelay,
            animationSpeed: animationSpeed,
            strokeDashoffset: 100,
            strokeDasharray: 100,
            d: "M14.1 27.2l7.1 7.2 16.7-16.8"
        })
    });
}
var $d8ee75bdf024b924$export$2e2bcd8739ae039 = $d8ee75bdf024b924$var$Checkmark;


const $f56970af37249378$var$CheckboxWrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  background-color: ${({ isChecked: isChecked })=>isChecked ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE : "#FFF"};
  border: 1px solid;
  border-color: ${({ isChecked: isChecked })=>isChecked ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  border-radius: ${({ isRadio: isRadio })=>isRadio ? "100%" : "5px"};
  ${({ size: size })=>`
    min-width: ${size}px;
    max-width: ${size}px;
  `}
  ${({ size: size })=>`
    min-height: ${size}px;
    max-height: ${size}px;
  `}
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease all;
  position: relative;
  
  :focus-within {
    box-shadow: 0 0 5px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE};
  }
  
  &:hover {
    border-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE};
  }

  &:active {
    opacity: 0.5;
  }
`;
const $f56970af37249378$var$CheckboxInput = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).input`
  cursor: pointer;
  appearance: none;
  width: 100%;
  height: 100%;
  outline: none;
`;
class $f56970af37249378$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).Component {
    render() {
        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($f56970af37249378$var$CheckboxWrapper, {
            size: this.props.size ?? 20,
            isRadio: !!this.props.isRadio,
            isChecked: this.props.checked,
            onClick: (e)=>{
                if (!this.props.disabled) this.props.onClick?.(e);
            },
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($f56970af37249378$var$CheckboxInput, {
                    disabled: this.props.disabled,
                    onChange: ()=>{},
                    type: "checkbox",
                    name: "toggle",
                    checked: this.props.checked,
                    isChecked: this.props.checked
                }),
                this.props.checked && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d8ee75bdf024b924$export$2e2bcd8739ae039), {
                    color: "white",
                    animationDelay: "0",
                    style: {
                        width: 20,
                        height: 20,
                        position: "absolute",
                        userSelect: "none"
                    }
                })
            ]
        });
    }
}






var $bnENU = parcelRequire("bnENU");






var $1ZJZa = parcelRequire("1ZJZa");

var $bnENU = parcelRequire("bnENU");

var $bnENU = parcelRequire("bnENU");
const $bcafec560369c8f2$export$af54d3055d90c64e = (0, $bnENU.createContext)({});
function $bcafec560369c8f2$export$985e8768c0e91dbc() {
    return (0, $bnENU.useContext)($bcafec560369c8f2$export$af54d3055d90c64e);
}


const $14e1a0a2b357406b$export$fd685cf7c99624bd = ({ children: children, endpoint: endpoint, config: config = {
    commitment: "confirmed"
} })=>{
    const connection = (0, $bnENU.useMemo)(()=>new (0, $1ZJZa.Connection)(endpoint, config), [
        endpoint,
        config
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $bcafec560369c8f2$export$af54d3055d90c64e).Provider, {
        value: {
            connection: connection
        }
    }, children);
};


var $bnENU = parcelRequire("bnENU");
const $a5bd67d4bd834f44$var$EMPTY_ARRAY = [];
const $a5bd67d4bd834f44$var$DEFAULT_CONTEXT = {
    autoConnect: false,
    connecting: false,
    connected: false,
    disconnecting: false,
    select () {
        $a5bd67d4bd834f44$var$logMissingProviderError("call", "select");
    },
    connect () {
        return Promise.reject($a5bd67d4bd834f44$var$logMissingProviderError("call", "connect"));
    },
    disconnect () {
        return Promise.reject($a5bd67d4bd834f44$var$logMissingProviderError("call", "disconnect"));
    },
    sendTransaction () {
        return Promise.reject($a5bd67d4bd834f44$var$logMissingProviderError("call", "sendTransaction"));
    },
    signTransaction () {
        return Promise.reject($a5bd67d4bd834f44$var$logMissingProviderError("call", "signTransaction"));
    },
    signAllTransactions () {
        return Promise.reject($a5bd67d4bd834f44$var$logMissingProviderError("call", "signAllTransactions"));
    },
    signMessage () {
        return Promise.reject($a5bd67d4bd834f44$var$logMissingProviderError("call", "signMessage"));
    },
    signIn () {
        return Promise.reject($a5bd67d4bd834f44$var$logMissingProviderError("call", "signIn"));
    }
};
Object.defineProperty($a5bd67d4bd834f44$var$DEFAULT_CONTEXT, "wallets", {
    get () {
        $a5bd67d4bd834f44$var$logMissingProviderError("read", "wallets");
        return $a5bd67d4bd834f44$var$EMPTY_ARRAY;
    }
});
Object.defineProperty($a5bd67d4bd834f44$var$DEFAULT_CONTEXT, "wallet", {
    get () {
        $a5bd67d4bd834f44$var$logMissingProviderError("read", "wallet");
        return null;
    }
});
Object.defineProperty($a5bd67d4bd834f44$var$DEFAULT_CONTEXT, "publicKey", {
    get () {
        $a5bd67d4bd834f44$var$logMissingProviderError("read", "publicKey");
        return null;
    }
});
function $a5bd67d4bd834f44$var$logMissingProviderError(action, property) {
    const error = new Error(`You have tried to ${action} "${property}" on a WalletContext without providing one. ` + "Make sure to render a WalletProvider as an ancestor of the component that uses WalletContext.");
    console.error(error);
    return error;
}
const $a5bd67d4bd834f44$export$19648c908dc8d0bf = (0, $bnENU.createContext)($a5bd67d4bd834f44$var$DEFAULT_CONTEXT);
function $a5bd67d4bd834f44$export$c34addee860b0acb() {
    return (0, $bnENU.useContext)($a5bd67d4bd834f44$export$19648c908dc8d0bf);
}

var $00930bab7d2e32f7$exports = {};
"use strict";
var $00930bab7d2e32f7$var$has = Object.prototype.hasOwnProperty, $00930bab7d2e32f7$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $00930bab7d2e32f7$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $00930bab7d2e32f7$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $00930bab7d2e32f7$var$Events().__proto__) $00930bab7d2e32f7$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $00930bab7d2e32f7$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $00930bab7d2e32f7$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $00930bab7d2e32f7$var$EE(fn, context || emitter, once), evt = $00930bab7d2e32f7$var$prefix ? $00930bab7d2e32f7$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $00930bab7d2e32f7$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $00930bab7d2e32f7$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $00930bab7d2e32f7$var$EventEmitter() {
    this._events = new $00930bab7d2e32f7$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $00930bab7d2e32f7$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($00930bab7d2e32f7$var$has.call(events, name)) names.push($00930bab7d2e32f7$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $00930bab7d2e32f7$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $00930bab7d2e32f7$var$prefix ? $00930bab7d2e32f7$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $00930bab7d2e32f7$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $00930bab7d2e32f7$var$prefix ? $00930bab7d2e32f7$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $00930bab7d2e32f7$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $00930bab7d2e32f7$var$prefix ? $00930bab7d2e32f7$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $00930bab7d2e32f7$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $00930bab7d2e32f7$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $00930bab7d2e32f7$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $00930bab7d2e32f7$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $00930bab7d2e32f7$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $00930bab7d2e32f7$var$prefix ? $00930bab7d2e32f7$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $00930bab7d2e32f7$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $00930bab7d2e32f7$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $00930bab7d2e32f7$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $00930bab7d2e32f7$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $00930bab7d2e32f7$var$prefix ? $00930bab7d2e32f7$var$prefix + event : event;
        if (this._events[evt]) $00930bab7d2e32f7$var$clearEvent(this, evt);
    } else {
        this._events = new $00930bab7d2e32f7$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$00930bab7d2e32f7$var$EventEmitter.prototype.off = $00930bab7d2e32f7$var$EventEmitter.prototype.removeListener;
$00930bab7d2e32f7$var$EventEmitter.prototype.addListener = $00930bab7d2e32f7$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$00930bab7d2e32f7$var$EventEmitter.prefixed = $00930bab7d2e32f7$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$00930bab7d2e32f7$var$EventEmitter.EventEmitter = $00930bab7d2e32f7$var$EventEmitter;
$00930bab7d2e32f7$exports = $00930bab7d2e32f7$var$EventEmitter;


class $a800e3a804b49fac$export$f46ec6f9dba8711d extends Error {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(message, error){
        super(message);
        this.error = error;
    }
}
class $a800e3a804b49fac$export$d65db264eda99cd7 extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletNotReadyError";
    }
}
class $a800e3a804b49fac$export$9a551f94af9b0bf8 extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletLoadError";
    }
}
class $a800e3a804b49fac$export$9525019988612a5e extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletConfigError";
    }
}
class $a800e3a804b49fac$export$38f21f1c810261c7 extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletConnectionError";
    }
}
class $a800e3a804b49fac$export$bf7028c52ebda81e extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletDisconnectedError";
    }
}
class $a800e3a804b49fac$export$92e2b26fad5723ee extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletDisconnectionError";
    }
}
class $a800e3a804b49fac$export$cd6fa2f8e2a8a612 extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletAccountError";
    }
}
class $a800e3a804b49fac$export$735bef3bfb0f2c86 extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletPublicKeyError";
    }
}
class $a800e3a804b49fac$export$c2957028686b1575 extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletKeypairError";
    }
}
class $a800e3a804b49fac$export$313d299817c74896 extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletNotConnectedError";
    }
}
class $a800e3a804b49fac$export$769332ac3f90f46c extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSendTransactionError";
    }
}
class $a800e3a804b49fac$export$96f177062fdd8180 extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignTransactionError";
    }
}
class $a800e3a804b49fac$export$2622c1721bbd4b17 extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignMessageError";
    }
}
class $a800e3a804b49fac$export$a4c7d3c66e3cdd6c extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignInError";
    }
}
class $a800e3a804b49fac$export$ec3efbdc71ef5c8c extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletTimeoutError";
    }
}
class $a800e3a804b49fac$export$c87b9320dc154c95 extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletWindowBlockedError";
    }
}
class $a800e3a804b49fac$export$d02b2d00a97edcea extends $a800e3a804b49fac$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletWindowClosedError";
    }
}


var $e820e806547f33d2$export$2a7b8071105d05b6;
(function(WalletReadyState) {
    /**
     * User-installable wallets can typically be detected by scanning for an API
     * that they've injected into the global context. If such an API is present,
     * we consider the wallet to have been installed.
     */ WalletReadyState["Installed"] = "Installed";
    WalletReadyState["NotDetected"] = "NotDetected";
    /**
     * Loadable wallets are always available to you. Since you can load them at
     * any time, it's meaningless to say that they have been detected.
     */ WalletReadyState["Loadable"] = "Loadable";
    /**
     * If a wallet is not supported on a given platform (eg. server-rendering, or
     * mobile) then it will stay in the `Unsupported` state.
     */ WalletReadyState["Unsupported"] = "Unsupported";
})($e820e806547f33d2$export$2a7b8071105d05b6 || ($e820e806547f33d2$export$2a7b8071105d05b6 = {}));
class $e820e806547f33d2$export$2af1ea2892adc469 extends (0, (/*@__PURE__*/$parcel$interopDefault($00930bab7d2e32f7$exports))) {
    get connected() {
        return !!this.publicKey;
    }
    async autoConnect() {
        await this.connect();
    }
    async prepareTransaction(transaction, connection, options = {}) {
        const publicKey = this.publicKey;
        if (!publicKey) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
        transaction.feePayer = transaction.feePayer || publicKey;
        transaction.recentBlockhash = transaction.recentBlockhash || (await connection.getLatestBlockhash({
            commitment: options.preflightCommitment,
            minContextSlot: options.minContextSlot
        })).blockhash;
        return transaction;
    }
}
function $e820e806547f33d2$export$378bae4c88e0b46e(detect) {
    // Early return when server-side rendering
    if (typeof window === "undefined" || typeof document === "undefined") return;
    const disposers = [];
    function detectAndDispose() {
        const detected = detect();
        if (detected) for (const dispose of disposers)dispose();
    }
    // Strategy #1: Try detecting every second.
    const interval = // TODO: #334 Replace with idle callback strategy.
    setInterval(detectAndDispose, 1000);
    disposers.push(()=>clearInterval(interval));
    // Strategy #2: Detect as soon as the DOM becomes 'ready'/'interactive'.
    if (// Implies that `DOMContentLoaded` has not yet fired.
    document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", detectAndDispose, {
            once: true
        });
        disposers.push(()=>document.removeEventListener("DOMContentLoaded", detectAndDispose));
    }
    // Strategy #3: Detect after the `window` has fully loaded.
    if (// If the `complete` state has been reached, we're too late.
    document.readyState !== "complete") {
        window.addEventListener("load", detectAndDispose, {
            once: true
        });
        disposers.push(()=>window.removeEventListener("load", detectAndDispose));
    }
    // Strategy #4: Detect synchronously, now.
    detectAndDispose();
}
function $e820e806547f33d2$export$bf89b558d1e273a2() {
    // SSR: return false
    if (!navigator) return false;
    const userAgent = navigator.userAgent.toLowerCase();
    // if on iOS the user agent will contain either iPhone or iPad
    // caveat: if requesting desktop site then this won't work
    const isIos = userAgent.includes("iphone") || userAgent.includes("ipad");
    // if in a webview then it will not include Safari
    // note that other iOS browsers also include Safari
    // so we will redirect only if Safari is also included
    const isSafari = userAgent.includes("safari");
    return isIos && isSafari;
}



function $5f36b6a60c860fd2$export$37ce1cc82e255d8(transaction) {
    return "version" in transaction;
}


class $e93033ae3d6cecb2$export$9a51bf5d1bea9e98 extends (0, $e820e806547f33d2$export$2af1ea2892adc469) {
    async sendTransaction(transaction, connection, options = {}) {
        let emit = true;
        try {
            if ((0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(transaction)) {
                if (!this.supportedTransactionVersions) throw new (0, $a800e3a804b49fac$export$769332ac3f90f46c)(`Sending versioned transactions isn't supported by this wallet`);
                if (!this.supportedTransactionVersions.has(transaction.version)) throw new (0, $a800e3a804b49fac$export$769332ac3f90f46c)(`Sending transaction version ${transaction.version} isn't supported by this wallet`);
                try {
                    transaction = await this.signTransaction(transaction);
                    const rawTransaction = transaction.serialize();
                    return await connection.sendRawTransaction(rawTransaction, options);
                } catch (error) {
                    // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                    if (error instanceof (0, $a800e3a804b49fac$export$96f177062fdd8180)) {
                        emit = false;
                        throw error;
                    }
                    throw new (0, $a800e3a804b49fac$export$769332ac3f90f46c)(error?.message, error);
                }
            } else try {
                const { signers: signers, ...sendOptions } = options;
                transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                signers?.length && transaction.partialSign(...signers);
                transaction = await this.signTransaction(transaction);
                const rawTransaction = transaction.serialize();
                return await connection.sendRawTransaction(rawTransaction, sendOptions);
            } catch (error) {
                // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                if (error instanceof (0, $a800e3a804b49fac$export$96f177062fdd8180)) {
                    emit = false;
                    throw error;
                }
                throw new (0, $a800e3a804b49fac$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            if (emit) this.emit("error", error);
            throw error;
        }
    }
    async signAllTransactions(transactions) {
        for (const transaction of transactions)if ((0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(transaction)) {
            if (!this.supportedTransactionVersions) throw new (0, $a800e3a804b49fac$export$96f177062fdd8180)(`Signing versioned transactions isn't supported by this wallet`);
            if (!this.supportedTransactionVersions.has(transaction.version)) throw new (0, $a800e3a804b49fac$export$96f177062fdd8180)(`Signing transaction version ${transaction.version} isn't supported by this wallet`);
        }
        const signedTransactions = [];
        for (const transaction of transactions)signedTransactions.push(await this.signTransaction(transaction));
        return signedTransactions;
    }
}
class $e93033ae3d6cecb2$export$9db08bcddd106c96 extends $e93033ae3d6cecb2$export$9a51bf5d1bea9e98 {
}
class $e93033ae3d6cecb2$export$9779f871ffdb3d87 extends $e93033ae3d6cecb2$export$9db08bcddd106c96 {
}



var $1ZJZa = parcelRequire("1ZJZa");

var $1ZJZa = parcelRequire("1ZJZa");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ /**
 * SHA2-512 a.k.a. sha512 and sha384. It is slower than sha256 in js because u64 operations are slow.
 *
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [the paper on truncated SHA512/256](https://eprint.iacr.org/2010/548.pdf).
 * @module
 */ /**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ /**
 * Internal assertion helpers.
 * @module
 */ /** Asserts something is positive integer. */ function $450f45142b167b7d$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error("positive integer expected, got " + n);
}
/** Is number an Uint8Array? Copied from utils for perf. */ function $450f45142b167b7d$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
/** Asserts something is Uint8Array. */ function $450f45142b167b7d$export$e8a750b9efad93f5(b, ...lengths) {
    if (!$450f45142b167b7d$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error("Uint8Array expected of length " + lengths + ", got length=" + b.length);
}
/** Asserts something is hash */ function $450f45142b167b7d$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $450f45142b167b7d$export$75364c6cb16d43b6(h.outputLen);
    $450f45142b167b7d$export$75364c6cb16d43b6(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function $450f45142b167b7d$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
/** Asserts output is properly-sized byte array */ function $450f45142b167b7d$export$e8e53abee12b995e(out, instance) {
    $450f45142b167b7d$export$e8a750b9efad93f5(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error("digestInto() expects output buffer of length at least " + min);
}


/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const $2551ccbe11946238$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;



function $a6815365d7c5325d$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $a6815365d7c5325d$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $a6815365d7c5325d$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $a6815365d7c5325d$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $a6815365d7c5325d$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $a6815365d7c5325d$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $a6815365d7c5325d$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $a6815365d7c5325d$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $a6815365d7c5325d$export$4a0a88cc2d284e7f = $a6815365d7c5325d$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$a6815365d7c5325d$export$a4170f7f8be47425(n);
function $a6815365d7c5325d$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $a6815365d7c5325d$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $a6815365d7c5325d$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $a6815365d7c5325d$export$58b867e287a802c8(bytes) {
    (0, $450f45142b167b7d$export$e8a750b9efad93f5)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a6815365d7c5325d$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $a6815365d7c5325d$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $a6815365d7c5325d$var$asciiToBase16(ch) {
    if (ch >= $a6815365d7c5325d$var$asciis._0 && ch <= $a6815365d7c5325d$var$asciis._9) return ch - $a6815365d7c5325d$var$asciis._0; // '2' => 50-48
    if (ch >= $a6815365d7c5325d$var$asciis.A && ch <= $a6815365d7c5325d$var$asciis.F) return ch - ($a6815365d7c5325d$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $a6815365d7c5325d$var$asciis.a && ch <= $a6815365d7c5325d$var$asciis.f) return ch - ($a6815365d7c5325d$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $a6815365d7c5325d$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $a6815365d7c5325d$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $a6815365d7c5325d$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $a6815365d7c5325d$export$bdd553fddd433dcb = async ()=>{};
async function $a6815365d7c5325d$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $a6815365d7c5325d$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $a6815365d7c5325d$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error("utf8ToBytes expected string, got " + typeof str);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $a6815365d7c5325d$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $a6815365d7c5325d$export$3df70a15530b5e81(data);
    (0, $450f45142b167b7d$export$e8a750b9efad93f5)(data);
    return data;
}
function $a6815365d7c5325d$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $450f45142b167b7d$export$e8a750b9efad93f5)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $a6815365d7c5325d$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
function $a6815365d7c5325d$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $a6815365d7c5325d$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($a6815365d7c5325d$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $a6815365d7c5325d$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a6815365d7c5325d$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $a6815365d7c5325d$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a6815365d7c5325d$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $a6815365d7c5325d$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $2551ccbe11946238$export$7effb53edfc7fa2d) && typeof (0, $2551ccbe11946238$export$7effb53edfc7fa2d).getRandomValues === "function") return (0, $2551ccbe11946238$export$7effb53edfc7fa2d).getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ((0, $2551ccbe11946238$export$7effb53edfc7fa2d) && typeof (0, $2551ccbe11946238$export$7effb53edfc7fa2d).randomBytes === "function") return (0, $2551ccbe11946238$export$7effb53edfc7fa2d).randomBytes(bytesLength);
    throw new Error("crypto.getRandomValues must be defined");
}


function $72a5f60cc5c82db8$export$b13f930c762582ab(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
function $72a5f60cc5c82db8$export$d0d97f016526eaf0(a, b, c) {
    return a & b ^ ~a & c;
}
function $72a5f60cc5c82db8$export$8b1d810b1bd30adf(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $72a5f60cc5c82db8$export$f9f830659f932cb2 extends (0, $a6815365d7c5325d$export$ab85ecd77ce6a5cd) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $a6815365d7c5325d$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $450f45142b167b7d$export$20871f6b1d047d77)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $a6815365d7c5325d$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $a6815365d7c5325d$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $450f45142b167b7d$export$20871f6b1d047d77)(this);
        (0, $450f45142b167b7d$export$e8e53abee12b995e)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $72a5f60cc5c82db8$export$b13f930c762582ab(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $a6815365d7c5325d$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}


/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $b17c8eac7fafbd55$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $b17c8eac7fafbd55$var$_32n = /* @__PURE__ */ BigInt(32);
function $b17c8eac7fafbd55$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $b17c8eac7fafbd55$var$U32_MASK64),
        l: Number(n >> $b17c8eac7fafbd55$var$_32n & $b17c8eac7fafbd55$var$U32_MASK64)
    };
    return {
        h: Number(n >> $b17c8eac7fafbd55$var$_32n & $b17c8eac7fafbd55$var$U32_MASK64) | 0,
        l: Number(n & $b17c8eac7fafbd55$var$U32_MASK64) | 0
    };
}
function $b17c8eac7fafbd55$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $b17c8eac7fafbd55$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $b17c8eac7fafbd55$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $b17c8eac7fafbd55$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $b17c8eac7fafbd55$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $b17c8eac7fafbd55$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $b17c8eac7fafbd55$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $b17c8eac7fafbd55$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $b17c8eac7fafbd55$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $b17c8eac7fafbd55$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $b17c8eac7fafbd55$export$a088d44bd387d2a3 = (_h, l)=>l;
const $b17c8eac7fafbd55$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $b17c8eac7fafbd55$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $b17c8eac7fafbd55$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $b17c8eac7fafbd55$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $b17c8eac7fafbd55$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $b17c8eac7fafbd55$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $b17c8eac7fafbd55$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $b17c8eac7fafbd55$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $b17c8eac7fafbd55$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $b17c8eac7fafbd55$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $b17c8eac7fafbd55$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $b17c8eac7fafbd55$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $b17c8eac7fafbd55$var$u64 = {
    fromBig: $b17c8eac7fafbd55$export$9625d4333cb56c3f,
    split: $b17c8eac7fafbd55$export$65980d18b75784e2,
    toBig: $b17c8eac7fafbd55$export$30f78adcaaa2eb7,
    shrSH: $b17c8eac7fafbd55$export$75aa78dc5bd52853,
    shrSL: $b17c8eac7fafbd55$export$a0225ff0aee14e25,
    rotrSH: $b17c8eac7fafbd55$export$97f812dfd830ca87,
    rotrSL: $b17c8eac7fafbd55$export$60987e30e2c9d9d,
    rotrBH: $b17c8eac7fafbd55$export$af9c7fbac44dcb76,
    rotrBL: $b17c8eac7fafbd55$export$f619171d6d5ac414,
    rotr32H: $b17c8eac7fafbd55$export$a088d44bd387d2a3,
    rotr32L: $b17c8eac7fafbd55$export$8415aae4d1f69577,
    rotlSH: $b17c8eac7fafbd55$export$4b80a2917447870e,
    rotlSL: $b17c8eac7fafbd55$export$20652918a7b63b3,
    rotlBH: $b17c8eac7fafbd55$export$a52f14bf902f9977,
    rotlBL: $b17c8eac7fafbd55$export$5d12cc1da441323f,
    add: $b17c8eac7fafbd55$export$e16d8520af44a096,
    add3L: $b17c8eac7fafbd55$export$c0c22b91f08911f,
    add3H: $b17c8eac7fafbd55$export$ef7b26044977a8ec,
    add4L: $b17c8eac7fafbd55$export$2f4e199c560f545d,
    add4H: $b17c8eac7fafbd55$export$e909220d675a7741,
    add5H: $b17c8eac7fafbd55$export$b45ee8d78c965098,
    add5L: $b17c8eac7fafbd55$export$d732b061fe9c9ae4
};
var $b17c8eac7fafbd55$export$2e2bcd8739ae039 = $b17c8eac7fafbd55$var$u64;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$b48f7bf91e010339$var$SHA512_Kh, $b48f7bf91e010339$var$SHA512_Kl] = /* @__PURE__ */ (()=>(0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $b48f7bf91e010339$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $b48f7bf91e010339$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $b48f7bf91e010339$export$d655fdb8a1cad5df extends (0, $72a5f60cc5c82db8$export$f9f830659f932cb2) {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $b48f7bf91e010339$var$SHA512_W_H[i] = view.getUint32(offset);
            $b48f7bf91e010339$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $b48f7bf91e010339$var$SHA512_W_H[i - 15] | 0;
            const W15l = $b48f7bf91e010339$var$SHA512_W_L[i - 15] | 0;
            const s0h = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSH(W15h, W15l, 1) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSH(W15h, W15l, 8) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).shrSH(W15h, W15l, 7);
            const s0l = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSL(W15h, W15l, 1) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSL(W15h, W15l, 8) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $b48f7bf91e010339$var$SHA512_W_H[i - 2] | 0;
            const W2l = $b48f7bf91e010339$var$SHA512_W_L[i - 2] | 0;
            const s1h = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSH(W2h, W2l, 19) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrBH(W2h, W2l, 61) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).shrSH(W2h, W2l, 6);
            const s1l = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSL(W2h, W2l, 19) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrBL(W2h, W2l, 61) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add4L(s0l, s1l, $b48f7bf91e010339$var$SHA512_W_L[i - 7], $b48f7bf91e010339$var$SHA512_W_L[i - 16]);
            const SUMh = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add4H(SUMl, s0h, s1h, $b48f7bf91e010339$var$SHA512_W_H[i - 7], $b48f7bf91e010339$var$SHA512_W_H[i - 16]);
            $b48f7bf91e010339$var$SHA512_W_H[i] = SUMh | 0;
            $b48f7bf91e010339$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSH(Eh, El, 14) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSH(Eh, El, 18) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrBH(Eh, El, 41);
            const sigma1l = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSL(Eh, El, 14) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSL(Eh, El, 18) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add5L(Hl, sigma1l, CHIl, $b48f7bf91e010339$var$SHA512_Kl[i], $b48f7bf91e010339$var$SHA512_W_L[i]);
            const T1h = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add5H(T1ll, Hh, sigma1h, CHIh, $b48f7bf91e010339$var$SHA512_Kh[i], $b48f7bf91e010339$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSH(Ah, Al, 28) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrBH(Ah, Al, 34) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrBH(Ah, Al, 39);
            const sigma0l = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrSL(Ah, Al, 28) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrBL(Ah, Al, 34) ^ (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add3L(T1l, sigma0l, MAJl);
            Ah = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = (0, $b17c8eac7fafbd55$export$2e2bcd8739ae039).add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $b48f7bf91e010339$var$SHA512_W_H.fill(0);
        $b48f7bf91e010339$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $b48f7bf91e010339$export$9269e18873efb8a1 extends $b48f7bf91e010339$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $b48f7bf91e010339$export$70b84015054354f1 extends $b48f7bf91e010339$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $b48f7bf91e010339$export$b4bd5cd48f62bcf0 extends $b48f7bf91e010339$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
const $b48f7bf91e010339$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $a6815365d7c5325d$export$f081816339df1972)(()=>new $b48f7bf91e010339$export$d655fdb8a1cad5df());
const $b48f7bf91e010339$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $a6815365d7c5325d$export$f081816339df1972)(()=>new $b48f7bf91e010339$export$9269e18873efb8a1());
const $b48f7bf91e010339$export$c78786b6da86db2a = /* @__PURE__ */ (0, $a6815365d7c5325d$export$f081816339df1972)(()=>new $b48f7bf91e010339$export$70b84015054354f1());
const $b48f7bf91e010339$export$612d47d55dedde45 = /* @__PURE__ */ (0, $a6815365d7c5325d$export$f081816339df1972)(()=>new $b48f7bf91e010339$export$b4bd5cd48f62bcf0());




var $Q6eBv = parcelRequire("Q6eBv");
/**
 * Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y².
 * For design rationale of types / exports, see weierstrass module documentation.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $Q6eBv = parcelRequire("Q6eBv");

var $i2UKs = parcelRequire("i2UKs");

var $O98NX = parcelRequire("O98NX");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $9e2cb22b01d28452$var$_0n = BigInt(0), $9e2cb22b01d28452$var$_1n = BigInt(1), $9e2cb22b01d28452$var$_2n = BigInt(2), $9e2cb22b01d28452$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $9e2cb22b01d28452$var$VERIFY_DEFAULT = {
    zip215: true
};
function $9e2cb22b01d28452$var$validateOpts(curve) {
    const opts = (0, $Q6eBv.validateBasic)(curve);
    $O98NX.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
function $9e2cb22b01d28452$export$f0c1eee63ea541eb(curveDef) {
    const CURVE = $9e2cb22b01d28452$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    // Important:
    // There are some places where Fp.BYTES is used instead of nByteLength.
    // So far, everything has been tested with curves of Fp.BYTES == nByteLength.
    // TODO: test and find curves which behave otherwise.
    const MASK = $9e2cb22b01d28452$var$_2n << BigInt(nByteLength * 8) - $9e2cb22b01d28452$var$_1n;
    const modP = Fp.create; // Function overrides
    const Fn = (0, $i2UKs.Field)(CURVE.n, CURVE.nBitLength);
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $9e2cb22b01d28452$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        (0, $O98NX.abool)("phflag", phflag);
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    // 0 <= n < MASK
    // Coordinates larger than Fp.ORDER are allowed for zip215
    function aCoordinate(title, n) {
        $O98NX.aInRange("coordinate " + title, n, $9e2cb22b01d28452$var$_0n, MASK);
    }
    function assertPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    const toAffineMemo = (0, $O98NX.memoized)((p, iz)=>{
        const { ex: x, ey: y, ez: z } = p;
        const is0 = p.is0();
        if (iz == null) iz = is0 ? $9e2cb22b01d28452$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
        const ax = modP(x * iz);
        const ay = modP(y * iz);
        const zz = modP(z * iz);
        if (is0) return {
            x: $9e2cb22b01d28452$var$_0n,
            y: $9e2cb22b01d28452$var$_1n
        };
        if (zz !== $9e2cb22b01d28452$var$_1n) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    const assertValidMemo = (0, $O98NX.memoized)((p)=>{
        const { a: a, d: d } = CURVE;
        if (p.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
        // Equation in affine coordinates: ax² + y² = 1 + dx²y²
        // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
        const { ex: X, ey: Y, ez: Z, et: T } = p;
        const X2 = modP(X * X); // X²
        const Y2 = modP(Y * Y); // Y²
        const Z2 = modP(Z * Z); // Z²
        const Z4 = modP(Z2 * Z2); // Z⁴
        const aX2 = modP(X2 * a); // aX²
        const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
        const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
        if (left !== right) throw new Error("bad point: equation left != right (1)");
        // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
        const XY = modP(X * Y);
        const ZT = modP(Z * T);
        if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        return true;
    });
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            aCoordinate("x", ex);
            aCoordinate("y", ey);
            aCoordinate("z", ez);
            aCoordinate("t", et);
            Object.freeze(this);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            aCoordinate("x", x);
            aCoordinate("y", y);
            return new Point(x, y, $9e2cb22b01d28452$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return (0, $Q6eBv.pippenger)(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            assertValidMemo(this);
        }
        // Compare one point to another.
        equals(other) {
            assertPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($9e2cb22b01d28452$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            assertPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $9e2cb22b01d28452$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $9e2cb22b01d28452$var$_2n * T2);
                const D = modP(T1 * $9e2cb22b01d28452$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const n = scalar;
            $O98NX.aInRange("scalar", n, $9e2cb22b01d28452$var$_1n, CURVE_ORDER); // 1 <= scalar < L
            const { p: p, f: f } = this.wNAF(n);
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        // Accepts optional accumulator to merge with multiply (important for sparse scalars)
        multiplyUnsafe(scalar, acc = Point.ZERO) {
            const n = scalar;
            $O98NX.aInRange("scalar", n, $9e2cb22b01d28452$var$_0n, CURVE_ORDER); // 0 <= scalar < L
            if (n === $9e2cb22b01d28452$var$_0n) return I;
            if (this.is0() || n === $9e2cb22b01d28452$var$_1n) return this;
            return wnaf.wNAFCachedUnsafe(this, n, Point.normalizeZ, acc);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $9e2cb22b01d28452$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $O98NX.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            (0, $O98NX.abool)("zip215", zip215);
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $O98NX.bytesToNumberLE(normed);
            // zip215=true is good for consensus-critical apps. =false follows RFC8032 / NIST186-5.
            // RFC8032 prohibits >= p, but ZIP215 doesn't
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            const max = zip215 ? MASK : Fp.ORDER;
            $O98NX.aInRange("pointHex.y", y, $9e2cb22b01d28452$var$_0n, max);
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $9e2cb22b01d28452$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $9e2cb22b01d28452$var$_1n) === $9e2cb22b01d28452$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $9e2cb22b01d28452$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $O98NX.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $9e2cb22b01d28452$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $O98NX.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $9e2cb22b01d28452$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($9e2cb22b01d28452$var$_0n, $9e2cb22b01d28452$var$_1n, $9e2cb22b01d28452$var$_1n, $9e2cb22b01d28452$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $Q6eBv.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $i2UKs.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($O98NX.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = Fp.BYTES;
        key = (0, $O98NX.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $O98NX.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $O98NX.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $O98NX.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $O98NX.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        $O98NX.aInRange("signature.s", s, $9e2cb22b01d28452$var$_0n, CURVE_ORDER); // 0 <= s < l
        const res = $O98NX.concatBytes(R, $O98NX.numberToBytesLE(s, Fp.BYTES));
        return (0, $O98NX.ensureBytes)("result", res, Fp.BYTES * 2); // 64-byte signature
    }
    const verifyOpts = $9e2cb22b01d28452$var$VERIFY_DEFAULT;
    /**
     * Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
     * An extended group equation is checked.
     */ function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $O98NX.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $O98NX.ensureBytes)("message", msg);
        publicKey = (0, $O98NX.ensureBytes)("publicKey", publicKey, len);
        if (zip215 !== undefined) (0, $O98NX.abool)("zip215", zip215);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $O98NX.bytesToNumberLE(sig.slice(len, 2 * len));
        let A, R, SB;
        try {
            // zip215=true is good for consensus-critical apps. =false follows RFC8032 / NIST186-5.
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // Extended group equation
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}



var $i2UKs = parcelRequire("i2UKs");

var $O98NX = parcelRequire("O98NX");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $180d50efb7760cfe$var$os2ip = (0, $O98NX.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $180d50efb7760cfe$var$i2osp(value, length) {
    $180d50efb7760cfe$var$anum(value);
    $180d50efb7760cfe$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error("invalid I2OSP input: " + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $180d50efb7760cfe$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $180d50efb7760cfe$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $180d50efb7760cfe$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $O98NX.abytes)(msg);
    (0, $O98NX.abytes)(DST);
    $180d50efb7760cfe$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $O98NX.concatBytes)((0, $O98NX.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error("expand_message_xmd: invalid lenInBytes");
    const DST_prime = (0, $O98NX.concatBytes)(DST, $180d50efb7760cfe$var$i2osp(DST.length, 1));
    const Z_pad = $180d50efb7760cfe$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $180d50efb7760cfe$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $O98NX.concatBytes)(Z_pad, msg, l_i_b_str, $180d50efb7760cfe$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $O98NX.concatBytes)(b_0, $180d50efb7760cfe$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $180d50efb7760cfe$var$strxor(b_0, b[i - 1]),
            $180d50efb7760cfe$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $O98NX.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $O98NX.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $180d50efb7760cfe$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $O98NX.abytes)(msg);
    (0, $O98NX.abytes)(DST);
    $180d50efb7760cfe$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $O98NX.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($180d50efb7760cfe$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($180d50efb7760cfe$var$i2osp(DST.length, 1)).digest();
}
function $180d50efb7760cfe$export$97cdd5ee18de8172(msg, count, options) {
    (0, $O98NX.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    (0, $O98NX.abytes)(msg);
    $180d50efb7760cfe$var$anum(count);
    const DST = typeof _DST === "string" ? (0, $O98NX.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $180d50efb7760cfe$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $180d50efb7760cfe$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $i2UKs.mod)($180d50efb7760cfe$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $180d50efb7760cfe$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $180d50efb7760cfe$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $180d50efb7760cfe$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $180d50efb7760cfe$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error("mapToCurve: expected array of bigints");
            for (const i of scalars)if (typeof i !== "bigint") throw new Error("mapToCurve: expected array of bigints");
            const P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}



var $i2UKs = parcelRequire("i2UKs");
/**
 * Montgomery curve methods. It's not really whole montgomery curve,
 * just bunch of very specific methods for X25519 / X448 from
 * [RFC 7748](https://www.rfc-editor.org/rfc/rfc7748)
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $i2UKs = parcelRequire("i2UKs");

var $O98NX = parcelRequire("O98NX");
const $2045a0ae0474ed65$var$_0n = BigInt(0);
const $2045a0ae0474ed65$var$_1n = BigInt(1);
function $2045a0ae0474ed65$var$validateOpts(curve) {
    (0, $O98NX.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
function $2045a0ae0474ed65$export$bdbee0d01bf914a7(curveDef) {
    const CURVE = $2045a0ae0474ed65$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $i2UKs.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $i2UKs.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(u, scalar) {
        (0, $O98NX.aInRange)("u", u, $2045a0ae0474ed65$var$_0n, P);
        (0, $O98NX.aInRange)("scalar", scalar, $2045a0ae0474ed65$var$_0n, P);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = scalar;
        const x_1 = u;
        let x_2 = $2045a0ae0474ed65$var$_1n;
        let z_2 = $2045a0ae0474ed65$var$_0n;
        let x_3 = u;
        let z_3 = $2045a0ae0474ed65$var$_1n;
        let swap = $2045a0ae0474ed65$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $2045a0ae0474ed65$var$_0n; t--){
            const k_t = k >> t & $2045a0ae0474ed65$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $O98NX.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        const u = (0, $O98NX.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        if (fieldLen === 32) u[31] &= 127; // 0b0111_1111
        return (0, $O98NX.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $O98NX.ensureBytes)("scalar", n);
        const len = bytes.length;
        if (len !== montgomeryBytes && len !== fieldLen) {
            let valid = "" + montgomeryBytes + " or " + fieldLen;
            throw new Error("invalid scalar, expected " + valid + " bytes, got " + len);
        }
        return (0, $O98NX.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $2045a0ae0474ed65$var$_0n) throw new Error("invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}



var $O98NX = parcelRequire("O98NX");
const $3ffd9d4258c4e38c$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
const $3ffd9d4258c4e38c$var$ED25519_SQRT_M1 = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $3ffd9d4258c4e38c$var$_0n = BigInt(0), $3ffd9d4258c4e38c$var$_1n = BigInt(1), $3ffd9d4258c4e38c$var$_2n = BigInt(2), $3ffd9d4258c4e38c$var$_3n = BigInt(3);
// prettier-ignore
const $3ffd9d4258c4e38c$var$_5n = BigInt(5), $3ffd9d4258c4e38c$var$_8n = BigInt(8);
function $3ffd9d4258c4e38c$var$ed25519_pow_2_252_3(x) {
    // prettier-ignore
    const _10n = BigInt(10), _20n = BigInt(20), _40n = BigInt(40), _80n = BigInt(80);
    const P = $3ffd9d4258c4e38c$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $i2UKs.pow2)(b2, $3ffd9d4258c4e38c$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $i2UKs.pow2)(b4, $3ffd9d4258c4e38c$var$_1n, P) * x % P; // x^31
    const b10 = (0, $i2UKs.pow2)(b5, $3ffd9d4258c4e38c$var$_5n, P) * b5 % P;
    const b20 = (0, $i2UKs.pow2)(b10, _10n, P) * b10 % P;
    const b40 = (0, $i2UKs.pow2)(b20, _20n, P) * b20 % P;
    const b80 = (0, $i2UKs.pow2)(b40, _40n, P) * b40 % P;
    const b160 = (0, $i2UKs.pow2)(b80, _80n, P) * b80 % P;
    const b240 = (0, $i2UKs.pow2)(b160, _80n, P) * b80 % P;
    const b250 = (0, $i2UKs.pow2)(b240, _10n, P) * b10 % P;
    const pow_p_5_8 = (0, $i2UKs.pow2)(b250, $3ffd9d4258c4e38c$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $3ffd9d4258c4e38c$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $3ffd9d4258c4e38c$var$uvRatio(u, v) {
    const P = $3ffd9d4258c4e38c$var$ED25519_P;
    const v3 = (0, $i2UKs.mod)(v * v * v, P); // v³
    const v7 = (0, $i2UKs.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $3ffd9d4258c4e38c$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $i2UKs.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $i2UKs.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $i2UKs.mod)(x * $3ffd9d4258c4e38c$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $i2UKs.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $i2UKs.mod)(-u * $3ffd9d4258c4e38c$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $i2UKs.isNegativeLE)(x, P)) x = (0, $i2UKs.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
const $3ffd9d4258c4e38c$export$5ce3305f0d0b8e6f = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $3ffd9d4258c4e38c$var$Fp = /* @__PURE__ */ (()=>(0, $i2UKs.Field)($3ffd9d4258c4e38c$var$ED25519_P, undefined, true))();
const $3ffd9d4258c4e38c$var$ed25519Defaults = /* @__PURE__ */ (()=>({
        // Param: a
        a: BigInt(-1),
        // d is equal to -121665/121666 over finite field.
        // Negative number is P - number, and division is invert(number, P)
        d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
        Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
        $3ffd9d4258c4e38c$var$Fp,
        // Subgroup order: how many points curve has
        // 2n**252n + 27742317777372353535851937790883648493n;
        n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
        // Cofactor
        h: $3ffd9d4258c4e38c$var$_8n,
        // Base point (x, y) aka generator point
        Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
        Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
        hash: (0, $b48f7bf91e010339$export$a888d2532e6dc7bb),
        randomBytes: $a6815365d7c5325d$export$5f828d93ff035aa8,
        adjustScalarBytes: $3ffd9d4258c4e38c$var$adjustScalarBytes,
        uvRatio: // dom2
        // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
        // Constant-time, u/√v
        $3ffd9d4258c4e38c$var$uvRatio
    }))();
const $3ffd9d4258c4e38c$export$f63794f4a09a19c1 = /* @__PURE__ */ (()=>(0, $9e2cb22b01d28452$export$f0c1eee63ea541eb)($3ffd9d4258c4e38c$var$ed25519Defaults))();
function $3ffd9d4258c4e38c$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $a6815365d7c5325d$export$287dd7971339c972)((0, $a6815365d7c5325d$export$3df70a15530b5e81)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
const $3ffd9d4258c4e38c$export$1bc11da7986b0196 = /* @__PURE__ */ (()=>(0, $9e2cb22b01d28452$export$f0c1eee63ea541eb)({
        ...$3ffd9d4258c4e38c$var$ed25519Defaults,
        domain: $3ffd9d4258c4e38c$var$ed25519_domain
    }))();
const $3ffd9d4258c4e38c$export$473acbb6f701cbb6 = /* @__PURE__ */ (()=>(0, $9e2cb22b01d28452$export$f0c1eee63ea541eb)(Object.assign({}, $3ffd9d4258c4e38c$var$ed25519Defaults, {
        domain: $3ffd9d4258c4e38c$var$ed25519_domain,
        prehash: (0, $b48f7bf91e010339$export$a888d2532e6dc7bb)
    })))();
const $3ffd9d4258c4e38c$export$dab9625394da700 = /* @__PURE__ */ (()=>(0, $2045a0ae0474ed65$export$bdbee0d01bf914a7)({
        P: $3ffd9d4258c4e38c$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $3ffd9d4258c4e38c$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $3ffd9d4258c4e38c$var$ed25519_pow_2_252_3(x);
            return (0, $i2UKs.mod)((0, $i2UKs.pow2)(pow_p_5_8, $3ffd9d4258c4e38c$var$_3n, P) * b2, P);
        },
        adjustScalarBytes: $3ffd9d4258c4e38c$var$adjustScalarBytes,
        randomBytes: $a6815365d7c5325d$export$5f828d93ff035aa8
    }))();
function $3ffd9d4258c4e38c$export$78609ae56f1edf04(edwardsPub) {
    const { y: y } = $3ffd9d4258c4e38c$export$f63794f4a09a19c1.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $3ffd9d4258c4e38c$var$Fp.toBytes($3ffd9d4258c4e38c$var$Fp.create((_1n + y) * $3ffd9d4258c4e38c$var$Fp.inv(_1n - y)));
}
const $3ffd9d4258c4e38c$export$84bc39a6e4664b07 = $3ffd9d4258c4e38c$export$78609ae56f1edf04; // deprecated
function $3ffd9d4258c4e38c$export$c32b0f86cebbdf19(edwardsPriv) {
    const hashed = $3ffd9d4258c4e38c$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $3ffd9d4258c4e38c$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $3ffd9d4258c4e38c$var$ELL2_C1 = /* @__PURE__ */ (()=>($3ffd9d4258c4e38c$var$Fp.ORDER + $3ffd9d4258c4e38c$var$_3n) / $3ffd9d4258c4e38c$var$_8n)(); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $3ffd9d4258c4e38c$var$ELL2_C2 = /* @__PURE__ */ (()=>$3ffd9d4258c4e38c$var$Fp.pow($3ffd9d4258c4e38c$var$_2n, $3ffd9d4258c4e38c$var$ELL2_C1))(); // 2. c2 = 2^c1
const $3ffd9d4258c4e38c$var$ELL2_C3 = /* @__PURE__ */ (()=>$3ffd9d4258c4e38c$var$Fp.sqrt($3ffd9d4258c4e38c$var$Fp.neg($3ffd9d4258c4e38c$var$Fp.ONE)))(); // 3. c3 = sqrt(-1)
// prettier-ignore
function $3ffd9d4258c4e38c$var$map_to_curve_elligator2_curve25519(u) {
    const ELL2_C4 = ($3ffd9d4258c4e38c$var$Fp.ORDER - $3ffd9d4258c4e38c$var$_5n) / $3ffd9d4258c4e38c$var$_8n; // 4. c4 = (q - 5) / 8       # Integer arithmetic
    const ELL2_J = BigInt(486662);
    let tv1 = $3ffd9d4258c4e38c$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $3ffd9d4258c4e38c$var$Fp.mul(tv1, $3ffd9d4258c4e38c$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $3ffd9d4258c4e38c$var$Fp.add(tv1, $3ffd9d4258c4e38c$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $3ffd9d4258c4e38c$var$Fp.neg(ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $3ffd9d4258c4e38c$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $3ffd9d4258c4e38c$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $3ffd9d4258c4e38c$var$Fp.mul(tv1, ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $3ffd9d4258c4e38c$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $3ffd9d4258c4e38c$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $3ffd9d4258c4e38c$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $3ffd9d4258c4e38c$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $3ffd9d4258c4e38c$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $3ffd9d4258c4e38c$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $3ffd9d4258c4e38c$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $3ffd9d4258c4e38c$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $3ffd9d4258c4e38c$var$Fp.pow(tv2, ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $3ffd9d4258c4e38c$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $3ffd9d4258c4e38c$var$Fp.mul(y11, $3ffd9d4258c4e38c$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $3ffd9d4258c4e38c$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $3ffd9d4258c4e38c$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $3ffd9d4258c4e38c$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $3ffd9d4258c4e38c$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $3ffd9d4258c4e38c$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $3ffd9d4258c4e38c$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $3ffd9d4258c4e38c$var$Fp.mul(y21, $3ffd9d4258c4e38c$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $3ffd9d4258c4e38c$var$Fp.mul(y21, $3ffd9d4258c4e38c$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $3ffd9d4258c4e38c$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $3ffd9d4258c4e38c$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $3ffd9d4258c4e38c$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $3ffd9d4258c4e38c$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $3ffd9d4258c4e38c$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $3ffd9d4258c4e38c$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $3ffd9d4258c4e38c$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $3ffd9d4258c4e38c$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $3ffd9d4258c4e38c$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $3ffd9d4258c4e38c$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $3ffd9d4258c4e38c$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $3ffd9d4258c4e38c$var$Fp.cmov(y, $3ffd9d4258c4e38c$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $3ffd9d4258c4e38c$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $3ffd9d4258c4e38c$var$ELL2_C1_EDWARDS = /* @__PURE__ */ (()=>(0, $i2UKs.FpSqrtEven)($3ffd9d4258c4e38c$var$Fp, $3ffd9d4258c4e38c$var$Fp.neg(BigInt(486664))))(); // sgn0(c1) MUST equal 0
function $3ffd9d4258c4e38c$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $3ffd9d4258c4e38c$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $3ffd9d4258c4e38c$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $3ffd9d4258c4e38c$var$Fp.mul(xn, $3ffd9d4258c4e38c$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $3ffd9d4258c4e38c$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $3ffd9d4258c4e38c$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $3ffd9d4258c4e38c$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $3ffd9d4258c4e38c$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $3ffd9d4258c4e38c$var$Fp.eql(tv1, $3ffd9d4258c4e38c$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $3ffd9d4258c4e38c$var$Fp.cmov(xn, $3ffd9d4258c4e38c$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $3ffd9d4258c4e38c$var$Fp.cmov(xd, $3ffd9d4258c4e38c$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $3ffd9d4258c4e38c$var$Fp.cmov(yn, $3ffd9d4258c4e38c$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $3ffd9d4258c4e38c$var$Fp.cmov(yd, $3ffd9d4258c4e38c$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $3ffd9d4258c4e38c$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $3ffd9d4258c4e38c$var$Fp.mul(xn, inv[0]),
        y: $3ffd9d4258c4e38c$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $3ffd9d4258c4e38c$var$htf = /* @__PURE__ */ (()=>(0, $180d50efb7760cfe$export$14b114effbc08b6b)($3ffd9d4258c4e38c$export$f63794f4a09a19c1.ExtendedPoint, (scalars)=>$3ffd9d4258c4e38c$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $3ffd9d4258c4e38c$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $b48f7bf91e010339$export$a888d2532e6dc7bb)
    }))();
const $3ffd9d4258c4e38c$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$3ffd9d4258c4e38c$var$htf.hashToCurve)();
const $3ffd9d4258c4e38c$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$3ffd9d4258c4e38c$var$htf.encodeToCurve)();
function $3ffd9d4258c4e38c$var$assertRstPoint(other) {
    if (!(other instanceof $3ffd9d4258c4e38c$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $3ffd9d4258c4e38c$var$SQRT_M1 = $3ffd9d4258c4e38c$var$ED25519_SQRT_M1;
// √(ad - 1)
const $3ffd9d4258c4e38c$var$SQRT_AD_MINUS_ONE = /* @__PURE__ */ BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $3ffd9d4258c4e38c$var$INVSQRT_A_MINUS_D = /* @__PURE__ */ BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $3ffd9d4258c4e38c$var$ONE_MINUS_D_SQ = /* @__PURE__ */ BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $3ffd9d4258c4e38c$var$D_MINUS_ONE_SQ = /* @__PURE__ */ BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $3ffd9d4258c4e38c$var$invertSqrt = (number)=>$3ffd9d4258c4e38c$var$uvRatio($3ffd9d4258c4e38c$var$_1n, number);
const $3ffd9d4258c4e38c$var$MAX_255B = /* @__PURE__ */ BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $3ffd9d4258c4e38c$var$bytes255ToNumberLE = (bytes)=>$3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE.Fp.create((0, $O98NX.bytesToNumberLE)(bytes) & $3ffd9d4258c4e38c$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $3ffd9d4258c4e38c$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE;
    const P = $3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
    const mod = $3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE.Fp.create;
    const r = mod($3ffd9d4258c4e38c$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $3ffd9d4258c4e38c$var$_1n) * $3ffd9d4258c4e38c$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $3ffd9d4258c4e38c$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $i2UKs.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $3ffd9d4258c4e38c$var$_1n) * $3ffd9d4258c4e38c$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $3ffd9d4258c4e38c$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($3ffd9d4258c4e38c$var$_1n - s2); // 12
    const W3 = mod($3ffd9d4258c4e38c$var$_1n + s2); // 13
    return new $3ffd9d4258c4e38c$export$f63794f4a09a19c1.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $3ffd9d4258c4e38c$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $3ffd9d4258c4e38c$var$RistPoint($3ffd9d4258c4e38c$export$f63794f4a09a19c1.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $O98NX.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $3ffd9d4258c4e38c$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $3ffd9d4258c4e38c$var$calcElligatorRistrettoMap(r1);
        const r2 = $3ffd9d4258c4e38c$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $3ffd9d4258c4e38c$var$calcElligatorRistrettoMap(r2);
        return new $3ffd9d4258c4e38c$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $O98NX.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = $3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE;
        const P = $3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $3ffd9d4258c4e38c$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $O98NX.equalBytes)((0, $O98NX.numberToBytesLE)(s, 32), hex) || (0, $i2UKs.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($3ffd9d4258c4e38c$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($3ffd9d4258c4e38c$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $3ffd9d4258c4e38c$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $i2UKs.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $i2UKs.isNegativeLE)(t, P) || y === $3ffd9d4258c4e38c$var$_0n) throw new Error(emsg);
        return new $3ffd9d4258c4e38c$var$RistPoint(new $3ffd9d4258c4e38c$export$f63794f4a09a19c1.ExtendedPoint(x, y, $3ffd9d4258c4e38c$var$_1n, t));
    }
    static msm(points, scalars) {
        const Fn = (0, $i2UKs.Field)($3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE.n, $3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE.nBitLength);
        return (0, $Q6eBv.pippenger)($3ffd9d4258c4e38c$var$RistPoint, Fn, points, scalars);
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = $3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $3ffd9d4258c4e38c$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $i2UKs.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $3ffd9d4258c4e38c$var$SQRT_M1);
            let _y = mod(x * $3ffd9d4258c4e38c$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $3ffd9d4258c4e38c$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $i2UKs.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $i2UKs.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $O98NX.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $O98NX.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $3ffd9d4258c4e38c$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = $3ffd9d4258c4e38c$export$f63794f4a09a19c1.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $3ffd9d4258c4e38c$var$assertRstPoint(other);
        return new $3ffd9d4258c4e38c$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $3ffd9d4258c4e38c$var$assertRstPoint(other);
        return new $3ffd9d4258c4e38c$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $3ffd9d4258c4e38c$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $3ffd9d4258c4e38c$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
    double() {
        return new $3ffd9d4258c4e38c$var$RistPoint(this.ep.double());
    }
    negate() {
        return new $3ffd9d4258c4e38c$var$RistPoint(this.ep.negate());
    }
}
const $3ffd9d4258c4e38c$export$5e87c4f36f27816d = /* @__PURE__ */ (()=>{
    if (!$3ffd9d4258c4e38c$var$RistPoint.BASE) $3ffd9d4258c4e38c$var$RistPoint.BASE = new $3ffd9d4258c4e38c$var$RistPoint($3ffd9d4258c4e38c$export$f63794f4a09a19c1.ExtendedPoint.BASE);
    if (!$3ffd9d4258c4e38c$var$RistPoint.ZERO) $3ffd9d4258c4e38c$var$RistPoint.ZERO = new $3ffd9d4258c4e38c$var$RistPoint($3ffd9d4258c4e38c$export$f63794f4a09a19c1.ExtendedPoint.ZERO);
    return $3ffd9d4258c4e38c$var$RistPoint;
})();
const $3ffd9d4258c4e38c$export$c9ad4c0d917ad3 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $a6815365d7c5325d$export$3df70a15530b5e81)(d) : d;
    const uniform_bytes = (0, $180d50efb7760cfe$export$3df78c69af9fc85d)(msg, DST, 64, (0, $b48f7bf91e010339$export$a888d2532e6dc7bb));
    const P = $3ffd9d4258c4e38c$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
const $3ffd9d4258c4e38c$export$667ef88de7a83a7f = $3ffd9d4258c4e38c$export$c9ad4c0d917ad3; // legacy


/**
 * @internal
 *
 * Efficiently compare {@link Indexed} arrays (e.g. `Array` and `Uint8Array`).
 *
 * @param a An array.
 * @param b Another array.
 *
 * @return `true` if the arrays have the same length and elements, `false` otherwise.
 *
 * @group Internal
 */ function $5d8c1a3e0d5fc4e0$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    const length = a.length;
    if (length !== b.length) return false;
    for(let i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $5d8c1a3e0d5fc4e0$export$c663ab80cce302c5(a, b) {
    return $5d8c1a3e0d5fc4e0$export$234180f8206db11b(a, b);
}


function $6f11d5f6c91f6ce1$export$54b8e79a8f938f52({ message: message, signedMessage: signedMessage, signature: signature, publicKey: publicKey }) {
    // TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
    return (0, $5d8c1a3e0d5fc4e0$export$c663ab80cce302c5)(message, signedMessage) && (0, $3ffd9d4258c4e38c$export$f63794f4a09a19c1).verify(signature, signedMessage, publicKey);
}
function $6f11d5f6c91f6ce1$export$a7a8e868ceb02186(input, output) {
    const { message: message, account: { publicKey: publicKey } } = input;
    const { signedMessage: signedMessage, signature: signature } = output;
    return $6f11d5f6c91f6ce1$export$54b8e79a8f938f52({
        message: message,
        signedMessage: signedMessage,
        signature: signature,
        publicKey: publicKey
    });
}



function $f20c9828b1b3be00$export$9828dc452d20db63(input, output) {
    const { signedMessage: signedMessage, signature: signature, account: { publicKey: publicKey } } = output;
    const message = $f20c9828b1b3be00$export$5a98156f426eafe8(input, output);
    return !!message && (0, $6f11d5f6c91f6ce1$export$54b8e79a8f938f52)({
        message: message,
        signedMessage: signedMessage,
        signature: signature,
        publicKey: publicKey
    });
}
function $f20c9828b1b3be00$export$5a98156f426eafe8(input, output) {
    const text = $f20c9828b1b3be00$export$14d5fbb279d179c2(input, output);
    if (!text) return null;
    return new TextEncoder().encode(text);
}
function $f20c9828b1b3be00$export$14d5fbb279d179c2(input, output) {
    const parsed = $f20c9828b1b3be00$export$ddde1a7f6f94bd0a(output.signedMessage);
    if (!parsed) return null;
    if (input.domain && input.domain !== parsed.domain) return null;
    if (input.address && input.address !== parsed.address) return null;
    if (input.statement !== parsed.statement) return null;
    if (input.uri !== parsed.uri) return null;
    if (input.version !== parsed.version) return null;
    if (input.chainId !== parsed.chainId) return null;
    if (input.nonce !== parsed.nonce) return null;
    if (input.issuedAt !== parsed.issuedAt) return null;
    if (input.expirationTime !== parsed.expirationTime) return null;
    if (input.notBefore !== parsed.notBefore) return null;
    if (input.requestId !== parsed.requestId) return null;
    if (input.resources) {
        if (!parsed.resources) return null;
        if (!(0, $5d8c1a3e0d5fc4e0$export$234180f8206db11b)(input.resources, parsed.resources)) return null;
    } else if (parsed.resources) return null;
    return $f20c9828b1b3be00$export$88aceda9565b68d2(parsed);
}
function $f20c9828b1b3be00$export$ddde1a7f6f94bd0a(message) {
    const text = new TextDecoder().decode(message);
    return $f20c9828b1b3be00$export$4a112f3ad8ba8e50(text);
}
// TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
const $f20c9828b1b3be00$var$DOMAIN = "(?<domain>[^\\n]+?) wants you to sign in with your Solana account:\\n";
const $f20c9828b1b3be00$var$ADDRESS = "(?<address>[^\\n]+)(?:\\n|$)";
const $f20c9828b1b3be00$var$STATEMENT = "(?:\\n(?<statement>[\\S\\s]*?)(?:\\n|$))??";
const $f20c9828b1b3be00$var$URI = "(?:\\nURI: (?<uri>[^\\n]+))?";
const $f20c9828b1b3be00$var$VERSION = "(?:\\nVersion: (?<version>[^\\n]+))?";
const $f20c9828b1b3be00$var$CHAIN_ID = "(?:\\nChain ID: (?<chainId>[^\\n]+))?";
const $f20c9828b1b3be00$var$NONCE = "(?:\\nNonce: (?<nonce>[^\\n]+))?";
const $f20c9828b1b3be00$var$ISSUED_AT = "(?:\\nIssued At: (?<issuedAt>[^\\n]+))?";
const $f20c9828b1b3be00$var$EXPIRATION_TIME = "(?:\\nExpiration Time: (?<expirationTime>[^\\n]+))?";
const $f20c9828b1b3be00$var$NOT_BEFORE = "(?:\\nNot Before: (?<notBefore>[^\\n]+))?";
const $f20c9828b1b3be00$var$REQUEST_ID = "(?:\\nRequest ID: (?<requestId>[^\\n]+))?";
const $f20c9828b1b3be00$var$RESOURCES = "(?:\\nResources:(?<resources>(?:\\n- [^\\n]+)*))?";
const $f20c9828b1b3be00$var$FIELDS = `${$f20c9828b1b3be00$var$URI}${$f20c9828b1b3be00$var$VERSION}${$f20c9828b1b3be00$var$CHAIN_ID}${$f20c9828b1b3be00$var$NONCE}${$f20c9828b1b3be00$var$ISSUED_AT}${$f20c9828b1b3be00$var$EXPIRATION_TIME}${$f20c9828b1b3be00$var$NOT_BEFORE}${$f20c9828b1b3be00$var$REQUEST_ID}${$f20c9828b1b3be00$var$RESOURCES}`;
const $f20c9828b1b3be00$var$MESSAGE = new RegExp(`^${$f20c9828b1b3be00$var$DOMAIN}${$f20c9828b1b3be00$var$ADDRESS}${$f20c9828b1b3be00$var$STATEMENT}${$f20c9828b1b3be00$var$FIELDS}\\n*$`);
function $f20c9828b1b3be00$export$4a112f3ad8ba8e50(text) {
    const match = $f20c9828b1b3be00$var$MESSAGE.exec(text);
    if (!match) return null;
    const groups = match.groups;
    if (!groups) return null;
    return {
        domain: groups.domain,
        address: groups.address,
        statement: groups.statement,
        uri: groups.uri,
        version: groups.version,
        nonce: groups.nonce,
        chainId: groups.chainId,
        issuedAt: groups.issuedAt,
        expirationTime: groups.expirationTime,
        notBefore: groups.notBefore,
        requestId: groups.requestId,
        resources: groups.resources?.split("\n- ").slice(1)
    };
}
function $f20c9828b1b3be00$export$92ddcd466ce9e7c4(input) {
    const text = $f20c9828b1b3be00$export$88aceda9565b68d2(input);
    return new TextEncoder().encode(text);
}
function $f20c9828b1b3be00$export$88aceda9565b68d2(input) {
    // ${domain} wants you to sign in with your Solana account:
    // ${address}
    //
    // ${statement}
    //
    // URI: ${uri}
    // Version: ${version}
    // Chain ID: ${chain}
    // Nonce: ${nonce}
    // Issued At: ${issued-at}
    // Expiration Time: ${expiration-time}
    // Not Before: ${not-before}
    // Request ID: ${request-id}
    // Resources:
    // - ${resources[0]}
    // - ${resources[1]}
    // ...
    // - ${resources[n]}
    let message = `${input.domain} wants you to sign in with your Solana account:\n`;
    message += `${input.address}`;
    if (input.statement) message += `\n\n${input.statement}`;
    const fields = [];
    if (input.uri) fields.push(`URI: ${input.uri}`);
    if (input.version) fields.push(`Version: ${input.version}`);
    if (input.chainId) fields.push(`Chain ID: ${input.chainId}`);
    if (input.nonce) fields.push(`Nonce: ${input.nonce}`);
    if (input.issuedAt) fields.push(`Issued At: ${input.issuedAt}`);
    if (input.expirationTime) fields.push(`Expiration Time: ${input.expirationTime}`);
    if (input.notBefore) fields.push(`Not Before: ${input.notBefore}`);
    if (input.requestId) fields.push(`Request ID: ${input.requestId}`);
    if (input.resources) {
        fields.push(`Resources:`);
        for (const resource of input.resources)fields.push(`- ${resource}`);
    }
    if (fields.length) message += `\n\n${fields.join("\n")}`;
    return message;
}


// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $cc0f3ff54fb9e626$export$93083e877aec7a8a = {
    ERROR_ASSOCIATION_PORT_OUT_OF_RANGE: "ERROR_ASSOCIATION_PORT_OUT_OF_RANGE",
    ERROR_REFLECTOR_ID_OUT_OF_RANGE: "ERROR_REFLECTOR_ID_OUT_OF_RANGE",
    ERROR_FORBIDDEN_WALLET_BASE_URL: "ERROR_FORBIDDEN_WALLET_BASE_URL",
    ERROR_SECURE_CONTEXT_REQUIRED: "ERROR_SECURE_CONTEXT_REQUIRED",
    ERROR_SESSION_CLOSED: "ERROR_SESSION_CLOSED",
    ERROR_SESSION_TIMEOUT: "ERROR_SESSION_TIMEOUT",
    ERROR_WALLET_NOT_FOUND: "ERROR_WALLET_NOT_FOUND",
    ERROR_INVALID_PROTOCOL_VERSION: "ERROR_INVALID_PROTOCOL_VERSION"
};
class $cc0f3ff54fb9e626$export$d77545679c409b63 extends Error {
    constructor(...args){
        const [code, message, data] = args;
        super(message);
        this.code = code;
        this.data = data;
        this.name = "SolanaMobileWalletAdapterError";
    }
}
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $cc0f3ff54fb9e626$export$23d27841621bc1e8 = {
    // Keep these in sync with `mobilewalletadapter/common/ProtocolContract.java`.
    ERROR_AUTHORIZATION_FAILED: -1,
    ERROR_INVALID_PAYLOADS: -2,
    ERROR_NOT_SIGNED: -3,
    ERROR_NOT_SUBMITTED: -4,
    ERROR_TOO_MANY_PAYLOADS: -5,
    ERROR_ATTEST_ORIGIN_ANDROID: -100
};
class $cc0f3ff54fb9e626$export$58b788f937123c66 extends Error {
    constructor(...args){
        const [jsonRpcMessageId, code, message, data] = args;
        super(message);
        this.code = code;
        this.data = data;
        this.jsonRpcMessageId = jsonRpcMessageId;
        this.name = "SolanaMobileWalletAdapterProtocolError";
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $cc0f3ff54fb9e626$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cc0f3ff54fb9e626$var$createHelloReq(ecdhPublicKey, associationKeypairPrivateKey) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const publicKeyBuffer = yield crypto.subtle.exportKey("raw", ecdhPublicKey);
        const signatureBuffer = yield crypto.subtle.sign({
            hash: "SHA-256",
            name: "ECDSA"
        }, associationKeypairPrivateKey, publicKeyBuffer);
        const response = new Uint8Array(publicKeyBuffer.byteLength + signatureBuffer.byteLength);
        response.set(new Uint8Array(publicKeyBuffer), 0);
        response.set(new Uint8Array(signatureBuffer), publicKeyBuffer.byteLength);
        return response;
    });
}
function $cc0f3ff54fb9e626$var$encode(input) {
    return window.btoa(input);
}
function $cc0f3ff54fb9e626$var$createSIWSMessage(payload) {
    return (0, $f20c9828b1b3be00$export$88aceda9565b68d2)(payload);
}
function $cc0f3ff54fb9e626$var$createSIWSMessageBase64(payload) {
    return $cc0f3ff54fb9e626$var$encode($cc0f3ff54fb9e626$var$createSIWSMessage(payload));
}
// optional features
const $cc0f3ff54fb9e626$export$6d2aa8b15676f603 = "solana:signTransactions";
const $cc0f3ff54fb9e626$export$7b8713ece485d770 = "solana:cloneAuthorization";
const $cc0f3ff54fb9e626$export$fca2a421c519d7f8 = "solana:signInWithSolana";
/**
 * Creates a {@link MobileWallet} proxy that handles backwards compatibility and API to RPC conversion.
 *
 * @param protocolVersion the protocol version in use for this session/request
 * @param protocolRequestHandler callback function that handles sending the RPC request to the wallet endpoint.
 * @returns a {@link MobileWallet} proxy
 */ function $cc0f3ff54fb9e626$var$createMobileWalletProxy(protocolVersion, protocolRequestHandler) {
    return new Proxy({}, {
        get (target, p) {
            if (target[p] == null) target[p] = function(inputParams) {
                return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                    const { method: method, params: params } = $cc0f3ff54fb9e626$var$handleMobileWalletRequest(p, inputParams, protocolVersion);
                    const result = yield protocolRequestHandler(method, params);
                    // if the request tried to sign in but the wallet did not return a sign in result, fallback on message signing
                    if (method === "authorize" && params.sign_in_payload && !result.sign_in_result) result["sign_in_result"] = yield $cc0f3ff54fb9e626$var$signInFallback(params.sign_in_payload, result, protocolRequestHandler);
                    return $cc0f3ff54fb9e626$var$handleMobileWalletResponse(p, result, protocolVersion);
                });
            };
            return target[p];
        },
        defineProperty () {
            return false;
        },
        deleteProperty () {
            return false;
        }
    });
}
/**
 * Handles all {@link MobileWallet} API requests and determines the correct MWA RPC method and params to call.
 * This handles backwards compatibility, based on the provided @protocolVersion.
 *
 * @param methodName the name of {@link MobileWallet} method that was called
 * @param methodParams the parameters that were passed to the method
 * @param protocolVersion the protocol version in use for this session/request
 * @returns the RPC request method and params that should be sent to the wallet endpoint
 */ function $cc0f3ff54fb9e626$var$handleMobileWalletRequest(methodName, methodParams, protocolVersion) {
    let params = methodParams;
    let method = methodName.toString().replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`).toLowerCase();
    switch(methodName){
        case "authorize":
            {
                let { chain: chain } = params;
                if (protocolVersion === "legacy") {
                    switch(chain){
                        case "solana:testnet":
                            chain = "testnet";
                            break;
                        case "solana:devnet":
                            chain = "devnet";
                            break;
                        case "solana:mainnet":
                            chain = "mainnet-beta";
                            break;
                        default:
                            chain = params.cluster;
                    }
                    params.cluster = chain;
                } else {
                    switch(chain){
                        case "testnet":
                        case "devnet":
                            chain = `solana:${chain}`;
                            break;
                        case "mainnet-beta":
                            chain = "solana:mainnet";
                            break;
                    }
                    params.chain = chain;
                }
            }
        case "reauthorize":
            {
                const { auth_token: auth_token, identity: identity } = params;
                if (auth_token) switch(protocolVersion){
                    case "legacy":
                        method = "reauthorize";
                        params = {
                            auth_token: auth_token,
                            identity: identity
                        };
                        break;
                    default:
                        method = "authorize";
                        break;
                }
                break;
            }
    }
    return {
        method: method,
        params: params
    };
}
/**
 * Handles all {@link MobileWallet} API responses and modifies the response for backwards compatibility, if needed
 *
 * @param method the {@link MobileWallet} method that was called
 * @param response the original response that was returned by the method call
 * @param protocolVersion the protocol version in use for this session/request
 * @returns the possibly modified response
 */ function $cc0f3ff54fb9e626$var$handleMobileWalletResponse(method, response, protocolVersion) {
    switch(method){
        case "getCapabilities":
            {
                const capabilities = response;
                switch(protocolVersion){
                    case "legacy":
                        {
                            const features = [
                                $cc0f3ff54fb9e626$export$6d2aa8b15676f603
                            ];
                            if (capabilities.supports_clone_authorization === true) features.push($cc0f3ff54fb9e626$export$7b8713ece485d770);
                            return Object.assign(Object.assign({}, capabilities), {
                                features: features
                            });
                        }
                    case "v1":
                        return Object.assign(Object.assign({}, capabilities), {
                            supports_sign_and_send_transactions: true,
                            supports_clone_authorization: capabilities.features.includes($cc0f3ff54fb9e626$export$7b8713ece485d770)
                        });
                }
            }
    }
    return response;
}
function $cc0f3ff54fb9e626$var$signInFallback(signInPayload, authorizationResult, protocolRequestHandler) {
    var _a;
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const domain = (_a = signInPayload.domain) !== null && _a !== void 0 ? _a : window.location.host;
        const address = authorizationResult.accounts[0].address;
        const siwsMessage = $cc0f3ff54fb9e626$var$createSIWSMessageBase64(Object.assign(Object.assign({}, signInPayload), {
            domain: domain,
            address: address
        }));
        const signMessageResult = yield protocolRequestHandler("sign_messages", {
            addresses: [
                address
            ],
            payloads: [
                siwsMessage
            ]
        });
        const signInResult = {
            address: address,
            signed_message: siwsMessage,
            signature: signMessageResult.signed_payloads[0].slice(siwsMessage.length)
        };
        return signInResult;
    });
}
const $cc0f3ff54fb9e626$var$SEQUENCE_NUMBER_BYTES = 4;
function $cc0f3ff54fb9e626$var$createSequenceNumberVector(sequenceNumber) {
    if (sequenceNumber >= 4294967296) throw new Error("Outbound sequence number overflow. The maximum sequence number is 32-bytes.");
    const byteArray = new ArrayBuffer($cc0f3ff54fb9e626$var$SEQUENCE_NUMBER_BYTES);
    const view = new DataView(byteArray);
    view.setUint32(0, sequenceNumber, /* littleEndian */ false);
    return new Uint8Array(byteArray);
}
const $cc0f3ff54fb9e626$var$INITIALIZATION_VECTOR_BYTES = 12;
const $cc0f3ff54fb9e626$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES = 65;
function $cc0f3ff54fb9e626$var$encryptMessage(plaintext, sequenceNumber, sharedSecret) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const sequenceNumberVector = $cc0f3ff54fb9e626$var$createSequenceNumberVector(sequenceNumber);
        const initializationVector = new Uint8Array($cc0f3ff54fb9e626$var$INITIALIZATION_VECTOR_BYTES);
        crypto.getRandomValues(initializationVector);
        const ciphertext = yield crypto.subtle.encrypt($cc0f3ff54fb9e626$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, new TextEncoder().encode(plaintext));
        const response = new Uint8Array(sequenceNumberVector.byteLength + initializationVector.byteLength + ciphertext.byteLength);
        response.set(new Uint8Array(sequenceNumberVector), 0);
        response.set(new Uint8Array(initializationVector), sequenceNumberVector.byteLength);
        response.set(new Uint8Array(ciphertext), sequenceNumberVector.byteLength + initializationVector.byteLength);
        return response;
    });
}
function $cc0f3ff54fb9e626$var$decryptMessage(message, sharedSecret) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const sequenceNumberVector = message.slice(0, $cc0f3ff54fb9e626$var$SEQUENCE_NUMBER_BYTES);
        const initializationVector = message.slice($cc0f3ff54fb9e626$var$SEQUENCE_NUMBER_BYTES, $cc0f3ff54fb9e626$var$SEQUENCE_NUMBER_BYTES + $cc0f3ff54fb9e626$var$INITIALIZATION_VECTOR_BYTES);
        const ciphertext = message.slice($cc0f3ff54fb9e626$var$SEQUENCE_NUMBER_BYTES + $cc0f3ff54fb9e626$var$INITIALIZATION_VECTOR_BYTES);
        const plaintextBuffer = yield crypto.subtle.decrypt($cc0f3ff54fb9e626$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, ciphertext);
        const plaintext = $cc0f3ff54fb9e626$var$getUtf8Decoder().decode(plaintextBuffer);
        return plaintext;
    });
}
function $cc0f3ff54fb9e626$var$getAlgorithmParams(sequenceNumber, initializationVector) {
    return {
        additionalData: sequenceNumber,
        iv: initializationVector,
        name: "AES-GCM",
        tagLength: 128
    };
}
let $cc0f3ff54fb9e626$var$_utf8Decoder;
function $cc0f3ff54fb9e626$var$getUtf8Decoder() {
    if ($cc0f3ff54fb9e626$var$_utf8Decoder === undefined) $cc0f3ff54fb9e626$var$_utf8Decoder = new TextDecoder("utf-8");
    return $cc0f3ff54fb9e626$var$_utf8Decoder;
}
function $cc0f3ff54fb9e626$var$generateAssociationKeypair() {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        return yield crypto.subtle.generateKey({
            name: "ECDSA",
            namedCurve: "P-256"
        }, false, [
            "sign"
        ]);
    });
}
function $cc0f3ff54fb9e626$var$generateECDHKeypair() {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        return yield crypto.subtle.generateKey({
            name: "ECDH",
            namedCurve: "P-256"
        }, false, [
            "deriveKey",
            "deriveBits"
        ]);
    });
}
function $cc0f3ff54fb9e626$var$encryptJsonRpcMessage(jsonRpcMessage, sharedSecret) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const plaintext = JSON.stringify(jsonRpcMessage);
        const sequenceNumber = jsonRpcMessage.id;
        return $cc0f3ff54fb9e626$var$encryptMessage(plaintext, sequenceNumber, sharedSecret);
    });
}
function $cc0f3ff54fb9e626$var$decryptJsonRpcMessage(message, sharedSecret) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const plaintext = yield $cc0f3ff54fb9e626$var$decryptMessage(message, sharedSecret);
        const jsonRpcMessage = JSON.parse(plaintext);
        if (Object.hasOwnProperty.call(jsonRpcMessage, "error")) throw new $cc0f3ff54fb9e626$export$58b788f937123c66(jsonRpcMessage.id, jsonRpcMessage.error.code, jsonRpcMessage.error.message);
        return jsonRpcMessage;
    });
}
function $cc0f3ff54fb9e626$var$parseHelloRsp(payloadBuffer, associationPublicKey, ecdhPrivateKey) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const [associationPublicKeyBuffer, walletPublicKey] = yield Promise.all([
            crypto.subtle.exportKey("raw", associationPublicKey),
            crypto.subtle.importKey("raw", payloadBuffer.slice(0, $cc0f3ff54fb9e626$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES), {
                name: "ECDH",
                namedCurve: "P-256"
            }, false, [])
        ]);
        const sharedSecret = yield crypto.subtle.deriveBits({
            name: "ECDH",
            public: walletPublicKey
        }, ecdhPrivateKey, 256);
        const ecdhSecretKey = yield crypto.subtle.importKey("raw", sharedSecret, "HKDF", false, [
            "deriveKey"
        ]);
        const aesKeyMaterialVal = yield crypto.subtle.deriveKey({
            name: "HKDF",
            hash: "SHA-256",
            salt: new Uint8Array(associationPublicKeyBuffer),
            info: new Uint8Array()
        }, ecdhSecretKey, {
            name: "AES-GCM",
            length: 128
        }, false, [
            "encrypt",
            "decrypt"
        ]);
        return aesKeyMaterialVal;
    });
}
function $cc0f3ff54fb9e626$var$parseSessionProps(message, sharedSecret) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const plaintext = yield $cc0f3ff54fb9e626$var$decryptMessage(message, sharedSecret);
        const jsonProperties = JSON.parse(plaintext);
        let protocolVersion = "legacy";
        if (Object.hasOwnProperty.call(jsonProperties, "v")) switch(jsonProperties.v){
            case 1:
            case "1":
            case "v1":
                protocolVersion = "v1";
                break;
            case "legacy":
                protocolVersion = "legacy";
                break;
            default:
                throw new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_INVALID_PROTOCOL_VERSION, `Unknown/unsupported protocol version: ${jsonProperties.v}`);
        }
        return {
            protocol_version: protocolVersion
        };
    });
}
function $cc0f3ff54fb9e626$var$getRandomAssociationPort() {
    return $cc0f3ff54fb9e626$var$assertAssociationPort(49152 + Math.floor(Math.random() * 16384));
}
function $cc0f3ff54fb9e626$var$assertAssociationPort(port) {
    if (port < 49152 || port > 65535) throw new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_ASSOCIATION_PORT_OUT_OF_RANGE, `Association port number must be between 49152 and 65535. ${port} given.`, {
        port: port
    });
    return port;
}
// https://stackoverflow.com/a/9458996/802047
function $cc0f3ff54fb9e626$var$arrayBufferToBase64String(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for(let ii = 0; ii < len; ii++)binary += String.fromCharCode(bytes[ii]);
    return window.btoa(binary);
}
function $cc0f3ff54fb9e626$var$getStringWithURLUnsafeCharactersReplaced(unsafeBase64EncodedString) {
    return unsafeBase64EncodedString.replace(/[/+=]/g, (m)=>({
            "/": "_",
            "+": "-",
            "=": "."
        })[m]);
}
function $cc0f3ff54fb9e626$var$getRandomReflectorId() {
    return $cc0f3ff54fb9e626$var$assertReflectorId($cc0f3ff54fb9e626$var$getRandomInt(0, 9007199254740991)); // 0 < id < 2^53 - 1
}
function $cc0f3ff54fb9e626$var$getRandomInt(min, max) {
    const randomBuffer = new Uint32Array(1);
    window.crypto.getRandomValues(randomBuffer);
    let randomNumber = randomBuffer[0] / 4294967296;
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(randomNumber * (max - min + 1)) + min;
}
function $cc0f3ff54fb9e626$var$assertReflectorId(id) {
    if (id < 0 || id > 9007199254740991) throw new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_REFLECTOR_ID_OUT_OF_RANGE, `Association port number must be between 49152 and 65535. ${id} given.`, {
        id: id
    });
    return id;
}
const $cc0f3ff54fb9e626$var$INTENT_NAME = "solana-wallet";
function $cc0f3ff54fb9e626$var$getPathParts(pathString) {
    return pathString// Strip leading and trailing slashes
    .replace(/(^\/+|\/+$)/g, "")// Return an array of directories
    .split("/");
}
function $cc0f3ff54fb9e626$var$getIntentURL(methodPathname, intentUrlBase) {
    let baseUrl = null;
    if (intentUrlBase) {
        try {
            baseUrl = new URL(intentUrlBase);
        } catch (_a) {} // eslint-disable-line no-empty
        if ((baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.protocol) !== "https:") throw new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
    }
    baseUrl || (baseUrl = new URL(`${$cc0f3ff54fb9e626$var$INTENT_NAME}:/`));
    const pathname = methodPathname.startsWith("/") ? methodPathname : [
        ...$cc0f3ff54fb9e626$var$getPathParts(baseUrl.pathname),
        ...$cc0f3ff54fb9e626$var$getPathParts(methodPathname)
    ].join("/");
    return new URL(pathname, baseUrl);
}
function $cc0f3ff54fb9e626$var$getAssociateAndroidIntentURL(associationPublicKey, putativePort, associationURLBase, protocolVersions = [
    "v1"
]) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const associationPort = $cc0f3ff54fb9e626$var$assertAssociationPort(putativePort);
        const exportedKey = yield crypto.subtle.exportKey("raw", associationPublicKey);
        const encodedKey = $cc0f3ff54fb9e626$var$arrayBufferToBase64String(exportedKey);
        const url = $cc0f3ff54fb9e626$var$getIntentURL("v1/associate/local", associationURLBase);
        url.searchParams.set("association", $cc0f3ff54fb9e626$var$getStringWithURLUnsafeCharactersReplaced(encodedKey));
        url.searchParams.set("port", `${associationPort}`);
        protocolVersions.forEach((version)=>{
            url.searchParams.set("v", version);
        });
        return url;
    });
}
function $cc0f3ff54fb9e626$var$getRemoteAssociateAndroidIntentURL(associationPublicKey, hostAuthority, putativeId, associationURLBase, protocolVersions = [
    "v1"
]) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const reflectorId = $cc0f3ff54fb9e626$var$assertReflectorId(putativeId);
        const exportedKey = yield crypto.subtle.exportKey("raw", associationPublicKey);
        const encodedKey = $cc0f3ff54fb9e626$var$arrayBufferToBase64String(exportedKey);
        const url = $cc0f3ff54fb9e626$var$getIntentURL("v1/associate/remote", associationURLBase);
        url.searchParams.set("association", $cc0f3ff54fb9e626$var$getStringWithURLUnsafeCharactersReplaced(encodedKey));
        url.searchParams.set("reflector", `${hostAuthority}`);
        url.searchParams.set("id", `${reflectorId}`);
        protocolVersions.forEach((version)=>{
            url.searchParams.set("v", version);
        });
        return url;
    });
}
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $cc0f3ff54fb9e626$var$Browser = {
    Firefox: 0,
    Other: 1
};
function $cc0f3ff54fb9e626$var$assertUnreachable(x) {
    return x;
}
function $cc0f3ff54fb9e626$var$getBrowser() {
    return navigator.userAgent.indexOf("Firefox/") !== -1 ? $cc0f3ff54fb9e626$var$Browser.Firefox : $cc0f3ff54fb9e626$var$Browser.Other;
}
function $cc0f3ff54fb9e626$var$getDetectionPromise() {
    // Chrome and others silently fail if a custom protocol is not supported.
    // For these, we wait to see if the browser is navigated away from in
    // a reasonable amount of time (ie. the native wallet opened).
    return new Promise((resolve, reject)=>{
        function cleanup() {
            clearTimeout(timeoutId);
            window.removeEventListener("blur", handleBlur);
        }
        function handleBlur() {
            cleanup();
            resolve();
        }
        window.addEventListener("blur", handleBlur);
        const timeoutId = setTimeout(()=>{
            cleanup();
            reject();
        }, 2000);
    });
}
let $cc0f3ff54fb9e626$var$_frame = null;
function $cc0f3ff54fb9e626$var$launchUrlThroughHiddenFrame(url) {
    if ($cc0f3ff54fb9e626$var$_frame == null) {
        $cc0f3ff54fb9e626$var$_frame = document.createElement("iframe");
        $cc0f3ff54fb9e626$var$_frame.style.display = "none";
        document.body.appendChild($cc0f3ff54fb9e626$var$_frame);
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $cc0f3ff54fb9e626$var$_frame.contentWindow.location.href = url.toString();
}
function $cc0f3ff54fb9e626$var$launchAssociation(associationUrl) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        if (associationUrl.protocol === "https:") // The association URL is an Android 'App Link' or iOS 'Universal Link'.
        // These are regular web URLs that are designed to launch an app if it
        // is installed or load the actual target webpage if not.
        window.location.assign(associationUrl);
        else // The association URL has a custom protocol (eg. `solana-wallet:`)
        try {
            const browser = $cc0f3ff54fb9e626$var$getBrowser();
            switch(browser){
                case $cc0f3ff54fb9e626$var$Browser.Firefox:
                    // If a custom protocol is not supported in Firefox, it throws.
                    $cc0f3ff54fb9e626$var$launchUrlThroughHiddenFrame(associationUrl);
                    break;
                case $cc0f3ff54fb9e626$var$Browser.Other:
                    {
                        const detectionPromise = $cc0f3ff54fb9e626$var$getDetectionPromise();
                        window.location.assign(associationUrl);
                        yield detectionPromise;
                        break;
                    }
                default:
                    $cc0f3ff54fb9e626$var$assertUnreachable(browser);
            }
        } catch (e) {
            throw new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_WALLET_NOT_FOUND, "Found no installed wallet that supports the mobile wallet protocol.");
        }
    });
}
function $cc0f3ff54fb9e626$var$startSession(associationPublicKey, associationURLBase) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const randomAssociationPort = $cc0f3ff54fb9e626$var$getRandomAssociationPort();
        const associationUrl = yield $cc0f3ff54fb9e626$var$getAssociateAndroidIntentURL(associationPublicKey, randomAssociationPort, associationURLBase);
        yield $cc0f3ff54fb9e626$var$launchAssociation(associationUrl);
        return randomAssociationPort;
    });
}
function $cc0f3ff54fb9e626$var$getRemoteSessionUrl(associationPublicKey, hostAuthority, associationURLBase) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        const randomReflectorId = $cc0f3ff54fb9e626$var$getRandomReflectorId();
        const associationUrl = yield $cc0f3ff54fb9e626$var$getRemoteAssociateAndroidIntentURL(associationPublicKey, hostAuthority, randomReflectorId, associationURLBase);
        return {
            associationUrl: associationUrl,
            reflectorId: randomReflectorId
        };
    });
}
const $cc0f3ff54fb9e626$var$WEBSOCKET_CONNECTION_CONFIG = {
    /**
     * 300 milliseconds is a generally accepted threshold for what someone
     * would consider an acceptable response time for a user interface
     * after having performed a low-attention tapping task. We set the initial
     * interval at which we wait for the wallet to set up the websocket at
     * half this, as per the Nyquist frequency, with a progressive backoff
     * sequence from there. The total wait time is 30s, which allows for the
     * user to be presented with a disambiguation dialog, select a wallet, and
     * for the wallet app to subsequently start.
     */ retryDelayScheduleMs: [
        150,
        150,
        200,
        500,
        500,
        750,
        750,
        1000
    ],
    timeoutMs: 30000
};
const $cc0f3ff54fb9e626$var$WEBSOCKET_PROTOCOL = "com.solana.mobilewalletadapter.v1";
function $cc0f3ff54fb9e626$var$assertSecureContext() {
    if (typeof window === "undefined" || window.isSecureContext !== true) throw new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_SECURE_CONTEXT_REQUIRED, "The mobile wallet adapter protocol must be used in a secure context (`https`).");
}
function $cc0f3ff54fb9e626$var$assertSecureEndpointSpecificURI(walletUriBase) {
    let url;
    try {
        url = new URL(walletUriBase);
    } catch (_a) {
        throw new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Invalid base URL supplied by wallet");
    }
    if (url.protocol !== "https:") throw new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
}
function $cc0f3ff54fb9e626$var$getSequenceNumberFromByteArray(byteArray) {
    const view = new DataView(byteArray);
    return view.getUint32(0, /* littleEndian */ false);
}
function $cc0f3ff54fb9e626$export$dac1bad6146b2469(callback, config) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        $cc0f3ff54fb9e626$var$assertSecureContext();
        const associationKeypair = yield $cc0f3ff54fb9e626$var$generateAssociationKeypair();
        const sessionPort = yield $cc0f3ff54fb9e626$var$startSession(associationKeypair.publicKey, config === null || config === void 0 ? void 0 : config.baseUri);
        const websocketURL = `ws://localhost:${sessionPort}/solana-wallet`;
        let connectionStartTime;
        const getNextRetryDelayMs = (()=>{
            const schedule = [
                ...$cc0f3ff54fb9e626$var$WEBSOCKET_CONNECTION_CONFIG.retryDelayScheduleMs
            ];
            return ()=>schedule.length > 1 ? schedule.shift() : schedule[0];
        })();
        let nextJsonRpcMessageId = 1;
        let lastKnownInboundSequenceNumber = 0;
        let state = {
            __type: "disconnected"
        };
        return new Promise((resolve, reject)=>{
            let socket;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const jsonRpcResponsePromises = {};
            const handleOpen = ()=>$cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                    if (state.__type !== "connecting") {
                        console.warn("Expected adapter state to be `connecting` at the moment the websocket opens. " + `Got \`${state.__type}\`.`);
                        return;
                    }
                    socket.removeEventListener("open", handleOpen);
                    // previous versions of this library and walletlib incorrectly implemented the MWA session 
                    // establishment protocol for local connections. The dapp is supposed to wait for the 
                    // APP_PING message before sending the HELLO_REQ. Instead, the dapp was sending the HELLO_REQ 
                    // immediately upon connection to the websocket server regardless of wether or not an 
                    // APP_PING was sent by the wallet/websocket server. We must continue to support this behavior 
                    // in case the user is using a wallet that has not updated their walletlib implementation. 
                    const { associationKeypair: associationKeypair } = state;
                    const ecdhKeypair = yield $cc0f3ff54fb9e626$var$generateECDHKeypair();
                    socket.send((yield $cc0f3ff54fb9e626$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey)));
                    state = {
                        __type: "hello_req_sent",
                        associationPublicKey: associationKeypair.publicKey,
                        ecdhPrivateKey: ecdhKeypair.privateKey
                    };
                });
            const handleClose = (evt)=>{
                if (evt.wasClean) state = {
                    __type: "disconnected"
                };
                else reject(new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The wallet session dropped unexpectedly (${evt.code}: ${evt.reason}).`, {
                    closeEvent: evt
                }));
                disposeSocket();
            };
            const handleError = (_evt)=>$cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                    disposeSocket();
                    if (Date.now() - connectionStartTime >= $cc0f3ff54fb9e626$var$WEBSOCKET_CONNECTION_CONFIG.timeoutMs) reject(new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_SESSION_TIMEOUT, `Failed to connect to the wallet websocket at ${websocketURL}.`));
                    else {
                        yield new Promise((resolve)=>{
                            const retryDelayMs = getNextRetryDelayMs();
                            retryWaitTimeoutId = window.setTimeout(resolve, retryDelayMs);
                        });
                        attemptSocketConnection();
                    }
                });
            const handleMessage = (evt)=>$cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                    const responseBuffer = yield evt.data.arrayBuffer();
                    switch(state.__type){
                        case "connecting":
                            if (responseBuffer.byteLength !== 0) throw new Error("Encountered unexpected message while connecting");
                            const ecdhKeypair = yield $cc0f3ff54fb9e626$var$generateECDHKeypair();
                            socket.send((yield $cc0f3ff54fb9e626$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey)));
                            state = {
                                __type: "hello_req_sent",
                                associationPublicKey: associationKeypair.publicKey,
                                ecdhPrivateKey: ecdhKeypair.privateKey
                            };
                            break;
                        case "connected":
                            try {
                                const sequenceNumberVector = responseBuffer.slice(0, $cc0f3ff54fb9e626$var$SEQUENCE_NUMBER_BYTES);
                                const sequenceNumber = $cc0f3ff54fb9e626$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                lastKnownInboundSequenceNumber = sequenceNumber;
                                const jsonRpcMessage = yield $cc0f3ff54fb9e626$var$decryptJsonRpcMessage(responseBuffer, state.sharedSecret);
                                const responsePromise = jsonRpcResponsePromises[jsonRpcMessage.id];
                                delete jsonRpcResponsePromises[jsonRpcMessage.id];
                                responsePromise.resolve(jsonRpcMessage.result);
                            } catch (e) {
                                if (e instanceof $cc0f3ff54fb9e626$export$58b788f937123c66) {
                                    const responsePromise = jsonRpcResponsePromises[e.jsonRpcMessageId];
                                    delete jsonRpcResponsePromises[e.jsonRpcMessageId];
                                    responsePromise.reject(e);
                                } else throw e;
                            }
                            break;
                        case "hello_req_sent":
                            {
                                // if we receive an APP_PING message (empty message), resend the HELLO_REQ (see above)
                                if (responseBuffer.byteLength === 0) {
                                    const ecdhKeypair = yield $cc0f3ff54fb9e626$var$generateECDHKeypair();
                                    socket.send((yield $cc0f3ff54fb9e626$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey)));
                                    state = {
                                        __type: "hello_req_sent",
                                        associationPublicKey: associationKeypair.publicKey,
                                        ecdhPrivateKey: ecdhKeypair.privateKey
                                    };
                                    break;
                                }
                                const sharedSecret = yield $cc0f3ff54fb9e626$var$parseHelloRsp(responseBuffer, state.associationPublicKey, state.ecdhPrivateKey);
                                const sessionPropertiesBuffer = responseBuffer.slice($cc0f3ff54fb9e626$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES);
                                const sessionProperties = sessionPropertiesBuffer.byteLength !== 0 ? yield (()=>$cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                                        const sequenceNumberVector = sessionPropertiesBuffer.slice(0, $cc0f3ff54fb9e626$var$SEQUENCE_NUMBER_BYTES);
                                        const sequenceNumber = $cc0f3ff54fb9e626$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                        if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                        lastKnownInboundSequenceNumber = sequenceNumber;
                                        return $cc0f3ff54fb9e626$var$parseSessionProps(sessionPropertiesBuffer, sharedSecret);
                                    }))() : {
                                    protocol_version: "legacy"
                                };
                                state = {
                                    __type: "connected",
                                    sharedSecret: sharedSecret,
                                    sessionProperties: sessionProperties
                                };
                                const wallet = $cc0f3ff54fb9e626$var$createMobileWalletProxy(sessionProperties.protocol_version, (method, params)=>$cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                                        const id = nextJsonRpcMessageId++;
                                        socket.send((yield $cc0f3ff54fb9e626$var$encryptJsonRpcMessage({
                                            id: id,
                                            jsonrpc: "2.0",
                                            method: method,
                                            params: params !== null && params !== void 0 ? params : {}
                                        }, sharedSecret)));
                                        return new Promise((resolve, reject)=>{
                                            jsonRpcResponsePromises[id] = {
                                                resolve (result) {
                                                    switch(method){
                                                        case "authorize":
                                                        case "reauthorize":
                                                            {
                                                                const { wallet_uri_base: wallet_uri_base } = result;
                                                                if (wallet_uri_base != null) try {
                                                                    $cc0f3ff54fb9e626$var$assertSecureEndpointSpecificURI(wallet_uri_base);
                                                                } catch (e) {
                                                                    reject(e);
                                                                    return;
                                                                }
                                                                break;
                                                            }
                                                    }
                                                    resolve(result);
                                                },
                                                reject: reject
                                            };
                                        });
                                    }));
                                try {
                                    resolve((yield callback(wallet)));
                                } catch (e) {
                                    reject(e);
                                } finally{
                                    disposeSocket();
                                    socket.close();
                                }
                                break;
                            }
                    }
                });
            let disposeSocket;
            let retryWaitTimeoutId;
            const attemptSocketConnection = ()=>{
                if (disposeSocket) disposeSocket();
                state = {
                    __type: "connecting",
                    associationKeypair: associationKeypair
                };
                if (connectionStartTime === undefined) connectionStartTime = Date.now();
                socket = new WebSocket(websocketURL, [
                    $cc0f3ff54fb9e626$var$WEBSOCKET_PROTOCOL
                ]);
                socket.addEventListener("open", handleOpen);
                socket.addEventListener("close", handleClose);
                socket.addEventListener("error", handleError);
                socket.addEventListener("message", handleMessage);
                disposeSocket = ()=>{
                    window.clearTimeout(retryWaitTimeoutId);
                    socket.removeEventListener("open", handleOpen);
                    socket.removeEventListener("close", handleClose);
                    socket.removeEventListener("error", handleError);
                    socket.removeEventListener("message", handleMessage);
                };
            };
            attemptSocketConnection();
        });
    });
}
function $cc0f3ff54fb9e626$export$27dc3ad82cd9eb4f(callback, config) {
    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
        $cc0f3ff54fb9e626$var$assertSecureContext();
        const associationKeypair = yield $cc0f3ff54fb9e626$var$generateAssociationKeypair();
        const { associationUrl: associationUrl, reflectorId: reflectorId } = yield $cc0f3ff54fb9e626$var$getRemoteSessionUrl(associationKeypair.publicKey, config.remoteHostAuthority, config === null || config === void 0 ? void 0 : config.baseUri);
        const websocketURL = `wss://${config === null || config === void 0 ? void 0 : config.remoteHostAuthority}/reflect?id=${reflectorId}`;
        let connectionStartTime;
        const getNextRetryDelayMs = (()=>{
            const schedule = [
                ...$cc0f3ff54fb9e626$var$WEBSOCKET_CONNECTION_CONFIG.retryDelayScheduleMs
            ];
            return ()=>schedule.length > 1 ? schedule.shift() : schedule[0];
        })();
        let nextJsonRpcMessageId = 1;
        let lastKnownInboundSequenceNumber = 0;
        let state = {
            __type: "disconnected"
        };
        return {
            associationUrl: associationUrl,
            result: new Promise((resolve, reject)=>{
                let socket;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const jsonRpcResponsePromises = {};
                const handleOpen = ()=>$cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                        if (state.__type !== "connecting") {
                            console.warn("Expected adapter state to be `connecting` at the moment the websocket opens. " + `Got \`${state.__type}\`.`);
                            return;
                        }
                        socket.removeEventListener("open", handleOpen);
                    });
                const handleClose = (evt)=>{
                    if (evt.wasClean) state = {
                        __type: "disconnected"
                    };
                    else reject(new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The wallet session dropped unexpectedly (${evt.code}: ${evt.reason}).`, {
                        closeEvent: evt
                    }));
                    disposeSocket();
                };
                const handleError = (_evt)=>$cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                        disposeSocket();
                        if (Date.now() - connectionStartTime >= $cc0f3ff54fb9e626$var$WEBSOCKET_CONNECTION_CONFIG.timeoutMs) reject(new $cc0f3ff54fb9e626$export$d77545679c409b63($cc0f3ff54fb9e626$export$93083e877aec7a8a.ERROR_SESSION_TIMEOUT, `Failed to connect to the wallet websocket at ${websocketURL}.`));
                        else {
                            yield new Promise((resolve)=>{
                                const retryDelayMs = getNextRetryDelayMs();
                                retryWaitTimeoutId = window.setTimeout(resolve, retryDelayMs);
                            });
                            attemptSocketConnection();
                        }
                    });
                const handleMessage = (evt)=>$cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                        const responseBuffer = yield evt.data.arrayBuffer();
                        switch(state.__type){
                            case "connecting":
                                if (responseBuffer.byteLength !== 0) throw new Error("Encountered unexpected message while connecting");
                                const ecdhKeypair = yield $cc0f3ff54fb9e626$var$generateECDHKeypair();
                                socket.send((yield $cc0f3ff54fb9e626$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey)));
                                state = {
                                    __type: "hello_req_sent",
                                    associationPublicKey: associationKeypair.publicKey,
                                    ecdhPrivateKey: ecdhKeypair.privateKey
                                };
                                break;
                            case "connected":
                                try {
                                    const sequenceNumberVector = responseBuffer.slice(0, $cc0f3ff54fb9e626$var$SEQUENCE_NUMBER_BYTES);
                                    const sequenceNumber = $cc0f3ff54fb9e626$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                    if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                    lastKnownInboundSequenceNumber = sequenceNumber;
                                    const jsonRpcMessage = yield $cc0f3ff54fb9e626$var$decryptJsonRpcMessage(responseBuffer, state.sharedSecret);
                                    const responsePromise = jsonRpcResponsePromises[jsonRpcMessage.id];
                                    delete jsonRpcResponsePromises[jsonRpcMessage.id];
                                    responsePromise.resolve(jsonRpcMessage.result);
                                } catch (e) {
                                    if (e instanceof $cc0f3ff54fb9e626$export$58b788f937123c66) {
                                        const responsePromise = jsonRpcResponsePromises[e.jsonRpcMessageId];
                                        delete jsonRpcResponsePromises[e.jsonRpcMessageId];
                                        responsePromise.reject(e);
                                    } else throw e;
                                }
                                break;
                            case "hello_req_sent":
                                {
                                    const sharedSecret = yield $cc0f3ff54fb9e626$var$parseHelloRsp(responseBuffer, state.associationPublicKey, state.ecdhPrivateKey);
                                    const sessionPropertiesBuffer = responseBuffer.slice($cc0f3ff54fb9e626$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES);
                                    const sessionProperties = sessionPropertiesBuffer.byteLength !== 0 ? yield (()=>$cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                                            const sequenceNumberVector = sessionPropertiesBuffer.slice(0, $cc0f3ff54fb9e626$var$SEQUENCE_NUMBER_BYTES);
                                            const sequenceNumber = $cc0f3ff54fb9e626$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                            if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                            lastKnownInboundSequenceNumber = sequenceNumber;
                                            return $cc0f3ff54fb9e626$var$parseSessionProps(sessionPropertiesBuffer, sharedSecret);
                                        }))() : {
                                        protocol_version: "legacy"
                                    };
                                    state = {
                                        __type: "connected",
                                        sharedSecret: sharedSecret,
                                        sessionProperties: sessionProperties
                                    };
                                    const wallet = $cc0f3ff54fb9e626$var$createMobileWalletProxy(sessionProperties.protocol_version, (method, params)=>$cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                                            const id = nextJsonRpcMessageId++;
                                            socket.send((yield $cc0f3ff54fb9e626$var$encryptJsonRpcMessage({
                                                id: id,
                                                jsonrpc: "2.0",
                                                method: method,
                                                params: params !== null && params !== void 0 ? params : {}
                                            }, sharedSecret)));
                                            return new Promise((resolve, reject)=>{
                                                jsonRpcResponsePromises[id] = {
                                                    resolve (result) {
                                                        switch(method){
                                                            case "authorize":
                                                            case "reauthorize":
                                                                {
                                                                    const { wallet_uri_base: wallet_uri_base } = result;
                                                                    if (wallet_uri_base != null) try {
                                                                        $cc0f3ff54fb9e626$var$assertSecureEndpointSpecificURI(wallet_uri_base);
                                                                    } catch (e) {
                                                                        reject(e);
                                                                        return;
                                                                    }
                                                                    break;
                                                                }
                                                        }
                                                        resolve(result);
                                                    },
                                                    reject: reject
                                                };
                                            });
                                        }));
                                    try {
                                        resolve((yield callback(new Proxy(wallet, {
                                            get (target, p) {
                                                if (p == "terminateSession") return function() {
                                                    return $cc0f3ff54fb9e626$var$__awaiter(this, void 0, void 0, function*() {
                                                        disposeSocket();
                                                        socket.close();
                                                        return;
                                                    });
                                                };
                                                else return target[p];
                                            }
                                        }))));
                                    } catch (e) {
                                        reject(e);
                                    }
                                    break;
                                }
                        }
                    });
                let disposeSocket;
                let retryWaitTimeoutId;
                const attemptSocketConnection = ()=>{
                    if (disposeSocket) disposeSocket();
                    state = {
                        __type: "connecting",
                        associationKeypair: associationKeypair
                    };
                    if (connectionStartTime === undefined) connectionStartTime = Date.now();
                    socket = new WebSocket(websocketURL, [
                        $cc0f3ff54fb9e626$var$WEBSOCKET_PROTOCOL
                    ]);
                    socket.addEventListener("open", handleOpen);
                    socket.addEventListener("close", handleClose);
                    socket.addEventListener("error", handleError);
                    socket.addEventListener("message", handleMessage);
                    disposeSocket = ()=>{
                        window.clearTimeout(retryWaitTimeoutId);
                        socket.removeEventListener("open", handleOpen);
                        socket.removeEventListener("close", handleClose);
                        socket.removeEventListener("error", handleError);
                        socket.removeEventListener("message", handleMessage);
                    };
                };
                attemptSocketConnection();
            })
        };
    });
}



var $gJbOl = parcelRequire("gJbOl");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $df7eaa54a4ba06d2$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $df7eaa54a4ba06d2$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $df7eaa54a4ba06d2$var$fromUint8Array(byteArray) {
    return window.btoa(String.fromCharCode.call(null, ...byteArray));
}
function $df7eaa54a4ba06d2$var$toUint8Array(base64EncodedByteArray) {
    return new Uint8Array(window.atob(base64EncodedByteArray).split("").map((c)=>c.charCodeAt(0)));
}
function $df7eaa54a4ba06d2$var$getPayloadFromTransaction(transaction) {
    const serializedTransaction = "version" in transaction ? transaction.serialize() : transaction.serialize({
        requireAllSignatures: false,
        verifySignatures: false
    });
    const payload = $df7eaa54a4ba06d2$var$fromUint8Array(serializedTransaction);
    return payload;
}
function $df7eaa54a4ba06d2$var$getTransactionFromWireMessage(byteArray) {
    const numSignatures = byteArray[0];
    const messageOffset = numSignatures * (0, $1ZJZa.SIGNATURE_LENGTH_IN_BYTES) + 1;
    const version = (0, $1ZJZa.VersionedMessage).deserializeMessageVersion(byteArray.slice(messageOffset, byteArray.length));
    if (version === "legacy") return (0, $1ZJZa.Transaction).from(byteArray);
    else return (0, $1ZJZa.VersionedTransaction).deserialize(byteArray);
}
function $df7eaa54a4ba06d2$export$dac1bad6146b2469(callback, config) {
    return $df7eaa54a4ba06d2$var$__awaiter(this, void 0, void 0, function*() {
        const augmentedCallback = (wallet)=>{
            const augmentedAPI = new Proxy({}, {
                get (target, p) {
                    if (target[p] == null) switch(p){
                        case "signAndSendTransactions":
                            target[p] = function(_a) {
                                var { minContextSlot: minContextSlot, commitment: commitment, skipPreflight: skipPreflight, maxRetries: maxRetries, waitForCommitmentToSendNextTransaction: waitForCommitmentToSendNextTransaction, transactions: transactions } = _a, rest = $df7eaa54a4ba06d2$var$__rest(_a, [
                                    "minContextSlot",
                                    "commitment",
                                    "skipPreflight",
                                    "maxRetries",
                                    "waitForCommitmentToSendNextTransaction",
                                    "transactions"
                                ]);
                                return $df7eaa54a4ba06d2$var$__awaiter(this, void 0, void 0, function*() {
                                    const payloads = transactions.map($df7eaa54a4ba06d2$var$getPayloadFromTransaction);
                                    const options = {
                                        min_context_slot: minContextSlot,
                                        commitment: commitment,
                                        skip_preflight: skipPreflight,
                                        max_retries: maxRetries,
                                        wait_for_commitment_to_send_next_transaction: waitForCommitmentToSendNextTransaction
                                    };
                                    const { signatures: base64EncodedSignatures } = yield wallet.signAndSendTransactions(Object.assign(Object.assign(Object.assign({}, rest), Object.values(options).some((element)=>element != null) ? {
                                        options: options
                                    } : null), {
                                        payloads: payloads
                                    }));
                                    const signatures = base64EncodedSignatures.map($df7eaa54a4ba06d2$var$toUint8Array).map((0, (/*@__PURE__*/$parcel$interopDefault($gJbOl))).encode);
                                    return signatures;
                                });
                            };
                            break;
                        case "signMessages":
                            target[p] = function(_a) {
                                var { payloads: payloads } = _a, rest = $df7eaa54a4ba06d2$var$__rest(_a, [
                                    "payloads"
                                ]);
                                return $df7eaa54a4ba06d2$var$__awaiter(this, void 0, void 0, function*() {
                                    const base64EncodedPayloads = payloads.map($df7eaa54a4ba06d2$var$fromUint8Array);
                                    const { signed_payloads: base64EncodedSignedMessages } = yield wallet.signMessages(Object.assign(Object.assign({}, rest), {
                                        payloads: base64EncodedPayloads
                                    }));
                                    const signedMessages = base64EncodedSignedMessages.map($df7eaa54a4ba06d2$var$toUint8Array);
                                    return signedMessages;
                                });
                            };
                            break;
                        case "signTransactions":
                            target[p] = function(_a) {
                                var { transactions: transactions } = _a, rest = $df7eaa54a4ba06d2$var$__rest(_a, [
                                    "transactions"
                                ]);
                                return $df7eaa54a4ba06d2$var$__awaiter(this, void 0, void 0, function*() {
                                    const payloads = transactions.map($df7eaa54a4ba06d2$var$getPayloadFromTransaction);
                                    const { signed_payloads: base64EncodedCompiledTransactions } = yield wallet.signTransactions(Object.assign(Object.assign({}, rest), {
                                        payloads: payloads
                                    }));
                                    const compiledTransactions = base64EncodedCompiledTransactions.map($df7eaa54a4ba06d2$var$toUint8Array);
                                    const signedTransactions = compiledTransactions.map($df7eaa54a4ba06d2$var$getTransactionFromWireMessage);
                                    return signedTransactions;
                                });
                            };
                            break;
                        default:
                            target[p] = wallet[p];
                            break;
                    }
                    return target[p];
                },
                defineProperty () {
                    return false;
                },
                deleteProperty () {
                    return false;
                }
            });
            return callback(augmentedAPI);
        };
        return yield (0, $cc0f3ff54fb9e626$export$dac1bad6146b2469)(augmentedCallback, config);
    });
}
function $df7eaa54a4ba06d2$export$27dc3ad82cd9eb4f(callback, config) {
    return $df7eaa54a4ba06d2$var$__awaiter(this, void 0, void 0, function*() {
        const augmentedCallback = (wallet)=>{
            const augmentedAPI = new Proxy({}, {
                get (target, p) {
                    if (target[p] == null) switch(p){
                        case "signAndSendTransactions":
                            target[p] = function(_a) {
                                var { minContextSlot: minContextSlot, commitment: commitment, skipPreflight: skipPreflight, maxRetries: maxRetries, waitForCommitmentToSendNextTransaction: waitForCommitmentToSendNextTransaction, transactions: transactions } = _a, rest = $df7eaa54a4ba06d2$var$__rest(_a, [
                                    "minContextSlot",
                                    "commitment",
                                    "skipPreflight",
                                    "maxRetries",
                                    "waitForCommitmentToSendNextTransaction",
                                    "transactions"
                                ]);
                                return $df7eaa54a4ba06d2$var$__awaiter(this, void 0, void 0, function*() {
                                    const payloads = transactions.map($df7eaa54a4ba06d2$var$getPayloadFromTransaction);
                                    const options = {
                                        min_context_slot: minContextSlot,
                                        commitment: commitment,
                                        skip_preflight: skipPreflight,
                                        max_retries: maxRetries,
                                        wait_for_commitment_to_send_next_transaction: waitForCommitmentToSendNextTransaction
                                    };
                                    const { signatures: base64EncodedSignatures } = yield wallet.signAndSendTransactions(Object.assign(Object.assign(Object.assign({}, rest), Object.values(options).some((element)=>element != null) ? {
                                        options: options
                                    } : null), {
                                        payloads: payloads
                                    }));
                                    const signatures = base64EncodedSignatures.map($df7eaa54a4ba06d2$var$toUint8Array).map((0, (/*@__PURE__*/$parcel$interopDefault($gJbOl))).encode);
                                    return signatures;
                                });
                            };
                            break;
                        case "signMessages":
                            target[p] = function(_a) {
                                var { payloads: payloads } = _a, rest = $df7eaa54a4ba06d2$var$__rest(_a, [
                                    "payloads"
                                ]);
                                return $df7eaa54a4ba06d2$var$__awaiter(this, void 0, void 0, function*() {
                                    const base64EncodedPayloads = payloads.map($df7eaa54a4ba06d2$var$fromUint8Array);
                                    const { signed_payloads: base64EncodedSignedMessages } = yield wallet.signMessages(Object.assign(Object.assign({}, rest), {
                                        payloads: base64EncodedPayloads
                                    }));
                                    const signedMessages = base64EncodedSignedMessages.map($df7eaa54a4ba06d2$var$toUint8Array);
                                    return signedMessages;
                                });
                            };
                            break;
                        case "signTransactions":
                            target[p] = function(_a) {
                                var { transactions: transactions } = _a, rest = $df7eaa54a4ba06d2$var$__rest(_a, [
                                    "transactions"
                                ]);
                                return $df7eaa54a4ba06d2$var$__awaiter(this, void 0, void 0, function*() {
                                    const payloads = transactions.map($df7eaa54a4ba06d2$var$getPayloadFromTransaction);
                                    const { signed_payloads: base64EncodedCompiledTransactions } = yield wallet.signTransactions(Object.assign(Object.assign({}, rest), {
                                        payloads: payloads
                                    }));
                                    const compiledTransactions = base64EncodedCompiledTransactions.map($df7eaa54a4ba06d2$var$toUint8Array);
                                    const signedTransactions = compiledTransactions.map($df7eaa54a4ba06d2$var$getTransactionFromWireMessage);
                                    return signedTransactions;
                                });
                            };
                            break;
                        default:
                            target[p] = wallet[p];
                            break;
                    }
                    return target[p];
                },
                defineProperty () {
                    return false;
                },
                deleteProperty () {
                    return false;
                }
            });
            return callback(augmentedAPI);
        };
        return yield (0, $cc0f3ff54fb9e626$export$27dc3ad82cd9eb4f)(augmentedCallback, config);
    });
}


var $2e96213cb0651c6d$exports = {};

$parcel$export($2e96213cb0651c6d$exports, "create", function () { return $2e96213cb0651c6d$export$185802fd694ee1f5; }, function (v) { return $2e96213cb0651c6d$export$185802fd694ee1f5 = v; });
$parcel$export($2e96213cb0651c6d$exports, "toCanvas", function () { return $2e96213cb0651c6d$export$f87f6982d1fd4f81; }, function (v) { return $2e96213cb0651c6d$export$f87f6982d1fd4f81 = v; });
$parcel$export($2e96213cb0651c6d$exports, "toDataURL", function () { return $2e96213cb0651c6d$export$723e4939e5a27c8; }, function (v) { return $2e96213cb0651c6d$export$723e4939e5a27c8 = v; });
$parcel$export($2e96213cb0651c6d$exports, "toString", function () { return $2e96213cb0651c6d$export$f84e8e69fd4488a5; }, function (v) { return $2e96213cb0651c6d$export$f84e8e69fd4488a5 = v; });
var $2e96213cb0651c6d$export$185802fd694ee1f5;
var $2e96213cb0651c6d$export$f87f6982d1fd4f81;
var $2e96213cb0651c6d$export$723e4939e5a27c8;
// only svg for now.
var $2e96213cb0651c6d$export$f84e8e69fd4488a5;
var $ca8f051e4f35fa17$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$ca8f051e4f35fa17$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $f5ae6034154ff0d0$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $1d513d13ed56457a$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $1d513d13ed56457a$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $1d513d13ed56457a$export$ed1d66da50968976;
var $1d513d13ed56457a$export$6733b14783f975c2;
var $1d513d13ed56457a$export$ce5b1274f8597fa0;
var $1d513d13ed56457a$export$43dd553ecded716d;
let $1d513d13ed56457a$var$toSJISFunction;
const $1d513d13ed56457a$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$1d513d13ed56457a$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$1d513d13ed56457a$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $1d513d13ed56457a$var$CODEWORDS_COUNT[version];
};
$1d513d13ed56457a$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$1d513d13ed56457a$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $1d513d13ed56457a$var$toSJISFunction = f;
};
$1d513d13ed56457a$export$ce5b1274f8597fa0 = function() {
    return typeof $1d513d13ed56457a$var$toSJISFunction !== "undefined";
};
$1d513d13ed56457a$export$43dd553ecded716d = function toSJIS(kanji) {
    return $1d513d13ed56457a$var$toSJISFunction(kanji);
};


var $6ea8f090962318e9$export$61196ced6d74a310;
var $6ea8f090962318e9$export$3a1a48c8f6ef640e;
var $6ea8f090962318e9$export$3722cfe417b6ed86;
var $6ea8f090962318e9$export$7f8ddf7c7c20b3cd;
var $6ea8f090962318e9$export$1ea939691cdc45b8;
var $6ea8f090962318e9$export$6788812c4e6611e6;
$6ea8f090962318e9$export$61196ced6d74a310 = {
    bit: 1
};
$6ea8f090962318e9$export$3a1a48c8f6ef640e = {
    bit: 0
};
$6ea8f090962318e9$export$3722cfe417b6ed86 = {
    bit: 3
};
$6ea8f090962318e9$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $6ea8f090962318e9$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $6ea8f090962318e9$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $6ea8f090962318e9$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $6ea8f090962318e9$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $6ea8f090962318e9$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$6ea8f090962318e9$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$6ea8f090962318e9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($6ea8f090962318e9$export$1ea939691cdc45b8(value)) return value;
    try {
        return $6ea8f090962318e9$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $c17cae5401366d04$exports = {};
function $c17cae5401366d04$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$c17cae5401366d04$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$c17cae5401366d04$exports = $c17cae5401366d04$var$BitBuffer;


var $125b752a8d9cdc49$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $125b752a8d9cdc49$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $125b752a8d9cdc49$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $125b752a8d9cdc49$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $125b752a8d9cdc49$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $125b752a8d9cdc49$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$125b752a8d9cdc49$exports = $125b752a8d9cdc49$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $fc13d96ed5227aa0$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $fc13d96ed5227aa0$export$c39457c570f2b189;

var $fc13d96ed5227aa0$require$getSymbolSize = $1d513d13ed56457a$export$8d4a06d3facd414b;
$fc13d96ed5227aa0$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $fc13d96ed5227aa0$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$fc13d96ed5227aa0$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $fc13d96ed5227aa0$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $efdcff49e77a086e$export$c39457c570f2b189;

var $efdcff49e77a086e$require$getSymbolSize = $1d513d13ed56457a$export$8d4a06d3facd414b;
const $efdcff49e77a086e$var$FINDER_PATTERN_SIZE = 7;
$efdcff49e77a086e$export$c39457c570f2b189 = function getPositions(version) {
    const size = $efdcff49e77a086e$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $efdcff49e77a086e$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $efdcff49e77a086e$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $82181dd07cc2568b$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $82181dd07cc2568b$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $82181dd07cc2568b$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $82181dd07cc2568b$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $82181dd07cc2568b$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $82181dd07cc2568b$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $82181dd07cc2568b$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $82181dd07cc2568b$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $82181dd07cc2568b$export$fe9625aaceb0e563;
$82181dd07cc2568b$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $82181dd07cc2568b$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$82181dd07cc2568b$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$82181dd07cc2568b$export$6788812c4e6611e6 = function from(value) {
    return $82181dd07cc2568b$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$82181dd07cc2568b$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $82181dd07cc2568b$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $82181dd07cc2568b$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $82181dd07cc2568b$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $82181dd07cc2568b$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$82181dd07cc2568b$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $82181dd07cc2568b$var$PenaltyScores.N2;
};
$82181dd07cc2568b$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $82181dd07cc2568b$var$PenaltyScores.N3;
};
$82181dd07cc2568b$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $82181dd07cc2568b$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $82181dd07cc2568b$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $82181dd07cc2568b$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $82181dd07cc2568b$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $82181dd07cc2568b$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $82181dd07cc2568b$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $82181dd07cc2568b$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $82181dd07cc2568b$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $82181dd07cc2568b$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $82181dd07cc2568b$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$82181dd07cc2568b$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $82181dd07cc2568b$var$getMaskAt(pattern, row, col));
    }
};
$82181dd07cc2568b$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($82181dd07cc2568b$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $82181dd07cc2568b$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $82181dd07cc2568b$export$a5fd3a02c14d0b3e(data) + $82181dd07cc2568b$export$9a9385107a518e46(data) + $82181dd07cc2568b$export$ade754353f0dc75e(data) + $82181dd07cc2568b$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $82181dd07cc2568b$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $bd589dee38e758e5$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $bd589dee38e758e5$export$683d1b3e8a1a8438;

const $bd589dee38e758e5$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $bd589dee38e758e5$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$bd589dee38e758e5$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $6ea8f090962318e9$export$61196ced6d74a310:
            return $bd589dee38e758e5$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $6ea8f090962318e9$export$3a1a48c8f6ef640e:
            return $bd589dee38e758e5$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $6ea8f090962318e9$export$3722cfe417b6ed86:
            return $bd589dee38e758e5$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $6ea8f090962318e9$export$7f8ddf7c7c20b3cd:
            return $bd589dee38e758e5$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$bd589dee38e758e5$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $6ea8f090962318e9$export$61196ced6d74a310:
            return $bd589dee38e758e5$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $6ea8f090962318e9$export$3a1a48c8f6ef640e:
            return $bd589dee38e758e5$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $6ea8f090962318e9$export$3722cfe417b6ed86:
            return $bd589dee38e758e5$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $6ea8f090962318e9$export$7f8ddf7c7c20b3cd:
            return $bd589dee38e758e5$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $128deab23cadcf86$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $523c36354cc839e5$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $523c36354cc839e5$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $523c36354cc839e5$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $2e7b31300f26d18f$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $2e7b31300f26d18f$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $2e7b31300f26d18f$export$6e3a27864ab166fe;
const $2e7b31300f26d18f$var$EXP_TABLE = new Uint8Array(512);
const $2e7b31300f26d18f$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $2e7b31300f26d18f$var$EXP_TABLE[i] = x;
        $2e7b31300f26d18f$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$2e7b31300f26d18f$var$EXP_TABLE[i] = $2e7b31300f26d18f$var$EXP_TABLE[i - 255];
})();
$2e7b31300f26d18f$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $2e7b31300f26d18f$var$LOG_TABLE[n];
};
$2e7b31300f26d18f$export$b310ec824aaee37f = function exp(n) {
    return $2e7b31300f26d18f$var$EXP_TABLE[n];
};
$2e7b31300f26d18f$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $2e7b31300f26d18f$var$EXP_TABLE[$2e7b31300f26d18f$var$LOG_TABLE[x] + $2e7b31300f26d18f$var$LOG_TABLE[y]];
};


$523c36354cc839e5$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $2e7b31300f26d18f$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$523c36354cc839e5$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $2e7b31300f26d18f$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$523c36354cc839e5$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $523c36354cc839e5$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $2e7b31300f26d18f$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $128deab23cadcf86$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $128deab23cadcf86$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $523c36354cc839e5$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $128deab23cadcf86$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $523c36354cc839e5$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$128deab23cadcf86$exports = $128deab23cadcf86$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $360343f423df1cff$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $360343f423df1cff$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $360343f423df1cff$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $360343f423df1cff$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $e8d82a1d892e4d16$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $e8d82a1d892e4d16$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $e8d82a1d892e4d16$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $e8d82a1d892e4d16$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $e8d82a1d892e4d16$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $e8d82a1d892e4d16$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $e8d82a1d892e4d16$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $e8d82a1d892e4d16$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $e8d82a1d892e4d16$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $e8d82a1d892e4d16$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $835defdafdefd1d1$export$1ea939691cdc45b8;
$835defdafdefd1d1$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $d5f7f04a9851b474$export$a4d452c2363c8e12;
var $d5f7f04a9851b474$export$9df7c29d562bab83;
var $d5f7f04a9851b474$export$8f4bf8f7eb581284;
var $d5f7f04a9851b474$export$4d318981b5a83836;
var $d5f7f04a9851b474$export$376a9ed239d6c1c8;
var $d5f7f04a9851b474$export$175f16aef75a4569;
var $d5f7f04a9851b474$export$50b7f9bf92c74274;
var $d5f7f04a9851b474$export$4ba5f52893b4ac97;
const $d5f7f04a9851b474$var$numeric = "[0-9]+";
const $d5f7f04a9851b474$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $d5f7f04a9851b474$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d5f7f04a9851b474$var$kanji = $d5f7f04a9851b474$var$kanji.replace(/u/g, "\\u");
const $d5f7f04a9851b474$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $d5f7f04a9851b474$var$kanji + ")(?:.|[\r\n]))+";
$d5f7f04a9851b474$export$a4d452c2363c8e12 = new RegExp($d5f7f04a9851b474$var$kanji, "g");
$d5f7f04a9851b474$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$d5f7f04a9851b474$export$8f4bf8f7eb581284 = new RegExp($d5f7f04a9851b474$var$byte, "g");
$d5f7f04a9851b474$export$4d318981b5a83836 = new RegExp($d5f7f04a9851b474$var$numeric, "g");
$d5f7f04a9851b474$export$376a9ed239d6c1c8 = new RegExp($d5f7f04a9851b474$var$alphanumeric, "g");
const $d5f7f04a9851b474$var$TEST_KANJI = new RegExp("^" + $d5f7f04a9851b474$var$kanji + "$");
const $d5f7f04a9851b474$var$TEST_NUMERIC = new RegExp("^" + $d5f7f04a9851b474$var$numeric + "$");
const $d5f7f04a9851b474$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$d5f7f04a9851b474$export$175f16aef75a4569 = function testKanji(str) {
    return $d5f7f04a9851b474$var$TEST_KANJI.test(str);
};
$d5f7f04a9851b474$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d5f7f04a9851b474$var$TEST_NUMERIC.test(str);
};
$d5f7f04a9851b474$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d5f7f04a9851b474$var$TEST_ALPHANUMERIC.test(str);
};


$e8d82a1d892e4d16$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$e8d82a1d892e4d16$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$e8d82a1d892e4d16$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$e8d82a1d892e4d16$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$e8d82a1d892e4d16$export$bb410559a65d3418 = {
    bit: -1
};
$e8d82a1d892e4d16$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$835defdafdefd1d1$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$e8d82a1d892e4d16$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($d5f7f04a9851b474$export$50b7f9bf92c74274(dataStr)) return $e8d82a1d892e4d16$export$4d318981b5a83836;
    else if ($d5f7f04a9851b474$export$4ba5f52893b4ac97(dataStr)) return $e8d82a1d892e4d16$export$376a9ed239d6c1c8;
    else if ($d5f7f04a9851b474$export$175f16aef75a4569(dataStr)) return $e8d82a1d892e4d16$export$a4d452c2363c8e12;
    else return $e8d82a1d892e4d16$export$8f4bf8f7eb581284;
};
$e8d82a1d892e4d16$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$e8d82a1d892e4d16$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $e8d82a1d892e4d16$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $e8d82a1d892e4d16$export$4d318981b5a83836;
        case "alphanumeric":
            return $e8d82a1d892e4d16$export$376a9ed239d6c1c8;
        case "kanji":
            return $e8d82a1d892e4d16$export$a4d452c2363c8e12;
        case "byte":
            return $e8d82a1d892e4d16$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$e8d82a1d892e4d16$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($e8d82a1d892e4d16$export$1ea939691cdc45b8(value)) return value;
    try {
        return $e8d82a1d892e4d16$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $360343f423df1cff$var$G18 = 7973;
const $360343f423df1cff$var$G18_BCH = $1d513d13ed56457a$export$ed1d66da50968976($360343f423df1cff$var$G18);
function $360343f423df1cff$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $360343f423df1cff$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $360343f423df1cff$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $e8d82a1d892e4d16$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $360343f423df1cff$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $360343f423df1cff$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $360343f423df1cff$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $360343f423df1cff$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $360343f423df1cff$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $e8d82a1d892e4d16$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$360343f423df1cff$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($835defdafdefd1d1$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$360343f423df1cff$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$835defdafdefd1d1$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $e8d82a1d892e4d16$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $1d513d13ed56457a$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $bd589dee38e758e5$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $e8d82a1d892e4d16$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $360343f423df1cff$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $e8d82a1d892e4d16$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $e8d82a1d892e4d16$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $e8d82a1d892e4d16$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $e8d82a1d892e4d16$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$360343f423df1cff$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $6ea8f090962318e9$export$6788812c4e6611e6(errorCorrectionLevel, $6ea8f090962318e9$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $360343f423df1cff$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $360343f423df1cff$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$360343f423df1cff$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$835defdafdefd1d1$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($1d513d13ed56457a$export$ed1d66da50968976(d) - $360343f423df1cff$var$G18_BCH >= 0)d ^= $360343f423df1cff$var$G18 << $1d513d13ed56457a$export$ed1d66da50968976(d) - $360343f423df1cff$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $b78d0f024b878e3b$export$eee5438974ef6f0e;

const $b78d0f024b878e3b$var$G15 = 1335;
const $b78d0f024b878e3b$var$G15_MASK = 21522;
const $b78d0f024b878e3b$var$G15_BCH = $1d513d13ed56457a$export$ed1d66da50968976($b78d0f024b878e3b$var$G15);
$b78d0f024b878e3b$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($1d513d13ed56457a$export$ed1d66da50968976(d) - $b78d0f024b878e3b$var$G15_BCH >= 0)d ^= $b78d0f024b878e3b$var$G15 << $1d513d13ed56457a$export$ed1d66da50968976(d) - $b78d0f024b878e3b$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $b78d0f024b878e3b$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $62d05eb3cd5bd89c$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $62d05eb3cd5bd89c$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $62d05eb3cd5bd89c$export$89ab1afb9839589b;

var $e041e9794c64e5f1$exports = {};

function $e041e9794c64e5f1$var$NumericData(data) {
    this.mode = $e8d82a1d892e4d16$export$4d318981b5a83836;
    this.data = data.toString();
}
$e041e9794c64e5f1$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$e041e9794c64e5f1$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$e041e9794c64e5f1$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $e041e9794c64e5f1$var$NumericData.getBitsLength(this.data.length);
};
$e041e9794c64e5f1$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$e041e9794c64e5f1$exports = $e041e9794c64e5f1$var$NumericData;


var $dc6792e650cb8d16$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $dc6792e650cb8d16$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $dc6792e650cb8d16$var$AlphanumericData(data) {
    this.mode = $e8d82a1d892e4d16$export$376a9ed239d6c1c8;
    this.data = data;
}
$dc6792e650cb8d16$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$dc6792e650cb8d16$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$dc6792e650cb8d16$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $dc6792e650cb8d16$var$AlphanumericData.getBitsLength(this.data.length);
};
$dc6792e650cb8d16$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $dc6792e650cb8d16$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $dc6792e650cb8d16$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($dc6792e650cb8d16$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$dc6792e650cb8d16$exports = $dc6792e650cb8d16$var$AlphanumericData;


var $4f21bd6ba814d456$exports = {};

function $4f21bd6ba814d456$var$ByteData(data) {
    this.mode = $e8d82a1d892e4d16$export$8f4bf8f7eb581284;
    if (typeof data === "string") this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$4f21bd6ba814d456$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$4f21bd6ba814d456$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$4f21bd6ba814d456$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $4f21bd6ba814d456$var$ByteData.getBitsLength(this.data.length);
};
$4f21bd6ba814d456$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$4f21bd6ba814d456$exports = $4f21bd6ba814d456$var$ByteData;


var $18d1bcb0a5c7d835$exports = {};


function $18d1bcb0a5c7d835$var$KanjiData(data) {
    this.mode = $e8d82a1d892e4d16$export$a4d452c2363c8e12;
    this.data = data;
}
$18d1bcb0a5c7d835$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$18d1bcb0a5c7d835$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$18d1bcb0a5c7d835$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $18d1bcb0a5c7d835$var$KanjiData.getBitsLength(this.data.length);
};
$18d1bcb0a5c7d835$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $1d513d13ed56457a$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$18d1bcb0a5c7d835$exports = $18d1bcb0a5c7d835$var$KanjiData;





var $7hI6X = parcelRequire("7hI6X");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $62d05eb3cd5bd89c$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $62d05eb3cd5bd89c$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $62d05eb3cd5bd89c$var$getSegmentsFromString(dataStr) {
    const numSegs = $62d05eb3cd5bd89c$var$getSegments($d5f7f04a9851b474$export$4d318981b5a83836, $e8d82a1d892e4d16$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $62d05eb3cd5bd89c$var$getSegments($d5f7f04a9851b474$export$376a9ed239d6c1c8, $e8d82a1d892e4d16$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($1d513d13ed56457a$export$ce5b1274f8597fa0()) {
        byteSegs = $62d05eb3cd5bd89c$var$getSegments($d5f7f04a9851b474$export$8f4bf8f7eb581284, $e8d82a1d892e4d16$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $62d05eb3cd5bd89c$var$getSegments($d5f7f04a9851b474$export$a4d452c2363c8e12, $e8d82a1d892e4d16$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $62d05eb3cd5bd89c$var$getSegments($d5f7f04a9851b474$export$9df7c29d562bab83, $e8d82a1d892e4d16$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $62d05eb3cd5bd89c$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $e8d82a1d892e4d16$export$4d318981b5a83836:
            return $e041e9794c64e5f1$exports.getBitsLength(length);
        case $e8d82a1d892e4d16$export$376a9ed239d6c1c8:
            return $dc6792e650cb8d16$exports.getBitsLength(length);
        case $e8d82a1d892e4d16$export$a4d452c2363c8e12:
            return $18d1bcb0a5c7d835$exports.getBitsLength(length);
        case $e8d82a1d892e4d16$export$8f4bf8f7eb581284:
            return $4f21bd6ba814d456$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $62d05eb3cd5bd89c$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $62d05eb3cd5bd89c$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $e8d82a1d892e4d16$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $e8d82a1d892e4d16$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $e8d82a1d892e4d16$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $e8d82a1d892e4d16$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $e8d82a1d892e4d16$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $e8d82a1d892e4d16$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $e8d82a1d892e4d16$export$8f4bf8f7eb581284,
                        length: $62d05eb3cd5bd89c$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $e8d82a1d892e4d16$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $e8d82a1d892e4d16$export$8f4bf8f7eb581284,
                        length: $62d05eb3cd5bd89c$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $62d05eb3cd5bd89c$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $62d05eb3cd5bd89c$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $62d05eb3cd5bd89c$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $62d05eb3cd5bd89c$var$getSegmentBitsLength(node.length, node.mode) + 4 + $e8d82a1d892e4d16$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $62d05eb3cd5bd89c$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $e8d82a1d892e4d16$export$1bd4c93ffb42e55e(data);
    mode = $e8d82a1d892e4d16$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $e8d82a1d892e4d16$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $e8d82a1d892e4d16$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $e8d82a1d892e4d16$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $e8d82a1d892e4d16$export$a4d452c2363c8e12 && !$1d513d13ed56457a$export$ce5b1274f8597fa0()) mode = $e8d82a1d892e4d16$export$8f4bf8f7eb581284;
    switch(mode){
        case $e8d82a1d892e4d16$export$4d318981b5a83836:
            return new $e041e9794c64e5f1$exports(data);
        case $e8d82a1d892e4d16$export$376a9ed239d6c1c8:
            return new $dc6792e650cb8d16$exports(data);
        case $e8d82a1d892e4d16$export$a4d452c2363c8e12:
            return new $18d1bcb0a5c7d835$exports(data);
        case $e8d82a1d892e4d16$export$8f4bf8f7eb581284:
            return new $4f21bd6ba814d456$exports(data);
    }
}
$62d05eb3cd5bd89c$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($62d05eb3cd5bd89c$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($62d05eb3cd5bd89c$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$62d05eb3cd5bd89c$export$3004f64547af360e = function fromString(data, version) {
    const segs = $62d05eb3cd5bd89c$var$getSegmentsFromString(data, $1d513d13ed56457a$export$ce5b1274f8597fa0());
    const nodes = $62d05eb3cd5bd89c$var$buildNodes(segs);
    const graph = $62d05eb3cd5bd89c$var$buildGraph(nodes, version);
    const path = $7hI6X.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $62d05eb3cd5bd89c$export$571d59b505e6bb4e($62d05eb3cd5bd89c$var$mergeSegments(optimizedSegs));
};
$62d05eb3cd5bd89c$export$89ab1afb9839589b = function rawSplit(data) {
    return $62d05eb3cd5bd89c$export$571d59b505e6bb4e($62d05eb3cd5bd89c$var$getSegmentsFromString(data, $1d513d13ed56457a$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $f5ae6034154ff0d0$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $efdcff49e77a086e$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $f5ae6034154ff0d0$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $f5ae6034154ff0d0$var$setupAlignmentPattern(matrix, version) {
    const pos = $fc13d96ed5227aa0$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $f5ae6034154ff0d0$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $360343f423df1cff$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $f5ae6034154ff0d0$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $b78d0f024b878e3b$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $f5ae6034154ff0d0$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $f5ae6034154ff0d0$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $c17cae5401366d04$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $e8d82a1d892e4d16$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $1d513d13ed56457a$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $bd589dee38e758e5$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $f5ae6034154ff0d0$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $f5ae6034154ff0d0$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $1d513d13ed56457a$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $bd589dee38e758e5$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $bd589dee38e758e5$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $128deab23cadcf86$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $f5ae6034154ff0d0$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $62d05eb3cd5bd89c$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $62d05eb3cd5bd89c$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $360343f423df1cff$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $62d05eb3cd5bd89c$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $360343f423df1cff$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $f5ae6034154ff0d0$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $1d513d13ed56457a$export$8d4a06d3facd414b(version);
    const modules = new $125b752a8d9cdc49$exports(moduleCount);
    // Add function modules
    $f5ae6034154ff0d0$var$setupFinderPattern(modules, version);
    $f5ae6034154ff0d0$var$setupTimingPattern(modules);
    $f5ae6034154ff0d0$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $f5ae6034154ff0d0$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $f5ae6034154ff0d0$var$setupVersionInfo(modules, version);
    // Add data codewords
    $f5ae6034154ff0d0$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $82181dd07cc2568b$export$fe9625aaceb0e563(modules, $f5ae6034154ff0d0$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $82181dd07cc2568b$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $f5ae6034154ff0d0$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$f5ae6034154ff0d0$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $6ea8f090962318e9$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $6ea8f090962318e9$export$6788812c4e6611e6(options.errorCorrectionLevel, $6ea8f090962318e9$export$3a1a48c8f6ef640e);
        version = $360343f423df1cff$export$6788812c4e6611e6(options.version);
        mask = $82181dd07cc2568b$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $1d513d13ed56457a$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $f5ae6034154ff0d0$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $09a289ad9a1eeff2$export$b3890eb0ae9dca99;
var $09a289ad9a1eeff2$export$c3e5526bbaf70a25;
var $fef2eed8599b6c89$export$d2312e68e1f5ad00;
var $fef2eed8599b6c89$export$5cdac61cf538712e;
var $fef2eed8599b6c89$export$c3a1a1f268a8142b;
var $fef2eed8599b6c89$export$83136f57c739c5f3;
function $fef2eed8599b6c89$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$fef2eed8599b6c89$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $fef2eed8599b6c89$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $fef2eed8599b6c89$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$fef2eed8599b6c89$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$fef2eed8599b6c89$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $fef2eed8599b6c89$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$fef2eed8599b6c89$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $fef2eed8599b6c89$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $09a289ad9a1eeff2$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $09a289ad9a1eeff2$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$09a289ad9a1eeff2$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $09a289ad9a1eeff2$var$getCanvasElement();
    opts = $fef2eed8599b6c89$export$d2312e68e1f5ad00(opts);
    const size = $fef2eed8599b6c89$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $fef2eed8599b6c89$export$83136f57c739c5f3(image.data, qrData, opts);
    $09a289ad9a1eeff2$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$09a289ad9a1eeff2$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $09a289ad9a1eeff2$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $292ed64bd9c62430$export$b3890eb0ae9dca99;

function $292ed64bd9c62430$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $292ed64bd9c62430$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $292ed64bd9c62430$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $292ed64bd9c62430$var$svgCmd("M", col + margin, 0.5 + row + margin) : $292ed64bd9c62430$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $292ed64bd9c62430$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$292ed64bd9c62430$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $fef2eed8599b6c89$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $292ed64bd9c62430$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $292ed64bd9c62430$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $292ed64bd9c62430$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $2e96213cb0651c6d$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$ca8f051e4f35fa17$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $f5ae6034154ff0d0$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $f5ae6034154ff0d0$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$2e96213cb0651c6d$export$185802fd694ee1f5 = $f5ae6034154ff0d0$export$185802fd694ee1f5;
$2e96213cb0651c6d$export$f87f6982d1fd4f81 = $2e96213cb0651c6d$var$renderCanvas.bind(null, $09a289ad9a1eeff2$export$b3890eb0ae9dca99);
$2e96213cb0651c6d$export$723e4939e5a27c8 = $2e96213cb0651c6d$var$renderCanvas.bind(null, $09a289ad9a1eeff2$export$c3e5526bbaf70a25);
$2e96213cb0651c6d$export$f84e8e69fd4488a5 = $2e96213cb0651c6d$var$renderCanvas.bind(null, function(data, _, opts) {
    return $292ed64bd9c62430$export$b3890eb0ae9dca99(data, opts);
});


/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ 
var $jtAZT = parcelRequire("jtAZT");
var $28a84d06a3882c92$require$Buffer = $jtAZT.Buffer;
const $28a84d06a3882c92$export$83d89fbfd8236492 = "3.7.7";
/**
 * @deprecated use lowercase `version`.
 */ const $28a84d06a3882c92$export$a4ad2735b021c132 = $28a84d06a3882c92$export$83d89fbfd8236492;
const $28a84d06a3882c92$var$_hasBuffer = typeof $28a84d06a3882c92$require$Buffer === "function";
const $28a84d06a3882c92$var$_TD = typeof TextDecoder === "function" ? new TextDecoder() : undefined;
const $28a84d06a3882c92$var$_TE = typeof TextEncoder === "function" ? new TextEncoder() : undefined;
const $28a84d06a3882c92$var$b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const $28a84d06a3882c92$var$b64chs = Array.prototype.slice.call($28a84d06a3882c92$var$b64ch);
const $28a84d06a3882c92$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($28a84d06a3882c92$var$b64chs);
const $28a84d06a3882c92$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $28a84d06a3882c92$var$_fromCC = String.fromCharCode.bind(String);
const $28a84d06a3882c92$var$_U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $28a84d06a3882c92$var$_mkUriSafe = (src)=>src.replace(/=/g, "").replace(/[+\/]/g, (m0)=>m0 == "+" ? "-" : "_");
const $28a84d06a3882c92$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, "");
/**
 * polyfill version of `btoa`
 */ const $28a84d06a3882c92$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = "";
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $28a84d06a3882c92$var$b64chs[u32 >> 18 & 63] + $28a84d06a3882c92$var$b64chs[u32 >> 12 & 63] + $28a84d06a3882c92$var$b64chs[u32 >> 6 & 63] + $28a84d06a3882c92$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $28a84d06a3882c92$export$a32219e24f8d1e2 = typeof btoa === "function" ? (bin)=>btoa(bin) : $28a84d06a3882c92$var$_hasBuffer ? (bin)=>$28a84d06a3882c92$require$Buffer.from(bin, "binary").toString("base64") : $28a84d06a3882c92$export$ec0fb543302ee251;
const $28a84d06a3882c92$var$_fromUint8Array = $28a84d06a3882c92$var$_hasBuffer ? (u8a)=>$28a84d06a3882c92$require$Buffer.from(u8a).toString("base64") : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($28a84d06a3882c92$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $28a84d06a3882c92$export$a32219e24f8d1e2(strs.join(""));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $28a84d06a3882c92$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $28a84d06a3882c92$var$_mkUriSafe($28a84d06a3882c92$var$_fromUint8Array(u8a)) : $28a84d06a3882c92$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $28a84d06a3882c92$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $28a84d06a3882c92$var$_fromCC(0xc0 | cc >>> 6) + $28a84d06a3882c92$var$_fromCC(0x80 | cc & 0x3f) : $28a84d06a3882c92$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $28a84d06a3882c92$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $28a84d06a3882c92$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $28a84d06a3882c92$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $28a84d06a3882c92$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $28a84d06a3882c92$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $28a84d06a3882c92$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $28a84d06a3882c92$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $28a84d06a3882c92$export$10d4b9bd20a66b0 = (u)=>u.replace($28a84d06a3882c92$var$re_utob, $28a84d06a3882c92$var$cb_utob);
//
const $28a84d06a3882c92$var$_encode = $28a84d06a3882c92$var$_hasBuffer ? (s)=>$28a84d06a3882c92$require$Buffer.from(s, "utf8").toString("base64") : $28a84d06a3882c92$var$_TE ? (s)=>$28a84d06a3882c92$var$_fromUint8Array($28a84d06a3882c92$var$_TE.encode(s)) : (s)=>$28a84d06a3882c92$export$a32219e24f8d1e2($28a84d06a3882c92$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $28a84d06a3882c92$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $28a84d06a3882c92$var$_mkUriSafe($28a84d06a3882c92$var$_encode(src)) : $28a84d06a3882c92$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $28a84d06a3882c92$export$90c31d5baa78df44 = (src)=>$28a84d06a3882c92$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $28a84d06a3882c92$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $28a84d06a3882c92$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $28a84d06a3882c92$var$_fromCC((offset >>> 10) + 0xD800) + $28a84d06a3882c92$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $28a84d06a3882c92$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $28a84d06a3882c92$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $28a84d06a3882c92$export$67e9defdeac3dd95 = (b)=>b.replace($28a84d06a3882c92$var$re_btou, $28a84d06a3882c92$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $28a84d06a3882c92$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, "");
    if (!$28a84d06a3882c92$var$b64re.test(asc)) throw new TypeError("malformed base64.");
    asc += "==".slice(2 - (asc.length & 3));
    let u24, bin = "", r1, r2;
    for(let i = 0; i < asc.length;){
        u24 = $28a84d06a3882c92$var$b64tab[asc.charAt(i++)] << 18 | $28a84d06a3882c92$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $28a84d06a3882c92$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $28a84d06a3882c92$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $28a84d06a3882c92$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $28a84d06a3882c92$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $28a84d06a3882c92$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $28a84d06a3882c92$export$1406ac7a6dfd7b7a = typeof atob === "function" ? (asc)=>atob($28a84d06a3882c92$var$_tidyB64(asc)) : $28a84d06a3882c92$var$_hasBuffer ? (asc)=>$28a84d06a3882c92$require$Buffer.from(asc, "base64").toString("binary") : $28a84d06a3882c92$export$7f16d8e674ddec24;
//
const $28a84d06a3882c92$var$_toUint8Array = $28a84d06a3882c92$var$_hasBuffer ? (a)=>$28a84d06a3882c92$var$_U8Afrom($28a84d06a3882c92$require$Buffer.from(a, "base64")) : (a)=>$28a84d06a3882c92$var$_U8Afrom($28a84d06a3882c92$export$1406ac7a6dfd7b7a(a).split("").map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $28a84d06a3882c92$export$73470fd2221e6aef = (a)=>$28a84d06a3882c92$var$_toUint8Array($28a84d06a3882c92$var$_unURI(a));
//
const $28a84d06a3882c92$var$_decode = $28a84d06a3882c92$var$_hasBuffer ? (a)=>$28a84d06a3882c92$require$Buffer.from(a, "base64").toString("utf8") : $28a84d06a3882c92$var$_TD ? (a)=>$28a84d06a3882c92$var$_TD.decode($28a84d06a3882c92$var$_toUint8Array(a)) : (a)=>$28a84d06a3882c92$export$67e9defdeac3dd95($28a84d06a3882c92$export$1406ac7a6dfd7b7a(a));
const $28a84d06a3882c92$var$_unURI = (a)=>$28a84d06a3882c92$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == "-" ? "+" : "/"));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $28a84d06a3882c92$export$c537b38001c583b7 = (src)=>$28a84d06a3882c92$var$_decode($28a84d06a3882c92$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $28a84d06a3882c92$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== "string") return false;
    const s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $28a84d06a3882c92$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $28a84d06a3882c92$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $28a84d06a3882c92$var$_noEnum(body));
    _add("fromBase64", function() {
        return $28a84d06a3882c92$export$c537b38001c583b7(this);
    });
    _add("toBase64", function(urlsafe) {
        return $28a84d06a3882c92$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $28a84d06a3882c92$export$37cc283d8fbd3462(this, true);
    });
    _add("toBase64URL", function() {
        return $28a84d06a3882c92$export$37cc283d8fbd3462(this, true);
    });
    _add("toUint8Array", function() {
        return $28a84d06a3882c92$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $28a84d06a3882c92$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $28a84d06a3882c92$var$_noEnum(body));
    _add("toBase64", function(urlsafe) {
        return $28a84d06a3882c92$export$27bbb4e040978768(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $28a84d06a3882c92$export$27bbb4e040978768(this, true);
    });
    _add("toBase64URL", function() {
        return $28a84d06a3882c92$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $28a84d06a3882c92$export$1abf1fe5ebfd5245 = ()=>{
    $28a84d06a3882c92$export$4678ebf2295c49b();
    $28a84d06a3882c92$export$a105d6a15258bd2();
};
const $28a84d06a3882c92$export$f436b0c2107cbd35 = {
    version: $28a84d06a3882c92$export$83d89fbfd8236492,
    VERSION: $28a84d06a3882c92$export$a4ad2735b021c132,
    atob: $28a84d06a3882c92$export$1406ac7a6dfd7b7a,
    atobPolyfill: $28a84d06a3882c92$export$7f16d8e674ddec24,
    btoa: $28a84d06a3882c92$export$a32219e24f8d1e2,
    btoaPolyfill: $28a84d06a3882c92$export$ec0fb543302ee251,
    fromBase64: $28a84d06a3882c92$export$c537b38001c583b7,
    toBase64: $28a84d06a3882c92$export$37cc283d8fbd3462,
    encode: $28a84d06a3882c92$export$37cc283d8fbd3462,
    encodeURI: $28a84d06a3882c92$export$90c31d5baa78df44,
    encodeURL: $28a84d06a3882c92$export$90c31d5baa78df44,
    utob: $28a84d06a3882c92$export$10d4b9bd20a66b0,
    btou: $28a84d06a3882c92$export$67e9defdeac3dd95,
    decode: $28a84d06a3882c92$export$c537b38001c583b7,
    isValid: $28a84d06a3882c92$export$1ea939691cdc45b8,
    fromUint8Array: $28a84d06a3882c92$export$27bbb4e040978768,
    toUint8Array: $28a84d06a3882c92$export$73470fd2221e6aef,
    extendString: $28a84d06a3882c92$export$4678ebf2295c49b,
    extendUint8Array: $28a84d06a3882c92$export$a105d6a15258bd2,
    extendBuiltins: $28a84d06a3882c92$export$1abf1fe5ebfd5245
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $89727768601eecb3$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $89727768601eecb3$var$toUint8Array(base64EncodedByteArray) {
    return new Uint8Array(window.atob(base64EncodedByteArray).split("").map((c)=>c.charCodeAt(0)));
}
function $89727768601eecb3$var$getIsSupported$1() {
    return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && /android/i.test(navigator.userAgent);
}
const $89727768601eecb3$export$f1265e9082f346f1 = "Mobile Wallet Adapter";
const $89727768601eecb3$var$SIGNATURE_LENGTH_IN_BYTES$1 = 64;
function $89727768601eecb3$var$getPublicKeyFromAddress$1(address) {
    const publicKeyByteArray = $89727768601eecb3$var$toUint8Array(address);
    return new (0, $1ZJZa.PublicKey)(publicKeyByteArray);
}
function $89727768601eecb3$var$isVersionedTransaction(transaction) {
    return "version" in transaction;
}
function $89727768601eecb3$var$clusterToChainId(cluster) {
    switch(cluster){
        case "mainnet-beta":
            return "solana:mainnet";
        case "testnet":
            return "solana:testnet";
        case "devnet":
            return "solana:devnet";
    }
}
class $89727768601eecb3$export$dec251788b2f5a84 extends (0, $e93033ae3d6cecb2$export$9779f871ffdb3d87) {
    constructor(config){
        var _a;
        super();
        this.supportedTransactionVersions = new Set(// FIXME(#244): We can't actually know what versions are supported until we know which wallet we're talking to.
        [
            "legacy",
            0
        ]);
        this.name = $89727768601eecb3$export$f1265e9082f346f1;
        this.url = "https://solanamobile.com/wallets";
        this.icon = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI4IiB3aWR0aD0iMjgiIHZpZXdCb3g9Ii0zIDAgMjggMjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI0RDQjhGRiI+PHBhdGggZD0iTTE3LjQgMTcuNEgxNXYyLjRoMi40di0yLjRabTEuMi05LjZoLTIuNHYyLjRoMi40VjcuOFoiLz48cGF0aCBkPSJNMjEuNiAzVjBoLTIuNHYzaC0zLjZWMGgtMi40djNoLTIuNHY2LjZINC41YTIuMSAyLjEgMCAxIDEgMC00LjJoMi43VjNINC41QTQuNSA0LjUgMCAwIDAgMCA3LjVWMjRoMjEuNnYtNi42aC0yLjR2NC4ySDIuNFYxMS41Yy41LjMgMS4yLjQgMS44LjVoNy41QTYuNiA2LjYgMCAwIDAgMjQgOVYzaC0yLjRabTAgNS43YTQuMiA0LjIgMCAxIDEtOC40IDBWNS40aDguNHYzLjNaIi8+PC9nPjwvc3ZnPg==";
        this._connecting = false;
        /**
         * Every time the connection is recycled in some way (eg. `disconnect()` is called)
         * increment this and use it to make sure that `transact` calls from the previous
         * 'generation' don't continue to do work and throw exceptions.
         */ this._connectionGeneration = 0;
        this._readyState = $89727768601eecb3$var$getIsSupported$1() ? (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable : (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported;
        this._authorizationResultCache = config.authorizationResultCache;
        this._addressSelector = config.addressSelector;
        this._appIdentity = config.appIdentity;
        this._chain = (_a = config.chain) !== null && _a !== void 0 ? _a : $89727768601eecb3$var$clusterToChainId(config.cluster);
        this._hostAuthority = config.remoteHostAuthority;
        this._onWalletNotFound = config.onWalletNotFound;
        if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported) this._authorizationResultCache.get().then((authorizationResult)=>{
            if (authorizationResult) // Having a prior authorization result is, right now, the best
            // indication that a mobile wallet is installed. There is no API
            // we can use to test for whether the association URI is supported.
            this.declareWalletAsInstalled();
        });
    }
    get publicKey() {
        if (this._publicKey == null && this._selectedAddress != null) try {
            this._publicKey = $89727768601eecb3$var$getPublicKeyFromAddress$1(this._selectedAddress);
        } catch (e) {
            throw new (0, $a800e3a804b49fac$export$735bef3bfb0f2c86)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
        }
        return this._publicKey ? this._publicKey : null;
    }
    get connected() {
        return !!this._authorizationResult;
    }
    get connecting() {
        return this._connecting;
    }
    get readyState() {
        return this._readyState;
    }
    declareWalletAsInstalled() {
        if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed) this.emit("readyStateChange", this._readyState = (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed);
    }
    runWithGuard(callback) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield callback();
            } catch (e) {
                this.emit("error", e);
                throw e;
            }
        });
    }
    /** @deprecated Use `autoConnect()` instead. */ autoConnect_DO_NOT_USE_OR_YOU_WILL_BE_FIRED() {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.autoConnect();
        });
    }
    autoConnect() {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connecting || this.connected) return;
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable) throw new (0, $a800e3a804b49fac$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        const cachedAuthorizationResult = yield this._authorizationResultCache.get();
                        if (cachedAuthorizationResult) // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                        this.handleAuthorizationResult(cachedAuthorizationResult);
                    } catch (e) {
                        throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
    connect() {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connecting || this.connected) return;
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable) throw new (0, $a800e3a804b49fac$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        yield this.performAuthorization();
                    } catch (e) {
                        throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
    performAuthorization(signInPayload) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const cachedAuthorizationResult = yield this._authorizationResultCache.get();
                if (cachedAuthorizationResult) {
                    // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                    this.handleAuthorizationResult(cachedAuthorizationResult);
                    return cachedAuthorizationResult;
                }
                return yield this.transact((wallet)=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                        const authorizationResult = yield wallet.authorize({
                            chain: this._chain,
                            identity: this._appIdentity,
                            sign_in_payload: signInPayload
                        });
                        // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                        Promise.all([
                            this._authorizationResultCache.set(authorizationResult),
                            this.handleAuthorizationResult(authorizationResult)
                        ]);
                        return authorizationResult;
                    }));
            } catch (e) {
                throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
            }
        });
    }
    handleAuthorizationResult(authorizationResult) {
        var _a;
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            const didPublicKeysChange = // Case 1: We started from having no authorization.
            this._authorizationResult == null || // Case 2: The number of authorized accounts changed.
            ((_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.accounts.length) !== authorizationResult.accounts.length || // Case 3: The new list of addresses isn't exactly the same as the old list, in the same order.
            this._authorizationResult.accounts.some((account, ii)=>account.address !== authorizationResult.accounts[ii].address);
            this._authorizationResult = authorizationResult;
            this.declareWalletAsInstalled();
            if (didPublicKeysChange) {
                const nextSelectedAddress = yield this._addressSelector.select(authorizationResult.accounts.map(({ address: address })=>address));
                if (nextSelectedAddress !== this._selectedAddress) {
                    this._selectedAddress = nextSelectedAddress;
                    delete this._publicKey;
                    this.emit("connect", // Having just set `this._selectedAddress`, `this.publicKey` is definitely non-null
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.publicKey);
                }
            }
        });
    }
    performReauthorization(wallet, authToken) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const authorizationResult = yield wallet.authorize({
                    auth_token: authToken,
                    identity: this._appIdentity
                });
                // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                Promise.all([
                    this._authorizationResultCache.set(authorizationResult),
                    this.handleAuthorizationResult(authorizationResult)
                ]);
            } catch (e) {
                this.disconnect();
                throw new (0, $a800e3a804b49fac$export$bf7028c52ebda81e)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
            }
        });
    }
    disconnect() {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            this._authorizationResultCache.clear(); // TODO: Evaluate whether there's any threat to not `awaiting` this expression
            this._connecting = false;
            this._connectionGeneration++;
            delete this._authorizationResult;
            delete this._publicKey;
            delete this._selectedAddress;
            this.emit("disconnect");
        });
    }
    transact(callback) {
        var _a;
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            const walletUriBase = (_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.wallet_uri_base;
            const config = walletUriBase ? {
                baseUri: walletUriBase
            } : undefined;
            const remoteConfig = this._hostAuthority ? {
                remoteHostAuthority: this._hostAuthority
            } : undefined;
            const currentConnectionGeneration = this._connectionGeneration;
            try {
                return yield (0, $df7eaa54a4ba06d2$export$dac1bad6146b2469)(callback, Object.assign(Object.assign({}, config), remoteConfig));
            } catch (e) {
                if (this._connectionGeneration !== currentConnectionGeneration) yield new Promise(()=>{}); // Never resolve.
                if (e instanceof Error && e.name === "SolanaMobileWalletAdapterError" && e.code === "ERROR_WALLET_NOT_FOUND") yield this._onWalletNotFound(this);
                throw e;
            }
        });
    }
    assertIsAuthorized() {
        if (!this._authorizationResult || !this._selectedAddress) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
        return {
            authToken: this._authorizationResult.auth_token,
            selectedAddress: this._selectedAddress
        };
    }
    performSignTransactions(transactions) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            const { authToken: authToken } = this.assertIsAuthorized();
            try {
                return yield this.transact((wallet)=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                        yield this.performReauthorization(wallet, authToken);
                        const signedTransactions = yield wallet.signTransactions({
                            transactions: transactions
                        });
                        return signedTransactions;
                    }));
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
            }
        });
    }
    sendTransaction(transaction, connection, options) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    const { authToken: authToken } = this.assertIsAuthorized();
                    const minContextSlot = options === null || options === void 0 ? void 0 : options.minContextSlot;
                    try {
                        return yield this.transact((wallet)=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                                function getTargetCommitment() {
                                    let targetCommitment;
                                    switch(connection.commitment){
                                        case "confirmed":
                                        case "finalized":
                                        case "processed":
                                            targetCommitment = connection.commitment;
                                            break;
                                        default:
                                            targetCommitment = "finalized";
                                    }
                                    let targetPreflightCommitment;
                                    switch(options === null || options === void 0 ? void 0 : options.preflightCommitment){
                                        case "confirmed":
                                        case "finalized":
                                        case "processed":
                                            targetPreflightCommitment = options.preflightCommitment;
                                            break;
                                        case undefined:
                                            targetPreflightCommitment = targetCommitment;
                                            break;
                                        default:
                                            targetPreflightCommitment = "finalized";
                                    }
                                    const preflightCommitmentScore = targetPreflightCommitment === "finalized" ? 2 : targetPreflightCommitment === "confirmed" ? 1 : 0;
                                    const targetCommitmentScore = targetCommitment === "finalized" ? 2 : targetCommitment === "confirmed" ? 1 : 0;
                                    return preflightCommitmentScore < targetCommitmentScore ? targetPreflightCommitment : targetCommitment;
                                }
                                const [capabilities, _1, _2] = yield Promise.all([
                                    wallet.getCapabilities(),
                                    this.performReauthorization(wallet, authToken),
                                    $89727768601eecb3$var$isVersionedTransaction(transaction) ? null : /**
                                   * Unlike versioned transactions, legacy `Transaction` objects
                                   * may not have an associated `feePayer` or `recentBlockhash`.
                                   * This code exists to patch them up in case they are missing.
                                   */ (()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                                            var _a;
                                            transaction.feePayer || (transaction.feePayer = (_a = this.publicKey) !== null && _a !== void 0 ? _a : undefined);
                                            if (transaction.recentBlockhash == null) {
                                                const { blockhash: blockhash } = yield connection.getLatestBlockhash({
                                                    commitment: getTargetCommitment()
                                                });
                                                transaction.recentBlockhash = blockhash;
                                            }
                                        }))()
                                ]);
                                if (capabilities.supports_sign_and_send_transactions) {
                                    const signatures = yield wallet.signAndSendTransactions({
                                        minContextSlot: minContextSlot,
                                        transactions: [
                                            transaction
                                        ]
                                    });
                                    return signatures[0];
                                } else {
                                    const [signedTransaction] = yield wallet.signTransactions({
                                        transactions: [
                                            transaction
                                        ]
                                    });
                                    if ($89727768601eecb3$var$isVersionedTransaction(signedTransaction)) return yield connection.sendTransaction(signedTransaction);
                                    else {
                                        const serializedTransaction = signedTransaction.serialize();
                                        return yield connection.sendRawTransaction(serializedTransaction, Object.assign(Object.assign({}, options), {
                                            preflightCommitment: getTargetCommitment()
                                        }));
                                    }
                                }
                            }));
                    } catch (error) {
                        throw new (0, $a800e3a804b49fac$export$769332ac3f90f46c)(error === null || error === void 0 ? void 0 : error.message, error);
                    }
                }));
        });
    }
    signTransaction(transaction) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    const [signedTransaction] = yield this.performSignTransactions([
                        transaction
                    ]);
                    return signedTransaction;
                }));
        });
    }
    signAllTransactions(transactions) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    const signedTransactions = yield this.performSignTransactions(transactions);
                    return signedTransactions;
                }));
        });
    }
    signMessage(message) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    const { authToken: authToken, selectedAddress: selectedAddress } = this.assertIsAuthorized();
                    try {
                        return yield this.transact((wallet)=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                                yield this.performReauthorization(wallet, authToken);
                                const [signedMessage] = yield wallet.signMessages({
                                    addresses: [
                                        selectedAddress
                                    ],
                                    payloads: [
                                        message
                                    ]
                                });
                                const signature = signedMessage.slice(-$89727768601eecb3$var$SIGNATURE_LENGTH_IN_BYTES$1);
                                return signature;
                            }));
                    } catch (error) {
                        throw new (0, $a800e3a804b49fac$export$2622c1721bbd4b17)(error === null || error === void 0 ? void 0 : error.message, error);
                    }
                }));
        });
    }
    signIn(input) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b;
                    if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable) throw new (0, $a800e3a804b49fac$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        const authorizationResult = yield this.performAuthorization(Object.assign(Object.assign({}, input), {
                            domain: (_a = input === null || input === void 0 ? void 0 : input.domain) !== null && _a !== void 0 ? _a : window.location.host
                        }));
                        if (!authorizationResult.sign_in_result) throw new Error("Sign in failed, no sign in result returned by wallet");
                        const signedInAddress = authorizationResult.sign_in_result.address;
                        const signedInAccount = Object.assign(Object.assign({}, (_b = authorizationResult.accounts.find((acc)=>acc.address == signedInAddress)) !== null && _b !== void 0 ? _b : {
                            address: signedInAddress
                        }), {
                            publicKey: $89727768601eecb3$var$toUint8Array(signedInAddress)
                        });
                        return {
                            account: signedInAccount,
                            signedMessage: $89727768601eecb3$var$toUint8Array(authorizationResult.sign_in_result.signed_message),
                            signature: $89727768601eecb3$var$toUint8Array(authorizationResult.sign_in_result.signature)
                        };
                    } catch (e) {
                        throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
}
const $89727768601eecb3$var$BluetoothHtml = `
    <div class="mobile-wallet-adapter-embedded-modal-content">
    <button id="mobile-wallet-adapter-embedded-modal-close" class="mobile-wallet-adapter-embedded-modal-close">
        <svg width="14" height="14">
        <path d="M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z" />
        </svg>
    </button>
    <h1><b>Jupiter</b> wants to connect</h1>
    <p class="mobile-wallet-adapter-embedded-modal-subtitle">Connect to your mobile wallet app through Bluetooth.</p>
    <div class="mobile-wallet-adapter-embedded-modal-connection-status-container">
        <div id="status-not-connected" class="connection-status">
        <svg class="bluetooth-icon" width="24" height="24" viewBox="0 0 24 24">
            <path fill="#a0a0a0" d="M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"/>
        </svg>
        <p>Not connected</p>
        </div>
        <div id="status-connecting" class="connection-status" style="display:none;">
        <div class="spinner"></div>
        <p>Connecting...</p>
        </div>
        <div id="status-connected" class="connection-status" style="display:none;">
        <svg class="checkmark-icon" width="24" height="24" viewBox="0 0 24 24">
            <path fill="#4CAF50" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
        <p>Connected</p>
        </div>
    </div>
    <div class="button-group">
        <button id="cancel-btn" class="cancel-btn">Cancel</button>
        <button id="connect-btn" class="connect-btn">Connect</button>
    </div>
    </div>
`;
const $89727768601eecb3$var$QRCodeHtml = `
<div class="mobile-wallet-adapter-embedded-modal-content">
  <button id="mobile-wallet-adapter-embedded-modal-close" class="mobile-wallet-adapter-embedded-modal-close">
    <svg width="14" height="14">
      <path d="M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z" />
    </svg>
  </button>
  <h1>Scan to connect</h1>
  <p class="mobile-wallet-adapter-embedded-modal-subtitle">Use your wallet app to scan the QR Code and connect.</p>
  <div id="mobile-wallet-adapter-embedded-modal-qr-code-container" />
</div>
`;
const $89727768601eecb3$var$css = `
.mobile-wallet-adapter-embedded-modal {
    display: flex; /* Use flexbox to center content */
    flex-direction: column;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

.mobile-wallet-adapter-embedded-modal-content {
    background: #10141f;
    padding: 20px;
    border-radius: 10px;
    width: 80%;
    max-width: 500px;
    text-align: center;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center; /* Center children horizontally */
}

.mobile-wallet-adapter-embedded-modal-subtitle {
    color: #D8D8D8;
}

.mobile-wallet-adapter-embedded-modal-close {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 18px;
    right: 18px;
    padding: 12px;
    cursor: pointer;
    background: #1a1f2e;
    border: none;
    border-radius: 50%;
}

.mobile-wallet-adapter-embedded-modal-close:focus-visible {
    outline-color: white;
}

.mobile-wallet-adapter-embedded-modal-close svg {
    fill: #777;
    transition: fill 200ms ease 0s;
}

.mobile-wallet-adapter-embedded-modal-close:hover svg {
    fill: #fff;
}

.icon-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #ddd; /* Placeholder for icon background */
}

/* Modal Title */
.mobile-wallet-adapter-embedded-modal-content h1 {
    color: white;
    font-size: 24px;   
}

.button-group {
    display: flex;
    width: 100%;
    gap: 10px;
}

.connect-btn, .cancel-btn {
    flex: 1;
    padding: 12px 20px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 10px;
    transition: all 0.3s ease;
}

.connect-btn {
    background-color: #007bff;
    color: white;
    border: none;
}

.connect-btn:hover {
    background-color: #0056b3;
}

.cancel-btn {
    background-color: transparent;
    color: #a0a0a0;
    border: 1px solid #a0a0a0;
}

.cancel-btn:hover {
    background-color: rgba(160, 160, 160, 0.1);
}

/* BT Connection Status */

.mobile-wallet-adapter-embedded-modal-connection-status-container {
    margin: 20px 0px 20px 0px;
}

.connection-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
}
  
.connection-status p {
    margin-top: 10px;
    color: #a0a0a0;
}
  
.bluetooth-icon, .checkmark-icon {
    width: 48px;
    height: 48px;
}
  
.spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
}
  
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* QR Code */

#mobile-wallet-adapter-embedded-modal-qr-code-container {
    width: 500px;
    height: 500px;
    align-content: center;
}
`;
class $89727768601eecb3$var$EmbeddedModal {
    constructor(title){
        this._root = null;
        this._title = title;
        // Bind methods to ensure `this` context is correct
        this.init = this.init.bind(this);
        this.injectQRCodeHTML = this.injectQRCodeHTML.bind(this);
        this.injectBluetoothHTML = this.injectBluetoothHTML.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.connect = this.connect.bind(this);
        this._root = document.getElementById("mobile-wallet-adapter-embedded-root-ui");
    }
    init(qrCode) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            console.log("Injecting modal");
            this.injectStyles();
            this.injectQRCodeHTML(qrCode);
        });
    }
    setConnectionStatus(status) {
        if (!this._root) return;
        const statuses = [
            "not-connected",
            "connecting",
            "connected"
        ];
        statuses.forEach((s)=>{
            const el = this._root.querySelector(`#status-${s}`);
            if (el instanceof HTMLElement) el.style.display = s === status ? "flex" : "none";
        });
    }
    injectStyles() {
        // Check if the styles have already been injected
        if (document.getElementById("mobile-wallet-adapter-styles")) return;
        const styleElement = document.createElement("style");
        styleElement.id = "mobile-wallet-adapter-styles";
        styleElement.textContent = $89727768601eecb3$var$css;
        document.head.appendChild(styleElement);
    }
    populateQRCode(qrUrl) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            const qrcodeContainer = document.getElementById("mobile-wallet-adapter-embedded-modal-qr-code-container");
            if (qrcodeContainer) {
                const qrCodeElement = yield (0, (/*@__PURE__*/$parcel$interopDefault($2e96213cb0651c6d$exports))).toCanvas(qrUrl, {
                    width: 400
                });
                if (qrcodeContainer.firstElementChild !== null) qrcodeContainer.replaceChild(qrCodeElement, qrcodeContainer.firstElementChild);
                else qrcodeContainer.appendChild(qrCodeElement);
            } else console.error("QRCode Container not found");
        });
    }
    injectQRCodeHTML(qrCode) {
        // Check if the HTML has already been injected
        if (document.getElementById("mobile-wallet-adapter-embedded-root-ui")) {
            if (!this._root) this._root = document.getElementById("mobile-wallet-adapter-embedded-root-ui");
            this.populateQRCode(qrCode);
            return;
        }
        // Create a container for the modal
        this._root = document.createElement("div");
        this._root.id = "mobile-wallet-adapter-embedded-root-ui";
        this._root.className = "mobile-wallet-adapter-embedded-modal";
        this._root.innerHTML = $89727768601eecb3$var$QRCodeHtml;
        this._root.style.display = "none";
        // Append the modal to the body
        document.body.appendChild(this._root);
        // Render the QRCode
        this.populateQRCode(qrCode);
        this.attachEventListeners();
    }
    injectBluetoothHTML() {
        // Check if the HTML has already been injected
        if (document.getElementById("mobile-wallet-adapter-embedded-root-ui")) return;
        this._root = document.createElement("div");
        this._root.id = "mobile-wallet-adapter-embedded-root-ui";
        this._root.className = "mobile-wallet-adapter-embedded-modal";
        this._root.innerHTML = $89727768601eecb3$var$BluetoothHtml;
        document.body.appendChild(this._root);
        this.attachEventListeners();
    }
    attachEventListeners() {
        if (!this._root) return;
        const closeBtn = this._root.querySelector("#mobile-wallet-adapter-embedded-modal-close");
        const cancelBtn = this._root.querySelector("#cancel-btn");
        const connectBtn = this._root.querySelector("#connect-btn");
        closeBtn === null || closeBtn === void 0 || closeBtn.addEventListener("click", ()=>this.close());
        cancelBtn === null || cancelBtn === void 0 || cancelBtn.addEventListener("click", ()=>this.close());
        connectBtn === null || connectBtn === void 0 || connectBtn.addEventListener("click", ()=>this.connect());
    }
    open() {
        console.debug("Modal open");
        if (this._root) {
            this._root.style.display = "flex";
            this.setConnectionStatus("not-connected"); // Reset status when opening
        }
    }
    close() {
        console.debug("Modal close");
        if (this._root) {
            this._root.style.display = "none";
            this.setConnectionStatus("not-connected"); // Reset status when closing
        }
    }
    connect() {
        console.log("Connecting...");
        // Mock connection
        this.setConnectionStatus("connecting");
        // Simulate connection process
        setTimeout(()=>{
            this.setConnectionStatus("connected");
            console.log("Connected!");
        }, 5000); // 5 seconds delay
    }
}
const $89727768601eecb3$export$8701a18cc5ef8b26 = "MWA (Remote)";
const $89727768601eecb3$var$SIGNATURE_LENGTH_IN_BYTES = 64;
function $89727768601eecb3$var$getPublicKeyFromAddress(address) {
    const publicKeyByteArray = (0, $28a84d06a3882c92$export$73470fd2221e6aef)(address);
    return new (0, $1ZJZa.PublicKey)(publicKeyByteArray);
}
/**
 * Determine the mobile operating system.
 * Returns true if running on a mobile operating system, or false otherwise.
 *
 * @returns {boolean}
 */ function $89727768601eecb3$var$isMobileOperatingSystem() {
    var userAgent = navigator.userAgent;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) return true;
    if (/android/i.test(userAgent)) return true;
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return true;
    return false;
}
function $89727768601eecb3$var$getIsSupported() {
    return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && !$89727768601eecb3$var$isMobileOperatingSystem();
}
/**
 * This burner wallet adapter is unsafe to use and is only included to provide an easy way for applications to test
 * Wallet Adapter without using a third-party wallet.
 */ class $89727768601eecb3$export$ac4a136ab7b98be7 extends (0, $e93033ae3d6cecb2$export$9779f871ffdb3d87) {
    constructor(config){
        super();
        this.supportedTransactionVersions = new Set(// FIXME(#244): We can't actually know what versions are supported until we know which wallet we're talking to.
        [
            "legacy",
            0
        ]);
        this.name = $89727768601eecb3$export$8701a18cc5ef8b26;
        this.url = "https://solanamobile.com/wallets";
        this.icon = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI4IiB3aWR0aD0iMjgiIHZpZXdCb3g9Ii0zIDAgMjggMjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI0RDQjhGRiI+PHBhdGggZD0iTTE3LjQgMTcuNEgxNXYyLjRoMi40di0yLjRabTEuMi05LjZoLTIuNHYyLjRoMi40VjcuOFoiLz48cGF0aCBkPSJNMjEuNiAzVjBoLTIuNHYzaC0zLjZWMGgtMi40djNoLTIuNHY2LjZINC41YTIuMSAyLjEgMCAxIDEgMC00LjJoMi43VjNINC41QTQuNSA0LjUgMCAwIDAgMCA3LjVWMjRoMjEuNnYtNi42aC0yLjR2NC4ySDIuNFYxMS41Yy41LjMgMS4yLjQgMS44LjVoNy41QTYuNiA2LjYgMCAwIDAgMjQgOVYzaC0yLjRabTAgNS43YTQuMiA0LjIgMCAxIDEtOC40IDBWNS40aDguNHYzLjNaIi8+PC9nPjwvc3ZnPg==";
        this._connecting = false;
        /**
         * Every time the connection is recycled in some way (eg. `disconnect()` is called)
         * increment this and use it to make sure that `transact` calls from the previous
         * 'generation' don't continue to do work and throw exceptions.
         */ this._connectionGeneration = 0;
        this._readyState = $89727768601eecb3$var$getIsSupported() ? (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable : (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported;
        this._authorizationResultCache = config.authorizationResultCache;
        this._addressSelector = config.addressSelector;
        this._appIdentity = config.appIdentity;
        this._chain = config.chain;
        this._hostAuthority = config.remoteHostAuthority;
        this._onWalletNotFound = config.onWalletNotFound;
        if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported) this._authorizationResultCache.get().then((authorizationResult)=>{
            if (authorizationResult) // Having a prior authorization result is, right now, the best
            // indication that a mobile wallet is installed. There is no API
            // we can use to test for whether the association URI is supported.
            this.declareWalletAsInstalled();
        });
    }
    get publicKey() {
        if (this._publicKey == null && this._selectedAddress != null) try {
            this._publicKey = $89727768601eecb3$var$getPublicKeyFromAddress(this._selectedAddress);
        } catch (e) {
            throw new (0, $a800e3a804b49fac$export$735bef3bfb0f2c86)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
        }
        return this._publicKey ? this._publicKey : null;
    }
    get connected() {
        return !!this._authorizationResult;
    }
    get connecting() {
        return this._connecting;
    }
    get readyState() {
        return this._readyState;
    }
    declareWalletAsInstalled() {
        if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed) this.emit("readyStateChange", this._readyState = (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed);
    }
    runWithGuard(callback) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield callback();
            } catch (e) {
                this.emit("error", e);
                throw e;
            }
        });
    }
    autoConnect() {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connecting || this.connected) return;
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable) throw new (0, $a800e3a804b49fac$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        const cachedAuthorizationResult = yield this._authorizationResultCache.get();
                        if (cachedAuthorizationResult) // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                        this.handleAuthorizationResult(cachedAuthorizationResult);
                    } catch (e) {
                        throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
    connect() {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connecting || this.connected) return;
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable) throw new (0, $a800e3a804b49fac$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        yield this.performAuthorization();
                    } catch (e) {
                        throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
    performAuthorization(signInPayload) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const cachedAuthorizationResult = yield this._authorizationResultCache.get();
                if (cachedAuthorizationResult) {
                    // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                    this.handleAuthorizationResult(cachedAuthorizationResult);
                    return cachedAuthorizationResult;
                }
                if (this._wallet) delete this._wallet;
                return yield this.transact((wallet)=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                        this._wallet = wallet;
                        const authorizationResult = yield wallet.authorize({
                            chain: this._chain,
                            identity: this._appIdentity,
                            sign_in_payload: signInPayload
                        });
                        // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                        Promise.all([
                            this._authorizationResultCache.set(authorizationResult),
                            this.handleAuthorizationResult(authorizationResult)
                        ]);
                        return authorizationResult;
                    }));
            } catch (e) {
                throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
            }
        });
    }
    handleAuthorizationResult(authorizationResult) {
        var _a;
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            const didPublicKeysChange = // Case 1: We started from having no authorization.
            this._authorizationResult == null || // Case 2: The number of authorized accounts changed.
            ((_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.accounts.length) !== authorizationResult.accounts.length || // Case 3: The new list of addresses isn't exactly the same as the old list, in the same order.
            this._authorizationResult.accounts.some((account, ii)=>account.address !== authorizationResult.accounts[ii].address);
            this._authorizationResult = authorizationResult;
            this.declareWalletAsInstalled();
            if (didPublicKeysChange) {
                const nextSelectedAddress = yield this._addressSelector.select(authorizationResult.accounts.map(({ address: address })=>address));
                if (nextSelectedAddress !== this._selectedAddress) {
                    this._selectedAddress = nextSelectedAddress;
                    delete this._publicKey;
                    this.emit("connect", // Having just set `this._selectedAddress`, `this.publicKey` is definitely non-null
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.publicKey);
                }
            }
        });
    }
    performReauthorization(wallet, authToken) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const authorizationResult = yield wallet.authorize({
                    auth_token: authToken,
                    identity: this._appIdentity
                });
                // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                Promise.all([
                    this._authorizationResultCache.set(authorizationResult),
                    this.handleAuthorizationResult(authorizationResult)
                ]);
            } catch (e) {
                this.disconnect();
                throw new (0, $a800e3a804b49fac$export$bf7028c52ebda81e)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
            }
        });
    }
    disconnect() {
        var _a;
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            // TODO: figure out why this call throws "TypeError: _a.terminateSession is not a function"
            //  even though the session termination is actually executed (websocket closes). 
            try {
                (_a = this._wallet) === null || _a === void 0 || _a.terminateSession();
            } catch (e) {}
            this._authorizationResultCache.clear(); // TODO: Evaluate whether there's any threat to not `awaiting` this expression
            this._connecting = false;
            this._connectionGeneration++;
            delete this._authorizationResult;
            delete this._publicKey;
            delete this._selectedAddress;
            delete this._wallet;
            this.emit("disconnect");
        });
    }
    transact(callback) {
        var _a;
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            const walletUriBase = (_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.wallet_uri_base;
            const baseConfig = walletUriBase ? {
                baseUri: walletUriBase
            } : undefined;
            const remoteConfig = Object.assign(Object.assign({}, baseConfig), {
                remoteHostAuthority: this._hostAuthority
            });
            const currentConnectionGeneration = this._connectionGeneration;
            const modal = new $89727768601eecb3$var$EmbeddedModal("MWA QR");
            if (this._wallet) return callback(this._wallet);
            try {
                const { associationUrl: associationUrl, result: promise } = yield (0, $df7eaa54a4ba06d2$export$27dc3ad82cd9eb4f)((wallet)=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                        const result = yield callback(wallet);
                        modal.close();
                        return result;
                    }), remoteConfig);
                modal.init(associationUrl.toString());
                modal.open();
                return yield promise;
            } catch (e) {
                modal.close();
                if (this._connectionGeneration !== currentConnectionGeneration) yield new Promise(()=>{}); // Never resolve.
                if (e instanceof Error && e.name === "SolanaMobileWalletAdapterError" && e.code === "ERROR_WALLET_NOT_FOUND") yield this._onWalletNotFound(this);
                throw e;
            }
        });
    }
    assertIsAuthorized() {
        if (!this._authorizationResult || !this._selectedAddress) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
        return {
            authToken: this._authorizationResult.auth_token,
            selectedAddress: this._selectedAddress
        };
    }
    performSignTransactions(transactions) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            const { authToken: authToken } = this.assertIsAuthorized();
            try {
                return yield this.transact((wallet)=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                        yield this.performReauthorization(wallet, authToken);
                        const signedTransactions = yield wallet.signTransactions({
                            transactions: transactions
                        });
                        return signedTransactions;
                    }));
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
            }
        });
    }
    sendTransaction(transaction, connection, options) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    const { authToken: authToken } = this.assertIsAuthorized();
                    const minContextSlot = options === null || options === void 0 ? void 0 : options.minContextSlot;
                    try {
                        return yield this.transact((wallet)=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                                function getTargetCommitment() {
                                    let targetCommitment;
                                    switch(connection.commitment){
                                        case "confirmed":
                                        case "finalized":
                                        case "processed":
                                            targetCommitment = connection.commitment;
                                            break;
                                        default:
                                            targetCommitment = "finalized";
                                    }
                                    let targetPreflightCommitment;
                                    switch(options === null || options === void 0 ? void 0 : options.preflightCommitment){
                                        case "confirmed":
                                        case "finalized":
                                        case "processed":
                                            targetPreflightCommitment = options.preflightCommitment;
                                            break;
                                        case undefined:
                                            targetPreflightCommitment = targetCommitment;
                                            break;
                                        default:
                                            targetPreflightCommitment = "finalized";
                                    }
                                    const preflightCommitmentScore = targetPreflightCommitment === "finalized" ? 2 : targetPreflightCommitment === "confirmed" ? 1 : 0;
                                    const targetCommitmentScore = targetCommitment === "finalized" ? 2 : targetCommitment === "confirmed" ? 1 : 0;
                                    return preflightCommitmentScore < targetCommitmentScore ? targetPreflightCommitment : targetCommitment;
                                }
                                const [capabilities, _1, _2] = yield Promise.all([
                                    wallet.getCapabilities(),
                                    this.performReauthorization(wallet, authToken),
                                    (0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(transaction) ? null : /**
                                   * Unlike versioned transactions, legacy `Transaction` objects
                                   * may not have an associated `feePayer` or `recentBlockhash`.
                                   * This code exists to patch them up in case they are missing.
                                   */ (()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                                            var _a;
                                            transaction.feePayer || (transaction.feePayer = (_a = this.publicKey) !== null && _a !== void 0 ? _a : undefined);
                                            if (transaction.recentBlockhash == null) {
                                                const { blockhash: blockhash } = yield connection.getLatestBlockhash({
                                                    commitment: getTargetCommitment()
                                                });
                                                transaction.recentBlockhash = blockhash;
                                            }
                                        }))()
                                ]);
                                if (capabilities.supports_sign_and_send_transactions) {
                                    const signatures = yield wallet.signAndSendTransactions({
                                        minContextSlot: minContextSlot,
                                        transactions: [
                                            transaction
                                        ]
                                    });
                                    return signatures[0];
                                } else {
                                    const [signedTransaction] = yield wallet.signTransactions({
                                        transactions: [
                                            transaction
                                        ]
                                    });
                                    if ((0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(signedTransaction)) return yield connection.sendTransaction(signedTransaction);
                                    else {
                                        const serializedTransaction = signedTransaction.serialize();
                                        return yield connection.sendRawTransaction(serializedTransaction, Object.assign(Object.assign({}, options), {
                                            preflightCommitment: getTargetCommitment()
                                        }));
                                    }
                                }
                            }));
                    } catch (error) {
                        throw new (0, $a800e3a804b49fac$export$769332ac3f90f46c)(error === null || error === void 0 ? void 0 : error.message, error);
                    }
                }));
        });
    }
    signTransaction(transaction) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    const [signedTransaction] = yield this.performSignTransactions([
                        transaction
                    ]);
                    return signedTransaction;
                }));
        });
    }
    signAllTransactions(transactions) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    const signedTransactions = yield this.performSignTransactions(transactions);
                    return signedTransactions;
                }));
        });
    }
    signMessage(message) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    const { authToken: authToken, selectedAddress: selectedAddress } = this.assertIsAuthorized();
                    try {
                        return yield this.transact((wallet)=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                                yield this.performReauthorization(wallet, authToken);
                                const [signedMessage] = yield wallet.signMessages({
                                    addresses: [
                                        selectedAddress
                                    ],
                                    payloads: [
                                        message
                                    ]
                                });
                                const signature = signedMessage.slice(-$89727768601eecb3$var$SIGNATURE_LENGTH_IN_BYTES);
                                return signature;
                            }));
                    } catch (error) {
                        throw new (0, $a800e3a804b49fac$export$2622c1721bbd4b17)(error === null || error === void 0 ? void 0 : error.message, error);
                    }
                }));
        });
    }
    signIn(input) {
        return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b;
                    if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable) throw new (0, $a800e3a804b49fac$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        const authorizationResult = yield this.performAuthorization(Object.assign(Object.assign({}, input), {
                            domain: (_a = input === null || input === void 0 ? void 0 : input.domain) !== null && _a !== void 0 ? _a : window.location.host
                        }));
                        if (!authorizationResult.sign_in_result) throw new Error("Sign in failed, no sign in result returned by wallet");
                        const signedInAddress = authorizationResult.sign_in_result.address;
                        const signedInAccount = Object.assign(Object.assign({}, (_b = authorizationResult.accounts.find((acc)=>acc.address == signedInAddress)) !== null && _b !== void 0 ? _b : {
                            address: signedInAddress
                        }), {
                            publicKey: (0, $28a84d06a3882c92$export$73470fd2221e6aef)(signedInAddress)
                        });
                        return {
                            account: signedInAccount,
                            signedMessage: (0, $28a84d06a3882c92$export$73470fd2221e6aef)(authorizationResult.sign_in_result.signed_message),
                            signature: (0, $28a84d06a3882c92$export$73470fd2221e6aef)(authorizationResult.sign_in_result.signature)
                        };
                    } catch (e) {
                        throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
}
function $89727768601eecb3$export$a299fb0acc11345b() {
    return {
        select (addresses) {
            return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                return addresses[0];
            });
        }
    };
}
const $89727768601eecb3$var$CACHE_KEY = "SolanaMobileWalletAdapterDefaultAuthorizationCache";
function $89727768601eecb3$export$4a0b597891770806() {
    let storage;
    try {
        storage = window.localStorage;
    // eslint-disable-next-line no-empty
    } catch (_a) {}
    return {
        clear () {
            return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    storage.removeItem($89727768601eecb3$var$CACHE_KEY);
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        },
        get () {
            return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    return JSON.parse(storage.getItem($89727768601eecb3$var$CACHE_KEY)) || undefined;
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        },
        set (authorizationResult) {
            return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    storage.setItem($89727768601eecb3$var$CACHE_KEY, JSON.stringify(authorizationResult));
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        }
    };
}
function $89727768601eecb3$var$defaultWalletNotFoundHandler(mobileWalletAdapter) {
    return $89727768601eecb3$var$__awaiter(this, void 0, void 0, function*() {
        if (typeof window !== "undefined") window.location.assign(mobileWalletAdapter.url);
    });
}
function $89727768601eecb3$export$e8b9e70cdf783b70() {
    return $89727768601eecb3$var$defaultWalletNotFoundHandler;
}



var $4bt7m = parcelRequire("4bt7m");
var $840Oq = parcelRequire("840Oq");
/** Name of the feature. */ const $21c6ff693543ac7b$export$cc68487eeb93b1d4 = "standard:connect";
const $21c6ff693543ac7b$export$59e6910693f047c2 = $21c6ff693543ac7b$export$cc68487eeb93b1d4;

/** Name of the feature. */ const $81b0a26bfbf4e734$export$5296443ca9e9fa0f = "standard:events";
const $81b0a26bfbf4e734$export$ada873a34909da65 = $81b0a26bfbf4e734$export$5296443ca9e9fa0f;


function $e04d5bbec5347bf7$export$de6946e7c2c87e9a(wallet) {
    return (0, $21c6ff693543ac7b$export$cc68487eeb93b1d4) in wallet.features && (0, $81b0a26bfbf4e734$export$5296443ca9e9fa0f) in wallet.features && ((0, $4bt7m.SolanaSignAndSendTransaction) in wallet.features || (0, $840Oq.SolanaSignTransaction) in wallet.features);
}


const $1dd3a3d79212cd66$export$c5439c91843266e6 = (0, $e04d5bbec5347bf7$export$de6946e7c2c87e9a);



var $4bt7m = parcelRequire("4bt7m");/** Name of the feature. */ const $7d976b3d2343c8cf$export$8adeab75f48a3607 = "solana:signIn";


var $5sd65 = parcelRequire("5sd65");
var $840Oq = parcelRequire("840Oq");
/** Solana Mainnet (beta) cluster, e.g. https://api.mainnet-beta.solana.com */ const $e0f5a63cd5840de2$export$bba9a228295b3963 = "solana:mainnet";
const $e0f5a63cd5840de2$export$654cc095bd2e650 = "solana:devnet";
const $e0f5a63cd5840de2$export$76575b7bf4de1f40 = "solana:testnet";
const $e0f5a63cd5840de2$export$483699a75281444c = "solana:localnet";
const $e0f5a63cd5840de2$export$d77e7f94b1f6bf7d = [
    $e0f5a63cd5840de2$export$bba9a228295b3963,
    $e0f5a63cd5840de2$export$654cc095bd2e650,
    $e0f5a63cd5840de2$export$76575b7bf4de1f40,
    $e0f5a63cd5840de2$export$483699a75281444c
];
function $e0f5a63cd5840de2$export$d8f86f4d3d9fc2b5(chain) {
    return $e0f5a63cd5840de2$export$d77e7f94b1f6bf7d.includes(chain);
}


const $4b0dba91f194f909$export$9462d80112b287bf = "https://api.mainnet-beta.solana.com";
const $4b0dba91f194f909$export$2416cc3545b31c3b = "https://api.devnet.solana.com";
const $4b0dba91f194f909$export$fe3dc909dfa57ddb = "https://api.testnet.solana.com";
const $4b0dba91f194f909$export$ec9ed1d68bb4713f = "http://localhost:8899";
function $4b0dba91f194f909$export$43dcd8213c5a5741(endpoint) {
    if (endpoint.includes($4b0dba91f194f909$export$9462d80112b287bf)) return 0, $e0f5a63cd5840de2$export$bba9a228295b3963;
    if (/\bdevnet\b/i.test(endpoint)) return 0, $e0f5a63cd5840de2$export$654cc095bd2e650;
    if (/\btestnet\b/i.test(endpoint)) return 0, $e0f5a63cd5840de2$export$76575b7bf4de1f40;
    if (/\blocalhost\b/i.test(endpoint) || /\b127\.0\.0\.1\b/.test(endpoint)) return 0, $e0f5a63cd5840de2$export$483699a75281444c;
    return 0, $e0f5a63cd5840de2$export$bba9a228295b3963;
}
function $4b0dba91f194f909$export$c9b15526ee38efba(chain, endpoint) {
    if (endpoint) return endpoint;
    if (chain === (0, $e0f5a63cd5840de2$export$bba9a228295b3963)) return $4b0dba91f194f909$export$9462d80112b287bf;
    if (chain === (0, $e0f5a63cd5840de2$export$654cc095bd2e650)) return $4b0dba91f194f909$export$2416cc3545b31c3b;
    if (chain === (0, $e0f5a63cd5840de2$export$76575b7bf4de1f40)) return $4b0dba91f194f909$export$fe3dc909dfa57ddb;
    if (chain === (0, $e0f5a63cd5840de2$export$483699a75281444c)) return $4b0dba91f194f909$export$ec9ed1d68bb4713f;
    return $4b0dba91f194f909$export$9462d80112b287bf;
}

/**
 * TODO: docs
 */ function $bd56e19e4f91ca4b$export$430b2bce150d42d4(commitment) {
    switch(commitment){
        case "processed":
        case "confirmed":
        case "finalized":
        case undefined:
            return commitment;
        case "recent":
            return "processed";
        case "single":
        case "singleGossip":
            return "confirmed";
        case "max":
        case "root":
            return "finalized";
        default:
            return undefined;
    }
}



var $1ZJZa = parcelRequire("1ZJZa");
/** Name of the feature. */ const $7012ebc3e37cd89f$export$38dbd4bbb9b696e6 = "standard:disconnect";
const $7012ebc3e37cd89f$export$9e282393ab352bcd = $7012ebc3e37cd89f$export$38dbd4bbb9b696e6;


var $90d30fbb3dd8c216$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $90d30fbb3dd8c216$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_address, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_publicKey, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_chains, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_features, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_label, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_icon;
class $90d30fbb3dd8c216$export$c0ac434c7ac96eb0 {
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.address | WalletAccount::address} */ get address() {
        return $90d30fbb3dd8c216$var$__classPrivateFieldGet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_address, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.publicKey | WalletAccount::publicKey} */ get publicKey() {
        return $90d30fbb3dd8c216$var$__classPrivateFieldGet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_publicKey, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.chains | WalletAccount::chains} */ get chains() {
        return $90d30fbb3dd8c216$var$__classPrivateFieldGet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_chains, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.features | WalletAccount::features} */ get features() {
        return $90d30fbb3dd8c216$var$__classPrivateFieldGet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_features, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.label | WalletAccount::label} */ get label() {
        return $90d30fbb3dd8c216$var$__classPrivateFieldGet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_label, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.icon | WalletAccount::icon} */ get icon() {
        return $90d30fbb3dd8c216$var$__classPrivateFieldGet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_icon, "f");
    }
    /**
     * Create and freeze a read-only account.
     *
     * @param account Account to copy properties from.
     */ constructor(account){
        $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_address.set(this, void 0);
        $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_publicKey.set(this, void 0);
        $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_chains.set(this, void 0);
        $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_features.set(this, void 0);
        $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_label.set(this, void 0);
        $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_icon.set(this, void 0);
        if (new.target === $90d30fbb3dd8c216$export$c0ac434c7ac96eb0) Object.freeze(this);
        $90d30fbb3dd8c216$var$__classPrivateFieldSet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_address, account.address, "f");
        $90d30fbb3dd8c216$var$__classPrivateFieldSet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_publicKey, account.publicKey.slice(), "f");
        $90d30fbb3dd8c216$var$__classPrivateFieldSet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_chains, account.chains.slice(), "f");
        $90d30fbb3dd8c216$var$__classPrivateFieldSet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_features, account.features.slice(), "f");
        $90d30fbb3dd8c216$var$__classPrivateFieldSet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_label, account.label, "f");
        $90d30fbb3dd8c216$var$__classPrivateFieldSet(this, $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_icon, account.icon, "f");
    }
}
$90d30fbb3dd8c216$var$_ReadonlyWalletAccount_address = new WeakMap(), $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_publicKey = new WeakMap(), $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_chains = new WeakMap(), $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_features = new WeakMap(), $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_label = new WeakMap(), $90d30fbb3dd8c216$var$_ReadonlyWalletAccount_icon = new WeakMap();
function $90d30fbb3dd8c216$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    const length = a.length;
    if (length !== b.length) return false;
    for(let i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $90d30fbb3dd8c216$export$c663ab80cce302c5(a, b) {
    return $90d30fbb3dd8c216$export$234180f8206db11b(a, b);
}
function $90d30fbb3dd8c216$export$287dd7971339c972(first, ...others) {
    const length = others.reduce((length, bytes)=>length + bytes.length, first.length);
    const bytes = new Uint8Array(length);
    bytes.set(first, 0);
    for (const other of others)bytes.set(other, bytes.length);
    return bytes;
}
function $90d30fbb3dd8c216$export$357523c63a2253b9(source, ...keys) {
    const picked = {};
    for (const key of keys)picked[key] = source[key];
    return picked;
}
function $90d30fbb3dd8c216$export$864d727b48066337(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}


// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $f5aeaea5ea931dfe$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    const BASE_MAP = new Uint8Array(256);
    for(let j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(let i = 0; i < ALPHABET.length; i++){
        const x = ALPHABET.charAt(i);
        const xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    const BASE = ALPHABET.length;
    const LEADER = ALPHABET.charAt(0);
    const FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    const iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        // eslint-disable-next-line no-empty
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        let zeroes = 0;
        let length = 0;
        let pbegin = 0;
        const pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        const size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        const b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            let carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            let i = 0;
            for(let it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        let it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        let str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        let psz = 0;
        // Skip and count leading '1's.
        let zeroes = 0;
        let length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        const size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        const b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Find code of next character
            const charCode = source.charCodeAt(psz);
            // Base map can not be indexed using char code
            if (charCode > 255) return;
            // Decode character
            let carry = BASE_MAP[charCode];
            // Invalid character
            if (carry === 255) return;
            let i = 0;
            for(let it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        let it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        const vch = new Uint8Array(zeroes + (size - it4));
        let j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        const buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $f5aeaea5ea931dfe$export$2e2bcd8739ae039 = $f5aeaea5ea931dfe$var$base;


var $40c056ff6698da7a$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var $40c056ff6698da7a$export$2e2bcd8739ae039 = (0, $f5aeaea5ea931dfe$export$2e2bcd8739ae039)($40c056ff6698da7a$var$ALPHABET);


var $cc9365d1d333c5b6$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $cc9365d1d333c5b6$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, $cc9365d1d333c5b6$var$_StandardWalletAdapter_publicKey, $cc9365d1d333c5b6$var$_StandardWalletAdapter_connecting, $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnecting, $cc9365d1d333c5b6$var$_StandardWalletAdapter_off, $cc9365d1d333c5b6$var$_StandardWalletAdapter_supportedTransactionVersions, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, $cc9365d1d333c5b6$var$_StandardWalletAdapter_readyState, $cc9365d1d333c5b6$var$_StandardWalletAdapter_connect, $cc9365d1d333c5b6$var$_StandardWalletAdapter_connected, $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnected, $cc9365d1d333c5b6$var$_StandardWalletAdapter_reset, $cc9365d1d333c5b6$var$_StandardWalletAdapter_changed, $cc9365d1d333c5b6$var$_StandardWalletAdapter_signTransaction, $cc9365d1d333c5b6$var$_StandardWalletAdapter_signAllTransactions, $cc9365d1d333c5b6$var$_StandardWalletAdapter_signMessage, $cc9365d1d333c5b6$var$_StandardWalletAdapter_signIn;
class $cc9365d1d333c5b6$export$e0949de9e32fe3b2 extends (0, $e820e806547f33d2$export$2af1ea2892adc469) {
    get name() {
        return $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").name;
    }
    get url() {
        return "https://github.com/solana-labs/wallet-standard";
    }
    get icon() {
        return $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").icon;
    }
    get readyState() {
        return $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_readyState, "f");
    }
    get publicKey() {
        return $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_publicKey, "f");
    }
    get connecting() {
        return $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_connecting, "f");
    }
    get supportedTransactionVersions() {
        return $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_supportedTransactionVersions, "f");
    }
    get wallet() {
        return $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f");
    }
    get standard() {
        return true;
    }
    constructor({ wallet: wallet }){
        super();
        $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances.add(this);
        $cc9365d1d333c5b6$var$_StandardWalletAdapter_account.set(this, void 0);
        $cc9365d1d333c5b6$var$_StandardWalletAdapter_publicKey.set(this, void 0);
        $cc9365d1d333c5b6$var$_StandardWalletAdapter_connecting.set(this, void 0);
        $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnecting.set(this, void 0);
        $cc9365d1d333c5b6$var$_StandardWalletAdapter_off.set(this, void 0);
        $cc9365d1d333c5b6$var$_StandardWalletAdapter_supportedTransactionVersions.set(this, void 0);
        $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet.set(this, void 0);
        $cc9365d1d333c5b6$var$_StandardWalletAdapter_readyState.set(this, typeof window === "undefined" || typeof document === "undefined" ? (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported : (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed);
        $cc9365d1d333c5b6$var$_StandardWalletAdapter_changed.set(this, (properties)=>{
            // If accounts have changed on the wallet, reflect this on the adapter.
            if ("accounts" in properties) {
                const account = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").accounts[0];
                // If the adapter isn't connected, or is disconnecting, or the first account hasn't changed, do nothing.
                if ($cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, "f") && !$cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnecting, "f") && account !== $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, "f")) {
                    // If there's a connected account, connect the adapter. Otherwise, disconnect it.
                    if (account) // Connect the adapter.
                    $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_connected).call(this, account);
                    else {
                        // Emit an error because the wallet spontaneously disconnected.
                        this.emit("error", new (0, $a800e3a804b49fac$export$bf7028c52ebda81e)());
                        // Disconnect the adapter.
                        $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnected).call(this);
                    }
                }
            }
            // After reflecting account changes, if features have changed on the wallet, reflect this on the adapter.
            if ("features" in properties) $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_reset).call(this);
        });
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, wallet, "f");
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, null, "f");
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_publicKey, null, "f");
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_connecting, false, "f");
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnecting, false, "f");
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_off, $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $81b0a26bfbf4e734$export$5296443ca9e9fa0f].on("change", $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_changed, "f")), "f");
        $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_reset).call(this);
    }
    destroy() {
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, null, "f");
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_publicKey, null, "f");
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_connecting, false, "f");
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnecting, false, "f");
        const off = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_off, "f");
        if (off) {
            $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_off, null, "f");
            off();
        }
    }
    async autoConnect() {
        return $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_connect).call(this, {
            silent: true
        });
    }
    async connect() {
        return $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_connect).call(this);
    }
    async disconnect() {
        if ((0, $7012ebc3e37cd89f$export$38dbd4bbb9b696e6) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features) try {
            $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnecting, true, "f");
            await $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $7012ebc3e37cd89f$export$38dbd4bbb9b696e6].disconnect();
        } catch (error) {
            this.emit("error", new (0, $a800e3a804b49fac$export$92e2b26fad5723ee)(error?.message, error));
        } finally{
            $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnecting, false, "f");
        }
        $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnected).call(this);
    }
    async sendTransaction(transaction, connection, options = {}) {
        try {
            const account = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, "f");
            if (!account) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            let feature;
            if ((0, $4bt7m.SolanaSignAndSendTransaction) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features) {
                if (account.features.includes((0, $4bt7m.SolanaSignAndSendTransaction))) feature = (0, $4bt7m.SolanaSignAndSendTransaction);
                else if ((0, $840Oq.SolanaSignTransaction) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features && account.features.includes((0, $840Oq.SolanaSignTransaction))) feature = (0, $840Oq.SolanaSignTransaction);
                else throw new (0, $a800e3a804b49fac$export$cd6fa2f8e2a8a612)();
            } else if ((0, $840Oq.SolanaSignTransaction) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features) {
                if (!account.features.includes((0, $840Oq.SolanaSignTransaction))) throw new (0, $a800e3a804b49fac$export$cd6fa2f8e2a8a612)();
                feature = (0, $840Oq.SolanaSignTransaction);
            } else throw new (0, $a800e3a804b49fac$export$9525019988612a5e)();
            const chain = (0, $4b0dba91f194f909$export$43dcd8213c5a5741)(connection.rpcEndpoint);
            if (!account.chains.includes(chain)) throw new (0, $a800e3a804b49fac$export$769332ac3f90f46c)();
            try {
                const { signers: signers, ...sendOptions } = options;
                let serializedTransaction;
                if ((0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(transaction)) {
                    signers?.length && transaction.sign(signers);
                    serializedTransaction = transaction.serialize();
                } else {
                    transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                    signers?.length && transaction.partialSign(...signers);
                    serializedTransaction = new Uint8Array(transaction.serialize({
                        requireAllSignatures: false,
                        verifySignatures: false
                    }));
                }
                if (feature === (0, $4bt7m.SolanaSignAndSendTransaction)) {
                    const [output] = await $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $4bt7m.SolanaSignAndSendTransaction].signAndSendTransaction({
                        account: account,
                        chain: chain,
                        transaction: serializedTransaction,
                        options: {
                            preflightCommitment: (0, $bd56e19e4f91ca4b$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                            skipPreflight: sendOptions.skipPreflight,
                            maxRetries: sendOptions.maxRetries,
                            minContextSlot: sendOptions.minContextSlot
                        }
                    });
                    return (0, $40c056ff6698da7a$export$2e2bcd8739ae039).encode(output.signature);
                } else {
                    const [output] = await $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $840Oq.SolanaSignTransaction].signTransaction({
                        account: account,
                        chain: chain,
                        transaction: serializedTransaction,
                        options: {
                            preflightCommitment: (0, $bd56e19e4f91ca4b$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                            minContextSlot: sendOptions.minContextSlot
                        }
                    });
                    return await connection.sendRawTransaction(output.signedTransaction, {
                        ...sendOptions,
                        preflightCommitment: (0, $bd56e19e4f91ca4b$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment)
                    });
                }
            } catch (error) {
                if (error instanceof (0, $a800e3a804b49fac$export$f46ec6f9dba8711d)) throw error;
                throw new (0, $a800e3a804b49fac$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
}
$cc9365d1d333c5b6$var$_StandardWalletAdapter_account = new WeakMap(), $cc9365d1d333c5b6$var$_StandardWalletAdapter_publicKey = new WeakMap(), $cc9365d1d333c5b6$var$_StandardWalletAdapter_connecting = new WeakMap(), $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnecting = new WeakMap(), $cc9365d1d333c5b6$var$_StandardWalletAdapter_off = new WeakMap(), $cc9365d1d333c5b6$var$_StandardWalletAdapter_supportedTransactionVersions = new WeakMap(), $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet = new WeakMap(), $cc9365d1d333c5b6$var$_StandardWalletAdapter_readyState = new WeakMap(), $cc9365d1d333c5b6$var$_StandardWalletAdapter_changed = new WeakMap(), $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances = new WeakSet(), $cc9365d1d333c5b6$var$_StandardWalletAdapter_connect = async function _StandardWalletAdapter_connect(input) {
    try {
        if (this.connected || this.connecting) return;
        if ($cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_readyState, "f") !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed) throw new (0, $a800e3a804b49fac$export$d65db264eda99cd7)();
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_connecting, true, "f");
        if (!$cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").accounts.length) try {
            await $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $21c6ff693543ac7b$export$cc68487eeb93b1d4].connect(input);
        } catch (error) {
            throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(error?.message, error);
        }
        const account = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").accounts[0];
        if (!account) throw new (0, $a800e3a804b49fac$export$cd6fa2f8e2a8a612)();
        $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_connected).call(this, account);
    } catch (error) {
        this.emit("error", error);
        throw error;
    } finally{
        $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_connecting, false, "f");
    }
}, $cc9365d1d333c5b6$var$_StandardWalletAdapter_connected = function _StandardWalletAdapter_connected(account) {
    let publicKey;
    try {
        // Use account.address instead of account.publicKey since address could be a PDA
        publicKey = new (0, $1ZJZa.PublicKey)(account.address);
    } catch (error) {
        throw new (0, $a800e3a804b49fac$export$735bef3bfb0f2c86)(error?.message, error);
    }
    $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, account, "f");
    $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_publicKey, publicKey, "f");
    $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_reset).call(this);
    this.emit("connect", publicKey);
}, $cc9365d1d333c5b6$var$_StandardWalletAdapter_disconnected = function _StandardWalletAdapter_disconnected() {
    $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, null, "f");
    $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_publicKey, null, "f");
    $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_reset).call(this);
    this.emit("disconnect");
}, $cc9365d1d333c5b6$var$_StandardWalletAdapter_reset = function _StandardWalletAdapter_reset() {
    const supportedTransactionVersions = (0, $4bt7m.SolanaSignAndSendTransaction) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features ? $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $4bt7m.SolanaSignAndSendTransaction].supportedTransactionVersions : $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $840Oq.SolanaSignTransaction].supportedTransactionVersions;
    $cc9365d1d333c5b6$var$__classPrivateFieldSet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_supportedTransactionVersions, (0, $90d30fbb3dd8c216$export$234180f8206db11b)(supportedTransactionVersions, [
        "legacy"
    ]) ? null : new Set(supportedTransactionVersions), "f");
    if ((0, $840Oq.SolanaSignTransaction) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features && $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, "f")?.features.includes((0, $840Oq.SolanaSignTransaction))) {
        this.signTransaction = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_signTransaction);
        this.signAllTransactions = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_signAllTransactions);
    } else {
        delete this.signTransaction;
        delete this.signAllTransactions;
    }
    if ((0, $5sd65.SolanaSignMessage) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features && $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, "f")?.features.includes((0, $5sd65.SolanaSignMessage))) this.signMessage = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_signMessage);
    else delete this.signMessage;
    if ((0, $7d976b3d2343c8cf$export$8adeab75f48a3607) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features) this.signIn = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_signIn);
    else delete this.signIn;
}, $cc9365d1d333c5b6$var$_StandardWalletAdapter_signTransaction = async function _StandardWalletAdapter_signTransaction(transaction) {
    try {
        const account = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
        if (!((0, $840Oq.SolanaSignTransaction) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $a800e3a804b49fac$export$9525019988612a5e)();
        if (!account.features.includes((0, $840Oq.SolanaSignTransaction))) throw new (0, $a800e3a804b49fac$export$cd6fa2f8e2a8a612)();
        try {
            const signedTransactions = await $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $840Oq.SolanaSignTransaction].signTransaction({
                account: account,
                transaction: (0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                    requireAllSignatures: false,
                    verifySignatures: false
                }))
            });
            const serializedTransaction = signedTransactions[0].signedTransaction;
            return (0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(transaction) ? (0, $1ZJZa.VersionedTransaction).deserialize(serializedTransaction) : (0, $1ZJZa.Transaction).from(serializedTransaction);
        } catch (error) {
            if (error instanceof (0, $a800e3a804b49fac$export$f46ec6f9dba8711d)) throw error;
            throw new (0, $a800e3a804b49fac$export$96f177062fdd8180)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $cc9365d1d333c5b6$var$_StandardWalletAdapter_signAllTransactions = async function _StandardWalletAdapter_signAllTransactions(transactions) {
    try {
        const account = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
        if (!((0, $840Oq.SolanaSignTransaction) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $a800e3a804b49fac$export$9525019988612a5e)();
        if (!account.features.includes((0, $840Oq.SolanaSignTransaction))) throw new (0, $a800e3a804b49fac$export$cd6fa2f8e2a8a612)();
        try {
            const signedTransactions = await $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $840Oq.SolanaSignTransaction].signTransaction(...transactions.map((transaction)=>({
                    account: account,
                    transaction: (0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                        requireAllSignatures: false,
                        verifySignatures: false
                    }))
                })));
            return transactions.map((transaction, index)=>{
                const signedTransaction = signedTransactions[index].signedTransaction;
                return (0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(transaction) ? (0, $1ZJZa.VersionedTransaction).deserialize(signedTransaction) : (0, $1ZJZa.Transaction).from(signedTransaction);
            });
        } catch (error) {
            throw new (0, $a800e3a804b49fac$export$96f177062fdd8180)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $cc9365d1d333c5b6$var$_StandardWalletAdapter_signMessage = async function _StandardWalletAdapter_signMessage(message) {
    try {
        const account = $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
        if (!((0, $5sd65.SolanaSignMessage) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $a800e3a804b49fac$export$9525019988612a5e)();
        if (!account.features.includes((0, $5sd65.SolanaSignMessage))) throw new (0, $a800e3a804b49fac$export$cd6fa2f8e2a8a612)();
        try {
            const signedMessages = await $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $5sd65.SolanaSignMessage].signMessage({
                account: account,
                message: message
            });
            return signedMessages[0].signature;
        } catch (error) {
            throw new (0, $a800e3a804b49fac$export$2622c1721bbd4b17)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $cc9365d1d333c5b6$var$_StandardWalletAdapter_signIn = async function _StandardWalletAdapter_signIn(input = {}) {
    try {
        if (!((0, $7d976b3d2343c8cf$export$8adeab75f48a3607) in $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $a800e3a804b49fac$export$9525019988612a5e)();
        let output;
        try {
            [output] = await $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_wallet, "f").features[0, $7d976b3d2343c8cf$export$8adeab75f48a3607].signIn(input);
        } catch (error) {
            throw new (0, $a800e3a804b49fac$export$a4c7d3c66e3cdd6c)(error?.message, error);
        }
        if (!output) throw new (0, $a800e3a804b49fac$export$a4c7d3c66e3cdd6c)();
        $cc9365d1d333c5b6$var$__classPrivateFieldGet(this, $cc9365d1d333c5b6$var$_StandardWalletAdapter_instances, "m", $cc9365d1d333c5b6$var$_StandardWalletAdapter_connected).call(this, output.account);
        return output;
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
};


var $e051336b6e515043$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e051336b6e515043$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e051336b6e515043$var$_AppReadyEvent_detail;
let $e051336b6e515043$var$wallets = undefined;
const $e051336b6e515043$var$registeredWalletsSet = new Set();
function $e051336b6e515043$var$addRegisteredWallet(wallet) {
    $e051336b6e515043$var$cachedWalletsArray = undefined;
    $e051336b6e515043$var$registeredWalletsSet.add(wallet);
}
function $e051336b6e515043$var$removeRegisteredWallet(wallet) {
    $e051336b6e515043$var$cachedWalletsArray = undefined;
    $e051336b6e515043$var$registeredWalletsSet.delete(wallet);
}
const $e051336b6e515043$var$listeners = {};
function $e051336b6e515043$export$ac4d188b6eef3eb7() {
    if ($e051336b6e515043$var$wallets) return $e051336b6e515043$var$wallets;
    $e051336b6e515043$var$wallets = Object.freeze({
        register: $e051336b6e515043$var$register,
        get: $e051336b6e515043$var$get,
        on: $e051336b6e515043$var$on
    });
    if (typeof window === "undefined") return $e051336b6e515043$var$wallets;
    const api = Object.freeze({
        register: $e051336b6e515043$var$register
    });
    try {
        window.addEventListener("wallet-standard:register-wallet", ({ detail: callback })=>callback(api));
    } catch (error) {
        console.error("wallet-standard:register-wallet event listener could not be added\n", error);
    }
    try {
        window.dispatchEvent(new $e051336b6e515043$var$AppReadyEvent(api));
    } catch (error) {
        console.error("wallet-standard:app-ready event could not be dispatched\n", error);
    }
    return $e051336b6e515043$var$wallets;
}
function $e051336b6e515043$var$register(...wallets) {
    // Filter out wallets that have already been registered.
    // This prevents the same wallet from being registered twice, but it also prevents wallets from being
    // unregistered by reusing a reference to the wallet to obtain the unregister function for it.
    wallets = wallets.filter((wallet)=>!$e051336b6e515043$var$registeredWalletsSet.has(wallet));
    // If there are no new wallets to register, just return a no-op unregister function.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!wallets.length) return ()=>{};
    wallets.forEach((wallet)=>$e051336b6e515043$var$addRegisteredWallet(wallet));
    $e051336b6e515043$var$listeners["register"]?.forEach((listener)=>$e051336b6e515043$var$guard(()=>listener(...wallets)));
    // Return a function that unregisters the registered wallets.
    return function unregister() {
        wallets.forEach((wallet)=>$e051336b6e515043$var$removeRegisteredWallet(wallet));
        $e051336b6e515043$var$listeners["unregister"]?.forEach((listener)=>$e051336b6e515043$var$guard(()=>listener(...wallets)));
    };
}
let $e051336b6e515043$var$cachedWalletsArray;
function $e051336b6e515043$var$get() {
    if (!$e051336b6e515043$var$cachedWalletsArray) $e051336b6e515043$var$cachedWalletsArray = [
        ...$e051336b6e515043$var$registeredWalletsSet
    ];
    return $e051336b6e515043$var$cachedWalletsArray;
}
function $e051336b6e515043$var$on(event, listener) {
    $e051336b6e515043$var$listeners[event]?.push(listener) || ($e051336b6e515043$var$listeners[event] = [
        listener
    ]);
    // Return a function that removes the event listener.
    return function off() {
        $e051336b6e515043$var$listeners[event] = $e051336b6e515043$var$listeners[event]?.filter((existingListener)=>listener !== existingListener);
    };
}
function $e051336b6e515043$var$guard(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}
class $e051336b6e515043$var$AppReadyEvent extends Event {
    get detail() {
        return $e051336b6e515043$var$__classPrivateFieldGet(this, $e051336b6e515043$var$_AppReadyEvent_detail, "f");
    }
    get type() {
        return "wallet-standard:app-ready";
    }
    constructor(api){
        super("wallet-standard:app-ready", {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $e051336b6e515043$var$_AppReadyEvent_detail.set(this, void 0);
        $e051336b6e515043$var$__classPrivateFieldSet(this, $e051336b6e515043$var$_AppReadyEvent_detail, api, "f");
    }
    /** @deprecated */ preventDefault() {
        throw new Error("preventDefault cannot be called");
    }
    /** @deprecated */ stopImmediatePropagation() {
        throw new Error("stopImmediatePropagation cannot be called");
    }
    /** @deprecated */ stopPropagation() {
        throw new Error("stopPropagation cannot be called");
    }
}
$e051336b6e515043$var$_AppReadyEvent_detail = new WeakMap();
function $e051336b6e515043$export$2194deb72a59836d() {
    if ($e051336b6e515043$var$wallets) return $e051336b6e515043$var$wallets;
    $e051336b6e515043$var$wallets = $e051336b6e515043$export$ac4d188b6eef3eb7();
    if (typeof window === "undefined") return $e051336b6e515043$var$wallets;
    const callbacks = window.navigator.wallets || [];
    if (!Array.isArray(callbacks)) {
        console.error("window.navigator.wallets is not an array");
        return $e051336b6e515043$var$wallets;
    }
    const { register: register } = $e051336b6e515043$var$wallets;
    const push = (...callbacks)=>callbacks.forEach((callback)=>$e051336b6e515043$var$guard(()=>callback({
                    register: register
                })));
    try {
        Object.defineProperty(window.navigator, "wallets", {
            value: Object.freeze({
                push: push
            })
        });
    } catch (error) {
        console.error("window.navigator.wallets could not be set");
        return $e051336b6e515043$var$wallets;
    }
    push(...callbacks);
    return $e051336b6e515043$var$wallets;
}



var $bnENU = parcelRequire("bnENU");
function $e383bfa102e46933$export$ca3bd81d254ceecf(adapters) {
    const warnings = $e383bfa102e46933$var$useConstant(()=>new Set());
    const { get: get, on: on } = $e383bfa102e46933$var$useConstant(()=>(0, $e051336b6e515043$export$2194deb72a59836d)());
    const [standardAdapters, setStandardAdapters] = (0, $bnENU.useState)(()=>$e383bfa102e46933$var$wrapWalletsWithAdapters(get()));
    (0, $bnENU.useEffect)(()=>{
        const listeners = [
            on("register", (...wallets)=>setStandardAdapters((standardAdapters)=>[
                        ...standardAdapters,
                        ...$e383bfa102e46933$var$wrapWalletsWithAdapters(wallets)
                    ])),
            on("unregister", (...wallets)=>setStandardAdapters((standardAdapters)=>standardAdapters.filter((standardAdapter)=>wallets.some((wallet)=>wallet === standardAdapter.wallet))))
        ];
        return ()=>listeners.forEach((off)=>off());
    }, [
        on
    ]);
    const prevStandardAdapters = $e383bfa102e46933$var$usePrevious(standardAdapters);
    (0, $bnENU.useEffect)(()=>{
        if (!prevStandardAdapters) return;
        const currentAdapters = new Set(standardAdapters);
        const removedAdapters = new Set(prevStandardAdapters.filter((previousAdapter)=>!currentAdapters.has(previousAdapter)));
        removedAdapters.forEach((adapter)=>adapter.destroy());
    }, [
        prevStandardAdapters,
        standardAdapters
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $bnENU.useEffect)(()=>()=>standardAdapters.forEach((adapter)=>adapter.destroy()), []);
    return (0, $bnENU.useMemo)(()=>[
            ...standardAdapters,
            ...adapters.filter(({ name: name })=>{
                if (standardAdapters.some((standardAdapter)=>standardAdapter.name === name)) {
                    if (!warnings.has(name)) {
                        warnings.add(name);
                        console.warn(`${name} was registered as a Standard Wallet. The Wallet Adapter for ${name} can be removed from your app.`);
                    }
                    return false;
                }
                return true;
            })
        ], [
        standardAdapters,
        adapters,
        warnings
    ]);
}
function $e383bfa102e46933$var$useConstant(fn) {
    const ref = (0, $bnENU.useRef)(undefined);
    if (ref.current === undefined) ref.current = {
        value: fn()
    };
    return ref.current.value;
}
function $e383bfa102e46933$var$usePrevious(state) {
    const ref = (0, $bnENU.useRef)(undefined);
    (0, $bnENU.useEffect)(()=>{
        ref.current = state;
    });
    return ref.current;
}
function $e383bfa102e46933$var$wrapWalletsWithAdapters(wallets) {
    return wallets.filter((0, $1dd3a3d79212cd66$export$c5439c91843266e6)).map((wallet)=>new (0, $cc9365d1d333c5b6$export$e0949de9e32fe3b2)({
            wallet: wallet
        }));
}



var $bnENU = parcelRequire("bnENU");


var $19e371d1c44cd73b$export$7dc6752a22ab011a;
(function(Environment) {
    Environment[Environment["DESKTOP_WEB"] = 0] = "DESKTOP_WEB";
    Environment[Environment["MOBILE_WEB"] = 1] = "MOBILE_WEB";
})($19e371d1c44cd73b$export$7dc6752a22ab011a || ($19e371d1c44cd73b$export$7dc6752a22ab011a = {}));
function $19e371d1c44cd73b$var$isWebView(userAgentString) {
    return /(WebView|Version\/.+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)|; wv\).+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+))/i.test(userAgentString);
}
function $19e371d1c44cd73b$export$2e2bcd8739ae039({ adapters: adapters, userAgentString: userAgentString }) {
    if (adapters.some((adapter)=>adapter.name !== (0, $89727768601eecb3$export$f1265e9082f346f1) && adapter.readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed)) /**
         * There are only two ways a browser extension adapter should be able to reach `Installed` status:
         *
         *     1. Its browser extension is installed.
         *     2. The app is running on a mobile wallet's in-app browser.
         *
         * In either case, we consider the environment to be desktop-like.
         */ return $19e371d1c44cd73b$export$7dc6752a22ab011a.DESKTOP_WEB;
    if (userAgentString && // Step 1: Check whether we're on a platform that supports MWA at all.
    /android/i.test(userAgentString) && // Step 2: Determine that we are *not* running in a WebView.
    !$19e371d1c44cd73b$var$isWebView(userAgentString)) return $19e371d1c44cd73b$export$7dc6752a22ab011a.MOBILE_WEB;
    else return $19e371d1c44cd73b$export$7dc6752a22ab011a.DESKTOP_WEB;
}


function $321d6039ad111135$export$2e2bcd8739ae039(endpoint) {
    if (!endpoint) return "mainnet-beta";
    if (/devnet/i.test(endpoint)) return "devnet";
    else if (/testnet/i.test(endpoint)) return "testnet";
    else return "mainnet-beta";
}




var $bnENU = parcelRequire("bnENU");
function $8b35f4d577ed1c15$export$86e2cef2561044ac(key, defaultState) {
    const state = (0, $bnENU.useState)(()=>{
        try {
            const value = localStorage.getItem(key);
            if (value) return JSON.parse(value);
        } catch (error) {
            if (typeof window !== "undefined") console.error(error);
        }
        return defaultState;
    });
    const value = state[0];
    const isFirstRenderRef = (0, $bnENU.useRef)(true);
    (0, $bnENU.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        try {
            if (value === null) localStorage.removeItem(key);
            else localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            if (typeof window !== "undefined") console.error(error);
        }
    }, [
        value,
        key
    ]);
    return state;
}




var $bnENU = parcelRequire("bnENU");

class $74093a16a55b5014$export$3f5ccdf96415785c extends (0, $a800e3a804b49fac$export$f46ec6f9dba8711d) {
    constructor(){
        super(...arguments);
        this.name = "WalletNotSelectedError";
    }
}



function $65fbb3187c0ec428$export$a50b3c99d691184b({ children: children, wallets: adapters, adapter: adapter, isUnloadingRef: isUnloadingRef, onAutoConnectRequest: onAutoConnectRequest, onConnectError: onConnectError, onError: onError, onSelectWallet: onSelectWallet }) {
    const isConnectingRef = (0, $bnENU.useRef)(false);
    const [connecting, setConnecting] = (0, $bnENU.useState)(false);
    const isDisconnectingRef = (0, $bnENU.useRef)(false);
    const [disconnecting, setDisconnecting] = (0, $bnENU.useState)(false);
    const [publicKey, setPublicKey] = (0, $bnENU.useState)(()=>adapter?.publicKey ?? null);
    const [connected, setConnected] = (0, $bnENU.useState)(()=>adapter?.connected ?? false);
    /**
     * Store the error handlers as refs so that a change in the
     * custom error handler does not recompute other dependencies.
     */ const onErrorRef = (0, $bnENU.useRef)(onError);
    (0, $bnENU.useEffect)(()=>{
        onErrorRef.current = onError;
        return ()=>{
            onErrorRef.current = undefined;
        };
    }, [
        onError
    ]);
    const handleErrorRef = (0, $bnENU.useRef)((error, adapter)=>{
        if (!isUnloadingRef.current) {
            if (onErrorRef.current) onErrorRef.current(error, adapter);
            else {
                console.error(error, adapter);
                if (error instanceof (0, $a800e3a804b49fac$export$d65db264eda99cd7) && typeof window !== "undefined" && adapter) window.open(adapter.url, "_blank");
            }
        }
        return error;
    });
    // Wrap adapters to conform to the `Wallet` interface
    const [wallets, setWallets] = (0, $bnENU.useState)(()=>adapters.map((adapter)=>({
                adapter: adapter,
                readyState: adapter.readyState
            })).filter(({ readyState: readyState })=>readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported));
    // When the adapters change, start to listen for changes to their `readyState`
    (0, $bnENU.useEffect)(()=>{
        // When the adapters change, wrap them to conform to the `Wallet` interface
        setWallets((wallets)=>adapters.map((adapter, index)=>{
                const wallet = wallets[index];
                // If the wallet hasn't changed, return the same instance
                return wallet && wallet.adapter === adapter && wallet.readyState === adapter.readyState ? wallet : {
                    adapter: adapter,
                    readyState: adapter.readyState
                };
            }).filter(({ readyState: readyState })=>readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported));
        function handleReadyStateChange(readyState) {
            setWallets((prevWallets)=>{
                const index = prevWallets.findIndex(({ adapter: adapter })=>adapter === this);
                if (index === -1) return prevWallets;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const { adapter: adapter } = prevWallets[index];
                return [
                    ...prevWallets.slice(0, index),
                    {
                        adapter: adapter,
                        readyState: readyState
                    },
                    ...prevWallets.slice(index + 1)
                ].filter(({ readyState: readyState })=>readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported);
            });
        }
        adapters.forEach((adapter)=>adapter.on("readyStateChange", handleReadyStateChange, adapter));
        return ()=>{
            adapters.forEach((adapter)=>adapter.off("readyStateChange", handleReadyStateChange, adapter));
        };
    }, [
        adapter,
        adapters
    ]);
    const wallet = (0, $bnENU.useMemo)(()=>wallets.find((wallet)=>wallet.adapter === adapter) ?? null, [
        adapter,
        wallets
    ]);
    // Setup and teardown event listeners when the adapter changes
    (0, $bnENU.useEffect)(()=>{
        if (!adapter) return;
        const handleConnect = (publicKey)=>{
            setPublicKey(publicKey);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(true);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        const handleDisconnect = ()=>{
            if (isUnloadingRef.current) return;
            setPublicKey(null);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(false);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        const handleError = (error)=>{
            handleErrorRef.current(error, adapter);
        };
        adapter.on("connect", handleConnect);
        adapter.on("disconnect", handleDisconnect);
        adapter.on("error", handleError);
        return ()=>{
            adapter.off("connect", handleConnect);
            adapter.off("disconnect", handleDisconnect);
            adapter.off("error", handleError);
            handleDisconnect();
        };
    }, [
        adapter,
        isUnloadingRef
    ]);
    // When the adapter changes, clear the `autoConnect` tracking flag
    const didAttemptAutoConnectRef = (0, $bnENU.useRef)(false);
    (0, $bnENU.useEffect)(()=>{
        return ()=>{
            didAttemptAutoConnectRef.current = false;
        };
    }, [
        adapter
    ]);
    // If auto-connect is enabled, request to connect when the adapter changes and is ready
    (0, $bnENU.useEffect)(()=>{
        if (didAttemptAutoConnectRef.current || isConnectingRef.current || connected || !onAutoConnectRequest || !(wallet?.readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed || wallet?.readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable)) return;
        isConnectingRef.current = true;
        setConnecting(true);
        didAttemptAutoConnectRef.current = true;
        (async function() {
            try {
                await onAutoConnectRequest();
            } catch  {
                onConnectError();
            // Drop the error. It will be caught by `handleError` anyway.
            } finally{
                setConnecting(false);
                isConnectingRef.current = false;
            }
        })();
    }, [
        connected,
        onAutoConnectRequest,
        onConnectError,
        wallet
    ]);
    // Send a transaction using the provided connection
    const sendTransaction = (0, $bnENU.useCallback)(async (transaction, connection, options)=>{
        if (!adapter) throw handleErrorRef.current(new (0, $74093a16a55b5014$export$3f5ccdf96415785c)());
        if (!connected) throw handleErrorRef.current(new (0, $a800e3a804b49fac$export$313d299817c74896)(), adapter);
        return await adapter.sendTransaction(transaction, connection, options);
    }, [
        adapter,
        connected
    ]);
    // Sign a transaction if the wallet supports it
    const signTransaction = (0, $bnENU.useMemo)(()=>adapter && "signTransaction" in adapter ? async (transaction)=>{
            if (!connected) throw handleErrorRef.current(new (0, $a800e3a804b49fac$export$313d299817c74896)(), adapter);
            return await adapter.signTransaction(transaction);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign multiple transactions if the wallet supports it
    const signAllTransactions = (0, $bnENU.useMemo)(()=>adapter && "signAllTransactions" in adapter ? async (transactions)=>{
            if (!connected) throw handleErrorRef.current(new (0, $a800e3a804b49fac$export$313d299817c74896)(), adapter);
            return await adapter.signAllTransactions(transactions);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign an arbitrary message if the wallet supports it
    const signMessage = (0, $bnENU.useMemo)(()=>adapter && "signMessage" in adapter ? async (message)=>{
            if (!connected) throw handleErrorRef.current(new (0, $a800e3a804b49fac$export$313d299817c74896)(), adapter);
            return await adapter.signMessage(message);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign in if the wallet supports it
    const signIn = (0, $bnENU.useMemo)(()=>adapter && "signIn" in adapter ? async (input)=>{
            return await adapter.signIn(input);
        } : undefined, [
        adapter
    ]);
    const handleConnect = (0, $bnENU.useCallback)(async ()=>{
        if (isConnectingRef.current || isDisconnectingRef.current || wallet?.adapter.connected) return;
        if (!wallet) throw handleErrorRef.current(new (0, $74093a16a55b5014$export$3f5ccdf96415785c)());
        const { adapter: adapter, readyState: readyState } = wallet;
        if (!(readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed || readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable)) throw handleErrorRef.current(new (0, $a800e3a804b49fac$export$d65db264eda99cd7)(), adapter);
        isConnectingRef.current = true;
        setConnecting(true);
        try {
            await adapter.connect();
        } catch (e) {
            onConnectError();
            throw e;
        } finally{
            setConnecting(false);
            isConnectingRef.current = false;
        }
    }, [
        onConnectError,
        wallet
    ]);
    const handleDisconnect = (0, $bnENU.useCallback)(async ()=>{
        if (isDisconnectingRef.current) return;
        if (!adapter) return;
        isDisconnectingRef.current = true;
        setDisconnecting(true);
        try {
            await adapter.disconnect();
        } finally{
            setDisconnecting(false);
            isDisconnectingRef.current = false;
        }
    }, [
        adapter
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $a5bd67d4bd834f44$export$19648c908dc8d0bf).Provider, {
        value: {
            autoConnect: !!onAutoConnectRequest,
            wallets: wallets,
            wallet: wallet,
            publicKey: publicKey,
            connected: connected,
            connecting: connecting,
            disconnecting: disconnecting,
            select: onSelectWallet,
            connect: handleConnect,
            disconnect: handleDisconnect,
            sendTransaction: sendTransaction,
            signTransaction: signTransaction,
            signAllTransactions: signAllTransactions,
            signMessage: signMessage,
            signIn: signIn
        }
    }, children);
}


let $132d3e8c6c6b1529$var$_userAgent;
function $132d3e8c6c6b1529$var$getUserAgent() {
    if ($132d3e8c6c6b1529$var$_userAgent === undefined) $132d3e8c6c6b1529$var$_userAgent = globalThis.navigator?.userAgent ?? null;
    return $132d3e8c6c6b1529$var$_userAgent;
}
function $132d3e8c6c6b1529$var$getIsMobile(adapters) {
    const userAgentString = $132d3e8c6c6b1529$var$getUserAgent();
    return (0, $19e371d1c44cd73b$export$2e2bcd8739ae039)({
        adapters: adapters,
        userAgentString: userAgentString
    }) === (0, $19e371d1c44cd73b$export$7dc6752a22ab011a).MOBILE_WEB;
}
function $132d3e8c6c6b1529$var$getUriForAppIdentity() {
    const location = globalThis.location;
    if (!location) return;
    return `${location.protocol}//${location.host}`;
}
function $132d3e8c6c6b1529$export$717b22fc3a2082b3({ children: children, wallets: adapters, autoConnect: autoConnect, localStorageKey: localStorageKey = "walletName", onError: onError }) {
    const { connection: connection } = (0, $bcafec560369c8f2$export$985e8768c0e91dbc)();
    const adaptersWithStandardAdapters = (0, $e383bfa102e46933$export$ca3bd81d254ceecf)(adapters);
    const mobileWalletAdapter = (0, $bnENU.useMemo)(()=>{
        if (!$132d3e8c6c6b1529$var$getIsMobile(adaptersWithStandardAdapters)) return null;
        const existingMobileWalletAdapter = adaptersWithStandardAdapters.find((adapter)=>adapter.name === (0, $89727768601eecb3$export$f1265e9082f346f1));
        if (existingMobileWalletAdapter) return existingMobileWalletAdapter;
        return new (0, $89727768601eecb3$export$dec251788b2f5a84)({
            addressSelector: (0, $89727768601eecb3$export$a299fb0acc11345b)(),
            appIdentity: {
                uri: $132d3e8c6c6b1529$var$getUriForAppIdentity()
            },
            authorizationResultCache: (0, $89727768601eecb3$export$4a0b597891770806)(),
            cluster: (0, $321d6039ad111135$export$2e2bcd8739ae039)(connection?.rpcEndpoint),
            onWalletNotFound: (0, $89727768601eecb3$export$e8b9e70cdf783b70)()
        });
    }, [
        adaptersWithStandardAdapters,
        connection?.rpcEndpoint
    ]);
    const adaptersWithMobileWalletAdapter = (0, $bnENU.useMemo)(()=>{
        if (mobileWalletAdapter == null || adaptersWithStandardAdapters.indexOf(mobileWalletAdapter) !== -1) return adaptersWithStandardAdapters;
        return [
            mobileWalletAdapter,
            ...adaptersWithStandardAdapters
        ];
    }, [
        adaptersWithStandardAdapters,
        mobileWalletAdapter
    ]);
    const [walletName, setWalletName] = (0, $8b35f4d577ed1c15$export$86e2cef2561044ac)(localStorageKey, null);
    const adapter = (0, $bnENU.useMemo)(()=>adaptersWithMobileWalletAdapter.find((a)=>a.name === walletName) ?? null, [
        adaptersWithMobileWalletAdapter,
        walletName
    ]);
    const changeWallet = (0, $bnENU.useCallback)((nextWalletName)=>{
        if (walletName === nextWalletName) return;
        if (adapter && // Selecting a wallet other than the mobile wallet adapter is not
        // sufficient reason to call `disconnect` on the mobile wallet adapter.
        // Calling `disconnect` on the mobile wallet adapter causes the entire
        // authorization store to be wiped.
        adapter.name !== (0, $89727768601eecb3$export$f1265e9082f346f1)) adapter.disconnect();
        setWalletName(nextWalletName);
    }, [
        adapter,
        setWalletName,
        walletName
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (!adapter) return;
        function handleDisconnect() {
            if (isUnloadingRef.current) return;
            setWalletName(null);
        }
        adapter.on("disconnect", handleDisconnect);
        return ()=>{
            adapter.off("disconnect", handleDisconnect);
        };
    }, [
        adapter,
        adaptersWithStandardAdapters,
        setWalletName,
        walletName
    ]);
    const hasUserSelectedAWallet = (0, $bnENU.useRef)(false);
    const handleAutoConnectRequest = (0, $bnENU.useMemo)(()=>{
        if (!autoConnect || !adapter) return;
        return async ()=>{
            // If autoConnect is true or returns true, use the default autoConnect behavior.
            if (autoConnect === true || await autoConnect(adapter)) {
                if (hasUserSelectedAWallet.current) await adapter.connect();
                else await adapter.autoConnect();
            }
        };
    }, [
        autoConnect,
        adapter
    ]);
    const isUnloadingRef = (0, $bnENU.useRef)(false);
    (0, $bnENU.useEffect)(()=>{
        if (walletName === (0, $89727768601eecb3$export$f1265e9082f346f1) && $132d3e8c6c6b1529$var$getIsMobile(adaptersWithStandardAdapters)) {
            isUnloadingRef.current = false;
            return;
        }
        function handleBeforeUnload() {
            isUnloadingRef.current = true;
        }
        /**
         * Some wallets fire disconnection events when the window unloads. Since there's no way to
         * distinguish between a disconnection event received because a user initiated it, and one
         * that was received because they've closed the window, we have to track window unload
         * events themselves. Downstream components use this information to decide whether to act
         * upon or drop wallet events and errors.
         */ window.addEventListener("beforeunload", handleBeforeUnload);
        return ()=>{
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [
        adaptersWithStandardAdapters,
        walletName
    ]);
    const handleConnectError = (0, $bnENU.useCallback)(()=>{
        if (adapter) // If any error happens while connecting, unset the adapter.
        changeWallet(null);
    }, [
        adapter,
        changeWallet
    ]);
    const selectWallet = (0, $bnENU.useCallback)((walletName)=>{
        hasUserSelectedAWallet.current = true;
        changeWallet(walletName);
    }, [
        changeWallet
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $65fbb3187c0ec428$export$a50b3c99d691184b), {
        wallets: adaptersWithMobileWalletAdapter,
        adapter: adapter,
        isUnloadingRef: isUnloadingRef,
        onAutoConnectRequest: handleAutoConnectRequest,
        onConnectError: handleConnectError,
        onError: onError,
        onSelectWallet: selectWallet
    }, children);
}



var $1ZJZa = parcelRequire("1ZJZa");

var $1ZJZa = parcelRequire("1ZJZa");

var $1ZJZa = parcelRequire("1ZJZa");
const $d917ee7adac252f0$export$79de3e3c2b1ca801 = new (0, $1ZJZa.PublicKey)("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
const $d917ee7adac252f0$export$8183845dc9f5ce72 = new (0, $1ZJZa.PublicKey)("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
const $d917ee7adac252f0$export$57a4f33bcc1767fa = new (0, $1ZJZa.PublicKey)("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
const $d917ee7adac252f0$export$71f490c6a4aef7af = new (0, $1ZJZa.PublicKey)("So11111111111111111111111111111111111111112");
const $d917ee7adac252f0$export$710fe796384b28ef = new (0, $1ZJZa.PublicKey)("9pan9bMn5HatX4EJdBwg9VgCa7Uz5HL8N1m5D3NdXejP");
function $d917ee7adac252f0$export$839bb614a661d99b(programId) {
    if (programId.equals($d917ee7adac252f0$export$79de3e3c2b1ca801)) return false;
    else return true;
}



var $Bz0HP = parcelRequire("Bz0HP");
const $694e77c67e168237$export$15db02dbfcaf60e0 = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};



var $Bz0HP = parcelRequire("Bz0HP");

var $dZYIo = parcelRequire("dZYIo");


var $jtAZT = parcelRequire("jtAZT");
var $3dd23c74bb3fd3eb$require$Buffer = $jtAZT.Buffer;
const $3dd23c74bb3fd3eb$export$c97e695afb26d84 = (length)=>(property)=>{
        const layout = (0, $Bz0HP.blob)(length, property);
        const { encode: encode, decode: decode } = (0, $694e77c67e168237$export$15db02dbfcaf60e0)(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $dZYIo.toBigIntLE)($3dd23c74bb3fd3eb$require$Buffer.from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $dZYIo.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $3dd23c74bb3fd3eb$export$8fa7afc0d3e063a4 = (length)=>(property)=>{
        const layout = (0, $Bz0HP.blob)(length, property);
        const { encode: encode, decode: decode } = (0, $694e77c67e168237$export$15db02dbfcaf60e0)(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $dZYIo.toBigIntBE)($3dd23c74bb3fd3eb$require$Buffer.from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $dZYIo.toBufferBE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $3dd23c74bb3fd3eb$export$cd1442401e54cffa = $3dd23c74bb3fd3eb$export$c97e695afb26d84(8);
const $3dd23c74bb3fd3eb$export$7f18746cf5292838 = $3dd23c74bb3fd3eb$export$8fa7afc0d3e063a4(8);
const $3dd23c74bb3fd3eb$export$6cebf8c93d35ecb4 = $3dd23c74bb3fd3eb$export$c97e695afb26d84(16);
const $3dd23c74bb3fd3eb$export$327689723be22772 = $3dd23c74bb3fd3eb$export$8fa7afc0d3e063a4(16);
const $3dd23c74bb3fd3eb$export$8f928ec3e6d68946 = $3dd23c74bb3fd3eb$export$c97e695afb26d84(24);
const $3dd23c74bb3fd3eb$export$559ccecc3c5a7252 = $3dd23c74bb3fd3eb$export$8fa7afc0d3e063a4(24);
const $3dd23c74bb3fd3eb$export$c6d3c723c6dee16b = $3dd23c74bb3fd3eb$export$c97e695afb26d84(32);
const $3dd23c74bb3fd3eb$export$667f357a9402d24c = $3dd23c74bb3fd3eb$export$8fa7afc0d3e063a4(32);


/*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var $14d312813cccd844$var$isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, $14d312813cccd844$var$mathceil = Math.ceil, $14d312813cccd844$var$mathfloor = Math.floor, $14d312813cccd844$var$bignumberError = "[BigNumber Error] ", $14d312813cccd844$var$tooManyDigits = $14d312813cccd844$var$bignumberError + "Number primitive has more than 15 significant digits: ", $14d312813cccd844$var$BASE = 1e14, $14d312813cccd844$var$LOG_BASE = 14, $14d312813cccd844$var$MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
$14d312813cccd844$var$POWS_TEN = [
    1,
    10,
    100,
    1e3,
    1e4,
    1e5,
    1e6,
    1e7,
    1e8,
    1e9,
    1e10,
    1e11,
    1e12,
    1e13
], $14d312813cccd844$var$SQRT_BASE = 1e7, // EDITABLE
// The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
// the arguments to toExponential, toFixed, toFormat, and toPrecision.
$14d312813cccd844$var$MAX = 1E9; // 0 to MAX_INT32
/*
 * Create and return a BigNumber constructor.
 */ function $14d312813cccd844$var$clone(configObject) {
    var div, convertBase, parseNumeric, P = BigNumber.prototype = {
        constructor: BigNumber,
        toString: null,
        valueOf: null
    }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.
    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: "\xa0",
        suffix: ""
    }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
    //------------------------------------------------------------------------------------------
    // CONSTRUCTOR
    /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */ function BigNumber(v, b) {
        var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
        // Enable constructor call without `new`.
        if (!(x instanceof BigNumber)) return new BigNumber(v, b);
        if (b == null) {
            if (v && v._isBigNumber === true) {
                x.s = v.s;
                if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                else if (v.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
                else {
                    x.e = v.e;
                    x.c = v.c.slice();
                }
                return;
            }
            if ((isNum = typeof v == "number") && v * 0 == 0) {
                // Use `1 / n` to handle minus zero also.
                x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                // Fast path for integers, where n < 2147483648 (2**31).
                if (v === ~~v) {
                    for(e = 0, i = v; i >= 10; i /= 10, e++);
                    if (e > MAX_EXP) x.c = x.e = null;
                    else {
                        x.e = e;
                        x.c = [
                            v
                        ];
                    }
                    return;
                }
                str = String(v);
            } else {
                if (!$14d312813cccd844$var$isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
            }
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            // Exponential form?
            if ((i = str.search(/e/i)) > 0) {
                // Determine exponent.
                if (e < 0) e = i;
                e += +str.slice(i + 1);
                str = str.substring(0, i);
            } else if (e < 0) // Integer.
            e = str.length;
        } else {
            // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
            $14d312813cccd844$var$intCheck(b, 2, ALPHABET.length, "Base");
            // Allow exponential notation to be used with base 10 argument, while
            // also rounding to DECIMAL_PLACES as with other bases.
            if (b == 10 && alphabetHasNormalDecimalDigits) {
                x = new BigNumber(v);
                return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
            }
            str = String(v);
            if (isNum = typeof v == "number") {
                // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error($14d312813cccd844$var$tooManyDigits + v);
            } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
            alphabet = ALPHABET.slice(0, b);
            e = i = 0;
            // Check that str is a valid base b number.
            // Don't use RegExp, so alphabet can contain special characters.
            for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                if (c == ".") // If '.' is not the first character and it has not be found before.
                {
                    if (i > e) {
                        e = len;
                        continue;
                    }
                } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                {
                    if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                        caseChanged = true;
                        i = -1;
                        e = 0;
                        continue;
                    }
                }
                return parseNumeric(x, String(v), isNum, b);
            }
            // Prevent later check for length on converted number.
            isNum = false;
            str = convertBase(str, b, 10, x.s);
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            else e = str.length;
        }
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(--len) === 48;);
        if (str = str.slice(i, ++len)) {
            len -= i;
            // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
            if (isNum && BigNumber.DEBUG && len > 15 && (v > $14d312813cccd844$var$MAX_SAFE_INTEGER || v !== $14d312813cccd844$var$mathfloor(v))) throw Error($14d312813cccd844$var$tooManyDigits + x.s * v);
            // Overflow?
            if ((e = e - i - 1) > MAX_EXP) // Infinity.
            x.c = x.e = null;
            else if (e < MIN_EXP) // Zero.
            x.c = [
                x.e = 0
            ];
            else {
                x.e = e;
                x.c = [];
                // Transform base
                // e is the base 10 exponent.
                // i is where to slice str to get the first element of the coefficient array.
                i = (e + 1) % $14d312813cccd844$var$LOG_BASE;
                if (e < 0) i += $14d312813cccd844$var$LOG_BASE; // i < 1
                if (i < len) {
                    if (i) x.c.push(+str.slice(0, i));
                    for(len -= $14d312813cccd844$var$LOG_BASE; i < len;)x.c.push(+str.slice(i, i += $14d312813cccd844$var$LOG_BASE));
                    i = $14d312813cccd844$var$LOG_BASE - (str = str.slice(i)).length;
                } else i -= len;
                for(; i--; str += "0");
                x.c.push(+str);
            }
        } else // Zero.
        x.c = [
            x.e = 0
        ];
    }
    // CONSTRUCTOR PROPERTIES
    BigNumber.clone = $14d312813cccd844$var$clone;
    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;
    /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */ BigNumber.config = BigNumber.set = function(obj) {
        var p, v;
        if (obj != null) {
            if (typeof obj == "object") {
                // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                    v = obj[p];
                    $14d312813cccd844$var$intCheck(v, 0, $14d312813cccd844$var$MAX, p);
                    DECIMAL_PLACES = v;
                }
                // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                    v = obj[p];
                    $14d312813cccd844$var$intCheck(v, 0, 8, p);
                    ROUNDING_MODE = v;
                }
                // EXPONENTIAL_AT {number|number[]}
                // Integer, -MAX to MAX inclusive or
                // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $14d312813cccd844$var$intCheck(v[0], -$14d312813cccd844$var$MAX, 0, p);
                        $14d312813cccd844$var$intCheck(v[1], 0, $14d312813cccd844$var$MAX, p);
                        TO_EXP_NEG = v[0];
                        TO_EXP_POS = v[1];
                    } else {
                        $14d312813cccd844$var$intCheck(v, -$14d312813cccd844$var$MAX, $14d312813cccd844$var$MAX, p);
                        TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                    }
                }
                // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                if (obj.hasOwnProperty(p = "RANGE")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $14d312813cccd844$var$intCheck(v[0], -$14d312813cccd844$var$MAX, -1, p);
                        $14d312813cccd844$var$intCheck(v[1], 1, $14d312813cccd844$var$MAX, p);
                        MIN_EXP = v[0];
                        MAX_EXP = v[1];
                    } else {
                        $14d312813cccd844$var$intCheck(v, -$14d312813cccd844$var$MAX, $14d312813cccd844$var$MAX, p);
                        if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                        else throw Error($14d312813cccd844$var$bignumberError + p + " cannot be zero: " + v);
                    }
                }
                // CRYPTO {boolean} true or false.
                // '[BigNumber Error] CRYPTO not true or false: {v}'
                // '[BigNumber Error] crypto unavailable'
                if (obj.hasOwnProperty(p = "CRYPTO")) {
                    v = obj[p];
                    if (v === !!v) {
                        if (v) {
                            if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                            else {
                                CRYPTO = !v;
                                throw Error($14d312813cccd844$var$bignumberError + "crypto unavailable");
                            }
                        } else CRYPTO = v;
                    } else throw Error($14d312813cccd844$var$bignumberError + p + " not true or false: " + v);
                }
                // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                    v = obj[p];
                    $14d312813cccd844$var$intCheck(v, 0, 9, p);
                    MODULO_MODE = v;
                }
                // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                    v = obj[p];
                    $14d312813cccd844$var$intCheck(v, 0, $14d312813cccd844$var$MAX, p);
                    POW_PRECISION = v;
                }
                // FORMAT {object}
                // '[BigNumber Error] FORMAT not an object: {v}'
                if (obj.hasOwnProperty(p = "FORMAT")) {
                    v = obj[p];
                    if (typeof v == "object") FORMAT = v;
                    else throw Error($14d312813cccd844$var$bignumberError + p + " not an object: " + v);
                }
                // ALPHABET {string}
                // '[BigNumber Error] ALPHABET invalid: {v}'
                if (obj.hasOwnProperty(p = "ALPHABET")) {
                    v = obj[p];
                    // Disallow if less than two characters,
                    // or if it contains '+', '-', '.', whitespace, or a repeated character.
                    if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                        alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                        ALPHABET = v;
                    } else throw Error($14d312813cccd844$var$bignumberError + p + " invalid: " + v);
                }
            } else // '[BigNumber Error] Object expected: {v}'
            throw Error($14d312813cccd844$var$bignumberError + "Object expected: " + obj);
        }
        return {
            DECIMAL_PLACES: DECIMAL_PLACES,
            ROUNDING_MODE: ROUNDING_MODE,
            EXPONENTIAL_AT: [
                TO_EXP_NEG,
                TO_EXP_POS
            ],
            RANGE: [
                MIN_EXP,
                MAX_EXP
            ],
            CRYPTO: CRYPTO,
            MODULO_MODE: MODULO_MODE,
            POW_PRECISION: POW_PRECISION,
            FORMAT: FORMAT,
            ALPHABET: ALPHABET
        };
    };
    /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */ BigNumber.isBigNumber = function(v) {
        if (!v || v._isBigNumber !== true) return false;
        if (!BigNumber.DEBUG) return true;
        var i, n, c = v.c, e = v.e, s = v.s;
        out: if (({}).toString.call(c) == "[object Array]") {
            if ((s === 1 || s === -1) && e >= -$14d312813cccd844$var$MAX && e <= $14d312813cccd844$var$MAX && e === $14d312813cccd844$var$mathfloor(e)) {
                // If the first element is zero, the BigNumber value must be zero.
                if (c[0] === 0) {
                    if (e === 0 && c.length === 1) return true;
                    break out;
                }
                // Calculate number of digits that c[0] should have, based on the exponent.
                i = (e + 1) % $14d312813cccd844$var$LOG_BASE;
                if (i < 1) i += $14d312813cccd844$var$LOG_BASE;
                // Calculate number of digits of c[0].
                //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                if (String(c[0]).length == i) {
                    for(i = 0; i < c.length; i++){
                        n = c[i];
                        if (n < 0 || n >= $14d312813cccd844$var$BASE || n !== $14d312813cccd844$var$mathfloor(n)) break out;
                    }
                    // Last element cannot be zero, unless it is the only element.
                    if (n !== 0) return true;
                }
            }
        } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
        throw Error($14d312813cccd844$var$bignumberError + "Invalid BigNumber: " + v);
    };
    /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.maximum = BigNumber.max = function() {
        return maxOrMin(arguments, -1);
    };
    /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.minimum = BigNumber.min = function() {
        return maxOrMin(arguments, 1);
    };
    /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */ BigNumber.random = function() {
        var pow2_53 = 0x20000000000000;
        // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
        // Check if Math.random() produces more than 32 bits of randomness.
        // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
        // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
        var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
            return $14d312813cccd844$var$mathfloor(Math.random() * pow2_53);
        } : function() {
            return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
        };
        return function(dp) {
            var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
            if (dp == null) dp = DECIMAL_PLACES;
            else $14d312813cccd844$var$intCheck(dp, 0, $14d312813cccd844$var$MAX);
            k = $14d312813cccd844$var$mathceil(dp / $14d312813cccd844$var$LOG_BASE);
            if (CRYPTO) {
                // Browsers supporting crypto.getRandomValues.
                if (crypto.getRandomValues) {
                    a = crypto.getRandomValues(new Uint32Array(k *= 2));
                    for(; i < k;){
                        // 53 bits:
                        // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                        // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                        // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                        //                                     11111 11111111 11111111
                        // 0x20000 is 2^21.
                        v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                        // Rejection sampling:
                        // 0 <= v < 9007199254740992
                        // Probability that v >= 9e15, is
                        // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                        if (v >= 9e15) {
                            b = crypto.getRandomValues(new Uint32Array(2));
                            a[i] = b[0];
                            a[i + 1] = b[1];
                        } else {
                            // 0 <= v <= 8999999999999999
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 2;
                        }
                    }
                    i = k / 2;
                // Node.js supporting crypto.randomBytes.
                } else if (crypto.randomBytes) {
                    // buffer
                    a = crypto.randomBytes(k *= 7);
                    for(; i < k;){
                        // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                        // 0x100000000 is 2^32, 0x1000000 is 2^24
                        // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                        // 0 <= v < 9007199254740992
                        v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                        if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                        else {
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 7;
                        }
                    }
                    i = k / 7;
                } else {
                    CRYPTO = false;
                    throw Error($14d312813cccd844$var$bignumberError + "crypto unavailable");
                }
            }
            // Use Math.random.
            if (!CRYPTO) for(; i < k;){
                v = random53bitInt();
                if (v < 9e15) c[i++] = v % 1e14;
            }
            k = c[--i];
            dp %= $14d312813cccd844$var$LOG_BASE;
            // Convert trailing digits to zeros according to dp.
            if (k && dp) {
                v = $14d312813cccd844$var$POWS_TEN[$14d312813cccd844$var$LOG_BASE - dp];
                c[i] = $14d312813cccd844$var$mathfloor(k / v) * v;
            }
            // Remove trailing elements which are zero.
            for(; c[i] === 0; c.pop(), i--);
            // Zero?
            if (i < 0) c = [
                e = 0
            ];
            else {
                // Remove leading elements which are zero and adjust exponent accordingly.
                for(e = -1; c[0] === 0; c.splice(0, 1), e -= $14d312813cccd844$var$LOG_BASE);
                // Count the digits of the first element of c to determine leading zeros, and...
                for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                // adjust the exponent accordingly.
                if (i < $14d312813cccd844$var$LOG_BASE) e -= $14d312813cccd844$var$LOG_BASE - i;
            }
            rand.e = e;
            rand.c = c;
            return rand;
        };
    }();
    /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.sum = function() {
        var i = 1, args = arguments, sum = new BigNumber(args[0]);
        for(; i < args.length;)sum = sum.plus(args[i++]);
        return sum;
    };
    // PRIVATE FUNCTIONS
    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = function() {
        var decimal = "0123456789";
        /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */ function toBaseOut(str, baseIn, baseOut, alphabet) {
            var j, arr = [
                0
            ], arrL, i = 0, len = str.length;
            for(; i < len;){
                for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                arr[0] += alphabet.indexOf(str.charAt(i++));
                for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                    if (arr[j + 1] == null) arr[j + 1] = 0;
                    arr[j + 1] += arr[j] / baseOut | 0;
                    arr[j] %= baseOut;
                }
            }
            return arr.reverse();
        }
        // Convert a numeric string of baseIn to a numeric string of baseOut.
        // If the caller is toString, we are converting from base 10 to baseOut.
        // If the caller is BigNumber, we are converting from baseIn to base 10.
        return function(str, baseIn, baseOut, sign, callerIsToString) {
            var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
            // Non-integer.
            if (i >= 0) {
                k = POW_PRECISION;
                // Unlimited precision.
                POW_PRECISION = 0;
                str = str.replace(".", "");
                y = new BigNumber(baseIn);
                x = y.pow(str.length - i);
                POW_PRECISION = k;
                // Convert str as if an integer, then restore the fraction part by dividing the
                // result by its base raised to a power.
                y.c = toBaseOut($14d312813cccd844$var$toFixedPoint($14d312813cccd844$var$coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                y.e = y.c.length;
            }
            // Convert the number as integer.
            xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
            // xc now represents str as an integer and converted to baseOut. e is the exponent.
            e = k = xc.length;
            // Remove trailing zeros.
            for(; xc[--k] == 0; xc.pop());
            // Zero?
            if (!xc[0]) return alphabet.charAt(0);
            // Does str represent an integer? If so, no need for the division.
            if (i < 0) --e;
            else {
                x.c = xc;
                x.e = e;
                // The sign is needed for correct rounding.
                x.s = sign;
                x = div(x, y, dp, rm, baseOut);
                xc = x.c;
                r = x.r;
                e = x.e;
            }
            // xc now represents str converted to baseOut.
            // THe index of the rounding digit.
            d = e + dp + 1;
            // The rounding digit: the digit to the right of the digit that may be rounded up.
            i = xc[d];
            // Look at the rounding digits and mode to determine whether to round up.
            k = baseOut / 2;
            r = r || d < 0 || xc[d + 1] != null;
            r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
            // If the index of the rounding digit is not greater than zero, or xc represents
            // zero, then the result of the base conversion is zero or, if rounding up, a value
            // such as 0.00001.
            if (d < 1 || !xc[0]) // 1^-dp or 0
            str = r ? $14d312813cccd844$var$toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
            else {
                // Truncate xc to the required number of decimal places.
                xc.length = d;
                // Round up?
                if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(--baseOut; ++xc[--d] > baseOut;){
                    xc[d] = 0;
                    if (!d) {
                        ++e;
                        xc = [
                            1
                        ].concat(xc);
                    }
                }
                // Determine trailing zeros.
                for(k = xc.length; !xc[--k];);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                // Add leading zeros, decimal point and trailing zeros as required.
                str = $14d312813cccd844$var$toFixedPoint(str, e, alphabet.charAt(0));
            }
            // The caller will add the sign.
            return str;
        };
    }();
    // Perform division in the specified base. Called by div and convertBase.
    div = function() {
        // Assume non-zero x and k.
        function multiply(x, k, base) {
            var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % $14d312813cccd844$var$SQRT_BASE, khi = k / $14d312813cccd844$var$SQRT_BASE | 0;
            for(x = x.slice(); i--;){
                xlo = x[i] % $14d312813cccd844$var$SQRT_BASE;
                xhi = x[i] / $14d312813cccd844$var$SQRT_BASE | 0;
                m = khi * xlo + xhi * klo;
                temp = klo * xlo + m % $14d312813cccd844$var$SQRT_BASE * $14d312813cccd844$var$SQRT_BASE + carry;
                carry = (temp / base | 0) + (m / $14d312813cccd844$var$SQRT_BASE | 0) + khi * xhi;
                x[i] = temp % base;
            }
            if (carry) x = [
                carry
            ].concat(x);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, cmp;
            if (aL != bL) cmp = aL > bL ? 1 : -1;
            else {
                for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                    cmp = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return cmp;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1; a.splice(0, 1));
        }
        // x: dividend, y: divisor.
        return function(x, y, dp, rm, base) {
            var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
            // Either NaN, Infinity or 0?
            if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
            !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
            q = new BigNumber(s);
            qc = q.c = [];
            e = x.e - y.e;
            s = dp + e + 1;
            if (!base) {
                base = $14d312813cccd844$var$BASE;
                e = $14d312813cccd844$var$bitFloor(x.e / $14d312813cccd844$var$LOG_BASE) - $14d312813cccd844$var$bitFloor(y.e / $14d312813cccd844$var$LOG_BASE);
                s = s / $14d312813cccd844$var$LOG_BASE | 0;
            }
            // Result exponent may be one less then the current value of e.
            // The coefficients of the BigNumbers from convertBase may have trailing zeros.
            for(i = 0; yc[i] == (xc[i] || 0); i++);
            if (yc[i] > (xc[i] || 0)) e--;
            if (s < 0) {
                qc.push(1);
                more = true;
            } else {
                xL = xc.length;
                yL = yc.length;
                i = 0;
                s += 2;
                // Normalise xc and yc so highest order digit of yc is >= base / 2.
                n = $14d312813cccd844$var$mathfloor(base / (yc[0] + 1));
                // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                if (n > 1) {
                    yc = multiply(yc, n, base);
                    xc = multiply(xc, n, base);
                    yL = yc.length;
                    xL = xc.length;
                }
                xi = yL;
                rem = xc.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL; rem[remL++] = 0);
                yz = yc.slice();
                yz = [
                    0
                ].concat(yz);
                yc0 = yc[0];
                if (yc[1] >= base / 2) yc0++;
                // Not necessary, but to prevent trial digit n > base, when using base 3.
                // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                do {
                    n = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yc, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, n.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                        // n is how many times the divisor goes into the current remainder.
                        n = $14d312813cccd844$var$mathfloor(rem0 / yc0);
                        //  Algorithm:
                        //  product = divisor multiplied by trial digit (n).
                        //  Compare product and remainder.
                        //  If product is greater than remainder:
                        //    Subtract divisor from product, decrement trial digit.
                        //  Subtract product from remainder.
                        //  If product was less than remainder at the last compare:
                        //    Compare new remainder and divisor.
                        //    If remainder is greater than divisor:
                        //      Subtract divisor from remainder, increment trial digit.
                        if (n > 1) {
                            // n may be > base only when base is 3.
                            if (n >= base) n = base - 1;
                            // product = divisor * trial digit.
                            prod = multiply(yc, n, base);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            // If product > remainder then trial digit n too high.
                            // n is 1 too high about 5% of the time, and is not known to have
                            // ever been more than 1 too high.
                            while(compare(prod, rem, prodL, remL) == 1){
                                n--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                prodL = prod.length;
                                cmp = 1;
                            }
                        } else {
                            // n is 0 or 1, cmp is -1.
                            // If n is 0, there is no need to compare yc and rem again below,
                            // so change cmp to 1 to avoid it.
                            // If n is 1, leave cmp as -1, so yc and rem are compared again.
                            if (n == 0) // divisor < remainder, so n must be at least 1.
                            cmp = n = 1;
                            // product = divisor
                            prod = yc.slice();
                            prodL = prod.length;
                        }
                        if (prodL < remL) prod = [
                            0
                        ].concat(prod);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL, base);
                        remL = rem.length;
                        // If product was < remainder.
                        if (cmp == -1) // Compare divisor and new remainder.
                        // If divisor < new remainder, subtract divisor from remainder.
                        // Trial digit n too low.
                        // n is 1 too low about 5% of the time, and very rarely 2 too low.
                        while(compare(yc, rem, yL, remL) < 1){
                            n++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yc, remL, base);
                            remL = rem.length;
                        }
                    } else if (cmp === 0) {
                        n++;
                        rem = [
                            0
                        ];
                    } // else cmp === 1 and n will be 0
                    // Add the next digit, n, to the result array.
                    qc[i++] = n;
                    // Update the remainder.
                    if (rem[0]) rem[remL++] = xc[xi] || 0;
                    else {
                        rem = [
                            xc[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] != null) && s--);
                more = rem[0] != null;
                // Leading zero?
                if (!qc[0]) qc.splice(0, 1);
            }
            if (base == $14d312813cccd844$var$BASE) {
                // To calculate q.e, first get the number of digits of qc[0].
                for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                round(q, dp + (q.e = i + e * $14d312813cccd844$var$LOG_BASE - 1) + 1, rm, more);
            // Caller is convertBase.
            } else {
                q.e = e;
                q.r = +more;
            }
            return q;
        };
    }();
    /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */ function format(n, i, rm, id) {
        var c0, e, ne, len, str;
        if (rm == null) rm = ROUNDING_MODE;
        else $14d312813cccd844$var$intCheck(rm, 0, 8);
        if (!n.c) return n.toString();
        c0 = n.c[0];
        ne = n.e;
        if (i == null) {
            str = $14d312813cccd844$var$coeffToString(n.c);
            str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? $14d312813cccd844$var$toExponential(str, ne) : $14d312813cccd844$var$toFixedPoint(str, ne, "0");
        } else {
            n = round(new BigNumber(n), i, rm);
            // n.e may have changed if the value was rounded up.
            e = n.e;
            str = $14d312813cccd844$var$coeffToString(n.c);
            len = str.length;
            // toPrecision returns exponential notation if the number of significant digits
            // specified is less than the number of digits necessary to represent the integer
            // part of the value in fixed-point notation.
            // Exponential notation.
            if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                // Append zeros?
                for(; len < i; str += "0", len++);
                str = $14d312813cccd844$var$toExponential(str, e);
            // Fixed-point notation.
            } else {
                i -= ne;
                str = $14d312813cccd844$var$toFixedPoint(str, e, "0");
                // Append zeros?
                if (e + 1 > len) {
                    if (--i > 0) for(str += "."; i--; str += "0");
                } else {
                    i += e - len;
                    if (i > 0) {
                        if (e + 1 == len) str += ".";
                        for(; i--; str += "0");
                    }
                }
            }
        }
        return n.s < 0 && c0 ? "-" + str : str;
    }
    // Handle BigNumber.max and BigNumber.min.
    // If any number is NaN, return NaN.
    function maxOrMin(args, n) {
        var k, y, i = 1, x = new BigNumber(args[0]);
        for(; i < args.length; i++){
            y = new BigNumber(args[i]);
            if (!y.s || (k = $14d312813cccd844$var$compare(x, y)) === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */ function normalise(n, c, e) {
        var i = 1, j = c.length;
        // Remove trailing zeros.
        for(; !c[--j]; c.pop());
        // Calculate the base 10 exponent. First get the number of digits of c[0].
        for(j = c[0]; j >= 10; j /= 10, i++);
        // Overflow?
        if ((e = i + e * $14d312813cccd844$var$LOG_BASE - 1) > MAX_EXP) // Infinity.
        n.c = n.e = null;
        else if (e < MIN_EXP) // Zero.
        n.c = [
            n.e = 0
        ];
        else {
            n.e = e;
            n.c = c;
        }
        return n;
    }
    // Handle values that fail the validity test in BigNumber.
    parseNumeric = function() {
        var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(x, str, isNum, b) {
            var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
            // No exception on ±Infinity or NaN.
            if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
            else {
                if (!isNum) {
                    // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                    s = s.replace(basePrefix, function(m, p1, p2) {
                        base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                        return !b || b == base ? p1 : m;
                    });
                    if (b) {
                        base = b;
                        // E.g. '1.' to '1', '.1' to '0.1'
                        s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                    }
                    if (str != s) return new BigNumber(s, base);
                }
                // '[BigNumber Error] Not a number: {n}'
                // '[BigNumber Error] Not a base {b} number: {n}'
                if (BigNumber.DEBUG) throw Error($14d312813cccd844$var$bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                // NaN
                x.s = null;
            }
            x.c = x.e = null;
        };
    }();
    /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */ function round(x, sd, rm, r) {
        var d, i, j, k, n, ni, rd, xc = x.c, pows10 = $14d312813cccd844$var$POWS_TEN;
        // if x is not Infinity or NaN...
        if (xc) {
            // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
            // n is a base 1e14 number, the value of the element of array x.c containing rd.
            // ni is the index of n within x.c.
            // d is the number of digits of n.
            // i is the index of rd within n including leading zeros.
            // j is the actual index of rd within n (if < 0, rd is a leading zero).
            out: {
                // Get the number of digits of the first element of xc.
                for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                i = sd - d;
                // If the rounding digit is in the first element of xc...
                if (i < 0) {
                    i += $14d312813cccd844$var$LOG_BASE;
                    j = sd;
                    n = xc[ni = 0];
                    // Get the rounding digit at index j of n.
                    rd = $14d312813cccd844$var$mathfloor(n / pows10[d - j - 1] % 10);
                } else {
                    ni = $14d312813cccd844$var$mathceil((i + 1) / $14d312813cccd844$var$LOG_BASE);
                    if (ni >= xc.length) {
                        if (r) {
                            // Needed by sqrt.
                            for(; xc.length <= ni; xc.push(0));
                            n = rd = 0;
                            d = 1;
                            i %= $14d312813cccd844$var$LOG_BASE;
                            j = i - $14d312813cccd844$var$LOG_BASE + 1;
                        } else break out;
                    } else {
                        n = k = xc[ni];
                        // Get the number of digits of n.
                        for(d = 1; k >= 10; k /= 10, d++);
                        // Get the index of rd within n.
                        i %= $14d312813cccd844$var$LOG_BASE;
                        // Get the index of rd within n, adjusted for leading zeros.
                        // The number of leading zeros of n is given by LOG_BASE - d.
                        j = i - $14d312813cccd844$var$LOG_BASE + d;
                        // Get the rounding digit at index j of n.
                        rd = j < 0 ? 0 : $14d312813cccd844$var$mathfloor(n / pows10[d - j - 1] % 10);
                    }
                }
                r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                if (sd < 1 || !xc[0]) {
                    xc.length = 0;
                    if (r) {
                        // Convert sd to decimal places.
                        sd -= x.e + 1;
                        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                        xc[0] = pows10[($14d312813cccd844$var$LOG_BASE - sd % $14d312813cccd844$var$LOG_BASE) % $14d312813cccd844$var$LOG_BASE];
                        x.e = -sd || 0;
                    } else // Zero.
                    xc[0] = x.e = 0;
                    return x;
                }
                // Remove excess digits.
                if (i == 0) {
                    xc.length = ni;
                    k = 1;
                    ni--;
                } else {
                    xc.length = ni + 1;
                    k = pows10[$14d312813cccd844$var$LOG_BASE - i];
                    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                    // j > 0 means i > number of leading zeros of n.
                    xc[ni] = j > 0 ? $14d312813cccd844$var$mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                }
                // Round up?
                if (r) {
                    for(;;)// If the digit to be rounded up is in the first element of xc...
                    if (ni == 0) {
                        // i will be the length of xc[0] before k is added.
                        for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                        j = xc[0] += k;
                        for(k = 1; j >= 10; j /= 10, k++);
                        // if i != k the length has increased.
                        if (i != k) {
                            x.e++;
                            if (xc[0] == $14d312813cccd844$var$BASE) xc[0] = 1;
                        }
                        break;
                    } else {
                        xc[ni] += k;
                        if (xc[ni] != $14d312813cccd844$var$BASE) break;
                        xc[ni--] = 0;
                        k = 1;
                    }
                }
                // Remove trailing zeros.
                for(i = xc.length; xc[--i] === 0; xc.pop());
            }
            // Overflow? Infinity.
            if (x.e > MAX_EXP) x.c = x.e = null;
            else if (x.e < MIN_EXP) x.c = [
                x.e = 0
            ];
        }
        return x;
    }
    function valueOf(n) {
        var str, e = n.e;
        if (e === null) return n.toString();
        str = $14d312813cccd844$var$coeffToString(n.c);
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $14d312813cccd844$var$toExponential(str, e) : $14d312813cccd844$var$toFixedPoint(str, e, "0");
        return n.s < 0 ? "-" + str : str;
    }
    // PROTOTYPE/INSTANCE METHODS
    /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */ P.absoluteValue = P.abs = function() {
        var x = new BigNumber(this);
        if (x.s < 0) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */ P.comparedTo = function(y, b) {
        return $14d312813cccd844$var$compare(this, new BigNumber(y, b));
    };
    /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.decimalPlaces = P.dp = function(dp, rm) {
        var c, n, v, x = this;
        if (dp != null) {
            $14d312813cccd844$var$intCheck(dp, 0, $14d312813cccd844$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $14d312813cccd844$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), dp + x.e + 1, rm);
        }
        if (!(c = x.c)) return null;
        n = ((v = c.length - 1) - $14d312813cccd844$var$bitFloor(this.e / $14d312813cccd844$var$LOG_BASE)) * $14d312813cccd844$var$LOG_BASE;
        // Subtract the number of trailing zeros of the last number.
        if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
        if (n < 0) n = 0;
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.dividedBy = P.div = function(y, b) {
        return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };
    /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */ P.dividedToIntegerBy = P.idiv = function(y, b) {
        return div(this, new BigNumber(y, b), 0, 1);
    };
    /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */ P.exponentiatedBy = P.pow = function(n, m) {
        var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
        n = new BigNumber(n);
        // Allow NaN and ±Infinity, but not other non-integers.
        if (n.c && !n.isInteger()) throw Error($14d312813cccd844$var$bignumberError + "Exponent not an integer: " + valueOf(n));
        if (m != null) m = new BigNumber(m);
        // Exponent of MAX_SAFE_INTEGER is 15.
        nIsBig = n.e > 14;
        // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
        if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
            // The sign of the result of pow when x is negative depends on the evenness of n.
            // If +n overflows to ±Infinity, the evenness of n would be not be known.
            y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - $14d312813cccd844$var$isOdd(n)) : +valueOf(n)));
            return m ? y.mod(m) : y;
        }
        nIsNeg = n.s < 0;
        if (m) {
            // x % m returns NaN if abs(m) is zero, or m is NaN.
            if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
            isModExp = !nIsNeg && x.isInteger() && m.isInteger();
            if (isModExp) x = x.mod(m);
        // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
        // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
        } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
            // If x is negative and n is odd, k = -0, else k = 0.
            k = x.s < 0 && $14d312813cccd844$var$isOdd(n) ? -0 : 0;
            // If x >= 1, k = ±Infinity.
            if (x.e > -1) k = 1 / k;
            // If n is negative return ±0, else return ±Infinity.
            return new BigNumber(nIsNeg ? 1 / k : k);
        } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = $14d312813cccd844$var$mathceil(POW_PRECISION / $14d312813cccd844$var$LOG_BASE + 2);
        if (nIsBig) {
            half = new BigNumber(0.5);
            if (nIsNeg) n.s = 1;
            nIsOdd = $14d312813cccd844$var$isOdd(n);
        } else {
            i = Math.abs(+valueOf(n));
            nIsOdd = i % 2;
        }
        y = new BigNumber(ONE);
        // Performs 54 loop iterations for n of 9007199254740991.
        for(;;){
            if (nIsOdd) {
                y = y.times(x);
                if (!y.c) break;
                if (k) {
                    if (y.c.length > k) y.c.length = k;
                } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
            }
            if (i) {
                i = $14d312813cccd844$var$mathfloor(i / 2);
                if (i === 0) break;
                nIsOdd = i % 2;
            } else {
                n = n.times(half);
                round(n, n.e + 1, 1);
                if (n.e > 14) nIsOdd = $14d312813cccd844$var$isOdd(n);
                else {
                    i = +valueOf(n);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                }
            }
            x = x.times(x);
            if (k) {
                if (x.c && x.c.length > k) x.c.length = k;
            } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
        if (isModExp) return y;
        if (nIsNeg) y = ONE.div(y);
        return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */ P.integerValue = function(rm) {
        var n = new BigNumber(this);
        if (rm == null) rm = ROUNDING_MODE;
        else $14d312813cccd844$var$intCheck(rm, 0, 8);
        return round(n, n.e + 1, rm);
    };
    /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isEqualTo = P.eq = function(y, b) {
        return $14d312813cccd844$var$compare(this, new BigNumber(y, b)) === 0;
    };
    /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */ P.isFinite = function() {
        return !!this.c;
    };
    /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isGreaterThan = P.gt = function(y, b) {
        return $14d312813cccd844$var$compare(this, new BigNumber(y, b)) > 0;
    };
    /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
        return (b = $14d312813cccd844$var$compare(this, new BigNumber(y, b))) === 1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */ P.isInteger = function() {
        return !!this.c && $14d312813cccd844$var$bitFloor(this.e / $14d312813cccd844$var$LOG_BASE) > this.c.length - 2;
    };
    /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isLessThan = P.lt = function(y, b) {
        return $14d312813cccd844$var$compare(this, new BigNumber(y, b)) < 0;
    };
    /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
        return (b = $14d312813cccd844$var$compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */ P.isNegative = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */ P.isPositive = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */ P.isZero = function() {
        return !!this.c && this.c[0] == 0;
    };
    /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */ P.minus = function(y, b) {
        var i, j, t, xLTy, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xe = x.e / $14d312813cccd844$var$LOG_BASE, ye = y.e / $14d312813cccd844$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Either Infinity?
            if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
            // Either zero?
            if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
            ROUNDING_MODE == 3 ? -0 : 0);
        }
        xe = $14d312813cccd844$var$bitFloor(xe);
        ye = $14d312813cccd844$var$bitFloor(ye);
        xc = xc.slice();
        // Determine which is the bigger number.
        if (a = xe - ye) {
            if (xLTy = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            // Prepend zeros to equalise exponents.
            for(b = a; b--; t.push(0));
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xLTy = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xLTy) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        b = (j = yc.length) - (i = xc.length);
        // Append zeros to xc if shorter.
        // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
        if (b > 0) for(; b--; xc[i++] = 0);
        b = $14d312813cccd844$var$BASE - 1;
        // Subtract yc from xc.
        for(; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i]; xc[i] = b);
                --xc[i];
                xc[j] += $14d312813cccd844$var$BASE;
            }
            xc[j] -= yc[j];
        }
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] == 0; xc.splice(0, 1), --ye);
        // Zero?
        if (!xc[0]) {
            // Following IEEE 754 (2008) 6.3,
            // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
            y.s = ROUNDING_MODE == 3 ? -1 : 1;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
        // for finite x and y.
        return normalise(y, xc, ye);
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */ P.modulo = P.mod = function(y, b) {
        var q, s, x = this;
        y = new BigNumber(y, b);
        // Return NaN if x is Infinity or NaN, or y is NaN or zero.
        if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
        else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
        if (MODULO_MODE == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // r = x - qy    where  0 <= r < abs(y)
            s = y.s;
            y.s = 1;
            q = div(x, y, 0, 3);
            y.s = s;
            q.s *= s;
        } else q = div(x, y, 0, MODULO_MODE);
        y = x.minus(q.times(y));
        // To match JavaScript %, ensure sign of zero is sign of dividend.
        if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
        return y;
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */ P.multipliedBy = P.times = function(y, b) {
        var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
        // Either NaN, ±Infinity or ±0?
        if (!xc || !yc || !xc[0] || !yc[0]) {
            // Return NaN if either is NaN, or one is 0 and the other is Infinity.
            if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
            else {
                y.s *= x.s;
                // Return ±Infinity if either is ±Infinity.
                if (!xc || !yc) y.c = y.e = null;
                else {
                    y.c = [
                        0
                    ];
                    y.e = 0;
                }
            }
            return y;
        }
        e = $14d312813cccd844$var$bitFloor(x.e / $14d312813cccd844$var$LOG_BASE) + $14d312813cccd844$var$bitFloor(y.e / $14d312813cccd844$var$LOG_BASE);
        y.s *= x.s;
        xcL = xc.length;
        ycL = yc.length;
        // Ensure xc points to longer array and xcL to its length.
        if (xcL < ycL) {
            zc = xc;
            xc = yc;
            yc = zc;
            i = xcL;
            xcL = ycL;
            ycL = i;
        }
        // Initialise the result array with zeros.
        for(i = xcL + ycL, zc = []; i--; zc.push(0));
        base = $14d312813cccd844$var$BASE;
        sqrtBase = $14d312813cccd844$var$SQRT_BASE;
        for(i = ycL; --i >= 0;){
            c = 0;
            ylo = yc[i] % sqrtBase;
            yhi = yc[i] / sqrtBase | 0;
            for(k = xcL, j = i + k; j > i;){
                xlo = xc[--k] % sqrtBase;
                xhi = xc[k] / sqrtBase | 0;
                m = yhi * xlo + xhi * ylo;
                xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                zc[j--] = xlo % base;
            }
            zc[j] = c;
        }
        if (c) ++e;
        else zc.splice(0, 1);
        return normalise(y, zc, e);
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */ P.negated = function() {
        var x = new BigNumber(this);
        x.s = -x.s || null;
        return x;
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */ P.plus = function(y, b) {
        var t, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }
        var xe = x.e / $14d312813cccd844$var$LOG_BASE, ye = y.e / $14d312813cccd844$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Return ±Infinity if either ±Infinity.
            if (!xc || !yc) return new BigNumber(a / 0);
            // Either zero?
            // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
        }
        xe = $14d312813cccd844$var$bitFloor(xe);
        ye = $14d312813cccd844$var$bitFloor(ye);
        xc = xc.slice();
        // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
        if (a = xe - ye) {
            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }
            t.reverse();
            for(; a--; t.push(0));
            t.reverse();
        }
        a = xc.length;
        b = yc.length;
        // Point xc to the longer array, and b to the shorter length.
        if (a - b < 0) {
            t = yc;
            yc = xc;
            xc = t;
            b = a;
        }
        // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
        for(a = 0; b;){
            a = (xc[--b] = xc[b] + yc[b] + a) / $14d312813cccd844$var$BASE | 0;
            xc[b] = $14d312813cccd844$var$BASE === xc[b] ? 0 : xc[b] % $14d312813cccd844$var$BASE;
        }
        if (a) {
            xc = [
                a
            ].concat(xc);
            ++ye;
        }
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        // ye = MAX_EXP + 1 possible
        return normalise(y, xc, ye);
    };
    /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.precision = P.sd = function(sd, rm) {
        var c, n, v, x = this;
        if (sd != null && sd !== !!sd) {
            $14d312813cccd844$var$intCheck(sd, 1, $14d312813cccd844$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $14d312813cccd844$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), sd, rm);
        }
        if (!(c = x.c)) return null;
        v = c.length - 1;
        n = v * $14d312813cccd844$var$LOG_BASE + 1;
        if (v = c[v]) {
            // Subtract the number of trailing zeros of the last element.
            for(; v % 10 == 0; v /= 10, n--);
            // Add the number of digits of the first element.
            for(v = c[0]; v >= 10; v /= 10, n++);
        }
        if (sd && x.e + 1 > n) n = x.e + 1;
        return n;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */ P.shiftedBy = function(k) {
        $14d312813cccd844$var$intCheck(k, -$14d312813cccd844$var$MAX_SAFE_INTEGER, $14d312813cccd844$var$MAX_SAFE_INTEGER);
        return this.times("1e" + k);
    };
    /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.squareRoot = P.sqrt = function() {
        var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
        // Initial estimate.
        s = Math.sqrt(+valueOf(x));
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = $14d312813cccd844$var$coeffToString(c);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(+n);
            e = $14d312813cccd844$var$bitFloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new BigNumber(n);
        } else r = new BigNumber(s + "");
        // Check for zero.
        // r could be zero if MIN_EXP is changed after the this value was created.
        // This would cause a division by zero (x/t) and hence Infinity below, which would cause
        // coeffToString to throw.
        if (r.c[0]) {
            e = r.e;
            s = e + dp;
            if (s < 3) s = 0;
            // Newton-Raphson iteration.
            for(;;){
                t = r;
                r = half.times(t.plus(div(x, t, dp, 1)));
                if ($14d312813cccd844$var$coeffToString(t.c).slice(0, s) === (n = $14d312813cccd844$var$coeffToString(r.c)).slice(0, s)) {
                    // The exponent of r may here be one less than the final result exponent,
                    // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                    // are indexed correctly.
                    if (r.e < e) --s;
                    n = n.slice(s - 3, s + 1);
                    // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                    // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                    // iteration.
                    if (n == "9999" || !rep && n == "4999") {
                        // On the first iteration only, check to see if rounding up gives the
                        // exact result as the nines may infinitely repeat.
                        if (!rep) {
                            round(t, t.e + DECIMAL_PLACES + 2, 0);
                            if (t.times(t).eq(x)) {
                                r = t;
                                break;
                            }
                        }
                        dp += 4;
                        s += 4;
                        rep = 1;
                    } else {
                        // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                        // result. If not, then there are further digits and m will be truthy.
                        if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                            // Truncate to the first rounding digit.
                            round(r, r.e + DECIMAL_PLACES + 2, 1);
                            m = !r.times(r).eq(x);
                        }
                        break;
                    }
                }
            }
        }
        return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };
    /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toExponential = function(dp, rm) {
        if (dp != null) {
            $14d312813cccd844$var$intCheck(dp, 0, $14d312813cccd844$var$MAX);
            dp++;
        }
        return format(this, dp, rm, 1);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toFixed = function(dp, rm) {
        if (dp != null) {
            $14d312813cccd844$var$intCheck(dp, 0, $14d312813cccd844$var$MAX);
            dp = dp + this.e + 1;
        }
        return format(this, dp, rm);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */ P.toFormat = function(dp, rm, format) {
        var str, x = this;
        if (format == null) {
            if (dp != null && rm && typeof rm == "object") {
                format = rm;
                rm = null;
            } else if (dp && typeof dp == "object") {
                format = dp;
                dp = rm = null;
            } else format = FORMAT;
        } else if (typeof format != "object") throw Error($14d312813cccd844$var$bignumberError + "Argument not an object: " + format);
        str = x.toFixed(dp, rm);
        if (x.c) {
            var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
            if (g2) {
                i = g1;
                g1 = g2;
                g2 = i;
                len -= i;
            }
            if (g1 > 0 && len > 0) {
                i = len % g1 || g1;
                intPart = intDigits.substr(0, i);
                for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                if (isNeg) intPart = "-" + intPart;
            }
            str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
        }
        return (format.prefix || "") + str + (format.suffix || "");
    };
    /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */ P.toFraction = function(md) {
        var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
        if (md != null) {
            n = new BigNumber(md);
            // Throw if md is less than one or is not an integer, unless it is Infinity.
            if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error($14d312813cccd844$var$bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
        }
        if (!xc) return new BigNumber(x);
        d = new BigNumber(ONE);
        n1 = d0 = new BigNumber(ONE);
        d1 = n0 = new BigNumber(ONE);
        s = $14d312813cccd844$var$coeffToString(xc);
        // Determine initial denominator.
        // d is a power of 10 and the minimum max denominator that specifies the value exactly.
        e = d.e = s.length - x.e - 1;
        d.c[0] = $14d312813cccd844$var$POWS_TEN[(exp = e % $14d312813cccd844$var$LOG_BASE) < 0 ? $14d312813cccd844$var$LOG_BASE + exp : exp];
        md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
        exp = MAX_EXP;
        MAX_EXP = 1 / 0;
        n = new BigNumber(s);
        // n0 = d1 = 0
        n0.c[0] = 0;
        for(;;){
            q = div(n, d, 0, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.comparedTo(md) == 1) break;
            d0 = d1;
            d1 = d2;
            n1 = n0.plus(q.times(d2 = n1));
            n0 = d2;
            d = n.minus(q.times(d2 = d));
            n = d2;
        }
        d2 = div(md.minus(d0), d1, 0, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        e = e * 2;
        // Determine which fraction is closer to x, n0/d0 or n1/d1
        r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        MAX_EXP = exp;
        return r;
    };
    /*
   * Return the value of this BigNumber converted to a number primitive.
   */ P.toNumber = function() {
        return +valueOf(this);
    };
    /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.toPrecision = function(sd, rm) {
        if (sd != null) $14d312813cccd844$var$intCheck(sd, 1, $14d312813cccd844$var$MAX);
        return format(this, sd, rm, 2);
    };
    /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */ P.toString = function(b) {
        var str, n = this, s = n.s, e = n.e;
        // Infinity or NaN?
        if (e === null) {
            if (s) {
                str = "Infinity";
                if (s < 0) str = "-" + str;
            } else str = "NaN";
        } else {
            if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $14d312813cccd844$var$toExponential($14d312813cccd844$var$coeffToString(n.c), e) : $14d312813cccd844$var$toFixedPoint($14d312813cccd844$var$coeffToString(n.c), e, "0");
            else if (b === 10 && alphabetHasNormalDecimalDigits) {
                n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                str = $14d312813cccd844$var$toFixedPoint($14d312813cccd844$var$coeffToString(n.c), n.e, "0");
            } else {
                $14d312813cccd844$var$intCheck(b, 2, ALPHABET.length, "Base");
                str = convertBase($14d312813cccd844$var$toFixedPoint($14d312813cccd844$var$coeffToString(n.c), e, "0"), 10, b, s, true);
            }
            if (s < 0 && n.c[0]) str = "-" + str;
        }
        return str;
    };
    /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */ P.valueOf = P.toJSON = function() {
        return valueOf(this);
    };
    P._isBigNumber = true;
    P[Symbol.toStringTag] = "BigNumber";
    // Node.js v10.12.0+
    P[Symbol.for("nodejs.util.inspect.custom")] = P.valueOf;
    if (configObject != null) BigNumber.set(configObject);
    return BigNumber;
}
// PRIVATE HELPER FUNCTIONS
// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
function $14d312813cccd844$var$bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
}
// Return a coefficient array as a string of base 10 digits.
function $14d312813cccd844$var$coeffToString(a) {
    var s, z, i = 1, j = a.length, r = a[0] + "";
    for(; i < j;){
        s = a[i++] + "";
        z = $14d312813cccd844$var$LOG_BASE - s.length;
        for(; z--; s = "0" + s);
        r += s;
    }
    // Determine trailing zeros.
    for(j = r.length; r.charCodeAt(--j) === 48;);
    return r.slice(0, j + 1 || 1);
}
// Compare the value of BigNumbers x and y.
function $14d312813cccd844$var$compare(x, y) {
    var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
    // Either NaN?
    if (!i || !j) return null;
    a = xc && !xc[0];
    b = yc && !yc[0];
    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    a = i < 0;
    b = k == l;
    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;
    j = (k = xc.length) < (l = yc.length) ? k : l;
    // Compare digit by digit.
    for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
}
/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */ function $14d312813cccd844$var$intCheck(n, min, max, name) {
    if (n < min || n > max || n !== $14d312813cccd844$var$mathfloor(n)) throw Error($14d312813cccd844$var$bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
}
// Assumes finite n.
function $14d312813cccd844$var$isOdd(n) {
    var k = n.c.length - 1;
    return $14d312813cccd844$var$bitFloor(n.e / $14d312813cccd844$var$LOG_BASE) == k && n.c[k] % 2 != 0;
}
function $14d312813cccd844$var$toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
}
function $14d312813cccd844$var$toFixedPoint(str, e, z) {
    var len, zs;
    // Negative exponent?
    if (e < 0) {
        // Prepend zeros.
        for(zs = z + "."; ++e; zs += z);
        str = zs + str;
    // Positive exponent
    } else {
        len = str.length;
        // Append zeros.
        if (++e > len) {
            for(zs = z, e -= len; --e; zs += z);
            str += zs;
        } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
    }
    return str;
}
var $14d312813cccd844$export$d97aa349ed20696 = $14d312813cccd844$var$clone();
var $14d312813cccd844$export$2e2bcd8739ae039 = $14d312813cccd844$export$d97aa349ed20696;




const $a3578a447ee14d65$export$23054672248b2c43 = new (0, $14d312813cccd844$export$2e2bcd8739ae039)("1e+18");
const $a3578a447ee14d65$export$78a48a3d1e5dbe89 = (property)=>{
    const layout = (0, $3dd23c74bb3fd3eb$export$6cebf8c93d35ecb4)(property);
    const { encode: encode, decode: decode } = (0, $694e77c67e168237$export$15db02dbfcaf60e0)(layout);
    const decimalLayout = layout;
    decimalLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset).toString();
        return new (0, $14d312813cccd844$export$2e2bcd8739ae039)(src).div($a3578a447ee14d65$export$23054672248b2c43);
    };
    decimalLayout.encode = (decimal, buffer, offset)=>{
        const src = BigInt(decimal.times($a3578a447ee14d65$export$23054672248b2c43).integerValue().toString());
        return encode(src, buffer, offset);
    };
    return decimalLayout;
};



var $Bz0HP = parcelRequire("Bz0HP");

const $ca773c1ee6b15d17$export$87b259aa03e3d267 = (property)=>{
    const layout = (0, $Bz0HP.u8)(property);
    const { encode: encode, decode: decode } = (0, $694e77c67e168237$export$15db02dbfcaf60e0)(layout);
    const boolLayout = layout;
    boolLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset);
        return !!src;
    };
    boolLayout.encode = (bool, buffer, offset)=>{
        const src = Number(bool);
        return encode(src, buffer, offset);
    };
    return boolLayout;
};



var $Bz0HP = parcelRequire("Bz0HP");

var $1ZJZa = parcelRequire("1ZJZa");

const $e5e62a64975f14ba$export$86f13247979de5d7 = (property)=>{
    const layout = (0, $Bz0HP.blob)(32, property);
    const { encode: encode, decode: decode } = (0, $694e77c67e168237$export$15db02dbfcaf60e0)(layout);
    const publicKeyLayout = layout;
    publicKeyLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset);
        return new (0, $1ZJZa.PublicKey)(src);
    };
    publicKeyLayout.encode = (publicKey, buffer, offset)=>{
        const src = publicKey.toBuffer();
        return encode(src, buffer, offset);
    };
    return publicKeyLayout;
};





var $1ZJZa = parcelRequire("1ZJZa");

/** Base class for errors */ class $69531333edd951b2$export$ed0b8b496332122d extends Error {
    constructor(message){
        super(message);
    }
}
class $69531333edd951b2$export$a09a5e48de2f3404 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenAccountNotFoundError";
    }
}
class $69531333edd951b2$export$f4938317c78e324f extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountError";
    }
}
class $69531333edd951b2$export$8daa71fef5582c70 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountDataError";
    }
}
class $69531333edd951b2$export$abb470453474d51 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountOwnerError";
    }
}
class $69531333edd951b2$export$250d31de4ddb7ca5 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountSizeError";
    }
}
class $69531333edd951b2$export$871debb212ec395 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidMintError";
    }
}
class $69531333edd951b2$export$9d3e0012e0e06993 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidOwnerError";
    }
}
class $69531333edd951b2$export$c431a85da6f99bf0 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenOwnerOffCurveError";
    }
}
class $69531333edd951b2$export$a241007212c884f6 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionProgramError";
    }
}
class $69531333edd951b2$export$3882cbbd44973a88 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionKeysError";
    }
}
class $69531333edd951b2$export$f96a822f391c3cc4 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionDataError";
    }
}
class $69531333edd951b2$export$e1301365d704141e extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionTypeError";
    }
}
class $69531333edd951b2$export$ff48aa5f01687311 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenUnsupportedInstructionError";
    }
}
class $69531333edd951b2$export$f515f489e4a79004 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenTransferHookAccountNotFound";
    }
}
class $69531333edd951b2$export$9fe40fd85b8108b extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenTransferHookInvalidSeed";
    }
}
class $69531333edd951b2$export$de66998ed6d15b14 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenTransferHookAccountDataNotFound";
    }
}
class $69531333edd951b2$export$738537c82cc9bdda extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenTransferHookInvalidPubkeyData";
    }
}
class $69531333edd951b2$export$ded5cb4f781ab8d1 extends $69531333edd951b2$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenTransferHookPubkeyDataTooSmall";
    }
}


var $51028f78ac45d1f3$export$b8ca5fa4899cbfc7;
(function(AccountType) {
    AccountType[AccountType["Uninitialized"] = 0] = "Uninitialized";
    AccountType[AccountType["Mint"] = 1] = "Mint";
    AccountType[AccountType["Account"] = 2] = "Account";
})($51028f78ac45d1f3$export$b8ca5fa4899cbfc7 || ($51028f78ac45d1f3$export$b8ca5fa4899cbfc7 = {}));
const $51028f78ac45d1f3$export$9d3ac77dcbf22b3f = 1;



var $Bz0HP = parcelRequire("Bz0HP");






var $Bz0HP = parcelRequire("Bz0HP");



const $920ede22f3e57658$export$c23cd279ce124ca0 = (0, $Bz0HP.struct)([
    (0, $Bz0HP.u8)("m"),
    (0, $Bz0HP.u8)("n"),
    (0, $ca773c1ee6b15d17$export$87b259aa03e3d267)("isInitialized"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer1"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer2"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer3"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer4"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer5"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer6"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer7"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer8"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer9"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer10"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("signer11")
]);
const $920ede22f3e57658$export$c2abf71f91a1605b = $920ede22f3e57658$export$c23cd279ce124ca0.span;
async function $920ede22f3e57658$export$257dfa65916d8d24(connection, address, commitment, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    return $920ede22f3e57658$export$2620f4d387573ced(address, info, programId);
}
function $920ede22f3e57658$export$2620f4d387573ced(address, info, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801)) {
    if (!info) throw new (0, $69531333edd951b2$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $69531333edd951b2$export$abb470453474d51)();
    if (info.data.length != $920ede22f3e57658$export$c2abf71f91a1605b) throw new (0, $69531333edd951b2$export$250d31de4ddb7ca5)();
    const multisig = $920ede22f3e57658$export$c23cd279ce124ca0.decode(info.data);
    return {
        address: address,
        ...multisig
    };
}
async function $920ede22f3e57658$export$cd6dc5245600da53(connection, commitment) {
    return await connection.getMinimumBalanceForRentExemption($920ede22f3e57658$export$c2abf71f91a1605b, commitment);
}


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $bf0bcea1d7d4510a$export$a143d493d941bafc;
var $bf0bcea1d7d4510a$export$e4cf37d7f6fb9e0a;
var $bf0bcea1d7d4510a$export$f99ded8fe4b79145;
var $bf0bcea1d7d4510a$export$599f31c3813fae4d;
"use strict";

var $gxC2H = parcelRequire("gxC2H");

var $8YfQz = parcelRequire("8YfQz");
const $bf0bcea1d7d4510a$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$bf0bcea1d7d4510a$export$a143d493d941bafc = $bf0bcea1d7d4510a$var$Buffer;
$bf0bcea1d7d4510a$export$e4cf37d7f6fb9e0a = $bf0bcea1d7d4510a$var$SlowBuffer;
$bf0bcea1d7d4510a$export$f99ded8fe4b79145 = 50;
const $bf0bcea1d7d4510a$var$K_MAX_LENGTH = 0x7fffffff;
$bf0bcea1d7d4510a$export$599f31c3813fae4d = $bf0bcea1d7d4510a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $bf0bcea1d7d4510a$var$Buffer.TYPED_ARRAY_SUPPORT = $bf0bcea1d7d4510a$var$typedArraySupport();
if (!$bf0bcea1d7d4510a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $bf0bcea1d7d4510a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($bf0bcea1d7d4510a$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$bf0bcea1d7d4510a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($bf0bcea1d7d4510a$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$bf0bcea1d7d4510a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $bf0bcea1d7d4510a$var$createBuffer(length) {
    if (length > $bf0bcea1d7d4510a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $bf0bcea1d7d4510a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $bf0bcea1d7d4510a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $bf0bcea1d7d4510a$var$allocUnsafe(arg);
    }
    return $bf0bcea1d7d4510a$var$from(arg, encodingOrOffset, length);
}
$bf0bcea1d7d4510a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $bf0bcea1d7d4510a$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $bf0bcea1d7d4510a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $bf0bcea1d7d4510a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($bf0bcea1d7d4510a$var$isInstance(value, ArrayBuffer) || value && $bf0bcea1d7d4510a$var$isInstance(value.buffer, ArrayBuffer)) return $bf0bcea1d7d4510a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($bf0bcea1d7d4510a$var$isInstance(value, SharedArrayBuffer) || value && $bf0bcea1d7d4510a$var$isInstance(value.buffer, SharedArrayBuffer))) return $bf0bcea1d7d4510a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $bf0bcea1d7d4510a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $bf0bcea1d7d4510a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $bf0bcea1d7d4510a$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $bf0bcea1d7d4510a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $bf0bcea1d7d4510a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($bf0bcea1d7d4510a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($bf0bcea1d7d4510a$var$Buffer, Uint8Array);
function $bf0bcea1d7d4510a$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $bf0bcea1d7d4510a$var$alloc(size, fill, encoding) {
    $bf0bcea1d7d4510a$var$assertSize(size);
    if (size <= 0) return $bf0bcea1d7d4510a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $bf0bcea1d7d4510a$var$createBuffer(size).fill(fill, encoding) : $bf0bcea1d7d4510a$var$createBuffer(size).fill(fill);
    return $bf0bcea1d7d4510a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $bf0bcea1d7d4510a$var$Buffer.alloc = function(size, fill, encoding) {
    return $bf0bcea1d7d4510a$var$alloc(size, fill, encoding);
};
function $bf0bcea1d7d4510a$var$allocUnsafe(size) {
    $bf0bcea1d7d4510a$var$assertSize(size);
    return $bf0bcea1d7d4510a$var$createBuffer(size < 0 ? 0 : $bf0bcea1d7d4510a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $bf0bcea1d7d4510a$var$Buffer.allocUnsafe = function(size) {
    return $bf0bcea1d7d4510a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $bf0bcea1d7d4510a$var$Buffer.allocUnsafeSlow = function(size) {
    return $bf0bcea1d7d4510a$var$allocUnsafe(size);
};
function $bf0bcea1d7d4510a$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$bf0bcea1d7d4510a$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $bf0bcea1d7d4510a$var$byteLength(string, encoding) | 0;
    let buf = $bf0bcea1d7d4510a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $bf0bcea1d7d4510a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $bf0bcea1d7d4510a$var$checked(array.length) | 0;
    const buf = $bf0bcea1d7d4510a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $bf0bcea1d7d4510a$var$fromArrayView(arrayView) {
    if ($bf0bcea1d7d4510a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $bf0bcea1d7d4510a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $bf0bcea1d7d4510a$var$fromArrayLike(arrayView);
}
function $bf0bcea1d7d4510a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $bf0bcea1d7d4510a$var$Buffer.prototype);
    return buf;
}
function $bf0bcea1d7d4510a$var$fromObject(obj) {
    if ($bf0bcea1d7d4510a$var$Buffer.isBuffer(obj)) {
        const len = $bf0bcea1d7d4510a$var$checked(obj.length) | 0;
        const buf = $bf0bcea1d7d4510a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $bf0bcea1d7d4510a$var$numberIsNaN(obj.length)) return $bf0bcea1d7d4510a$var$createBuffer(0);
        return $bf0bcea1d7d4510a$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $bf0bcea1d7d4510a$var$fromArrayLike(obj.data);
}
function $bf0bcea1d7d4510a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $bf0bcea1d7d4510a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $bf0bcea1d7d4510a$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $bf0bcea1d7d4510a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $bf0bcea1d7d4510a$var$Buffer.alloc(+length);
}
$bf0bcea1d7d4510a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $bf0bcea1d7d4510a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$bf0bcea1d7d4510a$var$Buffer.compare = function compare(a, b) {
    if ($bf0bcea1d7d4510a$var$isInstance(a, Uint8Array)) a = $bf0bcea1d7d4510a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($bf0bcea1d7d4510a$var$isInstance(b, Uint8Array)) b = $bf0bcea1d7d4510a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$bf0bcea1d7d4510a$var$Buffer.isBuffer(a) || !$bf0bcea1d7d4510a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$bf0bcea1d7d4510a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$bf0bcea1d7d4510a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $bf0bcea1d7d4510a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $bf0bcea1d7d4510a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($bf0bcea1d7d4510a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$bf0bcea1d7d4510a$var$Buffer.isBuffer(buf)) buf = $bf0bcea1d7d4510a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$bf0bcea1d7d4510a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $bf0bcea1d7d4510a$var$byteLength(string, encoding) {
    if ($bf0bcea1d7d4510a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $bf0bcea1d7d4510a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $bf0bcea1d7d4510a$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $bf0bcea1d7d4510a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $bf0bcea1d7d4510a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$bf0bcea1d7d4510a$var$Buffer.byteLength = $bf0bcea1d7d4510a$var$byteLength;
function $bf0bcea1d7d4510a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $bf0bcea1d7d4510a$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $bf0bcea1d7d4510a$var$utf8Slice(this, start, end);
        case "ascii":
            return $bf0bcea1d7d4510a$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $bf0bcea1d7d4510a$var$latin1Slice(this, start, end);
        case "base64":
            return $bf0bcea1d7d4510a$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $bf0bcea1d7d4510a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$bf0bcea1d7d4510a$var$Buffer.prototype._isBuffer = true;
function $bf0bcea1d7d4510a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$bf0bcea1d7d4510a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$bf0bcea1d7d4510a$var$swap(this, i, i + 1);
    return this;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $bf0bcea1d7d4510a$var$swap(this, i, i + 3);
        $bf0bcea1d7d4510a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $bf0bcea1d7d4510a$var$swap(this, i, i + 7);
        $bf0bcea1d7d4510a$var$swap(this, i + 1, i + 6);
        $bf0bcea1d7d4510a$var$swap(this, i + 2, i + 5);
        $bf0bcea1d7d4510a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $bf0bcea1d7d4510a$var$utf8Slice(this, 0, length);
    return $bf0bcea1d7d4510a$var$slowToString.apply(this, arguments);
};
$bf0bcea1d7d4510a$var$Buffer.prototype.toLocaleString = $bf0bcea1d7d4510a$var$Buffer.prototype.toString;
$bf0bcea1d7d4510a$var$Buffer.prototype.equals = function equals(b) {
    if (!$bf0bcea1d7d4510a$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $bf0bcea1d7d4510a$var$Buffer.compare(this, b) === 0;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $bf0bcea1d7d4510a$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($bf0bcea1d7d4510a$var$customInspectSymbol) $bf0bcea1d7d4510a$var$Buffer.prototype[$bf0bcea1d7d4510a$var$customInspectSymbol] = $bf0bcea1d7d4510a$var$Buffer.prototype.inspect;
$bf0bcea1d7d4510a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($bf0bcea1d7d4510a$var$isInstance(target, Uint8Array)) target = $bf0bcea1d7d4510a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$bf0bcea1d7d4510a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $bf0bcea1d7d4510a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($bf0bcea1d7d4510a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $bf0bcea1d7d4510a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($bf0bcea1d7d4510a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $bf0bcea1d7d4510a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $bf0bcea1d7d4510a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $bf0bcea1d7d4510a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$bf0bcea1d7d4510a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $bf0bcea1d7d4510a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$bf0bcea1d7d4510a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $bf0bcea1d7d4510a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $bf0bcea1d7d4510a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($bf0bcea1d7d4510a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $bf0bcea1d7d4510a$var$utf8Write(buf, string, offset, length) {
    return $bf0bcea1d7d4510a$var$blitBuffer($bf0bcea1d7d4510a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $bf0bcea1d7d4510a$var$asciiWrite(buf, string, offset, length) {
    return $bf0bcea1d7d4510a$var$blitBuffer($bf0bcea1d7d4510a$var$asciiToBytes(string), buf, offset, length);
}
function $bf0bcea1d7d4510a$var$base64Write(buf, string, offset, length) {
    return $bf0bcea1d7d4510a$var$blitBuffer($bf0bcea1d7d4510a$var$base64ToBytes(string), buf, offset, length);
}
function $bf0bcea1d7d4510a$var$ucs2Write(buf, string, offset, length) {
    return $bf0bcea1d7d4510a$var$blitBuffer($bf0bcea1d7d4510a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$bf0bcea1d7d4510a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $bf0bcea1d7d4510a$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $bf0bcea1d7d4510a$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $bf0bcea1d7d4510a$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $bf0bcea1d7d4510a$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $bf0bcea1d7d4510a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$bf0bcea1d7d4510a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $bf0bcea1d7d4510a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gxC2H.fromByteArray(buf);
    else return $gxC2H.fromByteArray(buf.slice(start, end));
}
function $bf0bcea1d7d4510a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $bf0bcea1d7d4510a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $bf0bcea1d7d4510a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $bf0bcea1d7d4510a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $bf0bcea1d7d4510a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $bf0bcea1d7d4510a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $bf0bcea1d7d4510a$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $bf0bcea1d7d4510a$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $bf0bcea1d7d4510a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $bf0bcea1d7d4510a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $bf0bcea1d7d4510a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$bf0bcea1d7d4510a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $bf0bcea1d7d4510a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $bf0bcea1d7d4510a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$bf0bcea1d7d4510a$var$Buffer.prototype.readUintLE = $bf0bcea1d7d4510a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readUintBE = $bf0bcea1d7d4510a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readUint8 = $bf0bcea1d7d4510a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readUint16LE = $bf0bcea1d7d4510a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readUint16BE = $bf0bcea1d7d4510a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readUint32LE = $bf0bcea1d7d4510a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readUint32BE = $bf0bcea1d7d4510a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readBigUInt64LE = $bf0bcea1d7d4510a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $bf0bcea1d7d4510a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $bf0bcea1d7d4510a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$bf0bcea1d7d4510a$var$Buffer.prototype.readBigUInt64BE = $bf0bcea1d7d4510a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $bf0bcea1d7d4510a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $bf0bcea1d7d4510a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$bf0bcea1d7d4510a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readBigInt64LE = $bf0bcea1d7d4510a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $bf0bcea1d7d4510a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $bf0bcea1d7d4510a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$bf0bcea1d7d4510a$var$Buffer.prototype.readBigInt64BE = $bf0bcea1d7d4510a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $bf0bcea1d7d4510a$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $bf0bcea1d7d4510a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$bf0bcea1d7d4510a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, true, 23, 4);
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 4, this.length);
    return $8YfQz.read(this, offset, false, 23, 4);
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, true, 52, 8);
};
$bf0bcea1d7d4510a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkOffset(offset, 8, this.length);
    return $8YfQz.read(this, offset, false, 52, 8);
};
function $bf0bcea1d7d4510a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$bf0bcea1d7d4510a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$bf0bcea1d7d4510a$var$Buffer.prototype.writeUintLE = $bf0bcea1d7d4510a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $bf0bcea1d7d4510a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeUintBE = $bf0bcea1d7d4510a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $bf0bcea1d7d4510a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeUint8 = $bf0bcea1d7d4510a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeUint16LE = $bf0bcea1d7d4510a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeUint16BE = $bf0bcea1d7d4510a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeUint32LE = $bf0bcea1d7d4510a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeUint32BE = $bf0bcea1d7d4510a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $bf0bcea1d7d4510a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $bf0bcea1d7d4510a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $bf0bcea1d7d4510a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $bf0bcea1d7d4510a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$bf0bcea1d7d4510a$var$Buffer.prototype.writeBigUInt64LE = $bf0bcea1d7d4510a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $bf0bcea1d7d4510a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$bf0bcea1d7d4510a$var$Buffer.prototype.writeBigUInt64BE = $bf0bcea1d7d4510a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $bf0bcea1d7d4510a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$bf0bcea1d7d4510a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $bf0bcea1d7d4510a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $bf0bcea1d7d4510a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeBigInt64LE = $bf0bcea1d7d4510a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $bf0bcea1d7d4510a$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$bf0bcea1d7d4510a$var$Buffer.prototype.writeBigInt64BE = $bf0bcea1d7d4510a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $bf0bcea1d7d4510a$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $bf0bcea1d7d4510a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $bf0bcea1d7d4510a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$bf0bcea1d7d4510a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $bf0bcea1d7d4510a$var$writeFloat(this, value, offset, true, noAssert);
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $bf0bcea1d7d4510a$var$writeFloat(this, value, offset, false, noAssert);
};
function $bf0bcea1d7d4510a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $bf0bcea1d7d4510a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8YfQz.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$bf0bcea1d7d4510a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $bf0bcea1d7d4510a$var$writeDouble(this, value, offset, true, noAssert);
};
$bf0bcea1d7d4510a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $bf0bcea1d7d4510a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$bf0bcea1d7d4510a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$bf0bcea1d7d4510a$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$bf0bcea1d7d4510a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$bf0bcea1d7d4510a$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $bf0bcea1d7d4510a$var$Buffer.isBuffer(val) ? val : $bf0bcea1d7d4510a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $bf0bcea1d7d4510a$var$errors = {};
function $bf0bcea1d7d4510a$var$E(sym, getMessage, Base) {
    $bf0bcea1d7d4510a$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$bf0bcea1d7d4510a$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$bf0bcea1d7d4510a$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$bf0bcea1d7d4510a$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $bf0bcea1d7d4510a$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $bf0bcea1d7d4510a$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $bf0bcea1d7d4510a$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $bf0bcea1d7d4510a$var$checkBounds(buf, offset, byteLength) {
    $bf0bcea1d7d4510a$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $bf0bcea1d7d4510a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $bf0bcea1d7d4510a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $bf0bcea1d7d4510a$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $bf0bcea1d7d4510a$var$checkBounds(buf, offset, byteLength);
}
function $bf0bcea1d7d4510a$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $bf0bcea1d7d4510a$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $bf0bcea1d7d4510a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $bf0bcea1d7d4510a$var$validateNumber(value, type);
        throw new $bf0bcea1d7d4510a$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $bf0bcea1d7d4510a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $bf0bcea1d7d4510a$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $bf0bcea1d7d4510a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $bf0bcea1d7d4510a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($bf0bcea1d7d4510a$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $bf0bcea1d7d4510a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $bf0bcea1d7d4510a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $bf0bcea1d7d4510a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $bf0bcea1d7d4510a$var$base64ToBytes(str) {
    return $gxC2H.toByteArray($bf0bcea1d7d4510a$var$base64clean(str));
}
function $bf0bcea1d7d4510a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $bf0bcea1d7d4510a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $bf0bcea1d7d4510a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $bf0bcea1d7d4510a$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $bf0bcea1d7d4510a$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $bf0bcea1d7d4510a$var$BufferBigIntNotDefined : fn;
}
function $bf0bcea1d7d4510a$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $7f741de2889b2aad$require$Buffer = $bf0bcea1d7d4510a$export$a143d493d941bafc;
var $7f741de2889b2aad$export$70504fba2ce56d52;
(function(AccountState) {
    AccountState[AccountState["Uninitialized"] = 0] = "Uninitialized";
    AccountState[AccountState["Initialized"] = 1] = "Initialized";
    AccountState[AccountState["Frozen"] = 2] = "Frozen";
})($7f741de2889b2aad$export$70504fba2ce56d52 || ($7f741de2889b2aad$export$70504fba2ce56d52 = {}));
const $7f741de2889b2aad$export$cab31ec27f6c5fa = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("mint"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("owner"),
    (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("amount"),
    (0, $Bz0HP.u32)("delegateOption"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("delegate"),
    (0, $Bz0HP.u8)("state"),
    (0, $Bz0HP.u32)("isNativeOption"),
    (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("isNative"),
    (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("delegatedAmount"),
    (0, $Bz0HP.u32)("closeAuthorityOption"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("closeAuthority")
]);
const $7f741de2889b2aad$export$66ab21ef808e9dc6 = $7f741de2889b2aad$export$cab31ec27f6c5fa.span;
async function $7f741de2889b2aad$export$4f9234baf34abd0(connection, address, commitment, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    return $7f741de2889b2aad$export$776350edf20ed1cc(address, info, programId);
}
async function $7f741de2889b2aad$export$7ecda0587e867ff2(connection, addresses, commitment, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801)) {
    const infos = await connection.getMultipleAccountsInfo(addresses, commitment);
    return addresses.map((address, i)=>$7f741de2889b2aad$export$776350edf20ed1cc(address, infos[i], programId));
}
async function $7f741de2889b2aad$export$22f9b1d0cdd74bb0(connection, commitment) {
    return await $7f741de2889b2aad$export$e650be7f0aa49cb4(connection, [], commitment);
}
async function $7f741de2889b2aad$export$e650be7f0aa49cb4(connection, extensions, commitment) {
    const accountLen = (0, $06185939c98642bc$export$37c8c863c6dd42a9)(extensions);
    return await connection.getMinimumBalanceForRentExemption(accountLen, commitment);
}
function $7f741de2889b2aad$export$776350edf20ed1cc(address, info, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801)) {
    if (!info) throw new (0, $69531333edd951b2$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $69531333edd951b2$export$abb470453474d51)();
    if (info.data.length < $7f741de2889b2aad$export$66ab21ef808e9dc6) throw new (0, $69531333edd951b2$export$250d31de4ddb7ca5)();
    const rawAccount = $7f741de2889b2aad$export$cab31ec27f6c5fa.decode(info.data.slice(0, $7f741de2889b2aad$export$66ab21ef808e9dc6));
    let tlvData = $7f741de2889b2aad$require$Buffer.alloc(0);
    if (info.data.length > $7f741de2889b2aad$export$66ab21ef808e9dc6) {
        if (info.data.length === (0, $920ede22f3e57658$export$c2abf71f91a1605b)) throw new (0, $69531333edd951b2$export$250d31de4ddb7ca5)();
        if (info.data[$7f741de2889b2aad$export$66ab21ef808e9dc6] != (0, $51028f78ac45d1f3$export$b8ca5fa4899cbfc7).Account) throw new (0, $69531333edd951b2$export$f4938317c78e324f)();
        tlvData = info.data.slice($7f741de2889b2aad$export$66ab21ef808e9dc6 + (0, $51028f78ac45d1f3$export$9d3ac77dcbf22b3f));
    }
    return {
        address: address,
        mint: rawAccount.mint,
        owner: rawAccount.owner,
        amount: rawAccount.amount,
        delegate: rawAccount.delegateOption ? rawAccount.delegate : null,
        delegatedAmount: rawAccount.delegatedAmount,
        isInitialized: rawAccount.state !== $7f741de2889b2aad$export$70504fba2ce56d52.Uninitialized,
        isFrozen: rawAccount.state === $7f741de2889b2aad$export$70504fba2ce56d52.Frozen,
        isNative: !!rawAccount.isNativeOption,
        rentExemptReserve: rawAccount.isNativeOption ? rawAccount.isNative : null,
        closeAuthority: rawAccount.closeAuthorityOption ? rawAccount.closeAuthority : null,
        tlvData: tlvData
    };
}






var $Bz0HP = parcelRequire("Bz0HP");


const $53a9d321bf5c6dac$export$f70216558c70b1a0 = (0, $Bz0HP.struct)([
    (0, $ca773c1ee6b15d17$export$87b259aa03e3d267)("lockCpi")
]);
const $53a9d321bf5c6dac$export$2ad51e83460d1d03 = $53a9d321bf5c6dac$export$f70216558c70b1a0.span;
function $53a9d321bf5c6dac$export$1f414ebe518a07c3(account) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).CpiGuard, account.tlvData);
    if (extensionData !== null) return $53a9d321bf5c6dac$export$f70216558c70b1a0.decode(extensionData);
    else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");

const $eb78f4a67dbb9619$export$e8ecc3a3060edae5 = (0, $Bz0HP.struct)([
    (0, $Bz0HP.u8)("state")
]);
const $eb78f4a67dbb9619$export$2e3c876eadfda1ab = $eb78f4a67dbb9619$export$e8ecc3a3060edae5.span;
function $eb78f4a67dbb9619$export$d7b87bbf5a44c34c(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).DefaultAccountState, mint.tlvData);
    if (extensionData !== null) return $eb78f4a67dbb9619$export$e8ecc3a3060edae5.decode(extensionData);
    else return null;
}



var $1ZJZa = parcelRequire("1ZJZa");
// src/codes.ts
var $7ed03450837e6cf8$export$637a712014b81b9c = 1;
var $7ed03450837e6cf8$export$2b45309b0547a9c4 = 2;
var $7ed03450837e6cf8$export$7cf14cde1226b7cb = 3;
var $7ed03450837e6cf8$export$6ad19ea5e363a944 = 4;
var $7ed03450837e6cf8$export$c37fe345cc9b38e7 = 5;
var $7ed03450837e6cf8$export$cf7b28c4ea07497b = 6;
var $7ed03450837e6cf8$export$e8ff0c73a3d6800d = 7;
var $7ed03450837e6cf8$export$7dd7d17f1f93a166 = 8;
var $7ed03450837e6cf8$export$8b23617676679e2d = 9;
var $7ed03450837e6cf8$export$e09e3905081e44fe = -32700;
var $7ed03450837e6cf8$export$afa40fd3fc01204 = -32603;
var $7ed03450837e6cf8$export$2981978a530b1a7c = -32602;
var $7ed03450837e6cf8$export$5ec955cc8b7e8cf9 = -32601;
var $7ed03450837e6cf8$export$23cb4efd59427895 = -32600;
var $7ed03450837e6cf8$export$4f93db3d1b48599e = -32016;
var $7ed03450837e6cf8$export$f7685139153f9191 = -32015;
var $7ed03450837e6cf8$export$65235469ebe9845e = -32014;
var $7ed03450837e6cf8$export$bdeebdca616ef1f3 = -32013;
var $7ed03450837e6cf8$export$1b90c411626421b1 = -32012;
var $7ed03450837e6cf8$export$8e678bf9b4e5cb64 = -32011;
var $7ed03450837e6cf8$export$54dea2286c43ec1e = -32010;
var $7ed03450837e6cf8$export$e71fbee92648fc61 = -32009;
var $7ed03450837e6cf8$export$eb4f7515ff6aa19d = -32008;
var $7ed03450837e6cf8$export$d21075fd06730e = -32007;
var $7ed03450837e6cf8$export$d964b43bb02eacdf = -32006;
var $7ed03450837e6cf8$export$6bad0f4fb625ae6e = -32005;
var $7ed03450837e6cf8$export$bfbf8b75e865efa0 = -32004;
var $7ed03450837e6cf8$export$83dce8c0aef70463 = -32003;
var $7ed03450837e6cf8$export$426cc73f5ad00f38 = -32002;
var $7ed03450837e6cf8$export$6ae475e85fe02aad = -32001;
var $7ed03450837e6cf8$export$fe284a92110eab86 = 28e5;
var $7ed03450837e6cf8$export$8aae3518bf4ea38c = 2800001;
var $7ed03450837e6cf8$export$e31a90a3bf6aebaa = 2800002;
var $7ed03450837e6cf8$export$adaec66b544981e7 = 2800003;
var $7ed03450837e6cf8$export$523a769cce7318bf = 2800004;
var $7ed03450837e6cf8$export$68473acf744cabf5 = 2800005;
var $7ed03450837e6cf8$export$940d17d3b63dba7c = 2800006;
var $7ed03450837e6cf8$export$a1cf857da540ee2e = 2800007;
var $7ed03450837e6cf8$export$30501b98da9564bb = 2800008;
var $7ed03450837e6cf8$export$123d01dd469dc2ef = 2800009;
var $7ed03450837e6cf8$export$2a7684440f52314e = 2800010;
var $7ed03450837e6cf8$export$8f39956700e64760 = 323e4;
var $7ed03450837e6cf8$export$1239089c4564c858 = 32300001;
var $7ed03450837e6cf8$export$afc08ee11abbc257 = 3230002;
var $7ed03450837e6cf8$export$57836d13a84f54b0 = 3230003;
var $7ed03450837e6cf8$export$f080cd056a56cd54 = 3230004;
var $7ed03450837e6cf8$export$f2bbb3c14e29977e = 361e4;
var $7ed03450837e6cf8$export$f18173f573d8bb21 = 3610001;
var $7ed03450837e6cf8$export$7ad09900bd645a86 = 3610002;
var $7ed03450837e6cf8$export$69c08c51e1841f29 = 3610003;
var $7ed03450837e6cf8$export$325dad4e0a6bd514 = 3610004;
var $7ed03450837e6cf8$export$242c341c7c464bee = 3610005;
var $7ed03450837e6cf8$export$a73c064bb32a7c36 = 3610006;
var $7ed03450837e6cf8$export$b6497aaa1c3cb4a7 = 3610007;
var $7ed03450837e6cf8$export$bc2b26beee0f9a0b = 3611e3;
var $7ed03450837e6cf8$export$bc1242deaa4d848d = 3704e3;
var $7ed03450837e6cf8$export$44352af09ecae39f = 3704001;
var $7ed03450837e6cf8$export$d2a0e93e506be463 = 3704002;
var $7ed03450837e6cf8$export$bbe4ed5687bc7f55 = 3704003;
var $7ed03450837e6cf8$export$436df06ce5af77b3 = 3704004;
var $7ed03450837e6cf8$export$552eeff1216c4a1e = 4128e3;
var $7ed03450837e6cf8$export$b260fc8c8d3cde52 = 4128001;
var $7ed03450837e6cf8$export$b81e507604713b9b = 4128002;
var $7ed03450837e6cf8$export$d308cb6df5c28ff6 = 4615e3;
var $7ed03450837e6cf8$export$ab2273c84ffc5d61 = 4615001;
var $7ed03450837e6cf8$export$23cc359156888c7f = 4615002;
var $7ed03450837e6cf8$export$a4193356408e9ff0 = 4615003;
var $7ed03450837e6cf8$export$f9ae264f831e3bcf = 4615004;
var $7ed03450837e6cf8$export$e170b44d99a3d17c = 4615005;
var $7ed03450837e6cf8$export$84ec8e94b54ae7d2 = 4615006;
var $7ed03450837e6cf8$export$4063fe8d5aed84a5 = 4615007;
var $7ed03450837e6cf8$export$ecdd3388f6a493b1 = 4615008;
var $7ed03450837e6cf8$export$df0a6d6cbb0d96a1 = 4615009;
var $7ed03450837e6cf8$export$e45bdcd5a97f01d1 = 4615010;
var $7ed03450837e6cf8$export$c2bfe7e903a0febb = 4615011;
var $7ed03450837e6cf8$export$fa2d8ac69bd6117e = 4615012;
var $7ed03450837e6cf8$export$2b7e7e6bd3d5b8c4 = 4615013;
var $7ed03450837e6cf8$export$72e64aed285de589 = 4615014;
var $7ed03450837e6cf8$export$95d7c72146ee65c6 = 4615015;
var $7ed03450837e6cf8$export$aa03f185732dc00b = 4615016;
var $7ed03450837e6cf8$export$c390f45549d7336b = 4615017;
var $7ed03450837e6cf8$export$2ea2f2f9a9e26449 = 4615018;
var $7ed03450837e6cf8$export$c9ece88629d0d2d8 = 4615019;
var $7ed03450837e6cf8$export$2f331454431511bf = 4615020;
var $7ed03450837e6cf8$export$3c4b9377ed4116a0 = 4615021;
var $7ed03450837e6cf8$export$211b990ef3bd19ce = 4615022;
var $7ed03450837e6cf8$export$ef486e0fcc8262b = 4615023;
var $7ed03450837e6cf8$export$afcb9eeb4bf056b5 = 4615024;
var $7ed03450837e6cf8$export$4db39a3a67e51db2 = 4615025;
var $7ed03450837e6cf8$export$5abe2d1d040bf6cf = 4615026;
var $7ed03450837e6cf8$export$35a7a209cf9aaee8 = 4615027;
var $7ed03450837e6cf8$export$203fce7ce63eb278 = 4615028;
var $7ed03450837e6cf8$export$c65d87b69a4b86e5 = 4615029;
var $7ed03450837e6cf8$export$d13686e596713674 = 4615030;
var $7ed03450837e6cf8$export$a070310f29fe959b = 4615031;
var $7ed03450837e6cf8$export$8eb8ce58a8afa4d8 = 4615032;
var $7ed03450837e6cf8$export$1224afa7bd705d3d = 4615033;
var $7ed03450837e6cf8$export$547fdb4fff65c547 = 4615034;
var $7ed03450837e6cf8$export$cbeea52e947eb081 = 4615035;
var $7ed03450837e6cf8$export$fd7a98f0746b6c8a = 4615036;
var $7ed03450837e6cf8$export$8e6d399c8fb88eaa = 4615037;
var $7ed03450837e6cf8$export$2c001ce75e66180d = 4615038;
var $7ed03450837e6cf8$export$ec7d592dad68aa12 = 4615039;
var $7ed03450837e6cf8$export$8815da3ec592d05a = 4615040;
var $7ed03450837e6cf8$export$b1b9bf899899a525 = 4615041;
var $7ed03450837e6cf8$export$67715a67add5645f = 4615042;
var $7ed03450837e6cf8$export$e343a153899b82e9 = 4615043;
var $7ed03450837e6cf8$export$2199fb95c7d85b85 = 4615044;
var $7ed03450837e6cf8$export$57c1675a0c20931f = 4615045;
var $7ed03450837e6cf8$export$9e62f446da191370 = 4615046;
var $7ed03450837e6cf8$export$b5ccaf975fe486a0 = 4615047;
var $7ed03450837e6cf8$export$4d39d4c2f04b41a8 = 4615048;
var $7ed03450837e6cf8$export$1997554dc67e9c4e = 4615049;
var $7ed03450837e6cf8$export$8a65209e9cece2cd = 4615050;
var $7ed03450837e6cf8$export$6b675123aa59300c = 4615051;
var $7ed03450837e6cf8$export$70b4e2dd1496c5a3 = 4615052;
var $7ed03450837e6cf8$export$43d5111034db211a = 4615053;
var $7ed03450837e6cf8$export$8aebe3e76f515046 = 4615054;
var $7ed03450837e6cf8$export$ee84b29a9985e516 = 5508e3;
var $7ed03450837e6cf8$export$9998b265c986beaa = 5508001;
var $7ed03450837e6cf8$export$dd792e9d67cd031b = 5508002;
var $7ed03450837e6cf8$export$14d32fbdad2233cd = 5508003;
var $7ed03450837e6cf8$export$8c6fc1cfcec8440c = 5508004;
var $7ed03450837e6cf8$export$dcec7171cff295d1 = 5508005;
var $7ed03450837e6cf8$export$200acbfc722e322b = 5508006;
var $7ed03450837e6cf8$export$4c96d9a95880ae4b = 5508007;
var $7ed03450837e6cf8$export$bba76b21ada319a5 = 5508008;
var $7ed03450837e6cf8$export$3cb3b480d2bfdacc = 5508009;
var $7ed03450837e6cf8$export$1f5fbaa83776feec = 5508010;
var $7ed03450837e6cf8$export$1d51c4c8b2c49e09 = 5508011;
var $7ed03450837e6cf8$export$694fd435994bcca = 5663e3;
var $7ed03450837e6cf8$export$707576ec00ca24d6 = 5663001;
var $7ed03450837e6cf8$export$e33d07a7526bded0 = 5663002;
var $7ed03450837e6cf8$export$a20747f749dd4515 = 5663003;
var $7ed03450837e6cf8$export$3963d9bca4091810 = 5663004;
var $7ed03450837e6cf8$export$b34a16b8adbffdc1 = 5663005;
var $7ed03450837e6cf8$export$3764bbcfb0679211 = 5663006;
var $7ed03450837e6cf8$export$ed2bdee7953e467f = 5663007;
var $7ed03450837e6cf8$export$11bea4440904349c = 5663008;
var $7ed03450837e6cf8$export$6d61b980429516bd = 5663009;
var $7ed03450837e6cf8$export$819b1b0603d2a966 = 5663010;
var $7ed03450837e6cf8$export$592862d1b11e32ac = 5663011;
var $7ed03450837e6cf8$export$242af5597d94abaf = 5663012;
var $7ed03450837e6cf8$export$802b3ebe5297e360 = 5663013;
var $7ed03450837e6cf8$export$bed6f92dafea0623 = 5663014;
var $7ed03450837e6cf8$export$36c2547c3c4d823f = 5663015;
var $7ed03450837e6cf8$export$de92784c954d1b84 = 5663016;
var $7ed03450837e6cf8$export$b55a3eb3d894ad9f = 5663017;
var $7ed03450837e6cf8$export$4e4582c633fc423e = 5663018;
var $7ed03450837e6cf8$export$8c82dde5b12c9789 = 705e4;
var $7ed03450837e6cf8$export$a746609ecc2f6acf = 7050001;
var $7ed03450837e6cf8$export$c4d8217d3eb3eaf8 = 7050002;
var $7ed03450837e6cf8$export$5d0f06cd8bc8e3af = 7050003;
var $7ed03450837e6cf8$export$83c8fe2717d1b271 = 7050004;
var $7ed03450837e6cf8$export$39ead28cf48a604c = 7050005;
var $7ed03450837e6cf8$export$624f65633216eb57 = 7050006;
var $7ed03450837e6cf8$export$2bbd9403cb117ea7 = 7050007;
var $7ed03450837e6cf8$export$e108dd5343c4c11 = 7050008;
var $7ed03450837e6cf8$export$a504ed6cab09ce4a = 7050009;
var $7ed03450837e6cf8$export$8c1ae05eccc11ef9 = 7050010;
var $7ed03450837e6cf8$export$47df44101c6f04b0 = 7050011;
var $7ed03450837e6cf8$export$89ae0c424691fbcb = 7050012;
var $7ed03450837e6cf8$export$bea5f92951bc42e7 = 7050013;
var $7ed03450837e6cf8$export$91a668e132084ecf = 7050014;
var $7ed03450837e6cf8$export$211b9b84186690f0 = 7050015;
var $7ed03450837e6cf8$export$291ea8d5a7496fde = 7050016;
var $7ed03450837e6cf8$export$5f027a86397cba92 = 7050017;
var $7ed03450837e6cf8$export$58bf90c73afbc02e = 7050018;
var $7ed03450837e6cf8$export$b8b2610c9a910763 = 7050019;
var $7ed03450837e6cf8$export$fb693aebffa32676 = 7050020;
var $7ed03450837e6cf8$export$572954173bc64b66 = 7050021;
var $7ed03450837e6cf8$export$fa9a13f1b40ee2fb = 7050022;
var $7ed03450837e6cf8$export$95c94f6ea500f1ab = 7050023;
var $7ed03450837e6cf8$export$11d69fb6993b2cf5 = 7050024;
var $7ed03450837e6cf8$export$bd54a9a85614b3a7 = 7050025;
var $7ed03450837e6cf8$export$df4ef1824fd194a3 = 7050026;
var $7ed03450837e6cf8$export$2725d50dd432fb3a = 7050027;
var $7ed03450837e6cf8$export$41f13726b04d8d05 = 7050028;
var $7ed03450837e6cf8$export$7b4a7eebff68ca7b = 7050029;
var $7ed03450837e6cf8$export$e3a4007020a2e8f5 = 7050030;
var $7ed03450837e6cf8$export$2ecc275dffbc087c = 7050031;
var $7ed03450837e6cf8$export$e3289c5954208202 = 7050032;
var $7ed03450837e6cf8$export$3569c6c71e349538 = 7050033;
var $7ed03450837e6cf8$export$4f413e02d5e82221 = 7050034;
var $7ed03450837e6cf8$export$1cd0de5dfcdeb99d = 7050035;
var $7ed03450837e6cf8$export$87e01307d368f511 = 7050036;
var $7ed03450837e6cf8$export$9c9326ce1e3df40c = 8078e3;
var $7ed03450837e6cf8$export$18fbf24f19efc69b = 8078001;
var $7ed03450837e6cf8$export$93561b31b951410d = 8078002;
var $7ed03450837e6cf8$export$3417da5bc6bcb45 = 8078003;
var $7ed03450837e6cf8$export$c4c73ab3c0833591 = 8078004;
var $7ed03450837e6cf8$export$824d79ab1779d517 = 8078005;
var $7ed03450837e6cf8$export$c464f3b291f1f3d0 = 8078006;
var $7ed03450837e6cf8$export$c04710d31ef4d278 = 8078007;
var $7ed03450837e6cf8$export$1fa107ead8489cf2 = 8078008;
var $7ed03450837e6cf8$export$2bb0703affb8fe68 = 8078009;
var $7ed03450837e6cf8$export$f6bf8a7c1f3defe4 = 8078010;
var $7ed03450837e6cf8$export$8653c145864f47f4 = 8078011;
var $7ed03450837e6cf8$export$89b582b06852d433 = 8078012;
var $7ed03450837e6cf8$export$4c1fcb4bd20b2951 = 8078013;
var $7ed03450837e6cf8$export$a617dff403944ec6 = 8078014;
var $7ed03450837e6cf8$export$c89f43f0d783cd50 = 8078015;
var $7ed03450837e6cf8$export$f73fb8ecbd4b2395 = 8078016;
var $7ed03450837e6cf8$export$efbd199de191d2aa = 8078017;
var $7ed03450837e6cf8$export$cb77f5a0f0fa7f18 = 8078018;
var $7ed03450837e6cf8$export$47278510a511031b = 8078019;
var $7ed03450837e6cf8$export$a9282ed13660c9f6 = 8078020;
var $7ed03450837e6cf8$export$5bdfee6423bc35ce = 8078021;
var $7ed03450837e6cf8$export$a2e9526594022372 = 8078022;
var $7ed03450837e6cf8$export$ef742b7036fb9005 = 81e5;
var $7ed03450837e6cf8$export$2a2f0f75708d1697 = 8100001;
var $7ed03450837e6cf8$export$7f6822f75edb8f41 = 8100002;
var $7ed03450837e6cf8$export$c2b279d002edb7ec = 819e4;
var $7ed03450837e6cf8$export$e1a3658b043aad8e = 8190001;
var $7ed03450837e6cf8$export$70877b3524829eb0 = 8190002;
var $7ed03450837e6cf8$export$d017b741c4452673 = 8190003;
var $7ed03450837e6cf8$export$b1b380d4068eeb8f = 8190004;
var $7ed03450837e6cf8$export$ecb673640304655c = 99e5;
var $7ed03450837e6cf8$export$bd3f60d945c38448 = 9900001;
var $7ed03450837e6cf8$export$b57ffff6ec11f63 = 9900002;
var $7ed03450837e6cf8$export$6fe73388375373f = 9900003;
// src/context.ts
function $7ed03450837e6cf8$var$encodeValue(value) {
    if (Array.isArray(value)) {
        const commaSeparatedValues = value.map($7ed03450837e6cf8$var$encodeValue).join("%2C%20");
        return "%5B" + commaSeparatedValues + /* "]" */ "%5D";
    } else if (typeof value === "bigint") return `${value}n`;
    else return encodeURIComponent(String(value != null && Object.getPrototypeOf(value) === null ? // Plain objects with no prototype don't have a `toString` method.
    // Convert them before stringifying them.
    {
        ...value
    } : value));
}
function $7ed03450837e6cf8$var$encodeObjectContextEntry([key, value]) {
    return `${key}=${$7ed03450837e6cf8$var$encodeValue(value)}`;
}
function $7ed03450837e6cf8$var$encodeContextObject(context) {
    const searchParamsString = Object.entries(context).map($7ed03450837e6cf8$var$encodeObjectContextEntry).join("&");
    return btoa(searchParamsString);
}
// src/messages.ts
var $7ed03450837e6cf8$var$SolanaErrorMessages = {
    [$7ed03450837e6cf8$export$8f39956700e64760]: "Account not found at address: $address",
    [$7ed03450837e6cf8$export$f080cd056a56cd54]: "Not all accounts were decoded. Encoded accounts found at addresses: $addresses.",
    [$7ed03450837e6cf8$export$57836d13a84f54b0]: "Expected decoded account at address: $address",
    [$7ed03450837e6cf8$export$afc08ee11abbc257]: "Failed to decode account data at address: $address",
    [$7ed03450837e6cf8$export$1239089c4564c858]: "Accounts not found at addresses: $addresses",
    [$7ed03450837e6cf8$export$123d01dd469dc2ef]: "Unable to find a viable program address bump seed.",
    [$7ed03450837e6cf8$export$e31a90a3bf6aebaa]: "$putativeAddress is not a base58-encoded address.",
    [$7ed03450837e6cf8$export$fe284a92110eab86]: "Expected base58 encoded address to decode to a byte array of length 32. Actual length: $actualLength.",
    [$7ed03450837e6cf8$export$adaec66b544981e7]: "The `CryptoKey` must be an `Ed25519` public key.",
    [$7ed03450837e6cf8$export$30501b98da9564bb]: "Invalid seeds; point must fall off the Ed25519 curve.",
    [$7ed03450837e6cf8$export$523a769cce7318bf]: "Expected given program derived address to have the following format: [Address, ProgramDerivedAddressBump].",
    [$7ed03450837e6cf8$export$940d17d3b63dba7c]: "A maximum of $maxSeeds seeds, including the bump seed, may be supplied when creating an address. Received: $actual.",
    [$7ed03450837e6cf8$export$a1cf857da540ee2e]: "The seed at index $index with length $actual exceeds the maximum length of $maxSeedLength bytes.",
    [$7ed03450837e6cf8$export$68473acf744cabf5]: "Expected program derived address bump to be in the range [0, 255], got: $bump.",
    [$7ed03450837e6cf8$export$2a7684440f52314e]: "Program address cannot end with PDA marker.",
    [$7ed03450837e6cf8$export$8aae3518bf4ea38c]: "Expected base58-encoded address string of length in the range [32, 44]. Actual length: $actualLength.",
    [$7ed03450837e6cf8$export$6ad19ea5e363a944]: "Expected base58-encoded blockash string of length in the range [32, 44]. Actual length: $actualLength.",
    [$7ed03450837e6cf8$export$637a712014b81b9c]: "The network has progressed past the last block for which this transaction could have been committed.",
    [$7ed03450837e6cf8$export$9c9326ce1e3df40c]: "Codec [$codecDescription] cannot decode empty byte arrays.",
    [$7ed03450837e6cf8$export$a2e9526594022372]: "Enum codec cannot use lexical values [$stringValues] as discriminators. Either remove all lexical values or set `useValuesAsDiscriminators` to `false`.",
    [$7ed03450837e6cf8$export$a9282ed13660c9f6]: "Sentinel [$hexSentinel] must not be present in encoded bytes [$hexEncodedBytes].",
    [$7ed03450837e6cf8$export$824d79ab1779d517]: "Encoder and decoder must have the same fixed size, got [$encoderFixedSize] and [$decoderFixedSize].",
    [$7ed03450837e6cf8$export$c464f3b291f1f3d0]: "Encoder and decoder must have the same max size, got [$encoderMaxSize] and [$decoderMaxSize].",
    [$7ed03450837e6cf8$export$c4c73ab3c0833591]: "Encoder and decoder must either both be fixed-size or variable-size.",
    [$7ed03450837e6cf8$export$1fa107ead8489cf2]: "Enum discriminator out of range. Expected a number in [$formattedValidDiscriminators], got $discriminator.",
    [$7ed03450837e6cf8$export$93561b31b951410d]: "Expected a fixed-size codec, got a variable-size one.",
    [$7ed03450837e6cf8$export$4c1fcb4bd20b2951]: "Codec [$codecDescription] expected a positive byte length, got $bytesLength.",
    [$7ed03450837e6cf8$export$3417da5bc6bcb45]: "Expected a variable-size codec, got a fixed-size one.",
    [$7ed03450837e6cf8$export$47278510a511031b]: "Codec [$codecDescription] expected zero-value [$hexZeroValue] to have the same size as the provided fixed-size item [$expectedSize bytes].",
    [$7ed03450837e6cf8$export$18fbf24f19efc69b]: "Codec [$codecDescription] expected $expected bytes, got $bytesLength.",
    [$7ed03450837e6cf8$export$cb77f5a0f0fa7f18]: "Expected byte array constant [$hexConstant] to be present in data [$hexData] at offset [$offset].",
    [$7ed03450837e6cf8$export$2bb0703affb8fe68]: "Invalid discriminated union variant. Expected one of [$variants], got $value.",
    [$7ed03450837e6cf8$export$f6bf8a7c1f3defe4]: "Invalid enum variant. Expected one of [$stringValues] or a number in [$formattedNumericalValues], got $variant.",
    [$7ed03450837e6cf8$export$c89f43f0d783cd50]: "Invalid literal union variant. Expected one of [$variants], got $value.",
    [$7ed03450837e6cf8$export$c04710d31ef4d278]: "Expected [$codecDescription] to have $expected items, got $actual.",
    [$7ed03450837e6cf8$export$89b582b06852d433]: "Invalid value $value for base $base with alphabet $alphabet.",
    [$7ed03450837e6cf8$export$f73fb8ecbd4b2395]: "Literal union discriminator out of range. Expected a number between $minRange and $maxRange, got $discriminator.",
    [$7ed03450837e6cf8$export$8653c145864f47f4]: "Codec [$codecDescription] expected number to be in the range [$min, $max], got $value.",
    [$7ed03450837e6cf8$export$a617dff403944ec6]: "Codec [$codecDescription] expected offset to be in the range [0, $bytesLength], got $offset.",
    [$7ed03450837e6cf8$export$5bdfee6423bc35ce]: "Expected sentinel [$hexSentinel] to be present in decoded bytes [$hexDecodedBytes].",
    [$7ed03450837e6cf8$export$efbd199de191d2aa]: "Union variant out of range. Expected an index between $minRange and $maxRange, got $variant.",
    [$7ed03450837e6cf8$export$bc2b26beee0f9a0b]: "No random values implementation could be found.",
    [$7ed03450837e6cf8$export$df0a6d6cbb0d96a1]: "instruction requires an uninitialized account",
    [$7ed03450837e6cf8$export$ef486e0fcc8262b]: "instruction tries to borrow reference for an account which is already borrowed",
    [$7ed03450837e6cf8$export$afcb9eeb4bf056b5]: "instruction left account with an outstanding borrowed reference",
    [$7ed03450837e6cf8$export$3c4b9377ed4116a0]: "program other than the account's owner changed the size of the account data",
    [$7ed03450837e6cf8$export$e170b44d99a3d17c]: "account data too small for instruction",
    [$7ed03450837e6cf8$export$211b990ef3bd19ce]: "instruction expected an executable account",
    [$7ed03450837e6cf8$export$9e62f446da191370]: "An account does not have enough lamports to be rent-exempt",
    [$7ed03450837e6cf8$export$4d39d4c2f04b41a8]: "Program arithmetic overflowed",
    [$7ed03450837e6cf8$export$57c1675a0c20931f]: "Failed to serialize or deserialize account data: $encodedData",
    [$7ed03450837e6cf8$export$8aebe3e76f515046]: "Builtin programs must consume compute units",
    [$7ed03450837e6cf8$export$8eb8ce58a8afa4d8]: "Cross-program invocation call depth too deep",
    [$7ed03450837e6cf8$export$2c001ce75e66180d]: "Computational budget exceeded",
    [$7ed03450837e6cf8$export$5abe2d1d040bf6cf]: "custom program error: #$code",
    [$7ed03450837e6cf8$export$c390f45549d7336b]: "instruction contains duplicate accounts",
    [$7ed03450837e6cf8$export$4db39a3a67e51db2]: "instruction modifications of multiply-passed account differ",
    [$7ed03450837e6cf8$export$d13686e596713674]: "executable accounts must be rent exempt",
    [$7ed03450837e6cf8$export$203fce7ce63eb278]: "instruction changed executable accounts data",
    [$7ed03450837e6cf8$export$c65d87b69a4b86e5]: "instruction changed the balance of an executable account",
    [$7ed03450837e6cf8$export$2ea2f2f9a9e26449]: "instruction changed executable bit of an account",
    [$7ed03450837e6cf8$export$72e64aed285de589]: "instruction modified data of an account it does not own",
    [$7ed03450837e6cf8$export$2b7e7e6bd3d5b8c4]: "instruction spent from the balance of an account it does not own",
    [$7ed03450837e6cf8$export$ab2273c84ffc5d61]: "generic instruction error",
    [$7ed03450837e6cf8$export$8a65209e9cece2cd]: "Provided owner is not allowed",
    [$7ed03450837e6cf8$export$e343a153899b82e9]: "Account is immutable",
    [$7ed03450837e6cf8$export$2199fb95c7d85b85]: "Incorrect authority provided",
    [$7ed03450837e6cf8$export$4063fe8d5aed84a5]: "incorrect program id for instruction",
    [$7ed03450837e6cf8$export$84ec8e94b54ae7d2]: "insufficient funds for instruction",
    [$7ed03450837e6cf8$export$f9ae264f831e3bcf]: "invalid account data for instruction",
    [$7ed03450837e6cf8$export$b5ccaf975fe486a0]: "Invalid account owner",
    [$7ed03450837e6cf8$export$23cc359156888c7f]: "invalid program argument",
    [$7ed03450837e6cf8$export$35a7a209cf9aaee8]: "program returned invalid error code",
    [$7ed03450837e6cf8$export$a4193356408e9ff0]: "invalid instruction data",
    [$7ed03450837e6cf8$export$8e6d399c8fb88eaa]: "Failed to reallocate account data",
    [$7ed03450837e6cf8$export$fd7a98f0746b6c8a]: "Provided seeds do not result in a valid address",
    [$7ed03450837e6cf8$export$6b675123aa59300c]: "Accounts data allocations exceeded the maximum allowed per transaction",
    [$7ed03450837e6cf8$export$70b4e2dd1496c5a3]: "Max accounts exceeded",
    [$7ed03450837e6cf8$export$43d5111034db211a]: "Max instruction trace length exceeded",
    [$7ed03450837e6cf8$export$cbeea52e947eb081]: "Length of the seed is too long for address generation",
    [$7ed03450837e6cf8$export$1224afa7bd705d3d]: "An account required by the instruction is missing",
    [$7ed03450837e6cf8$export$ecdd3388f6a493b1]: "missing required signature for instruction",
    [$7ed03450837e6cf8$export$fa2d8ac69bd6117e]: "instruction illegally modified the program id of an account",
    [$7ed03450837e6cf8$export$2f331454431511bf]: "insufficient account keys for instruction",
    [$7ed03450837e6cf8$export$ec7d592dad68aa12]: "Cross-program invocation with unauthorized signer or writable account",
    [$7ed03450837e6cf8$export$8815da3ec592d05a]: "Failed to create program execution environment",
    [$7ed03450837e6cf8$export$67715a67add5645f]: "Program failed to compile",
    [$7ed03450837e6cf8$export$b1b9bf899899a525]: "Program failed to complete",
    [$7ed03450837e6cf8$export$aa03f185732dc00b]: "instruction modified data of a read-only account",
    [$7ed03450837e6cf8$export$95d7c72146ee65c6]: "instruction changed the balance of a read-only account",
    [$7ed03450837e6cf8$export$547fdb4fff65c547]: "Cross-program invocation reentrancy not allowed for this instruction",
    [$7ed03450837e6cf8$export$c9ece88629d0d2d8]: "instruction modified rent epoch of an account",
    [$7ed03450837e6cf8$export$c2bfe7e903a0febb]: "sum of account balances before and after instruction do not match",
    [$7ed03450837e6cf8$export$e45bdcd5a97f01d1]: "instruction requires an initialized account",
    [$7ed03450837e6cf8$export$d308cb6df5c28ff6]: "",
    [$7ed03450837e6cf8$export$a070310f29fe959b]: "Unsupported program id",
    [$7ed03450837e6cf8$export$1997554dc67e9c4e]: "Unsupported sysvar",
    [$7ed03450837e6cf8$export$552eeff1216c4a1e]: "The instruction does not have any accounts.",
    [$7ed03450837e6cf8$export$b260fc8c8d3cde52]: "The instruction does not have any data.",
    [$7ed03450837e6cf8$export$b81e507604713b9b]: "Expected instruction to have progress address $expectedProgramAddress, got $actualProgramAddress.",
    [$7ed03450837e6cf8$export$c37fe345cc9b38e7]: "Expected base58 encoded blockhash to decode to a byte array of length 32. Actual length: $actualLength.",
    [$7ed03450837e6cf8$export$2b45309b0547a9c4]: "The nonce `$expectedNonceValue` is no longer valid. It has advanced to `$actualNonceValue`",
    [$7ed03450837e6cf8$export$b57ffff6ec11f63]: "Invariant violation: Found no abortable iterable cache entry for key `$cacheKey`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$7ed03450837e6cf8$export$6fe73388375373f]: "Invariant violation: Switch statement non-exhaustive. Received unexpected value `$unexpectedValue`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$7ed03450837e6cf8$export$bd3f60d945c38448]: "Invariant violation: WebSocket message iterator state is corrupt; iterated without first resolving existing message promise. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$7ed03450837e6cf8$export$ecb673640304655c]: "Invariant violation: WebSocket message iterator is missing state storage. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$7ed03450837e6cf8$export$afa40fd3fc01204]: "JSON-RPC error: Internal JSON-RPC error ($__serverMessage)",
    [$7ed03450837e6cf8$export$2981978a530b1a7c]: "JSON-RPC error: Invalid method parameter(s) ($__serverMessage)",
    [$7ed03450837e6cf8$export$23cb4efd59427895]: "JSON-RPC error: The JSON sent is not a valid `Request` object ($__serverMessage)",
    [$7ed03450837e6cf8$export$5ec955cc8b7e8cf9]: "JSON-RPC error: The method does not exist / is not available ($__serverMessage)",
    [$7ed03450837e6cf8$export$e09e3905081e44fe]: "JSON-RPC error: An error occurred on the server while parsing the JSON text ($__serverMessage)",
    [$7ed03450837e6cf8$export$1b90c411626421b1]: "$__serverMessage",
    [$7ed03450837e6cf8$export$6ae475e85fe02aad]: "$__serverMessage",
    [$7ed03450837e6cf8$export$bfbf8b75e865efa0]: "$__serverMessage",
    [$7ed03450837e6cf8$export$65235469ebe9845e]: "$__serverMessage",
    [$7ed03450837e6cf8$export$54dea2286c43ec1e]: "$__serverMessage",
    [$7ed03450837e6cf8$export$e71fbee92648fc61]: "$__serverMessage",
    [$7ed03450837e6cf8$export$4f93db3d1b48599e]: "Minimum context slot has not been reached",
    [$7ed03450837e6cf8$export$6bad0f4fb625ae6e]: "Node is unhealthy; behind by $numSlotsBehind slots",
    [$7ed03450837e6cf8$export$eb4f7515ff6aa19d]: "No snapshot",
    [$7ed03450837e6cf8$export$426cc73f5ad00f38]: "Transaction simulation failed",
    [$7ed03450837e6cf8$export$d21075fd06730e]: "$__serverMessage",
    [$7ed03450837e6cf8$export$8e678bf9b4e5cb64]: "Transaction history is not available from this node",
    [$7ed03450837e6cf8$export$d964b43bb02eacdf]: "$__serverMessage",
    [$7ed03450837e6cf8$export$bdeebdca616ef1f3]: "Transaction signature length mismatch",
    [$7ed03450837e6cf8$export$83dce8c0aef70463]: "Transaction signature verification failure",
    [$7ed03450837e6cf8$export$f7685139153f9191]: "$__serverMessage",
    [$7ed03450837e6cf8$export$bc1242deaa4d848d]: "Key pair bytes must be of length 64, got $byteLength.",
    [$7ed03450837e6cf8$export$44352af09ecae39f]: "Expected private key bytes with length 32. Actual length: $actualLength.",
    [$7ed03450837e6cf8$export$d2a0e93e506be463]: "Expected base58-encoded signature to decode to a byte array of length 64. Actual length: $actualLength.",
    [$7ed03450837e6cf8$export$436df06ce5af77b3]: "The provided private key does not match the provided public key.",
    [$7ed03450837e6cf8$export$bbe4ed5687bc7f55]: "Expected base58-encoded signature string of length in the range [64, 88]. Actual length: $actualLength.",
    [$7ed03450837e6cf8$export$cf7b28c4ea07497b]: "Lamports value must be in the range [0, 2e64-1]",
    [$7ed03450837e6cf8$export$e8ff0c73a3d6800d]: "`$value` cannot be parsed as a `BigInt`",
    [$7ed03450837e6cf8$export$7dd7d17f1f93a166]: "`$value` cannot be parsed as a `Number`",
    [$7ed03450837e6cf8$export$7cf14cde1226b7cb]: "No nonce account could be found at address `$nonceAccountAddress`",
    [$7ed03450837e6cf8$export$c2b279d002edb7ec]: "Either the notification name must end in 'Notifications' or the API must supply a subscription creator function for the notification '$notificationName' to map between the notification name and the subscribe/unsubscribe method names.",
    [$7ed03450837e6cf8$export$e1a3658b043aad8e]: "Failed to obtain a subscription id from the server",
    [$7ed03450837e6cf8$export$70877b3524829eb0]: "WebSocket was closed before payload could be added to the send buffer",
    [$7ed03450837e6cf8$export$d017b741c4452673]: "WebSocket connection closed",
    [$7ed03450837e6cf8$export$b1b380d4068eeb8f]: "WebSocket failed to connect",
    [$7ed03450837e6cf8$export$ef742b7036fb9005]: "The $argumentLabel argument to the `$methodName` RPC method$optionalPathLabel was `$value`. This number is unsafe for use with the Solana JSON-RPC because it exceeds `Number.MAX_SAFE_INTEGER`.",
    [$7ed03450837e6cf8$export$7f6822f75edb8f41]: "HTTP error ($statusCode): $message",
    [$7ed03450837e6cf8$export$2a2f0f75708d1697]: "HTTP header(s) forbidden: $headers. Learn more at https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name.",
    [$7ed03450837e6cf8$export$ee84b29a9985e516]: "Multiple distinct signers were identified for address `$address`. Please ensure that you are using the same signer instance for each address.",
    [$7ed03450837e6cf8$export$9998b265c986beaa]: "The provided value does not implement the `KeyPairSigner` interface",
    [$7ed03450837e6cf8$export$14d32fbdad2233cd]: "The provided value does not implement the `MessageModifyingSigner` interface",
    [$7ed03450837e6cf8$export$8c6fc1cfcec8440c]: "The provided value does not implement the `MessagePartialSigner` interface",
    [$7ed03450837e6cf8$export$dd792e9d67cd031b]: "The provided value does not implement any of the `MessageSigner` interfaces",
    [$7ed03450837e6cf8$export$200acbfc722e322b]: "The provided value does not implement the `TransactionModifyingSigner` interface",
    [$7ed03450837e6cf8$export$4c96d9a95880ae4b]: "The provided value does not implement the `TransactionPartialSigner` interface",
    [$7ed03450837e6cf8$export$bba76b21ada319a5]: "The provided value does not implement the `TransactionSendingSigner` interface",
    [$7ed03450837e6cf8$export$dcec7171cff295d1]: "The provided value does not implement any of the `TransactionSigner` interfaces",
    [$7ed03450837e6cf8$export$3cb3b480d2bfdacc]: "More than one `TransactionSendingSigner` was identified.",
    [$7ed03450837e6cf8$export$1f5fbaa83776feec]: "No `TransactionSendingSigner` was identified. Please provide a valid `ITransactionWithSingleSendingSigner` transaction.",
    [$7ed03450837e6cf8$export$1d51c4c8b2c49e09]: "Wallet account signers do not support signing multiple messages/transactions in a single operation",
    [$7ed03450837e6cf8$export$b6497aaa1c3cb4a7]: "Cannot export a non-extractable key.",
    [$7ed03450837e6cf8$export$f18173f573d8bb21]: "No digest implementation could be found.",
    [$7ed03450837e6cf8$export$f2bbb3c14e29977e]: "Cryptographic operations are only allowed in secure browser contexts. Read more here: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts.",
    [$7ed03450837e6cf8$export$7ad09900bd645a86]: "This runtime does not support the generation of Ed25519 key pairs.\n\nInstall @solana/webcrypto-ed25519-polyfill and call its `install` function before generating keys in environments that do not support Ed25519.\n\nFor a list of runtimes that currently support Ed25519 operations, visit https://github.com/WICG/webcrypto-secure-curves/issues/20.",
    [$7ed03450837e6cf8$export$69c08c51e1841f29]: "No signature verification implementation could be found.",
    [$7ed03450837e6cf8$export$325dad4e0a6bd514]: "No key generation implementation could be found.",
    [$7ed03450837e6cf8$export$242c341c7c464bee]: "No signing implementation could be found.",
    [$7ed03450837e6cf8$export$a73c064bb32a7c36]: "No key export implementation could be found.",
    [$7ed03450837e6cf8$export$8b23617676679e2d]: "Timestamp value must be in the range [-8.64e15, 8.64e15]. `$value` given",
    [$7ed03450837e6cf8$export$291ea8d5a7496fde]: "Transaction processing left an account with an outstanding borrowed reference",
    [$7ed03450837e6cf8$export$a746609ecc2f6acf]: "Account in use",
    [$7ed03450837e6cf8$export$c4d8217d3eb3eaf8]: "Account loaded twice",
    [$7ed03450837e6cf8$export$5d0f06cd8bc8e3af]: "Attempt to debit an account but found no record of a prior credit.",
    [$7ed03450837e6cf8$export$95c94f6ea500f1ab]: "Transaction loads an address table account that doesn't exist",
    [$7ed03450837e6cf8$export$2bbd9403cb117ea7]: "This transaction has already been processed",
    [$7ed03450837e6cf8$export$e108dd5343c4c11]: "Blockhash not found",
    [$7ed03450837e6cf8$export$a504ed6cab09ce4a]: "Loader call chain is too deep",
    [$7ed03450837e6cf8$export$211b9b84186690f0]: "Transactions are currently disabled due to cluster maintenance",
    [$7ed03450837e6cf8$export$e3a4007020a2e8f5]: "Transaction contains a duplicate instruction ($index) that is not allowed",
    [$7ed03450837e6cf8$export$39ead28cf48a604c]: "Insufficient funds for fee",
    [$7ed03450837e6cf8$export$2ecc275dffbc087c]: "Transaction results in an account ($accountIndex) with insufficient funds for rent",
    [$7ed03450837e6cf8$export$624f65633216eb57]: "This account may not be used to pay transaction fees",
    [$7ed03450837e6cf8$export$47df44101c6f04b0]: "Transaction contains an invalid account reference",
    [$7ed03450837e6cf8$export$bd54a9a85614b3a7]: "Transaction loads an address table account with invalid data",
    [$7ed03450837e6cf8$export$df4ef1824fd194a3]: "Transaction address table lookup uses an invalid index",
    [$7ed03450837e6cf8$export$11d69fb6993b2cf5]: "Transaction loads an address table account with an invalid owner",
    [$7ed03450837e6cf8$export$3569c6c71e349538]: "LoadedAccountsDataSizeLimit set for transaction must be greater than 0.",
    [$7ed03450837e6cf8$export$bea5f92951bc42e7]: "This program may not be used for executing instructions",
    [$7ed03450837e6cf8$export$2725d50dd432fb3a]: "Transaction leaves an account with a lower balance than rent-exempt minimum",
    [$7ed03450837e6cf8$export$b8b2610c9a910763]: "Transaction loads a writable account that cannot be written",
    [$7ed03450837e6cf8$export$e3289c5954208202]: "Transaction exceeded max loaded accounts data size cap",
    [$7ed03450837e6cf8$export$8c1ae05eccc11ef9]: "Transaction requires a fee but has no signature present",
    [$7ed03450837e6cf8$export$83c8fe2717d1b271]: "Attempt to load a program that does not exist",
    [$7ed03450837e6cf8$export$1cd0de5dfcdeb99d]: "Execution of the program referenced by account at index $accountIndex is temporarily restricted.",
    [$7ed03450837e6cf8$export$4f413e02d5e82221]: "ResanitizationNeeded",
    [$7ed03450837e6cf8$export$91a668e132084ecf]: "Transaction failed to sanitize accounts offsets correctly",
    [$7ed03450837e6cf8$export$89ae0c424691fbcb]: "Transaction did not pass signature verification",
    [$7ed03450837e6cf8$export$fa9a13f1b40ee2fb]: "Transaction locked too many accounts",
    [$7ed03450837e6cf8$export$87e01307d368f511]: "Sum of account balances before and after transaction do not match",
    [$7ed03450837e6cf8$export$8c82dde5b12c9789]: "The transaction failed with the error `$errorName`",
    [$7ed03450837e6cf8$export$58bf90c73afbc02e]: "Transaction version is unsupported",
    [$7ed03450837e6cf8$export$572954173bc64b66]: "Transaction would exceed account data limit within the block",
    [$7ed03450837e6cf8$export$7b4a7eebff68ca7b]: "Transaction would exceed total account data limit",
    [$7ed03450837e6cf8$export$fb693aebffa32676]: "Transaction would exceed max account limit within the block",
    [$7ed03450837e6cf8$export$5f027a86397cba92]: "Transaction would exceed max Block Cost Limit",
    [$7ed03450837e6cf8$export$41f13726b04d8d05]: "Transaction would exceed max Vote Cost Limit",
    [$7ed03450837e6cf8$export$36c2547c3c4d823f]: "Attempted to sign a transaction with an address that is not a signer for it",
    [$7ed03450837e6cf8$export$819b1b0603d2a966]: "Transaction is missing an address at index: $index.",
    [$7ed03450837e6cf8$export$de92784c954d1b84]: "Transaction has no expected signers therefore it cannot be encoded",
    [$7ed03450837e6cf8$export$e33d07a7526bded0]: "Transaction does not have a blockhash lifetime",
    [$7ed03450837e6cf8$export$a20747f749dd4515]: "Transaction is not a durable nonce transaction",
    [$7ed03450837e6cf8$export$b34a16b8adbffdc1]: "Contents of these address lookup tables unknown: $lookupTableAddresses",
    [$7ed03450837e6cf8$export$3764bbcfb0679211]: "Lookup of address at index $highestRequestedIndex failed for lookup table `$lookupTableAddress`. Highest known index is $highestKnownIndex. The lookup table may have been extended since its contents were retrieved",
    [$7ed03450837e6cf8$export$11bea4440904349c]: "No fee payer set in CompiledTransaction",
    [$7ed03450837e6cf8$export$ed2bdee7953e467f]: "Could not find program address at index $index",
    [$7ed03450837e6cf8$export$4e4582c633fc423e]: "Failed to estimate the compute unit consumption for this transaction message. This is likely because simulating the transaction failed. Inspect the `cause` property of this error to learn more",
    [$7ed03450837e6cf8$export$592862d1b11e32ac]: "Transaction is missing a fee payer.",
    [$7ed03450837e6cf8$export$242af5597d94abaf]: "Could not determine this transaction's signature. Make sure that the transaction has been signed by its fee payer.",
    [$7ed03450837e6cf8$export$bed6f92dafea0623]: "Transaction first instruction is not advance nonce account instruction.",
    [$7ed03450837e6cf8$export$802b3ebe5297e360]: "Transaction with no instructions cannot be durable nonce transaction.",
    [$7ed03450837e6cf8$export$694fd435994bcca]: "This transaction includes an address (`$programAddress`) which is both invoked and set as the fee payer. Program addresses may not pay fees",
    [$7ed03450837e6cf8$export$707576ec00ca24d6]: "This transaction includes an address (`$programAddress`) which is both invoked and marked writable. Program addresses may not be writable",
    [$7ed03450837e6cf8$export$b55a3eb3d894ad9f]: "The transaction message expected the transaction to have $signerAddressesLength signatures, got $signaturesLength.",
    [$7ed03450837e6cf8$export$6d61b980429516bd]: "Transaction is missing signatures for addresses: $addresses.",
    [$7ed03450837e6cf8$export$3963d9bca4091810]: "Transaction version must be in the range [0, 127]. `$actualVersion` given"
};
// src/message-formatter.ts
var $7ed03450837e6cf8$var$START_INDEX = "i";
var $7ed03450837e6cf8$var$TYPE = "t";
function $7ed03450837e6cf8$var$getHumanReadableErrorMessage(code, context = {}) {
    const messageFormatString = $7ed03450837e6cf8$var$SolanaErrorMessages[code];
    if (messageFormatString.length === 0) return "";
    let state;
    function commitStateUpTo(endIndex) {
        if (state[$7ed03450837e6cf8$var$TYPE] === 2 /* Variable */ ) {
            const variableName = messageFormatString.slice(state[$7ed03450837e6cf8$var$START_INDEX] + 1, endIndex);
            fragments.push(variableName in context ? `${context[variableName]}` : `$${variableName}`);
        } else if (state[$7ed03450837e6cf8$var$TYPE] === 1 /* Text */ ) fragments.push(messageFormatString.slice(state[$7ed03450837e6cf8$var$START_INDEX], endIndex));
    }
    const fragments = [];
    messageFormatString.split("").forEach((char, ii)=>{
        if (ii === 0) {
            state = {
                [$7ed03450837e6cf8$var$START_INDEX]: 0,
                [$7ed03450837e6cf8$var$TYPE]: messageFormatString[0] === "\\" ? 0 /* EscapeSequence */  : messageFormatString[0] === "$" ? 2 /* Variable */  : 1 /* Text */ 
            };
            return;
        }
        let nextState;
        switch(state[$7ed03450837e6cf8$var$TYPE]){
            case 0 /* EscapeSequence */ :
                nextState = {
                    [$7ed03450837e6cf8$var$START_INDEX]: ii,
                    [$7ed03450837e6cf8$var$TYPE]: 1 /* Text */ 
                };
                break;
            case 1 /* Text */ :
                if (char === "\\") nextState = {
                    [$7ed03450837e6cf8$var$START_INDEX]: ii,
                    [$7ed03450837e6cf8$var$TYPE]: 0 /* EscapeSequence */ 
                };
                else if (char === "$") nextState = {
                    [$7ed03450837e6cf8$var$START_INDEX]: ii,
                    [$7ed03450837e6cf8$var$TYPE]: 2 /* Variable */ 
                };
                break;
            case 2 /* Variable */ :
                if (char === "\\") nextState = {
                    [$7ed03450837e6cf8$var$START_INDEX]: ii,
                    [$7ed03450837e6cf8$var$TYPE]: 0 /* EscapeSequence */ 
                };
                else if (char === "$") nextState = {
                    [$7ed03450837e6cf8$var$START_INDEX]: ii,
                    [$7ed03450837e6cf8$var$TYPE]: 2 /* Variable */ 
                };
                else if (!char.match(/\w/)) nextState = {
                    [$7ed03450837e6cf8$var$START_INDEX]: ii,
                    [$7ed03450837e6cf8$var$TYPE]: 1 /* Text */ 
                };
                break;
        }
        if (nextState) {
            if (state !== nextState) commitStateUpTo(ii);
            state = nextState;
        }
    });
    commitStateUpTo();
    return fragments.join("");
}
function $7ed03450837e6cf8$var$getErrorMessage(code, context = {}) {
    {
        let decodingAdviceMessage = `Solana error #${code}; Decode this error by running \`npx @solana/errors decode -- ${code}`;
        if (Object.keys(context).length) decodingAdviceMessage += ` '${$7ed03450837e6cf8$var$encodeContextObject(context)}'`;
        return `${decodingAdviceMessage}\``;
    }
}
// src/error.ts
function $7ed03450837e6cf8$export$cfead212e52d9961(e, code) {
    const isSolanaError2 = e instanceof Error && e.name === "SolanaError";
    if (isSolanaError2) {
        if (code !== void 0) return e.context.__code === code;
        return true;
    }
    return false;
}
var $7ed03450837e6cf8$export$8349fd9adaaed269 = class extends Error {
    cause = this.cause;
    context;
    constructor(...[code, contextAndErrorOptions]){
        let context;
        let errorOptions;
        if (contextAndErrorOptions) {
            const { cause: cause, ...contextRest } = contextAndErrorOptions;
            if (cause) errorOptions = {
                cause: cause
            };
            if (Object.keys(contextRest).length > 0) context = contextRest;
        }
        const message = $7ed03450837e6cf8$var$getErrorMessage(code, context);
        super(message, errorOptions);
        this.context = {
            __code: code,
            ...context
        };
        this.name = "SolanaError";
    }
};
// src/stack-trace.ts
function $7ed03450837e6cf8$export$4608fd6508cb51(...args) {
    if ("captureStackTrace" in Error && typeof Error.captureStackTrace === "function") Error.captureStackTrace(...args);
}
// src/rpc-enum-errors.ts
function $7ed03450837e6cf8$var$getSolanaErrorFromRpcError({ errorCodeBaseOffset: errorCodeBaseOffset, getErrorContext: getErrorContext, orderedErrorNames: orderedErrorNames, rpcEnumError: rpcEnumError }, constructorOpt) {
    let rpcErrorName;
    let rpcErrorContext;
    if (typeof rpcEnumError === "string") rpcErrorName = rpcEnumError;
    else {
        rpcErrorName = Object.keys(rpcEnumError)[0];
        rpcErrorContext = rpcEnumError[rpcErrorName];
    }
    const codeOffset = orderedErrorNames.indexOf(rpcErrorName);
    const errorCode = errorCodeBaseOffset + codeOffset;
    const errorContext = getErrorContext(errorCode, rpcErrorName, rpcErrorContext);
    const err = new $7ed03450837e6cf8$export$8349fd9adaaed269(errorCode, errorContext);
    $7ed03450837e6cf8$export$4608fd6508cb51(err, constructorOpt);
    return err;
}
// src/instruction-error.ts
var $7ed03450837e6cf8$var$ORDERED_ERROR_NAMES = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/program/src/instruction.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "GenericError",
    "InvalidArgument",
    "InvalidInstructionData",
    "InvalidAccountData",
    "AccountDataTooSmall",
    "InsufficientFunds",
    "IncorrectProgramId",
    "MissingRequiredSignature",
    "AccountAlreadyInitialized",
    "UninitializedAccount",
    "UnbalancedInstruction",
    "ModifiedProgramId",
    "ExternalAccountLamportSpend",
    "ExternalAccountDataModified",
    "ReadonlyLamportChange",
    "ReadonlyDataModified",
    "DuplicateAccountIndex",
    "ExecutableModified",
    "RentEpochModified",
    "NotEnoughAccountKeys",
    "AccountDataSizeChanged",
    "AccountNotExecutable",
    "AccountBorrowFailed",
    "AccountBorrowOutstanding",
    "DuplicateAccountOutOfSync",
    "Custom",
    "InvalidError",
    "ExecutableDataModified",
    "ExecutableLamportChange",
    "ExecutableAccountNotRentExempt",
    "UnsupportedProgramId",
    "CallDepth",
    "MissingAccount",
    "ReentrancyNotAllowed",
    "MaxSeedLengthExceeded",
    "InvalidSeeds",
    "InvalidRealloc",
    "ComputationalBudgetExceeded",
    "PrivilegeEscalation",
    "ProgramEnvironmentSetupFailure",
    "ProgramFailedToComplete",
    "ProgramFailedToCompile",
    "Immutable",
    "IncorrectAuthority",
    "BorshIoError",
    "AccountNotRentExempt",
    "InvalidAccountOwner",
    "ArithmeticOverflow",
    "UnsupportedSysvar",
    "IllegalOwner",
    "MaxAccountsDataAllocationsExceeded",
    "MaxAccountsExceeded",
    "MaxInstructionTraceLengthExceeded",
    "BuiltinProgramsMustConsumeComputeUnits"
];
function $7ed03450837e6cf8$export$4e38d43e41953f9e(index, instructionError) {
    return $7ed03450837e6cf8$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 4615001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $7ed03450837e6cf8$export$d308cb6df5c28ff6) return {
                errorName: rpcErrorName,
                index: index,
                ...rpcErrorContext !== void 0 ? {
                    instructionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $7ed03450837e6cf8$export$5abe2d1d040bf6cf) return {
                code: rpcErrorContext,
                index: index
            };
            else if (errorCode === $7ed03450837e6cf8$export$57c1675a0c20931f) return {
                encodedData: rpcErrorContext,
                index: index
            };
            return {
                index: index
            };
        },
        orderedErrorNames: $7ed03450837e6cf8$var$ORDERED_ERROR_NAMES,
        rpcEnumError: instructionError
    }, $7ed03450837e6cf8$export$4e38d43e41953f9e);
}
// src/transaction-error.ts
var $7ed03450837e6cf8$var$ORDERED_ERROR_NAMES2 = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/src/transaction/error.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "AccountInUse",
    "AccountLoadedTwice",
    "AccountNotFound",
    "ProgramAccountNotFound",
    "InsufficientFundsForFee",
    "InvalidAccountForFee",
    "AlreadyProcessed",
    "BlockhashNotFound",
    // `InstructionError` intentionally omitted; delegated to `getSolanaErrorFromInstructionError`
    "CallChainTooDeep",
    "MissingSignatureForFee",
    "InvalidAccountIndex",
    "SignatureFailure",
    "InvalidProgramForExecution",
    "SanitizeFailure",
    "ClusterMaintenance",
    "AccountBorrowOutstanding",
    "WouldExceedMaxBlockCostLimit",
    "UnsupportedVersion",
    "InvalidWritableAccount",
    "WouldExceedMaxAccountCostLimit",
    "WouldExceedAccountDataBlockLimit",
    "TooManyAccountLocks",
    "AddressLookupTableNotFound",
    "InvalidAddressLookupTableOwner",
    "InvalidAddressLookupTableData",
    "InvalidAddressLookupTableIndex",
    "InvalidRentPayingAccount",
    "WouldExceedMaxVoteCostLimit",
    "WouldExceedAccountDataTotalLimit",
    "DuplicateInstruction",
    "InsufficientFundsForRent",
    "MaxLoadedAccountsDataSizeExceeded",
    "InvalidLoadedAccountsDataSizeLimit",
    "ResanitizationNeeded",
    "ProgramExecutionTemporarilyRestricted",
    "UnbalancedTransaction"
];
function $7ed03450837e6cf8$export$c10ce7a2fd9c66f0(transactionError) {
    if (typeof transactionError === "object" && "InstructionError" in transactionError) return $7ed03450837e6cf8$export$4e38d43e41953f9e(...transactionError.InstructionError);
    return $7ed03450837e6cf8$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 7050001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $7ed03450837e6cf8$export$8c82dde5b12c9789) return {
                errorName: rpcErrorName,
                ...rpcErrorContext !== void 0 ? {
                    transactionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $7ed03450837e6cf8$export$e3a4007020a2e8f5) return {
                index: rpcErrorContext
            };
            else if (errorCode === $7ed03450837e6cf8$export$2ecc275dffbc087c || errorCode === $7ed03450837e6cf8$export$1cd0de5dfcdeb99d) return {
                accountIndex: rpcErrorContext.account_index
            };
        },
        orderedErrorNames: $7ed03450837e6cf8$var$ORDERED_ERROR_NAMES2,
        rpcEnumError: transactionError
    }, $7ed03450837e6cf8$export$c10ce7a2fd9c66f0);
}
// src/json-rpc-error.ts
function $7ed03450837e6cf8$export$1f67f8d128316a6d({ code: code, data: data, message: message }) {
    let out;
    if (code === $7ed03450837e6cf8$export$426cc73f5ad00f38) {
        const { err: err, ...preflightErrorContext } = data;
        const causeObject = err ? {
            cause: $7ed03450837e6cf8$export$c10ce7a2fd9c66f0(err)
        } : null;
        out = new $7ed03450837e6cf8$export$8349fd9adaaed269($7ed03450837e6cf8$export$426cc73f5ad00f38, {
            ...preflightErrorContext,
            ...causeObject
        });
    } else {
        let errorContext;
        switch(code){
            case $7ed03450837e6cf8$export$afa40fd3fc01204:
            case $7ed03450837e6cf8$export$2981978a530b1a7c:
            case $7ed03450837e6cf8$export$23cb4efd59427895:
            case $7ed03450837e6cf8$export$5ec955cc8b7e8cf9:
            case $7ed03450837e6cf8$export$e09e3905081e44fe:
            case $7ed03450837e6cf8$export$1b90c411626421b1:
            case $7ed03450837e6cf8$export$6ae475e85fe02aad:
            case $7ed03450837e6cf8$export$bfbf8b75e865efa0:
            case $7ed03450837e6cf8$export$65235469ebe9845e:
            case $7ed03450837e6cf8$export$54dea2286c43ec1e:
            case $7ed03450837e6cf8$export$e71fbee92648fc61:
            case $7ed03450837e6cf8$export$d21075fd06730e:
            case $7ed03450837e6cf8$export$d964b43bb02eacdf:
            case $7ed03450837e6cf8$export$f7685139153f9191:
                errorContext = {
                    __serverMessage: message
                };
                break;
            default:
                if (typeof data === "object" && !Array.isArray(data)) errorContext = data;
        }
        out = new $7ed03450837e6cf8$export$8349fd9adaaed269(code, errorContext);
    }
    $7ed03450837e6cf8$export$4608fd6508cb51(out, $7ed03450837e6cf8$export$1f67f8d128316a6d);
    return out;
}
 //# sourceMappingURL=index.browser.mjs.map


// src/add-codec-sentinel.ts
// src/bytes.ts
var $d541973339e39c73$export$6cf3317d55598fde = (byteArrays)=>{
    const nonEmptyByteArrays = byteArrays.filter((arr)=>arr.length);
    if (nonEmptyByteArrays.length === 0) return byteArrays.length ? byteArrays[0] : new Uint8Array();
    if (nonEmptyByteArrays.length === 1) return nonEmptyByteArrays[0];
    const totalLength = nonEmptyByteArrays.reduce((total, arr)=>total + arr.length, 0);
    const result = new Uint8Array(totalLength);
    let offset = 0;
    nonEmptyByteArrays.forEach((arr)=>{
        result.set(arr, offset);
        offset += arr.length;
    });
    return result;
};
var $d541973339e39c73$export$4c6b868113605df3 = (bytes, length)=>{
    if (bytes.length >= length) return bytes;
    const paddedBytes = new Uint8Array(length).fill(0);
    paddedBytes.set(bytes);
    return paddedBytes;
};
var $d541973339e39c73$export$11b3146a4f4702ef = (bytes, length)=>$d541973339e39c73$export$4c6b868113605df3(bytes.length <= length ? bytes : bytes.slice(0, length), length);
function $d541973339e39c73$export$1b62aef2a79e6b21(data, bytes, offset) {
    const slice = offset === 0 && data.length === bytes.length ? data : data.slice(offset, offset + bytes.length);
    if (slice.length !== bytes.length) return false;
    return bytes.every((b, i)=>b === slice[i]);
}
function $d541973339e39c73$export$30f3257599397621(value, encoder) {
    return "fixedSize" in encoder ? encoder.fixedSize : encoder.getSizeFromValue(value);
}
function $d541973339e39c73$export$4e76eeb6df88c889(encoder) {
    return Object.freeze({
        ...encoder,
        encode: (value)=>{
            const bytes = new Uint8Array($d541973339e39c73$export$30f3257599397621(value, encoder));
            encoder.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $d541973339e39c73$export$f8c898e83b60faaa(decoder) {
    return Object.freeze({
        ...decoder,
        decode: (bytes, offset = 0)=>decoder.read(bytes, offset)[0]
    });
}
function $d541973339e39c73$export$a4cf2f585987cc8(codec) {
    return Object.freeze({
        ...codec,
        decode: (bytes, offset = 0)=>codec.read(bytes, offset)[0],
        encode: (value)=>{
            const bytes = new Uint8Array($d541973339e39c73$export$30f3257599397621(value, codec));
            codec.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $d541973339e39c73$export$f9d60229c95384d4(codec) {
    return "fixedSize" in codec && typeof codec.fixedSize === "number";
}
function $d541973339e39c73$export$4e85b7423fd6bc55(codec) {
    if (!$d541973339e39c73$export$f9d60229c95384d4(codec)) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$93561b31b951410d));
}
function $d541973339e39c73$export$d76fd0b6e42f051a(codec) {
    return !$d541973339e39c73$export$f9d60229c95384d4(codec);
}
function $d541973339e39c73$export$6bf5fc425e413c8a(codec) {
    if (!$d541973339e39c73$export$d76fd0b6e42f051a(codec)) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$3417da5bc6bcb45));
}
function $d541973339e39c73$export$b88681b853abde79(encoder, decoder) {
    if ($d541973339e39c73$export$f9d60229c95384d4(encoder) !== $d541973339e39c73$export$f9d60229c95384d4(decoder)) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$c4c73ab3c0833591));
    if ($d541973339e39c73$export$f9d60229c95384d4(encoder) && $d541973339e39c73$export$f9d60229c95384d4(decoder) && encoder.fixedSize !== decoder.fixedSize) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$824d79ab1779d517), {
        decoderFixedSize: decoder.fixedSize,
        encoderFixedSize: encoder.fixedSize
    });
    if (!$d541973339e39c73$export$f9d60229c95384d4(encoder) && !$d541973339e39c73$export$f9d60229c95384d4(decoder) && encoder.maxSize !== decoder.maxSize) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$c464f3b291f1f3d0), {
        decoderMaxSize: decoder.maxSize,
        encoderMaxSize: encoder.maxSize
    });
    return {
        ...decoder,
        ...encoder,
        decode: decoder.decode,
        encode: encoder.encode,
        read: decoder.read,
        write: encoder.write
    };
}
// src/add-codec-sentinel.ts
function $d541973339e39c73$export$e98b1308839de22(encoder, sentinel) {
    const write = (value, bytes, offset)=>{
        const encoderBytes = encoder.encode(value);
        if ($d541973339e39c73$var$findSentinelIndex(encoderBytes, sentinel) >= 0) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$a9282ed13660c9f6), {
            encodedBytes: encoderBytes,
            hexEncodedBytes: $d541973339e39c73$var$hexBytes(encoderBytes),
            hexSentinel: $d541973339e39c73$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        bytes.set(encoderBytes, offset);
        offset += encoderBytes.length;
        bytes.set(sentinel, offset);
        offset += sentinel.length;
        return offset;
    };
    if ($d541973339e39c73$export$f9d60229c95384d4(encoder)) return $d541973339e39c73$export$4e76eeb6df88c889({
        ...encoder,
        fixedSize: encoder.fixedSize + sentinel.length,
        write: write
    });
    return $d541973339e39c73$export$4e76eeb6df88c889({
        ...encoder,
        ...encoder.maxSize != null ? {
            maxSize: encoder.maxSize + sentinel.length
        } : {},
        getSizeFromValue: (value)=>encoder.getSizeFromValue(value) + sentinel.length,
        write: write
    });
}
function $d541973339e39c73$export$cdbc1a8bfd8f69c8(decoder, sentinel) {
    const read = (bytes, offset)=>{
        const candidateBytes = offset === 0 ? bytes : bytes.slice(offset);
        const sentinelIndex = $d541973339e39c73$var$findSentinelIndex(candidateBytes, sentinel);
        if (sentinelIndex === -1) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$5bdfee6423bc35ce), {
            decodedBytes: candidateBytes,
            hexDecodedBytes: $d541973339e39c73$var$hexBytes(candidateBytes),
            hexSentinel: $d541973339e39c73$var$hexBytes(sentinel),
            sentinel: sentinel
        });
        const preSentinelBytes = candidateBytes.slice(0, sentinelIndex);
        return [
            decoder.decode(preSentinelBytes),
            offset + preSentinelBytes.length + sentinel.length
        ];
    };
    if ($d541973339e39c73$export$f9d60229c95384d4(decoder)) return $d541973339e39c73$export$f8c898e83b60faaa({
        ...decoder,
        fixedSize: decoder.fixedSize + sentinel.length,
        read: read
    });
    return $d541973339e39c73$export$f8c898e83b60faaa({
        ...decoder,
        ...decoder.maxSize != null ? {
            maxSize: decoder.maxSize + sentinel.length
        } : {},
        read: read
    });
}
function $d541973339e39c73$export$56d7c5070d1e9d9b(codec, sentinel) {
    return $d541973339e39c73$export$b88681b853abde79($d541973339e39c73$export$e98b1308839de22(codec, sentinel), $d541973339e39c73$export$cdbc1a8bfd8f69c8(codec, sentinel));
}
function $d541973339e39c73$var$findSentinelIndex(bytes, sentinel) {
    return bytes.findIndex((byte, index, arr)=>{
        if (sentinel.length === 1) return byte === sentinel[0];
        return $d541973339e39c73$export$1b62aef2a79e6b21(arr, sentinel, index);
    });
}
function $d541973339e39c73$var$hexBytes(bytes) {
    return bytes.reduce((str, byte)=>str + byte.toString(16).padStart(2, "0"), "");
}
function $d541973339e39c73$export$bf929351331b7b89(codecDescription, bytes, offset = 0) {
    if (bytes.length - offset <= 0) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$9c9326ce1e3df40c), {
        codecDescription: codecDescription
    });
}
function $d541973339e39c73$export$4a981e7c9ed0b6bf(codecDescription, expected, bytes, offset = 0) {
    const bytesLength = bytes.length - offset;
    if (bytesLength < expected) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$18fbf24f19efc69b), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        expected: expected
    });
}
function $d541973339e39c73$export$9319e0aa6a4927d2(codecDescription, offset, bytesLength) {
    if (offset < 0 || offset > bytesLength) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$a617dff403944ec6), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        offset: offset
    });
}
// src/add-codec-size-prefix.ts
function $d541973339e39c73$export$37e5b12cb5a8d560(encoder, prefix) {
    const write = (value, bytes, offset)=>{
        const encoderBytes = encoder.encode(value);
        offset = prefix.write(encoderBytes.length, bytes, offset);
        bytes.set(encoderBytes, offset);
        return offset + encoderBytes.length;
    };
    if ($d541973339e39c73$export$f9d60229c95384d4(prefix) && $d541973339e39c73$export$f9d60229c95384d4(encoder)) return $d541973339e39c73$export$4e76eeb6df88c889({
        ...encoder,
        fixedSize: prefix.fixedSize + encoder.fixedSize,
        write: write
    });
    const prefixMaxSize = $d541973339e39c73$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : prefix.maxSize ?? null;
    const encoderMaxSize = $d541973339e39c73$export$f9d60229c95384d4(encoder) ? encoder.fixedSize : encoder.maxSize ?? null;
    const maxSize = prefixMaxSize !== null && encoderMaxSize !== null ? prefixMaxSize + encoderMaxSize : null;
    return $d541973339e39c73$export$4e76eeb6df88c889({
        ...encoder,
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        getSizeFromValue: (value)=>{
            const encoderSize = $d541973339e39c73$export$30f3257599397621(value, encoder);
            return $d541973339e39c73$export$30f3257599397621(encoderSize, prefix) + encoderSize;
        },
        write: write
    });
}
function $d541973339e39c73$export$fe2b33c81523b294(decoder, prefix) {
    const read = (bytes, offset)=>{
        const [bigintSize, decoderOffset] = prefix.read(bytes, offset);
        const size = Number(bigintSize);
        offset = decoderOffset;
        if (offset > 0 || bytes.length > size) bytes = bytes.slice(offset, offset + size);
        $d541973339e39c73$export$4a981e7c9ed0b6bf("addDecoderSizePrefix", size, bytes);
        return [
            decoder.decode(bytes),
            offset + size
        ];
    };
    if ($d541973339e39c73$export$f9d60229c95384d4(prefix) && $d541973339e39c73$export$f9d60229c95384d4(decoder)) return $d541973339e39c73$export$f8c898e83b60faaa({
        ...decoder,
        fixedSize: prefix.fixedSize + decoder.fixedSize,
        read: read
    });
    const prefixMaxSize = $d541973339e39c73$export$f9d60229c95384d4(prefix) ? prefix.fixedSize : prefix.maxSize ?? null;
    const decoderMaxSize = $d541973339e39c73$export$f9d60229c95384d4(decoder) ? decoder.fixedSize : decoder.maxSize ?? null;
    const maxSize = prefixMaxSize !== null && decoderMaxSize !== null ? prefixMaxSize + decoderMaxSize : null;
    return $d541973339e39c73$export$f8c898e83b60faaa({
        ...decoder,
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        read: read
    });
}
function $d541973339e39c73$export$ec85c1caba397ab2(codec, prefix) {
    return $d541973339e39c73$export$b88681b853abde79($d541973339e39c73$export$37e5b12cb5a8d560(codec, prefix), $d541973339e39c73$export$fe2b33c81523b294(codec, prefix));
}
// src/fix-codec-size.ts
function $d541973339e39c73$export$cbdfce031443a1(encoder, fixedBytes) {
    return $d541973339e39c73$export$4e76eeb6df88c889({
        fixedSize: fixedBytes,
        write: (value, bytes, offset)=>{
            const variableByteArray = encoder.encode(value);
            const fixedByteArray = variableByteArray.length > fixedBytes ? variableByteArray.slice(0, fixedBytes) : variableByteArray;
            bytes.set(fixedByteArray, offset);
            return offset + fixedBytes;
        }
    });
}
function $d541973339e39c73$export$1f85f8b8d2788007(decoder, fixedBytes) {
    return $d541973339e39c73$export$f8c898e83b60faaa({
        fixedSize: fixedBytes,
        read: (bytes, offset)=>{
            $d541973339e39c73$export$4a981e7c9ed0b6bf("fixCodecSize", fixedBytes, bytes, offset);
            if (offset > 0 || bytes.length > fixedBytes) bytes = bytes.slice(offset, offset + fixedBytes);
            if ($d541973339e39c73$export$f9d60229c95384d4(decoder)) bytes = $d541973339e39c73$export$11b3146a4f4702ef(bytes, decoder.fixedSize);
            const [value] = decoder.read(bytes, 0);
            return [
                value,
                offset + fixedBytes
            ];
        }
    });
}
function $d541973339e39c73$export$ff7dc697d5cc308f(codec, fixedBytes) {
    return $d541973339e39c73$export$b88681b853abde79($d541973339e39c73$export$cbdfce031443a1(codec, fixedBytes), $d541973339e39c73$export$1f85f8b8d2788007(codec, fixedBytes));
}
// src/offset-codec.ts
function $d541973339e39c73$export$92407871fbff8926(encoder, config) {
    return $d541973339e39c73$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, preOffset)=>{
            const wrapBytes = (offset)=>$d541973339e39c73$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $d541973339e39c73$export$9319e0aa6a4927d2("offsetEncoder", newPreOffset, bytes.length);
            const postOffset = encoder.write(value, bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $d541973339e39c73$export$9319e0aa6a4927d2("offsetEncoder", newPostOffset, bytes.length);
            return newPostOffset;
        }
    });
}
function $d541973339e39c73$export$24667feddece166a(decoder, config) {
    return $d541973339e39c73$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, preOffset)=>{
            const wrapBytes = (offset)=>$d541973339e39c73$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $d541973339e39c73$export$9319e0aa6a4927d2("offsetDecoder", newPreOffset, bytes.length);
            const [value, postOffset] = decoder.read(bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $d541973339e39c73$export$9319e0aa6a4927d2("offsetDecoder", newPostOffset, bytes.length);
            return [
                value,
                newPostOffset
            ];
        }
    });
}
function $d541973339e39c73$export$8170ddca0f3f53ea(codec, config) {
    return $d541973339e39c73$export$b88681b853abde79($d541973339e39c73$export$92407871fbff8926(codec, config), $d541973339e39c73$export$24667feddece166a(codec, config));
}
function $d541973339e39c73$var$modulo(dividend, divisor) {
    if (divisor === 0) return 0;
    return (dividend % divisor + divisor) % divisor;
}
function $d541973339e39c73$export$d41c2ca858573bc6(encoder, resize) {
    if ($d541973339e39c73$export$f9d60229c95384d4(encoder)) {
        const fixedSize = resize(encoder.fixedSize);
        if (fixedSize < 0) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeEncoder"
        });
        return $d541973339e39c73$export$4e76eeb6df88c889({
            ...encoder,
            fixedSize: fixedSize
        });
    }
    return $d541973339e39c73$export$4e76eeb6df88c889({
        ...encoder,
        getSizeFromValue: (value)=>{
            const newSize = resize(encoder.getSizeFromValue(value));
            if (newSize < 0) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$4c1fcb4bd20b2951), {
                bytesLength: newSize,
                codecDescription: "resizeEncoder"
            });
            return newSize;
        }
    });
}
function $d541973339e39c73$export$7369e12a03366140(decoder, resize) {
    if ($d541973339e39c73$export$f9d60229c95384d4(decoder)) {
        const fixedSize = resize(decoder.fixedSize);
        if (fixedSize < 0) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeDecoder"
        });
        return $d541973339e39c73$export$f8c898e83b60faaa({
            ...decoder,
            fixedSize: fixedSize
        });
    }
    return decoder;
}
function $d541973339e39c73$export$aff234b7657ae683(codec, resize) {
    return $d541973339e39c73$export$b88681b853abde79($d541973339e39c73$export$d41c2ca858573bc6(codec, resize), $d541973339e39c73$export$7369e12a03366140(codec, resize));
}
// src/pad-codec.ts
function $d541973339e39c73$export$66b1746799cd3030(encoder, offset) {
    return $d541973339e39c73$export$92407871fbff8926($d541973339e39c73$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $d541973339e39c73$export$770586d1e6f1e5b(encoder, offset) {
    return $d541973339e39c73$export$92407871fbff8926($d541973339e39c73$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $d541973339e39c73$export$d88f5bbaa5c2e177(decoder, offset) {
    return $d541973339e39c73$export$24667feddece166a($d541973339e39c73$export$7369e12a03366140(decoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $d541973339e39c73$export$57a7baba87e0aed9(decoder, offset) {
    return $d541973339e39c73$export$24667feddece166a($d541973339e39c73$export$7369e12a03366140(decoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $d541973339e39c73$export$d6ed5bbf596a5505(codec, offset) {
    return $d541973339e39c73$export$b88681b853abde79($d541973339e39c73$export$66b1746799cd3030(codec, offset), $d541973339e39c73$export$d88f5bbaa5c2e177(codec, offset));
}
function $d541973339e39c73$export$b11ce69168faaa31(codec, offset) {
    return $d541973339e39c73$export$b88681b853abde79($d541973339e39c73$export$770586d1e6f1e5b(codec, offset), $d541973339e39c73$export$57a7baba87e0aed9(codec, offset));
}
// src/reverse-codec.ts
function $d541973339e39c73$var$copySourceToTargetInReverse(source, target_WILL_MUTATE, sourceOffset, sourceLength, targetOffset = 0) {
    while(sourceOffset < --sourceLength){
        const leftValue = source[sourceOffset];
        target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceLength];
        target_WILL_MUTATE[sourceLength + targetOffset] = leftValue;
        sourceOffset++;
    }
    if (sourceOffset === sourceLength) target_WILL_MUTATE[sourceOffset + targetOffset] = source[sourceOffset];
}
function $d541973339e39c73$export$290b4b66fdcc682c(encoder) {
    $d541973339e39c73$export$4e85b7423fd6bc55(encoder);
    return $d541973339e39c73$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, offset)=>{
            const newOffset = encoder.write(value, bytes, offset);
            $d541973339e39c73$var$copySourceToTargetInReverse(bytes, bytes, offset, offset + encoder.fixedSize);
            return newOffset;
        }
    });
}
function $d541973339e39c73$export$1dded7e9fb3087ff(decoder) {
    $d541973339e39c73$export$4e85b7423fd6bc55(decoder);
    return $d541973339e39c73$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const reversedBytes = bytes.slice();
            $d541973339e39c73$var$copySourceToTargetInReverse(bytes, reversedBytes, offset, offset + decoder.fixedSize);
            return decoder.read(reversedBytes, offset);
        }
    });
}
function $d541973339e39c73$export$e1ef688f83355e2e(codec) {
    return $d541973339e39c73$export$b88681b853abde79($d541973339e39c73$export$290b4b66fdcc682c(codec), $d541973339e39c73$export$1dded7e9fb3087ff(codec));
}
// src/transform-codec.ts
function $d541973339e39c73$export$30169aca64409a56(encoder, unmap) {
    return $d541973339e39c73$export$4e76eeb6df88c889({
        ...$d541973339e39c73$export$d76fd0b6e42f051a(encoder) ? {
            ...encoder,
            getSizeFromValue: (value)=>encoder.getSizeFromValue(unmap(value))
        } : encoder,
        write: (value, bytes, offset)=>encoder.write(unmap(value), bytes, offset)
    });
}
function $d541973339e39c73$export$605b10ee38669daa(decoder, map) {
    return $d541973339e39c73$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const [value, newOffset] = decoder.read(bytes, offset);
            return [
                map(value, bytes, offset),
                newOffset
            ];
        }
    });
}
function $d541973339e39c73$export$59b20038bbe52b5f(codec, unmap, map) {
    return $d541973339e39c73$export$a4cf2f585987cc8({
        ...$d541973339e39c73$export$30169aca64409a56(codec, unmap),
        read: map ? $d541973339e39c73$export$605b10ee38669daa(codec, map).read : codec.read
    });
}
 //# sourceMappingURL=index.browser.mjs.map




// src/assertions.ts
function $850883b1d3fb5b0b$export$50ab5941a148d055(codecDescription, min, max, value) {
    if (value < min || value > max) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$8653c145864f47f4), {
        codecDescription: codecDescription,
        max: max,
        min: min,
        value: value
    });
}
// src/common.ts
var $850883b1d3fb5b0b$export$54493dce0da47833 = /* @__PURE__ */ ((Endian2)=>{
    Endian2[Endian2["Little"] = 0] = "Little";
    Endian2[Endian2["Big"] = 1] = "Big";
    return Endian2;
})($850883b1d3fb5b0b$export$54493dce0da47833 || {});
function $850883b1d3fb5b0b$var$isLittleEndian(config) {
    return config?.endian === 1 /* Big */  ? false : true;
}
function $850883b1d3fb5b0b$var$numberEncoderFactory(input) {
    return (0, $d541973339e39c73$export$4e76eeb6df88c889)({
        fixedSize: input.size,
        write (value, bytes, offset) {
            if (input.range) $850883b1d3fb5b0b$export$50ab5941a148d055(input.name, input.range[0], input.range[1], value);
            const arrayBuffer = new ArrayBuffer(input.size);
            input.set(new DataView(arrayBuffer), value, $850883b1d3fb5b0b$var$isLittleEndian(input.config));
            bytes.set(new Uint8Array(arrayBuffer), offset);
            return offset + input.size;
        }
    });
}
function $850883b1d3fb5b0b$var$numberDecoderFactory(input) {
    return (0, $d541973339e39c73$export$f8c898e83b60faaa)({
        fixedSize: input.size,
        read (bytes, offset = 0) {
            (0, $d541973339e39c73$export$bf929351331b7b89)(input.name, bytes, offset);
            (0, $d541973339e39c73$export$4a981e7c9ed0b6bf)(input.name, input.size, bytes, offset);
            const view = new DataView($850883b1d3fb5b0b$var$toArrayBuffer(bytes, offset, input.size));
            return [
                input.get(view, $850883b1d3fb5b0b$var$isLittleEndian(input.config)),
                offset + input.size
            ];
        }
    });
}
function $850883b1d3fb5b0b$var$toArrayBuffer(bytes, offset, length) {
    const bytesOffset = bytes.byteOffset + (offset ?? 0);
    const bytesLength = length ?? bytes.byteLength;
    return bytes.buffer.slice(bytesOffset, bytesOffset + bytesLength);
}
// src/f32.ts
var $850883b1d3fb5b0b$export$d76ef1cfec201bc9 = (config = {})=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        config: config,
        name: "f32",
        set: (view, value, le)=>view.setFloat32(0, Number(value), le),
        size: 4
    });
var $850883b1d3fb5b0b$export$314df11445cfa5d0 = (config = {})=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getFloat32(0, le),
        name: "f32",
        size: 4
    });
var $850883b1d3fb5b0b$export$97a035f0564c51de = (config = {})=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$d76ef1cfec201bc9(config), $850883b1d3fb5b0b$export$314df11445cfa5d0(config));
var $850883b1d3fb5b0b$export$551368d522177b99 = (config = {})=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        config: config,
        name: "f64",
        set: (view, value, le)=>view.setFloat64(0, Number(value), le),
        size: 8
    });
var $850883b1d3fb5b0b$export$9475ae45ddf86dec = (config = {})=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getFloat64(0, le),
        name: "f64",
        size: 8
    });
var $850883b1d3fb5b0b$export$9db82e6fbf3ec8ac = (config = {})=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$551368d522177b99(config), $850883b1d3fb5b0b$export$9475ae45ddf86dec(config));
var $850883b1d3fb5b0b$export$cf7587f741407205 = (config = {})=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        config: config,
        name: "i128",
        range: [
            -BigInt("0x7fffffffffffffffffffffffffffffff") - 1n,
            BigInt("0x7fffffffffffffffffffffffffffffff")
        ],
        set: (view, value, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const rightMask = 0xffffffffffffffffn;
            view.setBigInt64(leftOffset, BigInt(value) >> 64n, le);
            view.setBigUint64(rightOffset, BigInt(value) & rightMask, le);
        },
        size: 16
    });
var $850883b1d3fb5b0b$export$aacd18c97984700c = (config = {})=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const left = view.getBigInt64(leftOffset, le);
            const right = view.getBigUint64(rightOffset, le);
            return (left << 64n) + right;
        },
        name: "i128",
        size: 16
    });
var $850883b1d3fb5b0b$export$b2a180b15845f643 = (config = {})=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$cf7587f741407205(config), $850883b1d3fb5b0b$export$aacd18c97984700c(config));
var $850883b1d3fb5b0b$export$45d575c12b2bb6a5 = (config = {})=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        config: config,
        name: "i16",
        range: [
            -Number("0x7fff") - 1,
            Number("0x7fff")
        ],
        set: (view, value, le)=>view.setInt16(0, Number(value), le),
        size: 2
    });
var $850883b1d3fb5b0b$export$4617ff1e22909f4 = (config = {})=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getInt16(0, le),
        name: "i16",
        size: 2
    });
var $850883b1d3fb5b0b$export$c82cd783a714bca2 = (config = {})=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$45d575c12b2bb6a5(config), $850883b1d3fb5b0b$export$4617ff1e22909f4(config));
var $850883b1d3fb5b0b$export$73a58a16e77bb58b = (config = {})=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        config: config,
        name: "i32",
        range: [
            -Number("0x7fffffff") - 1,
            Number("0x7fffffff")
        ],
        set: (view, value, le)=>view.setInt32(0, Number(value), le),
        size: 4
    });
var $850883b1d3fb5b0b$export$a7167d44cb5c65b9 = (config = {})=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getInt32(0, le),
        name: "i32",
        size: 4
    });
var $850883b1d3fb5b0b$export$c31d2e083195a86f = (config = {})=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$73a58a16e77bb58b(config), $850883b1d3fb5b0b$export$a7167d44cb5c65b9(config));
var $850883b1d3fb5b0b$export$42b58a304e7edd67 = (config = {})=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        config: config,
        name: "i64",
        range: [
            -BigInt("0x7fffffffffffffff") - 1n,
            BigInt("0x7fffffffffffffff")
        ],
        set: (view, value, le)=>view.setBigInt64(0, BigInt(value), le),
        size: 8
    });
var $850883b1d3fb5b0b$export$6f14c9b3a349f404 = (config = {})=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getBigInt64(0, le),
        name: "i64",
        size: 8
    });
var $850883b1d3fb5b0b$export$ebdc4dbdba726e6a = (config = {})=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$42b58a304e7edd67(config), $850883b1d3fb5b0b$export$6f14c9b3a349f404(config));
var $850883b1d3fb5b0b$export$44792a8c35b3c0ce = ()=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        name: "i8",
        range: [
            -Number("0x7f") - 1,
            Number("0x7f")
        ],
        set: (view, value)=>view.setInt8(0, Number(value)),
        size: 1
    });
var $850883b1d3fb5b0b$export$fdc22c4a59dfe6be = ()=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        get: (view)=>view.getInt8(0),
        name: "i8",
        size: 1
    });
var $850883b1d3fb5b0b$export$f930a8952cfab173 = ()=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$44792a8c35b3c0ce(), $850883b1d3fb5b0b$export$fdc22c4a59dfe6be());
var $850883b1d3fb5b0b$export$6f025a6ce2a023fc = ()=>(0, $d541973339e39c73$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>{
            if (value <= 127) return 1;
            if (value <= 16383) return 2;
            return 3;
        },
        maxSize: 3,
        write: (value, bytes, offset)=>{
            $850883b1d3fb5b0b$export$50ab5941a148d055("shortU16", 0, 65535, value);
            const shortU16Bytes = [
                0
            ];
            for(let ii = 0;; ii += 1){
                const alignedValue = Number(value) >> ii * 7;
                if (alignedValue === 0) break;
                const nextSevenBits = 127 & alignedValue;
                shortU16Bytes[ii] = nextSevenBits;
                if (ii > 0) shortU16Bytes[ii - 1] |= 128;
            }
            bytes.set(shortU16Bytes, offset);
            return offset + shortU16Bytes.length;
        }
    });
var $850883b1d3fb5b0b$export$fa35aa457fb08b4a = ()=>(0, $d541973339e39c73$export$f8c898e83b60faaa)({
        maxSize: 3,
        read: (bytes, offset)=>{
            let value = 0;
            let byteCount = 0;
            while(++byteCount){
                const byteIndex = byteCount - 1;
                const currentByte = bytes[offset + byteIndex];
                const nextSevenBits = 127 & currentByte;
                value |= nextSevenBits << byteIndex * 7;
                if ((currentByte & 128) === 0) break;
            }
            return [
                value,
                offset + byteCount
            ];
        }
    });
var $850883b1d3fb5b0b$export$9f6b1d6c8cda8e31 = ()=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$6f025a6ce2a023fc(), $850883b1d3fb5b0b$export$fa35aa457fb08b4a());
var $850883b1d3fb5b0b$export$3333225663a8d6bb = (config = {})=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        config: config,
        name: "u128",
        range: [
            0n,
            BigInt("0xffffffffffffffffffffffffffffffff")
        ],
        set: (view, value, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const rightMask = 0xffffffffffffffffn;
            view.setBigUint64(leftOffset, BigInt(value) >> 64n, le);
            view.setBigUint64(rightOffset, BigInt(value) & rightMask, le);
        },
        size: 16
    });
var $850883b1d3fb5b0b$export$523e33537e060693 = (config = {})=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const left = view.getBigUint64(leftOffset, le);
            const right = view.getBigUint64(rightOffset, le);
            return (left << 64n) + right;
        },
        name: "u128",
        size: 16
    });
var $850883b1d3fb5b0b$export$e775878beaafab29 = (config = {})=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$3333225663a8d6bb(config), $850883b1d3fb5b0b$export$523e33537e060693(config));
var $850883b1d3fb5b0b$export$e156211d06496a2f = (config = {})=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        config: config,
        name: "u16",
        range: [
            0,
            Number("0xffff")
        ],
        set: (view, value, le)=>view.setUint16(0, Number(value), le),
        size: 2
    });
var $850883b1d3fb5b0b$export$1a649eb0055ac058 = (config = {})=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getUint16(0, le),
        name: "u16",
        size: 2
    });
var $850883b1d3fb5b0b$export$dda1212c8afd5e5c = (config = {})=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$e156211d06496a2f(config), $850883b1d3fb5b0b$export$1a649eb0055ac058(config));
var $850883b1d3fb5b0b$export$3e3136013a349951 = (config = {})=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        config: config,
        name: "u32",
        range: [
            0,
            Number("0xffffffff")
        ],
        set: (view, value, le)=>view.setUint32(0, Number(value), le),
        size: 4
    });
var $850883b1d3fb5b0b$export$ddc26825031b1ac9 = (config = {})=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getUint32(0, le),
        name: "u32",
        size: 4
    });
var $850883b1d3fb5b0b$export$172bf721fe9bbfd1 = (config = {})=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$3e3136013a349951(config), $850883b1d3fb5b0b$export$ddc26825031b1ac9(config));
var $850883b1d3fb5b0b$export$59d3bc8d559487ec = (config = {})=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        config: config,
        name: "u64",
        range: [
            0n,
            BigInt("0xffffffffffffffff")
        ],
        set: (view, value, le)=>view.setBigUint64(0, BigInt(value), le),
        size: 8
    });
var $850883b1d3fb5b0b$export$faa05ffebebd465d = (config = {})=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getBigUint64(0, le),
        name: "u64",
        size: 8
    });
var $850883b1d3fb5b0b$export$7e56ec13f6029ccc = (config = {})=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$59d3bc8d559487ec(config), $850883b1d3fb5b0b$export$faa05ffebebd465d(config));
var $850883b1d3fb5b0b$export$dc9732115561fb4b = ()=>$850883b1d3fb5b0b$var$numberEncoderFactory({
        name: "u8",
        range: [
            0,
            Number("0xff")
        ],
        set: (view, value)=>view.setUint8(0, Number(value)),
        size: 1
    });
var $850883b1d3fb5b0b$export$edadf68f5f1a8bc6 = ()=>$850883b1d3fb5b0b$var$numberDecoderFactory({
        get: (view)=>view.getUint8(0),
        name: "u8",
        size: 1
    });
var $850883b1d3fb5b0b$export$5ae2d5c46a10d97 = ()=>(0, $d541973339e39c73$export$b88681b853abde79)($850883b1d3fb5b0b$export$dc9732115561fb4b(), $850883b1d3fb5b0b$export$edadf68f5f1a8bc6());
 //# sourceMappingURL=index.browser.mjs.map



// src/array.ts
function $f6bc56e04ddc7ba5$export$1e6cff54ac72b1a3(codecDescription, expected, actual) {
    if (expected !== actual) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$c04710d31ef4d278), {
        actual: actual,
        codecDescription: codecDescription,
        expected: expected
    });
}
function $f6bc56e04ddc7ba5$var$maxCodecSizes(sizes) {
    return sizes.reduce((all, size)=>all === null || size === null ? null : Math.max(all, size), 0);
}
function $f6bc56e04ddc7ba5$var$sumCodecSizes(sizes) {
    return sizes.reduce((all, size)=>all === null || size === null ? null : all + size, 0);
}
function $f6bc56e04ddc7ba5$var$getFixedSize(codec) {
    return (0, $d541973339e39c73$export$f9d60229c95384d4)(codec) ? codec.fixedSize : null;
}
function $f6bc56e04ddc7ba5$var$getMaxSize(codec) {
    return (0, $d541973339e39c73$export$f9d60229c95384d4)(codec) ? codec.fixedSize : codec.maxSize ?? null;
}
// src/array.ts
function $f6bc56e04ddc7ba5$export$415199198053c0b(item, config = {}) {
    const size = config.size ?? (0, $850883b1d3fb5b0b$export$3e3136013a349951)();
    const fixedSize = $f6bc56e04ddc7ba5$var$computeArrayLikeCodecSize(size, $f6bc56e04ddc7ba5$var$getFixedSize(item));
    const maxSize = $f6bc56e04ddc7ba5$var$computeArrayLikeCodecSize(size, $f6bc56e04ddc7ba5$var$getMaxSize(item)) ?? void 0;
    return (0, $d541973339e39c73$export$4e76eeb6df88c889)({
        ...fixedSize !== null ? {
            fixedSize: fixedSize
        } : {
            getSizeFromValue: (array)=>{
                const prefixSize = typeof size === "object" ? (0, $d541973339e39c73$export$30f3257599397621)(array.length, size) : 0;
                return prefixSize + [
                    ...array
                ].reduce((all, value)=>all + (0, $d541973339e39c73$export$30f3257599397621)(value, item), 0);
            },
            maxSize: maxSize
        },
        write: (array, bytes, offset)=>{
            if (typeof size === "number") $f6bc56e04ddc7ba5$export$1e6cff54ac72b1a3("array", size, array.length);
            if (typeof size === "object") offset = size.write(array.length, bytes, offset);
            array.forEach((value)=>{
                offset = item.write(value, bytes, offset);
            });
            return offset;
        }
    });
}
function $f6bc56e04ddc7ba5$export$9016038b2e3b0c2f(item, config = {}) {
    const size = config.size ?? (0, $850883b1d3fb5b0b$export$ddc26825031b1ac9)();
    const itemSize = $f6bc56e04ddc7ba5$var$getFixedSize(item);
    const fixedSize = $f6bc56e04ddc7ba5$var$computeArrayLikeCodecSize(size, itemSize);
    const maxSize = $f6bc56e04ddc7ba5$var$computeArrayLikeCodecSize(size, $f6bc56e04ddc7ba5$var$getMaxSize(item)) ?? void 0;
    return (0, $d541973339e39c73$export$f8c898e83b60faaa)({
        ...fixedSize !== null ? {
            fixedSize: fixedSize
        } : {
            maxSize: maxSize
        },
        read: (bytes, offset)=>{
            const array = [];
            if (typeof size === "object" && bytes.slice(offset).length === 0) return [
                array,
                offset
            ];
            if (size === "remainder") {
                while(offset < bytes.length){
                    const [value, newOffset2] = item.read(bytes, offset);
                    offset = newOffset2;
                    array.push(value);
                }
                return [
                    array,
                    offset
                ];
            }
            const [resolvedSize, newOffset] = typeof size === "number" ? [
                size,
                offset
            ] : size.read(bytes, offset);
            offset = newOffset;
            for(let i = 0; i < resolvedSize; i += 1){
                const [value, newOffset2] = item.read(bytes, offset);
                offset = newOffset2;
                array.push(value);
            }
            return [
                array,
                offset
            ];
        }
    });
}
function $f6bc56e04ddc7ba5$export$8390591075c4b219(item, config = {}) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$415199198053c0b(item, config), $f6bc56e04ddc7ba5$export$9016038b2e3b0c2f(item, config));
}
function $f6bc56e04ddc7ba5$var$computeArrayLikeCodecSize(size, itemSize) {
    if (typeof size !== "number") return null;
    if (size === 0) return 0;
    return itemSize === null ? null : itemSize * size;
}
function $f6bc56e04ddc7ba5$export$f0392815667c42f2(size, config = {}) {
    const parsedConfig = typeof config === "boolean" ? {
        backward: config
    } : config;
    const backward = parsedConfig.backward ?? false;
    return (0, $d541973339e39c73$export$4e76eeb6df88c889)({
        fixedSize: size,
        write (value, bytes, offset) {
            const bytesToAdd = [];
            for(let i = 0; i < size; i += 1){
                let byte = 0;
                for(let j = 0; j < 8; j += 1){
                    const feature = Number(value[i * 8 + j] ?? 0);
                    byte |= feature << (backward ? j : 7 - j);
                }
                if (backward) bytesToAdd.unshift(byte);
                else bytesToAdd.push(byte);
            }
            bytes.set(bytesToAdd, offset);
            return size;
        }
    });
}
function $f6bc56e04ddc7ba5$export$5b3f10dd092d835b(size, config = {}) {
    const parsedConfig = typeof config === "boolean" ? {
        backward: config
    } : config;
    const backward = parsedConfig.backward ?? false;
    return (0, $d541973339e39c73$export$f8c898e83b60faaa)({
        fixedSize: size,
        read (bytes, offset) {
            (0, $d541973339e39c73$export$4a981e7c9ed0b6bf)("bitArray", size, bytes, offset);
            const booleans = [];
            let slice = bytes.slice(offset, offset + size);
            slice = backward ? slice.reverse() : slice;
            slice.forEach((byte)=>{
                for(let i = 0; i < 8; i += 1)if (backward) {
                    booleans.push(Boolean(byte & 1));
                    byte >>= 1;
                } else {
                    booleans.push(Boolean(byte & 128));
                    byte <<= 1;
                }
            });
            return [
                booleans,
                offset + size
            ];
        }
    });
}
function $f6bc56e04ddc7ba5$export$eb1097a7c4c3befd(size, config = {}) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$f0392815667c42f2(size, config), $f6bc56e04ddc7ba5$export$5b3f10dd092d835b(size, config));
}
function $f6bc56e04ddc7ba5$export$4a518d3f98f842eb(config = {}) {
    return (0, $d541973339e39c73$export$30169aca64409a56)(config.size ?? (0, $850883b1d3fb5b0b$export$dc9732115561fb4b)(), (value)=>value ? 1 : 0);
}
function $f6bc56e04ddc7ba5$export$43a73c742ad521e1(config = {}) {
    return (0, $d541973339e39c73$export$605b10ee38669daa)(config.size ?? (0, $850883b1d3fb5b0b$export$edadf68f5f1a8bc6)(), (value)=>Number(value) === 1);
}
function $f6bc56e04ddc7ba5$export$3071f075392d1897(config = {}) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$4a518d3f98f842eb(config), $f6bc56e04ddc7ba5$export$43a73c742ad521e1(config));
}
function $f6bc56e04ddc7ba5$export$636c51ad84d0674a() {
    return (0, $d541973339e39c73$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>value.length,
        write: (value, bytes, offset)=>{
            bytes.set(value, offset);
            return offset + value.length;
        }
    });
}
function $f6bc56e04ddc7ba5$export$b90e67818b1b3d45() {
    return (0, $d541973339e39c73$export$f8c898e83b60faaa)({
        read: (bytes, offset)=>{
            const slice = bytes.slice(offset);
            return [
                slice,
                offset + slice.length
            ];
        }
    });
}
function $f6bc56e04ddc7ba5$export$f3c2d67c19d09b74() {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$636c51ad84d0674a(), $f6bc56e04ddc7ba5$export$b90e67818b1b3d45());
}
var $f6bc56e04ddc7ba5$var$getBase16Decoder = ()=>(0, $d541973339e39c73$export$f8c898e83b60faaa)({
        read (bytes, offset) {
            const value = bytes.slice(offset).reduce((str, byte)=>str + byte.toString(16).padStart(2, "0"), "");
            return [
                value,
                bytes.length
            ];
        }
    });
function $f6bc56e04ddc7ba5$export$23a212060029ca97(constant) {
    return (0, $d541973339e39c73$export$4e76eeb6df88c889)({
        fixedSize: constant.length,
        write: (_, bytes, offset)=>{
            bytes.set(constant, offset);
            return offset + constant.length;
        }
    });
}
function $f6bc56e04ddc7ba5$export$13c771567a4019f7(constant) {
    return (0, $d541973339e39c73$export$f8c898e83b60faaa)({
        fixedSize: constant.length,
        read: (bytes, offset)=>{
            const base16 = $f6bc56e04ddc7ba5$var$getBase16Decoder();
            if (!(0, $d541973339e39c73$export$1b62aef2a79e6b21)(bytes, constant, offset)) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$cb77f5a0f0fa7f18), {
                constant: constant,
                data: bytes,
                hexConstant: base16.decode(constant),
                hexData: base16.decode(bytes),
                offset: offset
            });
            return [
                void 0,
                offset + constant.length
            ];
        }
    });
}
function $f6bc56e04ddc7ba5$export$ad029b7073097608(constant) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$23a212060029ca97(constant), $f6bc56e04ddc7ba5$export$13c771567a4019f7(constant));
}
function $f6bc56e04ddc7ba5$export$6b19a6a85541fd99(items) {
    const fixedSize = $f6bc56e04ddc7ba5$var$sumCodecSizes(items.map($f6bc56e04ddc7ba5$var$getFixedSize));
    const maxSize = $f6bc56e04ddc7ba5$var$sumCodecSizes(items.map($f6bc56e04ddc7ba5$var$getMaxSize)) ?? void 0;
    return (0, $d541973339e39c73$export$4e76eeb6df88c889)({
        ...fixedSize === null ? {
            getSizeFromValue: (value)=>items.map((item, index)=>(0, $d541973339e39c73$export$30f3257599397621)(value[index], item)).reduce((all, one)=>all + one, 0),
            maxSize: maxSize
        } : {
            fixedSize: fixedSize
        },
        write: (value, bytes, offset)=>{
            $f6bc56e04ddc7ba5$export$1e6cff54ac72b1a3("tuple", items.length, value.length);
            items.forEach((item, index)=>{
                offset = item.write(value[index], bytes, offset);
            });
            return offset;
        }
    });
}
function $f6bc56e04ddc7ba5$export$9800955a9fcaec5(items) {
    const fixedSize = $f6bc56e04ddc7ba5$var$sumCodecSizes(items.map($f6bc56e04ddc7ba5$var$getFixedSize));
    const maxSize = $f6bc56e04ddc7ba5$var$sumCodecSizes(items.map($f6bc56e04ddc7ba5$var$getMaxSize)) ?? void 0;
    return (0, $d541973339e39c73$export$f8c898e83b60faaa)({
        ...fixedSize === null ? {
            maxSize: maxSize
        } : {
            fixedSize: fixedSize
        },
        read: (bytes, offset)=>{
            const values = [];
            items.forEach((item)=>{
                const [newValue, newOffset] = item.read(bytes, offset);
                values.push(newValue);
                offset = newOffset;
            });
            return [
                values,
                offset
            ];
        }
    });
}
function $f6bc56e04ddc7ba5$export$dc2491d24b0f7b51(items) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$6b19a6a85541fd99(items), $f6bc56e04ddc7ba5$export$9800955a9fcaec5(items));
}
function $f6bc56e04ddc7ba5$export$a9351c88c0e29fc0(variants, getIndexFromValue) {
    const fixedSize = $f6bc56e04ddc7ba5$var$getUnionFixedSize(variants);
    const write = (variant, bytes, offset)=>{
        const index = getIndexFromValue(variant);
        $f6bc56e04ddc7ba5$var$assertValidVariantIndex(variants, index);
        return variants[index].write(variant, bytes, offset);
    };
    if (fixedSize !== null) return (0, $d541973339e39c73$export$4e76eeb6df88c889)({
        fixedSize: fixedSize,
        write: write
    });
    const maxSize = $f6bc56e04ddc7ba5$var$getUnionMaxSize(variants);
    return (0, $d541973339e39c73$export$4e76eeb6df88c889)({
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        getSizeFromValue: (variant)=>{
            const index = getIndexFromValue(variant);
            $f6bc56e04ddc7ba5$var$assertValidVariantIndex(variants, index);
            return (0, $d541973339e39c73$export$30f3257599397621)(variant, variants[index]);
        },
        write: write
    });
}
function $f6bc56e04ddc7ba5$export$ba967eb6bc7384b7(variants, getIndexFromBytes) {
    const fixedSize = $f6bc56e04ddc7ba5$var$getUnionFixedSize(variants);
    const read = (bytes, offset)=>{
        const index = getIndexFromBytes(bytes, offset);
        $f6bc56e04ddc7ba5$var$assertValidVariantIndex(variants, index);
        return variants[index].read(bytes, offset);
    };
    if (fixedSize !== null) return (0, $d541973339e39c73$export$f8c898e83b60faaa)({
        fixedSize: fixedSize,
        read: read
    });
    const maxSize = $f6bc56e04ddc7ba5$var$getUnionMaxSize(variants);
    return (0, $d541973339e39c73$export$f8c898e83b60faaa)({
        ...maxSize !== null ? {
            maxSize: maxSize
        } : {},
        read: read
    });
}
function $f6bc56e04ddc7ba5$export$8e8c799359f1b4d2(variants, getIndexFromValue, getIndexFromBytes) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$a9351c88c0e29fc0(variants, getIndexFromValue), $f6bc56e04ddc7ba5$export$ba967eb6bc7384b7(variants, getIndexFromBytes));
}
function $f6bc56e04ddc7ba5$var$assertValidVariantIndex(variants, index) {
    if (typeof variants[index] === "undefined") throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$efbd199de191d2aa), {
        maxRange: variants.length - 1,
        minRange: 0,
        variant: index
    });
}
function $f6bc56e04ddc7ba5$var$getUnionFixedSize(variants) {
    if (variants.length === 0) return 0;
    if (!(0, $d541973339e39c73$export$f9d60229c95384d4)(variants[0])) return null;
    const variantSize = variants[0].fixedSize;
    const sameSizedVariants = variants.every((variant)=>(0, $d541973339e39c73$export$f9d60229c95384d4)(variant) && variant.fixedSize === variantSize);
    return sameSizedVariants ? variantSize : null;
}
function $f6bc56e04ddc7ba5$var$getUnionMaxSize(variants) {
    return $f6bc56e04ddc7ba5$var$maxCodecSizes(variants.map((variant)=>$f6bc56e04ddc7ba5$var$getMaxSize(variant)));
}
// src/discriminated-union.ts
function $f6bc56e04ddc7ba5$export$927540af483f54a(variants, config = {}) {
    const discriminatorProperty = config.discriminator ?? "__kind";
    const prefix = config.size ?? (0, $850883b1d3fb5b0b$export$dc9732115561fb4b)();
    return $f6bc56e04ddc7ba5$export$a9351c88c0e29fc0(variants.map(([, variant], index)=>(0, $d541973339e39c73$export$30169aca64409a56)($f6bc56e04ddc7ba5$export$6b19a6a85541fd99([
            prefix,
            variant
        ]), (value)=>[
                index,
                value
            ])), (value)=>$f6bc56e04ddc7ba5$var$getVariantDiscriminator(variants, value[discriminatorProperty]));
}
function $f6bc56e04ddc7ba5$export$46f8fe299eb88c54(variants, config = {}) {
    const discriminatorProperty = config.discriminator ?? "__kind";
    const prefix = config.size ?? (0, $850883b1d3fb5b0b$export$edadf68f5f1a8bc6)();
    return $f6bc56e04ddc7ba5$export$ba967eb6bc7384b7(variants.map(([discriminator, variant])=>(0, $d541973339e39c73$export$605b10ee38669daa)($f6bc56e04ddc7ba5$export$9800955a9fcaec5([
            prefix,
            variant
        ]), ([, value])=>({
                [discriminatorProperty]: discriminator,
                ...value
            }))), (bytes, offset)=>Number(prefix.read(bytes, offset)[0]));
}
function $f6bc56e04ddc7ba5$export$54ce790fc77f87b2(variants, config = {}) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$927540af483f54a(variants, config), $f6bc56e04ddc7ba5$export$46f8fe299eb88c54(variants, config));
}
function $f6bc56e04ddc7ba5$var$getVariantDiscriminator(variants, discriminatorValue) {
    const discriminator = variants.findIndex(([key])=>discriminatorValue === key);
    if (discriminator < 0) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$2bb0703affb8fe68), {
        value: discriminatorValue,
        variants: variants.map(([key])=>key)
    });
    return discriminator;
}
var $f6bc56e04ddc7ba5$export$b7bab0bb6c91fbe9 = $f6bc56e04ddc7ba5$export$927540af483f54a;
var $f6bc56e04ddc7ba5$export$9cf3b180fc535fb1 = $f6bc56e04ddc7ba5$export$46f8fe299eb88c54;
var $f6bc56e04ddc7ba5$export$e076362323986828 = $f6bc56e04ddc7ba5$export$54ce790fc77f87b2;
// src/enum-helpers.ts
function $f6bc56e04ddc7ba5$var$getEnumStats(constructor) {
    const numericalValues = [
        ...new Set(Object.values(constructor).filter((v)=>typeof v === "number"))
    ].sort();
    const enumRecord = Object.fromEntries(Object.entries(constructor).slice(numericalValues.length));
    const enumKeys = Object.keys(enumRecord);
    const enumValues = Object.values(enumRecord);
    const stringValues = [
        .../* @__PURE__ */ new Set([
            ...enumKeys,
            ...enumValues.filter((v)=>typeof v === "string")
        ])
    ];
    return {
        enumKeys: enumKeys,
        enumRecord: enumRecord,
        enumValues: enumValues,
        numericalValues: numericalValues,
        stringValues: stringValues
    };
}
function $f6bc56e04ddc7ba5$var$getEnumIndexFromVariant({ enumKeys: enumKeys, enumValues: enumValues, variant: variant }) {
    const valueIndex = $f6bc56e04ddc7ba5$var$findLastIndex(enumValues, (value)=>value === variant);
    if (valueIndex >= 0) return valueIndex;
    return enumKeys.findIndex((key)=>key === variant);
}
function $f6bc56e04ddc7ba5$var$getEnumIndexFromDiscriminator({ discriminator: discriminator, enumKeys: enumKeys, enumValues: enumValues, useValuesAsDiscriminators: useValuesAsDiscriminators }) {
    if (!useValuesAsDiscriminators) return discriminator >= 0 && discriminator < enumKeys.length ? discriminator : -1;
    return $f6bc56e04ddc7ba5$var$findLastIndex(enumValues, (value)=>value === discriminator);
}
function $f6bc56e04ddc7ba5$var$findLastIndex(array, predicate) {
    let l = array.length;
    while(l--){
        if (predicate(array[l], l, array)) return l;
    }
    return -1;
}
function $f6bc56e04ddc7ba5$var$formatNumericalValues(values) {
    if (values.length === 0) return "";
    let range = [
        values[0],
        values[0]
    ];
    const ranges = [];
    for(let index = 1; index < values.length; index++){
        const value = values[index];
        if (range[1] + 1 === value) range[1] = value;
        else {
            ranges.push(range[0] === range[1] ? `${range[0]}` : `${range[0]}-${range[1]}`);
            range = [
                value,
                value
            ];
        }
    }
    ranges.push(range[0] === range[1] ? `${range[0]}` : `${range[0]}-${range[1]}`);
    return ranges.join(", ");
}
// src/enum.ts
function $f6bc56e04ddc7ba5$export$d531177bc561a76e(constructor, config = {}) {
    const prefix = config.size ?? (0, $850883b1d3fb5b0b$export$dc9732115561fb4b)();
    const useValuesAsDiscriminators = config.useValuesAsDiscriminators ?? false;
    const { enumKeys: enumKeys, enumValues: enumValues, numericalValues: numericalValues, stringValues: stringValues } = $f6bc56e04ddc7ba5$var$getEnumStats(constructor);
    if (useValuesAsDiscriminators && enumValues.some((value)=>typeof value === "string")) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$a2e9526594022372), {
        stringValues: enumValues.filter((v)=>typeof v === "string")
    });
    return (0, $d541973339e39c73$export$30169aca64409a56)(prefix, (variant)=>{
        const index = $f6bc56e04ddc7ba5$var$getEnumIndexFromVariant({
            enumKeys: enumKeys,
            enumValues: enumValues,
            variant: variant
        });
        if (index < 0) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$f6bf8a7c1f3defe4), {
            formattedNumericalValues: $f6bc56e04ddc7ba5$var$formatNumericalValues(numericalValues),
            numericalValues: numericalValues,
            stringValues: stringValues,
            variant: variant
        });
        return useValuesAsDiscriminators ? enumValues[index] : index;
    });
}
function $f6bc56e04ddc7ba5$export$9999963707d133fe(constructor, config = {}) {
    const prefix = config.size ?? (0, $850883b1d3fb5b0b$export$edadf68f5f1a8bc6)();
    const useValuesAsDiscriminators = config.useValuesAsDiscriminators ?? false;
    const { enumKeys: enumKeys, enumValues: enumValues, numericalValues: numericalValues } = $f6bc56e04ddc7ba5$var$getEnumStats(constructor);
    if (useValuesAsDiscriminators && enumValues.some((value)=>typeof value === "string")) throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$a2e9526594022372), {
        stringValues: enumValues.filter((v)=>typeof v === "string")
    });
    return (0, $d541973339e39c73$export$605b10ee38669daa)(prefix, (value)=>{
        const discriminator = Number(value);
        const index = $f6bc56e04ddc7ba5$var$getEnumIndexFromDiscriminator({
            discriminator: discriminator,
            enumKeys: enumKeys,
            enumValues: enumValues,
            useValuesAsDiscriminators: useValuesAsDiscriminators
        });
        if (index < 0) {
            const validDiscriminators = useValuesAsDiscriminators ? numericalValues : [
                ...Array(enumKeys.length).keys()
            ];
            throw new (0, $7ed03450837e6cf8$export$8349fd9adaaed269)((0, $7ed03450837e6cf8$export$1fa107ead8489cf2), {
                discriminator: discriminator,
                formattedValidDiscriminators: $f6bc56e04ddc7ba5$var$formatNumericalValues(validDiscriminators),
                validDiscriminators: validDiscriminators
            });
        }
        return enumValues[index];
    });
}
function $f6bc56e04ddc7ba5$export$32fbd6339c31df5a(constructor, config = {}) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$d531177bc561a76e(constructor, config), $f6bc56e04ddc7ba5$export$9999963707d133fe(constructor, config));
}
var $f6bc56e04ddc7ba5$export$b851c0039bae17a3 = $f6bc56e04ddc7ba5$export$d531177bc561a76e;
var $f6bc56e04ddc7ba5$export$8da56cb51c791874 = $f6bc56e04ddc7ba5$export$9999963707d133fe;
var $f6bc56e04ddc7ba5$export$5f12d67506fd387e = $f6bc56e04ddc7ba5$export$32fbd6339c31df5a;
function $f6bc56e04ddc7ba5$export$e68e10087ec64330(encoder, prefixedEncoders) {
    return (0, $d541973339e39c73$export$30169aca64409a56)($f6bc56e04ddc7ba5$export$6b19a6a85541fd99([
        ...prefixedEncoders,
        encoder
    ]), (value)=>[
            ...prefixedEncoders.map(()=>void 0),
            value
        ]);
}
function $f6bc56e04ddc7ba5$export$3e731190a51906e9(decoder, prefixedDecoders) {
    return (0, $d541973339e39c73$export$605b10ee38669daa)($f6bc56e04ddc7ba5$export$9800955a9fcaec5([
        ...prefixedDecoders,
        decoder
    ]), (tuple)=>tuple[tuple.length - 1]);
}
function $f6bc56e04ddc7ba5$export$e34ca45edea62fa(codec, prefixedCodecs) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$e68e10087ec64330(codec, prefixedCodecs), $f6bc56e04ddc7ba5$export$3e731190a51906e9(codec, prefixedCodecs));
}
function $f6bc56e04ddc7ba5$export$48adc3d128b1e47b(encoder, suffixedEncoders) {
    return (0, $d541973339e39c73$export$30169aca64409a56)($f6bc56e04ddc7ba5$export$6b19a6a85541fd99([
        encoder,
        ...suffixedEncoders
    ]), (value)=>[
            value,
            ...suffixedEncoders.map(()=>void 0)
        ]);
}
function $f6bc56e04ddc7ba5$export$27bbee57fb582997(decoder, suffixedDecoders) {
    return (0, $d541973339e39c73$export$605b10ee38669daa)($f6bc56e04ddc7ba5$export$9800955a9fcaec5([
        decoder,
        ...suffixedDecoders
    ]), (tuple)=>tuple[0]);
}
function $f6bc56e04ddc7ba5$export$997dd3a140dcd82a(codec, suffixedCodecs) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$48adc3d128b1e47b(codec, suffixedCodecs), $f6bc56e04ddc7ba5$export$27bbee57fb582997(codec, suffixedCodecs));
}
function $f6bc56e04ddc7ba5$export$75c3a7c49a778905(key, value, config = {}) {
    return (0, $d541973339e39c73$export$30169aca64409a56)($f6bc56e04ddc7ba5$export$415199198053c0b($f6bc56e04ddc7ba5$export$6b19a6a85541fd99([
        key,
        value
    ]), config), (map)=>[
            ...map.entries()
        ]);
}
function $f6bc56e04ddc7ba5$export$e102943539f62962(key, value, config = {}) {
    return (0, $d541973339e39c73$export$605b10ee38669daa)($f6bc56e04ddc7ba5$export$9016038b2e3b0c2f($f6bc56e04ddc7ba5$export$9800955a9fcaec5([
        key,
        value
    ]), config), (entries)=>new Map(entries));
}
function $f6bc56e04ddc7ba5$export$191db844d92ad593(key, value, config = {}) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$75c3a7c49a778905(key, value, config), $f6bc56e04ddc7ba5$export$e102943539f62962(key, value, config));
}
function $f6bc56e04ddc7ba5$export$a222f4a6d9205421() {
    return (0, $d541973339e39c73$export$4e76eeb6df88c889)({
        fixedSize: 0,
        write: (_value, _bytes, offset)=>offset
    });
}
function $f6bc56e04ddc7ba5$export$46a76d99d5c61218() {
    return (0, $d541973339e39c73$export$f8c898e83b60faaa)({
        fixedSize: 0,
        read: (_bytes, offset)=>[
                void 0,
                offset
            ]
    });
}
function $f6bc56e04ddc7ba5$export$68459b38e676038a() {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$a222f4a6d9205421(), $f6bc56e04ddc7ba5$export$46a76d99d5c61218());
}
// src/nullable.ts
function $f6bc56e04ddc7ba5$export$b0dc66f9f6de624b(item, config = {}) {
    const prefix = (()=>{
        if (config.prefix === null) return (0, $d541973339e39c73$export$30169aca64409a56)($f6bc56e04ddc7ba5$export$a222f4a6d9205421(), (_boolean)=>void 0);
        return $f6bc56e04ddc7ba5$export$4a518d3f98f842eb({
            size: config.prefix ?? (0, $850883b1d3fb5b0b$export$dc9732115561fb4b)()
        });
    })();
    const noneValue = (()=>{
        if (config.noneValue === "zeroes") {
            (0, $d541973339e39c73$export$4e85b7423fd6bc55)(item);
            return (0, $d541973339e39c73$export$cbdfce031443a1)($f6bc56e04ddc7ba5$export$a222f4a6d9205421(), item.fixedSize);
        }
        if (!config.noneValue) return $f6bc56e04ddc7ba5$export$a222f4a6d9205421();
        return $f6bc56e04ddc7ba5$export$23a212060029ca97(config.noneValue);
    })();
    return $f6bc56e04ddc7ba5$export$a9351c88c0e29fc0([
        (0, $d541973339e39c73$export$30169aca64409a56)($f6bc56e04ddc7ba5$export$6b19a6a85541fd99([
            prefix,
            noneValue
        ]), (_value)=>[
                false,
                void 0
            ]),
        (0, $d541973339e39c73$export$30169aca64409a56)($f6bc56e04ddc7ba5$export$6b19a6a85541fd99([
            prefix,
            item
        ]), (value)=>[
                true,
                value
            ])
    ], (variant)=>Number(variant !== null));
}
function $f6bc56e04ddc7ba5$export$320bb1c6ae316289(item, config = {}) {
    const prefix = (()=>{
        if (config.prefix === null) return (0, $d541973339e39c73$export$605b10ee38669daa)($f6bc56e04ddc7ba5$export$46a76d99d5c61218(), ()=>false);
        return $f6bc56e04ddc7ba5$export$43a73c742ad521e1({
            size: config.prefix ?? (0, $850883b1d3fb5b0b$export$edadf68f5f1a8bc6)()
        });
    })();
    const noneValue = (()=>{
        if (config.noneValue === "zeroes") {
            (0, $d541973339e39c73$export$4e85b7423fd6bc55)(item);
            return (0, $d541973339e39c73$export$1f85f8b8d2788007)($f6bc56e04ddc7ba5$export$46a76d99d5c61218(), item.fixedSize);
        }
        if (!config.noneValue) return $f6bc56e04ddc7ba5$export$46a76d99d5c61218();
        return $f6bc56e04ddc7ba5$export$13c771567a4019f7(config.noneValue);
    })();
    return $f6bc56e04ddc7ba5$export$ba967eb6bc7384b7([
        (0, $d541973339e39c73$export$605b10ee38669daa)($f6bc56e04ddc7ba5$export$9800955a9fcaec5([
            prefix,
            noneValue
        ]), ()=>null),
        (0, $d541973339e39c73$export$605b10ee38669daa)($f6bc56e04ddc7ba5$export$9800955a9fcaec5([
            prefix,
            item
        ]), ([, value])=>value)
    ], (bytes, offset)=>{
        if (config.prefix === null && !config.noneValue) return Number(offset < bytes.length);
        if (config.prefix === null && config.noneValue != null) {
            const zeroValue = config.noneValue === "zeroes" ? new Uint8Array(noneValue.fixedSize).fill(0) : config.noneValue;
            return (0, $d541973339e39c73$export$1b62aef2a79e6b21)(bytes, zeroValue, offset) ? 0 : 1;
        }
        return Number(prefix.read(bytes, offset)[0]);
    });
}
function $f6bc56e04ddc7ba5$export$ac13939aa9a57a06(item, config = {}) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$b0dc66f9f6de624b(item, config), $f6bc56e04ddc7ba5$export$320bb1c6ae316289(item, config));
}
function $f6bc56e04ddc7ba5$export$b5f13ff6baa9ba6c(item, config = {}) {
    return (0, $d541973339e39c73$export$30169aca64409a56)($f6bc56e04ddc7ba5$export$415199198053c0b(item, config), (set)=>[
            ...set
        ]);
}
function $f6bc56e04ddc7ba5$export$b5164526d93d52f2(item, config = {}) {
    return (0, $d541973339e39c73$export$605b10ee38669daa)($f6bc56e04ddc7ba5$export$9016038b2e3b0c2f(item, config), (entries)=>new Set(entries));
}
function $f6bc56e04ddc7ba5$export$a7c6e50519818c5d(item, config = {}) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$b5f13ff6baa9ba6c(item, config), $f6bc56e04ddc7ba5$export$b5164526d93d52f2(item, config));
}
function $f6bc56e04ddc7ba5$export$64024546a32014b8(fields) {
    const fieldCodecs = fields.map(([, codec])=>codec);
    const fixedSize = $f6bc56e04ddc7ba5$var$sumCodecSizes(fieldCodecs.map($f6bc56e04ddc7ba5$var$getFixedSize));
    const maxSize = $f6bc56e04ddc7ba5$var$sumCodecSizes(fieldCodecs.map($f6bc56e04ddc7ba5$var$getMaxSize)) ?? void 0;
    return (0, $d541973339e39c73$export$4e76eeb6df88c889)({
        ...fixedSize === null ? {
            getSizeFromValue: (value)=>fields.map(([key, codec])=>(0, $d541973339e39c73$export$30f3257599397621)(value[key], codec)).reduce((all, one)=>all + one, 0),
            maxSize: maxSize
        } : {
            fixedSize: fixedSize
        },
        write: (struct, bytes, offset)=>{
            fields.forEach(([key, codec])=>{
                offset = codec.write(struct[key], bytes, offset);
            });
            return offset;
        }
    });
}
function $f6bc56e04ddc7ba5$export$7070fbe048971470(fields) {
    const fieldCodecs = fields.map(([, codec])=>codec);
    const fixedSize = $f6bc56e04ddc7ba5$var$sumCodecSizes(fieldCodecs.map($f6bc56e04ddc7ba5$var$getFixedSize));
    const maxSize = $f6bc56e04ddc7ba5$var$sumCodecSizes(fieldCodecs.map($f6bc56e04ddc7ba5$var$getMaxSize)) ?? void 0;
    return (0, $d541973339e39c73$export$f8c898e83b60faaa)({
        ...fixedSize === null ? {
            maxSize: maxSize
        } : {
            fixedSize: fixedSize
        },
        read: (bytes, offset)=>{
            const struct = {};
            fields.forEach(([key, codec])=>{
                const [value, newOffset] = codec.read(bytes, offset);
                offset = newOffset;
                struct[key] = value;
            });
            return [
                struct,
                offset
            ];
        }
    });
}
function $f6bc56e04ddc7ba5$export$e7bbe4696420bde8(fields) {
    return (0, $d541973339e39c73$export$b88681b853abde79)($f6bc56e04ddc7ba5$export$64024546a32014b8(fields), $f6bc56e04ddc7ba5$export$7070fbe048971470(fields));
}
 //# sourceMappingURL=index.browser.mjs.map


const $9530d6cfb57d1c23$var$tokenGroupMemberCodec = (0, $f6bc56e04ddc7ba5$export$e7bbe4696420bde8)([
    [
        "mint",
        (0, $d541973339e39c73$export$ff7dc697d5cc308f)((0, $f6bc56e04ddc7ba5$export$f3c2d67c19d09b74)(), 32)
    ],
    [
        "group",
        (0, $d541973339e39c73$export$ff7dc697d5cc308f)((0, $f6bc56e04ddc7ba5$export$f3c2d67c19d09b74)(), 32)
    ],
    [
        "memberNumber",
        (0, $850883b1d3fb5b0b$export$7e56ec13f6029ccc)()
    ]
]);
const $9530d6cfb57d1c23$export$922ab442b9cf73bd = $9530d6cfb57d1c23$var$tokenGroupMemberCodec.fixedSize;
function $9530d6cfb57d1c23$export$57f8603c3835e979(member) {
    return $9530d6cfb57d1c23$var$tokenGroupMemberCodec.encode({
        mint: member.mint.toBuffer(),
        group: member.group.toBuffer(),
        memberNumber: member.memberNumber
    });
}
function $9530d6cfb57d1c23$export$1724e5edf41d9e41(buffer) {
    const data = $9530d6cfb57d1c23$var$tokenGroupMemberCodec.decode(buffer);
    return {
        mint: new (0, $1ZJZa.PublicKey)(data.mint),
        group: new (0, $1ZJZa.PublicKey)(data.group),
        memberNumber: data.memberNumber
    };
}


var $1ZJZa = parcelRequire("1ZJZa");

const $0f418e2520602fd6$var$tokenGroupCodec = (0, $f6bc56e04ddc7ba5$export$e7bbe4696420bde8)([
    [
        "updateAuthority",
        (0, $d541973339e39c73$export$ff7dc697d5cc308f)((0, $f6bc56e04ddc7ba5$export$f3c2d67c19d09b74)(), 32)
    ],
    [
        "mint",
        (0, $d541973339e39c73$export$ff7dc697d5cc308f)((0, $f6bc56e04ddc7ba5$export$f3c2d67c19d09b74)(), 32)
    ],
    [
        "size",
        (0, $850883b1d3fb5b0b$export$7e56ec13f6029ccc)()
    ],
    [
        "maxSize",
        (0, $850883b1d3fb5b0b$export$7e56ec13f6029ccc)()
    ]
]);
const $0f418e2520602fd6$export$83b408df29875efc = $0f418e2520602fd6$var$tokenGroupCodec.fixedSize;
// Checks if all elements in the array are 0
function $0f418e2520602fd6$var$isNonePubkey(buffer) {
    for(let i = 0; i < buffer.length; i++){
        if (buffer[i] !== 0) return false;
    }
    return true;
}
function $0f418e2520602fd6$export$861b848ad534e6d5(group) {
    // If no updateAuthority given, set it to the None/Zero PublicKey for encoding
    const updateAuthority = group.updateAuthority ?? (0, $1ZJZa.PublicKey).default;
    return $0f418e2520602fd6$var$tokenGroupCodec.encode({
        updateAuthority: updateAuthority.toBuffer(),
        mint: group.mint.toBuffer(),
        size: group.size,
        maxSize: group.maxSize
    });
}
function $0f418e2520602fd6$export$28d9c2954cb7f24e(buffer) {
    const data = $0f418e2520602fd6$var$tokenGroupCodec.decode(buffer);
    return $0f418e2520602fd6$var$isNonePubkey(data.updateAuthority) ? {
        mint: new (0, $1ZJZa.PublicKey)(data.mint),
        size: data.size,
        maxSize: data.maxSize
    } : {
        updateAuthority: new (0, $1ZJZa.PublicKey)(data.updateAuthority),
        mint: new (0, $1ZJZa.PublicKey)(data.mint),
        size: data.size,
        maxSize: data.maxSize
    };
}



var $Bz0HP = parcelRequire("Bz0HP");


var $1ZJZa = parcelRequire("1ZJZa");

const $3ade4c85f0da52ae$export$b9dda2426c86a44d = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("authority"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("memberAddress")
]);
const $3ade4c85f0da52ae$export$f4d582c48d8cc7e7 = $3ade4c85f0da52ae$export$b9dda2426c86a44d.span;
function $3ade4c85f0da52ae$export$5562dfc68f7b75f4(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).GroupMemberPointer, mint.tlvData);
    if (extensionData !== null) {
        const { authority: authority, memberAddress: memberAddress } = $3ade4c85f0da52ae$export$b9dda2426c86a44d.decode(extensionData);
        // Explicitly set None/Zero keys to null
        return {
            authority: authority.equals((0, $1ZJZa.PublicKey).default) ? null : authority,
            memberAddress: memberAddress.equals((0, $1ZJZa.PublicKey).default) ? null : memberAddress
        };
    } else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");


var $1ZJZa = parcelRequire("1ZJZa");

const $fdcb460d2833cb5d$export$511631140e2874fe = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("authority"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("groupAddress")
]);
const $fdcb460d2833cb5d$export$3852a2b4ecb1c96c = $fdcb460d2833cb5d$export$511631140e2874fe.span;
function $fdcb460d2833cb5d$export$9dc2a030696ac8a7(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).GroupPointer, mint.tlvData);
    if (extensionData !== null) {
        const { authority: authority, groupAddress: groupAddress } = $fdcb460d2833cb5d$export$511631140e2874fe.decode(extensionData);
        // Explicitly set None/Zero keys to null
        return {
            authority: authority.equals((0, $1ZJZa.PublicKey).default) ? null : authority,
            groupAddress: groupAddress.equals((0, $1ZJZa.PublicKey).default) ? null : groupAddress
        };
    } else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");

const $80dd37dda6db6940$export$3b7e34eff13c869c = (0, $Bz0HP.struct)([]);
const $80dd37dda6db6940$export$4ba1dedcafaef535 = $80dd37dda6db6940$export$3b7e34eff13c869c.span;
function $80dd37dda6db6940$export$ff9fc6dae6f7d7a0(account) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).ImmutableOwner, account.tlvData);
    if (extensionData !== null) return $80dd37dda6db6940$export$3b7e34eff13c869c.decode(extensionData);
    else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");


const $653810106d8aa4cf$export$dea2930f2b4b5995 = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("rateAuthority"),
    (0, $Bz0HP.ns64)("initializationTimestamp"),
    (0, $Bz0HP.s16)("preUpdateAverageRate"),
    (0, $Bz0HP.ns64)("lastUpdateTimestamp"),
    (0, $Bz0HP.s16)("currentRate")
]);
const $653810106d8aa4cf$export$5deaa22b862a446f = $653810106d8aa4cf$export$dea2930f2b4b5995.span;
function $653810106d8aa4cf$export$c0f4cb585bb22702(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).InterestBearingConfig, mint.tlvData);
    if (extensionData !== null) return $653810106d8aa4cf$export$dea2930f2b4b5995.decode(extensionData);
    return null;
}



var $Bz0HP = parcelRequire("Bz0HP");


const $9be2de765674365b$export$5607c4289fc50398 = (0, $Bz0HP.struct)([
    (0, $ca773c1ee6b15d17$export$87b259aa03e3d267)("requireIncomingTransferMemos")
]);
const $9be2de765674365b$export$f4b5375ad34477a1 = $9be2de765674365b$export$5607c4289fc50398.span;
function $9be2de765674365b$export$3f4bed2e631f122c(account) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).MemoTransfer, account.tlvData);
    if (extensionData !== null) return $9be2de765674365b$export$5607c4289fc50398.decode(extensionData);
    else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");


var $1ZJZa = parcelRequire("1ZJZa");

const $261106fb77ad78f4$export$4dfd642335bea3f4 = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("authority"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("metadataAddress")
]);
const $261106fb77ad78f4$export$46bfcd668f9095d0 = $261106fb77ad78f4$export$4dfd642335bea3f4.span;
function $261106fb77ad78f4$export$eef22d421b9622d(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).MetadataPointer, mint.tlvData);
    if (extensionData !== null) {
        const { authority: authority, metadataAddress: metadataAddress } = $261106fb77ad78f4$export$4dfd642335bea3f4.decode(extensionData);
        // Explicitly set None/Zero keys to null
        return {
            authority: authority.equals((0, $1ZJZa.PublicKey).default) ? null : authority,
            metadataAddress: metadataAddress.equals((0, $1ZJZa.PublicKey).default) ? null : metadataAddress
        };
    } else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");


const $85f5f02c1cd432a2$export$ece081d471f0fc95 = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("closeAuthority")
]);
const $85f5f02c1cd432a2$export$1e1aa83bde32eb68 = $85f5f02c1cd432a2$export$ece081d471f0fc95.span;
function $85f5f02c1cd432a2$export$bfd41dfeb5917197(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).MintCloseAuthority, mint.tlvData);
    if (extensionData !== null) return $85f5f02c1cd432a2$export$ece081d471f0fc95.decode(extensionData);
    else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");

const $d68f9e984158304d$export$bae9d70f4fd33725 = (0, $Bz0HP.struct)([]);
const $d68f9e984158304d$export$31a113d46d052efb = $d68f9e984158304d$export$bae9d70f4fd33725.span;
const $d68f9e984158304d$export$91a6e2e8798d2502 = $d68f9e984158304d$export$bae9d70f4fd33725.span;
function $d68f9e984158304d$export$718a9bb289be2420(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).NonTransferable, mint.tlvData);
    if (extensionData !== null) return $d68f9e984158304d$export$bae9d70f4fd33725.decode(extensionData);
    else return null;
}
function $d68f9e984158304d$export$a8f1f408ee730236(account) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).NonTransferableAccount, account.tlvData);
    if (extensionData !== null) return $d68f9e984158304d$export$bae9d70f4fd33725.decode(extensionData);
    else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");


const $1c60a6729a69425c$export$475f6622ee1552dd = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("authority"),
    (0, $ca773c1ee6b15d17$export$87b259aa03e3d267)("paused")
]);
const $1c60a6729a69425c$export$5b36c6a8fe7f3f5b = $1c60a6729a69425c$export$475f6622ee1552dd.span;
function $1c60a6729a69425c$export$d917adb6fd5f389a(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).PausableConfig, mint.tlvData);
    if (extensionData !== null) return $1c60a6729a69425c$export$475f6622ee1552dd.decode(extensionData);
    else return null;
}
const $1c60a6729a69425c$export$96f26b72addfb57 = (0, $Bz0HP.struct)([]); // esline-disable-line
const $1c60a6729a69425c$export$5a90dde3236e8b55 = $1c60a6729a69425c$export$96f26b72addfb57.span;
function $1c60a6729a69425c$export$a2f93a7e8c3a47ae(account) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).PausableAccount, account.tlvData);
    if (extensionData !== null) return $1c60a6729a69425c$export$96f26b72addfb57.decode(extensionData);
    else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");


const $4599116dcdb57545$export$1d6e8e6f44705001 = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("delegate")
]);
const $4599116dcdb57545$export$636ea2373b6c6b7d = $4599116dcdb57545$export$1d6e8e6f44705001.span;
function $4599116dcdb57545$export$3d161872832356b0(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).PermanentDelegate, mint.tlvData);
    if (extensionData !== null) return $4599116dcdb57545$export$1d6e8e6f44705001.decode(extensionData);
    else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");


const $02a6fe244bf4c8a2$export$d5785298d6309389 = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("authority"),
    (0, $Bz0HP.f64)("multiplier"),
    (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("newMultiplierEffectiveTimestamp"),
    (0, $Bz0HP.f64)("newMultiplier")
]);
const $02a6fe244bf4c8a2$export$88eb1c31690c2d3b = $02a6fe244bf4c8a2$export$d5785298d6309389.span;
function $02a6fe244bf4c8a2$export$79f53e68df557d03(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).ScaledUiAmountConfig, mint.tlvData);
    if (extensionData !== null) return $02a6fe244bf4c8a2$export$d5785298d6309389.decode(extensionData);
    return null;
}



var $Bz0HP = parcelRequire("Bz0HP");


const $92eecbd6f95aadca$export$7bf230db5a769018 = 10000;
const $92eecbd6f95aadca$export$8a34ad2d496101b6 = BigInt($92eecbd6f95aadca$export$7bf230db5a769018);
function $92eecbd6f95aadca$export$35e5691ab3997dac(property) {
    return (0, $Bz0HP.struct)([
        (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("epoch"),
        (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("maximumFee"),
        (0, $Bz0HP.u16)("transferFeeBasisPoints")
    ], property);
}
function $92eecbd6f95aadca$export$8c3f5e003a1e38c7(transferFee, preFeeAmount) {
    const transferFeeBasisPoints = transferFee.transferFeeBasisPoints;
    if (transferFeeBasisPoints === 0 || preFeeAmount === BigInt(0)) return BigInt(0);
    else {
        const numerator = preFeeAmount * BigInt(transferFeeBasisPoints);
        const rawFee = (numerator + $92eecbd6f95aadca$export$8a34ad2d496101b6 - BigInt(1)) / $92eecbd6f95aadca$export$8a34ad2d496101b6;
        const fee = rawFee > transferFee.maximumFee ? transferFee.maximumFee : rawFee;
        return BigInt(fee);
    }
}
const $92eecbd6f95aadca$export$c849e8e6e4ae7e4b = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("transferFeeConfigAuthority"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("withdrawWithheldAuthority"),
    (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("withheldAmount"),
    $92eecbd6f95aadca$export$35e5691ab3997dac("olderTransferFee"),
    $92eecbd6f95aadca$export$35e5691ab3997dac("newerTransferFee")
]);
const $92eecbd6f95aadca$export$972cf5dcc13158da = $92eecbd6f95aadca$export$c849e8e6e4ae7e4b.span;
function $92eecbd6f95aadca$export$2e57a339fb6e8894(transferFeeConfig, epoch) {
    if (epoch >= transferFeeConfig.newerTransferFee.epoch) return transferFeeConfig.newerTransferFee;
    else return transferFeeConfig.olderTransferFee;
}
function $92eecbd6f95aadca$export$c8f0c7e4622306bc(transferFeeConfig, epoch, preFeeAmount) {
    const transferFee = $92eecbd6f95aadca$export$2e57a339fb6e8894(transferFeeConfig, epoch);
    return $92eecbd6f95aadca$export$8c3f5e003a1e38c7(transferFee, preFeeAmount);
}
const $92eecbd6f95aadca$export$a20fb363192b96a2 = (0, $Bz0HP.struct)([
    (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("withheldAmount")
]);
const $92eecbd6f95aadca$export$8657a852ae4f4019 = $92eecbd6f95aadca$export$a20fb363192b96a2.span;
function $92eecbd6f95aadca$export$451dabe4cdde5d9a(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).TransferFeeConfig, mint.tlvData);
    if (extensionData !== null) return $92eecbd6f95aadca$export$c849e8e6e4ae7e4b.decode(extensionData);
    else return null;
}
function $92eecbd6f95aadca$export$857f13d8ce75ecd9(account) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).TransferFeeAmount, account.tlvData);
    if (extensionData !== null) return $92eecbd6f95aadca$export$a20fb363192b96a2.decode(extensionData);
    else return null;
}



var $Bz0HP = parcelRequire("Bz0HP");


var $1ZJZa = parcelRequire("1ZJZa");




var $7e0e5f3206139b12$require$Buffer = $bf0bcea1d7d4510a$export$a143d493d941bafc;
const $7e0e5f3206139b12$var$DISCRIMINATOR_SPAN = 1;
const $7e0e5f3206139b12$var$LITERAL_LENGTH_SPAN = 1;
const $7e0e5f3206139b12$var$INSTRUCTION_ARG_OFFSET_SPAN = 1;
const $7e0e5f3206139b12$var$INSTRUCTION_ARG_LENGTH_SPAN = 1;
const $7e0e5f3206139b12$var$ACCOUNT_KEY_INDEX_SPAN = 1;
const $7e0e5f3206139b12$var$ACCOUNT_DATA_ACCOUNT_INDEX_SPAN = 1;
const $7e0e5f3206139b12$var$ACCOUNT_DATA_OFFSET_SPAN = 1;
const $7e0e5f3206139b12$var$ACCOUNT_DATA_LENGTH_SPAN = 1;
function $7e0e5f3206139b12$var$unpackSeedLiteral(seeds) {
    if (seeds.length < 1) throw new (0, $69531333edd951b2$export$9fe40fd85b8108b)();
    const [length, ...rest] = seeds;
    if (rest.length < length) throw new (0, $69531333edd951b2$export$9fe40fd85b8108b)();
    return {
        data: $7e0e5f3206139b12$require$Buffer.from(rest.slice(0, length)),
        packedLength: $7e0e5f3206139b12$var$DISCRIMINATOR_SPAN + $7e0e5f3206139b12$var$LITERAL_LENGTH_SPAN + length
    };
}
function $7e0e5f3206139b12$var$unpackSeedInstructionArg(seeds, instructionData) {
    if (seeds.length < 2) throw new (0, $69531333edd951b2$export$9fe40fd85b8108b)();
    const [index, length] = seeds;
    if (instructionData.length < length + index) throw new (0, $69531333edd951b2$export$9fe40fd85b8108b)();
    return {
        data: instructionData.subarray(index, index + length),
        packedLength: $7e0e5f3206139b12$var$DISCRIMINATOR_SPAN + $7e0e5f3206139b12$var$INSTRUCTION_ARG_OFFSET_SPAN + $7e0e5f3206139b12$var$INSTRUCTION_ARG_LENGTH_SPAN
    };
}
function $7e0e5f3206139b12$var$unpackSeedAccountKey(seeds, previousMetas) {
    if (seeds.length < 1) throw new (0, $69531333edd951b2$export$9fe40fd85b8108b)();
    const [index] = seeds;
    if (previousMetas.length <= index) throw new (0, $69531333edd951b2$export$9fe40fd85b8108b)();
    return {
        data: previousMetas[index].pubkey.toBuffer(),
        packedLength: $7e0e5f3206139b12$var$DISCRIMINATOR_SPAN + $7e0e5f3206139b12$var$ACCOUNT_KEY_INDEX_SPAN
    };
}
async function $7e0e5f3206139b12$var$unpackSeedAccountData(seeds, previousMetas, connection) {
    if (seeds.length < 3) throw new (0, $69531333edd951b2$export$9fe40fd85b8108b)();
    const [accountIndex, dataIndex, length] = seeds;
    if (previousMetas.length <= accountIndex) throw new (0, $69531333edd951b2$export$9fe40fd85b8108b)();
    const accountInfo = await connection.getAccountInfo(previousMetas[accountIndex].pubkey);
    if (accountInfo == null) throw new (0, $69531333edd951b2$export$de66998ed6d15b14)();
    if (accountInfo.data.length < dataIndex + length) throw new (0, $69531333edd951b2$export$9fe40fd85b8108b)();
    return {
        data: accountInfo.data.subarray(dataIndex, dataIndex + length),
        packedLength: $7e0e5f3206139b12$var$DISCRIMINATOR_SPAN + $7e0e5f3206139b12$var$ACCOUNT_DATA_ACCOUNT_INDEX_SPAN + $7e0e5f3206139b12$var$ACCOUNT_DATA_OFFSET_SPAN + $7e0e5f3206139b12$var$ACCOUNT_DATA_LENGTH_SPAN
    };
}
async function $7e0e5f3206139b12$var$unpackFirstSeed(seeds, previousMetas, instructionData, connection) {
    const [discriminator, ...rest] = seeds;
    const remaining = new Uint8Array(rest);
    switch(discriminator){
        case 0:
            return null;
        case 1:
            return $7e0e5f3206139b12$var$unpackSeedLiteral(remaining);
        case 2:
            return $7e0e5f3206139b12$var$unpackSeedInstructionArg(remaining, instructionData);
        case 3:
            return $7e0e5f3206139b12$var$unpackSeedAccountKey(remaining, previousMetas);
        case 4:
            return $7e0e5f3206139b12$var$unpackSeedAccountData(remaining, previousMetas, connection);
        default:
            throw new (0, $69531333edd951b2$export$9fe40fd85b8108b)();
    }
}
async function $7e0e5f3206139b12$export$e3c2327a8649c7d4(seeds, previousMetas, instructionData, connection) {
    const unpackedSeeds = [];
    let i = 0;
    while(i < 32){
        const seed = await $7e0e5f3206139b12$var$unpackFirstSeed(seeds.slice(i), previousMetas, instructionData, connection);
        if (seed == null) break;
        unpackedSeeds.push(seed.data);
        i += seed.packedLength;
    }
    return unpackedSeeds;
}



var $1ZJZa = parcelRequire("1ZJZa");

async function $a2134a7c62b8081b$export$76e46d2bd9d499e8(keyDataConfig, previousMetas, instructionData, connection) {
    const [discriminator, ...rest] = keyDataConfig;
    const remaining = new Uint8Array(rest);
    switch(discriminator){
        case 1:
            return $a2134a7c62b8081b$var$unpackPubkeyDataFromInstructionData(remaining, instructionData);
        case 2:
            return $a2134a7c62b8081b$var$unpackPubkeyDataFromAccountData(remaining, previousMetas, connection);
        default:
            throw new (0, $69531333edd951b2$export$738537c82cc9bdda)();
    }
}
function $a2134a7c62b8081b$var$unpackPubkeyDataFromInstructionData(remaining, instructionData) {
    if (remaining.length < 1) throw new (0, $69531333edd951b2$export$738537c82cc9bdda)();
    const dataIndex = remaining[0];
    if (instructionData.length < dataIndex + (0, $1ZJZa.PUBLIC_KEY_LENGTH)) throw new (0, $69531333edd951b2$export$ded5cb4f781ab8d1)();
    return new (0, $1ZJZa.PublicKey)(instructionData.subarray(dataIndex, dataIndex + (0, $1ZJZa.PUBLIC_KEY_LENGTH)));
}
async function $a2134a7c62b8081b$var$unpackPubkeyDataFromAccountData(remaining, previousMetas, connection) {
    if (remaining.length < 2) throw new (0, $69531333edd951b2$export$738537c82cc9bdda)();
    const [accountIndex, dataIndex] = remaining;
    if (previousMetas.length <= accountIndex) throw new (0, $69531333edd951b2$export$de66998ed6d15b14)();
    const accountInfo = await connection.getAccountInfo(previousMetas[accountIndex].pubkey);
    if (accountInfo == null) throw new (0, $69531333edd951b2$export$f515f489e4a79004)();
    if (accountInfo.data.length < dataIndex + (0, $1ZJZa.PUBLIC_KEY_LENGTH)) throw new (0, $69531333edd951b2$export$ded5cb4f781ab8d1)();
    return new (0, $1ZJZa.PublicKey)(accountInfo.data.subarray(dataIndex, dataIndex + (0, $1ZJZa.PUBLIC_KEY_LENGTH)));
}



var $cad7122580a17f06$require$Buffer = $bf0bcea1d7d4510a$export$a143d493d941bafc;
const $cad7122580a17f06$export$ce2e6042aff3c26e = (0, $Bz0HP.struct)([
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("authority"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("programId")
]);
const $cad7122580a17f06$export$5ade3cdfd72ee348 = $cad7122580a17f06$export$ce2e6042aff3c26e.span;
function $cad7122580a17f06$export$eb429b5bab502847(mint) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).TransferHook, mint.tlvData);
    if (extensionData !== null) return $cad7122580a17f06$export$ce2e6042aff3c26e.decode(extensionData);
    else return null;
}
const $cad7122580a17f06$export$28d4d57b6bd1f0ec = (0, $Bz0HP.struct)([
    (0, $ca773c1ee6b15d17$export$87b259aa03e3d267)("transferring")
]);
const $cad7122580a17f06$export$998fd74b23e70abd = $cad7122580a17f06$export$28d4d57b6bd1f0ec.span;
function $cad7122580a17f06$export$67421072ccffa447(account) {
    const extensionData = (0, $06185939c98642bc$export$4fff3ed4eba4f4ee)((0, $06185939c98642bc$export$4f037c6ec2da4eeb).TransferHookAccount, account.tlvData);
    if (extensionData !== null) return $cad7122580a17f06$export$28d4d57b6bd1f0ec.decode(extensionData);
    else return null;
}
function $cad7122580a17f06$export$92a7ba5e4a13b776(mint, programId) {
    const seeds = [
        $cad7122580a17f06$require$Buffer.from("extra-account-metas"),
        mint.toBuffer()
    ];
    return (0, $1ZJZa.PublicKey).findProgramAddressSync(seeds, programId)[0];
}
const $cad7122580a17f06$export$38015d717b952b07 = (0, $Bz0HP.struct)([
    (0, $Bz0HP.u8)("discriminator"),
    (0, $Bz0HP.blob)(32, "addressConfig"),
    (0, $ca773c1ee6b15d17$export$87b259aa03e3d267)("isSigner"),
    (0, $ca773c1ee6b15d17$export$87b259aa03e3d267)("isWritable")
]);
const $cad7122580a17f06$export$547d3e194f2ec408 = (0, $Bz0HP.struct)([
    (0, $Bz0HP.u32)("count"),
    (0, $Bz0HP.seq)($cad7122580a17f06$export$38015d717b952b07, (0, $Bz0HP.greedy)($cad7122580a17f06$export$38015d717b952b07.span), "extraAccounts")
]);
const $cad7122580a17f06$export$e8f817468b384f2f = (0, $Bz0HP.struct)([
    (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("instructionDiscriminator"),
    (0, $Bz0HP.u32)("length"),
    $cad7122580a17f06$export$547d3e194f2ec408.replicate("extraAccountsList")
]);
function $cad7122580a17f06$export$b7fb7bf27b1d242(account) {
    const extraAccountsList = $cad7122580a17f06$export$e8f817468b384f2f.decode(account.data).extraAccountsList;
    return extraAccountsList.extraAccounts.slice(0, extraAccountsList.count);
}
async function $cad7122580a17f06$export$a538050d412c5646(connection, extraMeta, previousMetas, instructionData, transferHookProgramId) {
    if (extraMeta.discriminator === 0) return {
        pubkey: new (0, $1ZJZa.PublicKey)(extraMeta.addressConfig),
        isSigner: extraMeta.isSigner,
        isWritable: extraMeta.isWritable
    };
    else if (extraMeta.discriminator === 2) {
        const pubkey = await (0, $a2134a7c62b8081b$export$76e46d2bd9d499e8)(extraMeta.addressConfig, previousMetas, instructionData, connection);
        return {
            pubkey: pubkey,
            isSigner: extraMeta.isSigner,
            isWritable: extraMeta.isWritable
        };
    }
    let programId = (0, $1ZJZa.PublicKey).default;
    if (extraMeta.discriminator === 1) programId = transferHookProgramId;
    else {
        const accountIndex = extraMeta.discriminator - 128;
        if (previousMetas.length <= accountIndex) throw new (0, $69531333edd951b2$export$f515f489e4a79004)();
        programId = previousMetas[accountIndex].pubkey;
    }
    const seeds = await (0, $7e0e5f3206139b12$export$e3c2327a8649c7d4)(extraMeta.addressConfig, previousMetas, instructionData, connection);
    const pubkey = (0, $1ZJZa.PublicKey).findProgramAddressSync(seeds, programId)[0];
    return {
        pubkey: pubkey,
        isSigner: extraMeta.isSigner,
        isWritable: extraMeta.isWritable
    };
}



var $06185939c98642bc$export$4f037c6ec2da4eeb;
(function(ExtensionType) {
    ExtensionType[ExtensionType["Uninitialized"] = 0] = "Uninitialized";
    ExtensionType[ExtensionType["TransferFeeConfig"] = 1] = "TransferFeeConfig";
    ExtensionType[ExtensionType["TransferFeeAmount"] = 2] = "TransferFeeAmount";
    ExtensionType[ExtensionType["MintCloseAuthority"] = 3] = "MintCloseAuthority";
    ExtensionType[ExtensionType["ConfidentialTransferMint"] = 4] = "ConfidentialTransferMint";
    ExtensionType[ExtensionType["ConfidentialTransferAccount"] = 5] = "ConfidentialTransferAccount";
    ExtensionType[ExtensionType["DefaultAccountState"] = 6] = "DefaultAccountState";
    ExtensionType[ExtensionType["ImmutableOwner"] = 7] = "ImmutableOwner";
    ExtensionType[ExtensionType["MemoTransfer"] = 8] = "MemoTransfer";
    ExtensionType[ExtensionType["NonTransferable"] = 9] = "NonTransferable";
    ExtensionType[ExtensionType["InterestBearingConfig"] = 10] = "InterestBearingConfig";
    ExtensionType[ExtensionType["CpiGuard"] = 11] = "CpiGuard";
    ExtensionType[ExtensionType["PermanentDelegate"] = 12] = "PermanentDelegate";
    ExtensionType[ExtensionType["NonTransferableAccount"] = 13] = "NonTransferableAccount";
    ExtensionType[ExtensionType["TransferHook"] = 14] = "TransferHook";
    ExtensionType[ExtensionType["TransferHookAccount"] = 15] = "TransferHookAccount";
    // ConfidentialTransferFee, // Not implemented yet
    // ConfidentialTransferFeeAmount, // Not implemented yet
    ExtensionType[ExtensionType["MetadataPointer"] = 18] = "MetadataPointer";
    ExtensionType[ExtensionType["TokenMetadata"] = 19] = "TokenMetadata";
    ExtensionType[ExtensionType["GroupPointer"] = 20] = "GroupPointer";
    ExtensionType[ExtensionType["TokenGroup"] = 21] = "TokenGroup";
    ExtensionType[ExtensionType["GroupMemberPointer"] = 22] = "GroupMemberPointer";
    ExtensionType[ExtensionType["TokenGroupMember"] = 23] = "TokenGroupMember";
    // ConfidentialMintBurn, // Not implemented yet
    ExtensionType[ExtensionType["ScaledUiAmountConfig"] = 25] = "ScaledUiAmountConfig";
    ExtensionType[ExtensionType["PausableConfig"] = 26] = "PausableConfig";
    ExtensionType[ExtensionType["PausableAccount"] = 27] = "PausableAccount";
})($06185939c98642bc$export$4f037c6ec2da4eeb || ($06185939c98642bc$export$4f037c6ec2da4eeb = {}));
const $06185939c98642bc$export$b60591f8709c84d6 = 2;
const $06185939c98642bc$export$7ae242f656e23fe = 2;
function $06185939c98642bc$var$addTypeAndLengthToLen(len) {
    return len + $06185939c98642bc$export$b60591f8709c84d6 + $06185939c98642bc$export$7ae242f656e23fe;
}
function $06185939c98642bc$var$isVariableLengthExtension(e) {
    switch(e){
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenMetadata:
            return true;
        default:
            return false;
    }
}
function $06185939c98642bc$export$a83377bb2e8914d8(e) {
    switch(e){
        case $06185939c98642bc$export$4f037c6ec2da4eeb.Uninitialized:
            return 0;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferFeeConfig:
            return 0, $92eecbd6f95aadca$export$972cf5dcc13158da;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferFeeAmount:
            return 0, $92eecbd6f95aadca$export$8657a852ae4f4019;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MintCloseAuthority:
            return 0, $85f5f02c1cd432a2$export$1e1aa83bde32eb68;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
            return 65;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
            return 295;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.CpiGuard:
            return 0, $53a9d321bf5c6dac$export$2ad51e83460d1d03;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.DefaultAccountState:
            return 0, $eb78f4a67dbb9619$export$2e3c876eadfda1ab;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ImmutableOwner:
            return 0, $80dd37dda6db6940$export$4ba1dedcafaef535;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MemoTransfer:
            return 0, $9be2de765674365b$export$f4b5375ad34477a1;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MetadataPointer:
            return 0, $261106fb77ad78f4$export$46bfcd668f9095d0;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.NonTransferable:
            return 0, $d68f9e984158304d$export$31a113d46d052efb;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.InterestBearingConfig:
            return 0, $653810106d8aa4cf$export$5deaa22b862a446f;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PermanentDelegate:
            return 0, $4599116dcdb57545$export$636ea2373b6c6b7d;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.NonTransferableAccount:
            return 0, $d68f9e984158304d$export$91a6e2e8798d2502;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferHook:
            return 0, $cad7122580a17f06$export$5ade3cdfd72ee348;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferHookAccount:
            return 0, $cad7122580a17f06$export$998fd74b23e70abd;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.GroupPointer:
            return 0, $fdcb460d2833cb5d$export$3852a2b4ecb1c96c;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.GroupMemberPointer:
            return 0, $3ade4c85f0da52ae$export$f4d582c48d8cc7e7;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenGroup:
            return 0, $0f418e2520602fd6$export$83b408df29875efc;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenGroupMember:
            return 0, $9530d6cfb57d1c23$export$922ab442b9cf73bd;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ScaledUiAmountConfig:
            return 0, $02a6fe244bf4c8a2$export$88eb1c31690c2d3b;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PausableConfig:
            return 0, $1c60a6729a69425c$export$5b36c6a8fe7f3f5b;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PausableAccount:
            return 0, $1c60a6729a69425c$export$5a90dde3236e8b55;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenMetadata:
            throw Error(`Cannot get type length for variable extension type: ${e}`);
        default:
            throw Error(`Unknown extension type: ${e}`);
    }
}
function $06185939c98642bc$export$bb78b607a215e9f6(e) {
    switch(e){
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferFeeConfig:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.NonTransferable:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PermanentDelegate:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferHook:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MetadataPointer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenMetadata:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.GroupPointer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.GroupMemberPointer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenGroup:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenGroupMember:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ScaledUiAmountConfig:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PausableConfig:
            return true;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.Uninitialized:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MemoTransfer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.CpiGuard:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.NonTransferableAccount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferHookAccount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PausableAccount:
            return false;
        default:
            throw Error(`Unknown extension type: ${e}`);
    }
}
function $06185939c98642bc$export$da3491d66fdbe926(e) {
    switch(e){
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MemoTransfer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.CpiGuard:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.NonTransferableAccount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferHookAccount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PausableAccount:
            return true;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.Uninitialized:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferFeeConfig:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.NonTransferable:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PermanentDelegate:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferHook:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MetadataPointer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenMetadata:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.GroupPointer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.GroupMemberPointer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenGroup:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenGroupMember:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ScaledUiAmountConfig:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PausableConfig:
            return false;
        default:
            throw Error(`Unknown extension type: ${e}`);
    }
}
function $06185939c98642bc$export$cbf93c990104e9e6(e) {
    switch(e){
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferFeeConfig:
            return $06185939c98642bc$export$4f037c6ec2da4eeb.TransferFeeAmount;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
            return $06185939c98642bc$export$4f037c6ec2da4eeb.ConfidentialTransferAccount;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.NonTransferable:
            return $06185939c98642bc$export$4f037c6ec2da4eeb.NonTransferableAccount;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferHook:
            return $06185939c98642bc$export$4f037c6ec2da4eeb.TransferHookAccount;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PausableConfig:
            return $06185939c98642bc$export$4f037c6ec2da4eeb.PausableAccount;
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.CpiGuard:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MemoTransfer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.MetadataPointer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenMetadata:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.Uninitialized:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PermanentDelegate:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.NonTransferableAccount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TransferHookAccount:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.GroupPointer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.GroupMemberPointer:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenGroup:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.TokenGroupMember:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.ScaledUiAmountConfig:
        case $06185939c98642bc$export$4f037c6ec2da4eeb.PausableAccount:
            return $06185939c98642bc$export$4f037c6ec2da4eeb.Uninitialized;
    }
}
function $06185939c98642bc$var$getLen(extensionTypes, baseSize, variableLengthExtensions = {}) {
    if (extensionTypes.length === 0 && Object.keys(variableLengthExtensions).length === 0) return baseSize;
    else {
        const accountLength = (0, $7f741de2889b2aad$export$66ab21ef808e9dc6) + (0, $51028f78ac45d1f3$export$9d3ac77dcbf22b3f) + extensionTypes.filter((element, i)=>i === extensionTypes.indexOf(element)).map((element)=>$06185939c98642bc$var$addTypeAndLengthToLen($06185939c98642bc$export$a83377bb2e8914d8(element))).reduce((a, b)=>a + b, 0) + Object.entries(variableLengthExtensions).map(([extension, len])=>{
            if (!$06185939c98642bc$var$isVariableLengthExtension(Number(extension))) throw Error(`Extension ${extension} is not variable length`);
            return $06185939c98642bc$var$addTypeAndLengthToLen(len);
        }).reduce((a, b)=>a + b, 0);
        if (accountLength === (0, $920ede22f3e57658$export$c2abf71f91a1605b)) return accountLength + $06185939c98642bc$export$b60591f8709c84d6;
        else return accountLength;
    }
}
function $06185939c98642bc$export$887e6fc33c7c42b5(extensionTypes, variableLengthExtensions = {}) {
    return $06185939c98642bc$var$getLen(extensionTypes, (0, $fd17f660d934a42c$export$1e66c79f18e1c0c4), variableLengthExtensions);
}
function $06185939c98642bc$export$37c8c863c6dd42a9(extensionTypes) {
    // There are currently no variable length extensions for accounts
    return $06185939c98642bc$var$getLen(extensionTypes, (0, $7f741de2889b2aad$export$66ab21ef808e9dc6));
}
function $06185939c98642bc$export$4fff3ed4eba4f4ee(extension, tlvData) {
    let extensionTypeIndex = 0;
    while($06185939c98642bc$var$addTypeAndLengthToLen(extensionTypeIndex) <= tlvData.length){
        const entryType = tlvData.readUInt16LE(extensionTypeIndex);
        const entryLength = tlvData.readUInt16LE(extensionTypeIndex + $06185939c98642bc$export$b60591f8709c84d6);
        const typeIndex = $06185939c98642bc$var$addTypeAndLengthToLen(extensionTypeIndex);
        if (entryType == extension) return tlvData.slice(typeIndex, typeIndex + entryLength);
        extensionTypeIndex = typeIndex + entryLength;
    }
    return null;
}
function $06185939c98642bc$export$ddfd0a43fd10c049(tlvData) {
    const extensionTypes = [];
    let extensionTypeIndex = 0;
    while(extensionTypeIndex < tlvData.length){
        const entryType = tlvData.readUInt16LE(extensionTypeIndex);
        extensionTypes.push(entryType);
        const entryLength = tlvData.readUInt16LE(extensionTypeIndex + $06185939c98642bc$export$b60591f8709c84d6);
        extensionTypeIndex += $06185939c98642bc$var$addTypeAndLengthToLen(entryLength);
    }
    return extensionTypes;
}
function $06185939c98642bc$export$8e188ecf75868f0c(mint) {
    const extensionTypes = $06185939c98642bc$export$ddfd0a43fd10c049(mint.tlvData);
    const accountExtensions = extensionTypes.map($06185939c98642bc$export$cbf93c990104e9e6);
    return $06185939c98642bc$export$37c8c863c6dd42a9(accountExtensions);
}
function $06185939c98642bc$export$59ff847e58b4aa16(info, address, extensionType, extensionLen, programId = (0, $d917ee7adac252f0$export$8183845dc9f5ce72)) {
    const mint = (0, $fd17f660d934a42c$export$624621e2731540bb)(address, info, programId);
    const extensionData = $06185939c98642bc$export$4fff3ed4eba4f4ee(extensionType, mint.tlvData);
    const currentExtensionLen = extensionData ? $06185939c98642bc$var$addTypeAndLengthToLen(extensionData.length) : 0;
    const newExtensionLen = $06185939c98642bc$var$addTypeAndLengthToLen(extensionLen);
    return info.data.length + newExtensionLen - currentExtensionLen;
}





var $fd17f660d934a42c$require$Buffer = $bf0bcea1d7d4510a$export$a143d493d941bafc;
const $fd17f660d934a42c$export$1374e91decd2fbe5 = (0, $Bz0HP.struct)([
    (0, $Bz0HP.u32)("mintAuthorityOption"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("mintAuthority"),
    (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("supply"),
    (0, $Bz0HP.u8)("decimals"),
    (0, $ca773c1ee6b15d17$export$87b259aa03e3d267)("isInitialized"),
    (0, $Bz0HP.u32)("freezeAuthorityOption"),
    (0, $e5e62a64975f14ba$export$86f13247979de5d7)("freezeAuthority")
]);
const $fd17f660d934a42c$export$1e66c79f18e1c0c4 = $fd17f660d934a42c$export$1374e91decd2fbe5.span;
async function $fd17f660d934a42c$export$aa28710f9c948d46(connection, address, commitment, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    return $fd17f660d934a42c$export$624621e2731540bb(address, info, programId);
}
function $fd17f660d934a42c$export$624621e2731540bb(address, info, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801)) {
    if (!info) throw new (0, $69531333edd951b2$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $69531333edd951b2$export$abb470453474d51)();
    if (info.data.length < $fd17f660d934a42c$export$1e66c79f18e1c0c4) throw new (0, $69531333edd951b2$export$250d31de4ddb7ca5)();
    const rawMint = $fd17f660d934a42c$export$1374e91decd2fbe5.decode(info.data.slice(0, $fd17f660d934a42c$export$1e66c79f18e1c0c4));
    let tlvData = $fd17f660d934a42c$require$Buffer.alloc(0);
    if (info.data.length > $fd17f660d934a42c$export$1e66c79f18e1c0c4) {
        if (info.data.length <= (0, $7f741de2889b2aad$export$66ab21ef808e9dc6)) throw new (0, $69531333edd951b2$export$250d31de4ddb7ca5)();
        if (info.data.length === (0, $920ede22f3e57658$export$c2abf71f91a1605b)) throw new (0, $69531333edd951b2$export$250d31de4ddb7ca5)();
        if (info.data[0, $7f741de2889b2aad$export$66ab21ef808e9dc6] != (0, $51028f78ac45d1f3$export$b8ca5fa4899cbfc7).Mint) throw new (0, $69531333edd951b2$export$871debb212ec395)();
        tlvData = info.data.slice((0, $7f741de2889b2aad$export$66ab21ef808e9dc6) + (0, $51028f78ac45d1f3$export$9d3ac77dcbf22b3f));
    }
    return {
        address: address,
        mintAuthority: rawMint.mintAuthorityOption ? rawMint.mintAuthority : null,
        supply: rawMint.supply,
        decimals: rawMint.decimals,
        isInitialized: rawMint.isInitialized,
        freezeAuthority: rawMint.freezeAuthorityOption ? rawMint.freezeAuthority : null,
        tlvData: tlvData
    };
}
async function $fd17f660d934a42c$export$ee29e619ed2e153c(connection, commitment) {
    return await $fd17f660d934a42c$export$42e75cb3f25fa0b8(connection, [], commitment);
}
async function $fd17f660d934a42c$export$42e75cb3f25fa0b8(connection, extensions, commitment) {
    const mintLen = (0, $06185939c98642bc$export$887e6fc33c7c42b5)(extensions);
    return await connection.getMinimumBalanceForRentExemption(mintLen, commitment);
}
async function $fd17f660d934a42c$export$d776e5c4182d21cc(mint, owner, allowOwnerOffCurve = false, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $d917ee7adac252f0$export$57a4f33bcc1767fa)) {
    if (!allowOwnerOffCurve && !(0, $1ZJZa.PublicKey).isOnCurve(owner.toBuffer())) throw new (0, $69531333edd951b2$export$c431a85da6f99bf0)();
    const [address] = await (0, $1ZJZa.PublicKey).findProgramAddress([
        owner.toBuffer(),
        programId.toBuffer(),
        mint.toBuffer()
    ], associatedTokenProgramId);
    return address;
}
function $fd17f660d934a42c$export$226efbbb37d925bb(mint, owner, allowOwnerOffCurve = false, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $d917ee7adac252f0$export$57a4f33bcc1767fa)) {
    if (!allowOwnerOffCurve && !(0, $1ZJZa.PublicKey).isOnCurve(owner.toBuffer())) throw new (0, $69531333edd951b2$export$c431a85da6f99bf0)();
    const [address] = (0, $1ZJZa.PublicKey).findProgramAddressSync([
        owner.toBuffer(),
        programId.toBuffer(),
        mint.toBuffer()
    ], associatedTokenProgramId);
    return address;
}



var $a827b1d0ace42dfe$require$Buffer = $bf0bcea1d7d4510a$export$a143d493d941bafc;
function $a827b1d0ace42dfe$export$65d7d2fa066d6cc6(payer, associatedToken, owner, mint, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $d917ee7adac252f0$export$57a4f33bcc1767fa)) {
    return $a827b1d0ace42dfe$var$buildAssociatedTokenAccountInstruction(payer, associatedToken, owner, mint, $a827b1d0ace42dfe$require$Buffer.alloc(0), programId, associatedTokenProgramId);
}
function $a827b1d0ace42dfe$export$b66dd1dc00a3bc28(payer, associatedToken, owner, mint, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $d917ee7adac252f0$export$57a4f33bcc1767fa)) {
    return $a827b1d0ace42dfe$var$buildAssociatedTokenAccountInstruction(payer, associatedToken, owner, mint, $a827b1d0ace42dfe$require$Buffer.from([
        1
    ]), programId, associatedTokenProgramId);
}
function $a827b1d0ace42dfe$export$c3ee1ff71d4bd091(payer, owner, mint, allowOwnerOffCurve = true, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $d917ee7adac252f0$export$57a4f33bcc1767fa)) {
    const associatedToken = (0, $fd17f660d934a42c$export$226efbbb37d925bb)(mint, owner, allowOwnerOffCurve);
    return $a827b1d0ace42dfe$export$b66dd1dc00a3bc28(payer, associatedToken, owner, mint, programId, associatedTokenProgramId);
}
function $a827b1d0ace42dfe$var$buildAssociatedTokenAccountInstruction(payer, associatedToken, owner, mint, instructionData, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $d917ee7adac252f0$export$57a4f33bcc1767fa)) {
    const keys = [
        {
            pubkey: payer,
            isSigner: true,
            isWritable: true
        },
        {
            pubkey: associatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: owner,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: (0, $1ZJZa.SystemProgram).programId,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: programId,
            isSigner: false,
            isWritable: false
        }
    ];
    return new (0, $1ZJZa.TransactionInstruction)({
        keys: keys,
        programId: associatedTokenProgramId,
        data: instructionData
    });
}
function $a827b1d0ace42dfe$export$2108cac48553e999(nestedAssociatedToken, nestedMint, destinationAssociatedToken, ownerAssociatedToken, ownerMint, owner, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $d917ee7adac252f0$export$57a4f33bcc1767fa)) {
    const keys = [
        {
            pubkey: nestedAssociatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: nestedMint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: destinationAssociatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: ownerAssociatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: ownerMint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: owner,
            isSigner: true,
            isWritable: true
        },
        {
            pubkey: programId,
            isSigner: false,
            isWritable: false
        }
    ];
    return new (0, $1ZJZa.TransactionInstruction)({
        keys: keys,
        programId: associatedTokenProgramId,
        data: $a827b1d0ace42dfe$require$Buffer.from([
            2
        ])
    });
}


var $Bz0HP = parcelRequire("Bz0HP");


var $1ZJZa = parcelRequire("1ZJZa");



var $1ZJZa = parcelRequire("1ZJZa");
function $42f7b998feb7db63$export$fde60050662f8c02(keys, ownerOrAuthority, multiSigners) {
    if (multiSigners.length) {
        keys.push({
            pubkey: ownerOrAuthority,
            isSigner: false,
            isWritable: false
        });
        for (const signer of multiSigners)keys.push({
            pubkey: signer instanceof (0, $1ZJZa.PublicKey) ? signer : signer.publicKey,
            isSigner: true,
            isWritable: false
        });
    } else keys.push({
        pubkey: ownerOrAuthority,
        isSigner: true,
        isWritable: false
    });
    return keys;
}


/** Instructions defined by the program */ var $d9b27581d3a37cd6$export$236c07be390a0994;
(function(TokenInstruction) {
    TokenInstruction[TokenInstruction["InitializeMint"] = 0] = "InitializeMint";
    TokenInstruction[TokenInstruction["InitializeAccount"] = 1] = "InitializeAccount";
    TokenInstruction[TokenInstruction["InitializeMultisig"] = 2] = "InitializeMultisig";
    TokenInstruction[TokenInstruction["Transfer"] = 3] = "Transfer";
    TokenInstruction[TokenInstruction["Approve"] = 4] = "Approve";
    TokenInstruction[TokenInstruction["Revoke"] = 5] = "Revoke";
    TokenInstruction[TokenInstruction["SetAuthority"] = 6] = "SetAuthority";
    TokenInstruction[TokenInstruction["MintTo"] = 7] = "MintTo";
    TokenInstruction[TokenInstruction["Burn"] = 8] = "Burn";
    TokenInstruction[TokenInstruction["CloseAccount"] = 9] = "CloseAccount";
    TokenInstruction[TokenInstruction["FreezeAccount"] = 10] = "FreezeAccount";
    TokenInstruction[TokenInstruction["ThawAccount"] = 11] = "ThawAccount";
    TokenInstruction[TokenInstruction["TransferChecked"] = 12] = "TransferChecked";
    TokenInstruction[TokenInstruction["ApproveChecked"] = 13] = "ApproveChecked";
    TokenInstruction[TokenInstruction["MintToChecked"] = 14] = "MintToChecked";
    TokenInstruction[TokenInstruction["BurnChecked"] = 15] = "BurnChecked";
    TokenInstruction[TokenInstruction["InitializeAccount2"] = 16] = "InitializeAccount2";
    TokenInstruction[TokenInstruction["SyncNative"] = 17] = "SyncNative";
    TokenInstruction[TokenInstruction["InitializeAccount3"] = 18] = "InitializeAccount3";
    TokenInstruction[TokenInstruction["InitializeMultisig2"] = 19] = "InitializeMultisig2";
    TokenInstruction[TokenInstruction["InitializeMint2"] = 20] = "InitializeMint2";
    TokenInstruction[TokenInstruction["GetAccountDataSize"] = 21] = "GetAccountDataSize";
    TokenInstruction[TokenInstruction["InitializeImmutableOwner"] = 22] = "InitializeImmutableOwner";
    TokenInstruction[TokenInstruction["AmountToUiAmount"] = 23] = "AmountToUiAmount";
    TokenInstruction[TokenInstruction["UiAmountToAmount"] = 24] = "UiAmountToAmount";
    TokenInstruction[TokenInstruction["InitializeMintCloseAuthority"] = 25] = "InitializeMintCloseAuthority";
    TokenInstruction[TokenInstruction["TransferFeeExtension"] = 26] = "TransferFeeExtension";
    TokenInstruction[TokenInstruction["ConfidentialTransferExtension"] = 27] = "ConfidentialTransferExtension";
    TokenInstruction[TokenInstruction["DefaultAccountStateExtension"] = 28] = "DefaultAccountStateExtension";
    TokenInstruction[TokenInstruction["Reallocate"] = 29] = "Reallocate";
    TokenInstruction[TokenInstruction["MemoTransferExtension"] = 30] = "MemoTransferExtension";
    TokenInstruction[TokenInstruction["CreateNativeMint"] = 31] = "CreateNativeMint";
    TokenInstruction[TokenInstruction["InitializeNonTransferableMint"] = 32] = "InitializeNonTransferableMint";
    TokenInstruction[TokenInstruction["InterestBearingMintExtension"] = 33] = "InterestBearingMintExtension";
    TokenInstruction[TokenInstruction["CpiGuardExtension"] = 34] = "CpiGuardExtension";
    TokenInstruction[TokenInstruction["InitializePermanentDelegate"] = 35] = "InitializePermanentDelegate";
    TokenInstruction[TokenInstruction["TransferHookExtension"] = 36] = "TransferHookExtension";
    // ConfidentialTransferFeeExtension = 37,
    // WithdrawalExcessLamports = 38,
    TokenInstruction[TokenInstruction["MetadataPointerExtension"] = 39] = "MetadataPointerExtension";
    TokenInstruction[TokenInstruction["GroupPointerExtension"] = 40] = "GroupPointerExtension";
    TokenInstruction[TokenInstruction["GroupMemberPointerExtension"] = 41] = "GroupMemberPointerExtension";
    // ConfidentialMintBurnExtension = 42,
    TokenInstruction[TokenInstruction["ScaledUiAmountExtension"] = 43] = "ScaledUiAmountExtension";
    TokenInstruction[TokenInstruction["PausableExtension"] = 44] = "PausableExtension";
})($d9b27581d3a37cd6$export$236c07be390a0994 || ($d9b27581d3a37cd6$export$236c07be390a0994 = {}));



var $1506a18501f744dc$require$Buffer = $bf0bcea1d7d4510a$export$a143d493d941bafc;
const $1506a18501f744dc$export$36b3d03efc16d305 = (0, $Bz0HP.struct)([
    (0, $Bz0HP.u8)("instruction"),
    (0, $3dd23c74bb3fd3eb$export$cd1442401e54cffa)("amount")
]);
function $1506a18501f744dc$export$b274d5cebe357db9(source, destination, owner, amount, multiSigners = [], programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801)) {
    const keys = (0, $42f7b998feb7db63$export$fde60050662f8c02)([
        {
            pubkey: source,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: destination,
            isSigner: false,
            isWritable: true
        }
    ], owner, multiSigners);
    const data = $1506a18501f744dc$require$Buffer.alloc($1506a18501f744dc$export$36b3d03efc16d305.span);
    $1506a18501f744dc$export$36b3d03efc16d305.encode({
        instruction: (0, $d9b27581d3a37cd6$export$236c07be390a0994).Transfer,
        amount: BigInt(amount)
    }, data);
    return new (0, $1ZJZa.TransactionInstruction)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $1506a18501f744dc$export$d4ef34cde439b107(instruction, programId = (0, $d917ee7adac252f0$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $69531333edd951b2$export$a241007212c884f6)();
    if (instruction.data.length !== $1506a18501f744dc$export$36b3d03efc16d305.span) throw new (0, $69531333edd951b2$export$f96a822f391c3cc4)();
    const { keys: { source: source, destination: destination, owner: owner, multiSigners: multiSigners }, data: data } = $1506a18501f744dc$export$f64172008a79e2e1(instruction);
    if (data.instruction !== (0, $d9b27581d3a37cd6$export$236c07be390a0994).Transfer) throw new (0, $69531333edd951b2$export$e1301365d704141e)();
    if (!source || !destination || !owner) throw new (0, $69531333edd951b2$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            source: source,
            destination: destination,
            owner: owner,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $1506a18501f744dc$export$f64172008a79e2e1({ programId: programId, keys: [source, destination, owner, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            source: source,
            destination: destination,
            owner: owner,
            multiSigners: multiSigners
        },
        data: $1506a18501f744dc$export$36b3d03efc16d305.decode(data)
    };
}




var $bnENU = parcelRequire("bnENU");





const $91a7bca2e0a02780$var$ModalContainer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  background-color: rgba(7, 7, 40, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${(0, $aeddef6c40752364$export$ac81a72f0c3b6512)} 0.2s;
`;
const $91a7bca2e0a02780$var$ModalInner = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  background-color: white;
  box-shadow: 0 0 20px rgba(7, 7, 40, 0.5);
  width: 500px;
  max-width: 90%;
  border-radius: 10px;
  animation: ${(0, $aeddef6c40752364$export$f9ae25e7d5fbc8b9)} 0.1s cubic-bezier(0.18, 0.89, 0.32, 1.15);
  max-height: 90%;
  overflow: scroll;
`;
class $91a7bca2e0a02780$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).Component {
    render() {
        if (!this.props.visible) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {});
        const content = /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($91a7bca2e0a02780$var$ModalContainer, {
            onClick: (e)=>{
                if (!(e.target === this.inner || this.inner?.contains(e.target))) this.props.onClose();
            },
            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($91a7bca2e0a02780$var$ModalInner, {
                ref: (inner)=>this.inner = inner,
                style: this.props.innerStyles,
                children: [
                    this.props.title && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: 30,
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                style: {
                                    fontSize: 16,
                                    fontWeight: 500
                                },
                                children: this.props.title
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$c25acd513dcc8062), {
                                type: "button",
                                onClick: ()=>this.props.onClose(),
                                style: {
                                    padding: 0
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $604fb7faec27af0d$export$2e2bcd8739ae039), {
                                    style: {
                                        width: "14px"
                                    }
                                })
                            })
                        ]
                    }),
                    this.props.children
                ]
            })
        });
        return /*#__PURE__*/ (0, $93b772b00f04f226$exports.createPortal)(content, document.body);
    }
    constructor(...args){
        super(...args);
        this.inner = null;
    }
}



var $0f1056e7829df92e$exports = {};
"use strict";
Object.defineProperty($0f1056e7829df92e$exports, "__esModule", {
    value: true
});
function $0f1056e7829df92e$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $bnENU = parcelRequire("bnENU");
var $0f1056e7829df92e$var$React__default = $0f1056e7829df92e$var$_interopDefault($bnENU);

var $1ttxg = parcelRequire("1ttxg");
var $0f1056e7829df92e$var$ClientUAInstance = new $1ttxg();
var $0f1056e7829df92e$var$browser = $0f1056e7829df92e$var$ClientUAInstance.getBrowser();
var $0f1056e7829df92e$var$cpu = $0f1056e7829df92e$var$ClientUAInstance.getCPU();
var $0f1056e7829df92e$var$device = $0f1056e7829df92e$var$ClientUAInstance.getDevice();
var $0f1056e7829df92e$var$engine = $0f1056e7829df92e$var$ClientUAInstance.getEngine();
var $0f1056e7829df92e$var$os = $0f1056e7829df92e$var$ClientUAInstance.getOS();
var $0f1056e7829df92e$var$ua = $0f1056e7829df92e$var$ClientUAInstance.getUA();
var $0f1056e7829df92e$var$setUa = function setUa(userAgentString) {
    return $0f1056e7829df92e$var$ClientUAInstance.setUA(userAgentString);
};
var $0f1056e7829df92e$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $1ttxg(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $0f1056e7829df92e$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $0f1056e7829df92e$var$ClientUAInstance,
    browser: $0f1056e7829df92e$var$browser,
    cpu: $0f1056e7829df92e$var$cpu,
    device: $0f1056e7829df92e$var$device,
    engine: $0f1056e7829df92e$var$engine,
    os: $0f1056e7829df92e$var$os,
    ua: $0f1056e7829df92e$var$ua,
    setUa: $0f1056e7829df92e$var$setUa,
    parseUserAgent: $0f1056e7829df92e$var$parseUserAgent
});
function $0f1056e7829df92e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0f1056e7829df92e$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0f1056e7829df92e$var$ownKeys(Object(source), true).forEach(function(key) {
            $0f1056e7829df92e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0f1056e7829df92e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0f1056e7829df92e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0f1056e7829df92e$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $0f1056e7829df92e$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0f1056e7829df92e$var$_typeof(obj);
}
function $0f1056e7829df92e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0f1056e7829df92e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0f1056e7829df92e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0f1056e7829df92e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0f1056e7829df92e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $0f1056e7829df92e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0f1056e7829df92e$var$_extends() {
    $0f1056e7829df92e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0f1056e7829df92e$var$_extends.apply(this, arguments);
}
function $0f1056e7829df92e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $0f1056e7829df92e$var$_setPrototypeOf(subClass, superClass);
}
function $0f1056e7829df92e$var$_getPrototypeOf(o) {
    $0f1056e7829df92e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0f1056e7829df92e$var$_getPrototypeOf(o);
}
function $0f1056e7829df92e$var$_setPrototypeOf(o, p) {
    $0f1056e7829df92e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0f1056e7829df92e$var$_setPrototypeOf(o, p);
}
function $0f1056e7829df92e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0f1056e7829df92e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0f1056e7829df92e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0f1056e7829df92e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0f1056e7829df92e$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0f1056e7829df92e$var$_assertThisInitialized(self);
}
function $0f1056e7829df92e$var$_slicedToArray(arr, i) {
    return $0f1056e7829df92e$var$_arrayWithHoles(arr) || $0f1056e7829df92e$var$_iterableToArrayLimit(arr, i) || $0f1056e7829df92e$var$_unsupportedIterableToArray(arr, i) || $0f1056e7829df92e$var$_nonIterableRest();
}
function $0f1056e7829df92e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0f1056e7829df92e$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0f1056e7829df92e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0f1056e7829df92e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0f1056e7829df92e$var$_arrayLikeToArray(o, minLen);
}
function $0f1056e7829df92e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0f1056e7829df92e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $0f1056e7829df92e$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $0f1056e7829df92e$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $0f1056e7829df92e$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $0f1056e7829df92e$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $0f1056e7829df92e$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $0f1056e7829df92e$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $0f1056e7829df92e$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $0f1056e7829df92e$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $0f1056e7829df92e$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $0f1056e7829df92e$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $0f1056e7829df92e$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $0f1056e7829df92e$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $0f1056e7829df92e$var$InitialDeviceTypes;
    }
};
var $0f1056e7829df92e$var$setUserAgent = function setUserAgent(userAgent) {
    return $0f1056e7829df92e$var$setUa(userAgent);
};
var $0f1056e7829df92e$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $0f1056e7829df92e$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $0f1056e7829df92e$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $0f1056e7829df92e$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $0f1056e7829df92e$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $0f1056e7829df92e$var$setDefaults(browser.major),
        browserFullVersion: $0f1056e7829df92e$var$setDefaults(browser.version),
        browserName: $0f1056e7829df92e$var$setDefaults(browser.name),
        engineName: $0f1056e7829df92e$var$setDefaults(engine.name),
        engineVersion: $0f1056e7829df92e$var$setDefaults(engine.version),
        osName: $0f1056e7829df92e$var$setDefaults(os.name),
        osVersion: $0f1056e7829df92e$var$setDefaults(os.version),
        userAgent: $0f1056e7829df92e$var$setDefaults(ua)
    };
};
var $0f1056e7829df92e$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $0f1056e7829df92e$var$_objectSpread2({}, type, {
        vendor: $0f1056e7829df92e$var$setDefaults(device.vendor),
        model: $0f1056e7829df92e$var$setDefaults(device.model),
        os: $0f1056e7829df92e$var$setDefaults(os.name),
        osVersion: $0f1056e7829df92e$var$setDefaults(os.version),
        ua: $0f1056e7829df92e$var$setDefaults(ua)
    });
};
var $0f1056e7829df92e$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $0f1056e7829df92e$var$setDefaults(engine.name),
        engineVersion: $0f1056e7829df92e$var$setDefaults(engine.version),
        osName: $0f1056e7829df92e$var$setDefaults(os.name),
        osVersion: $0f1056e7829df92e$var$setDefaults(os.version),
        userAgent: $0f1056e7829df92e$var$setDefaults(ua)
    };
};
var $0f1056e7829df92e$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $0f1056e7829df92e$var$setDefaults(engine.name),
        engineVersion: $0f1056e7829df92e$var$setDefaults(engine.version),
        osName: $0f1056e7829df92e$var$setDefaults(os.name),
        osVersion: $0f1056e7829df92e$var$setDefaults(os.version),
        userAgent: $0f1056e7829df92e$var$setDefaults(ua)
    };
};
var $0f1056e7829df92e$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $0f1056e7829df92e$var$setDefaults(engine.name),
        engineVersion: $0f1056e7829df92e$var$setDefaults(engine.version),
        osName: $0f1056e7829df92e$var$setDefaults(os.name),
        osVersion: $0f1056e7829df92e$var$setDefaults(os.version),
        userAgent: $0f1056e7829df92e$var$setDefaults(ua)
    };
};
var $0f1056e7829df92e$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $0f1056e7829df92e$var$setDefaults(device.vendor),
        model: $0f1056e7829df92e$var$setDefaults(device.model),
        engineName: $0f1056e7829df92e$var$setDefaults(engine.name),
        engineVersion: $0f1056e7829df92e$var$setDefaults(engine.version),
        osName: $0f1056e7829df92e$var$setDefaults(os.name),
        osVersion: $0f1056e7829df92e$var$setDefaults(os.version),
        userAgent: $0f1056e7829df92e$var$setDefaults(ua)
    };
};
function $0f1056e7829df92e$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $0f1056e7829df92e$var$parseUserAgent(userAgent) : $0f1056e7829df92e$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $0f1056e7829df92e$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $0f1056e7829df92e$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $0f1056e7829df92e$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $0f1056e7829df92e$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $0f1056e7829df92e$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $0f1056e7829df92e$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $0f1056e7829df92e$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $0f1056e7829df92e$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $0f1056e7829df92e$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $0f1056e7829df92e$var$DeviceTypes.Mobile;
};
var $0f1056e7829df92e$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $0f1056e7829df92e$var$DeviceTypes.Tablet;
};
var $0f1056e7829df92e$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $0f1056e7829df92e$var$DeviceTypes.Mobile || type === $0f1056e7829df92e$var$DeviceTypes.Tablet;
};
var $0f1056e7829df92e$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $0f1056e7829df92e$var$DeviceTypes.SmartTv;
};
var $0f1056e7829df92e$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $0f1056e7829df92e$var$DeviceTypes.Browser;
};
var $0f1056e7829df92e$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $0f1056e7829df92e$var$DeviceTypes.Wearable;
};
var $0f1056e7829df92e$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $0f1056e7829df92e$var$DeviceTypes.Console;
};
var $0f1056e7829df92e$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $0f1056e7829df92e$var$DeviceTypes.Embedded;
};
var $0f1056e7829df92e$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $0f1056e7829df92e$var$setDefaults(vendor);
};
var $0f1056e7829df92e$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $0f1056e7829df92e$var$setDefaults(model);
};
var $0f1056e7829df92e$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $0f1056e7829df92e$var$setDefaults(type, "browser");
}; // os types
var $0f1056e7829df92e$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $0f1056e7829df92e$var$OsTypes.Android;
};
var $0f1056e7829df92e$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $0f1056e7829df92e$var$OsTypes.Windows;
};
var $0f1056e7829df92e$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $0f1056e7829df92e$var$OsTypes.MAC_OS;
};
var $0f1056e7829df92e$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $0f1056e7829df92e$var$OsTypes.WindowsPhone;
};
var $0f1056e7829df92e$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $0f1056e7829df92e$var$OsTypes.IOS;
};
var $0f1056e7829df92e$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $0f1056e7829df92e$var$setDefaults(version);
};
var $0f1056e7829df92e$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $0f1056e7829df92e$var$setDefaults(name);
}; // browser types
var $0f1056e7829df92e$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.Chrome;
};
var $0f1056e7829df92e$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.Firefox;
};
var $0f1056e7829df92e$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.Chromium;
};
var $0f1056e7829df92e$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.Edge;
};
var $0f1056e7829df92e$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.Yandex;
};
var $0f1056e7829df92e$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.Safari || name === $0f1056e7829df92e$var$BrowserTypes.MobileSafari;
};
var $0f1056e7829df92e$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.MobileSafari;
};
var $0f1056e7829df92e$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.Opera;
};
var $0f1056e7829df92e$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.InternetExplorer || name === $0f1056e7829df92e$var$BrowserTypes.Ie;
};
var $0f1056e7829df92e$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.MIUI;
};
var $0f1056e7829df92e$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $0f1056e7829df92e$var$BrowserTypes.SamsungBrowser;
};
var $0f1056e7829df92e$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $0f1056e7829df92e$var$setDefaults(version);
};
var $0f1056e7829df92e$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $0f1056e7829df92e$var$setDefaults(major);
};
var $0f1056e7829df92e$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $0f1056e7829df92e$var$setDefaults(name);
}; // engine types
var $0f1056e7829df92e$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $0f1056e7829df92e$var$setDefaults(name);
};
var $0f1056e7829df92e$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $0f1056e7829df92e$var$setDefaults(version);
};
var $0f1056e7829df92e$var$isElectronType = function isElectronType() {
    var nav = $0f1056e7829df92e$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $0f1056e7829df92e$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $0f1056e7829df92e$var$getIOS13 = function getIOS13() {
    var nav = $0f1056e7829df92e$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $0f1056e7829df92e$var$getIPad13 = function getIPad13() {
    return $0f1056e7829df92e$var$isIOS13Check("iPad");
};
var $0f1056e7829df92e$var$getIphone13 = function getIphone13() {
    return $0f1056e7829df92e$var$isIOS13Check("iPhone");
};
var $0f1056e7829df92e$var$getIPod13 = function getIPod13() {
    return $0f1056e7829df92e$var$isIOS13Check("iPod");
};
var $0f1056e7829df92e$var$getUseragent = function getUseragent(userAg) {
    return $0f1056e7829df92e$var$setDefaults(userAg);
};
function $0f1056e7829df92e$var$buildSelectorsObject(options) {
    var _ref = options ? options : $0f1056e7829df92e$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $0f1056e7829df92e$var$isSmartTVType(device),
        isConsole: $0f1056e7829df92e$var$isConsoleType(device),
        isWearable: $0f1056e7829df92e$var$isWearableType(device),
        isEmbedded: $0f1056e7829df92e$var$isEmbeddedType(device),
        isMobileSafari: $0f1056e7829df92e$var$isMobileSafariType(browser) || $0f1056e7829df92e$var$getIPad13(),
        isChromium: $0f1056e7829df92e$var$isChromiumType(browser),
        isMobile: $0f1056e7829df92e$var$isMobileAndTabletType(device) || $0f1056e7829df92e$var$getIPad13(),
        isMobileOnly: $0f1056e7829df92e$var$isMobileType(device),
        isTablet: $0f1056e7829df92e$var$isTabletType(device) || $0f1056e7829df92e$var$getIPad13(),
        isBrowser: $0f1056e7829df92e$var$isBrowserType(device),
        isDesktop: $0f1056e7829df92e$var$isBrowserType(device),
        isAndroid: $0f1056e7829df92e$var$isAndroidType(os),
        isWinPhone: $0f1056e7829df92e$var$isWinPhoneType(os),
        isIOS: $0f1056e7829df92e$var$isIOSType(os) || $0f1056e7829df92e$var$getIPad13(),
        isChrome: $0f1056e7829df92e$var$isChromeType(browser),
        isFirefox: $0f1056e7829df92e$var$isFirefoxType(browser),
        isSafari: $0f1056e7829df92e$var$isSafariType(browser),
        isOpera: $0f1056e7829df92e$var$isOperaType(browser),
        isIE: $0f1056e7829df92e$var$isIEType(browser),
        osVersion: $0f1056e7829df92e$var$getOsVersion(os),
        osName: $0f1056e7829df92e$var$getOsName(os),
        fullBrowserVersion: $0f1056e7829df92e$var$getBrowserFullVersion(browser),
        browserVersion: $0f1056e7829df92e$var$getBrowserVersion(browser),
        browserName: $0f1056e7829df92e$var$getBrowserName(browser),
        mobileVendor: $0f1056e7829df92e$var$getMobileVendor(device),
        mobileModel: $0f1056e7829df92e$var$getMobileModel(device),
        engineName: $0f1056e7829df92e$var$getEngineName(engine),
        engineVersion: $0f1056e7829df92e$var$getEngineVersion(engine),
        getUA: $0f1056e7829df92e$var$getUseragent(ua),
        isEdge: $0f1056e7829df92e$var$isEdgeType(browser) || $0f1056e7829df92e$var$isEdgeChromiumType(ua),
        isYandex: $0f1056e7829df92e$var$isYandexType(browser),
        deviceType: $0f1056e7829df92e$var$getDeviceType(device),
        isIOS13: $0f1056e7829df92e$var$getIOS13(),
        isIPad13: $0f1056e7829df92e$var$getIPad13(),
        isIPhone13: $0f1056e7829df92e$var$getIphone13(),
        isIPod13: $0f1056e7829df92e$var$getIPod13(),
        isElectron: $0f1056e7829df92e$var$isElectronType(),
        isEdgeChromium: $0f1056e7829df92e$var$isEdgeChromiumType(ua),
        isLegacyEdge: $0f1056e7829df92e$var$isEdgeType(browser) && !$0f1056e7829df92e$var$isEdgeChromiumType(ua),
        isWindows: $0f1056e7829df92e$var$isWindowsType(os),
        isMacOs: $0f1056e7829df92e$var$isMacOsType(os),
        isMIUI: $0f1056e7829df92e$var$isMIUIType(browser),
        isSamsungBrowser: $0f1056e7829df92e$var$isSamsungBrowserType(browser)
    };
}
var $0f1056e7829df92e$var$isSmartTV = $0f1056e7829df92e$var$isSmartTVType($0f1056e7829df92e$var$device);
var $0f1056e7829df92e$var$isConsole = $0f1056e7829df92e$var$isConsoleType($0f1056e7829df92e$var$device);
var $0f1056e7829df92e$var$isWearable = $0f1056e7829df92e$var$isWearableType($0f1056e7829df92e$var$device);
var $0f1056e7829df92e$var$isEmbedded = $0f1056e7829df92e$var$isEmbeddedType($0f1056e7829df92e$var$device);
var $0f1056e7829df92e$var$isMobileSafari = $0f1056e7829df92e$var$isMobileSafariType($0f1056e7829df92e$var$browser) || $0f1056e7829df92e$var$getIPad13();
var $0f1056e7829df92e$var$isChromium = $0f1056e7829df92e$var$isChromiumType($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$isMobile = $0f1056e7829df92e$var$isMobileAndTabletType($0f1056e7829df92e$var$device) || $0f1056e7829df92e$var$getIPad13();
var $0f1056e7829df92e$var$isMobileOnly = $0f1056e7829df92e$var$isMobileType($0f1056e7829df92e$var$device);
var $0f1056e7829df92e$var$isTablet = $0f1056e7829df92e$var$isTabletType($0f1056e7829df92e$var$device) || $0f1056e7829df92e$var$getIPad13();
var $0f1056e7829df92e$var$isBrowser = $0f1056e7829df92e$var$isBrowserType($0f1056e7829df92e$var$device);
var $0f1056e7829df92e$var$isDesktop = $0f1056e7829df92e$var$isBrowserType($0f1056e7829df92e$var$device);
var $0f1056e7829df92e$var$isAndroid = $0f1056e7829df92e$var$isAndroidType($0f1056e7829df92e$var$os);
var $0f1056e7829df92e$var$isWinPhone = $0f1056e7829df92e$var$isWinPhoneType($0f1056e7829df92e$var$os);
var $0f1056e7829df92e$var$isIOS = $0f1056e7829df92e$var$isIOSType($0f1056e7829df92e$var$os) || $0f1056e7829df92e$var$getIPad13();
var $0f1056e7829df92e$var$isChrome = $0f1056e7829df92e$var$isChromeType($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$isFirefox = $0f1056e7829df92e$var$isFirefoxType($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$isSafari = $0f1056e7829df92e$var$isSafariType($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$isOpera = $0f1056e7829df92e$var$isOperaType($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$isIE = $0f1056e7829df92e$var$isIEType($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$osVersion = $0f1056e7829df92e$var$getOsVersion($0f1056e7829df92e$var$os);
var $0f1056e7829df92e$var$osName = $0f1056e7829df92e$var$getOsName($0f1056e7829df92e$var$os);
var $0f1056e7829df92e$var$fullBrowserVersion = $0f1056e7829df92e$var$getBrowserFullVersion($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$browserVersion = $0f1056e7829df92e$var$getBrowserVersion($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$browserName = $0f1056e7829df92e$var$getBrowserName($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$mobileVendor = $0f1056e7829df92e$var$getMobileVendor($0f1056e7829df92e$var$device);
var $0f1056e7829df92e$var$mobileModel = $0f1056e7829df92e$var$getMobileModel($0f1056e7829df92e$var$device);
var $0f1056e7829df92e$var$engineName = $0f1056e7829df92e$var$getEngineName($0f1056e7829df92e$var$engine);
var $0f1056e7829df92e$var$engineVersion = $0f1056e7829df92e$var$getEngineVersion($0f1056e7829df92e$var$engine);
var $0f1056e7829df92e$var$getUA = $0f1056e7829df92e$var$getUseragent($0f1056e7829df92e$var$ua);
var $0f1056e7829df92e$var$isEdge = $0f1056e7829df92e$var$isEdgeType($0f1056e7829df92e$var$browser) || $0f1056e7829df92e$var$isEdgeChromiumType($0f1056e7829df92e$var$ua);
var $0f1056e7829df92e$var$isYandex = $0f1056e7829df92e$var$isYandexType($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$deviceType = $0f1056e7829df92e$var$getDeviceType($0f1056e7829df92e$var$device);
var $0f1056e7829df92e$var$isIOS13 = $0f1056e7829df92e$var$getIOS13();
var $0f1056e7829df92e$var$isIPad13 = $0f1056e7829df92e$var$getIPad13();
var $0f1056e7829df92e$var$isIPhone13 = $0f1056e7829df92e$var$getIphone13();
var $0f1056e7829df92e$var$isIPod13 = $0f1056e7829df92e$var$getIPod13();
var $0f1056e7829df92e$var$isElectron = $0f1056e7829df92e$var$isElectronType();
var $0f1056e7829df92e$var$isEdgeChromium = $0f1056e7829df92e$var$isEdgeChromiumType($0f1056e7829df92e$var$ua);
var $0f1056e7829df92e$var$isLegacyEdge = $0f1056e7829df92e$var$isEdgeType($0f1056e7829df92e$var$browser) && !$0f1056e7829df92e$var$isEdgeChromiumType($0f1056e7829df92e$var$ua);
var $0f1056e7829df92e$var$isWindows = $0f1056e7829df92e$var$isWindowsType($0f1056e7829df92e$var$os);
var $0f1056e7829df92e$var$isMacOs = $0f1056e7829df92e$var$isMacOsType($0f1056e7829df92e$var$os);
var $0f1056e7829df92e$var$isMIUI = $0f1056e7829df92e$var$isMIUIType($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$isSamsungBrowser = $0f1056e7829df92e$var$isSamsungBrowserType($0f1056e7829df92e$var$browser);
var $0f1056e7829df92e$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $0f1056e7829df92e$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $0f1056e7829df92e$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $0f1056e7829df92e$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $0f1056e7829df92e$var$isAndroid ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $0f1056e7829df92e$var$isBrowser ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $0f1056e7829df92e$var$isIE ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $0f1056e7829df92e$var$isIOS ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $0f1056e7829df92e$var$isMobile ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $0f1056e7829df92e$var$isTablet ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $0f1056e7829df92e$var$isWinPhone ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $0f1056e7829df92e$var$isMobileOnly ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $0f1056e7829df92e$var$isSmartTV ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $0f1056e7829df92e$var$isConsole ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $0f1056e7829df92e$var$isWearable ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
var $0f1056e7829df92e$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $0f1056e7829df92e$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $0f1056e7829df92e$var$React__default.createElement($bnENU.Fragment, null, children) : $0f1056e7829df92e$var$React__default.createElement("div", props, children) : null;
};
function $0f1056e7829df92e$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $0f1056e7829df92e$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $0f1056e7829df92e$var$_classCallCheck(this, _class);
            _this = $0f1056e7829df92e$var$_possibleConstructorReturn(this, $0f1056e7829df92e$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($0f1056e7829df92e$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($0f1056e7829df92e$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($0f1056e7829df92e$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $0f1056e7829df92e$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $0f1056e7829df92e$var$_typeof(window)) !== undefined && $0f1056e7829df92e$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $0f1056e7829df92e$var$React__default.createElement(WrappedComponent, $0f1056e7829df92e$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($0f1056e7829df92e$var$React__default.Component);
}
function $0f1056e7829df92e$var$useMobileOrientation() {
    var _useState = $bnENU.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $0f1056e7829df92e$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $bnENU.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $bnENU.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $0f1056e7829df92e$var$_typeof(window)) !== undefined && $0f1056e7829df92e$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $0f1056e7829df92e$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $0f1056e7829df92e$var$parseUserAgent(hookUserAgent);
}
function $0f1056e7829df92e$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $0f1056e7829df92e$var$useDeviceData(hookUserAgent);
    var selectors = $0f1056e7829df92e$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$0f1056e7829df92e$exports.AndroidView = $0f1056e7829df92e$var$AndroidView;
$0f1056e7829df92e$exports.BrowserTypes = $0f1056e7829df92e$var$BrowserTypes;
$0f1056e7829df92e$exports.BrowserView = $0f1056e7829df92e$var$BrowserView;
$0f1056e7829df92e$exports.ConsoleView = $0f1056e7829df92e$var$ConsoleView;
$0f1056e7829df92e$exports.CustomView = $0f1056e7829df92e$var$CustomView;
$0f1056e7829df92e$exports.IEView = $0f1056e7829df92e$var$IEView;
$0f1056e7829df92e$exports.IOSView = $0f1056e7829df92e$var$IOSView;
$0f1056e7829df92e$exports.MobileOnlyView = $0f1056e7829df92e$var$MobileOnlyView;
$0f1056e7829df92e$exports.MobileView = $0f1056e7829df92e$var$MobileView;
$0f1056e7829df92e$exports.OsTypes = $0f1056e7829df92e$var$OsTypes;
$0f1056e7829df92e$exports.SmartTVView = $0f1056e7829df92e$var$SmartTVView;
$0f1056e7829df92e$exports.TabletView = $0f1056e7829df92e$var$TabletView;
$0f1056e7829df92e$exports.WearableView = $0f1056e7829df92e$var$WearableView;
$0f1056e7829df92e$exports.WinPhoneView = $0f1056e7829df92e$var$WinPhoneView;
$0f1056e7829df92e$exports.browserName = $0f1056e7829df92e$var$browserName;
$0f1056e7829df92e$exports.browserVersion = $0f1056e7829df92e$var$browserVersion;
$0f1056e7829df92e$exports.deviceDetect = $0f1056e7829df92e$var$deviceDetect;
$0f1056e7829df92e$exports.deviceType = $0f1056e7829df92e$var$deviceType;
$0f1056e7829df92e$exports.engineName = $0f1056e7829df92e$var$engineName;
$0f1056e7829df92e$exports.engineVersion = $0f1056e7829df92e$var$engineVersion;
$0f1056e7829df92e$exports.fullBrowserVersion = $0f1056e7829df92e$var$fullBrowserVersion;
$0f1056e7829df92e$exports.getSelectorsByUserAgent = $0f1056e7829df92e$var$getSelectorsByUserAgent;
$0f1056e7829df92e$exports.getUA = $0f1056e7829df92e$var$getUA;
$0f1056e7829df92e$exports.isAndroid = $0f1056e7829df92e$var$isAndroid;
$0f1056e7829df92e$exports.isBrowser = $0f1056e7829df92e$var$isBrowser;
$0f1056e7829df92e$exports.isChrome = $0f1056e7829df92e$var$isChrome;
$0f1056e7829df92e$exports.isChromium = $0f1056e7829df92e$var$isChromium;
$0f1056e7829df92e$exports.isConsole = $0f1056e7829df92e$var$isConsole;
$0f1056e7829df92e$exports.isDesktop = $0f1056e7829df92e$var$isDesktop;
$0f1056e7829df92e$exports.isEdge = $0f1056e7829df92e$var$isEdge;
$0f1056e7829df92e$exports.isEdgeChromium = $0f1056e7829df92e$var$isEdgeChromium;
$0f1056e7829df92e$exports.isElectron = $0f1056e7829df92e$var$isElectron;
$0f1056e7829df92e$exports.isEmbedded = $0f1056e7829df92e$var$isEmbedded;
$0f1056e7829df92e$exports.isFirefox = $0f1056e7829df92e$var$isFirefox;
$0f1056e7829df92e$exports.isIE = $0f1056e7829df92e$var$isIE;
$0f1056e7829df92e$exports.isIOS = $0f1056e7829df92e$var$isIOS;
$0f1056e7829df92e$exports.isIOS13 = $0f1056e7829df92e$var$isIOS13;
$0f1056e7829df92e$exports.isIPad13 = $0f1056e7829df92e$var$isIPad13;
$0f1056e7829df92e$exports.isIPhone13 = $0f1056e7829df92e$var$isIPhone13;
$0f1056e7829df92e$exports.isIPod13 = $0f1056e7829df92e$var$isIPod13;
$0f1056e7829df92e$exports.isLegacyEdge = $0f1056e7829df92e$var$isLegacyEdge;
$0f1056e7829df92e$exports.isMIUI = $0f1056e7829df92e$var$isMIUI;
$0f1056e7829df92e$exports.isMacOs = $0f1056e7829df92e$var$isMacOs;
$0f1056e7829df92e$exports.isMobile = $0f1056e7829df92e$var$isMobile;
$0f1056e7829df92e$exports.isMobileOnly = $0f1056e7829df92e$var$isMobileOnly;
$0f1056e7829df92e$exports.isMobileSafari = $0f1056e7829df92e$var$isMobileSafari;
$0f1056e7829df92e$exports.isOpera = $0f1056e7829df92e$var$isOpera;
$0f1056e7829df92e$exports.isSafari = $0f1056e7829df92e$var$isSafari;
$0f1056e7829df92e$exports.isSamsungBrowser = $0f1056e7829df92e$var$isSamsungBrowser;
$0f1056e7829df92e$exports.isSmartTV = $0f1056e7829df92e$var$isSmartTV;
$0f1056e7829df92e$exports.isTablet = $0f1056e7829df92e$var$isTablet;
$0f1056e7829df92e$exports.isWearable = $0f1056e7829df92e$var$isWearable;
$0f1056e7829df92e$exports.isWinPhone = $0f1056e7829df92e$var$isWinPhone;
$0f1056e7829df92e$exports.isWindows = $0f1056e7829df92e$var$isWindows;
$0f1056e7829df92e$exports.isYandex = $0f1056e7829df92e$var$isYandex;
$0f1056e7829df92e$exports.mobileModel = $0f1056e7829df92e$var$mobileModel;
$0f1056e7829df92e$exports.mobileVendor = $0f1056e7829df92e$var$mobileVendor;
$0f1056e7829df92e$exports.osName = $0f1056e7829df92e$var$osName;
$0f1056e7829df92e$exports.osVersion = $0f1056e7829df92e$var$osVersion;
$0f1056e7829df92e$exports.parseUserAgent = $0f1056e7829df92e$var$parseUserAgent;
$0f1056e7829df92e$exports.setUserAgent = $0f1056e7829df92e$var$setUserAgent;
$0f1056e7829df92e$exports.useDeviceData = $0f1056e7829df92e$var$useDeviceData;
$0f1056e7829df92e$exports.useDeviceSelectors = $0f1056e7829df92e$var$useDeviceSelectors;
$0f1056e7829df92e$exports.useMobileOrientation = $0f1056e7829df92e$var$useMobileOrientation;
$0f1056e7829df92e$exports.withOrientationChange = $0f1056e7829df92e$var$withOrientationChange;



var $bnENU = parcelRequire("bnENU");

var $bnENU = parcelRequire("bnENU");
const $5c2e30aa4d09c44d$var$DEFAULT_CONTEXT = {
    setVisible (_open) {
        console.error($5c2e30aa4d09c44d$var$constructMissingProviderErrorMessage("call", "setVisible"));
    },
    visible: false
};
Object.defineProperty($5c2e30aa4d09c44d$var$DEFAULT_CONTEXT, "visible", {
    get () {
        console.error($5c2e30aa4d09c44d$var$constructMissingProviderErrorMessage("read", "visible"));
        return false;
    }
});
function $5c2e30aa4d09c44d$var$constructMissingProviderErrorMessage(action, valueName) {
    return "You have tried to " + ` ${action} "${valueName}"` + " on a WalletModalContext without providing one." + " Make sure to render a WalletModalProvider" + " as an ancestor of the component that uses " + "WalletModalContext";
}
const $5c2e30aa4d09c44d$export$8fa8c0fc3ea86e87 = (0, $bnENU.createContext)($5c2e30aa4d09c44d$var$DEFAULT_CONTEXT);
function $5c2e30aa4d09c44d$export$6fdf0454adae214b() {
    return (0, $bnENU.useContext)($5c2e30aa4d09c44d$export$8fa8c0fc3ea86e87);
}





var $bnENU = parcelRequire("bnENU");


var $bnENU = parcelRequire("bnENU");
const $6ce8b5c336997aaf$export$78768a9af065a7b = ({ id: id, children: children, expanded: expanded = false })=>{
    const ref = (0, $bnENU.useRef)(null);
    const instant = (0, $bnENU.useRef)(true);
    const transition = "height 250ms ease-out";
    const openCollapse = ()=>{
        const node = ref.current;
        if (!node) return;
        requestAnimationFrame(()=>{
            node.style.height = node.scrollHeight + "px";
        });
    };
    const closeCollapse = ()=>{
        const node = ref.current;
        if (!node) return;
        requestAnimationFrame(()=>{
            node.style.height = node.offsetHeight + "px";
            node.style.overflow = "hidden";
            requestAnimationFrame(()=>{
                node.style.height = "0";
            });
        });
    };
    (0, $bnENU.useLayoutEffect)(()=>{
        if (expanded) openCollapse();
        else closeCollapse();
    }, [
        expanded
    ]);
    (0, $bnENU.useLayoutEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        function handleComplete() {
            if (!node) return;
            node.style.overflow = expanded ? "initial" : "hidden";
            if (expanded) node.style.height = "auto";
        }
        function handleTransitionEnd(event) {
            if (node && event.target === node && event.propertyName === "height") handleComplete();
        }
        if (instant.current) {
            handleComplete();
            instant.current = false;
        }
        node.addEventListener("transitionend", handleTransitionEnd);
        return ()=>node.removeEventListener("transitionend", handleTransitionEnd);
    }, [
        expanded
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("div", {
        className: "wallet-adapter-collapse",
        id: id,
        ref: ref,
        role: "region",
        style: {
            height: 0,
            transition: instant.current ? undefined : transition
        }
    }, children);
};




var $bnENU = parcelRequire("bnENU");

var $bnENU = parcelRequire("bnENU");
const $6bbcd052ae56aec7$export$353f5b6fc5456de1 = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("button", {
        className: `wallet-adapter-button ${props.className || ""}`,
        disabled: props.disabled,
        style: props.style,
        onClick: props.onClick,
        tabIndex: props.tabIndex || 0,
        type: "button"
    }, props.startIcon && (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("i", {
        className: "wallet-adapter-button-start-icon"
    }, props.startIcon), props.children, props.endIcon && (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("i", {
        className: "wallet-adapter-button-end-icon"
    }, props.endIcon));
};



var $bnENU = parcelRequire("bnENU");
const $6d6a10cc24129104$export$deff84e7338ee5a5 = ({ wallet: wallet, ...props })=>{
    return wallet && (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("img", {
        src: wallet.adapter.icon,
        alt: `${wallet.adapter.name} icon`,
        ...props
    });
};


const $e15d467fdda2523d$export$b6b33106605f17bb = ({ handleClick: handleClick, tabIndex: tabIndex, wallet: wallet })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("li", null, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $6bbcd052ae56aec7$export$353f5b6fc5456de1), {
        onClick: handleClick,
        startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $6d6a10cc24129104$export$deff84e7338ee5a5), {
            wallet: wallet
        }),
        tabIndex: tabIndex
    }, wallet.adapter.name, wallet.readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed && (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("span", null, "Detected")));
};



var $bnENU = parcelRequire("bnENU");
const $af8a7e2f371d2e4d$export$d822b842d2dccc19 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("svg", {
        width: "97",
        height: "96",
        viewBox: "0 0 97 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "48",
        fill: "url(#paint0_linear_880_5115)",
        fillOpacity: "0.1"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "47",
        stroke: "url(#paint1_linear_880_5115)",
        strokeOpacity: "0.4",
        strokeWidth: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("g", {
        clipPath: "url(#clip0_880_5115)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("path", {
        d: "M65.5769 28.1523H31.4231C27.6057 28.1523 24.5 31.258 24.5 35.0754V60.9215C24.5 64.7389 27.6057 67.8446 31.4231 67.8446H65.5769C69.3943 67.8446 72.5 64.7389 72.5 60.9215V35.0754C72.5 31.258 69.3943 28.1523 65.5769 28.1523ZM69.7308 52.1523H59.5769C57.2865 52.1523 55.4231 50.289 55.4231 47.9985C55.4231 45.708 57.2864 43.8446 59.5769 43.8446H69.7308V52.1523ZM69.7308 41.0754H59.5769C55.7595 41.0754 52.6539 44.1811 52.6539 47.9985C52.6539 51.8159 55.7595 54.9215 59.5769 54.9215H69.7308V60.9215C69.7308 63.2119 67.8674 65.0754 65.5769 65.0754H31.4231C29.1327 65.0754 27.2692 63.212 27.2692 60.9215V35.0754C27.2692 32.785 29.1326 30.9215 31.4231 30.9215H65.5769C67.8673 30.9215 69.7308 32.7849 69.7308 35.0754V41.0754Z",
        fill: "url(#paint2_linear_880_5115)"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("path", {
        d: "M61.4231 46.6172H59.577C58.8123 46.6172 58.1924 47.2371 58.1924 48.0018C58.1924 48.7665 58.8123 49.3863 59.577 49.3863H61.4231C62.1878 49.3863 62.8077 48.7664 62.8077 48.0018C62.8077 47.2371 62.1878 46.6172 61.4231 46.6172Z",
        fill: "url(#paint3_linear_880_5115)"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("linearGradient", {
        id: "paint0_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("linearGradient", {
        id: "paint1_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("linearGradient", {
        id: "paint2_linear_880_5115",
        x1: "25.9583",
        y1: "68.7101",
        x2: "67.2337",
        y2: "23.7879",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("linearGradient", {
        id: "paint3_linear_880_5115",
        x1: "58.3326",
        y1: "49.4467",
        x2: "61.0002",
        y2: "45.4453",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("clipPath", {
        id: "clip0_880_5115"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("rect", {
        width: "48",
        height: "48",
        fill: "white",
        transform: "translate(24.5 24)"
    }))));
};



const $57bc95155ccc0f0e$export$851b8e4aa786e6a1 = ({ className: className = "", container: container = "body" })=>{
    const ref = (0, $bnENU.useRef)(null);
    const { wallets: wallets, select: select } = (0, $a5bd67d4bd834f44$export$c34addee860b0acb)();
    const { setVisible: setVisible } = (0, $5c2e30aa4d09c44d$export$6fdf0454adae214b)();
    const [expanded, setExpanded] = (0, $bnENU.useState)(false);
    const [fadeIn, setFadeIn] = (0, $bnENU.useState)(false);
    const [portal, setPortal] = (0, $bnENU.useState)(null);
    const [listedWallets, collapsedWallets] = (0, $bnENU.useMemo)(()=>{
        const installed = [];
        const notInstalled = [];
        for (const wallet of wallets)if (wallet.readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed) installed.push(wallet);
        else notInstalled.push(wallet);
        return installed.length ? [
            installed,
            notInstalled
        ] : [
            notInstalled,
            []
        ];
    }, [
        wallets
    ]);
    const hideModal = (0, $bnENU.useCallback)(()=>{
        setFadeIn(false);
        setTimeout(()=>setVisible(false), 150);
    }, [
        setVisible
    ]);
    const handleClose = (0, $bnENU.useCallback)((event)=>{
        event.preventDefault();
        hideModal();
    }, [
        hideModal
    ]);
    const handleWalletClick = (0, $bnENU.useCallback)((event, walletName)=>{
        select(walletName);
        handleClose(event);
    }, [
        select,
        handleClose
    ]);
    const handleCollapseClick = (0, $bnENU.useCallback)(()=>setExpanded(!expanded), [
        expanded
    ]);
    const handleTabKey = (0, $bnENU.useCallback)((event)=>{
        const node = ref.current;
        if (!node) return;
        // here we query all focusable elements
        const focusableElements = node.querySelectorAll("button");
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstElement = focusableElements[0];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey) // if going backward by pressing tab and firstElement is active, shift focus to last focusable element
        {
            if (document.activeElement === firstElement) {
                lastElement.focus();
                event.preventDefault();
            }
        } else // if going forward by pressing tab and lastElement is active, shift focus to first focusable element
        if (document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
        }
    }, [
        ref
    ]);
    (0, $bnENU.useLayoutEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") hideModal();
            else if (event.key === "Tab") handleTabKey(event);
        };
        // Get original overflow
        const { overflow: overflow } = window.getComputedStyle(document.body);
        // Hack to enable fade in animation after mount
        setTimeout(()=>setFadeIn(true), 0);
        // Prevent scrolling on mount
        document.body.style.overflow = "hidden";
        // Listen for keydown events
        window.addEventListener("keydown", handleKeyDown, false);
        return ()=>{
            // Re-enable scrolling when component unmounts
            document.body.style.overflow = overflow;
            window.removeEventListener("keydown", handleKeyDown, false);
        };
    }, [
        hideModal,
        handleTabKey
    ]);
    (0, $bnENU.useLayoutEffect)(()=>setPortal(document.querySelector(container)), [
        container
    ]);
    return portal && (0, $93b772b00f04f226$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("div", {
        "aria-labelledby": "wallet-adapter-modal-title",
        "aria-modal": "true",
        className: `wallet-adapter-modal ${fadeIn && "wallet-adapter-modal-fade-in"} ${className}`,
        ref: ref,
        role: "dialog"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("div", {
        className: "wallet-adapter-modal-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("div", {
        className: "wallet-adapter-modal-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("button", {
        onClick: handleClose,
        className: "wallet-adapter-modal-button-close"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("svg", {
        width: "14",
        height: "14"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("path", {
        d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
    }))), listedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "Connect a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, listedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $e15d467fdda2523d$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            wallet: wallet
        })), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $6ce8b5c336997aaf$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, collapsedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $e15d467fdda2523d$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        }))) : null), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("span", null, expanded ? "Less " : "More ", "options"), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${expanded ? "wallet-adapter-modal-list-more-icon-rotate" : ""}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))) : null) : (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "You'll need a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("div", {
        className: "wallet-adapter-modal-middle"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $af8a7e2f371d2e4d$export$d822b842d2dccc19), null)), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("span", null, expanded ? "Hide " : "Already have a wallet? View ", "options"), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${expanded ? "wallet-adapter-modal-list-more-icon-rotate" : ""}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $6ce8b5c336997aaf$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, collapsedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $e15d467fdda2523d$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        }))))) : null))), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("div", {
        className: "wallet-adapter-modal-overlay",
        onMouseDown: handleClose
    })), portal);
};


const $002d503486502648$export$43bb60413a8a3ee6 = ({ children: children, ...props })=>{
    const [visible, setVisible] = (0, $bnENU.useState)(false);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $5c2e30aa4d09c44d$export$8fa8c0fc3ea86e87).Provider, {
        value: {
            visible: visible,
            setVisible: setVisible
        }
    }, children, visible && (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $57bc95155ccc0f0e$export$851b8e4aa786e6a1), {
        ...props
    }));
};


var $bnENU = parcelRequire("bnENU");


var $bnENU = parcelRequire("bnENU");
function $b426ed418fff7637$export$629f18756d2627db({ onSelectWallet: onSelectWallet }) {
    const { connect: connect, connected: connected, connecting: connecting, disconnect: disconnect, disconnecting: disconnecting, publicKey: publicKey, select: select, wallet: wallet, wallets: wallets } = (0, $a5bd67d4bd834f44$export$c34addee860b0acb)();
    let buttonState;
    if (connecting) buttonState = "connecting";
    else if (connected) buttonState = "connected";
    else if (disconnecting) buttonState = "disconnecting";
    else if (wallet) buttonState = "has-wallet";
    else buttonState = "no-wallet";
    const handleConnect = (0, $bnENU.useCallback)(()=>{
        connect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        connect
    ]);
    const handleDisconnect = (0, $bnENU.useCallback)(()=>{
        disconnect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        disconnect
    ]);
    const handleSelectWallet = (0, $bnENU.useCallback)(()=>{
        onSelectWallet({
            onSelectWallet: select,
            wallets: wallets
        });
    }, [
        onSelectWallet,
        select,
        wallets
    ]);
    return {
        buttonState: buttonState,
        onConnect: buttonState === "has-wallet" ? handleConnect : undefined,
        onDisconnect: buttonState !== "disconnecting" && buttonState !== "no-wallet" ? handleDisconnect : undefined,
        onSelectWallet: handleSelectWallet,
        publicKey: publicKey ?? undefined,
        walletIcon: wallet?.adapter.icon,
        walletName: wallet?.adapter.name
    };
}



var $bnENU = parcelRequire("bnENU");

var $bnENU = parcelRequire("bnENU");


function $a8ad04049728c3f3$export$a0d4a8038508425f({ walletIcon: walletIcon, walletName: walletName, ...props }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $6bbcd052ae56aec7$export$353f5b6fc5456de1), {
        ...props,
        className: "wallet-adapter-button-trigger",
        startIcon: walletIcon && walletName ? (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $6d6a10cc24129104$export$deff84e7338ee5a5), {
            wallet: {
                adapter: {
                    icon: walletIcon,
                    name: walletName
                }
            }
        }) : undefined
    });
}



function $20ea65d435bc3f80$export$50382f20865178f9({ children: children, labels: labels, ...props }) {
    const { setVisible: setModalVisible } = (0, $5c2e30aa4d09c44d$export$6fdf0454adae214b)();
    const { buttonState: buttonState, onConnect: onConnect, onDisconnect: onDisconnect, publicKey: publicKey, walletIcon: walletIcon, walletName: walletName } = (0, $b426ed418fff7637$export$629f18756d2627db)({
        onSelectWallet () {
            setModalVisible(true);
        }
    });
    const [copied, setCopied] = (0, $bnENU.useState)(false);
    const [menuOpen, setMenuOpen] = (0, $bnENU.useState)(false);
    const ref = (0, $bnENU.useRef)(null);
    (0, $bnENU.useEffect)(()=>{
        const listener = (event)=>{
            const node = ref.current;
            // Do nothing if clicking dropdown or its descendants
            if (!node || node.contains(event.target)) return;
            setMenuOpen(false);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, []);
    const content = (0, $bnENU.useMemo)(()=>{
        if (children) return children;
        else if (publicKey) {
            const base58 = publicKey.toBase58();
            return base58.slice(0, 4) + ".." + base58.slice(-4);
        } else if (buttonState === "connecting" || buttonState === "has-wallet") return labels[buttonState];
        else return labels["no-wallet"];
    }, [
        buttonState,
        children,
        labels,
        publicKey
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("div", {
        className: "wallet-adapter-dropdown"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $a8ad04049728c3f3$export$a0d4a8038508425f), {
        ...props,
        "aria-expanded": menuOpen,
        style: {
            pointerEvents: menuOpen ? "none" : "auto",
            ...props.style
        },
        onClick: ()=>{
            switch(buttonState){
                case "no-wallet":
                    setModalVisible(true);
                    break;
                case "has-wallet":
                    if (onConnect) onConnect();
                    break;
                case "connected":
                    setMenuOpen(true);
                    break;
            }
        },
        walletIcon: walletIcon,
        walletName: walletName
    }, content), (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("ul", {
        "aria-label": "dropdown-list",
        className: `wallet-adapter-dropdown-list ${menuOpen && "wallet-adapter-dropdown-list-active"}`,
        ref: ref,
        role: "menu"
    }, publicKey ? (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: async ()=>{
            await navigator.clipboard.writeText(publicKey.toBase58());
            setCopied(true);
            setTimeout(()=>setCopied(false), 400);
        },
        role: "menuitem"
    }, copied ? labels["copied"] : labels["copy-address"]) : null, (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: ()=>{
            setModalVisible(true);
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels["change-wallet"]), onDisconnect ? (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: ()=>{
            onDisconnect();
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels["disconnect"]) : null));
}


const $cca717a5b78af885$var$LABELS = {
    "change-wallet": "Change wallet",
    connecting: "Connecting ...",
    "copy-address": "Copy address",
    copied: "Copied",
    disconnect: "Disconnect",
    "has-wallet": "Connect",
    "no-wallet": "Select Wallet"
};
function $cca717a5b78af885$export$968d144f04194cbb(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).createElement((0, $20ea65d435bc3f80$export$50382f20865178f9), {
        ...props,
        labels: $cca717a5b78af885$var$LABELS
    });
}




var $1ZJZa = parcelRequire("1ZJZa");
const $6386cde6f6f9d7f0$export$37766f30d842581a = "Phantom";
class $6386cde6f6f9d7f0$export$a8fff984faa686f6 extends (0, $e93033ae3d6cecb2$export$9db08bcddd106c96) {
    constructor(config = {}){
        super();
        this.name = $6386cde6f6f9d7f0$export$37766f30d842581a;
        this.url = "https://phantom.app";
        this.icon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDgiIGhlaWdodD0iMTA4IiB2aWV3Qm94PSIwIDAgMTA4IDEwOCIgZmlsbD0ibm9uZSI+CjxyZWN0IHdpZHRoPSIxMDgiIGhlaWdodD0iMTA4IiByeD0iMjYiIGZpbGw9IiNBQjlGRjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ni41MjY3IDY5LjkyMjlDNDIuMDA1NCA3Ni44NTA5IDM0LjQyOTIgODUuNjE4MiAyNC4zNDggODUuNjE4MkMxOS41ODI0IDg1LjYxODIgMTUgODMuNjU2MyAxNSA3NS4xMzQyQzE1IDUzLjQzMDUgNDQuNjMyNiAxOS44MzI3IDcyLjEyNjggMTkuODMyN0M4Ny43NjggMTkuODMyNyA5NCAzMC42ODQ2IDk0IDQzLjAwNzlDOTQgNTguODI1OCA4My43MzU1IDc2LjkxMjIgNzMuNTMyMSA3Ni45MTIyQzcwLjI5MzkgNzYuOTEyMiA2OC43MDUzIDc1LjEzNDIgNjguNzA1MyA3Mi4zMTRDNjguNzA1MyA3MS41NzgzIDY4LjgyNzUgNzAuNzgxMiA2OS4wNzE5IDY5LjkyMjlDNjUuNTg5MyA3NS44Njk5IDU4Ljg2ODUgODEuMzg3OCA1Mi41NzU0IDgxLjM4NzhDNDcuOTkzIDgxLjM4NzggNDUuNjcxMyA3OC41MDYzIDQ1LjY3MTMgNzQuNDU5OEM0NS42NzEzIDcyLjk4ODQgNDUuOTc2OCA3MS40NTU2IDQ2LjUyNjcgNjkuOTIyOVpNODMuNjc2MSA0Mi41Nzk0QzgzLjY3NjEgNDYuMTcwNCA4MS41NTc1IDQ3Ljk2NTggNzkuMTg3NSA0Ny45NjU4Qzc2Ljc4MTYgNDcuOTY1OCA3NC42OTg5IDQ2LjE3MDQgNzQuNjk4OSA0Mi41Nzk0Qzc0LjY5ODkgMzguOTg4NSA3Ni43ODE2IDM3LjE5MzEgNzkuMTg3NSAzNy4xOTMxQzgxLjU1NzUgMzcuMTkzMSA4My42NzYxIDM4Ljk4ODUgODMuNjc2MSA0Mi41Nzk0Wk03MC4yMTAzIDQyLjU3OTVDNzAuMjEwMyA0Ni4xNzA0IDY4LjA5MTYgNDcuOTY1OCA2NS43MjE2IDQ3Ljk2NThDNjMuMzE1NyA0Ny45NjU4IDYxLjIzMyA0Ni4xNzA0IDYxLjIzMyA0Mi41Nzk1QzYxLjIzMyAzOC45ODg1IDYzLjMxNTcgMzcuMTkzMSA2NS43MjE2IDM3LjE5MzFDNjguMDkxNiAzNy4xOTMxIDcwLjIxMDMgMzguOTg4NSA3MC4yMTAzIDQyLjU3OTVaIiBmaWxsPSIjRkZGREY4Ii8+Cjwvc3ZnPg==";
        this.supportedTransactionVersions = new Set([
            "legacy",
            0
        ]);
        this._readyState = typeof window === "undefined" || typeof document === "undefined" ? (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported : (0, $e820e806547f33d2$export$2a7b8071105d05b6).NotDetected;
        this._disconnected = ()=>{
            const wallet = this._wallet;
            if (wallet) {
                wallet.off("disconnect", this._disconnected);
                wallet.off("accountChanged", this._accountChanged);
                this._wallet = null;
                this._publicKey = null;
                this.emit("error", new (0, $a800e3a804b49fac$export$bf7028c52ebda81e)());
                this.emit("disconnect");
            }
        };
        this._accountChanged = (newPublicKey)=>{
            const publicKey = this._publicKey;
            if (!publicKey) return;
            try {
                newPublicKey = new (0, $1ZJZa.PublicKey)(newPublicKey.toBytes());
            } catch (error) {
                this.emit("error", new (0, $a800e3a804b49fac$export$735bef3bfb0f2c86)(error?.message, error));
                return;
            }
            if (publicKey.equals(newPublicKey)) return;
            this._publicKey = newPublicKey;
            this.emit("connect", newPublicKey);
        };
        this._connecting = false;
        this._wallet = null;
        this._publicKey = null;
        if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported) {
            if ((0, $e820e806547f33d2$export$bf89b558d1e273a2)()) {
                // when in iOS (not webview), set Phantom as loadable instead of checking for install
                this._readyState = (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable;
                this.emit("readyStateChange", this._readyState);
            } else (0, $e820e806547f33d2$export$378bae4c88e0b46e)(()=>{
                if (window.phantom?.solana?.isPhantom || window.solana?.isPhantom) {
                    this._readyState = (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed;
                    this.emit("readyStateChange", this._readyState);
                    return true;
                }
                return false;
            });
        }
    }
    get publicKey() {
        return this._publicKey;
    }
    get connecting() {
        return this._connecting;
    }
    get readyState() {
        return this._readyState;
    }
    async autoConnect() {
        // Skip autoconnect in the Loadable state
        // We can't redirect to a universal link without user input
        if (this.readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed) await this.connect();
    }
    async connect() {
        try {
            if (this.connected || this.connecting) return;
            if (this.readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable) {
                // redirect to the Phantom /browse universal link
                // this will open the current URL in the Phantom in-wallet browser
                const url = encodeURIComponent(window.location.href);
                const ref = encodeURIComponent(window.location.origin);
                window.location.href = `https://phantom.app/ul/browse/${url}?ref=${ref}`;
                return;
            }
            if (this.readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed) throw new (0, $a800e3a804b49fac$export$d65db264eda99cd7)();
            this._connecting = true;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const wallet = window.phantom?.solana || window.solana;
            if (!wallet.isConnected) try {
                await wallet.connect();
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(error?.message, error);
            }
            if (!wallet.publicKey) throw new (0, $a800e3a804b49fac$export$cd6fa2f8e2a8a612)();
            let publicKey;
            try {
                publicKey = new (0, $1ZJZa.PublicKey)(wallet.publicKey.toBytes());
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$735bef3bfb0f2c86)(error?.message, error);
            }
            wallet.on("disconnect", this._disconnected);
            wallet.on("accountChanged", this._accountChanged);
            this._wallet = wallet;
            this._publicKey = publicKey;
            this.emit("connect", publicKey);
        } catch (error) {
            this.emit("error", error);
            throw error;
        } finally{
            this._connecting = false;
        }
    }
    async disconnect() {
        const wallet = this._wallet;
        if (wallet) {
            wallet.off("disconnect", this._disconnected);
            wallet.off("accountChanged", this._accountChanged);
            this._wallet = null;
            this._publicKey = null;
            try {
                await wallet.disconnect();
            } catch (error) {
                this.emit("error", new (0, $a800e3a804b49fac$export$92e2b26fad5723ee)(error?.message, error));
            }
        }
        this.emit("disconnect");
    }
    async sendTransaction(transaction, connection, options = {}) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            try {
                const { signers: signers, ...sendOptions } = options;
                if ((0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(transaction)) signers?.length && transaction.sign(signers);
                else {
                    transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                    signers?.length && transaction.partialSign(...signers);
                }
                sendOptions.preflightCommitment = sendOptions.preflightCommitment || connection.commitment;
                const { signature: signature } = await wallet.signAndSendTransaction(transaction, sendOptions);
                return signature;
            } catch (error) {
                if (error instanceof (0, $a800e3a804b49fac$export$f46ec6f9dba8711d)) throw error;
                throw new (0, $a800e3a804b49fac$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
    async signTransaction(transaction) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            try {
                return await wallet.signTransaction(transaction) || transaction;
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$96f177062fdd8180)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
    async signAllTransactions(transactions) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            try {
                return await wallet.signAllTransactions(transactions) || transactions;
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$96f177062fdd8180)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
    async signMessage(message) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            try {
                const { signature: signature } = await wallet.signMessage(message);
                return signature;
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$2622c1721bbd4b17)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
}




var $1ZJZa = parcelRequire("1ZJZa");
var $c098c0ae6d17e1ec$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c098c0ae6d17e1ec$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $c098c0ae6d17e1ec$var$_RegisterWalletEvent_detail;
function $c098c0ae6d17e1ec$export$ecffa18c0543eceb(wallet) {
    const callback = ({ register: register })=>register(wallet);
    try {
        window.dispatchEvent(new $c098c0ae6d17e1ec$var$RegisterWalletEvent(callback));
    } catch (error) {
        console.error("wallet-standard:register-wallet event could not be dispatched\n", error);
    }
    try {
        window.addEventListener("wallet-standard:app-ready", ({ detail: api })=>callback(api));
    } catch (error) {
        console.error("wallet-standard:app-ready event listener could not be added\n", error);
    }
}
class $c098c0ae6d17e1ec$var$RegisterWalletEvent extends Event {
    get detail() {
        return $c098c0ae6d17e1ec$var$__classPrivateFieldGet(this, $c098c0ae6d17e1ec$var$_RegisterWalletEvent_detail, "f");
    }
    get type() {
        return "wallet-standard:register-wallet";
    }
    constructor(callback){
        super("wallet-standard:register-wallet", {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $c098c0ae6d17e1ec$var$_RegisterWalletEvent_detail.set(this, void 0);
        $c098c0ae6d17e1ec$var$__classPrivateFieldSet(this, $c098c0ae6d17e1ec$var$_RegisterWalletEvent_detail, callback, "f");
    }
    /** @deprecated */ preventDefault() {
        throw new Error("preventDefault cannot be called");
    }
    /** @deprecated */ stopImmediatePropagation() {
        throw new Error("stopImmediatePropagation cannot be called");
    }
    /** @deprecated */ stopPropagation() {
        throw new Error("stopPropagation cannot be called");
    }
}
$c098c0ae6d17e1ec$var$_RegisterWalletEvent_detail = new WeakMap();
function $c098c0ae6d17e1ec$export$2dd0e8edbdeb04ec(wallet) {
    var _a;
    $c098c0ae6d17e1ec$export$ecffa18c0543eceb(wallet);
    try {
        ((_a = window.navigator).wallets || (_a.wallets = [])).push(({ register: register })=>register(wallet));
    } catch (error) {
        console.error("window.navigator.wallets could not be pushed\n", error);
    }
}





var $4bt7m = parcelRequire("4bt7m");
var $5sd65 = parcelRequire("5sd65");
var $840Oq = parcelRequire("840Oq");

/** @internal */ const $fe86903b5f02453a$export$1ca1ec8b29a4ce27 = "data:image/svg+xml;base64,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";


var $ca51160b3b5041f0$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $ca51160b3b5041f0$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_instances, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_listeners, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_version, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_name, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_icon, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_on, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_emit, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_off, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_connect, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_disconnect, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signAndSendTransaction, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signTransaction, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signMessage;

class $ca51160b3b5041f0$export$b9711d1b27bbdcc {
    constructor(){
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_instances.add(this);
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_listeners.set(this, {});
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_version.set(this, "1.0.0");
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_name.set(this, "MetaMask");
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_icon.set(this, (0, $fe86903b5f02453a$export$1ca1ec8b29a4ce27));
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask.set(this, null);
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_on.set(this, (event, listener)=>{
            $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_listeners, "f")[event]?.push(listener) || ($ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_listeners, "f")[event] = [
                listener
            ]);
            return ()=>$ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_instances, "m", $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_off).call(this, event, listener);
        });
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_connect.set(this, async ()=>{
            if (!$ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) {
                let SolflareMetaMaskClass;
                try {
                    SolflareMetaMaskClass = (await (parcelRequire("infFV"))).default;
                } catch (error) {
                    throw new Error("Unable to load Solflare MetaMask SDK");
                }
                $ca51160b3b5041f0$var$__classPrivateFieldSet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, new SolflareMetaMaskClass(), "f");
                $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").on("standard_change", (properties)=>$ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_instances, "m", $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_emit).call(this, "change", properties));
            }
            if (!this.accounts.length) await $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").connect();
            return {
                accounts: this.accounts
            };
        });
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_disconnect.set(this, async ()=>{
            if (!$ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) return;
            await $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").disconnect();
        });
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signAndSendTransaction.set(this, async (...inputs)=>{
            if (!$ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            return await $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").standardSignAndSendTransaction(...inputs);
        });
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signTransaction.set(this, async (...inputs)=>{
            if (!$ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            return await $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").standardSignTransaction(...inputs);
        });
        $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signMessage.set(this, async (...inputs)=>{
            if (!$ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f")) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            return await $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").standardSignMessage(...inputs);
        });
    }
    get version() {
        return $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_version, "f");
    }
    get name() {
        return $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_name, "f");
    }
    get icon() {
        return $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_icon, "f");
    }
    get chains() {
        return [
            (0, $e0f5a63cd5840de2$export$bba9a228295b3963),
            (0, $e0f5a63cd5840de2$export$654cc095bd2e650),
            (0, $e0f5a63cd5840de2$export$76575b7bf4de1f40)
        ];
    }
    get features() {
        return {
            [(0, $21c6ff693543ac7b$export$cc68487eeb93b1d4)]: {
                version: "1.0.0",
                connect: $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_connect, "f")
            },
            [(0, $7012ebc3e37cd89f$export$38dbd4bbb9b696e6)]: {
                version: "1.0.0",
                disconnect: $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_disconnect, "f")
            },
            [(0, $81b0a26bfbf4e734$export$5296443ca9e9fa0f)]: {
                version: "1.0.0",
                on: $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_on, "f")
            },
            [(0, $4bt7m.SolanaSignAndSendTransaction)]: {
                version: "1.0.0",
                supportedTransactionVersions: [
                    "legacy",
                    0
                ],
                signAndSendTransaction: $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signAndSendTransaction, "f")
            },
            [(0, $840Oq.SolanaSignTransaction)]: {
                version: "1.0.0",
                supportedTransactionVersions: [
                    "legacy",
                    0
                ],
                signTransaction: $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signTransaction, "f")
            },
            [(0, $5sd65.SolanaSignMessage)]: {
                version: "1.0.0",
                signMessage: $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signMessage, "f")
            }
        };
    }
    get accounts() {
        return $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f") ? $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask, "f").standardAccounts : [];
    }
}
$ca51160b3b5041f0$var$_SolflareMetaMaskWallet_listeners = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_version = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_name = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_icon = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_solflareMetaMask = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_on = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_connect = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_disconnect = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signAndSendTransaction = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signTransaction = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_signMessage = new WeakMap(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_instances = new WeakSet(), $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_emit = function _SolflareMetaMaskWallet_emit(event, ...args) {
    // eslint-disable-next-line prefer-spread
    $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_listeners, "f")[event]?.forEach((listener)=>listener.apply(null, args));
}, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_off = function _SolflareMetaMaskWallet_off(event, listener) {
    $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_listeners, "f")[event] = $ca51160b3b5041f0$var$__classPrivateFieldGet(this, $ca51160b3b5041f0$var$_SolflareMetaMaskWallet_listeners, "f")[event]?.filter((existingListener)=>listener !== existingListener);
};


let $3e732dbef4aefd80$var$registered = false;
function $3e732dbef4aefd80$var$register() {
    if ($3e732dbef4aefd80$var$registered) return;
    (0, $c098c0ae6d17e1ec$export$ecffa18c0543eceb)(new (0, $ca51160b3b5041f0$export$b9711d1b27bbdcc)());
    $3e732dbef4aefd80$var$registered = true;
}
async function $3e732dbef4aefd80$export$2dd247ebd3228ce5() {
    const id = "solflare-detect-metamask";
    function postMessage() {
        window.postMessage({
            target: "metamask-contentscript",
            data: {
                name: "metamask-provider",
                data: {
                    id: id,
                    jsonrpc: "2.0",
                    method: "wallet_getSnaps"
                }
            }
        }, window.location.origin);
    }
    function onMessage(event) {
        const message = event.data;
        if (message?.target === "metamask-inpage" && message.data?.name === "metamask-provider") {
            if (message.data.data?.id === id) {
                window.removeEventListener("message", onMessage);
                if (!message.data.data.error) $3e732dbef4aefd80$var$register();
            } else postMessage();
        }
    }
    window.addEventListener("message", onMessage);
    window.setTimeout(()=>window.removeEventListener("message", onMessage), 5000);
    postMessage();
}


const $97214e8223c1fbed$export$588524c4690a874f = "Solflare";

class $97214e8223c1fbed$export$9fd69c70c5f8b9b4 extends (0, $e93033ae3d6cecb2$export$9db08bcddd106c96) {
    constructor(config = {}){
        super();
        this.name = $97214e8223c1fbed$export$588524c4690a874f;
        this.url = "https://solflare.com";
        this.icon = "data:image/svg+xml;base64,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";
        this.supportedTransactionVersions = new Set([
            "legacy",
            0
        ]);
        this._readyState = typeof window === "undefined" || typeof document === "undefined" ? (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported : (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable;
        this._disconnected = ()=>{
            const wallet = this._wallet;
            if (wallet) {
                wallet.off("disconnect", this._disconnected);
                this._wallet = null;
                this._publicKey = null;
                this.emit("error", new (0, $a800e3a804b49fac$export$bf7028c52ebda81e)());
                this.emit("disconnect");
            }
        };
        this._accountChanged = (newPublicKey)=>{
            if (!newPublicKey) return;
            const publicKey = this._publicKey;
            if (!publicKey) return;
            try {
                newPublicKey = new (0, $1ZJZa.PublicKey)(newPublicKey.toBytes());
            } catch (error) {
                this.emit("error", new (0, $a800e3a804b49fac$export$735bef3bfb0f2c86)(error?.message, error));
                return;
            }
            if (publicKey.equals(newPublicKey)) return;
            this._publicKey = newPublicKey;
            this.emit("connect", newPublicKey);
        };
        this._connecting = false;
        this._publicKey = null;
        this._wallet = null;
        this._config = config;
        if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Unsupported) {
            (0, $e820e806547f33d2$export$378bae4c88e0b46e)(()=>{
                if (window.solflare?.isSolflare || window.SolflareApp) {
                    this._readyState = (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed;
                    this.emit("readyStateChange", this._readyState);
                    return true;
                }
                return false;
            });
            (0, $3e732dbef4aefd80$export$2dd247ebd3228ce5)();
        }
    }
    get publicKey() {
        return this._publicKey;
    }
    get connecting() {
        return this._connecting;
    }
    get connected() {
        return !!this._wallet?.connected;
    }
    get readyState() {
        return this._readyState;
    }
    async autoConnect() {
        // Skip autoconnect in the Loadable state on iOS
        // We can't redirect to a universal link without user input
        if (!(this.readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable && (0, $e820e806547f33d2$export$bf89b558d1e273a2)())) await this.connect();
    }
    async connect() {
        try {
            if (this.connected || this.connecting) return;
            if (this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable && this._readyState !== (0, $e820e806547f33d2$export$2a7b8071105d05b6).Installed) throw new (0, $a800e3a804b49fac$export$d65db264eda99cd7)();
            // redirect to the Solflare /browse universal link
            // this will open the current URL in the Solflare in-wallet browser
            if (this.readyState === (0, $e820e806547f33d2$export$2a7b8071105d05b6).Loadable && (0, $e820e806547f33d2$export$bf89b558d1e273a2)()) {
                const url = encodeURIComponent(window.location.href);
                const ref = encodeURIComponent(window.location.origin);
                window.location.href = `https://solflare.com/ul/v1/browse/${url}?ref=${ref}`;
                return;
            }
            let SolflareClass;
            try {
                SolflareClass = (await (parcelRequire("eEFR0"))).default;
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$9a551f94af9b0bf8)(error?.message, error);
            }
            let wallet;
            try {
                wallet = new SolflareClass({
                    network: this._config.network
                });
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$9525019988612a5e)(error?.message, error);
            }
            this._connecting = true;
            if (!wallet.connected) try {
                await wallet.connect();
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)(error?.message, error);
            }
            if (!wallet.publicKey) throw new (0, $a800e3a804b49fac$export$38f21f1c810261c7)();
            let publicKey;
            try {
                publicKey = new (0, $1ZJZa.PublicKey)(wallet.publicKey.toBytes());
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$735bef3bfb0f2c86)(error?.message, error);
            }
            wallet.on("disconnect", this._disconnected);
            wallet.on("accountChanged", this._accountChanged);
            this._wallet = wallet;
            this._publicKey = publicKey;
            this.emit("connect", publicKey);
        } catch (error) {
            this.emit("error", error);
            throw error;
        } finally{
            this._connecting = false;
        }
    }
    async disconnect() {
        const wallet = this._wallet;
        if (wallet) {
            wallet.off("disconnect", this._disconnected);
            wallet.off("accountChanged", this._accountChanged);
            this._wallet = null;
            this._publicKey = null;
            try {
                await wallet.disconnect();
            } catch (error) {
                this.emit("error", new (0, $a800e3a804b49fac$export$92e2b26fad5723ee)(error?.message, error));
            }
        }
        this.emit("disconnect");
    }
    async sendTransaction(transaction, connection, options = {}) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            try {
                const { signers: signers, ...sendOptions } = options;
                if ((0, $5f36b6a60c860fd2$export$37ce1cc82e255d8)(transaction)) signers?.length && transaction.sign(signers);
                else {
                    transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                    signers?.length && transaction.partialSign(...signers);
                }
                sendOptions.preflightCommitment = sendOptions.preflightCommitment || connection.commitment;
                return await wallet.signAndSendTransaction(transaction, sendOptions);
            } catch (error) {
                if (error instanceof (0, $a800e3a804b49fac$export$f46ec6f9dba8711d)) throw error;
                throw new (0, $a800e3a804b49fac$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
    async signTransaction(transaction) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            try {
                return await wallet.signTransaction(transaction) || transaction;
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$96f177062fdd8180)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
    async signAllTransactions(transactions) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            try {
                return await wallet.signAllTransactions(transactions) || transactions;
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$96f177062fdd8180)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
    async signMessage(message) {
        try {
            const wallet = this._wallet;
            if (!wallet) throw new (0, $a800e3a804b49fac$export$313d299817c74896)();
            try {
                return await wallet.signMessage(message, "utf8");
            } catch (error) {
                throw new (0, $a800e3a804b49fac$export$2622c1721bbd4b17)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
}



const $ad5727fe9615d0d0$var$ConnectedWalletContainer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  box-shadow: 0 0 3px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  border-radius: 5px;
`;
function $ad5727fe9615d0d0$var$endpointUrl(cluster) {
    if (cluster === "devnet") return "https://api.devnet.solana.com";
    return "https://api.radom.com/solana";
}
function $ad5727fe9615d0d0$var$maxBigInt(a, b) {
    return a > b ? a : b;
}
const $ad5727fe9615d0d0$var$SolanaWalletInner = (props)=>{
    const { connect: connect, connected: connected, disconnect: solanaDisconnect, sendTransaction: sendTransaction, publicKey: publicKey, select: select, wallet: wallet, wallets: wallets } = (0, $a5bd67d4bd834f44$export$c34addee860b0acb)();
    const { connection: connection } = (0, $bcafec560369c8f2$export$985e8768c0e91dbc)();
    (0, $bnENU.useEffect)(()=>{
        if (wallet && !connected && !(0, $0f1056e7829df92e$exports.isMobile)) connect();
    }, []);
    const [isSolanaWalletModalVisible, setIsSolanaWalletModalVisible] = (0, $bnENU.useState)(false);
    (0, $bnENU.useEffect)(()=>{
        if (wallet && !(0, $0f1056e7829df92e$exports.isMobile)) connect();
    }, [
        wallet
    ]);
    const { isLoading: isLoading, setIsLoading: setIsLoading, managedPaymentDetails: managedPaymentDetails } = props;
    const onClick = async ()=>{
        if (!publicKey) return;
        setIsLoading(true);
        try {
            let transaction;
            const { value: { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight }, context: { slot: minContextSlot } } = await connection.getLatestBlockhashAndContext();
            if (managedPaymentDetails.token) {
                const tokenAddress = await $fd17f660d934a42c$export$d776e5c4182d21cc(new (0, $1ZJZa.PublicKey)(managedPaymentDetails.token), new (0, $1ZJZa.PublicKey)(managedPaymentDetails.paymentAddress));
                const fromTokenAddress = await $fd17f660d934a42c$export$d776e5c4182d21cc(new (0, $1ZJZa.PublicKey)(managedPaymentDetails.token), publicKey);
                const method = (0, $5760199798158999$export$8793fab959da70d1)(managedPaymentDetails.network, managedPaymentDetails.token);
                transaction = new (0, $1ZJZa.Transaction)({
                    blockhash: blockhash,
                    lastValidBlockHeight: lastValidBlockHeight,
                    feePayer: publicKey
                }).add($a827b1d0ace42dfe$export$b66dd1dc00a3bc28(publicKey, new (0, $1ZJZa.PublicKey)(tokenAddress), new (0, $1ZJZa.PublicKey)(managedPaymentDetails.paymentAddress), new (0, $1ZJZa.PublicKey)(managedPaymentDetails.token))).add($1506a18501f744dc$export$b274d5cebe357db9(fromTokenAddress, tokenAddress, publicKey, (0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(managedPaymentDetails.amount, method.tokenInfo?.decimals ?? 9)));
            } else {
                const minimumAmount = BigInt(await connection.getMinimumBalanceForRentExemption(0));
                transaction = new (0, $1ZJZa.Transaction)({
                    blockhash: blockhash,
                    lastValidBlockHeight: lastValidBlockHeight,
                    feePayer: publicKey
                }).add((0, $1ZJZa.SystemProgram).transfer({
                    fromPubkey: publicKey,
                    toPubkey: new (0, $1ZJZa.PublicKey)(managedPaymentDetails.paymentAddress),
                    lamports: $ad5727fe9615d0d0$var$maxBigInt((0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(managedPaymentDetails.amount, 9), minimumAmount)
                }));
            }
            const signature = await sendTransaction(transaction, connection, {
                preflightCommitment: "processed",
                minContextSlot: minContextSlot
            });
            await connection.confirmTransaction({
                blockhash: blockhash,
                lastValidBlockHeight: lastValidBlockHeight,
                signature: signature
            });
        } catch (err) {
            console.error("Failed", err);
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
        children: [
            wallet?.adapter.publicKey && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                children: [
                    props.presaleStyling && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    color: props.presaleStyling.darkTextColor,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            textTransform: "uppercase",
                                            fontSize: 10
                                        },
                                        children: "Connected wallet"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        children: (0, $8d017118df5fe2e5$export$193698062786be9a)(wallet.adapter.publicKey.toString(), 10)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                disabled: isLoading,
                                onClick: async ()=>await solanaDisconnect(),
                                style: {
                                    padding: 0,
                                    border: 0,
                                    color: props.presaleStyling.titleTextColor,
                                    textTransform: "uppercase",
                                    fontSize: 10
                                },
                                children: "Disconnect"
                            })
                        ]
                    }),
                    !props.presaleStyling && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($ad5727fe9615d0d0$var$ConnectedWalletContainer, {
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                borderRadius: 5
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: 15,
                                        backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                fontSize: 14
                                            },
                                            children: "Connected wallet"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                            style: {
                                                border: 0,
                                                padding: 0,
                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                fontSize: 10,
                                                textTransform: "uppercase"
                                            },
                                            onClick: async ()=>await solanaDisconnect(),
                                            children: "Disconnect"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        padding: 15
                                    },
                                    children: wallet.adapter.publicKey.toString()
                                })
                            ]
                        })
                    })
                ]
            }),
            wallet?.adapter.publicKey ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                isLoading: isLoading,
                onClick: ()=>{
                    onClick();
                },
                style: {
                    width: "100%",
                    background: props.primaryButtonColor,
                    color: props.presaleStyling?.buttonTextColor
                },
                children: "Open wallet"
            }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $cca717a5b78af885$export$968d144f04194cbb), {
                style: {
                    width: "100%",
                    backgroundColor: "black",
                    background: props.primaryButtonColor,
                    color: props.presaleStyling?.buttonTextColor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    fontWeight: 400,
                    borderRadius: 30
                }
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $91a7bca2e0a02780$export$2e2bcd8739ae039), {
                onClose: ()=>setIsSolanaWalletModalVisible(!isSolanaWalletModalVisible),
                visible: isSolanaWalletModalVisible,
                innerStyles: {
                    width: 350
                },
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        padding: 20,
                        gap: 10,
                        fontSize: 14
                    },
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                            style: {
                                marginBottom: 10
                            },
                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                style: {
                                    fontSize: 16,
                                    fontWeight: 500
                                },
                                children: "Select wallet"
                            })
                        }),
                        wallets.length <= 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                padding: "30px 0",
                                gap: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        fontSize: 14
                                    },
                                    children: "No wallet found."
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "Please install a Solana compatible wallet."
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "Please open the app within Phantom or Solflare."
                                })
                            ]
                        }),
                        wallets.map((w, i)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                onClick: async ()=>{
                                    if (0, $0f1056e7829df92e$exports.isMobile) {
                                        await connect();
                                        setIsSolanaWalletModalVisible(false);
                                    } else {
                                        select(w.adapter.name);
                                        setIsSolanaWalletModalVisible(false);
                                    }
                                },
                                style: {
                                    backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED,
                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 15,
                                        justifyContent: "flex-start",
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                width: 20,
                                                height: 20,
                                                backgroundImage: `url(${w.adapter.icon})`,
                                                backgroundSize: "contain",
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: "center center"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            children: w.adapter.name
                                        })
                                    ]
                                })
                            }, i))
                    ]
                })
            })
        ]
    });
};
const $ad5727fe9615d0d0$var$SolanaWallet = (props)=>{
    const endpoint = $ad5727fe9615d0d0$var$endpointUrl(props.managedPaymentDetails.network === "Solana" ? "mainnet" : "devnet");
    const wallets = (0, $bnENU.useMemo)(()=>[
            new (0, $6386cde6f6f9d7f0$export$a8fff984faa686f6)(),
            new (0, $97214e8223c1fbed$export$9fd69c70c5f8b9b4)()
        ], []);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $14e1a0a2b357406b$export$fd685cf7c99624bd), {
        endpoint: endpoint,
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132d3e8c6c6b1529$export$717b22fc3a2082b3), {
            wallets: wallets,
            autoConnect: true,
            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $002d503486502648$export$43bb60413a8a3ee6), {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($ad5727fe9615d0d0$var$SolanaWalletInner, {
                    ...props
                })
            })
        })
    });
};
var $ad5727fe9615d0d0$export$2e2bcd8739ae039 = $ad5727fe9615d0d0$var$SolanaWallet;





var $bnENU = parcelRequire("bnENU");


parcelRequire("bnENU");


var $bnENU = parcelRequire("bnENU");






const $4e36cf643347ef05$var$DropdownListItem = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  cursor: pointer;

  :hover {
    background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST};
  }
`;
const $4e36cf643347ef05$var$DropdownSelectedItem = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  border-radius: 5px;
  gap: 10px;
  background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST};
  padding: 8px;
`;
const $4e36cf643347ef05$var$DropdownPlaceholder = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  padding: 20px;
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER};
`;
// ---------------------------------------------------------------------------------------------------------------------
const $4e36cf643347ef05$var$SearchMultiselect = (props)=>{
    const [query, setQuery] = (0, $bnENU.useState)("");
    const [highlightedIndex, setHighlightedIndex] = (0, $bnENU.useState)(-1);
    const dropdownRef = (0, $bnENU.useRef)(null);
    const queryInputRef = (0, $bnENU.useRef)(null);
    const listboxIdRef = (0, $bnENU.useRef)(`search-list-${Math.random().toString(36).slice(2, 9)}`);
    const setDropdown = (open)=>dropdownRef.current?.toggleDropdown(open);
    const focusQueryInput = ()=>{
        queryInputRef.current?.focus();
        if (typeof window !== "undefined") window.requestAnimationFrame(()=>queryInputRef.current?.focus());
        setTimeout(()=>queryInputRef.current?.focus(), 20);
    };
    const itemSearchFilter = (item)=>{
        const probe = props.keyExtractor(item).toLowerCase();
        return !props.selectedItems.find((i)=>props.keyExtractor(i).toLowerCase() === probe) && (query === "" || probe.includes(query.toLowerCase()));
    };
    const dropdownItems = (0, $bnENU.useMemo)(()=>props.itemArray.filter(itemSearchFilter), [
        props.itemArray,
        props.selectedItems,
        query
    ]);
    const onQueryChange = (e)=>{
        const val = e.target.value;
        if (val !== "") setDropdown(true);
        setQuery(val);
        setHighlightedIndex(0);
    };
    (0, $bnENU.useEffect)(()=>{
        setHighlightedIndex((currentIndex)=>{
            if (dropdownItems.length === 0) return -1;
            if (currentIndex < 0) return 0;
            if (currentIndex >= dropdownItems.length) return dropdownItems.length - 1;
            return currentIndex;
        });
    }, [
        dropdownItems.length
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (highlightedIndex < 0) return;
        const activeItemId = `${listboxIdRef.current}-${highlightedIndex}`;
        document.getElementById(activeItemId)?.scrollIntoView({
            block: "nearest"
        });
    }, [
        highlightedIndex
    ]);
    const onItemSelect = (e, item)=>{
        e.preventDefault();
        e.stopPropagation();
        setQuery("");
        setDropdown(false);
        setHighlightedIndex(-1);
        if (props.isSingleSelect) props.setSelectedItems([
            item
        ]);
        else props.setSelectedItems([
            ...props.selectedItems,
            item
        ]);
    };
    const onItemDelete = (e, item)=>{
        e.preventDefault();
        e.stopPropagation();
        props.setSelectedItems(props.selectedItems.filter((c)=>props.keyExtractor(c) !== props.keyExtractor(item)));
    };
    const onClickDropdown = ()=>focusQueryInput();
    const onDropdownWrapperKeyDown = (e)=>{
        if (e.currentTarget !== e.target) return;
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        if (e.key.length === 1) {
            e.preventDefault();
            setDropdown(true);
            setQuery((prev)=>`${prev}${e.key}`);
            setHighlightedIndex(0);
            focusQueryInput();
            return;
        }
        if (e.key === "Backspace" && query.length > 0) {
            e.preventDefault();
            setDropdown(true);
            setQuery((prev)=>prev.slice(0, -1));
            setHighlightedIndex(0);
            focusQueryInput();
        }
    };
    const onQueryKeyDown = (e)=>{
        if (!dropdownItems.length) {
            if (e.key === "Escape") setDropdown(false);
            if (e.key === "Tab") setDropdown(false);
            return;
        }
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setDropdown(true);
            setHighlightedIndex((prev)=>(prev + 1) % dropdownItems.length);
            return;
        }
        if (e.key === "ArrowUp") {
            e.preventDefault();
            setDropdown(true);
            setHighlightedIndex((prev)=>prev <= 0 ? dropdownItems.length - 1 : prev - 1);
            return;
        }
        if (e.key === "Enter") {
            const item = dropdownItems[highlightedIndex >= 0 ? highlightedIndex : 0];
            if (item) onItemSelect(e, item);
            return;
        }
        if (e.key === "Escape") {
            setDropdown(false);
            setHighlightedIndex(-1);
            return;
        }
        if (e.key === "Tab") {
            setDropdown(false);
            setHighlightedIndex(-1);
        }
    };
    // -------------------------------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            fontSize: 14
        },
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $3de4cfeabec36e0d$export$2e2bcd8739ae039), {
            ref: dropdownRef,
            onClick: onClickDropdown,
            onKeyDown: onDropdownWrapperKeyDown,
            openOnFocus: true,
            disabled: props.disabled,
            outerStyle: props.innerStyle,
            dropdownMaxHeight: props.dropdownMaxHeight ?? 320,
            // Format zero or more selected items
            selectedContent: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                style: {
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 8
                },
                children: [
                    props.isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {}),
                    (props.selectedItems.length === 0 || props.hideSelectedContent) && !props.isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                        style: {
                            opacity: 0.5
                        },
                        children: props.placeholder ?? "Select items"
                    }),
                    props.selectedItems.length > 0 && !props.hideSelectedContent && !props.isLoading && props.selectedItems.map((item, i)=>props.isSingleSelect ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                            style: {
                                display: "flex"
                            },
                            children: props.labelExtractor(item)
                        }, i) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4e36cf643347ef05$var$DropdownSelectedItem, {
                            children: [
                                props.labelExtractor(item),
                                !props.disabled && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$c25acd513dcc8062), {
                                    style: {
                                        padding: 5
                                    },
                                    onClick: (e)=>onItemDelete(e, item),
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $604fb7faec27af0d$export$2e2bcd8739ae039), {
                                        style: {
                                            width: 10,
                                            pointerEvents: "none"
                                        }
                                    })
                                })
                            ]
                        }, i))
                ]
            }),
            // Format list items
            dropdownContent: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            position: "sticky",
                            top: 0,
                            background: "white",
                            zIndex: 1,
                            boxShadow: `0 0 5px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $3de4cfeabec36e0d$export$5d302286c68f338), {
                                style: {
                                    borderBottom: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $3de4cfeabec36e0d$export$fe2cc6a6c0693b4a), {
                                        ref: queryInputRef,
                                        type: "text",
                                        autoComplete: "off",
                                        value: query,
                                        onChange: onQueryChange,
                                        onKeyDown: onQueryKeyDown,
                                        onFocus: ()=>{
                                            setDropdown(true);
                                            focusQueryInput();
                                        },
                                        placeholder: "Search...",
                                        role: "combobox",
                                        "aria-autocomplete": "list",
                                        "aria-controls": listboxIdRef.current,
                                        "aria-label": props.dropdownPlaceholder ?? "Search options",
                                        "aria-activedescendant": highlightedIndex >= 0 ? `${listboxIdRef.current}-${highlightedIndex}` : undefined
                                    }),
                                    query !== "" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$c25acd513dcc8062), {
                                        style: {
                                            position: "absolute",
                                            right: 10,
                                            padding: 5
                                        },
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setQuery("");
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $604fb7faec27af0d$export$2e2bcd8739ae039), {
                                            style: {
                                                width: 10,
                                                pointerEvents: "none"
                                            }
                                        })
                                    })
                                ]
                            }),
                            props.headers?.map((h, i)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $3de4cfeabec36e0d$export$5d302286c68f338), {
                                    onClick: ()=>setDropdown(false),
                                    children: h
                                }, i))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $3de4cfeabec36e0d$export$1d74d2b90d306635), {
                        id: listboxIdRef.current,
                        role: "listbox",
                        children: [
                            !dropdownItems.length && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4e36cf643347ef05$var$DropdownPlaceholder, {
                                children: props.dropdownPlaceholder ?? "No Items"
                            }),
                            dropdownItems.map((item, index)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4e36cf643347ef05$var$DropdownListItem, {
                                    id: `${listboxIdRef.current}-${index}`,
                                    onClick: (e)=>onItemSelect(e, item),
                                    style: {
                                        ...props.dropdownListItemStyle ?? {},
                                        backgroundColor: index === highlightedIndex ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST : undefined
                                    },
                                    role: "option",
                                    "aria-selected": index === highlightedIndex,
                                    tabIndex: -1,
                                    children: props.labelExtractor(item)
                                }, props.keyExtractor(item)))
                        ]
                    })
                ]
            })
        })
    });
};
var $4e36cf643347ef05$export$2e2bcd8739ae039 = $4e36cf643347ef05$var$SearchMultiselect;


var $2407e95b657632c3$exports = {};
$2407e95b657632c3$exports = JSON.parse('[{"name":"Afghanistan","isoCode":"AF","flag":"\uD83C\uDDE6\uD83C\uDDEB","phonecode":"93","currency":"AFN","latitude":"33.00000000","longitude":"65.00000000","timezones":[{"zoneName":"Asia/Kabul","gmtOffset":16200,"gmtOffsetName":"UTC+04:30","abbreviation":"AFT","tzName":"Afghanistan Time"}]},{"name":"Aland Islands","isoCode":"AX","flag":"\uD83C\uDDE6\uD83C\uDDFD","phonecode":"+358-18","currency":"EUR","latitude":"60.11666700","longitude":"19.90000000","timezones":[{"zoneName":"Europe/Mariehamn","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Albania","isoCode":"AL","flag":"\uD83C\uDDE6\uD83C\uDDF1","phonecode":"355","currency":"ALL","latitude":"41.00000000","longitude":"20.00000000","timezones":[{"zoneName":"Europe/Tirane","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Algeria","isoCode":"DZ","flag":"\uD83C\uDDE9\uD83C\uDDFF","phonecode":"213","currency":"DZD","latitude":"28.00000000","longitude":"3.00000000","timezones":[{"zoneName":"Africa/Algiers","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"American Samoa","isoCode":"AS","flag":"\uD83C\uDDE6\uD83C\uDDF8","phonecode":"+1-684","currency":"USD","latitude":"-14.33333333","longitude":"-170.00000000","timezones":[{"zoneName":"Pacific/Pago_Pago","gmtOffset":-39600,"gmtOffsetName":"UTC-11:00","abbreviation":"SST","tzName":"Samoa Standard Time"}]},{"name":"Andorra","isoCode":"AD","flag":"\uD83C\uDDE6\uD83C\uDDE9","phonecode":"376","currency":"EUR","latitude":"42.50000000","longitude":"1.50000000","timezones":[{"zoneName":"Europe/Andorra","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Angola","isoCode":"AO","flag":"\uD83C\uDDE6\uD83C\uDDF4","phonecode":"244","currency":"AOA","latitude":"-12.50000000","longitude":"18.50000000","timezones":[{"zoneName":"Africa/Luanda","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Anguilla","isoCode":"AI","flag":"\uD83C\uDDE6\uD83C\uDDEE","phonecode":"+1-264","currency":"XCD","latitude":"18.25000000","longitude":"-63.16666666","timezones":[{"zoneName":"America/Anguilla","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Antarctica","isoCode":"AQ","flag":"\uD83C\uDDE6\uD83C\uDDF6","phonecode":"672","currency":"AAD","latitude":"-74.65000000","longitude":"4.48000000","timezones":[{"zoneName":"Antarctica/Casey","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"AWST","tzName":"Australian Western Standard Time"},{"zoneName":"Antarctica/Davis","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"DAVT","tzName":"Davis Time"},{"zoneName":"Antarctica/DumontDUrville","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"DDUT","tzName":"Dumont d\'Urville Time"},{"zoneName":"Antarctica/Mawson","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"MAWT","tzName":"Mawson Station Time"},{"zoneName":"Antarctica/McMurdo","gmtOffset":46800,"gmtOffsetName":"UTC+13:00","abbreviation":"NZDT","tzName":"New Zealand Daylight Time"},{"zoneName":"Antarctica/Palmer","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"CLST","tzName":"Chile Summer Time"},{"zoneName":"Antarctica/Rothera","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ROTT","tzName":"Rothera Research Station Time"},{"zoneName":"Antarctica/Syowa","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"SYOT","tzName":"Showa Station Time"},{"zoneName":"Antarctica/Troll","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"},{"zoneName":"Antarctica/Vostok","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"VOST","tzName":"Vostok Station Time"}]},{"name":"Antigua And Barbuda","isoCode":"AG","flag":"\uD83C\uDDE6\uD83C\uDDEC","phonecode":"+1-268","currency":"XCD","latitude":"17.05000000","longitude":"-61.80000000","timezones":[{"zoneName":"America/Antigua","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Argentina","isoCode":"AR","flag":"\uD83C\uDDE6\uD83C\uDDF7","phonecode":"54","currency":"ARS","latitude":"-34.00000000","longitude":"-64.00000000","timezones":[{"zoneName":"America/Argentina/Buenos_Aires","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Catamarca","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Cordoba","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Jujuy","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/La_Rioja","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Mendoza","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Rio_Gallegos","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Salta","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/San_Juan","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/San_Luis","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Tucuman","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"},{"zoneName":"America/Argentina/Ushuaia","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"ART","tzName":"Argentina Time"}]},{"name":"Armenia","isoCode":"AM","flag":"\uD83C\uDDE6\uD83C\uDDF2","phonecode":"374","currency":"AMD","latitude":"40.00000000","longitude":"45.00000000","timezones":[{"zoneName":"Asia/Yerevan","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"AMT","tzName":"Armenia Time"}]},{"name":"Aruba","isoCode":"AW","flag":"\uD83C\uDDE6\uD83C\uDDFC","phonecode":"297","currency":"AWG","latitude":"12.50000000","longitude":"-69.96666666","timezones":[{"zoneName":"America/Aruba","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Australia","isoCode":"AU","flag":"\uD83C\uDDE6\uD83C\uDDFA","phonecode":"61","currency":"AUD","latitude":"-27.00000000","longitude":"133.00000000","timezones":[{"zoneName":"Antarctica/Macquarie","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"MIST","tzName":"Macquarie Island Station Time"},{"zoneName":"Australia/Adelaide","gmtOffset":37800,"gmtOffsetName":"UTC+10:30","abbreviation":"ACDT","tzName":"Australian Central Daylight Saving Time"},{"zoneName":"Australia/Brisbane","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"AEST","tzName":"Australian Eastern Standard Time"},{"zoneName":"Australia/Broken_Hill","gmtOffset":37800,"gmtOffsetName":"UTC+10:30","abbreviation":"ACDT","tzName":"Australian Central Daylight Saving Time"},{"zoneName":"Australia/Currie","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"AEDT","tzName":"Australian Eastern Daylight Saving Time"},{"zoneName":"Australia/Darwin","gmtOffset":34200,"gmtOffsetName":"UTC+09:30","abbreviation":"ACST","tzName":"Australian Central Standard Time"},{"zoneName":"Australia/Eucla","gmtOffset":31500,"gmtOffsetName":"UTC+08:45","abbreviation":"ACWST","tzName":"Australian Central Western Standard Time (Unofficial)"},{"zoneName":"Australia/Hobart","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"AEDT","tzName":"Australian Eastern Daylight Saving Time"},{"zoneName":"Australia/Lindeman","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"AEST","tzName":"Australian Eastern Standard Time"},{"zoneName":"Australia/Lord_Howe","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"LHST","tzName":"Lord Howe Summer Time"},{"zoneName":"Australia/Melbourne","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"AEDT","tzName":"Australian Eastern Daylight Saving Time"},{"zoneName":"Australia/Perth","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"AWST","tzName":"Australian Western Standard Time"},{"zoneName":"Australia/Sydney","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"AEDT","tzName":"Australian Eastern Daylight Saving Time"}]},{"name":"Austria","isoCode":"AT","flag":"\uD83C\uDDE6\uD83C\uDDF9","phonecode":"43","currency":"EUR","latitude":"47.33333333","longitude":"13.33333333","timezones":[{"zoneName":"Europe/Vienna","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Azerbaijan","isoCode":"AZ","flag":"\uD83C\uDDE6\uD83C\uDDFF","phonecode":"994","currency":"AZN","latitude":"40.50000000","longitude":"47.50000000","timezones":[{"zoneName":"Asia/Baku","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"AZT","tzName":"Azerbaijan Time"}]},{"name":"The Bahamas","isoCode":"BS","flag":"\uD83C\uDDE7\uD83C\uDDF8","phonecode":"+1-242","currency":"BSD","latitude":"24.25000000","longitude":"-76.00000000","timezones":[{"zoneName":"America/Nassau","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America)"}]},{"name":"Bahrain","isoCode":"BH","flag":"\uD83C\uDDE7\uD83C\uDDED","phonecode":"973","currency":"BHD","latitude":"26.00000000","longitude":"50.55000000","timezones":[{"zoneName":"Asia/Bahrain","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Bangladesh","isoCode":"BD","flag":"\uD83C\uDDE7\uD83C\uDDE9","phonecode":"880","currency":"BDT","latitude":"24.00000000","longitude":"90.00000000","timezones":[{"zoneName":"Asia/Dhaka","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"BDT","tzName":"Bangladesh Standard Time"}]},{"name":"Barbados","isoCode":"BB","flag":"\uD83C\uDDE7\uD83C\uDDE7","phonecode":"+1-246","currency":"BBD","latitude":"13.16666666","longitude":"-59.53333333","timezones":[{"zoneName":"America/Barbados","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Belarus","isoCode":"BY","flag":"\uD83C\uDDE7\uD83C\uDDFE","phonecode":"375","currency":"BYN","latitude":"53.00000000","longitude":"28.00000000","timezones":[{"zoneName":"Europe/Minsk","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"MSK","tzName":"Moscow Time"}]},{"name":"Belgium","isoCode":"BE","flag":"\uD83C\uDDE7\uD83C\uDDEA","phonecode":"32","currency":"EUR","latitude":"50.83333333","longitude":"4.00000000","timezones":[{"zoneName":"Europe/Brussels","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Belize","isoCode":"BZ","flag":"\uD83C\uDDE7\uD83C\uDDFF","phonecode":"501","currency":"BZD","latitude":"17.25000000","longitude":"-88.75000000","timezones":[{"zoneName":"America/Belize","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America)"}]},{"name":"Benin","isoCode":"BJ","flag":"\uD83C\uDDE7\uD83C\uDDEF","phonecode":"229","currency":"XOF","latitude":"9.50000000","longitude":"2.25000000","timezones":[{"zoneName":"Africa/Porto-Novo","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Bermuda","isoCode":"BM","flag":"\uD83C\uDDE7\uD83C\uDDF2","phonecode":"+1-441","currency":"BMD","latitude":"32.33333333","longitude":"-64.75000000","timezones":[{"zoneName":"Atlantic/Bermuda","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Bhutan","isoCode":"BT","flag":"\uD83C\uDDE7\uD83C\uDDF9","phonecode":"975","currency":"BTN","latitude":"27.50000000","longitude":"90.50000000","timezones":[{"zoneName":"Asia/Thimphu","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"BTT","tzName":"Bhutan Time"}]},{"name":"Bolivia","isoCode":"BO","flag":"\uD83C\uDDE7\uD83C\uDDF4","phonecode":"591","currency":"BOB","latitude":"-17.00000000","longitude":"-65.00000000","timezones":[{"zoneName":"America/La_Paz","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"BOT","tzName":"Bolivia Time"}]},{"name":"Bosnia and Herzegovina","isoCode":"BA","flag":"\uD83C\uDDE7\uD83C\uDDE6","phonecode":"387","currency":"BAM","latitude":"44.00000000","longitude":"18.00000000","timezones":[{"zoneName":"Europe/Sarajevo","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Botswana","isoCode":"BW","flag":"\uD83C\uDDE7\uD83C\uDDFC","phonecode":"267","currency":"BWP","latitude":"-22.00000000","longitude":"24.00000000","timezones":[{"zoneName":"Africa/Gaborone","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Bouvet Island","isoCode":"BV","flag":"\uD83C\uDDE7\uD83C\uDDFB","phonecode":"0055","currency":"NOK","latitude":"-54.43333333","longitude":"3.40000000","timezones":[{"zoneName":"Europe/Oslo","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Brazil","isoCode":"BR","flag":"\uD83C\uDDE7\uD83C\uDDF7","phonecode":"55","currency":"BRL","latitude":"-10.00000000","longitude":"-55.00000000","timezones":[{"zoneName":"America/Araguaina","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Bahia","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Belem","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Boa_Vista","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AMT","tzName":"Amazon Time (Brazil)[3"},{"zoneName":"America/Campo_Grande","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AMT","tzName":"Amazon Time (Brazil)[3"},{"zoneName":"America/Cuiaba","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"BRT","tzName":"Brasilia Time"},{"zoneName":"America/Eirunepe","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"ACT","tzName":"Acre Time"},{"zoneName":"America/Fortaleza","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Maceio","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Manaus","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AMT","tzName":"Amazon Time (Brazil)"},{"zoneName":"America/Noronha","gmtOffset":-7200,"gmtOffsetName":"UTC-02:00","abbreviation":"FNT","tzName":"Fernando de Noronha Time"},{"zoneName":"America/Porto_Velho","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AMT","tzName":"Amazon Time (Brazil)[3"},{"zoneName":"America/Recife","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Rio_Branco","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"ACT","tzName":"Acre Time"},{"zoneName":"America/Santarem","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"},{"zoneName":"America/Sao_Paulo","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"BRT","tzName":"Bras\xedlia Time"}]},{"name":"British Indian Ocean Territory","isoCode":"IO","flag":"\uD83C\uDDEE\uD83C\uDDF4","phonecode":"246","currency":"USD","latitude":"-6.00000000","longitude":"71.50000000","timezones":[{"zoneName":"Indian/Chagos","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"IOT","tzName":"Indian Ocean Time"}]},{"name":"Brunei","isoCode":"BN","flag":"\uD83C\uDDE7\uD83C\uDDF3","phonecode":"673","currency":"BND","latitude":"4.50000000","longitude":"114.66666666","timezones":[{"zoneName":"Asia/Brunei","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"BNT","tzName":"Brunei Darussalam Time"}]},{"name":"Bulgaria","isoCode":"BG","flag":"\uD83C\uDDE7\uD83C\uDDEC","phonecode":"359","currency":"BGN","latitude":"43.00000000","longitude":"25.00000000","timezones":[{"zoneName":"Europe/Sofia","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Burkina Faso","isoCode":"BF","flag":"\uD83C\uDDE7\uD83C\uDDEB","phonecode":"226","currency":"XOF","latitude":"13.00000000","longitude":"-2.00000000","timezones":[{"zoneName":"Africa/Ouagadougou","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Burundi","isoCode":"BI","flag":"\uD83C\uDDE7\uD83C\uDDEE","phonecode":"257","currency":"BIF","latitude":"-3.50000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Bujumbura","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Cambodia","isoCode":"KH","flag":"\uD83C\uDDF0\uD83C\uDDED","phonecode":"855","currency":"KHR","latitude":"13.00000000","longitude":"105.00000000","timezones":[{"zoneName":"Asia/Phnom_Penh","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"ICT","tzName":"Indochina Time"}]},{"name":"Cameroon","isoCode":"CM","flag":"\uD83C\uDDE8\uD83C\uDDF2","phonecode":"237","currency":"XAF","latitude":"6.00000000","longitude":"12.00000000","timezones":[{"zoneName":"Africa/Douala","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Canada","isoCode":"CA","flag":"\uD83C\uDDE8\uD83C\uDDE6","phonecode":"1","currency":"CAD","latitude":"60.00000000","longitude":"-95.00000000","timezones":[{"zoneName":"America/Atikokan","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America)"},{"zoneName":"America/Blanc-Sablon","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"},{"zoneName":"America/Cambridge_Bay","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Creston","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Dawson","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Dawson_Creek","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Edmonton","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Fort_Nelson","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America)"},{"zoneName":"America/Glace_Bay","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"},{"zoneName":"America/Goose_Bay","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"},{"zoneName":"America/Halifax","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"},{"zoneName":"America/Inuvik","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Iqaluit","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Moncton","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"},{"zoneName":"America/Nipigon","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Pangnirtung","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Rainy_River","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Rankin_Inlet","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Regina","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Resolute","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/St_Johns","gmtOffset":-12600,"gmtOffsetName":"UTC-03:30","abbreviation":"NST","tzName":"Newfoundland Standard Time"},{"zoneName":"America/Swift_Current","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Thunder_Bay","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Toronto","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Vancouver","gmtOffset":-28800,"gmtOffsetName":"UTC-08:00","abbreviation":"PST","tzName":"Pacific Standard Time (North America"},{"zoneName":"America/Whitehorse","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Winnipeg","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Yellowknife","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"}]},{"name":"Cape Verde","isoCode":"CV","flag":"\uD83C\uDDE8\uD83C\uDDFB","phonecode":"238","currency":"CVE","latitude":"16.00000000","longitude":"-24.00000000","timezones":[{"zoneName":"Atlantic/Cape_Verde","gmtOffset":-3600,"gmtOffsetName":"UTC-01:00","abbreviation":"CVT","tzName":"Cape Verde Time"}]},{"name":"Cayman Islands","isoCode":"KY","flag":"\uD83C\uDDF0\uD83C\uDDFE","phonecode":"+1-345","currency":"KYD","latitude":"19.50000000","longitude":"-80.50000000","timezones":[{"zoneName":"America/Cayman","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"}]},{"name":"Central African Republic","isoCode":"CF","flag":"\uD83C\uDDE8\uD83C\uDDEB","phonecode":"236","currency":"XAF","latitude":"7.00000000","longitude":"21.00000000","timezones":[{"zoneName":"Africa/Bangui","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Chad","isoCode":"TD","flag":"\uD83C\uDDF9\uD83C\uDDE9","phonecode":"235","currency":"XAF","latitude":"15.00000000","longitude":"19.00000000","timezones":[{"zoneName":"Africa/Ndjamena","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Chile","isoCode":"CL","flag":"\uD83C\uDDE8\uD83C\uDDF1","phonecode":"56","currency":"CLP","latitude":"-30.00000000","longitude":"-71.00000000","timezones":[{"zoneName":"America/Punta_Arenas","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"CLST","tzName":"Chile Summer Time"},{"zoneName":"America/Santiago","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"CLST","tzName":"Chile Summer Time"},{"zoneName":"Pacific/Easter","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EASST","tzName":"Easter Island Summer Time"}]},{"name":"China","isoCode":"CN","flag":"\uD83C\uDDE8\uD83C\uDDF3","phonecode":"86","currency":"CNY","latitude":"35.00000000","longitude":"105.00000000","timezones":[{"zoneName":"Asia/Shanghai","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"CST","tzName":"China Standard Time"},{"zoneName":"Asia/Urumqi","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"XJT","tzName":"China Standard Time"}]},{"name":"Christmas Island","isoCode":"CX","flag":"\uD83C\uDDE8\uD83C\uDDFD","phonecode":"61","currency":"AUD","latitude":"-10.50000000","longitude":"105.66666666","timezones":[{"zoneName":"Indian/Christmas","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"CXT","tzName":"Christmas Island Time"}]},{"name":"Cocos (Keeling) Islands","isoCode":"CC","flag":"\uD83C\uDDE8\uD83C\uDDE8","phonecode":"61","currency":"AUD","latitude":"-12.50000000","longitude":"96.83333333","timezones":[{"zoneName":"Indian/Cocos","gmtOffset":23400,"gmtOffsetName":"UTC+06:30","abbreviation":"CCT","tzName":"Cocos Islands Time"}]},{"name":"Colombia","isoCode":"CO","flag":"\uD83C\uDDE8\uD83C\uDDF4","phonecode":"57","currency":"COP","latitude":"4.00000000","longitude":"-72.00000000","timezones":[{"zoneName":"America/Bogota","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"COT","tzName":"Colombia Time"}]},{"name":"Comoros","isoCode":"KM","flag":"\uD83C\uDDF0\uD83C\uDDF2","phonecode":"269","currency":"KMF","latitude":"-12.16666666","longitude":"44.25000000","timezones":[{"zoneName":"Indian/Comoro","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Congo","isoCode":"CG","flag":"\uD83C\uDDE8\uD83C\uDDEC","phonecode":"242","currency":"XAF","latitude":"-1.00000000","longitude":"15.00000000","timezones":[{"zoneName":"Africa/Brazzaville","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Democratic Republic of the Congo","isoCode":"CD","flag":"\uD83C\uDDE8\uD83C\uDDE9","phonecode":"243","currency":"CDF","latitude":"0.00000000","longitude":"25.00000000","timezones":[{"zoneName":"Africa/Kinshasa","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"},{"zoneName":"Africa/Lubumbashi","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Cook Islands","isoCode":"CK","flag":"\uD83C\uDDE8\uD83C\uDDF0","phonecode":"682","currency":"NZD","latitude":"-21.23333333","longitude":"-159.76666666","timezones":[{"zoneName":"Pacific/Rarotonga","gmtOffset":-36000,"gmtOffsetName":"UTC-10:00","abbreviation":"CKT","tzName":"Cook Island Time"}]},{"name":"Costa Rica","isoCode":"CR","flag":"\uD83C\uDDE8\uD83C\uDDF7","phonecode":"506","currency":"CRC","latitude":"10.00000000","longitude":"-84.00000000","timezones":[{"zoneName":"America/Costa_Rica","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"}]},{"name":"Cote D\'Ivoire (Ivory Coast)","isoCode":"CI","flag":"\uD83C\uDDE8\uD83C\uDDEE","phonecode":"225","currency":"XOF","latitude":"8.00000000","longitude":"-5.00000000","timezones":[{"zoneName":"Africa/Abidjan","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Croatia","isoCode":"HR","flag":"\uD83C\uDDED\uD83C\uDDF7","phonecode":"385","currency":"HRK","latitude":"45.16666666","longitude":"15.50000000","timezones":[{"zoneName":"Europe/Zagreb","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Cuba","isoCode":"CU","flag":"\uD83C\uDDE8\uD83C\uDDFA","phonecode":"53","currency":"CUP","latitude":"21.50000000","longitude":"-80.00000000","timezones":[{"zoneName":"America/Havana","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"CST","tzName":"Cuba Standard Time"}]},{"name":"Cyprus","isoCode":"CY","flag":"\uD83C\uDDE8\uD83C\uDDFE","phonecode":"357","currency":"EUR","latitude":"35.00000000","longitude":"33.00000000","timezones":[{"zoneName":"Asia/Famagusta","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"},{"zoneName":"Asia/Nicosia","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Czech Republic","isoCode":"CZ","flag":"\uD83C\uDDE8\uD83C\uDDFF","phonecode":"420","currency":"CZK","latitude":"49.75000000","longitude":"15.50000000","timezones":[{"zoneName":"Europe/Prague","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Denmark","isoCode":"DK","flag":"\uD83C\uDDE9\uD83C\uDDF0","phonecode":"45","currency":"DKK","latitude":"56.00000000","longitude":"10.00000000","timezones":[{"zoneName":"Europe/Copenhagen","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Djibouti","isoCode":"DJ","flag":"\uD83C\uDDE9\uD83C\uDDEF","phonecode":"253","currency":"DJF","latitude":"11.50000000","longitude":"43.00000000","timezones":[{"zoneName":"Africa/Djibouti","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Dominica","isoCode":"DM","flag":"\uD83C\uDDE9\uD83C\uDDF2","phonecode":"+1-767","currency":"XCD","latitude":"15.41666666","longitude":"-61.33333333","timezones":[{"zoneName":"America/Dominica","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Dominican Republic","isoCode":"DO","flag":"\uD83C\uDDE9\uD83C\uDDF4","phonecode":"+1-809 and 1-829","currency":"DOP","latitude":"19.00000000","longitude":"-70.66666666","timezones":[{"zoneName":"America/Santo_Domingo","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"East Timor","isoCode":"TL","flag":"\uD83C\uDDF9\uD83C\uDDF1","phonecode":"670","currency":"USD","latitude":"-8.83333333","longitude":"125.91666666","timezones":[{"zoneName":"Asia/Dili","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"TLT","tzName":"Timor Leste Time"}]},{"name":"Ecuador","isoCode":"EC","flag":"\uD83C\uDDEA\uD83C\uDDE8","phonecode":"593","currency":"USD","latitude":"-2.00000000","longitude":"-77.50000000","timezones":[{"zoneName":"America/Guayaquil","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"ECT","tzName":"Ecuador Time"},{"zoneName":"Pacific/Galapagos","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"GALT","tzName":"Gal\xe1pagos Time"}]},{"name":"Egypt","isoCode":"EG","flag":"\uD83C\uDDEA\uD83C\uDDEC","phonecode":"20","currency":"EGP","latitude":"27.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Cairo","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"El Salvador","isoCode":"SV","flag":"\uD83C\uDDF8\uD83C\uDDFB","phonecode":"503","currency":"USD","latitude":"13.83333333","longitude":"-88.91666666","timezones":[{"zoneName":"America/El_Salvador","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"}]},{"name":"Equatorial Guinea","isoCode":"GQ","flag":"\uD83C\uDDEC\uD83C\uDDF6","phonecode":"240","currency":"XAF","latitude":"2.00000000","longitude":"10.00000000","timezones":[{"zoneName":"Africa/Malabo","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Eritrea","isoCode":"ER","flag":"\uD83C\uDDEA\uD83C\uDDF7","phonecode":"291","currency":"ERN","latitude":"15.00000000","longitude":"39.00000000","timezones":[{"zoneName":"Africa/Asmara","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Estonia","isoCode":"EE","flag":"\uD83C\uDDEA\uD83C\uDDEA","phonecode":"372","currency":"EUR","latitude":"59.00000000","longitude":"26.00000000","timezones":[{"zoneName":"Europe/Tallinn","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Ethiopia","isoCode":"ET","flag":"\uD83C\uDDEA\uD83C\uDDF9","phonecode":"251","currency":"ETB","latitude":"8.00000000","longitude":"38.00000000","timezones":[{"zoneName":"Africa/Addis_Ababa","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Falkland Islands","isoCode":"FK","flag":"\uD83C\uDDEB\uD83C\uDDF0","phonecode":"500","currency":"FKP","latitude":"-51.75000000","longitude":"-59.00000000","timezones":[{"zoneName":"Atlantic/Stanley","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"FKST","tzName":"Falkland Islands Summer Time"}]},{"name":"Faroe Islands","isoCode":"FO","flag":"\uD83C\uDDEB\uD83C\uDDF4","phonecode":"298","currency":"DKK","latitude":"62.00000000","longitude":"-7.00000000","timezones":[{"zoneName":"Atlantic/Faroe","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"WET","tzName":"Western European Time"}]},{"name":"Fiji Islands","isoCode":"FJ","flag":"\uD83C\uDDEB\uD83C\uDDEF","phonecode":"679","currency":"FJD","latitude":"-18.00000000","longitude":"175.00000000","timezones":[{"zoneName":"Pacific/Fiji","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"FJT","tzName":"Fiji Time"}]},{"name":"Finland","isoCode":"FI","flag":"\uD83C\uDDEB\uD83C\uDDEE","phonecode":"358","currency":"EUR","latitude":"64.00000000","longitude":"26.00000000","timezones":[{"zoneName":"Europe/Helsinki","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"France","isoCode":"FR","flag":"\uD83C\uDDEB\uD83C\uDDF7","phonecode":"33","currency":"EUR","latitude":"46.00000000","longitude":"2.00000000","timezones":[{"zoneName":"Europe/Paris","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"French Guiana","isoCode":"GF","flag":"\uD83C\uDDEC\uD83C\uDDEB","phonecode":"594","currency":"EUR","latitude":"4.00000000","longitude":"-53.00000000","timezones":[{"zoneName":"America/Cayenne","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"GFT","tzName":"French Guiana Time"}]},{"name":"French Polynesia","isoCode":"PF","flag":"\uD83C\uDDF5\uD83C\uDDEB","phonecode":"689","currency":"XPF","latitude":"-15.00000000","longitude":"-140.00000000","timezones":[{"zoneName":"Pacific/Gambier","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"GAMT","tzName":"Gambier Islands Time"},{"zoneName":"Pacific/Marquesas","gmtOffset":-34200,"gmtOffsetName":"UTC-09:30","abbreviation":"MART","tzName":"Marquesas Islands Time"},{"zoneName":"Pacific/Tahiti","gmtOffset":-36000,"gmtOffsetName":"UTC-10:00","abbreviation":"TAHT","tzName":"Tahiti Time"}]},{"name":"French Southern Territories","isoCode":"TF","flag":"\uD83C\uDDF9\uD83C\uDDEB","phonecode":"262","currency":"EUR","latitude":"-49.25000000","longitude":"69.16700000","timezones":[{"zoneName":"Indian/Kerguelen","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"TFT","tzName":"French Southern and Antarctic Time"}]},{"name":"Gabon","isoCode":"GA","flag":"\uD83C\uDDEC\uD83C\uDDE6","phonecode":"241","currency":"XAF","latitude":"-1.00000000","longitude":"11.75000000","timezones":[{"zoneName":"Africa/Libreville","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"The Gambia","isoCode":"GM","flag":"\uD83C\uDDEC\uD83C\uDDF2","phonecode":"220","currency":"GMD","latitude":"13.46666666","longitude":"-16.56666666","timezones":[{"zoneName":"Africa/Banjul","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Georgia","isoCode":"GE","flag":"\uD83C\uDDEC\uD83C\uDDEA","phonecode":"995","currency":"GEL","latitude":"42.00000000","longitude":"43.50000000","timezones":[{"zoneName":"Asia/Tbilisi","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"GET","tzName":"Georgia Standard Time"}]},{"name":"Germany","isoCode":"DE","flag":"\uD83C\uDDE9\uD83C\uDDEA","phonecode":"49","currency":"EUR","latitude":"51.00000000","longitude":"9.00000000","timezones":[{"zoneName":"Europe/Berlin","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"},{"zoneName":"Europe/Busingen","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Ghana","isoCode":"GH","flag":"\uD83C\uDDEC\uD83C\uDDED","phonecode":"233","currency":"GHS","latitude":"8.00000000","longitude":"-2.00000000","timezones":[{"zoneName":"Africa/Accra","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Gibraltar","isoCode":"GI","flag":"\uD83C\uDDEC\uD83C\uDDEE","phonecode":"350","currency":"GIP","latitude":"36.13333333","longitude":"-5.35000000","timezones":[{"zoneName":"Europe/Gibraltar","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Greece","isoCode":"GR","flag":"\uD83C\uDDEC\uD83C\uDDF7","phonecode":"30","currency":"EUR","latitude":"39.00000000","longitude":"22.00000000","timezones":[{"zoneName":"Europe/Athens","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Greenland","isoCode":"GL","flag":"\uD83C\uDDEC\uD83C\uDDF1","phonecode":"299","currency":"DKK","latitude":"72.00000000","longitude":"-40.00000000","timezones":[{"zoneName":"America/Danmarkshavn","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"},{"zoneName":"America/Nuuk","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"WGT","tzName":"West Greenland Time"},{"zoneName":"America/Scoresbysund","gmtOffset":-3600,"gmtOffsetName":"UTC-01:00","abbreviation":"EGT","tzName":"Eastern Greenland Time"},{"zoneName":"America/Thule","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Grenada","isoCode":"GD","flag":"\uD83C\uDDEC\uD83C\uDDE9","phonecode":"+1-473","currency":"XCD","latitude":"12.11666666","longitude":"-61.66666666","timezones":[{"zoneName":"America/Grenada","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Guadeloupe","isoCode":"GP","flag":"\uD83C\uDDEC\uD83C\uDDF5","phonecode":"590","currency":"EUR","latitude":"16.25000000","longitude":"-61.58333300","timezones":[{"zoneName":"America/Guadeloupe","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Guam","isoCode":"GU","flag":"\uD83C\uDDEC\uD83C\uDDFA","phonecode":"+1-671","currency":"USD","latitude":"13.46666666","longitude":"144.78333333","timezones":[{"zoneName":"Pacific/Guam","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"CHST","tzName":"Chamorro Standard Time"}]},{"name":"Guatemala","isoCode":"GT","flag":"\uD83C\uDDEC\uD83C\uDDF9","phonecode":"502","currency":"GTQ","latitude":"15.50000000","longitude":"-90.25000000","timezones":[{"zoneName":"America/Guatemala","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"}]},{"name":"Guernsey and Alderney","isoCode":"GG","flag":"\uD83C\uDDEC\uD83C\uDDEC","phonecode":"+44-1481","currency":"GBP","latitude":"49.46666666","longitude":"-2.58333333","timezones":[{"zoneName":"Europe/Guernsey","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Guinea","isoCode":"GN","flag":"\uD83C\uDDEC\uD83C\uDDF3","phonecode":"224","currency":"GNF","latitude":"11.00000000","longitude":"-10.00000000","timezones":[{"zoneName":"Africa/Conakry","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Guinea-Bissau","isoCode":"GW","flag":"\uD83C\uDDEC\uD83C\uDDFC","phonecode":"245","currency":"XOF","latitude":"12.00000000","longitude":"-15.00000000","timezones":[{"zoneName":"Africa/Bissau","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Guyana","isoCode":"GY","flag":"\uD83C\uDDEC\uD83C\uDDFE","phonecode":"592","currency":"GYD","latitude":"5.00000000","longitude":"-59.00000000","timezones":[{"zoneName":"America/Guyana","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"GYT","tzName":"Guyana Time"}]},{"name":"Haiti","isoCode":"HT","flag":"\uD83C\uDDED\uD83C\uDDF9","phonecode":"509","currency":"HTG","latitude":"19.00000000","longitude":"-72.41666666","timezones":[{"zoneName":"America/Port-au-Prince","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"}]},{"name":"Heard Island and McDonald Islands","isoCode":"HM","flag":"\uD83C\uDDED\uD83C\uDDF2","phonecode":"672","currency":"AUD","latitude":"-53.10000000","longitude":"72.51666666","timezones":[{"zoneName":"Indian/Kerguelen","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"TFT","tzName":"French Southern and Antarctic Time"}]},{"name":"Honduras","isoCode":"HN","flag":"\uD83C\uDDED\uD83C\uDDF3","phonecode":"504","currency":"HNL","latitude":"15.00000000","longitude":"-86.50000000","timezones":[{"zoneName":"America/Tegucigalpa","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"}]},{"name":"Hong Kong S.A.R.","isoCode":"HK","flag":"\uD83C\uDDED\uD83C\uDDF0","phonecode":"852","currency":"HKD","latitude":"22.25000000","longitude":"114.16666666","timezones":[{"zoneName":"Asia/Hong_Kong","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"HKT","tzName":"Hong Kong Time"}]},{"name":"Hungary","isoCode":"HU","flag":"\uD83C\uDDED\uD83C\uDDFA","phonecode":"36","currency":"HUF","latitude":"47.00000000","longitude":"20.00000000","timezones":[{"zoneName":"Europe/Budapest","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Iceland","isoCode":"IS","flag":"\uD83C\uDDEE\uD83C\uDDF8","phonecode":"354","currency":"ISK","latitude":"65.00000000","longitude":"-18.00000000","timezones":[{"zoneName":"Atlantic/Reykjavik","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"India","isoCode":"IN","flag":"\uD83C\uDDEE\uD83C\uDDF3","phonecode":"91","currency":"INR","latitude":"20.00000000","longitude":"77.00000000","timezones":[{"zoneName":"Asia/Kolkata","gmtOffset":19800,"gmtOffsetName":"UTC+05:30","abbreviation":"IST","tzName":"Indian Standard Time"}]},{"name":"Indonesia","isoCode":"ID","flag":"\uD83C\uDDEE\uD83C\uDDE9","phonecode":"62","currency":"IDR","latitude":"-5.00000000","longitude":"120.00000000","timezones":[{"zoneName":"Asia/Jakarta","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"WIB","tzName":"Western Indonesian Time"},{"zoneName":"Asia/Jayapura","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"WIT","tzName":"Eastern Indonesian Time"},{"zoneName":"Asia/Makassar","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"WITA","tzName":"Central Indonesia Time"},{"zoneName":"Asia/Pontianak","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"WIB","tzName":"Western Indonesian Time"}]},{"name":"Iran","isoCode":"IR","flag":"\uD83C\uDDEE\uD83C\uDDF7","phonecode":"98","currency":"IRR","latitude":"32.00000000","longitude":"53.00000000","timezones":[{"zoneName":"Asia/Tehran","gmtOffset":12600,"gmtOffsetName":"UTC+03:30","abbreviation":"IRDT","tzName":"Iran Daylight Time"}]},{"name":"Iraq","isoCode":"IQ","flag":"\uD83C\uDDEE\uD83C\uDDF6","phonecode":"964","currency":"IQD","latitude":"33.00000000","longitude":"44.00000000","timezones":[{"zoneName":"Asia/Baghdad","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Ireland","isoCode":"IE","flag":"\uD83C\uDDEE\uD83C\uDDEA","phonecode":"353","currency":"EUR","latitude":"53.00000000","longitude":"-8.00000000","timezones":[{"zoneName":"Europe/Dublin","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Israel","isoCode":"IL","flag":"\uD83C\uDDEE\uD83C\uDDF1","phonecode":"972","currency":"ILS","latitude":"31.50000000","longitude":"34.75000000","timezones":[{"zoneName":"Asia/Jerusalem","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"IST","tzName":"Israel Standard Time"}]},{"name":"Italy","isoCode":"IT","flag":"\uD83C\uDDEE\uD83C\uDDF9","phonecode":"39","currency":"EUR","latitude":"42.83333333","longitude":"12.83333333","timezones":[{"zoneName":"Europe/Rome","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Jamaica","isoCode":"JM","flag":"\uD83C\uDDEF\uD83C\uDDF2","phonecode":"+1-876","currency":"JMD","latitude":"18.25000000","longitude":"-77.50000000","timezones":[{"zoneName":"America/Jamaica","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"}]},{"name":"Japan","isoCode":"JP","flag":"\uD83C\uDDEF\uD83C\uDDF5","phonecode":"81","currency":"JPY","latitude":"36.00000000","longitude":"138.00000000","timezones":[{"zoneName":"Asia/Tokyo","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"JST","tzName":"Japan Standard Time"}]},{"name":"Jersey","isoCode":"JE","flag":"\uD83C\uDDEF\uD83C\uDDEA","phonecode":"+44-1534","currency":"GBP","latitude":"49.25000000","longitude":"-2.16666666","timezones":[{"zoneName":"Europe/Jersey","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Jordan","isoCode":"JO","flag":"\uD83C\uDDEF\uD83C\uDDF4","phonecode":"962","currency":"JOD","latitude":"31.00000000","longitude":"36.00000000","timezones":[{"zoneName":"Asia/Amman","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Kazakhstan","isoCode":"KZ","flag":"\uD83C\uDDF0\uD83C\uDDFF","phonecode":"7","currency":"KZT","latitude":"48.00000000","longitude":"68.00000000","timezones":[{"zoneName":"Asia/Almaty","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"ALMT","tzName":"Alma-Ata Time[1"},{"zoneName":"Asia/Aqtau","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"AQTT","tzName":"Aqtobe Time"},{"zoneName":"Asia/Aqtobe","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"AQTT","tzName":"Aqtobe Time"},{"zoneName":"Asia/Atyrau","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"MSD+1","tzName":"Moscow Daylight Time+1"},{"zoneName":"Asia/Oral","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"ORAT","tzName":"Oral Time"},{"zoneName":"Asia/Qostanay","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"QYZST","tzName":"Qyzylorda Summer Time"},{"zoneName":"Asia/Qyzylorda","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"QYZT","tzName":"Qyzylorda Summer Time"}]},{"name":"Kenya","isoCode":"KE","flag":"\uD83C\uDDF0\uD83C\uDDEA","phonecode":"254","currency":"KES","latitude":"1.00000000","longitude":"38.00000000","timezones":[{"zoneName":"Africa/Nairobi","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Kiribati","isoCode":"KI","flag":"\uD83C\uDDF0\uD83C\uDDEE","phonecode":"686","currency":"AUD","latitude":"1.41666666","longitude":"173.00000000","timezones":[{"zoneName":"Pacific/Enderbury","gmtOffset":46800,"gmtOffsetName":"UTC+13:00","abbreviation":"PHOT","tzName":"Phoenix Island Time"},{"zoneName":"Pacific/Kiritimati","gmtOffset":50400,"gmtOffsetName":"UTC+14:00","abbreviation":"LINT","tzName":"Line Islands Time"},{"zoneName":"Pacific/Tarawa","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"GILT","tzName":"Gilbert Island Time"}]},{"name":"North Korea","isoCode":"KP","flag":"\uD83C\uDDF0\uD83C\uDDF5","phonecode":"850","currency":"KPW","latitude":"40.00000000","longitude":"127.00000000","timezones":[{"zoneName":"Asia/Pyongyang","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"KST","tzName":"Korea Standard Time"}]},{"name":"South Korea","isoCode":"KR","flag":"\uD83C\uDDF0\uD83C\uDDF7","phonecode":"82","currency":"KRW","latitude":"37.00000000","longitude":"127.50000000","timezones":[{"zoneName":"Asia/Seoul","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"KST","tzName":"Korea Standard Time"}]},{"name":"Kuwait","isoCode":"KW","flag":"\uD83C\uDDF0\uD83C\uDDFC","phonecode":"965","currency":"KWD","latitude":"29.50000000","longitude":"45.75000000","timezones":[{"zoneName":"Asia/Kuwait","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Kyrgyzstan","isoCode":"KG","flag":"\uD83C\uDDF0\uD83C\uDDEC","phonecode":"996","currency":"KGS","latitude":"41.00000000","longitude":"75.00000000","timezones":[{"zoneName":"Asia/Bishkek","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"KGT","tzName":"Kyrgyzstan Time"}]},{"name":"Laos","isoCode":"LA","flag":"\uD83C\uDDF1\uD83C\uDDE6","phonecode":"856","currency":"LAK","latitude":"18.00000000","longitude":"105.00000000","timezones":[{"zoneName":"Asia/Vientiane","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"ICT","tzName":"Indochina Time"}]},{"name":"Latvia","isoCode":"LV","flag":"\uD83C\uDDF1\uD83C\uDDFB","phonecode":"371","currency":"EUR","latitude":"57.00000000","longitude":"25.00000000","timezones":[{"zoneName":"Europe/Riga","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Lebanon","isoCode":"LB","flag":"\uD83C\uDDF1\uD83C\uDDE7","phonecode":"961","currency":"LBP","latitude":"33.83333333","longitude":"35.83333333","timezones":[{"zoneName":"Asia/Beirut","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Lesotho","isoCode":"LS","flag":"\uD83C\uDDF1\uD83C\uDDF8","phonecode":"266","currency":"LSL","latitude":"-29.50000000","longitude":"28.50000000","timezones":[{"zoneName":"Africa/Maseru","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"SAST","tzName":"South African Standard Time"}]},{"name":"Liberia","isoCode":"LR","flag":"\uD83C\uDDF1\uD83C\uDDF7","phonecode":"231","currency":"LRD","latitude":"6.50000000","longitude":"-9.50000000","timezones":[{"zoneName":"Africa/Monrovia","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Libya","isoCode":"LY","flag":"\uD83C\uDDF1\uD83C\uDDFE","phonecode":"218","currency":"LYD","latitude":"25.00000000","longitude":"17.00000000","timezones":[{"zoneName":"Africa/Tripoli","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Liechtenstein","isoCode":"LI","flag":"\uD83C\uDDF1\uD83C\uDDEE","phonecode":"423","currency":"CHF","latitude":"47.26666666","longitude":"9.53333333","timezones":[{"zoneName":"Europe/Vaduz","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Lithuania","isoCode":"LT","flag":"\uD83C\uDDF1\uD83C\uDDF9","phonecode":"370","currency":"EUR","latitude":"56.00000000","longitude":"24.00000000","timezones":[{"zoneName":"Europe/Vilnius","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Luxembourg","isoCode":"LU","flag":"\uD83C\uDDF1\uD83C\uDDFA","phonecode":"352","currency":"EUR","latitude":"49.75000000","longitude":"6.16666666","timezones":[{"zoneName":"Europe/Luxembourg","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Macau S.A.R.","isoCode":"MO","flag":"\uD83C\uDDF2\uD83C\uDDF4","phonecode":"853","currency":"MOP","latitude":"22.16666666","longitude":"113.55000000","timezones":[{"zoneName":"Asia/Macau","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"CST","tzName":"China Standard Time"}]},{"name":"Macedonia","isoCode":"MK","flag":"\uD83C\uDDF2\uD83C\uDDF0","phonecode":"389","currency":"MKD","latitude":"41.83333333","longitude":"22.00000000","timezones":[{"zoneName":"Europe/Skopje","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Madagascar","isoCode":"MG","flag":"\uD83C\uDDF2\uD83C\uDDEC","phonecode":"261","currency":"MGA","latitude":"-20.00000000","longitude":"47.00000000","timezones":[{"zoneName":"Indian/Antananarivo","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Malawi","isoCode":"MW","flag":"\uD83C\uDDF2\uD83C\uDDFC","phonecode":"265","currency":"MWK","latitude":"-13.50000000","longitude":"34.00000000","timezones":[{"zoneName":"Africa/Blantyre","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Malaysia","isoCode":"MY","flag":"\uD83C\uDDF2\uD83C\uDDFE","phonecode":"60","currency":"MYR","latitude":"2.50000000","longitude":"112.50000000","timezones":[{"zoneName":"Asia/Kuala_Lumpur","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"MYT","tzName":"Malaysia Time"},{"zoneName":"Asia/Kuching","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"MYT","tzName":"Malaysia Time"}]},{"name":"Maldives","isoCode":"MV","flag":"\uD83C\uDDF2\uD83C\uDDFB","phonecode":"960","currency":"MVR","latitude":"3.25000000","longitude":"73.00000000","timezones":[{"zoneName":"Indian/Maldives","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"MVT","tzName":"Maldives Time"}]},{"name":"Mali","isoCode":"ML","flag":"\uD83C\uDDF2\uD83C\uDDF1","phonecode":"223","currency":"XOF","latitude":"17.00000000","longitude":"-4.00000000","timezones":[{"zoneName":"Africa/Bamako","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Malta","isoCode":"MT","flag":"\uD83C\uDDF2\uD83C\uDDF9","phonecode":"356","currency":"EUR","latitude":"35.83333333","longitude":"14.58333333","timezones":[{"zoneName":"Europe/Malta","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Man (Isle of)","isoCode":"IM","flag":"\uD83C\uDDEE\uD83C\uDDF2","phonecode":"+44-1624","currency":"GBP","latitude":"54.25000000","longitude":"-4.50000000","timezones":[{"zoneName":"Europe/Isle_of_Man","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Marshall Islands","isoCode":"MH","flag":"\uD83C\uDDF2\uD83C\uDDED","phonecode":"692","currency":"USD","latitude":"9.00000000","longitude":"168.00000000","timezones":[{"zoneName":"Pacific/Kwajalein","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"MHT","tzName":"Marshall Islands Time"},{"zoneName":"Pacific/Majuro","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"MHT","tzName":"Marshall Islands Time"}]},{"name":"Martinique","isoCode":"MQ","flag":"\uD83C\uDDF2\uD83C\uDDF6","phonecode":"596","currency":"EUR","latitude":"14.66666700","longitude":"-61.00000000","timezones":[{"zoneName":"America/Martinique","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Mauritania","isoCode":"MR","flag":"\uD83C\uDDF2\uD83C\uDDF7","phonecode":"222","currency":"MRO","latitude":"20.00000000","longitude":"-12.00000000","timezones":[{"zoneName":"Africa/Nouakchott","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Mauritius","isoCode":"MU","flag":"\uD83C\uDDF2\uD83C\uDDFA","phonecode":"230","currency":"MUR","latitude":"-20.28333333","longitude":"57.55000000","timezones":[{"zoneName":"Indian/Mauritius","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"MUT","tzName":"Mauritius Time"}]},{"name":"Mayotte","isoCode":"YT","flag":"\uD83C\uDDFE\uD83C\uDDF9","phonecode":"262","currency":"EUR","latitude":"-12.83333333","longitude":"45.16666666","timezones":[{"zoneName":"Indian/Mayotte","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Mexico","isoCode":"MX","flag":"\uD83C\uDDF2\uD83C\uDDFD","phonecode":"52","currency":"MXN","latitude":"23.00000000","longitude":"-102.00000000","timezones":[{"zoneName":"America/Bahia_Banderas","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Cancun","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Chihuahua","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Hermosillo","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Matamoros","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Mazatlan","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Merida","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Mexico_City","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Monterrey","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Ojinaga","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Tijuana","gmtOffset":-28800,"gmtOffsetName":"UTC-08:00","abbreviation":"PST","tzName":"Pacific Standard Time (North America"}]},{"name":"Micronesia","isoCode":"FM","flag":"\uD83C\uDDEB\uD83C\uDDF2","phonecode":"691","currency":"USD","latitude":"6.91666666","longitude":"158.25000000","timezones":[{"zoneName":"Pacific/Chuuk","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"CHUT","tzName":"Chuuk Time"},{"zoneName":"Pacific/Kosrae","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"KOST","tzName":"Kosrae Time"},{"zoneName":"Pacific/Pohnpei","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"PONT","tzName":"Pohnpei Standard Time"}]},{"name":"Moldova","isoCode":"MD","flag":"\uD83C\uDDF2\uD83C\uDDE9","phonecode":"373","currency":"MDL","latitude":"47.00000000","longitude":"29.00000000","timezones":[{"zoneName":"Europe/Chisinau","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Monaco","isoCode":"MC","flag":"\uD83C\uDDF2\uD83C\uDDE8","phonecode":"377","currency":"EUR","latitude":"43.73333333","longitude":"7.40000000","timezones":[{"zoneName":"Europe/Monaco","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Mongolia","isoCode":"MN","flag":"\uD83C\uDDF2\uD83C\uDDF3","phonecode":"976","currency":"MNT","latitude":"46.00000000","longitude":"105.00000000","timezones":[{"zoneName":"Asia/Choibalsan","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"CHOT","tzName":"Choibalsan Standard Time"},{"zoneName":"Asia/Hovd","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"HOVT","tzName":"Hovd Time"},{"zoneName":"Asia/Ulaanbaatar","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"ULAT","tzName":"Ulaanbaatar Standard Time"}]},{"name":"Montenegro","isoCode":"ME","flag":"\uD83C\uDDF2\uD83C\uDDEA","phonecode":"382","currency":"EUR","latitude":"42.50000000","longitude":"19.30000000","timezones":[{"zoneName":"Europe/Podgorica","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Montserrat","isoCode":"MS","flag":"\uD83C\uDDF2\uD83C\uDDF8","phonecode":"+1-664","currency":"XCD","latitude":"16.75000000","longitude":"-62.20000000","timezones":[{"zoneName":"America/Montserrat","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Morocco","isoCode":"MA","flag":"\uD83C\uDDF2\uD83C\uDDE6","phonecode":"212","currency":"MAD","latitude":"32.00000000","longitude":"-5.00000000","timezones":[{"zoneName":"Africa/Casablanca","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WEST","tzName":"Western European Summer Time"}]},{"name":"Mozambique","isoCode":"MZ","flag":"\uD83C\uDDF2\uD83C\uDDFF","phonecode":"258","currency":"MZN","latitude":"-18.25000000","longitude":"35.00000000","timezones":[{"zoneName":"Africa/Maputo","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Myanmar","isoCode":"MM","flag":"\uD83C\uDDF2\uD83C\uDDF2","phonecode":"95","currency":"MMK","latitude":"22.00000000","longitude":"98.00000000","timezones":[{"zoneName":"Asia/Yangon","gmtOffset":23400,"gmtOffsetName":"UTC+06:30","abbreviation":"MMT","tzName":"Myanmar Standard Time"}]},{"name":"Namibia","isoCode":"NA","flag":"\uD83C\uDDF3\uD83C\uDDE6","phonecode":"264","currency":"NAD","latitude":"-22.00000000","longitude":"17.00000000","timezones":[{"zoneName":"Africa/Windhoek","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"WAST","tzName":"West Africa Summer Time"}]},{"name":"Nauru","isoCode":"NR","flag":"\uD83C\uDDF3\uD83C\uDDF7","phonecode":"674","currency":"AUD","latitude":"-0.53333333","longitude":"166.91666666","timezones":[{"zoneName":"Pacific/Nauru","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"NRT","tzName":"Nauru Time"}]},{"name":"Nepal","isoCode":"NP","flag":"\uD83C\uDDF3\uD83C\uDDF5","phonecode":"977","currency":"NPR","latitude":"28.00000000","longitude":"84.00000000","timezones":[{"zoneName":"Asia/Kathmandu","gmtOffset":20700,"gmtOffsetName":"UTC+05:45","abbreviation":"NPT","tzName":"Nepal Time"}]},{"name":"Bonaire, Sint Eustatius and Saba","isoCode":"BQ","flag":"\uD83C\uDDE7\uD83C\uDDF6","phonecode":"599","currency":"USD","latitude":"12.15000000","longitude":"-68.26666700","timezones":[{"zoneName":"America/Anguilla","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Netherlands","isoCode":"NL","flag":"\uD83C\uDDF3\uD83C\uDDF1","phonecode":"31","currency":"EUR","latitude":"52.50000000","longitude":"5.75000000","timezones":[{"zoneName":"Europe/Amsterdam","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"New Caledonia","isoCode":"NC","flag":"\uD83C\uDDF3\uD83C\uDDE8","phonecode":"687","currency":"XPF","latitude":"-21.50000000","longitude":"165.50000000","timezones":[{"zoneName":"Pacific/Noumea","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"NCT","tzName":"New Caledonia Time"}]},{"name":"New Zealand","isoCode":"NZ","flag":"\uD83C\uDDF3\uD83C\uDDFF","phonecode":"64","currency":"NZD","latitude":"-41.00000000","longitude":"174.00000000","timezones":[{"zoneName":"Pacific/Auckland","gmtOffset":46800,"gmtOffsetName":"UTC+13:00","abbreviation":"NZDT","tzName":"New Zealand Daylight Time"},{"zoneName":"Pacific/Chatham","gmtOffset":49500,"gmtOffsetName":"UTC+13:45","abbreviation":"CHAST","tzName":"Chatham Standard Time"}]},{"name":"Nicaragua","isoCode":"NI","flag":"\uD83C\uDDF3\uD83C\uDDEE","phonecode":"505","currency":"NIO","latitude":"13.00000000","longitude":"-85.00000000","timezones":[{"zoneName":"America/Managua","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"}]},{"name":"Niger","isoCode":"NE","flag":"\uD83C\uDDF3\uD83C\uDDEA","phonecode":"227","currency":"XOF","latitude":"16.00000000","longitude":"8.00000000","timezones":[{"zoneName":"Africa/Niamey","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Nigeria","isoCode":"NG","flag":"\uD83C\uDDF3\uD83C\uDDEC","phonecode":"234","currency":"NGN","latitude":"10.00000000","longitude":"8.00000000","timezones":[{"zoneName":"Africa/Lagos","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WAT","tzName":"West Africa Time"}]},{"name":"Niue","isoCode":"NU","flag":"\uD83C\uDDF3\uD83C\uDDFA","phonecode":"683","currency":"NZD","latitude":"-19.03333333","longitude":"-169.86666666","timezones":[{"zoneName":"Pacific/Niue","gmtOffset":-39600,"gmtOffsetName":"UTC-11:00","abbreviation":"NUT","tzName":"Niue Time"}]},{"name":"Norfolk Island","isoCode":"NF","flag":"\uD83C\uDDF3\uD83C\uDDEB","phonecode":"672","currency":"AUD","latitude":"-29.03333333","longitude":"167.95000000","timezones":[{"zoneName":"Pacific/Norfolk","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"NFT","tzName":"Norfolk Time"}]},{"name":"Northern Mariana Islands","isoCode":"MP","flag":"\uD83C\uDDF2\uD83C\uDDF5","phonecode":"+1-670","currency":"USD","latitude":"15.20000000","longitude":"145.75000000","timezones":[{"zoneName":"Pacific/Saipan","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"ChST","tzName":"Chamorro Standard Time"}]},{"name":"Norway","isoCode":"NO","flag":"\uD83C\uDDF3\uD83C\uDDF4","phonecode":"47","currency":"NOK","latitude":"62.00000000","longitude":"10.00000000","timezones":[{"zoneName":"Europe/Oslo","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Oman","isoCode":"OM","flag":"\uD83C\uDDF4\uD83C\uDDF2","phonecode":"968","currency":"OMR","latitude":"21.00000000","longitude":"57.00000000","timezones":[{"zoneName":"Asia/Muscat","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"GST","tzName":"Gulf Standard Time"}]},{"name":"Pakistan","isoCode":"PK","flag":"\uD83C\uDDF5\uD83C\uDDF0","phonecode":"92","currency":"PKR","latitude":"30.00000000","longitude":"70.00000000","timezones":[{"zoneName":"Asia/Karachi","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"PKT","tzName":"Pakistan Standard Time"}]},{"name":"Palau","isoCode":"PW","flag":"\uD83C\uDDF5\uD83C\uDDFC","phonecode":"680","currency":"USD","latitude":"7.50000000","longitude":"134.50000000","timezones":[{"zoneName":"Pacific/Palau","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"PWT","tzName":"Palau Time"}]},{"name":"Palestinian Territory Occupied","isoCode":"PS","flag":"\uD83C\uDDF5\uD83C\uDDF8","phonecode":"970","currency":"ILS","latitude":"31.90000000","longitude":"35.20000000","timezones":[{"zoneName":"Asia/Gaza","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"},{"zoneName":"Asia/Hebron","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Panama","isoCode":"PA","flag":"\uD83C\uDDF5\uD83C\uDDE6","phonecode":"507","currency":"PAB","latitude":"9.00000000","longitude":"-80.00000000","timezones":[{"zoneName":"America/Panama","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"}]},{"name":"Papua new Guinea","isoCode":"PG","flag":"\uD83C\uDDF5\uD83C\uDDEC","phonecode":"675","currency":"PGK","latitude":"-6.00000000","longitude":"147.00000000","timezones":[{"zoneName":"Pacific/Bougainville","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"BST","tzName":"Bougainville Standard Time[6"},{"zoneName":"Pacific/Port_Moresby","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"PGT","tzName":"Papua New Guinea Time"}]},{"name":"Paraguay","isoCode":"PY","flag":"\uD83C\uDDF5\uD83C\uDDFE","phonecode":"595","currency":"PYG","latitude":"-23.00000000","longitude":"-58.00000000","timezones":[{"zoneName":"America/Asuncion","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"PYST","tzName":"Paraguay Summer Time"}]},{"name":"Peru","isoCode":"PE","flag":"\uD83C\uDDF5\uD83C\uDDEA","phonecode":"51","currency":"PEN","latitude":"-10.00000000","longitude":"-76.00000000","timezones":[{"zoneName":"America/Lima","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"PET","tzName":"Peru Time"}]},{"name":"Philippines","isoCode":"PH","flag":"\uD83C\uDDF5\uD83C\uDDED","phonecode":"63","currency":"PHP","latitude":"13.00000000","longitude":"122.00000000","timezones":[{"zoneName":"Asia/Manila","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"PHT","tzName":"Philippine Time"}]},{"name":"Pitcairn Island","isoCode":"PN","flag":"\uD83C\uDDF5\uD83C\uDDF3","phonecode":"870","currency":"NZD","latitude":"-25.06666666","longitude":"-130.10000000","timezones":[{"zoneName":"Pacific/Pitcairn","gmtOffset":-28800,"gmtOffsetName":"UTC-08:00","abbreviation":"PST","tzName":"Pacific Standard Time (North America"}]},{"name":"Poland","isoCode":"PL","flag":"\uD83C\uDDF5\uD83C\uDDF1","phonecode":"48","currency":"PLN","latitude":"52.00000000","longitude":"20.00000000","timezones":[{"zoneName":"Europe/Warsaw","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Portugal","isoCode":"PT","flag":"\uD83C\uDDF5\uD83C\uDDF9","phonecode":"351","currency":"EUR","latitude":"39.50000000","longitude":"-8.00000000","timezones":[{"zoneName":"Atlantic/Azores","gmtOffset":-3600,"gmtOffsetName":"UTC-01:00","abbreviation":"AZOT","tzName":"Azores Standard Time"},{"zoneName":"Atlantic/Madeira","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"WET","tzName":"Western European Time"},{"zoneName":"Europe/Lisbon","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"WET","tzName":"Western European Time"}]},{"name":"Puerto Rico","isoCode":"PR","flag":"\uD83C\uDDF5\uD83C\uDDF7","phonecode":"+1-787 and 1-939","currency":"USD","latitude":"18.25000000","longitude":"-66.50000000","timezones":[{"zoneName":"America/Puerto_Rico","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Qatar","isoCode":"QA","flag":"\uD83C\uDDF6\uD83C\uDDE6","phonecode":"974","currency":"QAR","latitude":"25.50000000","longitude":"51.25000000","timezones":[{"zoneName":"Asia/Qatar","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Reunion","isoCode":"RE","flag":"\uD83C\uDDF7\uD83C\uDDEA","phonecode":"262","currency":"EUR","latitude":"-21.15000000","longitude":"55.50000000","timezones":[{"zoneName":"Indian/Reunion","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"RET","tzName":"R\xe9union Time"}]},{"name":"Romania","isoCode":"RO","flag":"\uD83C\uDDF7\uD83C\uDDF4","phonecode":"40","currency":"RON","latitude":"46.00000000","longitude":"25.00000000","timezones":[{"zoneName":"Europe/Bucharest","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Russia","isoCode":"RU","flag":"\uD83C\uDDF7\uD83C\uDDFA","phonecode":"7","currency":"RUB","latitude":"60.00000000","longitude":"100.00000000","timezones":[{"zoneName":"Asia/Anadyr","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"ANAT","tzName":"Anadyr Time[4"},{"zoneName":"Asia/Barnaul","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"KRAT","tzName":"Krasnoyarsk Time"},{"zoneName":"Asia/Chita","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"YAKT","tzName":"Yakutsk Time"},{"zoneName":"Asia/Irkutsk","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"IRKT","tzName":"Irkutsk Time"},{"zoneName":"Asia/Kamchatka","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"PETT","tzName":"Kamchatka Time"},{"zoneName":"Asia/Khandyga","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"YAKT","tzName":"Yakutsk Time"},{"zoneName":"Asia/Krasnoyarsk","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"KRAT","tzName":"Krasnoyarsk Time"},{"zoneName":"Asia/Magadan","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"MAGT","tzName":"Magadan Time"},{"zoneName":"Asia/Novokuznetsk","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"KRAT","tzName":"Krasnoyarsk Time"},{"zoneName":"Asia/Novosibirsk","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"NOVT","tzName":"Novosibirsk Time"},{"zoneName":"Asia/Omsk","gmtOffset":21600,"gmtOffsetName":"UTC+06:00","abbreviation":"OMST","tzName":"Omsk Time"},{"zoneName":"Asia/Sakhalin","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"SAKT","tzName":"Sakhalin Island Time"},{"zoneName":"Asia/Srednekolymsk","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"SRET","tzName":"Srednekolymsk Time"},{"zoneName":"Asia/Tomsk","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"MSD+3","tzName":"Moscow Daylight Time+3"},{"zoneName":"Asia/Ust-Nera","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"VLAT","tzName":"Vladivostok Time"},{"zoneName":"Asia/Vladivostok","gmtOffset":36000,"gmtOffsetName":"UTC+10:00","abbreviation":"VLAT","tzName":"Vladivostok Time"},{"zoneName":"Asia/Yakutsk","gmtOffset":32400,"gmtOffsetName":"UTC+09:00","abbreviation":"YAKT","tzName":"Yakutsk Time"},{"zoneName":"Asia/Yekaterinburg","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"YEKT","tzName":"Yekaterinburg Time"},{"zoneName":"Europe/Astrakhan","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"SAMT","tzName":"Samara Time"},{"zoneName":"Europe/Kaliningrad","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"},{"zoneName":"Europe/Kirov","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"MSK","tzName":"Moscow Time"},{"zoneName":"Europe/Moscow","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"MSK","tzName":"Moscow Time"},{"zoneName":"Europe/Samara","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"SAMT","tzName":"Samara Time"},{"zoneName":"Europe/Saratov","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"MSD","tzName":"Moscow Daylight Time+4"},{"zoneName":"Europe/Ulyanovsk","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"SAMT","tzName":"Samara Time"},{"zoneName":"Europe/Volgograd","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"MSK","tzName":"Moscow Standard Time"}]},{"name":"Rwanda","isoCode":"RW","flag":"\uD83C\uDDF7\uD83C\uDDFC","phonecode":"250","currency":"RWF","latitude":"-2.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Kigali","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Saint Helena","isoCode":"SH","flag":"\uD83C\uDDF8\uD83C\uDDED","phonecode":"290","currency":"SHP","latitude":"-15.95000000","longitude":"-5.70000000","timezones":[{"zoneName":"Atlantic/St_Helena","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Saint Kitts And Nevis","isoCode":"KN","flag":"\uD83C\uDDF0\uD83C\uDDF3","phonecode":"+1-869","currency":"XCD","latitude":"17.33333333","longitude":"-62.75000000","timezones":[{"zoneName":"America/St_Kitts","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Saint Lucia","isoCode":"LC","flag":"\uD83C\uDDF1\uD83C\uDDE8","phonecode":"+1-758","currency":"XCD","latitude":"13.88333333","longitude":"-60.96666666","timezones":[{"zoneName":"America/St_Lucia","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Saint Pierre and Miquelon","isoCode":"PM","flag":"\uD83C\uDDF5\uD83C\uDDF2","phonecode":"508","currency":"EUR","latitude":"46.83333333","longitude":"-56.33333333","timezones":[{"zoneName":"America/Miquelon","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"PMDT","tzName":"Pierre & Miquelon Daylight Time"}]},{"name":"Saint Vincent And The Grenadines","isoCode":"VC","flag":"\uD83C\uDDFB\uD83C\uDDE8","phonecode":"+1-784","currency":"XCD","latitude":"13.25000000","longitude":"-61.20000000","timezones":[{"zoneName":"America/St_Vincent","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Saint-Barthelemy","isoCode":"BL","flag":"\uD83C\uDDE7\uD83C\uDDF1","phonecode":"590","currency":"EUR","latitude":"18.50000000","longitude":"-63.41666666","timezones":[{"zoneName":"America/St_Barthelemy","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Saint-Martin (French part)","isoCode":"MF","flag":"\uD83C\uDDF2\uD83C\uDDEB","phonecode":"590","currency":"EUR","latitude":"18.08333333","longitude":"-63.95000000","timezones":[{"zoneName":"America/Marigot","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Samoa","isoCode":"WS","flag":"\uD83C\uDDFC\uD83C\uDDF8","phonecode":"685","currency":"WST","latitude":"-13.58333333","longitude":"-172.33333333","timezones":[{"zoneName":"Pacific/Apia","gmtOffset":50400,"gmtOffsetName":"UTC+14:00","abbreviation":"WST","tzName":"West Samoa Time"}]},{"name":"San Marino","isoCode":"SM","flag":"\uD83C\uDDF8\uD83C\uDDF2","phonecode":"378","currency":"EUR","latitude":"43.76666666","longitude":"12.41666666","timezones":[{"zoneName":"Europe/San_Marino","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Sao Tome and Principe","isoCode":"ST","flag":"\uD83C\uDDF8\uD83C\uDDF9","phonecode":"239","currency":"STD","latitude":"1.00000000","longitude":"7.00000000","timezones":[{"zoneName":"Africa/Sao_Tome","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Saudi Arabia","isoCode":"SA","flag":"\uD83C\uDDF8\uD83C\uDDE6","phonecode":"966","currency":"SAR","latitude":"25.00000000","longitude":"45.00000000","timezones":[{"zoneName":"Asia/Riyadh","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Senegal","isoCode":"SN","flag":"\uD83C\uDDF8\uD83C\uDDF3","phonecode":"221","currency":"XOF","latitude":"14.00000000","longitude":"-14.00000000","timezones":[{"zoneName":"Africa/Dakar","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Serbia","isoCode":"RS","flag":"\uD83C\uDDF7\uD83C\uDDF8","phonecode":"381","currency":"RSD","latitude":"44.00000000","longitude":"21.00000000","timezones":[{"zoneName":"Europe/Belgrade","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Seychelles","isoCode":"SC","flag":"\uD83C\uDDF8\uD83C\uDDE8","phonecode":"248","currency":"SCR","latitude":"-4.58333333","longitude":"55.66666666","timezones":[{"zoneName":"Indian/Mahe","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"SCT","tzName":"Seychelles Time"}]},{"name":"Sierra Leone","isoCode":"SL","flag":"\uD83C\uDDF8\uD83C\uDDF1","phonecode":"232","currency":"SLL","latitude":"8.50000000","longitude":"-11.50000000","timezones":[{"zoneName":"Africa/Freetown","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Singapore","isoCode":"SG","flag":"\uD83C\uDDF8\uD83C\uDDEC","phonecode":"65","currency":"SGD","latitude":"1.36666666","longitude":"103.80000000","timezones":[{"zoneName":"Asia/Singapore","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"SGT","tzName":"Singapore Time"}]},{"name":"Slovakia","isoCode":"SK","flag":"\uD83C\uDDF8\uD83C\uDDF0","phonecode":"421","currency":"EUR","latitude":"48.66666666","longitude":"19.50000000","timezones":[{"zoneName":"Europe/Bratislava","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Slovenia","isoCode":"SI","flag":"\uD83C\uDDF8\uD83C\uDDEE","phonecode":"386","currency":"EUR","latitude":"46.11666666","longitude":"14.81666666","timezones":[{"zoneName":"Europe/Ljubljana","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Solomon Islands","isoCode":"SB","flag":"\uD83C\uDDF8\uD83C\uDDE7","phonecode":"677","currency":"SBD","latitude":"-8.00000000","longitude":"159.00000000","timezones":[{"zoneName":"Pacific/Guadalcanal","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"SBT","tzName":"Solomon Islands Time"}]},{"name":"Somalia","isoCode":"SO","flag":"\uD83C\uDDF8\uD83C\uDDF4","phonecode":"252","currency":"SOS","latitude":"10.00000000","longitude":"49.00000000","timezones":[{"zoneName":"Africa/Mogadishu","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"South Africa","isoCode":"ZA","flag":"\uD83C\uDDFF\uD83C\uDDE6","phonecode":"27","currency":"ZAR","latitude":"-29.00000000","longitude":"24.00000000","timezones":[{"zoneName":"Africa/Johannesburg","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"SAST","tzName":"South African Standard Time"}]},{"name":"South Georgia","isoCode":"GS","flag":"\uD83C\uDDEC\uD83C\uDDF8","phonecode":"500","currency":"GBP","latitude":"-54.50000000","longitude":"-37.00000000","timezones":[{"zoneName":"Atlantic/South_Georgia","gmtOffset":-7200,"gmtOffsetName":"UTC-02:00","abbreviation":"GST","tzName":"South Georgia and the South Sandwich Islands Time"}]},{"name":"South Sudan","isoCode":"SS","flag":"\uD83C\uDDF8\uD83C\uDDF8","phonecode":"211","currency":"SSP","latitude":"7.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Juba","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Spain","isoCode":"ES","flag":"\uD83C\uDDEA\uD83C\uDDF8","phonecode":"34","currency":"EUR","latitude":"40.00000000","longitude":"-4.00000000","timezones":[{"zoneName":"Africa/Ceuta","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"},{"zoneName":"Atlantic/Canary","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"WET","tzName":"Western European Time"},{"zoneName":"Europe/Madrid","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Sri Lanka","isoCode":"LK","flag":"\uD83C\uDDF1\uD83C\uDDF0","phonecode":"94","currency":"LKR","latitude":"7.00000000","longitude":"81.00000000","timezones":[{"zoneName":"Asia/Colombo","gmtOffset":19800,"gmtOffsetName":"UTC+05:30","abbreviation":"IST","tzName":"Indian Standard Time"}]},{"name":"Sudan","isoCode":"SD","flag":"\uD83C\uDDF8\uD83C\uDDE9","phonecode":"249","currency":"SDG","latitude":"15.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Khartoum","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EAT","tzName":"Eastern African Time"}]},{"name":"Suriname","isoCode":"SR","flag":"\uD83C\uDDF8\uD83C\uDDF7","phonecode":"597","currency":"SRD","latitude":"4.00000000","longitude":"-56.00000000","timezones":[{"zoneName":"America/Paramaribo","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"SRT","tzName":"Suriname Time"}]},{"name":"Svalbard And Jan Mayen Islands","isoCode":"SJ","flag":"\uD83C\uDDF8\uD83C\uDDEF","phonecode":"47","currency":"NOK","latitude":"78.00000000","longitude":"20.00000000","timezones":[{"zoneName":"Arctic/Longyearbyen","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Swaziland","isoCode":"SZ","flag":"\uD83C\uDDF8\uD83C\uDDFF","phonecode":"268","currency":"SZL","latitude":"-26.50000000","longitude":"31.50000000","timezones":[{"zoneName":"Africa/Mbabane","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"SAST","tzName":"South African Standard Time"}]},{"name":"Sweden","isoCode":"SE","flag":"\uD83C\uDDF8\uD83C\uDDEA","phonecode":"46","currency":"SEK","latitude":"62.00000000","longitude":"15.00000000","timezones":[{"zoneName":"Europe/Stockholm","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Switzerland","isoCode":"CH","flag":"\uD83C\uDDE8\uD83C\uDDED","phonecode":"41","currency":"CHF","latitude":"47.00000000","longitude":"8.00000000","timezones":[{"zoneName":"Europe/Zurich","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Syria","isoCode":"SY","flag":"\uD83C\uDDF8\uD83C\uDDFE","phonecode":"963","currency":"SYP","latitude":"35.00000000","longitude":"38.00000000","timezones":[{"zoneName":"Asia/Damascus","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Taiwan","isoCode":"TW","flag":"\uD83C\uDDF9\uD83C\uDDFC","phonecode":"886","currency":"TWD","latitude":"23.50000000","longitude":"121.00000000","timezones":[{"zoneName":"Asia/Taipei","gmtOffset":28800,"gmtOffsetName":"UTC+08:00","abbreviation":"CST","tzName":"China Standard Time"}]},{"name":"Tajikistan","isoCode":"TJ","flag":"\uD83C\uDDF9\uD83C\uDDEF","phonecode":"992","currency":"TJS","latitude":"39.00000000","longitude":"71.00000000","timezones":[{"zoneName":"Asia/Dushanbe","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"TJT","tzName":"Tajikistan Time"}]},{"name":"Tanzania","isoCode":"TZ","flag":"\uD83C\uDDF9\uD83C\uDDFF","phonecode":"255","currency":"TZS","latitude":"-6.00000000","longitude":"35.00000000","timezones":[{"zoneName":"Africa/Dar_es_Salaam","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Thailand","isoCode":"TH","flag":"\uD83C\uDDF9\uD83C\uDDED","phonecode":"66","currency":"THB","latitude":"15.00000000","longitude":"100.00000000","timezones":[{"zoneName":"Asia/Bangkok","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"ICT","tzName":"Indochina Time"}]},{"name":"Togo","isoCode":"TG","flag":"\uD83C\uDDF9\uD83C\uDDEC","phonecode":"228","currency":"XOF","latitude":"8.00000000","longitude":"1.16666666","timezones":[{"zoneName":"Africa/Lome","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"Tokelau","isoCode":"TK","flag":"\uD83C\uDDF9\uD83C\uDDF0","phonecode":"690","currency":"NZD","latitude":"-9.00000000","longitude":"-172.00000000","timezones":[{"zoneName":"Pacific/Fakaofo","gmtOffset":46800,"gmtOffsetName":"UTC+13:00","abbreviation":"TKT","tzName":"Tokelau Time"}]},{"name":"Tonga","isoCode":"TO","flag":"\uD83C\uDDF9\uD83C\uDDF4","phonecode":"676","currency":"TOP","latitude":"-20.00000000","longitude":"-175.00000000","timezones":[{"zoneName":"Pacific/Tongatapu","gmtOffset":46800,"gmtOffsetName":"UTC+13:00","abbreviation":"TOT","tzName":"Tonga Time"}]},{"name":"Trinidad And Tobago","isoCode":"TT","flag":"\uD83C\uDDF9\uD83C\uDDF9","phonecode":"+1-868","currency":"TTD","latitude":"11.00000000","longitude":"-61.00000000","timezones":[{"zoneName":"America/Port_of_Spain","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Tunisia","isoCode":"TN","flag":"\uD83C\uDDF9\uD83C\uDDF3","phonecode":"216","currency":"TND","latitude":"34.00000000","longitude":"9.00000000","timezones":[{"zoneName":"Africa/Tunis","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Turkey","isoCode":"TR","flag":"\uD83C\uDDF9\uD83C\uDDF7","phonecode":"90","currency":"TRY","latitude":"39.00000000","longitude":"35.00000000","timezones":[{"zoneName":"Europe/Istanbul","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"Turkmenistan","isoCode":"TM","flag":"\uD83C\uDDF9\uD83C\uDDF2","phonecode":"993","currency":"TMT","latitude":"40.00000000","longitude":"60.00000000","timezones":[{"zoneName":"Asia/Ashgabat","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"TMT","tzName":"Turkmenistan Time"}]},{"name":"Turks And Caicos Islands","isoCode":"TC","flag":"\uD83C\uDDF9\uD83C\uDDE8","phonecode":"+1-649","currency":"USD","latitude":"21.75000000","longitude":"-71.58333333","timezones":[{"zoneName":"America/Grand_Turk","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"}]},{"name":"Tuvalu","isoCode":"TV","flag":"\uD83C\uDDF9\uD83C\uDDFB","phonecode":"688","currency":"AUD","latitude":"-8.00000000","longitude":"178.00000000","timezones":[{"zoneName":"Pacific/Funafuti","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"TVT","tzName":"Tuvalu Time"}]},{"name":"Uganda","isoCode":"UG","flag":"\uD83C\uDDFA\uD83C\uDDEC","phonecode":"256","currency":"UGX","latitude":"1.00000000","longitude":"32.00000000","timezones":[{"zoneName":"Africa/Kampala","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"EAT","tzName":"East Africa Time"}]},{"name":"Ukraine","isoCode":"UA","flag":"\uD83C\uDDFA\uD83C\uDDE6","phonecode":"380","currency":"UAH","latitude":"49.00000000","longitude":"32.00000000","timezones":[{"zoneName":"Europe/Kiev","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"},{"zoneName":"Europe/Simferopol","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"MSK","tzName":"Moscow Time"},{"zoneName":"Europe/Uzhgorod","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"},{"zoneName":"Europe/Zaporozhye","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"EET","tzName":"Eastern European Time"}]},{"name":"United Arab Emirates","isoCode":"AE","flag":"\uD83C\uDDE6\uD83C\uDDEA","phonecode":"971","currency":"AED","latitude":"24.00000000","longitude":"54.00000000","timezones":[{"zoneName":"Asia/Dubai","gmtOffset":14400,"gmtOffsetName":"UTC+04:00","abbreviation":"GST","tzName":"Gulf Standard Time"}]},{"name":"United Kingdom","isoCode":"GB","flag":"\uD83C\uDDEC\uD83C\uDDE7","phonecode":"44","currency":"GBP","latitude":"54.00000000","longitude":"-2.00000000","timezones":[{"zoneName":"Europe/London","gmtOffset":0,"gmtOffsetName":"UTC\xb100","abbreviation":"GMT","tzName":"Greenwich Mean Time"}]},{"name":"United States","isoCode":"US","flag":"\uD83C\uDDFA\uD83C\uDDF8","phonecode":"1","currency":"USD","latitude":"38.00000000","longitude":"-97.00000000","timezones":[{"zoneName":"America/Adak","gmtOffset":-36000,"gmtOffsetName":"UTC-10:00","abbreviation":"HST","tzName":"Hawaii\u2013Aleutian Standard Time"},{"zoneName":"America/Anchorage","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"America/Boise","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Chicago","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Denver","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Detroit","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Indianapolis","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Knox","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Indiana/Marengo","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Petersburg","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Tell_City","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Indiana/Vevay","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Vincennes","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Indiana/Winamac","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Juneau","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"America/Kentucky/Louisville","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Kentucky/Monticello","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Los_Angeles","gmtOffset":-28800,"gmtOffsetName":"UTC-08:00","abbreviation":"PST","tzName":"Pacific Standard Time (North America"},{"zoneName":"America/Menominee","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Metlakatla","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"America/New_York","gmtOffset":-18000,"gmtOffsetName":"UTC-05:00","abbreviation":"EST","tzName":"Eastern Standard Time (North America"},{"zoneName":"America/Nome","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"America/North_Dakota/Beulah","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/North_Dakota/Center","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/North_Dakota/New_Salem","gmtOffset":-21600,"gmtOffsetName":"UTC-06:00","abbreviation":"CST","tzName":"Central Standard Time (North America"},{"zoneName":"America/Phoenix","gmtOffset":-25200,"gmtOffsetName":"UTC-07:00","abbreviation":"MST","tzName":"Mountain Standard Time (North America"},{"zoneName":"America/Sitka","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"America/Yakutat","gmtOffset":-32400,"gmtOffsetName":"UTC-09:00","abbreviation":"AKST","tzName":"Alaska Standard Time"},{"zoneName":"Pacific/Honolulu","gmtOffset":-36000,"gmtOffsetName":"UTC-10:00","abbreviation":"HST","tzName":"Hawaii\u2013Aleutian Standard Time"}]},{"name":"United States Minor Outlying Islands","isoCode":"UM","flag":"\uD83C\uDDFA\uD83C\uDDF2","phonecode":"1","currency":"USD","latitude":"0.00000000","longitude":"0.00000000","timezones":[{"zoneName":"Pacific/Midway","gmtOffset":-39600,"gmtOffsetName":"UTC-11:00","abbreviation":"SST","tzName":"Samoa Standard Time"},{"zoneName":"Pacific/Wake","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"WAKT","tzName":"Wake Island Time"}]},{"name":"Uruguay","isoCode":"UY","flag":"\uD83C\uDDFA\uD83C\uDDFE","phonecode":"598","currency":"UYU","latitude":"-33.00000000","longitude":"-56.00000000","timezones":[{"zoneName":"America/Montevideo","gmtOffset":-10800,"gmtOffsetName":"UTC-03:00","abbreviation":"UYT","tzName":"Uruguay Standard Time"}]},{"name":"Uzbekistan","isoCode":"UZ","flag":"\uD83C\uDDFA\uD83C\uDDFF","phonecode":"998","currency":"UZS","latitude":"41.00000000","longitude":"64.00000000","timezones":[{"zoneName":"Asia/Samarkand","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"UZT","tzName":"Uzbekistan Time"},{"zoneName":"Asia/Tashkent","gmtOffset":18000,"gmtOffsetName":"UTC+05:00","abbreviation":"UZT","tzName":"Uzbekistan Time"}]},{"name":"Vanuatu","isoCode":"VU","flag":"\uD83C\uDDFB\uD83C\uDDFA","phonecode":"678","currency":"VUV","latitude":"-16.00000000","longitude":"167.00000000","timezones":[{"zoneName":"Pacific/Efate","gmtOffset":39600,"gmtOffsetName":"UTC+11:00","abbreviation":"VUT","tzName":"Vanuatu Time"}]},{"name":"Vatican City State (Holy See)","isoCode":"VA","flag":"\uD83C\uDDFB\uD83C\uDDE6","phonecode":"379","currency":"EUR","latitude":"41.90000000","longitude":"12.45000000","timezones":[{"zoneName":"Europe/Vatican","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Venezuela","isoCode":"VE","flag":"\uD83C\uDDFB\uD83C\uDDEA","phonecode":"58","currency":"VEF","latitude":"8.00000000","longitude":"-66.00000000","timezones":[{"zoneName":"America/Caracas","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"VET","tzName":"Venezuelan Standard Time"}]},{"name":"Vietnam","isoCode":"VN","flag":"\uD83C\uDDFB\uD83C\uDDF3","phonecode":"84","currency":"VND","latitude":"16.16666666","longitude":"107.83333333","timezones":[{"zoneName":"Asia/Ho_Chi_Minh","gmtOffset":25200,"gmtOffsetName":"UTC+07:00","abbreviation":"ICT","tzName":"Indochina Time"}]},{"name":"Virgin Islands (British)","isoCode":"VG","flag":"\uD83C\uDDFB\uD83C\uDDEC","phonecode":"+1-284","currency":"USD","latitude":"18.43138300","longitude":"-64.62305000","timezones":[{"zoneName":"America/Tortola","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Virgin Islands (US)","isoCode":"VI","flag":"\uD83C\uDDFB\uD83C\uDDEE","phonecode":"+1-340","currency":"USD","latitude":"18.34000000","longitude":"-64.93000000","timezones":[{"zoneName":"America/St_Thomas","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Wallis And Futuna Islands","isoCode":"WF","flag":"\uD83C\uDDFC\uD83C\uDDEB","phonecode":"681","currency":"XPF","latitude":"-13.30000000","longitude":"-176.20000000","timezones":[{"zoneName":"Pacific/Wallis","gmtOffset":43200,"gmtOffsetName":"UTC+12:00","abbreviation":"WFT","tzName":"Wallis & Futuna Time"}]},{"name":"Western Sahara","isoCode":"EH","flag":"\uD83C\uDDEA\uD83C\uDDED","phonecode":"212","currency":"MAD","latitude":"24.50000000","longitude":"-13.00000000","timezones":[{"zoneName":"Africa/El_Aaiun","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"WEST","tzName":"Western European Summer Time"}]},{"name":"Yemen","isoCode":"YE","flag":"\uD83C\uDDFE\uD83C\uDDEA","phonecode":"967","currency":"YER","latitude":"15.00000000","longitude":"48.00000000","timezones":[{"zoneName":"Asia/Aden","gmtOffset":10800,"gmtOffsetName":"UTC+03:00","abbreviation":"AST","tzName":"Arabia Standard Time"}]},{"name":"Zambia","isoCode":"ZM","flag":"\uD83C\uDDFF\uD83C\uDDF2","phonecode":"260","currency":"ZMW","latitude":"-15.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Lusaka","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Zimbabwe","isoCode":"ZW","flag":"\uD83C\uDDFF\uD83C\uDDFC","phonecode":"263","currency":"ZWL","latitude":"-20.00000000","longitude":"30.00000000","timezones":[{"zoneName":"Africa/Harare","gmtOffset":7200,"gmtOffsetName":"UTC+02:00","abbreviation":"CAT","tzName":"Central Africa Time"}]},{"name":"Kosovo","isoCode":"XK","flag":"\uD83C\uDDFD\uD83C\uDDF0","phonecode":"383","currency":"EUR","latitude":"42.56129090","longitude":"20.34030350","timezones":[{"zoneName":"Europe/Belgrade","gmtOffset":3600,"gmtOffsetName":"UTC+01:00","abbreviation":"CET","tzName":"Central European Time"}]},{"name":"Cura\xe7ao","isoCode":"CW","flag":"\uD83C\uDDE8\uD83C\uDDFC","phonecode":"599","currency":"ANG","latitude":"12.11666700","longitude":"-68.93333300","timezones":[{"zoneName":"America/Curacao","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]},{"name":"Sint Maarten (Dutch part)","isoCode":"SX","flag":"\uD83C\uDDF8\uD83C\uDDFD","phonecode":"1721","currency":"ANG","latitude":"18.03333300","longitude":"-63.05000000","timezones":[{"zoneName":"America/Anguilla","gmtOffset":-14400,"gmtOffsetName":"UTC-04:00","abbreviation":"AST","tzName":"Atlantic Standard Time"}]}]');


const $e55e4e34e9f3dfab$export$f402ac270728efb9 = (source, code)=>{
    if (code && source != null) {
        const codex = source.findIndex((c)=>{
            return c.isoCode === code;
        });
        return codex !== -1 ? source[codex] : undefined;
    }
    return undefined;
};
const $e55e4e34e9f3dfab$export$5459063425dbd5d = (source, code, countryCode)=>{
    if (code && countryCode && source != null) {
        const codex = source.findIndex((c)=>{
            return c.isoCode === code && c.countryCode === countryCode;
        });
        return codex !== -1 ? source[codex] : undefined;
    }
    return undefined;
};
function $e55e4e34e9f3dfab$export$8982a0378820ff7b(entity) {
    return entity.name;
}
const $e55e4e34e9f3dfab$export$398604a469f7de9a = (a, b, // eslint-disable-next-line no-unused-vars
keyToCompare = $e55e4e34e9f3dfab$export$8982a0378820ff7b)=>{
    if (keyToCompare(a) < keyToCompare(b)) return -1;
    if (keyToCompare(a) > keyToCompare(b)) return 1;
    return 0;
};
const $e55e4e34e9f3dfab$export$4ffa58f6da7470fc = (keys, arr)=>{
    const result = arr.map((subArr)=>{
        return Object.fromEntries(keys.map((key, index)=>[
                key,
                subArr[index]
            ]));
    });
    return result;
};


// Get a country by isoCode.
function $e80c2cf8ebb93fb4$var$getCountryByCode(isoCode) {
    if (!isoCode) return undefined;
    return (0, $e55e4e34e9f3dfab$export$f402ac270728efb9)((0, (/*@__PURE__*/$parcel$interopDefault($2407e95b657632c3$exports))), isoCode);
}
// Get a list of all countries.
function $e80c2cf8ebb93fb4$var$getAllCountries() {
    return 0, (/*@__PURE__*/$parcel$interopDefault($2407e95b657632c3$exports));
}
function $e80c2cf8ebb93fb4$var$sortByIsoCode(countries) {
    return countries.sort((a, b)=>{
        return (0, $e55e4e34e9f3dfab$export$398604a469f7de9a)(a, b, (entity)=>{
            return entity.isoCode;
        });
    });
}
var $e80c2cf8ebb93fb4$export$2e2bcd8739ae039 = {
    getCountryByCode: $e80c2cf8ebb93fb4$var$getCountryByCode,
    getAllCountries: $e80c2cf8ebb93fb4$var$getAllCountries,
    sortByIsoCode: $e80c2cf8ebb93fb4$var$sortByIsoCode
};




parcelRequire("bnENU");
const $9537909adb69401f$export$ba2409dea8f18692 = 18;
const $9537909adb69401f$export$5cbe2f369dfef0ce = (countryIsoCode)=>`https://pay.radom.com/flags/${countryIsoCode.toLowerCase()}.svg`;
const $9537909adb69401f$export$fd6e61e0125bcbc0 = (flagUrl)=>{
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
        style: {
            width: $9537909adb69401f$export$ba2409dea8f18692,
            maxHeight: $9537909adb69401f$export$ba2409dea8f18692,
            maxWidth: $9537909adb69401f$export$ba2409dea8f18692,
            marginRight: 10
        },
        src: flagUrl
    });
};
const $9537909adb69401f$export$879c1b5abbbaad75 = (countryIsoCode, iconSize)=>{
    const size = iconSize || $9537909adb69401f$export$ba2409dea8f18692;
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
        style: {
            width: size,
            maxHeight: size,
            maxWidth: size,
            marginRight: 10
        },
        src: $9537909adb69401f$export$5cbe2f369dfef0ce(countryIsoCode)
    });
};


const $96e19f8f97c8e649$var$COMMON_COUNTRY_NAMES = [
    "United States",
    "United Kingdom",
    "Canada",
    "Australia",
    "Germany",
    "France",
    "Spain",
    "Italy",
    "Netherlands",
    "Switzerland",
    "Sweden",
    "Norway",
    "Ireland",
    "United Arab Emirates",
    "Singapore",
    "Japan"
];
const $96e19f8f97c8e649$var$CountrySelector = (props)=>{
    // The dropdown label contains the flag icon followed by the country name
    // If the country name is not found, return the supplied country name
    const labelGenerator = (country)=>{
        const c = countryByName(country);
        return c ? genLabelWithFlag(c) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
            children: country
        });
    };
    // Reducer for excluding both sanctioned countries and territories with zero population
    const excludeSanctionedCountries = (acc, country)=>{
        if (!(0, $afdf282d9c361d03$export$e324f73a87016a95).has(country.name) && !(0, $afdf282d9c361d03$export$1a56b0c6dfb40ff0).has(country.name)) acc.push({
            ...country,
            flagIconSrc: (0, $9537909adb69401f$export$5cbe2f369dfef0ce)(country.isoCode)
        });
        return acc;
    };
    // Reducer for adding flag icon to list of allowed countries
    const extendAllowedCountries = (acc, country)=>{
        acc.push({
            ...country,
            flagIconSrc: (0, $9537909adb69401f$export$5cbe2f369dfef0ce)(country.isoCode)
        });
        return acc;
    };
    const countriesUnsorted = props.allowedCountries && props.allowedCountries.length > 0 ? props.allowedCountries.reduce(extendAllowedCountries, []) : (0, $e80c2cf8ebb93fb4$export$2e2bcd8739ae039).getAllCountries().reduce(excludeSanctionedCountries, []);
    const commonCountryPriority = new Map($96e19f8f97c8e649$var$COMMON_COUNTRY_NAMES.map((name, index)=>[
            name,
            index
        ]));
    const countries = [
        ...countriesUnsorted
    ].sort((a, b)=>{
        const aPriority = commonCountryPriority.get(a.name);
        const bPriority = commonCountryPriority.get(b.name);
        if (aPriority !== undefined && bPriority !== undefined) return aPriority - bPriority;
        if (aPriority !== undefined) return -1;
        if (bPriority !== undefined) return 1;
        return a.name.localeCompare(b.name);
    });
    const countryByName = (targetCountry)=>targetCountry ? countries.filter((country)=>country.name === targetCountry)[0] : undefined;
    const genLabelWithFlag = (c)=>{
        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
            children: [
                (0, $9537909adb69401f$export$fd6e61e0125bcbc0)(c.flagIconSrc),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                    children: c.name
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4e36cf643347ef05$export$2e2bcd8739ae039), {
        innerStyle: props.style,
        isSingleSelect: true,
        disabled: props.disabled,
        itemArray: countries.map((c)=>c.name),
        selectedItems: props.selectedCountry ? [
            props.selectedCountry
        ] : [],
        setSelectedItems: (selectedCountries)=>{
            const selectedCountryName = selectedCountries[0];
            props.onCountrySelected(selectedCountryName ? countryByName(selectedCountryName) : undefined);
        },
        keyExtractor: (c)=>c,
        labelExtractor: labelGenerator,
        placeholder: "Select country",
        dropdownMaxHeight: 300
    });
};
var $96e19f8f97c8e649$export$2e2bcd8739ae039 = $96e19f8f97c8e649$var$CountrySelector;








parcelRequire("bnENU");


const $1de62bdd15479f35$var$SwitchWrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  background-color: ${({ isChecked: isChecked })=>isChecked ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NICE_GREEN : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  border-radius: 50px;
  width: ${({ sizeScale: sizeScale })=>42 * sizeScale}px;
  height: ${({ sizeScale: sizeScale })=>24 * sizeScale}px;
  position: relative;
  display: flex;
  align-items: center;
  transition: 0.2s ease all;
  cursor: pointer;
  
  ${({ disabled: disabled })=>disabled && `
    cursor: default;
    opacity: 0.5;
  `}
  
  &:hover {
    background-color: ${({ isChecked: isChecked })=>isChecked ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NICE_GREEN : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER};
  }

  &:active {
    opacity: 0.75;
  }
`;
const $1de62bdd15479f35$var$SwitchInput = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).input`
  cursor: ${({ disabled: disabled })=>disabled ? "default" : "pointer"};
  appearance: none;
  width:  ${({ sizeScale: sizeScale })=>18 * sizeScale}px;
  height: ${({ sizeScale: sizeScale })=>18 * sizeScale}px;
  border-radius: 100%;
  margin: 0px;
  padding: 0px;
  position: absolute;
  left: ${({ checked: checked, sizeScale: sizeScale })=>checked ? 21 * sizeScale : 3 * sizeScale}px;
  background-color: #FFF;
  transition: 0.2s ease all;
`;
const $1de62bdd15479f35$var$Switch = ({ checked: checked, disabled: disabled, sizeScale: sizeScale = 0.85, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($1de62bdd15479f35$var$SwitchWrapper, {
        sizeScale: sizeScale,
        isChecked: checked,
        disabled: disabled,
        onClick: (_)=>{
            if (!disabled) onClick?.();
        },
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($1de62bdd15479f35$var$SwitchInput, {
            sizeScale: sizeScale,
            disabled: disabled,
            onChange: ()=>{},
            type: "checkbox",
            checked: checked,
            isChecked: checked
        })
    });
};
var $1de62bdd15479f35$export$2e2bcd8739ae039 = $1de62bdd15479f35$var$Switch;




var $fDWVA = parcelRequire("fDWVA");
var $80a0a81ef33cf27c$exports = {};
$80a0a81ef33cf27c$exports = JSON.parse('[{"name":"Canillo","isoCode":"02","countryCode":"AD","latitude":"42.59782490","longitude":"1.65663770"},{"name":"Encamp","isoCode":"03","countryCode":"AD","latitude":"42.53597640","longitude":"1.58367730"},{"name":"La Massana","isoCode":"04","countryCode":"AD","latitude":"42.54562500","longitude":"1.51473920"},{"name":"Ordino","isoCode":"05","countryCode":"AD","latitude":"42.59944330","longitude":"1.54023270"},{"name":"Sant Juli\xe0 de L\xf2ria","isoCode":"06","countryCode":"AD","latitude":"42.45296310","longitude":"1.49182350"},{"name":"Andorra la Vella","isoCode":"07","countryCode":"AD","latitude":"42.50631740","longitude":"1.52183550"},{"name":"Escaldes-Engordany","isoCode":"08","countryCode":"AD","latitude":"42.49093790","longitude":"1.58869660"},{"name":"Ajman Emirate","isoCode":"AJ","countryCode":"AE","latitude":"25.40521650","longitude":"55.51364330"},{"name":"Abu Dhabi Emirate","isoCode":"AZ","countryCode":"AE","latitude":"24.45388400","longitude":"54.37734380"},{"name":"Dubai","isoCode":"DU","countryCode":"AE","latitude":"25.20484930","longitude":"55.27078280"},{"name":"Fujairah","isoCode":"FU","countryCode":"AE","latitude":"25.12880990","longitude":"56.32648490"},{"name":"Ras al-Khaimah","isoCode":"RK","countryCode":"AE","latitude":"25.67413430","longitude":"55.98041730"},{"name":"Sharjah Emirate","isoCode":"SH","countryCode":"AE","latitude":"25.07539740","longitude":"55.75784030"},{"name":"Umm al-Quwain","isoCode":"UQ","countryCode":"AE","latitude":"25.54263240","longitude":"55.54753480"},{"name":"Balkh","isoCode":"BAL","countryCode":"AF","latitude":"36.75506030","longitude":"66.89753720"},{"name":"Bamyan","isoCode":"BAM","countryCode":"AF","latitude":"34.81000670","longitude":"67.82121040"},{"name":"Badghis","isoCode":"BDG","countryCode":"AF","latitude":"35.16713390","longitude":"63.76953840"},{"name":"Badakhshan","isoCode":"BDS","countryCode":"AF","latitude":"36.73477250","longitude":"70.81199530"},{"name":"Baghlan","isoCode":"BGL","countryCode":"AF","latitude":"36.17890260","longitude":"68.74530640"},{"name":"Daykundi","isoCode":"DAY","countryCode":"AF","latitude":"33.66949500","longitude":"66.04635340"},{"name":"Farah","isoCode":"FRA","countryCode":"AF","latitude":"32.49532800","longitude":"62.26266270"},{"name":"Faryab","isoCode":"FYB","countryCode":"AF","latitude":"36.07956130","longitude":"64.90595500"},{"name":"Ghazni","isoCode":"GHA","countryCode":"AF","latitude":"33.54505870","longitude":"68.41739720"},{"name":"Gh\u014Dr","isoCode":"GHO","countryCode":"AF","latitude":"34.09957760","longitude":"64.90595500"},{"name":"Helmand","isoCode":"HEL","countryCode":"AF","latitude":"39.29893610","longitude":"-76.61604720"},{"name":"Herat","isoCode":"HER","countryCode":"AF","latitude":"34.35286500","longitude":"62.20402870"},{"name":"Jowzjan","isoCode":"JOW","countryCode":"AF","latitude":"36.89696920","longitude":"65.66585680"},{"name":"Kabul","isoCode":"KAB","countryCode":"AF","latitude":"34.55534940","longitude":"69.20748600"},{"name":"Kandahar","isoCode":"KAN","countryCode":"AF","latitude":"31.62887100","longitude":"65.73717490"},{"name":"Kapisa","isoCode":"KAP","countryCode":"AF","latitude":"34.98105720","longitude":"69.62145620"},{"name":"Kunduz Province","isoCode":"KDZ","countryCode":"AF","latitude":"36.72855110","longitude":"68.86789820"},{"name":"Khost","isoCode":"KHO","countryCode":"AF","latitude":"33.33384720","longitude":"69.93716730"},{"name":"Kunar","isoCode":"KNR","countryCode":"AF","latitude":"34.84658930","longitude":"71.09731700"},{"name":"Laghman","isoCode":"LAG","countryCode":"AF","latitude":"34.68976870","longitude":"70.14558050"},{"name":"Logar","isoCode":"LOG","countryCode":"AF","latitude":"34.01455180","longitude":"69.19239160"},{"name":"Nangarhar","isoCode":"NAN","countryCode":"AF","latitude":"34.17183130","longitude":"70.62167940"},{"name":"Nimruz","isoCode":"NIM","countryCode":"AF","latitude":"31.02614880","longitude":"62.45041540"},{"name":"Nuristan","isoCode":"NUR","countryCode":"AF","latitude":"35.32502230","longitude":"70.90712360"},{"name":"Panjshir","isoCode":"PAN","countryCode":"AF","latitude":"38.88023910","longitude":"-77.17172380"},{"name":"Parwan","isoCode":"PAR","countryCode":"AF","latitude":"34.96309770","longitude":"68.81088490"},{"name":"Paktia","isoCode":"PIA","countryCode":"AF","latitude":"33.70619900","longitude":"69.38310790"},{"name":"Paktika","isoCode":"PKA","countryCode":"AF","latitude":"32.26453860","longitude":"68.52471490"},{"name":"Samangan","isoCode":"SAM","countryCode":"AF","latitude":"36.31555060","longitude":"67.96428630"},{"name":"Sar-e Pol","isoCode":"SAR","countryCode":"AF","latitude":"36.21662800","longitude":"65.93336000"},{"name":"Takhar","isoCode":"TAK","countryCode":"AF","latitude":"36.66980130","longitude":"69.47845410"},{"name":"Urozgan","isoCode":"URU","countryCode":"AF","latitude":"32.92712870","longitude":"66.14152630"},{"name":"Zabul","isoCode":"ZAB","countryCode":"AF","latitude":"32.19187820","longitude":"67.18944880"},{"name":"Saint George Parish","isoCode":"03","countryCode":"AG","latitude":null,"longitude":null},{"name":"Saint John Parish","isoCode":"04","countryCode":"AG","latitude":null,"longitude":null},{"name":"Saint Mary Parish","isoCode":"05","countryCode":"AG","latitude":null,"longitude":null},{"name":"Saint Paul Parish","isoCode":"06","countryCode":"AG","latitude":null,"longitude":null},{"name":"Saint Peter Parish","isoCode":"07","countryCode":"AG","latitude":null,"longitude":null},{"name":"Saint Philip Parish","isoCode":"08","countryCode":"AG","latitude":"40.43682580","longitude":"-80.06855320"},{"name":"Barbuda","isoCode":"10","countryCode":"AG","latitude":"17.62662420","longitude":"-61.77130280"},{"name":"Redonda","isoCode":"11","countryCode":"AG","latitude":"16.93841600","longitude":"-62.34551480"},{"name":"Berat County","isoCode":"01","countryCode":"AL","latitude":"40.69530120","longitude":"20.04496620"},{"name":"Durr\xebs County","isoCode":"02","countryCode":"AL","latitude":"41.50809720","longitude":"19.61631850"},{"name":"Elbasan County","isoCode":"03","countryCode":"AL","latitude":"41.12666720","longitude":"20.23556470"},{"name":"Fier County","isoCode":"04","countryCode":"AL","latitude":"40.91913920","longitude":"19.66393090"},{"name":"Gjirokast\xebr County","isoCode":"05","countryCode":"AL","latitude":"40.06728740","longitude":"20.10452290"},{"name":"Kor\xe7\xeb County","isoCode":"06","countryCode":"AL","latitude":"40.59056700","longitude":"20.61689210"},{"name":"Kuk\xebs County","isoCode":"07","countryCode":"AL","latitude":"42.08074640","longitude":"20.41429230"},{"name":"Lezh\xeb County","isoCode":"08","countryCode":"AL","latitude":"41.78137590","longitude":"19.80679160"},{"name":"Dib\xebr County","isoCode":"09","countryCode":"AL","latitude":"41.58881630","longitude":"20.23556470"},{"name":"Shkod\xebr County","isoCode":"10","countryCode":"AL","latitude":"42.15037100","longitude":"19.66393090"},{"name":"Tirana County","isoCode":"11","countryCode":"AL","latitude":"41.24275980","longitude":"19.80679160"},{"name":"Vlor\xeb County","isoCode":"12","countryCode":"AL","latitude":"40.15009600","longitude":"19.80679160"},{"name":"Berat District","isoCode":"BR","countryCode":"AL","latitude":"40.70863770","longitude":"19.94373140"},{"name":"Bulqiz\xeb District","isoCode":"BU","countryCode":"AL","latitude":"41.49425870","longitude":"20.21471570"},{"name":"Dib\xebr District","isoCode":"DI","countryCode":"AL","latitude":"41.58881630","longitude":"20.23556470"},{"name":"Delvin\xeb District","isoCode":"DL","countryCode":"AL","latitude":"39.94813640","longitude":"20.09558910"},{"name":"Durr\xebs District","isoCode":"DR","countryCode":"AL","latitude":"41.37065170","longitude":"19.52110630"},{"name":"Devoll District","isoCode":"DV","countryCode":"AL","latitude":"40.64473470","longitude":"20.95066360"},{"name":"Kolonj\xeb District","isoCode":"ER","countryCode":"AL","latitude":"40.33732620","longitude":"20.67946760"},{"name":"Fier District","isoCode":"FR","countryCode":"AL","latitude":"40.72750400","longitude":"19.56275960"},{"name":"Gjirokast\xebr District","isoCode":"GJ","countryCode":"AL","latitude":"40.06728740","longitude":"20.10452290"},{"name":"Gramsh District","isoCode":"GR","countryCode":"AL","latitude":"40.86698730","longitude":"20.18493230"},{"name":"Has District","isoCode":"HA","countryCode":"AL","latitude":"42.79013360","longitude":"-83.61220120"},{"name":"Kavaj\xeb District","isoCode":"KA","countryCode":"AL","latitude":"41.18445290","longitude":"19.56275960"},{"name":"Kurbin District","isoCode":"KB","countryCode":"AL","latitude":"41.64126440","longitude":"19.70559500"},{"name":"Ku\xe7ov\xeb District","isoCode":"KC","countryCode":"AL","latitude":"40.78370630","longitude":"19.87823480"},{"name":"Kor\xe7\xeb District","isoCode":"KO","countryCode":"AL","latitude":"40.59056700","longitude":"20.61689210"},{"name":"Kruj\xeb District","isoCode":"KR","countryCode":"AL","latitude":"41.50947650","longitude":"19.77107320"},{"name":"Kuk\xebs District","isoCode":"KU","countryCode":"AL","latitude":"42.08074640","longitude":"20.41429230"},{"name":"Librazhd District","isoCode":"LB","countryCode":"AL","latitude":"41.18292320","longitude":"20.31747690"},{"name":"Lezh\xeb District","isoCode":"LE","countryCode":"AL","latitude":"41.78607300","longitude":"19.64607580"},{"name":"Lushnj\xeb District","isoCode":"LU","countryCode":"AL","latitude":"40.94198300","longitude":"19.69964280"},{"name":"Mallakast\xebr District","isoCode":"MK","countryCode":"AL","latitude":"40.52733760","longitude":"19.78297910"},{"name":"Mal\xebsi e Madhe District","isoCode":"MM","countryCode":"AL","latitude":"42.42451730","longitude":"19.61631850"},{"name":"Mirdit\xeb District","isoCode":"MR","countryCode":"AL","latitude":"41.76428600","longitude":"19.90205090"},{"name":"Mat District","isoCode":"MT","countryCode":"AL","latitude":"41.59376750","longitude":"19.99732440"},{"name":"Pogradec District","isoCode":"PG","countryCode":"AL","latitude":"40.90153140","longitude":"20.65562890"},{"name":"Peqin District","isoCode":"PQ","countryCode":"AL","latitude":"41.04709020","longitude":"19.75023840"},{"name":"P\xebrmet District","isoCode":"PR","countryCode":"AL","latitude":"40.23618370","longitude":"20.35173340"},{"name":"Puk\xeb District","isoCode":"PU","countryCode":"AL","latitude":"42.04697720","longitude":"19.89609680"},{"name":"Shkod\xebr District","isoCode":"SH","countryCode":"AL","latitude":"42.06929850","longitude":"19.50325590"},{"name":"Skrapar District","isoCode":"SK","countryCode":"AL","latitude":"40.53499460","longitude":"20.28322170"},{"name":"Sarand\xeb District","isoCode":"SR","countryCode":"AL","latitude":"39.85921190","longitude":"20.02710010"},{"name":"Tepelen\xeb District","isoCode":"TE","countryCode":"AL","latitude":"40.29666320","longitude":"20.01816730"},{"name":"Tropoj\xeb District","isoCode":"TP","countryCode":"AL","latitude":"42.39821510","longitude":"20.16259550"},{"name":"Tirana District","isoCode":"TR","countryCode":"AL","latitude":"41.32754590","longitude":"19.81869820"},{"name":"Vlor\xeb District","isoCode":"VL","countryCode":"AL","latitude":"40.46606680","longitude":"19.49135600"},{"name":"Aragatsotn Region","isoCode":"AG","countryCode":"AM","latitude":"40.33473010","longitude":"44.37482960"},{"name":"Ararat Province","isoCode":"AR","countryCode":"AM","latitude":"39.91394150","longitude":"44.72000040"},{"name":"Armavir Region","isoCode":"AV","countryCode":"AM","latitude":"40.15546310","longitude":"44.03724460"},{"name":"Yerevan","isoCode":"ER","countryCode":"AM","latitude":"40.18720230","longitude":"44.51520900"},{"name":"Gegharkunik Province","isoCode":"GR","countryCode":"AM","latitude":"40.35264260","longitude":"45.12604140"},{"name":"Kotayk Region","isoCode":"KT","countryCode":"AM","latitude":"40.54102140","longitude":"44.76901480"},{"name":"Lori Region","isoCode":"LO","countryCode":"AM","latitude":"40.96984520","longitude":"44.49001380"},{"name":"Shirak Region","isoCode":"SH","countryCode":"AM","latitude":"40.96308140","longitude":"43.81024610"},{"name":"Syunik Province","isoCode":"SU","countryCode":"AM","latitude":"39.51331120","longitude":"46.33932340"},{"name":"Tavush Region","isoCode":"TV","countryCode":"AM","latitude":"40.88662960","longitude":"45.33934900"},{"name":"Vayots Dzor Region","isoCode":"VD","countryCode":"AM","latitude":"39.76419960","longitude":"45.33375280"},{"name":"Bengo Province","isoCode":"BGO","countryCode":"AO","latitude":"-9.10422570","longitude":"13.72891670"},{"name":"Benguela Province","isoCode":"BGU","countryCode":"AO","latitude":"-12.80037440","longitude":"13.91439900"},{"name":"Bi\xe9 Province","isoCode":"BIE","countryCode":"AO","latitude":"-12.57279070","longitude":"17.66888700"},{"name":"Cabinda Province","isoCode":"CAB","countryCode":"AO","latitude":"-5.02487490","longitude":"12.34638750"},{"name":"Cuando Cubango Province","isoCode":"CCU","countryCode":"AO","latitude":"-16.41808240","longitude":"18.80761950"},{"name":"Cunene Province","isoCode":"CNN","countryCode":"AO","latitude":"-16.28022210","longitude":"16.15809370"},{"name":"Cuanza Norte Province","isoCode":"CNO","countryCode":"AO","latitude":"-9.23985130","longitude":"14.65878210"},{"name":"Cuanza Sul","isoCode":"CUS","countryCode":"AO","latitude":"-10.59519100","longitude":"15.40680790"},{"name":"Huambo Province","isoCode":"HUA","countryCode":"AO","latitude":"-12.52682210","longitude":"15.59433880"},{"name":"Hu\xedla Province","isoCode":"HUI","countryCode":"AO","latitude":"-14.92805530","longitude":"14.65878210"},{"name":"Lunda Norte Province","isoCode":"LNO","countryCode":"AO","latitude":"-8.35250220","longitude":"19.18800470"},{"name":"Lunda Sul Province","isoCode":"LSU","countryCode":"AO","latitude":"-10.28665780","longitude":"20.71224650"},{"name":"Luanda Province","isoCode":"LUA","countryCode":"AO","latitude":"-9.03508800","longitude":"13.26634790"},{"name":"Malanje Province","isoCode":"MAL","countryCode":"AO","latitude":"-9.82511830","longitude":"16.91225100"},{"name":"Moxico Province","isoCode":"MOX","countryCode":"AO","latitude":"-13.42935790","longitude":"20.33088140"},{"name":"U\xedge Province","isoCode":"UIG","countryCode":"AO","latitude":"-7.17367320","longitude":"15.40680790"},{"name":"Zaire Province","isoCode":"ZAI","countryCode":"AO","latitude":"-6.57334580","longitude":"13.17403480"},{"name":"Salta","isoCode":"A","countryCode":"AR","latitude":"-24.79976880","longitude":"-65.41503670"},{"name":"Buenos Aires","isoCode":"B","countryCode":"AR","latitude":"-37.20172850","longitude":"-59.84106970"},{"name":"Ciudad Aut\xf3noma de Buenos Aires","isoCode":"C","countryCode":"AR","latitude":"-34.60368440","longitude":"-58.38155910"},{"name":"San Luis","isoCode":"D","countryCode":"AR","latitude":"-33.29620420","longitude":"-66.32949480"},{"name":"Entre R\xedos","isoCode":"E","countryCode":"AR","latitude":"-31.77466540","longitude":"-60.49564610"},{"name":"La Rioja","isoCode":"F","countryCode":"AR","latitude":"-29.41937930","longitude":"-66.85599320"},{"name":"Santiago del Estero","isoCode":"G","countryCode":"AR","latitude":"-27.78335740","longitude":"-64.26416700"},{"name":"Chaco","isoCode":"H","countryCode":"AR","latitude":"-27.42571750","longitude":"-59.02437840"},{"name":"San Juan","isoCode":"J","countryCode":"AR","latitude":"-31.53169760","longitude":"-68.56769620"},{"name":"Catamarca","isoCode":"K","countryCode":"AR","latitude":"-28.47158770","longitude":"-65.78772090"},{"name":"La Pampa","isoCode":"L","countryCode":"AR","latitude":"-36.61475730","longitude":"-64.28392090"},{"name":"Mendoza","isoCode":"M","countryCode":"AR","latitude":"-32.88945870","longitude":"-68.84583860"},{"name":"Misiones","isoCode":"N","countryCode":"AR","latitude":"-27.42692550","longitude":"-55.94670760"},{"name":"Formosa","isoCode":"P","countryCode":"AR","latitude":"-26.18948040","longitude":"-58.22428060"},{"name":"Neuqu\xe9n","isoCode":"Q","countryCode":"AR","latitude":"-38.94587000","longitude":"-68.07309250"},{"name":"R\xedo Negro","isoCode":"R","countryCode":"AR","latitude":"-40.82614340","longitude":"-63.02663390"},{"name":"Santa Fe","isoCode":"S","countryCode":"AR","latitude":"-31.58551090","longitude":"-60.72380160"},{"name":"Tucum\xe1n","isoCode":"T","countryCode":"AR","latitude":"-26.82211270","longitude":"-65.21929030"},{"name":"Chubut","isoCode":"U","countryCode":"AR","latitude":"-43.29342460","longitude":"-65.11148180"},{"name":"Tierra del Fuego","isoCode":"V","countryCode":"AR","latitude":"-54.80539980","longitude":"-68.32420610"},{"name":"Corrientes","isoCode":"W","countryCode":"AR","latitude":"-27.46921310","longitude":"-58.83063490"},{"name":"C\xf3rdoba","isoCode":"X","countryCode":"AR","latitude":"-31.39928760","longitude":"-64.26438420"},{"name":"Jujuy","isoCode":"Y","countryCode":"AR","latitude":"-24.18433970","longitude":"-65.30217700"},{"name":"Santa Cruz","isoCode":"Z","countryCode":"AR","latitude":"-51.63528210","longitude":"-69.24743530"},{"name":"Burgenland","isoCode":"1","countryCode":"AT","latitude":"47.15371650","longitude":"16.26887970"},{"name":"Carinthia","isoCode":"2","countryCode":"AT","latitude":"46.72220300","longitude":"14.18058820"},{"name":"Lower Austria","isoCode":"3","countryCode":"AT","latitude":"48.10807700","longitude":"15.80495580"},{"name":"Upper Austria","isoCode":"4","countryCode":"AT","latitude":"48.02585400","longitude":"13.97236650"},{"name":"Salzburg","isoCode":"5","countryCode":"AT","latitude":"47.80949000","longitude":"13.05501000"},{"name":"Styria","isoCode":"6","countryCode":"AT","latitude":"47.35934420","longitude":"14.46998270"},{"name":"Tyrol","isoCode":"7","countryCode":"AT","latitude":"47.25374140","longitude":"11.60148700"},{"name":"Vorarlberg","isoCode":"8","countryCode":"AT","latitude":"47.24974270","longitude":"9.97973730"},{"name":"Vienna","isoCode":"9","countryCode":"AT","latitude":"48.20817430","longitude":"16.37381890"},{"name":"Australian Capital Territory","isoCode":"ACT","countryCode":"AU","latitude":"-35.47346790","longitude":"149.01236790"},{"name":"New South Wales","isoCode":"NSW","countryCode":"AU","latitude":"-31.25321830","longitude":"146.92109900"},{"name":"Northern Territory","isoCode":"NT","countryCode":"AU","latitude":"-19.49141080","longitude":"132.55096030"},{"name":"Queensland","isoCode":"QLD","countryCode":"AU","latitude":"-20.91757380","longitude":"142.70279560"},{"name":"South Australia","isoCode":"SA","countryCode":"AU","latitude":"-30.00023150","longitude":"136.20915470"},{"name":"Tasmania","isoCode":"TAS","countryCode":"AU","latitude":"-41.45451960","longitude":"145.97066470"},{"name":"Victoria","isoCode":"VIC","countryCode":"AU","latitude":"-36.48564230","longitude":"140.97794250"},{"name":"Western Australia","isoCode":"WA","countryCode":"AU","latitude":"-27.67281680","longitude":"121.62830980"},{"name":"Absheron District","isoCode":"ABS","countryCode":"AZ","latitude":"40.36296930","longitude":"49.27368150"},{"name":"Agstafa District","isoCode":"AGA","countryCode":"AZ","latitude":"41.26559330","longitude":"45.51342910"},{"name":"Aghjabadi District","isoCode":"AGC","countryCode":"AZ","latitude":"28.78918410","longitude":"77.51607880"},{"name":"Agdam District","isoCode":"AGM","countryCode":"AZ","latitude":"39.99318530","longitude":"46.99495620"},{"name":"Agdash District","isoCode":"AGS","countryCode":"AZ","latitude":"40.63354270","longitude":"47.46743100"},{"name":"Agsu District","isoCode":"AGU","countryCode":"AZ","latitude":"40.52833390","longitude":"48.36508350"},{"name":"Astara District","isoCode":"AST","countryCode":"AZ","latitude":"38.49378450","longitude":"48.69443650"},{"name":"Baku","isoCode":"BA","countryCode":"AZ","latitude":"40.40926170","longitude":"49.86709240"},{"name":"Babek District","isoCode":"BAB","countryCode":"AZ","latitude":"39.15076130","longitude":"45.44853680"},{"name":"Balakan District","isoCode":"BAL","countryCode":"AZ","latitude":"41.70375090","longitude":"46.40442130"},{"name":"Barda District","isoCode":"BAR","countryCode":"AZ","latitude":"40.37065550","longitude":"47.13789090"},{"name":"Beylagan District","isoCode":"BEY","countryCode":"AZ","latitude":"39.77230730","longitude":"47.61541660"},{"name":"Bilasuvar District","isoCode":"BIL","countryCode":"AZ","latitude":"39.45988330","longitude":"48.55098130"},{"name":"Jabrayil District","isoCode":"CAB","countryCode":"AZ","latitude":"39.26455440","longitude":"46.96215620"},{"name":"Jalilabad District","isoCode":"CAL","countryCode":"AZ","latitude":"39.20516320","longitude":"48.51006040"},{"name":"Julfa District","isoCode":"CUL","countryCode":"AZ","latitude":"38.96049830","longitude":"45.62929390"},{"name":"Dashkasan District","isoCode":"DAS","countryCode":"AZ","latitude":"40.52022570","longitude":"46.07793040"},{"name":"Fizuli District","isoCode":"FUZ","countryCode":"AZ","latitude":"39.53786050","longitude":"47.30338770"},{"name":"Ganja","isoCode":"GA","countryCode":"AZ","latitude":"36.36873380","longitude":"-95.99857670"},{"name":"G\u0259d\u0259b\u0259y","isoCode":"GAD","countryCode":"AZ","latitude":"40.56996390","longitude":"45.81068830"},{"name":"Goranboy District","isoCode":"GOR","countryCode":"AZ","latitude":"40.53805060","longitude":"46.59908910"},{"name":"Goychay","isoCode":"GOY","countryCode":"AZ","latitude":"40.62361680","longitude":"47.74030340"},{"name":"Goygol District","isoCode":"GYG","countryCode":"AZ","latitude":"40.55953780","longitude":"46.33149530"},{"name":"Hajigabul District","isoCode":"HAC","countryCode":"AZ","latitude":"40.03937700","longitude":"48.92025330"},{"name":"Imishli District","isoCode":"IMI","countryCode":"AZ","latitude":"39.86946860","longitude":"48.06652180"},{"name":"Ismailli District","isoCode":"ISM","countryCode":"AZ","latitude":"40.74299360","longitude":"48.21255560"},{"name":"Kalbajar District","isoCode":"KAL","countryCode":"AZ","latitude":"40.10243290","longitude":"46.03648720"},{"name":"Kangarli District","isoCode":"KAN","countryCode":"AZ","latitude":"39.38719400","longitude":"45.16398520"},{"name":"Kurdamir District","isoCode":"KUR","countryCode":"AZ","latitude":"40.36986510","longitude":"48.16446260"},{"name":"Lankaran District","isoCode":"LA","countryCode":"AZ","latitude":"38.75286690","longitude":"48.84750150"},{"name":"Lachin District","isoCode":"LAC","countryCode":"AZ","latitude":"39.63834140","longitude":"46.54608530"},{"name":"Lankaran","isoCode":"LAN","countryCode":"AZ","latitude":"38.75286690","longitude":"48.84750150"},{"name":"Lerik District","isoCode":"LER","countryCode":"AZ","latitude":"38.77361920","longitude":"48.41514830"},{"name":"Masally District","isoCode":"MAS","countryCode":"AZ","latitude":"39.03407220","longitude":"48.65893540"},{"name":"Mingachevir","isoCode":"MI","countryCode":"AZ","latitude":"40.77025630","longitude":"47.04960150"},{"name":"Neftchala District","isoCode":"NEF","countryCode":"AZ","latitude":"39.38810520","longitude":"49.24137430"},{"name":"Nakhchivan Autonomous Republic","isoCode":"NX","countryCode":"AZ","latitude":"39.32568140","longitude":"45.49126480"},{"name":"Oghuz District","isoCode":"OGU","countryCode":"AZ","latitude":"41.07279240","longitude":"47.46506720"},{"name":"Ordubad District","isoCode":"ORD","countryCode":"AZ","latitude":"38.90216220","longitude":"46.02376250"},{"name":"Qabala District","isoCode":"QAB","countryCode":"AZ","latitude":"40.92539250","longitude":"47.80161060"},{"name":"Qakh District","isoCode":"QAX","countryCode":"AZ","latitude":"41.42068270","longitude":"46.93201840"},{"name":"Qazakh District","isoCode":"QAZ","countryCode":"AZ","latitude":"41.09710740","longitude":"45.35163310"},{"name":"Quba District","isoCode":"QBA","countryCode":"AZ","latitude":"41.15642420","longitude":"48.41350210"},{"name":"Qubadli District","isoCode":"QBI","countryCode":"AZ","latitude":"39.27139960","longitude":"46.63543120"},{"name":"Gobustan District","isoCode":"QOB","countryCode":"AZ","latitude":"40.53261040","longitude":"48.92737500"},{"name":"Qusar District","isoCode":"QUS","countryCode":"AZ","latitude":"41.42668860","longitude":"48.43455770"},{"name":"Shaki","isoCode":"SA","countryCode":"AZ","latitude":"41.19747530","longitude":"47.15712410"},{"name":"Sabirabad District","isoCode":"SAB","countryCode":"AZ","latitude":"39.98706630","longitude":"48.46925450"},{"name":"Sadarak District","isoCode":"SAD","countryCode":"AZ","latitude":"39.71051140","longitude":"44.88642770"},{"name":"Shahbuz District","isoCode":"SAH","countryCode":"AZ","latitude":"39.44521030","longitude":"45.65680090"},{"name":"Shaki District","isoCode":"SAK","countryCode":"AZ","latitude":"41.11346620","longitude":"47.13169270"},{"name":"Salyan District","isoCode":"SAL","countryCode":"AZ","latitude":"28.35248110","longitude":"82.12784000"},{"name":"Sharur District","isoCode":"SAR","countryCode":"AZ","latitude":"39.55363320","longitude":"44.98456800"},{"name":"Saatly District","isoCode":"SAT","countryCode":"AZ","latitude":"39.90955030","longitude":"48.35951220"},{"name":"Shabran District","isoCode":"SBN","countryCode":"AZ","latitude":"41.22283760","longitude":"48.84573040"},{"name":"Siazan District","isoCode":"SIY","countryCode":"AZ","latitude":"41.07838330","longitude":"49.11184770"},{"name":"Shamkir District","isoCode":"SKR","countryCode":"AZ","latitude":"40.82881440","longitude":"46.01668790"},{"name":"Sumqayit","isoCode":"SM","countryCode":"AZ","latitude":"40.58547650","longitude":"49.63174110"},{"name":"Shamakhi District","isoCode":"SMI","countryCode":"AZ","latitude":"40.63187310","longitude":"48.63638010"},{"name":"Samukh District","isoCode":"SMX","countryCode":"AZ","latitude":"40.76046310","longitude":"46.40631810"},{"name":"Shirvan","isoCode":"SR","countryCode":"AZ","latitude":"39.94697070","longitude":"48.92239190"},{"name":"Shusha District","isoCode":"SUS","countryCode":"AZ","latitude":"39.75374380","longitude":"46.74647550"},{"name":"Tartar District","isoCode":"TAR","countryCode":"AZ","latitude":"40.34438750","longitude":"46.93765190"},{"name":"Tovuz District","isoCode":"TOV","countryCode":"AZ","latitude":"40.99545230","longitude":"45.61659070"},{"name":"Ujar District","isoCode":"UCA","countryCode":"AZ","latitude":"40.50675250","longitude":"47.64896410"},{"name":"Khachmaz District","isoCode":"XAC","countryCode":"AZ","latitude":"41.45911680","longitude":"48.80206260"},{"name":"Khojali District","isoCode":"XCI","countryCode":"AZ","latitude":"39.91325530","longitude":"46.79430500"},{"name":"Khizi District","isoCode":"XIZ","countryCode":"AZ","latitude":"40.91094890","longitude":"49.07292640"},{"name":"Martuni","isoCode":"XVD","countryCode":"AZ","latitude":"39.79146930","longitude":"47.11008140"},{"name":"Yardymli District","isoCode":"YAR","countryCode":"AZ","latitude":"38.90589170","longitude":"48.24961270"},{"name":"Yevlakh","isoCode":"YE","countryCode":"AZ","latitude":"40.61966380","longitude":"47.15003240"},{"name":"Yevlakh District","isoCode":"YEV","countryCode":"AZ","latitude":"40.61966380","longitude":"47.15003240"},{"name":"Zangilan District","isoCode":"ZAN","countryCode":"AZ","latitude":"39.08568990","longitude":"46.65247280"},{"name":"Zaqatala District","isoCode":"ZAQ","countryCode":"AZ","latitude":"41.59068890","longitude":"46.72403730"},{"name":"Zardab District","isoCode":"ZAR","countryCode":"AZ","latitude":"40.21481140","longitude":"47.71494400"},{"name":"Una-Sana Canton","isoCode":"01","countryCode":"BA","latitude":"44.65031160","longitude":"16.31716290"},{"name":"Posavina Canton","isoCode":"02","countryCode":"BA","latitude":"45.07520940","longitude":"18.37763040"},{"name":"Tuzla Canton","isoCode":"03","countryCode":"BA","latitude":"44.53434630","longitude":"18.69727970"},{"name":"Zenica-Doboj Canton","isoCode":"04","countryCode":"BA","latitude":"44.21271090","longitude":"18.16046250"},{"name":"Bosnian Podrinje Canton","isoCode":"05","countryCode":"BA","latitude":"43.68749000","longitude":"18.82443940"},{"name":"Central Bosnia Canton","isoCode":"06","countryCode":"BA","latitude":"44.13818560","longitude":"17.68667140"},{"name":"Herzegovina-Neretva Canton","isoCode":"07","countryCode":"BA","latitude":"43.52651590","longitude":"17.76362100"},{"name":"West Herzegovina Canton","isoCode":"08","countryCode":"BA","latitude":"43.43692440","longitude":"17.38488310"},{"name":"Sarajevo Canton","isoCode":"09","countryCode":"BA","latitude":"43.85125640","longitude":"18.29534420"},{"name":"Canton 10","isoCode":"10","countryCode":"BA","latitude":"43.95341550","longitude":"16.94251870"},{"name":"Federation of Bosnia and Herzegovina","isoCode":"BIH","countryCode":"BA","latitude":"43.88748970","longitude":"17.84279300"},{"name":"Br\u010Dko District","isoCode":"BRC","countryCode":"BA","latitude":"44.84059440","longitude":"18.74215300"},{"name":"Republika Srpska","isoCode":"SRP","countryCode":"BA","latitude":"44.72801860","longitude":"17.31481360"},{"name":"Christ Church","isoCode":"01","countryCode":"BB","latitude":"36.00604070","longitude":"-95.92112100"},{"name":"Saint Andrew","isoCode":"02","countryCode":"BB","latitude":null,"longitude":null},{"name":"Saint George","isoCode":"03","countryCode":"BB","latitude":"37.09652780","longitude":"-113.56841640"},{"name":"Saint James","isoCode":"04","countryCode":"BB","latitude":"48.52356600","longitude":"-1.32378850"},{"name":"Saint John","isoCode":"05","countryCode":"BB","latitude":"45.27331530","longitude":"-66.06330800"},{"name":"Saint Joseph","isoCode":"06","countryCode":"BB","latitude":"39.76745780","longitude":"-94.84668100"},{"name":"Saint Lucy","isoCode":"07","countryCode":"BB","latitude":"38.76146250","longitude":"-77.44914390"},{"name":"Saint Michael","isoCode":"08","countryCode":"BB","latitude":"36.03597700","longitude":"-95.84905200"},{"name":"Saint Peter","isoCode":"09","countryCode":"BB","latitude":"37.08271190","longitude":"-94.51712500"},{"name":"Saint Philip","isoCode":"10","countryCode":"BB","latitude":"35.23311400","longitude":"-89.43640420"},{"name":"Saint Thomas","isoCode":"11","countryCode":"BB","latitude":"18.33809650","longitude":"-64.89409460"},{"name":"Bandarban District","isoCode":"01","countryCode":"BD","latitude":"21.83110020","longitude":"92.36863210"},{"name":"Barguna District","isoCode":"02","countryCode":"BD","latitude":"22.09529150","longitude":"90.11206960"},{"name":"Bogra District","isoCode":"03","countryCode":"BD","latitude":"24.85104020","longitude":"89.36972250"},{"name":"Brahmanbaria District","isoCode":"04","countryCode":"BD","latitude":"23.96081810","longitude":"91.11150140"},{"name":"Bagerhat District","isoCode":"05","countryCode":"BD","latitude":"22.66024360","longitude":"89.78954780"},{"name":"Barisal District","isoCode":"06","countryCode":"BD","latitude":"22.70220980","longitude":"90.36963160"},{"name":"Bhola District","isoCode":"07","countryCode":"BD","latitude":"22.17853150","longitude":"90.71010230"},{"name":"Comilla District","isoCode":"08","countryCode":"BD","latitude":"23.45756670","longitude":"91.18089960"},{"name":"Chandpur District","isoCode":"09","countryCode":"BD","latitude":"23.25131480","longitude":"90.85178460"},{"name":"Chittagong District","isoCode":"10","countryCode":"BD","latitude":"22.51501050","longitude":"91.75388170"},{"name":"Cox\'s Bazar District","isoCode":"11","countryCode":"BD","latitude":"21.56406260","longitude":"92.02821290"},{"name":"Chuadanga District","isoCode":"12","countryCode":"BD","latitude":"23.61605120","longitude":"88.82630060"},{"name":"Dhaka District","isoCode":"13","countryCode":"BD","latitude":"23.81051400","longitude":"90.33718890"},{"name":"Dinajpur District","isoCode":"14","countryCode":"BD","latitude":"25.62791230","longitude":"88.63317580"},{"name":"Faridpur District","isoCode":"15","countryCode":"BD","latitude":"23.54239190","longitude":"89.63089210"},{"name":"Feni District","isoCode":"16","countryCode":"BD","latitude":"22.94087840","longitude":"91.40666460"},{"name":"Gopalganj District","isoCode":"17","countryCode":"BD","latitude":"26.48315840","longitude":"84.43655000"},{"name":"Gazipur District","isoCode":"18","countryCode":"BD","latitude":"24.09581710","longitude":"90.41251810"},{"name":"Gaibandha District","isoCode":"19","countryCode":"BD","latitude":"25.32969280","longitude":"89.54296520"},{"name":"Habiganj District","isoCode":"20","countryCode":"BD","latitude":"24.47712360","longitude":"91.45065650"},{"name":"Jamalpur District","isoCode":"21","countryCode":"BD","latitude":"25.08309260","longitude":"89.78532180"},{"name":"Jessore District","isoCode":"22","countryCode":"BD","latitude":"23.16340140","longitude":"89.21816640"},{"name":"Jhenaidah District","isoCode":"23","countryCode":"BD","latitude":"23.54498730","longitude":"89.17260310"},{"name":"Joypurhat District","isoCode":"24","countryCode":"BD","latitude":"25.09473490","longitude":"89.09449370"},{"name":"Jhalokati District","isoCode":"25","countryCode":"BD","latitude":"22.57208000","longitude":"90.18696440"},{"name":"Kishoreganj District","isoCode":"26","countryCode":"BD","latitude":"24.42604570","longitude":"90.98206680"},{"name":"Khulna District","isoCode":"27","countryCode":"BD","latitude":"22.67377350","longitude":"89.39665810"},{"name":"Kurigram District","isoCode":"28","countryCode":"BD","latitude":"25.80724140","longitude":"89.62947460"},{"name":"Khagrachari District","isoCode":"29","countryCode":"BD","latitude":"23.13217510","longitude":"91.94902100"},{"name":"Kushtia District","isoCode":"30","countryCode":"BD","latitude":"23.89069950","longitude":"89.10993680"},{"name":"Lakshmipur District","isoCode":"31","countryCode":"BD","latitude":"22.94467440","longitude":"90.82819070"},{"name":"Lalmonirhat District","isoCode":"32","countryCode":"BD","latitude":"25.99233980","longitude":"89.28472510"},{"name":"Bahadia","isoCode":"33","countryCode":"BD","latitude":"23.78987120","longitude":"90.16714830"},{"name":"Mymensingh District","isoCode":"34","countryCode":"BD","latitude":"24.75385750","longitude":"90.40729190"},{"name":"Munshiganj District","isoCode":"35","countryCode":"BD","latitude":"23.49809310","longitude":"90.41266210"},{"name":"Madaripur District","isoCode":"36","countryCode":"BD","latitude":"23.23933460","longitude":"90.18696440"},{"name":"Moulvibazar District","isoCode":"38","countryCode":"BD","latitude":"24.30953440","longitude":"91.73149030"},{"name":"Meherpur District","isoCode":"39","countryCode":"BD","latitude":"23.80519910","longitude":"88.67235780"},{"name":"Narayanganj District","isoCode":"40","countryCode":"BD","latitude":"23.71466010","longitude":"90.56360900"},{"name":"Netrokona District","isoCode":"41","countryCode":"BD","latitude":"24.81032840","longitude":"90.86564150"},{"name":"Narail District","isoCode":"43","countryCode":"BD","latitude":"23.11629290","longitude":"89.58404040"},{"name":"Natore District","isoCode":"44","countryCode":"BD","latitude":"24.41024300","longitude":"89.00761770"},{"name":"Chapai Nawabganj District","isoCode":"45","countryCode":"BD","latitude":"24.74131110","longitude":"88.29120690"},{"name":"Nilphamari District","isoCode":"46","countryCode":"BD","latitude":"25.84827980","longitude":"88.94141340"},{"name":"Noakhali District","isoCode":"47","countryCode":"BD","latitude":"22.87237890","longitude":"91.09731840"},{"name":"Naogaon District","isoCode":"48","countryCode":"BD","latitude":"24.91315970","longitude":"88.75309520"},{"name":"Pabna District","isoCode":"49","countryCode":"BD","latitude":"24.15850500","longitude":"89.44807180"},{"name":"Pirojpur District","isoCode":"50","countryCode":"BD","latitude":"22.57907440","longitude":"89.97592640"},{"name":"Patuakhali District","isoCode":"51","countryCode":"BD","latitude":"22.22486320","longitude":"90.45475030"},{"name":"Panchagarh District","isoCode":"52","countryCode":"BD","latitude":"26.27087050","longitude":"88.59517510"},{"name":"Rajbari District","isoCode":"53","countryCode":"BD","latitude":"23.71513400","longitude":"89.58748190"},{"name":"Rajshahi District","isoCode":"54","countryCode":"BD","latitude":"24.37330870","longitude":"88.60487160"},{"name":"Rangpur District","isoCode":"55","countryCode":"BD","latitude":"25.74679250","longitude":"89.25083350"},{"name":"Rangamati Hill District","isoCode":"56","countryCode":"BD","latitude":"22.73241730","longitude":"92.29851340"},{"name":"Sherpur District","isoCode":"57","countryCode":"BD","latitude":"25.07462350","longitude":"90.14949040"},{"name":"Satkhira District","isoCode":"58","countryCode":"BD","latitude":"22.31548120","longitude":"89.11145250"},{"name":"Sirajganj District","isoCode":"59","countryCode":"BD","latitude":"24.31411150","longitude":"89.56996150"},{"name":"Sylhet District","isoCode":"60","countryCode":"BD","latitude":"24.89933570","longitude":"91.87004730"},{"name":"Sunamganj District","isoCode":"61","countryCode":"BD","latitude":"25.07145350","longitude":"91.39916270"},{"name":"Shariatpur District","isoCode":"62","countryCode":"BD","latitude":"23.24232140","longitude":"90.43477110"},{"name":"Tangail District","isoCode":"63","countryCode":"BD","latitude":"24.39174270","longitude":"89.99482570"},{"name":"Thakurgaon District","isoCode":"64","countryCode":"BD","latitude":"26.04183920","longitude":"88.42826160"},{"name":"Barisal Division","isoCode":"A","countryCode":"BD","latitude":"22.38111310","longitude":"90.33718890"},{"name":"Chittagong Division","isoCode":"B","countryCode":"BD","latitude":"23.17931570","longitude":"91.98815270"},{"name":"Dhaka Division","isoCode":"C","countryCode":"BD","latitude":"23.95357420","longitude":"90.14949880"},{"name":"Khulna Division","isoCode":"D","countryCode":"BD","latitude":"22.80878160","longitude":"89.24671910"},{"name":"Rajshahi Division","isoCode":"E","countryCode":"BD","latitude":"24.71057760","longitude":"88.94138650"},{"name":"Rangpur Division","isoCode":"F","countryCode":"BD","latitude":"25.84833880","longitude":"88.94138650"},{"name":"Sylhet Division","isoCode":"G","countryCode":"BD","latitude":"24.70498110","longitude":"91.67606910"},{"name":"Mymensingh Division","isoCode":"H","countryCode":"BD","latitude":"24.71362000","longitude":"90.45023680"},{"name":"Brussels-Capital Region","isoCode":"BRU","countryCode":"BE","latitude":"50.85034630","longitude":"4.35172110"},{"name":"Antwerp","isoCode":"VAN","countryCode":"BE","latitude":"51.21944750","longitude":"4.40246430"},{"name":"Flemish Brabant","isoCode":"VBR","countryCode":"BE","latitude":"50.88154340","longitude":"4.56459700"},{"name":"Flanders","isoCode":"VLG","countryCode":"BE","latitude":"51.01087060","longitude":"3.72646130"},{"name":"Limburg","isoCode":"VLI","countryCode":"BE","latitude":null,"longitude":null},{"name":"East Flanders","isoCode":"VOV","countryCode":"BE","latitude":"51.03621010","longitude":"3.73731240"},{"name":"West Flanders","isoCode":"VWV","countryCode":"BE","latitude":"40.01793340","longitude":"-105.28067330"},{"name":"Wallonia","isoCode":"WAL","countryCode":"BE","latitude":"50.41756370","longitude":"4.45100660"},{"name":"Walloon Brabant","isoCode":"WBR","countryCode":"BE","latitude":"50.63324100","longitude":"4.52431500"},{"name":"Hainaut","isoCode":"WHT","countryCode":"BE","latitude":"50.52570760","longitude":"4.06210170"},{"name":"Li\xe8ge","isoCode":"WLG","countryCode":"BE","latitude":"50.63255740","longitude":"5.57966620"},{"name":"Luxembourg","isoCode":"WLX","countryCode":"BE","latitude":"49.81527300","longitude":"6.12958300"},{"name":"Namur","isoCode":"WNA","countryCode":"BE","latitude":"50.46738830","longitude":"4.87198540"},{"name":"Boucle du Mouhoun Region","isoCode":"01","countryCode":"BF","latitude":"12.41660000","longitude":"-3.41955270"},{"name":"Cascades Region","isoCode":"02","countryCode":"BF","latitude":"10.40729920","longitude":"-4.56244260"},{"name":"Centre","isoCode":"03","countryCode":"BF","latitude":null,"longitude":null},{"name":"Centre-Est Region","isoCode":"04","countryCode":"BF","latitude":"11.52476740","longitude":"-0.14949880"},{"name":"Centre-Nord Region","isoCode":"05","countryCode":"BF","latitude":"13.17244640","longitude":"-0.90566230"},{"name":"Centre-Ouest Region","isoCode":"06","countryCode":"BF","latitude":"11.87984660","longitude":"-2.30244600"},{"name":"Centre-Sud Region","isoCode":"07","countryCode":"BF","latitude":"11.52289110","longitude":"-1.05861350"},{"name":"Est Region","isoCode":"08","countryCode":"BF","latitude":"12.43655260","longitude":"0.90566230"},{"name":"Hauts-Bassins Region","isoCode":"09","countryCode":"BF","latitude":"11.49420030","longitude":"-4.23333550"},{"name":"Nord Region, Burkina Faso","isoCode":"10","countryCode":"BF","latitude":"13.71825200","longitude":"-2.30244600"},{"name":"Plateau-Central Region","isoCode":"11","countryCode":"BF","latitude":"12.25376480","longitude":"-0.75328090"},{"name":"Sahel Region","isoCode":"12","countryCode":"BF","latitude":"14.10008650","longitude":"-0.14949880"},{"name":"Sud-Ouest Region","isoCode":"13","countryCode":"BF","latitude":"10.42314930","longitude":"-3.25836260"},{"name":"Bal\xe9 Province","isoCode":"BAL","countryCode":"BF","latitude":"11.78206020","longitude":"-3.01757120"},{"name":"Bam Province","isoCode":"BAM","countryCode":"BF","latitude":"13.44613300","longitude":"-1.59839590"},{"name":"Banwa Province","isoCode":"BAN","countryCode":"BF","latitude":"12.13230530","longitude":"-4.15137640"},{"name":"Baz\xe8ga Province","isoCode":"BAZ","countryCode":"BF","latitude":"11.97676920","longitude":"-1.44346900"},{"name":"Bougouriba Province","isoCode":"BGR","countryCode":"BF","latitude":"10.87226460","longitude":"-3.33889170"},{"name":"Boulgou","isoCode":"BLG","countryCode":"BF","latitude":"11.43367660","longitude":"-0.37483540"},{"name":"Como\xe9 Province","isoCode":"COM","countryCode":"BF","latitude":"10.40729920","longitude":"-4.56244260"},{"name":"Ganzourgou Province","isoCode":"GAN","countryCode":"BF","latitude":"12.25376480","longitude":"-0.75328090"},{"name":"Gnagna Province","isoCode":"GNA","countryCode":"BF","latitude":"12.89749920","longitude":"0.07467670"},{"name":"Gourma Province","isoCode":"GOU","countryCode":"BF","latitude":"12.16244730","longitude":"0.67730460"},{"name":"Houet Province","isoCode":"HOU","countryCode":"BF","latitude":"11.13204470","longitude":"-4.23333550"},{"name":"Ioba Province","isoCode":"IOB","countryCode":"BF","latitude":"11.05620340","longitude":"-3.01757120"},{"name":"Kadiogo Province","isoCode":"KAD","countryCode":"BF","latitude":"12.34258970","longitude":"-1.44346900"},{"name":"K\xe9n\xe9dougou Province","isoCode":"KEN","countryCode":"BF","latitude":"11.39193950","longitude":"-4.97665400"},{"name":"Komondjari Province","isoCode":"KMD","countryCode":"BF","latitude":"12.71265270","longitude":"0.67730460"},{"name":"Kompienga Province","isoCode":"KMP","countryCode":"BF","latitude":"11.52383620","longitude":"0.75328090"},{"name":"Koulp\xe9logo Province","isoCode":"KOP","countryCode":"BF","latitude":"11.52476740","longitude":"0.14949880"},{"name":"Kossi Province","isoCode":"KOS","countryCode":"BF","latitude":"12.96045800","longitude":"-3.90626880"},{"name":"Kouritenga Province","isoCode":"KOT","countryCode":"BF","latitude":"12.16318130","longitude":"-0.22446620"},{"name":"Kourw\xe9ogo Province","isoCode":"KOW","countryCode":"BF","latitude":"12.70774950","longitude":"-1.75388170"},{"name":"L\xe9raba Province","isoCode":"LER","countryCode":"BF","latitude":"10.66487850","longitude":"-5.31025050"},{"name":"Loroum Province","isoCode":"LOR","countryCode":"BF","latitude":"13.81298140","longitude":"-2.06651970"},{"name":"Mouhoun","isoCode":"MOU","countryCode":"BF","latitude":"12.14323810","longitude":"-3.33889170"},{"name":"Namentenga Province","isoCode":"NAM","countryCode":"BF","latitude":"13.08125840","longitude":"-0.52578230"},{"name":"Nahouri Province","isoCode":"NAO","countryCode":"BF","latitude":"11.25022670","longitude":"-1.13530200"},{"name":"Nayala Province","isoCode":"NAY","countryCode":"BF","latitude":"12.69645580","longitude":"-3.01757120"},{"name":"Noumbiel Province","isoCode":"NOU","countryCode":"BF","latitude":"9.84409460","longitude":"-2.97755580"},{"name":"Oubritenga Province","isoCode":"OUB","countryCode":"BF","latitude":"12.70960870","longitude":"-1.44346900"},{"name":"Oudalan Province","isoCode":"OUD","countryCode":"BF","latitude":"14.47190200","longitude":"-0.45023680"},{"name":"Passor\xe9 Province","isoCode":"PAS","countryCode":"BF","latitude":"12.88812210","longitude":"-2.22366670"},{"name":"Poni Province","isoCode":"PON","countryCode":"BF","latitude":"10.33259960","longitude":"-3.33889170"},{"name":"S\xe9no Province","isoCode":"SEN","countryCode":"BF","latitude":"14.00722340","longitude":"-0.07467670"},{"name":"Sissili Province","isoCode":"SIS","countryCode":"BF","latitude":"11.24412190","longitude":"-2.22366670"},{"name":"Sanmatenga Province","isoCode":"SMT","countryCode":"BF","latitude":"13.35653040","longitude":"-1.05861350"},{"name":"Sangui\xe9 Province","isoCode":"SNG","countryCode":"BF","latitude":"12.15018610","longitude":"-2.69838680"},{"name":"Soum Province","isoCode":"SOM","countryCode":"BF","latitude":"14.09628410","longitude":"-1.36621600"},{"name":"Sourou Province","isoCode":"SOR","countryCode":"BF","latitude":"13.34180300","longitude":"-2.93757390"},{"name":"Tapoa Province","isoCode":"TAP","countryCode":"BF","latitude":"12.24970720","longitude":"1.67606910"},{"name":"Tuy Province","isoCode":"TUI","countryCode":"BF","latitude":"38.88868400","longitude":"-77.00471900"},{"name":"Yagha Province","isoCode":"YAG","countryCode":"BF","latitude":"13.35761570","longitude":"0.75328090"},{"name":"Yatenga Province","isoCode":"YAT","countryCode":"BF","latitude":"13.62493440","longitude":"-2.38136210"},{"name":"Ziro Province","isoCode":"ZIR","countryCode":"BF","latitude":"11.60949950","longitude":"-1.90992380"},{"name":"Zondoma Province","isoCode":"ZON","countryCode":"BF","latitude":"13.11659260","longitude":"-2.42087130"},{"name":"Zoundw\xe9ogo Province","isoCode":"ZOU","countryCode":"BF","latitude":"11.61411740","longitude":"-0.98206680"},{"name":"Blagoevgrad Province","isoCode":"01","countryCode":"BG","latitude":"42.02086140","longitude":"23.09433560"},{"name":"Burgas Province","isoCode":"02","countryCode":"BG","latitude":"42.50480000","longitude":"27.46260790"},{"name":"Varna Province","isoCode":"03","countryCode":"BG","latitude":"43.20464770","longitude":"27.91054880"},{"name":"Veliko Tarnovo Province","isoCode":"04","countryCode":"BG","latitude":"43.07565390","longitude":"25.61715000"},{"name":"Vidin Province","isoCode":"05","countryCode":"BG","latitude":"43.99617390","longitude":"22.86795150"},{"name":"Vratsa Province","isoCode":"06","countryCode":"BG","latitude":"43.21018060","longitude":"23.55292100"},{"name":"Gabrovo Province","isoCode":"07","countryCode":"BG","latitude":"42.86847000","longitude":"25.31688900"},{"name":"Dobrich Province","isoCode":"08","countryCode":"BG","latitude":"43.57278600","longitude":"27.82728020"},{"name":"Kardzhali Province","isoCode":"09","countryCode":"BG","latitude":"41.63384160","longitude":"25.37766870"},{"name":"Kyustendil Province","isoCode":"10","countryCode":"BG","latitude":"42.28687990","longitude":"22.69396350"},{"name":"Lovech Province","isoCode":"11","countryCode":"BG","latitude":"43.13677980","longitude":"24.71393350"},{"name":"Montana Province","isoCode":"12","countryCode":"BG","latitude":"43.40851480","longitude":"23.22575890"},{"name":"Pazardzhik Province","isoCode":"13","countryCode":"BG","latitude":"42.19275670","longitude":"24.33362260"},{"name":"Pernik Province","isoCode":"14","countryCode":"BG","latitude":"42.60519900","longitude":"23.03779160"},{"name":"Pleven Province","isoCode":"15","countryCode":"BG","latitude":"43.41701690","longitude":"24.60667080"},{"name":"Plovdiv Province","isoCode":"16","countryCode":"BG","latitude":"42.13540790","longitude":"24.74529040"},{"name":"Razgrad Province","isoCode":"17","countryCode":"BG","latitude":"43.52717050","longitude":"26.52412280"},{"name":"Ruse Province","isoCode":"18","countryCode":"BG","latitude":"43.83559640","longitude":"25.96561440"},{"name":"Silistra Province","isoCode":"19","countryCode":"BG","latitude":"44.11471010","longitude":"27.26714540"},{"name":"Sliven Province","isoCode":"20","countryCode":"BG","latitude":"42.68167020","longitude":"26.32285690"},{"name":"Smolyan Province","isoCode":"21","countryCode":"BG","latitude":"41.57741480","longitude":"24.70108710"},{"name":"Sofia City Province","isoCode":"22","countryCode":"BG","latitude":"42.75701090","longitude":"23.45046830"},{"name":"Sofia Province","isoCode":"23","countryCode":"BG","latitude":"42.67344000","longitude":"23.83349370"},{"name":"Stara Zagora Province","isoCode":"24","countryCode":"BG","latitude":"42.42577090","longitude":"25.63448550"},{"name":"Targovishte Province","isoCode":"25","countryCode":"BG","latitude":"43.24623490","longitude":"26.56912510"},{"name":"Haskovo Province","isoCode":"26","countryCode":"BG","latitude":"41.93441780","longitude":"25.55546720"},{"name":"Shumen","isoCode":"27","countryCode":"BG","latitude":"43.27123980","longitude":"26.93612860"},{"name":"Yambol Province","isoCode":"28","countryCode":"BG","latitude":"42.48414940","longitude":"26.50352960"},{"name":"Capital Governorate","isoCode":"13","countryCode":"BH","latitude":null,"longitude":null},{"name":"Southern Governorate","isoCode":"14","countryCode":"BH","latitude":"25.93810180","longitude":"50.57568870"},{"name":"Muharraq Governorate","isoCode":"15","countryCode":"BH","latitude":"26.26856530","longitude":"50.64825170"},{"name":"Central Governorate","isoCode":"16","countryCode":"BH","latitude":"26.14260930","longitude":"50.56532940"},{"name":"Northern Governorate","isoCode":"17","countryCode":"BH","latitude":"26.15519140","longitude":"50.48251730"},{"name":"Bubanza Province","isoCode":"BB","countryCode":"BI","latitude":"-3.15724030","longitude":"29.37149090"},{"name":"Bujumbura Rural Province","isoCode":"BL","countryCode":"BI","latitude":"-3.50901440","longitude":"29.46435900"},{"name":"Bujumbura Mairie Province","isoCode":"BM","countryCode":"BI","latitude":"-3.38841410","longitude":"29.34826460"},{"name":"Bururi Province","isoCode":"BR","countryCode":"BI","latitude":"-3.90068510","longitude":"29.51077080"},{"name":"Cankuzo Province","isoCode":"CA","countryCode":"BI","latitude":"-3.15277880","longitude":"30.61998950"},{"name":"Cibitoke Province","isoCode":"CI","countryCode":"BI","latitude":"-2.81028970","longitude":"29.18557850"},{"name":"Gitega Province","isoCode":"GI","countryCode":"BI","latitude":"-3.49290510","longitude":"29.92779470"},{"name":"Kirundo Province","isoCode":"KI","countryCode":"BI","latitude":"-2.57628820","longitude":"30.11273500"},{"name":"Karuzi Province","isoCode":"KR","countryCode":"BI","latitude":"-3.13403470","longitude":"30.11273500"},{"name":"Kayanza Province","isoCode":"KY","countryCode":"BI","latitude":"-3.00779810","longitude":"29.64991620"},{"name":"Makamba Province","isoCode":"MA","countryCode":"BI","latitude":"-4.32570620","longitude":"29.69626770"},{"name":"Muramvya Province","isoCode":"MU","countryCode":"BI","latitude":"-3.28983980","longitude":"29.64991620"},{"name":"Mwaro Province","isoCode":"MW","countryCode":"BI","latitude":"-3.50259180","longitude":"29.64991620"},{"name":"Muyinga Province","isoCode":"MY","countryCode":"BI","latitude":"-2.77935110","longitude":"30.29741990"},{"name":"Ngozi Province","isoCode":"NG","countryCode":"BI","latitude":"-2.89582430","longitude":"29.88152030"},{"name":"Rumonge Province","isoCode":"RM","countryCode":"BI","latitude":"-3.97540490","longitude":"29.43880140"},{"name":"Rutana Province","isoCode":"RT","countryCode":"BI","latitude":"-3.87915230","longitude":"30.06652360"},{"name":"Ruyigi Province","isoCode":"RY","countryCode":"BI","latitude":"-3.44620700","longitude":"30.25127280"},{"name":"Atakora Department","isoCode":"AK","countryCode":"BJ","latitude":"10.79549310","longitude":"1.67606910"},{"name":"Alibori Department","isoCode":"AL","countryCode":"BJ","latitude":"10.96810930","longitude":"2.77798130"},{"name":"Atlantique Department","isoCode":"AQ","countryCode":"BJ","latitude":"6.65883910","longitude":"2.22366670"},{"name":"Borgou Department","isoCode":"BO","countryCode":"BJ","latitude":"9.53408640","longitude":"2.77798130"},{"name":"Collines Department","isoCode":"CO","countryCode":"BJ","latitude":"8.30222970","longitude":"2.30244600"},{"name":"Donga Department","isoCode":"DO","countryCode":"BJ","latitude":"9.71918670","longitude":"1.67606910"},{"name":"Kouffo Department","isoCode":"KO","countryCode":"BJ","latitude":"7.00358940","longitude":"1.75388170"},{"name":"Littoral Department","isoCode":"LI","countryCode":"BJ","latitude":"6.38069730","longitude":"2.44063870"},{"name":"Mono Department","isoCode":"MO","countryCode":"BJ","latitude":"37.92186080","longitude":"-118.95286450"},{"name":"Ou\xe9m\xe9 Department","isoCode":"OU","countryCode":"BJ","latitude":"6.61481520","longitude":"2.49999180"},{"name":"Plateau Department","isoCode":"PL","countryCode":"BJ","latitude":"7.34451410","longitude":"2.53960300"},{"name":"Zou Department","isoCode":"ZO","countryCode":"BJ","latitude":"7.34692680","longitude":"2.06651970"},{"name":"Devonshire Parish","isoCode":"DEV","countryCode":"BM","latitude":"32.30380620","longitude":"-64.76069540"},{"name":"Hamilton Parish","isoCode":"HA","countryCode":"BM","latitude":"32.34494320","longitude":"-64.72365000"},{"name":"Paget Parish","isoCode":"PAG","countryCode":"BM","latitude":"32.28107400","longitude":"-64.77847870"},{"name":"Pembroke Parish","isoCode":"PEM","countryCode":"BM","latitude":"32.30076720","longitude":"-64.79626300"},{"name":"Sandys Parish","isoCode":"SAN","countryCode":"BM","latitude":"32.29995280","longitude":"-64.86741030"},{"name":"Saint George\'s Parish","isoCode":"SGE","countryCode":"BM","latitude":"17.12577590","longitude":"-62.56198110"},{"name":"Smith\'s Parish,","isoCode":"SMI","countryCode":"BM","latitude":"32.31339660","longitude":"-64.73105880"},{"name":"Southampton Parish","isoCode":"SOU","countryCode":"BM","latitude":"32.25400950","longitude":"-64.82590580"},{"name":"Warwick Parish","isoCode":"WAR","countryCode":"BM","latitude":"32.26615340","longitude":"-64.80811980"},{"name":"Belait District","isoCode":"BE","countryCode":"BN","latitude":"4.37507490","longitude":"114.61928990"},{"name":"Brunei-Muara District","isoCode":"BM","countryCode":"BN","latitude":"4.93112060","longitude":"114.95168690"},{"name":"Temburong District","isoCode":"TE","countryCode":"BN","latitude":"4.62041280","longitude":"115.14148400"},{"name":"Tutong District","isoCode":"TU","countryCode":"BN","latitude":"4.71403730","longitude":"114.66679390"},{"name":"Beni Department","isoCode":"B","countryCode":"BO","latitude":"-14.37827470","longitude":"-65.09577920"},{"name":"Cochabamba Department","isoCode":"C","countryCode":"BO","latitude":"-17.56816750","longitude":"-65.47573600"},{"name":"Chuquisaca Department","isoCode":"H","countryCode":"BO","latitude":"-20.02491440","longitude":"-64.14782360"},{"name":"La Paz Department","isoCode":"L","countryCode":"BO","latitude":null,"longitude":null},{"name":"Pando Department","isoCode":"N","countryCode":"BO","latitude":"-10.79889010","longitude":"-66.99880110"},{"name":"Oruro Department","isoCode":"O","countryCode":"BO","latitude":"-18.57115790","longitude":"-67.76159830"},{"name":"Potos\xed Department","isoCode":"P","countryCode":"BO","latitude":"-20.62471300","longitude":"-66.99880110"},{"name":"Santa Cruz Department","isoCode":"S","countryCode":"BO","latitude":"-16.74760370","longitude":"-62.07509980"},{"name":"Tarija Department","isoCode":"T","countryCode":"BO","latitude":"-21.58315950","longitude":"-63.95861110"},{"name":"Acre","isoCode":"AC","countryCode":"BR","latitude":"-9.02379600","longitude":"-70.81199500"},{"name":"Alagoas","isoCode":"AL","countryCode":"BR","latitude":"-9.57130580","longitude":"-36.78195050"},{"name":"Amazonas","isoCode":"AM","countryCode":"BR","latitude":"-3.07000000","longitude":"-61.66000000"},{"name":"Amap\xe1","isoCode":"AP","countryCode":"BR","latitude":"0.90199250","longitude":"-52.00295650"},{"name":"Bahia","isoCode":"BA","countryCode":"BR","latitude":"-11.40987400","longitude":"-41.28085700"},{"name":"Cear\xe1","isoCode":"CE","countryCode":"BR","latitude":"-5.49839770","longitude":"-39.32062410"},{"name":"Distrito Federal","isoCode":"DF","countryCode":"BR","latitude":"-15.79976540","longitude":"-47.86447150"},{"name":"Esp\xedrito Santo","isoCode":"ES","countryCode":"BR","latitude":"-19.18342290","longitude":"-40.30886260"},{"name":"Goi\xe1s","isoCode":"GO","countryCode":"BR","latitude":"-15.82703690","longitude":"-49.83622370"},{"name":"Maranh\xe3o","isoCode":"MA","countryCode":"BR","latitude":"-4.96094980","longitude":"-45.27441590"},{"name":"Minas Gerais","isoCode":"MG","countryCode":"BR","latitude":"-18.51217800","longitude":"-44.55503080"},{"name":"Mato Grosso do Sul","isoCode":"MS","countryCode":"BR","latitude":"-20.77222950","longitude":"-54.78515310"},{"name":"Mato Grosso","isoCode":"MT","countryCode":"BR","latitude":"-12.68187120","longitude":"-56.92109900"},{"name":"Par\xe1","isoCode":"PA","countryCode":"BR","latitude":"-1.99812710","longitude":"-54.93061520"},{"name":"Para\xedba","isoCode":"PB","countryCode":"BR","latitude":"-7.23996090","longitude":"-36.78195050"},{"name":"Pernambuco","isoCode":"PE","countryCode":"BR","latitude":"-8.81371730","longitude":"-36.95410700"},{"name":"Piau\xed","isoCode":"PI","countryCode":"BR","latitude":"-7.71834010","longitude":"-42.72892360"},{"name":"Paran\xe1","isoCode":"PR","countryCode":"BR","latitude":"-25.25208880","longitude":"-52.02154150"},{"name":"Rio de Janeiro","isoCode":"RJ","countryCode":"BR","latitude":"-22.90684670","longitude":"-43.17289650"},{"name":"Rio Grande do Norte","isoCode":"RN","countryCode":"BR","latitude":"-5.40258030","longitude":"-36.95410700"},{"name":"Rond\xf4nia","isoCode":"RO","countryCode":"BR","latitude":"-11.50573410","longitude":"-63.58061100"},{"name":"Roraima","isoCode":"RR","countryCode":"BR","latitude":"2.73759710","longitude":"-62.07509980"},{"name":"Rio Grande do Sul","isoCode":"RS","countryCode":"BR","latitude":"-30.03463160","longitude":"-51.21769860"},{"name":"Santa Catarina","isoCode":"SC","countryCode":"BR","latitude":"-27.33000000","longitude":"-49.44000000"},{"name":"Sergipe","isoCode":"SE","countryCode":"BR","latitude":"-10.57409340","longitude":"-37.38565810"},{"name":"S\xe3o Paulo","isoCode":"SP","countryCode":"BR","latitude":"-23.55051990","longitude":"-46.63330940"},{"name":"Tocantins","isoCode":"TO","countryCode":"BR","latitude":"-10.17528000","longitude":"-48.29824740"},{"name":"Acklins and Crooked Islands","isoCode":"AC","countryCode":"BS","latitude":"22.36577080","longitude":"-74.05351260"},{"name":"Acklins","isoCode":"AK","countryCode":"BS","latitude":"22.36577080","longitude":"-74.05351260"},{"name":"Bimini","isoCode":"BI","countryCode":"BS","latitude":"24.64153250","longitude":"-79.85062260"},{"name":"Black Point","isoCode":"BP","countryCode":"BS","latitude":"41.39510240","longitude":"-71.46505560"},{"name":"Berry Islands","isoCode":"BY","countryCode":"BS","latitude":"25.62500420","longitude":"-77.82522030"},{"name":"Central Eleuthera","isoCode":"CE","countryCode":"BS","latitude":"25.13620370","longitude":"-76.14359150"},{"name":"Cat Island","isoCode":"CI","countryCode":"BS","latitude":"30.22801360","longitude":"-89.10149330"},{"name":"Crooked Island","isoCode":"CK","countryCode":"BS","latitude":"22.63909820","longitude":"-74.00650900"},{"name":"Central Abaco","isoCode":"CO","countryCode":"BS","latitude":"26.35550290","longitude":"-77.14851630"},{"name":"Central Andros","isoCode":"CS","countryCode":"BS","latitude":"24.46884820","longitude":"-77.97386500"},{"name":"East Grand Bahama","isoCode":"EG","countryCode":"BS","latitude":"26.65828230","longitude":"-78.22482910"},{"name":"Exuma","isoCode":"EX","countryCode":"BS","latitude":"23.61925980","longitude":"-75.96954650"},{"name":"Fresh Creek","isoCode":"FC","countryCode":"BS","latitude":"40.65437560","longitude":"-73.89479390"},{"name":"Freeport","isoCode":"FP","countryCode":"BS","latitude":"42.29668610","longitude":"-89.62122710"},{"name":"Grand Cay","isoCode":"GC","countryCode":"BS","latitude":"27.21626150","longitude":"-78.32305590"},{"name":"Governor\'s Harbour","isoCode":"GH","countryCode":"BS","latitude":"25.19480960","longitude":"-76.24396220"},{"name":"Green Turtle Cay","isoCode":"GT","countryCode":"BS","latitude":"26.77471070","longitude":"-77.32957080"},{"name":"Harbour Island","isoCode":"HI","countryCode":"BS","latitude":"25.50011000","longitude":"-76.63405110"},{"name":"High Rock","isoCode":"HR","countryCode":"BS","latitude":"46.68434150","longitude":"-121.90174610"},{"name":"Hope Town","isoCode":"HT","countryCode":"BS","latitude":"26.50095040","longitude":"-76.99598720"},{"name":"Inagua","isoCode":"IN","countryCode":"BS","latitude":"21.06560660","longitude":"-73.32370800"},{"name":"Kemps Bay","isoCode":"KB","countryCode":"BS","latitude":"24.02364000","longitude":"-77.54534900"},{"name":"Long Island","isoCode":"LI","countryCode":"BS","latitude":"40.78914200","longitude":"-73.13496100"},{"name":"Mangrove Cay","isoCode":"MC","countryCode":"BS","latitude":"24.14814250","longitude":"-77.76809520"},{"name":"Mayaguana District","isoCode":"MG","countryCode":"BS","latitude":"22.40177140","longitude":"-73.06413960"},{"name":"Marsh Harbour","isoCode":"MH","countryCode":"BS","latitude":"26.52416530","longitude":"-77.09098090"},{"name":"Nichollstown and Berry Islands","isoCode":"NB","countryCode":"BS","latitude":"25.72362340","longitude":"-77.83101040"},{"name":"North Eleuthera","isoCode":"NE","countryCode":"BS","latitude":"25.46475170","longitude":"-76.67592200"},{"name":"North Abaco","isoCode":"NO","countryCode":"BS","latitude":"26.78716970","longitude":"-77.43577390"},{"name":"New Providence","isoCode":"NP","countryCode":"BS","latitude":"40.69843480","longitude":"-74.40154050"},{"name":"North Andros","isoCode":"NS","countryCode":"BS","latitude":"24.70638050","longitude":"-78.01953870"},{"name":"Rum Cay District","isoCode":"RC","countryCode":"BS","latitude":"23.68546760","longitude":"-74.83901620"},{"name":"Ragged Island","isoCode":"RI","countryCode":"BS","latitude":"41.59743100","longitude":"-71.26020200"},{"name":"Rock Sound","isoCode":"RS","countryCode":"BS","latitude":"39.01424430","longitude":"-95.67089890"},{"name":"South Andros","isoCode":"SA","countryCode":"BS","latitude":"23.97135560","longitude":"-77.60778650"},{"name":"South Eleuthera","isoCode":"SE","countryCode":"BS","latitude":"24.77085620","longitude":"-76.21314740"},{"name":"South Abaco","isoCode":"SO","countryCode":"BS","latitude":"26.06405910","longitude":"-77.26350380"},{"name":"Sandy Point","isoCode":"SP","countryCode":"BS","latitude":"39.01454640","longitude":"-76.39989250"},{"name":"San Salvador and Rum Cay","isoCode":"SR","countryCode":"BS","latitude":"23.68546760","longitude":"-74.83901620"},{"name":"San Salvador Island","isoCode":"SS","countryCode":"BS","latitude":"24.07755460","longitude":"-74.47600880"},{"name":"Spanish Wells","isoCode":"SW","countryCode":"BS","latitude":"26.32505990","longitude":"-81.79803280"},{"name":"West Grand Bahama","isoCode":"WG","countryCode":"BS","latitude":"26.65944700","longitude":"-78.52065000"},{"name":"Paro District","isoCode":"11","countryCode":"BT","latitude":"27.42859490","longitude":"89.41665160"},{"name":"Chukha District","isoCode":"12","countryCode":"BT","latitude":"27.07843040","longitude":"89.47421770"},{"name":"Haa District","isoCode":"13","countryCode":"BT","latitude":"27.26516690","longitude":"89.17059980"},{"name":"Samtse District","isoCode":"14","countryCode":"BT","latitude":"27.02918320","longitude":"89.05615320"},{"name":"Thimphu District","isoCode":"15","countryCode":"BT","latitude":"27.47122160","longitude":"89.63390410"},{"name":"Tsirang District","isoCode":"21","countryCode":"BT","latitude":"27.03220700","longitude":"90.18696440"},{"name":"Dagana District","isoCode":"22","countryCode":"BT","latitude":"27.03228610","longitude":"89.88793040"},{"name":"Punakha District","isoCode":"23","countryCode":"BT","latitude":"27.69037160","longitude":"89.88793040"},{"name":"Wangdue Phodrang District","isoCode":"24","countryCode":"BT","latitude":"27.45260460","longitude":"90.06749280"},{"name":"Sarpang District","isoCode":"31","countryCode":"BT","latitude":"26.93730410","longitude":"90.48799160"},{"name":"Trongsa District","isoCode":"32","countryCode":"BT","latitude":"27.50022690","longitude":"90.50806340"},{"name":"Bumthang District","isoCode":"33","countryCode":"BT","latitude":"27.64183900","longitude":"90.67730460"},{"name":"Zhemgang District","isoCode":"34","countryCode":"BT","latitude":"27.07697500","longitude":"90.82940020"},{"name":"Trashigang District","isoCode":"41","countryCode":"BT","latitude":"27.25667950","longitude":"91.75388170"},{"name":"Mongar District","isoCode":"42","countryCode":"BT","latitude":"27.26170590","longitude":"91.28910360"},{"name":"Pemagatshel District","isoCode":"43","countryCode":"BT","latitude":"27.00238200","longitude":"91.34692470"},{"name":"Lhuntse District","isoCode":"44","countryCode":"BT","latitude":"27.82649890","longitude":"91.13530200"},{"name":"Samdrup Jongkhar District","isoCode":"45","countryCode":"BT","latitude":"26.80356820","longitude":"91.50392070"},{"name":"Gasa District","isoCode":"GA","countryCode":"BT","latitude":"28.01858860","longitude":"89.92532330"},{"name":"Central District","isoCode":"CE","countryCode":"BW","latitude":null,"longitude":null},{"name":"Ghanzi District","isoCode":"GH","countryCode":"BW","latitude":"-21.86523140","longitude":"21.85685860"},{"name":"Kgalagadi District","isoCode":"KG","countryCode":"BW","latitude":"-24.75502850","longitude":"21.85685860"},{"name":"Kgatleng District","isoCode":"KL","countryCode":"BW","latitude":"-24.19704450","longitude":"26.23046160"},{"name":"Kweneng District","isoCode":"KW","countryCode":"BW","latitude":"-23.83672490","longitude":"25.28375850"},{"name":"North-East District","isoCode":"NE","countryCode":"BW","latitude":"37.58844610","longitude":"-94.68637820"},{"name":"Ngamiland","isoCode":"NG","countryCode":"BW","latitude":"-19.19053210","longitude":"23.00119890"},{"name":"North-West District","isoCode":"NW","countryCode":"BW","latitude":"39.34463070","longitude":"-76.68542830"},{"name":"South-East District","isoCode":"SE","countryCode":"BW","latitude":"31.21637980","longitude":"-82.35270440"},{"name":"Southern District","isoCode":"SO","countryCode":"BW","latitude":null,"longitude":null},{"name":"Brest Region","isoCode":"BR","countryCode":"BY","latitude":"52.52966410","longitude":"25.46064800"},{"name":"Minsk","isoCode":"HM","countryCode":"BY","latitude":"53.90060110","longitude":"27.55897200"},{"name":"Gomel Region","isoCode":"HO","countryCode":"BY","latitude":"52.16487540","longitude":"29.13332510"},{"name":"Grodno Region","isoCode":"HR","countryCode":"BY","latitude":"53.65999450","longitude":"25.34485710"},{"name":"Mogilev Region","isoCode":"MA","countryCode":"BY","latitude":"53.51017910","longitude":"30.40064440"},{"name":"Minsk Region","isoCode":"MI","countryCode":"BY","latitude":"54.10678890","longitude":"27.41292450"},{"name":"Vitebsk Region","isoCode":"VI","countryCode":"BY","latitude":"55.29598330","longitude":"28.75836270"},{"name":"Belize District","isoCode":"BZ","countryCode":"BZ","latitude":"17.56776790","longitude":"-88.40160410"},{"name":"Cayo District","isoCode":"CY","countryCode":"BZ","latitude":"17.09844450","longitude":"-88.94138650"},{"name":"Corozal District","isoCode":"CZL","countryCode":"BZ","latitude":"18.13492380","longitude":"-88.24611830"},{"name":"Orange Walk District","isoCode":"OW","countryCode":"BZ","latitude":"17.76035300","longitude":"-88.86469800"},{"name":"Stann Creek District","isoCode":"SC","countryCode":"BZ","latitude":"16.81166310","longitude":"-88.40160410"},{"name":"Toledo District","isoCode":"TOL","countryCode":"BZ","latitude":"16.24919230","longitude":"-88.86469800"},{"name":"Alberta","isoCode":"AB","countryCode":"CA","latitude":"53.93327060","longitude":"-116.57650350"},{"name":"British Columbia","isoCode":"BC","countryCode":"CA","latitude":"53.72666830","longitude":"-127.64762050"},{"name":"Manitoba","isoCode":"MB","countryCode":"CA","latitude":"53.76086080","longitude":"-98.81387620"},{"name":"New Brunswick","isoCode":"NB","countryCode":"CA","latitude":"46.56531630","longitude":"-66.46191640"},{"name":"Newfoundland and Labrador","isoCode":"NL","countryCode":"CA","latitude":"53.13550910","longitude":"-57.66043640"},{"name":"Nova Scotia","isoCode":"NS","countryCode":"CA","latitude":"44.68198660","longitude":"-63.74431100"},{"name":"Northwest Territories","isoCode":"NT","countryCode":"CA","latitude":"64.82554410","longitude":"-124.84573340"},{"name":"Nunavut","isoCode":"NU","countryCode":"CA","latitude":"70.29977110","longitude":"-83.10757700"},{"name":"Ontario","isoCode":"ON","countryCode":"CA","latitude":"51.25377500","longitude":"-85.32321400"},{"name":"Prince Edward Island","isoCode":"PE","countryCode":"CA","latitude":"46.51071200","longitude":"-63.41681360"},{"name":"Quebec","isoCode":"QC","countryCode":"CA","latitude":"52.93991590","longitude":"-73.54913610"},{"name":"Saskatchewan","isoCode":"SK","countryCode":"CA","latitude":"52.93991590","longitude":"-106.45086390"},{"name":"Yukon","isoCode":"YT","countryCode":"CA","latitude":"35.50672150","longitude":"-97.76254410"},{"name":"Kongo Central","isoCode":"BC","countryCode":"CD","latitude":"-5.23656850","longitude":"13.91439900"},{"name":"Bas-U\xe9l\xe9","isoCode":"BU","countryCode":"CD","latitude":"3.99010090","longitude":"24.90422080"},{"name":"\xc9quateur","isoCode":"EQ","countryCode":"CD","latitude":"-1.83123900","longitude":"-78.18340600"},{"name":"Haut-Katanga","isoCode":"HK","countryCode":"CD","latitude":"-10.41020750","longitude":"27.54958460"},{"name":"Haut-Lomami","isoCode":"HL","countryCode":"CD","latitude":"-7.70527520","longitude":"24.90422080"},{"name":"Haut-U\xe9l\xe9","isoCode":"HU","countryCode":"CD","latitude":"3.58451540","longitude":"28.29943500"},{"name":"Ituri","isoCode":"IT","countryCode":"CD","latitude":"1.59576820","longitude":"29.41793240"},{"name":"Kasa\xef Central","isoCode":"KC","countryCode":"CD","latitude":"-8.44045910","longitude":"20.41659340"},{"name":"Kasa\xef Oriental","isoCode":"KE","countryCode":"CD","latitude":"-6.03362300","longitude":"23.57285010"},{"name":"Kwango","isoCode":"KG","countryCode":"CD","latitude":"-6.43374090","longitude":"17.66888700"},{"name":"Kwilu","isoCode":"KL","countryCode":"CD","latitude":"-5.11888250","longitude":"18.42760470"},{"name":"Kinshasa","isoCode":"KN","countryCode":"CD","latitude":"-4.44193110","longitude":"15.26629310"},{"name":"Kasa\xef","isoCode":"KS","countryCode":"CD","latitude":"-5.04719790","longitude":"20.71224650"},{"name":"Lomami","isoCode":"LO","countryCode":"CD","latitude":"-6.14539310","longitude":"24.52426400"},{"name":"Lualaba","isoCode":"LU","countryCode":"CD","latitude":"-10.48086980","longitude":"25.62978160"},{"name":"Maniema","isoCode":"MA","countryCode":"CD","latitude":"-3.07309290","longitude":"26.04138890"},{"name":"Mai-Ndombe","isoCode":"MN","countryCode":"CD","latitude":"-2.63574340","longitude":"18.42760470"},{"name":"Mongala","isoCode":"MO","countryCode":"CD","latitude":"1.99623240","longitude":"21.47528510"},{"name":"Nord-Kivu","isoCode":"NK","countryCode":"CD","latitude":"-0.79177290","longitude":"29.04599270"},{"name":"Nord-Ubangi","isoCode":"NU","countryCode":"CD","latitude":"3.78787260","longitude":"21.47528510"},{"name":"Sankuru","isoCode":"SA","countryCode":"CD","latitude":"-2.84374530","longitude":"23.38235450"},{"name":"Sud-Kivu","isoCode":"SK","countryCode":"CD","latitude":"-3.01165800","longitude":"28.29943500"},{"name":"Sud-Ubangi","isoCode":"SU","countryCode":"CD","latitude":"3.22999420","longitude":"19.18800470"},{"name":"Tanganyika","isoCode":"TA","countryCode":"CD","latitude":"-6.27401180","longitude":"27.92490020"},{"name":"Tshopo","isoCode":"TO","countryCode":"CD","latitude":"0.54554620","longitude":"24.90422080"},{"name":"Tshuapa","isoCode":"TU","countryCode":"CD","latitude":"-0.99030230","longitude":"23.02888440"},{"name":"Ouham Prefecture","isoCode":"AC","countryCode":"CF","latitude":"7.09091100","longitude":"17.66888700"},{"name":"Bamingui-Bangoran Prefecture","isoCode":"BB","countryCode":"CF","latitude":"8.27334550","longitude":"20.71224650"},{"name":"Bangui","isoCode":"BGF","countryCode":"CF","latitude":"4.39467350","longitude":"18.55818990"},{"name":"Basse-Kotto Prefecture","isoCode":"BK","countryCode":"CF","latitude":"4.87193190","longitude":"21.28450250"},{"name":"Haute-Kotto Prefecture","isoCode":"HK","countryCode":"CF","latitude":"7.79643790","longitude":"23.38235450"},{"name":"Haut-Mbomou Prefecture","isoCode":"HM","countryCode":"CF","latitude":"6.25371340","longitude":"25.47335540"},{"name":"Mamb\xe9r\xe9-Kad\xe9\xef","isoCode":"HS","countryCode":"CF","latitude":"4.70556530","longitude":"15.96998780"},{"name":"Nana-Gr\xe9bizi Economic Prefecture","isoCode":"KB","countryCode":"CF","latitude":"7.18486070","longitude":"19.37832060"},{"name":"K\xe9mo Prefecture","isoCode":"KG","countryCode":"CF","latitude":"5.88677940","longitude":"19.37832060"},{"name":"Lobaye Prefecture","isoCode":"LB","countryCode":"CF","latitude":"4.35259810","longitude":"17.47951730"},{"name":"Mbomou Prefecture","isoCode":"MB","countryCode":"CF","latitude":"5.55683700","longitude":"23.76328280"},{"name":"Ombella-M\'Poko Prefecture","isoCode":"MP","countryCode":"CF","latitude":"5.11888250","longitude":"18.42760470"},{"name":"Nana-Mamb\xe9r\xe9 Prefecture","isoCode":"NM","countryCode":"CF","latitude":"5.69321350","longitude":"15.21948080"},{"name":"Ouham-Pend\xe9 Prefecture","isoCode":"OP","countryCode":"CF","latitude":"6.48509840","longitude":"16.15809370"},{"name":"Sangha-Mba\xe9r\xe9","isoCode":"SE","countryCode":"CF","latitude":"3.43686070","longitude":"16.34637910"},{"name":"Ouaka Prefecture","isoCode":"UK","countryCode":"CF","latitude":"6.31682160","longitude":"20.71224650"},{"name":"Vakaga Prefecture","isoCode":"VK","countryCode":"CF","latitude":"9.51132960","longitude":"22.23840170"},{"name":"Bouenza Department","isoCode":"11","countryCode":"CG","latitude":"-4.11280790","longitude":"13.72891670"},{"name":"Pool Department","isoCode":"12","countryCode":"CG","latitude":"-3.77626280","longitude":"14.84546190"},{"name":"Sangha Department","isoCode":"13","countryCode":"CG","latitude":"1.46623280","longitude":"15.40680790"},{"name":"Plateaux Department","isoCode":"14","countryCode":"CG","latitude":"-2.06800880","longitude":"15.40680790"},{"name":"Cuvette-Ouest Department","isoCode":"15","countryCode":"CG","latitude":"0.14475500","longitude":"14.47233010"},{"name":"Pointe-Noire","isoCode":"16","countryCode":"CG","latitude":"-4.76916230","longitude":"11.86636200"},{"name":"L\xe9koumou Department","isoCode":"2","countryCode":"CG","latitude":"-3.17038200","longitude":"13.35872880"},{"name":"Kouilou Department","isoCode":"5","countryCode":"CG","latitude":"-4.14284130","longitude":"11.88917210"},{"name":"Likouala Department","isoCode":"7","countryCode":"CG","latitude":"2.04392400","longitude":"17.66888700"},{"name":"Cuvette Department","isoCode":"8","countryCode":"CG","latitude":"-0.28774460","longitude":"16.15809370"},{"name":"Niari Department","isoCode":"9","countryCode":"CG","latitude":"-3.18427000","longitude":"12.25479190"},{"name":"Brazzaville","isoCode":"BZV","countryCode":"CG","latitude":"-4.26335970","longitude":"15.24288530"},{"name":"Aargau","isoCode":"AG","countryCode":"CH","latitude":"47.38766640","longitude":"8.25542950"},{"name":"Appenzell Innerrhoden","isoCode":"AI","countryCode":"CH","latitude":"47.31619250","longitude":"9.43165730"},{"name":"Appenzell Ausserrhoden","isoCode":"AR","countryCode":"CH","latitude":"47.36648100","longitude":"9.30009160"},{"name":"Bern","isoCode":"BE","countryCode":"CH","latitude":"46.79886210","longitude":"7.70807010"},{"name":"Basel-Land","isoCode":"BL","countryCode":"CH","latitude":"47.44181220","longitude":"7.76440020"},{"name":"Basel-Stadt","isoCode":"BS","countryCode":"CH","latitude":"47.56666700","longitude":"7.60000000"},{"name":"Fribourg","isoCode":"FR","countryCode":"CH","latitude":"46.68167480","longitude":"7.11726350"},{"name":"Geneva","isoCode":"GE","countryCode":"CH","latitude":"46.21800730","longitude":"6.12169250"},{"name":"Glarus","isoCode":"GL","countryCode":"CH","latitude":"47.04112320","longitude":"9.06790000"},{"name":"Graub\xfcnden","isoCode":"GR","countryCode":"CH","latitude":"46.65698710","longitude":"9.57802570"},{"name":"Jura","isoCode":"JU","countryCode":"CH","latitude":"47.34444740","longitude":"7.14306080"},{"name":"Lucerne","isoCode":"LU","countryCode":"CH","latitude":"47.07956710","longitude":"8.16624450"},{"name":"Neuch\xe2tel","isoCode":"NE","countryCode":"CH","latitude":"46.98998740","longitude":"6.92927320"},{"name":"Nidwalden","isoCode":"NW","countryCode":"CH","latitude":"46.92670160","longitude":"8.38499820"},{"name":"Obwalden","isoCode":"OW","countryCode":"CH","latitude":"46.87785800","longitude":"8.25124900"},{"name":"St. Gallen","isoCode":"SG","countryCode":"CH","latitude":"47.14562540","longitude":"9.35043320"},{"name":"Schaffhausen","isoCode":"SH","countryCode":"CH","latitude":"47.70093640","longitude":"8.56800400"},{"name":"Solothurn","isoCode":"SO","countryCode":"CH","latitude":"47.33207170","longitude":"7.63883850"},{"name":"Schwyz","isoCode":"SZ","countryCode":"CH","latitude":"47.02071380","longitude":"8.65298840"},{"name":"Thurgau","isoCode":"TG","countryCode":"CH","latitude":"47.60378560","longitude":"9.05573710"},{"name":"Ticino","isoCode":"TI","countryCode":"CH","latitude":"46.33173400","longitude":"8.80045290"},{"name":"Uri","isoCode":"UR","countryCode":"CH","latitude":"41.48606470","longitude":"-71.53085370"},{"name":"Vaud","isoCode":"VD","countryCode":"CH","latitude":"46.56131350","longitude":"6.53676500"},{"name":"Valais","isoCode":"VS","countryCode":"CH","latitude":"46.19046140","longitude":"7.54492260"},{"name":"Zug","isoCode":"ZG","countryCode":"CH","latitude":"47.16615050","longitude":"8.51547490"},{"name":"Z\xfcrich","isoCode":"ZH","countryCode":"CH","latitude":"47.35953600","longitude":"8.63564520"},{"name":"Lagunes region","isoCode":"01","countryCode":"CI","latitude":"5.88273340","longitude":"-4.23333550"},{"name":"Haut-Sassandra","isoCode":"02","countryCode":"CI","latitude":"6.87578480","longitude":"-6.57833870"},{"name":"Savanes Region","isoCode":"03","countryCode":"CI","latitude":null,"longitude":null},{"name":"Vall\xe9e du Bandama Region","isoCode":"04","countryCode":"CI","latitude":"8.27897800","longitude":"-4.89356270"},{"name":"Moyen-Como\xe9","isoCode":"05","countryCode":"CI","latitude":"6.65149170","longitude":"-3.50034540"},{"name":"Dix-Huit Montagnes","isoCode":"06","countryCode":"CI","latitude":"7.37623730","longitude":"-7.43813550"},{"name":"Lacs Region","isoCode":"07","countryCode":"CI","latitude":"47.73958660","longitude":"-70.41866520"},{"name":"Bas-Sassandra Region","isoCode":"09","countryCode":"CI","latitude":"5.35679160","longitude":"-6.74939930"},{"name":"Dengu\xe9l\xe9 Region","isoCode":"10","countryCode":"CI","latitude":"9.46623720","longitude":"-7.43813550"},{"name":"N\'zi-Como\xe9","isoCode":"11","countryCode":"CI","latitude":"7.24567490","longitude":"-4.23333550"},{"name":"Marahou\xe9 Region","isoCode":"12","countryCode":"CI","latitude":"6.88462070","longitude":"-5.89871390"},{"name":"Sud-Como\xe9","isoCode":"13","countryCode":"CI","latitude":"5.55279300","longitude":"-3.25836260"},{"name":"Worodougou","isoCode":"14","countryCode":"CI","latitude":"8.25489620","longitude":"-6.57833870"},{"name":"Sud-Bandama","isoCode":"15","countryCode":"CI","latitude":"5.53570830","longitude":"-5.56172790"},{"name":"Agn\xe9by","isoCode":"16","countryCode":"CI","latitude":"5.32245030","longitude":"-4.34495290"},{"name":"Bafing Region","isoCode":"17","countryCode":"CI","latitude":"8.32520470","longitude":"-7.52472430"},{"name":"Fromager","isoCode":"18","countryCode":"CI","latitude":"45.54502130","longitude":"-73.60462230"},{"name":"Moyen-Cavally","isoCode":"19","countryCode":"CI","latitude":"6.52087930","longitude":"-7.61142170"},{"name":"Abidjan","isoCode":"AB","countryCode":"CI","latitude":"5.35995170","longitude":"-4.00825630"},{"name":"Bas-Sassandra District","isoCode":"BS","countryCode":"CI","latitude":"5.27983560","longitude":"-6.15269850"},{"name":"Como\xe9 District","isoCode":"CM","countryCode":"CI","latitude":"5.55279300","longitude":"-3.25836260"},{"name":"Dengu\xe9l\xe9 District","isoCode":"DN","countryCode":"CI","latitude":"48.07077630","longitude":"-68.56093410"},{"name":"G\xf4h-Djiboua District","isoCode":"GD","countryCode":"CI","latitude":"5.87113930","longitude":"-5.56172790"},{"name":"Lacs District","isoCode":"LC","countryCode":"CI","latitude":"48.19801690","longitude":"-80.45644120"},{"name":"Lagunes District","isoCode":"LG","countryCode":"CI","latitude":"5.88273340","longitude":"-4.23333550"},{"name":"Montagnes District","isoCode":"MG","countryCode":"CI","latitude":"7.37623730","longitude":"-7.43813550"},{"name":"Sassandra-Marahou\xe9 District","isoCode":"SM","countryCode":"CI","latitude":"6.88033480","longitude":"-6.23759470"},{"name":"Vall\xe9e du Bandama District","isoCode":"VB","countryCode":"CI","latitude":"8.27897800","longitude":"-4.89356270"},{"name":"Woroba District","isoCode":"WR","countryCode":"CI","latitude":"8.24913720","longitude":"-6.92091350"},{"name":"Yamoussoukro","isoCode":"YM","countryCode":"CI","latitude":"6.82762280","longitude":"-5.28934330"},{"name":"Zanzan Region","isoCode":"ZZ","countryCode":"CI","latitude":"8.82079040","longitude":"-3.41955270"},{"name":"Ais\xe9n del General Carlos Iba\xf1ez del Campo","isoCode":"AI","countryCode":"CL","latitude":"-46.37834500","longitude":"-72.30076230"},{"name":"Antofagasta","isoCode":"AN","countryCode":"CL","latitude":"-23.83691040","longitude":"-69.28775350"},{"name":"Arica y Parinacota","isoCode":"AP","countryCode":"CL","latitude":"-18.59404850","longitude":"-69.47845410"},{"name":"La Araucan\xeda","isoCode":"AR","countryCode":"CL","latitude":"-38.94892100","longitude":"-72.33111300"},{"name":"Atacama","isoCode":"AT","countryCode":"CL","latitude":"-27.56605580","longitude":"-70.05031400"},{"name":"Biob\xedo","isoCode":"BI","countryCode":"CL","latitude":"-37.44644280","longitude":"-72.14161320"},{"name":"Coquimbo","isoCode":"CO","countryCode":"CL","latitude":"-30.54018100","longitude":"-70.81199530"},{"name":"Libertador General Bernardo O\'Higgins","isoCode":"LI","countryCode":"CL","latitude":"-34.57553740","longitude":"-71.00223110"},{"name":"Los Lagos","isoCode":"LL","countryCode":"CL","latitude":"-41.91977790","longitude":"-72.14161320"},{"name":"Los R\xedos","isoCode":"LR","countryCode":"CL","latitude":"-40.23102170","longitude":"-72.33111300"},{"name":"Magallanes y de la Ant\xe1rtica Chilena","isoCode":"MA","countryCode":"CL","latitude":"-52.20643160","longitude":"-72.16850010"},{"name":"Maule","isoCode":"ML","countryCode":"CL","latitude":"-35.51636030","longitude":"-71.57239530"},{"name":"\xd1uble","isoCode":"NB","countryCode":"CL","latitude":"-36.72257430","longitude":"-71.76224810"},{"name":"Regi\xf3n Metropolitana de Santiago","isoCode":"RM","countryCode":"CL","latitude":"-33.43755450","longitude":"-70.65048960"},{"name":"Tarapac\xe1","isoCode":"TA","countryCode":"CL","latitude":"-20.20287990","longitude":"-69.28775350"},{"name":"Valpara\xedso","isoCode":"VS","countryCode":"CL","latitude":"-33.04723800","longitude":"-71.61268850"},{"name":"Adamawa","isoCode":"AD","countryCode":"CM","latitude":"9.32647510","longitude":"12.39838530"},{"name":"Centre","isoCode":"CE","countryCode":"CM","latitude":null,"longitude":null},{"name":"Far North","isoCode":"EN","countryCode":"CM","latitude":"66.76134510","longitude":"124.12375300"},{"name":"East","isoCode":"ES","countryCode":"CM","latitude":"39.01853360","longitude":"-94.27924110"},{"name":"Littoral","isoCode":"LT","countryCode":"CM","latitude":"48.46227570","longitude":"-68.51780710"},{"name":"North","isoCode":"NO","countryCode":"CM","latitude":"37.09024000","longitude":"-95.71289100"},{"name":"Northwest","isoCode":"NW","countryCode":"CM","latitude":"36.37118570","longitude":"-94.19346060"},{"name":"West","isoCode":"OU","countryCode":"CM","latitude":"37.03649890","longitude":"-95.67059870"},{"name":"South","isoCode":"SU","countryCode":"CM","latitude":"37.63159500","longitude":"-97.34584090"},{"name":"Southwest","isoCode":"SW","countryCode":"CM","latitude":"36.19088130","longitude":"-95.88974480"},{"name":"Anhui","isoCode":"AH","countryCode":"CN","latitude":"30.60067730","longitude":"117.92490020"},{"name":"Beijing","isoCode":"BJ","countryCode":"CN","latitude":"39.90419990","longitude":"116.40739630"},{"name":"Chongqing","isoCode":"CQ","countryCode":"CN","latitude":"29.43158610","longitude":"106.91225100"},{"name":"Fujian","isoCode":"FJ","countryCode":"CN","latitude":"26.48368420","longitude":"117.92490020"},{"name":"Guangdong","isoCode":"GD","countryCode":"CN","latitude":"23.37903330","longitude":"113.76328280"},{"name":"Gansu","isoCode":"GS","countryCode":"CN","latitude":"35.75183260","longitude":"104.28611160"},{"name":"Guangxi Zhuang","isoCode":"GX","countryCode":"CN","latitude":"23.72475990","longitude":"108.80761950"},{"name":"Guizhou","isoCode":"GZ","countryCode":"CN","latitude":"26.84296450","longitude":"107.29028390"},{"name":"Henan","isoCode":"HA","countryCode":"CN","latitude":"34.29043020","longitude":"113.38235450"},{"name":"Hubei","isoCode":"HB","countryCode":"CN","latitude":"30.73781180","longitude":"112.23840170"},{"name":"Hebei","isoCode":"HE","countryCode":"CN","latitude":"37.89565940","longitude":"114.90422080"},{"name":"Hainan","isoCode":"HI","countryCode":"CN","latitude":"19.56639470","longitude":"109.94968600"},{"name":"Hong Kong SAR","isoCode":"HK","countryCode":"CN","latitude":"22.31930390","longitude":"114.16936110"},{"name":"Heilongjiang","isoCode":"HL","countryCode":"CN","latitude":"47.12164720","longitude":"128.73823100"},{"name":"Hunan","isoCode":"HN","countryCode":"CN","latitude":"36.73412940","longitude":"-95.93449020"},{"name":"Jilin","isoCode":"JL","countryCode":"CN","latitude":"43.83788300","longitude":"126.54957200"},{"name":"Jiangsu","isoCode":"JS","countryCode":"CN","latitude":"33.14017150","longitude":"119.78892480"},{"name":"Jiangxi","isoCode":"JX","countryCode":"CN","latitude":"27.08745640","longitude":"114.90422080"},{"name":"Liaoning","isoCode":"LN","countryCode":"CN","latitude":"41.94365430","longitude":"122.52903760"},{"name":"Macau SAR","isoCode":"MO","countryCode":"CN","latitude":"22.19874500","longitude":"113.54387300"},{"name":"Inner Mongolia","isoCode":"NM","countryCode":"CN","latitude":"43.37822000","longitude":"115.05948150"},{"name":"Ningxia Huizu","isoCode":"NX","countryCode":"CN","latitude":"37.19873100","longitude":"106.15809370"},{"name":"Qinghai","isoCode":"QH","countryCode":"CN","latitude":"35.74479800","longitude":"96.40773580"},{"name":"Sichuan","isoCode":"SC","countryCode":"CN","latitude":"30.26380320","longitude":"102.80547530"},{"name":"Shandong","isoCode":"SD","countryCode":"CN","latitude":"37.80060640","longitude":"-122.26999180"},{"name":"Shanghai","isoCode":"SH","countryCode":"CN","latitude":"31.23041600","longitude":"121.47370100"},{"name":"Shaanxi","isoCode":"SN","countryCode":"CN","latitude":"35.39399080","longitude":"109.18800470"},{"name":"Shanxi","isoCode":"SX","countryCode":"CN","latitude":"37.24256490","longitude":"111.85685860"},{"name":"Tianjin","isoCode":"TJ","countryCode":"CN","latitude":"39.12522910","longitude":"117.01534350"},{"name":"Taiwan","isoCode":"TW","countryCode":"CN","latitude":"23.69781000","longitude":"120.96051500"},{"name":"Xinjiang","isoCode":"XJ","countryCode":"CN","latitude":"42.52463570","longitude":"87.53958550"},{"name":"Xizang","isoCode":"XZ","countryCode":"CN","latitude":"30.15336050","longitude":"88.78786780"},{"name":"Yunnan","isoCode":"YN","countryCode":"CN","latitude":"24.47528470","longitude":"101.34310580"},{"name":"Zhejiang","isoCode":"ZJ","countryCode":"CN","latitude":"29.14164320","longitude":"119.78892480"},{"name":"Amazonas","isoCode":"AMA","countryCode":"CO","latitude":"-1.44291230","longitude":"-71.57239530"},{"name":"Antioquia","isoCode":"ANT","countryCode":"CO","latitude":"7.19860640","longitude":"-75.34121790"},{"name":"Arauca","isoCode":"ARA","countryCode":"CO","latitude":"6.54730600","longitude":"-71.00223110"},{"name":"Atl\xe1ntico","isoCode":"ATL","countryCode":"CO","latitude":"10.69661590","longitude":"-74.87410450"},{"name":"Bol\xedvar","isoCode":"BOL","countryCode":"CO","latitude":"8.67043820","longitude":"-74.03001220"},{"name":"Boyac\xe1","isoCode":"BOY","countryCode":"CO","latitude":"5.45451100","longitude":"-73.36200300"},{"name":"Caldas","isoCode":"CAL","countryCode":"CO","latitude":"5.29826000","longitude":"-75.24790610"},{"name":"Caquet\xe1","isoCode":"CAQ","countryCode":"CO","latitude":"0.86989200","longitude":"-73.84190630"},{"name":"Casanare","isoCode":"CAS","countryCode":"CO","latitude":"5.75892690","longitude":"-71.57239530"},{"name":"Cauca","isoCode":"CAU","countryCode":"CO","latitude":"2.70498130","longitude":"-76.82596520"},{"name":"Cesar","isoCode":"CES","countryCode":"CO","latitude":"9.33729480","longitude":"-73.65362090"},{"name":"Choc\xf3","isoCode":"CHO","countryCode":"CO","latitude":"5.25280330","longitude":"-76.82596520"},{"name":"C\xf3rdoba","isoCode":"COR","countryCode":"CO","latitude":"8.04929300","longitude":"-75.57405000"},{"name":"Cundinamarca","isoCode":"CUN","countryCode":"CO","latitude":"5.02600300","longitude":"-74.03001220"},{"name":"Bogot\xe1 D.C.","isoCode":"DC","countryCode":"CO","latitude":"4.28204150","longitude":"-74.50270420"},{"name":"Guain\xeda","isoCode":"GUA","countryCode":"CO","latitude":"2.58539300","longitude":"-68.52471490"},{"name":"Guaviare","isoCode":"GUV","countryCode":"CO","latitude":"2.04392400","longitude":"-72.33111300"},{"name":"Huila","isoCode":"HUI","countryCode":"CO","latitude":"2.53593490","longitude":"-75.52766990"},{"name":"La Guajira","isoCode":"LAG","countryCode":"CO","latitude":"11.35477430","longitude":"-72.52048270"},{"name":"Magdalena","isoCode":"MAG","countryCode":"CO","latitude":"10.41130140","longitude":"-74.40566120"},{"name":"Meta","isoCode":"MET","countryCode":"CO","latitude":"39.76732580","longitude":"-104.97535950"},{"name":"Nari\xf1o","isoCode":"NAR","countryCode":"CO","latitude":"1.28915100","longitude":"-77.35794000"},{"name":"Norte de Santander","isoCode":"NSA","countryCode":"CO","latitude":"7.94628310","longitude":"-72.89880690"},{"name":"Putumayo","isoCode":"PUT","countryCode":"CO","latitude":"0.43595060","longitude":"-75.52766990"},{"name":"Quind\xedo","isoCode":"QUI","countryCode":"CO","latitude":"4.46101910","longitude":"-75.66735600"},{"name":"Risaralda","isoCode":"RIS","countryCode":"CO","latitude":"5.31584750","longitude":"-75.99276520"},{"name":"Santander","isoCode":"SAN","countryCode":"CO","latitude":"6.64370760","longitude":"-73.65362090"},{"name":"Archipi\xe9lago de San Andr\xe9s, Providencia y Santa Catalina","isoCode":"SAP","countryCode":"CO","latitude":"12.55673240","longitude":"-81.71852530"},{"name":"Sucre","isoCode":"SUC","countryCode":"CO","latitude":"8.81397700","longitude":"-74.72328300"},{"name":"Tolima","isoCode":"TOL","countryCode":"CO","latitude":"4.09251680","longitude":"-75.15453810"},{"name":"Valle del Cauca","isoCode":"VAC","countryCode":"CO","latitude":"3.80088930","longitude":"-76.64127120"},{"name":"Vaup\xe9s","isoCode":"VAU","countryCode":"CO","latitude":"0.85535610","longitude":"-70.81199530"},{"name":"Vichada","isoCode":"VID","countryCode":"CO","latitude":"4.42344520","longitude":"-69.28775350"},{"name":"Alajuela Province","isoCode":"A","countryCode":"CR","latitude":"10.39158300","longitude":"-84.43827210"},{"name":"Provincia de Cartago","isoCode":"C","countryCode":"CR","latitude":"9.86223110","longitude":"-83.92141870"},{"name":"Guanacaste Province","isoCode":"G","countryCode":"CR","latitude":"10.62673990","longitude":"-85.44367060"},{"name":"Heredia Province","isoCode":"H","countryCode":"CR","latitude":"10.47352300","longitude":"-84.01674230"},{"name":"Lim\xf3n Province","isoCode":"L","countryCode":"CR","latitude":"9.98963980","longitude":"-83.03324170"},{"name":"Puntarenas Province","isoCode":"P","countryCode":"CR","latitude":"9.21695310","longitude":"-83.33618800"},{"name":"San Jos\xe9 Province","isoCode":"SJ","countryCode":"CR","latitude":"9.91297270","longitude":"-84.07682940"},{"name":"Pinar del R\xedo Province","isoCode":"01","countryCode":"CU","latitude":"22.40762560","longitude":"-83.84730150"},{"name":"Havana Province","isoCode":"03","countryCode":"CU","latitude":"23.05406980","longitude":"-82.34518900"},{"name":"Matanzas Province","isoCode":"04","countryCode":"CU","latitude":"22.57671230","longitude":"-81.33994140"},{"name":"Villa Clara Province","isoCode":"05","countryCode":"CU","latitude":"22.49372040","longitude":"-79.91927020"},{"name":"Cienfuegos Province","isoCode":"06","countryCode":"CU","latitude":"22.23797830","longitude":"-80.36586500"},{"name":"Sancti Sp\xedritus Province","isoCode":"07","countryCode":"CU","latitude":"21.99382140","longitude":"-79.47038850"},{"name":"Ciego de \xc1vila Province","isoCode":"08","countryCode":"CU","latitude":"21.93295150","longitude":"-78.56608520"},{"name":"Camag\xfcey Province","isoCode":"09","countryCode":"CU","latitude":"21.21672470","longitude":"-77.74520810"},{"name":"Las Tunas Province","isoCode":"10","countryCode":"CU","latitude":"21.06051620","longitude":"-76.91820970"},{"name":"Holgu\xedn Province","isoCode":"11","countryCode":"CU","latitude":"20.78378930","longitude":"-75.80690820"},{"name":"Granma Province","isoCode":"12","countryCode":"CU","latitude":"20.38449020","longitude":"-76.64127120"},{"name":"Santiago de Cuba Province","isoCode":"13","countryCode":"CU","latitude":"20.23976820","longitude":"-75.99276520"},{"name":"Guant\xe1namo Province","isoCode":"14","countryCode":"CU","latitude":"20.14559170","longitude":"-74.87410450"},{"name":"Artemisa Province","isoCode":"15","countryCode":"CU","latitude":"22.75229030","longitude":"-82.99316070"},{"name":"Mayabeque Province","isoCode":"16","countryCode":"CU","latitude":"22.89265290","longitude":"-81.95348150"},{"name":"Isla de la Juventud","isoCode":"99","countryCode":"CU","latitude":"21.70847370","longitude":"-82.82202320"},{"name":"Barlavento Islands","isoCode":"B","countryCode":"CV","latitude":"16.82368450","longitude":"-23.99348810"},{"name":"Brava","isoCode":"BR","countryCode":"CV","latitude":"40.98977780","longitude":"-73.68357150"},{"name":"Boa Vista","isoCode":"BV","countryCode":"CV","latitude":"38.74346600","longitude":"-120.73042970"},{"name":"Santa Catarina","isoCode":"CA","countryCode":"CV","latitude":"-27.24233920","longitude":"-50.21885560"},{"name":"Santa Catarina do Fogo","isoCode":"CF","countryCode":"CV","latitude":"14.93091040","longitude":"-24.32225770"},{"name":"Santa Cruz","isoCode":"CR","countryCode":"CV","latitude":"36.97411710","longitude":"-122.03079630"},{"name":"Maio Municipality","isoCode":"MA","countryCode":"CV","latitude":"15.20030980","longitude":"-23.16797930"},{"name":"Mosteiros","isoCode":"MO","countryCode":"CV","latitude":"37.89043480","longitude":"-25.82075560"},{"name":"Paul","isoCode":"PA","countryCode":"CV","latitude":"37.06250000","longitude":"-95.67706800"},{"name":"Porto Novo","isoCode":"PN","countryCode":"CV","latitude":"6.49685740","longitude":"2.62885230"},{"name":"Praia","isoCode":"PR","countryCode":"CV","latitude":"14.93305000","longitude":"-23.51332670"},{"name":"Ribeira Brava Municipality","isoCode":"RB","countryCode":"CV","latitude":"16.60707390","longitude":"-24.20338430"},{"name":"Ribeira Grande","isoCode":"RG","countryCode":"CV","latitude":"37.82103690","longitude":"-25.51481370"},{"name":"Ribeira Grande de Santiago","isoCode":"RS","countryCode":"CV","latitude":"14.98302980","longitude":"-23.65617250"},{"name":"Sotavento Islands","isoCode":"S","countryCode":"CV","latitude":"15.00000000","longitude":"-24.00000000"},{"name":"S\xe3o Domingos","isoCode":"SD","countryCode":"CV","latitude":"15.02861650","longitude":"-23.56392200"},{"name":"S\xe3o Filipe","isoCode":"SF","countryCode":"CV","latitude":"14.89516790","longitude":"-24.49456360"},{"name":"Sal","isoCode":"SL","countryCode":"CV","latitude":"26.59581220","longitude":"-80.20450830"},{"name":"S\xe3o Miguel","isoCode":"SM","countryCode":"CV","latitude":"37.78041100","longitude":"-25.49704660"},{"name":"S\xe3o Louren\xe7o dos \xd3rg\xe3os","isoCode":"SO","countryCode":"CV","latitude":"15.05378410","longitude":"-23.60856120"},{"name":"S\xe3o Vicente","isoCode":"SV","countryCode":"CV","latitude":"-23.96071570","longitude":"-46.39620220"},{"name":"Tarrafal","isoCode":"TA","countryCode":"CV","latitude":"15.27605780","longitude":"-23.74840770"},{"name":"Tarrafal de S\xe3o Nicolau","isoCode":"TS","countryCode":"CV","latitude":"16.56364980","longitude":"-24.35494200"},{"name":"Nicosia District (Lefko\u015Fa)","isoCode":"01","countryCode":"CY","latitude":"35.18556590","longitude":"33.38227640"},{"name":"Limassol District (Leymasun)","isoCode":"02","countryCode":"CY","latitude":"34.70713010","longitude":"33.02261740"},{"name":"Larnaca District (Larnaka)","isoCode":"03","countryCode":"CY","latitude":"34.85072060","longitude":"33.48319060"},{"name":"Famagusta District (Ma\u011Fusa)","isoCode":"04","countryCode":"CY","latitude":"35.28570230","longitude":"33.84112880"},{"name":"Paphos District (Pafos)","isoCode":"05","countryCode":"CY","latitude":"34.91645940","longitude":"32.49200880"},{"name":"Kyrenia District (Keryneia)","isoCode":"06","countryCode":"CY","latitude":"35.29919400","longitude":"33.23632460"},{"name":"Praha, Hlavn\xed m\u011Bsto","isoCode":"10","countryCode":"CZ","latitude":"50.07553810","longitude":"14.43780050"},{"name":"St\u0159edo\u010Desk\xfd kraj","isoCode":"20","countryCode":"CZ","latitude":"49.87822230","longitude":"14.93629550"},{"name":"Bene\u0161ov","isoCode":"201","countryCode":"CZ","latitude":"49.69008280","longitude":"14.77643990"},{"name":"Beroun","isoCode":"202","countryCode":"CZ","latitude":"49.95734280","longitude":"13.98407150"},{"name":"Kladno","isoCode":"203","countryCode":"CZ","latitude":"50.19402580","longitude":"14.10436570"},{"name":"Kol\xedn","isoCode":"204","countryCode":"CZ","latitude":"49.98832930","longitude":"15.05519770"},{"name":"Kutn\xe1 Hora","isoCode":"205","countryCode":"CZ","latitude":"49.94920890","longitude":"15.24704400"},{"name":"M\u011Bln\xedk","isoCode":"206","countryCode":"CZ","latitude":"50.31044150","longitude":"14.51792230"},{"name":"Mlad\xe1 Boleslav","isoCode":"207","countryCode":"CZ","latitude":"50.42523170","longitude":"14.93624770"},{"name":"Nymburk","isoCode":"208","countryCode":"CZ","latitude":"50.18558160","longitude":"15.04366040"},{"name":"Praha-v\xfdchod","isoCode":"209","countryCode":"CZ","latitude":"49.93893070","longitude":"14.79244720"},{"name":"Praha-z\xe1pad","isoCode":"20A","countryCode":"CZ","latitude":"49.89352350","longitude":"14.32937790"},{"name":"P\u0159\xedbram","isoCode":"20B","countryCode":"CZ","latitude":"49.69479590","longitude":"14.08238100"},{"name":"Rakovn\xedk","isoCode":"20C","countryCode":"CZ","latitude":"50.10612300","longitude":"13.73966230"},{"name":"Jiho\u010Desk\xfd kraj","isoCode":"31","countryCode":"CZ","latitude":"48.94577890","longitude":"14.44160550"},{"name":"\u010Cesk\xe9 Bud\u011Bjovice","isoCode":"311","countryCode":"CZ","latitude":"48.97755530","longitude":"14.51507470"},{"name":"\u010Cesk\xfd Krumlov","isoCode":"312","countryCode":"CZ","latitude":"48.81273540","longitude":"14.31746570"},{"name":"Jind\u0159ich\u016Fv Hradec","isoCode":"313","countryCode":"CZ","latitude":"49.14448230","longitude":"15.00613890"},{"name":"P\xedsek","isoCode":"314","countryCode":"CZ","latitude":"49.34199380","longitude":"14.24697600"},{"name":"Prachatice","isoCode":"315","countryCode":"CZ","latitude":"49.01091000","longitude":"14.00000050"},{"name":"Strakonice","isoCode":"316","countryCode":"CZ","latitude":"49.26040430","longitude":"13.91030850"},{"name":"T\xe1bor","isoCode":"317","countryCode":"CZ","latitude":"49.36462930","longitude":"14.71912930"},{"name":"Plze\u0148sk\xfd kraj","isoCode":"32","countryCode":"CZ","latitude":"49.41348120","longitude":"13.31572460"},{"name":"Doma\u017Elice","isoCode":"321","countryCode":"CZ","latitude":"49.43970270","longitude":"12.93114350"},{"name":"Klatovy","isoCode":"322","countryCode":"CZ","latitude":"49.39555490","longitude":"13.29509370"},{"name":"Plze\u0148-m\u011Bsto","isoCode":"323","countryCode":"CZ","latitude":"49.73843140","longitude":"13.37363710"},{"name":"Plze\u0148-jih","isoCode":"324","countryCode":"CZ","latitude":"49.59048850","longitude":"13.57158610"},{"name":"Plze\u0148-sever","isoCode":"325","countryCode":"CZ","latitude":"49.87748930","longitude":"13.25374280"},{"name":"Rokycany","isoCode":"326","countryCode":"CZ","latitude":"49.82628270","longitude":"13.68749430"},{"name":"Tachov","isoCode":"327","countryCode":"CZ","latitude":"49.79878030","longitude":"12.63619210"},{"name":"Karlovarsk\xfd kraj","isoCode":"41","countryCode":"CZ","latitude":"50.14350000","longitude":"12.75018990"},{"name":"Cheb","isoCode":"411","countryCode":"CZ","latitude":"50.07953340","longitude":"12.36986360"},{"name":"Karlovy Vary","isoCode":"412","countryCode":"CZ","latitude":"50.14350000","longitude":"12.75018990"},{"name":"Sokolov","isoCode":"413","countryCode":"CZ","latitude":"50.20134340","longitude":"12.60546360"},{"name":"\xdasteck\xfd kraj","isoCode":"42","countryCode":"CZ","latitude":"50.61190370","longitude":"13.78700860"},{"name":"D\u011B\u010D\xedn","isoCode":"421","countryCode":"CZ","latitude":"50.77255630","longitude":"14.21276120"},{"name":"Chomutov","isoCode":"422","countryCode":"CZ","latitude":"50.45838720","longitude":"13.30179100"},{"name":"Litom\u011B\u0159ice","isoCode":"423","countryCode":"CZ","latitude":"50.53841970","longitude":"14.13054580"},{"name":"Louny","isoCode":"424","countryCode":"CZ","latitude":"50.35398120","longitude":"13.80335510"},{"name":"Most","isoCode":"425","countryCode":"CZ","latitude":"37.15540830","longitude":"-94.29488840"},{"name":"Teplice","isoCode":"426","countryCode":"CZ","latitude":"50.65846050","longitude":"13.75132270"},{"name":"\xdast\xed nad Labem","isoCode":"427","countryCode":"CZ","latitude":"50.61190370","longitude":"13.78700860"},{"name":"Libereck\xfd kraj","isoCode":"51","countryCode":"CZ","latitude":"50.65942400","longitude":"14.76324240"},{"name":"\u010Cesk\xe1 L\xedpa","isoCode":"511","countryCode":"CZ","latitude":"50.67852010","longitude":"14.53969910"},{"name":"Jablonec nad Nisou","isoCode":"512","countryCode":"CZ","latitude":"50.72205280","longitude":"15.17031350"},{"name":"Liberec","isoCode":"513","countryCode":"CZ","latitude":"50.75641010","longitude":"14.99650410"},{"name":"Semily","isoCode":"514","countryCode":"CZ","latitude":"50.60515760","longitude":"15.32814090"},{"name":"Kr\xe1lov\xe9hradeck\xfd kraj","isoCode":"52","countryCode":"CZ","latitude":"50.35124840","longitude":"15.79764590"},{"name":"Hradec Kr\xe1lov\xe9","isoCode":"521","countryCode":"CZ","latitude":"50.24148050","longitude":"15.67430000"},{"name":"Ji\u010D\xedn","isoCode":"522","countryCode":"CZ","latitude":"50.43533250","longitude":"15.36104400"},{"name":"N\xe1chod","isoCode":"523","countryCode":"CZ","latitude":"50.41457220","longitude":"16.16563470"},{"name":"Rychnov nad Kn\u011B\u017Enou","isoCode":"524","countryCode":"CZ","latitude":"50.16596510","longitude":"16.27768420"},{"name":"Trutnov","isoCode":"525","countryCode":"CZ","latitude":"50.56538380","longitude":"15.90909230"},{"name":"Pardubick\xfd kraj","isoCode":"53","countryCode":"CZ","latitude":"49.94444790","longitude":"16.28569160"},{"name":"Chrudim","isoCode":"531","countryCode":"CZ","latitude":"49.88302160","longitude":"15.82908660"},{"name":"Pardubice","isoCode":"532","countryCode":"CZ","latitude":"49.94444790","longitude":"16.28569160"},{"name":"Svitavy","isoCode":"533","countryCode":"CZ","latitude":"49.75516290","longitude":"16.46918610"},{"name":"\xdast\xed nad Orlic\xed","isoCode":"534","countryCode":"CZ","latitude":"49.97218010","longitude":"16.39966170"},{"name":"Kraj Vyso\u010Dina","isoCode":"63","countryCode":"CZ","latitude":"49.44900520","longitude":"15.64059340"},{"name":"Havl\xed\u010Dk\u016Fv Brod","isoCode":"631","countryCode":"CZ","latitude":"49.60433640","longitude":"15.57965520"},{"name":"Jihlava","isoCode":"632","countryCode":"CZ","latitude":"49.39837820","longitude":"15.58704150"},{"name":"Pelh\u0159imov","isoCode":"633","countryCode":"CZ","latitude":"49.43062070","longitude":"15.22298300"},{"name":"T\u0159eb\xed\u010D","isoCode":"634","countryCode":"CZ","latitude":"49.21478690","longitude":"15.87955160"},{"name":"\u017D\u010F\xe1r nad S\xe1zavou","isoCode":"635","countryCode":"CZ","latitude":"49.56430120","longitude":"15.93910300"},{"name":"Jihomoravsk\xfd kraj","isoCode":"64","countryCode":"CZ","latitude":"48.95445280","longitude":"16.76768990"},{"name":"Blansko","isoCode":"641","countryCode":"CZ","latitude":"49.36485020","longitude":"16.64775520"},{"name":"Brno-m\u011Bsto","isoCode":"642","countryCode":"CZ","latitude":"49.19506020","longitude":"16.60683710"},{"name":"Brno-venkov","isoCode":"643","countryCode":"CZ","latitude":"49.12501380","longitude":"16.45588240"},{"name":"B\u0159eclav","isoCode":"644","countryCode":"CZ","latitude":"48.75314000","longitude":"16.88251690"},{"name":"Hodon\xedn","isoCode":"645","countryCode":"CZ","latitude":"48.85293910","longitude":"17.12600250"},{"name":"Vy\u0161kov","isoCode":"646","countryCode":"CZ","latitude":"49.21274450","longitude":"16.98559270"},{"name":"Znojmo","isoCode":"647","countryCode":"CZ","latitude":"48.92723270","longitude":"16.10378080"},{"name":"Olomouck\xfd kraj","isoCode":"71","countryCode":"CZ","latitude":"49.65865490","longitude":"17.08114060"},{"name":"Jesen\xedk","isoCode":"711","countryCode":"CZ","latitude":"50.22462490","longitude":"17.19804710"},{"name":"Olomouc","isoCode":"712","countryCode":"CZ","latitude":"49.59377800","longitude":"17.25087870"},{"name":"Prost\u011Bjov","isoCode":"713","countryCode":"CZ","latitude":"49.44184010","longitude":"17.12779040"},{"name":"P\u0159erov","isoCode":"714","countryCode":"CZ","latitude":"49.46713560","longitude":"17.50773320"},{"name":"\u0160umperk","isoCode":"715","countryCode":"CZ","latitude":"49.97784070","longitude":"16.97177540"},{"name":"Zl\xednsk\xfd kraj","isoCode":"72","countryCode":"CZ","latitude":"49.21622960","longitude":"17.77203530"},{"name":"Krom\u011B\u0159\xed\u017E","isoCode":"721","countryCode":"CZ","latitude":"49.29165820","longitude":"17.39938000"},{"name":"Uhersk\xe9 Hradi\u0161t\u011B","isoCode":"722","countryCode":"CZ","latitude":"49.05979690","longitude":"17.49585010"},{"name":"Vset\xedn","isoCode":"723","countryCode":"CZ","latitude":"49.37932500","longitude":"18.06181620"},{"name":"Zl\xedn","isoCode":"724","countryCode":"CZ","latitude":"49.16960520","longitude":"17.80252200"},{"name":"Moravskoslezsk\xfd kraj","isoCode":"80","countryCode":"CZ","latitude":"49.73053270","longitude":"18.23326370"},{"name":"Brunt\xe1l","isoCode":"801","countryCode":"CZ","latitude":"49.98817670","longitude":"17.46369410"},{"name":"Fr\xfddek-M\xedstek","isoCode":"802","countryCode":"CZ","latitude":"49.68193050","longitude":"18.36732160"},{"name":"Karvin\xe1","isoCode":"803","countryCode":"CZ","latitude":"49.85665240","longitude":"18.54321860"},{"name":"Nov\xfd Ji\u010D\xedn","isoCode":"804","countryCode":"CZ","latitude":"49.59432510","longitude":"18.01353560"},{"name":"Opava","isoCode":"805","countryCode":"CZ","latitude":"49.90837570","longitude":"17.91633800"},{"name":"Ostrava-m\u011Bsto","isoCode":"806","countryCode":"CZ","latitude":"49.82092260","longitude":"18.26252430"},{"name":"Brandenburg","isoCode":"BB","countryCode":"DE","latitude":"52.41252870","longitude":"12.53164440"},{"name":"Berlin","isoCode":"BE","countryCode":"DE","latitude":"52.52000660","longitude":"13.40495400"},{"name":"Baden-W\xfcrttemberg","isoCode":"BW","countryCode":"DE","latitude":"48.66160370","longitude":"9.35013360"},{"name":"Bavaria","isoCode":"BY","countryCode":"DE","latitude":"48.79044720","longitude":"11.49788950"},{"name":"Bremen","isoCode":"HB","countryCode":"DE","latitude":"53.07929620","longitude":"8.80169360"},{"name":"Hesse","isoCode":"HE","countryCode":"DE","latitude":"50.65205150","longitude":"9.16243760"},{"name":"Hamburg","isoCode":"HH","countryCode":"DE","latitude":"53.55108460","longitude":"9.99368190"},{"name":"Mecklenburg-Vorpommern","isoCode":"MV","countryCode":"DE","latitude":"53.61265050","longitude":"12.42959530"},{"name":"Lower Saxony","isoCode":"NI","countryCode":"DE","latitude":"52.63670360","longitude":"9.84507660"},{"name":"North Rhine-Westphalia","isoCode":"NW","countryCode":"DE","latitude":"51.43323670","longitude":"7.66159380"},{"name":"Rhineland-Palatinate","isoCode":"RP","countryCode":"DE","latitude":"50.11834600","longitude":"7.30895270"},{"name":"Schleswig-Holstein","isoCode":"SH","countryCode":"DE","latitude":"54.21936720","longitude":"9.69611670"},{"name":"Saarland","isoCode":"SL","countryCode":"DE","latitude":"49.39642340","longitude":"7.02296070"},{"name":"Saxony","isoCode":"SN","countryCode":"DE","latitude":"51.10454070","longitude":"13.20173840"},{"name":"Saxony-Anhalt","isoCode":"ST","countryCode":"DE","latitude":"51.95026490","longitude":"11.69227340"},{"name":"Thuringia","isoCode":"TH","countryCode":"DE","latitude":"51.01098920","longitude":"10.84534600"},{"name":"Arta Region","isoCode":"AR","countryCode":"DJ","latitude":"11.52555280","longitude":"42.84794740"},{"name":"Ali Sabieh Region","isoCode":"AS","countryCode":"DJ","latitude":"11.19289730","longitude":"42.94169800"},{"name":"Dikhil Region","isoCode":"DI","countryCode":"DJ","latitude":"11.10543360","longitude":"42.37047440"},{"name":"Djibouti","isoCode":"DJ","countryCode":"DJ","latitude":"11.82513800","longitude":"42.59027500"},{"name":"Obock Region","isoCode":"OB","countryCode":"DJ","latitude":"12.38956910","longitude":"43.01948970"},{"name":"Tadjourah Region","isoCode":"TA","countryCode":"DJ","latitude":"11.93388850","longitude":"42.39383750"},{"name":"North Denmark Region","isoCode":"81","countryCode":"DK","latitude":"56.83074160","longitude":"9.49305270"},{"name":"Central Denmark Region","isoCode":"82","countryCode":"DK","latitude":"56.30213900","longitude":"9.30277700"},{"name":"Region of Southern Denmark","isoCode":"83","countryCode":"DK","latitude":"55.33077140","longitude":"9.09249030"},{"name":"Capital Region of Denmark","isoCode":"84","countryCode":"DK","latitude":"55.67518120","longitude":"12.54932610"},{"name":"Region Zealand","isoCode":"85","countryCode":"DK","latitude":"55.46325180","longitude":"11.72149790"},{"name":"Saint Andrew Parish","isoCode":"02","countryCode":"DM","latitude":null,"longitude":null},{"name":"Saint David Parish","isoCode":"03","countryCode":"DM","latitude":null,"longitude":null},{"name":"Saint George Parish","isoCode":"04","countryCode":"DM","latitude":null,"longitude":null},{"name":"Saint John Parish","isoCode":"05","countryCode":"DM","latitude":null,"longitude":null},{"name":"Saint Joseph Parish","isoCode":"06","countryCode":"DM","latitude":"39.02227120","longitude":"-94.71765040"},{"name":"Saint Luke Parish","isoCode":"07","countryCode":"DM","latitude":"42.10513630","longitude":"-80.05707220"},{"name":"Saint Mark Parish","isoCode":"08","countryCode":"DM","latitude":null,"longitude":null},{"name":"Saint Patrick Parish","isoCode":"09","countryCode":"DM","latitude":null,"longitude":null},{"name":"Saint Paul Parish","isoCode":"10","countryCode":"DM","latitude":"38.86146000","longitude":"-90.74356190"},{"name":"Saint Peter Parish","isoCode":"11","countryCode":"DM","latitude":"40.45241940","longitude":"-80.00850560"},{"name":"Distrito Nacional","isoCode":"01","countryCode":"DO","latitude":"18.48605750","longitude":"-69.93121170"},{"name":"Azua Province","isoCode":"02","countryCode":"DO","latitude":"18.45527090","longitude":"-70.73809280"},{"name":"Baoruco Province","isoCode":"03","countryCode":"DO","latitude":"18.48798980","longitude":"-71.41822490"},{"name":"Barahona Province","isoCode":"04","countryCode":"DO","latitude":"18.21390660","longitude":"-71.10437590"},{"name":"Dajab\xf3n Province","isoCode":"05","countryCode":"DO","latitude":"19.54992410","longitude":"-71.70865140"},{"name":"Duarte Province","isoCode":"06","countryCode":"DO","latitude":"19.20908230","longitude":"-70.02700040"},{"name":"El Seibo Province","isoCode":"08","countryCode":"DO","latitude":"18.76584960","longitude":"-69.04066800"},{"name":"Espaillat Province","isoCode":"09","countryCode":"DO","latitude":"19.62776580","longitude":"-70.27867750"},{"name":"Independencia","isoCode":"10","countryCode":"DO","latitude":"32.63357480","longitude":"-115.42892940"},{"name":"La Altagracia Province","isoCode":"11","countryCode":"DO","latitude":"18.58502360","longitude":"-68.62010720"},{"name":"La Romana Province","isoCode":"12","countryCode":"DO","latitude":"18.43102710","longitude":"-68.98373730"},{"name":"La Vega Province","isoCode":"13","countryCode":"DO","latitude":"19.22115540","longitude":"-70.52887530"},{"name":"Mar\xeda Trinidad S\xe1nchez Province","isoCode":"14","countryCode":"DO","latitude":"19.37345970","longitude":"-69.85144390"},{"name":"Monte Cristi Province","isoCode":"15","countryCode":"DO","latitude":"19.73968990","longitude":"-71.44339840"},{"name":"Pedernales Province","isoCode":"16","countryCode":"DO","latitude":"17.85376260","longitude":"-71.33032090"},{"name":"Peravia Province","isoCode":"17","countryCode":"DO","latitude":"18.27865940","longitude":"-70.33358870"},{"name":"Puerto Plata Province","isoCode":"18","countryCode":"DO","latitude":"19.75432250","longitude":"-70.83328470"},{"name":"Hermanas Mirabal Province","isoCode":"19","countryCode":"DO","latitude":"19.37475590","longitude":"-70.35132350"},{"name":"Saman\xe1 Province","isoCode":"20","countryCode":"DO","latitude":"19.20583710","longitude":"-69.33629490"},{"name":"San Crist\xf3bal Province","isoCode":"21","countryCode":"DO","latitude":"18.41804140","longitude":"-70.10658490"},{"name":"San Juan Province","isoCode":"22","countryCode":"DO","latitude":"-31.52871270","longitude":"-68.53604030"},{"name":"San Pedro de Macor\xeds","isoCode":"23","countryCode":"DO","latitude":"18.46266000","longitude":"-69.30512340"},{"name":"S\xe1nchez Ram\xedrez Province","isoCode":"24","countryCode":"DO","latitude":"19.05270600","longitude":"-70.14922640"},{"name":"Santiago Province","isoCode":"25","countryCode":"DO","latitude":"-33.45000000","longitude":"-70.66670000"},{"name":"Santiago Rodr\xedguez Province","isoCode":"26","countryCode":"DO","latitude":"19.47131810","longitude":"-71.33958010"},{"name":"Valverde Province","isoCode":"27","countryCode":"DO","latitude":"19.58812210","longitude":"-70.98033100"},{"name":"Monse\xf1or Nouel Province","isoCode":"28","countryCode":"DO","latitude":"18.92152340","longitude":"-70.38368150"},{"name":"Monte Plata Province","isoCode":"29","countryCode":"DO","latitude":"18.80808780","longitude":"-69.78691460"},{"name":"Hato Mayor Province","isoCode":"30","countryCode":"DO","latitude":"18.76357990","longitude":"-69.25576370"},{"name":"San Jos\xe9 de Ocoa Province","isoCode":"31","countryCode":"DO","latitude":"18.54385800","longitude":"-70.50418160"},{"name":"Santo Domingo Province","isoCode":"32","countryCode":"DO","latitude":"18.51042530","longitude":"-69.84040540"},{"name":"Adrar","isoCode":"01","countryCode":"DZ","latitude":"26.41813100","longitude":"-0.60147170"},{"name":"Chlef","isoCode":"02","countryCode":"DZ","latitude":"36.16935150","longitude":"1.28910360"},{"name":"Laghouat","isoCode":"03","countryCode":"DZ","latitude":"33.80783410","longitude":"2.86282940"},{"name":"Oum El Bouaghi","isoCode":"04","countryCode":"DZ","latitude":"35.86887890","longitude":"7.11082660"},{"name":"Batna","isoCode":"05","countryCode":"DZ","latitude":"35.59659540","longitude":"5.89871390"},{"name":"B\xe9ja\xefa","isoCode":"06","countryCode":"DZ","latitude":"36.75152580","longitude":"5.05568370"},{"name":"Biskra","isoCode":"07","countryCode":"DZ","latitude":"34.84494370","longitude":"5.72485670"},{"name":"B\xe9char","isoCode":"08","countryCode":"DZ","latitude":"31.62380980","longitude":"-2.21624430"},{"name":"Blida","isoCode":"09","countryCode":"DZ","latitude":"36.53112300","longitude":"2.89762540"},{"name":"Bou\xefra","isoCode":"10","countryCode":"DZ","latitude":"36.36918460","longitude":"3.90061940"},{"name":"Tamanghasset","isoCode":"11","countryCode":"DZ","latitude":"22.79029720","longitude":"5.51932680"},{"name":"T\xe9bessa","isoCode":"12","countryCode":"DZ","latitude":"35.12906910","longitude":"7.95928630"},{"name":"Tlemcen","isoCode":"13","countryCode":"DZ","latitude":"34.67802840","longitude":"-1.36621600"},{"name":"Tiaret","isoCode":"14","countryCode":"DZ","latitude":"35.37086890","longitude":"1.32178520"},{"name":"Tizi Ouzou","isoCode":"15","countryCode":"DZ","latitude":"36.70691100","longitude":"4.23333550"},{"name":"Algiers","isoCode":"16","countryCode":"DZ","latitude":"36.69972940","longitude":"3.05761990"},{"name":"Djelfa","isoCode":"17","countryCode":"DZ","latitude":"34.67039560","longitude":"3.25037610"},{"name":"Jijel","isoCode":"18","countryCode":"DZ","latitude":"36.71796810","longitude":"5.98325770"},{"name":"S\xe9tif","isoCode":"19","countryCode":"DZ","latitude":"36.30733890","longitude":"5.56172790"},{"name":"Sa\xefda","isoCode":"20","countryCode":"DZ","latitude":"34.84152070","longitude":"0.14560550"},{"name":"Skikda","isoCode":"21","countryCode":"DZ","latitude":"36.67211980","longitude":"6.83509990"},{"name":"Sidi Bel Abb\xe8s","isoCode":"22","countryCode":"DZ","latitude":"34.68060240","longitude":"-1.09994950"},{"name":"Annaba","isoCode":"23","countryCode":"DZ","latitude":"36.80205080","longitude":"7.52472430"},{"name":"Guelma","isoCode":"24","countryCode":"DZ","latitude":"36.46274440","longitude":"7.43308330"},{"name":"Constantine","isoCode":"25","countryCode":"DZ","latitude":"36.33739110","longitude":"6.66381200"},{"name":"M\xe9d\xe9a","isoCode":"26","countryCode":"DZ","latitude":"36.26370780","longitude":"2.75878570"},{"name":"Mostaganem","isoCode":"27","countryCode":"DZ","latitude":"35.95830540","longitude":"0.33718890"},{"name":"M\'Sila","isoCode":"28","countryCode":"DZ","latitude":"35.71866460","longitude":"4.52334230"},{"name":"Mascara","isoCode":"29","countryCode":"DZ","latitude":"35.39041250","longitude":"0.14949880"},{"name":"Ouargla","isoCode":"30","countryCode":"DZ","latitude":"32.22648630","longitude":"5.72998210"},{"name":"Oran","isoCode":"31","countryCode":"DZ","latitude":"35.60823510","longitude":"-0.56360900"},{"name":"El Bayadh","isoCode":"32","countryCode":"DZ","latitude":"32.71488240","longitude":"0.90566230"},{"name":"Illizi","isoCode":"33","countryCode":"DZ","latitude":"26.16900050","longitude":"8.48424650"},{"name":"Bordj Bou Arr\xe9ridj","isoCode":"34","countryCode":"DZ","latitude":"36.07399250","longitude":"4.76302710"},{"name":"Boumerd\xe8s","isoCode":"35","countryCode":"DZ","latitude":"36.68395590","longitude":"3.62178020"},{"name":"El Tarf","isoCode":"36","countryCode":"DZ","latitude":"36.75766780","longitude":"8.30763430"},{"name":"Tindouf","isoCode":"37","countryCode":"DZ","latitude":"27.80631190","longitude":"-5.72998210"},{"name":"Tissemsilt","isoCode":"38","countryCode":"DZ","latitude":"35.60537810","longitude":"1.81309800"},{"name":"El Oued","isoCode":"39","countryCode":"DZ","latitude":"33.36781100","longitude":"6.85165110"},{"name":"Khenchela","isoCode":"40","countryCode":"DZ","latitude":"35.42694040","longitude":"7.14601550"},{"name":"Souk Ahras","isoCode":"41","countryCode":"DZ","latitude":"36.28010620","longitude":"7.93840330"},{"name":"Tipasa","isoCode":"42","countryCode":"DZ","latitude":"36.54626500","longitude":"2.18432850"},{"name":"Mila","isoCode":"43","countryCode":"DZ","latitude":"36.36479570","longitude":"6.15269850"},{"name":"A\xefn Defla","isoCode":"44","countryCode":"DZ","latitude":"36.25094290","longitude":"1.93938150"},{"name":"Naama","isoCode":"45","countryCode":"DZ","latitude":"33.26673170","longitude":"-0.31286590"},{"name":"A\xefn T\xe9mouchent","isoCode":"46","countryCode":"DZ","latitude":"35.29926980","longitude":"-1.13927920"},{"name":"Gharda\xefa","isoCode":"47","countryCode":"DZ","latitude":"32.49437410","longitude":"3.64446000"},{"name":"Relizane","isoCode":"48","countryCode":"DZ","latitude":"35.73834050","longitude":"0.75328090"},{"name":"El M\'ghair","isoCode":"49","countryCode":"DZ","latitude":"33.95405610","longitude":"5.13464180"},{"name":"El Menia","isoCode":"50","countryCode":"DZ","latitude":"31.36422500","longitude":"2.57844950"},{"name":"Ouled Djellal","isoCode":"51","countryCode":"DZ","latitude":"34.41782210","longitude":"4.96858430"},{"name":"Bordj Baji Mokhtar","isoCode":"52","countryCode":"DZ","latitude":"22.96633500","longitude":"-3.94727320"},{"name":"B\xe9ni Abb\xe8s","isoCode":"53","countryCode":"DZ","latitude":"30.08310420","longitude":"-2.83450520"},{"name":"Timimoun","isoCode":"54","countryCode":"DZ","latitude":"29.67890600","longitude":"0.50046080"},{"name":"Touggourt","isoCode":"55","countryCode":"DZ","latitude":"33.12484760","longitude":"5.78327150"},{"name":"Djanet","isoCode":"56","countryCode":"DZ","latitude":"23.83108720","longitude":"8.70046720"},{"name":"In Salah","isoCode":"57","countryCode":"DZ","latitude":"27.21492290","longitude":"1.84843960"},{"name":"In Guezzam","isoCode":"58","countryCode":"DZ","latitude":"20.38643230","longitude":"4.77893940"},{"name":"Azuay","isoCode":"A","countryCode":"EC","latitude":"-2.89430680","longitude":"-78.99683440"},{"name":"Bol\xedvar","isoCode":"B","countryCode":"EC","latitude":"-1.70958280","longitude":"-79.04504290"},{"name":"Carchi","isoCode":"C","countryCode":"EC","latitude":"0.50269120","longitude":"-77.90425210"},{"name":"Orellana","isoCode":"D","countryCode":"EC","latitude":"-0.45451630","longitude":"-76.99502860"},{"name":"Esmeraldas","isoCode":"E","countryCode":"EC","latitude":"0.96817890","longitude":"-79.65172020"},{"name":"Ca\xf1ar","isoCode":"F","countryCode":"EC","latitude":"-2.55893150","longitude":"-78.93881910"},{"name":"Guayas","isoCode":"G","countryCode":"EC","latitude":"-1.95748390","longitude":"-79.91927020"},{"name":"Chimborazo","isoCode":"H","countryCode":"EC","latitude":"-1.66479950","longitude":"-78.65432550"},{"name":"Imbabura","isoCode":"I","countryCode":"EC","latitude":"0.34997680","longitude":"-78.12601290"},{"name":"Loja","isoCode":"L","countryCode":"EC","latitude":"-3.99313000","longitude":"-79.20422000"},{"name":"Manab\xed","isoCode":"M","countryCode":"EC","latitude":"-1.05434340","longitude":"-80.45264400"},{"name":"Napo","isoCode":"N","countryCode":"EC","latitude":"-0.99559640","longitude":"-77.81296840"},{"name":"El Oro","isoCode":"O","countryCode":"EC","latitude":"-3.25924130","longitude":"-79.95835410"},{"name":"Pichincha","isoCode":"P","countryCode":"EC","latitude":"-0.14648470","longitude":"-78.47519450"},{"name":"Los R\xedos","isoCode":"R","countryCode":"EC","latitude":"-1.02306070","longitude":"-79.46088970"},{"name":"Morona-Santiago","isoCode":"S","countryCode":"EC","latitude":"-2.30510620","longitude":"-78.11468660"},{"name":"Santo Domingo de los Ts\xe1chilas","isoCode":"SD","countryCode":"EC","latitude":"-0.25218820","longitude":"-79.18793830"},{"name":"Santa Elena","isoCode":"SE","countryCode":"EC","latitude":"-2.22671050","longitude":"-80.85949900"},{"name":"Tungurahua","isoCode":"T","countryCode":"EC","latitude":"-1.26352840","longitude":"-78.56608520"},{"name":"Sucumb\xedos","isoCode":"U","countryCode":"EC","latitude":"0.08892310","longitude":"-76.88975570"},{"name":"Gal\xe1pagos","isoCode":"W","countryCode":"EC","latitude":"-0.95376910","longitude":"-90.96560190"},{"name":"Cotopaxi","isoCode":"X","countryCode":"EC","latitude":"-0.83842060","longitude":"-78.66626780"},{"name":"Pastaza","isoCode":"Y","countryCode":"EC","latitude":"-1.48822650","longitude":"-78.00310570"},{"name":"Zamora Chinchipe","isoCode":"Z","countryCode":"EC","latitude":"-4.06558920","longitude":"-78.95035250"},{"name":"Harju County","isoCode":"37","countryCode":"EE","latitude":"59.33342390","longitude":"25.24669740"},{"name":"Hiiu County","isoCode":"39","countryCode":"EE","latitude":"58.92395530","longitude":"22.59194680"},{"name":"Ida-Viru County","isoCode":"44","countryCode":"EE","latitude":"59.25926630","longitude":"27.41365350"},{"name":"J\xf5geva County","isoCode":"49","countryCode":"EE","latitude":"58.75061430","longitude":"26.36048780"},{"name":"J\xe4rva County","isoCode":"51","countryCode":"EE","latitude":"58.88667130","longitude":"25.50006240"},{"name":"L\xe4\xe4ne County","isoCode":"57","countryCode":"EE","latitude":"58.97227420","longitude":"23.87408340"},{"name":"L\xe4\xe4ne-Viru County","isoCode":"59","countryCode":"EE","latitude":"59.30188160","longitude":"26.32803120"},{"name":"P\xf5lva County","isoCode":"65","countryCode":"EE","latitude":"58.11606220","longitude":"27.20663940"},{"name":"P\xe4rnu County","isoCode":"67","countryCode":"EE","latitude":"58.52619520","longitude":"24.40201590"},{"name":"Rapla County","isoCode":"70","countryCode":"EE","latitude":"58.84926250","longitude":"24.73465690"},{"name":"Saare County","isoCode":"74","countryCode":"EE","latitude":"58.48497210","longitude":"22.61364080"},{"name":"Tartu County","isoCode":"78","countryCode":"EE","latitude":"58.40571280","longitude":"26.80157600"},{"name":"Valga County","isoCode":"82","countryCode":"EE","latitude":"57.91034410","longitude":"26.16018190"},{"name":"Viljandi County","isoCode":"84","countryCode":"EE","latitude":"58.28217460","longitude":"25.57522330"},{"name":"V\xf5ru County","isoCode":"86","countryCode":"EE","latitude":"57.73773720","longitude":"27.13989380"},{"name":"Alexandria","isoCode":"ALX","countryCode":"EG","latitude":"30.87605680","longitude":"29.74260400"},{"name":"Aswan","isoCode":"ASN","countryCode":"EG","latitude":"23.69664980","longitude":"32.71813750"},{"name":"Asyut","isoCode":"AST","countryCode":"EG","latitude":"27.21338310","longitude":"31.44561790"},{"name":"Red Sea","isoCode":"BA","countryCode":"EG","latitude":"24.68263160","longitude":"34.15319470"},{"name":"Beheira","isoCode":"BH","countryCode":"EG","latitude":"30.84809860","longitude":"30.34355060"},{"name":"Beni Suef","isoCode":"BNS","countryCode":"EG","latitude":"28.89388370","longitude":"31.44561790"},{"name":"Cairo","isoCode":"C","countryCode":"EG","latitude":"29.95375640","longitude":"31.53700030"},{"name":"Dakahlia","isoCode":"DK","countryCode":"EG","latitude":"31.16560440","longitude":"31.49131820"},{"name":"Damietta","isoCode":"DT","countryCode":"EG","latitude":"31.36257990","longitude":"31.67393710"},{"name":"Faiyum","isoCode":"FYM","countryCode":"EG","latitude":"29.30840210","longitude":"30.84284970"},{"name":"Gharbia","isoCode":"GH","countryCode":"EG","latitude":"30.87535560","longitude":"31.03351000"},{"name":"Giza","isoCode":"GZ","countryCode":"EG","latitude":"28.76662160","longitude":"29.23207840"},{"name":"Ismailia","isoCode":"IS","countryCode":"EG","latitude":"30.58309340","longitude":"32.26538870"},{"name":"South Sinai","isoCode":"JS","countryCode":"EG","latitude":"29.31018280","longitude":"34.15319470"},{"name":"Qalyubia","isoCode":"KB","countryCode":"EG","latitude":"30.32923680","longitude":"31.21684660"},{"name":"Kafr el-Sheikh","isoCode":"KFS","countryCode":"EG","latitude":"31.30854440","longitude":"30.80394740"},{"name":"Qena","isoCode":"KN","countryCode":"EG","latitude":"26.23460330","longitude":"32.98883190"},{"name":"Luxor","isoCode":"LX","countryCode":"EG","latitude":"25.39444440","longitude":"32.49200880"},{"name":"Minya","isoCode":"MN","countryCode":"EG","latitude":"28.28472900","longitude":"30.52790960"},{"name":"Monufia","isoCode":"MNF","countryCode":"EG","latitude":"30.59724550","longitude":"30.98763210"},{"name":"Matrouh","isoCode":"MT","countryCode":"EG","latitude":"29.56963500","longitude":"26.41938900"},{"name":"Port Said","isoCode":"PTS","countryCode":"EG","latitude":"31.07586060","longitude":"32.26538870"},{"name":"Sohag","isoCode":"SHG","countryCode":"EG","latitude":"26.69383400","longitude":"32.17460500"},{"name":"Sharqia","isoCode":"SHR","countryCode":"EG","latitude":"30.67305450","longitude":"31.15932470"},{"name":"North Sinai","isoCode":"SIN","countryCode":"EG","latitude":"30.28236500","longitude":"33.61757700"},{"name":"Suez","isoCode":"SUZ","countryCode":"EG","latitude":"29.36822550","longitude":"32.17460500"},{"name":"New Valley","isoCode":"WAD","countryCode":"EG","latitude":"24.54556380","longitude":"27.17353160"},{"name":"Anseba Region","isoCode":"AN","countryCode":"ER","latitude":"16.47455310","longitude":"37.80876930"},{"name":"Southern Red Sea Region","isoCode":"DK","countryCode":"ER","latitude":"13.51371030","longitude":"41.76064720"},{"name":"Debub Region","isoCode":"DU","countryCode":"ER","latitude":"14.94786920","longitude":"39.15436770"},{"name":"Gash-Barka Region","isoCode":"GB","countryCode":"ER","latitude":"15.40688250","longitude":"37.63866220"},{"name":"Maekel Region","isoCode":"MA","countryCode":"ER","latitude":"15.35514090","longitude":"38.86236830"},{"name":"Northern Red Sea Region","isoCode":"SK","countryCode":"ER","latitude":"16.25839970","longitude":"38.82054540"},{"name":"Andalusia","isoCode":"AN","countryCode":"ES","latitude":"37.54427060","longitude":"-4.72775280"},{"name":"Aragon","isoCode":"AR","countryCode":"ES","latitude":"41.59762750","longitude":"-0.90566230"},{"name":"Asturias","isoCode":"AS","countryCode":"ES","latitude":"43.36139530","longitude":"-5.85932670"},{"name":"\xc1vila","isoCode":"AV","countryCode":"ES","latitude":"40.69345110","longitude":"-4.89356270"},{"name":"Burgos Province","isoCode":"BU","countryCode":"ES","latitude":"42.33807580","longitude":"-3.58126920"},{"name":"Cantabria","isoCode":"CB","countryCode":"ES","latitude":"43.18283960","longitude":"-3.98784270"},{"name":"Ceuta","isoCode":"CE","countryCode":"ES","latitude":"35.88938740","longitude":"-5.32134550"},{"name":"Castile and Le\xf3n","isoCode":"CL","countryCode":"ES","latitude":"41.83568210","longitude":"-4.39763570"},{"name":"Castilla La Mancha","isoCode":"CM","countryCode":"ES","latitude":"39.27956070","longitude":"-3.09770200"},{"name":"Canary Islands","isoCode":"CN","countryCode":"ES","latitude":"28.29156370","longitude":"-16.62913040"},{"name":"Catalonia","isoCode":"CT","countryCode":"ES","latitude":"41.59115890","longitude":"1.52086240"},{"name":"Extremadura","isoCode":"EX","countryCode":"ES","latitude":"39.49373920","longitude":"-6.06791940"},{"name":"Galicia","isoCode":"GA","countryCode":"ES","latitude":"42.57505540","longitude":"-8.13385580"},{"name":"L\xe9on","isoCode":"LE","countryCode":"ES","latitude":"42.59870410","longitude":"-5.56708390"},{"name":"Murcia","isoCode":"MC","countryCode":"ES","latitude":"38.13981410","longitude":"-1.36621600"},{"name":"Madrid","isoCode":"MD","countryCode":"ES","latitude":"40.41675150","longitude":"-3.70383220"},{"name":"Melilla","isoCode":"ML","countryCode":"ES","latitude":"35.29227750","longitude":"-2.93809730"},{"name":"Navarra","isoCode":"NC","countryCode":"ES","latitude":"42.69539090","longitude":"-1.67606910"},{"name":"Palencia Province","isoCode":"P","countryCode":"ES","latitude":"42.00968320","longitude":"-4.52879490"},{"name":"Balearic Islands","isoCode":"PM","countryCode":"ES","latitude":"39.35877590","longitude":"2.73563280"},{"name":"Basque Country","isoCode":"PV","countryCode":"ES","latitude":"42.98962480","longitude":"-2.61892730"},{"name":"La Rioja","isoCode":"RI","countryCode":"ES","latitude":"42.28707330","longitude":"-2.53960300"},{"name":"Salamanca Province","isoCode":"SA","countryCode":"ES","latitude":"40.95152630","longitude":"-6.23759470"},{"name":"Segovia Province","isoCode":"SG","countryCode":"ES","latitude":"40.94292960","longitude":"-4.10889420"},{"name":"Soria Province","isoCode":"SO","countryCode":"ES","latitude":"41.76654640","longitude":"-2.47903060"},{"name":"Valladolid Province","isoCode":"VA","countryCode":"ES","latitude":"41.65173750","longitude":"-4.72449500"},{"name":"Valencia","isoCode":"VC","countryCode":"ES","latitude":"39.48401080","longitude":"-0.75328090"},{"name":"Zamora Province","isoCode":"ZA","countryCode":"ES","latitude":"41.60957440","longitude":"-5.89871390"},{"name":"Addis Ababa","isoCode":"AA","countryCode":"ET","latitude":"8.98060340","longitude":"38.75776050"},{"name":"Afar Region","isoCode":"AF","countryCode":"ET","latitude":"11.75593880","longitude":"40.95868800"},{"name":"Amhara Region","isoCode":"AM","countryCode":"ET","latitude":"11.34942470","longitude":"37.97845850"},{"name":"Benishangul-Gumuz Region","isoCode":"BE","countryCode":"ET","latitude":"10.78028890","longitude":"35.56578620"},{"name":"Dire Dawa","isoCode":"DD","countryCode":"ET","latitude":"9.60087470","longitude":"41.85014200"},{"name":"Gambela Region","isoCode":"GA","countryCode":"ET","latitude":"7.92196870","longitude":"34.15319470"},{"name":"Harari Region","isoCode":"HA","countryCode":"ET","latitude":"9.31486600","longitude":"42.19677160"},{"name":"Oromia Region","isoCode":"OR","countryCode":"ET","latitude":"7.54603770","longitude":"40.63468510"},{"name":"Southern Nations, Nationalities, and Peoples\' Region","isoCode":"SN","countryCode":"ET","latitude":"6.51569110","longitude":"36.95410700"},{"name":"Somali Region","isoCode":"SO","countryCode":"ET","latitude":"6.66122930","longitude":"43.79084530"},{"name":"Tigray Region","isoCode":"TI","countryCode":"ET","latitude":"14.03233360","longitude":"38.31657250"},{"name":"\xc5land Islands","isoCode":"01","countryCode":"FI","latitude":"60.17852470","longitude":"19.91561050"},{"name":"South Karelia","isoCode":"02","countryCode":"FI","latitude":"61.11819490","longitude":"28.10243720"},{"name":"Southern Ostrobothnia","isoCode":"03","countryCode":"FI","latitude":"62.94330990","longitude":"23.52852670"},{"name":"Southern Savonia","isoCode":"04","countryCode":"FI","latitude":"61.69451480","longitude":"27.80050150"},{"name":"Kainuu","isoCode":"05","countryCode":"FI","latitude":"64.37365640","longitude":"28.74374750"},{"name":"Tavastia Proper","isoCode":"06","countryCode":"FI","latitude":"60.90701500","longitude":"24.30054980"},{"name":"Central Ostrobothnia","isoCode":"07","countryCode":"FI","latitude":"63.56217350","longitude":"24.00136310"},{"name":"Central Finland","isoCode":"08","countryCode":"FI","latitude":"62.56667430","longitude":"25.55494450"},{"name":"Kymenlaakso","isoCode":"09","countryCode":"FI","latitude":"60.78051200","longitude":"26.88293360"},{"name":"Pirkanmaa","isoCode":"11","countryCode":"FI","latitude":"61.69869180","longitude":"23.78955980"},{"name":"Ostrobothnia","isoCode":"12","countryCode":"FI","latitude":"63.11817570","longitude":"21.90610620"},{"name":"North Karelia","isoCode":"13","countryCode":"FI","latitude":"62.80620780","longitude":"30.15538870"},{"name":"Northern Ostrobothnia","isoCode":"14","countryCode":"FI","latitude":"65.27949300","longitude":"26.28904170"},{"name":"Northern Savonia","isoCode":"15","countryCode":"FI","latitude":"63.08448000","longitude":"27.02535040"},{"name":"P\xe4ij\xe4nne Tavastia","isoCode":"16","countryCode":"FI","latitude":"61.32300410","longitude":"25.73224960"},{"name":"Satakunta","isoCode":"17","countryCode":"FI","latitude":"61.59327580","longitude":"22.14830810"},{"name":"Uusimaa","isoCode":"18","countryCode":"FI","latitude":"60.21872000","longitude":"25.27162100"},{"name":"Finland Proper","isoCode":"19","countryCode":"FI","latitude":"60.36279140","longitude":"22.44393690"},{"name":"Eastern Finland Province","isoCode":"IS","countryCode":"FI","latitude":"62.56338910","longitude":"28.50240420"},{"name":"Lapland","isoCode":"LL","countryCode":"FI","latitude":"67.92223040","longitude":"26.50464380"},{"name":"Oulu Province","isoCode":"OL","countryCode":"FI","latitude":"65.01207480","longitude":"25.46504960"},{"name":"Ba","isoCode":"01","countryCode":"FJ","latitude":"36.06138930","longitude":"-95.80058720"},{"name":"Bua","isoCode":"02","countryCode":"FJ","latitude":"43.09645840","longitude":"-89.50088000"},{"name":"Cakaudrove","isoCode":"03","countryCode":"FJ","latitude":"-16.58141050","longitude":"179.51200840"},{"name":"Kadavu","isoCode":"04","countryCode":"FJ","latitude":"-19.01271220","longitude":"178.18766760"},{"name":"Lau","isoCode":"05","countryCode":"FJ","latitude":"31.66870150","longitude":"-106.39557630"},{"name":"Lomaiviti","isoCode":"06","countryCode":"FJ","latitude":"-17.70900000","longitude":"179.09100000"},{"name":"Macuata","isoCode":"07","countryCode":"FJ","latitude":"-16.48649220","longitude":"179.28472510"},{"name":"Nadroga-Navosa","isoCode":"08","countryCode":"FJ","latitude":"-17.98652780","longitude":"177.65811300"},{"name":"Naitasiri","isoCode":"09","countryCode":"FJ","latitude":"-17.89757540","longitude":"178.20715980"},{"name":"Namosi","isoCode":"10","countryCode":"FJ","latitude":"-18.08641760","longitude":"178.12913870"},{"name":"Ra","isoCode":"11","countryCode":"FJ","latitude":"37.10031530","longitude":"-95.67442460"},{"name":"Rewa","isoCode":"12","countryCode":"FJ","latitude":"34.79235170","longitude":"-82.36092640"},{"name":"Serua","isoCode":"13","countryCode":"FJ","latitude":"-18.18047490","longitude":"178.05097900"},{"name":"Tailevu","isoCode":"14","countryCode":"FJ","latitude":"-17.82691110","longitude":"178.29324800"},{"name":"Central Division","isoCode":"C","countryCode":"FJ","latitude":"34.04400660","longitude":"-118.24727380"},{"name":"Eastern Division","isoCode":"E","countryCode":"FJ","latitude":"32.80943050","longitude":"-117.12899370"},{"name":"Northern Division","isoCode":"N","countryCode":"FJ","latitude":"32.87687660","longitude":"-117.21563450"},{"name":"Rotuma","isoCode":"R","countryCode":"FJ","latitude":"-12.50250690","longitude":"177.07241640"},{"name":"Western Division","isoCode":"W","countryCode":"FJ","latitude":"42.96621980","longitude":"-78.70211340"},{"name":"Kosrae State","isoCode":"KSA","countryCode":"FM","latitude":"5.30956180","longitude":"162.98148770"},{"name":"Pohnpei State","isoCode":"PNI","countryCode":"FM","latitude":"6.85412540","longitude":"158.26238220"},{"name":"Chuuk State","isoCode":"TRK","countryCode":"FM","latitude":"7.13867590","longitude":"151.55930650"},{"name":"Yap State","isoCode":"YAP","countryCode":"FM","latitude":"8.67164900","longitude":"142.84393350"},{"name":"Ain","isoCode":"01","countryCode":"FR","latitude":"46.06508600","longitude":"4.88861500"},{"name":"Aisne","isoCode":"02","countryCode":"FR","latitude":"49.45289210","longitude":"3.04651110"},{"name":"Allier","isoCode":"03","countryCode":"FR","latitude":"46.36708630","longitude":"2.58082770"},{"name":"Alpes-de-Haute-Provence","isoCode":"04","countryCode":"FR","latitude":"44.16377520","longitude":"5.67247800"},{"name":"Hautes-Alpes","isoCode":"05","countryCode":"FR","latitude":"44.65626820","longitude":"5.68732110"},{"name":"Alpes-Maritimes","isoCode":"06","countryCode":"FR","latitude":"43.92041700","longitude":"6.61678220"},{"name":"Ard\xe8che","isoCode":"07","countryCode":"FR","latitude":"44.81486950","longitude":"3.81334830"},{"name":"Ardennes","isoCode":"08","countryCode":"FR","latitude":"49.69759510","longitude":"4.14895760"},{"name":"Ari\xe8ge","isoCode":"09","countryCode":"FR","latitude":"42.94347830","longitude":"0.94048640"},{"name":"Aube","isoCode":"10","countryCode":"FR","latitude":"48.31975470","longitude":"3.56371040"},{"name":"Aude","isoCode":"11","countryCode":"FR","latitude":"43.05411400","longitude":"1.90384760"},{"name":"Aveyron","isoCode":"12","countryCode":"FR","latitude":"44.31563620","longitude":"2.08523790"},{"name":"Bouches-du-Rh\xf4ne","isoCode":"13","countryCode":"FR","latitude":"43.54038650","longitude":"4.46138290"},{"name":"Calvados","isoCode":"14","countryCode":"FR","latitude":"49.09035140","longitude":"-0.91706480"},{"name":"Cantal","isoCode":"15","countryCode":"FR","latitude":"45.04921770","longitude":"2.15672720"},{"name":"Charente","isoCode":"16","countryCode":"FR","latitude":"45.66584790","longitude":"-0.31845770"},{"name":"Charente-Maritime","isoCode":"17","countryCode":"FR","latitude":"45.72968280","longitude":"-1.33881160"},{"name":"Cher","isoCode":"18","countryCode":"FR","latitude":"47.02436280","longitude":"1.86627320"},{"name":"Corr\xe8ze","isoCode":"19","countryCode":"FR","latitude":"45.34237070","longitude":"1.31717330"},{"name":"Corse","isoCode":"20R","countryCode":"FR","latitude":"42.03960420","longitude":"9.01289260"},{"name":"C\xf4te-d\'Or","isoCode":"21","countryCode":"FR","latitude":"47.46513020","longitude":"4.23154950"},{"name":"C\xf4tes-d\'Armor","isoCode":"22","countryCode":"FR","latitude":"48.46633360","longitude":"-3.34789610"},{"name":"Creuse","isoCode":"23","countryCode":"FR","latitude":"46.05903940","longitude":"1.43150500"},{"name":"Dordogne","isoCode":"24","countryCode":"FR","latitude":"45.14234160","longitude":"0.14274080"},{"name":"Doubs","isoCode":"25","countryCode":"FR","latitude":"46.93217740","longitude":"6.34762140"},{"name":"Dr\xf4me","isoCode":"26","countryCode":"FR","latitude":"44.72933570","longitude":"4.67821580"},{"name":"Eure","isoCode":"27","countryCode":"FR","latitude":"49.07540350","longitude":"0.48937320"},{"name":"Eure-et-Loir","isoCode":"28","countryCode":"FR","latitude":"48.44697840","longitude":"0.81470250"},{"name":"Finist\xe8re","isoCode":"29","countryCode":"FR","latitude":"48.22696100","longitude":"-4.82437330"},{"name":"Corse-du-Sud","isoCode":"2A","countryCode":"FR","latitude":"41.85720550","longitude":"8.41091830"},{"name":"Haute-Corse","isoCode":"2B","countryCode":"FR","latitude":"42.42958660","longitude":"8.50625610"},{"name":"Gard","isoCode":"30","countryCode":"FR","latitude":"43.95952760","longitude":"3.49356810"},{"name":"Haute-Garonne","isoCode":"31","countryCode":"FR","latitude":"43.30505550","longitude":"0.68455150"},{"name":"Gers","isoCode":"32","countryCode":"FR","latitude":"43.69505340","longitude":"-0.09997280"},{"name":"Gironde","isoCode":"33","countryCode":"FR","latitude":"44.89584690","longitude":"-1.59405320"},{"name":"H\xe9rault","isoCode":"34","countryCode":"FR","latitude":"43.59111200","longitude":"2.80661080"},{"name":"Ille-et-Vilaine","isoCode":"35","countryCode":"FR","latitude":"48.17624840","longitude":"-2.21304010"},{"name":"Indre","isoCode":"36","countryCode":"FR","latitude":"46.81175500","longitude":"0.97555230"},{"name":"Indre-et-Loire","isoCode":"37","countryCode":"FR","latitude":"47.22285820","longitude":"0.14896190"},{"name":"Is\xe8re","isoCode":"38","countryCode":"FR","latitude":"45.28922710","longitude":"4.99023550"},{"name":"Jura","isoCode":"39","countryCode":"FR","latitude":"46.78287410","longitude":"5.16918440"},{"name":"Landes","isoCode":"40","countryCode":"FR","latitude":"44.00950800","longitude":"-1.25385790"},{"name":"Loir-et-Cher","isoCode":"41","countryCode":"FR","latitude":"47.65937600","longitude":"0.85376310"},{"name":"Loire","isoCode":"42","countryCode":"FR","latitude":"46.35228120","longitude":"-1.17563390"},{"name":"Haute-Loire","isoCode":"43","countryCode":"FR","latitude":"45.08538060","longitude":"3.22607070"},{"name":"Loire-Atlantique","isoCode":"44","countryCode":"FR","latitude":"47.34757210","longitude":"-2.34663120"},{"name":"Loiret","isoCode":"45","countryCode":"FR","latitude":"47.91354310","longitude":"1.76009900"},{"name":"Lot","isoCode":"46","countryCode":"FR","latitude":"44.62460700","longitude":"1.03576310"},{"name":"Lot-et-Garonne","isoCode":"47","countryCode":"FR","latitude":"44.36873140","longitude":"-0.09161690"},{"name":"Loz\xe8re","isoCode":"48","countryCode":"FR","latitude":"44.54227790","longitude":"2.92934590"},{"name":"Maine-et-Loire","isoCode":"49","countryCode":"FR","latitude":"47.38900340","longitude":"-1.12025270"},{"name":"Manche","isoCode":"50","countryCode":"FR","latitude":"49.08817340","longitude":"-2.46272090"},{"name":"Marne","isoCode":"51","countryCode":"FR","latitude":"48.96107450","longitude":"3.65737670"},{"name":"Haute-Marne","isoCode":"52","countryCode":"FR","latitude":"48.13248210","longitude":"4.69834990"},{"name":"Mayenne","isoCode":"53","countryCode":"FR","latitude":"48.30668420","longitude":"-0.64901820"},{"name":"Meurthe-et-Moselle","isoCode":"54","countryCode":"FR","latitude":"48.95566150","longitude":"5.71423500"},{"name":"Meuse","isoCode":"55","countryCode":"FR","latitude":"49.01246200","longitude":"4.81087340"},{"name":"Morbihan","isoCode":"56","countryCode":"FR","latitude":"47.74395180","longitude":"-3.44555240"},{"name":"Moselle","isoCode":"57","countryCode":"FR","latitude":"49.02045660","longitude":"6.20553220"},{"name":"Ni\xe8vre","isoCode":"58","countryCode":"FR","latitude":"47.11921640","longitude":"2.97797130"},{"name":"Nord","isoCode":"59","countryCode":"FR","latitude":"50.52854770","longitude":"2.60007760"},{"name":"Oise","isoCode":"60","countryCode":"FR","latitude":"49.41173350","longitude":"1.86688250"},{"name":"Orne","isoCode":"61","countryCode":"FR","latitude":"48.57576440","longitude":"-0.50242950"},{"name":"Pas-de-Calais","isoCode":"62","countryCode":"FR","latitude":"50.51446990","longitude":"1.81149800"},{"name":"Puy-de-D\xf4me","isoCode":"63","countryCode":"FR","latitude":"45.77141850","longitude":"2.62626760"},{"name":"Pyr\xe9n\xe9es-Atlantiques","isoCode":"64","countryCode":"FR","latitude":"43.18681700","longitude":"-1.44170710"},{"name":"Hautes-Pyr\xe9n\xe9es","isoCode":"65","countryCode":"FR","latitude":"43.14294620","longitude":"-0.40097360"},{"name":"Pyr\xe9n\xe9es-Orientales","isoCode":"66","countryCode":"FR","latitude":"42.62541790","longitude":"1.88929580"},{"name":"Bas-Rhin","isoCode":"67","countryCode":"FR","latitude":"48.59864440","longitude":"7.02666760"},{"name":"Haut-Rhin","isoCode":"68","countryCode":"FR","latitude":"47.86537740","longitude":"6.67113810"},{"name":"Rh\xf4ne","isoCode":"69","countryCode":"FR","latitude":"44.93433000","longitude":"4.24093290"},{"name":"M\xe9tropole de Lyon","isoCode":"69M","countryCode":"FR","latitude":"45.74826290","longitude":"4.59584040"},{"name":"Alsace","isoCode":"6AE","countryCode":"FR","latitude":"48.31817950","longitude":"7.44162410"},{"name":"Haute-Sa\xf4ne","isoCode":"70","countryCode":"FR","latitude":"47.63789960","longitude":"5.53550550"},{"name":"Sa\xf4ne-et-Loire","isoCode":"71","countryCode":"FR","latitude":"46.65548830","longitude":"3.98350500"},{"name":"Sarthe","isoCode":"72","countryCode":"FR","latitude":"48.02627330","longitude":"-0.32613170"},{"name":"Savoie","isoCode":"73","countryCode":"FR","latitude":"45.49469900","longitude":"5.84329840"},{"name":"Haute-Savoie","isoCode":"74","countryCode":"FR","latitude":"46.04452770","longitude":"5.86413800"},{"name":"Paris","isoCode":"75C","countryCode":"FR","latitude":"48.85661400","longitude":"2.35222190"},{"name":"Seine-Maritime","isoCode":"76","countryCode":"FR","latitude":"49.66096810","longitude":"0.36775610"},{"name":"Seine-et-Marne","isoCode":"77","countryCode":"FR","latitude":"48.61853940","longitude":"2.41525610"},{"name":"Yvelines","isoCode":"78","countryCode":"FR","latitude":"48.76153010","longitude":"1.27729490"},{"name":"Deux-S\xe8vres","isoCode":"79","countryCode":"FR","latitude":"46.53868170","longitude":"-0.90199480"},{"name":"Somme","isoCode":"80","countryCode":"FR","latitude":"49.96859220","longitude":"1.73106960"},{"name":"Tarn","isoCode":"81","countryCode":"FR","latitude":"43.79149770","longitude":"1.67588930"},{"name":"Tarn-et-Garonne","isoCode":"82","countryCode":"FR","latitude":"44.08089500","longitude":"1.08916570"},{"name":"Var","isoCode":"83","countryCode":"FR","latitude":"43.39507300","longitude":"5.73424170"},{"name":"Vaucluse","isoCode":"84","countryCode":"FR","latitude":"44.04475000","longitude":"4.64277180"},{"name":"Vend\xe9e","isoCode":"85","countryCode":"FR","latitude":"46.67541030","longitude":"-2.02983920"},{"name":"Vienne","isoCode":"86","countryCode":"FR","latitude":"45.52213140","longitude":"4.84531360"},{"name":"Haute-Vienne","isoCode":"87","countryCode":"FR","latitude":"45.91868780","longitude":"0.70972060"},{"name":"Vosges","isoCode":"88","countryCode":"FR","latitude":"48.16301730","longitude":"5.73556000"},{"name":"Yonne","isoCode":"89","countryCode":"FR","latitude":"47.85476140","longitude":"3.03394040"},{"name":"Territoire de Belfort","isoCode":"90","countryCode":"FR","latitude":"47.62930720","longitude":"6.66962000"},{"name":"Essonne","isoCode":"91","countryCode":"FR","latitude":"48.53046150","longitude":"1.96990560"},{"name":"Hauts-de-Seine","isoCode":"92","countryCode":"FR","latitude":"48.84030080","longitude":"2.10125590"},{"name":"Seine-Saint-Denis","isoCode":"93","countryCode":"FR","latitude":"48.90993180","longitude":"2.30573790"},{"name":"Val-de-Marne","isoCode":"94","countryCode":"FR","latitude":"48.77470040","longitude":"2.32210390"},{"name":"Val-d\'Oise","isoCode":"95","countryCode":"FR","latitude":"49.07518180","longitude":"1.82169140"},{"name":"Guadeloupe","isoCode":"971","countryCode":"FR","latitude":"16.26500000","longitude":"-61.55100000"},{"name":"Martinique","isoCode":"972","countryCode":"FR","latitude":"14.64152800","longitude":"-61.02417400"},{"name":"French Guiana","isoCode":"973","countryCode":"FR","latitude":"3.93388900","longitude":"-53.12578200"},{"name":"La R\xe9union","isoCode":"974","countryCode":"FR","latitude":"-21.11514100","longitude":"55.53638400"},{"name":"Mayotte","isoCode":"976","countryCode":"FR","latitude":"-12.82750000","longitude":"45.16624400"},{"name":"Auvergne-Rh\xf4ne-Alpes","isoCode":"ARA","countryCode":"FR","latitude":"45.44714310","longitude":"4.38525070"},{"name":"Bourgogne-Franche-Comt\xe9","isoCode":"BFC","countryCode":"FR","latitude":"47.28051270","longitude":"4.99943720"},{"name":"Saint-Barth\xe9lemy","isoCode":"BL","countryCode":"FR","latitude":"17.90051340","longitude":"-62.82058710"},{"name":"Bretagne","isoCode":"BRE","countryCode":"FR","latitude":"48.20204710","longitude":"-2.93264350"},{"name":"Clipperton","isoCode":"CP","countryCode":"FR","latitude":"10.28335410","longitude":"-109.22542150"},{"name":"Centre-Val de Loire","isoCode":"CVL","countryCode":"FR","latitude":"47.75156860","longitude":"1.67506310"},{"name":"Grand-Est","isoCode":"GES","countryCode":"FR","latitude":"48.69980300","longitude":"6.18780740"},{"name":"Hauts-de-France","isoCode":"HDF","countryCode":"FR","latitude":"50.48011530","longitude":"2.79372650"},{"name":"\xcele-de-France","isoCode":"IDF","countryCode":"FR","latitude":"48.84991980","longitude":"2.63704110"},{"name":"Saint-Martin","isoCode":"MF","countryCode":"FR","latitude":"18.07082980","longitude":"-63.05008090"},{"name":"Nouvelle-Aquitaine","isoCode":"NAQ","countryCode":"FR","latitude":"45.70871820","longitude":"0.62689100"},{"name":"Normandie","isoCode":"NOR","countryCode":"FR","latitude":"48.87987040","longitude":"0.17125290"},{"name":"Occitanie","isoCode":"OCC","countryCode":"FR","latitude":"43.89272320","longitude":"3.28276250"},{"name":"Provence-Alpes-C\xf4te-d\u2019Azur","isoCode":"PAC","countryCode":"FR","latitude":"43.93516910","longitude":"6.06791940"},{"name":"Pays-de-la-Loire","isoCode":"PDL","countryCode":"FR","latitude":"47.76328360","longitude":"-0.32996870"},{"name":"French Polynesia","isoCode":"PF","countryCode":"FR","latitude":"-17.67974200","longitude":"-149.40684300"},{"name":"Saint Pierre and Miquelon","isoCode":"PM","countryCode":"FR","latitude":"46.88520000","longitude":"-56.31590000"},{"name":"French Southern and Antarctic Lands","isoCode":"TF","countryCode":"FR","latitude":"-47.54466040","longitude":"51.28375420"},{"name":"Wallis and Futuna","isoCode":"WF","countryCode":"FR","latitude":"-14.29380000","longitude":"-178.11650000"},{"name":"Estuaire Province","isoCode":"1","countryCode":"GA","latitude":"0.44328640","longitude":"10.08072980"},{"name":"Haut-Ogoou\xe9 Province","isoCode":"2","countryCode":"GA","latitude":"-1.47625440","longitude":"13.91439900"},{"name":"Moyen-Ogoou\xe9 Province","isoCode":"3","countryCode":"GA","latitude":"-0.44278400","longitude":"10.43965600"},{"name":"Ngouni\xe9 Province","isoCode":"4","countryCode":"GA","latitude":"-1.49303030","longitude":"10.98070030"},{"name":"Nyanga Province","isoCode":"5","countryCode":"GA","latitude":"-2.88210330","longitude":"11.16173560"},{"name":"Ogoou\xe9-Ivindo Province","isoCode":"6","countryCode":"GA","latitude":"0.88183110","longitude":"13.17403480"},{"name":"Ogoou\xe9-Lolo Province","isoCode":"7","countryCode":"GA","latitude":"-0.88440930","longitude":"12.43805810"},{"name":"Ogoou\xe9-Maritime Province","isoCode":"8","countryCode":"GA","latitude":"-1.34659750","longitude":"9.72326730"},{"name":"Woleu-Ntem Province","isoCode":"9","countryCode":"GA","latitude":"2.29898270","longitude":"11.44669140"},{"name":"Armagh, Banbridge and Craigavon","isoCode":"ABC","countryCode":"GB","latitude":"54.39325920","longitude":"-6.45634010"},{"name":"Aberdeenshire","isoCode":"ABD","countryCode":"GB","latitude":"57.28687230","longitude":"-2.38156840"},{"name":"Aberdeen","isoCode":"ABE","countryCode":"GB","latitude":"57.14971700","longitude":"-2.09427800"},{"name":"Argyll and Bute","isoCode":"AGB","countryCode":"GB","latitude":"56.40062140","longitude":"-5.48074800"},{"name":"Ards and North Down","isoCode":"AND","countryCode":"GB","latitude":"54.58996450","longitude":"-5.59849720"},{"name":"Antrim and Newtownabbey","isoCode":"ANN","countryCode":"GB","latitude":"54.69568870","longitude":"-5.94810690"},{"name":"Angus","isoCode":"ANS","countryCode":"GB","latitude":"37.27578860","longitude":"-95.65010330"},{"name":"Antrim","isoCode":"ANT","countryCode":"GB","latitude":"54.71953380","longitude":"-6.20724980"},{"name":"Ards","isoCode":"ARD","countryCode":"GB","latitude":"42.13918510","longitude":"-87.86149720"},{"name":"Armagh City and District Council","isoCode":"ARM","countryCode":"GB","latitude":"54.39325920","longitude":"-6.45634010"},{"name":"Bath and North East Somerset","isoCode":"BAS","countryCode":"GB","latitude":"51.32501020","longitude":"-2.47662410"},{"name":"Blackburn with Darwen","isoCode":"BBD","countryCode":"GB","latitude":"53.69575220","longitude":"-2.46829850"},{"name":"Bedford","isoCode":"BDF","countryCode":"GB","latitude":"32.84401700","longitude":"-97.14306710"},{"name":"London Borough of Barking and Dagenham","isoCode":"BDG","countryCode":"GB","latitude":"51.55406660","longitude":"0.13401700"},{"name":"London Borough of Brent","isoCode":"BEN","countryCode":"GB","latitude":"51.56728080","longitude":"-0.27105680"},{"name":"London Borough of Bexley","isoCode":"BEX","countryCode":"GB","latitude":"51.45190210","longitude":"0.11717860"},{"name":"Belfast district","isoCode":"BFS","countryCode":"GB","latitude":"54.61703660","longitude":"-5.95318610"},{"name":"Bridgend County Borough","isoCode":"BGE","countryCode":"GB","latitude":"51.50831990","longitude":"-3.58120750"},{"name":"Blaenau Gwent County Borough","isoCode":"BGW","countryCode":"GB","latitude":"51.78757790","longitude":"-3.20439310"},{"name":"Birmingham","isoCode":"BIR","countryCode":"GB","latitude":"33.51858920","longitude":"-86.81035670"},{"name":"Buckinghamshire","isoCode":"BKM","countryCode":"GB","latitude":"51.80722040","longitude":"-0.81276640"},{"name":"Ballymena Borough","isoCode":"BLA","countryCode":"GB","latitude":"54.86426000","longitude":"-6.27910740"},{"name":"Ballymoney","isoCode":"BLY","countryCode":"GB","latitude":"55.07048880","longitude":"-6.51737080"},{"name":"Bournemouth","isoCode":"BMH","countryCode":"GB","latitude":"50.71916400","longitude":"-1.88076900"},{"name":"Banbridge","isoCode":"BNB","countryCode":"GB","latitude":"54.34872900","longitude":"-6.27048030"},{"name":"London Borough of Barnet","isoCode":"BNE","countryCode":"GB","latitude":"51.60496730","longitude":"-0.20762950"},{"name":"Brighton and Hove","isoCode":"BNH","countryCode":"GB","latitude":"50.82262880","longitude":"-0.13704700"},{"name":"Barnsley","isoCode":"BNS","countryCode":"GB","latitude":"34.29949560","longitude":"-84.98458090"},{"name":"Bolton","isoCode":"BOL","countryCode":"GB","latitude":"44.37264760","longitude":"-72.87876250"},{"name":"Blackpool","isoCode":"BPL","countryCode":"GB","latitude":"53.81750530","longitude":"-3.03567480"},{"name":"Bracknell Forest","isoCode":"BRC","countryCode":"GB","latitude":"51.41538280","longitude":"-0.75364950"},{"name":"Bradford","isoCode":"BRD","countryCode":"GB","latitude":"53.79598400","longitude":"-1.75939800"},{"name":"London Borough of Bromley","isoCode":"BRY","countryCode":"GB","latitude":"51.36797050","longitude":"0.07006200"},{"name":"City of Bristol","isoCode":"BST","countryCode":"GB","latitude":"41.67352200","longitude":"-72.94653750"},{"name":"Bury","isoCode":"BUR","countryCode":"GB","latitude":"53.59334980","longitude":"-2.29660540"},{"name":"Cambridgeshire","isoCode":"CAM","countryCode":"GB","latitude":"52.20529730","longitude":"0.12181950"},{"name":"Caerphilly County Borough","isoCode":"CAY","countryCode":"GB","latitude":"51.66044650","longitude":"-3.21787240"},{"name":"Central Bedfordshire","isoCode":"CBF","countryCode":"GB","latitude":"52.00297440","longitude":"-0.46513890"},{"name":"Causeway Coast and Glens","isoCode":"CCG","countryCode":"GB","latitude":"55.04318300","longitude":"-6.67412880"},{"name":"Ceredigion","isoCode":"CGN","countryCode":"GB","latitude":"52.21914290","longitude":"-3.93212560"},{"name":"Craigavon Borough Council","isoCode":"CGV","countryCode":"GB","latitude":"54.39325920","longitude":"-6.45634010"},{"name":"Cheshire East","isoCode":"CHE","countryCode":"GB","latitude":"53.16104460","longitude":"-2.21859320"},{"name":"Cheshire West and Chester","isoCode":"CHW","countryCode":"GB","latitude":"53.23029740","longitude":"-2.71511170"},{"name":"Carrickfergus Borough Council","isoCode":"CKF","countryCode":"GB","latitude":"54.72568430","longitude":"-5.80937190"},{"name":"Cookstown District Council","isoCode":"CKT","countryCode":"GB","latitude":"54.64181580","longitude":"-6.74438950"},{"name":"Calderdale","isoCode":"CLD","countryCode":"GB","latitude":"53.72478450","longitude":"-1.86583570"},{"name":"Clackmannanshire","isoCode":"CLK","countryCode":"GB","latitude":"56.10753510","longitude":"-3.75294090"},{"name":"Coleraine Borough Council","isoCode":"CLR","countryCode":"GB","latitude":"55.14515700","longitude":"-6.67598140"},{"name":"Cumbria","isoCode":"CMA","countryCode":"GB","latitude":"54.57723230","longitude":"-2.79748350"},{"name":"London Borough of Camden","isoCode":"CMD","countryCode":"GB","latitude":"51.54547360","longitude":"-0.16279020"},{"name":"Carmarthenshire","isoCode":"CMN","countryCode":"GB","latitude":"51.85723090","longitude":"-4.31159590"},{"name":"Cornwall","isoCode":"CON","countryCode":"GB","latitude":"50.26604710","longitude":"-5.05271250"},{"name":"Coventry","isoCode":"COV","countryCode":"GB","latitude":"52.40682200","longitude":"-1.51969300"},{"name":"City and County of Cardiff","isoCode":"CRF","countryCode":"GB","latitude":"51.48158100","longitude":"-3.17909000"},{"name":"London Borough of Croydon","isoCode":"CRY","countryCode":"GB","latitude":"51.38274460","longitude":"-0.09851630"},{"name":"Castlereagh","isoCode":"CSR","countryCode":"GB","latitude":"54.57567900","longitude":"-5.88840280"},{"name":"Conwy County Borough","isoCode":"CWY","countryCode":"GB","latitude":"53.29350130","longitude":"-3.72651610"},{"name":"Darlington","isoCode":"DAL","countryCode":"GB","latitude":"34.29987620","longitude":"-79.87617410"},{"name":"Derbyshire","isoCode":"DBY","countryCode":"GB","latitude":"53.10467820","longitude":"-1.56238850"},{"name":"Denbighshire","isoCode":"DEN","countryCode":"GB","latitude":"53.18422880","longitude":"-3.42249850"},{"name":"City of Derby","isoCode":"DER","countryCode":"GB","latitude":"37.54837550","longitude":"-97.24851910"},{"name":"Devon","isoCode":"DEV","countryCode":"GB","latitude":"50.71555910","longitude":"-3.53087500"},{"name":"Dungannon and South Tyrone Borough Council","isoCode":"DGN","countryCode":"GB","latitude":"54.50826840","longitude":"-6.76658910"},{"name":"Dumfries and Galloway","isoCode":"DGY","countryCode":"GB","latitude":"55.07010730","longitude":"-3.60525810"},{"name":"Doncaster","isoCode":"DNC","countryCode":"GB","latitude":"53.52282000","longitude":"-1.12846200"},{"name":"Dundee","isoCode":"DND","countryCode":"GB","latitude":"56.46201800","longitude":"-2.97072100"},{"name":"Dorset","isoCode":"DOR","countryCode":"GB","latitude":"50.74876350","longitude":"-2.34447860"},{"name":"Down District Council","isoCode":"DOW","countryCode":"GB","latitude":"54.24342870","longitude":"-5.95779590"},{"name":"Derry City and Strabane","isoCode":"DRS","countryCode":"GB","latitude":"55.00474430","longitude":"-7.32092220"},{"name":"Derry City Council","isoCode":"DRY","countryCode":"GB","latitude":"54.96907780","longitude":"-7.19583510"},{"name":"Dudley","isoCode":"DUD","countryCode":"GB","latitude":"42.04336610","longitude":"-71.92760330"},{"name":"County Durham","isoCode":"DUR","countryCode":"GB","latitude":"54.72940990","longitude":"-1.88115980"},{"name":"London Borough of Ealing","isoCode":"EAL","countryCode":"GB","latitude":"51.52503660","longitude":"-0.34139650"},{"name":"East Ayrshire","isoCode":"EAY","countryCode":"GB","latitude":"55.45184960","longitude":"-4.26444780"},{"name":"Edinburgh","isoCode":"EDH","countryCode":"GB","latitude":"55.95325200","longitude":"-3.18826700"},{"name":"East Dunbartonshire","isoCode":"EDU","countryCode":"GB","latitude":"55.97431620","longitude":"-4.20229800"},{"name":"East Lothian","isoCode":"ELN","countryCode":"GB","latitude":"55.94933830","longitude":"-2.77044640"},{"name":"Outer Hebrides","isoCode":"ELS","countryCode":"GB","latitude":"57.75989180","longitude":"-7.01940340"},{"name":"London Borough of Enfield","isoCode":"ENF","countryCode":"GB","latitude":"51.66229090","longitude":"-0.11806510"},{"name":"England","isoCode":"ENG","countryCode":"GB","latitude":"52.35551770","longitude":"-1.17431970"},{"name":"East Renfrewshire","isoCode":"ERW","countryCode":"GB","latitude":"55.77047350","longitude":"-4.33598210"},{"name":"East Riding of Yorkshire","isoCode":"ERY","countryCode":"GB","latitude":"53.84161680","longitude":"-0.43441060"},{"name":"Essex","isoCode":"ESS","countryCode":"GB","latitude":"51.57424470","longitude":"0.48567810"},{"name":"East Sussex","isoCode":"ESX","countryCode":"GB","latitude":"50.90859550","longitude":"0.24941660"},{"name":"Falkirk","isoCode":"FAL","countryCode":"GB","latitude":"56.00187750","longitude":"-3.78391310"},{"name":"Fermanagh District Council","isoCode":"FER","countryCode":"GB","latitude":"54.34479780","longitude":"-7.63842180"},{"name":"Fife","isoCode":"FIF","countryCode":"GB","latitude":"56.20820780","longitude":"-3.14951750"},{"name":"Flintshire","isoCode":"FLN","countryCode":"GB","latitude":"53.16686580","longitude":"-3.14189080"},{"name":"Fermanagh and Omagh","isoCode":"FMO","countryCode":"GB","latitude":"54.45135240","longitude":"-7.71250180"},{"name":"Gateshead","isoCode":"GAT","countryCode":"GB","latitude":"54.95268000","longitude":"-1.60341100"},{"name":"Glasgow","isoCode":"GLG","countryCode":"GB","latitude":"55.86423700","longitude":"-4.25180600"},{"name":"Gloucestershire","isoCode":"GLS","countryCode":"GB","latitude":"51.86421120","longitude":"-2.23803350"},{"name":"Royal Borough of Greenwich","isoCode":"GRE","countryCode":"GB","latitude":"51.48346270","longitude":"0.05862020"},{"name":"Gwynedd","isoCode":"GWN","countryCode":"GB","latitude":"52.92772660","longitude":"-4.13348360"},{"name":"Halton","isoCode":"HAL","countryCode":"GB","latitude":"43.53253720","longitude":"-79.87448360"},{"name":"Hampshire","isoCode":"HAM","countryCode":"GB","latitude":"51.05769480","longitude":"-1.30806290"},{"name":"London Borough of Havering","isoCode":"HAV","countryCode":"GB","latitude":"51.57792400","longitude":"0.21208290"},{"name":"London Borough of Hackney","isoCode":"HCK","countryCode":"GB","latitude":"51.57344500","longitude":"-0.07243760"},{"name":"Herefordshire","isoCode":"HEF","countryCode":"GB","latitude":"52.07651640","longitude":"-2.65441820"},{"name":"London Borough of Hillingdon","isoCode":"HIL","countryCode":"GB","latitude":"51.53518320","longitude":"-0.44813780"},{"name":"Highland","isoCode":"HLD","countryCode":"GB","latitude":"36.29675080","longitude":"-95.83803660"},{"name":"London Borough of Hammersmith and Fulham","isoCode":"HMF","countryCode":"GB","latitude":"51.49901560","longitude":"-0.22915000"},{"name":"London Borough of Hounslow","isoCode":"HNS","countryCode":"GB","latitude":"51.48283580","longitude":"-0.38820620"},{"name":"Hartlepool","isoCode":"HPL","countryCode":"GB","latitude":"54.69174500","longitude":"-1.21292600"},{"name":"Hertfordshire","isoCode":"HRT","countryCode":"GB","latitude":"51.80978230","longitude":"-0.23767440"},{"name":"London Borough of Harrow","isoCode":"HRW","countryCode":"GB","latitude":"51.58816270","longitude":"-0.34228510"},{"name":"London Borough of Haringey","isoCode":"HRY","countryCode":"GB","latitude":"51.59061130","longitude":"-0.11097090"},{"name":"Isles of Scilly","isoCode":"IOS","countryCode":"GB","latitude":"49.92772610","longitude":"-6.32749660"},{"name":"Isle of Wight","isoCode":"IOW","countryCode":"GB","latitude":"50.69384790","longitude":"-1.30473400"},{"name":"London Borough of Islington","isoCode":"ISL","countryCode":"GB","latitude":"51.54650630","longitude":"-0.10580580"},{"name":"Inverclyde","isoCode":"IVC","countryCode":"GB","latitude":"55.93165690","longitude":"-4.68001580"},{"name":"Royal Borough of Kensington and Chelsea","isoCode":"KEC","countryCode":"GB","latitude":"51.49908050","longitude":"-0.19382530"},{"name":"Kent","isoCode":"KEN","countryCode":"GB","latitude":"41.15366740","longitude":"-81.35788590"},{"name":"City of Kingston upon Hull","isoCode":"KHL","countryCode":"GB","latitude":"53.76762360","longitude":"-0.32741980"},{"name":"Kirklees","isoCode":"KIR","countryCode":"GB","latitude":"53.59334320","longitude":"-1.80095090"},{"name":"Royal Borough of Kingston upon Thames","isoCode":"KTT","countryCode":"GB","latitude":"51.37811700","longitude":"-0.29270900"},{"name":"Knowsley","isoCode":"KWL","countryCode":"GB","latitude":"53.45459400","longitude":"-2.85290700"},{"name":"Lancashire","isoCode":"LAN","countryCode":"GB","latitude":"53.76322540","longitude":"-2.70440520"},{"name":"Lisburn and Castlereagh","isoCode":"LBC","countryCode":"GB","latitude":"54.49815840","longitude":"-6.13067910"},{"name":"London Borough of Lambeth","isoCode":"LBH","countryCode":"GB","latitude":"51.45714770","longitude":"-0.12306810"},{"name":"City of Leicester","isoCode":"LCE","countryCode":"GB","latitude":"52.63687780","longitude":"-1.13975920"},{"name":"Leeds","isoCode":"LDS","countryCode":"GB","latitude":"53.80075540","longitude":"-1.54907740"},{"name":"Leicestershire","isoCode":"LEC","countryCode":"GB","latitude":"52.77257100","longitude":"-1.20521260"},{"name":"London Borough of Lewisham","isoCode":"LEW","countryCode":"GB","latitude":"51.44145790","longitude":"-0.01170060"},{"name":"Lincolnshire","isoCode":"LIN","countryCode":"GB","latitude":"52.94518890","longitude":"-0.16012460"},{"name":"Liverpool","isoCode":"LIV","countryCode":"GB","latitude":"32.65649810","longitude":"-115.47632410"},{"name":"Limavady Borough Council","isoCode":"LMV","countryCode":"GB","latitude":"55.05168200","longitude":"-6.94919440"},{"name":"City of London","isoCode":"LND","countryCode":"GB","latitude":"51.51234430","longitude":"-0.09098520"},{"name":"Larne Borough Council","isoCode":"LRN","countryCode":"GB","latitude":"54.85780030","longitude":"-5.82362240"},{"name":"Lisburn City Council","isoCode":"LSB","countryCode":"GB","latitude":"54.49815840","longitude":"-6.13067910"},{"name":"Manchester","isoCode":"MAN","countryCode":"GB","latitude":"53.48075930","longitude":"-2.24263050"},{"name":"Middlesbrough","isoCode":"MDB","countryCode":"GB","latitude":"54.57422700","longitude":"-1.23495600"},{"name":"Medway","isoCode":"MDW","countryCode":"GB","latitude":"42.14176410","longitude":"-71.39672560"},{"name":"Mid and East Antrim","isoCode":"MEA","countryCode":"GB","latitude":"54.93993410","longitude":"-6.11374230"},{"name":"Magherafelt District Council","isoCode":"MFT","countryCode":"GB","latitude":"54.75532790","longitude":"-6.60774870"},{"name":"Milton Keynes","isoCode":"MIK","countryCode":"GB","latitude":"52.08520380","longitude":"-0.73331330"},{"name":"Midlothian","isoCode":"MLN","countryCode":"GB","latitude":"32.47533500","longitude":"-97.01031810"},{"name":"Monmouthshire","isoCode":"MON","countryCode":"GB","latitude":"51.81161000","longitude":"-2.71634170"},{"name":"London Borough of Merton","isoCode":"MRT","countryCode":"GB","latitude":"51.40977420","longitude":"-0.21080840"},{"name":"Moray","isoCode":"MRY","countryCode":"GB","latitude":"57.64984760","longitude":"-3.31680390"},{"name":"Merthyr Tydfil County Borough","isoCode":"MTY","countryCode":"GB","latitude":"51.74674740","longitude":"-3.38132750"},{"name":"Mid Ulster","isoCode":"MUL","countryCode":"GB","latitude":"54.64113010","longitude":"-6.75225490"},{"name":"Moyle District Council","isoCode":"MYL","countryCode":"GB","latitude":"55.20473270","longitude":"-6.25317400"},{"name":"North Ayrshire","isoCode":"NAY","countryCode":"GB","latitude":"55.64167310","longitude":"-4.75946000"},{"name":"Northumberland","isoCode":"NBL","countryCode":"GB","latitude":"55.20825420","longitude":"-2.07841380"},{"name":"North Down Borough Council","isoCode":"NDN","countryCode":"GB","latitude":"54.65362970","longitude":"-5.67249250"},{"name":"North East Lincolnshire","isoCode":"NEL","countryCode":"GB","latitude":"53.56682010","longitude":"-0.08150660"},{"name":"Newcastle upon Tyne","isoCode":"NET","countryCode":"GB","latitude":"54.97825200","longitude":"-1.61778000"},{"name":"Norfolk","isoCode":"NFK","countryCode":"GB","latitude":"36.85076890","longitude":"-76.28587260"},{"name":"City of Nottingham","isoCode":"NGM","countryCode":"GB","latitude":"52.95478320","longitude":"-1.15810860"},{"name":"Northern Ireland","isoCode":"NIR","countryCode":"GB","latitude":"54.78771490","longitude":"-6.49231450"},{"name":"North Lanarkshire","isoCode":"NLK","countryCode":"GB","latitude":"55.86624320","longitude":"-3.96131440"},{"name":"North Lincolnshire","isoCode":"NLN","countryCode":"GB","latitude":"53.60555920","longitude":"-0.55965820"},{"name":"Newry, Mourne and Down","isoCode":"NMD","countryCode":"GB","latitude":"54.24342870","longitude":"-5.95779590"},{"name":"North Somerset","isoCode":"NSM","countryCode":"GB","latitude":"51.38790280","longitude":"-2.77810910"},{"name":"Newtownabbey Borough Council","isoCode":"NTA","countryCode":"GB","latitude":"54.67924220","longitude":"-5.95911020"},{"name":"Northamptonshire","isoCode":"NTH","countryCode":"GB","latitude":"52.27299440","longitude":"-0.87555150"},{"name":"Neath Port Talbot County Borough","isoCode":"NTL","countryCode":"GB","latitude":"51.59785190","longitude":"-3.78396680"},{"name":"Nottinghamshire","isoCode":"NTT","countryCode":"GB","latitude":"53.10031900","longitude":"-0.99363060"},{"name":"North Tyneside","isoCode":"NTY","countryCode":"GB","latitude":"55.01823990","longitude":"-1.48584360"},{"name":"London Borough of Newham","isoCode":"NWM","countryCode":"GB","latitude":"51.52551620","longitude":"0.03521630"},{"name":"Newport","isoCode":"NWP","countryCode":"GB","latitude":"37.52782340","longitude":"-94.10438760"},{"name":"North Yorkshire","isoCode":"NYK","countryCode":"GB","latitude":"53.99150280","longitude":"-1.54120150"},{"name":"Newry and Mourne District Council","isoCode":"NYM","countryCode":"GB","latitude":"54.17425050","longitude":"-6.33919920"},{"name":"Oldham","isoCode":"OLD","countryCode":"GB","latitude":"42.20405980","longitude":"-71.20481190"},{"name":"Omagh District Council","isoCode":"OMH","countryCode":"GB","latitude":"54.45135240","longitude":"-7.71250180"},{"name":"Orkney Islands","isoCode":"ORK","countryCode":"GB","latitude":"58.98094010","longitude":"-2.96052060"},{"name":"Oxfordshire","isoCode":"OXF","countryCode":"GB","latitude":"51.76120560","longitude":"-1.24646740"},{"name":"Pembrokeshire","isoCode":"PEM","countryCode":"GB","latitude":"51.67407800","longitude":"-4.90887850"},{"name":"Perth and Kinross","isoCode":"PKN","countryCode":"GB","latitude":"56.39538170","longitude":"-3.42835470"},{"name":"City of Plymouth","isoCode":"PLY","countryCode":"GB","latitude":"42.37089410","longitude":"-83.46971410"},{"name":"Poole","isoCode":"POL","countryCode":"GB","latitude":"50.71505000","longitude":"-1.98724800"},{"name":"City of Portsmouth","isoCode":"POR","countryCode":"GB","latitude":"36.83291500","longitude":"-76.29755490"},{"name":"Powys","isoCode":"POW","countryCode":"GB","latitude":"52.64642490","longitude":"-3.32609040"},{"name":"City of Peterborough","isoCode":"PTE","countryCode":"GB","latitude":"44.30936360","longitude":"-78.32015300"},{"name":"Redcar and Cleveland","isoCode":"RCC","countryCode":"GB","latitude":"54.59713440","longitude":"-1.07759970"},{"name":"Rochdale","isoCode":"RCH","countryCode":"GB","latitude":"53.60971360","longitude":"-2.15610000"},{"name":"Rhondda Cynon Taf","isoCode":"RCT","countryCode":"GB","latitude":"51.64902070","longitude":"-3.42886920"},{"name":"London Borough of Redbridge","isoCode":"RDB","countryCode":"GB","latitude":"51.58861210","longitude":"0.08239820"},{"name":"Reading","isoCode":"RDG","countryCode":"GB","latitude":"36.14866590","longitude":"-95.98400120"},{"name":"Renfrewshire","isoCode":"RFW","countryCode":"GB","latitude":"55.84665400","longitude":"-4.53312590"},{"name":"London Borough of Richmond upon Thames","isoCode":"RIC","countryCode":"GB","latitude":"51.46130540","longitude":"-0.30377090"},{"name":"Rotherham","isoCode":"ROT","countryCode":"GB","latitude":"53.43260350","longitude":"-1.36350090"},{"name":"Rutland","isoCode":"RUT","countryCode":"GB","latitude":"43.61062370","longitude":"-72.97260650"},{"name":"Sandwell","isoCode":"SAW","countryCode":"GB","latitude":"52.53616740","longitude":"-2.01079300"},{"name":"South Ayrshire","isoCode":"SAY","countryCode":"GB","latitude":"55.45889880","longitude":"-4.62919940"},{"name":"Scottish Borders","isoCode":"SCB","countryCode":"GB","latitude":"55.54856970","longitude":"-2.78613880"},{"name":"Scotland","isoCode":"SCT","countryCode":"GB","latitude":"56.49067120","longitude":"-4.20264580"},{"name":"Suffolk","isoCode":"SFK","countryCode":"GB","latitude":"52.18724720","longitude":"0.97078010"},{"name":"Sefton","isoCode":"SFT","countryCode":"GB","latitude":"53.50344490","longitude":"-2.97035900"},{"name":"South Gloucestershire","isoCode":"SGC","countryCode":"GB","latitude":"51.52643610","longitude":"-2.47284870"},{"name":"Ascension Island","isoCode":"SH-AC","countryCode":"GB","latitude":"-7.94671660","longitude":"-14.35591580"},{"name":"Saint Helena","isoCode":"SH-HL","countryCode":"GB","latitude":"-15.96501040","longitude":"-5.70892410"},{"name":"Sheffield","isoCode":"SHF","countryCode":"GB","latitude":"36.09507430","longitude":"-80.27884660"},{"name":"St Helens","isoCode":"SHN","countryCode":"GB","latitude":"45.85896100","longitude":"-122.82123560"},{"name":"Shropshire","isoCode":"SHR","countryCode":"GB","latitude":"52.70636570","longitude":"-2.74178490"},{"name":"Stockport","isoCode":"SKP","countryCode":"GB","latitude":"53.41063160","longitude":"-2.15753320"},{"name":"Salford","isoCode":"SLF","countryCode":"GB","latitude":"53.48752350","longitude":"-2.29012640"},{"name":"Slough","isoCode":"SLG","countryCode":"GB","latitude":"51.51053840","longitude":"-0.59504060"},{"name":"South Lanarkshire","isoCode":"SLK","countryCode":"GB","latitude":"55.67359090","longitude":"-3.78196610"},{"name":"City of Sunderland","isoCode":"SND","countryCode":"GB","latitude":"54.88614890","longitude":"-1.47857970"},{"name":"Solihull","isoCode":"SOL","countryCode":"GB","latitude":"52.41181100","longitude":"-1.77761000"},{"name":"Somerset","isoCode":"SOM","countryCode":"GB","latitude":"51.10509700","longitude":"-2.92623070"},{"name":"Southend-on-Sea","isoCode":"SOS","countryCode":"GB","latitude":"51.54592690","longitude":"0.70771230"},{"name":"Surrey","isoCode":"SRY","countryCode":"GB","latitude":"51.31475930","longitude":"-0.55995010"},{"name":"Strabane District Council","isoCode":"STB","countryCode":"GB","latitude":"54.82738650","longitude":"-7.46331030"},{"name":"City of Stoke-on-Trent","isoCode":"STE","countryCode":"GB","latitude":"53.00266800","longitude":"-2.17940400"},{"name":"Stirling","isoCode":"STG","countryCode":"GB","latitude":"56.11652270","longitude":"-3.93690290"},{"name":"City of Southampton","isoCode":"STH","countryCode":"GB","latitude":"50.90970040","longitude":"-1.40435090"},{"name":"London Borough of Sutton","isoCode":"STN","countryCode":"GB","latitude":"51.35737620","longitude":"-0.17527960"},{"name":"Staffordshire","isoCode":"STS","countryCode":"GB","latitude":"52.87927450","longitude":"-2.05718680"},{"name":"Stockton-on-Tees","isoCode":"STT","countryCode":"GB","latitude":"54.57045510","longitude":"-1.32898210"},{"name":"South Tyneside","isoCode":"STY","countryCode":"GB","latitude":"54.96366930","longitude":"-1.44186340"},{"name":"City and County of Swansea","isoCode":"SWA","countryCode":"GB","latitude":"51.62144000","longitude":"-3.94364600"},{"name":"Swindon","isoCode":"SWD","countryCode":"GB","latitude":"51.55577390","longitude":"-1.77971760"},{"name":"London Borough of Southwark","isoCode":"SWK","countryCode":"GB","latitude":"51.48805720","longitude":"-0.07628380"},{"name":"Tameside","isoCode":"TAM","countryCode":"GB","latitude":"53.48058280","longitude":"-2.08098910"},{"name":"Telford and Wrekin","isoCode":"TFW","countryCode":"GB","latitude":"52.74099160","longitude":"-2.48685860"},{"name":"Thurrock","isoCode":"THR","countryCode":"GB","latitude":"51.49345570","longitude":"0.35291970"},{"name":"Torbay","isoCode":"TOB","countryCode":"GB","latitude":"50.43923290","longitude":"-3.53698990"},{"name":"Torfaen","isoCode":"TOF","countryCode":"GB","latitude":"51.70022530","longitude":"-3.04460150"},{"name":"Trafford","isoCode":"TRF","countryCode":"GB","latitude":"40.38562460","longitude":"-79.75893470"},{"name":"London Borough of Tower Hamlets","isoCode":"TWH","countryCode":"GB","latitude":"51.52026070","longitude":"-0.02933960"},{"name":"United Kingdom","isoCode":"UKM","countryCode":"GB","latitude":"55.37805100","longitude":"-3.43597300"},{"name":"Vale of Glamorgan","isoCode":"VGL","countryCode":"GB","latitude":"51.40959580","longitude":"-3.48481670"},{"name":"Warwickshire","isoCode":"WAR","countryCode":"GB","latitude":"52.26713530","longitude":"-1.46752160"},{"name":"West Berkshire","isoCode":"WBK","countryCode":"GB","latitude":"51.43082550","longitude":"-1.14449270"},{"name":"West Dunbartonshire","isoCode":"WDU","countryCode":"GB","latitude":"55.94509250","longitude":"-4.56462590"},{"name":"London Borough of Waltham Forest","isoCode":"WFT","countryCode":"GB","latitude":"51.58863830","longitude":"-0.01176250"},{"name":"Metropolitan Borough of Wigan","isoCode":"WGN","countryCode":"GB","latitude":"53.51348120","longitude":"-2.61069990"},{"name":"Wiltshire","isoCode":"WIL","countryCode":"GB","latitude":"51.34919960","longitude":"-1.99271050"},{"name":"Wakefield","isoCode":"WKF","countryCode":"GB","latitude":"42.50393950","longitude":"-71.07233910"},{"name":"Walsall","isoCode":"WLL","countryCode":"GB","latitude":"52.58621400","longitude":"-1.98291900"},{"name":"West Lothian","isoCode":"WLN","countryCode":"GB","latitude":"55.90701980","longitude":"-3.55171670"},{"name":"Wales","isoCode":"WLS","countryCode":"GB","latitude":"52.13066070","longitude":"-3.78371170"},{"name":"City of Wolverhampton","isoCode":"WLV","countryCode":"GB","latitude":"52.58891200","longitude":"-2.15646300"},{"name":"London Borough of Wandsworth","isoCode":"WND","countryCode":"GB","latitude":"51.45682740","longitude":"-0.18966380"},{"name":"Windsor and Maidenhead","isoCode":"WNM","countryCode":"GB","latitude":"51.47997120","longitude":"-0.62425650"},{"name":"Wokingham","isoCode":"WOK","countryCode":"GB","latitude":"51.41045700","longitude":"-0.83386100"},{"name":"Worcestershire","isoCode":"WOR","countryCode":"GB","latitude":"52.25452250","longitude":"-2.26683820"},{"name":"Wirral","isoCode":"WRL","countryCode":"GB","latitude":"53.37271810","longitude":"-3.07375400"},{"name":"Warrington","isoCode":"WRT","countryCode":"GB","latitude":"40.24927410","longitude":"-75.13406040"},{"name":"Wrexham County Borough","isoCode":"WRX","countryCode":"GB","latitude":"53.03013780","longitude":"-3.02614870"},{"name":"City of Westminster","isoCode":"WSM","countryCode":"GB","latitude":"39.57659770","longitude":"-76.99721260"},{"name":"West Sussex","isoCode":"WSX","countryCode":"GB","latitude":"50.92801430","longitude":"-0.46170750"},{"name":"City of York","isoCode":"YOR","countryCode":"GB","latitude":"53.95996510","longitude":"-1.08729790"},{"name":"Shetland Islands","isoCode":"ZET","countryCode":"GB","latitude":"60.52965070","longitude":"-1.26594090"},{"name":"Saint Andrew Parish","isoCode":"01","countryCode":"GD","latitude":null,"longitude":null},{"name":"Saint David Parish","isoCode":"02","countryCode":"GD","latitude":null,"longitude":null},{"name":"Saint George Parish","isoCode":"03","countryCode":"GD","latitude":null,"longitude":null},{"name":"Saint John Parish","isoCode":"04","countryCode":"GD","latitude":"30.11183310","longitude":"-90.48799160"},{"name":"Saint Mark Parish","isoCode":"05","countryCode":"GD","latitude":"40.58818630","longitude":"-73.94957010"},{"name":"Saint Patrick Parish","isoCode":"06","countryCode":"GD","latitude":null,"longitude":null},{"name":"Carriacou and Petite Martinique","isoCode":"10","countryCode":"GD","latitude":"12.47858880","longitude":"-61.44938420"},{"name":"Khelvachauri Municipality","isoCode":"29","countryCode":"GE","latitude":"41.58019260","longitude":"41.66107420"},{"name":"Senaki Municipality","isoCode":"50","countryCode":"GE","latitude":"42.26963600","longitude":"42.06568960"},{"name":"Autonomous Republic of Abkhazia","isoCode":"AB","countryCode":"GE","latitude":"43.00155440","longitude":"41.02340700"},{"name":"Adjara","isoCode":"AJ","countryCode":"GE","latitude":"41.60056260","longitude":"42.06883830"},{"name":"Guria","isoCode":"GU","countryCode":"GE","latitude":"41.94427360","longitude":"42.04580910"},{"name":"Imereti","isoCode":"IM","countryCode":"GE","latitude":"42.23010800","longitude":"42.90086640"},{"name":"Kakheti","isoCode":"KA","countryCode":"GE","latitude":"41.64816020","longitude":"45.69055540"},{"name":"Kvemo Kartli","isoCode":"KK","countryCode":"GE","latitude":"41.47918330","longitude":"44.65604510"},{"name":"Mtskheta-Mtianeti","isoCode":"MM","countryCode":"GE","latitude":"42.16821850","longitude":"44.65060580"},{"name":"Racha-Lechkhumi and Kvemo Svaneti","isoCode":"RL","countryCode":"GE","latitude":"42.67188730","longitude":"43.05628360"},{"name":"Samtskhe-Javakheti","isoCode":"SJ","countryCode":"GE","latitude":"41.54792960","longitude":"43.27764000"},{"name":"Shida Kartli","isoCode":"SK","countryCode":"GE","latitude":"42.07569440","longitude":"43.95404620"},{"name":"Samegrelo-Zemo Svaneti","isoCode":"SZ","countryCode":"GE","latitude":"42.73522470","longitude":"42.16893620"},{"name":"Tbilisi","isoCode":"TB","countryCode":"GE","latitude":"41.71513770","longitude":"44.82709600"},{"name":"Greater Accra","isoCode":"AA","countryCode":"GH","latitude":"5.81428360","longitude":"0.07467670"},{"name":"Ahafo","isoCode":"AF","countryCode":"GH","latitude":"7.58213720","longitude":"-2.54974630"},{"name":"Ashanti","isoCode":"AH","countryCode":"GH","latitude":"6.74704360","longitude":"-1.52086240"},{"name":"Bono East","isoCode":"BE","countryCode":"GH","latitude":"7.75000000","longitude":"-1.05000000"},{"name":"Bono","isoCode":"BO","countryCode":"GH","latitude":"7.65000000","longitude":"-2.50000000"},{"name":"Central","isoCode":"CP","countryCode":"GH","latitude":"5.50000000","longitude":"-1.00000000"},{"name":"Eastern","isoCode":"EP","countryCode":"GH","latitude":"6.50000000","longitude":"-0.50000000"},{"name":"North East","isoCode":"NE","countryCode":"GH","latitude":"10.51666700","longitude":"-0.36666700"},{"name":"Northern","isoCode":"NP","countryCode":"GH","latitude":"9.50000000","longitude":"-1.00000000"},{"name":"Oti","isoCode":"OT","countryCode":"GH","latitude":"7.90000000","longitude":"0.30000000"},{"name":"Savannah","isoCode":"SV","countryCode":"GH","latitude":"9.08333300","longitude":"-1.81666700"},{"name":"Volta","isoCode":"TV","countryCode":"GH","latitude":"6.57813730","longitude":"0.45023680"},{"name":"Upper East","isoCode":"UE","countryCode":"GH","latitude":"10.70824990","longitude":"-0.98206680"},{"name":"Upper West","isoCode":"UW","countryCode":"GH","latitude":"10.25297570","longitude":"-2.14502450"},{"name":"Western North","isoCode":"WN","countryCode":"GH","latitude":"6.30000000","longitude":"-2.80000000"},{"name":"Western","isoCode":"WP","countryCode":"GH","latitude":"5.50000000","longitude":"-2.50000000"},{"name":"Banjul","isoCode":"B","countryCode":"GM","latitude":"13.45487610","longitude":"-16.57903230"},{"name":"Lower River Division","isoCode":"L","countryCode":"GM","latitude":"13.35533060","longitude":"-15.92299000"},{"name":"Central River Division","isoCode":"M","countryCode":"GM","latitude":"13.59944690","longitude":"-14.89216680"},{"name":"North Bank Division","isoCode":"N","countryCode":"GM","latitude":"13.52854360","longitude":"-16.01699710"},{"name":"Upper River Division","isoCode":"U","countryCode":"GM","latitude":"13.42573660","longitude":"-14.00723480"},{"name":"West Coast Division","isoCode":"W","countryCode":"GM","latitude":"5.97727980","longitude":"116.07542880"},{"name":"Bok\xe9 Region","isoCode":"B","countryCode":"GN","latitude":"11.18646720","longitude":"-14.10013260"},{"name":"Beyla Prefecture","isoCode":"BE","countryCode":"GN","latitude":"8.91981780","longitude":"-8.30884410"},{"name":"Boffa Prefecture","isoCode":"BF","countryCode":"GN","latitude":"10.18082540","longitude":"-14.03916150"},{"name":"Bok\xe9 Prefecture","isoCode":"BK","countryCode":"GN","latitude":"11.08473790","longitude":"-14.37919120"},{"name":"Conakry","isoCode":"C","countryCode":"GN","latitude":"9.64118550","longitude":"-13.57840120"},{"name":"Coyah Prefecture","isoCode":"CO","countryCode":"GN","latitude":"9.77155350","longitude":"-13.31252990"},{"name":"Kindia Region","isoCode":"D","countryCode":"GN","latitude":"10.17816940","longitude":"-12.98961500"},{"name":"Dabola Prefecture","isoCode":"DB","countryCode":"GN","latitude":"10.72978060","longitude":"-11.11078540"},{"name":"Dinguiraye Prefecture","isoCode":"DI","countryCode":"GN","latitude":"11.68442220","longitude":"-10.80000510"},{"name":"Dalaba Prefecture","isoCode":"DL","countryCode":"GN","latitude":"10.68681760","longitude":"-12.24906970"},{"name":"Dubr\xe9ka Prefecture","isoCode":"DU","countryCode":"GN","latitude":"9.79073480","longitude":"-13.51477350"},{"name":"Faranah Prefecture","isoCode":"FA","countryCode":"GN","latitude":"9.90573990","longitude":"-10.80000510"},{"name":"For\xe9cariah Prefecture","isoCode":"FO","countryCode":"GN","latitude":"9.38861870","longitude":"-13.08179030"},{"name":"Fria Prefecture","isoCode":"FR","countryCode":"GN","latitude":"10.36745430","longitude":"-13.58418710"},{"name":"Gaoual Prefecture","isoCode":"GA","countryCode":"GN","latitude":"11.57628040","longitude":"-13.35872880"},{"name":"Gu\xe9ck\xe9dou Prefecture","isoCode":"GU","countryCode":"GN","latitude":"8.56496880","longitude":"-10.13111630"},{"name":"Kankan Region","isoCode":"K","countryCode":"GN","latitude":"10.12092300","longitude":"-9.54509740"},{"name":"Kankan Prefecture","isoCode":"KA","countryCode":"GN","latitude":"10.30344650","longitude":"-9.36730840"},{"name":"Koubia Prefecture","isoCode":"KB","countryCode":"GN","latitude":"11.58235400","longitude":"-11.89202370"},{"name":"Kindia Prefecture","isoCode":"KD","countryCode":"GN","latitude":"10.10132920","longitude":"-12.71351210"},{"name":"K\xe9rouan\xe9 Prefecture","isoCode":"KE","countryCode":"GN","latitude":"9.25366430","longitude":"-9.01289260"},{"name":"Koundara Prefecture","isoCode":"KN","countryCode":"GN","latitude":"12.48940210","longitude":"-13.30675620"},{"name":"Kouroussa Prefecture","isoCode":"KO","countryCode":"GN","latitude":"10.64892290","longitude":"-9.88505860"},{"name":"Kissidougou Prefecture","isoCode":"KS","countryCode":"GN","latitude":"9.22520220","longitude":"-10.08072980"},{"name":"Lab\xe9 Region","isoCode":"L","countryCode":"GN","latitude":"11.32320420","longitude":"-12.28913140"},{"name":"Lab\xe9 Prefecture","isoCode":"LA","countryCode":"GN","latitude":"11.35419390","longitude":"-12.34638750"},{"name":"L\xe9louma Prefecture","isoCode":"LE","countryCode":"GN","latitude":"11.18333300","longitude":"-12.93333300"},{"name":"Lola Prefecture","isoCode":"LO","countryCode":"GN","latitude":"7.96138180","longitude":"-8.39649380"},{"name":"Mamou Region","isoCode":"M","countryCode":"GN","latitude":"10.57360240","longitude":"-11.88917210"},{"name":"Macenta Prefecture","isoCode":"MC","countryCode":"GN","latitude":"8.46157950","longitude":"-9.27855830"},{"name":"Mandiana Prefecture","isoCode":"MD","countryCode":"GN","latitude":"10.61728270","longitude":"-8.69857160"},{"name":"Mali Prefecture","isoCode":"ML","countryCode":"GN","latitude":"11.98370900","longitude":"-12.25479190"},{"name":"Mamou Prefecture","isoCode":"MM","countryCode":"GN","latitude":"10.57360240","longitude":"-11.88917210"},{"name":"Nz\xe9r\xe9kor\xe9 Region","isoCode":"N","countryCode":"GN","latitude":"8.03858700","longitude":"-8.83627550"},{"name":"Nz\xe9r\xe9kor\xe9 Prefecture","isoCode":"NZ","countryCode":"GN","latitude":"7.74783590","longitude":"-8.82525020"},{"name":"Pita Prefecture","isoCode":"PI","countryCode":"GN","latitude":"10.80620860","longitude":"-12.71351210"},{"name":"Siguiri Prefecture","isoCode":"SI","countryCode":"GN","latitude":"11.41481130","longitude":"-9.17883040"},{"name":"T\xe9lim\xe9l\xe9 Prefecture","isoCode":"TE","countryCode":"GN","latitude":"10.90893640","longitude":"-13.02993310"},{"name":"Tougu\xe9 Prefecture","isoCode":"TO","countryCode":"GN","latitude":"11.38415830","longitude":"-11.61577730"},{"name":"Yomou Prefecture","isoCode":"YO","countryCode":"GN","latitude":"7.56962790","longitude":"-9.25915710"},{"name":"Annob\xf3n Province","isoCode":"AN","countryCode":"GQ","latitude":"-1.42687820","longitude":"5.63528010"},{"name":"Bioko Norte Province","isoCode":"BN","countryCode":"GQ","latitude":"3.65950720","longitude":"8.79218360"},{"name":"Bioko Sur Province","isoCode":"BS","countryCode":"GQ","latitude":"3.42097850","longitude":"8.61606740"},{"name":"R\xedo Muni","isoCode":"C","countryCode":"GQ","latitude":"1.46106060","longitude":"9.67868940"},{"name":"Centro Sur Province","isoCode":"CS","countryCode":"GQ","latitude":"1.34360840","longitude":"10.43965600"},{"name":"Insular Region","isoCode":"I","countryCode":"GQ","latitude":"37.09024000","longitude":"-95.71289100"},{"name":"Ki\xe9-Ntem Province","isoCode":"KN","countryCode":"GQ","latitude":"2.02809300","longitude":"11.07117580"},{"name":"Litoral Province","isoCode":"LI","countryCode":"GQ","latitude":"1.57502440","longitude":"9.81249350"},{"name":"Wele-Nzas Province","isoCode":"WN","countryCode":"GQ","latitude":"1.41661620","longitude":"11.07117580"},{"name":"Aetolia-Acarnania Regional Unit","isoCode":"01","countryCode":"GR","latitude":"38.70843860","longitude":"21.37989280"},{"name":"Boeotia Regional Unit","isoCode":"03","countryCode":"GR","latitude":"38.36636640","longitude":"23.09650640"},{"name":"Euboea","isoCode":"04","countryCode":"GR","latitude":"38.52360360","longitude":"23.85847370"},{"name":"Phthiotis Prefecture","isoCode":"06","countryCode":"GR","latitude":"38.99978500","longitude":"22.33377690"},{"name":"Argolis Regional Unit","isoCode":"11","countryCode":"GR","latitude":null,"longitude":null},{"name":"Arcadia Prefecture","isoCode":"12","countryCode":"GR","latitude":"37.55578250","longitude":"22.33377690"},{"name":"Achaea Regional Unit","isoCode":"13","countryCode":"GR","latitude":"38.11587290","longitude":"21.95224910"},{"name":"Corinthia Regional Unit","isoCode":"15","countryCode":"GR","latitude":null,"longitude":null},{"name":"Laconia","isoCode":"16","countryCode":"GR","latitude":"43.52785460","longitude":"-71.47035090"},{"name":"Corfu Prefecture","isoCode":"22","countryCode":"GR","latitude":"39.62498380","longitude":"19.92234610"},{"name":"Kefalonia Prefecture","isoCode":"23","countryCode":"GR","latitude":"38.17536750","longitude":"20.56921790"},{"name":"Lefkada Regional Unit","isoCode":"24","countryCode":"GR","latitude":"38.83336630","longitude":"20.70691080"},{"name":"Ioannina Regional Unit","isoCode":"33","countryCode":"GR","latitude":"39.66502880","longitude":"20.85374660"},{"name":"Preveza Prefecture","isoCode":"34","countryCode":"GR","latitude":"38.95926490","longitude":"20.75171550"},{"name":"Karditsa Regional Unit","isoCode":"41","countryCode":"GR","latitude":"39.36402580","longitude":"21.92140490"},{"name":"Larissa Prefecture","isoCode":"42","countryCode":"GR","latitude":"39.63902240","longitude":"22.41912540"},{"name":"Grevena Prefecture","isoCode":"51","countryCode":"GR","latitude":"40.08376260","longitude":"21.42732990"},{"name":"Drama Regional Unit","isoCode":"52","countryCode":"GR","latitude":"41.23400230","longitude":"24.23904980"},{"name":"Imathia Regional Unit","isoCode":"53","countryCode":"GR","latitude":"40.60600670","longitude":"22.14302150"},{"name":"Thessaloniki Regional Unit","isoCode":"54","countryCode":"GR","latitude":"40.64006290","longitude":"22.94441910"},{"name":"Kastoria Regional Unit","isoCode":"56","countryCode":"GR","latitude":"40.51926910","longitude":"21.26871710"},{"name":"Kilkis Regional Unit","isoCode":"57","countryCode":"GR","latitude":"40.99370710","longitude":"22.87536740"},{"name":"Kozani Prefecture","isoCode":"58","countryCode":"GR","latitude":"40.30055860","longitude":"21.78877370"},{"name":"Pella Regional Unit","isoCode":"59","countryCode":"GR","latitude":"40.91480390","longitude":"22.14302150"},{"name":"Serres Prefecture","isoCode":"62","countryCode":"GR","latitude":"41.08638540","longitude":"23.54838190"},{"name":"Chania Regional Unit","isoCode":"94","countryCode":"GR","latitude":"35.51382980","longitude":"24.01803670"},{"name":"East Macedonia and Thrace","isoCode":"A","countryCode":"GR","latitude":"41.12951260","longitude":"24.88771910"},{"name":"East Attica Regional Unit","isoCode":"A2","countryCode":"GR","latitude":"38.20540930","longitude":"23.85847370"},{"name":"Central Macedonia","isoCode":"B","countryCode":"GR","latitude":"40.62117300","longitude":"23.19180210"},{"name":"West Macedonia Region","isoCode":"C","countryCode":"GR","latitude":"40.30040580","longitude":"21.79035590"},{"name":"Epirus Region","isoCode":"D","countryCode":"GR","latitude":"39.57064130","longitude":"20.76428430"},{"name":"Ionian Islands Region","isoCode":"F","countryCode":"GR","latitude":"37.96948980","longitude":"21.38023720"},{"name":"West Greece Region","isoCode":"G","countryCode":"GR","latitude":"38.51154960","longitude":"21.57067860"},{"name":"Central Greece Region","isoCode":"H","countryCode":"GR","latitude":"38.60439840","longitude":"22.71521310"},{"name":"Attica Region","isoCode":"I","countryCode":"GR","latitude":"38.04575680","longitude":"23.85847370"},{"name":"Peloponnese Region","isoCode":"J","countryCode":"GR","latitude":"37.50794720","longitude":"22.37349000"},{"name":"South Aegean","isoCode":"L","countryCode":"GR","latitude":"37.08553020","longitude":"25.14892150"},{"name":"Crete Region","isoCode":"M","countryCode":"GR","latitude":"35.24011700","longitude":"24.80926910"},{"name":"Alta Verapaz Department","isoCode":"AV","countryCode":"GT","latitude":"15.59428830","longitude":"-90.14949880"},{"name":"Baja Verapaz Department","isoCode":"BV","countryCode":"GT","latitude":"15.12558670","longitude":"-90.37483540"},{"name":"Chimaltenango Department","isoCode":"CM","countryCode":"GT","latitude":"14.56347870","longitude":"-90.98206680"},{"name":"Chiquimula Department","isoCode":"CQ","countryCode":"GT","latitude":"14.75149990","longitude":"-89.47421770"},{"name":"Escuintla Department","isoCode":"ES","countryCode":"GT","latitude":"14.19109120","longitude":"-90.98206680"},{"name":"Guatemala Department","isoCode":"GU","countryCode":"GT","latitude":"14.56494010","longitude":"-90.52578230"},{"name":"Huehuetenango Department","isoCode":"HU","countryCode":"GT","latitude":"15.58799140","longitude":"-91.67606910"},{"name":"Izabal Department","isoCode":"IZ","countryCode":"GT","latitude":"15.49765170","longitude":"-88.86469800"},{"name":"Jalapa Department","isoCode":"JA","countryCode":"GT","latitude":"14.61214460","longitude":"-89.96267990"},{"name":"Jutiapa Department","isoCode":"JU","countryCode":"GT","latitude":"14.19308020","longitude":"-89.92532330"},{"name":"Pet\xe9n Department","isoCode":"PE","countryCode":"GT","latitude":"16.91203300","longitude":"-90.29957850"},{"name":"El Progreso Department","isoCode":"PR","countryCode":"GT","latitude":"14.93887320","longitude":"-90.07467670"},{"name":"Quich\xe9 Department","isoCode":"QC","countryCode":"GT","latitude":"15.49838080","longitude":"-90.98206680"},{"name":"Quetzaltenango Department","isoCode":"QZ","countryCode":"GT","latitude":"14.79243300","longitude":"-91.71495800"},{"name":"Retalhuleu Department","isoCode":"RE","countryCode":"GT","latitude":"14.52454850","longitude":"-91.68578800"},{"name":"Sacatep\xe9quez Department","isoCode":"SA","countryCode":"GT","latitude":"14.51783790","longitude":"-90.71527490"},{"name":"San Marcos Department","isoCode":"SM","countryCode":"GT","latitude":"14.93095690","longitude":"-91.90992380"},{"name":"Solol\xe1 Department","isoCode":"SO","countryCode":"GT","latitude":"14.74852300","longitude":"-91.28910360"},{"name":"Santa Rosa Department","isoCode":"SR","countryCode":"GT","latitude":"38.44057590","longitude":"-122.70375430"},{"name":"Suchitep\xe9quez Department","isoCode":"SU","countryCode":"GT","latitude":"14.42159820","longitude":"-91.40482490"},{"name":"Totonicap\xe1n Department","isoCode":"TO","countryCode":"GT","latitude":"14.91734020","longitude":"-91.36139230"},{"name":"Bafat\xe1","isoCode":"BA","countryCode":"GW","latitude":"12.17352430","longitude":"-14.65295200"},{"name":"Bolama Region","isoCode":"BL","countryCode":"GW","latitude":"11.14805910","longitude":"-16.13457050"},{"name":"Biombo Region","isoCode":"BM","countryCode":"GW","latitude":"11.85290610","longitude":"-15.73511710"},{"name":"Cacheu Region","isoCode":"CA","countryCode":"GW","latitude":"12.05514160","longitude":"-16.06401790"},{"name":"Gab\xfa Region","isoCode":"GA","countryCode":"GW","latitude":"11.89624880","longitude":"-14.10013260"},{"name":"Leste Province","isoCode":"L","countryCode":"GW","latitude":null,"longitude":null},{"name":"Norte Province","isoCode":"N","countryCode":"GW","latitude":"7.87218110","longitude":"123.88577470"},{"name":"Oio Region","isoCode":"OI","countryCode":"GW","latitude":"12.27607090","longitude":"-15.31311850"},{"name":"Quinara Region","isoCode":"QU","countryCode":"GW","latitude":"11.79556200","longitude":"-15.17268160"},{"name":"Sul Province","isoCode":"S","countryCode":"GW","latitude":"-10.28665780","longitude":"20.71224650"},{"name":"Tombali Region","isoCode":"TO","countryCode":"GW","latitude":"11.36326960","longitude":"-14.98561760"},{"name":"Barima-Waini","isoCode":"BA","countryCode":"GY","latitude":"7.48824190","longitude":"-59.65644940"},{"name":"Cuyuni-Mazaruni","isoCode":"CU","countryCode":"GY","latitude":"6.46421410","longitude":"-60.21107520"},{"name":"Demerara-Mahaica","isoCode":"DE","countryCode":"GY","latitude":"6.54642600","longitude":"-58.09820460"},{"name":"East Berbice-Corentyne","isoCode":"EB","countryCode":"GY","latitude":"2.74779220","longitude":"-57.46272590"},{"name":"Essequibo Islands-West Demerara","isoCode":"ES","countryCode":"GY","latitude":"6.57201320","longitude":"-58.46299970"},{"name":"Mahaica-Berbice","isoCode":"MA","countryCode":"GY","latitude":"6.23849600","longitude":"-57.91625550"},{"name":"Pomeroon-Supenaam","isoCode":"PM","countryCode":"GY","latitude":"7.12941660","longitude":"-58.92062950"},{"name":"Potaro-Siparuni","isoCode":"PT","countryCode":"GY","latitude":"4.78558530","longitude":"-59.28799770"},{"name":"Upper Demerara-Berbice","isoCode":"UD","countryCode":"GY","latitude":"5.30648790","longitude":"-58.18929210"},{"name":"Upper Takutu-Upper Essequibo","isoCode":"UT","countryCode":"GY","latitude":"2.92395950","longitude":"-58.73736340"},{"name":"Central and Western District","isoCode":"HCW","countryCode":"HK","latitude":"22.28666000","longitude":"114.15497000"},{"name":"Eastern","isoCode":"HEA","countryCode":"HK","latitude":"22.28411000","longitude":"114.22414000"},{"name":"Southern","isoCode":"HSO","countryCode":"HK","latitude":"22.24725000","longitude":"114.15884000"},{"name":"Wan Chai","isoCode":"HWC","countryCode":"HK","latitude":"22.27968000","longitude":"114.17168000"},{"name":"Kowloon City","isoCode":"KKC","countryCode":"HK","latitude":"22.32820000","longitude":"114.19155000"},{"name":"Kwun Tong","isoCode":"KKT","countryCode":"HK","latitude":"22.31326000","longitude":"114.22581000"},{"name":"Sham Shui Po","isoCode":"KSS","countryCode":"HK","latitude":"22.33074000","longitude":"114.16220000"},{"name":"Wong Tai Sin","isoCode":"KWT","countryCode":"HK","latitude":"22.33353000","longitude":"114.19686000"},{"name":"Yau Tsim Mong","isoCode":"KYT","countryCode":"HK","latitude":"22.32138000","longitude":"114.17260000"},{"name":"Islands District","isoCode":"NIS","countryCode":"HK","latitude":"22.26114000","longitude":"113.94608000"},{"name":"Kwai Tsing","isoCode":"NKT","countryCode":"HK","latitude":"22.35488000","longitude":"114.08401000"},{"name":"North","isoCode":"NNO","countryCode":"HK","latitude":"22.49471000","longitude":"114.13812000"},{"name":"Sai Kung District","isoCode":"NSK","countryCode":"HK","latitude":"22.38143000","longitude":"114.27052000"},{"name":"Sha Tin","isoCode":"NST","countryCode":"HK","latitude":"22.38715000","longitude":"114.19534000"},{"name":"Tuen Mun","isoCode":"NTM","countryCode":"HK","latitude":"22.39163000","longitude":"113.97708850"},{"name":"Tsuen Wan District","isoCode":"NTW","countryCode":"HK","latitude":"22.36281000","longitude":"114.12907000"},{"name":"Yuen Long District","isoCode":"NYL","countryCode":"HK","latitude":"22.44559000","longitude":"114.02218000"},{"name":"Atl\xe1ntida Department","isoCode":"AT","countryCode":"HN","latitude":"15.66962830","longitude":"-87.14228950"},{"name":"Choluteca Department","isoCode":"CH","countryCode":"HN","latitude":"13.25043250","longitude":"-87.14228950"},{"name":"Col\xf3n Department","isoCode":"CL","countryCode":"HN","latitude":"15.64259650","longitude":"-85.52002400"},{"name":"Comayagua Department","isoCode":"CM","countryCode":"HN","latitude":"14.55348280","longitude":"-87.61863790"},{"name":"Cop\xe1n Department","isoCode":"CP","countryCode":"HN","latitude":"14.93608380","longitude":"-88.86469800"},{"name":"Cort\xe9s Department","isoCode":"CR","countryCode":"HN","latitude":"15.49235080","longitude":"-88.09007620"},{"name":"El Para\xedso Department","isoCode":"EP","countryCode":"HN","latitude":"13.98212940","longitude":"-86.49965460"},{"name":"Francisco Moraz\xe1n Department","isoCode":"FM","countryCode":"HN","latitude":"14.45411000","longitude":"-87.06242610"},{"name":"Gracias a Dios Department","isoCode":"GD","countryCode":"HN","latitude":"15.34180600","longitude":"-84.60604490"},{"name":"Bay Islands Department","isoCode":"IB","countryCode":"HN","latitude":"16.48266140","longitude":"-85.87932520"},{"name":"Intibuc\xe1 Department","isoCode":"IN","countryCode":"HN","latitude":"14.37273400","longitude":"-88.24611830"},{"name":"Lempira Department","isoCode":"LE","countryCode":"HN","latitude":"14.18876980","longitude":"-88.55653100"},{"name":"La Paz Department","isoCode":"LP","countryCode":"HN","latitude":"-15.08924160","longitude":"-68.52471490"},{"name":"Ocotepeque Department","isoCode":"OC","countryCode":"HN","latitude":"14.51703470","longitude":"-89.05615320"},{"name":"Olancho Department","isoCode":"OL","countryCode":"HN","latitude":"14.80674060","longitude":"-85.76666450"},{"name":"Santa B\xe1rbara Department","isoCode":"SB","countryCode":"HN","latitude":"15.12027950","longitude":"-88.40160410"},{"name":"Valle Department","isoCode":"VA","countryCode":"HN","latitude":"13.57829360","longitude":"-87.57912870"},{"name":"Yoro Department","isoCode":"YO","countryCode":"HN","latitude":"15.29496790","longitude":"-87.14228950"},{"name":"Zagreb County","isoCode":"01","countryCode":"HR","latitude":"45.87066120","longitude":"16.39549100"},{"name":"Krapina-Zagorje County","isoCode":"02","countryCode":"HR","latitude":"46.10133930","longitude":"15.88096930"},{"name":"Sisak-Moslavina County","isoCode":"03","countryCode":"HR","latitude":"45.38379260","longitude":"16.53809940"},{"name":"Karlovac County","isoCode":"05","countryCode":"HR","latitude":"45.26133520","longitude":"15.52542016"},{"name":"Koprivnica-Kri\u017Eevci County","isoCode":"06","countryCode":"HR","latitude":"46.15689190","longitude":"16.83908260"},{"name":"Bjelovar-Bilogora County","isoCode":"07","countryCode":"HR","latitude":"45.89879720","longitude":"16.84230930"},{"name":"Primorje-Gorski Kotar County","isoCode":"08","countryCode":"HR","latitude":"45.31739960","longitude":"14.81674660"},{"name":"Lika-Senj County","isoCode":"09","countryCode":"HR","latitude":"44.61922180","longitude":"15.47016080"},{"name":"Virovitica-Podravina County","isoCode":"10","countryCode":"HR","latitude":"45.65579850","longitude":"17.79324720"},{"name":"Po\u017Eega-Slavonia County","isoCode":"11","countryCode":"HR","latitude":"45.34178680","longitude":"17.81143590"},{"name":"Brod-Posavina County","isoCode":"12","countryCode":"HR","latitude":"45.26379510","longitude":"17.32645620"},{"name":"Zadar County","isoCode":"13","countryCode":"HR","latitude":"44.14693900","longitude":"15.61649430"},{"name":"Osijek-Baranja County","isoCode":"14","countryCode":"HR","latitude":"45.55764280","longitude":"18.39421410"},{"name":"\u0160ibenik-Knin County","isoCode":"15","countryCode":"HR","latitude":"43.92814850","longitude":"16.10376940"},{"name":"Vukovar-Syrmia County","isoCode":"16","countryCode":"HR","latitude":"45.17735520","longitude":"18.80535270"},{"name":"Split-Dalmatia County","isoCode":"17","countryCode":"HR","latitude":"43.52403280","longitude":"16.81783770"},{"name":"Istria County","isoCode":"18","countryCode":"HR","latitude":"45.12864550","longitude":"13.90154200"},{"name":"Dubrovnik-Neretva County","isoCode":"19","countryCode":"HR","latitude":"43.07665880","longitude":"17.52684710"},{"name":"Me\u0111imurje County","isoCode":"20","countryCode":"HR","latitude":"46.37666440","longitude":"16.42132980"},{"name":"Zagreb","isoCode":"21","countryCode":"HR","latitude":"45.81501080","longitude":"15.98191890"},{"name":"Artibonite","isoCode":"AR","countryCode":"HT","latitude":"19.36290200","longitude":"-72.42581450"},{"name":"Centre","isoCode":"CE","countryCode":"HT","latitude":"32.83702510","longitude":"-96.77738820"},{"name":"Grand\'Anse","isoCode":"GA","countryCode":"HT","latitude":"12.01666670","longitude":"-61.76666670"},{"name":"Nord","isoCode":"ND","countryCode":"HT","latitude":"43.19052600","longitude":"-89.43792100"},{"name":"Nord-Est","isoCode":"NE","countryCode":"HT","latitude":"19.48897230","longitude":"-71.85713310"},{"name":"Nippes","isoCode":"NI","countryCode":"HT","latitude":"18.39907350","longitude":"-73.41802110"},{"name":"Nord-Ouest","isoCode":"NO","countryCode":"HT","latitude":"19.83740090","longitude":"-73.04052770"},{"name":"Ouest","isoCode":"OU","countryCode":"HT","latitude":"45.45472490","longitude":"-73.65023650"},{"name":"Sud","isoCode":"SD","countryCode":"HT","latitude":"29.92132480","longitude":"-90.09737720"},{"name":"Sud-Est","isoCode":"SE","countryCode":"HT","latitude":"18.27835980","longitude":"-72.35479150"},{"name":"Baranya County","isoCode":"BA","countryCode":"HU","latitude":"46.04845850","longitude":"18.27191730"},{"name":"B\xe9k\xe9scsaba","isoCode":"BC","countryCode":"HU","latitude":"46.67359390","longitude":"21.08773090"},{"name":"B\xe9k\xe9s County","isoCode":"BE","countryCode":"HU","latitude":"46.67048990","longitude":"21.04349960"},{"name":"B\xe1cs-Kiskun County","isoCode":"BK","countryCode":"HU","latitude":"46.56614370","longitude":"19.42724640"},{"name":"Budapest","isoCode":"BU","countryCode":"HU","latitude":"47.49791200","longitude":"19.04023500"},{"name":"Borsod-Aba\xfaj-Zempl\xe9n County","isoCode":"BZ","countryCode":"HU","latitude":"48.29394010","longitude":"20.69341120"},{"name":"Csongr\xe1d County","isoCode":"CS","countryCode":"HU","latitude":"46.41670500","longitude":"20.25661610"},{"name":"Debrecen","isoCode":"DE","countryCode":"HU","latitude":"47.53160490","longitude":"21.62731240"},{"name":"Duna\xfajv\xe1ros","isoCode":"DU","countryCode":"HU","latitude":"46.96190590","longitude":"18.93552270"},{"name":"Eger","isoCode":"EG","countryCode":"HU","latitude":"47.90253480","longitude":"20.37722840"},{"name":"\xc9rd","isoCode":"ER","countryCode":"HU","latitude":"47.39197180","longitude":"18.90454400"},{"name":"Fej\xe9r County","isoCode":"FE","countryCode":"HU","latitude":"47.12179320","longitude":"18.52948150"},{"name":"Gy\u0151r-Moson-Sopron County","isoCode":"GS","countryCode":"HU","latitude":"47.65092850","longitude":"17.25058830"},{"name":"Gy\u0151r","isoCode":"GY","countryCode":"HU","latitude":"47.68745690","longitude":"17.65039740"},{"name":"Hajd\xfa-Bihar County","isoCode":"HB","countryCode":"HU","latitude":"47.46883550","longitude":"21.54532270"},{"name":"Heves County","isoCode":"HE","countryCode":"HU","latitude":"47.80576170","longitude":"20.20385590"},{"name":"H\xf3dmez\u0151v\xe1s\xe1rhely","isoCode":"HV","countryCode":"HU","latitude":"46.41812620","longitude":"20.33003150"},{"name":"J\xe1sz-Nagykun-Szolnok County","isoCode":"JN","countryCode":"HU","latitude":"47.25555790","longitude":"20.52324560"},{"name":"Kecskem\xe9t","isoCode":"KM","countryCode":"HU","latitude":"46.89637110","longitude":"19.68968610"},{"name":"Kaposv\xe1r","isoCode":"KV","countryCode":"HU","latitude":"46.35936060","longitude":"17.79676390"},{"name":"Miskolc","isoCode":"MI","countryCode":"HU","latitude":"48.10347750","longitude":"20.77843840"},{"name":"Nagykanizsa","isoCode":"NK","countryCode":"HU","latitude":"46.45902180","longitude":"16.98967960"},{"name":"N\xf3gr\xe1d County","isoCode":"NO","countryCode":"HU","latitude":"47.90410310","longitude":"19.04985040"},{"name":"Ny\xedregyh\xe1za","isoCode":"NY","countryCode":"HU","latitude":"47.94953240","longitude":"21.72440530"},{"name":"Pest County","isoCode":"PE","countryCode":"HU","latitude":"47.44800010","longitude":"19.46181280"},{"name":"P\xe9cs","isoCode":"PS","countryCode":"HU","latitude":"46.07273450","longitude":"18.23226600"},{"name":"Szeged","isoCode":"SD","countryCode":"HU","latitude":"46.25301020","longitude":"20.14142530"},{"name":"Sz\xe9kesfeh\xe9rv\xe1r","isoCode":"SF","countryCode":"HU","latitude":"47.18602620","longitude":"18.42213580"},{"name":"Szombathely","isoCode":"SH","countryCode":"HU","latitude":"47.23068510","longitude":"16.62184410"},{"name":"Szolnok","isoCode":"SK","countryCode":"HU","latitude":"47.16213550","longitude":"20.18247120"},{"name":"Sopron","isoCode":"SN","countryCode":"HU","latitude":"47.68166190","longitude":"16.58447950"},{"name":"Somogy County","isoCode":"SO","countryCode":"HU","latitude":"46.55485900","longitude":"17.58667320"},{"name":"Szeksz\xe1rd","isoCode":"SS","countryCode":"HU","latitude":"46.34743260","longitude":"18.70622930"},{"name":"Salg\xf3tarj\xe1n","isoCode":"ST","countryCode":"HU","latitude":"48.09352370","longitude":"19.79998130"},{"name":"Szabolcs-Szatm\xe1r-Bereg County","isoCode":"SZ","countryCode":"HU","latitude":"48.03949540","longitude":"22.00333000"},{"name":"Tatab\xe1nya","isoCode":"TB","countryCode":"HU","latitude":"47.56924600","longitude":"18.40481800"},{"name":"Tolna County","isoCode":"TO","countryCode":"HU","latitude":"46.47627540","longitude":"18.55706270"},{"name":"Vas County","isoCode":"VA","countryCode":"HU","latitude":"47.09291110","longitude":"16.68121830"},{"name":"Veszpr\xe9m County","isoCode":"VE","countryCode":"HU","latitude":"47.09309740","longitude":"17.91007630"},{"name":"Veszpr\xe9m","isoCode":"VM","countryCode":"HU","latitude":"47.10280870","longitude":"17.90930190"},{"name":"Zala County","isoCode":"ZA","countryCode":"HU","latitude":"46.73844040","longitude":"16.91522520"},{"name":"Zalaegerszeg","isoCode":"ZE","countryCode":"HU","latitude":"46.84169360","longitude":"16.84163220"},{"name":"Aceh","isoCode":"AC","countryCode":"ID","latitude":"4.69513500","longitude":"96.74939930"},{"name":"Bali","isoCode":"BA","countryCode":"ID","latitude":"-8.34053890","longitude":"115.09195090"},{"name":"Kepulauan Bangka Belitung","isoCode":"BB","countryCode":"ID","latitude":"-2.74105130","longitude":"106.44058720"},{"name":"Bengkulu","isoCode":"BE","countryCode":"ID","latitude":"-3.79284510","longitude":"102.26076410"},{"name":"Banten","isoCode":"BT","countryCode":"ID","latitude":"-6.40581720","longitude":"106.06401790"},{"name":"Gorontalo","isoCode":"GO","countryCode":"ID","latitude":"0.54354420","longitude":"123.05676930"},{"name":"Jambi","isoCode":"JA","countryCode":"ID","latitude":"-1.61012290","longitude":"103.61312030"},{"name":"Jawa Barat","isoCode":"JB","countryCode":"ID","latitude":"-7.09091100","longitude":"107.66888700"},{"name":"Jawa Timur","isoCode":"JI","countryCode":"ID","latitude":"-7.53606390","longitude":"112.23840170"},{"name":"DKI Jakarta","isoCode":"JK","countryCode":"ID","latitude":"-6.20876340","longitude":"106.84559900"},{"name":"Jawa Tengah","isoCode":"JT","countryCode":"ID","latitude":"-7.15097500","longitude":"110.14025940"},{"name":"Kalimantan Barat","isoCode":"KA","countryCode":"ID","latitude":"0.96188340","longitude":"114.55484950"},{"name":"Kalimantan Timur","isoCode":"KI","countryCode":"ID","latitude":"0.53865860","longitude":"116.41938900"},{"name":"Kepulauan Riau","isoCode":"KR","countryCode":"ID","latitude":"3.94565140","longitude":"108.14286690"},{"name":"Kalimantan Selatan","isoCode":"KS","countryCode":"ID","latitude":"-3.09264150","longitude":"115.28375850"},{"name":"Kalimantan Tengah","isoCode":"KT","countryCode":"ID","latitude":"-1.68148780","longitude":"113.38235450"},{"name":"Kalimantan Utara","isoCode":"KU","countryCode":"ID","latitude":"3.07309290","longitude":"116.04138890"},{"name":"Lampung","isoCode":"LA","countryCode":"ID","latitude":"-4.55858490","longitude":"105.40680790"},{"name":"Maluku","isoCode":"MA","countryCode":"ID","latitude":"-3.23846160","longitude":"130.14527340"},{"name":"Maluku Utara","isoCode":"MU","countryCode":"ID","latitude":"1.57099930","longitude":"127.80876930"},{"name":"Nusa Tenggara Barat","isoCode":"NB","countryCode":"ID","latitude":"-8.65293340","longitude":"117.36164760"},{"name":"Nusa Tenggara Timur","isoCode":"NT","countryCode":"ID","latitude":"-8.65738190","longitude":"121.07937050"},{"name":"Papua","isoCode":"PA","countryCode":"ID","latitude":"-5.01222020","longitude":"141.34701590"},{"name":"Papua Barat","isoCode":"PB","countryCode":"ID","latitude":"-1.33611540","longitude":"133.17471620"},{"name":"Riau","isoCode":"RI","countryCode":"ID","latitude":"0.29334690","longitude":"101.70682940"},{"name":"Sulawesi Utara","isoCode":"SA","countryCode":"ID","latitude":"0.62469320","longitude":"123.97500180"},{"name":"Sumatera Barat","isoCode":"SB","countryCode":"ID","latitude":"-0.73993970","longitude":"100.80000510"},{"name":"Sulawesi Tenggara","isoCode":"SG","countryCode":"ID","latitude":"-4.14491000","longitude":"122.17460500"},{"name":"Sulawesi Selatan","isoCode":"SN","countryCode":"ID","latitude":"-3.66879940","longitude":"119.97405340"},{"name":"Sulawesi Barat","isoCode":"SR","countryCode":"ID","latitude":"-2.84413710","longitude":"119.23207840"},{"name":"Sumatera Selatan","isoCode":"SS","countryCode":"ID","latitude":"-3.31943740","longitude":"103.91439900"},{"name":"Sulawesi Tengah","isoCode":"ST","countryCode":"ID","latitude":"-1.43002540","longitude":"121.44561790"},{"name":"Sumatera Utara","isoCode":"SU","countryCode":"ID","latitude":"2.11535470","longitude":"99.54509740"},{"name":"DI Yogyakarta","isoCode":"YO","countryCode":"ID","latitude":"-7.87538490","longitude":"110.42620880"},{"name":"Connacht","isoCode":"C","countryCode":"IE","latitude":"53.83762430","longitude":"-8.95844810"},{"name":"Clare","isoCode":"CE","countryCode":"IE","latitude":"43.04664000","longitude":"-87.89958100"},{"name":"Cavan","isoCode":"CN","countryCode":"IE","latitude":"53.97654240","longitude":"-7.29966230"},{"name":"Cork","isoCode":"CO","countryCode":"IE","latitude":"51.89851430","longitude":"-8.47560350"},{"name":"Carlow","isoCode":"CW","countryCode":"IE","latitude":"52.72322170","longitude":"-6.81082950"},{"name":"Dublin","isoCode":"D","countryCode":"IE","latitude":"53.34980530","longitude":"-6.26030970"},{"name":"Donegal","isoCode":"DL","countryCode":"IE","latitude":"54.65489930","longitude":"-8.10409670"},{"name":"Galway","isoCode":"G","countryCode":"IE","latitude":"53.35645090","longitude":"-8.85341130"},{"name":"Kildare","isoCode":"KE","countryCode":"IE","latitude":"53.21204340","longitude":"-6.81947080"},{"name":"Kilkenny","isoCode":"KK","countryCode":"IE","latitude":"52.57769570","longitude":"-7.21800200"},{"name":"Kerry","isoCode":"KY","countryCode":"IE","latitude":"52.15446070","longitude":"-9.56686330"},{"name":"Leinster","isoCode":"L","countryCode":"IE","latitude":"53.32715380","longitude":"-7.51408410"},{"name":"Longford","isoCode":"LD","countryCode":"IE","latitude":"53.72749820","longitude":"-7.79315270"},{"name":"Louth","isoCode":"LH","countryCode":"IE","latitude":"53.92523240","longitude":"-6.48894230"},{"name":"Limerick","isoCode":"LK","countryCode":"IE","latitude":"52.50905170","longitude":"-8.74749550"},{"name":"Laois","isoCode":"LS","countryCode":"IE","latitude":"52.99429500","longitude":"-7.33230070"},{"name":"Munster","isoCode":"M","countryCode":"IE","latitude":"51.94711970","longitude":"7.58453200"},{"name":"Meath","isoCode":"MH","countryCode":"IE","latitude":"53.60554800","longitude":"-6.65641690"},{"name":"Monaghan","isoCode":"MN","countryCode":"IE","latitude":"54.24920460","longitude":"-6.96831320"},{"name":"Mayo","isoCode":"MO","countryCode":"IE","latitude":"54.01526040","longitude":"-9.42893690"},{"name":"Offaly","isoCode":"OY","countryCode":"IE","latitude":"53.23568710","longitude":"-7.71222290"},{"name":"Roscommon","isoCode":"RN","countryCode":"IE","latitude":"53.75926040","longitude":"-8.26816210"},{"name":"Sligo","isoCode":"SO","countryCode":"IE","latitude":"54.15532770","longitude":"-8.60645320"},{"name":"Tipperary","isoCode":"TA","countryCode":"IE","latitude":"52.47378940","longitude":"-8.16185140"},{"name":"Ulster","isoCode":"U","countryCode":"IE","latitude":"54.76165550","longitude":"-6.96122730"},{"name":"Waterford","isoCode":"WD","countryCode":"IE","latitude":"52.19435490","longitude":"-7.62275120"},{"name":"Westmeath","isoCode":"WH","countryCode":"IE","latitude":"53.53453080","longitude":"-7.46532170"},{"name":"Wicklow","isoCode":"WW","countryCode":"IE","latitude":"52.98623130","longitude":"-6.36725430"},{"name":"Wexford","isoCode":"WX","countryCode":"IE","latitude":"52.47936030","longitude":"-6.58399130"},{"name":"Southern District","isoCode":"D","countryCode":"IL","latitude":"40.71375860","longitude":"-74.00090590"},{"name":"Haifa District","isoCode":"HA","countryCode":"IL","latitude":"32.48141110","longitude":"34.99475100"},{"name":"Jerusalem District","isoCode":"JM","countryCode":"IL","latitude":"31.76482430","longitude":"34.99475100"},{"name":"Central District","isoCode":"M","countryCode":"IL","latitude":"47.60875830","longitude":"-122.29642350"},{"name":"Tel Aviv District","isoCode":"TA","countryCode":"IL","latitude":"32.09290750","longitude":"34.80721650"},{"name":"Northern District","isoCode":"Z","countryCode":"IL","latitude":"36.15118640","longitude":"-95.99517630"},{"name":"Andaman and Nicobar Islands","isoCode":"AN","countryCode":"IN","latitude":"11.74008670","longitude":"92.65864010"},{"name":"Andhra Pradesh","isoCode":"AP","countryCode":"IN","latitude":"15.91289980","longitude":"79.73998750"},{"name":"Arunachal Pradesh","isoCode":"AR","countryCode":"IN","latitude":"28.21799940","longitude":"94.72775280"},{"name":"Assam","isoCode":"AS","countryCode":"IN","latitude":"26.20060430","longitude":"92.93757390"},{"name":"Bihar","isoCode":"BR","countryCode":"IN","latitude":"25.09607420","longitude":"85.31311940"},{"name":"Chandigarh","isoCode":"CH","countryCode":"IN","latitude":"30.73331480","longitude":"76.77941790"},{"name":"Chhattisgarh","isoCode":"CT","countryCode":"IN","latitude":"21.27865670","longitude":"81.86614420"},{"name":"Dadra and Nagar Haveli and Daman and Diu","isoCode":"DH","countryCode":"IN","latitude":"20.39737360","longitude":"72.83279910"},{"name":"Delhi","isoCode":"DL","countryCode":"IN","latitude":"28.70405920","longitude":"77.10249020"},{"name":"Goa","isoCode":"GA","countryCode":"IN","latitude":"15.29932650","longitude":"74.12399600"},{"name":"Gujarat","isoCode":"GJ","countryCode":"IN","latitude":"22.25865200","longitude":"71.19238050"},{"name":"Himachal Pradesh","isoCode":"HP","countryCode":"IN","latitude":"31.10482940","longitude":"77.17339010"},{"name":"Haryana","isoCode":"HR","countryCode":"IN","latitude":"29.05877570","longitude":"76.08560100"},{"name":"Jharkhand","isoCode":"JH","countryCode":"IN","latitude":"23.61018080","longitude":"85.27993540"},{"name":"Jammu and Kashmir","isoCode":"JK","countryCode":"IN","latitude":"33.27783900","longitude":"75.34121790"},{"name":"Karnataka","isoCode":"KA","countryCode":"IN","latitude":"15.31727750","longitude":"75.71388840"},{"name":"Kerala","isoCode":"KL","countryCode":"IN","latitude":"10.85051590","longitude":"76.27108330"},{"name":"Ladakh","isoCode":"LA","countryCode":"IN","latitude":"34.22684750","longitude":"77.56194190"},{"name":"Lakshadweep","isoCode":"LD","countryCode":"IN","latitude":"10.32802650","longitude":"72.78463360"},{"name":"Maharashtra","isoCode":"MH","countryCode":"IN","latitude":"19.75147980","longitude":"75.71388840"},{"name":"Meghalaya","isoCode":"ML","countryCode":"IN","latitude":"25.46703080","longitude":"91.36621600"},{"name":"Manipur","isoCode":"MN","countryCode":"IN","latitude":"24.66371730","longitude":"93.90626880"},{"name":"Madhya Pradesh","isoCode":"MP","countryCode":"IN","latitude":"22.97342290","longitude":"78.65689420"},{"name":"Mizoram","isoCode":"MZ","countryCode":"IN","latitude":"23.16454300","longitude":"92.93757390"},{"name":"Nagaland","isoCode":"NL","countryCode":"IN","latitude":"26.15843540","longitude":"94.56244260"},{"name":"Odisha","isoCode":"OR","countryCode":"IN","latitude":"20.95166580","longitude":"85.09852360"},{"name":"Punjab","isoCode":"PB","countryCode":"IN","latitude":"31.14713050","longitude":"75.34121790"},{"name":"Puducherry","isoCode":"PY","countryCode":"IN","latitude":"11.94159150","longitude":"79.80831330"},{"name":"Rajasthan","isoCode":"RJ","countryCode":"IN","latitude":"27.02380360","longitude":"74.21793260"},{"name":"Sikkim","isoCode":"SK","countryCode":"IN","latitude":"27.53297180","longitude":"88.51221780"},{"name":"Telangana","isoCode":"TG","countryCode":"IN","latitude":"18.11243720","longitude":"79.01929970"},{"name":"Tamil Nadu","isoCode":"TN","countryCode":"IN","latitude":"11.12712250","longitude":"78.65689420"},{"name":"Tripura","isoCode":"TR","countryCode":"IN","latitude":"23.94084820","longitude":"91.98815270"},{"name":"Uttar Pradesh","isoCode":"UP","countryCode":"IN","latitude":"26.84670880","longitude":"80.94615920"},{"name":"Uttarakhand","isoCode":"UT","countryCode":"IN","latitude":"30.06675300","longitude":"79.01929970"},{"name":"West Bengal","isoCode":"WB","countryCode":"IN","latitude":"22.98675690","longitude":"87.85497550"},{"name":"Al Anbar Governorate","isoCode":"AN","countryCode":"IQ","latitude":"32.55976140","longitude":"41.91964710"},{"name":"Erbil Governorate","isoCode":"AR","countryCode":"IQ","latitude":"36.55706280","longitude":"44.38512630"},{"name":"Basra Governorate","isoCode":"BA","countryCode":"IQ","latitude":"30.51142520","longitude":"47.82962530"},{"name":"Babylon Governorate","isoCode":"BB","countryCode":"IQ","latitude":"32.46819100","longitude":"44.55019350"},{"name":"Baghdad Governorate","isoCode":"BG","countryCode":"IQ","latitude":"33.31526180","longitude":"44.36606530"},{"name":"Dohuk Governorate","isoCode":"DA","countryCode":"IQ","latitude":"36.90772520","longitude":"43.06316890"},{"name":"Diyala Governorate","isoCode":"DI","countryCode":"IQ","latitude":"33.77334870","longitude":"45.14945050"},{"name":"Dhi Qar Governorate","isoCode":"DQ","countryCode":"IQ","latitude":"31.10422920","longitude":"46.36246860"},{"name":"Karbala Governorate","isoCode":"KA","countryCode":"IQ","latitude":"32.40454930","longitude":"43.86732220"},{"name":"Kirkuk Governorate","isoCode":"KI","countryCode":"IQ","latitude":"35.32920140","longitude":"43.94367880"},{"name":"Maysan Governorate","isoCode":"MA","countryCode":"IQ","latitude":"31.87340020","longitude":"47.13621250"},{"name":"Al Muthanna Governorate","isoCode":"MU","countryCode":"IQ","latitude":"29.91331710","longitude":"45.29938620"},{"name":"Najaf Governorate","isoCode":"NA","countryCode":"IQ","latitude":"31.35174860","longitude":"44.09603110"},{"name":"Nineveh Governorate","isoCode":"NI","countryCode":"IQ","latitude":"36.22957400","longitude":"42.23624350"},{"name":"Al-Q\u0101disiyyah Governorate","isoCode":"QA","countryCode":"IQ","latitude":"32.04369100","longitude":"45.14945050"},{"name":"Saladin Governorate","isoCode":"SD","countryCode":"IQ","latitude":"34.53375270","longitude":"43.48373800"},{"name":"Sulaymaniyah Governorate","isoCode":"SU","countryCode":"IQ","latitude":"35.54663480","longitude":"45.30036830"},{"name":"Wasit Governorate","isoCode":"WA","countryCode":"IQ","latitude":"32.60240940","longitude":"45.75209850"},{"name":"Markazi","isoCode":"00","countryCode":"IR","latitude":"34.61230500","longitude":"49.85472660"},{"name":"Gilan","isoCode":"01","countryCode":"IR","latitude":"37.28094550","longitude":"49.59241340"},{"name":"Mazandaran","isoCode":"02","countryCode":"IR","latitude":"36.22623930","longitude":"52.53186040"},{"name":"East Azerbaijan","isoCode":"03","countryCode":"IR","latitude":"37.90357330","longitude":"46.26821090"},{"name":"West Azarbaijan","isoCode":"04","countryCode":"IR","latitude":"37.45500620","longitude":"45.00000000"},{"name":"Kermanshah","isoCode":"05","countryCode":"IR","latitude":"34.45762330","longitude":"46.67053400"},{"name":"Khuzestan","isoCode":"06","countryCode":"IR","latitude":"31.43601490","longitude":"49.04131200"},{"name":"Fars","isoCode":"07","countryCode":"IR","latitude":"29.10438130","longitude":"53.04589300"},{"name":"Kerman","isoCode":"08","countryCode":"IR","latitude":"29.48500890","longitude":"57.64390480"},{"name":"Razavi Khorasan","isoCode":"09","countryCode":"IR","latitude":"35.10202530","longitude":"59.10417580"},{"name":"Isfahan","isoCode":"10","countryCode":"IR","latitude":"33.27710730","longitude":"52.36133780"},{"name":"Sistan and Baluchestan","isoCode":"11","countryCode":"IR","latitude":"27.52999060","longitude":"60.58206760"},{"name":"Kurdistan","isoCode":"12","countryCode":"IR","latitude":"35.95535790","longitude":"47.13621250"},{"name":"Hamadan","isoCode":"13","countryCode":"IR","latitude":"34.91936070","longitude":"47.48329250"},{"name":"Chaharmahal and Bakhtiari","isoCode":"14","countryCode":"IR","latitude":"31.99704190","longitude":"50.66138490"},{"name":"Lorestan","isoCode":"15","countryCode":"IR","latitude":"33.58183940","longitude":"48.39881860"},{"name":"Ilam","isoCode":"16","countryCode":"IR","latitude":"33.29576180","longitude":"46.67053400"},{"name":"Kohgiluyeh and Boyer-Ahmad","isoCode":"17","countryCode":"IR","latitude":"30.72458600","longitude":"50.84563230"},{"name":"Bushehr","isoCode":"18","countryCode":"IR","latitude":"28.76207390","longitude":"51.51500770"},{"name":"Zanjan","isoCode":"19","countryCode":"IR","latitude":"36.50181850","longitude":"48.39881860"},{"name":"Semnan","isoCode":"20","countryCode":"IR","latitude":"35.22555850","longitude":"54.43421380"},{"name":"Yazd","isoCode":"21","countryCode":"IR","latitude":"32.10063870","longitude":"54.43421380"},{"name":"Hormozgan","isoCode":"22","countryCode":"IR","latitude":"27.13872300","longitude":"55.13758340"},{"name":"Tehran","isoCode":"23","countryCode":"IR","latitude":"35.72484160","longitude":"51.38165300"},{"name":"Ardabil","isoCode":"24","countryCode":"IR","latitude":"38.48532760","longitude":"47.89112090"},{"name":"Qom","isoCode":"25","countryCode":"IR","latitude":"34.64157640","longitude":"50.87460350"},{"name":"Qazvin","isoCode":"26","countryCode":"IR","latitude":"36.08813170","longitude":"49.85472660"},{"name":"Golestan","isoCode":"27","countryCode":"IR","latitude":"37.28981230","longitude":"55.13758340"},{"name":"North Khorasan","isoCode":"28","countryCode":"IR","latitude":"37.47103530","longitude":"57.10131880"},{"name":"South Khorasan","isoCode":"29","countryCode":"IR","latitude":"32.51756430","longitude":"59.10417580"},{"name":"Alborz","isoCode":"30","countryCode":"IR","latitude":"35.99604670","longitude":"50.92892460"},{"name":"Capital Region","isoCode":"1","countryCode":"IS","latitude":"38.56569570","longitude":"-92.18169490"},{"name":"Southern Peninsula Region","isoCode":"2","countryCode":"IS","latitude":"63.91548030","longitude":"-22.36496670"},{"name":"Western Region","isoCode":"3","countryCode":"IS","latitude":null,"longitude":null},{"name":"Westfjords","isoCode":"4","countryCode":"IS","latitude":"65.91961500","longitude":"-21.88117640"},{"name":"Northwestern Region","isoCode":"5","countryCode":"IS","latitude":"41.91339320","longitude":"-73.04716880"},{"name":"Northeastern Region","isoCode":"6","countryCode":"IS","latitude":"43.29942850","longitude":"-74.21793260"},{"name":"Eastern Region","isoCode":"7","countryCode":"IS","latitude":null,"longitude":null},{"name":"Southern Region","isoCode":"8","countryCode":"IS","latitude":null,"longitude":null},{"name":"Piedmont","isoCode":"21","countryCode":"IT","latitude":"45.05223660","longitude":"7.51538850"},{"name":"Aosta Valley","isoCode":"23","countryCode":"IT","latitude":"45.73888780","longitude":"7.42618660"},{"name":"Lombardy","isoCode":"25","countryCode":"IT","latitude":"45.47906710","longitude":"9.84524330"},{"name":"Trentino-South Tyrol","isoCode":"32","countryCode":"IT","latitude":"46.43366620","longitude":"11.16932960"},{"name":"Veneto","isoCode":"34","countryCode":"IT","latitude":"45.44146620","longitude":"12.31525950"},{"name":"Friuli\u2013Venezia Giulia","isoCode":"36","countryCode":"IT","latitude":"46.22591770","longitude":"13.10336460"},{"name":"Liguria","isoCode":"42","countryCode":"IT","latitude":"44.31679170","longitude":"8.39649380"},{"name":"Emilia-Romagna","isoCode":"45","countryCode":"IT","latitude":"44.59676070","longitude":"11.21863960"},{"name":"Tuscany","isoCode":"52","countryCode":"IT","latitude":"43.77105130","longitude":"11.24862080"},{"name":"Umbria","isoCode":"55","countryCode":"IT","latitude":"42.93800400","longitude":"12.62162110"},{"name":"Marche","isoCode":"57","countryCode":"IT","latitude":"30.55670700","longitude":"-81.44930300"},{"name":"Lazio","isoCode":"62","countryCode":"IT","latitude":"45.69916670","longitude":"-73.65583330"},{"name":"Abruzzo","isoCode":"65","countryCode":"IT","latitude":"42.19201190","longitude":"13.72891670"},{"name":"Molise","isoCode":"67","countryCode":"IT","latitude":"41.67388650","longitude":"14.75209390"},{"name":"Campania","isoCode":"72","countryCode":"IT","latitude":"40.66708870","longitude":"15.10681130"},{"name":"Apulia","isoCode":"75","countryCode":"IT","latitude":"40.79283930","longitude":"17.10119310"},{"name":"Basilicata","isoCode":"77","countryCode":"IT","latitude":"40.64307660","longitude":"15.96998780"},{"name":"Calabria","isoCode":"78","countryCode":"IT","latitude":"39.30877140","longitude":"16.34637910"},{"name":"Sicily","isoCode":"82","countryCode":"IT","latitude":"37.59999380","longitude":"14.01535570"},{"name":"Sardinia","isoCode":"88","countryCode":"IT","latitude":"40.12087520","longitude":"9.01289260"},{"name":"Libero consorzio comunale di Agrigento","isoCode":"AG","countryCode":"IT","latitude":"37.31052020","longitude":"13.58579780"},{"name":"Province of Alessandria","isoCode":"AL","countryCode":"IT","latitude":"44.81755870","longitude":"8.70466270"},{"name":"Province of Ancona","isoCode":"AN","countryCode":"IT","latitude":"43.54932450","longitude":"13.26634790"},{"name":"Province of Ascoli Piceno","isoCode":"AP","countryCode":"IT","latitude":"42.86389330","longitude":"13.58997330"},{"name":"Province of L\'Aquila","isoCode":"AQ","countryCode":"IT","latitude":"42.12563170","longitude":"13.63627150"},{"name":"Province of Asti","isoCode":"AT","countryCode":"IT","latitude":"44.90076520","longitude":"8.20643150"},{"name":"Province of Avellino","isoCode":"AV","countryCode":"IT","latitude":"40.99645100","longitude":"15.12589550"},{"name":"Metropolitan City of Bari","isoCode":"BA","countryCode":"IT","latitude":"41.11714320","longitude":"16.87187150"},{"name":"Province of Bergamo","isoCode":"BG","countryCode":"IT","latitude":"45.69826420","longitude":"9.67726980"},{"name":"Province of Biella","isoCode":"BI","countryCode":"IT","latitude":"45.56281760","longitude":"8.05827170"},{"name":"Province of Belluno","isoCode":"BL","countryCode":"IT","latitude":"46.24976590","longitude":"12.19695650"},{"name":"Benevento Province","isoCode":"BN","countryCode":"IT","latitude":"41.20350930","longitude":"14.75209390"},{"name":"Metropolitan City of Bologna","isoCode":"BO","countryCode":"IT","latitude":"44.49488700","longitude":"11.34261620"},{"name":"Province of Brindisi","isoCode":"BR","countryCode":"IT","latitude":"40.61126630","longitude":"17.76362100"},{"name":"Province of Brescia","isoCode":"BS","countryCode":"IT","latitude":"45.54155260","longitude":"10.21180190"},{"name":"Province of Barletta-Andria-Trani","isoCode":"BT","countryCode":"IT","latitude":"41.20045430","longitude":"16.20514840"},{"name":"South Tyrol","isoCode":"BZ","countryCode":"IT","latitude":"46.49494500","longitude":"11.34026570"},{"name":"Metropolitan City of Cagliari","isoCode":"CA","countryCode":"IT","latitude":"39.22384110","longitude":"9.12166130"},{"name":"Province of Campobasso","isoCode":"CB","countryCode":"IT","latitude":"41.67388650","longitude":"14.75209390"},{"name":"Province of Caserta","isoCode":"CE","countryCode":"IT","latitude":"41.20783540","longitude":"14.10013260"},{"name":"Province of Chieti","isoCode":"CH","countryCode":"IT","latitude":"42.03344280","longitude":"14.37919120"},{"name":"Province of Carbonia-Iglesias","isoCode":"CI","countryCode":"IT","latitude":"39.25346590","longitude":"8.57210160"},{"name":"Libero consorzio comunale di Caltanissetta","isoCode":"CL","countryCode":"IT","latitude":"37.48601300","longitude":"14.06149820"},{"name":"Province of Cuneo","isoCode":"CN","countryCode":"IT","latitude":"44.59703140","longitude":"7.61142170"},{"name":"Province of Como","isoCode":"CO","countryCode":"IT","latitude":"45.80804160","longitude":"9.08517930"},{"name":"Province of Cremona","isoCode":"CR","countryCode":"IT","latitude":"45.20143750","longitude":"9.98365820"},{"name":"Province of Cosenza","isoCode":"CS","countryCode":"IT","latitude":"39.56441050","longitude":"16.25221430"},{"name":"Metropolitan City of Catania","isoCode":"CT","countryCode":"IT","latitude":"37.45154380","longitude":"15.05574150"},{"name":"Province of Catanzaro","isoCode":"CZ","countryCode":"IT","latitude":"38.88963480","longitude":"16.44058720"},{"name":"Libero consorzio comunale di Enna","isoCode":"EN","countryCode":"IT","latitude":"37.56762160","longitude":"14.27953490"},{"name":"Province of Forl\xec-Cesena","isoCode":"FC","countryCode":"IT","latitude":"43.99476810","longitude":"11.98046130"},{"name":"Province of Ferrara","isoCode":"FE","countryCode":"IT","latitude":"44.76636800","longitude":"11.76440680"},{"name":"Province of Foggia","isoCode":"FG","countryCode":"IT","latitude":"41.63844800","longitude":"15.59433880"},{"name":"Metropolitan City of Florence","isoCode":"FI","countryCode":"IT","latitude":"43.76791780","longitude":"11.25237920"},{"name":"Province of Fermo","isoCode":"FM","countryCode":"IT","latitude":"43.09313670","longitude":"13.58997330"},{"name":"Province of Frosinone","isoCode":"FR","countryCode":"IT","latitude":"41.65765280","longitude":"13.63627150"},{"name":"Metropolitan City of Genoa","isoCode":"GE","countryCode":"IT","latitude":"44.40564930","longitude":"8.94625640"},{"name":"Province of Gorizia","isoCode":"GO","countryCode":"IT","latitude":"45.90538990","longitude":"13.51637250"},{"name":"Province of Grosseto","isoCode":"GR","countryCode":"IT","latitude":"42.85180070","longitude":"11.25237920"},{"name":"Province of Imperia","isoCode":"IM","countryCode":"IT","latitude":"43.94186600","longitude":"7.82863680"},{"name":"Province of Isernia","isoCode":"IS","countryCode":"IT","latitude":"41.58915550","longitude":"14.19309180"},{"name":"Province of Crotone","isoCode":"KR","countryCode":"IT","latitude":"39.13098560","longitude":"17.00670310"},{"name":"Province of Lecco","isoCode":"LC","countryCode":"IT","latitude":"45.93829410","longitude":"9.38572900"},{"name":"Province of Lecce","isoCode":"LE","countryCode":"IT","latitude":"40.23473930","longitude":"18.14286690"},{"name":"Province of Livorno","isoCode":"LI","countryCode":"IT","latitude":"43.02398480","longitude":"10.66471010"},{"name":"Province of Lodi","isoCode":"LO","countryCode":"IT","latitude":"45.24050360","longitude":"9.52925120"},{"name":"Province of Latina","isoCode":"LT","countryCode":"IT","latitude":"41.40874760","longitude":"13.08179030"},{"name":"Province of Lucca","isoCode":"LU","countryCode":"IT","latitude":"43.83767360","longitude":"10.49505300"},{"name":"Province of Monza and Brianza","isoCode":"MB","countryCode":"IT","latitude":"45.62359900","longitude":"9.25880150"},{"name":"Province of Macerata","isoCode":"MC","countryCode":"IT","latitude":"43.24593220","longitude":"13.26634790"},{"name":"Metropolitan City of Messina","isoCode":"ME","countryCode":"IT","latitude":"38.19373350","longitude":"15.55420570"},{"name":"Metropolitan City of Milan","isoCode":"MI","countryCode":"IT","latitude":"45.45862600","longitude":"9.18187300"},{"name":"Province of Mantua","isoCode":"MN","countryCode":"IT","latitude":"45.16677280","longitude":"10.77536130"},{"name":"Province of Modena","isoCode":"MO","countryCode":"IT","latitude":"44.55137990","longitude":"10.91804800"},{"name":"Province of Massa and Carrara","isoCode":"MS","countryCode":"IT","latitude":"44.22139980","longitude":"10.03596610"},{"name":"Province of Matera","isoCode":"MT","countryCode":"IT","latitude":"40.66634960","longitude":"16.60436360"},{"name":"Metropolitan City of Naples","isoCode":"NA","countryCode":"IT","latitude":"40.90197500","longitude":"14.33264400"},{"name":"Province of Novara","isoCode":"NO","countryCode":"IT","latitude":"45.54851330","longitude":"8.51507930"},{"name":"Province of Nuoro","isoCode":"NU","countryCode":"IT","latitude":"40.32869040","longitude":"9.45615500"},{"name":"Province of Ogliastra","isoCode":"OG","countryCode":"IT","latitude":"39.84105360","longitude":"9.45615500"},{"name":"Province of Oristano","isoCode":"OR","countryCode":"IT","latitude":"40.05990680","longitude":"8.74811670"},{"name":"Province of Olbia-Tempio","isoCode":"OT","countryCode":"IT","latitude":"40.82683830","longitude":"9.27855830"},{"name":"Metropolitan City of Palermo","isoCode":"PA","countryCode":"IT","latitude":"38.11569000","longitude":"13.36148680"},{"name":"Province of Piacenza","isoCode":"PC","countryCode":"IT","latitude":"44.82631120","longitude":"9.52914470"},{"name":"Province of Padua","isoCode":"PD","countryCode":"IT","latitude":"45.36618640","longitude":"11.82091390"},{"name":"Province of Pescara","isoCode":"PE","countryCode":"IT","latitude":"42.35706550","longitude":"13.96080910"},{"name":"Province of Perugia","isoCode":"PG","countryCode":"IT","latitude":"42.93800400","longitude":"12.62162110"},{"name":"Province of Pisa","isoCode":"PI","countryCode":"IT","latitude":"43.72283150","longitude":"10.40171940"},{"name":"Province of Pordenone","isoCode":"PN","countryCode":"IT","latitude":"46.03788620","longitude":"12.71083500"},{"name":"Province of Prato","isoCode":"PO","countryCode":"IT","latitude":"44.04539000","longitude":"11.11644520"},{"name":"Province of Parma","isoCode":"PR","countryCode":"IT","latitude":"44.80153220","longitude":"10.32793540"},{"name":"Province of Pistoia","isoCode":"PT","countryCode":"IT","latitude":"43.95437330","longitude":"10.89030990"},{"name":"Pesaro and Urbino Province","isoCode":"PU","countryCode":"IT","latitude":"43.61301180","longitude":"12.71351210"},{"name":"Province of Pavia","isoCode":"PV","countryCode":"IT","latitude":"45.32181660","longitude":"8.84662360"},{"name":"Province of Potenza","isoCode":"PZ","countryCode":"IT","latitude":"40.41821940","longitude":"15.87600400"},{"name":"Province of Ravenna","isoCode":"RA","countryCode":"IT","latitude":"44.41844430","longitude":"12.20359980"},{"name":"Metropolitan City of Reggio Calabria","isoCode":"RC","countryCode":"IT","latitude":"38.10843960","longitude":"15.64370480"},{"name":"Province of Reggio Emilia","isoCode":"RE","countryCode":"IT","latitude":"44.58565800","longitude":"10.55647360"},{"name":"Libero consorzio comunale di Ragusa","isoCode":"RG","countryCode":"IT","latitude":"36.92692730","longitude":"14.72551290"},{"name":"Province of Rieti","isoCode":"RI","countryCode":"IT","latitude":"42.36744050","longitude":"12.89750980"},{"name":"Metropolitan City of Rome","isoCode":"RM","countryCode":"IT","latitude":"41.90270080","longitude":"12.49623520"},{"name":"Province of Rimini","isoCode":"RN","countryCode":"IT","latitude":"44.06782880","longitude":"12.56951580"},{"name":"Province of Rovigo","isoCode":"RO","countryCode":"IT","latitude":"45.02418180","longitude":"11.82381620"},{"name":"Province of Salerno","isoCode":"SA","countryCode":"IT","latitude":"40.42878320","longitude":"15.21948080"},{"name":"Province of Siena","isoCode":"SI","countryCode":"IT","latitude":"43.29377320","longitude":"11.43391480"},{"name":"Province of Sondrio","isoCode":"SO","countryCode":"IT","latitude":"46.17276360","longitude":"9.79949170"},{"name":"Province of La Spezia","isoCode":"SP","countryCode":"IT","latitude":"44.24479130","longitude":"9.76786870"},{"name":"Libero consorzio comunale di Siracusa","isoCode":"SR","countryCode":"IT","latitude":"37.06569240","longitude":"15.28571090"},{"name":"Province of Sassari","isoCode":"SS","countryCode":"IT","latitude":"40.79679070","longitude":"8.57504070"},{"name":"Province of Savona","isoCode":"SV","countryCode":"IT","latitude":"44.28879950","longitude":"8.26505800"},{"name":"Province of Taranto","isoCode":"TA","countryCode":"IT","latitude":"40.57409010","longitude":"17.24299760"},{"name":"Province of Teramo","isoCode":"TE","countryCode":"IT","latitude":"42.58956080","longitude":"13.63627150"},{"name":"Trentino","isoCode":"TN","countryCode":"IT","latitude":"46.05120040","longitude":"11.11753920"},{"name":"Metropolitan City of Turin","isoCode":"TO","countryCode":"IT","latitude":"45.06329900","longitude":"7.66928900"},{"name":"Libero consorzio comunale di Trapani","isoCode":"TP","countryCode":"IT","latitude":"38.01831160","longitude":"12.51482650"},{"name":"Province of Terni","isoCode":"TR","countryCode":"IT","latitude":"42.56345340","longitude":"12.52980280"},{"name":"Province of Trieste","isoCode":"TS","countryCode":"IT","latitude":"45.68948230","longitude":"13.78330720"},{"name":"Province of Treviso","isoCode":"TV","countryCode":"IT","latitude":"45.66685170","longitude":"12.24306170"},{"name":"Province of Udine","isoCode":"UD","countryCode":"IT","latitude":"46.14079720","longitude":"13.16628960"},{"name":"Province of Varese","isoCode":"VA","countryCode":"IT","latitude":"45.79902600","longitude":"8.73009450"},{"name":"Province of Verbano-Cusio-Ossola","isoCode":"VB","countryCode":"IT","latitude":"46.13996880","longitude":"8.27246490"},{"name":"Province of Vercelli","isoCode":"VC","countryCode":"IT","latitude":"45.32022040","longitude":"8.41850800"},{"name":"Metropolitan City of Venice","isoCode":"VE","countryCode":"IT","latitude":"45.44146850","longitude":"12.31526720"},{"name":"Province of Vicenza","isoCode":"VI","countryCode":"IT","latitude":"45.69839950","longitude":"11.56614650"},{"name":"Province of Verona","isoCode":"VR","countryCode":"IT","latitude":"45.44184980","longitude":"11.07353160"},{"name":"Province of Medio Campidano","isoCode":"VS","countryCode":"IT","latitude":"39.53173890","longitude":"8.70407500"},{"name":"Province of Viterbo","isoCode":"VT","countryCode":"IT","latitude":"42.40024200","longitude":"11.88917210"},{"name":"Province of Vibo Valentia","isoCode":"VV","countryCode":"IT","latitude":"38.63785650","longitude":"16.20514840"},{"name":"Kingston Parish","isoCode":"01","countryCode":"JM","latitude":"17.96832710","longitude":"-76.78270200"},{"name":"Saint Andrew","isoCode":"02","countryCode":"JM","latitude":"37.22451030","longitude":"-95.70211890"},{"name":"Saint Thomas Parish","isoCode":"03","countryCode":"JM","latitude":"41.44253890","longitude":"-81.74022180"},{"name":"Portland Parish","isoCode":"04","countryCode":"JM","latitude":"18.08442740","longitude":"-76.41002670"},{"name":"Saint Mary Parish","isoCode":"05","countryCode":"JM","latitude":"36.09252200","longitude":"-95.97384400"},{"name":"Saint Ann Parish","isoCode":"06","countryCode":"JM","latitude":"37.28714520","longitude":"-77.41035330"},{"name":"Trelawny Parish","isoCode":"07","countryCode":"JM","latitude":"18.35261430","longitude":"-77.60778650"},{"name":"Saint James Parish","isoCode":"08","countryCode":"JM","latitude":"30.01792920","longitude":"-90.79132270"},{"name":"Hanover Parish","isoCode":"09","countryCode":"JM","latitude":"18.40977070","longitude":"-78.13363800"},{"name":"Westmoreland Parish","isoCode":"10","countryCode":"JM","latitude":"18.29443780","longitude":"-78.15644320"},{"name":"Saint Elizabeth Parish","isoCode":"11","countryCode":"JM","latitude":"38.99253080","longitude":"-94.58992000"},{"name":"Manchester Parish","isoCode":"12","countryCode":"JM","latitude":"18.06696540","longitude":"-77.51607880"},{"name":"Clarendon Parish","isoCode":"13","countryCode":"JM","latitude":"17.95571830","longitude":"-77.24051530"},{"name":"Saint Catherine Parish","isoCode":"14","countryCode":"JM","latitude":"18.03641340","longitude":"-77.05644640"},{"name":"Ajloun Governorate","isoCode":"AJ","countryCode":"JO","latitude":"32.33255840","longitude":"35.75168440"},{"name":"Amman Governorate","isoCode":"AM","countryCode":"JO","latitude":"31.94536330","longitude":"35.92838950"},{"name":"Aqaba Governorate","isoCode":"AQ","countryCode":"JO","latitude":"29.53208600","longitude":"35.00628210"},{"name":"Tafilah Governorate","isoCode":"AT","countryCode":"JO","latitude":"30.83380630","longitude":"35.61605130"},{"name":"Zarqa Governorate","isoCode":"AZ","countryCode":"JO","latitude":"32.06085050","longitude":"36.09421210"},{"name":"Balqa Governorate","isoCode":"BA","countryCode":"JO","latitude":"32.03668060","longitude":"35.72884800"},{"name":"Irbid Governorate","isoCode":"IR","countryCode":"JO","latitude":"32.55696360","longitude":"35.84789650"},{"name":"Jerash Governorate","isoCode":"JA","countryCode":"JO","latitude":"32.27472370","longitude":"35.89609540"},{"name":"Karak Governorate","isoCode":"KA","countryCode":"JO","latitude":"31.18535270","longitude":"35.70476820"},{"name":"Mafraq Governorate","isoCode":"MA","countryCode":"JO","latitude":"32.34169230","longitude":"36.20201750"},{"name":"Madaba Governorate","isoCode":"MD","countryCode":"JO","latitude":"31.71960970","longitude":"35.79327540"},{"name":"Ma\'an Governorate","isoCode":"MN","countryCode":"JO","latitude":"30.19267890","longitude":"35.72493190"},{"name":"Hokkaid\u014D Prefecture","isoCode":"01","countryCode":"JP","latitude":"43.22032660","longitude":"142.86347370"},{"name":"Aomori Prefecture","isoCode":"02","countryCode":"JP","latitude":"40.76570770","longitude":"140.91758790"},{"name":"Iwate Prefecture","isoCode":"03","countryCode":"JP","latitude":"39.58329890","longitude":"141.25345740"},{"name":"Miyagi Prefecture","isoCode":"04","countryCode":"JP","latitude":"38.63061200","longitude":"141.11930480"},{"name":"Akita Prefecture","isoCode":"05","countryCode":"JP","latitude":"40.13762930","longitude":"140.33434100"},{"name":"Yamagata Prefecture","isoCode":"06","countryCode":"JP","latitude":"38.53705640","longitude":"140.14351980"},{"name":"Fukushima Prefecture","isoCode":"07","countryCode":"JP","latitude":"37.38343730","longitude":"140.18325160"},{"name":"Ibaraki Prefecture","isoCode":"08","countryCode":"JP","latitude":"36.21935710","longitude":"140.18325160"},{"name":"Tochigi Prefecture","isoCode":"09","countryCode":"JP","latitude":"36.67147390","longitude":"139.85472660"},{"name":"Gunma Prefecture","isoCode":"10","countryCode":"JP","latitude":"36.56053880","longitude":"138.87999720"},{"name":"Saitama Prefecture","isoCode":"11","countryCode":"JP","latitude":"35.99625130","longitude":"139.44660050"},{"name":"Chiba Prefecture","isoCode":"12","countryCode":"JP","latitude":"35.33541550","longitude":"140.18325160"},{"name":"Tokyo","isoCode":"13","countryCode":"JP","latitude":"35.67619190","longitude":"139.65031060"},{"name":"Kanagawa Prefecture","isoCode":"14","countryCode":"JP","latitude":"35.49135350","longitude":"139.28414300"},{"name":"Niigata Prefecture","isoCode":"15","countryCode":"JP","latitude":"37.51783860","longitude":"138.92697940"},{"name":"Toyama Prefecture","isoCode":"16","countryCode":"JP","latitude":"36.69582660","longitude":"137.21370710"},{"name":"Ishikawa Prefecture","isoCode":"17","countryCode":"JP","latitude":"36.32603170","longitude":"136.52896530"},{"name":"Fukui Prefecture","isoCode":"18","countryCode":"JP","latitude":"35.89622700","longitude":"136.21115790"},{"name":"Yamanashi Prefecture","isoCode":"19","countryCode":"JP","latitude":"35.66351130","longitude":"138.63888790"},{"name":"Nagano Prefecture","isoCode":"20","countryCode":"JP","latitude":"36.15439410","longitude":"137.92182040"},{"name":"Gifu Prefecture","isoCode":"21","countryCode":"JP","latitude":"35.74374910","longitude":"136.98051030"},{"name":"Shizuoka Prefecture","isoCode":"22","countryCode":"JP","latitude":"35.09293970","longitude":"138.31902760"},{"name":"Aichi Prefecture","isoCode":"23","countryCode":"JP","latitude":"35.01825050","longitude":"137.29238930"},{"name":"Mie Prefecture","isoCode":"24","countryCode":"JP","latitude":"33.81439010","longitude":"136.04870470"},{"name":"Shiga Prefecture","isoCode":"25","countryCode":"JP","latitude":"35.32920140","longitude":"136.05632120"},{"name":"Ky\u014Dto Prefecture","isoCode":"26","countryCode":"JP","latitude":"35.15666090","longitude":"135.52519820"},{"name":"\u014Csaka Prefecture","isoCode":"27","countryCode":"JP","latitude":"34.64133150","longitude":"135.56293940"},{"name":"Hy\u014Dgo Prefecture","isoCode":"28","countryCode":"JP","latitude":"34.85795180","longitude":"134.54537870"},{"name":"Nara Prefecture","isoCode":"29","countryCode":"JP","latitude":"34.29755280","longitude":"135.82797340"},{"name":"Wakayama Prefecture","isoCode":"30","countryCode":"JP","latitude":"33.94809140","longitude":"135.37453580"},{"name":"Tottori Prefecture","isoCode":"31","countryCode":"JP","latitude":"35.35731610","longitude":"133.40666180"},{"name":"Shimane Prefecture","isoCode":"32","countryCode":"JP","latitude":"35.12440940","longitude":"132.62934460"},{"name":"Okayama Prefecture","isoCode":"33","countryCode":"JP","latitude":"34.89634070","longitude":"133.63753140"},{"name":"Hiroshima Prefecture","isoCode":"34","countryCode":"JP","latitude":"34.88234080","longitude":"133.01948970"},{"name":"Yamaguchi Prefecture","isoCode":"35","countryCode":"JP","latitude":"34.27967690","longitude":"131.52127420"},{"name":"Tokushima Prefecture","isoCode":"36","countryCode":"JP","latitude":"33.94196550","longitude":"134.32365570"},{"name":"Kagawa Prefecture","isoCode":"37","countryCode":"JP","latitude":"34.22259150","longitude":"134.01991520"},{"name":"Ehime Prefecture","isoCode":"38","countryCode":"JP","latitude":"33.60253060","longitude":"132.78575830"},{"name":"K\u014Dchi Prefecture","isoCode":"39","countryCode":"JP","latitude":"33.28791610","longitude":"132.27592620"},{"name":"Fukuoka Prefecture","isoCode":"40","countryCode":"JP","latitude":"33.56625590","longitude":"130.71585700"},{"name":"Saga Prefecture","isoCode":"41","countryCode":"JP","latitude":"33.30783710","longitude":"130.22712430"},{"name":"Nagasaki Prefecture","isoCode":"42","countryCode":"JP","latitude":"33.24885250","longitude":"129.69309120"},{"name":"Kumamoto Prefecture","isoCode":"43","countryCode":"JP","latitude":"32.85944270","longitude":"130.79691490"},{"name":"\u014Cita Prefecture","isoCode":"44","countryCode":"JP","latitude":"33.15892990","longitude":"131.36111210"},{"name":"Miyazaki Prefecture","isoCode":"45","countryCode":"JP","latitude":"32.60360220","longitude":"131.44125100"},{"name":"Kagoshima Prefecture","isoCode":"46","countryCode":"JP","latitude":"31.39119580","longitude":"130.87785860"},{"name":"Okinawa Prefecture","isoCode":"47","countryCode":"JP","latitude":"26.12019110","longitude":"127.70250120"},{"name":"Baringo","isoCode":"01","countryCode":"KE","latitude":"0.85549880","longitude":"36.08934060"},{"name":"Bomet","isoCode":"02","countryCode":"KE","latitude":"-0.80150090","longitude":"35.30272260"},{"name":"Bungoma","isoCode":"03","countryCode":"KE","latitude":"0.56952520","longitude":"34.55837660"},{"name":"Busia","isoCode":"04","countryCode":"KE","latitude":"0.43465060","longitude":"34.24215970"},{"name":"Elgeyo-Marakwet","isoCode":"05","countryCode":"KE","latitude":"1.04982370","longitude":"35.47819260"},{"name":"Embu","isoCode":"06","countryCode":"KE","latitude":"-0.65604770","longitude":"37.72376780"},{"name":"Garissa","isoCode":"07","countryCode":"KE","latitude":"-0.45322930","longitude":"39.64609880"},{"name":"Homa Bay","isoCode":"08","countryCode":"KE","latitude":"-0.62206550","longitude":"34.33103640"},{"name":"Isiolo","isoCode":"09","countryCode":"KE","latitude":"0.35243520","longitude":"38.48499230"},{"name":"Kajiado","isoCode":"10","countryCode":"KE","latitude":"-2.09807510","longitude":"36.78195050"},{"name":"Kakamega","isoCode":"11","countryCode":"KE","latitude":"0.30789400","longitude":"34.77407930"},{"name":"Kericho","isoCode":"12","countryCode":"KE","latitude":"-0.18279130","longitude":"35.47819260"},{"name":"Kiambu","isoCode":"13","countryCode":"KE","latitude":"-1.03137010","longitude":"36.86807910"},{"name":"Kilifi","isoCode":"14","countryCode":"KE","latitude":"-3.51065080","longitude":"39.90932690"},{"name":"Kirinyaga","isoCode":"15","countryCode":"KE","latitude":"-0.65905650","longitude":"37.38272340"},{"name":"Kisii","isoCode":"16","countryCode":"KE","latitude":"-0.67733400","longitude":"34.77960300"},{"name":"Kisumu","isoCode":"17","countryCode":"KE","latitude":"-0.09170160","longitude":"34.76795680"},{"name":"Kitui","isoCode":"18","countryCode":"KE","latitude":"-1.68328220","longitude":"38.31657250"},{"name":"Kwale","isoCode":"19","countryCode":"KE","latitude":"-4.18161150","longitude":"39.46056120"},{"name":"Laikipia","isoCode":"20","countryCode":"KE","latitude":"0.36060630","longitude":"36.78195050"},{"name":"Lamu","isoCode":"21","countryCode":"KE","latitude":"-2.23550580","longitude":"40.47200040"},{"name":"Machakos","isoCode":"22","countryCode":"KE","latitude":"-1.51768370","longitude":"37.26341460"},{"name":"Makueni","isoCode":"23","countryCode":"KE","latitude":"-2.25587340","longitude":"37.89366630"},{"name":"Mandera","isoCode":"24","countryCode":"KE","latitude":"3.57379910","longitude":"40.95868800"},{"name":"Marsabit","isoCode":"25","countryCode":"KE","latitude":"2.44264030","longitude":"37.97845850"},{"name":"Meru","isoCode":"26","countryCode":"KE","latitude":"0.35571740","longitude":"37.80876930"},{"name":"Migori","isoCode":"27","countryCode":"KE","latitude":"-0.93657020","longitude":"34.41982430"},{"name":"Mombasa","isoCode":"28","countryCode":"KE","latitude":"-3.97682910","longitude":"39.71371810"},{"name":"Murang\'a","isoCode":"29","countryCode":"KE","latitude":"-0.78392810","longitude":"37.04003390"},{"name":"Nairobi City","isoCode":"30","countryCode":"KE","latitude":"-1.29206590","longitude":"36.82194620"},{"name":"Nakuru","isoCode":"31","countryCode":"KE","latitude":"-0.30309880","longitude":"36.08002600"},{"name":"Nandi","isoCode":"32","countryCode":"KE","latitude":"0.18358670","longitude":"35.12687810"},{"name":"Narok","isoCode":"33","countryCode":"KE","latitude":"-1.10411100","longitude":"36.08934060"},{"name":"Nyamira","isoCode":"34","countryCode":"KE","latitude":"-0.56694050","longitude":"34.93412340"},{"name":"Nyandarua","isoCode":"35","countryCode":"KE","latitude":"-0.18038550","longitude":"36.52296410"},{"name":"Nyeri","isoCode":"36","countryCode":"KE","latitude":"-0.41969150","longitude":"37.04003390"},{"name":"Samburu","isoCode":"37","countryCode":"KE","latitude":"1.21545060","longitude":"36.95410700"},{"name":"Siaya","isoCode":"38","countryCode":"KE","latitude":"-0.06173280","longitude":"34.24215970"},{"name":"Taita\u2013Taveta","isoCode":"39","countryCode":"KE","latitude":"-3.31606870","longitude":"38.48499230"},{"name":"Tana River","isoCode":"40","countryCode":"KE","latitude":"-1.65184680","longitude":"39.65181650"},{"name":"Tharaka-Nithi","isoCode":"41","countryCode":"KE","latitude":"-0.29648510","longitude":"37.72376780"},{"name":"Trans Nzoia","isoCode":"42","countryCode":"KE","latitude":"1.05666670","longitude":"34.95066250"},{"name":"Turkana","isoCode":"43","countryCode":"KE","latitude":"3.31224770","longitude":"35.56578620"},{"name":"Uasin Gishu","isoCode":"44","countryCode":"KE","latitude":"0.55276380","longitude":"35.30272260"},{"name":"Vihiga","isoCode":"45","countryCode":"KE","latitude":"0.07675530","longitude":"34.70776650"},{"name":"Wajir","isoCode":"46","countryCode":"KE","latitude":"1.63604750","longitude":"40.30886260"},{"name":"West Pokot","isoCode":"47","countryCode":"KE","latitude":"1.62100760","longitude":"35.39050460"},{"name":"Batken Region","isoCode":"B","countryCode":"KG","latitude":"39.97214250","longitude":"69.85974060"},{"name":"Chuy Region","isoCode":"C","countryCode":"KG","latitude":"42.56550000","longitude":"74.40566120"},{"name":"Bishkek","isoCode":"GB","countryCode":"KG","latitude":"42.87462120","longitude":"74.56976170"},{"name":"Osh","isoCode":"GO","countryCode":"KG","latitude":"36.06313990","longitude":"-95.91828950"},{"name":"Jalal-Abad Region","isoCode":"J","countryCode":"KG","latitude":"41.10680800","longitude":"72.89880690"},{"name":"Naryn Region","isoCode":"N","countryCode":"KG","latitude":"41.29432270","longitude":"75.34121790"},{"name":"Osh Region","isoCode":"O","countryCode":"KG","latitude":"39.84073660","longitude":"72.89880690"},{"name":"Talas Region","isoCode":"T","countryCode":"KG","latitude":"42.28673390","longitude":"72.52048270"},{"name":"Issyk-Kul Region","isoCode":"Y","countryCode":"KG","latitude":"42.18594280","longitude":"77.56194190"},{"name":"Banteay Meanchey","isoCode":"1","countryCode":"KH","latitude":"13.75319140","longitude":"102.98961500"},{"name":"Kratie","isoCode":"10","countryCode":"KH","latitude":"12.50436080","longitude":"105.96998780"},{"name":"Mondulkiri","isoCode":"11","countryCode":"KH","latitude":"12.78794270","longitude":"107.10119310"},{"name":"Phnom Penh","isoCode":"12","countryCode":"KH","latitude":"11.55637380","longitude":"104.92820990"},{"name":"Preah Vihear","isoCode":"13","countryCode":"KH","latitude":"14.00857970","longitude":"104.84546190"},{"name":"Prey Veng","isoCode":"14","countryCode":"KH","latitude":"11.38024420","longitude":"105.50054830"},{"name":"Pursat","isoCode":"15","countryCode":"KH","latitude":"12.27209560","longitude":"103.72891670"},{"name":"Ratanakiri","isoCode":"16","countryCode":"KH","latitude":"13.85766070","longitude":"107.10119310"},{"name":"Siem Reap","isoCode":"17","countryCode":"KH","latitude":"13.33026600","longitude":"104.10013260"},{"name":"Sihanoukville","isoCode":"18","countryCode":"KH","latitude":"10.75818990","longitude":"103.82162610"},{"name":"Stung Treng","isoCode":"19","countryCode":"KH","latitude":"13.57647300","longitude":"105.96998780"},{"name":"Battambang","isoCode":"2","countryCode":"KH","latitude":"13.02869710","longitude":"102.98961500"},{"name":"Svay Rieng","isoCode":"20","countryCode":"KH","latitude":"11.14272200","longitude":"105.82902980"},{"name":"Takeo","isoCode":"21","countryCode":"KH","latitude":"10.93215190","longitude":"104.79877100"},{"name":"Oddar Meanchey","isoCode":"22","countryCode":"KH","latitude":"14.16097380","longitude":"103.82162610"},{"name":"Kep","isoCode":"23","countryCode":"KH","latitude":"10.53608900","longitude":"104.35591580"},{"name":"Pailin","isoCode":"24","countryCode":"KH","latitude":"12.90929620","longitude":"102.66755750"},{"name":"Kampong Cham","isoCode":"3","countryCode":"KH","latitude":"12.09829180","longitude":"105.31311850"},{"name":"Kampong Chhnang","isoCode":"4","countryCode":"KH","latitude":"12.13923520","longitude":"104.56552730"},{"name":"Kampong Speu","isoCode":"5","countryCode":"KH","latitude":"11.61551090","longitude":"104.37919120"},{"name":"Kampong Thom","isoCode":"6","countryCode":"KH","latitude":"12.81674850","longitude":"103.84131040"},{"name":"Kampot","isoCode":"7","countryCode":"KH","latitude":"10.73253510","longitude":"104.37919120"},{"name":"Kandal","isoCode":"8","countryCode":"KH","latitude":"11.22373830","longitude":"105.12589550"},{"name":"Koh Kong","isoCode":"9","countryCode":"KH","latitude":"11.57628040","longitude":"103.35872880"},{"name":"Tai Po District","isoCode":"NTP","countryCode":"KH","latitude":"22.45085000","longitude":"114.16422000"},{"name":"Gilbert Islands","isoCode":"G","countryCode":"KI","latitude":"0.35242620","longitude":"174.75526340"},{"name":"Line Islands","isoCode":"L","countryCode":"KI","latitude":"1.74294390","longitude":"-157.21328260"},{"name":"Phoenix Islands","isoCode":"P","countryCode":"KI","latitude":"33.32843690","longitude":"-111.98247740"},{"name":"Anjouan","isoCode":"A","countryCode":"KM","latitude":"-12.21381450","longitude":"44.43706060"},{"name":"Grande Comore","isoCode":"G","countryCode":"KM","latitude":"-11.71673380","longitude":"43.36807880"},{"name":"Moh\xe9li","isoCode":"M","countryCode":"KM","latitude":"-12.33773760","longitude":"43.73340890"},{"name":"Christ Church Nichola Town Parish","isoCode":"01","countryCode":"KN","latitude":"17.36048120","longitude":"-62.76178370"},{"name":"Saint Anne Sandy Point Parish","isoCode":"02","countryCode":"KN","latitude":"17.37253330","longitude":"-62.84411330"},{"name":"Saint George Gingerland Parish","isoCode":"04","countryCode":"KN","latitude":"17.12577590","longitude":"-62.56198110"},{"name":"Saint James Windward Parish","isoCode":"05","countryCode":"KN","latitude":"17.17696330","longitude":"-62.57960260"},{"name":"Saint John Capisterre Parish","isoCode":"06","countryCode":"KN","latitude":"17.38103410","longitude":"-62.79118330"},{"name":"Saint John Figtree Parish","isoCode":"07","countryCode":"KN","latitude":"17.11557480","longitude":"-62.60310040"},{"name":"Saint Mary Cayon Parish","isoCode":"08","countryCode":"KN","latitude":"17.34620710","longitude":"-62.73826710"},{"name":"Saint Paul Capisterre Parish","isoCode":"09","countryCode":"KN","latitude":"17.40166830","longitude":"-62.82573320"},{"name":"Saint Paul Charlestown Parish","isoCode":"10","countryCode":"KN","latitude":"17.13462970","longitude":"-62.61338160"},{"name":"Saint Peter Basseterre Parish","isoCode":"11","countryCode":"KN","latitude":"17.31029110","longitude":"-62.71475330"},{"name":"Saint Thomas Lowland Parish","isoCode":"12","countryCode":"KN","latitude":"17.16505130","longitude":"-62.60897530"},{"name":"Saint Thomas Middle Island Parish","isoCode":"13","countryCode":"KN","latitude":"17.33488130","longitude":"-62.80882510"},{"name":"Trinity Palmetto Point Parish","isoCode":"15","countryCode":"KN","latitude":"17.30635190","longitude":"-62.76178370"},{"name":"Saint Kitts","isoCode":"K","countryCode":"KN","latitude":"17.34337960","longitude":"-62.75590430"},{"name":"Nevis","isoCode":"N","countryCode":"KN","latitude":"17.15535580","longitude":"-62.57960260"},{"name":"Pyongyang","isoCode":"01","countryCode":"KP","latitude":"39.03921930","longitude":"125.76252410"},{"name":"South Pyongan Province","isoCode":"02","countryCode":"KP","latitude":"39.35391780","longitude":"126.16827100"},{"name":"North Pyongan Province","isoCode":"03","countryCode":"KP","latitude":"39.92556180","longitude":"125.39280250"},{"name":"Chagang Province","isoCode":"04","countryCode":"KP","latitude":"40.72028090","longitude":"126.56211370"},{"name":"South Hwanghae Province","isoCode":"05","countryCode":"KP","latitude":"38.20072150","longitude":"125.47819260"},{"name":"North Hwanghae Province","isoCode":"06","countryCode":"KP","latitude":"38.37860850","longitude":"126.43643630"},{"name":"Kangwon Province","isoCode":"07","countryCode":"KP","latitude":"38.84323930","longitude":"127.55970670"},{"name":"South Hamgyong Province","isoCode":"08","countryCode":"KP","latitude":"40.37253390","longitude":"128.29888400"},{"name":"North Hamgyong Province","isoCode":"09","countryCode":"KP","latitude":"41.81487580","longitude":"129.45819550"},{"name":"Ryanggang Province","isoCode":"10","countryCode":"KP","latitude":"41.23189210","longitude":"128.50763590"},{"name":"Rason","isoCode":"13","countryCode":"KP","latitude":"42.25690630","longitude":"130.29771860"},{"name":"Seoul","isoCode":"11","countryCode":"KR","latitude":"37.56653500","longitude":"126.97796920"},{"name":"Busan","isoCode":"26","countryCode":"KR","latitude":"35.17955430","longitude":"129.07564160"},{"name":"Daegu","isoCode":"27","countryCode":"KR","latitude":"35.87143540","longitude":"128.60144500"},{"name":"Incheon","isoCode":"28","countryCode":"KR","latitude":"37.45625570","longitude":"126.70520620"},{"name":"Gwangju","isoCode":"29","countryCode":"KR","latitude":"35.15954540","longitude":"126.85260120"},{"name":"Daejeon","isoCode":"30","countryCode":"KR","latitude":"36.35041190","longitude":"127.38454750"},{"name":"Ulsan","isoCode":"31","countryCode":"KR","latitude":"35.53837730","longitude":"129.31135960"},{"name":"Gyeonggi Province","isoCode":"41","countryCode":"KR","latitude":"37.41380000","longitude":"127.51830000"},{"name":"Gangwon Province","isoCode":"42","countryCode":"KR","latitude":"37.82280000","longitude":"128.15550000"},{"name":"North Chungcheong Province","isoCode":"43","countryCode":"KR","latitude":"36.80000000","longitude":"127.70000000"},{"name":"South Chungcheong Province","isoCode":"44","countryCode":"KR","latitude":"36.51840000","longitude":"126.80000000"},{"name":"North Jeolla Province","isoCode":"45","countryCode":"KR","latitude":"35.71750000","longitude":"127.15300000"},{"name":"South Jeolla Province","isoCode":"46","countryCode":"KR","latitude":"34.86790000","longitude":"126.99100000"},{"name":"North Gyeongsang Province","isoCode":"47","countryCode":"KR","latitude":"36.49190000","longitude":"128.88890000"},{"name":"South Gyeongsang Province","isoCode":"48","countryCode":"KR","latitude":"35.46060000","longitude":"128.21320000"},{"name":"Jeju","isoCode":"49","countryCode":"KR","latitude":"33.95682780","longitude":"-84.13135000"},{"name":"Sejong City","isoCode":"50","countryCode":"KR","latitude":"34.05233230","longitude":"-118.30848970"},{"name":"Al Ahmadi Governorate","isoCode":"AH","countryCode":"KW","latitude":"28.57451250","longitude":"48.10247430"},{"name":"Al Farwaniyah Governorate","isoCode":"FA","countryCode":"KW","latitude":"29.27335700","longitude":"47.94001540"},{"name":"Hawalli Governorate","isoCode":"HA","countryCode":"KW","latitude":"29.30567160","longitude":"48.03076130"},{"name":"Al Jahra Governorate","isoCode":"JA","countryCode":"KW","latitude":"29.99318310","longitude":"47.76347310"},{"name":"Capital Governorate","isoCode":"KU","countryCode":"KW","latitude":"26.22851610","longitude":"50.58604970"},{"name":"Mubarak Al-Kabeer Governorate","isoCode":"MU","countryCode":"KW","latitude":"29.21224000","longitude":"48.06051080"},{"name":"Akmola Region","isoCode":"AKM","countryCode":"KZ","latitude":"51.91653200","longitude":"69.41104940"},{"name":"Aktobe Region","isoCode":"AKT","countryCode":"KZ","latitude":"48.77970780","longitude":"57.99743780"},{"name":"Almaty","isoCode":"ALA","countryCode":"KZ","latitude":"43.22201460","longitude":"76.85124850"},{"name":"Almaty Region","isoCode":"ALM","countryCode":"KZ","latitude":"45.01192270","longitude":"78.42293920"},{"name":"Nur-Sultan","isoCode":"AST","countryCode":"KZ","latitude":"51.16052270","longitude":"71.47035580"},{"name":"Atyrau Region","isoCode":"ATY","countryCode":"KZ","latitude":"47.10761880","longitude":"51.91413300"},{"name":"Baikonur","isoCode":"BAY","countryCode":"KZ","latitude":"45.96458510","longitude":"63.30524280"},{"name":"Karaganda Region","isoCode":"KAR","countryCode":"KZ","latitude":"47.90221820","longitude":"71.77068070"},{"name":"Kostanay Region","isoCode":"KUS","countryCode":"KZ","latitude":"51.50770960","longitude":"64.04790730"},{"name":"Kyzylorda Region","isoCode":"KZY","countryCode":"KZ","latitude":"44.69226130","longitude":"62.65718850"},{"name":"Mangystau Region","isoCode":"MAN","countryCode":"KZ","latitude":"44.59080200","longitude":"53.84995080"},{"name":"Pavlodar Region","isoCode":"PAV","countryCode":"KZ","latitude":"52.28784440","longitude":"76.97334530"},{"name":"North Kazakhstan Region","isoCode":"SEV","countryCode":"KZ","latitude":"54.16220660","longitude":"69.93870710"},{"name":"East Kazakhstan Region","isoCode":"VOS","countryCode":"KZ","latitude":"48.70626870","longitude":"80.79225340"},{"name":"Turkestan Region","isoCode":"YUZ","countryCode":"KZ","latitude":"43.36669580","longitude":"68.40944050"},{"name":"West Kazakhstan Province","isoCode":"ZAP","countryCode":"KZ","latitude":"49.56797270","longitude":"50.80666160"},{"name":"Jambyl Region","isoCode":"ZHA","countryCode":"KZ","latitude":"44.22203080","longitude":"72.36579670"},{"name":"Attapeu Province","isoCode":"AT","countryCode":"LA","latitude":"14.93634000","longitude":"107.10119310"},{"name":"Bokeo Province","isoCode":"BK","countryCode":"LA","latitude":"20.28726620","longitude":"100.70978670"},{"name":"Bolikhamsai Province","isoCode":"BL","countryCode":"LA","latitude":"18.43629240","longitude":"104.47233010"},{"name":"Champasak Province","isoCode":"CH","countryCode":"LA","latitude":"14.65786640","longitude":"105.96998780"},{"name":"Houaphanh Province","isoCode":"HO","countryCode":"LA","latitude":"20.32541750","longitude":"104.10013260"},{"name":"Khammouane Province","isoCode":"KH","countryCode":"LA","latitude":"17.63840660","longitude":"105.21948080"},{"name":"Luang Namtha Province","isoCode":"LM","countryCode":"LA","latitude":"20.91701870","longitude":"101.16173560"},{"name":"Luang Prabang Province","isoCode":"LP","countryCode":"LA","latitude":"20.06562290","longitude":"102.62162110"},{"name":"Oudomxay Province","isoCode":"OU","countryCode":"LA","latitude":"20.49219290","longitude":"101.88917210"},{"name":"Phongsaly Province","isoCode":"PH","countryCode":"LA","latitude":"21.59193770","longitude":"102.25479190"},{"name":"Salavan Province","isoCode":"SL","countryCode":"LA","latitude":"15.81710730","longitude":"106.25221430"},{"name":"Savannakhet Province","isoCode":"SV","countryCode":"LA","latitude":"16.50653810","longitude":"105.59433880"},{"name":"Vientiane Province","isoCode":"VI","countryCode":"LA","latitude":"18.57050630","longitude":"102.62162110"},{"name":"Vientiane Prefecture","isoCode":"VT","countryCode":"LA","latitude":"18.11054100","longitude":"102.52980280"},{"name":"Sainyabuli Province","isoCode":"XA","countryCode":"LA","latitude":"19.39078860","longitude":"101.52480550"},{"name":"Sekong Province","isoCode":"XE","countryCode":"LA","latitude":"15.57674460","longitude":"107.00670310"},{"name":"Xiangkhouang Province","isoCode":"XI","countryCode":"LA","latitude":"19.60930030","longitude":"103.72891670"},{"name":"Xaisomboun","isoCode":"XN","countryCode":"LA","latitude":null,"longitude":null},{"name":"Xaisomboun Province","isoCode":"XS","countryCode":"LA","latitude":"18.43629240","longitude":"104.47233010"},{"name":"Akkar Governorate","isoCode":"AK","countryCode":"LB","latitude":"34.53287630","longitude":"36.13281320"},{"name":"North Governorate","isoCode":"AS","countryCode":"LB","latitude":"34.43806250","longitude":"35.83082330"},{"name":"Beirut Governorate","isoCode":"BA","countryCode":"LB","latitude":"33.88861060","longitude":"35.49547720"},{"name":"Baalbek-Hermel Governorate","isoCode":"BH","countryCode":"LB","latitude":"34.26585560","longitude":"36.34980970"},{"name":"Beqaa Governorate","isoCode":"BI","countryCode":"LB","latitude":"33.84626620","longitude":"35.90194890"},{"name":"South Governorate","isoCode":"JA","countryCode":"LB","latitude":"33.27214790","longitude":"35.20327780"},{"name":"Mount Lebanon Governorate","isoCode":"JL","countryCode":"LB","latitude":"33.81008580","longitude":"35.59731390"},{"name":"Nabatieh Governorate","isoCode":"NA","countryCode":"LB","latitude":"33.37716930","longitude":"35.48382930"},{"name":"Anse la Raye Quarter","isoCode":"01","countryCode":"LC","latitude":"13.94594240","longitude":"-61.03694680"},{"name":"Castries Quarter","isoCode":"02","countryCode":"LC","latitude":"14.01010940","longitude":"-60.98746870"},{"name":"Choiseul Quarter","isoCode":"03","countryCode":"LC","latitude":"13.77501540","longitude":"-61.04859100"},{"name":"Dauphin Quarter","isoCode":"04","countryCode":"LC","latitude":"14.01033960","longitude":"-60.91909880"},{"name":"Dennery Quarter","isoCode":"05","countryCode":"LC","latitude":"13.92673930","longitude":"-60.91909880"},{"name":"Gros Islet Quarter","isoCode":"06","countryCode":"LC","latitude":"14.08435780","longitude":"-60.94527940"},{"name":"Laborie Quarter","isoCode":"07","countryCode":"LC","latitude":"13.75227830","longitude":"-60.99328890"},{"name":"Micoud Quarter","isoCode":"08","countryCode":"LC","latitude":"13.82118710","longitude":"-60.90019340"},{"name":"Praslin Quarter","isoCode":"09","countryCode":"LC","latitude":"13.87523920","longitude":"-60.89946630"},{"name":"Soufri\xe8re Quarter","isoCode":"10","countryCode":"LC","latitude":"13.85709860","longitude":"-61.05732480"},{"name":"Vieux Fort Quarter","isoCode":"11","countryCode":"LC","latitude":"13.72060800","longitude":"-60.94964330"},{"name":"Canaries","isoCode":"12","countryCode":"LC","latitude":"28.29156370","longitude":"-16.62913040"},{"name":"Balzers","isoCode":"01","countryCode":"LI","latitude":"42.05283570","longitude":"-88.03668480"},{"name":"Eschen","isoCode":"02","countryCode":"LI","latitude":"40.76695740","longitude":"-73.95228210"},{"name":"Gamprin","isoCode":"03","countryCode":"LI","latitude":"47.21324900","longitude":"9.50251950"},{"name":"Mauren","isoCode":"04","countryCode":"LI","latitude":"47.21892850","longitude":"9.54173500"},{"name":"Planken","isoCode":"05","countryCode":"LI","latitude":"40.66505760","longitude":"-73.50479800"},{"name":"Ruggell","isoCode":"06","countryCode":"LI","latitude":"47.25292220","longitude":"9.54021270"},{"name":"Schaan","isoCode":"07","countryCode":"LI","latitude":"47.12043400","longitude":"9.59416020"},{"name":"Schellenberg","isoCode":"08","countryCode":"LI","latitude":"47.23096600","longitude":"9.54678430"},{"name":"Triesen","isoCode":"09","countryCode":"LI","latitude":"47.10979880","longitude":"9.52482960"},{"name":"Triesenberg","isoCode":"10","countryCode":"LI","latitude":"47.12245110","longitude":"9.57019850"},{"name":"Vaduz","isoCode":"11","countryCode":"LI","latitude":"47.14103030","longitude":"9.52092770"},{"name":"Western Province","isoCode":"1","countryCode":"LK","latitude":null,"longitude":null},{"name":"Colombo District","isoCode":"11","countryCode":"LK","latitude":"6.92695570","longitude":"79.86173060"},{"name":"Gampaha District","isoCode":"12","countryCode":"LK","latitude":"7.07126190","longitude":"80.00877460"},{"name":"Kalutara District","isoCode":"13","countryCode":"LK","latitude":"6.60846860","longitude":"80.14285840"},{"name":"Central Province","isoCode":"2","countryCode":"LK","latitude":null,"longitude":null},{"name":"Kandy District","isoCode":"21","countryCode":"LK","latitude":"7.29315880","longitude":"80.63501070"},{"name":"Matale District","isoCode":"22","countryCode":"LK","latitude":"7.46596460","longitude":"80.62342590"},{"name":"Nuwara Eliya District","isoCode":"23","countryCode":"LK","latitude":"6.96065320","longitude":"80.76927580"},{"name":"Southern Province","isoCode":"3","countryCode":"LK","latitude":null,"longitude":null},{"name":"Galle District","isoCode":"31","countryCode":"LK","latitude":"6.05774900","longitude":"80.21755720"},{"name":"Matara District","isoCode":"32","countryCode":"LK","latitude":"5.94493480","longitude":"80.54879970"},{"name":"Hambantota District","isoCode":"33","countryCode":"LK","latitude":"6.15358160","longitude":"81.12714900"},{"name":"Northern Province","isoCode":"4","countryCode":"LK","latitude":null,"longitude":null},{"name":"Jaffna District","isoCode":"41","countryCode":"LK","latitude":"9.69304680","longitude":"80.16518540"},{"name":"Kilinochchi District","isoCode":"42","countryCode":"LK","latitude":"9.36779710","longitude":"80.32131060"},{"name":"Mannar District","isoCode":"43","countryCode":"LK","latitude":"8.98095310","longitude":"79.90439750"},{"name":"Vavuniya District","isoCode":"44","countryCode":"LK","latitude":"8.75947390","longitude":"80.50003340"},{"name":"Mullaitivu District","isoCode":"45","countryCode":"LK","latitude":"9.26753880","longitude":"80.81282540"},{"name":"Eastern Province","isoCode":"5","countryCode":"LK","latitude":null,"longitude":null},{"name":"Batticaloa District","isoCode":"51","countryCode":"LK","latitude":"7.82927810","longitude":"81.47183870"},{"name":"Ampara District","isoCode":"52","countryCode":"LK","latitude":"7.29116850","longitude":"81.67237610"},{"name":"Trincomalee District","isoCode":"53","countryCode":"LK","latitude":"8.60130690","longitude":"81.11960750"},{"name":"North Western Province","isoCode":"6","countryCode":"LK","latitude":"7.75840910","longitude":"80.18750650"},{"name":"Puttalam District","isoCode":"62","countryCode":"LK","latitude":"8.02599150","longitude":"79.84712720"},{"name":"North Central Province","isoCode":"7","countryCode":"LK","latitude":"8.19956380","longitude":"80.63269160"},{"name":"Anuradhapura District","isoCode":"71","countryCode":"LK","latitude":"8.33183050","longitude":"80.40290170"},{"name":"Polonnaruwa District","isoCode":"72","countryCode":"LK","latitude":"7.93955670","longitude":"81.00034030"},{"name":"Uva Province","isoCode":"8","countryCode":"LK","latitude":"6.84276120","longitude":"81.33994140"},{"name":"Badulla District","isoCode":"81","countryCode":"LK","latitude":"6.99340090","longitude":"81.05498150"},{"name":"Monaragala District","isoCode":"82","countryCode":"LK","latitude":"6.87277810","longitude":"81.35068320"},{"name":"Sabaragamuwa Province","isoCode":"9","countryCode":"LK","latitude":"6.73959410","longitude":"80.36586500"},{"name":"Ratnapura district","isoCode":"91","countryCode":"LK","latitude":"6.70551680","longitude":"80.38483890"},{"name":"Kegalle District","isoCode":"92","countryCode":"LK","latitude":"7.12040530","longitude":"80.32131060"},{"name":"Bong County","isoCode":"BG","countryCode":"LR","latitude":"6.82950190","longitude":"-9.36730840"},{"name":"Bomi County","isoCode":"BM","countryCode":"LR","latitude":"6.75629260","longitude":"-10.84514670"},{"name":"Grand Cape Mount County","isoCode":"CM","countryCode":"LR","latitude":"7.04677580","longitude":"-11.07117580"},{"name":"Grand Bassa County","isoCode":"GB","countryCode":"LR","latitude":"6.23084520","longitude":"-9.81249350"},{"name":"Grand Gedeh County","isoCode":"GG","countryCode":"LR","latitude":"5.92220780","longitude":"-8.22129790"},{"name":"Grand Kru County","isoCode":"GK","countryCode":"LR","latitude":"4.76138620","longitude":"-8.22129790"},{"name":"Gbarpolu County","isoCode":"GP","countryCode":"LR","latitude":"7.49526370","longitude":"-10.08072980"},{"name":"Lofa County","isoCode":"LO","countryCode":"LR","latitude":"8.19111840","longitude":"-9.72326730"},{"name":"Margibi County","isoCode":"MG","countryCode":"LR","latitude":"6.51518750","longitude":"-10.30488970"},{"name":"Montserrado County","isoCode":"MO","countryCode":"LR","latitude":"6.55258150","longitude":"-10.52961150"},{"name":"Maryland County","isoCode":"MY","countryCode":"LR","latitude":"39.04575490","longitude":"-76.64127120"},{"name":"Nimba","isoCode":"NI","countryCode":"LR","latitude":"7.61666670","longitude":"-8.41666670"},{"name":"River Gee County","isoCode":"RG","countryCode":"LR","latitude":"5.26048940","longitude":"-7.87216000"},{"name":"River Cess County","isoCode":"RI","countryCode":"LR","latitude":"5.90253280","longitude":"-9.45615500"},{"name":"Sinoe County","isoCode":"SI","countryCode":"LR","latitude":"5.49871000","longitude":"-8.66005860"},{"name":"Maseru District","isoCode":"A","countryCode":"LS","latitude":"-29.51656500","longitude":"27.83114280"},{"name":"Butha-Buthe District","isoCode":"B","countryCode":"LS","latitude":"-28.76537540","longitude":"28.24681480"},{"name":"Leribe District","isoCode":"C","countryCode":"LS","latitude":"-28.86380650","longitude":"28.04788260"},{"name":"Berea District","isoCode":"D","countryCode":"LS","latitude":"41.36616140","longitude":"-81.85430260"},{"name":"Mafeteng District","isoCode":"E","countryCode":"LS","latitude":"-29.80410080","longitude":"27.50261740"},{"name":"Mohale\'s Hoek District","isoCode":"F","countryCode":"LS","latitude":"-30.14259170","longitude":"27.46738450"},{"name":"Quthing District","isoCode":"G","countryCode":"LS","latitude":"-30.40156870","longitude":"27.70801330"},{"name":"Qacha\'s Nek District","isoCode":"H","countryCode":"LS","latitude":"-30.11145650","longitude":"28.67897900"},{"name":"Mokhotlong District","isoCode":"J","countryCode":"LS","latitude":"-29.25731930","longitude":"28.95286450"},{"name":"Thaba-Tseka District","isoCode":"K","countryCode":"LS","latitude":"-29.52389750","longitude":"28.60897520"},{"name":"Akmen\u0117 District Municipality","isoCode":"01","countryCode":"LT","latitude":"56.24550290","longitude":"22.74711690"},{"name":"Alytus City Municipality","isoCode":"02","countryCode":"LT","latitude":"54.39629380","longitude":"24.04587610"},{"name":"Alytus District Municipality","isoCode":"03","countryCode":"LT","latitude":"54.32974960","longitude":"24.19609310"},{"name":"Bir\u0161tonas Municipality","isoCode":"05","countryCode":"LT","latitude":"54.56696640","longitude":"24.00930980"},{"name":"Bir\u017Eai District Municipality","isoCode":"06","countryCode":"LT","latitude":"56.20177190","longitude":"24.75601180"},{"name":"Druskininkai municipality","isoCode":"07","countryCode":"LT","latitude":"53.99336850","longitude":"24.03424380"},{"name":"Elektr\u0117nai municipality","isoCode":"08","countryCode":"LT","latitude":"54.76539340","longitude":"24.77405830"},{"name":"Ignalina District Municipality","isoCode":"09","countryCode":"LT","latitude":"55.40903420","longitude":"26.32848930"},{"name":"Jonava District Municipality","isoCode":"10","countryCode":"LT","latitude":"55.07272420","longitude":"24.27933370"},{"name":"Joni\u0161kis District Municipality","isoCode":"11","countryCode":"LT","latitude":"56.23607300","longitude":"23.61365790"},{"name":"Jurbarkas District Municipality","isoCode":"12","countryCode":"LT","latitude":"55.07740700","longitude":"22.74195690"},{"name":"Kai\u0161iadorys District Municipality","isoCode":"13","countryCode":"LT","latitude":"54.85886690","longitude":"24.42779290"},{"name":"Kalvarija municipality","isoCode":"14","countryCode":"LT","latitude":"54.37616740","longitude":"23.19203210"},{"name":"Kaunas City Municipality","isoCode":"15","countryCode":"LT","latitude":"54.91453260","longitude":"23.90535180"},{"name":"Kaunas District Municipality","isoCode":"16","countryCode":"LT","latitude":"54.99362360","longitude":"23.63249410"},{"name":"Kazl\u0173 R\u016Bda municipality","isoCode":"17","countryCode":"LT","latitude":"54.78075260","longitude":"23.48402430"},{"name":"K\u0117dainiai District Municipality","isoCode":"18","countryCode":"LT","latitude":"55.35609470","longitude":"23.98326830"},{"name":"Kelm\u0117 District Municipality","isoCode":"19","countryCode":"LT","latitude":"55.62663520","longitude":"22.87817200"},{"name":"Klaipeda City Municipality","isoCode":"20","countryCode":"LT","latitude":"55.70329480","longitude":"21.14427950"},{"name":"Klaip\u0117da District Municipality","isoCode":"21","countryCode":"LT","latitude":"55.68416150","longitude":"21.44164640"},{"name":"Kretinga District Municipality","isoCode":"22","countryCode":"LT","latitude":"55.88384200","longitude":"21.23509190"},{"name":"Kupi\u0161kis District Municipality","isoCode":"23","countryCode":"LT","latitude":"55.84287410","longitude":"25.02958160"},{"name":"Lazdijai District Municipality","isoCode":"24","countryCode":"LT","latitude":"54.23432670","longitude":"23.51565050"},{"name":"Marijampol\u0117 Municipality","isoCode":"25","countryCode":"LT","latitude":"54.57110940","longitude":"23.48593710"},{"name":"Ma\u017Eeikiai District Municipality","isoCode":"26","countryCode":"LT","latitude":"56.30924390","longitude":"22.34146800"},{"name":"Mol\u0117tai District Municipality","isoCode":"27","countryCode":"LT","latitude":"55.22653090","longitude":"25.41800110"},{"name":"Neringa Municipality","isoCode":"28","countryCode":"LT","latitude":"55.45724030","longitude":"21.08390050"},{"name":"Pag\u0117giai municipality","isoCode":"29","countryCode":"LT","latitude":"55.17213200","longitude":"21.96836140"},{"name":"Pakruojis District Municipality","isoCode":"30","countryCode":"LT","latitude":"56.07326050","longitude":"23.93899060"},{"name":"Palanga City Municipality","isoCode":"31","countryCode":"LT","latitude":"55.92019800","longitude":"21.06776140"},{"name":"Panev\u0117\u017Eys City Municipality","isoCode":"32","countryCode":"LT","latitude":"55.73479150","longitude":"24.35747740"},{"name":"Panev\u0117\u017Eys District Municipality","isoCode":"33","countryCode":"LT","latitude":"55.61667280","longitude":"24.31422830"},{"name":"Pasvalys District Municipality","isoCode":"34","countryCode":"LT","latitude":"56.06046190","longitude":"24.39629100"},{"name":"Plung\u0117 District Municipality","isoCode":"35","countryCode":"LT","latitude":"55.91078400","longitude":"21.84540690"},{"name":"Prienai District Municipality","isoCode":"36","countryCode":"LT","latitude":"54.63835800","longitude":"23.94680090"},{"name":"Radvili\u0161kis District Municipality","isoCode":"37","countryCode":"LT","latitude":"55.81083990","longitude":"23.54648700"},{"name":"Raseiniai District Municipality","isoCode":"38","countryCode":"LT","latitude":"55.38194990","longitude":"23.11561290"},{"name":"Rietavas municipality","isoCode":"39","countryCode":"LT","latitude":"55.70217190","longitude":"21.99865640"},{"name":"Roki\u0161kis District Municipality","isoCode":"40","countryCode":"LT","latitude":"55.95550390","longitude":"25.58592490"},{"name":"\u0160akiai District Municipality","isoCode":"41","countryCode":"LT","latitude":"54.95267100","longitude":"23.04801990"},{"name":"\u0160al\u010Dininkai District Municipality","isoCode":"42","countryCode":"LT","latitude":"54.30976700","longitude":"25.38756400"},{"name":"\u0160iauliai City Municipality","isoCode":"43","countryCode":"LT","latitude":"55.93490850","longitude":"23.31368230"},{"name":"\u0160iauliai District Municipality","isoCode":"44","countryCode":"LT","latitude":"55.97214560","longitude":"23.03323710"},{"name":"\u0160ilal\u0117 District Municipality","isoCode":"45","countryCode":"LT","latitude":"55.49268000","longitude":"22.18455590"},{"name":"\u0160ilut\u0117 District Municipality","isoCode":"46","countryCode":"LT","latitude":"55.35041400","longitude":"21.46598590"},{"name":"\u0160irvintos District Municipality","isoCode":"47","countryCode":"LT","latitude":"55.04310200","longitude":"24.95698100"},{"name":"Skuodas District Municipality","isoCode":"48","countryCode":"LT","latitude":"56.27021690","longitude":"21.52143310"},{"name":"\u0160ven\u010Dionys District Municipality","isoCode":"49","countryCode":"LT","latitude":"55.10280980","longitude":"26.00718550"},{"name":"Taurag\u0117 District Municipality","isoCode":"50","countryCode":"LT","latitude":"55.25036600","longitude":"22.29095000"},{"name":"Tel\u0161iai District Municipality","isoCode":"51","countryCode":"LT","latitude":"55.91752150","longitude":"22.34518400"},{"name":"Trakai District Municipality","isoCode":"52","countryCode":"LT","latitude":"54.63791130","longitude":"24.93468940"},{"name":"Ukmerg\u0117 District Municipality","isoCode":"53","countryCode":"LT","latitude":"55.24526500","longitude":"24.77607490"},{"name":"Utena District Municipality","isoCode":"54","countryCode":"LT","latitude":"55.50846140","longitude":"25.68326420"},{"name":"Var\u0117na District Municipality","isoCode":"55","countryCode":"LT","latitude":"54.22033300","longitude":"24.57899700"},{"name":"Vilkavi\u0161kis District Municipality","isoCode":"56","countryCode":"LT","latitude":"54.65194500","longitude":"23.03515500"},{"name":"Vilnius City Municipality","isoCode":"57","countryCode":"LT","latitude":"54.67107610","longitude":"25.28787210"},{"name":"Vilnius District Municipality","isoCode":"58","countryCode":"LT","latitude":"54.77325780","longitude":"25.58671130"},{"name":"Visaginas Municipality","isoCode":"59","countryCode":"LT","latitude":"55.59411800","longitude":"26.43079540"},{"name":"Zarasai District Municipality","isoCode":"60","countryCode":"LT","latitude":"55.73096090","longitude":"26.24529500"},{"name":"Alytus County","isoCode":"AL","countryCode":"LT","latitude":"54.20002140","longitude":"24.15126340"},{"name":"Klaip\u0117da County","isoCode":"KL","countryCode":"LT","latitude":"55.65197440","longitude":"21.37439560"},{"name":"Kaunas County","isoCode":"KU","countryCode":"LT","latitude":"54.98728630","longitude":"23.95257360"},{"name":"Marijampol\u0117 County","isoCode":"MR","countryCode":"LT","latitude":"54.78199710","longitude":"23.13413650"},{"name":"Panev\u0117\u017Eys County","isoCode":"PN","countryCode":"LT","latitude":"55.97480490","longitude":"25.07947670"},{"name":"\u0160iauliai County","isoCode":"SA","countryCode":"LT","latitude":"55.99857510","longitude":"23.13800510"},{"name":"Taurag\u0117 County","isoCode":"TA","countryCode":"LT","latitude":"55.30725860","longitude":"22.35729390"},{"name":"Tel\u0161iai County","isoCode":"TE","countryCode":"LT","latitude":"56.10266160","longitude":"22.11139150"},{"name":"Utena County","isoCode":"UT","countryCode":"LT","latitude":"55.53189690","longitude":"25.79046990"},{"name":"Vilnius County","isoCode":"VL","countryCode":"LT","latitude":"54.80865020","longitude":"25.21821390"},{"name":"Canton of Capellen","isoCode":"CA","countryCode":"LU","latitude":"49.64039310","longitude":"5.95538460"},{"name":"Canton of Clervaux","isoCode":"CL","countryCode":"LU","latitude":"50.05463130","longitude":"6.02858750"},{"name":"Diekirch District","isoCode":"D","countryCode":"LU","latitude":"49.86717200","longitude":"6.15963620"},{"name":"Canton of Diekirch","isoCode":"DI","countryCode":"LU","latitude":"49.86717840","longitude":"6.15956330"},{"name":"Canton of Echternach","isoCode":"EC","countryCode":"LU","latitude":"49.81141330","longitude":"6.41756350"},{"name":"Canton of Esch-sur-Alzette","isoCode":"ES","countryCode":"LU","latitude":"49.50088050","longitude":"5.98609250"},{"name":"Grevenmacher District","isoCode":"G","countryCode":"LU","latitude":"49.68085100","longitude":"6.44075240"},{"name":"Canton of Grevenmacher","isoCode":"GR","countryCode":"LU","latitude":"49.68084100","longitude":"6.44075930"},{"name":"Luxembourg District","isoCode":"L","countryCode":"LU","latitude":"49.59537060","longitude":"6.13331780"},{"name":"Canton of Luxembourg","isoCode":"LU","countryCode":"LU","latitude":"49.63010250","longitude":"6.15201850"},{"name":"Canton of Mersch","isoCode":"ME","countryCode":"LU","latitude":"49.75429060","longitude":"6.12921850"},{"name":"Canton of Redange","isoCode":"RD","countryCode":"LU","latitude":"49.76455000","longitude":"5.88948000"},{"name":"Canton of Remich","isoCode":"RM","countryCode":"LU","latitude":"49.54501700","longitude":"6.36742220"},{"name":"Canton of Vianden","isoCode":"VD","countryCode":"LU","latitude":"49.93419240","longitude":"6.20199170"},{"name":"Canton of Wiltz","isoCode":"WI","countryCode":"LU","latitude":"49.96622000","longitude":"5.93243060"},{"name":"Aglona Municipality","isoCode":"001","countryCode":"LV","latitude":"56.10890060","longitude":"27.12862270"},{"name":"Aizkraukle Municipality","isoCode":"002","countryCode":"LV","latitude":"56.64610800","longitude":"25.23708540"},{"name":"Aizpute Municipality","isoCode":"003","countryCode":"LV","latitude":"56.71825960","longitude":"21.60727590"},{"name":"Akn\u012Bste Municipality","isoCode":"004","countryCode":"LV","latitude":"56.16130370","longitude":"25.74848270"},{"name":"Aloja Municipality","isoCode":"005","countryCode":"LV","latitude":"57.76713600","longitude":"24.87708390"},{"name":"Alsunga Municipality","isoCode":"006","countryCode":"LV","latitude":"56.98285310","longitude":"21.55559190"},{"name":"Al\u016Bksne Municipality","isoCode":"007","countryCode":"LV","latitude":"57.42544850","longitude":"27.04249680"},{"name":"Amata Municipality","isoCode":"008","countryCode":"LV","latitude":"56.99387260","longitude":"25.26276750"},{"name":"Ape Municipality","isoCode":"009","countryCode":"LV","latitude":"57.53926970","longitude":"26.69416490"},{"name":"Auce Municipality","isoCode":"010","countryCode":"LV","latitude":"56.46016800","longitude":"22.90547810"},{"name":"Bab\u012Bte Municipality","isoCode":"012","countryCode":"LV","latitude":"56.95415500","longitude":"23.94539900"},{"name":"Baldone Municipality","isoCode":"013","countryCode":"LV","latitude":"56.74246000","longitude":"24.39115440"},{"name":"Baltinava Municipality","isoCode":"014","countryCode":"LV","latitude":"56.94584680","longitude":"27.64410660"},{"name":"Balvi Municipality","isoCode":"015","countryCode":"LV","latitude":"57.13262400","longitude":"27.26466850"},{"name":"Bauska Municipality","isoCode":"016","countryCode":"LV","latitude":"56.41018680","longitude":"24.20006890"},{"name":"Bever\u012Bna Municipality","isoCode":"017","countryCode":"LV","latitude":"57.51971090","longitude":"25.60736540"},{"name":"Broc\u0113ni Municipality","isoCode":"018","countryCode":"LV","latitude":"56.73475410","longitude":"22.63573710"},{"name":"Burtnieki Municipality","isoCode":"019","countryCode":"LV","latitude":"57.69490040","longitude":"25.27647770"},{"name":"Carnikava Municipality","isoCode":"020","countryCode":"LV","latitude":"57.10241210","longitude":"24.21086620"},{"name":"Cesvaine Municipality","isoCode":"021","countryCode":"LV","latitude":"56.96792640","longitude":"26.30831720"},{"name":"C\u0113sis Municipality","isoCode":"022","countryCode":"LV","latitude":"57.31028970","longitude":"25.26761250"},{"name":"Cibla Municipality","isoCode":"023","countryCode":"LV","latitude":"56.61023440","longitude":"27.86965980"},{"name":"Dagda Municipality","isoCode":"024","countryCode":"LV","latitude":"56.09560890","longitude":"27.53245900"},{"name":"Daugavpils Municipality","isoCode":"025","countryCode":"LV","latitude":"55.89917830","longitude":"26.61020120"},{"name":"Dobele Municipality","isoCode":"026","countryCode":"LV","latitude":"56.62630500","longitude":"23.28090660"},{"name":"Dundaga Municipality","isoCode":"027","countryCode":"LV","latitude":"57.50491670","longitude":"22.35051140"},{"name":"Durbe Municipality","isoCode":"028","countryCode":"LV","latitude":"56.62798570","longitude":"21.49162450"},{"name":"Engure Municipality","isoCode":"029","countryCode":"LV","latitude":"57.16235000","longitude":"23.21966340"},{"name":"\u0112rg\u013Ci Municipality","isoCode":"030","countryCode":"LV","latitude":"56.92370650","longitude":"25.67538520"},{"name":"Garkalne Municipality","isoCode":"031","countryCode":"LV","latitude":"57.01903870","longitude":"24.38261810"},{"name":"Grobi\u0146a Municipality","isoCode":"032","countryCode":"LV","latitude":"56.53963200","longitude":"21.16689200"},{"name":"Gulbene Municipality","isoCode":"033","countryCode":"LV","latitude":"57.21556450","longitude":"26.64529550"},{"name":"Iecava Municipality","isoCode":"034","countryCode":"LV","latitude":"56.59867930","longitude":"24.19962720"},{"name":"Ik\u0161\u0137ile Municipality","isoCode":"035","countryCode":"LV","latitude":"56.83736670","longitude":"24.49747450"},{"name":"Il\u016Bkste Municipality","isoCode":"036","countryCode":"LV","latitude":"55.97825470","longitude":"26.29650880"},{"name":"In\u010Dukalns Municipality","isoCode":"037","countryCode":"LV","latitude":"57.09943420","longitude":"24.68555700"},{"name":"Jaunjelgava Municipality","isoCode":"038","countryCode":"LV","latitude":"56.52836590","longitude":"25.39214430"},{"name":"Jaunpiebalga Municipality","isoCode":"039","countryCode":"LV","latitude":"57.14334710","longitude":"25.99518880"},{"name":"Jaunpils Municipality","isoCode":"040","countryCode":"LV","latitude":"56.73141940","longitude":"23.01256160"},{"name":"Jelgava Municipality","isoCode":"041","countryCode":"LV","latitude":"56.58956890","longitude":"23.66104810"},{"name":"J\u0113kabpils Municipality","isoCode":"042","countryCode":"LV","latitude":"56.29193200","longitude":"25.98120170"},{"name":"Kandava Municipality","isoCode":"043","countryCode":"LV","latitude":"57.03406730","longitude":"22.78018130"},{"name":"K\u0101rsava Municipality","isoCode":"044","countryCode":"LV","latitude":"56.76458420","longitude":"27.73582950"},{"name":"Koc\u0113ni Municipality","isoCode":"045","countryCode":"LV","latitude":"57.52262920","longitude":"25.33495070"},{"name":"Koknese Municipality","isoCode":"046","countryCode":"LV","latitude":"56.72055600","longitude":"25.48939090"},{"name":"Kr\u0101slava Municipality","isoCode":"047","countryCode":"LV","latitude":"55.89514640","longitude":"27.18145770"},{"name":"Krimulda Municipality","isoCode":"048","countryCode":"LV","latitude":"57.17912730","longitude":"24.71401270"},{"name":"Krustpils Municipality","isoCode":"049","countryCode":"LV","latitude":"56.54155780","longitude":"26.24463970"},{"name":"Kuld\u012Bga Municipality","isoCode":"050","countryCode":"LV","latitude":"56.96872570","longitude":"21.96137390"},{"name":"\u0136egums Municipality","isoCode":"051","countryCode":"LV","latitude":"56.74753570","longitude":"24.71736450"},{"name":"\u0136ekava Municipality","isoCode":"052","countryCode":"LV","latitude":"56.80643510","longitude":"24.19394930"},{"name":"Lielv\u0101rde Municipality","isoCode":"053","countryCode":"LV","latitude":"56.73929760","longitude":"24.97116180"},{"name":"Limba\u017Ei Municipality","isoCode":"054","countryCode":"LV","latitude":"57.54032270","longitude":"24.71344510"},{"name":"L\u012Bgatne Municipality","isoCode":"055","countryCode":"LV","latitude":"57.19442040","longitude":"25.09406810"},{"name":"L\u012Bv\u0101ni Municipality","isoCode":"056","countryCode":"LV","latitude":"56.35509420","longitude":"26.17251900"},{"name":"Lub\u0101na Municipality","isoCode":"057","countryCode":"LV","latitude":"56.89992690","longitude":"26.71987890"},{"name":"Ludza Municipality","isoCode":"058","countryCode":"LV","latitude":"56.54595900","longitude":"27.71431990"},{"name":"Madona Municipality","isoCode":"059","countryCode":"LV","latitude":"56.85989230","longitude":"26.22762010"},{"name":"Mazsalaca Municipality","isoCode":"060","countryCode":"LV","latitude":"57.92677490","longitude":"25.06698950"},{"name":"M\u0101lpils Municipality","isoCode":"061","countryCode":"LV","latitude":"57.00841190","longitude":"24.95742780"},{"name":"M\u0101rupe Municipality","isoCode":"062","countryCode":"LV","latitude":"56.89657170","longitude":"24.04600490"},{"name":"M\u0113rsrags Municipality","isoCode":"063","countryCode":"LV","latitude":"57.33068810","longitude":"23.10237070"},{"name":"Nauk\u0161\u0113ni Municipality","isoCode":"064","countryCode":"LV","latitude":"57.92953610","longitude":"25.51192660"},{"name":"Nereta Municipality","isoCode":"065","countryCode":"LV","latitude":"56.19866550","longitude":"25.32529690"},{"name":"N\u012Bca Municipality","isoCode":"066","countryCode":"LV","latitude":"56.34649830","longitude":"21.06549300"},{"name":"Ogre Municipality","isoCode":"067","countryCode":"LV","latitude":"56.81473550","longitude":"24.60445550"},{"name":"Olaine Municipality","isoCode":"068","countryCode":"LV","latitude":"56.79523530","longitude":"24.01535890"},{"name":"Ozolnieki Municipality","isoCode":"069","countryCode":"LV","latitude":"56.67563050","longitude":"23.89948160"},{"name":"P\u0101rgauja Municipality","isoCode":"070","countryCode":"LV","latitude":"57.36481220","longitude":"24.98220450"},{"name":"P\u0101vilosta Municipality","isoCode":"071","countryCode":"LV","latitude":"56.88654240","longitude":"21.19468490"},{"name":"P\u013Cavi\u0146as Municipality","isoCode":"072","countryCode":"LV","latitude":"56.61773130","longitude":"25.71940430"},{"name":"Prei\u013Ci Municipality","isoCode":"073","countryCode":"LV","latitude":"56.15111570","longitude":"26.74397670"},{"name":"Priekule Municipality","isoCode":"074","countryCode":"LV","latitude":"56.41794130","longitude":"21.55033360"},{"name":"Prieku\u013Ci Municipality","isoCode":"075","countryCode":"LV","latitude":"57.36171380","longitude":"25.44104230"},{"name":"Rauna Municipality","isoCode":"076","countryCode":"LV","latitude":"57.33169300","longitude":"25.61003390"},{"name":"R\u0113zekne Municipality","isoCode":"077","countryCode":"LV","latitude":"56.32736380","longitude":"27.32843310"},{"name":"Riebi\u0146i Municipality","isoCode":"078","countryCode":"LV","latitude":"56.34361900","longitude":"26.80181380"},{"name":"Roja Municipality","isoCode":"079","countryCode":"LV","latitude":"57.50467130","longitude":"22.80121640"},{"name":"Ropa\u017Ei Municipality","isoCode":"080","countryCode":"LV","latitude":"56.96157860","longitude":"24.60104760"},{"name":"Rucava Municipality","isoCode":"081","countryCode":"LV","latitude":"56.15931240","longitude":"21.16181210"},{"name":"Rug\u0101ji Municipality","isoCode":"082","countryCode":"LV","latitude":"57.00560230","longitude":"27.13172030"},{"name":"Rund\u0101le Municipality","isoCode":"083","countryCode":"LV","latitude":"56.40972100","longitude":"24.01241390"},{"name":"R\u016Bjiena Municipality","isoCode":"084","countryCode":"LV","latitude":"57.89372910","longitude":"25.33910080"},{"name":"Sala Municipality","isoCode":"085","countryCode":"LV","latitude":"59.96796130","longitude":"16.49782170"},{"name":"Salacgr\u012Bva Municipality","isoCode":"086","countryCode":"LV","latitude":"57.75808830","longitude":"24.35431810"},{"name":"Salaspils Municipality","isoCode":"087","countryCode":"LV","latitude":"56.86081520","longitude":"24.34978810"},{"name":"Saldus Municipality","isoCode":"088","countryCode":"LV","latitude":"56.66650880","longitude":"22.49354930"},{"name":"Saulkrasti Municipality","isoCode":"089","countryCode":"LV","latitude":"57.25794180","longitude":"24.41831460"},{"name":"S\u0113ja Municipality","isoCode":"090","countryCode":"LV","latitude":"57.20069950","longitude":"24.59228210"},{"name":"Sigulda Municipality","isoCode":"091","countryCode":"LV","latitude":"57.10550920","longitude":"24.83142590"},{"name":"Skr\u012Bveri Municipality","isoCode":"092","countryCode":"LV","latitude":"56.67613910","longitude":"25.09788490"},{"name":"Skrunda Municipality","isoCode":"093","countryCode":"LV","latitude":"56.66434580","longitude":"22.00457290"},{"name":"Smiltene Municipality","isoCode":"094","countryCode":"LV","latitude":"57.42303320","longitude":"25.90027800"},{"name":"Stopi\u0146i Municipality","isoCode":"095","countryCode":"LV","latitude":"56.93644900","longitude":"24.28729490"},{"name":"Stren\u010Di Municipality","isoCode":"096","countryCode":"LV","latitude":"57.62254710","longitude":"25.80480860"},{"name":"Talsi Municipality","isoCode":"097","countryCode":"LV","latitude":"57.34152080","longitude":"22.57131250"},{"name":"T\u0113rvete Municipality","isoCode":"098","countryCode":"LV","latitude":"56.41192010","longitude":"23.31883320"},{"name":"Tukums Municipality","isoCode":"099","countryCode":"LV","latitude":"56.96728680","longitude":"23.15243790"},{"name":"Vai\u0146ode Municipality","isoCode":"100","countryCode":"LV","latitude":"56.41542710","longitude":"21.85139840"},{"name":"Valka Municipality","isoCode":"101","countryCode":"LV","latitude":"57.77439000","longitude":"26.01700500"},{"name":"Varak\u013C\u0101ni Municipality","isoCode":"102","countryCode":"LV","latitude":"56.66880060","longitude":"26.56364140"},{"name":"V\u0101rkava Municipality","isoCode":"103","countryCode":"LV","latitude":"56.24657440","longitude":"26.56643710"},{"name":"Vecpiebalga Municipality","isoCode":"104","countryCode":"LV","latitude":"57.06033560","longitude":"25.81615920"},{"name":"Vecumnieki Municipality","isoCode":"105","countryCode":"LV","latitude":"56.60623370","longitude":"24.52218910"},{"name":"Ventspils Municipality","isoCode":"106","countryCode":"LV","latitude":"57.28336820","longitude":"21.85875580"},{"name":"Vies\u012Bte Municipality","isoCode":"107","countryCode":"LV","latitude":"56.31130850","longitude":"25.50704640"},{"name":"Vi\u013Caka Municipality","isoCode":"108","countryCode":"LV","latitude":"57.17222630","longitude":"27.66731880"},{"name":"Vi\u013C\u0101ni Municipality","isoCode":"109","countryCode":"LV","latitude":"56.54561710","longitude":"26.91679270"},{"name":"Zilupe Municipality","isoCode":"110","countryCode":"LV","latitude":"56.30189850","longitude":"28.13395900"},{"name":"Daugavpils","isoCode":"DGV","countryCode":"LV","latitude":"55.87473600","longitude":"26.53617900"},{"name":"Jelgava","isoCode":"JEL","countryCode":"LV","latitude":"56.65110910","longitude":"23.72135410"},{"name":"J\u0113kabpils","isoCode":"JKB","countryCode":"LV","latitude":"56.50145500","longitude":"25.87829900"},{"name":"J\u016Brmala","isoCode":"JUR","countryCode":"LV","latitude":"56.94707900","longitude":"23.61684850"},{"name":"Liep\u0101ja","isoCode":"LPX","countryCode":"LV","latitude":"56.50466780","longitude":"21.01080600"},{"name":"R\u0113zekne","isoCode":"REZ","countryCode":"LV","latitude":"56.50992230","longitude":"27.33313570"},{"name":"Riga","isoCode":"RIX","countryCode":"LV","latitude":"56.94964870","longitude":"24.10518650"},{"name":"Ventspils","isoCode":"VEN","countryCode":"LV","latitude":"57.39372160","longitude":"21.56470660"},{"name":"Valmiera","isoCode":"VMR","countryCode":"LV","latitude":"57.53846590","longitude":"25.42636180"},{"name":"Benghazi","isoCode":"BA","countryCode":"LY","latitude":"32.11942420","longitude":"20.08679090"},{"name":"Derna District","isoCode":"DR","countryCode":"LY","latitude":"32.75561300","longitude":"22.63774320"},{"name":"Ghat District","isoCode":"GT","countryCode":"LY","latitude":"24.96403710","longitude":"10.17592850"},{"name":"Jabal al Akhdar","isoCode":"JA","countryCode":"LY","latitude":"23.18560810","longitude":"57.37138790"},{"name":"Jabal al Gharbi District","isoCode":"JG","countryCode":"LY","latitude":"30.26380320","longitude":"12.80547530"},{"name":"Jafara","isoCode":"JI","countryCode":"LY","latitude":"32.45259040","longitude":"12.94355360"},{"name":"Jufra","isoCode":"JU","countryCode":"LY","latitude":"27.98351350","longitude":"16.91225100"},{"name":"Kufra District","isoCode":"KF","countryCode":"LY","latitude":"23.31123890","longitude":"21.85685860"},{"name":"Murqub","isoCode":"MB","countryCode":"LY","latitude":"32.45996770","longitude":"14.10013260"},{"name":"Misrata District","isoCode":"MI","countryCode":"LY","latitude":"32.32558840","longitude":"15.09925560"},{"name":"Marj District","isoCode":"MJ","countryCode":"LY","latitude":"32.05503630","longitude":"21.18911510"},{"name":"Murzuq District","isoCode":"MQ","countryCode":"LY","latitude":"25.91822620","longitude":"13.92600010"},{"name":"Nalut District","isoCode":"NL","countryCode":"LY","latitude":"31.87423480","longitude":"10.97504840"},{"name":"Nuqat al Khams","isoCode":"NQ","countryCode":"LY","latitude":"32.69149090","longitude":"11.88917210"},{"name":"Sabha District","isoCode":"SB","countryCode":"LY","latitude":"27.03654060","longitude":"14.42902360"},{"name":"Sirte District","isoCode":"SR","countryCode":"LY","latitude":"31.18968900","longitude":"16.57019270"},{"name":"Tripoli District","isoCode":"TB","countryCode":"LY","latitude":"32.64080210","longitude":"13.26634790"},{"name":"Al Wahat District","isoCode":"WA","countryCode":"LY","latitude":"29.04668080","longitude":"21.85685860"},{"name":"Wadi al Hayaa District","isoCode":"WD","countryCode":"LY","latitude":"26.42259260","longitude":"12.62162110"},{"name":"Wadi al Shatii District","isoCode":"WS","countryCode":"LY","latitude":"27.73514680","longitude":"12.43805810"},{"name":"Zawiya District","isoCode":"ZA","countryCode":"LY","latitude":"32.76302820","longitude":"12.73649620"},{"name":"Tanger-T\xe9touan-Al Hoce\xefma","isoCode":"01","countryCode":"MA","latitude":"35.26295580","longitude":"-5.56172790"},{"name":"L\'Oriental","isoCode":"02","countryCode":"MA","latitude":"37.06968300","longitude":"-94.51227700"},{"name":"F\xe8s-Mekn\xe8s","isoCode":"03","countryCode":"MA","latitude":"34.06252900","longitude":"-4.72775280"},{"name":"Rabat-Sal\xe9-K\xe9nitra","isoCode":"04","countryCode":"MA","latitude":"34.07686400","longitude":"-7.34544760"},{"name":"B\xe9ni Mellal-Kh\xe9nifra","isoCode":"05","countryCode":"MA","latitude":"32.57191840","longitude":"-6.06791940"},{"name":"Casablanca-Settat","isoCode":"06","countryCode":"MA","latitude":"33.21608720","longitude":"-7.43813550"},{"name":"Marrakesh-Safi","isoCode":"07","countryCode":"MA","latitude":"31.73308330","longitude":"-8.13385580"},{"name":"Dr\xe2a-Tafilalet","isoCode":"08","countryCode":"MA","latitude":"31.14995380","longitude":"-5.39395510"},{"name":"Souss-Massa","isoCode":"09","countryCode":"MA","latitude":"30.27506110","longitude":"-8.13385580"},{"name":"Guelmim-Oued Noun (EH-partial)","isoCode":"10","countryCode":"MA","latitude":"28.48442810","longitude":"-10.08072980"},{"name":"La\xe2youne-Sakia El Hamra (EH-partial)","isoCode":"11","countryCode":"MA","latitude":"27.86831940","longitude":"-11.98046130"},{"name":"Dakhla-Oued Ed-Dahab (EH)","isoCode":"12","countryCode":"MA","latitude":"22.73378920","longitude":"-14.28611160"},{"name":"Agadir-Ida-Ou-Tanane","isoCode":"AGD","countryCode":"MA","latitude":"30.64620910","longitude":"-9.83390610"},{"name":"Aousserd (EH)","isoCode":"AOU","countryCode":"MA","latitude":"22.55215380","longitude":"-14.32973530"},{"name":"Assa-Zag (EH-partial)","isoCode":"ASZ","countryCode":"MA","latitude":"28.14023950","longitude":"-9.72326730"},{"name":"Azilal","isoCode":"AZI","countryCode":"MA","latitude":"32.00426200","longitude":"-6.57833870"},{"name":"B\xe9ni Mellal","isoCode":"BEM","countryCode":"MA","latitude":"32.34244300","longitude":"-6.37579900"},{"name":"Berkane","isoCode":"BER","countryCode":"MA","latitude":"34.88408760","longitude":"-2.34188700"},{"name":"Benslimane","isoCode":"BES","countryCode":"MA","latitude":"33.61896980","longitude":"-7.13055360"},{"name":"Boujdour (EH)","isoCode":"BOD","countryCode":"MA","latitude":"26.12524930","longitude":"-14.48473470"},{"name":"Boulemane","isoCode":"BOM","countryCode":"MA","latitude":"33.36251590","longitude":"-4.73033970"},{"name":"Berrechid","isoCode":"BRR","countryCode":"MA","latitude":"33.26025230","longitude":"-7.59848370"},{"name":"Casablanca","isoCode":"CAS","countryCode":"MA","latitude":"33.57226780","longitude":"-7.65703260"},{"name":"Chefchaouen","isoCode":"CHE","countryCode":"MA","latitude":"35.01817200","longitude":"-5.14320680"},{"name":"Chichaoua","isoCode":"CHI","countryCode":"MA","latitude":"31.53835810","longitude":"-8.76463880"},{"name":"Chtouka-Ait Baha","isoCode":"CHT","countryCode":"MA","latitude":"30.10724220","longitude":"-9.27855830"},{"name":"Driouch","isoCode":"DRI","countryCode":"MA","latitude":"34.97603200","longitude":"-3.39644930"},{"name":"Errachidia","isoCode":"ERR","countryCode":"MA","latitude":"31.90512750","longitude":"-4.72775280"},{"name":"Essaouira","isoCode":"ESI","countryCode":"MA","latitude":"31.50849260","longitude":"-9.75950410"},{"name":"Es-Semara (EH-partial)","isoCode":"ESM","countryCode":"MA","latitude":"26.74185600","longitude":"-11.67836710"},{"name":"Fahs-Anjra","isoCode":"FAH","countryCode":"MA","latitude":"35.76019920","longitude":"-5.66683060"},{"name":"F\xe8s","isoCode":"FES","countryCode":"MA","latitude":"34.02395790","longitude":"-5.03675990"},{"name":"Figuig","isoCode":"FIG","countryCode":"MA","latitude":"32.10926130","longitude":"-1.22980600"},{"name":"Fquih Ben Salah","isoCode":"FQH","countryCode":"MA","latitude":"32.50016800","longitude":"-6.71007170"},{"name":"Guelmim","isoCode":"GUE","countryCode":"MA","latitude":"28.98836590","longitude":"-10.05274980"},{"name":"Guercif","isoCode":"GUF","countryCode":"MA","latitude":"34.23450360","longitude":"-3.38130050"},{"name":"El Hajeb","isoCode":"HAJ","countryCode":"MA","latitude":"33.68573500","longitude":"-5.36778440"},{"name":"Al Haouz","isoCode":"HAO","countryCode":"MA","latitude":"31.29567290","longitude":"-7.87216000"},{"name":"Al Hoce\xefma","isoCode":"HOC","countryCode":"MA","latitude":"35.24455890","longitude":"-3.93174680"},{"name":"Ifrane","isoCode":"IFR","countryCode":"MA","latitude":"33.52280620","longitude":"-5.11095520"},{"name":"Inezgane-Ait Melloul","isoCode":"INE","countryCode":"MA","latitude":"30.35090980","longitude":"-9.38951100"},{"name":"El Jadida","isoCode":"JDI","countryCode":"MA","latitude":"33.23163260","longitude":"-8.50071160"},{"name":"Jerada","isoCode":"JRA","countryCode":"MA","latitude":"34.30617910","longitude":"-2.17941360"},{"name":"K\xe9nitra","isoCode":"KEN","countryCode":"MA","latitude":"34.25405030","longitude":"-6.58901660"},{"name":"El Kel\xe2a des Sraghna","isoCode":"KES","countryCode":"MA","latitude":"32.05227670","longitude":"-7.35165580"},{"name":"Kh\xe9misset","isoCode":"KHE","countryCode":"MA","latitude":"33.81537040","longitude":"-6.05733020"},{"name":"Kh\xe9nifra","isoCode":"KHN","countryCode":"MA","latitude":"32.93404710","longitude":"-5.66157100"},{"name":"Khouribga","isoCode":"KHO","countryCode":"MA","latitude":"32.88602300","longitude":"-6.92086550"},{"name":"La\xe2youne (EH)","isoCode":"LAA","countryCode":"MA","latitude":"27.15003840","longitude":"-13.19907580"},{"name":"Larache","isoCode":"LAR","countryCode":"MA","latitude":"35.17442710","longitude":"-6.14739640"},{"name":"Marrakech","isoCode":"MAR","countryCode":"MA","latitude":"31.63460230","longitude":"-8.07789320"},{"name":"M\u2019diq-Fnideq","isoCode":"MDF","countryCode":"MA","latitude":"35.77330190","longitude":"-5.51433000"},{"name":"M\xe9diouna","isoCode":"MED","countryCode":"MA","latitude":"33.45409390","longitude":"-7.51660200"},{"name":"Mekn\xe8s","isoCode":"MEK","countryCode":"MA","latitude":"33.88100000","longitude":"-5.57303970"},{"name":"Midelt","isoCode":"MID","countryCode":"MA","latitude":"32.68550790","longitude":"-4.75017090"},{"name":"Mohammadia","isoCode":"MOH","countryCode":"MA","latitude":"33.68737490","longitude":"-7.42391420"},{"name":"Moulay Yacoub","isoCode":"MOU","countryCode":"MA","latitude":"34.08744790","longitude":"-5.17840190"},{"name":"Nador","isoCode":"NAD","countryCode":"MA","latitude":"34.91719260","longitude":"-2.85771050"},{"name":"Nouaceur","isoCode":"NOU","countryCode":"MA","latitude":"33.36703930","longitude":"-7.57325370"},{"name":"Ouarzazate","isoCode":"OUA","countryCode":"MA","latitude":"30.93354360","longitude":"-6.93701600"},{"name":"Oued Ed-Dahab (EH)","isoCode":"OUD","countryCode":"MA","latitude":"22.73378920","longitude":"-14.28611160"},{"name":"Oujda-Angad","isoCode":"OUJ","countryCode":"MA","latitude":"34.68375040","longitude":"-2.29932390"},{"name":"Ouezzane","isoCode":"OUZ","countryCode":"MA","latitude":"34.80634500","longitude":"-5.59145050"},{"name":"Rabat","isoCode":"RAB","countryCode":"MA","latitude":"33.96919900","longitude":"-6.92730290"},{"name":"Rehamna","isoCode":"REH","countryCode":"MA","latitude":"32.20329050","longitude":"-8.56896710"},{"name":"Safi","isoCode":"SAF","countryCode":"MA","latitude":"32.29898720","longitude":"-9.10134980"},{"name":"Sal\xe9","isoCode":"SAL","countryCode":"MA","latitude":"34.03775700","longitude":"-6.84270730"},{"name":"Sefrou","isoCode":"SEF","countryCode":"MA","latitude":"33.83052440","longitude":"-4.83531540"},{"name":"Settat","isoCode":"SET","countryCode":"MA","latitude":"32.99242420","longitude":"-7.62226650"},{"name":"Sidi Bennour","isoCode":"SIB","countryCode":"MA","latitude":"32.64926020","longitude":"-8.44714530"},{"name":"Sidi Ifni","isoCode":"SIF","countryCode":"MA","latitude":"29.36657970","longitude":"-10.21084850"},{"name":"Sidi Kacem","isoCode":"SIK","countryCode":"MA","latitude":"34.22601720","longitude":"-5.71291640"},{"name":"Sidi Slimane","isoCode":"SIL","countryCode":"MA","latitude":"34.27378280","longitude":"-5.98059720"},{"name":"Skhirate-T\xe9mara","isoCode":"SKH","countryCode":"MA","latitude":"33.76224250","longitude":"-7.04190520"},{"name":"Tarfaya (EH-partial)","isoCode":"TAF","countryCode":"MA","latitude":"27.93777010","longitude":"-12.92940630"},{"name":"Taourirt","isoCode":"TAI","countryCode":"MA","latitude":"34.21259800","longitude":"-2.69838680"},{"name":"Taounate","isoCode":"TAO","countryCode":"MA","latitude":"34.53691700","longitude":"-4.63986930"},{"name":"Taroudannt","isoCode":"TAR","countryCode":"MA","latitude":"30.47271260","longitude":"-8.87487650"},{"name":"Tata","isoCode":"TAT","countryCode":"MA","latitude":"29.75087700","longitude":"-7.97563430"},{"name":"Taza","isoCode":"TAZ","countryCode":"MA","latitude":"34.27889530","longitude":"-3.58126920"},{"name":"T\xe9touan","isoCode":"TET","countryCode":"MA","latitude":"35.58889950","longitude":"-5.36255160"},{"name":"Tinghir","isoCode":"TIN","countryCode":"MA","latitude":"31.48507940","longitude":"-6.20192980"},{"name":"Tiznit","isoCode":"TIZ","countryCode":"MA","latitude":"29.69339200","longitude":"-9.73215700"},{"name":"Tanger-Assilah","isoCode":"TNG","countryCode":"MA","latitude":"35.76325390","longitude":"-5.90450980"},{"name":"Tan-Tan (EH-partial)","isoCode":"TNT","countryCode":"MA","latitude":"28.03012000","longitude":"-11.16173560"},{"name":"Youssoufia","isoCode":"YUS","countryCode":"MA","latitude":"32.02006790","longitude":"-8.86926480"},{"name":"Zagora","isoCode":"ZAG","countryCode":"MA","latitude":"30.57860930","longitude":"-5.89871390"},{"name":"La Colle","isoCode":"CL","countryCode":"MC","latitude":"43.73274650","longitude":"7.41372760"},{"name":"La Condamine","isoCode":"CO","countryCode":"MC","latitude":"43.73506650","longitude":"7.41990600"},{"name":"Moneghetti","isoCode":"MG","countryCode":"MC","latitude":"43.73649270","longitude":"7.41533830"},{"name":"Anenii Noi District","isoCode":"AN","countryCode":"MD","latitude":"46.87956630","longitude":"29.23121750"},{"name":"B\u0103l\u021Bi Municipality","isoCode":"BA","countryCode":"MD","latitude":"47.75399470","longitude":"27.91841480"},{"name":"Bender Municipality","isoCode":"BD","countryCode":"MD","latitude":"46.82275510","longitude":"29.46201010"},{"name":"Briceni District","isoCode":"BR","countryCode":"MD","latitude":"48.36320220","longitude":"27.07503980"},{"name":"Basarabeasca District","isoCode":"BS","countryCode":"MD","latitude":"46.42370600","longitude":"28.89354920"},{"name":"Cahul District","isoCode":"CA","countryCode":"MD","latitude":"45.89394040","longitude":"28.18902750"},{"name":"C\u0103l\u0103ra\u0219i District","isoCode":"CL","countryCode":"MD","latitude":"47.28694600","longitude":"28.27453100"},{"name":"Cimi\u0219lia District","isoCode":"CM","countryCode":"MD","latitude":"46.52508510","longitude":"28.77218350"},{"name":"Criuleni District","isoCode":"CR","countryCode":"MD","latitude":"47.21361140","longitude":"29.15575190"},{"name":"C\u0103u\u0219eni District","isoCode":"CS","countryCode":"MD","latitude":"46.65547150","longitude":"29.40912220"},{"name":"Cantemir District","isoCode":"CT","countryCode":"MD","latitude":"46.27717420","longitude":"28.20096530"},{"name":"Chi\u0219in\u0103u Municipality","isoCode":"CU","countryCode":"MD","latitude":"47.01045290","longitude":"28.86381020"},{"name":"Dondu\u0219eni District","isoCode":"DO","countryCode":"MD","latitude":"48.23383050","longitude":"27.59980870"},{"name":"Drochia District","isoCode":"DR","countryCode":"MD","latitude":"48.07977880","longitude":"27.86041140"},{"name":"Dub\u0103sari District","isoCode":"DU","countryCode":"MD","latitude":"47.26439420","longitude":"29.15503480"},{"name":"Edine\u021B District","isoCode":"ED","countryCode":"MD","latitude":"48.16789910","longitude":"27.29361430"},{"name":"F\u0103le\u0219ti District","isoCode":"FA","countryCode":"MD","latitude":"47.56477250","longitude":"27.72655930"},{"name":"Flore\u0219ti District","isoCode":"FL","countryCode":"MD","latitude":"47.86678490","longitude":"28.33918640"},{"name":"Gagauzia","isoCode":"GA","countryCode":"MD","latitude":"46.09794350","longitude":"28.63846450"},{"name":"Glodeni District","isoCode":"GL","countryCode":"MD","latitude":"47.77901560","longitude":"27.51680100"},{"name":"H\xeence\u0219ti District","isoCode":"HI","countryCode":"MD","latitude":"46.82811470","longitude":"28.58508890"},{"name":"Ialoveni District","isoCode":"IA","countryCode":"MD","latitude":"46.86308600","longitude":"28.82342180"},{"name":"Nisporeni District","isoCode":"NI","countryCode":"MD","latitude":"47.07513490","longitude":"28.17681550"},{"name":"Ocni\u021Ba District","isoCode":"OC","countryCode":"MD","latitude":"48.41104350","longitude":"27.47680920"},{"name":"Orhei District","isoCode":"OR","countryCode":"MD","latitude":"47.38604000","longitude":"28.83030820"},{"name":"Rezina District","isoCode":"RE","countryCode":"MD","latitude":"47.71804470","longitude":"28.88710240"},{"name":"R\xee\u0219cani District","isoCode":"RI","countryCode":"MD","latitude":"47.90701530","longitude":"27.53749960"},{"name":"\u0218old\u0103ne\u0219ti District","isoCode":"SD","countryCode":"MD","latitude":"47.81473890","longitude":"28.78895860"},{"name":"S\xeengerei District","isoCode":"SI","countryCode":"MD","latitude":"47.63891340","longitude":"28.13718160"},{"name":"Transnistria autonomous territorial unit","isoCode":"SN","countryCode":"MD","latitude":"47.21529720","longitude":"29.46380540"},{"name":"Soroca District","isoCode":"SO","countryCode":"MD","latitude":"48.15497430","longitude":"28.28707830"},{"name":"Str\u0103\u0219eni District","isoCode":"ST","countryCode":"MD","latitude":"47.14502670","longitude":"28.61367360"},{"name":"\u0218tefan Vod\u0103 District","isoCode":"SV","countryCode":"MD","latitude":"46.55404880","longitude":"29.70224200"},{"name":"Taraclia District","isoCode":"TA","countryCode":"MD","latitude":"45.89865100","longitude":"28.66716440"},{"name":"Telene\u0219ti District","isoCode":"TE","countryCode":"MD","latitude":"47.49839620","longitude":"28.36760190"},{"name":"Ungheni District","isoCode":"UN","countryCode":"MD","latitude":"47.23057670","longitude":"27.78926610"},{"name":"Andrijevica Municipality","isoCode":"01","countryCode":"ME","latitude":"42.73624770","longitude":"19.78595560"},{"name":"Bar Municipality","isoCode":"02","countryCode":"ME","latitude":"42.12781190","longitude":"19.14043800"},{"name":"Berane Municipality","isoCode":"03","countryCode":"ME","latitude":"42.82572890","longitude":"19.90205090"},{"name":"Bijelo Polje Municipality","isoCode":"04","countryCode":"ME","latitude":"43.08465260","longitude":"19.71154720"},{"name":"Budva Municipality","isoCode":"05","countryCode":"ME","latitude":"42.31407200","longitude":"18.83138320"},{"name":"Old Royal Capital Cetinje","isoCode":"06","countryCode":"ME","latitude":"42.39309590","longitude":"18.91159640"},{"name":"Danilovgrad Municipality","isoCode":"07","countryCode":"ME","latitude":"42.58357000","longitude":"19.14043800"},{"name":"Kola\u0161in Municipality","isoCode":"09","countryCode":"ME","latitude":"42.76019160","longitude":"19.42591140"},{"name":"Kotor Municipality","isoCode":"10","countryCode":"ME","latitude":"42.57402610","longitude":"18.64131450"},{"name":"Mojkovac Municipality","isoCode":"11","countryCode":"ME","latitude":"42.96880180","longitude":"19.52110630"},{"name":"Nik\u0161i\u0107 Municipality","isoCode":"12","countryCode":"ME","latitude":"42.79971840","longitude":"18.76009630"},{"name":"Plav Municipality","isoCode":"13","countryCode":"ME","latitude":"42.60013370","longitude":"19.94075410"},{"name":"Pljevlja Municipality","isoCode":"14","countryCode":"ME","latitude":"43.27233830","longitude":"19.28315310"},{"name":"Plu\u017Eine Municipality","isoCode":"15","countryCode":"ME","latitude":"43.15933840","longitude":"18.85514840"},{"name":"Podgorica Municipality","isoCode":"16","countryCode":"ME","latitude":"42.36938340","longitude":"19.28315310"},{"name":"Ro\u017Eaje Municipality","isoCode":"17","countryCode":"ME","latitude":"42.84083890","longitude":"20.16706280"},{"name":"\u0160avnik Municipality","isoCode":"18","countryCode":"ME","latitude":"42.96037560","longitude":"19.14043800"},{"name":"Tivat Municipality","isoCode":"19","countryCode":"ME","latitude":"42.42348000","longitude":"18.71851840"},{"name":"Ulcinj Municipality","isoCode":"20","countryCode":"ME","latitude":"41.96527950","longitude":"19.30694320"},{"name":"\u017Dabljak Municipality","isoCode":"21","countryCode":"ME","latitude":"43.15551520","longitude":"19.12260180"},{"name":"Gusinje Municipality","isoCode":"22","countryCode":"ME","latitude":"42.55634550","longitude":"19.83060510"},{"name":"Petnjica Municipality","isoCode":"23","countryCode":"ME","latitude":"42.93534800","longitude":"20.02114490"},{"name":"Toamasina Province","isoCode":"A","countryCode":"MG","latitude":"-18.14428110","longitude":"49.39578360"},{"name":"Antsiranana Province","isoCode":"D","countryCode":"MG","latitude":"-13.77153900","longitude":"49.52799960"},{"name":"Fianarantsoa Province","isoCode":"F","countryCode":"MG","latitude":"-22.35362400","longitude":"46.82528380"},{"name":"Mahajanga Province","isoCode":"M","countryCode":"MG","latitude":"-16.52388300","longitude":"46.51626200"},{"name":"Antananarivo Province","isoCode":"T","countryCode":"MG","latitude":"-18.70514740","longitude":"46.82528380"},{"name":"Toliara Province","isoCode":"U","countryCode":"MG","latitude":"-23.35161910","longitude":"43.68549360"},{"name":"Ralik Chain","isoCode":"L","countryCode":"MH","latitude":"8.13614600","longitude":"164.88679560"},{"name":"Ratak Chain","isoCode":"T","countryCode":"MH","latitude":"10.27632760","longitude":"170.55009370"},{"name":"Aerodrom Municipality","isoCode":"01","countryCode":"MK","latitude":"41.94643630","longitude":"21.49317130"},{"name":"Ara\u010Dinovo Municipality","isoCode":"02","countryCode":"MK","latitude":"42.02473810","longitude":"21.57664070"},{"name":"Berovo Municipality","isoCode":"03","countryCode":"MK","latitude":"41.66619290","longitude":"22.76288300"},{"name":"Bitola Municipality","isoCode":"04","countryCode":"MK","latitude":"41.03633020","longitude":"21.33219740"},{"name":"Bogdanci Municipality","isoCode":"05","countryCode":"MK","latitude":"41.18696160","longitude":"22.59602680"},{"name":"Bogovinje Municipality","isoCode":"06","countryCode":"MK","latitude":"41.92363710","longitude":"20.91638870"},{"name":"Bosilovo Municipality","isoCode":"07","countryCode":"MK","latitude":"41.49048640","longitude":"22.78671740"},{"name":"Brvenica Municipality","isoCode":"08","countryCode":"MK","latitude":"41.96814820","longitude":"20.98195860"},{"name":"Butel Municipality","isoCode":"09","countryCode":"MK","latitude":"42.08950680","longitude":"21.46336100"},{"name":"Valandovo Municipality","isoCode":"10","countryCode":"MK","latitude":"41.32119090","longitude":"22.50066930"},{"name":"Vasilevo Municipality","isoCode":"11","countryCode":"MK","latitude":"41.47416990","longitude":"22.64221280"},{"name":"Vev\u010Dani Municipality","isoCode":"12","countryCode":"MK","latitude":"41.24075430","longitude":"20.59156490"},{"name":"Veles Municipality","isoCode":"13","countryCode":"MK","latitude":"41.72744260","longitude":"21.71376940"},{"name":"Vinica Municipality","isoCode":"14","countryCode":"MK","latitude":"41.85710200","longitude":"22.57218810"},{"name":"Vrane\u0161tica Municipality","isoCode":"15","countryCode":"MK","latitude":"41.48290870","longitude":"21.05796320"},{"name":"Vrap\u010Di\u0161te Municipality","isoCode":"16","countryCode":"MK","latitude":"41.87911600","longitude":"20.83145000"},{"name":"Gazi Baba Municipality","isoCode":"17","countryCode":"MK","latitude":"42.01629610","longitude":"21.49913340"},{"name":"Gevgelija Municipality","isoCode":"18","countryCode":"MK","latitude":"41.21186060","longitude":"22.38146240"},{"name":"Gostivar Municipality","isoCode":"19","countryCode":"MK","latitude":"41.80255410","longitude":"20.90893780"},{"name":"Gradsko Municipality","isoCode":"20","countryCode":"MK","latitude":"41.59916080","longitude":"21.88070640"},{"name":"Debarca Municipality","isoCode":"22","countryCode":"MK","latitude":"41.35840770","longitude":"20.85529190"},{"name":"Del\u010Devo Municipality","isoCode":"23","countryCode":"MK","latitude":"41.96843870","longitude":"22.76288300"},{"name":"Demir Kapija Municipality","isoCode":"24","countryCode":"MK","latitude":"41.37955380","longitude":"22.21455710"},{"name":"Demir Hisar Municipality","isoCode":"25","countryCode":"MK","latitude":"41.22708300","longitude":"21.14142260"},{"name":"Dojran Municipality","isoCode":"26","countryCode":"MK","latitude":"41.24366720","longitude":"22.69137640"},{"name":"Dolneni Municipality","isoCode":"27","countryCode":"MK","latitude":"41.46409350","longitude":"21.40374070"},{"name":"Drugovo Municipality","isoCode":"28","countryCode":"MK","latitude":"41.44081530","longitude":"20.92682010"},{"name":"Gjor\u010De Petrov Municipality","isoCode":"29","countryCode":"MK","latitude":"42.06063740","longitude":"21.32027360"},{"name":"\u017Delino Municipality","isoCode":"30","countryCode":"MK","latitude":"41.90065310","longitude":"21.11757670"},{"name":"Zajas Municipality","isoCode":"31","countryCode":"MK","latitude":"41.60303280","longitude":"20.87913430"},{"name":"Zelenikovo Municipality","isoCode":"32","countryCode":"MK","latitude":"41.87338120","longitude":"21.60272500"},{"name":"Zrnovci Municipality","isoCode":"33","countryCode":"MK","latitude":"41.82282210","longitude":"22.41722560"},{"name":"Ilinden Municipality","isoCode":"34","countryCode":"MK","latitude":"41.99574430","longitude":"21.56769750"},{"name":"Jegunovce Municipality","isoCode":"35","countryCode":"MK","latitude":"42.07407200","longitude":"21.12204780"},{"name":"Kavadarci Municipality","isoCode":"36","countryCode":"MK","latitude":"41.28900680","longitude":"21.99994350"},{"name":"Karbinci","isoCode":"37","countryCode":"MK","latitude":"41.81801590","longitude":"22.23247580"},{"name":"Karpo\u0161 Municipality","isoCode":"38","countryCode":"MK","latitude":"41.97096610","longitude":"21.39181680"},{"name":"Kisela Voda Municipality","isoCode":"39","countryCode":"MK","latitude":"41.92748000","longitude":"21.49317130"},{"name":"Ki\u010Devo Municipality","isoCode":"40","countryCode":"MK","latitude":"41.51291120","longitude":"20.95250650"},{"name":"Kon\u010De Municipality","isoCode":"41","countryCode":"MK","latitude":"41.51710110","longitude":"22.38146240"},{"name":"Ko\u010Dani Municipality","isoCode":"42","countryCode":"MK","latitude":"41.98583740","longitude":"22.40530460"},{"name":"Kratovo Municipality","isoCode":"43","countryCode":"MK","latitude":"42.05371410","longitude":"22.07148350"},{"name":"Kriva Palanka Municipality","isoCode":"44","countryCode":"MK","latitude":"42.20584540","longitude":"22.33079650"},{"name":"Krivoga\u0161tani Municipality","isoCode":"45","countryCode":"MK","latitude":"41.30823060","longitude":"21.36796890"},{"name":"Kru\u0161evo Municipality","isoCode":"46","countryCode":"MK","latitude":"41.37693310","longitude":"21.26065540"},{"name":"Kumanovo Municipality","isoCode":"47","countryCode":"MK","latitude":"42.07326130","longitude":"21.78531430"},{"name":"Lipkovo Municipality","isoCode":"48","countryCode":"MK","latitude":"42.20066260","longitude":"21.61837550"},{"name":"Lozovo Municipality","isoCode":"49","countryCode":"MK","latitude":"41.78181390","longitude":"21.90008270"},{"name":"Mavrovo and Rostu\u0161a Municipality","isoCode":"50","countryCode":"MK","latitude":"41.60924270","longitude":"20.60124880"},{"name":"Makedonska Kamenica Municipality","isoCode":"51","countryCode":"MK","latitude":"42.06946040","longitude":"22.54834900"},{"name":"Makedonski Brod Municipality","isoCode":"52","countryCode":"MK","latitude":"41.51330880","longitude":"21.21743290"},{"name":"Mogila Municipality","isoCode":"53","countryCode":"MK","latitude":"41.14796450","longitude":"21.45143690"},{"name":"Negotino Municipality","isoCode":"54","countryCode":"MK","latitude":"41.49899850","longitude":"22.09532970"},{"name":"Novaci Municipality","isoCode":"55","countryCode":"MK","latitude":"41.04426610","longitude":"21.45888940"},{"name":"Novo Selo Municipality","isoCode":"56","countryCode":"MK","latitude":"41.43255800","longitude":"22.88204890"},{"name":"Oslomej Municipality","isoCode":"57","countryCode":"MK","latitude":"41.57583910","longitude":"21.02219600"},{"name":"Ohrid Municipality","isoCode":"58","countryCode":"MK","latitude":"41.06820880","longitude":"20.75992660"},{"name":"Petrovec Municipality","isoCode":"59","countryCode":"MK","latitude":"41.90298970","longitude":"21.68992100"},{"name":"Peh\u010Devo Municipality","isoCode":"60","countryCode":"MK","latitude":"41.77371320","longitude":"22.88204890"},{"name":"Plasnica Municipality","isoCode":"61","countryCode":"MK","latitude":"41.45463490","longitude":"21.10565390"},{"name":"Prilep Municipality","isoCode":"62","countryCode":"MK","latitude":"41.26931420","longitude":"21.71376940"},{"name":"Probi\u0161tip Municipality","isoCode":"63","countryCode":"MK","latitude":"41.95891460","longitude":"22.16686700"},{"name":"Radovi\u0161 Municipality","isoCode":"64","countryCode":"MK","latitude":"41.64955310","longitude":"22.47682870"},{"name":"Rankovce Municipality","isoCode":"65","countryCode":"MK","latitude":"42.18081410","longitude":"22.09532970"},{"name":"Resen Municipality","isoCode":"66","countryCode":"MK","latitude":"40.93680930","longitude":"21.04604070"},{"name":"Rosoman Municipality","isoCode":"67","countryCode":"MK","latitude":"41.48480060","longitude":"21.88070640"},{"name":"Saraj Municipality","isoCode":"68","countryCode":"MK","latitude":"41.98694960","longitude":"21.26065540"},{"name":"Sveti Nikole Municipality","isoCode":"69","countryCode":"MK","latitude":"41.89803120","longitude":"21.99994350"},{"name":"Sopi\u0161te Municipality","isoCode":"70","countryCode":"MK","latitude":"41.86384920","longitude":"21.30834990"},{"name":"Staro Nagori\u010Dane Municipality","isoCode":"71","countryCode":"MK","latitude":"42.21916920","longitude":"21.90455410"},{"name":"Struga Municipality","isoCode":"72","countryCode":"MK","latitude":"41.31737440","longitude":"20.66456830"},{"name":"Strumica Municipality","isoCode":"73","countryCode":"MK","latitude":"41.43780040","longitude":"22.64274280"},{"name":"Studeni\u010Dani Municipality","isoCode":"74","countryCode":"MK","latitude":"41.92256390","longitude":"21.53639650"},{"name":"Tearce Municipality","isoCode":"75","countryCode":"MK","latitude":"42.07775110","longitude":"21.05349230"},{"name":"Tetovo Municipality","isoCode":"76","countryCode":"MK","latitude":"42.02748600","longitude":"20.95066360"},{"name":"Centar Municipality","isoCode":"77","countryCode":"MK","latitude":"41.96989340","longitude":"21.42162670"},{"name":"Centar \u017Dupa Municipality","isoCode":"78","countryCode":"MK","latitude":"41.46522590","longitude":"20.59305480"},{"name":"\u010Cair Municipality","isoCode":"79","countryCode":"MK","latitude":"41.99303550","longitude":"21.43653180"},{"name":"\u010Ca\u0161ka Municipality","isoCode":"80","countryCode":"MK","latitude":"41.64743800","longitude":"21.69141150"},{"name":"\u010Ce\u0161inovo-Oble\u0161evo Municipality","isoCode":"81","countryCode":"MK","latitude":"41.86393160","longitude":"22.26224600"},{"name":"\u010Cu\u010Der-Sandevo Municipality","isoCode":"82","countryCode":"MK","latitude":"42.14839460","longitude":"21.40374070"},{"name":"\u0160tip Municipality","isoCode":"83","countryCode":"MK","latitude":"41.70792970","longitude":"22.19071220"},{"name":"\u0160uto Orizari Municipality","isoCode":"84","countryCode":"MK","latitude":"42.02904160","longitude":"21.40970270"},{"name":"Greater Skopje","isoCode":"85","countryCode":"MK","latitude":"41.99812940","longitude":"21.42543550"},{"name":"Kayes Region","isoCode":"1","countryCode":"ML","latitude":"14.08183080","longitude":"-9.90181310"},{"name":"Taoud\xe9nit Region","isoCode":"10","countryCode":"ML","latitude":"22.67641320","longitude":"-3.97891430"},{"name":"Koulikoro Region","isoCode":"2","countryCode":"ML","latitude":"13.80180740","longitude":"-7.43813550"},{"name":"Sikasso Region","isoCode":"3","countryCode":"ML","latitude":"10.89051860","longitude":"-7.43813550"},{"name":"S\xe9gou Region","isoCode":"4","countryCode":"ML","latitude":"13.83944560","longitude":"-6.06791940"},{"name":"Mopti Region","isoCode":"5","countryCode":"ML","latitude":"14.63380390","longitude":"-3.41955270"},{"name":"Tombouctou Region","isoCode":"6","countryCode":"ML","latitude":"21.05267060","longitude":"-3.74350900"},{"name":"Gao Region","isoCode":"7","countryCode":"ML","latitude":"16.90663320","longitude":"1.52086240"},{"name":"Kidal Region","isoCode":"8","countryCode":"ML","latitude":"18.79868320","longitude":"1.83183340"},{"name":"M\xe9naka Region","isoCode":"9","countryCode":"ML","latitude":"15.91564210","longitude":"2.39617400"},{"name":"Bamako","isoCode":"BKO","countryCode":"ML","latitude":"12.63923160","longitude":"-8.00288920"},{"name":"Sagaing Region","isoCode":"01","countryCode":"MM","latitude":"24.42838100","longitude":"95.39395510"},{"name":"Bago","isoCode":"02","countryCode":"MM","latitude":"17.32207110","longitude":"96.46632860"},{"name":"Magway Region","isoCode":"03","countryCode":"MM","latitude":"19.88713860","longitude":"94.72775280"},{"name":"Mandalay Region","isoCode":"04","countryCode":"MM","latitude":"21.56190580","longitude":"95.89871390"},{"name":"Tanintharyi Region","isoCode":"05","countryCode":"MM","latitude":"12.47068760","longitude":"99.01289260"},{"name":"Yangon Region","isoCode":"06","countryCode":"MM","latitude":"16.91434880","longitude":"96.15269850"},{"name":"Ayeyarwady Region","isoCode":"07","countryCode":"MM","latitude":"17.03421250","longitude":"95.22666750"},{"name":"Kachin State","isoCode":"11","countryCode":"MM","latitude":"25.85090400","longitude":"97.43813550"},{"name":"Kayah State","isoCode":"12","countryCode":"MM","latitude":"19.23420610","longitude":"97.26528580"},{"name":"Kayin State","isoCode":"13","countryCode":"MM","latitude":"16.94593460","longitude":"97.95928630"},{"name":"Chin State","isoCode":"14","countryCode":"MM","latitude":"22.00869780","longitude":"93.58126920"},{"name":"Mon State","isoCode":"15","countryCode":"MM","latitude":"16.30031330","longitude":"97.69822720"},{"name":"Rakhine State","isoCode":"16","countryCode":"MM","latitude":"20.10408180","longitude":"93.58126920"},{"name":"Shan State","isoCode":"17","countryCode":"MM","latitude":"22.03619850","longitude":"98.13385580"},{"name":"Naypyidaw Union Territory","isoCode":"18","countryCode":"MM","latitude":"19.93862450","longitude":"96.15269850"},{"name":"Orkhon Province","isoCode":"035","countryCode":"MN","latitude":"49.00470500","longitude":"104.30165270"},{"name":"Darkhan-Uul Province","isoCode":"037","countryCode":"MN","latitude":"49.46484340","longitude":"105.97459190"},{"name":"Khentii Province","isoCode":"039","countryCode":"MN","latitude":"47.60812090","longitude":"109.93728560"},{"name":"Kh\xf6vsg\xf6l Province","isoCode":"041","countryCode":"MN","latitude":"50.22044840","longitude":"100.32137680"},{"name":"Khovd Province","isoCode":"043","countryCode":"MN","latitude":"47.11296540","longitude":"92.31107520"},{"name":"Uvs Province","isoCode":"046","countryCode":"MN","latitude":"49.64497070","longitude":"93.27365760"},{"name":"T\xf6v Province","isoCode":"047","countryCode":"MN","latitude":"47.21240560","longitude":"106.41541000"},{"name":"Selenge Province","isoCode":"049","countryCode":"MN","latitude":"50.00592730","longitude":"106.44341080"},{"name":"S\xfckhbaatar Province","isoCode":"051","countryCode":"MN","latitude":"46.56531630","longitude":"113.53808360"},{"name":"\xd6mn\xf6govi Province","isoCode":"053","countryCode":"MN","latitude":"43.50002400","longitude":"104.28611160"},{"name":"\xd6v\xf6rkhangai Province","isoCode":"055","countryCode":"MN","latitude":"45.76243920","longitude":"103.09170320"},{"name":"Zavkhan Province","isoCode":"057","countryCode":"MN","latitude":"48.23881470","longitude":"96.07030190"},{"name":"Dundgovi Province","isoCode":"059","countryCode":"MN","latitude":"45.58227860","longitude":"106.76442090"},{"name":"Dornod Province","isoCode":"061","countryCode":"MN","latitude":"47.46581540","longitude":"115.39271200"},{"name":"Dornogovi Province","isoCode":"063","countryCode":"MN","latitude":"43.96538890","longitude":"109.17734590"},{"name":"Govis\xfcmber Province","isoCode":"064","countryCode":"MN","latitude":"46.47627540","longitude":"108.55706270"},{"name":"Govi-Altai Province","isoCode":"065","countryCode":"MN","latitude":"45.45112270","longitude":"95.85057660"},{"name":"Bulgan Province","isoCode":"067","countryCode":"MN","latitude":"48.96909130","longitude":"102.88317230"},{"name":"Bayankhongor Province","isoCode":"069","countryCode":"MN","latitude":"45.15267070","longitude":"100.10736670"},{"name":"Bayan-\xd6lgii Province","isoCode":"071","countryCode":"MN","latitude":"48.39832540","longitude":"89.66259150"},{"name":"Arkhangai Province","isoCode":"073","countryCode":"MN","latitude":"47.89711010","longitude":"100.72401650"},{"name":"Hodh Ech Chargui Region","isoCode":"01","countryCode":"MR","latitude":"18.67370260","longitude":"-7.09287700"},{"name":"Hodh El Gharbi Region","isoCode":"02","countryCode":"MR","latitude":"16.69121490","longitude":"-9.54509740"},{"name":"Assaba Region","isoCode":"03","countryCode":"MR","latitude":"16.77595580","longitude":"-11.52480550"},{"name":"Gorgol Region","isoCode":"04","countryCode":"MR","latitude":"15.97173570","longitude":"-12.62162110"},{"name":"Brakna Region","isoCode":"05","countryCode":"MR","latitude":"17.23175610","longitude":"-13.17403480"},{"name":"Trarza Region","isoCode":"06","countryCode":"MR","latitude":"17.86649640","longitude":"-14.65878210"},{"name":"Adrar Region","isoCode":"07","countryCode":"MR","latitude":"19.86521760","longitude":"-12.80547530"},{"name":"Dakhlet Nouadhibou","isoCode":"08","countryCode":"MR","latitude":"20.59855880","longitude":"-16.25221430"},{"name":"Tagant Region","isoCode":"09","countryCode":"MR","latitude":"18.54675270","longitude":"-9.90181310"},{"name":"Guidimaka Region","isoCode":"10","countryCode":"MR","latitude":"15.25573310","longitude":"-12.25479190"},{"name":"Tiris Zemmour Region","isoCode":"11","countryCode":"MR","latitude":"24.57737640","longitude":"-9.90181310"},{"name":"Inchiri Region","isoCode":"12","countryCode":"MR","latitude":"20.02805610","longitude":"-15.40680790"},{"name":"Nouakchott-Ouest Region","isoCode":"13","countryCode":"MR","latitude":"18.15113570","longitude":"-15.99349100"},{"name":"Nouakchott-Nord Region","isoCode":"14","countryCode":"MR","latitude":"18.11302050","longitude":"-15.89949560"},{"name":"Nouakchott-Sud Region","isoCode":"15","countryCode":"MR","latitude":"17.97092880","longitude":"-15.94648740"},{"name":"Attard","isoCode":"01","countryCode":"MT","latitude":"35.89049670","longitude":"14.41993220"},{"name":"Balzan","isoCode":"02","countryCode":"MT","latitude":"35.89574140","longitude":"14.45340650"},{"name":"Birgu","isoCode":"03","countryCode":"MT","latitude":"35.88792140","longitude":"14.52256200"},{"name":"Birkirkara","isoCode":"04","countryCode":"MT","latitude":"35.89547060","longitude":"14.46650720"},{"name":"Bir\u017Cebbu\u0121a","isoCode":"05","countryCode":"MT","latitude":"35.81359890","longitude":"14.52474630"},{"name":"Cospicua","isoCode":"06","countryCode":"MT","latitude":"35.88067530","longitude":"14.52183380"},{"name":"Dingli","isoCode":"07","countryCode":"MT","latitude":"35.86273090","longitude":"14.38501070"},{"name":"Fgura","isoCode":"08","countryCode":"MT","latitude":"35.87382690","longitude":"14.52329010"},{"name":"Floriana","isoCode":"09","countryCode":"MT","latitude":"45.49521850","longitude":"-73.71395760"},{"name":"Fontana","isoCode":"10","countryCode":"MT","latitude":"34.09223350","longitude":"-117.43504800"},{"name":"Gudja","isoCode":"11","countryCode":"MT","latitude":"35.84698030","longitude":"14.50290400"},{"name":"G\u017Cira","isoCode":"12","countryCode":"MT","latitude":"35.90589700","longitude":"14.49533380"},{"name":"G\u0127ajnsielem","isoCode":"13","countryCode":"MT","latitude":"36.02479660","longitude":"14.28029610"},{"name":"G\u0127arb","isoCode":"14","countryCode":"MT","latitude":"36.06890900","longitude":"14.20180980"},{"name":"G\u0127arg\u0127ur","isoCode":"15","countryCode":"MT","latitude":"35.92205690","longitude":"14.45631760"},{"name":"G\u0127asri","isoCode":"16","countryCode":"MT","latitude":"36.06680750","longitude":"14.21924750"},{"name":"G\u0127axaq","isoCode":"17","countryCode":"MT","latitude":"35.84403590","longitude":"14.51600900"},{"name":"\u0126amrun","isoCode":"18","countryCode":"MT","latitude":"35.88612370","longitude":"14.48834420"},{"name":"Iklin","isoCode":"19","countryCode":"MT","latitude":"35.90987740","longitude":"14.45777320"},{"name":"Senglea","isoCode":"20","countryCode":"MT","latitude":"35.88730410","longitude":"14.51673710"},{"name":"Kalkara","isoCode":"21","countryCode":"MT","latitude":"35.89142420","longitude":"14.53202780"},{"name":"Ker\u010Bem","isoCode":"22","countryCode":"MT","latitude":"36.04479390","longitude":"14.22506050"},{"name":"Kirkop","isoCode":"23","countryCode":"MT","latitude":"35.84378620","longitude":"14.48543240"},{"name":"Lija","isoCode":"24","countryCode":"MT","latitude":"49.18007600","longitude":"-123.10331700"},{"name":"Luqa","isoCode":"25","countryCode":"MT","latitude":"35.85828650","longitude":"14.48688830"},{"name":"Marsa","isoCode":"26","countryCode":"MT","latitude":"34.03195870","longitude":"-118.44555350"},{"name":"Marsaskala","isoCode":"27","countryCode":"MT","latitude":"35.86036400","longitude":"14.55678760"},{"name":"Marsaxlokk","isoCode":"28","countryCode":"MT","latitude":"35.84116990","longitude":"14.53930970"},{"name":"Mdina","isoCode":"29","countryCode":"MT","latitude":"35.88809300","longitude":"14.40683570"},{"name":"Mellie\u0127a","isoCode":"30","countryCode":"MT","latitude":"35.95235290","longitude":"14.35009750"},{"name":"M\u0121arr","isoCode":"31","countryCode":"MT","latitude":"35.91893270","longitude":"14.36173430"},{"name":"Mosta","isoCode":"32","countryCode":"MT","latitude":"35.91415040","longitude":"14.42284270"},{"name":"Mqabba","isoCode":"33","countryCode":"MT","latitude":"35.84441430","longitude":"14.46941860"},{"name":"Msida","isoCode":"34","countryCode":"MT","latitude":"35.89563880","longitude":"14.48688830"},{"name":"Mtarfa","isoCode":"35","countryCode":"MT","latitude":"35.88951250","longitude":"14.39519530"},{"name":"Munxar","isoCode":"36","countryCode":"MT","latitude":"36.02880580","longitude":"14.22506050"},{"name":"Nadur","isoCode":"37","countryCode":"MT","latitude":"36.04470190","longitude":"14.29192730"},{"name":"Naxxar","isoCode":"38","countryCode":"MT","latitude":"35.93175180","longitude":"14.43157460"},{"name":"Paola","isoCode":"39","countryCode":"MT","latitude":"38.57223530","longitude":"-94.87912940"},{"name":"Pembroke","isoCode":"40","countryCode":"MT","latitude":"34.68016260","longitude":"-79.19503730"},{"name":"Piet\xe0","isoCode":"41","countryCode":"MT","latitude":"42.21862000","longitude":"-83.73464700"},{"name":"Qala","isoCode":"42","countryCode":"MT","latitude":"36.03886280","longitude":"14.31810100"},{"name":"Qormi","isoCode":"43","countryCode":"MT","latitude":"35.87643880","longitude":"14.46941860"},{"name":"Qrendi","isoCode":"44","countryCode":"MT","latitude":"35.83284880","longitude":"14.45486210"},{"name":"Victoria","isoCode":"45","countryCode":"MT","latitude":"28.80526740","longitude":"-97.00359820"},{"name":"Rabat","isoCode":"46","countryCode":"MT","latitude":"33.97159040","longitude":"-6.84981290"},{"name":"St. Julian\'s","isoCode":"48","countryCode":"MT","latitude":"42.21225130","longitude":"-85.89171270"},{"name":"San \u0120wann","isoCode":"49","countryCode":"MT","latitude":"35.90773650","longitude":"14.47524160"},{"name":"Saint Lawrence","isoCode":"50","countryCode":"MT","latitude":"38.95780560","longitude":"-95.25656890"},{"name":"St. Paul\'s Bay","isoCode":"51","countryCode":"MT","latitude":"35.93601700","longitude":"14.39665030"},{"name":"Sannat","isoCode":"52","countryCode":"MT","latitude":"36.01926430","longitude":"14.25994370"},{"name":"Santa Lu\u010Bija","isoCode":"53","countryCode":"MT","latitude":"35.85614200","longitude":"14.50436000"},{"name":"Santa Venera","isoCode":"54","countryCode":"MT","latitude":"35.89022010","longitude":"14.47669740"},{"name":"Si\u0121\u0121iewi","isoCode":"55","countryCode":"MT","latitude":"35.84637420","longitude":"14.43157460"},{"name":"Sliema","isoCode":"56","countryCode":"MT","latitude":"35.91100810","longitude":"14.50290400"},{"name":"Swieqi","isoCode":"57","countryCode":"MT","latitude":"35.91911820","longitude":"14.46941860"},{"name":"Ta\' Xbiex","isoCode":"58","countryCode":"MT","latitude":"35.89914480","longitude":"14.49635190"},{"name":"Tarxien","isoCode":"59","countryCode":"MT","latitude":"35.86725520","longitude":"14.51164050"},{"name":"Valletta","isoCode":"60","countryCode":"MT","latitude":"35.89890850","longitude":"14.51455280"},{"name":"Xag\u0127ra","isoCode":"61","countryCode":"MT","latitude":"36.05084500","longitude":"14.26748200"},{"name":"Xewkija","isoCode":"62","countryCode":"MT","latitude":"36.02992360","longitude":"14.25994370"},{"name":"Xg\u0127ajra","isoCode":"63","countryCode":"MT","latitude":"35.88682820","longitude":"14.54723910"},{"name":"\u017Babbar","isoCode":"64","countryCode":"MT","latitude":"35.87247150","longitude":"14.54513540"},{"name":"\u017Bebbu\u0121 Gozo","isoCode":"65","countryCode":"MT","latitude":"36.07164030","longitude":"14.24540800"},{"name":"\u017Bebbu\u0121 Malta","isoCode":"66","countryCode":"MT","latitude":"35.87646480","longitude":"14.43908400"},{"name":"\u017Bejtun","isoCode":"67","countryCode":"MT","latitude":"35.85487140","longitude":"14.53639690"},{"name":"\u017Burrieq","isoCode":"68","countryCode":"MT","latitude":"35.82163060","longitude":"14.48106480"},{"name":"Agal\xe9ga","isoCode":"AG","countryCode":"MU","latitude":"-10.40000000","longitude":"56.61666670"},{"name":"Rivi\xe8re Noire District","isoCode":"BL","countryCode":"MU","latitude":"-20.37084920","longitude":"57.39486490"},{"name":"Beau Bassin-Rose Hill","isoCode":"BR","countryCode":"MU","latitude":"-20.22303050","longitude":"57.46838300"},{"name":"Cargados Carajos","isoCode":"CC","countryCode":"MU","latitude":"-16.58333300","longitude":"59.61666700"},{"name":"Curepipe","isoCode":"CU","countryCode":"MU","latitude":"-20.31708720","longitude":"57.52652890"},{"name":"Flacq District","isoCode":"FL","countryCode":"MU","latitude":"-20.22578360","longitude":"57.71192740"},{"name":"Grand Port District","isoCode":"GP","countryCode":"MU","latitude":"-20.38515460","longitude":"57.66657420"},{"name":"Moka District","isoCode":"MO","countryCode":"MU","latitude":"-20.23997820","longitude":"57.57592600"},{"name":"Pamplemousses District","isoCode":"PA","countryCode":"MU","latitude":"-20.11360080","longitude":"57.57592600"},{"name":"Port Louis District","isoCode":"PL","countryCode":"MU","latitude":"-20.16089120","longitude":"57.50122220"},{"name":"Port Louis","isoCode":"PU","countryCode":"MU","latitude":"-20.16089120","longitude":"57.50122220"},{"name":"Plaines Wilhems District","isoCode":"PW","countryCode":"MU","latitude":"-20.30548720","longitude":"57.48535610"},{"name":"Quatre Bornes","isoCode":"QB","countryCode":"MU","latitude":"-20.26747180","longitude":"57.47969810"},{"name":"Rodrigues","isoCode":"RO","countryCode":"MU","latitude":"-19.72453850","longitude":"63.42721850"},{"name":"Rivi\xe8re du Rempart District","isoCode":"RR","countryCode":"MU","latitude":"-20.05609830","longitude":"57.65523890"},{"name":"Savanne District","isoCode":"SA","countryCode":"MU","latitude":"-20.47395300","longitude":"57.48535610"},{"name":"Vacoas-Phoenix","isoCode":"VP","countryCode":"MU","latitude":"-20.29840260","longitude":"57.49383550"},{"name":"Alif Dhaal Atoll","isoCode":"00","countryCode":"MV","latitude":"3.65433020","longitude":"72.80427970"},{"name":"Addu Atoll","isoCode":"01","countryCode":"MV","latitude":"-0.63009950","longitude":"73.15856260"},{"name":"Alif Alif Atoll","isoCode":"02","countryCode":"MV","latitude":"4.08500000","longitude":"72.85154790"},{"name":"Lhaviyani Atoll","isoCode":"03","countryCode":"MV","latitude":"5.37470210","longitude":"73.51229280"},{"name":"Vaavu Atoll","isoCode":"04","countryCode":"MV","latitude":"3.39554380","longitude":"73.51229280"},{"name":"Laamu Atoll","isoCode":"05","countryCode":"MV","latitude":"1.94307370","longitude":"73.41802110"},{"name":"Haa Alif Atoll","isoCode":"07","countryCode":"MV","latitude":"6.99034880","longitude":"72.94605660"},{"name":"Thaa Atoll","isoCode":"08","countryCode":"MV","latitude":"2.43111610","longitude":"73.18216230"},{"name":"Meemu Atoll","isoCode":"12","countryCode":"MV","latitude":"3.00903450","longitude":"73.51229280"},{"name":"Raa Atoll","isoCode":"13","countryCode":"MV","latitude":"5.60064570","longitude":"72.94605660"},{"name":"Faafu Atoll","isoCode":"14","countryCode":"MV","latitude":"3.23094090","longitude":"72.94605660"},{"name":"Dhaalu Atoll","isoCode":"17","countryCode":"MV","latitude":"2.84685020","longitude":"72.94605660"},{"name":"Haa Dhaalu Atoll","isoCode":"23","countryCode":"MV","latitude":"6.57827170","longitude":"72.94605660"},{"name":"Shaviyani Atoll","isoCode":"24","countryCode":"MV","latitude":"6.17511000","longitude":"73.13496050"},{"name":"Noonu Atoll","isoCode":"25","countryCode":"MV","latitude":"5.85512760","longitude":"73.32370800"},{"name":"Kaafu Atoll","isoCode":"26","countryCode":"MV","latitude":"4.45589790","longitude":"73.55941280"},{"name":"Gaafu Alif Atoll","isoCode":"27","countryCode":"MV","latitude":"0.61248130","longitude":"73.32370800"},{"name":"Gaafu Dhaalu Atoll","isoCode":"28","countryCode":"MV","latitude":"0.35880400","longitude":"73.18216230"},{"name":"Gnaviyani Atoll","isoCode":"29","countryCode":"MV","latitude":"-0.30064250","longitude":"73.42391430"},{"name":"Central Province","isoCode":"CE","countryCode":"MV","latitude":null,"longitude":null},{"name":"Mal\xe9","isoCode":"MLE","countryCode":"MV","latitude":"46.34888670","longitude":"10.90724890"},{"name":"North Central Province","isoCode":"NC","countryCode":"MV","latitude":null,"longitude":null},{"name":"North Province","isoCode":"NO","countryCode":"MV","latitude":"8.88550270","longitude":"80.27673270"},{"name":"South Central Province","isoCode":"SC","countryCode":"MV","latitude":"7.25649960","longitude":"80.72144170"},{"name":"South Province","isoCode":"SU","countryCode":"MV","latitude":"-21.74820060","longitude":"166.17837390"},{"name":"Upper South Province","isoCode":"US","countryCode":"MV","latitude":"0.23070000","longitude":"73.27948460"},{"name":"Balaka District","isoCode":"BA","countryCode":"MW","latitude":"-15.05065950","longitude":"35.08285880"},{"name":"Blantyre District","isoCode":"BL","countryCode":"MW","latitude":"-15.67785410","longitude":"34.95066250"},{"name":"Central Region","isoCode":"C","countryCode":"MW","latitude":null,"longitude":null},{"name":"Chikwawa District","isoCode":"CK","countryCode":"MW","latitude":"-16.19584460","longitude":"34.77407930"},{"name":"Chiradzulu District","isoCode":"CR","countryCode":"MW","latitude":"-15.74231510","longitude":"35.25879640"},{"name":"Chitipa district","isoCode":"CT","countryCode":"MW","latitude":"-9.70376550","longitude":"33.27002530"},{"name":"Dedza District","isoCode":"DE","countryCode":"MW","latitude":"-14.18945850","longitude":"34.24215970"},{"name":"Dowa District","isoCode":"DO","countryCode":"MW","latitude":"-13.60412560","longitude":"33.88577470"},{"name":"Karonga District","isoCode":"KR","countryCode":"MW","latitude":"-9.90363650","longitude":"33.97500180"},{"name":"Kasungu District","isoCode":"KS","countryCode":"MW","latitude":"-13.13670650","longitude":"33.25879300"},{"name":"Lilongwe District","isoCode":"LI","countryCode":"MW","latitude":"-14.04752280","longitude":"33.61757700"},{"name":"Likoma District","isoCode":"LK","countryCode":"MW","latitude":"-12.05840050","longitude":"34.73540310"},{"name":"Mchinji District","isoCode":"MC","countryCode":"MW","latitude":"-13.74015250","longitude":"32.98883190"},{"name":"Mangochi District","isoCode":"MG","countryCode":"MW","latitude":"-14.13882480","longitude":"35.03881640"},{"name":"Machinga District","isoCode":"MH","countryCode":"MW","latitude":"-14.94072630","longitude":"35.47819260"},{"name":"Mulanje District","isoCode":"MU","countryCode":"MW","latitude":"-15.93464340","longitude":"35.52200120"},{"name":"Mwanza District","isoCode":"MW","countryCode":"MW","latitude":"-2.46711970","longitude":"32.89868120"},{"name":"Mzimba District","isoCode":"MZ","countryCode":"MW","latitude":"-11.74754520","longitude":"33.52800720"},{"name":"Northern Region","isoCode":"N","countryCode":"MW","latitude":null,"longitude":null},{"name":"Nkhata Bay District","isoCode":"NB","countryCode":"MW","latitude":"-11.71850420","longitude":"34.33103640"},{"name":"Ntchisi District","isoCode":"NI","countryCode":"MW","latitude":"-13.28419920","longitude":"33.88577470"},{"name":"Nkhotakota District","isoCode":"NK","countryCode":"MW","latitude":"-12.75419610","longitude":"34.24215970"},{"name":"Nsanje District","isoCode":"NS","countryCode":"MW","latitude":"-16.72882020","longitude":"35.17087410"},{"name":"Ntcheu District","isoCode":"NU","countryCode":"MW","latitude":"-14.90375380","longitude":"34.77407930"},{"name":"Phalombe District","isoCode":"PH","countryCode":"MW","latitude":"-15.70920380","longitude":"35.65328480"},{"name":"Rumphi District","isoCode":"RU","countryCode":"MW","latitude":"-10.78515370","longitude":"34.33103640"},{"name":"Southern Region","isoCode":"S","countryCode":"MW","latitude":"32.75049570","longitude":"-97.33154760"},{"name":"Salima District","isoCode":"SA","countryCode":"MW","latitude":"-13.68095860","longitude":"34.41982430"},{"name":"Thyolo District","isoCode":"TH","countryCode":"MW","latitude":"-16.12991770","longitude":"35.12687810"},{"name":"Zomba District","isoCode":"ZO","countryCode":"MW","latitude":"-15.37658570","longitude":"35.33565180"},{"name":"Aguascalientes","isoCode":"AGU","countryCode":"MX","latitude":"21.88525620","longitude":"-102.29156770"},{"name":"Baja California","isoCode":"BCN","countryCode":"MX","latitude":"30.84063380","longitude":"-115.28375850"},{"name":"Baja California Sur","isoCode":"BCS","countryCode":"MX","latitude":"26.04444460","longitude":"-111.66607250"},{"name":"Campeche","isoCode":"CAM","countryCode":"MX","latitude":"19.83012510","longitude":"-90.53490870"},{"name":"Ciudad de M\xe9xico","isoCode":"CDMX","countryCode":"MX","latitude":"19.43260770","longitude":"-99.13320800"},{"name":"Chihuahua","isoCode":"CHH","countryCode":"MX","latitude":"28.63299570","longitude":"-106.06910040"},{"name":"Chiapas","isoCode":"CHP","countryCode":"MX","latitude":"16.75693180","longitude":"-93.12923530"},{"name":"Coahuila de Zaragoza","isoCode":"COA","countryCode":"MX","latitude":"27.05867600","longitude":"-101.70682940"},{"name":"Colima","isoCode":"COL","countryCode":"MX","latitude":"19.24523420","longitude":"-103.72408680"},{"name":"Durango","isoCode":"DUR","countryCode":"MX","latitude":"37.27528000","longitude":"-107.88006670"},{"name":"Guerrero","isoCode":"GRO","countryCode":"MX","latitude":"17.43919260","longitude":"-99.54509740"},{"name":"Guanajuato","isoCode":"GUA","countryCode":"MX","latitude":"21.01901450","longitude":"-101.25735860"},{"name":"Hidalgo","isoCode":"HID","countryCode":"MX","latitude":"26.10035470","longitude":"-98.26306840"},{"name":"Jalisco","isoCode":"JAL","countryCode":"MX","latitude":"20.65953820","longitude":"-103.34943760"},{"name":"Estado de M\xe9xico","isoCode":"MEX","countryCode":"MX","latitude":"23.63450100","longitude":"-102.55278400"},{"name":"Michoac\xe1n de Ocampo","isoCode":"MIC","countryCode":"MX","latitude":"19.56651920","longitude":"-101.70682940"},{"name":"Morelos","isoCode":"MOR","countryCode":"MX","latitude":"18.68130490","longitude":"-99.10134980"},{"name":"Nayarit","isoCode":"NAY","countryCode":"MX","latitude":"21.75138440","longitude":"-104.84546190"},{"name":"Nuevo Le\xf3n","isoCode":"NLE","countryCode":"MX","latitude":"25.59217200","longitude":"-99.99619470"},{"name":"Oaxaca","isoCode":"OAX","countryCode":"MX","latitude":"17.07318420","longitude":"-96.72658890"},{"name":"Puebla","isoCode":"PUE","countryCode":"MX","latitude":"19.04143980","longitude":"-98.20627270"},{"name":"Quer\xe9taro","isoCode":"QUE","countryCode":"MX","latitude":"20.58879320","longitude":"-100.38988810"},{"name":"Quintana Roo","isoCode":"ROO","countryCode":"MX","latitude":"19.18173930","longitude":"-88.47913760"},{"name":"Sinaloa","isoCode":"SIN","countryCode":"MX","latitude":"25.17210910","longitude":"-107.47951730"},{"name":"San Luis Potos\xed","isoCode":"SLP","countryCode":"MX","latitude":"22.15646990","longitude":"-100.98554090"},{"name":"Sonora","isoCode":"SON","countryCode":"MX","latitude":"37.98294960","longitude":"-120.38217240"},{"name":"Tabasco","isoCode":"TAB","countryCode":"MX","latitude":"17.84091730","longitude":"-92.61892730"},{"name":"Tamaulipas","isoCode":"TAM","countryCode":"MX","latitude":"24.26694000","longitude":"-98.83627550"},{"name":"Tlaxcala","isoCode":"TLA","countryCode":"MX","latitude":"19.31815400","longitude":"-98.23749540"},{"name":"Veracruz de Ignacio de la Llave","isoCode":"VER","countryCode":"MX","latitude":"19.17377300","longitude":"-96.13422410"},{"name":"Yucat\xe1n","isoCode":"YUC","countryCode":"MX","latitude":"20.70987860","longitude":"-89.09433770"},{"name":"Zacatecas","isoCode":"ZAC","countryCode":"MX","latitude":"22.77085550","longitude":"-102.58324260"},{"name":"Johor","isoCode":"01","countryCode":"MY","latitude":"1.48536820","longitude":"103.76181540"},{"name":"Kedah","isoCode":"02","countryCode":"MY","latitude":"6.11839640","longitude":"100.36845950"},{"name":"Kelantan","isoCode":"03","countryCode":"MY","latitude":"6.12539690","longitude":"102.23807100"},{"name":"Malacca","isoCode":"04","countryCode":"MY","latitude":"2.18959400","longitude":"102.25008680"},{"name":"Negeri Sembilan","isoCode":"05","countryCode":"MY","latitude":"2.72580580","longitude":"101.94237820"},{"name":"Pahang","isoCode":"06","countryCode":"MY","latitude":"3.81263180","longitude":"103.32562040"},{"name":"Penang","isoCode":"07","countryCode":"MY","latitude":"5.41639350","longitude":"100.33267860"},{"name":"Perak","isoCode":"08","countryCode":"MY","latitude":"4.59211260","longitude":"101.09010900"},{"name":"Perlis","isoCode":"09","countryCode":"MY","latitude":"29.92270940","longitude":"-90.12285590"},{"name":"Selangor","isoCode":"10","countryCode":"MY","latitude":"3.07383790","longitude":"101.51834690"},{"name":"Terengganu","isoCode":"11","countryCode":"MY","latitude":"5.31169160","longitude":"103.13241540"},{"name":"Sabah","isoCode":"12","countryCode":"MY","latitude":"5.97883980","longitude":"116.07531990"},{"name":"Sarawak","isoCode":"13","countryCode":"MY","latitude":"1.55327830","longitude":"110.35921270"},{"name":"Kuala Lumpur","isoCode":"14","countryCode":"MY","latitude":"3.13900300","longitude":"101.68685500"},{"name":"Labuan","isoCode":"15","countryCode":"MY","latitude":"5.28314560","longitude":"115.23082500"},{"name":"Putrajaya","isoCode":"16","countryCode":"MY","latitude":"2.92636100","longitude":"101.69644500"},{"name":"Niassa Province","isoCode":"A","countryCode":"MZ","latitude":"-12.78262020","longitude":"36.60939260"},{"name":"Manica Province","isoCode":"B","countryCode":"MZ","latitude":"-19.50597870","longitude":"33.43835300"},{"name":"Gaza Province","isoCode":"G","countryCode":"MZ","latitude":"-23.02219280","longitude":"32.71813750"},{"name":"Inhambane Province","isoCode":"I","countryCode":"MZ","latitude":"-22.85279970","longitude":"34.55087580"},{"name":"Maputo Province","isoCode":"L","countryCode":"MZ","latitude":"-25.25698760","longitude":"32.53727410"},{"name":"Maputo","isoCode":"MPM","countryCode":"MZ","latitude":"-25.96924800","longitude":"32.57317460"},{"name":"Nampula Province","isoCode":"N","countryCode":"MZ","latitude":"-14.76049310","longitude":"39.32062410"},{"name":"Cabo Delgado Province","isoCode":"P","countryCode":"MZ","latitude":"-12.33354740","longitude":"39.32062410"},{"name":"Zambezia Province","isoCode":"Q","countryCode":"MZ","latitude":"-16.56389870","longitude":"36.60939260"},{"name":"Sofala Province","isoCode":"S","countryCode":"MZ","latitude":"-19.20390730","longitude":"34.86241660"},{"name":"Tete Province","isoCode":"T","countryCode":"MZ","latitude":"-15.65960560","longitude":"32.71813750"},{"name":"Zambezi Region","isoCode":"CA","countryCode":"NA","latitude":"-17.81934190","longitude":"23.95364660"},{"name":"Erongo Region","isoCode":"ER","countryCode":"NA","latitude":"-22.25656820","longitude":"15.40680790"},{"name":"Hardap Region","isoCode":"HA","countryCode":"NA","latitude":"-24.23101340","longitude":"17.66888700"},{"name":"Karas Region","isoCode":"KA","countryCode":"NA","latitude":"-26.84296450","longitude":"17.29028390"},{"name":"Kavango East Region","isoCode":"KE","countryCode":"NA","latitude":"-18.27104800","longitude":"18.42760470"},{"name":"Khomas Region","isoCode":"KH","countryCode":"NA","latitude":"-22.63778540","longitude":"17.10119310"},{"name":"Kunene Region","isoCode":"KU","countryCode":"NA","latitude":"-19.40863170","longitude":"13.91439900"},{"name":"Kavango West Region","isoCode":"KW","countryCode":"NA","latitude":"-18.27104800","longitude":"18.42760470"},{"name":"Otjozondjupa Region","isoCode":"OD","countryCode":"NA","latitude":"-20.54869160","longitude":"17.66888700"},{"name":"Omaheke Region","isoCode":"OH","countryCode":"NA","latitude":"-21.84666510","longitude":"19.18800470"},{"name":"Oshana Region","isoCode":"ON","countryCode":"NA","latitude":"-18.43050640","longitude":"15.68817880"},{"name":"Omusati Region","isoCode":"OS","countryCode":"NA","latitude":"-18.40702940","longitude":"14.84546190"},{"name":"Oshikoto Region","isoCode":"OT","countryCode":"NA","latitude":"-18.41525750","longitude":"16.91225100"},{"name":"Ohangwena Region","isoCode":"OW","countryCode":"NA","latitude":"-17.59792910","longitude":"16.81783770"},{"name":"Agadez Region","isoCode":"1","countryCode":"NE","latitude":"20.66707520","longitude":"12.07182810"},{"name":"Diffa Region","isoCode":"2","countryCode":"NE","latitude":"13.67686470","longitude":"12.71351210"},{"name":"Dosso Region","isoCode":"3","countryCode":"NE","latitude":"13.15139470","longitude":"3.41955270"},{"name":"Maradi Region","isoCode":"4","countryCode":"NE","latitude":"13.80180740","longitude":"7.43813550"},{"name":"Tahoua Region","isoCode":"5","countryCode":"NE","latitude":"16.09025430","longitude":"5.39395510"},{"name":"Tillab\xe9ri Region","isoCode":"6","countryCode":"NE","latitude":"14.64895250","longitude":"2.14502450"},{"name":"Zinder Region","isoCode":"7","countryCode":"NE","latitude":"15.17188810","longitude":"10.26001250"},{"name":"Abia","isoCode":"AB","countryCode":"NG","latitude":"5.45273540","longitude":"7.52484140"},{"name":"Adamawa","isoCode":"AD","countryCode":"NG","latitude":"9.32647510","longitude":"12.39838530"},{"name":"Akwa Ibom","isoCode":"AK","countryCode":"NG","latitude":"4.90573710","longitude":"7.85366750"},{"name":"Anambra","isoCode":"AN","countryCode":"NG","latitude":"6.22089970","longitude":"6.93695590"},{"name":"Bauchi","isoCode":"BA","countryCode":"NG","latitude":"10.77606240","longitude":"9.99919430"},{"name":"Benue","isoCode":"BE","countryCode":"NG","latitude":"7.33690240","longitude":"8.74036870"},{"name":"Borno","isoCode":"BO","countryCode":"NG","latitude":"11.88463560","longitude":"13.15196650"},{"name":"Bayelsa","isoCode":"BY","countryCode":"NG","latitude":"4.77190710","longitude":"6.06985260"},{"name":"Cross River","isoCode":"CR","countryCode":"NG","latitude":"5.87017240","longitude":"8.59880140"},{"name":"Delta","isoCode":"DE","countryCode":"NG","latitude":"33.74537840","longitude":"-90.73545080"},{"name":"Ebonyi","isoCode":"EB","countryCode":"NG","latitude":"6.26492320","longitude":"8.01373020"},{"name":"Edo","isoCode":"ED","countryCode":"NG","latitude":"6.63418310","longitude":"5.93040560"},{"name":"Ekiti","isoCode":"EK","countryCode":"NG","latitude":"7.71898620","longitude":"5.31095050"},{"name":"Enugu","isoCode":"EN","countryCode":"NG","latitude":"6.53635300","longitude":"7.43561940"},{"name":"Abuja Federal Capital Territory","isoCode":"FC","countryCode":"NG","latitude":"8.89406910","longitude":"7.18604020"},{"name":"Gombe","isoCode":"GO","countryCode":"NG","latitude":"10.36377950","longitude":"11.19275870"},{"name":"Imo","isoCode":"IM","countryCode":"NG","latitude":"5.57201220","longitude":"7.05882190"},{"name":"Jigawa","isoCode":"JI","countryCode":"NG","latitude":"12.22801200","longitude":"9.56158670"},{"name":"Kaduna","isoCode":"KD","countryCode":"NG","latitude":"10.37640060","longitude":"7.70945370"},{"name":"Kebbi","isoCode":"KE","countryCode":"NG","latitude":"11.49420030","longitude":"4.23333550"},{"name":"Kano","isoCode":"KN","countryCode":"NG","latitude":"11.74706980","longitude":"8.52471070"},{"name":"Kogi","isoCode":"KO","countryCode":"NG","latitude":"7.73373250","longitude":"6.69058360"},{"name":"Katsina","isoCode":"KT","countryCode":"NG","latitude":"12.37967070","longitude":"7.63057480"},{"name":"Kwara","isoCode":"KW","countryCode":"NG","latitude":"8.96689610","longitude":"4.38740510"},{"name":"Lagos","isoCode":"LA","countryCode":"NG","latitude":"6.52437930","longitude":"3.37920570"},{"name":"Nasarawa","isoCode":"NA","countryCode":"NG","latitude":"8.49979080","longitude":"8.19969370"},{"name":"Niger","isoCode":"NI","countryCode":"NG","latitude":"9.93092240","longitude":"5.59832100"},{"name":"Ogun","isoCode":"OG","countryCode":"NG","latitude":"6.99797470","longitude":"3.47373780"},{"name":"Ondo","isoCode":"ON","countryCode":"NG","latitude":"6.91486820","longitude":"5.14781440"},{"name":"Osun","isoCode":"OS","countryCode":"NG","latitude":"7.56289640","longitude":"4.51995930"},{"name":"Oyo","isoCode":"OY","countryCode":"NG","latitude":"8.15738090","longitude":"3.61465340"},{"name":"Plateau","isoCode":"PL","countryCode":"NG","latitude":"9.21820930","longitude":"9.51794880"},{"name":"Rivers","isoCode":"RI","countryCode":"NG","latitude":"5.02134200","longitude":"6.43760220"},{"name":"Sokoto","isoCode":"SO","countryCode":"NG","latitude":"13.05331430","longitude":"5.32227220"},{"name":"Taraba","isoCode":"TA","countryCode":"NG","latitude":"7.99936160","longitude":"10.77398630"},{"name":"Yobe","isoCode":"YO","countryCode":"NG","latitude":"12.29387600","longitude":"11.43904110"},{"name":"Zamfara","isoCode":"ZA","countryCode":"NG","latitude":"12.12218050","longitude":"6.22358190"},{"name":"North Caribbean Coast","isoCode":"AN","countryCode":"NI","latitude":"13.83944560","longitude":"-83.93208060"},{"name":"South Caribbean Coast","isoCode":"AS","countryCode":"NI","latitude":"12.19185020","longitude":"-84.10128610"},{"name":"Boaco","isoCode":"BO","countryCode":"NI","latitude":"12.46928400","longitude":"-85.66146820"},{"name":"Carazo","isoCode":"CA","countryCode":"NI","latitude":"11.72747290","longitude":"-86.21584970"},{"name":"Chinandega","isoCode":"CI","countryCode":"NI","latitude":"12.88200620","longitude":"-87.14228950"},{"name":"Chontales","isoCode":"CO","countryCode":"NI","latitude":"11.93947170","longitude":"-85.18940450"},{"name":"Estel\xed","isoCode":"ES","countryCode":"NI","latitude":"13.08511390","longitude":"-86.36301970"},{"name":"Granada","isoCode":"GR","countryCode":"NI","latitude":"11.93440730","longitude":"-85.95600050"},{"name":"Jinotega","isoCode":"JI","countryCode":"NI","latitude":"13.08839070","longitude":"-85.99939970"},{"name":"Le\xf3n","isoCode":"LE","countryCode":"NI","latitude":"12.50920370","longitude":"-86.66110830"},{"name":"Madriz","isoCode":"MD","countryCode":"NI","latitude":"13.47260050","longitude":"-86.45920910"},{"name":"Managua","isoCode":"MN","countryCode":"NI","latitude":"12.13916990","longitude":"-86.33767610"},{"name":"Masaya","isoCode":"MS","countryCode":"NI","latitude":"11.97593280","longitude":"-86.07334980"},{"name":"Matagalpa","isoCode":"MT","countryCode":"NI","latitude":"12.94984360","longitude":"-85.43755740"},{"name":"Nueva Segovia","isoCode":"NS","countryCode":"NI","latitude":"13.76570610","longitude":"-86.53700390"},{"name":"Rivas","isoCode":"RI","countryCode":"NI","latitude":"11.40234900","longitude":"-85.68457800"},{"name":"R\xedo San Juan","isoCode":"SJ","countryCode":"NI","latitude":"11.47816100","longitude":"-84.77333250"},{"name":"Bonaire","isoCode":"BQ1","countryCode":"NL","latitude":"12.20189020","longitude":"-68.26238220"},{"name":"Saba","isoCode":"BQ2","countryCode":"NL","latitude":"17.63546420","longitude":"-63.23267630"},{"name":"Sint Eustatius","isoCode":"BQ3","countryCode":"NL","latitude":"17.48903060","longitude":"-62.97355500"},{"name":"Drenthe","isoCode":"DR","countryCode":"NL","latitude":"52.94760120","longitude":"6.62305860"},{"name":"Flevoland","isoCode":"FL","countryCode":"NL","latitude":"52.52797810","longitude":"5.59535080"},{"name":"Friesland","isoCode":"FR","countryCode":"NL","latitude":"53.16416420","longitude":"5.78175420"},{"name":"Gelderland","isoCode":"GE","countryCode":"NL","latitude":"52.04515500","longitude":"5.87182350"},{"name":"Groningen","isoCode":"GR","countryCode":"NL","latitude":"53.21938350","longitude":"6.56650170"},{"name":"Limburg","isoCode":"LI","countryCode":"NL","latitude":"51.44272380","longitude":"6.06087260"},{"name":"North Brabant","isoCode":"NB","countryCode":"NL","latitude":"51.48265370","longitude":"5.23216870"},{"name":"North Holland","isoCode":"NH","countryCode":"NL","latitude":"52.52058690","longitude":"4.78847400"},{"name":"Overijssel","isoCode":"OV","countryCode":"NL","latitude":"52.43878140","longitude":"6.50164110"},{"name":"Utrecht","isoCode":"UT","countryCode":"NL","latitude":"52.09073740","longitude":"5.12142010"},{"name":"Zeeland","isoCode":"ZE","countryCode":"NL","latitude":"51.49403090","longitude":"3.84968150"},{"name":"South Holland","isoCode":"ZH","countryCode":"NL","latitude":"41.60086810","longitude":"-87.60698940"},{"name":"\xd8stfold","isoCode":"01","countryCode":"NO","latitude":"59.25582860","longitude":"11.32790060"},{"name":"Akershus","isoCode":"02","countryCode":"NO","latitude":"28.37042030","longitude":"-81.54680580"},{"name":"Oslo","isoCode":"03","countryCode":"NO","latitude":"59.91386880","longitude":"10.75224540"},{"name":"Hedmark","isoCode":"04","countryCode":"NO","latitude":"61.39673110","longitude":"11.56273690"},{"name":"Oppland","isoCode":"05","countryCode":"NO","latitude":"61.54227520","longitude":"9.71663150"},{"name":"Buskerud","isoCode":"06","countryCode":"NO","latitude":"60.48460250","longitude":"8.69837640"},{"name":"Vestfold","isoCode":"07","countryCode":"NO","latitude":"59.17078620","longitude":"10.11443550"},{"name":"Telemark","isoCode":"08","countryCode":"NO","latitude":"59.39139850","longitude":"8.32112090"},{"name":"Vest-Agder","isoCode":"10","countryCode":"NO","latitude":"58.09990810","longitude":"6.58698090"},{"name":"Rogaland","isoCode":"11","countryCode":"NO","latitude":"59.14895440","longitude":"6.01434320"},{"name":"Hordaland","isoCode":"12","countryCode":"NO","latitude":"60.27336740","longitude":"5.72201940"},{"name":"Sogn og Fjordane","isoCode":"14","countryCode":"NO","latitude":"61.55394350","longitude":"6.33258790"},{"name":"M\xf8re og Romsdal","isoCode":"15","countryCode":"NO","latitude":"62.84068330","longitude":"7.00714300"},{"name":"S\xf8r-Tr\xf8ndelag","isoCode":"16","countryCode":"NO","latitude":"63.01368230","longitude":"10.34871360"},{"name":"Nord-Tr\xf8ndelag","isoCode":"17","countryCode":"NO","latitude":"64.43707920","longitude":"11.74629500"},{"name":"Nordland","isoCode":"18","countryCode":"NO","latitude":"67.69305800","longitude":"12.70739360"},{"name":"Troms","isoCode":"19","countryCode":"NO","latitude":"69.81782420","longitude":"18.78193650"},{"name":"Finnmark","isoCode":"20","countryCode":"NO","latitude":"70.48303880","longitude":"26.01351070"},{"name":"Svalbard","isoCode":"21","countryCode":"NO","latitude":"77.87497250","longitude":"20.97518210"},{"name":"Jan Mayen","isoCode":"22","countryCode":"NO","latitude":"71.03181800","longitude":"-8.29203460"},{"name":"Tr\xf8ndelag","isoCode":"50","countryCode":"NO","latitude":"63.54201250","longitude":"10.93692670"},{"name":"Central Region","isoCode":"1","countryCode":"NP","latitude":null,"longitude":null},{"name":"Mid-Western Region","isoCode":"2","countryCode":"NP","latitude":"38.41118410","longitude":"-90.38320980"},{"name":"Western Region","isoCode":"3","countryCode":"NP","latitude":null,"longitude":null},{"name":"Eastern Development Region","isoCode":"4","countryCode":"NP","latitude":"27.33090720","longitude":"87.06242610"},{"name":"Far-Western Development Region","isoCode":"5","countryCode":"NP","latitude":"29.29878710","longitude":"80.98710740"},{"name":"Bagmati Zone","isoCode":"BA","countryCode":"NP","latitude":"28.03675770","longitude":"85.43755740"},{"name":"Bheri Zone","isoCode":"BH","countryCode":"NP","latitude":"28.51745600","longitude":"81.77870210"},{"name":"Dhaulagiri Zone","isoCode":"DH","countryCode":"NP","latitude":"28.61117600","longitude":"83.50702030"},{"name":"Gandaki Zone","isoCode":"GA","countryCode":"NP","latitude":"28.37320370","longitude":"84.43827210"},{"name":"Janakpur Zone","isoCode":"JA","countryCode":"NP","latitude":"27.21108990","longitude":"86.01215730"},{"name":"Karnali Zone","isoCode":"KA","countryCode":"NP","latitude":"29.38625550","longitude":"82.38857830"},{"name":"Kosi Zone","isoCode":"KO","countryCode":"NP","latitude":"27.05365240","longitude":"87.30161320"},{"name":"Lumbini Zone","isoCode":"LU","countryCode":"NP","latitude":"27.45000000","longitude":"83.25000000"},{"name":"Mahakali Zone","isoCode":"MA","countryCode":"NP","latitude":"29.36010790","longitude":"80.54384500"},{"name":"Mechi Zone","isoCode":"ME","countryCode":"NP","latitude":"26.87600070","longitude":"87.93348030"},{"name":"Narayani Zone","isoCode":"NA","countryCode":"NP","latitude":"27.36117660","longitude":"84.85679320"},{"name":"Rapti Zone","isoCode":"RA","countryCode":"NP","latitude":"28.27434700","longitude":"82.38857830"},{"name":"Sagarmatha Zone","isoCode":"SA","countryCode":"NP","latitude":"27.32382630","longitude":"86.74163740"},{"name":"Seti Zone","isoCode":"SE","countryCode":"NP","latitude":"29.69054270","longitude":"81.33994140"},{"name":"Aiwo District","isoCode":"01","countryCode":"NR","latitude":"-0.53400120","longitude":"166.91388730"},{"name":"Anabar District","isoCode":"02","countryCode":"NR","latitude":"-0.51335170","longitude":"166.94846240"},{"name":"Anetan District","isoCode":"03","countryCode":"NR","latitude":"-0.50643430","longitude":"166.94270060"},{"name":"Anibare District","isoCode":"04","countryCode":"NR","latitude":"-0.52947580","longitude":"166.95134320"},{"name":"Baiti District","isoCode":"05","countryCode":"NR","latitude":"-0.51043100","longitude":"166.92757440"},{"name":"Boe District","isoCode":"06","countryCode":"NR","latitude":"39.07327760","longitude":"-94.57104980"},{"name":"Buada District","isoCode":"07","countryCode":"NR","latitude":"-0.53287770","longitude":"166.92685410"},{"name":"Denigomodu District","isoCode":"08","countryCode":"NR","latitude":"-0.52479640","longitude":"166.91676890"},{"name":"Ewa District","isoCode":"09","countryCode":"NR","latitude":"-0.50872410","longitude":"166.93693840"},{"name":"Ijuw District","isoCode":"10","countryCode":"NR","latitude":"-0.52027670","longitude":"166.95710460"},{"name":"Meneng District","isoCode":"11","countryCode":"NR","latitude":"-0.54672400","longitude":"166.93837900"},{"name":"Nibok District","isoCode":"12","countryCode":"NR","latitude":"-0.51962080","longitude":"166.91893010"},{"name":"Uaboe District","isoCode":"13","countryCode":"NR","latitude":"-0.52022220","longitude":"166.93117610"},{"name":"Yaren District","isoCode":"14","countryCode":"NR","latitude":"-0.54668570","longitude":"166.92109130"},{"name":"Auckland Region","isoCode":"AUK","countryCode":"NZ","latitude":"-36.66753280","longitude":"174.77333250"},{"name":"Bay of Plenty Region","isoCode":"BOP","countryCode":"NZ","latitude":"-37.42339170","longitude":"176.74163740"},{"name":"Canterbury Region","isoCode":"CAN","countryCode":"NZ","latitude":"-43.75422750","longitude":"171.16372450"},{"name":"Chatham Islands","isoCode":"CIT","countryCode":"NZ","latitude":"-44.00575230","longitude":"-176.54006740"},{"name":"Gisborne District","isoCode":"GIS","countryCode":"NZ","latitude":"-38.13581740","longitude":"178.32393090"},{"name":"Hawke\'s Bay Region","isoCode":"HKB","countryCode":"NZ","latitude":"-39.60165970","longitude":"176.58044730"},{"name":"Marlborough Region","isoCode":"MBH","countryCode":"NZ","latitude":"-41.59168830","longitude":"173.76240530"},{"name":"Manawatu-Wanganui Region","isoCode":"MWT","countryCode":"NZ","latitude":"-39.72733560","longitude":"175.43755740"},{"name":"Nelson Region","isoCode":"NSN","countryCode":"NZ","latitude":"-41.29853970","longitude":"173.24414910"},{"name":"Northland Region","isoCode":"NTL","countryCode":"NZ","latitude":"-35.41361720","longitude":"173.93208060"},{"name":"Otago Region","isoCode":"OTA","countryCode":"NZ","latitude":"-45.47906710","longitude":"170.15475670"},{"name":"Southland Region","isoCode":"STL","countryCode":"NZ","latitude":"-45.84891590","longitude":"167.67553870"},{"name":"Tasman District","isoCode":"TAS","countryCode":"NZ","latitude":"-41.45711840","longitude":"172.82097400"},{"name":"Taranaki Region","isoCode":"TKI","countryCode":"NZ","latitude":"-39.35381490","longitude":"174.43827210"},{"name":"Wellington Region","isoCode":"WGN","countryCode":"NZ","latitude":"-41.02993230","longitude":"175.43755740"},{"name":"Waikato Region","isoCode":"WKO","countryCode":"NZ","latitude":"-37.61908620","longitude":"175.02334600"},{"name":"West Coast Region","isoCode":"WTC","countryCode":"NZ","latitude":"62.41136340","longitude":"-149.07297140"},{"name":"Al Batinah Region","isoCode":"BA","countryCode":"OM","latitude":"24.34198460","longitude":"56.72989040"},{"name":"Al Batinah South Governorate","isoCode":"BJ","countryCode":"OM","latitude":"23.43149030","longitude":"57.42397960"},{"name":"Al Batinah North Governorate","isoCode":"BS","countryCode":"OM","latitude":"24.34198460","longitude":"56.72989040"},{"name":"Al Buraimi Governorate","isoCode":"BU","countryCode":"OM","latitude":"24.16714130","longitude":"56.11422530"},{"name":"Ad Dakhiliyah Governorate","isoCode":"DA","countryCode":"OM","latitude":"22.85887580","longitude":"57.53943560"},{"name":"Muscat Governorate","isoCode":"MA","countryCode":"OM","latitude":"23.58803070","longitude":"58.38287170"},{"name":"Musandam Governorate","isoCode":"MU","countryCode":"OM","latitude":"26.19861440","longitude":"56.24609490"},{"name":"Ash Sharqiyah Region","isoCode":"SH","countryCode":"OM","latitude":"22.71411960","longitude":"58.53080640"},{"name":"Ash Sharqiyah South Governorate","isoCode":"SJ","countryCode":"OM","latitude":"22.01582490","longitude":"59.32519220"},{"name":"Ash Sharqiyah North Governorate","isoCode":"SS","countryCode":"OM","latitude":"22.71411960","longitude":"58.53080640"},{"name":"Al Wusta Governorate","isoCode":"WU","countryCode":"OM","latitude":"19.95710780","longitude":"56.27568460"},{"name":"Ad Dhahirah Governorate","isoCode":"ZA","countryCode":"OM","latitude":"23.21616740","longitude":"56.49074440"},{"name":"Dhofar Governorate","isoCode":"ZU","countryCode":"OM","latitude":"17.03221210","longitude":"54.14252140"},{"name":"Bocas del Toro Province","isoCode":"1","countryCode":"PA","latitude":"9.41655210","longitude":"-82.52077870"},{"name":"Panam\xe1 Oeste Province","isoCode":"10","countryCode":"PA","latitude":"9.11967510","longitude":"-79.29021330"},{"name":"Cocl\xe9 Province","isoCode":"2","countryCode":"PA","latitude":"8.62660680","longitude":"-80.36586500"},{"name":"Col\xf3n Province","isoCode":"3","countryCode":"PA","latitude":"9.18519890","longitude":"-80.05349230"},{"name":"Chiriqu\xed Province","isoCode":"4","countryCode":"PA","latitude":"8.58489800","longitude":"-82.38857830"},{"name":"Dari\xe9n Province","isoCode":"5","countryCode":"PA","latitude":"7.86817130","longitude":"-77.83672820"},{"name":"Herrera Province","isoCode":"6","countryCode":"PA","latitude":"7.77042820","longitude":"-80.72144170"},{"name":"Los Santos Province","isoCode":"7","countryCode":"PA","latitude":"7.59093020","longitude":"-80.36586500"},{"name":"Panam\xe1 Province","isoCode":"8","countryCode":"PA","latitude":"9.11967510","longitude":"-79.29021330"},{"name":"Veraguas Province","isoCode":"9","countryCode":"PA","latitude":"8.12310330","longitude":"-81.07546570"},{"name":"Ember\xe1-Wounaan Comarca","isoCode":"EM","countryCode":"PA","latitude":"8.37669830","longitude":"-77.65361250"},{"name":"Guna Yala","isoCode":"KY","countryCode":"PA","latitude":"9.23443950","longitude":"-78.19262500"},{"name":"Ng\xf6be-Bugl\xe9 Comarca","isoCode":"NB","countryCode":"PA","latitude":"8.65958330","longitude":"-81.77870210"},{"name":"Amazonas","isoCode":"AMA","countryCode":"PE","latitude":null,"longitude":null},{"name":"\xc1ncash","isoCode":"ANC","countryCode":"PE","latitude":"-9.32504970","longitude":"-77.56194190"},{"name":"Apur\xedmac","isoCode":"APU","countryCode":"PE","latitude":"-14.05045330","longitude":"-73.08774900"},{"name":"Arequipa","isoCode":"ARE","countryCode":"PE","latitude":"-16.40904740","longitude":"-71.53745100"},{"name":"Ayacucho","isoCode":"AYA","countryCode":"PE","latitude":"-13.16387370","longitude":"-74.22356410"},{"name":"Cajamarca","isoCode":"CAJ","countryCode":"PE","latitude":"-7.16174650","longitude":"-78.51278550"},{"name":"Callao","isoCode":"CAL","countryCode":"PE","latitude":"-12.05084910","longitude":"-77.12598430"},{"name":"Cusco","isoCode":"CUS","countryCode":"PE","latitude":"-13.53195000","longitude":"-71.96746260"},{"name":"Huanuco","isoCode":"HUC","countryCode":"PE","latitude":"-9.92076480","longitude":"-76.24108430"},{"name":"Huancavelica","isoCode":"HUV","countryCode":"PE","latitude":"-12.78619780","longitude":"-74.97640240"},{"name":"Ica","isoCode":"ICA","countryCode":"PE","latitude":"42.35288320","longitude":"-71.04300970"},{"name":"Jun\xedn","isoCode":"JUN","countryCode":"PE","latitude":"-11.15819250","longitude":"-75.99263060"},{"name":"La Libertad","isoCode":"LAL","countryCode":"PE","latitude":"13.49069700","longitude":"-89.30846070"},{"name":"Lambayeque","isoCode":"LAM","countryCode":"PE","latitude":"-6.71976660","longitude":"-79.90807570"},{"name":"Lima","isoCode":"LIM","countryCode":"PE","latitude":"-12.04637310","longitude":"-77.04275400"},{"name":"Loreto","isoCode":"LOR","countryCode":"PE","latitude":"-4.37416430","longitude":"-76.13042640"},{"name":"Madre de Dios","isoCode":"MDD","countryCode":"PE","latitude":"-11.76687050","longitude":"-70.81199530"},{"name":"Moquegua","isoCode":"MOQ","countryCode":"PE","latitude":"-17.19273610","longitude":"-70.93281380"},{"name":"Pasco","isoCode":"PAS","countryCode":"PE","latitude":"46.23050490","longitude":"-119.09223160"},{"name":"Piura","isoCode":"PIU","countryCode":"PE","latitude":"-5.17828840","longitude":"-80.65488820"},{"name":"Puno","isoCode":"PUN","countryCode":"PE","latitude":"-15.84022180","longitude":"-70.02188050"},{"name":"San Mart\xedn","isoCode":"SAM","countryCode":"PE","latitude":"37.08494640","longitude":"-121.61022160"},{"name":"Tacna","isoCode":"TAC","countryCode":"PE","latitude":"-18.00656790","longitude":"-70.24627410"},{"name":"Tumbes","isoCode":"TUM","countryCode":"PE","latitude":"-3.55649210","longitude":"-80.42708850"},{"name":"Ucayali","isoCode":"UCA","countryCode":"PE","latitude":"-9.82511830","longitude":"-73.08774900"},{"name":"Chimbu Province","isoCode":"CPK","countryCode":"PG","latitude":"-6.30876820","longitude":"144.87312190"},{"name":"Central Province","isoCode":"CPM","countryCode":"PG","latitude":null,"longitude":null},{"name":"East New Britain","isoCode":"EBR","countryCode":"PG","latitude":"-4.61289430","longitude":"151.88773210"},{"name":"Eastern Highlands Province","isoCode":"EHG","countryCode":"PG","latitude":"-6.58616740","longitude":"145.66896360"},{"name":"Enga Province","isoCode":"EPW","countryCode":"PG","latitude":"-5.30058490","longitude":"143.56356370"},{"name":"Gulf","isoCode":"GPK","countryCode":"PG","latitude":"37.05483150","longitude":"-94.43704190"},{"name":"Hela","isoCode":"HLA","countryCode":"PG","latitude":"42.33295160","longitude":"-83.04826180"},{"name":"Jiwaka Province","isoCode":"JWK","countryCode":"PG","latitude":"-5.86911540","longitude":"144.69727740"},{"name":"Milne Bay Province","isoCode":"MBA","countryCode":"PG","latitude":"-9.52214510","longitude":"150.67496530"},{"name":"Morobe Province","isoCode":"MPL","countryCode":"PG","latitude":"-6.80137370","longitude":"146.56164700"},{"name":"Madang Province","isoCode":"MPM","countryCode":"PG","latitude":"-4.98497330","longitude":"145.13758340"},{"name":"Manus Province","isoCode":"MRL","countryCode":"PG","latitude":"-2.09411690","longitude":"146.87609510"},{"name":"Port Moresby","isoCode":"NCD","countryCode":"PG","latitude":"-9.44380040","longitude":"147.18026710"},{"name":"New Ireland Province","isoCode":"NIK","countryCode":"PG","latitude":"-4.28532560","longitude":"152.92059180"},{"name":"Oro Province","isoCode":"NPP","countryCode":"PG","latitude":"-8.89880630","longitude":"148.18929210"},{"name":"Bougainville","isoCode":"NSB","countryCode":"PG","latitude":"-6.37539190","longitude":"155.38071010"},{"name":"Sandaun Province","isoCode":"SAN","countryCode":"PG","latitude":"-3.71261790","longitude":"141.68342750"},{"name":"Southern Highlands Province","isoCode":"SHM","countryCode":"PG","latitude":"-6.41790830","longitude":"143.56356370"},{"name":"West New Britain Province","isoCode":"WBK","countryCode":"PG","latitude":"-5.70474320","longitude":"150.02594660"},{"name":"Western Highlands Province","isoCode":"WHM","countryCode":"PG","latitude":"-5.62681280","longitude":"144.25931180"},{"name":"Western Province","isoCode":"WPD","countryCode":"PG","latitude":null,"longitude":null},{"name":"Ilocos Region","isoCode":"01","countryCode":"PH","latitude":"16.08321440","longitude":"120.61998950"},{"name":"Cagayan Valley","isoCode":"02","countryCode":"PH","latitude":"16.97537580","longitude":"121.81070790"},{"name":"Central Luzon","isoCode":"03","countryCode":"PH","latitude":"15.48277220","longitude":"120.71200230"},{"name":"Bicol Region","isoCode":"05","countryCode":"PH","latitude":"13.42098850","longitude":"123.41367360"},{"name":"Western Visayas","isoCode":"06","countryCode":"PH","latitude":"11.00498360","longitude":"122.53727410"},{"name":"Central Visayas","isoCode":"07","countryCode":"PH","latitude":"9.81687500","longitude":"124.06414190"},{"name":"Eastern Visayas","isoCode":"08","countryCode":"PH","latitude":"12.24455330","longitude":"125.03881640"},{"name":"Zamboanga Peninsula","isoCode":"09","countryCode":"PH","latitude":"8.15407700","longitude":"123.25879300"},{"name":"Northern Mindanao","isoCode":"10","countryCode":"PH","latitude":"8.02016350","longitude":"124.68565090"},{"name":"Davao Region","isoCode":"11","countryCode":"PH","latitude":"7.30416220","longitude":"126.08934060"},{"name":"Soccsksargen","isoCode":"12","countryCode":"PH","latitude":"6.27069180","longitude":"124.68565090"},{"name":"Caraga","isoCode":"13","countryCode":"PH","latitude":"8.80145620","longitude":"125.74068820"},{"name":"Autonomous Region in Muslim Mindanao","isoCode":"14","countryCode":"PH","latitude":"6.95683130","longitude":"124.24215970"},{"name":"Cordillera Administrative Region","isoCode":"15","countryCode":"PH","latitude":"17.35125420","longitude":"121.17188510"},{"name":"Calabarzon","isoCode":"40","countryCode":"PH","latitude":"14.10078030","longitude":"121.07937050"},{"name":"Mimaropa","isoCode":"41","countryCode":"PH","latitude":"9.84320650","longitude":"118.73647830"},{"name":"Abra","isoCode":"ABR","countryCode":"PH","latitude":"42.49708300","longitude":"-96.38441000"},{"name":"Agusan del Norte","isoCode":"AGN","countryCode":"PH","latitude":"8.94562590","longitude":"125.53192340"},{"name":"Agusan del Sur","isoCode":"AGS","countryCode":"PH","latitude":"8.04638880","longitude":"126.06153840"},{"name":"Aklan","isoCode":"AKL","countryCode":"PH","latitude":"11.81661090","longitude":"122.09415410"},{"name":"Albay","isoCode":"ALB","countryCode":"PH","latitude":"13.17748270","longitude":"123.52800720"},{"name":"Antique","isoCode":"ANT","countryCode":"PH","latitude":"37.03586950","longitude":"-95.63616940"},{"name":"Apayao","isoCode":"APA","countryCode":"PH","latitude":"18.01203040","longitude":"121.17103890"},{"name":"Aurora","isoCode":"AUR","countryCode":"PH","latitude":"36.97089100","longitude":"-93.71797900"},{"name":"Bataan","isoCode":"BAN","countryCode":"PH","latitude":"14.64168420","longitude":"120.48184460"},{"name":"Basilan","isoCode":"BAS","countryCode":"PH","latitude":"6.42963490","longitude":"121.98701650"},{"name":"Benguet","isoCode":"BEN","countryCode":"PH","latitude":"16.55772570","longitude":"120.80394740"},{"name":"Biliran","isoCode":"BIL","countryCode":"PH","latitude":"11.58331520","longitude":"124.46418480"},{"name":"Bohol","isoCode":"BOH","countryCode":"PH","latitude":"9.84999110","longitude":"124.14354270"},{"name":"Batangas","isoCode":"BTG","countryCode":"PH","latitude":"13.75646510","longitude":"121.05830760"},{"name":"Batanes","isoCode":"BTN","countryCode":"PH","latitude":"20.44850740","longitude":"121.97081290"},{"name":"Bukidnon","isoCode":"BUK","countryCode":"PH","latitude":"8.05150540","longitude":"124.92299460"},{"name":"Bulacan","isoCode":"BUL","countryCode":"PH","latitude":"14.79427350","longitude":"120.87990080"},{"name":"Cagayan","isoCode":"CAG","countryCode":"PH","latitude":"18.24896290","longitude":"121.87878330"},{"name":"Camiguin","isoCode":"CAM","countryCode":"PH","latitude":"9.17321640","longitude":"124.72987650"},{"name":"Camarines Norte","isoCode":"CAN","countryCode":"PH","latitude":"14.13902650","longitude":"122.76330360"},{"name":"Capiz","isoCode":"CAP","countryCode":"PH","latitude":"11.55288160","longitude":"122.74072300"},{"name":"Camarines Sur","isoCode":"CAS","countryCode":"PH","latitude":"13.52501970","longitude":"123.34861470"},{"name":"Catanduanes","isoCode":"CAT","countryCode":"PH","latitude":"13.70886840","longitude":"124.24215970"},{"name":"Cavite","isoCode":"CAV","countryCode":"PH","latitude":"14.47912970","longitude":"120.89696340"},{"name":"Cebu","isoCode":"CEB","countryCode":"PH","latitude":"10.31569920","longitude":"123.88543660"},{"name":"Compostela Valley","isoCode":"COM","countryCode":"PH","latitude":"7.51251500","longitude":"126.17626150"},{"name":"Davao Oriental","isoCode":"DAO","countryCode":"PH","latitude":"7.31715850","longitude":"126.54198870"},{"name":"Davao del Sur","isoCode":"DAS","countryCode":"PH","latitude":"6.76626870","longitude":"125.32842690"},{"name":"Davao del Norte","isoCode":"DAV","countryCode":"PH","latitude":"7.56176990","longitude":"125.65328480"},{"name":"Dinagat Islands","isoCode":"DIN","countryCode":"PH","latitude":"10.12818160","longitude":"125.60954740"},{"name":"Davao Occidental","isoCode":"DVO","countryCode":"PH","latitude":"6.09413960","longitude":"125.60954740"},{"name":"Eastern Samar","isoCode":"EAS","countryCode":"PH","latitude":"11.50007310","longitude":"125.49999080"},{"name":"Guimaras","isoCode":"GUI","countryCode":"PH","latitude":"10.59286610","longitude":"122.63250810"},{"name":"Ifugao","isoCode":"IFU","countryCode":"PH","latitude":"16.83307920","longitude":"121.17103890"},{"name":"Iloilo","isoCode":"ILI","countryCode":"PH","latitude":"10.72015010","longitude":"122.56210630"},{"name":"Ilocos Norte","isoCode":"ILN","countryCode":"PH","latitude":"18.16472810","longitude":"120.71155920"},{"name":"Ilocos Sur","isoCode":"ILS","countryCode":"PH","latitude":"17.22786640","longitude":"120.57395790"},{"name":"Isabela","isoCode":"ISA","countryCode":"PH","latitude":"18.50077590","longitude":"-67.02434620"},{"name":"Kalinga","isoCode":"KAL","countryCode":"PH","latitude":"17.47404220","longitude":"121.35416310"},{"name":"Laguna","isoCode":"LAG","countryCode":"PH","latitude":"33.54271890","longitude":"-117.78535680"},{"name":"Lanao del Norte","isoCode":"LAN","countryCode":"PH","latitude":"7.87218110","longitude":"123.88577470"},{"name":"Lanao del Sur","isoCode":"LAS","countryCode":"PH","latitude":"7.82317600","longitude":"124.41982430"},{"name":"Leyte","isoCode":"LEY","countryCode":"PH","latitude":"10.86245360","longitude":"124.88111950"},{"name":"La Union","isoCode":"LUN","countryCode":"PH","latitude":"38.87668780","longitude":"-77.12809120"},{"name":"Marinduque","isoCode":"MAD","countryCode":"PH","latitude":"13.47671710","longitude":"121.90321920"},{"name":"Maguindanao","isoCode":"MAG","countryCode":"PH","latitude":"6.94225810","longitude":"124.41982430"},{"name":"Masbate","isoCode":"MAS","countryCode":"PH","latitude":"12.35743460","longitude":"123.55040760"},{"name":"Occidental Mindoro","isoCode":"MDC","countryCode":"PH","latitude":"13.10241110","longitude":"120.76512840"},{"name":"Oriental Mindoro","isoCode":"MDR","countryCode":"PH","latitude":"13.05645980","longitude":"121.40694170"},{"name":"Mountain Province","isoCode":"MOU","countryCode":"PH","latitude":"40.70754370","longitude":"-73.95010330"},{"name":"Misamis Occidental","isoCode":"MSC","countryCode":"PH","latitude":"8.33749030","longitude":"123.70706190"},{"name":"Misamis Oriental","isoCode":"MSR","countryCode":"PH","latitude":"8.50455580","longitude":"124.62195920"},{"name":"Cotabato","isoCode":"NCO","countryCode":"PH","latitude":"7.20466680","longitude":"124.23104390"},{"name":"Metro Manila","isoCode":"NCR","countryCode":"PH","latitude":"14.60905370","longitude":"121.02225650"},{"name":"Negros Occidental","isoCode":"NEC","countryCode":"PH","latitude":"10.29256090","longitude":"123.02465180"},{"name":"Negros Oriental","isoCode":"NER","countryCode":"PH","latitude":"9.62820830","longitude":"122.98883190"},{"name":"Northern Samar","isoCode":"NSA","countryCode":"PH","latitude":"12.36131990","longitude":"124.77407930"},{"name":"Nueva Ecija","isoCode":"NUE","countryCode":"PH","latitude":"15.57837500","longitude":"121.11126150"},{"name":"Nueva Vizcaya","isoCode":"NUV","countryCode":"PH","latitude":"16.33011070","longitude":"121.17103890"},{"name":"Pampanga","isoCode":"PAM","countryCode":"PH","latitude":"15.07940900","longitude":"120.61998950"},{"name":"Pangasinan","isoCode":"PAN","countryCode":"PH","latitude":"15.89490550","longitude":"120.28631830"},{"name":"Palawan","isoCode":"PLW","countryCode":"PH","latitude":"9.83494930","longitude":"118.73836150"},{"name":"Quezon","isoCode":"QUE","countryCode":"PH","latitude":"14.03139060","longitude":"122.11309090"},{"name":"Quirino","isoCode":"QUI","countryCode":"PH","latitude":"16.27004240","longitude":"121.53700030"},{"name":"Rizal","isoCode":"RIZ","countryCode":"PH","latitude":"14.60374460","longitude":"121.30840880"},{"name":"Romblon","isoCode":"ROM","countryCode":"PH","latitude":"12.57780160","longitude":"122.26914600"},{"name":"Sarangani","isoCode":"SAR","countryCode":"PH","latitude":"5.92671750","longitude":"124.99475100"},{"name":"South Cotabato","isoCode":"SCO","countryCode":"PH","latitude":"6.33575650","longitude":"124.77407930"},{"name":"Siquijor","isoCode":"SIG","countryCode":"PH","latitude":"9.19987790","longitude":"123.59519250"},{"name":"Southern Leyte","isoCode":"SLE","countryCode":"PH","latitude":"10.33462060","longitude":"125.17087410"},{"name":"Sulu","isoCode":"SLU","countryCode":"PH","latitude":"5.97490110","longitude":"121.03351000"},{"name":"Sorsogon","isoCode":"SOR","countryCode":"PH","latitude":"12.99270950","longitude":"124.01474640"},{"name":"Sultan Kudarat","isoCode":"SUK","countryCode":"PH","latitude":"6.50694010","longitude":"124.41982430"},{"name":"Surigao del Norte","isoCode":"SUN","countryCode":"PH","latitude":"9.51482800","longitude":"125.69699840"},{"name":"Surigao del Sur","isoCode":"SUR","countryCode":"PH","latitude":"8.54049060","longitude":"126.11447580"},{"name":"Tarlac","isoCode":"TAR","countryCode":"PH","latitude":"15.47547860","longitude":"120.59634920"},{"name":"Tawi-Tawi","isoCode":"TAW","countryCode":"PH","latitude":"5.13381100","longitude":"119.95092600"},{"name":"Zamboanga del Norte","isoCode":"ZAN","countryCode":"PH","latitude":"8.38862820","longitude":"123.16888830"},{"name":"Zamboanga del Sur","isoCode":"ZAS","countryCode":"PH","latitude":"7.83830540","longitude":"123.29666570"},{"name":"Zambales","isoCode":"ZMB","countryCode":"PH","latitude":"15.50817660","longitude":"119.96978080"},{"name":"Zamboanga Sibugay","isoCode":"ZSI","countryCode":"PH","latitude":"7.52252470","longitude":"122.31075170"},{"name":"Balochistan","isoCode":"BA","countryCode":"PK","latitude":"28.49073320","longitude":"65.09577920"},{"name":"Gilgit-Baltistan","isoCode":"GB","countryCode":"PK","latitude":"35.80256670","longitude":"74.98318080"},{"name":"Islamabad Capital Territory","isoCode":"IS","countryCode":"PK","latitude":"33.72049970","longitude":"73.04052770"},{"name":"Azad Kashmir","isoCode":"JK","countryCode":"PK","latitude":"33.92590550","longitude":"73.78103340"},{"name":"Khyber Pakhtunkhwa","isoCode":"KP","countryCode":"PK","latitude":"34.95262050","longitude":"72.33111300"},{"name":"Punjab","isoCode":"PB","countryCode":"PK","latitude":"31.14713050","longitude":"75.34121790"},{"name":"Sindh","isoCode":"SD","countryCode":"PK","latitude":"25.89430180","longitude":"68.52471490"},{"name":"Federally Administered Tribal Areas","isoCode":"TA","countryCode":"PK","latitude":"32.66747600","longitude":"69.85974060"},{"name":"Lower Silesian Voivodeship","isoCode":"DS","countryCode":"PL","latitude":"51.13398610","longitude":"16.88419610"},{"name":"Kuyavian-Pomeranian Voivodeship","isoCode":"KP","countryCode":"PL","latitude":"53.16483630","longitude":"18.48342240"},{"name":"Lubusz Voivodeship","isoCode":"LB","countryCode":"PL","latitude":"52.22746120","longitude":"15.25591030"},{"name":"\u0141\xf3d\u017A Voivodeship","isoCode":"LD","countryCode":"PL","latitude":"51.46347710","longitude":"19.17269740"},{"name":"Lublin Voivodeship","isoCode":"LU","countryCode":"PL","latitude":"51.24935190","longitude":"23.10113920"},{"name":"Lesser Poland Voivodeship","isoCode":"MA","countryCode":"PL","latitude":"49.72253060","longitude":"20.25033580"},{"name":"Masovian Voivodeship","isoCode":"MZ","countryCode":"PL","latitude":"51.89271820","longitude":"21.00216790"},{"name":"Opole Voivodeship","isoCode":"OP","countryCode":"PL","latitude":"50.80037610","longitude":"17.93798900"},{"name":"Podlaskie Voivodeship","isoCode":"PD","countryCode":"PL","latitude":"53.06971590","longitude":"22.96746390"},{"name":"Podkarpackie Voivodeship","isoCode":"PK","countryCode":"PL","latitude":"50.05747490","longitude":"22.08956910"},{"name":"Pomeranian Voivodeship","isoCode":"PM","countryCode":"PL","latitude":"54.29442520","longitude":"18.15311640"},{"name":"\u015Awi\u0119tokrzyskie Voivodeship","isoCode":"SK","countryCode":"PL","latitude":"50.62610410","longitude":"20.94062790"},{"name":"Silesian Voivodeship","isoCode":"SL","countryCode":"PL","latitude":"50.57165950","longitude":"19.32197680"},{"name":"Warmian-Masurian Voivodeship","isoCode":"WN","countryCode":"PL","latitude":"53.86711170","longitude":"20.70278610"},{"name":"Greater Poland Voivodeship","isoCode":"WP","countryCode":"PL","latitude":"52.27998600","longitude":"17.35229390"},{"name":"West Pomeranian Voivodeship","isoCode":"ZP","countryCode":"PL","latitude":"53.46578910","longitude":"15.18225810"},{"name":"Aveiro","isoCode":"01","countryCode":"PT","latitude":"40.72090230","longitude":"-8.57210160"},{"name":"Beja","isoCode":"02","countryCode":"PT","latitude":"37.96877860","longitude":"-7.87216000"},{"name":"Braga","isoCode":"03","countryCode":"PT","latitude":"41.55038800","longitude":"-8.42613010"},{"name":"Bragan\xe7a","isoCode":"04","countryCode":"PT","latitude":"41.80616520","longitude":"-6.75674270"},{"name":"Castelo Branco","isoCode":"05","countryCode":"PT","latitude":"39.86313230","longitude":"-7.48141630"},{"name":"Coimbra","isoCode":"06","countryCode":"PT","latitude":"40.20579940","longitude":"-8.41369000"},{"name":"\xc9vora","isoCode":"07","countryCode":"PT","latitude":"38.57444680","longitude":"-7.90765530"},{"name":"Faro","isoCode":"08","countryCode":"PT","latitude":"37.01935480","longitude":"-7.93043970"},{"name":"Guarda","isoCode":"09","countryCode":"PT","latitude":"40.53859720","longitude":"-7.26757720"},{"name":"Leiria","isoCode":"10","countryCode":"PT","latitude":"39.77095320","longitude":"-8.79218360"},{"name":"Lisbon","isoCode":"11","countryCode":"PT","latitude":"38.72232630","longitude":"-9.13927140"},{"name":"Portalegre","isoCode":"12","countryCode":"PT","latitude":"39.29670860","longitude":"-7.42847550"},{"name":"Porto","isoCode":"13","countryCode":"PT","latitude":"41.14766290","longitude":"-8.60789730"},{"name":"Santar\xe9m","isoCode":"14","countryCode":"PT","latitude":"39.23666870","longitude":"-8.68599440"},{"name":"Set\xfabal","isoCode":"15","countryCode":"PT","latitude":"38.52409330","longitude":"-8.89258760"},{"name":"Viana do Castelo","isoCode":"16","countryCode":"PT","latitude":"41.69180460","longitude":"-8.83445100"},{"name":"Vila Real","isoCode":"17","countryCode":"PT","latitude":"41.30035270","longitude":"-7.74572740"},{"name":"Viseu","isoCode":"18","countryCode":"PT","latitude":"40.65884240","longitude":"-7.91475600"},{"name":"A\xe7ores","isoCode":"20","countryCode":"PT","latitude":"37.74124880","longitude":"-25.67559440"},{"name":"Madeira","isoCode":"30","countryCode":"PT","latitude":"32.76070740","longitude":"-16.95947230"},{"name":"Aimeliik","isoCode":"002","countryCode":"PW","latitude":"7.44558590","longitude":"134.50308780"},{"name":"Airai","isoCode":"004","countryCode":"PW","latitude":"7.39661180","longitude":"134.56902250"},{"name":"Angaur","isoCode":"010","countryCode":"PW","latitude":"6.90922300","longitude":"134.13879340"},{"name":"Hatohobei","isoCode":"050","countryCode":"PW","latitude":"3.00706580","longitude":"131.12377810"},{"name":"Kayangel","isoCode":"100","countryCode":"PW","latitude":"8.07000000","longitude":"134.70277800"},{"name":"Koror","isoCode":"150","countryCode":"PW","latitude":"7.33756460","longitude":"134.48894690"},{"name":"Melekeok","isoCode":"212","countryCode":"PW","latitude":"7.51502860","longitude":"134.59725180"},{"name":"Ngaraard","isoCode":"214","countryCode":"PW","latitude":"7.60794000","longitude":"134.63486450"},{"name":"Ngarchelong","isoCode":"218","countryCode":"PW","latitude":"7.71054690","longitude":"134.63016460"},{"name":"Ngardmau","isoCode":"222","countryCode":"PW","latitude":"7.58504860","longitude":"134.55960890"},{"name":"Ngatpang","isoCode":"224","countryCode":"PW","latitude":"7.47109940","longitude":"134.52664660"},{"name":"Ngchesar","isoCode":"226","countryCode":"PW","latitude":"7.45232800","longitude":"134.57843420"},{"name":"Ngeremlengui","isoCode":"227","countryCode":"PW","latitude":"7.51983970","longitude":"134.55960890"},{"name":"Ngiwal","isoCode":"228","countryCode":"PW","latitude":"7.56147640","longitude":"134.61606190"},{"name":"Peleliu","isoCode":"350","countryCode":"PW","latitude":"7.00229060","longitude":"134.24316280"},{"name":"Sonsorol","isoCode":"370","countryCode":"PW","latitude":"5.32681190","longitude":"132.22391170"},{"name":"Concepci\xf3n Department","isoCode":"1","countryCode":"PY","latitude":"-23.42142640","longitude":"-57.43444510"},{"name":"Alto Paran\xe1 Department","isoCode":"10","countryCode":"PY","latitude":"-25.60755460","longitude":"-54.96118360"},{"name":"Central Department","isoCode":"11","countryCode":"PY","latitude":"36.15592290","longitude":"-95.96620750"},{"name":"\xd1eembuc\xfa Department","isoCode":"12","countryCode":"PY","latitude":"-27.02991140","longitude":"-57.82539500"},{"name":"Amambay Department","isoCode":"13","countryCode":"PY","latitude":"-22.55902720","longitude":"-56.02499820"},{"name":"Canindey\xfa","isoCode":"14","countryCode":"PY","latitude":"-24.13787350","longitude":"-55.66896360"},{"name":"Presidente Hayes Department","isoCode":"15","countryCode":"PY","latitude":"-23.35126050","longitude":"-58.73736340"},{"name":"Alto Paraguay Department","isoCode":"16","countryCode":"PY","latitude":"-20.08525080","longitude":"-59.47209040"},{"name":"Boquer\xf3n Department","isoCode":"19","countryCode":"PY","latitude":"-21.74492540","longitude":"-60.95400730"},{"name":"San Pedro Department","isoCode":"2","countryCode":"PY","latitude":"-24.19486680","longitude":"-56.56164700"},{"name":"Cordillera Department","isoCode":"3","countryCode":"PY","latitude":"-25.22894910","longitude":"-57.01116810"},{"name":"Guair\xe1 Department","isoCode":"4","countryCode":"PY","latitude":"-25.88109320","longitude":"-56.29293810"},{"name":"Caaguaz\xfa","isoCode":"5","countryCode":"PY","latitude":"-25.46458180","longitude":"-56.01385100"},{"name":"Caazap\xe1","isoCode":"6","countryCode":"PY","latitude":"-26.18277130","longitude":"-56.37123270"},{"name":"Itap\xfaa","isoCode":"7","countryCode":"PY","latitude":"-26.79236230","longitude":"-55.66896360"},{"name":"Misiones Department","isoCode":"8","countryCode":"PY","latitude":"-26.84335120","longitude":"-57.10131880"},{"name":"Paraguar\xed Department","isoCode":"9","countryCode":"PY","latitude":"-25.62621740","longitude":"-57.15206420"},{"name":"Doha","isoCode":"DA","countryCode":"QA","latitude":"25.28544730","longitude":"51.53103980"},{"name":"Al Khor","isoCode":"KH","countryCode":"QA","latitude":"25.68040780","longitude":"51.49685020"},{"name":"Madinat ash Shamal","isoCode":"MS","countryCode":"QA","latitude":"26.11827430","longitude":"51.21572650"},{"name":"Al Rayyan Municipality","isoCode":"RA","countryCode":"QA","latitude":"25.25225510","longitude":"51.43887130"},{"name":"Al-Shahaniya","isoCode":"SH","countryCode":"QA","latitude":"25.41063860","longitude":"51.18460250"},{"name":"Umm Salal Municipality","isoCode":"US","countryCode":"QA","latitude":"25.48752420","longitude":"51.39656800"},{"name":"Al Wakrah","isoCode":"WA","countryCode":"QA","latitude":"25.16593140","longitude":"51.59755240"},{"name":"Al Daayen","isoCode":"ZA","countryCode":"QA","latitude":"25.57845590","longitude":"51.48213870"},{"name":"Alba","isoCode":"AB","countryCode":"RO","latitude":"44.70091530","longitude":"8.03569110"},{"name":"Arges","isoCode":"AG","countryCode":"RO","latitude":"45.07225270","longitude":"24.81427260"},{"name":"Arad County","isoCode":"AR","countryCode":"RO","latitude":"46.22836510","longitude":"21.65978190"},{"name":"Bucharest","isoCode":"B","countryCode":"RO","latitude":"44.42676740","longitude":"26.10253840"},{"name":"Bac\u0103u County","isoCode":"BC","countryCode":"RO","latitude":"46.32581840","longitude":"26.66237800"},{"name":"Bihor County","isoCode":"BH","countryCode":"RO","latitude":"47.01575160","longitude":"22.17226600"},{"name":"Bistri\u021Ba-N\u0103s\u0103ud County","isoCode":"BN","countryCode":"RO","latitude":"47.24861070","longitude":"24.53228140"},{"name":"Braila","isoCode":"BR","countryCode":"RO","latitude":"45.26524630","longitude":"27.95947140"},{"name":"Boto\u0219ani County","isoCode":"BT","countryCode":"RO","latitude":"47.89240420","longitude":"26.75917810"},{"name":"Bra\u0219ov County","isoCode":"BV","countryCode":"RO","latitude":"45.77818440","longitude":"25.22258000"},{"name":"Buz\u0103u County","isoCode":"BZ","countryCode":"RO","latitude":"45.33509120","longitude":"26.71075780"},{"name":"Cluj County","isoCode":"CJ","countryCode":"RO","latitude":"46.79417970","longitude":"23.61214920"},{"name":"C\u0103l\u0103ra\u0219i County","isoCode":"CL","countryCode":"RO","latitude":"44.36587150","longitude":"26.75486070"},{"name":"Cara\u0219-Severin County","isoCode":"CS","countryCode":"RO","latitude":"45.11396460","longitude":"22.07409930"},{"name":"Constan\u021Ba County","isoCode":"CT","countryCode":"RO","latitude":"44.21298700","longitude":"28.25500550"},{"name":"Covasna County","isoCode":"CV","countryCode":"RO","latitude":"45.94263470","longitude":"25.89189840"},{"name":"D\xe2mbovi\u021Ba County","isoCode":"DB","countryCode":"RO","latitude":"44.92898930","longitude":"25.42538500"},{"name":"Dolj County","isoCode":"DJ","countryCode":"RO","latitude":"44.16230220","longitude":"23.63250540"},{"name":"Gorj County","isoCode":"GJ","countryCode":"RO","latitude":"44.94855950","longitude":"23.24270790"},{"name":"Gala\u021Bi County","isoCode":"GL","countryCode":"RO","latitude":"45.78005690","longitude":"27.82515760"},{"name":"Giurgiu County","isoCode":"GR","countryCode":"RO","latitude":"43.90370760","longitude":"25.96992650"},{"name":"Hunedoara County","isoCode":"HD","countryCode":"RO","latitude":"45.79363800","longitude":"22.99759930"},{"name":"Harghita County","isoCode":"HR","countryCode":"RO","latitude":"46.49285070","longitude":"25.64566960"},{"name":"Ilfov County","isoCode":"IF","countryCode":"RO","latitude":"44.53554800","longitude":"26.23248860"},{"name":"Ialomi\u021Ba County","isoCode":"IL","countryCode":"RO","latitude":"44.60313300","longitude":"27.37899140"},{"name":"Ia\u0219i County","isoCode":"IS","countryCode":"RO","latitude":"47.26796530","longitude":"27.21856620"},{"name":"Mehedin\u021Bi County","isoCode":"MH","countryCode":"RO","latitude":"44.55150530","longitude":"22.90441570"},{"name":"Maramure\u0219 County","isoCode":"MM","countryCode":"RO","latitude":"46.55699040","longitude":"24.67232150"},{"name":"Mure\u0219 County","isoCode":"MS","countryCode":"RO","latitude":"46.55699040","longitude":"24.67232150"},{"name":"Neam\u021B County","isoCode":"NT","countryCode":"RO","latitude":"46.97586850","longitude":"26.38187640"},{"name":"Olt County","isoCode":"OT","countryCode":"RO","latitude":"44.20079700","longitude":"24.50229810"},{"name":"Prahova County","isoCode":"PH","countryCode":"RO","latitude":"45.08919060","longitude":"26.08293130"},{"name":"Sibiu County","isoCode":"SB","countryCode":"RO","latitude":"45.92691060","longitude":"24.22548070"},{"name":"S\u0103laj County","isoCode":"SJ","countryCode":"RO","latitude":"47.20908130","longitude":"23.21219010"},{"name":"Satu Mare County","isoCode":"SM","countryCode":"RO","latitude":"47.76689050","longitude":"22.92413770"},{"name":"Suceava County","isoCode":"SV","countryCode":"RO","latitude":"47.55055480","longitude":"25.74106200"},{"name":"Tulcea County","isoCode":"TL","countryCode":"RO","latitude":"45.04505650","longitude":"29.03249120"},{"name":"Timi\u0219 County","isoCode":"TM","countryCode":"RO","latitude":"45.81389020","longitude":"21.33310550"},{"name":"Teleorman County","isoCode":"TR","countryCode":"RO","latitude":"44.01604910","longitude":"25.29866280"},{"name":"V\xe2lcea County","isoCode":"VL","countryCode":"RO","latitude":"45.07980510","longitude":"24.08352830"},{"name":"Vrancea County","isoCode":"VN","countryCode":"RO","latitude":"45.81348760","longitude":"27.06575310"},{"name":"Vaslui County","isoCode":"VS","countryCode":"RO","latitude":"46.46310590","longitude":"27.73980310"},{"name":"Belgrade","isoCode":"00","countryCode":"RS","latitude":"44.78656800","longitude":"20.44892160"},{"name":"North Ba\u010Dka District","isoCode":"01","countryCode":"RS","latitude":"45.98033940","longitude":"19.59070010"},{"name":"Central Banat District","isoCode":"02","countryCode":"RS","latitude":"45.47884850","longitude":"20.60825220"},{"name":"North Banat District","isoCode":"03","countryCode":"RS","latitude":"45.90683900","longitude":"19.99934170"},{"name":"South Banat District","isoCode":"04","countryCode":"RS","latitude":"45.00274570","longitude":"21.05425090"},{"name":"West Ba\u010Dka District","isoCode":"05","countryCode":"RS","latitude":"45.73553850","longitude":"19.18973640"},{"name":"South Ba\u010Dka District","isoCode":"06","countryCode":"RS","latitude":"45.48903440","longitude":"19.69761870"},{"name":"Srem District","isoCode":"07","countryCode":"RS","latitude":"45.00291710","longitude":"19.80137730"},{"name":"Ma\u010Dva District","isoCode":"08","countryCode":"RS","latitude":"44.59253140","longitude":"19.50822460"},{"name":"Kolubara District","isoCode":"09","countryCode":"RS","latitude":"44.35098110","longitude":"20.00043050"},{"name":"Podunavlje District","isoCode":"10","countryCode":"RS","latitude":"44.47291560","longitude":"20.99014260"},{"name":"Brani\u010Devo District","isoCode":"11","countryCode":"RS","latitude":"44.69822460","longitude":"21.54467750"},{"name":"\u0160umadija District","isoCode":"12","countryCode":"RS","latitude":"44.20506780","longitude":"20.78565650"},{"name":"Pomoravlje District","isoCode":"13","countryCode":"RS","latitude":"43.95913790","longitude":"21.27135300"},{"name":"Bor District","isoCode":"14","countryCode":"RS","latitude":"44.06989180","longitude":"22.09850860"},{"name":"Zaje\u010Dar District","isoCode":"15","countryCode":"RS","latitude":"43.90150480","longitude":"22.27380110"},{"name":"Zlatibor District","isoCode":"16","countryCode":"RS","latitude":"43.64541700","longitude":"19.71014550"},{"name":"Moravica District","isoCode":"17","countryCode":"RS","latitude":"43.84147000","longitude":"20.29049870"},{"name":"Ra\u0161ka District","isoCode":"18","countryCode":"RS","latitude":"43.33734610","longitude":"20.57340050"},{"name":"Rasina District","isoCode":"19","countryCode":"RS","latitude":"43.52635250","longitude":"21.15881780"},{"name":"Ni\u0161ava District","isoCode":"20","countryCode":"RS","latitude":"43.37389020","longitude":"21.93223310"},{"name":"Toplica District","isoCode":"21","countryCode":"RS","latitude":"43.19065920","longitude":"21.34077620"},{"name":"Pirot District","isoCode":"22","countryCode":"RS","latitude":"43.08740360","longitude":"22.59830440"},{"name":"Jablanica District","isoCode":"23","countryCode":"RS","latitude":"42.94815600","longitude":"21.81293210"},{"name":"P\u010Dinja District","isoCode":"24","countryCode":"RS","latitude":"42.58363620","longitude":"22.14302150"},{"name":"Vojvodina","isoCode":"VO","countryCode":"RS","latitude":"45.26086510","longitude":"19.83193380"},{"name":"Republic of Adygea","isoCode":"AD","countryCode":"RU","latitude":"44.82291550","longitude":"40.17544630"},{"name":"Altai Republic","isoCode":"AL","countryCode":"RU","latitude":"50.61819240","longitude":"86.21993080"},{"name":"Altai Krai","isoCode":"ALT","countryCode":"RU","latitude":"51.79362980","longitude":"82.67585960"},{"name":"Amur Oblast","isoCode":"AMU","countryCode":"RU","latitude":"54.60350650","longitude":"127.48017210"},{"name":"Arkhangelsk","isoCode":"ARK","countryCode":"RU","latitude":"64.54585490","longitude":"40.55057690"},{"name":"Astrakhan Oblast","isoCode":"AST","countryCode":"RU","latitude":"46.13211660","longitude":"48.06101150"},{"name":"Republic of Bashkortostan","isoCode":"BA","countryCode":"RU","latitude":"54.23121720","longitude":"56.16452570"},{"name":"Belgorod Oblast","isoCode":"BEL","countryCode":"RU","latitude":"50.71069260","longitude":"37.75333770"},{"name":"Bryansk Oblast","isoCode":"BRY","countryCode":"RU","latitude":"53.04085990","longitude":"33.26909000"},{"name":"Republic of Buryatia","isoCode":"BU","countryCode":"RU","latitude":"54.83311460","longitude":"112.40605300"},{"name":"Chechen Republic","isoCode":"CE","countryCode":"RU","latitude":"43.40233010","longitude":"45.71874680"},{"name":"Chelyabinsk Oblast","isoCode":"CHE","countryCode":"RU","latitude":"54.43194220","longitude":"60.87889630"},{"name":"Chukotka Autonomous Okrug","isoCode":"CHU","countryCode":"RU","latitude":"65.62983550","longitude":"171.69521590"},{"name":"Chuvash Republic","isoCode":"CU","countryCode":"RU","latitude":"55.55959920","longitude":"46.92835350"},{"name":"Republic of Dagestan","isoCode":"DA","countryCode":"RU","latitude":"42.14318860","longitude":"47.09497990"},{"name":"Republic of Ingushetia","isoCode":"IN","countryCode":"RU","latitude":"43.40516980","longitude":"44.82029990"},{"name":"Irkutsk","isoCode":"IRK","countryCode":"RU","latitude":"52.28548340","longitude":"104.28902220"},{"name":"Ivanovo Oblast","isoCode":"IVA","countryCode":"RU","latitude":"57.10568540","longitude":"41.48300840"},{"name":"Kamchatka Krai","isoCode":"KAM","countryCode":"RU","latitude":"61.43439810","longitude":"166.78841310"},{"name":"Kabardino-Balkar Republic","isoCode":"KB","countryCode":"RU","latitude":"43.39324690","longitude":"43.56284980"},{"name":"Karachay-Cherkess Republic","isoCode":"KC","countryCode":"RU","latitude":"43.88451430","longitude":"41.73039390"},{"name":"Krasnodar Krai","isoCode":"KDA","countryCode":"RU","latitude":"45.64152890","longitude":"39.70559770"},{"name":"Kemerovo Oblast","isoCode":"KEM","countryCode":"RU","latitude":"54.75746480","longitude":"87.40552880"},{"name":"Kaliningrad","isoCode":"KGD","countryCode":"RU","latitude":"54.71042640","longitude":"20.45221440"},{"name":"Kurgan Oblast","isoCode":"KGN","countryCode":"RU","latitude":"55.44815480","longitude":"65.11809750"},{"name":"Khabarovsk Krai","isoCode":"KHA","countryCode":"RU","latitude":"50.58884310","longitude":"135.00000000"},{"name":"Khanty-Mansi Autonomous Okrug","isoCode":"KHM","countryCode":"RU","latitude":"62.22870620","longitude":"70.64100570"},{"name":"Kirov Oblast","isoCode":"KIR","countryCode":"RU","latitude":"58.41985290","longitude":"50.20972480"},{"name":"Republic of Khakassia","isoCode":"KK","countryCode":"RU","latitude":"53.04522810","longitude":"90.39821450"},{"name":"Republic of Kalmykia","isoCode":"KL","countryCode":"RU","latitude":"46.18671760","longitude":"45.00000000"},{"name":"Kaluga Oblast","isoCode":"KLU","countryCode":"RU","latitude":"54.38726660","longitude":"35.18890940"},{"name":"Komi Republic","isoCode":"KO","countryCode":"RU","latitude":"63.86305390","longitude":"54.83126900"},{"name":"Kostroma Oblast","isoCode":"KOS","countryCode":"RU","latitude":"58.55010690","longitude":"43.95411020"},{"name":"Republic of Karelia","isoCode":"KR","countryCode":"RU","latitude":"63.15587020","longitude":"32.99055520"},{"name":"Kursk Oblast","isoCode":"KRS","countryCode":"RU","latitude":"51.76340260","longitude":"35.38118120"},{"name":"Krasnoyarsk Krai","isoCode":"KYA","countryCode":"RU","latitude":"64.24797580","longitude":"95.11041760"},{"name":"Leningrad Oblast","isoCode":"LEN","countryCode":"RU","latitude":"60.07932080","longitude":"31.89266450"},{"name":"Lipetsk Oblast","isoCode":"LIP","countryCode":"RU","latitude":"52.52647020","longitude":"39.20322690"},{"name":"Magadan Oblast","isoCode":"MAG","countryCode":"RU","latitude":"62.66434170","longitude":"153.91499100"},{"name":"Mari El Republic","isoCode":"ME","countryCode":"RU","latitude":"56.43845700","longitude":"47.96077580"},{"name":"Republic of Mordovia","isoCode":"MO","countryCode":"RU","latitude":"54.23694410","longitude":"44.06839700"},{"name":"Moscow Oblast","isoCode":"MOS","countryCode":"RU","latitude":"55.34039600","longitude":"38.29176510"},{"name":"Moscow","isoCode":"MOW","countryCode":"RU","latitude":"55.75582600","longitude":"37.61729990"},{"name":"Murmansk Oblast","isoCode":"MUR","countryCode":"RU","latitude":"67.84426740","longitude":"35.08841020"},{"name":"Nenets Autonomous Okrug","isoCode":"NEN","countryCode":"RU","latitude":"67.60783370","longitude":"57.63383310"},{"name":"Novgorod Oblast","isoCode":"NGR","countryCode":"RU","latitude":"58.24275520","longitude":"32.56651900"},{"name":"Nizhny Novgorod Oblast","isoCode":"NIZ","countryCode":"RU","latitude":"55.79951590","longitude":"44.02967690"},{"name":"Novosibirsk","isoCode":"NVS","countryCode":"RU","latitude":"54.98326930","longitude":"82.89638310"},{"name":"Omsk Oblast","isoCode":"OMS","countryCode":"RU","latitude":"55.05546690","longitude":"73.31673420"},{"name":"Orenburg Oblast","isoCode":"ORE","countryCode":"RU","latitude":"51.76340260","longitude":"54.61881880"},{"name":"Oryol Oblast","isoCode":"ORL","countryCode":"RU","latitude":"52.78564140","longitude":"36.92423440"},{"name":"Perm Krai","isoCode":"PER","countryCode":"RU","latitude":"58.82319290","longitude":"56.58724810"},{"name":"Penza Oblast","isoCode":"PNZ","countryCode":"RU","latitude":"53.14121050","longitude":"44.09400480"},{"name":"Primorsky Krai","isoCode":"PRI","countryCode":"RU","latitude":"45.05256410","longitude":"135.00000000"},{"name":"Pskov Oblast","isoCode":"PSK","countryCode":"RU","latitude":"56.77085990","longitude":"29.09400900"},{"name":"Rostov Oblast","isoCode":"ROS","countryCode":"RU","latitude":"47.68532470","longitude":"41.82589520"},{"name":"Ryazan Oblast","isoCode":"RYA","countryCode":"RU","latitude":"54.38759640","longitude":"41.25956610"},{"name":"Sakha Republic","isoCode":"SA","countryCode":"RU","latitude":"66.76134510","longitude":"124.12375300"},{"name":"Sakhalin","isoCode":"SAK","countryCode":"RU","latitude":"50.69098480","longitude":"142.95056890"},{"name":"Samara Oblast","isoCode":"SAM","countryCode":"RU","latitude":"53.41838390","longitude":"50.47255280"},{"name":"Saratov Oblast","isoCode":"SAR","countryCode":"RU","latitude":"51.83692630","longitude":"46.75393970"},{"name":"Republic of North Ossetia-Alania","isoCode":"SE","countryCode":"RU","latitude":"43.04513020","longitude":"44.28709720"},{"name":"Smolensk Oblast","isoCode":"SMO","countryCode":"RU","latitude":"54.98829940","longitude":"32.66773780"},{"name":"Saint Petersburg","isoCode":"SPE","countryCode":"RU","latitude":"59.93105840","longitude":"30.36090960"},{"name":"Stavropol Krai","isoCode":"STA","countryCode":"RU","latitude":"44.66809930","longitude":"43.52021400"},{"name":"Sverdlovsk","isoCode":"SVE","countryCode":"RU","latitude":"56.84309930","longitude":"60.64540860"},{"name":"Republic of Tatarstan","isoCode":"TA","countryCode":"RU","latitude":"55.18023640","longitude":"50.72639450"},{"name":"Tambov Oblast","isoCode":"TAM","countryCode":"RU","latitude":"52.64165890","longitude":"41.42164510"},{"name":"Tomsk Oblast","isoCode":"TOM","countryCode":"RU","latitude":"58.89698820","longitude":"82.67655000"},{"name":"Tula Oblast","isoCode":"TUL","countryCode":"RU","latitude":"54.16376800","longitude":"37.56495070"},{"name":"Tver Oblast","isoCode":"TVE","countryCode":"RU","latitude":"57.00216540","longitude":"33.98531420"},{"name":"Tuva Republic","isoCode":"TY","countryCode":"RU","latitude":"51.88726690","longitude":"95.62601720"},{"name":"Tyumen Oblast","isoCode":"TYU","countryCode":"RU","latitude":"56.96343870","longitude":"66.94827800"},{"name":"Sevastopol","isoCode":"UA-40","countryCode":"RU","latitude":"44.61665000","longitude":"33.52536710"},{"name":"Udmurt Republic","isoCode":"UD","countryCode":"RU","latitude":"57.06702180","longitude":"53.02779480"},{"name":"Ulyanovsk Oblast","isoCode":"ULY","countryCode":"RU","latitude":"53.97933570","longitude":"47.77624250"},{"name":"Volgograd Oblast","isoCode":"VGG","countryCode":"RU","latitude":"49.25873930","longitude":"39.81544630"},{"name":"Vladimir Oblast","isoCode":"VLA","countryCode":"RU","latitude":"56.15534650","longitude":"40.59266850"},{"name":"Vologda Oblast","isoCode":"VLG","countryCode":"RU","latitude":"59.87067110","longitude":"40.65554110"},{"name":"Voronezh Oblast","isoCode":"VOR","countryCode":"RU","latitude":"50.85897130","longitude":"39.86443740"},{"name":"Yamalo-Nenets Autonomous Okrug","isoCode":"YAN","countryCode":"RU","latitude":"66.06530570","longitude":"76.93451930"},{"name":"Yaroslavl Oblast","isoCode":"YAR","countryCode":"RU","latitude":"57.89915230","longitude":"38.83886330"},{"name":"Jewish Autonomous Oblast","isoCode":"YEV","countryCode":"RU","latitude":"48.48081470","longitude":"131.76573670"},{"name":"Zabaykalsky Krai","isoCode":"ZAB","countryCode":"RU","latitude":"53.09287710","longitude":"116.96765610"},{"name":"Kigali district","isoCode":"01","countryCode":"RW","latitude":"-1.94407270","longitude":"30.06188510"},{"name":"Eastern Province","isoCode":"02","countryCode":"RW","latitude":null,"longitude":null},{"name":"Northern Province","isoCode":"03","countryCode":"RW","latitude":null,"longitude":null},{"name":"Western Province","isoCode":"04","countryCode":"RW","latitude":null,"longitude":null},{"name":"Southern Province","isoCode":"05","countryCode":"RW","latitude":null,"longitude":null},{"name":"Riyadh","isoCode":"01","countryCode":"SA","latitude":"22.75543850","longitude":"46.20915470"},{"name":"Makkah","isoCode":"02","countryCode":"SA","latitude":"21.52355840","longitude":"41.91964710"},{"name":"Al Madinah","isoCode":"03","countryCode":"SA","latitude":"24.84039770","longitude":"39.32062410"},{"name":"Eastern Province","isoCode":"04","countryCode":"SA","latitude":"24.04399320","longitude":"45.65892250"},{"name":"Al-Qassim","isoCode":"05","countryCode":"SA","latitude":"26.20782600","longitude":"43.48373800"},{"name":"Ha\'il","isoCode":"06","countryCode":"SA","latitude":"27.70761430","longitude":"41.91964710"},{"name":"Tabuk","isoCode":"07","countryCode":"SA","latitude":"28.24533350","longitude":"37.63866220"},{"name":"Northern Borders","isoCode":"08","countryCode":"SA","latitude":"30.07991620","longitude":"42.86378750"},{"name":"Jizan","isoCode":"09","countryCode":"SA","latitude":"17.17381760","longitude":"42.70761070"},{"name":"Najran","isoCode":"10","countryCode":"SA","latitude":"18.35146640","longitude":"45.60071080"},{"name":"Al Bahah","isoCode":"11","countryCode":"SA","latitude":"20.27227390","longitude":"41.44125100"},{"name":"Al Jawf","isoCode":"12","countryCode":"SA","latitude":"29.88735600","longitude":"39.32062410"},{"name":"\'Asir","isoCode":"14","countryCode":"SA","latitude":"19.09690620","longitude":"42.86378750"},{"name":"Central Province","isoCode":"CE","countryCode":"SB","latitude":null,"longitude":null},{"name":"Choiseul Province","isoCode":"CH","countryCode":"SB","latitude":"-7.05014940","longitude":"156.95114590"},{"name":"Honiara","isoCode":"CT","countryCode":"SB","latitude":"-9.44563810","longitude":"159.97289990"},{"name":"Guadalcanal Province","isoCode":"GU","countryCode":"SB","latitude":"-9.57732840","longitude":"160.14558050"},{"name":"Isabel Province","isoCode":"IS","countryCode":"SB","latitude":"-8.05923530","longitude":"159.14470810"},{"name":"Makira-Ulawa Province","isoCode":"MK","countryCode":"SB","latitude":"-10.57374470","longitude":"161.80969410"},{"name":"Malaita Province","isoCode":"ML","countryCode":"SB","latitude":"-8.94461680","longitude":"160.90712360"},{"name":"Rennell and Bellona Province","isoCode":"RB","countryCode":"SB","latitude":"-11.61314350","longitude":"160.16939490"},{"name":"Temotu Province","isoCode":"TE","countryCode":"SB","latitude":"-10.68692900","longitude":"166.06239790"},{"name":"Western Province","isoCode":"WE","countryCode":"SB","latitude":null,"longitude":null},{"name":"Anse-aux-Pins","isoCode":"01","countryCode":"SC","latitude":"-4.69004430","longitude":"55.51502890"},{"name":"Anse Boileau","isoCode":"02","countryCode":"SC","latitude":"-4.70472680","longitude":"55.48593630"},{"name":"Au Cap","isoCode":"04","countryCode":"SC","latitude":"-4.70597230","longitude":"55.50810120"},{"name":"Anse Royale","isoCode":"05","countryCode":"SC","latitude":"-4.74079880","longitude":"55.50810120"},{"name":"Baie Lazare","isoCode":"06","countryCode":"SC","latitude":"-4.74825250","longitude":"55.48593630"},{"name":"Baie Sainte Anne","isoCode":"07","countryCode":"SC","latitude":"47.05259000","longitude":"-64.95245790"},{"name":"Beau Vallon","isoCode":"08","countryCode":"SC","latitude":"-4.62109670","longitude":"55.42778020"},{"name":"Bel Air","isoCode":"09","countryCode":"SC","latitude":"34.10024550","longitude":"-118.45946300"},{"name":"Bel Ombre","isoCode":"10","countryCode":"SC","latitude":"-20.50100950","longitude":"57.42596240"},{"name":"Cascade","isoCode":"11","countryCode":"SC","latitude":"44.51628210","longitude":"-116.04179830"},{"name":"Glacis","isoCode":"12","countryCode":"SC","latitude":"47.11573030","longitude":"-70.30281830"},{"name":"Grand\'Anse Mah\xe9","isoCode":"13","countryCode":"SC","latitude":"-4.67739200","longitude":"55.46377700"},{"name":"Grand\'Anse Praslin","isoCode":"14","countryCode":"SC","latitude":"-4.31762190","longitude":"55.70783630"},{"name":"La Digue","isoCode":"15","countryCode":"SC","latitude":"49.76669220","longitude":"-97.15466290"},{"name":"La Rivi\xe8re Anglaise","isoCode":"16","countryCode":"SC","latitude":"-4.61061500","longitude":"55.45408410"},{"name":"Mont Buxton","isoCode":"17","countryCode":"SC","latitude":"-4.61666670","longitude":"55.44577680"},{"name":"Mont Fleuri","isoCode":"18","countryCode":"SC","latitude":"-4.63565430","longitude":"55.45546880"},{"name":"Plaisance","isoCode":"19","countryCode":"SC","latitude":"45.60709500","longitude":"-75.11427450"},{"name":"Pointe La Rue","isoCode":"20","countryCode":"SC","latitude":"-4.68048900","longitude":"55.51918570"},{"name":"Port Glaud","isoCode":"21","countryCode":"SC","latitude":"-4.64885230","longitude":"55.41947530"},{"name":"Saint Louis","isoCode":"22","countryCode":"SC","latitude":"38.62700250","longitude":"-90.19940420"},{"name":"Takamaka","isoCode":"23","countryCode":"SC","latitude":"37.96459170","longitude":"-1.22177270"},{"name":"Les Mamelles","isoCode":"24","countryCode":"SC","latitude":"38.82505050","longitude":"-90.48345170"},{"name":"Roche Caiman","isoCode":"25","countryCode":"SC","latitude":"-4.63960280","longitude":"55.46793150"},{"name":"Central Darfur","isoCode":"DC","countryCode":"SD","latitude":"14.37827470","longitude":"24.90422080"},{"name":"East Darfur","isoCode":"DE","countryCode":"SD","latitude":"14.37827470","longitude":"24.90422080"},{"name":"North Darfur","isoCode":"DN","countryCode":"SD","latitude":"15.76619690","longitude":"24.90422080"},{"name":"South Darfur","isoCode":"DS","countryCode":"SD","latitude":"11.64886390","longitude":"24.90422080"},{"name":"West Darfur","isoCode":"DW","countryCode":"SD","latitude":"12.84635610","longitude":"23.00119890"},{"name":"Al Qadarif","isoCode":"GD","countryCode":"SD","latitude":"14.02430700","longitude":"35.36856790"},{"name":"West Kordofan","isoCode":"GK","countryCode":"SD","latitude":"11.19901920","longitude":"29.41793240"},{"name":"Al Jazirah","isoCode":"GZ","countryCode":"SD","latitude":"14.88596110","longitude":"33.43835300"},{"name":"Kassala","isoCode":"KA","countryCode":"SD","latitude":"15.45813320","longitude":"36.40396290"},{"name":"Khartoum","isoCode":"KH","countryCode":"SD","latitude":"15.50065440","longitude":"32.55989940"},{"name":"North Kordofan","isoCode":"KN","countryCode":"SD","latitude":"13.83064410","longitude":"29.41793240"},{"name":"South Kordofan","isoCode":"KS","countryCode":"SD","latitude":"11.19901920","longitude":"29.41793240"},{"name":"Blue Nile","isoCode":"NB","countryCode":"SD","latitude":"47.59867300","longitude":"-122.33441900"},{"name":"Northern","isoCode":"NO","countryCode":"SD","latitude":"38.06381700","longitude":"-84.46286480"},{"name":"River Nile","isoCode":"NR","countryCode":"SD","latitude":"23.97275950","longitude":"32.87492060"},{"name":"White Nile","isoCode":"NW","countryCode":"SD","latitude":"9.33215160","longitude":"31.46153000"},{"name":"Red Sea","isoCode":"RS","countryCode":"SD","latitude":"20.28023200","longitude":"38.51257300"},{"name":"Sennar","isoCode":"SI","countryCode":"SD","latitude":"13.56746900","longitude":"33.56720450"},{"name":"Stockholm County","isoCode":"AB","countryCode":"SE","latitude":"59.60249580","longitude":"18.13843830"},{"name":"V\xe4sterbotten County","isoCode":"AC","countryCode":"SE","latitude":"65.33373110","longitude":"16.51616940"},{"name":"Norrbotten County","isoCode":"BD","countryCode":"SE","latitude":"66.83092160","longitude":"20.39919660"},{"name":"Uppsala County","isoCode":"C","countryCode":"SE","latitude":"60.00922620","longitude":"17.27145880"},{"name":"S\xf6dermanland County","isoCode":"D","countryCode":"SE","latitude":"59.03363490","longitude":"16.75188990"},{"name":"\xd6sterg\xf6tland County","isoCode":"E","countryCode":"SE","latitude":"58.34536350","longitude":"15.51978440"},{"name":"J\xf6nk\xf6ping County","isoCode":"F","countryCode":"SE","latitude":"57.37084340","longitude":"14.34391740"},{"name":"Kronoberg County","isoCode":"G","countryCode":"SE","latitude":"56.71834030","longitude":"14.41146730"},{"name":"Kalmar County","isoCode":"H","countryCode":"SE","latitude":"57.23501560","longitude":"16.18493490"},{"name":"Gotland County","isoCode":"I","countryCode":"SE","latitude":"57.46841210","longitude":"18.48674470"},{"name":"Blekinge","isoCode":"K","countryCode":"SE","latitude":"56.27838370","longitude":"15.01800580"},{"name":"Sk\xe5ne County","isoCode":"M","countryCode":"SE","latitude":"55.99025720","longitude":"13.59576920"},{"name":"Halland County","isoCode":"N","countryCode":"SE","latitude":"56.89668050","longitude":"12.80339930"},{"name":"V\xe4stra G\xf6taland County","isoCode":"O","countryCode":"SE","latitude":"58.25279260","longitude":"13.05964250"},{"name":"V\xe4rmland County","isoCode":"S","countryCode":"SE","latitude":"59.72940650","longitude":"13.23540240"},{"name":"\xd6rebro County","isoCode":"T","countryCode":"SE","latitude":"59.53503600","longitude":"15.00657310"},{"name":"V\xe4stmanland County","isoCode":"U","countryCode":"SE","latitude":"59.67138790","longitude":"16.21589530"},{"name":"Dalarna County","isoCode":"W","countryCode":"SE","latitude":"61.09170120","longitude":"14.66636530"},{"name":"G\xe4vleborg County","isoCode":"X","countryCode":"SE","latitude":"61.30119930","longitude":"16.15342140"},{"name":"V\xe4sternorrland County","isoCode":"Y","countryCode":"SE","latitude":"63.42764730","longitude":"17.72924440"},{"name":"Central Singapore Community Development Council","isoCode":"01","countryCode":"SG","latitude":"1.29868","longitude":"103.85367"},{"name":"North East Community Development Council","isoCode":"02","countryCode":"SG","latitude":"1.31421","longitude":"103.85822"},{"name":"North West Community Development Council","isoCode":"03","countryCode":"SG","latitude":"1.29868","longitude":"103.81986"},{"name":"South East Community Development Council","isoCode":"04","countryCode":"SG","latitude":"1.30683","longitude":"103.88698"},{"name":"South West Community Development Council","isoCode":"05","countryCode":"SG","latitude":"1.31464","longitude":"103.83007"},{"name":"Ajdov\u0161\u010Dina Municipality","isoCode":"001","countryCode":"SI","latitude":"45.88707760","longitude":"13.90428180"},{"name":"Beltinci Municipality","isoCode":"002","countryCode":"SI","latitude":"46.60791530","longitude":"16.23651270"},{"name":"Bled Municipality","isoCode":"003","countryCode":"SI","latitude":"46.36832660","longitude":"14.11457980"},{"name":"Bohinj Municipality","isoCode":"004","countryCode":"SI","latitude":"46.30056520","longitude":"13.94271950"},{"name":"Borovnica Municipality","isoCode":"005","countryCode":"SI","latitude":"45.90445250","longitude":"14.38241890"},{"name":"Bovec Municipality","isoCode":"006","countryCode":"SI","latitude":"46.33804950","longitude":"13.55241740"},{"name":"Brda Municipality","isoCode":"007","countryCode":"SI","latitude":"45.99756520","longitude":"13.52704740"},{"name":"Brezovica Municipality","isoCode":"008","countryCode":"SI","latitude":"45.95593510","longitude":"14.43499520"},{"name":"Bre\u017Eice Municipality","isoCode":"009","countryCode":"SI","latitude":"45.90410960","longitude":"15.59436390"},{"name":"Ti\u0161ina Municipality","isoCode":"010","countryCode":"SI","latitude":"46.65418840","longitude":"16.07547810"},{"name":"City Municipality of Celje","isoCode":"011","countryCode":"SI","latitude":"46.23974950","longitude":"15.26770630"},{"name":"Cerklje na Gorenjskem Municipality","isoCode":"012","countryCode":"SI","latitude":"46.25170540","longitude":"14.48579790"},{"name":"Cerknica Municipality","isoCode":"013","countryCode":"SI","latitude":"45.79662550","longitude":"14.39217700"},{"name":"Cerkno Municipality","isoCode":"014","countryCode":"SI","latitude":"46.12884140","longitude":"13.98940270"},{"name":"\u010Cren\u0161ovci Municipality","isoCode":"015","countryCode":"SI","latitude":"46.57200290","longitude":"16.28773460"},{"name":"\u010Crna na Koro\u0161kem Municipality","isoCode":"016","countryCode":"SI","latitude":"46.47045290","longitude":"14.84999980"},{"name":"\u010Crnomelj Municipality","isoCode":"017","countryCode":"SI","latitude":"45.53612250","longitude":"15.19441430"},{"name":"Destrnik Municipality","isoCode":"018","countryCode":"SI","latitude":"46.49223680","longitude":"15.87779560"},{"name":"Diva\u010Da Municipality","isoCode":"019","countryCode":"SI","latitude":"45.68060690","longitude":"13.97203120"},{"name":"Dobrepolje Municipality","isoCode":"020","countryCode":"SI","latitude":"45.85249510","longitude":"14.70831090"},{"name":"Dobrova\u2013Polhov Gradec Municipality","isoCode":"021","countryCode":"SI","latitude":"46.06488960","longitude":"14.31681950"},{"name":"Dol pri Ljubljani Municipality","isoCode":"022","countryCode":"SI","latitude":"46.08843860","longitude":"14.64247920"},{"name":"Dom\u017Eale Municipality","isoCode":"023","countryCode":"SI","latitude":"46.14382690","longitude":"14.63752790"},{"name":"Dornava Municipality","isoCode":"024","countryCode":"SI","latitude":"46.44435130","longitude":"15.98891590"},{"name":"Dravograd Municipality","isoCode":"025","countryCode":"SI","latitude":"46.58921900","longitude":"15.02460210"},{"name":"Duplek Municipality","isoCode":"026","countryCode":"SI","latitude":"46.50100160","longitude":"15.75463070"},{"name":"Gorenja Vas\u2013Poljane Municipality","isoCode":"027","countryCode":"SI","latitude":"46.11165820","longitude":"14.11493480"},{"name":"Gori\u0161nica Municipality","isoCode":"028","countryCode":"SI","latitude":"46.41202710","longitude":"16.01330890"},{"name":"Gornja Radgona Municipality","isoCode":"029","countryCode":"SI","latitude":"46.67670990","longitude":"15.99108470"},{"name":"Gornji Grad Municipality","isoCode":"030","countryCode":"SI","latitude":"46.29617120","longitude":"14.80623470"},{"name":"Gornji Petrovci Municipality","isoCode":"031","countryCode":"SI","latitude":"46.80371280","longitude":"16.21913790"},{"name":"Grosuplje Municipality","isoCode":"032","countryCode":"SI","latitude":"45.95576450","longitude":"14.65889900"},{"name":"\u0160alovci Municipality","isoCode":"033","countryCode":"SI","latitude":"46.85335680","longitude":"16.25917910"},{"name":"Hrastnik Municipality","isoCode":"034","countryCode":"SI","latitude":"46.14172880","longitude":"15.08448940"},{"name":"Hrpelje\u2013Kozina Municipality","isoCode":"035","countryCode":"SI","latitude":"45.60911920","longitude":"13.93791480"},{"name":"Idrija Municipality","isoCode":"036","countryCode":"SI","latitude":"46.00409390","longitude":"13.97754930"},{"name":"Ig Municipality","isoCode":"037","countryCode":"SI","latitude":"45.95888680","longitude":"14.52705280"},{"name":"Municipality of Ilirska Bistrica","isoCode":"038","countryCode":"SI","latitude":"45.57913230","longitude":"14.28097290"},{"name":"Ivan\u010Dna Gorica Municipality","isoCode":"039","countryCode":"SI","latitude":"45.93958410","longitude":"14.80476260"},{"name":"Izola Municipality","isoCode":"040","countryCode":"SI","latitude":"45.53135570","longitude":"13.66646490"},{"name":"Jesenice Municipality","isoCode":"041","countryCode":"SI","latitude":"46.43670470","longitude":"14.05260570"},{"name":"Jur\u0161inci Municipality","isoCode":"042","countryCode":"SI","latitude":"46.48986510","longitude":"15.98092300"},{"name":"Kamnik Municipality","isoCode":"043","countryCode":"SI","latitude":"46.22216660","longitude":"14.60707270"},{"name":"Kanal ob So\u010Di Municipality","isoCode":"044","countryCode":"SI","latitude":"46.06735300","longitude":"13.62033500"},{"name":"Kidri\u010Devo Municipality","isoCode":"045","countryCode":"SI","latitude":"46.39575720","longitude":"15.79259060"},{"name":"Kobarid Municipality","isoCode":"046","countryCode":"SI","latitude":"46.24569710","longitude":"13.57869490"},{"name":"Kobilje Municipality","isoCode":"047","countryCode":"SI","latitude":"46.68518000","longitude":"16.39367190"},{"name":"Ko\u010Devje Municipality","isoCode":"048","countryCode":"SI","latitude":"45.64280000","longitude":"14.86158380"},{"name":"Komen Municipality","isoCode":"049","countryCode":"SI","latitude":"45.81752350","longitude":"13.74827110"},{"name":"Koper City Municipality","isoCode":"050","countryCode":"SI","latitude":"45.54805900","longitude":"13.73018770"},{"name":"Kozje Municipality","isoCode":"051","countryCode":"SI","latitude":"46.07332110","longitude":"15.55967190"},{"name":"Kranj City Municipality","isoCode":"052","countryCode":"SI","latitude":"46.25850210","longitude":"14.35435690"},{"name":"Kranjska Gora Municipality","isoCode":"053","countryCode":"SI","latitude":"46.48452930","longitude":"13.78571450"},{"name":"Municipality of Kr\u0161ko","isoCode":"054","countryCode":"SI","latitude":"45.95896090","longitude":"15.49235550"},{"name":"Kungota","isoCode":"055","countryCode":"SI","latitude":"46.64187930","longitude":"15.60362880"},{"name":"Kuzma Municipality","isoCode":"056","countryCode":"SI","latitude":"46.83510380","longitude":"16.08071000"},{"name":"La\u0161ko Municipality","isoCode":"057","countryCode":"SI","latitude":"46.15422360","longitude":"15.23614910"},{"name":"Lenart Municipality","isoCode":"058","countryCode":"SI","latitude":"46.58344240","longitude":"15.82621250"},{"name":"Lendava Municipality","isoCode":"059","countryCode":"SI","latitude":"46.55134830","longitude":"16.44198390"},{"name":"Litija Municipality","isoCode":"060","countryCode":"SI","latitude":"46.05732260","longitude":"14.83096360"},{"name":"Ljubljana City Municipality","isoCode":"061","countryCode":"SI","latitude":"46.05694650","longitude":"14.50575150"},{"name":"Ljubno Municipality","isoCode":"062","countryCode":"SI","latitude":"46.34431250","longitude":"14.83354920"},{"name":"Ljutomer Municipality","isoCode":"063","countryCode":"SI","latitude":"46.51908480","longitude":"16.18932160"},{"name":"Logatec Municipality","isoCode":"064","countryCode":"SI","latitude":"45.91761100","longitude":"14.23514510"},{"name":"Lo\u0161ka Dolina Municipality","isoCode":"065","countryCode":"SI","latitude":"45.64779080","longitude":"14.49731470"},{"name":"Lo\u0161ki Potok Municipality","isoCode":"066","countryCode":"SI","latitude":"45.69096370","longitude":"14.59859700"},{"name":"Lu\u010De Municipality","isoCode":"067","countryCode":"SI","latitude":"46.35449250","longitude":"14.74715040"},{"name":"Lukovica Municipality","isoCode":"068","countryCode":"SI","latitude":"46.16962930","longitude":"14.69072590"},{"name":"Maj\u0161perk Municipality","isoCode":"069","countryCode":"SI","latitude":"46.35030190","longitude":"15.73405950"},{"name":"Maribor City Municipality","isoCode":"070","countryCode":"SI","latitude":"46.55064960","longitude":"15.62054390"},{"name":"Medvode Municipality","isoCode":"071","countryCode":"SI","latitude":"46.14190800","longitude":"14.40325960"},{"name":"Menge\u0161 Municipality","isoCode":"072","countryCode":"SI","latitude":"46.16591220","longitude":"14.57196940"},{"name":"Metlika Municipality","isoCode":"073","countryCode":"SI","latitude":"45.64807150","longitude":"15.31778380"},{"name":"Me\u017Eica Municipality","isoCode":"074","countryCode":"SI","latitude":"46.52150270","longitude":"14.85213400"},{"name":"Miren\u2013Kostanjevica Municipality","isoCode":"075","countryCode":"SI","latitude":"45.84360290","longitude":"13.62766470"},{"name":"Mislinja Municipality","isoCode":"076","countryCode":"SI","latitude":"46.44294030","longitude":"15.19876780"},{"name":"Morav\u010De Municipality","isoCode":"077","countryCode":"SI","latitude":"46.13627810","longitude":"14.74600100"},{"name":"Moravske Toplice Municipality","isoCode":"078","countryCode":"SI","latitude":"46.68569320","longitude":"16.22245820"},{"name":"Mozirje Municipality","isoCode":"079","countryCode":"SI","latitude":"46.33943500","longitude":"14.96024130"},{"name":"Murska Sobota City Municipality","isoCode":"080","countryCode":"SI","latitude":"46.64321470","longitude":"16.15157540"},{"name":"Muta Municipality","isoCode":"081","countryCode":"SI","latitude":"46.60973660","longitude":"15.16299950"},{"name":"Naklo Municipality","isoCode":"082","countryCode":"SI","latitude":"46.27186630","longitude":"14.31569320"},{"name":"Nazarje Municipality","isoCode":"083","countryCode":"SI","latitude":"46.28217410","longitude":"14.92256290"},{"name":"Nova Gorica City Municipality","isoCode":"084","countryCode":"SI","latitude":"45.97627600","longitude":"13.73088810"},{"name":"City Municipality of Novo Mesto","isoCode":"085","countryCode":"SI","latitude":"45.80108240","longitude":"15.17100890"},{"name":"Odranci Municipality","isoCode":"086","countryCode":"SI","latitude":"46.59010170","longitude":"16.27881650"},{"name":"Ormo\u017E Municipality","isoCode":"087","countryCode":"SI","latitude":"46.43533330","longitude":"16.15437400"},{"name":"Osilnica Municipality","isoCode":"088","countryCode":"SI","latitude":"45.54184670","longitude":"14.71563030"},{"name":"Pesnica Municipality","isoCode":"089","countryCode":"SI","latitude":"46.60887550","longitude":"15.67570510"},{"name":"Piran Municipality","isoCode":"090","countryCode":"SI","latitude":"45.52888560","longitude":"13.56807350"},{"name":"Pivka Municipality","isoCode":"091","countryCode":"SI","latitude":"45.67892960","longitude":"14.25426890"},{"name":"Pod\u010Detrtek Municipality","isoCode":"092","countryCode":"SI","latitude":"46.17395420","longitude":"15.60138160"},{"name":"Podvelka Municipality","isoCode":"093","countryCode":"SI","latitude":"46.62219520","longitude":"15.38899220"},{"name":"Postojna Municipality","isoCode":"094","countryCode":"SI","latitude":"45.77493900","longitude":"14.21342630"},{"name":"Preddvor Municipality","isoCode":"095","countryCode":"SI","latitude":"46.30171390","longitude":"14.42181650"},{"name":"Ptuj City Municipality","isoCode":"096","countryCode":"SI","latitude":"46.41995350","longitude":"15.86968840"},{"name":"Puconci Municipality","isoCode":"097","countryCode":"SI","latitude":"46.72004180","longitude":"16.09977920"},{"name":"Ra\u010De\u2013Fram Municipality","isoCode":"098","countryCode":"SI","latitude":"46.45420830","longitude":"15.63294670"},{"name":"Rade\u010De Municipality","isoCode":"099","countryCode":"SI","latitude":"46.06669540","longitude":"15.18204380"},{"name":"Radenci Municipality","isoCode":"100","countryCode":"SI","latitude":"46.62311210","longitude":"16.05069030"},{"name":"Radlje ob Dravi Municipality","isoCode":"101","countryCode":"SI","latitude":"46.61357320","longitude":"15.23544380"},{"name":"Radovljica Municipality","isoCode":"102","countryCode":"SI","latitude":"46.33558270","longitude":"14.20945340"},{"name":"Ravne na Koro\u0161kem Municipality","isoCode":"103","countryCode":"SI","latitude":"46.55211940","longitude":"14.95990840"},{"name":"Ribnica Municipality","isoCode":"104","countryCode":"SI","latitude":"45.74003030","longitude":"14.72657820"},{"name":"Roga\u0161ovci Municipality","isoCode":"105","countryCode":"SI","latitude":"46.80557850","longitude":"16.03452370"},{"name":"Roga\u0161ka Slatina Municipality","isoCode":"106","countryCode":"SI","latitude":"46.24539730","longitude":"15.62650140"},{"name":"Rogatec Municipality","isoCode":"107","countryCode":"SI","latitude":"46.22866260","longitude":"15.69913380"},{"name":"Ru\u0161e Municipality","isoCode":"108","countryCode":"SI","latitude":"46.52062650","longitude":"15.48178690"},{"name":"Semi\u010D Municipality","isoCode":"109","countryCode":"SI","latitude":"45.65205340","longitude":"15.18207010"},{"name":"Sevnica Municipality","isoCode":"110","countryCode":"SI","latitude":"46.00703170","longitude":"15.30456790"},{"name":"Se\u017Eana Municipality","isoCode":"111","countryCode":"SI","latitude":"45.72751090","longitude":"13.86619310"},{"name":"Slovenj Gradec City Municipality","isoCode":"112","countryCode":"SI","latitude":"46.48777180","longitude":"15.07294780"},{"name":"Slovenska Bistrica Municipality","isoCode":"113","countryCode":"SI","latitude":"46.39198130","longitude":"15.57278690"},{"name":"Slovenske Konjice Municipality","isoCode":"114","countryCode":"SI","latitude":"46.33691910","longitude":"15.42147080"},{"name":"Star\u0161e Municipality","isoCode":"115","countryCode":"SI","latitude":"46.46743310","longitude":"15.76405460"},{"name":"Sveti Jurij ob \u0160\u010Davnici Municipality","isoCode":"116","countryCode":"SI","latitude":"46.56874520","longitude":"16.02225280"},{"name":"\u0160en\u010Dur Municipality","isoCode":"117","countryCode":"SI","latitude":"46.24336990","longitude":"14.41922230"},{"name":"\u0160entilj Municipality","isoCode":"118","countryCode":"SI","latitude":"46.68628390","longitude":"15.71035670"},{"name":"\u0160entjernej Municipality","isoCode":"119","countryCode":"SI","latitude":"45.84341300","longitude":"15.33783120"},{"name":"\u0160entjur Municipality","isoCode":"120","countryCode":"SI","latitude":"46.26543390","longitude":"15.40800000"},{"name":"\u0160kocjan Municipality","isoCode":"121","countryCode":"SI","latitude":"45.91754540","longitude":"15.31017360"},{"name":"\u0160kofja Loka Municipality","isoCode":"122","countryCode":"SI","latitude":"46.14098440","longitude":"14.28118730"},{"name":"Municipality of \u0160kofljica","isoCode":"123","countryCode":"SI","latitude":"45.98409620","longitude":"14.57466260"},{"name":"\u0160marje pri Jel\u0161ah Municipality","isoCode":"124","countryCode":"SI","latitude":"46.22870250","longitude":"15.51903530"},{"name":"\u0160martno ob Paki Municipality","isoCode":"125","countryCode":"SI","latitude":"46.32903720","longitude":"15.03339370"},{"name":"\u0160o\u0161tanj Municipality","isoCode":"126","countryCode":"SI","latitude":"46.37828360","longitude":"15.04613780"},{"name":"\u0160tore Municipality","isoCode":"127","countryCode":"SI","latitude":"46.22225140","longitude":"15.31261160"},{"name":"Tolmin Municipality","isoCode":"128","countryCode":"SI","latitude":"46.18571880","longitude":"13.73198380"},{"name":"Trbovlje Municipality","isoCode":"129","countryCode":"SI","latitude":"46.15035630","longitude":"15.04531370"},{"name":"Trebnje Municipality","isoCode":"130","countryCode":"SI","latitude":"45.90801630","longitude":"15.01319050"},{"name":"Tr\u017Ei\u010D Municipality","isoCode":"131","countryCode":"SI","latitude":"46.35935140","longitude":"14.30066230"},{"name":"Turni\u0161\u010De Municipality","isoCode":"132","countryCode":"SI","latitude":"46.61375040","longitude":"16.32021000"},{"name":"Velike La\u0161\u010De Municipality","isoCode":"134","countryCode":"SI","latitude":"45.83365910","longitude":"14.63623630"},{"name":"Videm Municipality","isoCode":"135","countryCode":"SI","latitude":"46.36383300","longitude":"15.87812120"},{"name":"Vipava Municipality","isoCode":"136","countryCode":"SI","latitude":"45.84126740","longitude":"13.96096130"},{"name":"Vitanje Municipality","isoCode":"137","countryCode":"SI","latitude":"46.38153230","longitude":"15.29506870"},{"name":"Vodice Municipality","isoCode":"138","countryCode":"SI","latitude":"46.18966430","longitude":"14.49385390"},{"name":"Vojnik Municipality","isoCode":"139","countryCode":"SI","latitude":"46.29205810","longitude":"15.30205800"},{"name":"Vrhnika Municipality","isoCode":"140","countryCode":"SI","latitude":"45.95027190","longitude":"14.32764220"},{"name":"Vuzenica Municipality","isoCode":"141","countryCode":"SI","latitude":"46.59808360","longitude":"15.16572370"},{"name":"Zagorje ob Savi Municipality","isoCode":"142","countryCode":"SI","latitude":"46.13452020","longitude":"14.99643840"},{"name":"Zavr\u010D Municipality","isoCode":"143","countryCode":"SI","latitude":"46.35713000","longitude":"16.04777470"},{"name":"Zre\u010De Municipality","isoCode":"144","countryCode":"SI","latitude":"46.41777860","longitude":"15.37094310"},{"name":"\u017Delezniki Municipality","isoCode":"146","countryCode":"SI","latitude":"46.22563770","longitude":"14.16936170"},{"name":"\u017Diri Municipality","isoCode":"147","countryCode":"SI","latitude":"46.04724990","longitude":"14.10984510"},{"name":"Benedikt Municipality","isoCode":"148","countryCode":"SI","latitude":"46.61558410","longitude":"15.89572810"},{"name":"Bistrica ob Sotli Municipality","isoCode":"149","countryCode":"SI","latitude":"46.05655790","longitude":"15.66259470"},{"name":"Bloke Municipality","isoCode":"150","countryCode":"SI","latitude":"45.77281410","longitude":"14.50634590"},{"name":"Braslov\u010De Municipality","isoCode":"151","countryCode":"SI","latitude":"46.28361920","longitude":"15.04183200"},{"name":"Cankova Municipality","isoCode":"152","countryCode":"SI","latitude":"46.71823700","longitude":"16.01972220"},{"name":"Cerkvenjak Municipality","isoCode":"153","countryCode":"SI","latitude":"46.56707110","longitude":"15.94297530"},{"name":"Dobje Municipality","isoCode":"154","countryCode":"SI","latitude":"46.13700370","longitude":"15.39412900"},{"name":"Dobrna Municipality","isoCode":"155","countryCode":"SI","latitude":"46.33561410","longitude":"15.22597320"},{"name":"Dobrovnik Municipality","isoCode":"156","countryCode":"SI","latitude":"46.65386620","longitude":"16.35065940"},{"name":"Dolenjske Toplice Municipality","isoCode":"157","countryCode":"SI","latitude":"45.73457110","longitude":"15.01294930"},{"name":"Grad Municipality","isoCode":"158","countryCode":"SI","latitude":"46.80873200","longitude":"16.10920600"},{"name":"Hajdina Municipality","isoCode":"159","countryCode":"SI","latitude":"46.41850140","longitude":"15.82447220"},{"name":"Ho\u010De\u2013Slivnica Municipality","isoCode":"160","countryCode":"SI","latitude":"46.47785800","longitude":"15.64760050"},{"name":"Hodo\u0161 Municipality","isoCode":"161","countryCode":"SI","latitude":"46.83141340","longitude":"16.32106800"},{"name":"Horjul Municipality","isoCode":"162","countryCode":"SI","latitude":"46.02253780","longitude":"14.29862690"},{"name":"Jezersko Municipality","isoCode":"163","countryCode":"SI","latitude":"46.39427940","longitude":"14.49855590"},{"name":"Komenda Municipality","isoCode":"164","countryCode":"SI","latitude":"46.20648800","longitude":"14.53824990"},{"name":"Kostel Municipality","isoCode":"165","countryCode":"SI","latitude":"45.49282550","longitude":"14.87082350"},{"name":"Kri\u017Eevci Municipality","isoCode":"166","countryCode":"SI","latitude":"46.57018210","longitude":"16.10926530"},{"name":"Lovrenc na Pohorju Municipality","isoCode":"167","countryCode":"SI","latitude":"46.54196380","longitude":"15.40004430"},{"name":"Markovci Municipality","isoCode":"168","countryCode":"SI","latitude":"46.38793090","longitude":"15.95860140"},{"name":"Miklav\u017E na Dravskem Polju Municipality","isoCode":"169","countryCode":"SI","latitude":"46.50826280","longitude":"15.69520650"},{"name":"Mirna Pe\u010D Municipality","isoCode":"170","countryCode":"SI","latitude":"45.84815740","longitude":"15.08794500"},{"name":"Oplotnica","isoCode":"171","countryCode":"SI","latitude":"46.38716300","longitude":"15.44581310"},{"name":"Podlehnik Municipality","isoCode":"172","countryCode":"SI","latitude":"46.33107820","longitude":"15.87858360"},{"name":"Polzela Municipality","isoCode":"173","countryCode":"SI","latitude":"46.28089700","longitude":"15.07373210"},{"name":"Prebold Municipality","isoCode":"174","countryCode":"SI","latitude":"46.23591360","longitude":"15.09369120"},{"name":"Prevalje Municipality","isoCode":"175","countryCode":"SI","latitude":"46.56211460","longitude":"14.88478610"},{"name":"Razkri\u017Eje Municipality","isoCode":"176","countryCode":"SI","latitude":"46.52263390","longitude":"16.26686380"},{"name":"Ribnica na Pohorju Municipality","isoCode":"177","countryCode":"SI","latitude":"46.53561450","longitude":"15.26745380"},{"name":"Selnica ob Dravi Municipality","isoCode":"178","countryCode":"SI","latitude":"46.55139180","longitude":"15.49294100"},{"name":"Sodra\u017Eica Municipality","isoCode":"179","countryCode":"SI","latitude":"45.76165650","longitude":"14.63528530"},{"name":"Sol\u010Dava Municipality","isoCode":"180","countryCode":"SI","latitude":"46.40235260","longitude":"14.68023040"},{"name":"Sveta Ana Municipality","isoCode":"181","countryCode":"SI","latitude":"46.65000000","longitude":"15.84527800"},{"name":"Sveti Andra\u017E v Slovenskih Goricah Municipality","isoCode":"182","countryCode":"SI","latitude":"46.51897470","longitude":"15.94982620"},{"name":"\u0160empeter\u2013Vrtojba Municipality","isoCode":"183","countryCode":"SI","latitude":"45.92900950","longitude":"13.64155940"},{"name":"Tabor Municipality","isoCode":"184","countryCode":"SI","latitude":"46.21079210","longitude":"15.01742490"},{"name":"Trnovska Vas Municipality","isoCode":"185","countryCode":"SI","latitude":"46.52940350","longitude":"15.88531180"},{"name":"Trzin Municipality","isoCode":"186","countryCode":"SI","latitude":"46.12982410","longitude":"14.55776370"},{"name":"Velika Polana Municipality","isoCode":"187","countryCode":"SI","latitude":"46.57317150","longitude":"16.34441260"},{"name":"Ver\u017Eej Municipality","isoCode":"188","countryCode":"SI","latitude":"46.58411350","longitude":"16.16208000"},{"name":"Vransko Municipality","isoCode":"189","countryCode":"SI","latitude":"46.23900600","longitude":"14.95272490"},{"name":"\u017Dalec Municipality","isoCode":"190","countryCode":"SI","latitude":"46.25197120","longitude":"15.16500720"},{"name":"\u017Detale Municipality","isoCode":"191","countryCode":"SI","latitude":"46.27428330","longitude":"15.79133590"},{"name":"\u017Dirovnica Municipality","isoCode":"192","countryCode":"SI","latitude":"46.39544030","longitude":"14.15396320"},{"name":"\u017Du\u017Eemberk Municipality","isoCode":"193","countryCode":"SI","latitude":"45.82003500","longitude":"14.95359190"},{"name":"\u0160martno pri Litiji Municipality","isoCode":"194","countryCode":"SI","latitude":"46.04549710","longitude":"14.84101330"},{"name":"Municipality of Apa\u010De","isoCode":"195","countryCode":"SI","latitude":"46.69746790","longitude":"15.91025340"},{"name":"Municipality of Cirkulane","isoCode":"196","countryCode":"SI","latitude":"46.32983220","longitude":"15.99806660"},{"name":"Kostanjevica na Krki Municipality","isoCode":"197","countryCode":"SI","latitude":"45.83166380","longitude":"15.44119060"},{"name":"Makole Municipality","isoCode":"198","countryCode":"SI","latitude":"46.31686970","longitude":"15.66641260"},{"name":"Mokronog\u2013Trebelno Municipality","isoCode":"199","countryCode":"SI","latitude":"45.90885290","longitude":"15.15967360"},{"name":"Polj\u010Dane Municipality","isoCode":"200","countryCode":"SI","latitude":"46.31398530","longitude":"15.57847910"},{"name":"Ren\u010De\u2013Vogrsko Municipality","isoCode":"201","countryCode":"SI","latitude":"45.89546170","longitude":"13.67856730"},{"name":"Sredi\u0161\u010De ob Dravi","isoCode":"202","countryCode":"SI","latitude":"46.39592820","longitude":"16.27049150"},{"name":"Stra\u017Ea Municipality","isoCode":"203","countryCode":"SI","latitude":"45.77684280","longitude":"15.09486940"},{"name":"Sveta Trojica v Slovenskih Goricah Municipality","isoCode":"204","countryCode":"SI","latitude":"46.56808090","longitude":"15.88230640"},{"name":"Sveti Toma\u017E Municipality","isoCode":"205","countryCode":"SI","latitude":"46.48352830","longitude":"16.07944200"},{"name":"\u0160marje\u0161ke Toplice Municipality","isoCode":"206","countryCode":"SI","latitude":"45.86803770","longitude":"15.23474220"},{"name":"Gorje Municipality","isoCode":"207","countryCode":"SI","latitude":"46.38024580","longitude":"14.06853390"},{"name":"Log\u2013Dragomer Municipality","isoCode":"208","countryCode":"SI","latitude":"46.01787470","longitude":"14.36877670"},{"name":"Re\u010Dica ob Savinji Municipality","isoCode":"209","countryCode":"SI","latitude":"46.32337900","longitude":"14.92236700"},{"name":"Sveti Jurij v Slovenskih Goricah Municipality","isoCode":"210","countryCode":"SI","latitude":"46.61707910","longitude":"15.78046770"},{"name":"\u0160entrupert Municipality","isoCode":"211","countryCode":"SI","latitude":"45.98731420","longitude":"15.08297830"},{"name":"Mirna Municipality","isoCode":"212","countryCode":"SI","latitude":"45.95156470","longitude":"15.06209770"},{"name":"Ankaran Municipality","isoCode":"213","countryCode":"SI","latitude":"45.57845100","longitude":"13.73691740"},{"name":"Bansk\xe1 Bystrica Region","isoCode":"BC","countryCode":"SK","latitude":"48.53124990","longitude":"19.38287400"},{"name":"Bratislava Region","isoCode":"BL","countryCode":"SK","latitude":"48.31183040","longitude":"17.19732990"},{"name":"Ko\u0161ice Region","isoCode":"KI","countryCode":"SK","latitude":"48.63757370","longitude":"21.08342250"},{"name":"Nitra Region","isoCode":"NI","countryCode":"SK","latitude":"48.01437650","longitude":"18.54165040"},{"name":"Pre\u0161ov Region","isoCode":"PV","countryCode":"SK","latitude":"49.17167730","longitude":"21.37420010"},{"name":"Trnava Region","isoCode":"TA","countryCode":"SK","latitude":"48.39438980","longitude":"17.72162050"},{"name":"Tren\u010D\xedn Region","isoCode":"TC","countryCode":"SK","latitude":"48.80867580","longitude":"18.23240260"},{"name":"\u017Dilina Region","isoCode":"ZI","countryCode":"SK","latitude":"49.20314350","longitude":"19.36457330"},{"name":"Eastern Province","isoCode":"E","countryCode":"SL","latitude":null,"longitude":null},{"name":"Northern Province","isoCode":"N","countryCode":"SL","latitude":null,"longitude":null},{"name":"Southern Province","isoCode":"S","countryCode":"SL","latitude":null,"longitude":null},{"name":"Western Area","isoCode":"W","countryCode":"SL","latitude":"40.25459690","longitude":"-80.24554440"},{"name":"Acquaviva","isoCode":"01","countryCode":"SM","latitude":"41.86715970","longitude":"14.74694790"},{"name":"Chiesanuova","isoCode":"02","countryCode":"SM","latitude":"45.42261720","longitude":"7.65038540"},{"name":"Domagnano","isoCode":"03","countryCode":"SM","latitude":"43.95019290","longitude":"12.46815370"},{"name":"Faetano","isoCode":"04","countryCode":"SM","latitude":"43.93489670","longitude":"12.48965540"},{"name":"Fiorentino","isoCode":"05","countryCode":"SM","latitude":"43.90783370","longitude":"12.45812090"},{"name":"Borgo Maggiore","isoCode":"06","countryCode":"SM","latitude":"43.95748820","longitude":"12.45525460"},{"name":"San Marino","isoCode":"07","countryCode":"SM","latitude":"43.94236000","longitude":"12.45777700"},{"name":"Montegiardino","isoCode":"08","countryCode":"SM","latitude":"43.90529990","longitude":"12.48105420"},{"name":"Serravalle","isoCode":"09","countryCode":"SM","latitude":"44.72320840","longitude":"8.85740050"},{"name":"Diourbel Region","isoCode":"DB","countryCode":"SN","latitude":"14.72830850","longitude":"-16.25221430"},{"name":"Dakar","isoCode":"DK","countryCode":"SN","latitude":"14.71667700","longitude":"-17.46768610"},{"name":"Fatick","isoCode":"FK","countryCode":"SN","latitude":"14.33901670","longitude":"-16.41114250"},{"name":"Kaffrine","isoCode":"KA","countryCode":"SN","latitude":"14.10520200","longitude":"-15.54157550"},{"name":"Kolda","isoCode":"KD","countryCode":"SN","latitude":"12.91074950","longitude":"-14.95056710"},{"name":"K\xe9dougou","isoCode":"KE","countryCode":"SN","latitude":"12.56046070","longitude":"-12.17470770"},{"name":"Kaolack","isoCode":"KL","countryCode":"SN","latitude":"14.16520830","longitude":"-16.07577490"},{"name":"Louga","isoCode":"LG","countryCode":"SN","latitude":"15.61417680","longitude":"-16.22868000"},{"name":"Matam","isoCode":"MT","countryCode":"SN","latitude":"15.66002250","longitude":"-13.25769060"},{"name":"S\xe9dhiou","isoCode":"SE","countryCode":"SN","latitude":"12.70460400","longitude":"-15.55623040"},{"name":"Saint-Louis","isoCode":"SL","countryCode":"SN","latitude":"38.62700250","longitude":"-90.19940420"},{"name":"Tambacounda Region","isoCode":"TC","countryCode":"SN","latitude":"13.56190110","longitude":"-13.17403480"},{"name":"Thi\xe8s Region","isoCode":"TH","countryCode":"SN","latitude":"14.79100520","longitude":"-16.93586040"},{"name":"Ziguinchor","isoCode":"ZG","countryCode":"SN","latitude":"12.56414790","longitude":"-16.26398250"},{"name":"Awdal Region","isoCode":"AW","countryCode":"SO","latitude":"10.63342850","longitude":"43.32946600"},{"name":"Bakool","isoCode":"BK","countryCode":"SO","latitude":"4.36572210","longitude":"44.09603110"},{"name":"Banaadir","isoCode":"BN","countryCode":"SO","latitude":"2.11873750","longitude":"45.33694590"},{"name":"Bari","isoCode":"BR","countryCode":"SO","latitude":"41.11714320","longitude":"16.87187150"},{"name":"Bay","isoCode":"BY","countryCode":"SO","latitude":"37.03655340","longitude":"-95.61747670"},{"name":"Galguduud","isoCode":"GA","countryCode":"SO","latitude":"5.18501280","longitude":"46.82528380"},{"name":"Gedo","isoCode":"GE","countryCode":"SO","latitude":"3.50392270","longitude":"42.23624350"},{"name":"Hiran","isoCode":"HI","countryCode":"SO","latitude":"4.32101500","longitude":"45.29938620"},{"name":"Middle Juba","isoCode":"JD","countryCode":"SO","latitude":"2.07804880","longitude":"41.60118140"},{"name":"Lower Juba","isoCode":"JH","countryCode":"SO","latitude":"0.22402100","longitude":"41.60118140"},{"name":"Mudug","isoCode":"MU","countryCode":"SO","latitude":"6.56567260","longitude":"47.76375650"},{"name":"Nugal","isoCode":"NU","countryCode":"SO","latitude":"43.27938610","longitude":"17.03392050"},{"name":"Sanaag Region","isoCode":"SA","countryCode":"SO","latitude":"10.39382180","longitude":"47.76375650"},{"name":"Middle Shebelle","isoCode":"SD","countryCode":"SO","latitude":"2.92502470","longitude":"45.90396890"},{"name":"Lower Shebelle","isoCode":"SH","countryCode":"SO","latitude":"1.87664580","longitude":"44.24790150"},{"name":"Togdheer Region","isoCode":"TO","countryCode":"SO","latitude":"9.44605870","longitude":"45.29938620"},{"name":"Brokopondo District","isoCode":"BR","countryCode":"SR","latitude":"4.77102470","longitude":"-55.04933750"},{"name":"Commewijne District","isoCode":"CM","countryCode":"SR","latitude":"5.74021100","longitude":"-54.87312190"},{"name":"Coronie District","isoCode":"CR","countryCode":"SR","latitude":"5.69432710","longitude":"-56.29293810"},{"name":"Marowijne District","isoCode":"MA","countryCode":"SR","latitude":"5.62681280","longitude":"-54.25931180"},{"name":"Nickerie District","isoCode":"NI","countryCode":"SR","latitude":"5.58554690","longitude":"-56.83111170"},{"name":"Paramaribo District","isoCode":"PM","countryCode":"SR","latitude":"5.85203550","longitude":"-55.20382780"},{"name":"Para District","isoCode":"PR","countryCode":"SR","latitude":"5.48173180","longitude":"-55.22592070"},{"name":"Saramacca District","isoCode":"SA","countryCode":"SR","latitude":"5.72408130","longitude":"-55.66896360"},{"name":"Sipaliwini District","isoCode":"SI","countryCode":"SR","latitude":"3.65673820","longitude":"-56.20353870"},{"name":"Wanica District","isoCode":"WA","countryCode":"SR","latitude":"5.73237620","longitude":"-55.27012350"},{"name":"Northern Bahr el Ghazal","isoCode":"BN","countryCode":"SS","latitude":"8.53604490","longitude":"26.79678490"},{"name":"Western Bahr el Ghazal","isoCode":"BW","countryCode":"SS","latitude":"8.64523990","longitude":"25.28375850"},{"name":"Central Equatoria","isoCode":"EC","countryCode":"SS","latitude":"4.61440630","longitude":"31.26263660"},{"name":"Eastern Equatoria","isoCode":"EE","countryCode":"SS","latitude":"5.06929950","longitude":"33.43835300"},{"name":"Western Equatoria","isoCode":"EW","countryCode":"SS","latitude":"5.34717990","longitude":"28.29943500"},{"name":"Jonglei State","isoCode":"JG","countryCode":"SS","latitude":"7.18196190","longitude":"32.35609520"},{"name":"Lakes","isoCode":"LK","countryCode":"SS","latitude":"37.16282550","longitude":"-95.69116230"},{"name":"Upper Nile","isoCode":"NU","countryCode":"SS","latitude":"9.88942020","longitude":"32.71813750"},{"name":"Unity","isoCode":"UY","countryCode":"SS","latitude":"37.78712760","longitude":"-122.40340790"},{"name":"Warrap","isoCode":"WR","countryCode":"SS","latitude":"8.08862380","longitude":"28.64106410"},{"name":"Pr\xedncipe Province","isoCode":"P","countryCode":"ST","latitude":"1.61393810","longitude":"7.40569280"},{"name":"S\xe3o Tom\xe9 Province","isoCode":"S","countryCode":"ST","latitude":"0.33019240","longitude":"6.73334300"},{"name":"Ahuachap\xe1n Department","isoCode":"AH","countryCode":"SV","latitude":"13.82161480","longitude":"-89.92532330"},{"name":"Caba\xf1as Department","isoCode":"CA","countryCode":"SV","latitude":"13.86482880","longitude":"-88.74939980"},{"name":"Chalatenango Department","isoCode":"CH","countryCode":"SV","latitude":"14.19166480","longitude":"-89.17059980"},{"name":"Cuscatl\xe1n Department","isoCode":"CU","countryCode":"SV","latitude":"13.86619570","longitude":"-89.05615320"},{"name":"La Libertad Department","isoCode":"LI","countryCode":"SV","latitude":"13.68176610","longitude":"-89.36062980"},{"name":"Moraz\xe1n Department","isoCode":"MO","countryCode":"SV","latitude":"13.76820000","longitude":"-88.12913870"},{"name":"La Paz Department","isoCode":"PA","countryCode":"SV","latitude":null,"longitude":null},{"name":"Santa Ana Department","isoCode":"SA","countryCode":"SV","latitude":"14.14611210","longitude":"-89.51200840"},{"name":"San Miguel Department","isoCode":"SM","countryCode":"SV","latitude":"13.44510410","longitude":"-88.24611830"},{"name":"Sonsonate Department","isoCode":"SO","countryCode":"SV","latitude":"13.68235800","longitude":"-89.66281110"},{"name":"San Salvador Department","isoCode":"SS","countryCode":"SV","latitude":"13.77399970","longitude":"-89.20867730"},{"name":"San Vicente Department","isoCode":"SV","countryCode":"SV","latitude":"13.58685610","longitude":"-88.74939980"},{"name":"La Uni\xf3n Department","isoCode":"UN","countryCode":"SV","latitude":"13.48864430","longitude":"-87.89424510"},{"name":"Usulut\xe1n Department","isoCode":"US","countryCode":"SV","latitude":"13.44706340","longitude":"-88.55653100"},{"name":"Damascus Governorate","isoCode":"DI","countryCode":"SY","latitude":"33.51514440","longitude":"36.39313540"},{"name":"Daraa Governorate","isoCode":"DR","countryCode":"SY","latitude":"32.92488130","longitude":"36.17626150"},{"name":"Deir ez-Zor Governorate","isoCode":"DY","countryCode":"SY","latitude":"35.28797980","longitude":"40.30886260"},{"name":"Al-Hasakah Governorate","isoCode":"HA","countryCode":"SY","latitude":"36.40551500","longitude":"40.79691490"},{"name":"Homs Governorate","isoCode":"HI","countryCode":"SY","latitude":"34.25671230","longitude":"38.31657250"},{"name":"Aleppo Governorate","isoCode":"HL","countryCode":"SY","latitude":"36.22623930","longitude":"37.46813960"},{"name":"Hama Governorate","isoCode":"HM","countryCode":"SY","latitude":"35.18878650","longitude":"37.21158290"},{"name":"Idlib Governorate","isoCode":"ID","countryCode":"SY","latitude":"35.82687980","longitude":"36.69572160"},{"name":"Latakia Governorate","isoCode":"LA","countryCode":"SY","latitude":"35.61297910","longitude":"36.00232250"},{"name":"Quneitra Governorate","isoCode":"QU","countryCode":"SY","latitude":"33.07763180","longitude":"35.89341360"},{"name":"Al-Raqqah Governorate","isoCode":"RA","countryCode":"SY","latitude":"35.95941060","longitude":"38.99810520"},{"name":"Rif Dimashq Governorate","isoCode":"RD","countryCode":"SY","latitude":"33.51672890","longitude":"36.95410700"},{"name":"As-Suwayda Governorate","isoCode":"SU","countryCode":"SY","latitude":"32.79891560","longitude":"36.78195050"},{"name":"Tartus Governorate","isoCode":"TA","countryCode":"SY","latitude":"35.00066520","longitude":"36.00232250"},{"name":"Hhohho District","isoCode":"HH","countryCode":"SZ","latitude":"-26.13656620","longitude":"31.35416310"},{"name":"Lubombo District","isoCode":"LU","countryCode":"SZ","latitude":"-26.78517730","longitude":"31.81070790"},{"name":"Manzini District","isoCode":"MA","countryCode":"SZ","latitude":"-26.50819990","longitude":"31.37131640"},{"name":"Shiselweni District","isoCode":"SH","countryCode":"SZ","latitude":"-26.98275770","longitude":"31.35416310"},{"name":"Batha Region","isoCode":"BA","countryCode":"TD","latitude":"13.93717750","longitude":"18.42760470"},{"name":"Bahr el Gazel","isoCode":"BG","countryCode":"TD","latitude":"14.77022660","longitude":"16.91225100"},{"name":"Borkou","isoCode":"BO","countryCode":"TD","latitude":"17.86888450","longitude":"18.80761950"},{"name":"Ennedi-Est","isoCode":"EE","countryCode":"TD","latitude":"16.34204960","longitude":"23.00119890"},{"name":"Ennedi Region","isoCode":"EN","countryCode":"TD","latitude":"17.54145780","longitude":"21.85685860"},{"name":"Ennedi-Ouest","isoCode":"EO","countryCode":"TD","latitude":"18.97756300","longitude":"21.85685860"},{"name":"Gu\xe9ra Region","isoCode":"GR","countryCode":"TD","latitude":"11.12190150","longitude":"18.42760470"},{"name":"Hadjer-Lamis","isoCode":"HL","countryCode":"TD","latitude":"12.45772730","longitude":"16.72346390"},{"name":"Kanem Region","isoCode":"KA","countryCode":"TD","latitude":"14.87812620","longitude":"15.40680790"},{"name":"Lac Region","isoCode":"LC","countryCode":"TD","latitude":"13.69153770","longitude":"14.10013260"},{"name":"Logone Occidental Region","isoCode":"LO","countryCode":"TD","latitude":"8.75967600","longitude":"15.87600400"},{"name":"Logone Oriental Region","isoCode":"LR","countryCode":"TD","latitude":"8.31499490","longitude":"16.34637910"},{"name":"Mandoul Region","isoCode":"MA","countryCode":"TD","latitude":"8.60309100","longitude":"17.47951730"},{"name":"Moyen-Chari Region","isoCode":"MC","countryCode":"TD","latitude":"9.06399980","longitude":"18.42760470"},{"name":"Mayo-Kebbi Est Region","isoCode":"ME","countryCode":"TD","latitude":"9.40460390","longitude":"14.84546190"},{"name":"Mayo-Kebbi Ouest Region","isoCode":"MO","countryCode":"TD","latitude":"10.41130140","longitude":"15.59433880"},{"name":"N\'Djamena","isoCode":"ND","countryCode":"TD","latitude":"12.13484570","longitude":"15.05574150"},{"name":"Ouadda\xef Region","isoCode":"OD","countryCode":"TD","latitude":"13.74847600","longitude":"20.71224650"},{"name":"Salamat Region","isoCode":"SA","countryCode":"TD","latitude":"10.96916010","longitude":"20.71224650"},{"name":"Sila Region","isoCode":"SI","countryCode":"TD","latitude":"12.13074000","longitude":"21.28450250"},{"name":"Tandjil\xe9 Region","isoCode":"TA","countryCode":"TD","latitude":"9.66257290","longitude":"16.72346390"},{"name":"Tibesti Region","isoCode":"TI","countryCode":"TD","latitude":"21.36500310","longitude":"16.91225100"},{"name":"Wadi Fira Region","isoCode":"WF","countryCode":"TD","latitude":"15.08924160","longitude":"21.47528510"},{"name":"Centrale Region","isoCode":"C","countryCode":"TG","latitude":"8.65860290","longitude":"1.05861350"},{"name":"Kara Region","isoCode":"K","countryCode":"TG","latitude":"9.72163930","longitude":"1.05861350"},{"name":"Maritime","isoCode":"M","countryCode":"TG","latitude":"41.65514930","longitude":"-83.52784670"},{"name":"Plateaux Region","isoCode":"P","countryCode":"TG","latitude":"7.61013780","longitude":"1.05861350"},{"name":"Savanes Region","isoCode":"S","countryCode":"TG","latitude":"10.52917810","longitude":"0.52578230"},{"name":"Bangkok","isoCode":"10","countryCode":"TH","latitude":"13.75633090","longitude":"100.50176510"},{"name":"Samut Prakan","isoCode":"11","countryCode":"TH","latitude":"13.59909610","longitude":"100.59983190"},{"name":"Nonthaburi","isoCode":"12","countryCode":"TH","latitude":"13.85910840","longitude":"100.52165080"},{"name":"Pathum Thani","isoCode":"13","countryCode":"TH","latitude":"14.02083910","longitude":"100.52502760"},{"name":"Phra Nakhon Si Ayutthaya","isoCode":"14","countryCode":"TH","latitude":"14.36923250","longitude":"100.58766340"},{"name":"Ang Thong","isoCode":"15","countryCode":"TH","latitude":"14.58960540","longitude":"100.45505200"},{"name":"Lop Buri","isoCode":"16","countryCode":"TH","latitude":"14.79950810","longitude":"100.65337060"},{"name":"Sing Buri","isoCode":"17","countryCode":"TH","latitude":"14.89362530","longitude":"100.39673140"},{"name":"Chai Nat","isoCode":"18","countryCode":"TH","latitude":"15.18519710","longitude":"100.12512500"},{"name":"Saraburi","isoCode":"19","countryCode":"TH","latitude":"14.52891540","longitude":"100.91014210"},{"name":"Chon Buri","isoCode":"20","countryCode":"TH","latitude":"13.36114310","longitude":"100.98467170"},{"name":"Rayong","isoCode":"21","countryCode":"TH","latitude":"12.68139570","longitude":"101.28162610"},{"name":"Chanthaburi","isoCode":"22","countryCode":"TH","latitude":"12.61124850","longitude":"102.10378060"},{"name":"Trat","isoCode":"23","countryCode":"TH","latitude":"12.24275630","longitude":"102.51747340"},{"name":"Chachoengsao","isoCode":"24","countryCode":"TH","latitude":"13.69041940","longitude":"101.07795960"},{"name":"Prachin Buri","isoCode":"25","countryCode":"TH","latitude":"14.04206990","longitude":"101.66008740"},{"name":"Nakhon Nayok","isoCode":"26","countryCode":"TH","latitude":"14.20694660","longitude":"101.21305110"},{"name":"Sa Kaeo","isoCode":"27","countryCode":"TH","latitude":"13.82403800","longitude":"102.06458390"},{"name":"Nakhon Ratchasima","isoCode":"30","countryCode":"TH","latitude":"14.97384930","longitude":"102.08365200"},{"name":"Buri Ram","isoCode":"31","countryCode":"TH","latitude":"14.99510030","longitude":"103.11159150"},{"name":"Surin","isoCode":"32","countryCode":"TH","latitude":"37.03582710","longitude":"-95.62763670"},{"name":"Si Sa Ket","isoCode":"33","countryCode":"TH","latitude":"15.11860090","longitude":"104.32200950"},{"name":"Ubon Ratchathani","isoCode":"34","countryCode":"TH","latitude":"15.24484530","longitude":"104.84729950"},{"name":"Yasothon","isoCode":"35","countryCode":"TH","latitude":"15.79264100","longitude":"104.14528270"},{"name":"Chaiyaphum","isoCode":"36","countryCode":"TH","latitude":"16.00749740","longitude":"101.61291720"},{"name":"Amnat Charoen","isoCode":"37","countryCode":"TH","latitude":"15.86567830","longitude":"104.62577740"},{"name":"Bueng Kan","isoCode":"38","countryCode":"TH","latitude":"18.36091040","longitude":"103.64644630"},{"name":"Nong Bua Lam Phu","isoCode":"39","countryCode":"TH","latitude":"17.22182470","longitude":"102.42603680"},{"name":"Khon Kaen","isoCode":"40","countryCode":"TH","latitude":"16.43219380","longitude":"102.82362140"},{"name":"Udon Thani","isoCode":"41","countryCode":"TH","latitude":"17.36469690","longitude":"102.81589240"},{"name":"Loei","isoCode":"42","countryCode":"TH","latitude":"17.48602320","longitude":"101.72230020"},{"name":"Nong Khai","isoCode":"43","countryCode":"TH","latitude":"17.87828030","longitude":"102.74126380"},{"name":"Maha Sarakham","isoCode":"44","countryCode":"TH","latitude":"16.01320150","longitude":"103.16151690"},{"name":"Roi Et","isoCode":"45","countryCode":"TH","latitude":"16.05381960","longitude":"103.65200360"},{"name":"Kalasin","isoCode":"46","countryCode":"TH","latitude":"16.43850800","longitude":"103.50609940"},{"name":"Sakon Nakhon","isoCode":"47","countryCode":"TH","latitude":"17.16642110","longitude":"104.14860550"},{"name":"Nakhon Phanom","isoCode":"48","countryCode":"TH","latitude":"17.39203900","longitude":"104.76955080"},{"name":"Mukdahan","isoCode":"49","countryCode":"TH","latitude":"16.54359140","longitude":"104.70241210"},{"name":"Chiang Mai","isoCode":"50","countryCode":"TH","latitude":"18.78834390","longitude":"98.98530080"},{"name":"Lamphun","isoCode":"51","countryCode":"TH","latitude":"18.57446060","longitude":"99.00872210"},{"name":"Lampang","isoCode":"52","countryCode":"TH","latitude":"18.28553950","longitude":"99.51278950"},{"name":"Uttaradit","isoCode":"53","countryCode":"TH","latitude":"17.62008860","longitude":"100.09929420"},{"name":"Phrae","isoCode":"54","countryCode":"TH","latitude":"18.14457740","longitude":"100.14028310"},{"name":"Nan","isoCode":"55","countryCode":"TH","latitude":"45.52220800","longitude":"-122.98632810"},{"name":"Phayao","isoCode":"56","countryCode":"TH","latitude":"19.21543670","longitude":"100.20236920"},{"name":"Chiang Rai","isoCode":"57","countryCode":"TH","latitude":"19.91047980","longitude":"99.84057600"},{"name":"Mae Hong Son","isoCode":"58","countryCode":"TH","latitude":"19.30202960","longitude":"97.96543680"},{"name":"Nakhon Sawan","isoCode":"60","countryCode":"TH","latitude":"15.69873820","longitude":"100.11996000"},{"name":"Uthai Thani","isoCode":"61","countryCode":"TH","latitude":"15.38350010","longitude":"100.02455270"},{"name":"Kamphaeng Phet","isoCode":"62","countryCode":"TH","latitude":"16.48277980","longitude":"99.52266180"},{"name":"Tak","isoCode":"63","countryCode":"TH","latitude":"45.02996460","longitude":"-93.10498150"},{"name":"Sukhothai","isoCode":"64","countryCode":"TH","latitude":"43.64855560","longitude":"-79.37466390"},{"name":"Phitsanulok","isoCode":"65","countryCode":"TH","latitude":"16.82112380","longitude":"100.26585160"},{"name":"Phichit","isoCode":"66","countryCode":"TH","latitude":"16.27408760","longitude":"100.33469910"},{"name":"Phetchabun","isoCode":"67","countryCode":"TH","latitude":"16.30166900","longitude":"101.11928040"},{"name":"Ratchaburi","isoCode":"70","countryCode":"TH","latitude":"13.52828930","longitude":"99.81342110"},{"name":"Kanchanaburi","isoCode":"71","countryCode":"TH","latitude":"14.10113930","longitude":"99.41794310"},{"name":"Suphan Buri","isoCode":"72","countryCode":"TH","latitude":"14.47448920","longitude":"100.11771280"},{"name":"Nakhon Pathom","isoCode":"73","countryCode":"TH","latitude":"13.81402930","longitude":"100.03729290"},{"name":"Samut Sakhon","isoCode":"74","countryCode":"TH","latitude":"13.54752160","longitude":"100.27439560"},{"name":"Samut Songkhram","isoCode":"75","countryCode":"TH","latitude":"13.40982170","longitude":"100.00226450"},{"name":"Phetchaburi","isoCode":"76","countryCode":"TH","latitude":"12.96492150","longitude":"99.64258830"},{"name":"Prachuap Khiri Khan","isoCode":"77","countryCode":"TH","latitude":"11.79383890","longitude":"99.79575640"},{"name":"Nakhon Si Thammarat","isoCode":"80","countryCode":"TH","latitude":"8.43248310","longitude":"99.95990330"},{"name":"Krabi","isoCode":"81","countryCode":"TH","latitude":"8.08629970","longitude":"98.90628350"},{"name":"Phangnga","isoCode":"82","countryCode":"TH","latitude":"8.45014140","longitude":"98.52553170"},{"name":"Phuket","isoCode":"83","countryCode":"TH","latitude":"7.88044790","longitude":"98.39225040"},{"name":"Surat Thani","isoCode":"84","countryCode":"TH","latitude":"9.13419490","longitude":"99.33341980"},{"name":"Ranong","isoCode":"85","countryCode":"TH","latitude":"9.95287020","longitude":"98.60846410"},{"name":"Chumphon","isoCode":"86","countryCode":"TH","latitude":"10.49304960","longitude":"99.18001990"},{"name":"Songkhla","isoCode":"90","countryCode":"TH","latitude":"7.18976590","longitude":"100.59538130"},{"name":"Satun","isoCode":"91","countryCode":"TH","latitude":"6.62381580","longitude":"100.06737440"},{"name":"Trang","isoCode":"92","countryCode":"TH","latitude":"7.56448330","longitude":"99.62393340"},{"name":"Phatthalung","isoCode":"93","countryCode":"TH","latitude":"7.61668230","longitude":"100.07402310"},{"name":"Pattani","isoCode":"94","countryCode":"TH","latitude":"6.76183080","longitude":"101.32325490"},{"name":"Yala","isoCode":"95","countryCode":"TH","latitude":"44.05791170","longitude":"-123.16538480"},{"name":"Narathiwat","isoCode":"96","countryCode":"TH","latitude":"6.42546070","longitude":"101.82531430"},{"name":"Pattaya","isoCode":"S","countryCode":"TH","latitude":"12.92355570","longitude":"100.88245510"},{"name":"Gorno-Badakhshan Autonomous Province","isoCode":"GB","countryCode":"TJ","latitude":"38.41273200","longitude":"73.08774900"},{"name":"Khatlon Province","isoCode":"KT","countryCode":"TJ","latitude":"37.91135620","longitude":"69.09702300"},{"name":"districts of Republican Subordination","isoCode":"RA","countryCode":"TJ","latitude":"39.08579020","longitude":"70.24083250"},{"name":"Sughd Province","isoCode":"SU","countryCode":"TJ","latitude":"39.51553260","longitude":"69.09702300"},{"name":"Aileu municipality","isoCode":"AL","countryCode":"TL","latitude":"-8.70439940","longitude":"125.60954740"},{"name":"Ainaro Municipality","isoCode":"AN","countryCode":"TL","latitude":"-9.01131710","longitude":"125.52200120"},{"name":"Baucau Municipality","isoCode":"BA","countryCode":"TL","latitude":"-8.47143080","longitude":"126.45759910"},{"name":"Bobonaro Municipality","isoCode":"BO","countryCode":"TL","latitude":"-8.96554060","longitude":"125.25879640"},{"name":"Cova Lima Municipality","isoCode":"CO","countryCode":"TL","latitude":"-9.26503750","longitude":"125.25879640"},{"name":"Dili municipality","isoCode":"DI","countryCode":"TL","latitude":"-8.24496130","longitude":"125.58766970"},{"name":"Ermera District","isoCode":"ER","countryCode":"TL","latitude":"-8.75248020","longitude":"125.39872940"},{"name":"Laut\xe9m Municipality","isoCode":"LA","countryCode":"TL","latitude":"-8.36423070","longitude":"126.90438450"},{"name":"Liqui\xe7\xe1 Municipality","isoCode":"LI","countryCode":"TL","latitude":"-8.66740950","longitude":"125.25879640"},{"name":"Manufahi Municipality","isoCode":"MF","countryCode":"TL","latitude":"-9.01454950","longitude":"125.82799590"},{"name":"Manatuto District","isoCode":"MT","countryCode":"TL","latitude":"-8.51556080","longitude":"126.01592550"},{"name":"Viqueque Municipality","isoCode":"VI","countryCode":"TL","latitude":"-8.85979180","longitude":"126.36335160"},{"name":"Ahal Region","isoCode":"A","countryCode":"TM","latitude":"38.63993980","longitude":"59.47209040"},{"name":"Balkan Region","isoCode":"B","countryCode":"TM","latitude":"41.81014720","longitude":"21.09373110"},{"name":"Da\u015Foguz Region","isoCode":"D","countryCode":"TM","latitude":"41.83687370","longitude":"59.96519040"},{"name":"Lebap Region","isoCode":"L","countryCode":"TM","latitude":"38.12724620","longitude":"64.71624150"},{"name":"Mary Region","isoCode":"M","countryCode":"TM","latitude":"36.94816230","longitude":"62.45041540"},{"name":"Ashgabat","isoCode":"S","countryCode":"TM","latitude":"37.96007660","longitude":"58.32606290"},{"name":"Tunis Governorate","isoCode":"11","countryCode":"TN","latitude":"36.83749460","longitude":"10.19273890"},{"name":"Ariana Governorate","isoCode":"12","countryCode":"TN","latitude":"36.99227510","longitude":"10.12551640"},{"name":"Ben Arous Governorate","isoCode":"13","countryCode":"TN","latitude":"36.64356060","longitude":"10.21515780"},{"name":"Manouba Governorate","isoCode":"14","countryCode":"TN","latitude":"36.84465040","longitude":"9.85714160"},{"name":"Zaghouan Governorate","isoCode":"22","countryCode":"TN","latitude":"36.40911880","longitude":"10.14231720"},{"name":"Bizerte Governorate","isoCode":"23","countryCode":"TN","latitude":"37.16093970","longitude":"9.63413500"},{"name":"Kassrine","isoCode":"31","countryCode":"TN","latitude":"35.17227160","longitude":"8.83076260"},{"name":"Jendouba Governorate","isoCode":"32","countryCode":"TN","latitude":"36.71818620","longitude":"8.74811670"},{"name":"Kef Governorate","isoCode":"33","countryCode":"TN","latitude":"36.12305120","longitude":"8.66005860"},{"name":"Siliana Governorate","isoCode":"34","countryCode":"TN","latitude":"36.08872080","longitude":"9.36453350"},{"name":"Kairouan Governorate","isoCode":"41","countryCode":"TN","latitude":"35.67116630","longitude":"10.10054690"},{"name":"Kasserine Governorate","isoCode":"42","countryCode":"TN","latitude":"35.08091480","longitude":"8.66005860"},{"name":"Sidi Bouzid Governorate","isoCode":"43","countryCode":"TN","latitude":"35.03543860","longitude":"9.48393920"},{"name":"Sousse Governorate","isoCode":"51","countryCode":"TN","latitude":"35.90222670","longitude":"10.34978950"},{"name":"Monastir Governorate","isoCode":"52","countryCode":"TN","latitude":"35.76425150","longitude":"10.81128850"},{"name":"Mahdia Governorate","isoCode":"53","countryCode":"TN","latitude":"35.33525580","longitude":"10.89030990"},{"name":"Sfax Governorate","isoCode":"61","countryCode":"TN","latitude":"34.86065810","longitude":"10.34978950"},{"name":"Gafsa Governorate","isoCode":"71","countryCode":"TN","latitude":"34.37885050","longitude":"8.66005860"},{"name":"Tozeur Governorate","isoCode":"72","countryCode":"TN","latitude":"33.97894910","longitude":"8.04651850"},{"name":"Kebili Governorate","isoCode":"73","countryCode":"TN","latitude":"33.70715510","longitude":"8.97146230"},{"name":"Gab\xe8s Governorate","isoCode":"81","countryCode":"TN","latitude":"33.94596480","longitude":"9.72326730"},{"name":"Medenine Governorate","isoCode":"82","countryCode":"TN","latitude":"33.22805650","longitude":"10.89030990"},{"name":"Tataouine Governorate","isoCode":"83","countryCode":"TN","latitude":"32.13441220","longitude":"10.08072980"},{"name":"\u02BBEua","isoCode":"01","countryCode":"TO","latitude":"37.09024000","longitude":"-95.71289100"},{"name":"Ha\u02BBapai","isoCode":"02","countryCode":"TO","latitude":"-19.75000000","longitude":"-174.36666700"},{"name":"Niuas","isoCode":"03","countryCode":"TO","latitude":"-15.95940000","longitude":"-173.78300000"},{"name":"Tongatapu","isoCode":"04","countryCode":"TO","latitude":"-21.14659680","longitude":"-175.25154820"},{"name":"Vava\u02BBu","isoCode":"05","countryCode":"TO","latitude":"-18.62275600","longitude":"-173.99029820"},{"name":"Adana","isoCode":"01","countryCode":"TR","latitude":"37.26123150","longitude":"35.39050460"},{"name":"Ad\u0131yaman","isoCode":"02","countryCode":"TR","latitude":"37.90782910","longitude":"38.48499230"},{"name":"Afyonkarahisar","isoCode":"03","countryCode":"TR","latitude":"38.73910990","longitude":"30.71200230"},{"name":"A\u011Fr\u0131","isoCode":"04","countryCode":"TR","latitude":"39.62692180","longitude":"43.02159650"},{"name":"Amasya","isoCode":"05","countryCode":"TR","latitude":"40.65166080","longitude":"35.90379660"},{"name":"Ankara","isoCode":"06","countryCode":"TR","latitude":"39.78052450","longitude":"32.71813750"},{"name":"Antalya","isoCode":"07","countryCode":"TR","latitude":"37.09516720","longitude":"31.07937050"},{"name":"Artvin","isoCode":"08","countryCode":"TR","latitude":"41.07866400","longitude":"41.76282230"},{"name":"Ayd\u0131n","isoCode":"09","countryCode":"TR","latitude":"37.81170330","longitude":"28.48639630"},{"name":"Bal\u0131kesir","isoCode":"10","countryCode":"TR","latitude":"39.76167820","longitude":"28.11226790"},{"name":"Bilecik","isoCode":"11","countryCode":"TR","latitude":"40.05665550","longitude":"30.06652360"},{"name":"Bing\xf6l","isoCode":"12","countryCode":"TR","latitude":"39.06263540","longitude":"40.76960950"},{"name":"Bitlis","isoCode":"13","countryCode":"TR","latitude":"38.65231330","longitude":"42.42020280"},{"name":"Bolu","isoCode":"14","countryCode":"TR","latitude":"40.57597660","longitude":"31.57880860"},{"name":"Burdur","isoCode":"15","countryCode":"TR","latitude":"37.46126690","longitude":"30.06652360"},{"name":"Bursa","isoCode":"16","countryCode":"TR","latitude":"40.06554590","longitude":"29.23207840"},{"name":"\xc7anakkale","isoCode":"17","countryCode":"TR","latitude":"40.05101040","longitude":"26.98524220"},{"name":"\xc7ank\u0131r\u0131","isoCode":"18","countryCode":"TR","latitude":"40.53690730","longitude":"33.58838930"},{"name":"\xc7orum","isoCode":"19","countryCode":"TR","latitude":"40.49982110","longitude":"34.59862630"},{"name":"Denizli","isoCode":"20","countryCode":"TR","latitude":"37.61283950","longitude":"29.23207840"},{"name":"Diyarbak\u0131r","isoCode":"21","countryCode":"TR","latitude":"38.10663720","longitude":"40.54268960"},{"name":"Edirne","isoCode":"22","countryCode":"TR","latitude":"41.15172220","longitude":"26.51379640"},{"name":"Elaz\u0131\u011F","isoCode":"23","countryCode":"TR","latitude":"38.49648040","longitude":"39.21990290"},{"name":"Erzincan","isoCode":"24","countryCode":"TR","latitude":"39.76819140","longitude":"39.05013060"},{"name":"Erzurum","isoCode":"25","countryCode":"TR","latitude":"40.07467990","longitude":"41.66945620"},{"name":"Eski\u015Fehir","isoCode":"26","countryCode":"TR","latitude":"39.63296570","longitude":"31.26263660"},{"name":"Gaziantep","isoCode":"27","countryCode":"TR","latitude":"37.07638820","longitude":"37.38272340"},{"name":"Giresun","isoCode":"28","countryCode":"TR","latitude":"40.64616720","longitude":"38.59355110"},{"name":"G\xfcm\xfc\u015Fhane","isoCode":"29","countryCode":"TR","latitude":"40.28036730","longitude":"39.31432530"},{"name":"Hakk\xe2ri","isoCode":"30","countryCode":"TR","latitude":"37.44593190","longitude":"43.74498410"},{"name":"Hatay","isoCode":"31","countryCode":"TR","latitude":"36.40184880","longitude":"36.34980970"},{"name":"Isparta","isoCode":"32","countryCode":"TR","latitude":"38.02114640","longitude":"31.07937050"},{"name":"Mersin","isoCode":"33","countryCode":"TR","latitude":"36.81208580","longitude":"34.64147500"},{"name":"Istanbul","isoCode":"34","countryCode":"TR","latitude":"41.16343020","longitude":"28.76644080"},{"name":"\u0130zmir","isoCode":"35","countryCode":"TR","latitude":"38.35916930","longitude":"27.26761160"},{"name":"Kars","isoCode":"36","countryCode":"TR","latitude":"40.28076360","longitude":"42.99195270"},{"name":"Kastamonu","isoCode":"37","countryCode":"TR","latitude":"41.41038630","longitude":"33.69983340"},{"name":"Kayseri","isoCode":"38","countryCode":"TR","latitude":"38.62568540","longitude":"35.74068820"},{"name":"K\u0131rklareli","isoCode":"39","countryCode":"TR","latitude":"41.72597950","longitude":"27.48383900"},{"name":"K\u0131r\u015Fehir","isoCode":"40","countryCode":"TR","latitude":"39.22689050","longitude":"33.97500180"},{"name":"Kocaeli","isoCode":"41","countryCode":"TR","latitude":"40.85327040","longitude":"29.88152030"},{"name":"Konya","isoCode":"42","countryCode":"TR","latitude":"37.98381340","longitude":"32.71813750"},{"name":"K\xfctahya","isoCode":"43","countryCode":"TR","latitude":"39.35813700","longitude":"29.60354950"},{"name":"Malatya","isoCode":"44","countryCode":"TR","latitude":"38.40150570","longitude":"37.95362980"},{"name":"Manisa","isoCode":"45","countryCode":"TR","latitude":"38.84193730","longitude":"28.11226790"},{"name":"Kahramanmara\u015F","isoCode":"46","countryCode":"TR","latitude":"37.75030360","longitude":"36.95410700"},{"name":"Mardin","isoCode":"47","countryCode":"TR","latitude":"37.34429290","longitude":"40.61964870"},{"name":"Mu\u011Fla","isoCode":"48","countryCode":"TR","latitude":"37.18358190","longitude":"28.48639630"},{"name":"Mu\u015F","isoCode":"49","countryCode":"TR","latitude":"38.94618880","longitude":"41.75389310"},{"name":"Nev\u015Fehir","isoCode":"50","countryCode":"TR","latitude":"38.69393990","longitude":"34.68565090"},{"name":"Ni\u011Fde","isoCode":"51","countryCode":"TR","latitude":"38.09930860","longitude":"34.68565090"},{"name":"Ordu","isoCode":"52","countryCode":"TR","latitude":"40.79905800","longitude":"37.38990050"},{"name":"Rize","isoCode":"53","countryCode":"TR","latitude":"40.95814970","longitude":"40.92269850"},{"name":"Sakarya","isoCode":"54","countryCode":"TR","latitude":"40.78885500","longitude":"30.40595400"},{"name":"Samsun","isoCode":"55","countryCode":"TR","latitude":"41.18648590","longitude":"36.13226780"},{"name":"Siirt","isoCode":"56","countryCode":"TR","latitude":"37.86588620","longitude":"42.14945230"},{"name":"Sinop","isoCode":"57","countryCode":"TR","latitude":"41.55947490","longitude":"34.85805320"},{"name":"Sivas","isoCode":"58","countryCode":"TR","latitude":"39.44880390","longitude":"37.12944970"},{"name":"Tekirda\u011F","isoCode":"59","countryCode":"TR","latitude":"41.11212270","longitude":"27.26761160"},{"name":"Tokat","isoCode":"60","countryCode":"TR","latitude":"40.39027130","longitude":"36.62518630"},{"name":"Trabzon","isoCode":"61","countryCode":"TR","latitude":"40.79924100","longitude":"39.58479440"},{"name":"Tunceli","isoCode":"62","countryCode":"TR","latitude":"39.30735540","longitude":"39.43877780"},{"name":"\u015Eanl\u0131urfa","isoCode":"63","countryCode":"TR","latitude":"37.35691020","longitude":"39.15436770"},{"name":"U\u015Fak","isoCode":"64","countryCode":"TR","latitude":"38.54313190","longitude":"29.23207840"},{"name":"Van","isoCode":"65","countryCode":"TR","latitude":"38.36794170","longitude":"43.71827870"},{"name":"Yozgat","isoCode":"66","countryCode":"TR","latitude":"39.72719790","longitude":"35.10778580"},{"name":"Zonguldak","isoCode":"67","countryCode":"TR","latitude":"41.31249170","longitude":"31.85982510"},{"name":"Aksaray","isoCode":"68","countryCode":"TR","latitude":"38.33520430","longitude":"33.97500180"},{"name":"Bayburt","isoCode":"69","countryCode":"TR","latitude":"40.26032000","longitude":"40.22804800"},{"name":"Karaman","isoCode":"70","countryCode":"TR","latitude":"37.24363360","longitude":"33.61757700"},{"name":"K\u0131r\u0131kkale","isoCode":"71","countryCode":"TR","latitude":"39.88768780","longitude":"33.75552480"},{"name":"Batman","isoCode":"72","countryCode":"TR","latitude":"37.83624960","longitude":"41.36057390"},{"name":"\u015E\u0131rnak","isoCode":"73","countryCode":"TR","latitude":"37.41874810","longitude":"42.49183380"},{"name":"Bart\u0131n","isoCode":"74","countryCode":"TR","latitude":"41.58105090","longitude":"32.46097940"},{"name":"Ardahan","isoCode":"75","countryCode":"TR","latitude":"41.11129640","longitude":"42.78316740"},{"name":"I\u011Fd\u0131r","isoCode":"76","countryCode":"TR","latitude":"39.88798410","longitude":"44.00483650"},{"name":"Yalova","isoCode":"77","countryCode":"TR","latitude":"40.57759860","longitude":"29.20883030"},{"name":"Karab\xfck","isoCode":"78","countryCode":"TR","latitude":"41.18748900","longitude":"32.74174190"},{"name":"Kilis","isoCode":"79","countryCode":"TR","latitude":"36.82047750","longitude":"37.16873390"},{"name":"Osmaniye","isoCode":"80","countryCode":"TR","latitude":"37.21302580","longitude":"36.17626150"},{"name":"D\xfczce","isoCode":"81","countryCode":"TR","latitude":"40.87705310","longitude":"31.31927130"},{"name":"Arima","isoCode":"ARI","countryCode":"TT","latitude":"46.79316040","longitude":"-71.25843110"},{"name":"Chaguanas","isoCode":"CHA","countryCode":"TT","latitude":"10.51683870","longitude":"-61.41144820"},{"name":"Couva-Tabaquite-Talparo Regional Corporation","isoCode":"CTT","countryCode":"TT","latitude":"10.42971450","longitude":"-61.37352100"},{"name":"Diego Martin Regional Corporation","isoCode":"DMN","countryCode":"TT","latitude":"10.73622860","longitude":"-61.55448360"},{"name":"Eastern Tobago","isoCode":"ETO","countryCode":"TT","latitude":"11.29793480","longitude":"-60.55885240"},{"name":"Rio Claro-Mayaro Regional Corporation","isoCode":"MRC","countryCode":"TT","latitude":"10.24128320","longitude":"-61.09372060"},{"name":"Penal-Debe Regional Corporation","isoCode":"PED","countryCode":"TT","latitude":"10.13374020","longitude":"-61.44354740"},{"name":"Port of Spain","isoCode":"POS","countryCode":"TT","latitude":"10.66031960","longitude":"-61.50856250"},{"name":"Princes Town Regional Corporation","isoCode":"PRT","countryCode":"TT","latitude":"10.17867460","longitude":"-61.28019960"},{"name":"Point Fortin","isoCode":"PTF","countryCode":"TT","latitude":"10.17027370","longitude":"-61.67133860"},{"name":"San Fernando","isoCode":"SFO","countryCode":"TT","latitude":"34.28194610","longitude":"-118.43897190"},{"name":"Sangre Grande Regional Corporation","isoCode":"SGE","countryCode":"TT","latitude":"10.58529390","longitude":"-61.13158130"},{"name":"Siparia Regional Corporation","isoCode":"SIP","countryCode":"TT","latitude":"10.12456260","longitude":"-61.56032440"},{"name":"San Juan-Laventille Regional Corporation","isoCode":"SJL","countryCode":"TT","latitude":"10.69085780","longitude":"-61.45522130"},{"name":"Tunapuna-Piarco Regional Corporation","isoCode":"TUP","countryCode":"TT","latitude":"10.68590960","longitude":"-61.30352480"},{"name":"Western Tobago","isoCode":"WTO","countryCode":"TT","latitude":"11.18970720","longitude":"-60.77954520"},{"name":"Funafuti","isoCode":"FUN","countryCode":"TV","latitude":"-8.52114710","longitude":"179.19619260"},{"name":"Niutao Island Council","isoCode":"NIT","countryCode":"TV","latitude":"-6.10642580","longitude":"177.34384290"},{"name":"Nukufetau","isoCode":"NKF","countryCode":"TV","latitude":"-8.00000000","longitude":"178.50000000"},{"name":"Nukulaelae","isoCode":"NKL","countryCode":"TV","latitude":"-9.38111100","longitude":"179.85222200"},{"name":"Nanumea","isoCode":"NMA","countryCode":"TV","latitude":"-5.68816170","longitude":"176.13701480"},{"name":"Nanumanga","isoCode":"NMG","countryCode":"TV","latitude":"-6.28580190","longitude":"176.31992800"},{"name":"Nui","isoCode":"NUI","countryCode":"TV","latitude":"-7.23887680","longitude":"177.14852320"},{"name":"Vaitupu","isoCode":"VAI","countryCode":"TV","latitude":"-7.47673270","longitude":"178.67476750"},{"name":"Changhua","isoCode":"CHA","countryCode":"TW","latitude":"24.05179630","longitude":"120.51613520"},{"name":"Chiayi","isoCode":"CYI","countryCode":"TW","latitude":"23.45184280","longitude":"120.25546150"},{"name":"Chiayi","isoCode":"CYQ","countryCode":"TW","latitude":"23.48007510","longitude":"120.44911130"},{"name":"Hsinchu","isoCode":"HSQ","countryCode":"TW","latitude":"24.83872260","longitude":"121.01772460"},{"name":"Hsinchu","isoCode":"HSZ","countryCode":"TW","latitude":"24.81382870","longitude":"120.96747980"},{"name":"Hualien","isoCode":"HUA","countryCode":"TW","latitude":"23.98715890","longitude":"121.60157140"},{"name":"Yilan","isoCode":"ILA","countryCode":"TW","latitude":"24.70210730","longitude":"121.73775020"},{"name":"Keelung","isoCode":"KEE","countryCode":"TW","latitude":"25.12418620","longitude":"121.64758340"},{"name":"Kaohsiung","isoCode":"KHH","countryCode":"TW","latitude":"22.62727840","longitude":"120.30143530"},{"name":"Kinmen","isoCode":"KIN","countryCode":"TW","latitude":"24.34877920","longitude":"118.32856440"},{"name":"Lienchiang","isoCode":"LIE","countryCode":"TW","latitude":"26.15055560","longitude":"119.92888890"},{"name":"Miaoli","isoCode":"MIA","countryCode":"TW","latitude":"24.56015900","longitude":"120.82142650"},{"name":"Nantou","isoCode":"NAN","countryCode":"TW","latitude":"23.96099810","longitude":"120.97186380"},{"name":"New Taipei","isoCode":"NWT","countryCode":"TW","latitude":"24.98752780","longitude":"121.36459470"},{"name":"Penghu","isoCode":"PEN","countryCode":"TW","latitude":"23.57118990","longitude":"119.57931570"},{"name":"Pingtung","isoCode":"PIF","countryCode":"TW","latitude":"22.55197590","longitude":"120.54875970"},{"name":"Taoyuan","isoCode":"TAO","countryCode":"TW","latitude":"24.99362810","longitude":"121.30097980"},{"name":"Tainan","isoCode":"TNN","countryCode":"TW","latitude":"22.99972810","longitude":"120.22702770"},{"name":"Taipei","isoCode":"TPE","countryCode":"TW","latitude":"25.03296940","longitude":"121.56541770"},{"name":"Taitung","isoCode":"TTT","countryCode":"TW","latitude":"22.79724470","longitude":"121.07137020"},{"name":"Taichung","isoCode":"TXG","countryCode":"TW","latitude":"24.14773580","longitude":"120.67364820"},{"name":"Yunlin","isoCode":"YUN","countryCode":"TW","latitude":"23.70920330","longitude":"120.43133730"},{"name":"Arusha","isoCode":"01","countryCode":"TZ","latitude":"-3.38692540","longitude":"36.68299270"},{"name":"Dar es Salaam","isoCode":"02","countryCode":"TZ","latitude":"-6.79235400","longitude":"39.20832840"},{"name":"Dodoma","isoCode":"03","countryCode":"TZ","latitude":"-6.57382280","longitude":"36.26308460"},{"name":"Iringa","isoCode":"04","countryCode":"TZ","latitude":"-7.78874420","longitude":"35.56578620"},{"name":"Kagera","isoCode":"05","countryCode":"TZ","latitude":"-1.30011150","longitude":"31.26263660"},{"name":"Pemba North","isoCode":"06","countryCode":"TZ","latitude":"-5.03193520","longitude":"39.77555710"},{"name":"Zanzibar North","isoCode":"07","countryCode":"TZ","latitude":"-5.93950930","longitude":"39.27910110"},{"name":"Kigoma","isoCode":"08","countryCode":"TZ","latitude":"-4.88240920","longitude":"29.66150550"},{"name":"Kilimanjaro","isoCode":"09","countryCode":"TZ","latitude":"-4.13369270","longitude":"37.80876930"},{"name":"Pemba South","isoCode":"10","countryCode":"TZ","latitude":"-5.31469610","longitude":"39.75495110"},{"name":"Zanzibar South","isoCode":"11","countryCode":"TZ","latitude":"-6.26428510","longitude":"39.44502810"},{"name":"Lindi","isoCode":"12","countryCode":"TZ","latitude":"-9.23433940","longitude":"38.31657250"},{"name":"Mara","isoCode":"13","countryCode":"TZ","latitude":"-1.77535380","longitude":"34.15319470"},{"name":"Mbeya","isoCode":"14","countryCode":"TZ","latitude":"-8.28661120","longitude":"32.81325370"},{"name":"Zanzibar West","isoCode":"15","countryCode":"TZ","latitude":"-6.22981360","longitude":"39.25832930"},{"name":"Morogoro","isoCode":"16","countryCode":"TZ","latitude":"-8.81371730","longitude":"36.95410700"},{"name":"Mtwara","isoCode":"17","countryCode":"TZ","latitude":"-10.33984550","longitude":"40.16574660"},{"name":"Mwanza","isoCode":"18","countryCode":"TZ","latitude":"-2.46711970","longitude":"32.89868120"},{"name":"Pwani","isoCode":"19","countryCode":"TZ","latitude":"-7.32377140","longitude":"38.82054540"},{"name":"Rukwa","isoCode":"20","countryCode":"TZ","latitude":"-8.01094440","longitude":"31.44561790"},{"name":"Ruvuma","isoCode":"21","countryCode":"TZ","latitude":"-10.68787170","longitude":"36.26308460"},{"name":"Shinyanga","isoCode":"22","countryCode":"TZ","latitude":"-3.68099610","longitude":"33.42714030"},{"name":"Singida","isoCode":"23","countryCode":"TZ","latitude":"-6.74533520","longitude":"34.15319470"},{"name":"Tabora","isoCode":"24","countryCode":"TZ","latitude":"-5.03421380","longitude":"32.80844960"},{"name":"Tanga","isoCode":"25","countryCode":"TZ","latitude":"-5.30497890","longitude":"38.31657250"},{"name":"Manyara","isoCode":"26","countryCode":"TZ","latitude":"-4.31500580","longitude":"36.95410700"},{"name":"Geita","isoCode":"27","countryCode":"TZ","latitude":"-2.82422570","longitude":"32.26538870"},{"name":"Katavi","isoCode":"28","countryCode":"TZ","latitude":"-6.36771250","longitude":"31.26263660"},{"name":"Njombe","isoCode":"29","countryCode":"TZ","latitude":"-9.24226320","longitude":"35.12687810"},{"name":"Simiyu","isoCode":"30","countryCode":"TZ","latitude":"-2.83087380","longitude":"34.15319470"},{"name":"Songwe","isoCode":"31","countryCode":"TZ","latitude":"-8.27261200","longitude":"31.71131740"},{"name":"Vinnytska oblast","isoCode":"05","countryCode":"UA","latitude":"49.23308300","longitude":"28.46821690"},{"name":"Volynska oblast","isoCode":"07","countryCode":"UA","latitude":"50.74723300","longitude":"25.32538300"},{"name":"Luhanska oblast","isoCode":"09","countryCode":"UA","latitude":"48.57404100","longitude":"39.30781500"},{"name":"Dnipropetrovska oblast","isoCode":"12","countryCode":"UA","latitude":"48.46471700","longitude":"35.04618300"},{"name":"Donetska oblast","isoCode":"14","countryCode":"UA","latitude":"48.01588300","longitude":"37.80285000"},{"name":"Zhytomyrska oblast","isoCode":"18","countryCode":"UA","latitude":"50.25465000","longitude":"28.65866690"},{"name":"Zakarpatska Oblast","isoCode":"21","countryCode":"UA","latitude":"48.62080000","longitude":"22.28788300"},{"name":"Zaporizka oblast","isoCode":"23","countryCode":"UA","latitude":"47.83880000","longitude":"35.13956700"},{"name":"Ivano-Frankivska oblast","isoCode":"26","countryCode":"UA","latitude":"48.92263300","longitude":"24.71111700"},{"name":"Kyiv","isoCode":"30","countryCode":"UA","latitude":"50.45010000","longitude":"30.52340000"},{"name":"Kyivska oblast","isoCode":"32","countryCode":"UA","latitude":"50.05295060","longitude":"30.76671340"},{"name":"Kirovohradska oblast","isoCode":"35","countryCode":"UA","latitude":"48.50793300","longitude":"32.26231700"},{"name":"Autonomous Republic of Crimea","isoCode":"43","countryCode":"UA","latitude":"44.95211700","longitude":"34.10241700"},{"name":"Lvivska oblast","isoCode":"46","countryCode":"UA","latitude":"49.83968300","longitude":"24.02971700"},{"name":"Mykolaivska oblast","isoCode":"48","countryCode":"UA","latitude":"46.97503300","longitude":"31.99458290"},{"name":"Odeska oblast","isoCode":"51","countryCode":"UA","latitude":"46.48458300","longitude":"30.73260000"},{"name":"Poltavska oblast","isoCode":"53","countryCode":"UA","latitude":"49.64291960","longitude":"32.66753390"},{"name":"Rivnenska oblast","isoCode":"56","countryCode":"UA","latitude":"50.61990000","longitude":"26.25161700"},{"name":"Sumska oblast","isoCode":"59","countryCode":"UA","latitude":"50.90770000","longitude":"34.79810000"},{"name":"Ternopilska oblast","isoCode":"61","countryCode":"UA","latitude":"49.55351700","longitude":"25.59476700"},{"name":"Kharkivska oblast","isoCode":"63","countryCode":"UA","latitude":"49.99350000","longitude":"36.23038300"},{"name":"Khersonska oblast","isoCode":"65","countryCode":"UA","latitude":"46.63541700","longitude":"32.61686700"},{"name":"Khmelnytska oblast","isoCode":"68","countryCode":"UA","latitude":"49.42298300","longitude":"26.98713310"},{"name":"Cherkaska oblast","isoCode":"71","countryCode":"UA","latitude":"49.44443300","longitude":"32.05976700"},{"name":"Chernihivska oblast","isoCode":"74","countryCode":"UA","latitude":"51.49820000","longitude":"31.28934990"},{"name":"Chernivetska oblast","isoCode":"77","countryCode":"UA","latitude":"48.29168300","longitude":"25.93521700"},{"name":"Kalangala District","isoCode":"101","countryCode":"UG","latitude":"-0.63505780","longitude":"32.53727410"},{"name":"Kampala District","isoCode":"102","countryCode":"UG","latitude":"0.34759640","longitude":"32.58251970"},{"name":"Kiboga District","isoCode":"103","countryCode":"UG","latitude":"0.96575900","longitude":"31.71954590"},{"name":"Luwero District","isoCode":"104","countryCode":"UG","latitude":"0.82711180","longitude":"32.62774550"},{"name":"Masaka District","isoCode":"105","countryCode":"UG","latitude":"-0.44636910","longitude":"31.90179540"},{"name":"Mpigi District","isoCode":"106","countryCode":"UG","latitude":"0.22735280","longitude":"32.32492360"},{"name":"Mubende District","isoCode":"107","countryCode":"UG","latitude":"0.57727580","longitude":"31.53700030"},{"name":"Mukono District","isoCode":"108","countryCode":"UG","latitude":"0.28354760","longitude":"32.76330360"},{"name":"Nakasongola District","isoCode":"109","countryCode":"UG","latitude":"1.34897210","longitude":"32.44672380"},{"name":"Rakai District","isoCode":"110","countryCode":"UG","latitude":"-0.70691350","longitude":"31.53700030"},{"name":"Sembabule District","isoCode":"111","countryCode":"UG","latitude":"0.06377150","longitude":"31.35416310"},{"name":"Kayunga District","isoCode":"112","countryCode":"UG","latitude":"0.98601820","longitude":"32.85357550"},{"name":"Wakiso District","isoCode":"113","countryCode":"UG","latitude":"0.06301900","longitude":"32.44672380"},{"name":"Lyantonde District","isoCode":"114","countryCode":"UG","latitude":"-0.22406960","longitude":"31.21684660"},{"name":"Mityana District","isoCode":"115","countryCode":"UG","latitude":"0.44548450","longitude":"32.08374450"},{"name":"Nakaseke District","isoCode":"116","countryCode":"UG","latitude":"1.22308480","longitude":"32.08374450"},{"name":"Buikwe District","isoCode":"117","countryCode":"UG","latitude":"0.31440460","longitude":"32.98883190"},{"name":"Bukomansimbi District","isoCode":"118","countryCode":"UG","latitude":"-0.14327520","longitude":"31.60548930"},{"name":"Butambala District","isoCode":"119","countryCode":"UG","latitude":"0.17425000","longitude":"32.10646680"},{"name":"Buvuma District","isoCode":"120","countryCode":"UG","latitude":"-0.37649120","longitude":"33.25879300"},{"name":"Gomba District","isoCode":"121","countryCode":"UG","latitude":"0.22297910","longitude":"31.67393710"},{"name":"Kalungu District","isoCode":"122","countryCode":"UG","latitude":"-0.09528310","longitude":"31.76513620"},{"name":"Kyankwanzi District","isoCode":"123","countryCode":"UG","latitude":"1.09660370","longitude":"31.71954590"},{"name":"Lwengo District","isoCode":"124","countryCode":"UG","latitude":"-0.41652880","longitude":"31.39989950"},{"name":"Kyotera District","isoCode":"125","countryCode":"UG","latitude":"-0.63589880","longitude":"31.54556370"},{"name":"Bugiri District","isoCode":"201","countryCode":"UG","latitude":"0.53161270","longitude":"33.75177230"},{"name":"Busia District","isoCode":"202","countryCode":"UG","latitude":"0.40447310","longitude":"34.01958270"},{"name":"Iganga District","isoCode":"203","countryCode":"UG","latitude":"0.66001370","longitude":"33.48319060"},{"name":"Jinja District","isoCode":"204","countryCode":"UG","latitude":"0.53437430","longitude":"33.30371430"},{"name":"Kamuli District","isoCode":"205","countryCode":"UG","latitude":"0.91871070","longitude":"33.12390490"},{"name":"Kapchorwa District","isoCode":"206","countryCode":"UG","latitude":"1.33502050","longitude":"34.39763560"},{"name":"Katakwi District","isoCode":"207","countryCode":"UG","latitude":"1.97310300","longitude":"34.06414190"},{"name":"Kumi District","isoCode":"208","countryCode":"UG","latitude":"1.48769990","longitude":"33.93039910"},{"name":"Mbale District","isoCode":"209","countryCode":"UG","latitude":"1.03442740","longitude":"34.19768820"},{"name":"Pallisa District","isoCode":"210","countryCode":"UG","latitude":"1.23242060","longitude":"33.75177230"},{"name":"Soroti District","isoCode":"211","countryCode":"UG","latitude":"1.72291170","longitude":"33.52800720"},{"name":"Tororo District","isoCode":"212","countryCode":"UG","latitude":"0.68709940","longitude":"34.06414190"},{"name":"Kaberamaido District","isoCode":"213","countryCode":"UG","latitude":"1.69633220","longitude":"33.21385100"},{"name":"Mayuge District","isoCode":"214","countryCode":"UG","latitude":"-0.21829820","longitude":"33.57280270"},{"name":"Sironko District","isoCode":"215","countryCode":"UG","latitude":"1.23022740","longitude":"34.24910640"},{"name":"Amuria District","isoCode":"216","countryCode":"UG","latitude":"2.03017000","longitude":"33.64275330"},{"name":"Budaka District","isoCode":"217","countryCode":"UG","latitude":"1.10162770","longitude":"33.93039910"},{"name":"Bududa District","isoCode":"218","countryCode":"UG","latitude":"1.00296930","longitude":"34.33381230"},{"name":"Bukedea District","isoCode":"219","countryCode":"UG","latitude":"1.35568980","longitude":"34.10867930"},{"name":"Bukwo District","isoCode":"220","countryCode":"UG","latitude":"1.28186510","longitude":"34.72987650"},{"name":"Butaleja District","isoCode":"221","countryCode":"UG","latitude":"0.84749220","longitude":"33.84112880"},{"name":"Kaliro District","isoCode":"222","countryCode":"UG","latitude":"1.04311070","longitude":"33.48319060"},{"name":"Manafwa District","isoCode":"223","countryCode":"UG","latitude":"0.90635990","longitude":"34.28660910"},{"name":"Namutumba District","isoCode":"224","countryCode":"UG","latitude":"0.84926100","longitude":"33.66233010"},{"name":"Bulambuli District","isoCode":"225","countryCode":"UG","latitude":"1.47988460","longitude":"34.37544140"},{"name":"Buyende District","isoCode":"226","countryCode":"UG","latitude":"1.24136820","longitude":"33.12390490"},{"name":"Kibuku District","isoCode":"227","countryCode":"UG","latitude":"1.04528740","longitude":"33.79925360"},{"name":"Kween District","isoCode":"228","countryCode":"UG","latitude":"1.44387900","longitude":"34.59713200"},{"name":"Luuka District","isoCode":"229","countryCode":"UG","latitude":"0.72505990","longitude":"33.30371430"},{"name":"Namayingo District","isoCode":"230","countryCode":"UG","latitude":"-0.28035750","longitude":"33.75177230"},{"name":"Ngora District","isoCode":"231","countryCode":"UG","latitude":"1.49081150","longitude":"33.75177230"},{"name":"Serere District","isoCode":"232","countryCode":"UG","latitude":"1.49940330","longitude":"33.54900780"},{"name":"Butebo District","isoCode":"233","countryCode":"UG","latitude":"1.21411240","longitude":"33.90808960"},{"name":"Namisindwa District","isoCode":"234","countryCode":"UG","latitude":"0.90710100","longitude":"34.35740370"},{"name":"Adjumani District","isoCode":"301","countryCode":"UG","latitude":"3.25485270","longitude":"31.71954590"},{"name":"Apac District","isoCode":"302","countryCode":"UG","latitude":"1.87302630","longitude":"32.62774550"},{"name":"Arua District","isoCode":"303","countryCode":"UG","latitude":"2.99598460","longitude":"31.17103890"},{"name":"Gulu District","isoCode":"304","countryCode":"UG","latitude":"2.81857760","longitude":"32.44672380"},{"name":"Kitgum District","isoCode":"305","countryCode":"UG","latitude":"3.33968290","longitude":"33.16888830"},{"name":"Kotido District","isoCode":"306","countryCode":"UG","latitude":"3.04156790","longitude":"33.88577470"},{"name":"Lira District","isoCode":"307","countryCode":"UG","latitude":"2.23161690","longitude":"32.94376670"},{"name":"Moroto District","isoCode":"308","countryCode":"UG","latitude":"2.61685450","longitude":"34.59713200"},{"name":"Moyo District","isoCode":"309","countryCode":"UG","latitude":"3.56964640","longitude":"31.67393710"},{"name":"Nebbi District","isoCode":"310","countryCode":"UG","latitude":"2.44093920","longitude":"31.35416310"},{"name":"Nakapiripirit District","isoCode":"311","countryCode":"UG","latitude":"1.96061730","longitude":"34.59713200"},{"name":"Pader District","isoCode":"312","countryCode":"UG","latitude":"2.94306820","longitude":"32.80844960"},{"name":"Yumbe District","isoCode":"313","countryCode":"UG","latitude":"3.46980230","longitude":"31.24832910"},{"name":"Abim District","isoCode":"314","countryCode":"UG","latitude":"2.70669800","longitude":"33.65953370"},{"name":"Amolatar District","isoCode":"315","countryCode":"UG","latitude":"1.60544020","longitude":"32.80844960"},{"name":"Amuru District","isoCode":"316","countryCode":"UG","latitude":"2.96678780","longitude":"32.08374450"},{"name":"Dokolo District","isoCode":"317","countryCode":"UG","latitude":"1.96364210","longitude":"33.03387670"},{"name":"Kaabong District","isoCode":"318","countryCode":"UG","latitude":"3.51262150","longitude":"33.97500180"},{"name":"Koboko District","isoCode":"319","countryCode":"UG","latitude":"3.52370580","longitude":"31.03351000"},{"name":"Maracha District","isoCode":"320","countryCode":"UG","latitude":"3.28731270","longitude":"30.94030230"},{"name":"Oyam District","isoCode":"321","countryCode":"UG","latitude":"2.27762810","longitude":"32.44672380"},{"name":"Agago District","isoCode":"322","countryCode":"UG","latitude":"2.92508200","longitude":"33.34861470"},{"name":"Alebtong District","isoCode":"323","countryCode":"UG","latitude":"2.25457730","longitude":"33.34861470"},{"name":"Amudat District","isoCode":"324","countryCode":"UG","latitude":"1.79162240","longitude":"34.90655100"},{"name":"Kole District","isoCode":"325","countryCode":"UG","latitude":"2.37010970","longitude":"32.76330360"},{"name":"Lamwo District","isoCode":"326","countryCode":"UG","latitude":"3.57075680","longitude":"32.53727410"},{"name":"Napak District","isoCode":"327","countryCode":"UG","latitude":"2.36299450","longitude":"34.24215970"},{"name":"Nwoya District","isoCode":"328","countryCode":"UG","latitude":"2.56244400","longitude":"31.90179540"},{"name":"Otuke District","isoCode":"329","countryCode":"UG","latitude":"2.52140590","longitude":"33.34861470"},{"name":"Zombo District","isoCode":"330","countryCode":"UG","latitude":"2.55442930","longitude":"30.94173680"},{"name":"Omoro District","isoCode":"331","countryCode":"UG","latitude":"2.71522300","longitude":"32.49200880"},{"name":"Pakwach District","isoCode":"332","countryCode":"UG","latitude":"2.46071410","longitude":"31.49417380"},{"name":"Bundibugyo District","isoCode":"401","countryCode":"UG","latitude":"0.68517630","longitude":"30.02029640"},{"name":"Bushenyi District","isoCode":"402","countryCode":"UG","latitude":"-0.48709180","longitude":"30.20510960"},{"name":"Kabale District","isoCode":"404","countryCode":"UG","latitude":"-1.24930840","longitude":"30.06652360"},{"name":"Kabarole District","isoCode":"405","countryCode":"UG","latitude":"0.58507910","longitude":"30.25127280"},{"name":"Kasese District","isoCode":"406","countryCode":"UG","latitude":"0.06462850","longitude":"30.06652360"},{"name":"Kibaale District","isoCode":"407","countryCode":"UG","latitude":"0.90668020","longitude":"31.07937050"},{"name":"Kisoro District","isoCode":"408","countryCode":"UG","latitude":"-1.22094300","longitude":"29.64991620"},{"name":"Masindi District","isoCode":"409","countryCode":"UG","latitude":"1.49203630","longitude":"31.71954590"},{"name":"Mbarara District","isoCode":"410","countryCode":"UG","latitude":"-0.60715960","longitude":"30.65450220"},{"name":"Ntungamo District","isoCode":"411","countryCode":"UG","latitude":"-0.98073410","longitude":"30.25127280"},{"name":"Rukungiri District","isoCode":"412","countryCode":"UG","latitude":"-0.75184900","longitude":"29.92779470"},{"name":"Kamwenge District","isoCode":"413","countryCode":"UG","latitude":"0.22579300","longitude":"30.48184460"},{"name":"Kanungu District","isoCode":"414","countryCode":"UG","latitude":"-0.81952530","longitude":"29.74260400"},{"name":"Kyenjojo District","isoCode":"415","countryCode":"UG","latitude":"0.60929230","longitude":"30.64012310"},{"name":"Buliisa District","isoCode":"416","countryCode":"UG","latitude":"2.02996070","longitude":"31.53700030"},{"name":"Ibanda District","isoCode":"417","countryCode":"UG","latitude":"-0.09648900","longitude":"30.57395790"},{"name":"Isingiro District","isoCode":"418","countryCode":"UG","latitude":"-0.84354300","longitude":"30.80394740"},{"name":"Kiruhura District","isoCode":"419","countryCode":"UG","latitude":"-0.19279980","longitude":"30.80394740"},{"name":"Buhweju District","isoCode":"420","countryCode":"UG","latitude":"-0.29113590","longitude":"30.29741990"},{"name":"Kiryandongo District","isoCode":"421","countryCode":"UG","latitude":"2.01799070","longitude":"32.08374450"},{"name":"Kyegegwa District","isoCode":"422","countryCode":"UG","latitude":"0.48181930","longitude":"31.05500930"},{"name":"Mitooma District","isoCode":"423","countryCode":"UG","latitude":"-0.61932760","longitude":"30.02029640"},{"name":"Ntoroko District","isoCode":"424","countryCode":"UG","latitude":"1.07881780","longitude":"30.38966510"},{"name":"Rubirizi District","isoCode":"425","countryCode":"UG","latitude":"-0.26424100","longitude":"30.10840330"},{"name":"Sheema District","isoCode":"426","countryCode":"UG","latitude":"-0.55152980","longitude":"30.38966510"},{"name":"Kagadi District","isoCode":"427","countryCode":"UG","latitude":"0.94007610","longitude":"30.81256380"},{"name":"Kakumiro District","isoCode":"428","countryCode":"UG","latitude":"0.78080350","longitude":"31.32413890"},{"name":"Rubanda District","isoCode":"429","countryCode":"UG","latitude":"-1.18611900","longitude":"29.84535760"},{"name":"Bunyangabu District","isoCode":"430","countryCode":"UG","latitude":"0.48709180","longitude":"30.20510960"},{"name":"Rukiga District","isoCode":"431","countryCode":"UG","latitude":"-1.13263370","longitude":"30.04341200"},{"name":"Central Region","isoCode":"C","countryCode":"UG","latitude":"44.29687500","longitude":"-94.74017330"},{"name":"Eastern Region","isoCode":"E","countryCode":"UG","latitude":"6.23740360","longitude":"-0.45023680"},{"name":"Northern Region","isoCode":"N","countryCode":"UG","latitude":"9.54392690","longitude":"-0.90566230"},{"name":"Western Region","isoCode":"W","countryCode":"UG","latitude":"40.76672150","longitude":"-111.88772030"},{"name":"Alaska","isoCode":"AK","countryCode":"US","latitude":"64.20084130","longitude":"-149.49367330"},{"name":"Alabama","isoCode":"AL","countryCode":"US","latitude":"32.31823140","longitude":"-86.90229800"},{"name":"Arkansas","isoCode":"AR","countryCode":"US","latitude":"35.20105000","longitude":"-91.83183340"},{"name":"American Samoa","isoCode":"AS","countryCode":"US","latitude":"-14.27097200","longitude":"-170.13221700"},{"name":"Arizona","isoCode":"AZ","countryCode":"US","latitude":"34.04892810","longitude":"-111.09373110"},{"name":"California","isoCode":"CA","countryCode":"US","latitude":"36.77826100","longitude":"-119.41793240"},{"name":"Colorado","isoCode":"CO","countryCode":"US","latitude":"39.55005070","longitude":"-105.78206740"},{"name":"Connecticut","isoCode":"CT","countryCode":"US","latitude":"41.60322070","longitude":"-73.08774900"},{"name":"District of Columbia","isoCode":"DC","countryCode":"US","latitude":"38.90719230","longitude":"-77.03687070"},{"name":"Delaware","isoCode":"DE","countryCode":"US","latitude":"38.91083250","longitude":"-75.52766990"},{"name":"Florida","isoCode":"FL","countryCode":"US","latitude":"27.66482740","longitude":"-81.51575350"},{"name":"Georgia","isoCode":"GA","countryCode":"US","latitude":"32.16562210","longitude":"-82.90007510"},{"name":"Guam","isoCode":"GU","countryCode":"US","latitude":"13.44430400","longitude":"144.79373100"},{"name":"Hawaii","isoCode":"HI","countryCode":"US","latitude":"19.89676620","longitude":"-155.58278180"},{"name":"Iowa","isoCode":"IA","countryCode":"US","latitude":"41.87800250","longitude":"-93.09770200"},{"name":"Idaho","isoCode":"ID","countryCode":"US","latitude":"44.06820190","longitude":"-114.74204080"},{"name":"Illinois","isoCode":"IL","countryCode":"US","latitude":"40.63312490","longitude":"-89.39852830"},{"name":"Indiana","isoCode":"IN","countryCode":"US","latitude":"40.26719410","longitude":"-86.13490190"},{"name":"Kansas","isoCode":"KS","countryCode":"US","latitude":"39.01190200","longitude":"-98.48424650"},{"name":"Kentucky","isoCode":"KY","countryCode":"US","latitude":"37.83933320","longitude":"-84.27001790"},{"name":"Louisiana","isoCode":"LA","countryCode":"US","latitude":"30.98429770","longitude":"-91.96233270"},{"name":"Massachusetts","isoCode":"MA","countryCode":"US","latitude":"42.40721070","longitude":"-71.38243740"},{"name":"Maryland","isoCode":"MD","countryCode":"US","latitude":"39.04575490","longitude":"-76.64127120"},{"name":"Maine","isoCode":"ME","countryCode":"US","latitude":"45.25378300","longitude":"-69.44546890"},{"name":"Michigan","isoCode":"MI","countryCode":"US","latitude":"44.31484430","longitude":"-85.60236430"},{"name":"Minnesota","isoCode":"MN","countryCode":"US","latitude":"46.72955300","longitude":"-94.68589980"},{"name":"Missouri","isoCode":"MO","countryCode":"US","latitude":"37.96425290","longitude":"-91.83183340"},{"name":"Northern Mariana Islands","isoCode":"MP","countryCode":"US","latitude":"15.09790000","longitude":"145.67390000"},{"name":"Mississippi","isoCode":"MS","countryCode":"US","latitude":"32.35466790","longitude":"-89.39852830"},{"name":"Montana","isoCode":"MT","countryCode":"US","latitude":"46.87968220","longitude":"-110.36256580"},{"name":"North Carolina","isoCode":"NC","countryCode":"US","latitude":"35.75957310","longitude":"-79.01929970"},{"name":"North Dakota","isoCode":"ND","countryCode":"US","latitude":"47.55149260","longitude":"-101.00201190"},{"name":"Nebraska","isoCode":"NE","countryCode":"US","latitude":"41.49253740","longitude":"-99.90181310"},{"name":"New Hampshire","isoCode":"NH","countryCode":"US","latitude":"43.19385160","longitude":"-71.57239530"},{"name":"New Jersey","isoCode":"NJ","countryCode":"US","latitude":"40.05832380","longitude":"-74.40566120"},{"name":"New Mexico","isoCode":"NM","countryCode":"US","latitude":"34.51994020","longitude":"-105.87009010"},{"name":"Nevada","isoCode":"NV","countryCode":"US","latitude":"38.80260970","longitude":"-116.41938900"},{"name":"New York","isoCode":"NY","countryCode":"US","latitude":"40.71277530","longitude":"-74.00597280"},{"name":"Ohio","isoCode":"OH","countryCode":"US","latitude":"40.41728710","longitude":"-82.90712300"},{"name":"Oklahoma","isoCode":"OK","countryCode":"US","latitude":"35.46756020","longitude":"-97.51642760"},{"name":"Oregon","isoCode":"OR","countryCode":"US","latitude":"43.80413340","longitude":"-120.55420120"},{"name":"Pennsylvania","isoCode":"PA","countryCode":"US","latitude":"41.20332160","longitude":"-77.19452470"},{"name":"Puerto Rico","isoCode":"PR","countryCode":"US","latitude":"18.22083300","longitude":"-66.59014900"},{"name":"Rhode Island","isoCode":"RI","countryCode":"US","latitude":"41.58009450","longitude":"-71.47742910"},{"name":"South Carolina","isoCode":"SC","countryCode":"US","latitude":"33.83608100","longitude":"-81.16372450"},{"name":"South Dakota","isoCode":"SD","countryCode":"US","latitude":"43.96951480","longitude":"-99.90181310"},{"name":"Tennessee","isoCode":"TN","countryCode":"US","latitude":"35.51749130","longitude":"-86.58044730"},{"name":"Texas","isoCode":"TX","countryCode":"US","latitude":"31.96859880","longitude":"-99.90181310"},{"name":"United States Minor Outlying Islands","isoCode":"UM","countryCode":"US","latitude":"19.28231920","longitude":"166.64704700"},{"name":"Johnston Atoll","isoCode":"UM-67","countryCode":"US","latitude":"16.72950350","longitude":"-169.53364770"},{"name":"Midway Atoll","isoCode":"UM-71","countryCode":"US","latitude":"28.20721680","longitude":"-177.37349260"},{"name":"Navassa Island","isoCode":"UM-76","countryCode":"US","latitude":"18.41006890","longitude":"-75.01146120"},{"name":"Wake Island","isoCode":"UM-79","countryCode":"US","latitude":"19.27961900","longitude":"166.64993480"},{"name":"Baker Island","isoCode":"UM-81","countryCode":"US","latitude":"0.19362660","longitude":"-176.47690800"},{"name":"Howland Island","isoCode":"UM-84","countryCode":"US","latitude":"0.81132190","longitude":"-176.61827360"},{"name":"Jarvis Island","isoCode":"UM-86","countryCode":"US","latitude":"-0.37435030","longitude":"-159.99672060"},{"name":"Kingman Reef","isoCode":"UM-89","countryCode":"US","latitude":"6.38333300","longitude":"-162.41666700"},{"name":"Palmyra Atoll","isoCode":"UM-95","countryCode":"US","latitude":"5.88850260","longitude":"-162.07866560"},{"name":"Utah","isoCode":"UT","countryCode":"US","latitude":"39.32098010","longitude":"-111.09373110"},{"name":"Virginia","isoCode":"VA","countryCode":"US","latitude":"37.43157340","longitude":"-78.65689420"},{"name":"United States Virgin Islands","isoCode":"VI","countryCode":"US","latitude":"18.33576500","longitude":"-64.89633500"},{"name":"Vermont","isoCode":"VT","countryCode":"US","latitude":"44.55880280","longitude":"-72.57784150"},{"name":"Washington","isoCode":"WA","countryCode":"US","latitude":"47.75107410","longitude":"-120.74013850"},{"name":"Wisconsin","isoCode":"WI","countryCode":"US","latitude":"43.78443970","longitude":"-88.78786780"},{"name":"West Virginia","isoCode":"WV","countryCode":"US","latitude":"38.59762620","longitude":"-80.45490260"},{"name":"Wyoming","isoCode":"WY","countryCode":"US","latitude":"43.07596780","longitude":"-107.29028390"},{"name":"Artigas Department","isoCode":"AR","countryCode":"UY","latitude":"-30.61751120","longitude":"-56.95945590"},{"name":"Canelones Department","isoCode":"CA","countryCode":"UY","latitude":"-34.54087170","longitude":"-55.93076000"},{"name":"Cerro Largo Department","isoCode":"CL","countryCode":"UY","latitude":"-32.44110320","longitude":"-54.35217530"},{"name":"Colonia Department","isoCode":"CO","countryCode":"UY","latitude":"-34.12946780","longitude":"-57.66051840"},{"name":"Durazno Department","isoCode":"DU","countryCode":"UY","latitude":"-33.02324540","longitude":"-56.02846440"},{"name":"Florida Department","isoCode":"FD","countryCode":"UY","latitude":"28.03594950","longitude":"-82.45792890"},{"name":"Flores Department","isoCode":"FS","countryCode":"UY","latitude":"-33.57337530","longitude":"-56.89450280"},{"name":"Lavalleja Department","isoCode":"LA","countryCode":"UY","latitude":"-33.92261750","longitude":"-54.97657940"},{"name":"Maldonado Department","isoCode":"MA","countryCode":"UY","latitude":"-34.55979320","longitude":"-54.86285520"},{"name":"Montevideo Department","isoCode":"MO","countryCode":"UY","latitude":"-34.81815870","longitude":"-56.21382560"},{"name":"Paysand\xfa Department","isoCode":"PA","countryCode":"UY","latitude":"-32.06673660","longitude":"-57.33647890"},{"name":"R\xedo Negro Department","isoCode":"RN","countryCode":"UY","latitude":"-32.76763560","longitude":"-57.42952070"},{"name":"Rocha Department","isoCode":"RO","countryCode":"UY","latitude":"-33.96900810","longitude":"-54.02148500"},{"name":"Rivera Department","isoCode":"RV","countryCode":"UY","latitude":"-31.48174210","longitude":"-55.24357590"},{"name":"Salto Department","isoCode":"SA","countryCode":"UY","latitude":"-31.38802800","longitude":"-57.96124550"},{"name":"San Jos\xe9 Department","isoCode":"SJ","countryCode":"UY","latitude":"37.34929680","longitude":"-121.90560490"},{"name":"Soriano Department","isoCode":"SO","countryCode":"UY","latitude":"-33.51027920","longitude":"-57.74981030"},{"name":"Tacuaremb\xf3 Department","isoCode":"TA","countryCode":"UY","latitude":"-31.72068370","longitude":"-55.98598870"},{"name":"Treinta y Tres Department","isoCode":"TT","countryCode":"UY","latitude":"-33.06850860","longitude":"-54.28586270"},{"name":"Andijan Region","isoCode":"AN","countryCode":"UZ","latitude":"40.76859410","longitude":"72.23637900"},{"name":"Bukhara Region","isoCode":"BU","countryCode":"UZ","latitude":"40.25041620","longitude":"63.20321510"},{"name":"Fergana Region","isoCode":"FA","countryCode":"UZ","latitude":"40.45680810","longitude":"71.28742090"},{"name":"Jizzakh Region","isoCode":"JI","countryCode":"UZ","latitude":"40.47064150","longitude":"67.57085360"},{"name":"Namangan Region","isoCode":"NG","countryCode":"UZ","latitude":"41.05100370","longitude":"71.09731700"},{"name":"Navoiy Region","isoCode":"NW","countryCode":"UZ","latitude":"42.69885750","longitude":"64.63376850"},{"name":"Qashqadaryo Region","isoCode":"QA","countryCode":"UZ","latitude":"38.89862310","longitude":"66.04635340"},{"name":"Karakalpakstan","isoCode":"QR","countryCode":"UZ","latitude":"43.80413340","longitude":"59.44579880"},{"name":"Samarqand Region","isoCode":"SA","countryCode":"UZ","latitude":"39.62701200","longitude":"66.97497310"},{"name":"Sirdaryo Region","isoCode":"SI","countryCode":"UZ","latitude":"40.38638080","longitude":"68.71549750"},{"name":"Surxondaryo Region","isoCode":"SU","countryCode":"UZ","latitude":"37.94090050","longitude":"67.57085360"},{"name":"Tashkent","isoCode":"TK","countryCode":"UZ","latitude":"41.29949580","longitude":"69.24007340"},{"name":"Tashkent Region","isoCode":"TO","countryCode":"UZ","latitude":"41.22132340","longitude":"69.85974060"},{"name":"Xorazm Region","isoCode":"XO","countryCode":"UZ","latitude":"41.35653360","longitude":"60.85666860"},{"name":"Charlotte Parish","isoCode":"01","countryCode":"VC","latitude":"13.21754510","longitude":"-61.16362440"},{"name":"Saint Andrew Parish","isoCode":"02","countryCode":"VC","latitude":"43.02429990","longitude":"-81.20250000"},{"name":"Saint David Parish","isoCode":"03","countryCode":"VC","latitude":"43.85230950","longitude":"-79.52366540"},{"name":"Saint George Parish","isoCode":"04","countryCode":"VC","latitude":"42.95760900","longitude":"-81.32670500"},{"name":"Saint Patrick Parish","isoCode":"05","countryCode":"VC","latitude":"39.75091860","longitude":"-94.84505560"},{"name":"Grenadines Parish","isoCode":"06","countryCode":"VC","latitude":"13.01229650","longitude":"-61.22773010"},{"name":"Distrito Capital","isoCode":"A","countryCode":"VE","latitude":"41.26148460","longitude":"-95.93108070"},{"name":"Anzo\xe1tegui","isoCode":"B","countryCode":"VE","latitude":"8.59130730","longitude":"-63.95861110"},{"name":"Apure","isoCode":"C","countryCode":"VE","latitude":"6.92694830","longitude":"-68.52471490"},{"name":"Aragua","isoCode":"D","countryCode":"VE","latitude":"10.06357580","longitude":"-67.28478750"},{"name":"Barinas","isoCode":"E","countryCode":"VE","latitude":"8.62314980","longitude":"-70.23710450"},{"name":"Bol\xedvar","isoCode":"F","countryCode":"VE","latitude":"37.61448380","longitude":"-93.41047490"},{"name":"Carabobo","isoCode":"G","countryCode":"VE","latitude":"10.11764330","longitude":"-68.04775090"},{"name":"Cojedes","isoCode":"H","countryCode":"VE","latitude":"9.38166820","longitude":"-68.33392750"},{"name":"Falc\xf3n","isoCode":"I","countryCode":"VE","latitude":"11.18106740","longitude":"-69.85974060"},{"name":"Gu\xe1rico","isoCode":"J","countryCode":"VE","latitude":"8.74893090","longitude":"-66.23671720"},{"name":"Lara","isoCode":"K","countryCode":"VE","latitude":"33.98221650","longitude":"-118.13227470"},{"name":"M\xe9rida","isoCode":"L","countryCode":"VE","latitude":"20.96737020","longitude":"-89.59258570"},{"name":"Miranda","isoCode":"M","countryCode":"VE","latitude":"42.35193830","longitude":"-71.52907660"},{"name":"Monagas","isoCode":"N","countryCode":"VE","latitude":"9.32416520","longitude":"-63.01475780"},{"name":"Nueva Esparta","isoCode":"O","countryCode":"VE","latitude":"10.99707230","longitude":"-63.91132960"},{"name":"Portuguesa","isoCode":"P","countryCode":"VE","latitude":"9.09439990","longitude":"-69.09702300"},{"name":"Sucre","isoCode":"R","countryCode":"VE","latitude":"-19.03534500","longitude":"-65.25921280"},{"name":"T\xe1chira","isoCode":"S","countryCode":"VE","latitude":"7.91370010","longitude":"-72.14161320"},{"name":"Trujillo","isoCode":"T","countryCode":"VE","latitude":"36.67343430","longitude":"-121.62875880"},{"name":"Yaracuy","isoCode":"U","countryCode":"VE","latitude":"10.33938900","longitude":"-68.81088490"},{"name":"Zulia","isoCode":"V","countryCode":"VE","latitude":"10.29102370","longitude":"-72.14161320"},{"name":"Federal Dependencies of Venezuela","isoCode":"W","countryCode":"VE","latitude":"10.93770530","longitude":"-65.35695730"},{"name":"La Guaira","isoCode":"X","countryCode":"VE","latitude":"29.30522680","longitude":"-94.79138540"},{"name":"Delta Amacuro","isoCode":"Y","countryCode":"VE","latitude":"8.84993070","longitude":"-61.14031960"},{"name":"Amazonas","isoCode":"Z","countryCode":"VE","latitude":"-3.41684270","longitude":"-65.85606460"},{"name":"Lai Ch\xe2u","isoCode":"01","countryCode":"VN","latitude":"22.38622270","longitude":"103.47026310"},{"name":"L\xe0o Cai","isoCode":"02","countryCode":"VN","latitude":"22.48094310","longitude":"103.97549590"},{"name":"H\xe0 Giang","isoCode":"03","countryCode":"VN","latitude":"22.80255880","longitude":"104.97844940"},{"name":"Cao B\u1EB1ng","isoCode":"04","countryCode":"VN","latitude":"22.63568900","longitude":"106.25221430"},{"name":"S\u01A1n La","isoCode":"05","countryCode":"VN","latitude":"21.10222840","longitude":"103.72891670"},{"name":"Y\xean B\xe1i","isoCode":"06","countryCode":"VN","latitude":"21.71676890","longitude":"104.89858780"},{"name":"Tuy\xean Quang","isoCode":"07","countryCode":"VN","latitude":"21.77672460","longitude":"105.22801960"},{"name":"L\u1EA1ng S\u01A1n","isoCode":"09","countryCode":"VN","latitude":"21.85370800","longitude":"106.76151900"},{"name":"Qu\u1EA3ng Ninh","isoCode":"13","countryCode":"VN","latitude":"21.00638200","longitude":"107.29251440"},{"name":"H\xf2a B\xecnh","isoCode":"14","countryCode":"VN","latitude":"20.68612650","longitude":"105.31311850"},{"name":"Ninh B\xecnh","isoCode":"18","countryCode":"VN","latitude":"20.25061490","longitude":"105.97445360"},{"name":"Th\xe1i B\xecnh","isoCode":"20","countryCode":"VN","latitude":"20.44634710","longitude":"106.33658280"},{"name":"Thanh H\xf3a","isoCode":"21","countryCode":"VN","latitude":"19.80669200","longitude":"105.78518160"},{"name":"Ngh\u1EC7 An","isoCode":"22","countryCode":"VN","latitude":"19.23424890","longitude":"104.92003650"},{"name":"H\xe0 T\u0129nh","isoCode":"23","countryCode":"VN","latitude":"18.35595370","longitude":"105.88774940"},{"name":"Qu\u1EA3ng B\xecnh","isoCode":"24","countryCode":"VN","latitude":"17.61027150","longitude":"106.34874740"},{"name":"Qu\u1EA3ng Tr\u1ECB","isoCode":"25","countryCode":"VN","latitude":"16.74030740","longitude":"107.18546790"},{"name":"Th\u1EEBa Thi\xean-Hu\u1EBF","isoCode":"26","countryCode":"VN","latitude":"16.46739700","longitude":"107.59053260"},{"name":"Qu\u1EA3ng Nam","isoCode":"27","countryCode":"VN","latitude":"15.53935380","longitude":"108.01910200"},{"name":"Kon Tum","isoCode":"28","countryCode":"VN","latitude":"14.34974030","longitude":"108.00046060"},{"name":"Qu\u1EA3ng Ng\xe3i","isoCode":"29","countryCode":"VN","latitude":"15.12138730","longitude":"108.80441450"},{"name":"Gia Lai","isoCode":"30","countryCode":"VN","latitude":"13.80789430","longitude":"108.10937500"},{"name":"B\xecnh \u0110\u1ECBnh","isoCode":"31","countryCode":"VN","latitude":"14.16653240","longitude":"108.90268300"},{"name":"Ph\xfa Y\xean","isoCode":"32","countryCode":"VN","latitude":"13.08818610","longitude":"109.09287640"},{"name":"\u0110\u1EAFk L\u1EAFk","isoCode":"33","countryCode":"VN","latitude":"12.71001160","longitude":"108.23775190"},{"name":"Kh\xe1nh H\xf2a","isoCode":"34","countryCode":"VN","latitude":"12.25850980","longitude":"109.05260760"},{"name":"L\xe2m \u0110\u1ED3ng","isoCode":"35","countryCode":"VN","latitude":"11.57527910","longitude":"108.14286690"},{"name":"Ninh Thu\u1EADn","isoCode":"36","countryCode":"VN","latitude":"11.67387670","longitude":"108.86295720"},{"name":"T\xe2y Ninh","isoCode":"37","countryCode":"VN","latitude":"11.33515540","longitude":"106.10988540"},{"name":"\u0110\u1ED3ng Nai","isoCode":"39","countryCode":"VN","latitude":"11.06863050","longitude":"107.16759760"},{"name":"B\xecnh Thu\u1EADn","isoCode":"40","countryCode":"VN","latitude":"11.09037030","longitude":"108.07207810"},{"name":"Long An","isoCode":"41","countryCode":"VN","latitude":"10.56071680","longitude":"106.64976230"},{"name":"B\xe0 R\u1ECBa-V\u0169ng T\xe0u","isoCode":"43","countryCode":"VN","latitude":"10.54173970","longitude":"107.24299760"},{"name":"An Giang","isoCode":"44","countryCode":"VN","latitude":"10.52158360","longitude":"105.12589550"},{"name":"\u0110\u1ED3ng Th\xe1p","isoCode":"45","countryCode":"VN","latitude":"10.49379890","longitude":"105.68817880"},{"name":"Ti\u1EC1n Giang","isoCode":"46","countryCode":"VN","latitude":"10.44933240","longitude":"106.34205040"},{"name":"Ki\xean Giang","isoCode":"47","countryCode":"VN","latitude":"9.82495870","longitude":"105.12589550"},{"name":"V\u0129nh Long","isoCode":"49","countryCode":"VN","latitude":"10.23957400","longitude":"105.95719280"},{"name":"B\u1EBFn Tre","isoCode":"50","countryCode":"VN","latitude":"10.24335560","longitude":"106.37555100"},{"name":"Tr\xe0 Vinh","isoCode":"51","countryCode":"VN","latitude":"9.81274100","longitude":"106.29929120"},{"name":"S\xf3c Tr\u0103ng","isoCode":"52","countryCode":"VN","latitude":"9.60252100","longitude":"105.97390490"},{"name":"B\u1EAFc K\u1EA1n","isoCode":"53","countryCode":"VN","latitude":"22.30329230","longitude":"105.87600400"},{"name":"B\u1EAFc Giang","isoCode":"54","countryCode":"VN","latitude":"21.28199210","longitude":"106.19747690"},{"name":"B\u1EA1c Li\xeau","isoCode":"55","countryCode":"VN","latitude":"9.29400270","longitude":"105.72156630"},{"name":"B\u1EAFc Ninh","isoCode":"56","countryCode":"VN","latitude":"21.12144400","longitude":"106.11105010"},{"name":"B\xecnh D\u01B0\u01A1ng","isoCode":"57","countryCode":"VN","latitude":"11.32540240","longitude":"106.47701700"},{"name":"B\xecnh Ph\u01B0\u1EDBc","isoCode":"58","countryCode":"VN","latitude":"11.75118940","longitude":"106.72346390"},{"name":"C\xe0 Mau","isoCode":"59","countryCode":"VN","latitude":"9.15267280","longitude":"105.19607950"},{"name":"H\u1EA3i D\u01B0\u01A1ng","isoCode":"61","countryCode":"VN","latitude":"20.93734130","longitude":"106.31455420"},{"name":"H\xe0 Nam","isoCode":"63","countryCode":"VN","latitude":"20.58351960","longitude":"105.92299000"},{"name":"H\u01B0ng Y\xean","isoCode":"66","countryCode":"VN","latitude":"20.85257110","longitude":"106.01699710"},{"name":"Nam \u0110\u1ECBnh","isoCode":"67","countryCode":"VN","latitude":"20.43882250","longitude":"106.16210530"},{"name":"Ph\xfa Th\u1ECD","isoCode":"68","countryCode":"VN","latitude":"21.26844300","longitude":"105.20455730"},{"name":"Th\xe1i Nguy\xean","isoCode":"69","countryCode":"VN","latitude":"21.56715590","longitude":"105.82520380"},{"name":"V\u0129nh Ph\xfac","isoCode":"70","countryCode":"VN","latitude":"21.36088050","longitude":"105.54743730"},{"name":"\u0110i\u1EC7n Bi\xean","isoCode":"71","countryCode":"VN","latitude":"21.80423090","longitude":"103.10765250"},{"name":"\u0110\u1EAFk N\xf4ng","isoCode":"72","countryCode":"VN","latitude":"12.26464760","longitude":"107.60980600"},{"name":"H\u1EADu Giang","isoCode":"73","countryCode":"VN","latitude":"9.75789800","longitude":"105.64125270"},{"name":"C\u1EA7n Th\u01A1","isoCode":"CT","countryCode":"VN","latitude":"10.03418510","longitude":"105.72255070"},{"name":"\u0110\xe0 N\u1EB5ng","isoCode":"DN","countryCode":"VN","latitude":"16.05440680","longitude":"108.20216670"},{"name":"H\xe0 N\u1ED9i","isoCode":"HN","countryCode":"VN","latitude":"21.02776440","longitude":"105.83415980"},{"name":"H\u1EA3i Ph\xf2ng","isoCode":"HP","countryCode":"VN","latitude":"20.84491150","longitude":"106.68808410"},{"name":"H\u1ED3 Ch\xed Minh","isoCode":"SG","countryCode":"VN","latitude":"10.82309890","longitude":"106.62966380"},{"name":"Malampa","isoCode":"MAP","countryCode":"VU","latitude":"-16.40114050","longitude":"167.60778650"},{"name":"Penama","isoCode":"PAM","countryCode":"VU","latitude":"-15.37957580","longitude":"167.90531820"},{"name":"Sanma","isoCode":"SAM","countryCode":"VU","latitude":"-15.48400170","longitude":"166.91820970"},{"name":"Shefa","isoCode":"SEE","countryCode":"VU","latitude":"32.80576500","longitude":"35.16997100"},{"name":"Tafea","isoCode":"TAE","countryCode":"VU","latitude":"-18.72378270","longitude":"169.06450560"},{"name":"Torba","isoCode":"TOB","countryCode":"VU","latitude":"37.07653000","longitude":"27.45657300"},{"name":"A\'ana","isoCode":"AA","countryCode":"WS","latitude":"-13.89841800","longitude":"-171.97529950"},{"name":"Aiga-i-le-Tai","isoCode":"AL","countryCode":"WS","latitude":"-13.85137910","longitude":"-172.03254010"},{"name":"Atua","isoCode":"AT","countryCode":"WS","latitude":"-13.97870530","longitude":"-171.62542830"},{"name":"Fa\'asaleleaga","isoCode":"FA","countryCode":"WS","latitude":"-13.63076380","longitude":"-172.23659810"},{"name":"Gaga\'emauga","isoCode":"GE","countryCode":"WS","latitude":"-13.54286660","longitude":"-172.36688700"},{"name":"Gaga\'ifomauga","isoCode":"GI","countryCode":"WS","latitude":"-13.54680070","longitude":"-172.49693310"},{"name":"Palauli","isoCode":"PA","countryCode":"WS","latitude":"-13.72945790","longitude":"-172.45361150"},{"name":"Satupa\'itea","isoCode":"SA","countryCode":"WS","latitude":"-13.65382140","longitude":"-172.61592710"},{"name":"Tuamasaga","isoCode":"TU","countryCode":"WS","latitude":"-13.91635920","longitude":"-171.82243620"},{"name":"Va\'a-o-Fonoti","isoCode":"VF","countryCode":"WS","latitude":"-13.94709030","longitude":"-171.54318720"},{"name":"Vaisigano","isoCode":"VS","countryCode":"WS","latitude":"-13.54138270","longitude":"-172.70233830"},{"name":"\u0110akovica District (Gjakove)","isoCode":"XDG","countryCode":"XK","latitude":"42.43757560","longitude":"20.37854380"},{"name":"Gjilan District","isoCode":"XGJ","countryCode":"XK","latitude":"42.46352060","longitude":"21.46940110"},{"name":"Kosovska Mitrovica District","isoCode":"XKM","countryCode":"XK","latitude":"42.89139090","longitude":"20.86599950"},{"name":"Pe\u0107 District","isoCode":"XPE","countryCode":"XK","latitude":"42.65921550","longitude":"20.28876240"},{"name":"Pristina (Pri\u015Ftine)","isoCode":"XPI","countryCode":"XK","latitude":"42.66291380","longitude":"21.16550280"},{"name":"Prizren District","isoCode":"XPR","countryCode":"XK","latitude":"42.21525220","longitude":"20.74147720"},{"name":"Uro\u0161evac District (Ferizaj)","isoCode":"XUF","countryCode":"XK","latitude":"42.37018440","longitude":"21.14832810"},{"name":"Abyan Governorate","isoCode":"AB","countryCode":"YE","latitude":"13.63434130","longitude":"46.05632120"},{"name":"\'Adan Governorate","isoCode":"AD","countryCode":"YE","latitude":"12.82574810","longitude":"44.79438040"},{"name":"\'Amran Governorate","isoCode":"AM","countryCode":"YE","latitude":"16.25692140","longitude":"43.94367880"},{"name":"Al Bayda\' Governorate","isoCode":"BA","countryCode":"YE","latitude":"14.35886620","longitude":"45.44980650"},{"name":"Dhamar Governorate","isoCode":"DH","countryCode":"YE","latitude":"14.71953440","longitude":"44.24790150"},{"name":"Hadhramaut Governorate","isoCode":"HD","countryCode":"YE","latitude":"16.93041350","longitude":"49.36531490"},{"name":"Hajjah Governorate","isoCode":"HJ","countryCode":"YE","latitude":"16.11806310","longitude":"43.32946600"},{"name":"Al Hudaydah Governorate","isoCode":"HU","countryCode":"YE","latitude":"15.30530720","longitude":"43.01948970"},{"name":"Ibb Governorate","isoCode":"IB","countryCode":"YE","latitude":"14.14157170","longitude":"44.24790150"},{"name":"Al Jawf Governorate","isoCode":"JA","countryCode":"YE","latitude":"16.79018190","longitude":"45.29938620"},{"name":"Lahij Governorate","isoCode":"LA","countryCode":"YE","latitude":"13.14895880","longitude":"44.85054950"},{"name":"Ma\'rib Governorate","isoCode":"MA","countryCode":"YE","latitude":"15.51588800","longitude":"45.44980650"},{"name":"Al Mahrah Governorate","isoCode":"MR","countryCode":"YE","latitude":"16.52384230","longitude":"51.68342750"},{"name":"Al Mahwit Governorate","isoCode":"MW","countryCode":"YE","latitude":"15.39632290","longitude":"43.56069460"},{"name":"Raymah Governorate","isoCode":"RA","countryCode":"YE","latitude":"14.62776820","longitude":"43.71424840"},{"name":"Sana\'a","isoCode":"SA","countryCode":"YE","latitude":"15.36944510","longitude":"44.19100660"},{"name":"Saada Governorate","isoCode":"SD","countryCode":"YE","latitude":"16.84765280","longitude":"43.94367880"},{"name":"Shabwah Governorate","isoCode":"SH","countryCode":"YE","latitude":"14.75463030","longitude":"46.51626200"},{"name":"Sana\'a Governorate","isoCode":"SN","countryCode":"YE","latitude":"15.31689130","longitude":"44.47480180"},{"name":"Socotra Governorate","isoCode":"SU","countryCode":"YE","latitude":"12.46342050","longitude":"53.82373850"},{"name":"Ta\'izz Governorate","isoCode":"TA","countryCode":"YE","latitude":"13.57758860","longitude":"44.01779890"},{"name":"Eastern Cape","isoCode":"EC","countryCode":"ZA","latitude":"-32.29684020","longitude":"26.41938900"},{"name":"Free State","isoCode":"FS","countryCode":"ZA","latitude":"37.68585250","longitude":"-97.28112560"},{"name":"Gauteng","isoCode":"GP","countryCode":"ZA","latitude":"-26.27075930","longitude":"28.11226790"},{"name":"KwaZulu-Natal","isoCode":"KZN","countryCode":"ZA","latitude":"-28.53055390","longitude":"30.89582420"},{"name":"Limpopo","isoCode":"LP","countryCode":"ZA","latitude":"-23.40129460","longitude":"29.41793240"},{"name":"Mpumalanga","isoCode":"MP","countryCode":"ZA","latitude":"-25.56533600","longitude":"30.52790960"},{"name":"Northern Cape","isoCode":"NC","countryCode":"ZA","latitude":"-29.04668080","longitude":"21.85685860"},{"name":"North West","isoCode":"NW","countryCode":"ZA","latitude":"32.75885200","longitude":"-97.32880600"},{"name":"Western Cape","isoCode":"WC","countryCode":"ZA","latitude":"-33.22779180","longitude":"21.85685860"},{"name":"Western Province","isoCode":"01","countryCode":"ZM","latitude":"6.90160860","longitude":"80.00877460"},{"name":"Central Province","isoCode":"02","countryCode":"ZM","latitude":"7.25649960","longitude":"80.72144170"},{"name":"Eastern Province","isoCode":"03","countryCode":"ZM","latitude":"23.16696880","longitude":"49.36531490"},{"name":"Luapula Province","isoCode":"04","countryCode":"ZM","latitude":"-11.56483100","longitude":"29.04599270"},{"name":"Northern Province","isoCode":"05","countryCode":"ZM","latitude":"8.88550270","longitude":"80.27673270"},{"name":"Northwestern Province","isoCode":"06","countryCode":"ZM","latitude":"-13.00502580","longitude":"24.90422080"},{"name":"Southern Province","isoCode":"07","countryCode":"ZM","latitude":"6.23737500","longitude":"80.54384500"},{"name":"Copperbelt Province","isoCode":"08","countryCode":"ZM","latitude":"-13.05700730","longitude":"27.54958460"},{"name":"Lusaka Province","isoCode":"09","countryCode":"ZM","latitude":"-15.36571290","longitude":"29.23207840"},{"name":"Muchinga Province","isoCode":"10","countryCode":"ZM","latitude":"-15.38219300","longitude":"28.26158000"},{"name":"Bulawayo Province","isoCode":"BU","countryCode":"ZW","latitude":"-20.14895050","longitude":"28.53310380"},{"name":"Harare Province","isoCode":"HA","countryCode":"ZW","latitude":"-17.82162880","longitude":"31.04922590"},{"name":"Manicaland","isoCode":"MA","countryCode":"ZW","latitude":"-18.92163860","longitude":"32.17460500"},{"name":"Mashonaland Central Province","isoCode":"MC","countryCode":"ZW","latitude":"-16.76442950","longitude":"31.07937050"},{"name":"Mashonaland East Province","isoCode":"ME","countryCode":"ZW","latitude":"-18.58716420","longitude":"31.26263660"},{"name":"Midlands Province","isoCode":"MI","countryCode":"ZW","latitude":"-19.05520090","longitude":"29.60354950"},{"name":"Matabeleland North Province","isoCode":"MN","countryCode":"ZW","latitude":"-18.53315660","longitude":"27.54958460"},{"name":"Matabeleland South Province","isoCode":"MS","countryCode":"ZW","latitude":"-21.05233700","longitude":"29.04599270"},{"name":"Masvingo Province","isoCode":"MV","countryCode":"ZW","latitude":"-20.62415090","longitude":"31.26263660"},{"name":"Mashonaland West Province","isoCode":"MW","countryCode":"ZW","latitude":"-17.48510290","longitude":"29.78892480"}]');



function $936eabaa5380ad2c$export$3f3fa39ec3644315() {
    return 0, (/*@__PURE__*/$parcel$interopDefault($80a0a81ef33cf27c$exports));
}
function $936eabaa5380ad2c$export$16a1ee7838267e23(countryCode = "") {
    if (!countryCode) return [];
    // get data from file or cache
    const states = (0, (/*@__PURE__*/$parcel$interopDefault($80a0a81ef33cf27c$exports))).filter((value)=>{
        return value.countryCode === countryCode;
    });
    return states.sort((0, $e55e4e34e9f3dfab$export$398604a469f7de9a));
}
function $936eabaa5380ad2c$export$a0f8a017c1458133(stateCode, countryCode) {
    if (!stateCode) return undefined;
    if (!countryCode) return undefined;
    return (0, $e55e4e34e9f3dfab$export$5459063425dbd5d)((0, (/*@__PURE__*/$parcel$interopDefault($80a0a81ef33cf27c$exports))), stateCode, countryCode);
}
function $936eabaa5380ad2c$export$61428eff43f86921(isoCode) {
    // eslint-disable-next-line no-console
    console.warn(`WARNING! 'getStateByCode' has been deprecated, please use the new 'getStateByCodeAndCountry' function instead!`);
    if (!isoCode) return undefined;
    return (0, $e55e4e34e9f3dfab$export$f402ac270728efb9)((0, (/*@__PURE__*/$parcel$interopDefault($80a0a81ef33cf27c$exports))), isoCode);
}
function $936eabaa5380ad2c$var$sortByIsoCode(countries) {
    return countries.sort((a, b)=>{
        return (0, $e55e4e34e9f3dfab$export$398604a469f7de9a)(a, b, (entity)=>{
            return `${entity.countryCode}-${entity.isoCode}`;
        });
    });
}
var $936eabaa5380ad2c$export$2e2bcd8739ae039 = {
    getAllStates: $936eabaa5380ad2c$export$3f3fa39ec3644315,
    getStatesOfCountry: $936eabaa5380ad2c$export$16a1ee7838267e23,
    getStateByCodeAndCountry: $936eabaa5380ad2c$export$a0f8a017c1458133,
    getStateByCode: $936eabaa5380ad2c$export$61428eff43f86921,
    sortByIsoCode: $936eabaa5380ad2c$var$sortByIsoCode
};


/*! js-cookie v3.0.5 | MIT */ /* eslint-disable no-var */ function $05de734c9c75e2e2$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)target[key] = source[key];
    }
    return target;
}
/* eslint-enable no-var */ /* eslint-disable no-var */ var $05de734c9c75e2e2$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
/* eslint-enable no-var */ /* eslint-disable no-var */ function $05de734c9c75e2e2$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === "undefined") return;
        attributes = $05de734c9c75e2e2$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = "";
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += "; " + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
        }
        return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === "undefined" || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split("; ") : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split("=");
            var value = parts.slice(1).join("=");
            try {
                var found = decodeURIComponent(parts[0]);
                jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (e) {}
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, "", $05de734c9c75e2e2$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $05de734c9c75e2e2$var$init(this.converter, $05de734c9c75e2e2$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $05de734c9c75e2e2$var$init($05de734c9c75e2e2$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $05de734c9c75e2e2$export$2e2bcd8739ae039 = $05de734c9c75e2e2$var$init($05de734c9c75e2e2$var$defaultConverter, {
    path: "/"
});


const $4b9baece09e0c79d$var$COOKIE_KEY = "radom_travel_rule_fields";
const $4b9baece09e0c79d$var$ADDRESS_MODE_DELAY_MS = 120;
const $4b9baece09e0c79d$var$COUNTRIES = (0, $e80c2cf8ebb93fb4$export$2e2bcd8739ae039).getAllCountries();
const $4b9baece09e0c79d$var$COUNTRY_ALIAS_MAP = {
    UK: "United Kingdom",
    "U K": "United Kingdom",
    GB: "United Kingdom",
    GBR: "United Kingdom",
    "GREAT BRITAIN": "United Kingdom",
    "UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND": "United Kingdom",
    USA: "United States",
    US: "United States",
    "U S": "United States",
    "UNITED STATES OF AMERICA": "United States",
    UAE: "United Arab Emirates"
};
const $4b9baece09e0c79d$var$countryLookupKey = (country)=>{
    return country.trim().toUpperCase().replace(/[().]/g, "").replace(/,/g, " ").replace(/\s+/g, " ");
};
const $4b9baece09e0c79d$var$normalizeCountryName = (country)=>{
    if (!country) return undefined;
    const trimmed = country.trim();
    if (trimmed.length === 0) return undefined;
    const lookupKey = $4b9baece09e0c79d$var$countryLookupKey(trimmed);
    const aliasMatch = $4b9baece09e0c79d$var$COUNTRY_ALIAS_MAP[lookupKey];
    if (aliasMatch) return aliasMatch;
    const isoMatch = $4b9baece09e0c79d$var$COUNTRIES.find((c)=>$4b9baece09e0c79d$var$countryLookupKey(c.isoCode) === lookupKey);
    if (isoMatch) return isoMatch.name;
    const exactMatch = $4b9baece09e0c79d$var$COUNTRIES.find((c)=>$4b9baece09e0c79d$var$countryLookupKey(c.name) === lookupKey);
    if (exactMatch) return exactMatch.name;
    return trimmed;
};
const $4b9baece09e0c79d$var$getCountryIsoCode = (country)=>{
    const normalized = $4b9baece09e0c79d$var$normalizeCountryName(country);
    if (!normalized) return "";
    return $4b9baece09e0c79d$var$COUNTRIES.find((c)=>c.name === normalized)?.isoCode ?? "";
};
const $4b9baece09e0c79d$var$firstNonEmpty = (...values)=>{
    for (const value of values){
        if (typeof value === "string" && value.trim().length > 0) return value.trim();
    }
    return undefined;
};
const $4b9baece09e0c79d$var$parseFallbackAddress = (address)=>{
    const parts = address.split(",").map((part)=>part.trim()).filter((part)=>part.length > 0);
    if (parts.length === 0) return {};
    const addressLine1 = parts[0];
    const countryRaw = parts.length > 1 ? parts[parts.length - 1] : "";
    const townOrCityRaw = parts.length > 2 ? parts[parts.length - 2] : parts[1];
    let townOrCity = townOrCityRaw ?? "";
    let stateOrProvince = "";
    let postalCode = "";
    const usLikeMatch = townOrCity.match(/^(.+?)(?:,\s*|\s+)([A-Za-z]{2})\s+([A-Za-z0-9- ]{3,10})$/);
    if (usLikeMatch) {
        townOrCity = usLikeMatch[1];
        stateOrProvince = usLikeMatch[2];
        postalCode = usLikeMatch[3];
    } else {
        const postCodeAtEnd = townOrCity.match(/^(.+?)\s+([A-Za-z0-9-]{3,10})$/);
        if (postCodeAtEnd && /\d/.test(postCodeAtEnd[2])) {
            townOrCity = postCodeAtEnd[1];
            postalCode = postCodeAtEnd[2];
        }
    }
    return {
        addressLine1: addressLine1,
        townOrCity: townOrCity?.trim() ?? "",
        stateOrProvince: stateOrProvince?.trim() ?? "",
        postalCode: postalCode?.trim() ?? "",
        countryOfResidence: $4b9baece09e0c79d$var$normalizeCountryName(countryRaw)
    };
};
// ---------------------------------------------------------------------------------------------------------------------
const $4b9baece09e0c79d$var$TravelRuleFieldsContainer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0;
  font-size: 15px;
  width: min(640px, 100%);
  max-width: 640px;
  min-width: 0;
  box-sizing: border-box;

  @media (max-width: 900px) {
    width: 100%;
    max-width: 100%;
  }
`;
const $4b9baece09e0c79d$var$TravelRuleFieldsRow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  min-width: 0;
`;
const $4b9baece09e0c79d$var$EmailSection = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  min-width: 0;
`;
const $4b9baece09e0c79d$var$BusinessToggleRow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  margin-top: 20px;
`;
const $4b9baece09e0c79d$var$IdentitySection = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
  width: 100%;
  min-width: 0;
`;
const $4b9baece09e0c79d$var$BillingSection = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 26px;
  width: 100%;
  min-width: 0;
`;
const $4b9baece09e0c79d$var$BillingSectionTitle = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  font-size: 13px;
  font-weight: 430;
  color: #7a879d;
  letter-spacing: 0.01em;
  text-transform: none;
  margin-bottom: 4px;
`;
const $4b9baece09e0c79d$var$AddressManualLink = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).button`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 4px 2px 4px 10px;
  min-height: 24px;
  margin: 0;
  width: fit-content;
  font-size: 13px;
  line-height: 1.2;
  color: #97a3b6;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  font-weight: 400;
  transition:
    opacity 0.16s ease,
    color 0.16s ease;

  &:hover {
    color: #7f8ba0;
  }

  &:focus-visible {
    outline: none;
    color: #7f8ba0;
  }

  &:disabled {
    opacity: 0.55;
    cursor: default;
  }
`;
const $4b9baece09e0c79d$var$AddressModeRow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-height: 24px;
  margin-top: 8px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;
const $4b9baece09e0c79d$var$AddressFieldsGroup = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  max-height: ${({ visible: visible, expandedHeight: expandedHeight })=>visible ? `${expandedHeight}px` : "0px"};
  opacity: ${({ visible: visible })=>visible ? 1 : 0};
  transform: translateY(${({ visible: visible })=>visible ? "0" : "-6px"});
  visibility: ${({ visible: visible })=>visible ? "visible" : "hidden"};
  pointer-events: ${({ visible: visible })=>visible ? "auto" : "none"};
  transition:
    max-height 260ms cubic-bezier(0.16, 1, 0.3, 1),
    opacity 220ms ease 40ms,
    transform 220ms ease,
    visibility 0s linear ${({ visible: visible })=>visible ? "0s" : "220ms"};
`;
const $4b9baece09e0c79d$var$FieldPair = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;
const $4b9baece09e0c79d$var$ContinueActionSection = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  margin-top: 28px;
  padding-top: 12px;
  padding-bottom: ${({ extraBottomSpace: extraBottomSpace })=>extraBottomSpace ? "calc(88px + env(safe-area-inset-bottom, 0px))" : "calc(20px + env(safe-area-inset-bottom, 0px))"};
  border-top: 1px solid #e2e8f3;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  box-sizing: border-box;
`;
const $4b9baece09e0c79d$var$FIELD_INPUT_STYLE = {
    minHeight: 44,
    borderRadius: 6,
    fontSize: 15,
    lineHeight: 1.3,
    padding: "8px 13px",
    borderColor: "#e1e7f0",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)"
};
const $4b9baece09e0c79d$var$COUNTRY_SELECTOR_STYLE = {
    minHeight: 44,
    borderRadius: 6,
    fontSize: 15,
    lineHeight: 1.3,
    padding: "7px 13px",
    borderColor: "#e1e7f0",
    backgroundColor: "#ffffff",
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)"
};
const $4b9baece09e0c79d$var$labelText = {
    name: [
        "Full name",
        "Full name"
    ],
    email: [
        "Email address",
        "Email address"
    ],
    billingAddress: [
        "Address",
        "Address"
    ],
    country: [
        "Country",
        "Country"
    ],
    company: [
        "",
        "Company name"
    ]
};
const $4b9baece09e0c79d$var$fetchLabelText = (labelName, isBusiness)=>$4b9baece09e0c79d$var$labelText[labelName][+isBusiness];
function $4b9baece09e0c79d$var$generateInputLabel(labelName, isBusiness) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 1
        },
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
            style: {
                fontWeight: 400,
                fontSize: 13,
                color: "#76849a"
            },
            children: $4b9baece09e0c79d$var$fetchLabelText(labelName, isBusiness)
        })
    });
}
const $4b9baece09e0c79d$var$getStoredFields = ()=>{
    const stored = (0, $05de734c9c75e2e2$export$2e2bcd8739ae039).get($4b9baece09e0c79d$var$COOKIE_KEY);
    if (stored) try {
        return JSON.parse(stored);
    } catch (e) {
        console.error("Error parsing stored travel rule fields:", e);
    }
    return null;
};
const $4b9baece09e0c79d$var$hasTextValue = (value)=>{
    return typeof value === "string" && value.trim().length > 0;
};
// ---------------------------------------------------------------------------------------------------------------------
const $4b9baece09e0c79d$var$TravelRuleFieldsWidget = (props)=>{
    const storedFields = $4b9baece09e0c79d$var$getStoredFields();
    const [isBusiness, setIsBusiness] = (0, $bnENU.useState)(()=>{
        const storedFields = $4b9baece09e0c79d$var$getStoredFields();
        if (storedFields?.accountType) return storedFields.accountType === (0, $8652974033b0a752$export$806b3fe74e359d5d).Business;
        const initialAccountType = props.travelRuleFieldsCollected.accountType ?? props.accountType;
        if (initialAccountType) return initialAccountType === "Business";
        return !!props.prefilledData?.companyName;
    });
    const [collectedTravelRuleFields, setCollectedTravelRuleFields] = (0, $bnENU.useState)(()=>{
        const baseFields = (0, $8652974033b0a752$export$4739bd9618b6a26b)();
        if (props.prefilledData) {
            if (props.prefilledData.name) baseFields.name = props.prefilledData.name;
            if (props.prefilledData.email) baseFields.emailAddress = props.prefilledData.email;
            if (props.prefilledData.companyName) baseFields.companyName = props.prefilledData.companyName;
            if (props.prefilledData.residenceCountry) baseFields.countryOfResidence = $4b9baece09e0c79d$var$normalizeCountryName(props.prefilledData.residenceCountry) ?? props.prefilledData.residenceCountry;
            const prefilledAddress = $4b9baece09e0c79d$var$parseFallbackAddress(props.prefilledData.billingAddress ?? "");
            if ($4b9baece09e0c79d$var$hasTextValue(prefilledAddress.addressLine1)) baseFields.addressLine1 = prefilledAddress.addressLine1;
            if ($4b9baece09e0c79d$var$hasTextValue(prefilledAddress.addressLine2)) baseFields.addressLine2 = prefilledAddress.addressLine2;
            if ($4b9baece09e0c79d$var$hasTextValue(prefilledAddress.townOrCity)) baseFields.townOrCity = prefilledAddress.townOrCity;
            if ($4b9baece09e0c79d$var$hasTextValue(prefilledAddress.stateOrProvince)) baseFields.stateOrProvince = prefilledAddress.stateOrProvince;
            if ($4b9baece09e0c79d$var$hasTextValue(prefilledAddress.postalCode)) baseFields.postalCode = prefilledAddress.postalCode;
            if (!$4b9baece09e0c79d$var$hasTextValue(baseFields.countryOfResidence) && $4b9baece09e0c79d$var$hasTextValue(prefilledAddress.countryOfResidence)) baseFields.countryOfResidence = prefilledAddress.countryOfResidence;
        }
        if (!storedFields) return baseFields;
        const merged = {
            ...baseFields,
            ...storedFields
        };
        merged.name = $4b9baece09e0c79d$var$hasTextValue(storedFields.name) ? storedFields.name : baseFields.name;
        merged.emailAddress = $4b9baece09e0c79d$var$hasTextValue(storedFields.emailAddress) ? storedFields.emailAddress : baseFields.emailAddress;
        merged.companyName = $4b9baece09e0c79d$var$hasTextValue(storedFields.companyName) ? storedFields.companyName : baseFields.companyName;
        merged.countryOfResidence = $4b9baece09e0c79d$var$hasTextValue(storedFields.countryOfResidence) ? $4b9baece09e0c79d$var$normalizeCountryName(storedFields.countryOfResidence) ?? storedFields.countryOfResidence : baseFields.countryOfResidence;
        return merged;
    });
    const [errorMessage, setErrorMessage] = (0, $bnENU.useState)();
    const [addressSuggestionList, setAddressSuggestionList] = (0, $bnENU.useState)([]);
    const [isManualAddressEntry, setIsManualAddressEntry] = (0, $bnENU.useState)(false);
    const [pendingAddressMode, setPendingAddressMode] = (0, $bnENU.useState)(null);
    const [isContinuing, setIsContinuing] = (0, $bnENU.useState)(false);
    const [validationErrors, setValidationErrors] = (0, $bnENU.useState)({});
    const [inputAddress, setInputAddress] = (0, $bnENU.useState)(()=>props.prefilledData?.billingAddress ?? "");
    const collectedTravelRuleFieldsRef = (0, $bnENU.useRef)(collectedTravelRuleFields);
    const addressModeTimeoutRef = (0, $bnENU.useRef)(null);
    const hasAttemptedCountryPrefillRef = (0, $bnENU.useRef)(false);
    const shouldCollectAddress = true;
    const shouldCollectCountry = true;
    const selectedCountryName = $4b9baece09e0c79d$var$normalizeCountryName(collectedTravelRuleFields.countryOfResidence);
    const selectedCountryIsoCode = $4b9baece09e0c79d$var$getCountryIsoCode(selectedCountryName);
    const shouldShowStateOrRegionField = selectedCountryIsoCode.length > 0 ? (0, $936eabaa5380ad2c$export$2e2bcd8739ae039).getStatesOfCountry(selectedCountryIsoCode).length > 0 : false;
    const fieldErrorStyle = (field, baseStyle)=>({
            ...baseStyle,
            ...validationErrors[field] ? (0, $196480508fc60042$export$15a6a1d6cb047a38) : undefined
        });
    const clearValidationErrors = (...fields)=>{
        setValidationErrors((currentErrors)=>{
            if (fields.every((field)=>!currentErrors[field])) return currentErrors;
            return Object.fromEntries(Object.entries(currentErrors).filter(([field])=>!fields.includes(field)));
        });
    };
    const focusValidationField = (field)=>{
        window.requestAnimationFrame(()=>{
            const fieldElement = document.querySelector(`[data-validation-field="${field}"]`);
            fieldElement?.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            const focusable = fieldElement?.matches("input") ? fieldElement : fieldElement?.querySelector('input, button, [tabindex]:not([tabindex="-1"])');
            focusable?.focus();
        });
    };
    const onCountrySelected = (country)=>{
        if (!country) return;
        const normalizedCountry = $4b9baece09e0c79d$var$normalizeCountryName(country.name) ?? country.name;
        const currentFields = collectedTravelRuleFieldsRef.current;
        const targetCountryIsoCode = $4b9baece09e0c79d$var$getCountryIsoCode(normalizedCountry);
        const normalizedRegionValue = currentFields.stateOrProvince?.trim() ?? "";
        let nextStateOrProvince = currentFields.stateOrProvince;
        if (normalizedRegionValue.length > 0 && targetCountryIsoCode.length > 0) {
            const statesForCountry = (0, $936eabaa5380ad2c$export$2e2bcd8739ae039).getStatesOfCountry(targetCountryIsoCode);
            if (statesForCountry.length === 0) nextStateOrProvince = "";
            else {
                const normalizedRegionKey = $4b9baece09e0c79d$var$countryLookupKey(normalizedRegionValue);
                const isKnownRegion = statesForCountry.some((state)=>{
                    return $4b9baece09e0c79d$var$countryLookupKey(state.name) === normalizedRegionKey || $4b9baece09e0c79d$var$countryLookupKey(state.isoCode) === normalizedRegionKey;
                });
                if (!isKnownRegion) nextStateOrProvince = "";
            }
        }
        updateTRFAndCache({
            ...currentFields,
            countryOfResidence: normalizedCountry,
            stateOrProvince: nextStateOrProvince
        });
        clearValidationErrors("countryOfResidence");
    };
    const updateTRFAndCache = (newFields)=>{
        collectedTravelRuleFieldsRef.current = newFields;
        setCollectedTravelRuleFields(newFields);
        (0, $05de734c9c75e2e2$export$2e2bcd8739ae039).set($4b9baece09e0c79d$var$COOKIE_KEY, JSON.stringify(newFields), {
            expires: 7
        });
    };
    const toggleIsBusiness = ()=>{
        const newIsBusinessState = !isBusiness;
        setIsBusiness(newIsBusinessState);
        const newFields = {
            ...collectedTravelRuleFields,
            companyName: newIsBusinessState ? collectedTravelRuleFields.companyName : "",
            accountType: newIsBusinessState ? (0, $8652974033b0a752$export$806b3fe74e359d5d).Business : (0, $8652974033b0a752$export$806b3fe74e359d5d).Individual
        };
        updateTRFAndCache(newFields);
        clearValidationErrors("companyName");
    };
    const debouncedFetch = (0, $bnENU.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($fDWVA))).debounce((value, countryCode, setAddressSuggestionList)=>{
        (0, $43c053927acc0cba$export$2e2bcd8739ae039).getGoolgePlaceAutoComplete(value, countryCode).then((res)=>{
            setAddressSuggestionList(res);
        });
    }, 500)).current;
    const applyAddressFromSuggestion = (selectedAddress, details)=>{
        const fallback = $4b9baece09e0c79d$var$parseFallbackAddress(selectedAddress);
        const currentFields = collectedTravelRuleFieldsRef.current;
        const normalizedCountry = $4b9baece09e0c79d$var$normalizeCountryName($4b9baece09e0c79d$var$firstNonEmpty(details?.country, details?.countryCode, fallback.countryOfResidence, currentFields.countryOfResidence)) ?? currentFields.countryOfResidence;
        updateTRFAndCache({
            ...currentFields,
            addressLine1: $4b9baece09e0c79d$var$firstNonEmpty(details?.addressLine1, fallback.addressLine1, currentFields.addressLine1) ?? "",
            addressLine2: $4b9baece09e0c79d$var$firstNonEmpty(details?.addressLine2, currentFields.addressLine2) ?? "",
            townOrCity: $4b9baece09e0c79d$var$firstNonEmpty(details?.townOrCity, fallback.townOrCity, currentFields.townOrCity) ?? "",
            stateOrProvince: $4b9baece09e0c79d$var$firstNonEmpty(details?.stateOrProvince, fallback.stateOrProvince, currentFields.stateOrProvince) ?? "",
            postalCode: $4b9baece09e0c79d$var$firstNonEmpty(details?.postalCode, fallback.postalCode, currentFields.postalCode) ?? "",
            countryOfResidence: normalizedCountry
        });
        clearValidationErrors("address", "addressLine1", "townOrCity", "countryOfResidence");
    };
    const handleClickAddressSuggestion = async (address)=>{
        setInputAddress(address);
        setAddressSuggestionList([]);
        try {
            const countryIsoCode = $4b9baece09e0c79d$var$getCountryIsoCode(collectedTravelRuleFieldsRef.current.countryOfResidence);
            const details = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getGooglePlaceAddressDetails(address, countryIsoCode);
            applyAddressFromSuggestion(address, details);
        } catch (err) {
            console.error("Error resolving selected address details:", err);
            applyAddressFromSuggestion(address, null);
        }
    };
    const enterManualAddressMode = ()=>{
        if (pendingAddressMode) return;
        setPendingAddressMode("manual");
        if (addressModeTimeoutRef.current) clearTimeout(addressModeTimeoutRef.current);
        addressModeTimeoutRef.current = setTimeout(()=>{
            const latestFields = collectedTravelRuleFieldsRef.current;
            const fallback = $4b9baece09e0c79d$var$parseFallbackAddress(inputAddress);
            if (!$4b9baece09e0c79d$var$hasTextValue(latestFields.addressLine1) && $4b9baece09e0c79d$var$hasTextValue(fallback.addressLine1)) updateTRFAndCache({
                ...latestFields,
                addressLine1: fallback.addressLine1 ?? "",
                addressLine2: $4b9baece09e0c79d$var$firstNonEmpty(latestFields.addressLine2, fallback.addressLine2) ?? "",
                townOrCity: $4b9baece09e0c79d$var$firstNonEmpty(latestFields.townOrCity, fallback.townOrCity) ?? "",
                stateOrProvince: $4b9baece09e0c79d$var$firstNonEmpty(latestFields.stateOrProvince, fallback.stateOrProvince) ?? "",
                postalCode: $4b9baece09e0c79d$var$firstNonEmpty(latestFields.postalCode, fallback.postalCode) ?? ""
            });
            setAddressSuggestionList([]);
            setInputAddress("");
            setIsManualAddressEntry(true);
            setPendingAddressMode(null);
            addressModeTimeoutRef.current = null;
        }, $4b9baece09e0c79d$var$ADDRESS_MODE_DELAY_MS);
    };
    const enterAutocompleteAddressMode = ()=>{
        if (pendingAddressMode) return;
        setPendingAddressMode("autocomplete");
        if (addressModeTimeoutRef.current) clearTimeout(addressModeTimeoutRef.current);
        addressModeTimeoutRef.current = setTimeout(()=>{
            const latestFields = collectedTravelRuleFieldsRef.current;
            const recomposedAddress = [
                latestFields.addressLine1,
                latestFields.addressLine2,
                latestFields.townOrCity,
                latestFields.stateOrProvince,
                latestFields.postalCode
            ].map((value)=>value?.trim()).filter((value)=>value && value.length > 0).join(", ");
            setInputAddress(recomposedAddress);
            setAddressSuggestionList([]);
            setIsManualAddressEntry(false);
            setPendingAddressMode(null);
            addressModeTimeoutRef.current = null;
        }, $4b9baece09e0c79d$var$ADDRESS_MODE_DELAY_MS);
    };
    const handleContinue = async ()=>{
        const latestFields = {
            ...collectedTravelRuleFieldsRef.current
        };
        const addressInputValue = inputAddress.trim();
        const fallbackAddress = $4b9baece09e0c79d$var$parseFallbackAddress(addressInputValue);
        latestFields.accountType = isBusiness ? (0, $8652974033b0a752$export$806b3fe74e359d5d).Business : (0, $8652974033b0a752$export$806b3fe74e359d5d).Individual;
        if (!isManualAddressEntry) {
            latestFields.addressLine1 = $4b9baece09e0c79d$var$firstNonEmpty(fallbackAddress.addressLine1, addressInputValue) ?? latestFields.addressLine1;
            latestFields.addressLine2 = $4b9baece09e0c79d$var$firstNonEmpty(fallbackAddress.addressLine2, latestFields.addressLine2) ?? "";
            latestFields.townOrCity = $4b9baece09e0c79d$var$firstNonEmpty(fallbackAddress.townOrCity, latestFields.townOrCity) ?? "";
            latestFields.stateOrProvince = $4b9baece09e0c79d$var$firstNonEmpty(fallbackAddress.stateOrProvince, latestFields.stateOrProvince) ?? "";
            latestFields.postalCode = $4b9baece09e0c79d$var$firstNonEmpty(fallbackAddress.postalCode, latestFields.postalCode) ?? "";
        }
        latestFields.countryOfResidence = $4b9baece09e0c79d$var$normalizeCountryName($4b9baece09e0c79d$var$firstNonEmpty(latestFields.countryOfResidence, fallbackAddress.countryOfResidence)) ?? "";
        const nextValidationErrors = {};
        if (isBusiness && !$4b9baece09e0c79d$var$hasTextValue(latestFields.companyName)) nextValidationErrors.companyName = "Enter company name.";
        if (!$4b9baece09e0c79d$var$hasTextValue(latestFields.name)) nextValidationErrors.name = "Enter full name.";
        if (!$4b9baece09e0c79d$var$hasTextValue(latestFields.emailAddress)) nextValidationErrors.emailAddress = "Enter email address.";
        else if (!(0, $8d017118df5fe2e5$export$1e21512880529eb2)(latestFields.emailAddress)) nextValidationErrors.emailAddress = "Enter a valid email address.";
        if (!$4b9baece09e0c79d$var$hasTextValue(latestFields.addressLine1)) {
            if (isManualAddressEntry) nextValidationErrors.addressLine1 = "Enter address line 1.";
            else nextValidationErrors.address = "Enter billing address.";
        }
        if (!$4b9baece09e0c79d$var$hasTextValue(latestFields.townOrCity)) {
            if (isManualAddressEntry) nextValidationErrors.townOrCity = "Enter city or town.";
            else nextValidationErrors.address = nextValidationErrors.address ?? "Enter a full billing address including city or town.";
        }
        if (!$4b9baece09e0c79d$var$hasTextValue(latestFields.countryOfResidence)) nextValidationErrors.countryOfResidence = "Select country.";
        const firstValidationField = Object.keys(nextValidationErrors)[0];
        setValidationErrors(nextValidationErrors);
        if (firstValidationField) {
            focusValidationField(firstValidationField);
            return;
        }
        setErrorMessage("");
        updateTRFAndCache(latestFields);
        setIsContinuing(true);
        try {
            await new Promise((resolve)=>setTimeout(resolve, 120));
            await Promise.resolve(props.onTravelRuleFieldsComplete(latestFields));
        } catch (err) {
            setErrorMessage(err?.message ?? "Failed to continue. Please try again.");
            setIsContinuing(false);
        }
    };
    (0, $bnENU.useEffect)(()=>{
        if (!props.prefilledData) return;
        const nextFields = {
            ...collectedTravelRuleFieldsRef.current
        };
        let didChange = false;
        if (!$4b9baece09e0c79d$var$hasTextValue(nextFields.name) && $4b9baece09e0c79d$var$hasTextValue(props.prefilledData.name)) {
            nextFields.name = props.prefilledData.name;
            didChange = true;
        }
        if (!$4b9baece09e0c79d$var$hasTextValue(nextFields.emailAddress) && $4b9baece09e0c79d$var$hasTextValue(props.prefilledData.email)) {
            nextFields.emailAddress = props.prefilledData.email;
            didChange = true;
        }
        if (!$4b9baece09e0c79d$var$hasTextValue(nextFields.companyName) && $4b9baece09e0c79d$var$hasTextValue(props.prefilledData.companyName)) {
            nextFields.companyName = props.prefilledData.companyName;
            didChange = true;
        }
        const normalizedResidenceCountry = $4b9baece09e0c79d$var$normalizeCountryName(props.prefilledData.residenceCountry);
        if (!$4b9baece09e0c79d$var$hasTextValue(nextFields.countryOfResidence) && $4b9baece09e0c79d$var$hasTextValue(normalizedResidenceCountry)) {
            nextFields.countryOfResidence = normalizedResidenceCountry;
            didChange = true;
        }
        const parsedPrefilledAddress = $4b9baece09e0c79d$var$parseFallbackAddress(props.prefilledData.billingAddress ?? "");
        if (!$4b9baece09e0c79d$var$hasTextValue(nextFields.addressLine1) && $4b9baece09e0c79d$var$hasTextValue(parsedPrefilledAddress.addressLine1)) {
            nextFields.addressLine1 = parsedPrefilledAddress.addressLine1;
            didChange = true;
        }
        if (!$4b9baece09e0c79d$var$hasTextValue(nextFields.addressLine2) && $4b9baece09e0c79d$var$hasTextValue(parsedPrefilledAddress.addressLine2)) {
            nextFields.addressLine2 = parsedPrefilledAddress.addressLine2;
            didChange = true;
        }
        if (!$4b9baece09e0c79d$var$hasTextValue(nextFields.townOrCity) && $4b9baece09e0c79d$var$hasTextValue(parsedPrefilledAddress.townOrCity)) {
            nextFields.townOrCity = parsedPrefilledAddress.townOrCity;
            didChange = true;
        }
        if (!$4b9baece09e0c79d$var$hasTextValue(nextFields.stateOrProvince) && $4b9baece09e0c79d$var$hasTextValue(parsedPrefilledAddress.stateOrProvince)) {
            nextFields.stateOrProvince = parsedPrefilledAddress.stateOrProvince;
            didChange = true;
        }
        if (!$4b9baece09e0c79d$var$hasTextValue(nextFields.postalCode) && $4b9baece09e0c79d$var$hasTextValue(parsedPrefilledAddress.postalCode)) {
            nextFields.postalCode = parsedPrefilledAddress.postalCode;
            didChange = true;
        }
        if (!$4b9baece09e0c79d$var$hasTextValue(nextFields.countryOfResidence) && $4b9baece09e0c79d$var$hasTextValue(parsedPrefilledAddress.countryOfResidence)) {
            nextFields.countryOfResidence = parsedPrefilledAddress.countryOfResidence;
            didChange = true;
        }
        if (didChange) updateTRFAndCache(nextFields);
    }, [
        props.prefilledData?.billingAddress,
        props.prefilledData?.companyName,
        props.prefilledData?.email,
        props.prefilledData?.name,
        props.prefilledData?.residenceCountry
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (hasAttemptedCountryPrefillRef.current) return;
        if ($4b9baece09e0c79d$var$hasTextValue(collectedTravelRuleFieldsRef.current.countryOfResidence)) {
            hasAttemptedCountryPrefillRef.current = true;
            return;
        }
        hasAttemptedCountryPrefillRef.current = true;
        let isActive = true;
        (0, $43c053927acc0cba$export$2e2bcd8739ae039).getCountryGuess().then((countryGuess)=>{
            if (!isActive || !countryGuess) return;
            if ($4b9baece09e0c79d$var$hasTextValue(collectedTravelRuleFieldsRef.current.countryOfResidence)) return;
            const guessedCountry = $4b9baece09e0c79d$var$normalizeCountryName(countryGuess.countryName) ?? $4b9baece09e0c79d$var$normalizeCountryName(countryGuess.countryCode);
            if (!$4b9baece09e0c79d$var$hasTextValue(guessedCountry)) return;
            const matchedCountry = $4b9baece09e0c79d$var$COUNTRIES.find((country)=>country.name === guessedCountry) ?? $4b9baece09e0c79d$var$COUNTRIES.find((country)=>country.isoCode === countryGuess.countryCode?.toUpperCase());
            if (!matchedCountry) return;
            const matchedCountrySelection = {
                name: matchedCountry.name
            };
            onCountrySelected(matchedCountrySelection);
        });
        return ()=>{
            isActive = false;
        };
    }, []);
    (0, $bnENU.useEffect)(()=>{
        if ($4b9baece09e0c79d$var$hasTextValue(inputAddress)) return;
        const fallbackInputAddress = [
            collectedTravelRuleFields.addressLine1,
            collectedTravelRuleFields.townOrCity,
            collectedTravelRuleFields.stateOrProvince,
            collectedTravelRuleFields.postalCode
        ].map((value)=>value?.trim()).filter((value)=>value && value.length > 0).join(", ");
        if (fallbackInputAddress.length > 0) setInputAddress(fallbackInputAddress);
    }, [
        collectedTravelRuleFields.addressLine1,
        collectedTravelRuleFields.postalCode,
        collectedTravelRuleFields.stateOrProvince,
        collectedTravelRuleFields.townOrCity,
        inputAddress
    ]);
    (0, $bnENU.useEffect)(()=>{
        return ()=>{
            if (addressModeTimeoutRef.current) clearTimeout(addressModeTimeoutRef.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$TravelRuleFieldsContainer, {
        children: [
            errorMessage && errorMessage.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                style: {
                    backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR,
                    padding: 15,
                    marginBottom: 10,
                    borderRadius: 5,
                    fontSize: 14,
                    color: "white",
                    overflowWrap: "break-word"
                },
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4b9baece09e0c79d$var$EmailSection, {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$TravelRuleFieldsRow, {
                    children: [
                        $4b9baece09e0c79d$var$generateInputLabel("email", isBusiness),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                            style: fieldErrorStyle("emailAddress", $4b9baece09e0c79d$var$FIELD_INPUT_STYLE),
                            name: "email",
                            autoComplete: "email",
                            value: collectedTravelRuleFields.emailAddress,
                            placeholder: "Email address",
                            required: true,
                            "aria-invalid": Boolean(validationErrors.emailAddress),
                            "data-validation-field": "emailAddress",
                            onInput: (el)=>{
                                clearValidationErrors("emailAddress");
                                updateTRFAndCache({
                                    ...collectedTravelRuleFields,
                                    emailAddress: el.currentTarget.value.toLowerCase()
                                });
                            }
                        }, "trEmailAddress"),
                        validationErrors.emailAddress && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                            children: validationErrors.emailAddress
                        })
                    ]
                }, "missingEmailAddress")
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$BusinessToggleRow, {
                role: "switch",
                "aria-checked": isBusiness,
                tabIndex: 0,
                onClick: toggleIsBusiness,
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        toggleIsBusiness();
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        onClick: (e)=>{
                            e.stopPropagation();
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $1de62bdd15479f35$export$2e2bcd8739ae039), {
                            checked: isBusiness,
                            onClick: toggleIsBusiness
                        })
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        style: {
                            flex: 1,
                            color: "#2d3648",
                            fontSize: 14,
                            overflowWrap: "break-word",
                            marginLeft: 8
                        },
                        children: "Paying as a business?"
                    })
                ]
            }),
            isBusiness && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4b9baece09e0c79d$var$IdentitySection, {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$TravelRuleFieldsRow, {
                    children: [
                        $4b9baece09e0c79d$var$generateInputLabel("company", true),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                            style: fieldErrorStyle("companyName", $4b9baece09e0c79d$var$FIELD_INPUT_STYLE),
                            name: "organization",
                            autoComplete: "organization",
                            value: collectedTravelRuleFields.companyName,
                            placeholder: "Company name",
                            required: true,
                            "aria-invalid": Boolean(validationErrors.companyName),
                            "data-validation-field": "companyName",
                            onInput: (el)=>{
                                clearValidationErrors("companyName");
                                updateTRFAndCache({
                                    ...collectedTravelRuleFields,
                                    companyName: el.currentTarget.value
                                });
                            }
                        }, "trCompanyName"),
                        validationErrors.companyName && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                            children: validationErrors.companyName
                        })
                    ]
                }, "missingCompanyName")
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$BillingSection, {
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4b9baece09e0c79d$var$BillingSectionTitle, {
                        children: "Billing address"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$TravelRuleFieldsRow, {
                        children: [
                            $4b9baece09e0c79d$var$generateInputLabel("name", isBusiness),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                style: fieldErrorStyle("name", $4b9baece09e0c79d$var$FIELD_INPUT_STYLE),
                                name: "name",
                                autoComplete: "name",
                                value: collectedTravelRuleFields.name,
                                placeholder: "Full name",
                                required: true,
                                "aria-invalid": Boolean(validationErrors.name),
                                "data-validation-field": "name",
                                onInput: (el)=>{
                                    clearValidationErrors("name");
                                    updateTRFAndCache({
                                        ...collectedTravelRuleFields,
                                        name: el.currentTarget.value
                                    });
                                }
                            }, "trName"),
                            validationErrors.name && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                children: validationErrors.name
                            })
                        ]
                    }, "missingName"),
                    shouldCollectCountry && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                        children: [
                            $4b9baece09e0c79d$var$generateInputLabel("country", isBusiness),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$TravelRuleFieldsRow, {
                                "data-validation-field": "countryOfResidence",
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $96e19f8f97c8e649$export$2e2bcd8739ae039), {
                                        style: fieldErrorStyle("countryOfResidence", $4b9baece09e0c79d$var$COUNTRY_SELECTOR_STYLE),
                                        selectedCountry: selectedCountryName,
                                        onCountrySelected: onCountrySelected
                                    }),
                                    validationErrors.countryOfResidence && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                        children: validationErrors.countryOfResidence
                                    })
                                ]
                            }, "countryOfResidence")
                        ]
                    }),
                    shouldCollectAddress && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$AddressFieldsGroup, {
                                visible: !isManualAddressEntry,
                                expandedHeight: 140,
                                children: [
                                    $4b9baece09e0c79d$var$generateInputLabel("billingAddress", isBusiness),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        "data-validation-field": "address",
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$328374105a880465), {
                                            label: "",
                                            inputStyle: $4b9baece09e0c79d$var$FIELD_INPUT_STYLE,
                                            isInvalid: Boolean(validationErrors.address),
                                            validationError: validationErrors.address,
                                            placeholder: "Address",
                                            value: inputAddress ?? "",
                                            required: true,
                                            suggestionList: addressSuggestionList,
                                            setSelectedItems: (items)=>{
                                                if (items[0]) handleClickAddressSuggestion(items[0]);
                                            },
                                            onChange: (e)=>{
                                                clearValidationErrors("address", "addressLine1", "townOrCity");
                                                const value = e.target.value;
                                                const trimmed = value.trim();
                                                if (value.length > 2) {
                                                    const countryIsoCode = $4b9baece09e0c79d$var$getCountryIsoCode(collectedTravelRuleFields.countryOfResidence);
                                                    debouncedFetch(value, countryIsoCode, setAddressSuggestionList);
                                                } else setAddressSuggestionList([]);
                                                const fallback = $4b9baece09e0c79d$var$parseFallbackAddress(value);
                                                updateTRFAndCache({
                                                    ...collectedTravelRuleFieldsRef.current,
                                                    addressLine1: $4b9baece09e0c79d$var$firstNonEmpty(fallback.addressLine1, trimmed) ?? "",
                                                    addressLine2: fallback.addressLine2 ?? "",
                                                    townOrCity: fallback.townOrCity ?? "",
                                                    stateOrProvince: fallback.stateOrProvince ?? "",
                                                    postalCode: fallback.postalCode ?? ""
                                                });
                                                setInputAddress(value);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4b9baece09e0c79d$var$AddressModeRow, {
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4b9baece09e0c79d$var$AddressManualLink, {
                                            type: "button",
                                            disabled: pendingAddressMode !== null,
                                            onMouseDown: (event)=>{
                                                event.preventDefault();
                                                event.stopPropagation();
                                                enterManualAddressMode();
                                            },
                                            onClick: (event)=>{
                                                event.preventDefault();
                                                event.stopPropagation();
                                            },
                                            children: "Enter address manually"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$AddressFieldsGroup, {
                                visible: isManualAddressEntry,
                                expandedHeight: 320,
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                        style: fieldErrorStyle("addressLine1", $4b9baece09e0c79d$var$FIELD_INPUT_STYLE),
                                        name: "address-line1",
                                        autoComplete: "address-line1",
                                        value: collectedTravelRuleFields.addressLine1,
                                        placeholder: "Address line 1",
                                        required: true,
                                        "aria-invalid": Boolean(validationErrors.addressLine1),
                                        "data-validation-field": "addressLine1",
                                        onInput: (el)=>{
                                            clearValidationErrors("addressLine1", "address");
                                            updateTRFAndCache({
                                                ...collectedTravelRuleFields,
                                                addressLine1: el.currentTarget.value
                                            });
                                        }
                                    }),
                                    validationErrors.addressLine1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                        children: validationErrors.addressLine1
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4b9baece09e0c79d$var$AddressModeRow, {
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4b9baece09e0c79d$var$AddressManualLink, {
                                            type: "button",
                                            disabled: pendingAddressMode !== null,
                                            onMouseDown: (event)=>{
                                                event.preventDefault();
                                                event.stopPropagation();
                                                enterAutocompleteAddressMode();
                                            },
                                            onClick: (event)=>{
                                                event.preventDefault();
                                                event.stopPropagation();
                                            },
                                            children: "Use address autocomplete"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                        style: $4b9baece09e0c79d$var$FIELD_INPUT_STYLE,
                                        name: "address-line2",
                                        autoComplete: "address-line2",
                                        value: collectedTravelRuleFields.addressLine2,
                                        placeholder: "Address line 2",
                                        onInput: (el)=>{
                                            updateTRFAndCache({
                                                ...collectedTravelRuleFields,
                                                addressLine2: el.currentTarget.value
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$FieldPair, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                        style: fieldErrorStyle("townOrCity", $4b9baece09e0c79d$var$FIELD_INPUT_STYLE),
                                                        name: "address-level2",
                                                        autoComplete: "address-level2",
                                                        value: collectedTravelRuleFields.townOrCity,
                                                        placeholder: "City / Town",
                                                        required: true,
                                                        "aria-invalid": Boolean(validationErrors.townOrCity),
                                                        "data-validation-field": "townOrCity",
                                                        onInput: (el)=>{
                                                            clearValidationErrors("townOrCity", "address");
                                                            updateTRFAndCache({
                                                                ...collectedTravelRuleFields,
                                                                townOrCity: el.currentTarget.value
                                                            });
                                                        }
                                                    }),
                                                    validationErrors.townOrCity && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                                        children: validationErrors.townOrCity
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                style: $4b9baece09e0c79d$var$FIELD_INPUT_STYLE,
                                                name: "postal-code",
                                                autoComplete: "postal-code",
                                                value: collectedTravelRuleFields.postalCode,
                                                placeholder: "Postcode / ZIP",
                                                onInput: (el)=>{
                                                    updateTRFAndCache({
                                                        ...collectedTravelRuleFields,
                                                        postalCode: el.currentTarget.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    shouldShowStateOrRegionField && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                        style: $4b9baece09e0c79d$var$FIELD_INPUT_STYLE,
                                        name: "address-level1",
                                        autoComplete: "address-level1",
                                        value: collectedTravelRuleFields.stateOrProvince,
                                        placeholder: "State / Region",
                                        onInput: (el)=>{
                                            updateTRFAndCache({
                                                ...collectedTravelRuleFields,
                                                stateOrProvince: el.currentTarget.value
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4b9baece09e0c79d$var$ContinueActionSection, {
                extraBottomSpace: isBusiness && isManualAddressEntry,
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                        isLoading: isContinuing,
                        style: {
                            background: "#3f6bf5",
                            width: "100%",
                            marginTop: 0,
                            fontWeight: 410,
                            minHeight: 48,
                            borderRadius: 7,
                            padding: "12px 14px"
                        },
                        onClick: ()=>{
                            handleContinue();
                        },
                        children: "Continue"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                        style: {
                            width: "100%",
                            textAlign: "center",
                            fontSize: 11,
                            color: "#98a4b7"
                        },
                        children: "You'll confirm the crypto transfer in the next step."
                    })
                ]
            })
        ]
    });
};
var $4b9baece09e0c79d$export$2e2bcd8739ae039 = $4b9baece09e0c79d$var$TravelRuleFieldsWidget;






parcelRequire("bnENU");


const $aac8e983fd3225f1$var$LinkExternalWrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).svg`
  transition: 0.2s ease all;
  ${(props)=>!props.stroke && `stroke: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};`}

  :hover {
    stroke: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE};
  }
`;
function $aac8e983fd3225f1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($aac8e983fd3225f1$var$LinkExternalWrapper, {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M11 4H4V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V13",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M9 15L20 4",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M15 4H20V9",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}




const $06825994d276e479$var$MANAGED_STEP_TRANSITION_DELAY_MS = 380;
const $06825994d276e479$var$CURRENCY_SEARCH_THRESHOLD = 7;
const $06825994d276e479$var$MOBILE_PAYMENT_BREAKPOINT = 900;
function $06825994d276e479$export$8e3f267d166b4a05(totalSeconds) {
    const duration = (0, $2a16fa66856ff33d$export$2e2bcd8739ae039)({
        start: 0,
        end: totalSeconds * 1000
    });
    const zeroPad = (num)=>String(num).padStart(2, "0");
    const formatted = [
        duration.days,
        duration.hours,
        duration.minutes,
        duration.seconds
    ].filter((a, i)=>i <= 1 ? !!a : true).map(zeroPad).join(":");
    return formatted;
}
const $06825994d276e479$var$formatPaymentAddressForDisplay = (address)=>{
    if (!address) return "";
    const prefix = address.startsWith("0x") ? "0x" : "";
    const body = prefix ? address.slice(2) : address;
    const chunkSize = body.length > 52 ? 18 : 16;
    const parts = body.match(new RegExp(`.{1,${chunkSize}}`, "g")) ?? [
        body
    ];
    return `${prefix}${parts.join("\u200B")}`;
};
const $06825994d276e479$var$Styles = (0, $2952da92fd5b9db2$export$f0f03736edb61697)`
  @property --angle {
    syntax: '<angle>';
    initial-value: 90deg;
    inherits: true;
  }

  :root {
    --d: 2500ms;
    --c1: rgba(0, 0, 0, 0.5);
    --c2: rgba(0, 0, 0, 0.1);
  }
`;
const $06825994d276e479$var$ConnectedWalletContainer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  box-shadow: 0 0 3px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  border-radius: 5px;
`;
const $06825994d276e479$export$ec3c7ce6a909733b = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  border-radius: 10px;
  overflow: hidden;
  width: fit-content;
  box-shadow: 0 5px 5px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  transition: 0.2s ease all;
  cursor: pointer;
  &:active {
    transform: scale(0.99);
  }
`;
const $06825994d276e479$export$3c6b4f0e2cd37515 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: fit-content;
  border-radius: 10px;
  box-shadow: 0 5px 5px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  padding: 10px;
  font-size: 0;
`;
const $06825994d276e479$export$b2a0bb8fc9a08697 = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  from {
    transform: translateY(-25%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;
const $06825994d276e479$var$WrapperAnimation = (0, $2952da92fd5b9db2$export$dbf350e5966cf602)`
  animation: ${$06825994d276e479$export$b2a0bb8fc9a08697} 0.26s cubic-bezier(0.22, 1, 0.36, 1);
`;
const $06825994d276e479$var$StepShellIn = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 0;
    transform: translateY(12px) scale(0.992);
    filter: blur(4px);
  }
  65% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
`;
const $06825994d276e479$var$StepContentIn = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 0;
    transform: translateX(10px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;
const $06825994d276e479$var$Wrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  flex-grow: 1;
  ${({ disableAnimation: disableAnimation })=>!disableAnimation && $06825994d276e479$var$WrapperAnimation}
`;
const $06825994d276e479$var$Container = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  ${({ disableAnimation: disableAnimation })=>!disableAnimation && $06825994d276e479$var$WrapperAnimation}
  // animation: ${$06825994d276e479$export$b2a0bb8fc9a08697} 0.2s ease;
`;
const $06825994d276e479$var$CHECKOUT_SPACING = {
    xs: 8,
    sm: 12,
    md: 16,
    lg: 24,
    xl: 32
};
const $06825994d276e479$var$StepShell = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: min(680px, 100%);
  margin: 0;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ compact: compact })=>compact ? "24px" : "16px"};
  transform-origin: 50% 16px;
  animation: ${$06825994d276e479$var$StepShellIn} 0.38s cubic-bezier(0.22, 1, 0.36, 1);

  @media (max-width: 900px) {
    width: 100%;
    gap: ${({ compact: compact })=>compact ? "20px" : "14px"};
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
const $06825994d276e479$var$StepTransitionFrame = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: ${$06825994d276e479$var$StepContentIn} 0.28s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: opacity, transform;

  @media (max-width: 900px) {
    gap: 14px;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
const $06825994d276e479$var$StepHeader = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: ${({ compact: compact })=>compact ? "16px" : "10px"};
`;
const $06825994d276e479$var$StepHeaderTopRow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;
const $06825994d276e479$var$StepEyebrow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-size: 12px;
  font-weight: 600;
  color: #748199;
`;
const $06825994d276e479$var$StepTitle = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: ${({ compact: compact })=>compact ? "20px" : "30px"};
  line-height: ${({ compact: compact })=>compact ? "1.2" : "1.1"};
  font-weight: ${({ compact: compact })=>compact ? 500 : 600};
  color: ${({ compact: compact })=>compact ? "#172133" : "#111827"};
`;
const $06825994d276e479$var$StepTitleMeta = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.58em;
  line-height: 1.15;
  font-weight: 500;
  color: #64748b;
  margin-left: 10px;
  white-space: nowrap;

  img {
    width: 18px;
    height: 18px;
    border-radius: 999px;
    flex-shrink: 0;
  }
`;
const $06825994d276e479$var$StepSubtitle = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: ${({ compact: compact })=>compact ? "12px" : "14px"};
  line-height: ${({ compact: compact })=>compact ? "1.35" : "1.45"};
  color: ${({ compact: compact })=>compact ? "#7b8699" : "#475569"};
`;
const $06825994d276e479$var$SectionTitle = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).h3`
  margin: 0;
  font-size: 19px;
  line-height: 1.25;
  font-weight: 600;
  color: #172033;
`;
const $06825994d276e479$var$SectionHelper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: #546177;
`;
const $06825994d276e479$var$FormSection = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const $06825994d276e479$var$FormFieldStack = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const $06825994d276e479$var$SelectableList = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  border: 1px solid #dbe3ef;
  border-radius: 14px;
  overflow: hidden;
  background: white;
`;
const $06825994d276e479$var$SelectorTools = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const $06825994d276e479$var$SelectorSearchInput = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)((0, $196480508fc60042$export$c86715117507e8e5))`
  min-height: 42px;
  border-radius: 12px;
  border-color: #d8dee9;
  background: #ffffff;
  font-size: 15px;
  line-height: 1.3;
  padding: 10px 12px;
`;
const $06825994d276e479$var$SelectableRow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).button`
  width: 100%;
  border: 0;
  border-bottom: 1px solid #edf2f8;
  background: ${({ selected: selected })=>selected ? "#f4f7ff" : "#ffffff"};
  padding: 16px 18px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
  position: relative;
  box-shadow: ${({ selected: selected })=>selected ? "inset 3px 0 0 #3f6bf5, inset 0 0 0 1px #c9d8ff" : "none"};
  transition:
    background-color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.16s ease,
    border-color 0.18s ease;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: ${({ selected: selected })=>selected ? "#f3f7ff" : "#f8faff"};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0) scale(0.995);
  }

  &:focus-visible {
    outline: 2px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE5};
    outline-offset: -2px;
  }
`;
const $06825994d276e479$var$SelectableRowLeft = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;
const $06825994d276e479$var$SelectableRowIcon = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 34px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #e3e8f1;
  background: ${({ src: src })=>src ? `center/contain no-repeat url(${src})` : "#eef2f9"};
  flex-shrink: 0;
`;
const $06825994d276e479$var$PaymentMethodIconRoot = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: ${({ size: size })=>size}px;
  height: ${({ size: size })=>size}px;
  border-radius: ${({ size: size })=>size / 2}px;
  border: 1px solid #e3e8f1;
  background: #ffffff;
  position: relative;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
`;
const $06825994d276e479$var$PaymentMethodIconMain = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  position: absolute;
  inset: 4px;
  border-radius: 999px;
  background: ${({ src: src })=>src ? `center/contain no-repeat url(${src})` : "#eef2f9"};
`;
const $06825994d276e479$var$PaymentMethodIconBadge = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  position: absolute;
  right: -4px;
  bottom: -3px;
  width: ${({ size: size })=>Math.round(size * 0.52)}px;
  height: ${({ size: size })=>Math.round(size * 0.52)}px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.14);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $06825994d276e479$var$PaymentMethodIconBadgeImage = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: ${({ size: size })=>Math.round(size * 0.34)}px;
  height: ${({ size: size })=>Math.round(size * 0.34)}px;
  border-radius: 999px;
  background: ${({ src: src })=>src ? `center/contain no-repeat url(${src})` : "#eef2f9"};
`;
const $06825994d276e479$var$SelectableRowText = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
`;
const $06825994d276e479$var$SelectableRowTitle = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 15px;
  font-weight: 500;
  color: #0f172a;
`;
const $06825994d276e479$var$SelectableRowMeta = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 13px;
  color: #64748b;
`;
const $06825994d276e479$var$SelectableRowValue = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
`;
const $06825994d276e479$var$Badge = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  border-radius: 999px;
  padding: 2px 8px;
  border: 1px solid #d4dcec;
  background: #f5f8ff;
  color: #516286;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
`;
const $06825994d276e479$var$HeroAmount = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;

  @media (max-width: 900px) {
    justify-content: flex-start;
  }
`;
const $06825994d276e479$var$HeroAmountSection = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-end;
  width: 100%;
  text-align: right;

  @media (max-width: 900px) {
    align-items: flex-start;
    text-align: left;
  }
`;
const $06825994d276e479$var$HeroAmountHeader = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 900px) {
    justify-content: flex-start;
  }
`;
const $06825994d276e479$var$HeroAmountLabel = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #7a879b;
`;
const $06825994d276e479$var$HeroAmountValue = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 34px;
  line-height: 1;
  font-weight: 600;
  color: #0f172a;

  @media (max-width: 1120px) and (min-width: 901px) {
    font-size: 30px;
  }
`;
const $06825994d276e479$var$HeroAmountTicker = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 16px;
  color: #64748b;
  font-weight: 500;
`;
const $06825994d276e479$var$QrHero = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).button`
  all: unset;
  width: fit-content;
  margin: 0 auto;
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid #dbe4f1;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
  background: white;
  padding: 8px;
  display: block;
  cursor: ${({ clickable: clickable })=>clickable ? "zoom-in" : "default"};
  transition:
    transform 0.18s ease,
    box-shadow 0.18s ease,
    border-color 0.18s ease;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at top right, rgba(59, 101, 240, 0.14), transparent 58%);
    opacity: 0;
    transition: opacity 0.18s ease;
    pointer-events: none;
  }

  ${({ clickable: clickable })=>clickable && (0, $2952da92fd5b9db2$export$dbf350e5966cf602)`
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 12px 28px rgba(15, 23, 42, 0.09);
      border-color: #d2ddf0;
    }

    &:hover::before,
    &:focus-visible::before {
      opacity: 1;
    }

    &:focus-visible {
      outline: none;
      box-shadow:
        0 0 0 3px rgba(97, 138, 250, 0.14),
        0 12px 28px rgba(15, 23, 42, 0.09);
    }
  `}
`;
const $06825994d276e479$var$QrHeroVisual = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  position: relative;
  display: block;
`;
const $06825994d276e479$var$QrHeroImage = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).img`
  width: 124px;
  height: 124px;

  @media (max-width: 1120px) and (min-width: 901px) {
    width: 108px;
    height: 108px;
  }

  @media (max-width: 900px) {
    width: 124px;
    height: 124px;
  }
`;
const $06825994d276e479$var$QrHeroHint = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.8);
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.18);
  color: white;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.01em;
  opacity: 0;
  transform: translateY(4px);
  transition:
    opacity 0.18s ease,
    transform 0.18s ease;
  pointer-events: none;

  svg {
    width: 11px;
    height: 11px;
    flex-shrink: 0;
    stroke: currentColor;
  }

  ${$06825994d276e479$var$QrHero}:hover &,
  ${$06825994d276e479$var$QrHero}:focus-visible & {
    opacity: 1;
    transform: translateY(0);
  }
`;
const $06825994d276e479$var$QrModalBody = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  position: relative;
  overflow: hidden;
  padding: 6px 28px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
`;
const $06825994d276e479$var$QrModalGlow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 4px;
  width: 260px;
  height: 260px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(59, 101, 240, 0.18) 0%, rgba(59, 101, 240, 0.08) 38%, transparent 72%);
  filter: blur(10px);
  pointer-events: none;
`;
const $06825994d276e479$var$QrModalDetails = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
const $06825994d276e479$var$QrModalMetaPill = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid #d9e3f8;
  background: rgba(255, 255, 255, 0.92);
  color: #324765;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.06);

  img {
    width: 16px;
    height: 16px;
    border-radius: 999px;
    flex-shrink: 0;
  }
`;
const $06825994d276e479$var$QrModalAmountBlock = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;
const $06825994d276e479$var$QrModalAmountLabel = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #7b879a;
`;
const $06825994d276e479$var$QrModalAmount = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  color: #0f172a;
  font-size: 28px;
  line-height: 1;
  font-weight: 600;
`;
const $06825994d276e479$var$QrModalAmountTicker = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
`;
const $06825994d276e479$var$QrModalFrame = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: fit-content;
  border-radius: 22px;
  border: 1px solid #dbe4f1;
  background: white;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
  padding: 14px;
`;
const $06825994d276e479$var$QrModalImage = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).img`
  width: min(68vw, 360px);
  height: min(68vw, 360px);
  display: block;
`;
const $06825994d276e479$var$QrModalCaption = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).p`
  margin: 0;
  max-width: 372px;
  text-align: center;
  color: #63738c;
  font-size: 14px;
  line-height: 1.55;
`;
const $06825994d276e479$var$QrDisclosureButton = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).button`
  width: fit-content;
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  padding: 0;
  color: #4f5f7b;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  svg {
    transition: transform 0.18s ease;
    transform: rotate(${({ expanded: expanded })=>expanded ? 180 : 90}deg);
  }
`;
const $06825994d276e479$var$StatusPill = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: fit-content;
  align-self: center;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid #d8e4ff;
  background: #eef4ff;
  color: #3158c5;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;
const $06825994d276e479$var$HeaderStatusPill = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)($06825994d276e479$var$StatusPill)`
  align-self: auto;
  margin-left: auto;
  padding: 5px 12px;
  gap: 7px;
  font-size: 10.25px;
  line-height: 1;
  color: #335dcb;
  background: #f6f8ff;
  border-color: #d8e2fb;
  box-shadow: none;

  @media (max-width: 900px) {
    margin-left: 0;
  }
`;
const $06825994d276e479$var$TimerPillIcon = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  position: relative;
  width: 13px;
  height: 13px;
  border: 1.5px solid currentColor;
  border-radius: 999px;
  display: inline-block;
  flex-shrink: 0;
  opacity: 0.9;

  ::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 2px;
    width: 1.4px;
    height: 3.5px;
    background: currentColor;
    border-radius: 999px;
    transform: translateX(-50%);
  }

  ::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    width: 3px;
    height: 1.4px;
    background: currentColor;
    border-radius: 999px;
    transform: translateY(-50%);
    transform-origin: left center;
  }
`;
const $06825994d276e479$var$PaymentDetailsBlock = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  border: 1px solid #dde4f0;
  border-radius: 14px;
  background: #fbfcff;
  padding: 13px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const $06825994d276e479$var$PaymentDetailRow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;
const $06825994d276e479$var$DetailLabel = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
`;
const $06825994d276e479$var$DetailValue = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 15px;
  color: #0f172a;
  font-weight: 500;
  text-align: right;
`;
const $06825994d276e479$var$MonoValue = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 13px;
  color: #1e293b;
  overflow-wrap: anywhere;
  text-align: right;
`;
const $06825994d276e479$var$PaymentAddressValue = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  line-height: 1.5;
  color: #1e293b;
  word-break: normal;
  overflow-wrap: anywhere;
  user-select: all;
  padding: 15px 74px 15px 18px;
  border-radius: 10px;
  border: 1px solid #e2e8f2;
  background: white;

  @media (max-width: 1120px) and (min-width: 901px) {
    font-size: 11.5px;
    padding: 14px 70px 14px 16px;
  }
`;
const $06825994d276e479$var$PaymentAddressField = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
`;
const $06825994d276e479$var$PaymentFlowDivider = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #5d6d86;
  font-size: 13px;
  font-weight: 600;

  ::before,
  ::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e3e9f3;
  }
`;
const $06825994d276e479$var$ManualPaymentCard = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  border: 1px solid #dde4f0;
  border-radius: 16px;
  background: #fbfcff;
  overflow: hidden;
`;
const $06825994d276e479$var$ManualPaymentGrid = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: ${({ hasQr: hasQr })=>hasQr ? "124px minmax(0, 1fr)" : "1fr"};
  align-items: start;
  gap: 28px;
  padding: 28px 28px 24px;

  @media (max-width: 1120px) and (min-width: 901px) {
    grid-template-columns: 108px minmax(0, 1fr);
    gap: 22px;
    padding: 24px 24px 22px;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }
`;
const $06825994d276e479$var$ManualPaymentInfoColumn = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  min-width: 0;
`;
const $06825994d276e479$var$ManualInfoDivider = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  height: 1px;
  background: #e6ebf2;
`;
const $06825994d276e479$var$ManualPaymentAddressSection = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  padding: 22px 26px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 1120px) and (min-width: 901px) {
    padding: 20px 24px 24px;
  }

  @media (max-width: 900px) {
    padding: 20px 16px 20px;
  }
`;
const $06825994d276e479$var$ManualNoticeIcon = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)((0, $1e598fd09e90fe12$export$2957fc44b3d2481))`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  opacity: 0.55;
`;
const $06825994d276e479$var$ManualPaymentFooter = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  border-top: 1px solid #e6ebf2;
  background: #f7f9fd;
  padding: 16px 26px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #5b6b83;
  font-size: 14px;
  line-height: 1.45;

  @media (max-width: 1120px) and (min-width: 901px) {
    padding: 14px 22px;
  }

  @media (max-width: 900px) {
    padding: 12px 16px;
  }
`;
const $06825994d276e479$var$UnderpaidNotice = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  border: 1px solid #f0d5a1;
  border-radius: 14px;
  background: #fffaf0;
  overflow: hidden;
`;
const $06825994d276e479$var$UnderpaidNoticeHeader = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  padding: 12px 16px;
  background: #fbeed4;
  color: #8a5a12;
  font-size: 13px;
  font-weight: 600;
`;
const $06825994d276e479$var$UnderpaidNoticeBody = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  color: #5b6b83;
  font-size: 14px;
  line-height: 1.45;
`;
const $06825994d276e479$var$CTASection = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  border-top: 1px solid #e6ebf2;
  padding-top: 14px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const $06825994d276e479$var$WalletConnectSection = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  padding-bottom: 10px;
  width: 100%;
`;
const $06825994d276e479$var$PaymentHeroActions = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
const $06825994d276e479$var$LoadingStateGroup = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 116px;
  padding: 12px 0 4px;
  animation: ${$06825994d276e479$export$b2a0bb8fc9a08697} 0.28s cubic-bezier(0.22, 1, 0.36, 1);
`;
const $06825994d276e479$var$PaymentStepColumn = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: min(640px, 100%);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 18px;

  @media (max-width: 900px) {
    width: 100%;
    gap: 14px;
  }
`;
const $06825994d276e479$var$StatusTimeline = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const $06825994d276e479$var$StatusTimelineRow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const $06825994d276e479$var$StatusDot = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  width: 12px;
  height: 12px;
  border-radius: 6px;
  display: inline-block;
  flex-shrink: 0;
  background: ${({ state: state })=>state === "done" ? "#22c55e" : state === "active" ? "#3f6bf5" : "#cdd6e5"};
`;
const $06825994d276e479$export$6f653acab4a8965a = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 15px;
  border-radius: ${({ hoverEffect: hoverEffect })=>hoverEffect ? "0px" : "5px"};
  cursor: pointer;
  border-bottom: 1px solid;
  ${({ isSelected: isSelected })=>isSelected && "border: 1px solid;"}
  border-color: ${({ isSelected: isSelected })=>isSelected ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NICE_GREEN : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  box-shadow: ${({ isSelected: isSelected })=>isSelected && `0 0 3px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NICE_GREEN}`};
  opacity: ${({ isSelected: isSelected })=>isSelected ? "1" : "0.3"};
  transition: 0.2s ease all;
  user-select: none;

  ${({ isSelected: isSelected })=>isSelected && `
    position: sticky;
    top: 0;
    bottom: 0;
    background: white;
    z-index: 1;
  `}

  ${({ isDisabled: isDisabled })=>isDisabled && "opacity: 0.5;"}

  &:hover {
    opacity: ${({ isSelected: isSelected })=>isSelected ? 1 : 0.6};
    ${({ hoverEffect: hoverEffect })=>hoverEffect && `
      background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST};
    `}
  }

  &:active {
    opacity: ${({ isSelected: isSelected })=>isSelected ? 1 : 0.8};
    transform: scale(0.98);
  }
`;
const $06825994d276e479$export$c825e58f74061357 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: -1;
  overflow: hidden;
`;
const $06825994d276e479$var$WaveAnim = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -1600px;
  }
`;
const $06825994d276e479$export$b8bb87b40c00c04e = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($037ea4094b2de8f5$exports)))}) repeat-x;
  position: absolute;
  width: 6400px;
  height: 50%;
  top: calc(50% - 100px);
  animation: ${$06825994d276e479$var$WaveAnim} 18s cubic-bezier( 0.36, 0.45, 0.63, 0.53) infinite;
`;
const $06825994d276e479$var$WaveAnim2 = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -3200px;
  }
`;
const $06825994d276e479$export$6128c696434ef87c = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)($06825994d276e479$export$b8bb87b40c00c04e)`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($18a35bb413290b73$exports)))}) repeat-x;
  animation: ${$06825994d276e479$var$WaveAnim2} 15s cubic-bezier( 0.36, 0.45, 0.63, 0.53) infinite;
`;
const $06825994d276e479$var$WaveAnim3 = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  0% {
    margin-left: -800px;
  }
  100% {
    margin-left: -2400px;
  }
`;
const $06825994d276e479$export$bd3f954aa84a63d6 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)($06825994d276e479$export$b8bb87b40c00c04e)`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($d8717c29a0ad1971$exports)))}) repeat-x;
  animation: ${$06825994d276e479$var$WaveAnim3} 6s cubic-bezier( 0.36, 0.45, 0.63, 0.53) infinite;
`;
const $06825994d276e479$var$Expand = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scaleY(0%);
  }
  100% {
    transform: scaleY(100%);
  }
`;
const $06825994d276e479$var$PaymentDetectedContainer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  animation: ${$06825994d276e479$var$Expand} 0.2s cubic-bezier(0, 1, 0, 1);
  transform-origin: 0 0;
  border-radius: 15px;
  border: 1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED};
  overflow: hidden;
`;
const $06825994d276e479$var$rotate = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  100% { transform: rotate(1turn); }
`;
const $06825994d276e479$var$LoaderWrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 50px;
  aspect-ratio: 1;
  padding: 2px;
  border-radius: 50%;
  opacity: 0.8;
  background:
    radial-gradient(farthest-side, ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE5} 94%, #0000) top/8px 8px no-repeat,
    conic-gradient(#0000 30%, ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).INFO});
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: ${$06825994d276e479$var$rotate} 1s infinite linear;
`;
const $06825994d276e479$export$4f2558dd25106ae2 = ({ onClick: onClick, style: style, iconColor: iconColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST })=>{
    const [copied, setCopied] = (0, $bnENU.useState)(false);
    (0, $bnENU.useEffect)(()=>{
        if (copied) {
            const timeout = setTimeout(()=>setCopied(false), 3000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        copied
    ]);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
        onClick: ()=>{
            setCopied(true);
            onClick();
        },
        style: {
            padding: "2px 4px",
            fontSize: 10,
            textTransform: "uppercase",
            background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED,
            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
            cursor: "pointer",
            borderRadius: 5,
            display: "flex",
            alignItems: "center",
            gap: 2,
            border: "none",
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                children: copied ? "Copied" : "Copy"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d15b0de6bb1f6866$export$2e2bcd8739ae039), {
                style: {
                    height: 10
                },
                stroke: iconColor
            })
        ]
    });
};
const $06825994d276e479$var$logoKey = (logo)=>typeof logo === "string" ? logo : String(logo ?? "");
const $06825994d276e479$var$getNativeCurrencyLogo = (method)=>{
    if (method.ticker === "ETH") return 0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports));
    return method.logo ?? method.tokenInfo?.logo;
};
const $06825994d276e479$var$getNetworkLogoForMethod = (method)=>{
    if (method.tokenInfo?.logo) return method.tokenInfo.logo;
    const networkName = method.tokenInfo?.networkName ?? method.name;
    try {
        return (0, $5760199798158999$export$8793fab959da70d1)(networkName).logo;
    } catch  {
        return method.logo;
    }
};
const $06825994d276e479$var$PaymentMethodIcon = ({ method: method, size: size = 34 })=>{
    const primaryLogo = $06825994d276e479$var$getNativeCurrencyLogo(method);
    const networkLogo = $06825994d276e479$var$getNetworkLogoForMethod(method);
    const showNetworkBadge = Boolean(networkLogo && primaryLogo && $06825994d276e479$var$logoKey(networkLogo) !== $06825994d276e479$var$logoKey(primaryLogo));
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentMethodIconRoot, {
        size: size,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$PaymentMethodIconMain, {
                src: primaryLogo
            }),
            showNetworkBadge && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$PaymentMethodIconBadge, {
                size: size,
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$PaymentMethodIconBadgeImage, {
                    src: networkLogo,
                    size: size
                })
            })
        ]
    });
};
var $06825994d276e479$export$267c62a135bb226c;
(function(CheckoutState) {
    CheckoutState[CheckoutState["CollectTravelRuleFields"] = 0] = "CollectTravelRuleFields";
    CheckoutState[CheckoutState["Checkout"] = 1] = "Checkout";
})($06825994d276e479$export$267c62a135bb226c || ($06825994d276e479$export$267c62a135bb226c = {}));
var $06825994d276e479$var$SubscriptionCheckoutState;
(function(SubscriptionCheckoutState) {
    SubscriptionCheckoutState[SubscriptionCheckoutState["Select"] = 0] = "Select";
    SubscriptionCheckoutState[SubscriptionCheckoutState["Confirm"] = 1] = "Confirm";
    SubscriptionCheckoutState[SubscriptionCheckoutState["Allowance"] = 2] = "Allowance";
    SubscriptionCheckoutState[SubscriptionCheckoutState["EmailInvoicePay"] = 3] = "EmailInvoicePay";
})($06825994d276e479$var$SubscriptionCheckoutState || ($06825994d276e479$var$SubscriptionCheckoutState = {}));
var $06825994d276e479$export$60341e7d25c98210;
(function(SubscriptionType) {
    SubscriptionType[SubscriptionType["EmailInvoice"] = 0] = "EmailInvoice";
    SubscriptionType[SubscriptionType["Autopay"] = 1] = "Autopay";
})($06825994d276e479$export$60341e7d25c98210 || ($06825994d276e479$export$60341e7d25c98210 = {}));
const $06825994d276e479$var$DEFAULT_FIAT_CURRENCY = "USD";
const $06825994d276e479$var$inputFieldValidationError = (field)=>{
    if (!field.isRequired) return undefined;
    const label = field.inputLabel.trim().length > 0 ? field.inputLabel.trim() : "this field";
    if (typeof field.value === "boolean") return field.value ? undefined : `Select ${label}.`;
    if (typeof field.value === "number") return Number.isNaN(field.value) ? `Enter ${label}.` : undefined;
    const value = String(field.value ?? "").trim();
    if (value.length === 0) return `Enter ${label}.`;
    if (field.dataType === "Email" && !(0, $8d017118df5fe2e5$export$1e21512880529eb2)(value)) return "Enter a valid email address.";
    return undefined;
};
const $06825994d276e479$var$hasMissingRequiredInputValues = (fields)=>{
    return fields.some((field)=>$06825994d276e479$var$inputFieldValidationError(field) !== undefined);
};
const $06825994d276e479$export$6fbd6664a2410aa5 = (trfFlagObj)=>{
    const { accountType: accountType, companyNameCollected: companyNameCollected, addressLine1Collected: addressLine1Collected, townOrCityCollected: townOrCityCollected, ...otherFields } = trfFlagObj;
    // Keep required address inputs minimal to reduce checkout friction while
    // still collecting the core travel-rule address fields.
    const addressMissing = !addressLine1Collected || !townOrCityCollected;
    const needsCompany = accountType !== "Individual" && !companyNameCollected;
    const needsOther = Object.entries(otherFields).some(([key, value])=>key !== "accountType" && !value);
    return addressMissing || needsCompany || needsOther ? 0 : 1;
};
// ---------------------------------------------------------------------------------------------------------------------
// This widget is used by multiple transaction types.
// Each has a different way of handling the collection of travel rule field (TRF) information
//
// * Payment Links      Multiple Use  TRFs collected at checkout
// * Donation Links     Multiple Use  TRFs collected at checkout
// * Invoices           Single Use    Zero or more TRFs created by merchant. Remaining TRFs collected at checkout
// * Payment Sessions   Single Use    Zero or more TRFs created by merchant. Remaining TRFs collected at checkout
// * Checkout Sessions  Single Use    Zero or more TRFs created by merchant. Remaining TRFs collected at checkout
// ---------------------------------------------------------------------------------------------------------------------
const $06825994d276e479$var$PayWidget = (props)=>{
    const [localCheckoutData, setLocalCheckoutData] = (0, $bnENU.useState)({});
    const [selectedMethod, setSelectedMethod] = (0, $bnENU.useState)();
    const [selectedTicker, setSelectedTicker] = (0, $bnENU.useState)();
    const [selectedChainName, setSelectedChainName] = (0, $bnENU.useState)();
    const [selectedTokenImageUrl, setSelectedTokenImageUrl] = (0, $bnENU.useState)();
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(false);
    const [isStepTransitioning, setIsStepTransitioning] = (0, $bnENU.useState)(false);
    const [managedRouteError, setManagedRouteError] = (0, $bnENU.useState)("");
    const [currencySearch, setCurrencySearch] = (0, $bnENU.useState)("");
    const [isMobilePaymentViewport, setIsMobilePaymentViewport] = (0, $bnENU.useState)(typeof window !== "undefined" ? window.innerWidth <= $06825994d276e479$var$MOBILE_PAYMENT_BREAKPOINT : false);
    const [showMobileQr, setShowMobileQr] = (0, $bnENU.useState)(false);
    const [priceQuotes, setPriceQuotes] = (0, $bnENU.useState)([]);
    const [quoteExpiryTimestamp, setQuoteExpiryTimestamp] = (0, $bnENU.useState)(new Date());
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [quoteSecondsRemaining, setQuoteSecondsRemaining] = (0, $bnENU.useState)(0);
    const [isLoadingPriceQuotes, setIsLoadingPriceQuotes] = (0, $bnENU.useState)(false);
    const { disconnect: disconnect } = (0, $9d39a2f446de0538$export$83bebf2fe7fead4e)();
    const { address: address, isConnected: isConnected, connector: connector } = (0, $2739213b2d55f551$export$83a8e409853da004)();
    const isOpenBanking = props.checkoutData?.gateway?.openBanking !== undefined;
    if (typeof window !== "undefined" && !window.__W3M_INITIALIZED__ && !isOpenBanking && props.checkoutData) {
        (0, $1a6c142165b114fb$export$14650d4efb17e382)({
            wagmiConfig: $5760199798158999$export$382a3cc012b91987,
            projectId: $5760199798158999$export$e4bb003b4e7478a
        });
        window.__W3M_INITIALIZED__ = true;
    }
    const { open: open } = (0, $c8101c12137113f6$export$69804ca079d47f29)();
    const [localInputFields, setLocalInputFields] = (0, $bnENU.useState)([]);
    const [inputFieldsConfirmed, setInputFieldsConfirmed] = (0, $bnENU.useState)(true);
    const [inputFieldValidationAttempted, setInputFieldValidationAttempted] = (0, $bnENU.useState)(false);
    const [subscriptionValidationError, setSubscriptionValidationError] = (0, $bnENU.useState)("");
    const inputFieldsSourceRef = (0, $bnENU.useRef)("");
    const inputFieldsDefinitionKey = (0, $bnENU.useMemo)(()=>{
        return (props.checkoutData.inputFields ?? []).map((inputField)=>[
                inputField.inputLabel,
                inputField.dataType,
                inputField.isRequired ? "required" : "optional"
            ].join(":")).join("|");
    }, [
        props.checkoutData.inputFields
    ]);
    const travelRulePrefilledData = (0, $bnENU.useMemo)(()=>{
        const getInputValue = (label)=>{
            const field = localInputFields.find((inputField)=>inputField.inputLabel.trim().toLowerCase() === label);
            if (!field || typeof field.value !== "string") return undefined;
            const value = field.value.trim();
            return value.length > 0 ? value : undefined;
        };
        const emailFromCheckoutData = props.checkoutData.travelRuleEmail?.trim();
        const email = emailFromCheckoutData && emailFromCheckoutData.length > 0 ? emailFromCheckoutData : getInputValue("email address");
        const name = getInputValue("name") ?? getInputValue("representative name");
        const companyName = getInputValue("company name") ?? getInputValue("organization");
        const residenceCountry = getInputValue("country") ?? getInputValue("country of residence");
        const billingAddress = getInputValue("billing address") ?? getInputValue("address");
        return {
            email: email,
            name: name,
            companyName: companyName,
            residenceCountry: residenceCountry,
            billingAddress: billingAddress
        };
    }, [
        localInputFields,
        props.checkoutData.travelRuleEmail
    ]);
    const [checkoutState, setCheckoutState] = (0, $bnENU.useState)(props.hideTravelRuleFields === true || props.checkoutData.isInvoice ? 1 : props.travelRuleFieldsCollected ? $06825994d276e479$export$6fbd6664a2410aa5(props.travelRuleFieldsCollected) : 0);
    const [travelRuleFields, setTravelRuleFields] = (0, $bnENU.useState)((0, $8652974033b0a752$export$4739bd9618b6a26b)());
    const inputRefs = (0, $bnENU.useRef)([]);
    const transitionTimeoutRef = (0, $bnENU.useRef)(null);
    const [subscriptionEmailAddress, setSubscriptionEmailAddress] = (0, $bnENU.useState)("");
    (0, $bnENU.useEffect)(()=>{
        props.onCheckoutStateChange?.(checkoutState === 1);
    }, [
        checkoutState,
        props.onCheckoutStateChange
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (props.managedPaymentDetails ?? props.tokenDelegatePaymentDetails) setCheckoutState(1);
    }, [
        props.managedPaymentDetails,
        props.tokenDelegatePaymentDetails
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (typeof window === "undefined" || window.__W3M_INITIALIZED__) return;
        if (props.checkoutData && !props.checkoutData.gateway?.openBanking) {
            (0, $1a6c142165b114fb$export$14650d4efb17e382)({
                wagmiConfig: $5760199798158999$export$382a3cc012b91987,
                projectId: $5760199798158999$export$e4bb003b4e7478a
            });
            window.__W3M_INITIALIZED__ = true;
        }
    }, [
        props.checkoutData
    ]);
    function formatCrypto8(value) {
        const maxDp = 8;
        const v = Number(value);
        if (!Number.isFinite(v)) return "\u2014";
        const threshold = Math.pow(10, -maxDp);
        if (v > 0 && v < threshold) return `< ${"0." + "0".repeat(maxDp - 1)}1`;
        const fixed = v.toFixed(maxDp);
        const trimmedZeros = fixed.replace(/(\.\d*?[1-9])0+$/, "$1").replace(/\.0+$/, "");
        return trimmedZeros;
    }
    (0, $bnENU.useEffect)(()=>{
        const nextInputFields = props.checkoutData.inputFields?.map((inputField)=>({
                ...inputField
            })) ?? [];
        const sourceKey = `${props.checkoutData.id ?? ""}:${inputFieldsDefinitionKey}`;
        inputRefs.current = inputRefs.current.slice(0, nextInputFields.length);
        setLocalInputFields(nextInputFields);
        if (inputFieldsSourceRef.current !== sourceKey) {
            inputFieldsSourceRef.current = sourceKey;
            setInputFieldsConfirmed(!$06825994d276e479$var$hasMissingRequiredInputValues(nextInputFields));
            setInputFieldValidationAttempted(false);
        }
    }, [
        inputFieldsDefinitionKey,
        props.checkoutData.id,
        props.checkoutData.inputFields
    ]);
    (0, $bnENU.useEffect)(()=>{
        return ()=>{
            if (transitionTimeoutRef.current) clearTimeout(transitionTimeoutRef.current);
        };
    }, []);
    (0, $bnENU.useEffect)(()=>{
        if (typeof window === "undefined") return;
        const updateViewportState = ()=>{
            setIsMobilePaymentViewport(window.innerWidth <= $06825994d276e479$var$MOBILE_PAYMENT_BREAKPOINT);
        };
        updateViewportState();
        window.addEventListener("resize", updateViewportState);
        return ()=>window.removeEventListener("resize", updateViewportState);
    }, []);
    (0, $bnENU.useEffect)(()=>{
        if (!isMobilePaymentViewport) {
            setShowMobileQr(true);
            return;
        }
        setShowMobileQr(false);
    }, [
        isMobilePaymentViewport,
        props.managedPaymentDetails?.paymentId
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    const getPriceQuotes = ()=>{
        props.onQuoteUpdate();
        setIsLoadingPriceQuotes(true);
        const fromCurList = [
            ...props.checkoutData.products?.map((p)=>p.product.currency) ?? [],
            ...props.checkoutData.lineItems?.map((p)=>p.currency ?? $06825994d276e479$var$DEFAULT_FIAT_CURRENCY) ?? [],
            props.currency || $06825994d276e479$var$DEFAULT_FIAT_CURRENCY
        ];
        const { managed: managed } = props.checkoutData.gateway;
        if (managed) fromCurList.push($06825994d276e479$var$DEFAULT_FIAT_CURRENCY, ...managed.methods.filter((t)=>!(0, $5760199798158999$export$53becfa3eb141e16)(t.network, t.token)).map((t)=>(0, $5760199798158999$export$8793fab959da70d1)(t.network, t.token).ticker || ""));
        const fromCur = [
            ...new Set(fromCurList)
        ];
        if (fromCur.length === 0) {
            setIsLoadingPriceQuotes(false);
            return;
        }
        (0, $43c053927acc0cba$export$2e2bcd8739ae039).getPriceQuotes(fromCur, fromCur).then((priceQuotes)=>{
            const minTimestamp = (0, $c322f0373ea50904$export$2e2bcd8739ae039)(priceQuotes.map((p)=>new Date(p.expiryTimestamp)));
            setQuoteExpiryTimestamp(minTimestamp);
            setQuoteSecondsRemaining((minTimestamp.getTime() - new Date().getTime()) / 1000);
            setPriceQuotes(priceQuotes);
        }).catch((err)=>{
            console.error("Failed to refresh pay widget quotes", err);
        }).finally(()=>{
            setIsLoadingPriceQuotes(false);
        });
    };
    // -------------------------------------------------------------------------------------------------------------------
    const [totalSum, recurringSum] = (0, $bnENU.useMemo)(()=>{
        return (0, $94d9469e1ad800ce$export$56eaa5cece9d2d8a)(props.checkoutData, priceQuotes, props.currency, props.discount);
    }, [
        props.checkoutData,
        priceQuotes,
        props.currency,
        props.discount
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    const recurringInterval = ()=>{
        if (props.checkoutData.products) {
            const g = props.checkoutData.products.find((p)=>p.product.chargingIntervalSeconds > 0);
            if (g) return g.product.chargingIntervalSeconds / 60 / 60 / 24;
        }
        if (props.checkoutData.lineItems) {
            const g = props.checkoutData.lineItems.find((p)=>p.chargingIntervalSeconds > 0);
            if (g) return g.chargingIntervalSeconds / 60 / 60 / 24;
        }
        return 0;
    };
    // -------------------------------------------------------------------------------------------------------------------
    const nextBillingAt = ()=>{
        if (props.checkoutData.products) {
            const g = props.checkoutData.products.find((p)=>p.product.chargingIntervalSeconds > 0);
            if (g?.product.nextBillingDateAt) return (0, $50403809f98fa2f7$export$2e2bcd8739ae039)(new Date(g.product.nextBillingDateAt), new Date());
        }
        if (props.checkoutData.lineItems) {
            const g = props.checkoutData.lineItems.find((p)=>p.chargingIntervalSeconds > 0);
            if (g?.nextBillingDateAt) return (0, $50403809f98fa2f7$export$2e2bcd8739ae039)(new Date(g.nextBillingDateAt), new Date());
        }
        return (0, $50403809f98fa2f7$export$2e2bcd8739ae039)(new Date(new Date().getTime() + recurringInterval() * 86400000), new Date());
    };
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        if ((0, $fDWVA.isEqual)(localCheckoutData.gateway, props.checkoutData.gateway) && (0, $fDWVA.isEqual)(localCheckoutData.products, props.checkoutData.products) && (0, $fDWVA.isEqual)(localCheckoutData.lineItems, props.checkoutData.lineItems) && (0, $fDWVA.isEqual)(localCheckoutData.currency, props.checkoutData.currency) && (0, $fDWVA.isEqual)(localCheckoutData.total, props.checkoutData.total)) return;
        if (props.checkoutData.gateway.managed) {
            setLocalCheckoutData((0, $fDWVA.cloneDeep)(props.checkoutData));
            getPriceQuotes();
        }
    }, [
        props.checkoutData
    ]);
    (0, $bnENU.useEffect)(()=>getPriceQuotes(), [
        props.checkoutData.products?.length
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        const myInterval = setInterval(()=>{
            if (quoteExpiryTimestamp.getTime() <= new Date().getTime()) getPriceQuotes();
            setQuoteSecondsRemaining((quoteExpiryTimestamp.getTime() - new Date().getTime()) / 1000);
        }, 1000);
        return ()=>clearInterval(myInterval);
    }, [
        quoteExpiryTimestamp
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    const [managedPaymentQrCode, setManagedPaymentQrCode] = (0, $bnENU.useState)("");
    const [isDesktopQrModalVisible, setIsDesktopQrModalVisible] = (0, $bnENU.useState)(false);
    const [isManagedEVMTxLoading, setIsManagedEVMTxLoading] = (0, $bnENU.useState)(false);
    const [isSigningMessage, setIsSigningMessage] = (0, $bnENU.useState)(false);
    const [isSettingAllowance, setIsSettingAllowance] = (0, $bnENU.useState)(false);
    const [allowSkipAllowance, setAllowSkipAllowance] = (0, $bnENU.useState)(false);
    const [gasCost, setGasCost] = (0, $bnENU.useState)("");
    const [isLoadingAllowance, setIsLoadingAllowance] = (0, $bnENU.useState)(false);
    const [managedSubscriptionState, setManagedSubscriptionState] = (0, $bnENU.useState)();
    const [selectedSubscriptionType, setSelectedSubscriptionType] = (0, $bnENU.useState)();
    const [receiveEmailNotifications, setReceiveEmailNotifications] = (0, $bnENU.useState)(false);
    (0, $bnENU.useEffect)(()=>{
        if (isMobilePaymentViewport || !managedPaymentQrCode) setIsDesktopQrModalVisible(false);
    }, [
        isMobilePaymentViewport,
        managedPaymentQrCode,
        props.managedPaymentDetails?.paymentId
    ]);
    const onKeyboardSelect = (e, callback)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            callback();
        }
    };
    const isBitcoinNetwork = (0, $bnENU.useMemo)(()=>props.managedPaymentDetails?.network === "Bitcoin", [
        props.managedPaymentDetails?.network
    ]);
    const { paymentStatus: paymentStatus, pendingAmount: pendingAmount, confirmedAmount: confirmedAmount, amountRemaining: amountRemaining, hasPaymentDetected: hasPaymentDetected, hasConfirmedPayment: hasConfirmedPayment, isUnderReview: isUnderReview, isAwaitingConfirmation: isAwaitingConfirmation, isUnderpaid: isUnderpaid, amountLeft: amountLeft } = (0, $bnENU.useMemo)(()=>{
        const status = props.paymentStatus?.status ?? "pending";
        const pending = props.paymentStatus?.pendingTransactions.reduce((sum, tx)=>sum + Number(tx.amount), 0) ?? 0;
        const confirmed = props.paymentStatus?.transactions.reduce((sum, tx)=>sum + Number(tx.amount), 0) ?? 0;
        const remaining = Number(props.paymentStatus?.amountRemaining ?? 0);
        const underReview = status === "inReview";
        const awaitingConfirmation = status === "paymentDetected" && confirmed > 0 && remaining <= 0;
        const isConfirmed = status === "paymentConfirmed" || !underReview && !awaitingConfirmation && confirmed > 0 && remaining <= 0;
        const underpaid = !isConfirmed && !underReview && confirmed > 0 && remaining > 0;
        return {
            paymentStatus: status,
            pendingAmount: pending,
            confirmedAmount: confirmed,
            amountRemaining: remaining,
            hasPaymentDetected: status === "paymentDetected" || pending > 0,
            hasConfirmedPayment: isConfirmed,
            isUnderReview: underReview,
            isAwaitingConfirmation: awaitingConfirmation,
            isUnderpaid: underpaid,
            amountLeft: underpaid ? props.paymentStatus?.amountRemaining ?? "" : props.managedPaymentDetails?.amount ?? ""
        };
    }, [
        props.paymentStatus,
        props.managedPaymentDetails?.amount
    ]);
    const amountLeftPaymentDetails = (0, $bnENU.useMemo)(()=>props.managedPaymentDetails ? {
            ...props.managedPaymentDetails,
            amount: amountLeft
        } : undefined, [
        props.managedPaymentDetails,
        amountLeft
    ]);
    const generateManagedPaymentQrCode = async ()=>{
        if (!amountLeftPaymentDetails) return;
        const [qrCodeData] = await (0, $772308ca90c00f76$export$45312203e6f4f22c)(amountLeftPaymentDetails);
        setManagedPaymentQrCode(qrCodeData);
    };
    // -------------------------------------------------------------------------------------------------------------------
    const onClickOpenWallet = async ()=>{
        if (!amountLeftPaymentDetails) return;
        switch(amountLeftPaymentDetails.network){
            case "Bitcoin":
            case "Solana":
            case "Zcash":
            case "ZcashTestnet":
            case "Polkadot":
            case "PolkadotTestnet":
            case "PolkadotAssetHub":
            case "PolkadotAssetHubTestnet":
                break;
            case "Ethereum":
            case "SepoliaTestnet":
            case "Polygon":
            case "PolygonTestnet":
            case "BNB":
            case "BNBTestnet":
            case "Base":
            case "Arbitrum":
            case "Avalanche":
                try {
                    if (!address) {
                        await open();
                        return;
                    }
                    setIsManagedEVMTxLoading(true);
                    const chain = (0, $5760199798158999$export$cc4208a8ebc9f985)[amountLeftPaymentDetails.network];
                    const provider = await connector?.getProvider();
                    const signer = (0, $bf4e0381e2c41280$export$362b8ea2edbd9090)({
                        chain: chain,
                        transport: (0, $c1b76a8a2251eb69$export$4c00f665f0d4b443)(provider)
                    });
                    if (connector?.switchChain) {
                        const chainId = await connector.getChainId();
                        if (chainId !== chain.id) await connector?.switchChain({
                            chainId: chain.id
                        });
                    }
                    if (amountLeftPaymentDetails.token) {
                        const method = (0, $5760199798158999$export$8793fab959da70d1)(amountLeftPaymentDetails.network, amountLeftPaymentDetails.token);
                        const contract = (0, $4a68b247381b8806$export$f518c38144e1f9d)({
                            address: amountLeftPaymentDetails.token,
                            abi: (0, $6Dftn.erc20Abi),
                            client: signer
                        });
                        try {
                            const balance = await contract.read.balanceOf([
                                address
                            ]);
                            const decimals = await contract.read.decimals();
                            const parsedAmount = (0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(amountLeftPaymentDetails.amount, decimals);
                            if (balance < parsedAmount) {
                                setIsManagedEVMTxLoading(false);
                                (0, $8d017118df5fe2e5$export$6badb0ecde4e0bd0)(`Your wallet does not have enough ${selectedMethod?.name} for payment.`);
                                return;
                            }
                        } catch (err) {
                            console.error("Failed to get token balance using injected provider", err);
                        }
                        await contract.write.transfer([
                            amountLeftPaymentDetails.paymentAddress,
                            (0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(amountLeftPaymentDetails.amount, method.tokenInfo?.decimals ?? 6)
                        ], {
                            account: address,
                            chain: chain
                        });
                    } else {
                        const client = (0, $8085cfeffb1fd5c6$export$d8e090d8c6a7a6ad)({
                            chain: chain,
                            transport: (0, $c1b76a8a2251eb69$export$4c00f665f0d4b443)(provider)
                        });
                        try {
                            const balance = await client.getBalance({
                                address: address
                            });
                            if (balance < (0, $5316bee174ce871c$export$642c4e67bbdc0bc7)(amountLeftPaymentDetails.amount)) {
                                setIsManagedEVMTxLoading(false);
                                (0, $8d017118df5fe2e5$export$6badb0ecde4e0bd0)(`Your wallet does not have enough ${selectedMethod?.ticker ?? "amount"} for payment.`);
                                return;
                            }
                        } catch (err) {
                            console.error("Failed to get balance using injected provider", err);
                        }
                        if (!signer) return;
                        await signer.sendTransaction({
                            account: address,
                            chain: chain,
                            to: amountLeftPaymentDetails.paymentAddress,
                            value: (0, $5316bee174ce871c$export$642c4e67bbdc0bc7)(amountLeftPaymentDetails.amount)
                        });
                    }
                } catch (err) {
                    setIsManagedEVMTxLoading(false);
                    (0, $8d017118df5fe2e5$export$6badb0ecde4e0bd0)("Failed to approve payment. Please ensure you have enough funds.");
                    console.error(err);
                }
                break;
            default:
                console.error("No wallet");
        }
    };
    // -------------------------------------------------------------------------------------------------------------------
    const setManagedSubscriptionAllowance = async ()=>{
        if (selectedMethod?.tokenInfo?.tokenType !== "evm") return;
        if (!address) {
            await open();
            return;
        }
        setIsSettingAllowance(true);
        try {
            if (!address) return;
            const chain = (0, $5760199798158999$export$cc4208a8ebc9f985)[selectedMethod.tokenInfo.networkName];
            const provider = await connector?.getProvider();
            const signer = (0, $bf4e0381e2c41280$export$362b8ea2edbd9090)({
                chain: chain,
                transport: (0, $c1b76a8a2251eb69$export$4c00f665f0d4b443)(provider)
            });
            if (connector?.switchChain) {
                const chainId = await connector.getChainId();
                if (chainId !== chain.id) await connector?.switchChain({
                    chainId: chain.id
                });
            }
            const contract = (0, $4a68b247381b8806$export$f518c38144e1f9d)({
                address: selectedMethod.tokenInfo.tokenAddress,
                abi: (0, $6Dftn.erc20Abi),
                client: {
                    public: signer,
                    wallet: signer
                }
            });
            const balance = await contract.read.balanceOf([
                address
            ]);
            const parsedAmount = (0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(totalSum.toString(), selectedMethod.tokenInfo.decimals);
            if (balance < parsedAmount) {
                setIsSettingAllowance(false);
                (0, $8d017118df5fe2e5$export$6badb0ecde4e0bd0)(`Your wallet does not have enough ${selectedMethod?.name} for payment.`);
                return;
            }
            const allowance = await contract.read.allowance([
                address,
                selectedMethod.tokenInfo.subscriptionContract
            ]);
            if (allowance <= BigInt(0) || allowance < parsedAmount * BigInt(300)) {
                if (selectedMethod.name === "Tether" && allowance > 0) {
                    const hash = await contract.write.approve([
                        selectedMethod.tokenInfo.subscriptionContract,
                        0n
                    ], {
                        account: address,
                        chain: chain
                    });
                    if (hash) try {
                        await (0, $f87a726a94dffdff$export$694ec9bdf0bb55cf)(signer, {
                            hash: hash,
                            retryCount: 30,
                            retryDelay: 1000
                        });
                    } catch (err) {
                        console.error("Failed to confirm allowance tx", err);
                    }
                }
                const hash = await contract.write.approve([
                    selectedMethod.tokenInfo.subscriptionContract,
                    (0, $64pxN.maxUint256)
                ], {
                    account: address,
                    chain: chain
                });
                if (hash) try {
                    console.log("Waiting for tx receipt");
                    await (0, $f87a726a94dffdff$export$694ec9bdf0bb55cf)(signer, {
                        hash: hash,
                        retryCount: 30,
                        retryDelay: 1000
                    });
                } catch (err) {
                    console.error("Failed to confirm allowance tx", err);
                }
            }
            setIsSettingAllowance(false);
            setManagedSubscriptionState(1);
        } catch (err) {
            setIsSettingAllowance(false);
            (0, $8d017118df5fe2e5$export$6badb0ecde4e0bd0)("Failed to set allowance");
            console.error(err);
        }
    };
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        if (props.managedPaymentDetails) generateManagedPaymentQrCode();
    }, [
        props.managedPaymentDetails,
        amountLeft
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        if (props.managedPaymentDetails) {
            if (managedSubscriptionState !== undefined) setManagedSubscriptionState(3);
        }
    }, [
        props.managedPaymentDetails
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        if (managedSubscriptionState === undefined) {
            setSelectedSubscriptionType(undefined);
            setReceiveEmailNotifications(false);
        }
        if (selectedMethod?.tokenInfo && selectedMethod.tokenInfo.tokenType === "evm") (0, $43c053927acc0cba$export$2e2bcd8739ae039).estimateTokenTranferGas(selectedMethod.tokenInfo.networkName, selectedMethod.tokenInfo.tokenAddress).then((g)=>{
            setGasCost(g.gasCost);
        }).catch((err)=>console.error(err));
    }, [
        managedSubscriptionState
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    const computeAllowanceStep = async ()=>{
        if (!props.tokenDelegatePaymentDetails) return;
        if (selectedMethod?.tokenInfo?.tokenType !== "evm") return;
        if (!address || !connector) {
            await open();
            return;
        }
        setIsLoadingAllowance(true);
        let signer;
        const chain = (0, $5760199798158999$export$cc4208a8ebc9f985)[props.tokenDelegatePaymentDetails.network];
        try {
            const provider = await connector?.getProvider();
            signer = (0, $bf4e0381e2c41280$export$362b8ea2edbd9090)({
                chain: chain,
                transport: (0, $c1b76a8a2251eb69$export$4c00f665f0d4b443)(provider)
            });
            if (connector?.switchChain) {
                const chainId = await connector.getChainId();
                if (chainId !== chain.id) await connector?.switchChain({
                    chainId: chain.id
                });
            }
        } catch (err) {
            setIsLoadingAllowance(false);
            (0, $8d017118df5fe2e5$export$6badb0ecde4e0bd0)(err.toString());
            return;
        }
        const contract = (0, $4a68b247381b8806$export$f518c38144e1f9d)({
            address: selectedMethod.tokenInfo.tokenAddress,
            abi: (0, $6Dftn.erc20Abi),
            client: {
                public: signer,
                wallet: signer
            }
        });
        try {
            if (!address) return;
            const allowance = await contract.read.allowance([
                address,
                selectedMethod.tokenInfo.subscriptionContract
            ]);
            const parsedAmount = (0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(totalSum.toString(), 6);
            if (allowance >= parsedAmount) setAllowSkipAllowance(true);
        } catch (err) {
            setAllowSkipAllowance(true);
        }
        setIsLoadingAllowance(false);
        setManagedSubscriptionState(2);
    };
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        if (props.tokenDelegatePaymentDetails) computeAllowanceStep();
        else if (managedSubscriptionState === 1) setManagedSubscriptionState(0);
    }, [
        props.tokenDelegatePaymentDetails
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        if (!props.errorMessage) return;
        (0, $8d017118df5fe2e5$export$6badb0ecde4e0bd0)(props.errorMessage);
    }, [
        props.errorMessage
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    // If any or all of the travel rule fields are missing, collect these first
    const trfWidget = !props.checkoutData.isInvoice && checkoutState === 0 ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4b9baece09e0c79d$export$2e2bcd8739ae039), {
        travelRuleFieldsCollected: props.travelRuleFieldsCollected ?? (0, $8652974033b0a752$export$3e77b1380e63cfaf)(),
        onTravelRuleFieldsComplete: async (collectedTrFields)=>{
            props.onTravelRuleFieldsContinue?.();
            setCheckoutState(1);
            setTravelRuleFields(collectedTrFields);
            const checkoutDataId = (0, $fDWVA.trim)((0, $fDWVA.toString)(props.checkoutData?.id));
            if (!(0, $fDWVA.isEmpty)(checkoutDataId)) try {
                if (props.checkoutData.isInvoice) await (0, $43c053927acc0cba$export$2e2bcd8739ae039).updateTrfsForCustomerViaInvoice(checkoutDataId, collectedTrFields);
                else if (props.checkoutData.sessionStatus !== undefined) await (0, $43c053927acc0cba$export$2e2bcd8739ae039).upsertTrfsForCheckoutSession(checkoutDataId, collectedTrFields);
            } catch (err) {
                console.error("Failed to save travel rule fields", err);
            }
            // If matching custom fields are still blank, seed them from the latest travel-rule values.
            let inputFieldsUpdated = false;
            const newLocalInputFields = localInputFields.map((inputField)=>{
                const normalizedLabel = inputField.inputLabel.trim().toLowerCase();
                const currentValue = String(inputField.value ?? "").trim();
                if (normalizedLabel === "email address" && currentValue.length === 0 && collectedTrFields.emailAddress) {
                    inputFieldsUpdated = true;
                    return {
                        ...inputField,
                        value: collectedTrFields.emailAddress
                    };
                }
                if (normalizedLabel === "name" && currentValue.length === 0 && collectedTrFields.name) {
                    inputFieldsUpdated = true;
                    return {
                        ...inputField,
                        value: collectedTrFields.name
                    };
                }
                return inputField;
            });
            if (inputFieldsUpdated) {
                setLocalInputFields(newLocalInputFields);
                props.onInputFieldsChange?.(newLocalInputFields);
            }
            if (!$06825994d276e479$var$hasMissingRequiredInputValues(newLocalInputFields)) setInputFieldsConfirmed(true);
        },
        prefilledData: travelRulePrefilledData
    }) : null;
    const isHexColor = (color)=>{
        if (!color) return;
        return /^#?[0-9A-Fa-f]{6}$/.test(color);
    };
    const getContrastColor = (hexColor)=>{
        if (!hexColor) return;
        const isHexColorCheck = isHexColor(hexColor);
        if (!isHexColorCheck) return;
        const hex = hexColor.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        const yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq >= 128 ? "#000000" : "#FFFFFF";
    };
    const displayManagedMethods = (0, $bnENU.useMemo)(()=>{
        const methods = (props.checkoutData.gateway.managed?.methods ?? []).filter((m)=>!(0, $5760199798158999$export$53becfa3eb141e16)(m.network, m.token));
        return methods.map((rawMethod)=>{
            const sourceMethod = (0, $5760199798158999$export$8793fab959da70d1)(rawMethod.network, rawMethod.token);
            const method = {
                ...sourceMethod,
                tokenInfo: sourceMethod.tokenInfo ? {
                    ...sourceMethod.tokenInfo
                } : undefined
            };
            // Keep ETH visual treatment consistent with Stripe-like flow expectations.
            if (method.ticker === "ETH") {
                if (method.tokenInfo) method.tokenInfo.logo = (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports)));
                else method.logo = (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports)));
            }
            return {
                rawMethod: rawMethod,
                method: method
            };
        });
    }, [
        props.checkoutData.gateway.managed?.methods
    ]);
    const hasMissingRequiredInputFields = (0, $bnENU.useMemo)(()=>{
        return $06825994d276e479$var$hasMissingRequiredInputValues(localInputFields);
    }, [
        localInputFields
    ]);
    const getManagedMethodDiscount = (discountPercentOff, ticker)=>{
        if (discountPercentOff && discountPercentOff > 0) return discountPercentOff;
        if (!props.discount) return 0;
        if (props.discount.model.modelType === "percentage") return Number(props.discount.model.amountOff) / 100;
        const fixedAmount = Number(props.discount.model.amountOff);
        const convertedFixed = (0, $94d9469e1ad800ce$export$61a490a80c552550)(fixedAmount, props.currency, ticker, priceQuotes, false);
        const baseValue = (0, $94d9469e1ad800ce$export$61a490a80c552550)(totalSum, props.currency, ticker, priceQuotes, false);
        if (!Number.isFinite(baseValue) || baseValue <= 0) return 0;
        return Math.max(0, Math.min(convertedFixed / baseValue, 1));
    };
    const currencyOptions = (0, $bnENU.useMemo)(()=>{
        const byTicker = new Map();
        for (const entry of displayManagedMethods){
            const networkName = entry.method.tokenInfo?.networkName ?? entry.method.name;
            const existing = byTicker.get(entry.method.ticker);
            const discount = getManagedMethodDiscount(entry.rawMethod.discountPercentOff, entry.method.ticker);
            if (!existing) {
                byTicker.set(entry.method.ticker, {
                    ticker: entry.method.ticker,
                    displayName: entry.method.currencyName ?? entry.method.name,
                    logo: entry.method.logo,
                    networkSet: new Set([
                        networkName
                    ]),
                    discount: discount
                });
                continue;
            }
            existing.networkSet.add(networkName);
            existing.discount = Math.max(existing.discount, discount);
        }
        return Array.from(byTicker.values()).map((entry)=>({
                ...entry,
                networkCount: entry.networkSet.size,
                amount: (0, $94d9469e1ad800ce$export$61a490a80c552550)(totalSum, props.currency, entry.ticker, priceQuotes, props.checkoutData.chargeCustomerNetworkFee, entry.discount)
            }));
    }, [
        displayManagedMethods,
        priceQuotes,
        props.checkoutData.chargeCustomerNetworkFee,
        props.currency,
        totalSum
    ]);
    const normalizedCurrencySearch = currencySearch.trim().toLowerCase();
    const showCurrencySearch = currencyOptions.length >= $06825994d276e479$var$CURRENCY_SEARCH_THRESHOLD;
    const filteredCurrencyOptions = (0, $bnENU.useMemo)(()=>{
        if (!showCurrencySearch || normalizedCurrencySearch.length === 0) return currencyOptions;
        return currencyOptions.filter((option)=>{
            const haystack = [
                option.ticker,
                option.displayName
            ].filter(Boolean).join(" ").toLowerCase();
            return haystack.includes(normalizedCurrencySearch);
        });
    }, [
        currencyOptions,
        normalizedCurrencySearch,
        showCurrencySearch
    ]);
    const selectedTickerNetworkOptions = (0, $bnENU.useMemo)(()=>{
        if (!selectedTicker) return [];
        const rows = displayManagedMethods.filter(({ method: method })=>method.ticker === selectedTicker).map(({ rawMethod: rawMethod, method: method })=>{
            const networkName = method.tokenInfo?.networkName ?? method.name;
            const discount = getManagedMethodDiscount(rawMethod.discountPercentOff, method.ticker);
            return {
                rawMethod: rawMethod,
                method: method,
                networkName: networkName,
                optionKey: `${method.ticker.toUpperCase()}:${networkName.trim().toLowerCase()}`,
                isTestnet: !!method.isTestnet,
                amount: (0, $94d9469e1ad800ce$export$61a490a80c552550)(totalSum, props.currency, method.ticker, priceQuotes, props.checkoutData.chargeCustomerNetworkFee, discount)
            };
        });
        const uniqueByNetwork = new Map();
        for (const row of rows)if (!uniqueByNetwork.has(row.optionKey)) uniqueByNetwork.set(row.optionKey, row);
        return Array.from(uniqueByNetwork.values());
    }, [
        displayManagedMethods,
        priceQuotes,
        props.checkoutData.chargeCustomerNetworkFee,
        props.currency,
        selectedTicker,
        totalSum
    ]);
    const proceedWithManagedMethod = async (method)=>{
        if (isLoading) return;
        setManagedRouteError("");
        setIsStepTransitioning(true);
        setSelectedMethod(method);
        setSelectedChainName(method.tokenInfo?.networkName ?? method.name);
        setSelectedTicker(method.ticker);
        setSelectedTokenImageUrl(method.logo ?? "");
        const transitionStartedAt = Date.now();
        setIsLoading(true);
        try {
            if (recurringInterval() > 0) {
                setManagedSubscriptionState(0);
                return;
            }
            await props.onCheckout({
                managed: {
                    selectedMethod: method
                },
                priceQuotes: priceQuotes,
                travelRuleFields: travelRuleFields
            });
        } catch (err) {
            console.error("Failed to initialize managed payment method", err);
            autoAdvanceRef.current = "";
            setSelectedMethod(undefined);
            setSelectedChainName("");
            setManagedRouteError(err instanceof Error ? err.message : "Unable to prepare your payment route.");
        } finally{
            const remainingDelay = Math.max(0, $06825994d276e479$var$MANAGED_STEP_TRANSITION_DELAY_MS - (Date.now() - transitionStartedAt));
            if (remainingDelay > 0) await new Promise((resolve)=>setTimeout(resolve, remainingDelay));
            setIsStepTransitioning(false);
            setIsLoading(false);
        }
    };
    const autoAdvanceRef = (0, $bnENU.useRef)("");
    const resetManagedPaymentSelection = ()=>{
        autoAdvanceRef.current = "";
        setSelectedMethod(undefined);
        setSelectedTicker("");
        setSelectedChainName("");
        setSelectedTokenImageUrl("");
        setManagedRouteError("");
        setManagedSubscriptionState(undefined);
        setIsStepTransitioning(false);
        setIsLoading(false);
        props.onChangePaymentMethod?.();
    };
    (0, $bnENU.useEffect)(()=>{
        if (checkoutState !== 1) return;
        if (props.managedPaymentDetails) return;
        if (managedSubscriptionState !== undefined) return;
        if (props.posMode ?? false) return;
        if (displayManagedMethods.length === 0 || !inputFieldsConfirmed || hasMissingRequiredInputFields || isLoadingPriceQuotes) return;
        if (currencyOptions.length === 1 && !selectedTicker) {
            const autoTicker = currencyOptions[0].ticker;
            setSelectedTicker(autoTicker);
            setSelectedTokenImageUrl(currencyOptions[0].logo ?? "");
            return;
        }
        if (selectedTicker && selectedTickerNetworkOptions.length === 1 && !selectedMethod) {
            const autoMethod = selectedTickerNetworkOptions[0].method;
            const autoKey = `${props.checkoutData.id}:${selectedTickerNetworkOptions[0].optionKey}`;
            if (autoAdvanceRef.current === autoKey) return;
            autoAdvanceRef.current = autoKey;
            proceedWithManagedMethod(autoMethod);
        }
    }, [
        checkoutState,
        currencyOptions,
        displayManagedMethods.length,
        hasMissingRequiredInputFields,
        inputFieldsConfirmed,
        isLoadingPriceQuotes,
        managedSubscriptionState,
        props.checkoutData.id,
        props.managedPaymentDetails,
        props.posMode,
        selectedMethod,
        selectedTicker,
        selectedTickerNetworkOptions
    ]);
    const managedDisplayMethod = (0, $bnENU.useMemo)(()=>{
        if (!props.managedPaymentDetails) return undefined;
        const source = (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token);
        const method = {
            ...source,
            tokenInfo: source.tokenInfo ? {
                ...source.tokenInfo
            } : undefined
        };
        if (method.ticker === "ETH") {
            if (method.tokenInfo) method.tokenInfo.logo = (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports)));
            else method.logo = (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports)));
        }
        return method;
    }, [
        props.managedPaymentDetails
    ]);
    const paymentNetworkName = managedDisplayMethod?.tokenInfo?.networkName ?? managedDisplayMethod?.name;
    const paymentTicker = managedDisplayMethod?.ticker ?? selectedMethod?.ticker ?? "";
    const paymentAddress = props.managedPaymentDetails?.paymentAddress ?? "";
    const paymentAmount = props.managedPaymentDetails?.amount ?? "";
    const paymentReference = props.managedPaymentDetails?.paymentId ?? "";
    const sellerDisplayName = props.checkoutData.sellerName?.trim() ?? "";
    const sellerAddress = props.checkoutData.sellerAddress?.trim() ?? "";
    const sellerNameLooksLikeFallback = sellerDisplayName.length === 0 || sellerDisplayName === sellerAddress || sellerDisplayName.includes("@") || /^0x[a-fA-F0-9]{40}$/.test(sellerDisplayName);
    const receiptRecipientName = sellerNameLooksLikeFallback ? "" : sellerDisplayName;
    const secondsRemaining = Math.max(0, Math.floor((new Date(props.paymentStatus?.expiresAt ?? props.managedPaymentDetails?.expiresAt ?? new Date()).getTime() - new Date().getTime()) / 1000));
    const lastTxHash = props.paymentStatus?.transactions[0]?.transactionHash;
    const networkExplorer = props.managedPaymentDetails ? (0, $5760199798158999$export$cc4208a8ebc9f985)[props.managedPaymentDetails.network]?.blockExplorers?.default?.url : undefined;
    const txExplorerUrl = networkExplorer && lastTxHash ? `${networkExplorer}/tx/${lastTxHash}` : undefined;
    const showWalletConnectArea = !props.posMode && paymentStatus !== "expired" && props.checkoutData.organizationId !== "f58cf6b3-b87d-4893-b859-cddc85ac0abf" && !!managedDisplayMethod?.isWalletSupported && !isBitcoinNetwork;
    const shouldUseManagedStepShellFlow = !!props.checkoutData.gateway.managed && !props.posMode;
    const selectedMethodInitialAmount = (0, $bnENU.useMemo)(()=>{
        if (!selectedMethod) return "\u2014";
        return formatCrypto8((0, $94d9469e1ad800ce$export$61a490a80c552550)(totalSum, props.currency, selectedMethod.ticker, priceQuotes, props.checkoutData.chargeCustomerNetworkFee));
    }, [
        priceQuotes,
        props.checkoutData.chargeCustomerNetworkFee,
        props.currency,
        selectedMethod,
        totalSum
    ]);
    const selectedMethodRecurringAmount = (0, $bnENU.useMemo)(()=>{
        if (!selectedMethod) return "\u2014";
        return formatCrypto8((0, $94d9469e1ad800ce$export$61a490a80c552550)(recurringSum, props.currency, selectedMethod.ticker, priceQuotes, false));
    }, [
        priceQuotes,
        props.currency,
        recurringSum,
        selectedMethod
    ]);
    const shellInputStyle = {
        minHeight: 44,
        borderRadius: 10,
        fontSize: 15,
        lineHeight: 1.3,
        padding: "10px 12px",
        borderColor: "#d8dee9",
        backgroundColor: "#ffffff"
    };
    const inputValidationStyle = (hasError, baseStyle = shellInputStyle)=>({
            ...baseStyle,
            ...hasError ? (0, $196480508fc60042$export$15a6a1d6cb047a38) : undefined
        });
    const shellLabelStyle = {
        fontSize: 14,
        fontWeight: 500,
        color: "#495774"
    };
    const primaryButtonStyle = {
        width: "100%",
        minHeight: 46,
        borderRadius: 11,
        fontWeight: 500,
        background: props.checkoutData.customizations?.primaryButtonColor,
        color: getContrastColor(props.checkoutData.customizations?.primaryButtonColor) ?? "#ffffff"
    };
    const secondaryButtonStyle = {
        borderColor: "#d9e0eb",
        color: "#4c5c78",
        background: "#ffffff",
        borderRadius: 10,
        minHeight: 40,
        fontSize: 14,
        fontWeight: 500
    };
    const receiptEmailFromInput = (0, $bnENU.useMemo)(()=>{
        const inputEmail = localInputFields.find((field)=>field.dataType === "Email");
        const fallback = typeof inputEmail?.value === "string" ? inputEmail.value.trim() : "";
        const travelRuleEmail = travelRuleFields.emailAddress?.trim();
        const checkoutEmail = props.checkoutData.travelRuleEmail?.trim();
        return travelRuleEmail ?? checkoutEmail ?? fallback ?? "";
    }, [
        localInputFields,
        props.checkoutData.travelRuleEmail,
        travelRuleFields.emailAddress
    ]);
    const formatSelectableAmount = (value)=>{
        if (!Number.isFinite(value)) return "\u2014";
        return formatCrypto8(value);
    };
    const focusFirstInvalidInputField = (index)=>{
        window.requestAnimationFrame(()=>{
            const fieldElement = inputRefs.current[index] ?? document.querySelector(`[data-input-field-index="${index}"]`);
            fieldElement?.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            if (fieldElement?.matches("input")) fieldElement.focus();
            else fieldElement?.querySelector('input, button, [tabindex]:not([tabindex="-1"])')?.focus();
        });
    };
    const validateRequiredInputFields = ()=>{
        const firstInvalidIndex = localInputFields.findIndex((field)=>$06825994d276e479$var$inputFieldValidationError(field) !== undefined);
        if (firstInvalidIndex >= 0) {
            setInputFieldValidationAttempted(true);
            focusFirstInvalidInputField(firstInvalidIndex);
            return false;
        }
        setInputFieldValidationAttempted(false);
        return true;
    };
    const handleInputFieldsContinue = ()=>{
        if (!validateRequiredInputFields()) return;
        setInputFieldsConfirmed(true);
    };
    const validateSubscriptionStep = ()=>{
        if (selectedSubscriptionType === undefined) {
            setSubscriptionValidationError("Choose how to pay for future renewals.");
            return false;
        }
        const emailRequired = selectedSubscriptionType === 0 || selectedSubscriptionType === 1 && receiveEmailNotifications;
        const emailValue = subscriptionEmailAddress.trim();
        if (emailRequired && emailValue.length === 0) {
            setSubscriptionValidationError("Enter email address.");
            return false;
        }
        if (emailValue.length > 0 && !(0, $8d017118df5fe2e5$export$1e21512880529eb2)(emailValue)) {
            setSubscriptionValidationError("Enter a valid email address.");
            return false;
        }
        setSubscriptionValidationError("");
        return true;
    };
    const renderCustomInputFields = ({ showIntro: showIntro = true } = {})=>{
        if (!props.checkoutData.inputFields || props.checkoutData.inputFields.length === 0) return null;
        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$FormSection, {
            children: [
                showIntro && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: $06825994d276e479$var$CHECKOUT_SPACING.xs
                    },
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SectionTitle, {
                            children: "Payer details"
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SectionHelper, {
                            children: "Enter required details before choosing a payment method."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$FormFieldStack, {
                    children: localInputFields.map((field, index)=>{
                        const validationError = inputFieldValidationAttempted ? $06825994d276e479$var$inputFieldValidationError(field) : undefined;
                        const hasValidationError = Boolean(validationError);
                        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            "data-input-field-index": index,
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                            style: shellLabelStyle,
                                            children: field.inputLabel === "" ? "Input label" : field.inputLabel
                                        }),
                                        !field.isRequired && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$bd0cf18531183c14), {
                                            children: "Optional"
                                        })
                                    ]
                                }),
                                field.dataType === "Boolean" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10,
                                        minHeight: 48,
                                        border: hasValidationError ? "1px solid #df1b41" : "1px solid transparent",
                                        boxShadow: hasValidationError ? (0, $196480508fc60042$export$15a6a1d6cb047a38).boxShadow : undefined,
                                        borderRadius: 10,
                                        padding: "0 10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $f56970af37249378$export$2e2bcd8739ae039), {
                                            checked: field.value === true,
                                            onClick: ()=>{
                                                const newInputs = localInputFields.slice();
                                                const currentValue = newInputs[index].value === true;
                                                newInputs[index].value = !currentValue;
                                                setLocalInputFields(newInputs);
                                                props.onInputFieldsChange?.(newInputs);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                color: "#1f2937"
                                            },
                                            children: "Enabled"
                                        })
                                    ]
                                }),
                                field.dataType !== "Boolean" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                    disabled: props.isPreProcessingPayment,
                                    type: field.dataType === "Number" ? "number" : "text",
                                    placeholder: field.dataType === "Number" ? "Enter a number" : `Enter ${field.inputLabel.toLowerCase()}`,
                                    value: field.value,
                                    required: field.isRequired,
                                    "aria-invalid": hasValidationError,
                                    style: inputValidationStyle(hasValidationError),
                                    ref: (el)=>inputRefs.current[index] = el,
                                    onInput: (event)=>{
                                        const newInputs = localInputFields.slice();
                                        const value = event.target.value;
                                        if (field.dataType === "Email") newInputs[index].value = value.toLowerCase();
                                        else newInputs[index].value = value;
                                        setLocalInputFields(newInputs);
                                        props.onInputFieldsChange?.(newInputs);
                                    }
                                }),
                                validationError && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                    children: validationError
                                })
                            ]
                        }, `${field.inputLabel}-${index}`);
                    })
                })
            ]
        });
    };
    const handleSelectCurrency = (ticker, logo)=>{
        if (isLoading) return;
        setManagedRouteError("");
        setIsStepTransitioning(true);
        setCurrencySearch("");
        setSelectedTicker(ticker);
        setSelectedTokenImageUrl(logo ?? "");
        setSelectedChainName("");
        setSelectedMethod(undefined);
        if (transitionTimeoutRef.current) clearTimeout(transitionTimeoutRef.current);
        transitionTimeoutRef.current = setTimeout(()=>{
            setIsStepTransitioning(false);
            transitionTimeoutRef.current = null;
        }, $06825994d276e479$var$MANAGED_STEP_TRANSITION_DELAY_MS);
    };
    const redirectToSuccessUrl = ()=>{
        if (!props.checkoutData.successUrl) return;
        const resolved = props.checkoutData.successUrl.replace("{CHECKOUT_SESSION_ID}", props.checkoutData.id);
        window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(resolved);
    };
    if ((!props.isSuccess || props.managedPaymentDetails) && shouldUseManagedStepShellFlow) {
        if (checkoutState === 0 && trfWidget) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Wrapper, {
            disableAnimation: props.disableAnimation,
            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Container, {
                disableAnimation: props.disableAnimation,
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepShell, {
                    compact: true,
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeader, {
                            compact: true,
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepEyebrow, {
                                    children: "Secure checkout"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepTitle, {
                                    compact: true,
                                    children: "Billing information"
                                })
                            ]
                        }),
                        trfWidget
                    ]
                }, "billing-information")
            })
        });
        if (!props.managedPaymentDetails && managedSubscriptionState === undefined && localInputFields.length > 0 && !inputFieldsConfirmed) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Wrapper, {
            disableAnimation: props.disableAnimation,
            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Container, {
                disableAnimation: props.disableAnimation,
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepShell, {
                    compact: true,
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeader, {
                            compact: true,
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepEyebrow, {
                                    children: "Secure checkout"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepTitle, {
                                    compact: true,
                                    children: "Payer details"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepSubtitle, {
                                    children: "Confirm your details before choosing a payment method."
                                })
                            ]
                        }),
                        renderCustomInputFields({
                            showIntro: false
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                            style: primaryButtonStyle,
                            disabled: props.isPreProcessingPayment,
                            onClick: handleInputFieldsContinue,
                            children: "Continue"
                        })
                    ]
                }, "payer-details")
            })
        });
        if (!props.managedPaymentDetails && managedSubscriptionState === undefined) {
            const showCurrencySelection = !selectedTicker && currencyOptions.length > 1 && !isStepTransitioning;
            const showNetworkSelection = !!selectedTicker && selectedTickerNetworkOptions.length > 1 && !selectedMethod && !isStepTransitioning;
            const showPreparingState = isStepTransitioning || !showCurrencySelection && !showNetworkSelection;
            const stepTransitionKey = showCurrencySelection ? "currency" : showNetworkSelection ? "network" : "preparing";
            const selectedCurrencyMeta = currencyOptions.find((option)=>option.ticker === selectedTicker);
            return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Wrapper, {
                disableAnimation: props.disableAnimation,
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Container, {
                    disableAnimation: props.disableAnimation,
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepShell, {
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeader, {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepEyebrow, {
                                        children: "Secure checkout"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepTitle, {
                                        children: showNetworkSelection ? "Choose network" : "Choose how to pay"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepSubtitle, {
                                        children: showNetworkSelection ? `Select the network you'll use to send ${selectedTicker}.` : "Select the cryptocurrency you want to use for this payment."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepTransitionFrame, {
                                children: [
                                    showCurrencySelection && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$FormSection, {
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectorTools, {
                                            children: [
                                                showCurrencySearch && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectorSearchInput, {
                                                    placeholder: "Search currencies",
                                                    value: currencySearch,
                                                    onInput: (event)=>setCurrencySearch(event.target.value)
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableList, {
                                                    children: filteredCurrencyOptions.length > 0 ? filteredCurrencyOptions.map((option)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRow, {
                                                            selected: selectedTicker === option.ticker,
                                                            disabled: isLoading || props.isPreProcessingPayment,
                                                            onClick: ()=>handleSelectCurrency(option.ticker, option.logo),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRowLeft, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRowIcon, {
                                                                            src: option.logo
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRowText, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRowTitle, {
                                                                                    children: option.displayName
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRowMeta, {
                                                                                    children: [
                                                                                        option.ticker,
                                                                                        option.networkCount > 1 ? ` \xb7 ${option.networkCount} networks` : " \xb7 1 network"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRowValue, {
                                                                    children: [
                                                                        formatSelectableAmount(option.amount),
                                                                        " ",
                                                                        option.ticker
                                                                    ]
                                                                })
                                                            ]
                                                        }, option.ticker)) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            padding: "18px 20px",
                                                            fontSize: 14,
                                                            color: "#64748b"
                                                        },
                                                        children: "No currencies match your search."
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    showNetworkSelection && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$FormSection, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableList, {
                                                children: selectedTickerNetworkOptions.map((option)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRow, {
                                                        selected: selectedChainName === option.networkName,
                                                        disabled: isLoading || props.isPreProcessingPayment,
                                                        onClick: ()=>{
                                                            proceedWithManagedMethod(option.method);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRowLeft, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$PaymentMethodIcon, {
                                                                        method: option.method
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRowText, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRowTitle, {
                                                                                children: option.networkName
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRowMeta, {
                                                                                children: option.method.ticker
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 8
                                                                },
                                                                children: [
                                                                    option.isTestnet && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Badge, {
                                                                        children: "Testnet"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRowValue, {
                                                                        children: [
                                                                            formatSelectableAmount(option.amount),
                                                                            " ",
                                                                            option.method.ticker
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, option.optionKey))
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                style: secondaryButtonStyle,
                                                onClick: ()=>{
                                                    setSelectedTicker("");
                                                    setSelectedChainName("");
                                                    setSelectedMethod(undefined);
                                                },
                                                disabled: isLoading || props.isPreProcessingPayment,
                                                children: "Back to currencies"
                                            })
                                        ]
                                    }),
                                    showPreparingState && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$FormSection, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailsBlock, {
                                                children: [
                                                    displayManagedMethods.length === 0 ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                                children: "Payment method"
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailValue, {
                                                                children: "No crypto methods available"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                                children: "Selected currency"
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailValue, {
                                                                children: selectedCurrencyMeta?.displayName ?? "Preparing payment options"
                                                            })
                                                        ]
                                                    }),
                                                    selectedCurrencyMeta && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                                children: "Amount due"
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                                children: [
                                                                    formatSelectableAmount(selectedCurrencyMeta.amount),
                                                                    " ",
                                                                    selectedCurrencyMeta.ticker
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$LoadingStateGroup, {
                                                children: managedRouteError.length > 0 || props.errorMessage ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SectionHelper, {
                                                    style: {
                                                        color: "#b45309",
                                                        textAlign: "center"
                                                    },
                                                    children: managedRouteError || props.errorMessage
                                                }) : displayManagedMethods.length === 0 ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SectionHelper, {
                                                    style: {
                                                        textAlign: "center"
                                                    },
                                                    children: "Please refresh or try another checkout method."
                                                }) : isStepTransitioning || isLoading || isLoadingPriceQuotes ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$LoaderWrapper, {}),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SectionHelper, {
                                                            style: {
                                                                textAlign: "center"
                                                            },
                                                            children: "Preparing your payment route..."
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SectionHelper, {
                                                    style: {
                                                        textAlign: "center"
                                                    },
                                                    children: "Preparing your payment route..."
                                                })
                                            }),
                                            (Boolean(selectedTicker) || selectedMethod !== undefined) && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                style: secondaryButtonStyle,
                                                onClick: resetManagedPaymentSelection,
                                                children: "Change payment method"
                                            })
                                        ]
                                    })
                                ]
                            }, stepTransitionKey)
                        ]
                    }, "payment-method-selection")
                })
            });
        }
        if (!props.managedPaymentDetails && managedSubscriptionState === 0 && selectedMethod) {
            const selectedNetworkName = selectedMethod.tokenInfo?.networkName ?? selectedMethod.name;
            const subscriptionIntervalLabel = (0, $afdf282d9c361d03$export$d82eb24974fa9fd)(recurringInterval() * 86400).toLowerCase();
            const canUseAutopay = (0, $5760199798158999$export$aab47327b38c6232)(selectedMethod);
            const showNotificationEmailField = selectedSubscriptionType === 1 && (receiveEmailNotifications || subscriptionEmailAddress.length === 0);
            return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Wrapper, {
                disableAnimation: props.disableAnimation,
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Container, {
                    disableAnimation: props.disableAnimation,
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepShell, {
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeader, {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepEyebrow, {
                                        children: "Secure checkout"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepTitle, {
                                        children: "Set up your subscription"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepSubtitle, {
                                        children: "Choose how you'd like to pay future renewals."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailsBlock, {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Payment method"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailValue, {
                                                children: selectedMethod.ticker
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Network"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailValue, {
                                                children: selectedNetworkName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "First payment"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                children: [
                                                    selectedMethodInitialAmount,
                                                    " ",
                                                    selectedMethod.ticker
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Recurring payment"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                children: [
                                                    selectedMethodRecurringAmount,
                                                    " ",
                                                    selectedMethod.ticker,
                                                    " / ",
                                                    subscriptionIntervalLabel
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$FormSection, {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableList, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRow, {
                                                selected: selectedSubscriptionType === 1,
                                                disabled: !canUseAutopay || props.isPreProcessingPayment || isLoadingAllowance,
                                                onClick: ()=>{
                                                    if (!canUseAutopay) return;
                                                    setSubscriptionValidationError("");
                                                    setSelectedSubscriptionType(1);
                                                    const { emailAddress: emailAddress } = travelRuleFields;
                                                    const { travelRuleEmail: travelRuleEmail } = props.checkoutData;
                                                    const trfEmail = emailAddress ?? travelRuleEmail ?? "";
                                                    setSubscriptionEmailAddress(trfEmail);
                                                },
                                                style: !canUseAutopay ? {
                                                    opacity: 0.5,
                                                    cursor: "not-allowed"
                                                } : undefined,
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRowLeft, {
                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRowText, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRowTitle, {
                                                                    children: "Auto-renew with wallet"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRowMeta, {
                                                                    children: "Set an allowance once and let future renewals be charged automatically."
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    !canUseAutopay && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Badge, {
                                                        children: "Unavailable"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRow, {
                                                selected: selectedSubscriptionType === 0,
                                                disabled: props.isPreProcessingPayment || isLoadingAllowance,
                                                onClick: ()=>{
                                                    setSubscriptionValidationError("");
                                                    setSelectedSubscriptionType(0);
                                                    const { emailAddress: emailAddress } = travelRuleFields;
                                                    const { travelRuleEmail: travelRuleEmail } = props.checkoutData;
                                                    const trfEmail = emailAddress ?? travelRuleEmail ?? "";
                                                    setSubscriptionEmailAddress(trfEmail);
                                                },
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRowLeft, {
                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$SelectableRowText, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRowTitle, {
                                                                children: "Email invoices"
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SelectableRowMeta, {
                                                                children: "Receive renewal invoices by email and pay each billing cycle manually."
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    selectedSubscriptionType === undefined && subscriptionValidationError && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                        children: subscriptionValidationError
                                    }),
                                    selectedSubscriptionType === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$FormFieldStack, {
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: $06825994d276e479$var$CHECKOUT_SPACING.xs
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                    style: shellLabelStyle,
                                                    children: "Email address"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                    autoFocus: true,
                                                    placeholder: "Enter email address",
                                                    value: subscriptionEmailAddress,
                                                    "aria-invalid": Boolean(subscriptionValidationError),
                                                    style: inputValidationStyle(Boolean(subscriptionValidationError)),
                                                    onChange: (e)=>{
                                                        setSubscriptionValidationError("");
                                                        setSubscriptionEmailAddress(e.target.value.toLowerCase());
                                                    }
                                                }),
                                                subscriptionValidationError && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                                    children: subscriptionValidationError
                                                })
                                            ]
                                        })
                                    }),
                                    selectedSubscriptionType === 1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$FormFieldStack, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("label", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 10,
                                                    color: "#475569",
                                                    cursor: "pointer",
                                                    fontSize: 14
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $f56970af37249378$export$2e2bcd8739ae039), {
                                                        checked: receiveEmailNotifications
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        children: "Send me email notifications about this subscription"
                                                    })
                                                ]
                                            }),
                                            showNotificationEmailField && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: $06825994d276e479$var$CHECKOUT_SPACING.xs
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                        style: shellLabelStyle,
                                                        children: "Email address"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                        autoFocus: true,
                                                        placeholder: "Enter email address",
                                                        value: subscriptionEmailAddress,
                                                        "aria-invalid": Boolean(subscriptionValidationError),
                                                        style: inputValidationStyle(Boolean(subscriptionValidationError)),
                                                        onChange: (e)=>{
                                                            setSubscriptionValidationError("");
                                                            setSubscriptionEmailAddress(e.target.value.toLowerCase());
                                                        }
                                                    }),
                                                    subscriptionValidationError && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                                        children: subscriptionValidationError
                                                    })
                                                ]
                                            }),
                                            address && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$PaymentDetailsBlock, {
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                            children: "Connected wallet"
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailValue, {
                                                            children: (0, $8d017118df5fe2e5$export$193698062786be9a)(address, 8)
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$CTASection, {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                        isLoading: isLoadingPriceQuotes || isSettingAllowance || props.isPreProcessingPayment || isLoadingAllowance,
                                        disabled: props.isPreProcessingPayment || isLoadingPriceQuotes || isSettingAllowance || isLoadingAllowance,
                                        style: primaryButtonStyle,
                                        onClick: async ()=>{
                                            if (!validateSubscriptionStep()) return;
                                            if (selectedSubscriptionType === 1 && !isConnected) {
                                                await open();
                                                return;
                                            }
                                            if (!selectedMethod || selectedSubscriptionType === undefined) return;
                                            props.onCheckout({
                                                managed: {
                                                    selectedMethod: selectedMethod
                                                },
                                                priceQuotes: priceQuotes,
                                                subscriptionOptions: {
                                                    autopay: selectedSubscriptionType === 1 ? {
                                                        subscriptionType: selectedSubscriptionType,
                                                        address: address
                                                    } : undefined,
                                                    emailInvoice: selectedSubscriptionType === 0 ? {
                                                        subscriptionType: selectedSubscriptionType,
                                                        emailAddress: subscriptionEmailAddress.toLowerCase()
                                                    } : undefined
                                                },
                                                travelRuleFields: travelRuleFields
                                            });
                                        },
                                        children: selectedSubscriptionType === 1 && !isConnected ? "Connect wallet to continue" : "Continue"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                        disabled: isLoadingPriceQuotes || isSettingAllowance || isLoadingAllowance || props.isPreProcessingPayment,
                                        style: secondaryButtonStyle,
                                        onClick: resetManagedPaymentSelection,
                                        children: "Change payment method"
                                    })
                                ]
                            })
                        ]
                    }, "subscription-setup")
                })
            });
        }
        if (!props.managedPaymentDetails && managedSubscriptionState === 2 && selectedMethod) {
            const selectedNetworkName = selectedMethod.tokenInfo?.networkName ?? selectedMethod.name;
            const subscriptionIntervalLabel = (0, $afdf282d9c361d03$export$d82eb24974fa9fd)(recurringInterval() * 86400).toLowerCase();
            return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Wrapper, {
                disableAnimation: props.disableAnimation,
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Container, {
                    disableAnimation: props.disableAnimation,
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepShell, {
                        compact: true,
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeader, {
                                compact: true,
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepEyebrow, {
                                        children: "Secure checkout"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepTitle, {
                                        compact: true,
                                        children: "Approve recurring payments"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepSubtitle, {
                                        compact: true,
                                        children: "Set an allowance once so future renewals can be charged automatically."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailsBlock, {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Initial payment"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                children: [
                                                    selectedMethodInitialAmount,
                                                    " ",
                                                    selectedMethod.ticker
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Recurring payment"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                children: [
                                                    selectedMethodRecurringAmount,
                                                    " ",
                                                    selectedMethod.ticker,
                                                    " / ",
                                                    subscriptionIntervalLabel
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Network"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailValue, {
                                                children: selectedNetworkName
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$CTASection, {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                        isLoading: isLoadingPriceQuotes || isSettingAllowance,
                                        style: primaryButtonStyle,
                                        onClick: ()=>{
                                            setManagedSubscriptionAllowance();
                                        },
                                        children: "Set allowance"
                                    }),
                                    allowSkipAllowance && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                        disabled: isLoadingPriceQuotes || isSettingAllowance,
                                        style: secondaryButtonStyle,
                                        onClick: ()=>setManagedSubscriptionState(1),
                                        children: "Continue without allowance"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                        disabled: isLoadingPriceQuotes || isSettingAllowance,
                                        style: secondaryButtonStyle,
                                        onClick: resetManagedPaymentSelection,
                                        children: "Change payment method"
                                    })
                                ]
                            })
                        ]
                    }, "subscription-allowance")
                })
            });
        }
        if (!props.managedPaymentDetails && managedSubscriptionState === 1 && selectedMethod) {
            const selectedNetworkName = selectedMethod.tokenInfo?.networkName ?? selectedMethod.name;
            const subscriptionIntervalLabel = (0, $afdf282d9c361d03$export$d82eb24974fa9fd)(recurringInterval() * 86400).toLowerCase();
            return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Wrapper, {
                disableAnimation: props.disableAnimation,
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Container, {
                    disableAnimation: props.disableAnimation,
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepShell, {
                        compact: true,
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeader, {
                                compact: true,
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepEyebrow, {
                                        children: "Secure checkout"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepTitle, {
                                        compact: true,
                                        children: "Review subscription"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepSubtitle, {
                                        compact: true,
                                        children: "Confirm the first payment and the recurring renewal schedule."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailsBlock, {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Initial payment"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                children: [
                                                    selectedMethodInitialAmount,
                                                    " ",
                                                    selectedMethod.ticker
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Recurring payment"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                children: [
                                                    selectedMethodRecurringAmount,
                                                    " ",
                                                    selectedMethod.ticker,
                                                    " / ",
                                                    subscriptionIntervalLabel
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Starts"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailValue, {
                                                children: nextBillingAt()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Network"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailValue, {
                                                children: selectedNetworkName
                                            })
                                        ]
                                    }),
                                    address && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                children: "Wallet"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$MonoValue, {
                                                children: (0, $8d017118df5fe2e5$export$193698062786be9a)(address, 8)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$CTASection, {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                        isLoading: isLoadingPriceQuotes || props.isPreProcessingPayment || isSigningMessage,
                                        style: primaryButtonStyle,
                                        onClick: async ()=>{
                                            if (!isConnected) {
                                                await open();
                                                return;
                                            }
                                            if (!props.tokenDelegatePaymentDetails || !address) return;
                                            setIsSigningMessage(true);
                                            try {
                                                const chain = (0, $5760199798158999$export$cc4208a8ebc9f985)[props.tokenDelegatePaymentDetails.network];
                                                const provider = await connector?.getProvider();
                                                const signer = (0, $bf4e0381e2c41280$export$362b8ea2edbd9090)({
                                                    chain: chain,
                                                    transport: (0, $c1b76a8a2251eb69$export$4c00f665f0d4b443)(provider)
                                                });
                                                const signature = await signer?.signMessage({
                                                    account: address,
                                                    message: props.tokenDelegatePaymentDetails.messageToSign
                                                });
                                                props.onCheckout({
                                                    travelRuleFields: travelRuleFields,
                                                    completeTokenDelegate: {
                                                        paymentId: props.tokenDelegatePaymentDetails.paymentId,
                                                        signature: signature
                                                    },
                                                    priceQuotes: priceQuotes
                                                });
                                            } catch (err) {
                                                (0, $8d017118df5fe2e5$export$6badb0ecde4e0bd0)(err.toString());
                                            }
                                            setIsSigningMessage(false);
                                        },
                                        children: isConnected ? "Subscribe" : "Connect wallet to subscribe"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                        style: secondaryButtonStyle,
                                        disabled: isLoadingPriceQuotes || props.isPreProcessingPayment || isSigningMessage,
                                        onClick: resetManagedPaymentSelection,
                                        children: "Change payment method"
                                    })
                                ]
                            })
                        ]
                    }, "subscription-confirm")
                })
            });
        }
        if (props.managedPaymentDetails) {
            const showReviewStep = isUnderReview;
            const showPendingStep = !showReviewStep && !hasConfirmedPayment && !isUnderpaid && hasPaymentDetected;
            const showSuccessStep = !showReviewStep && hasConfirmedPayment;
            const isExpired = paymentStatus === "expired";
            const paymentAmountNumber = Number(paymentAmount || 0);
            const amountDueText = formatSelectableAmount(paymentAmountNumber);
            const amountLeftText = formatSelectableAmount(Number(amountLeft || 0));
            const pendingTotalText = formatSelectableAmount(pendingAmount);
            const confirmedTotalText = formatSelectableAmount(confirmedAmount > 0 ? confirmedAmount : paymentAmountNumber);
            const amountRemainingText = formatSelectableAmount(amountRemaining);
            const displayNetworkName = paymentNetworkName ?? props.managedPaymentDetails.network;
            const displayNetworkIcon = managedDisplayMethod ? $06825994d276e479$var$getNetworkLogoForMethod(managedDisplayMethod) : undefined;
            const canDisplayQr = props.checkoutData.customizations?.displayQrCode !== false;
            const shouldShowQr = canDisplayQr && (!isMobilePaymentViewport || showMobileQr);
            const canChangePaymentMethod = displayManagedMethods.length > 1;
            return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Wrapper, {
                disableAnimation: props.disableAnimation,
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Container, {
                    disableAnimation: props.disableAnimation,
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepShell, {
                        children: [
                            showSuccessStep && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeader, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepEyebrow, {
                                                children: "Payment confirmed"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepTitle, {
                                                children: "Payment received"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepSubtitle, {
                                                children: "Your payment has been confirmed and the merchant can now process your order."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            width: 64,
                                            height: 64,
                                            borderRadius: 32,
                                            border: "1px solid #ccead9",
                                            background: "#eaf8f0",
                                            color: "#1f9d58",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: 28,
                                            fontWeight: 600,
                                            margin: "0 auto"
                                        },
                                        children: "\u2713"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailsBlock, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Amount paid"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        children: [
                                                            confirmedTotalText,
                                                            " ",
                                                            paymentTicker
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Network"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 8
                                                        },
                                                        children: [
                                                            displayNetworkIcon && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                src: displayNetworkIcon,
                                                                style: {
                                                                    width: 16,
                                                                    height: 16,
                                                                    borderRadius: 999
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                children: displayNetworkName
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            receiptRecipientName.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Recipient"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailValue, {
                                                        children: receiptRecipientName
                                                    })
                                                ]
                                            }),
                                            paymentAddress.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Recipient address"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 6
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$MonoValue, {
                                                                title: paymentAddress,
                                                                children: (0, $8d017118df5fe2e5$export$193698062786be9a)(paymentAddress)
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$4f2558dd25106ae2, {
                                                                onClick: async ()=>{
                                                                    navigator.clipboard.writeText(paymentAddress);
                                                                },
                                                                style: {
                                                                    padding: "3px 6px",
                                                                    fontSize: 10
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            receiptEmailFromInput.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Receipt"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailValue, {
                                                        children: receiptEmailFromInput
                                                    })
                                                ]
                                            }),
                                            paymentReference.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Payment ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 6
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$MonoValue, {
                                                                title: paymentReference,
                                                                children: (0, $8d017118df5fe2e5$export$193698062786be9a)(paymentReference)
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$4f2558dd25106ae2, {
                                                                onClick: async ()=>{
                                                                    navigator.clipboard.writeText(paymentReference);
                                                                },
                                                                style: {
                                                                    padding: "3px 6px",
                                                                    fontSize: 10
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            lastTxHash && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Transaction Hash"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 6
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$MonoValue, {
                                                                title: lastTxHash,
                                                                children: (0, $8d017118df5fe2e5$export$193698062786be9a)(lastTxHash)
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$4f2558dd25106ae2, {
                                                                onClick: async ()=>{
                                                                    navigator.clipboard.writeText(lastTxHash);
                                                                },
                                                                style: {
                                                                    padding: "3px 6px",
                                                                    fontSize: 10
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$CTASection, {
                                        children: [
                                            !!props.checkoutData.successUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                style: primaryButtonStyle,
                                                onClick: redirectToSuccessUrl,
                                                children: "Return to merchant"
                                            }),
                                            txExplorerUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("a", {
                                                href: txExplorerUrl,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                style: {
                                                    textAlign: "center",
                                                    color: "#3f6bf5",
                                                    textDecoration: "none",
                                                    fontSize: 14,
                                                    fontWeight: 500
                                                },
                                                children: "View payment details"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showReviewStep && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeader, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepEyebrow, {
                                                children: "Payment received"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepTitle, {
                                                children: "Payment under review"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepSubtitle, {
                                                children: "We've received your payment. It's going through a routine compliance check before it is released to the merchant."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "center",
                                            margin: 20
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$LoaderWrapper, {})
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailsBlock, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Amount paid"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        children: [
                                                            confirmedTotalText,
                                                            " ",
                                                            paymentTicker
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Network"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 8
                                                        },
                                                        children: [
                                                            displayNetworkIcon && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                src: displayNetworkIcon,
                                                                style: {
                                                                    width: 16,
                                                                    height: 16,
                                                                    borderRadius: 999
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                children: displayNetworkName
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            paymentReference.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Payment ID"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 6
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$MonoValue, {
                                                                title: paymentReference,
                                                                children: (0, $8d017118df5fe2e5$export$193698062786be9a)(paymentReference)
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$4f2558dd25106ae2, {
                                                                onClick: async ()=>{
                                                                    navigator.clipboard.writeText(paymentReference);
                                                                },
                                                                style: {
                                                                    padding: "3px 6px",
                                                                    fontSize: 10
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            lastTxHash && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Transaction Hash"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 6
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$MonoValue, {
                                                                title: lastTxHash,
                                                                children: (0, $8d017118df5fe2e5$export$193698062786be9a)(lastTxHash)
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$4f2558dd25106ae2, {
                                                                onClick: async ()=>{
                                                                    navigator.clipboard.writeText(lastTxHash);
                                                                },
                                                                style: {
                                                                    padding: "3px 6px",
                                                                    fontSize: 10
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showPendingStep && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeader, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepEyebrow, {
                                                children: "Secure checkout"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepTitle, {
                                                children: isAwaitingConfirmation ? "Confirming your payment" : "Waiting for payment"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepSubtitle, {
                                                children: isAwaitingConfirmation ? "We\u2019ve received your transfer and are confirming it. This page updates automatically." : "We\u2019re watching the blockchain for your transaction."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$LoaderWrapper, {})
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StatusTimeline, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StatusTimelineRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StatusDot, {
                                                        state: "done"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        children: "Payment detected"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StatusTimelineRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StatusDot, {
                                                        state: hasConfirmedPayment ? "done" : "active"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        children: "Waiting for confirmations"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StatusTimelineRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StatusDot, {
                                                        state: hasConfirmedPayment ? "done" : "pending"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        children: "Confirmed"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailsBlock, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Amount due"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        children: [
                                                            amountDueText,
                                                            " ",
                                                            paymentTicker
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: isAwaitingConfirmation ? "Received" : "Detected so far"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        children: [
                                                            isAwaitingConfirmation ? confirmedTotalText : pendingTotalText,
                                                            " ",
                                                            paymentTicker
                                                        ]
                                                    })
                                                ]
                                            }),
                                            amountRemaining > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Remaining"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        children: [
                                                            amountRemainingText,
                                                            " ",
                                                            paymentTicker
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                        children: "Network"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 8
                                                        },
                                                        children: [
                                                            displayNetworkIcon && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                src: displayNetworkIcon,
                                                                style: {
                                                                    width: 16,
                                                                    height: 16,
                                                                    borderRadius: 999
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                children: displayNetworkName
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SectionHelper, {
                                        style: {
                                            textAlign: "center"
                                        },
                                        children: "Keep this page open. This page updates automatically."
                                    })
                                ]
                            }),
                            !showSuccessStep && !showPendingStep && !showReviewStep && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeader, {
                                        compact: true,
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepHeaderTopRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepEyebrow, {
                                                        children: "Secure checkout"
                                                    }),
                                                    !isExpired && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$HeaderStatusPill, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$TimerPillIcon, {
                                                                "aria-hidden": true
                                                            }),
                                                            "Time remaining",
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                children: $06825994d276e479$export$8e3f267d166b4a05(secondsRemaining)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepTitle, {
                                                style: {
                                                    marginTop: 6
                                                },
                                                children: isExpired ? "Payment window expired" : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                                    children: [
                                                        isUnderpaid ? `Complete your ${paymentTicker} payment` : `Pay with ${paymentTicker}`,
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$StepTitleMeta, {
                                                            children: [
                                                                displayNetworkIcon && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                    src: displayNetworkIcon,
                                                                    alt: displayNetworkName
                                                                }),
                                                                `on ${displayNetworkName}`
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            isExpired && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepSubtitle, {
                                                children: "This payment session has expired. Refresh to generate a new payment request."
                                            }),
                                            !isExpired && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$StepSubtitle, {
                                                compact: true,
                                                children: isUnderpaid ? "Send the remaining balance to complete your order." : "Connect your wallet, scan the QR code, or send the exact amount below."
                                            })
                                        ]
                                    }),
                                    !isExpired && isUnderpaid && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$UnderpaidNotice, {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$UnderpaidNoticeHeader, {
                                                children: "Underpaid payment"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$UnderpaidNoticeBody, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        children: "We've received your payment, but it was under the required amount. Please send the remaining balance to complete your order."
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailsBlock, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                                        children: "Amount due"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                                        children: [
                                                                            amountDueText,
                                                                            " ",
                                                                            paymentTicker
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                                        children: "Amount received"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                                        children: [
                                                                            confirmedTotalText,
                                                                            " ",
                                                                            paymentTicker
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetailRow, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                                        children: "Amount remaining"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$DetailValue, {
                                                                        children: [
                                                                            amountRemainingText,
                                                                            " ",
                                                                            paymentTicker
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    pendingAmount > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$SectionHelper, {
                                                        children: "We've detected another transaction and are waiting for it to confirm. This page updates automatically."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !isExpired && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentStepColumn, {
                                        children: [
                                            showWalletConnectArea && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentHeroActions, {
                                                style: {
                                                    width: "100%",
                                                    maxWidth: 500,
                                                    alignSelf: "center",
                                                    paddingTop: 4
                                                },
                                                children: [
                                                    !managedDisplayMethod?.isSolana && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$WalletConnectSection, {
                                                        children: [
                                                            isConnected && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$ConnectedWalletContainer, {
                                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        border: "1px solid #d3dbea",
                                                                        borderRadius: 12
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                            style: {
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                                padding: 12,
                                                                                backgroundColor: "#f3f6fc",
                                                                                borderTopLeftRadius: 12,
                                                                                borderTopRightRadius: 12
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                    style: {
                                                                                        fontSize: 13,
                                                                                        color: "#4f5f7b"
                                                                                    },
                                                                                    children: "Connected wallet"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                                                    style: {
                                                                                        border: 0,
                                                                                        padding: 0,
                                                                                        color: "#4f5f7b",
                                                                                        fontSize: 11,
                                                                                        textTransform: "uppercase"
                                                                                    },
                                                                                    onClick: ()=>disconnect(),
                                                                                    children: "Disconnect"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                padding: 12,
                                                                                fontSize: 14
                                                                            },
                                                                            children: address
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                                isLoading: isManagedEVMTxLoading,
                                                                style: {
                                                                    ...primaryButtonStyle,
                                                                    minHeight: 54
                                                                },
                                                                onClick: ()=>{
                                                                    onClickOpenWallet();
                                                                },
                                                                children: isConnected ? "Pay with connected wallet" : "Connect wallet to pay"
                                                            })
                                                        ]
                                                    }),
                                                    managedDisplayMethod?.isSolana && amountLeftPaymentDetails && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$WalletConnectSection, {
                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $ad5727fe9615d0d0$export$2e2bcd8739ae039), {
                                                            managedPaymentDetails: amountLeftPaymentDetails,
                                                            isLoading: isManagedEVMTxLoading,
                                                            setIsLoading: setIsManagedEVMTxLoading,
                                                            primaryButtonColor: props.checkoutData.customizations?.primaryButtonColor
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$PaymentFlowDivider, {
                                                children: "or pay manually"
                                            }),
                                            canDisplayQr && isMobilePaymentViewport && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$QrDisclosureButton, {
                                                expanded: showMobileQr,
                                                onClick: ()=>setShowMobileQr((current)=>!current),
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {}),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        children: showMobileQr ? "Hide QR code" : "Display QR code"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$ManualPaymentCard, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$ManualPaymentGrid, {
                                                        hasQr: shouldShowQr,
                                                        children: [
                                                            shouldShowQr && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$QrHero, {
                                                                clickable: !isMobilePaymentViewport,
                                                                onClick: ()=>{
                                                                    if (!isMobilePaymentViewport) setIsDesktopQrModalVisible(true);
                                                                },
                                                                onKeyDown: (e)=>{
                                                                    if (!isMobilePaymentViewport && (e.key === "Enter" || e.key === " ")) {
                                                                        e.preventDefault();
                                                                        setIsDesktopQrModalVisible(true);
                                                                    }
                                                                },
                                                                type: "button",
                                                                "aria-label": isMobilePaymentViewport ? undefined : "Open larger QR code",
                                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$QrHeroVisual, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$QrHeroImage, {
                                                                            src: managedPaymentQrCode
                                                                        }),
                                                                        !isMobilePaymentViewport && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$QrHeroHint, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $aac8e983fd3225f1$export$2e2bcd8739ae039), {}),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                    children: "Enlarge"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$ManualPaymentInfoColumn, {
                                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$HeroAmountSection, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$HeroAmountHeader, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$HeroAmountLabel, {
                                                                                    children: isUnderpaid ? "Amount remaining" : "Amount due"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$4f2558dd25106ae2, {
                                                                                    onClick: async ()=>{
                                                                                        navigator.clipboard.writeText(amountLeft);
                                                                                    },
                                                                                    style: {
                                                                                        padding: "3px 6px",
                                                                                        fontSize: 10
                                                                                    }
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$HeroAmount, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$HeroAmountValue, {
                                                                                    children: amountLeftText
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$HeroAmountTicker, {
                                                                                    children: paymentTicker
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$ManualInfoDivider, {}),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$ManualPaymentAddressSection, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$DetailLabel, {
                                                                style: {
                                                                    textTransform: "uppercase",
                                                                    letterSpacing: "0.02em",
                                                                    fontWeight: 600
                                                                },
                                                                children: "Payment address"
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentAddressField, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$PaymentAddressValue, {
                                                                        children: $06825994d276e479$var$formatPaymentAddressForDisplay(paymentAddress)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$4f2558dd25106ae2, {
                                                                        onClick: async ()=>{
                                                                            navigator.clipboard.writeText(paymentAddress);
                                                                        },
                                                                        style: {
                                                                            position: "absolute",
                                                                            top: 10,
                                                                            right: 10,
                                                                            padding: "4px 8px",
                                                                            fontSize: 10
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$ManualPaymentFooter, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$ManualNoticeIcon, {}),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                children: `Send the exact amount on ${displayNetworkName} only.`
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !isMobilePaymentViewport && !!managedPaymentQrCode && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $91a7bca2e0a02780$export$2e2bcd8739ae039), {
                                                visible: isDesktopQrModalVisible,
                                                onClose: ()=>setIsDesktopQrModalVisible(false),
                                                title: "Scan to pay",
                                                innerStyles: {
                                                    width: 460,
                                                    maxWidth: "92%",
                                                    borderRadius: 18,
                                                    overflow: "hidden",
                                                    boxShadow: "0 28px 72px rgba(15, 23, 42, 0.18)",
                                                    background: "linear-gradient(180deg, #f7fbff 0%, #ffffff 42%)"
                                                },
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$QrModalBody, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$QrModalGlow, {
                                                            "aria-hidden": true
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$QrModalDetails, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$QrModalMetaPill, {
                                                                    children: [
                                                                        displayNetworkIcon && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                            src: displayNetworkIcon,
                                                                            alt: displayNetworkName
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            children: `${paymentTicker} on ${displayNetworkName}`
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$QrModalAmountBlock, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$QrModalAmountLabel, {
                                                                            children: isUnderpaid ? "Amount remaining" : "Amount due"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$QrModalAmount, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                    children: amountLeftText
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$QrModalAmountTicker, {
                                                                                    children: paymentTicker
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$QrModalFrame, {
                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$QrModalImage, {
                                                                src: managedPaymentQrCode
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$QrModalCaption, {
                                                            children: "Scan this code with your wallet app to prefill the payment address and exact amount."
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$CTASection, {
                                        children: [
                                            !isExpired && canChangePaymentMethod && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                style: secondaryButtonStyle,
                                                onClick: resetManagedPaymentSelection,
                                                children: "Change payment method"
                                            }),
                                            isExpired && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                style: primaryButtonStyle,
                                                onClick: ()=>window.location.reload(),
                                                children: "Reload payment"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, "payment-instructions")
                })
            });
        }
    }
    // -------------------------------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$Wrapper, {
        disableAnimation: props.disableAnimation,
        children: [
            props.isSuccess && props.successElement,
            trfWidget ?? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                children: !props.isSuccess && props.checkoutData.gateway.managed && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$Container, {
                    disableAnimation: props.disableAnimation,
                    children: [
                        // -----------------------------------------------------------------------------------------------------------
                        !props.managedPaymentDetails && managedSubscriptionState === undefined && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$Container, {
                            disableAnimation: props.disableAnimation,
                            children: [
                                props.checkoutData.inputFields && props.checkoutData.inputFields.length > 0 && !props.isSuccess && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                    style: {
                                        width: "100%",
                                        display: "grid",
                                        gap: 20,
                                        paddingBottom: 25,
                                        borderBottom: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED}`
                                    },
                                    children: // ---------------------------------------------------------------------------------------------------
                                    // Render zero or more custom input fields
                                    localInputFields.map((c, i)=>{
                                        const validationError = inputFieldValidationAttempted ? $06825994d276e479$var$inputFieldValidationError(c) : undefined;
                                        const hasValidationError = Boolean(validationError);
                                        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            "data-input-field-index": i,
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 8
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                            children: c.inputLabel === "" ? "Input label" : c.inputLabel
                                                        }),
                                                        !c.isRequired && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$bd0cf18531183c14), {
                                                            children: "Optional"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    children: [
                                                        // Matching travel-rule values may seed blank custom fields, but customers can still edit them.
                                                        c.dataType === "Email" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                            disabled: props.isPreProcessingPayment,
                                                            ref: (el)=>inputRefs.current[i] = el,
                                                            placeholder: `Enter ${c.inputLabel.toLowerCase()}`,
                                                            value: c.value,
                                                            required: c.isRequired,
                                                            "aria-invalid": hasValidationError,
                                                            style: inputValidationStyle(hasValidationError, {}),
                                                            onInput: (e)=>{
                                                                const newInputs = localInputFields.slice();
                                                                newInputs[i].value = e.target.value.toLowerCase();
                                                                setLocalInputFields(newInputs);
                                                                props.onInputFieldsChange?.(newInputs);
                                                            }
                                                        }),
                                                        // Matching travel-rule values may seed blank custom fields, but customers can still edit them.
                                                        c.dataType === "String" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                            disabled: props.isPreProcessingPayment,
                                                            ref: (el)=>inputRefs.current[i] = el,
                                                            placeholder: `Enter ${c.inputLabel.toLowerCase()}`,
                                                            value: c.value,
                                                            required: c.isRequired,
                                                            "aria-invalid": hasValidationError,
                                                            style: inputValidationStyle(hasValidationError, {}),
                                                            onInput: (e)=>{
                                                                const newInputs = localInputFields.slice();
                                                                newInputs[i].value = e.target.value;
                                                                setLocalInputFields(newInputs);
                                                                props.onInputFieldsChange?.(newInputs);
                                                            }
                                                        }),
                                                        c.dataType === "Number" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                            disabled: props.isPreProcessingPayment,
                                                            type: "number",
                                                            value: c.value,
                                                            ref: (el)=>inputRefs.current[i] = el,
                                                            required: c.isRequired,
                                                            placeholder: "Enter a number",
                                                            "aria-invalid": hasValidationError,
                                                            style: inputValidationStyle(hasValidationError, {}),
                                                            onInput: (e)=>{
                                                                const val = e.target.value;
                                                                const newInputs = localInputFields.slice();
                                                                newInputs[i].value = val;
                                                                setLocalInputFields(newInputs);
                                                                props.onInputFieldsChange?.(newInputs);
                                                            }
                                                        })
                                                    ]
                                                }),
                                                validationError && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                                    children: validationError
                                                })
                                            ]
                                        }, i);
                                    })
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("style", {
                                            children: `
                  @keyframes fadeSlideIn {
                    from {opacity:0;transform:translateY(6px)}
                    to {opacity:1;transform:none}
                  }
                  .pm-list {
                    animation:fadeSlideIn .15s ease-out;
                    overflow: hidden;
                  }

                  @keyframes fadeSlideUp {
                    from {opacity: 0; transform: translateY(10px);}
                    to {opacity: 1; transform: none;}
                  }

                  .pm-sublist.fade-in {
                    animation: fadeSlideUp 0.35s ease-out;
                  }

                  .pm-row {
                    position:relative;
                    border-radius:10px;
                    transition:background-color .18s ease,border-color .18s ease;
                    border: 1px solid transparent;
                    overflow: hidden;
                  }
                  .pm-row:hover {
                    background:#f8fafd;
                    border-color:#e8edf6;
                    overflow: hidden;
                  }
                  .pm-row:focus-visible {
                    outline: 2px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE5};
                    outline-offset: -2px;
                  }

                  @keyframes fadeRowUp {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: none; }
                  }

                  .pm-row.fade-in-row {}

                  .chevron {
                    transform:rotate(270deg);
                    transition:transform .35s cubic-bezier(.45,.05,.25,1),fill .35s cubic-bezier(.45,.05,.25,1);
                  }
                `
                                        }),
                                        isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                width: "15px",
                                                height: "15px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                margin: "0 auto"
                                            },
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$LoaderWrapper, {})
                                        }),
                                        !isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10,
                                                paddingBottom: 10
                                            },
                                            children: [
                                                !selectedMethod && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                        style: {
                                                            textAlign: "left",
                                                            margin: "0",
                                                            fontSize: 14,
                                                            paddingBottom: 10,
                                                            color: "#4f5c70",
                                                            opacity: 1,
                                                            fontWeight: 600
                                                        },
                                                        children: [
                                                            selectedTicker && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                                                className: "chevron",
                                                                onClick: ()=>{
                                                                    setSelectedTicker("");
                                                                    setSelectedChainName("");
                                                                    setSelectedMethod(undefined);
                                                                },
                                                                fill: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                                style: {
                                                                    width: 14,
                                                                    height: 14,
                                                                    transform: "rotate(90deg)",
                                                                    cursor: "pointer",
                                                                    marginRight: 5
                                                                }
                                                            }),
                                                            !selectedTicker ? "Select payment currency" : "Select Payment Network for",
                                                            selectedTicker && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 5
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                        src: selectedTokenImageUrl ?? "",
                                                                        style: {
                                                                            height: 25,
                                                                            width: 25,
                                                                            borderRadius: 10,
                                                                            opacity: 1
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                        style: {
                                                                            textTransform: "capitalize",
                                                                            color: "black"
                                                                        },
                                                                        children: selectedTicker
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    className: "pm-list",
                                                    style: {
                                                        border: "1px solid",
                                                        borderColor: "#dbe2ef",
                                                        borderBottom: "none",
                                                        borderRadius: 12,
                                                        maxHeight: 340,
                                                        overflow: "hidden",
                                                        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)"
                                                    },
                                                    children: [
                                                        props.checkoutData.gateway.managed.methods.filter((m)=>!(0, $5760199798158999$export$53becfa3eb141e16)(m.network, m.token)).length === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                fontSize: 14,
                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                                margin: 20
                                                            },
                                                            children: "No available payment methods"
                                                        }),
                                                        !selectedTicker && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                                                            children: Array.from(new Map(props.checkoutData.gateway.managed.methods.filter((m)=>!(0, $5760199798158999$export$53becfa3eb141e16)(m.network, m.token)).map((m)=>{
                                                                const mm = (0, $5760199798158999$export$8793fab959da70d1)(m.network, m.token);
                                                                if (mm.ticker === "ETH") {
                                                                    if (mm.tokenInfo) mm.tokenInfo.logo = (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports)));
                                                                    else mm.logo = (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports)));
                                                                }
                                                                let discountAmount = 0;
                                                                if (m.discountPercentOff) discountAmount = m.discountPercentOff;
                                                                else if (props.discount) {
                                                                    const model = props.discount.model;
                                                                    if (model.modelType === "percentage") discountAmount = Number(model.amountOff) / 100;
                                                                    else if (model.modelType === "fixed") {
                                                                        const fixedAmount = Number(model.amountOff);
                                                                        const converted = (0, $94d9469e1ad800ce$export$61a490a80c552550)(fixedAmount, props.currency, mm.ticker, priceQuotes, false);
                                                                        discountAmount = converted / (0, $94d9469e1ad800ce$export$61a490a80c552550)(totalSum, props.currency, mm.ticker, priceQuotes, false);
                                                                        discountAmount = Math.min(discountAmount, 1);
                                                                    }
                                                                }
                                                                return [
                                                                    mm.ticker,
                                                                    {
                                                                        method: mm,
                                                                        discountAmount: discountAmount
                                                                    }
                                                                ];
                                                            })).values()).map(({ method: method, discountAmount: discountAmount }, i, arr)=>{
                                                                const isSelected = selectedTicker === method.ticker;
                                                                const isLast = arr.length >= 3 && i === arr.length - 1;
                                                                const selectTicker = ()=>{
                                                                    if (!validateRequiredInputFields()) return;
                                                                    setInputFieldsConfirmed(true);
                                                                    const willSelect = !isSelected;
                                                                    setSelectedTicker(willSelect ? method.ticker : "");
                                                                    setSelectedTokenImageUrl(method.logo || "");
                                                                    setSelectedChainName("");
                                                                    setSelectedMethod(undefined);
                                                                };
                                                                return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    className: `pm-row ${isLast ? "fade-in-row" : ""}`,
                                                                    "data-selected": isSelected,
                                                                    role: "button",
                                                                    tabIndex: 0,
                                                                    "aria-label": `Select ${method.ticker} payment method`,
                                                                    style: {
                                                                        padding: 13,
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        borderBottom: "1px solid #edf1f7",
                                                                        cursor: "pointer"
                                                                    },
                                                                    onClick: selectTicker,
                                                                    onKeyDown: (e)=>onKeyboardSelect(e, selectTicker),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                            style: {
                                                                                display: "flex",
                                                                                gap: 15
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                    style: {
                                                                                        width: 30,
                                                                                        height: 30,
                                                                                        borderRadius: 15,
                                                                                        background: `center/contain no-repeat url(${method.logo || ""})`
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                                    style: {
                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        gap: 2
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                                            style: {
                                                                                                display: "flex",
                                                                                                gap: 5,
                                                                                                alignItems: "center"
                                                                                            },
                                                                                            children: [
                                                                                                (()=>{
                                                                                                    const hasQuotes = !!priceQuotes && priceQuotes.length > 0 && !isLoadingPriceQuotes;
                                                                                                    const baseVal = hasQuotes ? (0, $94d9469e1ad800ce$export$61a490a80c552550)(totalSum, props.currency, method.ticker, priceQuotes, props.checkoutData.chargeCustomerNetworkFee) : null;
                                                                                                    const discountedVal = hasQuotes ? (0, $94d9469e1ad800ce$export$61a490a80c552550)(totalSum, props.currency, method.ticker, priceQuotes, props.checkoutData.chargeCustomerNetworkFee, discountAmount) : null;
                                                                                                    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                                                                                        children: [
                                                                                                            discountAmount > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                                                style: {
                                                                                                                    textDecoration: "line-through",
                                                                                                                    opacity: 0.5
                                                                                                                },
                                                                                                                children: hasQuotes ? formatCrypto8(baseVal) : "\u2014"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                                                children: hasQuotes ? formatCrypto8(discountedVal) : isLoadingPriceQuotes ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {}) : "\u2014"
                                                                                                            })
                                                                                                        ]
                                                                                                    });
                                                                                                })(),
                                                                                                discountAmount > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                                    style: {
                                                                                                        padding: "2px 6px",
                                                                                                        fontSize: 11,
                                                                                                        fontWeight: 600,
                                                                                                        background: "#e9f8ef",
                                                                                                        border: "1px solid #bce6ca",
                                                                                                        borderRadius: 999,
                                                                                                        textTransform: "uppercase",
                                                                                                        color: "#256c44"
                                                                                                    },
                                                                                                    children: props.discount && props.discount.model.modelType === "percentage" ? `${Number(props.discount.model.amountOff)}% off` : props.discount ? `-${Number(props.discount.model.amountOff)} ${props.currency}` : ""
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                            style: {
                                                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).INPUT_PLACEHOLDER,
                                                                                                fontSize: 12
                                                                                            },
                                                                                            children: method.ticker
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                                                            className: "chevron",
                                                                            fill: isSelected ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK,
                                                                            style: {
                                                                                width: 15,
                                                                                height: 15,
                                                                                transform: isSelected ? "rotate(0deg)" : "rotate(270deg)"
                                                                            }
                                                                        })
                                                                    ]
                                                                }, i);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            className: "pm-sublist",
                                                            children: selectedTicker && !selectedMethod && Array.from(new Map(props.checkoutData.gateway.managed.methods.filter((m)=>!(0, $5760199798158999$export$53becfa3eb141e16)(m.network, m.token) && (0, $5760199798158999$export$8793fab959da70d1)(m.network, m.token).ticker === selectedTicker).map((m)=>{
                                                                const mm = (0, $5760199798158999$export$8793fab959da70d1)(m.network, m.token);
                                                                const uniqueKey = `${m.network}-${m.token ?? "null"}`;
                                                                return [
                                                                    uniqueKey,
                                                                    {
                                                                        method: mm
                                                                    }
                                                                ];
                                                            })).values()).map(({ method: method }, i)=>{
                                                                const networkName = method.tokenInfo?.networkName ?? method.name;
                                                                const isSelected = selectedChainName === networkName;
                                                                const selectNetwork = async ()=>{
                                                                    if (isLoading || isSelected) return;
                                                                    if (!validateRequiredInputFields()) return;
                                                                    setInputFieldsConfirmed(true);
                                                                    await proceedWithManagedMethod(method);
                                                                };
                                                                return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    className: "pm-row",
                                                                    "data-selected": isSelected,
                                                                    role: "button",
                                                                    tabIndex: isLoading ? -1 : 0,
                                                                    "aria-disabled": isLoading || isSelected,
                                                                    "aria-label": `Pay with ${method.ticker} on ${networkName}`,
                                                                    style: {
                                                                        padding: 13,
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        borderBottom: "1px solid #edf1f7",
                                                                        cursor: `${isSelected || isLoading ? "not-allowed" : "pointer"}`,
                                                                        pointerEvents: isLoading ? "none" : "auto"
                                                                    },
                                                                    onClick: ()=>{
                                                                        selectNetwork();
                                                                    },
                                                                    onKeyDown: (e)=>onKeyboardSelect(e, ()=>{
                                                                            selectNetwork();
                                                                        }),
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                            style: {
                                                                                display: "flex",
                                                                                gap: 15
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$PaymentMethodIcon, {
                                                                                    method: method,
                                                                                    size: 30
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                                    style: {
                                                                                        display: "flex",
                                                                                        flexDirection: "column",
                                                                                        gap: 2
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                            style: {
                                                                                                fontSize: 14,
                                                                                                fontWeight: 500,
                                                                                                textTransform: "capitalize"
                                                                                            },
                                                                                            children: networkName
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                            style: {
                                                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).INPUT_PLACEHOLDER,
                                                                                                fontSize: 12
                                                                                            },
                                                                                            children: method.ticker
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                                                            className: "chevron",
                                                                            fill: isSelected ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK,
                                                                            style: {
                                                                                width: 15,
                                                                                height: 15
                                                                            }
                                                                        })
                                                                    ]
                                                                }, i);
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        // -----------------------------------------------------------------------------------------------------------
                        !props.managedPaymentDetails && managedSubscriptionState === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$Container, {
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            children: "Payment method"
                                        }),
                                        selectedMethod && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 15,
                                                alignItems: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        width: 30,
                                                        height: 30,
                                                        backgroundImage: `url(${selectedMethod.logo})`,
                                                        backgroundSize: "contain",
                                                        backgroundPosition: "center",
                                                        backgroundRepeat: "no-repeat",
                                                        position: "relative"
                                                    },
                                                    children: selectedMethod.tokenInfo && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            background: "rgba(255, 255, 255, 0.95)",
                                                            borderRadius: "100%",
                                                            width: 15,
                                                            height: 15,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            position: "absolute",
                                                            bottom: -1,
                                                            right: -5,
                                                            boxShadow: "0 0 1px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                width: 10,
                                                                height: 10,
                                                                backgroundImage: `url(${selectedMethod.tokenInfo.logo})`,
                                                                backgroundSize: "contain",
                                                                backgroundPosition: "center",
                                                                backgroundRepeat: "no-repeat"
                                                            }
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "column"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                            },
                                                            children: selectedMethod.ticker
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                            },
                                                            children: selectedMethod.tokenInfo?.networkName ?? selectedMethod.name
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 15
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            children: "Select subscription type"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                    disabled: props.isPreProcessingPayment || isLoadingAllowance || !(0, $5760199798158999$export$aab47327b38c6232)(selectedMethod),
                                                    style: {
                                                        background: "none",
                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                        justifyContent: "flex-start",
                                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                        padding: 20,
                                                        borderRadius: 5,
                                                        fontSize: 14
                                                    },
                                                    onClick: ()=>{
                                                        setSubscriptionValidationError("");
                                                        setSelectedSubscriptionType(1);
                                                        const { emailAddress: emailAddress } = travelRuleFields;
                                                        const { travelRuleEmail: travelRuleEmail } = props.checkoutData;
                                                        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                                                        const trfEmail = emailAddress || travelRuleEmail || "";
                                                        setSubscriptionEmailAddress(trfEmail);
                                                    },
                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 10,
                                                            justifyContent: "space-between",
                                                            width: "100%"
                                                        },
                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $f56970af37249378$export$2e2bcd8739ae039), {
                                                                    isRadio: true,
                                                                    checked: selectedSubscriptionType === 1
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "flex-start"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                textAlign: "left"
                                                                            },
                                                                            children: "Subscribe with auto renew"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                opacity: 0.5,
                                                                                textAlign: "left"
                                                                            },
                                                                            children: "Set an alllowance and automatically pay"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                    disabled: props.isPreProcessingPayment || isLoadingAllowance,
                                                    style: {
                                                        background: "none",
                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                        justifyContent: "flex-start",
                                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                        padding: 20,
                                                        borderRadius: 5,
                                                        fontSize: 14
                                                    },
                                                    onClick: ()=>{
                                                        setSubscriptionValidationError("");
                                                        setSelectedSubscriptionType(0);
                                                        // Fill the subscription invoice email address with the travel rule fields email address
                                                        // If the email address has not been collected as part of the travel rule fields, then its because
                                                        // we already have that value from a previous checkout and therefore it has been supplied by the
                                                        // backend
                                                        const { emailAddress: emailAddress } = travelRuleFields;
                                                        const { travelRuleEmail: travelRuleEmail } = props.checkoutData;
                                                        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                                                        const trfEmail = emailAddress || travelRuleEmail || "";
                                                        setSubscriptionEmailAddress(trfEmail);
                                                    },
                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 10,
                                                            justifyContent: "space-between",
                                                            width: "100%"
                                                        },
                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $f56970af37249378$export$2e2bcd8739ae039), {
                                                                    isRadio: true,
                                                                    checked: selectedSubscriptionType === 0
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "flex-start"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                textAlign: "left"
                                                                            },
                                                                            children: "Subscribe with email invoices"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                opacity: 0.5,
                                                                                textAlign: "left"
                                                                            },
                                                                            children: "Manually pay using email invoices"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        selectedSubscriptionType === undefined && subscriptionValidationError && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                            children: subscriptionValidationError
                                        }),
                                        selectedSubscriptionType === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    children: "Email address"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                    autoFocus: true,
                                                    placeholder: "Enter email address",
                                                    value: subscriptionEmailAddress,
                                                    "aria-invalid": Boolean(subscriptionValidationError),
                                                    style: inputValidationStyle(Boolean(subscriptionValidationError), {}),
                                                    onChange: (e)=>{
                                                        setSubscriptionValidationError("");
                                                        setSubscriptionEmailAddress(e.target.value.toLowerCase());
                                                    }
                                                }),
                                                subscriptionValidationError && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                                    children: subscriptionValidationError
                                                })
                                            ]
                                        }),
                                        selectedSubscriptionType === 1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        gap: 8,
                                                        alignItems: "center",
                                                        cursor: "pointer"
                                                    },
                                                    onClick: ()=>setReceiveEmailNotifications(!receiveEmailNotifications),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $f56970af37249378$export$2e2bcd8739ae039), {
                                                            checked: receiveEmailNotifications
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            children: "Send me email notifications about my subscription"
                                                        })
                                                    ]
                                                }),
                                                receiveEmailNotifications && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                    autoFocus: true,
                                                    placeholder: "Enter email address",
                                                    value: subscriptionEmailAddress,
                                                    "aria-invalid": Boolean(subscriptionValidationError),
                                                    style: inputValidationStyle(Boolean(subscriptionValidationError), {}),
                                                    onChange: (e)=>{
                                                        setSubscriptionValidationError("");
                                                        setSubscriptionEmailAddress(e.target.value.toLowerCase());
                                                    }
                                                }),
                                                subscriptionValidationError && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                                    children: subscriptionValidationError
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                selectedSubscriptionType === 1 && address && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$ConnectedWalletContainer, {
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                            borderRadius: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    padding: 15,
                                                    backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            fontSize: 14
                                                        },
                                                        children: "Connected wallet"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                        style: {
                                                            border: 0,
                                                            padding: 0,
                                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                            fontSize: 10,
                                                            textTransform: "uppercase"
                                                        },
                                                        onClick: ()=>disconnect(),
                                                        children: "Disconnect"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                style: {
                                                    padding: 15
                                                },
                                                children: address
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                    isLoading: isLoadingPriceQuotes || isSettingAllowance || props.isPreProcessingPayment || isLoadingAllowance,
                                    disabled: isLoadingPriceQuotes || isSettingAllowance || props.isPreProcessingPayment || isLoadingAllowance,
                                    style: {
                                        background: props.checkoutData.customizations?.primaryButtonColor,
                                        color: getContrastColor(props.checkoutData.customizations?.primaryButtonColor),
                                        width: "100%",
                                        margin: "auto"
                                    },
                                    onClick: async ()=>{
                                        if (!validateSubscriptionStep()) return;
                                        if (selectedSubscriptionType === 1 && !isConnected) return await open();
                                        if (!selectedMethod || selectedSubscriptionType === undefined) return;
                                        props.onCheckout({
                                            managed: {
                                                selectedMethod: selectedMethod
                                            },
                                            priceQuotes: priceQuotes,
                                            subscriptionOptions: {
                                                autopay: selectedSubscriptionType === 1 ? {
                                                    subscriptionType: selectedSubscriptionType,
                                                    address: address
                                                } : undefined,
                                                emailInvoice: selectedSubscriptionType === 0 ? {
                                                    subscriptionType: selectedSubscriptionType,
                                                    emailAddress: subscriptionEmailAddress.toLowerCase()
                                                } : undefined
                                            },
                                            travelRuleFields: travelRuleFields
                                        });
                                    },
                                    children: selectedSubscriptionType === 1 && !isConnected ? "Approve payment" : "Continue"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                    disabled: isLoadingPriceQuotes || isSettingAllowance || isLoadingAllowance || props.isPreProcessingPayment,
                                    style: {
                                        border: 0,
                                        padding: 5,
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                    },
                                    onClick: resetManagedPaymentSelection,
                                    children: "Change payment method"
                                })
                            ]
                        }),
                        // -----------------------------------------------------------------------------------------------------------
                        !props.managedPaymentDetails && (managedSubscriptionState === 2 || managedSubscriptionState === 1) && selectedMethod && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$Container, {
                            style: {
                                gap: 30
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        userSelect: "none",
                                        alignItems: "center",
                                        gap: 10,
                                        padding: 15,
                                        borderRadius: 5,
                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED}`
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 5,
                                                flexShrink: 0,
                                                padding: "0 20px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        display: "flex",
                                                        borderRadius: "100%",
                                                        width: 20,
                                                        height: 20,
                                                        backgroundColor: managedSubscriptionState === 1 ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS_LIGHT : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NICE_GREEN,
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                        color: "white",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        transition: "0.2s ease all"
                                                    },
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 16,
                                                        fontWeight: managedSubscriptionState === 1 ? 300 : 400,
                                                        color: managedSubscriptionState === 1 ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                        transition: "0.2s ease all"
                                                    },
                                                    children: "Set allowance"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                width: "100%",
                                                backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK,
                                                height: 2,
                                                borderRadius: 2,
                                                flexGrow: 1,
                                                transition: "0.2s ease all"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 5,
                                                flexShrink: 0,
                                                padding: "0 20px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        display: "flex",
                                                        borderRadius: "100%",
                                                        width: 20,
                                                        height: 20,
                                                        backgroundColor: managedSubscriptionState === 1 ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NICE_GREEN : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                        color: "white",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        transition: "0.2s ease all"
                                                    },
                                                    children: "2"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 16,
                                                        fontWeight: managedSubscriptionState === 1 ? 400 : 300
                                                    },
                                                    children: "Subscribe"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                managedSubscriptionState === 2 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10,
                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                borderRadius: 5
                                            },
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                children: "Set an allowance to enable automatically recurring payments for your subscription."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                    isLoading: isLoadingPriceQuotes || isSettingAllowance,
                                                    style: {
                                                        background: props.checkoutData.customizations?.primaryButtonColor,
                                                        width: "100%",
                                                        margin: "auto"
                                                    },
                                                    onClick: ()=>{
                                                        setManagedSubscriptionAllowance();
                                                    },
                                                    children: "Set allowance"
                                                }),
                                                allowSkipAllowance && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                    disabled: isLoadingPriceQuotes || isSettingAllowance,
                                                    style: {
                                                        padding: 5,
                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                        borderColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK
                                                    },
                                                    onClick: ()=>setManagedSubscriptionState(1),
                                                    children: "Skip"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                    disabled: isLoadingPriceQuotes || isSettingAllowance,
                                                    style: {
                                                        border: 0,
                                                        padding: 5,
                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                    },
                                                    onClick: resetManagedPaymentSelection,
                                                    children: "Change payment method"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                managedSubscriptionState === 1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$Container, {
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                boxShadow: `0 0 3px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                borderRadius: 5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED,
                                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                        borderTopLeftRadius: 5,
                                                        borderTopRightRadius: 5,
                                                        padding: 10
                                                    },
                                                    children: "Initial payment"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        gap: 15,
                                                        alignItems: "center",
                                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                        padding: 15,
                                                        borderTop: 0,
                                                        borderBottomLeftRadius: 5,
                                                        borderBottomRightRadius: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                width: 30,
                                                                height: 30,
                                                                backgroundImage: `url(${selectedMethod.logo})`,
                                                                backgroundSize: "contain",
                                                                backgroundPosition: "center",
                                                                backgroundRepeat: "no-repeat",
                                                                position: "relative"
                                                            },
                                                            children: selectedMethod.tokenInfo && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                style: {
                                                                    background: "rgba(255, 255, 255, 0.95)",
                                                                    borderRadius: "100%",
                                                                    width: 15,
                                                                    height: 15,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    position: "absolute",
                                                                    bottom: -1,
                                                                    right: -5,
                                                                    boxShadow: "0 0 1px"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                    style: {
                                                                        width: 10,
                                                                        height: 10,
                                                                        backgroundImage: `url(${selectedMethod.tokenInfo.logo})`,
                                                                        backgroundSize: "contain",
                                                                        backgroundPosition: "center",
                                                                        backgroundRepeat: "no-repeat"
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        gap: 5,
                                                                        alignItems: "center"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                fontSize: 16
                                                                            },
                                                                            children: isLoadingPriceQuotes ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {}) : formatCrypto8((0, $94d9469e1ad800ce$export$61a490a80c552550)(totalSum, props.currency, selectedMethod.ticker, priceQuotes, false))
                                                                        }),
                                                                        props.checkoutData.chargeCustomerNetworkFee && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                    children: "+"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                                    style: {
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        gap: 4,
                                                                                        backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED,
                                                                                        borderRadius: 5,
                                                                                        padding: "2px 6px",
                                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $47c8fb8b4a8751d5$export$2e2bcd8739ae039), {
                                                                                            style: {
                                                                                                height: 10
                                                                                            },
                                                                                            fill: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                            children: gasCost
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        alignItems: "baseline",
                                                                        gap: 3
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                fontSize: 12,
                                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                                            },
                                                                            children: selectedMethod.ticker
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                                            style: {
                                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                                            },
                                                                            children: [
                                                                                "on ",
                                                                                selectedMethod.tokenInfo?.networkName ?? selectedMethod.name
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                boxShadow: `0 0 3px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                borderRadius: 5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                        borderBottom: 0,
                                                        borderTopLeftRadius: 5,
                                                        borderTopRightRadius: 5,
                                                        padding: 10,
                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                        backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST
                                                    },
                                                    children: "Recurring payments"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 10,
                                                        padding: "10px 20px",
                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                        borderTop: 0,
                                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                        borderBottomLeftRadius: 5,
                                                        borderBottomRightRadius: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                width: 20,
                                                                height: 20,
                                                                backgroundImage: `url(${selectedMethod.logo})`,
                                                                backgroundSize: "contain",
                                                                backgroundPosition: "center",
                                                                backgroundRepeat: "no-repeat",
                                                                position: "relative"
                                                            },
                                                            children: selectedMethod.tokenInfo && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                style: {
                                                                    background: "rgba(255, 255, 255, 0.95)",
                                                                    borderRadius: "100%",
                                                                    width: 12,
                                                                    height: 12,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    position: "absolute",
                                                                    bottom: -1,
                                                                    right: -5,
                                                                    boxShadow: "0 0 1px"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                    style: {
                                                                        width: 8,
                                                                        height: 8,
                                                                        backgroundImage: `url(${selectedMethod.tokenInfo.logo})`,
                                                                        backgroundSize: "contain",
                                                                        backgroundPosition: "center",
                                                                        backgroundRepeat: "no-repeat"
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                gap: 3
                                                            },
                                                            children: [
                                                                formatCrypto8((0, $94d9469e1ad800ce$export$61a490a80c552550)(recurringSum, props.currency, selectedMethod.ticker, priceQuotes, false)),
                                                                " ",
                                                                props.checkoutData.chargeCustomerNetworkFee && `+ gas fee per ${(0, $afdf282d9c361d03$export$d82eb24974fa9fd)(recurringInterval() * 86400).toLowerCase()}`,
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    children: "starting"
                                                                }),
                                                                nextBillingAt()
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                    isLoading: isLoadingPriceQuotes || props.isPreProcessingPayment || isSigningMessage,
                                                    style: {
                                                        background: props.checkoutData.customizations?.primaryButtonColor,
                                                        width: "100%",
                                                        margin: "auto"
                                                    },
                                                    onClick: async ()=>{
                                                        if (!props.tokenDelegatePaymentDetails || !address) return;
                                                        setIsSigningMessage(true);
                                                        try {
                                                            const chain = (0, $5760199798158999$export$cc4208a8ebc9f985)[props.tokenDelegatePaymentDetails.network];
                                                            const provider = await connector?.getProvider();
                                                            const signer = (0, $bf4e0381e2c41280$export$362b8ea2edbd9090)({
                                                                chain: chain,
                                                                transport: (0, $c1b76a8a2251eb69$export$4c00f665f0d4b443)(provider)
                                                            });
                                                            const signature = await signer?.signMessage({
                                                                account: address,
                                                                message: props.tokenDelegatePaymentDetails.messageToSign
                                                            });
                                                            props.onCheckout({
                                                                travelRuleFields: travelRuleFields,
                                                                completeTokenDelegate: {
                                                                    paymentId: props.tokenDelegatePaymentDetails.paymentId,
                                                                    signature: signature
                                                                },
                                                                priceQuotes: priceQuotes
                                                            });
                                                        } catch (err) {
                                                            (0, $8d017118df5fe2e5$export$6badb0ecde4e0bd0)(err.toString());
                                                        }
                                                        setIsSigningMessage(false);
                                                    },
                                                    children: "Subscribe"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                    style: {
                                                        border: 0,
                                                        padding: 5,
                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                    },
                                                    disabled: isLoadingPriceQuotes || props.isPreProcessingPayment || isSigningMessage,
                                                    onClick: resetManagedPaymentSelection,
                                                    children: "Change payment method"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        // -----------------------------------------------------------------------------------------------------------
                        props.managedPaymentDetails && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$Container, {
                            style: {
                                overflowWrap: "anywhere",
                                ...props.posMode && {
                                    alignItems: "center",
                                    gap: 60,
                                    overflowWrap: "normal"
                                }
                            },
                            children: [
                                props.posMode && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$export$c825e58f74061357, {
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$b8bb87b40c00c04e, {}),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$6128c696434ef87c, {}),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$bd3f954aa84a63d6, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$Styles, {}),
                                props.posMode && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        fontSize: 12,
                                        gap: 3,
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                opacity: 0.5,
                                                textTransform: "uppercase",
                                                textAlign: props.posMode ? "center" : undefined
                                            },
                                            children: "Time remaining"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                fontSize: 16,
                                                fontWeight: 100,
                                                textAlign: "center"
                                            },
                                            children: $06825994d276e479$export$8e3f267d166b4a05((new Date(props.paymentStatus?.expiresAt ?? props.managedPaymentDetails.expiresAt).getTime() - new Date().getTime()) / 1000)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                fontSize: 20,
                                                fontWeight: 500,
                                                textAlign: "center",
                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                ...props.posMode && {
                                                    marginBottom: 20,
                                                    marginTop: 10
                                                }
                                            },
                                            children: [
                                                "Pay with ",
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                    src: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                    style: {
                                                        height: 20,
                                                        width: "auto",
                                                        paddingLeft: 5
                                                    }
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        color: "black"
                                                    },
                                                    children: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).ticker
                                                }),
                                                " on",
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        color: "black",
                                                        marginLeft: 5
                                                    },
                                                    children: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token)?.tokenInfo?.networkName ?? (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token)?.name
                                                }),
                                                " network"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                fontSize: 14,
                                                textAlign: "center",
                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                marginTop: 10
                                            },
                                            children: "Connect to your wallet, scan the QR code or copy the address to make a payment."
                                        })
                                    ]
                                }),
                                props.paymentStatus?.status !== "expired" && props.checkoutData.customizations?.displayQrCode !== false && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$ec3c7ce6a909733b, {
                                    style: {
                                        margin: "0 auto"
                                    },
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$3c6b4f0e2cd37515, {
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                            src: managedPaymentQrCode,
                                            style: {
                                                width: 150,
                                                height: 150
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        padding: "10px 15px",
                                        borderRadius: 20,
                                        margin: "0 auto",
                                        backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE7,
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE5
                                    },
                                    children: [
                                        "Time Remaining ",
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE4,
                                                fontWeight: 500
                                            },
                                            children: $06825994d276e479$export$8e3f267d166b4a05((new Date(props.paymentStatus?.expiresAt ?? props.managedPaymentDetails.expiresAt).getTime() - new Date().getTime()) / 1000)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 20,
                                        ...props.posMode && {
                                            gap: 40
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                fontSize: 12,
                                                gap: 3,
                                                ...props.posMode && {
                                                    alignItems: "center"
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                opacity: 0.5,
                                                                textTransform: "uppercase"
                                                            },
                                                            children: "Payment address"
                                                        }),
                                                        props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$4f2558dd25106ae2, {
                                                            onClick: async ()=>await navigator.clipboard.writeText(props.managedPaymentDetails?.paymentAddress ?? "")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 16,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 2,
                                                        fontWeight: 100
                                                    },
                                                    children: props.paymentStatus?.status === "expired" ? "Expired" : props.managedPaymentDetails.paymentAddress
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                gap: "20px 40px",
                                                flexWrap: "wrap"
                                            },
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    fontSize: 12,
                                                    gap: 3,
                                                    flexGrow: 1,
                                                    ...props.posMode && {
                                                        alignItems: "center"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                style: {
                                                                    opacity: 0.5,
                                                                    textTransform: "uppercase"
                                                                },
                                                                children: "Amount due"
                                                            }),
                                                            props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$export$4f2558dd25106ae2, {
                                                                onClick: async ()=>await navigator.clipboard.writeText(formatCrypto8(props.managedPaymentDetails?.amount))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            fontSize: 16,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 5,
                                                            fontWeight: 300
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                src: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                                style: {
                                                                    height: 20,
                                                                    width: "auto"
                                                                }
                                                            }),
                                                            formatCrypto8(props.managedPaymentDetails.amount),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                style: {
                                                                    opacity: 0.5,
                                                                    fontWeight: 100
                                                                },
                                                                children: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).ticker
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        props.paymentStatus && props.paymentStatus.transactions.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                borderRadius: 15,
                                                border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED}`,
                                                overflow: "hidden"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        padding: 15,
                                                        backgroundColor: "rgb(255 223 230)"
                                                    },
                                                    children: "Underpaid payment"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        padding: 20,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 20
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            children: "We have received your payment, but it was under the required amount. Please send the remaining balance to complete your order."
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                width: "100%",
                                                                height: 1,
                                                                backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    style: {
                                                                        opacity: 0.5,
                                                                        textTransform: "uppercase",
                                                                        fontSize: 12
                                                                    },
                                                                    children: "Amount remaining"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                        style: {
                                                                            fontSize: 16,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: 5,
                                                                            fontWeight: 300
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                                src: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                                                style: {
                                                                                    height: 20,
                                                                                    width: "auto"
                                                                                }
                                                                            }),
                                                                            formatCrypto8(props.paymentStatus.amountRemaining),
                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                style: {
                                                                                    opacity: 0.5,
                                                                                    fontWeight: 100
                                                                                },
                                                                                children: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).ticker
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        props.paymentStatus && props.paymentStatus.pendingTransactions.length > 0 && props.paymentStatus.transactions.length <= 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($06825994d276e479$var$PaymentDetectedContainer, {
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        padding: 15,
                                                        backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED
                                                    },
                                                    children: "Payment detected"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        padding: 20,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 20
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            children: "Your payment has been detected and is currently pending confirmation."
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                width: "100%",
                                                                height: 1,
                                                                backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    style: {
                                                                        opacity: 0.5,
                                                                        textTransform: "uppercase",
                                                                        fontSize: 12
                                                                    },
                                                                    children: "Amount paid"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                        style: {
                                                                            fontSize: 16,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: 5,
                                                                            fontWeight: 300
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                                src: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                                                style: {
                                                                                    height: 20,
                                                                                    width: "auto"
                                                                                }
                                                                            }),
                                                                            formatCrypto8(props.paymentStatus.pendingTransactions.reduce((s, t)=>s + Number(t.amount), 0)),
                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                style: {
                                                                                    opacity: 0.5,
                                                                                    fontWeight: 100
                                                                                },
                                                                                children: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).ticker
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !props.posMode && props.paymentStatus?.status !== "expired" && props.checkoutData.organizationId !== "f58cf6b3-b87d-4893-b859-cddc85ac0abf" && !isBitcoinNetwork && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                width: "100%",
                                                borderTop: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                paddingTop: 20,
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 20
                                            },
                                            children: [
                                                !selectedMethod?.isSolana && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                                    children: [
                                                        isConnected && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($06825994d276e479$var$ConnectedWalletContainer, {
                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                                    borderRadius: 5
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            padding: 15,
                                                                            backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                style: {
                                                                                    fontSize: 14
                                                                                },
                                                                                children: "Connected wallet"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                                                style: {
                                                                                    border: 0,
                                                                                    padding: 0,
                                                                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                                                    fontSize: 10,
                                                                                    textTransform: "uppercase"
                                                                                },
                                                                                onClick: ()=>disconnect(),
                                                                                children: "Disconnect"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                        style: {
                                                                            padding: 15
                                                                        },
                                                                        children: address
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                            isLoading: isManagedEVMTxLoading,
                                                            onClick: onClickOpenWallet,
                                                            style: {
                                                                width: "100%",
                                                                background: props.checkoutData.customizations?.primaryButtonColor,
                                                                color: getContrastColor(props.checkoutData.customizations?.primaryButtonColor)
                                                            },
                                                            children: isConnected ? "Approve payment" : "Connect wallet"
                                                        })
                                                    ]
                                                }),
                                                selectedMethod?.isSolana && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $ad5727fe9615d0d0$export$2e2bcd8739ae039), {
                                                    managedPaymentDetails: props.managedPaymentDetails,
                                                    isLoading: isManagedEVMTxLoading,
                                                    setIsLoading: setIsManagedEVMTxLoading,
                                                    primaryButtonColor: props.checkoutData.customizations?.primaryButtonColor
                                                })
                                            ]
                                        }),
                                        !props.posMode && props.paymentStatus?.status === "expired" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                width: "100%",
                                                borderTop: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                paddingTop: 20
                                            },
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                onClick: ()=>window.location.reload(),
                                                style: {
                                                    width: "100%",
                                                    background: props.checkoutData.customizations?.primaryButtonColor
                                                },
                                                children: "Reload"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $06825994d276e479$export$2e2bcd8739ae039 = $06825994d276e479$var$PayWidget;





parcelRequire("bnENU");




var $7d1f5c15b23a4e63$exports = {};

$7d1f5c15b23a4e63$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "FRAXLogo.493412e4.svg";


var $d25cb6d9b89fd115$exports = {};

$d25cb6d9b89fd115$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "DaiLogo.5b7d885d.svg";


var $4ab9fc454436f49e$exports = {};

$4ab9fc454436f49e$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "WETH.6226dbd9.svg";


var $8d0b83b880f96eb5$exports = {};

$8d0b83b880f96eb5$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "GeminiLogo.5cbba47e.png";



var $8a03ae73279485df$exports = {};

$8a03ae73279485df$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "TORLogo.bd732ad4.svg";


var $742aee939864354c$exports = {};

$742aee939864354c$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "TUSDLogo.df934baa.svg";


var $1dca8ff814661a4c$exports = {};

$1dca8ff814661a4c$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "USDPLogo.d2d050af.svg";


var $5be97408376d16b3$exports = {};

$5be97408376d16b3$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "TetherGoldLogo.5d02ace7.svg";


var $b1d1642e1e906da0$exports = {};

$b1d1642e1e906da0$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "PRQLogo.ef7c079b.svg";


var $7d9a9ec698a1d03b$exports = {};

$7d9a9ec698a1d03b$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "PAXGLogo.814ce36e.svg";


var $255b0ef38b8c5846$exports = {};

$255b0ef38b8c5846$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "MIMLogo.ea9454b3.svg";



var $9a2a95efb70a21e1$exports = {};

$9a2a95efb70a21e1$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "FantomLogo.59ea410b.svg";


var $314a6c3bb9333527$exports = {};

$314a6c3bb9333527$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "WrappedBitcoin.a9abc558.svg";





var $e080bc482f321354$exports = {};

$e080bc482f321354$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "DAIKLogo.7aa105ad.png";


var $a3ad8e8f2a5f1c45$exports = {};

$a3ad8e8f2a5f1c45$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "ETHKLogo.b79115fc.png";


var $40f35ff09abceecc$exports = {};

$40f35ff09abceecc$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "BTCKLogo.9770427e.png";


var $0387bb37ad65bd8c$exports = {};

$0387bb37ad65bd8c$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "WOKTLogo.2376971f.png";


var $2ecbca6dce07e18a$exports = {};

$2ecbca6dce07e18a$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "OKBLogo.8b0e77b3.png";


const $706108142b0cd8b7$export$8e1e81ac145e31be = {
    USDC: {
        name: "USD Coin",
        ticker: "USDC",
        addresses: {
            1: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
            31337: "0x6d4cc59Ca95Ab85e333a17bAF97a225CA10F292c",
            5: "0x12437ca9aCb41Cc73D1c59E29C7496A054FC8A78",
            80001: "0x8f8b1972eea072C3C228EbE8f9FEADe03927D70F",
            4002: "0x31720c00bD9EDEF0dbcBFcBa20B572c6b950C6Dc",
            11155111: "0xa4fCE8264370437e718aE207805b4e6233638b9E",
            1313161555: "0x0C6013dfdaBF883F3fc2d7D9911f30f54D10E4a6",
            43113: "0x2e9B1F01068B96D7c85913f70Cf29464FA98b567",
            534353: "0x87cba17033bAA29324708dC12503a14C179a00D7",
            137: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
            56: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
            250: "0x04068DA6C83AFCFA0e13ba15A6696662335D5B75",
            43114: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
            66: "0xc946DAf81b08146B1C7A8Da2A851Ddf2B3EAaf85"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
        decimals: {
            default: 6,
            56: 18,
            66: 18
        }
    },
    PAXG: {
        name: "Paxos Gold",
        ticker: "PAXG",
        addresses: {
            1: "0x45804880de22913dafe09f4980848ece6ecbaf78"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($7d9a9ec698a1d03b$exports))),
        decimals: {
            default: 18
        }
    },
    DAIK: {
        name: "DAI",
        ticker: "DAIK",
        pricefeedTicker: "DAI",
        addresses: {
            66: "0x21cDE7E32a6CAF4742d00d44B07279e7596d26B9"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($e080bc482f321354$exports))),
        decimals: {
            default: 18
        }
    },
    ETHK: {
        name: "ETHK",
        ticker: "ETHK",
        pricefeedTicker: "ETH",
        addresses: {
            66: "0xEF71CA2EE68F45B9Ad6F72fbdb33d707b872315C"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($a3ad8e8f2a5f1c45$exports))),
        decimals: {
            default: 18
        }
    },
    WOKT: {
        name: "Wrapped OKT",
        ticker: "WOKT",
        pricefeedTicker: "OKT",
        addresses: {
            66: "0x8F8526dbfd6E38E3D8307702cA8469Bae6C56C15"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($0387bb37ad65bd8c$exports))),
        decimals: {
            default: 18
        }
    },
    XAUT: {
        name: "Tether Gold",
        ticker: "XAUT",
        addresses: {
            1: "0x68749665FF8D2d112Fa859AA293F07A622782F38"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($5be97408376d16b3$exports))),
        decimals: {
            default: 6
        }
    },
    WBTC: {
        name: "Wrapped Bitcoin",
        ticker: "WBTC",
        addresses: {
            1: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
            250: "0x321162Cd933E2Be498Cd2267a90534A804051b11",
            137: "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
            56: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
            43114: "0x50b7545627a5162f82a992c33b87adc75187b218"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($314a6c3bb9333527$exports))),
        decimals: {
            default: 8,
            56: 18
        }
    },
    USDCe: {
        name: "Bridged USDC Coin",
        ticker: "USDC.e",
        pricefeedTicker: "USDC",
        addresses: {
            1313161554: "0xb12bfca5a55806aaf64e99521918a4bf0fc40802",
            43114: "0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($bda59fb5663105ad$exports))),
        decimals: {
            default: 6
        }
    },
    EURT: {
        name: "Euro Tether",
        ticker: "EURT",
        addresses: {
            1: "0xC581b735A1688071A1746c968e0798D642EDE491"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
        decimals: {
            default: 6
        }
    },
    BTCK: {
        name: "BTCK",
        ticker: "BTCK",
        pricefeedTicker: "BTC",
        addresses: {
            66: "0x54e4622DC504176b3BB432dCCAf504569699a7fF"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($40f35ff09abceecc$exports))),
        decimals: {
            default: 18
        }
    },
    OKB: {
        name: "OKB",
        ticker: "OKB",
        addresses: {
            66: "0xdF54B6c6195EA4d948D03bfD818D365cf175cFC2"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($2ecbca6dce07e18a$exports))),
        decimals: {
            default: 18
        }
    },
    EURC: {
        name: "Euro Coin",
        ticker: "EURC",
        addresses: {
            1: "0x1abaea1f7c830bd89acc67ec4af516284b1bc33c"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($076a42c8390623c8$exports))),
        decimals: {
            default: 6
        }
    },
    USDT: {
        name: "Tether USD",
        ticker: "USDT",
        addresses: {
            1: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
            31337: "0x7e05775C8CD424Fc80a0a6B31c7596fdF20B8076",
            5: "0x1AAaF0f10C26E33DBe04d06531E533345CbA755e",
            80001: "0x70BE8802e2F3C6652B7e0814B478f66Ec52d9d88",
            4002: "0xCc8401Fbca27934D4bFC762FEbb667ACdb976F88",
            11155111: "0xE50d86c6dE38F9754f6777d2925377564Bf79482",
            1313161555: "0x7696c118ea37866c38918CAE97C4A9383e8129F6",
            43113: "0x31720c00bD9EDEF0dbcBFcBa20B572c6b950C6Dc",
            534353: "0xA0CA2CdC4291826AAFb0C2DF77f303EdfeA34ef3",
            137: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
            56: "0x55d398326f99059ff775485246999027b3197955",
            43114: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7",
            66: "0x382bB369d343125BfB2117af9c149795C6C65C50"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
        decimals: {
            default: 6,
            56: 18,
            66: 18
        }
    },
    USDTe: {
        name: "Tether USD",
        ticker: "USDT.e",
        pricefeedTicker: "USDT",
        addresses: {
            1313161554: "0x4988a896b1227218e4A686fdE5EabdcAbd91571f",
            43114: "0xc7198437980c041c805a1edcba50c1ce5db95118"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
        decimals: {
            default: 6
        }
    },
    FUSDT: {
        name: "Frapped USDT",
        ticker: "fUSDT",
        pricefeedTicker: "USDT",
        addresses: {
            250: "0x049d68029688eAbF473097a2fC38ef61633A3C7A"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($e608bbb91d2eed9f$exports))),
        decimals: {
            default: 6
        }
    },
    FRAX: {
        name: "FRAX",
        ticker: "FRAX",
        addresses: {
            1: "0x853d955acef822db058eb8505911ed77f175b99e",
            250: "0xdc301622e621166bd8e82f2ca0a26c13ad0be355",
            43114: "0xD24C2Ad096400B6FBcd2ad8B24E7acBc21A1da64"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($7d1f5c15b23a4e63$exports))),
        decimals: {
            default: 18
        }
    },
    WAVAX: {
        name: "Wrapped AVAX",
        ticker: "WAVAX",
        pricefeedTicker: "AVAX",
        addresses: {
            43114: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($0f6589a7fd3dabb4$exports))),
        decimals: {
            default: 18
        }
    },
    USDP: {
        name: "Pax Dollar",
        ticker: "USDP",
        addresses: {
            1: "0x8e870d67f660d95d5be530380d0ec0bd388289e1"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($1dca8ff814661a4c$exports))),
        decimals: {
            default: 18
        }
    },
    TUSD: {
        name: "TrueUSD",
        ticker: "TUSD",
        addresses: {
            1: "0x0000000000085d4780B73119b644AE5ecd22b376"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($742aee939864354c$exports))),
        decimals: {
            default: 18
        }
    },
    MIM: {
        name: "Magic Internet Money",
        ticker: "MIM",
        addresses: {
            250: "0x82f0B8B456c1A451378467398982d4834b6829c1",
            43114: "0x130966628846bfd36ff31a822705796e8cb8c18d"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($255b0ef38b8c5846$exports))),
        decimals: {
            default: 18
        }
    },
    WFTM: {
        name: "Wrapped Fantom",
        ticker: "WFTM",
        pricefeedTicker: "FTM",
        addresses: {
            250: "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($9a2a95efb70a21e1$exports))),
        decimals: {
            default: 18
        }
    },
    DAI: {
        name: "DAI Stablecoin",
        ticker: "DAI",
        addresses: {
            1: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
            31337: "0x3a2F7b4b41706C6A0A60cDf02835321175c919e4",
            5: "0x16246c650be7C4EE01fDE5DAEd829D4C65c09450",
            80001: "0x3C10B58B766F2E9BEE0895cd5654EF8E02Fb6b8B",
            4002: "0x2e9B1F01068B96D7c85913f70Cf29464FA98b567",
            11155111: "0xE76FbC3C71499e0C522F21ad1520825BB7Be6714",
            1313161555: "0xACdC5B8b4cD24D99737116afA55F98D05D853c55",
            43113: "0x04C15309Edf4ff9fcDa1F542CddBd63684bd50f0",
            534353: "0x56F8853aE261FFD95D65131e8525DBd317103664",
            137: "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063",
            56: "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
            1313161554: "0xe3520349F477A5F6EB06107066048508498A291b",
            250: "0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($d25cb6d9b89fd115$exports))),
        decimals: {
            default: 18
        }
    },
    DAIe: {
        name: "DAI Stablecoin",
        ticker: "DAI.e",
        pricefeedTicker: "DAI",
        addresses: {
            43114: "0xd586e7f844cea2f87f50152665bcbc2c279d8d70"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($d25cb6d9b89fd115$exports))),
        decimals: {
            default: 18
        }
    },
    BUSD: {
        name: "Binance USD",
        ticker: "BUSD",
        addresses: {
            56: "0xe9e7cea3dedca5984780bafc599bd69add087d56"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($f37f8496d4380a6d$exports))),
        decimals: {
            default: 18
        }
    },
    BUSDe: {
        name: "Binance USD",
        ticker: "BUSD.e",
        pricefeedTicker: "BUSD",
        addresses: {
            43114: "0x19860ccb0a68fd4213ab9d8266f7bbf05a8dde98"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($f37f8496d4380a6d$exports))),
        decimals: {
            default: 18
        }
    },
    TOR: {
        name: "TOR",
        ticker: "TOR",
        addresses: {
            250: "0x74e23df9110aa9ea0b6ff2faee01e740ca1c642e"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($8a03ae73279485df$exports))),
        decimals: {
            default: 18
        }
    },
    GUSD: {
        name: "Gemini Dollar",
        ticker: "GUSD",
        addresses: {
            1: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
            31337: "0xc9777dd0eCe801171dFedAE50d3FE8f9D03C80F1",
            5: "0xd72301a9aB0583d5294bb4BcAfb3781B14855001",
            80001: "0x1Df991976eFA97dCE09023B702f138F30E3fC8B4",
            4002: "0x04C15309Edf4ff9fcDa1F542CddBd63684bd50f0",
            11155111: "0xB081F0D0f1eb825D0A42134ef1121dAF5321D917",
            1313161555: "0x705210d03E8585FC8FFb41D008C6b4962001E346",
            43113: "0x692d1A26B49B8417d09b9CCD510096B933c8Bc4B",
            534353: "0xEc11bA12B74E0c6215FA66334c756780C2AB3fbb",
            137: "0xc8a94a3d3d2dabc3c1caffffdca6a7543c3e3e65"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($8d0b83b880f96eb5$exports))),
        decimals: {
            default: 2
        }
    },
    WETH: {
        name: "Wrapped Ether",
        ticker: "WETH",
        addresses: {
            1: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
            31337: "0xC89366f3e4C59DDBf17fb116ba9DF8bbD806338c",
            5: "0x0DAa76b8ebdAe1c170bc350c9E0eFb2C595de621",
            80001: "0x9aE88Fb19F76d07996b7d5Bc5d45E9747e6E0b31",
            4002: "0x692d1A26B49B8417d09b9CCD510096B933c8Bc4B",
            11155111: "0xa5Da2a6f19D79A88bd280d758393793d348FcD3D",
            1313161555: "0x54a2D690d06DFa62d911355F5d2f79ceA1f81C8c",
            43113: "0xa550DDe4f887Bd3B49137BAbE38BBD6bFa4e0BDA",
            534353: "0x7FDbC336F0d85BC31511fE20d582c7dCA46233e3",
            137: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
            56: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
            250: "0x74b23882a30290451A17c44f4F05243b6b58C76d",
            43114: "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($4ab9fc454436f49e$exports))),
        decimals: {
            default: 18
        }
    },
    WBNB: {
        name: "Wrapped BNB",
        ticker: "WBNB",
        addresses: {
            56: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($d049204adf92834d$exports))),
        decimals: {
            default: 18
        }
    },
    WMATIC: {
        name: "Wrapped Polygon",
        ticker: "WMATIC",
        pricefeedTicker: "MATIC",
        addresses: {
            137: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
        decimals: {
            default: 18
        }
    },
    BAT: {
        name: "Basic Attention Token",
        ticker: "BAT",
        addresses: {
            1: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
            137: "0x3cef98bb43d732e2f285ee605a8158cde967d219",
            56: "0x101d82428437127bf1608f699cd651e6abf9766e",
            80001: "0xd445cAAbb9eA6685D3A512439256866563a16E93",
            4002: "0x5720755857EF377D59cb8758B5E3eDBC483b4467",
            11155111: "0x5D684d37922dAf7Aa2013E65A22880a11C475e25",
            1313161555: "0x8dEf8ef4ea453c4dd988c1596DD6FaDD6A291e53",
            43113: "0xABB6a5C05a70098585D095D5446b6845b57E2873"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($f9d4be6bd5381211$exports))),
        decimals: {
            default: 18
        }
    },
    PRQ: {
        name: "Parsiq Token",
        ticker: "PRQ",
        addresses: {
            1: "0x362bc847A3a9637d3af6624EeC853618a43ed7D2"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($b1d1642e1e906da0$exports))),
        decimals: {
            default: 18
        }
    }
};
function $706108142b0cd8b7$export$257b2d10b709d8ef(address, chainId) {
    const token = Object.values($706108142b0cd8b7$export$8e1e81ac145e31be).find((t)=>Object.entries(t.addresses).find(([chain, addr])=>chain.toString() === chainId.toString() && addr.toLowerCase() === address.toLowerCase()));
    if (!token) return {
        name: "Unknown",
        ticker: "UNKNOWN",
        addresses: {},
        logo: "",
        decimals: {
            default: 18
        }
    };
    return token;
}


const $0478aee74ce0fceb$export$330f51eee3728a4c = [
    {
        icon: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "$"
        }),
        ticker: "USD"
    },
    {
        icon: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "$"
        }),
        ticker: "CAD"
    },
    {
        icon: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "\xa3"
        }),
        ticker: "GBP"
    },
    {
        icon: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "\u20AC"
        }),
        ticker: "EUR"
    },
    {
        icon: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
            src: (0, $706108142b0cd8b7$export$8e1e81ac145e31be).USDC.logo,
            style: {
                width: "inherit"
            }
        }),
        ticker: "USDC"
    },
    {
        icon: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
            src: (0, $706108142b0cd8b7$export$8e1e81ac145e31be).EURC.logo,
            style: {
                width: "inherit"
            }
        }),
        ticker: "EURC"
    },
    {
        icon: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
            src: (0, $706108142b0cd8b7$export$8e1e81ac145e31be).USDT.logo,
            style: {
                width: "inherit"
            }
        }),
        ticker: "USDT"
    }
];
const $0478aee74ce0fceb$export$413b0d1e3ece6964 = [
    "USDT",
    "USDC",
    "EURC",
    "ETH"
];
const $0478aee74ce0fceb$export$3dc27271f5d5c629 = (currency, amount, decimals = 2)=>{
    const effectiveDecimals = decimals !== undefined ? decimals : 2;
    const numericAmount = typeof amount === "number" ? amount : Number(amount);
    if (!$0478aee74ce0fceb$export$413b0d1e3ece6964.includes(currency)) try {
        const options = {
            style: "currency",
            currency: currency,
            minimumFractionDigits: effectiveDecimals,
            maximumFractionDigits: effectiveDecimals
        };
        const formattedAmount = Intl.NumberFormat("en-US", options).format(numericAmount).replace(/(\.\d*[1-9])0+$|\.0*$/, "$1");
        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
            children: formattedAmount
        });
    } catch (err) {
        const tokenFormattedAmount = numericAmount.toFixed(6).replace(/(\.\d*[1-9])0+$|\.0*$/, "$1");
        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
            style: {
                display: "inline-flex",
                gap: "4px"
            },
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                    children: tokenFormattedAmount
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                    style: {
                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                    },
                    children: currency
                })
            ]
        });
    }
    const tokenFormattedAmount = numericAmount.toFixed(6).replace(/(\.\d*[1-9])0+$|\.0*$/, "$1");
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        style: {
            display: "inline-flex",
            gap: "4px"
        },
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                children: tokenFormattedAmount
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                style: {
                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                },
                children: currency
            })
        ]
    });
};
const $0478aee74ce0fceb$export$bc56dd87ebd6aae2 = (currency, amount)=>{
    if (!$0478aee74ce0fceb$export$413b0d1e3ece6964.includes(currency)) try {
        return Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency
        }).format(amount);
    } catch (err) {
        return Intl.NumberFormat("en-US").format(amount);
    }
    return `${Intl.NumberFormat("en-US").format(amount)} ${currency}`;
};



var $fDWVA = parcelRequire("fDWVA");

const $8652974033b0a752$export$d3a2f40bf7ab619b = (color, amount = 0.2)=>{
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const hexToRgb = (hex)=>{
        hex = hex.replace("#", "");
        if (hex.length === 3) hex = hex.split("").map((c)=>c + c).join("");
        const bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    };
    let r = 0;
    let g = 0;
    let b = 0;
    if (color.startsWith("#")) ({ r: r, g: g, b: b } = hexToRgb(color));
    else if (color.startsWith("rgb")) {
        const nums = color.match(/\d+/g);
        if (nums) {
            r = parseInt(nums[0], 10);
            g = parseInt(nums[1], 10);
            b = parseInt(nums[2], 10);
        }
    } else return color // fallback
    ;
    // darken
    r = Math.max(0, Math.min(255, Math.floor(r * (1 - amount))));
    g = Math.max(0, Math.min(255, Math.floor(g * (1 - amount))));
    b = Math.max(0, Math.min(255, Math.floor(b * (1 - amount))));
    return `rgba(${r}, ${g}, ${b}, 0.4)` // 0.2 alpha，或你想要的透明度
    ;
};
const $8652974033b0a752$var$getFiatCurrencySymbol = (currency)=>{
    try {
        const symbol = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency,
            currencyDisplay: "symbol"
        }).formatToParts(0).find((part)=>part.type === "currency")?.value;
        return symbol ?? currency;
    } catch  {
        return currency;
    }
};
const $8652974033b0a752$var$sanitizeFiatAmountInput = (rawValue)=>{
    const valueWithoutChars = rawValue.replace(/[^\d.]/g, "");
    const [whole = "", ...fractionParts] = valueWithoutChars.split(".");
    const fraction = fractionParts.join("").slice(0, 2);
    return fractionParts.length > 0 ? `${whole}.${fraction}` : whole;
};
const $8652974033b0a752$var$normalizeFiatAmount = (rawValue)=>{
    if (!rawValue) return "";
    const parsed = Number.parseFloat(rawValue);
    if (!Number.isFinite(parsed) || parsed < 0) return "";
    return parsed.toFixed(2);
};
const $8652974033b0a752$export$35a585e8a115e315 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  animation: ${(0, $aeddef6c40752364$export$bd7370ffb2917ab7)} 0.5s ease;
  font-size: 14px;
  min-width: 100%;
  background: white;
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;

  @media (max-width: 900px) {
    height: auto;
    overflow: visible;
    min-height: 100vh;
  }
`;
const $8652974033b0a752$export$e3b4754a92ccf466 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  background: ${({ background: background })=>background};
  color: ${({ textColor: textColor })=>textColor};
  display: flex;
  flex-direction: column;
  align-items: ${({ center: center = true })=>center ? "center" : "flex-start"};
  justify-content: ${({ center: center = true })=>center ? "center" : "flex-start"};
  padding: 0;
  width: 48%;
  position: relative;
  min-height: 100vh;
  height: 100vh;
  box-sizing: border-box;
  border-right: 1px solid rgba(15, 23, 42, 0.1);
  overflow: hidden;
  ${({ slantedEdge: slantedEdge })=>slantedEdge && `
    border-right: none;
    z-index: 0;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      pointer-events: none;
      z-index: -1;
      background: linear-gradient(
        to right,
        rgba(15, 23, 42, 0) calc(100% - 260px),
        rgba(15, 23, 42, 0.14) calc(100% - 60px),
        rgba(15, 23, 42, 0.3) 100%
      );
    }

    @media (max-width: 900px) {
      &::before {
        display: none;
      }
    }
  `}

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 30%);
  }

  @media (max-width: 900px) {
    display: ${({ hideOnMobile: hideOnMobile = false })=>hideOnMobile ? "none" : "flex"};
    width: 100%;
    clip-path: none;
    border-right: none;
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
    min-height: auto;
    height: auto;
    align-items: flex-start;
    justify-content: flex-start;
    overflow: initial;

    &::after {
      display: none;
    }
  }
`;
const $8652974033b0a752$var$SLANT_OFFSET = "90px";
const $8652974033b0a752$export$7fcbc7dd475548f6 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  background-color: #ffffff;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
  text-overflow: ellipsis;
  min-height: 0;
  height: 100vh;
  width: 52%;
  overflow-y: auto;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  box-shadow:
    -34px 0 64px -36px rgba(15, 23, 42, 0.34),
    -10px 0 22px -18px rgba(15, 23, 42, 0.18);
  padding:
    clamp(42px, 5.5vh, 60px)
    clamp(96px, 10.5vw, 144px)
    24px
    clamp(40px, 4.5vw, 64px);

  @media (max-width: 1320px) and (min-width: 901px) {
    padding:
      clamp(36px, 4.5vh, 52px)
      clamp(54px, 5.8vw, 82px)
      24px
      clamp(28px, 2.8vw, 40px);
  }

  @media (max-width: 900px) {
    padding: 20px 18px 24px;
    width: 100%;
    min-height: ${({ fillViewportOnMobile: fillViewportOnMobile = false })=>fillViewportOnMobile ? "100vh" : "auto"};
    height: auto;
    overflow: visible;
    justify-content: initial;
    align-items: stretch;
    box-shadow: none;
  }

  ${({ slantedEdge: slantedEdge })=>slantedEdge && `
    margin-left: -${$8652974033b0a752$var$SLANT_OFFSET};
    width: calc(52% + ${$8652974033b0a752$var$SLANT_OFFSET});
    padding-left: calc(clamp(40px, 4.5vw, 64px) + ${$8652974033b0a752$var$SLANT_OFFSET});
    clip-path: polygon(${$8652974033b0a752$var$SLANT_OFFSET} 0, 100% 0, 100% 100%, 0 100%);
    box-shadow: none;

    @media (max-width: 1320px) and (min-width: 901px) {
      padding-left: calc(clamp(28px, 2.8vw, 40px) + ${$8652974033b0a752$var$SLANT_OFFSET});
    }

    @media (max-width: 900px) {
      margin-left: 0;
      width: 100%;
      padding-left: 18px;
      clip-path: none;
    }
  `}
`;
const $8652974033b0a752$var$DESKTOP_MANAGED_FORM_WIDTH = "512px";
const $8652974033b0a752$var$DESKTOP_STANDARD_FORM_WIDTH = "492px";
const $8652974033b0a752$var$DESKTOP_NARROW_MANAGED_FORM_WIDTH = "500px";
const $8652974033b0a752$var$DESKTOP_NARROW_STANDARD_FORM_WIDTH = "484px";
const $8652974033b0a752$var$DESKTOP_WIDE_MANAGED_FORM_WIDTH = "528px";
const $8652974033b0a752$var$DESKTOP_WIDE_STANDARD_FORM_WIDTH = "540px";
const $8652974033b0a752$var$DESKTOP_LEFT_RAIL_MANAGED_WIDTH = $8652974033b0a752$var$DESKTOP_MANAGED_FORM_WIDTH;
const $8652974033b0a752$var$DESKTOP_LEFT_RAIL_STANDARD_WIDTH = $8652974033b0a752$var$DESKTOP_STANDARD_FORM_WIDTH;
const $8652974033b0a752$var$DESKTOP_LEFT_RAIL_NARROW_MANAGED_WIDTH = $8652974033b0a752$var$DESKTOP_NARROW_MANAGED_FORM_WIDTH;
const $8652974033b0a752$var$DESKTOP_LEFT_RAIL_NARROW_STANDARD_WIDTH = $8652974033b0a752$var$DESKTOP_NARROW_STANDARD_FORM_WIDTH;
const $8652974033b0a752$var$DESKTOP_LEFT_RAIL_WIDE_MANAGED_WIDTH = $8652974033b0a752$var$DESKTOP_WIDE_MANAGED_FORM_WIDTH;
const $8652974033b0a752$var$DESKTOP_LEFT_RAIL_WIDE_STANDARD_WIDTH = $8652974033b0a752$var$DESKTOP_WIDE_STANDARD_FORM_WIDTH;
const $8652974033b0a752$var$RightFormContainer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: ${({ isManagedFlow: isManagedFlow })=>isManagedFlow ? `min(${$8652974033b0a752$var$DESKTOP_MANAGED_FORM_WIDTH}, 100%)` : `min(${$8652974033b0a752$var$DESKTOP_STANDARD_FORM_WIDTH}, 100%)`};
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  box-sizing: border-box;
  margin: clamp(26px, 4.5vh, 40px) 0 0 clamp(2px, 0.4vw, 8px);
  align-self: flex-start;

  @media (max-width: 900px) {
    width: min(100%, 620px);
    max-width: 100%;
    border: none;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
    background: transparent;
    margin: 0 auto;
    align-self: center;
  }

  @media (max-width: 1320px) and (min-width: 901px) {
    width: ${({ isManagedFlow: isManagedFlow })=>isManagedFlow ? `min(${$8652974033b0a752$var$DESKTOP_NARROW_MANAGED_FORM_WIDTH}, 100%)` : `min(${$8652974033b0a752$var$DESKTOP_NARROW_STANDARD_FORM_WIDTH}, 100%)`};
    margin-left: 0;
  }

  @media (min-width: 1600px) {
    width: ${({ isManagedFlow: isManagedFlow })=>isManagedFlow ? `min(${$8652974033b0a752$var$DESKTOP_WIDE_MANAGED_FORM_WIDTH}, 100%)` : `min(${$8652974033b0a752$var$DESKTOP_WIDE_STANDARD_FORM_WIDTH}, 100%)`};
  }
`;
const $8652974033b0a752$export$c033e000b908eef6 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 100%;
  min-height: min-content;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0;
  @media (max-width: 900px) {
    width: 100%;
    height: auto;
  }
`;
const $8652974033b0a752$var$LeftSectionContent = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding:
    26px
    clamp(34px, 4vw, 56px)
    28px
    clamp(40px, 4.5vw, 56px);
  width: 100%;
  max-width: 700px;
  margin: 0;
  flex: 1;
  min-height: 0;

  @media (max-width: 900px) {
    width: 100%;
    padding: 18px 20px 18px;
    gap: 16px;
  }
`;
const $8652974033b0a752$var$LEFT_RAIL_COLUMN_OFFSET = "clamp(76px, 7vw, 124px)";
const $8652974033b0a752$var$LEFT_RAIL_COLUMN_GUTTER = "clamp(8px, 1vw, 14px)";
const $8652974033b0a752$var$InputAmountBox = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 32px;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  margin-top: 0;

  @media (max-width: 900px) {
    margin-top: 0;
    width: 100%;
  }
`;
const $8652974033b0a752$var$AmountInputWrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 100%;
  position: relative;
`;
const $8652974033b0a752$var$AmountInputSymbol = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #667085;
  font-size: 20px;
  font-weight: 500;
  pointer-events: none;
`;
const $8652974033b0a752$var$AmountInput = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)((0, $196480508fc60042$export$c86715117507e8e5))`
  height: 52px;
  padding-left: 34px;
  font-size: 26px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.2px;
`;
const $8652974033b0a752$var$CurrencyPill = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).button`
  border: 1px solid;
  border-color: ${({ selected: selected })=>selected ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE5 : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  background: ${({ selected: selected })=>selected ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE7 : "white"};
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK};
  border-radius: 8px;
  height: 34px;
  min-width: 56px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: 0.2s ease all;

  :hover {
    border-color: ${({ selected: selected })=>selected ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE5 : "#c4ccde"};
  }

  :focus-visible {
    border-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE5};
    box-shadow: 0 0 0 3px rgb(97 138 250 / 18%);
    outline: none;
  }
`;
const $8652974033b0a752$var$SummaryCard = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 100%;
  background: transparent;
`;
const $8652974033b0a752$var$SummaryCardHeader = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: ${({ $columnWidth: $columnWidth })=>$columnWidth};
  margin-left: ${$8652974033b0a752$var$LEFT_RAIL_COLUMN_OFFSET};
  padding-bottom: 18px;
  border-bottom: 1px solid #dbe1ec;

  @media (max-width: 1320px) and (min-width: 901px) {
    max-width: ${({ $columnWidthNarrow: $columnWidthNarrow })=>$columnWidthNarrow};
  }

  @media (min-width: 1600px) {
    max-width: ${({ $columnWidthWide: $columnWidthWide })=>$columnWidthWide};
  }

  @media (max-width: 900px) {
    max-width: 100%;
    margin-left: 0;
    padding-bottom: 14px;
  }
`;
const $8652974033b0a752$var$SummaryCardBody = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: ${({ $columnWidth: $columnWidth })=>$columnWidth};
  padding: clamp(88px, 10vh, 126px) 0 0;
  margin-left: ${$8652974033b0a752$var$LEFT_RAIL_COLUMN_OFFSET};

  @media (max-width: 1320px) and (min-width: 901px) {
    max-width: ${({ $columnWidthNarrow: $columnWidthNarrow })=>$columnWidthNarrow};
  }

  @media (min-width: 1600px) {
    max-width: ${({ $columnWidthWide: $columnWidthWide })=>$columnWidthWide};
    margin-left: clamp(76px, 6vw, 124px);
  }

  @media (max-width: 900px) {
    max-width: 100%;
    margin-left: 0;
    padding-top: 24px;
  }
`;
const $8652974033b0a752$var$LeftFooter = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 100%;
  box-sizing: border-box;
  margin-top: auto;
  padding:
    0
    clamp(34px, 4vw, 56px)
    22px
    clamp(40px, 4.5vw, 56px);
  font-size: 13px;
  display: flex;
  justify-content: flex-start;

  @media (max-width: 900px) {
    padding: 4px 20px 18px;
  }
`;
const $8652974033b0a752$var$LeftFooterInline = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
  white-space: nowrap;
  min-width: max-content;
  width: 100%;
  max-width: ${({ $columnWidth: $columnWidth })=>$columnWidth};
  margin-left: ${$8652974033b0a752$var$LEFT_RAIL_COLUMN_OFFSET};

  @media (max-width: 1320px) and (min-width: 901px) {
    max-width: ${({ $columnWidthNarrow: $columnWidthNarrow })=>$columnWidthNarrow};
  }

  @media (min-width: 1600px) {
    max-width: ${({ $columnWidthWide: $columnWidthWide })=>$columnWidthWide};
  }

  @media (max-width: 900px) {
    max-width: 100%;
    margin-left: 0;
    width: auto;
    min-width: 0;
  }
`;
const $8652974033b0a752$var$MobileRightFooter = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: none;

  @media (max-width: 900px) {
    display: flex;
    justify-content: flex-start;
    margin-top: auto;
    padding: 28px 2px 8px;
  }
`;
function $8652974033b0a752$export$4739bd9618b6a26b() {
    return {
        accountType: "",
        companyName: "",
        name: "",
        emailAddress: "",
        addressLine1: "",
        addressLine2: "",
        townOrCity: "",
        postalCode: "",
        stateOrProvince: "",
        countryOfResidence: ""
    };
}
function $8652974033b0a752$export$3e77b1380e63cfaf() {
    return {
        accountType: undefined,
        companyNameCollected: false,
        nameCollected: false,
        emailAddressCollected: false,
        addressLine1Collected: false,
        addressLine2Collected: false,
        townOrCityCollected: false,
        postalCodeCollected: false,
        stateOrProvinceCollected: false,
        countryOfResidenceCollected: false,
        dateOfBirthCollected: false
    };
}
function $8652974033b0a752$export$4217e132ac074f47() {
    return {
        accountType: "Individual",
        companyNameCollected: true,
        nameCollected: true,
        emailAddressCollected: true,
        addressLine1Collected: true,
        addressLine2Collected: true,
        townOrCityCollected: true,
        postalCodeCollected: true,
        stateOrProvinceCollected: true,
        countryOfResidenceCollected: true,
        dateOfBirthCollected: true
    };
}
var $8652974033b0a752$export$806b3fe74e359d5d;
(function(CheckoutType) {
    CheckoutType["Individual"] = "Individual";
    CheckoutType["Business"] = "Business";
})($8652974033b0a752$export$806b3fe74e359d5d || ($8652974033b0a752$export$806b3fe74e359d5d = {}));
// ---------------------------------------------------------------------------------------------------------------------
function $8652974033b0a752$var$Checkout(props) {
    const { checkoutData: checkoutData, onCheckout: onCheckout } = props;
    const [localCheckoutData, setLocalCheckoutData] = (0, $bnENU.useState)({});
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(true);
    const [showDiscountCodeInput, setShowDiscountCodeInput] = (0, $bnENU.useState)(false);
    const [totalSum, setTotalSum] = (0, $bnENU.useState)(0);
    const [subscriptionSum, setSubscriptionSum] = (0, $bnENU.useState)(0);
    const [currency, setCurrency] = (0, $bnENU.useState)("USD");
    const [discountCode, setDiscountCode] = (0, $bnENU.useState)("");
    const [payAmount, setPayAmount] = (0, $bnENU.useState)("");
    const [formatPayAmount, setFormatPayAmount] = (0, $bnENU.useState)("");
    const [payCurrency, setPayCurrency] = (0, $bnENU.useState)(props.checkoutData.products?.[0]?.product?.currency ?? props.checkoutData.lineItems?.[0]?.currency ?? props.checkoutData.currency ?? "USD");
    const [controlFreeInput, setControlFreeInput] = (0, $bnENU.useState)(false);
    const [lockedPayAmount, setLockedPayAmount] = (0, $bnENU.useState)("");
    const [lockedPayCurrency, setLockedPayCurrency] = (0, $bnENU.useState)("");
    const [hideMobileSummary, setHideMobileSummary] = (0, $bnENU.useState)(false);
    const subscriptionProducts = checkoutData.products?.filter((p)=>p.product.chargingIntervalSeconds > 0) ?? [];
    const firstProduct = subscriptionProducts.length > 0 ? subscriptionProducts?.[0] : checkoutData?.products?.[0] ?? undefined;
    const paymentLinkCustomizations = checkoutData.customizations;
    const customizations = {
        leftPanelColor: paymentLinkCustomizations?.leftPanelColor ?? "#eff2f8",
        primaryButtonColor: paymentLinkCustomizations?.primaryButtonColor ?? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE,
        slantedEdge: paymentLinkCustomizations?.slantedEdge ?? false,
        allowDiscountCodes: paymentLinkCustomizations?.allowDiscountCodes ?? false
    };
    const merchantAccentColor = customizations.primaryButtonColor ?? "#3b65f0";
    const leftTextColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "white", "black");
    const leftMutedTextColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.76)", "rgba(31, 41, 55, 0.68)");
    const leftFooterTextColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.64)", "rgba(55, 65, 81, 0.72)");
    const leftSubtleBorderColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.2)", "rgba(15, 23, 42, 0.14)");
    const sellerDisplayName = checkoutData.sellerName && checkoutData.sellerName.length > 0 ? checkoutData.sellerName : (0, $8d017118df5fe2e5$export$193698062786be9a)(checkoutData.sellerAddress, 8) || "Merchant";
    const sellerDisplayInitial = sellerDisplayName.trim().charAt(0).toUpperCase() || "M";
    const merchantDescriptionSource = (checkoutData.subscription?.product?.description ?? checkoutData.products?.find((line)=>(line.product?.description?.trim()?.length ?? 0) > 0)?.product.description ?? checkoutData.lineItems?.find((item)=>(item.description?.trim()?.length ?? 0) > 0)?.description)?.trim();
    const merchantDescription = merchantDescriptionSource && merchantDescriptionSource.length > 90 ? `${merchantDescriptionSource.slice(0, 90)}...` : merchantDescriptionSource;
    const hasProductSummaryRows = (checkoutData.products?.length ?? 0) > 0;
    const hasLineItemSummaryRows = (checkoutData.lineItems?.length ?? 0) > 0;
    const showEmptyOrderFallback = !checkoutData.customizations?.allowFreeInputAmount && subscriptionProducts.length === 0 && !hasProductSummaryRows && !hasLineItemSummaryRows;
    const isManagedFlow = !!checkoutData.gateway.managed;
    const leftRailColumnWidth = `min(${isManagedFlow ? $8652974033b0a752$var$DESKTOP_LEFT_RAIL_MANAGED_WIDTH : $8652974033b0a752$var$DESKTOP_LEFT_RAIL_STANDARD_WIDTH}, calc(100% - ${$8652974033b0a752$var$LEFT_RAIL_COLUMN_OFFSET} - ${$8652974033b0a752$var$LEFT_RAIL_COLUMN_GUTTER}))`;
    const leftRailColumnWidthNarrow = `min(${isManagedFlow ? $8652974033b0a752$var$DESKTOP_LEFT_RAIL_NARROW_MANAGED_WIDTH : $8652974033b0a752$var$DESKTOP_LEFT_RAIL_NARROW_STANDARD_WIDTH}, calc(100% - ${$8652974033b0a752$var$LEFT_RAIL_COLUMN_OFFSET} - ${$8652974033b0a752$var$LEFT_RAIL_COLUMN_GUTTER}))`;
    const leftRailColumnWidthWide = `min(${isManagedFlow ? $8652974033b0a752$var$DESKTOP_LEFT_RAIL_WIDE_MANAGED_WIDTH : $8652974033b0a752$var$DESKTOP_LEFT_RAIL_WIDE_STANDARD_WIDTH}, calc(100% - 176px))`;
    const handleBack = ()=>{
        if (checkoutData.cancelUrl && checkoutData.cancelUrl.length > 0) {
            window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(checkoutData.cancelUrl);
            return;
        }
        if (window.history.length > 1) window.history.back();
    };
    const getPriceQuotes = ()=>{
        const normalizedCheckoutTotal = Number(checkoutData.total ?? 0);
        const hasProvidedTotal = Number.isFinite(normalizedCheckoutTotal) && normalizedCheckoutTotal > 0;
        let nextCurrency = checkoutData.currency ?? "USD";
        if (subscriptionProducts.length > 0) nextCurrency = subscriptionProducts[0]?.product.currency ?? "USD";
        else if (checkoutData.products && checkoutData.products.length > 0) nextCurrency = checkoutData.products?.[0]?.product?.currency ?? "USD";
        else if (checkoutData.lineItems && checkoutData.lineItems.length > 0) nextCurrency = checkoutData.lineItems?.[0]?.currency ?? checkoutData.currency ?? "USD";
        else if (!checkoutData.customizations?.allowFreeInputAmount) {
            if (hasProvidedTotal) {
                setCurrency(checkoutData.currency ?? nextCurrency);
                setTotalSum(normalizedCheckoutTotal);
                setSubscriptionSum(0);
            }
            setIsLoading(false);
            return;
        }
        setCurrency(nextCurrency);
        const fromCurrencies = checkoutData.customizations?.allowFreeInputAmount ? [
            payCurrency
        ] : [
            ...checkoutData.products?.map((p)=>p.product.currency) ?? [],
            ...checkoutData.lineItems?.map((lineItem)=>lineItem.currency ?? nextCurrency) ?? [],
            ...checkoutData.currency ? [
                checkoutData.currency
            ] : []
        ];
        const uniqueFromCurrencies = [
            ...new Set(fromCurrencies.filter((value)=>typeof value === "string" && value.length > 0).map((value)=>value.toUpperCase()))
        ];
        if (uniqueFromCurrencies.length === 0) {
            if (hasProvidedTotal) {
                setTotalSum(normalizedCheckoutTotal);
                setSubscriptionSum(0);
            }
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        (0, $43c053927acc0cba$export$2e2bcd8739ae039).getPriceQuotes(uniqueFromCurrencies, [
            nextCurrency
        ]).then((p)=>{
            // Get price quotes in terms of first product's currency
            const [total, subscriptionTotal] = (0, $94d9469e1ad800ce$export$56eaa5cece9d2d8a)(checkoutData, p, nextCurrency);
            const normalizedTotal = Number(total);
            const normalizedSubscriptionTotal = Number(subscriptionTotal);
            setTotalSum(Number.isFinite(normalizedTotal) && normalizedTotal > 0 ? normalizedTotal : hasProvidedTotal ? normalizedCheckoutTotal : 0);
            setSubscriptionSum(Number.isFinite(normalizedSubscriptionTotal) ? normalizedSubscriptionTotal : 0);
        }).catch((err)=>{
            console.error("Failed to load checkout price quotes", err);
            if (hasProvidedTotal) {
                setTotalSum(normalizedCheckoutTotal);
                setSubscriptionSum(0);
            }
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    (0, $bnENU.useEffect)(()=>{
        getPriceQuotes();
    }, []);
    const effectivePayCurrency = controlFreeInput && lockedPayCurrency.length > 0 ? lockedPayCurrency : payCurrency;
    const effectivePayAmount = controlFreeInput && lockedPayAmount.length > 0 ? lockedPayAmount : payAmount;
    const lockFreeInputSelection = ()=>{
        if (!checkoutData.customizations?.allowFreeInputAmount) return undefined;
        const normalizedAmount = controlFreeInput && lockedPayAmount.length > 0 ? lockedPayAmount : $8652974033b0a752$var$normalizeFiatAmount(payAmount || formatPayAmount);
        const amount = normalizedAmount ? parseFloat(normalizedAmount) : 0;
        if (!controlFreeInput) {
            setPayAmount(normalizedAmount);
            setFormatPayAmount(normalizedAmount);
            setLockedPayAmount(normalizedAmount);
            setLockedPayCurrency(payCurrency);
            setControlFreeInput(true);
        }
        props.onCurrency?.(payCurrency);
        props.onTotalChange?.(amount);
        return {
            amount: amount,
            currency: payCurrency
        };
    };
    (0, $bnENU.useEffect)(()=>{
        if ((0, $fDWVA.isEqual)(localCheckoutData.gateway, checkoutData.gateway) && (0, $fDWVA.isEqual)(localCheckoutData.products, checkoutData.products) && (0, $fDWVA.isEqual)(localCheckoutData.lineItems, checkoutData.lineItems) && (0, $fDWVA.isEqual)(localCheckoutData.currency, checkoutData.currency) && (0, $fDWVA.isEqual)(localCheckoutData.total, checkoutData.total)) return;
        setLocalCheckoutData(checkoutData);
        setIsLoading(true);
        getPriceQuotes();
    }, [
        checkoutData
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (!checkoutData.gateway.managed) setHideMobileSummary(false);
    }, [
        checkoutData.gateway.managed,
        checkoutData.id
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (props.discountResult?.success) setShowDiscountCodeInput(true);
    }, [
        props.discountResult
    ]);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8652974033b0a752$export$35a585e8a115e315, {
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8652974033b0a752$export$e3b4754a92ccf466, {
                center: false,
                slantedEdge: customizations.slantedEdge,
                background: customizations.leftPanelColor,
                textColor: leftTextColor,
                hideOnMobile: hideMobileSummary,
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($8652974033b0a752$var$LeftSectionContent, {
                        style: {
                            maxWidth: checkoutData.customizations?.allowFreeInputAmount ? "min(820px, 100%)" : "min(980px, 100%)",
                            gap: 20
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8652974033b0a752$var$SummaryCard, {
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8652974033b0a752$var$SummaryCardHeader, {
                                    $columnWidth: leftRailColumnWidth,
                                    $columnWidthNarrow: leftRailColumnWidthNarrow,
                                    $columnWidthWide: leftRailColumnWidthWide,
                                    style: {
                                        borderBottomColor: leftSubtleBorderColor
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$c25acd513dcc8062), {
                                            "aria-label": "Go back",
                                            onClick: handleBack,
                                            style: {
                                                padding: 2,
                                                marginRight: 4,
                                                color: leftMutedTextColor,
                                                flexShrink: 0
                                            },
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a6503dca462d11a6$export$2e2bcd8739ae039), {
                                                width: 18,
                                                height: 18,
                                                stroke: leftMutedTextColor,
                                                style: {
                                                    transform: "rotate(180deg)"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                width: 30,
                                                height: 30,
                                                borderRadius: 8,
                                                overflow: "hidden",
                                                flexShrink: 0,
                                                backgroundColor: checkoutData.sellerLogoUrl ? "transparent" : merchantAccentColor,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "white",
                                                fontSize: 14,
                                                fontWeight: 500
                                            },
                                            children: checkoutData.sellerLogoUrl ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                src: checkoutData.sellerLogoUrl,
                                                style: {
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    pointerEvents: "none"
                                                }
                                            }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                children: sellerDisplayInitial
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        fontWeight: 400,
                                                        lineHeight: 1.2,
                                                        fontSize: 17,
                                                        color: leftTextColor
                                                    },
                                                    children: sellerDisplayName
                                                }),
                                                merchantDescription && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        marginTop: 2,
                                                        fontSize: 13,
                                                        color: leftMutedTextColor,
                                                        lineHeight: 1.3,
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        maxWidth: 360
                                                    },
                                                    title: merchantDescription,
                                                    children: merchantDescription
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8652974033b0a752$var$SummaryCardBody, {
                                    $columnWidth: leftRailColumnWidth,
                                    $columnWidthNarrow: leftRailColumnWidthNarrow,
                                    $columnWidthWide: leftRailColumnWidthWide,
                                    children: [
                                        !checkoutData.customizations?.allowFreeInputAmount && subscriptionProducts.length === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 4,
                                                marginBottom: 4
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                    style: {
                                                        color: leftMutedTextColor,
                                                        fontSize: 14,
                                                        fontWeight: 400
                                                    },
                                                    children: [
                                                        "Pay ",
                                                        sellerDisplayName
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        color: leftTextColor,
                                                        fontSize: 37,
                                                        lineHeight: 1,
                                                        fontWeight: 500
                                                    },
                                                    children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, totalSum)
                                                })
                                            ]
                                        }),
                                        subscriptionProducts.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                    style: {
                                                        fontSize: 28,
                                                        display: "flex",
                                                        flexDirection: "column"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                fontWeight: 400,
                                                                fontSize: 16,
                                                                opacity: 0.68
                                                            },
                                                            children: "Subscribe to"
                                                        }),
                                                        subscriptionProducts[0].product.name
                                                    ]
                                                }),
                                                isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {}),
                                                !isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        fontSize: 54,
                                                        fontWeight: 500
                                                    },
                                                    children: [
                                                        (0, $0478aee74ce0fceb$export$413b0d1e3ece6964).includes(currency) && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                width: 32,
                                                                marginRight: "8px"
                                                            },
                                                            children: (0, $0478aee74ce0fceb$export$330f51eee3728a4c).find((c)=>c.ticker === currency)?.icon
                                                        }),
                                                        (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, totalSum),
                                                        subscriptionProducts.length === checkoutData.products?.length && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                            style: {
                                                                fontSize: 16,
                                                                marginLeft: 5,
                                                                fontWeight: 500,
                                                                width: 30,
                                                                opacity: 0.75,
                                                                display: "inline-block"
                                                            },
                                                            children: [
                                                                "per",
                                                                " ",
                                                                (0, $afdf282d9c361d03$export$d82eb24974fa9fd)(subscriptionProducts[0].product.chargingIntervalSeconds).toLowerCase()
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                subscriptionProducts.length !== checkoutData.products?.length && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                    style: {
                                                        fontSize: 18,
                                                        opacity: 0.65
                                                    },
                                                    children: [
                                                        "Then ",
                                                        (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, subscriptionSum),
                                                        " per",
                                                        " ",
                                                        (0, $afdf282d9c361d03$export$d82eb24974fa9fd)(subscriptionProducts[0].product.chargingIntervalSeconds).toLowerCase()
                                                    ]
                                                }),
                                                checkoutData.products?.length === 1 && firstProduct && firstProduct.product.imageUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                    style: {
                                                        marginTop: 10,
                                                        maxWidth: 200,
                                                        maxHeight: 200,
                                                        borderRadius: 5
                                                    },
                                                    src: firstProduct.product.imageUrl
                                                })
                                            ]
                                        }),
                                        subscriptionProducts.length === 0 && !checkoutData.isInvoice && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                            children: [
                                                checkoutData.customizations?.allowFreeInputAmount ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8652974033b0a752$var$InputAmountBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                            style: {
                                                                color: leftMutedTextColor,
                                                                fontSize: 18,
                                                                fontWeight: 500,
                                                                marginBottom: 10,
                                                                textAlign: "left",
                                                                width: "100%"
                                                            },
                                                            children: "Enter Payment Amount"
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                display: "flex",
                                                                gap: 8,
                                                                marginBottom: 10
                                                            },
                                                            children: [
                                                                "USD",
                                                                "EUR",
                                                                "GBP"
                                                            ].map((fiat)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($8652974033b0a752$var$CurrencyPill, {
                                                                    type: "button",
                                                                    selected: payCurrency === fiat,
                                                                    disabled: controlFreeInput,
                                                                    onClick: ()=>{
                                                                        if (controlFreeInput) return;
                                                                        setCurrency(fiat);
                                                                        setPayCurrency(fiat);
                                                                        props.onCurrency?.(fiat);
                                                                        if (payAmount) setFormatPayAmount(payAmount);
                                                                    },
                                                                    children: fiat
                                                                }, fiat))
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8652974033b0a752$var$AmountInputWrapper, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($8652974033b0a752$var$AmountInputSymbol, {
                                                                    children: $8652974033b0a752$var$getFiatCurrencySymbol(payCurrency)
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($8652974033b0a752$var$AmountInput, {
                                                                    disabled: controlFreeInput,
                                                                    autoFocus: true,
                                                                    placeholder: "0.00",
                                                                    min: "0",
                                                                    autoComplete: "off",
                                                                    inputMode: "decimal",
                                                                    "aria-label": "Payment amount",
                                                                    value: formatPayAmount,
                                                                    onFocus: (e)=>{
                                                                        setFormatPayAmount(payAmount);
                                                                        e.currentTarget.select();
                                                                    },
                                                                    onBlur: ()=>{
                                                                        const normalized = $8652974033b0a752$var$normalizeFiatAmount(payAmount);
                                                                        setPayAmount(normalized);
                                                                        setFormatPayAmount(normalized);
                                                                        props.onCurrency?.(payCurrency);
                                                                        props.onTotalChange?.(normalized ? parseFloat(normalized) : 0);
                                                                    },
                                                                    onChange: (e)=>{
                                                                        const value = $8652974033b0a752$var$sanitizeFiatAmountInput(e.target.value);
                                                                        setPayAmount(value);
                                                                        setFormatPayAmount(value);
                                                                    },
                                                                    onKeyDown: (e)=>{
                                                                        if (e.key === "Enter") {
                                                                            e.preventDefault();
                                                                            e.currentTarget.blur();
                                                                        }
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 13,
                                                        fontWeight: 400,
                                                        color: leftMutedTextColor
                                                    },
                                                    children: "Order summary"
                                                }),
                                                isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {})
                                            ]
                                        }),
                                        !checkoutData.customizations?.allowFreeInputAmount && subscriptionProducts.length === 0 && checkoutData.products && checkoutData.products.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                marginTop: 0,
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "100%",
                                                borderTop: `1px solid ${leftSubtleBorderColor}`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        maxHeight: 320,
                                                        overflowY: "auto"
                                                    },
                                                    children: checkoutData.products.map((line, index)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                fontSize: 14,
                                                                display: "flex",
                                                                width: "100%",
                                                                justifyContent: "space-between",
                                                                alignItems: "flex-start",
                                                                gap: 12,
                                                                padding: "12px 0",
                                                                borderBottom: `1px solid ${leftSubtleBorderColor}`
                                                            },
                                                            children: [
                                                                line.product.imageUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                    style: {
                                                                        width: 36,
                                                                        height: 36,
                                                                        borderRadius: 6,
                                                                        flexShrink: 0
                                                                    },
                                                                    src: line.product.imageUrl
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        flexGrow: 1,
                                                                        minWidth: 0
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                            style: {
                                                                                marginBottom: 4,
                                                                                fontWeight: 400,
                                                                                overflowWrap: "anywhere"
                                                                            },
                                                                            children: line.product.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                            style: {
                                                                                fontSize: 12,
                                                                                opacity: 0.65
                                                                            },
                                                                            children: [
                                                                                "Qty ",
                                                                                line.quantity ?? 1
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        textAlign: "right",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        whiteSpace: "nowrap"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                fontWeight: 400
                                                                            },
                                                                            children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(line.product.currency, line.product.price * (line.quantity ?? 1))
                                                                        }),
                                                                        (line.quantity ?? 1) > 1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                                            style: {
                                                                                fontSize: "12px",
                                                                                textAlign: "right",
                                                                                color: leftMutedTextColor
                                                                            },
                                                                            children: [
                                                                                (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(line.product.currency, line.product.price),
                                                                                " each"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, line.product.id || `${line.product.name}-${index}`))
                                                }),
                                                !isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        paddingTop: 12,
                                                        borderBottom: `1px solid ${leftSubtleBorderColor}`,
                                                        paddingBottom: 12
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                color: leftTextColor,
                                                                fontWeight: 500
                                                            },
                                                            children: "Total due"
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                fontWeight: 500,
                                                                fontSize: 17
                                                            },
                                                            children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, totalSum)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !checkoutData.customizations?.allowFreeInputAmount && subscriptionProducts.length === 0 && (!checkoutData.products || checkoutData.products.length === 0) && checkoutData.lineItems && checkoutData.lineItems.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                marginTop: 0,
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "100%",
                                                borderTop: `1px solid ${leftSubtleBorderColor}`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        maxHeight: 320,
                                                        overflowY: "auto"
                                                    },
                                                    children: checkoutData.lineItems.map((lineItem, index)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                fontSize: 14,
                                                                display: "flex",
                                                                width: "100%",
                                                                justifyContent: "space-between",
                                                                alignItems: "flex-start",
                                                                gap: 12,
                                                                padding: "12px 0",
                                                                borderBottom: `1px solid ${leftSubtleBorderColor}`
                                                            },
                                                            children: [
                                                                lineItem.imageUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                                    style: {
                                                                        width: 36,
                                                                        height: 36,
                                                                        borderRadius: 6,
                                                                        flexShrink: 0
                                                                    },
                                                                    src: lineItem.imageUrl
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        flexGrow: 1,
                                                                        minWidth: 0
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                            style: {
                                                                                marginBottom: 4,
                                                                                fontWeight: 400,
                                                                                overflowWrap: "anywhere"
                                                                            },
                                                                            children: lineItem.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                            style: {
                                                                                fontSize: 12,
                                                                                opacity: 0.65
                                                                            },
                                                                            children: [
                                                                                "Qty ",
                                                                                lineItem.quantity ?? 1
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        textAlign: "right",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        whiteSpace: "nowrap"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                fontWeight: 400
                                                                            },
                                                                            children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(lineItem.currency ?? currency, lineItem.price * (lineItem.quantity ?? 1))
                                                                        }),
                                                                        (lineItem.quantity ?? 1) > 1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                                            style: {
                                                                                fontSize: "12px",
                                                                                textAlign: "right",
                                                                                color: leftMutedTextColor
                                                                            },
                                                                            children: [
                                                                                (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(lineItem.currency ?? currency, lineItem.price),
                                                                                " each"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, `${lineItem.name}-${index}`))
                                                }),
                                                !isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        paddingTop: 12,
                                                        borderBottom: `1px solid ${leftSubtleBorderColor}`,
                                                        paddingBottom: 12
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                color: leftTextColor,
                                                                fontWeight: 500
                                                            },
                                                            children: "Total due"
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                fontWeight: 500,
                                                                fontSize: 17
                                                            },
                                                            children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, totalSum)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        showEmptyOrderFallback && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                marginTop: 0,
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "100%",
                                                borderTop: `1px solid ${leftSubtleBorderColor}`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        fontSize: 14,
                                                        display: "flex",
                                                        width: "100%",
                                                        justifyContent: "space-between",
                                                        alignItems: "flex-start",
                                                        gap: 12,
                                                        padding: "12px 0",
                                                        borderBottom: `1px solid ${leftSubtleBorderColor}`
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 4
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                    style: {
                                                                        marginBottom: 0,
                                                                        fontWeight: 400,
                                                                        overflowWrap: "anywhere"
                                                                    },
                                                                    children: "Payment"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                    style: {
                                                                        fontSize: 12,
                                                                        color: leftMutedTextColor
                                                                    },
                                                                    children: "Qty 1"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                textAlign: "right",
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                whiteSpace: "nowrap"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, totalSum)
                                                            })
                                                        })
                                                    ]
                                                }),
                                                !isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        paddingTop: 12,
                                                        borderBottom: `1px solid ${leftSubtleBorderColor}`,
                                                        paddingBottom: 12
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                color: leftTextColor,
                                                                fontWeight: 500
                                                            },
                                                            children: "Total due"
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                fontWeight: 500,
                                                                fontSize: 17
                                                            },
                                                            children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, totalSum)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        customizations.allowDiscountCodes && !showDiscountCodeInput && !props.discountLocked && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $d589b7ebc11d644f$export$c25acd513dcc8062), {
                                            onClick: ()=>{
                                                if (props.onDiscountCodeEntered) setShowDiscountCodeInput(true);
                                            },
                                            style: {
                                                marginTop: 10,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                                padding: 0,
                                                color: leftMutedTextColor
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    children: "Add discount code"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a6503dca462d11a6$export$2e2bcd8739ae039), {
                                                    stroke: leftMutedTextColor,
                                                    height: 15
                                                })
                                            ]
                                        }),
                                        showDiscountCodeInput && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                marginTop: 10,
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10,
                                                width: "100%",
                                                maxWidth: 400,
                                                marginLeft: "auto",
                                                marginRight: "auto"
                                            },
                                            children: [
                                                !props.discountResult?.success && !props.discountLocked && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        borderRadius: 5,
                                                        border: "1px solid",
                                                        backgroundColor: (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.1)", "rgba(255, 255, 255, 0.25)"),
                                                        color: (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "white", "black"),
                                                        borderColor: (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.1)", "rgba(0, 0, 0, 0.1)"),
                                                        display: "flex",
                                                        alignItems: "center",
                                                        padding: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                            autoFocus: true,
                                                            placeholder: "Enter code",
                                                            autoCorrect: "off",
                                                            spellCheck: "false",
                                                            type: "text",
                                                            onChange: (e)=>setDiscountCode(e.target.value),
                                                            style: {
                                                                color: (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "white", "black"),
                                                                background: "none",
                                                                border: "none",
                                                                boxShadow: "none",
                                                                flex: 1
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                            onClick: ()=>props.onDiscountCodeEntered?.(discountCode),
                                                            style: {
                                                                padding: "3px 10px",
                                                                textTransform: "uppercase",
                                                                color: (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "white", "black"),
                                                                border: "none"
                                                            },
                                                            children: "Apply"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        gap: 10
                                                    },
                                                    children: [
                                                        props.discountResult?.element,
                                                        props.discountResult?.success && !props.discountLocked && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$c25acd513dcc8062), {
                                                            style: {
                                                                padding: 5
                                                            },
                                                            onClick: ()=>props.resetDiscountCode?.(),
                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $604fb7faec27af0d$export$2e2bcd8739ae039), {
                                                                width: 15,
                                                                height: 15,
                                                                stroke: (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "white", "black"),
                                                                style: {
                                                                    opacity: 0.5
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($8652974033b0a752$var$LeftFooter, {
                        style: {
                            color: leftFooterTextColor
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8652974033b0a752$var$LeftFooterInline, {
                            $columnWidth: leftRailColumnWidth,
                            $columnWidthNarrow: leftRailColumnWidthNarrow,
                            $columnWidthWide: leftRailColumnWidthWide,
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                                    href: "https://radom.com",
                                    target: "_blank",
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: 6,
                                        cursor: "pointer",
                                        userSelect: "none",
                                        color: "inherit",
                                        fontWeight: 400,
                                        textDecoration: "none"
                                    },
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            children: "Powered by"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                            width: 50,
                                            fill: leftFooterTextColor
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "|"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("a", {
                                    href: "https://www.radom.com/terms",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    style: {
                                        color: "inherit",
                                        textDecoration: "none"
                                    },
                                    children: "Terms"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "|"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("a", {
                                    href: "https://radom.com/privacy",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    style: {
                                        color: "inherit",
                                        textDecoration: "none"
                                    },
                                    children: "Privacy"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8652974033b0a752$export$7fcbc7dd475548f6, {
                fillViewportOnMobile: hideMobileSummary,
                slantedEdge: customizations.slantedEdge,
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($8652974033b0a752$var$RightFormContainer, {
                        isManagedFlow: !!checkoutData.gateway.managed,
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($8652974033b0a752$export$c033e000b908eef6, {
                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $06825994d276e479$export$2e2bcd8739ae039), {
                                checkoutData: {
                                    ...checkoutData,
                                    total: effectivePayAmount ? parseFloat(effectivePayAmount) : totalSum,
                                    currency: effectivePayCurrency
                                },
                                currency: effectivePayCurrency,
                                isPreProcessingPayment: props.isPreProcessingPayment,
                                paymentStatus: props.paymentStatus,
                                isSuccess: props.isSuccess,
                                managedPaymentDetails: props.managedPaymentDetails,
                                tokenDelegatePaymentDetails: props.tokenDelegatePaymentDetails,
                                discount: props.discount,
                                onCheckout: (params)=>{
                                    const freeInput = lockFreeInputSelection();
                                    onCheckout({
                                        ...params,
                                        freeInput: freeInput
                                    });
                                },
                                onInputFieldsChange: props.onInputFieldsChange,
                                onQuoteUpdate: ()=>getPriceQuotes(),
                                successElement: props.successElement,
                                errorMessage: props.errorMessage,
                                travelRuleFieldsCollected: props.travelRuleFieldsCollected,
                                hideTravelRuleFields: props.hideTravelRuleFields,
                                onTravelRuleFieldsContinue: lockFreeInputSelection,
                                onCheckoutStateChange: (isCheckoutState)=>{
                                    setHideMobileSummary(!!checkoutData.gateway.managed && isCheckoutState);
                                },
                                onChangePaymentMethod: props.onChangePaymentMethod
                            })
                        })
                    }),
                    hideMobileSummary && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($8652974033b0a752$var$MobileRightFooter, {
                        style: {
                            color: leftFooterTextColor
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8652974033b0a752$var$LeftFooterInline, {
                            $columnWidth: leftRailColumnWidth,
                            $columnWidthNarrow: leftRailColumnWidthNarrow,
                            $columnWidthWide: leftRailColumnWidthWide,
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                                    href: "https://radom.com",
                                    target: "_blank",
                                    style: {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: 6,
                                        cursor: "pointer",
                                        userSelect: "none",
                                        color: "inherit",
                                        fontWeight: 400,
                                        textDecoration: "none"
                                    },
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            children: "Powered by"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                            width: 50,
                                            fill: leftFooterTextColor
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "|"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("a", {
                                    href: "https://www.radom.com/terms",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    style: {
                                        color: "inherit",
                                        textDecoration: "none"
                                    },
                                    children: "Terms"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "|"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("a", {
                                    href: "https://radom.com/privacy",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    style: {
                                        color: "inherit",
                                        textDecoration: "none"
                                    },
                                    children: "Privacy"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $8652974033b0a752$export$2e2bcd8739ae039 = $8652974033b0a752$var$Checkout;



parcelRequire("bnENU");


parcelRequire("bnENU");

const $132e35e0f1f0eb86$var$LoadingBarAnimation = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  from {
    opacity: 1;
  }
  to {
    opacity: 0.5;
  }
`;
const $132e35e0f1f0eb86$var$LoadingBarInner = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  animation: ${$132e35e0f1f0eb86$var$LoadingBarAnimation} ${({ animationSpeed: animationSpeed })=>animationSpeed}s alternate infinite linear;
  background-color: rgba(0, 0, 0, 0.1);
  background: linear-gradient(-45deg, rgb(155 158 177 / 50%), rgb(155 158 177 / 30%));
  border-radius: 5px;
  width: 50px;
  height: 20px;
`;
const $132e35e0f1f0eb86$var$LoadingBar = ({ animationSpeed: animationSpeed = 0.5, style: style })=>{
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($132e35e0f1f0eb86$var$LoadingBarInner, {
        animationSpeed: animationSpeed,
        style: style
    });
};
var $132e35e0f1f0eb86$export$2e2bcd8739ae039 = $132e35e0f1f0eb86$var$LoadingBar;





const $29b678b206bd49d4$var$FadeInWrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  animation: ${(0, $aeddef6c40752364$export$bd7370ffb2917ab7)} 0.5s ease;
  font-size: 14px;
  min-width: 100%;
  height: 100vh;
  background-color: white;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
const $29b678b206bd49d4$var$LoadingCheckout = ()=>{
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($29b678b206bd49d4$var$FadeInWrapper, {
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $8652974033b0a752$export$e3b4754a92ccf466), {
                slantedEdge: false,
                background: "linear-gradient(to top right,#edf4fb,#F8F8FB)",
                textColor: "black",
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            maxWidth: "400px",
                            paddingTop: 40,
                            paddingBottom: 40
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                style: {
                                    position: "absolute",
                                    top: 30,
                                    left: 30,
                                    width: 30,
                                    height: 30
                                }
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                style: {
                                    width: 160,
                                    height: 160
                                }
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                style: {
                                    width: 200,
                                    height: 35
                                }
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                style: {
                                    width: 160,
                                    height: 25
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                        href: "https://radom.com",
                        target: "_blank",
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: 14,
                            color: "rgba(0, 0, 0, 0.45)",
                            fontWeight: 100,
                            position: "absolute",
                            bottom: 30,
                            left: 30,
                            textDecoration: "none"
                        },
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                children: "Checkout by"
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                width: 50,
                                fill: "rgba(0, 0, 0, 0.5)"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $8652974033b0a752$export$7fcbc7dd475548f6), {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                    style: {
                        width: "100%",
                        maxWidth: 420
                    },
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            maxWidth: "400px",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            justifyContent: "center",
                            alignItems: "center",
                            margin: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                animationSpeed: 1,
                                style: {
                                    width: "100%",
                                    height: 35
                                }
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                animationSpeed: 1.1,
                                style: {
                                    width: "100%",
                                    height: 35
                                }
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                animationSpeed: 1.2,
                                style: {
                                    width: "100%",
                                    height: 35
                                }
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                animationSpeed: 1.3,
                                style: {
                                    width: "100%",
                                    height: 35
                                }
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                animationSpeed: 1.4,
                                style: {
                                    width: "100%",
                                    height: 35
                                }
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $29b678b206bd49d4$export$2e2bcd8739ae039 = $29b678b206bd49d4$var$LoadingCheckout;



var $jtAZT = parcelRequire("jtAZT");
var $43d4df94ebd065cc$require$Buffer = $jtAZT.Buffer;
const $43d4df94ebd065cc$export$8e7009dd18ef5a83 = (hash)=>{
    const encoded = hash.replace(/^#/, "");
    if (!encoded) return undefined;
    try {
        return JSON.parse($43d4df94ebd065cc$require$Buffer.from(encoded, "base64").toString("utf8"));
    } catch  {
        return undefined;
    }
};


const $46dd2823527947d2$var$qaTimestamp = "2026-04-21T00:00:00.000Z";
const $46dd2823527947d2$var$sellerAddress = "0x1111111111111111111111111111111111111111";
const $46dd2823527947d2$var$launchPlan = {
    id: "qa-product-launch-plan",
    name: "Launch plan",
    description: "One-time onboarding and payment setup package.",
    chargingIntervalSeconds: 0,
    currency: "GBP",
    price: 100,
    createdAt: new Date($46dd2823527947d2$var$qaTimestamp),
    imageUrl: "",
    updatedAt: new Date($46dd2823527947d2$var$qaTimestamp),
    sellerAddress: $46dd2823527947d2$var$sellerAddress
};
const $46dd2823527947d2$var$prioritySupport = {
    id: "qa-product-priority-support",
    name: "Priority support",
    description: "Monthly priority support for merchant operations.",
    chargingIntervalSeconds: 2592000,
    currency: "GBP",
    price: 49,
    createdAt: new Date($46dd2823527947d2$var$qaTimestamp),
    imageUrl: "",
    updatedAt: new Date($46dd2823527947d2$var$qaTimestamp),
    sellerAddress: $46dd2823527947d2$var$sellerAddress
};
const $46dd2823527947d2$var$platformAccess = {
    id: "qa-product-platform-access",
    name: "Platform access",
    description: "Annual platform access for payment operations.",
    chargingIntervalSeconds: 0,
    currency: "GBP",
    price: 1200,
    createdAt: new Date($46dd2823527947d2$var$qaTimestamp),
    imageUrl: "",
    updatedAt: new Date($46dd2823527947d2$var$qaTimestamp),
    sellerAddress: $46dd2823527947d2$var$sellerAddress
};
const $46dd2823527947d2$export$89b987e009802937 = {
    id: "qa-payment-link-preview",
    url: "/payment_link/qa-payment-link-preview",
    products: [
        $46dd2823527947d2$var$launchPlan,
        $46dd2823527947d2$var$prioritySupport
    ],
    gateway: {
        managed: {
            methods: [
                {
                    network: "Ethereum"
                },
                {
                    network: "Base"
                },
                {
                    network: "Ethereum",
                    token: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
                },
                {
                    network: "Base",
                    token: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913"
                },
                {
                    network: "Solana",
                    token: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
                }
            ]
        }
    },
    customizations: {
        leftPanelColor: "rgba(0,0,0,1)",
        primaryButtonColor: "#0a2540",
        slantedEdge: false,
        allowDiscountCodes: true,
        allowFreeInputAmount: false
    },
    sellerAddress: $46dd2823527947d2$var$sellerAddress,
    sellerLogoUrl: "",
    sellerName: "Radom QA Studio",
    createdAt: new Date($46dd2823527947d2$var$qaTimestamp),
    updatedAt: new Date($46dd2823527947d2$var$qaTimestamp),
    inputFields: [],
    chargeCustomerNetworkFee: true,
    successUrl: "https://radom.com/checkout/success"
};
const $46dd2823527947d2$export$ad729a2639e08ae4 = {
    id: "qa-invoice-preview",
    sellerAddress: $46dd2823527947d2$var$sellerAddress,
    seller: {
        id: "qa-seller",
        email: "support@radom.example",
        name: "Radom QA Studio"
    },
    gateway: $46dd2823527947d2$export$89b987e009802937.gateway,
    customer: {
        id: "qa-customer-northstar",
        email: "finance@northstar.example",
        name: "Northstar Supply Co.",
        billingAddress: "120 Moorgate, London EC2M 6UR, United Kingdom",
        residenceCountry: "GB",
        companyName: "Northstar Supply Co."
    },
    tokens: [],
    products: [
        {
            product: $46dd2823527947d2$var$platformAccess,
            quantity: 1
        }
    ],
    lineItems: [
        {
            invoiceId: "",
            name: "Implementation workshop",
            quantity: 1,
            price: 450,
            currency: "GBP"
        },
        {
            invoiceId: "",
            name: "Priority support credit",
            quantity: 2,
            price: 125,
            currency: "GBP"
        }
    ],
    issuedAt: new Date($46dd2823527947d2$var$qaTimestamp),
    overdueAt: new Date("2026-05-05T00:00:00.000Z"),
    inputData: [],
    status: "pending",
    memo: "Thanks for choosing Radom. This QA invoice includes a saved customer, product, line items, and several accepted payment methods."
};


function $e97aa13a27cfb8bd$var$PaymentLinkPreview() {
    const location = (0, $6738ab3539650fb6$export$45d76561a5302f2b)();
    const paymentLinkData = (0, $43d4df94ebd065cc$export$8e7009dd18ef5a83)(location.hash) ?? (0, $46dd2823527947d2$export$89b987e009802937);
    if (!paymentLinkData.products || paymentLinkData.products.length <= 0) {
        if (!paymentLinkData.customizations?.allowFreeInputAmount) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $29b678b206bd49d4$export$2e2bcd8739ae039), {});
    }
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $8652974033b0a752$export$2e2bcd8739ae039), {
        checkoutData: {
            ...paymentLinkData,
            products: paymentLinkData.products.map((p)=>{
                return {
                    product: p,
                    quantity: 1
                };
            })
        },
        onCheckout: ()=>{},
        isPreProcessingPayment: false,
        isSuccess: false,
        successElement: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {}),
        hideTravelRuleFields: true,
        travelRuleFieldsCollected: (0, $8652974033b0a752$export$4217e132ac074f47)()
    });
}
var $e97aa13a27cfb8bd$export$2e2bcd8739ae039 = $e97aa13a27cfb8bd$var$PaymentLinkPreview;




var $fDWVA = parcelRequire("fDWVA");

var $bnENU = parcelRequire("bnENU");




parcelRequire("bnENU");






const $296a0ea3087b85aa$var$ReceiptIn = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 0;
    transform: translateY(25%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;
const $296a0ea3087b85aa$export$af661ccd4dd193f2 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  animation: ${$296a0ea3087b85aa$var$ReceiptIn} 0.5s ease;
  box-shadow: rgb(0 0 0 / 15%) 0px 1px 5px;
  padding: 40px;
`;
const $296a0ea3087b85aa$export$763817fece9a8c9d = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NICE_GREEN};
  animation: ${(0, $aeddef6c40752364$export$f9ae25e7d5fbc8b9)} 0.5s ease;
`;


const $4c45ee8cb3cb4e28$var$OutcomeWrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;
const $4c45ee8cb3cb4e28$var$OutcomeHeading = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
`;
const $4c45ee8cb3cb4e28$var$OutcomeNote = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  font-size: 14px;
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST};
  text-align: center;
`;
const $4c45ee8cb3cb4e28$export$e2668574711a3262 = ()=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4c45ee8cb3cb4e28$var$OutcomeWrapper, {
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4c45ee8cb3cb4e28$var$OutcomeHeading, {
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d8ee75bdf024b924$export$2e2bcd8739ae039), {
                        width: 30,
                        height: 30,
                        animationDelay: "0.5s",
                        animationSpeed: "0.75s"
                    })
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                    style: {
                        fontSize: 18,
                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                    },
                    children: "Payment successful"
                })
            ]
        })
    });
const $4c45ee8cb3cb4e28$export$de273779fa7d2ee0 = ()=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4c45ee8cb3cb4e28$var$OutcomeWrapper, {
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4c45ee8cb3cb4e28$var$OutcomeHeading, {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                    style: {
                        fontSize: 18,
                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                    },
                    children: "Payment under review"
                })
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4c45ee8cb3cb4e28$var$OutcomeNote, {
                children: "We've received your payment. It's going through a routine compliance check and will be released to the merchant once it clears."
            })
        ]
    });
const $4c45ee8cb3cb4e28$export$790db536b8560d2a = ()=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($4c45ee8cb3cb4e28$var$OutcomeWrapper, {
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4c45ee8cb3cb4e28$var$OutcomeHeading, {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                    style: {
                        fontSize: 18,
                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                    },
                    children: "Confirming your payment"
                })
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($4c45ee8cb3cb4e28$var$OutcomeNote, {
                children: "We've received your transfer and are confirming it. This page updates automatically."
            })
        ]
    });







const $d082008f50ed1b11$var$SESSION_KEY_PREFIX = "radom:checkout-funnel-session";
const $d082008f50ed1b11$var$PERSISTED_SESSION_KEY_TTL_MS = 21600000;
const $d082008f50ed1b11$var$generateSessionKey = ()=>{
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};
const $d082008f50ed1b11$var$getClientMetadata = ()=>{
    if (typeof window === "undefined") return {};
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const isTouch = window.matchMedia("(pointer: coarse)").matches;
    let referrerHost;
    if (document.referrer) try {
        referrerHost = new URL(document.referrer).hostname;
    } catch  {
        referrerHost = undefined;
    }
    const deviceType = viewportWidth <= 768 ? "mobile" : viewportWidth <= 1024 ? "tablet" : "desktop";
    return {
        checkoutClient: "pay-web",
        pagePath: window.location.pathname,
        referrerHost: referrerHost,
        viewportWidth: viewportWidth,
        viewportHeight: viewportHeight,
        deviceType: deviceType,
        inputMode: isTouch ? "touch" : "mouse",
        locale: typeof navigator !== "undefined" ? navigator.language : undefined,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };
};
const $d082008f50ed1b11$export$38ac8d36077d011 = (sourceType, sourceId)=>{
    if (typeof window === "undefined") return `${sourceType}-${sourceId}`;
    const storageKey = `${$d082008f50ed1b11$var$SESSION_KEY_PREFIX}:${sourceType}:${sourceId}`;
    const existing = $d082008f50ed1b11$var$getStoredSessionKey(window.sessionStorage, storageKey) ?? $d082008f50ed1b11$var$getStoredSessionKey(window.localStorage, storageKey, $d082008f50ed1b11$var$PERSISTED_SESSION_KEY_TTL_MS);
    if (existing) {
        $d082008f50ed1b11$var$persistSessionKey(window.sessionStorage, storageKey, existing);
        $d082008f50ed1b11$var$persistSessionKey(window.localStorage, storageKey, existing, true);
        return existing;
    }
    const sessionKey = `${sourceType}-${sourceId}-${$d082008f50ed1b11$var$generateSessionKey()}`;
    $d082008f50ed1b11$var$persistSessionKey(window.sessionStorage, storageKey, sessionKey);
    $d082008f50ed1b11$var$persistSessionKey(window.localStorage, storageKey, sessionKey, true);
    return sessionKey;
};
const $d082008f50ed1b11$var$parseStoredSessionKey = (raw, ttlMs)=>{
    try {
        const parsed = JSON.parse(raw);
        if (typeof parsed.sessionKey !== "string" || parsed.sessionKey.length === 0) return undefined;
        if (ttlMs !== undefined) {
            const createdAt = typeof parsed.createdAt === "number" ? parsed.createdAt : 0;
            if (Date.now() - createdAt > ttlMs) return undefined;
        }
        return parsed.sessionKey;
    } catch  {
        return raw.length > 0 ? raw : undefined;
    }
};
const $d082008f50ed1b11$var$getStoredSessionKey = (storage, storageKey, ttlMs)=>{
    try {
        const raw = storage.getItem(storageKey);
        if (!raw) return undefined;
        return $d082008f50ed1b11$var$parseStoredSessionKey(raw, ttlMs);
    } catch  {
        return undefined;
    }
};
const $d082008f50ed1b11$var$persistSessionKey = (storage, storageKey, sessionKey, includeTimestamp = false)=>{
    try {
        storage.setItem(storageKey, includeTimestamp ? JSON.stringify({
            sessionKey: sessionKey,
            createdAt: Date.now()
        }) : sessionKey);
    } catch  {}
};
const $d082008f50ed1b11$export$e763aef27fa496d8 = async ({ sourceType: sourceType, sourceId: sourceId, rail: rail, step: step, metadata: metadata })=>{
    const trackEvent = (0, $43c053927acc0cba$export$2e2bcd8739ae039)?.trackCheckoutFunnelEvent;
    if (typeof trackEvent !== "function") return;
    try {
        await trackEvent.call((0, $43c053927acc0cba$export$2e2bcd8739ae039), {
            sourceType: sourceType,
            sourceId: sourceId,
            rail: rail,
            step: step,
            sessionKey: $d082008f50ed1b11$export$38ac8d36077d011(sourceType, sourceId),
            metadata: {
                ...$d082008f50ed1b11$var$getClientMetadata(),
                ...metadata
            }
        });
    } catch (err) {
        console.warn("Failed to track checkout funnel step", err);
    }
};


const $f8c8710feaaa9285$var$STORAGE_PREFIX = "radom.paymentSession";
const $f8c8710feaaa9285$var$MAX_SESSION_AGE_MS = 86400000;
const $f8c8710feaaa9285$var$storageKey = (sourceId)=>`${$f8c8710feaaa9285$var$STORAGE_PREFIX}.${sourceId}`;
const $f8c8710feaaa9285$var$storages = ()=>{
    if (typeof window === "undefined") return [];
    const available = [];
    try {
        available.push(window.localStorage);
    } catch  {}
    try {
        available.push(window.sessionStorage);
    } catch  {}
    return available;
};
const $f8c8710feaaa9285$var$isExpired = (session)=>!session.savedAt || Date.now() - session.savedAt > $f8c8710feaaa9285$var$MAX_SESSION_AGE_MS;
const $f8c8710feaaa9285$export$b96aa13c6879f837 = (sourceId, session)=>{
    const payload = JSON.stringify({
        ...session,
        savedAt: session.savedAt ?? Date.now()
    });
    $f8c8710feaaa9285$var$storages().forEach((storage)=>{
        try {
            storage.setItem($f8c8710feaaa9285$var$storageKey(sourceId), payload);
        } catch  {}
    });
};
const $f8c8710feaaa9285$export$f4d961d73df7b7b = (sourceId)=>{
    for (const storage of $f8c8710feaaa9285$var$storages()){
        let session;
        try {
            const raw = storage.getItem($f8c8710feaaa9285$var$storageKey(sourceId));
            if (!raw) continue;
            session = JSON.parse(raw);
        } catch  {
            continue;
        }
        if (!session.managed && !session.tokenDelegate) continue;
        if ($f8c8710feaaa9285$var$isExpired(session)) {
            $f8c8710feaaa9285$export$a774b110a5502c04(sourceId);
            return undefined;
        }
        return session;
    }
    return undefined;
};
const $f8c8710feaaa9285$export$a774b110a5502c04 = (sourceId)=>{
    $f8c8710feaaa9285$var$storages().forEach((storage)=>{
        try {
            storage.removeItem($f8c8710feaaa9285$var$storageKey(sourceId));
        } catch  {}
    });
};



parcelRequire("bnENU");



const $7c18a005ad02503d$var$Wrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 100%;
  min-width: ${({ fullPage: fullPage = true })=>fullPage ? "100vw" : "100%"};
  min-height: ${({ fullPage: fullPage = true })=>fullPage ? "100vh" : "220px"};
  display: flex;
  align-items: ${({ fullPage: fullPage = true })=>fullPage ? "flex-start" : "center"};
  justify-content: center;
  padding: ${({ fullPage: fullPage = true })=>fullPage ? "64px 24px 24px" : "24px 0"};
  box-sizing: border-box;
  background: transparent;
`;
const $7c18a005ad02503d$var$Content = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 560px;
  text-align: center;
  color: #111827;
`;
const $7c18a005ad02503d$var$Title = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: 22px;
  line-height: 1.2;
  font-weight: 600;
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK};
`;
const $7c18a005ad02503d$var$Message = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #4b5565;
`;
const $7c18a005ad02503d$var$PageLoadState = ({ title: title = "Unable to load page", message: message, fullPage: fullPage = true, onRetry: onRetry, retryLabel: retryLabel = "Retry" })=>{
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($7c18a005ad02503d$var$Wrapper, {
        fullPage: fullPage,
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($7c18a005ad02503d$var$Content, {
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($7c18a005ad02503d$var$Title, {
                    children: title
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($7c18a005ad02503d$var$Message, {
                    children: message
                }),
                onRetry && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                    onClick: ()=>{
                        onRetry();
                    },
                    style: {
                        minWidth: 132,
                        marginTop: 6,
                        borderRadius: 12
                    },
                    children: retryLabel
                })
            ]
        })
    });
};
var $7c18a005ad02503d$export$2e2bcd8739ae039 = $7c18a005ad02503d$var$PageLoadState;



const $7c89e1c32e8657b1$var$PAYMENT_LINK_REDIRECT_DELAY_SECONDS = 3;
const $7c89e1c32e8657b1$var$TOKEN_AMOUNT_KEY = "Token amount";
// ---------------------------------------------------------------------------------------------------------------------
function $7c89e1c32e8657b1$var$PaymentLink() {
    const paymentLinkId = window.location.pathname.split("/").filter(Boolean).pop() ?? "";
    const [searchParams] = (0, $f0e8e6c6e69cddf0$export$f1a78c17382fe22a)();
    const [total, setTotal] = (0, $bnENU.useState)(0);
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(true);
    const [loadError, setLoadError] = (0, $bnENU.useState)("");
    const [paymentLinkData, setPaymentLinkData] = (0, $bnENU.useState)();
    const [sellerProfile, setSellerProfile] = (0, $bnENU.useState)();
    const [currency, setCurrency] = (0, $bnENU.useState)("USD");
    const [isPreProcessingPayment, setIsPreProcessingPayment] = (0, $bnENU.useState)(false);
    const [isSuccess, setIsSuccess] = (0, $bnENU.useState)(false);
    const [countdown, setCountdown] = (0, $bnENU.useState)(10);
    const [errorMessage, setErrorMessage] = (0, $bnENU.useState)("");
    const [inputFields, setInputFields] = (0, $bnENU.useState)([]);
    const [successElement, setSuccessElement] = (0, $bnENU.useState)(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {}));
    const [discountResult, setDiscountResult] = (0, $bnENU.useState)({
        success: false,
        element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {})
    });
    const [discount, setDiscount] = (0, $bnENU.useState)();
    const [discountLocked, setDiscountLocked] = (0, $bnENU.useState)(false);
    const [paymentStatus, setPaymentStatus] = (0, $bnENU.useState)();
    const trackedFunnelStepsRef = (0, $bnENU.useRef)(new Set());
    const managedPollingIntervalRef = (0, $bnENU.useRef)(null);
    const [managedPaymentDetails, setManagedPaymentDetails] = (0, $bnENU.useState)();
    const [tokenDelegatePaymentDetails, setTokenDelegatePaymentDetails] = (0, $bnENU.useState)();
    const clearManagedPaymentPolling = ()=>{
        if (managedPollingIntervalRef.current) {
            clearInterval(managedPollingIntervalRef.current);
            managedPollingIntervalRef.current = null;
        }
    };
    const trackFunnelStepOnce = (step, sourceId)=>{
        if (trackedFunnelStepsRef.current.has(step)) return;
        trackedFunnelStepsRef.current.add(step);
        (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
            sourceType: "paymentLink",
            sourceId: sourceId,
            rail: "crypto",
            step: step
        });
    };
    const startManagedPaymentPolling = (managed)=>{
        if (!paymentLinkData) return;
        const sourceId = paymentLinkData.id;
        clearManagedPaymentPolling();
        let appliedOutcome;
        managedPollingIntervalRef.current = setInterval(()=>{
            (0, $43c053927acc0cba$export$2e2bcd8739ae039).getManagedPaymentStatus(managed.paymentId).then((res)=>{
                setPaymentStatus(res);
                if (res.status === "inReview") {
                    if (appliedOutcome !== "inReview") {
                        appliedOutcome = "inReview";
                        setIsSuccess(true);
                        setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$de273779fa7d2ee0), {}));
                    }
                    return;
                }
                if (res.status === "paymentConfirmed") {
                    appliedOutcome = "paymentConfirmed";
                    trackFunnelStepOnce("paymentConfirmed", sourceId);
                    (0, $f8c8710feaaa9285$export$a774b110a5502c04)(sourceId);
                    setIsSuccess(true);
                    clearManagedPaymentPolling();
                    setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$e2668574711a3262), {}));
                }
                if (res.status === "failed" || res.status === "expired") {
                    if (res.status === "failed") trackFunnelStepOnce("paymentFailed", sourceId);
                    (0, $f8c8710feaaa9285$export$a774b110a5502c04)(sourceId);
                    clearManagedPaymentPolling();
                }
            }).catch(()=>{});
        }, 1000);
    };
    const startTokenDelegatePolling = (paymentId)=>{
        if (!paymentLinkData) return;
        const sourceId = paymentLinkData.id;
        clearManagedPaymentPolling();
        let appliedOutcome;
        managedPollingIntervalRef.current = setInterval(()=>{
            (0, $43c053927acc0cba$export$2e2bcd8739ae039).getManagedTokenPaymentStatus(paymentId).then((res)=>{
                setPaymentStatus(res);
                if (res.status === "inReview") {
                    if (appliedOutcome !== "inReview") {
                        appliedOutcome = "inReview";
                        setIsPreProcessingPayment(false);
                        setIsSuccess(true);
                        setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$de273779fa7d2ee0), {}));
                    }
                    return;
                }
                if (res.status === "paymentConfirmed") {
                    appliedOutcome = "paymentConfirmed";
                    trackFunnelStepOnce("paymentConfirmed", sourceId);
                    (0, $f8c8710feaaa9285$export$a774b110a5502c04)(sourceId);
                    setIsPreProcessingPayment(false);
                    setIsSuccess(true);
                    clearManagedPaymentPolling();
                    setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$e2668574711a3262), {}));
                }
                if (res.status === "failed") {
                    trackFunnelStepOnce("paymentFailed", sourceId);
                    (0, $f8c8710feaaa9285$export$a774b110a5502c04)(sourceId);
                    clearManagedPaymentPolling();
                    setIsPreProcessingPayment(false);
                    setTokenDelegatePaymentDetails(undefined);
                    setErrorMessage("Transaction failed, please try again.");
                }
            }).catch(()=>{});
        }, 1000);
    };
    (0, $bnENU.useEffect)(()=>{
        if (!paymentLinkData || managedPollingIntervalRef.current) return;
        const session = (0, $f8c8710feaaa9285$export$f4d961d73df7b7b)(paymentLinkData.id);
        if (!session) return;
        if (session.managed) {
            setDiscountLocked(true);
            setManagedPaymentDetails(session.managed);
            startManagedPaymentPolling(session.managed);
            return;
        }
        if (session.tokenDelegate && session.delegateSubmitted) {
            setDiscountLocked(true);
            setIsPreProcessingPayment(true);
            setTokenDelegatePaymentDetails(session.tokenDelegate);
            startTokenDelegatePolling(session.tokenDelegate.paymentId);
        }
    }, [
        paymentLinkData
    ]);
    (0, $bnENU.useEffect)(()=>clearManagedPaymentPolling, []);
    (0, $bnENU.useEffect)(()=>{
        const discountCode = searchParams.get("discountCode");
        if (discountCode) redeemDiscountCode(discountCode);
        if (Array.isArray(paymentLinkData?.inputFields)) {
            const inputFields = [];
            for (const input of paymentLinkData.inputFields){
                const prefilledValue = searchParams.get((0, $fDWVA.camelCase)(input.inputLabel));
                inputFields.push({
                    ...input,
                    value: prefilledValue ?? ""
                });
            }
            setInputFields(inputFields);
        }
    }, [
        searchParams,
        paymentLinkData
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (!paymentLinkData?.isPresale) return;
        if (!window.location.pathname.startsWith("/payment_link/")) return;
        const search = window.location.search;
        window.location.replace(`/presale/${paymentLinkData.id}${search}`);
    }, [
        paymentLinkData
    ]);
    const redeemDiscountCode = async (discountCode)=>{
        setDiscountResult({
            success: false,
            element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {})
        });
        (0, $43c053927acc0cba$export$2e2bcd8739ae039).redeemDiscountCode({
            paymentLinkId: paymentLinkId,
            code: discountCode
        }).then((discount)=>{
            setDiscount(discount);
            setDiscountResult({
                success: true,
                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        gap: 10,
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                            children: "Discount applied!"
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                            style: {
                                padding: 5,
                                backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS,
                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS_LIGHT,
                                borderRadius: 5,
                                fontWeight: 600,
                                fontSize: 12
                            },
                            children: [
                                discount.model.modelType === "percentage" ? new Intl.NumberFormat("en-US", {
                                    style: "percent",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }).format(discount.model.amountOff / 100) : (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, discount.model.amountOff),
                                " OFF"
                            ]
                        })
                    ]
                })
            });
        }).catch((_)=>{
            setDiscountResult({
                success: false,
                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                    style: {
                        opacity: 0.5,
                        fontSize: 12
                    },
                    children: "Invalid discount code"
                })
            });
        });
    };
    const onCheckout = async ({ managed: managed, completeTokenDelegate: completeTokenDelegate, subscriptionOptions: subscriptionOptions, travelRuleFields: travelRuleFields, freeInput: freeInput })=>{
        setErrorMessage("");
        if (!paymentLinkData) {
            setErrorMessage("Payment link data not set. Please refresh and try again.");
            return;
        }
        if (!travelRuleFields) {
            setErrorMessage("Travel rule fields are required. Please refresh and try again.");
            return;
        }
        if (!trackedFunnelStepsRef.current.has("travelRuleCompleted")) {
            trackedFunnelStepsRef.current.add("travelRuleCompleted");
            (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
                sourceType: "paymentLink",
                sourceId: paymentLinkData.id,
                rail: "crypto",
                step: "travelRuleCompleted"
            });
        }
        if (managed) {
            const storedSession = (0, $f8c8710feaaa9285$export$f4d961d73df7b7b)(paymentLinkData.id);
            if (storedSession?.managed) {
                setDiscountLocked(true);
                setManagedPaymentDetails(storedSession.managed);
                startManagedPaymentPolling(storedSession.managed);
                return;
            }
            const { selectedMethod: method } = managed;
            const safeProducts = Array.isArray(paymentLinkData.products) ? paymentLinkData.products : [];
            const checkoutAmount = freeInput?.amount ?? total;
            const checkoutCurrency = freeInput?.currency ?? currency;
            const presaleProduct = safeProducts.find((product)=>product.productType?.Presale?.Token);
            const tokenAmountDecimals = Number(presaleProduct?.productType?.Presale?.Token?.decimals ?? 6);
            const canDeriveFreeInputPresaleAmount = !!presaleProduct && paymentLinkData.customizations.allowFreeInputAmount && checkoutCurrency === presaleProduct.currency;
            const derivedPurchaseAmount = canDeriveFreeInputPresaleAmount ? checkoutAmount : safeProducts.reduce((sum, product)=>sum + Number(product.price ?? 0), 0);
            const derivedTokenAmount = presaleProduct && Number(presaleProduct.price) > 0 && Number.isFinite(derivedPurchaseAmount) ? (derivedPurchaseAmount / Number(presaleProduct.price)).toFixed(Math.max(0, Math.min(12, tokenAmountDecimals))).replace(/(\.\d*?[1-9])0+$/, "$1").replace(/\.0+$/, "") : undefined;
            const orderData = inputFields.map((c)=>{
                return {
                    key: c.inputLabel,
                    value: c.value.toString()
                };
            }).filter((entry)=>entry.key !== $7c89e1c32e8657b1$var$TOKEN_AMOUNT_KEY);
            if (derivedTokenAmount && derivedTokenAmount.length > 0) orderData.push({
                key: $7c89e1c32e8657b1$var$TOKEN_AMOUNT_KEY,
                value: derivedTokenAmount
            });
            let paymentMethod = {
                managed: {
                    method: {
                        network: method.tokenInfo?.networkName ?? method.name,
                        token: method.tokenInfo?.tokenAddress ?? undefined
                    }
                }
            };
            if (subscriptionOptions) {
                if (subscriptionOptions.autopay) {
                    if (!method.tokenInfo) {
                        setErrorMessage("Cannot set up an autopay subscription without an EVM based token");
                        return;
                    }
                    paymentMethod = {
                        managedTokenDelegate: {
                            buyerAddress: subscriptionOptions.autopay.address,
                            network: method.tokenInfo.networkName,
                            token: method.tokenInfo.tokenAddress
                        }
                    };
                }
                if (subscriptionOptions.emailInvoice) {
                    if (!subscriptionOptions.emailInvoice.emailAddress) {
                        setErrorMessage("Cannot set up an email invoice subscription without an email address");
                        return;
                    }
                }
            }
            setIsPreProcessingPayment(true);
            try {
                const res = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).createPaymentLinkOrder({
                    paymentLinkId: paymentLinkData.id,
                    paymentMethod: paymentMethod,
                    orderData: orderData,
                    amount: paymentLinkData.customizations.allowFreeInputAmount ? checkoutAmount : undefined,
                    currency: paymentLinkData.customizations.allowFreeInputAmount ? checkoutCurrency : undefined,
                    orderProductData: [],
                    discountCode: discount?.code,
                    emailAddress: subscriptionOptions?.emailInvoice?.emailAddress.toLowerCase(),
                    travelRuleFields: travelRuleFields
                });
                if (!trackedFunnelStepsRef.current.has("paymentInitiated")) {
                    trackedFunnelStepsRef.current.add("paymentInitiated");
                    (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
                        sourceType: "paymentLink",
                        sourceId: paymentLinkData.id,
                        rail: "crypto",
                        step: "paymentInitiated",
                        metadata: {
                            network: method.tokenInfo?.networkName ?? method.name,
                            tokenAddress: method.tokenInfo?.tokenAddress
                        }
                    });
                }
                setDiscountLocked(true);
                if (res.paymentMethodDetails.managed) {
                    const managedDetails = res.paymentMethodDetails.managed;
                    setManagedPaymentDetails(managedDetails);
                    (0, $f8c8710feaaa9285$export$b96aa13c6879f837)(paymentLinkData.id, {
                        managed: managedDetails
                    });
                    startManagedPaymentPolling(managedDetails);
                } else if (res.paymentMethodDetails.managedTokenDelegate) {
                    const delegateDetails = res.paymentMethodDetails.managedTokenDelegate;
                    setTokenDelegatePaymentDetails(delegateDetails);
                    (0, $f8c8710feaaa9285$export$b96aa13c6879f837)(paymentLinkData.id, {
                        tokenDelegate: delegateDetails
                    });
                } else throw new Error("Unexpected empty managed payment method details");
            } catch (err) {
                console.error(err);
                setErrorMessage(err.reason || err.message);
                throw err;
            }
            setIsPreProcessingPayment(false);
            return;
        }
        if (completeTokenDelegate) {
            const { paymentId: paymentId, signature: signature } = completeTokenDelegate;
            setIsPreProcessingPayment(true);
            try {
                await (0, $43c053927acc0cba$export$2e2bcd8739ae039).completeTokenDelegatePayment(paymentId, signature);
                if (tokenDelegatePaymentDetails) (0, $f8c8710feaaa9285$export$b96aa13c6879f837)(paymentLinkData.id, {
                    tokenDelegate: tokenDelegatePaymentDetails,
                    delegateSubmitted: true
                });
                startTokenDelegatePolling(paymentId);
            } catch (err) {
                setIsPreProcessingPayment(false);
                setErrorMessage(err.reason || err.message);
                throw err;
            }
            return;
        }
        setErrorMessage("Oops, something went wrong.");
    };
    (0, $bnENU.useEffect)(()=>{
        if (!paymentLinkData) return;
        if (trackedFunnelStepsRef.current.has("viewed")) return;
        trackedFunnelStepsRef.current.add("viewed");
        (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
            sourceType: "paymentLink",
            sourceId: paymentLinkData.id,
            rail: "crypto",
            step: "viewed"
        });
    }, [
        paymentLinkData?.id
    ]);
    (0, $bnENU.useEffect)(()=>{
        let cancelled = false;
        const loadPaymentLink = async ()=>{
            try {
                const data = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getPaymentLink(paymentLinkId);
                if (cancelled) return;
                const safeInputFields = Array.isArray(data.inputFields) ? data.inputFields : [];
                setPaymentLinkData(data);
                setInputFields(safeInputFields.map((c)=>{
                    return {
                        ...c,
                        value: ""
                    };
                }));
                if (data.sellerAddress) try {
                    const profile = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getSellerProfile(data.sellerAddress);
                    if (cancelled) return;
                    setSellerProfile(profile);
                } catch (profileErr) {
                    console.warn("Failed to load seller profile for payment link", profileErr);
                }
            } catch (err) {
                console.error(err);
                if (!cancelled) setLoadError(err?.message ?? err?.response?.data?.error ?? "Payment link is unavailable");
            } finally{
                if (!cancelled) setIsLoading(false);
            }
        };
        loadPaymentLink();
        return ()=>{
            cancelled = true;
        };
    }, [
        paymentLinkId
    ]);
    (0, $bnENU.useEffect)(()=>{
        let countdownTimer;
        let redirectTimer;
        if (isSuccess && paymentLinkData?.successUrl) {
            // Start the countdown timer
            const initialCountdown = $7c89e1c32e8657b1$var$PAYMENT_LINK_REDIRECT_DELAY_SECONDS;
            countdownTimer = setInterval(()=>{
                setCountdown((countdown)=>Math.max(countdown - 1, 0));
            }, 1000);
            setCountdown(initialCountdown);
            // Start the redirect timer
            redirectTimer = setTimeout(()=>{
                window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(paymentLinkData?.successUrl);
            }, $7c89e1c32e8657b1$var$PAYMENT_LINK_REDIRECT_DELAY_SECONDS * 1000);
        }
        // Clean up the timers when the component unmounts or the values change
        return ()=>{
            clearInterval(countdownTimer);
            clearTimeout(redirectTimer);
        };
    }, [
        isSuccess,
        paymentLinkData
    ]);
    // Update the countdown label whenever the countdown value changes
    (0, $bnENU.useEffect)(()=>{
        if (countdown > 0 && countdown < $7c89e1c32e8657b1$var$PAYMENT_LINK_REDIRECT_DELAY_SECONDS && isSuccess) document.title = `Redirecting in ${countdown} seconds`;
        else if (isSuccess && countdown === 0) document.title = "Redirecting...";
    }, [
        countdown,
        isSuccess
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $29b678b206bd49d4$export$2e2bcd8739ae039), {});
    if (loadError || !paymentLinkData) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7c18a005ad02503d$export$2e2bcd8739ae039), {
        title: "Payment link unavailable",
        message: loadError || "This payment link could not be loaded right now.",
        onRetry: async ()=>{
            window.location.reload();
        }
    });
    const safeProducts = Array.isArray(paymentLinkData.products) ? paymentLinkData.products : [];
    if (safeProducts.length <= 0 && !paymentLinkData.customizations.allowFreeInputAmount) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            minWidth: "100vw",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "white",
            color: "#111827",
            padding: 24,
            textAlign: "center"
        },
        children: "This payment link is currently unavailable."
    });
    const normalizedPaymentLinkTotal = paymentLinkData.total == null ? undefined : Number(paymentLinkData.total);
    const checkoutCurrency = paymentLinkData.currency ?? safeProducts[0]?.currency ?? currency;
    // For a pyament link, all travel rule fields must be collected from the end user at checkout time
    // Hence travelRuleFieldsCollected argument must be set to collect all fields
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $8652974033b0a752$export$2e2bcd8739ae039), {
        checkoutData: {
            ...paymentLinkData,
            total: normalizedPaymentLinkTotal !== undefined && Number.isFinite(normalizedPaymentLinkTotal) ? normalizedPaymentLinkTotal : undefined,
            currency: checkoutCurrency,
            sellerName: sellerProfile?.name ?? paymentLinkData.sellerName,
            sellerLogoUrl: sellerProfile?.logoUrl ?? paymentLinkData.sellerLogoUrl,
            products: safeProducts.map((p)=>{
                return {
                    product: p,
                    quantity: 1
                };
            }),
            inputFields: inputFields
        },
        onInputFieldsChange: setInputFields,
        onCheckout: onCheckout,
        managedPaymentDetails: managedPaymentDetails,
        tokenDelegatePaymentDetails: tokenDelegatePaymentDetails,
        onChangePaymentMethod: ()=>{
            clearManagedPaymentPolling();
            if (paymentLinkData) (0, $f8c8710feaaa9285$export$a774b110a5502c04)(paymentLinkData.id);
            setManagedPaymentDetails(undefined);
            setTokenDelegatePaymentDetails(undefined);
            setPaymentStatus(undefined);
            setErrorMessage("");
            setIsPreProcessingPayment(false);
        },
        isPreProcessingPayment: isPreProcessingPayment,
        isSuccess: isSuccess,
        errorMessage: errorMessage,
        onCurrency: (currency)=>setCurrency(currency),
        onTotalChange: (total)=>setTotal(total),
        onDiscountCodeEntered: async (discountCode)=>await redeemDiscountCode(discountCode),
        discountResult: discountResult,
        discount: discount,
        discountLocked: discountLocked,
        resetDiscountCode: ()=>{
            setDiscountResult({
                success: false,
                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {})
            });
            setDiscount(undefined);
        },
        successElement: successElement,
        paymentStatus: paymentStatus,
        travelRuleFieldsCollected: (0, $8652974033b0a752$export$3e77b1380e63cfaf)()
    });
}
var $7c89e1c32e8657b1$export$2e2bcd8739ae039 = $7c89e1c32e8657b1$var$PaymentLink;




var $bnENU = parcelRequire("bnENU");




















var $bnENU = parcelRequire("bnENU");

const $070d885cb609f38e$var$x = (0, $bnENU.memo)(({ checkoutUrl: e, onSuccess: r, onCancel: t, displayOptions: o })=>((0, $bnENU.useEffect)(()=>{
        const s = (n)=>{
            try {
                const u = new URL(e);
                if (new URL(n.origin).hostname !== u.hostname) return;
            } catch  {
                return;
            }
            const a = $070d885cb609f38e$var$L(n);
            if (!a) return;
            const { value: i, redirectUrl: l, referenceId: d } = a;
            i === "success" && r({
                redirectUrl: l,
                referenceId: d
            }), i === "error" && t({
                redirectUrl: l,
                referenceId: d
            });
        };
        return window.addEventListener("message", s), ()=>window.removeEventListener("message", s);
    }, [
        r,
        t,
        e
    ]), /* @__PURE__ */ (0, $7476e21157772a88$exports.jsx)("iframe", {
        title: "Checkout screen",
        className: "ivy-embedded-checkout-screen",
        style: {
            maxHeight: o.maxHeight,
            maxWidth: o.maxWidth
        },
        sandbox: "allow-scripts allow-same-origin allow-popups allow-forms allow-popups-to-escape-sandbox allow-top-navigation",
        allow: "clipboard-write",
        src: $070d885cb609f38e$var$b(e)
    }))), $070d885cb609f38e$var$b = (e)=>{
    const r = new URL(e);
    return r.searchParams.set("iframe", "true"), r.toString();
}, $070d885cb609f38e$var$L = (e)=>{
    if (typeof e.data != "string") return null;
    try {
        const r = JSON.parse(e.data);
        if (typeof r != "object" || Array.isArray(r) || r === null) return null;
        const t = $070d885cb609f38e$var$m(r.source), o = $070d885cb609f38e$var$m(r.source), s = $070d885cb609f38e$var$E(r.value);
        return t !== "ivy" || o === "iframe" || !s ? null : {
            value: s,
            redirectUrl: $070d885cb609f38e$var$m(r.redirectUrl) ?? "",
            referenceId: $070d885cb609f38e$var$m(r.referenceId) ?? ""
        };
    } catch  {
        return null;
    }
}, $070d885cb609f38e$var$M = (e)=>typeof e == "string" && [
        "success",
        "error"
    ].includes(e), $070d885cb609f38e$var$E = (e)=>$070d885cb609f38e$var$M(e) ? e : null, $070d885cb609f38e$var$m = (e)=>typeof e == "string" ? e : null, $070d885cb609f38e$var$I = ({ url: e, maxWidth: r, maxHeight: t })=>/* @__PURE__ */ (0, $7476e21157772a88$exports.jsx)("div", {
        className: "ivy-modal-container",
        children: /* @__PURE__ */ (0, $7476e21157772a88$exports.jsx)("div", {
            className: "ivy-modal-content",
            children: /* @__PURE__ */ (0, $7476e21157772a88$exports.jsx)("div", {
                className: "ivy-modal-iframe-container",
                style: {
                    maxHeight: `${t}px`,
                    maxWidth: `${r}px`
                },
                children: /* @__PURE__ */ (0, $7476e21157772a88$exports.jsx)("iframe", {
                    sandbox: "allow-scripts allow-same-origin allow-popups allow-forms allow-popups-to-escape-sandbox allow-top-navigation",
                    className: "ivy-modal-checkout-screen",
                    id: "ivy-modal-iframe",
                    title: "Checkout screen",
                    allow: "clipboard-write",
                    src: e
                })
            })
        })
    }), $070d885cb609f38e$var$R = (0, $bnENU.memo)(({ checkoutUrl: e, onSuccess: r, onCancel: t, displayOptions: o })=>{
    const s = (0, $bnENU.useRef)();
    return (0, $bnENU.useEffect)(()=>{
        const n = (a)=>{
            try {
                const w = new URL(e);
                if (new URL(a.origin).hostname !== w.hostname) return;
            } catch  {
                return;
            }
            const i = $070d885cb609f38e$var$P(a);
            if (!i) return;
            const { type: l, status: d, redirectUrl: u, referenceId: p } = i;
            l === "redirect" && r({
                redirectUrl: u,
                referenceId: p
            }), (l === "closeModal" || d === "error") && t({
                redirectUrl: u,
                referenceId: p
            });
        };
        return window.addEventListener("message", n), ()=>window.removeEventListener("message", n);
    }, [
        r,
        t,
        e
    ]), (0, $bnENU.useEffect)(()=>(s.current = getComputedStyle(document.body).overflow, document.body.style.overflow = "hidden", ()=>{
            s.current && (document.body.style.overflow = s.current);
        }), []), (0, $93b772b00f04f226$exports.createPortal)(/* @__PURE__ */ (0, $7476e21157772a88$exports.jsx)($070d885cb609f38e$var$I, {
        url: $070d885cb609f38e$var$N(e),
        maxHeight: o.maxHeight || 700,
        maxWidth: o.maxWidth || 520
    }), document.body, "ivy-checkout-modal");
}), $070d885cb609f38e$var$N = (e)=>{
    const r = new URL(e);
    return r.searchParams.set("popup", "true"), r.toString();
}, $070d885cb609f38e$var$P = (e)=>{
    var s, n, a, i, l;
    if (!e.data || typeof e.data != "object" || Array.isArray(e.data) || e.data === null) return null;
    const r = $070d885cb609f38e$var$U((s = e.data) == null ? void 0 : s.type), t = $070d885cb609f38e$var$f((n = e.data) == null ? void 0 : n.source), o = $070d885cb609f38e$var$H((a = e.data) == null ? void 0 : a.status);
    return t !== "ivy" || !r || !o ? null : {
        status: o,
        type: r,
        redirectUrl: $070d885cb609f38e$var$f((i = e.data) == null ? void 0 : i.value) ?? "",
        referenceId: $070d885cb609f38e$var$f((l = e.data) == null ? void 0 : l.referenceId) ?? ""
    };
}, $070d885cb609f38e$var$C = (e)=>typeof e == "string" && [
        "success",
        "error"
    ].includes(e), $070d885cb609f38e$var$H = (e)=>$070d885cb609f38e$var$C(e) ? e : null, $070d885cb609f38e$var$S = (e)=>typeof e == "string" && [
        "redirect",
        "closeModal"
    ].includes(e), $070d885cb609f38e$var$U = (e)=>$070d885cb609f38e$var$S(e) ? e : null, $070d885cb609f38e$var$f = (e)=>typeof e == "string" ? e : null, $070d885cb609f38e$export$9ef8e5c12230ae65 = ({ checkoutUrl: e, displayOptions: r, onCancel: t, onSuccess: o })=>{
    if (!e) return null;
    if (r.type === "embedded") return /* @__PURE__ */ (0, $7476e21157772a88$exports.jsx)($070d885cb609f38e$var$x, {
        onCancel: t,
        onSuccess: o,
        checkoutUrl: e,
        displayOptions: r
    });
    if (r.type === "modal") return /* @__PURE__ */ (0, $7476e21157772a88$exports.jsx)($070d885cb609f38e$var$R, {
        onCancel: t,
        onSuccess: o,
        checkoutUrl: e,
        displayOptions: r
    });
};



var $9f43d18654df7a0b$exports = {};

$9f43d18654df7a0b$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "de_3.a3625524.png";


var $2d2d35c8f4d1512f$exports = {};

$2d2d35c8f4d1512f$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "nl_3.d58cedc9.png";


var $ab2236fa69621930$exports = {};

$ab2236fa69621930$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "fr_3.5245a318.png";


var $7f653c48a95a0935$exports = {};

$7f653c48a95a0935$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "es_3.ad2f5d9f.png";


var $e284077ffb19f94b$exports = {};

$e284077ffb19f94b$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "pt_3.7cd5ed24.png";


var $33401ac17b319fee$exports = {};

$33401ac17b319fee$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "pl_3.71278cad.png";


var $ffc83ed3dc41bfd2$exports = {};

$ffc83ed3dc41bfd2$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "sk_3.356463f5.png";


var $9c861f03447c1111$exports = {};

$9c861f03447c1111$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "uk_3.f58a4276.png";


const $d5ca48e110fef8bd$var$languageData = {
    en: {
        translations: {
            instandBankTransfer: "Instant bank transfer",
            totalDue: "Total due",
            fullName: "Full name",
            email: "Email",
            countryoOfResidence: "Country of residence",
            dateOfBirth: "Date of Birth",
            address: "Address",
            phoneNumber: "Phone number",
            amountToBePaid: "Checkout Powered by Crypto",
            exchangeRate: "Exchange rate",
            amountPurchased: "Purchasing",
            youArePurchasingAmount: "You are purchasing amount",
            youWillReceive: "You will receive",
            yourCryptocurrencyWillBeDeliveredTo: "Your cryptocurrency will be delivered to",
            iHaveRead: "I have read and agree to the",
            termsOfService: "Terms of Service",
            continueToSelectYourBank: "Continue to select your bank",
            youAcknowledgeAndConsentToPurchasing: "You acknowledge and consent to purchasing",
            inExchangeFor: "in exchange for",
            aConfirmationOfYourTransactionWillBeSentTo: "A confirmation of your transaction will be sent to",
            // filled based on FR
            billingInformation: "Billing information",
            checkoutSummary: "Checkout summary",
            continueToSummary: "Continue to summary",
            selectBank: "Select a bank",
            agreeAndContinue: "Agree and continue",
            continueToCheckout: "Continue to checkout",
            youSpend: "You spend",
            youReceive: "Receive",
            paymentMethod: "Payment method",
            receiving: "Receiving",
            receivingAddress: "Receiving address",
            paymentDetails: "Payment details",
            amount: "Amount",
            network: "Network",
            estTime: "Estimated time",
            emailReceipt: "Email receipt",
            instantBankTransfer: "Instant bank transfer"
        },
        image: (0, (/*@__PURE__*/$parcel$interopDefault($9c861f03447c1111$exports)))
    },
    de: {
        translations: {
            instandBankTransfer: "Sofortige Bank\xfcberweisung",
            totalDue: "Gesamtbetrag f\xe4llig",
            fullName: "Vollst\xe4ndiger Name",
            email: "E-Mail",
            countryoOfResidence: "Wohnsitzland",
            dateOfBirth: "Geburtsdatum",
            address: "Adresse",
            phoneNumber: "Telefonnummer",
            amountToBePaid: "Zu zahlender Betrag",
            exchangeRate: "Wechselkurs",
            amountPurchased: "Gekaufte Menge",
            youArePurchasingAmount: "Sie kaufen Menge",
            youWillReceive: "Sie erhalten",
            yourCryptocurrencyWillBeDeliveredTo: "Ihre Kryptow\xe4hrung wird geliefert an",
            iHaveRead: "Ich habe gelesen und stimme den",
            termsOfService: "Nutzungsbedingungen",
            continueToSelectYourBank: "Weiter zur Bankauswahl",
            youAcknowledgeAndConsentToPurchasing: "Sie best\xe4tigen und stimmen dem Kauf von",
            inExchangeFor: "im Austausch f\xfcr",
            aConfirmationOfYourTransactionWillBeSentTo: "Eine Best\xe4tigung Ihrer Transaktion wird gesendet an",
            billingInformation: "Rechnungsinformationen",
            checkoutSummary: "Checkout-Zusammenfassung",
            continueToSummary: "Weiter zur Zusammenfassung",
            selectBank: "Bank ausw\xe4hlen",
            continueToCheckout: "Weiter zur Kasse",
            youSpend: "Sie geben aus",
            youReceive: "Sie erhalten",
            paymentMethod: "Zahlungsmethode",
            receiving: "Empfang",
            receivingAddress: "Empfangsadresse",
            paymentDetails: "Zahlungsdetails",
            amount: "Betrag",
            network: "Netzwerk",
            estTime: "Gesch\xe4tzte Zeit",
            emailReceipt: "E-Mail-Beleg",
            instantBankTransfer: "Sofortige Bank\xfcberweisung",
            agreeAndContinue: "Zustimmen und fortfahren"
        },
        image: (0, (/*@__PURE__*/$parcel$interopDefault($9f43d18654df7a0b$exports)))
    },
    nl: {
        translations: {
            instandBankTransfer: "Directe bankoverschrijving",
            totalDue: "Totaal verschuldigd",
            fullName: "Volledige naam",
            email: "E-mail",
            countryoOfResidence: "Land van verblijf",
            dateOfBirth: "Geboortedatum",
            address: "Adres",
            phoneNumber: "Telefoonnummer",
            amountToBePaid: "Te betalen bedrag",
            exchangeRate: "Wisselkoers",
            amountPurchased: "Aankoopbedrag",
            youArePurchasingAmount: "U koopt bedrag",
            youWillReceive: "U ontvangt",
            yourCryptocurrencyWillBeDeliveredTo: "Uw cryptocurrency wordt geleverd aan",
            iHaveRead: "Ik heb gelezen en ga akkoord met de",
            termsOfService: "Servicevoorwaarden",
            continueToSelectYourBank: "Ga verder om uw bank te selecteren",
            youAcknowledgeAndConsentToPurchasing: "U erkent en stemt in met de aankoop van",
            inExchangeFor: "in ruil voor",
            aConfirmationOfYourTransactionWillBeSentTo: "Een bevestiging van uw transactie wordt verzonden naar",
            billingInformation: "Factuurinformatie",
            checkoutSummary: "Betaaloverzicht",
            continueToSummary: "Doorgaan naar overzicht",
            selectBank: "Selecteer een bank",
            continueToCheckout: "Doorgaan naar afrekenen",
            youSpend: "U besteedt",
            youReceive: "U ontvangt",
            paymentMethod: "Betaalmethode",
            receiving: "Ontvangst",
            receivingAddress: "Ontvangstadres",
            paymentDetails: "Betalingsgegevens",
            amount: "Bedrag",
            network: "Netwerk",
            estTime: "Geschatte tijd",
            emailReceipt: "E-mailbon",
            instantBankTransfer: "Directe bankoverschrijving",
            agreeAndContinue: "Akkoord en doorgaan"
        },
        image: (0, (/*@__PURE__*/$parcel$interopDefault($2d2d35c8f4d1512f$exports)))
    },
    fr: {
        translations: {
            instandBankTransfer: "Virement bancaire instantan\xe9",
            totalDue: "Total d\xfb",
            fullName: "Nom complet",
            email: "E-mail",
            countryoOfResidence: "Pays de r\xe9sidence",
            dateOfBirth: "Date de naissance",
            address: "Adresse",
            phoneNumber: "Num\xe9ro de t\xe9l\xe9phone",
            amountToBePaid: "Montant \xe0 payer",
            exchangeRate: "Taux de change",
            amountPurchased: "Achat",
            youArePurchasingAmount: "Vous achetez le montant",
            youWillReceive: "Vous recevrez",
            yourCryptocurrencyWillBeDeliveredTo: "Votre cryptomonnaie sera livr\xe9e \xe0",
            iHaveRead: "J'ai lu et j'accepte les",
            termsOfService: "Conditions d'utilisation",
            continueToSelectYourBank: "Continuer pour s\xe9lectionner votre banque",
            youAcknowledgeAndConsentToPurchasing: "Vous reconnaissez et consentez \xe0 l'achat de",
            inExchangeFor: "en \xe9change de",
            aConfirmationOfYourTransactionWillBeSentTo: "Une confirmation de votre transaction sera envoy\xe9e \xe0",
            billingInformation: "Informations de facturation",
            checkoutSummary: "R\xe9sum\xe9 de la commande",
            continueToSummary: "Continuer vers le r\xe9sum\xe9",
            selectBank: "S\xe9lectionner une banque",
            continueToCheckout: "Continuer vers le paiement",
            youSpend: "Vous D\xe9pensez",
            youReceive: "Vous Recevez",
            paymentMethod: "M\xe9thode de paiement",
            receiving: "R\xe9ception",
            receivingAddress: "Adresse de r\xe9ception",
            paymentDetails: "D\xe9tails de paiement",
            amount: "Montant",
            network: "R\xe9seau",
            estTime: "Temps estim\xe9",
            emailReceipt: "Re\xe7u par e-mail",
            instantBankTransfer: "Virement bancaire instantan\xe9",
            agreeAndContinue: "Accepter et continuer"
        },
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ab2236fa69621930$exports)))
    },
    es: {
        translations: {
            instandBankTransfer: "Transferencia bancaria instant\xe1nea",
            totalDue: "Total adeudado",
            fullName: "Nombre completo",
            email: "Correo electr\xf3nico",
            countryoOfResidence: "Pa\xeds de residencia",
            dateOfBirth: "Fecha de nacimiento",
            address: "Direcci\xf3n",
            phoneNumber: "N\xfamero de tel\xe9fono",
            amountToBePaid: "Monto a pagar",
            exchangeRate: "Tipo de cambio",
            amountPurchased: "Comprando",
            youArePurchasingAmount: "Est\xe1s comprando la cantidad",
            youWillReceive: "Recibir\xe1s",
            yourCryptocurrencyWillBeDeliveredTo: "Tu criptomoneda ser\xe1 entregada a",
            iHaveRead: "He le\xeddo y acepto los",
            termsOfService: "T\xe9rminos del servicio",
            continueToSelectYourBank: "Continuar para seleccionar su banco",
            youAcknowledgeAndConsentToPurchasing: "Usted reconoce y consiente la compra de",
            inExchangeFor: "a cambio de",
            aConfirmationOfYourTransactionWillBeSentTo: "Se enviar\xe1 una confirmaci\xf3n de su transacci\xf3n a",
            billingInformation: "Informaci\xf3n de facturaci\xf3n",
            checkoutSummary: "Resumen del pago",
            continueToSummary: "Continuar al resumen",
            selectBank: "Seleccionar un banco",
            continueToCheckout: "Continuar al pago",
            youSpend: "Usted gasta",
            youReceive: "Usted recibe",
            paymentMethod: "M\xe9todo de pago",
            receiving: "Recepci\xf3n",
            receivingAddress: "Direcci\xf3n de recepci\xf3n",
            paymentDetails: "Detalles de pago",
            amount: "Monto",
            network: "Red",
            estTime: "Tiempo estimado",
            emailReceipt: "Recibo por correo electr\xf3nico",
            instantBankTransfer: "Transferencia bancaria instant\xe1nea",
            agreeAndContinue: "Aceptar y continuar"
        },
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7f653c48a95a0935$exports)))
    },
    it: {
        translations: {
            instandBankTransfer: "Bonifico bancario istantaneo",
            totalDue: "Totale dovuto",
            fullName: "Nome completo",
            email: "Email",
            countryoOfResidence: "Paese di residenza",
            dateOfBirth: "Data di nascita",
            address: "Indirizzo",
            phoneNumber: "Numero di telefono",
            amountToBePaid: "Importo da pagare",
            exchangeRate: "Tasso di scambio",
            amountPurchased: "Acquisto",
            youArePurchasingAmount: "Stai acquistando la quantit\xe0",
            youWillReceive: "Riceverai",
            yourCryptocurrencyWillBeDeliveredTo: "La tua criptovaluta verr\xe0 consegnata a",
            iHaveRead: "Ho letto e accetto i",
            termsOfService: "Termini di servizio",
            continueToSelectYourBank: "Continua per selezionare la tua banca",
            youAcknowledgeAndConsentToPurchasing: "Riconosci e acconsenti all'acquisto di",
            inExchangeFor: "in cambio di",
            aConfirmationOfYourTransactionWillBeSentTo: "Una conferma della tua transazione sar\xe0 inviata a",
            billingInformation: "Informazioni di fatturazione",
            checkoutSummary: "Riepilogo del pagamento",
            continueToSummary: "Continua al riepilogo",
            selectBank: "Seleziona una banca",
            continueToCheckout: "Continua al pagamento",
            youSpend: "Spendi",
            youReceive: "Ricevi",
            paymentMethod: "Metodo di pagamento",
            receiving: "Ricezione",
            receivingAddress: "Indirizzo di ricezione",
            paymentDetails: "Dettagli di pagamento",
            amount: "Importo",
            network: "Rete",
            estTime: "Tempo stimato",
            emailReceipt: "Ricevuta via e-mail",
            instantBankTransfer: "Bonifico bancario istantaneo",
            agreeAndContinue: "Accetta e continua"
        },
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7f653c48a95a0935$exports)))
    },
    pt: {
        translations: {
            instandBankTransfer: "Transfer\xeancia banc\xe1ria instant\xe2nea",
            totalDue: "Total devido",
            fullName: "Nome completo",
            email: "E-mail",
            countryoOfResidence: "Pa\xeds de resid\xeancia",
            dateOfBirth: "Data de nascimento",
            address: "Endere\xe7o",
            phoneNumber: "N\xfamero de telefone",
            amountToBePaid: "Valor a pagar",
            exchangeRate: "Taxa de c\xe2mbio",
            amountPurchased: "Compra",
            youArePurchasingAmount: "Voc\xea est\xe1 comprando a quantidade",
            youWillReceive: "Voc\xea receber\xe1",
            yourCryptocurrencyWillBeDeliveredTo: "Sua criptomoeda ser\xe1 entregue a",
            iHaveRead: "Eu li e concordo com os",
            termsOfService: "Termos de Servi\xe7o",
            continueToSelectYourBank: "Continuar para selecionar seu banco",
            youAcknowledgeAndConsentToPurchasing: "Voc\xea reconhece e concorda em comprar",
            inExchangeFor: "em troca de",
            aConfirmationOfYourTransactionWillBeSentTo: "Uma confirma\xe7\xe3o da sua transa\xe7\xe3o ser\xe1 enviada para",
            billingInformation: "Informa\xe7\xf5es de faturamento",
            checkoutSummary: "Resumo do pagamento",
            continueToSummary: "Continuar para o resumo",
            selectBank: "Selecionar um banco",
            continueToCheckout: "Continuar para o pagamento",
            youSpend: "Voc\xea gasta",
            youReceive: "Voc\xea recebe",
            paymentMethod: "M\xe9todo de pagamento",
            receiving: "Recebimento",
            receivingAddress: "Endere\xe7o de recebimento",
            paymentDetails: "Detalhes do pagamento",
            amount: "Valor",
            network: "Rede",
            estTime: "Tempo estimado",
            emailReceipt: "Recibo por e-mail",
            instantBankTransfer: "Transfer\xeancia banc\xe1ria instant\xe2nea",
            agreeAndContinue: "Concordar e continuar"
        },
        image: (0, (/*@__PURE__*/$parcel$interopDefault($e284077ffb19f94b$exports)))
    },
    sv: {
        translations: {
            instandBankTransfer: "Omedelbar bank\xf6verf\xf6ring",
            totalDue: "Totalt f\xf6rfaller",
            fullName: "Fullst\xe4ndigt namn",
            email: "E-post",
            countryoOfResidence: "Bostadsland",
            dateOfBirth: "F\xf6delsedatum",
            address: "Adress",
            phoneNumber: "Telefonnummer",
            amountToBePaid: "Belopp att betala",
            exchangeRate: "V\xe4xelkurs",
            amountPurchased: "K\xf6p",
            youArePurchasingAmount: "Du k\xf6per belopp",
            youWillReceive: "Du kommer att ta emot",
            yourCryptocurrencyWillBeDeliveredTo: "Din kryptovaluta kommer att levereras till",
            iHaveRead: "Jag har l\xe4st och godk\xe4nner",
            termsOfService: "Anv\xe4ndarvillkor",
            continueToSelectYourBank: "Forts\xe4tt f\xf6r att v\xe4lja din bank",
            youAcknowledgeAndConsentToPurchasing: "Du bekr\xe4ftar och samtycker till att k\xf6pa",
            inExchangeFor: "i utbyte mot",
            aConfirmationOfYourTransactionWillBeSentTo: "En bekr\xe4ftelse p\xe5 din transaktion kommer att skickas till",
            billingInformation: "Faktureringsinformation",
            checkoutSummary: "Betalnings\xf6versikt",
            continueToSummary: "Forts\xe4tt till \xf6versikt",
            selectBank: "V\xe4lj bank",
            continueToCheckout: "Forts\xe4tt till betalning",
            youSpend: "Du spenderar",
            youReceive: "Du f\xe5r",
            paymentMethod: "Betalningsmetod",
            receiving: "Mottagning",
            receivingAddress: "Mottagningsadress",
            paymentDetails: "Betalningsdetaljer",
            amount: "Belopp",
            network: "N\xe4tverk",
            estTime: "Uppskattad tid",
            emailReceipt: "Kvitto via e-post",
            instantBankTransfer: "Omedelbar bank\xf6verf\xf6ring",
            agreeAndContinue: "Godk\xe4nn och forts\xe4tt"
        },
        image: (0, (/*@__PURE__*/$parcel$interopDefault($7f653c48a95a0935$exports)))
    },
    pl: {
        translations: {
            instandBankTransfer: "Natychmiastowy przelew bankowy",
            totalDue: "\u0141\u0105czna nale\u017Cno\u015B\u0107",
            fullName: "Pe\u0142ne imi\u0119 i nazwisko",
            email: "E-mail",
            countryoOfResidence: "Kraj zamieszkania",
            dateOfBirth: "Data urodzenia",
            address: "Adres",
            phoneNumber: "Numer telefonu",
            amountToBePaid: "Kwota do zap\u0142aty",
            exchangeRate: "Kurs wymiany",
            amountPurchased: "Zakup",
            youArePurchasingAmount: "Kupujesz kwot\u0119",
            youWillReceive: "Otrzymasz",
            yourCryptocurrencyWillBeDeliveredTo: "Twoja kryptowaluta zostanie dostarczona do",
            iHaveRead: "Przeczyta\u0142em i zgadzam si\u0119 z",
            termsOfService: "Warunkami korzystania z us\u0142ugi",
            continueToSelectYourBank: "Kontynuuj, aby wybra\u0107 sw\xf3j bank",
            youAcknowledgeAndConsentToPurchasing: "Potwierdzasz i zgadzasz si\u0119 na zakup",
            inExchangeFor: "w zamian za",
            aConfirmationOfYourTransactionWillBeSentTo: "Potwierdzenie twojej transakcji zostanie wys\u0142ane na",
            billingInformation: "Dane do faktury",
            checkoutSummary: "Podsumowanie p\u0142atno\u015Bci",
            continueToSummary: "Przejd\u017A do podsumowania",
            selectBank: "Wybierz bank",
            continueToCheckout: "Przejd\u017A do p\u0142atno\u015Bci",
            youSpend: "Wydajesz",
            youReceive: "Otrzymujesz",
            paymentMethod: "Metoda p\u0142atno\u015Bci",
            receiving: "Odbi\xf3r",
            receivingAddress: "Adres odbioru",
            paymentDetails: "Szczeg\xf3\u0142y p\u0142atno\u015Bci",
            amount: "Kwota",
            network: "Sie\u0107",
            estTime: "Szacowany czas",
            emailReceipt: "Potwierdzenie e-mailem",
            instantBankTransfer: "Natychmiastowy przelew bankowy",
            agreeAndContinue: "Zgadzam si\u0119 i kontynuuj\u0119"
        },
        image: (0, (/*@__PURE__*/$parcel$interopDefault($33401ac17b319fee$exports)))
    },
    sk: {
        translations: {
            instandBankTransfer: "Okam\u017Eit\xfd bankov\xfd prevod",
            totalDue: "Celkov\xe1 splatn\xe1 suma",
            fullName: "Cel\xe9 meno",
            email: "E-mail",
            countryoOfResidence: "Krajina bydliska",
            dateOfBirth: "D\xe1tum narodenia",
            address: "Adresa",
            phoneNumber: "Telef\xf3nne \u010D\xedslo",
            amountToBePaid: "Suma na zaplatenie",
            exchangeRate: "V\xfdmenn\xfd kurz",
            amountPurchased: "N\xe1kup",
            youArePurchasingAmount: "Kupujete mno\u017Estvo",
            youWillReceive: "Obdr\u017E\xedte",
            yourCryptocurrencyWillBeDeliveredTo: "Va\u0161a kryptomena bude doru\u010Den\xe1 na",
            iHaveRead: "Pre\u010D\xedtal som si a s\xfahlas\xedm s",
            termsOfService: "Podmienkami pou\u017E\xedvania",
            continueToSelectYourBank: "Pokra\u010Dova\u0165 na v\xfdber va\u0161ej banky",
            youAcknowledgeAndConsentToPurchasing: "Potvrdzujete a s\xfahlas\xedte s n\xe1kupom",
            inExchangeFor: "v\xfdmenou za",
            aConfirmationOfYourTransactionWillBeSentTo: "Potvrdenie o va\u0161ej transakcii bude zaslan\xe9 na",
            billingInformation: "Faktura\u010Dn\xe9 \xfadaje",
            checkoutSummary: "Zhrnutie platby",
            continueToSummary: "Pokra\u010Dova\u0165 na zhrnutie",
            selectBank: "Vybra\u0165 banku",
            continueToCheckout: "Pokra\u010Dova\u0165 k platbe",
            youSpend: "Miniete",
            youReceive: "Dostanete",
            paymentMethod: "Sp\xf4sob platby",
            receiving: "Prij\xedmanie",
            receivingAddress: "Adresa prijatia",
            paymentDetails: "Podrobnosti platby",
            amount: "Suma",
            network: "Sie\u0165",
            estTime: "Odhadovan\xfd \u010Das",
            emailReceipt: "Potvrdenie e-mailom",
            instantBankTransfer: "Okam\u017Eit\xfd bankov\xfd prevod",
            agreeAndContinue: "S\xfahlas\xedm a pokra\u010Dujem"
        },
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ffc83ed3dc41bfd2$exports)))
    }
};
let $d5ca48e110fef8bd$var$currentLanguage = "en";
const $d5ca48e110fef8bd$export$4b6bf64406ec64af = (lang)=>{
    $d5ca48e110fef8bd$var$currentLanguage = lang;
};
const $d5ca48e110fef8bd$export$625550452a3fa3ec = (key)=>{
    return $d5ca48e110fef8bd$var$languageData[$d5ca48e110fef8bd$var$currentLanguage].translations[key] || key;
};
const $d5ca48e110fef8bd$export$ea9efa9b6eb2022a = ()=>{
    return $d5ca48e110fef8bd$var$languageData[$d5ca48e110fef8bd$var$currentLanguage].image;
};







function $4f9af2ecc875d183$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $f3af13645545885b$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $708bbd65a69565bb$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}



function $d12ae440379e2c62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}



function $16397f2e96634f56$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    return day;
}



function $614c6e878043ac23$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



function $5511991919559ee3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    return month;
}



function $d43d9dbc2fc41b6f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    return (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}



function $5b23479582bec0d3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}





function $becf2f2072c4830d$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $6e3145262e897fb9$export$430a3269e24b912e)();
    var weekStartsOn = (0, $f3af13645545885b$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $1be276f3a9a0b11f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $f3af13645545885b$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $708bbd65a69565bb$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




function $df55bf4f7a42fad2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $f3af13645545885b$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $4f9af2ecc875d183$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




var $bnENU = parcelRequire("bnENU");


parcelRequire("bnENU");
function $d569ad02676fbbdc$export$e1aef45b828286de(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: "#292929",
        strokeWidth: "2",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("g", {
                clipPath: "url(#clip0_3_564)",
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M4 4H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V4Z",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M4 8H20",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M16 3V5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M8 3V5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("clipPath", {
                    id: "clip0_3_564",
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
}







const $de1108aeeb072783$var$Calendar = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  cursor: default;
  max-width: 110%;
  box-sizing: border-box;
`;
const $de1108aeeb072783$var$CalendarHeader = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;
const $de1108aeeb072783$var$DayGrid = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 100%;
`;
const $de1108aeeb072783$var$MonthGrid = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
`;
const $de1108aeeb072783$var$YearGrid = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  height: 200px;
  width: 100%;
  overflow: auto;
`;
const $de1108aeeb072783$var$Arrow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)((0, $34655a3478656274$export$65be7b63f510f362))`
  width: 12px;
  height: 12px;
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  transition: 0.2s ease all;
  fill: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER};
`;
const $de1108aeeb072783$var$GridItem = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 30px;
  height: 30px;
  line-height: 30px;
  justify-self: center;
`;
const $de1108aeeb072783$var$Day = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)($de1108aeeb072783$var$GridItem)`
  text-align: center;
  border-radius: 100%;
  transition: 0.2s ease all;

  :hover {
    background-color: ${({ selected: selected, disabled: disabled })=>selected ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE : disabled ? "transparent" : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED}
  }

  ${({ selected: selected })=>selected && `background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE}; color: white;`}
  ${({ disabled: disabled })=>!disabled && "cursor: pointer;"}
  ${({ disabled: disabled })=>disabled && "opacity: 40%;"}
`;
const $de1108aeeb072783$var$Month = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)($de1108aeeb072783$var$GridItem)`
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  transition: 0.2s ease all;
  border-radius: 20px;
  width: 100%;
  padding: 0px 5px;

  :hover {
    background-color: ${({ selected: selected, disabled: disabled })=>selected ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE : disabled ? "transparent" : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED}
  }

  ${({ selected: selected })=>selected && `background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE}; color: white;`}
  ${({ disabled: disabled })=>!disabled && "cursor: pointer;"}
  ${({ disabled: disabled })=>disabled && "opacity: 40%;"}
`;
const $de1108aeeb072783$var$Year = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)($de1108aeeb072783$var$GridItem)`
  height: 40px;
  width: 100%;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  transition: 0.2s ease all;
  border-radius: 20px;

  ${({ selected: selected })=>!selected && `:hover { background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED}; }`}
  ${({ selected: selected })=>selected && `background-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE};`}
  ${({ selected: selected })=>selected && "color: white;"}
`;
// ---------------------------------------------------------------------------------------------------------------------
const $de1108aeeb072783$var$DEFAULT_DATE_EARLIEST = new Date(1900, 1, 1);
const $de1108aeeb072783$var$DEFAULT_DATE_LATEST = new Date(2100, 12, 31);
// ---------------------------------------------------------------------------------------------------------------------
// Create a calendar date picker that operates between the start and end dates (inclusive)
// ---------------------------------------------------------------------------------------------------------------------
const $de1108aeeb072783$var$DateSelector = ({ startDate: startDate = $de1108aeeb072783$var$DEFAULT_DATE_EARLIEST, endDate: endDate = $de1108aeeb072783$var$DEFAULT_DATE_LATEST, value: value = "", onChange: onChange = (0, $8d017118df5fe2e5$export$b50b6e108474309b), placeholder: placeholder = "Select a date", innerStyle: innerStyle = {} })=>{
    const props = {
        startDate: startDate,
        endDate: endDate,
        value: value,
        onChange: onChange,
        placeholder: placeholder,
        innerStyle: innerStyle
    };
    const yearGridRef = (0, $bnENU.useRef)(null);
    const [view, setView] = (0, $bnENU.useState)("day");
    const [selectedDate, setSelectedDate] = (0, $bnENU.useState)(props.value ? new Date(props.value) : undefined);
    const [displayDate, setDisplayDate] = (0, $bnENU.useState)(props.value ? (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(new Date(props.value), "dd/MM/yyyy") : "");
    const [dateProbe, setDateProbe] = (0, $bnENU.useState)(props.value ? new Date(props.value) : props.endDate);
    const [open, setOpen] = (0, $bnENU.useState)(false);
    const [invalid, setInvalid] = (0, $bnENU.useState)(false);
    const firstDOW = (0, $becf2f2072c4830d$export$2e2bcd8739ae039)(new Date());
    const shortWeekDaysArray = Array.from(Array(7)).map((e, i)=>(0, $de2ab8211093dff3$export$2e2bcd8739ae039)((0, $af9c50b7122d249f$export$2e2bcd8739ae039)(firstDOW, i), "eee"));
    // First day of month and number of days in month of curDateProbe
    const probeDay = (0, $bnENU.useMemo)(()=>(0, $16397f2e96634f56$export$2e2bcd8739ae039)((0, $5b23479582bec0d3$export$2e2bcd8739ae039)(dateProbe)), [
        dateProbe
    ]);
    const probeDaysInMonth = (0, $bnENU.useMemo)(()=>(0, $614c6e878043ac23$export$2e2bcd8739ae039)(dateProbe), [
        dateProbe
    ]);
    const containerRef = (0, $bnENU.useRef)(null);
    const [calendarPosition, setCalendarPosition] = (0, $bnENU.useState)({
        top: 0,
        left: 0
    });
    const calendarRef = (0, $bnENU.useRef)(null);
    const [inputWidth, setInputWidth] = (0, $bnENU.useState)(0);
    (0, $bnENU.useLayoutEffect)(()=>{
        if (!open || !containerRef.current || !calendarRef.current) return;
        const wrapper = containerRef.current.getBoundingClientRect();
        const calendar = calendarRef.current.getBoundingClientRect();
        const viewportPadding = 8;
        setInputWidth(wrapper.width) // <--- 关键
        ;
        const bottomAlign = wrapper.bottom + 5;
        const topAlign = wrapper.top - calendar.height - 5;
        let top = bottomAlign;
        if (bottomAlign + calendar.height > window.innerHeight - viewportPadding && topAlign >= viewportPadding) top = topAlign;
        else if (bottomAlign + calendar.height > window.innerHeight - viewportPadding && topAlign < viewportPadding) top = Math.max(viewportPadding, window.innerHeight - calendar.height - viewportPadding);
        let left = wrapper.left;
        if (left + calendar.width > window.innerWidth - viewportPadding) left = wrapper.right - calendar.width;
        left = Math.max(viewportPadding, Math.min(left, window.innerWidth - calendar.width - viewportPadding));
        setCalendarPosition({
            top: top,
            left: left
        });
    }, [
        open,
        view,
        dateProbe
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    // Year view
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        if (view === "year") {
            const row = props.startDate.getFullYear() / 3;
            yearGridRef.current?.scrollTo({
                top: row * 36 - 72
            });
        }
    }, [
        view,
        yearGridRef
    ]);
    const onPrevYear = ()=>{
        const prevYear = (0, $df55bf4f7a42fad2$export$2e2bcd8739ae039)(dateProbe, 1);
        if (prevYear.getFullYear() < props.startDate.getFullYear()) return;
        setDateProbe(prevYear);
    };
    const onNextYear = ()=>{
        const nextYear = (0, $4f9af2ecc875d183$export$2e2bcd8739ae039)(dateProbe, 1);
        if (props.endDate.getFullYear() < nextYear.getFullYear()) return;
        setDateProbe(nextYear);
    };
    (0, $bnENU.useEffect)(()=>{
        if (view === "day") renderDayView();
        if (view === "month") renderMonthView();
        if (view === "year") renderYearView();
    }, [
        view,
        dateProbe
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (!open) return;
        const handleClickOutside = (e)=>{
            if (!containerRef.current?.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        open
    ]);
    const renderYearView = ()=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$YearGrid, {
            ref: yearGridRef,
            children: Array.from({
                length: props.endDate.getFullYear() - props.startDate.getFullYear() + 1
            }, (_, yearNum)=>{
                const selectYear = ()=>{
                    const newDate = new Date(props.startDate.getFullYear() + yearNum, dateProbe.getMonth(), dateProbe.getDate());
                    setDateProbe(newDate);
                    setView("day");
                };
                return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$Year, {
                    selected: (0, $d43d9dbc2fc41b6f$export$2e2bcd8739ae039)(dateProbe) - props.startDate.getFullYear() === yearNum,
                    role: "button",
                    tabIndex: 0,
                    onClick: selectYear,
                    onKeyDown: (e)=>onSelectableKeyDown(e, selectYear),
                    children: props.startDate.getFullYear() + yearNum
                }, yearNum);
            })
        });
    // -------------------------------------------------------------------------------------------------------------------
    // Month view
    // -------------------------------------------------------------------------------------------------------------------
    const monthIsDisabled = (monthNum)=>{
        const displayMonth = new Date(dateProbe.getFullYear(), monthNum, dateProbe.getDate());
        return displayMonth < props.startDate || displayMonth > props.endDate;
    };
    const onPrevMonth = ()=>{
        const oneMonthAgo = (0, $1be276f3a9a0b11f$export$2e2bcd8739ae039)(dateProbe, 1);
        if (oneMonthAgo.getFullYear() <= props.startDate.getFullYear() && oneMonthAgo.getMonth() < props.startDate.getMonth()) return;
        setDateProbe(oneMonthAgo);
    };
    const onNextMonth = ()=>{
        const nextMonth = (0, $708bbd65a69565bb$export$2e2bcd8739ae039)(dateProbe, 1);
        if (props.endDate.getFullYear() <= nextMonth.getFullYear() && props.endDate.getMonth() < nextMonth.getMonth()) return;
        setDateProbe(nextMonth);
    };
    const onSelectableKeyDown = (e, onSelect, disabled = false)=>{
        if (disabled) return;
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onSelect();
        }
    };
    const renderMonthView = ()=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$CalendarHeader, {
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                onClick: ()=>{
                                    setView("year");
                                },
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 0,
                                    background: "transparent",
                                    color: "black",
                                    gap: 10,
                                    fontWeight: 500,
                                    fontSize: 14
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        children: (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(dateProbe, "yyyy")
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                        style: {
                                            transform: "rotate(0deg)"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$Arrow, {
                                onClick: onPrevYear,
                                style: {
                                    transform: "rotate(90deg)"
                                }
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$Arrow, {
                                onClick: onNextYear,
                                style: {
                                    transform: "rotate(270deg)"
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$MonthGrid, {
                    children: Array.from({
                        length: (0, $c4053e94986594e8$export$80d7e435f744f319)
                    }, (_, i)=>{
                        const disabled = monthIsDisabled(i);
                        const selectMonth = ()=>{
                            const selectedDate = new Date(dateProbe.getFullYear(), i, dateProbe.getDate());
                            setDateProbe(selectedDate);
                            setView("day");
                        };
                        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$Month, {
                            selected: (0, $5511991919559ee3$export$2e2bcd8739ae039)(dateProbe) === i,
                            disabled: disabled,
                            role: "button",
                            tabIndex: disabled ? -1 : 0,
                            onClick: disabled ? (0, $8d017118df5fe2e5$export$b50b6e108474309b) : selectMonth,
                            onKeyDown: (e)=>onSelectableKeyDown(e, selectMonth, disabled),
                            children: (0, $06a86a86a3f7bb82$export$2e2bcd8739ae039).localize?.month(i)
                        }, i);
                    })
                })
            ]
        });
    // -------------------------------------------------------------------------------------------------------------------
    // Day view
    // -------------------------------------------------------------------------------------------------------------------
    const dayIsDisabled = (date)=>{
        const day = new Date(dateProbe.getFullYear(), dateProbe.getMonth(), date + 1);
        return day < props.startDate || day > props.endDate;
    };
    const renderDayView = ()=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$CalendarHeader, {
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                onClick: ()=>{
                                    setView("year");
                                },
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: 0,
                                    background: "transparent",
                                    color: "black",
                                    gap: 10,
                                    fontWeight: 500,
                                    fontSize: 14
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                        children: [
                                            (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(dateProbe, "MMMM"),
                                            " ",
                                            (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(dateProbe, "yyyy")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                        style: {
                                            transform: "rotate(0deg)"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$Arrow, {
                                        onClick: onPrevMonth,
                                        style: {
                                            transform: "rotate(90deg)"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$Arrow, {
                                        onClick: onNextMonth,
                                        style: {
                                            transform: "rotate(270deg)"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($de1108aeeb072783$var$DayGrid, {
                    children: [
                        shortWeekDaysArray.map((d)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    textAlign: "center",
                                    width: "30px",
                                    height: "30px",
                                    opacity: 0.3,
                                    justifySelf: "center",
                                    fontWeight: 600,
                                    fontSize: 12
                                },
                                children: d
                            }, d)),
                        Array.from({
                            length: probeDay
                        }, (_, i)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$GridItem, {}, i)),
                        Array.from({
                            length: probeDaysInMonth
                        }, (_, dayNum)=>{
                            const disabled = dayIsDisabled(dayNum);
                            const selectDay = ()=>{
                                const selected = new Date(dateProbe.getFullYear(), dateProbe.getMonth(), dayNum + 1, 12);
                                setSelectedDate(selected);
                                setDisplayDate((0, $de2ab8211093dff3$export$2e2bcd8739ae039)(selected, "dd/MM/yyyy"));
                                props.onChange(selected);
                                setOpen(false);
                            };
                            return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($de1108aeeb072783$var$Day, {
                                disabled: disabled,
                                selected: selectedDate ? (0, $d12ae440379e2c62$export$2e2bcd8739ae039)(selectedDate) === dayNum + 1 : false,
                                role: "button",
                                tabIndex: disabled ? -1 : 0,
                                onClick: disabled ? (0, $8d017118df5fe2e5$export$b50b6e108474309b) : selectDay,
                                onKeyDown: (e)=>onSelectableKeyDown(e, selectDay, disabled),
                                children: dayNum + 1
                            }, dayNum);
                        })
                    ]
                })
            ]
        });
    const formatDateString = (raw)=>{
        const parts = [];
        parts.push(raw.slice(0, 2));
        if (raw.length >= 3 || raw.length > 0) parts.push(raw.slice(2, 4));
        if (raw.length >= 5 || raw.length > 2) parts.push(raw.slice(4, 8));
        const day = (parts[0] || "").padEnd(2, "D");
        const month = (parts[1] || "").padEnd(2, "M");
        const year = (parts[2] || "").padEnd(4, "Y");
        return `${day}/${month}/${year}`;
    };
    const mapFormattedToRawIndex = (pos)=>{
        if (pos <= 2) return pos;
        if (pos <= 5) return pos - 1;
        return pos - 2;
    };
    const mapRawToFormattedIndex = (rawIdx)=>{
        if (rawIdx <= 2) return rawIdx;
        if (rawIdx <= 4) return rawIdx + 1;
        return rawIdx + 2;
    };
    const onChangeDate = (e)=>{
        const input = e.target;
        const prevFormatted = displayDate;
        const prevRaw = prevFormatted.replace(/\D/g, "");
        const prevCursor = input.selectionStart ?? 0;
        const prevRawPos = mapFormattedToRawIndex(prevCursor);
        const newRaw = input.value.replace(/\D/g, "").slice(0, 8);
        const formatted = formatDateString(newRaw);
        setDisplayDate(formatted);
        if (newRaw.length >= 4) {
            const day = parseInt(newRaw.slice(0, 2), 10);
            const month = parseInt(newRaw.slice(2, 4), 10);
            const year = parseInt(newRaw.slice(4, 8), 10);
            if (!isNaN(month) && !isNaN(year)) {
                const tentative = new Date(year || 2000, (month || 1) - 1, day || 1);
                setDateProbe(tentative);
            }
        }
        const isDeleting = newRaw.length < prevRaw.length;
        let rawCursor = prevRawPos;
        if (!isDeleting) rawCursor = prevRawPos + 1;
        rawCursor = Math.max(0, Math.min(newRaw.length, rawCursor));
        const newCursor = mapRawToFormattedIndex(rawCursor);
        setTimeout(()=>{
            input.setSelectionRange(newCursor, newCursor);
        }, 0);
        if (newRaw.length === 8) {
            const day = parseInt(newRaw.slice(0, 2), 10);
            const month = parseInt(newRaw.slice(2, 4), 10);
            const year = parseInt(newRaw.slice(4, 8), 10);
            const isValid = !isNaN(day) && !isNaN(month) && !isNaN(year) && day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= 2100;
            if (isValid) {
                const date = new Date(year, month - 1, day);
                if (date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day) {
                    setSelectedDate(date);
                    props.onChange(date);
                    setInvalid(false);
                    setDateProbe(date);
                    setView("day");
                } else setInvalid(true);
            } else setInvalid(true);
        } else setInvalid(false);
    };
    // -------------------------------------------------------------------------------------------------------------------
    // Render calendar view using the normal (non-American) date format
    // -------------------------------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        ref: containerRef,
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d569ad02676fbbdc$export$e1aef45b828286de), {
                style: {
                    height: 18,
                    position: "absolute",
                    right: 8,
                    top: 7
                },
                stroke: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                onClick: ()=>{
                    setOpen(!open);
                    if (!open) {
                        setView("day");
                        setDateProbe(()=>{
                            const currentDate = selectedDate ?? new Date();
                            // 确保日期不会超出范围
                            if (currentDate > props.endDate) return props.endDate;
                            if (currentDate < props.startDate) return props.startDate;
                            return currentDate;
                        });
                    }
                }
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                style: {
                    ...props.innerStyle,
                    cursor: "pointer",
                    border: invalid ? "1px solid red" : props.innerStyle?.border ?? undefined
                },
                value: displayDate,
                placeholder: props.placeholder,
                type: "text",
                onClick: ()=>{
                    setOpen(!open);
                },
                onChange: onChangeDate,
                onKeyDown: (e)=>{
                    if ((e.key === "ArrowDown" || e.key === " ") && !open) {
                        e.preventDefault();
                        setOpen(true);
                        return;
                    }
                    if (e.key === "Escape" && open) {
                        e.preventDefault();
                        setOpen(false);
                        return;
                    }
                    if (e.key === "Tab" && open) setOpen(false);
                    if (e.key === "Enter") {
                        const date = new Date(e.currentTarget.value);
                        if (date.toString() !== "Invalid Date") {
                            setSelectedDate(date);
                            props.onChange(date);
                            setInvalid(false);
                        } else setInvalid(true);
                    }
                }
            }, selectedDate?.toString()),
            open && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($de1108aeeb072783$var$Calendar, {
                ref: calendarRef,
                style: {
                    position: "fixed",
                    top: calendarPosition.top,
                    left: calendarPosition.left,
                    zIndex: 9999,
                    background: "white",
                    minWidth: 250,
                    borderRadius: 5,
                    boxShadow: `0 0 5px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                    width: inputWidth,
                    cursor: "pointer"
                },
                children: [
                    view === "day" && renderDayView(),
                    view === "month" && renderMonthView(),
                    view === "year" && renderYearView()
                ]
            })
        ]
    });
};
var $de1108aeeb072783$export$2e2bcd8739ae039 = $de1108aeeb072783$var$DateSelector;




var $bnENU = parcelRequire("bnENU");


/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */ 


var $bnENU = parcelRequire("bnENU");

















const $0ce5a428e300b80d$export$5720c1871db44880 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  text-transform: capitalize;
  padding: 4px 10px;
  border: 1px solid transparent;
  border-radius: 999px;
  color: white;
  font-size: 12px;
  font-weight: 600;

  ${({ status: status })=>{
    let bgColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR_LIGHT;
    let textColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR;
    switch(status){
        case "paid":
            bgColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS_LIGHT;
            textColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS;
            break;
        case "pending":
            bgColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK;
            textColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST;
            break;
    }
    return `
      background-color: ${bgColor};
      color: ${textColor};
    `;
}};
`;
const $0ce5a428e300b80d$var$LineItemGrid = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: grid;
  align-items: start;
  grid-template-columns: 8fr 1fr;
  row-gap: 18px;
  padding: 20px 0px;
  font-size: 14px;

  > *:nth-child(2n) {
    text-align: right;
  }
`;
const $0ce5a428e300b80d$export$60332b2344f7fe41 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  font-size: 14px;
  padding: 26px;
  border-radius: 12px;
  background-color: white;
  border: 1px solid #e2e8f3;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);

  @media (max-width: ${(0, $afdf282d9c361d03$export$a794f8af63328e6b).MOBILE_LARGE}) {
    padding: 20px;
  }
`;
const $0ce5a428e300b80d$export$42a852a2b6b56249 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  max-width: 760px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 30px 22px;
  animation: fadeSlide 0.5s ease;

  @keyframes fadeSlide {
    from {
      opacity: 0;
      transform: translateY(-25%);
    }

    to {
      opacity: 100%;
      transform: translateY(0%);
    }
  }

  @media (max-width: ${(0, $afdf282d9c361d03$export$a794f8af63328e6b).MOBILE_LARGE}) {
    padding: 18px;
  }
`;
const $0ce5a428e300b80d$var$InvoiceHeaderRow = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #e6ebf4;
`;
const $0ce5a428e300b80d$var$InvoiceHero = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  padding: 28px 24px 24px;
  border-bottom: 1px solid #e6ebf4;
  background: #f8fafd;
`;
const $0ce5a428e300b80d$var$InvoiceCompactSummary = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  padding: 18px 24px;
  background: #f8fafd;

  @media (max-width: ${(0, $afdf282d9c361d03$export$a794f8af63328e6b).MOBILE_LARGE}) {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
`;
const $0ce5a428e300b80d$var$InvoiceCompactAmount = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  font-size: 26px;
  font-weight: 600;
  line-height: 1.05;
  color: #0f172a;
`;
const $0ce5a428e300b80d$var$InvoiceMetaGrid = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 88px 1fr;
  margin: 0 0 18px;
  row-gap: 8px;
  column-gap: 16px;

  > *:nth-child(2n+1) {
    color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER};
  }
`;
const $0ce5a428e300b80d$var$ViewInvoiceButton = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  cursor: pointer;
  margin-top: 18px;
  color: #67768d;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 5px;

  :hover {
    opacity: 0.5;
  }
`;
const $0ce5a428e300b80d$var$Footer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #67768d;
  font-size: 13px;
  padding: 2px 0 8px;
  flex-wrap: wrap;
`;
// ---------------------------------------------------------------------------------------------------------------------
// Determine which travel rule fields need to be collected
const $0ce5a428e300b80d$var$determineMissingTrfs = (customer)=>{
    const addressParts = (customer.billingAddress ?? "").split(",").map((part)=>part.trim()).filter((part)=>part.length > 0);
    const hasLine1 = addressParts.length >= 1;
    const hasTownOrCity = addressParts.length >= 2;
    const hasState = addressParts.length >= 3;
    const hasPostalCode = addressParts.length >= 4;
    const hasLine2 = addressParts.length >= 5;
    return {
        accountType: customer.accountType,
        countryOfResidenceCollected: Boolean(customer.residenceCountry),
        dateOfBirthCollected: Boolean(customer.dob),
        emailAddressCollected: Boolean(customer.email),
        nameCollected: Boolean(customer.name),
        companyNameCollected: Boolean(customer.companyName),
        addressLine1Collected: hasLine1,
        addressLine2Collected: hasLine2,
        townOrCityCollected: hasTownOrCity,
        postalCodeCollected: hasPostalCode,
        stateOrProvinceCollected: hasState
    };
};
// ---------------------------------------------------------------------------------------------------------------------
const $0ce5a428e300b80d$var$PayInvoice = (props)=>{
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(true);
    const [loadError, setLoadError] = (0, $bnENU.useState)("");
    const [invoiceData, setInvoice] = (0, $bnENU.useState)();
    const [priceQuotes, setPriceQuotes] = (0, $bnENU.useState)([]);
    const [totalSum, setTotalSum] = (0, $bnENU.useState)(0);
    const [currency, setCurrency] = (0, $bnENU.useState)("USD");
    const [detailsExpanded, setDetailsExpanded] = (0, $bnENU.useState)(false);
    const [hasStartedInvoicePayment, setHasStartedInvoicePayment] = (0, $bnENU.useState)(false);
    const [isPreProcessingPayment, setIsPreProcessingPayment] = (0, $bnENU.useState)(false);
    const [isSuccess, setIsSuccess] = (0, $bnENU.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $bnENU.useState)("");
    const [managedPaymentDetails, setManagedPaymentDetails] = (0, $bnENU.useState)();
    const [successElement, setSuccessElement] = (0, $bnENU.useState)(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {}));
    const [paymentStatus, setPaymentStatus] = (0, $bnENU.useState)();
    const trackedFunnelStepsRef = (0, $bnENU.useRef)(new Set());
    const paymentPanelRef = (0, $bnENU.useRef)(null);
    // Start by assuming that none of the travel rule fields have been collected
    const [collectedTrfs, setCollectedTrfs] = (0, $bnENU.useState)((0, $8652974033b0a752$export$3e77b1380e63cfaf)());
    const [checkoutState, setCheckoutState] = (0, $bnENU.useState)((0, $06825994d276e479$export$267c62a135bb226c).CollectTravelRuleFields);
    const scrollToPaymentPanel = ()=>{
        setHasStartedInvoicePayment(true);
        setDetailsExpanded(false);
        setTimeout(()=>{
            paymentPanelRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
            const firstFocusable = paymentPanelRef.current?.querySelector('input, button, [tabindex]:not([tabindex="-1"])');
            firstFocusable?.focus();
        }, 0);
    };
    const getQuotes = async (invoice)=>{
        const productCurrencies = [
            ...new Set([
                ...invoice.products.map((p)=>p.product.currency) ?? []
            ]),
            ...invoice.lineItems.map((l)=>l.currency ?? "USD") ?? []
        ];
        if (productCurrencies.length === 0) return;
        if (productCurrencies.every((c)=>priceQuotes.findIndex((q)=>q.from === c && q.to === currency) !== -1)) return;
        setIsLoading(true);
        try {
            const quotes = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getPriceQuotes(productCurrencies, [
                currency
            ]);
            if (quotes) setPriceQuotes(quotes);
        } catch (err) {
            console.error("Failed to load price quotes", err);
        } finally{
            setIsLoading(false);
        }
    };
    // -------------------------------------------------------------------------------------------------------------------
    const checkoutData = (0, $bnENU.useMemo)(()=>{
        const c = {
            isInvoice: true,
            sellerAddress: "",
            sellerLogoUrl: "",
            sellerName: "",
            products: [],
            lineItems: [],
            gateway: {},
            customizations: {
                allowFreeInputAmount: false,
                allowDiscountCodes: false,
                slantedEdge: false
            },
            chargeCustomerNetworkFee: false,
            travelRuleFields: {},
            travelRuleEmail: ""
        };
        if (invoiceData) {
            c.sellerAddress = (0, $8d017118df5fe2e5$export$193698062786be9a)(invoiceData.sellerAddress, 6);
            if (invoiceData.seller) {
                c.sellerLogoUrl = invoiceData.seller.logoUrl ?? "";
                c.sellerName = invoiceData.seller.name || invoiceData.seller.email;
            }
            c.products = invoiceData.products;
            c.lineItems = invoiceData.lineItems?.map((l)=>{
                return {
                    ...l,
                    currency: l.currency ?? "USD",
                    chargingIntervalSeconds: 0
                };
            });
            c.gateway = invoiceData.gateway;
            // Adopt the customer email address as the travel rule email value
            c.travelRuleEmail = invoiceData.customer.email;
        }
        return c;
    }, [
        invoiceData,
        priceQuotes
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    const onCheckout = async ({ selfCustodial: selfCustodial, managed: managed, priceQuotes: priceQuotes })=>{
        if (props.previewData) return;
        setErrorMessage("");
        if (!invoiceData) {
            setErrorMessage("Payment link data not set. Please refresh and try again.");
            return;
        }
        if (managed) {
            setHasStartedInvoicePayment(true);
            setIsPreProcessingPayment(true);
            const { selectedMethod: method } = managed;
            try {
                if (!invoiceData) throw new Error("Invoice not found");
                if (!trackedFunnelStepsRef.current.has("paymentInitiated")) {
                    trackedFunnelStepsRef.current.add("paymentInitiated");
                    (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
                        sourceType: "invoice",
                        sourceId: invoiceData.id,
                        rail: "crypto",
                        step: "paymentInitiated",
                        metadata: {
                            network: method.tokenInfo?.networkName ?? method.name,
                            tokenAddress: method.tokenInfo?.tokenAddress
                        }
                    });
                }
                const res = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).createInvoicePayment({
                    invoiceId: invoiceData.id,
                    paymentMethod: {
                        managed: {
                            method: {
                                network: method.tokenInfo?.networkName ?? method.name,
                                token: method.tokenInfo?.tokenAddress ?? undefined
                            }
                        }
                    }
                });
                if (!res.paymentMethodDetails.managed) throw new Error("Unexpected empty managed payment method details");
                setManagedPaymentDetails(res.paymentMethodDetails.managed);
                const checkPaymentInterval = setInterval(()=>{
                    if (!res.paymentMethodDetails.managed) return;
                    (0, $43c053927acc0cba$export$2e2bcd8739ae039).getManagedPaymentStatus(res.paymentMethodDetails.managed?.paymentId).then((res)=>{
                        setPaymentStatus(res);
                        if (res.status === "paymentConfirmed") {
                            if (!trackedFunnelStepsRef.current.has("paymentConfirmed")) {
                                trackedFunnelStepsRef.current.add("paymentConfirmed");
                                (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
                                    sourceType: "invoice",
                                    sourceId: invoiceData.id,
                                    rail: "crypto",
                                    step: "paymentConfirmed"
                                });
                            }
                            setIsSuccess(true);
                            clearInterval(checkPaymentInterval);
                            setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d8ee75bdf024b924$export$2e2bcd8739ae039), {
                                            width: 30,
                                            height: 30,
                                            animationDelay: "0.5s",
                                            animationSpeed: "0.75s"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            fontSize: 18,
                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                        },
                                        children: "Payment successful"
                                    })
                                ]
                            }));
                        }
                        if (res.status === "failed") {
                            if (!trackedFunnelStepsRef.current.has("paymentFailed")) {
                                trackedFunnelStepsRef.current.add("paymentFailed");
                                (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
                                    sourceType: "invoice",
                                    sourceId: invoiceData.id,
                                    rail: "crypto",
                                    step: "paymentFailed"
                                });
                            }
                            clearInterval(checkPaymentInterval);
                        }
                    }).catch(()=>{});
                }, 1000);
            } catch (err) {
                console.error(err);
                setErrorMessage(err.reason || err.message);
            }
            setIsPreProcessingPayment(false);
        }
    };
    // -------------------------------------------------------------------------------------------------------------------
    const onQuoteUpdate = async ()=>{
        if (invoiceData) getQuotes(invoiceData);
    };
    const loadInvoiceData = async ()=>{
        setLoadError("");
        setIsLoading(true);
        try {
            if (props.invoiceId) {
                const invoice = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getInvoice(props.invoiceId);
                const trfValues = $0ce5a428e300b80d$var$determineMissingTrfs(invoice.customer);
                setCollectedTrfs(trfValues);
                setCheckoutState((0, $06825994d276e479$export$6fbd6664a2410aa5)(trfValues));
                setInvoice(invoice);
                await getQuotes(invoice);
            }
            if (props.previewData) {
                setInvoice(props.previewData);
                await getQuotes(props.previewData);
            }
        } catch (err) {
            console.error("Failed to load invoice", err);
            setLoadError(err?.response?.data?.error ?? err?.message ?? "Unable to load invoice right now.");
        } finally{
            setIsLoading(false);
        }
    };
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        document.title = "Radom - Invoice";
        loadInvoiceData();
    }, [
        props.invoiceId,
        props.previewData
    ]);
    (0, $bnENU.useEffect)(()=>{
        setHasStartedInvoicePayment(false);
        setDetailsExpanded(false);
    }, [
        invoiceData?.id
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        if (checkoutData) {
            let primaryCurrency = "USD";
            if (checkoutData.products && checkoutData.products?.length > 0) primaryCurrency = checkoutData.products[0].product.currency;
            else if (checkoutData.lineItems && checkoutData.lineItems.length > 0 && checkoutData.lineItems[0].currency) primaryCurrency = checkoutData.lineItems[0].currency;
            setCurrency(primaryCurrency);
            const [sum] = (0, $94d9469e1ad800ce$export$56eaa5cece9d2d8a)(checkoutData, priceQuotes, primaryCurrency);
            setTotalSum(sum);
        }
    }, [
        checkoutData
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        if (!invoiceData) return;
        if (trackedFunnelStepsRef.current.has("viewed")) return;
        trackedFunnelStepsRef.current.add("viewed");
        (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
            sourceType: "invoice",
            sourceId: invoiceData.id,
            rail: "crypto",
            step: "viewed"
        });
    }, [
        invoiceData?.id
    ]);
    // -------------------------------------------------------------------------------------------------------------------
    (0, $bnENU.useEffect)(()=>{
        if (props.previewData) {
            let primaryCurrency = "USD";
            if (props.previewData.products && props.previewData.products.length > 0) primaryCurrency = props.previewData.products[0].product.currency;
            else if (props.previewData.lineItems && props.previewData.lineItems.length > 0 && props.previewData.lineItems[0].currency) primaryCurrency = props.previewData.lineItems[0].currency;
            setCurrency(primaryCurrency);
        }
    }, [
        props.previewData
    ]);
    if (loadError) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7c18a005ad02503d$export$2e2bcd8739ae039), {
        title: "Invoice unavailable",
        message: loadError,
        onRetry: loadInvoiceData
    });
    if (!invoiceData && !props.previewData) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            display: "flex",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {})
    });
    const sellerDisplayName = invoiceData?.seller?.name && invoiceData.seller.name.length > 0 ? invoiceData.seller.name : (0, $8d017118df5fe2e5$export$193698062786be9a)(invoiceData?.sellerAddress ?? "", 4);
    const invoiceIdentifier = props.invoiceId ?? invoiceData?.id ?? "example-invoice-uuid";
    // -------------------------------------------------------------------------------------------------------------------
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            minWidth: "100vw",
            minHeight: "100vh",
            backgroundColor: "#f6f9fc"
        },
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$export$42a852a2b6b56249, {
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$export$60332b2344f7fe41, {
                    style: {
                        padding: 0,
                        overflow: "hidden"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$var$InvoiceHeaderRow, {
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        gap: 10,
                                        alignItems: "center",
                                        fontSize: 14,
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                    },
                                    children: [
                                        checkoutData.sellerLogoUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                            src: checkoutData.sellerLogoUrl,
                                            style: {
                                                maxWidth: 90,
                                                maxHeight: 26
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            children: sellerDisplayName
                                        })
                                    ]
                                }),
                                invoiceData?.status && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($0ce5a428e300b80d$export$5720c1871db44880, {
                                    status: invoiceData.status,
                                    children: invoiceData.status
                                })
                            ]
                        }),
                        hasStartedInvoicePayment && !detailsExpanded ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$var$InvoiceCompactSummary, {
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                fontSize: 13,
                                                color: "#67768d",
                                                fontWeight: 500
                                            },
                                            children: [
                                                "Invoice from ",
                                                sellerDisplayName
                                            ]
                                        }),
                                        !isLoading ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($0ce5a428e300b80d$var$InvoiceCompactAmount, {
                                            children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, totalSum)
                                        }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {}),
                                        invoiceData?.overdueAt && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                fontSize: 13,
                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                            },
                                            children: [
                                                "Due ",
                                                (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(new Date(invoiceData.overdueAt), "MMMM do, yyyy")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$var$ViewInvoiceButton, {
                                    onClick: ()=>setDetailsExpanded(true),
                                    style: {
                                        marginTop: 0,
                                        flexShrink: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            children: "View invoice"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                            style: {
                                                opacity: 0.4,
                                                rotate: "0deg",
                                                transition: "0.2s ease all"
                                            }
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$var$InvoiceHero, {
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                fontSize: 14,
                                                color: "#67768d",
                                                marginBottom: 8,
                                                fontWeight: 500
                                            },
                                            children: [
                                                "Invoice from ",
                                                sellerDisplayName
                                            ]
                                        }),
                                        !isLoading ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                fontSize: 46,
                                                fontWeight: 600,
                                                lineHeight: 1.06,
                                                color: "#0f172a"
                                            },
                                            children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, totalSum)
                                        }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {}),
                                        invoiceData?.overdueAt && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                marginTop: 8,
                                                fontSize: 16,
                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                            },
                                            children: [
                                                "Due ",
                                                (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(new Date(invoiceData.overdueAt), "MMMM do, yyyy")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        padding: 22
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$var$InvoiceMetaGrid, {
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    children: "Invoice"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    children: invoiceIdentifier
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    children: "To"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    children: invoiceData?.customer.name || invoiceData?.customer.email
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    children: "From"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    children: sellerDisplayName
                                                }),
                                                invoiceData?.memo && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            children: "Memo"
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            children: invoiceData.memo
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !hasStartedInvoicePayment && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                            disabled: invoiceData?.status === "voided" || invoiceData?.status === "paid",
                                            style: {
                                                width: "100%",
                                                background: "#0a2540",
                                                borderRadius: 8
                                            },
                                            onClick: scrollToPaymentPanel,
                                            children: "Pay this invoice"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$var$ViewInvoiceButton, {
                                            onClick: ()=>setDetailsExpanded(!detailsExpanded),
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                    children: [
                                                        detailsExpanded ? "Hide" : "Show",
                                                        " invoice details"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                                    style: {
                                                        opacity: 0.4,
                                                        rotate: detailsExpanded ? "180deg" : "0deg",
                                                        transition: "0.2s ease all"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                transition: "0.35s ease",
                                                overflow: "hidden",
                                                maxHeight: `${detailsExpanded ? "280px" : "0"}`
                                            },
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$var$LineItemGrid, {
                                                children: [
                                                    invoiceData?.products.map((line, index)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                            children: line.product.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                            style: {
                                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                                            },
                                                                            children: [
                                                                                "Qty ",
                                                                                line.quantity ?? 1
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    children: [
                                                                        isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {}),
                                                                        !isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                            children: [
                                                                                (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(line.product.currency, line.product.price * (line.quantity ?? 1)),
                                                                                line.product.currency !== currency && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                    style: {
                                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                                                    },
                                                                                    children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, (0, $94d9469e1ad800ce$export$9b8b3c5440f71236)({
                                                                                        ...line.product,
                                                                                        quantity: line.quantity
                                                                                    }, currency, priceQuotes))
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, `product-${line.product.id || index}`)),
                                                    invoiceData?.lineItems?.map((line, index)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                            children: line.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                            style: {
                                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                                            },
                                                                            children: [
                                                                                "Qty ",
                                                                                line.quantity ?? 1
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    children: [
                                                                        (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(line.currency ?? "USD", line.price * (line.quantity ?? 1)),
                                                                        line.currency !== currency && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                            style: {
                                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                                            },
                                                                            children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, (0, $94d9469e1ad800ce$export$9b8b3c5440f71236)(line, currency, priceQuotes))
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, `line-item-${line.name}-${index}`))
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$export$60332b2344f7fe41, {
                    ref: paymentPanelRef,
                    style: {
                        scrollMarginTop: 16
                    },
                    children: [
                        !props.hideTravelRuleFields && checkoutState === (0, $06825994d276e479$export$267c62a135bb226c).CollectTravelRuleFields && invoiceData?.status !== "paid" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4b9baece09e0c79d$export$2e2bcd8739ae039), {
                            travelRuleFieldsCollected: collectedTrfs,
                            prefilledData: invoiceData?.customer,
                            accountType: invoiceData?.customer.accountType,
                            onTravelRuleFieldsComplete: async (collectedTrfs)=>{
                                if (!invoiceData) return;
                                try {
                                    await (0, $43c053927acc0cba$export$2e2bcd8739ae039).updateTrfsForCustomerViaInvoice(invoiceData.id, collectedTrfs);
                                    setCheckoutState((0, $06825994d276e479$export$267c62a135bb226c).Checkout);
                                    setHasStartedInvoicePayment(true);
                                    setDetailsExpanded(false);
                                    if (!trackedFunnelStepsRef.current.has("travelRuleCompleted")) {
                                        trackedFunnelStepsRef.current.add("travelRuleCompleted");
                                        (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
                                            sourceType: "invoice",
                                            sourceId: invoiceData.id,
                                            rail: "crypto",
                                            step: "travelRuleCompleted"
                                        });
                                    }
                                } catch (err) {
                                    setErrorMessage(err?.message ?? "Failed to save billing details. Please try again.");
                                }
                            }
                        }),
                        (props.hideTravelRuleFields || checkoutState !== (0, $06825994d276e479$export$267c62a135bb226c).CollectTravelRuleFields) && (invoiceData?.status === "pending" || invoiceData?.status === "overdue" || props.previewData) && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $06825994d276e479$export$2e2bcd8739ae039), {
                            currency: currency,
                            checkoutData: checkoutData,
                            onCheckout: onCheckout,
                            onQuoteUpdate: async ()=>await onQuoteUpdate(),
                            isSuccess: isSuccess,
                            isPreProcessingPayment: isPreProcessingPayment,
                            errorMessage: errorMessage,
                            managedPaymentDetails: managedPaymentDetails,
                            onChangePaymentMethod: ()=>{
                                setManagedPaymentDetails(undefined);
                                setPaymentStatus(undefined);
                                setErrorMessage("");
                                setIsPreProcessingPayment(false);
                            },
                            successElement: successElement,
                            paymentStatus: paymentStatus,
                            hideTravelRuleFields: !!props.previewData
                        }),
                        invoiceData?.status === "voided" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                            style: {
                                fontSize: 16,
                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR,
                                textAlign: "center"
                            },
                            children: "Invoice has been voided"
                        }),
                        invoiceData?.status === "paid" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 10,
                                userSelect: "none"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                    style: {
                                        width: 20,
                                        height: 20
                                    },
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d8ee75bdf024b924$export$2e2bcd8739ae039), {
                                        width: 20,
                                        height: 20,
                                        animationDelay: "0.5s",
                                        animationSpeed: "0.75s"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                    style: {
                                        fontSize: 16,
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NICE_GREEN,
                                        textAlign: "center"
                                    },
                                    children: "Invoice has been paid"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($0ce5a428e300b80d$var$Footer, {
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                            href: "https://radom.com",
                            target: "_blank",
                            rel: "noreferrer",
                            style: {
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                                textDecoration: "none",
                                color: "inherit",
                                fontWeight: 500
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    children: "Powered by"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                    width: 48,
                                    fill: "#67768d"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                            style: {
                                opacity: 0.5
                            },
                            children: "|"
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("a", {
                            href: "https://www.radom.com/terms",
                            target: "_blank",
                            rel: "noreferrer",
                            style: {
                                color: "inherit",
                                textDecoration: "none"
                            },
                            children: "Terms"
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                            style: {
                                opacity: 0.5
                            },
                            children: "|"
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("a", {
                            href: "https://radom.com/privacy",
                            target: "_blank",
                            rel: "noreferrer",
                            style: {
                                color: "inherit",
                                textDecoration: "none"
                            },
                            children: "Privacy"
                        })
                    ]
                })
            ]
        })
    });
};
var $0ce5a428e300b80d$export$2e2bcd8739ae039 = $0ce5a428e300b80d$var$PayInvoice;




parcelRequire("bnENU");
const $2ed2b40f76b02664$var$Upload = (props)=>{
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        width: "32",
        height: "33",
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: "#33324F",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("g", {
                clipPath: "url(#clip0_299_4863)",
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M16 18.5V4.5",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M27 18.5V26.5H5V18.5",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M11 9.5L16 4.5L21 9.5",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("clipPath", {
                    id: "clip0_299_4863",
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("rect", {
                        width: "32",
                        height: "32",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
var $2ed2b40f76b02664$export$2e2bcd8739ae039 = $2ed2b40f76b02664$var$Upload;




parcelRequire("bnENU");
function $78ada9a78e9ecf07$var$ID(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        t: "1744118882251",
        className: "icon",
        viewBox: "0 0 1024 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "p-id": "1478",
        width: "24",
        height: "24",
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M421.738667 348.032l-234.666667-0.021333a21.333333 21.333333 0 0 1 0-42.666667l234.666667 0.021333a21.333333 21.333333 0 0 1 0 42.666667zM485.738667 433.365333h-298.666667a21.333333 21.333333 0 0 1 0-42.666666h298.666667a21.333333 21.333333 0 0 1 0 42.666666zM357.738667 517.397333h-170.666667a21.333333 21.333333 0 0 1 0-42.666666h170.666667a21.333333 21.333333 0 0 1 0 42.666666zM710.72 687.744c-70.592 0-128-57.408-128-128s57.408-128 128-128 128 57.408 128 128-57.408 128-128 128z m0-213.333333c-47.061333 0-85.333333 38.272-85.333333 85.333333s38.272 85.333333 85.333333 85.333333 85.333333-38.272 85.333333-85.333333c0-47.04-38.272-85.333333-85.333333-85.333333z",
                fill: "#3464E6",
                "p-id": "1479"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M892.053333 856.96h-42.666666c0-82.325333-62.208-149.333333-138.666667-149.333333s-138.666667 67.008-138.666667 149.333333h-42.666666c0-105.877333 81.344-192 181.333333-192s181.333333 86.122667 181.333333 192z",
                fill: "#3464E6",
                "p-id": "1480"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M891.221333 860.928h-725.333333c-47.061333 0-85.333333-38.272-85.333333-85.333333v-116.906667a21.333333 21.333333 0 1 1 42.666666 0v116.906667c0 23.530667 19.136 42.666667 42.666667 42.666666h725.333333c23.530667 0 42.666667-19.136 42.666667-42.666666v-554.666667c0-23.530667-19.136-42.666667-42.666667-42.666667h-725.333333c-23.530667 0-42.666667 19.136-42.666667 42.666667v245.781333a21.333333 21.333333 0 0 1-42.666666 0V220.928c0-47.061333 38.272-85.333333 85.333333-85.333333h725.333333c47.061333 0 85.333333 38.272 85.333334 85.333333v554.666667c0 47.061333-38.272 85.333333-85.333334 85.333333z",
                fill: "#3464E6",
                "p-id": "1481"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M100.778667 562.709333m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z",
                fill: "#3464E6",
                "p-id": "1482"
            })
        ]
    });
}
var $78ada9a78e9ecf07$export$2e2bcd8739ae039 = $78ada9a78e9ecf07$var$ID;



parcelRequire("bnENU");
function $61870e8b986a56a3$var$Selfie(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("svg", {
        t: "1744119559859",
        className: "icon",
        viewBox: "0 0 1024 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "p-id": "5847",
        width: "24",
        height: "24",
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
            d: "M197.517385 432.727833q0 85.769382 42.239577 158.534094 42.239578 72.774952 115.00429 115.00429 72.764712 42.229338 157.243868 42.229338 84.468915 0 157.243868-42.229338 72.764712-42.229338 115.004289-115.00429 42.239578-72.764712 42.239578-158.534094v-77.966581q0-85.769382-42.239578-158.534094-42.239578-72.764712-115.004289-115.00429-72.774952-42.229338-157.243868-42.229338-84.468915 0-157.243868 42.229338-72.764712 42.239578-115.00429 115.00429t-42.239577 158.534094v77.966581z m77.97682-77.966581q0-63.681923 31.835842-118.260577t86.414496-86.414496q54.578654-31.835842 118.250337-31.835842 63.671683 0 118.250338 31.835842 54.578654 31.835842 86.414495 86.414496 31.835842 54.578654 31.835842 118.260577v77.966581q0 63.671683-31.835842 118.250337-31.835842 54.578654-86.414495 86.414496-54.578654 31.835842-118.250338 31.835842-63.671683 0-118.250337-31.835842-54.578654-31.835842-86.414496-86.414496-31.835842-54.578654-31.835842-118.250337v-77.966581z m465.208788 432.727833h-94.862411q-45.485625 0-83.168449 15.585124-51.97772 16.895831-105.255907 0-32.491195-15.585124-83.168448-15.585124h-90.961011q-44.185158 0-81.867981 22.742813-37.682823 22.742813-60.425636 60.425635t-22.742813 81.867982q0 29.890261 20.786993 50.677253 20.797232 20.797232 50.687493 20.797232h645.840581q29.890261 0 50.03214-20.797232 20.141879-20.786992 20.141879-50.677253 0-44.174918-22.097699-81.867982-22.087459-37.682823-60.425636-60.425635-38.327937-22.742813-82.513095-22.742813zM197.517385 944.722713q2.600934-32.491195 26.644213-55.234008 24.04328-22.732573 59.125169-22.732573h90.961011q25.98886 0 54.578654 11.693963 38.98329 14.294897 81.867981 14.294898t84.468915-14.294898q23.387926-11.693963 50.677254-11.693963h94.862411q35.081889 0 59.125169 22.732573 24.04328 22.742813 26.644213 55.234008H197.517385z m15.595364-314.477495H79.267047V488.606954H0v180.621554q0 14.294897 12.339077 26.644213 12.339077 12.339077 26.644213 12.339077h174.129459v-77.96658z m731.609964 0H826.472375v77.96658h158.534095q14.294897 0 26.633974-12.339077 12.349317-12.349317 12.349316-26.644213V488.606954h-79.267047v141.638264zM985.00647 0H826.472375v79.267047h118.250338v126.05314H1023.98976V38.98329q0-14.294897-12.349316-26.644213Q999.301367 0 985.00647 0zM79.267047 79.267047h133.845702V0H38.98329Q24.688393 0 12.339077 12.339077 0 24.678153 0 38.98329v166.336897h79.267047V79.267047zM511.99488 618.551254q53.278187 0 94.862411-29.890261 22.087459-15.595364 40.283758-38.98329l2.600934-2.600934q9.093029-14.294897 6.492095-29.890261-2.600934-15.585124-14.294897-24.688393-11.693963-9.103269-28.589794-6.502335-16.895831 2.600934-25.988861 14.294897l-9.093029 9.093029q-11.693963 10.393496-24.688393 16.895831-18.196298 9.093029-37.682823 9.093029-45.485625 0-68.873551-28.589794l-1.300467-2.590694q-6.502335-14.294897-22.087459-20.141879-15.595364-5.846982-29.890261 0t-20.141879 21.432106q-5.846982 15.595364 0.645114 29.890261 10.393496 32.491195 41.584224 54.578654 38.98329 28.589794 96.162878 28.589795z",
            fill: "#3464E6",
            "p-id": "5848"
        })
    });
}
var $61870e8b986a56a3$export$2e2bcd8739ae039 = $61870e8b986a56a3$var$Selfie;



var $hA0xX = parcelRequire("hA0xX");
function $23ece11cb8699afe$export$44a3d0c0dcd51c9c(ctx, points, isClosed) {
    if (isClosed === void 0) isClosed = false;
    ctx.beginPath();
    points.slice(1).forEach(function(_a, prevIdx) {
        var x = _a.x, y = _a.y;
        var from = points[prevIdx];
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(x, y);
    });
    if (isClosed) {
        var from = points[points.length - 1];
        var to = points[0];
        if (!from || !to) return;
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
    }
    ctx.stroke();
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c5ef6752615abb23$var$extendStatics = function(d, b) {
    $c5ef6752615abb23$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c5ef6752615abb23$var$extendStatics(d, b);
};
function $c5ef6752615abb23$export$a8ba968b8961cb8a(d, b) {
    $c5ef6752615abb23$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c5ef6752615abb23$export$18ce0697a983be9b = function() {
    $c5ef6752615abb23$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c5ef6752615abb23$export$18ce0697a983be9b.apply(this, arguments);
};
function $c5ef6752615abb23$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c5ef6752615abb23$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c5ef6752615abb23$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c5ef6752615abb23$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c5ef6752615abb23$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c5ef6752615abb23$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $c5ef6752615abb23$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $c5ef6752615abb23$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $c5ef6752615abb23$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c5ef6752615abb23$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c5ef6752615abb23$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c5ef6752615abb23$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c5ef6752615abb23$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c5ef6752615abb23$export$10c90e4f7922046c(v) {
    return this instanceof $c5ef6752615abb23$export$10c90e4f7922046c ? (this.v = v, this) : new $c5ef6752615abb23$export$10c90e4f7922046c(v);
}
function $c5ef6752615abb23$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c5ef6752615abb23$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c5ef6752615abb23$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c5ef6752615abb23$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $c5ef6752615abb23$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c5ef6752615abb23$export$19a8beecd37a4c45 === "function" ? $c5ef6752615abb23$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c5ef6752615abb23$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $c5ef6752615abb23$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $c5ef6752615abb23$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c5ef6752615abb23$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $c5ef6752615abb23$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



var $hA0xX = parcelRequire("hA0xX");


var $95d2ae67e35f5d9d$export$d5b8c1948b345816 = /** @class */ function() {
    function Dimensions(width, height) {
        if (!(0, $4c1c2b1e5936cf08$export$d6781b696a0576d1)(width) || !(0, $4c1c2b1e5936cf08$export$d6781b696a0576d1)(height)) throw new Error("Dimensions.constructor - expected width and height to be valid numbers, instead have " + JSON.stringify({
            width: width,
            height: height
        }));
        this._width = width;
        this._height = height;
    }
    Object.defineProperty(Dimensions.prototype, "width", {
        get: function() {
            return this._width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dimensions.prototype, "height", {
        get: function() {
            return this._height;
        },
        enumerable: true,
        configurable: true
    });
    Dimensions.prototype.reverse = function() {
        return new Dimensions(1 / this.width, 1 / this.height);
    };
    return Dimensions;
}();


function $4c1c2b1e5936cf08$export$74b139e729aaf0a9(tensor, dim) {
    return tensor instanceof $hA0xX.Tensor && tensor.shape.length === dim;
}
function $4c1c2b1e5936cf08$export$2961fffd3dfccbab(tensor) {
    return $4c1c2b1e5936cf08$export$74b139e729aaf0a9(tensor, 1);
}
function $4c1c2b1e5936cf08$export$526eeee0f4260e87(tensor) {
    return $4c1c2b1e5936cf08$export$74b139e729aaf0a9(tensor, 2);
}
function $4c1c2b1e5936cf08$export$e3e19112bd5349fe(tensor) {
    return $4c1c2b1e5936cf08$export$74b139e729aaf0a9(tensor, 3);
}
function $4c1c2b1e5936cf08$export$d19096252e754643(tensor) {
    return $4c1c2b1e5936cf08$export$74b139e729aaf0a9(tensor, 4);
}
function $4c1c2b1e5936cf08$export$4ba1d6600e2a2892(num) {
    return num % 1 !== 0;
}
function $4c1c2b1e5936cf08$export$ce16302d1253e25(num) {
    return num % 2 === 0;
}
function $4c1c2b1e5936cf08$export$2077e0241d6afd3c(num, prec) {
    if (prec === void 0) prec = 2;
    var f = Math.pow(10, prec);
    return Math.floor(num * f) / f;
}
function $4c1c2b1e5936cf08$export$3515a30241fa21b8(obj) {
    return obj && obj.width && obj.height;
}
function $4c1c2b1e5936cf08$export$c55ab00bd17542e8(_a, inputSize) {
    var width = _a.width, height = _a.height;
    var scale = inputSize / Math.max(height, width);
    return new (0, $95d2ae67e35f5d9d$export$d5b8c1948b345816)(Math.round(width * scale), Math.round(height * scale));
}
function $4c1c2b1e5936cf08$export$4f8e0fbe7322c1cd(pts) {
    return pts.reduce(function(sum, pt) {
        return sum.add(pt);
    }, new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(0, 0)).div(new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(pts.length, pts.length));
}
function $4c1c2b1e5936cf08$export$d02631cccf789723(num, start, step) {
    return Array(num).fill(0).map(function(_, i) {
        return start + i * step;
    });
}
function $4c1c2b1e5936cf08$export$d6781b696a0576d1(num) {
    return !!num && num !== Infinity && num !== -Infinity && !isNaN(num) || num === 0;
}
function $4c1c2b1e5936cf08$export$8c6c09d122023c19(num) {
    return $4c1c2b1e5936cf08$export$d6781b696a0576d1(num) && 0 <= num && num <= 1.0;
}


var $055ec253cd1c6ad3$export$baf26146a414f24a = /** @class */ function() {
    function Point(x, y) {
        this._x = x;
        this._y = y;
    }
    Object.defineProperty(Point.prototype, "x", {
        get: function() {
            return this._x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Point.prototype, "y", {
        get: function() {
            return this._y;
        },
        enumerable: true,
        configurable: true
    });
    Point.prototype.add = function(pt) {
        return new Point(this.x + pt.x, this.y + pt.y);
    };
    Point.prototype.sub = function(pt) {
        return new Point(this.x - pt.x, this.y - pt.y);
    };
    Point.prototype.mul = function(pt) {
        return new Point(this.x * pt.x, this.y * pt.y);
    };
    Point.prototype.div = function(pt) {
        return new Point(this.x / pt.x, this.y / pt.y);
    };
    Point.prototype.abs = function() {
        return new Point(Math.abs(this.x), Math.abs(this.y));
    };
    Point.prototype.magnitude = function() {
        return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2));
    };
    Point.prototype.floor = function() {
        return new Point(Math.floor(this.x), Math.floor(this.y));
    };
    return Point;
}();


var $c24b8f381986ff10$export$e71c4d32a2263218 = /** @class */ function() {
    function Box(_box, allowNegativeDimensions) {
        if (allowNegativeDimensions === void 0) allowNegativeDimensions = true;
        var box = _box || {};
        var isBbox = [
            box.left,
            box.top,
            box.right,
            box.bottom
        ].every((0, $4c1c2b1e5936cf08$export$d6781b696a0576d1));
        var isRect = [
            box.x,
            box.y,
            box.width,
            box.height
        ].every((0, $4c1c2b1e5936cf08$export$d6781b696a0576d1));
        if (!isRect && !isBbox) throw new Error("Box.constructor - expected box to be IBoundingBox | IRect, instead have " + JSON.stringify(box));
        var _a = isRect ? [
            box.x,
            box.y,
            box.width,
            box.height
        ] : [
            box.left,
            box.top,
            box.right - box.left,
            box.bottom - box.top
        ], x = _a[0], y = _a[1], width = _a[2], height = _a[3];
        Box.assertIsValidBox({
            x: x,
            y: y,
            width: width,
            height: height
        }, "Box.constructor", allowNegativeDimensions);
        this._x = x;
        this._y = y;
        this._width = width;
        this._height = height;
    }
    Box.isRect = function(rect) {
        return !!rect && [
            rect.x,
            rect.y,
            rect.width,
            rect.height
        ].every((0, $4c1c2b1e5936cf08$export$d6781b696a0576d1));
    };
    Box.assertIsValidBox = function(box, callee, allowNegativeDimensions) {
        if (allowNegativeDimensions === void 0) allowNegativeDimensions = false;
        if (!Box.isRect(box)) throw new Error(callee + " - invalid box: " + JSON.stringify(box) + ", expected object with properties x, y, width, height");
        if (!allowNegativeDimensions && (box.width < 0 || box.height < 0)) throw new Error(callee + " - width (" + box.width + ") and height (" + box.height + ") must be positive numbers");
    };
    Object.defineProperty(Box.prototype, "x", {
        get: function() {
            return this._x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "y", {
        get: function() {
            return this._y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "width", {
        get: function() {
            return this._width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "height", {
        get: function() {
            return this._height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "left", {
        get: function() {
            return this.x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "top", {
        get: function() {
            return this.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "right", {
        get: function() {
            return this.x + this.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "bottom", {
        get: function() {
            return this.y + this.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "area", {
        get: function() {
            return this.width * this.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "topLeft", {
        get: function() {
            return new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(this.left, this.top);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "topRight", {
        get: function() {
            return new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(this.right, this.top);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "bottomLeft", {
        get: function() {
            return new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(this.left, this.bottom);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Box.prototype, "bottomRight", {
        get: function() {
            return new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(this.right, this.bottom);
        },
        enumerable: true,
        configurable: true
    });
    Box.prototype.round = function() {
        var _a = [
            this.x,
            this.y,
            this.width,
            this.height
        ].map(function(val) {
            return Math.round(val);
        }), x = _a[0], y = _a[1], width = _a[2], height = _a[3];
        return new Box({
            x: x,
            y: y,
            width: width,
            height: height
        });
    };
    Box.prototype.floor = function() {
        var _a = [
            this.x,
            this.y,
            this.width,
            this.height
        ].map(function(val) {
            return Math.floor(val);
        }), x = _a[0], y = _a[1], width = _a[2], height = _a[3];
        return new Box({
            x: x,
            y: y,
            width: width,
            height: height
        });
    };
    Box.prototype.toSquare = function() {
        var _a = this, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var diff = Math.abs(width - height);
        if (width < height) {
            x -= diff / 2;
            width += diff;
        }
        if (height < width) {
            y -= diff / 2;
            height += diff;
        }
        return new Box({
            x: x,
            y: y,
            width: width,
            height: height
        });
    };
    Box.prototype.rescale = function(s) {
        var scaleX = (0, $4c1c2b1e5936cf08$export$3515a30241fa21b8)(s) ? s.width : s;
        var scaleY = (0, $4c1c2b1e5936cf08$export$3515a30241fa21b8)(s) ? s.height : s;
        return new Box({
            x: this.x * scaleX,
            y: this.y * scaleY,
            width: this.width * scaleX,
            height: this.height * scaleY
        });
    };
    Box.prototype.pad = function(padX, padY) {
        var _a = [
            this.x - padX / 2,
            this.y - padY / 2,
            this.width + padX,
            this.height + padY
        ], x = _a[0], y = _a[1], width = _a[2], height = _a[3];
        return new Box({
            x: x,
            y: y,
            width: width,
            height: height
        });
    };
    Box.prototype.clipAtImageBorders = function(imgWidth, imgHeight) {
        var _a = this, x = _a.x, y = _a.y, right = _a.right, bottom = _a.bottom;
        var clippedX = Math.max(x, 0);
        var clippedY = Math.max(y, 0);
        var newWidth = right - clippedX;
        var newHeight = bottom - clippedY;
        var clippedWidth = Math.min(newWidth, imgWidth - clippedX);
        var clippedHeight = Math.min(newHeight, imgHeight - clippedY);
        return new Box({
            x: clippedX,
            y: clippedY,
            width: clippedWidth,
            height: clippedHeight
        }).floor();
    };
    Box.prototype.shift = function(sx, sy) {
        var _a = this, width = _a.width, height = _a.height;
        var x = this.x + sx;
        var y = this.y + sy;
        return new Box({
            x: x,
            y: y,
            width: width,
            height: height
        });
    };
    Box.prototype.padAtBorders = function(imageHeight, imageWidth) {
        var w = this.width + 1;
        var h = this.height + 1;
        var dx = 1;
        var dy = 1;
        var edx = w;
        var edy = h;
        var x = this.left;
        var y = this.top;
        var ex = this.right;
        var ey = this.bottom;
        if (ex > imageWidth) {
            edx = -ex + imageWidth + w;
            ex = imageWidth;
        }
        if (ey > imageHeight) {
            edy = -ey + imageHeight + h;
            ey = imageHeight;
        }
        if (x < 1) {
            edy = 2 - x;
            x = 1;
        }
        if (y < 1) {
            edy = 2 - y;
            y = 1;
        }
        return {
            dy: dy,
            edy: edy,
            dx: dx,
            edx: edx,
            y: y,
            ey: ey,
            x: x,
            ex: ex,
            w: w,
            h: h
        };
    };
    Box.prototype.calibrate = function(region) {
        return new Box({
            left: this.left + region.left * this.width,
            top: this.top + region.top * this.height,
            right: this.right + region.right * this.width,
            bottom: this.bottom + region.bottom * this.height
        }).toSquare().round();
    };
    return Box;
}();


var $1d960209cebf9691$export$63080c4de6cfc362 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(BoundingBox, _super);
    function BoundingBox(left, top, right, bottom, allowNegativeDimensions) {
        if (allowNegativeDimensions === void 0) allowNegativeDimensions = false;
        return _super.call(this, {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        }, allowNegativeDimensions) || this;
    }
    return BoundingBox;
}((0, $c24b8f381986ff10$export$e71c4d32a2263218));







var $7085fdf7180c233c$export$9b4b75cb82ceb9ed = /** @class */ function() {
    function ObjectDetection(score, classScore, className, relativeBox, imageDims) {
        this._imageDims = new (0, $95d2ae67e35f5d9d$export$d5b8c1948b345816)(imageDims.width, imageDims.height);
        this._score = score;
        this._classScore = classScore;
        this._className = className;
        this._box = new (0, $c24b8f381986ff10$export$e71c4d32a2263218)(relativeBox).rescale(this._imageDims);
    }
    Object.defineProperty(ObjectDetection.prototype, "score", {
        get: function() {
            return this._score;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectDetection.prototype, "classScore", {
        get: function() {
            return this._classScore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectDetection.prototype, "className", {
        get: function() {
            return this._className;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectDetection.prototype, "box", {
        get: function() {
            return this._box;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectDetection.prototype, "imageDims", {
        get: function() {
            return this._imageDims;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectDetection.prototype, "imageWidth", {
        get: function() {
            return this.imageDims.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectDetection.prototype, "imageHeight", {
        get: function() {
            return this.imageDims.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ObjectDetection.prototype, "relativeBox", {
        get: function() {
            return new (0, $c24b8f381986ff10$export$e71c4d32a2263218)(this._box).rescale(this.imageDims.reverse());
        },
        enumerable: true,
        configurable: true
    });
    ObjectDetection.prototype.forSize = function(width, height) {
        return new ObjectDetection(this.score, this.classScore, this.className, this.relativeBox, {
            width: width,
            height: height
        });
    };
    return ObjectDetection;
}();


var $86da6cbb0a7a9620$export$dc77199a917e22c2 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceDetection, _super);
    function FaceDetection(score, relativeBox, imageDims) {
        return _super.call(this, score, score, "", relativeBox, imageDims) || this;
    }
    FaceDetection.prototype.forSize = function(width, height) {
        var _a = _super.prototype.forSize.call(this, width, height), score = _a.score, relativeBox = _a.relativeBox, imageDims = _a.imageDims;
        return new FaceDetection(score, relativeBox, imageDims);
    };
    return FaceDetection;
}((0, $7085fdf7180c233c$export$9b4b75cb82ceb9ed));


function $9aa1a18c14d602d1$export$9325c46723431801(box1, box2, isIOU) {
    if (isIOU === void 0) isIOU = true;
    var width = Math.max(0.0, Math.min(box1.right, box2.right) - Math.max(box1.left, box2.left));
    var height = Math.max(0.0, Math.min(box1.bottom, box2.bottom) - Math.max(box1.top, box2.top));
    var interSection = width * height;
    return isIOU ? interSection / (box1.area + box2.area - interSection) : interSection / Math.min(box1.area, box2.area);
}



function $581cdab38d7198c0$export$1355ffefdcb7c178(pts) {
    var xs = pts.map(function(pt) {
        return pt.x;
    });
    var ys = pts.map(function(pt) {
        return pt.y;
    });
    var minX = xs.reduce(function(min, x) {
        return x < min ? x : min;
    }, Infinity);
    var minY = ys.reduce(function(min, y) {
        return y < min ? y : min;
    }, Infinity);
    var maxX = xs.reduce(function(max, x) {
        return max < x ? x : max;
    }, 0);
    var maxY = ys.reduce(function(max, y) {
        return max < y ? y : max;
    }, 0);
    return new (0, $1d960209cebf9691$export$63080c4de6cfc362)(minX, minY, maxX, maxY);
}



function $e0d7a8b8653ee871$export$b7d265b19ca1d628(boxes, scores, iouThreshold, isIOU) {
    if (isIOU === void 0) isIOU = true;
    var indicesSortedByScore = scores.map(function(score, boxIndex) {
        return {
            score: score,
            boxIndex: boxIndex
        };
    }).sort(function(c1, c2) {
        return c1.score - c2.score;
    }).map(function(c) {
        return c.boxIndex;
    });
    var pick = [];
    var _loop_1 = function() {
        var curr = indicesSortedByScore.pop();
        pick.push(curr);
        var indices = indicesSortedByScore;
        var outputs = [];
        for(var i = 0; i < indices.length; i++){
            var idx = indices[i];
            var currBox = boxes[curr];
            var idxBox = boxes[idx];
            outputs.push((0, $9aa1a18c14d602d1$export$9325c46723431801)(currBox, idxBox, isIOU));
        }
        indicesSortedByScore = indicesSortedByScore.filter(function(_, j) {
            return outputs[j] <= iouThreshold;
        });
    };
    while(indicesSortedByScore.length > 0)_loop_1();
    return pick;
}




var $hA0xX = parcelRequire("hA0xX");
function $20edefd13a8a19f6$export$a3295358bff77e(x, meanRgb) {
    return $hA0xX.tidy(function() {
        var r = meanRgb[0], g = meanRgb[1], b = meanRgb[2];
        var avg_r = $hA0xX.fill((0, $c5ef6752615abb23$export$6388937ca91ccae8)(x.shape.slice(0, 3), [
            1
        ]), r);
        var avg_g = $hA0xX.fill((0, $c5ef6752615abb23$export$6388937ca91ccae8)(x.shape.slice(0, 3), [
            1
        ]), g);
        var avg_b = $hA0xX.fill((0, $c5ef6752615abb23$export$6388937ca91ccae8)(x.shape.slice(0, 3), [
            1
        ]), b);
        var avg_rgb = $hA0xX.concat([
            avg_r,
            avg_g,
            avg_b
        ], 3);
        return $hA0xX.sub(x, avg_rgb);
    });
}



var $hA0xX = parcelRequire("hA0xX");
function $45d96e1d1c4b6311$export$1c0e305c9992342(imgTensor, isCenterImage) {
    if (isCenterImage === void 0) isCenterImage = false;
    return $hA0xX.tidy(function() {
        var _a = imgTensor.shape.slice(1), height = _a[0], width = _a[1];
        if (height === width) return imgTensor;
        var dimDiff = Math.abs(height - width);
        var paddingAmount = Math.round(dimDiff * (isCenterImage ? 0.5 : 1));
        var paddingAxis = height > width ? 2 : 1;
        var createPaddingTensor = function(paddingAmount) {
            var paddingTensorShape = imgTensor.shape.slice();
            paddingTensorShape[paddingAxis] = paddingAmount;
            return $hA0xX.fill(paddingTensorShape, 0);
        };
        var paddingTensorAppend = createPaddingTensor(paddingAmount);
        var remainingPaddingAmount = dimDiff - paddingTensorAppend.shape[paddingAxis];
        var paddingTensorPrepend = isCenterImage && remainingPaddingAmount ? createPaddingTensor(remainingPaddingAmount) : null;
        var tensorsToStack = [
            paddingTensorPrepend,
            imgTensor,
            paddingTensorAppend
        ].filter(function(t) {
            return !!t;
        }).map(function(t) {
            return t.toFloat();
        });
        return $hA0xX.concat(tensorsToStack, paddingAxis);
    });
}


function $ddd1d5bca7095f60$export$7ac3a88d34a76e7(inputArray) {
    var array = inputArray.slice();
    for(var i = array.length - 1; i > 0; i--){
        var j = Math.floor(Math.random() * (i + 1));
        var x = array[i];
        array[i] = array[j];
        array[j] = x;
    }
    return array;
}


function $4b52c5d3962f4228$export$3b295495ca3cad7c(x) {
    return 1 / (1 + Math.exp(-x));
}
function $4b52c5d3962f4228$export$6e6c7b7321756d9a(x) {
    return Math.log(x / (1 - x));
}









var $aef801190ddb2db5$export$c79fc6492f3af13d = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(Rect, _super);
    function Rect(x, y, width, height, allowNegativeDimensions) {
        if (allowNegativeDimensions === void 0) allowNegativeDimensions = false;
        return _super.call(this, {
            x: x,
            y: y,
            width: width,
            height: height
        }, allowNegativeDimensions) || this;
    }
    return Rect;
}((0, $c24b8f381986ff10$export$e71c4d32a2263218));


// face alignment constants
var $cf4d8aca6a25dc8f$var$relX = 0.5;
var $cf4d8aca6a25dc8f$var$relY = 0.43;
var $cf4d8aca6a25dc8f$var$relScale = 0.45;
var $cf4d8aca6a25dc8f$export$a2e672dd92b622a7 = /** @class */ function() {
    function FaceLandmarks(relativeFaceLandmarkPositions, imgDims, shift) {
        if (shift === void 0) shift = new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(0, 0);
        var width = imgDims.width, height = imgDims.height;
        this._imgDims = new (0, $95d2ae67e35f5d9d$export$d5b8c1948b345816)(width, height);
        this._shift = shift;
        this._positions = relativeFaceLandmarkPositions.map(function(pt) {
            return pt.mul(new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(width, height)).add(shift);
        });
    }
    Object.defineProperty(FaceLandmarks.prototype, "shift", {
        get: function() {
            return new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(this._shift.x, this._shift.y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FaceLandmarks.prototype, "imageWidth", {
        get: function() {
            return this._imgDims.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FaceLandmarks.prototype, "imageHeight", {
        get: function() {
            return this._imgDims.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FaceLandmarks.prototype, "positions", {
        get: function() {
            return this._positions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FaceLandmarks.prototype, "relativePositions", {
        get: function() {
            var _this = this;
            return this._positions.map(function(pt) {
                return pt.sub(_this._shift).div(new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(_this.imageWidth, _this.imageHeight));
            });
        },
        enumerable: true,
        configurable: true
    });
    FaceLandmarks.prototype.forSize = function(width, height) {
        return new this.constructor(this.relativePositions, {
            width: width,
            height: height
        });
    };
    FaceLandmarks.prototype.shiftBy = function(x, y) {
        return new this.constructor(this.relativePositions, this._imgDims, new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(x, y));
    };
    FaceLandmarks.prototype.shiftByPoint = function(pt) {
        return this.shiftBy(pt.x, pt.y);
    };
    /**
     * Aligns the face landmarks after face detection from the relative positions of the faces
     * bounding box, or it's current shift. This function should be used to align the face images
     * after face detection has been performed, before they are passed to the face recognition net.
     * This will make the computed face descriptor more accurate.
     *
     * @param detection (optional) The bounding box of the face or the face detection result. If
     * no argument was passed the position of the face landmarks are assumed to be relative to
     * it's current shift.
     * @returns The bounding box of the aligned face.
     */ FaceLandmarks.prototype.align = function(detection, options) {
        if (options === void 0) options = {};
        if (detection) {
            var box = detection instanceof (0, $86da6cbb0a7a9620$export$dc77199a917e22c2) ? detection.box.floor() : new (0, $c24b8f381986ff10$export$e71c4d32a2263218)(detection);
            return this.shiftBy(box.x, box.y).align(null, options);
        }
        var _a = Object.assign({}, {
            useDlibAlignment: false,
            minBoxPadding: 0.2
        }, options), useDlibAlignment = _a.useDlibAlignment, minBoxPadding = _a.minBoxPadding;
        if (useDlibAlignment) return this.alignDlib();
        return this.alignMinBbox(minBoxPadding);
    };
    FaceLandmarks.prototype.alignDlib = function() {
        var centers = this.getRefPointsForAlignment();
        var leftEyeCenter = centers[0], rightEyeCenter = centers[1], mouthCenter = centers[2];
        var distToMouth = function(pt) {
            return mouthCenter.sub(pt).magnitude();
        };
        var eyeToMouthDist = (distToMouth(leftEyeCenter) + distToMouth(rightEyeCenter)) / 2;
        var size = Math.floor(eyeToMouthDist / $cf4d8aca6a25dc8f$var$relScale);
        var refPoint = (0, $4c1c2b1e5936cf08$export$4f8e0fbe7322c1cd)(centers);
        // TODO: pad in case rectangle is out of image bounds
        var x = Math.floor(Math.max(0, refPoint.x - $cf4d8aca6a25dc8f$var$relX * size));
        var y = Math.floor(Math.max(0, refPoint.y - $cf4d8aca6a25dc8f$var$relY * size));
        return new (0, $aef801190ddb2db5$export$c79fc6492f3af13d)(x, y, Math.min(size, this.imageWidth + x), Math.min(size, this.imageHeight + y));
    };
    FaceLandmarks.prototype.alignMinBbox = function(padding) {
        var box = (0, $581cdab38d7198c0$export$1355ffefdcb7c178)(this.positions);
        return box.pad(box.width * padding, box.height * padding);
    };
    FaceLandmarks.prototype.getRefPointsForAlignment = function() {
        throw new Error("getRefPointsForAlignment not implemented by base class");
    };
    return FaceLandmarks;
}();





var $507a61368e2b7e43$export$16e5cdff813a4f0a = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceLandmarks5, _super);
    function FaceLandmarks5() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FaceLandmarks5.prototype.getRefPointsForAlignment = function() {
        var pts = this.positions;
        return [
            pts[0],
            pts[1],
            (0, $4c1c2b1e5936cf08$export$4f8e0fbe7322c1cd)([
                pts[3],
                pts[4]
            ])
        ];
    };
    return FaceLandmarks5;
}((0, $cf4d8aca6a25dc8f$export$a2e672dd92b622a7));





var $6f5f9d48a04e19fd$export$5e5b3e6dd53574c5 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceLandmarks68, _super);
    function FaceLandmarks68() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FaceLandmarks68.prototype.getJawOutline = function() {
        return this.positions.slice(0, 17);
    };
    FaceLandmarks68.prototype.getLeftEyeBrow = function() {
        return this.positions.slice(17, 22);
    };
    FaceLandmarks68.prototype.getRightEyeBrow = function() {
        return this.positions.slice(22, 27);
    };
    FaceLandmarks68.prototype.getNose = function() {
        return this.positions.slice(27, 36);
    };
    FaceLandmarks68.prototype.getLeftEye = function() {
        return this.positions.slice(36, 42);
    };
    FaceLandmarks68.prototype.getRightEye = function() {
        return this.positions.slice(42, 48);
    };
    FaceLandmarks68.prototype.getMouth = function() {
        return this.positions.slice(48, 68);
    };
    FaceLandmarks68.prototype.getRefPointsForAlignment = function() {
        return [
            this.getLeftEye(),
            this.getRightEye(),
            this.getMouth()
        ].map((0, $4c1c2b1e5936cf08$export$4f8e0fbe7322c1cd));
    };
    return FaceLandmarks68;
}((0, $cf4d8aca6a25dc8f$export$a2e672dd92b622a7));



var $e9730e5e0c01d652$export$458f566a73b40a79 = /** @class */ function() {
    function FaceMatch(label, distance) {
        this._label = label;
        this._distance = distance;
    }
    Object.defineProperty(FaceMatch.prototype, "label", {
        get: function() {
            return this._label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FaceMatch.prototype, "distance", {
        get: function() {
            return this._distance;
        },
        enumerable: true,
        configurable: true
    });
    FaceMatch.prototype.toString = function(withDistance) {
        if (withDistance === void 0) withDistance = true;
        return "" + this.label + (withDistance ? " (" + (0, $4c1c2b1e5936cf08$export$2077e0241d6afd3c)(this.distance) + ")" : "");
    };
    return FaceMatch;
}();





var $ae0091ef5f360437$export$dc148b0502442707 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(LabeledBox, _super);
    function LabeledBox(box, label) {
        var _this = _super.call(this, box) || this;
        _this._label = label;
        return _this;
    }
    LabeledBox.assertIsValidLabeledBox = function(box, callee) {
        (0, $c24b8f381986ff10$export$e71c4d32a2263218).assertIsValidBox(box, callee);
        if (!(0, $4c1c2b1e5936cf08$export$d6781b696a0576d1)(box.label)) throw new Error(callee + " - expected property label (" + box.label + ") to be a number");
    };
    Object.defineProperty(LabeledBox.prototype, "label", {
        get: function() {
            return this._label;
        },
        enumerable: true,
        configurable: true
    });
    return LabeledBox;
}((0, $c24b8f381986ff10$export$e71c4d32a2263218));


var $2eb798887d9813d6$export$716a745f210bce1a = /** @class */ function() {
    function LabeledFaceDescriptors(label, descriptors) {
        if (!(typeof label === "string")) throw new Error("LabeledFaceDescriptors - constructor expected label to be a string");
        if (!Array.isArray(descriptors) || descriptors.some(function(desc) {
            return !(desc instanceof Float32Array);
        })) throw new Error("LabeledFaceDescriptors - constructor expected descriptors to be an array of Float32Array");
        this._label = label;
        this._descriptors = descriptors;
    }
    Object.defineProperty(LabeledFaceDescriptors.prototype, "label", {
        get: function() {
            return this._label;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LabeledFaceDescriptors.prototype, "descriptors", {
        get: function() {
            return this._descriptors;
        },
        enumerable: true,
        configurable: true
    });
    LabeledFaceDescriptors.prototype.toJSON = function() {
        return {
            label: this.label,
            descriptors: this.descriptors.map(function(d) {
                return Array.from(d);
            })
        };
    };
    LabeledFaceDescriptors.fromJSON = function(json) {
        var descriptors = json.descriptors.map(function(d) {
            return new Float32Array(d);
        });
        return new LabeledFaceDescriptors(json.label, descriptors);
    };
    return LabeledFaceDescriptors;
}();







var $26fd8cbfcf6dcbc5$export$63f8acb1286b5113 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictedBox, _super);
    function PredictedBox(box, label, score, classScore) {
        var _this = _super.call(this, box, label) || this;
        _this._score = score;
        _this._classScore = classScore;
        return _this;
    }
    PredictedBox.assertIsValidPredictedBox = function(box, callee) {
        (0, $ae0091ef5f360437$export$dc148b0502442707).assertIsValidLabeledBox(box, callee);
        if (!(0, $4c1c2b1e5936cf08$export$8c6c09d122023c19)(box.score) || !(0, $4c1c2b1e5936cf08$export$8c6c09d122023c19)(box.classScore)) throw new Error(callee + " - expected properties score (" + box.score + ") and (" + box.classScore + ") to be a number between [0, 1]");
    };
    Object.defineProperty(PredictedBox.prototype, "score", {
        get: function() {
            return this._score;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PredictedBox.prototype, "classScore", {
        get: function() {
            return this._classScore;
        },
        enumerable: true,
        configurable: true
    });
    return PredictedBox;
}((0, $ae0091ef5f360437$export$dc148b0502442707));







function $0be2c959ccd6f649$export$2dad0453743890bf(obj) {
    return obj["detection"] instanceof (0, $86da6cbb0a7a9620$export$dc77199a917e22c2);
}
function $0be2c959ccd6f649$export$637b164fcc98d63f(sourceObj, detection) {
    var extension = {
        detection: detection
    };
    return Object.assign({}, sourceObj, extension);
}




function $7e874240b499e205$export$54e2d221b0bb901f() {
    var fetch = window["fetch"] || function() {
        throw new Error("fetch - missing fetch implementation for browser environment");
    };
    var readFile = function() {
        throw new Error("readFile - filesystem not available for browser environment");
    };
    return {
        Canvas: HTMLCanvasElement,
        CanvasRenderingContext2D: CanvasRenderingContext2D,
        Image: HTMLImageElement,
        ImageData: ImageData,
        Video: HTMLVideoElement,
        createCanvasElement: function() {
            return document.createElement("canvas");
        },
        createImageElement: function() {
            return document.createElement("img");
        },
        fetch: fetch,
        readFile: readFile
    };
}



function $87be65f6793b1f53$export$693cd14e4758092e(fs) {
    var requireFsError = "";
    if (!fs) try {
        fs = (parcelRequire("1S6xU"));
    } catch (err) {
        requireFsError = err.toString();
    }
    var readFile = fs ? function(filePath) {
        return new Promise(function(res, rej) {
            fs.readFile(filePath, function(err, buffer) {
                return err ? rej(err) : res(buffer);
            });
        });
    } : function() {
        throw new Error("readFile - failed to require fs in nodejs environment with error: " + requireFsError);
    };
    return {
        readFile: readFile
    };
}




function $c0abf41bc09a9e17$export$39b7cca8a0e96bd1() {
    var Canvas = $parcel$global["Canvas"] || $parcel$global["HTMLCanvasElement"];
    var Image = $parcel$global["Image"] || $parcel$global["HTMLImageElement"];
    var createCanvasElement = function() {
        if (Canvas) return new Canvas();
        throw new Error("createCanvasElement - missing Canvas implementation for nodejs environment");
    };
    var createImageElement = function() {
        if (Image) return new Image();
        throw new Error("createImageElement - missing Image implementation for nodejs environment");
    };
    var fetch = $parcel$global["fetch"] || function() {
        throw new Error("fetch - missing fetch implementation for nodejs environment");
    };
    var fileSystem = (0, $87be65f6793b1f53$export$693cd14e4758092e)();
    return (0, $c5ef6752615abb23$export$18ce0697a983be9b)({
        Canvas: Canvas || /** @class */ function() {
            function Canvas() {}
            return Canvas;
        }(),
        CanvasRenderingContext2D: $parcel$global["CanvasRenderingContext2D"] || /** @class */ function() {
            function class_1() {}
            return class_1;
        }(),
        Image: Image || /** @class */ function() {
            function Image() {}
            return Image;
        }(),
        ImageData: $parcel$global["ImageData"] || /** @class */ function() {
            function class_2() {}
            return class_2;
        }(),
        Video: $parcel$global["HTMLVideoElement"] || /** @class */ function() {
            function class_3() {}
            return class_3;
        }(),
        createCanvasElement: createCanvasElement,
        createImageElement: createImageElement,
        fetch: fetch
    }, fileSystem);
}


function $2d99e3774b3f913a$export$4e09c449d6c407f7() {
    return typeof window === "object" && typeof document !== "undefined" && typeof HTMLImageElement !== "undefined" && typeof HTMLCanvasElement !== "undefined" && typeof HTMLVideoElement !== "undefined" && typeof ImageData !== "undefined" && typeof CanvasRenderingContext2D !== "undefined";
}



var $cmlvI = parcelRequire("cmlvI");
function $61746cfdf9042a2b$export$e7163a08b04175b9() {
    return typeof $parcel$global === "object" && true && true && typeof $cmlvI !== "undefined" && !!$cmlvI.version;
}


var $cb889b654af1b67d$var$environment;
function $cb889b654af1b67d$var$getEnv() {
    if (!$cb889b654af1b67d$var$environment) throw new Error("getEnv - environment is not defined, check isNodejs() and isBrowser()");
    return $cb889b654af1b67d$var$environment;
}
function $cb889b654af1b67d$var$setEnv(env) {
    $cb889b654af1b67d$var$environment = env;
}
function $cb889b654af1b67d$var$initialize() {
    // check for isBrowser() first to prevent electron renderer process
    // to be initialized with wrong environment due to isNodejs() returning true
    if ((0, $2d99e3774b3f913a$export$4e09c449d6c407f7)()) $cb889b654af1b67d$var$setEnv((0, $7e874240b499e205$export$54e2d221b0bb901f)());
    if ((0, $61746cfdf9042a2b$export$e7163a08b04175b9)()) $cb889b654af1b67d$var$setEnv((0, $c0abf41bc09a9e17$export$39b7cca8a0e96bd1)());
}
function $cb889b654af1b67d$var$monkeyPatch(env) {
    if (!$cb889b654af1b67d$var$environment) $cb889b654af1b67d$var$initialize();
    if (!$cb889b654af1b67d$var$environment) throw new Error("monkeyPatch - environment is not defined, check isNodejs() and isBrowser()");
    var _a = env.Canvas, Canvas = _a === void 0 ? $cb889b654af1b67d$var$environment.Canvas : _a, _b = env.Image, Image = _b === void 0 ? $cb889b654af1b67d$var$environment.Image : _b;
    $cb889b654af1b67d$var$environment.Canvas = Canvas;
    $cb889b654af1b67d$var$environment.Image = Image;
    $cb889b654af1b67d$var$environment.createCanvasElement = env.createCanvasElement || function() {
        return new Canvas();
    };
    $cb889b654af1b67d$var$environment.createImageElement = env.createImageElement || function() {
        return new Image();
    };
    $cb889b654af1b67d$var$environment.ImageData = env.ImageData || $cb889b654af1b67d$var$environment.ImageData;
    $cb889b654af1b67d$var$environment.Video = env.Video || $cb889b654af1b67d$var$environment.Video;
    $cb889b654af1b67d$var$environment.fetch = env.fetch || $cb889b654af1b67d$var$environment.fetch;
    $cb889b654af1b67d$var$environment.readFile = env.readFile || $cb889b654af1b67d$var$environment.readFile;
}
var $cb889b654af1b67d$export$a7b6bc01c63cdfc3 = {
    getEnv: $cb889b654af1b67d$var$getEnv,
    setEnv: $cb889b654af1b67d$var$setEnv,
    initialize: $cb889b654af1b67d$var$initialize,
    createBrowserEnv: (0, $7e874240b499e205$export$54e2d221b0bb901f),
    createFileSystem: (0, $87be65f6793b1f53$export$693cd14e4758092e),
    createNodejsEnv: (0, $c0abf41bc09a9e17$export$39b7cca8a0e96bd1),
    monkeyPatch: $cb889b654af1b67d$var$monkeyPatch,
    isBrowser: (0, $2d99e3774b3f913a$export$4e09c449d6c407f7),
    isNodejs: (0, $61746cfdf9042a2b$export$e7163a08b04175b9)
};
$cb889b654af1b67d$var$initialize();



function $7fbf2b50550477a2$export$6b00f15e011fe783(arg) {
    if (!(0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).isNodejs() && typeof arg === "string") return document.getElementById(arg);
    return arg;
}


function $c40df77cbcb9e781$export$40d273013da632b6(canvasArg) {
    var _a = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv(), Canvas = _a.Canvas, CanvasRenderingContext2D = _a.CanvasRenderingContext2D;
    if (canvasArg instanceof CanvasRenderingContext2D) return canvasArg;
    var canvas = (0, $7fbf2b50550477a2$export$6b00f15e011fe783)(canvasArg);
    if (!(canvas instanceof Canvas)) throw new Error("resolveContext2d - expected canvas to be of instance of Canvas");
    var ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("resolveContext2d - canvas 2d context is null");
    return ctx;
}




var $fb218195190972cb$export$46f2ac8590c84f57;
(function(AnchorPosition) {
    AnchorPosition["TOP_LEFT"] = "TOP_LEFT";
    AnchorPosition["TOP_RIGHT"] = "TOP_RIGHT";
    AnchorPosition["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    AnchorPosition["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})($fb218195190972cb$export$46f2ac8590c84f57 || ($fb218195190972cb$export$46f2ac8590c84f57 = {}));
var $fb218195190972cb$export$d96baa95b0119f11 = /** @class */ function() {
    function DrawTextFieldOptions(options) {
        if (options === void 0) options = {};
        var anchorPosition = options.anchorPosition, backgroundColor = options.backgroundColor, fontColor = options.fontColor, fontSize = options.fontSize, fontStyle = options.fontStyle, padding = options.padding;
        this.anchorPosition = anchorPosition || $fb218195190972cb$export$46f2ac8590c84f57.TOP_LEFT;
        this.backgroundColor = backgroundColor || "rgba(0, 0, 0, 0.5)";
        this.fontColor = fontColor || "rgba(255, 255, 255, 1)";
        this.fontSize = fontSize || 14;
        this.fontStyle = fontStyle || "Georgia";
        this.padding = padding || 4;
    }
    return DrawTextFieldOptions;
}();
var $fb218195190972cb$export$c176ca95f96aff69 = /** @class */ function() {
    function DrawTextField(text, anchor, options) {
        if (options === void 0) options = {};
        this.text = typeof text === "string" ? [
            text
        ] : text instanceof DrawTextField ? text.text : text;
        this.anchor = anchor;
        this.options = new $fb218195190972cb$export$d96baa95b0119f11(options);
    }
    DrawTextField.prototype.measureWidth = function(ctx) {
        var padding = this.options.padding;
        return this.text.map(function(l) {
            return ctx.measureText(l).width;
        }).reduce(function(w0, w1) {
            return w0 < w1 ? w1 : w0;
        }, 0) + 2 * padding;
    };
    DrawTextField.prototype.measureHeight = function() {
        var _a = this.options, fontSize = _a.fontSize, padding = _a.padding;
        return this.text.length * fontSize + 2 * padding;
    };
    DrawTextField.prototype.getUpperLeft = function(ctx, canvasDims) {
        var anchorPosition = this.options.anchorPosition;
        var isShiftLeft = anchorPosition === $fb218195190972cb$export$46f2ac8590c84f57.BOTTOM_RIGHT || anchorPosition === $fb218195190972cb$export$46f2ac8590c84f57.TOP_RIGHT;
        var isShiftTop = anchorPosition === $fb218195190972cb$export$46f2ac8590c84f57.BOTTOM_LEFT || anchorPosition === $fb218195190972cb$export$46f2ac8590c84f57.BOTTOM_RIGHT;
        var textFieldWidth = this.measureWidth(ctx);
        var textFieldHeight = this.measureHeight();
        var x = isShiftLeft ? this.anchor.x - textFieldWidth : this.anchor.x;
        var y = isShiftTop ? this.anchor.y - textFieldHeight : this.anchor.y;
        // adjust anchor if text box exceeds canvas borders
        if (canvasDims) {
            var width = canvasDims.width, height = canvasDims.height;
            var newX = Math.max(Math.min(x, width - textFieldWidth), 0);
            var newY = Math.max(Math.min(y, height - textFieldHeight), 0);
            return {
                x: newX,
                y: newY
            };
        }
        return {
            x: x,
            y: y
        };
    };
    DrawTextField.prototype.draw = function(canvasArg) {
        var canvas = (0, $7fbf2b50550477a2$export$6b00f15e011fe783)(canvasArg);
        var ctx = (0, $c40df77cbcb9e781$export$40d273013da632b6)(canvas);
        var _a = this.options, backgroundColor = _a.backgroundColor, fontColor = _a.fontColor, fontSize = _a.fontSize, fontStyle = _a.fontStyle, padding = _a.padding;
        ctx.font = fontSize + "px " + fontStyle;
        var maxTextWidth = this.measureWidth(ctx);
        var textHeight = this.measureHeight();
        ctx.fillStyle = backgroundColor;
        var upperLeft = this.getUpperLeft(ctx, canvas);
        ctx.fillRect(upperLeft.x, upperLeft.y, maxTextWidth, textHeight);
        ctx.fillStyle = fontColor;
        this.text.forEach(function(textLine, i) {
            var x = padding + upperLeft.x;
            var y = padding + upperLeft.y + (i + 1) * fontSize;
            ctx.fillText(textLine, x, y);
        });
    };
    return DrawTextField;
}();


var $ea66e670b6641f2c$export$44dff08adf85e37f = /** @class */ function() {
    function DrawBoxOptions(options) {
        if (options === void 0) options = {};
        var boxColor = options.boxColor, lineWidth = options.lineWidth, label = options.label, drawLabelOptions = options.drawLabelOptions;
        this.boxColor = boxColor || "rgba(0, 0, 255, 1)";
        this.lineWidth = lineWidth || 2;
        this.label = label;
        var defaultDrawLabelOptions = {
            anchorPosition: (0, $fb218195190972cb$export$46f2ac8590c84f57).BOTTOM_LEFT,
            backgroundColor: this.boxColor
        };
        this.drawLabelOptions = new (0, $fb218195190972cb$export$d96baa95b0119f11)(Object.assign({}, defaultDrawLabelOptions, drawLabelOptions));
    }
    return DrawBoxOptions;
}();
var $ea66e670b6641f2c$export$110703ce240af00c = /** @class */ function() {
    function DrawBox(box, options) {
        if (options === void 0) options = {};
        this.box = new (0, $c24b8f381986ff10$export$e71c4d32a2263218)(box);
        this.options = new $ea66e670b6641f2c$export$44dff08adf85e37f(options);
    }
    DrawBox.prototype.draw = function(canvasArg) {
        var ctx = (0, $c40df77cbcb9e781$export$40d273013da632b6)(canvasArg);
        var _a = this.options, boxColor = _a.boxColor, lineWidth = _a.lineWidth;
        var _b = this.box, x = _b.x, y = _b.y, width = _b.width, height = _b.height;
        ctx.strokeStyle = boxColor;
        ctx.lineWidth = lineWidth;
        ctx.strokeRect(x, y, width, height);
        var label = this.options.label;
        if (label) new (0, $fb218195190972cb$export$c176ca95f96aff69)([
            label
        ], {
            x: x - lineWidth / 2,
            y: y
        }, this.options.drawLabelOptions).draw(canvasArg);
    };
    return DrawBox;
}();


function $1c43a2291156c2f8$export$cba50806131430a(canvasArg, detections) {
    var detectionsArray = Array.isArray(detections) ? detections : [
        detections
    ];
    detectionsArray.forEach(function(det) {
        var score = det instanceof (0, $86da6cbb0a7a9620$export$dc77199a917e22c2) ? det.score : (0, $0be2c959ccd6f649$export$2dad0453743890bf)(det) ? det.detection.score : undefined;
        var box = det instanceof (0, $86da6cbb0a7a9620$export$dc77199a917e22c2) ? det.box : (0, $0be2c959ccd6f649$export$2dad0453743890bf)(det) ? det.detection.box : new (0, $c24b8f381986ff10$export$e71c4d32a2263218)(det);
        var label = score ? "" + (0, $4c1c2b1e5936cf08$export$2077e0241d6afd3c)(score) : undefined;
        new (0, $ea66e670b6641f2c$export$110703ce240af00c)(box, {
            label: label
        }).draw(canvasArg);
    });
}





var $hA0xX = parcelRequire("hA0xX");


function $20df92554189c4e2$export$affc88aa7d0cacb(media) {
    var _a = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv(), Image = _a.Image, Video = _a.Video;
    return media instanceof Image && media.complete || media instanceof Video && media.readyState >= 3;
}


function $b1b49f0fcfb2502f$export$41fd6993145a624f(media) {
    return new Promise(function(resolve, reject) {
        if (media instanceof (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv().Canvas || (0, $20df92554189c4e2$export$affc88aa7d0cacb)(media)) return resolve();
        function onLoad(e) {
            if (!e.currentTarget) return;
            e.currentTarget.removeEventListener("load", onLoad);
            e.currentTarget.removeEventListener("error", onError);
            resolve(e);
        }
        function onError(e) {
            if (!e.currentTarget) return;
            e.currentTarget.removeEventListener("load", onLoad);
            e.currentTarget.removeEventListener("error", onError);
            reject(e);
        }
        media.addEventListener("load", onLoad);
        media.addEventListener("error", onError);
    });
}



function $63b67fcde42ae16b$export$13a3eeeb9d235509(buf) {
    return new Promise(function(resolve, reject) {
        if (!(buf instanceof Blob)) return reject("bufferToImage - expected buf to be of type: Blob");
        var reader = new FileReader();
        reader.onload = function() {
            if (typeof reader.result !== "string") return reject("bufferToImage - expected reader.result to be a string, in onload");
            var img = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv().createImageElement();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = reader.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(buf);
    });
}






function $670e9f1fdb562e99$export$6546ae40f758dd7d(input) {
    var _a = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv(), Image = _a.Image, Video = _a.Video;
    if (input instanceof Image) return new (0, $95d2ae67e35f5d9d$export$d5b8c1948b345816)(input.naturalWidth, input.naturalHeight);
    if (input instanceof Video) return new (0, $95d2ae67e35f5d9d$export$d5b8c1948b345816)(input.videoWidth, input.videoHeight);
    return new (0, $95d2ae67e35f5d9d$export$d5b8c1948b345816)(input.width, input.height);
}



function $8aaafed594548f89$export$cd3d1f114b139967(_a) {
    var width = _a.width, height = _a.height;
    var createCanvasElement = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv().createCanvasElement;
    var canvas = createCanvasElement();
    canvas.width = width;
    canvas.height = height;
    return canvas;
}
function $8aaafed594548f89$export$a5a7c95acc5cffa0(media, dims) {
    var ImageData = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv().ImageData;
    if (!(media instanceof ImageData) && !(0, $20df92554189c4e2$export$affc88aa7d0cacb)(media)) throw new Error("createCanvasFromMedia - media has not finished loading yet");
    var _a = dims || (0, $670e9f1fdb562e99$export$6546ae40f758dd7d)(media), width = _a.width, height = _a.height;
    var canvas = $8aaafed594548f89$export$cd3d1f114b139967({
        width: width,
        height: height
    });
    if (media instanceof ImageData) (0, $c40df77cbcb9e781$export$40d273013da632b6)(canvas).putImageData(media, 0, 0);
    else (0, $c40df77cbcb9e781$export$40d273013da632b6)(canvas).drawImage(media, 0, 0, width, height);
    return canvas;
}









var $hA0xX = parcelRequire("hA0xX");


function $214e707ffde63ef8$export$27916b8837dd6a11(imgTensor, canvas) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var targetCanvas, _a, height, width, numChannels, imgTensor3D;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    targetCanvas = canvas || (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv().createCanvasElement();
                    _a = imgTensor.shape.slice((0, $4c1c2b1e5936cf08$export$d19096252e754643)(imgTensor) ? 1 : 0), height = _a[0], width = _a[1], numChannels = _a[2];
                    imgTensor3D = $hA0xX.tidy(function() {
                        return imgTensor.as3D(height, width, numChannels).toInt();
                    });
                    return [
                        4 /*yield*/ ,
                        $hA0xX.browser.toPixels(imgTensor3D, targetCanvas)
                    ];
                case 1:
                    _b.sent();
                    imgTensor3D.dispose();
                    return [
                        2 /*return*/ ,
                        targetCanvas
                    ];
            }
        });
    });
}






function $b710e90bd1fc9bbe$export$c9096aa6a573e5bb(input) {
    var _a = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv(), Image = _a.Image, Canvas = _a.Canvas, Video = _a.Video;
    return input instanceof Image || input instanceof Canvas || input instanceof Video;
}



var $hA0xX = parcelRequire("hA0xX");








function $356c90ab4814eaa0$export$a90facd2926d3d6f(input, inputSize, centerImage) {
    if (centerImage === void 0) centerImage = false;
    var _a = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv(), Image = _a.Image, Canvas = _a.Canvas;
    if (!(input instanceof Image || input instanceof Canvas)) throw new Error("imageToSquare - expected arg0 to be HTMLImageElement | HTMLCanvasElement");
    var dims = (0, $670e9f1fdb562e99$export$6546ae40f758dd7d)(input);
    var scale = inputSize / Math.max(dims.height, dims.width);
    var width = scale * dims.width;
    var height = scale * dims.height;
    var targetCanvas = (0, $8aaafed594548f89$export$cd3d1f114b139967)({
        width: inputSize,
        height: inputSize
    });
    var inputCanvas = input instanceof Canvas ? input : (0, $8aaafed594548f89$export$a5a7c95acc5cffa0)(input);
    var offset = Math.abs(width - height) / 2;
    var dx = centerImage && width < height ? offset : 0;
    var dy = centerImage && height < width ? offset : 0;
    (0, $c40df77cbcb9e781$export$40d273013da632b6)(targetCanvas).drawImage(inputCanvas, dx, dy, width, height);
    return targetCanvas;
}


var $89ff8a044ed2569b$export$d4b5e83a462ad4ac = /** @class */ function() {
    function NetInput(inputs, treatAsBatchInput) {
        var _this = this;
        if (treatAsBatchInput === void 0) treatAsBatchInput = false;
        this._imageTensors = [];
        this._canvases = [];
        this._treatAsBatchInput = false;
        this._inputDimensions = [];
        if (!Array.isArray(inputs)) throw new Error("NetInput.constructor - expected inputs to be an Array of TResolvedNetInput or to be instanceof tf.Tensor4D, instead have " + inputs);
        this._treatAsBatchInput = treatAsBatchInput;
        this._batchSize = inputs.length;
        inputs.forEach(function(input, idx) {
            if ((0, $4c1c2b1e5936cf08$export$e3e19112bd5349fe)(input)) {
                _this._imageTensors[idx] = input;
                _this._inputDimensions[idx] = input.shape;
                return;
            }
            if ((0, $4c1c2b1e5936cf08$export$d19096252e754643)(input)) {
                var batchSize = input.shape[0];
                if (batchSize !== 1) throw new Error("NetInput - tf.Tensor4D with batchSize " + batchSize + " passed, but not supported in input array");
                _this._imageTensors[idx] = input;
                _this._inputDimensions[idx] = input.shape.slice(1);
                return;
            }
            var canvas = input instanceof (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv().Canvas ? input : (0, $8aaafed594548f89$export$a5a7c95acc5cffa0)(input);
            _this._canvases[idx] = canvas;
            _this._inputDimensions[idx] = [
                canvas.height,
                canvas.width,
                3
            ];
        });
    }
    Object.defineProperty(NetInput.prototype, "imageTensors", {
        get: function() {
            return this._imageTensors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NetInput.prototype, "canvases", {
        get: function() {
            return this._canvases;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NetInput.prototype, "isBatchInput", {
        get: function() {
            return this.batchSize > 1 || this._treatAsBatchInput;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NetInput.prototype, "batchSize", {
        get: function() {
            return this._batchSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NetInput.prototype, "inputDimensions", {
        get: function() {
            return this._inputDimensions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NetInput.prototype, "inputSize", {
        get: function() {
            return this._inputSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NetInput.prototype, "reshapedInputDimensions", {
        get: function() {
            var _this = this;
            return (0, $4c1c2b1e5936cf08$export$d02631cccf789723)(this.batchSize, 0, 1).map(function(_, batchIdx) {
                return _this.getReshapedInputDimensions(batchIdx);
            });
        },
        enumerable: true,
        configurable: true
    });
    NetInput.prototype.getInput = function(batchIdx) {
        return this.canvases[batchIdx] || this.imageTensors[batchIdx];
    };
    NetInput.prototype.getInputDimensions = function(batchIdx) {
        return this._inputDimensions[batchIdx];
    };
    NetInput.prototype.getInputHeight = function(batchIdx) {
        return this._inputDimensions[batchIdx][0];
    };
    NetInput.prototype.getInputWidth = function(batchIdx) {
        return this._inputDimensions[batchIdx][1];
    };
    NetInput.prototype.getReshapedInputDimensions = function(batchIdx) {
        if (typeof this.inputSize !== "number") throw new Error("getReshapedInputDimensions - inputSize not set, toBatchTensor has not been called yet");
        var width = this.getInputWidth(batchIdx);
        var height = this.getInputHeight(batchIdx);
        return (0, $4c1c2b1e5936cf08$export$c55ab00bd17542e8)({
            width: width,
            height: height
        }, this.inputSize);
    };
    /**
     * Create a batch tensor from all input canvases and tensors
     * with size [batchSize, inputSize, inputSize, 3].
     *
     * @param inputSize Height and width of the tensor.
     * @param isCenterImage (optional, default: false) If true, add an equal amount of padding on
     * both sides of the minor dimension oof the image.
     * @returns The batch tensor.
     */ NetInput.prototype.toBatchTensor = function(inputSize, isCenterInputs) {
        var _this = this;
        if (isCenterInputs === void 0) isCenterInputs = true;
        this._inputSize = inputSize;
        return $hA0xX.tidy(function() {
            var inputTensors = (0, $4c1c2b1e5936cf08$export$d02631cccf789723)(_this.batchSize, 0, 1).map(function(batchIdx) {
                var input = _this.getInput(batchIdx);
                if (input instanceof $hA0xX.Tensor) {
                    var imgTensor = (0, $4c1c2b1e5936cf08$export$d19096252e754643)(input) ? input : input.expandDims();
                    imgTensor = (0, $45d96e1d1c4b6311$export$1c0e305c9992342)(imgTensor, isCenterInputs);
                    if (imgTensor.shape[1] !== inputSize || imgTensor.shape[2] !== inputSize) imgTensor = $hA0xX.image.resizeBilinear(imgTensor, [
                        inputSize,
                        inputSize
                    ]);
                    return imgTensor.as3D(inputSize, inputSize, 3);
                }
                if (input instanceof (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv().Canvas) return $hA0xX.browser.fromPixels((0, $356c90ab4814eaa0$export$a90facd2926d3d6f)(input, inputSize, isCenterInputs));
                throw new Error("toBatchTensor - at batchIdx " + batchIdx + ", expected input to be instanceof tf.Tensor or instanceof HTMLCanvasElement, instead have " + input);
            });
            var batchTensor = $hA0xX.stack(inputTensors.map(function(t) {
                return t.toFloat();
            })).as4D(_this.batchSize, inputSize, inputSize, 3);
            return batchTensor;
        });
    };
    return NetInput;
}();



function $1c337d29aa263e52$export$62e8dacccc036b74(inputs) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var inputArgArray, getIdxHint, inputArray;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (inputs instanceof (0, $89ff8a044ed2569b$export$d4b5e83a462ad4ac)) return [
                        2 /*return*/ ,
                        inputs
                    ];
                    inputArgArray = Array.isArray(inputs) ? inputs : [
                        inputs
                    ];
                    if (!inputArgArray.length) throw new Error("toNetInput - empty array passed as input");
                    getIdxHint = function(idx) {
                        return Array.isArray(inputs) ? " at input index " + idx + ":" : "";
                    };
                    inputArray = inputArgArray.map((0, $7fbf2b50550477a2$export$6b00f15e011fe783));
                    inputArray.forEach(function(input, i) {
                        if (!(0, $b710e90bd1fc9bbe$export$c9096aa6a573e5bb)(input) && !(0, $4c1c2b1e5936cf08$export$e3e19112bd5349fe)(input) && !(0, $4c1c2b1e5936cf08$export$d19096252e754643)(input)) {
                            if (typeof inputArgArray[i] === "string") throw new Error("toNetInput -" + getIdxHint(i) + " string passed, but could not resolve HTMLElement for element id " + inputArgArray[i]);
                            throw new Error("toNetInput -" + getIdxHint(i) + " expected media to be of type HTMLImageElement | HTMLVideoElement | HTMLCanvasElement | tf.Tensor3D, or to be an element id");
                        }
                        if ((0, $4c1c2b1e5936cf08$export$d19096252e754643)(input)) {
                            // if tf.Tensor4D is passed in the input array, the batch size has to be 1
                            var batchSize = input.shape[0];
                            if (batchSize !== 1) throw new Error("toNetInput -" + getIdxHint(i) + " tf.Tensor4D with batchSize " + batchSize + " passed, but not supported in input array");
                        }
                    });
                    // wait for all media elements being loaded
                    return [
                        4 /*yield*/ ,
                        Promise.all(inputArray.map(function(input) {
                            return (0, $b710e90bd1fc9bbe$export$c9096aa6a573e5bb)(input) && (0, $b1b49f0fcfb2502f$export$41fd6993145a624f)(input);
                        }))
                    ];
                case 1:
                    // wait for all media elements being loaded
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        new (0, $89ff8a044ed2569b$export$d4b5e83a462ad4ac)(inputArray, Array.isArray(inputs))
                    ];
            }
        });
    });
}


function $539219fdf6e46a7a$export$a6268ec9f807b452(input, detections) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var Canvas, canvas, netInput, tensorOrCanvas, _a, ctx, boxes;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    Canvas = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv().Canvas;
                    canvas = input;
                    if (!!(input instanceof Canvas)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                    ];
                case 1:
                    netInput = _b.sent();
                    if (netInput.batchSize > 1) throw new Error("extractFaces - batchSize > 1 not supported");
                    tensorOrCanvas = netInput.getInput(0);
                    if (!(tensorOrCanvas instanceof Canvas)) return [
                        3 /*break*/ ,
                        2
                    ];
                    _a = tensorOrCanvas;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $214e707ffde63ef8$export$27916b8837dd6a11)(tensorOrCanvas)
                    ];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    canvas = _a;
                    _b.label = 5;
                case 5:
                    ctx = (0, $c40df77cbcb9e781$export$40d273013da632b6)(canvas);
                    boxes = detections.map(function(det) {
                        return det instanceof (0, $86da6cbb0a7a9620$export$dc77199a917e22c2) ? det.forSize(canvas.width, canvas.height).box.floor() : det;
                    }).map(function(box) {
                        return box.clipAtImageBorders(canvas.width, canvas.height);
                    });
                    return [
                        2 /*return*/ ,
                        boxes.map(function(_a) {
                            var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
                            var faceImg = (0, $8aaafed594548f89$export$cd3d1f114b139967)({
                                width: width,
                                height: height
                            });
                            (0, $c40df77cbcb9e781$export$40d273013da632b6)(faceImg).putImageData(ctx.getImageData(x, y, width, height), 0, 0);
                            return faceImg;
                        })
                    ];
            }
        });
    });
}




var $hA0xX = parcelRequire("hA0xX");


function $0c146d6bc429a854$export$42290f6c8994c1ec(imageTensor, detections) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
            if (!(0, $4c1c2b1e5936cf08$export$e3e19112bd5349fe)(imageTensor) && !(0, $4c1c2b1e5936cf08$export$d19096252e754643)(imageTensor)) throw new Error("extractFaceTensors - expected image tensor to be 3D or 4D");
            if ((0, $4c1c2b1e5936cf08$export$d19096252e754643)(imageTensor) && imageTensor.shape[0] > 1) throw new Error("extractFaceTensors - batchSize > 1 not supported");
            return [
                2 /*return*/ ,
                $hA0xX.tidy(function() {
                    var _a = imageTensor.shape.slice((0, $4c1c2b1e5936cf08$export$d19096252e754643)(imageTensor) ? 1 : 0), imgHeight = _a[0], imgWidth = _a[1], numChannels = _a[2];
                    var boxes = detections.map(function(det) {
                        return det instanceof (0, $86da6cbb0a7a9620$export$dc77199a917e22c2) ? det.forSize(imgWidth, imgHeight).box : det;
                    }).map(function(box) {
                        return box.clipAtImageBorders(imgWidth, imgHeight);
                    });
                    var faceTensors = boxes.map(function(_a) {
                        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
                        return $hA0xX.slice3d(imageTensor.as3D(imgHeight, imgWidth, numChannels), [
                            y,
                            x,
                            0
                        ], [
                            height,
                            width,
                            numChannels
                        ]);
                    });
                    return faceTensors;
                })
            ];
        });
    });
}






function $cb6fe29786a4c13d$export$65038256ee8843af(url, init) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var fetch, res;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    fetch = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv().fetch;
                    return [
                        4 /*yield*/ ,
                        fetch(url, init)
                    ];
                case 1:
                    res = _a.sent();
                    if (!(res.status < 400)) throw new Error("failed to fetch: (" + res.status + ") " + res.statusText + ", from url: " + res.url);
                    return [
                        2 /*return*/ ,
                        res
                    ];
            }
        });
    });
}


function $92d56dad07cc600e$export$260f1342281499a4(uri) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var res, blob;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, $cb6fe29786a4c13d$export$65038256ee8843af)(uri)
                    ];
                case 1:
                    res = _a.sent();
                    return [
                        4 /*yield*/ ,
                        res.blob()
                    ];
                case 2:
                    blob = _a.sent();
                    if (!blob.type.startsWith("image/")) throw new Error("fetchImage - expected blob type to be of type image/*, instead have: " + blob.type + ", for url: " + res.url);
                    return [
                        2 /*return*/ ,
                        (0, $63b67fcde42ae16b$export$13a3eeeb9d235509)(blob)
                    ];
            }
        });
    });
}




function $830a89c570c313d7$export$6d71b655afe1638d(uri) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        (0, $cb6fe29786a4c13d$export$65038256ee8843af)(uri)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent().json()
                    ];
            }
        });
    });
}




function $28f8ed7578f18c52$export$c05d9abe8d6799ea(uri) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var _a;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = Float32Array.bind;
                    return [
                        4 /*yield*/ ,
                        (0, $cb6fe29786a4c13d$export$65038256ee8843af)(uri)
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        _b.sent().arrayBuffer()
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        new (_a.apply(Float32Array, [
                            void 0,
                            _b.sent()
                        ]))()
                    ];
            }
        });
    });
}











var $hA0xX = parcelRequire("hA0xX");
function $0d32132744a737ad$export$a0d5a8fce32d1b45(uri, defaultModelName) {
    var defaultManifestFilename = defaultModelName + "-weights_manifest.json";
    if (!uri) return {
        modelBaseUri: "",
        manifestUri: defaultManifestFilename
    };
    if (uri === "/") return {
        modelBaseUri: "/",
        manifestUri: "/" + defaultManifestFilename
    };
    var protocol = uri.startsWith("http://") ? "http://" : uri.startsWith("https://") ? "https://" : "";
    uri = uri.replace(protocol, "");
    var parts = uri.split("/").filter(function(s) {
        return s;
    });
    var manifestFile = uri.endsWith(".json") ? parts[parts.length - 1] : defaultManifestFilename;
    var modelBaseUri = protocol + (uri.endsWith(".json") ? parts.slice(0, parts.length - 1) : parts).join("/");
    modelBaseUri = uri.startsWith("/") ? "/" + modelBaseUri : modelBaseUri;
    return {
        modelBaseUri: modelBaseUri,
        manifestUri: modelBaseUri === "/" ? "/" + manifestFile : modelBaseUri + "/" + manifestFile
    };
}



function $ba750443bdb72c5e$export$d28d7aef3b4cc323(uri, defaultModelName) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var _a, manifestUri, modelBaseUri, manifest;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = (0, $0d32132744a737ad$export$a0d5a8fce32d1b45)(uri, defaultModelName), manifestUri = _a.manifestUri, modelBaseUri = _a.modelBaseUri;
                    return [
                        4 /*yield*/ ,
                        (0, $830a89c570c313d7$export$6d71b655afe1638d)(manifestUri)
                    ];
                case 1:
                    manifest = _b.sent();
                    return [
                        2 /*return*/ ,
                        $hA0xX.io.loadWeights(manifest, modelBaseUri)
                    ];
            }
        });
    });
}



function $cf3996204eec444d$export$b208c0a1da3a53c6(input, reference, useMediaDimensions) {
    if (useMediaDimensions === void 0) useMediaDimensions = false;
    var _a = useMediaDimensions ? (0, $670e9f1fdb562e99$export$6546ae40f758dd7d)(reference) : reference, width = _a.width, height = _a.height;
    input.width = width;
    input.height = height;
    return {
        width: width,
        height: height
    };
}









var $hA0xX = parcelRequire("hA0xX");



var $hA0xX = parcelRequire("hA0xX");



var $89ef56f11ec234e4$export$3a2d186bf4f565eb = /** @class */ function() {
    function NeuralNetwork(_name) {
        this._name = _name;
        this._params = undefined;
        this._paramMappings = [];
    }
    Object.defineProperty(NeuralNetwork.prototype, "params", {
        get: function() {
            return this._params;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NeuralNetwork.prototype, "paramMappings", {
        get: function() {
            return this._paramMappings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NeuralNetwork.prototype, "isLoaded", {
        get: function() {
            return !!this.params;
        },
        enumerable: true,
        configurable: true
    });
    NeuralNetwork.prototype.getParamFromPath = function(paramPath) {
        var _a = this.traversePropertyPath(paramPath), obj = _a.obj, objProp = _a.objProp;
        return obj[objProp];
    };
    NeuralNetwork.prototype.reassignParamFromPath = function(paramPath, tensor) {
        var _a = this.traversePropertyPath(paramPath), obj = _a.obj, objProp = _a.objProp;
        obj[objProp].dispose();
        obj[objProp] = tensor;
    };
    NeuralNetwork.prototype.getParamList = function() {
        var _this = this;
        return this._paramMappings.map(function(_a) {
            var paramPath = _a.paramPath;
            return {
                path: paramPath,
                tensor: _this.getParamFromPath(paramPath)
            };
        });
    };
    NeuralNetwork.prototype.getTrainableParams = function() {
        return this.getParamList().filter(function(param) {
            return param.tensor instanceof $hA0xX.Variable;
        });
    };
    NeuralNetwork.prototype.getFrozenParams = function() {
        return this.getParamList().filter(function(param) {
            return !(param.tensor instanceof $hA0xX.Variable);
        });
    };
    NeuralNetwork.prototype.variable = function() {
        var _this = this;
        this.getFrozenParams().forEach(function(_a) {
            var path = _a.path, tensor = _a.tensor;
            _this.reassignParamFromPath(path, tensor.variable());
        });
    };
    NeuralNetwork.prototype.freeze = function() {
        var _this = this;
        this.getTrainableParams().forEach(function(_a) {
            var path = _a.path, variable = _a.tensor;
            var tensor = $hA0xX.tensor(variable.dataSync());
            variable.dispose();
            _this.reassignParamFromPath(path, tensor);
        });
    };
    NeuralNetwork.prototype.dispose = function(throwOnRedispose) {
        if (throwOnRedispose === void 0) throwOnRedispose = true;
        this.getParamList().forEach(function(param) {
            if (throwOnRedispose && param.tensor.isDisposed) throw new Error("param tensor has already been disposed for path " + param.path);
            param.tensor.dispose();
        });
        this._params = undefined;
    };
    NeuralNetwork.prototype.serializeParams = function() {
        return new Float32Array(this.getParamList().map(function(_a) {
            var tensor = _a.tensor;
            return Array.from(tensor.dataSync());
        }).reduce(function(flat, arr) {
            return flat.concat(arr);
        }));
    };
    NeuralNetwork.prototype.load = function(weightsOrUrl) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (weightsOrUrl instanceof Float32Array) {
                            this.extractWeights(weightsOrUrl);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            this.loadFromUri(weightsOrUrl)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    NeuralNetwork.prototype.loadFromUri = function(uri) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var weightMap;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (uri && typeof uri !== "string") throw new Error(this._name + ".loadFromUri - expected model uri");
                        return [
                            4 /*yield*/ ,
                            (0, $ba750443bdb72c5e$export$d28d7aef3b4cc323)(uri, this.getDefaultModelName())
                        ];
                    case 1:
                        weightMap = _a.sent();
                        this.loadFromWeightMap(weightMap);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    NeuralNetwork.prototype.loadFromDisk = function(filePath) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var readFile, _a, manifestUri, modelBaseUri, fetchWeightsFromDisk, loadWeights, manifest, _b, _c, weightMap;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        if (filePath && typeof filePath !== "string") throw new Error(this._name + ".loadFromDisk - expected model file path");
                        readFile = (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).getEnv().readFile;
                        _a = (0, $0d32132744a737ad$export$a0d5a8fce32d1b45)(filePath, this.getDefaultModelName()), manifestUri = _a.manifestUri, modelBaseUri = _a.modelBaseUri;
                        fetchWeightsFromDisk = function(filePaths) {
                            return Promise.all(filePaths.map(function(filePath) {
                                return readFile(filePath).then(function(buf) {
                                    return buf.buffer;
                                });
                            }));
                        };
                        loadWeights = $hA0xX.io.weightsLoaderFactory(fetchWeightsFromDisk);
                        _c = (_b = JSON).parse;
                        return [
                            4 /*yield*/ ,
                            readFile(manifestUri)
                        ];
                    case 1:
                        manifest = _c.apply(_b, [
                            _d.sent().toString()
                        ]);
                        return [
                            4 /*yield*/ ,
                            loadWeights(manifest, modelBaseUri)
                        ];
                    case 2:
                        weightMap = _d.sent();
                        this.loadFromWeightMap(weightMap);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    NeuralNetwork.prototype.loadFromWeightMap = function(weightMap) {
        var _a = this.extractParamsFromWeigthMap(weightMap), paramMappings = _a.paramMappings, params = _a.params;
        this._paramMappings = paramMappings;
        this._params = params;
    };
    NeuralNetwork.prototype.extractWeights = function(weights) {
        var _a = this.extractParams(weights), paramMappings = _a.paramMappings, params = _a.params;
        this._paramMappings = paramMappings;
        this._params = params;
    };
    NeuralNetwork.prototype.traversePropertyPath = function(paramPath) {
        if (!this.params) throw new Error("traversePropertyPath - model has no loaded params");
        var result = paramPath.split("/").reduce(function(res, objProp) {
            if (!res.nextObj.hasOwnProperty(objProp)) throw new Error("traversePropertyPath - object does not have property " + objProp + ", for path " + paramPath);
            return {
                obj: res.nextObj,
                objProp: objProp,
                nextObj: res.nextObj[objProp]
            };
        }, {
            nextObj: this.params
        });
        var obj = result.obj, objProp = result.objProp;
        if (!obj || !objProp || !(obj[objProp] instanceof $hA0xX.Tensor)) throw new Error("traversePropertyPath - parameter is not a tensor, for path " + paramPath);
        return {
            obj: obj,
            objProp: objProp
        };
    };
    return NeuralNetwork;
}();




var $hA0xX = parcelRequire("hA0xX");

var $hA0xX = parcelRequire("hA0xX");
function $06cc5b41ba881be9$export$d65a03e5919e6e04(x, params, stride) {
    return $hA0xX.tidy(function() {
        var out = $hA0xX.separableConv2d(x, params.depthwise_filter, params.pointwise_filter, stride, "same");
        out = $hA0xX.add(out, params.bias);
        return out;
    });
}


function $576fdfe156555725$export$95413fd61909fa19(x, denseBlockParams, isFirstLayer) {
    if (isFirstLayer === void 0) isFirstLayer = false;
    return $hA0xX.tidy(function() {
        var out1 = $hA0xX.relu(isFirstLayer ? $hA0xX.add($hA0xX.conv2d(x, denseBlockParams.conv0.filters, [
            2,
            2
        ], "same"), denseBlockParams.conv0.bias) : (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)(x, denseBlockParams.conv0, [
            2,
            2
        ]));
        var out2 = (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)(out1, denseBlockParams.conv1, [
            1,
            1
        ]);
        var in3 = $hA0xX.relu($hA0xX.add(out1, out2));
        var out3 = (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)(in3, denseBlockParams.conv2, [
            1,
            1
        ]);
        return $hA0xX.relu($hA0xX.add(out1, $hA0xX.add(out2, out3)));
    });
}
function $576fdfe156555725$export$4a38125beda73202(x, denseBlockParams, isFirstLayer, isScaleDown) {
    if (isFirstLayer === void 0) isFirstLayer = false;
    if (isScaleDown === void 0) isScaleDown = true;
    return $hA0xX.tidy(function() {
        var out1 = $hA0xX.relu(isFirstLayer ? $hA0xX.add($hA0xX.conv2d(x, denseBlockParams.conv0.filters, isScaleDown ? [
            2,
            2
        ] : [
            1,
            1
        ], "same"), denseBlockParams.conv0.bias) : (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)(x, denseBlockParams.conv0, isScaleDown ? [
            2,
            2
        ] : [
            1,
            1
        ]));
        var out2 = (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)(out1, denseBlockParams.conv1, [
            1,
            1
        ]);
        var in3 = $hA0xX.relu($hA0xX.add(out1, out2));
        var out3 = (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)(in3, denseBlockParams.conv2, [
            1,
            1
        ]);
        var in4 = $hA0xX.relu($hA0xX.add(out1, $hA0xX.add(out2, out3)));
        var out4 = (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)(in4, denseBlockParams.conv3, [
            1,
            1
        ]);
        return $hA0xX.relu($hA0xX.add(out1, $hA0xX.add(out2, $hA0xX.add(out3, out4))));
    });
}



var $hA0xX = parcelRequire("hA0xX");
function $0fab8badd4fa75a5$export$edca6ac2edb44105(x, params, padding, withRelu) {
    if (padding === void 0) padding = "same";
    if (withRelu === void 0) withRelu = false;
    return $hA0xX.tidy(function() {
        var out = $hA0xX.add($hA0xX.conv2d(x, params.filters, [
            1,
            1
        ], padding), params.bias);
        return withRelu ? $hA0xX.relu(out) : out;
    });
}



function $8af358d5eb8121b0$export$8c2f782f98a64dcc(weightMap, paramMappings) {
    Object.keys(weightMap).forEach(function(path) {
        if (!paramMappings.some(function(pm) {
            return pm.originalPath === path;
        })) weightMap[path].dispose();
    });
}



var $hA0xX = parcelRequire("hA0xX");
function $bd086950888a8c1c$export$413a2f764691001c(extractWeights, paramMappings) {
    return function(channelsIn, channelsOut, filterSize, mappedPrefix) {
        var filters = $hA0xX.tensor4d(extractWeights(channelsIn * channelsOut * filterSize * filterSize), [
            filterSize,
            filterSize,
            channelsIn,
            channelsOut
        ]);
        var bias = $hA0xX.tensor1d(extractWeights(channelsOut));
        paramMappings.push({
            paramPath: mappedPrefix + "/filters"
        }, {
            paramPath: mappedPrefix + "/bias"
        });
        return {
            filters: filters,
            bias: bias
        };
    };
}



var $hA0xX = parcelRequire("hA0xX");
function $090eb72b4d1e0021$export$4072014b46fe651b(extractWeights, paramMappings) {
    return function(channelsIn, channelsOut, mappedPrefix) {
        var fc_weights = $hA0xX.tensor2d(extractWeights(channelsIn * channelsOut), [
            channelsIn,
            channelsOut
        ]);
        var fc_bias = $hA0xX.tensor1d(extractWeights(channelsOut));
        paramMappings.push({
            paramPath: mappedPrefix + "/weights"
        }, {
            paramPath: mappedPrefix + "/bias"
        });
        return {
            weights: fc_weights,
            bias: fc_bias
        };
    };
}



var $hA0xX = parcelRequire("hA0xX");
var $93b55f7b10adc9bb$export$ac1c7baec9125005 = /** @class */ function() {
    function SeparableConvParams(depthwise_filter, pointwise_filter, bias) {
        this.depthwise_filter = depthwise_filter;
        this.pointwise_filter = pointwise_filter;
        this.bias = bias;
    }
    return SeparableConvParams;
}();


function $d0388f3c6ce89a92$export$d4282d0b3a9e13c6(extractWeights, paramMappings) {
    return function(channelsIn, channelsOut, mappedPrefix) {
        var depthwise_filter = $hA0xX.tensor4d(extractWeights(9 * channelsIn), [
            3,
            3,
            channelsIn,
            1
        ]);
        var pointwise_filter = $hA0xX.tensor4d(extractWeights(channelsIn * channelsOut), [
            1,
            1,
            channelsIn,
            channelsOut
        ]);
        var bias = $hA0xX.tensor1d(extractWeights(channelsOut));
        paramMappings.push({
            paramPath: mappedPrefix + "/depthwise_filter"
        }, {
            paramPath: mappedPrefix + "/pointwise_filter"
        }, {
            paramPath: mappedPrefix + "/bias"
        });
        return new (0, $93b55f7b10adc9bb$export$ac1c7baec9125005)(depthwise_filter, pointwise_filter, bias);
    };
}
function $d0388f3c6ce89a92$export$e213f501b518bdd4(extractWeightEntry) {
    return function(prefix) {
        var depthwise_filter = extractWeightEntry(prefix + "/depthwise_filter", 4);
        var pointwise_filter = extractWeightEntry(prefix + "/pointwise_filter", 4);
        var bias = extractWeightEntry(prefix + "/bias", 1);
        return new (0, $93b55f7b10adc9bb$export$ac1c7baec9125005)(depthwise_filter, pointwise_filter, bias);
    };
}



function $0c460a5f8990e5eb$export$ef0fb3c0e9f7c333(weightMap, paramMappings) {
    return function(originalPath, paramRank, mappedPath) {
        var tensor = weightMap[originalPath];
        if (!(0, $4c1c2b1e5936cf08$export$74b139e729aaf0a9)(tensor, paramRank)) throw new Error("expected weightMap[" + originalPath + "] to be a Tensor" + paramRank + "D, instead have " + tensor);
        paramMappings.push({
            originalPath: originalPath,
            paramPath: mappedPath || originalPath
        });
        return tensor;
    };
}


function $d6b5f6264aa92ea2$export$4f1d9b03928e19e3(weights) {
    var remainingWeights = weights;
    function extractWeights(numWeights) {
        var ret = remainingWeights.slice(0, numWeights);
        remainingWeights = remainingWeights.slice(numWeights);
        return ret;
    }
    function getRemainingWeights() {
        return remainingWeights;
    }
    return {
        extractWeights: extractWeights,
        getRemainingWeights: getRemainingWeights
    };
}







function $d4fbc8ca00e7cdb2$export$536a8e24d81fcc6d(extractWeights, paramMappings) {
    var extractConvParams = (0, $bd086950888a8c1c$export$413a2f764691001c)(extractWeights, paramMappings);
    var extractSeparableConvParams = (0, $d0388f3c6ce89a92$export$d4282d0b3a9e13c6)(extractWeights, paramMappings);
    function extractDenseBlock3Params(channelsIn, channelsOut, mappedPrefix, isFirstLayer) {
        if (isFirstLayer === void 0) isFirstLayer = false;
        var conv0 = isFirstLayer ? extractConvParams(channelsIn, channelsOut, 3, mappedPrefix + "/conv0") : extractSeparableConvParams(channelsIn, channelsOut, mappedPrefix + "/conv0");
        var conv1 = extractSeparableConvParams(channelsOut, channelsOut, mappedPrefix + "/conv1");
        var conv2 = extractSeparableConvParams(channelsOut, channelsOut, mappedPrefix + "/conv2");
        return {
            conv0: conv0,
            conv1: conv1,
            conv2: conv2
        };
    }
    function extractDenseBlock4Params(channelsIn, channelsOut, mappedPrefix, isFirstLayer) {
        if (isFirstLayer === void 0) isFirstLayer = false;
        var _a = extractDenseBlock3Params(channelsIn, channelsOut, mappedPrefix, isFirstLayer), conv0 = _a.conv0, conv1 = _a.conv1, conv2 = _a.conv2;
        var conv3 = extractSeparableConvParams(channelsOut, channelsOut, mappedPrefix + "/conv3");
        return {
            conv0: conv0,
            conv1: conv1,
            conv2: conv2,
            conv3: conv3
        };
    }
    return {
        extractDenseBlock3Params: extractDenseBlock3Params,
        extractDenseBlock4Params: extractDenseBlock4Params
    };
}


function $01d03c8626008694$export$302ea4f536e3b4c5(weights) {
    var paramMappings = [];
    var _a = (0, $d6b5f6264aa92ea2$export$4f1d9b03928e19e3)(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
    var extractDenseBlock4Params = (0, $d4fbc8ca00e7cdb2$export$536a8e24d81fcc6d)(extractWeights, paramMappings).extractDenseBlock4Params;
    var dense0 = extractDenseBlock4Params(3, 32, "dense0", true);
    var dense1 = extractDenseBlock4Params(32, 64, "dense1");
    var dense2 = extractDenseBlock4Params(64, 128, "dense2");
    var dense3 = extractDenseBlock4Params(128, 256, "dense3");
    if (getRemainingWeights().length !== 0) throw new Error("weights remaing after extract: " + getRemainingWeights().length);
    return {
        paramMappings: paramMappings,
        params: {
            dense0: dense0,
            dense1: dense1,
            dense2: dense2,
            dense3: dense3
        }
    };
}




function $15b201e64b36be2f$export$4360f6e62c1ed97a(extractWeightEntry) {
    return function(prefix) {
        var filters = extractWeightEntry(prefix + "/filters", 4);
        var bias = extractWeightEntry(prefix + "/bias", 1);
        return {
            filters: filters,
            bias: bias
        };
    };
}


function $10ea615b3d8c797c$export$a546f601b7c90f(weightMap, paramMappings) {
    var extractWeightEntry = (0, $0c460a5f8990e5eb$export$ef0fb3c0e9f7c333)(weightMap, paramMappings);
    var extractConvParams = (0, $15b201e64b36be2f$export$4360f6e62c1ed97a)(extractWeightEntry);
    var extractSeparableConvParams = (0, $d0388f3c6ce89a92$export$e213f501b518bdd4)(extractWeightEntry);
    function extractDenseBlock3Params(prefix, isFirstLayer) {
        if (isFirstLayer === void 0) isFirstLayer = false;
        var conv0 = isFirstLayer ? extractConvParams(prefix + "/conv0") : extractSeparableConvParams(prefix + "/conv0");
        var conv1 = extractSeparableConvParams(prefix + "/conv1");
        var conv2 = extractSeparableConvParams(prefix + "/conv2");
        return {
            conv0: conv0,
            conv1: conv1,
            conv2: conv2
        };
    }
    function extractDenseBlock4Params(prefix, isFirstLayer) {
        if (isFirstLayer === void 0) isFirstLayer = false;
        var conv0 = isFirstLayer ? extractConvParams(prefix + "/conv0") : extractSeparableConvParams(prefix + "/conv0");
        var conv1 = extractSeparableConvParams(prefix + "/conv1");
        var conv2 = extractSeparableConvParams(prefix + "/conv2");
        var conv3 = extractSeparableConvParams(prefix + "/conv3");
        return {
            conv0: conv0,
            conv1: conv1,
            conv2: conv2,
            conv3: conv3
        };
    }
    return {
        extractDenseBlock3Params: extractDenseBlock3Params,
        extractDenseBlock4Params: extractDenseBlock4Params
    };
}


function $9f146c23be7bf23e$export$74edd096d8165fb0(weightMap) {
    var paramMappings = [];
    var extractDenseBlock4Params = (0, $10ea615b3d8c797c$export$a546f601b7c90f)(weightMap, paramMappings).extractDenseBlock4Params;
    var params = {
        dense0: extractDenseBlock4Params("dense0", true),
        dense1: extractDenseBlock4Params("dense1"),
        dense2: extractDenseBlock4Params("dense2"),
        dense3: extractDenseBlock4Params("dense3")
    };
    (0, $8af358d5eb8121b0$export$8c2f782f98a64dcc)(weightMap, paramMappings);
    return {
        params: params,
        paramMappings: paramMappings
    };
}


var $6a67157047be63b2$export$ba7d9bf58306a0e7 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceFeatureExtractor, _super);
    function FaceFeatureExtractor() {
        return _super.call(this, "FaceFeatureExtractor") || this;
    }
    FaceFeatureExtractor.prototype.forwardInput = function(input) {
        var params = this.params;
        if (!params) throw new Error("FaceFeatureExtractor - load model before inference");
        return $hA0xX.tidy(function() {
            var batchTensor = input.toBatchTensor(112, true);
            var meanRgb = [
                122.782,
                117.001,
                104.298
            ];
            var normalized = (0, $20edefd13a8a19f6$export$a3295358bff77e)(batchTensor, meanRgb).div($hA0xX.scalar(255));
            var out = (0, $576fdfe156555725$export$4a38125beda73202)(normalized, params.dense0, true);
            out = (0, $576fdfe156555725$export$4a38125beda73202)(out, params.dense1);
            out = (0, $576fdfe156555725$export$4a38125beda73202)(out, params.dense2);
            out = (0, $576fdfe156555725$export$4a38125beda73202)(out, params.dense3);
            out = $hA0xX.avgPool(out, [
                7,
                7
            ], [
                2,
                2
            ], "valid");
            return out;
        });
    };
    FaceFeatureExtractor.prototype.forward = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(this, [
                                _b.sent()
                            ])
                        ];
                }
            });
        });
    };
    FaceFeatureExtractor.prototype.getDefaultModelName = function() {
        return "face_feature_extractor_model";
    };
    FaceFeatureExtractor.prototype.extractParamsFromWeigthMap = function(weightMap) {
        return (0, $9f146c23be7bf23e$export$74edd096d8165fb0)(weightMap);
    };
    FaceFeatureExtractor.prototype.extractParams = function(weights) {
        return (0, $01d03c8626008694$export$302ea4f536e3b4c5)(weights);
    };
    return FaceFeatureExtractor;
}((0, $89ef56f11ec234e4$export$3a2d186bf4f565eb));




var $hA0xX = parcelRequire("hA0xX");

var $hA0xX = parcelRequire("hA0xX");
function $674b2a159e0f1f54$export$419f910a45631e59(x, params) {
    return $hA0xX.tidy(function() {
        return $hA0xX.add($hA0xX.matMul(x, params.weights), params.bias);
    });
}





function $8d1e30bdeb778f93$export$302ea4f536e3b4c5(weights, channelsIn, channelsOut) {
    var paramMappings = [];
    var _a = (0, $d6b5f6264aa92ea2$export$4f1d9b03928e19e3)(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
    var extractFCParams = (0, $090eb72b4d1e0021$export$4072014b46fe651b)(extractWeights, paramMappings);
    var fc = extractFCParams(channelsIn, channelsOut, "fc");
    if (getRemainingWeights().length !== 0) throw new Error("weights remaing after extract: " + getRemainingWeights().length);
    return {
        paramMappings: paramMappings,
        params: {
            fc: fc
        }
    };
}



function $914e668c7faf331e$export$74edd096d8165fb0(weightMap) {
    var paramMappings = [];
    var extractWeightEntry = (0, $0c460a5f8990e5eb$export$ef0fb3c0e9f7c333)(weightMap, paramMappings);
    function extractFcParams(prefix) {
        var weights = extractWeightEntry(prefix + "/weights", 2);
        var bias = extractWeightEntry(prefix + "/bias", 1);
        return {
            weights: weights,
            bias: bias
        };
    }
    var params = {
        fc: extractFcParams("fc")
    };
    (0, $8af358d5eb8121b0$export$8c2f782f98a64dcc)(weightMap, paramMappings);
    return {
        params: params,
        paramMappings: paramMappings
    };
}


function $b30a8f0fdeaa8466$export$22d070df96a64c23(weightMap) {
    var featureExtractorMap = {};
    var classifierMap = {};
    Object.keys(weightMap).forEach(function(key) {
        var map = key.startsWith("fc") ? classifierMap : featureExtractorMap;
        map[key] = weightMap[key];
    });
    return {
        featureExtractorMap: featureExtractorMap,
        classifierMap: classifierMap
    };
}


var $0074dfd4cfa30b8e$export$53ae7e118f75ddd = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceProcessor, _super);
    function FaceProcessor(_name, faceFeatureExtractor) {
        var _this = _super.call(this, _name) || this;
        _this._faceFeatureExtractor = faceFeatureExtractor;
        return _this;
    }
    Object.defineProperty(FaceProcessor.prototype, "faceFeatureExtractor", {
        get: function() {
            return this._faceFeatureExtractor;
        },
        enumerable: true,
        configurable: true
    });
    FaceProcessor.prototype.runNet = function(input) {
        var _this = this;
        var params = this.params;
        if (!params) throw new Error(this._name + " - load model before inference");
        return $hA0xX.tidy(function() {
            var bottleneckFeatures = input instanceof (0, $89ff8a044ed2569b$export$d4b5e83a462ad4ac) ? _this.faceFeatureExtractor.forwardInput(input) : input;
            return (0, $674b2a159e0f1f54$export$419f910a45631e59)(bottleneckFeatures.as2D(bottleneckFeatures.shape[0], -1), params.fc);
        });
    };
    FaceProcessor.prototype.dispose = function(throwOnRedispose) {
        if (throwOnRedispose === void 0) throwOnRedispose = true;
        this.faceFeatureExtractor.dispose(throwOnRedispose);
        _super.prototype.dispose.call(this, throwOnRedispose);
    };
    FaceProcessor.prototype.loadClassifierParams = function(weights) {
        var _a = this.extractClassifierParams(weights), params = _a.params, paramMappings = _a.paramMappings;
        this._params = params;
        this._paramMappings = paramMappings;
    };
    FaceProcessor.prototype.extractClassifierParams = function(weights) {
        return (0, $8d1e30bdeb778f93$export$302ea4f536e3b4c5)(weights, this.getClassifierChannelsIn(), this.getClassifierChannelsOut());
    };
    FaceProcessor.prototype.extractParamsFromWeigthMap = function(weightMap) {
        var _a = (0, $b30a8f0fdeaa8466$export$22d070df96a64c23)(weightMap), featureExtractorMap = _a.featureExtractorMap, classifierMap = _a.classifierMap;
        this.faceFeatureExtractor.loadFromWeightMap(featureExtractorMap);
        return (0, $914e668c7faf331e$export$74edd096d8165fb0)(classifierMap);
    };
    FaceProcessor.prototype.extractParams = function(weights) {
        var cIn = this.getClassifierChannelsIn();
        var cOut = this.getClassifierChannelsOut();
        var classifierWeightSize = cOut * cIn + cOut;
        var featureExtractorWeights = weights.slice(0, weights.length - classifierWeightSize);
        var classifierWeights = weights.slice(weights.length - classifierWeightSize);
        this.faceFeatureExtractor.extractWeights(featureExtractorWeights);
        return this.extractClassifierParams(classifierWeights);
    };
    return FaceProcessor;
}((0, $89ef56f11ec234e4$export$3a2d186bf4f565eb));


var $f4ce59b741ab49ee$export$c415d437e7667624 = [
    "neutral",
    "happy",
    "sad",
    "angry",
    "fearful",
    "disgusted",
    "surprised"
];
var $f4ce59b741ab49ee$export$2bde8de3f8031dc3 = /** @class */ function() {
    function FaceExpressions(probabilities) {
        var _this = this;
        if (probabilities.length !== 7) throw new Error("FaceExpressions.constructor - expected probabilities.length to be 7, have: " + probabilities.length);
        $f4ce59b741ab49ee$export$c415d437e7667624.forEach(function(expression, idx) {
            _this[expression] = probabilities[idx];
        });
    }
    FaceExpressions.prototype.asSortedArray = function() {
        var _this = this;
        return $f4ce59b741ab49ee$export$c415d437e7667624.map(function(expression) {
            return {
                expression: expression,
                probability: _this[expression]
            };
        }).sort(function(e0, e1) {
            return e1.probability - e0.probability;
        });
    };
    return FaceExpressions;
}();


var $013001d7b12bc645$export$2297623eaa429f6c = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceExpressionNet, _super);
    function FaceExpressionNet(faceFeatureExtractor) {
        if (faceFeatureExtractor === void 0) faceFeatureExtractor = new (0, $6a67157047be63b2$export$ba7d9bf58306a0e7)();
        return _super.call(this, "FaceExpressionNet", faceFeatureExtractor) || this;
    }
    FaceExpressionNet.prototype.forwardInput = function(input) {
        var _this = this;
        return $hA0xX.tidy(function() {
            return $hA0xX.softmax(_this.runNet(input));
        });
    };
    FaceExpressionNet.prototype.forward = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(this, [
                                _b.sent()
                            ])
                        ];
                }
            });
        });
    };
    FaceExpressionNet.prototype.predictExpressions = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var netInput, out, probabilitesByBatch, predictionsByBatch;
            var _this = this;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        netInput = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.forwardInput(netInput)
                        ];
                    case 2:
                        out = _a.sent();
                        return [
                            4 /*yield*/ ,
                            Promise.all($hA0xX.unstack(out).map(function(t) {
                                return (0, $c5ef6752615abb23$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                    var data;
                                    return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    t.data()
                                                ];
                                            case 1:
                                                data = _a.sent();
                                                t.dispose();
                                                return [
                                                    2 /*return*/ ,
                                                    data
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 3:
                        probabilitesByBatch = _a.sent();
                        out.dispose();
                        predictionsByBatch = probabilitesByBatch.map(function(probabilites) {
                            return new (0, $f4ce59b741ab49ee$export$2bde8de3f8031dc3)(probabilites);
                        });
                        return [
                            2 /*return*/ ,
                            netInput.isBatchInput ? predictionsByBatch : predictionsByBatch[0]
                        ];
                }
            });
        });
    };
    FaceExpressionNet.prototype.getDefaultModelName = function() {
        return "face_expression_model";
    };
    FaceExpressionNet.prototype.getClassifierChannelsIn = function() {
        return 256;
    };
    FaceExpressionNet.prototype.getClassifierChannelsOut = function() {
        return 7;
    };
    return FaceExpressionNet;
}((0, $0074dfd4cfa30b8e$export$53ae7e118f75ddd));







function $db9bc8639eca43c8$export$f717c01aa5efdce0(obj) {
    return obj["expressions"] instanceof (0, $f4ce59b741ab49ee$export$2bde8de3f8031dc3);
}
function $db9bc8639eca43c8$export$caba98c51e1a223f(sourceObj, expressions) {
    var extension = {
        expressions: expressions
    };
    return Object.assign({}, sourceObj, extension);
}




function $2b36124a2eef3aa6$export$39d02c8e3a804aca(canvasArg, faceExpressions, minConfidence, textFieldAnchor) {
    if (minConfidence === void 0) minConfidence = 0.1;
    var faceExpressionsArray = Array.isArray(faceExpressions) ? faceExpressions : [
        faceExpressions
    ];
    faceExpressionsArray.forEach(function(e) {
        var expr = e instanceof (0, $f4ce59b741ab49ee$export$2bde8de3f8031dc3) ? e : (0, $db9bc8639eca43c8$export$f717c01aa5efdce0)(e) ? e.expressions : undefined;
        if (!expr) throw new Error("drawFaceExpressions - expected faceExpressions to be FaceExpressions | WithFaceExpressions<{}> or array thereof");
        var sorted = expr.asSortedArray();
        var resultsToDisplay = sorted.filter(function(expr) {
            return expr.probability > minConfidence;
        });
        var anchor = (0, $0be2c959ccd6f649$export$2dad0453743890bf)(e) ? e.detection.box.bottomLeft : textFieldAnchor || new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(0, 0);
        var drawTextField = new (0, $fb218195190972cb$export$c176ca95f96aff69)(resultsToDisplay.map(function(expr) {
            return expr.expression + " (" + (0, $4c1c2b1e5936cf08$export$2077e0241d6afd3c)(expr.probability) + ")";
        }), anchor);
        drawTextField.draw(canvasArg);
    });
}









function $16a59fcb4d20ce1c$export$51efdc1ea20f6714(obj) {
    return (0, $0be2c959ccd6f649$export$2dad0453743890bf)(obj) && obj["landmarks"] instanceof (0, $cf4d8aca6a25dc8f$export$a2e672dd92b622a7) && obj["unshiftedLandmarks"] instanceof (0, $cf4d8aca6a25dc8f$export$a2e672dd92b622a7) && obj["alignedRect"] instanceof (0, $86da6cbb0a7a9620$export$dc77199a917e22c2);
}
function $16a59fcb4d20ce1c$export$d990eabccad4ce39(sourceObj, unshiftedLandmarks) {
    var shift = sourceObj.detection.box;
    var landmarks = unshiftedLandmarks.shiftBy(shift.x, shift.y);
    var rect = landmarks.align();
    var imageDims = sourceObj.detection.imageDims;
    var alignedRect = new (0, $86da6cbb0a7a9620$export$dc77199a917e22c2)(sourceObj.detection.score, rect.rescale(imageDims.reverse()), imageDims);
    var extension = {
        landmarks: landmarks,
        unshiftedLandmarks: unshiftedLandmarks,
        alignedRect: alignedRect
    };
    return Object.assign({}, sourceObj, extension);
}



var $b0fc7be78fa93bde$export$327d6ecfe3b9333f = /** @class */ function() {
    function DrawFaceLandmarksOptions(options) {
        if (options === void 0) options = {};
        var _a = options.drawLines, drawLines = _a === void 0 ? true : _a, _b = options.drawPoints, drawPoints = _b === void 0 ? true : _b, lineWidth = options.lineWidth, lineColor = options.lineColor, pointSize = options.pointSize, pointColor = options.pointColor;
        this.drawLines = drawLines;
        this.drawPoints = drawPoints;
        this.lineWidth = lineWidth || 1;
        this.pointSize = pointSize || 2;
        this.lineColor = lineColor || "rgba(0, 255, 255, 1)";
        this.pointColor = pointColor || "rgba(255, 0, 255, 1)";
    }
    return DrawFaceLandmarksOptions;
}();
var $b0fc7be78fa93bde$export$2d23385616377dcc = /** @class */ function() {
    function DrawFaceLandmarks(faceLandmarks, options) {
        if (options === void 0) options = {};
        this.faceLandmarks = faceLandmarks;
        this.options = new $b0fc7be78fa93bde$export$327d6ecfe3b9333f(options);
    }
    DrawFaceLandmarks.prototype.draw = function(canvasArg) {
        var ctx = (0, $c40df77cbcb9e781$export$40d273013da632b6)(canvasArg);
        var _a = this.options, drawLines = _a.drawLines, drawPoints = _a.drawPoints, lineWidth = _a.lineWidth, lineColor = _a.lineColor, pointSize = _a.pointSize, pointColor = _a.pointColor;
        if (drawLines && this.faceLandmarks instanceof (0, $6f5f9d48a04e19fd$export$5e5b3e6dd53574c5)) {
            ctx.strokeStyle = lineColor;
            ctx.lineWidth = lineWidth;
            (0, $23ece11cb8699afe$export$44a3d0c0dcd51c9c)(ctx, this.faceLandmarks.getJawOutline());
            (0, $23ece11cb8699afe$export$44a3d0c0dcd51c9c)(ctx, this.faceLandmarks.getLeftEyeBrow());
            (0, $23ece11cb8699afe$export$44a3d0c0dcd51c9c)(ctx, this.faceLandmarks.getRightEyeBrow());
            (0, $23ece11cb8699afe$export$44a3d0c0dcd51c9c)(ctx, this.faceLandmarks.getNose());
            (0, $23ece11cb8699afe$export$44a3d0c0dcd51c9c)(ctx, this.faceLandmarks.getLeftEye(), true);
            (0, $23ece11cb8699afe$export$44a3d0c0dcd51c9c)(ctx, this.faceLandmarks.getRightEye(), true);
            (0, $23ece11cb8699afe$export$44a3d0c0dcd51c9c)(ctx, this.faceLandmarks.getMouth(), true);
        }
        if (drawPoints) {
            ctx.strokeStyle = pointColor;
            ctx.fillStyle = pointColor;
            var drawPoint = function(pt) {
                ctx.beginPath();
                ctx.arc(pt.x, pt.y, pointSize, 0, 2 * Math.PI);
                ctx.fill();
            };
            this.faceLandmarks.positions.forEach(drawPoint);
        }
    };
    return DrawFaceLandmarks;
}();
function $b0fc7be78fa93bde$export$95856cb6e17fa888(canvasArg, faceLandmarks) {
    var faceLandmarksArray = Array.isArray(faceLandmarks) ? faceLandmarks : [
        faceLandmarks
    ];
    faceLandmarksArray.forEach(function(f) {
        var landmarks = f instanceof (0, $cf4d8aca6a25dc8f$export$a2e672dd92b622a7) ? f : (0, $16a59fcb4d20ce1c$export$51efdc1ea20f6714)(f) ? f.landmarks : undefined;
        if (!landmarks) throw new Error("drawFaceLandmarks - expected faceExpressions to be FaceLandmarks | WithFaceLandmarks<WithFaceDetection<{}>> or array thereof");
        new $b0fc7be78fa93bde$export$2d23385616377dcc(landmarks).draw(canvasArg);
    });
}








var $hA0xX = parcelRequire("hA0xX");




var $hA0xX = parcelRequire("hA0xX");







function $fad341c7087f4663$var$extractorsFactory(extractWeights, paramMappings) {
    var extractConvParams = (0, $bd086950888a8c1c$export$413a2f764691001c)(extractWeights, paramMappings);
    var extractSeparableConvParams = (0, $d0388f3c6ce89a92$export$d4282d0b3a9e13c6)(extractWeights, paramMappings);
    function extractReductionBlockParams(channelsIn, channelsOut, mappedPrefix) {
        var separable_conv0 = extractSeparableConvParams(channelsIn, channelsOut, mappedPrefix + "/separable_conv0");
        var separable_conv1 = extractSeparableConvParams(channelsOut, channelsOut, mappedPrefix + "/separable_conv1");
        var expansion_conv = extractConvParams(channelsIn, channelsOut, 1, mappedPrefix + "/expansion_conv");
        return {
            separable_conv0: separable_conv0,
            separable_conv1: separable_conv1,
            expansion_conv: expansion_conv
        };
    }
    function extractMainBlockParams(channels, mappedPrefix) {
        var separable_conv0 = extractSeparableConvParams(channels, channels, mappedPrefix + "/separable_conv0");
        var separable_conv1 = extractSeparableConvParams(channels, channels, mappedPrefix + "/separable_conv1");
        var separable_conv2 = extractSeparableConvParams(channels, channels, mappedPrefix + "/separable_conv2");
        return {
            separable_conv0: separable_conv0,
            separable_conv1: separable_conv1,
            separable_conv2: separable_conv2
        };
    }
    return {
        extractConvParams: extractConvParams,
        extractSeparableConvParams: extractSeparableConvParams,
        extractReductionBlockParams: extractReductionBlockParams,
        extractMainBlockParams: extractMainBlockParams
    };
}
function $fad341c7087f4663$export$302ea4f536e3b4c5(weights, numMainBlocks) {
    var paramMappings = [];
    var _a = (0, $d6b5f6264aa92ea2$export$4f1d9b03928e19e3)(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
    var _b = $fad341c7087f4663$var$extractorsFactory(extractWeights, paramMappings), extractConvParams = _b.extractConvParams, extractSeparableConvParams = _b.extractSeparableConvParams, extractReductionBlockParams = _b.extractReductionBlockParams, extractMainBlockParams = _b.extractMainBlockParams;
    var entry_flow_conv_in = extractConvParams(3, 32, 3, "entry_flow/conv_in");
    var entry_flow_reduction_block_0 = extractReductionBlockParams(32, 64, "entry_flow/reduction_block_0");
    var entry_flow_reduction_block_1 = extractReductionBlockParams(64, 128, "entry_flow/reduction_block_1");
    var entry_flow = {
        conv_in: entry_flow_conv_in,
        reduction_block_0: entry_flow_reduction_block_0,
        reduction_block_1: entry_flow_reduction_block_1
    };
    var middle_flow = {};
    (0, $4c1c2b1e5936cf08$export$d02631cccf789723)(numMainBlocks, 0, 1).forEach(function(idx) {
        middle_flow["main_block_" + idx] = extractMainBlockParams(128, "middle_flow/main_block_" + idx);
    });
    var exit_flow_reduction_block = extractReductionBlockParams(128, 256, "exit_flow/reduction_block");
    var exit_flow_separable_conv = extractSeparableConvParams(256, 512, "exit_flow/separable_conv");
    var exit_flow = {
        reduction_block: exit_flow_reduction_block,
        separable_conv: exit_flow_separable_conv
    };
    if (getRemainingWeights().length !== 0) throw new Error("weights remaing after extract: " + getRemainingWeights().length);
    return {
        paramMappings: paramMappings,
        params: {
            entry_flow: entry_flow,
            middle_flow: middle_flow,
            exit_flow: exit_flow
        }
    };
}





function $d9ff77797765d69e$var$loadParamsFactory(weightMap, paramMappings) {
    var extractWeightEntry = (0, $0c460a5f8990e5eb$export$ef0fb3c0e9f7c333)(weightMap, paramMappings);
    var extractConvParams = (0, $15b201e64b36be2f$export$4360f6e62c1ed97a)(extractWeightEntry);
    var extractSeparableConvParams = (0, $d0388f3c6ce89a92$export$e213f501b518bdd4)(extractWeightEntry);
    function extractReductionBlockParams(mappedPrefix) {
        var separable_conv0 = extractSeparableConvParams(mappedPrefix + "/separable_conv0");
        var separable_conv1 = extractSeparableConvParams(mappedPrefix + "/separable_conv1");
        var expansion_conv = extractConvParams(mappedPrefix + "/expansion_conv");
        return {
            separable_conv0: separable_conv0,
            separable_conv1: separable_conv1,
            expansion_conv: expansion_conv
        };
    }
    function extractMainBlockParams(mappedPrefix) {
        var separable_conv0 = extractSeparableConvParams(mappedPrefix + "/separable_conv0");
        var separable_conv1 = extractSeparableConvParams(mappedPrefix + "/separable_conv1");
        var separable_conv2 = extractSeparableConvParams(mappedPrefix + "/separable_conv2");
        return {
            separable_conv0: separable_conv0,
            separable_conv1: separable_conv1,
            separable_conv2: separable_conv2
        };
    }
    return {
        extractConvParams: extractConvParams,
        extractSeparableConvParams: extractSeparableConvParams,
        extractReductionBlockParams: extractReductionBlockParams,
        extractMainBlockParams: extractMainBlockParams
    };
}
function $d9ff77797765d69e$export$74edd096d8165fb0(weightMap, numMainBlocks) {
    var paramMappings = [];
    var _a = $d9ff77797765d69e$var$loadParamsFactory(weightMap, paramMappings), extractConvParams = _a.extractConvParams, extractSeparableConvParams = _a.extractSeparableConvParams, extractReductionBlockParams = _a.extractReductionBlockParams, extractMainBlockParams = _a.extractMainBlockParams;
    var entry_flow_conv_in = extractConvParams("entry_flow/conv_in");
    var entry_flow_reduction_block_0 = extractReductionBlockParams("entry_flow/reduction_block_0");
    var entry_flow_reduction_block_1 = extractReductionBlockParams("entry_flow/reduction_block_1");
    var entry_flow = {
        conv_in: entry_flow_conv_in,
        reduction_block_0: entry_flow_reduction_block_0,
        reduction_block_1: entry_flow_reduction_block_1
    };
    var middle_flow = {};
    (0, $4c1c2b1e5936cf08$export$d02631cccf789723)(numMainBlocks, 0, 1).forEach(function(idx) {
        middle_flow["main_block_" + idx] = extractMainBlockParams("middle_flow/main_block_" + idx);
    });
    var exit_flow_reduction_block = extractReductionBlockParams("exit_flow/reduction_block");
    var exit_flow_separable_conv = extractSeparableConvParams("exit_flow/separable_conv");
    var exit_flow = {
        reduction_block: exit_flow_reduction_block,
        separable_conv: exit_flow_separable_conv
    };
    (0, $8af358d5eb8121b0$export$8c2f782f98a64dcc)(weightMap, paramMappings);
    return {
        params: {
            entry_flow: entry_flow,
            middle_flow: middle_flow,
            exit_flow: exit_flow
        },
        paramMappings: paramMappings
    };
}


function $01b771c9cd70ff82$var$conv(x, params, stride) {
    return $hA0xX.add($hA0xX.conv2d(x, params.filters, stride, "same"), params.bias);
}
function $01b771c9cd70ff82$var$reductionBlock(x, params, isActivateInput) {
    if (isActivateInput === void 0) isActivateInput = true;
    var out = isActivateInput ? $hA0xX.relu(x) : x;
    out = (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)(out, params.separable_conv0, [
        1,
        1
    ]);
    out = (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)($hA0xX.relu(out), params.separable_conv1, [
        1,
        1
    ]);
    out = $hA0xX.maxPool(out, [
        3,
        3
    ], [
        2,
        2
    ], "same");
    out = $hA0xX.add(out, $01b771c9cd70ff82$var$conv(x, params.expansion_conv, [
        2,
        2
    ]));
    return out;
}
function $01b771c9cd70ff82$var$mainBlock(x, params) {
    var out = (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)($hA0xX.relu(x), params.separable_conv0, [
        1,
        1
    ]);
    out = (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)($hA0xX.relu(out), params.separable_conv1, [
        1,
        1
    ]);
    out = (0, $06cc5b41ba881be9$export$d65a03e5919e6e04)($hA0xX.relu(out), params.separable_conv2, [
        1,
        1
    ]);
    out = $hA0xX.add(out, x);
    return out;
}
var $01b771c9cd70ff82$export$7db35fd551bf578a = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(TinyXception, _super);
    function TinyXception(numMainBlocks) {
        var _this = _super.call(this, "TinyXception") || this;
        _this._numMainBlocks = numMainBlocks;
        return _this;
    }
    TinyXception.prototype.forwardInput = function(input) {
        var _this = this;
        var params = this.params;
        if (!params) throw new Error("TinyXception - load model before inference");
        return $hA0xX.tidy(function() {
            var batchTensor = input.toBatchTensor(112, true);
            var meanRgb = [
                122.782,
                117.001,
                104.298
            ];
            var normalized = (0, $20edefd13a8a19f6$export$a3295358bff77e)(batchTensor, meanRgb).div($hA0xX.scalar(256));
            var out = $hA0xX.relu($01b771c9cd70ff82$var$conv(normalized, params.entry_flow.conv_in, [
                2,
                2
            ]));
            out = $01b771c9cd70ff82$var$reductionBlock(out, params.entry_flow.reduction_block_0, false);
            out = $01b771c9cd70ff82$var$reductionBlock(out, params.entry_flow.reduction_block_1);
            (0, $4c1c2b1e5936cf08$export$d02631cccf789723)(_this._numMainBlocks, 0, 1).forEach(function(idx) {
                out = $01b771c9cd70ff82$var$mainBlock(out, params.middle_flow["main_block_" + idx]);
            });
            out = $01b771c9cd70ff82$var$reductionBlock(out, params.exit_flow.reduction_block);
            out = $hA0xX.relu((0, $06cc5b41ba881be9$export$d65a03e5919e6e04)(out, params.exit_flow.separable_conv, [
                1,
                1
            ]));
            return out;
        });
    };
    TinyXception.prototype.forward = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(this, [
                                _b.sent()
                            ])
                        ];
                }
            });
        });
    };
    TinyXception.prototype.getDefaultModelName = function() {
        return "tiny_xception_model";
    };
    TinyXception.prototype.extractParamsFromWeigthMap = function(weightMap) {
        return (0, $d9ff77797765d69e$export$74edd096d8165fb0)(weightMap, this._numMainBlocks);
    };
    TinyXception.prototype.extractParams = function(weights) {
        return (0, $fad341c7087f4663$export$302ea4f536e3b4c5)(weights, this._numMainBlocks);
    };
    return TinyXception;
}((0, $89ef56f11ec234e4$export$3a2d186bf4f565eb));



function $906065c2a3a9b9c4$export$302ea4f536e3b4c5(weights) {
    var paramMappings = [];
    var _a = (0, $d6b5f6264aa92ea2$export$4f1d9b03928e19e3)(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
    var extractFCParams = (0, $090eb72b4d1e0021$export$4072014b46fe651b)(extractWeights, paramMappings);
    var age = extractFCParams(512, 1, "fc/age");
    var gender = extractFCParams(512, 2, "fc/gender");
    if (getRemainingWeights().length !== 0) throw new Error("weights remaing after extract: " + getRemainingWeights().length);
    return {
        paramMappings: paramMappings,
        params: {
            fc: {
                age: age,
                gender: gender
            }
        }
    };
}



function $a3a38f1cb04f5a88$export$74edd096d8165fb0(weightMap) {
    var paramMappings = [];
    var extractWeightEntry = (0, $0c460a5f8990e5eb$export$ef0fb3c0e9f7c333)(weightMap, paramMappings);
    function extractFcParams(prefix) {
        var weights = extractWeightEntry(prefix + "/weights", 2);
        var bias = extractWeightEntry(prefix + "/bias", 1);
        return {
            weights: weights,
            bias: bias
        };
    }
    var params = {
        fc: {
            age: extractFcParams("fc/age"),
            gender: extractFcParams("fc/gender")
        }
    };
    (0, $8af358d5eb8121b0$export$8c2f782f98a64dcc)(weightMap, paramMappings);
    return {
        params: params,
        paramMappings: paramMappings
    };
}


var $39a4d4e3795b22e3$export$d549c77c8a078892;
(function(Gender) {
    Gender["FEMALE"] = "female";
    Gender["MALE"] = "male";
})($39a4d4e3795b22e3$export$d549c77c8a078892 || ($39a4d4e3795b22e3$export$d549c77c8a078892 = {}));




var $beab387d78d67b7c$export$550cd3f15456e936 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(AgeGenderNet, _super);
    function AgeGenderNet(faceFeatureExtractor) {
        if (faceFeatureExtractor === void 0) faceFeatureExtractor = new (0, $01b771c9cd70ff82$export$7db35fd551bf578a)(2);
        var _this = _super.call(this, "AgeGenderNet") || this;
        _this._faceFeatureExtractor = faceFeatureExtractor;
        return _this;
    }
    Object.defineProperty(AgeGenderNet.prototype, "faceFeatureExtractor", {
        get: function() {
            return this._faceFeatureExtractor;
        },
        enumerable: true,
        configurable: true
    });
    AgeGenderNet.prototype.runNet = function(input) {
        var _this = this;
        var params = this.params;
        if (!params) throw new Error(this._name + " - load model before inference");
        return $hA0xX.tidy(function() {
            var bottleneckFeatures = input instanceof (0, $89ff8a044ed2569b$export$d4b5e83a462ad4ac) ? _this.faceFeatureExtractor.forwardInput(input) : input;
            var pooled = $hA0xX.avgPool(bottleneckFeatures, [
                7,
                7
            ], [
                2,
                2
            ], "valid").as2D(bottleneckFeatures.shape[0], -1);
            var age = (0, $674b2a159e0f1f54$export$419f910a45631e59)(pooled, params.fc.age).as1D();
            var gender = (0, $674b2a159e0f1f54$export$419f910a45631e59)(pooled, params.fc.gender);
            return {
                age: age,
                gender: gender
            };
        });
    };
    AgeGenderNet.prototype.forwardInput = function(input) {
        var _this = this;
        return $hA0xX.tidy(function() {
            var _a = _this.runNet(input), age = _a.age, gender = _a.gender;
            return {
                age: age,
                gender: $hA0xX.softmax(gender)
            };
        });
    };
    AgeGenderNet.prototype.forward = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(this, [
                                _b.sent()
                            ])
                        ];
                }
            });
        });
    };
    AgeGenderNet.prototype.predictAgeAndGender = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var netInput, out, ages, genders, ageAndGenderTensors, predictionsByBatch;
            var _this = this;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        netInput = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.forwardInput(netInput)
                        ];
                    case 2:
                        out = _a.sent();
                        ages = $hA0xX.unstack(out.age);
                        genders = $hA0xX.unstack(out.gender);
                        ageAndGenderTensors = ages.map(function(ageTensor, i) {
                            return {
                                ageTensor: ageTensor,
                                genderTensor: genders[i]
                            };
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(ageAndGenderTensors.map(function(_a) {
                                var ageTensor = _a.ageTensor, genderTensor = _a.genderTensor;
                                return (0, $c5ef6752615abb23$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                    var age, probMale, isMale, gender, genderProbability;
                                    return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    ageTensor.data()
                                                ];
                                            case 1:
                                                age = _b.sent()[0];
                                                return [
                                                    4 /*yield*/ ,
                                                    genderTensor.data()
                                                ];
                                            case 2:
                                                probMale = _b.sent()[0];
                                                isMale = probMale > 0.5;
                                                gender = isMale ? (0, $39a4d4e3795b22e3$export$d549c77c8a078892).MALE : (0, $39a4d4e3795b22e3$export$d549c77c8a078892).FEMALE;
                                                genderProbability = isMale ? probMale : 1 - probMale;
                                                ageTensor.dispose();
                                                genderTensor.dispose();
                                                return [
                                                    2 /*return*/ ,
                                                    {
                                                        age: age,
                                                        gender: gender,
                                                        genderProbability: genderProbability
                                                    }
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 3:
                        predictionsByBatch = _a.sent();
                        out.age.dispose();
                        out.gender.dispose();
                        return [
                            2 /*return*/ ,
                            netInput.isBatchInput ? predictionsByBatch : predictionsByBatch[0]
                        ];
                }
            });
        });
    };
    AgeGenderNet.prototype.getDefaultModelName = function() {
        return "age_gender_model";
    };
    AgeGenderNet.prototype.dispose = function(throwOnRedispose) {
        if (throwOnRedispose === void 0) throwOnRedispose = true;
        this.faceFeatureExtractor.dispose(throwOnRedispose);
        _super.prototype.dispose.call(this, throwOnRedispose);
    };
    AgeGenderNet.prototype.loadClassifierParams = function(weights) {
        var _a = this.extractClassifierParams(weights), params = _a.params, paramMappings = _a.paramMappings;
        this._params = params;
        this._paramMappings = paramMappings;
    };
    AgeGenderNet.prototype.extractClassifierParams = function(weights) {
        return (0, $906065c2a3a9b9c4$export$302ea4f536e3b4c5)(weights);
    };
    AgeGenderNet.prototype.extractParamsFromWeigthMap = function(weightMap) {
        var _a = (0, $b30a8f0fdeaa8466$export$22d070df96a64c23)(weightMap), featureExtractorMap = _a.featureExtractorMap, classifierMap = _a.classifierMap;
        this.faceFeatureExtractor.loadFromWeightMap(featureExtractorMap);
        return (0, $a3a38f1cb04f5a88$export$74edd096d8165fb0)(classifierMap);
    };
    AgeGenderNet.prototype.extractParams = function(weights) {
        var classifierWeightSize = 1539;
        var featureExtractorWeights = weights.slice(0, weights.length - classifierWeightSize);
        var classifierWeights = weights.slice(weights.length - classifierWeightSize);
        this.faceFeatureExtractor.extractWeights(featureExtractorWeights);
        return this.extractClassifierParams(classifierWeights);
    };
    return AgeGenderNet;
}((0, $89ef56f11ec234e4$export$3a2d186bf4f565eb));














var $hA0xX = parcelRequire("hA0xX");





var $8f6c8007830a522d$export$230578e141477107 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceLandmark68NetBase, _super);
    function FaceLandmark68NetBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FaceLandmark68NetBase.prototype.postProcess = function(output, inputSize, originalDimensions) {
        var inputDimensions = originalDimensions.map(function(_a) {
            var width = _a.width, height = _a.height;
            var scale = inputSize / Math.max(height, width);
            return {
                width: width * scale,
                height: height * scale
            };
        });
        var batchSize = inputDimensions.length;
        return $hA0xX.tidy(function() {
            var createInterleavedTensor = function(fillX, fillY) {
                return $hA0xX.stack([
                    $hA0xX.fill([
                        68
                    ], fillX),
                    $hA0xX.fill([
                        68
                    ], fillY)
                ], 1).as2D(1, 136).as1D();
            };
            var getPadding = function(batchIdx, cond) {
                var _a = inputDimensions[batchIdx], width = _a.width, height = _a.height;
                return cond(width, height) ? Math.abs(width - height) / 2 : 0;
            };
            var getPaddingX = function(batchIdx) {
                return getPadding(batchIdx, function(w, h) {
                    return w < h;
                });
            };
            var getPaddingY = function(batchIdx) {
                return getPadding(batchIdx, function(w, h) {
                    return h < w;
                });
            };
            var landmarkTensors = output.mul($hA0xX.fill([
                batchSize,
                136
            ], inputSize)).sub($hA0xX.stack(Array.from(Array(batchSize), function(_, batchIdx) {
                return createInterleavedTensor(getPaddingX(batchIdx), getPaddingY(batchIdx));
            }))).div($hA0xX.stack(Array.from(Array(batchSize), function(_, batchIdx) {
                return createInterleavedTensor(inputDimensions[batchIdx].width, inputDimensions[batchIdx].height);
            })));
            return landmarkTensors;
        });
    };
    FaceLandmark68NetBase.prototype.forwardInput = function(input) {
        var _this = this;
        return $hA0xX.tidy(function() {
            var out = _this.runNet(input);
            return _this.postProcess(out, input.inputSize, input.inputDimensions.map(function(_a) {
                var height = _a[0], width = _a[1];
                return {
                    height: height,
                    width: width
                };
            }));
        });
    };
    FaceLandmark68NetBase.prototype.forward = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(this, [
                                _b.sent()
                            ])
                        ];
                }
            });
        });
    };
    FaceLandmark68NetBase.prototype.detectLandmarks = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var netInput, landmarkTensors, landmarksForBatch;
            var _this = this;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        netInput = _a.sent();
                        landmarkTensors = $hA0xX.tidy(function() {
                            return $hA0xX.unstack(_this.forwardInput(netInput));
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(landmarkTensors.map(function(landmarkTensor, batchIdx) {
                                return (0, $c5ef6752615abb23$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                    var landmarksArray, _a, _b, xCoords, yCoords;
                                    return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_c) {
                                        switch(_c.label){
                                            case 0:
                                                _b = (_a = Array).from;
                                                return [
                                                    4 /*yield*/ ,
                                                    landmarkTensor.data()
                                                ];
                                            case 1:
                                                landmarksArray = _b.apply(_a, [
                                                    _c.sent()
                                                ]);
                                                xCoords = landmarksArray.filter(function(_, i) {
                                                    return (0, $4c1c2b1e5936cf08$export$ce16302d1253e25)(i);
                                                });
                                                yCoords = landmarksArray.filter(function(_, i) {
                                                    return !(0, $4c1c2b1e5936cf08$export$ce16302d1253e25)(i);
                                                });
                                                return [
                                                    2 /*return*/ ,
                                                    new (0, $6f5f9d48a04e19fd$export$5e5b3e6dd53574c5)(Array(68).fill(0).map(function(_, i) {
                                                        return new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(xCoords[i], yCoords[i]);
                                                    }), {
                                                        height: netInput.getInputHeight(batchIdx),
                                                        width: netInput.getInputWidth(batchIdx)
                                                    })
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 2:
                        landmarksForBatch = _a.sent();
                        landmarkTensors.forEach(function(t) {
                            return t.dispose();
                        });
                        return [
                            2 /*return*/ ,
                            netInput.isBatchInput ? landmarksForBatch : landmarksForBatch[0]
                        ];
                }
            });
        });
    };
    FaceLandmark68NetBase.prototype.getClassifierChannelsOut = function() {
        return 136;
    };
    return FaceLandmark68NetBase;
}((0, $0074dfd4cfa30b8e$export$53ae7e118f75ddd));


var $b33c07f9976e510c$export$71e7113cb684e3f3 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceLandmark68Net, _super);
    function FaceLandmark68Net(faceFeatureExtractor) {
        if (faceFeatureExtractor === void 0) faceFeatureExtractor = new (0, $6a67157047be63b2$export$ba7d9bf58306a0e7)();
        return _super.call(this, "FaceLandmark68Net", faceFeatureExtractor) || this;
    }
    FaceLandmark68Net.prototype.getDefaultModelName = function() {
        return "face_landmark_68_model";
    };
    FaceLandmark68Net.prototype.getClassifierChannelsIn = function() {
        return 256;
    };
    return FaceLandmark68Net;
}((0, $8f6c8007830a522d$export$230578e141477107));





var $hA0xX = parcelRequire("hA0xX");






function $8e6205215e6b8ff4$export$746bf51dbaf42b89(weightMap) {
    var paramMappings = [];
    var extractDenseBlock3Params = (0, $10ea615b3d8c797c$export$a546f601b7c90f)(weightMap, paramMappings).extractDenseBlock3Params;
    var params = {
        dense0: extractDenseBlock3Params("dense0", true),
        dense1: extractDenseBlock3Params("dense1"),
        dense2: extractDenseBlock3Params("dense2")
    };
    (0, $8af358d5eb8121b0$export$8c2f782f98a64dcc)(weightMap, paramMappings);
    return {
        params: params,
        paramMappings: paramMappings
    };
}




function $f772b8054bfc4ab5$export$d317e43a5e48b68f(weights) {
    var paramMappings = [];
    var _a = (0, $d6b5f6264aa92ea2$export$4f1d9b03928e19e3)(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
    var extractDenseBlock3Params = (0, $d4fbc8ca00e7cdb2$export$536a8e24d81fcc6d)(extractWeights, paramMappings).extractDenseBlock3Params;
    var dense0 = extractDenseBlock3Params(3, 32, "dense0", true);
    var dense1 = extractDenseBlock3Params(32, 64, "dense1");
    var dense2 = extractDenseBlock3Params(64, 128, "dense2");
    if (getRemainingWeights().length !== 0) throw new Error("weights remaing after extract: " + getRemainingWeights().length);
    return {
        paramMappings: paramMappings,
        params: {
            dense0: dense0,
            dense1: dense1,
            dense2: dense2
        }
    };
}


var $7b43d8642f85b83e$export$37db602492a092ba = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(TinyFaceFeatureExtractor, _super);
    function TinyFaceFeatureExtractor() {
        return _super.call(this, "TinyFaceFeatureExtractor") || this;
    }
    TinyFaceFeatureExtractor.prototype.forwardInput = function(input) {
        var params = this.params;
        if (!params) throw new Error("TinyFaceFeatureExtractor - load model before inference");
        return $hA0xX.tidy(function() {
            var batchTensor = input.toBatchTensor(112, true);
            var meanRgb = [
                122.782,
                117.001,
                104.298
            ];
            var normalized = (0, $20edefd13a8a19f6$export$a3295358bff77e)(batchTensor, meanRgb).div($hA0xX.scalar(255));
            var out = (0, $576fdfe156555725$export$95413fd61909fa19)(normalized, params.dense0, true);
            out = (0, $576fdfe156555725$export$95413fd61909fa19)(out, params.dense1);
            out = (0, $576fdfe156555725$export$95413fd61909fa19)(out, params.dense2);
            out = $hA0xX.avgPool(out, [
                14,
                14
            ], [
                2,
                2
            ], "valid");
            return out;
        });
    };
    TinyFaceFeatureExtractor.prototype.forward = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(this, [
                                _b.sent()
                            ])
                        ];
                }
            });
        });
    };
    TinyFaceFeatureExtractor.prototype.getDefaultModelName = function() {
        return "face_feature_extractor_tiny_model";
    };
    TinyFaceFeatureExtractor.prototype.extractParamsFromWeigthMap = function(weightMap) {
        return (0, $8e6205215e6b8ff4$export$746bf51dbaf42b89)(weightMap);
    };
    TinyFaceFeatureExtractor.prototype.extractParams = function(weights) {
        return (0, $f772b8054bfc4ab5$export$d317e43a5e48b68f)(weights);
    };
    return TinyFaceFeatureExtractor;
}((0, $89ef56f11ec234e4$export$3a2d186bf4f565eb));



var $30951a47eb228716$export$bce9de1e20c3c0e6 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceLandmark68TinyNet, _super);
    function FaceLandmark68TinyNet(faceFeatureExtractor) {
        if (faceFeatureExtractor === void 0) faceFeatureExtractor = new (0, $7b43d8642f85b83e$export$37db602492a092ba)();
        return _super.call(this, "FaceLandmark68TinyNet", faceFeatureExtractor) || this;
    }
    FaceLandmark68TinyNet.prototype.getDefaultModelName = function() {
        return "face_landmark_68_tiny_model";
    };
    FaceLandmark68TinyNet.prototype.getClassifierChannelsIn = function() {
        return 128;
    };
    return FaceLandmark68TinyNet;
}((0, $8f6c8007830a522d$export$230578e141477107));


var $e708e4e90931ea41$export$e4ce6d8a10ac31dd = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceLandmarkNet, _super);
    function FaceLandmarkNet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FaceLandmarkNet;
}((0, $b33c07f9976e510c$export$71e7113cb684e3f3));




var $hA0xX = parcelRequire("hA0xX");




var $hA0xX = parcelRequire("hA0xX");

var $hA0xX = parcelRequire("hA0xX");
function $170259fc0d82c94e$export$dcdf75081b88279d(x, params) {
    return $hA0xX.add($hA0xX.mul(x, params.weights), params.biases);
}


function $7eb4943278b38978$var$convLayer(x, params, strides, withRelu, padding) {
    if (padding === void 0) padding = "same";
    var _a = params.conv, filters = _a.filters, bias = _a.bias;
    var out = $hA0xX.conv2d(x, filters, strides, padding);
    out = $hA0xX.add(out, bias);
    out = (0, $170259fc0d82c94e$export$dcdf75081b88279d)(out, params.scale);
    return withRelu ? $hA0xX.relu(out) : out;
}
function $7eb4943278b38978$export$a378a23c505b471d(x, params) {
    return $7eb4943278b38978$var$convLayer(x, params, [
        1,
        1
    ], true);
}
function $7eb4943278b38978$export$72c7a0c1bfa20354(x, params) {
    return $7eb4943278b38978$var$convLayer(x, params, [
        1,
        1
    ], false);
}
function $7eb4943278b38978$export$9483fa7d893ae5b1(x, params) {
    return $7eb4943278b38978$var$convLayer(x, params, [
        2,
        2
    ], true, "valid");
}



var $hA0xX = parcelRequire("hA0xX");


function $c2b1d6a0bfe4f92c$var$extractorsFactory(extractWeights, paramMappings) {
    function extractFilterValues(numFilterValues, numFilters, filterSize) {
        var weights = extractWeights(numFilterValues);
        var depth = weights.length / (numFilters * filterSize * filterSize);
        if ((0, $4c1c2b1e5936cf08$export$4ba1d6600e2a2892)(depth)) throw new Error("depth has to be an integer: " + depth + ", weights.length: " + weights.length + ", numFilters: " + numFilters + ", filterSize: " + filterSize);
        return $hA0xX.tidy(function() {
            return $hA0xX.transpose($hA0xX.tensor4d(weights, [
                numFilters,
                depth,
                filterSize,
                filterSize
            ]), [
                2,
                3,
                1,
                0
            ]);
        });
    }
    function extractConvParams(numFilterValues, numFilters, filterSize, mappedPrefix) {
        var filters = extractFilterValues(numFilterValues, numFilters, filterSize);
        var bias = $hA0xX.tensor1d(extractWeights(numFilters));
        paramMappings.push({
            paramPath: mappedPrefix + "/filters"
        }, {
            paramPath: mappedPrefix + "/bias"
        });
        return {
            filters: filters,
            bias: bias
        };
    }
    function extractScaleLayerParams(numWeights, mappedPrefix) {
        var weights = $hA0xX.tensor1d(extractWeights(numWeights));
        var biases = $hA0xX.tensor1d(extractWeights(numWeights));
        paramMappings.push({
            paramPath: mappedPrefix + "/weights"
        }, {
            paramPath: mappedPrefix + "/biases"
        });
        return {
            weights: weights,
            biases: biases
        };
    }
    function extractConvLayerParams(numFilterValues, numFilters, filterSize, mappedPrefix) {
        var conv = extractConvParams(numFilterValues, numFilters, filterSize, mappedPrefix + "/conv");
        var scale = extractScaleLayerParams(numFilters, mappedPrefix + "/scale");
        return {
            conv: conv,
            scale: scale
        };
    }
    function extractResidualLayerParams(numFilterValues, numFilters, filterSize, mappedPrefix, isDown) {
        if (isDown === void 0) isDown = false;
        var conv1 = extractConvLayerParams((isDown ? 0.5 : 1) * numFilterValues, numFilters, filterSize, mappedPrefix + "/conv1");
        var conv2 = extractConvLayerParams(numFilterValues, numFilters, filterSize, mappedPrefix + "/conv2");
        return {
            conv1: conv1,
            conv2: conv2
        };
    }
    return {
        extractConvLayerParams: extractConvLayerParams,
        extractResidualLayerParams: extractResidualLayerParams
    };
}
function $c2b1d6a0bfe4f92c$export$302ea4f536e3b4c5(weights) {
    var _a = (0, $d6b5f6264aa92ea2$export$4f1d9b03928e19e3)(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
    var paramMappings = [];
    var _b = $c2b1d6a0bfe4f92c$var$extractorsFactory(extractWeights, paramMappings), extractConvLayerParams = _b.extractConvLayerParams, extractResidualLayerParams = _b.extractResidualLayerParams;
    var conv32_down = extractConvLayerParams(4704, 32, 7, "conv32_down");
    var conv32_1 = extractResidualLayerParams(9216, 32, 3, "conv32_1");
    var conv32_2 = extractResidualLayerParams(9216, 32, 3, "conv32_2");
    var conv32_3 = extractResidualLayerParams(9216, 32, 3, "conv32_3");
    var conv64_down = extractResidualLayerParams(36864, 64, 3, "conv64_down", true);
    var conv64_1 = extractResidualLayerParams(36864, 64, 3, "conv64_1");
    var conv64_2 = extractResidualLayerParams(36864, 64, 3, "conv64_2");
    var conv64_3 = extractResidualLayerParams(36864, 64, 3, "conv64_3");
    var conv128_down = extractResidualLayerParams(147456, 128, 3, "conv128_down", true);
    var conv128_1 = extractResidualLayerParams(147456, 128, 3, "conv128_1");
    var conv128_2 = extractResidualLayerParams(147456, 128, 3, "conv128_2");
    var conv256_down = extractResidualLayerParams(589824, 256, 3, "conv256_down", true);
    var conv256_1 = extractResidualLayerParams(589824, 256, 3, "conv256_1");
    var conv256_2 = extractResidualLayerParams(589824, 256, 3, "conv256_2");
    var conv256_down_out = extractResidualLayerParams(589824, 256, 3, "conv256_down_out");
    var fc = $hA0xX.tidy(function() {
        return $hA0xX.transpose($hA0xX.tensor2d(extractWeights(32768), [
            128,
            256
        ]), [
            1,
            0
        ]);
    });
    paramMappings.push({
        paramPath: "fc"
    });
    if (getRemainingWeights().length !== 0) throw new Error("weights remaing after extract: " + getRemainingWeights().length);
    var params = {
        conv32_down: conv32_down,
        conv32_1: conv32_1,
        conv32_2: conv32_2,
        conv32_3: conv32_3,
        conv64_down: conv64_down,
        conv64_1: conv64_1,
        conv64_2: conv64_2,
        conv64_3: conv64_3,
        conv128_down: conv128_down,
        conv128_1: conv128_1,
        conv128_2: conv128_2,
        conv256_down: conv256_down,
        conv256_1: conv256_1,
        conv256_2: conv256_2,
        conv256_down_out: conv256_down_out,
        fc: fc
    };
    return {
        params: params,
        paramMappings: paramMappings
    };
}




function $72315103ccb05b6d$var$extractorsFactory(weightMap, paramMappings) {
    var extractWeightEntry = (0, $0c460a5f8990e5eb$export$ef0fb3c0e9f7c333)(weightMap, paramMappings);
    function extractScaleLayerParams(prefix) {
        var weights = extractWeightEntry(prefix + "/scale/weights", 1);
        var biases = extractWeightEntry(prefix + "/scale/biases", 1);
        return {
            weights: weights,
            biases: biases
        };
    }
    function extractConvLayerParams(prefix) {
        var filters = extractWeightEntry(prefix + "/conv/filters", 4);
        var bias = extractWeightEntry(prefix + "/conv/bias", 1);
        var scale = extractScaleLayerParams(prefix);
        return {
            conv: {
                filters: filters,
                bias: bias
            },
            scale: scale
        };
    }
    function extractResidualLayerParams(prefix) {
        return {
            conv1: extractConvLayerParams(prefix + "/conv1"),
            conv2: extractConvLayerParams(prefix + "/conv2")
        };
    }
    return {
        extractConvLayerParams: extractConvLayerParams,
        extractResidualLayerParams: extractResidualLayerParams
    };
}
function $72315103ccb05b6d$export$74edd096d8165fb0(weightMap) {
    var paramMappings = [];
    var _a = $72315103ccb05b6d$var$extractorsFactory(weightMap, paramMappings), extractConvLayerParams = _a.extractConvLayerParams, extractResidualLayerParams = _a.extractResidualLayerParams;
    var conv32_down = extractConvLayerParams("conv32_down");
    var conv32_1 = extractResidualLayerParams("conv32_1");
    var conv32_2 = extractResidualLayerParams("conv32_2");
    var conv32_3 = extractResidualLayerParams("conv32_3");
    var conv64_down = extractResidualLayerParams("conv64_down");
    var conv64_1 = extractResidualLayerParams("conv64_1");
    var conv64_2 = extractResidualLayerParams("conv64_2");
    var conv64_3 = extractResidualLayerParams("conv64_3");
    var conv128_down = extractResidualLayerParams("conv128_down");
    var conv128_1 = extractResidualLayerParams("conv128_1");
    var conv128_2 = extractResidualLayerParams("conv128_2");
    var conv256_down = extractResidualLayerParams("conv256_down");
    var conv256_1 = extractResidualLayerParams("conv256_1");
    var conv256_2 = extractResidualLayerParams("conv256_2");
    var conv256_down_out = extractResidualLayerParams("conv256_down_out");
    var fc = weightMap["fc"];
    paramMappings.push({
        originalPath: "fc",
        paramPath: "fc"
    });
    if (!(0, $4c1c2b1e5936cf08$export$526eeee0f4260e87)(fc)) throw new Error("expected weightMap[fc] to be a Tensor2D, instead have " + fc);
    var params = {
        conv32_down: conv32_down,
        conv32_1: conv32_1,
        conv32_2: conv32_2,
        conv32_3: conv32_3,
        conv64_down: conv64_down,
        conv64_1: conv64_1,
        conv64_2: conv64_2,
        conv64_3: conv64_3,
        conv128_down: conv128_down,
        conv128_1: conv128_1,
        conv128_2: conv128_2,
        conv256_down: conv256_down,
        conv256_1: conv256_1,
        conv256_2: conv256_2,
        conv256_down_out: conv256_down_out,
        fc: fc
    };
    (0, $8af358d5eb8121b0$export$8c2f782f98a64dcc)(weightMap, paramMappings);
    return {
        params: params,
        paramMappings: paramMappings
    };
}




var $hA0xX = parcelRequire("hA0xX");

function $865a12bcdf89dfae$export$55f5b63bf26b3f58(x, params) {
    var out = (0, $7eb4943278b38978$export$a378a23c505b471d)(x, params.conv1);
    out = (0, $7eb4943278b38978$export$72c7a0c1bfa20354)(out, params.conv2);
    out = $hA0xX.add(out, x);
    out = $hA0xX.relu(out);
    return out;
}
function $865a12bcdf89dfae$export$b86a2a990774a215(x, params) {
    var out = (0, $7eb4943278b38978$export$9483fa7d893ae5b1)(x, params.conv1);
    out = (0, $7eb4943278b38978$export$72c7a0c1bfa20354)(out, params.conv2);
    var pooled = $hA0xX.avgPool(x, 2, 2, "valid");
    var zeros = $hA0xX.zeros(pooled.shape);
    var isPad = pooled.shape[3] !== out.shape[3];
    var isAdjustShape = pooled.shape[1] !== out.shape[1] || pooled.shape[2] !== out.shape[2];
    if (isAdjustShape) {
        var padShapeX = (0, $c5ef6752615abb23$export$6388937ca91ccae8)(out.shape);
        padShapeX[1] = 1;
        var zerosW = $hA0xX.zeros(padShapeX);
        out = $hA0xX.concat([
            out,
            zerosW
        ], 1);
        var padShapeY = (0, $c5ef6752615abb23$export$6388937ca91ccae8)(out.shape);
        padShapeY[2] = 1;
        var zerosH = $hA0xX.zeros(padShapeY);
        out = $hA0xX.concat([
            out,
            zerosH
        ], 2);
    }
    pooled = isPad ? $hA0xX.concat([
        pooled,
        zeros
    ], 3) : pooled;
    out = $hA0xX.add(pooled, out);
    out = $hA0xX.relu(out);
    return out;
}


var $80eaf1ef4ca56e13$export$5a3bb00a348264dd = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceRecognitionNet, _super);
    function FaceRecognitionNet() {
        return _super.call(this, "FaceRecognitionNet") || this;
    }
    FaceRecognitionNet.prototype.forwardInput = function(input) {
        var params = this.params;
        if (!params) throw new Error("FaceRecognitionNet - load model before inference");
        return $hA0xX.tidy(function() {
            var batchTensor = input.toBatchTensor(150, true).toFloat();
            var meanRgb = [
                122.782,
                117.001,
                104.298
            ];
            var normalized = (0, $20edefd13a8a19f6$export$a3295358bff77e)(batchTensor, meanRgb).div($hA0xX.scalar(256));
            var out = (0, $7eb4943278b38978$export$9483fa7d893ae5b1)(normalized, params.conv32_down);
            out = $hA0xX.maxPool(out, 3, 2, "valid");
            out = (0, $865a12bcdf89dfae$export$55f5b63bf26b3f58)(out, params.conv32_1);
            out = (0, $865a12bcdf89dfae$export$55f5b63bf26b3f58)(out, params.conv32_2);
            out = (0, $865a12bcdf89dfae$export$55f5b63bf26b3f58)(out, params.conv32_3);
            out = (0, $865a12bcdf89dfae$export$b86a2a990774a215)(out, params.conv64_down);
            out = (0, $865a12bcdf89dfae$export$55f5b63bf26b3f58)(out, params.conv64_1);
            out = (0, $865a12bcdf89dfae$export$55f5b63bf26b3f58)(out, params.conv64_2);
            out = (0, $865a12bcdf89dfae$export$55f5b63bf26b3f58)(out, params.conv64_3);
            out = (0, $865a12bcdf89dfae$export$b86a2a990774a215)(out, params.conv128_down);
            out = (0, $865a12bcdf89dfae$export$55f5b63bf26b3f58)(out, params.conv128_1);
            out = (0, $865a12bcdf89dfae$export$55f5b63bf26b3f58)(out, params.conv128_2);
            out = (0, $865a12bcdf89dfae$export$b86a2a990774a215)(out, params.conv256_down);
            out = (0, $865a12bcdf89dfae$export$55f5b63bf26b3f58)(out, params.conv256_1);
            out = (0, $865a12bcdf89dfae$export$55f5b63bf26b3f58)(out, params.conv256_2);
            out = (0, $865a12bcdf89dfae$export$b86a2a990774a215)(out, params.conv256_down_out);
            var globalAvg = out.mean([
                1,
                2
            ]);
            var fullyConnected = $hA0xX.matMul(globalAvg, params.fc);
            return fullyConnected;
        });
    };
    FaceRecognitionNet.prototype.forward = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(this, [
                                _b.sent()
                            ])
                        ];
                }
            });
        });
    };
    FaceRecognitionNet.prototype.computeFaceDescriptor = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var netInput, faceDescriptorTensors, faceDescriptorsForBatch;
            var _this = this;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        netInput = _a.sent();
                        faceDescriptorTensors = $hA0xX.tidy(function() {
                            return $hA0xX.unstack(_this.forwardInput(netInput));
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(faceDescriptorTensors.map(function(t) {
                                return t.data();
                            }))
                        ];
                    case 2:
                        faceDescriptorsForBatch = _a.sent();
                        faceDescriptorTensors.forEach(function(t) {
                            return t.dispose();
                        });
                        return [
                            2 /*return*/ ,
                            netInput.isBatchInput ? faceDescriptorsForBatch : faceDescriptorsForBatch[0]
                        ];
                }
            });
        });
    };
    FaceRecognitionNet.prototype.getDefaultModelName = function() {
        return "face_recognition_model";
    };
    FaceRecognitionNet.prototype.extractParamsFromWeigthMap = function(weightMap) {
        return (0, $72315103ccb05b6d$export$74edd096d8165fb0)(weightMap);
    };
    FaceRecognitionNet.prototype.extractParams = function(weights) {
        return (0, $c2b1d6a0bfe4f92c$export$302ea4f536e3b4c5)(weights);
    };
    return FaceRecognitionNet;
}((0, $89ef56f11ec234e4$export$3a2d186bf4f565eb));


function $2cbfd5490f9ebb81$export$eb28be58d5c87569(weights) {
    var net = new (0, $80eaf1ef4ca56e13$export$5a3bb00a348264dd)();
    net.extractWeights(weights);
    return net;
}


function $436db6b74dffc32d$export$c5fea8ed5d49eb01(sourceObj, descriptor) {
    var extension = {
        descriptor: descriptor
    };
    return Object.assign({}, sourceObj, extension);
}





function $cc2a3ff7900b53be$export$eab6812d3da6edca(obj) {
    return typeof obj["age"] === "number";
}
function $cc2a3ff7900b53be$export$dd983850230dc285(sourceObj, age) {
    var extension = {
        age: age
    };
    return Object.assign({}, sourceObj, extension);
}




function $6c12e6a3e32f26d5$export$cb38b73d94fc2e98(obj) {
    return (obj["gender"] === (0, $39a4d4e3795b22e3$export$d549c77c8a078892).MALE || obj["gender"] === (0, $39a4d4e3795b22e3$export$d549c77c8a078892).FEMALE) && (0, $4c1c2b1e5936cf08$export$8c6c09d122023c19)(obj["genderProbability"]);
}
function $6c12e6a3e32f26d5$export$6c7236d62a6a2e3c(sourceObj, gender, genderProbability) {
    var extension = {
        gender: gender,
        genderProbability: genderProbability
    };
    return Object.assign({}, sourceObj, extension);
}





var $5af9889218fc5497$export$fe531e0ea63f5dc9 = /** @class */ function() {
    function MtcnnOptions(_a) {
        var _b = _a === void 0 ? {} : _a, minFaceSize = _b.minFaceSize, scaleFactor = _b.scaleFactor, maxNumScales = _b.maxNumScales, scoreThresholds = _b.scoreThresholds, scaleSteps = _b.scaleSteps;
        this._name = "MtcnnOptions";
        this._minFaceSize = minFaceSize || 20;
        this._scaleFactor = scaleFactor || 0.709;
        this._maxNumScales = maxNumScales || 10;
        this._scoreThresholds = scoreThresholds || [
            0.6,
            0.7,
            0.7
        ];
        this._scaleSteps = scaleSteps;
        if (typeof this._minFaceSize !== "number" || this._minFaceSize < 0) throw new Error(this._name + " - expected minFaceSize to be a number > 0");
        if (typeof this._scaleFactor !== "number" || this._scaleFactor <= 0 || this._scaleFactor >= 1) throw new Error(this._name + " - expected scaleFactor to be a number between 0 and 1");
        if (typeof this._maxNumScales !== "number" || this._maxNumScales < 0) throw new Error(this._name + " - expected maxNumScales to be a number > 0");
        if (!Array.isArray(this._scoreThresholds) || this._scoreThresholds.length !== 3 || this._scoreThresholds.some(function(th) {
            return typeof th !== "number";
        })) throw new Error(this._name + " - expected scoreThresholds to be an array of numbers of length 3");
        if (this._scaleSteps && (!Array.isArray(this._scaleSteps) || this._scaleSteps.some(function(th) {
            return typeof th !== "number";
        }))) throw new Error(this._name + " - expected scaleSteps to be an array of numbers");
    }
    Object.defineProperty(MtcnnOptions.prototype, "minFaceSize", {
        get: function() {
            return this._minFaceSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MtcnnOptions.prototype, "scaleFactor", {
        get: function() {
            return this._scaleFactor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MtcnnOptions.prototype, "maxNumScales", {
        get: function() {
            return this._maxNumScales;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MtcnnOptions.prototype, "scoreThresholds", {
        get: function() {
            return this._scoreThresholds;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MtcnnOptions.prototype, "scaleSteps", {
        get: function() {
            return this._scaleSteps;
        },
        enumerable: true,
        configurable: true
    });
    return MtcnnOptions;
}();





var $hA0xX = parcelRequire("hA0xX");





var $hA0xX = parcelRequire("hA0xX");

function $f4e6659196bd24a1$var$extractorsFactory(extractWeights, paramMappings) {
    function extractDepthwiseConvParams(numChannels, mappedPrefix) {
        var filters = $hA0xX.tensor4d(extractWeights(9 * numChannels), [
            3,
            3,
            numChannels,
            1
        ]);
        var batch_norm_scale = $hA0xX.tensor1d(extractWeights(numChannels));
        var batch_norm_offset = $hA0xX.tensor1d(extractWeights(numChannels));
        var batch_norm_mean = $hA0xX.tensor1d(extractWeights(numChannels));
        var batch_norm_variance = $hA0xX.tensor1d(extractWeights(numChannels));
        paramMappings.push({
            paramPath: mappedPrefix + "/filters"
        }, {
            paramPath: mappedPrefix + "/batch_norm_scale"
        }, {
            paramPath: mappedPrefix + "/batch_norm_offset"
        }, {
            paramPath: mappedPrefix + "/batch_norm_mean"
        }, {
            paramPath: mappedPrefix + "/batch_norm_variance"
        });
        return {
            filters: filters,
            batch_norm_scale: batch_norm_scale,
            batch_norm_offset: batch_norm_offset,
            batch_norm_mean: batch_norm_mean,
            batch_norm_variance: batch_norm_variance
        };
    }
    function extractConvParams(channelsIn, channelsOut, filterSize, mappedPrefix, isPointwiseConv) {
        var filters = $hA0xX.tensor4d(extractWeights(channelsIn * channelsOut * filterSize * filterSize), [
            filterSize,
            filterSize,
            channelsIn,
            channelsOut
        ]);
        var bias = $hA0xX.tensor1d(extractWeights(channelsOut));
        paramMappings.push({
            paramPath: mappedPrefix + "/filters"
        }, {
            paramPath: mappedPrefix + "/" + (isPointwiseConv ? "batch_norm_offset" : "bias")
        });
        return {
            filters: filters,
            bias: bias
        };
    }
    function extractPointwiseConvParams(channelsIn, channelsOut, filterSize, mappedPrefix) {
        var _a = extractConvParams(channelsIn, channelsOut, filterSize, mappedPrefix, true), filters = _a.filters, bias = _a.bias;
        return {
            filters: filters,
            batch_norm_offset: bias
        };
    }
    function extractConvPairParams(channelsIn, channelsOut, mappedPrefix) {
        var depthwise_conv = extractDepthwiseConvParams(channelsIn, mappedPrefix + "/depthwise_conv");
        var pointwise_conv = extractPointwiseConvParams(channelsIn, channelsOut, 1, mappedPrefix + "/pointwise_conv");
        return {
            depthwise_conv: depthwise_conv,
            pointwise_conv: pointwise_conv
        };
    }
    function extractMobilenetV1Params() {
        var conv_0 = extractPointwiseConvParams(3, 32, 3, "mobilenetv1/conv_0");
        var conv_1 = extractConvPairParams(32, 64, "mobilenetv1/conv_1");
        var conv_2 = extractConvPairParams(64, 128, "mobilenetv1/conv_2");
        var conv_3 = extractConvPairParams(128, 128, "mobilenetv1/conv_3");
        var conv_4 = extractConvPairParams(128, 256, "mobilenetv1/conv_4");
        var conv_5 = extractConvPairParams(256, 256, "mobilenetv1/conv_5");
        var conv_6 = extractConvPairParams(256, 512, "mobilenetv1/conv_6");
        var conv_7 = extractConvPairParams(512, 512, "mobilenetv1/conv_7");
        var conv_8 = extractConvPairParams(512, 512, "mobilenetv1/conv_8");
        var conv_9 = extractConvPairParams(512, 512, "mobilenetv1/conv_9");
        var conv_10 = extractConvPairParams(512, 512, "mobilenetv1/conv_10");
        var conv_11 = extractConvPairParams(512, 512, "mobilenetv1/conv_11");
        var conv_12 = extractConvPairParams(512, 1024, "mobilenetv1/conv_12");
        var conv_13 = extractConvPairParams(1024, 1024, "mobilenetv1/conv_13");
        return {
            conv_0: conv_0,
            conv_1: conv_1,
            conv_2: conv_2,
            conv_3: conv_3,
            conv_4: conv_4,
            conv_5: conv_5,
            conv_6: conv_6,
            conv_7: conv_7,
            conv_8: conv_8,
            conv_9: conv_9,
            conv_10: conv_10,
            conv_11: conv_11,
            conv_12: conv_12,
            conv_13: conv_13
        };
    }
    function extractPredictionLayerParams() {
        var conv_0 = extractPointwiseConvParams(1024, 256, 1, "prediction_layer/conv_0");
        var conv_1 = extractPointwiseConvParams(256, 512, 3, "prediction_layer/conv_1");
        var conv_2 = extractPointwiseConvParams(512, 128, 1, "prediction_layer/conv_2");
        var conv_3 = extractPointwiseConvParams(128, 256, 3, "prediction_layer/conv_3");
        var conv_4 = extractPointwiseConvParams(256, 128, 1, "prediction_layer/conv_4");
        var conv_5 = extractPointwiseConvParams(128, 256, 3, "prediction_layer/conv_5");
        var conv_6 = extractPointwiseConvParams(256, 64, 1, "prediction_layer/conv_6");
        var conv_7 = extractPointwiseConvParams(64, 128, 3, "prediction_layer/conv_7");
        var box_encoding_0_predictor = extractConvParams(512, 12, 1, "prediction_layer/box_predictor_0/box_encoding_predictor");
        var class_predictor_0 = extractConvParams(512, 9, 1, "prediction_layer/box_predictor_0/class_predictor");
        var box_encoding_1_predictor = extractConvParams(1024, 24, 1, "prediction_layer/box_predictor_1/box_encoding_predictor");
        var class_predictor_1 = extractConvParams(1024, 18, 1, "prediction_layer/box_predictor_1/class_predictor");
        var box_encoding_2_predictor = extractConvParams(512, 24, 1, "prediction_layer/box_predictor_2/box_encoding_predictor");
        var class_predictor_2 = extractConvParams(512, 18, 1, "prediction_layer/box_predictor_2/class_predictor");
        var box_encoding_3_predictor = extractConvParams(256, 24, 1, "prediction_layer/box_predictor_3/box_encoding_predictor");
        var class_predictor_3 = extractConvParams(256, 18, 1, "prediction_layer/box_predictor_3/class_predictor");
        var box_encoding_4_predictor = extractConvParams(256, 24, 1, "prediction_layer/box_predictor_4/box_encoding_predictor");
        var class_predictor_4 = extractConvParams(256, 18, 1, "prediction_layer/box_predictor_4/class_predictor");
        var box_encoding_5_predictor = extractConvParams(128, 24, 1, "prediction_layer/box_predictor_5/box_encoding_predictor");
        var class_predictor_5 = extractConvParams(128, 18, 1, "prediction_layer/box_predictor_5/class_predictor");
        var box_predictor_0 = {
            box_encoding_predictor: box_encoding_0_predictor,
            class_predictor: class_predictor_0
        };
        var box_predictor_1 = {
            box_encoding_predictor: box_encoding_1_predictor,
            class_predictor: class_predictor_1
        };
        var box_predictor_2 = {
            box_encoding_predictor: box_encoding_2_predictor,
            class_predictor: class_predictor_2
        };
        var box_predictor_3 = {
            box_encoding_predictor: box_encoding_3_predictor,
            class_predictor: class_predictor_3
        };
        var box_predictor_4 = {
            box_encoding_predictor: box_encoding_4_predictor,
            class_predictor: class_predictor_4
        };
        var box_predictor_5 = {
            box_encoding_predictor: box_encoding_5_predictor,
            class_predictor: class_predictor_5
        };
        return {
            conv_0: conv_0,
            conv_1: conv_1,
            conv_2: conv_2,
            conv_3: conv_3,
            conv_4: conv_4,
            conv_5: conv_5,
            conv_6: conv_6,
            conv_7: conv_7,
            box_predictor_0: box_predictor_0,
            box_predictor_1: box_predictor_1,
            box_predictor_2: box_predictor_2,
            box_predictor_3: box_predictor_3,
            box_predictor_4: box_predictor_4,
            box_predictor_5: box_predictor_5
        };
    }
    return {
        extractMobilenetV1Params: extractMobilenetV1Params,
        extractPredictionLayerParams: extractPredictionLayerParams
    };
}
function $f4e6659196bd24a1$export$302ea4f536e3b4c5(weights) {
    var paramMappings = [];
    var _a = (0, $d6b5f6264aa92ea2$export$4f1d9b03928e19e3)(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
    var _b = $f4e6659196bd24a1$var$extractorsFactory(extractWeights, paramMappings), extractMobilenetV1Params = _b.extractMobilenetV1Params, extractPredictionLayerParams = _b.extractPredictionLayerParams;
    var mobilenetv1 = extractMobilenetV1Params();
    var prediction_layer = extractPredictionLayerParams();
    var extra_dim = $hA0xX.tensor3d(extractWeights(20472), [
        1,
        5118,
        4
    ]);
    var output_layer = {
        extra_dim: extra_dim
    };
    paramMappings.push({
        paramPath: "output_layer/extra_dim"
    });
    if (getRemainingWeights().length !== 0) throw new Error("weights remaing after extract: " + getRemainingWeights().length);
    return {
        params: {
            mobilenetv1: mobilenetv1,
            prediction_layer: prediction_layer,
            output_layer: output_layer
        },
        paramMappings: paramMappings
    };
}




function $1ad957a9f8c07499$var$extractorsFactory(weightMap, paramMappings) {
    var extractWeightEntry = (0, $0c460a5f8990e5eb$export$ef0fb3c0e9f7c333)(weightMap, paramMappings);
    function extractPointwiseConvParams(prefix, idx, mappedPrefix) {
        var filters = extractWeightEntry(prefix + "/Conv2d_" + idx + "_pointwise/weights", 4, mappedPrefix + "/filters");
        var batch_norm_offset = extractWeightEntry(prefix + "/Conv2d_" + idx + "_pointwise/convolution_bn_offset", 1, mappedPrefix + "/batch_norm_offset");
        return {
            filters: filters,
            batch_norm_offset: batch_norm_offset
        };
    }
    function extractConvPairParams(idx) {
        var mappedPrefix = "mobilenetv1/conv_" + idx;
        var prefixDepthwiseConv = "MobilenetV1/Conv2d_" + idx + "_depthwise";
        var mappedPrefixDepthwiseConv = mappedPrefix + "/depthwise_conv";
        var mappedPrefixPointwiseConv = mappedPrefix + "/pointwise_conv";
        var filters = extractWeightEntry(prefixDepthwiseConv + "/depthwise_weights", 4, mappedPrefixDepthwiseConv + "/filters");
        var batch_norm_scale = extractWeightEntry(prefixDepthwiseConv + "/BatchNorm/gamma", 1, mappedPrefixDepthwiseConv + "/batch_norm_scale");
        var batch_norm_offset = extractWeightEntry(prefixDepthwiseConv + "/BatchNorm/beta", 1, mappedPrefixDepthwiseConv + "/batch_norm_offset");
        var batch_norm_mean = extractWeightEntry(prefixDepthwiseConv + "/BatchNorm/moving_mean", 1, mappedPrefixDepthwiseConv + "/batch_norm_mean");
        var batch_norm_variance = extractWeightEntry(prefixDepthwiseConv + "/BatchNorm/moving_variance", 1, mappedPrefixDepthwiseConv + "/batch_norm_variance");
        return {
            depthwise_conv: {
                filters: filters,
                batch_norm_scale: batch_norm_scale,
                batch_norm_offset: batch_norm_offset,
                batch_norm_mean: batch_norm_mean,
                batch_norm_variance: batch_norm_variance
            },
            pointwise_conv: extractPointwiseConvParams("MobilenetV1", idx, mappedPrefixPointwiseConv)
        };
    }
    function extractMobilenetV1Params() {
        return {
            conv_0: extractPointwiseConvParams("MobilenetV1", 0, "mobilenetv1/conv_0"),
            conv_1: extractConvPairParams(1),
            conv_2: extractConvPairParams(2),
            conv_3: extractConvPairParams(3),
            conv_4: extractConvPairParams(4),
            conv_5: extractConvPairParams(5),
            conv_6: extractConvPairParams(6),
            conv_7: extractConvPairParams(7),
            conv_8: extractConvPairParams(8),
            conv_9: extractConvPairParams(9),
            conv_10: extractConvPairParams(10),
            conv_11: extractConvPairParams(11),
            conv_12: extractConvPairParams(12),
            conv_13: extractConvPairParams(13)
        };
    }
    function extractConvParams(prefix, mappedPrefix) {
        var filters = extractWeightEntry(prefix + "/weights", 4, mappedPrefix + "/filters");
        var bias = extractWeightEntry(prefix + "/biases", 1, mappedPrefix + "/bias");
        return {
            filters: filters,
            bias: bias
        };
    }
    function extractBoxPredictorParams(idx) {
        var box_encoding_predictor = extractConvParams("Prediction/BoxPredictor_" + idx + "/BoxEncodingPredictor", "prediction_layer/box_predictor_" + idx + "/box_encoding_predictor");
        var class_predictor = extractConvParams("Prediction/BoxPredictor_" + idx + "/ClassPredictor", "prediction_layer/box_predictor_" + idx + "/class_predictor");
        return {
            box_encoding_predictor: box_encoding_predictor,
            class_predictor: class_predictor
        };
    }
    function extractPredictionLayerParams() {
        return {
            conv_0: extractPointwiseConvParams("Prediction", 0, "prediction_layer/conv_0"),
            conv_1: extractPointwiseConvParams("Prediction", 1, "prediction_layer/conv_1"),
            conv_2: extractPointwiseConvParams("Prediction", 2, "prediction_layer/conv_2"),
            conv_3: extractPointwiseConvParams("Prediction", 3, "prediction_layer/conv_3"),
            conv_4: extractPointwiseConvParams("Prediction", 4, "prediction_layer/conv_4"),
            conv_5: extractPointwiseConvParams("Prediction", 5, "prediction_layer/conv_5"),
            conv_6: extractPointwiseConvParams("Prediction", 6, "prediction_layer/conv_6"),
            conv_7: extractPointwiseConvParams("Prediction", 7, "prediction_layer/conv_7"),
            box_predictor_0: extractBoxPredictorParams(0),
            box_predictor_1: extractBoxPredictorParams(1),
            box_predictor_2: extractBoxPredictorParams(2),
            box_predictor_3: extractBoxPredictorParams(3),
            box_predictor_4: extractBoxPredictorParams(4),
            box_predictor_5: extractBoxPredictorParams(5)
        };
    }
    return {
        extractMobilenetV1Params: extractMobilenetV1Params,
        extractPredictionLayerParams: extractPredictionLayerParams
    };
}
function $1ad957a9f8c07499$export$74edd096d8165fb0(weightMap) {
    var paramMappings = [];
    var _a = $1ad957a9f8c07499$var$extractorsFactory(weightMap, paramMappings), extractMobilenetV1Params = _a.extractMobilenetV1Params, extractPredictionLayerParams = _a.extractPredictionLayerParams;
    var extra_dim = weightMap["Output/extra_dim"];
    paramMappings.push({
        originalPath: "Output/extra_dim",
        paramPath: "output_layer/extra_dim"
    });
    if (!(0, $4c1c2b1e5936cf08$export$e3e19112bd5349fe)(extra_dim)) throw new Error("expected weightMap['Output/extra_dim'] to be a Tensor3D, instead have " + extra_dim);
    var params = {
        mobilenetv1: extractMobilenetV1Params(),
        prediction_layer: extractPredictionLayerParams(),
        output_layer: {
            extra_dim: extra_dim
        }
    };
    (0, $8af358d5eb8121b0$export$8c2f782f98a64dcc)(weightMap, paramMappings);
    return {
        params: params,
        paramMappings: paramMappings
    };
}



var $hA0xX = parcelRequire("hA0xX");

var $hA0xX = parcelRequire("hA0xX");
function $4c286775f757640a$export$2c0b85d1a38f6d3c(x, params, strides) {
    return $hA0xX.tidy(function() {
        var out = $hA0xX.conv2d(x, params.filters, strides, "same");
        out = $hA0xX.add(out, params.batch_norm_offset);
        return $hA0xX.clipByValue(out, 0, 6);
    });
}


var $2891896ab9a2573e$var$epsilon = 0.0010000000474974513;
function $2891896ab9a2573e$var$depthwiseConvLayer(x, params, strides) {
    return $hA0xX.tidy(function() {
        var out = $hA0xX.depthwiseConv2d(x, params.filters, strides, "same");
        out = $hA0xX.batchNorm(out, params.batch_norm_mean, params.batch_norm_variance, params.batch_norm_offset, params.batch_norm_scale, $2891896ab9a2573e$var$epsilon);
        return $hA0xX.clipByValue(out, 0, 6);
    });
}
function $2891896ab9a2573e$var$getStridesForLayerIdx(layerIdx) {
    return [
        2,
        4,
        6,
        12
    ].some(function(idx) {
        return idx === layerIdx;
    }) ? [
        2,
        2
    ] : [
        1,
        1
    ];
}
function $2891896ab9a2573e$export$ed68b86e00644e72(x, params) {
    return $hA0xX.tidy(function() {
        var conv11 = null;
        var out = (0, $4c286775f757640a$export$2c0b85d1a38f6d3c)(x, params.conv_0, [
            2,
            2
        ]);
        var convPairParams = [
            params.conv_1,
            params.conv_2,
            params.conv_3,
            params.conv_4,
            params.conv_5,
            params.conv_6,
            params.conv_7,
            params.conv_8,
            params.conv_9,
            params.conv_10,
            params.conv_11,
            params.conv_12,
            params.conv_13
        ];
        convPairParams.forEach(function(param, i) {
            var layerIdx = i + 1;
            var depthwiseConvStrides = $2891896ab9a2573e$var$getStridesForLayerIdx(layerIdx);
            out = $2891896ab9a2573e$var$depthwiseConvLayer(out, param.depthwise_conv, depthwiseConvStrides);
            out = (0, $4c286775f757640a$export$2c0b85d1a38f6d3c)(out, param.pointwise_conv, [
                1,
                1
            ]);
            if (layerIdx === 11) conv11 = out;
        });
        if (conv11 === null) throw new Error("mobileNetV1 - output of conv layer 11 is null");
        return {
            out: out,
            conv11: conv11
        };
    });
}


function $4773277f26bf43a8$export$b7d265b19ca1d628(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
    var numBoxes = boxes.shape[0];
    var outputSize = Math.min(maxOutputSize, numBoxes);
    var candidates = scores.map(function(score, boxIndex) {
        return {
            score: score,
            boxIndex: boxIndex
        };
    }).filter(function(c) {
        return c.score > scoreThreshold;
    }).sort(function(c1, c2) {
        return c2.score - c1.score;
    });
    var suppressFunc = function(x) {
        return x <= iouThreshold ? 1 : 0;
    };
    var selected = [];
    candidates.forEach(function(c) {
        if (selected.length >= outputSize) return;
        var originalScore = c.score;
        for(var j = selected.length - 1; j >= 0; --j){
            var iou = $4773277f26bf43a8$var$IOU(boxes, c.boxIndex, selected[j]);
            if (iou === 0.0) continue;
            c.score *= suppressFunc(iou);
            if (c.score <= scoreThreshold) break;
        }
        if (originalScore === c.score) selected.push(c.boxIndex);
    });
    return selected;
}
function $4773277f26bf43a8$var$IOU(boxes, i, j) {
    var boxesData = boxes.arraySync();
    var yminI = Math.min(boxesData[i][0], boxesData[i][2]);
    var xminI = Math.min(boxesData[i][1], boxesData[i][3]);
    var ymaxI = Math.max(boxesData[i][0], boxesData[i][2]);
    var xmaxI = Math.max(boxesData[i][1], boxesData[i][3]);
    var yminJ = Math.min(boxesData[j][0], boxesData[j][2]);
    var xminJ = Math.min(boxesData[j][1], boxesData[j][3]);
    var ymaxJ = Math.max(boxesData[j][0], boxesData[j][2]);
    var xmaxJ = Math.max(boxesData[j][1], boxesData[j][3]);
    var areaI = (ymaxI - yminI) * (xmaxI - xminI);
    var areaJ = (ymaxJ - yminJ) * (xmaxJ - xminJ);
    if (areaI <= 0 || areaJ <= 0) return 0.0;
    var intersectionYmin = Math.max(yminI, yminJ);
    var intersectionXmin = Math.max(xminI, xminJ);
    var intersectionYmax = Math.min(ymaxI, ymaxJ);
    var intersectionXmax = Math.min(xmaxI, xmaxJ);
    var intersectionArea = Math.max(intersectionYmax - intersectionYmin, 0.0) * Math.max(intersectionXmax - intersectionXmin, 0.0);
    return intersectionArea / (areaI + areaJ - intersectionArea);
}



var $hA0xX = parcelRequire("hA0xX");
function $4aa8dde3d41163ea$var$getCenterCoordinatesAndSizesLayer(x) {
    var vec = $hA0xX.unstack($hA0xX.transpose(x, [
        1,
        0
    ]));
    var sizes = [
        $hA0xX.sub(vec[2], vec[0]),
        $hA0xX.sub(vec[3], vec[1])
    ];
    var centers = [
        $hA0xX.add(vec[0], $hA0xX.div(sizes[0], $hA0xX.scalar(2))),
        $hA0xX.add(vec[1], $hA0xX.div(sizes[1], $hA0xX.scalar(2)))
    ];
    return {
        sizes: sizes,
        centers: centers
    };
}
function $4aa8dde3d41163ea$var$decodeBoxesLayer(x0, x1) {
    var _a = $4aa8dde3d41163ea$var$getCenterCoordinatesAndSizesLayer(x0), sizes = _a.sizes, centers = _a.centers;
    var vec = $hA0xX.unstack($hA0xX.transpose(x1, [
        1,
        0
    ]));
    var div0_out = $hA0xX.div($hA0xX.mul($hA0xX.exp($hA0xX.div(vec[2], $hA0xX.scalar(5))), sizes[0]), $hA0xX.scalar(2));
    var add0_out = $hA0xX.add($hA0xX.mul($hA0xX.div(vec[0], $hA0xX.scalar(10)), sizes[0]), centers[0]);
    var div1_out = $hA0xX.div($hA0xX.mul($hA0xX.exp($hA0xX.div(vec[3], $hA0xX.scalar(5))), sizes[1]), $hA0xX.scalar(2));
    var add1_out = $hA0xX.add($hA0xX.mul($hA0xX.div(vec[1], $hA0xX.scalar(10)), sizes[1]), centers[1]);
    return $hA0xX.transpose($hA0xX.stack([
        $hA0xX.sub(add0_out, div0_out),
        $hA0xX.sub(add1_out, div1_out),
        $hA0xX.add(add0_out, div0_out),
        $hA0xX.add(add1_out, div1_out)
    ]), [
        1,
        0
    ]);
}
function $4aa8dde3d41163ea$export$63b54331760408f9(boxPredictions, classPredictions, params) {
    return $hA0xX.tidy(function() {
        var batchSize = boxPredictions.shape[0];
        var boxes = $4aa8dde3d41163ea$var$decodeBoxesLayer($hA0xX.reshape($hA0xX.tile(params.extra_dim, [
            batchSize,
            1,
            1
        ]), [
            -1,
            4
        ]), $hA0xX.reshape(boxPredictions, [
            -1,
            4
        ]));
        boxes = $hA0xX.reshape(boxes, [
            batchSize,
            boxes.shape[0] / batchSize,
            4
        ]);
        var scoresAndClasses = $hA0xX.sigmoid($hA0xX.slice(classPredictions, [
            0,
            0,
            1
        ], [
            -1,
            -1,
            -1
        ]));
        var scores = $hA0xX.slice(scoresAndClasses, [
            0,
            0,
            0
        ], [
            -1,
            -1,
            1
        ]);
        scores = $hA0xX.reshape(scores, [
            batchSize,
            scores.shape[1]
        ]);
        var boxesByBatch = $hA0xX.unstack(boxes);
        var scoresByBatch = $hA0xX.unstack(scores);
        return {
            boxes: boxesByBatch,
            scores: scoresByBatch
        };
    });
}



var $hA0xX = parcelRequire("hA0xX");

var $hA0xX = parcelRequire("hA0xX");

function $8584c542d09faadc$export$76eed6cd67506d60(x, params) {
    return $hA0xX.tidy(function() {
        var batchSize = x.shape[0];
        var boxPredictionEncoding = $hA0xX.reshape((0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(x, params.box_encoding_predictor), [
            batchSize,
            -1,
            1,
            4
        ]);
        var classPrediction = $hA0xX.reshape((0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(x, params.class_predictor), [
            batchSize,
            -1,
            3
        ]);
        return {
            boxPredictionEncoding: boxPredictionEncoding,
            classPrediction: classPrediction
        };
    });
}



function $2144768894f23921$export$9db291eb8b728012(x, conv11, params) {
    return $hA0xX.tidy(function() {
        var conv0 = (0, $4c286775f757640a$export$2c0b85d1a38f6d3c)(x, params.conv_0, [
            1,
            1
        ]);
        var conv1 = (0, $4c286775f757640a$export$2c0b85d1a38f6d3c)(conv0, params.conv_1, [
            2,
            2
        ]);
        var conv2 = (0, $4c286775f757640a$export$2c0b85d1a38f6d3c)(conv1, params.conv_2, [
            1,
            1
        ]);
        var conv3 = (0, $4c286775f757640a$export$2c0b85d1a38f6d3c)(conv2, params.conv_3, [
            2,
            2
        ]);
        var conv4 = (0, $4c286775f757640a$export$2c0b85d1a38f6d3c)(conv3, params.conv_4, [
            1,
            1
        ]);
        var conv5 = (0, $4c286775f757640a$export$2c0b85d1a38f6d3c)(conv4, params.conv_5, [
            2,
            2
        ]);
        var conv6 = (0, $4c286775f757640a$export$2c0b85d1a38f6d3c)(conv5, params.conv_6, [
            1,
            1
        ]);
        var conv7 = (0, $4c286775f757640a$export$2c0b85d1a38f6d3c)(conv6, params.conv_7, [
            2,
            2
        ]);
        var boxPrediction0 = (0, $8584c542d09faadc$export$76eed6cd67506d60)(conv11, params.box_predictor_0);
        var boxPrediction1 = (0, $8584c542d09faadc$export$76eed6cd67506d60)(x, params.box_predictor_1);
        var boxPrediction2 = (0, $8584c542d09faadc$export$76eed6cd67506d60)(conv1, params.box_predictor_2);
        var boxPrediction3 = (0, $8584c542d09faadc$export$76eed6cd67506d60)(conv3, params.box_predictor_3);
        var boxPrediction4 = (0, $8584c542d09faadc$export$76eed6cd67506d60)(conv5, params.box_predictor_4);
        var boxPrediction5 = (0, $8584c542d09faadc$export$76eed6cd67506d60)(conv7, params.box_predictor_5);
        var boxPredictions = $hA0xX.concat([
            boxPrediction0.boxPredictionEncoding,
            boxPrediction1.boxPredictionEncoding,
            boxPrediction2.boxPredictionEncoding,
            boxPrediction3.boxPredictionEncoding,
            boxPrediction4.boxPredictionEncoding,
            boxPrediction5.boxPredictionEncoding
        ], 1);
        var classPredictions = $hA0xX.concat([
            boxPrediction0.classPrediction,
            boxPrediction1.classPrediction,
            boxPrediction2.classPrediction,
            boxPrediction3.classPrediction,
            boxPrediction4.classPrediction,
            boxPrediction5.classPrediction
        ], 1);
        return {
            boxPredictions: boxPredictions,
            classPredictions: classPredictions
        };
    });
}


var $5494815e9839434a$export$7750daea02ba9089 = /** @class */ function() {
    function SsdMobilenetv1Options(_a) {
        var _b = _a === void 0 ? {} : _a, minConfidence = _b.minConfidence, maxResults = _b.maxResults;
        this._name = "SsdMobilenetv1Options";
        this._minConfidence = minConfidence || 0.5;
        this._maxResults = maxResults || 100;
        if (typeof this._minConfidence !== "number" || this._minConfidence <= 0 || this._minConfidence >= 1) throw new Error(this._name + " - expected minConfidence to be a number between 0 and 1");
        if (typeof this._maxResults !== "number") throw new Error(this._name + " - expected maxResults to be a number");
    }
    Object.defineProperty(SsdMobilenetv1Options.prototype, "minConfidence", {
        get: function() {
            return this._minConfidence;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SsdMobilenetv1Options.prototype, "maxResults", {
        get: function() {
            return this._maxResults;
        },
        enumerable: true,
        configurable: true
    });
    return SsdMobilenetv1Options;
}();


var $42415a77fcc9abe3$export$cfe528f380868d81 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(SsdMobilenetv1, _super);
    function SsdMobilenetv1() {
        return _super.call(this, "SsdMobilenetv1") || this;
    }
    SsdMobilenetv1.prototype.forwardInput = function(input) {
        var params = this.params;
        if (!params) throw new Error("SsdMobilenetv1 - load model before inference");
        return $hA0xX.tidy(function() {
            var batchTensor = input.toBatchTensor(512, false).toFloat();
            var x = $hA0xX.sub($hA0xX.mul(batchTensor, $hA0xX.scalar(0.007843137718737125)), $hA0xX.scalar(1));
            var features = (0, $2891896ab9a2573e$export$ed68b86e00644e72)(x, params.mobilenetv1);
            var _a = (0, $2144768894f23921$export$9db291eb8b728012)(features.out, features.conv11, params.prediction_layer), boxPredictions = _a.boxPredictions, classPredictions = _a.classPredictions;
            return (0, $4aa8dde3d41163ea$export$63b54331760408f9)(boxPredictions, classPredictions, params.output_layer);
        });
    };
    SsdMobilenetv1.prototype.forward = function(input) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(this, [
                                _b.sent()
                            ])
                        ];
                }
            });
        });
    };
    SsdMobilenetv1.prototype.locateFaces = function(input, options) {
        if (options === void 0) options = {};
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, maxResults, minConfidence, netInput, _b, _boxes, _scores, boxes, scores, i, scoresData, _c, _d, iouThreshold, indices, reshapedDims, inputSize, padX, padY, boxesData, results;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = new (0, $5494815e9839434a$export$7750daea02ba9089)(options), maxResults = _a.maxResults, minConfidence = _a.minConfidence;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        netInput = _e.sent();
                        _b = this.forwardInput(netInput), _boxes = _b.boxes, _scores = _b.scores;
                        boxes = _boxes[0];
                        scores = _scores[0];
                        for(i = 1; i < _boxes.length; i++){
                            _boxes[i].dispose();
                            _scores[i].dispose();
                        }
                        _d = (_c = Array).from;
                        return [
                            4 /*yield*/ ,
                            scores.data()
                        ];
                    case 2:
                        scoresData = _d.apply(_c, [
                            _e.sent()
                        ]);
                        iouThreshold = 0.5;
                        indices = (0, $4773277f26bf43a8$export$b7d265b19ca1d628)(boxes, scoresData, maxResults, iouThreshold, minConfidence);
                        reshapedDims = netInput.getReshapedInputDimensions(0);
                        inputSize = netInput.inputSize;
                        padX = inputSize / reshapedDims.width;
                        padY = inputSize / reshapedDims.height;
                        boxesData = boxes.arraySync();
                        results = indices.map(function(idx) {
                            var _a = [
                                Math.max(0, boxesData[idx][0]),
                                Math.min(1.0, boxesData[idx][2])
                            ].map(function(val) {
                                return val * padY;
                            }), top = _a[0], bottom = _a[1];
                            var _b = [
                                Math.max(0, boxesData[idx][1]),
                                Math.min(1.0, boxesData[idx][3])
                            ].map(function(val) {
                                return val * padX;
                            }), left = _b[0], right = _b[1];
                            return new (0, $86da6cbb0a7a9620$export$dc77199a917e22c2)(scoresData[idx], new (0, $aef801190ddb2db5$export$c79fc6492f3af13d)(left, top, right - left, bottom - top), {
                                height: netInput.getInputHeight(0),
                                width: netInput.getInputWidth(0)
                            });
                        });
                        boxes.dispose();
                        scores.dispose();
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    SsdMobilenetv1.prototype.getDefaultModelName = function() {
        return "ssd_mobilenetv1_model";
    };
    SsdMobilenetv1.prototype.extractParamsFromWeigthMap = function(weightMap) {
        return (0, $1ad957a9f8c07499$export$74edd096d8165fb0)(weightMap);
    };
    SsdMobilenetv1.prototype.extractParams = function(weights) {
        return (0, $f4e6659196bd24a1$export$302ea4f536e3b4c5)(weights);
    };
    return SsdMobilenetv1;
}((0, $89ef56f11ec234e4$export$3a2d186bf4f565eb));



function $5d4ec439fb162aee$export$3de4ce2c4d1815c4(weights) {
    var net = new (0, $42415a77fcc9abe3$export$cfe528f380868d81)();
    net.extractWeights(weights);
    return net;
}
function $5d4ec439fb162aee$export$197e3c27e3c6e8e3(weights) {
    return $5d4ec439fb162aee$export$3de4ce2c4d1815c4(weights);
}
// alias for backward compatibily
var $5d4ec439fb162aee$export$13acdba3f1724604 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(FaceDetectionNet, _super);
    function FaceDetectionNet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FaceDetectionNet;
}((0, $42415a77fcc9abe3$export$cfe528f380868d81));





var $ca909eb4103079b5$export$853a06d611537d86 = 0.4;
var $ca909eb4103079b5$export$677cc96adb34cf6 = [
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(0.738768, 0.874946),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(2.42204, 2.65704),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(4.30971, 7.04493),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(10.246, 4.59428),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(12.6868, 11.8741)
];
var $ca909eb4103079b5$export$3069f0349abe7cc = [
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(1.603231, 2.094468),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(6.041143, 7.080126),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(2.882459, 3.518061),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(4.266906, 5.178857),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(9.041765, 10.66308)
];
var $ca909eb4103079b5$export$4307312fa5e546f2 = [
    117.001,
    114.697,
    97.404
];
var $ca909eb4103079b5$export$9ffb2eac80132860 = "tiny_yolov2_model";
var $ca909eb4103079b5$export$9c1b3354d30e6864 = "tiny_yolov2_separable_conv_model";




var $hA0xX = parcelRequire("hA0xX");








var $a6d9c952e6614411$var$isNumber = function(arg) {
    return typeof arg === "number";
};
function $a6d9c952e6614411$export$127f9a442b42d18(config) {
    if (!config) throw new Error("invalid config: " + config);
    if (typeof config.withSeparableConvs !== "boolean") throw new Error("config.withSeparableConvs has to be a boolean, have: " + config.withSeparableConvs);
    if (!$a6d9c952e6614411$var$isNumber(config.iouThreshold) || config.iouThreshold < 0 || config.iouThreshold > 1.0) throw new Error("config.iouThreshold has to be a number between [0, 1], have: " + config.iouThreshold);
    if (!Array.isArray(config.classes) || !config.classes.length || !config.classes.every(function(c) {
        return typeof c === "string";
    })) throw new Error("config.classes has to be an array class names: string[], have: " + JSON.stringify(config.classes));
    if (!Array.isArray(config.anchors) || !config.anchors.length || !config.anchors.map(function(a) {
        return a || {};
    }).every(function(a) {
        return $a6d9c952e6614411$var$isNumber(a.x) && $a6d9c952e6614411$var$isNumber(a.y);
    })) throw new Error("config.anchors has to be an array of { x: number, y: number }, have: " + JSON.stringify(config.anchors));
    if (config.meanRgb && (!Array.isArray(config.meanRgb) || config.meanRgb.length !== 3 || !config.meanRgb.every($a6d9c952e6614411$var$isNumber))) throw new Error("config.meanRgb has to be an array of shape [number, number, number], have: " + JSON.stringify(config.meanRgb));
}



var $hA0xX = parcelRequire("hA0xX");

var $hA0xX = parcelRequire("hA0xX");
function $35b028b9e075861e$export$844284792d564f97(x) {
    return $hA0xX.tidy(function() {
        var min = $hA0xX.mul(x, $hA0xX.scalar(0.10000000149011612));
        return $hA0xX.add($hA0xX.relu($hA0xX.sub(x, min)), min);
    //return tf.maximum(x, min)
    });
}


function $8c46903dec8792dd$export$c17a7c4f222cfc32(x, params) {
    return $hA0xX.tidy(function() {
        var out = $hA0xX.pad(x, [
            [
                0,
                0
            ],
            [
                1,
                1
            ],
            [
                1,
                1
            ],
            [
                0,
                0
            ]
        ]);
        out = $hA0xX.conv2d(out, params.conv.filters, [
            1,
            1
        ], "valid");
        out = $hA0xX.sub(out, params.bn.sub);
        out = $hA0xX.mul(out, params.bn.truediv);
        out = $hA0xX.add(out, params.conv.bias);
        return (0, $35b028b9e075861e$export$844284792d564f97)(out);
    });
}



var $hA0xX = parcelRequire("hA0xX");

function $ed777591d3f6e0b6$export$d65a03e5919e6e04(x, params) {
    return $hA0xX.tidy(function() {
        var out = $hA0xX.pad(x, [
            [
                0,
                0
            ],
            [
                1,
                1
            ],
            [
                1,
                1
            ],
            [
                0,
                0
            ]
        ]);
        out = $hA0xX.separableConv2d(out, params.depthwise_filter, params.pointwise_filter, [
            1,
            1
        ], "valid");
        out = $hA0xX.add(out, params.bias);
        return (0, $35b028b9e075861e$export$844284792d564f97)(out);
    });
}



var $hA0xX = parcelRequire("hA0xX");



function $19684fce1cc7e68b$var$extractorsFactory(extractWeights, paramMappings) {
    var extractConvParams = (0, $bd086950888a8c1c$export$413a2f764691001c)(extractWeights, paramMappings);
    function extractBatchNormParams(size, mappedPrefix) {
        var sub = $hA0xX.tensor1d(extractWeights(size));
        var truediv = $hA0xX.tensor1d(extractWeights(size));
        paramMappings.push({
            paramPath: mappedPrefix + "/sub"
        }, {
            paramPath: mappedPrefix + "/truediv"
        });
        return {
            sub: sub,
            truediv: truediv
        };
    }
    function extractConvWithBatchNormParams(channelsIn, channelsOut, mappedPrefix) {
        var conv = extractConvParams(channelsIn, channelsOut, 3, mappedPrefix + "/conv");
        var bn = extractBatchNormParams(channelsOut, mappedPrefix + "/bn");
        return {
            conv: conv,
            bn: bn
        };
    }
    var extractSeparableConvParams = (0, $d0388f3c6ce89a92$export$d4282d0b3a9e13c6)(extractWeights, paramMappings);
    return {
        extractConvParams: extractConvParams,
        extractConvWithBatchNormParams: extractConvWithBatchNormParams,
        extractSeparableConvParams: extractSeparableConvParams
    };
}
function $19684fce1cc7e68b$export$302ea4f536e3b4c5(weights, config, boxEncodingSize, filterSizes) {
    var _a = (0, $d6b5f6264aa92ea2$export$4f1d9b03928e19e3)(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
    var paramMappings = [];
    var _b = $19684fce1cc7e68b$var$extractorsFactory(extractWeights, paramMappings), extractConvParams = _b.extractConvParams, extractConvWithBatchNormParams = _b.extractConvWithBatchNormParams, extractSeparableConvParams = _b.extractSeparableConvParams;
    var params;
    if (config.withSeparableConvs) {
        var s0 = filterSizes[0], s1 = filterSizes[1], s2 = filterSizes[2], s3 = filterSizes[3], s4 = filterSizes[4], s5 = filterSizes[5], s6 = filterSizes[6], s7 = filterSizes[7], s8 = filterSizes[8];
        var conv0 = config.isFirstLayerConv2d ? extractConvParams(s0, s1, 3, "conv0") : extractSeparableConvParams(s0, s1, "conv0");
        var conv1 = extractSeparableConvParams(s1, s2, "conv1");
        var conv2 = extractSeparableConvParams(s2, s3, "conv2");
        var conv3 = extractSeparableConvParams(s3, s4, "conv3");
        var conv4 = extractSeparableConvParams(s4, s5, "conv4");
        var conv5 = extractSeparableConvParams(s5, s6, "conv5");
        var conv6 = s7 ? extractSeparableConvParams(s6, s7, "conv6") : undefined;
        var conv7 = s8 ? extractSeparableConvParams(s7, s8, "conv7") : undefined;
        var conv8 = extractConvParams(s8 || s7 || s6, 5 * boxEncodingSize, 1, "conv8");
        params = {
            conv0: conv0,
            conv1: conv1,
            conv2: conv2,
            conv3: conv3,
            conv4: conv4,
            conv5: conv5,
            conv6: conv6,
            conv7: conv7,
            conv8: conv8
        };
    } else {
        var s0 = filterSizes[0], s1 = filterSizes[1], s2 = filterSizes[2], s3 = filterSizes[3], s4 = filterSizes[4], s5 = filterSizes[5], s6 = filterSizes[6], s7 = filterSizes[7], s8 = filterSizes[8];
        var conv0 = extractConvWithBatchNormParams(s0, s1, "conv0");
        var conv1 = extractConvWithBatchNormParams(s1, s2, "conv1");
        var conv2 = extractConvWithBatchNormParams(s2, s3, "conv2");
        var conv3 = extractConvWithBatchNormParams(s3, s4, "conv3");
        var conv4 = extractConvWithBatchNormParams(s4, s5, "conv4");
        var conv5 = extractConvWithBatchNormParams(s5, s6, "conv5");
        var conv6 = extractConvWithBatchNormParams(s6, s7, "conv6");
        var conv7 = extractConvWithBatchNormParams(s7, s8, "conv7");
        var conv8 = extractConvParams(s8, 5 * boxEncodingSize, 1, "conv8");
        params = {
            conv0: conv0,
            conv1: conv1,
            conv2: conv2,
            conv3: conv3,
            conv4: conv4,
            conv5: conv5,
            conv6: conv6,
            conv7: conv7,
            conv8: conv8
        };
    }
    if (getRemainingWeights().length !== 0) throw new Error("weights remaing after extract: " + getRemainingWeights().length);
    return {
        params: params,
        paramMappings: paramMappings
    };
}





function $18c58771524c193f$var$extractorsFactory(weightMap, paramMappings) {
    var extractWeightEntry = (0, $0c460a5f8990e5eb$export$ef0fb3c0e9f7c333)(weightMap, paramMappings);
    function extractBatchNormParams(prefix) {
        var sub = extractWeightEntry(prefix + "/sub", 1);
        var truediv = extractWeightEntry(prefix + "/truediv", 1);
        return {
            sub: sub,
            truediv: truediv
        };
    }
    function extractConvParams(prefix) {
        var filters = extractWeightEntry(prefix + "/filters", 4);
        var bias = extractWeightEntry(prefix + "/bias", 1);
        return {
            filters: filters,
            bias: bias
        };
    }
    function extractConvWithBatchNormParams(prefix) {
        var conv = extractConvParams(prefix + "/conv");
        var bn = extractBatchNormParams(prefix + "/bn");
        return {
            conv: conv,
            bn: bn
        };
    }
    var extractSeparableConvParams = (0, $d0388f3c6ce89a92$export$e213f501b518bdd4)(extractWeightEntry);
    return {
        extractConvParams: extractConvParams,
        extractConvWithBatchNormParams: extractConvWithBatchNormParams,
        extractSeparableConvParams: extractSeparableConvParams
    };
}
function $18c58771524c193f$export$74edd096d8165fb0(weightMap, config) {
    var paramMappings = [];
    var _a = $18c58771524c193f$var$extractorsFactory(weightMap, paramMappings), extractConvParams = _a.extractConvParams, extractConvWithBatchNormParams = _a.extractConvWithBatchNormParams, extractSeparableConvParams = _a.extractSeparableConvParams;
    var params;
    if (config.withSeparableConvs) {
        var numFilters = config.filterSizes && config.filterSizes.length || 9;
        params = {
            conv0: config.isFirstLayerConv2d ? extractConvParams("conv0") : extractSeparableConvParams("conv0"),
            conv1: extractSeparableConvParams("conv1"),
            conv2: extractSeparableConvParams("conv2"),
            conv3: extractSeparableConvParams("conv3"),
            conv4: extractSeparableConvParams("conv4"),
            conv5: extractSeparableConvParams("conv5"),
            conv6: numFilters > 7 ? extractSeparableConvParams("conv6") : undefined,
            conv7: numFilters > 8 ? extractSeparableConvParams("conv7") : undefined,
            conv8: extractConvParams("conv8")
        };
    } else params = {
        conv0: extractConvWithBatchNormParams("conv0"),
        conv1: extractConvWithBatchNormParams("conv1"),
        conv2: extractConvWithBatchNormParams("conv2"),
        conv3: extractConvWithBatchNormParams("conv3"),
        conv4: extractConvWithBatchNormParams("conv4"),
        conv5: extractConvWithBatchNormParams("conv5"),
        conv6: extractConvWithBatchNormParams("conv6"),
        conv7: extractConvWithBatchNormParams("conv7"),
        conv8: extractConvParams("conv8")
    };
    (0, $8af358d5eb8121b0$export$8c2f782f98a64dcc)(weightMap, paramMappings);
    return {
        params: params,
        paramMappings: paramMappings
    };
}



var $d38b10cc96a92653$export$65790114c6542c07;
(function(TinyYolov2SizeType) {
    TinyYolov2SizeType[TinyYolov2SizeType["XS"] = 224] = "XS";
    TinyYolov2SizeType[TinyYolov2SizeType["SM"] = 320] = "SM";
    TinyYolov2SizeType[TinyYolov2SizeType["MD"] = 416] = "MD";
    TinyYolov2SizeType[TinyYolov2SizeType["LG"] = 608] = "LG";
})($d38b10cc96a92653$export$65790114c6542c07 || ($d38b10cc96a92653$export$65790114c6542c07 = {}));
var $d38b10cc96a92653$export$b4f9bf3a27d6056 = /** @class */ function() {
    function TinyYolov2Options(_a) {
        var _b = _a === void 0 ? {} : _a, inputSize = _b.inputSize, scoreThreshold = _b.scoreThreshold;
        this._name = "TinyYolov2Options";
        this._inputSize = inputSize || 416;
        this._scoreThreshold = scoreThreshold || 0.5;
        if (typeof this._inputSize !== "number" || this._inputSize % 32 !== 0) throw new Error(this._name + " - expected inputSize to be a number divisible by 32");
        if (typeof this._scoreThreshold !== "number" || this._scoreThreshold <= 0 || this._scoreThreshold >= 1) throw new Error(this._name + " - expected scoreThreshold to be a number between 0 and 1");
    }
    Object.defineProperty(TinyYolov2Options.prototype, "inputSize", {
        get: function() {
            return this._inputSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TinyYolov2Options.prototype, "scoreThreshold", {
        get: function() {
            return this._scoreThreshold;
        },
        enumerable: true,
        configurable: true
    });
    return TinyYolov2Options;
}();


var $8cd1fbe2a329d1b4$export$2a42422b518ce707 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(TinyYolov2Base, _super);
    function TinyYolov2Base(config) {
        var _this = _super.call(this, "TinyYolov2") || this;
        (0, $a6d9c952e6614411$export$127f9a442b42d18)(config);
        _this._config = config;
        return _this;
    }
    Object.defineProperty(TinyYolov2Base.prototype, "config", {
        get: function() {
            return this._config;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TinyYolov2Base.prototype, "withClassScores", {
        get: function() {
            return this.config.withClassScores || this.config.classes.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TinyYolov2Base.prototype, "boxEncodingSize", {
        get: function() {
            return 5 + (this.withClassScores ? this.config.classes.length : 0);
        },
        enumerable: true,
        configurable: true
    });
    TinyYolov2Base.prototype.runTinyYolov2 = function(x, params) {
        var out = (0, $8c46903dec8792dd$export$c17a7c4f222cfc32)(x, params.conv0);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $8c46903dec8792dd$export$c17a7c4f222cfc32)(out, params.conv1);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $8c46903dec8792dd$export$c17a7c4f222cfc32)(out, params.conv2);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $8c46903dec8792dd$export$c17a7c4f222cfc32)(out, params.conv3);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $8c46903dec8792dd$export$c17a7c4f222cfc32)(out, params.conv4);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $8c46903dec8792dd$export$c17a7c4f222cfc32)(out, params.conv5);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            1,
            1
        ], "same");
        out = (0, $8c46903dec8792dd$export$c17a7c4f222cfc32)(out, params.conv6);
        out = (0, $8c46903dec8792dd$export$c17a7c4f222cfc32)(out, params.conv7);
        return (0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(out, params.conv8, "valid", false);
    };
    TinyYolov2Base.prototype.runMobilenet = function(x, params) {
        var out = this.config.isFirstLayerConv2d ? (0, $35b028b9e075861e$export$844284792d564f97)((0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(x, params.conv0, "valid", false)) : (0, $ed777591d3f6e0b6$export$d65a03e5919e6e04)(x, params.conv0);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $ed777591d3f6e0b6$export$d65a03e5919e6e04)(out, params.conv1);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $ed777591d3f6e0b6$export$d65a03e5919e6e04)(out, params.conv2);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $ed777591d3f6e0b6$export$d65a03e5919e6e04)(out, params.conv3);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $ed777591d3f6e0b6$export$d65a03e5919e6e04)(out, params.conv4);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $ed777591d3f6e0b6$export$d65a03e5919e6e04)(out, params.conv5);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            1,
            1
        ], "same");
        out = params.conv6 ? (0, $ed777591d3f6e0b6$export$d65a03e5919e6e04)(out, params.conv6) : out;
        out = params.conv7 ? (0, $ed777591d3f6e0b6$export$d65a03e5919e6e04)(out, params.conv7) : out;
        return (0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(out, params.conv8, "valid", false);
    };
    TinyYolov2Base.prototype.forwardInput = function(input, inputSize) {
        var _this = this;
        var params = this.params;
        if (!params) throw new Error("TinyYolov2 - load model before inference");
        return $hA0xX.tidy(function() {
            var batchTensor = input.toBatchTensor(inputSize, false).toFloat();
            batchTensor = _this.config.meanRgb ? (0, $20edefd13a8a19f6$export$a3295358bff77e)(batchTensor, _this.config.meanRgb) : batchTensor;
            batchTensor = batchTensor.div($hA0xX.scalar(256));
            return _this.config.withSeparableConvs ? _this.runMobilenet(batchTensor, params) : _this.runTinyYolov2(batchTensor, params);
        });
    };
    TinyYolov2Base.prototype.forward = function(input, inputSize) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(this, [
                                _b.sent(),
                                inputSize
                            ])
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    TinyYolov2Base.prototype.detect = function(input, forwardParams) {
        if (forwardParams === void 0) forwardParams = {};
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, inputSize, scoreThreshold, netInput, out, out0, inputDimensions, results, boxes, scores, classScores, classNames, indices, detections;
            var _this = this;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = new (0, $d38b10cc96a92653$export$b4f9bf3a27d6056)(forwardParams), inputSize = _a.inputSize, scoreThreshold = _a.scoreThreshold;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        netInput = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.forwardInput(netInput, inputSize)
                        ];
                    case 2:
                        out = _b.sent();
                        out0 = $hA0xX.tidy(function() {
                            return $hA0xX.unstack(out)[0].expandDims();
                        });
                        inputDimensions = {
                            width: netInput.getInputWidth(0),
                            height: netInput.getInputHeight(0)
                        };
                        return [
                            4 /*yield*/ ,
                            this.extractBoxes(out0, netInput.getReshapedInputDimensions(0), scoreThreshold)
                        ];
                    case 3:
                        results = _b.sent();
                        out.dispose();
                        out0.dispose();
                        boxes = results.map(function(res) {
                            return res.box;
                        });
                        scores = results.map(function(res) {
                            return res.score;
                        });
                        classScores = results.map(function(res) {
                            return res.classScore;
                        });
                        classNames = results.map(function(res) {
                            return _this.config.classes[res.label];
                        });
                        indices = (0, $e0d7a8b8653ee871$export$b7d265b19ca1d628)(boxes.map(function(box) {
                            return box.rescale(inputSize);
                        }), scores, this.config.iouThreshold, true);
                        detections = indices.map(function(idx) {
                            return new (0, $7085fdf7180c233c$export$9b4b75cb82ceb9ed)(scores[idx], classScores[idx], classNames[idx], boxes[idx], inputDimensions);
                        });
                        return [
                            2 /*return*/ ,
                            detections
                        ];
                }
            });
        });
    };
    TinyYolov2Base.prototype.getDefaultModelName = function() {
        return "";
    };
    TinyYolov2Base.prototype.extractParamsFromWeigthMap = function(weightMap) {
        return (0, $18c58771524c193f$export$74edd096d8165fb0)(weightMap, this.config);
    };
    TinyYolov2Base.prototype.extractParams = function(weights) {
        var filterSizes = this.config.filterSizes || TinyYolov2Base.DEFAULT_FILTER_SIZES;
        var numFilters = filterSizes ? filterSizes.length : undefined;
        if (numFilters !== 7 && numFilters !== 8 && numFilters !== 9) throw new Error("TinyYolov2 - expected 7 | 8 | 9 convolutional filters, but found " + numFilters + " filterSizes in config");
        return (0, $19684fce1cc7e68b$export$302ea4f536e3b4c5)(weights, this.config, this.boxEncodingSize, filterSizes);
    };
    TinyYolov2Base.prototype.extractBoxes = function(outputTensor, inputBlobDimensions, scoreThreshold) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var width, height, inputSize, correctionFactorX, correctionFactorY, numCells, numBoxes, _a, boxesTensor, scoresTensor, classScoresTensor, results, scoresData, boxesData, row, col, anchor, score, ctX, ctY, width_1, height_1, x, y, pos, _b, classScore, label, _c;
            var _this = this;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        width = inputBlobDimensions.width, height = inputBlobDimensions.height;
                        inputSize = Math.max(width, height);
                        correctionFactorX = inputSize / width;
                        correctionFactorY = inputSize / height;
                        numCells = outputTensor.shape[1];
                        numBoxes = this.config.anchors.length;
                        _a = $hA0xX.tidy(function() {
                            var reshaped = outputTensor.reshape([
                                numCells,
                                numCells,
                                numBoxes,
                                _this.boxEncodingSize
                            ]);
                            var boxes = reshaped.slice([
                                0,
                                0,
                                0,
                                0
                            ], [
                                numCells,
                                numCells,
                                numBoxes,
                                4
                            ]);
                            var scores = reshaped.slice([
                                0,
                                0,
                                0,
                                4
                            ], [
                                numCells,
                                numCells,
                                numBoxes,
                                1
                            ]);
                            var classScores = _this.withClassScores ? $hA0xX.softmax(reshaped.slice([
                                0,
                                0,
                                0,
                                5
                            ], [
                                numCells,
                                numCells,
                                numBoxes,
                                _this.config.classes.length
                            ]), 3) : $hA0xX.scalar(0);
                            return [
                                boxes,
                                scores,
                                classScores
                            ];
                        }), boxesTensor = _a[0], scoresTensor = _a[1], classScoresTensor = _a[2];
                        results = [];
                        return [
                            4 /*yield*/ ,
                            scoresTensor.array()
                        ];
                    case 1:
                        scoresData = _d.sent();
                        return [
                            4 /*yield*/ ,
                            boxesTensor.array()
                        ];
                    case 2:
                        boxesData = _d.sent();
                        row = 0;
                        _d.label = 3;
                    case 3:
                        if (!(row < numCells)) return [
                            3 /*break*/ ,
                            12
                        ];
                        col = 0;
                        _d.label = 4;
                    case 4:
                        if (!(col < numCells)) return [
                            3 /*break*/ ,
                            11
                        ];
                        anchor = 0;
                        _d.label = 5;
                    case 5:
                        if (!(anchor < numBoxes)) return [
                            3 /*break*/ ,
                            10
                        ];
                        score = (0, $4b52c5d3962f4228$export$3b295495ca3cad7c)(scoresData[row][col][anchor][0]);
                        if (!(!scoreThreshold || score > scoreThreshold)) return [
                            3 /*break*/ ,
                            9
                        ];
                        ctX = (col + (0, $4b52c5d3962f4228$export$3b295495ca3cad7c)(boxesData[row][col][anchor][0])) / numCells * correctionFactorX;
                        ctY = (row + (0, $4b52c5d3962f4228$export$3b295495ca3cad7c)(boxesData[row][col][anchor][1])) / numCells * correctionFactorY;
                        width_1 = Math.exp(boxesData[row][col][anchor][2]) * this.config.anchors[anchor].x / numCells * correctionFactorX;
                        height_1 = Math.exp(boxesData[row][col][anchor][3]) * this.config.anchors[anchor].y / numCells * correctionFactorY;
                        x = ctX - width_1 / 2;
                        y = ctY - height_1 / 2;
                        pos = {
                            row: row,
                            col: col,
                            anchor: anchor
                        };
                        if (!this.withClassScores) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            this.extractPredictedClass(classScoresTensor, pos)
                        ];
                    case 6:
                        _c = _d.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        _c = {
                            classScore: 1,
                            label: 0
                        };
                        _d.label = 8;
                    case 8:
                        _b = _c, classScore = _b.classScore, label = _b.label;
                        results.push((0, $c5ef6752615abb23$export$18ce0697a983be9b)({
                            box: new (0, $1d960209cebf9691$export$63080c4de6cfc362)(x, y, x + width_1, y + height_1),
                            score: score,
                            classScore: score * classScore,
                            label: label
                        }, pos));
                        _d.label = 9;
                    case 9:
                        anchor++;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 10:
                        col++;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 11:
                        row++;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 12:
                        boxesTensor.dispose();
                        scoresTensor.dispose();
                        classScoresTensor.dispose();
                        return [
                            2 /*return*/ ,
                            results
                        ];
                }
            });
        });
    };
    TinyYolov2Base.prototype.extractPredictedClass = function(classesTensor, pos) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var row, col, anchor, classesData;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        row = pos.row, col = pos.col, anchor = pos.anchor;
                        return [
                            4 /*yield*/ ,
                            classesTensor.array()
                        ];
                    case 1:
                        classesData = _a.sent();
                        return [
                            2 /*return*/ ,
                            Array(this.config.classes.length).fill(0).map(function(_, i) {
                                return classesData[row][col][anchor][i];
                            }).map(function(classScore, label) {
                                return {
                                    classScore: classScore,
                                    label: label
                                };
                            }).reduce(function(max, curr) {
                                return max.classScore > curr.classScore ? max : curr;
                            })
                        ];
                }
            });
        });
    };
    TinyYolov2Base.DEFAULT_FILTER_SIZES = [
        3,
        16,
        32,
        64,
        128,
        256,
        512,
        1024,
        1024
    ];
    return TinyYolov2Base;
}((0, $89ef56f11ec234e4$export$3a2d186bf4f565eb));


var $ca0bf054ceaa99a6$export$af5f44608fefb9e8 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(TinyYolov2, _super);
    function TinyYolov2(withSeparableConvs) {
        if (withSeparableConvs === void 0) withSeparableConvs = true;
        var _this = this;
        var config = Object.assign({}, {
            withSeparableConvs: withSeparableConvs,
            iouThreshold: (0, $ca909eb4103079b5$export$853a06d611537d86),
            classes: [
                "face"
            ]
        }, withSeparableConvs ? {
            anchors: (0, $ca909eb4103079b5$export$3069f0349abe7cc),
            meanRgb: (0, $ca909eb4103079b5$export$4307312fa5e546f2)
        } : {
            anchors: (0, $ca909eb4103079b5$export$677cc96adb34cf6),
            withClassScores: true
        });
        _this = _super.call(this, config) || this;
        return _this;
    }
    Object.defineProperty(TinyYolov2.prototype, "withSeparableConvs", {
        get: function() {
            return this.config.withSeparableConvs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TinyYolov2.prototype, "anchors", {
        get: function() {
            return this.config.anchors;
        },
        enumerable: true,
        configurable: true
    });
    TinyYolov2.prototype.locateFaces = function(input, forwardParams) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var objectDetections;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.detect(input, forwardParams)
                        ];
                    case 1:
                        objectDetections = _a.sent();
                        return [
                            2 /*return*/ ,
                            objectDetections.map(function(det) {
                                return new (0, $86da6cbb0a7a9620$export$dc77199a917e22c2)(det.score, det.relativeBox, {
                                    width: det.imageWidth,
                                    height: det.imageHeight
                                });
                            })
                        ];
                }
            });
        });
    };
    TinyYolov2.prototype.getDefaultModelName = function() {
        return this.withSeparableConvs ? (0, $ca909eb4103079b5$export$9c1b3354d30e6864) : (0, $ca909eb4103079b5$export$9ffb2eac80132860);
    };
    TinyYolov2.prototype.extractParamsFromWeigthMap = function(weightMap) {
        return _super.prototype.extractParamsFromWeigthMap.call(this, weightMap);
    };
    return TinyYolov2;
}((0, $8cd1fbe2a329d1b4$export$2a42422b518ce707));




function $c762052c95838b58$export$b16fdb25207d516c(weights, withSeparableConvs) {
    if (withSeparableConvs === void 0) withSeparableConvs = true;
    var net = new (0, $ca0bf054ceaa99a6$export$af5f44608fefb9e8)(withSeparableConvs);
    net.extractWeights(weights);
    return net;
}









var $3d7825a9e6f5efa9$export$10bee5cd93f5f680 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(TinyFaceDetectorOptions, _super);
    function TinyFaceDetectorOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._name = "TinyFaceDetectorOptions";
        return _this;
    }
    return TinyFaceDetectorOptions;
}((0, $d38b10cc96a92653$export$b4f9bf3a27d6056));




var $e7ed37862deca8d2$export$ac4908c0dcb7706c = /** @class */ function() {
    function ComposableTask() {}
    ComposableTask.prototype.then = function(onfulfilled) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = onfulfilled;
                        return [
                            4 /*yield*/ ,
                            this.run()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(void 0, [
                                _b.sent()
                            ])
                        ];
                }
            });
        });
    };
    ComposableTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                throw new Error("ComposableTask - run is not implemented");
            });
        });
    };
    return ComposableTask;
}();




var $hA0xX = parcelRequire("hA0xX");








var $hA0xX = parcelRequire("hA0xX");


function $3c7b729c5e14c2ef$export$7f9e366e1b1284b9(parentResults, input, computeResults, extractedFaces, getRectForAlignment) {
    if (getRectForAlignment === void 0) getRectForAlignment = function(_a) {
        var alignedRect = _a.alignedRect;
        return alignedRect;
    };
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var faceBoxes, faces, _a, _b, results;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    faceBoxes = parentResults.map(function(parentResult) {
                        return (0, $16a59fcb4d20ce1c$export$51efdc1ea20f6714)(parentResult) ? getRectForAlignment(parentResult) : parentResult.detection;
                    });
                    _a = extractedFaces;
                    if (_a) return [
                        3 /*break*/ ,
                        5
                    ];
                    if (!(input instanceof $hA0xX.Tensor)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        (0, $0c146d6bc429a854$export$42290f6c8994c1ec)(input, faceBoxes)
                    ];
                case 1:
                    _b = _c.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        (0, $539219fdf6e46a7a$export$a6268ec9f807b452)(input, faceBoxes)
                    ];
                case 3:
                    _b = _c.sent();
                    _c.label = 4;
                case 4:
                    _a = _b;
                    _c.label = 5;
                case 5:
                    faces = _a;
                    return [
                        4 /*yield*/ ,
                        computeResults(faces)
                    ];
                case 6:
                    results = _c.sent();
                    faces.forEach(function(f) {
                        return f instanceof $hA0xX.Tensor && f.dispose();
                    });
                    return [
                        2 /*return*/ ,
                        results
                    ];
            }
        });
    });
}
function $3c7b729c5e14c2ef$export$2ed465c30629b069(parentResult, input, computeResult, extractedFaces, getRectForAlignment) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var _this = this;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                $3c7b729c5e14c2ef$export$7f9e366e1b1284b9([
                    parentResult
                ], input, function(faces) {
                    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                computeResult(faces[0])
                            ];
                        });
                    });
                }, extractedFaces, getRectForAlignment)
            ];
        });
    });
}









var $hA0xX = parcelRequire("hA0xX");







var $hA0xX = parcelRequire("hA0xX");
function $e6c09ad793e5ccce$export$17fba901c15a5c29(tensor) {
    return $hA0xX.tidy(function() {
        return $hA0xX.stack($hA0xX.unstack(tensor, 3).reverse(), 3);
    });
}


var $df78c0105b8e5f37$export$9cf4cc9c3bb99830 = 2;
var $df78c0105b8e5f37$export$b6ba90e55ec79c0b = 12;




var $hA0xX = parcelRequire("hA0xX");

function $fa8618f2ae0e3263$var$extractorsFactory(extractWeights, paramMappings) {
    var extractConvParams = (0, $bd086950888a8c1c$export$413a2f764691001c)(extractWeights, paramMappings);
    var extractFCParams = (0, $090eb72b4d1e0021$export$4072014b46fe651b)(extractWeights, paramMappings);
    function extractPReluParams(size, paramPath) {
        var alpha = $hA0xX.tensor1d(extractWeights(size));
        paramMappings.push({
            paramPath: paramPath
        });
        return alpha;
    }
    function extractSharedParams(numFilters, mappedPrefix, isRnet) {
        if (isRnet === void 0) isRnet = false;
        var conv1 = extractConvParams(numFilters[0], numFilters[1], 3, mappedPrefix + "/conv1");
        var prelu1_alpha = extractPReluParams(numFilters[1], mappedPrefix + "/prelu1_alpha");
        var conv2 = extractConvParams(numFilters[1], numFilters[2], 3, mappedPrefix + "/conv2");
        var prelu2_alpha = extractPReluParams(numFilters[2], mappedPrefix + "/prelu2_alpha");
        var conv3 = extractConvParams(numFilters[2], numFilters[3], isRnet ? 2 : 3, mappedPrefix + "/conv3");
        var prelu3_alpha = extractPReluParams(numFilters[3], mappedPrefix + "/prelu3_alpha");
        return {
            conv1: conv1,
            prelu1_alpha: prelu1_alpha,
            conv2: conv2,
            prelu2_alpha: prelu2_alpha,
            conv3: conv3,
            prelu3_alpha: prelu3_alpha
        };
    }
    function extractPNetParams() {
        var sharedParams = extractSharedParams([
            3,
            10,
            16,
            32
        ], "pnet");
        var conv4_1 = extractConvParams(32, 2, 1, "pnet/conv4_1");
        var conv4_2 = extractConvParams(32, 4, 1, "pnet/conv4_2");
        return (0, $c5ef6752615abb23$export$18ce0697a983be9b)((0, $c5ef6752615abb23$export$18ce0697a983be9b)({}, sharedParams), {
            conv4_1: conv4_1,
            conv4_2: conv4_2
        });
    }
    function extractRNetParams() {
        var sharedParams = extractSharedParams([
            3,
            28,
            48,
            64
        ], "rnet", true);
        var fc1 = extractFCParams(576, 128, "rnet/fc1");
        var prelu4_alpha = extractPReluParams(128, "rnet/prelu4_alpha");
        var fc2_1 = extractFCParams(128, 2, "rnet/fc2_1");
        var fc2_2 = extractFCParams(128, 4, "rnet/fc2_2");
        return (0, $c5ef6752615abb23$export$18ce0697a983be9b)((0, $c5ef6752615abb23$export$18ce0697a983be9b)({}, sharedParams), {
            fc1: fc1,
            prelu4_alpha: prelu4_alpha,
            fc2_1: fc2_1,
            fc2_2: fc2_2
        });
    }
    function extractONetParams() {
        var sharedParams = extractSharedParams([
            3,
            32,
            64,
            64
        ], "onet");
        var conv4 = extractConvParams(64, 128, 2, "onet/conv4");
        var prelu4_alpha = extractPReluParams(128, "onet/prelu4_alpha");
        var fc1 = extractFCParams(1152, 256, "onet/fc1");
        var prelu5_alpha = extractPReluParams(256, "onet/prelu5_alpha");
        var fc2_1 = extractFCParams(256, 2, "onet/fc2_1");
        var fc2_2 = extractFCParams(256, 4, "onet/fc2_2");
        var fc2_3 = extractFCParams(256, 10, "onet/fc2_3");
        return (0, $c5ef6752615abb23$export$18ce0697a983be9b)((0, $c5ef6752615abb23$export$18ce0697a983be9b)({}, sharedParams), {
            conv4: conv4,
            prelu4_alpha: prelu4_alpha,
            fc1: fc1,
            prelu5_alpha: prelu5_alpha,
            fc2_1: fc2_1,
            fc2_2: fc2_2,
            fc2_3: fc2_3
        });
    }
    return {
        extractPNetParams: extractPNetParams,
        extractRNetParams: extractRNetParams,
        extractONetParams: extractONetParams
    };
}
function $fa8618f2ae0e3263$export$302ea4f536e3b4c5(weights) {
    var _a = (0, $d6b5f6264aa92ea2$export$4f1d9b03928e19e3)(weights), extractWeights = _a.extractWeights, getRemainingWeights = _a.getRemainingWeights;
    var paramMappings = [];
    var _b = $fa8618f2ae0e3263$var$extractorsFactory(extractWeights, paramMappings), extractPNetParams = _b.extractPNetParams, extractRNetParams = _b.extractRNetParams, extractONetParams = _b.extractONetParams;
    var pnet = extractPNetParams();
    var rnet = extractRNetParams();
    var onet = extractONetParams();
    if (getRemainingWeights().length !== 0) throw new Error("weights remaing after extract: " + getRemainingWeights().length);
    return {
        params: {
            pnet: pnet,
            rnet: rnet,
            onet: onet
        },
        paramMappings: paramMappings
    };
}




function $21ae8e950d40c028$var$extractorsFactory(weightMap, paramMappings) {
    var extractWeightEntry = (0, $0c460a5f8990e5eb$export$ef0fb3c0e9f7c333)(weightMap, paramMappings);
    function extractConvParams(prefix) {
        var filters = extractWeightEntry(prefix + "/weights", 4, prefix + "/filters");
        var bias = extractWeightEntry(prefix + "/bias", 1);
        return {
            filters: filters,
            bias: bias
        };
    }
    function extractFCParams(prefix) {
        var weights = extractWeightEntry(prefix + "/weights", 2);
        var bias = extractWeightEntry(prefix + "/bias", 1);
        return {
            weights: weights,
            bias: bias
        };
    }
    function extractPReluParams(paramPath) {
        return extractWeightEntry(paramPath, 1);
    }
    function extractSharedParams(prefix) {
        var conv1 = extractConvParams(prefix + "/conv1");
        var prelu1_alpha = extractPReluParams(prefix + "/prelu1_alpha");
        var conv2 = extractConvParams(prefix + "/conv2");
        var prelu2_alpha = extractPReluParams(prefix + "/prelu2_alpha");
        var conv3 = extractConvParams(prefix + "/conv3");
        var prelu3_alpha = extractPReluParams(prefix + "/prelu3_alpha");
        return {
            conv1: conv1,
            prelu1_alpha: prelu1_alpha,
            conv2: conv2,
            prelu2_alpha: prelu2_alpha,
            conv3: conv3,
            prelu3_alpha: prelu3_alpha
        };
    }
    function extractPNetParams() {
        var sharedParams = extractSharedParams("pnet");
        var conv4_1 = extractConvParams("pnet/conv4_1");
        var conv4_2 = extractConvParams("pnet/conv4_2");
        return (0, $c5ef6752615abb23$export$18ce0697a983be9b)((0, $c5ef6752615abb23$export$18ce0697a983be9b)({}, sharedParams), {
            conv4_1: conv4_1,
            conv4_2: conv4_2
        });
    }
    function extractRNetParams() {
        var sharedParams = extractSharedParams("rnet");
        var fc1 = extractFCParams("rnet/fc1");
        var prelu4_alpha = extractPReluParams("rnet/prelu4_alpha");
        var fc2_1 = extractFCParams("rnet/fc2_1");
        var fc2_2 = extractFCParams("rnet/fc2_2");
        return (0, $c5ef6752615abb23$export$18ce0697a983be9b)((0, $c5ef6752615abb23$export$18ce0697a983be9b)({}, sharedParams), {
            fc1: fc1,
            prelu4_alpha: prelu4_alpha,
            fc2_1: fc2_1,
            fc2_2: fc2_2
        });
    }
    function extractONetParams() {
        var sharedParams = extractSharedParams("onet");
        var conv4 = extractConvParams("onet/conv4");
        var prelu4_alpha = extractPReluParams("onet/prelu4_alpha");
        var fc1 = extractFCParams("onet/fc1");
        var prelu5_alpha = extractPReluParams("onet/prelu5_alpha");
        var fc2_1 = extractFCParams("onet/fc2_1");
        var fc2_2 = extractFCParams("onet/fc2_2");
        var fc2_3 = extractFCParams("onet/fc2_3");
        return (0, $c5ef6752615abb23$export$18ce0697a983be9b)((0, $c5ef6752615abb23$export$18ce0697a983be9b)({}, sharedParams), {
            conv4: conv4,
            prelu4_alpha: prelu4_alpha,
            fc1: fc1,
            prelu5_alpha: prelu5_alpha,
            fc2_1: fc2_1,
            fc2_2: fc2_2,
            fc2_3: fc2_3
        });
    }
    return {
        extractPNetParams: extractPNetParams,
        extractRNetParams: extractRNetParams,
        extractONetParams: extractONetParams
    };
}
function $21ae8e950d40c028$export$74edd096d8165fb0(weightMap) {
    var paramMappings = [];
    var _a = $21ae8e950d40c028$var$extractorsFactory(weightMap, paramMappings), extractPNetParams = _a.extractPNetParams, extractRNetParams = _a.extractRNetParams, extractONetParams = _a.extractONetParams;
    var pnet = extractPNetParams();
    var rnet = extractRNetParams();
    var onet = extractONetParams();
    (0, $8af358d5eb8121b0$export$8c2f782f98a64dcc)(weightMap, paramMappings);
    return {
        params: {
            pnet: pnet,
            rnet: rnet,
            onet: onet
        },
        paramMappings: paramMappings
    };
}


function $b5e4a989981b8a5c$export$4fe2ab5d97431e89(scale, _a) {
    var height = _a[0], width = _a[1];
    return {
        height: Math.floor(height * scale),
        width: Math.floor(width * scale)
    };
}




function $2cff200c9333c2f3$export$bf4478ee49b510d5(minFaceSize, scaleFactor, dims) {
    var height = dims[0], width = dims[1];
    var m = (0, $df78c0105b8e5f37$export$b6ba90e55ec79c0b) / minFaceSize;
    var scales = [];
    var minLayer = Math.min(height, width) * m;
    var exp = 0;
    while(minLayer >= 12){
        scales.push(m * Math.pow(scaleFactor, exp));
        minLayer = minLayer * scaleFactor;
        exp += 1;
    }
    return scales;
}



var $hA0xX = parcelRequire("hA0xX");






var $d6b108c4bcaf1b20$export$bb07887006d2e314 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(MtcnnBox, _super);
    function MtcnnBox(left, top, right, bottom) {
        return _super.call(this, {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        }, true) || this;
    }
    return MtcnnBox;
}((0, $c24b8f381986ff10$export$e71c4d32a2263218));



var $hA0xX = parcelRequire("hA0xX");
function $a9222fc0440bd45a$export$a3295358bff77e(x) {
    return $hA0xX.tidy(function() {
        return $hA0xX.mul($hA0xX.sub(x, $hA0xX.scalar(127.5)), $hA0xX.scalar(0.0078125));
    });
}



var $hA0xX = parcelRequire("hA0xX");


var $hA0xX = parcelRequire("hA0xX");


var $hA0xX = parcelRequire("hA0xX");
function $9e8608e85e29e262$export$5882f235222e6729(x, alpha) {
    return $hA0xX.tidy(function() {
        return $hA0xX.add($hA0xX.relu(x), $hA0xX.mul(alpha, $hA0xX.neg($hA0xX.relu($hA0xX.neg(x)))));
    });
}


function $c8911aec741cc229$export$e6e848830c77ef51(x, params, isPnet) {
    if (isPnet === void 0) isPnet = false;
    return $hA0xX.tidy(function() {
        var out = (0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(x, params.conv1, "valid");
        out = (0, $9e8608e85e29e262$export$5882f235222e6729)(out, params.prelu1_alpha);
        out = $hA0xX.maxPool(out, isPnet ? [
            2,
            2
        ] : [
            3,
            3
        ], [
            2,
            2
        ], "same");
        out = (0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(out, params.conv2, "valid");
        out = (0, $9e8608e85e29e262$export$5882f235222e6729)(out, params.prelu2_alpha);
        out = isPnet ? out : $hA0xX.maxPool(out, [
            3,
            3
        ], [
            2,
            2
        ], "valid");
        out = (0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(out, params.conv3, "valid");
        out = (0, $9e8608e85e29e262$export$5882f235222e6729)(out, params.prelu3_alpha);
        return out;
    });
}


function $4c204571812a70bc$export$76c3c5f4d252ac96(x, params) {
    return $hA0xX.tidy(function() {
        var out = (0, $c8911aec741cc229$export$e6e848830c77ef51)(x, params, true);
        var conv = (0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(out, params.conv4_1, "valid");
        var max = $hA0xX.expandDims($hA0xX.max(conv, 3), 3);
        var prob = $hA0xX.softmax($hA0xX.sub(conv, max), 3);
        var regions = (0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(out, params.conv4_2, "valid");
        return {
            prob: prob,
            regions: regions
        };
    });
}


function $6c33e59271d436b1$var$rescaleAndNormalize(x, scale) {
    return $hA0xX.tidy(function() {
        var _a = (0, $b5e4a989981b8a5c$export$4fe2ab5d97431e89)(scale, x.shape.slice(1)), height = _a.height, width = _a.width;
        var resized = $hA0xX.image.resizeBilinear(x, [
            height,
            width
        ]);
        var normalized = (0, $a9222fc0440bd45a$export$a3295358bff77e)(resized);
        return $hA0xX.transpose(normalized, [
            0,
            2,
            1,
            3
        ]);
    });
}
function $6c33e59271d436b1$var$extractBoundingBoxes(scoresTensor, regionsTensor, scale, scoreThreshold) {
    // TODO: fix this!, maybe better to use tf.gather here
    var indices = [];
    var scoresData = scoresTensor.arraySync();
    for(var y = 0; y < scoresTensor.shape[0]; y++){
        for(var x = 0; x < scoresTensor.shape[1]; x++)if (scoresData[y][x] >= scoreThreshold) indices.push(new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(x, y));
    }
    var boundingBoxes = indices.map(function(idx) {
        var cell = new (0, $1d960209cebf9691$export$63080c4de6cfc362)(Math.round((idx.y * (0, $df78c0105b8e5f37$export$9cf4cc9c3bb99830) + 1) / scale), Math.round((idx.x * (0, $df78c0105b8e5f37$export$9cf4cc9c3bb99830) + 1) / scale), Math.round((idx.y * (0, $df78c0105b8e5f37$export$9cf4cc9c3bb99830) + (0, $df78c0105b8e5f37$export$b6ba90e55ec79c0b)) / scale), Math.round((idx.x * (0, $df78c0105b8e5f37$export$9cf4cc9c3bb99830) + (0, $df78c0105b8e5f37$export$b6ba90e55ec79c0b)) / scale));
        var score = scoresData[idx.y][idx.x];
        var regionsData = regionsTensor.arraySync();
        var region = new (0, $d6b108c4bcaf1b20$export$bb07887006d2e314)(regionsData[idx.y][idx.x][0], regionsData[idx.y][idx.x][1], regionsData[idx.y][idx.x][2], regionsData[idx.y][idx.x][3]);
        return {
            cell: cell,
            score: score,
            region: region
        };
    });
    return boundingBoxes;
}
function $6c33e59271d436b1$export$136a030281f5f0af(imgTensor, scales, scoreThreshold, params, stats) {
    stats.stage1 = [];
    var pnetOutputs = scales.map(function(scale) {
        return $hA0xX.tidy(function() {
            var statsForScale = {
                scale: scale
            };
            var resized = $6c33e59271d436b1$var$rescaleAndNormalize(imgTensor, scale);
            var ts = Date.now();
            var _a = (0, $4c204571812a70bc$export$76c3c5f4d252ac96)(resized, params), prob = _a.prob, regions = _a.regions;
            statsForScale.pnet = Date.now() - ts;
            var scoresTensor = $hA0xX.unstack($hA0xX.unstack(prob, 3)[1])[0];
            var regionsTensor = $hA0xX.unstack(regions)[0];
            return {
                scoresTensor: scoresTensor,
                regionsTensor: regionsTensor,
                scale: scale,
                statsForScale: statsForScale
            };
        });
    });
    var boxesForScale = pnetOutputs.map(function(_a) {
        var scoresTensor = _a.scoresTensor, regionsTensor = _a.regionsTensor, scale = _a.scale, statsForScale = _a.statsForScale;
        var boundingBoxes = $6c33e59271d436b1$var$extractBoundingBoxes(scoresTensor, regionsTensor, scale, scoreThreshold);
        scoresTensor.dispose();
        regionsTensor.dispose();
        if (!boundingBoxes.length) {
            stats.stage1.push(statsForScale);
            return [];
        }
        var ts = Date.now();
        var indices = (0, $e0d7a8b8653ee871$export$b7d265b19ca1d628)(boundingBoxes.map(function(bbox) {
            return bbox.cell;
        }), boundingBoxes.map(function(bbox) {
            return bbox.score;
        }), 0.5);
        statsForScale.nms = Date.now() - ts;
        statsForScale.numBoxes = indices.length;
        stats.stage1.push(statsForScale);
        return indices.map(function(boxIdx) {
            return boundingBoxes[boxIdx];
        });
    });
    var allBoxes = boxesForScale.reduce(function(all, boxes) {
        return all.concat(boxes);
    }, []);
    var finalBoxes = [];
    var finalScores = [];
    if (allBoxes.length > 0) {
        var ts = Date.now();
        var indices = (0, $e0d7a8b8653ee871$export$b7d265b19ca1d628)(allBoxes.map(function(bbox) {
            return bbox.cell;
        }), allBoxes.map(function(bbox) {
            return bbox.score;
        }), 0.7);
        stats.stage1_nms = Date.now() - ts;
        finalScores = indices.map(function(idx) {
            return allBoxes[idx].score;
        });
        finalBoxes = indices.map(function(idx) {
            return allBoxes[idx];
        }).map(function(_a) {
            var cell = _a.cell, region = _a.region;
            return new (0, $1d960209cebf9691$export$63080c4de6cfc362)(cell.left + region.left * cell.width, cell.top + region.top * cell.height, cell.right + region.right * cell.width, cell.bottom + region.bottom * cell.height).toSquare().round();
        });
    }
    return {
        boxes: finalBoxes,
        scores: finalScores
    };
}




var $hA0xX = parcelRequire("hA0xX");



var $hA0xX = parcelRequire("hA0xX");



function $a535e3b717ee5687$export$9b7d7f2bb2b576c3(img, boxes, _a) {
    var width = _a.width, height = _a.height;
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var imgCtx, bitmaps, imagePatchesDatas;
        var _this = this;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    imgCtx = (0, $c40df77cbcb9e781$export$40d273013da632b6)(img);
                    return [
                        4 /*yield*/ ,
                        Promise.all(boxes.map(function(box) {
                            return (0, $c5ef6752615abb23$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                var _a, y, ey, x, ex, fromX, fromY, imgData;
                                return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                                    _a = box.padAtBorders(img.height, img.width), y = _a.y, ey = _a.ey, x = _a.x, ex = _a.ex;
                                    fromX = x - 1;
                                    fromY = y - 1;
                                    imgData = imgCtx.getImageData(fromX, fromY, ex - fromX, ey - fromY);
                                    return [
                                        2 /*return*/ ,
                                        (0, $cb889b654af1b67d$export$a7b6bc01c63cdfc3).isNodejs() ? (0, $8aaafed594548f89$export$a5a7c95acc5cffa0)(imgData) : createImageBitmap(imgData)
                                    ];
                                });
                            });
                        }))
                    ];
                case 1:
                    bitmaps = _b.sent();
                    imagePatchesDatas = [];
                    bitmaps.forEach(function(bmp) {
                        var patch = (0, $8aaafed594548f89$export$cd3d1f114b139967)({
                            width: width,
                            height: height
                        });
                        var patchCtx = (0, $c40df77cbcb9e781$export$40d273013da632b6)(patch);
                        patchCtx.drawImage(bmp, 0, 0, width, height);
                        var data = patchCtx.getImageData(0, 0, width, height).data;
                        var currData = [];
                        // RGBA -> BGR
                        for(var i = 0; i < data.length; i += 4){
                            currData.push(data[i + 2]);
                            currData.push(data[i + 1]);
                            currData.push(data[i]);
                        }
                        imagePatchesDatas.push(currData);
                    });
                    return [
                        2 /*return*/ ,
                        imagePatchesDatas.map(function(data) {
                            var t = $hA0xX.tidy(function() {
                                var imagePatchTensor = $hA0xX.transpose($hA0xX.tensor4d(data, [
                                    1,
                                    width,
                                    height,
                                    3
                                ]), [
                                    0,
                                    2,
                                    1,
                                    3
                                ]).toFloat();
                                return (0, $a9222fc0440bd45a$export$a3295358bff77e)(imagePatchTensor);
                            });
                            return t;
                        })
                    ];
            }
        });
    });
}




var $hA0xX = parcelRequire("hA0xX");



function $27f31c54b04a172d$export$167f2f83f36c89eb(x, params) {
    return $hA0xX.tidy(function() {
        var convOut = (0, $c8911aec741cc229$export$e6e848830c77ef51)(x, params);
        var vectorized = $hA0xX.reshape(convOut, [
            convOut.shape[0],
            params.fc1.weights.shape[0]
        ]);
        var fc1 = (0, $674b2a159e0f1f54$export$419f910a45631e59)(vectorized, params.fc1);
        var prelu4 = (0, $9e8608e85e29e262$export$5882f235222e6729)(fc1, params.prelu4_alpha);
        var fc2_1 = (0, $674b2a159e0f1f54$export$419f910a45631e59)(prelu4, params.fc2_1);
        var max = $hA0xX.expandDims($hA0xX.max(fc2_1, 1), 1);
        var prob = $hA0xX.softmax($hA0xX.sub(fc2_1, max), 1);
        var regions = (0, $674b2a159e0f1f54$export$419f910a45631e59)(prelu4, params.fc2_2);
        var scores = $hA0xX.unstack(prob, 1)[1];
        return {
            scores: scores,
            regions: regions
        };
    });
}


function $2d673b4c07710422$export$92623bdd66d1427c(img, inputBoxes, scoreThreshold, params, stats) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var ts, rnetInputs, rnetOuts, scoresTensor, scores, _a, _b, indices, filteredBoxes, filteredScores, finalBoxes, finalScores, indicesNms, regions_1;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    ts = Date.now();
                    return [
                        4 /*yield*/ ,
                        (0, $a535e3b717ee5687$export$9b7d7f2bb2b576c3)(img, inputBoxes, {
                            width: 24,
                            height: 24
                        })
                    ];
                case 1:
                    rnetInputs = _c.sent();
                    stats.stage2_extractImagePatches = Date.now() - ts;
                    ts = Date.now();
                    rnetOuts = rnetInputs.map(function(rnetInput) {
                        var out = (0, $27f31c54b04a172d$export$167f2f83f36c89eb)(rnetInput, params);
                        rnetInput.dispose();
                        return out;
                    });
                    stats.stage2_rnet = Date.now() - ts;
                    scoresTensor = rnetOuts.length > 1 ? $hA0xX.concat(rnetOuts.map(function(out) {
                        return out.scores;
                    })) : rnetOuts[0].scores;
                    _b = (_a = Array).from;
                    return [
                        4 /*yield*/ ,
                        scoresTensor.data()
                    ];
                case 2:
                    scores = _b.apply(_a, [
                        _c.sent()
                    ]);
                    scoresTensor.dispose();
                    indices = scores.map(function(score, idx) {
                        return {
                            score: score,
                            idx: idx
                        };
                    }).filter(function(c) {
                        return c.score > scoreThreshold;
                    }).map(function(_a) {
                        var idx = _a.idx;
                        return idx;
                    });
                    filteredBoxes = indices.map(function(idx) {
                        return inputBoxes[idx];
                    });
                    filteredScores = indices.map(function(idx) {
                        return scores[idx];
                    });
                    finalBoxes = [];
                    finalScores = [];
                    if (filteredBoxes.length > 0) {
                        ts = Date.now();
                        indicesNms = (0, $e0d7a8b8653ee871$export$b7d265b19ca1d628)(filteredBoxes, filteredScores, 0.7);
                        stats.stage2_nms = Date.now() - ts;
                        regions_1 = indicesNms.map(function(idx) {
                            var regionsData = rnetOuts[indices[idx]].regions.arraySync();
                            return new (0, $d6b108c4bcaf1b20$export$bb07887006d2e314)(regionsData[0][0], regionsData[0][1], regionsData[0][2], regionsData[0][3]);
                        });
                        finalScores = indicesNms.map(function(idx) {
                            return filteredScores[idx];
                        });
                        finalBoxes = indicesNms.map(function(idx, i) {
                            return filteredBoxes[idx].calibrate(regions_1[i]);
                        });
                    }
                    rnetOuts.forEach(function(t) {
                        t.regions.dispose();
                        t.scores.dispose();
                    });
                    return [
                        2 /*return*/ ,
                        {
                            boxes: finalBoxes,
                            scores: finalScores
                        }
                    ];
            }
        });
    });
}




var $hA0xX = parcelRequire("hA0xX");





var $hA0xX = parcelRequire("hA0xX");




function $cb0f962cdc3640b7$export$1eeb6fcef754884f(x, params) {
    return $hA0xX.tidy(function() {
        var out = (0, $c8911aec741cc229$export$e6e848830c77ef51)(x, params);
        out = $hA0xX.maxPool(out, [
            2,
            2
        ], [
            2,
            2
        ], "same");
        out = (0, $0fab8badd4fa75a5$export$edca6ac2edb44105)(out, params.conv4, "valid");
        out = (0, $9e8608e85e29e262$export$5882f235222e6729)(out, params.prelu4_alpha);
        var vectorized = $hA0xX.reshape(out, [
            out.shape[0],
            params.fc1.weights.shape[0]
        ]);
        var fc1 = (0, $674b2a159e0f1f54$export$419f910a45631e59)(vectorized, params.fc1);
        var prelu5 = (0, $9e8608e85e29e262$export$5882f235222e6729)(fc1, params.prelu5_alpha);
        var fc2_1 = (0, $674b2a159e0f1f54$export$419f910a45631e59)(prelu5, params.fc2_1);
        var max = $hA0xX.expandDims($hA0xX.max(fc2_1, 1), 1);
        var prob = $hA0xX.softmax($hA0xX.sub(fc2_1, max), 1);
        var regions = (0, $674b2a159e0f1f54$export$419f910a45631e59)(prelu5, params.fc2_2);
        var points = (0, $674b2a159e0f1f54$export$419f910a45631e59)(prelu5, params.fc2_3);
        var scores = $hA0xX.unstack(prob, 1)[1];
        return {
            scores: scores,
            regions: regions,
            points: points
        };
    });
}


function $7dd400cecff0a011$export$8630b9f3b4bcf183(img, inputBoxes, scoreThreshold, params, stats) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var ts, onetInputs, onetOuts, scoresTensor, scores, _a, _b, indices, filteredRegions, filteredBoxes, filteredScores, finalBoxes, finalScores, points, indicesNms;
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_c) {
            switch(_c.label){
                case 0:
                    ts = Date.now();
                    return [
                        4 /*yield*/ ,
                        (0, $a535e3b717ee5687$export$9b7d7f2bb2b576c3)(img, inputBoxes, {
                            width: 48,
                            height: 48
                        })
                    ];
                case 1:
                    onetInputs = _c.sent();
                    stats.stage3_extractImagePatches = Date.now() - ts;
                    ts = Date.now();
                    onetOuts = onetInputs.map(function(onetInput) {
                        var out = (0, $cb0f962cdc3640b7$export$1eeb6fcef754884f)(onetInput, params);
                        onetInput.dispose();
                        return out;
                    });
                    stats.stage3_onet = Date.now() - ts;
                    scoresTensor = onetOuts.length > 1 ? $hA0xX.concat(onetOuts.map(function(out) {
                        return out.scores;
                    })) : onetOuts[0].scores;
                    _b = (_a = Array).from;
                    return [
                        4 /*yield*/ ,
                        scoresTensor.data()
                    ];
                case 2:
                    scores = _b.apply(_a, [
                        _c.sent()
                    ]);
                    scoresTensor.dispose();
                    indices = scores.map(function(score, idx) {
                        return {
                            score: score,
                            idx: idx
                        };
                    }).filter(function(c) {
                        return c.score > scoreThreshold;
                    }).map(function(_a) {
                        var idx = _a.idx;
                        return idx;
                    });
                    filteredRegions = indices.map(function(idx) {
                        var regionsData = onetOuts[idx].regions.arraySync();
                        return new (0, $d6b108c4bcaf1b20$export$bb07887006d2e314)(regionsData[0][0], regionsData[0][1], regionsData[0][2], regionsData[0][3]);
                    });
                    filteredBoxes = indices.map(function(idx, i) {
                        return inputBoxes[idx].calibrate(filteredRegions[i]);
                    });
                    filteredScores = indices.map(function(idx) {
                        return scores[idx];
                    });
                    finalBoxes = [];
                    finalScores = [];
                    points = [];
                    if (filteredBoxes.length > 0) {
                        ts = Date.now();
                        indicesNms = (0, $e0d7a8b8653ee871$export$b7d265b19ca1d628)(filteredBoxes, filteredScores, 0.7, false);
                        stats.stage3_nms = Date.now() - ts;
                        finalBoxes = indicesNms.map(function(idx) {
                            return filteredBoxes[idx];
                        });
                        finalScores = indicesNms.map(function(idx) {
                            return filteredScores[idx];
                        });
                        points = indicesNms.map(function(idx, i) {
                            return Array(5).fill(0).map(function(_, ptIdx) {
                                var pointsData = onetOuts[idx].points.arraySync();
                                return new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(pointsData[0][ptIdx] * (finalBoxes[i].width + 1) + finalBoxes[i].left, pointsData[0][ptIdx + 5] * (finalBoxes[i].height + 1) + finalBoxes[i].top);
                            });
                        });
                    }
                    onetOuts.forEach(function(t) {
                        t.regions.dispose();
                        t.scores.dispose();
                        t.points.dispose();
                    });
                    return [
                        2 /*return*/ ,
                        {
                            boxes: finalBoxes,
                            scores: finalScores,
                            points: points
                        }
                    ];
            }
        });
    });
}


var $20ad8cb82127b168$export$f66f25ab847de6b8 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(Mtcnn, _super);
    function Mtcnn() {
        return _super.call(this, "Mtcnn") || this;
    }
    Mtcnn.prototype.load = function(weightsOrUrl) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                console.warn("mtcnn is deprecated and will be removed soon");
                return [
                    2 /*return*/ ,
                    _super.prototype.load.call(this, weightsOrUrl)
                ];
            });
        });
    };
    Mtcnn.prototype.loadFromDisk = function(filePath) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                console.warn("mtcnn is deprecated and will be removed soon");
                return [
                    2 /*return*/ ,
                    _super.prototype.loadFromDisk.call(this, filePath)
                ];
            });
        });
    };
    Mtcnn.prototype.forwardInput = function(input, forwardParams) {
        if (forwardParams === void 0) forwardParams = {};
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var params, inputCanvas, stats, tsTotal, imgTensor, onReturn, _a, height, width, _b, minFaceSize, scaleFactor, maxNumScales, scoreThresholds, scaleSteps, scales, ts, out1, out2, out3, results;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        params = this.params;
                        if (!params) throw new Error("Mtcnn - load model before inference");
                        inputCanvas = input.canvases[0];
                        if (!inputCanvas) throw new Error("Mtcnn - inputCanvas is not defined, note that passing tensors into Mtcnn.forwardInput is not supported yet.");
                        stats = {};
                        tsTotal = Date.now();
                        imgTensor = $hA0xX.tidy(function() {
                            return (0, $e6c09ad793e5ccce$export$17fba901c15a5c29)($hA0xX.expandDims($hA0xX.browser.fromPixels(inputCanvas)).toFloat());
                        });
                        onReturn = function(results) {
                            // dispose tensors on return
                            imgTensor.dispose();
                            stats.total = Date.now() - tsTotal;
                            return results;
                        };
                        _a = imgTensor.shape.slice(1), height = _a[0], width = _a[1];
                        _b = new (0, $5af9889218fc5497$export$fe531e0ea63f5dc9)(forwardParams), minFaceSize = _b.minFaceSize, scaleFactor = _b.scaleFactor, maxNumScales = _b.maxNumScales, scoreThresholds = _b.scoreThresholds, scaleSteps = _b.scaleSteps;
                        scales = (scaleSteps || (0, $2cff200c9333c2f3$export$bf4478ee49b510d5)(minFaceSize, scaleFactor, [
                            height,
                            width
                        ])).filter(function(scale) {
                            var sizes = (0, $b5e4a989981b8a5c$export$4fe2ab5d97431e89)(scale, [
                                height,
                                width
                            ]);
                            return Math.min(sizes.width, sizes.height) > (0, $df78c0105b8e5f37$export$b6ba90e55ec79c0b);
                        }).slice(0, maxNumScales);
                        stats.scales = scales;
                        stats.pyramid = scales.map(function(scale) {
                            return (0, $b5e4a989981b8a5c$export$4fe2ab5d97431e89)(scale, [
                                height,
                                width
                            ]);
                        });
                        ts = Date.now();
                        return [
                            4 /*yield*/ ,
                            (0, $6c33e59271d436b1$export$136a030281f5f0af)(imgTensor, scales, scoreThresholds[0], params.pnet, stats)
                        ];
                    case 1:
                        out1 = _c.sent();
                        stats.total_stage1 = Date.now() - ts;
                        if (!out1.boxes.length) return [
                            2 /*return*/ ,
                            onReturn({
                                results: [],
                                stats: stats
                            })
                        ];
                        stats.stage2_numInputBoxes = out1.boxes.length;
                        // using the inputCanvas to extract and resize the image patches, since it is faster
                        // than doing this on the gpu
                        ts = Date.now();
                        return [
                            4 /*yield*/ ,
                            (0, $2d673b4c07710422$export$92623bdd66d1427c)(inputCanvas, out1.boxes, scoreThresholds[1], params.rnet, stats)
                        ];
                    case 2:
                        out2 = _c.sent();
                        stats.total_stage2 = Date.now() - ts;
                        if (!out2.boxes.length) return [
                            2 /*return*/ ,
                            onReturn({
                                results: [],
                                stats: stats
                            })
                        ];
                        stats.stage3_numInputBoxes = out2.boxes.length;
                        ts = Date.now();
                        return [
                            4 /*yield*/ ,
                            (0, $7dd400cecff0a011$export$8630b9f3b4bcf183)(inputCanvas, out2.boxes, scoreThresholds[2], params.onet, stats)
                        ];
                    case 3:
                        out3 = _c.sent();
                        stats.total_stage3 = Date.now() - ts;
                        results = out3.boxes.map(function(box, idx) {
                            return (0, $16a59fcb4d20ce1c$export$d990eabccad4ce39)((0, $0be2c959ccd6f649$export$637b164fcc98d63f)({}, new (0, $86da6cbb0a7a9620$export$dc77199a917e22c2)(out3.scores[idx], new (0, $aef801190ddb2db5$export$c79fc6492f3af13d)(box.left / width, box.top / height, box.width / width, box.height / height), {
                                height: height,
                                width: width
                            })), new (0, $507a61368e2b7e43$export$16e5cdff813a4f0a)(out3.points[idx].map(function(pt) {
                                return pt.sub(new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(box.left, box.top)).div(new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(box.width, box.height));
                            }), {
                                width: box.width,
                                height: box.height
                            }));
                        });
                        return [
                            2 /*return*/ ,
                            onReturn({
                                results: results,
                                stats: stats
                            })
                        ];
                }
            });
        });
    };
    Mtcnn.prototype.forward = function(input, forwardParams) {
        if (forwardParams === void 0) forwardParams = {};
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _a.apply(this, [
                                _b.sent(),
                                forwardParams
                            ])
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _b.sent().results
                        ];
                }
            });
        });
    };
    Mtcnn.prototype.forwardWithStats = function(input, forwardParams) {
        if (forwardParams === void 0) forwardParams = {};
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this.forwardInput;
                        return [
                            4 /*yield*/ ,
                            (0, $1c337d29aa263e52$export$62e8dacccc036b74)(input)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.apply(this, [
                                _b.sent(),
                                forwardParams
                            ])
                        ];
                }
            });
        });
    };
    Mtcnn.prototype.getDefaultModelName = function() {
        return "mtcnn_model";
    };
    Mtcnn.prototype.extractParamsFromWeigthMap = function(weightMap) {
        return (0, $21ae8e950d40c028$export$74edd096d8165fb0)(weightMap);
    };
    Mtcnn.prototype.extractParams = function(weights) {
        return (0, $fa8618f2ae0e3263$export$302ea4f536e3b4c5)(weights);
    };
    return Mtcnn;
}((0, $89ef56f11ec234e4$export$3a2d186bf4f565eb));







var $4f29d431d8ca4c28$export$853a06d611537d86 = 0.4;
var $4f29d431d8ca4c28$export$677cc96adb34cf6 = [
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(1.603231, 2.094468),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(6.041143, 7.080126),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(2.882459, 3.518061),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(4.266906, 5.178857),
    new (0, $055ec253cd1c6ad3$export$baf26146a414f24a)(9.041765, 10.66308)
];
var $4f29d431d8ca4c28$export$11179f7ef9978c22 = [
    117.001,
    114.697,
    97.404
];


var $37a676370850995f$export$3a02a529d987be72 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(TinyFaceDetector, _super);
    function TinyFaceDetector() {
        var _this = this;
        var config = {
            withSeparableConvs: true,
            iouThreshold: (0, $4f29d431d8ca4c28$export$853a06d611537d86),
            classes: [
                "face"
            ],
            anchors: (0, $4f29d431d8ca4c28$export$677cc96adb34cf6),
            meanRgb: (0, $4f29d431d8ca4c28$export$11179f7ef9978c22),
            isFirstLayerConv2d: true,
            filterSizes: [
                3,
                16,
                32,
                64,
                128,
                256,
                512
            ]
        };
        _this = _super.call(this, config) || this;
        return _this;
    }
    Object.defineProperty(TinyFaceDetector.prototype, "anchors", {
        get: function() {
            return this.config.anchors;
        },
        enumerable: true,
        configurable: true
    });
    TinyFaceDetector.prototype.locateFaces = function(input, forwardParams) {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var objectDetections;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.detect(input, forwardParams)
                        ];
                    case 1:
                        objectDetections = _a.sent();
                        return [
                            2 /*return*/ ,
                            objectDetections.map(function(det) {
                                return new (0, $86da6cbb0a7a9620$export$dc77199a917e22c2)(det.score, det.relativeBox, {
                                    width: det.imageWidth,
                                    height: det.imageHeight
                                });
                            })
                        ];
                }
            });
        });
    };
    TinyFaceDetector.prototype.getDefaultModelName = function() {
        return "tiny_face_detector_model";
    };
    TinyFaceDetector.prototype.extractParamsFromWeigthMap = function(weightMap) {
        return _super.prototype.extractParamsFromWeigthMap.call(this, weightMap);
    };
    return TinyFaceDetector;
}((0, $8cd1fbe2a329d1b4$export$2a42422b518ce707));



var $47da655e3ac5bac5$export$b5e37e3556a3b49c = {
    ssdMobilenetv1: new (0, $42415a77fcc9abe3$export$cfe528f380868d81)(),
    tinyFaceDetector: new (0, $37a676370850995f$export$3a02a529d987be72)(),
    tinyYolov2: new (0, $ca0bf054ceaa99a6$export$af5f44608fefb9e8)(),
    mtcnn: new (0, $20ad8cb82127b168$export$f66f25ab847de6b8)(),
    faceLandmark68Net: new (0, $b33c07f9976e510c$export$71e7113cb684e3f3)(),
    faceLandmark68TinyNet: new (0, $30951a47eb228716$export$bce9de1e20c3c0e6)(),
    faceRecognitionNet: new (0, $80eaf1ef4ca56e13$export$5a3bb00a348264dd)(),
    faceExpressionNet: new (0, $013001d7b12bc645$export$2297623eaa429f6c)(),
    ageGenderNet: new (0, $beab387d78d67b7c$export$550cd3f15456e936)()
};
var $47da655e3ac5bac5$export$8c9b8ae0ef71c85f = function(input, options) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.ssdMobilenetv1.locateFaces(input, options);
};
var $47da655e3ac5bac5$export$5fdca0fea6d67420 = function(input, options) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.tinyFaceDetector.locateFaces(input, options);
};
var $47da655e3ac5bac5$export$370cdadb7c645e76 = function(input, options) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.tinyYolov2.locateFaces(input, options);
};
var $47da655e3ac5bac5$export$1545efa8d284c32c = function(input, options) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.mtcnn.forward(input, options);
};
var $47da655e3ac5bac5$export$97afc70917762fbc = function(input) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.faceLandmark68Net.detectLandmarks(input);
};
var $47da655e3ac5bac5$export$c954857f4c80264b = function(input) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.faceLandmark68TinyNet.detectLandmarks(input);
};
var $47da655e3ac5bac5$export$92856396a3c0e51d = function(input) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.faceRecognitionNet.computeFaceDescriptor(input);
};
var $47da655e3ac5bac5$export$617cde640c689fe9 = function(input) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.faceExpressionNet.predictExpressions(input);
};
var $47da655e3ac5bac5$export$f665470363899c2c = function(input) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.ageGenderNet.predictAgeAndGender(input);
};
var $47da655e3ac5bac5$export$cb67d920bb7a4392 = function(url) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.ssdMobilenetv1.load(url);
};
var $47da655e3ac5bac5$export$eb79ccb76eb86934 = function(url) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.tinyFaceDetector.load(url);
};
var $47da655e3ac5bac5$export$1c4f2b15a95263b3 = function(url) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.mtcnn.load(url);
};
var $47da655e3ac5bac5$export$91e99b88dd66803d = function(url) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.tinyYolov2.load(url);
};
var $47da655e3ac5bac5$export$102a4eac870e6c6f = function(url) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.faceLandmark68Net.load(url);
};
var $47da655e3ac5bac5$export$c5aed07ed893f15 = function(url) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.faceLandmark68TinyNet.load(url);
};
var $47da655e3ac5bac5$export$46278355ccc3f8bc = function(url) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.faceRecognitionNet.load(url);
};
var $47da655e3ac5bac5$export$bff9ab0b2c599fc3 = function(url) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.faceExpressionNet.load(url);
};
var $47da655e3ac5bac5$export$31dbcc2ecad67858 = function(url) {
    return $47da655e3ac5bac5$export$b5e37e3556a3b49c.ageGenderNet.load(url);
};
var $47da655e3ac5bac5$export$3ced6bcc50819578 = $47da655e3ac5bac5$export$cb67d920bb7a4392;
var $47da655e3ac5bac5$export$fc4840f9370aa717 = $47da655e3ac5bac5$export$8c9b8ae0ef71c85f;
var $47da655e3ac5bac5$export$1f7d44edfda7abdd = $47da655e3ac5bac5$export$97afc70917762fbc;
















var $2beeb1137a9339a8$export$c62fb78fc140fa6f = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictFaceExpressionsTaskBase, _super);
    function PredictFaceExpressionsTaskBase(parentTask, input, extractedFaces) {
        var _this = _super.call(this) || this;
        _this.parentTask = parentTask;
        _this.input = input;
        _this.extractedFaces = extractedFaces;
        return _this;
    }
    return PredictFaceExpressionsTaskBase;
}((0, $e7ed37862deca8d2$export$ac4908c0dcb7706c));
var $2beeb1137a9339a8$export$fddc8270e6c26241 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictAllFaceExpressionsTask, _super);
    function PredictAllFaceExpressionsTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PredictAllFaceExpressionsTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parentResults, faceExpressionsByFace;
            var _this = this;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parentTask
                        ];
                    case 1:
                        parentResults = _a.sent();
                        return [
                            4 /*yield*/ ,
                            (0, $3c7b729c5e14c2ef$export$7f9e366e1b1284b9)(parentResults, this.input, function(faces) {
                                return (0, $c5ef6752615abb23$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                    return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    Promise.all(faces.map(function(face) {
                                                        return (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).faceExpressionNet.predictExpressions(face);
                                                    }))
                                                ];
                                            case 1:
                                                return [
                                                    2 /*return*/ ,
                                                    _a.sent()
                                                ];
                                        }
                                    });
                                });
                            }, this.extractedFaces)
                        ];
                    case 2:
                        faceExpressionsByFace = _a.sent();
                        return [
                            2 /*return*/ ,
                            parentResults.map(function(parentResult, i) {
                                return (0, $db9bc8639eca43c8$export$caba98c51e1a223f)(parentResult, faceExpressionsByFace[i]);
                            })
                        ];
                }
            });
        });
    };
    PredictAllFaceExpressionsTask.prototype.withAgeAndGender = function() {
        return new (0, $1a22b1a79d579a6c$export$6346b6f51dc20101)(this, this.input);
    };
    return PredictAllFaceExpressionsTask;
}($2beeb1137a9339a8$export$c62fb78fc140fa6f);
var $2beeb1137a9339a8$export$504ee62f1bd6b0af = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictSingleFaceExpressionsTask, _super);
    function PredictSingleFaceExpressionsTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PredictSingleFaceExpressionsTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parentResult, faceExpressions;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parentTask
                        ];
                    case 1:
                        parentResult = _a.sent();
                        if (!parentResult) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $3c7b729c5e14c2ef$export$2ed465c30629b069)(parentResult, this.input, function(face) {
                                return (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).faceExpressionNet.predictExpressions(face);
                            }, this.extractedFaces)
                        ];
                    case 2:
                        faceExpressions = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $db9bc8639eca43c8$export$caba98c51e1a223f)(parentResult, faceExpressions)
                        ];
                }
            });
        });
    };
    PredictSingleFaceExpressionsTask.prototype.withAgeAndGender = function() {
        return new (0, $1a22b1a79d579a6c$export$f08c803a258f49cf)(this, this.input);
    };
    return PredictSingleFaceExpressionsTask;
}($2beeb1137a9339a8$export$c62fb78fc140fa6f);
var $2beeb1137a9339a8$export$fc2b40ce4c71824 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictAllFaceExpressionsWithFaceAlignmentTask, _super);
    function PredictAllFaceExpressionsWithFaceAlignmentTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PredictAllFaceExpressionsWithFaceAlignmentTask.prototype.withAgeAndGender = function() {
        return new (0, $1a22b1a79d579a6c$export$228c1598be4262f7)(this, this.input);
    };
    PredictAllFaceExpressionsWithFaceAlignmentTask.prototype.withFaceDescriptors = function() {
        return new (0, $c5d75affb8427f13$export$56919a2d2b6f55da)(this, this.input);
    };
    return PredictAllFaceExpressionsWithFaceAlignmentTask;
}($2beeb1137a9339a8$export$fddc8270e6c26241);
var $2beeb1137a9339a8$export$9f48f0886dfbc85b = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictSingleFaceExpressionsWithFaceAlignmentTask, _super);
    function PredictSingleFaceExpressionsWithFaceAlignmentTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PredictSingleFaceExpressionsWithFaceAlignmentTask.prototype.withAgeAndGender = function() {
        return new (0, $1a22b1a79d579a6c$export$82d43b1d807d95d2)(this, this.input);
    };
    PredictSingleFaceExpressionsWithFaceAlignmentTask.prototype.withFaceDescriptor = function() {
        return new (0, $c5d75affb8427f13$export$476d67dbc7cbe35e)(this, this.input);
    };
    return PredictSingleFaceExpressionsWithFaceAlignmentTask;
}($2beeb1137a9339a8$export$504ee62f1bd6b0af);


var $1a22b1a79d579a6c$export$ce0cbb1efe69b073 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictAgeAndGenderTaskBase, _super);
    function PredictAgeAndGenderTaskBase(parentTask, input, extractedFaces) {
        var _this = _super.call(this) || this;
        _this.parentTask = parentTask;
        _this.input = input;
        _this.extractedFaces = extractedFaces;
        return _this;
    }
    return PredictAgeAndGenderTaskBase;
}((0, $e7ed37862deca8d2$export$ac4908c0dcb7706c));
var $1a22b1a79d579a6c$export$6346b6f51dc20101 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictAllAgeAndGenderTask, _super);
    function PredictAllAgeAndGenderTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PredictAllAgeAndGenderTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parentResults, ageAndGenderByFace;
            var _this = this;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parentTask
                        ];
                    case 1:
                        parentResults = _a.sent();
                        return [
                            4 /*yield*/ ,
                            (0, $3c7b729c5e14c2ef$export$7f9e366e1b1284b9)(parentResults, this.input, function(faces) {
                                return (0, $c5ef6752615abb23$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                    return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    Promise.all(faces.map(function(face) {
                                                        return (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).ageGenderNet.predictAgeAndGender(face);
                                                    }))
                                                ];
                                            case 1:
                                                return [
                                                    2 /*return*/ ,
                                                    _a.sent()
                                                ];
                                        }
                                    });
                                });
                            }, this.extractedFaces)
                        ];
                    case 2:
                        ageAndGenderByFace = _a.sent();
                        return [
                            2 /*return*/ ,
                            parentResults.map(function(parentResult, i) {
                                var _a = ageAndGenderByFace[i], age = _a.age, gender = _a.gender, genderProbability = _a.genderProbability;
                                return (0, $cc2a3ff7900b53be$export$dd983850230dc285)((0, $6c12e6a3e32f26d5$export$6c7236d62a6a2e3c)(parentResult, gender, genderProbability), age);
                            })
                        ];
                }
            });
        });
    };
    PredictAllAgeAndGenderTask.prototype.withFaceExpressions = function() {
        return new (0, $2beeb1137a9339a8$export$fddc8270e6c26241)(this, this.input);
    };
    return PredictAllAgeAndGenderTask;
}($1a22b1a79d579a6c$export$ce0cbb1efe69b073);
var $1a22b1a79d579a6c$export$f08c803a258f49cf = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictSingleAgeAndGenderTask, _super);
    function PredictSingleAgeAndGenderTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PredictSingleAgeAndGenderTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parentResult, _a, age, gender, genderProbability;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parentTask
                        ];
                    case 1:
                        parentResult = _b.sent();
                        if (!parentResult) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $3c7b729c5e14c2ef$export$2ed465c30629b069)(parentResult, this.input, function(face) {
                                return (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).ageGenderNet.predictAgeAndGender(face);
                            }, this.extractedFaces)
                        ];
                    case 2:
                        _a = _b.sent(), age = _a.age, gender = _a.gender, genderProbability = _a.genderProbability;
                        return [
                            2 /*return*/ ,
                            (0, $cc2a3ff7900b53be$export$dd983850230dc285)((0, $6c12e6a3e32f26d5$export$6c7236d62a6a2e3c)(parentResult, gender, genderProbability), age)
                        ];
                }
            });
        });
    };
    PredictSingleAgeAndGenderTask.prototype.withFaceExpressions = function() {
        return new (0, $2beeb1137a9339a8$export$504ee62f1bd6b0af)(this, this.input);
    };
    return PredictSingleAgeAndGenderTask;
}($1a22b1a79d579a6c$export$ce0cbb1efe69b073);
var $1a22b1a79d579a6c$export$228c1598be4262f7 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictAllAgeAndGenderWithFaceAlignmentTask, _super);
    function PredictAllAgeAndGenderWithFaceAlignmentTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PredictAllAgeAndGenderWithFaceAlignmentTask.prototype.withFaceExpressions = function() {
        return new (0, $2beeb1137a9339a8$export$fc2b40ce4c71824)(this, this.input);
    };
    PredictAllAgeAndGenderWithFaceAlignmentTask.prototype.withFaceDescriptors = function() {
        return new (0, $c5d75affb8427f13$export$56919a2d2b6f55da)(this, this.input);
    };
    return PredictAllAgeAndGenderWithFaceAlignmentTask;
}($1a22b1a79d579a6c$export$6346b6f51dc20101);
var $1a22b1a79d579a6c$export$82d43b1d807d95d2 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(PredictSingleAgeAndGenderWithFaceAlignmentTask, _super);
    function PredictSingleAgeAndGenderWithFaceAlignmentTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PredictSingleAgeAndGenderWithFaceAlignmentTask.prototype.withFaceExpressions = function() {
        return new (0, $2beeb1137a9339a8$export$9f48f0886dfbc85b)(this, this.input);
    };
    PredictSingleAgeAndGenderWithFaceAlignmentTask.prototype.withFaceDescriptor = function() {
        return new (0, $c5d75affb8427f13$export$476d67dbc7cbe35e)(this, this.input);
    };
    return PredictSingleAgeAndGenderWithFaceAlignmentTask;
}($1a22b1a79d579a6c$export$f08c803a258f49cf);



var $c5d75affb8427f13$export$d8b217dca88c0bb6 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(ComputeFaceDescriptorsTaskBase, _super);
    function ComputeFaceDescriptorsTaskBase(parentTask, input) {
        var _this = _super.call(this) || this;
        _this.parentTask = parentTask;
        _this.input = input;
        return _this;
    }
    return ComputeFaceDescriptorsTaskBase;
}((0, $e7ed37862deca8d2$export$ac4908c0dcb7706c));
var $c5d75affb8427f13$export$56919a2d2b6f55da = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(ComputeAllFaceDescriptorsTask, _super);
    function ComputeAllFaceDescriptorsTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComputeAllFaceDescriptorsTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parentResults, descriptors;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parentTask
                        ];
                    case 1:
                        parentResults = _a.sent();
                        return [
                            4 /*yield*/ ,
                            (0, $3c7b729c5e14c2ef$export$7f9e366e1b1284b9)(parentResults, this.input, function(faces) {
                                return Promise.all(faces.map(function(face) {
                                    return (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).faceRecognitionNet.computeFaceDescriptor(face);
                                }));
                            }, null, function(parentResult) {
                                return parentResult.landmarks.align(null, {
                                    useDlibAlignment: true
                                });
                            })
                        ];
                    case 2:
                        descriptors = _a.sent();
                        return [
                            2 /*return*/ ,
                            descriptors.map(function(descriptor, i) {
                                return (0, $436db6b74dffc32d$export$c5fea8ed5d49eb01)(parentResults[i], descriptor);
                            })
                        ];
                }
            });
        });
    };
    ComputeAllFaceDescriptorsTask.prototype.withFaceExpressions = function() {
        return new (0, $2beeb1137a9339a8$export$fc2b40ce4c71824)(this, this.input);
    };
    ComputeAllFaceDescriptorsTask.prototype.withAgeAndGender = function() {
        return new (0, $1a22b1a79d579a6c$export$228c1598be4262f7)(this, this.input);
    };
    return ComputeAllFaceDescriptorsTask;
}($c5d75affb8427f13$export$d8b217dca88c0bb6);
var $c5d75affb8427f13$export$476d67dbc7cbe35e = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(ComputeSingleFaceDescriptorTask, _super);
    function ComputeSingleFaceDescriptorTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComputeSingleFaceDescriptorTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parentResult, descriptor;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parentTask
                        ];
                    case 1:
                        parentResult = _a.sent();
                        if (!parentResult) return [
                            2 /*return*/ 
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $3c7b729c5e14c2ef$export$2ed465c30629b069)(parentResult, this.input, function(face) {
                                return (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).faceRecognitionNet.computeFaceDescriptor(face);
                            }, null, function(parentResult) {
                                return parentResult.landmarks.align(null, {
                                    useDlibAlignment: true
                                });
                            })
                        ];
                    case 2:
                        descriptor = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $436db6b74dffc32d$export$c5fea8ed5d49eb01)(parentResult, descriptor)
                        ];
                }
            });
        });
    };
    ComputeSingleFaceDescriptorTask.prototype.withFaceExpressions = function() {
        return new (0, $2beeb1137a9339a8$export$9f48f0886dfbc85b)(this, this.input);
    };
    ComputeSingleFaceDescriptorTask.prototype.withAgeAndGender = function() {
        return new (0, $1a22b1a79d579a6c$export$82d43b1d807d95d2)(this, this.input);
    };
    return ComputeSingleFaceDescriptorTask;
}($c5d75affb8427f13$export$d8b217dca88c0bb6);





var $ee9ce33f2aaad1b4$export$93a5c9d66e38aced = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(DetectFaceLandmarksTaskBase, _super);
    function DetectFaceLandmarksTaskBase(parentTask, input, useTinyLandmarkNet) {
        var _this = _super.call(this) || this;
        _this.parentTask = parentTask;
        _this.input = input;
        _this.useTinyLandmarkNet = useTinyLandmarkNet;
        return _this;
    }
    Object.defineProperty(DetectFaceLandmarksTaskBase.prototype, "landmarkNet", {
        get: function() {
            return this.useTinyLandmarkNet ? (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).faceLandmark68TinyNet : (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).faceLandmark68Net;
        },
        enumerable: true,
        configurable: true
    });
    return DetectFaceLandmarksTaskBase;
}((0, $e7ed37862deca8d2$export$ac4908c0dcb7706c));
var $ee9ce33f2aaad1b4$export$ef61863650c81169 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(DetectAllFaceLandmarksTask, _super);
    function DetectAllFaceLandmarksTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetectAllFaceLandmarksTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parentResults, detections, faces, _a, faceLandmarksByFace;
            var _this = this;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parentTask
                        ];
                    case 1:
                        parentResults = _b.sent();
                        detections = parentResults.map(function(res) {
                            return res.detection;
                        });
                        if (!(this.input instanceof $hA0xX.Tensor)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $0c146d6bc429a854$export$42290f6c8994c1ec)(this.input, detections)
                        ];
                    case 2:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $539219fdf6e46a7a$export$a6268ec9f807b452)(this.input, detections)
                        ];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        faces = _a;
                        return [
                            4 /*yield*/ ,
                            Promise.all(faces.map(function(face) {
                                return _this.landmarkNet.detectLandmarks(face);
                            }))
                        ];
                    case 6:
                        faceLandmarksByFace = _b.sent();
                        faces.forEach(function(f) {
                            return f instanceof $hA0xX.Tensor && f.dispose();
                        });
                        return [
                            2 /*return*/ ,
                            parentResults.map(function(parentResult, i) {
                                return (0, $16a59fcb4d20ce1c$export$d990eabccad4ce39)(parentResult, faceLandmarksByFace[i]);
                            })
                        ];
                }
            });
        });
    };
    DetectAllFaceLandmarksTask.prototype.withFaceExpressions = function() {
        return new (0, $2beeb1137a9339a8$export$fc2b40ce4c71824)(this, this.input);
    };
    DetectAllFaceLandmarksTask.prototype.withAgeAndGender = function() {
        return new (0, $1a22b1a79d579a6c$export$228c1598be4262f7)(this, this.input);
    };
    DetectAllFaceLandmarksTask.prototype.withFaceDescriptors = function() {
        return new (0, $c5d75affb8427f13$export$56919a2d2b6f55da)(this, this.input);
    };
    return DetectAllFaceLandmarksTask;
}($ee9ce33f2aaad1b4$export$93a5c9d66e38aced);
var $ee9ce33f2aaad1b4$export$84ce8df2652a849b = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(DetectSingleFaceLandmarksTask, _super);
    function DetectSingleFaceLandmarksTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetectSingleFaceLandmarksTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parentResult, detection, faces, _a, landmarks;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parentTask
                        ];
                    case 1:
                        parentResult = _b.sent();
                        if (!parentResult) return [
                            2 /*return*/ 
                        ];
                        detection = parentResult.detection;
                        if (!(this.input instanceof $hA0xX.Tensor)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $0c146d6bc429a854$export$42290f6c8994c1ec)(this.input, [
                                detection
                            ])
                        ];
                    case 2:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $539219fdf6e46a7a$export$a6268ec9f807b452)(this.input, [
                                detection
                            ])
                        ];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        faces = _a;
                        return [
                            4 /*yield*/ ,
                            this.landmarkNet.detectLandmarks(faces[0])
                        ];
                    case 6:
                        landmarks = _b.sent();
                        faces.forEach(function(f) {
                            return f instanceof $hA0xX.Tensor && f.dispose();
                        });
                        return [
                            2 /*return*/ ,
                            (0, $16a59fcb4d20ce1c$export$d990eabccad4ce39)(parentResult, landmarks)
                        ];
                }
            });
        });
    };
    DetectSingleFaceLandmarksTask.prototype.withFaceExpressions = function() {
        return new (0, $2beeb1137a9339a8$export$9f48f0886dfbc85b)(this, this.input);
    };
    DetectSingleFaceLandmarksTask.prototype.withAgeAndGender = function() {
        return new (0, $1a22b1a79d579a6c$export$82d43b1d807d95d2)(this, this.input);
    };
    DetectSingleFaceLandmarksTask.prototype.withFaceDescriptor = function() {
        return new (0, $c5d75affb8427f13$export$476d67dbc7cbe35e)(this, this.input);
    };
    return DetectSingleFaceLandmarksTask;
}($ee9ce33f2aaad1b4$export$93a5c9d66e38aced);





var $fb6f2e7c9418fc81$export$8f413eaf31daee78 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(DetectFacesTaskBase, _super);
    function DetectFacesTaskBase(input, options) {
        if (options === void 0) options = new (0, $5494815e9839434a$export$7750daea02ba9089)();
        var _this = _super.call(this) || this;
        _this.input = input;
        _this.options = options;
        return _this;
    }
    return DetectFacesTaskBase;
}((0, $e7ed37862deca8d2$export$ac4908c0dcb7706c));
var $fb6f2e7c9418fc81$export$2d3c2b93bce51d5c = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(DetectAllFacesTask, _super);
    function DetectAllFacesTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetectAllFacesTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a, input, options, faceDetectionFunction;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this, input = _a.input, options = _a.options;
                        if (!(options instanceof (0, $5af9889218fc5497$export$fe531e0ea63f5dc9))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).mtcnn.forward(input, options)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent().map(function(result) {
                                return result.detection;
                            })
                        ];
                    case 2:
                        faceDetectionFunction = options instanceof (0, $3d7825a9e6f5efa9$export$10bee5cd93f5f680) ? function(input) {
                            return (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).tinyFaceDetector.locateFaces(input, options);
                        } : options instanceof (0, $5494815e9839434a$export$7750daea02ba9089) ? function(input) {
                            return (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).ssdMobilenetv1.locateFaces(input, options);
                        } : options instanceof (0, $d38b10cc96a92653$export$b4f9bf3a27d6056) ? function(input) {
                            return (0, $47da655e3ac5bac5$export$b5e37e3556a3b49c).tinyYolov2.locateFaces(input, options);
                        } : null;
                        if (!faceDetectionFunction) throw new Error("detectFaces - expected options to be instance of TinyFaceDetectorOptions | SsdMobilenetv1Options | MtcnnOptions | TinyYolov2Options");
                        return [
                            2 /*return*/ ,
                            faceDetectionFunction(input)
                        ];
                }
            });
        });
    };
    DetectAllFacesTask.prototype.runAndExtendWithFaceDetections = function() {
        var _this = this;
        return new Promise(function(res) {
            return (0, $c5ef6752615abb23$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var detections;
                return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.run()
                            ];
                        case 1:
                            detections = _a.sent();
                            return [
                                2 /*return*/ ,
                                res(detections.map(function(detection) {
                                    return (0, $0be2c959ccd6f649$export$637b164fcc98d63f)({}, detection);
                                }))
                            ];
                    }
                });
            });
        });
    };
    DetectAllFacesTask.prototype.withFaceLandmarks = function(useTinyLandmarkNet) {
        if (useTinyLandmarkNet === void 0) useTinyLandmarkNet = false;
        return new (0, $ee9ce33f2aaad1b4$export$ef61863650c81169)(this.runAndExtendWithFaceDetections(), this.input, useTinyLandmarkNet);
    };
    DetectAllFacesTask.prototype.withFaceExpressions = function() {
        return new (0, $2beeb1137a9339a8$export$fddc8270e6c26241)(this.runAndExtendWithFaceDetections(), this.input);
    };
    DetectAllFacesTask.prototype.withAgeAndGender = function() {
        return new (0, $1a22b1a79d579a6c$export$6346b6f51dc20101)(this.runAndExtendWithFaceDetections(), this.input);
    };
    return DetectAllFacesTask;
}($fb6f2e7c9418fc81$export$8f413eaf31daee78);
var $fb6f2e7c9418fc81$export$b0d065005d94b9a4 = /** @class */ function(_super) {
    (0, $c5ef6752615abb23$export$a8ba968b8961cb8a)(DetectSingleFaceTask, _super);
    function DetectSingleFaceTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DetectSingleFaceTask.prototype.run = function() {
        return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var faceDetections, faceDetectionWithHighestScore;
            return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            new $fb6f2e7c9418fc81$export$2d3c2b93bce51d5c(this.input, this.options)
                        ];
                    case 1:
                        faceDetections = _a.sent();
                        faceDetectionWithHighestScore = faceDetections[0];
                        faceDetections.forEach(function(faceDetection) {
                            if (faceDetection.score > faceDetectionWithHighestScore.score) faceDetectionWithHighestScore = faceDetection;
                        });
                        return [
                            2 /*return*/ ,
                            faceDetectionWithHighestScore
                        ];
                }
            });
        });
    };
    DetectSingleFaceTask.prototype.runAndExtendWithFaceDetection = function() {
        var _this = this;
        return new Promise(function(res) {
            return (0, $c5ef6752615abb23$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var detection;
                return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.run()
                            ];
                        case 1:
                            detection = _a.sent();
                            return [
                                2 /*return*/ ,
                                res(detection ? (0, $0be2c959ccd6f649$export$637b164fcc98d63f)({}, detection) : undefined)
                            ];
                    }
                });
            });
        });
    };
    DetectSingleFaceTask.prototype.withFaceLandmarks = function(useTinyLandmarkNet) {
        if (useTinyLandmarkNet === void 0) useTinyLandmarkNet = false;
        return new (0, $ee9ce33f2aaad1b4$export$84ce8df2652a849b)(this.runAndExtendWithFaceDetection(), this.input, useTinyLandmarkNet);
    };
    DetectSingleFaceTask.prototype.withFaceExpressions = function() {
        return new (0, $2beeb1137a9339a8$export$504ee62f1bd6b0af)(this.runAndExtendWithFaceDetection(), this.input);
    };
    DetectSingleFaceTask.prototype.withAgeAndGender = function() {
        return new (0, $1a22b1a79d579a6c$export$f08c803a258f49cf)(this.runAndExtendWithFaceDetection(), this.input);
    };
    return DetectSingleFaceTask;
}($fb6f2e7c9418fc81$export$8f413eaf31daee78);


function $9cc9424c1d17c458$export$312baa2523ca74e3(input, options) {
    if (options === void 0) options = new (0, $5494815e9839434a$export$7750daea02ba9089)();
    return new (0, $fb6f2e7c9418fc81$export$b0d065005d94b9a4)(input, options);
}
function $9cc9424c1d17c458$export$61533b6593f94842(input, options) {
    if (options === void 0) options = new (0, $5494815e9839434a$export$7750daea02ba9089)();
    return new (0, $fb6f2e7c9418fc81$export$2d3c2b93bce51d5c)(input, options);
}


function $8db4a9de64707ac0$export$2bacb29ff9491fc0(input, minConfidence) {
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    console.warn("allFacesSsdMobilenetv1 is deprecated and will be removed soon, use the high level api instead");
                    return [
                        4 /*yield*/ ,
                        (0, $9cc9424c1d17c458$export$61533b6593f94842)(input, new (0, $5494815e9839434a$export$7750daea02ba9089)(minConfidence ? {
                            minConfidence: minConfidence
                        } : {})).withFaceLandmarks().withFaceDescriptors()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}
function $8db4a9de64707ac0$export$127f3aacf01730a2(input, forwardParams) {
    if (forwardParams === void 0) forwardParams = {};
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    console.warn("allFacesTinyYolov2 is deprecated and will be removed soon, use the high level api instead");
                    return [
                        4 /*yield*/ ,
                        (0, $9cc9424c1d17c458$export$61533b6593f94842)(input, new (0, $d38b10cc96a92653$export$b4f9bf3a27d6056)(forwardParams)).withFaceLandmarks().withFaceDescriptors()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}
function $8db4a9de64707ac0$export$53ac2f195b750853(input, forwardParams) {
    if (forwardParams === void 0) forwardParams = {};
    return (0, $c5ef6752615abb23$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $c5ef6752615abb23$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    console.warn("allFacesMtcnn is deprecated and will be removed soon, use the high level api instead");
                    return [
                        4 /*yield*/ ,
                        (0, $9cc9424c1d17c458$export$61533b6593f94842)(input, new (0, $5af9889218fc5497$export$fe531e0ea63f5dc9)(forwardParams)).withFaceLandmarks().withFaceDescriptors()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}
var $8db4a9de64707ac0$export$1f85396cafda6ffb = $8db4a9de64707ac0$export$2bacb29ff9491fc0;









function $ba18760c1818d294$export$a5235d323d0269f3(arr1, arr2) {
    if (arr1.length !== arr2.length) throw new Error("euclideanDistance: arr1.length !== arr2.length");
    var desc1 = Array.from(arr1);
    var desc2 = Array.from(arr2);
    return Math.sqrt(desc1.map(function(val, i) {
        return val - desc2[i];
    }).reduce(function(res, diff) {
        return res + Math.pow(diff, 2);
    }, 0));
}


var $e73575217171cc2e$export$8610947fe8728c24 = /** @class */ function() {
    function FaceMatcher(inputs, distanceThreshold) {
        if (distanceThreshold === void 0) distanceThreshold = 0.6;
        this._distanceThreshold = distanceThreshold;
        var inputArray = Array.isArray(inputs) ? inputs : [
            inputs
        ];
        if (!inputArray.length) throw new Error("FaceRecognizer.constructor - expected atleast one input");
        var count = 1;
        var createUniqueLabel = function() {
            return "person " + count++;
        };
        this._labeledDescriptors = inputArray.map(function(desc) {
            if (desc instanceof (0, $2eb798887d9813d6$export$716a745f210bce1a)) return desc;
            if (desc instanceof Float32Array) return new (0, $2eb798887d9813d6$export$716a745f210bce1a)(createUniqueLabel(), [
                desc
            ]);
            if (desc.descriptor && desc.descriptor instanceof Float32Array) return new (0, $2eb798887d9813d6$export$716a745f210bce1a)(createUniqueLabel(), [
                desc.descriptor
            ]);
            throw new Error("FaceRecognizer.constructor - expected inputs to be of type LabeledFaceDescriptors | WithFaceDescriptor<any> | Float32Array | Array<LabeledFaceDescriptors | WithFaceDescriptor<any> | Float32Array>");
        });
    }
    Object.defineProperty(FaceMatcher.prototype, "labeledDescriptors", {
        get: function() {
            return this._labeledDescriptors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FaceMatcher.prototype, "distanceThreshold", {
        get: function() {
            return this._distanceThreshold;
        },
        enumerable: true,
        configurable: true
    });
    FaceMatcher.prototype.computeMeanDistance = function(queryDescriptor, descriptors) {
        return descriptors.map(function(d) {
            return (0, $ba18760c1818d294$export$a5235d323d0269f3)(d, queryDescriptor);
        }).reduce(function(d1, d2) {
            return d1 + d2;
        }, 0) / (descriptors.length || 1);
    };
    FaceMatcher.prototype.matchDescriptor = function(queryDescriptor) {
        var _this = this;
        return this.labeledDescriptors.map(function(_a) {
            var descriptors = _a.descriptors, label = _a.label;
            return new (0, $e9730e5e0c01d652$export$458f566a73b40a79)(label, _this.computeMeanDistance(queryDescriptor, descriptors));
        }).reduce(function(best, curr) {
            return best.distance < curr.distance ? best : curr;
        });
    };
    FaceMatcher.prototype.findBestMatch = function(queryDescriptor) {
        var bestMatch = this.matchDescriptor(queryDescriptor);
        return bestMatch.distance < this.distanceThreshold ? bestMatch : new (0, $e9730e5e0c01d652$export$458f566a73b40a79)("unknown", bestMatch.distance);
    };
    FaceMatcher.prototype.toJSON = function() {
        return {
            distanceThreshold: this.distanceThreshold,
            labeledDescriptors: this.labeledDescriptors.map(function(ld) {
                return ld.toJSON();
            })
        };
    };
    FaceMatcher.fromJSON = function(json) {
        var labeledDescriptors = json.labeledDescriptors.map(function(ld) {
            return (0, $2eb798887d9813d6$export$716a745f210bce1a).fromJSON(ld);
        });
        return new FaceMatcher(labeledDescriptors, json.distanceThreshold);
    };
    return FaceMatcher;
}();







function $8df4bda5b710ae48$export$6418c12181c82ae7(weights) {
    var net = new (0, $20ad8cb82127b168$export$f66f25ab847de6b8)();
    net.extractWeights(weights);
    return net;
}






function $1420dfab922186c1$export$9ef82b3f7678cef4(weights) {
    var net = new (0, $37a676370850995f$export$3a02a529d987be72)();
    net.extractWeights(weights);
    return net;
}










function $e3ba42da63819421$export$551f3cff336285e1(results, dimensions) {
    var _a = new (0, $95d2ae67e35f5d9d$export$d5b8c1948b345816)(dimensions.width, dimensions.height), width = _a.width, height = _a.height;
    if (width <= 0 || height <= 0) throw new Error("resizeResults - invalid dimensions: " + JSON.stringify({
        width: width,
        height: height
    }));
    if (Array.isArray(results)) return results.map(function(obj) {
        return $e3ba42da63819421$export$551f3cff336285e1(obj, {
            width: width,
            height: height
        });
    });
    if ((0, $16a59fcb4d20ce1c$export$51efdc1ea20f6714)(results)) {
        var resizedDetection = results.detection.forSize(width, height);
        var resizedLandmarks = results.unshiftedLandmarks.forSize(resizedDetection.box.width, resizedDetection.box.height);
        return (0, $16a59fcb4d20ce1c$export$d990eabccad4ce39)((0, $0be2c959ccd6f649$export$637b164fcc98d63f)(results, resizedDetection), resizedLandmarks);
    }
    if ((0, $0be2c959ccd6f649$export$2dad0453743890bf)(results)) return (0, $0be2c959ccd6f649$export$637b164fcc98d63f)(results, results.detection.forSize(width, height));
    if (results instanceof (0, $cf4d8aca6a25dc8f$export$a2e672dd92b622a7) || results instanceof (0, $86da6cbb0a7a9620$export$dc77199a917e22c2)) return results.forSize(width, height);
    return results;
}





const $cd5b106c2dfcc0b3$var$rotate = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  100% { transform: rotate(1turn); }
`;
const $cd5b106c2dfcc0b3$var$LoaderWrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 80px;
  aspect-ratio: 1;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE} 94%, #0000) top/8px 8px no-repeat,
    conic-gradient(#0000 30%, ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE});
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: ${$cd5b106c2dfcc0b3$var$rotate} 1s infinite linear;
`;
var $cd5b106c2dfcc0b3$var$KycProgress;
(function(KycProgress) {
    KycProgress[KycProgress["INITIAL"] = 0] = "INITIAL";
    KycProgress[KycProgress["CHOICE"] = 1] = "CHOICE";
    KycProgress[KycProgress["DOCUMENT"] = 2] = "DOCUMENT";
    KycProgress[KycProgress["SELFIE"] = 3] = "SELFIE";
})($cd5b106c2dfcc0b3$var$KycProgress || ($cd5b106c2dfcc0b3$var$KycProgress = {}));
var $cd5b106c2dfcc0b3$var$DocumentType;
(function(DocumentType) {
    DocumentType["PASSPORT"] = "passport";
    DocumentType["ID_CARD"] = "id_card";
    DocumentType["DRIVER_LICENSE"] = "driver_license";
})($cd5b106c2dfcc0b3$var$DocumentType || ($cd5b106c2dfcc0b3$var$DocumentType = {}));
var $cd5b106c2dfcc0b3$var$PaymentStatus;
(function(PaymentStatus) {
    PaymentStatus["INITIAL"] = "initial";
    PaymentStatus["KYC"] = "kyc";
    PaymentStatus["WAITING"] = "waiting";
    PaymentStatus["SUCCESS"] = "success";
    PaymentStatus["ERROR"] = "error";
})($cd5b106c2dfcc0b3$var$PaymentStatus || ($cd5b106c2dfcc0b3$var$PaymentStatus = {}));
const $cd5b106c2dfcc0b3$var$KycView = ({ setOpenbankPayStatus: setOpenbankPayStatus, ...props })=>{
    const videoRef = (0, $bnENU.useRef)(null);
    const inputRef = (0, $bnENU.useRef)(null);
    const [countdown, setCountdown] = (0, $bnENU.useState)(null);
    const countdownRef = (0, $bnENU.useRef)(null);
    const countdownValueRef = (0, $bnENU.useRef)(3);
    const stableStartRef = (0, $bnENU.useRef)(null);
    const [modelsLoaded, setModelsLoaded] = (0, $bnENU.useState)(false);
    const [progressValue, setProgressValue] = (0, $bnENU.useState)(0);
    const [documentType, setDocumentType] = (0, $bnENU.useState)();
    const [documentTypeState, setDocumentTypeState] = (0, $bnENU.useState)();
    const [kycData, setKycData] = (0, $bnENU.useState)({
        selfieImage: "",
        selfieImageFile: null,
        passportImage: "",
        passportImageFile: null,
        idcardImage: "",
        idcardImageFile: null
    });
    (0, $bnENU.useEffect)(()=>{
        // M.AutoInit()
        loadModels();
    }, []);
    const startVideo = async ()=>{
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {}
            });
            if (videoRef.current) videoRef.current.srcObject = stream;
        } catch (error) {
            console.error("Error accessing webcam:", error);
        }
    };
    const stopVideo = ()=>{
        const stream = videoRef.current.srcObject;
        const tracks = stream.getTracks();
        tracks.forEach((track)=>{
            track.stop();
        });
    };
    const toBase64 = async (file)=>await new Promise((resolve, reject)=>{
            if (!(file instanceof Blob)) return reject(new TypeError("Provided input is not a Blob or File."));
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = ()=>{
                const result = reader.result;
                const base64 = result.split(",")[1];
                resolve(base64);
            };
            reader.onerror = (error)=>reject(error);
        });
    const loadModels = async ()=>{
        try {
            await $47da655e3ac5bac5$export$b5e37e3556a3b49c.tinyFaceDetector.loadFromUri("/models");
            setModelsLoaded(true) // 设置模型加载完成
            ;
            console.log("Models loaded");
        } catch (error) {
            console.log(error);
            console.error("Error loading models:", error);
        }
    };
    const onPlay = async ()=>{
        if (!modelsLoaded || !videoRef.current || videoRef.current.paused || videoRef.current.ended) {
            setTimeout(onPlay, 100);
            return;
        }
        const options = new $3d7825a9e6f5efa9$export$10bee5cd93f5f680({
            inputSize: 128,
            scoreThreshold: 0.5
        });
        const result = await $9cc9424c1d17c458$export$312baa2523ca74e3(videoRef.current, options);
        const score = result?.score ?? 0;
        setProgressValue(score * 100);
        if (score > 0.6) {
            if (countdown === null && countdownRef.current === null) {
                countdownValueRef.current = 3;
                setCountdown(3);
                countdownRef.current = setInterval(()=>{
                    countdownValueRef.current -= 1;
                    if (countdownValueRef.current > 0) setCountdown(countdownValueRef.current);
                    else {
                        clearInterval(countdownRef.current);
                        countdownRef.current = null;
                        setCountdown(null);
                        const canvas = document.createElement("canvas");
                        const video = videoRef.current;
                        if (!canvas || !video) return;
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;
                        const ctx = canvas.getContext("2d");
                        if (ctx) {
                            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                            canvas.toBlob((blob)=>{
                                if (blob) {
                                    const file = new File([
                                        blob
                                    ], "selfie.png", {
                                        type: "image/png"
                                    });
                                    const tempUrl = URL.createObjectURL(file);
                                    setProgressValue(0);
                                    toBase64(file).then((d)=>{
                                        setKycData({
                                            ...kycData,
                                            selfieImage: tempUrl,
                                            selfieImageFile: file
                                        });
                                        props.onChange({
                                            imageFile: d,
                                            kycType: 3
                                        });
                                        stopVideo();
                                    });
                                }
                            }, "image/png");
                        }
                    }
                }, 1000);
            }
        } else {
            // 中断倒计时
            if (countdownRef.current) {
                clearInterval(countdownRef.current);
                countdownRef.current = null;
            }
            setCountdown(null);
            countdownValueRef.current = 3;
        }
        if (!kycData.selfieImage) setTimeout(onPlay, 100);
    };
    const onFileChange = async (event)=>{
        const fileList = event.target.files;
        const file = fileList?.[0];
        if (!file?.type?.startsWith("image")) return;
        const toBase64 = async (file)=>await new Promise((resolve, reject)=>{
                if (!(file instanceof Blob)) return reject(new TypeError("Provided input is not a Blob or File."));
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = ()=>{
                    const result = reader.result;
                    const base64 = result.split(",")[1];
                    resolve(base64);
                };
                reader.onerror = (error)=>reject(error);
            });
        try {
            const base64String = await toBase64(file);
            const imageUrl = URL.createObjectURL(file);
            if (currentProgress === 2) {
                props.onChange({
                    imageFile: base64String,
                    kycType: 2,
                    documentType: documentType
                });
                if (documentType === "id_card") setKycData({
                    ...kycData,
                    idcardImage: imageUrl,
                    idcardImageFile: file
                });
                if (documentType === "passport") setKycData({
                    ...kycData,
                    passportImage: imageUrl,
                    passportImageFile: file
                });
            }
        } catch (err) {
            console.error("Failed to convert image to base64:", err);
        } finally{}
    };
    const back = ()=>{
        if (currentProgress === 3) setCurrentProgress(2);
        if (currentProgress === 2) {
            setDocumentType(undefined);
            setDocumentTypeState(undefined);
            setCurrentProgress(0);
        }
        if (currentProgress === 0) props.onBack();
    };
    const [currentProgress, setCurrentProgress] = (0, $bnENU.useState)(0);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $0ce5a428e300b80d$export$42a852a2b6b56249), {
        style: {
            margin: "initial",
            position: "relative",
            padding: 0,
            width: props.minWidth ?? 450,
            maxWidth: "100%",
            minHeight: props.minHeight ?? 500,
            height: "100%"
        },
        children: [
            currentProgress === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            overflowY: "auto",
                            display: "flex",
                            flexDirection: "column",
                            gap: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                        fontSize: 16,
                                        fontWeight: 500,
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: 20
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                            onClick: back,
                                            style: {
                                                cursor: "pointer",
                                                minWidth: 20,
                                                transform: "rotate(90deg)"
                                            }
                                        }),
                                        "Let's get your KYC verified"
                                    ]
                                })
                            }),
                            props.kycTips && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).INFO_LIGHT,
                                    padding: 20,
                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                    borderRadius: 10,
                                    fontSize: 14
                                },
                                children: props.kycTips
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: 10,
                                    gap: 20
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    borderRadius: "50%",
                                                    background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK,
                                                    padding: 10,
                                                    height: 50,
                                                    width: 50,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $78ada9a78e9ecf07$export$2e2bcd8739ae039), {
                                                    style: {
                                                        height: 20
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    marginLeft: 10,
                                                    fontSize: 14
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                            marginBottom: 5
                                                        },
                                                        children: "Step 1"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        children: "Provide identity document"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    borderRadius: "50%",
                                                    background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK,
                                                    padding: 10,
                                                    height: 50,
                                                    width: 50,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                },
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $61870e8b986a56a3$export$2e2bcd8739ae039), {
                                                    style: {
                                                        height: 13
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    marginLeft: 10,
                                                    fontSize: 14
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                            marginBottom: 5
                                                        },
                                                        children: "Step 2"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        children: "Get ready for a live face scan"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        style: {
                            position: "sticky",
                            bottom: 0,
                            padding: 20
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                            style: {
                                width: "100%"
                            },
                            onClick: ()=>{
                                setCurrentProgress(2);
                            },
                            children: "Ready to start"
                        })
                    })
                ]
            }),
            currentProgress === 2 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                flex: 1,
                                overflowY: "auto",
                                display: "flex",
                                gap: 20,
                                flexDirection: "column"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                            fontSize: 16,
                                            fontWeight: 600,
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                                onClick: back,
                                                style: {
                                                    cursor: "pointer",
                                                    minWidth: 20,
                                                    transform: "rotate(90deg)"
                                                }
                                            }),
                                            "Upload your ID Card/Passport"
                                        ]
                                    })
                                }),
                                props.kycTips && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                    style: {
                                        background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).INFO_LIGHT,
                                        padding: 20,
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                        borderRadius: 10,
                                        fontSize: 14,
                                        marginBottom: 30
                                    },
                                    children: props.kycTips
                                }),
                                (documentTypeState === "passport" || documentTypeState === "id_card") && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                border: "1px dashed #ccc",
                                                padding: 20,
                                                borderRadius: 10,
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            },
                                            children: [
                                                !(kycData.passportImage || kycData.idcardImage) && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                    style: {
                                                        fontSize: 14,
                                                        width: "100%",
                                                        height: 100,
                                                        backgroundColor: "transparent",
                                                        border: "none",
                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        padding: 0,
                                                        gap: 5,
                                                        position: "sticky"
                                                    },
                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("label", {
                                                        style: {
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 5
                                                        },
                                                        children: [
                                                            kycData.passportImage || "Upload ID card/Passport",
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $2ed2b40f76b02664$export$2e2bcd8739ae039), {
                                                                stroke: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                                style: {
                                                                    width: 18,
                                                                    height: 18
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("input", {
                                                                type: "file",
                                                                accept: ".png, .jpg, .jpeg",
                                                                onChange: onFileChange,
                                                                style: {
                                                                    opacity: 0,
                                                                    cursor: "pointer",
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: 0,
                                                                    right: 0,
                                                                    bottom: 0
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }),
                                                kycData.passportImage && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                    onClick: ()=>{
                                                        setKycData({
                                                            ...kycData,
                                                            passportImage: "",
                                                            passportImageFile: null
                                                        });
                                                    },
                                                    src: kycData.passportImage,
                                                    style: {
                                                        width: "100%",
                                                        height: "auto",
                                                        borderRadius: 10
                                                    }
                                                }),
                                                kycData.idcardImage && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                    onClick: ()=>{
                                                        setKycData({
                                                            ...kycData,
                                                            idcardImage: "",
                                                            idcardImageFile: null
                                                        });
                                                    },
                                                    src: kycData.idcardImage,
                                                    style: {
                                                        width: "100%",
                                                        height: "auto",
                                                        borderRadius: 10
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 10,
                                                fontSize: 14,
                                                marginTop: 20,
                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).INPUT_PLACEHOLDER
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        marginTop: 5,
                                                        marginBottom: 5,
                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY4
                                                    },
                                                    children: "Guide for ID Card Scan"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    children: "1. Make sure your uploaded image is clear and the entire document is visible."
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    children: "2. Ensure all letters are visible and the image is not blurry"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    children: "3. Make sure your ID document is a valid government issued ID and has not expired."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !documentTypeState && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10,
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("h4", {
                                                children: "Select your document type"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    gap: 10,
                                                    alignContent: "center",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                    background: "white",
                                                    padding: 10,
                                                    paddingLeft: 20,
                                                    paddingRight: 20,
                                                    borderRadius: 10,
                                                    fontSize: 14,
                                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                },
                                                onClick: ()=>{
                                                    setDocumentType("id_card");
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        children: "ID card"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $f56970af37249378$export$2e2bcd8739ae039), {
                                                        isRadio: true,
                                                        checked: documentType === "id_card"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    gap: 10,
                                                    alignContent: "center",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                    background: "white",
                                                    padding: 10,
                                                    paddingLeft: 20,
                                                    paddingRight: 20,
                                                    borderRadius: 10,
                                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                },
                                                onClick: ()=>{
                                                    setDocumentType("passport");
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        children: "Passport"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $f56970af37249378$export$2e2bcd8739ae039), {
                                                        isRadio: true,
                                                        checked: documentType === "passport"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                            style: {
                                position: "sticky",
                                marginTop: 30,
                                bottom: 0,
                                width: "100%"
                            },
                            disabled: !documentTypeState ? !documentType : !(kycData.passportImage || kycData.idcardImage),
                            onClick: ()=>{
                                if (documentTypeState) {
                                    setCurrentProgress(3);
                                    startVideo();
                                }
                                if (documentType) setDocumentTypeState(documentType);
                            },
                            children: !documentTypeState ? "Next 1/3" : "Next 2/3"
                        })
                    ]
                })
            }),
            currentProgress === 3 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            position: "relative",
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                    fontSize: 16,
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                        onClick: back,
                                        style: {
                                            cursor: "pointer",
                                            minWidth: 20,
                                            transform: "rotate(90deg)"
                                        }
                                    }),
                                    "Take your Selfie"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    marginTop: 5,
                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY4
                                },
                                children: "Guide for Selfie"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            overflowY: "auto"
                        },
                        children: [
                            props.kycTips && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).INFO_LIGHT,
                                    padding: 20,
                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                    borderRadius: 10,
                                    fontSize: 14,
                                    marginBottom: 30
                                },
                                children: props.kycTips
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    alignContent: "center",
                                    justifyContent: "center",
                                    paddingTop: 20
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        position: "relative",
                                        width: 300,
                                        height: 400,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                position: "absolute",
                                                width: "105%",
                                                height: "103%",
                                                borderRadius: "47%",
                                                opacity: 0.7,
                                                background: `conic-gradient(
      ${progressValue < 30 ? "#FF4C4C" : progressValue < 70 ? "#FFD700" : (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS} ${progressValue - 5}%,
      rgba(245, 246, 246, 0.5) ${progressValue}%,
      rgb(245, 246, 246) ${progressValue + 5}% 100%
    )`,
                                                boxShadow: `0 0 20px 5px rgba(${progressValue < 30 ? "0, 0, 0" : progressValue < 70 ? "255, 215, 0" : "0, 255, 0"}, 0.15)`,
                                                filter: "blur(1px)",
                                                zIndex: 1,
                                                transition: "all 1.5s cubic-bezier(0.4, 0, 0.2, 1)"
                                            }
                                        }),
                                        countdown !== null && !kycData.selfieImage && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                background: "rgba(0,0,0,0.2)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                zIndex: 5,
                                                borderRadius: "50%",
                                                color: "white",
                                                fontSize: 48,
                                                fontWeight: 700
                                            },
                                            children: countdown
                                        }),
                                        !kycData.selfieImage && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("video", {
                                            width: 500,
                                            ref: videoRef,
                                            onLoadedMetadata: onPlay,
                                            autoPlay: true,
                                            muted: true,
                                            playsInline: true,
                                            // hidden
                                            id: "inputVideo",
                                            // hidden
                                            style: {
                                                borderRadius: "47%",
                                                width: 300,
                                                height: 400,
                                                objectFit: "cover",
                                                position: "relative",
                                                zIndex: 2 // 确保视频在进度条上方
                                            }
                                        }),
                                        kycData.selfieImage && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                            src: kycData.selfieImage,
                                            style: {
                                                width: 300,
                                                height: 400,
                                                borderRadius: "45%",
                                                objectFit: "cover",
                                                position: "relative",
                                                zIndex: 2
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                style: {
                                    display: "block",
                                    textAlign: "center",
                                    width: "100%",
                                    marginTop: 50,
                                    borderRadius: 25,
                                    background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY8,
                                    fontSize: 16,
                                    fontWeight: 500,
                                    color: "black",
                                    padding: 15,
                                    border: "none" // 确保按钮内文字居中
                                },
                                onClick: ()=>{
                                    startVideo();
                                    setKycData({
                                        ...kycData,
                                        selfieImage: "",
                                        selfieImageFile: null
                                    });
                                },
                                children: "Retake"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                        style: {
                            width: "100%"
                        },
                        disabled: !kycData.selfieImage || !kycData.passportImage && !kycData.idcardImage,
                        onClick: props.onSubmit,
                        children: "Continue to Payment"
                    })
                ]
            })
        ]
    });
};
var $cd5b106c2dfcc0b3$export$2e2bcd8739ae039 = $cd5b106c2dfcc0b3$var$KycView;



var $fDWVA = parcelRequire("fDWVA");

parcelRequire("bnENU");

const $df059e440c9a1479$var$Dash = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  to {
    stroke-dashoffset: 0;
  }
`;
const $df059e440c9a1479$var$AnimatedLine = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).line`
  animation: ${$df059e440c9a1479$var$Dash} ${({ animationSpeed: animationSpeed })=>animationSpeed} cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards;
  animation-delay: ${({ animationDelay: animationDelay })=>animationDelay};
`;
function $df059e440c9a1479$var$Crossmark({ animationDelay: animationDelay = "0.05s", animationSpeed: animationSpeed = "0.15s", ...props }) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        width: "52",
        height: "52",
        viewBox: "0 0 52 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        strokeWidth: 4,
        stroke: "white",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($df059e440c9a1479$var$AnimatedLine, {
                x1: "16",
                y1: "16",
                x2: "36",
                y2: "36",
                strokeDasharray: 28.28,
                strokeDashoffset: 28.28,
                animationDelay: animationDelay,
                animationSpeed: animationSpeed
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($df059e440c9a1479$var$AnimatedLine, {
                x1: "36",
                y1: "16",
                x2: "16",
                y2: "36",
                strokeDasharray: 28.28,
                strokeDashoffset: 28.28,
                animationDelay: `calc(${animationDelay} + ${animationSpeed})`,
                animationSpeed: animationSpeed
            })
        ]
    });
}
var $df059e440c9a1479$export$2e2bcd8739ae039 = $df059e440c9a1479$var$Crossmark;



parcelRequire("bnENU");

const $6dac766084d8c11a$var$Rotate = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  100% {
    transform: rotate(360deg);
  }
`;
const $6dac766084d8c11a$var$SpinnerCircle = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).circle`
  stroke-dasharray: 80;
  stroke-dashoffset: 60;
  transform-origin: 50% 50%;
  animation: ${$6dac766084d8c11a$var$Rotate} ${({ animationSpeed: animationSpeed })=>animationSpeed} linear infinite;
  animation-delay: ${({ animationDelay: animationDelay })=>animationDelay};
`;
function $6dac766084d8c11a$var$PendingSpinner({ animationDelay: animationDelay = "0s", animationSpeed: animationSpeed = "1s", ...props }) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("svg", {
        width: "52",
        height: "52",
        viewBox: "0 0 52 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        strokeWidth: 4,
        stroke: "orange",
        ...props,
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($6dac766084d8c11a$var$SpinnerCircle, {
            cx: "26",
            cy: "26",
            r: "20",
            fill: "none",
            animationDelay: animationDelay,
            animationSpeed: animationSpeed
        })
    });
}
var $6dac766084d8c11a$export$2e2bcd8739ae039 = $6dac766084d8c11a$var$PendingSpinner;





parcelRequire("bnENU");




var $bnENU = parcelRequire("bnENU");



const $cad3c79bf25e7dc3$var$StyledInput = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).input`
  ${(0, $196480508fc60042$export$1e8407dccf0d27b6)}
  position: relative;
  outline: none;
  border: 1px solid;
  border-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  flex: 1 1 auto;
  background-color: ${({ theme: theme })=>theme.bg1};
  font-size: ${({ fontSize: fontSize })=>fontSize ?? "28px"};
  text-align: ${({ align: align })=>align && align};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0px;
  text-align: left;
  padding: 8px 6px;
  border-radius: 5px;
  transition: 0.2s ease all;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  margin: 0;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  :hover {
    border-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  }
  
  :focus {
    border-color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
    box-shadow: 0 0 5px ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK};
  }

  ::placeholder {
    color: ${({ theme: theme })=>theme.text4};
  }
`;
var $cad3c79bf25e7dc3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).memo(function InnerInput({ value: value, onUserInput: onUserInput, placeholder: placeholder, prependSymbol: prependSymbol, ...rest }) {
    function handleChange(event) {
        const newValue = event.target.value;
        if (/^\d*\.?\d*$/.test(newValue)) onUserInput(newValue);
    }
    function handleKeyPress(event) {
        const charCode = event.code;
        if (charCode === "Minus") event.preventDefault();
        else if (charCode !== "delete" && charCode > "a" && (charCode < "0" || charCode > "9")) event.preventDefault();
    }
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($cad3c79bf25e7dc3$var$StyledInput, {
        ...rest,
        value: value,
        onChange: handleChange,
        onKeyPress: handleKeyPress,
        inputMode: "numeric",
        autoComplete: "off",
        autoCorrect: "off",
        placeholder: placeholder ?? "0.00",
        minLength: 1,
        maxLength: 79,
        spellCheck: "false"
    });
});



parcelRequire("bnENU");



const $dd1ebb65b37f556e$var$PaymentMethod = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
`;
const $dd1ebb65b37f556e$export$c79ea7891059d5bc = (props)=>{
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $b18c92e2e4b17921$export$2e2bcd8739ae039), {
        style: {
            maxWidth: 300
        },
        message: props.method.hostChain ? `${props.method.name} on ${props.method.hostChain.name}` : props.method.name,
        disabled: props.disableToolTip,
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
            style: {
                width: props.size ?? 25,
                height: props.size ?? 25,
                backgroundImage: `url(${props.method.logo})`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                position: "relative",
                cursor: "pointer"
            },
            children: props.method.hostChain && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                style: {
                    background: "rgba(255, 255, 255, 0.95)",
                    borderRadius: "100%",
                    width: props.size ? props.size * 0.6 : 15,
                    height: props.size ? props.size * 0.6 : 15,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    bottom: -1,
                    right: -5,
                    boxShadow: "0 0 1px"
                },
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                    style: {
                        width: props.size ? props.size * 0.4 : 10,
                        height: props.size ? props.size * 0.4 : 10,
                        backgroundImage: `url(${props.method.hostChain.logo})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat"
                    }
                })
            })
        })
    });
};
const $dd1ebb65b37f556e$var$PaymentMethodDisplay = (props)=>{
    const m = props.paymentMethod ?? (0, $5760199798158999$export$8793fab959da70d1)(props.method.network, props.method.token);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($dd1ebb65b37f556e$var$PaymentMethod, {
        style: props.style,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($dd1ebb65b37f556e$export$c79ea7891059d5bc, {
                method: m,
                disableToolTip: props.disableTooltip ?? true,
                size: props.size
            }),
            !props.excludeName && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                style: {
                    marginLeft: 4
                },
                children: m.name
            }),
            props.includeNetworkName && props.method.network !== "Fiat" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                children: [
                    "on ",
                    props.method.network
                ]
            })
        ]
    });
};
var $dd1ebb65b37f556e$export$2e2bcd8739ae039 = $dd1ebb65b37f556e$var$PaymentMethodDisplay;


const $8b11f71ec29ada79$var$OnrampDiv = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  padding: 20px;
  max-width: 100%;
  min-width: 100%;
  background-color: ${()=>(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST};
  border-radius: 20px;
`;
const $8b11f71ec29ada79$export$c45011cd9d0c2964 = ({ method: method, amount: amount, tag: tag, loading: loading, style: style })=>{
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($8b11f71ec29ada79$var$OnrampDiv, {
        style: style,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                style: {
                    fontSize: 12,
                    textTransform: "uppercase",
                    fontFamily: "Roboto Mono",
                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                },
                children: tag
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $cad3c79bf25e7dc3$export$2e2bcd8739ae039), {
                        placeholder: "0",
                        value: amount,
                        style: {
                            fontSize: 22,
                            border: 0,
                            padding: "10px 0",
                            boxShadow: "none",
                            fontWeight: 500,
                            color: "black",
                            background: "transparent"
                        },
                        disabled: true,
                        onUserInput: (input)=>{}
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                            backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED,
                            padding: 10,
                            borderRadius: 20,
                            marginBottom: 12,
                            cursor: "pointer",
                            userSelect: "none",
                            color: "black",
                            boxShadow: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $dd1ebb65b37f556e$export$2e2bcd8739ae039), {
                                size: 28,
                                method: method,
                                excludeName: true
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                style: {
                                    fontSize: 16,
                                    fontWeight: 500,
                                    marginLeft: 5
                                },
                                children: method.ticker
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("bnENU");

const $c9e2a9a16cab16b0$export$6cf52243487b4355 = (props)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE,
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M19 12L5 12",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                d: "M12 19L19 12L12 5",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });



parcelRequire("bnENU");
function $1280caa2c18f8a52$var$USDCLogo(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("g", {
                clipPath: "url(#clip0_842_16633)",
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M9.99821 20.4963C4.4631 20.4999 0 16.0439 0 10.5088C0 4.91654 4.52385 0.457019 10.0911 0.503472C15.5548 0.549926 20.0393 4.97014 20 10.5839C19.9571 16.1011 15.494 20.5034 9.99821 20.4963ZM10.67 14.3037C10.7843 14.2751 10.888 14.2501 10.988 14.2215C12.035 13.9321 12.8426 13.0995 12.7425 11.8417C12.6854 11.1199 12.3602 10.591 11.6884 10.2944C11.2417 10.0943 10.7701 10.0193 10.2948 9.93351C9.90531 9.86561 9.51224 9.787 9.13704 9.66193C8.75112 9.53329 8.61533 9.21169 8.62605 8.81148C8.64034 8.42556 8.81544 8.15756 9.16562 8.0039C9.46579 7.87169 9.78024 7.87526 10.0947 7.89313C10.6521 7.92172 11.0452 8.17542 11.2274 8.715C11.2882 8.89367 11.4097 8.96871 11.5919 8.96871C11.7706 8.96871 11.9493 8.96871 12.1279 8.96871C12.4209 8.96513 12.5389 8.81862 12.4745 8.53276C12.2959 7.71804 11.6205 7.07484 10.7843 6.9462C10.6557 6.92476 10.6164 6.88188 10.62 6.75681C10.6271 6.49953 10.6235 6.24582 10.6235 5.98854C10.6235 5.74556 10.4842 5.59905 10.2412 5.58833C10.0733 5.58118 9.90888 5.58476 9.74093 5.58833C9.47293 5.58833 9.33357 5.72054 9.32285 5.98854C9.3157 6.16006 9.32285 6.33516 9.32285 6.50668C9.32285 6.86044 9.32285 6.86044 8.98696 6.94262C8.01143 7.18918 7.37538 7.85025 7.29677 8.75788C7.22173 9.66551 7.53618 10.3552 8.41522 10.6982C8.72968 10.8197 9.062 10.8947 9.39074 10.9769C9.87315 11.0948 10.377 11.1556 10.8415 11.32C11.4025 11.5165 11.5848 12.1454 11.2846 12.6671C11.0595 13.0566 10.6986 13.2317 10.2698 13.2746C9.47651 13.3568 8.60104 13.1531 8.44738 12.1883C8.42237 12.0382 8.30088 11.9596 8.14722 11.9596C7.95783 11.956 7.76487 11.956 7.57549 11.956C7.2253 11.956 7.1181 12.0918 7.18957 12.4384C7.40397 13.4354 8.05789 13.9857 9.01554 14.2251C9.13346 14.2537 9.25496 14.2787 9.38002 14.3073C9.38002 14.636 9.38002 14.9433 9.38002 15.2542C9.38002 15.4829 9.51224 15.6151 9.74451 15.6223C9.90531 15.6258 10.0661 15.6258 10.2269 15.6258C10.5485 15.6258 10.6736 15.5008 10.6736 15.1684C10.6736 14.8826 10.67 14.5967 10.67 14.3037ZM11.8849 17.1767C11.8849 17.3089 11.8742 17.4411 11.8885 17.5697C11.91 17.777 12.0815 17.8735 12.2744 17.802C12.3066 17.7913 12.3423 17.777 12.3745 17.7663C13.7538 17.3089 14.9223 16.5335 15.8263 15.3971C17.3021 13.5426 17.8524 11.4343 17.3486 9.11521C16.7375 6.31014 15.0188 4.44129 12.3245 3.46934C12.0493 3.36929 11.8885 3.49078 11.8778 3.78737C11.8706 3.97675 11.8671 4.16971 11.8742 4.3591C11.8849 4.5878 11.9993 4.7486 12.2173 4.83078C14.858 5.83489 16.5124 8.49345 16.1765 11.2878C15.8871 13.6819 14.6185 15.39 12.4066 16.3798C11.8814 16.6156 11.8778 16.6085 11.8849 17.1767ZM2.46918 10.5946C2.49062 10.909 2.49419 11.2271 2.53707 11.5379C2.83723 13.6676 3.84134 15.39 5.57441 16.6728C6.22119 17.1516 6.93586 17.4983 7.69698 17.752C7.90781 17.8199 8.01858 17.7806 8.08647 17.5697C8.12935 17.4375 8.12221 17.291 8.12578 17.1481C8.12935 16.5978 8.10434 16.562 7.60765 16.3548C7.55405 16.3334 7.50045 16.3048 7.44327 16.2797C4.17366 14.8218 2.70859 10.7804 4.64535 7.45004C5.37788 6.18865 6.44631 5.31318 7.80061 4.7879C8.04359 4.695 8.12578 4.57708 8.12935 4.31622C8.13293 4.18401 8.12935 4.05537 8.12935 3.92315C8.12935 3.44433 8.01143 3.35499 7.56477 3.50507C4.52385 4.53062 2.47275 7.39286 2.46918 10.5946Z",
                        fill: "#0274D0"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M10.6695 14.3038C10.6695 14.5968 10.6695 14.8827 10.6695 15.165C10.6695 15.4937 10.5444 15.6224 10.2228 15.6224C10.062 15.6224 9.90121 15.6259 9.74041 15.6188C9.51172 15.6116 9.3795 15.4794 9.37593 15.2507C9.37236 14.9398 9.37593 14.6325 9.37593 14.3038C9.25086 14.2752 9.13294 14.2502 9.01145 14.2216C8.0538 13.9822 7.40346 13.4319 7.18548 12.4349C7.11044 12.0883 7.21764 11.9525 7.5714 11.9525C7.76079 11.9525 7.95375 11.9525 8.14313 11.9561C8.30036 11.9597 8.42185 12.0347 8.44329 12.1848C8.59695 13.1496 9.47598 13.3533 10.2657 13.2711C10.6945 13.2282 11.0554 13.0531 11.2805 12.6636C11.5807 12.1419 11.3984 11.5166 10.8374 11.3164C10.3693 11.1521 9.86905 11.0913 9.38665 10.9734C9.0579 10.8948 8.72559 10.8197 8.41113 10.6947C7.5321 10.3481 7.21764 9.6584 7.29268 8.75433C7.36772 7.84312 8.00377 7.18205 8.98286 6.93906C9.31876 6.8533 9.31876 6.8533 9.31876 6.50311C9.31876 6.33159 9.31518 6.15649 9.31876 5.98497C9.32948 5.71696 9.46884 5.58475 9.73684 5.58475C9.90478 5.58475 10.0692 5.5776 10.2371 5.58475C10.4801 5.59547 10.6159 5.74198 10.6194 5.98497C10.623 6.24225 10.6266 6.49596 10.6159 6.75324C10.6123 6.87831 10.648 6.92477 10.7802 6.94263C11.6128 7.07127 12.2918 7.71448 12.4704 8.52921C12.5347 8.81866 12.4168 8.96159 12.1238 8.96516C11.9451 8.96516 11.7665 8.96516 11.5878 8.96516C11.4092 8.96516 11.2841 8.8937 11.2233 8.71145C11.0411 8.17187 10.648 7.92174 10.0906 7.88958C9.77257 7.87171 9.45812 7.86814 9.16153 8.00035C8.81134 8.15401 8.63268 8.42201 8.62196 8.80793C8.60767 9.20815 8.74703 9.52976 9.13294 9.6584C9.50814 9.78347 9.90121 9.86208 10.2907 9.92997C10.766 10.0157 11.2412 10.0908 11.6843 10.2909C12.3561 10.591 12.6813 11.1199 12.7384 11.8382C12.8385 13.096 12.0309 13.9286 10.9839 14.218C10.8874 14.2502 10.7838 14.2752 10.6695 14.3038Z",
                        fill: "#FEFEFE"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M11.8846 17.1766C11.8775 16.6049 11.881 16.6156 12.4099 16.3798C14.6218 15.39 15.8904 13.6819 16.1798 11.2878C16.5157 8.49341 14.8613 5.83841 12.2205 4.83073C12.0025 4.74855 11.8882 4.58775 11.8775 4.35905C11.8703 4.16967 11.8739 3.97671 11.881 3.78732C11.8918 3.49073 12.0526 3.37281 12.3277 3.46929C15.0256 4.44124 16.7409 6.3101 17.3519 9.11517C17.8558 11.4343 17.3055 13.5425 15.8296 15.3971C14.922 16.5334 13.7535 17.3088 12.3777 17.7662C12.3456 17.7769 12.3098 17.7912 12.2777 17.802C12.0811 17.8734 11.9132 17.7769 11.8918 17.5697C11.8739 17.441 11.8846 17.3088 11.8846 17.1766Z",
                        fill: "#FEFEFE"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M2.46979 10.5946C2.47336 7.3929 4.52445 4.53423 7.56893 3.50511C8.0156 3.35503 8.13352 3.44436 8.13352 3.92319C8.13352 4.0554 8.13352 4.18404 8.13352 4.31626C8.12995 4.57711 8.04776 4.69146 7.80477 4.78794C6.45048 5.31679 5.38205 6.19226 4.64952 7.45008C2.71277 10.7804 4.17784 14.8219 7.45101 16.2798C7.50461 16.3048 7.55821 16.3298 7.61539 16.3548C8.11565 16.5657 8.14067 16.5978 8.13352 17.1481C8.13352 17.2875 8.13709 17.4376 8.09421 17.5698C8.02632 17.7806 7.91197 17.8199 7.70472 17.752C6.9436 17.5019 6.22536 17.1517 5.58216 16.6729C3.84909 15.39 2.84499 13.6677 2.54483 11.538C2.4948 11.2235 2.49123 10.9091 2.46979 10.5946Z",
                        fill: "#FEFEFE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("clipPath", {
                    id: "clip0_842_16633",
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("rect", {
                        width: "20",
                        height: "19.9929",
                        fill: "white",
                        transform: "translate(0 0.503571)"
                    })
                })
            })
        ]
    });
}
var $1280caa2c18f8a52$export$2e2bcd8739ae039 = $1280caa2c18f8a52$var$USDCLogo;




parcelRequire("bnENU");
function $a25f930b859b61aa$var$Dots(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: "#292929",
        strokeWidth: "2",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("g", {
                clipPath: "url(#clip0_3_444)",
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M5 16L4 20L8 19L19.5858 7.41421C20.3668 6.63316 20.3668 5.36683 19.5858 4.58579L19.4142 4.41421C18.6332 3.63316 17.3668 3.63317 16.5858 4.41421L5 16Z",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M15 6L18 9",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M13 20H21",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("clipPath", {
                    id: "clip0_3_444",
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
var $a25f930b859b61aa$export$2e2bcd8739ae039 = $a25f930b859b61aa$var$Dots;




const $35ce030e39d4f986$var$CURRENCY_USD = "USD";
const $35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY = $35ce030e39d4f986$var$CURRENCY_USD;
const $35ce030e39d4f986$var$isSecureHostedUrl = (value)=>{
    if (!value) return false;
    try {
        const parsedUrl = new URL(value);
        return parsedUrl.protocol === "https:";
    } catch  {
        return false;
    }
};
const $35ce030e39d4f986$var$formatOpenBankingErrorMessage = (message)=>{
    const normalized = (message ?? "").trim();
    if (!normalized) return "We could not start the bank transfer. Please try again.";
    if (normalized.toLowerCase() === "kyc verified false") return "We could not verify your details. Please review your information and try again.";
    return normalized;
};
const $35ce030e39d4f986$var$normalizeOpenBankingProviderStatus = (status)=>(status ?? "").trim().toLowerCase().replace(/[\s-]+/g, "_");
const $35ce030e39d4f986$var$OPEN_BANKING_PROVIDER_CONFIRMED_STATUSES = new Set([
    "paid",
    "success",
    "succeeded",
    "complete",
    "completed"
]);
const $35ce030e39d4f986$var$OPEN_BANKING_PROVIDER_FAILED_STATUSES = new Set([
    "failed",
    "canceled",
    "cancelled"
]);
const $35ce030e39d4f986$var$OPEN_BANKING_PROVIDER_AUTHORIZED_STATUSES = new Set([
    "authorized",
    "waiting_for_payment"
]);
const $35ce030e39d4f986$var$hasOpenBankingDestinationAddress = (address)=>typeof address === "string" && address.trim().length > 0;
const $35ce030e39d4f986$var$isOpenBankingProviderConfirmed = (data)=>$35ce030e39d4f986$var$OPEN_BANKING_PROVIDER_CONFIRMED_STATUSES.has($35ce030e39d4f986$var$normalizeOpenBankingProviderStatus(data?.status));
const $35ce030e39d4f986$var$isOpenBankingProviderFailed = (data)=>$35ce030e39d4f986$var$OPEN_BANKING_PROVIDER_FAILED_STATUSES.has($35ce030e39d4f986$var$normalizeOpenBankingProviderStatus(data?.status));
const $35ce030e39d4f986$var$getOpenBankingSchemeName = (data)=>{
    const scheme = data?.paymentScheme?.trim();
    if (scheme) return scheme;
    if (data?.instantPaymentScheme === true) return "instant bank transfer";
    if (data?.instantPaymentScheme === false) return "standard bank transfer";
    return "bank transfer";
};
const $35ce030e39d4f986$var$isStandardOpenBankingScheme = (data)=>{
    const scheme = data?.paymentScheme?.trim().toLowerCase();
    return data?.instantPaymentScheme === false || scheme === "sepa credit" || scheme === "bacs / chaps" || scheme === "bacs" || scheme === "chaps";
};
const $35ce030e39d4f986$var$getOpenBankingReturnStatusCopy = (data, sessionStatus)=>{
    if (sessionStatus === "expired") return {
        title: "Payment expired",
        body: "The checkout session expired before the bank transfer completed. Please start a new payment.",
        isError: true
    };
    if (sessionStatus === "cancelled") return {
        title: "Payment cancelled",
        body: "The checkout session was cancelled before the bank transfer completed.",
        isError: true
    };
    const status = $35ce030e39d4f986$var$normalizeOpenBankingProviderStatus(data?.status);
    const schemeName = $35ce030e39d4f986$var$getOpenBankingSchemeName(data);
    if (status === "canceled" || status === "cancelled") return {
        title: "Payment cancelled",
        body: "The bank authorization was cancelled. You can try again or use another bank.",
        isError: true
    };
    if (status === "failed") return {
        title: "Payment unsuccessful",
        body: "The bank transfer was not completed. Please try again or use another bank.",
        isError: true
    };
    if (status === "finalizing") return {
        title: "Payment received",
        body: "We have received the transfer and are completing final checks. This usually takes a few minutes.",
        isError: false
    };
    if ($35ce030e39d4f986$var$isOpenBankingProviderConfirmed(data)) return {
        title: "Payment received",
        body: "The transfer has been received. We are updating the payment status now.",
        isError: false
    };
    if ($35ce030e39d4f986$var$OPEN_BANKING_PROVIDER_AUTHORIZED_STATUSES.has(status)) {
        if ($35ce030e39d4f986$var$isStandardOpenBankingScheme(data)) return {
            title: "Transfer sent",
            body: `Your bank has sent the payment via ${schemeName}. Standard transfers can take longer to arrive, so we will complete the payment once it reaches us.`,
            isError: false
        };
        return {
            title: "Transfer authorized",
            body: `Your bank has authorized the ${schemeName}. We are waiting for settlement confirmation before completing the payment.`,
            isError: false
        };
    }
    if (status === "processing") return {
        title: "Payment started",
        body: "Follow the bank authorization steps. We will update this page as soon as your bank sends a status.",
        isError: false
    };
    return {
        title: "Confirming payment",
        body: "Please keep this page open while we confirm the bank transfer.",
        isError: false
    };
};
const $35ce030e39d4f986$var$Container = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 100vw;
  height: 100%;
  height: 100vh;
  background-color: white;
  font-size: 14px;
  overflow: hidden;

  @media (max-width: 800px) {
    min-height: 100vh;
    height: auto;
    overflow: visible;
  }
`;
var $35ce030e39d4f986$var$OpenBankingRenderStates;
(function(OpenBankingRenderStates) {
    OpenBankingRenderStates[OpenBankingRenderStates["onramp"] = 0] = "onramp";
    OpenBankingRenderStates[OpenBankingRenderStates["billing"] = 1] = "billing";
    OpenBankingRenderStates[OpenBankingRenderStates["summary"] = 2] = "summary";
})($35ce030e39d4f986$var$OpenBankingRenderStates || ($35ce030e39d4f986$var$OpenBankingRenderStates = {}));
const $35ce030e39d4f986$var$hasCompleteOpenBankingCustomerDetails = (data, email)=>{
    return data.name.trim().length > 0 && data.dateOfBirth.trim().length > 0 && data.countryOfResidence.trim().length > 0 && data.address.trim().length > 0 && (0, $8d017118df5fe2e5$export$f9c4d85d720ef909)(data.phoneNumber) && (email?.trim().length ?? 0) > 0;
};
const $35ce030e39d4f986$var$compactAddressParts = (...parts)=>parts.map((part)=>part?.trim()).filter((part)=>Boolean(part && part.length > 0)).join(", ");
const $35ce030e39d4f986$var$openBankingAddressCountryParts = new Set([
    "austria",
    "belgium",
    "bulgaria",
    "croatia",
    "cyprus",
    "czech republic",
    "denmark",
    "estonia",
    "finland",
    "france",
    "germany",
    "greece",
    "hungary",
    "iceland",
    "ireland",
    "italy",
    "latvia",
    "liechtenstein",
    "lithuania",
    "luxembourg",
    "malta",
    "netherlands",
    "norway",
    "poland",
    "portugal",
    "romania",
    "slovakia",
    "slovenia",
    "spain",
    "sweden",
    "united kingdom",
    "uk"
]);
const $35ce030e39d4f986$var$removeTrailingCountryPart = (parts)=>{
    const lastPart = parts[parts.length - 1]?.toLowerCase();
    if (parts.length > 2 && lastPart && $35ce030e39d4f986$var$openBankingAddressCountryParts.has(lastPart)) return parts.slice(0, -1);
    return parts;
};
const $35ce030e39d4f986$var$splitTownAndPostalCode = (value)=>{
    const leadingPostalCodeMatch = value.match(/^(\d{4,6})\s+(.+)$/);
    if (leadingPostalCodeMatch) return {
        townOrCity: leadingPostalCodeMatch[2].trim(),
        postalCode: leadingPostalCodeMatch[1].trim()
    };
    const trailingPostalCodeMatch = value.match(/^(.+?)\s+([A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2})$/i);
    if (trailingPostalCodeMatch) return {
        townOrCity: trailingPostalCodeMatch[1].trim(),
        postalCode: trailingPostalCodeMatch[2].toUpperCase().trim()
    };
    return {
        townOrCity: value,
        postalCode: ""
    };
};
const $35ce030e39d4f986$var$parseOpenBankingAddress = (address)=>{
    const parts = $35ce030e39d4f986$var$removeTrailingCountryPart(address.split(",").map((part)=>part.trim()).filter((part)=>part.length > 0));
    if (parts.length === 2) {
        const { townOrCity: townOrCity, postalCode: postalCode } = $35ce030e39d4f986$var$splitTownAndPostalCode(parts[1]);
        return {
            addressLine1: parts[0],
            addressLine2: "",
            townOrCity: townOrCity,
            stateOrProvince: "",
            postalCode: postalCode
        };
    }
    return {
        addressLine1: parts[0] ?? "",
        addressLine2: "",
        townOrCity: parts[1] ?? "",
        stateOrProvince: parts.length >= 4 ? parts[2] ?? "" : "",
        postalCode: parts.length >= 4 ? parts[3] ?? "" : parts[2] ?? ""
    };
};
const $35ce030e39d4f986$var$composeManualOpenBankingAddress = (address)=>$35ce030e39d4f986$var$compactAddressParts(address.addressLine1, address.addressLine2, address.townOrCity, address.stateOrProvince, address.postalCode);
const $35ce030e39d4f986$var$normalizeOpenBankingDob = (dateOfBirth)=>{
    if (dateOfBirth.trim().length === 0) return "";
    const parsedDate = new Date(dateOfBirth);
    if (Number.isNaN(parsedDate.getTime())) return dateOfBirth;
    return parsedDate.toLocaleDateString("en-CA");
};
const $35ce030e39d4f986$var$buildOpenBankingCustomerPayload = (data, extra = {})=>{
    const normalizedDob = $35ce030e39d4f986$var$normalizeOpenBankingDob(data.dateOfBirth);
    return {
        name: data.name,
        phone: data.phoneNumber,
        address: data.address,
        billingAddress: data.address,
        dateOfBirth: normalizedDob,
        dob: normalizedDob,
        residenceCountry: data.countryOfResidence,
        ...extra
    };
};
var $35ce030e39d4f986$var$PaymentStatus;
(function(PaymentStatus) {
    PaymentStatus["INITIAL"] = "initial";
    PaymentStatus["KYC"] = "kyc";
    PaymentStatus["KYC_PENDING_VIEW"] = "kyc_pending_view";
    PaymentStatus["WAITING"] = "waiting";
    PaymentStatus["SUCCESS"] = "success";
    PaymentStatus["Expired"] = "expired";
    PaymentStatus["ERROR"] = "error";
})($35ce030e39d4f986$var$PaymentStatus || ($35ce030e39d4f986$var$PaymentStatus = {}));
const $35ce030e39d4f986$var$RenderOpenBankingInitial = ({ renderState: renderState, setRenderState: setRenderState, checkoutData: checkoutData, totalSum: totalSum, currency: currency, isPreProcessingPayment: isPreProcessingPayment, onrampAmount: onrampAmount, randomAddress: randomAddress, userKycData: userKycData, setUserKycData: setUserKycData, addressSuggestionList: addressSuggestionList, setAddressSuggestionList: setAddressSuggestionList, allCountries: allCountries, debouncedFetch: debouncedFetch, checkMarkOpenbanking: checkMarkOpenbanking, setCheckMarkOpenBanking: setCheckMarkOpenBanking, errorMessage: errorMessage, setErrorMessage: setErrorMessage, setOpenbankPayStatus: setOpenbankPayStatus, setOpenBankingCheckoutUrl: setOpenBankingCheckoutUrl })=>{
    const { checkoutId: checkoutId } = (0, $6738ab3539650fb6$export$99eaa27ddbbb95ef)();
    const trackedOpenBankingStepsRef = (0, $bnENU.useRef)(new Set());
    const trackOpenBankingStep = (0, $bnENU.useCallback)((step)=>{
        if (!checkoutId || trackedOpenBankingStepsRef.current.has(step)) return;
        trackedOpenBankingStepsRef.current.add(step);
        (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
            sourceType: "checkoutSession",
            sourceId: checkoutId,
            rail: "openBanking",
            step: step
        });
    }, [
        checkoutId
    ]);
    const fromMethod = (0, $bnENU.useMemo)(()=>{
        if (checkoutData?.currency === "EUR") return {
            name: "EUR",
            ticker: "EUR",
            network: "Fiat",
            token: "EUR",
            currencyName: "Euro",
            isWalletSupported: false
        };
        else return {
            name: "GBP",
            ticker: "GBP",
            network: "Fiat",
            token: "GBP",
            currencyName: "British Pound",
            isWalletSupported: false
        };
    }, [
        checkoutData?.gateway.openBanking
    ]);
    const toMethod = (0, $bnENU.useMemo)(()=>{
        return {
            name: "USDC",
            ticker: "USDC",
            network: "Ethereum",
            currencyName: "USDC",
            isWalletSupported: false
        };
    }, [
        checkoutData?.gateway.openBanking
    ]);
    const onBack = ()=>{
        if (renderState === 1) setRenderState(0);
        else if (renderState === 2) setRenderState(1);
    };
    const onChangeFullName = (0, $bnENU.useCallback)((e)=>{
        setUserKycData((prev)=>({
                ...prev,
                name: e.target.value
            }));
    }, []);
    const [isManualAddressEntry, setIsManualAddressEntry] = (0, $bnENU.useState)(false);
    const [manualAddress, setManualAddress] = (0, $bnENU.useState)(()=>$35ce030e39d4f986$var$parseOpenBankingAddress(userKycData.address));
    const [validationErrors, setValidationErrors] = (0, $bnENU.useState)({});
    const fieldErrorStyle = (field)=>({
            ...validationErrors[field] ? (0, $196480508fc60042$export$15a6a1d6cb047a38) : undefined
        });
    const clearValidationErrors = (...fields)=>{
        setValidationErrors((currentErrors)=>{
            if (fields.every((field)=>!currentErrors[field])) return currentErrors;
            return Object.fromEntries(Object.entries(currentErrors).filter(([field])=>!fields.includes(field)));
        });
    };
    const focusValidationField = (field)=>{
        window.requestAnimationFrame(()=>{
            const fieldElement = document.querySelector(`[data-open-banking-field="${field}"]`);
            fieldElement?.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            const focusable = fieldElement?.matches("input") ? fieldElement : fieldElement?.querySelector('input, button, [tabindex]:not([tabindex="-1"])');
            focusable?.focus();
        });
    };
    (0, $bnENU.useEffect)(()=>{
        if (!isManualAddressEntry) setManualAddress($35ce030e39d4f986$var$parseOpenBankingAddress(userKycData.address));
    }, [
        isManualAddressEntry,
        userKycData.address
    ]);
    const enterManualAddressEntry = ()=>{
        const parsedAddress = $35ce030e39d4f986$var$parseOpenBankingAddress(userKycData.address);
        setAddressSuggestionList([]);
        setManualAddress(parsedAddress);
        setUserKycData((prev)=>({
                ...prev,
                address: $35ce030e39d4f986$var$composeManualOpenBankingAddress(parsedAddress) || prev.address
            }));
        setIsManualAddressEntry(true);
    };
    const enterAutocompleteAddressEntry = ()=>{
        setAddressSuggestionList([]);
        setIsManualAddressEntry(false);
    };
    const updateManualAddress = (patch)=>{
        setManualAddress((prev)=>{
            const nextAddress = {
                ...prev,
                ...patch
            };
            const address = $35ce030e39d4f986$var$composeManualOpenBankingAddress(nextAddress);
            setUserKycData((prevKycData)=>({
                    ...prevKycData,
                    address: address
                }));
            return nextAddress;
        });
    };
    const validateOpenBankingBilling = ()=>{
        const nextErrors = {};
        if (userKycData.name.trim().length === 0) nextErrors.name = "Enter full name.";
        if (userKycData.dateOfBirth.trim().length === 0) nextErrors.dateOfBirth = "Enter date of birth.";
        if (userKycData.countryOfResidence.trim().length === 0) nextErrors.countryOfResidence = "Select country.";
        if (isManualAddressEntry) {
            if (manualAddress.addressLine1.trim().length === 0) nextErrors.addressLine1 = "Enter address line 1.";
            if (manualAddress.townOrCity.trim().length === 0) nextErrors.townOrCity = "Enter city or town.";
        } else if (userKycData.address.trim().length === 0) nextErrors.address = "Enter address.";
        if (userKycData.phoneNumber.trim().length === 0) nextErrors.phoneNumber = "Enter phone number.";
        else if (!(0, $8d017118df5fe2e5$export$f9c4d85d720ef909)(userKycData.phoneNumber)) nextErrors.phoneNumber = "Enter a valid phone number.";
        const firstValidationField = Object.keys(nextErrors)[0];
        setValidationErrors(nextErrors);
        if (firstValidationField) {
            focusValidationField(firstValidationField);
            return false;
        }
        return true;
    };
    const composeAddressText = (details, fallbackAddress)=>{
        if (!details) return fallbackAddress;
        const locality = [
            details.townOrCity,
            details.stateOrProvince
        ].map((part)=>part?.trim()).filter((part)=>Boolean(part && part.length > 0)).join(", ");
        const parts = [
            details.addressLine1,
            details.addressLine2,
            locality,
            details.postalCode
        ].map((part)=>part?.trim()).filter((part)=>Boolean(part && part.length > 0));
        if (parts.length > 0) return parts.join(", ");
        return details.formattedAddress ?? fallbackAddress;
    };
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(false);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            justifyItems: "center",
                            alignItems: "center",
                            marginTop: 10,
                            marginRight: 5,
                            fontSize: 20,
                            fontWeight: 600
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10
                                },
                                children: [
                                    renderState !== 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                        style: {
                                            transform: "rotate(90deg)",
                                            cursor: "pointer",
                                            userSelect: "none",
                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                        },
                                        onClick: onBack,
                                        width: 14,
                                        height: 14,
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                    }),
                                    renderState === 0 ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("amountToBePaid")
                                    }) : renderState === 1 ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("billingInformation")
                                    }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("checkoutSummary")
                                    })
                                ]
                            }),
                            renderState === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, totalSum)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            justifyItems: "center",
                            alignItems: "center",
                            marginTop: 4,
                            marginRight: 5,
                            fontSize: 14,
                            color: "white",
                            fontWeight: 400
                        },
                        children: [
                            renderState === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 10,
                                    alignItems: "center",
                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                    width: "100%",
                                    padding: "0"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $8b11f71ec29ada79$export$c45011cd9d0c2964), {
                                        style: {
                                            marginTop: 35,
                                            marginBottom: 2.5
                                        },
                                        method: fromMethod,
                                        tag: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("youSpend"),
                                        amount: totalSum.toString(),
                                        loading: isPreProcessingPayment
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            margin: "-26px",
                                            width: 40,
                                            height: 40,
                                            background: "white",
                                            zIndex: 1,
                                            borderRadius: "100%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $c9e2a9a16cab16b0$export$6cf52243487b4355), {
                                            style: {
                                                transform: "rotate(90deg)",
                                                width: 24
                                            },
                                            stroke: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $8b11f71ec29ada79$export$c45011cd9d0c2964), {
                                        style: {
                                            marginTop: 2.5
                                        },
                                        method: toMethod,
                                        tag: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("youReceive"),
                                        amount: parseFloat(onrampAmount.toString()).toFixed(2),
                                        loading: isPreProcessingPayment
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            marginTop: 10,
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                    marginLeft: 10,
                                                    marginBottom: 5,
                                                    fontSize: 14,
                                                    fontWeight: 500
                                                },
                                                children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("paymentMethod")
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    padding: 20,
                                                    backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST,
                                                    borderRadius: 20,
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "space-between"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("instantBankTransfer")
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                        src: (0, $d5ca48e110fef8bd$export$ea9efa9b6eb2022a)(),
                                                        style: {
                                                            height: 20,
                                                            width: "auto"
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                    marginLeft: 10,
                                                    marginBottom: 5,
                                                    fontSize: 14,
                                                    fontWeight: 500
                                                },
                                                children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("receivingAddress")
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    padding: 20,
                                                    backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST,
                                                    borderRadius: 20,
                                                    width: "100%",
                                                    display: "flex",
                                                    overflowX: "auto",
                                                    scrollbarWidth: "none"
                                                },
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    children: checkoutData?.gateway.openBanking?.destinationCryptoAddress ?? randomAddress
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                        style: {
                                            width: "100%",
                                            marginTop: 20
                                        },
                                        onClick: ()=>{
                                            setRenderState($35ce030e39d4f986$var$hasCompleteOpenBankingCustomerDetails(userKycData, checkoutData?.gateway.openBanking?.email) ? 2 : 1);
                                        },
                                        children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("continueToCheckout")
                                    })
                                ]
                            }),
                            renderState === 1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    height: "100%",
                                    minHeight: "475px",
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 10,
                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                    fontSize: 14,
                                    marginTop: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: "10px",
                                            justifyContent: "space-between",
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                "data-open-banking-field": "name",
                                                style: {
                                                    fontSize: 14,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 10,
                                                    flex: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$30c69c51aadaa8e4), {
                                                    label: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("fullName"),
                                                    value: userKycData.name,
                                                    required: true,
                                                    inputStyle: fieldErrorStyle("name"),
                                                    validationError: validationErrors.name,
                                                    onChange: (e)=>{
                                                        clearValidationErrors("name");
                                                        onChangeFullName(e);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 14,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 10,
                                                    flex: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    "data-open-banking-field": "dateOfBirth",
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 10
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("dateOfBirth")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: validationErrors.dateOfBirth ? {
                                                                border: "1px solid #df1b41",
                                                                borderRadius: 8,
                                                                ...(0, $196480508fc60042$export$15a6a1d6cb047a38)
                                                            } : undefined,
                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $de1108aeeb072783$export$2e2bcd8739ae039), {
                                                                placeholder: "DD/MM/YYYY",
                                                                value: userKycData.dateOfBirth ? new Date(userKycData.dateOfBirth) : undefined,
                                                                onChange: (e)=>{
                                                                    clearValidationErrors("dateOfBirth");
                                                                    setUserKycData({
                                                                        ...userKycData,
                                                                        dateOfBirth: e?.toDateString() ?? ""
                                                                    });
                                                                },
                                                                startDate: new Date("1935-01-01"),
                                                                endDate: (0, $df55bf4f7a42fad2$export$2e2bcd8739ae039)(new Date(), 18)
                                                            })
                                                        }),
                                                        validationErrors.dateOfBirth && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                                            children: validationErrors.dateOfBirth
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$30c69c51aadaa8e4), {
                                        label: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("email"),
                                        disabled: true,
                                        value: checkoutData?.gateway.openBanking?.email ?? "",
                                        required: true,
                                        onChange: ()=>{}
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10,
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("countryoOfResidence")
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                "data-open-banking-field": "countryOfResidence",
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $96e19f8f97c8e649$export$2e2bcd8739ae039), {
                                                    allowedCountries: allCountries,
                                                    style: fieldErrorStyle("countryOfResidence"),
                                                    selectedCountry: (allCountries.find((c)=>c.name.toLowerCase() === userKycData.countryOfResidence.toLowerCase() || c.isoCode.toLowerCase() === userKycData.countryOfResidence.toLowerCase())?.name ?? userKycData.countryOfResidence) || "",
                                                    onCountrySelected: (country)=>{
                                                        if (country) {
                                                            clearValidationErrors("countryOfResidence");
                                                            setUserKycData((prev)=>({
                                                                    ...prev,
                                                                    phoneNumber: prev.phoneNumber.trim().length === 0 ? `+${country.phonecode} ` : prev.phoneNumber,
                                                                    countryOfResidence: country.name
                                                                }));
                                                        }
                                                    }
                                                })
                                            }),
                                            validationErrors.countryOfResidence && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                                children: validationErrors.countryOfResidence
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                        children: [
                                            !isManualAddressEntry && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                "data-open-banking-field": "address",
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$328374105a880465), {
                                                        label: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("address"),
                                                        value: userKycData.address,
                                                        placeholder: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("address"),
                                                        required: true,
                                                        isInvalid: Boolean(validationErrors.address),
                                                        validationError: validationErrors.address,
                                                        suggestionList: addressSuggestionList,
                                                        setSelectedItems: (items)=>{
                                                            const selectedAddress = items[0];
                                                            if (!selectedAddress) return;
                                                            setAddressSuggestionList([]);
                                                            clearValidationErrors("address", "addressLine1", "townOrCity");
                                                            setUserKycData((prev)=>({
                                                                    ...prev,
                                                                    address: selectedAddress
                                                                }));
                                                            (async ()=>{
                                                                let details = null;
                                                                try {
                                                                    const selectedCountry = allCountries.find((c)=>c.name === userKycData.countryOfResidence);
                                                                    details = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getGooglePlaceAddressDetails(selectedAddress, selectedCountry?.isoCode ?? "");
                                                                } catch (err) {
                                                                    console.error("Failed to resolve selected address details", err);
                                                                    details = null;
                                                                }
                                                                if (!details) return;
                                                                const countryFromDetails = details.country?.toLowerCase();
                                                                const matchedCountry = allCountries.find((c)=>c.name.toLowerCase() === countryFromDetails || c.isoCode.toLowerCase() === countryFromDetails);
                                                                const resolvedAddress = composeAddressText(details, selectedAddress);
                                                                setUserKycData((prev)=>({
                                                                        ...prev,
                                                                        address: resolvedAddress,
                                                                        countryOfResidence: prev.countryOfResidence.trim().length > 0 ? prev.countryOfResidence : matchedCountry?.name ?? prev.countryOfResidence,
                                                                        phoneNumber: matchedCountry && prev.phoneNumber.trim().length === 0 ? `+${matchedCountry.phonecode} ` : prev.phoneNumber
                                                                    }));
                                                            })();
                                                        },
                                                        onChange: (e)=>{
                                                            clearValidationErrors("address", "addressLine1", "townOrCity");
                                                            const value = e.target.value;
                                                            if (value.length === 0) setAddressSuggestionList([]);
                                                            setUserKycData((prev)=>({
                                                                    ...prev,
                                                                    address: value
                                                                }));
                                                            if (value.length > 2) {
                                                                const country = allCountries.find((c)=>c.name === userKycData.countryOfResidence);
                                                                debouncedFetch(value, country?.isoCode ?? "", setAddressSuggestionList);
                                                            } else setAddressSuggestionList([]);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            display: "flex",
                                                            justifyContent: "flex-end"
                                                        },
                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: enterManualAddressEntry,
                                                            style: {
                                                                border: "none",
                                                                background: "transparent",
                                                                color: "#97a3b6",
                                                                textDecoration: "underline",
                                                                textUnderlineOffset: 2,
                                                                cursor: "pointer",
                                                                fontSize: 13,
                                                                padding: "2px 0"
                                                            },
                                                            children: "Enter address manually"
                                                        })
                                                    })
                                                ]
                                            }),
                                            isManualAddressEntry && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 10
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                        children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("address")
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                        name: "address-line1",
                                                        autoComplete: "address-line1",
                                                        value: manualAddress.addressLine1,
                                                        placeholder: "Address line 1",
                                                        required: true,
                                                        "aria-invalid": Boolean(validationErrors.addressLine1),
                                                        "data-open-banking-field": "addressLine1",
                                                        style: fieldErrorStyle("addressLine1"),
                                                        onChange: (e)=>{
                                                            clearValidationErrors("addressLine1");
                                                            updateManualAddress({
                                                                addressLine1: e.currentTarget.value
                                                            });
                                                        }
                                                    }),
                                                    validationErrors.addressLine1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                                        children: validationErrors.addressLine1
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            display: "flex",
                                                            justifyContent: "flex-end"
                                                        },
                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: enterAutocompleteAddressEntry,
                                                            style: {
                                                                border: "none",
                                                                background: "transparent",
                                                                color: "#97a3b6",
                                                                textDecoration: "underline",
                                                                textUnderlineOffset: 2,
                                                                cursor: "pointer",
                                                                fontSize: 13,
                                                                padding: "2px 0"
                                                            },
                                                            children: "Use address autocomplete"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                        name: "address-line2",
                                                        autoComplete: "address-line2",
                                                        value: manualAddress.addressLine2,
                                                        placeholder: "Address line 2",
                                                        onChange: (e)=>updateManualAddress({
                                                                addressLine2: e.currentTarget.value
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            gap: 10
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    gap: 6,
                                                                    flex: 1
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                                        name: "address-level2",
                                                                        autoComplete: "address-level2",
                                                                        value: manualAddress.townOrCity,
                                                                        placeholder: "City / Town",
                                                                        required: true,
                                                                        "aria-invalid": Boolean(validationErrors.townOrCity),
                                                                        "data-open-banking-field": "townOrCity",
                                                                        style: fieldErrorStyle("townOrCity"),
                                                                        onChange: (e)=>{
                                                                            clearValidationErrors("townOrCity");
                                                                            updateManualAddress({
                                                                                townOrCity: e.currentTarget.value
                                                                            });
                                                                        }
                                                                    }),
                                                                    validationErrors.townOrCity && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$d0c7d80884f46f7d), {
                                                                        children: validationErrors.townOrCity
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                                name: "postal-code",
                                                                autoComplete: "postal-code",
                                                                value: manualAddress.postalCode,
                                                                placeholder: "Postcode",
                                                                onChange: (e)=>updateManualAddress({
                                                                        postalCode: e.currentTarget.value
                                                                    })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                        name: "address-level1",
                                                        autoComplete: "address-level1",
                                                        value: manualAddress.stateOrProvince,
                                                        placeholder: "State / Region",
                                                        onChange: (e)=>updateManualAddress({
                                                                stateOrProvince: e.currentTarget.value
                                                            })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                "data-open-banking-field": "phoneNumber",
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$30c69c51aadaa8e4), {
                                                    label: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("phoneNumber"),
                                                    required: true,
                                                    value: userKycData.phoneNumber,
                                                    inputStyle: fieldErrorStyle("phoneNumber"),
                                                    validationError: validationErrors.phoneNumber,
                                                    onChange: (e)=>{
                                                        clearValidationErrors("phoneNumber");
                                                        setUserKycData((prev)=>({
                                                                ...prev,
                                                                phoneNumber: e.target.value
                                                            }));
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            position: "sticky",
                                            bottom: 0,
                                            background: "white",
                                            paddingTop: 20,
                                            zIndex: 2
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                            style: {
                                                width: "100%",
                                                marginTop: 24
                                            },
                                            onClick: ()=>{
                                                if (!validateOpenBankingBilling()) return;
                                                setErrorMessage("");
                                                trackOpenBankingStep("travelRuleCompleted");
                                                setRenderState(2);
                                            },
                                            children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("continueToSummary")
                                        })
                                    })
                                ]
                            }),
                            renderState === 2 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    height: "100%",
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 24,
                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                    fontSize: 14,
                                    marginTop: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            width: "100%",
                                            padding: 24,
                                            borderRadius: 20,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            textAlign: "center",
                                            gap: 16
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 13,
                                                    color: "#6B6C7E"
                                                },
                                                children: "You're paying"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "baseline",
                                                    justifyContent: "space-between",
                                                    gap: 8
                                                },
                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "baseline",
                                                        gap: 8
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $dd1ebb65b37f556e$export$2e2bcd8739ae039), {
                                                            size: 28,
                                                            method: fromMethod,
                                                            excludeName: true
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                            style: {
                                                                fontSize: 34,
                                                                fontWeight: 600
                                                            },
                                                            children: [
                                                                Number(totalSum).toFixed(2),
                                                                " ",
                                                                currency
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 13,
                                                    color: "#6B6C7E"
                                                },
                                                children: "Including all fees"
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    height: 1.5,
                                                    backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                    width: "100%",
                                                    opacity: 0.1
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 8,
                                                    width: "100%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            // lineHeight: '28px',
                                                            marginBottom: 14
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                style: {
                                                                    fontSize: 16,
                                                                    color: "#6B6C7E",
                                                                    fontWeight: 500
                                                                },
                                                                children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("estTime")
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                style: {
                                                                    fontWeight: 500,
                                                                    fontSize: 14
                                                                },
                                                                children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("INSTANT")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "flex-start"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                style: {
                                                                    fontSize: 12,
                                                                    color: "#6B6C7E",
                                                                    lineHeight: "20px"
                                                                },
                                                                children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("youReceive")
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "flex-end",
                                                                    gap: 4
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                        style: {
                                                                            lineHeight: "18px",
                                                                            fontWeight: 200
                                                                        },
                                                                        children: [
                                                                            Number(onrampAmount).toFixed(2),
                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                style: {
                                                                                    fontSize: 10,
                                                                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                                                },
                                                                                children: " USDC "
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                        style: {
                                                                            fontSize: 8,
                                                                            color: "#6B6C7E"
                                                                        },
                                                                        children: "on Ethereum"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    padding: 16,
                                                    backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST,
                                                    borderRadius: 16,
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    gap: 12,
                                                    flexDirection: "column",
                                                    overflowX: "auto",
                                                    scrollbarWidth: "none",
                                                    marginTop: 10,
                                                    opacity: 0.6
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                            fontSize: 14
                                                        },
                                                        children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("receivingAddress")
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            justifyContent: "space-between"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                style: {
                                                                    fontFamily: "monospace",
                                                                    fontSize: 13,
                                                                    wordBreak: "break-all"
                                                                },
                                                                children: checkoutData?.gateway.openBanking?.destinationCryptoAddress ?? randomAddress
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a25f930b859b61aa$export$2e2bcd8739ae039), {
                                                                stroke: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                                style: {
                                                                    height: 16,
                                                                    width: "auto",
                                                                    cursor: "default"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10,
                                            marginTop: 40
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    marginLeft: 5,
                                                    fontSize: 11,
                                                    lineHeight: 1.5,
                                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                },
                                                children: [
                                                    "By continuing, you agree to our",
                                                    " ",
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                                            cursor: "pointer"
                                                        },
                                                        onClick: ()=>window.open("https://www.radom.com/terms", "_blank"),
                                                        children: "Terms and Conditions"
                                                    }),
                                                    " ",
                                                    "and",
                                                    " ",
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                                            cursor: "pointer"
                                                        },
                                                        onClick: ()=>window.open("https://www.radom.com/acceptable-use-policy", "_blank"),
                                                        children: "Acceptable Use Policy"
                                                    }),
                                                    ". You confirm that you are not purchasing crypto assets for investment purposes and understand the risks involved in digital asset transactions."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                disabled: isLoading,
                                                onClick: ()=>{
                                                    trackOpenBankingStep("paymentInitiated");
                                                    setIsLoading(true);
                                                    localStorage.setItem("OpenBankingAprove", "true");
                                                    if (!$35ce030e39d4f986$var$isSecureHostedUrl(checkoutData?.gateway.openBanking?.openBankingCheckoutUrl)) (0, $43c053927acc0cba$export$2e2bcd8739ae039).updateCustomerKycData(checkoutId ?? "", $35ce030e39d4f986$var$buildOpenBankingCustomerPayload(userKycData)).then(async ()=>{
                                                        const res = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getCheckoutSession(checkoutId ?? "");
                                                        const checkoutUrl = res.gateway.openBanking?.openBankingCheckoutUrl;
                                                        if (!checkoutUrl) setOpenbankPayStatus("kyc");
                                                        else {
                                                            setOpenBankingCheckoutUrl(checkoutUrl);
                                                            setOpenbankPayStatus("waiting");
                                                        }
                                                        setIsLoading(false);
                                                    }).catch((e)=>{
                                                        setErrorMessage(e.message || "");
                                                        setIsLoading(false);
                                                    });
                                                    else {
                                                        setIsLoading(false);
                                                        setOpenbankPayStatus("waiting");
                                                    }
                                                },
                                                style: {
                                                    marginTop: 20,
                                                    width: "100%",
                                                    minHeight: 52,
                                                    borderRadius: 14,
                                                    fontSize: 16,
                                                    fontWeight: 500,
                                                    backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLUE4
                                                },
                                                children: isLoading ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    children: (0, $d5ca48e110fef8bd$export$625550452a3fa3ec)("agreeAndContinue")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            errorMessage && errorMessage.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                style: {
                    backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR,
                    padding: 15,
                    borderRadius: 5,
                    marginBottom: 20,
                    color: "white",
                    overflowWrap: "break-word"
                },
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    fontSize: 12
                },
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                        href: "https://www.radom.com/industries/igaming",
                        target: "_blank",
                        title: "Crypto Presale Powered by Radom",
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                            cursor: "pointer",
                            userSelect: "none",
                            textDecoration: "none",
                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                        },
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: 13,
                                    fontWeight: 500
                                },
                                children: [
                                    "Powered by",
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                        width: 60,
                                        height: 14,
                                        fill: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                style: {
                                    position: "absolute",
                                    width: "1px",
                                    height: "1px",
                                    margin: "-1px",
                                    padding: 0,
                                    overflow: "hidden",
                                    clip: "rect(0, 0, 0, 0)",
                                    border: 0
                                },
                                children: "Radom"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const $35ce030e39d4f986$var$HostedCheckout = ()=>{
    const { checkoutId: checkoutId } = (0, $6738ab3539650fb6$export$99eaa27ddbbb95ef)();
    const [searchParams] = (0, $f0e8e6c6e69cddf0$export$f1a78c17382fe22a)();
    const posMode = (0, $bnENU.useMemo)(()=>searchParams.get("posMode"), []);
    const isOpenBankingRedirectReturn = searchParams.get("forceRedirect") === "true";
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(true);
    const [isPreProcessingPayment, setIsPreProcessingPayment] = (0, $bnENU.useState)(false);
    const [isExpired, setIsExpired] = (0, $bnENU.useState)(false);
    const [isComplete, setIsComplete] = (0, $bnENU.useState)(false);
    const [isSuccess, setIsSuccess] = (0, $bnENU.useState)(false);
    const [successElement, setSuccessElement] = (0, $bnENU.useState)(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {}));
    const [loadError, setLoadError] = (0, $bnENU.useState)("");
    const [errorMessage, setErrorMessage] = (0, $bnENU.useState)("");
    const [totalSum, setTotalSum] = (0, $bnENU.useState)(0);
    const [currency, setCurrency] = (0, $bnENU.useState)($35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY);
    const [checkoutData, setCheckoutData] = (0, $bnENU.useState)();
    const [addressSuggestionList, setAddressSuggestionList] = (0, $bnENU.useState)([]);
    const [managedPaymentDetails, setManagedPaymentDetails] = (0, $bnENU.useState)();
    const [tokenDelegatePaymentDetails, setTokenDelegatePaymentDetails] = (0, $bnENU.useState)();
    const [discountCode, setDiscountCode] = (0, $bnENU.useState)("");
    const [discountResult, setDiscountResult] = (0, $bnENU.useState)({
        success: false,
        element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {})
    });
    const [discount, setDiscount] = (0, $bnENU.useState)();
    const [discountLocked, setDiscountLocked] = (0, $bnENU.useState)(false);
    const [paymentStatus, setPaymentStatus] = (0, $bnENU.useState)();
    const managedPollingIntervalRef = (0, $bnENU.useRef)(null);
    const trackedFunnelStepsRef = (0, $bnENU.useRef)(new Set());
    const trackHostedCheckoutStep = (0, $bnENU.useCallback)((rail, step, metadata)=>{
        if (!checkoutId) return;
        const dedupeKey = `${rail}:${step}`;
        if (trackedFunnelStepsRef.current.has(dedupeKey)) return;
        trackedFunnelStepsRef.current.add(dedupeKey);
        (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
            sourceType: "checkoutSession",
            sourceId: checkoutId,
            rail: rail,
            step: step,
            metadata: metadata
        });
    }, [
        checkoutId
    ]);
    const [isOpenbank, setIsOpenbank] = (0, $bnENU.useState)(false);
    const [openbankPayStatus, setOpenbankPayStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($bnENU))).useState("initial");
    const openBankingIntervalRef = (0, $bnENU.useRef)(null);
    const openBankingReturnIntervalRef = (0, $bnENU.useRef)(null);
    const allowCountries = [
        "Austria",
        "Belgium",
        "Bulgaria",
        "Croatia",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Estonia",
        "Finland",
        "France",
        "Germany",
        "Greece",
        "Hungary",
        "Iceland",
        "Ireland",
        "Italy",
        "Latvia",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Malta",
        "Netherlands",
        "Norway",
        "Poland",
        "Portugal",
        "Romania",
        "Slovakia",
        "Slovenia",
        "Spain",
        "Sweden",
        "United Kingdom"
    ];
    const allCountries = (0, $e80c2cf8ebb93fb4$export$2e2bcd8739ae039).getAllCountries().filter((c)=>{
        return allowCountries.includes(c.name);
    });
    const [userKycData, setUserKycData] = (0, $bnENU.useState)({
        name: "",
        phoneNumber: "",
        countryOfResidence: "",
        address: "",
        dateOfBirth: "",
        passportFile: "",
        idCardFile: "",
        selfieFile: ""
    });
    const [checkMarkOpenbanking, setCheckMarkOpenBanking] = (0, $bnENU.useState)(false);
    const randomAddress = (0, $bnENU.useMemo)(()=>"0x" + [
            ...Array(40)
        ].map(()=>"0123456789abcdef"[Math.floor(Math.random() * 16)]).join(""), []);
    const [openBankingCheckoutUrl, setOpenBankingCheckoutUrl] = (0, $bnENU.useState)("");
    const hasOpenBankingCheckout = !!checkoutData?.gateway.openBanking;
    const openBankingReturnStatusCopy = $35ce030e39d4f986$var$getOpenBankingReturnStatusCopy(checkoutData?.openBankingPaymentData, checkoutData?.sessionStatus);
    const debouncedFetch = (0, $bnENU.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($fDWVA))).debounce((value, countryCode, setAddressSuggestionList)=>{
        (0, $43c053927acc0cba$export$2e2bcd8739ae039).getGoolgePlaceAutoComplete(value, countryCode).then((res)=>{
            setAddressSuggestionList(res);
        });
    }, 500)).current;
    // Start by assuming that none of the travel rule fields have been collected
    const [travelRuleFieldsCollected, setTravelRuleFieldsCollected] = (0, $bnENU.useState)((0, $8652974033b0a752$export$3e77b1380e63cfaf)());
    (0, $bnENU.useEffect)(()=>{
        if (!checkoutData?.gateway.openBanking) return;
        if (openBankingIntervalRef.current) clearInterval(openBankingIntervalRef.current);
        if (checkoutData?.sessionStatus === "success" || checkoutData?.sessionStatus === "refunded") {
            setOpenbankPayStatus("success");
            return;
        }
        if (checkoutData?.sessionStatus === "expired") {
            setOpenbankPayStatus("expired");
            return;
        }
        if ($35ce030e39d4f986$var$isOpenBankingProviderFailed(checkoutData.openBankingPaymentData)) {
            setErrorMessage(openBankingReturnStatusCopy.body);
            setOpenbankPayStatus("error");
            return;
        }
        if (isOpenBankingRedirectReturn) {
            setOpenbankPayStatus("kyc_pending_view");
            setRenderOpenBankingState(2);
            setIsLoading(false);
            return;
        }
        if (checkoutData?.gateway.openBanking?.openBankingCheckoutUrl && checkoutData?.gateway.openBanking?.openBankingCheckoutUrl !== "") {
            if ($35ce030e39d4f986$var$isSecureHostedUrl(checkoutData?.gateway.openBanking?.openBankingCheckoutUrl)) {
                setOpenbankPayStatus("kyc_pending_view");
                const openBankingClicked = localStorage.getItem("OpenBankingAprove");
                setTimeout(()=>{
                    if (checkoutData?.gateway.openBanking?.existingUserPaidSuccess === true || openBankingClicked) setOpenbankPayStatus("waiting");
                    else setOpenbankPayStatus("initial");
                    setRenderOpenBankingState(2);
                }, 2000);
            } else {
                setErrorMessage($35ce030e39d4f986$var$formatOpenBankingErrorMessage(checkoutData?.gateway.openBanking?.openBankingCheckoutUrl));
                setOpenbankPayStatus("error");
            }
        }
        setIsLoading(false);
    }, [
        checkoutData?.gateway.openBanking,
        checkoutData?.openBankingPaymentData,
        checkoutData?.sessionStatus,
        isOpenBankingRedirectReturn,
        openBankingReturnStatusCopy.body
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (openbankPayStatus === "success") trackHostedCheckoutStep("openBanking", "paymentConfirmed", {
            sessionStatus: checkoutData?.sessionStatus,
            openBankingStatus: checkoutData?.openBankingPaymentData?.status,
            redirectReturn: isOpenBankingRedirectReturn
        });
    }, [
        checkoutData?.openBankingPaymentData?.status,
        checkoutData?.sessionStatus,
        isOpenBankingRedirectReturn,
        openbankPayStatus,
        trackHostedCheckoutStep
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (openbankPayStatus === "error") trackHostedCheckoutStep("openBanking", "paymentFailed", {
            sessionStatus: checkoutData?.sessionStatus,
            openBankingStatus: checkoutData?.openBankingPaymentData?.status,
            redirectReturn: isOpenBankingRedirectReturn,
            reason: errorMessage || openBankingReturnStatusCopy.body
        });
    }, [
        checkoutData?.openBankingPaymentData?.status,
        checkoutData?.sessionStatus,
        errorMessage,
        isOpenBankingRedirectReturn,
        openBankingReturnStatusCopy.body,
        openbankPayStatus,
        trackHostedCheckoutStep
    ]);
    const getCheckoutData = async ()=>{
        if (!checkoutId) {
            setLoadError("Checkout session ID is missing.");
            return;
        }
        setLoadError("");
        try {
            const processCheckoutSession = (checkoutSession)=>({
                    ...checkoutSession,
                    successUrl: checkoutSession.successUrl ? (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(checkoutSession.successUrl.replace("{CHECKOUT_SESSION_ID}", checkoutSession.id)) : "",
                    cancelUrl: (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(checkoutSession.cancelUrl?.replace("{CHECKOUT_SESSION_ID}", checkoutSession.id))
                });
            const c = processCheckoutSession(await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getCheckoutSession(checkoutId, {
                refreshOpenBankingStatus: isOpenBankingRedirectReturn
            }));
            const p = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getSellerProfile(c.organizationId);
            trackHostedCheckoutStep(c.gateway.openBanking ? "openBanking" : "crypto", "viewed");
            // Which travel rule fields have already been collected?
            setTravelRuleFieldsCollected({
                countryOfResidenceCollected: c.travelRuleFields.countryOfResidenceCollected,
                dateOfBirthCollected: c.travelRuleFields.dateOfBirthCollected,
                emailAddressCollected: c.travelRuleFields.emailAddressCollected,
                nameCollected: c.travelRuleFields.nameCollected,
                companyNameCollected: c.travelRuleFields.companyNameCollected,
                accountType: c.travelRuleFields.accountType,
                addressLine1Collected: c.travelRuleFields.addressLine1Collected,
                addressLine2Collected: c.travelRuleFields.addressLine2Collected,
                townOrCityCollected: c.travelRuleFields.townOrCityCollected,
                postalCodeCollected: c.travelRuleFields.postalCodeCollected,
                stateOrProvinceCollected: c.travelRuleFields.stateOrProvinceCollected
            });
            const cData = {
                ...c,
                total: c.total !== undefined && c.total !== null ? Number(c.total) : undefined,
                sellerLogoUrl: p?.logoUrl ?? "",
                sellerName: p?.name ?? c.sellerAddress,
                products: c.products?.map((p)=>{
                    return {
                        product: p,
                        quantity: 1
                    };
                }) ?? [],
                lineItems: c.items
            };
            setCheckoutData(cData);
            if ((c.metadata ?? []).filter((m)=>m.key === "locale").length > 0) (0, $d5ca48e110fef8bd$export$4b6bf64406ec64af)(c.metadata?.find((m)=>m.key === "locale")?.value ?? "en");
            else (0, $d5ca48e110fef8bd$export$4b6bf64406ec64af)("en");
            if (c.gateway.openBanking) {
                setIsOpenbank(true);
                const openBankingGateway = c.gateway.openBanking;
                const kycData = openBankingGateway.kycData;
                const nextUserKycData = {
                    name: kycData?.name ?? "",
                    phoneNumber: kycData?.phone ?? "",
                    countryOfResidence: openBankingGateway.residenceCountry ?? "",
                    address: kycData?.address ?? "",
                    dateOfBirth: kycData?.dob ?? "",
                    passportFile: "",
                    idCardFile: "",
                    selfieFile: ""
                };
                setUserKycData(nextUserKycData);
                setOpenBankingCheckoutUrl(openBankingGateway.openBankingCheckoutUrl ?? "");
                if ($35ce030e39d4f986$var$hasCompleteOpenBankingCustomerDetails(nextUserKycData, openBankingGateway.email)) setRenderOpenBankingState(2);
                else if (!openBankingGateway.destinationCryptoAddress) setRenderOpenBankingState(1);
            }
            const products = [];
            if (c.products) c.products.forEach((p)=>{
                products.push({
                    product: {
                        ...p,
                        chargingIntervalSeconds: p.chargingIntervalSeconds || 0
                    },
                    quantity: 1
                });
            });
            if (c.items) c.items.forEach((lineItem)=>{
                const lineProduct = {
                    id: "",
                    name: lineItem.name,
                    description: lineItem.description ?? "",
                    chargingIntervalSeconds: lineItem.chargingIntervalSeconds || 0,
                    price: lineItem.price,
                    currency: lineItem.currency ?? $35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY,
                    createdAt: new Date(),
                    imageUrl: lineItem.imageUrl,
                    updatedAt: new Date(),
                    sellerAddress: checkoutData?.sellerAddress ?? ""
                };
                products.push({
                    product: lineProduct,
                    quantity: 1
                });
            });
            const hasPaymentInFlight = !!checkoutId && !!(0, $f8c8710feaaa9285$export$f4d961d73df7b7b)(checkoutId);
            if (c.expiresAt && new Date(c.expiresAt) < new Date() && !hasPaymentInFlight) setIsExpired(true);
            if (c.sessionStatus === "cancelled") {
                if (c.cancelUrl && !c.gateway.openBanking) setTimeout(()=>{
                    window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(c.cancelUrl);
                }, 2000);
            }
            if (c.sessionStatus === "success" || c.sessionStatus === "refunded") {
                setIsComplete(true);
                if (c.successUrl && !c.gateway.openBanking) setTimeout(()=>{
                    window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(c.successUrl);
                }, 3000);
                else if (c.gateway.openBanking) {
                    if (c.successUrl && c.gateway.openBanking.destinationCryptoAddress === null) setTimeout(()=>{
                        window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(c.successUrl);
                    }, 3000);
                }
            }
            if (Number(c.total) > 0) {
                setTotalSum(Number(c.total));
                setCurrency(c.currency ?? $35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY);
            } else {
                let primaryCurrency = $35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY;
                const subscriptionProducts = products.filter((product)=>product.product.chargingIntervalSeconds > 0);
                if (subscriptionProducts.length > 0) primaryCurrency = subscriptionProducts[0]?.product.currency ?? $35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY;
                else if (cData.products && cData.products.length > 0) primaryCurrency = cData.products?.[0]?.product?.currency ?? $35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY;
                setCurrency(primaryCurrency);
                const productCurrencies = [
                    ...cData.items?.map((i)=>i.currency ?? $35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY),
                    ...cData.products?.map((p)=>p.product.currency)
                ];
                try {
                    const quotes = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getPriceQuotes(productCurrencies, [
                        primaryCurrency
                    ]);
                    const [total] = (0, $94d9469e1ad800ce$export$56eaa5cece9d2d8a)(cData, quotes, primaryCurrency);
                    setTotalSum(total);
                } catch (err) {
                    console.error("Failed to load checkout price quotes", err);
                }
            }
        } catch (err) {
            console.error("Failed to load checkout session", err);
            setLoadError(err?.response?.data?.error ?? err?.message ?? "Unable to load checkout right now.");
        }
    };
    const getPriceQuotes = ()=>{
        if (!checkoutData) return;
        const normalizedCheckoutTotal = Number(checkoutData.total ?? 0);
        const hasProvidedTotal = Number.isFinite(normalizedCheckoutTotal) && normalizedCheckoutTotal > 0;
        const productCurrencies = [
            ...checkoutData.lineItems?.map((i)=>i.currency ?? $35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY) ?? [
                $35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY
            ],
            ...checkoutData.products?.map((p)=>p.product.currency) ?? [
                $35ce030e39d4f986$var$DEFAULT_FIAT_CURRENCY
            ]
        ];
        if (productCurrencies.length === 0) {
            if (hasProvidedTotal) setTotalSum(normalizedCheckoutTotal);
            return;
        }
        (0, $43c053927acc0cba$export$2e2bcd8739ae039).getPriceQuotes(productCurrencies, [
            currency
        ]).then((p)=>{
            // Get price quotes in terms of first product's currency
            const [total] = (0, $94d9469e1ad800ce$export$56eaa5cece9d2d8a)(checkoutData, p, currency);
            const normalizedTotal = Number(total);
            setTotalSum(Number.isFinite(normalizedTotal) && normalizedTotal > 0 ? normalizedTotal : hasProvidedTotal ? normalizedCheckoutTotal : 0);
        }).catch((err)=>{
            console.error("Failed to refresh price quotes", err);
            if (hasProvidedTotal) setTotalSum(normalizedCheckoutTotal);
        });
    };
    const clearManagedPaymentPolling = ()=>{
        if (managedPollingIntervalRef.current) {
            clearInterval(managedPollingIntervalRef.current);
            managedPollingIntervalRef.current = null;
        }
    };
    const startManagedPaymentPolling = (managed)=>{
        clearManagedPaymentPolling();
        let appliedOutcome;
        managedPollingIntervalRef.current = setInterval(()=>{
            (0, $43c053927acc0cba$export$2e2bcd8739ae039).getManagedPaymentStatus(managed.paymentId).then((res)=>{
                setPaymentStatus(res);
                if (res.status === "inReview") {
                    if (appliedOutcome !== "inReview") {
                        appliedOutcome = "inReview";
                        setIsSuccess(true);
                        setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$de273779fa7d2ee0), {}));
                    }
                    return;
                }
                if (res.status === "paymentConfirmed") {
                    appliedOutcome = "paymentConfirmed";
                    trackHostedCheckoutStep("crypto", "paymentConfirmed");
                    if (checkoutId) (0, $f8c8710feaaa9285$export$a774b110a5502c04)(checkoutId);
                    if (checkoutData?.successUrl && !posMode) setTimeout(()=>{
                        if (checkoutData?.successUrl) window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(checkoutData.successUrl);
                    }, 3000);
                    setIsSuccess(true);
                    clearManagedPaymentPolling();
                    setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$e2668574711a3262), {}));
                }
                if (res.status === "failed" || res.status === "expired") {
                    if (res.status === "failed") trackHostedCheckoutStep("crypto", "paymentFailed");
                    if (checkoutId) (0, $f8c8710feaaa9285$export$a774b110a5502c04)(checkoutId);
                    clearManagedPaymentPolling();
                }
            }).catch(()=>{});
        }, 1000);
    };
    const startTokenDelegatePolling = (paymentId)=>{
        clearManagedPaymentPolling();
        let appliedOutcome;
        managedPollingIntervalRef.current = setInterval(()=>{
            (0, $43c053927acc0cba$export$2e2bcd8739ae039).getManagedTokenPaymentStatus(paymentId).then((res)=>{
                setPaymentStatus(res);
                if (res.status === "inReview") {
                    if (appliedOutcome !== "inReview") {
                        appliedOutcome = "inReview";
                        setIsPreProcessingPayment(false);
                        setIsSuccess(true);
                        setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$de273779fa7d2ee0), {}));
                    }
                    return;
                }
                if (res.status === "paymentConfirmed") {
                    appliedOutcome = "paymentConfirmed";
                    trackHostedCheckoutStep("crypto", "paymentConfirmed");
                    setIsPreProcessingPayment(false);
                    setIsSuccess(true);
                    clearManagedPaymentPolling();
                    if (checkoutId) (0, $f8c8710feaaa9285$export$a774b110a5502c04)(checkoutId);
                    setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$e2668574711a3262), {}));
                    setTimeout(()=>{
                        if (checkoutData?.successUrl) window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(checkoutData.successUrl);
                    }, 3000);
                }
                if (res.status === "failed") {
                    trackHostedCheckoutStep("crypto", "paymentFailed");
                    clearManagedPaymentPolling();
                    if (checkoutId) (0, $f8c8710feaaa9285$export$a774b110a5502c04)(checkoutId);
                    setIsPreProcessingPayment(false);
                    setTokenDelegatePaymentDetails(undefined);
                    setErrorMessage("Transaction failed, please try again.");
                }
            }).catch(()=>{});
        }, 1000);
    };
    (0, $bnENU.useEffect)(()=>{
        if (!checkoutId || !checkoutData || isComplete || isExpired || managedPollingIntervalRef.current) return;
        const session = (0, $f8c8710feaaa9285$export$f4d961d73df7b7b)(checkoutId);
        if (!session) return;
        if (session.managed) {
            setDiscountLocked(true);
            setManagedPaymentDetails(session.managed);
            startManagedPaymentPolling(session.managed);
            return;
        }
        if (session.tokenDelegate && session.delegateSubmitted) {
            setDiscountLocked(true);
            setIsPreProcessingPayment(true);
            setTokenDelegatePaymentDetails(session.tokenDelegate);
            startTokenDelegatePolling(session.tokenDelegate.paymentId);
        }
    }, [
        checkoutId,
        checkoutData,
        isComplete,
        isExpired
    ]);
    (0, $bnENU.useEffect)(()=>clearManagedPaymentPolling, []);
    const onCheckout = async ({ managed: managed, completeTokenDelegate: completeTokenDelegate, subscriptionOptions: subscriptionOptions })=>{
        if (managed) {
            if (!checkoutData) throw new Error("Something went wrong");
            if (!checkoutId) throw new Error("Something went wrong");
            const storedSession = (0, $f8c8710feaaa9285$export$f4d961d73df7b7b)(checkoutId);
            if (storedSession?.managed) {
                setDiscountLocked(true);
                setManagedPaymentDetails(storedSession.managed);
                startManagedPaymentPolling(storedSession.managed);
                return;
            }
            const { selectedMethod: method } = managed;
            let paymentMethod = {
                managed: {
                    method: {
                        network: method.tokenInfo?.networkName ?? method.name,
                        token: method.tokenInfo?.tokenAddress ?? undefined
                    }
                }
            };
            if (subscriptionOptions) {
                if (subscriptionOptions.autopay) {
                    if (!method.tokenInfo) {
                        setErrorMessage("Cannot set up an autopay subscription without an EVM based token");
                        return;
                    }
                    paymentMethod = {
                        managedTokenDelegate: {
                            buyerAddress: subscriptionOptions.autopay.address,
                            network: method.tokenInfo.networkName,
                            token: method.tokenInfo.tokenAddress
                        }
                    };
                }
                if (subscriptionOptions.emailInvoice) {
                    if (!subscriptionOptions.emailInvoice.emailAddress) {
                        setErrorMessage("Cannot set up an email invoice subscription without an email address");
                        return;
                    }
                }
            }
            trackHostedCheckoutStep("crypto", "travelRuleCompleted");
            setIsPreProcessingPayment(true);
            try {
                const res = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).createCheckoutSessionOrder({
                    checkoutSessionId: checkoutId,
                    paymentMethod: paymentMethod,
                    orderData: [],
                    orderProductData: [],
                    emailAddress: subscriptionOptions?.emailInvoice?.emailAddress.toLowerCase(),
                    discountCode: discountCode
                });
                trackHostedCheckoutStep("crypto", "paymentInitiated", {
                    network: method.tokenInfo?.networkName ?? method.name,
                    tokenAddress: method.tokenInfo?.tokenAddress
                });
                setDiscountLocked(true);
                if (res.paymentMethodDetails.managed) {
                    const managedDetails = res.paymentMethodDetails.managed;
                    setManagedPaymentDetails(managedDetails);
                    if (checkoutId) (0, $f8c8710feaaa9285$export$b96aa13c6879f837)(checkoutId, {
                        managed: managedDetails
                    });
                    startManagedPaymentPolling(managedDetails);
                } else if (res.paymentMethodDetails.managedTokenDelegate) {
                    const delegateDetails = res.paymentMethodDetails.managedTokenDelegate;
                    setTokenDelegatePaymentDetails(delegateDetails);
                    if (checkoutId) (0, $f8c8710feaaa9285$export$b96aa13c6879f837)(checkoutId, {
                        tokenDelegate: delegateDetails
                    });
                } else throw new Error("Unexpected empty managed payment method details");
            } catch (err) {
                console.error(err);
                if (err.message === "Checkout session is complete") {
                    setIsLoading(false);
                    trackHostedCheckoutStep("crypto", "paymentConfirmed");
                    setIsSuccess(true);
                    setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$e2668574711a3262), {}));
                } else {
                    trackHostedCheckoutStep("crypto", "paymentFailed");
                    setErrorMessage(err.reason || err.message);
                    setDiscountLocked(false);
                }
            }
            setIsPreProcessingPayment(false);
        }
        if (completeTokenDelegate) {
            const { paymentId: paymentId, signature: signature } = completeTokenDelegate;
            setIsPreProcessingPayment(true);
            try {
                trackHostedCheckoutStep("crypto", "paymentInitiated");
                await (0, $43c053927acc0cba$export$2e2bcd8739ae039).completeTokenDelegatePayment(paymentId, signature);
                if (checkoutId && tokenDelegatePaymentDetails) (0, $f8c8710feaaa9285$export$b96aa13c6879f837)(checkoutId, {
                    tokenDelegate: tokenDelegatePaymentDetails,
                    delegateSubmitted: true
                });
                startTokenDelegatePolling(paymentId);
            } catch (err) {
                trackHostedCheckoutStep("crypto", "paymentFailed");
                setErrorMessage(err.reason || err.message);
                setIsPreProcessingPayment(false);
            }
        }
    };
    const redeemDiscountCode = async (discountCode)=>{
        if (!checkoutId) return;
        setDiscountCode(discountCode);
        setDiscountResult({
            success: false,
            element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {})
        });
        (0, $43c053927acc0cba$export$2e2bcd8739ae039).redeemDiscountCode({
            checkoutSessionId: checkoutId,
            code: discountCode
        }).then((discount)=>{
            setDiscount(discount);
            setDiscountResult({
                success: true,
                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        gap: 10,
                        alignItems: "center",
                        fontSize: 14
                    },
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                            children: "Discount applied!"
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                            style: {
                                padding: 5,
                                backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS,
                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS_LIGHT,
                                borderRadius: 5,
                                fontWeight: 600,
                                fontSize: 12
                            },
                            children: [
                                discount.model.modelType === "percentage" ? new Intl.NumberFormat("en-US", {
                                    style: "percent",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                }).format(discount.model.amountOff / 100) : (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, discount.model.amountOff),
                                " OFF"
                            ]
                        })
                    ]
                })
            });
        }).catch((_)=>{
            setDiscountResult({
                success: false,
                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                    style: {
                        opacity: 0.5,
                        fontSize: 12
                    },
                    children: "Invalid discount code"
                })
            });
        });
    };
    const resetDiscountCode = ()=>{
        setDiscountResult({
            success: false,
            element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {})
        });
        setDiscount(undefined);
        setDiscountCode("");
    };
    const [renderOpenBankingState, setRenderOpenBankingState] = (0, $bnENU.useState)(0);
    (0, $bnENU.useEffect)(()=>{
        document.title = "Radom - Checkout";
        getCheckoutData().finally(()=>setIsLoading(false));
    }, []);
    (0, $bnENU.useEffect)(()=>{
        if (!isOpenBankingRedirectReturn || !checkoutId || !hasOpenBankingCheckout) return;
        trackHostedCheckoutStep("openBanking", "bankRedirectReturned", {
            sessionStatus: checkoutData?.sessionStatus,
            openBankingStatus: checkoutData?.openBankingPaymentData?.status
        });
    }, [
        checkoutId,
        hasOpenBankingCheckout,
        isOpenBankingRedirectReturn,
        trackHostedCheckoutStep
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (!isOpenBankingRedirectReturn || !checkoutId || !hasOpenBankingCheckout) return;
        if (openbankPayStatus === "success" || openbankPayStatus === "expired" || openbankPayStatus === "error") return;
        const clearReturnInterval = ()=>{
            if (openBankingReturnIntervalRef.current) {
                clearInterval(openBankingReturnIntervalRef.current);
                openBankingReturnIntervalRef.current = null;
            }
        };
        const refreshOpenBankingReturnStatus = async ()=>{
            try {
                const res = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getCheckoutSession(checkoutId, {
                    refreshOpenBankingStatus: true
                });
                const openBankingGateway = res.gateway.openBanking;
                setCheckoutData((prev)=>{
                    if (!prev) return prev;
                    return {
                        ...prev,
                        sessionStatus: res.sessionStatus,
                        gateway: {
                            ...prev.gateway,
                            openBanking: openBankingGateway ?? prev.gateway.openBanking
                        },
                        openBankingPaymentData: res.openBankingPaymentData
                    };
                });
                setRenderOpenBankingState(2);
                if (res.sessionStatus === "success" || res.sessionStatus === "refunded") {
                    localStorage.removeItem("OpenBankingAprove");
                    setOpenbankPayStatus("success");
                    clearReturnInterval();
                    if (!$35ce030e39d4f986$var$hasOpenBankingDestinationAddress(openBankingGateway?.destinationCryptoAddress) && res.successUrl) setTimeout(()=>{
                        window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(res.successUrl);
                    }, 1500);
                    return;
                }
                if (res.sessionStatus === "expired") {
                    setOpenbankPayStatus("expired");
                    clearReturnInterval();
                    return;
                }
                if (res.sessionStatus === "cancelled") {
                    if (res.cancelUrl) window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(res.cancelUrl);
                    else {
                        setErrorMessage($35ce030e39d4f986$var$getOpenBankingReturnStatusCopy(res.openBankingPaymentData, res.sessionStatus).body);
                        setOpenbankPayStatus("error");
                    }
                    clearReturnInterval();
                    return;
                }
                if ($35ce030e39d4f986$var$isOpenBankingProviderFailed(res.openBankingPaymentData)) {
                    setErrorMessage($35ce030e39d4f986$var$getOpenBankingReturnStatusCopy(res.openBankingPaymentData, res.sessionStatus).body);
                    setOpenbankPayStatus("error");
                    clearReturnInterval();
                    return;
                }
                if ($35ce030e39d4f986$var$isOpenBankingProviderConfirmed(res.openBankingPaymentData)) localStorage.removeItem("OpenBankingAprove");
                setOpenbankPayStatus("kyc_pending_view");
            } catch (err) {
                console.error("Failed to refresh open banking checkout after bank redirect", err);
                setOpenbankPayStatus("kyc_pending_view");
            }
        };
        clearReturnInterval();
        openBankingReturnIntervalRef.current = setInterval(()=>{
            refreshOpenBankingReturnStatus();
        }, 3000);
        refreshOpenBankingReturnStatus();
        return clearReturnInterval;
    }, [
        checkoutId,
        hasOpenBankingCheckout,
        isOpenBankingRedirectReturn,
        openbankPayStatus
    ]);
    (0, $bnENU.useEffect)(()=>{
        const discountCode = searchParams.get("discountCode");
        if (discountCode) {
            setDiscountCode(discountCode);
            redeemDiscountCode(discountCode);
        }
    }, [
        searchParams
    ]);
    if (loadError) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7c18a005ad02503d$export$2e2bcd8739ae039), {
        title: "Checkout unavailable",
        message: loadError,
        onRetry: async ()=>{
            setIsLoading(true);
            await getCheckoutData().finally(()=>setIsLoading(false));
        }
    });
    if (isExpired) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7c18a005ad02503d$export$2e2bcd8739ae039), {
        title: "Checkout session expired",
        message: "This checkout session has expired. Start again to generate a fresh payment request.",
        retryLabel: checkoutData?.cancelUrl ? "Return to merchant" : "Refresh checkout",
        onRetry: async ()=>{
            if (checkoutData?.cancelUrl) {
                window.location.href = (0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(checkoutData.cancelUrl);
                return;
            }
            setIsLoading(true);
            await getCheckoutData().finally(()=>setIsLoading(false));
        }
    });
    if (posMode) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "white",
            zIndex: 100,
            display: "flex",
            flexDirection: "column",
            padding: "30px",
            alignItems: "center",
            justifyContent: "space-between",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                style: {
                    fontWeight: 200
                },
                children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(currency, totalSum)
            }),
            !isComplete && checkoutData && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                style: {
                    maxWidth: "600px",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "auto"
                },
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $06825994d276e479$export$2e2bcd8739ae039), {
                    currency: currency,
                    checkoutData: checkoutData,
                    isPreProcessingPayment: isPreProcessingPayment,
                    isSuccess: isSuccess,
                    onCheckout: onCheckout,
                    managedPaymentDetails: managedPaymentDetails,
                    onChangePaymentMethod: ()=>{
                        clearManagedPaymentPolling();
                        if (checkoutId) (0, $f8c8710feaaa9285$export$a774b110a5502c04)(checkoutId);
                        setManagedPaymentDetails(undefined);
                        setTokenDelegatePaymentDetails(undefined);
                        setPaymentStatus(undefined);
                        setErrorMessage("");
                        setIsPreProcessingPayment(false);
                    },
                    onQuoteUpdate: ()=>getPriceQuotes(),
                    errorMessage: errorMessage,
                    successElement: successElement,
                    paymentStatus: paymentStatus,
                    posMode: true,
                    travelRuleFieldsCollected: travelRuleFieldsCollected
                })
            })
        ]
    });
    if (isOpenbank) {
        const isIvyCheckoutVisible = openbankPayStatus === "waiting";
        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: isIvyCheckoutVisible ? "100dvh" : "auto",
                minHeight: "100dvh",
                fontSize: 15,
                background: "#d9dddf",
                overflow: isIvyCheckoutVisible ? "hidden" : "visible"
            },
            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                style: {
                    position: "relative",
                    padding: isIvyCheckoutVisible ? 0 : "40px 30px",
                    background: "white",
                    minHeight: isIvyCheckoutVisible ? "auto" : 680,
                    height: isIvyCheckoutVisible ? "min(760px, calc(100dvh - 20px))" : "auto",
                    // minHeight: 650,
                    transition: "0.2s ease height",
                    width: isIvyCheckoutVisible ? "min(100vw, 520px)" : "95vw",
                    maxWidth: isIvyCheckoutVisible ? "520px" : "500px",
                    borderRadius: isIvyCheckoutVisible ? 16 : 15,
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    gap: isIvyCheckoutVisible ? 0 : 30,
                    marginTop: isIvyCheckoutVisible ? 0 : 10,
                    marginBottom: isIvyCheckoutVisible ? 0 : 10,
                    overflow: isIvyCheckoutVisible ? "hidden" : "visible",
                    boxShadow: isIvyCheckoutVisible ? "0 18px 50px rgba(15, 23, 42, 0.18)" : undefined
                },
                children: [
                    openbankPayStatus === "success" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            position: "relative",
                            margin: "10px 20px",
                            background: "white",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 600
                        },
                        children: [
                            checkoutData?.gateway.openBanking?.destinationCryptoAddress === null && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                        style: {
                                            background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                            width: 45,
                                            height: 45
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d8ee75bdf024b924$export$2e2bcd8739ae039), {
                                            animationDelay: "0.5s",
                                            animationSpeed: "0.75s",
                                            stroke: "white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            fontSize: 18,
                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                        },
                                        children: "Payment successful"
                                    })
                                ]
                            }),
                            checkoutData?.gateway.openBanking?.destinationCryptoAddress && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    fontSize: 16
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            transform: "translateY(-80px)",
                                            alignItems: "center",
                                            marginBottom: 5,
                                            width: "100%",
                                            fontWeight: 600,
                                            fontSize: 26,
                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY4
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $1280caa2c18f8a52$export$2e2bcd8739ae039), {
                                                style: {
                                                    width: 48,
                                                    height: 48,
                                                    marginBottom: 12
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                children: [
                                                    "Buying",
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                        style: {
                                                            color: "black",
                                                            fontWeight: 600,
                                                            marginLeft: 5
                                                        },
                                                        children: [
                                                            " ",
                                                            Number(checkoutData.gateway.openBanking.onrampAmount).toFixed(2),
                                                            "  USDC"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                children: [
                                                    "for ",
                                                    (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(checkoutData.currency ?? "", totalSum)
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("ul", {
                                        style: {
                                            position: "relative",
                                            paddingLeft: 45,
                                            listStyle: "none",
                                            margin: 0,
                                            transform: "translateY(-20px)"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 15,
                                                    width: 0,
                                                    height: "95%",
                                                    borderLeft: "2px solid #CCC",
                                                    zIndex: 0
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("li", {
                                                style: {
                                                    position: "relative",
                                                    paddingBottom: 20,
                                                    zIndex: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            position: "absolute",
                                                            left: -37,
                                                            top: 0,
                                                            width: 14,
                                                            height: 14,
                                                            borderRadius: "50%",
                                                            border: "2px solid green",
                                                            background: "green",
                                                            color: "#fff",
                                                            fontSize: 10,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        },
                                                        children: "\u2714"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("strong", {
                                                        children: "Transaction created"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            color: "#6B6C7E",
                                                            fontSize: 14
                                                        },
                                                        children: checkoutData.createdAt ? new Date(checkoutData.createdAt).toLocaleString() : ""
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("li", {
                                                style: {
                                                    position: "relative",
                                                    paddingBottom: 20,
                                                    zIndex: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            position: "absolute",
                                                            left: -37,
                                                            top: 0,
                                                            width: 14,
                                                            height: 14,
                                                            borderRadius: "50%",
                                                            border: "2px solid green",
                                                            background: "green",
                                                            color: "#fff",
                                                            fontSize: 10,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        },
                                                        children: "\u2714"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("strong", {
                                                        children: "Verification successful"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            color: "#6B6C7E",
                                                            fontSize: 14
                                                        },
                                                        children: checkoutData.updatedAt ? new Date(checkoutData.updatedAt).toLocaleString() : ""
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("li", {
                                                style: {
                                                    position: "relative",
                                                    paddingBottom: 20,
                                                    zIndex: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            position: "absolute",
                                                            left: -37,
                                                            top: 0,
                                                            width: 14,
                                                            height: 14,
                                                            borderRadius: "50%",
                                                            border: "2px solid green",
                                                            background: "green",
                                                            color: "#fff",
                                                            fontSize: 10,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        },
                                                        children: "\u2714"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("strong", {
                                                        children: "Payment confirmed"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            color: "#6B6C7E",
                                                            fontSize: 14
                                                        },
                                                        children: checkoutData.updatedAt ? new Date(checkoutData.updatedAt).toLocaleString() : ""
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("li", {
                                                style: {
                                                    position: "relative",
                                                    paddingBottom: 20,
                                                    zIndex: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            position: "absolute",
                                                            left: -37,
                                                            top: 0,
                                                            width: 14,
                                                            height: 14,
                                                            borderRadius: "50%",
                                                            border: checkoutData?.gateway.openBanking?.instantPaymentStatus ? "2px solid green" : "2px solid green",
                                                            background: checkoutData?.gateway.openBanking?.instantPaymentStatus ? "green" : "#fff",
                                                            color: checkoutData?.gateway.openBanking?.instantPaymentStatus ? "#fff" : "green",
                                                            fontSize: 10,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        },
                                                        children: checkoutData?.gateway.openBanking?.instantPaymentStatus ? "\u2714" : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                width: 10,
                                                                height: 10,
                                                                border: "2px solid green",
                                                                borderTop: "2px solid transparent",
                                                                borderRadius: "50%",
                                                                animation: "spin 1s linear infinite"
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("strong", {
                                                        children: "Final checks in progress"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            color: "#6B6C7E",
                                                            fontSize: 14
                                                        },
                                                        children: new Date().toLocaleString()
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            fontSize: 14,
                                                            color: "#6B6C7E"
                                                        },
                                                        children: [
                                                            "We're completing final checks to keep your transaction secure and compliant with local regulations.",
                                                            "                      "
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("style", {
                                                children: `
                    @keyframes spin {
                      from { transform: rotate(0deg); }
                      to { transform: rotate(360deg); }
                    }
                    `
                                            }),
                                            checkoutData?.gateway.openBanking?.instantPaymentStatus ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("li", {
                                                style: {
                                                    position: "relative",
                                                    zIndex: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            position: "absolute",
                                                            left: -37,
                                                            top: 0,
                                                            width: 14,
                                                            height: 14,
                                                            borderRadius: "50%",
                                                            border: "2px solid green",
                                                            background: "green",
                                                            color: "#fff",
                                                            fontSize: 10,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        },
                                                        children: "\u2714"
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("strong", {
                                                        children: "Crypto delivered"
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("li", {
                                                style: {
                                                    position: "relative",
                                                    zIndex: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            position: "absolute",
                                                            left: -37,
                                                            top: 0,
                                                            width: 12,
                                                            height: 12,
                                                            borderRadius: "50%",
                                                            border: "2px solid #CCC",
                                                            background: "#fff"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("strong", {
                                                        style: {
                                                            color: "#6B6C7E"
                                                        },
                                                        children: "Crypto delivery"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    bottom: 0,
                                    position: "absolute",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 10,
                                    marginBottom: 30
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                                    href: "https://www.radom.com/crypto-presales",
                                    target: "_blank",
                                    title: "Crypto Presale Powered by Radom",
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 2,
                                        cursor: "pointer",
                                        userSelect: "none",
                                        textDecoration: "none",
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                    },
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: 13,
                                                fontWeight: 500
                                            },
                                            children: [
                                                "Powered by",
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                                    width: 60,
                                                    height: 14,
                                                    fill: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                position: "absolute",
                                                width: "1px",
                                                height: "1px",
                                                margin: "-1px",
                                                padding: 0,
                                                overflow: "hidden",
                                                clip: "rect(0, 0, 0, 0)",
                                                border: 0
                                            },
                                            children: "Radom"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    openbankPayStatus === "waiting" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $070d885cb609f38e$export$9ef8e5c12230ae65), {
                        "data-hj-allow-iframe": true,
                        checkoutUrl: openBankingCheckoutUrl,
                        displayOptions: {
                            type: "embedded",
                            maxHeight: 760,
                            maxWidth: 520
                        },
                        onSuccess: ()=>{
                            setOpenbankPayStatus("kyc_pending_view");
                            setRenderOpenBankingState(2);
                            if (openBankingIntervalRef.current) clearInterval(openBankingIntervalRef.current);
                            const refreshAfterIvySuccess = ()=>{
                                (0, $43c053927acc0cba$export$2e2bcd8739ae039).getCheckoutSession(checkoutId ?? "", {
                                    refreshOpenBankingStatus: true
                                }).then((res)=>{
                                    const openBankingGateway = res.gateway.openBanking;
                                    setCheckoutData((prev)=>{
                                        if (!prev) return prev;
                                        return {
                                            ...prev,
                                            sessionStatus: res.sessionStatus,
                                            gateway: {
                                                ...prev.gateway,
                                                openBanking: openBankingGateway ?? prev.gateway.openBanking
                                            },
                                            openBankingPaymentData: res.openBankingPaymentData
                                        };
                                    });
                                    if (res.sessionStatus === "success" || res.sessionStatus === "refunded") {
                                        if (openBankingIntervalRef.current) {
                                            clearInterval(openBankingIntervalRef.current);
                                            openBankingIntervalRef.current = null;
                                        }
                                        setOpenbankPayStatus("success");
                                        if (!$35ce030e39d4f986$var$hasOpenBankingDestinationAddress(openBankingGateway?.destinationCryptoAddress) && res.successUrl) setTimeout(()=>{
                                            window.location.replace((0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(res.successUrl));
                                        }, 1500);
                                        return;
                                    }
                                    if (res.sessionStatus === "expired") {
                                        if (openBankingIntervalRef.current) {
                                            clearInterval(openBankingIntervalRef.current);
                                            openBankingIntervalRef.current = null;
                                        }
                                        setOpenbankPayStatus("expired");
                                        return;
                                    }
                                    if (res.sessionStatus === "cancelled" || $35ce030e39d4f986$var$isOpenBankingProviderFailed(res.openBankingPaymentData)) {
                                        if (openBankingIntervalRef.current) {
                                            clearInterval(openBankingIntervalRef.current);
                                            openBankingIntervalRef.current = null;
                                        }
                                        setErrorMessage($35ce030e39d4f986$var$getOpenBankingReturnStatusCopy(res.openBankingPaymentData, res.sessionStatus).body);
                                        setOpenbankPayStatus("error");
                                    }
                                }).catch((err)=>{
                                    console.error("Failed to refresh open banking checkout after Ivy success", err);
                                });
                            };
                            refreshAfterIvySuccess();
                            openBankingIntervalRef.current = setInterval(refreshAfterIvySuccess, 3000);
                        },
                        onCancel: ()=>{
                            window.location.replace((0, $8d017118df5fe2e5$export$6b8c04140f1b2745)(checkoutData?.cancelUrl));
                        }
                    }),
                    openbankPayStatus === "initial" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($35ce030e39d4f986$var$RenderOpenBankingInitial, {
                        renderState: renderOpenBankingState,
                        setRenderState: setRenderOpenBankingState,
                        checkoutData: checkoutData,
                        totalSum: totalSum,
                        currency: currency,
                        isPreProcessingPayment: isPreProcessingPayment,
                        onrampAmount: checkoutData?.gateway.openBanking?.onrampAmount ?? 0,
                        randomAddress: randomAddress,
                        userKycData: userKycData,
                        setUserKycData: setUserKycData,
                        addressSuggestionList: addressSuggestionList,
                        setAddressSuggestionList: setAddressSuggestionList,
                        allCountries: allCountries,
                        debouncedFetch: debouncedFetch,
                        checkMarkOpenbanking: checkMarkOpenbanking,
                        setCheckMarkOpenBanking: setCheckMarkOpenBanking,
                        errorMessage: errorMessage,
                        setErrorMessage: setErrorMessage,
                        setOpenbankPayStatus: setOpenbankPayStatus,
                        setOpenBankingCheckoutUrl: setOpenBankingCheckoutUrl,
                        openBankingCheckoutUrl: openBankingCheckoutUrl,
                        setOpenBankingTotalUsdRate: ()=>{}
                    }),
                    openbankPayStatus === "kyc" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        children: [
                            isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100vw",
                                    height: "100vh",
                                    backgroundColor: "rgba(0, 0, 0, 0.15)",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 9999
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                    style: {
                                        background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                        width: 50,
                                        height: 50
                                    },
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6dac766084d8c11a$export$2e2bcd8739ae039), {
                                        animationDelay: "0.5s",
                                        animationSpeed: "0.75s",
                                        stroke: "white"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $cd5b106c2dfcc0b3$export$2e2bcd8739ae039), {
                                kycTips: "KYC verification will apply if you deposit more than 1K EUR per single transaction or in total for 24 hours",
                                errorMessage: errorMessage,
                                onBack: ()=>{
                                    setOpenbankPayStatus("initial");
                                    if (openBankingIntervalRef.current) clearInterval(openBankingIntervalRef.current);
                                },
                                setOpenbankPayStatus: setOpenbankPayStatus,
                                onSubmit: ()=>{
                                    setIsLoading(true);
                                    setOpenbankPayStatus("kyc_pending_view");
                                    openBankingIntervalRef.current = setInterval(()=>{
                                        (0, $43c053927acc0cba$export$2e2bcd8739ae039).getCheckoutSession(checkoutId ?? "").then((res)=>{
                                            const checkoutUrl = res.gateway.openBanking?.openBankingCheckoutUrl;
                                            if (checkoutUrl && checkoutUrl !== "") {
                                                if ($35ce030e39d4f986$var$isSecureHostedUrl(checkoutUrl)) {
                                                    setOpenBankingCheckoutUrl(checkoutUrl);
                                                    setOpenbankPayStatus("waiting");
                                                    if (openBankingIntervalRef.current) clearInterval(openBankingIntervalRef.current);
                                                } else {
                                                    setErrorMessage($35ce030e39d4f986$var$formatOpenBankingErrorMessage(checkoutUrl));
                                                    setOpenbankPayStatus("error");
                                                }
                                            }
                                        });
                                    }, 2000);
                                },
                                onChange: async (value)=>{
                                    setIsLoading(true);
                                    if (value.kycType === 2) {
                                        if (value.documentType === "passport") {
                                            setUserKycData({
                                                ...userKycData,
                                                passportFile: value.imageFile
                                            });
                                            await (0, $43c053927acc0cba$export$2e2bcd8739ae039).updateCustomerKycData(checkoutId ?? "", $35ce030e39d4f986$var$buildOpenBankingCustomerPayload(userKycData, {
                                                passportFile: value.imageFile
                                            })).finally(()=>{
                                                setIsLoading(false);
                                            });
                                        } else if (value.documentType === "id_card") {
                                            setUserKycData({
                                                ...userKycData,
                                                idCardFile: value.imageFile
                                            });
                                            await (0, $43c053927acc0cba$export$2e2bcd8739ae039).updateCustomerKycData(checkoutId ?? "", $35ce030e39d4f986$var$buildOpenBankingCustomerPayload(userKycData, {
                                                idCardFile: value.imageFile
                                            })).finally(()=>{
                                                setIsLoading(false);
                                            });
                                        }
                                    } else if (value.kycType === 3) {
                                        await (0, $43c053927acc0cba$export$2e2bcd8739ae039).updateCustomerKycData(checkoutId ?? "", $35ce030e39d4f986$var$buildOpenBankingCustomerPayload(userKycData, {
                                            selfieFile: value.imageFile
                                        })).finally(()=>{
                                            setIsLoading(false);
                                        });
                                        setUserKycData({
                                            ...userKycData,
                                            selfieFile: value.imageFile
                                        });
                                    }
                                }
                            })
                        ]
                    }),
                    openbankPayStatus === "expired" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            position: "relative",
                            margin: "10px 20px",
                            background: "#f5f6f6",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 600
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                        style: {
                                            background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR,
                                            width: 45,
                                            height: 45
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $df059e440c9a1479$export$2e2bcd8739ae039), {
                                            animationDelay: "0.5s",
                                            animationSpeed: "0.75s",
                                            stroke: "white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            fontSize: 18,
                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                        },
                                        children: "Payment Expired"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    bottom: 0,
                                    position: "absolute",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 10,
                                    marginBottom: 30
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                                    href: "https://www.radom.com/crypto-presales",
                                    target: "_blank",
                                    title: "Crypto Presale Powered by Radom",
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 2,
                                        cursor: "pointer",
                                        userSelect: "none",
                                        textDecoration: "none",
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                    },
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: 13,
                                                fontWeight: 500
                                            },
                                            children: [
                                                "Powered by",
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                                    width: 60,
                                                    height: 14,
                                                    fill: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                position: "absolute",
                                                width: "1px",
                                                height: "1px",
                                                margin: "-1px",
                                                padding: 0,
                                                overflow: "hidden",
                                                clip: "rect(0, 0, 0, 0)",
                                                border: 0
                                            },
                                            children: "Radom"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    openbankPayStatus === "error" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            position: "relative",
                            margin: "10px 20px",
                            background: "#f5f6f6",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 600
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                        style: {
                                            background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR,
                                            width: 45,
                                            height: 45
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $df059e440c9a1479$export$2e2bcd8739ae039), {
                                            animationDelay: "0.2s",
                                            animationSpeed: "0.15s",
                                            stroke: "white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            fontSize: 18,
                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                        },
                                        children: openBankingReturnStatusCopy.isError ? openBankingReturnStatusCopy.title : "Verification required"
                                    }),
                                    (errorMessage || openBankingReturnStatusCopy.isError) && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR,
                                            padding: 15,
                                            borderRadius: 5,
                                            marginTop: 20,
                                            // marginBottom: 20,
                                            color: "white",
                                            overflowWrap: "break-word"
                                        },
                                        children: errorMessage || openBankingReturnStatusCopy.body
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    bottom: 0,
                                    position: "absolute",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 10,
                                    marginBottom: 30
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                                    href: "https://www.radom.com/crypto-presales",
                                    target: "_blank",
                                    title: "Crypto Presale Powered by Radom",
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 2,
                                        cursor: "pointer",
                                        userSelect: "none",
                                        textDecoration: "none",
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                    },
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: 13,
                                                fontWeight: 500
                                            },
                                            children: [
                                                "Powered by",
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                                    width: 60,
                                                    height: 14,
                                                    fill: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                position: "absolute",
                                                width: "1px",
                                                height: "1px",
                                                margin: "-1px",
                                                padding: 0,
                                                overflow: "hidden",
                                                clip: "rect(0, 0, 0, 0)",
                                                border: 0
                                            },
                                            children: "Radom"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    openbankPayStatus === "kyc_pending_view" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            position: "relative",
                            margin: "10px 20px",
                            background: "white",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 600
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                        style: {
                                            background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                            width: 60,
                                            height: 60
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6dac766084d8c11a$export$2e2bcd8739ae039), {
                                            animationDelay: "0.5s",
                                            animationSpeed: "0.75s",
                                            stroke: "white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            fontSize: 18,
                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                        },
                                        children: openBankingReturnStatusCopy.title
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                            fontSize: 14,
                                            lineHeight: 1.4,
                                            maxWidth: 300,
                                            textAlign: "center"
                                        },
                                        children: openBankingReturnStatusCopy.body
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    bottom: 0,
                                    position: "absolute",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 10,
                                    marginBottom: 30
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                                    href: "https://www.radom.com/crypto-presales",
                                    target: "_blank",
                                    title: "Crypto Presale Powered by Radom",
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 2,
                                        cursor: "pointer",
                                        userSelect: "none",
                                        textDecoration: "none",
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                    },
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: 13,
                                                fontWeight: 500
                                            },
                                            children: [
                                                "Powered by",
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                                    width: 60,
                                                    height: 14,
                                                    fill: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                position: "absolute",
                                                width: "1px",
                                                height: "1px",
                                                margin: "-1px",
                                                padding: 0,
                                                overflow: "hidden",
                                                clip: "rect(0, 0, 0, 0)",
                                                border: 0
                                            },
                                            children: "Radom"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    if (!checkoutData) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($35ce030e39d4f986$var$Container, {
        children: !isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
            children: "Checkout id not found"
        })
    });
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $8652974033b0a752$export$2e2bcd8739ae039), {
        checkoutData: checkoutData,
        isPreProcessingPayment: isPreProcessingPayment,
        isSuccess: isSuccess,
        onCheckout: onCheckout,
        managedPaymentDetails: managedPaymentDetails,
        tokenDelegatePaymentDetails: tokenDelegatePaymentDetails,
        onChangePaymentMethod: ()=>{
            clearManagedPaymentPolling();
            if (checkoutId) (0, $f8c8710feaaa9285$export$a774b110a5502c04)(checkoutId);
            setManagedPaymentDetails(undefined);
            setTokenDelegatePaymentDetails(undefined);
            setPaymentStatus(undefined);
            setErrorMessage("");
            setIsPreProcessingPayment(false);
        },
        successElement: successElement,
        errorMessage: errorMessage,
        onDiscountCodeEntered: redeemDiscountCode,
        resetDiscountCode: resetDiscountCode,
        discountResult: discountResult,
        discount: discount,
        discountLocked: discountLocked,
        paymentStatus: paymentStatus,
        travelRuleFieldsCollected: travelRuleFieldsCollected,
        onCurrency: (value)=>setCurrency(value),
        onTotalChange: (value)=>setTotalSum(value)
    });
};
var $35ce030e39d4f986$export$2e2bcd8739ae039 = $35ce030e39d4f986$var$HostedCheckout;



parcelRequire("bnENU");




const $e590643c9fd8496b$var$InvoicePreview = ()=>{
    const location = (0, $6738ab3539650fb6$export$45d76561a5302f2b)();
    const invoiceData = (0, $43d4df94ebd065cc$export$8e7009dd18ef5a83)(location.hash) ?? (0, $46dd2823527947d2$export$ad729a2639e08ae4);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $0ce5a428e300b80d$export$2e2bcd8739ae039), {
        previewData: invoiceData,
        hideTravelRuleFields: true
    });
};
var $e590643c9fd8496b$export$2e2bcd8739ae039 = $e590643c9fd8496b$var$InvoicePreview;



parcelRequire("bnENU");


const $941e198c2321b7b8$var$Invoice = ()=>{
    const { invoiceId: invoiceId } = (0, $6738ab3539650fb6$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
        children: invoiceId && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $0ce5a428e300b80d$export$2e2bcd8739ae039), {
            invoiceId: invoiceId
        })
    });
};
var $941e198c2321b7b8$export$2e2bcd8739ae039 = $941e198c2321b7b8$var$Invoice;




var $bnENU = parcelRequire("bnENU");










var $bd17aec34555d69e$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
function $bd17aec34555d69e$export$2e2bcd8739ae039(duration, options) {
    var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
    if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
    var defaultOptions = (0, $6e3145262e897fb9$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $46f8710aa8a87258$export$2e2bcd8739ae039);
    var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : $bd17aec34555d69e$var$defaultFormat;
    var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
    var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : " ";
    if (!locale.formatDistance) return "";
    var result = format.reduce(function(acc, unit) {
        var token = "x".concat(unit.replace(/(^.)/, function(m) {
            return m.toUpperCase();
        }));
        var value = duration[unit];
        if (typeof value === "number" && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}













var $aae311a4a68fd77b$exports = {};

$aae311a4a68fd77b$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "AuroraLogo.5103bfbf.svg";


var $10ab8245671fb0a8$exports = {};

$10ab8245671fb0a8$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "MetisLogo.a52a09ed.svg";





var $87c3b858021d7f6e$exports = {};

$87c3b858021d7f6e$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "OptimismLogo.4bfae879.svg";



var $a4751bbc55dc39ef$exports = {};

$a4751bbc55dc39ef$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "RadomLogo.e62d1930.svg";


var $04f04072dfc35cb0$exports = {};

$04f04072dfc35cb0$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "ScrollLogo.6da344f7.svg";


var $2463245816584a7c$exports = {};

$2463245816584a7c$exports = (parcelRequire("5waPY")).getBundleURL("aK4Nu") + "OKXLogo.c4036e07.png";



const $16b97261be8212a7$export$c3f32f9b7c2f46bb = {
    RadomDevelopment: {
        name: "Radom Development",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($a4751bbc55dc39ef$exports))),
        chainId: 31337,
        symbol: "ETH",
        rpcURL: "https://dzcd0iqtbql7u.cloudfront.net"
    },
    Ethereum: {
        name: "Ethereum",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
        chainId: 1,
        symbol: "ETH",
        rpcURL: "https://rpc.ankr.com/eth"
    },
    Goerli: {
        name: "Goerli Testnet",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
        chainId: 5,
        symbol: "ETH",
        rpcURL: "https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"
    },
    BSC: {
        name: "Binance Smart Chain",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($d049204adf92834d$exports))),
        chainId: 56,
        symbol: "BNB",
        rpcURL: "https://bsc-dataseed.binance.org"
    },
    BSCTestnet: {
        name: "Binance Smart Chain Testnet",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($d049204adf92834d$exports))),
        chainId: 97,
        symbol: "BNB",
        rpcURL: "https://data-seed-prebsc-1-s3.binance.org:8545"
    },
    Polygon: {
        name: "Polygon",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
        chainId: 137,
        symbol: "MATIC",
        rpcURL: "https://polygon.llamarpc.com"
    },
    Avalanche: {
        name: "Avalanche",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($0f6589a7fd3dabb4$exports))),
        chainId: 43114,
        symbol: "AVAX",
        rpcURL: "https://api.avax.network/ext/bc/C/rpc"
    },
    Arbitrum: {
        name: "Arbitrum",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($786b5fdea564ab1f$exports))),
        chainId: 42161,
        symbol: "ETH",
        rpcURL: "https://arb1.arbitrum.io/rpc"
    },
    "Arbitrum Rinkeby": {
        name: "Arbitrum Rinkeby",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($786b5fdea564ab1f$exports))),
        chainId: 421611,
        symbol: "ETH",
        rpcURL: "https://rinkeby.arbitrum.io/rpc"
    },
    Optimism: {
        name: "Optimism",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($87c3b858021d7f6e$exports))),
        chainId: 10,
        symbol: "ETH",
        rpcURL: "https://mainnet.optimism.io"
    },
    Fantom: {
        name: "Fantom",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($9a2a95efb70a21e1$exports))),
        chainId: 250,
        symbol: "FTM",
        rpcURL: "https://rpc.fantom.network"
    },
    "Fantom Testnet": {
        name: "Fantom Testnet",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($9a2a95efb70a21e1$exports))),
        chainId: 4002,
        symbol: "FTM",
        rpcURL: "https://rpc.ankr.com/fantom_testnet"
    },
    Aurora: {
        name: "Aurora",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($aae311a4a68fd77b$exports))),
        chainId: 1313161554,
        symbol: "ETH",
        rpcURL: "https://mainnet.aurora.dev"
    },
    "Aurora Testnet": {
        name: "Aurora Testnet",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($aae311a4a68fd77b$exports))),
        chainId: 1313161555,
        symbol: "ETH",
        rpcURL: "https://testnet.aurora.dev"
    },
    Metis: {
        name: "Metis",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($10ab8245671fb0a8$exports))),
        chainId: 1088,
        symbol: "METIS",
        rpcURL: "https://andromeda.metis.io/?owner=1088"
    },
    "Metis Testnet": {
        name: "Metis Testnet",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($10ab8245671fb0a8$exports))),
        chainId: 588,
        symbol: "METIS",
        rpcURL: "https://stardust.metis.io/?owner=588"
    },
    Mumbai: {
        name: "Polygon Mumbai",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($36139881f9901c23$exports))),
        chainId: 80001,
        symbol: "MATIC",
        rpcURL: "https://rpc-mumbai.maticvigil.com"
    },
    Sepolia: {
        name: "Sepolia",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($8e2a7a4543c2cd55$exports))),
        chainId: 11155111,
        symbol: "ETH",
        rpcURL: "https://sepolia.drpc.org"
    },
    "Avalanche Testnet": {
        name: "Avalanche Testnet",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($0f6589a7fd3dabb4$exports))),
        chainId: 43113,
        symbol: "AVAX",
        rpcURL: "https://rpc.ankr.com/avalanche_fuji"
    },
    "Scroll Alpha Testnet": {
        name: "Scroll Testnet",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($04f04072dfc35cb0$exports))),
        chainId: 534353,
        symbol: "ETH",
        rpcURL: "https://alpha-rpc.scroll.io/l2"
    },
    OKTC: {
        name: "OKT Chain",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($2463245816584a7c$exports))),
        chainId: 66,
        symbol: "OKT",
        rpcURL: "https://exchainrpc.okex.org"
    }
};
const $16b97261be8212a7$var$addressType = (network, initialType)=>{
    if (network === "PolkadotTestnet" || network === "Polkadot") {
        if (initialType === "tx") return "extrinsic";
    }
    if (network === "TronTestnet" || network === "Tron") {
        if (initialType === "tx") return "transaction";
    }
    return initialType;
};
const $16b97261be8212a7$export$b1e41f75147fe8d2 = (network, type, hash)=>{
    if (network === "TronTestnet" || network === "Tron") hash = hash.replace("0x", "");
    return `${(0, $afdf282d9c361d03$export$cb8c5ae35c7906d6)[network]}/${$16b97261be8212a7$var$addressType(network, type)}/${hash}`;
};
function $16b97261be8212a7$export$2889085f66c5f9c0(id) {
    const chain = Object.values($16b97261be8212a7$export$c3f32f9b7c2f46bb).find((chain)=>chain.chainId === id);
    if (!chain) return {
        name: "Unknown",
        chainId: id,
        rpcURL: "",
        symbol: "UNK"
    };
    return chain;
}




var $6Dftn = parcelRequire("6Dftn");
var $iwa3L = parcelRequire("iwa3L");
var $64pxN = parcelRequire("64pxN");





parcelRequire("bnENU");
function $ea5ac4910a2b2c1c$var$S(props) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        stroke: "black",
        strokeWidth: "2",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("g", {
                clipPath: "url(#clip0_1103_20)",
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M18.5452 8.07812L23.5452 3.07812",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M29.5452 9.07812L24.5452 14.0781",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M28.5452 18.0781L14.5452 4.07812",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M27.0452 16.5781L19.7164 23.9069C18.9663 24.6568 17.949 25.0781 16.8883 25.0781C15.8276 25.0781 14.8103 24.6568 14.0602 23.9069L8.71644 18.5631C7.96648 17.813 7.54517 16.7957 7.54517 15.735C7.54517 14.6743 7.96648 13.657 8.71644 12.9069L16.0452 5.57812",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("path", {
                        d: "M11.3889 21.2344L4.54517 28.0781",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("clipPath", {
                    id: "clip0_1103_20",
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("rect", {
                        width: "32",
                        height: "32",
                        fill: "white",
                        transform: "translate(0.545166 0.078125)"
                    })
                })
            })
        ]
    });
}
var $ea5ac4910a2b2c1c$export$2e2bcd8739ae039 = $ea5ac4910a2b2c1c$var$S;





const $23109ce8e3723d50$export$8c2efd953f9e6756 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).a`
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK};
  align-items: center;
  display: flex;
  gap: 3px;
  text-decoration: none;
  
  &:hover {
    color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK};
    text-decoration: underline;
  }

  &:active {
    opacity: 0.5;
  }
`;
const $23109ce8e3723d50$var$StatusBadge = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  text-transform: capitalize;
  padding: 5px 10px;
  border-radius: 5px;
  color: white;
  font-size: 14px;
  width: fit-content;

  ${({ status: status })=>{
    let bgColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR_LIGHT;
    let textColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR;
    switch(status){
        case "active":
            bgColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS_LIGHT;
            textColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS;
            break;
        case "cancelled":
            bgColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).WARNING_LIGHT;
            textColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).WARNING;
            break;
    }
    return `
    background-color: ${bgColor};
    color: ${textColor};
  `;
}};
`;
const $23109ce8e3723d50$var$RightSectionInner = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 100%;
  max-width: 600px;
  height: fit-content;
  padding: 50px;
    
  @media (max-width: 480px) {
    padding: 5px;
  }
`;
const $23109ce8e3723d50$export$cd1e1769f67f807a = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).a`
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  opacity: 0.7;
  transition: transform 0.18s cubic-bezier(.4,0,.2,1), opacity 0.16s;
  will-change: transform, opacity;
  cursor: pointer;
  padding: 8px 10px;  // Add padding for bigger hit area
  border-radius: 8px; // Optionally round

  &:hover, &:focus-visible {
    opacity: 1;
    transform: translateX(-6px) scale(1.08);
    text-decoration: underline;
  }
  &:active {
    opacity: 0.4;
    transform: translateX(-2px) scale(0.99);
  }
`;
const $23109ce8e3723d50$var$SubscriptionView = ()=>{
    const { subscriptionId: subscriptionId } = (0, $6738ab3539650fb6$export$99eaa27ddbbb95ef)();
    if (typeof window !== "undefined" && !window.__W3M_INITIALIZED__) {
        (0, $1a6c142165b114fb$export$14650d4efb17e382)({
            wagmiConfig: $5760199798158999$export$382a3cc012b91987,
            projectId: $5760199798158999$export$e4bb003b4e7478a,
            enableAnalytics: true
        });
        window.__W3M_INITIALIZED__ = true;
    }
    const [subscription, setSubscription] = (0, $bnENU.useState)();
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(true);
    const [loadError, setLoadError] = (0, $bnENU.useState)("");
    const [sellerProfile, setSellerProfile] = (0, $bnENU.useState)();
    const [backButtonUrl, setBackButtonUrl] = (0, $bnENU.useState)(null);
    const [isPaying, setIsPaying] = (0, $bnENU.useState)(false);
    const [customizations, setCustomizations] = (0, $bnENU.useState)({
        slantedEdge: false,
        leftPanelColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED
    });
    const [showPastPayments, setShowPastPayments] = (0, $bnENU.useState)(false);
    const [isPreProcessingPayment, setIsPreProcessingPayment] = (0, $bnENU.useState)(false);
    const [managedPaymentDetails, setManagedPaymentDetails] = (0, $bnENU.useState)();
    const [tokenDelegatePaymentDetails, setTokenDelegatePaymentDetails] = (0, $bnENU.useState)();
    const [isSuccess, setIsSuccess] = (0, $bnENU.useState)(false);
    const [successElement, setSuccessElement] = (0, $bnENU.useState)(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {}));
    const [paymentErrorMessage, setPaymentErrorMessage] = (0, $bnENU.useState)("");
    const section = (0, $bnENU.useRef)(null);
    const [cancelSubscriptionModalOpen, setCancelSubscriptionModalOpen] = (0, $bnENU.useState)(false);
    const [isCancelling, setIsCancelling] = (0, $bnENU.useState)(false);
    const [paymentStatus, setPaymentStatus] = (0, $bnENU.useState)();
    const paymentPollingIntervalRef = (0, $bnENU.useRef)(null);
    const [isUpdatingAllowance, setIsUpdatingAllowance] = (0, $bnENU.useState)(false);
    const [allowanceAmount, setAllowanceAmount] = (0, $bnENU.useState)("");
    const { disconnect: disconnect } = (0, $9d39a2f446de0538$export$83bebf2fe7fead4e)();
    const { address: address, isConnected: isConnected, connector: connector } = (0, $2739213b2d55f551$export$83a8e409853da004)();
    const { open: open } = (0, $c8101c12137113f6$export$69804ca079d47f29)();
    const clearPaymentPolling = ()=>{
        if (paymentPollingIntervalRef.current) {
            clearInterval(paymentPollingIntervalRef.current);
            paymentPollingIntervalRef.current = null;
        }
    };
    const resetPaymentState = ()=>{
        clearPaymentPolling();
        if (subscriptionId) (0, $f8c8710feaaa9285$export$a774b110a5502c04)(subscriptionId);
        setIsPreProcessingPayment(false);
        setManagedPaymentDetails(undefined);
        setTokenDelegatePaymentDetails(undefined);
        setPaymentStatus(undefined);
        setIsSuccess(false);
        setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {}));
        setPaymentErrorMessage("");
    };
    const fetchSubscription = async ()=>{
        if (!subscriptionId) {
            setLoadError("Subscription ID is missing.");
            setSubscription(undefined);
            setIsLoading(false);
            return;
        }
        setLoadError("");
        setIsLoading(true);
        try {
            const s = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getSubscription(subscriptionId);
            setSubscription(s);
        } catch (err) {
            setSubscription(undefined);
            setLoadError(err?.message ?? "Unable to load subscription right now.");
        } finally{
            setIsLoading(false);
        }
    };
    (0, $bnENU.useEffect)(()=>{
        fetchSubscription();
    }, [
        subscriptionId
    ]);
    const reconnectWallet = async ()=>{
        disconnect();
        await open();
    };
    const editAllowance = async ()=>{
        if (!subscription) return;
        if (!isConnected) return await reconnectWallet();
        try {
            if (!address) return;
            const chain = (0, $5760199798158999$export$cc4208a8ebc9f985)[subscription.network];
            const provider = await connector?.getProvider();
            const signer = (0, $bf4e0381e2c41280$export$362b8ea2edbd9090)({
                chain: chain,
                transport: (0, $c1b76a8a2251eb69$export$4c00f665f0d4b443)(provider)
            });
            if (connector?.switchChain) {
                const chainId = await connector.getChainId();
                if (chainId !== chain.id) await connector?.switchChain({
                    chainId: chain.id
                });
            }
            const contract = (0, $4a68b247381b8806$export$f518c38144e1f9d)({
                address: subscription.token,
                abi: (0, $6Dftn.erc20Abi),
                client: signer
            });
            setIsUpdatingAllowance(true);
            const method = (0, $5760199798158999$export$8793fab959da70d1)(subscription.network, subscription.token);
            if (method.name === "Tether" && BigInt(allowanceAmount) > 0) {
                const hash = await contract.write.approve([
                    subscription.subscriptionType.automatedEVMSubscription?.subscriptionContractAddress,
                    0n
                ], {
                    account: address,
                    chain: chain
                });
                if (hash) try {
                    await (0, $f87a726a94dffdff$export$694ec9bdf0bb55cf)(signer, {
                        hash: hash,
                        retryCount: 30,
                        retryDelay: 1000
                    });
                } catch (err) {
                    console.error("Failed to confirm allowance tx", err);
                }
            }
            const hash = await contract.write.approve([
                subscription.subscriptionType.automatedEVMSubscription?.subscriptionContractAddress,
                (0, $64pxN.maxUint256)
            ], {
                account: address,
                chain: chain
            });
            if (hash) try {
                await (0, $f87a726a94dffdff$export$694ec9bdf0bb55cf)(signer, {
                    hash: hash,
                    retryCount: 30,
                    retryDelay: 1000
                });
            } catch (err) {
                console.error("Failed to confirm allowance tx", err);
            }
            await calculateAllowance();
            setIsUpdatingAllowance(false);
        } catch (err) {
            setIsUpdatingAllowance(false);
        }
    };
    const calculateAllowance = async ()=>{
        if (!subscription) return;
        if (subscription.subscriptionType.automatedEVMSubscription) {
            const address = subscription.subscriptionType.automatedEVMSubscription.buyerAddress;
            const chain = (0, $5760199798158999$export$cc4208a8ebc9f985)[subscription.network];
            const publicClient = (0, $8085cfeffb1fd5c6$export$d8e090d8c6a7a6ad)({
                chain: chain,
                transport: (0, $ff2d1e1ca66a97fb$export$7d6f1c8842f9f527)()
            });
            const contract = (0, $4a68b247381b8806$export$f518c38144e1f9d)({
                address: subscription.token,
                abi: (0, $6Dftn.erc20Abi),
                client: publicClient
            });
            try {
                setIsUpdatingAllowance(true);
                const allowance = await contract.read.allowance([
                    address,
                    subscription.subscriptionType.automatedEVMSubscription.subscriptionContractAddress
                ]);
                const paymentMethod = (0, $5760199798158999$export$8793fab959da70d1)(subscription.network, subscription.token);
                let allowanceStr = (0, $iwa3L.formatUnits)(allowance, paymentMethod.tokenInfo?.decimals ?? 1);
                if (allowanceStr.split(".")[0].length > 9) allowanceStr = "\u221E";
                setAllowanceAmount(allowanceStr);
                setIsUpdatingAllowance(false);
            } catch (err) {
                setIsUpdatingAllowance(false);
            }
        }
    };
    (0, $bnENU.useEffect)(()=>{
        if (subscription) {
            if (subscription.customizations) setCustomizations({
                leftPanelColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED,
                slantedEdge: false,
                ...subscription.customizations
            });
            calculateAllowance();
            (0, $43c053927acc0cba$export$2e2bcd8739ae039).getSellerProfile(subscription.organizationId).then((p)=>setSellerProfile(p)).catch(()=>{});
        }
    }, [
        subscription
    ]);
    const arrowColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "#fff", "#1a1a1a");
    (0, $bnENU.useEffect)(()=>{
        if (subscriptionId) (0, $43c053927acc0cba$export$2e2bcd8739ae039).getSubscriptionBackButtonUrl(subscriptionId).then((url)=>setBackButtonUrl(url ?? null)).catch(()=>setBackButtonUrl(null));
    }, [
        subscriptionId
    ]);
    (0, $bnENU.useEffect)(()=>{
        return ()=>clearPaymentPolling();
    }, []);
    const setPaymentSuccess = ()=>{
        setIsSuccess(true);
        setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$e2668574711a3262), {}));
    };
    const setPaymentUnderReview = ()=>{
        setIsSuccess(true);
        setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $4c45ee8cb3cb4e28$export$de273779fa7d2ee0), {}));
    };
    const startManagedPaymentPolling = (paymentId, managedTokenDelegate = false)=>{
        clearPaymentPolling();
        let appliedOutcome;
        paymentPollingIntervalRef.current = setInterval(()=>{
            const getStatus = managedTokenDelegate ? (0, $43c053927acc0cba$export$2e2bcd8739ae039).getManagedTokenPaymentStatus(paymentId) : (0, $43c053927acc0cba$export$2e2bcd8739ae039).getManagedPaymentStatus(paymentId);
            getStatus.then((res)=>{
                setPaymentStatus(res);
                if (res.status === "inReview") {
                    if (appliedOutcome !== "inReview") {
                        appliedOutcome = "inReview";
                        setIsPreProcessingPayment(false);
                        setPaymentUnderReview();
                    }
                    return;
                }
                if (res.status === "paymentConfirmed") {
                    appliedOutcome = "paymentConfirmed";
                    clearPaymentPolling();
                    if (subscriptionId) (0, $f8c8710feaaa9285$export$a774b110a5502c04)(subscriptionId);
                    setIsPreProcessingPayment(false);
                    setPaymentSuccess();
                }
                if (res.status === "failed" || res.status === "expired") {
                    clearPaymentPolling();
                    if (subscriptionId) (0, $f8c8710feaaa9285$export$a774b110a5502c04)(subscriptionId);
                    setIsPreProcessingPayment(false);
                }
            }).catch(()=>{});
        }, 1000);
    };
    (0, $bnENU.useEffect)(()=>{
        if (!subscriptionId || !subscription || paymentPollingIntervalRef.current) return;
        const session = (0, $f8c8710feaaa9285$export$f4d961d73df7b7b)(subscriptionId);
        if (!session) return;
        if (session.managed) {
            setManagedPaymentDetails(session.managed);
            startManagedPaymentPolling(session.managed.paymentId);
            return;
        }
        if (session.tokenDelegate && session.delegateSubmitted) {
            setIsPreProcessingPayment(true);
            setTokenDelegatePaymentDetails(session.tokenDelegate);
            startManagedPaymentPolling(session.tokenDelegate.paymentId, true);
        }
    }, [
        subscriptionId,
        subscription
    ]);
    const subscriptionCheckoutData = (0, $bnENU.useMemo)(()=>{
        if (!subscription) return undefined;
        const product = subscription.product ? {
            ...subscription.product,
            chargingIntervalSeconds: 0
        } : {
            id: `subscription-${subscription.id}`,
            name: "Subscription payment",
            description: "",
            chargingIntervalSeconds: 0,
            currency: subscription.currency,
            price: Number(subscription.amount),
            createdAt: new Date(subscription.createdAt),
            imageUrl: "",
            updatedAt: new Date(subscription.createdAt),
            sellerAddress: ""
        };
        return {
            id: subscription.id,
            organizationId: subscription.organizationId,
            sellerLogoUrl: sellerProfile?.logoUrl ?? "",
            sellerName: sellerProfile?.name ?? "Merchant",
            sellerAddress: product.sellerAddress ?? "",
            products: [
                {
                    product: product,
                    quantity: 1
                }
            ],
            gateway: {
                managed: {
                    methods: [
                        {
                            network: subscription.network,
                            token: subscription.token
                        }
                    ]
                }
            },
            customizations: customizations,
            currency: subscription.currency,
            total: Number(subscription.amount),
            cancelUrl: backButtonUrl ?? (subscriptionId ? `/subscription/${subscriptionId}` : undefined),
            chargeCustomerNetworkFee: true
        };
    }, [
        backButtonUrl,
        customizations,
        sellerProfile?.logoUrl,
        sellerProfile?.name,
        subscription,
        subscriptionId
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            minWidth: "100vw",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f6f9fc"
        },
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {})
    });
    if (loadError) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7c18a005ad02503d$export$2e2bcd8739ae039), {
        title: "Subscription unavailable",
        message: loadError,
        onRetry: async ()=>await fetchSubscription()
    });
    if (!subscription) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            minWidth: "100vw",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f6f9fc",
            color: "#111827",
            padding: 24,
            textAlign: "center"
        },
        children: "Subscription is unavailable."
    });
    if (isPaying && subscriptionCheckoutData) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $8652974033b0a752$export$2e2bcd8739ae039), {
        checkoutData: subscriptionCheckoutData,
        isPreProcessingPayment: isPreProcessingPayment,
        isSuccess: isSuccess,
        managedPaymentDetails: managedPaymentDetails,
        tokenDelegatePaymentDetails: tokenDelegatePaymentDetails,
        paymentStatus: paymentStatus,
        errorMessage: paymentErrorMessage,
        successElement: successElement,
        travelRuleFieldsCollected: (0, $8652974033b0a752$export$4217e132ac074f47)(),
        hideTravelRuleFields: true,
        onChangePaymentMethod: resetPaymentState,
        onCheckout: async ({ completeTokenDelegate: completeTokenDelegate })=>{
            setPaymentErrorMessage("");
            if (completeTokenDelegate) {
                const { paymentId: paymentId, signature: signature } = completeTokenDelegate;
                setIsPreProcessingPayment(true);
                try {
                    await (0, $43c053927acc0cba$export$2e2bcd8739ae039).completeTokenDelegatePayment(paymentId, signature);
                    if (tokenDelegatePaymentDetails) (0, $f8c8710feaaa9285$export$b96aa13c6879f837)(subscriptionId ?? subscription.id, {
                        tokenDelegate: tokenDelegatePaymentDetails,
                        delegateSubmitted: true
                    });
                    startManagedPaymentPolling(paymentId, true);
                } catch (err) {
                    setPaymentErrorMessage(err?.message ?? "Unable to complete this subscription payment right now.");
                    setIsPreProcessingPayment(false);
                }
                return;
            }
            setIsPreProcessingPayment(true);
            try {
                const res = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).createSubscriptionPayment(subscription.id);
                if (res.paymentMethodDetails.managed) {
                    setManagedPaymentDetails(res.paymentMethodDetails.managed);
                    (0, $f8c8710feaaa9285$export$b96aa13c6879f837)(subscriptionId ?? subscription.id, {
                        managed: res.paymentMethodDetails.managed
                    });
                    startManagedPaymentPolling(res.paymentMethodDetails.managed.paymentId);
                } else if (res.paymentMethodDetails.managedTokenDelegate) {
                    const delegateDetails = res.paymentMethodDetails.managedTokenDelegate;
                    setTokenDelegatePaymentDetails(delegateDetails);
                    (0, $f8c8710feaaa9285$export$b96aa13c6879f837)(subscriptionId ?? subscription.id, {
                        tokenDelegate: delegateDetails
                    });
                    setIsPreProcessingPayment(false);
                } else {
                    setPaymentErrorMessage("Unable to start this subscription payment right now.");
                    setIsPreProcessingPayment(false);
                }
            } catch (err) {
                setPaymentErrorMessage(err?.message ?? "Unable to start this subscription payment right now.");
                setIsPreProcessingPayment(false);
            }
        },
        onInputFieldsChange: ()=>{}
    });
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $8652974033b0a752$export$35a585e8a115e315), {
        children: [
            subscription.product && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $8652974033b0a752$export$e3b4754a92ccf466), {
                slantedEdge: customizations.slantedEdge,
                background: customizations.leftPanelColor,
                textColor: (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "white", "black"),
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            maxWidth: "400px",
                            paddingTop: 40,
                            paddingBottom: 40
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    top: 30,
                                    left: 30
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10
                                    },
                                    children: [
                                        backButtonUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($23109ce8e3723d50$export$cd1e1769f67f807a, {
                                            href: backButtonUrl,
                                            rel: "nofollow noreferrer",
                                            "aria-label": "Back",
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a6503dca462d11a6$export$2e2bcd8739ae039), {
                                                width: 24,
                                                height: 24,
                                                style: {
                                                    transform: "rotate(180deg)"
                                                },
                                                stroke: arrowColor
                                            })
                                        }),
                                        sellerProfile?.logoUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                            src: sellerProfile.logoUrl,
                                            style: {
                                                width: "auto",
                                                height: 42,
                                                pointerEvents: "none",
                                                marginRight: 8
                                            },
                                            alt: sellerProfile?.name || "Seller logo"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                opacity: 0.75,
                                                fontWeight: 500
                                            },
                                            children: sellerProfile?.name
                                        })
                                    ]
                                })
                            }),
                            subscription.product && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                        style: {
                                            fontSize: 28,
                                            display: "flex",
                                            flexDirection: "column"
                                        },
                                        children: [
                                            subscription.product.name,
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                style: {
                                                    fontWeight: 100,
                                                    fontSize: 18,
                                                    opacity: 0.5
                                                },
                                                children: "Subscription"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            fontSize: 54,
                                            fontWeight: 100
                                        },
                                        children: [
                                            (0, $0478aee74ce0fceb$export$413b0d1e3ece6964).includes(subscription.product.currency) && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    width: 32,
                                                    marginRight: "8px"
                                                },
                                                children: (0, $0478aee74ce0fceb$export$330f51eee3728a4c).find((c)=>c.ticker === subscription.product?.currency)?.icon
                                            }),
                                            (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(subscription.product.currency, subscription.product.price),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                style: {
                                                    fontSize: 16,
                                                    marginLeft: 5,
                                                    fontWeight: 300,
                                                    width: 30,
                                                    opacity: 0.75,
                                                    display: "inline-block"
                                                },
                                                children: [
                                                    "per ",
                                                    (0, $afdf282d9c361d03$export$d82eb24974fa9fd)(subscription.product.chargingIntervalSeconds).toLowerCase()
                                                ]
                                            })
                                        ]
                                    }),
                                    subscription.product.imageUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                        style: {
                                            marginTop: 10,
                                            maxWidth: 200,
                                            maxHeight: 200
                                        },
                                        src: subscription.product.imageUrl
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                        href: "https://radom.com",
                        target: "_blank",
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                            cursor: "pointer",
                            userSelect: "none",
                            fontSize: 14,
                            color: (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.45)", "rgba(0, 0, 0, 0.45)"),
                            fontWeight: 100,
                            position: "absolute",
                            bottom: 30,
                            left: 30,
                            textDecoration: "none"
                        },
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                children: "Powered by"
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                width: 60,
                                height: 14,
                                fill: (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.5)", "rgba(0, 0, 0, 0.5)")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $8652974033b0a752$export$7fcbc7dd475548f6), {
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                    style: {
                        overflow: "scroll",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        height: "100%"
                    },
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($23109ce8e3723d50$var$RightSectionInner, {
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            ref: section,
                            style: {
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                gap: 20,
                                height: "fit-content"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $0ce5a428e300b80d$export$60332b2344f7fe41), {
                                    children: [
                                        !isPaying && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 30
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 18
                                                    },
                                                    children: "Subscription details"
                                                }),
                                                subscription.status === "active" && subscription.subscriptionType.automatedEVMSubscription && isConnected && address?.toLowerCase() !== subscription.subscriptionType.automatedEVMSubscription.buyerAddress && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        borderRadius: 15,
                                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED}`,
                                                        overflow: "hidden"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                padding: 20,
                                                                backgroundColor: "rgb(255 223 230)"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    children: "Incorrect address"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                                    onClick: ()=>{
                                                                        disconnect();
                                                                    },
                                                                    style: {
                                                                        padding: 0,
                                                                        border: 0,
                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                                        alignItems: "center",
                                                                        gap: 5,
                                                                        display: "flex"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $ea5ac4910a2b2c1c$export$2e2bcd8739ae039), {
                                                                            style: {
                                                                                height: 15,
                                                                                width: "auto",
                                                                                marginBottom: -2
                                                                            },
                                                                            strokeWidth: 3,
                                                                            stroke: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            children: "Disconnect"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                padding: 20,
                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                            },
                                                            children: "Your connected address is not the subscriber address. Reconnect with the subscriber address to modify your allowance."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        gridTemplateColumns: "auto auto",
                                                        display: "grid",
                                                        rowGap: 30,
                                                        columnGap: 40
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    style: {
                                                                        opacity: 0.5
                                                                    },
                                                                    children: "Price"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                                    children: [
                                                                        (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(subscription.currency, subscription.amount),
                                                                        " ",
                                                                        subscription.periodCustomDuration ? `every ${subscription.periodCustomDuration} seconds` : subscription.period
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        gap: 5
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                        style: {
                                                                            opacity: 0.5
                                                                        },
                                                                        children: "Status"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($23109ce8e3723d50$var$StatusBadge, {
                                                                    status: subscription.status,
                                                                    children: subscription.status
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    style: {
                                                                        opacity: 0.5
                                                                    },
                                                                    children: "Created"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    children: (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(new Date(subscription.createdAt), "MMMM d, yyyy")
                                                                })
                                                            ]
                                                        }),
                                                        subscription.status === "active" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    style: {
                                                                        opacity: 0.5
                                                                    },
                                                                    children: "Next payment due"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    children: (0, $de2ab8211093dff3$export$2e2bcd8739ae039)(new Date(subscription.nextBillingDateAt), "MMMM d, yyyy")
                                                                })
                                                            ]
                                                        }),
                                                        subscription.status === "active" && subscription.subscriptionType.automatedEVMSubscription && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        gap: 5,
                                                                        alignItems: "center"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                opacity: 0.5
                                                                            },
                                                                            children: "Allowance"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                                            onClick: ()=>{
                                                                                editAllowance();
                                                                            },
                                                                            style: {
                                                                                padding: 0,
                                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                                                border: 0
                                                                            },
                                                                            children: isConnected ? "Edit" : "Connect"
                                                                        }),
                                                                        isConnected && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                                            onClick: ()=>{
                                                                                disconnect();
                                                                            },
                                                                            style: {
                                                                                padding: 0,
                                                                                border: 0,
                                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $ea5ac4910a2b2c1c$export$2e2bcd8739ae039), {
                                                                                style: {
                                                                                    height: 15,
                                                                                    width: "auto",
                                                                                    marginBottom: -2
                                                                                },
                                                                                strokeWidth: 3,
                                                                                stroke: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    children: isUpdatingAllowance ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $a404f1924ec00259$export$2e2bcd8739ae039), {}) : allowanceAmount
                                                                })
                                                            ]
                                                        }),
                                                        subscription.subscriptionType.automatedEVMSubscription && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        gap: 5,
                                                                        alignItems: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                        style: {
                                                                            opacity: 0.5
                                                                        },
                                                                        children: "Subscriber address"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($23109ce8e3723d50$export$8c2efd953f9e6756, {
                                                                        onClick: (e)=>e.stopPropagation(),
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        href: (0, $16b97261be8212a7$export$b1e41f75147fe8d2)(subscription.network, "address", subscription.subscriptionType.automatedEVMSubscription.buyerAddress),
                                                                        children: [
                                                                            (0, $8d017118df5fe2e5$export$193698062786be9a)(subscription.subscriptionType.automatedEVMSubscription.buyerAddress, 6),
                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $aac8e983fd3225f1$export$2e2bcd8739ae039), {
                                                                                stroke: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                                                width: 13
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        subscription.status !== "active" && new Date(subscription.nextBillingDateAt).getTime() > new Date().getTime() && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    style: {
                                                                        opacity: 0.5
                                                                    },
                                                                    children: "Expires in"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    children: (0, $bd17aec34555d69e$export$2e2bcd8739ae039)((0, $2a16fa66856ff33d$export$2e2bcd8739ae039)({
                                                                        start: new Date(subscription.nextBillingDateAt),
                                                                        end: new Date()
                                                                    }), {
                                                                        format: [
                                                                            "years",
                                                                            "months",
                                                                            "days"
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                subscription.status === "active" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                width: "100%",
                                                                height: 1,
                                                                backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 10,
                                                                alignItems: "center"
                                                            },
                                                            children: [
                                                                subscription.subscriptionType.emailInvoiceSubscription && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                                    style: {
                                                                        width: "100%",
                                                                        background: "black"
                                                                    },
                                                                    onClick: ()=>{
                                                                        resetPaymentState();
                                                                        setIsPaying(true);
                                                                    },
                                                                    children: "Make subscription payment"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                                    style: {
                                                                        padding: 3,
                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                                        border: 0,
                                                                        width: "fit-content"
                                                                    },
                                                                    onClick: ()=>setCancelSubscriptionModalOpen(true),
                                                                    children: "Cancel subscription"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        isPaying && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 30
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                    onClick: ()=>{
                                                        setIsPaying(false);
                                                        setManagedPaymentDetails(undefined);
                                                    },
                                                    style: {
                                                        border: 0,
                                                        padding: 0,
                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 5,
                                                        opacity: 0.5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                                            style: {
                                                                transform: "rotate(90deg)"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            children: "Back"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $06825994d276e479$export$2e2bcd8739ae039), {
                                                    checkoutData: {
                                                        subscription: subscription,
                                                        chargeCustomerNetworkFee: true,
                                                        customizations: customizations,
                                                        gateway: {
                                                            managed: {
                                                                methods: [
                                                                    {
                                                                        network: subscription.network,
                                                                        token: subscription.token
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    },
                                                    currency: "USD",
                                                    isPreProcessingPayment: isPreProcessingPayment,
                                                    isSuccess: isSuccess,
                                                    successElement: successElement,
                                                    paymentStatus: paymentStatus,
                                                    onCheckout: async (c)=>{
                                                        setIsPreProcessingPayment(true);
                                                        try {
                                                            const res = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).createSubscriptionPayment(subscription.id);
                                                            if (res.paymentMethodDetails.managed) setManagedPaymentDetails(res.paymentMethodDetails.managed);
                                                            const checkPaymentInterval = setInterval(()=>{
                                                                if (!res.paymentMethodDetails.managed) return;
                                                                (0, $43c053927acc0cba$export$2e2bcd8739ae039).getManagedPaymentStatus(res.paymentMethodDetails.managed?.paymentId).then((res)=>{
                                                                    setPaymentStatus(res);
                                                                    if (res.status === "paymentConfirmed") {
                                                                        setIsSuccess(true);
                                                                        clearInterval(checkPaymentInterval);
                                                                        setSuccessElement(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                            style: {
                                                                                display: "flex",
                                                                                flexDirection: "row",
                                                                                alignItems: "center",
                                                                                gap: 10
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d8ee75bdf024b924$export$2e2bcd8739ae039), {
                                                                                        width: 30,
                                                                                        height: 30,
                                                                                        animationDelay: "0.5s",
                                                                                        animationSpeed: "0.75s"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                    style: {
                                                                                        fontSize: 18,
                                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                                                                    },
                                                                                    children: "Payment successful"
                                                                                })
                                                                            ]
                                                                        }));
                                                                    }
                                                                }).catch(()=>{});
                                                            }, 1000);
                                                        } catch (err) {}
                                                        setIsPreProcessingPayment(false);
                                                    },
                                                    managedPaymentDetails: managedPaymentDetails,
                                                    onChangePaymentMethod: resetPaymentState,
                                                    onQuoteUpdate: ()=>{},
                                                    disableAnimation: true
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                subscription.subscriptionType.emailInvoiceSubscription && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                    style: {
                                        padding: 3,
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                        border: 0
                                    },
                                    onClick: ()=>setShowPastPayments(!showPastPayments),
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: 5,
                                            alignItems: "center",
                                            justifyContent: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                children: [
                                                    showPastPayments ? "Hide" : "Show",
                                                    " past payments"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                                style: {
                                                    opacity: 0.4,
                                                    rotate: showPastPayments ? "180deg" : "0deg",
                                                    transition: "0.2s ease all"
                                                }
                                            })
                                        ]
                                    })
                                }),
                                showPastPayments && (subscription.payments ?? []).map((p, i)=>{
                                    const method = (0, $5760199798158999$export$8793fab959da70d1)(p.network, p.token);
                                    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $0ce5a428e300b80d$export$60332b2344f7fe41), {
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                style: {
                                                    fontSize: 16
                                                },
                                                children: [
                                                    "Payment #",
                                                    i + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                style: {
                                                    width: "100%",
                                                    height: 1,
                                                    backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST,
                                                    margin: "20px 0"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    gridTemplateColumns: "repeat(2, fit-content(100%))",
                                                    display: "grid",
                                                    rowGap: 30,
                                                    columnGap: 40
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                children: "Network"
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 4
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                        style: {
                                                                            width: 20,
                                                                            height: 20,
                                                                            backgroundImage: `url(${method.tokenInfo?.logo ?? method.logo})`,
                                                                            backgroundSize: "contain",
                                                                            backgroundPosition: "center",
                                                                            backgroundRepeat: "no-repeat",
                                                                            position: "relative"
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                        children: method.tokenInfo?.networkName ?? method.name
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                children: "Amount"
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 8
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                        style: {
                                                                            width: 20,
                                                                            height: 20,
                                                                            backgroundImage: `url(${method.logo})`,
                                                                            backgroundSize: "contain",
                                                                            backgroundPosition: "center",
                                                                            backgroundRepeat: "no-repeat",
                                                                            position: "relative"
                                                                        },
                                                                        children: method.tokenInfo && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                            style: {
                                                                                background: "rgba(255, 255, 255, 0.95)",
                                                                                borderRadius: "100%",
                                                                                width: 12,
                                                                                height: 12,
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                position: "absolute",
                                                                                bottom: -1,
                                                                                right: -5,
                                                                                boxShadow: "0 0 1px"
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                style: {
                                                                                    width: 8,
                                                                                    height: 8,
                                                                                    backgroundImage: `url(${method.tokenInfo.logo})`,
                                                                                    backgroundSize: "contain",
                                                                                    backgroundPosition: "center",
                                                                                    backgroundRepeat: "no-repeat"
                                                                                }
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                        children: Number(p.amount)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                children: "Transactions"
                                                            }),
                                                            (p.transactionHashes ?? []).map((t)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($23109ce8e3723d50$export$8c2efd953f9e6756, {
                                                                    onClick: (e)=>e.stopPropagation(),
                                                                    target: "_blank",
                                                                    rel: "noreferrer",
                                                                    href: (0, $16b97261be8212a7$export$b1e41f75147fe8d2)(p.network, "tx", t),
                                                                    children: [
                                                                        (0, $8d017118df5fe2e5$export$193698062786be9a)(t, 6),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $aac8e983fd3225f1$export$2e2bcd8739ae039), {
                                                                            stroke: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK,
                                                                            width: 13
                                                                        })
                                                                    ]
                                                                }, t))
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                children: "Date"
                                                            }),
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                children: (0, $50403809f98fa2f7$export$2e2bcd8739ae039)(new Date(p.date), new Date())
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, i);
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $91a7bca2e0a02780$export$2e2bcd8739ae039), {
                title: "Cancel subscription",
                visible: cancelSubscriptionModalOpen,
                onClose: ()=>setCancelSubscriptionModalOpen(false),
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            padding: "10px 30px",
                            gap: 20,
                            fontSize: 14
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                            children: "Are you sure you would like to cancel your subscription?"
                        })
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        style: {
                            padding: 20
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                            style: {
                                width: "100%",
                                backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                            },
                            isLoading: isCancelling,
                            onClick: async ()=>{
                                if (!subscriptionId) return;
                                setIsCancelling(true);
                                (0, $43c053927acc0cba$export$2e2bcd8739ae039).cancelSubscription(subscriptionId).then(async ()=>await fetchSubscription()).catch(()=>{}).finally(()=>{
                                    setIsCancelling(false);
                                    setCancelSubscriptionModalOpen(false);
                                });
                            },
                            children: "Cancel subscription"
                        })
                    })
                ]
            })
        ]
    });
};
var $23109ce8e3723d50$export$2e2bcd8739ae039 = $23109ce8e3723d50$var$SubscriptionView;


// src/queryClient.ts

// src/queryCache.ts

// src/query.ts




var $a5115cbe15278d05$export$62297b13309008b2 = class extends (0, $55b970f24c1c5ee7$export$e09608847fcc8c59) {
    #initialState;
    #revertState;
    #cache;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = config.state || $a5115cbe15278d05$var$getDefaultState(this.options);
        this.state = this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $5dfb5b9a80630a8b$export$17619bac5b909b23)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.#dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $5dfb5b9a80630a8b$export$8793edee2d425525)).catch((0, $5dfb5b9a80630a8b$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.#initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $5dfb5b9a80630a8b$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (!this.options.queryFn || this.options.queryFn === (0, $5dfb5b9a80630a8b$export$1aa5a89531b7670d)) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        this.options.behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        const onError = (error)=>{
            if (!((0, $8dc79ca1ee4f70f8$export$986cc6445c1d323)(error) && error.silent)) this.#dispatch({
                type: "error",
                error: error
            });
            if (!(0, $8dc79ca1ee4f70f8$export$986cc6445c1d323)(error)) {
                this.#cache.config.onError?.(error, this);
                this.#cache.config.onSettled?.(this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        this.#retryer = (0, $8dc79ca1ee4f70f8$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                this.#cache.config.onSuccess?.(data, this);
                this.#cache.config.onSettled?.(data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        return this.#retryer.start();
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$a5115cbe15278d05$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $8dc79ca1ee4f70f8$export$986cc6445c1d323)(error) && error.revert && this.#revertState) return {
                        ...this.#revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $a5115cbe15278d05$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $8dc79ca1ee4f70f8$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $a5115cbe15278d05$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $d53828acabf2c813$export$5dde0cd941da8468 = class extends (0, $d61d2bdd5fa15550$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $5dfb5b9a80630a8b$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $a5115cbe15278d05$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $5dfb5b9a80630a8b$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $5dfb5b9a80630a8b$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};


// src/mutationCache.ts




var $25303685acb10bf6$export$1fcfd9a244434844 = class extends (0, $d61d2bdd5fa15550$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Map();
        this.#mutationId = Date.now();
    }
    #mutations;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $c39499a820a95a1b$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        const scope = $25303685acb10bf6$var$scopeFor(mutation);
        const mutations = this.#mutations.get(scope) ?? [];
        mutations.push(mutation);
        this.#mutations.set(scope, mutations);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        const scope = $25303685acb10bf6$var$scopeFor(mutation);
        if (this.#mutations.has(scope)) {
            const mutations = this.#mutations.get(scope)?.filter((x)=>x !== mutation);
            if (mutations) {
                if (mutations.length === 0) this.#mutations.delete(scope);
                else this.#mutations.set(scope, mutations);
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const firstPendingMutation = this.#mutations.get($25303685acb10bf6$var$scopeFor(mutation))?.find((m)=>m.state.status === "pending");
        return !firstPendingMutation || firstPendingMutation === mutation;
    }
    runNext(mutation) {
        const foundMutation = this.#mutations.get($25303685acb10bf6$var$scopeFor(mutation))?.find((m)=>m !== mutation && m.state.isPaused);
        return foundMutation?.continue() ?? Promise.resolve();
    }
    clear() {
        (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return [
            ...this.#mutations.values()
        ].flat();
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $5dfb5b9a80630a8b$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $5dfb5b9a80630a8b$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $5dfb5b9a80630a8b$export$8793edee2d425525)))));
    }
};
function $25303685acb10bf6$var$scopeFor(mutation) {
    return mutation.options.scope?.id ?? String(mutation.mutationId);
}





// src/infiniteQueryBehavior.ts

function $56797cf7ec16a2eb$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                const options = context.options;
                const direction = context.fetchOptions?.meta?.fetchMore?.direction;
                const oldPages = context.state.data?.pages || [];
                const oldPageParams = context.state.data?.pageParams || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn && context.options.queryFn !== (0, $5dfb5b9a80630a8b$export$1aa5a89531b7670d) ? context.options.queryFn : ()=>{
                    return Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`));
                };
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $5dfb5b9a80630a8b$export$8c6246b73dd61f4a) : (0, $5dfb5b9a80630a8b$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $56797cf7ec16a2eb$var$getPreviousPageParam : $56797cf7ec16a2eb$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $56797cf7ec16a2eb$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $56797cf7ec16a2eb$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $56797cf7ec16a2eb$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams);
}
function $56797cf7ec16a2eb$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $56797cf7ec16a2eb$var$getNextPageParam(options, data) != null;
}
function $56797cf7ec16a2eb$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $56797cf7ec16a2eb$var$getPreviousPageParam(options, data) != null;
}


var $8b9d185dc2ce01e1$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $d53828acabf2c813$export$5dde0cd941da8468)();
        this.#mutationCache = config.mutationCache || new (0, $25303685acb10bf6$export$1fcfd9a244434844)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $7b5df0496e6ff019$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $54b2c43c090d3758$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        if (cachedData === void 0) return this.fetchQuery(options);
        else {
            const defaultedOptions = this.defaultQueryOptions(options);
            const query = this.#queryCache.build(this, defaultedOptions);
            if (options.revalidateIfStale && query.isStaleByTime(defaultedOptions.staleTime)) this.prefetchQuery(defaultedOptions);
            return Promise.resolve(cachedData);
        }
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, $5dfb5b9a80630a8b$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $5dfb5b9a80630a8b$export$8793edee2d425525)).catch((0, $5dfb5b9a80630a8b$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options?.cancelRefetch ?? true
        };
        const promises = (0, $cb00b657be35baa3$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $5dfb5b9a80630a8b$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $5dfb5b9a80630a8b$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $5dfb5b9a80630a8b$export$8793edee2d425525)).catch((0, $5dfb5b9a80630a8b$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $56797cf7ec16a2eb$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $5dfb5b9a80630a8b$export$8793edee2d425525)).catch((0, $5dfb5b9a80630a8b$export$8793edee2d425525));
    }
    resumePausedMutations() {
        if ((0, $54b2c43c090d3758$export$b113e788b2dd3fdc).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $5dfb5b9a80630a8b$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $5dfb5b9a80630a8b$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $5dfb5b9a80630a8b$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $5dfb5b9a80630a8b$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $5dfb5b9a80630a8b$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, $5dfb5b9a80630a8b$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};




parcelRequire("bnENU");


var $bnENU = parcelRequire("bnENU");











var $6Dftn = parcelRequire("6Dftn");




var $fDWVA = parcelRequire("fDWVA");







function $bdc4b3c06a4413f5$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}


function $384d82dbddd07818$export$2e2bcd8739ae039(object) {
    return (0, $bdc4b3c06a4413f5$export$2e2bcd8739ae039)({}, object);
}





var $87c9686e10305b48$var$MINUTES_IN_DAY = 1440;
var $87c9686e10305b48$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $87c9686e10305b48$var$MINUTES_IN_MONTH = 43200;
var $87c9686e10305b48$var$MINUTES_IN_TWO_MONTHS = 86400;
function $87c9686e10305b48$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $6e3145262e897fb9$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $46f8710aa8a87258$export$2e2bcd8739ae039);
    if (!locale.formatDistance) throw new RangeError("locale must contain formatDistance property");
    var comparison = (0, $08121a36a9b63f2e$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, $bdc4b3c06a4413f5$export$2e2bcd8739ae039)((0, $384d82dbddd07818$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyBaseDate);
        dateRight = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
    } else {
        dateLeft = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyDate);
        dateRight = (0, $57ad6a2f8ace4ec4$export$2e2bcd8739ae039)(dirtyBaseDate);
    }
    var seconds = (0, $b42a9811b1b67611$export$2e2bcd8739ae039)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $cc5f146101733a31$export$2e2bcd8739ae039)(dateRight) - (0, $cc5f146101733a31$export$2e2bcd8739ae039)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $87c9686e10305b48$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $87c9686e10305b48$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $87c9686e10305b48$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $87c9686e10305b48$var$MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $87c9686e10305b48$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $87c9686e10305b48$var$MINUTES_IN_MONTH);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $096360ed154bb762$export$2e2bcd8739ae039)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $87c9686e10305b48$var$MINUTES_IN_MONTH);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}



function $30d93d29e26dabaf$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $d12a27f68fbe2a7a$export$2e2bcd8739ae039)(1, arguments);
    return (0, $87c9686e10305b48$export$2e2bcd8739ae039)(dirtyDate, Date.now(), options);
}






const $5efe5fcb4ce2b706$var$Wrapper = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  flex-grow: 1;
  animation: ${(0, $06825994d276e479$export$b2a0bb8fc9a08697)} 0.2s ease;
`;
const $5efe5fcb4ce2b706$var$TokenIcon = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 20px;
  height: 20px;
  background-image: url(${({ imageUrl: imageUrl })=>imageUrl});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;
const $5efe5fcb4ce2b706$var$TimeInnerContainer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;
var $5efe5fcb4ce2b706$var$State;
(function(State) {
    State[State["SettingAmount"] = 0] = "SettingAmount";
    State[State["SettingPaymentMethod"] = 1] = "SettingPaymentMethod";
    State[State["SettingInputFields"] = 2] = "SettingInputFields";
    State[State["MakingPayment"] = 3] = "MakingPayment";
})($5efe5fcb4ce2b706$var$State || ($5efe5fcb4ce2b706$var$State = {}));
function $5efe5fcb4ce2b706$var$Presale(props) {
    const [customizations, setCustomizations] = (0, $bnENU.useState)({
        leftPanelColor: "white",
        primaryButtonColor: "black"
    });
    const [searchParams] = (0, $f0e8e6c6e69cddf0$export$f1a78c17382fe22a)();
    const [fiatAmount, setFiatAmount] = (0, $bnENU.useState)();
    const [tokenAmount, setTokenAmount] = (0, $bnENU.useState)();
    const [bonusTokenAmount, setBonusTokenAmount] = (0, $bnENU.useState)();
    // Delisted methods stay in checkout data for API backwards-compat but must
    // never be pre-selected or selectable on the hosted checkout.
    const [selectedMethod, setSelectedPaymentMethod] = (0, $bnENU.useState)(props.checkoutData.gateway.managed?.methods.find((m)=>!(0, $5760199798158999$export$53becfa3eb141e16)(m.network, m.token)));
    const [state, setState] = (0, $bnENU.useState)(0);
    const [startsAt, setStartsAt] = (0, $bnENU.useState)();
    const [endsAt, setEndsAt] = (0, $bnENU.useState)();
    const [nextPriceIncreaseAt, setNextPriceIncreaseAt] = (0, $bnENU.useState)();
    (0, $bnENU.useEffect)(()=>{
        setSelectedPaymentMethod(props.checkoutData.gateway.managed?.methods.find((m)=>!(0, $5760199798158999$export$53becfa3eb141e16)(m.network, m.token)));
    }, [
        props.checkoutData.gateway.managed?.methods
    ]);
    if (!props.checkoutData.products || props.checkoutData.products?.length <= 0) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {});
    const presaleData = props.checkoutData.presaleData;
    const token = props.checkoutData.products[0];
    const titleTextColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 1)", "rgba(0, 0, 0, 1)");
    const lightTextColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.05)", "rgba(0, 0, 0, 0.05)");
    const mediumTextColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.1)", "rgba(0, 0, 0, 0.1)");
    const textColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.45)", "rgba(0, 0, 0, 0.45)");
    const darkTextColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.65)", "rgba(0, 0, 0, 0.65)");
    const buttonTextColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.primaryButtonColor, "rgba(255, 255, 255, 0.95)", "rgba(0, 0, 0, 0.95)");
    const [priceMultiplier, setPriceMultiplier] = (0, $bnENU.useState)(1);
    const getBonus = (amount, bonusLevels)=>{
        for (const level of bonusLevels){
            if (amount >= level.greaterThan && amount < level.lessThan) return level.bonus;
        }
        return 0;
    };
    const setTokenAmountFromFiatAmount = (fiatAmount)=>{
        const price = token.product.price * priceMultiplier;
        const tokenAmount = Number(fiatAmount) / price;
        const bonus = getBonus(tokenAmount, presaleData?.tokenPresaleData?.bonus ?? []);
        setTokenAmount((0, $fDWVA.round)(tokenAmount, token.product.productType?.Presale?.Token?.decimals).toString());
        setBonusTokenAmount((tokenAmount * bonus / 100).toString());
    };
    const setFiatAmountFromTokenAmount = (tokenAmount)=>{
        const bonus = getBonus(tokenAmount, presaleData?.tokenPresaleData?.bonus ?? []);
        setBonusTokenAmount((tokenAmount * bonus / 100).toString());
        const price = token.product.price * priceMultiplier;
        const fiatAmount = Number(tokenAmount) * price;
        setFiatAmount((0, $fDWVA.round)(fiatAmount, 2).toString());
    };
    const updateIntervals = ()=>{
        const { startsAt: startsAt, endsAt: endsAt, pricingStrategies: pricingStrategies } = presaleData?.tokenPresaleData ?? {};
        setStartsAt(startsAt ? new Date(startsAt) : undefined);
        setEndsAt(endsAt ? new Date(endsAt) : undefined);
        setNextPriceIncreaseAt(undefined);
        if (pricingStrategies) {
            const { timeBased: timeBased } = pricingStrategies;
            if (timeBased) {
                const { startsAt: startsAt, roundDurationSeconds: roundDurationSeconds, priceIncreasePercentage: priceIncreasePercentage } = timeBased;
                const roundDuration = roundDurationSeconds * 1000 || 1000;
                const start = new Date(startsAt).getTime();
                const now = new Date().getTime();
                let nextIncreaseAt;
                if (start > now) nextIncreaseAt = start + roundDuration;
                else {
                    nextIncreaseAt = start + Math.ceil((now - start) / roundDuration) * roundDuration;
                    const multipliers = Math.floor((now - start) / roundDuration);
                    const percentIncrease = 1 + multipliers * priceIncreasePercentage;
                    setPriceMultiplier(percentIncrease);
                }
                setNextPriceIncreaseAt((0, $2a16fa66856ff33d$export$2e2bcd8739ae039)({
                    start: new Date(),
                    end: new Date(nextIncreaseAt)
                }));
            }
        }
        const amountBased = pricingStrategies?.amountBased;
        if (amountBased) {
            const totalRaised = Number(presaleData?.tokenPresaleData?.totalAmountRaised ?? 0);
            for (const stage of amountBased.sort((a, b)=>Number(b.targetAmount) - Number(a.targetAmount))){
                const targetAmount = Number(stage.targetAmount);
                const priceIncreaseTo = Number(stage.priceIncreaseTo);
                if (totalRaised >= targetAmount) {
                    const newMultipliers = 1 + (priceIncreaseTo - token.product.price) / token.product.price;
                    setPriceMultiplier(newMultipliers);
                    return;
                }
            }
        }
        setPriceMultiplier(1);
    };
    (0, $bnENU.useEffect)(()=>{
        setCustomizations(props.checkoutData.customizations ?? customizations);
        const interval = setInterval(()=>updateIntervals(), 1000);
        updateIntervals();
        return ()=>clearInterval(interval);
    }, [
        props.checkoutData
    ]);
    (0, $bnENU.useEffect)(()=>{
        setErrorMessage(props.errorMessage);
    }, [
        props.errorMessage
    ]);
    const [managedPaymentQrCode, setManagedPaymentQrCode] = (0, $bnENU.useState)("");
    const generateManagedPaymentQrCode = async ()=>{
        if (!props.managedPaymentDetails) return;
        const darkColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.leftPanelColor, "#00000000", "#ffffff00");
        const lightColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)(customizations.primaryButtonColor, "#000000", "#000000");
        const [qrCodeData] = await (0, $772308ca90c00f76$export$45312203e6f4f22c)(props.managedPaymentDetails, lightColor, darkColor, true);
        setManagedPaymentQrCode(qrCodeData);
    };
    const [errorMessage, setErrorMessage] = (0, $bnENU.useState)();
    const { disconnect: disconnect } = (0, $9d39a2f446de0538$export$83bebf2fe7fead4e)();
    const { address: address, isConnected: isConnected, connector: connector } = (0, $2739213b2d55f551$export$83a8e409853da004)();
    const { open: open } = (0, $c8101c12137113f6$export$69804ca079d47f29)();
    const [isWalletLoading, setIsWalletLoading] = (0, $bnENU.useState)(false);
    const onClickOpenWallet = async ()=>{
        if (!props.managedPaymentDetails) return;
        switch(props.managedPaymentDetails.network){
            case "Bitcoin":
            case "Solana":
            case "Zcash":
            case "ZcashTestnet":
                break;
            case "Ethereum":
            case "SepoliaTestnet":
            case "Polygon":
            case "PolygonTestnet":
            case "BNB":
            case "BNBTestnet":
            case "Base":
            case "Arbitrum":
            case "Avalanche":
                try {
                    setErrorMessage("");
                    if (!address) {
                        await open();
                        return;
                    }
                    if (!selectedMethod) return;
                    setIsWalletLoading(true);
                    const chain = (0, $5760199798158999$export$cc4208a8ebc9f985)[props.managedPaymentDetails.network];
                    const provider = await connector?.getProvider();
                    const signer = (0, $bf4e0381e2c41280$export$362b8ea2edbd9090)({
                        chain: chain,
                        transport: (0, $c1b76a8a2251eb69$export$4c00f665f0d4b443)(provider)
                    });
                    if (connector?.switchChain) {
                        const chainId = await connector.getChainId();
                        if (chainId !== chain.id) await connector?.switchChain({
                            chainId: chain.id
                        });
                    }
                    if (props.managedPaymentDetails.token) {
                        const contract = (0, $4a68b247381b8806$export$f518c38144e1f9d)({
                            address: props.managedPaymentDetails.token,
                            abi: (0, $6Dftn.erc20Abi),
                            client: signer
                        });
                        const balance = await contract.read.balanceOf([
                            address
                        ]);
                        const decimals = await contract.read.decimals();
                        const parsedAmount = (0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(props.managedPaymentDetails.amount.toString(), decimals);
                        if (balance < parsedAmount) {
                            setIsWalletLoading(false);
                            return setErrorMessage(`Your wallet does not have enough ${(0, $5760199798158999$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).name} for payment.`);
                        }
                        await contract.write.transfer([
                            props.managedPaymentDetails.paymentAddress,
                            (0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(props.managedPaymentDetails.amount, decimals)
                        ], {
                            account: address,
                            chain: chain
                        });
                    } else {
                        const publicClient = (0, $8085cfeffb1fd5c6$export$d8e090d8c6a7a6ad)({
                            chain: chain,
                            transport: (0, $ff2d1e1ca66a97fb$export$7d6f1c8842f9f527)()
                        });
                        const contract = (0, $4a68b247381b8806$export$f518c38144e1f9d)({
                            address: props.managedPaymentDetails.token,
                            abi: (0, $6Dftn.erc20Abi),
                            client: {
                                public: publicClient,
                                wallet: signer
                            }
                        });
                        try {
                            const balance = await contract.read.balanceOf([
                                address
                            ]);
                            if (balance < (0, $5316bee174ce871c$export$642c4e67bbdc0bc7)(props.managedPaymentDetails.amount)) {
                                setIsWalletLoading(false);
                                return setErrorMessage(`Your wallet does not have enough ${selectedMethod?.token ?? "amount"} for payment.`);
                            }
                        } catch (err) {
                            console.log(err);
                        }
                        if (!signer) return;
                        await signer.sendTransaction({
                            account: address,
                            chain: chain,
                            to: props.managedPaymentDetails.paymentAddress,
                            value: (0, $5316bee174ce871c$export$642c4e67bbdc0bc7)(props.managedPaymentDetails.amount)
                        });
                        setIsWalletLoading(false);
                    }
                } catch (err) {
                    setIsWalletLoading(false);
                    // setErrorMessage('Failed to open wallet. Please ensure you have enough funds.')
                    console.error(err);
                }
                break;
            default:
                console.error("No wallet");
        }
    };
    const totalRaised = Number(presaleData?.tokenPresaleData?.totalAmountRaised ?? 0);
    const totalGoal = Number(presaleData?.tokenPresaleData?.totalRaiseAmount) || 1;
    const amountBasedStages = presaleData?.tokenPresaleData?.pricingStrategies?.amountBased ?? [];
    const segments = amountBasedStages.map((stage)=>{
        const stageTarget = Number(stage.targetAmount);
        const reached = totalRaised >= stageTarget;
        return {
            width: stageTarget / totalGoal * 100,
            color: reached ? customizations.primaryButtonColor : lightTextColor,
            borderColor: titleTextColor
        };
    });
    let currentStageName = "";
    for (const stage of amountBasedStages.sort((a, b)=>Number(b.targetAmount) - Number(a.targetAmount))){
        const stageTarget = Number(stage.targetAmount);
        if (totalRaised >= stageTarget) {
            currentStageName = stage.name;
            break;
        }
    }
    (0, $bnENU.useEffect)(()=>{
        if (props.managedPaymentDetails) generateManagedPaymentQrCode();
    }, [
        props.managedPaymentDetails
    ]);
    (0, $bnENU.useEffect)(()=>{
        const customUrlParmasLabel = [
            "fiatAmount",
            "tokenAmount"
        ];
        for (const label of customUrlParmasLabel){
            const value = searchParams.get(label);
            if (value) {
                if (label === "fiatAmount") {
                    setFiatAmount(value);
                    setTokenAmountFromFiatAmount(Number(value));
                } else if (label === "tokenAmount") {
                    setTokenAmount(value);
                    setFiatAmountFromTokenAmount(Number(value));
                }
            }
        }
    }, [
        priceMultiplier
    ]);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 14,
            minHeight: "100%"
        },
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
            style: {
                width: 450,
                minHeight: 550,
                maxWidth: "100%",
                background: customizations.leftPanelColor,
                padding: 30,
                borderRadius: 25,
                display: "flex",
                flexDirection: "column",
                position: "relative",
                overflow: "hidden"
            },
            children: [
                (props.paymentStatus ? Number(props.paymentStatus.amountRemaining) > 0 : true) && props.managedPaymentDetails && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $06825994d276e479$export$c825e58f74061357), {
                    style: {
                        zIndex: 0,
                        pointerEvents: "none",
                        opacity: 0.15
                    },
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $06825994d276e479$export$b8bb87b40c00c04e), {
                        style: {
                            top: 150
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 30,
                        textAlign: "center",
                        zIndex: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                            style: {
                                fontSize: Number(presaleData?.tokenPresaleData?.customizations?.titleFontSize ?? 46),
                                fontWeight: 800,
                                fontFamily: presaleData?.tokenPresaleData?.customizations?.titleFontFamily,
                                color: presaleData?.tokenPresaleData?.customizations?.titleFontColor ?? titleTextColor
                            },
                            children: [
                                presaleData?.tokenPresaleData?.customizations?.title ?? `BUY $${token.product.productType?.Presale?.Token?.ticker}`,
                                currentStageName !== "" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                    style: {
                                        fontSize: Number(presaleData?.tokenPresaleData?.customizations?.titleFontSize ?? 24),
                                        marginBottom: 10
                                    },
                                    children: currentStageName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                            style: {
                                color: textColor
                            },
                            children: [
                                "1 ",
                                token.product.productType?.Presale?.Token?.ticker,
                                " = ",
                                (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(token.product.currency, token.product.price * priceMultiplier, 10)
                            ]
                        })
                    ]
                }),
                state === 0 && !nextPriceIncreaseAt && endsAt && endsAt.getTime() > new Date().getTime() && (!startsAt || startsAt && startsAt.getTime() < new Date().getTime()) && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginBottom: 30
                    },
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        style: {
                            padding: "10px 20px",
                            color: darkTextColor,
                            backgroundColor: lightTextColor,
                            borderRadius: 10
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                            children: [
                                "Presale ends in ",
                                (0, $30d93d29e26dabaf$export$2e2bcd8739ae039)(endsAt)
                            ]
                        })
                    })
                }),
                state === 0 && nextPriceIncreaseAt && (!endsAt || endsAt && endsAt.getTime() > new Date().getTime()) && (!startsAt || startsAt && startsAt.getTime() < new Date().getTime()) && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: 30,
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "center",
                            borderRadius: 10,
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                style: {
                                    fontSize: 14,
                                    color: titleTextColor
                                },
                                children: "Next price increase in"
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    alignItems: "center",
                                    border: `1px solid ${mediumTextColor}`,
                                    borderRadius: 10,
                                    overflow: "hidden"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            alignItems: "center",
                                            display: "grid",
                                            gridTemplateColumns: "repeat(4, 1fr)",
                                            width: "100%",
                                            padding: 15
                                        },
                                        children: [
                                            "days",
                                            "hours",
                                            "minutes",
                                            "seconds"
                                        ].map((t)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($5efe5fcb4ce2b706$var$TimeInnerContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            textTransform: "uppercase",
                                                            color: darkTextColor,
                                                            fontSize: 10
                                                        },
                                                        children: (0, $fDWVA.startCase)(t)
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            color: titleTextColor,
                                                            fontSize: 18
                                                        },
                                                        children: nextPriceIncreaseAt[t]
                                                    })
                                                ]
                                            }, t))
                                    }),
                                    endsAt && endsAt.getTime() > new Date().getTime() && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            color: darkTextColor,
                                            fontSize: 12,
                                            textAlign: "center",
                                            backgroundColor: lightTextColor,
                                            width: "100%",
                                            padding: 3
                                        },
                                        children: [
                                            "Presale ends in ",
                                            (0, $30d93d29e26dabaf$export$2e2bcd8739ae039)(endsAt)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                (props.paymentStatus ? Number(props.paymentStatus.amountRemaining) > 0 : true) && props.managedPaymentDetails && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($5efe5fcb4ce2b706$var$Wrapper, {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 30
                    },
                    children: [
                        props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $06825994d276e479$export$ec3c7ce6a909733b), {
                            style: {
                                boxShadow: "initial"
                            },
                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $06825994d276e479$export$3c6b4f0e2cd37515), {
                                style: {
                                    border: "1px solid",
                                    borderColor: textColor,
                                    background: "white",
                                    borderRadius: 10,
                                    width: 168,
                                    height: 168,
                                    position: "relative",
                                    overflow: "hidden",
                                    padding: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            width: "100%",
                                            height: "100%",
                                            position: "absolute",
                                            opacity: 0.15,
                                            zIndex: 0,
                                            left: 0,
                                            top: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                        src: managedPaymentQrCode,
                                        style: {
                                            width: 160,
                                            height: 160,
                                            position: "relative",
                                            zIndex: 1
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                rowGap: 20,
                                columnGap: 30,
                                flexWrap: "wrap",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        fontSize: 12,
                                        gap: 3
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        opacity: 0.5,
                                                        textTransform: "uppercase",
                                                        color: darkTextColor
                                                    },
                                                    children: "Amount due"
                                                }),
                                                props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $06825994d276e479$export$4f2558dd25106ae2), {
                                                    style: {
                                                        background: lightTextColor,
                                                        color: textColor
                                                    },
                                                    iconColor: textColor,
                                                    onClick: async ()=>await navigator.clipboard.writeText((0, $8d017118df5fe2e5$export$f5dd818bff069720)(props.managedPaymentDetails?.amount, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 18
                                                        }))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                fontSize: 16,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 5,
                                                fontWeight: 300,
                                                color: titleTextColor
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                    src: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                    style: {
                                                        height: 20,
                                                        width: "auto"
                                                    }
                                                }),
                                                (0, $8d017118df5fe2e5$export$f5dd818bff069720)(props.managedPaymentDetails.amount, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 18
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        opacity: 0.5,
                                                        fontWeight: 100
                                                    },
                                                    children: (0, $5760199798158999$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).ticker
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                    children: [
                                                        "on ",
                                                        selectedMethod?.network
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        fontSize: 12,
                                        gap: 3,
                                        alignItems: "start"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                opacity: 0.5,
                                                textTransform: "uppercase",
                                                textAlign: "center",
                                                color: darkTextColor
                                            },
                                            children: "Time remaining"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                fontSize: 16,
                                                fontWeight: 100,
                                                textAlign: "center",
                                                color: titleTextColor
                                            },
                                            children: (0, $06825994d276e479$export$8e3f267d166b4a05)((new Date(props.managedPaymentDetails.expiresAt).getTime() - new Date().getTime()) / 1000)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        fontSize: 12,
                                        gap: 3
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        opacity: 0.5,
                                                        textTransform: "uppercase",
                                                        color: darkTextColor
                                                    },
                                                    children: "Payment address"
                                                }),
                                                props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $06825994d276e479$export$4f2558dd25106ae2), {
                                                    style: {
                                                        background: lightTextColor,
                                                        color: textColor
                                                    },
                                                    iconColor: textColor,
                                                    onClick: async ()=>await navigator.clipboard.writeText(props.managedPaymentDetails?.paymentAddress ?? "")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            style: {
                                                fontSize: 16,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                                fontWeight: 100,
                                                color: titleTextColor,
                                                overflowWrap: "anywhere",
                                                textAlign: "left"
                                            },
                                            children: props.paymentStatus?.status === "expired" ? "Expired" : props.managedPaymentDetails.paymentAddress
                                        })
                                    ]
                                })
                            ]
                        }),
                        errorMessage && errorMessage.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                            style: {
                                backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR,
                                padding: 15,
                                borderRadius: 5,
                                color: "white",
                                overflowWrap: "break-word"
                            },
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                backgroundColor: address ? lightTextColor : "initial",
                                borderBottomLeftRadius: 25,
                                borderBottomRightRadius: 25,
                                borderTopLeftRadius: 5,
                                borderTopRightRadius: 5
                            },
                            children: [
                                selectedMethod && (0, $5760199798158999$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).name !== "Bitcoin" && !(0, $5760199798158999$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).isSolana && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                    children: [
                                        address && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        color: darkTextColor,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                textTransform: "uppercase",
                                                                fontSize: 10
                                                            },
                                                            children: "Connected wallet"
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            children: (0, $8d017118df5fe2e5$export$193698062786be9a)(address, 10)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                    disabled: isWalletLoading,
                                                    onClick: ()=>disconnect(),
                                                    style: {
                                                        padding: 0,
                                                        border: 0,
                                                        color: titleTextColor,
                                                        textTransform: "uppercase",
                                                        fontSize: 10
                                                    },
                                                    children: "Disconnect"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                            onClick: onClickOpenWallet,
                                            isLoading: isWalletLoading,
                                            spinnerColor: buttonTextColor,
                                            style: {
                                                background: customizations.primaryButtonColor,
                                                color: buttonTextColor,
                                                width: "100%"
                                            },
                                            children: isConnected ? "Approve payment" : "Connect wallet"
                                        })
                                    ]
                                }),
                                selectedMethod && (0, $5760199798158999$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).isSolana && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $ad5727fe9615d0d0$export$2e2bcd8739ae039), {
                                    managedPaymentDetails: props.managedPaymentDetails,
                                    isLoading: isWalletLoading,
                                    setIsLoading: setIsWalletLoading,
                                    primaryButtonColor: props.checkoutData.customizations?.primaryButtonColor,
                                    presaleStyling: {
                                        titleTextColor: titleTextColor,
                                        darkTextColor: darkTextColor,
                                        buttonTextColor: buttonTextColor
                                    }
                                })
                            ]
                        })
                    ]
                }),
                props.paymentStatus?.status === "expired" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexGrow: 1,
                        flexDirection: "column",
                        gap: 5
                    },
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                            style: {
                                fontSize: 18,
                                color: titleTextColor
                            },
                            children: "Payment expired"
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                            style: {
                                color: darkTextColor,
                                textAlign: "center",
                                marginBottom: 20
                            },
                            children: "The payment timer has expired."
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                            onClick: ()=>window.location.reload(),
                            isLoading: props.isPreProcessingPayment,
                            style: {
                                background: customizations.primaryButtonColor,
                                color: buttonTextColor,
                                width: "100%"
                            },
                            children: "Refresh"
                        })
                    ]
                }),
                Number(props.paymentStatus?.amountRemaining) <= 0 && props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 30,
                            width: "100%",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                        style: {
                                            background: customizations.primaryButtonColor,
                                            width: 45,
                                            height: 45
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d8ee75bdf024b924$export$2e2bcd8739ae039), {
                                            animationDelay: "0.5s",
                                            animationSpeed: "0.75s",
                                            stroke: buttonTextColor
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            fontSize: 18,
                                            color: titleTextColor
                                        },
                                        children: "Payment successful"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, auto)",
                                    rowGap: 10,
                                    columnGap: 20,
                                    width: "100%",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    border: "1px solid",
                                    borderColor: lightTextColor,
                                    borderRadius: 25,
                                    padding: 20
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            color: textColor
                                        },
                                        children: "Order ID"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            gap: 5,
                                            alignItems: "center",
                                            color: titleTextColor
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            children: props.order?.id
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            gridColumn: "span 2",
                                            borderBottom: "1px solid",
                                            margin: "5px 0",
                                            borderColor: textColor,
                                            opacity: 0.25
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            color: textColor
                                        },
                                        children: "Tokens purchased"
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: 5,
                                            alignItems: "center",
                                            color: titleTextColor
                                        },
                                        children: [
                                            token.product.imageUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($5efe5fcb4ce2b706$var$TokenIcon, {
                                                imageUrl: token.product.imageUrl
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                children: tokenAmount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            gridColumn: "span 2",
                                            borderBottom: "1px solid",
                                            margin: "5px 0",
                                            borderColor: textColor,
                                            opacity: 0.25
                                        }
                                    }),
                                    props.checkoutData.inputFields?.map((iF, i)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        color: textColor
                                                    },
                                                    children: iF.inputLabel
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        color: titleTextColor,
                                                        textOverflow: "ellipsis",
                                                        overflow: "auto"
                                                    },
                                                    children: iF.value
                                                }),
                                                props.checkoutData.inputFields && i < props.checkoutData.inputFields.length - 1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        gridColumn: "span 2",
                                                        borderBottom: "1px solid",
                                                        borderColor: textColor,
                                                        opacity: 0.25
                                                    }
                                                })
                                            ]
                                        }))
                                ]
                            })
                        ]
                    })
                }),
                !props.managedPaymentDetails && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                    children: [
                        state === 1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($5efe5fcb4ce2b706$var$Wrapper, {
                            style: {
                                display: "flex",
                                flexGrow: 1,
                                overflow: "scroll",
                                border: `1px solid ${lightTextColor}`,
                                borderRadius: 15,
                                maxHeight: 340
                            },
                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8,
                                    width: "100%",
                                    height: "fit-content",
                                    padding: 10
                                },
                                children: [
                                    props.checkoutData.gateway.managed?.methods.filter((method)=>!(0, $5760199798158999$export$53becfa3eb141e16)(method.network, method.token)).map((method, i)=>{
                                        const m = (0, $5760199798158999$export$8793fab959da70d1)(method.network, method.token);
                                        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                            onClick: ()=>{
                                                setSelectedPaymentMethod(method);
                                                setState(0);
                                            },
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "left",
                                                gap: 5,
                                                background: lightTextColor,
                                                padding: 15,
                                                borderRadius: 15,
                                                fontSize: 14
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                    style: {
                                                        width: 20,
                                                        height: 20,
                                                        backgroundImage: `url(${m.logo})`,
                                                        backgroundSize: "contain",
                                                        backgroundPosition: "center",
                                                        backgroundRepeat: "no-repeat",
                                                        position: "relative"
                                                    },
                                                    children: m.tokenInfo && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            background: "rgba(255, 255, 255, 0.95)",
                                                            borderRadius: "100%",
                                                            width: 12,
                                                            height: 12,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            position: "absolute",
                                                            bottom: -1,
                                                            right: -5,
                                                            boxShadow: "0 0 1px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                width: 8,
                                                                height: 8,
                                                                backgroundImage: `url(${m.tokenInfo.logo})`,
                                                                backgroundSize: "contain",
                                                                backgroundPosition: "center",
                                                                backgroundRepeat: "no-repeat"
                                                            }
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        color: titleTextColor
                                                    },
                                                    children: m.tokenInfo ? `${m.name} on ${m.tokenInfo.networkName}` : m.name
                                                })
                                            ]
                                        }, i);
                                    }),
                                    (props.checkoutData.gateway.managed?.methods ?? []).filter((method)=>!(0, $5760199798158999$export$53becfa3eb141e16)(method.network, method.token)).length === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            color: textColor,
                                            fontSize: 14,
                                            textAlign: "center",
                                            padding: 10
                                        },
                                        children: "No payment methods available"
                                    })
                                ]
                            })
                        }),
                        state === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($5efe5fcb4ce2b706$var$Wrapper, {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 15,
                                    justifyContent: "center"
                                },
                                children: [
                                    presaleData?.tokenPresaleData?.totalRaiseAmount && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: 10,
                                            flexDirection: "column",
                                            marginBottom: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    width: "100%",
                                                    background: lightTextColor,
                                                    height: 15,
                                                    borderRadius: 25,
                                                    overflow: "hidden",
                                                    position: "relative"
                                                },
                                                children: [
                                                    segments.map((segment, index)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                position: "absolute",
                                                                width: `${segment.width}%`,
                                                                maxWidth: "99%",
                                                                height: "100%",
                                                                background: index !== segments.length - 1 ? segment.color : "none",
                                                                transition: "width 0.3s ease-in-out, border-right 0.3s ease-in-out",
                                                                boxShadow: index !== segments.length - 1 ? "5px 0 15px rgba(0, 0, 0, 0.3)" : "none" // 添加阴影效果
                                                            }
                                                        }, index)),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                        style: {
                                                            position: "absolute",
                                                            zIndex: 1,
                                                            width: `${Number(presaleData?.tokenPresaleData.totalAmountRaised ?? 0) / Number(presaleData?.tokenPresaleData.totalRaiseAmount) * 100}%`,
                                                            height: "100%",
                                                            background: customizations.primaryButtonColor
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    textTransform: "uppercase",
                                                    fontSize: 12,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    color: textColor,
                                                    fontWeight: 600
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                        children: [
                                                            token.product.currency,
                                                            " raised"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                        children: [
                                                            (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(token.product.currency, presaleData?.tokenPresaleData.totalAmountRaised ?? 0),
                                                            !presaleData?.tokenPresaleData?.customizations?.hideTotalRaiseGoal && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                                                children: [
                                                                    "/ ",
                                                                    (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(token.product.currency, presaleData?.tokenPresaleData.totalRaiseAmount)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            border: `1px solid ${mediumTextColor}`,
                                            borderRadius: 15,
                                            padding: 15,
                                            color: textColor,
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    flexGrow: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            gap: 10,
                                                            alignItems: "center",
                                                            marginBottom: 10
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                children: [
                                                                    "You pay (",
                                                                    token.product.currency,
                                                                    ")"
                                                                ]
                                                            }),
                                                            fiatAmount && Number(fiatAmount) < Number(presaleData?.tokenPresaleData?.minimumPurchaseAmount ?? 0) && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                style: {
                                                                    color: "red",
                                                                    textTransform: "uppercase",
                                                                    fontSize: 10
                                                                },
                                                                children: [
                                                                    "Min ",
                                                                    presaleData?.tokenPresaleData?.minimumPurchaseAmount
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                        placeholder: (0, $0478aee74ce0fceb$export$bc56dd87ebd6aae2)(token.product.currency, fiatAmount ? Number(fiatAmount) : 0),
                                                        disabled: props.isPreProcessingPayment,
                                                        value: fiatAmount,
                                                        onChange: (e)=>{
                                                            if (!isNaN(e.target.value)) {
                                                                const amount = e.target.value;
                                                                setFiatAmount(amount);
                                                                setTokenAmountFromFiatAmount(amount);
                                                            }
                                                        },
                                                        placeholderColor: textColor,
                                                        style: {
                                                            border: 0,
                                                            boxShadow: "none",
                                                            padding: 0,
                                                            fontSize: 16,
                                                            background: "none",
                                                            color: titleTextColor
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                onClick: ()=>setState(1),
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 5,
                                                    background: lightTextColor,
                                                    padding: "5px 10px",
                                                    borderRadius: 15,
                                                    fontSize: 14
                                                },
                                                children: selectedMethod && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                width: 20,
                                                                height: 20,
                                                                backgroundImage: `url(${(0, $5760199798158999$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).logo})`,
                                                                backgroundSize: "contain",
                                                                backgroundPosition: "center",
                                                                backgroundRepeat: "no-repeat",
                                                                position: "relative"
                                                            },
                                                            children: (0, $5760199798158999$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).tokenInfo && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                style: {
                                                                    background: "rgba(255, 255, 255, 0.95)",
                                                                    borderRadius: "100%",
                                                                    width: 12,
                                                                    height: 12,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    position: "absolute",
                                                                    bottom: -1,
                                                                    right: -5,
                                                                    boxShadow: "0 0 1px"
                                                                },
                                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                    style: {
                                                                        width: 8,
                                                                        height: 8,
                                                                        backgroundImage: `url(${(0, $5760199798158999$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).tokenInfo?.logo})`,
                                                                        backgroundSize: "contain",
                                                                        backgroundPosition: "center",
                                                                        backgroundRepeat: "no-repeat"
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                color: titleTextColor
                                                            },
                                                            children: (0, $5760199798158999$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).name
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                                            fill: titleTextColor,
                                                            style: {
                                                                transform: "rotate(-90deg)",
                                                                opacity: 0.6
                                                            }
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                        style: {
                                            border: `1px solid ${mediumTextColor}`,
                                            borderRadius: 15,
                                            padding: 15,
                                            color: textColor,
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    flexGrow: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                        style: {
                                                            marginBottom: 10
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                children: "You receive"
                                                            }),
                                                            bonusTokenAmount && bonusTokenAmount !== "0" && presaleData?.tokenPresaleData?.customizations?.bonusTitle && presaleData?.tokenPresaleData?.customizations?.bonusTitle !== "" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                style: {
                                                                    color: titleTextColor,
                                                                    borderRadius: 5,
                                                                    boxShadow: "0px 4px 6px rgba(0, 0.1, 0.1, 0.2)",
                                                                    fontSize: 10,
                                                                    padding: "5px 10px",
                                                                    justifyContent: "center",
                                                                    marginLeft: 5
                                                                },
                                                                children: presaleData.tokenPresaleData?.customizations?.bonusTitle ?? ""
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                        disabled: props.isPreProcessingPayment,
                                                        placeholder: "0",
                                                        value: tokenAmount && bonusTokenAmount ? (Number(tokenAmount) + Number(bonusTokenAmount)).toString() : tokenAmount,
                                                        onChange: (e)=>{
                                                            if (!isNaN(e.target.value)) {
                                                                const amount = e.target.value;
                                                                setTokenAmount(amount);
                                                                setFiatAmountFromTokenAmount(amount);
                                                            }
                                                        },
                                                        placeholderColor: textColor,
                                                        style: {
                                                            border: 0,
                                                            boxShadow: "none",
                                                            padding: 0,
                                                            fontSize: 16,
                                                            background: "none",
                                                            color: titleTextColor
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 5,
                                                    background: lightTextColor,
                                                    padding: "5px 10px",
                                                    borderRadius: 15
                                                },
                                                children: [
                                                    token.product.imageUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($5efe5fcb4ce2b706$var$TokenIcon, {
                                                        imageUrl: token.product.imageUrl
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            color: titleTextColor
                                                        },
                                                        children: token.product.productType?.Presale?.Token?.ticker
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: 2
                                        },
                                        children: [
                                            ...new Set(props.checkoutData.gateway.managed?.methods.filter((p)=>!(0, $5760199798158999$export$53becfa3eb141e16)(p.network, p.token)).map((p)=>(0, $5760199798158999$export$8793fab959da70d1)(p.network, p.token).logo))
                                        ].map((p, i)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                style: {
                                                    height: 20,
                                                    maxWidth: 20
                                                },
                                                src: p
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                        disabled: Number(fiatAmount ?? 1) < Number(presaleData?.tokenPresaleData?.minimumPurchaseAmount ?? 0),
                                        onClick: ()=>{
                                            if (startsAt && startsAt.getTime() > new Date().getTime()) return;
                                            if (endsAt && endsAt.getTime() < new Date().getTime()) return;
                                            if (selectedMethod && tokenAmount) setState(2);
                                        },
                                        isLoading: props.isPreProcessingPayment,
                                        style: {
                                            background: customizations.primaryButtonColor,
                                            color: buttonTextColor
                                        },
                                        children: startsAt && startsAt.getTime() > new Date().getTime() ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    children: "Presale starts in"
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 12,
                                                        opacity: 0.5
                                                    },
                                                    children: (0, $bd17aec34555d69e$export$2e2bcd8739ae039)((0, $2a16fa66856ff33d$export$2e2bcd8739ae039)({
                                                        start: new Date(),
                                                        end: startsAt
                                                    }))
                                                })
                                            ]
                                        }) : endsAt && endsAt.getTime() < new Date().getTime() ? "Presale has ended" : "Continue"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                !props.managedPaymentDetails && state === 2 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($5efe5fcb4ce2b706$var$Wrapper, {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                columnGap: 40,
                                rowGap: 20,
                                flexWrap: "wrap"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        color: textColor,
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: "Token amount"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 5,
                                                alignItems: "center",
                                                color: titleTextColor
                                            },
                                            children: [
                                                token.product.imageUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($5efe5fcb4ce2b706$var$TokenIcon, {
                                                    imageUrl: token.product.imageUrl
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    children: tokenAmount
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        color: textColor,
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: "Payment method"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 5,
                                                alignItems: "center",
                                                color: titleTextColor
                                            },
                                            children: selectedMethod && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                        style: {
                                                            height: 20,
                                                            maxWidth: 20
                                                        },
                                                        src: (0, $5760199798158999$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).logo
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                        style: {
                                                            opacity: 0.75,
                                                            fontWeight: 100
                                                        },
                                                        children: (0, $5760199798158999$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).ticker
                                                    }),
                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                        children: [
                                                            "on ",
                                                            selectedMethod?.network
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                presaleData?.tokenPresaleData?.bonus !== undefined && presaleData?.tokenPresaleData?.bonus !== null && bonusTokenAmount && bonusTokenAmount !== "0" && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        color: textColor,
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: "Bonus reward"
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 5,
                                                alignItems: "center",
                                                color: titleTextColor
                                            },
                                            children: [
                                                token.product.imageUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($5efe5fcb4ce2b706$var$TokenIcon, {
                                                    imageUrl: token.product.imageUrl
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                    children: (0, $fDWVA.round)(Number(bonusTokenAmount), 6)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        props.checkoutData.inputFields?.map((inputField, i)=>/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                style: {
                                    border: `1px solid ${mediumTextColor}`,
                                    borderRadius: 15,
                                    padding: 15,
                                    color: textColor,
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        flexGrow: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: inputField.inputLabel
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                            autoFocus: i === 0,
                                            disabled: props.isPreProcessingPayment,
                                            placeholder: `Enter ${inputField.inputLabel.toLowerCase()}`,
                                            value: inputField.value,
                                            onChange: (e)=>{
                                                if (!props.checkoutData.inputFields) return;
                                                const target = e.target;
                                                let val = target.value;
                                                if (inputField.inputLabel === "Email address") val = val.toLowerCase();
                                                const newInputs = props.checkoutData.inputFields.slice();
                                                newInputs[i].value = val;
                                                props.onInputFieldsChange?.(newInputs);
                                            },
                                            placeholderColor: textColor,
                                            style: {
                                                border: 0,
                                                boxShadow: "none",
                                                padding: 0,
                                                fontSize: 16,
                                                background: "none",
                                                color: titleTextColor
                                            }
                                        })
                                    ]
                                })
                            }, i)),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                            style: {
                                display: "flex",
                                flexGrow: 1
                            }
                        }),
                        errorMessage && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: 5,
                                width: "100%",
                                backgroundColor: "red",
                                borderRadius: 5,
                                padding: "10px 15px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        color: "white",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 3,
                                        textTransform: "uppercase",
                                        opacity: 0.75,
                                        fontSize: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $604fb7faec27af0d$export$2e2bcd8739ae039), {
                                            style: {
                                                height: 8,
                                                width: 8
                                            },
                                            stroke: "white",
                                            strokeWidth: 2
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            children: "Error"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                    style: {
                                        color: "white"
                                    },
                                    children: errorMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                gap: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                    onClick: ()=>{
                                        setErrorMessage(undefined);
                                        setState(0);
                                    },
                                    disabled: props.isPreProcessingPayment,
                                    spinnerColor: buttonTextColor,
                                    style: {
                                        background: lightTextColor,
                                        color: textColor,
                                        borderRadius: 25,
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 0,
                                        alignItems: "center",
                                        gap: 3
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $34655a3478656274$export$65be7b63f510f362), {
                                            fill: textColor,
                                            style: {
                                                transform: "rotate(90deg)",
                                                height: 14,
                                                width: 14,
                                                marginTop: -2
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                            children: "Back"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                    onClick: ()=>{
                                        const paidAmount = tokenAmount ?? "0";
                                        if (selectedMethod && tokenAmount) props.onCheckout({
                                            selectedMethod: selectedMethod,
                                            tokenAmount: paidAmount
                                        });
                                    },
                                    isLoading: props.isPreProcessingPayment,
                                    spinnerColor: buttonTextColor,
                                    style: {
                                        background: customizations.primaryButtonColor,
                                        color: buttonTextColor,
                                        flexGrow: 1,
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0
                                    },
                                    children: "Continue"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: 30
                    },
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                        href: "https://www.radom.com/crypto-presales",
                        target: "_blank",
                        title: "Crypto Presale Powered by Radom",
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                            cursor: "pointer",
                            userSelect: "none",
                            textDecoration: "none",
                            color: textColor
                        },
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                style: {
                                    fontSize: 8,
                                    fontWeight: 100,
                                    marginBottom: 2
                                },
                                children: "Crypto Presale"
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: 14,
                                    fontWeight: 100
                                },
                                children: [
                                    "Powered by",
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                        width: 60,
                                        height: 14,
                                        fill: textColor
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                style: {
                                    position: "absolute",
                                    width: "1px",
                                    height: "1px",
                                    margin: "-1px",
                                    padding: 0,
                                    overflow: "hidden",
                                    clip: "rect(0, 0, 0, 0)",
                                    border: 0
                                },
                                children: "Radom"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $5efe5fcb4ce2b706$export$2e2bcd8739ae039 = $5efe5fcb4ce2b706$var$Presale;




parcelRequire("bnENU");

function $9fc9621b4020f2cb$var$LoadingPresale() {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 14,
            minHeight: "100%"
        },
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
            style: {
                width: 450,
                minHeight: 550,
                maxWidth: "100%",
                padding: 30,
                borderRadius: 25,
                display: "flex",
                flexDirection: "column"
            }
        })
    });
}
var $9fc9621b4020f2cb$export$2e2bcd8739ae039 = $9fc9621b4020f2cb$var$LoadingPresale;



var $jtAZT = parcelRequire("jtAZT");
var $3940b4cd84e3ba62$require$Buffer = $jtAZT.Buffer;
function $3940b4cd84e3ba62$var$PresalePreview() {
    const location = (0, $6738ab3539650fb6$export$45d76561a5302f2b)();
    const paymentLinkData = JSON.parse($3940b4cd84e3ba62$require$Buffer.from(location.hash.replace("#", ""), "base64").toString("utf8"));
    if (!paymentLinkData || paymentLinkData.products.length <= 0) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $9fc9621b4020f2cb$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $5efe5fcb4ce2b706$export$2e2bcd8739ae039), {
        checkoutData: {
            ...paymentLinkData,
            products: paymentLinkData.products.map((p)=>{
                return {
                    product: p,
                    quantity: 1
                };
            })
        },
        onCheckout: ()=>{},
        isPreProcessingPayment: false,
        isSuccess: false,
        successElement: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {})
    });
}
var $3940b4cd84e3ba62$export$2e2bcd8739ae039 = $3940b4cd84e3ba62$var$PresalePreview;




var $bnENU = parcelRequire("bnENU");





var $fDWVA = parcelRequire("fDWVA");




function $278c8c19bab9424a$var$PresaleView() {
    const paymentLinkId = window.location.pathname.split("/").filter(Boolean).pop() ?? "";
    if (typeof window !== "undefined" && !window.__W3M_INITIALIZED__) {
        (0, $1a6c142165b114fb$export$14650d4efb17e382)({
            wagmiConfig: $5760199798158999$export$382a3cc012b91987,
            projectId: $5760199798158999$export$e4bb003b4e7478a,
            enableAnalytics: true
        });
        window.__W3M_INITIALIZED__ = true;
    }
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(true);
    const [searchParams] = (0, $f0e8e6c6e69cddf0$export$f1a78c17382fe22a)();
    const [paymentLinkData, setPaymentLinkData] = (0, $bnENU.useState)();
    const [isPreProcessingPayment, setIsPreProcessingPayment] = (0, $bnENU.useState)(false);
    const [order, setOrder] = (0, $bnENU.useState)();
    const [managedPaymentDetails, setManagedPaymentDetails] = (0, $bnENU.useState)();
    const [paymentStatus, setPaymentStatus] = (0, $bnENU.useState)();
    const trackedFunnelStepsRef = (0, $bnENU.useRef)(new Set());
    const [inputFields, setInputFields] = (0, $bnENU.useState)([]);
    const [errorMessage, setErrorMessage] = (0, $bnENU.useState)();
    const [loadErrorMessage, setLoadErrorMessage] = (0, $bnENU.useState)();
    (0, $bnENU.useEffect)(()=>{
        setLoadErrorMessage(undefined);
        (0, $43c053927acc0cba$export$2e2bcd8739ae039).getPaymentLink(paymentLinkId).then((data)=>{
            setPaymentLinkData(data);
            if (!trackedFunnelStepsRef.current.has("viewed")) {
                trackedFunnelStepsRef.current.add("viewed");
                (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
                    sourceType: "presale",
                    sourceId: paymentLinkId,
                    rail: "crypto",
                    step: "viewed"
                });
            }
            if (data.inputFields) {
                const inputFields = [];
                for (const input of data.inputFields){
                    const prefilledValue = searchParams.get((0, $fDWVA.camelCase)(input.inputLabel));
                    inputFields.push({
                        ...input,
                        value: prefilledValue ?? ""
                    });
                }
                setInputFields(inputFields);
            }
        }).catch((err)=>{
            setLoadErrorMessage(err?.response?.data?.error ?? err?.message ?? "Unable to load this presale link.");
        }).finally(()=>{
            setIsLoading(false);
        });
    }, []);
    if (isLoading) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $9fc9621b4020f2cb$export$2e2bcd8739ae039), {});
    if (loadErrorMessage) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7c18a005ad02503d$export$2e2bcd8739ae039), {
        title: "Presale unavailable",
        message: loadErrorMessage,
        onRetry: async ()=>{
            window.location.reload();
        }
    });
    if (!paymentLinkData || paymentLinkData.products.length <= 0) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            padding: 24,
            textAlign: "center",
            color: "#111827"
        },
        children: "This presale link is currently unavailable."
    });
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $5efe5fcb4ce2b706$export$2e2bcd8739ae039), {
        checkoutData: {
            ...paymentLinkData,
            inputFields: inputFields,
            products: paymentLinkData.products.map((p)=>{
                return {
                    product: p,
                    quantity: 1
                };
            })
        },
        onCheckout: async ({ selectedMethod: selectedMethod, tokenAmount: tokenAmount })=>{
            try {
                setErrorMessage(undefined);
                setIsPreProcessingPayment(true);
                const orderRes = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).createPaymentLinkOrder({
                    paymentLinkId: paymentLinkId,
                    paymentMethod: {
                        managed: {
                            method: selectedMethod
                        }
                    },
                    orderData: [
                        ...inputFields.map((c)=>{
                            return {
                                key: c.inputLabel,
                                value: c.value.toString()
                            };
                        }),
                        {
                            key: "Token amount",
                            value: tokenAmount
                        }
                    ]
                });
                if (!trackedFunnelStepsRef.current.has("paymentInitiated")) {
                    trackedFunnelStepsRef.current.add("paymentInitiated");
                    (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
                        sourceType: "presale",
                        sourceId: paymentLinkId,
                        rail: "crypto",
                        step: "paymentInitiated",
                        metadata: {
                            network: selectedMethod.network,
                            tokenAddress: selectedMethod.token
                        }
                    });
                }
                setOrder(orderRes);
                setIsPreProcessingPayment(false);
                if (orderRes.paymentMethodDetails.managed) setManagedPaymentDetails(orderRes.paymentMethodDetails.managed);
                const checkPaymentInterval = setInterval(()=>{
                    if (!orderRes.paymentMethodDetails.managed) return;
                    (0, $43c053927acc0cba$export$2e2bcd8739ae039).getManagedPaymentStatus(orderRes.paymentMethodDetails.managed?.paymentId).then((res)=>{
                        setPaymentStatus(res);
                        if (res.status === "paymentConfirmed") {
                            if (!trackedFunnelStepsRef.current.has("paymentConfirmed")) {
                                trackedFunnelStepsRef.current.add("paymentConfirmed");
                                (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
                                    sourceType: "presale",
                                    sourceId: paymentLinkId,
                                    rail: "crypto",
                                    step: "paymentConfirmed"
                                });
                            }
                            if (window?.parent) window.parent.postMessage({
                                orderId: orderRes.id,
                                status: res.status
                            }, "*");
                            clearInterval(checkPaymentInterval);
                        }
                        if (res.status === "failed") {
                            if (!trackedFunnelStepsRef.current.has("paymentFailed")) {
                                trackedFunnelStepsRef.current.add("paymentFailed");
                                (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
                                    sourceType: "presale",
                                    sourceId: paymentLinkId,
                                    rail: "crypto",
                                    step: "paymentFailed"
                                });
                            }
                            clearInterval(checkPaymentInterval);
                        }
                    }).catch(()=>{});
                }, 1000);
            } catch (err) {
                setErrorMessage(err.reason || err.message);
                setIsPreProcessingPayment(false);
            }
        },
        order: order,
        managedPaymentDetails: managedPaymentDetails,
        errorMessage: errorMessage,
        isPreProcessingPayment: isPreProcessingPayment,
        paymentStatus: paymentStatus,
        onInputFieldsChange: setInputFields,
        isSuccess: false,
        successElement: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {})
    });
}
var $278c8c19bab9424a$export$2e2bcd8739ae039 = $278c8c19bab9424a$var$PresaleView;




var $bnENU = parcelRequire("bnENU");







var $fDWVA = parcelRequire("fDWVA");









var $bnENU = parcelRequire("bnENU");




const $e754e21e54414cee$var$StyledCopyButton = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)((0, $d589b7ebc11d644f$export$f861551692d63a2e))`
  padding: 2px 4px;
  font-size: 10px;
  text-transform: uppercase;
  background: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED};
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST};
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 2px;
  border: none;
`;
const $e754e21e54414cee$var$CopyButton = ({ onClick: onClick, style: style, iconColor: iconColor = (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST })=>{
    const [copied, setCopied] = (0, $bnENU.useState)(false);
    (0, $bnENU.useEffect)(()=>{
        if (copied) {
            const timeout = setTimeout(()=>setCopied(false), 3000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        copied
    ]);
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($e754e21e54414cee$var$StyledCopyButton, {
        onClick: ()=>{
            setCopied(true);
            onClick();
        },
        style: style,
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                children: copied ? "Copied" : "Copy"
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d15b0de6bb1f6866$export$2e2bcd8739ae039), {
                style: {
                    height: 10
                },
                stroke: iconColor
            })
        ]
    });
};
var $e754e21e54414cee$export$2e2bcd8739ae039 = $e754e21e54414cee$var$CopyButton;




var $6Dftn = parcelRequire("6Dftn");











parcelRequire("bnENU");

const $7eba43859c4a69de$var$DrawCheck = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  from {
    stroke-dashoffset: 50;
  }
  to {
    stroke-dashoffset: 0;
  }
`;
const $7eba43859c4a69de$var$SpinnerCircle = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).path`
  stroke-dasharray: 50;
  stroke-dashoffset: 50;
  fill: none;
  animation: ${$7eba43859c4a69de$var$DrawCheck} ${({ animationSpeed: animationSpeed })=>animationSpeed} ease forwards;
  animation-delay: ${({ animationDelay: animationDelay })=>animationDelay};
`;
function $7eba43859c4a69de$var$SuccessSpinner({ animationDelay: animationDelay = "0s", animationSpeed: animationSpeed = "0.5s", ...props }) {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("svg", {
        width: "52",
        height: "52",
        viewBox: "0 0 52 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        strokeWidth: 4,
        stroke: "white",
        ...props,
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($7eba43859c4a69de$var$SpinnerCircle, {
            d: "M16 27L23 34L36 20",
            animationDelay: animationDelay,
            animationSpeed: animationSpeed
        })
    });
}
var $7eba43859c4a69de$export$2e2bcd8739ae039 = $7eba43859c4a69de$var$SuccessSpinner;



const $60de58894af34819$var$ErrorMessage = {
    APPLICANT_INTERRUPTED_INTERVIEW: "Applicant interrupted the video interview",
    ADDITIONAL_DOCUMENT_REQUIRED: "Additional document required",
    BACK_SIDE_MISSING: "Back side of the document is missing",
    BAD_AVATAR: "Avatar does not meet requirements",
    BAD_FACE_MATCHING: "Face matching failed between document and selfie",
    BAD_PROOF_OF_ADDRESS: "Incorrect proof of address",
    BAD_PROOF_OF_IDENTITY: "Incorrect proof of identity",
    BAD_PROOF_OF_PAYMENT: "Incorrect proof of payment",
    BAD_SELFIE: "Bad selfie uploaded",
    BAD_VIDEO_SELFIE: "Bad video selfie uploaded",
    BLACK_AND_WHITE: "Black and white document not accepted",
    COMPANY_NOT_DEFINED_BENEFICIARIES: "Beneficiaries not defined",
    COMPANY_NOT_DEFINED_REPRESENTATIVES: "Company representatives not defined",
    COMPANY_NOT_DEFINED_STRUCTURE: "Company control structure undefined",
    COMPANY_NOT_VALIDATED_BENEFICIARIES: "Beneficiaries not validated",
    COMPANY_NOT_VALIDATED_REPRESENTATIVES: "Representatives not validated",
    CONNECTION_INTERRUPTED: "Video interview connection interrupted",
    DIGITAL_DOCUMENT: "Digital document is not accepted",
    DOCUMENT_DEPRIVED: "Applicant deprived of document",
    DOCUMENT_DAMAGED: "Document is damaged",
    DOCUMENT_MISSING: "Required document missing during video call",
    DOCUMENT_PAGE_MISSING: "Document page is missing",
    EXPIRATION_DATE: "Document is expired",
    FRONT_SIDE_MISSING: "Front side of the document is missing",
    GRAPHIC_EDITOR: "Document appears to be edited",
    ID_INVALID: "Invalid identity document",
    INCOMPATIBLE_LANGUAGE: "Incompatible document language",
    INCOMPLETE_DOCUMENT: "Incomplete document",
    INCORRECT_SOCIAL_NUMBER: "Incorrect social number",
    PROBLEMATIC_APPLICANT_DATA: "Applicant data inconsistent with document",
    REQUESTED_DATA_MISMATCH: "Submitted data mismatch with document",
    SELFIE_WITH_PAPER: "Missing required selfie with paper",
    LOW_QUALITY: "Low quality document image",
    NOT_ALL_CHECKS_COMPLETED: "Not all verification checks completed",
    SCREENSHOTS: "Screenshots are not accepted",
    UNFILLED_ID: "ID is unsigned or unsealed",
    UNSATISFACTORY_PHOTOS: "Unsatisfactory photos",
    UNSUITABLE_ENV: "Unsuitable environment for verification",
    WRONG_ADDRESS: "Address mismatch",
    ADVERSE_MEDIA: "Adverse media found",
    AGE_REQUIREMENT_MISMATCH: "Age requirement not met",
    BLOCKLIST: "Applicant is on blocklist",
    CHECK_UNAVAILABLE: "Verification check unavailable",
    COMPROMISED_PERSONS: "Applicant flagged as politically compromised",
    CRIMINAL: "Applicant has criminal record",
    DB_DATA_MISMATCH: "Database data mismatch",
    DB_DATA_NOT_FOUND: "Database data not found",
    DOCUMENT_TEMPLATE: "Document appears to be a template",
    DUPLICATE: "Duplicate applicant not allowed",
    EXPERIENCE_REQUIREMENT_MISMATCH: "Experience requirement not met",
    FORGERY: "Forgery attempt detected",
    FRAUDULENT_LIVENESS: "Liveness check bypass attempt",
    FRAUDULENT_PATTERNS: "Fraudulent patterns detected",
    INCONSISTENT_PROFILE: "Inconsistent applicant profile",
    PEP: "Applicant is a PEP",
    REGULATIONS_VIOLATIONS: "Regulations violation detected",
    SANCTIONS: "Applicant is on sanctions list",
    SELFIE_MISMATCH: "Selfie does not match document",
    SPAM: "Applicant flagged as spam",
    NOT_DOCUMENT: "Uploaded file is not a valid document",
    THIRD_PARTY_INVOLVED: "Third-party involvement detected",
    UNSUPPORTED_LANGUAGE: "Unsupported language for video verification",
    WRONG_USER_REGION: "User region not allowed",
    SUSPICIOUS_PATTERNS: "Suspicious patterns detected"
};
const $60de58894af34819$export$94280540b9997672 = (errorCode)=>{
    return "KYC Failed: " + ($60de58894af34819$var$ErrorMessage[errorCode] || "Unknown error");
};






var $jtAZT = parcelRequire("jtAZT");
var $27bda91cc43d8a64$require$Buffer = $jtAZT.Buffer;
const $27bda91cc43d8a64$var$fadeIn = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const $27bda91cc43d8a64$var$AnimatedReceipt = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  animation: ${$27bda91cc43d8a64$var$fadeIn} 1s ease-in-out;
`;
const $27bda91cc43d8a64$var$BackgroundFadeIn = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: black;
  animation: ${(0, $aeddef6c40752364$export$21430ab519d0e9c)} 1s ease;
  opacity: 0;
`;
const $27bda91cc43d8a64$var$BackgroundScaleIn = (0, $2952da92fd5b9db2$export$d25ddfdf17c3ad3e)`
  from {
    background-size: 110%;
  }
  to {
    background-size: 100%;
  }
`;
const $27bda91cc43d8a64$var$Background = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  background-size: cover;
  height: 275px;
  max-height: 20%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;
  margin-bottom: 60px;
  background-repeat: no-repeat;
  animation: ${$27bda91cc43d8a64$var$BackgroundScaleIn} 0.5s ease;
  background-position: top center;
`;
const $27bda91cc43d8a64$var$QRCodeWrapperOuter = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  padding: 10px;
  border-radius: 20px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
`;
const $27bda91cc43d8a64$var$QRCodeWrapperInner = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  width: 160px;
  height: 160px;
  position: relative;
  overflow: hidden;
  border-radius: 10px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
const $27bda91cc43d8a64$var$PaymentDetailsContainer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039)((0, $0ce5a428e300b80d$export$42a852a2b6b56249))`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 0;
  max-width: 100%;
`;
const $27bda91cc43d8a64$var$Timer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  font-size: 14px;
  font-color: #3464E6;
  font-weight: 600;
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE};
  margin-bottom: 10px;
  background: #E7EDFF;
  padding: 8px 12px 8px 12px;
  gap: 8px;
  border-radius: 35px;
  opacity: 0px;
`;
const $27bda91cc43d8a64$var$IconContainer = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: inline-block;
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 4px;
  vertical-align: middle;
`;
const $27bda91cc43d8a64$var$PaymentDetailWithCopy = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;
const $27bda91cc43d8a64$var$PaymentDetailText = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 5px;
`;
const $27bda91cc43d8a64$var$PaymentDetailColumn = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding-top: 15px;
`;
const $27bda91cc43d8a64$var$AmountInputShell = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $27bda91cc43d8a64$var$AmountPrefix = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).span`
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #667085;
  font-size: 18px;
  font-weight: 500;
  pointer-events: none;
`;
const $27bda91cc43d8a64$var$getFiatCurrencySymbol = (currency)=>{
    try {
        const symbol = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency,
            currencyDisplay: "symbol"
        }).formatToParts(0).find((part)=>part.type === "currency")?.value;
        return symbol ?? currency;
    } catch  {
        return currency;
    }
};
const $27bda91cc43d8a64$var$sanitizeFiatAmountInput = (rawValue)=>{
    const valueWithoutChars = rawValue.replace(/[^\d.]/g, "");
    const [whole = "", ...fractionParts] = valueWithoutChars.split(".");
    const fraction = fractionParts.join("").slice(0, 2);
    return fractionParts.length > 0 ? `${whole}.${fraction}` : whole;
};
const $27bda91cc43d8a64$var$normalizeFiatAmount = (rawValue)=>{
    if (!rawValue) return "";
    const parsed = Number.parseFloat(rawValue);
    if (!Number.isFinite(parsed) || parsed <= 0) return "";
    return parsed.toFixed(2);
};
const $27bda91cc43d8a64$export$f2361e995ad47093 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
`;
const $27bda91cc43d8a64$export$8c2efd953f9e6756 = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).a`
  color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE};
  align-items: center;
  display: flex;
  gap: 3px;
  text-decoration: none;

  &:hover {
    color: ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ORANGE};
    text-decoration: underline;
  }
`;
var $27bda91cc43d8a64$var$KycCheckingViewControl;
(function(KycCheckingViewControl) {
    KycCheckingViewControl[KycCheckingViewControl["NONE"] = 0] = "NONE";
    KycCheckingViewControl[KycCheckingViewControl["PEDNING"] = 1] = "PEDNING";
    KycCheckingViewControl[KycCheckingViewControl["APPROVED"] = 2] = "APPROVED";
    KycCheckingViewControl[KycCheckingViewControl["SUBMITTED"] = 3] = "SUBMITTED";
    KycCheckingViewControl[KycCheckingViewControl["REJECTED"] = 4] = "REJECTED";
})($27bda91cc43d8a64$var$KycCheckingViewControl || ($27bda91cc43d8a64$var$KycCheckingViewControl = {}));
function $27bda91cc43d8a64$var$validEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}
function $27bda91cc43d8a64$var$composeAddressText(details, fallbackAddress) {
    if (!details) return fallbackAddress;
    const locality = [
        details.townOrCity,
        details.stateOrProvince
    ].map((part)=>part?.trim()).filter((part)=>Boolean(part && part.length > 0)).join(", ");
    const parts = [
        details.addressLine1,
        details.addressLine2,
        locality,
        details.postalCode
    ].map((part)=>part?.trim()).filter((part)=>Boolean(part && part.length > 0));
    if (parts.length > 0) return parts.join(", ");
    return details.formattedAddress ?? fallbackAddress;
}
function $27bda91cc43d8a64$var$DonationLink() {
    const location = (0, $6738ab3539650fb6$export$45d76561a5302f2b)();
    const { donationLinkId: donationLinkIdParam } = (0, $6738ab3539650fb6$export$99eaa27ddbbb95ef)();
    const isPreviewRoute = location.pathname === "/preview/donation";
    const donationLinkId = donationLinkIdParam ?? (isPreviewRoute ? "previewdonation" : location.pathname.split("/").filter(Boolean).pop() ?? "");
    if (typeof window !== "undefined" && !window.__W3M_INITIALIZED__) {
        (0, $1a6c142165b114fb$export$14650d4efb17e382)({
            wagmiConfig: $5760199798158999$export$382a3cc012b91987,
            projectId: $5760199798158999$export$e4bb003b4e7478a,
            enableAnalytics: true
        });
        window.__W3M_INITIALIZED__ = true;
    }
    const [donationLink, setDonationLink] = (0, $bnENU.useState)(null);
    const [isLoading, setIsLoading] = (0, $bnENU.useState)(true);
    const [selectedMethod, setSelectedMethod] = (0, $bnENU.useState)(null);
    const [donationAmount, setDonationAmount] = (0, $bnENU.useState)("");
    const [formatDonationAmount, setFormatDonationAmount] = (0, $bnENU.useState)("");
    const [closeFn, setCloseFn] = (0, $bnENU.useState)(()=>()=>{});
    const [paymentDetails, setPaymentDetails] = (0, $bnENU.useState)(null);
    const [managedPaymentQrCode, setManagedPaymentQrCode] = (0, $bnENU.useState)("");
    const [formStep, setFormStep] = (0, $bnENU.useState)(1);
    const [isSubmitting] = (0, $bnENU.useState)(false);
    const [timeRemaining, setTimeRemaining] = (0, $bnENU.useState)("");
    const [isPaymentConfirmed, setIsPaymentConfirmed] = (0, $bnENU.useState)(false);
    const [paymentStatus, setPaymentStatus] = (0, $bnENU.useState)(null);
    const { disconnect: disconnect } = (0, $9d39a2f446de0538$export$83bebf2fe7fead4e)();
    const { address: address, isConnected: isConnected, connector: connector } = (0, $2739213b2d55f551$export$83a8e409853da004)();
    const { open: open } = (0, $c8101c12137113f6$export$69804ca079d47f29)();
    const [isWalletLoading, setIsWalletLoading] = (0, $bnENU.useState)(false);
    const [checkTerms, setCheckTerms] = (0, $bnENU.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $bnENU.useState)();
    const errorRef = (0, $bnENU.useRef)(null);
    const trackedFunnelStepsRef = (0, $bnENU.useRef)(new Set());
    const textColor = (0, $8d017118df5fe2e5$export$8121a4101142837f)((0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST, "rgba(255, 255, 255, 0.45)", "rgba(0, 0, 0, 0.45)");
    const trackDonationStep = (step, metadata)=>{
        if (trackedFunnelStepsRef.current.has(step)) return;
        trackedFunnelStepsRef.current.add(step);
        (0, $d082008f50ed1b11$export$e763aef27fa496d8)({
            sourceType: "donationLink",
            sourceId: donationLink?.id ?? donationLinkId,
            rail: "crypto",
            step: step,
            metadata: metadata
        });
    };
    const trackDonationPaymentInitiated = (method)=>{
        trackDonationStep("paymentInitiated", {
            network: method?.tokenInfo?.networkName ?? method?.name,
            tokenAddress: method?.tokenInfo?.tokenAddress
        });
    };
    // kyc Stuff
    const [userKycData, setUserKycData] = (0, $bnENU.useState)({
        name: "",
        phoneNumber: "",
        countryOfResidence: "",
        address: "",
        dateOfBirth: "",
        passportFile: "",
        idCardFile: "",
        email: "",
        selfieFile: ""
    });
    const kycIntervalRef = (0, $bnENU.useRef)(null);
    const [kycViewControl, setKycViewControl] = (0, $bnENU.useState)(0);
    const [addressSuggestionList, setAddressSuggestionList] = (0, $bnENU.useState)([]);
    const debouncedFetch = (0, $bnENU.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($fDWVA))).debounce((value, countryCode, setAddressSuggestionList)=>{
        (0, $43c053927acc0cba$export$2e2bcd8739ae039).getGoolgePlaceAutoComplete(value, countryCode).then((res)=>{
            setAddressSuggestionList(res);
        });
    }, 500)).current;
    (0, $bnENU.useEffect)(()=>{
        if (donationLinkId !== "previewdonation") (0, $43c053927acc0cba$export$2e2bcd8739ae039).getDonationLink(donationLinkId).then((data)=>{
            setDonationLink(data);
            setIsLoading(false);
        }).catch((error)=>{
            console.error(error);
            setIsLoading(false);
        });
        else {
            const previewData = window.location.hash.substring(1);
            if (previewData) {
                const parsedData = JSON.parse($27bda91cc43d8a64$require$Buffer.from(previewData, "base64").toString("utf8"));
                setDonationLink(parsedData);
            }
            setIsLoading(false);
        }
    }, [
        donationLinkId,
        window.location.hash
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (donationLink && donationLink.methods?.length > 0) {
            const method = donationLink.methods[0];
            setSelectedMethod((0, $5760199798158999$export$8793fab959da70d1)(method.network, method.token));
            trackDonationStep("viewed");
        } else setSelectedMethod(null);
    }, [
        donationLink
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (paymentDetails?.expiresAt) {
            const interval = setInterval(()=>{
                const now = new Date().getTime();
                const distance = new Date(paymentDetails.expiresAt).getTime() - now;
                setTimeRemaining((0, $06825994d276e479$export$8e3f267d166b4a05)((new Date(paymentDetails.expiresAt).getTime() - new Date().getTime()) / 1000));
                if (distance < 0) {
                    clearInterval(interval);
                    setTimeRemaining("EXPIRED");
                }
            }, 1000);
            return ()=>clearInterval(interval);
        }
    }, [
        paymentDetails
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (kycIntervalRef.current) clearTimeout(kycIntervalRef.current);
        if (paymentDetails) {
            const checkPaymentInterval = setInterval(()=>{
                (0, $43c053927acc0cba$export$2e2bcd8739ae039).getManagedPaymentStatus(paymentDetails.paymentId).then((res)=>{
                    if (res.status === "paymentConfirmed") {
                        trackDonationStep("paymentConfirmed");
                        setPaymentStatus(res);
                        setIsPaymentConfirmed(true);
                        clearInterval(checkPaymentInterval);
                    } else if (res.status === "failed") {
                        trackDonationStep("paymentFailed");
                        clearInterval(checkPaymentInterval);
                    }
                }).catch(()=>{});
            }, 1000);
            return ()=>clearInterval(checkPaymentInterval);
        }
    }, [
        paymentDetails
    ]);
    (0, $bnENU.useEffect)(()=>{
        if (kycViewControl === 3) {
            kycIntervalRef.current = window.setInterval(()=>{
                (0, $43c053927acc0cba$export$2e2bcd8739ae039).getCustomerMatchEmailDobByDonationLink(donationLinkId, userKycData.email, userKycData.dateOfBirth).then(async (res)=>{
                    if (res.kycCheck === "Verified") {
                        if (kycIntervalRef.current !== null) {
                            clearInterval(kycIntervalRef.current);
                            kycIntervalRef.current = null;
                        }
                        if (!donationLink || !selectedMethod) return;
                        const paymentMethod = convertToIManagedPaymentMethod(selectedMethod);
                        trackDonationPaymentInitiated(selectedMethod);
                        const response = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).createDonationLinkOrder({
                            donationLinkId: donationLink.id,
                            paymentMethod: paymentMethod,
                            orderData: [
                                {
                                    key: "email address",
                                    value: userKycData.email.toLowerCase()
                                }
                            ],
                            amount: parseFloat(donationAmount),
                            currency: donationLink.currency
                        });
                        if (response.paymentMethodDetails.managed) {
                            setPaymentDetails(response.paymentMethodDetails.managed);
                            generateManagedPaymentQrCode(response.paymentMethodDetails.managed);
                            setKycViewControl(2);
                            setTimeout(()=>{
                                setFormStep(4);
                                setKycViewControl(0);
                            }, 2000);
                        } else console.error("Payment method details are not available");
                    } else if (res.kycCheck === "NotVerified") {
                        if (kycIntervalRef.current !== null) {
                            clearInterval(kycIntervalRef.current);
                            kycIntervalRef.current = null;
                        }
                        // setErrorMessage('KYC not verified')
                        setKycViewControl(4);
                        setTimeout(()=>{
                            setKycViewControl(0);
                            setFormStep(1);
                        }, 2000);
                    }
                }).catch((e)=>{
                    if (kycIntervalRef.current !== null) {
                        clearInterval(kycIntervalRef.current);
                        kycIntervalRef.current = null;
                    }
                    if (e.message === "Customer not found") setFormStep(2);
                    else setErrorMessage(e.message);
                });
            }, 2000);
            return ()=>{
                if (kycIntervalRef.current !== null) {
                    clearInterval(kycIntervalRef.current);
                    kycIntervalRef.current = null;
                }
            };
        }
    }, [
        kycViewControl
    ]);
    if (!donationLink) return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        children: "Error loading donation link"
    });
    const methods = donationLink.methods;
    function convertToIManagedPaymentMethod(method) {
        return {
            network: method.tokenInfo ? method.tokenInfo.networkName : method.name,
            token: method.tokenInfo ? method.tokenInfo.tokenAddress : undefined
        };
    }
    const handleNextStep = ()=>{
        setIsLoading(true);
        if (donationLinkId === "previewdonation") {
            setIsLoading(false);
            return;
        }
        setErrorMessage(undefined);
        if (!selectedMethod || !donationAmount) {
            setErrorMessage("Please select a payment method and enter a donation amount");
            return;
        }
        const amount = parseFloat(donationAmount);
        if (isNaN(amount) || amount <= 0) {
            setErrorMessage("Please enter a valid donation amount");
            return;
        }
        if (formStep === 1) {
            if (userKycData.email && userKycData.dateOfBirth) {
                if (!$27bda91cc43d8a64$var$validEmail(userKycData.email)) {
                    setErrorMessage("Please enter a valid email address");
                    setIsLoading(false);
                    return;
                }
                (0, $43c053927acc0cba$export$2e2bcd8739ae039).getCustomerMatchEmailDobByDonationLink(donationLink.id, userKycData.email, userKycData.dateOfBirth).then(async (res)=>{
                    if (res.kycCheck === "Verified") {
                        if (!selectedMethod) return;
                        const paymentMethod = convertToIManagedPaymentMethod(selectedMethod);
                        trackDonationPaymentInitiated(selectedMethod);
                        const response = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).createDonationLinkOrder({
                            donationLinkId: donationLink.id,
                            paymentMethod: paymentMethod,
                            orderData: [
                                {
                                    key: "email address",
                                    value: userKycData.email.toLowerCase()
                                }
                            ],
                            amount: parseFloat(donationAmount),
                            currency: donationLink.currency
                        });
                        if (response.paymentMethodDetails.managed) {
                            setPaymentDetails(response.paymentMethodDetails.managed);
                            generateManagedPaymentQrCode(response.paymentMethodDetails.managed);
                            setFormStep(4);
                        } else console.error("Payment method details are not available");
                    } else if (res.kycCheck === "Submitted") setKycViewControl(3);
                    else if (res.failedReason !== "") {
                        setKycViewControl(0);
                        if (res.failedReason !== null) setErrorMessage((0, $60de58894af34819$export$94280540b9997672)(res.failedReason));
                        if (donationLink.customizations?.enableKycCheck === true && parseFloat(donationAmount) + parseFloat(res.total) >= 500) setFormStep(2);
                        else {
                            if (!selectedMethod) return;
                            const paymentMethod = convertToIManagedPaymentMethod(selectedMethod);
                            trackDonationPaymentInitiated(selectedMethod);
                            const response = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).createDonationLinkOrder({
                                donationLinkId: donationLink.id,
                                paymentMethod: paymentMethod,
                                orderData: [
                                    {
                                        key: "email address",
                                        value: userKycData.email.toLowerCase()
                                    }
                                ],
                                amount: parseFloat(donationAmount),
                                currency: donationLink.currency
                            });
                            if (response.paymentMethodDetails.managed) {
                                setPaymentDetails(response.paymentMethodDetails.managed);
                                generateManagedPaymentQrCode(response.paymentMethodDetails.managed);
                                setFormStep(4);
                            } else console.error("Payment method details are not available");
                        }
                    }
                }).catch((e)=>{
                    if (e.message === "Customer not found") setFormStep(2);
                    else setErrorMessage(e.message);
                }).finally(()=>{
                    setIsLoading(false);
                });
            }
        }
        if (formStep === 2) {
            let validationError;
            if (!userKycData.name) validationError = "Please enter a valid name";
            if (!userKycData.phoneNumber) validationError = "Please enter a valid phone number";
            if (!userKycData.countryOfResidence) validationError = "Please select a valid country of residence";
            if (!userKycData.address) validationError = "Please enter a valid address";
            if (!userKycData.dateOfBirth) validationError = "Please enter a valid date of birth";
            if (validationError) {
                setErrorMessage(validationError);
                setIsLoading(false);
                return;
            }
            trackDonationStep("travelRuleCompleted");
            (0, $43c053927acc0cba$export$2e2bcd8739ae039).createCustomerForDonationLink(donationLinkId, {
                name: userKycData.name,
                phone: userKycData.phoneNumber,
                residenceCountry: userKycData.countryOfResidence,
                billingAddress: userKycData.address,
                dob: userKycData.dateOfBirth,
                passportFile: userKycData.passportFile,
                idCardFile: userKycData.idCardFile,
                selfieFile: userKycData.selfieFile,
                email: userKycData.email
            }).then((res)=>{
                if (donationLink.customizations?.enableKycCheck === true && parseFloat(donationAmount) >= 500) setFormStep(3);
                else {
                    if (!selectedMethod) return;
                    const paymentMethod = convertToIManagedPaymentMethod(selectedMethod);
                    trackDonationPaymentInitiated(selectedMethod);
                    (0, $43c053927acc0cba$export$2e2bcd8739ae039).createDonationLinkOrder({
                        donationLinkId: donationLink.id,
                        paymentMethod: paymentMethod,
                        orderData: [
                            {
                                key: "email address",
                                value: userKycData.email.toLowerCase()
                            }
                        ],
                        amount: parseFloat(donationAmount),
                        currency: donationLink.currency
                    }).then((response)=>{
                        if (response.paymentMethodDetails.managed) {
                            setPaymentDetails(response.paymentMethodDetails.managed);
                            generateManagedPaymentQrCode(response.paymentMethodDetails.managed);
                            setFormStep(4);
                        } else console.error("Payment method details are not available");
                    }).catch((e)=>{
                        setErrorMessage(e.message);
                    });
                }
            }).catch((e)=>{
                if (e.message === "Customer with this email already exists") setFormStep(3);
                else setErrorMessage(e.message);
            });
        }
        setIsLoading(false);
    };
    const generateManagedPaymentQrCode = async (details)=>{
        if (!details.paymentAddress) {
            console.error("Payment address is not available");
            return;
        }
        const [qrCodeData] = await (0, $772308ca90c00f76$export$45312203e6f4f22c)(details);
        setManagedPaymentQrCode(qrCodeData);
    };
    const copyToClipboard = (text)=>{
        navigator.clipboard.writeText(text);
    };
    const onClickOpenWallet = async ()=>{
        if (!paymentDetails) return;
        switch(paymentDetails.network){
            case "Bitcoin":
            case "BitcoinTestnet":
            case "Dogecoin":
            case "DogecoinTestnet":
            case "Litecoin":
            case "LitecoinTestnet":
            case "BitcoinCash":
            case "BitcoinCashTestnet":
            case "BitcoinSV":
            case "BitcoinSVTestnet":
            case "Solana":
            case "Zcash":
            case "ZcashTestnet":
            case "Polkadot":
            case "PolkadotTestnet":
                break;
            case "Ethereum":
            case "SepoliaTestnet":
            case "Polygon":
            case "PolygonTestnet":
            case "BNB":
            case "BNBTestnet":
            case "Base":
            case "Arbitrum":
            case "Avalanche":
                try {
                    if (!address) {
                        await open();
                        return;
                    }
                    if (!selectedMethod) return;
                    setIsWalletLoading(true);
                    const chain = (0, $5760199798158999$export$cc4208a8ebc9f985)[paymentDetails.network];
                    const provider = await connector?.getProvider();
                    const signer = (0, $bf4e0381e2c41280$export$362b8ea2edbd9090)({
                        chain: chain,
                        transport: (0, $c1b76a8a2251eb69$export$4c00f665f0d4b443)(provider)
                    });
                    if (connector?.switchChain) {
                        const chainId = await connector.getChainId();
                        if (chainId !== chain.id) await connector?.switchChain({
                            chainId: chain.id
                        });
                    }
                    if (paymentDetails.token) {
                        const publicClient = (0, $8085cfeffb1fd5c6$export$d8e090d8c6a7a6ad)({
                            chain: chain,
                            transport: (0, $ff2d1e1ca66a97fb$export$7d6f1c8842f9f527)()
                        });
                        const contract = (0, $4a68b247381b8806$export$f518c38144e1f9d)({
                            address: paymentDetails.token,
                            abi: (0, $6Dftn.erc20Abi),
                            client: {
                                public: publicClient,
                                wallet: signer
                            }
                        });
                        const balance = await contract.read.balanceOf([
                            address
                        ]);
                        const decimals = await contract.read.decimals();
                        const parsedAmount = (0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(paymentDetails.amount.toString(), decimals);
                        if (balance < parsedAmount) {
                            setIsWalletLoading(false);
                            return setErrorMessage(`Your wallet does not have enough ${(0, $5760199798158999$export$8793fab959da70d1)(donationLink.methods[0].network, donationLink.methods[0].token).name} for payment.`);
                        }
                        await contract.write.transfer([
                            paymentDetails.paymentAddress,
                            (0, $8ee9eff684bd0e3a$export$203ae30b4f6490b3)(paymentDetails.amount, decimals)
                        ], {
                            account: address,
                            chain: chain
                        });
                    } else {
                        const publicClient = (0, $8085cfeffb1fd5c6$export$d8e090d8c6a7a6ad)({
                            chain: chain,
                            transport: (0, $ff2d1e1ca66a97fb$export$7d6f1c8842f9f527)()
                        });
                        try {
                            const balance = await publicClient.getBalance({
                                address: address
                            });
                            if (balance < (0, $5316bee174ce871c$export$642c4e67bbdc0bc7)(paymentDetails.amount)) {
                                setIsWalletLoading(false);
                                return setErrorMessage(`Your wallet does not have enough ${selectedMethod?.ticker ?? "amount"} for payment.`);
                            }
                        } catch (err) {
                            console.error(err);
                        }
                        if (!signer) return;
                        await signer.sendTransaction({
                            account: address,
                            chain: chain,
                            to: paymentDetails.paymentAddress,
                            value: (0, $5316bee174ce871c$export$642c4e67bbdc0bc7)(paymentDetails.amount)
                        });
                        setIsWalletLoading(false);
                    }
                } catch (err) {
                    setIsWalletLoading(false);
                    console.error(err);
                }
                break;
            default:
                console.error("No wallet");
        }
    };
    // The list of countries must not include:
    // * Sanctioned countries
    // * Territories with zero population
    const allowedCountryCodes = donationLink.customizations?.allowedCountries;
    const baseCountries = (0, $e80c2cf8ebb93fb4$export$2e2bcd8739ae039).getAllCountries().filter((c)=>!(0, $afdf282d9c361d03$export$e324f73a87016a95).has(c.name) && !(0, $afdf282d9c361d03$export$1a56b0c6dfb40ff0).has(c.name));
    const allCountries = allowedCountryCodes ? baseCountries.filter((c)=>allowedCountryCodes.includes(c.isoCode)) : baseCountries;
    if (isPaymentConfirmed && paymentStatus) {
        const transaction = paymentStatus.transactions[0];
        return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
            style: {
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
                zIndex: 5,
                position: "relative"
            },
            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($27bda91cc43d8a64$var$AnimatedReceipt, {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                    backgroundColor: "white",
                    padding: "20px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    width: "450px",
                    margin: "20px auto",
                    color: "black",
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        style: {
                            marginBottom: "10px",
                            backgroundImage: `url(${donationLink.imageUrl})`,
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            height: "150px",
                            width: "150px",
                            backgroundColor: "white",
                            borderRadius: "100%",
                            border: "8px solid rgba(255, 255, 255, 1)",
                            boxShadow: "0 0 10px rgba(0, 0, 0, 0.15)",
                            zIndex: 1
                        }
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                        style: {
                            fontSize: "16px",
                            fontWeight: "700",
                            marginBottom: "40px"
                        },
                        children: [
                            "Thank you for supporting ",
                            donationLink.name ?? "Unknown"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            marginBottom: "2.5px"
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                            style: {
                                fontSize: "12px",
                                fontWeight: "300",
                                wordBreak: "break-all",
                                textAlign: "left"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        fontWeight: 400,
                                        fontSize: "14px"
                                    },
                                    children: "Donation Amount:"
                                }),
                                " ",
                                paymentDetails?.amount,
                                " ",
                                paymentDetails?.token ?? paymentDetails?.network
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            marginBottom: "2.5px"
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                            style: {
                                fontSize: "12px",
                                fontWeight: "300",
                                wordBreak: "break-all",
                                textAlign: "left"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        fontWeight: 400,
                                        fontSize: "14px"
                                    },
                                    children: "Payment Address:"
                                }),
                                " ",
                                (0, $8d017118df5fe2e5$export$193698062786be9a)(paymentDetails?.paymentAddress ?? "0x", 15)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            marginBottom: "10px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                style: {
                                    fontSize: "12px",
                                    fontWeight: "300",
                                    wordBreak: "break-all",
                                    textAlign: "left"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                        style: {
                                            fontWeight: 400,
                                            fontSize: "14px"
                                        },
                                        children: "Tx Hash:"
                                    }),
                                    " ",
                                    (0, $8d017118df5fe2e5$export$193698062786be9a)(transaction.transactionHash ?? "0x", 20)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $e754e21e54414cee$export$2e2bcd8739ae039), {
                                onClick: ()=>copyToClipboard(transaction.transactionHash),
                                children: "Copy"
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
        style: {
            minHeight: "100vh",
            backgroundColor: "white",
            fontSize: 14,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        },
        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: 10
            },
            children: [
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($27bda91cc43d8a64$var$Background, {
                    style: {
                        backgroundImage: `url(${donationLink.bannerImageUrl})`,
                        backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_MED
                    },
                    children: [
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                            style: {
                                backgroundImage: `url(${donationLink.imageUrl})`,
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center center",
                                height: 150,
                                width: 150,
                                marginBottom: -60,
                                backgroundColor: "white",
                                borderRadius: "100%",
                                border: "8px solid rgba(255, 255, 255, 1)",
                                boxShadow: "0 0 10px rgba(0, 0, 0, 0.15)",
                                zIndex: 1
                            }
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($27bda91cc43d8a64$var$BackgroundFadeIn, {})
                    ]
                }),
                isLoading && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                    style: {
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.15)",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    },
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                        style: {
                            background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                            width: 50,
                            height: 50,
                            opacity: 0.8
                        },
                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6dac766084d8c11a$export$2e2bcd8739ae039), {
                            animationDelay: "0.5s",
                            animationSpeed: "0.75s",
                            stroke: "white"
                        })
                    })
                }),
                donationLink.customizations?.warningMessage && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                        style: {
                            position: "fixed",
                            top: 0,
                            paddingTop: 10,
                            paddingBottom: 10,
                            paddingLeft: 10,
                            paddingRight: 10,
                            textAlign: "center",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            backgroundColor: "#71afe5",
                            color: "white",
                            zIndex: 99
                        },
                        children: donationLink.customizations.warningMessage
                    })
                }),
                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 20,
                        gap: 40
                    },
                    children: [
                        formStep < 3 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                alignItems: "center",
                                fontSize: 20
                            },
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    style: {
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                    },
                                    children: "Donate with crypto to"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("a", {
                                    href: "#",
                                    style: {
                                        fontWeight: 500,
                                        textDecoration: "underline",
                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                    },
                                    children: donationLink.name ?? "Unknown"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                            style: {
                                width: "fit-content",
                                maxWidth: "90%",
                                display: "flex",
                                flexDirection: "column",
                                gap: 15
                            },
                            children: [
                                errorMessage && errorMessage.length > 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                    ref: errorRef,
                                    style: {
                                        backgroundColor: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR,
                                        padding: 15,
                                        borderRadius: 5,
                                        marginBottom: 20,
                                        color: "white",
                                        overflowWrap: "break-word"
                                    },
                                    children: errorMessage
                                }),
                                kycViewControl === 0 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $7476e21157772a88$exports.Fragment), {
                                    children: [
                                        formStep === 1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $0ce5a428e300b80d$export$42a852a2b6b56249), {
                                            style: {
                                                margin: "initial",
                                                width: 450,
                                                padding: 0,
                                                maxWidth: "100%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 10
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                            children: "Select donation method"
                                                        }),
                                                        methods?.length > 0 ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $3de4cfeabec36e0d$export$2e2bcd8739ae039), {
                                                            outerStyle: {
                                                                background: "white",
                                                                border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                                borderRadius: 5
                                                            },
                                                            noChevron: methods.length <= 1,
                                                            onCloseFn: (fn)=>setCloseFn(()=>fn),
                                                            selectedContent: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                                                                children: selectedMethod && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        gap: 10,
                                                                        alignItems: "center"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                            style: {
                                                                                width: 25,
                                                                                height: 25,
                                                                                backgroundImage: `url(${selectedMethod.logo})`,
                                                                                backgroundSize: "contain",
                                                                                backgroundPosition: "center",
                                                                                backgroundRepeat: "no-repeat",
                                                                                position: "relative"
                                                                            },
                                                                            children: selectedMethod.tokenInfo && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                style: {
                                                                                    background: "rgb(255, 255, 255)",
                                                                                    borderRadius: "100%",
                                                                                    width: 15,
                                                                                    height: 15,
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                    position: "absolute",
                                                                                    bottom: -1,
                                                                                    right: -5,
                                                                                    boxShadow: "0 0 1px"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                    style: {
                                                                                        width: 10,
                                                                                        height: 10,
                                                                                        backgroundImage: `url(${selectedMethod.tokenInfo.logo})`,
                                                                                        backgroundSize: "contain",
                                                                                        backgroundPosition: "center",
                                                                                        backgroundRepeat: "no-repeat"
                                                                                    }
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                            style: {
                                                                                display: "flex",
                                                                                flexDirection: "column"
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                                style: {
                                                                                    display: "flex",
                                                                                    alignItems: "baseline",
                                                                                    gap: 3
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                        style: {
                                                                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                                                        },
                                                                                        children: selectedMethod.ticker
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                                                        style: {
                                                                                            color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                                                        },
                                                                                        children: [
                                                                                            "on ",
                                                                                            selectedMethod.tokenInfo?.networkName ?? selectedMethod.name
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            dropdownContent: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                                                                children: methods.map((method)=>(0, $5760199798158999$export$8793fab959da70d1)(method.network, method.token)).filter((method)=>!(0, $fDWVA.isEqual)(selectedMethod, method)).map((method, i)=>{
                                                                    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $06825994d276e479$export$6f653acab4a8965a), {
                                                                        hoverEffect: true,
                                                                        isDisabled: false,
                                                                        isSelected: false,
                                                                        style: {
                                                                            opacity: 1,
                                                                            border: "none"
                                                                        },
                                                                        onClick: ()=>{
                                                                            setSelectedMethod(method);
                                                                            closeFn();
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                            style: {
                                                                                display: "flex",
                                                                                gap: 10,
                                                                                alignItems: "center"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                    style: {
                                                                                        width: 25,
                                                                                        height: 25,
                                                                                        backgroundImage: `url(${method.logo})`,
                                                                                        backgroundSize: "contain",
                                                                                        backgroundPosition: "center",
                                                                                        backgroundRepeat: "no-repeat",
                                                                                        position: "relative"
                                                                                    },
                                                                                    children: method.tokenInfo && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                        style: {
                                                                                            background: "rgba(255, 255, 255, 0.95)",
                                                                                            borderRadius: "100%",
                                                                                            width: 15,
                                                                                            height: 15,
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            justifyContent: "center",
                                                                                            position: "absolute",
                                                                                            bottom: -1,
                                                                                            right: -5,
                                                                                            boxShadow: "0 0 1px"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                            style: {
                                                                                                width: 10,
                                                                                                height: 10,
                                                                                                backgroundImage: `url(${method.tokenInfo.logo})`,
                                                                                                backgroundSize: "contain",
                                                                                                backgroundPosition: "center",
                                                                                                backgroundRepeat: "no-repeat"
                                                                                            }
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                                    style: {
                                                                                        display: "flex",
                                                                                        flexDirection: "column"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                                        style: {
                                                                                            display: "flex",
                                                                                            alignItems: "baseline",
                                                                                            gap: 3
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                                style: {
                                                                                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                                                                },
                                                                                                children: method.ticker
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                                                                style: {
                                                                                                    color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                                                                },
                                                                                                children: [
                                                                                                    "on ",
                                                                                                    method.tokenInfo?.networkName ?? method.name
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, i);
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                                            style: {
                                                                width: "100%",
                                                                height: 40
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 10
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                            children: "Enter donation amount"
                                                        }),
                                                        donationLink ? selectedMethod ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($27bda91cc43d8a64$var$AmountInputShell, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($27bda91cc43d8a64$var$AmountPrefix, {
                                                                    children: $27bda91cc43d8a64$var$getFiatCurrencySymbol(donationLink.currency)
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$c86715117507e8e5), {
                                                                    style: {
                                                                        height: 48,
                                                                        paddingLeft: 36,
                                                                        fontSize: 20,
                                                                        lineHeight: 1.2,
                                                                        fontWeight: 600
                                                                    },
                                                                    disabled: false,
                                                                    autoFocus: true,
                                                                    placeholder: "0.00",
                                                                    min: "0",
                                                                    inputMode: "decimal",
                                                                    autoComplete: "off",
                                                                    value: formatDonationAmount,
                                                                    onFocus: (e)=>{
                                                                        setFormatDonationAmount(donationAmount);
                                                                        e.currentTarget.select();
                                                                    },
                                                                    onBlur: ()=>{
                                                                        const normalized = $27bda91cc43d8a64$var$normalizeFiatAmount(donationAmount);
                                                                        setDonationAmount(normalized);
                                                                        setFormatDonationAmount(normalized);
                                                                    },
                                                                    onChange: (e)=>{
                                                                        const value = $27bda91cc43d8a64$var$sanitizeFiatAmountInput(e.target.value);
                                                                        setDonationAmount(value);
                                                                        setFormatDonationAmount(value);
                                                                    },
                                                                    onKeyDown: (e)=>{
                                                                        if (e.key === "Enter") {
                                                                            e.preventDefault();
                                                                            e.currentTarget.blur();
                                                                        }
                                                                    }
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                fontSize: 14,
                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                                borderRadius: 5,
                                                                border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                                padding: "10px 15px"
                                                            },
                                                            children: "No available payment methods"
                                                        }) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {}),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                display: "flex",
                                                                gap: 5
                                                            },
                                                            children: [
                                                                25,
                                                                50,
                                                                100,
                                                                250,
                                                                500
                                                            ].map((a, i)=>donationLink ? /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                                    onClick: ()=>{
                                                                        const formatted = Number(a).toFixed(2);
                                                                        setDonationAmount(formatted);
                                                                        setFormatDonationAmount(formatted);
                                                                    },
                                                                    style: {
                                                                        padding: 10,
                                                                        borderRadius: 5,
                                                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                                        flexGrow: 1,
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        cursor: "pointer",
                                                                        userSelect: "none",
                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).BLACK
                                                                    },
                                                                    children: (0, $0478aee74ce0fceb$export$3dc27271f5d5c629)(donationLink.currency, a)
                                                                }, i) : /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $132e35e0f1f0eb86$export$2e2bcd8739ae039), {
                                                                    style: {
                                                                        width: "100%",
                                                                        height: 40
                                                                    }
                                                                }, i))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$30c69c51aadaa8e4), {
                                                    label: "Email address",
                                                    value: userKycData.email,
                                                    required: true,
                                                    onChange: (e)=>setUserKycData({
                                                            ...userKycData,
                                                            email: e.target.value
                                                        }),
                                                    placeholder: "Email address",
                                                    autoFocus: true,
                                                    inputStyle: {
                                                        background: "white",
                                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        fontSize: 14,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 10,
                                                        flex: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                children: "Date of birth"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $de1108aeeb072783$export$2e2bcd8739ae039), {
                                                            innerStyle: {
                                                                background: "white",
                                                                border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`
                                                            },
                                                            placeholder: "DD/MM/YYYY",
                                                            value: userKycData.dateOfBirth ? new Date(userKycData.dateOfBirth) : undefined,
                                                            onChange: (e)=>setUserKycData({
                                                                    ...userKycData,
                                                                    dateOfBirth: e ? (0, $8d017118df5fe2e5$export$565a3e0423f3fda3)(e).datePart : ""
                                                                }),
                                                            startDate: new Date("1935-01-01"),
                                                            endDate: (0, $df55bf4f7a42fad2$export$2e2bcd8739ae039)(new Date(), 18)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($27bda91cc43d8a64$export$f2361e995ad47093, {
                                                    onClick: ()=>setCheckTerms(!checkTerms),
                                                    style: {
                                                        marginLeft: 5,
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        gap: 8 // 在元素之间添加间距
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $f56970af37249378$export$2e2bcd8739ae039), {
                                                                checked: checkTerms
                                                            })
                                                        }),
                                                        donationLink.tosUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                                fontSize: 12
                                                            },
                                                            children: [
                                                                "I accept the ",
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    onClick: ()=>{
                                                                        window.open(donationLink.tosUrl, "_blank");
                                                                    },
                                                                    style: {
                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: "Terms of Service"
                                                                }),
                                                                " of the organization receiving my donation. This donation is processed by Radom. By continuing, you also agree to our ",
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    onClick: (e)=>{
                                                                        e.preventDefault();
                                                                        window.open("https://radom.com/terms", "_blank");
                                                                    },
                                                                    style: {
                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: "terms"
                                                                }),
                                                                " and ",
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    onClick: (e)=>{
                                                                        e.preventDefault();
                                                                        window.open("https://radom.com/privacy", "_blank");
                                                                    },
                                                                    style: {
                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: "privacy policy"
                                                                }),
                                                                "."
                                                            ]
                                                        }),
                                                        !donationLink.tosUrl && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                                fontSize: 12
                                                            },
                                                            children: [
                                                                "This donation is processed by Radom. By continuing, you agree to our ",
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    onClick: (e)=>{
                                                                        e.preventDefault();
                                                                        window.open("https://radom.com/terms", "_blank");
                                                                    },
                                                                    style: {
                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: "terms"
                                                                }),
                                                                " and ",
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                    onClick: (e)=>{
                                                                        e.preventDefault();
                                                                        window.open("https://radom.com/privacy", "_blank");
                                                                    },
                                                                    style: {
                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                                                        textDecoration: "underline",
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: "privacy policy"
                                                                }),
                                                                "."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                    disabled: !userKycData.email || !userKycData.dateOfBirth || !donationAmount || !selectedMethod || !checkTerms,
                                                    onClick: handleNextStep,
                                                    style: {
                                                        background: donationLink.primaryButtonColor,
                                                        fontSize: 16,
                                                        height: 50,
                                                        marginTop: "20px"
                                                    },
                                                    children: "Next"
                                                })
                                            ]
                                        }),
                                        formStep === 2 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                position: "relative",
                                                flexDirection: "column",
                                                gap: 10,
                                                width: 450,
                                                maxWidth: "100%",
                                                padding: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        height: "100%",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 10
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                gap: "10px",
                                                                justifyContent: "space-between"
                                                            },
                                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                style: {
                                                                    fontSize: 14,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    gap: 10,
                                                                    flex: 1
                                                                },
                                                                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$30c69c51aadaa8e4), {
                                                                    inputStyle: {
                                                                        background: "white",
                                                                        border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`
                                                                    },
                                                                    label: "Full Name",
                                                                    value: userKycData.name,
                                                                    required: true,
                                                                    onChange: (e)=>setUserKycData({
                                                                            ...userKycData,
                                                                            name: e.target.value
                                                                        })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                gap: 10,
                                                                flex: 1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$76d3231fec538b73), {
                                                                    children: "Country of Residence"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $96e19f8f97c8e649$export$2e2bcd8739ae039), {
                                                                    allowedCountries: allCountries,
                                                                    selectedCountry: (allCountries.find((c)=>c.name.toLowerCase() === userKycData.countryOfResidence.toLowerCase() || c.isoCode.toLowerCase() === userKycData.countryOfResidence.toLowerCase())?.name ?? userKycData.countryOfResidence) || "",
                                                                    onCountrySelected: (country)=>{
                                                                        if (country) setUserKycData((prev)=>({
                                                                                ...prev,
                                                                                phoneNumber: prev.phoneNumber.trim().length === 0 ? `+${country.phonecode} ` : prev.phoneNumber,
                                                                                countryOfResidence: country.name
                                                                            }));
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$328374105a880465), {
                                                            label: "Address",
                                                            value: userKycData.address,
                                                            required: true,
                                                            suggestionList: addressSuggestionList,
                                                            inputStyle: {
                                                                background: "white",
                                                                border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                                cursor: "text"
                                                            },
                                                            setSelectedItems: (items)=>{
                                                                const selectedAddress = items[0];
                                                                if (!selectedAddress) return;
                                                                setAddressSuggestionList([]);
                                                                setUserKycData((prev)=>({
                                                                        ...prev,
                                                                        address: selectedAddress
                                                                    }));
                                                                (async ()=>{
                                                                    let details = null;
                                                                    try {
                                                                        const selectedCountry = allCountries.find((c)=>c.name === userKycData.countryOfResidence);
                                                                        details = await (0, $43c053927acc0cba$export$2e2bcd8739ae039).getGooglePlaceAddressDetails(selectedAddress, selectedCountry?.isoCode ?? "");
                                                                    } catch (err) {
                                                                        console.error("Failed to resolve selected address details", err);
                                                                        details = null;
                                                                    }
                                                                    if (!details) return;
                                                                    const countryFromDetails = details.country?.toLowerCase();
                                                                    const matchedCountry = allCountries.find((c)=>c.name.toLowerCase() === countryFromDetails || c.isoCode.toLowerCase() === countryFromDetails);
                                                                    setUserKycData((prev)=>({
                                                                            ...prev,
                                                                            address: $27bda91cc43d8a64$var$composeAddressText(details, selectedAddress),
                                                                            countryOfResidence: prev.countryOfResidence.trim().length > 0 ? prev.countryOfResidence : matchedCountry?.name ?? prev.countryOfResidence,
                                                                            phoneNumber: matchedCountry && prev.phoneNumber.trim().length === 0 ? `+${matchedCountry.phonecode} ` : prev.phoneNumber
                                                                        }));
                                                                })();
                                                            },
                                                            onChange: (e)=>{
                                                                const value = e.target.value;
                                                                if (value.length === 0) setAddressSuggestionList([]);
                                                                setUserKycData((prev)=>({
                                                                        ...prev,
                                                                        address: value
                                                                    }));
                                                                if (value.length > 2) {
                                                                    const country = allCountries.find((c)=>c.name === userKycData.countryOfResidence);
                                                                    debouncedFetch(value, country?.isoCode ?? "", setAddressSuggestionList);
                                                                } else setAddressSuggestionList([]);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $196480508fc60042$export$30c69c51aadaa8e4), {
                                                            label: "Phone Number",
                                                            required: true,
                                                            inputStyle: {
                                                                background: "white",
                                                                border: `1px solid ${(0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARK}`
                                                            },
                                                            value: userKycData.phoneNumber,
                                                            onChange: (e)=>setUserKycData({
                                                                    ...userKycData,
                                                                    phoneNumber: e.target.value
                                                                })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                    onClick: handleNextStep,
                                                    isLoading: isSubmitting,
                                                    disabled: !userKycData.name || !userKycData.phoneNumber || !userKycData.countryOfResidence || !userKycData.address,
                                                    style: {
                                                        background: donationLink.primaryButtonColor,
                                                        fontSize: 16,
                                                        height: 50,
                                                        marginTop: 20
                                                    },
                                                    children: "Next"
                                                })
                                            ]
                                        }),
                                        formStep === 3 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7476e21157772a88$exports.Fragment), {
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $cd5b106c2dfcc0b3$export$2e2bcd8739ae039), {
                                                errorMessage: errorMessage,
                                                minHeight: 200,
                                                onBack: ()=>{
                                                    setFormStep(2);
                                                    setErrorMessage("");
                                                },
                                                onChange: async (value)=>{
                                                    setIsLoading(true);
                                                    if (value.kycType === 2) {
                                                        if (value.documentType === "passport") {
                                                            setUserKycData({
                                                                ...userKycData,
                                                                passportFile: value.imageFile
                                                            });
                                                            await (0, $43c053927acc0cba$export$2e2bcd8739ae039).updateCustomerKycDataByDonationLink(donationLinkId, userKycData.email, userKycData.dateOfBirth, {
                                                                name: userKycData.name,
                                                                phone: userKycData.phoneNumber,
                                                                address: userKycData.address,
                                                                dateOfBirth: new Date(userKycData.dateOfBirth).toLocaleDateString("en-CA"),
                                                                residenceCountry: userKycData.countryOfResidence,
                                                                passportFile: value.imageFile
                                                            }).then(()=>{
                                                                setErrorMessage("");
                                                            }).catch((err)=>{
                                                                console.error(err);
                                                                setErrorMessage(err.message);
                                                            }).finally(()=>{
                                                                setIsLoading(false);
                                                            });
                                                        } else if (value.documentType === "id_card") {
                                                            setUserKycData({
                                                                ...userKycData,
                                                                idCardFile: value.imageFile
                                                            });
                                                            await (0, $43c053927acc0cba$export$2e2bcd8739ae039).updateCustomerKycDataByDonationLink(donationLinkId, userKycData.email, userKycData.dateOfBirth, {
                                                                name: userKycData.name,
                                                                phone: userKycData.phoneNumber,
                                                                address: userKycData.address,
                                                                dateOfBirth: new Date(userKycData.dateOfBirth).toLocaleDateString("en-CA"),
                                                                residenceCountry: userKycData.countryOfResidence,
                                                                idCardFile: value.imageFile
                                                            }).then(()=>{
                                                                setErrorMessage("");
                                                            }).catch((err)=>{
                                                                console.error(err);
                                                                setErrorMessage(err.message);
                                                            }).finally(()=>{
                                                                setIsLoading(false);
                                                            });
                                                        }
                                                    } else if (value.kycType === 3) {
                                                        await (0, $43c053927acc0cba$export$2e2bcd8739ae039).updateCustomerKycDataByDonationLink(donationLinkId, userKycData.email, userKycData.dateOfBirth, {
                                                            name: userKycData.name,
                                                            phone: userKycData.phoneNumber,
                                                            address: userKycData.address,
                                                            dateOfBirth: new Date(userKycData.dateOfBirth).toLocaleDateString("en-CA"),
                                                            residenceCountry: userKycData.countryOfResidence,
                                                            selfieFile: value.imageFile
                                                        }).then(()=>{
                                                            setErrorMessage("");
                                                        }).catch((err)=>{
                                                            console.error(err);
                                                            setErrorMessage(err.message);
                                                        }).finally(()=>{
                                                            setIsLoading(false);
                                                        });
                                                        setUserKycData({
                                                            ...userKycData,
                                                            selfieFile: value.imageFile
                                                        });
                                                    }
                                                },
                                                onSubmit: async ()=>{
                                                    setIsLoading(true);
                                                    setKycViewControl(1);
                                                    await (0, $43c053927acc0cba$export$2e2bcd8739ae039).submitCustomerKycCheckRequestByDonationLink(donationLinkId, userKycData.email, userKycData.dateOfBirth).then(()=>{
                                                        setTimeout(()=>{
                                                            setKycViewControl(3);
                                                        }, 1000);
                                                    }).catch((err)=>{
                                                        console.error(err);
                                                        setKycViewControl(0);
                                                        setErrorMessage(err.message);
                                                    }).finally(()=>{
                                                        setIsLoading(false);
                                                    });
                                                }
                                            })
                                        }),
                                        formStep === 4 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($27bda91cc43d8a64$var$PaymentDetailsContainer, {
                                            children: [
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                    style: {
                                                        color: "#747894",
                                                        fontSize: "18px",
                                                        fontWeight: "600"
                                                    },
                                                    children: [
                                                        "Donating ",
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($27bda91cc43d8a64$var$IconContainer, {
                                                            style: {
                                                                backgroundImage: `url(${selectedMethod?.logo})`
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                color: "#33324F"
                                                            },
                                                            children: selectedMethod?.name
                                                        }),
                                                        " on ",
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($27bda91cc43d8a64$var$IconContainer, {
                                                            style: {
                                                                backgroundImage: `url(${selectedMethod?.tokenInfo?.logo ?? selectedMethod?.logo})`
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                            style: {
                                                                color: "#33324F"
                                                            },
                                                            children: selectedMethod?.tokenInfo?.networkName ?? selectedMethod?.name
                                                        }),
                                                        " network"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                    style: {
                                                        color: "#555470",
                                                        fontSize: "12px",
                                                        fontWeight: "400",
                                                        textAlign: "center",
                                                        paddingBottom: "10px"
                                                    },
                                                    children: [
                                                        "Connect to your wallet, scan the QR code or copy the ",
                                                        selectedMethod?.name,
                                                        " address to",
                                                        " ",
                                                        "make a payment."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($27bda91cc43d8a64$var$QRCodeWrapperOuter, {
                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($27bda91cc43d8a64$var$QRCodeWrapperInner, {
                                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("img", {
                                                            src: managedPaymentQrCode,
                                                            alt: "QR Code"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($27bda91cc43d8a64$var$PaymentDetailColumn, {
                                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($27bda91cc43d8a64$var$Timer, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                style: {
                                                                    fontWeight: "500",
                                                                    color: "#618AF9",
                                                                    fontSize: "14px",
                                                                    marginRight: "2px"
                                                                },
                                                                children: "Time Remaining"
                                                            }),
                                                            " ",
                                                            timeRemaining
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($27bda91cc43d8a64$var$PaymentDetailWithCopy, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($27bda91cc43d8a64$var$PaymentDetailText, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                    style: {
                                                                        color: "#33324F",
                                                                        fontSize: "12px",
                                                                        fontWeight: "500",
                                                                        marginBottom: "5px"
                                                                    },
                                                                    children: "Payment Address"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                    style: {
                                                                        color: "#747894",
                                                                        fontSize: "12px",
                                                                        fontWeight: "400"
                                                                    },
                                                                    children: paymentDetails?.paymentAddress
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $e754e21e54414cee$export$2e2bcd8739ae039), {
                                                            onClick: ()=>copyToClipboard(paymentDetails?.paymentAddress ?? ""),
                                                            children: "Copy"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($27bda91cc43d8a64$var$PaymentDetailWithCopy, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)($27bda91cc43d8a64$var$PaymentDetailText, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                                                    style: {
                                                                        color: "#33324F",
                                                                        fontSize: "12px",
                                                                        fontWeight: "500",
                                                                        marginBottom: "5px"
                                                                    },
                                                                    children: "Total Amount"
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        alignItems: "center"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($27bda91cc43d8a64$var$IconContainer, {
                                                                            style: {
                                                                                backgroundImage: `url(${selectedMethod?.logo})`
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("span", {
                                                                            style: {
                                                                                color: "#000000",
                                                                                fontSize: "16px",
                                                                                fontWeight: "500"
                                                                            },
                                                                            children: [
                                                                                paymentDetails?.amount,
                                                                                " ",
                                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                                    style: {
                                                                                        fontWeight: "400",
                                                                                        color: "#555470"
                                                                                    },
                                                                                    children: selectedMethod?.ticker
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $e754e21e54414cee$export$2e2bcd8739ae039), {
                                                            onClick: ()=>copyToClipboard(paymentDetails?.amount ?? ""),
                                                            children: "Copy"
                                                        })
                                                    ]
                                                }),
                                                selectedMethod?.isWalletSupported && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                    style: {
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%",
                                                        backgroundColor: address ? (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_LIGHTEST : "initial",
                                                        borderBottomLeftRadius: 25,
                                                        borderBottomRightRadius: 25,
                                                        borderTopLeftRadius: 5,
                                                        borderTopRightRadius: 5
                                                    },
                                                    children: [
                                                        address && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "center",
                                                                padding: 10
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                                                    style: {
                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        gap: 5
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            style: {
                                                                                textTransform: "uppercase",
                                                                                fontSize: 10
                                                                            },
                                                                            children: "Connected wallet"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                                                            children: (0, $8d017118df5fe2e5$export$193698062786be9a)(address, 10)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$f861551692d63a2e), {
                                                                    disabled: isWalletLoading,
                                                                    onClick: ()=>disconnect(),
                                                                    style: {
                                                                        padding: 0,
                                                                        border: 0,
                                                                        color: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                                        textTransform: "uppercase",
                                                                        fontSize: 10
                                                                    },
                                                                    children: "Disconnect"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $d589b7ebc11d644f$export$ac16a6a04d9b7c84), {
                                                            onClick: onClickOpenWallet,
                                                            isLoading: isWalletLoading,
                                                            spinnerColor: "white",
                                                            style: {
                                                                background: donationLink.primaryButtonColor,
                                                                color: "white",
                                                                width: "100%"
                                                            },
                                                            children: isConnected ? "Approve payment" : "Connect wallet"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                kycViewControl === 1 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                    style: {
                                        height: 400,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        gap: 10
                                    },
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                        style: {
                                            background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).NEW_BLUE,
                                            width: 50,
                                            height: 50
                                        },
                                        children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6dac766084d8c11a$export$2e2bcd8739ae039), {
                                            animationDelay: "0.5s",
                                            animationSpeed: "0.75s",
                                            stroke: "white"
                                        })
                                    })
                                }),
                                kycViewControl === 2 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        height: 400,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        gap: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                            style: {
                                                background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS,
                                                width: 50,
                                                height: 50
                                            },
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7eba43859c4a69de$export$2e2bcd8739ae039), {
                                                animationDelay: "0.5s",
                                                animationSpeed: "0.75s",
                                                stroke: "white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            children: "Your KYC is approved."
                                        })
                                    ]
                                }),
                                kycViewControl === 3 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        height: 400,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        gap: 20
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                            style: {
                                                background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).SUCCESS,
                                                width: 50,
                                                height: 50
                                            },
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6dac766084d8c11a$export$2e2bcd8739ae039), {
                                                animationDelay: "0.5s",
                                                animationSpeed: "0.75s",
                                                stroke: "white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            children: "Your details are being verified."
                                        })
                                    ]
                                }),
                                kycViewControl === 4 && /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("div", {
                                    style: {
                                        height: 400,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        gap: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $296a0ea3087b85aa$export$763817fece9a8c9d), {
                                            style: {
                                                background: (0, $afdf282d9c361d03$export$8fe7e62e076ddbb5).ERROR,
                                                width: 45,
                                                height: 45
                                            },
                                            children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $df059e440c9a1479$export$2e2bcd8739ae039), {
                                                animationDelay: "0.5s",
                                                animationSpeed: "0.75s",
                                                stroke: "white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("div", {
                                            children: "Your KYC is rejected. Please try again."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)("a", {
                            href: "https://radom.com",
                            target: "_blank",
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 6,
                                cursor: "pointer",
                                userSelect: "none",
                                fontSize: 14,
                                color: "rgba(0, 0, 0, 0.45)",
                                fontWeight: 100,
                                textDecoration: "none",
                                padding: 20,
                                justifySelf: "flex-end"
                            },
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)("span", {
                                    children: "Powered by"
                                }),
                                /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                    width: 60,
                                    height: 14,
                                    fill: textColor
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $27bda91cc43d8a64$export$2e2bcd8739ae039 = $27bda91cc43d8a64$var$DonationLink;



const $770cd5bd9f30ff09$var$queryClient = new (0, $8b9d185dc2ce01e1$export$405d0624ed55a03f)();
const $770cd5bd9f30ff09$var$Container = (0, $2952da92fd5b9db2$export$2e2bcd8739ae039).div`
  background-color: black;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
function $770cd5bd9f30ff09$var$App() {
    return /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $91be27bdcb92956c$export$a28463dc600bc9f8), {
        config: (0, $5760199798158999$export$382a3cc012b91987),
        children: [
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $074a53b639ae13c4$export$45604f0cc8ae667b), {
                client: $770cd5bd9f30ff09$var$queryClient,
                children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $f0e8e6c6e69cddf0$export$9ba4e89fdfa1fc54), {
                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsxs)((0, $6738ab3539650fb6$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)($770cd5bd9f30ff09$var$Container, {
                                    children: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $591ac205d4dd229c$export$2e2bcd8739ae039), {
                                        fill: "white"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/preview/pay",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $e97aa13a27cfb8bd$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/pay/*",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7c89e1c32e8657b1$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/payment_link/:paymentLinkId",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $7c89e1c32e8657b1$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/preview/invoice",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $e590643c9fd8496b$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/invoice/:invoiceId",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $941e198c2321b7b8$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/checkout/:checkoutId",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $35ce030e39d4f986$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/subscription/:subscriptionId",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $23109ce8e3723d50$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/presale/*",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $278c8c19bab9424a$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/preview/presale",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $3940b4cd84e3ba62$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/donate/:donationLinkId",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $27bda91cc43d8a64$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/donation/:donationLinkId",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $27bda91cc43d8a64$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/donation_link/:donationLinkId",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $27bda91cc43d8a64$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $6738ab3539650fb6$export$e7b0ac011bb776c6), {
                                path: "/preview/donation",
                                element: /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $27bda91cc43d8a64$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $71a78e40f6b201d2$export$fb98e3a2a4cd92d7), {
                position: "bottom-right"
            })
        ]
    });
}
var $770cd5bd9f30ff09$export$2e2bcd8739ae039 = $770cd5bd9f30ff09$var$App;




if (0, $afdf282d9c361d03$export$1345fde192f5a83e) $7e5720515a763331$export$2cd8252107eb640b({
    dsn: "https://55021c91df5eef7cbbf78d01e56c83df@o4506811525824512.ingest.sentry.io/4506811527200768",
    integrations: [
        (0, $73971d057111abc9$export$caa9b6c4a4144db4)({
            levels: [
                "error"
            ]
        }),
        $b96e0b3274f71e54$export$b4109253475213e9(),
        $e2f0a84b44552346$export$2832a2ae028f5e28({
            maskAllText: false,
            blockAllMedia: false
        })
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost"
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
console.info(`
\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}
\u{255A}\u{2550}\u{255D}  \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}  \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}  \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}
Welcome to Radom!
Build: ${undefined}
`);
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const $56f5cd1e19ffdc7d$var$root = (0, $a818400b9257b505$export$882461b6382ed46c)(document.getElementById("app"));
$56f5cd1e19ffdc7d$var$root.render(/*#__PURE__*/ (0, $7476e21157772a88$exports.jsx)((0, $770cd5bd9f30ff09$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.974149ba.js.map
